/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://static.milanote.com/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(825);
	
	__webpack_require__(2030);

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(191);


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1449)();
	}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.connectAdvanced = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(1541);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connectAdvanced = __webpack_require__(625);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _connect = __webpack_require__(1542);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Provider = _Provider2.default;
	exports.connectAdvanced = _connectAdvanced2.default;
	exports.connect = _connect2.default;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.4';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      reLeadingDot = /^\./,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)',
	      rsOrdUpper = '\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Adds the key-value `pair` to `map`.
	   *
	   * @private
	   * @param {Object} map The map to modify.
	   * @param {Array} pair The key-value pair to add.
	   * @returns {Object} Returns `map`.
	   */
	  function addMapEntry(map, pair) {
	    // Don't return `map.set` because it's not chainable in IE 11.
	    map.set(pair[0], pair[1]);
	    return map;
	  }
	
	  /**
	   * Adds `value` to `set`.
	   *
	   * @private
	   * @param {Object} set The set to modify.
	   * @param {*} value The value to add.
	   * @returns {Object} Returns `set`.
	   */
	  function addSetEntry(set, value) {
	    // Don't return `set.add` because it's not chainable in IE 11.
	    set.add(value);
	    return set;
	  }
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, baseClone, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = object[key],
	          srcValue = source[key],
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `map`.
	     *
	     * @private
	     * @param {Object} map The map to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned map.
	     */
	    function cloneMap(map, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
	      return arrayReduce(array, addMapEntry, new map.constructor);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of `set`.
	     *
	     * @private
	     * @param {Object} set The set to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned set.
	     */
	    function cloneSet(set, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
	      return arrayReduce(array, addSetEntry, new set.constructor);
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, cloneFunc, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return cloneMap(object, isDeep, cloneFunc);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return cloneSet(object, isDeep, cloneFunc);
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return !!length &&
	        (typeof value == 'number' || reIsUint.test(value)) &&
	        (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (reLeadingDot.test(string)) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            result = wait - timeSinceLastCall;
	
	        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(args) {
	      args.push(undefined, customDefaultsAssignIn);
	      return apply(assignInWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(209)(module)))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(15)
	  , core      = __webpack_require__(112)
	  , hide      = __webpack_require__(68)
	  , redefine  = __webpack_require__(69)
	  , ctx       = __webpack_require__(113)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
	    , key, own, out, exp;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if(target)redefine(target, key, out, type & $export.U);
	    // export
	    if(exports[key] != out)hide(exports, key, exp);
	    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 7 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.defaultMemoize = defaultMemoize;
	exports.createSelectorCreator = createSelectorCreator;
	exports.createStructuredSelector = createStructuredSelector;
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function defaultEqualityCheck(a, b) {
	  return a === b;
	}
	
	function defaultMemoize(func) {
	  var equalityCheck = arguments.length <= 1 || arguments[1] === undefined ? defaultEqualityCheck : arguments[1];
	
	  var lastArgs = null;
	  var lastResult = null;
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    if (lastArgs === null || lastArgs.length !== args.length || !args.every(function (value, index) {
	      return equalityCheck(value, lastArgs[index]);
	    })) {
	      lastResult = func.apply(undefined, args);
	    }
	    lastArgs = args;
	    return lastResult;
	  };
	}
	
	function getDependencies(funcs) {
	  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
	
	  if (!dependencies.every(function (dep) {
	    return typeof dep === 'function';
	  })) {
	    var dependencyTypes = dependencies.map(function (dep) {
	      return typeof dep;
	    }).join(', ');
	    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
	  }
	
	  return dependencies;
	}
	
	function createSelectorCreator(memoize) {
	  for (var _len2 = arguments.length, memoizeOptions = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    memoizeOptions[_key2 - 1] = arguments[_key2];
	  }
	
	  return function () {
	    for (var _len3 = arguments.length, funcs = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      funcs[_key3] = arguments[_key3];
	    }
	
	    var recomputations = 0;
	    var resultFunc = funcs.pop();
	    var dependencies = getDependencies(funcs);
	
	    var memoizedResultFunc = memoize.apply(undefined, [function () {
	      recomputations++;
	      return resultFunc.apply(undefined, arguments);
	    }].concat(memoizeOptions));
	
	    var selector = function selector(state, props) {
	      for (var _len4 = arguments.length, args = Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
	        args[_key4 - 2] = arguments[_key4];
	      }
	
	      var params = dependencies.map(function (dependency) {
	        return dependency.apply(undefined, [state, props].concat(args));
	      });
	      return memoizedResultFunc.apply(undefined, _toConsumableArray(params));
	    };
	
	    selector.resultFunc = resultFunc;
	    selector.recomputations = function () {
	      return recomputations;
	    };
	    selector.resetRecomputations = function () {
	      return recomputations = 0;
	    };
	    return selector;
	  };
	}
	
	var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);
	
	function createStructuredSelector(selectors) {
	  var selectorCreator = arguments.length <= 1 || arguments[1] === undefined ? createSelector : arguments[1];
	
	  if (typeof selectors !== 'object') {
	    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
	  }
	  var objectKeys = Object.keys(selectors);
	  return selectorCreator(objectKeys.map(function (key) {
	    return selectors[key];
	  }), function () {
	    for (var _len5 = arguments.length, values = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	      values[_key5] = arguments[_key5];
	    }
	
	    return values.reduce(function (composition, value, index) {
	      composition[objectKeys[index]] = value;
	      return composition;
	    }, {});
	  });
	}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 *  Copyright (c) 2014-2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.Immutable = factory());
	}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
	  function createClass(ctor, superClass) {
	    if (superClass) {
	      ctor.prototype = Object.create(superClass.prototype);
	    }
	    ctor.prototype.constructor = ctor;
	  }
	
	  function Iterable(value) {
	      return isIterable(value) ? value : Seq(value);
	    }
	
	
	  createClass(KeyedIterable, Iterable);
	    function KeyedIterable(value) {
	      return isKeyed(value) ? value : KeyedSeq(value);
	    }
	
	
	  createClass(IndexedIterable, Iterable);
	    function IndexedIterable(value) {
	      return isIndexed(value) ? value : IndexedSeq(value);
	    }
	
	
	  createClass(SetIterable, Iterable);
	    function SetIterable(value) {
	      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
	    }
	
	
	
	  function isIterable(maybeIterable) {
	    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
	  }
	
	  function isKeyed(maybeKeyed) {
	    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
	  }
	
	  function isIndexed(maybeIndexed) {
	    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
	  }
	
	  function isAssociative(maybeAssociative) {
	    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
	  }
	
	  function isOrdered(maybeOrdered) {
	    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
	  }
	
	  Iterable.isIterable = isIterable;
	  Iterable.isKeyed = isKeyed;
	  Iterable.isIndexed = isIndexed;
	  Iterable.isAssociative = isAssociative;
	  Iterable.isOrdered = isOrdered;
	
	  Iterable.Keyed = KeyedIterable;
	  Iterable.Indexed = IndexedIterable;
	  Iterable.Set = SetIterable;
	
	
	  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  // Used for setting prototype methods that IE8 chokes on.
	  var DELETE = 'delete';
	
	  // Constants describing the size of trie nodes.
	  var SHIFT = 5; // Resulted in best performance after ______?
	  var SIZE = 1 << SHIFT;
	  var MASK = SIZE - 1;
	
	  // A consistent shared value representing "not set" which equals nothing other
	  // than itself, and nothing that could be provided externally.
	  var NOT_SET = {};
	
	  // Boolean references, Rough equivalent of `bool &`.
	  var CHANGE_LENGTH = { value: false };
	  var DID_ALTER = { value: false };
	
	  function MakeRef(ref) {
	    ref.value = false;
	    return ref;
	  }
	
	  function SetRef(ref) {
	    ref && (ref.value = true);
	  }
	
	  // A function which returns a value representing an "owner" for transient writes
	  // to tries. The return value will only ever equal itself, and will not equal
	  // the return of any subsequent call of this function.
	  function OwnerID() {}
	
	  // http://jsperf.com/copy-array-inline
	  function arrCopy(arr, offset) {
	    offset = offset || 0;
	    var len = Math.max(0, arr.length - offset);
	    var newArr = new Array(len);
	    for (var ii = 0; ii < len; ii++) {
	      newArr[ii] = arr[ii + offset];
	    }
	    return newArr;
	  }
	
	  function ensureSize(iter) {
	    if (iter.size === undefined) {
	      iter.size = iter.__iterate(returnTrue);
	    }
	    return iter.size;
	  }
	
	  function wrapIndex(iter, index) {
	    // This implements "is array index" which the ECMAString spec defines as:
	    //
	    //     A String property name P is an array index if and only if
	    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
	    //     to 2^32−1.
	    //
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
	    if (typeof index !== 'number') {
	      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
	      if ('' + uint32Index !== index || uint32Index === 4294967295) {
	        return NaN;
	      }
	      index = uint32Index;
	    }
	    return index < 0 ? ensureSize(iter) + index : index;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function wholeSlice(begin, end, size) {
	    return (begin === 0 || (size !== undefined && begin <= -size)) &&
	      (end === undefined || (size !== undefined && end >= size));
	  }
	
	  function resolveBegin(begin, size) {
	    return resolveIndex(begin, size, 0);
	  }
	
	  function resolveEnd(end, size) {
	    return resolveIndex(end, size, size);
	  }
	
	  function resolveIndex(index, size, defaultIndex) {
	    return index === undefined ?
	      defaultIndex :
	      index < 0 ?
	        Math.max(0, size + index) :
	        size === undefined ?
	          index :
	          Math.min(size, index);
	  }
	
	  /* global Symbol */
	
	  var ITERATE_KEYS = 0;
	  var ITERATE_VALUES = 1;
	  var ITERATE_ENTRIES = 2;
	
	  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
	  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
	  function Iterator(next) {
	      this.next = next;
	    }
	
	    Iterator.prototype.toString = function() {
	      return '[Iterator]';
	    };
	
	
	  Iterator.KEYS = ITERATE_KEYS;
	  Iterator.VALUES = ITERATE_VALUES;
	  Iterator.ENTRIES = ITERATE_ENTRIES;
	
	  Iterator.prototype.inspect =
	  Iterator.prototype.toSource = function () { return this.toString(); }
	  Iterator.prototype[ITERATOR_SYMBOL] = function () {
	    return this;
	  };
	
	
	  function iteratorValue(type, k, v, iteratorResult) {
	    var value = type === 0 ? k : type === 1 ? v : [k, v];
	    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
	      value: value, done: false
	    });
	    return iteratorResult;
	  }
	
	  function iteratorDone() {
	    return { value: undefined, done: true };
	  }
	
	  function hasIterator(maybeIterable) {
	    return !!getIteratorFn(maybeIterable);
	  }
	
	  function isIterator(maybeIterator) {
	    return maybeIterator && typeof maybeIterator.next === 'function';
	  }
	
	  function getIterator(iterable) {
	    var iteratorFn = getIteratorFn(iterable);
	    return iteratorFn && iteratorFn.call(iterable);
	  }
	
	  function getIteratorFn(iterable) {
	    var iteratorFn = iterable && (
	      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
	      iterable[FAUX_ITERATOR_SYMBOL]
	    );
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  function isArrayLike(value) {
	    return value && typeof value.length === 'number';
	  }
	
	  createClass(Seq, Iterable);
	    function Seq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        isIterable(value) ? value.toSeq() : seqFromValue(value);
	    }
	
	    Seq.of = function(/*...values*/) {
	      return Seq(arguments);
	    };
	
	    Seq.prototype.toSeq = function() {
	      return this;
	    };
	
	    Seq.prototype.toString = function() {
	      return this.__toString('Seq {', '}');
	    };
	
	    Seq.prototype.cacheResult = function() {
	      if (!this._cache && this.__iterateUncached) {
	        this._cache = this.entrySeq().toArray();
	        this.size = this._cache.length;
	      }
	      return this;
	    };
	
	    // abstract __iterateUncached(fn, reverse)
	
	    Seq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, true);
	    };
	
	    // abstract __iteratorUncached(type, reverse)
	
	    Seq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, true);
	    };
	
	
	
	  createClass(KeyedSeq, Seq);
	    function KeyedSeq(value) {
	      return value === null || value === undefined ?
	        emptySequence().toKeyedSeq() :
	        isIterable(value) ?
	          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
	          keyedSeqFromValue(value);
	    }
	
	    KeyedSeq.prototype.toKeyedSeq = function() {
	      return this;
	    };
	
	
	
	  createClass(IndexedSeq, Seq);
	    function IndexedSeq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
	    }
	
	    IndexedSeq.of = function(/*...values*/) {
	      return IndexedSeq(arguments);
	    };
	
	    IndexedSeq.prototype.toIndexedSeq = function() {
	      return this;
	    };
	
	    IndexedSeq.prototype.toString = function() {
	      return this.__toString('Seq [', ']');
	    };
	
	    IndexedSeq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, false);
	    };
	
	    IndexedSeq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, false);
	    };
	
	
	
	  createClass(SetSeq, Seq);
	    function SetSeq(value) {
	      return (
	        value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value
	      ).toSetSeq();
	    }
	
	    SetSeq.of = function(/*...values*/) {
	      return SetSeq(arguments);
	    };
	
	    SetSeq.prototype.toSetSeq = function() {
	      return this;
	    };
	
	
	
	  Seq.isSeq = isSeq;
	  Seq.Keyed = KeyedSeq;
	  Seq.Set = SetSeq;
	  Seq.Indexed = IndexedSeq;
	
	  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
	  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
	  createClass(ArraySeq, IndexedSeq);
	    function ArraySeq(array) {
	      this._array = array;
	      this.size = array.length;
	    }
	
	    ArraySeq.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
	    };
	
	    ArraySeq.prototype.__iterate = function(fn, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ArraySeq.prototype.__iterator = function(type, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
	      );
	    };
	
	
	
	  createClass(ObjectSeq, KeyedSeq);
	    function ObjectSeq(object) {
	      var keys = Object.keys(object);
	      this._object = object;
	      this._keys = keys;
	      this.size = keys.length;
	    }
	
	    ObjectSeq.prototype.get = function(key, notSetValue) {
	      if (notSetValue !== undefined && !this.has(key)) {
	        return notSetValue;
	      }
	      return this._object[key];
	    };
	
	    ObjectSeq.prototype.has = function(key) {
	      return this._object.hasOwnProperty(key);
	    };
	
	    ObjectSeq.prototype.__iterate = function(fn, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        if (fn(object[key], key, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ObjectSeq.prototype.__iterator = function(type, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, key, object[key]);
	      });
	    };
	
	  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(IterableSeq, IndexedSeq);
	    function IterableSeq(iterable) {
	      this._iterable = iterable;
	      this.size = iterable.length || iterable.size;
	    }
	
	    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      var iterations = 0;
	      if (isIterator(iterator)) {
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (fn(step.value, iterations++, this) === false) {
	            break;
	          }
	        }
	      }
	      return iterations;
	    };
	
	    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      if (!isIterator(iterator)) {
	        return new Iterator(iteratorDone);
	      }
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step : iteratorValue(type, iterations++, step.value);
	      });
	    };
	
	
	
	  createClass(IteratorSeq, IndexedSeq);
	    function IteratorSeq(iterator) {
	      this._iterator = iterator;
	      this._iteratorCache = [];
	    }
	
	    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      while (iterations < cache.length) {
	        if (fn(cache[iterations], iterations++, this) === false) {
	          return iterations;
	        }
	      }
	      var step;
	      while (!(step = iterator.next()).done) {
	        var val = step.value;
	        cache[iterations] = val;
	        if (fn(val, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	
	    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      return new Iterator(function()  {
	        if (iterations >= cache.length) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          cache[iterations] = step.value;
	        }
	        return iteratorValue(type, iterations, cache[iterations++]);
	      });
	    };
	
	
	
	
	  // # pragma Helper functions
	
	  function isSeq(maybeSeq) {
	    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
	  }
	
	  var EMPTY_SEQ;
	
	  function emptySequence() {
	    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
	  }
	
	  function keyedSeqFromValue(value) {
	    var seq =
	      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
	      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
	      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
	      typeof value === 'object' ? new ObjectSeq(value) :
	      undefined;
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of [k, v] entries, '+
	        'or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function indexedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function seqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value) ||
	      (typeof value === 'object' && new ObjectSeq(value));
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values, or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function maybeIndexedSeqFromValue(value) {
	    return (
	      isArrayLike(value) ? new ArraySeq(value) :
	      isIterator(value) ? new IteratorSeq(value) :
	      hasIterator(value) ? new IterableSeq(value) :
	      undefined
	    );
	  }
	
	  function seqIterate(seq, fn, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    }
	    return seq.__iterateUncached(fn, reverse);
	  }
	
	  function seqIterator(seq, type, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
	      });
	    }
	    return seq.__iteratorUncached(type, reverse);
	  }
	
	  function fromJS(json, converter) {
	    return converter ?
	      fromJSWith(converter, json, '', {'': json}) :
	      fromJSDefault(json);
	  }
	
	  function fromJSWith(converter, json, key, parentJSON) {
	    if (Array.isArray(json)) {
	      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    if (isPlainObj(json)) {
	      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    return json;
	  }
	
	  function fromJSDefault(json) {
	    if (Array.isArray(json)) {
	      return IndexedSeq(json).map(fromJSDefault).toList();
	    }
	    if (isPlainObj(json)) {
	      return KeyedSeq(json).map(fromJSDefault).toMap();
	    }
	    return json;
	  }
	
	  function isPlainObj(value) {
	    return value && (value.constructor === Object || value.constructor === undefined);
	  }
	
	  /**
	   * An extension of the "same-value" algorithm as [described for use by ES6 Map
	   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
	   *
	   * NaN is considered the same as NaN, however -0 and 0 are considered the same
	   * value, which is different from the algorithm described by
	   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
	   *
	   * This is extended further to allow Objects to describe the values they
	   * represent, by way of `valueOf` or `equals` (and `hashCode`).
	   *
	   * Note: because of this extension, the key equality of Immutable.Map and the
	   * value equality of Immutable.Set will differ from ES6 Map and Set.
	   *
	   * ### Defining custom values
	   *
	   * The easiest way to describe the value an object represents is by implementing
	   * `valueOf`. For example, `Date` represents a value by returning a unix
	   * timestamp for `valueOf`:
	   *
	   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
	   *     var date2 = new Date(1234567890000);
	   *     date1.valueOf(); // 1234567890000
	   *     assert( date1 !== date2 );
	   *     assert( Immutable.is( date1, date2 ) );
	   *
	   * Note: overriding `valueOf` may have other implications if you use this object
	   * where JavaScript expects a primitive, such as implicit string coercion.
	   *
	   * For more complex types, especially collections, implementing `valueOf` may
	   * not be performant. An alternative is to implement `equals` and `hashCode`.
	   *
	   * `equals` takes another object, presumably of similar type, and returns true
	   * if the it is equal. Equality is symmetrical, so the same result should be
	   * returned if this and the argument are flipped.
	   *
	   *     assert( a.equals(b) === b.equals(a) );
	   *
	   * `hashCode` returns a 32bit integer number representing the object which will
	   * be used to determine how to store the value object in a Map or Set. You must
	   * provide both or neither methods, one must not exist without the other.
	   *
	   * Also, an important relationship between these methods must be upheld: if two
	   * values are equal, they *must* return the same hashCode. If the values are not
	   * equal, they might have the same hashCode; this is called a hash collision,
	   * and while undesirable for performance reasons, it is acceptable.
	   *
	   *     if (a.equals(b)) {
	   *       assert( a.hashCode() === b.hashCode() );
	   *     }
	   *
	   * All Immutable collections implement `equals` and `hashCode`.
	   *
	   */
	  function is(valueA, valueB) {
	    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	      return true;
	    }
	    if (!valueA || !valueB) {
	      return false;
	    }
	    if (typeof valueA.valueOf === 'function' &&
	        typeof valueB.valueOf === 'function') {
	      valueA = valueA.valueOf();
	      valueB = valueB.valueOf();
	      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	        return true;
	      }
	      if (!valueA || !valueB) {
	        return false;
	      }
	    }
	    if (typeof valueA.equals === 'function' &&
	        typeof valueB.equals === 'function' &&
	        valueA.equals(valueB)) {
	      return true;
	    }
	    return false;
	  }
	
	  function deepEqual(a, b) {
	    if (a === b) {
	      return true;
	    }
	
	    if (
	      !isIterable(b) ||
	      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
	      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
	      isKeyed(a) !== isKeyed(b) ||
	      isIndexed(a) !== isIndexed(b) ||
	      isOrdered(a) !== isOrdered(b)
	    ) {
	      return false;
	    }
	
	    if (a.size === 0 && b.size === 0) {
	      return true;
	    }
	
	    var notAssociative = !isAssociative(a);
	
	    if (isOrdered(a)) {
	      var entries = a.entries();
	      return b.every(function(v, k)  {
	        var entry = entries.next().value;
	        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
	      }) && entries.next().done;
	    }
	
	    var flipped = false;
	
	    if (a.size === undefined) {
	      if (b.size === undefined) {
	        if (typeof a.cacheResult === 'function') {
	          a.cacheResult();
	        }
	      } else {
	        flipped = true;
	        var _ = a;
	        a = b;
	        b = _;
	      }
	    }
	
	    var allEqual = true;
	    var bSize = b.__iterate(function(v, k)  {
	      if (notAssociative ? !a.has(v) :
	          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
	        allEqual = false;
	        return false;
	      }
	    });
	
	    return allEqual && a.size === bSize;
	  }
	
	  createClass(Repeat, IndexedSeq);
	
	    function Repeat(value, times) {
	      if (!(this instanceof Repeat)) {
	        return new Repeat(value, times);
	      }
	      this._value = value;
	      this.size = times === undefined ? Infinity : Math.max(0, times);
	      if (this.size === 0) {
	        if (EMPTY_REPEAT) {
	          return EMPTY_REPEAT;
	        }
	        EMPTY_REPEAT = this;
	      }
	    }
	
	    Repeat.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Repeat []';
	      }
	      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
	    };
	
	    Repeat.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._value : notSetValue;
	    };
	
	    Repeat.prototype.includes = function(searchValue) {
	      return is(this._value, searchValue);
	    };
	
	    Repeat.prototype.slice = function(begin, end) {
	      var size = this.size;
	      return wholeSlice(begin, end, size) ? this :
	        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
	    };
	
	    Repeat.prototype.reverse = function() {
	      return this;
	    };
	
	    Repeat.prototype.indexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return 0;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.lastIndexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return this.size;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.__iterate = function(fn, reverse) {
	      for (var ii = 0; ii < this.size; ii++) {
	        if (fn(this._value, ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
	      );
	    };
	
	    Repeat.prototype.equals = function(other) {
	      return other instanceof Repeat ?
	        is(this._value, other._value) :
	        deepEqual(other);
	    };
	
	
	  var EMPTY_REPEAT;
	
	  function invariant(condition, error) {
	    if (!condition) throw new Error(error);
	  }
	
	  createClass(Range, IndexedSeq);
	
	    function Range(start, end, step) {
	      if (!(this instanceof Range)) {
	        return new Range(start, end, step);
	      }
	      invariant(step !== 0, 'Cannot step a Range by 0');
	      start = start || 0;
	      if (end === undefined) {
	        end = Infinity;
	      }
	      step = step === undefined ? 1 : Math.abs(step);
	      if (end < start) {
	        step = -step;
	      }
	      this._start = start;
	      this._end = end;
	      this._step = step;
	      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
	      if (this.size === 0) {
	        if (EMPTY_RANGE) {
	          return EMPTY_RANGE;
	        }
	        EMPTY_RANGE = this;
	      }
	    }
	
	    Range.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Range []';
	      }
	      return 'Range [ ' +
	        this._start + '...' + this._end +
	        (this._step !== 1 ? ' by ' + this._step : '') +
	      ' ]';
	    };
	
	    Range.prototype.get = function(index, notSetValue) {
	      return this.has(index) ?
	        this._start + wrapIndex(this, index) * this._step :
	        notSetValue;
	    };
	
	    Range.prototype.includes = function(searchValue) {
	      var possibleIndex = (searchValue - this._start) / this._step;
	      return possibleIndex >= 0 &&
	        possibleIndex < this.size &&
	        possibleIndex === Math.floor(possibleIndex);
	    };
	
	    Range.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      begin = resolveBegin(begin, this.size);
	      end = resolveEnd(end, this.size);
	      if (end <= begin) {
	        return new Range(0, 0);
	      }
	      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
	    };
	
	    Range.prototype.indexOf = function(searchValue) {
	      var offsetValue = searchValue - this._start;
	      if (offsetValue % this._step === 0) {
	        var index = offsetValue / this._step;
	        if (index >= 0 && index < this.size) {
	          return index
	        }
	      }
	      return -1;
	    };
	
	    Range.prototype.lastIndexOf = function(searchValue) {
	      return this.indexOf(searchValue);
	    };
	
	    Range.prototype.__iterate = function(fn, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(value, ii, this) === false) {
	          return ii + 1;
	        }
	        value += reverse ? -step : step;
	      }
	      return ii;
	    };
	
	    Range.prototype.__iterator = function(type, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      var ii = 0;
	      return new Iterator(function()  {
	        var v = value;
	        value += reverse ? -step : step;
	        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
	      });
	    };
	
	    Range.prototype.equals = function(other) {
	      return other instanceof Range ?
	        this._start === other._start &&
	        this._end === other._end &&
	        this._step === other._step :
	        deepEqual(this, other);
	    };
	
	
	  var EMPTY_RANGE;
	
	  createClass(Collection, Iterable);
	    function Collection() {
	      throw TypeError('Abstract');
	    }
	
	
	  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
	  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
	  createClass(SetCollection, Collection);function SetCollection() {}
	
	
	  Collection.Keyed = KeyedCollection;
	  Collection.Indexed = IndexedCollection;
	  Collection.Set = SetCollection;
	
	  var imul =
	    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
	    Math.imul :
	    function imul(a, b) {
	      a = a | 0; // int
	      b = b | 0; // int
	      var c = a & 0xffff;
	      var d = b & 0xffff;
	      // Shift by 0 fixes the sign on the high part.
	      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
	    };
	
	  // v8 has an optimization for storing 31-bit signed numbers.
	  // Values which have either 00 or 11 as the high order bits qualify.
	  // This function drops the highest order bit in a signed number, maintaining
	  // the sign bit.
	  function smi(i32) {
	    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
	  }
	
	  function hash(o) {
	    if (o === false || o === null || o === undefined) {
	      return 0;
	    }
	    if (typeof o.valueOf === 'function') {
	      o = o.valueOf();
	      if (o === false || o === null || o === undefined) {
	        return 0;
	      }
	    }
	    if (o === true) {
	      return 1;
	    }
	    var type = typeof o;
	    if (type === 'number') {
	      if (o !== o || o === Infinity) {
	        return 0;
	      }
	      var h = o | 0;
	      if (h !== o) {
	        h ^= o * 0xFFFFFFFF;
	      }
	      while (o > 0xFFFFFFFF) {
	        o /= 0xFFFFFFFF;
	        h ^= o;
	      }
	      return smi(h);
	    }
	    if (type === 'string') {
	      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
	    }
	    if (typeof o.hashCode === 'function') {
	      return o.hashCode();
	    }
	    if (type === 'object') {
	      return hashJSObj(o);
	    }
	    if (typeof o.toString === 'function') {
	      return hashString(o.toString());
	    }
	    throw new Error('Value type ' + type + ' cannot be hashed.');
	  }
	
	  function cachedHashString(string) {
	    var hash = stringHashCache[string];
	    if (hash === undefined) {
	      hash = hashString(string);
	      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
	        STRING_HASH_CACHE_SIZE = 0;
	        stringHashCache = {};
	      }
	      STRING_HASH_CACHE_SIZE++;
	      stringHashCache[string] = hash;
	    }
	    return hash;
	  }
	
	  // http://jsperf.com/hashing-strings
	  function hashString(string) {
	    // This is the hash from JVM
	    // The hash code for a string is computed as
	    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
	    // where s[i] is the ith character of the string and n is the length of
	    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
	    // (exclusive) by dropping high bits.
	    var hash = 0;
	    for (var ii = 0; ii < string.length; ii++) {
	      hash = 31 * hash + string.charCodeAt(ii) | 0;
	    }
	    return smi(hash);
	  }
	
	  function hashJSObj(obj) {
	    var hash;
	    if (usingWeakMap) {
	      hash = weakMap.get(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = obj[UID_HASH_KEY];
	    if (hash !== undefined) {
	      return hash;
	    }
	
	    if (!canDefineProperty) {
	      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
	      if (hash !== undefined) {
	        return hash;
	      }
	
	      hash = getIENodeHash(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = ++objHashUID;
	    if (objHashUID & 0x40000000) {
	      objHashUID = 0;
	    }
	
	    if (usingWeakMap) {
	      weakMap.set(obj, hash);
	    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
	      throw new Error('Non-extensible objects are not allowed as keys.');
	    } else if (canDefineProperty) {
	      Object.defineProperty(obj, UID_HASH_KEY, {
	        'enumerable': false,
	        'configurable': false,
	        'writable': false,
	        'value': hash
	      });
	    } else if (obj.propertyIsEnumerable !== undefined &&
	               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
	      // Since we can't define a non-enumerable property on the object
	      // we'll hijack one of the less-used non-enumerable properties to
	      // save our hash on it. Since this is a function it will not show up in
	      // `JSON.stringify` which is what we want.
	      obj.propertyIsEnumerable = function() {
	        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
	      };
	      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
	    } else if (obj.nodeType !== undefined) {
	      // At this point we couldn't get the IE `uniqueID` to use as a hash
	      // and we couldn't use a non-enumerable property to exploit the
	      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
	      // itself.
	      obj[UID_HASH_KEY] = hash;
	    } else {
	      throw new Error('Unable to set a non-enumerable property on object.');
	    }
	
	    return hash;
	  }
	
	  // Get references to ES5 object methods.
	  var isExtensible = Object.isExtensible;
	
	  // True if Object.defineProperty works as expected. IE8 fails this test.
	  var canDefineProperty = (function() {
	    try {
	      Object.defineProperty({}, '@', {});
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }());
	
	  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
	  // and avoid memory leaks from the IE cloneNode bug.
	  function getIENodeHash(node) {
	    if (node && node.nodeType > 0) {
	      switch (node.nodeType) {
	        case 1: // Element
	          return node.uniqueID;
	        case 9: // Document
	          return node.documentElement && node.documentElement.uniqueID;
	      }
	    }
	  }
	
	  // If possible, use a WeakMap.
	  var usingWeakMap = typeof WeakMap === 'function';
	  var weakMap;
	  if (usingWeakMap) {
	    weakMap = new WeakMap();
	  }
	
	  var objHashUID = 0;
	
	  var UID_HASH_KEY = '__immutablehash__';
	  if (typeof Symbol === 'function') {
	    UID_HASH_KEY = Symbol(UID_HASH_KEY);
	  }
	
	  var STRING_HASH_CACHE_MIN_STRLEN = 16;
	  var STRING_HASH_CACHE_MAX_SIZE = 255;
	  var STRING_HASH_CACHE_SIZE = 0;
	  var stringHashCache = {};
	
	  function assertNotInfinite(size) {
	    invariant(
	      size !== Infinity,
	      'Cannot perform this action with an infinite size.'
	    );
	  }
	
	  createClass(Map, KeyedCollection);
	
	    // @pragma Construction
	
	    function Map(value) {
	      return value === null || value === undefined ? emptyMap() :
	        isMap(value) && !isOrdered(value) ? value :
	        emptyMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
	      return emptyMap().withMutations(function(map ) {
	        for (var i = 0; i < keyValues.length; i += 2) {
	          if (i + 1 >= keyValues.length) {
	            throw new Error('Missing value for key: ' + keyValues[i]);
	          }
	          map.set(keyValues[i], keyValues[i + 1]);
	        }
	      });
	    };
	
	    Map.prototype.toString = function() {
	      return this.__toString('Map {', '}');
	    };
	
	    // @pragma Access
	
	    Map.prototype.get = function(k, notSetValue) {
	      return this._root ?
	        this._root.get(0, undefined, k, notSetValue) :
	        notSetValue;
	    };
	
	    // @pragma Modification
	
	    Map.prototype.set = function(k, v) {
	      return updateMap(this, k, v);
	    };
	
	    Map.prototype.setIn = function(keyPath, v) {
	      return this.updateIn(keyPath, NOT_SET, function()  {return v});
	    };
	
	    Map.prototype.remove = function(k) {
	      return updateMap(this, k, NOT_SET);
	    };
	
	    Map.prototype.deleteIn = function(keyPath) {
	      return this.updateIn(keyPath, function()  {return NOT_SET});
	    };
	
	    Map.prototype.update = function(k, notSetValue, updater) {
	      return arguments.length === 1 ?
	        k(this) :
	        this.updateIn([k], notSetValue, updater);
	    };
	
	    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
	      if (!updater) {
	        updater = notSetValue;
	        notSetValue = undefined;
	      }
	      var updatedValue = updateInDeepMap(
	        this,
	        forceIterator(keyPath),
	        notSetValue,
	        updater
	      );
	      return updatedValue === NOT_SET ? undefined : updatedValue;
	    };
	
	    Map.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._root = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyMap();
	    };
	
	    // @pragma Composition
	
	    Map.prototype.merge = function(/*...iters*/) {
	      return mergeIntoMapWith(this, undefined, arguments);
	    };
	
	    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, merger, iters);
	    };
	
	    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.merge === 'function' ?
	          m.merge.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoMapWith(this, deepMerger, arguments);
	    };
	
	    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
	    };
	
	    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.mergeDeep === 'function' ?
	          m.mergeDeep.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator));
	    };
	
	    Map.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator, mapper));
	    };
	
	    // @pragma Mutability
	
	    Map.prototype.withMutations = function(fn) {
	      var mutable = this.asMutable();
	      fn(mutable);
	      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
	    };
	
	    Map.prototype.asMutable = function() {
	      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
	    };
	
	    Map.prototype.asImmutable = function() {
	      return this.__ensureOwner();
	    };
	
	    Map.prototype.wasAltered = function() {
	      return this.__altered;
	    };
	
	    Map.prototype.__iterator = function(type, reverse) {
	      return new MapIterator(this, type, reverse);
	    };
	
	    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      this._root && this._root.iterate(function(entry ) {
	        iterations++;
	        return fn(entry[1], entry[0], this$0);
	      }, reverse);
	      return iterations;
	    };
	
	    Map.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeMap(this.size, this._root, ownerID, this.__hash);
	    };
	
	
	  function isMap(maybeMap) {
	    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
	  }
	
	  Map.isMap = isMap;
	
	  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
	  var MapPrototype = Map.prototype;
	  MapPrototype[IS_MAP_SENTINEL] = true;
	  MapPrototype[DELETE] = MapPrototype.remove;
	  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
	  // #pragma Trie Nodes
	
	
	
	    function ArrayMapNode(ownerID, entries) {
	      this.ownerID = ownerID;
	      this.entries = entries;
	    }
	
	    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && entries.length === 1) {
	        return; // undefined
	      }
	
	      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
	        return createNodes(ownerID, entries, key, value);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new ArrayMapNode(ownerID, newEntries);
	    };
	
	
	
	
	    function BitmapIndexedNode(ownerID, bitmap, nodes) {
	      this.ownerID = ownerID;
	      this.bitmap = bitmap;
	      this.nodes = nodes;
	    }
	
	    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
	      var bitmap = this.bitmap;
	      return (bitmap & bit) === 0 ? notSetValue :
	        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
	    };
	
	    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var bit = 1 << keyHashFrag;
	      var bitmap = this.bitmap;
	      var exists = (bitmap & bit) !== 0;
	
	      if (!exists && value === NOT_SET) {
	        return this;
	      }
	
	      var idx = popCount(bitmap & (bit - 1));
	      var nodes = this.nodes;
	      var node = exists ? nodes[idx] : undefined;
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
	      if (newNode === node) {
	        return this;
	      }
	
	      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
	        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
	      }
	
	      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
	        return nodes[idx ^ 1];
	      }
	
	      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
	        return newNode;
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
	      var newNodes = exists ? newNode ?
	        setIn(nodes, idx, newNode, isEditable) :
	        spliceOut(nodes, idx, isEditable) :
	        spliceIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.bitmap = newBitmap;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
	    };
	
	
	
	
	    function HashArrayMapNode(ownerID, count, nodes) {
	      this.ownerID = ownerID;
	      this.count = count;
	      this.nodes = nodes;
	    }
	
	    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var node = this.nodes[idx];
	      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
	    };
	
	    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var removed = value === NOT_SET;
	      var nodes = this.nodes;
	      var node = nodes[idx];
	
	      if (removed && !node) {
	        return this;
	      }
	
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	      if (newNode === node) {
	        return this;
	      }
	
	      var newCount = this.count;
	      if (!node) {
	        newCount++;
	      } else if (!newNode) {
	        newCount--;
	        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
	          return packNodes(ownerID, nodes, newCount, idx);
	        }
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.count = newCount;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new HashArrayMapNode(ownerID, newCount, newNodes);
	    };
	
	
	
	
	    function HashCollisionNode(ownerID, keyHash, entries) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entries = entries;
	    }
	
	    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	
	      var removed = value === NOT_SET;
	
	      if (keyHash !== this.keyHash) {
	        if (removed) {
	          return this;
	        }
	        SetRef(didAlter);
	        SetRef(didChangeSize);
	        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
	      }
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && len === 2) {
	        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
	    };
	
	
	
	
	    function ValueNode(ownerID, keyHash, entry) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entry = entry;
	    }
	
	    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
	    };
	
	    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	      var keyMatch = is(key, this.entry[0]);
	      if (keyMatch ? value === this.entry[1] : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	
	      if (removed) {
	        SetRef(didChangeSize);
	        return; // undefined
	      }
	
	      if (keyMatch) {
	        if (ownerID && ownerID === this.ownerID) {
	          this.entry[1] = value;
	          return this;
	        }
	        return new ValueNode(ownerID, this.keyHash, [key, value]);
	      }
	
	      SetRef(didChangeSize);
	      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
	    };
	
	
	
	  // #pragma Iterators
	
	  ArrayMapNode.prototype.iterate =
	  HashCollisionNode.prototype.iterate = function (fn, reverse) {
	    var entries = this.entries;
	    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
	      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
	        return false;
	      }
	    }
	  }
	
	  BitmapIndexedNode.prototype.iterate =
	  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
	    var nodes = this.nodes;
	    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
	      var node = nodes[reverse ? maxIndex - ii : ii];
	      if (node && node.iterate(fn, reverse) === false) {
	        return false;
	      }
	    }
	  }
	
	  ValueNode.prototype.iterate = function (fn, reverse) {
	    return fn(this.entry);
	  }
	
	  createClass(MapIterator, Iterator);
	
	    function MapIterator(map, type, reverse) {
	      this._type = type;
	      this._reverse = reverse;
	      this._stack = map._root && mapIteratorFrame(map._root);
	    }
	
	    MapIterator.prototype.next = function() {
	      var type = this._type;
	      var stack = this._stack;
	      while (stack) {
	        var node = stack.node;
	        var index = stack.index++;
	        var maxIndex;
	        if (node.entry) {
	          if (index === 0) {
	            return mapIteratorValue(type, node.entry);
	          }
	        } else if (node.entries) {
	          maxIndex = node.entries.length - 1;
	          if (index <= maxIndex) {
	            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
	          }
	        } else {
	          maxIndex = node.nodes.length - 1;
	          if (index <= maxIndex) {
	            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
	            if (subNode) {
	              if (subNode.entry) {
	                return mapIteratorValue(type, subNode.entry);
	              }
	              stack = this._stack = mapIteratorFrame(subNode, stack);
	            }
	            continue;
	          }
	        }
	        stack = this._stack = this._stack.__prev;
	      }
	      return iteratorDone();
	    };
	
	
	  function mapIteratorValue(type, entry) {
	    return iteratorValue(type, entry[0], entry[1]);
	  }
	
	  function mapIteratorFrame(node, prev) {
	    return {
	      node: node,
	      index: 0,
	      __prev: prev
	    };
	  }
	
	  function makeMap(size, root, ownerID, hash) {
	    var map = Object.create(MapPrototype);
	    map.size = size;
	    map._root = root;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_MAP;
	  function emptyMap() {
	    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
	  }
	
	  function updateMap(map, k, v) {
	    var newRoot;
	    var newSize;
	    if (!map._root) {
	      if (v === NOT_SET) {
	        return map;
	      }
	      newSize = 1;
	      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
	    } else {
	      var didChangeSize = MakeRef(CHANGE_LENGTH);
	      var didAlter = MakeRef(DID_ALTER);
	      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
	      if (!didAlter.value) {
	        return map;
	      }
	      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
	    }
	    if (map.__ownerID) {
	      map.size = newSize;
	      map._root = newRoot;
	      map.__hash = undefined;
	      map.__altered = true;
	      return map;
	    }
	    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
	  }
	
	  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (!node) {
	      if (value === NOT_SET) {
	        return node;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return new ValueNode(ownerID, keyHash, [key, value]);
	    }
	    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
	  }
	
	  function isLeafNode(node) {
	    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
	  }
	
	  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
	    if (node.keyHash === keyHash) {
	      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
	    }
	
	    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
	    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
	    var newNode;
	    var nodes = idx1 === idx2 ?
	      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
	      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
	    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
	  }
	
	  function createNodes(ownerID, entries, key, value) {
	    if (!ownerID) {
	      ownerID = new OwnerID();
	    }
	    var node = new ValueNode(ownerID, hash(key), [key, value]);
	    for (var ii = 0; ii < entries.length; ii++) {
	      var entry = entries[ii];
	      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
	    }
	    return node;
	  }
	
	  function packNodes(ownerID, nodes, count, excluding) {
	    var bitmap = 0;
	    var packedII = 0;
	    var packedNodes = new Array(count);
	    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
	      var node = nodes[ii];
	      if (node !== undefined && ii !== excluding) {
	        bitmap |= bit;
	        packedNodes[packedII++] = node;
	      }
	    }
	    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
	  }
	
	  function expandNodes(ownerID, nodes, bitmap, including, node) {
	    var count = 0;
	    var expandedNodes = new Array(SIZE);
	    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
	      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
	    }
	    expandedNodes[including] = node;
	    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
	  }
	
	  function mergeIntoMapWith(map, merger, iterables) {
	    var iters = [];
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = KeyedIterable(value);
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    return mergeIntoCollectionWith(map, merger, iters);
	  }
	
	  function deepMerger(existing, value, key) {
	    return existing && existing.mergeDeep && isIterable(value) ?
	      existing.mergeDeep(value) :
	      is(existing, value) ? existing : value;
	  }
	
	  function deepMergerWith(merger) {
	    return function(existing, value, key)  {
	      if (existing && existing.mergeDeepWith && isIterable(value)) {
	        return existing.mergeDeepWith(merger, value);
	      }
	      var nextValue = merger(existing, value, key);
	      return is(existing, nextValue) ? existing : nextValue;
	    };
	  }
	
	  function mergeIntoCollectionWith(collection, merger, iters) {
	    iters = iters.filter(function(x ) {return x.size !== 0});
	    if (iters.length === 0) {
	      return collection;
	    }
	    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
	      return collection.constructor(iters[0]);
	    }
	    return collection.withMutations(function(collection ) {
	      var mergeIntoMap = merger ?
	        function(value, key)  {
	          collection.update(key, NOT_SET, function(existing )
	            {return existing === NOT_SET ? value : merger(existing, value, key)}
	          );
	        } :
	        function(value, key)  {
	          collection.set(key, value);
	        }
	      for (var ii = 0; ii < iters.length; ii++) {
	        iters[ii].forEach(mergeIntoMap);
	      }
	    });
	  }
	
	  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
	    var isNotSet = existing === NOT_SET;
	    var step = keyPathIter.next();
	    if (step.done) {
	      var existingValue = isNotSet ? notSetValue : existing;
	      var newValue = updater(existingValue);
	      return newValue === existingValue ? existing : newValue;
	    }
	    invariant(
	      isNotSet || (existing && existing.set),
	      'invalid keyPath'
	    );
	    var key = step.value;
	    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
	    var nextUpdated = updateInDeepMap(
	      nextExisting,
	      keyPathIter,
	      notSetValue,
	      updater
	    );
	    return nextUpdated === nextExisting ? existing :
	      nextUpdated === NOT_SET ? existing.remove(key) :
	      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
	  }
	
	  function popCount(x) {
	    x = x - ((x >> 1) & 0x55555555);
	    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
	    x = (x + (x >> 4)) & 0x0f0f0f0f;
	    x = x + (x >> 8);
	    x = x + (x >> 16);
	    return x & 0x7f;
	  }
	
	  function setIn(array, idx, val, canEdit) {
	    var newArray = canEdit ? array : arrCopy(array);
	    newArray[idx] = val;
	    return newArray;
	  }
	
	  function spliceIn(array, idx, val, canEdit) {
	    var newLen = array.length + 1;
	    if (canEdit && idx + 1 === newLen) {
	      array[idx] = val;
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        newArray[ii] = val;
	        after = -1;
	      } else {
	        newArray[ii] = array[ii + after];
	      }
	    }
	    return newArray;
	  }
	
	  function spliceOut(array, idx, canEdit) {
	    var newLen = array.length - 1;
	    if (canEdit && idx === newLen) {
	      array.pop();
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        after = 1;
	      }
	      newArray[ii] = array[ii + after];
	    }
	    return newArray;
	  }
	
	  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
	  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
	  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
	  createClass(List, IndexedCollection);
	
	    // @pragma Construction
	
	    function List(value) {
	      var empty = emptyList();
	      if (value === null || value === undefined) {
	        return empty;
	      }
	      if (isList(value)) {
	        return value;
	      }
	      var iter = IndexedIterable(value);
	      var size = iter.size;
	      if (size === 0) {
	        return empty;
	      }
	      assertNotInfinite(size);
	      if (size > 0 && size < SIZE) {
	        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
	      }
	      return empty.withMutations(function(list ) {
	        list.setSize(size);
	        iter.forEach(function(v, i)  {return list.set(i, v)});
	      });
	    }
	
	    List.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    List.prototype.toString = function() {
	      return this.__toString('List [', ']');
	    };
	
	    // @pragma Access
	
	    List.prototype.get = function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      if (index >= 0 && index < this.size) {
	        index += this._origin;
	        var node = listNodeFor(this, index);
	        return node && node.array[index & MASK];
	      }
	      return notSetValue;
	    };
	
	    // @pragma Modification
	
	    List.prototype.set = function(index, value) {
	      return updateList(this, index, value);
	    };
	
	    List.prototype.remove = function(index) {
	      return !this.has(index) ? this :
	        index === 0 ? this.shift() :
	        index === this.size - 1 ? this.pop() :
	        this.splice(index, 1);
	    };
	
	    List.prototype.insert = function(index, value) {
	      return this.splice(index, 0, value);
	    };
	
	    List.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = this._origin = this._capacity = 0;
	        this._level = SHIFT;
	        this._root = this._tail = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyList();
	    };
	
	    List.prototype.push = function(/*...values*/) {
	      var values = arguments;
	      var oldSize = this.size;
	      return this.withMutations(function(list ) {
	        setListBounds(list, 0, oldSize + values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(oldSize + ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.pop = function() {
	      return setListBounds(this, 0, -1);
	    };
	
	    List.prototype.unshift = function(/*...values*/) {
	      var values = arguments;
	      return this.withMutations(function(list ) {
	        setListBounds(list, -values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.shift = function() {
	      return setListBounds(this, 1);
	    };
	
	    // @pragma Composition
	
	    List.prototype.merge = function(/*...iters*/) {
	      return mergeIntoListWith(this, undefined, arguments);
	    };
	
	    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, merger, iters);
	    };
	
	    List.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoListWith(this, deepMerger, arguments);
	    };
	
	    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, deepMergerWith(merger), iters);
	    };
	
	    List.prototype.setSize = function(size) {
	      return setListBounds(this, 0, size);
	    };
	
	    // @pragma Iteration
	
	    List.prototype.slice = function(begin, end) {
	      var size = this.size;
	      if (wholeSlice(begin, end, size)) {
	        return this;
	      }
	      return setListBounds(
	        this,
	        resolveBegin(begin, size),
	        resolveEnd(end, size)
	      );
	    };
	
	    List.prototype.__iterator = function(type, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      return new Iterator(function()  {
	        var value = values();
	        return value === DONE ?
	          iteratorDone() :
	          iteratorValue(type, index++, value);
	      });
	    };
	
	    List.prototype.__iterate = function(fn, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      var value;
	      while ((value = values()) !== DONE) {
	        if (fn(value, index++, this) === false) {
	          break;
	        }
	      }
	      return index;
	    };
	
	    List.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        return this;
	      }
	      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
	    };
	
	
	  function isList(maybeList) {
	    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
	  }
	
	  List.isList = isList;
	
	  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
	  var ListPrototype = List.prototype;
	  ListPrototype[IS_LIST_SENTINEL] = true;
	  ListPrototype[DELETE] = ListPrototype.remove;
	  ListPrototype.setIn = MapPrototype.setIn;
	  ListPrototype.deleteIn =
	  ListPrototype.removeIn = MapPrototype.removeIn;
	  ListPrototype.update = MapPrototype.update;
	  ListPrototype.updateIn = MapPrototype.updateIn;
	  ListPrototype.mergeIn = MapPrototype.mergeIn;
	  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  ListPrototype.withMutations = MapPrototype.withMutations;
	  ListPrototype.asMutable = MapPrototype.asMutable;
	  ListPrototype.asImmutable = MapPrototype.asImmutable;
	  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
	    function VNode(array, ownerID) {
	      this.array = array;
	      this.ownerID = ownerID;
	    }
	
	    // TODO: seems like these methods are very similar
	
	    VNode.prototype.removeBefore = function(ownerID, level, index) {
	      if (index === level ? 1 << level : 0 || this.array.length === 0) {
	        return this;
	      }
	      var originIndex = (index >>> level) & MASK;
	      if (originIndex >= this.array.length) {
	        return new VNode([], ownerID);
	      }
	      var removingFirst = originIndex === 0;
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[originIndex];
	        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && removingFirst) {
	          return this;
	        }
	      }
	      if (removingFirst && !newChild) {
	        return this;
	      }
	      var editable = editableVNode(this, ownerID);
	      if (!removingFirst) {
	        for (var ii = 0; ii < originIndex; ii++) {
	          editable.array[ii] = undefined;
	        }
	      }
	      if (newChild) {
	        editable.array[originIndex] = newChild;
	      }
	      return editable;
	    };
	
	    VNode.prototype.removeAfter = function(ownerID, level, index) {
	      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
	        return this;
	      }
	      var sizeIndex = ((index - 1) >>> level) & MASK;
	      if (sizeIndex >= this.array.length) {
	        return this;
	      }
	
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[sizeIndex];
	        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
	          return this;
	        }
	      }
	
	      var editable = editableVNode(this, ownerID);
	      editable.array.splice(sizeIndex + 1);
	      if (newChild) {
	        editable.array[sizeIndex] = newChild;
	      }
	      return editable;
	    };
	
	
	
	  var DONE = {};
	
	  function iterateList(list, reverse) {
	    var left = list._origin;
	    var right = list._capacity;
	    var tailPos = getTailOffset(right);
	    var tail = list._tail;
	
	    return iterateNodeOrLeaf(list._root, list._level, 0);
	
	    function iterateNodeOrLeaf(node, level, offset) {
	      return level === 0 ?
	        iterateLeaf(node, offset) :
	        iterateNode(node, level, offset);
	    }
	
	    function iterateLeaf(node, offset) {
	      var array = offset === tailPos ? tail && tail.array : node && node.array;
	      var from = offset > left ? 0 : left - offset;
	      var to = right - offset;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        if (from === to) {
	          return DONE;
	        }
	        var idx = reverse ? --to : from++;
	        return array && array[idx];
	      };
	    }
	
	    function iterateNode(node, level, offset) {
	      var values;
	      var array = node && node.array;
	      var from = offset > left ? 0 : (left - offset) >> level;
	      var to = ((right - offset) >> level) + 1;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        do {
	          if (values) {
	            var value = values();
	            if (value !== DONE) {
	              return value;
	            }
	            values = null;
	          }
	          if (from === to) {
	            return DONE;
	          }
	          var idx = reverse ? --to : from++;
	          values = iterateNodeOrLeaf(
	            array && array[idx], level - SHIFT, offset + (idx << level)
	          );
	        } while (true);
	      };
	    }
	  }
	
	  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
	    var list = Object.create(ListPrototype);
	    list.size = capacity - origin;
	    list._origin = origin;
	    list._capacity = capacity;
	    list._level = level;
	    list._root = root;
	    list._tail = tail;
	    list.__ownerID = ownerID;
	    list.__hash = hash;
	    list.__altered = false;
	    return list;
	  }
	
	  var EMPTY_LIST;
	  function emptyList() {
	    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
	  }
	
	  function updateList(list, index, value) {
	    index = wrapIndex(list, index);
	
	    if (index !== index) {
	      return list;
	    }
	
	    if (index >= list.size || index < 0) {
	      return list.withMutations(function(list ) {
	        index < 0 ?
	          setListBounds(list, index).set(0, value) :
	          setListBounds(list, 0, index + 1).set(index, value)
	      });
	    }
	
	    index += list._origin;
	
	    var newTail = list._tail;
	    var newRoot = list._root;
	    var didAlter = MakeRef(DID_ALTER);
	    if (index >= getTailOffset(list._capacity)) {
	      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
	    } else {
	      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
	    }
	
	    if (!didAlter.value) {
	      return list;
	    }
	
	    if (list.__ownerID) {
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
	  }
	
	  function updateVNode(node, ownerID, level, index, value, didAlter) {
	    var idx = (index >>> level) & MASK;
	    var nodeHas = node && idx < node.array.length;
	    if (!nodeHas && value === undefined) {
	      return node;
	    }
	
	    var newNode;
	
	    if (level > 0) {
	      var lowerNode = node && node.array[idx];
	      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
	      if (newLowerNode === lowerNode) {
	        return node;
	      }
	      newNode = editableVNode(node, ownerID);
	      newNode.array[idx] = newLowerNode;
	      return newNode;
	    }
	
	    if (nodeHas && node.array[idx] === value) {
	      return node;
	    }
	
	    SetRef(didAlter);
	
	    newNode = editableVNode(node, ownerID);
	    if (value === undefined && idx === newNode.array.length - 1) {
	      newNode.array.pop();
	    } else {
	      newNode.array[idx] = value;
	    }
	    return newNode;
	  }
	
	  function editableVNode(node, ownerID) {
	    if (ownerID && node && ownerID === node.ownerID) {
	      return node;
	    }
	    return new VNode(node ? node.array.slice() : [], ownerID);
	  }
	
	  function listNodeFor(list, rawIndex) {
	    if (rawIndex >= getTailOffset(list._capacity)) {
	      return list._tail;
	    }
	    if (rawIndex < 1 << (list._level + SHIFT)) {
	      var node = list._root;
	      var level = list._level;
	      while (node && level > 0) {
	        node = node.array[(rawIndex >>> level) & MASK];
	        level -= SHIFT;
	      }
	      return node;
	    }
	  }
	
	  function setListBounds(list, begin, end) {
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	    var owner = list.__ownerID || new OwnerID();
	    var oldOrigin = list._origin;
	    var oldCapacity = list._capacity;
	    var newOrigin = oldOrigin + begin;
	    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
	    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
	      return list;
	    }
	
	    // If it's going to end after it starts, it's empty.
	    if (newOrigin >= newCapacity) {
	      return list.clear();
	    }
	
	    var newLevel = list._level;
	    var newRoot = list._root;
	
	    // New origin might need creating a higher root.
	    var offsetShift = 0;
	    while (newOrigin + offsetShift < 0) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
	      newLevel += SHIFT;
	      offsetShift += 1 << newLevel;
	    }
	    if (offsetShift) {
	      newOrigin += offsetShift;
	      oldOrigin += offsetShift;
	      newCapacity += offsetShift;
	      oldCapacity += offsetShift;
	    }
	
	    var oldTailOffset = getTailOffset(oldCapacity);
	    var newTailOffset = getTailOffset(newCapacity);
	
	    // New size might need creating a higher root.
	    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
	      newLevel += SHIFT;
	    }
	
	    // Locate or create the new tail.
	    var oldTail = list._tail;
	    var newTail = newTailOffset < oldTailOffset ?
	      listNodeFor(list, newCapacity - 1) :
	      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
	    // Merge Tail into tree.
	    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
	      newRoot = editableVNode(newRoot, owner);
	      var node = newRoot;
	      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
	        var idx = (oldTailOffset >>> level) & MASK;
	        node = node.array[idx] = editableVNode(node.array[idx], owner);
	      }
	      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
	    }
	
	    // If the size has been reduced, there's a chance the tail needs to be trimmed.
	    if (newCapacity < oldCapacity) {
	      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
	    }
	
	    // If the new origin is within the tail, then we do not need a root.
	    if (newOrigin >= newTailOffset) {
	      newOrigin -= newTailOffset;
	      newCapacity -= newTailOffset;
	      newLevel = SHIFT;
	      newRoot = null;
	      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
	    // Otherwise, if the root has been trimmed, garbage collect.
	    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
	      offsetShift = 0;
	
	      // Identify the new top root node of the subtree of the old root.
	      while (newRoot) {
	        var beginIndex = (newOrigin >>> newLevel) & MASK;
	        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
	          break;
	        }
	        if (beginIndex) {
	          offsetShift += (1 << newLevel) * beginIndex;
	        }
	        newLevel -= SHIFT;
	        newRoot = newRoot.array[beginIndex];
	      }
	
	      // Trim the new sides of the new root.
	      if (newRoot && newOrigin > oldOrigin) {
	        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
	      }
	      if (newRoot && newTailOffset < oldTailOffset) {
	        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
	      }
	      if (offsetShift) {
	        newOrigin -= offsetShift;
	        newCapacity -= offsetShift;
	      }
	    }
	
	    if (list.__ownerID) {
	      list.size = newCapacity - newOrigin;
	      list._origin = newOrigin;
	      list._capacity = newCapacity;
	      list._level = newLevel;
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
	  }
	
	  function mergeIntoListWith(list, merger, iterables) {
	    var iters = [];
	    var maxSize = 0;
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = IndexedIterable(value);
	      if (iter.size > maxSize) {
	        maxSize = iter.size;
	      }
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    if (maxSize > list.size) {
	      list = list.setSize(maxSize);
	    }
	    return mergeIntoCollectionWith(list, merger, iters);
	  }
	
	  function getTailOffset(size) {
	    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
	  }
	
	  createClass(OrderedMap, Map);
	
	    // @pragma Construction
	
	    function OrderedMap(value) {
	      return value === null || value === undefined ? emptyOrderedMap() :
	        isOrderedMap(value) ? value :
	        emptyOrderedMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    OrderedMap.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedMap.prototype.toString = function() {
	      return this.__toString('OrderedMap {', '}');
	    };
	
	    // @pragma Access
	
	    OrderedMap.prototype.get = function(k, notSetValue) {
	      var index = this._map.get(k);
	      return index !== undefined ? this._list.get(index)[1] : notSetValue;
	    };
	
	    // @pragma Modification
	
	    OrderedMap.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._map.clear();
	        this._list.clear();
	        return this;
	      }
	      return emptyOrderedMap();
	    };
	
	    OrderedMap.prototype.set = function(k, v) {
	      return updateOrderedMap(this, k, v);
	    };
	
	    OrderedMap.prototype.remove = function(k) {
	      return updateOrderedMap(this, k, NOT_SET);
	    };
	
	    OrderedMap.prototype.wasAltered = function() {
	      return this._map.wasAltered() || this._list.wasAltered();
	    };
	
	    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._list.__iterate(
	        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
	        reverse
	      );
	    };
	
	    OrderedMap.prototype.__iterator = function(type, reverse) {
	      return this._list.fromEntrySeq().__iterator(type, reverse);
	    };
	
	    OrderedMap.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      var newList = this._list.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        this._list = newList;
	        return this;
	      }
	      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
	    };
	
	
	  function isOrderedMap(maybeOrderedMap) {
	    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
	  }
	
	  OrderedMap.isOrderedMap = isOrderedMap;
	
	  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
	  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
	  function makeOrderedMap(map, list, ownerID, hash) {
	    var omap = Object.create(OrderedMap.prototype);
	    omap.size = map ? map.size : 0;
	    omap._map = map;
	    omap._list = list;
	    omap.__ownerID = ownerID;
	    omap.__hash = hash;
	    return omap;
	  }
	
	  var EMPTY_ORDERED_MAP;
	  function emptyOrderedMap() {
	    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
	  }
	
	  function updateOrderedMap(omap, k, v) {
	    var map = omap._map;
	    var list = omap._list;
	    var i = map.get(k);
	    var has = i !== undefined;
	    var newMap;
	    var newList;
	    if (v === NOT_SET) { // removed
	      if (!has) {
	        return omap;
	      }
	      if (list.size >= SIZE && list.size >= map.size * 2) {
	        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
	        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
	        if (omap.__ownerID) {
	          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
	        }
	      } else {
	        newMap = map.remove(k);
	        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
	      }
	    } else {
	      if (has) {
	        if (v === list.get(i)[1]) {
	          return omap;
	        }
	        newMap = map;
	        newList = list.set(i, [k, v]);
	      } else {
	        newMap = map.set(k, list.size);
	        newList = list.set(list.size, [k, v]);
	      }
	    }
	    if (omap.__ownerID) {
	      omap.size = newMap.size;
	      omap._map = newMap;
	      omap._list = newList;
	      omap.__hash = undefined;
	      return omap;
	    }
	    return makeOrderedMap(newMap, newList);
	  }
	
	  createClass(ToKeyedSequence, KeyedSeq);
	    function ToKeyedSequence(indexed, useKeys) {
	      this._iter = indexed;
	      this._useKeys = useKeys;
	      this.size = indexed.size;
	    }
	
	    ToKeyedSequence.prototype.get = function(key, notSetValue) {
	      return this._iter.get(key, notSetValue);
	    };
	
	    ToKeyedSequence.prototype.has = function(key) {
	      return this._iter.has(key);
	    };
	
	    ToKeyedSequence.prototype.valueSeq = function() {
	      return this._iter.valueSeq();
	    };
	
	    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
	      var reversedSequence = reverseFactory(this, true);
	      if (!this._useKeys) {
	        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
	      }
	      return reversedSequence;
	    };
	
	    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
	      var mappedSequence = mapFactory(this, mapper, context);
	      if (!this._useKeys) {
	        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
	      }
	      return mappedSequence;
	    };
	
	    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var ii;
	      return this._iter.__iterate(
	        this._useKeys ?
	          function(v, k)  {return fn(v, k, this$0)} :
	          ((ii = reverse ? resolveSize(this) : 0),
	            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
	        reverse
	      );
	    };
	
	    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
	      if (this._useKeys) {
	        return this._iter.__iterator(type, reverse);
	      }
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var ii = reverse ? resolveSize(this) : 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
	      });
	    };
	
	  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(ToIndexedSequence, IndexedSeq);
	    function ToIndexedSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToIndexedSequence.prototype.includes = function(value) {
	      return this._iter.includes(value);
	    };
	
	    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
	    };
	
	    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, iterations++, step.value, step)
	      });
	    };
	
	
	
	  createClass(ToSetSequence, SetSeq);
	    function ToSetSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToSetSequence.prototype.has = function(key) {
	      return this._iter.includes(key);
	    };
	
	    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
	    };
	
	    ToSetSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, step.value, step.value, step);
	      });
	    };
	
	
	
	  createClass(FromEntriesSequence, KeyedSeq);
	    function FromEntriesSequence(entries) {
	      this._iter = entries;
	      this.size = entries.size;
	    }
	
	    FromEntriesSequence.prototype.entrySeq = function() {
	      return this._iter.toSeq();
	    };
	
	    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(entry ) {
	        // Check if entry exists first so array access doesn't throw for holes
	        // in the parent iteration.
	        if (entry) {
	          validateEntry(entry);
	          var indexedIterable = isIterable(entry);
	          return fn(
	            indexedIterable ? entry.get(1) : entry[1],
	            indexedIterable ? entry.get(0) : entry[0],
	            this$0
	          );
	        }
	      }, reverse);
	    };
	
	    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          // Check if entry exists first so array access doesn't throw for holes
	          // in the parent iteration.
	          if (entry) {
	            validateEntry(entry);
	            var indexedIterable = isIterable(entry);
	            return iteratorValue(
	              type,
	              indexedIterable ? entry.get(0) : entry[0],
	              indexedIterable ? entry.get(1) : entry[1],
	              step
	            );
	          }
	        }
	      });
	    };
	
	
	  ToIndexedSequence.prototype.cacheResult =
	  ToKeyedSequence.prototype.cacheResult =
	  ToSetSequence.prototype.cacheResult =
	  FromEntriesSequence.prototype.cacheResult =
	    cacheResultThrough;
	
	
	  function flipFactory(iterable) {
	    var flipSequence = makeSequence(iterable);
	    flipSequence._iter = iterable;
	    flipSequence.size = iterable.size;
	    flipSequence.flip = function()  {return iterable};
	    flipSequence.reverse = function () {
	      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
	      reversedSequence.flip = function()  {return iterable.reverse()};
	      return reversedSequence;
	    };
	    flipSequence.has = function(key ) {return iterable.includes(key)};
	    flipSequence.includes = function(key ) {return iterable.has(key)};
	    flipSequence.cacheResult = cacheResultThrough;
	    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
	    }
	    flipSequence.__iteratorUncached = function(type, reverse) {
	      if (type === ITERATE_ENTRIES) {
	        var iterator = iterable.__iterator(type, reverse);
	        return new Iterator(function()  {
	          var step = iterator.next();
	          if (!step.done) {
	            var k = step.value[0];
	            step.value[0] = step.value[1];
	            step.value[1] = k;
	          }
	          return step;
	        });
	      }
	      return iterable.__iterator(
	        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
	        reverse
	      );
	    }
	    return flipSequence;
	  }
	
	
	  function mapFactory(iterable, mapper, context) {
	    var mappedSequence = makeSequence(iterable);
	    mappedSequence.size = iterable.size;
	    mappedSequence.has = function(key ) {return iterable.has(key)};
	    mappedSequence.get = function(key, notSetValue)  {
	      var v = iterable.get(key, NOT_SET);
	      return v === NOT_SET ?
	        notSetValue :
	        mapper.call(context, v, key, iterable);
	    };
	    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(
	        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
	        reverse
	      );
	    }
	    mappedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var key = entry[0];
	        return iteratorValue(
	          type,
	          key,
	          mapper.call(context, entry[1], key, iterable),
	          step
	        );
	      });
	    }
	    return mappedSequence;
	  }
	
	
	  function reverseFactory(iterable, useKeys) {
	    var reversedSequence = makeSequence(iterable);
	    reversedSequence._iter = iterable;
	    reversedSequence.size = iterable.size;
	    reversedSequence.reverse = function()  {return iterable};
	    if (iterable.flip) {
	      reversedSequence.flip = function () {
	        var flipSequence = flipFactory(iterable);
	        flipSequence.reverse = function()  {return iterable.flip()};
	        return flipSequence;
	      };
	    }
	    reversedSequence.get = function(key, notSetValue) 
	      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
	    reversedSequence.has = function(key )
	      {return iterable.has(useKeys ? key : -1 - key)};
	    reversedSequence.includes = function(value ) {return iterable.includes(value)};
	    reversedSequence.cacheResult = cacheResultThrough;
	    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
	    };
	    reversedSequence.__iterator =
	      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
	    return reversedSequence;
	  }
	
	
	  function filterFactory(iterable, predicate, context, useKeys) {
	    var filterSequence = makeSequence(iterable);
	    if (useKeys) {
	      filterSequence.has = function(key ) {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
	      };
	      filterSequence.get = function(key, notSetValue)  {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
	          v : notSetValue;
	      };
	    }
	    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      }, reverse);
	      return iterations;
	    };
	    filterSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          var key = entry[0];
	          var value = entry[1];
	          if (predicate.call(context, value, key, iterable)) {
	            return iteratorValue(type, useKeys ? key : iterations++, value, step);
	          }
	        }
	      });
	    }
	    return filterSequence;
	  }
	
	
	  function countByFactory(iterable, grouper, context) {
	    var groups = Map().asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        0,
	        function(a ) {return a + 1}
	      );
	    });
	    return groups.asImmutable();
	  }
	
	
	  function groupByFactory(iterable, grouper, context) {
	    var isKeyedIter = isKeyed(iterable);
	    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
	      );
	    });
	    var coerce = iterableClass(iterable);
	    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
	  }
	
	
	  function sliceFactory(iterable, begin, end, useKeys) {
	    var originalSize = iterable.size;
	
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      if (end === Infinity) {
	        end = originalSize;
	      } else {
	        end = end | 0;
	      }
	    }
	
	    if (wholeSlice(begin, end, originalSize)) {
	      return iterable;
	    }
	
	    var resolvedBegin = resolveBegin(begin, originalSize);
	    var resolvedEnd = resolveEnd(end, originalSize);
	
	    // begin or end will be NaN if they were provided as negative numbers and
	    // this iterable's size is unknown. In that case, cache first so there is
	    // a known size and these do not resolve to NaN.
	    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
	      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
	    }
	
	    // Note: resolvedEnd is undefined when the original sequence's length is
	    // unknown and this slice did not supply an end and should contain all
	    // elements after resolvedBegin.
	    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
	    var resolvedSize = resolvedEnd - resolvedBegin;
	    var sliceSize;
	    if (resolvedSize === resolvedSize) {
	      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
	    }
	
	    var sliceSeq = makeSequence(iterable);
	
	    // If iterable.size is undefined, the size of the realized sliceSeq is
	    // unknown at this point unless the number of items to slice is 0
	    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
	    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
	      sliceSeq.get = function (index, notSetValue) {
	        index = wrapIndex(this, index);
	        return index >= 0 && index < sliceSize ?
	          iterable.get(index + resolvedBegin, notSetValue) :
	          notSetValue;
	      }
	    }
	
	    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (sliceSize === 0) {
	        return 0;
	      }
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var skipped = 0;
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k)  {
	        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
	                 iterations !== sliceSize;
	        }
	      });
	      return iterations;
	    };
	
	    sliceSeq.__iteratorUncached = function(type, reverse) {
	      if (sliceSize !== 0 && reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      // Don't bother instantiating parent iterator if taking 0.
	      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
	      var skipped = 0;
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (skipped++ < resolvedBegin) {
	          iterator.next();
	        }
	        if (++iterations > sliceSize) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (useKeys || type === ITERATE_VALUES) {
	          return step;
	        } else if (type === ITERATE_KEYS) {
	          return iteratorValue(type, iterations - 1, undefined, step);
	        } else {
	          return iteratorValue(type, iterations - 1, step.value[1], step);
	        }
	      });
	    }
	
	    return sliceSeq;
	  }
	
	
	  function takeWhileFactory(iterable, predicate, context) {
	    var takeSequence = makeSequence(iterable);
	    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c) 
	        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
	      );
	      return iterations;
	    };
	    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterating = true;
	      return new Iterator(function()  {
	        if (!iterating) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var k = entry[0];
	        var v = entry[1];
	        if (!predicate.call(context, v, k, this$0)) {
	          iterating = false;
	          return iteratorDone();
	        }
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return takeSequence;
	  }
	
	
	  function skipWhileFactory(iterable, predicate, context, useKeys) {
	    var skipSequence = makeSequence(iterable);
	    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      });
	      return iterations;
	    };
	    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var skipping = true;
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step, k, v;
	        do {
	          step = iterator.next();
	          if (step.done) {
	            if (useKeys || type === ITERATE_VALUES) {
	              return step;
	            } else if (type === ITERATE_KEYS) {
	              return iteratorValue(type, iterations++, undefined, step);
	            } else {
	              return iteratorValue(type, iterations++, step.value[1], step);
	            }
	          }
	          var entry = step.value;
	          k = entry[0];
	          v = entry[1];
	          skipping && (skipping = predicate.call(context, v, k, this$0));
	        } while (skipping);
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return skipSequence;
	  }
	
	
	  function concatFactory(iterable, values) {
	    var isKeyedIterable = isKeyed(iterable);
	    var iters = [iterable].concat(values).map(function(v ) {
	      if (!isIterable(v)) {
	        v = isKeyedIterable ?
	          keyedSeqFromValue(v) :
	          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
	      } else if (isKeyedIterable) {
	        v = KeyedIterable(v);
	      }
	      return v;
	    }).filter(function(v ) {return v.size !== 0});
	
	    if (iters.length === 0) {
	      return iterable;
	    }
	
	    if (iters.length === 1) {
	      var singleton = iters[0];
	      if (singleton === iterable ||
	          isKeyedIterable && isKeyed(singleton) ||
	          isIndexed(iterable) && isIndexed(singleton)) {
	        return singleton;
	      }
	    }
	
	    var concatSeq = new ArraySeq(iters);
	    if (isKeyedIterable) {
	      concatSeq = concatSeq.toKeyedSeq();
	    } else if (!isIndexed(iterable)) {
	      concatSeq = concatSeq.toSetSeq();
	    }
	    concatSeq = concatSeq.flatten(true);
	    concatSeq.size = iters.reduce(
	      function(sum, seq)  {
	        if (sum !== undefined) {
	          var size = seq.size;
	          if (size !== undefined) {
	            return sum + size;
	          }
	        }
	      },
	      0
	    );
	    return concatSeq;
	  }
	
	
	  function flattenFactory(iterable, depth, useKeys) {
	    var flatSequence = makeSequence(iterable);
	    flatSequence.__iterateUncached = function(fn, reverse) {
	      var iterations = 0;
	      var stopped = false;
	      function flatDeep(iter, currentDepth) {var this$0 = this;
	        iter.__iterate(function(v, k)  {
	          if ((!depth || currentDepth < depth) && isIterable(v)) {
	            flatDeep(v, currentDepth + 1);
	          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
	            stopped = true;
	          }
	          return !stopped;
	        }, reverse);
	      }
	      flatDeep(iterable, 0);
	      return iterations;
	    }
	    flatSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(type, reverse);
	      var stack = [];
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (iterator) {
	          var step = iterator.next();
	          if (step.done !== false) {
	            iterator = stack.pop();
	            continue;
	          }
	          var v = step.value;
	          if (type === ITERATE_ENTRIES) {
	            v = v[1];
	          }
	          if ((!depth || stack.length < depth) && isIterable(v)) {
	            stack.push(iterator);
	            iterator = v.__iterator(type, reverse);
	          } else {
	            return useKeys ? step : iteratorValue(type, iterations++, v, step);
	          }
	        }
	        return iteratorDone();
	      });
	    }
	    return flatSequence;
	  }
	
	
	  function flatMapFactory(iterable, mapper, context) {
	    var coerce = iterableClass(iterable);
	    return iterable.toSeq().map(
	      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
	    ).flatten(true);
	  }
	
	
	  function interposeFactory(iterable, separator) {
	    var interposedSequence = makeSequence(iterable);
	    interposedSequence.size = iterable.size && iterable.size * 2 -1;
	    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k) 
	        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
	        fn(v, iterations++, this$0) !== false},
	        reverse
	      );
	      return iterations;
	    };
	    interposedSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      var step;
	      return new Iterator(function()  {
	        if (!step || iterations % 2) {
	          step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	        }
	        return iterations % 2 ?
	          iteratorValue(type, iterations++, separator) :
	          iteratorValue(type, iterations++, step.value, step);
	      });
	    };
	    return interposedSequence;
	  }
	
	
	  function sortFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    var isKeyedIterable = isKeyed(iterable);
	    var index = 0;
	    var entries = iterable.toSeq().map(
	      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
	    ).toArray();
	    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
	      isKeyedIterable ?
	      function(v, i)  { entries[i].length = 2; } :
	      function(v, i)  { entries[i] = v[1]; }
	    );
	    return isKeyedIterable ? KeyedSeq(entries) :
	      isIndexed(iterable) ? IndexedSeq(entries) :
	      SetSeq(entries);
	  }
	
	
	  function maxFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    if (mapper) {
	      var entry = iterable.toSeq()
	        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
	        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
	      return entry && entry[0];
	    } else {
	      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
	    }
	  }
	
	  function maxCompare(comparator, a, b) {
	    var comp = comparator(b, a);
	    // b is considered the new max if the comparator declares them equal, but
	    // they are not equal and b is in fact a nullish value.
	    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
	  }
	
	
	  function zipWithFactory(keyIter, zipper, iters) {
	    var zipSequence = makeSequence(keyIter);
	    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
	    // Note: this a generic base implementation of __iterate in terms of
	    // __iterator which may be more generically useful in the future.
	    zipSequence.__iterate = function(fn, reverse) {
	      /* generic:
	      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        iterations++;
	        if (fn(step.value[1], step.value[0], this) === false) {
	          break;
	        }
	      }
	      return iterations;
	      */
	      // indexed:
	      var iterator = this.__iterator(ITERATE_VALUES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        if (fn(step.value, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	    zipSequence.__iteratorUncached = function(type, reverse) {
	      var iterators = iters.map(function(i )
	        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
	      );
	      var iterations = 0;
	      var isDone = false;
	      return new Iterator(function()  {
	        var steps;
	        if (!isDone) {
	          steps = iterators.map(function(i ) {return i.next()});
	          isDone = steps.some(function(s ) {return s.done});
	        }
	        if (isDone) {
	          return iteratorDone();
	        }
	        return iteratorValue(
	          type,
	          iterations++,
	          zipper.apply(null, steps.map(function(s ) {return s.value}))
	        );
	      });
	    };
	    return zipSequence
	  }
	
	
	  // #pragma Helper Functions
	
	  function reify(iter, seq) {
	    return isSeq(iter) ? seq : iter.constructor(seq);
	  }
	
	  function validateEntry(entry) {
	    if (entry !== Object(entry)) {
	      throw new TypeError('Expected [K, V] tuple: ' + entry);
	    }
	  }
	
	  function resolveSize(iter) {
	    assertNotInfinite(iter.size);
	    return ensureSize(iter);
	  }
	
	  function iterableClass(iterable) {
	    return isKeyed(iterable) ? KeyedIterable :
	      isIndexed(iterable) ? IndexedIterable :
	      SetIterable;
	  }
	
	  function makeSequence(iterable) {
	    return Object.create(
	      (
	        isKeyed(iterable) ? KeyedSeq :
	        isIndexed(iterable) ? IndexedSeq :
	        SetSeq
	      ).prototype
	    );
	  }
	
	  function cacheResultThrough() {
	    if (this._iter.cacheResult) {
	      this._iter.cacheResult();
	      this.size = this._iter.size;
	      return this;
	    } else {
	      return Seq.prototype.cacheResult.call(this);
	    }
	  }
	
	  function defaultComparator(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	  }
	
	  function forceIterator(keyPath) {
	    var iter = getIterator(keyPath);
	    if (!iter) {
	      // Array might not be iterable in this environment, so we need a fallback
	      // to our wrapped type.
	      if (!isArrayLike(keyPath)) {
	        throw new TypeError('Expected iterable or array-like: ' + keyPath);
	      }
	      iter = getIterator(Iterable(keyPath));
	    }
	    return iter;
	  }
	
	  createClass(Record, KeyedCollection);
	
	    function Record(defaultValues, name) {
	      var hasInitialized;
	
	      var RecordType = function Record(values) {
	        if (values instanceof RecordType) {
	          return values;
	        }
	        if (!(this instanceof RecordType)) {
	          return new RecordType(values);
	        }
	        if (!hasInitialized) {
	          hasInitialized = true;
	          var keys = Object.keys(defaultValues);
	          setProps(RecordTypePrototype, keys);
	          RecordTypePrototype.size = keys.length;
	          RecordTypePrototype._name = name;
	          RecordTypePrototype._keys = keys;
	          RecordTypePrototype._defaultValues = defaultValues;
	        }
	        this._map = Map(values);
	      };
	
	      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
	      RecordTypePrototype.constructor = RecordType;
	
	      return RecordType;
	    }
	
	    Record.prototype.toString = function() {
	      return this.__toString(recordName(this) + ' {', '}');
	    };
	
	    // @pragma Access
	
	    Record.prototype.has = function(k) {
	      return this._defaultValues.hasOwnProperty(k);
	    };
	
	    Record.prototype.get = function(k, notSetValue) {
	      if (!this.has(k)) {
	        return notSetValue;
	      }
	      var defaultVal = this._defaultValues[k];
	      return this._map ? this._map.get(k, defaultVal) : defaultVal;
	    };
	
	    // @pragma Modification
	
	    Record.prototype.clear = function() {
	      if (this.__ownerID) {
	        this._map && this._map.clear();
	        return this;
	      }
	      var RecordType = this.constructor;
	      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
	    };
	
	    Record.prototype.set = function(k, v) {
	      if (!this.has(k)) {
	        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
	      }
	      if (this._map && !this._map.has(k)) {
	        var defaultVal = this._defaultValues[k];
	        if (v === defaultVal) {
	          return this;
	        }
	      }
	      var newMap = this._map && this._map.set(k, v);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.remove = function(k) {
	      if (!this.has(k)) {
	        return this;
	      }
	      var newMap = this._map && this._map.remove(k);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
	    };
	
	    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
	    };
	
	    Record.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map && this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return makeRecord(this, newMap, ownerID);
	    };
	
	
	  var RecordPrototype = Record.prototype;
	  RecordPrototype[DELETE] = RecordPrototype.remove;
	  RecordPrototype.deleteIn =
	  RecordPrototype.removeIn = MapPrototype.removeIn;
	  RecordPrototype.merge = MapPrototype.merge;
	  RecordPrototype.mergeWith = MapPrototype.mergeWith;
	  RecordPrototype.mergeIn = MapPrototype.mergeIn;
	  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
	  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
	  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  RecordPrototype.setIn = MapPrototype.setIn;
	  RecordPrototype.update = MapPrototype.update;
	  RecordPrototype.updateIn = MapPrototype.updateIn;
	  RecordPrototype.withMutations = MapPrototype.withMutations;
	  RecordPrototype.asMutable = MapPrototype.asMutable;
	  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
	  function makeRecord(likeRecord, map, ownerID) {
	    var record = Object.create(Object.getPrototypeOf(likeRecord));
	    record._map = map;
	    record.__ownerID = ownerID;
	    return record;
	  }
	
	  function recordName(record) {
	    return record._name || record.constructor.name || 'Record';
	  }
	
	  function setProps(prototype, names) {
	    try {
	      names.forEach(setProp.bind(undefined, prototype));
	    } catch (error) {
	      // Object.defineProperty failed. Probably IE8.
	    }
	  }
	
	  function setProp(prototype, name) {
	    Object.defineProperty(prototype, name, {
	      get: function() {
	        return this.get(name);
	      },
	      set: function(value) {
	        invariant(this.__ownerID, 'Cannot set on an immutable record.');
	        this.set(name, value);
	      }
	    });
	  }
	
	  createClass(Set, SetCollection);
	
	    // @pragma Construction
	
	    function Set(value) {
	      return value === null || value === undefined ? emptySet() :
	        isSet(value) && !isOrdered(value) ? value :
	        emptySet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    Set.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Set.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    Set.prototype.toString = function() {
	      return this.__toString('Set {', '}');
	    };
	
	    // @pragma Access
	
	    Set.prototype.has = function(value) {
	      return this._map.has(value);
	    };
	
	    // @pragma Modification
	
	    Set.prototype.add = function(value) {
	      return updateSet(this, this._map.set(value, true));
	    };
	
	    Set.prototype.remove = function(value) {
	      return updateSet(this, this._map.remove(value));
	    };
	
	    Set.prototype.clear = function() {
	      return updateSet(this, this._map.clear());
	    };
	
	    // @pragma Composition
	
	    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
	      iters = iters.filter(function(x ) {return x.size !== 0});
	      if (iters.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
	        return this.constructor(iters[0]);
	      }
	      return this.withMutations(function(set ) {
	        for (var ii = 0; ii < iters.length; ii++) {
	          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
	        }
	      });
	    };
	
	    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (!iters.every(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (iters.some(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.merge = function() {
	      return this.union.apply(this, arguments);
	    };
	
	    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return this.union.apply(this, iters);
	    };
	
	    Set.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator));
	    };
	
	    Set.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator, mapper));
	    };
	
	    Set.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
	    };
	
	    Set.prototype.__iterator = function(type, reverse) {
	      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
	    };
	
	    Set.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return this.__make(newMap, ownerID);
	    };
	
	
	  function isSet(maybeSet) {
	    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
	  }
	
	  Set.isSet = isSet;
	
	  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
	  var SetPrototype = Set.prototype;
	  SetPrototype[IS_SET_SENTINEL] = true;
	  SetPrototype[DELETE] = SetPrototype.remove;
	  SetPrototype.mergeDeep = SetPrototype.merge;
	  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
	  SetPrototype.withMutations = MapPrototype.withMutations;
	  SetPrototype.asMutable = MapPrototype.asMutable;
	  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
	  SetPrototype.__empty = emptySet;
	  SetPrototype.__make = makeSet;
	
	  function updateSet(set, newMap) {
	    if (set.__ownerID) {
	      set.size = newMap.size;
	      set._map = newMap;
	      return set;
	    }
	    return newMap === set._map ? set :
	      newMap.size === 0 ? set.__empty() :
	      set.__make(newMap);
	  }
	
	  function makeSet(map, ownerID) {
	    var set = Object.create(SetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_SET;
	  function emptySet() {
	    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
	  }
	
	  createClass(OrderedSet, Set);
	
	    // @pragma Construction
	
	    function OrderedSet(value) {
	      return value === null || value === undefined ? emptyOrderedSet() :
	        isOrderedSet(value) ? value :
	        emptyOrderedSet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    OrderedSet.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedSet.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    OrderedSet.prototype.toString = function() {
	      return this.__toString('OrderedSet {', '}');
	    };
	
	
	  function isOrderedSet(maybeOrderedSet) {
	    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
	  }
	
	  OrderedSet.isOrderedSet = isOrderedSet;
	
	  var OrderedSetPrototype = OrderedSet.prototype;
	  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
	  OrderedSetPrototype.__empty = emptyOrderedSet;
	  OrderedSetPrototype.__make = makeOrderedSet;
	
	  function makeOrderedSet(map, ownerID) {
	    var set = Object.create(OrderedSetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_ORDERED_SET;
	  function emptyOrderedSet() {
	    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
	  }
	
	  createClass(Stack, IndexedCollection);
	
	    // @pragma Construction
	
	    function Stack(value) {
	      return value === null || value === undefined ? emptyStack() :
	        isStack(value) ? value :
	        emptyStack().unshiftAll(value);
	    }
	
	    Stack.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Stack.prototype.toString = function() {
	      return this.__toString('Stack [', ']');
	    };
	
	    // @pragma Access
	
	    Stack.prototype.get = function(index, notSetValue) {
	      var head = this._head;
	      index = wrapIndex(this, index);
	      while (head && index--) {
	        head = head.next;
	      }
	      return head ? head.value : notSetValue;
	    };
	
	    Stack.prototype.peek = function() {
	      return this._head && this._head.value;
	    };
	
	    // @pragma Modification
	
	    Stack.prototype.push = function(/*...values*/) {
	      if (arguments.length === 0) {
	        return this;
	      }
	      var newSize = this.size + arguments.length;
	      var head = this._head;
	      for (var ii = arguments.length - 1; ii >= 0; ii--) {
	        head = {
	          value: arguments[ii],
	          next: head
	        };
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pushAll = function(iter) {
	      iter = IndexedIterable(iter);
	      if (iter.size === 0) {
	        return this;
	      }
	      assertNotInfinite(iter.size);
	      var newSize = this.size;
	      var head = this._head;
	      iter.reverse().forEach(function(value ) {
	        newSize++;
	        head = {
	          value: value,
	          next: head
	        };
	      });
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pop = function() {
	      return this.slice(1);
	    };
	
	    Stack.prototype.unshift = function(/*...values*/) {
	      return this.push.apply(this, arguments);
	    };
	
	    Stack.prototype.unshiftAll = function(iter) {
	      return this.pushAll(iter);
	    };
	
	    Stack.prototype.shift = function() {
	      return this.pop.apply(this, arguments);
	    };
	
	    Stack.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._head = undefined;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyStack();
	    };
	
	    Stack.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      var resolvedBegin = resolveBegin(begin, this.size);
	      var resolvedEnd = resolveEnd(end, this.size);
	      if (resolvedEnd !== this.size) {
	        // super.slice(begin, end);
	        return IndexedCollection.prototype.slice.call(this, begin, end);
	      }
	      var newSize = this.size - resolvedBegin;
	      var head = this._head;
	      while (resolvedBegin--) {
	        head = head.next;
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    // @pragma Mutability
	
	    Stack.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeStack(this.size, this._head, ownerID, this.__hash);
	    };
	
	    // @pragma Iteration
	
	    Stack.prototype.__iterate = function(fn, reverse) {
	      if (reverse) {
	        return this.reverse().__iterate(fn);
	      }
	      var iterations = 0;
	      var node = this._head;
	      while (node) {
	        if (fn(node.value, iterations++, this) === false) {
	          break;
	        }
	        node = node.next;
	      }
	      return iterations;
	    };
	
	    Stack.prototype.__iterator = function(type, reverse) {
	      if (reverse) {
	        return this.reverse().__iterator(type);
	      }
	      var iterations = 0;
	      var node = this._head;
	      return new Iterator(function()  {
	        if (node) {
	          var value = node.value;
	          node = node.next;
	          return iteratorValue(type, iterations++, value);
	        }
	        return iteratorDone();
	      });
	    };
	
	
	  function isStack(maybeStack) {
	    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
	  }
	
	  Stack.isStack = isStack;
	
	  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
	  var StackPrototype = Stack.prototype;
	  StackPrototype[IS_STACK_SENTINEL] = true;
	  StackPrototype.withMutations = MapPrototype.withMutations;
	  StackPrototype.asMutable = MapPrototype.asMutable;
	  StackPrototype.asImmutable = MapPrototype.asImmutable;
	  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	  function makeStack(size, head, ownerID, hash) {
	    var map = Object.create(StackPrototype);
	    map.size = size;
	    map._head = head;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_STACK;
	  function emptyStack() {
	    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
	  }
	
	  /**
	   * Contributes additional methods to a constructor
	   */
	  function mixin(ctor, methods) {
	    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
	    Object.keys(methods).forEach(keyCopier);
	    Object.getOwnPropertySymbols &&
	      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
	    return ctor;
	  }
	
	  Iterable.Iterator = Iterator;
	
	  mixin(Iterable, {
	
	    // ### Conversion to other types
	
	    toArray: function() {
	      assertNotInfinite(this.size);
	      var array = new Array(this.size || 0);
	      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
	      return array;
	    },
	
	    toIndexedSeq: function() {
	      return new ToIndexedSequence(this);
	    },
	
	    toJS: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
	      ).__toJS();
	    },
	
	    toJSON: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
	      ).__toJS();
	    },
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, true);
	    },
	
	    toMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Map(this.toKeyedSeq());
	    },
	
	    toObject: function() {
	      assertNotInfinite(this.size);
	      var object = {};
	      this.__iterate(function(v, k)  { object[k] = v; });
	      return object;
	    },
	
	    toOrderedMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedMap(this.toKeyedSeq());
	    },
	
	    toOrderedSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Set(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSetSeq: function() {
	      return new ToSetSequence(this);
	    },
	
	    toSeq: function() {
	      return isIndexed(this) ? this.toIndexedSeq() :
	        isKeyed(this) ? this.toKeyedSeq() :
	        this.toSetSeq();
	    },
	
	    toStack: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Stack(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toList: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return List(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	
	    // ### Common JavaScript methods and properties
	
	    toString: function() {
	      return '[Iterable]';
	    },
	
	    __toString: function(head, tail) {
	      if (this.size === 0) {
	        return head + tail;
	      }
	      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    concat: function() {var values = SLICE$0.call(arguments, 0);
	      return reify(this, concatFactory(this, values));
	    },
	
	    includes: function(searchValue) {
	      return this.some(function(value ) {return is(value, searchValue)});
	    },
	
	    entries: function() {
	      return this.__iterator(ITERATE_ENTRIES);
	    },
	
	    every: function(predicate, context) {
	      assertNotInfinite(this.size);
	      var returnValue = true;
	      this.__iterate(function(v, k, c)  {
	        if (!predicate.call(context, v, k, c)) {
	          returnValue = false;
	          return false;
	        }
	      });
	      return returnValue;
	    },
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, true));
	    },
	
	    find: function(predicate, context, notSetValue) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[1] : notSetValue;
	    },
	
	    forEach: function(sideEffect, context) {
	      assertNotInfinite(this.size);
	      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
	    },
	
	    join: function(separator) {
	      assertNotInfinite(this.size);
	      separator = separator !== undefined ? '' + separator : ',';
	      var joined = '';
	      var isFirst = true;
	      this.__iterate(function(v ) {
	        isFirst ? (isFirst = false) : (joined += separator);
	        joined += v !== null && v !== undefined ? v.toString() : '';
	      });
	      return joined;
	    },
	
	    keys: function() {
	      return this.__iterator(ITERATE_KEYS);
	    },
	
	    map: function(mapper, context) {
	      return reify(this, mapFactory(this, mapper, context));
	    },
	
	    reduce: function(reducer, initialReduction, context) {
	      assertNotInfinite(this.size);
	      var reduction;
	      var useFirst;
	      if (arguments.length < 2) {
	        useFirst = true;
	      } else {
	        reduction = initialReduction;
	      }
	      this.__iterate(function(v, k, c)  {
	        if (useFirst) {
	          useFirst = false;
	          reduction = v;
	        } else {
	          reduction = reducer.call(context, reduction, v, k, c);
	        }
	      });
	      return reduction;
	    },
	
	    reduceRight: function(reducer, initialReduction, context) {
	      var reversed = this.toKeyedSeq().reverse();
	      return reversed.reduce.apply(reversed, arguments);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, true));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, true));
	    },
	
	    some: function(predicate, context) {
	      return !this.every(not(predicate), context);
	    },
	
	    sort: function(comparator) {
	      return reify(this, sortFactory(this, comparator));
	    },
	
	    values: function() {
	      return this.__iterator(ITERATE_VALUES);
	    },
	
	
	    // ### More sequential methods
	
	    butLast: function() {
	      return this.slice(0, -1);
	    },
	
	    isEmpty: function() {
	      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
	    },
	
	    count: function(predicate, context) {
	      return ensureSize(
	        predicate ? this.toSeq().filter(predicate, context) : this
	      );
	    },
	
	    countBy: function(grouper, context) {
	      return countByFactory(this, grouper, context);
	    },
	
	    equals: function(other) {
	      return deepEqual(this, other);
	    },
	
	    entrySeq: function() {
	      var iterable = this;
	      if (iterable._cache) {
	        // We cache as an entries array, so we can just return the cache!
	        return new ArraySeq(iterable._cache);
	      }
	      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
	      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
	      return entriesSequence;
	    },
	
	    filterNot: function(predicate, context) {
	      return this.filter(not(predicate), context);
	    },
	
	    findEntry: function(predicate, context, notSetValue) {
	      var found = notSetValue;
	      this.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          found = [k, v];
	          return false;
	        }
	      });
	      return found;
	    },
	
	    findKey: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry && entry[0];
	    },
	
	    findLast: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
	    },
	
	    findLastEntry: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
	    },
	
	    findLastKey: function(predicate, context) {
	      return this.toKeyedSeq().reverse().findKey(predicate, context);
	    },
	
	    first: function() {
	      return this.find(returnTrue);
	    },
	
	    flatMap: function(mapper, context) {
	      return reify(this, flatMapFactory(this, mapper, context));
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, true));
	    },
	
	    fromEntrySeq: function() {
	      return new FromEntriesSequence(this);
	    },
	
	    get: function(searchKey, notSetValue) {
	      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
	    },
	
	    getIn: function(searchKeyPath, notSetValue) {
	      var nested = this;
	      // Note: in an ES6 environment, we would prefer:
	      // for (var key of searchKeyPath) {
	      var iter = forceIterator(searchKeyPath);
	      var step;
	      while (!(step = iter.next()).done) {
	        var key = step.value;
	        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
	        if (nested === NOT_SET) {
	          return notSetValue;
	        }
	      }
	      return nested;
	    },
	
	    groupBy: function(grouper, context) {
	      return groupByFactory(this, grouper, context);
	    },
	
	    has: function(searchKey) {
	      return this.get(searchKey, NOT_SET) !== NOT_SET;
	    },
	
	    hasIn: function(searchKeyPath) {
	      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
	    },
	
	    isSubset: function(iter) {
	      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
	      return this.every(function(value ) {return iter.includes(value)});
	    },
	
	    isSuperset: function(iter) {
	      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
	      return iter.isSubset(this);
	    },
	
	    keyOf: function(searchValue) {
	      return this.findKey(function(value ) {return is(value, searchValue)});
	    },
	
	    keySeq: function() {
	      return this.toSeq().map(keyMapper).toIndexedSeq();
	    },
	
	    last: function() {
	      return this.toSeq().reverse().first();
	    },
	
	    lastKeyOf: function(searchValue) {
	      return this.toKeyedSeq().reverse().keyOf(searchValue);
	    },
	
	    max: function(comparator) {
	      return maxFactory(this, comparator);
	    },
	
	    maxBy: function(mapper, comparator) {
	      return maxFactory(this, comparator, mapper);
	    },
	
	    min: function(comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
	    },
	
	    minBy: function(mapper, comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
	    },
	
	    rest: function() {
	      return this.slice(1);
	    },
	
	    skip: function(amount) {
	      return this.slice(Math.max(0, amount));
	    },
	
	    skipLast: function(amount) {
	      return reify(this, this.toSeq().reverse().skip(amount).reverse());
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, true));
	    },
	
	    skipUntil: function(predicate, context) {
	      return this.skipWhile(not(predicate), context);
	    },
	
	    sortBy: function(mapper, comparator) {
	      return reify(this, sortFactory(this, comparator, mapper));
	    },
	
	    take: function(amount) {
	      return this.slice(0, Math.max(0, amount));
	    },
	
	    takeLast: function(amount) {
	      return reify(this, this.toSeq().reverse().take(amount).reverse());
	    },
	
	    takeWhile: function(predicate, context) {
	      return reify(this, takeWhileFactory(this, predicate, context));
	    },
	
	    takeUntil: function(predicate, context) {
	      return this.takeWhile(not(predicate), context);
	    },
	
	    valueSeq: function() {
	      return this.toIndexedSeq();
	    },
	
	
	    // ### Hashable Object
	
	    hashCode: function() {
	      return this.__hash || (this.__hash = hashIterable(this));
	    }
	
	
	    // ### Internal
	
	    // abstract __iterate(fn, reverse)
	
	    // abstract __iterator(type, reverse)
	  });
	
	  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  var IterablePrototype = Iterable.prototype;
	  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
	  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
	  IterablePrototype.__toJS = IterablePrototype.toArray;
	  IterablePrototype.__toStringMapper = quoteString;
	  IterablePrototype.inspect =
	  IterablePrototype.toSource = function() { return this.toString(); };
	  IterablePrototype.chain = IterablePrototype.flatMap;
	  IterablePrototype.contains = IterablePrototype.includes;
	
	  mixin(KeyedIterable, {
	
	    // ### More sequential methods
	
	    flip: function() {
	      return reify(this, flipFactory(this));
	    },
	
	    mapEntries: function(mapper, context) {var this$0 = this;
	      var iterations = 0;
	      return reify(this,
	        this.toSeq().map(
	          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
	        ).fromEntrySeq()
	      );
	    },
	
	    mapKeys: function(mapper, context) {var this$0 = this;
	      return reify(this,
	        this.toSeq().flip().map(
	          function(k, v)  {return mapper.call(context, k, v, this$0)}
	        ).flip()
	      );
	    }
	
	  });
	
	  var KeyedIterablePrototype = KeyedIterable.prototype;
	  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
	  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
	  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
	  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
	  mixin(IndexedIterable, {
	
	    // ### Conversion to other types
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, false);
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, false));
	    },
	
	    findIndex: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    indexOf: function(searchValue) {
	      var key = this.keyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    lastIndexOf: function(searchValue) {
	      var key = this.lastKeyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, false));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, false));
	    },
	
	    splice: function(index, removeNum /*, ...values*/) {
	      var numArgs = arguments.length;
	      removeNum = Math.max(removeNum | 0, 0);
	      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
	        return this;
	      }
	      // If index is negative, it should resolve relative to the size of the
	      // collection. However size may be expensive to compute if not cached, so
	      // only call count() if the number is in fact negative.
	      index = resolveBegin(index, index < 0 ? this.count() : this.size);
	      var spliced = this.slice(0, index);
	      return reify(
	        this,
	        numArgs === 1 ?
	          spliced :
	          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
	      );
	    },
	
	
	    // ### More collection methods
	
	    findLastIndex: function(predicate, context) {
	      var entry = this.findLastEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    first: function() {
	      return this.get(0);
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, false));
	    },
	
	    get: function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      return (index < 0 || (this.size === Infinity ||
	          (this.size !== undefined && index > this.size))) ?
	        notSetValue :
	        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
	    },
	
	    has: function(index) {
	      index = wrapIndex(this, index);
	      return index >= 0 && (this.size !== undefined ?
	        this.size === Infinity || index < this.size :
	        this.indexOf(index) !== -1
	      );
	    },
	
	    interpose: function(separator) {
	      return reify(this, interposeFactory(this, separator));
	    },
	
	    interleave: function(/*...iterables*/) {
	      var iterables = [this].concat(arrCopy(arguments));
	      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
	      var interleaved = zipped.flatten(true);
	      if (zipped.size) {
	        interleaved.size = zipped.size * iterables.length;
	      }
	      return reify(this, interleaved);
	    },
	
	    keySeq: function() {
	      return Range(0, this.size);
	    },
	
	    last: function() {
	      return this.get(-1);
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, false));
	    },
	
	    zip: function(/*, ...iterables */) {
	      var iterables = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, iterables));
	    },
	
	    zipWith: function(zipper/*, ...iterables */) {
	      var iterables = arrCopy(arguments);
	      iterables[0] = this;
	      return reify(this, zipWithFactory(this, zipper, iterables));
	    }
	
	  });
	
	  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
	  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
	  mixin(SetIterable, {
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    get: function(value, notSetValue) {
	      return this.has(value) ? value : notSetValue;
	    },
	
	    includes: function(value) {
	      return this.has(value);
	    },
	
	
	    // ### More sequential methods
	
	    keySeq: function() {
	      return this.valueSeq();
	    }
	
	  });
	
	  SetIterable.prototype.has = IterablePrototype.includes;
	  SetIterable.prototype.contains = SetIterable.prototype.includes;
	
	
	  // Mixin subclasses
	
	  mixin(KeyedSeq, KeyedIterable.prototype);
	  mixin(IndexedSeq, IndexedIterable.prototype);
	  mixin(SetSeq, SetIterable.prototype);
	
	  mixin(KeyedCollection, KeyedIterable.prototype);
	  mixin(IndexedCollection, IndexedIterable.prototype);
	  mixin(SetCollection, SetIterable.prototype);
	
	
	  // #pragma Helper functions
	
	  function keyMapper(v, k) {
	    return k;
	  }
	
	  function entryMapper(v, k) {
	    return [k, v];
	  }
	
	  function not(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    }
	  }
	
	  function neg(predicate) {
	    return function() {
	      return -predicate.apply(this, arguments);
	    }
	  }
	
	  function quoteString(value) {
	    return typeof value === 'string' ? JSON.stringify(value) : String(value);
	  }
	
	  function defaultZipper() {
	    return arrCopy(arguments);
	  }
	
	  function defaultNegComparator(a, b) {
	    return a < b ? 1 : a > b ? -1 : 0;
	  }
	
	  function hashIterable(iterable) {
	    if (iterable.size === Infinity) {
	      return 0;
	    }
	    var ordered = isOrdered(iterable);
	    var keyed = isKeyed(iterable);
	    var h = ordered ? 1 : 0;
	    var size = iterable.__iterate(
	      keyed ?
	        ordered ?
	          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
	          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
	        ordered ?
	          function(v ) { h = 31 * h + hash(v) | 0; } :
	          function(v ) { h = h + hash(v) | 0; }
	    );
	    return murmurHashOfSize(size, h);
	  }
	
	  function murmurHashOfSize(size, h) {
	    h = imul(h, 0xCC9E2D51);
	    h = imul(h << 15 | h >>> -15, 0x1B873593);
	    h = imul(h << 13 | h >>> -13, 5);
	    h = (h + 0xE6546B64 | 0) ^ size;
	    h = imul(h ^ h >>> 16, 0x85EBCA6B);
	    h = imul(h ^ h >>> 13, 0xC2B2AE35);
	    h = smi(h ^ h >>> 16);
	    return h;
	  }
	
	  function hashMerge(a, b) {
	    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
	  }
	
	  var Immutable = {
	
	    Iterable: Iterable,
	
	    Seq: Seq,
	    Collection: Collection,
	    Map: Map,
	    OrderedMap: OrderedMap,
	    List: List,
	    Stack: Stack,
	    Set: Set,
	    OrderedSet: OrderedSet,
	
	    Record: Record,
	    Range: Range,
	    Repeat: Repeat,
	
	    is: is,
	    fromJS: fromJS
	
	  };
	
	  return Immutable;
	
	}));

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.setObservableConfig = exports.createEventHandler = exports.mapPropsStream = exports.componentFromStream = exports.hoistStatics = exports.nest = exports.componentFromProp = exports.createSink = exports.createEagerFactory = exports.createEagerElement = exports.isClassComponent = exports.shallowEqual = exports.wrapDisplayName = exports.getDisplayName = exports.compose = exports.setDisplayName = exports.setPropTypes = exports.setStatic = exports.toClass = exports.lifecycle = exports.getContext = exports.withContext = exports.onlyUpdateForPropTypes = exports.onlyUpdateForKeys = exports.pure = exports.shouldUpdate = exports.renderNothing = exports.renderComponent = exports.branch = exports.withReducer = exports.withState = exports.flattenProp = exports.renameProps = exports.renameProp = exports.defaultProps = exports.withHandlers = exports.withPropsOnChange = exports.withProps = exports.mapProps = undefined;
	
	var _mapProps2 = __webpack_require__(285);
	
	var _mapProps3 = _interopRequireDefault(_mapProps2);
	
	var _withProps2 = __webpack_require__(1614);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _withPropsOnChange2 = __webpack_require__(1615);
	
	var _withPropsOnChange3 = _interopRequireDefault(_withPropsOnChange2);
	
	var _withHandlers2 = __webpack_require__(1613);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _defaultProps2 = __webpack_require__(1595);
	
	var _defaultProps3 = _interopRequireDefault(_defaultProps2);
	
	var _renameProp2 = __webpack_require__(1605);
	
	var _renameProp3 = _interopRequireDefault(_renameProp2);
	
	var _renameProps2 = __webpack_require__(1606);
	
	var _renameProps3 = _interopRequireDefault(_renameProps2);
	
	var _flattenProp2 = __webpack_require__(1596);
	
	var _flattenProp3 = _interopRequireDefault(_flattenProp2);
	
	var _withState2 = __webpack_require__(1617);
	
	var _withState3 = _interopRequireDefault(_withState2);
	
	var _withReducer2 = __webpack_require__(1616);
	
	var _withReducer3 = _interopRequireDefault(_withReducer2);
	
	var _branch2 = __webpack_require__(1590);
	
	var _branch3 = _interopRequireDefault(_branch2);
	
	var _renderComponent2 = __webpack_require__(1607);
	
	var _renderComponent3 = _interopRequireDefault(_renderComponent2);
	
	var _renderNothing2 = __webpack_require__(1608);
	
	var _renderNothing3 = _interopRequireDefault(_renderNothing2);
	
	var _shouldUpdate2 = __webpack_require__(411);
	
	var _shouldUpdate3 = _interopRequireDefault(_shouldUpdate2);
	
	var _pure2 = __webpack_require__(1604);
	
	var _pure3 = _interopRequireDefault(_pure2);
	
	var _onlyUpdateForKeys2 = __webpack_require__(644);
	
	var _onlyUpdateForKeys3 = _interopRequireDefault(_onlyUpdateForKeys2);
	
	var _onlyUpdateForPropTypes2 = __webpack_require__(1603);
	
	var _onlyUpdateForPropTypes3 = _interopRequireDefault(_onlyUpdateForPropTypes2);
	
	var _withContext2 = __webpack_require__(1612);
	
	var _withContext3 = _interopRequireDefault(_withContext2);
	
	var _getContext2 = __webpack_require__(1597);
	
	var _getContext3 = _interopRequireDefault(_getContext2);
	
	var _lifecycle2 = __webpack_require__(1599);
	
	var _lifecycle3 = _interopRequireDefault(_lifecycle2);
	
	var _toClass2 = __webpack_require__(1611);
	
	var _toClass3 = _interopRequireDefault(_toClass2);
	
	var _setStatic2 = __webpack_require__(410);
	
	var _setStatic3 = _interopRequireDefault(_setStatic2);
	
	var _setPropTypes2 = __webpack_require__(1610);
	
	var _setPropTypes3 = _interopRequireDefault(_setPropTypes2);
	
	var _setDisplayName2 = __webpack_require__(1609);
	
	var _setDisplayName3 = _interopRequireDefault(_setDisplayName2);
	
	var _compose2 = __webpack_require__(1592);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _getDisplayName2 = __webpack_require__(407);
	
	var _getDisplayName3 = _interopRequireDefault(_getDisplayName2);
	
	var _wrapDisplayName2 = __webpack_require__(1618);
	
	var _wrapDisplayName3 = _interopRequireDefault(_wrapDisplayName2);
	
	var _shallowEqual2 = __webpack_require__(287);
	
	var _shallowEqual3 = _interopRequireDefault(_shallowEqual2);
	
	var _isClassComponent2 = __webpack_require__(408);
	
	var _isClassComponent3 = _interopRequireDefault(_isClassComponent2);
	
	var _createEagerElement2 = __webpack_require__(642);
	
	var _createEagerElement3 = _interopRequireDefault(_createEagerElement2);
	
	var _createEagerFactory2 = __webpack_require__(53);
	
	var _createEagerFactory3 = _interopRequireDefault(_createEagerFactory2);
	
	var _createSink2 = __webpack_require__(1594);
	
	var _createSink3 = _interopRequireDefault(_createSink2);
	
	var _componentFromProp2 = __webpack_require__(1591);
	
	var _componentFromProp3 = _interopRequireDefault(_componentFromProp2);
	
	var _nest2 = __webpack_require__(1601);
	
	var _nest3 = _interopRequireDefault(_nest2);
	
	var _hoistStatics2 = __webpack_require__(1598);
	
	var _hoistStatics3 = _interopRequireDefault(_hoistStatics2);
	
	var _componentFromStream2 = __webpack_require__(641);
	
	var _componentFromStream3 = _interopRequireDefault(_componentFromStream2);
	
	var _mapPropsStream2 = __webpack_require__(1600);
	
	var _mapPropsStream3 = _interopRequireDefault(_mapPropsStream2);
	
	var _createEventHandler2 = __webpack_require__(1593);
	
	var _createEventHandler3 = _interopRequireDefault(_createEventHandler2);
	
	var _setObservableConfig2 = __webpack_require__(286);
	
	var _setObservableConfig3 = _interopRequireDefault(_setObservableConfig2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.mapProps = _mapProps3.default; // Higher-order component helpers
	
	exports.withProps = _withProps3.default;
	exports.withPropsOnChange = _withPropsOnChange3.default;
	exports.withHandlers = _withHandlers3.default;
	exports.defaultProps = _defaultProps3.default;
	exports.renameProp = _renameProp3.default;
	exports.renameProps = _renameProps3.default;
	exports.flattenProp = _flattenProp3.default;
	exports.withState = _withState3.default;
	exports.withReducer = _withReducer3.default;
	exports.branch = _branch3.default;
	exports.renderComponent = _renderComponent3.default;
	exports.renderNothing = _renderNothing3.default;
	exports.shouldUpdate = _shouldUpdate3.default;
	exports.pure = _pure3.default;
	exports.onlyUpdateForKeys = _onlyUpdateForKeys3.default;
	exports.onlyUpdateForPropTypes = _onlyUpdateForPropTypes3.default;
	exports.withContext = _withContext3.default;
	exports.getContext = _getContext3.default;
	exports.lifecycle = _lifecycle3.default;
	exports.toClass = _toClass3.default;
	
	// Static property helpers
	
	exports.setStatic = _setStatic3.default;
	exports.setPropTypes = _setPropTypes3.default;
	exports.setDisplayName = _setDisplayName3.default;
	
	// Composition function
	
	exports.compose = _compose3.default;
	
	// Other utils
	
	exports.getDisplayName = _getDisplayName3.default;
	exports.wrapDisplayName = _wrapDisplayName3.default;
	exports.shallowEqual = _shallowEqual3.default;
	exports.isClassComponent = _isClassComponent3.default;
	exports.createEagerElement = _createEagerElement3.default;
	exports.createEagerFactory = _createEagerFactory3.default;
	exports.createSink = _createSink3.default;
	exports.componentFromProp = _componentFromProp3.default;
	exports.nest = _nest3.default;
	exports.hoistStatics = _hoistStatics3.default;
	
	// Observable helpers
	
	exports.componentFromStream = _componentFromStream3.default;
	exports.mapPropsStream = _mapPropsStream3.default;
	exports.createEventHandler = _createEventHandler3.default;
	exports.setObservableConfig = _setObservableConfig3.default;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ICON_SIZES = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reselect = __webpack_require__(7);
	
	var _gridConstants = __webpack_require__(205);
	
	var _gridSizeSelector = __webpack_require__(66);
	
	var _logger = __webpack_require__(128);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _large = __webpack_require__(1784);
	
	var _large2 = _interopRequireDefault(_large);
	
	var _small = __webpack_require__(1856);
	
	var _small2 = _interopRequireDefault(_small);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ICON_SIZES = exports.ICON_SIZES = {
	    SMALL: 'SMALL',
	    LARGE: 'LARGE'
	};
	
	var iconSelector = (0, _reselect.createSelector)(_gridSizeSelector.getGridSizeName, function (state, props) {
	    return props.size;
	}, function (sizeName, overideSize) {
	    if (overideSize) return { iconSize: overideSize };
	
	    var iconSize = sizeName === _gridConstants.GRID.SMALL.name ? ICON_SIZES.SMALL : ICON_SIZES.LARGE;
	
	    return { iconSize: iconSize };
	});
	
	var Icon = function Icon(_ref) {
	    var name = _ref.name,
	        iconSize = _ref.iconSize;
	
	    var SmallIcon = _small2.default[name];
	    var LargeIcon = _large2.default[name];
	    var RenderIcon = SmallIcon && iconSize === ICON_SIZES.SMALL ? SmallIcon : LargeIcon;
	
	    if (!RenderIcon) {
	        _logger2.default.warn('Icon not found (name: ' + name + ', iconSize: ' + iconSize + ')');
	        return null;
	    }
	
	    return _react2.default.createElement(RenderIcon, null);
	};
	
	Icon.propTypes = {
	    name: _propTypes2.default.string,
	    iconSize: _propTypes2.default.string
	};
	
	exports.default = (0, _reactRedux.connect)(iconSelector)(Icon);

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var ELEMENT_MOVE = exports.ELEMENT_MOVE = 'ELEMENT_MOVE';
	var ELEMENT_CREATE = exports.ELEMENT_CREATE = 'ELEMENT_CREATE';
	var ELEMENT_DELETE = exports.ELEMENT_DELETE = 'ELEMENT_DELETE';
	var ELEMENT_UPDATE = exports.ELEMENT_UPDATE = 'ELEMENT_UPDATE';
	var ELEMENT_SET_TYPE = exports.ELEMENT_SET_TYPE = 'ELEMENT_SET_TYPE';
	var ELEMENT_SHARE = exports.ELEMENT_SHARE = 'ELEMENT_SHARE';
	var ELEMENT_UNSHARE = exports.ELEMENT_UNSHARE = 'ELEMENT_UNSHARE';
	var ELEMENT_MOVE_AND_UPDATE = exports.ELEMENT_MOVE_AND_UPDATE = 'ELEMENT_MOVE_AND_UPDATE';
	
	var ELEMENT_MOVE_MULTI = exports.ELEMENT_MOVE_MULTI = 'ELEMENT_MOVE_MULTI';
	
	// Server interactions
	var ELEMENT_FORCE_LOAD = exports.ELEMENT_FORCE_LOAD = 'ELEMENT_FORCE_LOAD';
	
	// Attachments
	var ELEMENT_ATTACHMENT_UPLOADING = exports.ELEMENT_ATTACHMENT_UPLOADING = 'ELEMENT_ATTACHMENT_UPLOADING';
	var ELEMENT_ATTACHMENT_DATA_READY = exports.ELEMENT_ATTACHMENT_DATA_READY = 'ELEMENT_ATTACHMENT_DATA_READY';
	var ELEMENT_ATTACHMENT_UPLOAD_PROGRESSED = exports.ELEMENT_ATTACHMENT_UPLOAD_PROGRESSED = 'ELEMENT_ATTACHMENT_UPLOAD_PROGRESSED';
	var ELEMENT_ATTACHMENT_UPLOAD_COMPLETED = exports.ELEMENT_ATTACHMENT_UPLOAD_COMPLETED = 'ELEMENT_ATTACHMENT_UPLOAD_COMPLETED';
	var ELEMENT_ATTACHMENT_CLEAN = exports.ELEMENT_ATTACHMENT_CLEAN = 'ELEMENT_ATTACHMENT_CLEAN';
	var ELEMENT_ATTACHMENT_UPLOAD_ERROR = exports.ELEMENT_ATTACHMENT_UPLOAD_ERROR = 'ELEMENT_ATTACHMENT_UPLOAD_ERROR';
	var ELEMENT_ATTACHMENT_CLEAR_ERROR = exports.ELEMENT_ATTACHMENT_CLEAR_ERROR = 'ELEMENT_ATTACHMENT_CLEAR_ERROR';
	
	// Icons
	var ELEMENT_ICON_FIND = exports.ELEMENT_ICON_FIND = 'ELEMENT_ICON_FIND';
	var ELEMENT_ICON_FIND_SUCCESS = exports.ELEMENT_ICON_FIND_SUCCESS = 'ELEMENT_ICON_FIND_SUCCESS';
	var ELEMENT_ICON_FIND_FAILURE = exports.ELEMENT_ICON_FIND_FAILURE = 'ELEMENT_ICON_FIND_FAILURE';
	var ELEMENT_ICON_SEARCH = exports.ELEMENT_ICON_SEARCH = 'ELEMENT_ICON_SEARCH';
	
	var ELEMENT_DND_TYPE = exports.ELEMENT_DND_TYPE = 'ELEMENT';
	
	var SKELETON_ELEMENT_TYPE = exports.SKELETON_ELEMENT_TYPE = 'SKELETON';
	
	var DROP_TARGET_BEHAVIOUR = exports.DROP_TARGET_BEHAVIOUR = {
	    SHRINK: 'shrink',
	    SHRINK_LIST: 'shrink-list',
	    NONE: null
	};
	
	var DROP_TARGET_TYPES = exports.DROP_TARGET_TYPES = {
	    BOARD: DROP_TARGET_BEHAVIOUR.SHRINK,
	    TRASH: DROP_TARGET_BEHAVIOUR.SHRINK,
	    BREADCRUMB: DROP_TARGET_BEHAVIOUR.SHRINK,
	    INBOX_CLOSED: DROP_TARGET_BEHAVIOUR.SHRINK,
	    LIST: DROP_TARGET_BEHAVIOUR.SHRINK_LIST,
	    NONE: DROP_TARGET_BEHAVIOUR.NONE
	};
	
	var ELEMENT_DEFAULT_WIDTH = exports.ELEMENT_DEFAULT_WIDTH = 34;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getSortedChildrenInSection = exports.sortByModified = exports.sortByScore = exports.getChildrenInSection = exports.getSharingContext = exports.getClosestUpBoardId = exports.getClosestUpOfType = exports.getClosestAncestorBoardId = exports.getClosestAncestorOfType = exports.getPhysicalChildIdsDeep = exports.getChildIdsDeep = exports.getChildrenDeep = exports.getParent = exports.getChildren = exports.getElement = exports.getElementId = exports.isElementRealContent = exports.isElementCreatedByUser = exports.isInList = exports.isElementLocked = exports.filterOutLinkedBoards = exports.getPhysicalId = exports.isLocationInbox = exports.isLocationCanvas = exports.isLocationTrash = exports.isLocationInSection = exports.getLocationPosition = exports.getLocationParentId = exports.getLocationSection = exports.isContent = exports.isContainer = exports.isBoardLike = exports.isImage = exports.isLine = exports.isBoard = exports.isAlias = exports.isColumn = exports.isLink = exports.isCard = exports.isSkeleton = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _immutableHelper = __webpack_require__(23);
	
	var _aliasConstants = __webpack_require__(241);
	
	var _boardConstants = __webpack_require__(17);
	
	var _columnConstants = __webpack_require__(207);
	
	var _cardConstants = __webpack_require__(111);
	
	var _linkConstants = __webpack_require__(174);
	
	var _lineConstants = __webpack_require__(57);
	
	var _elementConstants = __webpack_require__(12);
	
	var _imageConstants = __webpack_require__(87);
	
	var _userConstants = __webpack_require__(32);
	
	// Element Type functions
	
	
	// Utils
	var isType = function isType(type) {
	    return function (elementType) {
	        return (0, _lodash.isString)(elementType) ? elementType === type : (0, _immutableHelper.prop)('elementType', elementType) === type;
	    };
	};
	
	// Constants
	// Lib
	var isSkeleton = exports.isSkeleton = isType(_elementConstants.SKELETON_ELEMENT_TYPE);
	var isCard = exports.isCard = isType(_cardConstants.CARD_TYPE);
	var isLink = exports.isLink = isType(_linkConstants.LINK_TYPE);
	var isColumn = exports.isColumn = isType(_columnConstants.COLUMN_TYPE);
	var isAlias = exports.isAlias = isType(_aliasConstants.ALIAS_TYPE);
	var isBoard = exports.isBoard = isType(_boardConstants.BOARD_TYPE);
	var isLine = exports.isLine = isType(_lineConstants.LINE_TYPE);
	var isImage = exports.isImage = isType(_imageConstants.IMAGE_TYPE);
	
	var isBoardLike = exports.isBoardLike = function isBoardLike(elementType) {
	    return isBoard(elementType) || isAlias(elementType);
	};
	
	var isContainer = exports.isContainer = function isContainer(elementType) {
	    return isBoard(elementType) || isAlias(elementType) || isColumn(elementType);
	};
	
	var isContent = exports.isContent = function isContent(elementType) {
	    return !isLine(elementType) && !isContainer(elementType);
	};
	
	// Element location utils
	var getLocationSection = exports.getLocationSection = (0, _immutableHelper.propIn)(['location', 'section']);
	var getLocationParentId = exports.getLocationParentId = (0, _immutableHelper.propIn)(['location', 'parentId']);
	var getLocationPosition = exports.getLocationPosition = (0, _immutableHelper.propIn)(['location', 'position']);
	
	var isLocationInSection = exports.isLocationInSection = function isLocationInSection(section) {
	    return function (element) {
	        return getLocationSection(element) === section;
	    };
	};
	
	var isLocationTrash = exports.isLocationTrash = isLocationInSection(_boardConstants.BOARD_SECTIONS.TRASH);
	var isLocationCanvas = exports.isLocationCanvas = isLocationInSection(_boardConstants.BOARD_SECTIONS.CANVAS);
	var isLocationInbox = exports.isLocationInbox = isLocationInSection(_boardConstants.BOARD_SECTIONS.INBOX);
	
	// Element data retrieval functions
	var getPhysicalId = exports.getPhysicalId = function getPhysicalId(element) {
	    return isAlias(element) ? (0, _immutableHelper.propIn)(['content', 'linkTo'], element) : (0, _immutableHelper.prop)('id', element);
	};
	
	var filterOutLinkedBoards = exports.filterOutLinkedBoards = function filterOutLinkedBoards(elements) {
	    var linkedBoardIds = elements.filter(isAlias).map(function (alias) {
	        return alias.getIn(['content', 'linkTo']);
	    });
	    return elements.filter(function (selectedElement) {
	        return linkedBoardIds.indexOf(selectedElement.get('id')) === -1;
	    });
	};
	
	var isElementLocked = exports.isElementLocked = function isElementLocked(element) {
	    return element && element.getIn(['content', 'locked']);
	};
	
	// TODO Review - is there a better way to do this?
	var isInList = exports.isInList = function isInList(element) {
	    return (0, _immutableHelper.propIn)(['location', 'section'], element) === _boardConstants.BOARD_SECTIONS.INBOX;
	};
	
	var isElementCreatedByUser = exports.isElementCreatedByUser = function isElementCreatedByUser(userId) {
	    return function (element) {
	        return (0, _immutableHelper.propIn)(['meta', 'creator'], element) === userId;
	    };
	};
	var isElementRealContent = exports.isElementRealContent = function isElementRealContent(element) {
	    return !isElementCreatedByUser(_userConstants.STARTER_CONTENT_CREATOR_ID)(element);
	};
	
	// Element retrieval functions
	var getId = (0, _immutableHelper.prop)('id');
	var getUnderscoreId = (0, _immutableHelper.prop)('_id');
	
	var getElementId = exports.getElementId = function getElementId(element) {
	    return element && getId(element) || getUnderscoreId(element);
	};
	
	var getElement = exports.getElement = function getElement(elementList, elementId) {
	    return elementList.get(elementId);
	};
	
	var getChildren = exports.getChildren = function getChildren(elementList, parentId) {
	    return elementList.filter(function (el) {
	        return el.get('id') && el.getIn(['location', 'parentId']) === parentId;
	    });
	};
	
	var getParent = exports.getParent = function getParent(elementList, element) {
	    return elementList.get(element.getIn(['location', 'parentId']));
	};
	
	/**
	 * Gets the 'deep' children of an element, meaning that children of columns will also be retrieved.
	 * This is important because the elements displayed on the canvas will be direct children and children of columns.
	 */
	var getChildrenDeep = exports.getChildrenDeep = function getChildrenDeep(elementList, parentId) {
	    return elementList.filter(function (el) {
	        var elParentId = el.getIn(['location', 'parentId']);
	        // If the elements parent ID equals the expected parent ID this element is a child
	        if (elParentId && elParentId === parentId) return true;
	
	        // If the parent is a column and its parent ID is the expected parent ID this element is a deep child
	        return isColumn(elementList.getIn([elParentId, 'elementType'])) && elementList.getIn([elParentId, 'location', 'parentId']) === parentId;
	    });
	};
	
	var getChildIdsDeep = exports.getChildIdsDeep = (0, _lodash.flow)([getChildrenDeep, _immutableHelper.toIdArray]);
	
	/**
	 * Similar to #getChildIdsDeep however this will replace aliases with the physical boards they link to.
	 * This is used to help determine which socket channels should be connected to.
	 */
	var getPhysicalChildIdsDeep = exports.getPhysicalChildIdsDeep = function getPhysicalChildIdsDeep(elementList, parentId) {
	    return getChildrenDeep(elementList, parentId).map(getPhysicalId).toSeq().toArray();
	};
	
	/**
	 * Finds the first ancestor or itself that matches a predicateFn.
	 */
	var searchUp = function searchUp(predicateFn) {
	    return function (elements, elementId) {
	        // Iterate up the ancestor tree until we find an element which matches the predicate
	        var element = elements.get(elementId);
	        while (element && element.getIn(['location', 'parentId']) && !predicateFn(element, elements, elementId)) {
	            element = elements.get(element.getIn(['location', 'parentId']));
	        }
	        return element && element.get('id');
	    };
	};
	
	/**
	 * Finds the closest ancestor of a specific type.
	 */
	var getClosestAncestorOfType = exports.getClosestAncestorOfType = function getClosestAncestorOfType(elementType) {
	    return searchUp(function (element, elements, startingElementId) {
	        return element.get('elementType') === elementType && element.get('id') !== startingElementId;
	    });
	};
	
	/**
	 * Finds the closest ancestor that's a board.
	 */
	var getClosestAncestorBoardId = exports.getClosestAncestorBoardId = getClosestAncestorOfType(_boardConstants.BOARD_TYPE);
	
	/**
	 * Finds the closest element up of a specific type (including self).
	 */
	var getClosestUpOfType = exports.getClosestUpOfType = function getClosestUpOfType(elementType) {
	    return searchUp(function (element, elements, startingElementId) {
	        return element.get('elementType') === elementType;
	    });
	};
	
	/**
	 * Finds the closest element up (including self) that's a board.
	 */
	var getClosestUpBoardId = exports.getClosestUpBoardId = getClosestUpOfType(_boardConstants.BOARD_TYPE);
	
	/**
	 * Finds the closest ancestor element (including itself) which is 'shared' (has an acl).
	 * This will be the ID of the channel to send actions to.
	 *
	 * @return {String} The ID of the sharing context (the element ID of the closest shared ancestor).
	 */
	var getSharingContext = exports.getSharingContext = searchUp(function (element) {
	    return element.get('acl');
	});
	
	var getChildrenInSection = exports.getChildrenInSection = function getChildrenInSection(elementList, section) {
	    return elementList.filter(function (el) {
	        return el.getIn(['location', 'section']) === section;
	    });
	};
	
	var sortByScore = exports.sortByScore = function sortByScore(elementA, elementB) {
	    return elementA.getIn(['location', 'position', 'score']) - elementB.getIn(['location', 'position', 'score']);
	};
	
	var sortByModified = exports.sortByModified = function sortByModified(elementA, elementB) {
	    return (elementA.getIn(['meta', 'modifiedTime']) || 0) - (elementB.getIn(['meta', 'modifiedTime']) || 0);
	};
	
	var getSortedChildrenInSection = exports.getSortedChildrenInSection = function getSortedChildrenInSection(elementList, section, parentId, sortFn) {
	    var childElements = parentId ? getChildren(elementList, parentId) : elementList;
	    return getChildrenInSection(childElements, section).toList().sort(sortFn || sortByScore);
	};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(25);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(59);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  (function () {
	    var printWarning = function printWarning(format) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    };
	
	    warning = function warning(condition, format) {
	      if (format === undefined) {
	        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	      }
	
	      if (format.indexOf('Failed Composite propType: ') === 0) {
	        return; // Ignore CompositeComponent proptype check.
	      }
	
	      if (!condition) {
	        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	          args[_key2 - 2] = arguments[_key2];
	        }
	
	        printWarning.apply(undefined, [format].concat(args));
	      }
	    };
	  })();
	}
	
	module.exports = warning;

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var BOARD_ID_TRASH_APPEND = exports.BOARD_ID_TRASH_APPEND = '-trash';
	
	var BOARD_SECTIONS = exports.BOARD_SECTIONS = {
	    CANVAS: 'CANVAS',
	    INBOX: 'INBOX',
	    TRASH: 'TRASH'
	};
	
	var INBOX_STATE = exports.INBOX_STATE = {
	    OPEN: 'OPEN',
	    CLOSED: 'CLOSED'
	};
	
	var BOARD_TYPE = exports.BOARD_TYPE = 'BOARD';
	var BOARD_DISPLAY_NAME = exports.BOARD_DISPLAY_NAME = 'Board';
	var BOARD_DEFAULT_TITLE = exports.BOARD_DEFAULT_TITLE = 'New Board';
	
	var DEFAULT_BOARD_WIDTH = exports.DEFAULT_BOARD_WIDTH = 10;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 19 */
/***/ (function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 21 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1487);


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.toIdArray = exports.getMany = exports.propFrom = exports.propIn = exports.prop = undefined;
	
	var _fp = __webpack_require__(52);
	
	/**
	 * Retrieves a property from an object.  The object can be a POJO or an Immutable object.
	 */
	var prop = exports.prop = (0, _fp.curry)(function (propName, object) {
	    if (!object) return object;
	
	    return (0, _fp.isFunction)(object.get) ? object.get(propName) : object[propName];
	}); // Lib
	var propIn = exports.propIn = (0, _fp.curry)(function (propArray, object) {
	    if (!object) return object;
	
	    return (0, _fp.isFunction)(object.getIn) ? object.getIn(propArray) : (0, _fp.get)(propArray, object);
	});
	
	/**
	 * Same as prop but takes the arguments in the reverse order.
	 */
	var propFrom = exports.propFrom = (0, _fp.curryN)(2, (0, _fp.flip)(prop));
	
	var getMany = exports.getMany = function getMany(keys, map) {
	    return map.filter(function (object, key) {
	        return (0, _fp.includes)(key, keys);
	    });
	};
	
	var toIdArray = exports.toIdArray = function toIdArray(immutableMap) {
	    return immutableMap.keySeq().toArray();
	};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EditorState
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(20);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BlockTree = __webpack_require__(532);
	var ContentState = __webpack_require__(356);
	var EditorBidiService = __webpack_require__(1064);
	var Immutable = __webpack_require__(28);
	var SelectionState = __webpack_require__(182);
	
	var OrderedSet = Immutable.OrderedSet;
	var Record = Immutable.Record;
	var Stack = Immutable.Stack;
	
	
	var defaultRecord = {
	  allowUndo: true,
	  currentContent: null,
	  decorator: null,
	  directionMap: null,
	  forceSelection: false,
	  inCompositionMode: false,
	  inlineStyleOverride: null,
	  lastChangeType: null,
	  nativelyRenderedContent: null,
	  redoStack: Stack(),
	  selection: null,
	  treeMap: null,
	  undoStack: Stack()
	};
	
	var EditorStateRecord = Record(defaultRecord);
	
	var EditorState = function () {
	  EditorState.createEmpty = function createEmpty(decorator) {
	    return EditorState.createWithContent(ContentState.createFromText(''), decorator);
	  };
	
	  EditorState.createWithContent = function createWithContent(contentState, decorator) {
	    var firstKey = contentState.getBlockMap().first().getKey();
	    return EditorState.create({
	      currentContent: contentState,
	      undoStack: Stack(),
	      redoStack: Stack(),
	      decorator: decorator || null,
	      selection: SelectionState.createEmpty(firstKey)
	    });
	  };
	
	  EditorState.create = function create(config) {
	    var currentContent = config.currentContent;
	    var decorator = config.decorator;
	
	    var recordConfig = _extends({}, config, {
	      treeMap: generateNewTreeMap(currentContent, decorator),
	      directionMap: EditorBidiService.getDirectionMap(currentContent)
	    });
	    return new EditorState(new EditorStateRecord(recordConfig));
	  };
	
	  EditorState.set = function set(editorState, put) {
	    var map = editorState.getImmutable().withMutations(function (state) {
	      var existingDecorator = state.get('decorator');
	      var decorator = existingDecorator;
	      if (put.decorator === null) {
	        decorator = null;
	      } else if (put.decorator) {
	        decorator = put.decorator;
	      }
	
	      var newContent = put.currentContent || editorState.getCurrentContent();
	
	      if (decorator !== existingDecorator) {
	        var treeMap = state.get('treeMap');
	        var newTreeMap;
	        if (decorator && existingDecorator) {
	          newTreeMap = regenerateTreeForNewDecorator(newContent.getBlockMap(), treeMap, decorator, existingDecorator);
	        } else {
	          newTreeMap = generateNewTreeMap(newContent, decorator);
	        }
	
	        state.merge({
	          decorator: decorator,
	          treeMap: newTreeMap,
	          nativelyRenderedContent: null
	        });
	        return;
	      }
	
	      var existingContent = editorState.getCurrentContent();
	      if (newContent !== existingContent) {
	        state.set('treeMap', regenerateTreeForNewBlocks(editorState, newContent.getBlockMap(), decorator));
	      }
	
	      state.merge(put);
	    });
	
	    return new EditorState(map);
	  };
	
	  EditorState.prototype.toJS = function toJS() {
	    return this.getImmutable().toJS();
	  };
	
	  EditorState.prototype.getAllowUndo = function getAllowUndo() {
	    return this.getImmutable().get('allowUndo');
	  };
	
	  EditorState.prototype.getCurrentContent = function getCurrentContent() {
	    return this.getImmutable().get('currentContent');
	  };
	
	  EditorState.prototype.getUndoStack = function getUndoStack() {
	    return this.getImmutable().get('undoStack');
	  };
	
	  EditorState.prototype.getRedoStack = function getRedoStack() {
	    return this.getImmutable().get('redoStack');
	  };
	
	  EditorState.prototype.getSelection = function getSelection() {
	    return this.getImmutable().get('selection');
	  };
	
	  EditorState.prototype.getDecorator = function getDecorator() {
	    return this.getImmutable().get('decorator');
	  };
	
	  EditorState.prototype.isInCompositionMode = function isInCompositionMode() {
	    return this.getImmutable().get('inCompositionMode');
	  };
	
	  EditorState.prototype.mustForceSelection = function mustForceSelection() {
	    return this.getImmutable().get('forceSelection');
	  };
	
	  EditorState.prototype.getNativelyRenderedContent = function getNativelyRenderedContent() {
	    return this.getImmutable().get('nativelyRenderedContent');
	  };
	
	  EditorState.prototype.getLastChangeType = function getLastChangeType() {
	    return this.getImmutable().get('lastChangeType');
	  };
	
	  /**
	   * While editing, the user may apply inline style commands with a collapsed
	   * cursor, intending to type text that adopts the specified style. In this
	   * case, we track the specified style as an "override" that takes precedence
	   * over the inline style of the text adjacent to the cursor.
	   *
	   * If null, there is no override in place.
	   */
	
	
	  EditorState.prototype.getInlineStyleOverride = function getInlineStyleOverride() {
	    return this.getImmutable().get('inlineStyleOverride');
	  };
	
	  EditorState.setInlineStyleOverride = function setInlineStyleOverride(editorState, inlineStyleOverride) {
	    return EditorState.set(editorState, { inlineStyleOverride: inlineStyleOverride });
	  };
	
	  /**
	   * Get the appropriate inline style for the editor state. If an
	   * override is in place, use it. Otherwise, the current style is
	   * based on the location of the selection state.
	   */
	
	
	  EditorState.prototype.getCurrentInlineStyle = function getCurrentInlineStyle() {
	    var override = this.getInlineStyleOverride();
	    if (override != null) {
	      return override;
	    }
	
	    var content = this.getCurrentContent();
	    var selection = this.getSelection();
	
	    if (selection.isCollapsed()) {
	      return getInlineStyleForCollapsedSelection(content, selection);
	    }
	
	    return getInlineStyleForNonCollapsedSelection(content, selection);
	  };
	
	  EditorState.prototype.getBlockTree = function getBlockTree(blockKey) {
	    return this.getImmutable().getIn(['treeMap', blockKey]);
	  };
	
	  EditorState.prototype.isSelectionAtStartOfContent = function isSelectionAtStartOfContent() {
	    var firstKey = this.getCurrentContent().getBlockMap().first().getKey();
	    return this.getSelection().hasEdgeWithin(firstKey, 0, 0);
	  };
	
	  EditorState.prototype.isSelectionAtEndOfContent = function isSelectionAtEndOfContent() {
	    var content = this.getCurrentContent();
	    var blockMap = content.getBlockMap();
	    var last = blockMap.last();
	    var end = last.getLength();
	    return this.getSelection().hasEdgeWithin(last.getKey(), end, end);
	  };
	
	  EditorState.prototype.getDirectionMap = function getDirectionMap() {
	    return this.getImmutable().get('directionMap');
	  };
	
	  /**
	   * Incorporate native DOM selection changes into the EditorState. This
	   * method can be used when we simply want to accept whatever the DOM
	   * has given us to represent selection, and we do not need to re-render
	   * the editor.
	   *
	   * To forcibly move the DOM selection, see `EditorState.forceSelection`.
	   */
	
	
	  EditorState.acceptSelection = function acceptSelection(editorState, selection) {
	    return updateSelection(editorState, selection, false);
	  };
	
	  /**
	   * At times, we need to force the DOM selection to be where we
	   * need it to be. This can occur when the anchor or focus nodes
	   * are non-text nodes, for instance. In this case, we want to trigger
	   * a re-render of the editor, which in turn forces selection into
	   * the correct place in the DOM. The `forceSelection` method
	   * accomplishes this.
	   *
	   * This method should be used in cases where you need to explicitly
	   * move the DOM selection from one place to another without a change
	   * in ContentState.
	   */
	
	
	  EditorState.forceSelection = function forceSelection(editorState, selection) {
	    if (!selection.getHasFocus()) {
	      selection = selection.set('hasFocus', true);
	    }
	    return updateSelection(editorState, selection, true);
	  };
	
	  /**
	   * Move selection to the end of the editor without forcing focus.
	   */
	
	
	  EditorState.moveSelectionToEnd = function moveSelectionToEnd(editorState) {
	    var content = editorState.getCurrentContent();
	    var lastBlock = content.getLastBlock();
	    var lastKey = lastBlock.getKey();
	    var length = lastBlock.getLength();
	
	    return EditorState.acceptSelection(editorState, new SelectionState({
	      anchorKey: lastKey,
	      anchorOffset: length,
	      focusKey: lastKey,
	      focusOffset: length,
	      isBackward: false
	    }));
	  };
	
	  /**
	   * Force focus to the end of the editor. This is useful in scenarios
	   * where we want to programmatically focus the input and it makes sense
	   * to allow the user to continue working seamlessly.
	   */
	
	
	  EditorState.moveFocusToEnd = function moveFocusToEnd(editorState) {
	    var afterSelectionMove = EditorState.moveSelectionToEnd(editorState);
	    return EditorState.forceSelection(afterSelectionMove, afterSelectionMove.getSelection());
	  };
	
	  /**
	   * Push the current ContentState onto the undo stack if it should be
	   * considered a boundary state, and set the provided ContentState as the
	   * new current content.
	   */
	
	
	  EditorState.push = function push(editorState, contentState, changeType) {
	    if (editorState.getCurrentContent() === contentState) {
	      return editorState;
	    }
	
	    var forceSelection = changeType !== 'insert-characters';
	    var directionMap = EditorBidiService.getDirectionMap(contentState, editorState.getDirectionMap());
	
	    if (!editorState.getAllowUndo()) {
	      return EditorState.set(editorState, {
	        currentContent: contentState,
	        directionMap: directionMap,
	        lastChangeType: changeType,
	        selection: contentState.getSelectionAfter(),
	        forceSelection: forceSelection,
	        inlineStyleOverride: null
	      });
	    }
	
	    var selection = editorState.getSelection();
	    var currentContent = editorState.getCurrentContent();
	    var undoStack = editorState.getUndoStack();
	    var newContent = contentState;
	
	    if (selection !== currentContent.getSelectionAfter() || mustBecomeBoundary(editorState, changeType)) {
	      undoStack = undoStack.push(currentContent);
	      newContent = newContent.set('selectionBefore', selection);
	    } else if (changeType === 'insert-characters' || changeType === 'backspace-character' || changeType === 'delete-character') {
	      // Preserve the previous selection.
	      newContent = newContent.set('selectionBefore', currentContent.getSelectionBefore());
	    }
	
	    var inlineStyleOverride = editorState.getInlineStyleOverride();
	
	    // Don't discard inline style overrides on block type or depth changes.
	    if (changeType !== 'adjust-depth' && changeType !== 'change-block-type') {
	      inlineStyleOverride = null;
	    }
	
	    var editorStateChanges = {
	      currentContent: newContent,
	      directionMap: directionMap,
	      undoStack: undoStack,
	      redoStack: Stack(),
	      lastChangeType: changeType,
	      selection: contentState.getSelectionAfter(),
	      forceSelection: forceSelection,
	      inlineStyleOverride: inlineStyleOverride
	    };
	
	    return EditorState.set(editorState, editorStateChanges);
	  };
	
	  /**
	   * Make the top ContentState in the undo stack the new current content and
	   * push the current content onto the redo stack.
	   */
	
	
	  EditorState.undo = function undo(editorState) {
	    if (!editorState.getAllowUndo()) {
	      return editorState;
	    }
	
	    var undoStack = editorState.getUndoStack();
	    var newCurrentContent = undoStack.peek();
	    if (!newCurrentContent) {
	      return editorState;
	    }
	
	    var currentContent = editorState.getCurrentContent();
	    var directionMap = EditorBidiService.getDirectionMap(newCurrentContent, editorState.getDirectionMap());
	
	    return EditorState.set(editorState, {
	      currentContent: newCurrentContent,
	      directionMap: directionMap,
	      undoStack: undoStack.shift(),
	      redoStack: editorState.getRedoStack().push(currentContent),
	      forceSelection: true,
	      inlineStyleOverride: null,
	      lastChangeType: 'undo',
	      nativelyRenderedContent: null,
	      selection: currentContent.getSelectionBefore()
	    });
	  };
	
	  /**
	   * Make the top ContentState in the redo stack the new current content and
	   * push the current content onto the undo stack.
	   */
	
	
	  EditorState.redo = function redo(editorState) {
	    if (!editorState.getAllowUndo()) {
	      return editorState;
	    }
	
	    var redoStack = editorState.getRedoStack();
	    var newCurrentContent = redoStack.peek();
	    if (!newCurrentContent) {
	      return editorState;
	    }
	
	    var currentContent = editorState.getCurrentContent();
	    var directionMap = EditorBidiService.getDirectionMap(newCurrentContent, editorState.getDirectionMap());
	
	    return EditorState.set(editorState, {
	      currentContent: newCurrentContent,
	      directionMap: directionMap,
	      undoStack: editorState.getUndoStack().push(currentContent),
	      redoStack: redoStack.shift(),
	      forceSelection: true,
	      inlineStyleOverride: null,
	      lastChangeType: 'redo',
	      nativelyRenderedContent: null,
	      selection: newCurrentContent.getSelectionAfter()
	    });
	  };
	
	  /**
	   * Not for public consumption.
	   */
	
	
	  function EditorState(immutable) {
	    _classCallCheck(this, EditorState);
	
	    this._immutable = immutable;
	  }
	
	  /**
	   * Not for public consumption.
	   */
	
	
	  EditorState.prototype.getImmutable = function getImmutable() {
	    return this._immutable;
	  };
	
	  return EditorState;
	}();
	
	/**
	 * Set the supplied SelectionState as the new current selection, and set
	 * the `force` flag to trigger manual selection placement by the view.
	 */
	
	
	function updateSelection(editorState, selection, forceSelection) {
	  return EditorState.set(editorState, {
	    selection: selection,
	    forceSelection: forceSelection,
	    nativelyRenderedContent: null,
	    inlineStyleOverride: null
	  });
	}
	
	/**
	 * Regenerate the entire tree map for a given ContentState and decorator.
	 * Returns an OrderedMap that maps all available ContentBlock objects.
	 */
	function generateNewTreeMap(contentState, decorator) {
	  return contentState.getBlockMap().map(function (block) {
	    return BlockTree.generate(block, decorator);
	  }).toOrderedMap();
	}
	
	/**
	 * Regenerate tree map objects for all ContentBlocks that have changed
	 * between the current editorState and newContent. Returns an OrderedMap
	 * with only changed regenerated tree map objects.
	 */
	function regenerateTreeForNewBlocks(editorState, newBlockMap, decorator) {
	  var prevBlockMap = editorState.getCurrentContent().getBlockMap();
	  var prevTreeMap = editorState.getImmutable().get('treeMap');
	  return prevTreeMap.merge(newBlockMap.toSeq().filter(function (block, key) {
	    return block !== prevBlockMap.get(key);
	  }).map(function (block) {
	    return BlockTree.generate(block, decorator);
	  }));
	}
	
	/**
	 * Generate tree map objects for a new decorator object, preserving any
	 * decorations that are unchanged from the previous decorator.
	 *
	 * Note that in order for this to perform optimally, decoration Lists for
	 * decorators should be preserved when possible to allow for direct immutable
	 * List comparison.
	 */
	function regenerateTreeForNewDecorator(blockMap, previousTreeMap, decorator, existingDecorator) {
	  return previousTreeMap.merge(blockMap.toSeq().filter(function (block) {
	    return decorator.getDecorations(block) !== existingDecorator.getDecorations(block);
	  }).map(function (block) {
	    return BlockTree.generate(block, decorator);
	  }));
	}
	
	/**
	 * Return whether a change should be considered a boundary state, given
	 * the previous change type. Allows us to discard potential boundary states
	 * during standard typing or deletion behavior.
	 */
	function mustBecomeBoundary(editorState, changeType) {
	  var lastChangeType = editorState.getLastChangeType();
	  return changeType !== lastChangeType || changeType !== 'insert-characters' && changeType !== 'backspace-character' && changeType !== 'delete-character';
	}
	
	function getInlineStyleForCollapsedSelection(content, selection) {
	  var startKey = selection.getStartKey();
	  var startOffset = selection.getStartOffset();
	  var startBlock = content.getBlockForKey(startKey);
	
	  // If the cursor is not at the start of the block, look backward to
	  // preserve the style of the preceding character.
	  if (startOffset > 0) {
	    return startBlock.getInlineStyleAt(startOffset - 1);
	  }
	
	  // The caret is at position zero in this block. If the block has any
	  // text at all, use the style of the first character.
	  if (startBlock.getLength()) {
	    return startBlock.getInlineStyleAt(0);
	  }
	
	  // Otherwise, look upward in the document to find the closest character.
	  return lookUpwardForInlineStyle(content, startKey);
	}
	
	function getInlineStyleForNonCollapsedSelection(content, selection) {
	  var startKey = selection.getStartKey();
	  var startOffset = selection.getStartOffset();
	  var startBlock = content.getBlockForKey(startKey);
	
	  // If there is a character just inside the selection, use its style.
	  if (startOffset < startBlock.getLength()) {
	    return startBlock.getInlineStyleAt(startOffset);
	  }
	
	  // Check if the selection at the end of a non-empty block. Use the last
	  // style in the block.
	  if (startOffset > 0) {
	    return startBlock.getInlineStyleAt(startOffset - 1);
	  }
	
	  // Otherwise, look upward in the document to find the closest character.
	  return lookUpwardForInlineStyle(content, startKey);
	}
	
	function lookUpwardForInlineStyle(content, fromKey) {
	  var previousBlock = content.getBlockBefore(fromKey);
	  var previousLength;
	
	  while (previousBlock) {
	    previousLength = previousBlock.getLength();
	    if (previousLength) {
	      return previousBlock.getInlineStyleAt(previousLength - 1);
	    }
	    previousBlock = content.getBlockBefore(previousBlock.getKey());
	  }
	
	  return OrderedSet();
	}
	
	module.exports = EditorState;

/***/ }),
/* 25 */
/***/ (function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.atomicMoveAndUpdate = exports.updateSelectedElements = exports.updateMultipleElements = exports.updateElement = exports.unshareElement = exports.shareElement = exports.createAndSelectElement = exports.loadElements = exports.createElement = exports.setElementType = exports.createElementWithId = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _elementActions = __webpack_require__(793);
	
	Object.defineProperty(exports, 'createElementWithId', {
	    enumerable: true,
	    get: function get() {
	        return _elementActions.createElementWithId;
	    }
	});
	Object.defineProperty(exports, 'setElementType', {
	    enumerable: true,
	    get: function get() {
	        return _elementActions.setElementType;
	    }
	});
	
	var _lodash = __webpack_require__(4);
	
	var _createElementId = __webpack_require__(2287);
	
	var _createElementId2 = _interopRequireDefault(_createElementId);
	
	var _inboxActions = __webpack_require__(305);
	
	var _elementAttachmentActions = __webpack_require__(142);
	
	var _selectionActions = __webpack_require__(55);
	
	var _elementHelper = __webpack_require__(13);
	
	var _timeUtil = __webpack_require__(43);
	
	var _undoRedoTransactionManager = __webpack_require__(86);
	
	var _selectedElementsSelector = __webpack_require__(127);
	
	var _elementMoveActions = __webpack_require__(302);
	
	var _elementConstants = __webpack_require__(12);
	
	var TYPES = _interopRequireWildcard(_elementConstants);
	
	var _elementsConstants = __webpack_require__(322);
	
	var ELEMENTS_ACTION_TYPE = _interopRequireWildcard(_elementsConstants);
	
	var _imageConstants = __webpack_require__(87);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// Util
	
	
	/**
	 * Creates an element in the given location with the provided content.
	 * If the location is a list but it doesn't have a score associated to it, the score will be calculated and the item
	 * will be inserted at that location.
	 *
	 * @param elementType {String} The type of the element to create (BOARD | CARD, etc).
	 * @param location {Object} An object containing the parentId, section and position.
	 * @param content {Object} An object representing the content of the element.
	 * @param sync {boolean} [true] Whether to sync this action with the server or not.
	 */
	var createElement = exports.createElement = function createElement(action) {
	    return function (dispatch, getState) {
	        var elementType = action.elementType,
	            location = action.location,
	            content = action.content,
	            attachment = action.attachment,
	            _action$sync = action.sync,
	            sync = _action$sync === undefined ? true : _action$sync,
	            duplicate = action.duplicate;
	
	
	        var state = getState();
	        var currentUser = state.getIn(['app', 'currentUser']);
	        var userId = currentUser.get('_id');
	        var clientId = currentUser.get('clientId');
	        var clientTick = currentUser.get('clientTick');
	        var elementId = (0, _createElementId2.default)(clientId, clientTick);
	        var now = (0, _timeUtil.getTimestamp)();
	        var transactionId = action.transactionId || (0, _undoRedoTransactionManager.getNewTransactionId)();
	
	        // Use the element move utility function to calculate the score
	        var creates = [{ id: elementId, location: location }];
	        creates.map((0, _elementMoveActions.updateLocation)(dispatch, getState)(creates));
	        var updatedLocation = creates[0] && creates[0].location || location;
	
	        dispatch((0, _elementActions.createElementWithId)({
	            id: elementId,
	            elementType: elementType,
	            location: updatedLocation,
	            content: content,
	            sync: sync,
	            modified: now,
	            meta: {
	                creator: userId
	            },
	            transactionId: transactionId,
	            duplicate: duplicate
	        }));
	
	        dispatch((0, _inboxActions.setInboxFromElementCreate)({ location: location, transactionId: transactionId }));
	
	        if (attachment) {
	            dispatch((0, _elementAttachmentActions.uploadAttachment)({ id: elementId, file: attachment, transactionId: transactionId }));
	        }
	
	        return elementId;
	    };
	};
	
	var loadElements = exports.loadElements = function loadElements(elements, deletedElementIds) {
	    return {
	        type: ELEMENTS_ACTION_TYPE.ELEMENTS_LOAD,
	        elements: elements,
	        deletedElementIds: deletedElementIds
	    };
	};
	
	var createAndSelectElement = exports.createAndSelectElement = function createAndSelectElement(action) {
	    return function (dispatch, getState) {
	        action.transactionId = action.transactionId || (0, _undoRedoTransactionManager.getNewTransactionId)();
	        var transactionId = action.transactionId;
	
	        var elementId = dispatch(createElement(action));
	
	        // can't select an element that doesn't exist
	        var elements = getState().get('elements');
	        var createdElement = elements.get(elementId);
	        if (!createdElement) return elementId;
	
	        if (action.currentBoardId && action.location.parentId !== action.currentBoardId) {
	            var targetElementType = elements.getIn([action.location.parentId, 'elementType']);
	
	            // Don't select or start editing the element if it's dropped into a board
	            if ((0, _elementHelper.isBoardLike)(targetElementType)) return elementId;
	        }
	
	        dispatch((0, _selectionActions.setSelectedElements)({ ids: [elementId], transactionId: transactionId }));
	
	        // Don't start editing images otherwise captions cannot be written straight away
	        if (action.elementType === _imageConstants.IMAGE_TYPE) return elementId;
	
	        (0, _lodash.defer)(function () {
	            return dispatch((0, _selectionActions.startEditingElement)({ id: elementId, editorKey: action.elementType, transactionId: transactionId }));
	        });
	
	        return elementId;
	    };
	};
	
	var shareElement = exports.shareElement = function shareElement(_ref) {
	    var id = _ref.id,
	        userId = _ref.userId,
	        permissions = _ref.permissions,
	        _ref$sync = _ref.sync,
	        sync = _ref$sync === undefined ? true : _ref$sync;
	    return {
	        type: TYPES.ELEMENT_SHARE,
	        id: id,
	        userId: userId,
	        permissions: permissions,
	        modified: (0, _timeUtil.getTimestamp)(),
	        sync: sync
	    };
	};
	
	var unshareElement = exports.unshareElement = function unshareElement(_ref2) {
	    var id = _ref2.id,
	        userId = _ref2.userId,
	        _ref2$sync = _ref2.sync,
	        sync = _ref2$sync === undefined ? true : _ref2$sync;
	    return {
	        type: TYPES.ELEMENT_UNSHARE,
	        id: id,
	        userId: userId,
	        modified: (0, _timeUtil.getTimestamp)(),
	        sync: sync
	    };
	};
	
	var updateElement = function updateElement(_ref3) {
	    var _ref3$transactionId = _ref3.transactionId,
	        transactionId = _ref3$transactionId === undefined ? (0, _undoRedoTransactionManager.getNewTransactionId)() : _ref3$transactionId,
	        rest = _objectWithoutProperties(_ref3, ['transactionId']);
	
	    return (0, _elementActions.updateElement)(_extends({}, rest, {
	        transactionId: transactionId
	    }));
	};
	
	exports.updateElement = updateElement;
	var updateMultipleElements = function updateMultipleElements(_ref4) {
	    var _ref4$transactionId = _ref4.transactionId,
	        transactionId = _ref4$transactionId === undefined ? (0, _undoRedoTransactionManager.getNewTransactionId)() : _ref4$transactionId,
	        rest = _objectWithoutProperties(_ref4, ['transactionId']);
	
	    return (0, _elementActions.updateMultipleElements)(_extends({}, rest, {
	        transactionId: transactionId
	    }));
	};
	
	exports.updateMultipleElements = updateMultipleElements;
	var defaultPredicate = function defaultPredicate() {
	    return true;
	};
	
	var updateSelectedElements = function updateSelectedElements(_ref5) {
	    var changes = _ref5.changes,
	        _ref5$predicate = _ref5.predicate,
	        predicate = _ref5$predicate === undefined ? defaultPredicate : _ref5$predicate,
	        rest = _objectWithoutProperties(_ref5, ['changes', 'predicate']);
	
	    return function (dispatch, getState) {
	        var state = getState();
	        var elementsToUpdate = (0, _selectedElementsSelector.getSelectedElements)(state).filter(predicate);
	        var updates = elementsToUpdate.map(function (element) {
	            return { id: element.get('id'), changes: changes };
	        }).toJS();
	        return dispatch(updateMultipleElements(_extends({ updates: updates }, rest)));
	    };
	};
	
	exports.updateSelectedElements = updateSelectedElements;
	var getSimpleMoveData = function getSimpleMoveData(_ref6) {
	    var id = _ref6.id,
	        location = _ref6.location,
	        getState = _ref6.getState;
	
	    // Get the element's current location, this will be the 'from' location in the action
	    var state = getState();
	    var element = state.getIn(['elements', id]);
	    var from = element.get('location').toJS();
	
	    return {
	        id: id,
	        location: location,
	        from: from
	    };
	};
	
	var atomicMoveAndUpdate = exports.atomicMoveAndUpdate = function atomicMoveAndUpdate(_ref7) {
	    var id = _ref7.id,
	        location = _ref7.location,
	        changes = _ref7.changes,
	        _ref7$sync = _ref7.sync,
	        sync = _ref7$sync === undefined ? true : _ref7$sync,
	        _ref7$transactionId = _ref7.transactionId,
	        transactionId = _ref7$transactionId === undefined ? (0, _undoRedoTransactionManager.getNewTransactionId)() : _ref7$transactionId;
	    return function (dispatch, getState) {
	        return dispatch(_extends({
	            type: TYPES.ELEMENT_MOVE_AND_UPDATE
	        }, getSimpleMoveData({ id: id, location: location, getState: getState }), {
	            changes: changes,
	            sync: sync,
	            modified: (0, _timeUtil.getTimestamp)(),
	            transactionId: transactionId
	        }));
	    };
	};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.redirectLoggedInUserToWorkspace = exports.updateBoardSlug = exports.navigateToRootWorkspace = exports.clearFilter = exports.navigateToBoard = exports.navigateToStaticPage = exports.navigateToForgotPassword = exports.navigateToRegister = exports.navigateToLogin = exports.refreshPage = undefined;
	
	var _reactRouterRedux = __webpack_require__(82);
	
	var _lodash = __webpack_require__(4);
	
	var _stringUtil = __webpack_require__(58);
	
	var _selectionActions = __webpack_require__(55);
	
	var _currentUserActions = __webpack_require__(84);
	
	var _currentUserSelector = __webpack_require__(33);
	
	var getLocation = function getLocation(state) {
	    return (0, _lodash.get)(state.get('routing'), 'locationBeforeTransitions', {});
	};
	var getLocationSearch = function getLocationSearch(state) {
	    return getLocation(state).search || '';
	};
	var getLocationPathname = function getLocationPathname(state) {
	    return getLocation(state).pathname || '';
	};
	var getLocationQuery = function getLocationQuery(state) {
	    return getLocation(state).query || {};
	};
	
	var refreshPage = exports.refreshPage = function refreshPage() {
	    return window.location.reload(false);
	};
	
	var navigateToLogin = exports.navigateToLogin = function navigateToLogin() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        from = _ref.from;
	
	    var loginPath = from ? '/login?from=' + from : '/login';
	
	    return (0, _reactRouterRedux.push)(loginPath);
	};
	
	var navigateToRegister = exports.navigateToRegister = function navigateToRegister() {
	    return (0, _reactRouterRedux.push)('/register');
	};
	var navigateToForgotPassword = exports.navigateToForgotPassword = function navigateToForgotPassword() {
	    return (0, _reactRouterRedux.push)('/forgotten-password');
	};
	var navigateToStaticPage = exports.navigateToStaticPage = function navigateToStaticPage(pageName) {
	    return (0, _reactRouterRedux.push)('/static/' + pageName);
	};
	
	/**
	 * Updates the route to the new board's location.
	 */
	var navigateToBoard = exports.navigateToBoard = function navigateToBoard(_ref2) {
	    var boardId = _ref2.boardId,
	        filter = _ref2.filter,
	        _ref2$keepSelection = _ref2.keepSelection,
	        keepSelection = _ref2$keepSelection === undefined ? false : _ref2$keepSelection;
	    return function (dispatch, getState) {
	        if (!boardId) return dispatch((0, _reactRouterRedux.push)('/'));
	
	        var state = getState();
	        var board = state.getIn(['elements', boardId]);
	
	        var title = board && board.getIn(['content', 'title']);
	
	        var slug = title ? '/' + (0, _stringUtil.slugify)(title) : '';
	        var filters = filter ? '?' + (0, _stringUtil.createQueryString)(filter) : '';
	        var path = '/' + boardId + slug + filters;
	
	        if (!keepSelection) dispatch((0, _selectionActions.deselectAllElements)());
	
	        return dispatch((0, _reactRouterRedux.push)(path));
	    };
	};
	
	var clearFilter = exports.clearFilter = function clearFilter() {
	    return function (dispatch, getState) {
	        var state = getState();
	        var filterState = getLocationSearch(state);
	        if (!filterState) return;
	
	        var pathname = getLocationPathname(state);
	        return dispatch((0, _reactRouterRedux.push)(pathname));
	    };
	};
	
	var navigateToRootWorkspace = exports.navigateToRootWorkspace = function navigateToRootWorkspace() {
	    return function (dispatch, getState) {
	        var state = getState();
	
	        var redirectFrom = getLocationQuery(state).from;
	        if (redirectFrom) return dispatch((0, _reactRouterRedux.push)(redirectFrom));
	
	        var rootBoardId = (0, _currentUserSelector.getCurrentUserRootBoardId)(state);
	        if (rootBoardId) return dispatch(navigateToBoard({ boardId: rootBoardId }));
	
	        dispatch((0, _reactRouterRedux.push)('/'));
	    };
	};
	
	var updateBoardSlug = exports.updateBoardSlug = function updateBoardSlug(_ref3) {
	    var boardId = _ref3.boardId,
	        routeParams = _ref3.routeParams;
	    return function (dispatch, getState) {
	        var state = getState();
	        var board = state.get('elements').get(boardId);
	
	        var title = board && board.get('content') && board.get('content').get('title');
	        var slug = title ? (0, _stringUtil.slugify)(title) : null;
	        var urlQuery = getLocationSearch(state);
	
	        if (!slug || routeParams.slug === slug) return;
	
	        var path = '/' + boardId;
	        path = slug ? path + '/' + slug + urlQuery : path;
	
	        return dispatch((0, _reactRouterRedux.replace)(path));
	    };
	};
	
	// redirects to root workspace, but keeps a flag if the user has been redirected
	// from login to avoid redirect loops with mangled auth tokens
	var redirectLoggedInUserToWorkspace = exports.redirectLoggedInUserToWorkspace = function redirectLoggedInUserToWorkspace() {
	    return function (dispatch, getState) {
	        var state = getState();
	        if (state.getIn(['app', 'currentUser', 'didRedirect'])) return;
	
	        dispatch((0, _currentUserActions.updateCurrentUser)({
	            changes: { didRedirect: true },
	            sync: false
	        }));
	
	        dispatch(navigateToRootWorkspace());
	    };
	};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 *  Copyright (c) 2014-2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  global.Immutable = factory();
	}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
	  function createClass(ctor, superClass) {
	    if (superClass) {
	      ctor.prototype = Object.create(superClass.prototype);
	    }
	    ctor.prototype.constructor = ctor;
	  }
	
	  function Iterable(value) {
	      return isIterable(value) ? value : Seq(value);
	    }
	
	
	  createClass(KeyedIterable, Iterable);
	    function KeyedIterable(value) {
	      return isKeyed(value) ? value : KeyedSeq(value);
	    }
	
	
	  createClass(IndexedIterable, Iterable);
	    function IndexedIterable(value) {
	      return isIndexed(value) ? value : IndexedSeq(value);
	    }
	
	
	  createClass(SetIterable, Iterable);
	    function SetIterable(value) {
	      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
	    }
	
	
	
	  function isIterable(maybeIterable) {
	    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
	  }
	
	  function isKeyed(maybeKeyed) {
	    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
	  }
	
	  function isIndexed(maybeIndexed) {
	    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
	  }
	
	  function isAssociative(maybeAssociative) {
	    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
	  }
	
	  function isOrdered(maybeOrdered) {
	    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
	  }
	
	  Iterable.isIterable = isIterable;
	  Iterable.isKeyed = isKeyed;
	  Iterable.isIndexed = isIndexed;
	  Iterable.isAssociative = isAssociative;
	  Iterable.isOrdered = isOrdered;
	
	  Iterable.Keyed = KeyedIterable;
	  Iterable.Indexed = IndexedIterable;
	  Iterable.Set = SetIterable;
	
	
	  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  // Used for setting prototype methods that IE8 chokes on.
	  var DELETE = 'delete';
	
	  // Constants describing the size of trie nodes.
	  var SHIFT = 5; // Resulted in best performance after ______?
	  var SIZE = 1 << SHIFT;
	  var MASK = SIZE - 1;
	
	  // A consistent shared value representing "not set" which equals nothing other
	  // than itself, and nothing that could be provided externally.
	  var NOT_SET = {};
	
	  // Boolean references, Rough equivalent of `bool &`.
	  var CHANGE_LENGTH = { value: false };
	  var DID_ALTER = { value: false };
	
	  function MakeRef(ref) {
	    ref.value = false;
	    return ref;
	  }
	
	  function SetRef(ref) {
	    ref && (ref.value = true);
	  }
	
	  // A function which returns a value representing an "owner" for transient writes
	  // to tries. The return value will only ever equal itself, and will not equal
	  // the return of any subsequent call of this function.
	  function OwnerID() {}
	
	  // http://jsperf.com/copy-array-inline
	  function arrCopy(arr, offset) {
	    offset = offset || 0;
	    var len = Math.max(0, arr.length - offset);
	    var newArr = new Array(len);
	    for (var ii = 0; ii < len; ii++) {
	      newArr[ii] = arr[ii + offset];
	    }
	    return newArr;
	  }
	
	  function ensureSize(iter) {
	    if (iter.size === undefined) {
	      iter.size = iter.__iterate(returnTrue);
	    }
	    return iter.size;
	  }
	
	  function wrapIndex(iter, index) {
	    // This implements "is array index" which the ECMAString spec defines as:
	    //
	    //     A String property name P is an array index if and only if
	    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
	    //     to 2^32−1.
	    //
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
	    if (typeof index !== 'number') {
	      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
	      if ('' + uint32Index !== index || uint32Index === 4294967295) {
	        return NaN;
	      }
	      index = uint32Index;
	    }
	    return index < 0 ? ensureSize(iter) + index : index;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function wholeSlice(begin, end, size) {
	    return (begin === 0 || (size !== undefined && begin <= -size)) &&
	      (end === undefined || (size !== undefined && end >= size));
	  }
	
	  function resolveBegin(begin, size) {
	    return resolveIndex(begin, size, 0);
	  }
	
	  function resolveEnd(end, size) {
	    return resolveIndex(end, size, size);
	  }
	
	  function resolveIndex(index, size, defaultIndex) {
	    return index === undefined ?
	      defaultIndex :
	      index < 0 ?
	        Math.max(0, size + index) :
	        size === undefined ?
	          index :
	          Math.min(size, index);
	  }
	
	  /* global Symbol */
	
	  var ITERATE_KEYS = 0;
	  var ITERATE_VALUES = 1;
	  var ITERATE_ENTRIES = 2;
	
	  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
	  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
	  function Iterator(next) {
	      this.next = next;
	    }
	
	    Iterator.prototype.toString = function() {
	      return '[Iterator]';
	    };
	
	
	  Iterator.KEYS = ITERATE_KEYS;
	  Iterator.VALUES = ITERATE_VALUES;
	  Iterator.ENTRIES = ITERATE_ENTRIES;
	
	  Iterator.prototype.inspect =
	  Iterator.prototype.toSource = function () { return this.toString(); }
	  Iterator.prototype[ITERATOR_SYMBOL] = function () {
	    return this;
	  };
	
	
	  function iteratorValue(type, k, v, iteratorResult) {
	    var value = type === 0 ? k : type === 1 ? v : [k, v];
	    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
	      value: value, done: false
	    });
	    return iteratorResult;
	  }
	
	  function iteratorDone() {
	    return { value: undefined, done: true };
	  }
	
	  function hasIterator(maybeIterable) {
	    return !!getIteratorFn(maybeIterable);
	  }
	
	  function isIterator(maybeIterator) {
	    return maybeIterator && typeof maybeIterator.next === 'function';
	  }
	
	  function getIterator(iterable) {
	    var iteratorFn = getIteratorFn(iterable);
	    return iteratorFn && iteratorFn.call(iterable);
	  }
	
	  function getIteratorFn(iterable) {
	    var iteratorFn = iterable && (
	      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
	      iterable[FAUX_ITERATOR_SYMBOL]
	    );
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  function isArrayLike(value) {
	    return value && typeof value.length === 'number';
	  }
	
	  createClass(Seq, Iterable);
	    function Seq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        isIterable(value) ? value.toSeq() : seqFromValue(value);
	    }
	
	    Seq.of = function(/*...values*/) {
	      return Seq(arguments);
	    };
	
	    Seq.prototype.toSeq = function() {
	      return this;
	    };
	
	    Seq.prototype.toString = function() {
	      return this.__toString('Seq {', '}');
	    };
	
	    Seq.prototype.cacheResult = function() {
	      if (!this._cache && this.__iterateUncached) {
	        this._cache = this.entrySeq().toArray();
	        this.size = this._cache.length;
	      }
	      return this;
	    };
	
	    // abstract __iterateUncached(fn, reverse)
	
	    Seq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, true);
	    };
	
	    // abstract __iteratorUncached(type, reverse)
	
	    Seq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, true);
	    };
	
	
	
	  createClass(KeyedSeq, Seq);
	    function KeyedSeq(value) {
	      return value === null || value === undefined ?
	        emptySequence().toKeyedSeq() :
	        isIterable(value) ?
	          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
	          keyedSeqFromValue(value);
	    }
	
	    KeyedSeq.prototype.toKeyedSeq = function() {
	      return this;
	    };
	
	
	
	  createClass(IndexedSeq, Seq);
	    function IndexedSeq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
	    }
	
	    IndexedSeq.of = function(/*...values*/) {
	      return IndexedSeq(arguments);
	    };
	
	    IndexedSeq.prototype.toIndexedSeq = function() {
	      return this;
	    };
	
	    IndexedSeq.prototype.toString = function() {
	      return this.__toString('Seq [', ']');
	    };
	
	    IndexedSeq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, false);
	    };
	
	    IndexedSeq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, false);
	    };
	
	
	
	  createClass(SetSeq, Seq);
	    function SetSeq(value) {
	      return (
	        value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value
	      ).toSetSeq();
	    }
	
	    SetSeq.of = function(/*...values*/) {
	      return SetSeq(arguments);
	    };
	
	    SetSeq.prototype.toSetSeq = function() {
	      return this;
	    };
	
	
	
	  Seq.isSeq = isSeq;
	  Seq.Keyed = KeyedSeq;
	  Seq.Set = SetSeq;
	  Seq.Indexed = IndexedSeq;
	
	  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
	  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
	  createClass(ArraySeq, IndexedSeq);
	    function ArraySeq(array) {
	      this._array = array;
	      this.size = array.length;
	    }
	
	    ArraySeq.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
	    };
	
	    ArraySeq.prototype.__iterate = function(fn, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ArraySeq.prototype.__iterator = function(type, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
	      );
	    };
	
	
	
	  createClass(ObjectSeq, KeyedSeq);
	    function ObjectSeq(object) {
	      var keys = Object.keys(object);
	      this._object = object;
	      this._keys = keys;
	      this.size = keys.length;
	    }
	
	    ObjectSeq.prototype.get = function(key, notSetValue) {
	      if (notSetValue !== undefined && !this.has(key)) {
	        return notSetValue;
	      }
	      return this._object[key];
	    };
	
	    ObjectSeq.prototype.has = function(key) {
	      return this._object.hasOwnProperty(key);
	    };
	
	    ObjectSeq.prototype.__iterate = function(fn, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        if (fn(object[key], key, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ObjectSeq.prototype.__iterator = function(type, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, key, object[key]);
	      });
	    };
	
	  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(IterableSeq, IndexedSeq);
	    function IterableSeq(iterable) {
	      this._iterable = iterable;
	      this.size = iterable.length || iterable.size;
	    }
	
	    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      var iterations = 0;
	      if (isIterator(iterator)) {
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (fn(step.value, iterations++, this) === false) {
	            break;
	          }
	        }
	      }
	      return iterations;
	    };
	
	    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      if (!isIterator(iterator)) {
	        return new Iterator(iteratorDone);
	      }
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step : iteratorValue(type, iterations++, step.value);
	      });
	    };
	
	
	
	  createClass(IteratorSeq, IndexedSeq);
	    function IteratorSeq(iterator) {
	      this._iterator = iterator;
	      this._iteratorCache = [];
	    }
	
	    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      while (iterations < cache.length) {
	        if (fn(cache[iterations], iterations++, this) === false) {
	          return iterations;
	        }
	      }
	      var step;
	      while (!(step = iterator.next()).done) {
	        var val = step.value;
	        cache[iterations] = val;
	        if (fn(val, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	
	    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      return new Iterator(function()  {
	        if (iterations >= cache.length) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          cache[iterations] = step.value;
	        }
	        return iteratorValue(type, iterations, cache[iterations++]);
	      });
	    };
	
	
	
	
	  // # pragma Helper functions
	
	  function isSeq(maybeSeq) {
	    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
	  }
	
	  var EMPTY_SEQ;
	
	  function emptySequence() {
	    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
	  }
	
	  function keyedSeqFromValue(value) {
	    var seq =
	      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
	      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
	      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
	      typeof value === 'object' ? new ObjectSeq(value) :
	      undefined;
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of [k, v] entries, '+
	        'or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function indexedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function seqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value) ||
	      (typeof value === 'object' && new ObjectSeq(value));
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values, or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function maybeIndexedSeqFromValue(value) {
	    return (
	      isArrayLike(value) ? new ArraySeq(value) :
	      isIterator(value) ? new IteratorSeq(value) :
	      hasIterator(value) ? new IterableSeq(value) :
	      undefined
	    );
	  }
	
	  function seqIterate(seq, fn, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    }
	    return seq.__iterateUncached(fn, reverse);
	  }
	
	  function seqIterator(seq, type, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
	      });
	    }
	    return seq.__iteratorUncached(type, reverse);
	  }
	
	  function fromJS(json, converter) {
	    return converter ?
	      fromJSWith(converter, json, '', {'': json}) :
	      fromJSDefault(json);
	  }
	
	  function fromJSWith(converter, json, key, parentJSON) {
	    if (Array.isArray(json)) {
	      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    if (isPlainObj(json)) {
	      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    return json;
	  }
	
	  function fromJSDefault(json) {
	    if (Array.isArray(json)) {
	      return IndexedSeq(json).map(fromJSDefault).toList();
	    }
	    if (isPlainObj(json)) {
	      return KeyedSeq(json).map(fromJSDefault).toMap();
	    }
	    return json;
	  }
	
	  function isPlainObj(value) {
	    return value && (value.constructor === Object || value.constructor === undefined);
	  }
	
	  /**
	   * An extension of the "same-value" algorithm as [described for use by ES6 Map
	   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
	   *
	   * NaN is considered the same as NaN, however -0 and 0 are considered the same
	   * value, which is different from the algorithm described by
	   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
	   *
	   * This is extended further to allow Objects to describe the values they
	   * represent, by way of `valueOf` or `equals` (and `hashCode`).
	   *
	   * Note: because of this extension, the key equality of Immutable.Map and the
	   * value equality of Immutable.Set will differ from ES6 Map and Set.
	   *
	   * ### Defining custom values
	   *
	   * The easiest way to describe the value an object represents is by implementing
	   * `valueOf`. For example, `Date` represents a value by returning a unix
	   * timestamp for `valueOf`:
	   *
	   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
	   *     var date2 = new Date(1234567890000);
	   *     date1.valueOf(); // 1234567890000
	   *     assert( date1 !== date2 );
	   *     assert( Immutable.is( date1, date2 ) );
	   *
	   * Note: overriding `valueOf` may have other implications if you use this object
	   * where JavaScript expects a primitive, such as implicit string coercion.
	   *
	   * For more complex types, especially collections, implementing `valueOf` may
	   * not be performant. An alternative is to implement `equals` and `hashCode`.
	   *
	   * `equals` takes another object, presumably of similar type, and returns true
	   * if the it is equal. Equality is symmetrical, so the same result should be
	   * returned if this and the argument are flipped.
	   *
	   *     assert( a.equals(b) === b.equals(a) );
	   *
	   * `hashCode` returns a 32bit integer number representing the object which will
	   * be used to determine how to store the value object in a Map or Set. You must
	   * provide both or neither methods, one must not exist without the other.
	   *
	   * Also, an important relationship between these methods must be upheld: if two
	   * values are equal, they *must* return the same hashCode. If the values are not
	   * equal, they might have the same hashCode; this is called a hash collision,
	   * and while undesirable for performance reasons, it is acceptable.
	   *
	   *     if (a.equals(b)) {
	   *       assert( a.hashCode() === b.hashCode() );
	   *     }
	   *
	   * All Immutable collections implement `equals` and `hashCode`.
	   *
	   */
	  function is(valueA, valueB) {
	    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	      return true;
	    }
	    if (!valueA || !valueB) {
	      return false;
	    }
	    if (typeof valueA.valueOf === 'function' &&
	        typeof valueB.valueOf === 'function') {
	      valueA = valueA.valueOf();
	      valueB = valueB.valueOf();
	      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	        return true;
	      }
	      if (!valueA || !valueB) {
	        return false;
	      }
	    }
	    if (typeof valueA.equals === 'function' &&
	        typeof valueB.equals === 'function' &&
	        valueA.equals(valueB)) {
	      return true;
	    }
	    return false;
	  }
	
	  function deepEqual(a, b) {
	    if (a === b) {
	      return true;
	    }
	
	    if (
	      !isIterable(b) ||
	      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
	      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
	      isKeyed(a) !== isKeyed(b) ||
	      isIndexed(a) !== isIndexed(b) ||
	      isOrdered(a) !== isOrdered(b)
	    ) {
	      return false;
	    }
	
	    if (a.size === 0 && b.size === 0) {
	      return true;
	    }
	
	    var notAssociative = !isAssociative(a);
	
	    if (isOrdered(a)) {
	      var entries = a.entries();
	      return b.every(function(v, k)  {
	        var entry = entries.next().value;
	        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
	      }) && entries.next().done;
	    }
	
	    var flipped = false;
	
	    if (a.size === undefined) {
	      if (b.size === undefined) {
	        if (typeof a.cacheResult === 'function') {
	          a.cacheResult();
	        }
	      } else {
	        flipped = true;
	        var _ = a;
	        a = b;
	        b = _;
	      }
	    }
	
	    var allEqual = true;
	    var bSize = b.__iterate(function(v, k)  {
	      if (notAssociative ? !a.has(v) :
	          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
	        allEqual = false;
	        return false;
	      }
	    });
	
	    return allEqual && a.size === bSize;
	  }
	
	  createClass(Repeat, IndexedSeq);
	
	    function Repeat(value, times) {
	      if (!(this instanceof Repeat)) {
	        return new Repeat(value, times);
	      }
	      this._value = value;
	      this.size = times === undefined ? Infinity : Math.max(0, times);
	      if (this.size === 0) {
	        if (EMPTY_REPEAT) {
	          return EMPTY_REPEAT;
	        }
	        EMPTY_REPEAT = this;
	      }
	    }
	
	    Repeat.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Repeat []';
	      }
	      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
	    };
	
	    Repeat.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._value : notSetValue;
	    };
	
	    Repeat.prototype.includes = function(searchValue) {
	      return is(this._value, searchValue);
	    };
	
	    Repeat.prototype.slice = function(begin, end) {
	      var size = this.size;
	      return wholeSlice(begin, end, size) ? this :
	        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
	    };
	
	    Repeat.prototype.reverse = function() {
	      return this;
	    };
	
	    Repeat.prototype.indexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return 0;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.lastIndexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return this.size;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.__iterate = function(fn, reverse) {
	      for (var ii = 0; ii < this.size; ii++) {
	        if (fn(this._value, ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
	      );
	    };
	
	    Repeat.prototype.equals = function(other) {
	      return other instanceof Repeat ?
	        is(this._value, other._value) :
	        deepEqual(other);
	    };
	
	
	  var EMPTY_REPEAT;
	
	  function invariant(condition, error) {
	    if (!condition) throw new Error(error);
	  }
	
	  createClass(Range, IndexedSeq);
	
	    function Range(start, end, step) {
	      if (!(this instanceof Range)) {
	        return new Range(start, end, step);
	      }
	      invariant(step !== 0, 'Cannot step a Range by 0');
	      start = start || 0;
	      if (end === undefined) {
	        end = Infinity;
	      }
	      step = step === undefined ? 1 : Math.abs(step);
	      if (end < start) {
	        step = -step;
	      }
	      this._start = start;
	      this._end = end;
	      this._step = step;
	      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
	      if (this.size === 0) {
	        if (EMPTY_RANGE) {
	          return EMPTY_RANGE;
	        }
	        EMPTY_RANGE = this;
	      }
	    }
	
	    Range.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Range []';
	      }
	      return 'Range [ ' +
	        this._start + '...' + this._end +
	        (this._step > 1 ? ' by ' + this._step : '') +
	      ' ]';
	    };
	
	    Range.prototype.get = function(index, notSetValue) {
	      return this.has(index) ?
	        this._start + wrapIndex(this, index) * this._step :
	        notSetValue;
	    };
	
	    Range.prototype.includes = function(searchValue) {
	      var possibleIndex = (searchValue - this._start) / this._step;
	      return possibleIndex >= 0 &&
	        possibleIndex < this.size &&
	        possibleIndex === Math.floor(possibleIndex);
	    };
	
	    Range.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      begin = resolveBegin(begin, this.size);
	      end = resolveEnd(end, this.size);
	      if (end <= begin) {
	        return new Range(0, 0);
	      }
	      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
	    };
	
	    Range.prototype.indexOf = function(searchValue) {
	      var offsetValue = searchValue - this._start;
	      if (offsetValue % this._step === 0) {
	        var index = offsetValue / this._step;
	        if (index >= 0 && index < this.size) {
	          return index
	        }
	      }
	      return -1;
	    };
	
	    Range.prototype.lastIndexOf = function(searchValue) {
	      return this.indexOf(searchValue);
	    };
	
	    Range.prototype.__iterate = function(fn, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(value, ii, this) === false) {
	          return ii + 1;
	        }
	        value += reverse ? -step : step;
	      }
	      return ii;
	    };
	
	    Range.prototype.__iterator = function(type, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      var ii = 0;
	      return new Iterator(function()  {
	        var v = value;
	        value += reverse ? -step : step;
	        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
	      });
	    };
	
	    Range.prototype.equals = function(other) {
	      return other instanceof Range ?
	        this._start === other._start &&
	        this._end === other._end &&
	        this._step === other._step :
	        deepEqual(this, other);
	    };
	
	
	  var EMPTY_RANGE;
	
	  createClass(Collection, Iterable);
	    function Collection() {
	      throw TypeError('Abstract');
	    }
	
	
	  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
	  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
	  createClass(SetCollection, Collection);function SetCollection() {}
	
	
	  Collection.Keyed = KeyedCollection;
	  Collection.Indexed = IndexedCollection;
	  Collection.Set = SetCollection;
	
	  var imul =
	    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
	    Math.imul :
	    function imul(a, b) {
	      a = a | 0; // int
	      b = b | 0; // int
	      var c = a & 0xffff;
	      var d = b & 0xffff;
	      // Shift by 0 fixes the sign on the high part.
	      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
	    };
	
	  // v8 has an optimization for storing 31-bit signed numbers.
	  // Values which have either 00 or 11 as the high order bits qualify.
	  // This function drops the highest order bit in a signed number, maintaining
	  // the sign bit.
	  function smi(i32) {
	    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
	  }
	
	  function hash(o) {
	    if (o === false || o === null || o === undefined) {
	      return 0;
	    }
	    if (typeof o.valueOf === 'function') {
	      o = o.valueOf();
	      if (o === false || o === null || o === undefined) {
	        return 0;
	      }
	    }
	    if (o === true) {
	      return 1;
	    }
	    var type = typeof o;
	    if (type === 'number') {
	      var h = o | 0;
	      if (h !== o) {
	        h ^= o * 0xFFFFFFFF;
	      }
	      while (o > 0xFFFFFFFF) {
	        o /= 0xFFFFFFFF;
	        h ^= o;
	      }
	      return smi(h);
	    }
	    if (type === 'string') {
	      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
	    }
	    if (typeof o.hashCode === 'function') {
	      return o.hashCode();
	    }
	    if (type === 'object') {
	      return hashJSObj(o);
	    }
	    if (typeof o.toString === 'function') {
	      return hashString(o.toString());
	    }
	    throw new Error('Value type ' + type + ' cannot be hashed.');
	  }
	
	  function cachedHashString(string) {
	    var hash = stringHashCache[string];
	    if (hash === undefined) {
	      hash = hashString(string);
	      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
	        STRING_HASH_CACHE_SIZE = 0;
	        stringHashCache = {};
	      }
	      STRING_HASH_CACHE_SIZE++;
	      stringHashCache[string] = hash;
	    }
	    return hash;
	  }
	
	  // http://jsperf.com/hashing-strings
	  function hashString(string) {
	    // This is the hash from JVM
	    // The hash code for a string is computed as
	    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
	    // where s[i] is the ith character of the string and n is the length of
	    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
	    // (exclusive) by dropping high bits.
	    var hash = 0;
	    for (var ii = 0; ii < string.length; ii++) {
	      hash = 31 * hash + string.charCodeAt(ii) | 0;
	    }
	    return smi(hash);
	  }
	
	  function hashJSObj(obj) {
	    var hash;
	    if (usingWeakMap) {
	      hash = weakMap.get(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = obj[UID_HASH_KEY];
	    if (hash !== undefined) {
	      return hash;
	    }
	
	    if (!canDefineProperty) {
	      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
	      if (hash !== undefined) {
	        return hash;
	      }
	
	      hash = getIENodeHash(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = ++objHashUID;
	    if (objHashUID & 0x40000000) {
	      objHashUID = 0;
	    }
	
	    if (usingWeakMap) {
	      weakMap.set(obj, hash);
	    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
	      throw new Error('Non-extensible objects are not allowed as keys.');
	    } else if (canDefineProperty) {
	      Object.defineProperty(obj, UID_HASH_KEY, {
	        'enumerable': false,
	        'configurable': false,
	        'writable': false,
	        'value': hash
	      });
	    } else if (obj.propertyIsEnumerable !== undefined &&
	               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
	      // Since we can't define a non-enumerable property on the object
	      // we'll hijack one of the less-used non-enumerable properties to
	      // save our hash on it. Since this is a function it will not show up in
	      // `JSON.stringify` which is what we want.
	      obj.propertyIsEnumerable = function() {
	        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
	      };
	      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
	    } else if (obj.nodeType !== undefined) {
	      // At this point we couldn't get the IE `uniqueID` to use as a hash
	      // and we couldn't use a non-enumerable property to exploit the
	      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
	      // itself.
	      obj[UID_HASH_KEY] = hash;
	    } else {
	      throw new Error('Unable to set a non-enumerable property on object.');
	    }
	
	    return hash;
	  }
	
	  // Get references to ES5 object methods.
	  var isExtensible = Object.isExtensible;
	
	  // True if Object.defineProperty works as expected. IE8 fails this test.
	  var canDefineProperty = (function() {
	    try {
	      Object.defineProperty({}, '@', {});
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }());
	
	  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
	  // and avoid memory leaks from the IE cloneNode bug.
	  function getIENodeHash(node) {
	    if (node && node.nodeType > 0) {
	      switch (node.nodeType) {
	        case 1: // Element
	          return node.uniqueID;
	        case 9: // Document
	          return node.documentElement && node.documentElement.uniqueID;
	      }
	    }
	  }
	
	  // If possible, use a WeakMap.
	  var usingWeakMap = typeof WeakMap === 'function';
	  var weakMap;
	  if (usingWeakMap) {
	    weakMap = new WeakMap();
	  }
	
	  var objHashUID = 0;
	
	  var UID_HASH_KEY = '__immutablehash__';
	  if (typeof Symbol === 'function') {
	    UID_HASH_KEY = Symbol(UID_HASH_KEY);
	  }
	
	  var STRING_HASH_CACHE_MIN_STRLEN = 16;
	  var STRING_HASH_CACHE_MAX_SIZE = 255;
	  var STRING_HASH_CACHE_SIZE = 0;
	  var stringHashCache = {};
	
	  function assertNotInfinite(size) {
	    invariant(
	      size !== Infinity,
	      'Cannot perform this action with an infinite size.'
	    );
	  }
	
	  createClass(Map, KeyedCollection);
	
	    // @pragma Construction
	
	    function Map(value) {
	      return value === null || value === undefined ? emptyMap() :
	        isMap(value) && !isOrdered(value) ? value :
	        emptyMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    Map.prototype.toString = function() {
	      return this.__toString('Map {', '}');
	    };
	
	    // @pragma Access
	
	    Map.prototype.get = function(k, notSetValue) {
	      return this._root ?
	        this._root.get(0, undefined, k, notSetValue) :
	        notSetValue;
	    };
	
	    // @pragma Modification
	
	    Map.prototype.set = function(k, v) {
	      return updateMap(this, k, v);
	    };
	
	    Map.prototype.setIn = function(keyPath, v) {
	      return this.updateIn(keyPath, NOT_SET, function()  {return v});
	    };
	
	    Map.prototype.remove = function(k) {
	      return updateMap(this, k, NOT_SET);
	    };
	
	    Map.prototype.deleteIn = function(keyPath) {
	      return this.updateIn(keyPath, function()  {return NOT_SET});
	    };
	
	    Map.prototype.update = function(k, notSetValue, updater) {
	      return arguments.length === 1 ?
	        k(this) :
	        this.updateIn([k], notSetValue, updater);
	    };
	
	    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
	      if (!updater) {
	        updater = notSetValue;
	        notSetValue = undefined;
	      }
	      var updatedValue = updateInDeepMap(
	        this,
	        forceIterator(keyPath),
	        notSetValue,
	        updater
	      );
	      return updatedValue === NOT_SET ? undefined : updatedValue;
	    };
	
	    Map.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._root = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyMap();
	    };
	
	    // @pragma Composition
	
	    Map.prototype.merge = function(/*...iters*/) {
	      return mergeIntoMapWith(this, undefined, arguments);
	    };
	
	    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, merger, iters);
	    };
	
	    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.merge === 'function' ?
	          m.merge.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoMapWith(this, deepMerger, arguments);
	    };
	
	    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
	    };
	
	    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.mergeDeep === 'function' ?
	          m.mergeDeep.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator));
	    };
	
	    Map.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator, mapper));
	    };
	
	    // @pragma Mutability
	
	    Map.prototype.withMutations = function(fn) {
	      var mutable = this.asMutable();
	      fn(mutable);
	      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
	    };
	
	    Map.prototype.asMutable = function() {
	      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
	    };
	
	    Map.prototype.asImmutable = function() {
	      return this.__ensureOwner();
	    };
	
	    Map.prototype.wasAltered = function() {
	      return this.__altered;
	    };
	
	    Map.prototype.__iterator = function(type, reverse) {
	      return new MapIterator(this, type, reverse);
	    };
	
	    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      this._root && this._root.iterate(function(entry ) {
	        iterations++;
	        return fn(entry[1], entry[0], this$0);
	      }, reverse);
	      return iterations;
	    };
	
	    Map.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeMap(this.size, this._root, ownerID, this.__hash);
	    };
	
	
	  function isMap(maybeMap) {
	    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
	  }
	
	  Map.isMap = isMap;
	
	  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
	  var MapPrototype = Map.prototype;
	  MapPrototype[IS_MAP_SENTINEL] = true;
	  MapPrototype[DELETE] = MapPrototype.remove;
	  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
	  // #pragma Trie Nodes
	
	
	
	    function ArrayMapNode(ownerID, entries) {
	      this.ownerID = ownerID;
	      this.entries = entries;
	    }
	
	    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && entries.length === 1) {
	        return; // undefined
	      }
	
	      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
	        return createNodes(ownerID, entries, key, value);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new ArrayMapNode(ownerID, newEntries);
	    };
	
	
	
	
	    function BitmapIndexedNode(ownerID, bitmap, nodes) {
	      this.ownerID = ownerID;
	      this.bitmap = bitmap;
	      this.nodes = nodes;
	    }
	
	    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
	      var bitmap = this.bitmap;
	      return (bitmap & bit) === 0 ? notSetValue :
	        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
	    };
	
	    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var bit = 1 << keyHashFrag;
	      var bitmap = this.bitmap;
	      var exists = (bitmap & bit) !== 0;
	
	      if (!exists && value === NOT_SET) {
	        return this;
	      }
	
	      var idx = popCount(bitmap & (bit - 1));
	      var nodes = this.nodes;
	      var node = exists ? nodes[idx] : undefined;
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
	      if (newNode === node) {
	        return this;
	      }
	
	      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
	        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
	      }
	
	      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
	        return nodes[idx ^ 1];
	      }
	
	      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
	        return newNode;
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
	      var newNodes = exists ? newNode ?
	        setIn(nodes, idx, newNode, isEditable) :
	        spliceOut(nodes, idx, isEditable) :
	        spliceIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.bitmap = newBitmap;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
	    };
	
	
	
	
	    function HashArrayMapNode(ownerID, count, nodes) {
	      this.ownerID = ownerID;
	      this.count = count;
	      this.nodes = nodes;
	    }
	
	    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var node = this.nodes[idx];
	      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
	    };
	
	    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var removed = value === NOT_SET;
	      var nodes = this.nodes;
	      var node = nodes[idx];
	
	      if (removed && !node) {
	        return this;
	      }
	
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	      if (newNode === node) {
	        return this;
	      }
	
	      var newCount = this.count;
	      if (!node) {
	        newCount++;
	      } else if (!newNode) {
	        newCount--;
	        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
	          return packNodes(ownerID, nodes, newCount, idx);
	        }
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.count = newCount;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new HashArrayMapNode(ownerID, newCount, newNodes);
	    };
	
	
	
	
	    function HashCollisionNode(ownerID, keyHash, entries) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entries = entries;
	    }
	
	    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	
	      var removed = value === NOT_SET;
	
	      if (keyHash !== this.keyHash) {
	        if (removed) {
	          return this;
	        }
	        SetRef(didAlter);
	        SetRef(didChangeSize);
	        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
	      }
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && len === 2) {
	        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
	    };
	
	
	
	
	    function ValueNode(ownerID, keyHash, entry) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entry = entry;
	    }
	
	    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
	    };
	
	    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	      var keyMatch = is(key, this.entry[0]);
	      if (keyMatch ? value === this.entry[1] : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	
	      if (removed) {
	        SetRef(didChangeSize);
	        return; // undefined
	      }
	
	      if (keyMatch) {
	        if (ownerID && ownerID === this.ownerID) {
	          this.entry[1] = value;
	          return this;
	        }
	        return new ValueNode(ownerID, this.keyHash, [key, value]);
	      }
	
	      SetRef(didChangeSize);
	      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
	    };
	
	
	
	  // #pragma Iterators
	
	  ArrayMapNode.prototype.iterate =
	  HashCollisionNode.prototype.iterate = function (fn, reverse) {
	    var entries = this.entries;
	    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
	      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
	        return false;
	      }
	    }
	  }
	
	  BitmapIndexedNode.prototype.iterate =
	  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
	    var nodes = this.nodes;
	    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
	      var node = nodes[reverse ? maxIndex - ii : ii];
	      if (node && node.iterate(fn, reverse) === false) {
	        return false;
	      }
	    }
	  }
	
	  ValueNode.prototype.iterate = function (fn, reverse) {
	    return fn(this.entry);
	  }
	
	  createClass(MapIterator, Iterator);
	
	    function MapIterator(map, type, reverse) {
	      this._type = type;
	      this._reverse = reverse;
	      this._stack = map._root && mapIteratorFrame(map._root);
	    }
	
	    MapIterator.prototype.next = function() {
	      var type = this._type;
	      var stack = this._stack;
	      while (stack) {
	        var node = stack.node;
	        var index = stack.index++;
	        var maxIndex;
	        if (node.entry) {
	          if (index === 0) {
	            return mapIteratorValue(type, node.entry);
	          }
	        } else if (node.entries) {
	          maxIndex = node.entries.length - 1;
	          if (index <= maxIndex) {
	            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
	          }
	        } else {
	          maxIndex = node.nodes.length - 1;
	          if (index <= maxIndex) {
	            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
	            if (subNode) {
	              if (subNode.entry) {
	                return mapIteratorValue(type, subNode.entry);
	              }
	              stack = this._stack = mapIteratorFrame(subNode, stack);
	            }
	            continue;
	          }
	        }
	        stack = this._stack = this._stack.__prev;
	      }
	      return iteratorDone();
	    };
	
	
	  function mapIteratorValue(type, entry) {
	    return iteratorValue(type, entry[0], entry[1]);
	  }
	
	  function mapIteratorFrame(node, prev) {
	    return {
	      node: node,
	      index: 0,
	      __prev: prev
	    };
	  }
	
	  function makeMap(size, root, ownerID, hash) {
	    var map = Object.create(MapPrototype);
	    map.size = size;
	    map._root = root;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_MAP;
	  function emptyMap() {
	    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
	  }
	
	  function updateMap(map, k, v) {
	    var newRoot;
	    var newSize;
	    if (!map._root) {
	      if (v === NOT_SET) {
	        return map;
	      }
	      newSize = 1;
	      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
	    } else {
	      var didChangeSize = MakeRef(CHANGE_LENGTH);
	      var didAlter = MakeRef(DID_ALTER);
	      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
	      if (!didAlter.value) {
	        return map;
	      }
	      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
	    }
	    if (map.__ownerID) {
	      map.size = newSize;
	      map._root = newRoot;
	      map.__hash = undefined;
	      map.__altered = true;
	      return map;
	    }
	    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
	  }
	
	  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (!node) {
	      if (value === NOT_SET) {
	        return node;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return new ValueNode(ownerID, keyHash, [key, value]);
	    }
	    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
	  }
	
	  function isLeafNode(node) {
	    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
	  }
	
	  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
	    if (node.keyHash === keyHash) {
	      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
	    }
	
	    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
	    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
	    var newNode;
	    var nodes = idx1 === idx2 ?
	      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
	      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
	    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
	  }
	
	  function createNodes(ownerID, entries, key, value) {
	    if (!ownerID) {
	      ownerID = new OwnerID();
	    }
	    var node = new ValueNode(ownerID, hash(key), [key, value]);
	    for (var ii = 0; ii < entries.length; ii++) {
	      var entry = entries[ii];
	      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
	    }
	    return node;
	  }
	
	  function packNodes(ownerID, nodes, count, excluding) {
	    var bitmap = 0;
	    var packedII = 0;
	    var packedNodes = new Array(count);
	    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
	      var node = nodes[ii];
	      if (node !== undefined && ii !== excluding) {
	        bitmap |= bit;
	        packedNodes[packedII++] = node;
	      }
	    }
	    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
	  }
	
	  function expandNodes(ownerID, nodes, bitmap, including, node) {
	    var count = 0;
	    var expandedNodes = new Array(SIZE);
	    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
	      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
	    }
	    expandedNodes[including] = node;
	    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
	  }
	
	  function mergeIntoMapWith(map, merger, iterables) {
	    var iters = [];
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = KeyedIterable(value);
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    return mergeIntoCollectionWith(map, merger, iters);
	  }
	
	  function deepMerger(existing, value, key) {
	    return existing && existing.mergeDeep && isIterable(value) ?
	      existing.mergeDeep(value) :
	      is(existing, value) ? existing : value;
	  }
	
	  function deepMergerWith(merger) {
	    return function(existing, value, key)  {
	      if (existing && existing.mergeDeepWith && isIterable(value)) {
	        return existing.mergeDeepWith(merger, value);
	      }
	      var nextValue = merger(existing, value, key);
	      return is(existing, nextValue) ? existing : nextValue;
	    };
	  }
	
	  function mergeIntoCollectionWith(collection, merger, iters) {
	    iters = iters.filter(function(x ) {return x.size !== 0});
	    if (iters.length === 0) {
	      return collection;
	    }
	    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
	      return collection.constructor(iters[0]);
	    }
	    return collection.withMutations(function(collection ) {
	      var mergeIntoMap = merger ?
	        function(value, key)  {
	          collection.update(key, NOT_SET, function(existing )
	            {return existing === NOT_SET ? value : merger(existing, value, key)}
	          );
	        } :
	        function(value, key)  {
	          collection.set(key, value);
	        }
	      for (var ii = 0; ii < iters.length; ii++) {
	        iters[ii].forEach(mergeIntoMap);
	      }
	    });
	  }
	
	  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
	    var isNotSet = existing === NOT_SET;
	    var step = keyPathIter.next();
	    if (step.done) {
	      var existingValue = isNotSet ? notSetValue : existing;
	      var newValue = updater(existingValue);
	      return newValue === existingValue ? existing : newValue;
	    }
	    invariant(
	      isNotSet || (existing && existing.set),
	      'invalid keyPath'
	    );
	    var key = step.value;
	    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
	    var nextUpdated = updateInDeepMap(
	      nextExisting,
	      keyPathIter,
	      notSetValue,
	      updater
	    );
	    return nextUpdated === nextExisting ? existing :
	      nextUpdated === NOT_SET ? existing.remove(key) :
	      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
	  }
	
	  function popCount(x) {
	    x = x - ((x >> 1) & 0x55555555);
	    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
	    x = (x + (x >> 4)) & 0x0f0f0f0f;
	    x = x + (x >> 8);
	    x = x + (x >> 16);
	    return x & 0x7f;
	  }
	
	  function setIn(array, idx, val, canEdit) {
	    var newArray = canEdit ? array : arrCopy(array);
	    newArray[idx] = val;
	    return newArray;
	  }
	
	  function spliceIn(array, idx, val, canEdit) {
	    var newLen = array.length + 1;
	    if (canEdit && idx + 1 === newLen) {
	      array[idx] = val;
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        newArray[ii] = val;
	        after = -1;
	      } else {
	        newArray[ii] = array[ii + after];
	      }
	    }
	    return newArray;
	  }
	
	  function spliceOut(array, idx, canEdit) {
	    var newLen = array.length - 1;
	    if (canEdit && idx === newLen) {
	      array.pop();
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        after = 1;
	      }
	      newArray[ii] = array[ii + after];
	    }
	    return newArray;
	  }
	
	  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
	  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
	  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
	  createClass(List, IndexedCollection);
	
	    // @pragma Construction
	
	    function List(value) {
	      var empty = emptyList();
	      if (value === null || value === undefined) {
	        return empty;
	      }
	      if (isList(value)) {
	        return value;
	      }
	      var iter = IndexedIterable(value);
	      var size = iter.size;
	      if (size === 0) {
	        return empty;
	      }
	      assertNotInfinite(size);
	      if (size > 0 && size < SIZE) {
	        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
	      }
	      return empty.withMutations(function(list ) {
	        list.setSize(size);
	        iter.forEach(function(v, i)  {return list.set(i, v)});
	      });
	    }
	
	    List.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    List.prototype.toString = function() {
	      return this.__toString('List [', ']');
	    };
	
	    // @pragma Access
	
	    List.prototype.get = function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      if (index >= 0 && index < this.size) {
	        index += this._origin;
	        var node = listNodeFor(this, index);
	        return node && node.array[index & MASK];
	      }
	      return notSetValue;
	    };
	
	    // @pragma Modification
	
	    List.prototype.set = function(index, value) {
	      return updateList(this, index, value);
	    };
	
	    List.prototype.remove = function(index) {
	      return !this.has(index) ? this :
	        index === 0 ? this.shift() :
	        index === this.size - 1 ? this.pop() :
	        this.splice(index, 1);
	    };
	
	    List.prototype.insert = function(index, value) {
	      return this.splice(index, 0, value);
	    };
	
	    List.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = this._origin = this._capacity = 0;
	        this._level = SHIFT;
	        this._root = this._tail = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyList();
	    };
	
	    List.prototype.push = function(/*...values*/) {
	      var values = arguments;
	      var oldSize = this.size;
	      return this.withMutations(function(list ) {
	        setListBounds(list, 0, oldSize + values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(oldSize + ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.pop = function() {
	      return setListBounds(this, 0, -1);
	    };
	
	    List.prototype.unshift = function(/*...values*/) {
	      var values = arguments;
	      return this.withMutations(function(list ) {
	        setListBounds(list, -values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.shift = function() {
	      return setListBounds(this, 1);
	    };
	
	    // @pragma Composition
	
	    List.prototype.merge = function(/*...iters*/) {
	      return mergeIntoListWith(this, undefined, arguments);
	    };
	
	    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, merger, iters);
	    };
	
	    List.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoListWith(this, deepMerger, arguments);
	    };
	
	    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, deepMergerWith(merger), iters);
	    };
	
	    List.prototype.setSize = function(size) {
	      return setListBounds(this, 0, size);
	    };
	
	    // @pragma Iteration
	
	    List.prototype.slice = function(begin, end) {
	      var size = this.size;
	      if (wholeSlice(begin, end, size)) {
	        return this;
	      }
	      return setListBounds(
	        this,
	        resolveBegin(begin, size),
	        resolveEnd(end, size)
	      );
	    };
	
	    List.prototype.__iterator = function(type, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      return new Iterator(function()  {
	        var value = values();
	        return value === DONE ?
	          iteratorDone() :
	          iteratorValue(type, index++, value);
	      });
	    };
	
	    List.prototype.__iterate = function(fn, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      var value;
	      while ((value = values()) !== DONE) {
	        if (fn(value, index++, this) === false) {
	          break;
	        }
	      }
	      return index;
	    };
	
	    List.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        return this;
	      }
	      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
	    };
	
	
	  function isList(maybeList) {
	    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
	  }
	
	  List.isList = isList;
	
	  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
	  var ListPrototype = List.prototype;
	  ListPrototype[IS_LIST_SENTINEL] = true;
	  ListPrototype[DELETE] = ListPrototype.remove;
	  ListPrototype.setIn = MapPrototype.setIn;
	  ListPrototype.deleteIn =
	  ListPrototype.removeIn = MapPrototype.removeIn;
	  ListPrototype.update = MapPrototype.update;
	  ListPrototype.updateIn = MapPrototype.updateIn;
	  ListPrototype.mergeIn = MapPrototype.mergeIn;
	  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  ListPrototype.withMutations = MapPrototype.withMutations;
	  ListPrototype.asMutable = MapPrototype.asMutable;
	  ListPrototype.asImmutable = MapPrototype.asImmutable;
	  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
	    function VNode(array, ownerID) {
	      this.array = array;
	      this.ownerID = ownerID;
	    }
	
	    // TODO: seems like these methods are very similar
	
	    VNode.prototype.removeBefore = function(ownerID, level, index) {
	      if (index === level ? 1 << level : 0 || this.array.length === 0) {
	        return this;
	      }
	      var originIndex = (index >>> level) & MASK;
	      if (originIndex >= this.array.length) {
	        return new VNode([], ownerID);
	      }
	      var removingFirst = originIndex === 0;
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[originIndex];
	        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && removingFirst) {
	          return this;
	        }
	      }
	      if (removingFirst && !newChild) {
	        return this;
	      }
	      var editable = editableVNode(this, ownerID);
	      if (!removingFirst) {
	        for (var ii = 0; ii < originIndex; ii++) {
	          editable.array[ii] = undefined;
	        }
	      }
	      if (newChild) {
	        editable.array[originIndex] = newChild;
	      }
	      return editable;
	    };
	
	    VNode.prototype.removeAfter = function(ownerID, level, index) {
	      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
	        return this;
	      }
	      var sizeIndex = ((index - 1) >>> level) & MASK;
	      if (sizeIndex >= this.array.length) {
	        return this;
	      }
	
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[sizeIndex];
	        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
	          return this;
	        }
	      }
	
	      var editable = editableVNode(this, ownerID);
	      editable.array.splice(sizeIndex + 1);
	      if (newChild) {
	        editable.array[sizeIndex] = newChild;
	      }
	      return editable;
	    };
	
	
	
	  var DONE = {};
	
	  function iterateList(list, reverse) {
	    var left = list._origin;
	    var right = list._capacity;
	    var tailPos = getTailOffset(right);
	    var tail = list._tail;
	
	    return iterateNodeOrLeaf(list._root, list._level, 0);
	
	    function iterateNodeOrLeaf(node, level, offset) {
	      return level === 0 ?
	        iterateLeaf(node, offset) :
	        iterateNode(node, level, offset);
	    }
	
	    function iterateLeaf(node, offset) {
	      var array = offset === tailPos ? tail && tail.array : node && node.array;
	      var from = offset > left ? 0 : left - offset;
	      var to = right - offset;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        if (from === to) {
	          return DONE;
	        }
	        var idx = reverse ? --to : from++;
	        return array && array[idx];
	      };
	    }
	
	    function iterateNode(node, level, offset) {
	      var values;
	      var array = node && node.array;
	      var from = offset > left ? 0 : (left - offset) >> level;
	      var to = ((right - offset) >> level) + 1;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        do {
	          if (values) {
	            var value = values();
	            if (value !== DONE) {
	              return value;
	            }
	            values = null;
	          }
	          if (from === to) {
	            return DONE;
	          }
	          var idx = reverse ? --to : from++;
	          values = iterateNodeOrLeaf(
	            array && array[idx], level - SHIFT, offset + (idx << level)
	          );
	        } while (true);
	      };
	    }
	  }
	
	  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
	    var list = Object.create(ListPrototype);
	    list.size = capacity - origin;
	    list._origin = origin;
	    list._capacity = capacity;
	    list._level = level;
	    list._root = root;
	    list._tail = tail;
	    list.__ownerID = ownerID;
	    list.__hash = hash;
	    list.__altered = false;
	    return list;
	  }
	
	  var EMPTY_LIST;
	  function emptyList() {
	    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
	  }
	
	  function updateList(list, index, value) {
	    index = wrapIndex(list, index);
	
	    if (index !== index) {
	      return list;
	    }
	
	    if (index >= list.size || index < 0) {
	      return list.withMutations(function(list ) {
	        index < 0 ?
	          setListBounds(list, index).set(0, value) :
	          setListBounds(list, 0, index + 1).set(index, value)
	      });
	    }
	
	    index += list._origin;
	
	    var newTail = list._tail;
	    var newRoot = list._root;
	    var didAlter = MakeRef(DID_ALTER);
	    if (index >= getTailOffset(list._capacity)) {
	      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
	    } else {
	      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
	    }
	
	    if (!didAlter.value) {
	      return list;
	    }
	
	    if (list.__ownerID) {
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
	  }
	
	  function updateVNode(node, ownerID, level, index, value, didAlter) {
	    var idx = (index >>> level) & MASK;
	    var nodeHas = node && idx < node.array.length;
	    if (!nodeHas && value === undefined) {
	      return node;
	    }
	
	    var newNode;
	
	    if (level > 0) {
	      var lowerNode = node && node.array[idx];
	      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
	      if (newLowerNode === lowerNode) {
	        return node;
	      }
	      newNode = editableVNode(node, ownerID);
	      newNode.array[idx] = newLowerNode;
	      return newNode;
	    }
	
	    if (nodeHas && node.array[idx] === value) {
	      return node;
	    }
	
	    SetRef(didAlter);
	
	    newNode = editableVNode(node, ownerID);
	    if (value === undefined && idx === newNode.array.length - 1) {
	      newNode.array.pop();
	    } else {
	      newNode.array[idx] = value;
	    }
	    return newNode;
	  }
	
	  function editableVNode(node, ownerID) {
	    if (ownerID && node && ownerID === node.ownerID) {
	      return node;
	    }
	    return new VNode(node ? node.array.slice() : [], ownerID);
	  }
	
	  function listNodeFor(list, rawIndex) {
	    if (rawIndex >= getTailOffset(list._capacity)) {
	      return list._tail;
	    }
	    if (rawIndex < 1 << (list._level + SHIFT)) {
	      var node = list._root;
	      var level = list._level;
	      while (node && level > 0) {
	        node = node.array[(rawIndex >>> level) & MASK];
	        level -= SHIFT;
	      }
	      return node;
	    }
	  }
	
	  function setListBounds(list, begin, end) {
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	    var owner = list.__ownerID || new OwnerID();
	    var oldOrigin = list._origin;
	    var oldCapacity = list._capacity;
	    var newOrigin = oldOrigin + begin;
	    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
	    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
	      return list;
	    }
	
	    // If it's going to end after it starts, it's empty.
	    if (newOrigin >= newCapacity) {
	      return list.clear();
	    }
	
	    var newLevel = list._level;
	    var newRoot = list._root;
	
	    // New origin might need creating a higher root.
	    var offsetShift = 0;
	    while (newOrigin + offsetShift < 0) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
	      newLevel += SHIFT;
	      offsetShift += 1 << newLevel;
	    }
	    if (offsetShift) {
	      newOrigin += offsetShift;
	      oldOrigin += offsetShift;
	      newCapacity += offsetShift;
	      oldCapacity += offsetShift;
	    }
	
	    var oldTailOffset = getTailOffset(oldCapacity);
	    var newTailOffset = getTailOffset(newCapacity);
	
	    // New size might need creating a higher root.
	    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
	      newLevel += SHIFT;
	    }
	
	    // Locate or create the new tail.
	    var oldTail = list._tail;
	    var newTail = newTailOffset < oldTailOffset ?
	      listNodeFor(list, newCapacity - 1) :
	      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
	    // Merge Tail into tree.
	    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
	      newRoot = editableVNode(newRoot, owner);
	      var node = newRoot;
	      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
	        var idx = (oldTailOffset >>> level) & MASK;
	        node = node.array[idx] = editableVNode(node.array[idx], owner);
	      }
	      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
	    }
	
	    // If the size has been reduced, there's a chance the tail needs to be trimmed.
	    if (newCapacity < oldCapacity) {
	      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
	    }
	
	    // If the new origin is within the tail, then we do not need a root.
	    if (newOrigin >= newTailOffset) {
	      newOrigin -= newTailOffset;
	      newCapacity -= newTailOffset;
	      newLevel = SHIFT;
	      newRoot = null;
	      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
	    // Otherwise, if the root has been trimmed, garbage collect.
	    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
	      offsetShift = 0;
	
	      // Identify the new top root node of the subtree of the old root.
	      while (newRoot) {
	        var beginIndex = (newOrigin >>> newLevel) & MASK;
	        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
	          break;
	        }
	        if (beginIndex) {
	          offsetShift += (1 << newLevel) * beginIndex;
	        }
	        newLevel -= SHIFT;
	        newRoot = newRoot.array[beginIndex];
	      }
	
	      // Trim the new sides of the new root.
	      if (newRoot && newOrigin > oldOrigin) {
	        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
	      }
	      if (newRoot && newTailOffset < oldTailOffset) {
	        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
	      }
	      if (offsetShift) {
	        newOrigin -= offsetShift;
	        newCapacity -= offsetShift;
	      }
	    }
	
	    if (list.__ownerID) {
	      list.size = newCapacity - newOrigin;
	      list._origin = newOrigin;
	      list._capacity = newCapacity;
	      list._level = newLevel;
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
	  }
	
	  function mergeIntoListWith(list, merger, iterables) {
	    var iters = [];
	    var maxSize = 0;
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = IndexedIterable(value);
	      if (iter.size > maxSize) {
	        maxSize = iter.size;
	      }
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    if (maxSize > list.size) {
	      list = list.setSize(maxSize);
	    }
	    return mergeIntoCollectionWith(list, merger, iters);
	  }
	
	  function getTailOffset(size) {
	    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
	  }
	
	  createClass(OrderedMap, Map);
	
	    // @pragma Construction
	
	    function OrderedMap(value) {
	      return value === null || value === undefined ? emptyOrderedMap() :
	        isOrderedMap(value) ? value :
	        emptyOrderedMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    OrderedMap.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedMap.prototype.toString = function() {
	      return this.__toString('OrderedMap {', '}');
	    };
	
	    // @pragma Access
	
	    OrderedMap.prototype.get = function(k, notSetValue) {
	      var index = this._map.get(k);
	      return index !== undefined ? this._list.get(index)[1] : notSetValue;
	    };
	
	    // @pragma Modification
	
	    OrderedMap.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._map.clear();
	        this._list.clear();
	        return this;
	      }
	      return emptyOrderedMap();
	    };
	
	    OrderedMap.prototype.set = function(k, v) {
	      return updateOrderedMap(this, k, v);
	    };
	
	    OrderedMap.prototype.remove = function(k) {
	      return updateOrderedMap(this, k, NOT_SET);
	    };
	
	    OrderedMap.prototype.wasAltered = function() {
	      return this._map.wasAltered() || this._list.wasAltered();
	    };
	
	    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._list.__iterate(
	        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
	        reverse
	      );
	    };
	
	    OrderedMap.prototype.__iterator = function(type, reverse) {
	      return this._list.fromEntrySeq().__iterator(type, reverse);
	    };
	
	    OrderedMap.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      var newList = this._list.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        this._list = newList;
	        return this;
	      }
	      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
	    };
	
	
	  function isOrderedMap(maybeOrderedMap) {
	    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
	  }
	
	  OrderedMap.isOrderedMap = isOrderedMap;
	
	  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
	  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
	  function makeOrderedMap(map, list, ownerID, hash) {
	    var omap = Object.create(OrderedMap.prototype);
	    omap.size = map ? map.size : 0;
	    omap._map = map;
	    omap._list = list;
	    omap.__ownerID = ownerID;
	    omap.__hash = hash;
	    return omap;
	  }
	
	  var EMPTY_ORDERED_MAP;
	  function emptyOrderedMap() {
	    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
	  }
	
	  function updateOrderedMap(omap, k, v) {
	    var map = omap._map;
	    var list = omap._list;
	    var i = map.get(k);
	    var has = i !== undefined;
	    var newMap;
	    var newList;
	    if (v === NOT_SET) { // removed
	      if (!has) {
	        return omap;
	      }
	      if (list.size >= SIZE && list.size >= map.size * 2) {
	        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
	        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
	        if (omap.__ownerID) {
	          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
	        }
	      } else {
	        newMap = map.remove(k);
	        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
	      }
	    } else {
	      if (has) {
	        if (v === list.get(i)[1]) {
	          return omap;
	        }
	        newMap = map;
	        newList = list.set(i, [k, v]);
	      } else {
	        newMap = map.set(k, list.size);
	        newList = list.set(list.size, [k, v]);
	      }
	    }
	    if (omap.__ownerID) {
	      omap.size = newMap.size;
	      omap._map = newMap;
	      omap._list = newList;
	      omap.__hash = undefined;
	      return omap;
	    }
	    return makeOrderedMap(newMap, newList);
	  }
	
	  createClass(ToKeyedSequence, KeyedSeq);
	    function ToKeyedSequence(indexed, useKeys) {
	      this._iter = indexed;
	      this._useKeys = useKeys;
	      this.size = indexed.size;
	    }
	
	    ToKeyedSequence.prototype.get = function(key, notSetValue) {
	      return this._iter.get(key, notSetValue);
	    };
	
	    ToKeyedSequence.prototype.has = function(key) {
	      return this._iter.has(key);
	    };
	
	    ToKeyedSequence.prototype.valueSeq = function() {
	      return this._iter.valueSeq();
	    };
	
	    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
	      var reversedSequence = reverseFactory(this, true);
	      if (!this._useKeys) {
	        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
	      }
	      return reversedSequence;
	    };
	
	    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
	      var mappedSequence = mapFactory(this, mapper, context);
	      if (!this._useKeys) {
	        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
	      }
	      return mappedSequence;
	    };
	
	    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var ii;
	      return this._iter.__iterate(
	        this._useKeys ?
	          function(v, k)  {return fn(v, k, this$0)} :
	          ((ii = reverse ? resolveSize(this) : 0),
	            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
	        reverse
	      );
	    };
	
	    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
	      if (this._useKeys) {
	        return this._iter.__iterator(type, reverse);
	      }
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var ii = reverse ? resolveSize(this) : 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
	      });
	    };
	
	  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(ToIndexedSequence, IndexedSeq);
	    function ToIndexedSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToIndexedSequence.prototype.includes = function(value) {
	      return this._iter.includes(value);
	    };
	
	    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
	    };
	
	    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, iterations++, step.value, step)
	      });
	    };
	
	
	
	  createClass(ToSetSequence, SetSeq);
	    function ToSetSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToSetSequence.prototype.has = function(key) {
	      return this._iter.includes(key);
	    };
	
	    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
	    };
	
	    ToSetSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, step.value, step.value, step);
	      });
	    };
	
	
	
	  createClass(FromEntriesSequence, KeyedSeq);
	    function FromEntriesSequence(entries) {
	      this._iter = entries;
	      this.size = entries.size;
	    }
	
	    FromEntriesSequence.prototype.entrySeq = function() {
	      return this._iter.toSeq();
	    };
	
	    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(entry ) {
	        // Check if entry exists first so array access doesn't throw for holes
	        // in the parent iteration.
	        if (entry) {
	          validateEntry(entry);
	          var indexedIterable = isIterable(entry);
	          return fn(
	            indexedIterable ? entry.get(1) : entry[1],
	            indexedIterable ? entry.get(0) : entry[0],
	            this$0
	          );
	        }
	      }, reverse);
	    };
	
	    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          // Check if entry exists first so array access doesn't throw for holes
	          // in the parent iteration.
	          if (entry) {
	            validateEntry(entry);
	            var indexedIterable = isIterable(entry);
	            return iteratorValue(
	              type,
	              indexedIterable ? entry.get(0) : entry[0],
	              indexedIterable ? entry.get(1) : entry[1],
	              step
	            );
	          }
	        }
	      });
	    };
	
	
	  ToIndexedSequence.prototype.cacheResult =
	  ToKeyedSequence.prototype.cacheResult =
	  ToSetSequence.prototype.cacheResult =
	  FromEntriesSequence.prototype.cacheResult =
	    cacheResultThrough;
	
	
	  function flipFactory(iterable) {
	    var flipSequence = makeSequence(iterable);
	    flipSequence._iter = iterable;
	    flipSequence.size = iterable.size;
	    flipSequence.flip = function()  {return iterable};
	    flipSequence.reverse = function () {
	      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
	      reversedSequence.flip = function()  {return iterable.reverse()};
	      return reversedSequence;
	    };
	    flipSequence.has = function(key ) {return iterable.includes(key)};
	    flipSequence.includes = function(key ) {return iterable.has(key)};
	    flipSequence.cacheResult = cacheResultThrough;
	    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
	    }
	    flipSequence.__iteratorUncached = function(type, reverse) {
	      if (type === ITERATE_ENTRIES) {
	        var iterator = iterable.__iterator(type, reverse);
	        return new Iterator(function()  {
	          var step = iterator.next();
	          if (!step.done) {
	            var k = step.value[0];
	            step.value[0] = step.value[1];
	            step.value[1] = k;
	          }
	          return step;
	        });
	      }
	      return iterable.__iterator(
	        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
	        reverse
	      );
	    }
	    return flipSequence;
	  }
	
	
	  function mapFactory(iterable, mapper, context) {
	    var mappedSequence = makeSequence(iterable);
	    mappedSequence.size = iterable.size;
	    mappedSequence.has = function(key ) {return iterable.has(key)};
	    mappedSequence.get = function(key, notSetValue)  {
	      var v = iterable.get(key, NOT_SET);
	      return v === NOT_SET ?
	        notSetValue :
	        mapper.call(context, v, key, iterable);
	    };
	    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(
	        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
	        reverse
	      );
	    }
	    mappedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var key = entry[0];
	        return iteratorValue(
	          type,
	          key,
	          mapper.call(context, entry[1], key, iterable),
	          step
	        );
	      });
	    }
	    return mappedSequence;
	  }
	
	
	  function reverseFactory(iterable, useKeys) {
	    var reversedSequence = makeSequence(iterable);
	    reversedSequence._iter = iterable;
	    reversedSequence.size = iterable.size;
	    reversedSequence.reverse = function()  {return iterable};
	    if (iterable.flip) {
	      reversedSequence.flip = function () {
	        var flipSequence = flipFactory(iterable);
	        flipSequence.reverse = function()  {return iterable.flip()};
	        return flipSequence;
	      };
	    }
	    reversedSequence.get = function(key, notSetValue) 
	      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
	    reversedSequence.has = function(key )
	      {return iterable.has(useKeys ? key : -1 - key)};
	    reversedSequence.includes = function(value ) {return iterable.includes(value)};
	    reversedSequence.cacheResult = cacheResultThrough;
	    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
	    };
	    reversedSequence.__iterator =
	      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
	    return reversedSequence;
	  }
	
	
	  function filterFactory(iterable, predicate, context, useKeys) {
	    var filterSequence = makeSequence(iterable);
	    if (useKeys) {
	      filterSequence.has = function(key ) {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
	      };
	      filterSequence.get = function(key, notSetValue)  {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
	          v : notSetValue;
	      };
	    }
	    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      }, reverse);
	      return iterations;
	    };
	    filterSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          var key = entry[0];
	          var value = entry[1];
	          if (predicate.call(context, value, key, iterable)) {
	            return iteratorValue(type, useKeys ? key : iterations++, value, step);
	          }
	        }
	      });
	    }
	    return filterSequence;
	  }
	
	
	  function countByFactory(iterable, grouper, context) {
	    var groups = Map().asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        0,
	        function(a ) {return a + 1}
	      );
	    });
	    return groups.asImmutable();
	  }
	
	
	  function groupByFactory(iterable, grouper, context) {
	    var isKeyedIter = isKeyed(iterable);
	    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
	      );
	    });
	    var coerce = iterableClass(iterable);
	    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
	  }
	
	
	  function sliceFactory(iterable, begin, end, useKeys) {
	    var originalSize = iterable.size;
	
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	
	    if (wholeSlice(begin, end, originalSize)) {
	      return iterable;
	    }
	
	    var resolvedBegin = resolveBegin(begin, originalSize);
	    var resolvedEnd = resolveEnd(end, originalSize);
	
	    // begin or end will be NaN if they were provided as negative numbers and
	    // this iterable's size is unknown. In that case, cache first so there is
	    // a known size and these do not resolve to NaN.
	    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
	      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
	    }
	
	    // Note: resolvedEnd is undefined when the original sequence's length is
	    // unknown and this slice did not supply an end and should contain all
	    // elements after resolvedBegin.
	    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
	    var resolvedSize = resolvedEnd - resolvedBegin;
	    var sliceSize;
	    if (resolvedSize === resolvedSize) {
	      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
	    }
	
	    var sliceSeq = makeSequence(iterable);
	
	    // If iterable.size is undefined, the size of the realized sliceSeq is
	    // unknown at this point unless the number of items to slice is 0
	    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
	    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
	      sliceSeq.get = function (index, notSetValue) {
	        index = wrapIndex(this, index);
	        return index >= 0 && index < sliceSize ?
	          iterable.get(index + resolvedBegin, notSetValue) :
	          notSetValue;
	      }
	    }
	
	    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (sliceSize === 0) {
	        return 0;
	      }
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var skipped = 0;
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k)  {
	        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
	                 iterations !== sliceSize;
	        }
	      });
	      return iterations;
	    };
	
	    sliceSeq.__iteratorUncached = function(type, reverse) {
	      if (sliceSize !== 0 && reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      // Don't bother instantiating parent iterator if taking 0.
	      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
	      var skipped = 0;
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (skipped++ < resolvedBegin) {
	          iterator.next();
	        }
	        if (++iterations > sliceSize) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (useKeys || type === ITERATE_VALUES) {
	          return step;
	        } else if (type === ITERATE_KEYS) {
	          return iteratorValue(type, iterations - 1, undefined, step);
	        } else {
	          return iteratorValue(type, iterations - 1, step.value[1], step);
	        }
	      });
	    }
	
	    return sliceSeq;
	  }
	
	
	  function takeWhileFactory(iterable, predicate, context) {
	    var takeSequence = makeSequence(iterable);
	    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c) 
	        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
	      );
	      return iterations;
	    };
	    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterating = true;
	      return new Iterator(function()  {
	        if (!iterating) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var k = entry[0];
	        var v = entry[1];
	        if (!predicate.call(context, v, k, this$0)) {
	          iterating = false;
	          return iteratorDone();
	        }
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return takeSequence;
	  }
	
	
	  function skipWhileFactory(iterable, predicate, context, useKeys) {
	    var skipSequence = makeSequence(iterable);
	    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      });
	      return iterations;
	    };
	    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var skipping = true;
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step, k, v;
	        do {
	          step = iterator.next();
	          if (step.done) {
	            if (useKeys || type === ITERATE_VALUES) {
	              return step;
	            } else if (type === ITERATE_KEYS) {
	              return iteratorValue(type, iterations++, undefined, step);
	            } else {
	              return iteratorValue(type, iterations++, step.value[1], step);
	            }
	          }
	          var entry = step.value;
	          k = entry[0];
	          v = entry[1];
	          skipping && (skipping = predicate.call(context, v, k, this$0));
	        } while (skipping);
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return skipSequence;
	  }
	
	
	  function concatFactory(iterable, values) {
	    var isKeyedIterable = isKeyed(iterable);
	    var iters = [iterable].concat(values).map(function(v ) {
	      if (!isIterable(v)) {
	        v = isKeyedIterable ?
	          keyedSeqFromValue(v) :
	          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
	      } else if (isKeyedIterable) {
	        v = KeyedIterable(v);
	      }
	      return v;
	    }).filter(function(v ) {return v.size !== 0});
	
	    if (iters.length === 0) {
	      return iterable;
	    }
	
	    if (iters.length === 1) {
	      var singleton = iters[0];
	      if (singleton === iterable ||
	          isKeyedIterable && isKeyed(singleton) ||
	          isIndexed(iterable) && isIndexed(singleton)) {
	        return singleton;
	      }
	    }
	
	    var concatSeq = new ArraySeq(iters);
	    if (isKeyedIterable) {
	      concatSeq = concatSeq.toKeyedSeq();
	    } else if (!isIndexed(iterable)) {
	      concatSeq = concatSeq.toSetSeq();
	    }
	    concatSeq = concatSeq.flatten(true);
	    concatSeq.size = iters.reduce(
	      function(sum, seq)  {
	        if (sum !== undefined) {
	          var size = seq.size;
	          if (size !== undefined) {
	            return sum + size;
	          }
	        }
	      },
	      0
	    );
	    return concatSeq;
	  }
	
	
	  function flattenFactory(iterable, depth, useKeys) {
	    var flatSequence = makeSequence(iterable);
	    flatSequence.__iterateUncached = function(fn, reverse) {
	      var iterations = 0;
	      var stopped = false;
	      function flatDeep(iter, currentDepth) {var this$0 = this;
	        iter.__iterate(function(v, k)  {
	          if ((!depth || currentDepth < depth) && isIterable(v)) {
	            flatDeep(v, currentDepth + 1);
	          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
	            stopped = true;
	          }
	          return !stopped;
	        }, reverse);
	      }
	      flatDeep(iterable, 0);
	      return iterations;
	    }
	    flatSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(type, reverse);
	      var stack = [];
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (iterator) {
	          var step = iterator.next();
	          if (step.done !== false) {
	            iterator = stack.pop();
	            continue;
	          }
	          var v = step.value;
	          if (type === ITERATE_ENTRIES) {
	            v = v[1];
	          }
	          if ((!depth || stack.length < depth) && isIterable(v)) {
	            stack.push(iterator);
	            iterator = v.__iterator(type, reverse);
	          } else {
	            return useKeys ? step : iteratorValue(type, iterations++, v, step);
	          }
	        }
	        return iteratorDone();
	      });
	    }
	    return flatSequence;
	  }
	
	
	  function flatMapFactory(iterable, mapper, context) {
	    var coerce = iterableClass(iterable);
	    return iterable.toSeq().map(
	      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
	    ).flatten(true);
	  }
	
	
	  function interposeFactory(iterable, separator) {
	    var interposedSequence = makeSequence(iterable);
	    interposedSequence.size = iterable.size && iterable.size * 2 -1;
	    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k) 
	        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
	        fn(v, iterations++, this$0) !== false},
	        reverse
	      );
	      return iterations;
	    };
	    interposedSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      var step;
	      return new Iterator(function()  {
	        if (!step || iterations % 2) {
	          step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	        }
	        return iterations % 2 ?
	          iteratorValue(type, iterations++, separator) :
	          iteratorValue(type, iterations++, step.value, step);
	      });
	    };
	    return interposedSequence;
	  }
	
	
	  function sortFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    var isKeyedIterable = isKeyed(iterable);
	    var index = 0;
	    var entries = iterable.toSeq().map(
	      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
	    ).toArray();
	    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
	      isKeyedIterable ?
	      function(v, i)  { entries[i].length = 2; } :
	      function(v, i)  { entries[i] = v[1]; }
	    );
	    return isKeyedIterable ? KeyedSeq(entries) :
	      isIndexed(iterable) ? IndexedSeq(entries) :
	      SetSeq(entries);
	  }
	
	
	  function maxFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    if (mapper) {
	      var entry = iterable.toSeq()
	        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
	        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
	      return entry && entry[0];
	    } else {
	      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
	    }
	  }
	
	  function maxCompare(comparator, a, b) {
	    var comp = comparator(b, a);
	    // b is considered the new max if the comparator declares them equal, but
	    // they are not equal and b is in fact a nullish value.
	    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
	  }
	
	
	  function zipWithFactory(keyIter, zipper, iters) {
	    var zipSequence = makeSequence(keyIter);
	    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
	    // Note: this a generic base implementation of __iterate in terms of
	    // __iterator which may be more generically useful in the future.
	    zipSequence.__iterate = function(fn, reverse) {
	      /* generic:
	      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        iterations++;
	        if (fn(step.value[1], step.value[0], this) === false) {
	          break;
	        }
	      }
	      return iterations;
	      */
	      // indexed:
	      var iterator = this.__iterator(ITERATE_VALUES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        if (fn(step.value, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	    zipSequence.__iteratorUncached = function(type, reverse) {
	      var iterators = iters.map(function(i )
	        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
	      );
	      var iterations = 0;
	      var isDone = false;
	      return new Iterator(function()  {
	        var steps;
	        if (!isDone) {
	          steps = iterators.map(function(i ) {return i.next()});
	          isDone = steps.some(function(s ) {return s.done});
	        }
	        if (isDone) {
	          return iteratorDone();
	        }
	        return iteratorValue(
	          type,
	          iterations++,
	          zipper.apply(null, steps.map(function(s ) {return s.value}))
	        );
	      });
	    };
	    return zipSequence
	  }
	
	
	  // #pragma Helper Functions
	
	  function reify(iter, seq) {
	    return isSeq(iter) ? seq : iter.constructor(seq);
	  }
	
	  function validateEntry(entry) {
	    if (entry !== Object(entry)) {
	      throw new TypeError('Expected [K, V] tuple: ' + entry);
	    }
	  }
	
	  function resolveSize(iter) {
	    assertNotInfinite(iter.size);
	    return ensureSize(iter);
	  }
	
	  function iterableClass(iterable) {
	    return isKeyed(iterable) ? KeyedIterable :
	      isIndexed(iterable) ? IndexedIterable :
	      SetIterable;
	  }
	
	  function makeSequence(iterable) {
	    return Object.create(
	      (
	        isKeyed(iterable) ? KeyedSeq :
	        isIndexed(iterable) ? IndexedSeq :
	        SetSeq
	      ).prototype
	    );
	  }
	
	  function cacheResultThrough() {
	    if (this._iter.cacheResult) {
	      this._iter.cacheResult();
	      this.size = this._iter.size;
	      return this;
	    } else {
	      return Seq.prototype.cacheResult.call(this);
	    }
	  }
	
	  function defaultComparator(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	  }
	
	  function forceIterator(keyPath) {
	    var iter = getIterator(keyPath);
	    if (!iter) {
	      // Array might not be iterable in this environment, so we need a fallback
	      // to our wrapped type.
	      if (!isArrayLike(keyPath)) {
	        throw new TypeError('Expected iterable or array-like: ' + keyPath);
	      }
	      iter = getIterator(Iterable(keyPath));
	    }
	    return iter;
	  }
	
	  createClass(Record, KeyedCollection);
	
	    function Record(defaultValues, name) {
	      var hasInitialized;
	
	      var RecordType = function Record(values) {
	        if (values instanceof RecordType) {
	          return values;
	        }
	        if (!(this instanceof RecordType)) {
	          return new RecordType(values);
	        }
	        if (!hasInitialized) {
	          hasInitialized = true;
	          var keys = Object.keys(defaultValues);
	          setProps(RecordTypePrototype, keys);
	          RecordTypePrototype.size = keys.length;
	          RecordTypePrototype._name = name;
	          RecordTypePrototype._keys = keys;
	          RecordTypePrototype._defaultValues = defaultValues;
	        }
	        this._map = Map(values);
	      };
	
	      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
	      RecordTypePrototype.constructor = RecordType;
	
	      return RecordType;
	    }
	
	    Record.prototype.toString = function() {
	      return this.__toString(recordName(this) + ' {', '}');
	    };
	
	    // @pragma Access
	
	    Record.prototype.has = function(k) {
	      return this._defaultValues.hasOwnProperty(k);
	    };
	
	    Record.prototype.get = function(k, notSetValue) {
	      if (!this.has(k)) {
	        return notSetValue;
	      }
	      var defaultVal = this._defaultValues[k];
	      return this._map ? this._map.get(k, defaultVal) : defaultVal;
	    };
	
	    // @pragma Modification
	
	    Record.prototype.clear = function() {
	      if (this.__ownerID) {
	        this._map && this._map.clear();
	        return this;
	      }
	      var RecordType = this.constructor;
	      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
	    };
	
	    Record.prototype.set = function(k, v) {
	      if (!this.has(k)) {
	        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
	      }
	      var newMap = this._map && this._map.set(k, v);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.remove = function(k) {
	      if (!this.has(k)) {
	        return this;
	      }
	      var newMap = this._map && this._map.remove(k);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
	    };
	
	    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
	    };
	
	    Record.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map && this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return makeRecord(this, newMap, ownerID);
	    };
	
	
	  var RecordPrototype = Record.prototype;
	  RecordPrototype[DELETE] = RecordPrototype.remove;
	  RecordPrototype.deleteIn =
	  RecordPrototype.removeIn = MapPrototype.removeIn;
	  RecordPrototype.merge = MapPrototype.merge;
	  RecordPrototype.mergeWith = MapPrototype.mergeWith;
	  RecordPrototype.mergeIn = MapPrototype.mergeIn;
	  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
	  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
	  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  RecordPrototype.setIn = MapPrototype.setIn;
	  RecordPrototype.update = MapPrototype.update;
	  RecordPrototype.updateIn = MapPrototype.updateIn;
	  RecordPrototype.withMutations = MapPrototype.withMutations;
	  RecordPrototype.asMutable = MapPrototype.asMutable;
	  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
	  function makeRecord(likeRecord, map, ownerID) {
	    var record = Object.create(Object.getPrototypeOf(likeRecord));
	    record._map = map;
	    record.__ownerID = ownerID;
	    return record;
	  }
	
	  function recordName(record) {
	    return record._name || record.constructor.name || 'Record';
	  }
	
	  function setProps(prototype, names) {
	    try {
	      names.forEach(setProp.bind(undefined, prototype));
	    } catch (error) {
	      // Object.defineProperty failed. Probably IE8.
	    }
	  }
	
	  function setProp(prototype, name) {
	    Object.defineProperty(prototype, name, {
	      get: function() {
	        return this.get(name);
	      },
	      set: function(value) {
	        invariant(this.__ownerID, 'Cannot set on an immutable record.');
	        this.set(name, value);
	      }
	    });
	  }
	
	  createClass(Set, SetCollection);
	
	    // @pragma Construction
	
	    function Set(value) {
	      return value === null || value === undefined ? emptySet() :
	        isSet(value) && !isOrdered(value) ? value :
	        emptySet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    Set.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Set.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    Set.prototype.toString = function() {
	      return this.__toString('Set {', '}');
	    };
	
	    // @pragma Access
	
	    Set.prototype.has = function(value) {
	      return this._map.has(value);
	    };
	
	    // @pragma Modification
	
	    Set.prototype.add = function(value) {
	      return updateSet(this, this._map.set(value, true));
	    };
	
	    Set.prototype.remove = function(value) {
	      return updateSet(this, this._map.remove(value));
	    };
	
	    Set.prototype.clear = function() {
	      return updateSet(this, this._map.clear());
	    };
	
	    // @pragma Composition
	
	    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
	      iters = iters.filter(function(x ) {return x.size !== 0});
	      if (iters.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
	        return this.constructor(iters[0]);
	      }
	      return this.withMutations(function(set ) {
	        for (var ii = 0; ii < iters.length; ii++) {
	          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
	        }
	      });
	    };
	
	    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (!iters.every(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (iters.some(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.merge = function() {
	      return this.union.apply(this, arguments);
	    };
	
	    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return this.union.apply(this, iters);
	    };
	
	    Set.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator));
	    };
	
	    Set.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator, mapper));
	    };
	
	    Set.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
	    };
	
	    Set.prototype.__iterator = function(type, reverse) {
	      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
	    };
	
	    Set.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return this.__make(newMap, ownerID);
	    };
	
	
	  function isSet(maybeSet) {
	    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
	  }
	
	  Set.isSet = isSet;
	
	  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
	  var SetPrototype = Set.prototype;
	  SetPrototype[IS_SET_SENTINEL] = true;
	  SetPrototype[DELETE] = SetPrototype.remove;
	  SetPrototype.mergeDeep = SetPrototype.merge;
	  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
	  SetPrototype.withMutations = MapPrototype.withMutations;
	  SetPrototype.asMutable = MapPrototype.asMutable;
	  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
	  SetPrototype.__empty = emptySet;
	  SetPrototype.__make = makeSet;
	
	  function updateSet(set, newMap) {
	    if (set.__ownerID) {
	      set.size = newMap.size;
	      set._map = newMap;
	      return set;
	    }
	    return newMap === set._map ? set :
	      newMap.size === 0 ? set.__empty() :
	      set.__make(newMap);
	  }
	
	  function makeSet(map, ownerID) {
	    var set = Object.create(SetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_SET;
	  function emptySet() {
	    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
	  }
	
	  createClass(OrderedSet, Set);
	
	    // @pragma Construction
	
	    function OrderedSet(value) {
	      return value === null || value === undefined ? emptyOrderedSet() :
	        isOrderedSet(value) ? value :
	        emptyOrderedSet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    OrderedSet.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedSet.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    OrderedSet.prototype.toString = function() {
	      return this.__toString('OrderedSet {', '}');
	    };
	
	
	  function isOrderedSet(maybeOrderedSet) {
	    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
	  }
	
	  OrderedSet.isOrderedSet = isOrderedSet;
	
	  var OrderedSetPrototype = OrderedSet.prototype;
	  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
	  OrderedSetPrototype.__empty = emptyOrderedSet;
	  OrderedSetPrototype.__make = makeOrderedSet;
	
	  function makeOrderedSet(map, ownerID) {
	    var set = Object.create(OrderedSetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_ORDERED_SET;
	  function emptyOrderedSet() {
	    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
	  }
	
	  createClass(Stack, IndexedCollection);
	
	    // @pragma Construction
	
	    function Stack(value) {
	      return value === null || value === undefined ? emptyStack() :
	        isStack(value) ? value :
	        emptyStack().unshiftAll(value);
	    }
	
	    Stack.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Stack.prototype.toString = function() {
	      return this.__toString('Stack [', ']');
	    };
	
	    // @pragma Access
	
	    Stack.prototype.get = function(index, notSetValue) {
	      var head = this._head;
	      index = wrapIndex(this, index);
	      while (head && index--) {
	        head = head.next;
	      }
	      return head ? head.value : notSetValue;
	    };
	
	    Stack.prototype.peek = function() {
	      return this._head && this._head.value;
	    };
	
	    // @pragma Modification
	
	    Stack.prototype.push = function(/*...values*/) {
	      if (arguments.length === 0) {
	        return this;
	      }
	      var newSize = this.size + arguments.length;
	      var head = this._head;
	      for (var ii = arguments.length - 1; ii >= 0; ii--) {
	        head = {
	          value: arguments[ii],
	          next: head
	        };
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pushAll = function(iter) {
	      iter = IndexedIterable(iter);
	      if (iter.size === 0) {
	        return this;
	      }
	      assertNotInfinite(iter.size);
	      var newSize = this.size;
	      var head = this._head;
	      iter.reverse().forEach(function(value ) {
	        newSize++;
	        head = {
	          value: value,
	          next: head
	        };
	      });
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pop = function() {
	      return this.slice(1);
	    };
	
	    Stack.prototype.unshift = function(/*...values*/) {
	      return this.push.apply(this, arguments);
	    };
	
	    Stack.prototype.unshiftAll = function(iter) {
	      return this.pushAll(iter);
	    };
	
	    Stack.prototype.shift = function() {
	      return this.pop.apply(this, arguments);
	    };
	
	    Stack.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._head = undefined;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyStack();
	    };
	
	    Stack.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      var resolvedBegin = resolveBegin(begin, this.size);
	      var resolvedEnd = resolveEnd(end, this.size);
	      if (resolvedEnd !== this.size) {
	        // super.slice(begin, end);
	        return IndexedCollection.prototype.slice.call(this, begin, end);
	      }
	      var newSize = this.size - resolvedBegin;
	      var head = this._head;
	      while (resolvedBegin--) {
	        head = head.next;
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    // @pragma Mutability
	
	    Stack.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeStack(this.size, this._head, ownerID, this.__hash);
	    };
	
	    // @pragma Iteration
	
	    Stack.prototype.__iterate = function(fn, reverse) {
	      if (reverse) {
	        return this.reverse().__iterate(fn);
	      }
	      var iterations = 0;
	      var node = this._head;
	      while (node) {
	        if (fn(node.value, iterations++, this) === false) {
	          break;
	        }
	        node = node.next;
	      }
	      return iterations;
	    };
	
	    Stack.prototype.__iterator = function(type, reverse) {
	      if (reverse) {
	        return this.reverse().__iterator(type);
	      }
	      var iterations = 0;
	      var node = this._head;
	      return new Iterator(function()  {
	        if (node) {
	          var value = node.value;
	          node = node.next;
	          return iteratorValue(type, iterations++, value);
	        }
	        return iteratorDone();
	      });
	    };
	
	
	  function isStack(maybeStack) {
	    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
	  }
	
	  Stack.isStack = isStack;
	
	  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
	  var StackPrototype = Stack.prototype;
	  StackPrototype[IS_STACK_SENTINEL] = true;
	  StackPrototype.withMutations = MapPrototype.withMutations;
	  StackPrototype.asMutable = MapPrototype.asMutable;
	  StackPrototype.asImmutable = MapPrototype.asImmutable;
	  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	  function makeStack(size, head, ownerID, hash) {
	    var map = Object.create(StackPrototype);
	    map.size = size;
	    map._head = head;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_STACK;
	  function emptyStack() {
	    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
	  }
	
	  /**
	   * Contributes additional methods to a constructor
	   */
	  function mixin(ctor, methods) {
	    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
	    Object.keys(methods).forEach(keyCopier);
	    Object.getOwnPropertySymbols &&
	      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
	    return ctor;
	  }
	
	  Iterable.Iterator = Iterator;
	
	  mixin(Iterable, {
	
	    // ### Conversion to other types
	
	    toArray: function() {
	      assertNotInfinite(this.size);
	      var array = new Array(this.size || 0);
	      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
	      return array;
	    },
	
	    toIndexedSeq: function() {
	      return new ToIndexedSequence(this);
	    },
	
	    toJS: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
	      ).__toJS();
	    },
	
	    toJSON: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
	      ).__toJS();
	    },
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, true);
	    },
	
	    toMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Map(this.toKeyedSeq());
	    },
	
	    toObject: function() {
	      assertNotInfinite(this.size);
	      var object = {};
	      this.__iterate(function(v, k)  { object[k] = v; });
	      return object;
	    },
	
	    toOrderedMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedMap(this.toKeyedSeq());
	    },
	
	    toOrderedSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Set(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSetSeq: function() {
	      return new ToSetSequence(this);
	    },
	
	    toSeq: function() {
	      return isIndexed(this) ? this.toIndexedSeq() :
	        isKeyed(this) ? this.toKeyedSeq() :
	        this.toSetSeq();
	    },
	
	    toStack: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Stack(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toList: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return List(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	
	    // ### Common JavaScript methods and properties
	
	    toString: function() {
	      return '[Iterable]';
	    },
	
	    __toString: function(head, tail) {
	      if (this.size === 0) {
	        return head + tail;
	      }
	      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    concat: function() {var values = SLICE$0.call(arguments, 0);
	      return reify(this, concatFactory(this, values));
	    },
	
	    includes: function(searchValue) {
	      return this.some(function(value ) {return is(value, searchValue)});
	    },
	
	    entries: function() {
	      return this.__iterator(ITERATE_ENTRIES);
	    },
	
	    every: function(predicate, context) {
	      assertNotInfinite(this.size);
	      var returnValue = true;
	      this.__iterate(function(v, k, c)  {
	        if (!predicate.call(context, v, k, c)) {
	          returnValue = false;
	          return false;
	        }
	      });
	      return returnValue;
	    },
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, true));
	    },
	
	    find: function(predicate, context, notSetValue) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[1] : notSetValue;
	    },
	
	    findEntry: function(predicate, context) {
	      var found;
	      this.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          found = [k, v];
	          return false;
	        }
	      });
	      return found;
	    },
	
	    findLastEntry: function(predicate, context) {
	      return this.toSeq().reverse().findEntry(predicate, context);
	    },
	
	    forEach: function(sideEffect, context) {
	      assertNotInfinite(this.size);
	      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
	    },
	
	    join: function(separator) {
	      assertNotInfinite(this.size);
	      separator = separator !== undefined ? '' + separator : ',';
	      var joined = '';
	      var isFirst = true;
	      this.__iterate(function(v ) {
	        isFirst ? (isFirst = false) : (joined += separator);
	        joined += v !== null && v !== undefined ? v.toString() : '';
	      });
	      return joined;
	    },
	
	    keys: function() {
	      return this.__iterator(ITERATE_KEYS);
	    },
	
	    map: function(mapper, context) {
	      return reify(this, mapFactory(this, mapper, context));
	    },
	
	    reduce: function(reducer, initialReduction, context) {
	      assertNotInfinite(this.size);
	      var reduction;
	      var useFirst;
	      if (arguments.length < 2) {
	        useFirst = true;
	      } else {
	        reduction = initialReduction;
	      }
	      this.__iterate(function(v, k, c)  {
	        if (useFirst) {
	          useFirst = false;
	          reduction = v;
	        } else {
	          reduction = reducer.call(context, reduction, v, k, c);
	        }
	      });
	      return reduction;
	    },
	
	    reduceRight: function(reducer, initialReduction, context) {
	      var reversed = this.toKeyedSeq().reverse();
	      return reversed.reduce.apply(reversed, arguments);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, true));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, true));
	    },
	
	    some: function(predicate, context) {
	      return !this.every(not(predicate), context);
	    },
	
	    sort: function(comparator) {
	      return reify(this, sortFactory(this, comparator));
	    },
	
	    values: function() {
	      return this.__iterator(ITERATE_VALUES);
	    },
	
	
	    // ### More sequential methods
	
	    butLast: function() {
	      return this.slice(0, -1);
	    },
	
	    isEmpty: function() {
	      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
	    },
	
	    count: function(predicate, context) {
	      return ensureSize(
	        predicate ? this.toSeq().filter(predicate, context) : this
	      );
	    },
	
	    countBy: function(grouper, context) {
	      return countByFactory(this, grouper, context);
	    },
	
	    equals: function(other) {
	      return deepEqual(this, other);
	    },
	
	    entrySeq: function() {
	      var iterable = this;
	      if (iterable._cache) {
	        // We cache as an entries array, so we can just return the cache!
	        return new ArraySeq(iterable._cache);
	      }
	      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
	      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
	      return entriesSequence;
	    },
	
	    filterNot: function(predicate, context) {
	      return this.filter(not(predicate), context);
	    },
	
	    findLast: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
	    },
	
	    first: function() {
	      return this.find(returnTrue);
	    },
	
	    flatMap: function(mapper, context) {
	      return reify(this, flatMapFactory(this, mapper, context));
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, true));
	    },
	
	    fromEntrySeq: function() {
	      return new FromEntriesSequence(this);
	    },
	
	    get: function(searchKey, notSetValue) {
	      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
	    },
	
	    getIn: function(searchKeyPath, notSetValue) {
	      var nested = this;
	      // Note: in an ES6 environment, we would prefer:
	      // for (var key of searchKeyPath) {
	      var iter = forceIterator(searchKeyPath);
	      var step;
	      while (!(step = iter.next()).done) {
	        var key = step.value;
	        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
	        if (nested === NOT_SET) {
	          return notSetValue;
	        }
	      }
	      return nested;
	    },
	
	    groupBy: function(grouper, context) {
	      return groupByFactory(this, grouper, context);
	    },
	
	    has: function(searchKey) {
	      return this.get(searchKey, NOT_SET) !== NOT_SET;
	    },
	
	    hasIn: function(searchKeyPath) {
	      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
	    },
	
	    isSubset: function(iter) {
	      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
	      return this.every(function(value ) {return iter.includes(value)});
	    },
	
	    isSuperset: function(iter) {
	      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
	      return iter.isSubset(this);
	    },
	
	    keySeq: function() {
	      return this.toSeq().map(keyMapper).toIndexedSeq();
	    },
	
	    last: function() {
	      return this.toSeq().reverse().first();
	    },
	
	    max: function(comparator) {
	      return maxFactory(this, comparator);
	    },
	
	    maxBy: function(mapper, comparator) {
	      return maxFactory(this, comparator, mapper);
	    },
	
	    min: function(comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
	    },
	
	    minBy: function(mapper, comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
	    },
	
	    rest: function() {
	      return this.slice(1);
	    },
	
	    skip: function(amount) {
	      return this.slice(Math.max(0, amount));
	    },
	
	    skipLast: function(amount) {
	      return reify(this, this.toSeq().reverse().skip(amount).reverse());
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, true));
	    },
	
	    skipUntil: function(predicate, context) {
	      return this.skipWhile(not(predicate), context);
	    },
	
	    sortBy: function(mapper, comparator) {
	      return reify(this, sortFactory(this, comparator, mapper));
	    },
	
	    take: function(amount) {
	      return this.slice(0, Math.max(0, amount));
	    },
	
	    takeLast: function(amount) {
	      return reify(this, this.toSeq().reverse().take(amount).reverse());
	    },
	
	    takeWhile: function(predicate, context) {
	      return reify(this, takeWhileFactory(this, predicate, context));
	    },
	
	    takeUntil: function(predicate, context) {
	      return this.takeWhile(not(predicate), context);
	    },
	
	    valueSeq: function() {
	      return this.toIndexedSeq();
	    },
	
	
	    // ### Hashable Object
	
	    hashCode: function() {
	      return this.__hash || (this.__hash = hashIterable(this));
	    }
	
	
	    // ### Internal
	
	    // abstract __iterate(fn, reverse)
	
	    // abstract __iterator(type, reverse)
	  });
	
	  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  var IterablePrototype = Iterable.prototype;
	  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
	  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
	  IterablePrototype.__toJS = IterablePrototype.toArray;
	  IterablePrototype.__toStringMapper = quoteString;
	  IterablePrototype.inspect =
	  IterablePrototype.toSource = function() { return this.toString(); };
	  IterablePrototype.chain = IterablePrototype.flatMap;
	  IterablePrototype.contains = IterablePrototype.includes;
	
	  // Temporary warning about using length
	  (function () {
	    try {
	      Object.defineProperty(IterablePrototype, 'length', {
	        get: function () {
	          if (!Iterable.noLengthWarning) {
	            var stack;
	            try {
	              throw new Error();
	            } catch (error) {
	              stack = error.stack;
	            }
	            if (stack.indexOf('_wrapObject') === -1) {
	              console && console.warn && console.warn(
	                'iterable.length has been deprecated, '+
	                'use iterable.size or iterable.count(). '+
	                'This warning will become a silent error in a future version. ' +
	                stack
	              );
	              return this.size;
	            }
	          }
	        }
	      });
	    } catch (e) {}
	  })();
	
	
	
	  mixin(KeyedIterable, {
	
	    // ### More sequential methods
	
	    flip: function() {
	      return reify(this, flipFactory(this));
	    },
	
	    findKey: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry && entry[0];
	    },
	
	    findLastKey: function(predicate, context) {
	      return this.toSeq().reverse().findKey(predicate, context);
	    },
	
	    keyOf: function(searchValue) {
	      return this.findKey(function(value ) {return is(value, searchValue)});
	    },
	
	    lastKeyOf: function(searchValue) {
	      return this.findLastKey(function(value ) {return is(value, searchValue)});
	    },
	
	    mapEntries: function(mapper, context) {var this$0 = this;
	      var iterations = 0;
	      return reify(this,
	        this.toSeq().map(
	          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
	        ).fromEntrySeq()
	      );
	    },
	
	    mapKeys: function(mapper, context) {var this$0 = this;
	      return reify(this,
	        this.toSeq().flip().map(
	          function(k, v)  {return mapper.call(context, k, v, this$0)}
	        ).flip()
	      );
	    }
	
	  });
	
	  var KeyedIterablePrototype = KeyedIterable.prototype;
	  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
	  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
	  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
	  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
	  mixin(IndexedIterable, {
	
	    // ### Conversion to other types
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, false);
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, false));
	    },
	
	    findIndex: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    indexOf: function(searchValue) {
	      var key = this.toKeyedSeq().keyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    lastIndexOf: function(searchValue) {
	      var key = this.toKeyedSeq().reverse().keyOf(searchValue);
	      return key === undefined ? -1 : key;
	
	      // var index =
	      // return this.toSeq().reverse().indexOf(searchValue);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, false));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, false));
	    },
	
	    splice: function(index, removeNum /*, ...values*/) {
	      var numArgs = arguments.length;
	      removeNum = Math.max(removeNum | 0, 0);
	      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
	        return this;
	      }
	      // If index is negative, it should resolve relative to the size of the
	      // collection. However size may be expensive to compute if not cached, so
	      // only call count() if the number is in fact negative.
	      index = resolveBegin(index, index < 0 ? this.count() : this.size);
	      var spliced = this.slice(0, index);
	      return reify(
	        this,
	        numArgs === 1 ?
	          spliced :
	          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
	      );
	    },
	
	
	    // ### More collection methods
	
	    findLastIndex: function(predicate, context) {
	      var key = this.toKeyedSeq().findLastKey(predicate, context);
	      return key === undefined ? -1 : key;
	    },
	
	    first: function() {
	      return this.get(0);
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, false));
	    },
	
	    get: function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      return (index < 0 || (this.size === Infinity ||
	          (this.size !== undefined && index > this.size))) ?
	        notSetValue :
	        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
	    },
	
	    has: function(index) {
	      index = wrapIndex(this, index);
	      return index >= 0 && (this.size !== undefined ?
	        this.size === Infinity || index < this.size :
	        this.indexOf(index) !== -1
	      );
	    },
	
	    interpose: function(separator) {
	      return reify(this, interposeFactory(this, separator));
	    },
	
	    interleave: function(/*...iterables*/) {
	      var iterables = [this].concat(arrCopy(arguments));
	      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
	      var interleaved = zipped.flatten(true);
	      if (zipped.size) {
	        interleaved.size = zipped.size * iterables.length;
	      }
	      return reify(this, interleaved);
	    },
	
	    last: function() {
	      return this.get(-1);
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, false));
	    },
	
	    zip: function(/*, ...iterables */) {
	      var iterables = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, iterables));
	    },
	
	    zipWith: function(zipper/*, ...iterables */) {
	      var iterables = arrCopy(arguments);
	      iterables[0] = this;
	      return reify(this, zipWithFactory(this, zipper, iterables));
	    }
	
	  });
	
	  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
	  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
	  mixin(SetIterable, {
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    get: function(value, notSetValue) {
	      return this.has(value) ? value : notSetValue;
	    },
	
	    includes: function(value) {
	      return this.has(value);
	    },
	
	
	    // ### More sequential methods
	
	    keySeq: function() {
	      return this.valueSeq();
	    }
	
	  });
	
	  SetIterable.prototype.has = IterablePrototype.includes;
	
	
	  // Mixin subclasses
	
	  mixin(KeyedSeq, KeyedIterable.prototype);
	  mixin(IndexedSeq, IndexedIterable.prototype);
	  mixin(SetSeq, SetIterable.prototype);
	
	  mixin(KeyedCollection, KeyedIterable.prototype);
	  mixin(IndexedCollection, IndexedIterable.prototype);
	  mixin(SetCollection, SetIterable.prototype);
	
	
	  // #pragma Helper functions
	
	  function keyMapper(v, k) {
	    return k;
	  }
	
	  function entryMapper(v, k) {
	    return [k, v];
	  }
	
	  function not(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    }
	  }
	
	  function neg(predicate) {
	    return function() {
	      return -predicate.apply(this, arguments);
	    }
	  }
	
	  function quoteString(value) {
	    return typeof value === 'string' ? JSON.stringify(value) : value;
	  }
	
	  function defaultZipper() {
	    return arrCopy(arguments);
	  }
	
	  function defaultNegComparator(a, b) {
	    return a < b ? 1 : a > b ? -1 : 0;
	  }
	
	  function hashIterable(iterable) {
	    if (iterable.size === Infinity) {
	      return 0;
	    }
	    var ordered = isOrdered(iterable);
	    var keyed = isKeyed(iterable);
	    var h = ordered ? 1 : 0;
	    var size = iterable.__iterate(
	      keyed ?
	        ordered ?
	          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
	          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
	        ordered ?
	          function(v ) { h = 31 * h + hash(v) | 0; } :
	          function(v ) { h = h + hash(v) | 0; }
	    );
	    return murmurHashOfSize(size, h);
	  }
	
	  function murmurHashOfSize(size, h) {
	    h = imul(h, 0xCC9E2D51);
	    h = imul(h << 15 | h >>> -15, 0x1B873593);
	    h = imul(h << 13 | h >>> -13, 5);
	    h = (h + 0xE6546B64 | 0) ^ size;
	    h = imul(h ^ h >>> 16, 0x85EBCA6B);
	    h = imul(h ^ h >>> 13, 0xC2B2AE35);
	    h = smi(h ^ h >>> 16);
	    return h;
	  }
	
	  function hashMerge(a, b) {
	    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
	  }
	
	  var Immutable = {
	
	    Iterable: Iterable,
	
	    Seq: Seq,
	    Collection: Collection,
	    Map: Map,
	    OrderedMap: OrderedMap,
	    List: List,
	    Stack: Stack,
	    Set: Set,
	    OrderedSet: OrderedSet,
	
	    Record: Record,
	    Range: Range,
	    Repeat: Repeat,
	
	    is: is,
	    fromJS: fromJS
	
	  };
	
	  return Immutable;
	
	}));

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	var store      = __webpack_require__(257)('wks')
	  , uid        = __webpack_require__(157)
	  , Symbol     = __webpack_require__(15).Symbol
	  , USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function(name){
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	var createHelper = function createHelper(func, helperName) {
	  var setDisplayName = arguments.length <= 2 || arguments[2] === undefined ? true : arguments[2];
	  var noArgs = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
	
	  if (false) {
	    var _ret = function () {
	      /* eslint-disable global-require */
	      var wrapDisplayName = require('./wrapDisplayName').default;
	      /* eslint-enable global-require */
	
	      if (noArgs) {
	        return {
	          v: function v(BaseComponent) {
	            var Component = func(BaseComponent);
	            Component.displayName = wrapDisplayName(BaseComponent, helperName);
	            return Component;
	          }
	        };
	      }
	
	      return {
	        v: function v() {
	          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	          }
	
	          if (args.length > func.length) {
	            /* eslint-disable */
	            console.error(
	            /* eslint-enable */
	            'Too many arguments passed to ' + helperName + '(). It should called ' + ('like so: ' + helperName + '(...args)(BaseComponent).'));
	          }
	
	          return function (BaseComponent) {
	            var Component = func.apply(undefined, args)(BaseComponent);
	            Component.displayName = wrapDisplayName(BaseComponent, helperName);
	            return Component;
	          };
	        }
	      };
	    }();
	
	    if (typeof _ret === "object") return _ret.v;
	  }
	
	  return func;
	};
	
	exports.default = createHelper;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getUserFn = exports.isUserSubscriptionAdmin = exports.isSubscriptionManuallyCreated = exports.isSubscribed = exports.isGuest = exports.isStaff = exports.isAdmin = exports.isOnline = exports.getInitials = exports.getDisplayName = undefined;
	
	var _immutableHelper = __webpack_require__(23);
	
	var _userConstants = __webpack_require__(32);
	
	var getDisplayName = exports.getDisplayName = function getDisplayName(user) {
	    var name = user.getIn(['name', 'displayName']);
	
	    var givenName = user.getIn(['name', 'givenName']);
	    var familyName = user.getIn(['name', 'familyName']);
	    if (!name && givenName) {
	        name = givenName + ' ' + familyName;
	    } else if (!name) {
	        name = user.get('email');
	    } else if (!name) {
	        name = 'Unknown user';
	    }
	
	    return name;
	};
	
	// Constants
	var getInitials = exports.getInitials = function getInitials(user) {
	    var givenName = user.getIn(['name', 'givenName']);
	    var familyName = user.getIn(['name', 'familyName']);
	
	    if (!givenName || !familyName) {
	        return '•••';
	    }
	
	    return givenName[0] + familyName[0];
	};
	
	var isOnline = exports.isOnline = function isOnline(user) {
	    return user && user.get('onlineStatus') === _userConstants.USER_ONLINE_STATUS.CONNECTED;
	};
	
	var isAdmin = exports.isAdmin = function isAdmin(user) {
	    return user && user.get('role') === _userConstants.USER_ROLES.ADMIN;
	};
	
	var isStaff = exports.isStaff = function isStaff(user) {
	    return user && user.get('role') === _userConstants.USER_ROLES.STAFF || isAdmin(user);
	};
	
	var isGuest = exports.isGuest = function isGuest(user) {
	    return !user || user.get('isGuest');
	};
	
	var isSubscribed = exports.isSubscribed = function isSubscribed(user) {
	    return (0, _immutableHelper.propIn)(['subscription', 'active'], user);
	};
	var isSubscriptionManuallyCreated = exports.isSubscriptionManuallyCreated = function isSubscriptionManuallyCreated(user) {
	    return user && user.getIn(['subscription', 'manuallyCreated']);
	};
	var isUserSubscriptionAdmin = exports.isUserSubscriptionAdmin = function isUserSubscriptionAdmin(user, subscription) {
	    return user && subscription && user.get('_id') === subscription.get('adminId');
	};
	
	var getUserFn = exports.getUserFn = function getUserFn(userList) {
	    return function (id) {
	        return userList.get(id);
	    };
	};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CONTENT_LIMIT_PRO_BASE = exports.CONTENT_LIMIT_REFERRAL_MULTIPLIER = exports.CONTENT_LIMIT_FREE_MAX = exports.CONTENT_LIMIT_FREE_BASE = exports.USER_IDLE_TIMEOUT_MILLISECONDS = exports.USER_IDLE_TIMEOUT_SECONDS = exports.SAFE_USER_PROPERTY_WHITELIST = exports.USER_UPDATE_BROADCAST_WHITELIST = exports.DEFAULT_AVATAR_SIZE = exports.GUEST_USER_ID = exports.STARTER_CONTENT_CREATOR_ID = exports.PUBLIC_USER_ID = exports.EMAIL_PREFERENCE_BUFFER_BITS = exports.EMAIL_PREFERENCE_ALL = exports.EMAIL_PREFERENCE_BITS = exports.USER_ONLINE_STATUS = exports.USER_STATUSES = exports.USER_ROLES = exports.USER_DISCONNECT = exports.USER_MARK_AS_DISCONNECTED = exports.USER_CONNECT = exports.USER_NAVIGATE = exports.USER_REFRESH = exports.USER_UPDATE = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var USER_UPDATE = exports.USER_UPDATE = 'USER_UPDATE'; // Lib
	var USER_REFRESH = exports.USER_REFRESH = 'USER_REFRESH';
	var USER_NAVIGATE = exports.USER_NAVIGATE = 'USER_NAVIGATE';
	
	var USER_CONNECT = exports.USER_CONNECT = 'USER_CONNECT';
	var USER_MARK_AS_DISCONNECTED = exports.USER_MARK_AS_DISCONNECTED = 'USER_MARK_AS_DISCONNECTED';
	var USER_DISCONNECT = exports.USER_DISCONNECT = 'USER_DISCONNECT';
	
	var USER_ROLES = exports.USER_ROLES = {
	    USER: 'USER',
	    ADMIN: 'ADMIN',
	    STAFF: 'STAFF',
	    BETA: 'BETA'
	};
	
	var USER_STATUSES = exports.USER_STATUSES = {
	    INVITED: 'INVITED',
	    ACTIVE: 'ACTIVE',
	    LOCKED: 'LOCKED'
	};
	
	var USER_ONLINE_STATUS = exports.USER_ONLINE_STATUS = {
	    CONNECTED: 'CONNECTED',
	    DISCONNECTED: 'DISCONNECTED',
	    IDLE: 'IDLE'
	};
	
	var EMAIL_PREFERENCE_BITS = exports.EMAIL_PREFERENCE_BITS = {
	    PRODUCT_UPDATES: 1,
	    ACTIVITY_DIGEST: 1 << 1,
	    SHARED_BOARDS: 1 << 2
	};
	// Expect to use no more than 8 bits for email preferences
	var EMAIL_PREFERENCE_ALL = exports.EMAIL_PREFERENCE_ALL = (1 << 8) - 1;
	// The buffer bits that we're currently not using but might in the future
	var EMAIL_PREFERENCE_BUFFER_BITS = exports.EMAIL_PREFERENCE_BUFFER_BITS = EMAIL_PREFERENCE_ALL ^ (0, _lodash.sum)((0, _lodash.values)(EMAIL_PREFERENCE_BITS));
	
	var PUBLIC_USER_ID = exports.PUBLIC_USER_ID = '_other';
	var STARTER_CONTENT_CREATOR_ID = exports.STARTER_CONTENT_CREATOR_ID = '_default';
	var GUEST_USER_ID = exports.GUEST_USER_ID = 'guest';
	
	var DEFAULT_AVATAR_SIZE = exports.DEFAULT_AVATAR_SIZE = 30;
	
	var USER_UPDATE_BROADCAST_WHITELIST = exports.USER_UPDATE_BROADCAST_WHITELIST = ['currentBoardId', 'name', 'status', 'image', 'email', 'onlineStatus'];
	var SAFE_USER_PROPERTY_WHITELIST = exports.SAFE_USER_PROPERTY_WHITELIST = ['_id', 'subscription'].concat(USER_UPDATE_BROADCAST_WHITELIST);
	
	// The time that a user can be idle for before being marked as disconnected
	var USER_IDLE_TIMEOUT_SECONDS = exports.USER_IDLE_TIMEOUT_SECONDS = 4 * 60;
	var USER_IDLE_TIMEOUT_MILLISECONDS = exports.USER_IDLE_TIMEOUT_MILLISECONDS = USER_IDLE_TIMEOUT_SECONDS * 1000;
	
	var CONTENT_LIMIT_FREE_BASE = exports.CONTENT_LIMIT_FREE_BASE = 100;
	var CONTENT_LIMIT_FREE_MAX = exports.CONTENT_LIMIT_FREE_MAX = 500;
	
	var CONTENT_LIMIT_REFERRAL_MULTIPLIER = exports.CONTENT_LIMIT_REFERRAL_MULTIPLIER = 20;
	
	// hopefully no-one makes more content that this :P
	var CONTENT_LIMIT_PRO_BASE = exports.CONTENT_LIMIT_PRO_BASE = 9999999999999;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.isUserAvailableSelector = exports.subscriptionAdminUserSelector = exports.subscriptionTeamSelector = exports.currentUserIsSubscriptionAdminSelector = exports.isGuestSelector = exports.getCurrentUserCustomer = exports.getCurrentUserSubscriptionDetail = exports.getCurrentUserSubscription = exports.getCurrentUserRootBoardId = exports.getCurrentUserEmail = exports.getCurrentUserId = exports.getCurrentUser = undefined;
	
	var _reselect = __webpack_require__(7);
	
	var _usersSelector = __webpack_require__(204);
	
	var _userUtil = __webpack_require__(31);
	
	var getCurrentUser = exports.getCurrentUser = function getCurrentUser(state) {
	    return state.getIn(['app', 'currentUser']);
	}; // Lib
	var getCurrentUserId = exports.getCurrentUserId = function getCurrentUserId(state) {
	    return state.getIn(['app', 'currentUser', '_id']);
	};
	var getCurrentUserEmail = exports.getCurrentUserEmail = function getCurrentUserEmail(state) {
	    return state.getIn(['app', 'currentUser', 'email']);
	};
	var getCurrentUserRootBoardId = exports.getCurrentUserRootBoardId = function getCurrentUserRootBoardId(state) {
	    return state.getIn(['app', 'currentUser', 'rootBoardId']);
	};
	
	var getCurrentUserSubscription = exports.getCurrentUserSubscription = function getCurrentUserSubscription(state) {
	    return state.getIn(['app', 'currentUser', 'subscription']);
	};
	var getCurrentUserSubscriptionDetail = exports.getCurrentUserSubscriptionDetail = function getCurrentUserSubscriptionDetail(state) {
	    return state.getIn(['app', 'currentUser', 'subscription', 'detail']);
	};
	var getCurrentUserCustomer = exports.getCurrentUserCustomer = function getCurrentUserCustomer(state) {
	    return state.getIn(['app', 'currentUser', 'customer']);
	};
	
	var isGuestSelector = exports.isGuestSelector = (0, _reselect.createSelector)(getCurrentUser, function (currentUser) {
	    return currentUser.get('isGuest');
	});
	
	var currentUserIsSubscriptionAdminSelector = exports.currentUserIsSubscriptionAdminSelector = (0, _reselect.createSelector)(getCurrentUser, getCurrentUserSubscription, function (currentUser, subscription) {
	    return (0, _userUtil.isUserSubscriptionAdmin)(currentUser, subscription);
	});
	
	var subscriptionTeamSelector = exports.subscriptionTeamSelector = (0, _reselect.createSelector)(getCurrentUserSubscription, _usersSelector.getUsers, function (subscription, users) {
	    var memberIds = subscription && subscription.get('teamMemberIds');
	    if (!memberIds) return null;
	
	    return memberIds.map(function (userId) {
	        return users.get(userId);
	    }).filter(function (user) {
	        return user;
	    });
	});
	
	var subscriptionAdminUserSelector = exports.subscriptionAdminUserSelector = (0, _reselect.createSelector)(getCurrentUserSubscription, _usersSelector.getUsers, function (subscription, users) {
	    if (!users || !subscription) return;
	
	    var adminId = subscription.get('adminId');
	    return users.get(adminId);
	});
	
	var isUserAvailableSelector = exports.isUserAvailableSelector = (0, _reselect.createSelector)(getCurrentUser, isGuestSelector, function (currentUser, isGuest) {
	    return isGuest || currentUser.get('authenticated') && currentUser.get('fetched') || false;
	});

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(553);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = function Button(props) {
	    return _react2.default.createElement(
	        'button',
	        { disabled: props.disabled, className: (0, _classnames2.default)('Button', props.className),
	            type: props.type || 'button',
	            onClick: props.onClickFn },
	        props.children
	    );
	};
	
	Button.propTypes = {
	    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array, _propTypes2.default.string]).isRequired,
	    onClickFn: _propTypes2.default.func,
	    className: _propTypes2.default.string,
	    disabled: _propTypes2.default.bool,
	    type: _propTypes2.default.string
	};
	
	exports.default = Button;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.togglePopup = exports.closePopup = exports.openPopup = undefined;
	
	var _popupConstants = __webpack_require__(140);
	
	var openPopup = exports.openPopup = function openPopup(popupId) {
	    return {
	        type: _popupConstants.POPUP_OPEN,
	        popupId: popupId
	    };
	};
	
	var closePopup = exports.closePopup = function closePopup(popupId) {
	    var closeAll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	    return {
	        type: _popupConstants.POPUP_CLOSE,
	        popupId: popupId,
	        closeAll: closeAll
	    };
	};
	
	var togglePopup = exports.togglePopup = function togglePopup(popupId) {
	    return {
	        type: _popupConstants.POPUP_TOGGLE,
	        popupId: popupId
	    };
	};

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var EMAIL_REGEX = exports.EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line
	/**
	 * Regular expression for matching links (used while pasting text from the clipboard to figure out what kind of
	 * element to create).
	 * From: http://stackoverflow.com/questions/3809401/what-is-a-good-regular-expression-to-match-a-url
	 */
	var URL_REGEX = exports.URL_REGEX = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,256}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g; // eslint-disable-line
	var IP_ADDRESS_REGEX = exports.IP_ADDRESS_REGEX = /(http(s)?:\/\/.)?^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(:\d{2,4})?\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)?$/; // eslint-disable-line
	var LOCALHOST_REGEX = exports.LOCALHOST_REGEX = /localhost:3000/g;
	
	var FIELD_TYPES = exports.FIELD_TYPES = {
	    text: 'text',
	    email: 'email',
	    password: 'password',
	    date: 'date',
	    select: 'select',
	    html: 'html',
	    url: 'url',
	    elementId: 'elementId',
	    object: 'object',
	    objectId: 'objectId'
	};
	
	var FAILURE_TYPES = exports.FAILURE_TYPES = {
	    ERROR: 'ERROR',
	    WARNING: 'WARNING',
	    INFO: 'INFO'
	};
	
	var FAILURE_NAMES = exports.FAILURE_NAMES = {
	    required: 'required',
	    email: 'email',
	    date: 'date',
	    select: 'select',
	    password: 'password',
	    maxlength: 'maxlength',
	    url: 'url',
	    elementId: 'elementId',
	    object: 'object',
	    objectId: 'objectId'
	};
	
	var FIELDS = exports.FIELDS = {
	    givenName: {
	        name: 'givenName',
	        type: FIELD_TYPES.text,
	        required: true,
	        maxLength: 50
	    },
	    familyName: {
	        name: 'familyName',
	        type: FIELD_TYPES.text,
	        required: true,
	        maxLength: 50
	    },
	    email: {
	        name: 'email',
	        type: FIELD_TYPES.email,
	        required: true,
	        maxLength: 255
	    },
	    password: {
	        name: 'password',
	        type: FIELD_TYPES.password,
	        required: true,
	        maxLength: 255
	    },
	    code: {
	        name: 'code',
	        type: FIELD_TYPES.text,
	        required: true,
	        maxLength: 40,
	        minLength: 40
	    }
	};
	
	FIELDS.loginPassword = _extends({}, FIELDS.password, {
	    disableTypeValidation: true
	});
	
	// Login page & route
	var LOGIN_FIELDS = exports.LOGIN_FIELDS = {
	    email: FIELDS.email,
	    password: FIELDS.loginPassword
	};
	
	// Registration page & route
	var REGISTER_FIELDS = exports.REGISTER_FIELDS = {
	    givenName: FIELDS.givenName,
	    familyName: FIELDS.familyName,
	    email: FIELDS.email,
	    password: FIELDS.password,
	    inviteCode: {
	        name: 'inviteCode',
	        type: FIELD_TYPES.text
	    },
	    referrerCode: {
	        name: 'referrerCode',
	        type: FIELD_TYPES.text
	    },
	    marketingReferralCode: {
	        name: 'marketingReferralCode',
	        type: FIELD_TYPES.text
	    }
	};
	
	// Forgotten password page & reset route
	var REQUEST_PASSWORD_RESET_FIELDS = exports.REQUEST_PASSWORD_RESET_FIELDS = {
	    email: FIELDS.email
	};
	
	// Change password page
	var CHANGE_PASSWORD_FIELDS = exports.CHANGE_PASSWORD_FIELDS = {
	    password: FIELDS.password
	};
	
	// Invitaion page & route
	var INVITE_FIELDS = exports.INVITE_FIELDS = {
	    email: FIELDS.email
	};
	
	// Sharing Popup
	var ADD_SHARED_USER_FIELDS = exports.ADD_SHARED_USER_FIELDS = {
	    userEmail: _extends({}, FIELDS.email, {
	        name: 'userEmail',
	        hideBeforeSubmit: true
	    })
	};
	
	var ELEMENT_FIELDS = {
	    id: {
	        name: 'id',
	        type: FIELD_TYPES.elementId,
	        required: true
	    },
	    elementType: {
	        name: 'elementType',
	        type: FIELD_TYPES.select,
	        validValues: ['CARD', 'LINK', 'IMAGE'],
	        required: true
	    },
	    location: {
	        name: 'location',
	        type: FIELD_TYPES.object,
	        keys: [{
	            name: 'parentId',
	            type: FIELD_TYPES.elementId
	        }, {
	            name: 'section',
	            type: FIELD_TYPES.select,
	            validValues: ['CANVAS', 'INBOX']
	        }, {
	            name: 'position',
	            type: FIELD_TYPES.object
	        }]
	    },
	    content: {
	        name: 'content',
	        type: FIELD_TYPES.object,
	        required: true
	    }
	};
	
	// Creating element with HTTP route
	var ELEMENT_CREATE_FIELDS = exports.ELEMENT_CREATE_FIELDS = {
	    elementType: ELEMENT_FIELDS.elementType,
	    content: ELEMENT_FIELDS.content
	};
	
	var ELEMENT_DUPLICATE_FIELDS = exports.ELEMENT_DUPLICATE_FIELDS = {
	    id: _extends({}, ELEMENT_FIELDS.id, {
	        required: false
	    }),
	    location: _extends({}, ELEMENT_FIELDS.location, {
	        required: true
	    })
	};
	
	var ELEMENT_UPDATE_FIELDS = exports.ELEMENT_UPDATE_FIELDS = {
	    elementType: ELEMENT_FIELDS.elementType,
	    content: ELEMENT_FIELDS.content
	};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(19)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(14)
	  , IE8_DOM_DEFINE = __webpack_require__(507)
	  , toPrimitive    = __webpack_require__(99)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(37) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Draft
	 */
	
	'use strict';
	
	var AtomicBlockUtils = __webpack_require__(1051);
	var BlockMapBuilder = __webpack_require__(213);
	var CharacterMetadata = __webpack_require__(94);
	var CompositeDraftDecorator = __webpack_require__(1052);
	var ContentBlock = __webpack_require__(158);
	var ContentState = __webpack_require__(356);
	var DefaultDraftBlockRenderMap = __webpack_require__(357);
	var DefaultDraftInlineStyle = __webpack_require__(533);
	var DraftEditor = __webpack_require__(1054);
	var DraftEditorBlock = __webpack_require__(534);
	var DraftModifier = __webpack_require__(63);
	var DraftEntity = __webpack_require__(117);
	var DraftEntityInstance = __webpack_require__(535);
	var EditorState = __webpack_require__(24);
	var KeyBindingUtil = __webpack_require__(358);
	var RichTextEditorUtil = __webpack_require__(1065);
	var SelectionState = __webpack_require__(182);
	
	var convertFromDraftStateToRaw = __webpack_require__(1070);
	var convertFromHTMLToContentBlocks = __webpack_require__(538);
	var convertFromRawToDraftState = __webpack_require__(1071);
	var generateRandomKey = __webpack_require__(100);
	var getDefaultKeyBinding = __webpack_require__(539);
	var getVisibleSelectionRect = __webpack_require__(1094);
	
	var DraftPublic = {
	  Editor: DraftEditor,
	  EditorBlock: DraftEditorBlock,
	  EditorState: EditorState,
	
	  CompositeDecorator: CompositeDraftDecorator,
	  Entity: DraftEntity,
	  EntityInstance: DraftEntityInstance,
	
	  BlockMapBuilder: BlockMapBuilder,
	  CharacterMetadata: CharacterMetadata,
	  ContentBlock: ContentBlock,
	  ContentState: ContentState,
	  SelectionState: SelectionState,
	
	  AtomicBlockUtils: AtomicBlockUtils,
	  KeyBindingUtil: KeyBindingUtil,
	  Modifier: DraftModifier,
	  RichUtils: RichTextEditorUtil,
	
	  DefaultDraftBlockRenderMap: DefaultDraftBlockRenderMap,
	  DefaultDraftInlineStyle: DefaultDraftInlineStyle,
	
	  convertFromHTML: convertFromHTMLToContentBlocks,
	  convertFromRaw: convertFromRawToDraftState,
	  convertToRaw: convertFromDraftStateToRaw,
	  genKey: generateRandomKey,
	  getDefaultKeyBinding: getDefaultKeyBinding,
	  getVisibleSelectionRect: getVisibleSelectionRect
	};
	
	module.exports = DraftPublic;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var DOMProperty = __webpack_require__(188);
	var ReactDOMComponentFlags = __webpack_require__(608);
	
	var invariant = __webpack_require__(10);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getColourHex = exports.getColourName = exports.elementsResourcesSelector = exports.getElement = exports.getElements = exports.getElementId = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Util
	
	
	var _reselect = __webpack_require__(7);
	
	var _elementHelper = __webpack_require__(13);
	
	var _elementFilterUtil = __webpack_require__(728);
	
	var _resourceSelector = __webpack_require__(472);
	
	var _resourceConstants = __webpack_require__(85);
	
	var _colorHelper = __webpack_require__(319);
	
	var _currentlyEditingSelector = __webpack_require__(233);
	
	var _selectedElementsSelector = __webpack_require__(127);
	
	var _dragModifierKeysSelector = __webpack_require__(759);
	
	var _recompose = __webpack_require__(9);
	
	var _milanoteReselect = __webpack_require__(49);
	
	var getElementId = exports.getElementId = function getElementId(state, ownProps) {
	    return ownProps.elementId || ownProps.element && ownProps.element.get('id');
	};
	var getElements = exports.getElements = function getElements(state) {
	    return state.get('elements');
	};
	var getElement = exports.getElement = function getElement(state, ownProps) {
	    return ownProps.element || getElements(state).get(ownProps.elementId);
	};
	var elementsResourcesSelector = exports.elementsResourcesSelector = (0, _resourceSelector.makeResourceTypeSelector)(_resourceConstants.RESOURCE_TYPES.elements);
	
	// Is editing selector helper methods
	var getIsEditingStateSlice = function getIsEditingStateSlice(state, ownProps) {
	    return {
	        elementId: getElementId(state, ownProps),
	        element: getElement(state, ownProps),
	        elements: getElements(state, ownProps),
	        currentlyEditingId: (0, _currentlyEditingSelector.getCurrentlyEditingId)(state, ownProps),
	        currentEditorKey: (0, _currentlyEditingSelector.getCurrentlyEditingEditorKey)(state, ownProps)
	    };
	};
	var isEditingSelectorEqualityChecker = function isEditingSelectorEqualityChecker(nextStateSlice, prevStateSlice) {
	    if (prevStateSlice.currentlyEditingId === nextStateSlice.currentlyEditingId) {
	        return prevStateSlice.currentEditorKey === nextStateSlice.currentEditorKey;
	    }
	    return (0, _recompose.shallowEqual)(prevStateSlice, nextStateSlice);
	};
	var createCustomIsEditingSelector = (0, _milanoteReselect.createCustomEqualShallowSelector)(isEditingSelectorEqualityChecker);
	
	var isEditingSelector = function isEditingSelector() {
	    return createCustomIsEditingSelector(getIsEditingStateSlice, function (_ref) {
	        var elementId = _ref.elementId,
	            element = _ref.element,
	            elements = _ref.elements,
	            currentlyEditingId = _ref.currentlyEditingId,
	            currentEditorKey = _ref.currentEditorKey;
	
	        var isEditing = false;
	        var isEditingChild = false;
	        var _currentEditorKey = null;
	
	        if (currentlyEditingId) {
	            isEditing = currentlyEditingId === elementId;
	            _currentEditorKey = isEditing ? currentEditorKey : null;
	
	            // Only performing this check if needed (to help improve performance)
	            if (!isEditing && (0, _elementHelper.isContainer)(element)) {
	                isEditingChild = (0, _elementHelper.getChildren)(elements, elementId).reduce(function (found, el) {
	                    return found || el.get('id') === currentlyEditingId;
	                }, false);
	            }
	        }
	
	        return {
	            isEditing: isEditing,
	            isEditingChild: isEditingChild,
	            currentEditorKey: _currentEditorKey
	        };
	    });
	};
	
	var isSelectedSelector = function isSelectedSelector() {
	    return (0, _reselect.createSelector)(getElementId, _selectedElementsSelector.getSelectedElementIds, function (elementId, selectedElementIds) {
	        return selectedElementIds.includes(elementId);
	    });
	};
	
	var isSingleSelectedSelector = function isSingleSelectedSelector() {
	    return (0, _reselect.createSelector)(getElementId, _selectedElementsSelector.getSelectedElementIds, function (elementId, selectedElementIds) {
	        return selectedElementIds.size === 1 && selectedElementIds.includes(elementId);
	    });
	};
	
	var remoteActivitySelector = function remoteActivitySelector() {
	    return (0, _milanoteReselect.createShallowSelector)(getElementId, function (state) {
	        return state.getIn(['remoteActivity', 'selectedElements']);
	    }, function (elementId, remoteElementActivity) {
	        var remoteSelectionData = remoteElementActivity.get(elementId);
	        var isRemotelySelected = remoteSelectionData && !!remoteSelectionData.get('userId');
	
	        return {
	            remoteSelectionData: remoteSelectionData,
	            isRemotelySelected: isRemotelySelected
	        };
	    });
	};
	
	var isLockedSelector = function isLockedSelector() {
	    return function (state, ownProps) {
	        return (0, _elementHelper.isElementLocked)(getElement(state, ownProps));
	    };
	};
	
	var filterSelector = function filterSelector() {
	    return (0, _reselect.createSelector)(getElement, function (state, ownProps) {
	        return ownProps.elementFilter;
	    }, function (element, elementFilter) {
	        if (!elementFilter) return null;
	
	        if ((0, _elementFilterUtil.filterElement)(element, elementFilter)) return 'filter-pass';
	
	        return 'filter-fail';
	    });
	};
	
	var getColourName = exports.getColourName = function getColourName(state, ownProps) {
	    return getElement(state, ownProps).getIn(['content', 'color']);
	};
	
	var getColourHex = exports.getColourHex = (0, _reselect.createSelector)(getColourName, _colorHelper.getColorHexValue);
	
	exports.default = function () {
	    return (0, _reselect.createSelector)(isSelectedSelector(), isSingleSelectedSelector(), remoteActivitySelector(), isEditingSelector(), isLockedSelector(), filterSelector(), _dragModifierKeysSelector.getDragModifierKeys, function (isSelected, isSingleSelected, remoteActivity, isEditing, isLocked, filter, dragModifierKeys) {
	        return _extends({}, isEditing, remoteActivity, {
	            isSingleSelected: isSingleSelected,
	            isSelected: isSelected,
	            isLocked: isLocked,
	            filter: filter,
	            dragModifierKeys: dragModifierKeys
	        });
	    });
	};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.positionPixelsToGridPoints = exports.getNormalisedFontStyle = exports.getElementStyle = exports.calculateFontSize = exports.getGridSizeName = exports.calculateGridSize = exports.gridPointsToPixels = exports.pixelsToGridPoints = undefined;
	
	var _point = __webpack_require__(50);
	
	var pointsLib = _interopRequireWildcard(_point);
	
	var _gridConstants = __webpack_require__(205);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Utils
	var pixelsToGridPoints = exports.pixelsToGridPoints = function pixelsToGridPoints(pixels, gridSize) {
	    return Math.round(pixels / gridSize);
	};
	var gridPointsToPixels = exports.gridPointsToPixels = function gridPointsToPixels(gridPoints, gridSize) {
	    return gridPoints * gridSize;
	};
	
	var getGridSizeForWidth = function getGridSizeForWidth(windowWidth) {
	    return _gridConstants.GRID_SIZE_LIST.reduce(function (currValue, size) {
	        return size.breakpoint > windowWidth ? currValue : size;
	    }, _gridConstants.GRID_SIZE_LIST[0]);
	};
	
	var calculateGridSize = exports.calculateGridSize = function calculateGridSize(windowWidth) {
	    return getGridSizeForWidth(windowWidth);
	};
	
	var getGridSizeName = exports.getGridSizeName = function getGridSizeName(sizeName) {
	    return 'app-size-' + sizeName;
	};
	
	var calculateFontSize = exports.calculateFontSize = function calculateFontSize(gridSize) {
	    return gridSize * _gridConstants.FONT_SIZE_MULTIPLIER;
	};
	
	var getElementStyle = exports.getElementStyle = function getElementStyle(width, gridSize, noSetWidth) {
	    return {
	        width: !noSetWidth ? gridPointsToPixels(width, gridSize) : 'auto'
	    };
	};
	
	var getNormalisedFontStyle = exports.getNormalisedFontStyle = function getNormalisedFontStyle(_ref) {
	    var gridSize = _ref.gridSize,
	        documentMode = _ref.documentMode;
	    return {
	        fontSize: documentMode ? 'inherit' : calculateFontSize(gridSize)
	    };
	};
	
	var positionPixelsToGridPoints = exports.positionPixelsToGridPoints = function positionPixelsToGridPoints(position, gridSize) {
	    return pointsLib.round(pointsLib.scale(1 / gridSize, position));
	};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.isMoreThan = exports.addDays = exports.getDaysSince = exports.getStartOfDayDate = exports.getDateTimezone = exports.getFutureTimestampSeconds = exports.getFutureTimestamp = exports.getTimestampSeconds = exports.getTimestamp = exports.millisToSeconds = exports.TIMES = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _fp = __webpack_require__(52);
	
	var SECOND = 1000;
	var MINUTE = SECOND * 60;
	var HOUR = MINUTE * 60;
	var DAY = HOUR * 24;
	var MONTH = DAY * 31;
	var YEAR = DAY * 365;
	
	var TIMES = exports.TIMES = {
	    SECOND: SECOND,
	    MINUTE: MINUTE,
	    HOUR: HOUR,
	    DAY: DAY,
	    MONTH: MONTH,
	    YEAR: YEAR
	};
	
	var millisToSeconds = exports.millisToSeconds = function millisToSeconds(millis) {
	    return Math.floor(millis / TIMES.SECOND);
	};
	var getTimestamp = exports.getTimestamp = function getTimestamp() {
	    return Date.now();
	};
	var getTimestampSeconds = exports.getTimestampSeconds = (0, _fp.flow)([getTimestamp, millisToSeconds]);
	var getFutureTimestamp = exports.getFutureTimestamp = function getFutureTimestamp(millisInFuture) {
	    return (0, _fp.flow)([getTimestamp, (0, _fp.add)(millisInFuture)]);
	};
	var getFutureTimestampSeconds = exports.getFutureTimestampSeconds = function getFutureTimestampSeconds(millisInFuture) {
	    return (0, _fp.flow)([getFutureTimestamp(millisInFuture), millisToSeconds]);
	};
	
	var getLocalTimezone = (0, _lodash.memoize)(function () {
	    return new Date().getTimezoneOffset();
	});
	
	var getDateTimezone = exports.getDateTimezone = function getDateTimezone(time) {
	    var timezone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getLocalTimezone();
	
	    var localTimezone = getLocalTimezone();
	    var userTimezone = timezone || localTimezone;
	
	    var timezoneModifier = (localTimezone - userTimezone) * TIMES.MINUTE;
	
	    return time + timezoneModifier;
	};
	
	var getStartOfDayDate = exports.getStartOfDayDate = function getStartOfDayDate(date) {
	    var startOfDayDate = new Date(date);
	    startOfDayDate.setUTCHours(0);
	    startOfDayDate.setUTCMinutes(0);
	    startOfDayDate.setUTCSeconds(0);
	    startOfDayDate.setUTCMilliseconds(0);
	    return startOfDayDate;
	};
	
	var getDaysSince = exports.getDaysSince = function getDaysSince(millis1) {
	    var millis2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.now();
	
	    var millis11IsStart = millis1 < millis2;
	    var start = millis11IsStart ? millis1 : millis2;
	    var end = millis11IsStart ? millis2 : millis1;
	    return Math.floor((end - start) / TIMES.DAY);
	};
	
	var addDays = exports.addDays = function addDays(initialDate, daysToAdd) {
	    var updatedDate = new Date(initialDate);
	    updatedDate.setDate(updatedDate.getDate() + daysToAdd);
	    return updatedDate;
	};
	
	var isMoreThan = exports.isMoreThan = function isMoreThan(timeDiff) {
	    return function (dateToTest) {
	        var comparisonDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
	
	        var time1 = comparisonDate.getTime();
	        var time2 = dateToTest.getTime();
	        return Math.abs(time1 - time2) > timeDiff;
	    };
	};

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(132)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.PropTypes = exports.RoutingContext = exports.RouterContext = exports.createRoutes = exports.useRoutes = exports.RouteContext = exports.Lifecycle = exports.History = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(133);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes2 = __webpack_require__(403);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(190);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(1559);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(630);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(1553);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(1572);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(1554);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(1555);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(631);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(1557);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _History2 = __webpack_require__(1552);
	
	var _History3 = _interopRequireDefault(_History2);
	
	var _Lifecycle2 = __webpack_require__(1556);
	
	var _Lifecycle3 = _interopRequireDefault(_Lifecycle2);
	
	var _RouteContext2 = __webpack_require__(1558);
	
	var _RouteContext3 = _interopRequireDefault(_RouteContext2);
	
	var _useRoutes2 = __webpack_require__(1571);
	
	var _useRoutes3 = _interopRequireDefault(_useRoutes2);
	
	var _RouterContext2 = __webpack_require__(283);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _RoutingContext2 = __webpack_require__(1560);
	
	var _RoutingContext3 = _interopRequireDefault(_RoutingContext2);
	
	var _PropTypes3 = _interopRequireDefault(_PropTypes2);
	
	var _match2 = __webpack_require__(1569);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(636);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(1562);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(1563);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(1567);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(633);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* mixins */
	
	exports.History = _History3.default;
	exports.Lifecycle = _Lifecycle3.default;
	exports.RouteContext = _RouteContext3.default;
	
	/* utils */
	
	exports.useRoutes = _useRoutes3.default;
	exports.RouterContext = _RouterContext3.default;
	exports.RoutingContext = _RoutingContext3.default;
	exports.PropTypes = _PropTypes3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(802);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.analyticsEvent = exports.INTERCOM_EVENTS = undefined;
	
	var _analyticsConstants = __webpack_require__(165);
	
	Object.defineProperty(exports, 'INTERCOM_EVENTS', {
	  enumerable: true,
	  get: function get() {
	    return _analyticsConstants.INTERCOM_EVENTS;
	  }
	});
	
	var _intercomService = __webpack_require__(290);
	
	var analyticsEvent = exports.analyticsEvent = _intercomService.intercomTrackEvent;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(4);
	
	exports.default = (0, _lodash.memoize)(function () {
	    if (typeof window !== 'undefined') return window.__clientconf;
	    if (typeof global !== 'undefined') return global.__clientconf;
	    throw new Error('Could not load client config from window or global');
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.createCustomEqualSelector = exports.createCustomEqualShallowSelector = exports.createImmutableShallowSelector = exports.createShallowSelector = exports.defaultMilanoteMemoize = undefined;
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _recompose = __webpack_require__(9);
	
	var _reselect = __webpack_require__(7);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var defaultMilanoteMemoize = exports.defaultMilanoteMemoize = function defaultMilanoteMemoize() {
	    var equalityCheck = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _recompose.shallowEqual;
	    return function (func) {
	        var lastArgs = null;
	        var lastResult = null;
	
	        return function () {
	            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                args[_key] = arguments[_key];
	            }
	
	            if (lastArgs !== null && lastArgs.length === args.length && args.every(function (value, index) {
	                return equalityCheck(value, lastArgs[index]);
	            })) {
	                return lastResult;
	            }
	            var newResult = func.apply(undefined, args);
	            if (!(0, _recompose.shallowEqual)(lastResult, newResult)) {
	                lastResult = newResult;
	            }
	            lastArgs = args;
	            return lastResult;
	        };
	    };
	};
	
	var createShallowSelector = exports.createShallowSelector = (0, _reselect.createSelectorCreator)(defaultMilanoteMemoize());
	var createImmutableShallowSelector = exports.createImmutableShallowSelector = (0, _reselect.createSelectorCreator)(defaultMilanoteMemoize(Immutable.is));
	
	var createCustomEqualShallowSelector = exports.createCustomEqualShallowSelector = function createCustomEqualShallowSelector(equalityCheckFn) {
	    return (0, _reselect.createSelectorCreator)(defaultMilanoteMemoize(equalityCheckFn));
	};
	var createCustomEqualSelector = exports.createCustomEqualSelector = function createCustomEqualSelector(equalityCheckFn) {
	    return (0, _reselect.createSelectorCreator)(_reselect.defaultMemoize, equalityCheckFn);
	};

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.equals = exports.moveFrom = exports.getDistance = exports.round = exports.reverseTranslate = exports.difference = exports.translate = exports.scale = exports.getPoint = undefined;
	
	var _geometry = __webpack_require__(797);
	
	var _geometry2 = _interopRequireDefault(_geometry);
	
	var _geometryUtils = __webpack_require__(796);
	
	var geometryUtils = _interopRequireWildcard(_geometryUtils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Lib
	var getPoint = exports.getPoint = function getPoint(x, y) {
	    return { x: x, y: y };
	};
	
	// Utils
	var scale = exports.scale = geometryUtils.scale;
	var translate = exports.translate = geometryUtils.translate;
	var difference = exports.difference = geometryUtils.difference;
	var reverseTranslate = exports.reverseTranslate = difference;
	var round = exports.round = geometryUtils.roundVals;
	
	var getDistance = exports.getDistance = function getDistance(point1, point2) {
	    var jjsPoint1 = _geometry2.default.point(point1);
	    return jjsPoint1.distance(point2);
	};
	
	var moveFrom = exports.moveFrom = function moveFrom(mobilePoint, staticPoint, distance) {
	    var jjsMobilePoint = _geometry2.default.point(mobilePoint);
	    return geometryUtils.roundUpVals(jjsMobilePoint.move(staticPoint, distance));
	};
	
	var equals = exports.equals = function equals(point1, point2) {
	    return point1.x === point2.x && point1.y === point2.y;
	};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(92);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(1439).runInContext();
	module.exports = __webpack_require__(1432)(_, _);


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createEagerElementUtil = __webpack_require__(645);
	
	var _createEagerElementUtil2 = _interopRequireDefault(_createEagerElementUtil);
	
	var _isReferentiallyTransparentFunctionComponent = __webpack_require__(643);
	
	var _isReferentiallyTransparentFunctionComponent2 = _interopRequireDefault(_isReferentiallyTransparentFunctionComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createFactory = function createFactory(type) {
	  var isReferentiallyTransparent = (0, _isReferentiallyTransparentFunctionComponent2.default)(type);
	  return function (p, c) {
	    return (0, _createEagerElementUtil2.default)(false, isReferentiallyTransparent, type, p, c);
	  };
	};
	
	exports.default = createFactory;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	// Selectors
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CSSTransitionGroup = __webpack_require__(134);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _reactRedux = __webpack_require__(3);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reselect = __webpack_require__(7);
	
	var _PopupPanelMouseManager = __webpack_require__(1926);
	
	var _PopupPanelMouseManager2 = _interopRequireDefault(_PopupPanelMouseManager);
	
	var _gridSizeSelector = __webpack_require__(66);
	
	var _popupActions = __webpack_require__(35);
	
	var _popupConstants = __webpack_require__(140);
	
	__webpack_require__(1178);
	
	__webpack_require__(1179);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PopupPanel = function PopupPanel(props) {
	    var visible = props.visible,
	        className = props.className,
	        arrowDir = props.arrowDir,
	        children = props.children;
	
	    if (!visible) return null;
	
	    return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('PopupPanel', className, 'arrow-' + (arrowDir || _popupConstants.ARROW_DIR.top)) },
	        _react2.default.createElement(
	            _PopupPanelMouseManager2.default,
	            props,
	            _react2.default.createElement(
	                'div',
	                { className: 'popup-content' },
	                children
	            )
	        )
	    );
	};
	
	var TransitionedPopupPanel = function TransitionedPopupPanel(props) {
	    return _react2.default.createElement(
	        _CSSTransitionGroup2.default,
	        {
	            transitionName: 'fade',
	            transitionAppear: true,
	            transitionEnterTimeout: 300,
	            transitionLeaveTimeout: 300,
	            transitionAppearTimeout: 300 },
	        props.visible ? _react2.default.createElement(PopupPanel, _extends({}, props, { visible: true })) : null
	    );
	};
	
	PopupPanel.propTypes = TransitionedPopupPanel.propTypes = {
	    visible: _propTypes2.default.bool,
	    className: _propTypes2.default.string,
	    arrowDir: _propTypes2.default.string,
	    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]).isRequired
	};
	
	var popupSelector = (0, _reselect.createSelector)(function (state, ownProps) {
	    return state.getIn(['app', 'popup', 'active']);
	}, function (state, ownProps) {
	    return ownProps.popupId;
	}, _gridSizeSelector.isMobileSize, function (popupState, popupId, isMobile) {
	    return {
	        visible: popupState.has(popupId),
	        isMobile: isMobile
	    };
	});
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        closePopup: function closePopup() {
	            return dispatch((0, _popupActions.closePopup)(ownProps.popupId, false));
	        }
	    };
	};
	
	var enhance = (0, _reactRedux.connect)(popupSelector, mapDispatchToProps);
	
	var PopupPanelContainer = function PopupPanelContainer(props) {
	    return props.fadeIn ? _react2.default.createElement(TransitionedPopupPanel, props) : _react2.default.createElement(PopupPanel, props);
	};
	
	PopupPanelContainer.propTypes = {
	    popupId: _propTypes2.default.string.isRequired,
	    className: _propTypes2.default.string,
	    arrowDir: _propTypes2.default.string,
	    arrowPos: _propTypes2.default.string,
	    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]).isRequired,
	    visible: _propTypes2.default.bool,
	    closePopups: _propTypes2.default.func,
	    onClose: _propTypes2.default.func,
	    fadeIn: _propTypes2.default.bool,
	    duration: _propTypes2.default.number,
	    isMobileView: _propTypes2.default.bool,
	    isMobile: _propTypes2.default.bool,
	    stayOpen: _propTypes2.default.bool
	};
	
	exports.default = enhance(PopupPanelContainer);

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.deselectAllElements = exports.toggleSelectedElements = exports.setSelectedElements = exports.addSelectedElements = exports.removeSelectedElements = exports.finishEditingElement = exports.startEditingElementWithDelay = exports.startEditingElement = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _timeUtil = __webpack_require__(43);
	
	var _permissionUtil = __webpack_require__(89);
	
	var _permissionsService = __webpack_require__(75);
	
	var _selectedElementsSelector = __webpack_require__(127);
	
	var _currentlyEditingSelector = __webpack_require__(233);
	
	var _currentUserSelector = __webpack_require__(33);
	
	var _elementSelector = __webpack_require__(41);
	
	var _immutableHelper = __webpack_require__(23);
	
	var _selectionConstants = __webpack_require__(77);
	
	var SELECTION_ACTION_TYPES = _interopRequireWildcard(_selectionConstants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } // Lib
	
	
	// Util
	
	
	// Constants
	
	
	var startEditingElement = exports.startEditingElement = function startEditingElement(_ref) {
	    var id = _ref.id,
	        editorKey = _ref.editorKey,
	        transactionId = _ref.transactionId;
	    return function (dispatch, getState) {
	        var state = getState();
	        var remoteSelectedElements = state.getIn(['remoteActivity', 'selectedElements']);
	
	        if (remoteSelectedElements.getIn([id, 'userId'])) {
	            console.warn('Cannot edit as it is remotely active', id);
	            return;
	        }
	
	        var elements = (0, _elementSelector.getElements)(state);
	        var currentUserId = (0, _currentUserSelector.getCurrentUserId)(state);
	        var acl = (0, _permissionsService.getUserPermissions)(elements, id, currentUserId);
	
	        if (acl && !(0, _permissionUtil.canWrite)(acl)) return;
	
	        return dispatch({
	            type: SELECTION_ACTION_TYPES.ELEMENT_EDIT_START,
	            id: id,
	            editorKey: editorKey,
	            transactionId: transactionId,
	            sync: false
	        });
	    };
	};
	
	var startEditingElementWithDelay = exports.startEditingElementWithDelay = function startEditingElementWithDelay(_ref2) {
	    var id = _ref2.id,
	        editDelay = _ref2.editDelay,
	        editorKey = _ref2.editorKey,
	        transactionId = _ref2.transactionId;
	    return function (dispatch, getState) {
	        if ((0, _currentlyEditingSelector.getCurrentlyEditingId)(getState()) === id) return;
	
	        (0, _lodash.delay)(function () {
	            var selectedIds = (0, _selectedElementsSelector.getSelectedElementIds)(getState());
	            if (!selectedIds.contains(id)) return;
	
	            dispatch(startEditingElement({ id: id, editorKey: editorKey, transactionId: transactionId }));
	        }, editDelay);
	    };
	};
	
	var finishEditingElement = exports.finishEditingElement = function finishEditingElement() {
	    return { type: SELECTION_ACTION_TYPES.ELEMENT_EDIT_COMPLETE, sync: false };
	};
	
	// ELEMENT SELECTIONS
	
	/**
	 * Removes the elements from the list of selected elements.
	 */
	var removeSelectedElements = exports.removeSelectedElements = function removeSelectedElements(_ref3) {
	    var ids = _ref3.ids,
	        transactionId = _ref3.transactionId;
	    return function (dispatch, getState) {
	        if ((0, _lodash.isEmpty)(ids)) return;
	
	        return dispatch({
	            type: SELECTION_ACTION_TYPES.ELEMENTS_DESELECTED,
	            ids: ids,
	            sync: true,
	            timestamp: (0, _timeUtil.getTimestamp)(),
	            transactionId: transactionId
	        });
	    };
	};
	
	/**
	 * Selects the specified elements if they are not already remotely selected.
	 */
	var addSelectedElements = exports.addSelectedElements = function addSelectedElements(_ref4) {
	    var ids = _ref4.ids,
	        transactionId = _ref4.transactionId;
	    return function (dispatch, getState) {
	        var state = getState();
	        var remoteSelectedElements = state.getIn(['remoteActivity', 'selectedElements']);
	        var elementIdsToSelect = ids.filter(function (id) {
	            return !remoteSelectedElements.getIn([id, 'userId']);
	        });
	
	        if (!elementIdsToSelect.length) return;
	
	        // Remove currently selected elements whose parents are being selected
	        var currentlySelectedElements = (0, _selectedElementsSelector.getSelectedElements)(state);
	        var currentlySelectedChildElementIds = currentlySelectedElements.filter(function (element) {
	            return element && (0, _lodash.includes)(ids, element.getIn(['location', 'parentId']));
	        }).map(function (element) {
	            return element.get('id');
	        }).toJS();
	        dispatch(removeSelectedElements({ ids: currentlySelectedChildElementIds, transactionId: transactionId }));
	
	        // Filter out ids that already have their parents selected (or will have their parents selected by this operation)
	        // And filter elements that are already selected
	        var elements = (0, _elementSelector.getElements)(state);
	        var currentlySelectedIds = (0, _selectedElementsSelector.getSelectedElementIds)(state).toJS();
	        var elementsToSelect = (0, _immutableHelper.getMany)(ids, elements);
	        var finalSelectedElementIds = [].concat(_toConsumableArray(elementIdsToSelect), _toConsumableArray(currentlySelectedElements.map(function (element) {
	            return element.get('id');
	        }).toJS()));
	        elementIdsToSelect = elementsToSelect.filter(function (element) {
	            return element && !(0, _lodash.includes)(finalSelectedElementIds, element.getIn(['location', 'parentId'])) && !(0, _lodash.includes)(currentlySelectedIds, element.get('id'));
	        }).map(function (element) {
	            return element.get('id');
	        }).keySeq().toArray();
	
	        if (!elementIdsToSelect.length) return;
	
	        return dispatch({
	            type: SELECTION_ACTION_TYPES.ELEMENTS_SELECTED,
	            ids: elementIdsToSelect,
	            timestamp: (0, _timeUtil.getTimestamp)(),
	            sync: true,
	            transactionId: transactionId
	        });
	    };
	};
	
	/**
	 * Sets the specified elements as selected and deselects other elements which were selected.
	 */
	var setSelectedElements = exports.setSelectedElements = function setSelectedElements(_ref5) {
	    var ids = _ref5.ids,
	        transactionId = _ref5.transactionId;
	    return function (dispatch, getState) {
	        var state = getState();
	        var currentSelection = (0, _selectedElementsSelector.getSelectedElementIds)(state);
	
	        if (currentSelection.size) {
	            var currentlySelectedIds = currentSelection.toJS();
	
	            var deselectedIds = (0, _lodash.difference)(currentlySelectedIds, ids);
	            dispatch(removeSelectedElements({ ids: deselectedIds, transactionId: transactionId }));
	
	            var newIds = (0, _lodash.difference)(ids, currentlySelectedIds);
	            if (!newIds.length) return;
	        }
	
	        return dispatch(addSelectedElements({ ids: ids, transactionId: transactionId }));
	    };
	};
	
	/**
	 * Selects elements (in the ids array) who are not already selected and deselect elements who are already selected.
	 */
	var toggleSelectedElements = exports.toggleSelectedElements = function toggleSelectedElements(_ref6) {
	    var ids = _ref6.ids,
	        transactionId = _ref6.transactionId;
	    return function (dispatch, getState) {
	        var state = getState();
	        var currentSelection = (0, _selectedElementsSelector.getSelectedElementIds)(state);
	
	        var selectedIds = ids;
	        if (currentSelection.size) {
	            var currentlySelectedIds = currentSelection.toJS();
	
	            // Any ID which was selected and is in the ids array that's been toggled should be deselected
	            var deselectedIds = (0, _lodash.intersection)(ids, currentlySelectedIds);
	            dispatch(removeSelectedElements({ ids: deselectedIds, transactionId: transactionId }));
	
	            selectedIds = (0, _lodash.difference)(ids, currentlySelectedIds);
	        }
	
	        return dispatch(addSelectedElements({ ids: selectedIds, transactionId: transactionId }));
	    };
	};
	
	var deselectAllElements = exports.deselectAllElements = function deselectAllElements() {
	    var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return function (dispatch, getState) {
	        var transactionId = args.transactionId;
	
	        var state = getState();
	
	        var currentSelection = (0, _selectedElementsSelector.getSelectedElementIds)(state);
	        if (currentSelection.size) {
	            dispatch({
	                type: SELECTION_ACTION_TYPES.ELEMENTS_DESELECT_ALL,
	                ids: currentSelection.toJS(),
	                sync: true,
	                timestamp: (0, _timeUtil.getTimestamp)(),
	                transactionId: transactionId
	            });
	        }
	
	        if ((0, _currentlyEditingSelector.getCurrentlyEditingId)(state)) {
	            dispatch(finishEditingElement());
	        }
	    };
	};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getElementDisplayName = exports.clearRegistry = exports.getElementTypeObjects = exports.getElementTypes = exports.getElementToStringFn = exports.getElementExportComponent = exports.getElementTooltip = exports.getElementPresentationalComponent = exports.getElementContainerComponent = exports.getElementTools = exports.createElementObject = exports.registerElementType = exports.isElementTypeValid = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _lodash = __webpack_require__(4);
	
	var _ElementExportFallback = __webpack_require__(2264);
	
	var _ElementExportFallback2 = _interopRequireDefault(_ElementExportFallback);
	
	var _elementExportStringFallback = __webpack_require__(2265);
	
	var _elementExportStringFallback2 = _interopRequireDefault(_elementExportStringFallback);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* FIXME This is using a singleton object, this makes it difficult to test and is the reason for the 'clearRegistry'
	         method below.  Find out a way to avoid this sort of object. */
	var elementTypeObjects = {};
	
	/**
	 * Retrieves the element type from the elementTypes map, or throws an exception if it doesn't exist.
	 *
	 * @param elementType
	 * @returns {*}
	 */
	var getElementTypeObject = function getElementTypeObject(elementType) {
	    var elementTypeObj = elementTypeObjects[elementType];
	    if (!elementTypeObj) console.error('Unknown element type: ' + elementType);
	    return elementTypeObj;
	};
	
	var isElementTypeValid = exports.isElementTypeValid = function isElementTypeValid(elementType) {
	    return (0, _lodash.isObject)(elementTypeObjects[elementType]);
	};
	
	var registerElementType = exports.registerElementType = function registerElementType(_ref) {
	    var elementType = _ref.elementType,
	        displayName = _ref.displayName,
	        objectConstructorFn = _ref.objectConstructorFn,
	        containerComponent = _ref.containerComponent,
	        presentationalComponent = _ref.presentationalComponent,
	        exportComponent = _ref.exportComponent,
	        toStringFn = _ref.toStringFn,
	        tools = _ref.tools,
	        _ref$showTool = _ref.showTool,
	        showTool = _ref$showTool === undefined ? true : _ref$showTool;
	
	    var elementTypeObj = elementTypeObjects[elementType] || {};
	
	    elementTypeObjects[elementType] = _extends({}, elementTypeObj, {
	        elementType: elementType,
	        displayName: displayName,
	        objectConstructorFn: objectConstructorFn,
	        containerComponent: containerComponent,
	        presentationalComponent: presentationalComponent,
	        exportComponent: exportComponent,
	        toStringFn: toStringFn,
	        tools: tools,
	        showTool: showTool
	    });
	};
	
	var createElementObject = exports.createElementObject = function createElementObject(action) {
	    var elementType = getElementTypeObject(action.elementType);
	    return elementType.objectConstructorFn(action);
	};
	
	var getElementTools = exports.getElementTools = function getElementTools(elementType) {
	    return getElementTypeObject(elementType) && getElementTypeObject(elementType).tools;
	};
	
	var getElementContainerComponent = exports.getElementContainerComponent = function getElementContainerComponent(elementType) {
	    return getElementTypeObject(elementType) && getElementTypeObject(elementType).containerComponent;
	};
	
	var getElementPresentationalComponent = exports.getElementPresentationalComponent = function getElementPresentationalComponent(elementType) {
	    return getElementTypeObject(elementType) && getElementTypeObject(elementType).presentationalComponent;
	};
	
	var getElementTooltip = exports.getElementTooltip = function getElementTooltip(elementType) {
	    return getElementTypeObject(elementType) && getElementTypeObject(elementType).tooltip || '';
	};
	
	var getElementExportComponent = exports.getElementExportComponent = function getElementExportComponent(elementType) {
	    return getElementTypeObject(elementType) && getElementTypeObject(elementType).exportComponent || _ElementExportFallback2.default;
	};
	
	var getElementToStringFn = exports.getElementToStringFn = function getElementToStringFn(elementType) {
	    return getElementTypeObject(elementType) && getElementTypeObject(elementType).toStringFn || _elementExportStringFallback2.default;
	};
	
	var getElementTypes = exports.getElementTypes = function getElementTypes() {
	    return Object.keys(elementTypeObjects);
	};
	var getElementTypeObjects = exports.getElementTypeObjects = function getElementTypeObjects() {
	    return elementTypeObjects;
	};
	
	var clearRegistry = exports.clearRegistry = function clearRegistry() {
	    elementTypeObjects = {};
	};
	
	var getElementDisplayName = exports.getElementDisplayName = function getElementDisplayName(elementType) {
	    return getElementTypeObject(elementType) && getElementTypeObject(elementType).displayName;
	};

/***/ }),
/* 57 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var LINE_TYPE = exports.LINE_TYPE = 'LINE';
	var LINE_DISPLAY_NAME = exports.LINE_DISPLAY_NAME = 'Line';
	
	var LINE_EDGE_DND_TYPE = exports.LINE_EDGE_DND_TYPE = 'LINE_EDGE';
	var LINE_CONTROL_POINT_DND_TYPE = exports.LINE_CONTROL_POINT_DND_TYPE = 'LINE_CONTROL_POINT';
	
	var LINE_STYLE = exports.LINE_STYLE = {
	    SOLID: 'SOLID',
	    DASHED: 'DASHED'
	};
	
	var LINE_EDGE = exports.LINE_EDGE = {
	    start: 'start',
	    end: 'end'
	};
	
	var LINE_MARKER_STYLE = exports.LINE_MARKER_STYLE = {
	    ARROW: 'ARROW',
	    DOT: 'DOT',
	    NONE: 'NONE'
	};
	
	var MIN_LINE_LENGTH = exports.MIN_LINE_LENGTH = 4;
	var DEFAULT_LINE_WIDTH = exports.DEFAULT_LINE_WIDTH = 17;
	var DEFAULT_LINE_HEIGHT = exports.DEFAULT_LINE_HEIGHT = DEFAULT_LINE_WIDTH;

/***/ }),
/* 58 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var choose = exports.choose = function choose(predicate, left, right) {
	    return predicate ? left : right;
	};
	var chooseSingular = exports.chooseSingular = function chooseSingular(count, left, right) {
	    return choose(count === 1, left, right);
	};
	var SPACE = exports.SPACE = ' ';
	
	var pluralise = exports.pluralise = function pluralise(string, count) {
	    return chooseSingular(count, string, string + 's');
	};
	
	var listSeparator = exports.listSeparator = function listSeparator(i, count) {
	    if (i === count - 2) return ' and ';
	    if (i >= count - 1) return '';
	    return ', ';
	};
	
	var slugify = exports.slugify = function slugify() {
	    var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var replaceSpace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';
	    return str.toString().toLowerCase().replace(/\s+/g, replaceSpace).replace(/\-\-+/g, replaceSpace).replace(/[^\w\-]+/g, '').replace(/^-+/, '').replace(/-+$/, '');
	};
	
	var cleanEmail = exports.cleanEmail = function cleanEmail() {
	    var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    return str.toString().toLowerCase().replace(/\s+/g, '');
	};
	
	var stringValue = function stringValue(value) {
	    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && Array.isArray(value)) return value.join(',');
	    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') return JSON.stringify(value);
	    return value ? value.toString() : '';
	};
	
	var chunkString = exports.chunkString = function chunkString(string, chunkSize) {
	    var ret = [];
	    var length = string.length;
	
	    for (var i = 0; i < length; i += chunkSize) {
	        ret.push(string.substr(i, chunkSize));
	    }
	
	    return ret;
	};
	
	// takes an object map and returns a query string
	// @input: { filter_ids=[abc,123], filter_after: 1245 }
	// @output: 'filter_ids=abc,123&filter_after=1234'
	var createQueryString = exports.createQueryString = function createQueryString(queryObject) {
	    if (!queryObject) return '';
	
	    return Object.keys(queryObject).map(function (key) {
	        return key + '=' + stringValue(queryObject[key]);
	    }).join('&');
	};

/***/ }),
/* 59 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Components
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(34);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	__webpack_require__(1149);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormButton = function FormButton(props) {
	    return _react2.default.createElement(_Button2.default, _extends({}, props, { className: (0, _classnames2.default)('FormButton', props.className) }));
	};
	
	FormButton.propTypes = {
	    className: _propTypes2.default.string
	};
	
	exports.default = FormButton;

/***/ }),
/* 61 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	// Media query used to determine if the device is on a retina display
	var RETINA_MEDIA = '(-webkit-min-device-pixel-ratio: 1.5),(-moz-min-device-pixel-ratio: 1.5),' + '(min-device-pixel-ratio: 1.5)';
	
	var PLATFORMS = exports.PLATFORMS = {
	    windows: 'windows',
	    mac: 'mac',
	    unix: 'unix',
	    linux: 'linux',
	    iOS: 'ios',
	    android: 'android'
	};
	
	var getPlatform = exports.getPlatform = function getPlatform() {
	    var _navigator = navigator,
	        userAgent = _navigator.userAgent,
	        appVersion = _navigator.appVersion;
	
	
	    if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || userAgent.match(/iPod/i)) return PLATFORMS.iOS;
	    if (userAgent.match(/Android/i)) return PLATFORMS.android;
	
	    if (appVersion.indexOf('Win') !== -1) return PLATFORMS.windows;
	    if (appVersion.indexOf('Mac') !== -1) return PLATFORMS.mac;
	    if (appVersion.indexOf('X11') !== -1) return PLATFORMS.unix;
	    if (appVersion.indexOf('Linux') !== -1) return PLATFORMS.linux;
	
	    return null;
	};
	
	/**
	 * Determines if the current device is retina or not.
	 *
	 * @return {Boolean} true if the current device is a retina display.
	 */
	var isRetina = exports.isRetina = window.devicePixelRatio > 1 || window.matchMedia && window.matchMedia(RETINA_MEDIA).matches;
	var isTouch = exports.isTouch = 'ontouchstart' in window || navigator.maxTouchPoints;
	var isApple = exports.isApple = getPlatform() === PLATFORMS.mac || getPlatform() === PLATFORMS.iOS;
	var isAndroid = exports.isAndroid = function isAndroid() {
	    return getPlatform() === PLATFORMS.android;
	};
	var isMobile = exports.isMobile = function isMobile() {
	    return getPlatform() === PLATFORMS.iOS || isAndroid();
	};
	
	var getUserAgent = function getUserAgent() {
	    return window.navigator.userAgent || '';
	};
	var isBrowser = exports.isBrowser = function isBrowser(testRegex) {
	    return testRegex.test(getUserAgent());
	};
	var isSafari = exports.isSafari = function isSafari() {
	    return !!window.safari;
	};
	var isFirefox = exports.isFirefox = function isFirefox() {
	    return isBrowser(/Firefox/g);
	};

/***/ }),
/* 62 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftModifier
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var CharacterMetadata = __webpack_require__(94);
	var ContentStateInlineStyle = __webpack_require__(1053);
	var Immutable = __webpack_require__(28);
	
	var applyEntityToContentState = __webpack_require__(1069);
	var getCharacterRemovalRange = __webpack_require__(1090);
	var getContentStateFragment = __webpack_require__(263);
	var insertFragmentIntoContentState = __webpack_require__(1095);
	var insertTextIntoContentState = __webpack_require__(1096);
	var invariant = __webpack_require__(10);
	var modifyBlockForContentState = __webpack_require__(1107);
	var removeEntitiesAtEdges = __webpack_require__(550);
	var removeRangeFromContentState = __webpack_require__(1108);
	var splitBlockInContentState = __webpack_require__(1110);
	
	var OrderedSet = Immutable.OrderedSet;
	
	/**
	 * `DraftModifier` provides a set of convenience methods that apply
	 * modifications to a `ContentState` object based on a target `SelectionState`.
	 *
	 * Any change to a `ContentState` should be decomposable into a series of
	 * transaction functions that apply the required changes and return output
	 * `ContentState` objects.
	 *
	 * These functions encapsulate some of the most common transaction sequences.
	 */
	
	var DraftModifier = {
	  replaceText: function replaceText(contentState, rangeToReplace, text, inlineStyle, entityKey) {
	    var withoutEntities = removeEntitiesAtEdges(contentState, rangeToReplace);
	    var withoutText = removeRangeFromContentState(withoutEntities, rangeToReplace);
	
	    var character = CharacterMetadata.create({
	      style: inlineStyle || OrderedSet(),
	      entity: entityKey || null
	    });
	
	    return insertTextIntoContentState(withoutText, withoutText.getSelectionAfter(), text, character);
	  },
	
	  insertText: function insertText(contentState, targetRange, text, inlineStyle, entityKey) {
	    !targetRange.isCollapsed() ?  false ? invariant(false, 'Target range must be collapsed for `insertText`.') : invariant(false) : void 0;
	    return DraftModifier.replaceText(contentState, targetRange, text, inlineStyle, entityKey);
	  },
	
	  moveText: function moveText(contentState, removalRange, targetRange) {
	    var movedFragment = getContentStateFragment(contentState, removalRange);
	
	    var afterRemoval = DraftModifier.removeRange(contentState, removalRange, 'backward');
	
	    return DraftModifier.replaceWithFragment(afterRemoval, targetRange, movedFragment);
	  },
	
	  replaceWithFragment: function replaceWithFragment(contentState, targetRange, fragment) {
	    var withoutEntities = removeEntitiesAtEdges(contentState, targetRange);
	    var withoutText = removeRangeFromContentState(withoutEntities, targetRange);
	
	    return insertFragmentIntoContentState(withoutText, withoutText.getSelectionAfter(), fragment);
	  },
	
	  removeRange: function removeRange(contentState, rangeToRemove, removalDirection) {
	    // Check whether the selection state overlaps with a single entity.
	    // If so, try to remove the appropriate substring of the entity text.
	    if (rangeToRemove.getAnchorKey() === rangeToRemove.getFocusKey()) {
	      var key = rangeToRemove.getAnchorKey();
	      var startOffset = rangeToRemove.getStartOffset();
	      var endOffset = rangeToRemove.getEndOffset();
	      var block = contentState.getBlockForKey(key);
	
	      var startEntity = block.getEntityAt(startOffset);
	      var endEntity = block.getEntityAt(endOffset - 1);
	      if (startEntity && startEntity === endEntity) {
	        var adjustedRemovalRange = getCharacterRemovalRange(block, rangeToRemove, removalDirection);
	        return removeRangeFromContentState(contentState, adjustedRemovalRange);
	      }
	    }
	
	    var withoutEntities = removeEntitiesAtEdges(contentState, rangeToRemove);
	    return removeRangeFromContentState(withoutEntities, rangeToRemove);
	  },
	
	  splitBlock: function splitBlock(contentState, selectionState) {
	    var withoutEntities = removeEntitiesAtEdges(contentState, selectionState);
	    var withoutText = removeRangeFromContentState(withoutEntities, selectionState);
	
	    return splitBlockInContentState(withoutText, withoutText.getSelectionAfter());
	  },
	
	  applyInlineStyle: function applyInlineStyle(contentState, selectionState, inlineStyle) {
	    return ContentStateInlineStyle.add(contentState, selectionState, inlineStyle);
	  },
	
	  removeInlineStyle: function removeInlineStyle(contentState, selectionState, inlineStyle) {
	    return ContentStateInlineStyle.remove(contentState, selectionState, inlineStyle);
	  },
	
	  setBlockType: function setBlockType(contentState, selectionState, blockType) {
	    return modifyBlockForContentState(contentState, selectionState, function (block) {
	      return block.merge({ type: blockType, depth: 0 });
	    });
	  },
	
	  setBlockData: function setBlockData(contentState, selectionState, blockData) {
	    return modifyBlockForContentState(contentState, selectionState, function (block) {
	      return block.merge({ data: blockData });
	    });
	  },
	
	  mergeBlockData: function mergeBlockData(contentState, selectionState, blockData) {
	    return modifyBlockForContentState(contentState, selectionState, function (block) {
	      return block.merge({ data: block.getData().merge(blockData) });
	    });
	  },
	
	  applyEntity: function applyEntity(contentState, selectionState, entityKey) {
	    var withoutEntities = removeEntitiesAtEdges(contentState, selectionState);
	    return applyEntityToContentState(withoutEntities, selectionState, entityKey);
	  }
	};
	
	module.exports = DraftModifier;

/***/ }),
/* 64 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CSSTransitionGroup = __webpack_require__(134);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Spinner = function Spinner(_ref) {
	    var show = _ref.show;
	    return _react2.default.createElement(
	        'div',
	        { className: 'Spinner' },
	        _react2.default.createElement(
	            'div',
	            { className: 'spinner-wrapper' },
	            _react2.default.createElement(
	                'div',
	                { className: 'spinner-container' },
	                _react2.default.createElement(
	                    'svg',
	                    { className: 'circular', viewBox: '25 25 50 50' },
	                    _react2.default.createElement('circle', { className: 'path spinner-line',
	                        cx: '50', cy: '50', r: '20', fill: 'none', strokeWidth: '2', strokeMiterlimit: '10' })
	                )
	            )
	        )
	    );
	};
	
	var SpinnerContainer = function SpinnerContainer(props) {
	    var show = props.show,
	        fadeIn = props.fadeIn;
	
	
	    if (fadeIn) {
	        return _react2.default.createElement(
	            _CSSTransitionGroup2.default,
	            {
	                transitionName: 'fade',
	                transitionEnterTimeout: 200,
	                transitionLeaveTimeout: 200 },
	            show ? _react2.default.createElement(Spinner, null) : null
	        );
	    }
	
	    return show ? _react2.default.createElement(Spinner, null) : null;
	};
	
	Spinner.propTypes = SpinnerContainer.propTypes = {
	    show: _propTypes2.default.bool,
	    fadeIn: _propTypes2.default.bool
	};
	
	exports.default = SpinnerContainer;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.isMobileSize = exports.gridSizeSelector = exports.getGridSizeName = exports.getGridSize = undefined;
	
	var _gridConstants = __webpack_require__(205);
	
	var getGridSize = exports.getGridSize = function getGridSize(state) {
	    return state.getIn(['app', 'gridSize', 'size']);
	}; // Constants
	var getGridSizeName = exports.getGridSizeName = function getGridSizeName(state) {
	    return state.getIn(['app', 'gridSize', 'name']);
	};
	
	var gridSizeSelector = exports.gridSizeSelector = function gridSizeSelector(state) {
	    return {
	        gridSize: getGridSize(state)
	    };
	};
	
	var isMobileSize = exports.isMobileSize = function isMobileSize(state) {
	    return getGridSizeName(state) === _gridConstants.GRID.MOBILE.name;
	};
	
	exports.default = getGridSize;

/***/ }),
/* 67 */
/***/ (function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(38)
	  , createDesc = __webpack_require__(131);
	module.exports = __webpack_require__(37) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(15)
	  , hide      = __webpack_require__(68)
	  , has       = __webpack_require__(62)
	  , SRC       = __webpack_require__(157)('src')
	  , TO_STRING = 'toString'
	  , $toString = Function[TO_STRING]
	  , TPL       = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(112).inspectSource = function(it){
	  return $toString.call(it);
	};
	
	(module.exports = function(O, key, val, safe){
	  var isFunction = typeof val == 'function';
	  if(isFunction)has(val, 'name') || hide(val, 'name', key);
	  if(O[key] === val)return;
	  if(isFunction)has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if(O === global){
	    O[key] = val;
	  } else {
	    if(!safe){
	      delete O[key];
	      hide(O, key, val);
	    } else {
	      if(O[key])O[key] = val;
	      else hide(O, key, val);
	    }
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString(){
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(5)
	  , fails   = __webpack_require__(19)
	  , defined = __webpack_require__(92)
	  , quot    = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function(string, tag, attribute, value) {
	  var S  = String(defined(string))
	    , p1 = '<' + tag;
	  if(attribute !== '')p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function(NAME, exec){
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function(){
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(211)
	  , defined = __webpack_require__(92);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DragDropContext = __webpack_require__(598);
	
	Object.defineProperty(exports, 'DragDropContext', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DragDropContext).default;
	  }
	});
	
	var _DragDropContextProvider = __webpack_require__(1461);
	
	Object.defineProperty(exports, 'DragDropContextProvider', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DragDropContextProvider).default;
	  }
	});
	
	var _DragLayer = __webpack_require__(1462);
	
	Object.defineProperty(exports, 'DragLayer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DragLayer).default;
	  }
	});
	
	var _DragSource = __webpack_require__(1463);
	
	Object.defineProperty(exports, 'DragSource', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DragSource).default;
	  }
	});
	
	var _DropTarget = __webpack_require__(1464);
	
	Object.defineProperty(exports, 'DropTarget', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DropTarget).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.combineReducers = undefined;
	
	var _combineReducers2 = __webpack_require__(1643);
	
	var _combineReducers3 = _interopRequireDefault(_combineReducers2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.combineReducers = _combineReducers3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Components
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(34);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	__webpack_require__(1131);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LinkButton = function LinkButton(props) {
	    return _react2.default.createElement(_Button2.default, _extends({}, props, { className: (0, _classnames2.default)('LinkButton', props.className) }));
	};
	
	LinkButton.propTypes = {
	    className: _propTypes2.default.string
	};
	
	exports.default = LinkButton;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.currentBoardSharedUsersSelector = exports.canSaveBoard = exports.getSharedUsers = exports.aliasUserPermissionsSelector = exports.createElementUserPermissionsSelector = exports.currentBoardPermissionsSelector = exports.currentBoardUserPermissionsSelector = exports.confirmedInvalidPermissions = exports.confirmedValidPermissions = exports.validatePermissions = exports.getAllPermissions = exports.getUserPermissions = exports.getUserAcl = undefined;
	
	var _reselect = __webpack_require__(7);
	
	var _milanoteReselect = __webpack_require__(49);
	
	var _elementUtil = __webpack_require__(105);
	
	var _userConstants = __webpack_require__(32);
	
	var _permissionConstants = __webpack_require__(485);
	
	/**
	 * Retrieves the ACL entry appropriate for the current user off ONLY the current element.
	 */
	
	
	// Constants
	
	
	// Utils
	var getUserAcl = exports.getUserAcl = function getUserAcl(element, userId) {
	    return element.getIn(['acl', userId]) || element.getIn(['acl', _userConstants.PUBLIC_USER_ID] || 0);
	}; // Lib
	var getUserPermissions = exports.getUserPermissions = function getUserPermissions(elements, elementId, userId) {
	    var userPermissions = 0;
	
	    var element = elements.get(elementId);
	    while (element) {
	        var currentElementUserPermissions = getUserAcl(element, userId);
	        userPermissions = userPermissions | currentElementUserPermissions;
	
	        var parentId = element.getIn(['location', 'parentId']);
	        element = elements.get(parentId);
	    }
	    return userPermissions;
	};
	
	var getAllPermissions = exports.getAllPermissions = function getAllPermissions(elements, elementId) {
	    var permissionsMap = {};
	
	    var element = elements.get(elementId);
	    while (element) {
	        var currentElementAcl = element.get('acl') || [];
	
	        // Bitwise OR the user permissions so the user permissions is the MOST permissive out of all the permissions
	        /* eslint-disable no-loop-func */
	        currentElementAcl.forEach(function (userEntry, userKey) {
	            permissionsMap[userKey] = permissionsMap[userKey] || {};
	            permissionsMap[userKey].permission = permissionsMap[userKey].permission | userEntry;
	
	            // Keep track of the closest ancestor this is shared from
	            permissionsMap[userKey].elementId = permissionsMap[userKey].elementId || element.get('id');
	        });
	        /* eslint-enable no-loop-func */
	
	        var parentId = element.getIn(['location', 'parentId']);
	        element = elements.get(parentId);
	    }
	
	    return permissionsMap;
	};
	
	var validatePermissions = exports.validatePermissions = function validatePermissions(elements, elementId, userId, requiredPermissions) {
	    if ((getUserPermissions(elements, elementId, userId) & requiredPermissions) === requiredPermissions) {
	        return _permissionConstants.PERMISSION_STATES.VALID;
	    }
	    return (0, _elementUtil.hasRetrievedAllAncestors)(elements, elementId) ? _permissionConstants.PERMISSION_STATES.INVALID : _permissionConstants.PERMISSION_STATES.UNKNOWN;
	};
	
	var confirmedValidPermissions = exports.confirmedValidPermissions = function confirmedValidPermissions(elements, elementId, userId, requiredPermissions) {
	    return validatePermissions(elements, elementId, userId, requiredPermissions) === _permissionConstants.PERMISSION_STATES.VALID;
	};
	
	var confirmedInvalidPermissions = exports.confirmedInvalidPermissions = function confirmedInvalidPermissions(elements, elementId, userId, requiredPermissions) {
	    return validatePermissions(elements, elementId, userId, requiredPermissions) === _permissionConstants.PERMISSION_STATES.INVALID;
	};
	
	var currentBoardUserPermissionsSelector = exports.currentBoardUserPermissionsSelector = (0, _reselect.createSelector)(function (state) {
	    return state.get('elements');
	}, function (state, ownProps) {
	    return ownProps.currentBoardId || ownProps.currentBoard && ownProps.currentBoard.get('id');
	}, function (state) {
	    return state.getIn(['app', 'currentUser', '_id']);
	}, getUserPermissions);
	
	var currentBoardPermissionsSelector = exports.currentBoardPermissionsSelector = (0, _milanoteReselect.createShallowSelector)(function (state) {
	    return state.get('elements');
	}, function (state, ownProps) {
	    return ownProps.currentBoardId;
	}, getAllPermissions);
	
	var createElementUserPermissionsSelector = exports.createElementUserPermissionsSelector = function createElementUserPermissionsSelector() {
	    return (0, _milanoteReselect.createShallowSelector)(function (state) {
	        return state.get('elements');
	    }, function (state, props) {
	        return props.elementId || props.element && props.element.get('id');
	    }, function (state) {
	        return state.getIn(['app', 'currentUser', '_id']);
	    }, getUserPermissions);
	};
	
	var aliasUserPermissionsSelector = exports.aliasUserPermissionsSelector = (0, _milanoteReselect.createShallowSelector)(function (state) {
	    return state.get('elements');
	}, function (state, props) {
	    return props.element.getIn(['content', 'linkTo']);
	}, function (state) {
	    return state.getIn(['app', 'currentUser', '_id']);
	}, function (elements, linkedBoardId, currentUserId) {
	    return getUserPermissions(elements, linkedBoardId, currentUserId);
	});
	
	var getSharedUsers = exports.getSharedUsers = function getSharedUsers(boardPermissions) {
	    return Object.keys(boardPermissions).filter(function (key) {
	        return key !== _userConstants.PUBLIC_USER_ID;
	    });
	};
	
	var canSaveBoard = exports.canSaveBoard = function canSaveBoard(elements, elementId, userId) {
	    return confirmedValidPermissions(elements, elementId, userId, _permissionConstants.ACCESS_BITS.SAVE);
	};
	
	var currentBoardSharedUsersSelector = exports.currentBoardSharedUsersSelector = (0, _milanoteReselect.createShallowSelector)(currentBoardPermissionsSelector, function (currentBoardPermissions) {
	    return getSharedUsers(currentBoardPermissions);
	});

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _http = __webpack_require__(2133);
	
	Object.keys(_http).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _http[key];
	    }
	  });
	});
	exports.default = _http.http;

/***/ }),
/* 77 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ELEMENT_EDIT_START = exports.ELEMENT_EDIT_START = 'ELEMENT_EDIT_START';
	var ELEMENT_SET_EDIT_HANDLER = exports.ELEMENT_SET_EDIT_HANDLER = 'ELEMENT_SET_EDIT_HANDLER';
	var ELEMENT_EDIT_COMPLETE = exports.ELEMENT_EDIT_COMPLETE = 'ELEMENT_EDIT_COMPLETE';
	
	// Selection action types
	var ELEMENTS_SELECTED = exports.ELEMENTS_SELECTED = 'ELEMENTS_SELECTED';
	var ELEMENTS_DESELECTED = exports.ELEMENTS_DESELECTED = 'ELEMENTS_DESELECTED';
	var ELEMENTS_DESELECT_ALL = exports.ELEMENTS_DESELECT_ALL = 'ELEMENTS_DESELECT_ALL';

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(494);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  typeof document.createElement -> undefined
	 */
	function isStandardBrowserEnv() {
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined' &&
	    typeof document.createElement === 'function'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object' && !isArray(obj)) {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE            = __webpack_require__(212)
	  , createDesc     = __webpack_require__(131)
	  , toIObject      = __webpack_require__(71)
	  , toPrimitive    = __webpack_require__(99)
	  , has            = __webpack_require__(62)
	  , IE8_DOM_DEFINE = __webpack_require__(507)
	  , gOPD           = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(37) ? gOPD : function getOwnPropertyDescriptor(O, P){
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if(IE8_DOM_DEFINE)try {
	    return gOPD(O, P);
	  } catch(e){ /* empty */ }
	  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
	};

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has         = __webpack_require__(62)
	  , toObject    = __webpack_require__(51)
	  , IE_PROTO    = __webpack_require__(343)('IE_PROTO')
	  , ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function(O){
	  O = toObject(O);
	  if(has(O, IE_PROTO))return O[IE_PROTO];
	  if(typeof O.constructor == 'function' && O instanceof O.constructor){
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};

/***/ }),
/* 81 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	var nullthrows = function nullthrows(x) {
	  if (x != null) {
	    return x;
	  }
	  throw new Error("Got unexpected null or undefined");
	};
	
	module.exports = nullthrows;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;
	
	var _reducer = __webpack_require__(629);
	
	Object.defineProperty(exports, 'LOCATION_CHANGE', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.LOCATION_CHANGE;
	  }
	});
	Object.defineProperty(exports, 'routerReducer', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.routerReducer;
	  }
	});
	
	var _actions = __webpack_require__(628);
	
	Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
	  enumerable: true,
	  get: function get() {
	    return _actions.CALL_HISTORY_METHOD;
	  }
	});
	Object.defineProperty(exports, 'push', {
	  enumerable: true,
	  get: function get() {
	    return _actions.push;
	  }
	});
	Object.defineProperty(exports, 'replace', {
	  enumerable: true,
	  get: function get() {
	    return _actions.replace;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _actions.go;
	  }
	});
	Object.defineProperty(exports, 'goBack', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goBack;
	  }
	});
	Object.defineProperty(exports, 'goForward', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goForward;
	  }
	});
	Object.defineProperty(exports, 'routerActions', {
	  enumerable: true,
	  get: function get() {
	    return _actions.routerActions;
	  }
	});
	
	var _sync = __webpack_require__(1551);
	
	var _sync2 = _interopRequireDefault(_sync);
	
	var _middleware = __webpack_require__(1550);
	
	var _middleware2 = _interopRequireDefault(_middleware);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.syncHistoryWithStore = _sync2['default'];
	exports.routerMiddleware = _middleware2['default'];

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getCurrentBoardInboxState = exports.getCurrentBoard = exports.getIsBoardFetched = exports.getBoardResourceState = exports.getFetchedBoardIds = exports.getCurrentBoardError = exports.getIsCurrentBoardError = exports.getIsCurrentBoardFetched = exports.getIsCurrentBoardFetching = exports.getCurrentBoardResourceState = exports.currentBoardIdSelector = exports.boardResourcesSelector = undefined;
	
	var _reselect = __webpack_require__(7);
	
	var _resourceSelector = __webpack_require__(472);
	
	var _resourceUtil = __webpack_require__(108);
	
	var _immutableHelper = __webpack_require__(23);
	
	var _currentBoardIdSelector = __webpack_require__(306);
	
	var _resourceConstants = __webpack_require__(85);
	
	// RESOURCES
	// Lib
	var boardResourcesSelector = exports.boardResourcesSelector = (0, _resourceSelector.makeResourceTypeSelector)(_resourceConstants.RESOURCE_TYPES.boards);
	
	// Constants
	
	
	// Utils
	var currentBoardIdSelector = exports.currentBoardIdSelector = function currentBoardIdSelector(state, props) {
	    return (0, _currentBoardIdSelector.getCurrentBoardId)(state) || props.currentBoardId || props.routeParams && props.routeParams.currentBoardId;
	};
	
	var getCurrentBoardResourceState = exports.getCurrentBoardResourceState = (0, _reselect.createSelector)(boardResourcesSelector, currentBoardIdSelector, function (boardResourcesState, currentBoardId) {
	    return boardResourcesState.get(currentBoardId);
	});
	
	var getIsCurrentBoardFetching = exports.getIsCurrentBoardFetching = (0, _reselect.createSelector)(getCurrentBoardResourceState, _resourceUtil.isFetching);
	
	var getIsCurrentBoardFetched = exports.getIsCurrentBoardFetched = (0, _reselect.createSelector)(getCurrentBoardResourceState, _resourceUtil.isFetched);
	
	var getIsCurrentBoardError = exports.getIsCurrentBoardError = (0, _reselect.createSelector)(getCurrentBoardResourceState, _resourceUtil.isError);
	
	var getCurrentBoardError = exports.getCurrentBoardError = (0, _reselect.createSelector)(getCurrentBoardResourceState, (0, _immutableHelper.prop)('error'));
	
	var getFetchedBoardIds = exports.getFetchedBoardIds = (0, _reselect.createSelector)(boardResourcesSelector, function (boardResourcesState) {
	    return (0, _immutableHelper.toIdArray)(boardResourcesState.filter(_resourceUtil.isFetched));
	});
	
	var getElementIdFromElement = function getElementIdFromElement(state, ownProps) {
	    return ownProps.element && ownProps.element.get('id');
	};
	
	var getBoardResourceState = exports.getBoardResourceState = function getBoardResourceState(state, ownProps) {
	    return boardResourcesSelector(state).get(getElementIdFromElement(state, ownProps));
	};
	
	var getIsBoardFetched = exports.getIsBoardFetched = function getIsBoardFetched(state, ownProps) {
	    return (0, _resourceUtil.isFetched)(getBoardResourceState(state, ownProps));
	};
	
	// STATE
	var getCurrentBoard = exports.getCurrentBoard = function getCurrentBoard(state, ownProps) {
	    return state.getIn(['elements', currentBoardIdSelector(state)]);
	};
	
	var getCurrentBoardInboxState = exports.getCurrentBoardInboxState = function getCurrentBoardInboxState(state, ownProps) {
	    var currentBoard = getCurrentBoard(state, ownProps);
	    return currentBoard && currentBoard.getIn(['content', 'inbox']);
	};

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchCurrentUserSubscription = exports.fetchCurrentUserReferrals = exports.uploadCurrentUserAvatar = exports.userImageUploadError = exports.userImageUploadCompleted = exports.setUserImage = exports.setCurrentUserGuest = exports.refreshCurrentUser = exports.updateCurrentUserHtpp = exports.fetchCurrentUser = exports.userNavigate = exports.updateCurrentUser = exports.setCurrentUser = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _http = __webpack_require__(76);
	
	var _authService = __webpack_require__(227);
	
	var _mediaService = __webpack_require__(315);
	
	var _mediaService2 = _interopRequireDefault(_mediaService);
	
	var _userService = __webpack_require__(106);
	
	var _elementActions = __webpack_require__(26);
	
	var _navigationActions = __webpack_require__(27);
	
	var _userActions = __webpack_require__(2289);
	
	var _userActions2 = __webpack_require__(758);
	
	var _elementCountActions = __webpack_require__(464);
	
	var _teamManagementActions = __webpack_require__(310);
	
	var _imageFileLoader = __webpack_require__(766);
	
	var _imageFileLoader2 = _interopRequireDefault(_imageFileLoader);
	
	var _timeUtil = __webpack_require__(43);
	
	var _idValidator = __webpack_require__(799);
	
	var _currentUserConstants = __webpack_require__(144);
	
	var _userConstants = __webpack_require__(32);
	
	var _mediaConstants = __webpack_require__(148);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Util
	
	
	// Actions
	var setCurrentUser = exports.setCurrentUser = function setCurrentUser(user) {
	    return {
	        type: _currentUserConstants.CURRENT_USER_SET,
	        user: user
	    };
	};
	
	// Constants
	// Services
	var updateCurrentUser = exports.updateCurrentUser = function updateCurrentUser(_ref) {
	    var userId = _ref.userId,
	        changes = _ref.changes,
	        _ref$sync = _ref.sync,
	        sync = _ref$sync === undefined ? true : _ref$sync;
	    return function (dispatch, getState) {
	        return dispatch((0, _userActions.updateUser)({
	            userId: userId || getState().getIn(['app', 'currentUser', '_id']),
	            changes: changes,
	            sync: sync
	        }));
	    };
	};
	
	var userNavigate = exports.userNavigate = function userNavigate(_ref2) {
	    var userId = _ref2.userId,
	        newBoardId = _ref2.newBoardId,
	        previousBoardId = _ref2.previousBoardId,
	        _ref2$sync = _ref2.sync,
	        sync = _ref2$sync === undefined ? true : _ref2$sync;
	    return function (dispatch) {
	        if (!(0, _idValidator.isElementId)(newBoardId)) return;
	
	        dispatch({
	            type: _userConstants.USER_NAVIGATE,
	            newBoardId: newBoardId,
	            previousBoardId: previousBoardId,
	            timestamp: (0, _timeUtil.getTimestamp)(),
	            userId: userId,
	            sync: sync
	        });
	    };
	};
	
	var fetchCurrentUser = exports.fetchCurrentUser = function fetchCurrentUser() {
	    return function (dispatch) {
	        dispatch({ type: _currentUserConstants.CURRENT_USER_GET_DETAILS });
	
	        var currentUserToken = (0, _authService.getCurrentUserToken)();
	
	        // TODO review - might need to implement a redirect
	        if (!currentUserToken) {
	            console.error('Attempting to retrieve a user without a user token.');
	            return;
	        }
	
	        (0, _userService.fetchMe)().then(function (response) {
	            var _response$data = response.data,
	                user = _response$data.user,
	                elements = _response$data.elements,
	                remoteUserIds = _response$data.remoteUserIds,
	                elementCount = _response$data.elementCount;
	
	
	            var userIds = (0, _lodash.keys)(remoteUserIds);
	            var userShareCounts = (0, _lodash.mapValues)(remoteUserIds, function (shareCount) {
	                return {
	                    shareCount: shareCount
	                };
	            });
	
	            dispatch(setCurrentUser(user));
	            dispatch((0, _elementActions.loadElements)(elements));
	
	            dispatch((0, _userActions2.trackUsers)(userIds));
	            dispatch((0, _userActions2.loadUsers)(userShareCounts));
	
	            dispatch((0, _elementCountActions.increaseElementCount)(elementCount));
	        }).catch(function (err) {
	            console.error(err, err.response);
	            dispatch({ type: _currentUserConstants.CURRENT_USER_GET_FAILURE });
	            dispatch((0, _navigationActions.navigateToLogin)());
	        });
	    };
	};
	
	var updateCurrentUserHtpp = exports.updateCurrentUserHtpp = function updateCurrentUserHtpp(userChanges) {
	    return function (dispatch) {
	        return (0, _userService.updateMe)({ userChanges: userChanges }).then(function (updatedUser) {
	            return dispatch(updateCurrentUser({ userId: updatedUser._id, changes: updatedUser }));
	        });
	    };
	};
	
	var refreshCurrentUser = exports.refreshCurrentUser = function refreshCurrentUser() {
	    return function (dispatch) {
	        return (0, _userService.refreshMe)().then(function (response) {
	            var user = response.data.user;
	
	            dispatch((0, _userActions.refreshUser)({ userId: user._id, user: user }));
	        });
	    };
	};
	
	var setCurrentUserGuest = exports.setCurrentUserGuest = function setCurrentUserGuest() {
	    return { type: _currentUserConstants.CURRENT_USER_SET_GUEST };
	};
	
	var setUserImage = exports.setUserImage = function setUserImage(_ref3) {
	    var userId = _ref3.userId,
	        imageData = _ref3.imageData;
	    return {
	        type: _currentUserConstants.CURRENT_USER_IMAGE_SET,
	        userId: userId,
	        imageData: imageData,
	        sync: false
	    };
	};
	
	var userImageUploadCompleted = exports.userImageUploadCompleted = function userImageUploadCompleted() {
	    return {
	        type: _currentUserConstants.CURRENT_USER_IMAGE_UPLOAD_COMPLETE,
	        sync: false
	    };
	};
	
	var userImageUploadError = exports.userImageUploadError = function userImageUploadError(error) {
	    return {
	        type: _currentUserConstants.CURRENT_USER_IMAGE_UPLOAD_ERROR,
	        error: error,
	        sync: false
	    };
	};
	
	var uploadCurrentUserAvatar = exports.uploadCurrentUserAvatar = function uploadCurrentUserAvatar(userId, imageFile) {
	    return function (dispatch, getState) {
	        var state = getState();
	        var isGuest = state.getIn(['app', 'currentUser', 'isGuest']);
	
	        // Don't upload avatars for guests
	        if (isGuest) return;
	
	        // TODO Handle errors
	        // Handles orientations of JPEGs if necessary
	        return (0, _imageFileLoader2.default)(imageFile).then(function (_ref4) {
	            var file = _ref4.file,
	                imageDataUri = _ref4.imageDataUri;
	
	            dispatch(setUserImage({ userId: userId, imageData: imageDataUri }));
	
	            return _mediaService2.default.image.uploadMediaFile(file, { slug: userId, type: _mediaConstants.IMAGE_TYPES.AVATAR }).then(function (response) {
	                dispatch(userImageUploadCompleted());
	                dispatch(updateCurrentUser({ userId: userId, changes: response.data }));
	            }).catch(function (err) {
	                console.error('An error occurred while uploading the image', err, err.response);
	                dispatch(userImageUploadError(err));
	            });
	        }).catch(function (err) {
	            console.error('ERROR: reading uploaded avatar', err, err.response);
	            return Promise.reject(err);
	        });
	    };
	};
	
	var fetchCurrentUserReferrals = exports.fetchCurrentUserReferrals = function fetchCurrentUserReferrals() {
	    return function (dispatch, getState) {
	        return (0, _http.http)({ url: 'users/me/referrals' }).then(function (_ref5) {
	            var data = _ref5.data;
	
	            var userId = getState().getIn(['app', 'currentUser', '_id']);
	            var users = data.users,
	                referrals = data.referrals;
	
	
	            if (users) dispatch((0, _userActions2.loadUsers)(users));
	
	            dispatch(updateCurrentUser({
	                userId: userId,
	                changes: {
	                    referrals: referrals
	                },
	                sync: false
	            }));
	        }).catch(function (err) {
	            return null;
	        }) // not a big deal if this fails
	        ;
	    };
	};
	
	var fetchCurrentUserSubscription = exports.fetchCurrentUserSubscription = function fetchCurrentUserSubscription() {
	    return function (dispatch, getState) {
	        return (0, _http.http)({ url: 'users/me/subscription' }).then(function (_ref6) {
	            var data = _ref6.data;
	
	            var userId = getState().getIn(['app', 'currentUser', '_id']);
	            var subscription = data.subscription,
	                customer = data.customer;
	
	
	            if (!subscription && !customer) return;
	
	            dispatch(updateCurrentUser({
	                userId: userId,
	                changes: {
	                    subscription: subscription,
	                    customer: customer
	                },
	                sync: false
	            }));
	
	            var teamMembers = subscription.teamMemberIds;
	            if (teamMembers.length > 1) {
	                dispatch((0, _teamManagementActions.setTeamMembers)({ userIds: teamMembers }));
	                dispatch((0, _userActions2.trackUsers)(teamMembers));
	            }
	        }).catch(function (err) {
	            return null;
	        }) // not a big deal if this fails
	        ;
	    };
	};

/***/ }),
/* 85 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var RESOURCES_FETCHING = exports.RESOURCES_FETCHING = 'RESOURCES_FETCHING';
	var RESOURCES_FETCHED = exports.RESOURCES_FETCHED = 'RESOURCES_FETCHED';
	var RESOURCES_FETCH_ERROR = exports.RESOURCES_FETCH_ERROR = 'RESOURCES_FETCH_ERROR';
	var RESOURCES_MARKED_AS_STALE = exports.RESOURCES_MARKED_AS_STALE = 'RESOURCES_MARKED_AS_STALE';
	var RESOURCES_INVALIDATED = exports.RESOURCES_INVALIDATED = 'RESOURCES_INVALIDATED';
	
	var RESOURCE_TYPES = exports.RESOURCE_TYPES = {
	    elements: 'elements',
	    boards: 'boards',
	    users: 'users'
	};

/***/ }),
/* 86 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var currentTransactionId = 0;
	
	var getCurrentTransactionId = exports.getCurrentTransactionId = function getCurrentTransactionId() {
	    return currentTransactionId;
	};
	
	var getNewTransactionId = exports.getNewTransactionId = function getNewTransactionId() {
	    currentTransactionId++;
	    return currentTransactionId;
	};

/***/ }),
/* 87 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var IMAGE_TYPE = exports.IMAGE_TYPE = 'IMAGE';
	var IMAGE_DISPLAY_NAME = exports.IMAGE_DISPLAY_NAME = 'Image';
	
	// Image size constants
	var IMAGE_WIDTH_THUMB = exports.IMAGE_WIDTH_THUMB = 1;
	var IMAGE_WIDTH_REGULAR = exports.IMAGE_WIDTH_REGULAR = 400;
	var IMAGE_WIDTH_LARGE = exports.IMAGE_WIDTH_LARGE = 800;
	var IMAGE_WIDTH_MAX = exports.IMAGE_WIDTH_MAX = 1600;
	
	var IMAGE_MIN_WIDTH_GRID = exports.IMAGE_MIN_WIDTH_GRID = 8;
	
	var IMAGE_SIZES = exports.IMAGE_SIZES = {
	    THUMB: {
	        name: 'thumb',
	        width: IMAGE_WIDTH_THUMB
	    },
	    REGULAR: {
	        name: 'regular',
	        width: IMAGE_WIDTH_REGULAR,
	        quality: 75
	    },
	    LARGE: {
	        name: 'large',
	        width: IMAGE_WIDTH_LARGE,
	        quality: 70
	    },
	    HUGE: {
	        name: 'huge',
	        width: IMAGE_WIDTH_MAX,
	        quality: 65
	    },
	    ORIGINAL: {
	        name: 'original',
	        width: Infinity,
	        original: true
	    }
	};
	
	// Document mode
	var DOC_MODE_IMAGE_WIDTH = exports.DOC_MODE_IMAGE_WIDTH = 716;
	
	var LINKED_IMAGE_URL_PREFIX = exports.LINKED_IMAGE_URL_PREFIX = '/api/media/safe?url=';

/***/ }),
/* 88 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var MODIFIED_ELEMENTS_MARK_SEEN = exports.MODIFIED_ELEMENTS_MARK_SEEN = 'MODIFIED_ELEMENTS_MARK_SEEN';
	var MODIFIED_ELEMENTS_FORCE_POLL = exports.MODIFIED_ELEMENTS_FORCE_POLL = 'MODIFIED_ELEMENTS_FORCE_POLL';
	
	var MODIFIED_ELEMENTS_MAX = exports.MODIFIED_ELEMENTS_MAX = 10;
	
	var MODIFIED_ELEMENTS_BOARD_MESSAGES = exports.MODIFIED_ELEMENTS_BOARD_MESSAGES = {
	    INVITED: 'INVITED',
	    UPDATED: 'UPDATED'
	};
	
	var MODIFIED_ELEMENTS_MESSAGES = exports.MODIFIED_ELEMENTS_MESSAGES = {
	    CREATED: 'CREATED',
	    UPDATED: 'UPDATED'
	};
	
	var INBOX_MOVE_MEANINGFUL_DIST = exports.INBOX_MOVE_MEANINGFUL_DIST = 3;
	var CANVAS_MOVE_MEANINGFUL_DIST_SQRD = exports.CANVAS_MOVE_MEANINGFUL_DIST_SQRD = Math.pow(34, 2);
	var UPDATE_MEANINGFUL_CHANGE_KEY_LIST = exports.UPDATE_MEANINGFUL_CHANGE_KEY_LIST = ['textContent', 'caption', 'showCaption', 'image', 'link'];
	
	var MILANOTE_EMAILS = exports.MILANOTE_EMAILS = {
	    SUPPORT: 'support@milanote.com',
	    INFO: 'info@milanote.com'
	};
	
	var URL_ENCODINGS = exports.URL_ENCODINGS = {
	    NEW_LINE: '%0A',
	    TAB: '%09'
	};

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.permissionNameList = exports.isDemoBoard = exports.calculatePermissionValue = exports.isOwner = exports.canEditPermissions = exports.canSave = exports.canWrite = exports.canRead = undefined;
	
	var _permissionConstants = __webpack_require__(485);
	
	var canRead = exports.canRead = function canRead(permission) {
	    return _permissionConstants.ACCESS_BITS.READ === (permission & _permissionConstants.ACCESS_BITS.READ);
	};
	var canWrite = exports.canWrite = function canWrite(permission) {
	    return _permissionConstants.ACCESS_BITS.WRITE === (permission & _permissionConstants.ACCESS_BITS.WRITE);
	};
	var canSave = exports.canSave = function canSave(permission) {
	    return _permissionConstants.ACCESS_BITS.SAVE === (permission & _permissionConstants.ACCESS_BITS.SAVE);
	};
	var canEditPermissions = exports.canEditPermissions = function canEditPermissions(permission) {
	    return _permissionConstants.ACCESS_BITS.PERMISSIONS === (permission & _permissionConstants.ACCESS_BITS.PERMISSIONS);
	};
	var isOwner = exports.isOwner = function isOwner(permission) {
	    return _permissionConstants.ACCESS_BITS.OWNER === (permission & _permissionConstants.ACCESS_BITS.OWNER);
	};
	
	var calculatePermissionValue = exports.calculatePermissionValue = function calculatePermissionValue(_ref) {
	    var _ref$read = _ref.read,
	        read = _ref$read === undefined ? true : _ref$read,
	        _ref$write = _ref.write,
	        write = _ref$write === undefined ? true : _ref$write,
	        _ref$save = _ref.save,
	        save = _ref$save === undefined ? true : _ref$save,
	        _ref$permissions = _ref.permissions,
	        permissions = _ref$permissions === undefined ? true : _ref$permissions,
	        _ref$owner = _ref.owner,
	        owner = _ref$owner === undefined ? false : _ref$owner;
	    return (read ? _permissionConstants.ACCESS_BITS.READ : 0) + (write ? _permissionConstants.ACCESS_BITS.WRITE : 0) + (save ? _permissionConstants.ACCESS_BITS.SAVE : 0) + (permissions ? _permissionConstants.ACCESS_BITS.PERMISSIONS : 0) + (owner ? _permissionConstants.ACCESS_BITS.OWNER : 0);
	};
	
	// demo board can be read & written to, but not saved
	var isDemoBoard = exports.isDemoBoard = function isDemoBoard(permission) {
	    return canRead(permission) && canWrite(permission) && !canSave(permission);
	};
	
	var permissionNameList = exports.permissionNameList = function permissionNameList(permission) {
	    return Object.keys(_permissionConstants.ACCESS_BITS).reduce(function (acc, key) {
	        var permissionValue = _permissionConstants.ACCESS_BITS[key];
	        if (permissionValue === permission & permissionValue) acc.push(key);
	        return acc;
	    }, []);
	};

/***/ }),
/* 90 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var HEADERS = exports.HEADERS = {
	    ACCEPT: 'Accept'
	};
	
	var ERROR_CODES = exports.ERROR_CODES = {
	    CONNECTION_ABORTED: 'ECONNABORTED',
	    CONNECTION_RESET: 'ECONNRESET',
	    CONNECTION_REFUSED: 'ECONNREFUSED'
	};
	
	var METHODS = exports.METHODS = {
	    GET: 'get',
	    POST: 'post',
	    PUT: 'put',
	    DELETE: 'delete',
	    COPY: 'copy'
	};

/***/ }),
/* 91 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ }),
/* 92 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	var fails = __webpack_require__(19);
	
	module.exports = function(method, arg){
	  return !!method && fails(function(){
	    arg ? method.call(null, function(){}, 1) : method.call(null);
	  });
	};

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CharacterMetadata
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _require = __webpack_require__(28);
	
	var Map = _require.Map;
	var OrderedSet = _require.OrderedSet;
	var Record = _require.Record;
	
	
	var EMPTY_SET = OrderedSet();
	
	var defaultRecord = {
	  style: EMPTY_SET,
	  entity: null
	};
	
	var CharacterMetadataRecord = Record(defaultRecord);
	
	var CharacterMetadata = function (_CharacterMetadataRec) {
	  _inherits(CharacterMetadata, _CharacterMetadataRec);
	
	  function CharacterMetadata() {
	    _classCallCheck(this, CharacterMetadata);
	
	    return _possibleConstructorReturn(this, _CharacterMetadataRec.apply(this, arguments));
	  }
	
	  CharacterMetadata.prototype.getStyle = function getStyle() {
	    return this.get('style');
	  };
	
	  CharacterMetadata.prototype.getEntity = function getEntity() {
	    return this.get('entity');
	  };
	
	  CharacterMetadata.prototype.hasStyle = function hasStyle(style) {
	    return this.getStyle().has(style);
	  };
	
	  CharacterMetadata.applyStyle = function applyStyle(record, style) {
	    var withStyle = record.set('style', record.getStyle().add(style));
	    return CharacterMetadata.create(withStyle);
	  };
	
	  CharacterMetadata.removeStyle = function removeStyle(record, style) {
	    var withoutStyle = record.set('style', record.getStyle().remove(style));
	    return CharacterMetadata.create(withoutStyle);
	  };
	
	  CharacterMetadata.applyEntity = function applyEntity(record, entityKey) {
	    var withEntity = record.getEntity() === entityKey ? record : record.set('entity', entityKey);
	    return CharacterMetadata.create(withEntity);
	  };
	
	  /**
	   * Use this function instead of the `CharacterMetadata` constructor.
	   * Since most content generally uses only a very small number of
	   * style/entity permutations, we can reuse these objects as often as
	   * possible.
	   */
	
	
	  CharacterMetadata.create = function create(config) {
	    if (!config) {
	      return EMPTY;
	    }
	
	    // Fill in unspecified properties, if necessary.
	    var configMap = Map({ style: EMPTY_SET, entity: null }).merge(config);
	
	    var existing = pool.get(configMap);
	    if (existing) {
	      return existing;
	    }
	
	    var newCharacter = new CharacterMetadata(configMap);
	    pool = pool.set(configMap, newCharacter);
	    return newCharacter;
	  };
	
	  return CharacterMetadata;
	}(CharacterMetadataRecord);
	
	var EMPTY = new CharacterMetadata();
	var pool = Map([[Map(defaultRecord), EMPTY]]);
	
	CharacterMetadata.EMPTY = EMPTY;
	
	module.exports = CharacterMetadata;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(4);
	
	__webpack_require__(554);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	var INPUT_PROPS = [
	// HTML attributes
	'placeholder', 'type', 'value', 'defaultValue', 'disabled', 'autoComplete', 'maxLength',
	// Event listeners
	'onBlur', 'onChange', 'onFocus'];
	
	var FormInput = function (_React$Component) {
	    _inherits(FormInput, _React$Component);
	
	    function FormInput(props) {
	        _classCallCheck(this, FormInput);
	
	        var _this = _possibleConstructorReturn(this, (FormInput.__proto__ || Object.getPrototypeOf(FormInput)).call(this, props));
	
	        _this.focus = _this.focus.bind(_this);
	        return _this;
	    }
	
	    _createClass(FormInput, [{
	        key: 'focus',
	        value: function focus() {
	            this.input.focus();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                name = _props.name,
	                type = _props.type,
	                fields = _props.fields,
	                onChange = _props.onChange,
	                sanitisedErrors = _props.sanitisedErrors,
	                className = _props.className,
	                noName = _props.noName,
	                valueFormatter = _props.valueFormatter;
	
	            var field = fields[name];
	
	            var isError = sanitisedErrors[name] && sanitisedErrors[name].showError;
	
	            return _react2.default.createElement('input', _extends({ id: name
	            }, (0, _lodash.pick)(this.props, INPUT_PROPS), (0, _lodash.pick)(field, INPUT_PROPS), {
	                value: valueFormatter ? valueFormatter(field.value) : field.value,
	                ref: function ref(c) {
	                    _this2.input = c;
	                },
	                name: noName ? undefined : name,
	                type: type,
	                onChange: onChange(name),
	                className: (0, _classnames2.default)('FormInput', className, { error: isError }) }));
	        }
	    }]);
	
	    return FormInput;
	}(_react2.default.Component);
	
	FormInput.propTypes = {
	    name: _propTypes2.default.string.isRequired,
	    type: _propTypes2.default.string.isRequired,
	    fields: _propTypes2.default.object.isRequired,
	    onChange: _propTypes2.default.func.isRequired,
	    sanitisedErrors: _propTypes2.default.object,
	    className: _propTypes2.default.string,
	    noName: _propTypes2.default.bool,
	    valueFormatter: _propTypes2.default.func
	};
	
	exports.default = FormInput;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx      = __webpack_require__(113)
	  , IObject  = __webpack_require__(211)
	  , toObject = __webpack_require__(51)
	  , toLength = __webpack_require__(44)
	  , asc      = __webpack_require__(834);
	module.exports = function(TYPE, $create){
	  var IS_MAP        = TYPE == 1
	    , IS_FILTER     = TYPE == 2
	    , IS_SOME       = TYPE == 3
	    , IS_EVERY      = TYPE == 4
	    , IS_FIND_INDEX = TYPE == 6
	    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX
	    , create        = $create || asc;
	  return function($this, callbackfn, that){
	    var O      = toObject($this)
	      , self   = IObject(O)
	      , f      = ctx(callbackfn, that, 3)
	      , length = toLength(self.length)
	      , index  = 0
	      , result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined
	      , val, res;
	    for(;length > index; index++)if(NO_HOLES || index in self){
	      val = self[index];
	      res = f(val, index, O);
	      if(TYPE){
	        if(IS_MAP)result[index] = res;            // map
	        else if(res)switch(TYPE){
	          case 3: return true;                    // some
	          case 5: return val;                     // find
	          case 6: return index;                   // findIndex
	          case 2: result.push(val);               // filter
	        } else if(IS_EVERY)return false;          // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(5)
	  , core    = __webpack_require__(112)
	  , fails   = __webpack_require__(19);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(25);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ }),
/* 100 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule generateRandomKey
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var seenKeys = {};
	var MULTIPLIER = Math.pow(2, 24);
	
	function generateRandomKey() {
	  var key = void 0;
	  while (key === undefined || seenKeys.hasOwnProperty(key) || !isNaN(+key)) {
	    key = Math.floor(Math.random() * MULTIPLIER).toString(32);
	  }
	  seenKeys[key] = true;
	  return key;
	}
	
	module.exports = generateRandomKey;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var UserAgentData = __webpack_require__(1338);
	var VersionRange = __webpack_require__(1339);
	
	var mapObject = __webpack_require__(1352);
	var memoizeStringOnly = __webpack_require__(567);
	
	/**
	 * Checks to see whether `name` and `version` satisfy `query`.
	 *
	 * @param {string} name Name of the browser, device, engine or platform
	 * @param {?string} version Version of the browser, engine or platform
	 * @param {string} query Query of form "Name [range expression]"
	 * @param {?function} normalizer Optional pre-processor for range expression
	 * @return {boolean}
	 */
	function compare(name, version, query, normalizer) {
	  // check for exact match with no version
	  if (name === query) {
	    return true;
	  }
	
	  // check for non-matching names
	  if (!query.startsWith(name)) {
	    return false;
	  }
	
	  // full comparison with version
	  var range = query.slice(name.length);
	  if (version) {
	    range = normalizer ? normalizer(range) : range;
	    return VersionRange.contains(range, version);
	  }
	
	  return false;
	}
	
	/**
	 * Normalizes `version` by stripping any "NT" prefix, but only on the Windows
	 * platform.
	 *
	 * Mimics the stripping performed by the `UserAgentWindowsPlatform` PHP class.
	 *
	 * @param {string} version
	 * @return {string}
	 */
	function normalizePlatformVersion(version) {
	  if (UserAgentData.platformName === 'Windows') {
	    return version.replace(/^\s*NT/, '');
	  }
	
	  return version;
	}
	
	/**
	 * Provides client-side access to the authoritative PHP-generated User Agent
	 * information supplied by the server.
	 */
	var UserAgent = {
	  /**
	   * Check if the User Agent browser matches `query`.
	   *
	   * `query` should be a string like "Chrome" or "Chrome > 33".
	   *
	   * Valid browser names include:
	   *
	   * - ACCESS NetFront
	   * - AOL
	   * - Amazon Silk
	   * - Android
	   * - BlackBerry
	   * - BlackBerry PlayBook
	   * - Chrome
	   * - Chrome for iOS
	   * - Chrome frame
	   * - Facebook PHP SDK
	   * - Facebook for iOS
	   * - Firefox
	   * - IE
	   * - IE Mobile
	   * - Mobile Safari
	   * - Motorola Internet Browser
	   * - Nokia
	   * - Openwave Mobile Browser
	   * - Opera
	   * - Opera Mini
	   * - Opera Mobile
	   * - Safari
	   * - UIWebView
	   * - Unknown
	   * - webOS
	   * - etc...
	   *
	   * An authoritative list can be found in the PHP `BrowserDetector` class and
	   * related classes in the same file (see calls to `new UserAgentBrowser` here:
	   * https://fburl.com/50728104).
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "Name [range expression]"
	   * @return {boolean}
	   */
	  isBrowser: function isBrowser(query) {
	    return compare(UserAgentData.browserName, UserAgentData.browserFullVersion, query);
	  },
	
	
	  /**
	   * Check if the User Agent browser uses a 32 or 64 bit architecture.
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "32" or "64".
	   * @return {boolean}
	   */
	  isBrowserArchitecture: function isBrowserArchitecture(query) {
	    return compare(UserAgentData.browserArchitecture, null, query);
	  },
	
	
	  /**
	   * Check if the User Agent device matches `query`.
	   *
	   * `query` should be a string like "iPhone" or "iPad".
	   *
	   * Valid device names include:
	   *
	   * - Kindle
	   * - Kindle Fire
	   * - Unknown
	   * - iPad
	   * - iPhone
	   * - iPod
	   * - etc...
	   *
	   * An authoritative list can be found in the PHP `DeviceDetector` class and
	   * related classes in the same file (see calls to `new UserAgentDevice` here:
	   * https://fburl.com/50728332).
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "Name"
	   * @return {boolean}
	   */
	  isDevice: function isDevice(query) {
	    return compare(UserAgentData.deviceName, null, query);
	  },
	
	
	  /**
	   * Check if the User Agent rendering engine matches `query`.
	   *
	   * `query` should be a string like "WebKit" or "WebKit >= 537".
	   *
	   * Valid engine names include:
	   *
	   * - Gecko
	   * - Presto
	   * - Trident
	   * - WebKit
	   * - etc...
	   *
	   * An authoritative list can be found in the PHP `RenderingEngineDetector`
	   * class related classes in the same file (see calls to `new
	   * UserAgentRenderingEngine` here: https://fburl.com/50728617).
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "Name [range expression]"
	   * @return {boolean}
	   */
	  isEngine: function isEngine(query) {
	    return compare(UserAgentData.engineName, UserAgentData.engineVersion, query);
	  },
	
	
	  /**
	   * Check if the User Agent platform matches `query`.
	   *
	   * `query` should be a string like "Windows" or "iOS 5 - 6".
	   *
	   * Valid platform names include:
	   *
	   * - Android
	   * - BlackBerry OS
	   * - Java ME
	   * - Linux
	   * - Mac OS X
	   * - Mac OS X Calendar
	   * - Mac OS X Internet Account
	   * - Symbian
	   * - SymbianOS
	   * - Windows
	   * - Windows Mobile
	   * - Windows Phone
	   * - iOS
	   * - iOS Facebook Integration Account
	   * - iOS Facebook Social Sharing UI
	   * - webOS
	   * - Chrome OS
	   * - etc...
	   *
	   * An authoritative list can be found in the PHP `PlatformDetector` class and
	   * related classes in the same file (see calls to `new UserAgentPlatform`
	   * here: https://fburl.com/50729226).
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "Name [range expression]"
	   * @return {boolean}
	   */
	  isPlatform: function isPlatform(query) {
	    return compare(UserAgentData.platformName, UserAgentData.platformFullVersion, query, normalizePlatformVersion);
	  },
	
	
	  /**
	   * Check if the User Agent platform is a 32 or 64 bit architecture.
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "32" or "64".
	   * @return {boolean}
	   */
	  isPlatformArchitecture: function isPlatformArchitecture(query) {
	    return compare(UserAgentData.platformArchitecture, null, query);
	  }
	};
	
	module.exports = mapObject(UserAgent, memoizeStringOnly);

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21),
	    _assign = __webpack_require__(20);
	
	var CallbackQueue = __webpack_require__(606);
	var PooledClass = __webpack_require__(163);
	var ReactFeatureFlags = __webpack_require__(611);
	var ReactReconciler = __webpack_require__(189);
	var Transaction = __webpack_require__(279);
	
	var invariant = __webpack_require__(10);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reduxForm = __webpack_require__(415);
	
	var _lodash = __webpack_require__(4);
	
	var _validationService = __webpack_require__(2298);
	
	var _validationService2 = _interopRequireDefault(_validationService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getFormState = function getFormState(state, reduxMountPoint) {
	    return state.get(reduxMountPoint);
	};
	
	exports.default = function (config, customMapStateToForm) {
	    return function (DecoratedComponent) {
	        var _dec, _class;
	
	        /**
	         *
	         * @param values
	         * @param props
	         * @returns {{}}
	         */
	        var validate = function validate(values, props) {
	            return (0, _validationService2.default)(values, config.fieldsConfig).errors;
	        };
	
	        var defaultConfig = {
	            getFormState: getFormState,
	            touchOnChange: true,
	            touchOnBlur: false,
	            validate: validate
	        };
	
	        // Create the redux form config by combining the input config with the default config
	        var reduxFormConfig = _extends({}, defaultConfig, config, {
	            fields: Object.keys(config.fieldsConfig)
	        });
	
	        var internalMapStateToForm = function internalMapStateToForm(state) {
	            var customState = customMapStateToForm ? customMapStateToForm(state) : undefined;
	
	            var form = state.get('form')[config.form];
	
	            return _extends({}, customState, {
	                primaryError: form && form.primaryError
	            });
	        };
	
	        var MilanoteForm = (_dec = (0, _reduxForm.reduxForm)(reduxFormConfig, internalMapStateToForm), _dec(_class = function (_React$Component) {
	            _inherits(MilanoteForm, _React$Component);
	
	            _createClass(MilanoteForm, null, [{
	                key: 'showError',
	                value: function showError(_ref) {
	                    var field = _ref.field,
	                        submitFailed = _ref.submitFailed,
	                        currentErrorMessage = _ref.currentErrorMessage,
	                        awaitingDebounce = _ref.awaitingDebounce;
	
	                    // If there's no errors, don't show any validation messages
	                    var isError = !field.isValid && field.error;
	                    if (!isError) return false;
	
	                    // If the error message hasn't changed, then continue to show it
	                    if (currentErrorMessage && currentErrorMessage === field.error.message) return true;
	
	                    // Show the error if it should be shown before submit or it shouldn't be shown before submit, but there's been a
	                    // submission
	                    return (!field.error.hideBeforeSubmit || field.error.hideBeforeSubmit && submitFailed) && (
	                    // And only show if it should be shown when touched, or it shouldn't and the field hasn't been touched
	                    !field.error.hideIfTouched || field.error.hideIfTouched && !field.touched)
	                    // And only show if the error is not debounced, or it is debounced and the field is not active or we're
	                    // not waiting for the debounce to finish
	                    && (!field.error.debounced || field.error.debounced && (!field.active || !awaitingDebounce));
	                }
	            }]);
	
	            function MilanoteForm(props) {
	                _classCallCheck(this, MilanoteForm);
	
	                var _this = _possibleConstructorReturn(this, (MilanoteForm.__proto__ || Object.getPrototypeOf(MilanoteForm)).call(this, props));
	
	                var debounceHandler = (0, _lodash.debounce)(function () {
	                    _this.debounce.waiting = false;
	                    _this.getErrorMessages(_this.props);
	                }, 3000);
	
	                _this.debounce = {
	                    waiting: false,
	                    handler: debounceHandler
	                };
	
	                _this.state = {
	                    newSubmission: false,
	                    sanitisedErrors: {},
	                    showingErrors: false,
	                    dirtySinceSubmission: false
	                };
	
	                _this.onChange = _this.onChange.bind(_this);
	                _this.submitInterceptor = _this.submitInterceptor.bind(_this);
	
	                _this.getSanitisedError = _this.getSanitisedError.bind(_this);
	                _this.getErrorMessages = _this.getErrorMessages.bind(_this);
	                return _this;
	            }
	
	            /**
	             * Whenever the validation error messages change we need to check to see if we should show them.
	             */
	
	
	            _createClass(MilanoteForm, [{
	                key: 'componentWillReceiveProps',
	                value: function componentWillReceiveProps(nextProps) {
	                    this.getErrorMessages(nextProps);
	                }
	            }, {
	                key: 'componentWillUpdate',
	                value: function componentWillUpdate(nextProps, nextState) {
	                    var newSubmission = nextState.newSubmission;
	
	
	                    if (newSubmission) {
	                        var untouchAll = nextProps.untouchAll;
	
	                        untouchAll();
	                        this.setState({ newSubmission: false });
	                    }
	                }
	
	                /**
	                 * Cancel the debounce timer when unmounting.
	                 */
	
	            }, {
	                key: 'componentWillUnmount',
	                value: function componentWillUnmount() {
	                    this.debounce.handler.cancel();
	                }
	
	                /**
	                 * Inercept the usual field onChange handler to begin the debounce tiemr.
	                 */
	
	            }, {
	                key: 'onChange',
	                value: function onChange(fieldName) {
	                    var _this2 = this;
	
	                    return function (event) {
	                        var fields = _this2.props.fields;
	
	
	                        _this2.debounce.waiting = true;
	                        _this2.debounce.handler();
	
	                        _this2.setState({
	                            dirtySinceSubmission: true
	                        });
	
	                        fields[fieldName].onChange(event);
	                    };
	                }
	
	                /**
	                 * Loops through every field and determines the sanitised error (based on the validation errors and the current
	                 * state of the form - i.e. if the user is still typing).
	                 */
	
	            }, {
	                key: 'getErrorMessages',
	                value: function getErrorMessages(props) {
	                    var fields = props.fields;
	
	
	                    var sanitisedErrors = {};
	                    var showingErrors = false;
	                    for (var fieldName in fields) {
	                        if (!fields.hasOwnProperty(fieldName)) continue;
	
	                        sanitisedErrors[fieldName] = this.getSanitisedError(props, fieldName);
	                        showingErrors = showingErrors || sanitisedErrors[fieldName].showError;
	                    }
	                    this.setState({ sanitisedErrors: sanitisedErrors, showingErrors: showingErrors });
	                }
	
	                /**
	                 * Get an error object describing whether an error should be shown for the specified field, and what the error
	                 * message, if any, should be.
	                 */
	
	            }, {
	                key: 'getSanitisedError',
	                value: function getSanitisedError(props, fieldName) {
	                    var fields = props.fields,
	                        submitFailed = props.submitFailed;
	
	                    var field = fields[fieldName];
	
	                    var sanitisedError = {};
	                    var currentErrorMessage = this.state.sanitisedErrors[fieldName] && this.state.sanitisedErrors[fieldName].message;
	                    var awaitingDebounce = this.debounce.waiting;
	
	                    sanitisedError.showError = MilanoteForm.showError({
	                        submitFailed: submitFailed,
	                        field: field,
	                        currentErrorMessage: currentErrorMessage,
	                        awaitingDebounce: awaitingDebounce
	                    });
	
	                    sanitisedError.message = sanitisedError.showError ? field.error.message : null;
	
	                    return sanitisedError;
	                }
	
	                /**
	                 * Intercepts the submission to first set state so that the componentWillUpdate can recognise that a submission
	                 * has just occurred.
	                 */
	
	            }, {
	                key: 'submitInterceptor',
	                value: function submitInterceptor(event) {
	                    var handleSubmit = this.props.handleSubmit;
	
	                    // Set the state to say a new submission was attempted so the componentWillUpdate can set the state of
	                    // fields correctly so that validation errors will be displayed
	
	                    this.setState({ newSubmission: true, dirtySinceSubmission: false });
	
	                    // Force the debounce handlers to fire immediately on submission
	                    this.debounce.handler.flush();
	
	                    handleSubmit(event);
	                }
	            }, {
	                key: 'render',
	                value: function render() {
	                    var _state = this.state,
	                        sanitisedErrors = _state.sanitisedErrors,
	                        showingErrors = _state.showingErrors,
	                        dirtySinceSubmission = _state.dirtySinceSubmission;
	
	                    return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, {
	                        submitInterceptor: this.submitInterceptor,
	                        onChange: this.onChange,
	                        sanitisedErrors: sanitisedErrors,
	                        showingErrors: showingErrors,
	                        dirtySinceSubmission: dirtySinceSubmission }));
	                }
	            }]);
	
	            return MilanoteForm;
	        }(_react2.default.Component)) || _class);
	
	
	        MilanoteForm.propTypes = {
	            handleSubmit: _propTypes2.default.func,
	            submitFailed: _propTypes2.default.bool,
	            fields: _propTypes2.default.object
	        };
	
	        return MilanoteForm;
	    };
	};

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getDomElementId = exports.elementClassNames = exports.getPhysicalAncestorIds = exports.hasRetrievedAllAncestors = undefined;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns true if an elements entire ancestor tree has been retrieved.
	 */
	var hasRetrievedAllAncestors = exports.hasRetrievedAllAncestors = function hasRetrievedAllAncestors(elements, elementId) {
	    var element = elements.get(elementId);
	
	    if (!element) return false;
	
	    var hasRetrievedAncestors = true;
	    var prevElement = element;
	
	    while (element && hasRetrievedAncestors) {
	        hasRetrievedAncestors = hasRetrievedAncestors && !!element.get('location');
	        prevElement = element;
	        var parentId = element.getIn(['location', 'parentId']);
	        element = elements.get(parentId);
	    }
	
	    var lastElementIsRoot = prevElement.getIn(['location', 'rootBoard']);
	    return lastElementIsRoot && hasRetrievedAncestors;
	};
	
	/**
	 * Gets the actual ancestors in the element's "physical" location.
	 * This will only iterate over the 'parentIds' of each ancestor and will not consider aliases.
	 */
	// Lib
	var getPhysicalAncestorIds = exports.getPhysicalAncestorIds = function getPhysicalAncestorIds(elements, elementId) {
	    var ancestors = [];
	    var currentElementId = elementId;
	    while (currentElementId) {
	        ancestors.push(currentElementId);
	        var element = elements.get(currentElementId);
	        currentElementId = element && !element.getIn(['location', 'rootBoard']) ? element.getIn(['location', 'parentId']) : null;
	    }
	    return ancestors;
	};
	
	var elementClassNames = exports.elementClassNames = function elementClassNames(prefix, props) {
	    var inList = props.inList,
	        isEditing = props.isEditing,
	        isSelected = props.isSelected,
	        isSingleSelected = props.isSingleSelected,
	        isRemotelySelected = props.isRemotelySelected,
	        isHovered = props.isHovered,
	        canDrop = props.canDrop,
	        className = props.className,
	        isLocked = props.isLocked,
	        filter = props.filter,
	        isLineEdgeHovered = props.isLineEdgeHovered,
	        transparent = props.transparent;
	
	
	    return (0, _classnames2.default)(prefix, inList, className, filter, {
	        editing: isEditing,
	        selected: isSelected,
	        'selected-single': isSingleSelected,
	        'remote-selected': isRemotelySelected,
	        'can-drop': isHovered && canDrop,
	        locked: isLocked,
	        'line-edge-can-drop': isLineEdgeHovered,
	        transparent: transparent
	    });
	};
	
	var getDomElementId = exports.getDomElementId = function getDomElementId(elementId) {
	    return 'el-' + elementId;
	};

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getOrInviteUser = exports.getUser = exports.fetchUsers = exports.checkIdleUsers = exports.fetchUserActivity = exports.refreshMe = exports.updateMe = exports.fetchMe = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _http = __webpack_require__(76);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _resources = __webpack_require__(469);
	
	var _resources2 = _interopRequireDefault(_resources);
	
	var _userActions = __webpack_require__(758);
	
	var _userHelper = __webpack_require__(175);
	
	var _userUtil = __webpack_require__(31);
	
	var _resourceUtil = __webpack_require__(108);
	
	var _usersSelector = __webpack_require__(204);
	
	var _currentUserSelector = __webpack_require__(33);
	
	var _remoteUsersSelector = __webpack_require__(237);
	
	var _httpConstants = __webpack_require__(90);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Selectors
	
	
	// Actions
	
	
	// Utils
	var fetchMe = exports.fetchMe = function fetchMe() {
	    var timezone = new Date().getTimezoneOffset();
	    return (0, _http2.default)({ url: 'users/me', timeout: 30000, retry: 1, params: { timezone: timezone } });
	};
	
	// Constants
	
	
	// Utils
	// Lib
	var updateMe = exports.updateMe = function updateMe(_ref) {
	    var userChanges = _ref.userChanges;
	    return (0, _http2.default)({ url: 'users/me', method: _httpConstants.METHODS.PUT, timeout: 10000, retry: 1, data: { userChanges: userChanges } }).then(function (response) {
	        return response.data;
	    });
	};
	
	var refreshMe = exports.refreshMe = function refreshMe() {
	    return (0, _http2.default)({ url: 'users/me/refresh', timeout: 10000 });
	};
	
	var userResourcesService = (0, _resources2.default)('users');
	
	/**
	 * Retrieves just the user activity details for the specified user IDs.
	 */
	var fetchUserActivity = exports.fetchUserActivity = function fetchUserActivity(userIds) {
	    return function (dispatch, getState) {
	        var state = getState();
	
	        var isGuest = (0, _currentUserSelector.isGuestSelector)(state);
	        if (isGuest) return;
	
	        var currentUserId = (0, _currentUserSelector.getCurrentUserId)(state);
	        var userIdsToFetch = userIds.filter((0, _userHelper.isNotUserId)(currentUserId));
	
	        if (!userIdsToFetch.length) return Promise.resolve();
	
	        var usersActivityHttpConf = {
	            url: 'users/activity',
	            params: {
	                ids: userIdsToFetch.join(',')
	            }
	        };
	
	        // First retrieve the users' activity data
	        return (0, _http2.default)(usersActivityHttpConf).then(function (response) {
	            var users = response.data.users;
	
	            var disconnectedUserIds = (0, _lodash.difference)(userIdsToFetch, (0, _lodash.keys)(users));
	            dispatch((0, _userActions.userActivityLoad)({ users: users, disconnectedUserIds: disconnectedUserIds }));
	            return response;
	        }).catch(function (err) {
	            dispatch((0, _userActions.userActivityError)(userIdsToFetch, err));
	            return Promise.reject(err);
	        });
	    };
	};
	
	/**
	 * Checks for all idle users and retrieves their updated activity information if any are found.
	 */
	var checkIdleUsers = exports.checkIdleUsers = function checkIdleUsers() {
	    return function (dispatch, getState) {
	        var state = getState();
	        var idleUserIds = (0, _remoteUsersSelector.getIdleOnlineUserIds)(state);
	
	        if (!idleUserIds.length) return;
	
	        return dispatch(fetchUserActivity(idleUserIds));
	    };
	};
	
	/**
	 * Retrieves the user details as well as the user activity for the specified user IDs.
	 */
	var fetchUsers = exports.fetchUsers = function fetchUsers(userIds) {
	    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    return function (dispatch, getState) {
	        var state = getState();
	        var userResources = (0, _usersSelector.userResourcesSelector)(state);
	        var getUserResource = (0, _userUtil.getUserFn)(userResources);
	
	        var isGuest = (0, _currentUserSelector.isGuestSelector)(state);
	        if (isGuest) return;
	
	        var missingUserIds = userIds.filter(_userHelper.isRealUserId).filter(function (userId) {
	            return (0, _resourceUtil.shouldFetchResource)(force, getUserResource(userId));
	        });
	
	        if (!missingUserIds.length) {
	            return;
	        }
	
	        dispatch(fetchUserActivity(missingUserIds));
	
	        return userResourcesService({ dispatch: dispatch, config: { retry: 3 }, ids: missingUserIds }).then(function (response) {
	            dispatch((0, _userActions.loadUsers)(response.data.users));
	            return response;
	        });
	    };
	};
	
	var getUser = exports.getUser = function getUser(_ref2) {
	    var userId = _ref2.userId,
	        _ref2$force = _ref2.force,
	        force = _ref2$force === undefined ? false : _ref2$force;
	    return function (dispatch, getState) {
	        if (!userId) {
	            return Promise.reject('Must provide a user ID.');
	        }
	
	        // The public/guest/_other user ID is not a real user, so don't fetch it
	        if (!(0, _userHelper.isRealUserId)(userId)) return;
	
	        var state = getState();
	        var users = state.get('users');
	        var userResources = (0, _usersSelector.userResourcesSelector)(state);
	
	        var userResource = userResources.get(userId);
	        if (!(0, _resourceUtil.shouldFetchResource)(force, userResource)) {
	            var user = users.get(userId);
	            return Promise.resolve(user.toJS());
	        }
	
	        return userResourcesService({ dispatch: dispatch, id: userId }).then(function (response) {
	            var userData = response.data.user;
	            dispatch((0, _userActions.loadUser)(userData));
	            return userData;
	        });
	    };
	};
	
	var getOrInviteUser = exports.getOrInviteUser = function getOrInviteUser(_ref3) {
	    var userEmail = _ref3.userEmail;
	    return function (dispatch, getState) {
	        if (!userEmail) {
	            return Promise.reject('Must provide a user email.');
	        }
	
	        var lowerCaseUserEmail = userEmail.toLowerCase();
	        var state = getState();
	        var users = state.get('users');
	
	        var filteredUsers = users.filter(function (userEntry) {
	            return userEntry.get('email') === lowerCaseUserEmail;
	        });
	        var user = filteredUsers.size ? filteredUsers.first() : null;
	
	        if (user) return Promise.resolve(user.toJS());
	
	        var userReq = {
	            method: _httpConstants.METHODS.POST,
	            url: 'users/get-or-invite',
	            data: {
	                email: lowerCaseUserEmail
	            },
	            retry: 3
	        };
	
	        return (0, _http2.default)(userReq).then(function (response) {
	            var userData = response.data.user;
	            dispatch((0, _userActions.loadUser)(userData));
	            return userData;
	        });
	    };
	};

/***/ }),
/* 107 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var isDOMNodeInView = exports.isDOMNodeInView = function isDOMNodeInView(domNode) {
	    var rect = domNode.getBoundingClientRect();
	    return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
	};
	
	var stopPropagationOnly = exports.stopPropagationOnly = function stopPropagationOnly(event) {
	    return event.stopPropagation();
	};
	
	var selectAndCopyInput = exports.selectAndCopyInput = function selectAndCopyInput(event) {
	    event.target.setSelectionRange(0, event.target.value.length);
	    document.execCommand('copy');
	};

/***/ }),
/* 108 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var isFetched = exports.isFetched = function isFetched(resource) {
	  return resource && resource.get('fetched') || false;
	};
	var isFetching = exports.isFetching = function isFetching(resource) {
	  return resource && resource.get('fetching') || false;
	};
	var isError = exports.isError = function isError(resource) {
	  return resource && resource.get('hasError') && !isFetching(resource);
	};
	
	/**
	 * If:
	 * - we're not currently fetching, and
	 * - we're forcing a fetch, or, we haven't fetched the element
	 * Then we should fetch the element.
	 */
	var shouldFetchResource = exports.shouldFetchResource = function shouldFetchResource(force, resource) {
	  return !isFetching(resource) && (force || !isFetched(resource));
	};

/***/ }),
/* 109 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SOCKET_CONNECTION_STATUS = exports.SOCKET_CONNECTION_STATUS = {
	    CONNECTED: 'CONNECTED',
	    DISCONNECTED: 'DISCONNECTED'
	};
	
	var SOCKET_CONNECT = exports.SOCKET_CONNECT = 'SOCKET_CONNECT';
	var SOCKET_DISCONNECT = exports.SOCKET_DISCONNECT = 'SOCKET_DISCONNECT';
	
	var CHANNELS_UPDATED = exports.CHANNELS_UPDATED = 'CHANNELS_UPDATED';
	
	var SOCKET_DISCONNECT_FETCH_TIMEOUT = exports.SOCKET_DISCONNECT_FETCH_TIMEOUT = 1000 * 30; // 30 seconds
	
	var LIVE_ACTIVITY_SUFFIX = exports.LIVE_ACTIVITY_SUFFIX = '-LIVE';

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1310);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tool = function Tool(props) {
	    var classes = { dragging: props.isDragging, active: props.isActive, draggable: props.isDraggable };
	
	    var toolNameElement = props.name ? _react2.default.createElement(
	        'span',
	        { className: 'tool-name' },
	        props.name
	    ) : null;
	
	    return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('Tool', props.className, classes),
	            onClick: props.handleClick,
	            onMouseDown: props.handleMouseDown,
	            title: props.tooltip },
	        _react2.default.createElement(
	            'div',
	            { className: 'icon' },
	            props.children
	        ),
	        toolNameElement
	    );
	};
	
	// Styles
	
	
	Tool.propTypes = {
	    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array]).isRequired,
	    name: _propTypes2.default.string,
	    iconName: _propTypes2.default.string,
	    isDraggable: _propTypes2.default.bool,
	    isDragging: _propTypes2.default.bool,
	    isActive: _propTypes2.default.bool,
	    handleClick: _propTypes2.default.func,
	    handleMouseDown: _propTypes2.default.func,
	    className: _propTypes2.default.string,
	    tooltip: _propTypes2.default.string
	};
	
	exports.default = Tool;

/***/ }),
/* 111 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CARD_TYPE = exports.CARD_TYPE = 'CARD';
	var CARD_DISPLAY_NAME = exports.CARD_DISPLAY_NAME = 'Note';

/***/ }),
/* 112 */
/***/ (function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(67);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	var Map     = __webpack_require__(523)
	  , $export = __webpack_require__(5)
	  , shared  = __webpack_require__(257)('metadata')
	  , store   = shared.store || (shared.store = new (__webpack_require__(526)));
	
	var getOrCreateMetadataMap = function(target, targetKey, create){
	  var targetMetadata = store.get(target);
	  if(!targetMetadata){
	    if(!create)return undefined;
	    store.set(target, targetMetadata = new Map);
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if(!keyMetadata){
	    if(!create)return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map);
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function(MetadataKey, O, P){
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function(MetadataKey, O, P){
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function(MetadataKey, MetadataValue, O, P){
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function(target, targetKey){
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false)
	    , keys        = [];
	  if(metadataMap)metadataMap.forEach(function(_, key){ keys.push(key); });
	  return keys;
	};
	var toMetaKey = function(it){
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function(O){
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	if(__webpack_require__(37)){
	  var LIBRARY             = __webpack_require__(150)
	    , global              = __webpack_require__(15)
	    , fails               = __webpack_require__(19)
	    , $export             = __webpack_require__(5)
	    , $typed              = __webpack_require__(258)
	    , $buffer             = __webpack_require__(350)
	    , ctx                 = __webpack_require__(113)
	    , anInstance          = __webpack_require__(149)
	    , propertyDesc        = __webpack_require__(131)
	    , hide                = __webpack_require__(68)
	    , redefineAll         = __webpack_require__(154)
	    , toInteger           = __webpack_require__(132)
	    , toLength            = __webpack_require__(44)
	    , toIndex             = __webpack_require__(156)
	    , toPrimitive         = __webpack_require__(99)
	    , has                 = __webpack_require__(62)
	    , same                = __webpack_require__(520)
	    , classof             = __webpack_require__(210)
	    , isObject            = __webpack_require__(25)
	    , toObject            = __webpack_require__(51)
	    , isArrayIter         = __webpack_require__(335)
	    , create              = __webpack_require__(151)
	    , getPrototypeOf      = __webpack_require__(80)
	    , gOPN                = __webpack_require__(152).f
	    , getIterFn           = __webpack_require__(352)
	    , uid                 = __webpack_require__(157)
	    , wks                 = __webpack_require__(29)
	    , createArrayMethod   = __webpack_require__(97)
	    , createArrayIncludes = __webpack_require__(248)
	    , speciesConstructor  = __webpack_require__(344)
	    , ArrayIterators      = __webpack_require__(353)
	    , Iterators           = __webpack_require__(179)
	    , $iterDetect         = __webpack_require__(254)
	    , setSpecies          = __webpack_require__(155)
	    , arrayFill           = __webpack_require__(328)
	    , arrayCopyWithin     = __webpack_require__(500)
	    , $DP                 = __webpack_require__(38)
	    , $GOPD               = __webpack_require__(79)
	    , dP                  = $DP.f
	    , gOPD                = $GOPD.f
	    , RangeError          = global.RangeError
	    , TypeError           = global.TypeError
	    , Uint8Array          = global.Uint8Array
	    , ARRAY_BUFFER        = 'ArrayBuffer'
	    , SHARED_BUFFER       = 'Shared' + ARRAY_BUFFER
	    , BYTES_PER_ELEMENT   = 'BYTES_PER_ELEMENT'
	    , PROTOTYPE           = 'prototype'
	    , ArrayProto          = Array[PROTOTYPE]
	    , $ArrayBuffer        = $buffer.ArrayBuffer
	    , $DataView           = $buffer.DataView
	    , arrayForEach        = createArrayMethod(0)
	    , arrayFilter         = createArrayMethod(2)
	    , arraySome           = createArrayMethod(3)
	    , arrayEvery          = createArrayMethod(4)
	    , arrayFind           = createArrayMethod(5)
	    , arrayFindIndex      = createArrayMethod(6)
	    , arrayIncludes       = createArrayIncludes(true)
	    , arrayIndexOf        = createArrayIncludes(false)
	    , arrayValues         = ArrayIterators.values
	    , arrayKeys           = ArrayIterators.keys
	    , arrayEntries        = ArrayIterators.entries
	    , arrayLastIndexOf    = ArrayProto.lastIndexOf
	    , arrayReduce         = ArrayProto.reduce
	    , arrayReduceRight    = ArrayProto.reduceRight
	    , arrayJoin           = ArrayProto.join
	    , arraySort           = ArrayProto.sort
	    , arraySlice          = ArrayProto.slice
	    , arrayToString       = ArrayProto.toString
	    , arrayToLocaleString = ArrayProto.toLocaleString
	    , ITERATOR            = wks('iterator')
	    , TAG                 = wks('toStringTag')
	    , TYPED_CONSTRUCTOR   = uid('typed_constructor')
	    , DEF_CONSTRUCTOR     = uid('def_constructor')
	    , ALL_CONSTRUCTORS    = $typed.CONSTR
	    , TYPED_ARRAY         = $typed.TYPED
	    , VIEW                = $typed.VIEW
	    , WRONG_LENGTH        = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function(O, length){
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function(){
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function(){
	    new Uint8Array(1).set({});
	  });
	
	  var strictToLength = function(it, SAME){
	    if(it === undefined)throw TypeError(WRONG_LENGTH);
	    var number = +it
	      , length = toLength(it);
	    if(SAME && !same(number, length))throw RangeError(WRONG_LENGTH);
	    return length;
	  };
	
	  var toOffset = function(it, BYTES){
	    var offset = toInteger(it);
	    if(offset < 0 || offset % BYTES)throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function(it){
	    if(isObject(it) && TYPED_ARRAY in it)return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function(C, length){
	    if(!(isObject(C) && TYPED_CONSTRUCTOR in C)){
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function(O, list){
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function(C, list){
	    var index  = 0
	      , length = list.length
	      , result = allocate(C, length);
	    while(length > index)result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function(it, key, internal){
	    dP(it, key, {get: function(){ return this._d[internal]; }});
	  };
	
	  var $from = function from(source /*, mapfn, thisArg */){
	    var O       = toObject(source)
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , iterFn  = getIterFn(O)
	      , i, length, values, result, step, iterator;
	    if(iterFn != undefined && !isArrayIter(iterFn)){
	      for(iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++){
	        values.push(step.value);
	      } O = values;
	    }
	    if(mapping && aLen > 2)mapfn = ctx(mapfn, arguments[2], 2);
	    for(i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++){
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/*...items*/){
	    var index  = 0
	      , length = arguments.length
	      , result = allocate(this, length);
	    while(length > index)result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function(){ arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString(){
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /*, end */){
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /*, thisArg */){
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /*, start, end */){ // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /*, thisArg */){
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /*, thisArg */){
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /*, thisArg */){
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /*, thisArg */){
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /*, fromIndex */){
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /*, fromIndex */){
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator){ // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /*, fromIndex */){ // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /*, thisArg */){
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse(){
	      var that   = this
	        , length = validate(that).length
	        , middle = Math.floor(length / 2)
	        , index  = 0
	        , value;
	      while(index < middle){
	        value         = that[index];
	        that[index++] = that[--length];
	        that[length]  = value;
	      } return that;
	    },
	    some: function some(callbackfn /*, thisArg */){
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn){
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end){
	      var O      = validate(this)
	        , length = O.length
	        , $begin = toIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end){
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /*, offset */){
	    validate(this);
	    var offset = toOffset(arguments[1], 1)
	      , length = this.length
	      , src    = toObject(arrayLike)
	      , len    = toLength(src.length)
	      , index  = 0;
	    if(len + offset > length)throw RangeError(WRONG_LENGTH);
	    while(index < len)this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries(){
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys(){
	      return arrayKeys.call(validate(this));
	    },
	    values: function values(){
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function(target, key){
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key){
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc){
	    if(isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ){
	      target[key] = desc.value;
	      return target;
	    } else return dP(target, key, desc);
	  };
	
	  if(!ALL_CONSTRUCTORS){
	    $GOPD.f = $getDesc;
	    $DP.f   = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty:           $setDesc
	  });
	
	  if(fails(function(){ arrayToString.call({}); })){
	    arrayToString = arrayToLocaleString = function toString(){
	      return arrayJoin.call(this);
	    }
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice:          $slice,
	    set:            $set,
	    constructor:    function(){ /* noop */ },
	    toString:       arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function(){ return this[TYPED_ARRAY]; }
	  });
	
	  module.exports = function(KEY, BYTES, wrapper, CLAMPED){
	    CLAMPED = !!CLAMPED;
	    var NAME       = KEY + (CLAMPED ? 'Clamped' : '') + 'Array'
	      , ISNT_UINT8 = NAME != 'Uint8Array'
	      , GETTER     = 'get' + KEY
	      , SETTER     = 'set' + KEY
	      , TypedArray = global[NAME]
	      , Base       = TypedArray || {}
	      , TAC        = TypedArray && getPrototypeOf(TypedArray)
	      , FORCED     = !TypedArray || !$typed.ABV
	      , O          = {}
	      , TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function(that, index){
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function(that, index, value){
	      var data = that._d;
	      if(CLAMPED)value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function(that, index){
	      dP(that, index, {
	        get: function(){
	          return getter(this, index);
	        },
	        set: function(value){
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if(FORCED){
	      TypedArray = wrapper(function(that, data, $offset, $length){
	        anInstance(that, TypedArray, NAME, '_d');
	        var index  = 0
	          , offset = 0
	          , buffer, byteLength, length, klass;
	        if(!isObject(data)){
	          length     = strictToLength(data, true)
	          byteLength = length * BYTES;
	          buffer     = new $ArrayBuffer(byteLength);
	        } else if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if($length === undefined){
	            if($len % BYTES)throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if(byteLength < 0)throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if(byteLength + offset > $len)throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if(TYPED_ARRAY in data){
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while(index < length)addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if(!$iterDetect(function(iter){
	      // V8 works with iterators, but fails in many other cases
	      // https://code.google.com/p/v8/issues/detail?id=4552
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)){
	      TypedArray = wrapper(function(that, data, $offset, $length){
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if(!isObject(data))return new Base(strictToLength(data, ISNT_UINT8));
	        if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if(TYPED_ARRAY in data)return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function(key){
	        if(!(key in TypedArray))hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if(!LIBRARY)TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator   = TypedArrayPrototype[ITERATOR]
	      , CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined)
	      , $iterator         = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if(CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)){
	      dP(TypedArrayPrototype, TAG, {
	        get: function(){ return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES,
	      from: $from,
	      of: $of
	    });
	
	    if(!(BYTES_PER_ELEMENT in TypedArrayPrototype))hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, {set: $set});
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    $export($export.P + $export.F * (TypedArrayPrototype.toString != arrayToString), NAME, {toString: arrayToString});
	
	    $export($export.P + $export.F * fails(function(){
	      new TypedArray(1).slice();
	    }), NAME, {slice: $slice});
	
	    $export($export.P + $export.F * (fails(function(){
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString()
	    }) || !fails(function(){
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, {toLocaleString: $toLocaleString});
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if(!LIBRARY && !CORRECT_ITER_NAME)hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function(){ /* empty */ };

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(1013);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // NB: In an Electron preload script, document will be defined but not fully
	  // initialized. Since we know we're in Chrome, we'll just detect this case
	  // explicitly
	  if (typeof window !== 'undefined' && window && typeof window.process !== 'undefined' && window.process.type === 'renderer') {
	    return true;
	  }
	
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && document && 'WebkitAppearance' in document.documentElement.style) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (typeof window !== 'undefined' && window && window.console && (console.firebug || (console.exception && console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (typeof navigator !== 'undefined' && navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
	    // double check webkit in userAgent just in case we are in a worker
	    (typeof navigator !== 'undefined' && navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs(args) {
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return;
	
	  var c = 'color: ' + this.color;
	  args.splice(1, 0, c, 'color: inherit')
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-zA-Z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (!r && typeof process !== 'undefined' && 'env' in process) {
	    r = ({"BROWSER":true,"NODE_ENV":"production","APPLICATION_MODE":"production"}).DEBUG;
	  }
	
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage() {
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(186)))

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _assign = __webpack_require__(20);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEntity
	 * @typechecks
	 * 
	 */
	
	var DraftEntityInstance = __webpack_require__(535);
	var Immutable = __webpack_require__(28);
	
	var invariant = __webpack_require__(10);
	
	var Map = Immutable.Map;
	
	
	var instances = Map();
	var instanceKey = 0;
	
	/**
	 * A "document entity" is an object containing metadata associated with a
	 * piece of text in a ContentBlock.
	 *
	 * For example, a `link` entity might include a `uri` property. When a
	 * ContentBlock is rendered in the browser, text that refers to that link
	 * entity may be rendered as an anchor, with the `uri` as the href value.
	 *
	 * In a ContentBlock, every position in the text may correspond to zero
	 * or one entities. This correspondence is tracked using a key string,
	 * generated via DraftEntity.create() and used to obtain entity metadata
	 * via DraftEntity.get().
	 */
	var DraftEntity = {
	  /**
	   * Create a DraftEntityInstance and store it for later retrieval.
	   *
	   * A random key string will be generated and returned. This key may
	   * be used to track the entity's usage in a ContentBlock, and for
	   * retrieving data about the entity at render time.
	   */
	  create: function create(type, mutability, data) {
	    return DraftEntity.add(new DraftEntityInstance({ type: type, mutability: mutability, data: data || {} }));
	  },
	
	  /**
	   * Add an existing DraftEntityInstance to the DraftEntity map. This is
	   * useful when restoring instances from the server.
	   */
	  add: function add(instance) {
	    var key = '' + ++instanceKey;
	    instances = instances.set(key, instance);
	    return key;
	  },
	
	  /**
	   * Retrieve the entity corresponding to the supplied key string.
	   */
	  get: function get(key) {
	    var instance = instances.get(key);
	    !!!instance ?  false ? invariant(false, 'Unknown DraftEntity key.') : invariant(false) : void 0;
	    return instance;
	  },
	
	  /**
	   * Entity instances are immutable. If you need to update the data for an
	   * instance, this method will merge your data updates and return a new
	   * instance.
	   */
	  mergeData: function mergeData(key, toMerge) {
	    var instance = DraftEntity.get(key);
	    var newData = _extends({}, instance.getData(), toMerge);
	    var newInstance = instance.set('data', newData);
	    instances = instances.set(key, newInstance);
	    return newInstance;
	  },
	
	  /**
	   * Completely replace the data for a given instance.
	   */
	  replaceData: function replaceData(key, newData) {
	    var instance = DraftEntity.get(key);
	    var newInstance = instance.set('data', newData);
	    instances = instances.set(key, newInstance);
	    return newInstance;
	  }
	};
	
	module.exports = DraftEntity;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(270),
	    getPrototype = __webpack_require__(1395),
	    isObjectLike = __webpack_require__(219);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(20);
	
	var PooledClass = __webpack_require__(163);
	
	var emptyFunction = __webpack_require__(59);
	var warning = __webpack_require__(16);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else if (typeof event.returnValue !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ }),
/* 120 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ }),
/* 121 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var HANDLER_RETURN_VALUES = exports.HANDLER_RETURN_VALUES = {
	    handled: 'handled',
	    notHandled: 'not-handled'
	};
	
	// I think future versions of Draft JS will expose this.  When they do this should be removed.
	var EditorChangeType = exports.EditorChangeType = {
	    MOVE_SELECTION_TO_END_OF_BLOCK: 'move-selection-to-end-of-block',
	    MOVE_SELECTION_TO_START_OF_BLOCK: 'move-selection-to-start-of-block',
	    CHANGE_BLOCK_TYPE: 'change-block-type',
	    CHANGE_INLINE_STYLE: 'change-inline-style',
	    SPLIT_BLOCK: 'split-block'
	};

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Shows a validation message if one exists.
	 */
	var FieldValidationMessages = function (_React$Component) {
	    _inherits(FieldValidationMessages, _React$Component);
	
	    function FieldValidationMessages() {
	        _classCallCheck(this, FieldValidationMessages);
	
	        return _possibleConstructorReturn(this, (FieldValidationMessages.__proto__ || Object.getPrototypeOf(FieldValidationMessages)).apply(this, arguments));
	    }
	
	    _createClass(FieldValidationMessages, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            return nextProps.sanitisedError !== this.props.sanitisedError;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var sanitisedError = this.props.sanitisedError;
	
	            return sanitisedError && sanitisedError.message ? _react2.default.createElement(
	                'div',
	                { className: 'field-message error' },
	                sanitisedError.message
	            ) : null;
	        }
	    }]);
	
	    return FieldValidationMessages;
	}(_react2.default.Component);
	
	FieldValidationMessages.propTypes = {
	    sanitisedError: _propTypes2.default.object
	};
	exports.default = FieldValidationMessages;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Constants
	
	
	var _reactRedux = __webpack_require__(3);
	
	var _measurementsConstants = __webpack_require__(231);
	
	exports.default = function () {
	    var opts = _extends({}, arguments.length <= 3 ? undefined : arguments[3], {
	        storeKey: _measurementsConstants.MEASUREMENTS_STORE_NAME,
	        getDisplayName: function getDisplayName(component) {
	            return 'MeasurementsConnect(' + component + ')';
	        }
	    });
	    return (0, _reactRedux.connect)(arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 1 ? undefined : arguments[1], arguments.length <= 2 ? undefined : arguments[2], opts);
	};

/***/ }),
/* 124 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Connections store
	var getMeasurementsMap = exports.getMeasurementsMap = function getMeasurementsMap(state) {
	  return state.get('measurements');
	};
	
	// Element's selectors
	var getMeasurementsMapFromProps = exports.getMeasurementsMapFromProps = function getMeasurementsMapFromProps(state, ownProps) {
	  return ownProps.measurements;
	};
	var getElementMeasurments = exports.getElementMeasurments = function getElementMeasurments(state, _ref) {
	  var id = _ref.id;
	  return getMeasurementsMap(state).get(id);
	};

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _domUtil = __webpack_require__(107);
	
	var _Modal = __webpack_require__(712);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _ModalKeyboardManager = __webpack_require__(1916);
	
	var _ModalKeyboardManager2 = _interopRequireDefault(_ModalKeyboardManager);
	
	__webpack_require__(1168);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Utils
	var FullScreenModal = function FullScreenModal(props) {
	    var children = props.children,
	        className = props.className,
	        overlay = props.overlay,
	        close = props.close,
	        backButtonRoutes = props.backButtonRoutes;
	
	
	    return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('FullScreenModal', className, { overlay: overlay }), onClick: close },
	        _react2.default.createElement(
	            'div',
	            { className: 'modal-positioner' },
	            _react2.default.createElement(
	                _ModalKeyboardManager2.default,
	                props,
	                _react2.default.createElement(
	                    _Modal2.default,
	                    { onClick: _domUtil.stopPropagationOnly, close: close, backButtonRoutes: backButtonRoutes },
	                    children
	                )
	            )
	        )
	    );
	};
	
	// Styles
	
	
	// Components
	// Lib
	
	
	FullScreenModal.propTypes = {
	    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array]).isRequired,
	    className: _propTypes2.default.string,
	    overlay: _propTypes2.default.bool,
	    close: _propTypes2.default.func,
	    backButtonRoutes: _propTypes2.default.array
	};
	
	exports.default = FullScreenModal;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(1170);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalActionsList = function ModalActionsList(_ref) {
	    var actions = _ref.actions;
	    return _react2.default.createElement(
	        'ul',
	        { className: 'ModalActionsList' },
	        actions.map(function (action, index) {
	            return _react2.default.createElement(
	                'li',
	                { key: index },
	                _react2.default.createElement(
	                    'a',
	                    { href: action.href || '#', onClick: action.func },
	                    action.text
	                )
	            );
	        })
	    );
	};
	
	// Styles
	// Lib
	
	
	ModalActionsList.propTypes = {
	    actions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        text: _propTypes2.default.string.isRequired,
	        func: _propTypes2.default.func,
	        href: _propTypes2.default.string
	    }))
	};
	
	exports.default = ModalActionsList;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getSelectedElements = exports.getSelectedElementIds = undefined;
	
	var _reselect = __webpack_require__(7);
	
	var _elementSelector = __webpack_require__(41);
	
	// Lib
	var getSelectedElementIds = exports.getSelectedElementIds = function getSelectedElementIds(state) {
	    return state.getIn(['app', 'selection', 'ids']);
	};
	
	// Selectors
	var getSelectedElements = exports.getSelectedElements = (0, _reselect.createSelector)(getSelectedElementIds, _elementSelector.getElements, function (selectedElementIds, elements) {
	    return selectedElementIds.map(function (id) {
	        return elements.get(id);
	    });
	});

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getClientConfig = __webpack_require__(48);
	
	var _getClientConfig2 = _interopRequireDefault(_getClientConfig);
	
	var _configConstants = __webpack_require__(135);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var debugLevel = (0, _getClientConfig2.default)().debugLevel || 0;
	var consoleLog = function consoleLog(logLevel, logMethod) {
	    return function () {
	        for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
	            values[_key] = arguments[_key];
	        }
	
	        if (debugLevel < logLevel) return;
	        logMethod.apply(console, values);
	    };
	};
	
	exports.default = {
	    log: consoleLog(_configConstants.DEBUG_LEVEL.FINE, console.log), // eslint-disable-line no-console
	    info: consoleLog(_configConstants.DEBUG_LEVEL.INFO, console.info), // eslint-disable-line no-console
	    table: consoleLog(_configConstants.DEBUG_LEVEL.INFO, console.table), // eslint-disable-line no-console
	    error: consoleLog(_configConstants.DEBUG_LEVEL.ERROR, console.error), // eslint-disable-line no-console
	    warn: consoleLog(_configConstants.DEBUG_LEVEL.WARN, console.warn) };

/***/ }),
/* 129 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var TOOLBAR_MODES = exports.TOOLBAR_MODES = {
	    ELEMENTS: 'ELEMENTS',
	    SELECT: 'SELECT'
	};
	
	var TOOLS = exports.TOOLS = {
	    RICH_TEXT: { id: 'RICH_TEXT', name: null, multiSelect: false },
	    COLOR: { id: 'COLOR', name: 'Color', multiSelect: true },
	    ICON: { id: 'ICON', name: 'Icon', multiSelect: false },
	    CAPTION: { id: 'CAPTION', name: 'Caption', multiSelect: false },
	    ATTACHMENT: { id: 'ATTACHMENT', name: 'Image', multiSelect: true },
	    LOCK: { id: 'LOCK', name: 'Lock position', multiSelect: true },
	    SHOW_BACKGROUND: { id: 'SHOW_BACKGROUND', name: 'Transparent', multiSelect: true },
	    START_ARROW: { id: 'START_ARROW', name: 'Start', multiSelect: true },
	    END_ARROW: { id: 'END_ARROW', name: 'End', multiSelect: true }
	};

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	var META     = __webpack_require__(157)('meta')
	  , isObject = __webpack_require__(25)
	  , has      = __webpack_require__(62)
	  , setDesc  = __webpack_require__(38).f
	  , id       = 0;
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	var FREEZE = !__webpack_require__(19)(function(){
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function(it){
	  setDesc(it, META, {value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  }});
	};
	var fastKey = function(it, create){
	  // return primitive with prefix
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return 'F';
	    // not necessary to add metadata
	    if(!create)return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function(it, create){
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return true;
	    // not necessary to add metadata
	    if(!create)return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function(it){
	  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY:      META,
	  NEED:     false,
	  fastKey:  fastKey,
	  getWeak:  getWeak,
	  onFreeze: onFreeze
	};

/***/ }),
/* 131 */
/***/ (function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ }),
/* 132 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__(1575);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _CSSTransitionGroupChild = __webpack_require__(1574);
	
	var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);
	
	var _PropTypes = __webpack_require__(637);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  transitionName: _PropTypes.nameShape.isRequired,
	
	  transitionAppear: _propTypes2.default.bool,
	  transitionEnter: _propTypes2.default.bool,
	  transitionLeave: _propTypes2.default.bool,
	  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
	  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
	  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
	};
	
	var defaultProps = {
	  transitionAppear: false,
	  transitionEnter: true,
	  transitionLeave: true
	};
	
	var CSSTransitionGroup = function (_React$Component) {
	  _inherits(CSSTransitionGroup, _React$Component);
	
	  function CSSTransitionGroup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
	      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
	        name: _this.props.transitionName,
	        appear: _this.props.transitionAppear,
	        enter: _this.props.transitionEnter,
	        leave: _this.props.transitionLeave,
	        appearTimeout: _this.props.transitionAppearTimeout,
	        enterTimeout: _this.props.transitionEnterTimeout,
	        leaveTimeout: _this.props.transitionLeaveTimeout
	      }, child);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // We need to provide this childFactory so that
	  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	  // leave while it is leaving.
	
	
	  CSSTransitionGroup.prototype.render = function render() {
	    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
	  };
	
	  return CSSTransitionGroup;
	}(_react2.default.Component);
	
	CSSTransitionGroup.displayName = 'CSSTransitionGroup';
	
	
	CSSTransitionGroup.propTypes = propTypes;
	CSSTransitionGroup.defaultProps = defaultProps;
	
	exports.default = CSSTransitionGroup;
	module.exports = exports['default'];

/***/ }),
/* 135 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var APPLICATION_MODE = exports.APPLICATION_MODE = {
	    development: 'development',
	    test: 'test',
	    production: 'production'
	};
	
	var DEBUG_LEVEL = exports.DEBUG_LEVEL = {
	    OFF: 0,
	    // Always show errors
	    ERROR: 0,
	    WARN: 100,
	    INFO: 200,
	    FINE: 300,
	    FINER: 400,
	    FINEST: 500
	};
	
	var ENV = exports.ENV = {
	    PRODUCTION: 'production',
	    DEVELOPMENT: 'development'
	};
	
	var SERVER_TYPE = exports.SERVER_TYPE = {
	    development: 'development',
	    staging: 'staging',
	    production: 'production'
	};

/***/ }),
/* 136 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOGIN_SUBMIT = exports.LOGIN_SUBMIT = 'LOGIN_SUBMIT';
	var LOGIN_SUCCESS = exports.LOGIN_SUCCESS = 'LOGIN_SUCCESS';
	var LOGIN_FAILURE = exports.LOGIN_FAILURE = 'LOGIN_FAILURE';
	
	var LOGOUT = exports.LOGOUT = 'LOGOUT';
	
	var REGISTER_SUBMIT = exports.REGISTER_SUBMIT = 'REGISTER_SUBMIT';
	var REGISTER_SUCCESS = exports.REGISTER_SUCCESS = 'REGISTER_SUCCESS';
	var REGISTER_FAILURE = exports.REGISTER_FAILURE = 'REGISTER_FAILURE';
	
	var REGISTER_INVITE_FETCHED = exports.REGISTER_INVITE_FETCHED = 'REGISTER_INVITE_FETCHED';
	
	var USER_LOCAL_STORAGE_TOKEN_KEY = exports.USER_LOCAL_STORAGE_TOKEN_KEY = 'token';

/***/ }),
/* 137 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getCaption = exports.getCaption = function getCaption(element) {
	  return element.getIn(['content', 'caption']);
	};
	var getShowCaption = exports.getShowCaption = function getShowCaption(element) {
	  return element.getIn(['content', 'showCaption']);
	};

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(4);
	
	__webpack_require__(1148);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FORM_PROPS = [
	// HTML attributes
	'action', 'autoComplete', 'encType', 'form', 'formAction', 'formEncType', 'formMethod', 'formNoValidate', 'formTarget', 'noValidate', 'novalidate', 'target',
	// Event listeners
	'onChange', 'onInput', 'onSubmit'];
	
	var Form = function Form(props) {
	    return _react2.default.createElement(
	        'form',
	        _extends({}, (0, _lodash.pick)(props, FORM_PROPS), { className: (0, _classnames2.default)('Form', props.className) }),
	        props.children
	    );
	};
	
	Form.propTypes = {
	    className: _propTypes2.default.string,
	    children: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.element])
	};
	
	exports.default = Form;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _FullScreenModal = __webpack_require__(125);
	
	var _FullScreenModal2 = _interopRequireDefault(_FullScreenModal);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	__webpack_require__(1167);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Icons
	// Lib
	var FullScreenErrorModal = function FullScreenErrorModal(_ref) {
	    var children = _ref.children,
	        className = _ref.className,
	        overlay = _ref.overlay,
	        close = _ref.close;
	    return _react2.default.createElement(
	        _FullScreenModal2.default,
	        { className: (0, _classnames2.default)('FullScreenErrorModal', className), overlay: overlay, close: close },
	        _react2.default.createElement(
	            'div',
	            { className: 'logo' },
	            _react2.default.createElement(_Icon2.default, { name: 'error-alert' })
	        ),
	        children
	    );
	};
	
	// Styles
	
	
	// Components
	
	
	FullScreenErrorModal.propTypes = {
	    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array]).isRequired,
	    overlay: _propTypes2.default.bool,
	    close: _propTypes2.default.func,
	    className: _propTypes2.default.string
	};
	
	exports.default = FullScreenErrorModal;

/***/ }),
/* 140 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var POPUP_OPEN = exports.POPUP_OPEN = 'POPUP_OPEN';
	var POPUP_CLOSE = exports.POPUP_CLOSE = 'POPUP_CLOSE';
	var POPUP_TOGGLE = exports.POPUP_TOGGLE = 'POPUP_TOGGLE';
	
	var ARROW_DIR = exports.ARROW_DIR = {
	    top: 'top',
	    bottom: 'bottom',
	    left: 'left',
	    right: 'right'
	};

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reselect = __webpack_require__(7);
	
	exports.default = function (expectedPopupId) {
	    return (0, _reselect.createSelector)(function (state) {
	        return state.getIn(['app', 'popup', 'active']);
	    }, function (activePopup) {
	        return activePopup.has(expectedPopupId);
	    });
	}; // Lib

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.uploadAttachment = exports.clearElementAttachmentError = exports.errorUploadingElementAttachment = exports.cleanElementAttachment = exports.completedUploadingElementAttachment = exports.progressUploadingElementAttachment = exports.readElementAttachment = exports.uploadingElementAttachment = undefined;
	
	var _elementConstants = __webpack_require__(12);
	
	var TYPES = _interopRequireWildcard(_elementConstants);
	
	var _imageFileLoader = __webpack_require__(766);
	
	var _imageFileLoader2 = _interopRequireDefault(_imageFileLoader);
	
	var _mediaService = __webpack_require__(315);
	
	var _mediaService2 = _interopRequireDefault(_mediaService);
	
	var _elementActions = __webpack_require__(26);
	
	var _mediaConstants = __webpack_require__(148);
	
	var _undoRedoTransactionManager = __webpack_require__(86);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Uploading attachments
	
	
	// Constants
	var uploadingElementAttachment = exports.uploadingElementAttachment = function uploadingElementAttachment(_ref) {
	    var id = _ref.id;
	    return { type: TYPES.ELEMENT_ATTACHMENT_UPLOADING, id: id, sync: false };
	};
	
	// TODO Review where these files are located
	var readElementAttachment = exports.readElementAttachment = function readElementAttachment(_ref2) {
	    var id = _ref2.id,
	        attachmentData = _ref2.attachmentData;
	    return {
	        type: TYPES.ELEMENT_ATTACHMENT_DATA_READY,
	        id: id,
	        attachmentData: attachmentData,
	        sync: false
	    };
	};
	var progressUploadingElementAttachment = exports.progressUploadingElementAttachment = function progressUploadingElementAttachment(_ref3) {
	    var id = _ref3.id,
	        percentageComplete = _ref3.percentageComplete;
	    return {
	        type: TYPES.ELEMENT_ATTACHMENT_UPLOAD_PROGRESSED,
	        id: id,
	        percentageComplete: percentageComplete,
	        sync: false
	    };
	};
	var completedUploadingElementAttachment = exports.completedUploadingElementAttachment = function completedUploadingElementAttachment(_ref4) {
	    var id = _ref4.id;
	    return {
	        type: TYPES.ELEMENT_ATTACHMENT_UPLOAD_COMPLETED,
	        id: id,
	        sync: false
	    };
	};
	var cleanElementAttachment = exports.cleanElementAttachment = function cleanElementAttachment(_ref5) {
	    var id = _ref5.id;
	    return {
	        type: TYPES.ELEMENT_ATTACHMENT_CLEAN,
	        id: id,
	        sync: false
	    };
	};
	var errorUploadingElementAttachment = exports.errorUploadingElementAttachment = function errorUploadingElementAttachment(_ref6) {
	    var id = _ref6.id,
	        error = _ref6.error;
	    return {
	        type: TYPES.ELEMENT_ATTACHMENT_UPLOAD_ERROR,
	        id: id,
	        error: error,
	        sync: false
	    };
	};
	var clearElementAttachmentError = exports.clearElementAttachmentError = function clearElementAttachmentError(_ref7) {
	    var id = _ref7.id;
	    return {
	        type: TYPES.ELEMENT_ATTACHMENT_CLEAR_ERROR,
	        id: id,
	        sync: false
	    };
	};
	
	/**
	 * Uploads an attachment on an element.
	 *
	 * @param id {String} The ID of the element to add an attachment for.
	 * @param file {File} The File object to add as an attachment to the element.
	 * @param transactionId {Number} A transaction ID that this action is associated to. Used to group undo / redo actions.
	 * @param imageType {String} The type of image to upload (sets sizes that the image will be saved at etc).
	 *      'BOARD' || 'ELEMENT'.
	 */
	// TODO - NOTE this is currently very specific to uploading images.  Will likely need a different action for other
	// file types
	var uploadAttachment = exports.uploadAttachment = function uploadAttachment(_ref8) {
	    var id = _ref8.id,
	        file = _ref8.file,
	        _ref8$transactionId = _ref8.transactionId,
	        transactionId = _ref8$transactionId === undefined ? (0, _undoRedoTransactionManager.getNewTransactionId)() : _ref8$transactionId,
	        imageType = _ref8.imageType;
	    return function (dispatch, getState) {
	        var state = getState();
	        var isGuest = state.getIn(['app', 'currentUser', 'isGuest']);
	
	        // First notify the application that a file upload is in progress
	        if (!isGuest) dispatch(uploadingElementAttachment({ id: id }));
	
	        // TODO Handle errors
	        // Handles orientations of JPEGs if necessary
	        return (0, _imageFileLoader2.default)(file).then(function (imageData) {
	            var imageDataUri = imageData.imageDataUri;
	
	            var imageFile = imageData.file;
	
	            // Read the file so we can immediately show the image to the user
	            dispatch(readElementAttachment({ id: id, attachmentData: imageDataUri }));
	
	            // If the user is guest, don't upload the image
	            if (isGuest) return;
	
	            return _mediaService2.default.image.uploadMediaFile(imageFile, { slug: id, type: imageType || _mediaConstants.IMAGE_TYPES.ELEMENT }).then(function (response) {
	                dispatch(completedUploadingElementAttachment({ id: id }));
	                dispatch((0, _elementActions.updateElement)({ id: id, changes: response.data, transactionId: transactionId }));
	            }).catch(function (err) {
	                console.error('An error occurred while uploading the image', err, err.response);
	                dispatch(errorUploadingElementAttachment({
	                    id: id,
	                    transactionId: transactionId,
	                    error: { message: 'The image failed to upload' }
	                }));
	            });
	        });
	    };
	};

/***/ }),
/* 143 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var DRAG_START = exports.DRAG_START = 'DRAG_START';
	var DRAG_END = exports.DRAG_END = 'DRAG_END';
	var DRAG_OVER = exports.DRAG_OVER = 'DRAG_OVER';

/***/ }),
/* 144 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CURRENT_USER_GET_DETAILS = exports.CURRENT_USER_GET_DETAILS = 'CURRENT_USER_GET_DETAILS';
	var CURRENT_USER_GET_FAILURE = exports.CURRENT_USER_GET_FAILURE = 'CURRENT_USER_GET_FAILURE';
	var CURRENT_USER_SET = exports.CURRENT_USER_SET = 'CURRENT_USER_SET';
	var CURRENT_USER_SET_GUEST = exports.CURRENT_USER_SET_GUEST = 'CURRENT_USER_SET_GUEST';
	// Image actions
	var CURRENT_USER_IMAGE_SET = exports.CURRENT_USER_IMAGE_SET = 'CURRENT_USER_IMAGE_SET';
	var CURRENT_USER_IMAGE_UPLOAD_COMPLETE = exports.CURRENT_USER_IMAGE_UPLOAD_COMPLETE = 'CURRENT_USER_IMAGE_UPLOAD_COMPLETE';
	var CURRENT_USER_IMAGE_UPLOAD_ERROR = exports.CURRENT_USER_IMAGE_UPLOAD_ERROR = 'CURRENT_USER_IMAGE_UPLOAD_ERROR';

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getElementDropPosition = exports.getElementOffset = exports.isNewElement = exports.getElementDragOrigin = exports.getNewLineDragOrigin = exports.getBoardIconCentreOffset = exports.dropTargetAlreadyHandled = undefined;
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lodash = __webpack_require__(4);
	
	var _elementHelper = __webpack_require__(13);
	
	var _point = __webpack_require__(50);
	
	var pointLib = _interopRequireWildcard(_point);
	
	var _boardConstants = __webpack_require__(17);
	
	var _lineConstants = __webpack_require__(57);
	
	var _dndConstants = __webpack_require__(171);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This helper function determines if a child component has already handled the drop event.
	 * NOTE: The child component MUST add a 'handledBy' property to the drop result in order for this to work.  The child
	 * must also be a DOM child of the element in order for this to work.
	 *
	 * @param monitor {DropTargetMonitor} The React DnD drop target monitor.
	 * @param component {ReactComponent} The React component that intends to handle the drop.
	 * @returns {boolean} True if a child component has already handled the drop.
	 */
	var dropTargetAlreadyHandled = exports.dropTargetAlreadyHandled = function dropTargetAlreadyHandled(monitor, component) {
	    var domNode = _reactDom2.default.findDOMNode(component);
	    var lastDropResult = monitor.getDropResult();
	    return lastDropResult && lastDropResult.handledBy && domNode.contains(lastDropResult.handledBy);
	};
	
	// Item predicates
	
	
	// Constants
	
	
	// Utils
	// Lib
	var sourceIsBoardInList = function sourceIsBoardInList(_ref) {
	    var item = _ref.item;
	    return item.fromList && (0, _elementHelper.isBoardLike)(item.element);
	};
	
	var sourceIsNewLine = function sourceIsNewLine(_ref2) {
	    var item = _ref2.item;
	    return item.isCreate && (0, _elementHelper.isLine)(item.element);
	};
	
	// Drag offsets
	var getBoardIconCentreOffset = exports.getBoardIconCentreOffset = function getBoardIconCentreOffset(_ref3) {
	    var gridSize = _ref3.gridSize;
	    return pointLib.getPoint(_boardConstants.DEFAULT_BOARD_WIDTH * gridSize / 2, _boardConstants.DEFAULT_BOARD_WIDTH * gridSize / 2);
	};
	
	var getBoardInListDragOrigin = getBoardIconCentreOffset;
	
	var getNewLineDragOrigin = exports.getNewLineDragOrigin = function getNewLineDragOrigin(_ref4) {
	    var gridSize = _ref4.gridSize;
	    return pointLib.getPoint(_lineConstants.DEFAULT_LINE_WIDTH * gridSize / 2, _lineConstants.DEFAULT_LINE_HEIGHT * gridSize / 2);
	};
	
	var getDefaultDragOrigin = function getDefaultDragOrigin(_ref5) {
	    var initialSourceClientOffset = _ref5.initialSourceClientOffset,
	        initialClientOffset = _ref5.initialClientOffset;
	    return pointLib.difference(initialSourceClientOffset, initialClientOffset);
	};
	
	var getElementDragOrigin = exports.getElementDragOrigin = (0, _lodash.cond)([[sourceIsBoardInList, getBoardInListDragOrigin], [sourceIsNewLine, getNewLineDragOrigin], [_lodash.stubTrue, getDefaultDragOrigin]]);
	
	var isNewElement = exports.isNewElement = function isNewElement(_ref6) {
	    var item = _ref6.item;
	    return item.isCreate;
	};
	
	var isGrabbedElement = function isGrabbedElement(_ref7) {
	    var grabbedElement = _ref7.grabbedElement,
	        element = _ref7.element;
	    return grabbedElement.get('id') === element.get('id');
	};
	
	var getGrabOffset = function getGrabOffset(_ref8) {
	    var clientOffset = _ref8.clientOffset,
	        sourceClientOffset = _ref8.sourceClientOffset;
	    return pointLib.difference(sourceClientOffset, clientOffset);
	};
	
	var getGrabbedBoardInListOffset = function getGrabbedBoardInListOffset(_ref9) {
	    var clientOffset = _ref9.clientOffset,
	        sourceClientOffset = _ref9.sourceClientOffset,
	        gridSize = _ref9.gridSize;
	    return pointLib.difference(getBoardInListDragOrigin({ gridSize: gridSize }), getGrabOffset({ clientOffset: clientOffset, sourceClientOffset: sourceClientOffset }));
	};
	
	// The grabbed element might need to be translated
	var getGrabbedElementTranslation = function getGrabbedElementTranslation(_ref10) {
	    var grabbedElement = _ref10.grabbedElement,
	        clientOffset = _ref10.clientOffset,
	        sourceClientOffset = _ref10.sourceClientOffset,
	        gridSize = _ref10.gridSize;
	
	    if ((0, _elementHelper.isBoardLike)(grabbedElement) && (0, _elementHelper.isInList)(grabbedElement)) {
	        return getGrabbedBoardInListOffset({ clientOffset: clientOffset, sourceClientOffset: sourceClientOffset, gridSize: gridSize });
	    }
	    return _dndConstants.NO_DRAG_OFFSET;
	};
	
	var grabbedElementRequiresOffset = function grabbedElementRequiresOffset(grabbedElement) {
	    return (0, _elementHelper.isBoardLike)(grabbedElement) && (0, _elementHelper.isInList)(grabbedElement);
	};
	
	var offsetHasBeenUpdated = function offsetHasBeenUpdated(offset) {
	    return !pointLib.equals(offset, _dndConstants.NO_DRAG_OFFSET);
	};
	
	/**
	 * NOTE: This is also used by the ElementDragPreviewPositioner, which is why it needs both the item and the element
	 * to figure out if the element is the "grabbedElement".
	 */
	var getElementOffset = exports.getElementOffset = function getElementOffset(_ref11) {
	    var item = _ref11.item,
	        element = _ref11.element,
	        clientOffset = _ref11.clientOffset,
	        sourceClientOffset = _ref11.sourceClientOffset,
	        gridSize = _ref11.gridSize;
	    var offsetsMap = item.offsetsMap;
	
	    var elementId = element.get('id');
	    var offset = offsetsMap[elementId];
	    var grabbedElement = item.element;
	
	    // Need to account for when the grabbed element needs a translation based on the grab position, such as when
	    // a board is in a list.
	    // FIXME This is a hack because we don't have the clientOffset & sourceClientOffset when creating the
	    // offset map.  It simply makes sure that the offset map has an offset for the grabbed element when it's
	    // a board in a list.
	    if (isGrabbedElement({ grabbedElement: grabbedElement, element: element }) && grabbedElementRequiresOffset(grabbedElement) && !offsetHasBeenUpdated(offset)) {
	        // Setting to the offsetsMap.  This should only ever happen once
	        offsetsMap[elementId] = getGrabbedElementTranslation({
	            grabbedElement: item.element,
	            clientOffset: clientOffset,
	            sourceClientOffset: sourceClientOffset,
	            gridSize: gridSize
	        });
	    }
	
	    return offsetsMap[elementId] || _dndConstants.NO_DRAG_OFFSET;
	};
	
	var getNewElementDropPosition = function getNewElementDropPosition(_ref12) {
	    var item = _ref12.item,
	        clientOffset = _ref12.clientOffset,
	        sourceClientOffset = _ref12.sourceClientOffset,
	        gridSize = _ref12.gridSize;
	
	    // Then add the offset of the dragged element
	    var element = item.element;
	
	    var offset = getElementOffset({ item: item, element: element, clientOffset: clientOffset, sourceClientOffset: sourceClientOffset, gridSize: gridSize });
	
	    // Get mouse up location (clientOffset instead of sourceClientOffset) for new elements
	    return pointLib.translate(clientOffset, offset);
	};
	
	var getMovedElementDropPosition = function getMovedElementDropPosition(_ref13) {
	    var sourceClientOffset = _ref13.sourceClientOffset;
	    return sourceClientOffset;
	};
	
	var getElementDropPosition = exports.getElementDropPosition = function getElementDropPosition(_ref14) {
	    var item = _ref14.item,
	        clientOffset = _ref14.clientOffset,
	        sourceClientOffset = _ref14.sourceClientOffset,
	        gridSize = _ref14.gridSize;
	    return isNewElement({ item: item }) ? getNewElementDropPosition({ item: item, clientOffset: clientOffset, sourceClientOffset: sourceClientOffset, gridSize: gridSize }) : getMovedElementDropPosition({ sourceClientOffset: sourceClientOffset });
	};

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.NON_CHARACTERS = exports.KEY_CODES = exports.SHORTCUT_KEYS = undefined;
	
	var _browser = __webpack_require__(61);
	
	var SHORTCUT_KEYS = exports.SHORTCUT_KEYS = {
	    ESCAPE: 'escape',
	    UNDO: _browser.isApple ? 'command+z' : 'ctrl+z',
	    REDO: _browser.isApple ? ['command+shift+z', 'command+y'] : ['ctrl+shift+z', 'ctrl+y'],
	    NEW_CARD: ['command+ctrl+n', 'command+alt+n'],
	    NEW_BOARD: ['command+ctrl+b', 'command+alt+b'],
	    NEW_COLUMN: ['command+ctrl+g', 'command+alt+g'],
	    NEW_IMAGE: ['command+ctrl+i', 'command+alt+i'],
	    NEW_LINK: ['command+ctrl+l', 'command+alt+l'],
	    DELETE: ['backspace', 'del'],
	    TOGGLE_UNSORTED_NOTES: ['command+\\', 'ctrl+\\'],
	    SAVE: ['command+s', 'ctrl+s'],
	
	    // Debug Shortcuts
	    TOGGLE_PERFORMANCE_RECORDING: ['command+e', 'ctrl+e']
	}; // Utils
	var KEY_CODES = exports.KEY_CODES = {
	    /* Modifiers / Special Keys. */
	    BACKSPACE: 8,
	    DELETE: 46,
	    TAB: 9,
	    SHIFT: 16,
	    ENTER: 13,
	    CTRL: 17,
	    ALT: 18,
	    CAPS: 20,
	    ESC: 27,
	    SPACEBAR: 32,
	
	    CMD_LEFT: 91, // Windows key
	    CMD_RIGHT: 93, // Windows menu
	
	    /* Navigation. */
	    PAGE_UP: 33,
	    PAGE_DOWN: 34,
	    END: 35,
	    HOME: 36,
	
	    /* Direction keys. */
	    LEFT_ARROW: 37,
	    UP_ARROW: 38,
	    RIGHT_ARROW: 39,
	    DOWN_ARROW: 40,
	
	    /* Numbers. */
	    0: 48,
	    1: 49,
	    2: 50,
	    3: 51,
	    4: 52,
	    5: 53,
	    6: 54,
	    7: 55,
	    8: 56,
	    9: 57,
	
	    /* Characters. */
	    A: 65,
	    B: 66,
	    C: 67,
	    D: 68,
	    E: 69,
	    F: 70,
	    G: 71,
	    H: 72,
	    I: 73,
	    J: 74,
	    K: 75,
	    L: 76,
	    M: 77,
	    N: 78,
	    O: 79,
	    P: 80,
	    Q: 81,
	    R: 82,
	    S: 83,
	    T: 84,
	    U: 85,
	    V: 86,
	    W: 87,
	    X: 88,
	    Y: 89,
	    Z: 90,
	
	    /* Special Characters */
	    ACCENT: 192,
	    DASH: 189,
	    FORWARD_SLASH: 191,
	    BACK_SLASH: 220,
	    OPEN_BRACKET: 219,
	    CLOSE_BRACKET: 221,
	    SEMICOLON: 186,
	    SINGLE_QUOTE: 22,
	    COMMA: 188,
	    PERIOD: 190,
	
	    /* Numpad. */
	    CLEAR: 12,
	    MULTIPLY: 106,
	    ADD: 107,
	    SUBTRACT: 109,
	    DECIMAL_POINT: 110,
	    DIVIDE: 111,
	    EQUAL: 187,
	
	    /* F.. */
	    F1: 112,
	    F2: 113,
	    F3: 114,
	    F4: 115,
	    F5: 116,
	    F6: 117,
	    F7: 118,
	    F8: 119,
	    F9: 120,
	    F10: 121,
	    F11: 122,
	    F12: 123,
	    F13: 124,
	    F14: 125,
	    F15: 126,
	    F16: 127,
	    F17: 128,
	    F18: 129,
	    F19: 130
	};
	
	var NON_CHARACTERS = exports.NON_CHARACTERS = [KEY_CODES.BACKSPACE, KEY_CODES.DELETE, KEY_CODES.TAB, KEY_CODES.SHIFT, KEY_CODES.ENTER, KEY_CODES.CTRL, KEY_CODES.ALT, KEY_CODES.CAPS, KEY_CODES.ESC, KEY_CODES.SPACEBAR, KEY_CODES.CMD_LEFT, KEY_CODES.CMD_RIGHT, KEY_CODES.PAGE_UP, KEY_CODES.PAGE_DOWN, KEY_CODES.END, KEY_CODES.HOME, KEY_CODES.LEFT_ARROW, KEY_CODES.UP_ARROW, KEY_CODES.RIGHT_ARROW, KEY_CODES.DOWN_ARROW];

/***/ }),
/* 147 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var hasChanged = exports.hasChanged = function hasChanged(propName) {
	  return function (oldProps, newProps) {
	    return oldProps[propName] !== newProps[propName];
	  };
	};
	var hasNotChanged = exports.hasNotChanged = function hasNotChanged(propName) {
	  return function (oldProps, newProps) {
	    return oldProps[propName] === newProps[propName];
	  };
	};
	var noLonger = exports.noLonger = function noLonger(propName) {
	  return function (oldProps, newProps) {
	    return oldProps[propName] && !newProps[propName];
	  };
	};
	var now = exports.now = function now(propName) {
	  return function (oldProps, newProps) {
	    return !oldProps[propName] && newProps[propName];
	  };
	};
	var stayedTrue = exports.stayedTrue = function stayedTrue(propName) {
	  return function (oldProps, newProps) {
	    return oldProps[propName] && newProps[propName];
	  };
	};
	var stayedFalse = exports.stayedFalse = function stayedFalse(propName) {
	  return function (oldProps, newProps) {
	    return !oldProps[propName] && !newProps[propName];
	  };
	};

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.IMAGE_TYPE_CONFIGS = exports.IMAGE_TYPES = undefined;
	
	var _IMAGE_TYPE_CONFIGS;
	
	var _lodash = __webpack_require__(4);
	
	var _imageConstants = __webpack_require__(87);
	
	var _userConstants = __webpack_require__(32);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // Lib
	
	
	// Constants
	
	
	var IMAGE_TYPES = exports.IMAGE_TYPES = {
	    ELEMENT: 'ELEMENT',
	    LINK: 'LINK',
	    AVATAR: 'AVATAR',
	    BOARD: 'BOARD'
	};
	
	var IMAGE_TYPE_CONFIGS = exports.IMAGE_TYPE_CONFIGS = (_IMAGE_TYPE_CONFIGS = {}, _defineProperty(_IMAGE_TYPE_CONFIGS, IMAGE_TYPES.ELEMENT, {
	    name: IMAGE_TYPES.ELEMENT,
	    sizes: (0, _lodash.values)(_imageConstants.IMAGE_SIZES).sort(function (sizeA, sizeB) {
	        return sizeA.width - sizeB.width;
	    })
	    // Don't include the thumbnail in the resizing - that uses special rules
	    .filter(function (size) {
	        return size.name !== 'thumb';
	    }),
	    thumb: {
	        enabled: true,
	        width: _imageConstants.IMAGE_WIDTH_THUMB
	    }
	}), _defineProperty(_IMAGE_TYPE_CONFIGS, IMAGE_TYPES.LINK, {
	    name: IMAGE_TYPES.LINK,
	    sizes: [{ name: 'regular', width: 300, height: 170, quality: 80 }, { name: 'large', width: 300 * 2, height: 170 * 2, quality: 60 }],
	    thumb: {
	        enabled: true,
	        width: _imageConstants.IMAGE_WIDTH_THUMB
	    }
	}), _defineProperty(_IMAGE_TYPE_CONFIGS, IMAGE_TYPES.AVATAR, {
	    name: IMAGE_TYPES.AVATAR,
	    sizes: [{ name: 'tiny', width: _userConstants.DEFAULT_AVATAR_SIZE }, { name: 'regular', width: _userConstants.DEFAULT_AVATAR_SIZE * 2 }, { name: 'large', width: 160 }],
	    thumb: {
	        enabled: false
	    }
	}), _defineProperty(_IMAGE_TYPE_CONFIGS, IMAGE_TYPES.BOARD, {
	    name: IMAGE_TYPES.BOARD,
	    sizes: [{ name: 'regular', width: 160, height: 160, quality: 75, enlargeIfRequired: true }],
	    thumb: {
	        enabled: false
	    }
	}), _IMAGE_TYPE_CONFIGS);

/***/ }),
/* 149 */
/***/ (function(module, exports) {

	module.exports = function(it, Constructor, name, forbiddenField){
	  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};

/***/ }),
/* 150 */
/***/ (function(module, exports) {

	module.exports = false;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject    = __webpack_require__(14)
	  , dPs         = __webpack_require__(513)
	  , enumBugKeys = __webpack_require__(331)
	  , IE_PROTO    = __webpack_require__(343)('IE_PROTO')
	  , Empty       = function(){ /* empty */ }
	  , PROTOTYPE   = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function(){
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(330)('iframe')
	    , i      = enumBugKeys.length
	    , lt     = '<'
	    , gt     = '>'
	    , iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(333).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties){
	  var result;
	  if(O !== null){
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty;
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys      = __webpack_require__(515)
	  , hiddenKeys = __webpack_require__(331).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
	  return $keys(O, hiddenKeys);
	};

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys       = __webpack_require__(515)
	  , enumBugKeys = __webpack_require__(331);
	
	module.exports = Object.keys || function keys(O){
	  return $keys(O, enumBugKeys);
	};

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(69);
	module.exports = function(target, src, safe){
	  for(var key in src)redefine(target, key, src[key], safe);
	  return target;
	};

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global      = __webpack_require__(15)
	  , dP          = __webpack_require__(38)
	  , DESCRIPTORS = __webpack_require__(37)
	  , SPECIES     = __webpack_require__(29)('species');
	
	module.exports = function(KEY){
	  var C = global[KEY];
	  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
	    configurable: true,
	    get: function(){ return this; }
	  });
	};

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(132)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ }),
/* 157 */
/***/ (function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ContentBlock
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Immutable = __webpack_require__(28);
	
	var findRangesImmutable = __webpack_require__(262);
	
	var List = Immutable.List;
	var Map = Immutable.Map;
	var OrderedSet = Immutable.OrderedSet;
	var Record = Immutable.Record;
	
	
	var EMPTY_SET = OrderedSet();
	
	var defaultRecord = {
	  key: '',
	  type: 'unstyled',
	  text: '',
	  characterList: List(),
	  depth: 0,
	  data: Map()
	};
	
	var ContentBlockRecord = Record(defaultRecord);
	
	var ContentBlock = function (_ContentBlockRecord) {
	  _inherits(ContentBlock, _ContentBlockRecord);
	
	  function ContentBlock() {
	    _classCallCheck(this, ContentBlock);
	
	    return _possibleConstructorReturn(this, _ContentBlockRecord.apply(this, arguments));
	  }
	
	  ContentBlock.prototype.getKey = function getKey() {
	    return this.get('key');
	  };
	
	  ContentBlock.prototype.getType = function getType() {
	    return this.get('type');
	  };
	
	  ContentBlock.prototype.getText = function getText() {
	    return this.get('text');
	  };
	
	  ContentBlock.prototype.getCharacterList = function getCharacterList() {
	    return this.get('characterList');
	  };
	
	  ContentBlock.prototype.getLength = function getLength() {
	    return this.getText().length;
	  };
	
	  ContentBlock.prototype.getDepth = function getDepth() {
	    return this.get('depth');
	  };
	
	  ContentBlock.prototype.getData = function getData() {
	    return this.get('data');
	  };
	
	  ContentBlock.prototype.getInlineStyleAt = function getInlineStyleAt(offset) {
	    var character = this.getCharacterList().get(offset);
	    return character ? character.getStyle() : EMPTY_SET;
	  };
	
	  ContentBlock.prototype.getEntityAt = function getEntityAt(offset) {
	    var character = this.getCharacterList().get(offset);
	    return character ? character.getEntity() : null;
	  };
	
	  /**
	   * Execute a callback for every contiguous range of styles within the block.
	   */
	
	
	  ContentBlock.prototype.findStyleRanges = function findStyleRanges(filterFn, callback) {
	    findRangesImmutable(this.getCharacterList(), haveEqualStyle, filterFn, callback);
	  };
	
	  /**
	   * Execute a callback for every contiguous range of entities within the block.
	   */
	
	
	  ContentBlock.prototype.findEntityRanges = function findEntityRanges(filterFn, callback) {
	    findRangesImmutable(this.getCharacterList(), haveEqualEntity, filterFn, callback);
	  };
	
	  return ContentBlock;
	}(ContentBlockRecord);
	
	function haveEqualStyle(charA, charB) {
	  return charA.getStyle() === charB.getStyle();
	}
	
	function haveEqualEntity(charA, charB) {
	  return charA.getEntity() === charB.getEntity();
	}
	
	module.exports = ContentBlock;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/**
	 * Unicode-enabled replacesments for basic String functions.
	 *
	 * All the functions in this module assume that the input string is a valid
	 * UTF-16 encoding of a Unicode sequence. If it's not the case, the behavior
	 * will be undefined.
	 *
	 * WARNING: Since this module is typechecks-enforced, you may find new bugs
	 * when replacing normal String functions with ones provided here.
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(10);
	
	// These two ranges are consecutive so anything in [HIGH_START, LOW_END] is a
	// surrogate code unit.
	var SURROGATE_HIGH_START = 0xD800;
	var SURROGATE_HIGH_END = 0xDBFF;
	var SURROGATE_LOW_START = 0xDC00;
	var SURROGATE_LOW_END = 0xDFFF;
	var SURROGATE_UNITS_REGEX = /[\uD800-\uDFFF]/;
	
	/**
	 * @param {number} codeUnit   A Unicode code-unit, in range [0, 0x10FFFF]
	 * @return {boolean}          Whether code-unit is in a surrogate (hi/low) range
	 */
	function isCodeUnitInSurrogateRange(codeUnit) {
	  return SURROGATE_HIGH_START <= codeUnit && codeUnit <= SURROGATE_LOW_END;
	}
	
	/**
	 * Returns whether the two characters starting at `index` form a surrogate pair.
	 * For example, given the string s = "\uD83D\uDE0A", (s, 0) returns true and
	 * (s, 1) returns false.
	 *
	 * @param {string} str
	 * @param {number} index
	 * @return {boolean}
	 */
	function isSurrogatePair(str, index) {
	  !(0 <= index && index < str.length) ?  false ? invariant(false, 'isSurrogatePair: Invalid index %s for string length %s.', index, str.length) : invariant(false) : void 0;
	  if (index + 1 === str.length) {
	    return false;
	  }
	  var first = str.charCodeAt(index);
	  var second = str.charCodeAt(index + 1);
	  return SURROGATE_HIGH_START <= first && first <= SURROGATE_HIGH_END && SURROGATE_LOW_START <= second && second <= SURROGATE_LOW_END;
	}
	
	/**
	 * @param {string} str  Non-empty string
	 * @return {boolean}    True if the input includes any surrogate code units
	 */
	function hasSurrogateUnit(str) {
	  return SURROGATE_UNITS_REGEX.test(str);
	}
	
	/**
	 * Return the length of the original Unicode character at given position in the
	 * String by looking into the UTF-16 code unit; that is equal to 1 for any
	 * non-surrogate characters in BMP ([U+0000..U+D7FF] and [U+E000, U+FFFF]); and
	 * returns 2 for the hi/low surrogates ([U+D800..U+DFFF]), which are in fact
	 * representing non-BMP characters ([U+10000..U+10FFFF]).
	 *
	 * Examples:
	 * - '\u0020' => 1
	 * - '\u3020' => 1
	 * - '\uD835' => 2
	 * - '\uD835\uDDEF' => 2
	 * - '\uDDEF' => 2
	 *
	 * @param {string} str  Non-empty string
	 * @param {number} pos  Position in the string to look for one code unit
	 * @return {number}      Number 1 or 2
	 */
	function getUTF16Length(str, pos) {
	  return 1 + isCodeUnitInSurrogateRange(str.charCodeAt(pos));
	}
	
	/**
	 * Fully Unicode-enabled replacement for String#length
	 *
	 * @param {string} str  Valid Unicode string
	 * @return {number}     The number of Unicode characters in the string
	 */
	function strlen(str) {
	  // Call the native functions if there's no surrogate char
	  if (!hasSurrogateUnit(str)) {
	    return str.length;
	  }
	
	  var len = 0;
	  for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
	    len++;
	  }
	  return len;
	}
	
	/**
	 * Fully Unicode-enabled replacement for String#substr()
	 *
	 * @param {string} str      Valid Unicode string
	 * @param {number} start    Location in Unicode sequence to begin extracting
	 * @param {?number} length  The number of Unicode characters to extract
	 *                          (default: to the end of the string)
	 * @return {string}         Extracted sub-string
	 */
	function substr(str, start, length) {
	  start = start || 0;
	  length = length === undefined ? Infinity : length || 0;
	
	  // Call the native functions if there's no surrogate char
	  if (!hasSurrogateUnit(str)) {
	    return str.substr(start, length);
	  }
	
	  // Obvious cases
	  var size = str.length;
	  if (size <= 0 || start > size || length <= 0) {
	    return '';
	  }
	
	  // Find the actual starting position
	  var posA = 0;
	  if (start > 0) {
	    for (; start > 0 && posA < size; start--) {
	      posA += getUTF16Length(str, posA);
	    }
	    if (posA >= size) {
	      return '';
	    }
	  } else if (start < 0) {
	    for (posA = size; start < 0 && 0 < posA; start++) {
	      posA -= getUTF16Length(str, posA - 1);
	    }
	    if (posA < 0) {
	      posA = 0;
	    }
	  }
	
	  // Find the actual ending position
	  var posB = size;
	  if (length < size) {
	    for (posB = posA; length > 0 && posB < size; length--) {
	      posB += getUTF16Length(str, posB);
	    }
	  }
	
	  return str.substring(posA, posB);
	}
	
	/**
	 * Fully Unicode-enabled replacement for String#substring()
	 *
	 * @param {string} str    Valid Unicode string
	 * @param {number} start  Location in Unicode sequence to begin extracting
	 * @param {?number} end   Location in Unicode sequence to end extracting
	 *                        (default: end of the string)
	 * @return {string}       Extracted sub-string
	 */
	function substring(str, start, end) {
	  start = start || 0;
	  end = end === undefined ? Infinity : end || 0;
	
	  if (start < 0) {
	    start = 0;
	  }
	  if (end < 0) {
	    end = 0;
	  }
	
	  var length = Math.abs(end - start);
	  start = start < end ? start : end;
	  return substr(str, start, length);
	}
	
	/**
	 * Get a list of Unicode code-points from a String
	 *
	 * @param {string} str        Valid Unicode string
	 * @return {array<number>}    A list of code-points in [0..0x10FFFF]
	 */
	function getCodePoints(str) {
	  var codePoints = [];
	  for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
	    codePoints.push(str.codePointAt(pos));
	  }
	  return codePoints;
	}
	
	var UnicodeUtils = {
	  getCodePoints: getCodePoints,
	  getUTF16Length: getUTF16Length,
	  hasSurrogateUnit: hasSurrogateUnit,
	  isCodeUnitInSurrogateRange: isCodeUnitInSurrogateRange,
	  isSurrogatePair: isSurrogatePair,
	  strlen: strlen,
	  substring: substring,
	  substr: substr
	};
	
	module.exports = UnicodeUtils;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.extractPath = extractPath;
	exports.parsePath = parsePath;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(102);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function extractPath(string) {
	  var match = string.match(/^https?:\/\/[^\/]*/);
	
	  if (match == null) return string;
	
	  return string.substring(match[0].length);
	}
	
	function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? _warning2['default'](path === pathname, 'A path must be pathname + search + hash only, not a fully qualified URL like "%s"', path) : undefined;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	}

/***/ }),
/* 161 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ }),
/* 162 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _react = __webpack_require__(1);
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var arrayOf = _react.PropTypes.arrayOf;
	var oneOfType = _react.PropTypes.oneOfType;
	var element = _react.PropTypes.element;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = shape({
	  listen: func.isRequired,
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired
	});
	
	var component = exports.component = oneOfType([func, string]);
	var components = exports.components = oneOfType([component, object]);
	var route = exports.route = oneOfType([object, element]);
	var routes = exports.routes = oneOfType([route, arrayOf(route)]);

/***/ }),
/* 165 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var INTERCOM_OPERATIONS = exports.INTERCOM_OPERATIONS = {
	    trackEvent: 'trackEvent',
	    boot: 'boot',
	    shutdown: 'shutdown',
	    update: 'update',
	    show: 'show',
	    onUnreadCountChange: 'onUnreadCountChange'
	};
	
	var GOOGLE_ANALYTICS_OPERATIONS = exports.GOOGLE_ANALYTICS_OPERATIONS = {
	    send: 'send'
	};
	
	var GOOGLE_ANALYTICS_HIT_TYPES = exports.GOOGLE_ANALYTICS_HIT_TYPES = {
	    event: 'event'
	};
	
	var INTERCOM_SHOW_MESSAGES = exports.INTERCOM_SHOW_MESSAGES = 'INTERCOM_SHOW_MESSAGES';
	var INTERCOM_SET_UNREAD_MESSAGES = exports.INTERCOM_SET_UNREAD_MESSAGES = 'INTERCOM_SET_UNREAD_MESSAGES';

/***/ }),
/* 166 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _STYLE_COMMAND_TYPES;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var STYLE_TYPES = exports.STYLE_TYPES = {
	    INLINE: 'INLINE',
	    BLOCK: 'BLOCK'
	};
	
	var STYLE_COMMANDS = exports.STYLE_COMMANDS = {
	    BOLD: 'BOLD',
	    ITALIC: 'ITALIC',
	    HEADING: 'header-two',
	    BLOCKQUOTE: 'blockquote',
	    CODE: 'code-block',
	    LIST: 'unordered-list-item',
	    ORDERED_LIST: 'ordered-list-item',
	    CHECKLIST: 'checklist',
	    UNSTYLED: 'unstyled',
	    HEADING_PREFIX: 'header'
	};
	
	var STYLE_COMMAND_TYPES = exports.STYLE_COMMAND_TYPES = (_STYLE_COMMAND_TYPES = {}, _defineProperty(_STYLE_COMMAND_TYPES, STYLE_COMMANDS.BOLD, STYLE_TYPES.INLINE), _defineProperty(_STYLE_COMMAND_TYPES, STYLE_COMMANDS.ITALIC, STYLE_TYPES.INLINE), _defineProperty(_STYLE_COMMAND_TYPES, STYLE_COMMANDS.HEADING, STYLE_TYPES.BLOCK), _defineProperty(_STYLE_COMMAND_TYPES, STYLE_COMMANDS.BLOCKQUOTE, STYLE_TYPES.BLOCK), _defineProperty(_STYLE_COMMAND_TYPES, STYLE_COMMANDS.CODE, STYLE_TYPES.INLINE), _defineProperty(_STYLE_COMMAND_TYPES, STYLE_COMMANDS.LIST, STYLE_TYPES.BLOCK), _defineProperty(_STYLE_COMMAND_TYPES, STYLE_COMMANDS.ORDERED_LIST, STYLE_TYPES.BLOCK), _defineProperty(_STYLE_COMMAND_TYPES, STYLE_COMMANDS.CHECKLIST, STYLE_TYPES.BLOCK), _STYLE_COMMAND_TYPES);
	
	var TOOLS = {
	    HEADING: { name: 'Heading', textCommand: STYLE_COMMANDS.HEADING, iconName: 'toolbar-h1' },
	    BOLD: { name: 'Bold', textCommand: STYLE_COMMANDS.BOLD, iconName: 'toolbar-bold' },
	    ITALIC: { name: 'Italic', textCommand: STYLE_COMMANDS.ITALIC, iconName: 'toolbar-italic' },
	    LIST: { name: 'Bullet', textCommand: STYLE_COMMANDS.LIST, iconName: 'toolbar-list' },
	    ORDERED_LIST: { name: 'Numbered list', textCommand: STYLE_COMMANDS.ORDERED_LIST, iconName: 'toolbar-numlist' },
	    CHECKLIST: { name: 'Checklist', textCommand: STYLE_COMMANDS.CHECKLIST, iconName: 'toolbar-checklist' },
	    QUOTE: { name: 'Quote', textCommand: STYLE_COMMANDS.BLOCKQUOTE, iconName: 'toolbar-quote' }
	};
	
	var INLINE_STYLE_TOOLS = exports.INLINE_STYLE_TOOLS = [TOOLS.BOLD, TOOLS.ITALIC];
	
	var RICH_STYLE_TOOLS = exports.RICH_STYLE_TOOLS = [TOOLS.HEADING, TOOLS.BOLD, TOOLS.ITALIC, TOOLS.LIST, TOOLS.ORDERED_LIST, TOOLS.CHECKLIST, TOOLS.QUOTE];

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.refreshIfModified = exports.fetchBoard = exports.fetchBoards = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Utils
	
	
	// Actions
	
	
	// Selectors
	
	
	// Constants
	
	
	var _lodash = __webpack_require__(4);
	
	var _http = __webpack_require__(76);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _resources = __webpack_require__(469);
	
	var _resources2 = _interopRequireDefault(_resources);
	
	var _elementHelper = __webpack_require__(13);
	
	var _resourceUtil = __webpack_require__(108);
	
	var _immutableHelper = __webpack_require__(23);
	
	var _logger = __webpack_require__(128);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _elementActions = __webpack_require__(26);
	
	var _mainSelector = __webpack_require__(239);
	
	var _boardSelector = __webpack_require__(83);
	
	var _resourceConstants = __webpack_require__(85);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var boardsResourceService = (0, _resources2.default)(_resourceConstants.RESOURCE_TYPES.boards);
	
	/**
	 * Fetches multiple boards in one go, based on the boardIds passed through in the argument object.
	 * But only fetches them if they aren't already being fetched.
	 */
	var fetchBoards = exports.fetchBoards = function fetchBoards(args) {
	    return function (dispatch, getState) {
	        var boardIds = args.boardIds,
	            force = args.force,
	            loadAncestors = args.loadAncestors,
	            excludeSelf = args.excludeSelf;
	
	
	        var state = getState();
	        var elements = state.get('elements');
	        var boardResourcesState = (0, _boardSelector.boardResourcesSelector)(state);
	
	        var getBoardResource = (0, _immutableHelper.propFrom)(boardResourcesState);
	        var boardResources = boardIds.map(getBoardResource);
	
	        // If we are not forcing the fetch, and we have the board, and it has been fetched or it is fetching
	        // then we don't need to fetch it again
	        var boardIdsToFetch = boardIds.filter(function (boardId) {
	            return !!boardId;
	        }).filter(function (boardId) {
	            return (0, _resourceUtil.shouldFetchResource)(force, getBoardResource(boardId));
	        });
	
	        // TODO This should potentially use the elements resources instead
	        var shouldExcludeSelf = boardResources.reduce(function (exclude, board) {
	            return exclude && ((0, _resourceUtil.isFetched)(board) || (0, _resourceUtil.isFetching)(board));
	        }, excludeSelf);
	
	        if (!boardIdsToFetch.length) {
	            return Promise.resolve();
	        }
	
	        // Get the current children of the board to compare after the fetch and find out what's been deleted
	        var initialChildIdsByParentIds = boardIdsToFetch.reduce(function (map, boardId) {
	            map[boardId] = (0, _elementHelper.getChildIdsDeep)(elements, boardId);
	            return map;
	        }, {});
	
	        var config = {
	            timeout: 30000,
	            retry: 1,
	            storeServerErrors: false,
	            params: {
	                excludeSelf: shouldExcludeSelf,
	                loadAncestors: loadAncestors
	            }
	        };
	
	        return boardsResourceService({ dispatch: dispatch, config: config, ids: boardIdsToFetch }).then(function (response) {
	            if (!(0, _lodash.size)(response.data.elements)) return response;
	
	            // Figure out the difference between the fetched elements and previous elements
	            // The remaining will need to be deleted
	            var retrievedChildIds = (0, _lodash.keys)(response.data.elements);
	            var deletedElementIds = boardIdsToFetch.reduce(function (deletedIdList, boardId) {
	                if (!response.data.childrenReturned[boardId]) return deletedIdList;
	                var initialChildIds = initialChildIdsByParentIds[boardId];
	                var deletedIds = (0, _lodash.difference)(initialChildIds, retrievedChildIds);
	                return deletedIdList.concat(deletedIds);
	            }, []);
	
	            dispatch((0, _elementActions.loadElements)(response.data.elements, deletedElementIds));
	            return response;
	        });
	    };
	};
	
	var fetchNextBoards = function fetchNextBoards(boardId) {
	    return function (dispatch, getState) {
	        var state = getState();
	        var elements = state.get('elements');
	        var getBoard = (0, _immutableHelper.propFrom)(elements);
	
	        var boardResourcesState = (0, _boardSelector.boardResourcesSelector)(state);
	        var getBoardResource = (0, _immutableHelper.propFrom)(boardResourcesState);
	
	        var ancestorAndChildrenIds = (0, _mainSelector.getCurrentChildrenDeep)(state, { currentBoardId: boardId }).keySeq().toArray().concat((0, _mainSelector.getBreadcrumb)(state, { currentBoardId: boardId }).path);
	
	        // Fetch any ancestor or child which:
	        // - doesn't exist, or
	        // - is a board or alias and hasn't been fetched yet
	        var nextBoardsToFetch = ancestorAndChildrenIds.map(function (elementId) {
	            var el = getBoard(elementId);
	            return !el ? elementId : (0, _elementHelper.getPhysicalId)(el);
	        }).filter(function (elementId) {
	            return (0, _resourceUtil.shouldFetchResource)(false, getBoardResource(elementId));
	        });
	
	        return dispatch(fetchBoards({ boardIds: nextBoardsToFetch, excludeSelf: true, loadAncestors: false }));
	    };
	};
	
	/**
	 * Fetches the board and its children from the server if required.
	 * If the board has already been fetched from the server then it will not be re-fetched, unless it is 'forced' to.
	 *
	 * @param boardId {String} The boardId of the board to fetch from the server.
	 * @param force {Boolean} (Optional) If true this will
	 *
	 * @return {Promise} A promise resolved when the data has been retrieved.
	 */
	var fetchBoard = exports.fetchBoard = function fetchBoard(args) {
	    return function (dispatch, getState) {
	        var boardId = args.boardId,
	            force = args.force,
	            loadNextBoards = args.loadNextBoards,
	            loadAncestors = args.loadAncestors,
	            excludeSelf = args.excludeSelf;
	
	
	        if (!boardId) {
	            return Promise.reject('ERROR: boardService.fetchBoard: "boardId" must be provided');
	        }
	
	        var state = getState();
	        var boardResourcesState = (0, _boardSelector.boardResourcesSelector)(state);
	        var boardResource = boardResourcesState.get(boardId);
	
	        // If we shouldn't fetch the board then resolve immediately after fetching the next boards
	        if (!(0, _resourceUtil.shouldFetchResource)(force, boardResource)) {
	            if (loadNextBoards) dispatch(fetchNextBoards(boardId));
	            return Promise.resolve();
	        }
	
	        // Get the current children of the board to compare after the fetch and find out what's been deleted
	        var elements = state.get('elements');
	        var initialChildIds = (0, _elementHelper.getChildIdsDeep)(elements, boardId);
	
	        var config = {
	            timeout: 15000,
	            retry: 1,
	            params: {
	                loadAncestors: loadAncestors,
	                excludeSelf: excludeSelf
	            }
	        };
	
	        return boardsResourceService({ dispatch: dispatch, config: config, id: boardId }).then(function (response) {
	            if (!(0, _lodash.size)(response.data.elements)) return response;
	
	            // If the children have been returned for a board, then delete children that were initially there but are
	            // no longer
	            var childrenReturned = response.data.childrenReturned;
	            var deletedElementIds = childrenReturned && (0, _lodash.difference)(initialChildIds, (0, _lodash.keys)(response.data.elements));
	
	            dispatch((0, _elementActions.loadElements)(response.data.elements, deletedElementIds));
	            if (loadNextBoards) dispatch(fetchNextBoards(boardId));
	            return response;
	        });
	    };
	};
	
	var getModified = function getModified(boardId) {
	    return (0, _http2.default)({ url: 'boards/' + boardId + '/modified', timeout: 1000 }).then(function (response) {
	        return response.data.modifiedTime;
	    }).catch(function (err) {
	        console.error('ERROR: fetching board modified time', err, err.response);
	        // Getting the modified time isn't overly important, so just return null and it will
	        // automatically refresh this element
	        return null;
	    });
	};
	
	var refreshIfModified = exports.refreshIfModified = function refreshIfModified(args) {
	    return function (dispatch, getState) {
	        return getModified(args.boardId).then(function (modifiedTime) {
	            var state = getState();
	            var boardResourcesState = (0, _boardSelector.boardResourcesSelector)(state);
	            var boardFetchedTime = boardResourcesState.getIn([args.boardId, 'fetchedTime']);
	
	            if (!boardFetchedTime) _logger2.default.warn('Board \'' + args.boardId + '\' does not have a fetched time');
	
	            if (!modifiedTime || modifiedTime > boardFetchedTime) {
	                return dispatch(fetchBoard(_extends({}, args, { force: true })));
	            }
	
	            return Promise.resolve(true);
	        });
	    };
	};

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Utils
	
	
	// Constants
	
	
	// Actions
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDnd = __webpack_require__(72);
	
	var _reactRedux = __webpack_require__(3);
	
	var _defaultDropLocationFn = __webpack_require__(726);
	
	var _defaultDropLocationFn2 = _interopRequireDefault(_defaultDropLocationFn);
	
	var _elementConstants = __webpack_require__(12);
	
	var _draggingActions = __webpack_require__(462);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        onHover: function onHover(targetId, targetType) {
	            return dispatch((0, _draggingActions.dragOver)(targetId, targetType));
	        }
	    };
	};
	
	var defaultDropCollect = function defaultDropCollect(connector, monitor) {
	    return {
	        connectDropTarget: connector.dropTarget(),
	        isHovered: monitor.canDrop() && monitor.isOver({ shallow: true }),
	        canDrop: monitor.canDrop()
	    };
	};
	
	var injectTargetType = function injectTargetType(Element, targetType) {
	    return function (props) {
	        return _react2.default.createElement(Element, _extends({}, props, { targetType: targetType }));
	    };
	};
	
	exports.default = function () {
	    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var targetType = arguments[1];
	    var customCollect = arguments[2];
	    return function (Element) {
	        var acceptDropTypes = [_elementConstants.ELEMENT_DND_TYPE];
	
	        if (config && config.acceptDropTypes) {
	            acceptDropTypes = acceptDropTypes.concat(config.acceptDropTypes);
	            delete config.acceptDropTypes;
	        }
	
	        var elementDropTarget = _extends({ drop: _defaultDropLocationFn2.default }, config);
	
	        var dropCollect = customCollect || defaultDropCollect;
	
	        var dropTarget = (0, _reactDnd.DropTarget)(acceptDropTypes, elementDropTarget, dropCollect)(Element);
	        return targetType ? (0, _reactRedux.connect)(null, mapDispatchToProps)(injectTargetType(dropTarget, targetType)) : dropTarget;
	    };
	};

/***/ }),
/* 169 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ELEMENT_COUNT_INCREAESE = exports.ELEMENT_COUNT_INCREAESE = 'ELEMENT_COUNT_INCREAESE';
	var ELEMENT_COUNT_DECREASE = exports.ELEMENT_COUNT_DECREASE = 'ELEMENT_COUNT_DECREASE';
	
	var ELEMENT_COUNT_WARNING_START = exports.ELEMENT_COUNT_WARNING_START = 20;
	var ELEMENT_COUNT_WARNING_INTERVAL = exports.ELEMENT_COUNT_WARNING_INTERVAL = 10;
	
	var ELEMENT_COUNT_LIMIT_POPUP = exports.ELEMENT_COUNT_LIMIT_POPUP = 'billing-alert';

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.contentTotalLimitSelector = exports.contentTotalCountSelector = exports.contentElementCountSelector = exports.elementCountSelector = undefined;
	
	var _reselect = __webpack_require__(7);
	
	var _elementHelper = __webpack_require__(13);
	
	var elementCountSelector = exports.elementCountSelector = (0, _reselect.createSelector)(function (state) {
	    return state.get('elementCount');
	}, function (elementCount) {
	    return elementCount;
	});
	
	var contentElementCountSelector = exports.contentElementCountSelector = (0, _reselect.createSelector)(elementCountSelector, function (elementCount) {
	    return elementCount.filter(function (count, type) {
	        return (0, _elementHelper.isContent)(type);
	    });
	});
	
	var contentTotalCountSelector = exports.contentTotalCountSelector = (0, _reselect.createSelector)(contentElementCountSelector, function (elementCount) {
	    return elementCount.reduce(function (count, typeCount) {
	        return count + typeCount;
	    }, 0);
	});
	
	var contentTotalLimitSelector = exports.contentTotalLimitSelector = (0, _reselect.createSelector)(function (state) {
	    return state.getIn(['app', 'currentUser']);
	}, function (currentUser) {
	    return currentUser.get('contentLimit');
	});

/***/ }),
/* 171 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var NO_DRAG_OFFSET = exports.NO_DRAG_OFFSET = { x: 0, y: 0 };
	
	// New elements by default will be grabbed 3 grid units in from the top left
	var DEFAULT_NEW_ELEMENT_DRAG_OFFSET_GRID_UNITS = exports.DEFAULT_NEW_ELEMENT_DRAG_OFFSET_GRID_UNITS = { x: 3, y: 3 };

/***/ }),
/* 172 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var DRAG_MODIFIER_KEYS_SET = exports.DRAG_MODIFIER_KEYS_SET = 'DRAG_MODIFIER_KEYS_SET';
	
	var MODIFIER_KEYS = exports.MODIFIER_KEYS = {
	    ctrlKey: 'ctrlKey',
	    shiftKey: 'shiftKey',
	    altKey: 'altKey',
	    metaKey: 'metaKey'
	};
	
	var MODIFIER_KEYS_NAMES = exports.MODIFIER_KEYS_NAMES = Object.keys(MODIFIER_KEYS);

/***/ }),
/* 173 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	/**
	 * A generic element constructor which all elements can use to create their type.
	 */
	exports.default = function (_ref) {
	    var id = _ref.id,
	        location = _ref.location,
	        content = _ref.content,
	        modified = _ref.modified,
	        meta = _ref.meta;
	    return {
	        id: id,
	        location: location,
	        content: content,
	        modified: modified || new Date().getTime(),
	        meta: meta
	    };
	};

/***/ }),
/* 174 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LINK_TYPE = exports.LINK_TYPE = 'LINK';
	var LINK_DISPLAY_NAME = exports.LINK_DISPLAY_NAME = 'Link';

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getName = exports.getEmail = exports.getFamilyName = exports.getGivenName = exports.getDisplayName = exports.getId = exports.isActive = exports.isRealUserId = exports.isNotUserId = exports.isNotPublicUserId = exports.isStarterUserId = exports.isGuestUserId = exports.isPublicUserId = exports.isUserId = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _not = __webpack_require__(2129);
	
	var _not2 = _interopRequireDefault(_not);
	
	var _immutableHelper = __webpack_require__(23);
	
	var _userConstants = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Lib
	var isUserId = exports.isUserId = function isUserId(testUserId) {
	    return function (userId) {
	        return userId === testUserId;
	    };
	};
	
	// Constants
	
	
	// Util
	var isPublicUserId = exports.isPublicUserId = isUserId(_userConstants.PUBLIC_USER_ID);
	var isGuestUserId = exports.isGuestUserId = isUserId(_userConstants.GUEST_USER_ID);
	var isStarterUserId = exports.isStarterUserId = isUserId(_userConstants.STARTER_CONTENT_CREATOR_ID);
	
	var isNotPublicUserId = exports.isNotPublicUserId = (0, _lodash.flow)([isPublicUserId, _not2.default]);
	var isNotUserId = exports.isNotUserId = function isNotUserId(testUserId) {
	    return (0, _lodash.flow)([isUserId(testUserId), _not2.default]);
	};
	
	var isRealUserId = exports.isRealUserId = function isRealUserId(userId) {
	    return !isPublicUserId(userId) && !isGuestUserId(userId) && !isStarterUserId(userId);
	};
	
	var isActive = exports.isActive = function isActive(user) {
	    return (0, _immutableHelper.prop)('status', user) === _userConstants.USER_STATUSES.ACTIVE;
	};
	
	var getId = exports.getId = (0, _immutableHelper.prop)('_id');
	var getDisplayName = exports.getDisplayName = (0, _immutableHelper.propIn)(['name', 'displayName']);
	var getGivenName = exports.getGivenName = (0, _immutableHelper.propIn)(['name', 'givenName']);
	var getFamilyName = exports.getFamilyName = (0, _immutableHelper.propIn)(['name', 'familyName']);
	var getEmail = exports.getEmail = (0, _immutableHelper.prop)('email');
	
	var getName = exports.getName = function getName(user) {
	    return getDisplayName(user) || getEmail(user) || 'Someone';
	};

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	if (true) {
	  module.exports = Emitter;
	}
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  function on() {
	    this.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks['$' + event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks['$' + event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(29)('unscopables')
	  , ArrayProto  = Array.prototype;
	if(ArrayProto[UNSCOPABLES] == undefined)__webpack_require__(68)(ArrayProto, UNSCOPABLES, {});
	module.exports = function(key){
	  ArrayProto[UNSCOPABLES][key] = true;
	};

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx         = __webpack_require__(113)
	  , call        = __webpack_require__(509)
	  , isArrayIter = __webpack_require__(335)
	  , anObject    = __webpack_require__(14)
	  , toLength    = __webpack_require__(44)
	  , getIterFn   = __webpack_require__(352)
	  , BREAK       = {}
	  , RETURN      = {};
	var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
	  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
	    , f      = ctx(fn, that, entries ? 2 : 1)
	    , index  = 0
	    , length, step, iterator, result;
	  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if(result === BREAK || result === RETURN)return result;
	  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
	    result = call(iterator, f, step.value, entries);
	    if(result === BREAK || result === RETURN)return result;
	  }
	};
	exports.BREAK  = BREAK;
	exports.RETURN = RETURN;

/***/ }),
/* 179 */
/***/ (function(module, exports) {

	module.exports = {};

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(38).f
	  , has = __webpack_require__(62)
	  , TAG = __webpack_require__(29)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(5)
	  , defined = __webpack_require__(92)
	  , fails   = __webpack_require__(19)
	  , spaces  = __webpack_require__(348)
	  , space   = '[' + spaces + ']'
	  , non     = '\u200b\u0085'
	  , ltrim   = RegExp('^' + space + space + '*')
	  , rtrim   = RegExp(space + space + '*$');
	
	var exporter = function(KEY, exec, ALIAS){
	  var exp   = {};
	  var FORCE = fails(function(){
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if(ALIAS)exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function(string, TYPE){
	  string = String(defined(string));
	  if(TYPE & 1)string = string.replace(ltrim, '');
	  if(TYPE & 2)string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SelectionState
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Immutable = __webpack_require__(28);
	
	var Record = Immutable.Record;
	
	
	var defaultRecord = {
	  anchorKey: '',
	  anchorOffset: 0,
	  focusKey: '',
	  focusOffset: 0,
	  isBackward: false,
	  hasFocus: false
	};
	
	var SelectionStateRecord = Record(defaultRecord);
	
	var SelectionState = function (_SelectionStateRecord) {
	  _inherits(SelectionState, _SelectionStateRecord);
	
	  function SelectionState() {
	    _classCallCheck(this, SelectionState);
	
	    return _possibleConstructorReturn(this, _SelectionStateRecord.apply(this, arguments));
	  }
	
	  SelectionState.prototype.serialize = function serialize() {
	    return 'Anchor: ' + this.getAnchorKey() + ':' + this.getAnchorOffset() + ', ' + 'Focus: ' + this.getFocusKey() + ':' + this.getFocusOffset() + ', ' + 'Is Backward: ' + String(this.getIsBackward()) + ', ' + 'Has Focus: ' + String(this.getHasFocus());
	  };
	
	  SelectionState.prototype.getAnchorKey = function getAnchorKey() {
	    return this.get('anchorKey');
	  };
	
	  SelectionState.prototype.getAnchorOffset = function getAnchorOffset() {
	    return this.get('anchorOffset');
	  };
	
	  SelectionState.prototype.getFocusKey = function getFocusKey() {
	    return this.get('focusKey');
	  };
	
	  SelectionState.prototype.getFocusOffset = function getFocusOffset() {
	    return this.get('focusOffset');
	  };
	
	  SelectionState.prototype.getIsBackward = function getIsBackward() {
	    return this.get('isBackward');
	  };
	
	  SelectionState.prototype.getHasFocus = function getHasFocus() {
	    return this.get('hasFocus');
	  };
	
	  /**
	   * Return whether the specified range overlaps with an edge of the
	   * SelectionState.
	   */
	
	
	  SelectionState.prototype.hasEdgeWithin = function hasEdgeWithin(blockKey, start, end) {
	    var anchorKey = this.getAnchorKey();
	    var focusKey = this.getFocusKey();
	
	    if (anchorKey === focusKey && anchorKey === blockKey) {
	      var selectionStart = this.getStartOffset();
	      var selectionEnd = this.getEndOffset();
	      return start <= selectionEnd && selectionStart <= end;
	    }
	
	    if (blockKey !== anchorKey && blockKey !== focusKey) {
	      return false;
	    }
	
	    var offsetToCheck = blockKey === anchorKey ? this.getAnchorOffset() : this.getFocusOffset();
	
	    return start <= offsetToCheck && end >= offsetToCheck;
	  };
	
	  SelectionState.prototype.isCollapsed = function isCollapsed() {
	    return this.getAnchorKey() === this.getFocusKey() && this.getAnchorOffset() === this.getFocusOffset();
	  };
	
	  SelectionState.prototype.getStartKey = function getStartKey() {
	    return this.getIsBackward() ? this.getFocusKey() : this.getAnchorKey();
	  };
	
	  SelectionState.prototype.getStartOffset = function getStartOffset() {
	    return this.getIsBackward() ? this.getFocusOffset() : this.getAnchorOffset();
	  };
	
	  SelectionState.prototype.getEndKey = function getEndKey() {
	    return this.getIsBackward() ? this.getAnchorKey() : this.getFocusKey();
	  };
	
	  SelectionState.prototype.getEndOffset = function getEndOffset() {
	    return this.getIsBackward() ? this.getAnchorOffset() : this.getFocusOffset();
	  };
	
	  SelectionState.createEmpty = function createEmpty(key) {
	    return new SelectionState({
	      anchorKey: key,
	      anchorOffset: 0,
	      focusKey: key,
	      focusOffset: 0,
	      isBackward: false,
	      hasFocus: false
	    });
	  };
	
	  return SelectionState;
	}(SelectionStateRecord);
	
	module.exports = SelectionState;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies.
	 */
	
	var keys = __webpack_require__(1118);
	var hasBinary = __webpack_require__(569);
	var sliceBuffer = __webpack_require__(805);
	var after = __webpack_require__(804);
	var utf8 = __webpack_require__(1119);
	
	var base64encoder;
	if (global && global.ArrayBuffer) {
	  base64encoder = __webpack_require__(827);
	}
	
	/**
	 * Check if we are running an android browser. That requires us to use
	 * ArrayBuffer with polling transports...
	 *
	 * http://ghinda.net/jpeg-blob-ajax-android/
	 */
	
	var isAndroid = typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent);
	
	/**
	 * Check if we are running in PhantomJS.
	 * Uploading a Blob with PhantomJS does not work correctly, as reported here:
	 * https://github.com/ariya/phantomjs/issues/11395
	 * @type boolean
	 */
	var isPhantomJS = typeof navigator !== 'undefined' && /PhantomJS/i.test(navigator.userAgent);
	
	/**
	 * When true, avoids using Blobs to encode payloads.
	 * @type boolean
	 */
	var dontSendBlobs = isAndroid || isPhantomJS;
	
	/**
	 * Current protocol version.
	 */
	
	exports.protocol = 3;
	
	/**
	 * Packet types.
	 */
	
	var packets = exports.packets = {
	    open:     0    // non-ws
	  , close:    1    // non-ws
	  , ping:     2
	  , pong:     3
	  , message:  4
	  , upgrade:  5
	  , noop:     6
	};
	
	var packetslist = keys(packets);
	
	/**
	 * Premade error packet.
	 */
	
	var err = { type: 'error', data: 'parser error' };
	
	/**
	 * Create a blob api even for blob builder when vendor prefixes exist
	 */
	
	var Blob = __webpack_require__(830);
	
	/**
	 * Encodes a packet.
	 *
	 *     <packet type id> [ <data> ]
	 *
	 * Example:
	 *
	 *     5hello world
	 *     3
	 *     4
	 *
	 * Binary is encoded in an identical principle
	 *
	 * @api private
	 */
	
	exports.encodePacket = function (packet, supportsBinary, utf8encode, callback) {
	  if (typeof supportsBinary === 'function') {
	    callback = supportsBinary;
	    supportsBinary = false;
	  }
	
	  if (typeof utf8encode === 'function') {
	    callback = utf8encode;
	    utf8encode = null;
	  }
	
	  var data = (packet.data === undefined)
	    ? undefined
	    : packet.data.buffer || packet.data;
	
	  if (global.ArrayBuffer && data instanceof ArrayBuffer) {
	    return encodeArrayBuffer(packet, supportsBinary, callback);
	  } else if (Blob && data instanceof global.Blob) {
	    return encodeBlob(packet, supportsBinary, callback);
	  }
	
	  // might be an object with { base64: true, data: dataAsBase64String }
	  if (data && data.base64) {
	    return encodeBase64Object(packet, callback);
	  }
	
	  // Sending data as a utf-8 string
	  var encoded = packets[packet.type];
	
	  // data fragment is optional
	  if (undefined !== packet.data) {
	    encoded += utf8encode ? utf8.encode(String(packet.data), { strict: false }) : String(packet.data);
	  }
	
	  return callback('' + encoded);
	
	};
	
	function encodeBase64Object(packet, callback) {
	  // packet data is an object { base64: true, data: dataAsBase64String }
	  var message = 'b' + exports.packets[packet.type] + packet.data.data;
	  return callback(message);
	}
	
	/**
	 * Encode packet helpers for binary types
	 */
	
	function encodeArrayBuffer(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  var data = packet.data;
	  var contentArray = new Uint8Array(data);
	  var resultBuffer = new Uint8Array(1 + data.byteLength);
	
	  resultBuffer[0] = packets[packet.type];
	  for (var i = 0; i < contentArray.length; i++) {
	    resultBuffer[i+1] = contentArray[i];
	  }
	
	  return callback(resultBuffer.buffer);
	}
	
	function encodeBlobAsArrayBuffer(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  var fr = new FileReader();
	  fr.onload = function() {
	    packet.data = fr.result;
	    exports.encodePacket(packet, supportsBinary, true, callback);
	  };
	  return fr.readAsArrayBuffer(packet.data);
	}
	
	function encodeBlob(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  if (dontSendBlobs) {
	    return encodeBlobAsArrayBuffer(packet, supportsBinary, callback);
	  }
	
	  var length = new Uint8Array(1);
	  length[0] = packets[packet.type];
	  var blob = new Blob([length.buffer, packet.data]);
	
	  return callback(blob);
	}
	
	/**
	 * Encodes a packet with binary data in a base64 string
	 *
	 * @param {Object} packet, has `type` and `data`
	 * @return {String} base64 encoded message
	 */
	
	exports.encodeBase64Packet = function(packet, callback) {
	  var message = 'b' + exports.packets[packet.type];
	  if (Blob && packet.data instanceof global.Blob) {
	    var fr = new FileReader();
	    fr.onload = function() {
	      var b64 = fr.result.split(',')[1];
	      callback(message + b64);
	    };
	    return fr.readAsDataURL(packet.data);
	  }
	
	  var b64data;
	  try {
	    b64data = String.fromCharCode.apply(null, new Uint8Array(packet.data));
	  } catch (e) {
	    // iPhone Safari doesn't let you apply with typed arrays
	    var typed = new Uint8Array(packet.data);
	    var basic = new Array(typed.length);
	    for (var i = 0; i < typed.length; i++) {
	      basic[i] = typed[i];
	    }
	    b64data = String.fromCharCode.apply(null, basic);
	  }
	  message += global.btoa(b64data);
	  return callback(message);
	};
	
	/**
	 * Decodes a packet. Changes format to Blob if requested.
	 *
	 * @return {Object} with `type` and `data` (if any)
	 * @api private
	 */
	
	exports.decodePacket = function (data, binaryType, utf8decode) {
	  if (data === undefined) {
	    return err;
	  }
	  // String data
	  if (typeof data === 'string') {
	    if (data.charAt(0) === 'b') {
	      return exports.decodeBase64Packet(data.substr(1), binaryType);
	    }
	
	    if (utf8decode) {
	      data = tryDecode(data);
	      if (data === false) {
	        return err;
	      }
	    }
	    var type = data.charAt(0);
	
	    if (Number(type) != type || !packetslist[type]) {
	      return err;
	    }
	
	    if (data.length > 1) {
	      return { type: packetslist[type], data: data.substring(1) };
	    } else {
	      return { type: packetslist[type] };
	    }
	  }
	
	  var asArray = new Uint8Array(data);
	  var type = asArray[0];
	  var rest = sliceBuffer(data, 1);
	  if (Blob && binaryType === 'blob') {
	    rest = new Blob([rest]);
	  }
	  return { type: packetslist[type], data: rest };
	};
	
	function tryDecode(data) {
	  try {
	    data = utf8.decode(data, { strict: false });
	  } catch (e) {
	    return false;
	  }
	  return data;
	}
	
	/**
	 * Decodes a packet encoded in a base64 string
	 *
	 * @param {String} base64 encoded message
	 * @return {Object} with `type` and `data` (if any)
	 */
	
	exports.decodeBase64Packet = function(msg, binaryType) {
	  var type = packetslist[msg.charAt(0)];
	  if (!base64encoder) {
	    return { type: type, data: { base64: true, data: msg.substr(1) } };
	  }
	
	  var data = base64encoder.decode(msg.substr(1));
	
	  if (binaryType === 'blob' && Blob) {
	    data = new Blob([data]);
	  }
	
	  return { type: type, data: data };
	};
	
	/**
	 * Encodes multiple messages (payload).
	 *
	 *     <length>:data
	 *
	 * Example:
	 *
	 *     11:hello world2:hi
	 *
	 * If any contents are binary, they will be encoded as base64 strings. Base64
	 * encoded strings are marked with a b before the length specifier
	 *
	 * @param {Array} packets
	 * @api private
	 */
	
	exports.encodePayload = function (packets, supportsBinary, callback) {
	  if (typeof supportsBinary === 'function') {
	    callback = supportsBinary;
	    supportsBinary = null;
	  }
	
	  var isBinary = hasBinary(packets);
	
	  if (supportsBinary && isBinary) {
	    if (Blob && !dontSendBlobs) {
	      return exports.encodePayloadAsBlob(packets, callback);
	    }
	
	    return exports.encodePayloadAsArrayBuffer(packets, callback);
	  }
	
	  if (!packets.length) {
	    return callback('0:');
	  }
	
	  function setLengthHeader(message) {
	    return message.length + ':' + message;
	  }
	
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, !isBinary ? false : supportsBinary, false, function(message) {
	      doneCallback(null, setLengthHeader(message));
	    });
	  }
	
	  map(packets, encodeOne, function(err, results) {
	    return callback(results.join(''));
	  });
	};
	
	/**
	 * Async array map using after
	 */
	
	function map(ary, each, done) {
	  var result = new Array(ary.length);
	  var next = after(ary.length, done);
	
	  var eachWithIndex = function(i, el, cb) {
	    each(el, function(error, msg) {
	      result[i] = msg;
	      cb(error, result);
	    });
	  };
	
	  for (var i = 0; i < ary.length; i++) {
	    eachWithIndex(i, ary[i], next);
	  }
	}
	
	/*
	 * Decodes data when a payload is maybe expected. Possible binary contents are
	 * decoded from their base64 representation
	 *
	 * @param {String} data, callback method
	 * @api public
	 */
	
	exports.decodePayload = function (data, binaryType, callback) {
	  if (typeof data !== 'string') {
	    return exports.decodePayloadAsBinary(data, binaryType, callback);
	  }
	
	  if (typeof binaryType === 'function') {
	    callback = binaryType;
	    binaryType = null;
	  }
	
	  var packet;
	  if (data === '') {
	    // parser error - ignoring payload
	    return callback(err, 0, 1);
	  }
	
	  var length = '', n, msg;
	
	  for (var i = 0, l = data.length; i < l; i++) {
	    var chr = data.charAt(i);
	
	    if (chr !== ':') {
	      length += chr;
	      continue;
	    }
	
	    if (length === '' || (length != (n = Number(length)))) {
	      // parser error - ignoring payload
	      return callback(err, 0, 1);
	    }
	
	    msg = data.substr(i + 1, n);
	
	    if (length != msg.length) {
	      // parser error - ignoring payload
	      return callback(err, 0, 1);
	    }
	
	    if (msg.length) {
	      packet = exports.decodePacket(msg, binaryType, false);
	
	      if (err.type === packet.type && err.data === packet.data) {
	        // parser error in individual packet - ignoring payload
	        return callback(err, 0, 1);
	      }
	
	      var ret = callback(packet, i + n, l);
	      if (false === ret) return;
	    }
	
	    // advance cursor
	    i += n;
	    length = '';
	  }
	
	  if (length !== '') {
	    // parser error - ignoring payload
	    return callback(err, 0, 1);
	  }
	
	};
	
	/**
	 * Encodes multiple messages (payload) as binary.
	 *
	 * <1 = binary, 0 = string><number from 0-9><number from 0-9>[...]<number
	 * 255><data>
	 *
	 * Example:
	 * 1 3 255 1 2 3, if the binary contents are interpreted as 8 bit integers
	 *
	 * @param {Array} packets
	 * @return {ArrayBuffer} encoded payload
	 * @api private
	 */
	
	exports.encodePayloadAsArrayBuffer = function(packets, callback) {
	  if (!packets.length) {
	    return callback(new ArrayBuffer(0));
	  }
	
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, true, true, function(data) {
	      return doneCallback(null, data);
	    });
	  }
	
	  map(packets, encodeOne, function(err, encodedPackets) {
	    var totalLength = encodedPackets.reduce(function(acc, p) {
	      var len;
	      if (typeof p === 'string'){
	        len = p.length;
	      } else {
	        len = p.byteLength;
	      }
	      return acc + len.toString().length + len + 2; // string/binary identifier + separator = 2
	    }, 0);
	
	    var resultArray = new Uint8Array(totalLength);
	
	    var bufferIndex = 0;
	    encodedPackets.forEach(function(p) {
	      var isString = typeof p === 'string';
	      var ab = p;
	      if (isString) {
	        var view = new Uint8Array(p.length);
	        for (var i = 0; i < p.length; i++) {
	          view[i] = p.charCodeAt(i);
	        }
	        ab = view.buffer;
	      }
	
	      if (isString) { // not true binary
	        resultArray[bufferIndex++] = 0;
	      } else { // true binary
	        resultArray[bufferIndex++] = 1;
	      }
	
	      var lenStr = ab.byteLength.toString();
	      for (var i = 0; i < lenStr.length; i++) {
	        resultArray[bufferIndex++] = parseInt(lenStr[i]);
	      }
	      resultArray[bufferIndex++] = 255;
	
	      var view = new Uint8Array(ab);
	      for (var i = 0; i < view.length; i++) {
	        resultArray[bufferIndex++] = view[i];
	      }
	    });
	
	    return callback(resultArray.buffer);
	  });
	};
	
	/**
	 * Encode as Blob
	 */
	
	exports.encodePayloadAsBlob = function(packets, callback) {
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, true, true, function(encoded) {
	      var binaryIdentifier = new Uint8Array(1);
	      binaryIdentifier[0] = 1;
	      if (typeof encoded === 'string') {
	        var view = new Uint8Array(encoded.length);
	        for (var i = 0; i < encoded.length; i++) {
	          view[i] = encoded.charCodeAt(i);
	        }
	        encoded = view.buffer;
	        binaryIdentifier[0] = 0;
	      }
	
	      var len = (encoded instanceof ArrayBuffer)
	        ? encoded.byteLength
	        : encoded.size;
	
	      var lenStr = len.toString();
	      var lengthAry = new Uint8Array(lenStr.length + 1);
	      for (var i = 0; i < lenStr.length; i++) {
	        lengthAry[i] = parseInt(lenStr[i]);
	      }
	      lengthAry[lenStr.length] = 255;
	
	      if (Blob) {
	        var blob = new Blob([binaryIdentifier.buffer, lengthAry.buffer, encoded]);
	        doneCallback(null, blob);
	      }
	    });
	  }
	
	  map(packets, encodeOne, function(err, results) {
	    return callback(new Blob(results));
	  });
	};
	
	/*
	 * Decodes data when a payload is maybe expected. Strings are decoded by
	 * interpreting each byte as a key code for entries marked to start with 0. See
	 * description of encodePayloadAsBinary
	 *
	 * @param {ArrayBuffer} data, callback method
	 * @api public
	 */
	
	exports.decodePayloadAsBinary = function (data, binaryType, callback) {
	  if (typeof binaryType === 'function') {
	    callback = binaryType;
	    binaryType = null;
	  }
	
	  var bufferTail = data;
	  var buffers = [];
	
	  while (bufferTail.byteLength > 0) {
	    var tailArray = new Uint8Array(bufferTail);
	    var isString = tailArray[0] === 0;
	    var msgLength = '';
	
	    for (var i = 1; ; i++) {
	      if (tailArray[i] === 255) break;
	
	      // 310 = char length of Number.MAX_VALUE
	      if (msgLength.length > 310) {
	        return callback(err, 0, 1);
	      }
	
	      msgLength += tailArray[i];
	    }
	
	    bufferTail = sliceBuffer(bufferTail, 2 + msgLength.length);
	    msgLength = parseInt(msgLength);
	
	    var msg = sliceBuffer(bufferTail, 0, msgLength);
	    if (isString) {
	      try {
	        msg = String.fromCharCode.apply(null, new Uint8Array(msg));
	      } catch (e) {
	        // iPhone Safari doesn't let you apply to typed arrays
	        var typed = new Uint8Array(msg);
	        msg = '';
	        for (var i = 0; i < typed.length; i++) {
	          msg += String.fromCharCode(typed[i]);
	        }
	      }
	    }
	
	    buffers.push(msg);
	    bufferTail = sliceBuffer(bufferTail, msgLength);
	  }
	
	  var total = buffers.length;
	  buffers.forEach(function(buffer, i) {
	    callback(exports.decodePacket(buffer, binaryType, true), i, total);
	  });
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 184 */
/***/ (function(module, exports) {

	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	'use strict';
	
	exports.__esModule = true;
	var PUSH = 'PUSH';
	
	exports.PUSH = PUSH;
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = 'REPLACE';
	
	exports.REPLACE = REPLACE;
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = 'POP';
	
	exports.POP = POP;
	exports['default'] = {
	  PUSH: PUSH,
	  REPLACE: REPLACE,
	  POP: POP
	};

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(588),
	    overRest = __webpack_require__(1422),
	    setToString = __webpack_require__(1425);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ }),
/* 186 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(386);
	var setInnerHTML = __webpack_require__(281);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(394);
	var setTextContent = __webpack_require__(623);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var invariant = __webpack_require__(10);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(1510);
	var ReactInstrumentation = __webpack_require__(95);
	
	var warning = __webpack_require__(16);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
	  ) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern);
	
	  var regexpSource = _compilePattern2.regexpSource;
	  var paramNames = _compilePattern2.paramNames;
	  var tokens = _compilePattern2.tokens;
	
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames;
	  var paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern);
	
	  var tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0;
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenCount += 1;
	    } else if (token === ')') {
	      parenCount -= 1;
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURIComponent(paramValue);
	    } else {
	      pathname += token;
	    }
	  }
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(20);
	
	var ReactChildren = __webpack_require__(1579);
	var ReactComponent = __webpack_require__(405);
	var ReactPureComponent = __webpack_require__(1584);
	var ReactClass = __webpack_require__(1580);
	var ReactDOMFactories = __webpack_require__(1581);
	var ReactElement = __webpack_require__(192);
	var ReactPropTypes = __webpack_require__(1583);
	var ReactVersion = __webpack_require__(1585);
	
	var onlyChild = __webpack_require__(1588);
	var warning = __webpack_require__(16);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	
	if (false) {
	  var warned = false;
	  __spread = function () {
	    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
	    warned = true;
	    return _assign.apply(null, arguments);
	  };
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	// TODO: Fix tests so that this deprecation warning doesn't cause failures.
	if (false) {
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        process.env.NODE_ENV !== 'production' ? warning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated. Use ' + 'the prop-types package from npm instead.') : void 0;
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	  }
	}
	
	module.exports = React;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(20);
	
	var ReactCurrentOwner = __webpack_require__(120);
	
	var warning = __webpack_require__(16);
	var canDefineProperty = __webpack_require__(640);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(639);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ }),
/* 193 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ }),
/* 194 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.makeFieldValue = makeFieldValue;
	exports.isFieldValue = isFieldValue;
	var flag = '_isFieldValue';
	var isObject = function isObject(object) {
	  return typeof object === 'object';
	};
	
	function makeFieldValue(object) {
	  if (object && isObject(object)) {
	    // This flag has to be enumerable, because otherwise it is not possible
	    // to serialize object with this field.
	    // The consequence is you lose information that particular field is
	    // field or nested group of fields, so you're not able to fetch
	    // field value from state when it has been affected in some way
	    // by serializing/using immutable and so on.
	    // @fixme marking field as leaf should be made in other way
	    Object.defineProperty(object, flag, { value: true, enumerable: true });
	  }
	  return object;
	}
	
	function isFieldValue(object) {
	  return !!(object && isObject(object) && object[flag]);
	}

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(418);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(1652);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(1651);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(1650);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(663);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(664);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.COMMANDS = exports.CHECKLIST_BLOCK_TYPE = undefined;
	
	var _richTextConstants = __webpack_require__(166);
	
	var CHECKLIST_BLOCK_TYPE = exports.CHECKLIST_BLOCK_TYPE = _richTextConstants.STYLE_COMMANDS.CHECKLIST; // TODO Rethink how this is structured
	var COMMANDS = exports.COMMANDS = {
	    MOVE_SELECTION_TO_END_OF_PREVIOUS_BLOCK: 'move-selection-to-end-of-prev-block'
	};

/***/ }),
/* 197 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var EDITOR_STORE_NAME = exports.EDITOR_STORE_NAME = 'editorStore';
	
	// Actions Types
	var EDITOR_STATE_CHANGED = exports.EDITOR_STATE_CHANGED = 'EDITOR_STATE_CHANGED';
	var EDITOR_STYLE_COMMAND = exports.EDITOR_STYLE_COMMAND = 'EDITOR_STYLE_COMMAND';

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1165);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FlexCenter = function FlexCenter(_ref) {
	    var children = _ref.children,
	        className = _ref.className;
	    return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('FlexCenter', className) },
	        _react2.default.createElement(
	            'div',
	            { className: 'flex-center-content' },
	            children
	        )
	    );
	};
	
	FlexCenter.propTypes = {
	    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array, _propTypes2.default.string]),
	    className: _propTypes2.default.string
	};
	
	exports.default = FlexCenter;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _userUtil = __webpack_require__(31);
	
	__webpack_require__(1186);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO 944 - Add back in when user image design is completed
	// import ImageAvatar from './ImageAvatar';
	
	// Util
	// Lib
	var GuestAvatar = function GuestAvatar() {
	    return _react2.default.createElement(
	        'span',
	        { className: 'guest' },
	        _react2.default.createElement(_Icon2.default, { name: 'user-guest' })
	    );
	};
	
	// Styles
	
	
	// Components
	
	
	var getAvatar = function getAvatar(user, size) {
	    if (!user || user.get('isGuest')) return _react2.default.createElement(GuestAvatar, null);
	
	    // TODO 944 - Add back in when user image design is completed
	    // if (user.get('image')) return <ImageAvatar user={user} size={size} />;
	
	    if (!user.getIn(['name', 'givenName'])) return _react2.default.createElement(GuestAvatar, null);
	
	    return _react2.default.createElement(
	        'span',
	        { className: 'initals' },
	        (0, _userUtil.getInitials)(user)
	    );
	};
	
	var UserAvatar = function UserAvatar(_ref) {
	    var user = _ref.user,
	        pulse = _ref.pulse,
	        active = _ref.active,
	        filter = _ref.filter,
	        size = _ref.size;
	    return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('UserAvatar', size, { pulse: pulse, active: active, filter: filter }) },
	        getAvatar(user, size),
	        _react2.default.createElement('div', { className: 'border' })
	    );
	};
	
	UserAvatar.propTypes = {
	    user: _propTypes2.default.object.isRequired,
	    pulse: _propTypes2.default.bool,
	    active: _propTypes2.default.bool,
	    filter: _propTypes2.default.bool,
	    size: _propTypes2.default.string
	};
	
	exports.default = UserAvatar;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDnd = __webpack_require__(72);
	
	var _lineConstants = __webpack_require__(57);
	
	var _dndConstants = __webpack_require__(171);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	// Constants
	
	
	var getIsOtherEdgeAlreadyConnected = function getIsOtherEdgeAlreadyConnected(props, monitor) {
	    var element = props.element;
	
	
	    var elementId = element.get('id');
	    var draggedEdge = monitor.getItem().edge;
	    var lineElement = monitor.getItem().element;
	
	    var oppositeEdge = draggedEdge === _lineConstants.LINE_EDGE.start ? _lineConstants.LINE_EDGE.end : _lineConstants.LINE_EDGE.start;
	    return lineElement.getIn(['content', oppositeEdge, 'elementId']) === elementId;
	};
	
	var getIsAlreadyConnected = function getIsAlreadyConnected(props, monitor) {
	    var element = props.element;
	
	    var elementId = element.get('id');
	    var lineElement = monitor.getItem().element;
	    return lineElement.getIn(['content', 'start', 'elementId']) === elementId || lineElement.getIn(['content', 'end', 'elementId']) === elementId;
	};
	
	var elementLineEdgeDropTargetSpec = {
	    drop: function drop(props, monitor) {
	        var element = props.element;
	
	
	        if (monitor.didDrop()) return;
	
	        var elementId = element.get('id');
	
	        // If already connected prevent drop
	        var isAlreadyConnected = getIsAlreadyConnected(props, monitor);
	        if (isAlreadyConnected) return;
	
	        var offsetDiff = monitor.getDifferenceFromInitialOffset() || _dndConstants.NO_DRAG_OFFSET;
	        return { offsetDiff: offsetDiff, snapped: true, elementId: elementId };
	    },
	    hover: function hover(props, monitor, component) {
	        // If other edge already connected prevent hover style
	        var isOtherEdgeAlreadyConnected = getIsOtherEdgeAlreadyConnected(props, monitor);
	        component.setAlreadyConnected(isOtherEdgeAlreadyConnected);
	    },
	    canDrop: function canDrop(props) {
	        return !props.isLocked;
	    }
	};
	
	var elementLineEdgeDropCollect = function elementLineEdgeDropCollect(connector, monitor) {
	    return {
	        connectLineEdgeDropTarget: connector.dropTarget(),
	        isLineEdgeHovered: monitor.isOver({ shallow: true })
	    };
	};
	
	exports.default = function (DecoratedComponent) {
	    var _dec, _class;
	
	    var elementLineEdgeDropTarget = (_dec = (0, _reactDnd.DropTarget)(_lineConstants.LINE_EDGE_DND_TYPE, elementLineEdgeDropTargetSpec, elementLineEdgeDropCollect), _dec(_class = function (_React$Component) {
	        _inherits(elementLineEdgeDropTarget, _React$Component);
	
	        function elementLineEdgeDropTarget(props) {
	            _classCallCheck(this, elementLineEdgeDropTarget);
	
	            var _this = _possibleConstructorReturn(this, (elementLineEdgeDropTarget.__proto__ || Object.getPrototypeOf(elementLineEdgeDropTarget)).call(this, props));
	
	            _this.setAlreadyConnected = function (isAlreadyConnected) {
	                if (_this.state.isAlreadyConnected === isAlreadyConnected) return;
	                _this.setState({ isAlreadyConnected: isAlreadyConnected });
	            };
	
	            _this.state = { isAlreadyConnected: false };
	            return _this;
	        }
	
	        _createClass(elementLineEdgeDropTarget, [{
	            key: 'render',
	            value: function render() {
	                var _props = this.props,
	                    isLineEdgeHovered = _props.isLineEdgeHovered,
	                    props = _objectWithoutProperties(_props, ['isLineEdgeHovered']);
	
	                var isAlreadyConnected = this.state.isAlreadyConnected;
	
	                var showIsHovered = !props.isLocked && isLineEdgeHovered && !isAlreadyConnected;
	
	                return _react2.default.createElement(DecoratedComponent, _extends({ isLineEdgeHovered: showIsHovered }, props));
	            }
	        }]);
	
	        return elementLineEdgeDropTarget;
	    }(_react2.default.Component)) || _class);
	
	
	    elementLineEdgeDropTarget.propTypes = {
	        element: _propTypes2.default.object.isRequired,
	        getIsAlreadyConnected: _propTypes2.default.func,
	        isLineEdgeHovered: _propTypes2.default.bool
	    };
	
	    return elementLineEdgeDropTarget;
	};

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getLinePointsOfInterest = exports.getVisibleConnectionPoint = exports.getEdgeOriginAndRect = exports.isLineEdgeSnapped = exports.getUnsnappedCoordinates = exports.enlargeLine = exports.getLineDistance = exports.getEdgePosition = exports.isEndEdge = exports.isStartEdge = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Utils
	
	
	// Geometry
	
	
	// Constants
	
	
	var _immutableHelper = __webpack_require__(23);
	
	var _rect = __webpack_require__(208);
	
	var rectLib = _interopRequireWildcard(_rect);
	
	var _point = __webpack_require__(50);
	
	var pointLib = _interopRequireWildcard(_point);
	
	var _bezierUtil = __webpack_require__(795);
	
	var _lineControlPointUtil = __webpack_require__(456);
	
	var _lineConstants = __webpack_require__(57);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var isStartEdge = exports.isStartEdge = function isStartEdge(edge) {
	    return edge === _lineConstants.LINE_EDGE.start;
	};
	var isEndEdge = exports.isEndEdge = function isEndEdge(edge) {
	    return edge === _lineConstants.LINE_EDGE.end;
	};
	
	var getEdgePosition = exports.getEdgePosition = function getEdgePosition(lineEdge) {
	    return pointLib.getPoint((0, _immutableHelper.prop)('x', lineEdge), (0, _immutableHelper.prop)('y', lineEdge));
	};
	
	var getLineDistance = exports.getLineDistance = function getLineDistance(_ref) {
	    var start = _ref.start,
	        end = _ref.end;
	
	    var startPoint = getEdgePosition(start);
	    var endPoint = getEdgePosition(end);
	    return pointLib.getDistance(startPoint, endPoint);
	};
	
	var enlargeLine = exports.enlargeLine = pointLib.moveFrom;
	
	var getUnsnappedCoordinates = exports.getUnsnappedCoordinates = function getUnsnappedCoordinates(lineEdge, gridSize) {
	    return pointLib.scale(gridSize, getEdgePosition(lineEdge));
	};
	
	var isLineEdgeSnapped = exports.isLineEdgeSnapped = function isLineEdgeSnapped(lineEdge) {
	    return lineEdge && lineEdge.get('snapped');
	};
	
	var getConnectedElementMeasurements = function getConnectedElementMeasurements(_ref2) {
	    var lineEdge = _ref2.lineEdge,
	        measurementsMap = _ref2.measurementsMap;
	
	    if (!isLineEdgeSnapped(lineEdge)) return null;
	    var connectedElementId = lineEdge.get('elementId');
	    var connectedElementMeasurements = measurementsMap.get(connectedElementId);
	    return connectedElementMeasurements && connectedElementMeasurements.toJS();
	};
	
	/**
	 * Gets the translation from the top left point of the line element to the top left point of the connected element.
	 */
	var getConnectedElementCoordinateTranslation = function getConnectedElementCoordinateTranslation(_ref3) {
	    var connectedElementPosition = _ref3.connectedElementPosition,
	        lineElementPosition = _ref3.lineElementPosition;
	    return pointLib.difference(lineElementPosition.toJS(), connectedElementPosition.toJS());
	};
	
	var getScaledConnectedElementCoordinateTranslation = function getScaledConnectedElementCoordinateTranslation(_ref4) {
	    var connectedElementPosition = _ref4.connectedElementPosition,
	        lineElementPosition = _ref4.lineElementPosition,
	        gridSize = _ref4.gridSize;
	
	    if (!connectedElementPosition) return null;
	
	    // The translation required to bring the connected element's dimensions into the line element's coordinate system
	    var lineElementCoordinateTranslation = getConnectedElementCoordinateTranslation({
	        connectedElementPosition: connectedElementPosition,
	        lineElementPosition: lineElementPosition
	    });
	    return pointLib.scale(gridSize, lineElementCoordinateTranslation);
	};
	
	var getConnectedElementRect = function getConnectedElementRect(_ref5) {
	    var lineEdge = _ref5.lineEdge,
	        connectedElementMeasurements = _ref5.connectedElementMeasurements,
	        connectedElementTranslation = _ref5.connectedElementTranslation;
	
	    if (!isLineEdgeSnapped(lineEdge) || !connectedElementTranslation || !connectedElementMeasurements) return null;
	
	    return rectLib.getRect(_extends({}, connectedElementTranslation, connectedElementMeasurements));
	};
	
	var getMeasurementsConnectionOrigin = (0, _immutableHelper.prop)('originOffset');
	
	var getTranslatedMeasurementsConnectionOrigin = function getTranslatedMeasurementsConnectionOrigin(_ref6) {
	    var connectedElementMeasurements = _ref6.connectedElementMeasurements,
	        connectedElementTranslation = _ref6.connectedElementTranslation;
	
	    var connectionOrigin = getMeasurementsConnectionOrigin(connectedElementMeasurements);
	    return pointLib.translate(connectedElementTranslation, connectionOrigin);
	};
	
	var getLineEdgeConnectionOrigin = function getLineEdgeConnectionOrigin(_ref7) {
	    var lineEdge = _ref7.lineEdge,
	        connectedElementMeasurements = _ref7.connectedElementMeasurements,
	        connectedElementTranslation = _ref7.connectedElementTranslation,
	        gridSize = _ref7.gridSize;
	    return !isLineEdgeSnapped(lineEdge) || !connectedElementMeasurements ? getUnsnappedCoordinates(lineEdge, gridSize) : getTranslatedMeasurementsConnectionOrigin({ connectedElementMeasurements: connectedElementMeasurements, connectedElementTranslation: connectedElementTranslation });
	};
	
	var getEdgeOriginAndRect = exports.getEdgeOriginAndRect = function getEdgeOriginAndRect(_ref8) {
	    var lineEdge = _ref8.lineEdge,
	        measurementsMap = _ref8.measurementsMap,
	        connectedElementPosition = _ref8.connectedElementPosition,
	        lineElementPosition = _ref8.lineElementPosition,
	        gridSize = _ref8.gridSize;
	
	    var connectedElementTranslation = getScaledConnectedElementCoordinateTranslation({
	        connectedElementPosition: connectedElementPosition,
	        lineElementPosition: lineElementPosition,
	        gridSize: gridSize
	    });
	
	    var connectedElementMeasurements = getConnectedElementMeasurements({ lineEdge: lineEdge, measurementsMap: measurementsMap });
	
	    var rect = getConnectedElementRect({
	        lineEdge: lineEdge,
	        connectedElementMeasurements: connectedElementMeasurements,
	        connectedElementTranslation: connectedElementTranslation
	    });
	    var origin = getLineEdgeConnectionOrigin({
	        lineEdge: lineEdge,
	        connectedElementMeasurements: connectedElementMeasurements,
	        connectedElementTranslation: connectedElementTranslation,
	        gridSize: gridSize
	    });
	
	    return {
	        origin: origin,
	        rect: rect
	    };
	};
	
	/**
	 * Finds the point at which the line visibly originates from.
	 * This is either the origin if there's no 'source perimeter' or a point along the perimeter that the line
	 * intersects with.
	 */
	var getVisibleConnectionPoint = exports.getVisibleConnectionPoint = function getVisibleConnectionPoint(_ref9) {
	    var sourcePoint = _ref9.sourcePoint,
	        controlPoint = _ref9.controlPoint,
	        targetPoint = _ref9.targetPoint,
	        sourcePerimeter = _ref9.sourcePerimeter;
	    return !sourcePerimeter ? sourcePoint : (0, _bezierUtil.rectBezierIntersection)(sourcePerimeter, { sourcePoint: sourcePoint, controlPoint: controlPoint, targetPoint: targetPoint }) || null;
	};
	
	var getLinePointsOfInterest = exports.getLinePointsOfInterest = function getLinePointsOfInterest(_ref10) {
	    var startEdgeOrigin = _ref10.startEdgeOrigin,
	        startConnectionRect = _ref10.startConnectionRect,
	        endEdgeOrigin = _ref10.endEdgeOrigin,
	        endConnectionRect = _ref10.endConnectionRect,
	        controlPoint = _ref10.controlPoint;
	
	    var _controlPoint = (0, _lineControlPointUtil.snapControlPointIfClose)({ controlPoint: controlPoint, startEdgeOrigin: startEdgeOrigin, endEdgeOrigin: endEdgeOrigin });
	
	    // Use the line connecting from the end to the centre point of the start rect.
	    var startVisibleConnectionPoint = getVisibleConnectionPoint({
	        sourcePoint: startEdgeOrigin,
	        controlPoint: _controlPoint,
	        targetPoint: endEdgeOrigin,
	        sourcePerimeter: startConnectionRect
	    });
	    var endVisibleConnectionPoint = getVisibleConnectionPoint({
	        sourcePoint: endEdgeOrigin,
	        controlPoint: _controlPoint,
	        targetPoint: startEdgeOrigin,
	        sourcePerimeter: endConnectionRect
	    });
	
	    var isControlPointWithinAnElement = rectLib.containsPoint(startConnectionRect, _controlPoint) || rectLib.containsPoint(endConnectionRect, _controlPoint);
	
	    if (startVisibleConnectionPoint && endVisibleConnectionPoint) {
	        var originLineMidpoint = (0, _lineControlPointUtil.getHalfwayPoint)(startEdgeOrigin, endEdgeOrigin);
	
	        // If the connected elements are overlapping each other and the line isn't being curved around them
	        if (rectLib.isOverlapping(startConnectionRect, endConnectionRect) && isControlPointWithinAnElement) {
	            return { start: {}, end: {} };
	        } else if (isControlPointWithinAnElement || pointLib.equals(originLineMidpoint, _controlPoint)) {
	            // If the control point is equal to the midpoint of the line, then make it the midpoint of the two
	            // visible connections
	            _controlPoint = (0, _lineControlPointUtil.getHalfwayPoint)(startVisibleConnectionPoint, endVisibleConnectionPoint);
	        }
	    }
	
	    return {
	        start: startVisibleConnectionPoint,
	        end: endVisibleConnectionPoint,
	        startEdgeOrigin: startEdgeOrigin,
	        endEdgeOrigin: endEdgeOrigin,
	        startConnectionRect: startConnectionRect,
	        endConnectionRect: endConnectionRect,
	        controlPoint: _controlPoint
	    };
	};

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PAYMENT_CARD_CLEAR = exports.PAYMENT_SET_PRORATE_DATE = exports.PAYMENT_UPCOMING_FAILED = exports.PAYMENT_UPCOMING_FETCHED = exports.PAYMENT_UPCOMING_FETCHING = exports.PAYMENT_COUPON_CLEAR = exports.PAYMENT_COUPON_FAILED = exports.PAYMENT_COUPON_FETCHED = exports.PAYMENT_COUPON_FETCHING = exports.PAYMENT_PLANS_FAILED = exports.PAYMENT_PLANS_FETCHED = exports.PAYMENT_PLANS_FETCHING = exports.PAYMENT_SET_VIEW_STATE = exports.CARD_UPDATE_FORM_FIELDS = exports.PAYMENT_VIEW_STATES = exports.PAYMENT_FORM_FIELDS = exports.PAYMENT_FORM_NAME = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _creditCardConstants = __webpack_require__(1774);
	
	var PAYMENT_FORM_NAME = exports.PAYMENT_FORM_NAME = 'payment';
	var PAYMENT_FORM_FIELDS = exports.PAYMENT_FORM_FIELDS = _extends({}, _creditCardConstants.CREDIT_CARD_FORM_FIELDS, {
	    plan: {
	        name: 'plan',
	        type: 'radio',
	        required: true
	    },
	    coupon: {
	        name: 'coupon',
	        type: 'text'
	    },
	    prorateDate: {
	        name: 'prorateDate',
	        type: 'text'
	    }
	});
	
	var PAYMENT_VIEW_STATES = exports.PAYMENT_VIEW_STATES = {
	    CARD_FORM: 'CARD_FORM',
	    PROCESSING: 'PROCESSING',
	    SUCCESS: 'SUCCESS'
	};
	
	var CARD_UPDATE_FORM_FIELDS = exports.CARD_UPDATE_FORM_FIELDS = _creditCardConstants.CREDIT_CARD_FORM_FIELDS;
	
	var PAYMENT_SET_VIEW_STATE = exports.PAYMENT_SET_VIEW_STATE = 'PAYMENT_SET_VIEW_STATE';
	var PAYMENT_PLANS_FETCHING = exports.PAYMENT_PLANS_FETCHING = 'PAYMENT_PLANS_FETCHING';
	var PAYMENT_PLANS_FETCHED = exports.PAYMENT_PLANS_FETCHED = 'PAYMENT_PLANS_FETCHED';
	var PAYMENT_PLANS_FAILED = exports.PAYMENT_PLANS_FAILED = 'PAYMENT_PLANS_FAILED';
	
	var PAYMENT_COUPON_FETCHING = exports.PAYMENT_COUPON_FETCHING = 'PAYMENT_COUPON_FETCHING';
	var PAYMENT_COUPON_FETCHED = exports.PAYMENT_COUPON_FETCHED = 'PAYMENT_COUPON_FETCHED';
	var PAYMENT_COUPON_FAILED = exports.PAYMENT_COUPON_FAILED = 'PAYMENT_COUPON_FAILED';
	var PAYMENT_COUPON_CLEAR = exports.PAYMENT_COUPON_CLEAR = 'PAYMENT_COUPON_CLEAR';
	
	var PAYMENT_UPCOMING_FETCHING = exports.PAYMENT_UPCOMING_FETCHING = 'PAYMENT_UPCOMING_FETCHING';
	var PAYMENT_UPCOMING_FETCHED = exports.PAYMENT_UPCOMING_FETCHED = 'PAYMENT_UPCOMING_FETCHED';
	var PAYMENT_UPCOMING_FAILED = exports.PAYMENT_UPCOMING_FAILED = 'PAYMENT_UPCOMING_FAILED';
	
	var PAYMENT_SET_PRORATE_DATE = exports.PAYMENT_SET_PRORATE_DATE = 'PAYMENT_SET_PRORATE_DATE';
	
	var PAYMENT_CARD_CLEAR = exports.PAYMENT_CARD_CLEAR = 'PAYMENT_CARD_CLEAR';

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Services
	
	
	// Utils
	
	
	// Selectors
	
	
	// Components
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reselect = __webpack_require__(7);
	
	var _CSSTransitionGroup = __webpack_require__(134);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _recompose = __webpack_require__(9);
	
	var _userService = __webpack_require__(106);
	
	var _resourceUtil = __webpack_require__(108);
	
	var _cssUtil = __webpack_require__(312);
	
	var _usersSelector = __webpack_require__(204);
	
	var _UserAvatar = __webpack_require__(199);
	
	var _UserAvatar2 = _interopRequireDefault(_UserAvatar);
	
	__webpack_require__(1262);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TAG_TYPE_ACTIVE = 'TAG_TYPE_ACTIVE';
	var TAG_TYPE_FILTER = 'TAG_TYPE_FILTER';
	
	var makeRemoteTagSelector = function makeRemoteTagSelector() {
	    return (0, _reselect.createSelector)(function (state, ownProps) {
	        return ownProps.isRemotelySelected;
	    }, function (state, ownProps) {
	        return ownProps.remoteSelectionData;
	    }, function (state) {
	        return state.get('users');
	    }, function (isRemotelySelected, remoteSelectionData, users) {
	        if (!isRemotelySelected) return null;
	
	        var userId = remoteSelectionData.get('userId');
	
	        return {
	            user: users.get(userId),
	            userId: userId,
	            type: TAG_TYPE_ACTIVE
	        };
	    });
	};
	
	var makeFilterTagSelector = function makeFilterTagSelector() {
	    return (0, _reselect.createSelector)(function (state, ownProps) {
	        return ownProps.filter;
	    }, function (state, ownProps) {
	        return ownProps.element;
	    }, function (state) {
	        return state.get('users');
	    }, function (filter, element, users) {
	        if (!filter || filter !== 'filter-pass') return null;
	
	        var userId = element.getIn(['meta', 'modifiedBy']);
	
	        return {
	            user: users.get(userId),
	            userId: userId,
	            type: TAG_TYPE_FILTER
	        };
	    });
	};
	
	var makeElementUserTagSelector = function makeElementUserTagSelector() {
	    return (0, _reselect.createSelector)(_usersSelector.userResourcesSelector, makeRemoteTagSelector(), makeFilterTagSelector(), function (userResources, remoteTag, filterTag) {
	        if (!remoteTag && !filterTag) return {};
	
	        var tag = remoteTag || filterTag;
	        var userId = tag.userId;
	        var userResourceState = userResources.get(userId);
	
	        return _extends({}, tag, {
	            isUserFetched: (0, _resourceUtil.isFetched)(userResourceState)
	        });
	    });
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        loadUser: function loadUser(userId) {
	            return dispatch((0, _userService.fetchUsers)([userId]));
	        }
	    };
	};
	
	var getTagStyle = function getTagStyle(_ref) {
	    var top = _ref.top,
	        left = _ref.left;
	
	    if (!top || !left) return null;
	
	    return (0, _cssUtil.getTranslationStyles)({ x: left, y: top });
	};
	
	var ElementUserTag = function ElementUserTag(_ref2) {
	    var user = _ref2.user,
	        type = _ref2.type,
	        top = _ref2.top,
	        left = _ref2.left;
	    return _react2.default.createElement(
	        'div',
	        { className: 'ElementUserTag', style: getTagStyle({ top: top, left: left }) },
	        _react2.default.createElement(_UserAvatar2.default, { user: user,
	            pulse: type === TAG_TYPE_ACTIVE,
	            active: type === TAG_TYPE_ACTIVE,
	            filter: type === TAG_TYPE_FILTER })
	    );
	};
	
	var ElementUserTagContainer = (_dec = (0, _reactRedux.connect)(makeElementUserTagSelector, mapDispatchToProps), _dec(_class = function (_React$Component) {
	    _inherits(ElementUserTagContainer, _React$Component);
	
	    function ElementUserTagContainer() {
	        _classCallCheck(this, ElementUserTagContainer);
	
	        return _possibleConstructorReturn(this, (ElementUserTagContainer.__proto__ || Object.getPrototypeOf(ElementUserTagContainer)).apply(this, arguments));
	    }
	
	    _createClass(ElementUserTagContainer, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var user = nextProps.user,
	                userId = nextProps.userId,
	                loadUser = nextProps.loadUser,
	                isUserFetched = nextProps.isUserFetched;
	
	
	            if (user && !isUserFetched) {
	                loadUser(userId);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                user = _props.user,
	                type = _props.type,
	                top = _props.top,
	                left = _props.left;
	
	
	            return _react2.default.createElement(
	                _CSSTransitionGroup2.default,
	                {
	                    transitionName: 'pop',
	                    transitionAppear: true,
	                    transitionAppearTimeout: 500,
	                    transitionEnterTimeout: 500,
	                    transitionLeaveTimeout: 500 },
	                user ? _react2.default.createElement(ElementUserTag, { user: user, type: type, top: top, left: left }) : null
	            );
	        }
	    }]);
	
	    return ElementUserTagContainer;
	}(_react2.default.Component)) || _class);
	
	
	ElementUserTag.propTypes = ElementUserTagContainer.propTypes = {
	    remoteSelectionData: _propTypes2.default.object,
	    lastModifiedUser: _propTypes2.default.object,
	    isRemotelySelected: _propTypes2.default.bool,
	    filter: _propTypes2.default.string,
	    user: _propTypes2.default.object,
	    userId: _propTypes2.default.string,
	    type: _propTypes2.default.string,
	    isUserFetched: _propTypes2.default.bool,
	    top: _propTypes2.default.number,
	    left: _propTypes2.default.number
	};
	
	exports.default = (0, _recompose.onlyUpdateForPropTypes)(ElementUserTagContainer);

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getUsers = exports.makeFilteredUsersResourcesSelector = exports.userResourcesSelector = undefined;
	
	var _resourceSelector = __webpack_require__(472);
	
	var userResourcesSelector = exports.userResourcesSelector = (0, _resourceSelector.makeResourceTypeSelector)('users'); // Utils
	var makeFilteredUsersResourcesSelector = exports.makeFilteredUsersResourcesSelector = (0, _resourceSelector.makeFilteredResourcesSelector)('users');
	
	var getUsers = exports.getUsers = function getUsers(state) {
	    return state.get('users');
	};

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.GRID_RESIZE = exports.FONT_SIZE_MULTIPLIER = exports.GRID_SIZE_LIST = exports.GRID = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var GRID = exports.GRID = {
	    MOBILE: { size: 10, breakpoint: 0, name: 'mobile' },
	    SMALL: { size: 8, breakpoint: 600, name: 'small' },
	    MEDIUM: { size: 10, breakpoint: 1600, name: 'regular' }
	};
	
	var GRID_SIZE_LIST = exports.GRID_SIZE_LIST = (0, _lodash.values)(GRID);
	
	var DEFAULT_FONT_SIZE = 16;
	var FONT_SIZE_MULTIPLIER = exports.FONT_SIZE_MULTIPLIER = DEFAULT_FONT_SIZE / GRID.MEDIUM.size;
	
	var GRID_RESIZE = exports.GRID_RESIZE = 'GRID_RESIZE';

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _recompose = __webpack_require__(9);
	
	var _lodash = __webpack_require__(4);
	
	var _createHelper = __webpack_require__(2131);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dontUpdateForKeys = function dontUpdateForKeys(propKeys) {
	    return (0, _recompose.shouldUpdate)(function (props, nextProps) {
	        return !(0, _recompose.shallowEqual)((0, _lodash.omit)(nextProps, propKeys), (0, _lodash.omit)(props, propKeys));
	    });
	};
	
	// Helper
	// Lib
	exports.default = (0, _createHelper2.default)(dontUpdateForKeys, 'dontUpdateForKeys');

/***/ }),
/* 207 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var COLUMN_TYPE = exports.COLUMN_TYPE = 'COLUMN';
	var COLUMN_DISPLAY_NAME = exports.COLUMN_DISPLAY_NAME = 'Column';
	var COLUMN_DEFAULT_TITLE = exports.COLUMN_DEFAULT_TITLE = 'New Column';

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getSides = exports.containsPoint = exports.isOverlapping = exports.addPadding = exports.translate = exports.scale = exports.getCentre = exports.getRect = undefined;
	
	var _fp = __webpack_require__(52);
	
	var _geometry = __webpack_require__(797);
	
	var _geometry2 = _interopRequireDefault(_geometry);
	
	var _point = __webpack_require__(50);
	
	var pointLib = _interopRequireWildcard(_point);
	
	var _line = __webpack_require__(2278);
	
	var lineLib = _interopRequireWildcard(_line);
	
	var _geometryUtils = __webpack_require__(796);
	
	var geometryUtils = _interopRequireWildcard(_geometryUtils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Formalises it, but does nothing
	var getRect = exports.getRect = function getRect(_ref) {
	    var x = _ref.x,
	        y = _ref.y,
	        width = _ref.width,
	        height = _ref.height;
	    return { x: x, y: y, width: width, height: height };
	};
	
	// Geometry
	// Lib
	var getCentre = exports.getCentre = function getCentre(rect) {
	    return pointLib.getPoint(rect.x + rect.width / 2, rect.y + rect.height / 2);
	};
	
	var scale = exports.scale = geometryUtils.scale;
	var translate = exports.translate = geometryUtils.translate;
	
	var addPadding = exports.addPadding = (0, _fp.curry)(function (padding, rect) {
	    return {
	        x: rect.x - padding,
	        y: rect.y - padding,
	        width: rect.width + 2 * padding,
	        height: rect.height + 2 * padding
	    };
	});
	
	var isOverlapping = exports.isOverlapping = (0, _fp.curry)(function (rect1, rect2) {
	    if (!rect1 || !rect2) return false;
	
	    var jjsRect1 = _geometry2.default.rect(rect1);
	    var jjsRect2 = _geometry2.default.rect(rect2);
	
	    return !!jjsRect1.intersect(jjsRect2);
	});
	
	var containsPoint = exports.containsPoint = (0, _fp.curry)(function (rect, point) {
	    if (!rect || !point) return false;
	
	    return point.x >= rect.x && point.x <= rect.x + rect.width && point.y >= rect.y && point.y <= rect.y + rect.height;
	});
	
	var getTopLine = function getTopLine(rect) {
	    return lineLib.getLine(pointLib.getPoint(rect.x, rect.y), pointLib.getPoint(rect.x + rect.width, rect.y));
	};
	
	var getRightLine = function getRightLine(rect) {
	    return lineLib.getLine(pointLib.getPoint(rect.x + rect.width, rect.y), pointLib.getPoint(rect.x + rect.width, rect.y + rect.height));
	};
	
	var getBottomLine = function getBottomLine(rect) {
	    return lineLib.getLine(pointLib.getPoint(rect.x, rect.y + rect.height), pointLib.getPoint(rect.x + rect.width, rect.y + rect.height));
	};
	
	var getLeftLine = function getLeftLine(rect) {
	    return lineLib.getLine(pointLib.getPoint(rect.x, rect.y), pointLib.getPoint(rect.x, rect.y + rect.height));
	};
	
	var getSides = exports.getSides = function getSides(rect, side) {
	    return {
	        top: getTopLine(rect),
	        right: getRightLine(rect),
	        bottom: getBottomLine(rect),
	        left: getLeftLine(rect)
	    };
	};

/***/ }),
/* 209 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(91)
	  , TAG = __webpack_require__(29)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function(it, key){
	  try {
	    return it[key];
	  } catch(e){ /* empty */ }
	};
	
	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(91);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ }),
/* 212 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BlockMapBuilder
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(28);
	
	var OrderedMap = Immutable.OrderedMap;
	
	
	var BlockMapBuilder = {
	  createFromArray: function createFromArray(blocks) {
	    return OrderedMap(blocks.map(function (block) {
	      return [block.getKey(), block];
	    }));
	  }
	};
	
	module.exports = BlockMapBuilder;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule removeTextWithStrategy
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(63);
	
	/**
	 * For a collapsed selection state, remove text based on the specified strategy.
	 * If the selection state is not collapsed, remove the entire selected range.
	 */
	function removeTextWithStrategy(editorState, strategy, direction) {
	  var selection = editorState.getSelection();
	  var content = editorState.getCurrentContent();
	  var target = selection;
	  if (selection.isCollapsed()) {
	    if (direction === 'forward') {
	      if (editorState.isSelectionAtEndOfContent()) {
	        return content;
	      }
	    } else if (editorState.isSelectionAtStartOfContent()) {
	      return content;
	    }
	
	    target = strategy(editorState);
	    if (target === selection) {
	      return content;
	    }
	  }
	  return DraftModifier.removeRange(content, target, direction);
	}
	
	module.exports = removeTextWithStrategy;

/***/ }),
/* 215 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/**
	 * This function is used to mark string literals representing CSS class names
	 * so that they can be transformed statically. This allows for modularization
	 * and minification of CSS class names.
	 *
	 * In static_upstream, this function is actually implemented, but it should
	 * eventually be replaced with something more descriptive, and the transform
	 * that is used in the main stack should be ported for use elsewhere.
	 *
	 * @param string|object className to modularize, or an object of key/values.
	 *                      In the object case, the values are conditions that
	 *                      determine if the className keys should be included.
	 * @param [string ...]  Variable list of classNames in the string case.
	 * @return string       Renderable space-separated CSS className.
	 */
	function cx(classNames) {
	  if (typeof classNames == 'object') {
	    return Object.keys(classNames).filter(function (className) {
	      return classNames[className];
	    }).map(replace).join(' ');
	  }
	  return Array.prototype.map.call(arguments, replace).join(' ');
	}
	
	function replace(str) {
	  return str.replace(/\//g, '-');
	}
	
	module.exports = cx;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(585);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 218 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 219 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getEmptyImage = exports.NativeTypes = undefined;
	exports.default = createHTML5Backend;
	
	var _HTML5Backend = __webpack_require__(1454);
	
	var _HTML5Backend2 = _interopRequireDefault(_HTML5Backend);
	
	var _getEmptyImage = __webpack_require__(1458);
	
	var _getEmptyImage2 = _interopRequireDefault(_getEmptyImage);
	
	var _NativeTypes = __webpack_require__(383);
	
	var NativeTypes = _interopRequireWildcard(_NativeTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.NativeTypes = NativeTypes;
	exports.getEmptyImage = _getEmptyImage2.default;
	function createHTML5Backend(manager) {
	  return new _HTML5Backend2.default(manager);
	}

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var EventPluginRegistry = __webpack_require__(387);
	var EventPluginUtils = __webpack_require__(388);
	var ReactErrorUtils = __webpack_require__(392);
	
	var accumulateInto = __webpack_require__(617);
	var forEachAccumulated = __webpack_require__(618);
	var invariant = __webpack_require__(10);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(221);
	var EventPluginUtils = __webpack_require__(388);
	
	var accumulateInto = __webpack_require__(617);
	var forEachAccumulated = __webpack_require__(618);
	var warning = __webpack_require__(16);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ }),
/* 223 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(119);
	
	var getEventTarget = __webpack_require__(397);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var fetchKeys = __webpack_require__(1369);
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if (ret !== void 0) {
	        return !!ret;
	    }
	
	    if (objA === objB) {
	        return true;
	    }
	
	    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	        return false;
	    }
	
	    var keysA = fetchKeys(objA);
	    var keysB = fetchKeys(objB);
	
	    var len = keysA.length;
	    if (len !== keysB.length) {
	        return false;
	    }
	
	    compareContext = compareContext || null;
	
	    // Test for A's keys different from B.
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	    for (var i = 0; i < len; i++) {
	        var key = keysA[i];
	        if (!bHasOwnProperty(key)) {
	            return false;
	        }
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        var _ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	        if (_ret === false || _ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	    }
	
	    return true;
	};

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.manuallyReportError = exports.setRollbarUser = undefined;
	
	var _processError = __webpack_require__(1665);
	
	var _processError2 = _interopRequireDefault(_processError);
	
	var _addUserId = __webpack_require__(1660);
	
	var _addUserId2 = _interopRequireDefault(_addUserId);
	
	var _rollbarConstants = __webpack_require__(420);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var setRollbarUser = exports.setRollbarUser = function setRollbarUser(user) {
	    if (!window.Rollbar) return;
	
	    window.Rollbar.configure({
	        payload: {
	            person: {
	                id: user._id,
	                email: user.email
	            }
	        }
	    });
	};
	
	// Constants
	// Utils
	var manuallyReportError = exports.manuallyReportError = function manuallyReportError(_ref) {
	    var errorMessage = _ref.errorMessage,
	        error = _ref.error,
	        sensitive = _ref.sensitive,
	        _ref$level = _ref.level,
	        level = _ref$level === undefined ? _rollbarConstants.ROLLBAR_LEVELS.ERROR : _ref$level,
	        getState = _ref.getState;
	
	    if (!window.Rollbar) return;
	
	    var levelFn = !!window.Rollbar[level] ? level : _rollbarConstants.ROLLBAR_LEVELS.ERROR;
	
	    var processedError = (0, _processError2.default)({ error: error, sensitive: sensitive });
	    processedError = (0, _addUserId2.default)(processedError, getState);
	
	    window.Rollbar[levelFn](errorMessage, error, processedError);
	};

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.removeCurrentUserToken = exports.setCurrentUserToken = exports.getCurrentUserToken = undefined;
	
	var _localStorage = __webpack_require__(314);
	
	var _localStorage2 = _interopRequireDefault(_localStorage);
	
	var _authConstants = __webpack_require__(136);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Services
	var getCurrentUserToken = exports.getCurrentUserToken = function getCurrentUserToken() {
	  return _localStorage2.default.getItem(_authConstants.USER_LOCAL_STORAGE_TOKEN_KEY);
	};
	
	// Constants
	var setCurrentUserToken = exports.setCurrentUserToken = function setCurrentUserToken(value) {
	  return _localStorage2.default.setItem(_authConstants.USER_LOCAL_STORAGE_TOKEN_KEY, value);
	};
	
	var removeCurrentUserToken = exports.removeCurrentUserToken = function removeCurrentUserToken() {
	  return _localStorage2.default.removeItem(_authConstants.USER_LOCAL_STORAGE_TOKEN_KEY);
	};

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _recompose = __webpack_require__(9);
	
	var _reselect = __webpack_require__(7);
	
	var _elementActions = __webpack_require__(26);
	
	var _selectionActions = __webpack_require__(55);
	
	var _currentlyEditingSelector = __webpack_require__(233);
	
	var _contentEditable = __webpack_require__(2126);
	
	var _domUtil = __webpack_require__(107);
	
	var _undoRedoTransactionManager = __webpack_require__(86);
	
	var _keyConstants = __webpack_require__(146);
	
	__webpack_require__(1137);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	// Actions
	
	
	// Utils
	
	
	// Constants
	
	
	// Styles
	
	
	var DEFAULT_MAX_LENGTH = 100;
	
	var getTitle = function getTitle(state, _ref) {
	    var element = _ref.element,
	        initialValue = _ref.initialValue;
	    return element && element.getIn(['content', 'title']) || initialValue;
	};
	
	var titleEditorSelector = (0, _reselect.createStructuredSelector)({
	    title: getTitle,
	    isEditing: _currentlyEditingSelector.getIsCurrentlyEditingThisElement
	});
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        dispatchUpdateTitle: function dispatchUpdateTitle(id, title, transactionId) {
	            return dispatch((0, _elementActions.updateElement)({ id: id, changes: { title: title }, transactionId: transactionId }));
	        },
	        dispatchStartEditingTitle: function dispatchStartEditingTitle(id, editDelay, editorKey) {
	            return editDelay ? dispatch((0, _selectionActions.startEditingElementWithDelay)({ id: id, editorKey: editorKey, editDelay: editDelay })) : dispatch((0, _selectionActions.startEditingElement)({ id: id, editorKey: editorKey }));
	        },
	        dispatchStopEditingTitle: function dispatchStopEditingTitle() {
	            dispatch((0, _selectionActions.finishEditingElement)());
	            dispatch((0, _selectionActions.deselectAllElements)());
	        }
	    };
	};
	
	var enhance = (0, _recompose.compose)((0, _reactRedux.connect)(titleEditorSelector, mapDispatchToProps), (0, _recompose.defaultProps)({ maxLength: DEFAULT_MAX_LENGTH }), _recompose.onlyUpdateForPropTypes);
	
	var EditableTitle = function (_React$Component) {
	    _inherits(EditableTitle, _React$Component);
	
	    function EditableTitle() {
	        var _ref2;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, EditableTitle);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = EditableTitle.__proto__ || Object.getPrototypeOf(EditableTitle)).call.apply(_ref2, [this].concat(args))), _this), _this.onKeyDown = function (event) {
	            if (event.metaKey) {
	                if (event.keyCode === _keyConstants.KEY_CODES.B || event.keyCode === _keyConstants.KEY_CODES.I) {
	                    event.preventDefault();
	                }
	            }
	            if (event.keyCode === _keyConstants.KEY_CODES.ENTER || event.keyCode === _keyConstants.KEY_CODES.ESC) {
	                event.preventDefault();
	                _this.props.dispatchStopEditingTitle();
	            }
	        }, _this.onDoubleClick = function (event) {
	            if (_this.props.isEditing) {
	                event.stopPropagation();
	            }
	        }, _this.onBlur = function (event) {
	            _this.updateTitle(_this.getTitleText());
	        }, _this.getTitleText = function () {
	            return _this.cleanTitleText(_this.titleInput.innerText);
	        }, _this.updateTitle = function (title) {
	            var _this$props = _this.props,
	                isEditable = _this$props.isEditable,
	                elementId = _this$props.elementId,
	                dispatchUpdateTitle = _this$props.dispatchUpdateTitle,
	                onUpdateCallbackFn = _this$props.onUpdateCallbackFn;
	
	            if (title === _this.props.title) return;
	
	            if (!isEditable) return;
	
	            if (title === '') {
	                _this.titleInput.innerText = _this.props.title;
	                return;
	            }
	
	            var transactionId = (0, _undoRedoTransactionManager.getNewTransactionId)();
	            dispatchUpdateTitle(elementId, title, transactionId);
	            onUpdateCallbackFn && onUpdateCallbackFn({ title: title, transactionId: transactionId });
	        }, _this.startEditingTitle = function (event) {
	            var _this$props2 = _this.props,
	                isEditable = _this$props2.isEditable,
	                selectFirst = _this$props2.selectFirst,
	                isSelected = _this$props2.isSelected,
	                editDelay = _this$props2.editDelay,
	                elementId = _this$props2.elementId,
	                dispatchStartEditingTitle = _this$props2.dispatchStartEditingTitle,
	                editorKey = _this$props2.editorKey;
	
	
	            if (!isEditable) return;
	            if (selectFirst && !isSelected) return;
	
	            dispatchStartEditingTitle(elementId, editDelay, editorKey);
	        }, _this.handlePasteEvent = function (event) {
	            // cancel paste
	            event.preventDefault();
	
	            // get text representation of clipboard
	            var text = (event.originalEvent || event).clipboardData.getData('text/plain');
	
	            // insert text manually
	            document.execCommand('insertHTML', false, _this.cleanTitleText(text));
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(EditableTitle, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.titleInput.addEventListener('paste', this.handlePasteEvent);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var isEditing = this.props.isEditing;
	
	
	            if (isEditing && !nextProps.isEditing) {
	                this.updateTitle(this.getTitleText());
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            var _props = this.props,
	                isEditing = _props.isEditing,
	                selectAllOnEdit = _props.selectAllOnEdit;
	
	
	            if (isEditing && !prevProps.isEditing) {
	                if (this.titleInput) {
	                    selectAllOnEdit ? (0, _contentEditable.selectAll)(this.titleInput) : (0, _contentEditable.placeCaretAtEnd)(this.titleInput);
	                }
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.titleInput.removeEventListener('paste', this.handlePasteEvent);
	        }
	    }, {
	        key: 'cleanTitleText',
	        value: function cleanTitleText(title) {
	            var maxLength = this.props.maxLength;
	
	
	            if (!title) return;
	
	            return title.replace('\n', '').substring(0, maxLength);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                title = _props2.title,
	                isEditing = _props2.isEditing,
	                wrapTitleElement = _props2.wrapTitleElement;
	
	
	            var titleText = this.cleanTitleText(title);
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'EditableTitle' },
	                _react2.default.createElement(
	                    'div',
	                    { className: (0, _classnames2.default)('editable-title', { editing: isEditing }),
	                        ref: function ref(c) {
	                            _this2.titleInput = c;
	                        },
	                        onClick: this.startEditingTitle,
	                        contentEditable: isEditing,
	                        suppressContentEditableWarning: true,
	                        onKeyDown: this.onKeyDown,
	                        onMouseDown: _domUtil.stopPropagationOnly,
	                        onDoubleClick: this.onDoubleClick,
	                        onBlur: this.onBlur },
	                    wrapTitleElement && !isEditing ? _react2.default.cloneElement(wrapTitleElement, null, titleText) : titleText
	                )
	            );
	        }
	    }]);
	
	    return EditableTitle;
	}(_react2.default.Component);
	
	EditableTitle.propTypes = {
	    element: _propTypes2.default.object,
	    elementId: _propTypes2.default.string,
	    title: _propTypes2.default.string,
	    editorKey: _propTypes2.default.string,
	    dispatchUpdateTitle: _propTypes2.default.func,
	    dispatchStartEditingTitle: _propTypes2.default.func,
	    dispatchStopEditingTitle: _propTypes2.default.func,
	    onUpdateCallbackFn: _propTypes2.default.func,
	    wrapTitleElement: _propTypes2.default.element,
	    maxLength: _propTypes2.default.number,
	    isEditing: _propTypes2.default.bool,
	    isEditable: _propTypes2.default.bool,
	    isSelected: _propTypes2.default.bool,
	    selectFirst: _propTypes2.default.bool,
	    selectAllOnEdit: _propTypes2.default.bool,
	    editDelay: _propTypes2.default.number
	};
	
	exports.default = enhance(EditableTitle);

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Constants
	
	
	var _formConstants = __webpack_require__(435);
	
	var _reduxForm = __webpack_require__(415);
	
	exports.default = function (reducerFn, formName) {
	    return function (state, action) {
	        var nextState = reducerFn(state, action);
	        if (action.form !== formName) return nextState;
	
	        switch (action.type) {
	            case _reduxForm.actionTypes.START_SUBMIT:
	                return _extends({}, nextState, {
	                    primaryError: null
	                });
	            case _formConstants.FORM_SUBMISSION_FAILED:
	                return _extends({}, nextState, {
	                    primaryError: action.primaryError
	                });
	            default:
	                return nextState;
	        }
	    };
	};

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FormPrimaryMessage = __webpack_require__(701);
	
	var _FormPrimaryMessage2 = _interopRequireDefault(_FormPrimaryMessage);
	
	__webpack_require__(1158);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	// Lib
	var PrimaryErrorMessage = function PrimaryErrorMessage(_ref) {
	    var message = _ref.message,
	        show = _ref.show,
	        children = _ref.children,
	        _ref$icon = _ref.icon,
	        icon = _ref$icon === undefined ? 'cross-small' : _ref$icon;
	    return _react2.default.createElement(
	        _FormPrimaryMessage2.default,
	        { className: 'PrimaryErrorMessage', message: message, show: show, icon: icon },
	        children
	    );
	};
	
	// Styles
	
	
	PrimaryErrorMessage.propTypes = {
	    message: _propTypes2.default.string,
	    show: _propTypes2.default.bool,
	    icon: _propTypes2.default.string,
	    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
	};
	
	exports.default = PrimaryErrorMessage;

/***/ }),
/* 231 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var MEASUREMENTS_STORE_NAME = exports.MEASUREMENTS_STORE_NAME = 'measurementsStore';
	
	// Action Types
	var MEASUREMENT_SET = exports.MEASUREMENT_SET = 'MEASUREMENT_SET';
	var MEASUREMENT_REMOVE = exports.MEASUREMENT_REMOVE = 'MEASUREMENT_REMOVE';
	
	var BULK_MEASUREMENT_ACTIONS = exports.BULK_MEASUREMENT_ACTIONS = [MEASUREMENT_SET, MEASUREMENT_REMOVE];

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getIsLineEndSnapped = exports.getIsLineStartSnapped = exports.getLineEndStyle = exports.getLineStartStyle = exports.makeGetEdgesPx = exports.makeGetLineEdgeDetails = exports.getControlPosition = exports.getEndConnectedElementId = exports.getStartConnectedElementId = exports.getLineControl = undefined;
	
	var _fp = __webpack_require__(52);
	
	var _Vector = __webpack_require__(323);
	
	var _Vector2 = _interopRequireDefault(_Vector);
	
	var _milanoteReselect = __webpack_require__(49);
	
	var _gridSizeSelector = __webpack_require__(66);
	
	var _lineUtil = __webpack_require__(201);
	
	var _elementHelper = __webpack_require__(13);
	
	var _elementSelector = __webpack_require__(41);
	
	var _elementPositionSelector = __webpack_require__(730);
	
	var _measurementsSelector = __webpack_require__(124);
	
	var _lineConstants = __webpack_require__(57);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Selectors
	
	
	// Utils
	/* eslint-disable */
	// Lib
	var getLineEdge = function getLineEdge(edge) {
	    return function (state, ownProps) {
	        return (0, _elementSelector.getElement)(state, ownProps).getIn(['content', edge]);
	    };
	};
	
	// Constants
	
	
	// Geometry
	var getLineControl = exports.getLineControl = function getLineControl(state, ownProps) {
	    return (0, _elementSelector.getElement)(state, ownProps).getIn(['content', 'control']);
	};
	
	var getConnectedElementId = function getConnectedElementId(edge) {
	    return function (state, ownProps) {
	        var lineEdge = getLineEdge(edge)(state, ownProps);
	        if (!lineEdge.get('snapped')) return null;
	        return lineEdge.get('elementId');
	    };
	};
	
	var getStartConnectedElementId = exports.getStartConnectedElementId = getConnectedElementId('start');
	var getEndConnectedElementId = exports.getEndConnectedElementId = getConnectedElementId('end');
	
	var getConnectedElement = function getConnectedElement(edge) {
	    return function (state, ownProps) {
	        var connectedElementId = getConnectedElementId(edge)(state, ownProps);
	        if (!connectedElementId) return null;
	
	        return (0, _elementSelector.getElements)(state, ownProps).get(connectedElementId);
	    };
	};
	
	var getConnectedElementPosition = function getConnectedElementPosition(edge) {
	    return function (state, ownProps) {
	        var connectedElement = getConnectedElement(edge)(state, ownProps);
	
	        if (!connectedElement) return null;
	
	        var parentId = connectedElement.getIn(['location', 'parentId']);
	        // Doubt this could happen, but just in case
	        if (!parentId) return null;
	
	        // If the parent is a column use it as the connected element
	        var parent = (0, _elementSelector.getElements)(state, ownProps).get(parentId);
	        if ((0, _elementHelper.isColumn)(parent)) return null;
	
	        return connectedElement.getIn(['location', 'position']);
	    };
	};
	
	var getControlPosition = exports.getControlPosition = function getControlPosition(_ref) {
	    var start = _ref.start,
	        end = _ref.end,
	        control = _ref.control;
	
	    var lineVector = _Vector2.default.lineVector(start, end);
	    var perpindicularVector = lineVector.clone().perpendicular();
	
	    // By default the control point is halfway along the straight line between the two points
	    var controlPerpMag = control ? control.get('perpMag') : 0;
	    var controlParallelRatio = control ? control.get('parallelRatio') : 0.5;
	
	    var controlPerp = perpindicularVector.toLength(controlPerpMag);
	    var controlParallel = lineVector.multiplyScalar(controlParallelRatio);
	
	    return controlParallel.add(controlPerp).add(start);
	};
	
	var makeGetLineEdgeDetails = exports.makeGetLineEdgeDetails = function makeGetLineEdgeDetails() {
	    return (0, _milanoteReselect.createShallowSelector)(
	    // get start edge
	    getLineEdge(_lineConstants.LINE_EDGE.start),
	    // get start element position
	    getConnectedElementPosition(_lineConstants.LINE_EDGE.start),
	    // get end edge
	    getLineEdge(_lineConstants.LINE_EDGE.end),
	    // get end element position
	    getConnectedElementPosition(_lineConstants.LINE_EDGE.end),
	    // Get current element position
	    _elementPositionSelector.getElementGridPosition,
	    // TODO Return only the required measurements (the ones that the line edges require)
	    // get measurements
	    _measurementsSelector.getMeasurementsMapFromProps, _gridSizeSelector.getGridSize, function (startEdge, startElementPosition, endEdge, endElementPosition, lineElementPosition, measurementsMap, gridSize) {
	        var startConnection = (0, _lineUtil.getEdgeOriginAndRect)({
	            lineEdge: startEdge,
	            measurementsMap: measurementsMap,
	            connectedElementPosition: startElementPosition,
	            lineElementPosition: lineElementPosition,
	            gridSize: gridSize
	        });
	        var endConnection = (0, _lineUtil.getEdgeOriginAndRect)({
	            lineEdge: endEdge,
	            measurementsMap: measurementsMap,
	            connectedElementPosition: endElementPosition,
	            lineElementPosition: lineElementPosition,
	            gridSize: gridSize
	        });
	
	        return {
	            startEdgeOrigin: startConnection.origin,
	            startConnectionRect: startConnection.rect,
	            endEdgeOrigin: endConnection.origin,
	            endConnectionRect: endConnection.rect
	        };
	    });
	};
	
	var makeGetEdgesPx = exports.makeGetEdgesPx = function makeGetEdgesPx() {
	    return (0, _milanoteReselect.createShallowSelector)(makeGetLineEdgeDetails(),
	    // Get the control point magnitudes
	    getLineControl, function (_ref2, control) {
	        var startEdgeOrigin = _ref2.startEdgeOrigin,
	            startConnectionRect = _ref2.startConnectionRect,
	            endEdgeOrigin = _ref2.endEdgeOrigin,
	            endConnectionRect = _ref2.endConnectionRect;
	
	        // Find the control point
	        var controlPoint = getControlPosition({ start: startEdgeOrigin, end: endEdgeOrigin, control: control });
	
	        return (0, _lineUtil.getLinePointsOfInterest)({
	            startEdgeOrigin: startEdgeOrigin,
	            startConnectionRect: startConnectionRect,
	            endEdgeOrigin: endEdgeOrigin,
	            endConnectionRect: endConnectionRect,
	            controlPoint: controlPoint
	        });
	    });
	};
	
	var getLineStartStyle = exports.getLineStartStyle = function getLineStartStyle(state, ownProps) {
	    return (0, _elementSelector.getElement)(state, ownProps).getIn(['content', 'startStyle']);
	};
	
	var getLineEndStyle = exports.getLineEndStyle = function getLineEndStyle(state, ownProps) {
	    return (0, _elementSelector.getElement)(state, ownProps).getIn(['content', 'endStyle']);
	};
	
	var getIsLineStartSnapped = exports.getIsLineStartSnapped = function getIsLineStartSnapped(state, ownProps) {
	    return (0, _elementSelector.getElement)(state, ownProps).getIn(['content', 'start', 'snapped']);
	};
	
	var getIsLineEndSnapped = exports.getIsLineEndSnapped = function getIsLineEndSnapped(state, ownProps) {
	    return (0, _elementSelector.getElement)(state, ownProps).getIn(['content', 'end', 'snapped']);
	};

/***/ }),
/* 233 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var getCurrentlyEditingState = exports.getCurrentlyEditingState = function getCurrentlyEditingState(state) {
	    return state.getIn(['app', 'currentlyEditing']);
	};
	
	var isCurrentlyEditing = exports.isCurrentlyEditing = function isCurrentlyEditing(state) {
	    return !!getCurrentlyEditingState(state).get('id');
	};
	
	var getCurrentlyEditingId = exports.getCurrentlyEditingId = function getCurrentlyEditingId(state) {
	    return state.getIn(['app', 'currentlyEditing', 'id']);
	};
	var getCurrentlyEditingEditorKey = exports.getCurrentlyEditingEditorKey = function getCurrentlyEditingEditorKey(state) {
	    return state.getIn(['app', 'currentlyEditing', 'editorKey']);
	};
	
	var getIsCurrentlyEditingThisElement = exports.getIsCurrentlyEditingThisElement = function getIsCurrentlyEditingThisElement(state, _ref) {
	    var elementId = _ref.elementId,
	        editorKey = _ref.editorKey;
	    return getCurrentlyEditingId(state) === elementId && getCurrentlyEditingEditorKey(state) === editorKey;
	};

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boardConstants = __webpack_require__(17);
	
	Object.defineProperty(exports, 'INBOX_STATE', {
	  enumerable: true,
	  get: function get() {
	    return _boardConstants.INBOX_STATE;
	  }
	});
	var INBOX_WIDTH = exports.INBOX_WIDTH = 38;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.googleAnalyticsIndividualPayment = exports.enterprisePlanEnquiryAnalytics = exports.teamPlanEnquiryAnalytics = exports.individualPlanEnquiryAnalytics = exports.googleAnalyticsEmailReferralEvent = exports.googleAnalyticsFacebookReferralEvent = exports.googleAnalyticsTwitterReferralEvent = exports.googleAnalyticsReferralViewEvent = exports.googleAnalyticsPlanViewEvent = undefined;
	
	var _intercomService = __webpack_require__(290);
	
	var _googleAnalyticsService = __webpack_require__(1664);
	
	var _analyticsConstants = __webpack_require__(165);
	
	var googleAnalyticsPaymentsEvent = function googleAnalyticsPaymentsEvent(eventAction) {
	    return (0, _googleAnalyticsService.googleAnalyticsSend)({
	        hitType: _analyticsConstants.GOOGLE_ANALYTICS_HIT_TYPES.event,
	        eventCategory: 'Payments',
	        eventAction: eventAction
	    });
	};
	
	// Constants
	// Analytics services
	var googleAnalyticsPlanViewEvent = exports.googleAnalyticsPlanViewEvent = function googleAnalyticsPlanViewEvent() {
	    return googleAnalyticsPaymentsEvent('plan-view');
	};
	var googleAnalyticsReferralViewEvent = exports.googleAnalyticsReferralViewEvent = function googleAnalyticsReferralViewEvent() {
	    return googleAnalyticsPaymentsEvent('referral-view');
	};
	
	var googleAnalyticsReferralEvent = function googleAnalyticsReferralEvent(referralType) {
	    return googleAnalyticsPaymentsEvent('plan-referral-' + referralType + '-click');
	};
	
	var googleAnalyticsTwitterReferralEvent = exports.googleAnalyticsTwitterReferralEvent = function googleAnalyticsTwitterReferralEvent() {
	    return googleAnalyticsReferralEvent('twitter');
	};
	var googleAnalyticsFacebookReferralEvent = exports.googleAnalyticsFacebookReferralEvent = function googleAnalyticsFacebookReferralEvent() {
	    return googleAnalyticsReferralEvent('facebook');
	};
	var googleAnalyticsEmailReferralEvent = exports.googleAnalyticsEmailReferralEvent = function googleAnalyticsEmailReferralEvent() {
	    return googleAnalyticsReferralEvent('email');
	};
	
	var googleAnalyticsPlanEnquiryEvent = function googleAnalyticsPlanEnquiryEvent(subscriptionType) {
	    return googleAnalyticsPaymentsEvent('plan-enquiry-' + subscriptionType + '-click');
	};
	
	var individualPlanEnquiryAnalytics = exports.individualPlanEnquiryAnalytics = function individualPlanEnquiryAnalytics() {
	    return googleAnalyticsPlanEnquiryEvent('individual');
	};
	var teamPlanEnquiryAnalytics = exports.teamPlanEnquiryAnalytics = function teamPlanEnquiryAnalytics() {
	    (0, _intercomService.intercomTrackEvent)('team-payment-enquiry');
	    googleAnalyticsPlanEnquiryEvent('team');
	};
	
	var enterprisePlanEnquiryAnalytics = exports.enterprisePlanEnquiryAnalytics = function enterprisePlanEnquiryAnalytics() {
	    (0, _intercomService.intercomTrackEvent)('enterprise-payment-enquiry');
	    googleAnalyticsPlanEnquiryEvent('enterprise');
	};
	
	var googleAnalyticsIndividualPayment = exports.googleAnalyticsIndividualPayment = function googleAnalyticsIndividualPayment() {
	    return googleAnalyticsPaymentsEvent('payment-individual');
	};

/***/ }),
/* 236 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var TEAM_MEMBER_ADD = exports.TEAM_MEMBER_ADD = 'TEAM_MEMBER_ADD';
	var TEAM_MEMBER_ADD_NEW = exports.TEAM_MEMBER_ADD_NEW = 'TEAM_MEMBER_ADD_NEW';
	var TEAM_MEMBER_REMOVE = exports.TEAM_MEMBER_REMOVE = 'TEAM_MEMBER_REMOVE';
	var TEAM_MEMBERS_SET = exports.TEAM_MEMBERS_SET = 'TEAM_MEMBERS_SET';
	
	var TEAM_MEMBER_STATES = exports.TEAM_MEMBER_STATES = {
	    NEW: 'NEW', // user has not been added to the team before
	    ADDED: 'ADDED', // user is an existing member of the team
	    REMOVED: 'REMOVED' };

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getIdleOnlineUserIds = exports.getIdleOnlineUsers = exports.getRemoteActiveCurrentlyViewedBoardIds = exports.getOnlineUsers = exports.getRemoteCurrentlyViewedBoardIds = exports.getTrackedUserIds = undefined;
	
	var _reselect = __webpack_require__(7);
	
	var _milanoteReselect = __webpack_require__(49);
	
	var _userUtil = __webpack_require__(31);
	
	var _immutableHelper = __webpack_require__(23);
	
	var _currentUserSelector = __webpack_require__(33);
	
	var _userConstants = __webpack_require__(32);
	
	// Selectors
	// Lib
	var getTrackedUserIds = exports.getTrackedUserIds = (0, _milanoteReselect.createShallowSelector)(function (state) {
	    return state.get('users').keySeq().toArray();
	}, function (trackedUserIds) {
	    return trackedUserIds;
	});
	
	// Constants
	
	
	// Util
	
	
	var getCurrentlyViewedBoardIds = function getCurrentlyViewedBoardIds(users) {
	    return users.reduce(function (boardIds, user) {
	        var usersCurrentBoardId = user.get('currentBoardId');
	        if (!!usersCurrentBoardId && boardIds.indexOf(usersCurrentBoardId) === -1) {
	            boardIds.push(usersCurrentBoardId);
	        }
	        return boardIds;
	    }, []);
	};
	
	var getRemoteCurrentlyViewedBoardIds = exports.getRemoteCurrentlyViewedBoardIds = (0, _milanoteReselect.createShallowSelector)(function (state) {
	    return state.get('users');
	}, getCurrentlyViewedBoardIds);
	
	var getOnlineUsers = exports.getOnlineUsers = (0, _reselect.createSelector)(function (state) {
	    return state.get('users').filter(_userUtil.isOnline);
	}, function (users) {
	    return users;
	});
	
	var getRemoteActiveCurrentlyViewedBoardIds = exports.getRemoteActiveCurrentlyViewedBoardIds = (0, _milanoteReselect.createShallowSelector)(getOnlineUsers, getCurrentlyViewedBoardIds);
	
	var getIdleOnlineUsers = exports.getIdleOnlineUsers = (0, _reselect.createSelector)(getOnlineUsers, _currentUserSelector.getCurrentUserId, function (onlineUsers, currentUserId) {
	    var currentTime = Date.now();
	    // Find every user that might be stale because we haven't heard from them within the idle timeout
	    var idleTimestamp = currentTime - _userConstants.USER_IDLE_TIMEOUT_MILLISECONDS;
	    return onlineUsers.filter(function (user) {
	        return user.get('timestamp') < idleTimestamp && currentUserId !== user.get('_id');
	    });
	});
	
	var getIdleOnlineUserIds = exports.getIdleOnlineUserIds = (0, _milanoteReselect.createShallowSelector)(getIdleOnlineUsers, _immutableHelper.toIdArray);

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.validateImageFile = exports.VALIDATION_CODES = undefined;
	
	var _fileUploadConstants = __webpack_require__(2290);
	
	var VALIDATION_CODES = exports.VALIDATION_CODES = {
	    MAX_SIZE: 'MAX_SIZE',
	    INVALID_TYPE: 'INVALID_TYPE'
	};
	
	/**
	 * Validates whether a file passed in is an image and is within the size limits expected.
	 *
	 * @param file {File} The DOM File object to validate.
	 * @returns {Object} null if the file is valid, otherwise an object with error codes and details.
	 */
	var validateImageFile = exports.validateImageFile = function validateImageFile(file) {
	    // The file type must match the expected mime pattern
	    if (!file.type || !file.type.match(_fileUploadConstants.FILE_TYPES.IMAGE.mimePattern)) {
	        var message = 'Sorry, this file type is not supported';
	        console.warn(message);
	        return {
	            error: true,
	            code: VALIDATION_CODES.INVALID_TYPE,
	            message: message,
	            explanation: 'You can upload PNGs, JPEGs and GIFs',
	            details: {
	                type: _fileUploadConstants.FILE_TYPES.IMAGE.name,
	                expected: 'image/*',
	                actual: file.type
	            }
	        };
	    }
	
	    // Ensure the file is within the allowed limits
	    if (file.size > _fileUploadConstants.FILE_TYPES.IMAGE.maxSize) {
	        var _message = 'Sorry, this image is too large';
	        console.warn(_message);
	        return {
	            error: true,
	            code: VALIDATION_CODES.MAX_SIZE,
	            message: _message,
	            explanation: 'The maximum supported file size is 10MB',
	            details: {
	                type: _fileUploadConstants.FILE_TYPES.IMAGE.name,
	                max: _fileUploadConstants.FILE_TYPES.IMAGE.max_size,
	                actual: file.size
	            }
	        };
	    }
	
	    // successful validation will not return an object
	    return null;
	};

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getBreadcrumb = exports.getParentIds = exports.getAliases = exports.getCurrentChildrenDeep = exports.getCurrentChildren = exports.getSelectedIds = undefined;
	
	var _reselect = __webpack_require__(7);
	
	var _elementHelper = __webpack_require__(13);
	
	var _boardSelector = __webpack_require__(83);
	
	var _milanoteReselect = __webpack_require__(49);
	
	var _boardConstants = __webpack_require__(17);
	
	var _elementConstants = __webpack_require__(12);
	
	var _aliasConstants = __webpack_require__(241);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// Utils
	
	
	// Selectors
	
	
	// Constants
	
	
	var getSelectedIds = exports.getSelectedIds = (0, _reselect.createSelector)(function (state) {
	    return state.get('app').get('selection');
	}, function (selection) {
	    return selection.get('ids');
	});
	
	var getCurrentChildren = exports.getCurrentChildren = (0, _reselect.createSelector)(function (state) {
	    return state.get('elements');
	}, function (state, props) {
	    return props.currentBoardId;
	}, function (elements, currentBoardId) {
	    return (0, _elementHelper.getChildren)(elements, currentBoardId);
	});
	
	var getCurrentChildrenDeep = exports.getCurrentChildrenDeep = (0, _reselect.createSelector)(function (state) {
	    return state.get('elements');
	}, function (state, props) {
	    return props.currentBoardId;
	}, function (elements, currentBoardId) {
	    return (0, _elementHelper.getChildrenDeep)(elements, currentBoardId);
	});
	
	var getAliases = exports.getAliases = function getAliases(elements, elementId) {
	    return elements.filter(function (element) {
	        return element.get('elementType') === _aliasConstants.ALIAS_TYPE && element.get('content').get('linkTo') === elementId;
	    });
	};
	
	var getParentIds = exports.getParentIds = function getParentIds(elements, element) {
	    var parentId = element.getIn(['location', 'parentId']);
	    var parent = elements.get(parentId);
	
	    if (!parent || !parent.get('location')) return null;
	
	    // We have a skeleton parent so an alias must be this user's true parent
	    if (parent.get('elementType') === _elementConstants.SKELETON_ELEMENT_TYPE) {
	        var aliases = getAliases(elements, element.get('id'));
	        return aliases.toArray().map(function (alias) {
	            return alias.get('id');
	        });
	    }
	
	    return [parentId];
	};
	
	/**
	 * Remove columns from the breadcrumb list
	 */
	var filterOutColumns = function filterOutColumns(elements) {
	    return function (elementId) {
	        var element = elements.get(elementId);
	        return (0, _elementHelper.isBoard)(element) || (0, _elementHelper.isSkeleton)(element);
	    };
	};
	
	var getBreadcrumb = exports.getBreadcrumb = (0, _reselect.createSelector)(function (state) {
	    return state.get('elements');
	}, function (state, props) {
	    return props.currentBoardId;
	}, function (state) {
	    return state.getIn(['app', 'currentUser', 'rootBoardId']);
	}, function (state) {
	    return state.getIn(['app', 'currentUser', 'isGuest']);
	}, function (elements, currentBoardId, rootBoardId, isGuest) {
	    // Breadth first search until we find a the root element or we encounter a missing element
	    var queue = [];
	    var missingElementIds = [];
	    var visitedElementIds = [];
	
	    // Start at the current board and work backwards
	    var elementId = currentBoardId;
	    var currentPath = [elementId];
	
	    var removeColumns = filterOutColumns(elements);
	
	    while (elementId) {
	        var element = elements.get(elementId);
	        if (!element) return { complete: false, fullPath: currentPath, path: currentPath };
	
	        if (elementId === rootBoardId) {
	            // We've hit the root, so now filter out elements that aren't boards as we won't show these in our
	            // breadcrumb
	            var _filteredPath = currentPath.filter(removeColumns);
	            var returnObj = { complete: true, fullPath: currentPath, path: _filteredPath };
	            return returnObj;
	        }
	
	        // Get the potential parents
	        // NOTE: If the alias has been deleted then this will return an empty array.  As a result it will pass
	        // the next if statement and finish the while loop.  In this situation we have decided to handle this case
	        // by using the default return statement at the bottom of this method to construct a breadcrumb including
	        // only this element and the root element.  If this changes in the future we will need to revisit the
	        // assumption here.
	        var parentIds = getParentIds(elements, element);
	        if (!parentIds) {
	            missingElementIds.push(element.getIn(['location', 'parentId']));
	            var _filteredPath2 = currentPath.filter(removeColumns);
	            return { complete: false, missingElementIds: missingElementIds, fullPath: currentPath, path: _filteredPath2 };
	        }
	
	        visitedElementIds.push(elementId);
	        /* eslint-disable no-loop-func */
	        parentIds.forEach(function (parentId) {
	            // If the parentId is already in the queue to be visited then don't add it again (this will effectively
	            // drop the path from being searched as there is a quicker or just as quick path to root).
	            if (queue.filter(function (queueEntry) {
	                return queueEntry.elementId === parentId;
	            }).length) return;
	
	            var queueEntry = {
	                elementId: parentId,
	                currentPath: [parentId].concat(_toConsumableArray(currentPath))
	            };
	            queue.push(queueEntry);
	        });
	        /* eslint-enable no-loop-func */
	
	        var nextQueueEntry = queue.shift();
	        elementId = nextQueueEntry && nextQueueEntry.elementId;
	        currentPath = nextQueueEntry ? nextQueueEntry.currentPath : currentPath;
	    }
	
	    // Will only arrive here if an alias has been deleted and there is no way back to root, so construct a fake
	    // path consisting only of the shared board and the root board.
	    var path = [].concat(_toConsumableArray(currentPath));
	    var filteredPath = currentPath.filter(removeColumns);
	
	    // Only add a root board ID if the user is not a guest user
	    if (!isGuest) {
	        filteredPath.unshift(rootBoardId);
	        path.unshift(rootBoardId);
	    }
	
	    return { complete: true, fullPath: path, path: filteredPath };
	});
	
	var emptyState = {
	    inboxElementIds: [],
	    canvasElementIds: [],
	    sortedCanvasElementIds: []
	};
	
	var inboxElementsSelector = (0, _milanoteReselect.createShallowSelector)(getCurrentChildren, function (children) {
	    return (0, _elementHelper.getSortedChildrenInSection)(children, _boardConstants.BOARD_SECTIONS.INBOX, null, _elementHelper.sortByScore).map(function (el) {
	        return el.get('id');
	    }).toJS();
	});
	
	var canvasElementsSelector = (0, _reselect.createSelector)(getCurrentChildren, function (children) {
	    return (0, _elementHelper.getSortedChildrenInSection)(children, _boardConstants.BOARD_SECTIONS.CANVAS, null, _elementHelper.sortByModified);
	});
	
	var sortedCanvasElementsSelector = (0, _milanoteReselect.createShallowSelector)(getSelectedIds, canvasElementsSelector, function (selectedIds, children) {
	    return children.sort(function (elA, elB) {
	        if ((0, _elementHelper.isElementLocked)(elA) && !(0, _elementHelper.isElementLocked)(elB)) return -1;
	        if ((0, _elementHelper.isElementLocked)(elB) && !(0, _elementHelper.isElementLocked)(elA)) return 1;
	
	        var elAisSelected = selectedIds.indexOf(elA.get('id')) !== -1;
	        var elBisSelected = selectedIds.indexOf(elB.get('id')) !== -1;
	        if (elAisSelected && !elBisSelected) return 1;
	        if (elBisSelected && !elAisSelected) return -1;
	
	        if ((0, _elementHelper.isLine)(elA)) return -1;
	        if ((0, _elementHelper.isLine)(elB)) return 1;
	
	        return 0;
	    }).map(function (el) {
	        return el.get('id');
	    }).toJS();
	});
	
	exports.default = (0, _reselect.createSelector)(_boardSelector.getIsCurrentBoardFetched, inboxElementsSelector, sortedCanvasElementsSelector, canvasElementsSelector, function (currentBoardFetched, inboxElementIds, sortedCanvasElementIds, canvasElements) {
	    if (!currentBoardFetched) return emptyState;
	
	    // Sort canvasElementIds by their ID to prevent them from jumping around in the DOM when their ID changes.
	    var canvasElementIds = canvasElements.map(function (el) {
	        return el.get('id');
	    }).toJS();
	
	    return {
	        inboxElementIds: inboxElementIds,
	        canvasElementIds: canvasElementIds,
	        sortedCanvasElementIds: sortedCanvasElementIds
	    };
	});

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.STRING_ICONS = exports.ICON_POPUP_LETTERS_LIST = exports.ICON_POPUP_NUMBERS_LIST = exports.ICON_POPUP_WORD_FILTERS = exports.ICON_POPUP_MODE_LIST_MAX = exports.ICON_POPUP_SEARCH_FAILURE = exports.ICON_POPUP_SEARCH_SUCCESS = exports.ICON_POPUP_SEARCH_SUBMIT = exports.ICON_POPUP_MODE_SET = exports.ICON_POPUP_MODE_IMAGES = exports.ICON_POPUP_MODE_LETTERS = exports.ICON_POPUP_MODE_DEFAULT = undefined;
	
	var _makeStringIconDef = __webpack_require__(430);
	
	var _makeStringIconDef2 = _interopRequireDefault(_makeStringIconDef);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ICON_POPUP_MODE_DEFAULT = exports.ICON_POPUP_MODE_DEFAULT = 'default';
	var ICON_POPUP_MODE_LETTERS = exports.ICON_POPUP_MODE_LETTERS = 'letters';
	var ICON_POPUP_MODE_IMAGES = exports.ICON_POPUP_MODE_IMAGES = 'images';
	
	var ICON_POPUP_MODE_SET = exports.ICON_POPUP_MODE_SET = 'ICON_POPUP_STATE_SET';
	var ICON_POPUP_SEARCH_SUBMIT = exports.ICON_POPUP_SEARCH_SUBMIT = 'ICON_POPUP_SEARCH_SUBMIT';
	var ICON_POPUP_SEARCH_SUCCESS = exports.ICON_POPUP_SEARCH_SUCCESS = 'ICON_POPUP_SEARCH_SUCCESS';
	var ICON_POPUP_SEARCH_FAILURE = exports.ICON_POPUP_SEARCH_FAILURE = 'ICON_POPUP_SEARCH_FAILURE';
	
	var ICON_POPUP_MODE_LIST_MAX = exports.ICON_POPUP_MODE_LIST_MAX = 5;
	var ICON_POPUP_WORD_FILTERS = exports.ICON_POPUP_WORD_FILTERS = ['a', 'an', 'and', 'as', 'at', 'but', 'by', 'for', 'in', 'into', 'is', 'it', 'nor', 'of', 'onto', 'or', 'so', 'than', 'that', 'the', 'then', 'to', 'until', 'with', 'yet', '/', '&', '!', '@', '#', '&'];
	
	var ICON_POPUP_NUMBERS_LIST = exports.ICON_POPUP_NUMBERS_LIST = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
	
	var ICON_POPUP_LETTERS_LIST = exports.ICON_POPUP_LETTERS_LIST = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '!', '#', '$', '%', '&', '=', '~'];
	
	var STRING_ICONS = exports.STRING_ICONS = ICON_POPUP_LETTERS_LIST.map(function (letter) {
	    return (0, _makeStringIconDef2.default)(letter, 'strdefault');
	});

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ALIAS_DISPLAY_NAME = exports.ALIAS_TYPE = undefined;
	
	var _boardConstants = __webpack_require__(17);
	
	var ALIAS_TYPE = exports.ALIAS_TYPE = 'ALIAS';
	var ALIAS_DISPLAY_NAME = exports.ALIAS_DISPLAY_NAME = _boardConstants.BOARD_DISPLAY_NAME;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getBottomRightBoundaryPoint = exports.getTopLeftBoundaryPoint = exports.getAveragePoint = exports.getPointBetween = exports.getPointBetweenY = exports.getPointBetweenX = exports.getPointBetween1D = exports.getDistance = exports.getDelta = exports.getYDelta = exports.getXDelta = exports.get1DDelta = exports.getPoint = undefined;
	
	var _fp = __webpack_require__(52);
	
	var _immutableHelper = __webpack_require__(23);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } // Lib
	
	
	// Utils
	
	
	// √
	var getPoint = exports.getPoint = function getPoint(x, y) {
	    return { x: x, y: y };
	};
	
	// √
	var get1DDelta = exports.get1DDelta = function get1DDelta(from, to, dimension) {
	    return to[dimension] - from[dimension];
	};
	var getXDelta = exports.getXDelta = function getXDelta(from, to) {
	    return get1DDelta(from, to, 'x');
	};
	var getYDelta = exports.getYDelta = function getYDelta(from, to) {
	    return get1DDelta(from, to, 'y');
	};
	var getDelta = exports.getDelta = function getDelta(from, to) {
	    return getPoint(getXDelta(from, to), getYDelta(from, to));
	};
	var getDistance = exports.getDistance = function getDistance(from, to) {
	    return Math.hypot(getXDelta(from, to), getYDelta(from, to));
	};
	
	// √
	var getPointBetween1D = exports.getPointBetween1D = function getPointBetween1D(point1, point2, dimension, fraction) {
	    return point1[dimension] + (point2[dimension] - point1[dimension]) * fraction;
	};
	var getPointBetweenX = exports.getPointBetweenX = function getPointBetweenX(point1, point2, fraction) {
	    return getPointBetween1D(point1, point2, 'x', fraction);
	};
	var getPointBetweenY = exports.getPointBetweenY = function getPointBetweenY(point1, point2, fraction) {
	    return getPointBetween1D(point1, point2, 'y', fraction);
	};
	var getPointBetween = exports.getPointBetween = function getPointBetween(point1, point2) {
	    var fraction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.5;
	    return getPoint(getPointBetweenX(point1, point2, fraction), getPointBetweenY(point1, point2, fraction));
	};
	
	/**
	 * Calculates an average point given an array of points passed in.
	 * It sums all the dimensions of each point and then returns the sum divided by the number of points.
	 *
	 * E.g. For three points:
	 * x = (p1.x + p2.x + p3.x) / 3, y = (p1.y + p2.y + p3.y) /3
	 */
	var getAveragePoint = exports.getAveragePoint = function getAveragePoint(points) {
	    return points.reduce(function (acc, point, index) {
	        acc.x += point.x;
	        acc.y += point.y;
	
	        // If the final point take the average and return it to the caller
	        if (index === points.length - 1) {
	            acc.x /= points.length;
	            acc.y /= points.length;
	        }
	        return acc;
	    }, getPoint(0, 0));
	};
	
	var choosePoint = (0, _fp.curry)(function (selectorFn, axis, points) {
	    return selectorFn.apply(undefined, _toConsumableArray(points.map((0, _immutableHelper.prop)(axis))));
	});
	var getLeftBoundary = choosePoint(Math.min, 'x');
	var getRightBoundary = choosePoint(Math.max, 'x');
	var getTopBoundary = choosePoint(Math.min, 'y');
	var getBottomBoundary = choosePoint(Math.max, 'y');
	var getTopLeftBoundaryPoint = exports.getTopLeftBoundaryPoint = function getTopLeftBoundaryPoint(points) {
	    return getPoint(getLeftBoundary(points), getTopBoundary(points));
	};
	var getBottomRightBoundaryPoint = exports.getBottomRightBoundaryPoint = function getBottomRightBoundaryPoint(points) {
	    return getPoint(getRightBoundary(points), getBottomBoundary(points));
	};

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RESPONSE_ERROR = exports.USER_ERROR = exports.BOARD_ERROR = exports.ERROR_CLEAR = exports.ERROR_THROW = undefined;
	
	var _httpConstants = __webpack_require__(90);
	
	var ERROR_THROW = exports.ERROR_THROW = 'ERROR_THROW'; // Constants
	var ERROR_CLEAR = exports.ERROR_CLEAR = 'ERROR_CLEAR';
	
	// boards
	var BOARD_ERROR = exports.BOARD_ERROR = {
	    GENERIC_ERROR: 'GENERIC_ERROR',
	    NOT_FOUND: 'BOARD_NOT_FOUND',
	    DELETED: 'BOARD_DELETED',
	    ACCESS_DENIED: 'BOARD_ACCESS_DENIED',
	    TIMEOUT: _httpConstants.ERROR_CODES.CONNECTION_ABORTED,
	    CONNECTION_LOST: _httpConstants.ERROR_CODES.CONNECTION_RESET
	};
	
	var USER_ERROR = exports.USER_ERROR = {
	    NOT_FOUND: 'USER_NOT_FOUND'
	};
	
	var RESPONSE_ERROR = exports.RESPONSE_ERROR = {
	    VALIDATION_FAILURE: 'INVALID',
	    NOT_ADMIN: 'NOT_ADMIN',
	    BAD_REQUEST: 'BAD_REQUEST'
	};

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.describeChargeAmount = exports.describeCard = exports.describeCardNumber = exports.describeFrequency = exports.describeCoupon = exports.calculateCouponDiscount = exports.dollarsToCents = exports.centsToDollars = exports.convertPriceUnits = undefined;
	
	var _stringUtil = __webpack_require__(58);
	
	var _currencyUtil = __webpack_require__(325);
	
	var _paymentConstants = __webpack_require__(484);
	
	var MONTHS_IN_YEAR = 12;
	
	// Constants
	// Util
	var convertPriceUnits = exports.convertPriceUnits = function convertPriceUnits(price, priceUnit, toUnit) {
	    if (priceUnit === _paymentConstants.PRICE_BILLING_UNITS.month && toUnit === _paymentConstants.PRICE_BILLING_UNITS.year) {
	        return price * MONTHS_IN_YEAR;
	    }
	
	    if (priceUnit === _paymentConstants.PRICE_BILLING_UNITS.year && toUnit === _paymentConstants.PRICE_BILLING_UNITS.month) {
	        return price / MONTHS_IN_YEAR;
	    }
	
	    return price;
	};
	
	var CENTS_IN_DOLLAR = 100;
	var centsToDollars = exports.centsToDollars = function centsToDollars(cents) {
	    var dollar = cents / CENTS_IN_DOLLAR;
	    return Number.isInteger(dollar) ? dollar : dollar.toFixed(2);
	};
	var dollarsToCents = exports.dollarsToCents = function dollarsToCents(dollars) {
	    return dollars * CENTS_IN_DOLLAR;
	};
	
	var calculateAmountOff = function calculateAmountOff(amountOff, price) {
	    return price - amountOff;
	};
	var calculatePercentOff = function calculatePercentOff(percentOff, price) {
	    return price - price * (percentOff / 100);
	};
	
	/**
	 * Calculate price
	 *
	 * @param coupon The coupon:
	 * { amount_off: Number (optional), percent_off: Number (optional), duration:[one of: 'forever', 'once', 'repeating'], duration_in_months: Number (exists if duration === 'repeating')] }
	 * @param price The price to calculate coupon value on
	 */
	var calculateCouponDiscount = exports.calculateCouponDiscount = function calculateCouponDiscount(coupon, price) {
	    if (!coupon) return price;
	    if (coupon.amount_off) return calculateAmountOff(coupon.amount_off, price);
	    if (coupon.percent_off) return calculatePercentOff(coupon.percent_off, price);
	    return price;
	};
	
	var describeCouponAmount = function describeCouponAmount(_ref) {
	    var amount_off = _ref.amount_off,
	        percent_off = _ref.percent_off;
	    return amount_off ? '$' + centsToDollars(amount_off) + ' off' : percent_off + '% off' // eslint-disable-line camelcase
	    ;
	};
	
	var describeCouponDuration = function describeCouponDuration(_ref2) {
	    var duration = _ref2.duration,
	        duration_in_months = _ref2.duration_in_months;
	
	    switch (duration) {
	        case _paymentConstants.COUPON_DURATION.forever:
	            return ' forever';
	        case _paymentConstants.COUPON_DURATION.repeating:
	            return ' for ' + duration_in_months + ' ' + (0, _stringUtil.pluralise)('month', duration_in_months); // eslint-disable-line camelcase
	        case _paymentConstants.COUPON_DURATION.once:
	        default:
	            return '';
	    }
	};
	
	/**
	 * Describe a coupon
	 *
	 * @param coupon The coupon:
	 * { amount_off: Number (optional), percent_off: Number (optional), duration:[one of: 'forever', 'once', 'repeating'], duration_in_months: Number (exists if duration === 'repeating')] }
	 */
	var describeCoupon = exports.describeCoupon = function describeCoupon(coupon) {
	    return coupon ? '' + describeCouponAmount(coupon) + describeCouponDuration(coupon) : undefined;
	};
	
	var describeFrequency = exports.describeFrequency = function describeFrequency(duration) {
	    switch (duration) {
	        case _paymentConstants.PRICE_BILLING_UNITS.year:
	            return 'annually';
	        case _paymentConstants.PRICE_BILLING_UNITS.month:
	        default:
	            return duration + 'ly';
	    }
	};
	
	var describeCardNumber = exports.describeCardNumber = function describeCardNumber(last4) {
	    return '\u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022 ' + last4;
	};
	
	var describeCard = exports.describeCard = function describeCard(_ref3) {
	    var last4 = _ref3.last4,
	        brand = _ref3.brand;
	
	    if (!last4 && !brand) return 'No card';
	
	    return brand + ' (' + describeCardNumber(last4) + ')';
	};
	
	var describeChargeAmount = exports.describeChargeAmount = function describeChargeAmount(_ref4) {
	    var currency = _ref4.currency,
	        amount = _ref4.amount;
	    return '' + (0, _currencyUtil.getCurrencySymbol)(currency) + centsToDollars(amount);
	};

/***/ }),
/* 245 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	/**
	 * Throttles calls to a function to ensure they only happen on a request animation frame.
	 */
	exports.default = function (fn) {
	    var requestId = void 0;
	
	    var throttled = function throttled() {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        var latestArgs = args;
	        // If we have already requested an animation frame, return
	        if (requestId) return;
	
	        // Wait an animation frame
	        requestId = requestAnimationFrame(function () {
	            requestId = null;
	            fn.apply(undefined, latestArgs);
	        });
	    };
	
	    throttled.cancel = function () {
	        if (!requestId) return;
	        cancelAnimationFrame(requestId);
	        requestId = null;
	    };
	
	    return throttled;
	};

/***/ }),
/* 246 */
/***/ (function(module, exports) {

	module.exports = (function (Base62) {
	    var DEFAULT_CHARACTER_SET = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
	
	    Base62.encode = function(integer){
	        if (integer === 0) {return '0';}
	        var s = '';
	        while (integer > 0) {
	            s = Base62.characterSet[integer % 62] + s;
	            integer = Math.floor(integer/62);
	        }
	        return s;
	    };
	
	    Base62.decode = function(base62String){
	        var val = 0, base62Chars = base62String.split("").reverse();
	        base62Chars.forEach(function(character, index){
	            val += Base62.characterSet.indexOf(character) * Math.pow(62, index);
	        });
	        return val;
	    };
	
	    Base62.setCharacterSet = function(chars) {
	        var arrayOfChars = chars.split(""), uniqueCharacters = [];
	
	        if(arrayOfChars.length != 62) throw Error("You must supply 62 characters");
	
	        arrayOfChars.forEach(function(char){
	            if(!~uniqueCharacters.indexOf(char)) uniqueCharacters.push(char);
	        });
	
	        if(uniqueCharacters.length != 62) throw Error("You must use unique characters.");
	
	        Base62.characterSet = arrayOfChars;
	    };
	
	    Base62.setCharacterSet(DEFAULT_CHARACTER_SET);
	    return Base62;
	}({}));


/***/ }),
/* 247 */
/***/ (function(module, exports) {

	
	module.exports = function(a, b){
	  var fn = function(){};
	  fn.prototype = b.prototype;
	  a.prototype = new fn;
	  a.prototype.constructor = a;
	};

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(71)
	  , toLength  = __webpack_require__(44)
	  , toIndex   = __webpack_require__(156);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global            = __webpack_require__(15)
	  , $export           = __webpack_require__(5)
	  , redefine          = __webpack_require__(69)
	  , redefineAll       = __webpack_require__(154)
	  , meta              = __webpack_require__(130)
	  , forOf             = __webpack_require__(178)
	  , anInstance        = __webpack_require__(149)
	  , isObject          = __webpack_require__(25)
	  , fails             = __webpack_require__(19)
	  , $iterDetect       = __webpack_require__(254)
	  , setToStringTag    = __webpack_require__(180)
	  , inheritIfRequired = __webpack_require__(334);
	
	module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
	  var Base  = global[NAME]
	    , C     = Base
	    , ADDER = IS_MAP ? 'set' : 'add'
	    , proto = C && C.prototype
	    , O     = {};
	  var fixMethod = function(KEY){
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a){
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a){ fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b){ fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if(typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
	    new C().entries().next();
	  }))){
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance             = new C
	      // early implementations not supports chaining
	      , HASNT_CHAINING       = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance
	      // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	      , THROWS_ON_PRIMITIVES = fails(function(){ instance.has(1); })
	      // most early implementations doesn't supports iterables, most modern - not close it correctly
	      , ACCEPT_ITERABLES     = $iterDetect(function(iter){ new C(iter); }) // eslint-disable-line no-new
	      // for early implementations -0 and +0 not the same
	      , BUGGY_ZERO = !IS_WEAK && fails(function(){
	        // V8 ~ Chromium 42- fails only with 5+ elements
	        var $instance = new C()
	          , index     = 5;
	        while(index--)$instance[ADDER](index, index);
	        return !$instance.has(-0);
	      });
	    if(!ACCEPT_ITERABLES){ 
	      C = wrapper(function(target, iterable){
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base, target, C);
	        if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if(THROWS_ON_PRIMITIVES || BUGGY_ZERO){
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if(BUGGY_ZERO || HASNT_CHAINING)fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if(IS_WEAK && proto.clear)delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var hide     = __webpack_require__(68)
	  , redefine = __webpack_require__(69)
	  , fails    = __webpack_require__(19)
	  , defined  = __webpack_require__(92)
	  , wks      = __webpack_require__(29);
	
	module.exports = function(KEY, length, exec){
	  var SYMBOL   = wks(KEY)
	    , fns      = exec(defined, SYMBOL, ''[KEY])
	    , strfn    = fns[0]
	    , rxfn     = fns[1];
	  if(fails(function(){
	    var O = {};
	    O[SYMBOL] = function(){ return 7; };
	    return ''[KEY](O) != 7;
	  })){
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function(string, arg){ return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function(string){ return rxfn.call(string, this); }
	    );
	  }
	};

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(14);
	module.exports = function(){
	  var that   = anObject(this)
	    , result = '';
	  if(that.global)     result += 'g';
	  if(that.ignoreCase) result += 'i';
	  if(that.multiline)  result += 'm';
	  if(that.unicode)    result += 'u';
	  if(that.sticky)     result += 'y';
	  return result;
	};

/***/ }),
/* 252 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function(fn, args, that){
	  var un = that === undefined;
	  switch(args.length){
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return              fn.apply(that, args);
	};

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(25)
	  , cof      = __webpack_require__(91)
	  , MATCH    = __webpack_require__(29)('match');
	module.exports = function(it){
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR     = __webpack_require__(29)('iterator')
	  , SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }
	
	module.exports = function(exec, skipClosing){
	  if(!skipClosing && !SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[ITERATOR]();
	    iter.next = function(){ return {done: safe = true}; };
	    arr[ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(150)|| !__webpack_require__(19)(function(){
	  var K = Math.random();
	  // In FF throws only define methods
	  __defineSetter__.call(null, K, function(){ /* empty */});
	  delete __webpack_require__(15)[K];
	});

/***/ }),
/* 256 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(15)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(15)
	  , hide   = __webpack_require__(68)
	  , uid    = __webpack_require__(157)
	  , TYPED  = uid('typed_array')
	  , VIEW   = uid('view')
	  , ABV    = !!(global.ArrayBuffer && global.DataView)
	  , CONSTR = ABV
	  , i = 0, l = 9, Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while(i < l){
	  if(Typed = global[TypedArrayConstructors[i++]]){
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV:    ABV,
	  CONSTR: CONSTR,
	  TYPED:  TYPED,
	  VIEW:   VIEW
	};

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.END_DRAG = exports.DROP = exports.HOVER = exports.PUBLISH_DRAG_SOURCE = exports.BEGIN_DRAG = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.beginDrag = beginDrag;
	exports.publishDragSource = publishDragSource;
	exports.hover = hover;
	exports.drop = drop;
	exports.endDrag = endDrag;
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isArray = __webpack_require__(162);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _isObject = __webpack_require__(218);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _matchesType = __webpack_require__(530);
	
	var _matchesType2 = _interopRequireDefault(_matchesType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BEGIN_DRAG = exports.BEGIN_DRAG = 'dnd-core/BEGIN_DRAG';
	var PUBLISH_DRAG_SOURCE = exports.PUBLISH_DRAG_SOURCE = 'dnd-core/PUBLISH_DRAG_SOURCE';
	var HOVER = exports.HOVER = 'dnd-core/HOVER';
	var DROP = exports.DROP = 'dnd-core/DROP';
	var END_DRAG = exports.END_DRAG = 'dnd-core/END_DRAG';
	
	function beginDrag(sourceIds) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { publishSource: true, clientOffset: null };
	  var publishSource = options.publishSource,
	      clientOffset = options.clientOffset,
	      getSourceClientOffset = options.getSourceClientOffset;
	
	  (0, _invariant2.default)((0, _isArray2.default)(sourceIds), 'Expected sourceIds to be an array.');
	
	  var monitor = this.getMonitor();
	  var registry = this.getRegistry();
	  (0, _invariant2.default)(!monitor.isDragging(), 'Cannot call beginDrag while dragging.');
	
	  for (var i = 0; i < sourceIds.length; i++) {
	    (0, _invariant2.default)(registry.getSource(sourceIds[i]), 'Expected sourceIds to be registered.');
	  }
	
	  var sourceId = null;
	  for (var _i = sourceIds.length - 1; _i >= 0; _i--) {
	    if (monitor.canDragSource(sourceIds[_i])) {
	      sourceId = sourceIds[_i];
	      break;
	    }
	  }
	  if (sourceId === null) {
	    return;
	  }
	
	  var sourceClientOffset = null;
	  if (clientOffset) {
	    (0, _invariant2.default)(typeof getSourceClientOffset === 'function', 'When clientOffset is provided, getSourceClientOffset must be a function.');
	    sourceClientOffset = getSourceClientOffset(sourceId);
	  }
	
	  var source = registry.getSource(sourceId);
	  var item = source.beginDrag(monitor, sourceId);
	  (0, _invariant2.default)((0, _isObject2.default)(item), 'Item must be an object.');
	
	  registry.pinSource(sourceId);
	
	  var itemType = registry.getSourceType(sourceId);
	  return {
	    type: BEGIN_DRAG,
	    itemType: itemType,
	    item: item,
	    sourceId: sourceId,
	    clientOffset: clientOffset,
	    sourceClientOffset: sourceClientOffset,
	    isSourcePublic: publishSource
	  };
	}
	
	function publishDragSource() {
	  var monitor = this.getMonitor();
	  if (!monitor.isDragging()) {
	    return;
	  }
	
	  return { type: PUBLISH_DRAG_SOURCE };
	}
	
	function hover(targetIdsArg) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$clientOffset = _ref.clientOffset,
	      clientOffset = _ref$clientOffset === undefined ? null : _ref$clientOffset;
	
	  (0, _invariant2.default)((0, _isArray2.default)(targetIdsArg), 'Expected targetIds to be an array.');
	  var targetIds = targetIdsArg.slice(0);
	
	  var monitor = this.getMonitor();
	  var registry = this.getRegistry();
	  (0, _invariant2.default)(monitor.isDragging(), 'Cannot call hover while not dragging.');
	  (0, _invariant2.default)(!monitor.didDrop(), 'Cannot call hover after drop.');
	
	  // First check invariants.
	  for (var i = 0; i < targetIds.length; i++) {
	    var targetId = targetIds[i];
	    (0, _invariant2.default)(targetIds.lastIndexOf(targetId) === i, 'Expected targetIds to be unique in the passed array.');
	
	    var target = registry.getTarget(targetId);
	    (0, _invariant2.default)(target, 'Expected targetIds to be registered.');
	  }
	
	  var draggedItemType = monitor.getItemType();
	
	  // Remove those targetIds that don't match the targetType.  This
	  // fixes shallow isOver which would only be non-shallow because of
	  // non-matching targets.
	  for (var _i2 = targetIds.length - 1; _i2 >= 0; _i2--) {
	    var _targetId = targetIds[_i2];
	    var targetType = registry.getTargetType(_targetId);
	    if (!(0, _matchesType2.default)(targetType, draggedItemType)) {
	      targetIds.splice(_i2, 1);
	    }
	  }
	
	  // Finally call hover on all matching targets.
	  for (var _i3 = 0; _i3 < targetIds.length; _i3++) {
	    var _targetId2 = targetIds[_i3];
	    var _target = registry.getTarget(_targetId2);
	    _target.hover(monitor, _targetId2);
	  }
	
	  return {
	    type: HOVER,
	    targetIds: targetIds,
	    clientOffset: clientOffset
	  };
	}
	
	function drop() {
	  var _this = this;
	
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var monitor = this.getMonitor();
	  var registry = this.getRegistry();
	  (0, _invariant2.default)(monitor.isDragging(), 'Cannot call drop while not dragging.');
	  (0, _invariant2.default)(!monitor.didDrop(), 'Cannot call drop twice during one drag operation.');
	
	  var targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);
	
	  targetIds.reverse();
	  targetIds.forEach(function (targetId, index) {
	    var target = registry.getTarget(targetId);
	
	    var dropResult = target.drop(monitor, targetId);
	    (0, _invariant2.default)(typeof dropResult === 'undefined' || (0, _isObject2.default)(dropResult), 'Drop result must either be an object or undefined.');
	    if (typeof dropResult === 'undefined') {
	      dropResult = index === 0 ? {} : monitor.getDropResult();
	    }
	
	    _this.store.dispatch({
	      type: DROP,
	      dropResult: _extends({}, options, dropResult)
	    });
	  });
	}
	
	function endDrag() {
	  var monitor = this.getMonitor();
	  var registry = this.getRegistry();
	  (0, _invariant2.default)(monitor.isDragging(), 'Cannot call endDrag while not dragging.');
	
	  var sourceId = monitor.getSourceId();
	  var source = registry.getSource(sourceId, true);
	  source.endDrag(monitor, sourceId);
	
	  registry.unpinSource();
	
	  return { type: END_DRAG };
	}

/***/ }),
/* 260 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.addSource = addSource;
	exports.addTarget = addTarget;
	exports.removeSource = removeSource;
	exports.removeTarget = removeTarget;
	var ADD_SOURCE = exports.ADD_SOURCE = 'dnd-core/ADD_SOURCE';
	var ADD_TARGET = exports.ADD_TARGET = 'dnd-core/ADD_TARGET';
	var REMOVE_SOURCE = exports.REMOVE_SOURCE = 'dnd-core/REMOVE_SOURCE';
	var REMOVE_TARGET = exports.REMOVE_TARGET = 'dnd-core/REMOVE_TARGET';
	
	function addSource(sourceId) {
	  return {
	    type: ADD_SOURCE,
	    sourceId: sourceId
	  };
	}
	
	function addTarget(targetId) {
	  return {
	    type: ADD_TARGET,
	    targetId: targetId
	  };
	}
	
	function removeSource(sourceId) {
	  return {
	    type: REMOVE_SOURCE,
	    sourceId: sourceId
	  };
	}
	
	function removeTarget(targetId) {
	  return {
	    type: REMOVE_TARGET,
	    targetId: targetId
	  };
	}

/***/ }),
/* 261 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftOffsetKey
	 * 
	 */
	
	'use strict';
	
	var KEY_DELIMITER = '-';
	
	var DraftOffsetKey = {
	  encode: function encode(blockKey, decoratorKey, leafKey) {
	    return blockKey + KEY_DELIMITER + decoratorKey + KEY_DELIMITER + leafKey;
	  },
	
	  decode: function decode(offsetKey) {
	    var _offsetKey$split = offsetKey.split(KEY_DELIMITER);
	
	    var blockKey = _offsetKey$split[0];
	    var decoratorKey = _offsetKey$split[1];
	    var leafKey = _offsetKey$split[2];
	
	    return {
	      blockKey: blockKey,
	      decoratorKey: parseInt(decoratorKey, 10),
	      leafKey: parseInt(leafKey, 10)
	    };
	  }
	};
	
	module.exports = DraftOffsetKey;

/***/ }),
/* 262 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findRangesImmutable
	 * 
	 */
	
	'use strict';
	
	/**
	 * Search through an array to find contiguous stretches of elements that
	 * match a specified filter function.
	 *
	 * When ranges are found, execute a specified `found` function to supply
	 * the values to the caller.
	 */
	function findRangesImmutable(haystack, areEqualFn, filterFn, foundFn) {
	  if (!haystack.size) {
	    return;
	  }
	
	  var cursor = 0;
	
	  haystack.reduce(function (value, nextValue, nextIndex) {
	    /* $FlowFixMe(>=0.28.0): `value` could be undefined! */
	    if (!areEqualFn(value, nextValue)) {
	      /* $FlowFixMe(>=0.28.0): `value` could be undefined! */
	      if (filterFn(value)) {
	        foundFn(cursor, nextIndex);
	      }
	      cursor = nextIndex;
	    }
	    return nextValue;
	  });
	
	  filterFn(haystack.last()) && foundFn(cursor, haystack.count());
	}
	
	module.exports = findRangesImmutable;

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getContentStateFragment
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var generateRandomKey = __webpack_require__(100);
	var removeEntitiesAtEdges = __webpack_require__(550);
	
	function getContentStateFragment(contentState, selectionState) {
	  var startKey = selectionState.getStartKey();
	  var startOffset = selectionState.getStartOffset();
	  var endKey = selectionState.getEndKey();
	  var endOffset = selectionState.getEndOffset();
	
	  // Edge entities should be stripped to ensure that we don't preserve
	  // invalid partial entities when the fragment is reused. We do, however,
	  // preserve entities that are entirely within the selection range.
	  var contentWithoutEdgeEntities = removeEntitiesAtEdges(contentState, selectionState);
	
	  var blockMap = contentWithoutEdgeEntities.getBlockMap();
	  var blockKeys = blockMap.keySeq();
	  var startIndex = blockKeys.indexOf(startKey);
	  var endIndex = blockKeys.indexOf(endKey) + 1;
	
	  var slice = blockMap.slice(startIndex, endIndex).map(function (block, blockKey) {
	    var newKey = generateRandomKey();
	
	    var text = block.getText();
	    var chars = block.getCharacterList();
	
	    if (startKey === endKey) {
	      return block.merge({
	        key: newKey,
	        text: text.slice(startOffset, endOffset),
	        characterList: chars.slice(startOffset, endOffset)
	      });
	    }
	
	    if (blockKey === startKey) {
	      return block.merge({
	        key: newKey,
	        text: text.slice(startOffset),
	        characterList: chars.slice(startOffset)
	      });
	    }
	
	    if (blockKey === endKey) {
	      return block.merge({
	        key: newKey,
	        text: text.slice(0, endOffset),
	        characterList: chars.slice(0, endOffset)
	      });
	    }
	
	    return block.set('key', newKey);
	  });
	
	  return slice.toOrderedMap();
	}
	
	module.exports = getContentStateFragment;

/***/ }),
/* 264 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isEventHandled
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	/**
	 * Utility method for determining whether or not the value returned
	 * from a handler indicates that it was handled.
	 */
	function isEventHandled(value) {
	  return value === 'handled' || value === true;
	}
	
	module.exports = isEventHandled;

/***/ }),
/* 265 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ }),
/* 266 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ }),
/* 267 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	exports.canUseDOM = canUseDOM;

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(102);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _queryString = __webpack_require__(1452);
	
	var _runTransitionHook = __webpack_require__(372);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(160);
	
	var _deprecate = __webpack_require__(371);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var SEARCH_BASE_KEY = '$searchBase';
	
	function defaultStringifyQuery(query) {
	  return _queryString.stringify(query).replace(/%20/g, '+');
	}
	
	var defaultParseQueryString = _queryString.parse;
	
	function isNestedObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p) && typeof object[p] === 'object' && !Array.isArray(object[p]) && object[p] !== null) return true;
	  }return false;
	}
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var stringifyQuery = options.stringifyQuery;
	    var parseQueryString = options.parseQueryString;
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    function addQuery(location) {
	      if (location.query == null) {
	        var search = location.search;
	
	        location.query = parseQueryString(search.substring(1));
	        location[SEARCH_BASE_KEY] = { search: search, searchBase: '' };
	      }
	
	      // TODO: Instead of all the book-keeping here, this should just strip the
	      // stringified query from the search.
	
	      return location;
	    }
	
	    function appendQuery(location, query) {
	      var _extends2;
	
	      var searchBaseSpec = location[SEARCH_BASE_KEY];
	      var queryString = query ? stringifyQuery(query) : '';
	      if (!searchBaseSpec && !queryString) {
	        return location;
	      }
	
	       false ? _warning2['default'](stringifyQuery !== defaultStringifyQuery || !isNestedObject(query), 'useQueries does not stringify nested query objects by default; ' + 'use a custom stringifyQuery function') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var searchBase = undefined;
	      if (searchBaseSpec && location.search === searchBaseSpec.search) {
	        searchBase = searchBaseSpec.searchBase;
	      } else {
	        searchBase = location.search || '';
	      }
	
	      var search = searchBase;
	      if (queryString) {
	        search += (search ? '&' : '?') + queryString;
	      }
	
	      return _extends({}, location, (_extends2 = {
	        search: search
	      }, _extends2[SEARCH_BASE_KEY] = { search: search, searchBase: searchBase }, _extends2));
	    }
	
	    // Override all read methods with query-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addQuery(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addQuery(location));
	      });
	    }
	
	    // Override all write methods with query-aware versions.
	    function push(location) {
	      history.push(appendQuery(location, location.query));
	    }
	
	    function replace(location) {
	      history.replace(appendQuery(location, location.query));
	    }
	
	    function createPath(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createPath is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createPath(appendQuery(location, query || location.query));
	    }
	
	    function createHref(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createHref is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createHref(appendQuery(location, query || location.query));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var fullLocation = history.createLocation.apply(history, [appendQuery(location, location.query)].concat(args));
	      if (location.query) {
	        fullLocation.query = location.query;
	      }
	      return addQuery(fullLocation);
	    }
	
	    // deprecated
	    function pushState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path, { query: query }));
	    }
	
	    // deprecated
	    function replaceState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path, { query: query }));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useQueries;
	module.exports = exports['default'];

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(274);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(375),
	    getRawTag = __webpack_require__(1396),
	    objectToString = __webpack_require__(1420);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(1405);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(1383),
	    getValue = __webpack_require__(1397);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(272);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 274 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(381),
	    isObjectLike = __webpack_require__(219);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = checkDecoratorArguments;
	function checkDecoratorArguments(functionName, signature) {
	  if (false) {
	    for (var i = 0; i < (arguments.length <= 2 ? 0 : arguments.length - 2); i += 1) {
	      var arg = arguments.length <= i + 2 ? undefined : arguments[i + 2];
	      if (arg && arg.prototype && arg.prototype.render) {
	        console.error( // eslint-disable-line no-console
	        'You seem to be applying the arguments in the wrong order. ' + ('It should be ' + functionName + '(' + signature + ')(Component), not the other way around. ') + 'Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#you-seem-to-be-applying-the-arguments-in-the-wrong-order');
	        return;
	      }
	    }
	  }
	}

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(20);
	
	var EventPluginRegistry = __webpack_require__(387);
	var ReactEventEmitterMixin = __webpack_require__(1502);
	var ViewportMetrics = __webpack_require__(616);
	
	var getVendorPrefixedEventName = __webpack_require__(1534);
	var isEventSupported = __webpack_require__(398);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(224);
	var ViewportMetrics = __webpack_require__(616);
	
	var getEventModifierState = __webpack_require__(396);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var invariant = __webpack_require__(10);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ }),
/* 280 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(64);
	var DOMNamespaces = __webpack_require__(386);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(394);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ }),
/* 282 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _deprecateObjectProperties = __webpack_require__(284);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _getRouteParams = __webpack_require__(1566);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _RouteUtils = __webpack_require__(133);
	
	var _routerWarning = __webpack_require__(46);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var array = _React$PropTypes.array;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	
	var RouterContext = _react2.default.createClass({
	  displayName: 'RouterContext',
	
	
	  propTypes: {
	    history: object,
	    router: object.isRequired,
	    location: object.isRequired,
	    routes: array.isRequired,
	    params: object.isRequired,
	    components: array.isRequired,
	    createElement: func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    history: object,
	    location: object.isRequired,
	    router: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    var _props = this.props;
	    var router = _props.router;
	    var history = _props.history;
	    var location = _props.location;
	
	    if (!router) {
	       false ? (0, _routerWarning2.default)(false, '`<RouterContext>` expects a `router` rather than a `history`') : void 0;
	
	      router = _extends({}, history, {
	        setRouteLeaveHook: history.listenBeforeLeavingRoute
	      });
	      delete router.listenBeforeLeavingRoute;
	    }
	
	    if (false) {
	      location = (0, _deprecateObjectProperties2.default)(location, '`context.location` is deprecated, please use a route component\'s `props.location` instead. http://tiny.cc/router-accessinglocation');
	    }
	
	    return { history: history, location: location, router: router };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props2 = this.props;
	    var history = _props2.history;
	    var location = _props2.location;
	    var routes = _props2.routes;
	    var params = _props2.params;
	    var components = _props2.components;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          history: history,
	          location: location,
	          params: params,
	          route: route,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.canUseMembrane = undefined;
	
	var _routerWarning = __webpack_require__(46);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseMembrane = exports.canUseMembrane = false;
	
	// No-op by default.
	var deprecateObjectProperties = function deprecateObjectProperties(object) {
	  return object;
	};
	
	if (false) {
	  try {
	    if (Object.defineProperty({}, 'x', {
	      get: function get() {
	        return true;
	      }
	    }).x) {
	      exports.canUseMembrane = canUseMembrane = true;
	    }
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	  if (canUseMembrane) {
	    deprecateObjectProperties = function deprecateObjectProperties(object, message) {
	      // Wrap the deprecated object in a membrane to warn on property access.
	      var membrane = {};
	
	      var _loop = function _loop(prop) {
	        if (!Object.prototype.hasOwnProperty.call(object, prop)) {
	          return 'continue';
	        }
	
	        if (typeof object[prop] === 'function') {
	          // Can't use fat arrow here because of use of arguments below.
	          membrane[prop] = function () {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop].apply(object, arguments);
	          };
	          return 'continue';
	        }
	
	        // These properties are non-enumerable to prevent React dev tools from
	        // seeing them and causing spurious warnings when accessing them. In
	        // principle this could be done with a proxy, but support for the
	        // ownKeys trap on proxies is not universal, even among browsers that
	        // otherwise support proxies.
	        Object.defineProperty(membrane, prop, {
	          get: function get() {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop];
	          }
	        });
	      };
	
	      for (var prop in object) {
	        var _ret = _loop(prop);
	
	        if (_ret === 'continue') continue;
	      }
	
	      return membrane;
	    };
	  }
	}
	
	exports.default = deprecateObjectProperties;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHelper = __webpack_require__(30);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _createEagerFactory = __webpack_require__(53);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapProps = function mapProps(propsMapper) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	    return function (props) {
	      return factory(propsMapper(props));
	    };
	  };
	};
	
	exports.default = (0, _createHelper2.default)(mapProps, 'mapProps');

/***/ }),
/* 286 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var _config = {
	  fromESObservable: null,
	  toESObservable: null
	};
	
	var configureObservable = function configureObservable(c) {
	  _config = c;
	};
	
	var config = exports.config = {
	  fromESObservable: function fromESObservable(observable) {
	    return typeof _config.fromESObservable === 'function' ? _config.fromESObservable(observable) : observable;
	  },
	  toESObservable: function toESObservable(stream) {
	    return typeof _config.toESObservable === 'function' ? _config.toESObservable(stream) : stream;
	  }
	};
	
	exports.default = configureObservable;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shallowEqual = __webpack_require__(266);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _shallowEqual2.default;

/***/ }),
/* 288 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isValid;
	function isValid(error) {
	  if (Array.isArray(error)) {
	    return error.reduce(function (valid, errorValue) {
	      return valid && isValid(errorValue);
	    }, true);
	  }
	  if (error && typeof error === 'object') {
	    return Object.keys(error).reduce(function (valid, key) {
	      return valid && isValid(error[key]);
	    }, true);
	  }
	  return !error;
	}

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.logger = exports.createLogger = exports.defaults = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _core = __webpack_require__(1647);
	
	var _helpers = __webpack_require__(661);
	
	var _defaults = __webpack_require__(1648);
	
	var _defaults2 = _interopRequireDefault(_defaults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates logger with following options
	 *
	 * @namespace
	 * @param {object} options - options for logger
	 * @param {string | function | object} options.level - console[level]
	 * @param {boolean} options.duration - print duration of each action?
	 * @param {boolean} options.timestamp - print timestamp with each action?
	 * @param {object} options.colors - custom colors
	 * @param {object} options.logger - implementation of the `console` API
	 * @param {boolean} options.logErrors - should errors in action execution be caught, logged, and re-thrown?
	 * @param {boolean} options.collapsed - is group collapsed?
	 * @param {boolean} options.predicate - condition which resolves logger behavior
	 * @param {function} options.stateTransformer - transform state before print
	 * @param {function} options.actionTransformer - transform action before print
	 * @param {function} options.errorTransformer - transform error before print
	 *
	 * @returns {function} logger middleware
	 */
	function createLogger() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var loggerOptions = _extends({}, _defaults2.default, options);
	
	  var logger = loggerOptions.logger,
	      stateTransformer = loggerOptions.stateTransformer,
	      errorTransformer = loggerOptions.errorTransformer,
	      predicate = loggerOptions.predicate,
	      logErrors = loggerOptions.logErrors,
	      diffPredicate = loggerOptions.diffPredicate;
	
	  // Return if 'console' object is not defined
	
	  if (typeof logger === 'undefined') {
	    return function () {
	      return function (next) {
	        return function (action) {
	          return next(action);
	        };
	      };
	    };
	  }
	
	  // Detect if 'createLogger' was passed directly to 'applyMiddleware'.
	  if (options.getState && options.dispatch) {
	    // eslint-disable-next-line no-console
	    console.error('[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from \'redux-logger\'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from \'redux-logger\'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n');
	
	    return function () {
	      return function (next) {
	        return function (action) {
	          return next(action);
	        };
	      };
	    };
	  }
	
	  var logBuffer = [];
	
	  return function (_ref) {
	    var getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        // Exit early if predicate function returns 'false'
	        if (typeof predicate === 'function' && !predicate(getState, action)) {
	          return next(action);
	        }
	
	        var logEntry = {};
	
	        logBuffer.push(logEntry);
	
	        logEntry.started = _helpers.timer.now();
	        logEntry.startedTime = new Date();
	        logEntry.prevState = stateTransformer(getState());
	        logEntry.action = action;
	
	        var returnedValue = void 0;
	        if (logErrors) {
	          try {
	            returnedValue = next(action);
	          } catch (e) {
	            logEntry.error = errorTransformer(e);
	          }
	        } else {
	          returnedValue = next(action);
	        }
	
	        logEntry.took = _helpers.timer.now() - logEntry.started;
	        logEntry.nextState = stateTransformer(getState());
	
	        var diff = loggerOptions.diff && typeof diffPredicate === 'function' ? diffPredicate(getState, action) : loggerOptions.diff;
	
	        (0, _core.printBuffer)(logBuffer, _extends({}, loggerOptions, { diff: diff }));
	        logBuffer.length = 0;
	
	        if (logEntry.error) throw logEntry.error;
	        return returnedValue;
	      };
	    };
	  };
	}
	
	var defaultLogger = function defaultLogger() {
	  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      dispatch = _ref2.dispatch,
	      getState = _ref2.getState;
	
	  if (typeof dispatch === 'function' || typeof getState === 'function') {
	    return createLogger()({ dispatch: dispatch, getState: getState });
	  } else {
	    // eslint-disable-next-line no-console
	    console.error('\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from \'redux-logger\'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from \'redux-logger\'\n');
	  }
	};
	
	exports.defaults = _defaults2.default;
	exports.createLogger = createLogger;
	exports.logger = defaultLogger;
	exports.default = defaultLogger;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.intercomUpdate = exports.intercomOnMessage = exports.intercomShowMessenger = exports.intercomTrackEvent = exports.intercomShutdown = exports.intercomBoot = exports.intercomAPI = exports.intercomAvaliable = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _getClientConfig = __webpack_require__(48);
	
	var _getClientConfig2 = _interopRequireDefault(_getClientConfig);
	
	var _logger = __webpack_require__(128);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _analyticsConstants = __webpack_require__(165);
	
	var _timeUtil = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useIntercom = (0, _lodash.memoize)(function () {
	    return (0, _getClientConfig2.default)().analytics.enabled;
	});
	var intercomAvaliable = exports.intercomAvaliable = (0, _lodash.memoize)(function () {
	    return window.document && typeof window.Intercom !== 'undefined';
	});
	
	var intercomAPI = exports.intercomAPI = function intercomAPI(action) {
	    return function (data, metadata) {
	        _logger2.default.info('Analytics:', action, data, metadata);
	
	        if (!useIntercom()) return;
	        if (!intercomAvaliable()) return _logger2.default.warn('Intercom not initialized yet');
	        window.Intercom(action, data, metadata); // eslint-disable-line new-cap
	    };
	};
	
	var intercomBoot = exports.intercomBoot = intercomAPI(_analyticsConstants.INTERCOM_OPERATIONS.boot);
	var intercomShutdown = exports.intercomShutdown = intercomAPI(_analyticsConstants.INTERCOM_OPERATIONS.shutdown);
	var intercomTrackEvent = exports.intercomTrackEvent = intercomAPI(_analyticsConstants.INTERCOM_OPERATIONS.trackEvent);
	var intercomShowMessenger = exports.intercomShowMessenger = intercomAPI(_analyticsConstants.INTERCOM_OPERATIONS.show);
	var intercomOnMessage = exports.intercomOnMessage = intercomAPI(_analyticsConstants.INTERCOM_OPERATIONS.onUnreadCountChange);
	
	// Throttle intercom updates so we don't get throttled by them.
	// Prod is on an Intercom SPA beta program with a much higher rate limit
	var intercomUpdateAction = intercomAPI(_analyticsConstants.INTERCOM_OPERATIONS.update);
	var intercomUpdate = exports.intercomUpdate = (0, _lodash.debounce)(intercomUpdateAction, _timeUtil.TIMES.SECOND * (0, _getClientConfig2.default)().analytics.debounceTimeSeconds, { maxWait: _timeUtil.TIMES.SECOND * (0, _getClientConfig2.default)().analytics.debounceMaxWaitSeconds });

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LOGIN_FORM_FIELDS = exports.LOGIN_FORM_NAME = undefined;
	
	var _validationConstants = __webpack_require__(36);
	
	var LOGIN_FORM_NAME = exports.LOGIN_FORM_NAME = 'login'; // Constants
	var LOGIN_FORM_FIELDS = exports.LOGIN_FORM_FIELDS = _validationConstants.LOGIN_FIELDS;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.REGISTER_FORM_FIELDS = exports.REGISTER_FORM_NAME = undefined;
	
	var _validationConstants = __webpack_require__(36);
	
	var REGISTER_FORM_NAME = exports.REGISTER_FORM_NAME = 'register'; // Constants
	var REGISTER_FORM_FIELDS = exports.REGISTER_FORM_FIELDS = _validationConstants.REGISTER_FIELDS;

/***/ }),
/* 293 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CAPTION_EDITOR_KEY = exports.CAPTION_EDITOR_KEY = 'CAPTION';

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(9);
	
	var _colorHelper = __webpack_require__(319);
	
	__webpack_require__(1136);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Utils
	var ColorBar = function ColorBar(_ref) {
	    var colorName = _ref.colorName;
	
	    // Don't show the colour bar if the colour name is not provided
	    if (!colorName) return null;
	
	    // Otherwise convert the colour name to a hex value and render the bar
	    var hexValue = (0, _colorHelper.getColorHexValue)(colorName);
	    var style = {
	        backgroundColor: hexValue
	    };
	
	    return _react2.default.createElement('div', { className: 'ColorBar', style: style });
	};
	
	// Styles
	// Lib
	
	
	ColorBar.propTypes = {
	    colorName: _propTypes2.default.string
	};
	
	exports.default = (0, _recompose.onlyUpdateForPropTypes)(ColorBar);

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.KEY_CODES = exports.Icon = exports.stopPropagationOnly = undefined;
	
	var _domUtil = __webpack_require__(107);
	
	Object.defineProperty(exports, 'stopPropagationOnly', {
	  enumerable: true,
	  get: function get() {
	    return _domUtil.stopPropagationOnly;
	  }
	});
	
	var _keyConstants = __webpack_require__(146);
	
	Object.defineProperty(exports, 'KEY_CODES', {
	  enumerable: true,
	  get: function get() {
	    return _keyConstants.KEY_CODES;
	  }
	});
	
	var _Icon2 = __webpack_require__(11);
	
	var _Icon3 = _interopRequireDefault(_Icon2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Icon = _Icon3.default;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(4);
	
	var _rollbarService = __webpack_require__(226);
	
	var _formActions = __webpack_require__(434);
	
	var _logger = __webpack_require__(128);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _errorConstants = __webpack_require__(243);
	
	var _rollbarConstants = __webpack_require__(420);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Constants
	
	
	// Actions
	// Utils
	exports.default = function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState,
	        form = _ref.form,
	        _ref$reportError = _ref.reportError,
	        reportError = _ref$reportError === undefined ? true : _ref$reportError,
	        sensitive = _ref.sensitive;
	    return function (err) {
	        var errorMessage = form + ' submission error';
	        _logger2.default.error(errorMessage, err, err.response);
	
	        if (!err.response) return Promise.reject(err);
	
	        var errorCode = (0, _lodash.get)(err, 'response.code');
	        var error = (0, _lodash.get)(err, 'response.data.error');
	        var isClientValidationError = error && error.code === _errorConstants.RESPONSE_ERROR.VALIDATION_FAILURE;
	
	        // Notify rollbar
	        var level = isClientValidationError ? _rollbarConstants.ROLLBAR_LEVELS.WARNING : _rollbarConstants.ROLLBAR_LEVELS.ERROR;
	        reportError && (0, _rollbarService.manuallyReportError)({ errorMessage: errorMessage, error: err, sensitive: sensitive, level: level, getState: getState });
	
	        var primaryError = undefined;
	        var errorRes = undefined;
	
	        // On validation errors respond with a structure that the form can react to
	        // But don't show any primary error message to the user
	        if (isClientValidationError) {
	            errorRes = error.details;
	        } else {
	            // Need to report these errors to Rollbar and also show the a primary error message on the form.
	            errorRes = err;
	            primaryError = {
	                message: (0, _lodash.get)(error, 'message') || 'Something went wrong, please try again'
	            };
	        }
	
	        dispatch((0, _formActions.formSubmissionFailed)({
	            form: form,
	            primaryError: primaryError,
	            errorCode: errorCode,
	            reportError: reportError
	        }));
	
	        return Promise.reject(errorRes);
	    };
	};

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Spinner = __webpack_require__(65);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _FlexCenter = __webpack_require__(198);
	
	var _FlexCenter2 = _interopRequireDefault(_FlexCenter);
	
	__webpack_require__(1163);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProcessingPage = function ProcessingPage(_ref) {
	    var children = _ref.children,
	        className = _ref.className;
	    return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('ProcessingPage', className) },
	        _react2.default.createElement(
	            _FlexCenter2.default,
	            null,
	            _react2.default.createElement(_Spinner2.default, { show: true }),
	            children
	        )
	    );
	};
	
	ProcessingPage.propTypes = {
	    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array, _propTypes2.default.string]),
	    className: _propTypes2.default.string
	};
	
	exports.default = ProcessingPage;

/***/ }),
/* 298 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ENABLE_DEBUG_TOOLS = exports.ENABLE_DEBUG_TOOLS = 'ENABLE_DEBUG_TOOLS';
	var DEBUG_TOOL_TOGGLE = exports.DEBUG_TOOL_TOGGLE = 'TOGGLE_DEBUG_TOOL';
	
	var DEBUG_LOCAL_STORAGE_KEY = exports.DEBUG_LOCAL_STORAGE_KEY = 'milanote.debug';

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.isDebugEnabled = exports.enableDebug = exports.shouldEnableDebugFeatures = undefined;
	
	var _localStorage = __webpack_require__(314);
	
	var _localStorage2 = _interopRequireDefault(_localStorage);
	
	var _debugConstants = __webpack_require__(298);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Services
	var shouldEnableDebugFeatures = exports.shouldEnableDebugFeatures = function shouldEnableDebugFeatures() {
	    return _localStorage2.default.getItem(_debugConstants.DEBUG_LOCAL_STORAGE_KEY);
	};
	
	// Constants
	
	
	var debugEnabled = false;
	
	var enableDebug = exports.enableDebug = function enableDebug() {
	    debugEnabled = true;
	};
	
	var isDebugEnabled = exports.isDebugEnabled = function isDebugEnabled() {
	    return debugEnabled;
	};

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _predicates = __webpack_require__(2294);
	
	var _predicates2 = _interopRequireDefault(_predicates);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    var predicateArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    var runPredicates = (0, _predicates2.default)(predicateArray);
	    return function (props, monitor) {
	        return runPredicates({ props: props, monitor: monitor });
	    };
	}; // Utils

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _elementHelper = __webpack_require__(13);
	
	exports.default = function (_ref) {
	    var monitor = _ref.monitor;
	
	    var item = monitor.getItem();
	    return !item.element || !item.draggedElements.every(_elementHelper.isLine);
	}; // Utils

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.moveMultipleElements = exports.updateLocation = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _undoRedoTransactionManager = __webpack_require__(86);
	
	var _scoreCalculator = __webpack_require__(794);
	
	var _elementHelper = __webpack_require__(13);
	
	var _resourceUtil = __webpack_require__(108);
	
	var _timeUtil = __webpack_require__(43);
	
	var _elementUtil = __webpack_require__(105);
	
	var _immutableHelper = __webpack_require__(23);
	
	var _sortUtil = __webpack_require__(2297);
	
	var _elementSelector = __webpack_require__(41);
	
	var _boardSelector = __webpack_require__(83);
	
	var _inboxActions = __webpack_require__(305);
	
	var _elementConstants = __webpack_require__(12);
	
	var TYPES = _interopRequireWildcard(_elementConstants);
	
	var _elementsConstants = __webpack_require__(322);
	
	var ELEMENTS_ACTION_TYPE = _interopRequireWildcard(_elementsConstants);
	
	var _boardConstants = __webpack_require__(17);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Base actions
	
	
	// Actions
	
	
	// Selectors
	
	
	// Utils
	var moveMultipleElementsAction = function moveMultipleElementsAction(_ref) {
	    var moves = _ref.moves,
	        _ref$sync = _ref.sync,
	        sync = _ref$sync === undefined ? true : _ref$sync,
	        _ref$transactionId = _ref.transactionId,
	        transactionId = _ref$transactionId === undefined ? (0, _undoRedoTransactionManager.getNewTransactionId)() : _ref$transactionId;
	    return {
	        type: TYPES.ELEMENT_MOVE_MULTI,
	        moves: moves,
	        sync: sync,
	        modified: (0, _timeUtil.getTimestamp)(),
	        transactionId: transactionId
	    };
	};
	
	// Constants
	// Lib
	
	
	var getFromLocation = function getFromLocation(initialState, elementId) {
	    var initialElementState = (0, _elementSelector.getElement)(initialState, { elementId: elementId });
	    return initialElementState.get('location').toJS();
	};
	
	var addFromLocation = function addFromLocation(initialState) {
	    return function (move) {
	        move.from = getFromLocation(initialState, move.id);
	        return move;
	    };
	};
	
	var getMoveScoreGroupKey = function getMoveScoreGroupKey(move) {
	    return move.location.parentId + '.' + move.location.position.index;
	};
	
	var moveRequiresScoreCalculation = function moveRequiresScoreCalculation(elements, boardResourcesState) {
	    return function (move) {
	        // elements and then increment by that amount for each element
	        var location = move.location;
	        // If the move is not to an inbox, then it doesn't need any complex calculations and can fire immediately
	
	        if (location.section !== _boardConstants.BOARD_SECTIONS.INBOX) return false;
	
	        // If it already has a score, use it rather than calculate it again (useful when undoing)
	        if (location.position.score != null) return false; // eslint-disable-line eqeqeq
	
	        // check to see if we have access to the children of the board that's having a child added to its inbox
	        var parentBoardResource = boardResourcesState.get(location.parentId);
	        var parent = elements.get(location.parentId);
	
	        // If we don't have it, then we can't calculate the score of the new item, so we just leave it as null for the
	        // server to take care of
	        if (!parent || (0, _elementHelper.isBoard)(parent) && !(0, _resourceUtil.isFetched)(parentBoardResource)) return false;
	
	        return true;
	    };
	};
	
	var resetScores = function resetScores(_ref2) {
	    var parentId = _ref2.parentId,
	        section = _ref2.section;
	    return {
	        type: ELEMENTS_ACTION_TYPE.ELEMENTS_RESET_SCORES,
	        parentId: parentId,
	        section: section,
	        sync: true
	    };
	};
	
	var getGroupScores = function getGroupScores(getState, moveGroup) {
	    var state = getState();
	    var elements = state.get('elements');
	
	    var location = moveGroup[0].location;
	    var inboxElements = (0, _elementHelper.getSortedChildrenInSection)(elements, location.section, location.parentId);
	
	    var currentScores = inboxElements.map((0, _immutableHelper.propIn)(['location', 'position', 'score'])).sort(_sortUtil.numbersAscending).toJS();
	
	    return (0, _scoreCalculator.getNewScores)(currentScores, location.position.index, moveGroup.length);
	};
	
	var buildScoreMap = function buildScoreMap(dispatch, getState) {
	    return function (moves) {
	        var state = getState();
	        var elements = state.get('elements');
	        var boardResourcesState = (0, _boardSelector.boardResourcesSelector)(state);
	
	        var movesRequiringScoreCalculation = moves.filter(moveRequiresScoreCalculation(elements, boardResourcesState));
	
	        // Group moves by parentId.index
	        var groupedMoves = (0, _lodash.groupBy)(movesRequiringScoreCalculation, getMoveScoreGroupKey);
	
	        // Calculate the scores for each one of those groups
	        return (0, _lodash.mapValues)(groupedMoves, function (moveGroup) {
	            var newScores = getGroupScores(getState, moveGroup);
	
	            // If the score is null a collision has occurred, so we need to refresh all elements scores before attempting
	            // to insert this new / moved element
	            if (newScores == null) {
	                // eslint-disable-line eqeqeq
	                dispatch(resetScores(location));
	
	                // Try to calculate the scores again
	                newScores = getGroupScores(getState, moveGroup) || [];
	            }
	
	            return {
	                currentIndex: 0,
	                newScores: newScores
	            };
	        });
	    };
	};
	
	/**
	 * Updates the location object with a score if necessary.
	 * This will happen when the location is within the INBOX section.  The index of the element will relate to a score
	 * which will enforce the ordering between cards.
	 *
	 * If a score collision happens (i.e. two elements end up with the same score) this method will also dispatch the
	 * 'ELEMENTS_RESET_SCORES' action which will recalculate the scores for every element and then attempt to calculate the
	 * score again.
	 */
	var updateLocation = exports.updateLocation = function updateLocation(dispatch, getState) {
	    return function (moves) {
	        var scoreMap = buildScoreMap(dispatch, getState)(moves);
	
	        var state = getState();
	        var elements = state.get('elements');
	        var boardResourcesState = (0, _boardSelector.boardResourcesSelector)(state);
	
	        return function (move) {
	            if (!moveRequiresScoreCalculation(elements, boardResourcesState)(move)) return move;
	
	            var scoreMapKey = getMoveScoreGroupKey(move);
	            var scoreEntry = scoreMap[scoreMapKey];
	            var _scoreEntry$currentIn = scoreEntry.currentIndex,
	                currentIndex = _scoreEntry$currentIn === undefined ? 0 : _scoreEntry$currentIn,
	                _scoreEntry$newScores = scoreEntry.newScores,
	                newScores = _scoreEntry$newScores === undefined ? [] : _scoreEntry$newScores;
	
	            (0, _lodash.set)(move, 'location.position.score', newScores[currentIndex]);
	            (0, _lodash.set)(scoreEntry, 'currentIndex', currentIndex + 1);
	
	            return move;
	        };
	    };
	};
	
	/**
	 * Ensures that a move won't result in a recursive structure.
	 * NOTE: This only checks the initial state, not the end state! It would be possible to
	 * configure a move such that a recursive structure was possible.
	 */
	var checkMoveSafety = function checkMoveSafety(state) {
	    return function (move) {
	        var elements = (0, _elementSelector.getElements)(state);
	        var ancestorIds = (0, _elementUtil.getPhysicalAncestorIds)(elements, move.location.parentId);
	
	        // If the moved element exists in the ancestors of the
	        var isSafeMove = !(0, _lodash.includes)(ancestorIds, move.id);
	        if (!isSafeMove) {
	            console.warn("Paradox: Unable to perform move as the moved element exists in the location's ancestry.", move);
	        }
	        return isSafeMove;
	    };
	};
	
	/**
	 * If the move being performed doesn't actually change anything (i.e. an element is dropped onto the same position
	 * in a list) then don't perform the move, as it's a wasted effort.
	 */
	var shouldMove = function shouldMove(state) {
	    return function (move, order) {
	        var id = move.id,
	            location = move.location;
	
	        // Can't move an element that we don't know about
	
	        var element = (0, _elementSelector.getElement)(state, { elementId: id });
	        if (!element) return false;
	
	        if (location.section !== _boardConstants.BOARD_SECTIONS.INBOX) return true;
	
	        var elements = (0, _elementSelector.getElements)(state);
	        var inboxElements = (0, _elementHelper.getSortedChildrenInSection)(elements, location.section, location.parentId);
	
	        // The final index is the dropped location plus the order that the element is in when it's moved.
	        var finalIndex = location.position.index + order;
	        var elementAtIndex = inboxElements.get(finalIndex);
	
	        return elementAtIndex ? elementAtIndex.get('id') !== id : true;
	    };
	};
	
	/**
	 * Dispatches a move event for an element, given the location to move the element to.
	 * The location's position will be updated with a 'score' if necessary.
	 */
	var moveMultipleElements = exports.moveMultipleElements = function moveMultipleElements(_ref3) {
	    var moves = _ref3.moves,
	        _ref3$sync = _ref3.sync,
	        sync = _ref3$sync === undefined ? true : _ref3$sync,
	        _ref3$transactionId = _ref3.transactionId,
	        transactionId = _ref3$transactionId === undefined ? (0, _undoRedoTransactionManager.getNewTransactionId)() : _ref3$transactionId;
	    return function (dispatch, getState) {
	        // Add the from location to the moves
	        var initialState = getState();
	
	        var isSafeMultiMove = moves.every(checkMoveSafety(initialState));
	        if (!isSafeMultiMove) {
	            // TODO Dispatch a warning action that displays a message explaining why the move failed
	            console.warn('Preventing moves as a paradox will occur.');
	            return;
	        }
	
	        var updatedMoves = moves.filter(shouldMove(initialState))
	        // NOTE: This assumes that all moves are going to the same parentId & section.  If this assumption becomes
	        //  incorrect, further work will need to be done here
	        .map(updateLocation(dispatch, getState)(moves)).map(addFromLocation(initialState));
	
	        // If we no longer need to perform any moves, just finish
	        if (!updatedMoves.length) return;
	
	        dispatch(moveMultipleElementsAction({ moves: updatedMoves, sync: sync, transactionId: transactionId }));
	
	        // if you're dropping on a board that isn't the current one, open up it's unsorted notes
	        dispatch((0, _inboxActions.setInboxFromMultiElementMove)({ moves: updatedMoves, transactionId: transactionId }));
	    };
	};

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lodash = __webpack_require__(4);
	
	var _elementUtil = __webpack_require__(105);
	
	var _EdgeDragHandle = __webpack_require__(735);
	
	var _EdgeDragHandle2 = _interopRequireDefault(_EdgeDragHandle);
	
	var _ConnectedEdgeDragHandle = __webpack_require__(1988);
	
	var _ConnectedEdgeDragHandle2 = _interopRequireDefault(_ConnectedEdgeDragHandle);
	
	var _ControlPointDragHandle = __webpack_require__(733);
	
	var _ControlPointDragHandle2 = _interopRequireDefault(_ControlPointDragHandle);
	
	var _ConnectedControlPointDragHandle = __webpack_require__(1987);
	
	var _ConnectedControlPointDragHandle2 = _interopRequireDefault(_ConnectedControlPointDragHandle);
	
	var _LineSvg = __webpack_require__(1997);
	
	var _LineSvg2 = _interopRequireDefault(_LineSvg);
	
	var _ElementUserTag = __webpack_require__(203);
	
	var _ElementUserTag2 = _interopRequireDefault(_ElementUserTag);
	
	var _lineConstants = __webpack_require__(57);
	
	__webpack_require__(1214);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	// Utils
	
	
	// Components
	
	
	// Constant
	
	
	// Styles
	
	
	var Line = function (_React$Component) {
	    _inherits(Line, _React$Component);
	
	    function Line() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Line);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Line.__proto__ || Object.getPrototypeOf(Line)).call.apply(_ref, [this].concat(args))), _this), _this.checkHitArea = function (event) {
	            var target = event.target;
	
	            // TODO this.line && this.hitArea aren't doing anything at the moment
	            // If the hit area is clicked then don't prevent or stop anything - allow the propagation to continue
	            // onto the draggable element which will handle the dragging
	
	            if (target === _this.hitArea || target === _this.line || target === _reactDom2.default.findDOMNode(_this.startDragHandle) || target === _reactDom2.default.findDOMNode(_this.endDragHandle) || target === _reactDom2.default.findDOMNode(_this.controlPointData)) return;
	
	            event.preventDefault();
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Line, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.disableDrag && this.props.disableDrag();
	        }
	
	        /**
	         * Used to prevent dragging from occurring when clicking the space surrounding the arrow.
	         */
	
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                elementId = _props.elementId,
	                elementEvents = _props.elementEvents,
	                isSelected = _props.isSelected,
	                colorHex = _props.colorHex,
	                isPresentational = _props.isPresentational,
	                start = _props.start,
	                end = _props.end,
	                updateLineEdge = _props.updateLineEdge,
	                gridSize = _props.gridSize,
	                toggleLineVisibility = _props.toggleLineVisibility,
	                startStyle = _props.startStyle,
	                endStyle = _props.endStyle,
	                isRemotelySelected = _props.isRemotelySelected,
	                updateLineControlPoint = _props.updateLineControlPoint,
	                controlPoint = _props.controlPoint,
	                enableDrag = _props.enableDrag,
	                disableDrag = _props.disableDrag,
	                startConnectionRect = _props.startConnectionRect,
	                endConnectionRect = _props.endConnectionRect,
	                element = _props.element,
	                startSnapped = _props.startSnapped,
	                endSnapped = _props.endSnapped,
	                startEdgeOrigin = _props.startEdgeOrigin,
	                endEdgeOrigin = _props.endEdgeOrigin,
	                dragModifierKeys = _props.dragModifierKeys;
	
	
	            if ((0, _lodash.isEmpty)(start) || (0, _lodash.isEmpty)(end)) return null;
	
	            var classes = (0, _elementUtil.elementClassNames)('Line', this.props);
	
	            var color = isRemotelySelected ? null : colorHex;
	
	            return _react2.default.createElement(
	                'div',
	                { id: (0, _elementUtil.getDomElementId)(elementId), className: classes, onMouseDown: this.checkHitArea },
	                _react2.default.createElement(_ElementUserTag2.default, _extends({}, this.props, { top: controlPoint.y, left: controlPoint.x })),
	                _react2.default.createElement(_EdgeDragHandle2.default, { pos: start, show: isSelected, snapped: startSnapped }),
	                _react2.default.createElement(_EdgeDragHandle2.default, { pos: end, show: isSelected, snapped: endSnapped }),
	                _react2.default.createElement(_ControlPointDragHandle2.default, { pos: controlPoint, color: color, show: isSelected }),
	                _react2.default.createElement(_LineSvg2.default, { elementId: elementId, elementEvents: elementEvents, start: start, end: end,
	                    controlPoint: controlPoint, isPresentational: isPresentational,
	                    startStyle: startStyle, endStyle: endStyle, gridSize: gridSize,
	                    colorHex: color, idSuffix: isPresentational ? 'drag' : null,
	                    disableDrag: disableDrag, enableDrag: enableDrag }),
	                _react2.default.createElement(_ConnectedEdgeDragHandle2.default, { edge: _lineConstants.LINE_EDGE.start, pos: start, show: isSelected && !isPresentational,
	                    updateLineEdge: updateLineEdge, gridSize: gridSize, toggleLineVisibility: toggleLineVisibility,
	                    dragModifierKeys: dragModifierKeys,
	                    element: element, origin: endEdgeOrigin, elementId: elementId,
	                    ref: function ref(component) {
	                        _this2.startDragHandle = component;
	                    } }),
	                _react2.default.createElement(_ConnectedEdgeDragHandle2.default, { edge: _lineConstants.LINE_EDGE.end, pos: end, show: isSelected && !isPresentational,
	                    updateLineEdge: updateLineEdge, gridSize: gridSize, toggleLineVisibility: toggleLineVisibility,
	                    dragModifierKeys: dragModifierKeys,
	                    element: element, origin: startEdgeOrigin, elementId: elementId,
	                    ref: function ref(component) {
	                        _this2.endDragHandle = component;
	                    } }),
	                _react2.default.createElement(_ConnectedControlPointDragHandle2.default, { controlPoint: controlPoint,
	                    startEdgeOrigin: startEdgeOrigin, endEdgeOrigin: endEdgeOrigin, color: color,
	                    toggleLineVisibility: toggleLineVisibility, gridSize: gridSize, element: element,
	                    updateLineControlPoint: updateLineControlPoint, elementId: elementId,
	                    ref: function ref(component) {
	                        _this2.controlPointData = component;
	                    },
	                    startConnectionRect: startConnectionRect, endConnectionRect: endConnectionRect,
	                    show: isSelected && !isPresentational })
	            );
	        }
	    }]);
	
	    return Line;
	}(_react2.default.Component);
	
	Line.propTypes = {
	    element: _propTypes2.default.object,
	    elementId: _propTypes2.default.string.isRequired,
	    elementEvents: _propTypes2.default.object,
	    isSelected: _propTypes2.default.bool,
	    isPresentational: _propTypes2.default.bool,
	    colorHex: _propTypes2.default.string,
	    start: _propTypes2.default.object,
	    end: _propTypes2.default.object,
	    updateLineEdge: _propTypes2.default.func,
	    updateLineControlPoint: _propTypes2.default.func,
	    toggleLineVisibility: _propTypes2.default.func,
	    gridSize: _propTypes2.default.number,
	    startStyle: _propTypes2.default.string,
	    endStyle: _propTypes2.default.string,
	    isRemotelySelected: _propTypes2.default.bool,
	    startSnapped: _propTypes2.default.bool,
	    endSnapped: _propTypes2.default.bool,
	    startEdgeOrigin: _propTypes2.default.object,
	    endEdgeOrigin: _propTypes2.default.object,
	    controlPoint: _propTypes2.default.object,
	    enableDrag: _propTypes2.default.func,
	    disableDrag: _propTypes2.default.func,
	    startConnectionRect: _propTypes2.default.object,
	    endConnectionRect: _propTypes2.default.object,
	    dragModifierKeys: _propTypes2.default.object
	};
	
	exports.default = Line;

/***/ }),
/* 304 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var RICH_MEDIA_RETURN_TO_PREVIEW = exports.RICH_MEDIA_RETURN_TO_PREVIEW = 'RICH_MEDIA_RETURN_TO_PREVIEW';
	var RICH_MEDIA_EMBEDDING = exports.RICH_MEDIA_EMBEDDING = 'RICH_MEDIA_EMBEDDING';
	var RICH_MEDIA_READY = exports.RICH_MEDIA_READY = 'RICH_MEDIA_READY';
	var RICH_MEDIA_ERROR = exports.RICH_MEDIA_ERROR = 'RICH_MEDIA_ERROR';
	
	var RICH_MEDIA_STATE = exports.RICH_MEDIA_STATE = {
	    PREVIEW: 'PREVIEW',
	    EMBEDDING: 'EMBEDDING',
	    READY: 'READY',
	    ERROR: 'ERROR'
	};

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setInboxFromElementCreate = exports.setInboxFromMultiElementMove = exports.closeInbox = exports.openInbox = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _elementHelper = __webpack_require__(13);
	
	var _undoRedoTransactionManager = __webpack_require__(86);
	
	var _elementActions = __webpack_require__(26);
	
	var _inboxConstants = __webpack_require__(234);
	
	var _boardConstants = __webpack_require__(17);
	
	// Constants
	// Lib
	var openInbox = exports.openInbox = function openInbox(_ref) {
	    var id = _ref.id,
	        _ref$sync = _ref.sync,
	        sync = _ref$sync === undefined ? true : _ref$sync,
	        _ref$transactionId = _ref.transactionId,
	        transactionId = _ref$transactionId === undefined ? (0, _undoRedoTransactionManager.getNewTransactionId)() : _ref$transactionId;
	    return (0, _elementActions.updateElement)({
	        id: id,
	        changes: {
	            inbox: _inboxConstants.INBOX_STATE.OPEN
	        },
	        sync: sync,
	        transactionId: transactionId
	    });
	};
	
	// Util
	var closeInbox = exports.closeInbox = function closeInbox(_ref2) {
	    var id = _ref2.id,
	        _ref2$sync = _ref2.sync,
	        sync = _ref2$sync === undefined ? true : _ref2$sync,
	        _ref2$transactionId = _ref2.transactionId,
	        transactionId = _ref2$transactionId === undefined ? (0, _undoRedoTransactionManager.getNewTransactionId)() : _ref2$transactionId;
	    return (0, _elementActions.updateElement)({
	        id: id,
	        changes: {
	            inbox: _inboxConstants.INBOX_STATE.CLOSED
	        },
	        sync: sync,
	        transactionId: transactionId
	    });
	};
	
	// --------------------------------------------------
	// logic for if we shoud open inbox on element move
	// --------------------------------------------------
	
	var shouldCloseCurrentBoardInbox = function shouldCloseCurrentBoardInbox(toLocation, fromLocation, state) {
	    if (fromLocation.section !== _boardConstants.BOARD_SECTIONS.INBOX) return false;
	
	    // never close the inbox if you're dragging to the inbox
	    if (fromLocation.parentId === toLocation.parentId && toLocation.section === _boardConstants.BOARD_SECTIONS.INBOX) return false;
	
	    // in inbox is already closed, don't close it again
	    var currentParentEl = state.get('elements').get(fromLocation.parentId);
	    if (currentParentEl && currentParentEl.get('content').get('inbox') === _inboxConstants.INBOX_STATE.CLOSED) return false;
	
	    var currentInboxChildren = (0, _elementHelper.getChildrenInSection)((0, _elementHelper.getChildren)(state.get('elements'), fromLocation.parentId), _boardConstants.BOARD_SECTIONS.INBOX);
	
	    // if there's still chidren in the current inbox, don't do anything
	    if (currentInboxChildren.size > 0) return false;
	
	    return true;
	};
	
	var shouldOpenTargetInbox = function shouldOpenTargetInbox(tolocation, fromLocation, state) {
	    // never open up inbox if you're moving to canvas
	    if (tolocation.section === _boardConstants.BOARD_SECTIONS.CANVAS) return false;
	
	    // never open up the inbox automatically if you're on the same parent
	    if (fromLocation.parentId === tolocation.parentId) return false;
	
	    // trash doesn't have an inbox!
	    if (tolocation.parentId.indexOf('trash') !== -1) return false;
	
	    var parentEl = state.get('elements').get(tolocation.parentId);
	
	    // if inbox is already open, don't open it again
	    if (parentEl && parentEl.get('content').get('inbox') === _inboxConstants.INBOX_STATE.OPEN) return false;
	
	    return true;
	};
	
	/**
	 * Performs a multi-update which includes any of the inbox state changes that should occur as a result of the moves.
	 */
	var setInboxFromMultiElementMove = exports.setInboxFromMultiElementMove = function setInboxFromMultiElementMove(_ref3) {
	    var moves = _ref3.moves,
	        _ref3$transactionId = _ref3.transactionId,
	        transactionId = _ref3$transactionId === undefined ? (0, _undoRedoTransactionManager.getNewTransactionId)() : _ref3$transactionId;
	    return function (dispatch, getState) {
	        var state = getState();
	
	        // Determine the inbox state changes that need to be made as a result of the moves
	        var inboxStateMap = moves.reduce(function (inboxMap, move) {
	            var fromLocation = move.from;
	            var toLocation = move.location;
	
	            if (shouldCloseCurrentBoardInbox(toLocation, fromLocation, state)) {
	                inboxMap[fromLocation.parentId] = _inboxConstants.INBOX_STATE.CLOSED;
	            }
	            if (shouldOpenTargetInbox(toLocation, fromLocation, state)) {
	                inboxMap[toLocation.parentId] = _inboxConstants.INBOX_STATE.OPEN;
	            }
	            return inboxMap;
	        }, {});
	
	        // Build an array of updates given the inbox state changes that need to be made
	        var inboxUpdates = (0, _lodash.map)(inboxStateMap, function (inboxState, id) {
	            return {
	                id: id,
	                changes: {
	                    inbox: inboxState
	                }
	            };
	        });
	
	        // If there's no updates, then don't dispatch the action.
	        if (inboxUpdates.length === 0) return;
	
	        dispatch((0, _elementActions.updateMultipleElements)({ updates: inboxUpdates, transactionId: transactionId }));
	    };
	};
	
	// --------------------------------------------------
	// logic for if we should open inbox on element create
	// --------------------------------------------------
	
	var shouldOpenInboxFromElementCreate = function shouldOpenInboxFromElementCreate(toLocation, state) {
	    var parentId = toLocation.parentId,
	        section = toLocation.section;
	
	    // don't open the inbox if we aren't creating something in the inbox
	
	    if (section !== _boardConstants.BOARD_SECTIONS.INBOX) return false;
	
	    var parentEl = state.get('elements').get(parentId);
	
	    // if inbox is already open, don't open it again
	    if (parentEl && parentEl.get('content').get('inbox') === _inboxConstants.INBOX_STATE.OPEN) return false;
	
	    return true;
	};
	
	var setInboxFromElementCreate = exports.setInboxFromElementCreate = function setInboxFromElementCreate(_ref4) {
	    var location = _ref4.location,
	        _ref4$transactionId = _ref4.transactionId,
	        transactionId = _ref4$transactionId === undefined ? (0, _undoRedoTransactionManager.getNewTransactionId)() : _ref4$transactionId;
	    return function (dispatch, getState) {
	        var shouldOpenInbox = shouldOpenInboxFromElementCreate(location, getState());
	        if (shouldOpenInbox) dispatch(openInbox({ id: location.parentId, transactionId: transactionId }));
	    };
	};

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getCurrentBoardId = exports.getIsCurrentBoardIdInitialised = undefined;
	
	var _currentBoardIdConstants = __webpack_require__(461);
	
	var getIsCurrentBoardIdInitialised = exports.getIsCurrentBoardIdInitialised = function getIsCurrentBoardIdInitialised(state) {
	    return state.getIn(['app', 'currentBoardId']) !== _currentBoardIdConstants.UNINITIALISED;
	}; // Constants
	var getCurrentBoardId = exports.getCurrentBoardId = function getCurrentBoardId(state) {
	    return getIsCurrentBoardIdInitialised(state) ? state.getIn(['app', 'currentBoardId']) : null;
	};

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.BATCH_ACTION_TYPE = exports.enableReducerBatching = exports.bulkingMiddleware = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _reduxBatchMiddleware = __webpack_require__(1619);
	
	var createDefaultIsBulkableAction = function createDefaultIsBulkableAction(_ref) {
	    var _ref$bulkActionTypes = _ref.bulkActionTypes,
	        bulkActionTypes = _ref$bulkActionTypes === undefined ? [] : _ref$bulkActionTypes;
	    return function (action) {
	        return (0, _lodash.includes)(bulkActionTypes, action.type);
	    };
	};
	
	/**
	 * Must be used in conjunction with redux-batch-middleware: https://github.com/mrydengren/redux-batch-middleware
	 *
	 * This allows specific actions to be debounced and batched together so they are dispatched as a single state update.
	 */
	var bulkingMiddleware = exports.bulkingMiddleware = function bulkingMiddleware() {
	    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return function (store) {
	        return function (next) {
	            var _config$debounceWait = config.debounceWait,
	                debounceWait = _config$debounceWait === undefined ? 0 : _config$debounceWait,
	                debounceOptions = config.debounceOptions;
	
	            var isBulkableAction = config.isBulkableAction || createDefaultIsBulkableAction(config);
	            var batchMiddleware = (0, _reduxBatchMiddleware.batch)(store)(next);
	
	            var bulkAction = [];
	
	            var addToBulkAction = function addToBulkAction(action) {
	                bulkAction.push(action);
	            };
	
	            var dispatchBulkAction = function dispatchBulkAction() {
	                var bulkActionToDispatch = bulkAction;
	                bulkAction = [];
	                return batchMiddleware(bulkActionToDispatch);
	            };
	
	            var debouncedBulkActionDispatch = (0, _lodash.debounce)(dispatchBulkAction, debounceWait, debounceOptions);
	
	            return function (action) {
	                if (!isBulkableAction(action)) return batchMiddleware(action);
	
	                addToBulkAction(action);
	                return debouncedBulkActionDispatch();
	            };
	        };
	    };
	};
	
	var enableReducerBatching = exports.enableReducerBatching = _reduxBatchMiddleware.batching;
	
	var BATCH_ACTION_TYPE = exports.BATCH_ACTION_TYPE = _reduxBatchMiddleware.type;

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.unsubscribeSelector = exports.paymentFormValuesSelector = exports.paymentSelector = exports.couponSelector = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _lodash = __webpack_require__(4);
	
	var _reselect = __webpack_require__(7);
	
	var _currentUserSelector = __webpack_require__(33);
	
	var _paymentUtil = __webpack_require__(244);
	
	var _teamManagementSelectors = __webpack_require__(463);
	
	var CARD_DEFAULT = {
	    name: ' ',
	    number: '•••• •••• •••• ••••',
	    expiry: '••/••',
	    cvc: '•••',
	    postCode: ' ',
	    cardPrefilled: true
	};
	
	var getPaymentModal = function getPaymentModal(state) {
	    return state.getIn(['app', 'modal', 'payment']);
	};
	
	var customerSelector = (0, _reselect.createSelector)(_currentUserSelector.getCurrentUser, function (currentUser) {
	    return currentUser.get('customer');
	});
	
	var subscriptionSelector = (0, _reselect.createSelector)(customerSelector, function (customer) {
	    return customer && customer.getIn(['subscriptions', 'data']) && customer.getIn(['subscriptions', 'data']).first();
	});
	
	var couponSelector = exports.couponSelector = (0, _reselect.createSelector)(subscriptionSelector, getPaymentModal, function (subscription, paymentModal) {
	    return paymentModal.get('coupon') || subscription && subscription.getIn(['discount', 'coupon']);
	});
	
	var cardSelector = (0, _reselect.createSelector)(_currentUserSelector.getCurrentUser, customerSelector, function (currentUser, customer) {
	    if (!customer && currentUser && currentUser.get('customerId')) return CARD_DEFAULT;
	    if (customer && customer.get('fetching')) return CARD_DEFAULT;
	
	    if (customer && !customer.get('fetching')) {
	        var card = customer.getIn(['sources', 'data']) && customer.getIn(['sources', 'data']).first();
	        if (!card) return {};
	
	        var last4 = card.get('last4');
	        var expMonth = (0, _lodash.padStart)(card.get('exp_month'), 2, '0');
	        var expYear = card.get('exp_year').toString().substr(2);
	        var brand = card.get('brand').toLowerCase();
	
	        var cardName = card.get('name');
	        var postcode = card.get('address_zip');
	
	        return _extends({}, CARD_DEFAULT, {
	            number: (0, _paymentUtil.describeCardNumber)(last4),
	            expiry: expMonth + '/' + expYear,
	            cardName: cardName,
	            postcode: postcode,
	            brand: brand
	        });
	    }
	
	    return {};
	});
	
	var paymentSelector = exports.paymentSelector = (0, _reselect.createSelector)(_currentUserSelector.getCurrentUser, getPaymentModal, customerSelector, subscriptionSelector, _teamManagementSelectors.selectedTeamMemberIdsSelector, couponSelector, function (currentUser, paymentModal, customer, subscription, teamMemberIds, coupon) {
	    return {
	        currentUser: currentUser,
	        viewState: paymentModal.get('viewState'),
	        teamMemberIds: teamMemberIds,
	        planVolume: teamMemberIds.size,
	        plans: paymentModal.get('plans'),
	        coupon: coupon,
	        upcomingInvoice: paymentModal.get('upcomingInvoice'),
	        customer: customer,
	        subscription: subscription
	    };
	});
	
	var getProationDate = (0, _reselect.createSelector)(getPaymentModal, function (paymentModal) {
	    return paymentModal.get('prorateDate');
	});
	
	var paymentFormValuesSelector = exports.paymentFormValuesSelector = (0, _reselect.createSelector)(cardSelector, getProationDate, subscriptionSelector, function (card, prorateDate, subscription) {
	    return {
	        initialValues: _extends({}, card, {
	            prorateDate: prorateDate,
	            plan: subscription && subscription.getIn(['plan', 'interval']) || 'year'
	        })
	    };
	});
	
	var unsubscribeSelector = exports.unsubscribeSelector = (0, _reselect.createSelector)(_currentUserSelector.getCurrentUser, subscriptionSelector, function (currentUser, subscription) {
	    return {
	        currentUser: currentUser,
	        subscription: subscription
	    };
	});

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ADD_TEAM_MEMBER_FORM_FIELDS = exports.ADD_TEAM_MEMBER_FORM_NAME = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Constants
	
	
	var _validationConstants = __webpack_require__(36);
	
	var ADD_TEAM_MEMBER_FORM_NAME = exports.ADD_TEAM_MEMBER_FORM_NAME = 'addTeamMember';
	var ADD_TEAM_MEMBER_FORM_FIELDS = exports.ADD_TEAM_MEMBER_FORM_FIELDS = {
	    userEmail: _extends({}, _validationConstants.FIELDS.email, {
	        name: 'userEmail',
	        hideBeforeSubmit: true
	    })
	};

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setTeamMembers = exports.removeTeamMember = exports.fetchAndAddTeamMember = exports.addNewTeamMember = exports.addTeamMember = undefined;
	
	var _userUtil = __webpack_require__(31);
	
	var _userService = __webpack_require__(106);
	
	var _formActions = __webpack_require__(434);
	
	var _teamManagementConstants = __webpack_require__(236);
	
	var _teamFormConstants = __webpack_require__(309);
	
	// Actions
	var addTeamMember = exports.addTeamMember = function addTeamMember(_ref) {
	    var userId = _ref.userId;
	    return { type: _teamManagementConstants.TEAM_MEMBER_ADD, userId: userId };
	}; // Util
	var addNewTeamMember = exports.addNewTeamMember = function addNewTeamMember(_ref2) {
	    var userId = _ref2.userId;
	    return { type: _teamManagementConstants.TEAM_MEMBER_ADD_NEW, userId: userId };
	};
	
	var fetchAndAddTeamMember = exports.fetchAndAddTeamMember = function fetchAndAddTeamMember(_ref3) {
	    var userEmail = _ref3.userEmail;
	    return function (dispatch, getState) {
	        var lowerCaseUserEmail = userEmail.toLowerCase();
	
	        return dispatch((0, _userService.getOrInviteUser)({ userEmail: lowerCaseUserEmail })).then(function (user) {
	            if (!user._id) return;
	
	            if ((0, _userUtil.isSubscribed)(user)) {
	                return dispatch((0, _formActions.formSubmissionFailed)({
	                    form: _teamFormConstants.ADD_TEAM_MEMBER_FORM_NAME,
	                    primaryError: {
	                        message: user.email + ' already has a subscription.' + 'They will need to unsubscribe before they can be added to this team.'
	                    },
	                    errorCode: 'ALREADY_SUBSCRIBED',
	                    reportError: false
	                }));
	            }
	
	            return dispatch(addNewTeamMember({ userId: user._id }));
	        }).catch(function (err) {
	            return console.error(err);
	        });
	    };
	};
	
	var removeTeamMember = exports.removeTeamMember = function removeTeamMember(_ref4) {
	    var userId = _ref4.userId;
	    return { type: _teamManagementConstants.TEAM_MEMBER_REMOVE, userId: userId };
	};
	
	var setTeamMembers = exports.setTeamMembers = function setTeamMembers(_ref5) {
	    var userIds = _ref5.userIds;
	    return { type: _teamManagementConstants.TEAM_MEMBERS_SET, userIds: userIds };
	};

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _userConstants = __webpack_require__(32);
	
	Object.keys(_userConstants).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _userConstants[key];
	    }
	  });
	});
	var TRACK_USERS = exports.TRACK_USERS = 'TRACK_USERS';
	var USERS_LOAD = exports.USERS_LOAD = 'USERS_LOAD';
	var USER_ACTIVITY_LOAD = exports.USER_ACTIVITY_LOAD = 'USER_ACTIVITY_LOAD';
	var USER_ACTIVITY_ERROR = exports.USER_ACTIVITY_ERROR = 'USER_ACTIVITY_ERROR';

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getTranslationStyles = undefined;
	
	var _immutableHelper = __webpack_require__(23);
	
	var getTranslationStyles = exports.getTranslationStyles = function getTranslationStyles(translationPoint) {
	    var x = (0, _immutableHelper.prop)('x', translationPoint);
	    var y = (0, _immutableHelper.prop)('y', translationPoint);
	    var transform = 'translate3d(' + x + 'px, ' + y + 'px, 0)';
	    return {
	        transform: transform,
	        WebkitTransform: transform
	    };
	}; // Utils

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hasShiftKey = exports.hasCommandModifier = exports.isControlKeyCommand = undefined;
	
	var _immutableHelper = __webpack_require__(23);
	
	var _browser = __webpack_require__(61);
	
	var _dragModifierKeysConstants = __webpack_require__(172);
	
	/**
	 * True if the control key is being pressed.
	 */
	var isControlKeyCommand = exports.isControlKeyCommand = function isControlKeyCommand(eventKeys) {
	  return !!(0, _immutableHelper.prop)(_dragModifierKeysConstants.MODIFIER_KEYS.ctrlKey, eventKeys);
	};
	
	/**
	 * Determines if the 'command modifier' is being used.  I.e. The 'command' key for macs, or the 'control' key for
	 * others.
	 *
	 * @param eventKeys {Object} A key map containing boolean flags denoting if the key is pressed.
	 *      E.g:  { metaKey: false, shiftKey: false, ctrlKey: true, ... }
	 *
	 *      This could also be a keyboard event object.
	 * @return {Boolean} True if the 'command' key is being held and the platform is a mac, or the 'control' key is being
	 *      held down for other platforms.
	 */
	
	
	// Constants
	// Utils
	var hasCommandModifier = exports.hasCommandModifier = function hasCommandModifier(eventKeys) {
	  return _browser.isApple ? !!(0, _immutableHelper.prop)(_dragModifierKeysConstants.MODIFIER_KEYS.metaKey, eventKeys) : isControlKeyCommand(eventKeys);
	};
	
	var hasShiftKey = exports.hasShiftKey = function hasShiftKey(eventKeys) {
	  return eventKeys && (0, _immutableHelper.prop)(_dragModifierKeysConstants.MODIFIER_KEYS.shiftKey, eventKeys);
	};

/***/ }),
/* 314 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	// Local storage
	var localStorageFeatureTest = exports.localStorageFeatureTest = function localStorageFeatureTest() {
	    var mod = 'local_storage';
	    try {
	        localStorage.setItem(mod, mod);
	        localStorage.removeItem(mod);
	        return true;
	    } catch (e) {
	        return false;
	    }
	};
	
	/**
	 * A mock to prevent exceptions from being thrown when the local storage is used.
	 */
	var localStorageMockFallback = {
	    getItem: function getItem() {
	        return null;
	    },
	    setItem: function setItem() {
	        return null;
	    },
	    removeItem: function removeItem() {
	        return null;
	    },
	    key: function key() {
	        return null;
	    },
	    length: 0
	};
	
	var localStorageService = localStorageFeatureTest() ? localStorage : localStorageMockFallback;
	
	exports.default = localStorageService;

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mediaService = __webpack_require__(2284);
	
	var _mediaService2 = _interopRequireDefault(_mediaService);
	
	var _getClientConfig = __webpack_require__(48);
	
	var _getClientConfig2 = _interopRequireDefault(_getClientConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clientConfig = (0, _getClientConfig2.default)();
	
	exports.default = (0, _mediaService2.default)(clientConfig.mediaServer.apiUrl);

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.endOperation = exports.startOperation = exports.redoAction = exports.undoAction = undefined;
	
	var _analytics = __webpack_require__(47);
	
	var _undoRedoSelector = __webpack_require__(474);
	
	var _undoRedoConstants = __webpack_require__(473);
	
	var _undoRedoTransactionManager = __webpack_require__(86);
	
	// Constants
	var NO_ACTIONS = [];
	
	// Selectors
	
	
	var getTransactionActions = function getTransactionActions(stackName, getState) {
	    var state = getState();
	    var stack = state.getIn(['undoRedo', stackName]);
	
	    if (stack.size <= 0) return NO_ACTIONS;
	
	    var transactionId = stack.peek();
	    return state.getIn(['undoRedo', 'transactions', transactionId]) || NO_ACTIONS;
	};
	
	var undoAction = exports.undoAction = function undoAction() {
	    return function (dispatch, getState) {
	        var undoActions = getTransactionActions('undoStack', getState);
	        undoActions.reverse().forEach(function (action) {
	            return action.undo && dispatch(action.undo);
	        });
	
	        if (undoActions.size) {
	            (0, _analytics.analyticsEvent)('used-undo');
	        }
	    };
	};
	
	var redoAction = exports.redoAction = function redoAction() {
	    return function (dispatch, getState) {
	        var redoActions = getTransactionActions('redoStack', getState);
	        redoActions.forEach(function (action) {
	            return action.redo && dispatch(action.redo);
	        });
	    };
	};
	
	// Operation Actions
	var startOperation = exports.startOperation = function startOperation(name) {
	    return function (dispatch, getState) {
	        var state = getState();
	        var operation = (0, _undoRedoSelector.getCurrentOperation)(state);
	
	        // Don't dispatch a new operation if we're already in an operation.
	        // This doesn't support parallel operations. If it's required this should be revisited
	        if (operation) return;
	
	        return dispatch({
	            type: _undoRedoConstants.START_OPERATION,
	            name: name,
	            transactionId: (0, _undoRedoTransactionManager.getNewTransactionId)()
	        });
	    };
	};
	
	var endOperation = exports.endOperation = function endOperation(name) {
	    return function (dispatch, getState) {
	        var state = getState();
	        var operation = (0, _undoRedoSelector.getCurrentOperation)(state);
	
	        if (!operation) return;
	
	        var transactionId = (0, _undoRedoSelector.getMostRecentTransactionId)(state);
	        dispatch({
	            type: _undoRedoConstants.END_OPERATION,
	            name: name,
	            transactionId: transactionId
	        });
	        return transactionId;
	    };
	};

/***/ }),
/* 317 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var EXPORT_BOARD_FETCH = exports.EXPORT_BOARD_FETCH = 'EXPORT_BOARD_FETCH';
	var EXPORT_BOARD_FAIL = exports.EXPORT_BOARD_FAIL = 'EXPORT_BOARD_FAIL';
	var EXPORT_BOARD_SUCCESS = exports.EXPORT_BOARD_SUCCESS = 'EXPORT_BOARD_SUCCESS';
	
	var EXPORT_BOARD_STATES = exports.EXPORT_BOARD_STATES = {
	    FETCHING: 'FETCHING',
	    FAILED: 'FAILED'
	};
	
	var EXPORT_ROOT_ELEMENT_ID = exports.EXPORT_ROOT_ELEMENT_ID = 'export-root';

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.remoteUserIdsCurrentlyViewingSelector = exports.boardSharingPopupSelector = exports.boardSharingUtilSelector = exports.isSharedUsersError = exports.isSharedUsersLoading = exports.getSharedUsersResourceState = exports.usersCurrentlyViewingSelector = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Selectors
	
	
	// Utils
	
	
	var _reselect = __webpack_require__(7);
	
	var _permissionsService = __webpack_require__(75);
	
	var _usersSelector = __webpack_require__(204);
	
	var _milanoteReselect = __webpack_require__(49);
	
	var _userUtil = __webpack_require__(31);
	
	var _resourceUtil = __webpack_require__(108);
	
	var _immutableHelper = __webpack_require__(23);
	
	var _popupOpenSelector = __webpack_require__(141);
	
	var _popupOpenSelector2 = _interopRequireDefault(_popupOpenSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var usersCurrentlyViewingSelector = exports.usersCurrentlyViewingSelector = (0, _reselect.createSelector)(function (state, ownProps) {
	    return ownProps.currentBoardId;
	}, function (state) {
	    return state.get('users');
	}, function (currentBoardId, users) {
	    return users.filter(function (user) {
	        return (0, _userUtil.isOnline)(user) && user.get('currentBoardId') === currentBoardId;
	    });
	});
	
	var getSharedUserIds = (0, _reselect.createSelector)(_permissionsService.currentBoardPermissionsSelector, _permissionsService.getSharedUsers);
	
	var getSharedUsersResourceState = exports.getSharedUsersResourceState = (0, _usersSelector.makeFilteredUsersResourcesSelector)(getSharedUserIds);
	
	var getSharedUsersSelector = (0, _reselect.createSelector)(getSharedUserIds, function (state) {
	    return state.get('users');
	}, _immutableHelper.getMany);
	
	var isSharedUsersLoading = exports.isSharedUsersLoading = (0, _reselect.createSelector)(getSharedUserIds, getSharedUsersSelector, getSharedUsersResourceState, function (sharedUserIds, sharedUsers, sharedUserResourcesState) {
	    return sharedUserIds.length - sharedUsers.size > 1 || sharedUserResourcesState.filter(_resourceUtil.isFetching).size > 1;
	});
	
	var isSharedUsersError = exports.isSharedUsersError = (0, _reselect.createSelector)(getSharedUsersResourceState, function (sharedUserResourcesState) {
	    return sharedUserResourcesState.some(_resourceUtil.isError);
	});
	
	var boardSharingUtilSelector = exports.boardSharingUtilSelector = (0, _reselect.createSelector)(function (state, ownProps) {
	    return state.getIn(['elements', ownProps.currentBoardId]);
	}, _permissionsService.currentBoardPermissionsSelector, (0, _popupOpenSelector2.default)('sharing'), _permissionsService.currentBoardUserPermissionsSelector, usersCurrentlyViewingSelector, function (state) {
	    return state.getIn(['app', 'popup', 'sharing']);
	}, getSharedUserIds, function (currentBoard, boardPermissions, popupOpen, userPermissions, usersCurrentlyViewing, sharingPopupState, sharedUserIds) {
	    var sharedUserCount = sharedUserIds.length;
	    var isRootBoard = currentBoard && currentBoard.getIn(['location', 'rootBoard']);
	
	    return {
	        popupOpen: popupOpen,
	        boardPermissions: boardPermissions,
	        sharedUserCount: sharedUserCount,
	        sharedUserIds: sharedUserIds,
	        isRootBoard: isRootBoard,
	        userPermissions: userPermissions,
	        usersCurrentlyViewing: usersCurrentlyViewing,
	        sharingPopupState: sharingPopupState
	    };
	});
	
	var boardSharingPopupSelector = exports.boardSharingPopupSelector = (0, _reselect.createSelector)(boardSharingUtilSelector, getSharedUsersSelector, isSharedUsersLoading, isSharedUsersError, function (boardSharingUtilState, sharedUsers, isLoading, isUserError) {
	    return _extends({}, boardSharingUtilState, {
	        sharedUsers: sharedUsers,
	        isLoading: isLoading,
	        isUserError: isUserError
	    });
	});
	
	var remoteUserIdsCurrentlyViewingSelector = exports.remoteUserIdsCurrentlyViewingSelector = (0, _milanoteReselect.createShallowSelector)(usersCurrentlyViewingSelector, function (state) {
	    return state.getIn(['app', 'currentUser', '_id']);
	}, function (users, currentUserId) {
	    return users.filter(function (user) {
	        return user.get('_id') !== currentUserId;
	    }).keySeq().toArray();
	});

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getColorHexValue = undefined;
	
	var _colorConstants = __webpack_require__(479);
	
	var getColorHexValue = exports.getColorHexValue = function getColorHexValue(colorName) {
	  return _colorConstants.COLORS[colorName] ? _colorConstants.COLORS[colorName].hex : null;
	};

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ELEMENT_TOP_RIGHT_READING_MODIFIER = exports.COLUMN_OVERLAP_THRESHOLD = exports.MIN_CHANGE_IN_SCREE_PLOT_SLOPE = exports.MAX_DIST_BETWEEN_BOTTOM_AND_TOP = exports.AUTO_COLUMN_DISTANCE = exports.AUTO_CLUSTER_DISTANCE = exports.SAME_COLOR_ADJUSTMENT = exports.SAME_TYPE_ADJUSTMENTS = undefined;
	
	var _SAME_TYPE_ADJUSTMENT;
	
	var _boardConstants = __webpack_require__(17);
	
	var _linkConstants = __webpack_require__(174);
	
	var _imageConstants = __webpack_require__(87);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // Constants
	
	
	// PARAMETERS
	// Distance adjustments based on categorical data
	var SAME_TYPE_ADJUSTMENTS = exports.SAME_TYPE_ADJUSTMENTS = (_SAME_TYPE_ADJUSTMENT = {}, _defineProperty(_SAME_TYPE_ADJUSTMENT, _boardConstants.BOARD_TYPE, 0.8), _defineProperty(_SAME_TYPE_ADJUSTMENT, _linkConstants.LINK_TYPE, 0.9), _defineProperty(_SAME_TYPE_ADJUSTMENT, _imageConstants.IMAGE_TYPE, 0.9), _SAME_TYPE_ADJUSTMENT);
	var SAME_COLOR_ADJUSTMENT = exports.SAME_COLOR_ADJUSTMENT = 0.9;
	
	// Distances below which we automatically create clusters (and ignore the scree plot slope)
	// Disable for clusters
	var AUTO_CLUSTER_DISTANCE = exports.AUTO_CLUSTER_DISTANCE = -1;
	var AUTO_COLUMN_DISTANCE = exports.AUTO_COLUMN_DISTANCE = 2;
	
	// This distance is used when elements can't be in the same column (because they don't overlap)
	// possible change: instead of 1000 for max distance, this could be set to the current max (to avoid incorrect elbows)
	var MAX_DIST_BETWEEN_BOTTOM_AND_TOP = exports.MAX_DIST_BETWEEN_BOTTOM_AND_TOP = 1000;
	
	// This prevents clusters from being created if the line is too linear
	var MIN_CHANGE_IN_SCREE_PLOT_SLOPE = exports.MIN_CHANGE_IN_SCREE_PLOT_SLOPE = 20 * Math.PI / 180;
	
	// This is used in distance calculations
	// export const MIN_OVERLAP_DISTANCE = 1;
	var COLUMN_OVERLAP_THRESHOLD = exports.COLUMN_OVERLAP_THRESHOLD = 0.5; // relative to the width of the smaller element being compared
	
	// This makes it easier to read from the top right of an element within a column
	var ELEMENT_TOP_RIGHT_READING_MODIFIER = exports.ELEMENT_TOP_RIGHT_READING_MODIFIER = 0.6;

/***/ }),
/* 321 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var AUTOUPDATE_DOWNLOAD_START = exports.AUTOUPDATE_DOWNLOAD_START = 'AUTOUPDATE_DOWNLOAD_START';
	var AUTOUPDATE_DOWNLOAD_COMPLETE = exports.AUTOUPDATE_DOWNLOAD_COMPLETE = 'AUTOUPDATE_DOWNLOAD_COMPLETE';
	var AUTOUPDATE_UPDATE_INSTALL = exports.AUTOUPDATE_UPDATE_INSTALL = 'AUTOUPDATE_UPDATE_INSTALL';
	
	var AUTOUPDATE_CHECK_START = exports.AUTOUPDATE_CHECK_START = 'AUTOUPDATE_CHECK_START';
	var AUTOUPDATE_CHECK_COMPLETE = exports.AUTOUPDATE_CHECK_COMPLETE = 'AUTOUPDATE_CHECK_COMPLETE';
	
	var AUTOUPDATE_FORCE_POLL = exports.AUTOUPDATE_FORCE_POLL = 'AUTOUPDATE_FORCE_POLL';
	var AUTOUPDATE_ERROR = exports.AUTOUPDATE_ERROR = 'AUTOUPDATE_ERROR';
	
	var ELECTRON_APP_SLEEP = exports.ELECTRON_APP_SLEEP = 'ELECTRON_APP_SLEEP';
	var ELECTRON_APP_WAKE = exports.ELECTRON_APP_WAKE = 'ELECTRON_APP_WAKE';
	
	var AUTOUPDATE_STATE = exports.AUTOUPDATE_STATE = {
	    NONE: undefined,
	    CHECKING: 'CHECKING',
	    DOWNLOADING: 'DOWNLOADING',
	    READY: 'READY',
	    ERROR: 'ERROR'
	};

/***/ }),
/* 322 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ELEMENTS_LOAD = exports.ELEMENTS_LOAD = 'ELEMENTS_LOAD';
	var ELEMENTS_RESET_SCORES = exports.ELEMENTS_RESET_SCORES = 'ELEMENTS_RESET_SCORES';

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _victor = __webpack_require__(2326);
	
	var _victor2 = _interopRequireDefault(_victor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Simply extending Victor.
	 * This will clobber Victor methods, so potentially dangerous if Victor updates.
	 */
	var Vector = _victor2.default;
	
	Vector.lineVector = function lineVector(start, end) {
	    var endVector = end instanceof _victor2.default ? end.clone() : _victor2.default.fromObject(end);
	
	    return endVector.subtract(start);
	};
	
	/**
	 * Creates a vector of the same magnitude as this vector but perpendicular to it.
	 */
	Vector.prototype.perpendicular = function perpendicular() {
	    var x = -this.y;
	    this.y = this.x;
	    this.x = x;
	    return this;
	};
	
	/**
	 * Creates a vector of the same magnitude as this vector but is the right perpendicular to it.
	 */
	Vector.prototype.perpendicularRight = function perpendicularRight() {
	    var x = this.y;
	    this.y = -this.x;
	    this.x = x;
	    return this;
	};
	
	/**
	 * Makes the vector have a specific length, but remain in the same direction.
	 */
	Vector.prototype.toLength = function toLength(length) {
	    return this.normalize().multiplyScalar(length);
	};
	
	/**
	 * Returns the magnitude of the projection of the "vector to project" onto this vector.
	 * I.e. This is the "adjacent" in the right angle triangle between this vector and other vector.
	 */
	Vector.prototype.projectedMagnitude = function projectedMagnitude(vectorToProject) {
	    return this.dot(vectorToProject) / this.length();
	};
	
	/**
	 * Returns the ratio of the projection of the "vector to project" onto this vector.
	 * I.e. This is the "adjacent" in the right angle triangle between this vector and other vector divided by
	 * the length of this vector.
	 */
	Vector.prototype.projectedRatio = function projectedRatio(vectorToProject) {
	    return this.dot(vectorToProject) / Math.pow(this.length(), 2);
	};
	
	Vector.prototype.toFixed = function toFixed(precision) {
	    var _precision = precision || 8;
	    this.x = Number(this.x.toFixed(_precision));
	    this.y = Number(this.y.toFixed(_precision));
	    return this;
	};
	
	exports.default = Vector;

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.isChangeMeaningful = exports.getAllChangedElements = exports.parseChangingUsers = exports.describeChangedElements = exports.parseChangedElementTypes = exports.describeElementTypes = exports.reduceTypeCounts = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _stringUtil = __webpack_require__(58);
	
	var _immutableHelper = __webpack_require__(23);
	
	var _elementRegistry = __webpack_require__(56);
	
	var _elementConstants = __webpack_require__(12);
	
	var ACTION_TYPES = _interopRequireWildcard(_elementConstants);
	
	var _aliasConstants = __webpack_require__(241);
	
	var _boardConstants = __webpack_require__(17);
	
	var _notificationConstants = __webpack_require__(88);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// ----------------------
	// Turn an array of [{ elementType: 'BOARD' }, { elementType: 'BOARD' }, { elementType: 'CARD' }, { elementType: 'LINK' }]
	// into a map of { BOARD: 2, CARD: 1, LINK: 1 }
	// ----------------------
	var reduceTypeCounts = exports.reduceTypeCounts = function reduceTypeCounts(acc, change) {
	    var type = (0, _immutableHelper.prop)('elementType', change) === _aliasConstants.ALIAS_TYPE ? _boardConstants.BOARD_TYPE : (0, _immutableHelper.prop)('elementType', change);
	    var count = acc[type] || 0;
	    acc[type] = count + 1;
	    return acc;
	};
	
	// ----------------------
	// Describe a map of { BOARD: 2, CARD: 1, LINK: 1 }
	// as "2 boards, 1 note and 1 link"
	// ----------------------
	
	
	// Element Registry
	var describeElementTypes = exports.describeElementTypes = function describeElementTypes(elementTypeChanges) {
	    var typesArray = Object.keys(elementTypeChanges).sort();
	
	    return typesArray.filter(function (type) {
	        return elementTypeChanges[type] > 0;
	    }).reduce(function (acc, type, i, self) {
	        var count = elementTypeChanges[type];
	        var typeName = (0, _elementRegistry.getElementDisplayName)(type).toLowerCase();
	        var name = (0, _stringUtil.pluralise)(typeName, count);
	        var separator = (0, _stringUtil.listSeparator)(i, self.length);
	        return '' + acc + count + ' ' + name + separator;
	    }, '');
	};
	
	// ----------------------
	// Turn an array of [{ elementType: 'CARD', message: 'CREATED' }, { elementType: 'BOARD', message: 'UPDATED' }, { elementType: 'CARD', message: 'UPDATED' }]
	// into a map of { created: { CARD: 1 }, updated: { BOARD: 1, CARD: 1 } }
	// ----------------------
	var parseChangedElementTypes = exports.parseChangedElementTypes = function parseChangedElementTypes(changes) {
	    var newElements = changes.filter(function (change) {
	        return change.message === _notificationConstants.MODIFIED_ELEMENTS_MESSAGES.CREATED;
	    }).reduce(reduceTypeCounts, {});
	
	    var updatedElements = changes.filter(function (change) {
	        return change.message === _notificationConstants.MODIFIED_ELEMENTS_MESSAGES.UPDATED;
	    }).reduce(reduceTypeCounts, {});
	
	    return {
	        created: newElements,
	        updated: updatedElements
	    };
	};
	
	// ----------------------
	// Describe a map of { created: { CARD: 1 }, updated: { BOARD: 1, CARD: 1 } }
	// as "created 1 card and updated 1 board and 1 card"
	// ----------------------
	var describeChangedElements = exports.describeChangedElements = function describeChangedElements(changesData) {
	    var hasNew = Object.keys(changesData.created).length > 0;
	    var hasUpdated = Object.keys(changesData.updated).length > 0;
	
	    var describeNew = hasNew ? 'created ' + describeElementTypes(changesData.created) : '';
	
	    var describeUpdated = hasUpdated ? 'updated ' + describeElementTypes(changesData.updated) : '';
	
	    var separator = hasNew && hasUpdated ? ' and ' : '';
	
	    return '' + describeNew + separator + describeUpdated;
	};
	
	// ----------------------
	// Describe an array of [{ modifiedBy: 'abc' }, { modifiedBy: 'xyz' }, { modifiedBy: 'abc' }, { modifiedBy: 'jkl' }]
	// as "Isaac Williams, Glenn Allen and Ollie Campbell"
	// ----------------------
	var parseChangingUsers = exports.parseChangingUsers = function parseChangingUsers(changes, users) {
	    return changes.map(function (change) {
	        return change.modifiedBy;
	    }).filter(function (userId, i, self) {
	        return self.indexOf(userId) === i;
	    }).map(function (userId) {
	        return users[userId];
	    }).map(function (user) {
	        return user.name.displayName;
	    }).reduce(function (acc, name, i, self) {
	        return acc + name + (0, _stringUtil.listSeparator)(i, self.length);
	    }, '');
	};
	
	var getAllChangedElements = exports.getAllChangedElements = function getAllChangedElements(changedBoards) {
	    return changedBoards.reduce(function (acc, board) {
	        return acc.concat(board.children);
	    }, []);
	};
	
	// ----------------------
	// The following take an element action & decide whether it is
	// a meaningful change or not
	// ----------------------
	
	var isMoveMeaningful = function isMoveMeaningful(action, move) {
	    if (!move.from) return false;
	    if (move.location.parentId !== move.from.parentId) return true;
	    if (move.location.section !== move.from.section) return true;
	
	    if (move.location.section === _boardConstants.BOARD_SECTIONS.INBOX) {
	        var index = (0, _lodash.get)(move, ['location', 'position', 'index'], 0);
	        var indexFrom = (0, _lodash.get)(move, ['from', 'position', 'index'], index);
	        var distanceMoved = Math.abs(index - indexFrom);
	        return distanceMoved >= _notificationConstants.INBOX_MOVE_MEANINGFUL_DIST;
	    }
	
	    var pos = (0, _lodash.get)(move, ['location', 'position'], { x: 0, y: 0 });
	    var posFrom = (0, _lodash.get)(move, ['from', 'position'], pos);
	
	    var dx = pos.x - posFrom.x;
	    var dy = pos.y - posFrom.y;
	    var distanceMovedSqrd = dx * dx + dy * dy;
	
	    return distanceMovedSqrd >= _notificationConstants.CANVAS_MOVE_MEANINGFUL_DIST_SQRD;
	};
	
	var isUpdateMeaningful = function isUpdateMeaningful(action) {
	    var updates = action.updates;
	
	    if (!updates) return false;
	
	    var changeKeys = (0, _lodash.flatMap)(updates, function (update) {
	        return Object.keys(update.changes);
	    });
	    var changeList = (0, _lodash.intersection)(changeKeys, _notificationConstants.UPDATE_MEANINGFUL_CHANGE_KEY_LIST);
	
	    return changeList.length > 0;
	};
	
	var isChangeMeaningful = exports.isChangeMeaningful = function isChangeMeaningful(action, data) {
	    switch (action.type) {
	        case ACTION_TYPES.ELEMENT_CREATE:
	        case ACTION_TYPES.ELEMENT_SHARE:
	        case ACTION_TYPES.ELEMENT_UNSHARE:
	            return true;
	        case ACTION_TYPES.ELEMENT_MOVE_MULTI:
	            return isMoveMeaningful(action, data);
	        case ACTION_TYPES.ELEMENT_UPDATE:
	            return isUpdateMeaningful(action);
	        default:
	            return false;
	    }
	};

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getCurrencySymbol = undefined;
	
	var _currencyConstants = __webpack_require__(2285);
	
	var getCurrencySymbol = exports.getCurrencySymbol = function getCurrencySymbol() {
	    var currencyCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	    var upperCurrencyCode = currencyCode.toUpperCase();
	    var currency = _currencyConstants.CURRENCY[upperCurrencyCode];
	    return currency ? currency.symbol : '' + upperCurrencyCode.substr(0, 2) + _currencyConstants.CURRENCY.default.symbol;
	}; // Constants

/***/ }),
/* 326 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var MARKETING_URL = exports.MARKETING_URL = 'https://www.milanote.com';
	var HELP_URL = exports.HELP_URL = 'http://help.milanote.com/';
	var BLOG_URL = exports.BLOG_URL = 'https://medium.com/milanote';
	
	var REFERRAL_REDIRECT_URL = exports.REFERRAL_REDIRECT_URL = MARKETING_URL + '/';
	
	var MARKETING_PLANS_URL = exports.MARKETING_PLANS_URL = MARKETING_URL + '/plans';
	var MARKETING_POLL_URL = exports.MARKETING_POLL_URL = MARKETING_URL + '/poll';

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(78);
	var normalizeHeaderName = __webpack_require__(822);
	
	var PROTECTION_PREFIX = /^\)\]\}',?\n/;
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(490);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(490);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      data = data.replace(PROTECTION_PREFIX, '');
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMehtodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(186)))

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(51)
	  , toIndex  = __webpack_require__(156)
	  , toLength = __webpack_require__(44);
	module.exports = function fill(value /*, start = 0, end = @length */){
	  var O      = toObject(this)
	    , length = toLength(O.length)
	    , aLen   = arguments.length
	    , index  = toIndex(aLen > 1 ? arguments[1] : undefined, length)
	    , end    = aLen > 2 ? arguments[2] : undefined
	    , endPos = end === undefined ? length : toIndex(end, length);
	  while(endPos > index)O[index++] = value;
	  return O;
	};

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(38)
	  , createDesc      = __webpack_require__(131);
	
	module.exports = function(object, index, value){
	  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(25)
	  , document = __webpack_require__(15).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ }),
/* 331 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(29)('match');
	module.exports = function(KEY){
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch(e){
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch(f){ /* empty */ }
	  } return true;
	};

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(15).document && document.documentElement;

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject       = __webpack_require__(25)
	  , setPrototypeOf = __webpack_require__(342).set;
	module.exports = function(that, target, C){
	  var P, S = target.constructor;
	  if(S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf){
	    setPrototypeOf(that, P);
	  } return that;
	};

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators  = __webpack_require__(179)
	  , ITERATOR   = __webpack_require__(29)('iterator')
	  , ArrayProto = Array.prototype;
	
	module.exports = function(it){
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(91);
	module.exports = Array.isArray || function isArray(arg){
	  return cof(arg) == 'Array';
	};

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create         = __webpack_require__(151)
	  , descriptor     = __webpack_require__(131)
	  , setToStringTag = __webpack_require__(180)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(68)(IteratorPrototype, __webpack_require__(29)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(150)
	  , $export        = __webpack_require__(5)
	  , redefine       = __webpack_require__(69)
	  , hide           = __webpack_require__(68)
	  , has            = __webpack_require__(62)
	  , Iterators      = __webpack_require__(179)
	  , $iterCreate    = __webpack_require__(337)
	  , setToStringTag = __webpack_require__(180)
	  , getPrototypeOf = __webpack_require__(80)
	  , ITERATOR       = __webpack_require__(29)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
	    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
	    , methods, key, IteratorPrototype;
	  // Fix native
	  if($anyNative){
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
	    if(IteratorPrototype !== Object.prototype){
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if(DEF_VALUES && $native && $native.name !== VALUES){
	    VALUES_BUG = true;
	    $default = function values(){ return $native.call(this); };
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES ? $default : getMethod(VALUES),
	      keys:    IS_SET     ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ }),
/* 339 */
/***/ (function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x){
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;

/***/ }),
/* 340 */
/***/ (function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x){
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(15)
	  , macrotask = __webpack_require__(349).set
	  , Observer  = global.MutationObserver || global.WebKitMutationObserver
	  , process   = global.process
	  , Promise   = global.Promise
	  , isNode    = __webpack_require__(91)(process) == 'process';
	
	module.exports = function(){
	  var head, last, notify;
	
	  var flush = function(){
	    var parent, fn;
	    if(isNode && (parent = process.domain))parent.exit();
	    while(head){
	      fn   = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch(e){
	        if(head)notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if(parent)parent.enter();
	  };
	
	  // Node.js
	  if(isNode){
	    notify = function(){
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver
	  } else if(Observer){
	    var toggle = true
	      , node   = document.createTextNode('');
	    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
	    notify = function(){
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if(Promise && Promise.resolve){
	    var promise = Promise.resolve();
	    notify = function(){
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function(){
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function(fn){
	    var task = {fn: fn, next: undefined};
	    if(last)last.next = task;
	    if(!head){
	      head = task;
	      notify();
	    } last = task;
	  };
	};

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(25)
	  , anObject = __webpack_require__(14);
	var check = function(O, proto){
	  anObject(O);
	  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function(test, buggy, set){
	      try {
	        set = __webpack_require__(113)(Function.call, __webpack_require__(79).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch(e){ buggy = true; }
	      return function setPrototypeOf(O, proto){
	        check(O, proto);
	        if(buggy)O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(257)('keys')
	  , uid    = __webpack_require__(157);
	module.exports = function(key){
	  return shared[key] || (shared[key] = uid(key));
	};

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject  = __webpack_require__(14)
	  , aFunction = __webpack_require__(67)
	  , SPECIES   = __webpack_require__(29)('species');
	module.exports = function(O, D){
	  var C = anObject(O).constructor, S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(132)
	  , defined   = __webpack_require__(92);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(253)
	  , defined  = __webpack_require__(92);
	
	module.exports = function(that, searchString, NAME){
	  if(isRegExp(searchString))throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(132)
	  , defined   = __webpack_require__(92);
	
	module.exports = function repeat(count){
	  var str = String(defined(this))
	    , res = ''
	    , n   = toInteger(count);
	  if(n < 0 || n == Infinity)throw RangeError("Count can't be negative");
	  for(;n > 0; (n >>>= 1) && (str += str))if(n & 1)res += str;
	  return res;
	};

/***/ }),
/* 348 */
/***/ (function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx                = __webpack_require__(113)
	  , invoke             = __webpack_require__(252)
	  , html               = __webpack_require__(333)
	  , cel                = __webpack_require__(330)
	  , global             = __webpack_require__(15)
	  , process            = global.process
	  , setTask            = global.setImmediate
	  , clearTask          = global.clearImmediate
	  , MessageChannel     = global.MessageChannel
	  , counter            = 0
	  , queue              = {}
	  , ONREADYSTATECHANGE = 'onreadystatechange'
	  , defer, channel, port;
	var run = function(){
	  var id = +this;
	  if(queue.hasOwnProperty(id)){
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function(event){
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if(!setTask || !clearTask){
	  setTask = function setImmediate(fn){
	    var args = [], i = 1;
	    while(arguments.length > i)args.push(arguments[i++]);
	    queue[++counter] = function(){
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id){
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if(__webpack_require__(91)(process) == 'process'){
	    defer = function(id){
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if(MessageChannel){
	    channel = new MessageChannel;
	    port    = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
	    defer = function(id){
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if(ONREADYSTATECHANGE in cel('script')){
	    defer = function(id){
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function(id){
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set:   setTask,
	  clear: clearTask
	};

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global         = __webpack_require__(15)
	  , DESCRIPTORS    = __webpack_require__(37)
	  , LIBRARY        = __webpack_require__(150)
	  , $typed         = __webpack_require__(258)
	  , hide           = __webpack_require__(68)
	  , redefineAll    = __webpack_require__(154)
	  , fails          = __webpack_require__(19)
	  , anInstance     = __webpack_require__(149)
	  , toInteger      = __webpack_require__(132)
	  , toLength       = __webpack_require__(44)
	  , gOPN           = __webpack_require__(152).f
	  , dP             = __webpack_require__(38).f
	  , arrayFill      = __webpack_require__(328)
	  , setToStringTag = __webpack_require__(180)
	  , ARRAY_BUFFER   = 'ArrayBuffer'
	  , DATA_VIEW      = 'DataView'
	  , PROTOTYPE      = 'prototype'
	  , WRONG_LENGTH   = 'Wrong length!'
	  , WRONG_INDEX    = 'Wrong index!'
	  , $ArrayBuffer   = global[ARRAY_BUFFER]
	  , $DataView      = global[DATA_VIEW]
	  , Math           = global.Math
	  , RangeError     = global.RangeError
	  , Infinity       = global.Infinity
	  , BaseBuffer     = $ArrayBuffer
	  , abs            = Math.abs
	  , pow            = Math.pow
	  , floor          = Math.floor
	  , log            = Math.log
	  , LN2            = Math.LN2
	  , BUFFER         = 'buffer'
	  , BYTE_LENGTH    = 'byteLength'
	  , BYTE_OFFSET    = 'byteOffset'
	  , $BUFFER        = DESCRIPTORS ? '_b' : BUFFER
	  , $LENGTH        = DESCRIPTORS ? '_l' : BYTE_LENGTH
	  , $OFFSET        = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	var packIEEE754 = function(value, mLen, nBytes){
	  var buffer = Array(nBytes)
	    , eLen   = nBytes * 8 - mLen - 1
	    , eMax   = (1 << eLen) - 1
	    , eBias  = eMax >> 1
	    , rt     = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0
	    , i      = 0
	    , s      = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0
	    , e, m, c;
	  value = abs(value)
	  if(value != value || value === Infinity){
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if(value * (c = pow(2, -e)) < 1){
	      e--;
	      c *= 2;
	    }
	    if(e + eBias >= 1){
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if(value * c >= 2){
	      e++;
	      c /= 2;
	    }
	    if(e + eBias >= eMax){
	      m = 0;
	      e = eMax;
	    } else if(e + eBias >= 1){
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for(; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for(; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	};
	var unpackIEEE754 = function(buffer, mLen, nBytes){
	  var eLen  = nBytes * 8 - mLen - 1
	    , eMax  = (1 << eLen) - 1
	    , eBias = eMax >> 1
	    , nBits = eLen - 7
	    , i     = nBytes - 1
	    , s     = buffer[i--]
	    , e     = s & 127
	    , m;
	  s >>= 7;
	  for(; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for(; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if(e === 0){
	    e = 1 - eBias;
	  } else if(e === eMax){
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	};
	
	var unpackI32 = function(bytes){
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	};
	var packI8 = function(it){
	  return [it & 0xff];
	};
	var packI16 = function(it){
	  return [it & 0xff, it >> 8 & 0xff];
	};
	var packI32 = function(it){
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	};
	var packF64 = function(it){
	  return packIEEE754(it, 52, 8);
	};
	var packF32 = function(it){
	  return packIEEE754(it, 23, 4);
	};
	
	var addGetter = function(C, key, internal){
	  dP(C[PROTOTYPE], key, {get: function(){ return this[internal]; }});
	};
	
	var get = function(view, bytes, index, isLittleEndian){
	  var numIndex = +index
	    , intIndex = toInteger(numIndex);
	  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b
	    , start = intIndex + view[$OFFSET]
	    , pack  = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	};
	var set = function(view, bytes, index, conversion, value, isLittleEndian){
	  var numIndex = +index
	    , intIndex = toInteger(numIndex);
	  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b
	    , start = intIndex + view[$OFFSET]
	    , pack  = conversion(+value);
	  for(var i = 0; i < bytes; i++)store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	};
	
	var validateArrayBufferArguments = function(that, length){
	  anInstance(that, $ArrayBuffer, ARRAY_BUFFER);
	  var numberLength = +length
	    , byteLength   = toLength(numberLength);
	  if(numberLength != byteLength)throw RangeError(WRONG_LENGTH);
	  return byteLength;
	};
	
	if(!$typed.ABV){
	  $ArrayBuffer = function ArrayBuffer(length){
	    var byteLength = validateArrayBufferArguments(this, length);
	    this._b       = arrayFill.call(Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength){
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH]
	      , offset       = toInteger(byteOffset);
	    if(offset < 0 || offset > bufferLength)throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if(offset + byteLength > bufferLength)throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if(DESCRIPTORS){
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset){
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset){
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /*, littleEndian */){
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /*, littleEndian */){
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /*, littleEndian */){
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /*, littleEndian */){
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /*, littleEndian */){
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /*, littleEndian */){
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value){
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value){
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /*, littleEndian */){
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /*, littleEndian */){
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /*, littleEndian */){
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if(!fails(function(){
	    new $ArrayBuffer;     // eslint-disable-line no-new
	  }) || !fails(function(){
	    new $ArrayBuffer(.5); // eslint-disable-line no-new
	  })){
	    $ArrayBuffer = function ArrayBuffer(length){
	      return new BaseBuffer(validateArrayBufferArguments(this, length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for(var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j; ){
	      if(!((key = keys[j++]) in $ArrayBuffer))hide($ArrayBuffer, key, BaseBuffer[key]);
	    };
	    if(!LIBRARY)ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2))
	    , $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if(view.getInt8(0) || !view.getInt8(1))redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value){
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value){
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	var global         = __webpack_require__(15)
	  , core           = __webpack_require__(112)
	  , LIBRARY        = __webpack_require__(150)
	  , wksExt         = __webpack_require__(522)
	  , defineProperty = __webpack_require__(38).f;
	module.exports = function(name){
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
	};

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(210)
	  , ITERATOR  = __webpack_require__(29)('iterator')
	  , Iterators = __webpack_require__(179);
	module.exports = __webpack_require__(112).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(177)
	  , step             = __webpack_require__(510)
	  , Iterators        = __webpack_require__(179)
	  , toIObject        = __webpack_require__(71);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(338)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(1016);
	var isArguments = __webpack_require__(1015);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),
/* 355 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = isDisposable;
	
	function isDisposable(obj) {
	  return Boolean(obj && typeof obj.dispose === 'function');
	}
	
	module.exports = exports['default'];

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ContentState
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlockMapBuilder = __webpack_require__(213);
	var CharacterMetadata = __webpack_require__(94);
	var ContentBlock = __webpack_require__(158);
	var Immutable = __webpack_require__(28);
	var SelectionState = __webpack_require__(182);
	
	var generateRandomKey = __webpack_require__(100);
	var sanitizeDraftText = __webpack_require__(362);
	
	var List = Immutable.List;
	var Record = Immutable.Record;
	var Repeat = Immutable.Repeat;
	
	
	var defaultRecord = {
	  blockMap: null,
	  selectionBefore: null,
	  selectionAfter: null
	};
	
	var ContentStateRecord = Record(defaultRecord);
	
	var ContentState = function (_ContentStateRecord) {
	  _inherits(ContentState, _ContentStateRecord);
	
	  function ContentState() {
	    _classCallCheck(this, ContentState);
	
	    return _possibleConstructorReturn(this, _ContentStateRecord.apply(this, arguments));
	  }
	
	  ContentState.prototype.getBlockMap = function getBlockMap() {
	    return this.get('blockMap');
	  };
	
	  ContentState.prototype.getSelectionBefore = function getSelectionBefore() {
	    return this.get('selectionBefore');
	  };
	
	  ContentState.prototype.getSelectionAfter = function getSelectionAfter() {
	    return this.get('selectionAfter');
	  };
	
	  ContentState.prototype.getBlockForKey = function getBlockForKey(key) {
	    var block = this.getBlockMap().get(key);
	    return block;
	  };
	
	  ContentState.prototype.getKeyBefore = function getKeyBefore(key) {
	    return this.getBlockMap().reverse().keySeq().skipUntil(function (v) {
	      return v === key;
	    }).skip(1).first();
	  };
	
	  ContentState.prototype.getKeyAfter = function getKeyAfter(key) {
	    return this.getBlockMap().keySeq().skipUntil(function (v) {
	      return v === key;
	    }).skip(1).first();
	  };
	
	  ContentState.prototype.getBlockAfter = function getBlockAfter(key) {
	    return this.getBlockMap().skipUntil(function (_, k) {
	      return k === key;
	    }).skip(1).first();
	  };
	
	  ContentState.prototype.getBlockBefore = function getBlockBefore(key) {
	    return this.getBlockMap().reverse().skipUntil(function (_, k) {
	      return k === key;
	    }).skip(1).first();
	  };
	
	  ContentState.prototype.getBlocksAsArray = function getBlocksAsArray() {
	    return this.getBlockMap().toArray();
	  };
	
	  ContentState.prototype.getFirstBlock = function getFirstBlock() {
	    return this.getBlockMap().first();
	  };
	
	  ContentState.prototype.getLastBlock = function getLastBlock() {
	    return this.getBlockMap().last();
	  };
	
	  ContentState.prototype.getPlainText = function getPlainText(delimiter) {
	    return this.getBlockMap().map(function (block) {
	      return block ? block.getText() : '';
	    }).join(delimiter || '\n');
	  };
	
	  ContentState.prototype.hasText = function hasText() {
	    var blockMap = this.getBlockMap();
	    return blockMap.size > 1 || blockMap.first().getLength() > 0;
	  };
	
	  ContentState.createFromBlockArray = function createFromBlockArray(blocks) {
	    var blockMap = BlockMapBuilder.createFromArray(blocks);
	    var selectionState = SelectionState.createEmpty(blockMap.first().getKey());
	    return new ContentState({
	      blockMap: blockMap,
	      selectionBefore: selectionState,
	      selectionAfter: selectionState
	    });
	  };
	
	  ContentState.createFromText = function createFromText(text) {
	    var delimiter = arguments.length <= 1 || arguments[1] === undefined ? /\r\n?|\n/g : arguments[1];
	
	    var strings = text.split(delimiter);
	    var blocks = strings.map(function (block) {
	      block = sanitizeDraftText(block);
	      return new ContentBlock({
	        key: generateRandomKey(),
	        text: block,
	        type: 'unstyled',
	        characterList: List(Repeat(CharacterMetadata.EMPTY, block.length))
	      });
	    });
	    return ContentState.createFromBlockArray(blocks);
	  };
	
	  return ContentState;
	}(ContentStateRecord);
	
	module.exports = ContentState;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultDraftBlockRenderMap
	 * 
	 */
	
	'use strict';
	
	var _require = __webpack_require__(28);
	
	var Map = _require.Map;
	
	var React = __webpack_require__(1);
	
	var cx = __webpack_require__(215);
	
	var UL_WRAP = React.createElement('ul', { className: cx('public/DraftStyleDefault/ul') });
	var OL_WRAP = React.createElement('ol', { className: cx('public/DraftStyleDefault/ol') });
	var PRE_WRAP = React.createElement('pre', { className: cx('public/DraftStyleDefault/pre') });
	
	module.exports = Map({
	  'header-one': {
	    element: 'h1'
	  },
	  'header-two': {
	    element: 'h2'
	  },
	  'header-three': {
	    element: 'h3'
	  },
	  'header-four': {
	    element: 'h4'
	  },
	  'header-five': {
	    element: 'h5'
	  },
	  'header-six': {
	    element: 'h6'
	  },
	  'unordered-list-item': {
	    element: 'li',
	    wrapper: UL_WRAP
	  },
	  'ordered-list-item': {
	    element: 'li',
	    wrapper: OL_WRAP
	  },
	  'blockquote': {
	    element: 'blockquote'
	  },
	  'atomic': {
	    element: 'figure'
	  },
	  'code-block': {
	    element: 'pre',
	    wrapper: PRE_WRAP
	  },
	  'unstyled': {
	    element: 'div'
	  }
	});

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule KeyBindingUtil
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var UserAgent = __webpack_require__(101);
	
	var isOSX = UserAgent.isPlatform('Mac OS X');
	
	var KeyBindingUtil = {
	  /**
	   * Check whether the ctrlKey modifier is *not* being used in conjunction with
	   * the altKey modifier. If they are combined, the result is an `altGraph`
	   * key modifier, which should not be handled by this set of key bindings.
	   */
	  isCtrlKeyCommand: function isCtrlKeyCommand(e) {
	    return !!e.ctrlKey && !e.altKey;
	  },
	
	  isOptionKeyCommand: function isOptionKeyCommand(e) {
	    return isOSX && e.altKey;
	  },
	
	  hasCommandModifier: function hasCommandModifier(e) {
	    return isOSX ? !!e.metaKey && !e.altKey : KeyBindingUtil.isCtrlKeyCommand(e);
	  }
	};
	
	module.exports = KeyBindingUtil;

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findAncestorOffsetKey
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var getSelectionOffsetKeyForNode = __webpack_require__(544);
	
	/**
	 * Get the key from the node's nearest offset-aware ancestor.
	 */
	function findAncestorOffsetKey(node) {
	  var searchNode = node;
	  while (searchNode && searchNode !== document.documentElement) {
	    var key = getSelectionOffsetKeyForNode(searchNode);
	    if (key != null) {
	      return key;
	    }
	    searchNode = searchNode.parentNode;
	  }
	  return null;
	}
	
	module.exports = findAncestorOffsetKey;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEntityKeyForSelection
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var DraftEntity = __webpack_require__(117);
	
	/**
	 * Return the entity key that should be used when inserting text for the
	 * specified target selection, only if the entity is `MUTABLE`. `IMMUTABLE`
	 * and `SEGMENTED` entities should not be used for insertion behavior.
	 */
	function getEntityKeyForSelection(contentState, targetSelection) {
	  var entityKey;
	
	  if (targetSelection.isCollapsed()) {
	    var key = targetSelection.getAnchorKey();
	    var offset = targetSelection.getAnchorOffset();
	    if (offset > 0) {
	      entityKey = contentState.getBlockForKey(key).getEntityAt(offset - 1);
	      return filterKey(entityKey);
	    }
	    return null;
	  }
	
	  var startKey = targetSelection.getStartKey();
	  var startOffset = targetSelection.getStartOffset();
	  var startBlock = contentState.getBlockForKey(startKey);
	
	  entityKey = startOffset === startBlock.getLength() ? null : startBlock.getEntityAt(startOffset);
	
	  return filterKey(entityKey);
	}
	
	/**
	 * Determine whether an entity key corresponds to a `MUTABLE` entity. If so,
	 * return it. If not, return null.
	 */
	function filterKey(entityKey) {
	  if (entityKey) {
	    var entity = DraftEntity.get(entityKey);
	    return entity.getMutability() === 'MUTABLE' ? entityKey : null;
	  }
	  return null;
	}
	
	module.exports = getEntityKeyForSelection;

/***/ }),
/* 361 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule moveSelectionBackward
	 * 
	 */
	
	'use strict';
	
	/**
	 * Given a collapsed selection, move the focus `maxDistance` backward within
	 * the selected block. If the selection will go beyond the start of the block,
	 * move focus to the end of the previous block, but no further.
	 *
	 * This function is not Unicode-aware, so surrogate pairs will be treated
	 * as having length 2.
	 */
	function moveSelectionBackward(editorState, maxDistance) {
	  var selection = editorState.getSelection();
	  var content = editorState.getCurrentContent();
	  var key = selection.getStartKey();
	  var offset = selection.getStartOffset();
	
	  var focusKey = key;
	  var focusOffset = 0;
	
	  if (maxDistance > offset) {
	    var keyBefore = content.getKeyBefore(key);
	    if (keyBefore == null) {
	      focusKey = key;
	    } else {
	      focusKey = keyBefore;
	      var blockBefore = content.getBlockForKey(keyBefore);
	      focusOffset = blockBefore.getText().length;
	    }
	  } else {
	    focusOffset = offset - maxDistance;
	  }
	
	  return selection.merge({
	    focusKey: focusKey,
	    focusOffset: focusOffset,
	    isBackward: true
	  });
	}
	
	module.exports = moveSelectionBackward;

/***/ }),
/* 362 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule sanitizeDraftText
	 * 
	 */
	
	'use strict';
	
	var REGEX_BLOCK_DELIMITER = new RegExp('\r', 'g');
	
	function sanitizeDraftText(input) {
	  return input.replace(REGEX_BLOCK_DELIMITER, '');
	}
	
	module.exports = sanitizeDraftText;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var parser = __webpack_require__(183);
	var Emitter = __webpack_require__(176);
	
	/**
	 * Module exports.
	 */
	
	module.exports = Transport;
	
	/**
	 * Transport abstract constructor.
	 *
	 * @param {Object} options.
	 * @api private
	 */
	
	function Transport (opts) {
	  this.path = opts.path;
	  this.hostname = opts.hostname;
	  this.port = opts.port;
	  this.secure = opts.secure;
	  this.query = opts.query;
	  this.timestampParam = opts.timestampParam;
	  this.timestampRequests = opts.timestampRequests;
	  this.readyState = '';
	  this.agent = opts.agent || false;
	  this.socket = opts.socket;
	  this.enablesXDR = opts.enablesXDR;
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx;
	  this.key = opts.key;
	  this.passphrase = opts.passphrase;
	  this.cert = opts.cert;
	  this.ca = opts.ca;
	  this.ciphers = opts.ciphers;
	  this.rejectUnauthorized = opts.rejectUnauthorized;
	  this.forceNode = opts.forceNode;
	
	  // other options for Node.js client
	  this.extraHeaders = opts.extraHeaders;
	  this.localAddress = opts.localAddress;
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Transport.prototype);
	
	/**
	 * Emits an error.
	 *
	 * @param {String} str
	 * @return {Transport} for chaining
	 * @api public
	 */
	
	Transport.prototype.onError = function (msg, desc) {
	  var err = new Error(msg);
	  err.type = 'TransportError';
	  err.description = desc;
	  this.emit('error', err);
	  return this;
	};
	
	/**
	 * Opens the transport.
	 *
	 * @api public
	 */
	
	Transport.prototype.open = function () {
	  if ('closed' === this.readyState || '' === this.readyState) {
	    this.readyState = 'opening';
	    this.doOpen();
	  }
	
	  return this;
	};
	
	/**
	 * Closes the transport.
	 *
	 * @api private
	 */
	
	Transport.prototype.close = function () {
	  if ('opening' === this.readyState || 'open' === this.readyState) {
	    this.doClose();
	    this.onClose();
	  }
	
	  return this;
	};
	
	/**
	 * Sends multiple packets.
	 *
	 * @param {Array} packets
	 * @api private
	 */
	
	Transport.prototype.send = function (packets) {
	  if ('open' === this.readyState) {
	    this.write(packets);
	  } else {
	    throw new Error('Transport not open');
	  }
	};
	
	/**
	 * Called upon open
	 *
	 * @api private
	 */
	
	Transport.prototype.onOpen = function () {
	  this.readyState = 'open';
	  this.writable = true;
	  this.emit('open');
	};
	
	/**
	 * Called with data.
	 *
	 * @param {String} data
	 * @api private
	 */
	
	Transport.prototype.onData = function (data) {
	  var packet = parser.decodePacket(data, this.socket.binaryType);
	  this.onPacket(packet);
	};
	
	/**
	 * Called with a decoded packet.
	 */
	
	Transport.prototype.onPacket = function (packet) {
	  this.emit('packet', packet);
	};
	
	/**
	 * Called upon close.
	 *
	 * @api private
	 */
	
	Transport.prototype.onClose = function () {
	  this.readyState = 'closed';
	  this.emit('close');
	};


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// browser shim for xmlhttprequest module
	
	var hasCORS = __webpack_require__(1358);
	
	module.exports = function (opts) {
	  var xdomain = opts.xdomain;
	
	  // scheme must be same when usign XDomainRequest
	  // http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx
	  var xscheme = opts.xscheme;
	
	  // XDomainRequest has a flow of not sending cookie, therefore it should be disabled as a default.
	  // https://github.com/Automattic/engine.io-client/pull/217
	  var enablesXDR = opts.enablesXDR;
	
	  // XMLHttpRequest can be disabled on IE
	  try {
	    if ('undefined' !== typeof XMLHttpRequest && (!xdomain || hasCORS)) {
	      return new XMLHttpRequest();
	    }
	  } catch (e) { }
	
	  // Use XDomainRequest for IE8 if enablesXDR is true
	  // because loading bar keeps flashing when using jsonp-polling
	  // https://github.com/yujiosaka/socke.io-ie8-loading-example
	  try {
	    if ('undefined' !== typeof XDomainRequest && !xscheme && enablesXDR) {
	      return new XDomainRequest();
	    }
	  } catch (e) { }
	
	  if (!xdomain) {
	    try {
	      return new global[['Active'].concat('Object').join('X')]('Microsoft.XMLHTTP');
	    } catch (e) { }
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 365 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	module.exports = {
	  BACKSPACE: 8,
	  TAB: 9,
	  RETURN: 13,
	  ALT: 18,
	  ESC: 27,
	  SPACE: 32,
	  PAGE_UP: 33,
	  PAGE_DOWN: 34,
	  END: 35,
	  HOME: 36,
	  LEFT: 37,
	  UP: 38,
	  RIGHT: 39,
	  DOWN: 40,
	  DELETE: 46,
	  COMMA: 188,
	  PERIOD: 190,
	  A: 65,
	  Z: 90,
	  ZERO: 48,
	  NUMPAD_0: 96,
	  NUMPAD_9: 105
	};

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var getStyleProperty = __webpack_require__(1346);
	
	/**
	 * @param {DOMNode} element [description]
	 * @param {string} name Overflow style property name.
	 * @return {boolean} True if the supplied ndoe is scrollable.
	 */
	function _isNodeScrollable(element, name) {
	  var overflow = Style.get(element, name);
	  return overflow === 'auto' || overflow === 'scroll';
	}
	
	/**
	 * Utilities for querying and mutating style properties.
	 */
	var Style = {
	  /**
	   * Gets the style property for the supplied node. This will return either the
	   * computed style, if available, or the declared style.
	   *
	   * @param {DOMNode} node
	   * @param {string} name Style property name.
	   * @return {?string} Style property value.
	   */
	  get: getStyleProperty,
	
	  /**
	   * Determines the nearest ancestor of a node that is scrollable.
	   *
	   * NOTE: This can be expensive if used repeatedly or on a node nested deeply.
	   *
	   * @param {?DOMNode} node Node from which to start searching.
	   * @return {?DOMWindow|DOMElement} Scroll parent of the supplied node.
	   */
	  getScrollParent: function getScrollParent(node) {
	    if (!node) {
	      return null;
	    }
	    var ownerDocument = node.ownerDocument;
	    while (node && node !== ownerDocument.body) {
	      if (_isNodeScrollable(node, 'overflow') || _isNodeScrollable(node, 'overflowY') || _isNodeScrollable(node, 'overflowX')) {
	        return node;
	      }
	      node = node.parentNode;
	    }
	    return ownerDocument.defaultView || ownerDocument.parentWindow;
	  }
	
	};
	
	module.exports = Style;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/**
	 * Constants to represent text directionality
	 *
	 * Also defines a *global* direciton, to be used in bidi algorithms as a
	 * default fallback direciton, when no better direction is found or provided.
	 *
	 * NOTE: Use `setGlobalDir()`, or update `initGlobalDir()`, to set the initial
	 *       global direction value based on the application.
	 *
	 * Part of the implementation of Unicode Bidirectional Algorithm (UBA)
	 * Unicode Standard Annex #9 (UAX9)
	 * http://www.unicode.org/reports/tr9/
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(10);
	
	var NEUTRAL = 'NEUTRAL'; // No strong direction
	var LTR = 'LTR'; // Left-to-Right direction
	var RTL = 'RTL'; // Right-to-Left direction
	
	var globalDir = null;
	
	// == Helpers ==
	
	/**
	 * Check if a directionality value is a Strong one
	 */
	function isStrong(dir) {
	  return dir === LTR || dir === RTL;
	}
	
	/**
	 * Get string value to be used for `dir` HTML attribute or `direction` CSS
	 * property.
	 */
	function getHTMLDir(dir) {
	  !isStrong(dir) ?  false ? invariant(false, '`dir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
	  return dir === LTR ? 'ltr' : 'rtl';
	}
	
	/**
	 * Get string value to be used for `dir` HTML attribute or `direction` CSS
	 * property, but returns null if `dir` has same value as `otherDir`.
	 * `null`.
	 */
	function getHTMLDirIfDifferent(dir, otherDir) {
	  !isStrong(dir) ?  false ? invariant(false, '`dir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
	  !isStrong(otherDir) ?  false ? invariant(false, '`otherDir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
	  return dir === otherDir ? null : getHTMLDir(dir);
	}
	
	// == Global Direction ==
	
	/**
	 * Set the global direction.
	 */
	function setGlobalDir(dir) {
	  globalDir = dir;
	}
	
	/**
	 * Initialize the global direction
	 */
	function initGlobalDir() {
	  setGlobalDir(LTR);
	}
	
	/**
	 * Get the global direction
	 */
	function getGlobalDir() {
	  if (!globalDir) {
	    this.initGlobalDir();
	  }
	  !globalDir ?  false ? invariant(false, 'Global direction not set.') : invariant(false) : void 0;
	  return globalDir;
	}
	
	var UnicodeBidiDirection = {
	  // Values
	  NEUTRAL: NEUTRAL,
	  LTR: LTR,
	  RTL: RTL,
	  // Helpers
	  isStrong: isStrong,
	  getHTMLDir: getHTMLDir,
	  getHTMLDirIfDifferent: getHTMLDirIfDifferent,
	  // Global Direction
	  setGlobalDir: setGlobalDir,
	  initGlobalDir: initGlobalDir,
	  getGlobalDir: getGlobalDir
	};
	
	module.exports = UnicodeBidiDirection;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(1350);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var getDocumentScrollElement = __webpack_require__(1342);
	var getUnboundedScrollPosition = __webpack_require__(565);
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are bounded. This means that if the scroll position is
	 * negative or exceeds the element boundaries (which is possible using inertial
	 * scrolling), you will get zero or the maximum scroll position, respectively.
	 *
	 * If you need the unbound scroll position, use `getUnboundedScrollPosition`.
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	function getScrollPosition(scrollable) {
	  var documentScrollElement = getDocumentScrollElement(scrollable.ownerDocument || scrollable.document);
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    scrollable = documentScrollElement;
	  }
	  var scrollPosition = getUnboundedScrollPosition(scrollable);
	
	  var viewport = scrollable === documentScrollElement ? scrollable.ownerDocument.documentElement : scrollable;
	
	  var xMax = scrollable.scrollWidth - viewport.clientWidth;
	  var yMax = scrollable.scrollHeight - viewport.clientHeight;
	
	  scrollPosition.x = Math.max(0, Math.min(scrollPosition.x, xMax));
	  scrollPosition.y = Math.max(0, Math.min(scrollPosition.y, yMax));
	
	  return scrollPosition;
	}
	
	module.exports = getScrollPosition;

/***/ }),
/* 370 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	exports.getHashPath = getHashPath;
	exports.replaceHashPath = replaceHashPath;
	exports.getWindowPath = getWindowPath;
	exports.go = go;
	exports.getUserConfirmation = getUserConfirmation;
	exports.supportsHistory = supportsHistory;
	exports.supportsGoWithoutReloadUsingHash = supportsGoWithoutReloadUsingHash;
	
	function addEventListener(node, event, listener) {
	  if (node.addEventListener) {
	    node.addEventListener(event, listener, false);
	  } else {
	    node.attachEvent('on' + event, listener);
	  }
	}
	
	function removeEventListener(node, event, listener) {
	  if (node.removeEventListener) {
	    node.removeEventListener(event, listener, false);
	  } else {
	    node.detachEvent('on' + event, listener);
	  }
	}
	
	function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  return window.location.href.split('#')[1] || '';
	}
	
	function replaceHashPath(path) {
	  window.location.replace(window.location.pathname + window.location.search + '#' + path);
	}
	
	function getWindowPath() {
	  return window.location.pathname + window.location.search + window.location.hash;
	}
	
	function go(n) {
	  if (n) window.history.go(n);
	}
	
	function getUserConfirmation(message, callback) {
	  callback(window.confirm(message));
	}
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
	 */
	
	function supportsHistory() {
	  var ua = navigator.userAgent;
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
	    return false;
	  }
	  return window.history && 'pushState' in window.history;
	}
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	
	function supportsGoWithoutReloadUsingHash() {
	  var ua = navigator.userAgent;
	  return ua.indexOf('Firefox') === -1;
	}

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(102);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function deprecate(fn, message) {
	  return function () {
	     false ? _warning2['default'](false, '[history] ' + message) : undefined;
	    return fn.apply(this, arguments);
	  };
	}
	
	exports['default'] = deprecate;
	module.exports = exports['default'];

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(102);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? _warning2['default'](result === undefined, 'You should not "return" in a transition hook with a callback argument; call the callback instead') : undefined;
	  }
	}
	
	exports['default'] = runTransitionHook;
	module.exports = exports['default'];

/***/ }),
/* 373 */
/***/ (function(module, exports) {

	module.exports = isPromise;
	
	function isPromise(obj) {
	  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
	}


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(578),
	    setCacheAdd = __webpack_require__(1423),
	    setCacheHas = __webpack_require__(1424);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(217);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(1379);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ }),
/* 377 */
/***/ (function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ }),
/* 378 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 379 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 380 */
/***/ (function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(590),
	    isLength = __webpack_require__(591);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 382 */
/***/ (function(module, exports) {

	/**
	 * Compiles a querystring
	 * Returns string representation of the object
	 *
	 * @param {Object}
	 * @api private
	 */
	
	exports.encode = function (obj) {
	  var str = '';
	
	  for (var i in obj) {
	    if (obj.hasOwnProperty(i)) {
	      if (str.length) str += '&';
	      str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
	    }
	  }
	
	  return str;
	};
	
	/**
	 * Parses a simple querystring into an object
	 *
	 * @param {String} qs
	 * @api private
	 */
	
	exports.decode = function(qs){
	  var qry = {};
	  var pairs = qs.split('&');
	  for (var i = 0, l = pairs.length; i < l; i++) {
	    var pair = pairs[i].split('=');
	    qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
	  }
	  return qry;
	};


/***/ }),
/* 383 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var FILE = exports.FILE = '__NATIVE_FILE__';
	var URL = exports.URL = '__NATIVE_URL__';
	var TEXT = exports.TEXT = '__NATIVE_TEXT__';

/***/ }),
/* 384 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i += 1) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	
	    var valA = objA[keysA[i]];
	    var valB = objB[keysA[i]];
	
	    if (valA !== valB) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(187);
	var Danger = __webpack_require__(1479);
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactInstrumentation = __webpack_require__(95);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(394);
	var setInnerHTML = __webpack_require__(281);
	var setTextContent = __webpack_require__(623);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: { toIndex: update.toIndex, content: update.content.toString() }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	
	};
	
	module.exports = DOMChildrenOperations;

/***/ }),
/* 386 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var ReactErrorUtils = __webpack_require__(392);
	
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(16);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ }),
/* 389 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var ReactPropTypesSecret = __webpack_require__(1508);
	var propTypesFactory = __webpack_require__(596);
	
	var React = __webpack_require__(191);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(16);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var invariant = __webpack_require__(10);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = func.bind(null, a);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var ReactCurrentOwner = __webpack_require__(120);
	var ReactInstanceMap = __webpack_require__(223);
	var ReactInstrumentation = __webpack_require__(95);
	var ReactUpdates = __webpack_require__(103);
	
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(16);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ }),
/* 394 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 395 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ }),
/* 396 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ }),
/* 397 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(64);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ }),
/* 399 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(20);
	
	var emptyFunction = __webpack_require__(59);
	var warning = __webpack_require__(16);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.storeShape = exports.subscriptionShape = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subscriptionShape = exports.subscriptionShape = _propTypes2.default.shape({
	  trySubscribe: _propTypes2.default.func.isRequired,
	  tryUnsubscribe: _propTypes2.default.func.isRequired,
	  notifyNestedSubs: _propTypes2.default.func.isRequired,
	  isSubscribed: _propTypes2.default.func.isRequired
	});
	
	var storeShape = exports.storeShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  dispatch: _propTypes2.default.func.isRequired,
	  getState: _propTypes2.default.func.isRequired
	});

/***/ }),
/* 402 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.router = exports.routes = exports.route = exports.components = exports.component = exports.location = exports.history = exports.falsy = exports.locationShape = exports.routerShape = undefined;
	
	var _react = __webpack_require__(1);
	
	var _deprecateObjectProperties = __webpack_require__(284);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _InternalPropTypes = __webpack_require__(164);
	
	var InternalPropTypes = _interopRequireWildcard(_InternalPropTypes);
	
	var _routerWarning = __webpack_require__(46);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	var routerShape = exports.routerShape = shape({
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired,
	  setRouteLeaveHook: func.isRequired,
	  isActive: func.isRequired
	});
	
	var locationShape = exports.locationShape = shape({
	  pathname: string.isRequired,
	  search: string.isRequired,
	  state: object,
	  action: string.isRequired,
	  key: string
	});
	
	// Deprecated stuff below:
	
	var falsy = exports.falsy = InternalPropTypes.falsy;
	var history = exports.history = InternalPropTypes.history;
	var location = exports.location = locationShape;
	var component = exports.component = InternalPropTypes.component;
	var components = exports.components = InternalPropTypes.components;
	var route = exports.route = InternalPropTypes.route;
	var routes = exports.routes = InternalPropTypes.routes;
	var router = exports.router = routerShape;
	
	if (false) {
	  (function () {
	    var deprecatePropType = function deprecatePropType(propType, message) {
	      return function () {
	        process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	        return propType.apply(undefined, arguments);
	      };
	    };
	
	    var deprecateInternalPropType = function deprecateInternalPropType(propType) {
	      return deprecatePropType(propType, 'This prop type is not intended for external use, and was previously exported by mistake. These internal prop types are deprecated for external use, and will be removed in a later version.');
	    };
	
	    var deprecateRenamedPropType = function deprecateRenamedPropType(propType, name) {
	      return deprecatePropType(propType, 'The `' + name + '` prop type is now exported as `' + name + 'Shape` to avoid name conflicts. This export is deprecated and will be removed in a later version.');
	    };
	
	    exports.falsy = falsy = deprecateInternalPropType(falsy);
	    exports.history = history = deprecateInternalPropType(history);
	    exports.component = component = deprecateInternalPropType(component);
	    exports.components = components = deprecateInternalPropType(components);
	    exports.route = route = deprecateInternalPropType(route);
	    exports.routes = routes = deprecateInternalPropType(routes);
	
	    exports.location = location = deprecateRenamedPropType(location, 'location');
	    exports.router = router = deprecateRenamedPropType(router, 'router');
	  })();
	}
	
	var defaultExport = {
	  falsy: falsy,
	  history: history,
	  location: location,
	  component: component,
	  components: components,
	  route: route,
	  // For some reason, routes was never here.
	  router: router
	};
	
	if (false) {
	  defaultExport = (0, _deprecateObjectProperties2.default)(defaultExport, 'The default export from `react-router/lib/PropTypes` is deprecated. Please use the named exports instead.');
	}
	
	exports.default = defaultExport;

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(46);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(1564);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(1561);
	
	var _isActive2 = __webpack_require__(1568);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(1565);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(1570);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	  function isActive(location) {
	    var indexOnlyOrDeprecatedQuery = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	    var deprecatedIndexOnly = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	    var indexOnly = void 0;
	    if (indexOnlyOrDeprecatedQuery && indexOnlyOrDeprecatedQuery !== true || deprecatedIndexOnly !== null) {
	       false ? (0, _routerWarning2.default)(false, '`isActive(pathname, query, indexOnly) is deprecated; use `isActive(location, indexOnly)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      location = { pathname: location, query: indexOnlyOrDeprecatedQuery };
	      indexOnly = deprecatedIndexOnly || false;
	    } else {
	      location = history.createLocation(location);
	      indexOnly = indexOnlyOrDeprecatedQuery;
	    }
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState);
	
	    var leaveRoutes = _computeChangedRoutes.leaveRoutes;
	    var changeRoutes = _computeChangedRoutes.changeRoutes;
	    var enterRoutes = _computeChangedRoutes.enterRoutes;
	
	
	    (0, _TransitionUtils.runLeaveHooks)(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    (0, _TransitionUtils.runChangeHooks)(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      (0, _TransitionUtils.runEnterHooks)(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.reduce(function (hooks, route) {
	      hooks.push.apply(hooks, RouteHooks[getRouteID(route)]);
	      return hooks;
	    }, []);
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route, false);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    // TODO: Warn if they register for a route that isn't currently
	    // active. They're probably doing something wrong, like re-creating
	    // route objects on every location change.
	    var routeID = getRouteID(route);
	    var hooks = RouteHooks[routeID];
	
	    if (!hooks) {
	      var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	
	      RouteHooks[routeID] = [hook];
	
	      if (thereWereNoRouteHooks) {
	        // setup transition & beforeunload hooks
	        unlistenBefore = history.listenBefore(transitionHook);
	
	        if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	      }
	    } else {
	      if (hooks.indexOf(hook) === -1) {
	         false ? (0, _routerWarning2.default)(false, 'adding multiple leave hooks for the same route is deprecated; manage multiple confirmations in your own code instead') : void 0;
	
	        hooks.push(hook);
	      }
	    }
	
	    return function () {
	      var hooks = RouteHooks[routeID];
	
	      if (hooks) {
	        var newHooks = hooks.filter(function (item) {
	          return item !== hook;
	        });
	
	        if (newHooks.length === 0) {
	          removeListenBeforeHooksForRoute(route);
	        } else {
	          RouteHooks[routeID] = newHooks;
	        }
	      }
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    // TODO: Only use a single history listener. Otherwise we'll
	    // end up with multiple concurrent calls to match.
	    return history.listen(function (location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    });
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	
	//export default useRoutes
	
	module.exports = exports['default'];

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(193);
	
	var ReactNoopUpdateQueue = __webpack_require__(406);
	
	var canDefineProperty = __webpack_require__(640);
	var emptyObject = __webpack_require__(216);
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(16);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(16);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 407 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var getDisplayName = function getDisplayName(Component) {
	  if (typeof Component === 'string') {
	    return Component;
	  }
	
	  if (!Component) {
	    return undefined;
	  }
	
	  return Component.displayName || Component.name || 'Component';
	};
	
	exports.default = getDisplayName;

/***/ }),
/* 408 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var isClassComponent = function isClassComponent(Component) {
	  return Boolean(Component && Component.prototype && typeof Component.prototype.isReactComponent === 'object');
	};
	
	exports.default = isClassComponent;

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* global window */
	'use strict';
	
	module.exports = __webpack_require__(1602)(global || window || this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHelper = __webpack_require__(30);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var setStatic = function setStatic(key, value) {
	  return function (BaseComponent) {
	    /* eslint-disable no-param-reassign */
	    BaseComponent[key] = value;
	    /* eslint-enable no-param-reassign */
	    return BaseComponent;
	  };
	};
	
	exports.default = (0, _createHelper2.default)(setStatic, 'setStatic', false);

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _createHelper = __webpack_require__(30);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _createEagerFactory = __webpack_require__(53);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var shouldUpdate = function shouldUpdate(test) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	    return function (_Component) {
	      _inherits(_class, _Component);
	
	      function _class() {
	        _classCallCheck(this, _class);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      _class.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return test(this.props, nextProps);
	      };
	
	      _class.prototype.render = function render() {
	        return factory(this.props);
	      };
	
	      return _class;
	    }(_react.Component);
	  };
	};
	
	exports.default = (0, _createHelper2.default)(shouldUpdate, 'shouldUpdate');

/***/ }),
/* 412 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var omit = function omit(obj, keys) {
	  var rest = _objectWithoutProperties(obj, []);
	
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (rest.hasOwnProperty(key)) {
	      delete rest[key];
	    }
	  }
	  return rest;
	};
	
	exports.default = omit;

/***/ }),
/* 413 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var pick = function pick(obj, keys) {
	  var result = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (obj.hasOwnProperty(key)) {
	      result[key] = obj[key];
	    }
	  }
	  return result;
	};
	
	exports.default = pick;

/***/ }),
/* 414 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var ADD_ARRAY_VALUE = exports.ADD_ARRAY_VALUE = 'redux-form/ADD_ARRAY_VALUE';
	var AUTOFILL = exports.AUTOFILL = 'redux-form/AUTOFILL';
	var BLUR = exports.BLUR = 'redux-form/BLUR';
	var CHANGE = exports.CHANGE = 'redux-form/CHANGE';
	var DESTROY = exports.DESTROY = 'redux-form/DESTROY';
	var FOCUS = exports.FOCUS = 'redux-form/FOCUS';
	var INITIALIZE = exports.INITIALIZE = 'redux-form/INITIALIZE';
	var REMOVE_ARRAY_VALUE = exports.REMOVE_ARRAY_VALUE = 'redux-form/REMOVE_ARRAY_VALUE';
	var RESET = exports.RESET = 'redux-form/RESET';
	var START_ASYNC_VALIDATION = exports.START_ASYNC_VALIDATION = 'redux-form/START_ASYNC_VALIDATION';
	var START_SUBMIT = exports.START_SUBMIT = 'redux-form/START_SUBMIT';
	var STOP_ASYNC_VALIDATION = exports.STOP_ASYNC_VALIDATION = 'redux-form/STOP_ASYNC_VALIDATION';
	var STOP_SUBMIT = exports.STOP_SUBMIT = 'redux-form/STOP_SUBMIT';
	var SUBMIT_FAILED = exports.SUBMIT_FAILED = 'redux-form/SUBMIT_FAILED';
	var SWAP_ARRAY_VALUES = exports.SWAP_ARRAY_VALUES = 'redux-form/SWAP_ARRAY_VALUES';
	var TOUCH = exports.TOUCH = 'redux-form/TOUCH';
	var UNTOUCH = exports.UNTOUCH = 'redux-form/UNTOUCH';

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.untouchWithKey = exports.untouch = exports.touchWithKey = exports.touch = exports.swapArrayValues = exports.stopSubmit = exports.stopAsyncValidation = exports.startSubmit = exports.startAsyncValidation = exports.reset = exports.propTypes = exports.initializeWithKey = exports.initialize = exports.getValues = exports.removeArrayValue = exports.reduxForm = exports.reducer = exports.focus = exports.destroy = exports.changeWithKey = exports.change = exports.blur = exports.autofillWithKey = exports.autofill = exports.addArrayValue = exports.actionTypes = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _createAll2 = __webpack_require__(1621);
	
	var _createAll3 = _interopRequireDefault(_createAll2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';
	
	var _createAll = (0, _createAll3.default)(isNative, _react2.default, _reactRedux.connect);
	
	var actionTypes = _createAll.actionTypes,
	    addArrayValue = _createAll.addArrayValue,
	    autofill = _createAll.autofill,
	    autofillWithKey = _createAll.autofillWithKey,
	    blur = _createAll.blur,
	    change = _createAll.change,
	    changeWithKey = _createAll.changeWithKey,
	    destroy = _createAll.destroy,
	    focus = _createAll.focus,
	    reducer = _createAll.reducer,
	    reduxForm = _createAll.reduxForm,
	    removeArrayValue = _createAll.removeArrayValue,
	    getValues = _createAll.getValues,
	    initialize = _createAll.initialize,
	    initializeWithKey = _createAll.initializeWithKey,
	    propTypes = _createAll.propTypes,
	    reset = _createAll.reset,
	    startAsyncValidation = _createAll.startAsyncValidation,
	    startSubmit = _createAll.startSubmit,
	    stopAsyncValidation = _createAll.stopAsyncValidation,
	    stopSubmit = _createAll.stopSubmit,
	    swapArrayValues = _createAll.swapArrayValues,
	    touch = _createAll.touch,
	    touchWithKey = _createAll.touchWithKey,
	    untouch = _createAll.untouch,
	    untouchWithKey = _createAll.untouchWithKey;
	exports.actionTypes = actionTypes;
	exports.addArrayValue = addArrayValue;
	exports.autofill = autofill;
	exports.autofillWithKey = autofillWithKey;
	exports.blur = blur;
	exports.change = change;
	exports.changeWithKey = changeWithKey;
	exports.destroy = destroy;
	exports.focus = focus;
	exports.reducer = reducer;
	exports.reduxForm = reduxForm;
	exports.removeArrayValue = removeArrayValue;
	exports.getValues = getValues;
	exports.initialize = initialize;
	exports.initializeWithKey = initializeWithKey;
	exports.propTypes = propTypes;
	exports.reset = reset;
	exports.startAsyncValidation = startAsyncValidation;
	exports.startSubmit = startSubmit;
	exports.stopAsyncValidation = stopAsyncValidation;
	exports.stopSubmit = stopSubmit;
	exports.swapArrayValues = swapArrayValues;
	exports.touch = touch;
	exports.touchWithKey = touchWithKey;
	exports.untouch = untouch;
	exports.untouchWithKey = untouchWithKey;

/***/ }),
/* 416 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = mapValues;
	/**
	 * Maps all the values in the given object through the given function and saves them, by key, to a result object
	 */
	function mapValues(obj, fn) {
	  return obj ? Object.keys(obj).reduce(function (accumulator, key) {
	    var _extends2;
	
	    return _extends({}, accumulator, (_extends2 = {}, _extends2[key] = fn(obj[key], key), _extends2));
	  }, {}) : obj;
	}

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.initialState = exports.globalErrorKey = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _initialState, _behaviors;
	
	var _actionTypes = __webpack_require__(414);
	
	var _mapValues = __webpack_require__(416);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _read = __webpack_require__(658);
	
	var _read2 = _interopRequireDefault(_read);
	
	var _write = __webpack_require__(659);
	
	var _write2 = _interopRequireDefault(_write);
	
	var _getValuesFromState = __webpack_require__(655);
	
	var _getValuesFromState2 = _interopRequireDefault(_getValuesFromState);
	
	var _initializeState = __webpack_require__(656);
	
	var _initializeState2 = _interopRequireDefault(_initializeState);
	
	var _resetState = __webpack_require__(1637);
	
	var _resetState2 = _interopRequireDefault(_resetState);
	
	var _setErrors = __webpack_require__(1638);
	
	var _setErrors2 = _interopRequireDefault(_setErrors);
	
	var _fieldValue = __webpack_require__(194);
	
	var _normalizeFields = __webpack_require__(1633);
	
	var _normalizeFields2 = _interopRequireDefault(_normalizeFields);
	
	var _createInitialState = __webpack_require__(648);
	
	var _createInitialState2 = _interopRequireDefault(_createInitialState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var globalErrorKey = exports.globalErrorKey = '_error';
	
	var initialState = exports.initialState = (_initialState = {
	  _active: undefined,
	  _asyncValidating: false
	}, _initialState[globalErrorKey] = undefined, _initialState._initialized = false, _initialState._submitting = false, _initialState._submitFailed = false, _initialState);
	
	var behaviors = (_behaviors = {}, _behaviors[_actionTypes.ADD_ARRAY_VALUE] = function (state, _ref) {
	  var path = _ref.path,
	      index = _ref.index,
	      value = _ref.value,
	      fields = _ref.fields;
	
	  var array = (0, _read2.default)(path, state);
	  var stateCopy = _extends({}, state);
	  var arrayCopy = array ? [].concat(array) : [];
	  var newValue = value !== null && typeof value === 'object' ? (0, _initializeState2.default)(value, fields || Object.keys(value)) : (0, _fieldValue.makeFieldValue)({ value: value });
	  if (index === undefined) {
	    arrayCopy.push(newValue);
	  } else {
	    arrayCopy.splice(index, 0, newValue);
	  }
	  return (0, _write2.default)(path, arrayCopy, stateCopy);
	}, _behaviors[_actionTypes.AUTOFILL] = function (state, _ref2) {
	  var field = _ref2.field,
	      value = _ref2.value;
	
	  return (0, _write2.default)(field, function (previous) {
	    var _previous$value$autof = _extends({}, previous, { value: value, autofilled: true }),
	        asyncError = _previous$value$autof.asyncError,
	        submitError = _previous$value$autof.submitError,
	        result = _objectWithoutProperties(_previous$value$autof, ['asyncError', 'submitError']);
	
	    return (0, _fieldValue.makeFieldValue)(result);
	  }, state);
	}, _behaviors[_actionTypes.BLUR] = function (state, _ref3) {
	  var field = _ref3.field,
	      value = _ref3.value,
	      touch = _ref3.touch;
	
	  var _active = state._active,
	      stateCopy = _objectWithoutProperties(state, ['_active']);
	
	  if (_active && _active !== field) {
	    // remove _active from state
	    stateCopy._active = _active;
	  }
	  return (0, _write2.default)(field, function (previous) {
	    var result = _extends({}, previous);
	    if (value !== undefined) {
	      result.value = value;
	    }
	    if (touch) {
	      result.touched = true;
	    }
	    return (0, _fieldValue.makeFieldValue)(result);
	  }, stateCopy);
	}, _behaviors[_actionTypes.CHANGE] = function (state, _ref4) {
	  var field = _ref4.field,
	      value = _ref4.value,
	      touch = _ref4.touch;
	
	  return (0, _write2.default)(field, function (previous) {
	    var _previous$value = _extends({}, previous, { value: value }),
	        asyncError = _previous$value.asyncError,
	        submitError = _previous$value.submitError,
	        autofilled = _previous$value.autofilled,
	        result = _objectWithoutProperties(_previous$value, ['asyncError', 'submitError', 'autofilled']);
	
	    if (touch) {
	      result.touched = true;
	    }
	    return (0, _fieldValue.makeFieldValue)(result);
	  }, state);
	}, _behaviors[_actionTypes.DESTROY] = function () {
	  return undefined;
	}, _behaviors[_actionTypes.FOCUS] = function (state, _ref5) {
	  var field = _ref5.field;
	
	  var stateCopy = (0, _write2.default)(field, function (previous) {
	    return (0, _fieldValue.makeFieldValue)(_extends({}, previous, { visited: true }));
	  }, state);
	  stateCopy._active = field;
	  return stateCopy;
	}, _behaviors[_actionTypes.INITIALIZE] = function (state, _ref6) {
	  var data = _ref6.data,
	      fields = _ref6.fields,
	      overwriteValues = _ref6.overwriteValues;
	
	  return (0, _createInitialState2.default)(data, fields, state, overwriteValues);
	}, _behaviors[_actionTypes.REMOVE_ARRAY_VALUE] = function (state, _ref7) {
	  var path = _ref7.path,
	      index = _ref7.index;
	
	  var array = (0, _read2.default)(path, state);
	  var stateCopy = _extends({}, state);
	  var arrayCopy = array ? [].concat(array) : [];
	  if (index === undefined) {
	    arrayCopy.pop();
	  } else if (isNaN(index)) {
	    delete arrayCopy[index];
	  } else {
	    arrayCopy.splice(index, 1);
	  }
	  return (0, _write2.default)(path, arrayCopy, stateCopy);
	}, _behaviors[_actionTypes.RESET] = function (state) {
	  var _extends2;
	
	  return _extends({}, (0, _resetState2.default)(state), (_extends2 = {
	    _active: undefined,
	    _asyncValidating: false
	  }, _extends2[globalErrorKey] = undefined, _extends2._initialized = state._initialized, _extends2._submitting = false, _extends2._submitFailed = false, _extends2));
	}, _behaviors[_actionTypes.START_ASYNC_VALIDATION] = function (state, _ref8) {
	  var field = _ref8.field;
	
	  return _extends({}, state, {
	    _asyncValidating: field || true
	  });
	}, _behaviors[_actionTypes.START_SUBMIT] = function (state) {
	  return _extends({}, state, {
	    _submitting: true
	  });
	}, _behaviors[_actionTypes.STOP_ASYNC_VALIDATION] = function (state, _ref9) {
	  var _extends3;
	
	  var errors = _ref9.errors;
	
	  return _extends({}, (0, _setErrors2.default)(state, errors, 'asyncError'), (_extends3 = {
	    _asyncValidating: false
	  }, _extends3[globalErrorKey] = errors && errors[globalErrorKey], _extends3));
	}, _behaviors[_actionTypes.STOP_SUBMIT] = function (state, _ref10) {
	  var _extends4;
	
	  var errors = _ref10.errors;
	
	  return _extends({}, (0, _setErrors2.default)(state, errors, 'submitError'), (_extends4 = {}, _extends4[globalErrorKey] = errors && errors[globalErrorKey], _extends4._submitting = false, _extends4._submitFailed = !!(errors && Object.keys(errors).length), _extends4));
	}, _behaviors[_actionTypes.SUBMIT_FAILED] = function (state) {
	  return _extends({}, state, {
	    _submitFailed: true
	  });
	}, _behaviors[_actionTypes.SWAP_ARRAY_VALUES] = function (state, _ref11) {
	  var path = _ref11.path,
	      indexA = _ref11.indexA,
	      indexB = _ref11.indexB;
	
	  var array = (0, _read2.default)(path, state);
	  var arrayLength = array.length;
	  if (indexA === indexB || isNaN(indexA) || isNaN(indexB) || indexA >= arrayLength || indexB >= arrayLength) {
	    return state; // do nothing
	  }
	  var stateCopy = _extends({}, state);
	  var arrayCopy = [].concat(array);
	  arrayCopy[indexA] = array[indexB];
	  arrayCopy[indexB] = array[indexA];
	  return (0, _write2.default)(path, arrayCopy, stateCopy);
	}, _behaviors[_actionTypes.TOUCH] = function (state, _ref12) {
	  var fields = _ref12.fields;
	
	  return _extends({}, state, fields.reduce(function (accumulator, field) {
	    return (0, _write2.default)(field, function (value) {
	      return (0, _fieldValue.makeFieldValue)(_extends({}, value, { touched: true }));
	    }, accumulator);
	  }, state));
	}, _behaviors[_actionTypes.UNTOUCH] = function (state, _ref13) {
	  var fields = _ref13.fields;
	
	  return _extends({}, state, fields.reduce(function (accumulator, field) {
	    return (0, _write2.default)(field, function (value) {
	      if (value) {
	        var touched = value.touched,
	            rest = _objectWithoutProperties(value, ['touched']);
	
	        return (0, _fieldValue.makeFieldValue)(rest);
	      }
	      return (0, _fieldValue.makeFieldValue)(value);
	    }, accumulator);
	  }, state));
	}, _behaviors);
	
	var reducer = function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var behavior = behaviors[action.type];
	  return behavior ? behavior(state, action) : state;
	};
	
	function formReducer() {
	  var _extends10;
	
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var form = action.form,
	      key = action.key,
	      rest = _objectWithoutProperties(action, ['form', 'key']); // eslint-disable-line no-redeclare
	
	
	  if (!form) {
	    return state;
	  }
	  if (key) {
	    var _extends7, _extends8;
	
	    if (action.type === _actionTypes.DESTROY) {
	      var _extends6;
	
	      return _extends({}, state, (_extends6 = {}, _extends6[form] = state[form] && Object.keys(state[form]).reduce(function (accumulator, stateKey) {
	        var _extends5;
	
	        return stateKey === key ? accumulator : _extends({}, accumulator, (_extends5 = {}, _extends5[stateKey] = state[form][stateKey], _extends5));
	      }, {}), _extends6));
	    }
	    return _extends({}, state, (_extends8 = {}, _extends8[form] = _extends({}, state[form], (_extends7 = {}, _extends7[key] = reducer((state[form] || {})[key], rest), _extends7)), _extends8));
	  }
	  if (action.type === _actionTypes.DESTROY) {
	    return Object.keys(state).reduce(function (accumulator, formName) {
	      var _extends9;
	
	      return formName === form ? accumulator : _extends({}, accumulator, (_extends9 = {}, _extends9[formName] = state[formName], _extends9));
	    }, {});
	  }
	  return _extends({}, state, (_extends10 = {}, _extends10[form] = reducer(state[form], rest), _extends10));
	}
	
	/**
	 * Adds additional functionality to the reducer
	 */
	function decorate(target) {
	  target.plugin = function plugin(reducers) {
	    var _this = this;
	
	    // use 'function' keyword to enable 'this'
	    return decorate(function () {
	      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var result = _this(state, action);
	      return _extends({}, result, (0, _mapValues2.default)(reducers, function (pluginReducer, key) {
	        return pluginReducer(result[key] || initialState, action);
	      }));
	    });
	  };
	
	  target.normalize = function normalize(normalizers) {
	    var _this2 = this;
	
	    // use 'function' keyword to enable 'this'
	    return decorate(function () {
	      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var result = _this2(state, action);
	      return _extends({}, result, (0, _mapValues2.default)(normalizers, function (formNormalizers, form) {
	        var runNormalize = function runNormalize(previous, currentResult) {
	          var previousValues = (0, _getValuesFromState2.default)(_extends({}, initialState, previous));
	          var formResult = _extends({}, initialState, currentResult);
	          var values = (0, _getValuesFromState2.default)(formResult);
	          return (0, _normalizeFields2.default)(formNormalizers, formResult, previous, values, previousValues);
	        };
	        if (action.key) {
	          var _extends11;
	
	          return _extends({}, result[form], (_extends11 = {}, _extends11[action.key] = runNormalize(state[form][action.key], result[form][action.key]), _extends11));
	        }
	        return runNormalize(state[form], result[form]);
	      }));
	    });
	  };
	
	  return target;
	}
	
	exports.default = decorate(formReducer);

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(118);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(2312);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	};
	
	/**
	 * Creates a Redux store that holds the state tree.
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [preloadedState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} enhancer The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i]();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/zenparsing/es-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var debug = __webpack_require__(116)('socket.io-parser');
	var Emitter = __webpack_require__(176);
	var hasBin = __webpack_require__(569);
	var binary = __webpack_require__(1657);
	var isBuf = __webpack_require__(668);
	
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	exports.protocol = 4;
	
	/**
	 * Packet types.
	 *
	 * @api public
	 */
	
	exports.types = [
	  'CONNECT',
	  'DISCONNECT',
	  'EVENT',
	  'ACK',
	  'ERROR',
	  'BINARY_EVENT',
	  'BINARY_ACK'
	];
	
	/**
	 * Packet type `connect`.
	 *
	 * @api public
	 */
	
	exports.CONNECT = 0;
	
	/**
	 * Packet type `disconnect`.
	 *
	 * @api public
	 */
	
	exports.DISCONNECT = 1;
	
	/**
	 * Packet type `event`.
	 *
	 * @api public
	 */
	
	exports.EVENT = 2;
	
	/**
	 * Packet type `ack`.
	 *
	 * @api public
	 */
	
	exports.ACK = 3;
	
	/**
	 * Packet type `error`.
	 *
	 * @api public
	 */
	
	exports.ERROR = 4;
	
	/**
	 * Packet type 'binary event'
	 *
	 * @api public
	 */
	
	exports.BINARY_EVENT = 5;
	
	/**
	 * Packet type `binary ack`. For acks with binary arguments.
	 *
	 * @api public
	 */
	
	exports.BINARY_ACK = 6;
	
	/**
	 * Encoder constructor.
	 *
	 * @api public
	 */
	
	exports.Encoder = Encoder;
	
	/**
	 * Decoder constructor.
	 *
	 * @api public
	 */
	
	exports.Decoder = Decoder;
	
	/**
	 * A socket.io Encoder instance
	 *
	 * @api public
	 */
	
	function Encoder() {}
	
	/**
	 * Encode a packet as a single string if non-binary, or as a
	 * buffer sequence, depending on packet type.
	 *
	 * @param {Object} obj - packet object
	 * @param {Function} callback - function to handle encodings (likely engine.write)
	 * @return Calls callback with Array of encodings
	 * @api public
	 */
	
	Encoder.prototype.encode = function(obj, callback){
	  if ((obj.type === exports.EVENT || obj.type === exports.ACK) && hasBin(obj.data)) {
	    obj.type = obj.type === exports.EVENT ? exports.BINARY_EVENT : exports.BINARY_ACK;
	  }
	
	  debug('encoding packet %j', obj);
	
	  if (exports.BINARY_EVENT === obj.type || exports.BINARY_ACK === obj.type) {
	    encodeAsBinary(obj, callback);
	  }
	  else {
	    var encoding = encodeAsString(obj);
	    callback([encoding]);
	  }
	};
	
	/**
	 * Encode packet as string.
	 *
	 * @param {Object} packet
	 * @return {String} encoded
	 * @api private
	 */
	
	function encodeAsString(obj) {
	
	  // first is type
	  var str = '' + obj.type;
	
	  // attachments if we have them
	  if (exports.BINARY_EVENT === obj.type || exports.BINARY_ACK === obj.type) {
	    str += obj.attachments + '-';
	  }
	
	  // if we have a namespace other than `/`
	  // we append it followed by a comma `,`
	  if (obj.nsp && '/' !== obj.nsp) {
	    str += obj.nsp + ',';
	  }
	
	  // immediately followed by the id
	  if (null != obj.id) {
	    str += obj.id;
	  }
	
	  // json data
	  if (null != obj.data) {
	    str += JSON.stringify(obj.data);
	  }
	
	  debug('encoded %j as %s', obj, str);
	  return str;
	}
	
	/**
	 * Encode packet as 'buffer sequence' by removing blobs, and
	 * deconstructing packet into object with placeholders and
	 * a list of buffers.
	 *
	 * @param {Object} packet
	 * @return {Buffer} encoded
	 * @api private
	 */
	
	function encodeAsBinary(obj, callback) {
	
	  function writeEncoding(bloblessData) {
	    var deconstruction = binary.deconstructPacket(bloblessData);
	    var pack = encodeAsString(deconstruction.packet);
	    var buffers = deconstruction.buffers;
	
	    buffers.unshift(pack); // add packet info to beginning of data list
	    callback(buffers); // write all the buffers
	  }
	
	  binary.removeBlobs(obj, writeEncoding);
	}
	
	/**
	 * A socket.io Decoder instance
	 *
	 * @return {Object} decoder
	 * @api public
	 */
	
	function Decoder() {
	  this.reconstructor = null;
	}
	
	/**
	 * Mix in `Emitter` with Decoder.
	 */
	
	Emitter(Decoder.prototype);
	
	/**
	 * Decodes an ecoded packet string into packet JSON.
	 *
	 * @param {String} obj - encoded packet
	 * @return {Object} packet
	 * @api public
	 */
	
	Decoder.prototype.add = function(obj) {
	  var packet;
	  if (typeof obj === 'string') {
	    packet = decodeString(obj);
	    if (exports.BINARY_EVENT === packet.type || exports.BINARY_ACK === packet.type) { // binary packet's json
	      this.reconstructor = new BinaryReconstructor(packet);
	
	      // no attachments, labeled binary but no binary data to follow
	      if (this.reconstructor.reconPack.attachments === 0) {
	        this.emit('decoded', packet);
	      }
	    } else { // non-binary full packet
	      this.emit('decoded', packet);
	    }
	  }
	  else if (isBuf(obj) || obj.base64) { // raw binary data
	    if (!this.reconstructor) {
	      throw new Error('got binary data when not reconstructing a packet');
	    } else {
	      packet = this.reconstructor.takeBinaryData(obj);
	      if (packet) { // received final buffer
	        this.reconstructor = null;
	        this.emit('decoded', packet);
	      }
	    }
	  }
	  else {
	    throw new Error('Unknown type: ' + obj);
	  }
	};
	
	/**
	 * Decode a packet String (JSON data)
	 *
	 * @param {String} str
	 * @return {Object} packet
	 * @api private
	 */
	
	function decodeString(str) {
	  var i = 0;
	  // look up type
	  var p = {
	    type: Number(str.charAt(0))
	  };
	
	  if (null == exports.types[p.type]) return error();
	
	  // look up attachments if type binary
	  if (exports.BINARY_EVENT === p.type || exports.BINARY_ACK === p.type) {
	    var buf = '';
	    while (str.charAt(++i) !== '-') {
	      buf += str.charAt(i);
	      if (i == str.length) break;
	    }
	    if (buf != Number(buf) || str.charAt(i) !== '-') {
	      throw new Error('Illegal attachments');
	    }
	    p.attachments = Number(buf);
	  }
	
	  // look up namespace (if any)
	  if ('/' === str.charAt(i + 1)) {
	    p.nsp = '';
	    while (++i) {
	      var c = str.charAt(i);
	      if (',' === c) break;
	      p.nsp += c;
	      if (i === str.length) break;
	    }
	  } else {
	    p.nsp = '/';
	  }
	
	  // look up id
	  var next = str.charAt(i + 1);
	  if ('' !== next && Number(next) == next) {
	    p.id = '';
	    while (++i) {
	      var c = str.charAt(i);
	      if (null == c || Number(c) != c) {
	        --i;
	        break;
	      }
	      p.id += str.charAt(i);
	      if (i === str.length) break;
	    }
	    p.id = Number(p.id);
	  }
	
	  // look up json data
	  if (str.charAt(++i)) {
	    p = tryParse(p, str.substr(i));
	  }
	
	  debug('decoded %s as %j', str, p);
	  return p;
	}
	
	function tryParse(p, str) {
	  try {
	    p.data = JSON.parse(str);
	  } catch(e){
	    return error();
	  }
	  return p; 
	}
	
	/**
	 * Deallocates a parser's resources
	 *
	 * @api public
	 */
	
	Decoder.prototype.destroy = function() {
	  if (this.reconstructor) {
	    this.reconstructor.finishedReconstruction();
	  }
	};
	
	/**
	 * A manager of a binary event's 'buffer sequence'. Should
	 * be constructed whenever a packet of type BINARY_EVENT is
	 * decoded.
	 *
	 * @param {Object} packet
	 * @return {BinaryReconstructor} initialized reconstructor
	 * @api private
	 */
	
	function BinaryReconstructor(packet) {
	  this.reconPack = packet;
	  this.buffers = [];
	}
	
	/**
	 * Method to be called when binary data received from connection
	 * after a BINARY_EVENT packet.
	 *
	 * @param {Buffer | ArrayBuffer} binData - the raw binary data received
	 * @return {null | Object} returns null if more binary data is expected or
	 *   a reconstructed packet object if all buffers have been received.
	 * @api private
	 */
	
	BinaryReconstructor.prototype.takeBinaryData = function(binData) {
	  this.buffers.push(binData);
	  if (this.buffers.length === this.reconPack.attachments) { // done with buffer list
	    var packet = binary.reconstructPacket(this.reconPack, this.buffers);
	    this.finishedReconstruction();
	    return packet;
	  }
	  return null;
	};
	
	/**
	 * Cleans up binary packet reconstruction variables.
	 *
	 * @api private
	 */
	
	BinaryReconstructor.prototype.finishedReconstruction = function() {
	  this.reconPack = null;
	  this.buffers = [];
	};
	
	function error() {
	  return {
	    type: exports.ERROR,
	    data: 'parser error'
	  };
	}


/***/ }),
/* 420 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var ROLLBAR_LEVELS = exports.ROLLBAR_LEVELS = {
	    CRITICAL: 'critical',
	    ERROR: 'error',
	    WARNING: 'warning',
	    INFO: 'info',
	    DEBUG: 'debug'
	};

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchInvite = exports.logout = exports.register = exports.login = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _http = __webpack_require__(76);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _authService = __webpack_require__(227);
	
	var _formSubmissionExceptionHandler = __webpack_require__(296);
	
	var _formSubmissionExceptionHandler2 = _interopRequireDefault(_formSubmissionExceptionHandler);
	
	var _navigationActions = __webpack_require__(27);
	
	var _authConstants = __webpack_require__(136);
	
	var AUTH_ACTION_TYPES = _interopRequireWildcard(_authConstants);
	
	var _registerFormConstants = __webpack_require__(292);
	
	var _loginFormConstants = __webpack_require__(291);
	
	var _httpConstants = __webpack_require__(90);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Lib
	
	
	// Utils
	
	
	// Actions
	
	
	// Constants
	
	
	var LOGIN_REGISTER_TIMEOUT = 15000;
	
	var login = exports.login = function login(email, password) {
	    return function (dispatch, getState) {
	        dispatch({ type: AUTH_ACTION_TYPES.LOGIN_SUBMIT });
	
	        var loginConfig = {
	            method: _httpConstants.METHODS.POST,
	            url: 'auth/login',
	            timeout: LOGIN_REGISTER_TIMEOUT,
	            data: {
	                email: email.toLowerCase(),
	                password: password
	            }
	        };
	
	        return (0, _http2.default)(loginConfig).then(function (response) {
	            dispatch({ type: AUTH_ACTION_TYPES.LOGIN_SUCCESS });
	
	            var token = response.data.token;
	
	            if (!token) throw new Error('No token found');
	
	            (0, _authService.setCurrentUserToken)(response.data.token);
	            dispatch((0, _navigationActions.navigateToRootWorkspace)());
	        }).catch((0, _formSubmissionExceptionHandler2.default)({ dispatch: dispatch, getState: getState, form: _loginFormConstants.LOGIN_FORM_NAME, sensitive: true }));
	    };
	};
	
	var register = function register(_ref) {
	    var email = _ref.email,
	        rest = _objectWithoutProperties(_ref, ['email']);
	
	    return function (dispatch, getState) {
	        dispatch({ type: AUTH_ACTION_TYPES.REGISTER_SUBMIT });
	
	        var registerConfig = {
	            method: _httpConstants.METHODS.POST,
	            url: 'auth/register',
	            timeout: LOGIN_REGISTER_TIMEOUT,
	            data: _extends({
	                email: email.toLowerCase()
	            }, rest)
	        };
	
	        return (0, _http2.default)(registerConfig).then(function (response) {
	            dispatch({ type: AUTH_ACTION_TYPES.REGISTER_SUCCESS });
	
	            var token = response.data.token;
	
	            if (!token) throw new Error('No token found');
	
	            (0, _authService.setCurrentUserToken)(response.data.token);
	
	            dispatch((0, _navigationActions.navigateToRootWorkspace)());
	        }).catch((0, _formSubmissionExceptionHandler2.default)({ dispatch: dispatch, getState: getState, form: _registerFormConstants.REGISTER_FORM_NAME, sensitive: true }));
	    };
	};
	
	exports.register = register;
	var logout = exports.logout = function logout() {
	    return function (dispatch, getState) {
	        var state = getState();
	        var userId = state.getIn(['app', 'currentUser', '_id']);
	
	        (0, _authService.removeCurrentUserToken)();
	        dispatch({ type: AUTH_ACTION_TYPES.LOGOUT, userId: userId, sync: false });
	        dispatch((0, _navigationActions.navigateToLogin)());
	    };
	};
	
	var fetchInvite = exports.fetchInvite = function fetchInvite() {
	    return function (dispatch, getState) {
	        var inviteCode = getState().get('routing').locationBeforeTransitions.query.invite;
	        if (!inviteCode) return;
	
	        var inviteConfig = {
	            method: _httpConstants.METHODS.GET,
	            url: 'invite/' + inviteCode
	        };
	
	        return (0, _http2.default)(inviteConfig).then(function (response) {
	            dispatch(_extends({
	                type: AUTH_ACTION_TYPES.REGISTER_INVITE_FETCHED
	            }, response.data));
	        }).catch(function (err) {
	            return null;
	        });
	    };
	};

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getInboxLocation = exports.getCanvasLocation = exports.getGridPosition = undefined;
	
	var _gridUtils = __webpack_require__(42);
	
	var _boardConstants = __webpack_require__(17);
	
	var getGridPosition = exports.getGridPosition = function getGridPosition(domComponent, canvasPositionPx, gridSize) {
	    var domComponentRect = domComponent.getBoundingClientRect();
	    var scrollLeft = domComponent.scrollLeft,
	        scrollTop = domComponent.scrollTop;
	
	
	    return {
	        x: Math.max((0, _gridUtils.pixelsToGridPoints)(canvasPositionPx.x + scrollLeft - domComponentRect.left, gridSize), 0),
	        y: Math.max((0, _gridUtils.pixelsToGridPoints)(canvasPositionPx.y + scrollTop - domComponentRect.top, gridSize), 0)
	    };
	};
	
	var getCanvasLocation = exports.getCanvasLocation = function getCanvasLocation(domComponent, canvasPositionPx, gridSize, parentId) {
	    var position = getGridPosition(domComponent, canvasPositionPx, gridSize);
	    return {
	        location: {
	            parentId: parentId,
	            section: _boardConstants.BOARD_SECTIONS.CANVAS,
	            position: position
	        },
	        handledBy: domComponent
	    };
	};
	
	var getInboxLocation = exports.getInboxLocation = function getInboxLocation(parentId) {
	    return {
	        location: {
	            parentId: parentId,
	            section: _boardConstants.BOARD_SECTIONS.INBOX,
	            position: {
	                index: 0
	            }
	        }
	    };
	};

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(553);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AnchorButton = function AnchorButton(props) {
	    return _react2.default.createElement(
	        'a',
	        { disabled: props.disabled, className: (0, _classnames2.default)('Button', props.className), href: props.href,
	            onClick: props.onClickFn, target: props.target },
	        props.children
	    );
	};
	
	AnchorButton.propTypes = {
	    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array, _propTypes2.default.string]).isRequired,
	    onClickFn: _propTypes2.default.func,
	    className: _propTypes2.default.string,
	    href: _propTypes2.default.string,
	    target: _propTypes2.default.string,
	    disabled: _propTypes2.default.bool,
	    type: _propTypes2.default.string
	};
	
	exports.default = AnchorButton;

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(9);
	
	var _editor = __webpack_require__(681);
	
	var _captionConstants = __webpack_require__(293);
	
	__webpack_require__(1135);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	// Components
	
	
	// Styles
	
	
	var Caption = function (_React$Component) {
	    _inherits(Caption, _React$Component);
	
	    function Caption(props) {
	        _classCallCheck(this, Caption);
	
	        var _this = _possibleConstructorReturn(this, (Caption.__proto__ || Object.getPrototypeOf(Caption)).call(this, props));
	
	        _this.wrappedSaveCaptionContent = _this.wrappedSaveCaptionContent.bind(_this);
	        return _this;
	    }
	
	    _createClass(Caption, [{
	        key: 'wrappedSaveCaptionContent',
	        value: function wrappedSaveCaptionContent(caption, sync) {
	            // Don't save if the caption isn't visible.  This helps prevent empty operations from being added to the
	            // undo stack
	            var _props = this.props,
	                captionVisible = _props.captionVisible,
	                saveCaptionContent = _props.saveCaptionContent;
	
	            if (!captionVisible) return null;
	
	            saveCaptionContent(caption, sync);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                captionVisible = _props2.captionVisible,
	                showDivider = _props2.showDivider,
	                element = _props2.element;
	
	            if (!captionVisible) return null;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'Caption' },
	                showDivider ? _react2.default.createElement('div', { className: 'caption-divider' }) : null,
	                _react2.default.createElement(_editor.SimpleTextEditor, _extends({}, this.props, {
	                    saveContent: this.wrappedSaveCaptionContent,
	                    editorId: element.get('id') + '-CAPTION',
	                    editorKey: _captionConstants.CAPTION_EDITOR_KEY }))
	            );
	        }
	    }]);
	
	    return Caption;
	}(_react2.default.Component);
	
	Caption.propTypes = {
	    element: _propTypes2.default.object.isRequired,
	    isEditing: _propTypes2.default.bool,
	    isEditable: _propTypes2.default.bool,
	    startEditing: _propTypes2.default.func,
	    stopEditing: _propTypes2.default.func,
	    saveCaptionContent: _propTypes2.default.func,
	    onEmptyBackspace: _propTypes2.default.func,
	    textContent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	    captionVisible: _propTypes2.default.bool,
	    currentEditorKey: _propTypes2.default.string,
	    createNewCard: _propTypes2.default.func,
	    showDivider: _propTypes2.default.bool
	};
	
	exports.default = (0, _recompose.onlyUpdateForPropTypes)(Caption);

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _captionActions = __webpack_require__(677);
	
	var _elementCaptionUtil = __webpack_require__(137);
	
	var _keyConstants = __webpack_require__(146);
	
	var _captionConstants = __webpack_require__(293);
	
	var _analytics = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	// Actions
	
	
	// Utils
	
	
	// Constants
	
	
	exports.default = function (DecoratedComponent) {
	    var _dec, _class;
	
	    var CaptionContainerDecorator = (_dec = (0, _reactRedux.connect)(), _dec(_class = function (_React$Component) {
	        _inherits(CaptionContainerDecorator, _React$Component);
	
	        function CaptionContainerDecorator() {
	            var _ref;
	
	            var _temp, _this, _ret;
	
	            _classCallCheck(this, CaptionContainerDecorator);
	
	            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                args[_key] = arguments[_key];
	            }
	
	            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CaptionContainerDecorator.__proto__ || Object.getPrototypeOf(CaptionContainerDecorator)).call.apply(_ref, [this].concat(args))), _this), _this.onEmptyBackspace = function () {
	                var _this$props = _this.props,
	                    isEditable = _this$props.isEditable,
	                    dispatch = _this$props.dispatch,
	                    element = _this$props.element,
	                    stopEditing = _this$props.stopEditing;
	
	                if (!isEditable) return;
	
	                dispatch((0, _captionActions.setHideCaption)({ elementId: element.get('id') }));
	                stopEditing();
	            }, _this.captionKeyHandler = function (event) {
	                var _this$props2 = _this.props,
	                    stopEditing = _this$props2.stopEditing,
	                    startEditing = _this$props2.startEditing,
	                    element = _this$props2.element,
	                    isEditing = _this$props2.isEditing;
	
	                // Unfortunately have to handle the escape key separately as it's not causing a keypress event
	
	                if (event.which === _keyConstants.KEY_CODES.ESC) {
	                    stopEditing();
	                    return;
	                }
	
	                // Unfortunately also have to handle this case to prevent an issue.
	                if (event.which === _keyConstants.KEY_CODES.BACKSPACE) {
	                    event.preventDefault();
	                    return;
	                }
	
	                // don't trigger a start editing event when non-character keys are pressed
	                if (_keyConstants.NON_CHARACTERS.indexOf(event.which) !== -1) {
	                    return;
	                }
	
	                var showingCaption = (0, _elementCaptionUtil.getShowCaption)(element);
	                if (!showingCaption) {
	                    _this.showCaption();
	                }
	
	                if (isEditing) {
	                    return;
	                }
	
	                startEditing(_captionConstants.CAPTION_EDITOR_KEY);
	            }, _this.saveCaptionContent = function (caption, sync) {
	                var _this$props3 = _this.props,
	                    element = _this$props3.element,
	                    isEditable = _this$props3.isEditable,
	                    dispatchUpdateElement = _this$props3.dispatchUpdateElement;
	
	                if (!isEditable) return;
	
	                dispatchUpdateElement({
	                    id: element.get('id'),
	                    changes: { caption: caption },
	                    sync: sync
	                });
	            }, _this.showCaption = function () {
	                var _this$props4 = _this.props,
	                    element = _this$props4.element,
	                    isEditable = _this$props4.isEditable,
	                    dispatch = _this$props4.dispatch;
	
	                if (!isEditable) return;
	
	                (0, _analytics.analyticsEvent)('added-' + element.get('elementType') + '-caption', { shortcut: true });
	
	                dispatch((0, _captionActions.setShowCaption)({ elementId: element.get('id') }));
	            }, _temp), _possibleConstructorReturn(_this, _ret);
	        }
	
	        _createClass(CaptionContainerDecorator, [{
	            key: 'render',
	            value: function render() {
	                return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, {
	                    captionKeyHandler: this.captionKeyHandler,
	                    saveCaptionContent: this.saveCaptionContent,
	                    showCaption: this.showCaption,
	                    onEmptyBackspace: this.onEmptyBackspace }));
	            }
	        }]);
	
	        return CaptionContainerDecorator;
	    }(_react2.default.Component)) || _class);
	
	
	    CaptionContainerDecorator.propTypes = {
	        element: _propTypes2.default.object.isRequired,
	        dispatchUpdateElement: _propTypes2.default.func.isRequired,
	        dispatch: _propTypes2.default.func,
	        stopEditing: _propTypes2.default.func,
	        startEditing: _propTypes2.default.func,
	        showCaption: _propTypes2.default.func,
	        isEditing: _propTypes2.default.bool,
	        isEditable: _propTypes2.default.bool
	    };
	
	    return CaptionContainerDecorator;
	};

/***/ }),
/* 426 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CONNECTIONS_SET = exports.CONNECTIONS_SET = 'CONNECTIONS_SET';
	var CONNECTIONS_REMOVE = exports.CONNECTIONS_REMOVE = 'CONNECTIONS_REMOVE';
	
	var BULK_CONNECTIONS_ACTIONS = exports.BULK_CONNECTIONS_ACTIONS = [CONNECTIONS_SET, CONNECTIONS_REMOVE];

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(45);
	
	var _electronSelector = __webpack_require__(692);
	
	var _electronSelector2 = _interopRequireDefault(_electronSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ElectronLink = function ElectronLink(_ref) {
	    var isElectron = _ref.isElectron,
	        to = _ref.to,
	        children = _ref.children,
	        className = _ref.className,
	        props = _objectWithoutProperties(_ref, ['isElectron', 'to', 'children', 'className']);
	
	    return isElectron ? _react2.default.createElement(
	        'a',
	        { href: 'https://app.milanote.com' + to, className: className, target: '_blank' },
	        children
	    ) : _react2.default.createElement(
	        _reactRouter.Link,
	        { to: to, className: className },
	        children
	    );
	};
	
	ElectronLink.propTypes = {
	    isElectron: _react2.default.PropTypes.bool,
	    children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node, _react2.default.PropTypes.string]),
	    to: _react2.default.PropTypes.string,
	    className: _react2.default.PropTypes.string
	};
	
	exports.default = (0, _reactRedux.connect)(_electronSelector2.default)(ElectronLink);

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dompurify = __webpack_require__(1038);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(4);
	
	var _Spinner = __webpack_require__(65);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	__webpack_require__(1144);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	// Components
	
	
	// Styles
	
	
	var cleanSVGIcon = function cleanSVGIcon(svg) {
	    return { __html: (0, _dompurify.sanitize)(atob(svg)) };
	};
	
	var SVGIcon = function SVGIcon(_ref) {
	    var svg = _ref.svg,
	        className = _ref.className;
	    return _react2.default.createElement('div', { className: (0, _classnames2.default)('Icon SVGIcon', className), dangerouslySetInnerHTML: cleanSVGIcon(svg) });
	};
	
	SVGIcon.propTypes = {
	    svg: _propTypes2.default.string,
	    className: _propTypes2.default.string
	};
	
	var StringIcon = function StringIcon(_ref2) {
	    var string = _ref2.string,
	        className = _ref2.className;
	    return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('Icon StringIcon', className) },
	        _react2.default.createElement(
	            'div',
	            { className: 'string-icon-' + string.length },
	            string.split('').map(function (letter, i) {
	                return _react2.default.createElement(
	                    'span',
	                    { key: i },
	                    letter
	                );
	            })
	        )
	    );
	};
	
	StringIcon.propTypes = {
	    string: _propTypes2.default.string,
	    className: _propTypes2.default.string
	};
	
	var ElementIcon = function (_React$Component) {
	    _inherits(ElementIcon, _React$Component);
	
	    function ElementIcon() {
	        _classCallCheck(this, ElementIcon);
	
	        var _this = _possibleConstructorReturn(this, (ElementIcon.__proto__ || Object.getPrototypeOf(ElementIcon)).call(this));
	
	        _this.state = {
	            faded: false
	        };
	
	        _this.fadeTimerId = null;
	        return _this;
	    }
	
	    _createClass(ElementIcon, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var icon = this.props.icon;
	
	            this.setState({ icon: icon });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _this2 = this;
	
	            var currentlyShowingSpinner = this.props.showLoading && this.props.icon && this.props.icon.get('fetching');
	            var nextShowingSpinner = nextProps.showLoading && nextProps.icon && nextProps.icon.get('fetching');
	
	            if (currentlyShowingSpinner && !nextShowingSpinner) {
	                // Start as faded
	                this.setState({ faded: true });
	                // The next frame remove the faded flag and allow the CSS transition to occur
	                requestAnimationFrame(function () {
	                    return _this2.setState({ faded: false });
	                });
	            }
	
	            if (nextProps.icon !== this.props.icon) {
	                this.setState({ faded: true });
	
	                // If we shouldn't fade, just return to the non-faded state and change the icon immediately
	                var timerDelay = nextProps.enableFade ? 300 : 0;
	                // The next frame remove the faded flag and allow the CSS transition to occur
	                this.fadeTimerId = (0, _lodash.delay)(function () {
	                    return _this2.setState({ icon: nextProps.icon, faded: false });
	                }, timerDelay);
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.fadeTimerId && clearTimeout(this.fadeTimerId);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                showLoading = _props.showLoading,
	                enableFade = _props.enableFade;
	            var _state = this.state,
	                icon = _state.icon,
	                faded = _state.faded;
	
	
	            var svg = icon && icon.get('svg');
	            var string = icon && icon.get('string');
	
	            if (icon && showLoading && icon.get('fetching')) return _react2.default.createElement(_Spinner2.default, { show: true });
	            if (icon && svg) return _react2.default.createElement(SVGIcon, { className: (0, _classnames2.default)({ faded: faded && !enableFade }), svg: svg });
	            if (icon && string) {
	                return _react2.default.createElement(StringIcon, { className: (0, _classnames2.default)({ faded: faded && !enableFade }), string: string });
	            }
	            return null;
	        }
	    }]);
	
	    return ElementIcon;
	}(_react2.default.Component);
	
	ElementIcon.propTypes = {
	    icon: _propTypes2.default.object,
	    showLoading: _propTypes2.default.bool,
	    enableFade: _propTypes2.default.bool
	};
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'ElementIcon' },
	        _react2.default.createElement(ElementIcon, props)
	    );
	};

/***/ }),
/* 429 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var ICON_TYPES = exports.ICON_TYPES = {
	    STRING: 'string',
	    SVG: 'svg'
	};
	
	var STRING_ICON_MAX_LENGTH = exports.STRING_ICON_MAX_LENGTH = 4;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _elementIconConstants = __webpack_require__(429);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = function (string) {
	    var idPrefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'str';
	    return Immutable.Map({
	        type: _elementIconConstants.ICON_TYPES.STRING,
	        id: idPrefix + '-' + string,
	        string: string.toUpperCase()
	    });
	};

/***/ }),
/* 431 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ERROR_MODAL_OPEN = exports.ERROR_MODAL_OPEN = 'ERROR_MODAL_OPEN';
	var ERROR_MODAL_CLOSE = exports.ERROR_MODAL_CLOSE = 'ERROR_MODAL_CLOSE';

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.bootStripe = exports.getStripe = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _getClientConfig = __webpack_require__(48);
	
	var _getClientConfig2 = _interopRequireDefault(_getClientConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stripeBooting = false;
	
	var createStripe = function createStripe() {
	    if (window.Stripe && (0, _lodash.isFunction)(window.Stripe)) return Promise.resolve(window.Stripe);
	
	    return new Promise(function (resolve, reject) {
	        if (stripeBooting) return resolve();
	
	        var stripe = document.createElement('script');
	        stripe.type = 'text/javascript';
	        stripe.async = true;
	        stripe.src = 'https://js.stripe.com/v2/';
	
	        stripeBooting = true;
	
	        var scripts = document.getElementsByTagName('script')[0];
	        scripts.parentNode.insertBefore(stripe, scripts);
	
	        stripe.addEventListener('load', function () {
	            stripeBooting = false;
	            resolve(window.Stripe);
	        });
	    });
	};
	
	var getStripe = exports.getStripe = function getStripe() {
	    if (window.Stripe && (0, _lodash.isFunction)(window.Stripe)) return window.Stripe;
	};
	
	var bootStripe = exports.bootStripe = function bootStripe() {
	    return createStripe().then(function (stripe) {
	        stripe.setPublishableKey((0, _getClientConfig2.default)().payment.publicKey);
	    });
	};
	
	exports.default = getStripe;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _FormInput = __webpack_require__(96);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	__webpack_require__(1151);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Creates an input field for a password which can be switched between hidden and shown.
	 */
	var PasswordInput = function (_React$Component) {
	    _inherits(PasswordInput, _React$Component);
	
	    function PasswordInput(props) {
	        _classCallCheck(this, PasswordInput);
	
	        var _this = _possibleConstructorReturn(this, (PasswordInput.__proto__ || Object.getPrototypeOf(PasswordInput)).call(this, props));
	
	        _this.state = {
	            isVisible: false
	        };
	
	        _this.toggleVisibility = _this.toggleVisibility.bind(_this);
	        _this.getVisiblePasswordInput = _this.getVisiblePasswordInput.bind(_this);
	        _this.getHiddenPasswordInput = _this.getHiddenPasswordInput.bind(_this);
	        return _this;
	    }
	
	    _createClass(PasswordInput, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            if (this.state.isVisible !== prevState.isVisible) {
	                this.refs.password.focus();
	            }
	        }
	    }, {
	        key: 'getVisiblePasswordInput',
	        value: function getVisiblePasswordInput() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'field-row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'field PasswordInput' },
	                    _react2.default.createElement(_FormInput2.default, _extends({}, this.props, { ref: 'password', type: 'text', className: 'password-input' })),
	                    _react2.default.createElement('input', { type: 'button', className: 'password-visibility-button', onClick: this.toggleVisibility,
	                        value: 'Hide' })
	                )
	            );
	        }
	    }, {
	        key: 'getHiddenPasswordInput',
	        value: function getHiddenPasswordInput() {
	            var canShowPassword = this.props.canShowPassword;
	
	            var classes = (0, _classnames2.default)('field PasswordInput', { 'has-show-button': canShowPassword });
	            return _react2.default.createElement(
	                'div',
	                { className: 'field-row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: classes },
	                    _react2.default.createElement(_FormInput2.default, _extends({}, this.props, { ref: 'password', type: 'password', className: 'password-input' })),
	                    canShowPassword ? _react2.default.createElement('input', { type: 'button', className: 'password-visibility-button', onClick: this.toggleVisibility,
	                        value: 'Show' }) : null
	                )
	            );
	        }
	    }, {
	        key: 'toggleVisibility',
	        value: function toggleVisibility(event) {
	            event.preventDefault();
	
	            this.setState({
	                isVisible: !this.state.isVisible
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var canShowPassword = this.props.canShowPassword;
	            var isVisible = this.state.isVisible;
	
	            return canShowPassword && isVisible ? this.getVisiblePasswordInput() : this.getHiddenPasswordInput();
	        }
	    }]);
	
	    return PasswordInput;
	}(_react2.default.Component);
	
	PasswordInput.propTypes = {
	    name: _propTypes2.default.string.isRequired,
	    canShowPassword: _propTypes2.default.bool
	};
	
	exports.default = PasswordInput;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.formSubmissionFailed = undefined;
	
	var _formConstants = __webpack_require__(435);
	
	var formSubmissionFailed = exports.formSubmissionFailed = function formSubmissionFailed(_ref) {
	    var form = _ref.form,
	        primaryError = _ref.primaryError,
	        _ref$reportError = _ref.reportError,
	        reportError = _ref$reportError === undefined ? true : _ref$reportError;
	    return {
	        type: _formConstants.FORM_SUBMISSION_FAILED,
	        form: form,
	        primaryError: primaryError,
	        reportError: reportError
	    };
	}; // Constants

/***/ }),
/* 435 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var FORM_SUBMISSION_FAILED = exports.FORM_SUBMISSION_FAILED = 'FORM_SUBMISSION_FAILED';

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1160);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BackgroundImage = function BackgroundImage(_ref) {
	    var className = _ref.className,
	        source = _ref.source,
	        children = _ref.children,
	        style = _ref.style;
	
	    var styles = _extends({}, style, {
	        backgroundImage: source && 'url(' + source + ')'
	    });
	
	    return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('BackgroundImage', className), style: styles },
	        children
	    );
	};
	
	BackgroundImage.propTypes = {
	    source: _propTypes2.default.string,
	    className: _propTypes2.default.string,
	    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	    style: _propTypes2.default.object
	};
	
	exports.default = BackgroundImage;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _elementAttachmentActions = __webpack_require__(142);
	
	var _OptimisticImage = __webpack_require__(1899);
	
	var _OptimisticImage2 = _interopRequireDefault(_OptimisticImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	// Actions
	
	
	// Components
	
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        dispatchCleanElementAttachment: function dispatchCleanElementAttachment(id) {
	            return dispatch((0, _elementAttachmentActions.cleanElementAttachment)({ id: id }));
	        }
	    };
	};
	
	var ElementImage = function (_React$Component) {
	    _inherits(ElementImage, _React$Component);
	
	    function ElementImage() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ElementImage);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ElementImage.__proto__ || Object.getPrototypeOf(ElementImage)).call.apply(_ref, [this].concat(args))), _this), _this.cleanElementAttachment = function () {
	            var _this$props = _this.props,
	                dispatchCleanElementAttachment = _this$props.dispatchCleanElementAttachment,
	                element = _this$props.element;
	
	            dispatchCleanElementAttachment(element.get('id'));
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ElementImage, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                element = _props.element,
	                children = _props.children,
	                size = _props.size,
	                imageType = _props.imageType,
	                forcedWidth = _props.forcedWidth,
	                forcedHeight = _props.forcedHeight;
	
	
	            var imageData = element.getIn(['content', 'image']);
	            var attachmentData = element.get('attachment');
	
	            return _react2.default.createElement(
	                _OptimisticImage2.default,
	                {
	                    imageType: imageType,
	                    imageDetails: imageData,
	                    attachmentDetails: attachmentData,
	                    onImageLoadCb: this.cleanElementAttachment,
	                    size: size,
	                    forcedWidth: forcedWidth,
	                    forcedHeight: forcedHeight },
	                children
	            );
	        }
	    }]);
	
	    return ElementImage;
	}(_react2.default.Component);
	
	ElementImage.propTypes = {
	    element: _propTypes2.default.object.isRequired,
	    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	    dispatchCleanElementAttachment: _propTypes2.default.func,
	    dispatchClearError: _propTypes2.default.func,
	    imageType: _propTypes2.default.string.isRequired,
	    size: _propTypes2.default.number.isRequired,
	    forcedWidth: _propTypes2.default.number,
	    forcedHeight: _propTypes2.default.number
	};
	
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(ElementImage);

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var LoadingTransitionManager = function LoadingTransitionManager(_ref) {
	    var isLoading = _ref.isLoading,
	        isSuccessful = _ref.isSuccessful,
	        loadingTransitionError = _ref.loadingTransitionError,
	        InitialComponent = _ref.InitialComponent,
	        LoadingComponent = _ref.LoadingComponent,
	        SuccessComponent = _ref.SuccessComponent,
	        ErrorComponent = _ref.ErrorComponent,
	        props = _objectWithoutProperties(_ref, ['isLoading', 'isSuccessful', 'loadingTransitionError', 'InitialComponent', 'LoadingComponent', 'SuccessComponent', 'ErrorComponent']);
	
	    var RenderComponent = void 0;
	
	    if (loadingTransitionError && ErrorComponent) {
	        RenderComponent = ErrorComponent;
	    } else if (isLoading) {
	        RenderComponent = LoadingComponent;
	    } else if (isSuccessful) {
	        RenderComponent = SuccessComponent;
	    } else {
	        RenderComponent = InitialComponent;
	    }
	
	    return _react2.default.createElement(RenderComponent, props);
	};
	
	LoadingTransitionManager.propTypes = {
	    InitialComponent: _propTypes2.default.func.isRequired,
	    LoadingComponent: _propTypes2.default.func.isRequired,
	    SuccessComponent: _propTypes2.default.func.isRequired,
	    ErrorComponent: _propTypes2.default.func,
	    isLoading: _propTypes2.default.bool,
	    isSuccessful: _propTypes2.default.bool,
	    loadingTransitionError: _propTypes2.default.any
	};
	
	exports.default = LoadingTransitionManager;

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _animateFadeDecorator = __webpack_require__(675);
	
	var _animateFadeDecorator2 = _interopRequireDefault(_animateFadeDecorator);
	
	var _LogoSpinner = __webpack_require__(707);
	
	var _LogoSpinner2 = _interopRequireDefault(_LogoSpinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var PageLoaderQuote = (0, _animateFadeDecorator2.default)()(function (_ref) {
	    var showQuote = _ref.showQuote,
	        quoteText = _ref.quoteText,
	        quoteAttribution = _ref.quoteAttribution;
	    return _react2.default.createElement(
	        'div',
	        { className: 'loading-text' },
	        quoteText ? _react2.default.createElement(
	            'div',
	            { className: 'loading-quote' },
	            '\u201C',
	            quoteText,
	            '\u201D'
	        ) : null,
	        quoteAttribution ? _react2.default.createElement(
	            'div',
	            { className: 'loading-attr' },
	            '\u2014',
	            quoteAttribution
	        ) : null
	    );
	});
	
	PageLoaderQuote.propTypes = {
	    quoteText: _propTypes2.default.string,
	    quoteAttribution: _propTypes2.default.string
	};
	
	var PageLoaderMain = function PageLoaderMain(_ref2) {
	    var logoAnimate = _ref2.logoAnimate,
	        logoFade = _ref2.logoFade,
	        logoShow = _ref2.logoShow,
	        quoteShow = _ref2.quoteShow,
	        quoteFade = _ref2.quoteFade,
	        rest = _objectWithoutProperties(_ref2, ['logoAnimate', 'logoFade', 'logoShow', 'quoteShow', 'quoteFade']);
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'PageLoaderMain workspace-positioner' },
	        _react2.default.createElement('div', { className: 'Toolbar' }),
	        _react2.default.createElement(
	            'main',
	            { className: 'Main' },
	            _react2.default.createElement(
	                'div',
	                { className: 'PageLoadingDisplay' },
	                _react2.default.createElement(_LogoSpinner2.default, _extends({}, rest, {
	                    animate: logoAnimate,
	                    fadeIn: logoFade,
	                    show: logoShow })),
	                _react2.default.createElement(PageLoaderQuote, _extends({ fadeIn: quoteFade, show: quoteShow }, rest))
	            )
	        )
	    );
	};
	
	PageLoaderMain.propTypes = {
	    logoAnimate: _propTypes2.default.bool,
	    logoFade: _propTypes2.default.bool,
	    logoShow: _propTypes2.default.bool,
	
	    quoteShow: _propTypes2.default.bool,
	    quoteFade: _propTypes2.default.bool
	};
	
	exports.default = PageLoaderMain;

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1164);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CountIndicator = function CountIndicator(_ref) {
	    var count = _ref.count,
	        hide = _ref.hide,
	        badge = _ref.badge;
	
	    if (hide || !count) return null;
	
	    return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('CountIndicator', { badge: badge }) },
	        count
	    );
	};
	
	CountIndicator.propTypes = {
	    count: _propTypes2.default.number,
	    hide: _propTypes2.default.bool,
	    badge: _propTypes2.default.bool
	};
	
	exports.default = CountIndicator;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Spinner = __webpack_require__(65);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	__webpack_require__(1177);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	// Lib
	var PopupEmptyContent = function PopupEmptyContent(_ref) {
	    var message = _ref.message,
	        children = _ref.children,
	        showSpinner = _ref.showSpinner;
	
	    var messageComponent = message ? _react2.default.createElement(
	        'p',
	        null,
	        message
	    ) : null;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'PopupEmptyContent' },
	        messageComponent,
	        _react2.default.createElement(_Spinner2.default, { show: showSpinner }),
	        children
	    );
	};
	
	// Styles
	
	
	PopupEmptyContent.propTypes = {
	    message: _propTypes2.default.string,
	    showSpinner: _propTypes2.default.bool,
	    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
	};
	
	exports.default = PopupEmptyContent;

/***/ }),
/* 442 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var STATIC_PAGE = exports.STATIC_PAGE = {
	    privacyPolicy: {
	        displayName: 'privacy policy',
	        resourceName: 'privacy-policy'
	    },
	    termsOfService: {
	        displayName: 'terms of service',
	        resourceName: 'terms-of-service'
	    }
	};
	
	var URL_PREFIX = exports.URL_PREFIX = '/static/';

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getStaticPageUrl = exports.getStaticHtmlResourceName = undefined;
	
	var _staticPageConstants = __webpack_require__(442);
	
	var getStaticHtmlResourceName = exports.getStaticHtmlResourceName = function getStaticHtmlResourceName(htmlDocName) {
	  return '/html/' + htmlDocName + '.html';
	};
	var getStaticPageUrl = exports.getStaticPageUrl = function getStaticPageUrl(htmlDocName) {
	  return '' + _staticPageConstants.URL_PREFIX + htmlDocName;
	};

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(1185);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	// Styles
	
	
	var ImageFileInput = function (_React$Component) {
	    _inherits(ImageFileInput, _React$Component);
	
	    function ImageFileInput(props) {
	        _classCallCheck(this, ImageFileInput);
	
	        var _this = _possibleConstructorReturn(this, (ImageFileInput.__proto__ || Object.getPrototypeOf(ImageFileInput)).call(this, props));
	
	        _this.handleFileSelection = _this.handleFileSelection.bind(_this);
	        return _this;
	    }
	
	    /**
	     * Handles the selection of a file to upload.
	     * If the file is not provided or is not an image then it does nothing, otherwise it delegates the uploading
	     * to a passed in property.
	     */
	
	
	    _createClass(ImageFileInput, [{
	        key: 'handleFileSelection',
	        value: function handleFileSelection(event) {
	            var fileInput = this.refs.fileInput;
	            var uploadImage = this.props.uploadImage;
	
	            // Don't do anything when no files are uploaded
	
	            if (!fileInput.files.length || !uploadImage) return;
	
	            var file = fileInput.files[0];
	
	            uploadImage(file);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var id = this.props.id;
	
	            return _react2.default.createElement('input', { className: 'ImageFileInput', type: 'file', accept: 'image/*', name: 'file-input-' + id,
	                id: 'file-input-' + id, ref: 'fileInput', onChange: this.handleFileSelection });
	        }
	    }]);
	
	    return ImageFileInput;
	}(_react2.default.Component);
	
	ImageFileInput.propTypes = {
	    id: _propTypes2.default.string.isRequired,
	    uploadImage: _propTypes2.default.func
	};
	
	exports.default = ImageFileInput;

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _UserPlanBadge = __webpack_require__(446);
	
	var _UserPlanBadge2 = _interopRequireDefault(_UserPlanBadge);
	
	var _userUtil = __webpack_require__(31);
	
	var _userHelper = __webpack_require__(175);
	
	__webpack_require__(1187);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserName = function UserName(_ref) {
	    var user = _ref.user;
	
	    if ((0, _userHelper.isActive)(user)) {
	        return _react2.default.createElement(
	            'span',
	            { className: 'UserName' },
	            _react2.default.createElement(
	                'span',
	                null,
	                (0, _userUtil.getDisplayName)(user)
	            ),
	            _react2.default.createElement(_UserPlanBadge2.default, { user: user })
	        );
	    }
	
	    return _react2.default.createElement(
	        'span',
	        { className: 'UserName email' },
	        _react2.default.createElement(
	            'span',
	            null,
	            user.get('email')
	        )
	    );
	};
	
	UserName.propTypes = {
	    user: _propTypes2.default.object.isRequired
	};
	
	exports.default = UserName;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _userUtil = __webpack_require__(31);
	
	__webpack_require__(1188);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserPlanBadge = function UserPlanBadge(_ref) {
	    var user = _ref.user;
	
	    if (!(0, _userUtil.isSubscribed)(user)) return null;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'UserPlanBadge' },
	        'Pro'
	    );
	};
	
	UserPlanBadge.propTypes = {
	    user: _propTypes2.default.object
	};
	
	exports.default = UserPlanBadge;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1194);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Lib
	var getLineStyle = function getLineStyle(_ref) {
	    var top = _ref.top,
	        left = _ref.left,
	        gridSize = _ref.gridSize;
	    return {
	        top: top * gridSize,
	        left: left * gridSize
	    };
	};
	
	// Styles
	
	
	var DocumentModeCanvasReadingLineDebugger = function DocumentModeCanvasReadingLineDebugger(props) {
	    var className = props.className,
	        order = props.order,
	        start = props.start,
	        end = props.end,
	        gridSize = props.gridSize;
	
	
	    var width = Math.abs(end.x - start.x) * gridSize;
	    var height = Math.max(2, Math.abs(end.y - start.y)) * gridSize + 10;
	
	    var top = Math.min(start.y, end.y) - 1;
	    var left = Math.min(start.x, end.x);
	
	    var x1 = (start.x - left) * gridSize;
	    var x2 = (end.x - left) * gridSize;
	
	    var y1 = (start.y - top) * gridSize;
	    var y2 = (end.y - top) * gridSize;
	
	    return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('DocumentModeCanvasReadingLineDebugger', className),
	            style: getLineStyle({ top: top, left: left, gridSize: gridSize }) },
	        _react2.default.createElement(
	            'div',
	            { className: 'order-marker' },
	            _react2.default.createElement(
	                'span',
	                { className: 'text' },
	                order
	            )
	        ),
	        _react2.default.createElement(
	            'svg',
	            { className: 'line', version: '1.1', width: width, height: height },
	            _react2.default.createElement(
	                'defs',
	                null,
	                _react2.default.createElement(
	                    'marker',
	                    { id: 'arrow', className: 'arrow', markerWidth: '5', markerHeight: '5', refX: '5', refY: '2',
	                        orient: 'auto', markerUnits: 'strokeWidth' },
	                    _react2.default.createElement('path', { d: 'M0,0 L0,4 L6,2 z' })
	                )
	            ),
	            _react2.default.createElement('line', { x1: x1, x2: x2, y1: y1, y2: y2, fill: 'transparent', markerEnd: 'url(#arrow)' })
	        )
	    );
	};
	
	DocumentModeCanvasReadingLineDebugger.propTypes = {
	    gridSize: _propTypes2.default.number.isRequired,
	    order: _propTypes2.default.number.isRequired,
	    start: _propTypes2.default.object.isRequired,
	    end: _propTypes2.default.object.isRequired,
	    className: _propTypes2.default.string
	};
	
	exports.default = DocumentModeCanvasReadingLineDebugger;

/***/ }),
/* 448 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var DOC_MODE_DEBUG_TOOL_NAME = exports.DOC_MODE_DEBUG_TOOL_NAME = 'documentMode';

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(9);
	
	var _ElementPresentational = __webpack_require__(1948);
	
	var _ElementPresentational2 = _interopRequireDefault(_ElementPresentational);
	
	var _ElementContainer = __webpack_require__(1946);
	
	var _ElementContainer2 = _interopRequireDefault(_ElementContainer);
	
	__webpack_require__(556);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Element = function Element(props) {
	    var isPresentational = props.isPresentational;
	
	    var DisplayElement = isPresentational ? _ElementPresentational2.default : _ElementContainer2.default;
	
	    return _react2.default.createElement(DisplayElement, props);
	};
	
	Element.propTypes = {
	    currentBoardId: _propTypes2.default.string.isRequired,
	    isPresentational: _propTypes2.default.bool
	};
	
	exports.default = (0, _recompose.pure)(Element);

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Components
	
	
	// Utils
	
	
	// Constants
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reselect = __webpack_require__(7);
	
	var _elementUtil = __webpack_require__(105);
	
	var _lodash = __webpack_require__(4);
	
	var _EditableTitle = __webpack_require__(228);
	
	var _EditableTitle2 = _interopRequireDefault(_EditableTitle);
	
	var _BoardIcon = __webpack_require__(451);
	
	var _BoardIcon2 = _interopRequireDefault(_BoardIcon);
	
	var _ContainerElementChildCount = __webpack_require__(724);
	
	var _ContainerElementChildCount2 = _interopRequireDefault(_ContainerElementChildCount);
	
	var _dontUpdateForKeys = __webpack_require__(206);
	
	var _dontUpdateForKeys2 = _interopRequireDefault(_dontUpdateForKeys);
	
	var _containerElementSelector = __webpack_require__(725);
	
	var _gridUtils = __webpack_require__(42);
	
	var _permissionUtil = __webpack_require__(89);
	
	var _boardSelector = __webpack_require__(83);
	
	var _boardConstants = __webpack_require__(17);
	
	var _userConstants = __webpack_require__(32);
	
	__webpack_require__(1198);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isSharedSelector = function isSharedSelector() {
	    return (0, _reselect.createSelector)(function (state, props) {
	        return props.element;
	    }, function (element) {
	        var acl = element.get('acl');
	        if (!acl || !acl.size) return false;
	
	        // don't show shared icon on public demo board alias
	        var publicAccess = acl.get(_userConstants.PUBLIC_USER_ID);
	        return !(publicAccess && (0, _permissionUtil.isDemoBoard)(publicAccess));
	    });
	};
	
	var makeBoardSelector = function makeBoardSelector() {
	    return (0, _reselect.createSelector)((0, _containerElementSelector.makeContainerElementChildrenTypesSelector)(), isSharedSelector(), _boardSelector.getIsBoardFetched, function (childrenTypes, isShared, isBoardFetched) {
	        return {
	            childrenTypes: childrenTypes,
	            isShared: isShared,
	            isBoardFetched: isBoardFetched
	        };
	    });
	};
	
	var BoardIconElement = function BoardIconElement(props) {
	    var element = props.element,
	        children = props.children,
	        isAlias = props.isAlias,
	        isLinkAlias = props.isLinkAlias,
	        isLocked = props.isLocked,
	        isShared = props.isShared,
	        documentMode = props.documentMode,
	        registerConnectionOrigin = props.registerConnectionOrigin;
	
	
	    var color = element.getIn(['content', 'color']);
	    var icon = element.getIn(['content', 'icon']);
	    var iconSize = documentMode ? 5 : 8;
	
	    return _react2.default.createElement(_BoardIcon2.default, _extends({}, props, {
	        registerConnectionOrigin: registerConnectionOrigin,
	        size: iconSize,
	        element: element,
	        color: color,
	        icon: icon,
	        children: children,
	        isShared: isShared,
	        isAlias: isAlias,
	        isLinkAlias: isLinkAlias,
	        isLocked: isLocked }));
	};
	
	BoardIconElement.propTypes = {
	    element: _propTypes2.default.object.isRequired,
	    children: _propTypes2.default.element,
	    gridSize: _propTypes2.default.number.isRequired,
	    isAlias: _propTypes2.default.bool,
	    isLinkAlias: _propTypes2.default.bool,
	    isLocked: _propTypes2.default.bool,
	    isShared: _propTypes2.default.bool,
	    documentMode: _propTypes2.default.bool,
	    registerConnectionOrigin: _propTypes2.default.func
	};
	
	BoardIconElement = (0, _dontUpdateForKeys2.default)(['isHovered', 'canDrop'])(BoardIconElement);
	
	var Board = (_dec = (0, _reactRedux.connect)(makeBoardSelector), _dec(_class = function (_React$Component) {
	    _inherits(Board, _React$Component);
	
	    function Board(props) {
	        _classCallCheck(this, Board);
	
	        var _this = _possibleConstructorReturn(this, (Board.__proto__ || Object.getPrototypeOf(Board)).call(this, props));
	
	        _this.handleTouchStart = _this.handleTouchStart.bind(_this);
	        return _this;
	    }
	
	    _createClass(Board, [{
	        key: 'handleTouchStart',
	        value: function handleTouchStart(event) {
	            var _props = this.props,
	                navigateToBoard = _props.navigateToBoard,
	                isEditing = _props.isEditing;
	
	
	            var timeNow = new Date().getTime();
	            if (this.lastTouch && this.lastTouch > timeNow - 500) {
	                if (isEditing) return;
	
	                return navigateToBoard();
	            }
	
	            this.lastTouch = timeNow;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                gridSize = _props2.gridSize,
	                inList = _props2.inList,
	                onDoubleClick = _props2.onDoubleClick,
	                onClick = _props2.onClick,
	                connectDropTarget = _props2.connectDropTarget,
	                connectLineEdgeDropTarget = _props2.connectLineEdgeDropTarget,
	                element = _props2.element,
	                onTitleEditDone = _props2.onTitleEditDone,
	                isBoardFetched = _props2.isBoardFetched,
	                elementEvents = _props2.elementEvents,
	                aliasId = _props2.aliasId;
	
	
	            var classes = (0, _elementUtil.elementClassNames)('Board', this.props);
	
	            var titleContainerStyle = {
	                width: (0, _gridUtils.gridPointsToPixels)(20, gridSize)
	            };
	
	            var boardContent = _react2.default.createElement(
	                'div',
	                { className: 'board-content' },
	                _react2.default.createElement(BoardIconElement, this.props),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'title-container', style: titleContainerStyle },
	                    _react2.default.createElement(_EditableTitle2.default, _extends({}, this.props, {
	                        elementId: element.get('id'),
	                        initialValue: 'New Board',
	                        selectFirst: true,
	                        selectAllOnEdit: true,
	                        onUpdateCallbackFn: onTitleEditDone,
	                        editDelay: 100,
	                        editorKey: _boardConstants.BOARD_TYPE })),
	                    _react2.default.createElement(_ContainerElementChildCount2.default, _extends({}, this.props, { show: isBoardFetched }))
	                )
	            );
	
	            var lineEdgeConnector = connectLineEdgeDropTarget && !inList ? connectLineEdgeDropTarget : _lodash.identity;
	
	            var domElementId = aliasId || element.get('id');
	
	            return _react2.default.createElement(
	                'div',
	                _extends({ id: (0, _elementUtil.getDomElementId)(domElementId), className: classes,
	                    style: (0, _gridUtils.getElementStyle)(_boardConstants.DEFAULT_BOARD_WIDTH, gridSize, inList)
	                }, elementEvents, {
	                    onClick: onClick,
	                    onDoubleClick: onDoubleClick,
	                    onTouchStart: this.handleTouchStart }),
	                connectDropTarget ? connectDropTarget(lineEdgeConnector(boardContent)) : boardContent
	            );
	        }
	    }]);
	
	    return Board;
	}(_react2.default.Component)) || _class);
	exports.default = Board;
	
	
	Board.propTypes = {
	    element: _propTypes2.default.object.isRequired,
	    gridSize: _propTypes2.default.number,
	    inList: _propTypes2.default.string,
	    isSelected: _propTypes2.default.bool,
	    isEditing: _propTypes2.default.bool,
	    isDragging: _propTypes2.default.bool,
	    onHeadingClick: _propTypes2.default.func,
	    updateTitle: _propTypes2.default.func,
	    navigateToBoard: _propTypes2.default.func,
	    onDoubleClick: _propTypes2.default.func,
	    onClick: _propTypes2.default.func,
	    connectDropTarget: _propTypes2.default.func,
	    connectLineEdgeDropTarget: _propTypes2.default.func,
	    onTitleEditDone: _propTypes2.default.func,
	    className: _propTypes2.default.string,
	    documentMode: _propTypes2.default.bool,
	    isBoardFetched: _propTypes2.default.bool,
	    elementEvents: _propTypes2.default.object,
	    aliasId: _propTypes2.default.string
	};

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _recompose = __webpack_require__(9);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(4);
	
	var _ElementIcon = __webpack_require__(428);
	
	var _ElementIcon2 = _interopRequireDefault(_ElementIcon);
	
	var _BoardStatus = __webpack_require__(1954);
	
	var _BoardStatus2 = _interopRequireDefault(_BoardStatus);
	
	var _BoardLock = __webpack_require__(1953);
	
	var _BoardLock2 = _interopRequireDefault(_BoardLock);
	
	var _BoardImage = __webpack_require__(721);
	
	var _BoardImage2 = _interopRequireDefault(_BoardImage);
	
	var _ElementUserTag = __webpack_require__(203);
	
	var _ElementUserTag2 = _interopRequireDefault(_ElementUserTag);
	
	var _colorHelper = __webpack_require__(319);
	
	var _gridSizeSelector = __webpack_require__(66);
	
	var _gridUtils = __webpack_require__(42);
	
	var _dontUpdateForKeys = __webpack_require__(206);
	
	var _dontUpdateForKeys2 = _interopRequireDefault(_dontUpdateForKeys);
	
	__webpack_require__(1199);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	// Lib
	var getStyle = function getStyle(_ref) {
	    var size = _ref.size,
	        color = _ref.color,
	        gridSize = _ref.gridSize,
	        hasImageData = _ref.hasImageData;
	
	    var iconSize = (0, _gridUtils.gridPointsToPixels)(size, gridSize);
	
	    var style = {
	        width: iconSize,
	        height: iconSize
	    };
	
	    if (color && !hasImageData) {
	        style.backgroundColor = (0, _colorHelper.getColorHexValue)(color);
	    }
	
	    return style;
	};
	
	// Styles
	
	
	// Utils
	
	
	var BoardIcon = function BoardIcon(props) {
	    var icon = props.icon,
	        element = props.element,
	        size = props.size,
	        gridSize = props.gridSize,
	        color = props.color,
	        registerConnectionOrigin = props.registerConnectionOrigin,
	        showNavigationFeedback = props.showNavigationFeedback;
	
	
	    var hasImageData = element && (element.getIn(['content', 'image']) || element.getIn(['attachment', 'data']));
	    var iconElement = hasImageData ? _react2.default.createElement(_BoardImage2.default, { element: element, size: size, gridSize: gridSize }) : _react2.default.createElement(_ElementIcon2.default, { icon: icon, showLoading: true, enableFade: true });
	
	    var boardIconContentStyle = getStyle({ size: size, color: color, gridSize: gridSize, hasImageData: hasImageData });
	    var boardIconClass = boardIconContentStyle.width < 60 ? 'small' : null;
	    var preNavClass = { 'pre-nav': showNavigationFeedback };
	
	    var wrapperFn = registerConnectionOrigin || _lodash.identity;
	
	    return wrapperFn(_react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('BoardIcon', boardIconClass, preNavClass) },
	        _react2.default.createElement(_ElementUserTag2.default, props),
	        _react2.default.createElement(
	            'div',
	            { className: 'board-icon-content drag-handle', style: boardIconContentStyle },
	            iconElement,
	            _react2.default.createElement(_BoardStatus2.default, props),
	            _react2.default.createElement(_BoardLock2.default, props)
	        )
	    ));
	};
	
	BoardIcon.propTypes = {
	    size: _propTypes2.default.number.isRequired,
	    iconName: _propTypes2.default.string,
	    color: _propTypes2.default.string,
	    icon: _propTypes2.default.object,
	    gridSize: _propTypes2.default.number,
	    element: _propTypes2.default.object,
	    registerConnectionOrigin: _propTypes2.default.func,
	    showNavigationFeedback: _propTypes2.default.bool
	};
	
	var enhance = (0, _recompose.compose)((0, _reactRedux.connect)(_gridSizeSelector.gridSizeSelector), (0, _dontUpdateForKeys2.default)(['elementEvents', 'isSelected', 'readyToMeasure', 'childrenTypes', 'isBoardFetched']));
	
	exports.default = enhance(BoardIcon);

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(3);
	
	var _recompose = __webpack_require__(9);
	
	var _ElementDropTarget = __webpack_require__(168);
	
	var _ElementDropTarget2 = _interopRequireDefault(_ElementDropTarget);
	
	var _elementHelper = __webpack_require__(13);
	
	var _keyboardUtility = __webpack_require__(313);
	
	var _columnActions = __webpack_require__(1964);
	
	var _boardConstants = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Actions
	
	
	// Utils
	// Lib
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        createColumnOnDrop: function createColumnOnDrop(location, childIdArray) {
	            return dispatch((0, _columnActions.createColumnWithChildren)({ location: location, childIdArray: childIdArray }));
	        }
	    };
	};
	
	// Constants
	
	
	// Custom Decorators
	
	
	var cardDropTargetHandler = function cardDropTargetHandler(props, monitor, component) {
	    var createColumnOnDrop = props.createColumnOnDrop,
	        element = props.element;
	
	
	    var handledBy = _reactDom2.default.findDOMNode(component);
	
	    var _monitor$getItem = monitor.getItem(),
	        draggedElements = _monitor$getItem.draggedElements;
	
	    var acceptedElementIds = draggedElements.filter(function (el) {
	        return !(0, _elementHelper.isLine)(el) && !(0, _elementHelper.isColumn)(el);
	    }).map(function (el) {
	        return el.get('id');
	    });
	
	    var childIdArray = [element.get('id')];
	
	    var _createColumnOnDrop = createColumnOnDrop(element.get('location').toJS(), childIdArray),
	        columnElementId = _createColumnOnDrop.columnElementId,
	        transactionId = _createColumnOnDrop.transactionId;
	
	    return {
	        acceptedElementIds: acceptedElementIds,
	        location: {
	            parentId: columnElementId,
	            section: _boardConstants.BOARD_SECTIONS.INBOX,
	            position: {
	                index: childIdArray.length
	            }
	        },
	        handledBy: handledBy,
	        transactionId: transactionId
	    };
	};
	
	var canDropHandler = function canDropHandler(props, monitor) {
	    var inList = props.inList,
	        dragModifierKeys = props.dragModifierKeys;
	
	    if (inList) return false;
	
	    var _monitor$getItem2 = monitor.getItem(),
	        draggedElements = _monitor$getItem2.draggedElements;
	
	    if (draggedElements.every(function (el) {
	        return (0, _elementHelper.isColumn)(el) || (0, _elementHelper.isLine)(el);
	    })) return false;
	
	    return (0, _keyboardUtility.hasCommandModifier)(dragModifierKeys);
	};
	
	/**
	 * This decorator adds the ability to create a column when another element is dropped onto this element.
	 * The new column will contain this element as well as the dropped element.
	 *
	 * @param Element {ReactComponent} The element to turn into a column on drop - drop target.
	 */
	
	exports.default = function (Element) {
	    return (0, _recompose.compose)((0, _reactRedux.connect)(null, mapDispatchToProps), (0, _ElementDropTarget2.default)({ drop: cardDropTargetHandler, canDrop: canDropHandler }, null))(Element);
	};

/***/ }),
/* 453 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (_ref, Component) {
	    var connectDropTarget = _ref.connectDropTarget,
	        inList = _ref.inList;
	
	    if (inList) return Component;
	    return connectDropTarget(Component);
	};

/***/ }),
/* 454 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (_ref) {
	    var props = _ref.props;
	    var isDragging = props.isDragging;
	
	    return !isDragging;
	};

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.moveElementToTrash = exports.createNewElement = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _elementActions = __webpack_require__(26);
	
	var _elementMoveActions = __webpack_require__(302);
	
	var _selectionActions = __webpack_require__(55);
	
	var _analytics = __webpack_require__(47);
	
	var _selectedElementsSelector = __webpack_require__(127);
	
	var _elementHelper = __webpack_require__(13);
	
	var _undoRedoTransactionManager = __webpack_require__(86);
	
	var _boardConstants = __webpack_require__(17);
	
	// Actions
	var createNewElement = exports.createNewElement = function createNewElement(elementType, props) {
	    return function (dispatch) {
	        if (!props.isEditable) return;
	        var transactionId = props.transactionId || (0, _undoRedoTransactionManager.getNewTransactionId)();
	
	        dispatch((0, _elementActions.createAndSelectElement)({
	            elementType: elementType,
	            location: {
	                parentId: props.currentBoardId,
	                section: _boardConstants.BOARD_SECTIONS.INBOX,
	                position: {
	                    index: 0
	                }
	            },
	            currentBoardId: props.currentBoardId,
	            transactionId: transactionId
	        }));
	    };
	};
	
	// Constants
	
	
	// Utils
	// Lib
	var moveElementToTrash = exports.moveElementToTrash = function moveElementToTrash(props) {
	    return function (dispatch, getState) {
	        if (!props.isEditable) return;
	
	        var transactionId = (0, _undoRedoTransactionManager.getNewTransactionId)();
	
	        var selectedElements = (0, _selectedElementsSelector.getSelectedElements)(getState());
	        if (!selectedElements.size) return;
	
	        dispatch((0, _selectionActions.deselectAllElements)({ transactionId: transactionId }));
	
	        var location = {
	            parentId: '' + props.currentBoardId + _boardConstants.BOARD_ID_TRASH_APPEND,
	            section: _boardConstants.BOARD_SECTIONS.TRASH,
	            position: {
	                addedDate: new Date().getTime()
	            }
	        };
	
	        var selectionToMoveToTrash = (0, _elementHelper.filterOutLinkedBoards)(selectedElements).filter((0, _lodash.negate)(_elementHelper.isElementLocked));
	
	        (0, _analytics.analyticsEvent)('moved-element-to-trash-delete-key');
	
	        var moves = selectionToMoveToTrash.map(function (element) {
	            return { id: element.get('id'), location: location };
	        }).toJS();
	        dispatch((0, _elementMoveActions.moveMultipleElements)({ moves: moves, transactionId: transactionId }));
	    };
	};

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.snapControlPointIfClose = exports.calculateControlPointPerpendicularMagnitude = exports.calculateControlPointParallelRatio = exports.shouldSnapToStraight = exports.isCurvedPastEndpoints = exports.isCloseToStraightLine = exports.getHalfwayPoint = undefined;
	
	var _Vector = __webpack_require__(323);
	
	var _Vector2 = _interopRequireDefault(_Vector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CLOSE_TO_STRAIGHT_LINE_MAGNITUDE_THRESHOLD = 8; // Utils
	var getHalfwayPoint = exports.getHalfwayPoint = function getHalfwayPoint(start, end) {
	    var lineVector = _Vector2.default.lineVector(start, end);
	    return lineVector.multiplyScalar(0.5).add(start);
	};
	
	var isCloseToStraightLine = exports.isCloseToStraightLine = function isCloseToStraightLine(controlPointPerpendicularMagnitude) {
	    return Math.abs(controlPointPerpendicularMagnitude) < CLOSE_TO_STRAIGHT_LINE_MAGNITUDE_THRESHOLD;
	};
	
	var isCurvedPastEndpoints = exports.isCurvedPastEndpoints = function isCurvedPastEndpoints(controlPointParallelRatio) {
	    return controlPointParallelRatio < 0 || controlPointParallelRatio > 1;
	};
	
	var shouldSnapToStraight = exports.shouldSnapToStraight = function shouldSnapToStraight(_ref) {
	    var controlPointPerpendicularMagnitude = _ref.controlPointPerpendicularMagnitude,
	        controlPointParallelRatio = _ref.controlPointParallelRatio;
	    return isCloseToStraightLine(controlPointPerpendicularMagnitude) && !isCurvedPastEndpoints(controlPointParallelRatio);
	};
	
	var calculateControlPointParallelRatio = exports.calculateControlPointParallelRatio = function calculateControlPointParallelRatio(_ref2) {
	    var controlPoint = _ref2.controlPoint,
	        startEdgeOrigin = _ref2.startEdgeOrigin,
	        endEdgeOrigin = _ref2.endEdgeOrigin;
	
	    var lineVector = _Vector2.default.lineVector(startEdgeOrigin, endEdgeOrigin);
	    // Move the controlPoint onto the start line's coordinate system
	    var translatedControlPoint = _Vector2.default.fromObject(controlPoint).subtract(startEdgeOrigin);
	    return lineVector.projectedRatio(translatedControlPoint);
	};
	
	var calculateControlPointPerpendicularMagnitude = exports.calculateControlPointPerpendicularMagnitude = function calculateControlPointPerpendicularMagnitude(_ref3) {
	    var controlPoint = _ref3.controlPoint,
	        startEdgeOrigin = _ref3.startEdgeOrigin,
	        endEdgeOrigin = _ref3.endEdgeOrigin;
	
	    var lineVector = _Vector2.default.lineVector(startEdgeOrigin, endEdgeOrigin);
	    var perpindicularVector = lineVector.clone().perpendicular();
	
	    // Move the controlPoint onto the start line's coordinate system
	    var translatedControlPoint = _Vector2.default.fromObject(controlPoint).subtract(startEdgeOrigin);
	    return perpindicularVector.projectedMagnitude(translatedControlPoint);
	};
	
	var snapControlPointIfClose = exports.snapControlPointIfClose = function snapControlPointIfClose(_ref4) {
	    var controlPoint = _ref4.controlPoint,
	        startEdgeOrigin = _ref4.startEdgeOrigin,
	        endEdgeOrigin = _ref4.endEdgeOrigin;
	
	    var controlPointPerpendicularMagnitude = calculateControlPointPerpendicularMagnitude({ controlPoint: controlPoint, startEdgeOrigin: startEdgeOrigin, endEdgeOrigin: endEdgeOrigin });
	    var controlPointParallelRatio = calculateControlPointParallelRatio({ controlPoint: controlPoint, startEdgeOrigin: startEdgeOrigin, endEdgeOrigin: endEdgeOrigin });
	    return shouldSnapToStraight({ controlPointPerpendicularMagnitude: controlPointPerpendicularMagnitude, controlPointParallelRatio: controlPointParallelRatio }) ? getHalfwayPoint(startEdgeOrigin, endEdgeOrigin) : controlPoint;
	};

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _richMediaConnectDecorator = __webpack_require__(2020);
	
	var _richMediaConnectDecorator2 = _interopRequireDefault(_richMediaConnectDecorator);
	
	var _RichMediaPreviewImage = __webpack_require__(2012);
	
	var _RichMediaPreviewImage2 = _interopRequireDefault(_RichMediaPreviewImage);
	
	var _RichMediaContent = __webpack_require__(2009);
	
	var _RichMediaContent2 = _interopRequireDefault(_RichMediaContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	// Components
	
	
	var RichMedia = function (_React$Component) {
	    _inherits(RichMedia, _React$Component);
	
	    function RichMedia() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, RichMedia);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RichMedia.__proto__ || Object.getPrototypeOf(RichMedia)).call.apply(_ref, [this].concat(args))), _this), _this.onPreviewClick = function (event) {
	            event.stopPropagation();
	            _this.props.dispatchRichMediaEmbedding();
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(RichMedia, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                element = _props.element,
	                className = _props.className,
	                showPreview = _props.showPreview,
	                showRichMedia = _props.showRichMedia,
	                embeddingRichMedia = _props.embeddingRichMedia,
	                _props$ContentCompone = _props.ContentComponent,
	                ContentComponent = _props$ContentCompone === undefined ? _RichMediaContent2.default : _props$ContentCompone,
	                _props$PreviewCompone = _props.PreviewComponent,
	                PreviewComponent = _props$PreviewCompone === undefined ? _RichMediaPreviewImage2.default : _props$PreviewCompone;
	
	
	            var mediaData = element.getIn(['content', 'media']);
	            var imageData = element.getIn(['content', 'image']);
	
	            return _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('RichMedia', className) },
	                _react2.default.createElement(ContentComponent, _extends({}, this.props, { show: showRichMedia, mediaData: mediaData })),
	                _react2.default.createElement(PreviewComponent, _extends({}, this.props, { show: showPreview, showLoader: embeddingRichMedia,
	                    mediaData: mediaData,
	                    imageData: imageData,
	                    onClick: this.onPreviewClick }))
	            );
	        }
	    }]);
	
	    return RichMedia;
	}(_react2.default.Component);
	
	RichMedia.propTypes = {
	    element: _propTypes2.default.object.isRequired,
	    PreviewComponent: _propTypes2.default.func,
	    ContentComponent: _propTypes2.default.func,
	    showPreview: _propTypes2.default.bool,
	    embeddingRichMedia: _propTypes2.default.bool,
	    showRichMedia: _propTypes2.default.bool,
	    dispatchRichMediaEmbedding: _propTypes2.default.func,
	    className: _propTypes2.default.string
	};
	
	exports.default = (0, _richMediaConnectDecorator2.default)(RichMedia);

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isAttemptingMultiSelect = undefined;
	
	var _keyboardUtility = __webpack_require__(313);
	
	var isAttemptingMultiSelect = exports.isAttemptingMultiSelect = function isAttemptingMultiSelect(event) {
	  return (0, _keyboardUtility.hasShiftKey)(event) || (0, _keyboardUtility.hasCommandModifier)(event);
	};

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Utils
	
	
	var _defaultDropLocationFn = __webpack_require__(726);
	
	var _defaultDropLocationFn2 = _interopRequireDefault(_defaultDropLocationFn);
	
	var _elementHelper = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props, monitor, component) {
	    var dropResult = (0, _defaultDropLocationFn2.default)(props, monitor, component);
	
	    // Can't drop lines onto the inbox
	
	    var _monitor$getItem = monitor.getItem(),
	        draggedElements = _monitor$getItem.draggedElements;
	
	    var acceptedElementIds = draggedElements.filter(function (el) {
	        return !(0, _elementHelper.isLine)(el);
	    }).map(function (el) {
	        return el.get('id');
	    });
	
	    return _extends({}, dropResult, {
	        acceptedElementIds: acceptedElementIds
	    });
	};

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.markBoardsAsSeen = exports.fetchModifiedBoards = exports.modifiedElementsError = exports.setModifiedElements = undefined;
	
	var _http = __webpack_require__(76);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _timeUtil = __webpack_require__(43);
	
	var _errorUtil = __webpack_require__(466);
	
	var _notificationConstants = __webpack_require__(748);
	
	var _elementActions = __webpack_require__(26);
	
	var _notificationConstants2 = __webpack_require__(88);
	
	var _analytics = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Util
	var setModifiedElements = exports.setModifiedElements = function setModifiedElements(modifiedElements) {
	    return {
	        type: _notificationConstants.MODIFIED_ELEMENTS_SET,
	        modifiedElements: modifiedElements
	    };
	};
	
	var modifiedElementsError = exports.modifiedElementsError = function modifiedElementsError(error) {
	    return {
	        type: _notificationConstants.MODIFIED_ELEMENTS_ERROR,
	        error: (0, _errorUtil.extractErrorDetailsForAction)(error)
	    };
	};
	
	var trackNotificationsAnanlyticsEvent = function trackNotificationsAnanlyticsEvent(modifiedElements, lastViewedNotifications) {
	    var unseenCount = Object.keys(modifiedElements).map(function (key) {
	        return modifiedElements[key];
	    }).filter(function (modified) {
	        return modified.active && modified.modifiedTime > lastViewedNotifications;
	    }).length;
	
	    if (unseenCount > 0) (0, _analytics.analyticsEvent)('loaded-unseen-notifications', { unseen_count: unseenCount });
	};
	
	var fetchModifiedBoards = exports.fetchModifiedBoards = function fetchModifiedBoards() {
	    return function (dispatch, getState) {
	        var lastFetch = getState().getIn(['notifications', 'fetchedTime']);
	
	        return (0, _http2.default)({ url: 'notifications/modified-elements', timeout: 30000, params: { after: lastFetch } }).then(function (response) {
	            var _response$data = response.data,
	                modifiedElements = _response$data.modifiedElements,
	                elements = _response$data.elements;
	
	
	            dispatch({ type: _notificationConstants.MODIFIED_ELEMENTS_ADD, modifiedElements: modifiedElements });
	            if (Object.keys(elements).length) dispatch((0, _elementActions.loadElements)(elements));
	
	            trackNotificationsAnanlyticsEvent(modifiedElements, getState().getIn(['app', 'currentUser', 'lastCheckedNotifications']));
	        }).catch(function (err) {
	            dispatch(modifiedElementsError(err));
	            return Promise.reject(err);
	        });
	    };
	};
	
	var markBoardsAsSeen = exports.markBoardsAsSeen = function markBoardsAsSeen(_ref) {
	    var ids = _ref.ids,
	        userId = _ref.userId,
	        _ref$sync = _ref.sync,
	        sync = _ref$sync === undefined ? true : _ref$sync;
	    return {
	        type: _notificationConstants2.MODIFIED_ELEMENTS_MARK_SEEN,
	        ids: ids,
	        userId: userId,
	        sync: sync,
	        timestamp: (0, _timeUtil.getTimestamp)()
	    };
	};

/***/ }),
/* 461 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CURRENT_BOARD_ID_SET = exports.CURRENT_BOARD_ID_SET = 'CURRENT_BOARD_ID_SET';
	
	// Constant for the current board ID so that other selectors can wait until there's a board ID available
	var UNINITIALISED = exports.UNINITIALISED = 'UNINITIALISED';

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dragOver = exports.dragEnd = exports.dragStart = undefined;
	
	var _draggingConstants = __webpack_require__(143);
	
	var dragStart = exports.dragStart = function dragStart(ids) {
	  return { type: _draggingConstants.DRAG_START, ids: ids };
	};
	var dragEnd = exports.dragEnd = function dragEnd() {
	  return { type: _draggingConstants.DRAG_END };
	};
	var dragOver = exports.dragOver = function dragOver(targetId, targetType) {
	  return { type: _draggingConstants.DRAG_OVER, targetId: targetId, targetType: targetType };
	};

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.teamManagementModalSelctor = exports.selectedTeamMemberIdsSelector = undefined;
	
	var _reselect = __webpack_require__(7);
	
	var _currentUserSelector = __webpack_require__(33);
	
	var _teamManagementConstants = __webpack_require__(236);
	
	var getTeamMembers = function getTeamMembers(state) {
	    return state.getIn(['app', 'modal', 'team', 'teamMembers']);
	}; // Lib
	
	var getInitialIds = function getInitialIds(state) {
	    return state.getIn(['app', 'modal', 'team', 'initialIds']);
	};
	
	var teamMemberUsersSelector = (0, _reselect.createSelector)(getTeamMembers, function (state) {
	    return state.get('users');
	}, function (teamMembers, users) {
	    return teamMembers.map(function (member) {
	        var user = users.get(member.get('userId'));
	        if (user) return user.set('memberState', member.get('state'));
	        return user;
	    }).filter(function (user) {
	        return user;
	    });
	});
	
	var selectedTeamMemberIdsSelector = exports.selectedTeamMemberIdsSelector = (0, _reselect.createSelector)(getTeamMembers, function (members) {
	    return members.filter(function (member) {
	        return member.get('state') === _teamManagementConstants.TEAM_MEMBER_STATES.ADDED || member.get('state') === _teamManagementConstants.TEAM_MEMBER_STATES.NEW;
	    }).map(function (member) {
	        return member.get('userId');
	    }).toList();
	});
	
	var teamHasChangesSelector = (0, _reselect.createSelector)(getInitialIds, selectedTeamMemberIdsSelector, function (initialIds, memberIds) {
	    return initialIds && !initialIds.equals(memberIds);
	});
	
	var teamManagementModalSelctor = exports.teamManagementModalSelctor = (0, _reselect.createStructuredSelector)({
	    currentUser: _currentUserSelector.getCurrentUser,
	    teamMembers: teamMemberUsersSelector,
	    hasChanges: teamHasChangesSelector
	});

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchBoardDescendantCountAndDecrease = exports.fetchBoardDescendantCountAndIncrease = exports.decreaseElementCount = exports.increaseElementCount = undefined;
	
	var _http = __webpack_require__(76);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _logger = __webpack_require__(128);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _elementCountConstants = __webpack_require__(169);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var increaseElementCount = exports.increaseElementCount = function increaseElementCount(counts, transactionId) {
	    return {
	        type: _elementCountConstants.ELEMENT_COUNT_INCREAESE,
	        counts: counts,
	        transactionId: transactionId
	    };
	};
	
	var decreaseElementCount = exports.decreaseElementCount = function decreaseElementCount(counts, transactionId) {
	    return {
	        type: _elementCountConstants.ELEMENT_COUNT_DECREASE,
	        counts: counts,
	        transactionId: transactionId
	    };
	};
	
	var fetchBoardDescendantCountAndModify = function fetchBoardDescendantCountAndModify(modificationFn) {
	    return function (elementId, transactionId) {
	        return function (dispatch, getState) {
	            return (0, _http2.default)({
	                url: 'boards/' + elementId + '/count',
	                params: {
	                    creatorId: getState().getIn(['app', 'currentUser', '_id'])
	                }
	            }).then(function (_ref) {
	                var data = _ref.data;
	                return dispatch(modificationFn(data.elementCount, transactionId));
	            }).catch(function (error) {
	                _logger2.default.warn(error);
	            });
	        };
	    };
	};
	
	var fetchBoardDescendantCountAndIncrease = exports.fetchBoardDescendantCountAndIncrease = fetchBoardDescendantCountAndModify(increaseElementCount);
	var fetchBoardDescendantCountAndDecrease = exports.fetchBoardDescendantCountAndDecrease = fetchBoardDescendantCountAndModify(decreaseElementCount);

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.connectedBoardChannelSelector = exports.storedBoardChannelsSelector = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _reselect = __webpack_require__(7);
	
	var _milanoteReselect = __webpack_require__(49);
	
	var _elementHelper = __webpack_require__(13);
	
	var _remoteUsersSelector = __webpack_require__(237);
	
	var _mainSelector = __webpack_require__(239);
	
	var _currentUserSelector = __webpack_require__(33);
	
	var _elementSelector = __webpack_require__(41);
	
	var _socketConstants = __webpack_require__(109);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } // Lib
	
	
	// Util
	
	
	// Selectors
	
	
	// Constants
	
	
	// A threshold for the number of connected boards before previously connected boards will be dropped
	var CONNECTED_BOARD_THRESHOLD = 10;
	var EMPTY_ARRAY = [];
	
	/**
	 * Gets the channels that are stored within the Redux store.
	 */
	var storedBoardChannelsSelector = exports.storedBoardChannelsSelector = (0, _reselect.createSelector)(function (state) {
	    return state.getIn(['app', 'socketConnection', 'boardChannels']);
	}, function (channels) {
	    return channels;
	});
	
	var getPhysicalChildIdsDeepSelector = (0, _reselect.createSelector)(_elementSelector.getElements, function (state, ownProps) {
	    return ownProps.currentBoardId;
	}, _elementHelper.getPhysicalChildIdsDeep);
	
	/**
	 * Viewed ancestors & viewed deep children (not descendants, just children of the current board)
	 *  = active board channels we want to connect to.
	 */
	var activeBoardChannelSelector = (0, _milanoteReselect.createShallowSelector)(_remoteUsersSelector.getRemoteActiveCurrentlyViewedBoardIds, _mainSelector.getBreadcrumb, getPhysicalChildIdsDeepSelector, function (state, ownProps) {
	    return ownProps.currentBoardId;
	}, _currentUserSelector.isGuestSelector, function (currentlyViewedBoardIds, breadcrumbObj, deepChildren, currentBoardId, isGuest) {
	    if (isGuest) return EMPTY_ARRAY;
	
	    // Includes the current board
	    var viewableAncestors = breadcrumbObj.path;
	    var viewedAncestors = (0, _lodash.intersection)(viewableAncestors, currentlyViewedBoardIds);
	    var viewedChildren = (0, _lodash.intersection)(deepChildren, currentlyViewedBoardIds);
	
	    return [].concat(_toConsumableArray(viewedAncestors), _toConsumableArray(viewedChildren));
	});
	
	/**
	 * Active board channels (Y) + previously active board channels (X)
	 *    (where: X = 5 - Y  iff Y < 5)
	 */
	var connectedBoardChannelSelector = exports.connectedBoardChannelSelector = (0, _milanoteReselect.createShallowSelector)(activeBoardChannelSelector, storedBoardChannelsSelector, _currentUserSelector.isGuestSelector, function (activeBoardChannels, currentlyConnectedChannels, isGuest) {
	    if (isGuest) return EMPTY_ARRAY;
	
	    // Don't connect to previously connected boards if there are more than 10 active boards
	    if (activeBoardChannels.length > CONNECTED_BOARD_THRESHOLD) return activeBoardChannels;
	
	    var availablePreviouslyConnectedSpaces = CONNECTED_BOARD_THRESHOLD - activeBoardChannels.length;
	
	    var previouslyConnectedChannels = currentlyConnectedChannels.filter(function (channel) {
	        return !(0, _lodash.includes)(activeBoardChannels, channel);
	    }).take(availablePreviouslyConnectedSpaces).toJS();
	
	    return (0, _lodash.concat)(activeBoardChannels, previouslyConnectedChannels);
	});
	
	/**
	 * Gets the channels based on the currently active viewed boards, the user's breadcrumb as well as a 'live activity'
	 * channel which will simply be the current board ID with a '-LIVE' suffix.  The latter channel is used for sending
	 * selection and deselection messages.
	 */
	var channelSelector = (0, _milanoteReselect.createShallowSelector)(_remoteUsersSelector.getTrackedUserIds, connectedBoardChannelSelector, function (state, ownProps) {
	    return ownProps.currentBoardId;
	}, _currentUserSelector.isGuestSelector, function (userIds, connectedBoardChannels, currentBoardId, isGuest) {
	    if (isGuest) return EMPTY_ARRAY;
	
	    return [].concat(_toConsumableArray(connectedBoardChannels), _toConsumableArray(userIds), [
	    // TODO Potential improvement - don't join this channel when on a personal board (also no need to sync
	    // TODO    selection and deselection actions in that instance).
	    '' + currentBoardId + _socketConstants.LIVE_ACTIVITY_SUFFIX]);
	});
	
	exports.default = (0, _milanoteReselect.createShallowSelector)(channelSelector, connectedBoardChannelSelector, _currentUserSelector.isGuestSelector, function (channels, boardChannels, isGuest) {
	    return { channels: channels, boardChannels: boardChannels, isGuest: isGuest };
	});

/***/ }),
/* 466 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var extractErrorDetailsForAction = exports.extractErrorDetailsForAction = function extractErrorDetailsForAction(error) {
	    return error.response ? _extends({ id: error.id, url: error.url }, error.response) : { id: error.id, url: error.url, message: error.message, code: error.code };
	};

/***/ }),
/* 467 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (htmlStr) {
	    return {
	        __html: htmlStr
	    };
	};

/***/ }),
/* 468 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/**
	 * Simple wrapper around the HTML5 FileReader object to turn its API into a promise based interface.
	 * This doesn't expose all the functionality of the API (such as progress notifications etc, so should only be
	 * used in simple situations.
	 */
	var readFile = function readFile(method) {
	    return function (file, bytes) {
	        return new Promise(function (resolve, reject) {
	            var reader = new FileReader();
	
	            reader.onload = function (onloadEvent) {
	                return resolve(onloadEvent.target.result);
	            };
	            reader.onabort = function (onabortEvent) {
	                return reject(onabortEvent);
	            };
	            reader.onerror = function (onerrorEvent) {
	                return reject(onerrorEvent);
	            };
	
	            // TODO FLickr used webkit & mozilla fallbacks here, double check if this is necessary
	            var filePortion = bytes ? file.slice(0, bytes) : file;
	            reader[method](filePortion);
	        });
	    };
	};
	
	// Methods to place into the file reader
	var readAsDataURL = exports.readAsDataURL = readFile('readAsDataURL');
	var readAsArrayBuffer = exports.readAsArrayBuffer = readFile('readAsArrayBuffer');
	// Not supported in IE
	var readAsBinaryString = exports.readAsBinaryString = readFile('readAsBinaryString');

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Utils
	
	
	// Actions
	
	
	// Constants
	
	
	var _lodash = __webpack_require__(4);
	
	var _index = __webpack_require__(76);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _errorUtil = __webpack_require__(2271);
	
	var _errorUtil2 = __webpack_require__(466);
	
	var _rollbarService = __webpack_require__(226);
	
	var _resourceActions = __webpack_require__(765);
	
	var _resourceConstants = __webpack_require__(85);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getSingleResourceConfig = function getSingleResourceConfig(resourceType, config, id) {
	    return _extends({
	        url: resourceType + '/' + id,
	        storeServerErrors: true
	    }, config);
	};
	
	var getMultiResourceConfig = function getMultiResourceConfig(resourceType, config, ids) {
	    return _extends({
	        url: resourceType,
	        storeServerErrors: true
	    }, config, {
	        params: _extends({
	            ids: ids.join(',')
	        }, config.params)
	    });
	};
	
	exports.default = function (resourceType) {
	    var fetchingResource = (0, _resourceActions.makeResourceActionCreator)(resourceType, _resourceConstants.RESOURCES_FETCHING);
	    var fetchedResource = (0, _resourceActions.makeResourceActionCreator)(resourceType, _resourceConstants.RESOURCES_FETCHED);
	    var resourceFetchError = (0, _resourceActions.makeResourceErrorActionCreator)(resourceType);
	    var staleResource = (0, _resourceActions.makeResourceStaleActionCreator)(resourceType);
	
	    return function (_ref) {
	        var dispatch = _ref.dispatch,
	            _ref$config = _ref.config,
	            config = _ref$config === undefined ? {} : _ref$config,
	            id = _ref.id,
	            ids = _ref.ids;
	
	        var multiple = !!ids;
	        var _config = multiple ? getMultiResourceConfig(resourceType, config, ids) : getSingleResourceConfig(resourceType, config, id);
	
	        var fetchingIds = id ? [id] : ids;
	        dispatch(fetchingResource({ ids: fetchingIds }));
	        return (0, _index2.default)(_config).then(function (response) {
	            var fetchedTime = response.data.fetchedTime;
	
	            var errorIds = (0, _lodash.keys)(response.data.errors);
	            var fetchedIds = (0, _lodash.difference)(fetchingIds, errorIds);
	            if (fetchedIds.length) {
	                // Deferred to ensure it occurs after any load events
	                (0, _lodash.defer)(function () {
	                    return dispatch(fetchedResource({ ids: fetchedIds, fetchedTime: fetchedTime }));
	                });
	            }
	
	            // TODO Make this more generic
	            (0, _lodash.forEach)(response.data.errors, function (errorData, elementId) {
	                return dispatch(resourceFetchError({ id: elementId, err: errorData.error }));
	            });
	
	            return response;
	        }).catch(function (err) {
	            err.id = err.id || (0, _errorUtil.generateUniqueErrorId)();
	            err.url = _config.url;
	
	            // Only save server errors to the store if required.  By default the config is true, but it is
	            // provided to prevent helper service calls such as 'fetchNextBoards' from causing many boards to
	            // error when if it times out
	            if (_config.storeServerErrors) {
	                dispatch(resourceFetchError({ ids: fetchingIds, err: (0, _errorUtil2.extractErrorDetailsForAction)(err) }));
	            } else {
	                dispatch(staleResource({ ids: fetchingIds }));
	            }
	
	            (0, _rollbarService.manuallyReportError)({
	                errorMessage: resourceType + ' resource fetching error: ' + err,
	                error: err,
	                sensitive: false
	            });
	            return Promise.reject(err);
	        });
	    };
	};

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _resourceConstants = __webpack_require__(85);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Lib
	var initialState = Immutable.Map({
	    fetching: false,
	    fetched: false,
	    hasError: false,
	    error: undefined
	});
	
	// Constants
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _resourceConstants.RESOURCES_FETCHING:
	            return state.set('fetching', true);
	        case _resourceConstants.RESOURCES_FETCHED:
	            return state.withMutations(function (mutateState) {
	                return mutateState.set('fetching', false).set('fetched', true).set('fetchedTime', action.fetchedTime).set('hasError', false).set('error', null);
	            });
	        case _resourceConstants.RESOURCES_FETCH_ERROR:
	            return state.withMutations(function (mutateState) {
	                return mutateState.set('fetching', false).set('fetched', true).set('hasError', true).set('error', Immutable.fromJS(action.err));
	            });
	        case _resourceConstants.RESOURCES_MARKED_AS_STALE:
	            return state.withMutations(function (mutateState) {
	                return mutateState.set('fetching', false).set('fetched', false);
	            });
	        default:
	            return state;
	    }
	};

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _getResourceReducer = __webpack_require__(2135);
	
	var _getResourceReducer2 = _interopRequireDefault(_getResourceReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Lib
	var initialState = Immutable.Map({});
	
	// Reducers
	
	
	var defaultPredicateFn = function defaultPredicateFn(resourceType) {
	    return function (action) {
	        return action.resource === resourceType;
	    };
	};
	
	exports.default = function (resourceType, customPredicateFn) {
	    var predicateFn = customPredicateFn || defaultPredicateFn(resourceType);
	
	    var resourceReducer = (0, _getResourceReducer2.default)(resourceType);
	
	    var delegateToResource = function delegateToResource(state, action) {
	        return function (resourceId) {
	            return state.update(resourceId, function (resourceState) {
	                return resourceReducer(resourceState || undefined, action);
	            });
	        };
	    };
	
	    var delegateToEachResource = function delegateToEachResource(state, action) {
	        return state.withMutations(function (mutableState) {
	            return action.ids.forEach(delegateToResource(mutableState, action));
	        });
	    };
	
	    var delegateToAllResources = function delegateToAllResources(state, action) {
	        return state.withMutations(function (mutableState) {
	            return state.keySeq().forEach(delegateToResource(mutableState, action));
	        });
	    };
	
	    return function () {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	        var action = arguments[1];
	
	        if (!predicateFn(action)) return state;
	
	        if (action.ids) return delegateToEachResource(state, action);
	        if (action.id) return delegateToResource(state, action)(action.id);
	
	        return delegateToAllResources(state, action);
	    };
	};

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.makeFilteredResourcesSelector = exports.makeGetResourceSelector = exports.makeResourceTypeSelector = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _reselect = __webpack_require__(7);
	
	var _immutableHelper = __webpack_require__(23);
	
	// Resources manage the loading state
	// these are all curried methods that are called with a particular resource type (user/board/element)
	// ==================================
	
	var makeResourceTypeSelector = exports.makeResourceTypeSelector = function makeResourceTypeSelector(resourceType) {
	    return function (state) {
	        return state.getIn(['resources', resourceType]);
	    };
	};
	
	// gets a single resource for an id
	
	
	// Utils
	// Lib
	var makeGetResourceSelector = exports.makeGetResourceSelector = function makeGetResourceSelector(resourceType) {
	    return function (state, _ref) {
	        var id = _ref.id;
	        return state.getIn(['resources', resourceType, id]);
	    };
	};
	
	// give an array of ids, the resource entry matching each id
	var makeFilteredResourcesSelector = exports.makeFilteredResourcesSelector = (0, _lodash.curry)(function (resourceType, resourceIdsSelector) {
	    return (0, _reselect.createSelector)(resourceIdsSelector, makeResourceTypeSelector(resourceType), _immutableHelper.getMany);
	});

/***/ }),
/* 473 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var UNDO_STACK_LIMIT = exports.UNDO_STACK_LIMIT = 500;
	var UNDO_STACK_SLICE_SIZE = exports.UNDO_STACK_SLICE_SIZE = 400;
	
	var START_OPERATION = exports.START_OPERATION = 'START_OPERATION';
	var END_OPERATION = exports.END_OPERATION = 'END_OPERATION';

/***/ }),
/* 474 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getCurrentOperation = exports.getCurrentOperation = function getCurrentOperation(state) {
	  return state.getIn(['undoRedo', 'operation']);
	};
	var getMostRecentTransactionId = exports.getMostRecentTransactionId = function getMostRecentTransactionId(state) {
	  return state.getIn(['undoRedo', 'mostRecentTransactionId']);
	};

/***/ }),
/* 475 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LIVE_EDITING_POPUP_ID = exports.LIVE_EDITING_POPUP_ID = 'remoteUsers';

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.utilSharedTitle = exports.sharedTitle = exports.isPublic = exports.getSharedUserCount = undefined;
	
	var _userConstants = __webpack_require__(32);
	
	var _permissionsService = __webpack_require__(75);
	
	// Constants
	var getSharedUserCount = exports.getSharedUserCount = function getSharedUserCount(boardPermissions) {
	    return (0, _permissionsService.getSharedUsers)(boardPermissions).length;
	};
	
	var isPublic = exports.isPublic = function isPublic(boardPermissions) {
	    return Object.keys(boardPermissions).indexOf(_userConstants.PUBLIC_USER_ID) !== -1;
	};
	
	var buildSharingTitle = function buildSharingTitle(privateTitle) {
	    return function (boardPermissions) {
	        var compact = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        var sharedUserCount = getSharedUserCount(boardPermissions);
	
	        if (sharedUserCount > 1) {
	            if (compact) return 'Shared (' + sharedUserCount + ')';
	            return 'Shared with ' + sharedUserCount + ' people';
	        }
	
	        if (isPublic(boardPermissions)) {
	            return 'Shared';
	        }
	
	        return privateTitle;
	    };
	};
	
	var sharedTitle = exports.sharedTitle = buildSharingTitle('Private');
	var utilSharedTitle = exports.utilSharedTitle = buildSharingTitle('Share');

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ADD_SHARED_USER_FORM_FIELDS = exports.ADD_SHARED_USER_FORM_NAME = undefined;
	
	var _validationConstants = __webpack_require__(36);
	
	var ADD_SHARED_USER_FORM_NAME = exports.ADD_SHARED_USER_FORM_NAME = 'addSharedUser'; // Constants
	var ADD_SHARED_USER_FORM_FIELDS = exports.ADD_SHARED_USER_FORM_FIELDS = _validationConstants.ADD_SHARED_USER_FIELDS;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.unsharePublicBoard = exports.publiclyShareBoard = exports.removeSharedUser = exports.addSharedUser = exports.toggleShareForm = undefined;
	
	var _permissionsService = __webpack_require__(75);
	
	var _permissionUtil = __webpack_require__(89);
	
	var _userService = __webpack_require__(106);
	
	var _elementActions = __webpack_require__(26);
	
	var _sharingPopupConstants = __webpack_require__(785);
	
	var _errorConstants = __webpack_require__(243);
	
	var _validationConstants = __webpack_require__(36);
	
	var _userConstants = __webpack_require__(32);
	
	var _analytics = __webpack_require__(47);
	
	var toggleShareForm = exports.toggleShareForm = function toggleShareForm() {
	    return { type: _sharingPopupConstants.SHARE_POPUP_TOGGLE_SHARE_FORM };
	};
	
	// Constants
	
	
	// Actions
	// Util
	var addSharedUser = exports.addSharedUser = function addSharedUser(_ref) {
	    var elementId = _ref.elementId,
	        userEmail = _ref.userEmail;
	    return function (dispatch, getState) {
	        var state = getState();
	        var elements = state.get('elements');
	        var lowerCaseUserEmail = userEmail.toLowerCase();
	
	        return dispatch((0, _userService.getOrInviteUser)({ userEmail: lowerCaseUserEmail })).catch(function (err) {
	            var error = err.response && err.response.data && err.response.data.error;
	
	            // TODO I don't think this is used any more, so should be removed.  Also need server side validation
	            // TODO    for sharing invites
	            // On validation errors respond with a structure that the form can react to
	            if (error && error.code === _errorConstants.USER_ERROR.NOT_FOUND) {
	                var errorRes = {
	                    userEmail: {
	                        message: error.message,
	                        type: _validationConstants.FAILURE_TYPES.ERROR,
	                        value: lowerCaseUserEmail
	                    }
	                };
	                return Promise.reject(errorRes);
	            }
	            return Promise.reject(err);
	        }).then(function (user) {
	            var elementPermissionsMap = (0, _permissionsService.getAllPermissions)(elements, elementId);
	            if (elementPermissionsMap[user._id]) {
	                return Promise.reject({
	                    userEmail: {
	                        message: 'This board has already been shared with ' + user.name.displayName,
	                        type: _validationConstants.FAILURE_TYPES.WARNING,
	                        value: lowerCaseUserEmail
	                    }
	                });
	            }
	
	            // Add the user to the element's permissions
	            // Calculate the default permissions for a user
	            var permissions = (0, _permissionUtil.calculatePermissionValue)({});
	
	            dispatch((0, _elementActions.shareElement)({
	                id: elementId,
	                userId: user._id,
	                permissions: permissions
	            }));
	
	            (0, _analytics.analyticsEvent)('shared-board', {
	                invited_user_email: lowerCaseUserEmail,
	                invited_user_status: user.status
	            });
	
	            return user;
	        }).catch(function (err) {
	            console.error('ERROR: Adding shared user.', err, err.response);
	            return Promise.reject(err);
	        });
	    };
	};
	
	var removeSharedUser = exports.removeSharedUser = function removeSharedUser(_ref2) {
	    var elementId = _ref2.elementId,
	        userId = _ref2.userId;
	    return function (dispatch, getState) {
	        var state = getState();
	        var elements = state.get('elements');
	
	        var elementPermissionsMap = (0, _permissionsService.getAllPermissions)(elements, elementId);
	        if (!elementPermissionsMap[userId]) {
	            throw new Error({
	                userId: {
	                    message: 'This board is not shared with user ID \'' + userId + '\'',
	                    type: _validationConstants.FAILURE_TYPES.WARNING,
	                    value: userId
	                }
	            });
	        }
	
	        (0, _analytics.analyticsEvent)('unshared-board');
	
	        return dispatch((0, _elementActions.unshareElement)({
	            id: elementId,
	            userId: userId
	        }));
	    };
	};
	
	var publiclyShareBoard = exports.publiclyShareBoard = function publiclyShareBoard(_ref3) {
	    var elementId = _ref3.elementId;
	
	    (0, _analytics.analyticsEvent)('shared-public-board');
	
	    return (0, _elementActions.shareElement)({
	        id: elementId,
	        userId: _userConstants.PUBLIC_USER_ID,
	        permissions: (0, _permissionUtil.calculatePermissionValue)({ read: true, write: false, save: false, permissions: false })
	    });
	};
	
	var unsharePublicBoard = exports.unsharePublicBoard = function unsharePublicBoard(_ref4) {
	    var elementId = _ref4.elementId;
	
	    (0, _analytics.analyticsEvent)('unshared-public-board');
	
	    return (0, _elementActions.unshareElement)({
	        id: elementId,
	        userId: _userConstants.PUBLIC_USER_ID
	    });
	};

/***/ }),
/* 479 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var COLORS = exports.COLORS = {
	    NONE: { name: null, hex: null },
	    GREEN: { name: 'GREEN', hex: '#9ec874' },
	    BROWN: { name: 'BROWN', hex: '#d3906b' },
	    RED: { name: 'RED', hex: '#ff5d69' },
	    ORANGE: { name: 'ORANGE', hex: '#ff9a5c' },
	    YELLOW: { name: 'YELLOW', hex: '#ffc852' },
	    PINK: { name: 'PINK', hex: '#ff7cba' },
	    PURPLE: { name: 'PURPLE', hex: '#aa88e9' },
	    BLUE: { name: 'BLUE', hex: '#54b1ea' }
	};

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getClosestPointTo = exports.isOverlappingHorizontally = exports.getYOverlapFraction = exports.getXOverlapFraction = exports.get1DOverlapFraction = exports.getYOverlap = exports.getXOverlap = exports.getOverlap = exports.getLength = exports.getDy = exports.getDx = exports.get1DDelta = exports.getCenter = exports.getPointAlong = exports.getNewLine = exports.combineLines = exports.isAligned = exports.isVerticallyAligned = exports.isHorizontallyAligned = exports.isAlignedAlongDimension = exports.isVertical = exports.isHorizontal = exports.isFlatAlongDimension = exports.lineComparison = exports.chooseLine = exports.getLine = undefined;
	
	var _point = __webpack_require__(242);
	
	var pointLib = _interopRequireWildcard(_point);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// √
	var getLine = exports.getLine = function getLine(point1, point2) {
	    return {
	        start: point1,
	        end: point2
	    };
	};
	
	// √
	// Points
	var chooseLine = exports.chooseLine = function chooseLine(line1, line2, compFn) {
	    return compFn(line1, line2) ? line1 : line2;
	};
	// Assumes horizontal or vertical lines
	var lineComparison = exports.lineComparison = {
	    // Horizontal
	    leftmost: function leftmost(line1, line2) {
	        return line1.start.x < line2.start.x;
	    },
	    rightmost: function rightmost(line1, line2) {
	        return line1.start.x > line2.start.x;
	    },
	    // Vertical
	    upper: function upper(line1, line2) {
	        return line1.start.y < line2.start.y;
	    },
	    lower: function lower(line1, line2) {
	        return line1.start.y > line2.start.y;
	    }
	};
	
	// √
	var isFlatAlongDimension = exports.isFlatAlongDimension = function isFlatAlongDimension(line, dimension) {
	    return line.start[dimension] === line.end[dimension];
	};
	var isHorizontal = exports.isHorizontal = function isHorizontal(line) {
	    return isFlatAlongDimension(line, 'y');
	};
	var isVertical = exports.isVertical = function isVertical(line) {
	    return isFlatAlongDimension(line, 'x');
	};
	
	// √
	var isAlignedAlongDimension = exports.isAlignedAlongDimension = function isAlignedAlongDimension(line1, line2, dimension) {
	    return (
	        // Start inline
	        line1.start[dimension] === line2.start[dimension] &&
	        // Remain inline
	        isFlatAlongDimension(line1, dimension) && isFlatAlongDimension(line2, dimension)
	    );
	};
	var isHorizontallyAligned = exports.isHorizontallyAligned = function isHorizontallyAligned(line1, line2) {
	    return isAlignedAlongDimension(line1, line2, 'y');
	};
	var isVerticallyAligned = exports.isVerticallyAligned = function isVerticallyAligned(line1, line2) {
	    return isAlignedAlongDimension(line1, line2, 'x');
	};
	var isAligned = exports.isAligned = function isAligned(line1, line2) {
	    return isHorizontal(line1) ? isHorizontallyAligned(line1, line2) : isVerticallyAligned(line1, line2);
	};
	
	/**
	 * Simply combines two lines by taking the min start and max end values.
	 * Currently this assumes that all lines are moving in positive directions (i.e. end is not < start).
	 */
	// √
	var combineLines = exports.combineLines = function combineLines(line1, line2) {
	    return getLine(pointLib.getPoint(Math.min(line1.start.x, line2.start.x), Math.min(line1.start.y, line2.start.y)), pointLib.getPoint(Math.max(line1.end.x, line2.end.x), Math.max(line1.end.y, line2.end.y)));
	};
	
	// √
	var getNewLine = exports.getNewLine = function getNewLine(line1, line2, selectionStrategy) {
	    return isAligned(line1, line2) ? combineLines(line1, line2) : chooseLine(line1, line2, selectionStrategy);
	};
	
	// √
	var getPointAlong = exports.getPointAlong = function getPointAlong(line, fraction) {
	    return pointLib.getPointBetween(line.start, line.end, fraction);
	};
	var getCenter = exports.getCenter = function getCenter(line) {
	    return getPointAlong(line);
	};
	
	// √
	var get1DDelta = exports.get1DDelta = function get1DDelta(line, dimension) {
	    return pointLib.get1DDelta(line.start, line.end, dimension);
	};
	var getDx = exports.getDx = function getDx(line) {
	    return pointLib.getXDelta(line.start, line.end);
	};
	var getDy = exports.getDy = function getDy(line) {
	    return pointLib.getYDelta(line.start, line.end);
	};
	var getLength = exports.getLength = function getLength(line) {
	    return pointLib.getDistance(line.start, line.end);
	};
	
	// √
	var getOverlap = exports.getOverlap = function getOverlap(line1, line2, dimension) {
	    return Math.max(0, Math.min(line1.end[dimension], line2.end[dimension]) - Math.max(line1.start[dimension], line2.start[dimension]));
	};
	var getXOverlap = exports.getXOverlap = function getXOverlap(line1, line2) {
	    return getOverlap(line1, line2, 'x');
	};
	var getYOverlap = exports.getYOverlap = function getYOverlap(line1, line2) {
	    return getOverlap(line1, line2, 'y');
	};
	var get1DOverlapFraction = exports.get1DOverlapFraction = function get1DOverlapFraction(line1, line2, dimension) {
	    return getOverlap(line1, line2, dimension) / Math.min(get1DDelta(line1, dimension), get1DDelta(line2, dimension));
	};
	var getXOverlapFraction = exports.getXOverlapFraction = function getXOverlapFraction(line1, line2) {
	    return get1DOverlapFraction(line1, line2, 'x');
	};
	var getYOverlapFraction = exports.getYOverlapFraction = function getYOverlapFraction(line1, line2) {
	    return get1DOverlapFraction(line1, line2, 'y');
	};
	// TODO Prefer - "isInlineHorizontally"
	var isOverlappingHorizontally = exports.isOverlappingHorizontally = function isOverlappingHorizontally(line1, line2) {
	    var threshold = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	    return getXOverlapFraction(line1, line2) > threshold;
	};
	
	// √
	var getClosestPointTo = exports.getClosestPointTo = function getClosestPointTo(line, point) {
	    var A = pointLib.getXDelta(point, line.start);
	    var B = pointLib.getYDelta(point, line.start);
	    // TODO Not sure why -1
	    var C = -1 * getDx(line);
	    var D = -1 * getDy(line);
	
	    var dot = A * C + B * D;
	    var lengthSq = C * C + D * D;
	
	    // The ratio along the line that the closest point is
	    var ratio = lengthSq === 0 ? -1 : dot / lengthSq;
	
	    // Start of the line
	    if (ratio < 0) {
	        return line.start;
	        // End of the line
	    } else if (ratio > 1) {
	        return line.end;
	    }
	
	    // Otherwise it's some point along the line
	    return getPointAlong(line, ratio);
	};

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.distanceFromAnySide = exports.isVerticallyInline = exports.isOverlapping = exports.getLineFromRect = exports.getBoundingRect = exports.getFromWidthHeight = undefined;
	
	var _line = __webpack_require__(480);
	
	var lineLib = _interopRequireWildcard(_line);
	
	var _point = __webpack_require__(242);
	
	var pointLib = _interopRequireWildcard(_point);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// √
	// Line lib
	var getFromWidthHeight = exports.getFromWidthHeight = function getFromWidthHeight(_ref) {
	    var x = _ref.x,
	        y = _ref.y,
	        width = _ref.width,
	        height = _ref.height;
	    return {
	        left: x,
	        right: x + width,
	        top: y,
	        bottom: y + height
	    };
	};
	
	// √
	var getBoundingRect = exports.getBoundingRect = function getBoundingRect(rect1, rect2) {
	    return {
	        left: Math.min(rect1.left, rect2.left),
	        right: Math.max(rect1.right, rect2.right),
	        top: Math.min(rect1.top, rect2.top),
	        bottom: Math.max(rect1.bottom, rect2.bottom)
	    };
	};
	
	// √
	var getLineFromRect = exports.getLineFromRect = function getLineFromRect(rect, side) {
	    return lineLib.getLine(pointLib.getPoint(side !== 'right' ? rect.left : rect.right, side !== 'bottom' ? rect.top : rect.bottom), pointLib.getPoint(side !== 'left' ? rect.right : rect.left, side !== 'top' ? rect.bottom : rect.top));
	};
	
	// √
	var isOverlapping = exports.isOverlapping = function isOverlapping(rect1, rect2) {
	    return (
	        // horizontal overlap
	        rect1.left < rect2.right && rect1.right > rect2.left &&
	        // and vertical overlap
	        rect1.top < rect2.bottom && rect2.top < rect1.bottom
	    );
	};
	
	/**
	 * Determines if two rectangles are overlapping horizontally.
	 * This assumes the rectangles are flat along the x and y dimensions.
	 */
	var isVerticallyInline = exports.isVerticallyInline = function isVerticallyInline(rect1, rect2, threshold) {
	    return lineLib.isOverlappingHorizontally(getLineFromRect(rect1, 'bottom'), getLineFromRect(rect2, 'bottom'), threshold);
	};
	
	/**
	 * Determines the distance between two rectangles.
	 */
	// √
	var distanceFromAnySide = exports.distanceFromAnySide = function distanceFromAnySide(rect1, rect2) {
	    if (isOverlapping(rect1, rect2)) return 0;
	
	    var mostLeftRect = rect1.left < rect2.left ? rect1 : rect2;
	    var mostRightRect = rect1.right > rect2.right ? rect1 : rect2;
	    // X difference
	    var xDiff = mostRightRect.left - mostLeftRect.right;
	    xDiff = Math.max(0, xDiff);
	
	    var upperRect = rect1.top < rect2.top ? rect1 : rect2;
	    var lowerRect = rect1.bottom > rect2.bottom ? rect1 : rect2;
	    // X difference
	    var yDiff = lowerRect.top - upperRect.bottom;
	    yDiff = Math.max(0, yDiff);
	
	    return Math.hypot(xDiff, yDiff);
	};

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getAverageBottomLeft = exports.getAverageTopRight = exports.getAverageTopLeft = exports.getAbsoluteCenterLeft = exports.getAbsoluteBottomRight = exports.getAbsoluteTopRight = exports.getAbsoluteBottomLeft = exports.getAbsoluteTopLeft = exports.mergeClusters = exports.createLeafCluster = undefined;
	
	var _point = __webpack_require__(242);
	
	var pointLib = _interopRequireWildcard(_point);
	
	var _rect = __webpack_require__(481);
	
	var rectLib = _interopRequireWildcard(_rect);
	
	var _edges = __webpack_require__(2261);
	
	var edgesLib = _interopRequireWildcard(_edges);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } // Rect lib
	
	
	var createLeafCluster = exports.createLeafCluster = function createLeafCluster(documentElement) {
	    var bounds = rectLib.getFromWidthHeight(documentElement);
	    var edges = edgesLib.getEdges(bounds);
	
	    return {
	        id: documentElement.id,
	        type: documentElement.type,
	        color: documentElement.color,
	        elements: [documentElement.id],
	        children: [],
	        // The boundary of all edges
	        bounds: bounds,
	        // The lines of each edge (might not extend to the full size of the boundary
	        edges: edges,
	        height: 0
	    };
	};
	
	var combineCategories = function combineCategories(cat1, cat2) {
	    return cat1 === cat2 ? cat1 : null;
	};
	
	/**
	 * Merges two clusters and gives them a score based on their distance and the distance of all other clusters that have
	 * already been merged (not necessarily below these clusters though).
	 */
	var mergeClusters = exports.mergeClusters = function mergeClusters(cluster1, cluster2, height) {
	    return {
	        id: cluster1.id + '_' + cluster2.id,
	        type: combineCategories(cluster1.type, cluster2.type),
	        color: combineCategories(cluster1.color, cluster2.color),
	        elements: [].concat(_toConsumableArray(cluster1.elements), _toConsumableArray(cluster2.elements)),
	        children: [cluster1, cluster2],
	        bounds: rectLib.getBoundingRect(cluster1.bounds, cluster2.bounds),
	        edges: edgesLib.mergeEdges(cluster1.edges, cluster2.edges),
	        height: height
	    };
	};
	
	// √
	var getAbsoluteTopLeft = exports.getAbsoluteTopLeft = function getAbsoluteTopLeft(cluster) {
	    return pointLib.getPoint(cluster.bounds.left, cluster.bounds.top);
	};
	var getAbsoluteBottomLeft = exports.getAbsoluteBottomLeft = function getAbsoluteBottomLeft(cluster) {
	    return pointLib.getPoint(cluster.bounds.left, cluster.bounds.bottom);
	};
	var getAbsoluteTopRight = exports.getAbsoluteTopRight = function getAbsoluteTopRight(cluster) {
	    return pointLib.getPoint(cluster.bounds.right, cluster.bounds.top);
	};
	var getAbsoluteBottomRight = exports.getAbsoluteBottomRight = function getAbsoluteBottomRight(cluster) {
	    return pointLib.getPoint(cluster.bounds.right, cluster.bounds.bottom);
	};
	var getAbsoluteCenterLeft = exports.getAbsoluteCenterLeft = function getAbsoluteCenterLeft(cluster) {
	    return pointLib.getPointBetween(getAbsoluteTopLeft(cluster), getAbsoluteBottomLeft(cluster));
	};
	
	// √
	var getAverageTopLeft = exports.getAverageTopLeft = function getAverageTopLeft(cluster) {
	    return pointLib.getAveragePoint([getAbsoluteTopLeft(cluster), cluster.edges.left.start, cluster.edges.top.start]);
	};
	var getAverageTopRight = exports.getAverageTopRight = function getAverageTopRight(cluster) {
	    return pointLib.getAveragePoint([getAbsoluteTopRight(cluster), cluster.edges.right.start, cluster.edges.top.end]);
	};
	var getAverageBottomLeft = exports.getAverageBottomLeft = function getAverageBottomLeft(cluster) {
	    return pointLib.getAveragePoint([getAbsoluteBottomLeft(cluster), cluster.edges.left.end, cluster.edges.bottom.start]);
	};

/***/ }),
/* 483 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var MEDIA_TYPES = exports.MEDIA_TYPES = {
	    IMAGE: 'IMAGE',
	    VIDEO: 'VIDEO',
	    AUDIO: 'AUDIO',
	    RICH: 'RICH',
	    MAP: 'MAP',
	    DOC: 'DOC',
	    PDF: 'PDF'
	};
	
	var RESIZEABLE_MEDIA = exports.RESIZEABLE_MEDIA = [MEDIA_TYPES.IMAGE, MEDIA_TYPES.VIDEO, MEDIA_TYPES.AUDIO, MEDIA_TYPES.RICH, MEDIA_TYPES.MAP, MEDIA_TYPES.PDF];

/***/ }),
/* 484 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var PRICE_BILLING_UNITS = exports.PRICE_BILLING_UNITS = {
	    month: 'month',
	    year: 'year'
	};
	
	var INVOICE_STATUS = exports.INVOICE_STATUS = {
	    RECEIVED: 'RECEIVED', // step 1: recieved invoice data from stripe
	    SENT: 'SENT', // step 4: send email to customer
	    PAID_IN_CREDIT: 'PAID_IN_CREDIT' };
	
	var COUPON_DURATION = exports.COUPON_DURATION = {
	    forever: 'forever',
	    repeating: 'repeating',
	    once: 'once'
	};
	
	var INVOICE_DUE_DAYS = exports.INVOICE_DUE_DAYS = 14;

/***/ }),
/* 485 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	// Root Owner    Permissions Save    Write   Read
	// Z     O        P           S       W       R
	var ACCESS_BITS = exports.ACCESS_BITS = {
	    READ: 1,
	    WRITE: 1 << 1,
	    SAVE: 1 << 2,
	    PERMISSIONS: 1 << 3,
	    OWNER: 1 << 4
	};
	
	var PERMISSION_STATES = exports.PERMISSION_STATES = {
	    VALID: 'VALID',
	    INVALID: 'INVALID',
	    UNKNOWN: 'UNKNOWN'
	};

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.createTimestamp = exports.getTimestamp = exports.parseTimestamp = undefined;
	
	var _base = __webpack_require__(246);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _uidConstants = __webpack_require__(487);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var parseTimestamp = exports.parseTimestamp = function parseTimestamp(timeStamp) {
	    return _base2.default.decode(timeStamp) * _uidConstants.TIME_DIVISOR;
	};
	
	var getTimestamp = exports.getTimestamp = function getTimestamp(id) {
	    return parseTimestamp(id.slice(0, _uidConstants.TIMESTAMP_LENGTH));
	};
	
	var createTimestamp = exports.createTimestamp = function createTimestamp(time) {
	    var divisor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _uidConstants.TIME_DIVISOR;
	    return _base2.default.encode(Math.floor(time / divisor));
	};

/***/ }),
/* 487 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var TIME_DIVISOR = exports.TIME_DIVISOR = 1000;
	
	var RADIX = exports.RADIX = 62;
	
	var TIMESTAMP_LENGTH = exports.TIMESTAMP_LENGTH = 6;
	var CLIENT_ID_LENGTH = exports.CLIENT_ID_LENGTH = 6;
	var CLIENT_TICK_LENGTH = exports.CLIENT_TICK_LENGTH = 2;
	var ELEMENT_ID_LENGTH = exports.ELEMENT_ID_LENGTH = TIMESTAMP_LENGTH + CLIENT_ID_LENGTH + CLIENT_TICK_LENGTH;
	
	var TICK_MAX = exports.TICK_MAX = RADIX * RADIX;
	var CLIENT_OFFSET_MAX = exports.CLIENT_OFFSET_MAX = RADIX * RADIX * RADIX * RADIX;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _index = __webpack_require__(2299);
	
	var validatorRegistry = _interopRequireWildcard(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/**
	 * Uses the registered validators to determine whether the specified field value is valid given its field config.
	 *
	 * @param fieldValue {String} The value of the field.
	 * @param validationConfig {Object} An object that specifies the validations to apply to the field value.
	 *          See validationConstants.js.
	 * @returns {Object|null} null if the field value is valid, otherwise an object describing the validation failure.
	 */
	exports.default = function (fieldValue, validationConfig) {
	    var errorObject = null;
	
	    for (var validatorName in validatorRegistry) {
	        if (!validatorRegistry.hasOwnProperty(validatorName)) continue;
	
	        var validator = validatorRegistry[validatorName];
	
	        // Perform the validation
	        errorObject = validator(fieldValue, validationConfig);
	
	        // Short circuit on error to prevent unneeded validation tests
	        if (errorObject) break;
	    }
	
	    return errorObject;
	};

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(808);

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(78);
	var settle = __webpack_require__(814);
	var buildURL = __webpack_require__(817);
	var parseHeaders = __webpack_require__(823);
	var isURLSameOrigin = __webpack_require__(821);
	var createError = __webpack_require__(493);
	var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(816);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	    var loadEvent = 'onreadystatechange';
	    var xDomain = false;
	
	    // For IE 8/9 CORS support
	    // Only supports POST and GET calls and doesn't returns the response headers.
	    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	    if (("production") !== 'test' &&
	        typeof window !== 'undefined' &&
	        window.XDomainRequest && !('withCredentials' in request) &&
	        !isURLSameOrigin(config.url)) {
	      request = new window.XDomainRequest();
	      loadEvent = 'onload';
	      xDomain = true;
	      request.onprogress = function handleProgress() {};
	      request.ontimeout = function handleTimeout() {};
	    }
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request[loadEvent] = function handleLoad() {
	      if (!request || (request.readyState !== 4 && !xDomain)) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
	        status: request.status === 1223 ? 204 : request.status,
	        statusText: request.status === 1223 ? 'No Content' : request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED'));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(819);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        if (request.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ }),
/* 491 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ }),
/* 492 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(813);
	
	/**
	 * Create an Error with the specified message, config, error code, and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 @ @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, response);
	};


/***/ }),
/* 494 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	  A javascript Bezier curve library by Pomax.
	
	  Based on http://pomax.github.io/bezierinfo
	
	  This code is MIT licensed.
	**/
	(function() {
	  "use strict";
	
	  // math-inlining.
	  var abs = Math.abs,
	      min = Math.min,
	      max = Math.max,
	      acos = Math.acos,
	      sqrt = Math.sqrt,
	      pi = Math.PI,
	      // a zero coordinate, which is surprisingly useful
	      ZERO = {x:0,y:0,z:0};
	
	  // quite needed
	  var utils = __webpack_require__(496);
	
	  // not quite needed, but eventually this'll be useful...
	  var PolyBezier = __webpack_require__(829);
	
	  /**
	   * Bezier curve constructor. The constructor argument can be one of three things:
	   *
	   * 1. array/4 of {x:..., y:..., z:...}, z optional
	   * 2. numerical array/8 ordered x1,y1,x2,y2,x3,y3,x4,y4
	   * 3. numerical array/12 ordered x1,y1,z1,x2,y2,z2,x3,y3,z3,x4,y4,z4
	   *
	   */
	  var Bezier = function(coords) {
	    var args = (coords && coords.forEach) ? coords : [].slice.call(arguments);
	    var coordlen = false;
	    if(typeof args[0] === "object") {
	      coordlen = args.length;
	      var newargs = [];
	      args.forEach(function(point) {
	        ['x','y','z'].forEach(function(d) {
	          if(typeof point[d] !== "undefined") {
	            newargs.push(point[d]);
	          }
	        });
	      });
	      args = newargs;
	    }
	    var higher = false;
	    var len = args.length;
	    if (coordlen) {
	      if(coordlen>4) {
	        if (arguments.length !== 1) {
	          throw new Error("Only new Bezier(point[]) is accepted for 4th and higher order curves");
	        }
	        higher = true;
	      }
	    } else {
	      if(len!==6 && len!==8 && len!==9 && len!==12) {
	        if (arguments.length !== 1) {
	          throw new Error("Only new Bezier(point[]) is accepted for 4th and higher order curves");
	        }
	      }
	    }
	    var _3d = (!higher && (len === 9 || len === 12)) || (coords && coords[0] && typeof coords[0].z !== "undefined");
	    this._3d = _3d;
	    var points = [];
	    for(var idx=0, step=(_3d ? 3 : 2); idx<len; idx+=step) {
	      var point = {
	        x: args[idx],
	        y: args[idx+1]
	      };
	      if(_3d) { point.z = args[idx+2] };
	      points.push(point);
	    }
	    this.order = points.length - 1;
	    this.points = points;
	    var dims = ['x','y'];
	    if(_3d) dims.push('z');
	    this.dims = dims;
	    this.dimlen = dims.length;
	
	    (function(curve) {
	      var order = curve.order;
	      var points = curve.points;
	      var a = utils.align(points, {p1:points[0], p2:points[order]});
	      for(var i=0; i<a.length; i++) {
	        if(abs(a[i].y) > 0.0001) {
	          curve._linear = false;
	          return;
	        }
	      }
	      curve._linear = true;
	    }(this));
	
	    this._t1 = 0;
	    this._t2 = 1;
	    this.update();
	  };
	
	  Bezier.fromSVG = function(svgString) {
	    var list = svgString.match(/[-+]?\d*\.?\d+(?:[eE][-+]?\d+)?/g).map(parseFloat);
	    var relative = /[cq]/.test(svgString);
	    if(!relative) return new Bezier(list);
	    list = list.map(function(v,i) {
	      return i < 2 ? v : v + list[i % 2];
	    });
	    return new Bezier(list);
	  };
	
	  function getABC(n,S,B,E,t) {
	    if(typeof t === "undefined") { t = 0.5; }
	    var u = utils.projectionratio(t,n),
	        um = 1-u,
	        C = {
	          x: u*S.x + um*E.x,
	          y: u*S.y + um*E.y
	        },
	        s = utils.abcratio(t,n),
	        A = {
	          x: B.x + (B.x-C.x)/s,
	          y: B.y + (B.y-C.y)/s
	        };
	    return { A:A, B:B, C:C };
	  }
	
	  Bezier.quadraticFromPoints = function(p1,p2,p3, t) {
	    if(typeof t === "undefined") { t = 0.5; }
	    // shortcuts, although they're really dumb
	    if(t===0) { return new Bezier(p2,p2,p3); }
	    if(t===1) { return new Bezier(p1,p2,p2); }
	    // real fitting.
	    var abc = getABC(2,p1,p2,p3,t);
	    return new Bezier(p1, abc.A, p3);
	  };
	
	  Bezier.cubicFromPoints = function(S,B,E, t,d1) {
	    if(typeof t === "undefined") { t = 0.5; }
	    var abc = getABC(3,S,B,E,t);
	    if(typeof d1 === "undefined") { d1 = utils.dist(B,abc.C); }
	    var d2 = d1 * (1-t)/t;
	
	    var selen = utils.dist(S,E),
	        lx = (E.x-S.x)/selen,
	        ly = (E.y-S.y)/selen,
	        bx1 = d1 * lx,
	        by1 = d1 * ly,
	        bx2 = d2 * lx,
	        by2 = d2 * ly;
	    // derivation of new hull coordinates
	    var e1  = { x: B.x - bx1, y: B.y - by1 },
	        e2  = { x: B.x + bx2, y: B.y + by2 },
	        A = abc.A,
	        v1  = { x: A.x + (e1.x-A.x)/(1-t), y: A.y + (e1.y-A.y)/(1-t) },
	        v2  = { x: A.x + (e2.x-A.x)/(t), y: A.y + (e2.y-A.y)/(t) },
	        nc1 = { x: S.x + (v1.x-S.x)/(t), y: S.y + (v1.y-S.y)/(t) },
	        nc2 = { x: E.x + (v2.x-E.x)/(1-t), y: E.y + (v2.y-E.y)/(1-t) };
	    // ...done
	    return new Bezier(S,nc1,nc2,E);
	  };
	
	  var getUtils = function() {
	    return utils;
	  };
	
	  Bezier.getUtils = getUtils;
	
	  Bezier.prototype = {
	    getUtils: getUtils,
	    valueOf: function() {
	      return this.toString();
	    },
	    toString: function() {
	      return utils.pointsToString(this.points);
	    },
	    toSVG: function(relative) {
	      if(this._3d) return false;
	      var p = this.points,
	          x = p[0].x,
	          y = p[0].y,
	          s = ["M", x, y, (this.order===2 ? "Q":"C")];
	      for(var i=1, last=p.length; i<last; i++) {
	        s.push(p[i].x);
	        s.push(p[i].y);
	      }
	      return s.join(" ");
	    },
	    update: function() {
	      // one-time compute derivative coordinates
	      this.dpoints = [];
	      for(var p=this.points, d=p.length, c=d-1; d>1; d--, c--) {
	        var list = [];
	        for(var j=0, dpt; j<c; j++) {
	          dpt = {
	            x: c * (p[j+1].x - p[j].x),
	            y: c * (p[j+1].y - p[j].y)
	          };
	          if(this._3d) {
	            dpt.z = c * (p[j+1].z - p[j].z);
	          }
	          list.push(dpt);
	        }
	        this.dpoints.push(list);
	        p = list;
	      };
	      this.computedirection();
	    },
	    computedirection: function() {
	      var points = this.points;
	      var angle = utils.angle(points[0], points[this.order], points[1]);
	      this.clockwise = angle > 0;
	    },
	    length: function() {
	      return utils.length(this.derivative.bind(this));
	    },
	    _lut: [],
	    getLUT: function(steps) {
	      steps = steps || 100;
	      if (this._lut.length === steps) { return this._lut; }
	      this._lut = [];
	      for(var t=0; t<=steps; t++) {
	        this._lut.push(this.compute(t/steps));
	      }
	      return this._lut;
	    },
	    on: function(point, error) {
	      error = error || 5;
	      var lut = this.getLUT(), hits = [], c, t=0;
	      for(var i=0; i<lut.length; i++) {
	        c = lut[i];
	        if (utils.dist(c,point) < error) {
	          hits.push(c)
	          t += i / lut.length;
	        }
	      }
	      if(!hits.length) return false;
	      return t /= hits.length;
	    },
	    project: function(point) {
	      // step 1: coarse check
	      var LUT = this.getLUT(), l = LUT.length-1,
	          closest = utils.closest(LUT, point),
	          mdist = closest.mdist,
	          mpos = closest.mpos;
	      if (mpos===0 || mpos===l) {
	        var t = mpos/l, pt = this.compute(t);
	        pt.t = t;
	        pt.d = mdist;
	        return pt;
	      }
	
	      // step 2: fine check
	      var ft, t, p, d,
	          t1 = (mpos-1)/l,
	          t2 = (mpos+1)/l,
	          step = 0.1/l;
	      mdist += 1;
	      for(t=t1,ft=t; t<t2+step; t+=step) {
	        p = this.compute(t);
	        d = utils.dist(point, p);
	        if (d<mdist) {
	          mdist = d;
	          ft = t;
	        }
	      }
	      p = this.compute(ft);
	      p.t = ft;
	      p.d = mdist;
	      return p;
	    },
	    get: function(t) {
	      return this.compute(t);
	    },
	    point: function(idx) {
	      return this.points[idx];
	    },
	    compute: function(t) {
	      // shortcuts
	      if(t===0) { return this.points[0]; }
	      if(t===1) { return this.points[this.order]; }
	
	      var p = this.points;
	      var mt = 1-t;
	
	      // linear?
	      if(this.order===1) {
	        ret = {
	          x: mt*p[0].x + t*p[1].x,
	          y: mt*p[0].y + t*p[1].y
	        };
	        if (this._3d) { ret.z = mt*p[0].z + t*p[1].z; }
	        return ret;
	      }
	
	      // quadratic/cubic curve?
	      if(this.order<4) {
	        var mt2 = mt*mt,
	            t2 = t*t,
	            a,b,c,d = 0;
	        if(this.order===2) {
	          p = [p[0], p[1], p[2], ZERO];
	          a = mt2;
	          b = mt*t*2;
	          c = t2;
	        }
	        else if(this.order===3) {
	          a = mt2*mt;
	          b = mt2*t*3;
	          c = mt*t2*3;
	          d = t*t2;
	        }
	        var ret = {
	          x: a*p[0].x + b*p[1].x + c*p[2].x + d*p[3].x,
	          y: a*p[0].y + b*p[1].y + c*p[2].y + d*p[3].y
	        };
	        if(this._3d) {
	          ret.z = a*p[0].z + b*p[1].z + c*p[2].z + d*p[3].z;
	        }
	        return ret;
	      }
	
	      // higher order curves: use de Casteljau's computation
	      var dCpts = JSON.parse(JSON.stringify(this.points));
	      while(dCpts.length > 1) {
	        for (var i=0; i<dCpts.length-1; i++) {
	          dCpts[i] = {
	            x: dCpts[i].x + (dCpts[i+1].x - dCpts[i].x) * t,
	            y: dCpts[i].y + (dCpts[i+1].y - dCpts[i].y) * t
	          };
	          if (typeof dCpts[i].z !== "undefined") {
	            dCpts[i] = dCpts[i].z + (dCpts[i+1].z - dCpts[i].z) * t
	          }
	        }
	        dCpts.splice(dCpts.length-1, 1);
	      }
	      return dCpts[0];
	    },
	    raise: function() {
	      var p = this.points, np = [p[0]], i, k=p.length, pi, pim;
	      for (var i=1; i<k; i++) {
	        pi = p[i];
	        pim = p[i-1];
	        np[i] = {
	          x: (k-i)/k * pi.x + i/k * pim.x,
	          y: (k-i)/k * pi.y + i/k * pim.y
	        };
	      }
	      np[k] = p[k-1];
	      return new Bezier(np);
	    },
	    derivative: function(t) {
	      var mt = 1-t,
	          a,b,c=0,
	          p = this.dpoints[0];
	      if(this.order===2) { p = [p[0], p[1], ZERO]; a = mt; b = t; }
	      if(this.order===3) { a = mt*mt; b = mt*t*2; c = t*t; }
	      var ret = {
	        x: a*p[0].x + b*p[1].x + c*p[2].x,
	        y: a*p[0].y + b*p[1].y + c*p[2].y
	      };
	      if(this._3d) {
	        ret.z = a*p[0].z + b*p[1].z + c*p[2].z;
	      }
	      return ret;
	    },
	    inflections: function() {
	      return utils.inflections(this.points);
	    },
	    normal: function(t) {
	      return this._3d ? this.__normal3(t) : this.__normal2(t);
	    },
	    __normal2: function(t) {
	      var d = this.derivative(t);
	      var q = sqrt(d.x*d.x + d.y*d.y)
	      return { x: -d.y/q, y: d.x/q };
	    },
	    __normal3: function(t) {
	      // see http://stackoverflow.com/questions/25453159
	      var r1 = this.derivative(t),
	          r2 = this.derivative(t+0.01),
	          q1 = sqrt(r1.x*r1.x + r1.y*r1.y + r1.z*r1.z),
	          q2 = sqrt(r2.x*r2.x + r2.y*r2.y + r2.z*r2.z);
	      r1.x /= q1; r1.y /= q1; r1.z /= q1;
	      r2.x /= q2; r2.y /= q2; r2.z /= q2;
	      // cross product
	      var c = {
	        x: r2.y*r1.z - r2.z*r1.y,
	        y: r2.z*r1.x - r2.x*r1.z,
	        z: r2.x*r1.y - r2.y*r1.x
	      };
	      var m = sqrt(c.x*c.x + c.y*c.y + c.z*c.z);
	      c.x /= m; c.y /= m; c.z /= m;
	      // rotation matrix
	      var R = [   c.x*c.x,   c.x*c.y-c.z, c.x*c.z+c.y,
	                c.x*c.y+c.z,   c.y*c.y,   c.y*c.z-c.x,
	                c.x*c.z-c.y, c.y*c.z+c.x,   c.z*c.z    ];
	      // normal vector:
	      var n = {
	        x: R[0] * r1.x + R[1] * r1.y + R[2] * r1.z,
	        y: R[3] * r1.x + R[4] * r1.y + R[5] * r1.z,
	        z: R[6] * r1.x + R[7] * r1.y + R[8] * r1.z
	      };
	      return n;
	    },
	    hull: function(t) {
	      var p = this.points,
	          _p = [],
	          pt,
	          q = [],
	          idx = 0,
	          i=0,
	          l=0;
	      q[idx++] = p[0];
	      q[idx++] = p[1];
	      q[idx++] = p[2];
	      if(this.order === 3) { q[idx++] = p[3]; }
	      // we lerp between all points at each iteration, until we have 1 point left.
	      while(p.length>1) {
	        _p = [];
	        for(i=0, l=p.length-1; i<l; i++) {
	          pt = utils.lerp(t,p[i],p[i+1]);
	          q[idx++] = pt;
	          _p.push(pt);
	        }
	        p = _p;
	      }
	      return q;
	    },
	    split: function(t1, t2) {
	      // shortcuts
	      if(t1===0 && !!t2) { return this.split(t2).left; }
	      if(t2===1) { return this.split(t1).right; }
	
	      // no shortcut: use "de Casteljau" iteration.
	      var q = this.hull(t1);
	      var result = {
	        left: this.order === 2 ? new Bezier([q[0],q[3],q[5]]) : new Bezier([q[0],q[4],q[7],q[9]]),
	        right: this.order === 2 ? new Bezier([q[5],q[4],q[2]]) : new Bezier([q[9],q[8],q[6],q[3]]),
	        span: q
	      };
	
	      // make sure we bind _t1/_t2 information!
	      result.left._t1  = utils.map(0,  0,1, this._t1,this._t2);
	      result.left._t2  = utils.map(t1, 0,1, this._t1,this._t2);
	      result.right._t1 = utils.map(t1, 0,1, this._t1,this._t2);
	      result.right._t2 = utils.map(1,  0,1, this._t1,this._t2);
	
	      // if we have no t2, we're done
	      if(!t2) { return result; }
	
	      // if we have a t2, split again:
	      t2 = utils.map(t2,t1,1,0,1);
	      var subsplit = result.right.split(t2);
	      return subsplit.left;
	    },
	    extrema: function() {
	      var dims = this.dims,
	          result={},
	          roots=[],
	          p, mfn;
	      dims.forEach(function(dim) {
	        mfn = function(v) { return v[dim]; };
	        p = this.dpoints[0].map(mfn);
	        result[dim] = utils.droots(p);
	        if(this.order === 3) {
	          p = this.dpoints[1].map(mfn);
	          result[dim] = result[dim].concat(utils.droots(p));
	        }
	        result[dim] = result[dim].filter(function(t) { return (t>=0 && t<=1); });
	        roots = roots.concat(result[dim].sort());
	      }.bind(this));
	      roots = roots.sort().filter(function(v,idx) { return (roots.indexOf(v) === idx); });
	      result.values = roots;
	      return result;
	    },
	    bbox: function() {
	      var extrema = this.extrema(), result = {};
	      this.dims.forEach(function(d) {
	        result[d] = utils.getminmax(this, d, extrema[d]);
	      }.bind(this));
	      return result;
	    },
	    overlaps: function(curve) {
	      var lbbox = this.bbox(),
	          tbbox = curve.bbox();
	      return utils.bboxoverlap(lbbox,tbbox);
	    },
	    offset: function(t, d) {
	      if(typeof d !== "undefined") {
	        var c = this.get(t);
	        var n = this.normal(t);
	        var ret = {
	          c: c,
	          n: n,
	          x: c.x + n.x * d,
	          y: c.y + n.y * d
	        };
	        if(this._3d) {
	          ret.z = c.z + n.z * d;
	        };
	        return ret;
	      }
	      if(this._linear) {
	        var nv = this.normal(0);
	        var coords = this.points.map(function(p) {
	          var ret = {
	            x: p.x + t * nv.x,
	            y: p.y + t * nv.y
	          };
	          if(p.z && n.z) { ret.z = p.z + t * nv.z; }
	          return ret;
	        });
	        return [new Bezier(coords)];
	      }
	      var reduced = this.reduce();
	      return reduced.map(function(s) {
	        return s.scale(t);
	      });
	    },
	    simple: function() {
	      if(this.order===3) {
	        var a1 = utils.angle(this.points[0], this.points[3], this.points[1]);
	        var a2 = utils.angle(this.points[0], this.points[3], this.points[2]);
	        if(a1>0 && a2<0 || a1<0 && a2>0) return false;
	      }
	      var n1 = this.normal(0);
	      var n2 = this.normal(1);
	      var s = n1.x*n2.x + n1.y*n2.y;
	      if(this._3d) { s += n1.z*n2.z; }
	      var angle = abs(acos(s));
	      return angle < pi/3;
	    },
	    reduce: function() {
	      var i, t1=0, t2=0, step=0.01, segment, pass1=[], pass2=[];
	      // first pass: split on extrema
	      var extrema = this.extrema().values;
	      if(extrema.indexOf(0)===-1) { extrema = [0].concat(extrema); }
	      if(extrema.indexOf(1)===-1) { extrema.push(1); }
	
	      for(t1=extrema[0], i=1; i<extrema.length; i++) {
	        t2 = extrema[i];
	        segment = this.split(t1,t2);
	        segment._t1 = t1;
	        segment._t2 = t2;
	        pass1.push(segment);
	        t1 = t2;
	      }
	
	      // second pass: further reduce these segments to simple segments
	      pass1.forEach(function(p1) {
	        t1=0;
	        t2=0;
	        while(t2 <= 1) {
	          for(t2=t1+step; t2<=1+step; t2+=step) {
	            segment = p1.split(t1,t2);
	            if(!segment.simple()) {
	              t2 -= step;
	              if(abs(t1-t2)<step) {
	                // we can never form a reduction
	                return [];
	              }
	              segment = p1.split(t1,t2);
	              segment._t1 = utils.map(t1,0,1,p1._t1,p1._t2);
	              segment._t2 = utils.map(t2,0,1,p1._t1,p1._t2);
	              pass2.push(segment);
	              t1 = t2;
	              break;
	            }
	          }
	        }
	        if(t1<1) {
	          segment = p1.split(t1,1);
	          segment._t1 = utils.map(t1,0,1,p1._t1,p1._t2);
	          segment._t2 = p1._t2;
	          pass2.push(segment);
	        }
	      });
	      return pass2;
	    },
	    scale: function(d) {
	      var order = this.order;
	      var distanceFn = false
	      if(typeof d === "function") { distanceFn = d; }
	      if(distanceFn && order === 2) { return this.raise().scale(distanceFn); }
	
	      // TODO: add special handling for degenerate (=linear) curves.
	      var clockwise = this.clockwise;
	      var r1 = distanceFn ? distanceFn(0) : d;
	      var r2 = distanceFn ? distanceFn(1) : d;
	      var v = [ this.offset(0,10), this.offset(1,10) ];
	      var o = utils.lli4(v[0], v[0].c, v[1], v[1].c);
	      if(!o) { throw new Error("cannot scale this curve. Try reducing it first."); }
	      // move all points by distance 'd' wrt the origin 'o'
	      var points=this.points, np=[];
	
	      // move end points by fixed distance along normal.
	      [0,1].forEach(function(t) {
	        var p = np[t*order] = utils.copy(points[t*order]);
	        p.x += (t?r2:r1) * v[t].n.x;
	        p.y += (t?r2:r1) * v[t].n.y;
	      }.bind(this));
	
	      if (!distanceFn) {
	        // move control points to lie on the intersection of the offset
	        // derivative vector, and the origin-through-control vector
	        [0,1].forEach(function(t) {
	          if(this.order===2 && !!t) return;
	          var p = np[t*order];
	          var d = this.derivative(t);
	          var p2 = { x: p.x + d.x, y: p.y + d.y };
	          np[t+1] = utils.lli4(p, p2, o, points[t+1]);
	        }.bind(this));
	        return new Bezier(np);
	      }
	
	      // move control points by "however much necessary to
	      // ensure the correct tangent to endpoint".
	      [0,1].forEach(function(t) {
	        if(this.order===2 && !!t) return;
	        var p = points[t+1];
	        var ov = {
	          x: p.x - o.x,
	          y: p.y - o.y
	        };
	        var rc = distanceFn ? distanceFn((t+1)/order) : d;
	        if(distanceFn && !clockwise) rc = -rc;
	        var m = sqrt(ov.x*ov.x + ov.y*ov.y);
	        ov.x /= m;
	        ov.y /= m;
	        np[t+1] = {
	          x: p.x + rc*ov.x,
	          y: p.y + rc*ov.y
	        }
	      }.bind(this));
	      return new Bezier(np);
	    },
	    outline: function(d1, d2, d3, d4) {
	      d2 = (typeof d2 === "undefined") ? d1 : d2;
	      var reduced = this.reduce(),
	          len = reduced.length,
	          fcurves = [],
	          bcurves = [],
	          p,
	          alen = 0,
	          tlen = this.length();
	
	      var graduated = (typeof d3 !== "undefined" && typeof d4 !== "undefined");
	
	      function linearDistanceFunction(s,e, tlen,alen,slen) {
	        return function (v) {
	          var f1 = alen/tlen, f2 = (alen+slen)/tlen, d = e-s;
	          return utils.map(v, 0,1, s+f1*d, s+f2*d);
	        };
	      };
	
	      // form curve oulines
	      reduced.forEach(function(segment) {
	        slen = segment.length();
	        if (graduated) {
	          fcurves.push(segment.scale(  linearDistanceFunction( d1, d3, tlen,alen,slen)  ));
	          bcurves.push(segment.scale(  linearDistanceFunction(-d2,-d4, tlen,alen,slen)  ));
	        } else {
	          fcurves.push(segment.scale( d1));
	          bcurves.push(segment.scale(-d2));
	        }
	        alen += slen;
	      });
	
	      // reverse the "return" outline
	      bcurves = bcurves.map(function(s) {
	        p = s.points;
	        if(p[3]) { s.points = [p[3],p[2],p[1],p[0]]; }
	        else { s.points = [p[2],p[1],p[0]]; }
	        return s;
	      }).reverse();
	
	      // form the endcaps as lines
	      var fs = fcurves[0].points[0],
	          fe = fcurves[len-1].points[fcurves[len-1].points.length-1],
	          bs = bcurves[len-1].points[bcurves[len-1].points.length-1],
	          be = bcurves[0].points[0],
	          ls = utils.makeline(bs,fs),
	          le = utils.makeline(fe,be),
	          segments = [ls].concat(fcurves).concat([le]).concat(bcurves),
	          slen = segments.length;
	
	      return new PolyBezier(segments);
	    },
	    outlineshapes: function(d1, d2, curveIntersectionThreshold) {
	      d2 = d2 || d1;
	      var outline = this.outline(d1,d2).curves;
	      var shapes = [];
	      for(var i=1, len=outline.length; i < len/2; i++) {
	        var shape = utils.makeshape(outline[i], outline[len-i], curveIntersectionThreshold);
	        shape.startcap.virtual = (i > 1);
	        shape.endcap.virtual = (i < len/2-1);
	        shapes.push(shape);
	      }
	      return shapes;
	    },
	    intersects: function(curve, curveIntersectionThreshold) {
	      if(!curve) return this.selfintersects(curveIntersectionThreshold);
	      if(curve.p1 && curve.p2) {
	        return this.lineIntersects(curve);
	      }
	      if(curve instanceof Bezier) { curve = curve.reduce(); }
	      return this.curveintersects(this.reduce(), curve, curveIntersectionThreshold);
	    },
	    lineIntersects: function(line) {
	      var mx = min(line.p1.x, line.p2.x),
	          my = min(line.p1.y, line.p2.y),
	          MX = max(line.p1.x, line.p2.x),
	          MY = max(line.p1.y, line.p2.y),
	          self=this;
	      return utils.roots(this.points, line).filter(function(t) {
	        var p = self.get(t);
	        return utils.between(p.x, mx, MX) && utils.between(p.y, my, MY);
	      });
	    },
	    selfintersects: function(curveIntersectionThreshold) {
	      var reduced = this.reduce();
	      // "simple" curves cannot intersect with their direct
	      // neighbour, so for each segment X we check whether
	      // it intersects [0:x-2][x+2:last].
	      var i,len=reduced.length-2,results=[],result,left,right;
	      for(i=0; i<len; i++) {
	        left = reduced.slice(i,i+1);
	        right = reduced.slice(i+2);
	        result = this.curveintersects(left, right, curveIntersectionThreshold);
	        results = results.concat( result );
	      }
	      return results;
	    },
	    curveintersects: function(c1, c2, curveIntersectionThreshold) {
	      var pairs = [];
	      // step 1: pair off any overlapping segments
	      c1.forEach(function(l) {
	        c2.forEach(function(r) {
	          if(l.overlaps(r)) {
	            pairs.push({ left: l, right: r });
	          }
	        });
	      });
	      // step 2: for each pairing, run through the convergence algorithm.
	      var intersections = [];
	      pairs.forEach(function(pair) {
	        var result = utils.pairiteration(pair.left, pair.right, curveIntersectionThreshold);
	        if(result.length > 0) {
	          intersections = intersections.concat(result);
	        }
	      });
	      return intersections;
	    },
	    arcs: function(errorThreshold) {
	      errorThreshold = errorThreshold || 0.5;
	      var circles = [];
	      return this._iterate(errorThreshold, circles);
	    },
	    _error: function(pc, np1, s, e) {
	      var q = (e - s) / 4,
	          c1 = this.get(s + q),
	          c2 = this.get(e - q),
	          ref = utils.dist(pc, np1),
	          d1  = utils.dist(pc, c1),
	          d2  = utils.dist(pc, c2);
	      return abs(d1-ref) + abs(d2-ref);
	    },
	    _iterate: function(errorThreshold, circles) {
	      var s = 0, e = 1, safety;
	      // we do a binary search to find the "good `t` closest to no-longer-good"
	      do {
	        safety=0;
	
	        // step 1: start with the maximum possible arc
	        e = 1;
	
	        // points:
	        var np1 = this.get(s), np2, np3, arc, prev_arc;
	
	        // booleans:
	        var curr_good = false, prev_good = false, done;
	
	        // numbers:
	        var m = e, prev_e = 1, step = 0;
	
	        // step 2: find the best possible arc
	        do {
	          prev_good = curr_good;
	          prev_arc = arc;
	          m = (s + e)/2;
	          step++;
	
	          np2 = this.get(m);
	          np3 = this.get(e);
	
	          arc = utils.getccenter(np1, np2, np3);
	
	          //also save the t values
	          arc.interval = {
	            start: s,
	            end: e
	          };
	
	          var error = this._error(arc, np1, s, e);
	          curr_good = (error <= errorThreshold);
	
	          done = prev_good && !curr_good;
	          if(!done) prev_e = e;
	
	          // this arc is fine: we can move 'e' up to see if we can find a wider arc
	          if(curr_good) {
	
	            // if e is already at max, then we're done for this arc.
	            if (e >= 1) {
	              arc.interval.end = prev_e = 1;
	              prev_arc = arc;
	              break;
	            }
	            // if not, move it up by half the iteration distance
	            e = e + (e-s)/2;
	          }
	
	          // this is a bad arc: we need to move 'e' down to find a good arc
	          else {
	            e = m;
	          }
	        }
	        while(!done && safety++<100);
	
	        if(safety>=100) {
	          break;
	        }
	
	        // console.log("L835: [F] arc found", s, prev_e, prev_arc.x, prev_arc.y, prev_arc.s, prev_arc.e);
	
	        prev_arc = (prev_arc ? prev_arc : arc);
	        circles.push(prev_arc);
	        s = prev_e;
	      }
	      while(e < 1);
	      return circles;
	    }
	  };
	
	  module.exports = Bezier;
	
	}());


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	(function() {
	  "use strict";
	
	  // math-inlining.
	  var abs = Math.abs,
	      cos = Math.cos,
	      sin = Math.sin,
	      acos = Math.acos,
	      atan2 = Math.atan2,
	      sqrt = Math.sqrt,
	      pow = Math.pow,
	      // cube root function yielding real roots
	      crt = function(v) { return (v<0) ? -pow(-v,1/3) : pow(v,1/3); },
	      // trig constants
	      pi = Math.PI,
	      tau = 2*pi,
	      quart = pi/2,
	      // float precision significant decimal
	      epsilon = 0.000001,
	      // extremas used in bbox calculation and similar algorithms
	      nMax = Number.MAX_SAFE_INTEGER,
	      nMin = Number.MIN_SAFE_INTEGER;
	
	  // Bezier utility functions
	  var utils = {
	    // Legendre-Gauss abscissae with n=24 (x_i values, defined at i=n as the roots of the nth order Legendre polynomial Pn(x))
	    Tvalues: [
	      -0.0640568928626056260850430826247450385909,
	       0.0640568928626056260850430826247450385909,
	      -0.1911188674736163091586398207570696318404,
	       0.1911188674736163091586398207570696318404,
	      -0.3150426796961633743867932913198102407864,
	       0.3150426796961633743867932913198102407864,
	      -0.4337935076260451384870842319133497124524,
	       0.4337935076260451384870842319133497124524,
	      -0.5454214713888395356583756172183723700107,
	       0.5454214713888395356583756172183723700107,
	      -0.6480936519369755692524957869107476266696,
	       0.6480936519369755692524957869107476266696,
	      -0.7401241915785543642438281030999784255232,
	       0.7401241915785543642438281030999784255232,
	      -0.8200019859739029219539498726697452080761,
	       0.8200019859739029219539498726697452080761,
	      -0.8864155270044010342131543419821967550873,
	       0.8864155270044010342131543419821967550873,
	      -0.9382745520027327585236490017087214496548,
	       0.9382745520027327585236490017087214496548,
	      -0.9747285559713094981983919930081690617411,
	       0.9747285559713094981983919930081690617411,
	      -0.9951872199970213601799974097007368118745,
	       0.9951872199970213601799974097007368118745
	    ],
	
	    // Legendre-Gauss weights with n=24 (w_i values, defined by a function linked to in the Bezier primer article)
	    Cvalues: [
	      0.1279381953467521569740561652246953718517,
	      0.1279381953467521569740561652246953718517,
	      0.1258374563468282961213753825111836887264,
	      0.1258374563468282961213753825111836887264,
	      0.1216704729278033912044631534762624256070,
	      0.1216704729278033912044631534762624256070,
	      0.1155056680537256013533444839067835598622,
	      0.1155056680537256013533444839067835598622,
	      0.1074442701159656347825773424466062227946,
	      0.1074442701159656347825773424466062227946,
	      0.0976186521041138882698806644642471544279,
	      0.0976186521041138882698806644642471544279,
	      0.0861901615319532759171852029837426671850,
	      0.0861901615319532759171852029837426671850,
	      0.0733464814110803057340336152531165181193,
	      0.0733464814110803057340336152531165181193,
	      0.0592985849154367807463677585001085845412,
	      0.0592985849154367807463677585001085845412,
	      0.0442774388174198061686027482113382288593,
	      0.0442774388174198061686027482113382288593,
	      0.0285313886289336631813078159518782864491,
	      0.0285313886289336631813078159518782864491,
	      0.0123412297999871995468056670700372915759,
	      0.0123412297999871995468056670700372915759
	    ],
	
	    arcfn: function(t, derivativeFn) {
	      var d = derivativeFn(t);
	      var l = d.x*d.x + d.y*d.y;
	      if(typeof d.z !== "undefined") {
	        l += d.z*d.z;
	      }
	      return sqrt(l);
	    },
	
	    between: function(v, m, M) {
	      return (m <= v && v <= M) || utils.approximately(v, m) || utils.approximately(v, M);
	    },
	
	    approximately: function(a,b,precision) {
	      return abs(a-b) <= (precision || epsilon);
	    },
	
	    length: function(derivativeFn) {
	      var z=0.5,sum=0,len=utils.Tvalues.length,i,t;
	      for(i=0; i<len; i++) {
	        t = z * utils.Tvalues[i] + z;
	        sum += utils.Cvalues[i] * utils.arcfn(t,derivativeFn);
	      }
	      return z * sum;
	    },
	
	    map: function(v, ds,de, ts,te) {
	      var d1 = de-ds, d2 = te-ts, v2 =  v-ds, r = v2/d1;
	      return ts + d2*r;
	    },
	
	    lerp: function(r, v1, v2) {
	      var ret = {
	        x: v1.x + r*(v2.x-v1.x),
	        y: v1.y + r*(v2.y-v1.y)
	      };
	      if(!!v1.z && !!v2.z) {
	        ret.z =  v1.z + r*(v2.z-v1.z);
	      }
	      return ret;
	    },
	
	    pointToString: function(p) {
	      var s = p.x+"/"+p.y;
	      if(typeof p.z !== "undefined") {
	        s += "/"+p.z;
	      }
	      return s;
	    },
	
	    pointsToString: function(points) {
	      return "[" + points.map(utils.pointToString).join(", ") + "]";
	    },
	
	    copy: function(obj) {
	      return JSON.parse(JSON.stringify(obj));
	    },
	
	    angle: function(o,v1,v2) {
	      var dx1 = v1.x - o.x,
	          dy1 = v1.y - o.y,
	          dx2 = v2.x - o.x,
	          dy2 = v2.y - o.y,
	          cross = dx1*dy2 - dy1*dx2,
	          dot = dx1*dx2 + dy1*dy2;
	      return atan2(cross, dot);
	    },
	
	    // round as string, to avoid rounding errors
	    round: function(v, d) {
	      var s = '' + v;
	      var pos = s.indexOf(".");
	      return parseFloat(s.substring(0,pos+1+d));
	    },
	
	    dist: function(p1, p2) {
	      var dx = p1.x - p2.x,
	          dy = p1.y - p2.y;
	      return sqrt(dx*dx+dy*dy);
	    },
	
	    closest: function(LUT, point) {
	      var mdist = pow(2,63), mpos, d;
	      LUT.forEach(function(p, idx) {
	        d = utils.dist(point, p);
	        if (d<mdist) {
	          mdist = d;
	          mpos = idx;
	        }
	      });
	      return { mdist:mdist, mpos:mpos };
	    },
	
	    abcratio: function(t, n) {
	      // see ratio(t) note on http://pomax.github.io/bezierinfo/#abc
	      if (n!==2 && n!==3) {
	        return false;
	      }
	      if (typeof t === "undefined") {
	        t = 0.5;
	      } else if (t===0 || t===1) {
	        return t;
	      }
	      var bottom = pow(t,n) + pow(1-t,n), top = bottom - 1;
	      return abs(top/bottom);
	    },
	
	    projectionratio: function(t, n) {
	      // see u(t) note on http://pomax.github.io/bezierinfo/#abc
	      if (n!==2 && n!==3) {
	        return false;
	      }
	      if (typeof t === "undefined") {
	        t = 0.5;
	      } else if (t===0 || t===1) {
	        return t;
	      }
	      var top = pow(1-t, n), bottom = pow(t,n) + top;
	      return top/bottom;
	    },
	
	    lli8: function(x1,y1,x2,y2,x3,y3,x4,y4) {
	      var nx=(x1*y2-y1*x2)*(x3-x4)-(x1-x2)*(x3*y4-y3*x4),
	          ny=(x1*y2-y1*x2)*(y3-y4)-(y1-y2)*(x3*y4-y3*x4),
	          d=(x1-x2)*(y3-y4)-(y1-y2)*(x3-x4);
	      if(d==0) { return false; }
	      return { x: nx/d, y: ny/d };
	    },
	
	    lli4: function(p1,p2,p3,p4) {
	      var x1 = p1.x, y1 = p1.y,
	          x2 = p2.x, y2 = p2.y,
	          x3 = p3.x, y3 = p3.y,
	          x4 = p4.x, y4 = p4.y;
	      return utils.lli8(x1,y1,x2,y2,x3,y3,x4,y4);
	    },
	
	    lli: function(v1, v2) {
	      return utils.lli4(v1,v1.c,v2,v2.c);
	    },
	
	    makeline: function(p1,p2) {
	      var Bezier = __webpack_require__(495);
	      var x1 = p1.x, y1 = p1.y, x2 = p2.x, y2 = p2.y, dx = (x2-x1)/3, dy = (y2-y1)/3;
	      return new Bezier(x1, y1, x1+dx, y1+dy, x1+2*dx, y1+2*dy, x2, y2);
	    },
	
	    findbbox: function(sections) {
	      var mx=nMax,my=nMax,MX=nMin,MY=nMin;
	      sections.forEach(function(s) {
	        var bbox = s.bbox();
	        if(mx > bbox.x.min) mx = bbox.x.min;
	        if(my > bbox.y.min) my = bbox.y.min;
	        if(MX < bbox.x.max) MX = bbox.x.max;
	        if(MY < bbox.y.max) MY = bbox.y.max;
	      });
	      return {
	        x: { min: mx, mid:(mx+MX)/2, max: MX, size:MX-mx },
	        y: { min: my, mid:(my+MY)/2, max: MY, size:MY-my }
	      }
	    },
	
	    shapeintersections: function(s1, bbox1, s2, bbox2, curveIntersectionThreshold) {
	      if(!utils.bboxoverlap(bbox1, bbox2)) return [];
	      var intersections = [];
	      var a1 = [s1.startcap, s1.forward, s1.back, s1.endcap];
	      var a2 = [s2.startcap, s2.forward, s2.back, s2.endcap];
	      a1.forEach(function(l1) {
	        if(l1.virtual) return;
	        a2.forEach(function(l2) {
	          if(l2.virtual) return;
	          var iss = l1.intersects(l2, curveIntersectionThreshold);
	          if(iss.length>0) {
	            iss.c1 = l1;
	            iss.c2 = l2;
	            iss.s1 = s1;
	            iss.s2 = s2;
	            intersections.push(iss);
	          }
	        });
	      });
	      return intersections;
	    },
	
	    makeshape: function(forward, back, curveIntersectionThreshold) {
	      var bpl = back.points.length;
	      var fpl = forward.points.length;
	      var start  = utils.makeline(back.points[bpl-1], forward.points[0]);
	      var end    = utils.makeline(forward.points[fpl-1], back.points[0]);
	      var shape  = {
	        startcap: start,
	        forward: forward,
	        back: back,
	        endcap: end,
	        bbox: utils.findbbox([start, forward, back, end])
	      };
	      var self = utils;
	      shape.intersections = function(s2) {
	        return self.shapeintersections(shape,shape.bbox,s2,s2.bbox, curveIntersectionThreshold);
	      };
	      return shape;
	    },
	
	    getminmax: function(curve, d, list) {
	      if(!list) return { min:0, max:0 };
	      var min=nMax, max=nMin,t,c;
	      if(list.indexOf(0)===-1) { list = [0].concat(list); }
	      if(list.indexOf(1)===-1) { list.push(1); }
	      for(var i=0,len=list.length; i<len; i++) {
	        t = list[i];
	        c = curve.get(t);
	        if(c[d] < min) { min = c[d]; }
	        if(c[d] > max) { max = c[d]; }
	      }
	      return { min:min, mid:(min+max)/2, max:max, size:max-min };
	    },
	
	    align: function(points, line) {
	      var tx = line.p1.x,
	          ty = line.p1.y,
	          a = -atan2(line.p2.y-ty, line.p2.x-tx),
	          d = function(v) {
	            return {
	              x: (v.x-tx)*cos(a) - (v.y-ty)*sin(a),
	              y: (v.x-tx)*sin(a) + (v.y-ty)*cos(a)
	            };
	          };
	      return points.map(d);
	    },
	
	    roots: function(points, line) {
	      line = line || {p1:{x:0,y:0},p2:{x:1,y:0}};
	      var order = points.length - 1;
	      var p = utils.align(points, line);
	      var reduce = function(t) { return 0<=t && t <=1; };
	
	      if (order === 2) {
	        var a = p[0].y,
	            b = p[1].y,
	            c = p[2].y,
	            d = a - 2*b + c;
	        if(d!==0) {
	          var m1 = -sqrt(b*b-a*c),
	              m2 = -a+b,
	              v1 = -( m1+m2)/d,
	              v2 = -(-m1+m2)/d;
	          return [v1, v2].filter(reduce);
	        }
	        else if(b!==c && d===0) {
	          return [ (2*b-c)/2*(b-c) ].filter(reduce);
	        }
	        return [];
	      }
	
	      // see http://www.trans4mind.com/personal_development/mathematics/polynomials/cubicAlgebra.htm
	      var pa = p[0].y,
	          pb = p[1].y,
	          pc = p[2].y,
	          pd = p[3].y,
	          d = (-pa + 3*pb - 3*pc + pd),
	          a = (3*pa - 6*pb + 3*pc) / d,
	          b = (-3*pa + 3*pb) / d,
	          c = pa / d,
	          p = (3*b - a*a)/3,
	          p3 = p/3,
	          q = (2*a*a*a - 9*a*b + 27*c)/27,
	          q2 = q/2,
	          discriminant = q2*q2 + p3*p3*p3,
	          u1,v1,x1,x2,x3;
	       if (discriminant < 0) {
	        var mp3 = -p/3,
	            mp33 = mp3*mp3*mp3,
	            r = sqrt( mp33 ),
	            t = -q/(2*r),
	            cosphi = t<-1 ? -1 : t>1 ? 1 : t,
	            phi = acos(cosphi),
	            crtr = crt(r),
	            t1 = 2*crtr;
	        x1 = t1 * cos(phi/3) - a/3;
	        x2 = t1 * cos((phi+tau)/3) - a/3;
	        x3 = t1 * cos((phi+2*tau)/3) - a/3;
	        return [x1, x2, x3].filter(reduce);
	      } else if(discriminant === 0) {
	        u1 = q2 < 0 ? crt(-q2) : -crt(q2);
	        x1 = 2*u1-a/3;
	        x2 = -u1 - a/3;
	        return [x1,x2].filter(reduce);
	      } else {
	        var sd = sqrt(discriminant);
	        u1 = crt(-q2+sd);
	        v1 = crt(q2+sd);
	        return [u1-v1-a/3].filter(reduce);;
	      }
	    },
	
	    droots: function(p) {
	      // quadratic roots are easy
	      if(p.length === 3) {
	        var a = p[0],
	            b = p[1],
	            c = p[2],
	            d = a - 2*b + c;
	        if(d!==0) {
	          var m1 = -sqrt(b*b-a*c),
	              m2 = -a+b,
	              v1 = -( m1+m2)/d,
	              v2 = -(-m1+m2)/d;
	          return [v1, v2];
	        }
	        else if(b!==c && d===0) {
	          return [(2*b-c)/(2*(b-c))];
	        }
	        return [];
	      }
	
	      // linear roots are even easier
	      if(p.length === 2) {
	        var a = p[0], b = p[1];
	        if(a!==b) {
	          return [a/(a-b)];
	        }
	        return [];
	      }
	    },
	
	    inflections: function(points) {
	      if (points.length<4) return [];
	
	      // FIXME: TODO: add in inflection abstraction for quartic+ curves?
	
	      var p = utils.align(points, { p1: points[0], p2: points.slice(-1)[0] }),
	          a = p[2].x * p[1].y,
	          b = p[3].x * p[1].y,
	          c = p[1].x * p[2].y,
	          d = p[3].x * p[2].y,
	          v1 = 18 * (-3*a + 2*b + 3*c - d),
	          v2 = 18 * (3*a - b - 3*c),
	          v3 = 18 * (c - a);
	
	      if (utils.approximately(v1,0)){
	        if(!utils.approximately(v2,0)){
	          var t = -v3/v2;
	          if (0 <= t && t <= 1)
	             return [t];
	        }
	        return [];
	      }
	
	      var trm = v2*v2 - 4*v1*v3,
	          sq = Math.sqrt(trm),
	          d = 2 * v1;
	
	      if (utils.approximately(d,0)) return [];
	
	      return [(sq-v2)/d, -(v2+sq)/d].filter(function(r) {
	        return (0 <= r && r <= 1);
	      });
	    },
	
	    bboxoverlap: function(b1,b2) {
	      var dims=['x','y'],len=dims.length,i,dim,l,t,d
	      for(i=0; i<len; i++) {
	        dim = dims[i];
	        l = b1[dim].mid;
	        t = b2[dim].mid;
	        d = (b1[dim].size + b2[dim].size)/2;
	        if(abs(l-t) >= d) return false;
	      }
	      return true;
	    },
	
	    expandbox: function(bbox, _bbox) {
	      if(_bbox.x.min < bbox.x.min) { bbox.x.min = _bbox.x.min; }
	      if(_bbox.y.min < bbox.y.min) { bbox.y.min = _bbox.y.min; }
	      if(_bbox.z && _bbox.z.min < bbox.z.min) { bbox.z.min = _bbox.z.min; }
	      if(_bbox.x.max > bbox.x.max) { bbox.x.max = _bbox.x.max; }
	      if(_bbox.y.max > bbox.y.max) { bbox.y.max = _bbox.y.max; }
	      if(_bbox.z && _bbox.z.max > bbox.z.max) { bbox.z.max = _bbox.z.max; }
	      bbox.x.mid = (bbox.x.min + bbox.x.max)/2;
	      bbox.y.mid = (bbox.y.min + bbox.y.max)/2;
	      if(bbox.z) { bbox.z.mid = (bbox.z.min + bbox.z.max)/2; }
	      bbox.x.size = bbox.x.max - bbox.x.min;
	      bbox.y.size = bbox.y.max - bbox.y.min;
	      if(bbox.z) { bbox.z.size = bbox.z.max - bbox.z.min; }
	    },
	
	    pairiteration: function(c1, c2, curveIntersectionThreshold) {
	      var c1b = c1.bbox(),
	          c2b = c2.bbox(),
	          r = 100000,
	          threshold = curveIntersectionThreshold || 0.5;
	      if(c1b.x.size + c1b.y.size < threshold && c2b.x.size + c2b.y.size < threshold) {
	        return [ ((r * (c1._t1+c1._t2)/2)|0)/r + "/" + ((r * (c2._t1+c2._t2)/2)|0)/r ];
	      }
	      var cc1 = c1.split(0.5),
	          cc2 = c2.split(0.5),
	          pairs = [
	            {left: cc1.left, right: cc2.left },
	            {left: cc1.left, right: cc2.right },
	            {left: cc1.right, right: cc2.right },
	            {left: cc1.right, right: cc2.left }];
	      pairs = pairs.filter(function(pair) {
	        return utils.bboxoverlap(pair.left.bbox(),pair.right.bbox());
	      });
	      var results = [];
	      if(pairs.length === 0) return results;
	      pairs.forEach(function(pair) {
	        results = results.concat(
	          utils.pairiteration(pair.left, pair.right, threshold)
	        );
	      })
	      results = results.filter(function(v,i) {
	        return results.indexOf(v) === i;
	      });
	      return results;
	    },
	
	    getccenter: function(p1,p2,p3) {
	      var dx1 = (p2.x - p1.x),
	          dy1 = (p2.y - p1.y),
	          dx2 = (p3.x - p2.x),
	          dy2 = (p3.y - p2.y);
	      var dx1p = dx1 * cos(quart) - dy1 * sin(quart),
	          dy1p = dx1 * sin(quart) + dy1 * cos(quart),
	          dx2p = dx2 * cos(quart) - dy2 * sin(quart),
	          dy2p = dx2 * sin(quart) + dy2 * cos(quart);
	      // chord midpoints
	      var mx1 = (p1.x + p2.x)/2,
	          my1 = (p1.y + p2.y)/2,
	          mx2 = (p2.x + p3.x)/2,
	          my2 = (p2.y + p3.y)/2;
	      // midpoint offsets
	      var mx1n = mx1 + dx1p,
	          my1n = my1 + dy1p,
	          mx2n = mx2 + dx2p,
	          my2n = my2 + dy2p;
	      // intersection of these lines:
	      var arc = utils.lli8(mx1,my1,mx1n,my1n, mx2,my2,mx2n,my2n),
	          r = utils.dist(arc,p1),
	          // arc start/end values, over mid point:
	          s = atan2(p1.y - arc.y, p1.x - arc.x),
	          m = atan2(p2.y - arc.y, p2.x - arc.x),
	          e = atan2(p3.y - arc.y, p3.x - arc.x),
	          _;
	      // determine arc direction (cw/ccw correction)
	      if (s<e) {
	        // if s<m<e, arc(s, e)
	        // if m<s<e, arc(e, s + tau)
	        // if s<e<m, arc(e, s + tau)
	        if (s>m || m>e) { s += tau; }
	        if (s>e) { _=e; e=s; s=_; }
	      } else {
	        // if e<m<s, arc(e, s)
	        // if m<e<s, arc(s, e + tau)
	        // if e<s<m, arc(s, e + tau)
	        if (e<m && m<s) { _=e; e=s; s=_; } else { e += tau; }
	      }
	      // assign and done.
	      arc.s = s;
	      arc.e = e;
	      arc.r = r;
	      return arc;
	    }
	  };
	
	  module.exports = utils;
	}());


/***/ }),
/* 497 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createChangeEmitter = exports.createChangeEmitter = function createChangeEmitter() {
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  function listen(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function () {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  function emit() {
	    currentListeners = nextListeners;
	    var listeners = currentListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i].apply(listeners, arguments);
	    }
	  }
	
	  return {
	    listen: listen,
	    emit: emit
	  };
	};

/***/ }),
/* 498 */
/***/ (function(module, exports) {

	/**
	 * Slice reference.
	 */
	
	var slice = [].slice;
	
	/**
	 * Bind `obj` to `fn`.
	 *
	 * @param {Object} obj
	 * @param {Function|String} fn or string
	 * @return {Function}
	 * @api public
	 */
	
	module.exports = function(obj, fn){
	  if ('string' == typeof fn) fn = obj[fn];
	  if ('function' != typeof fn) throw new Error('bind() requires a function');
	  var args = slice.call(arguments, 2);
	  return function(){
	    return fn.apply(obj, args.concat(slice.call(arguments)));
	  }
	};


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(91);
	module.exports = function(it, msg){
	  if(typeof it != 'number' && cof(it) != 'Number')throw TypeError(msg);
	  return +it;
	};

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(51)
	  , toIndex  = __webpack_require__(156)
	  , toLength = __webpack_require__(44);
	
	module.exports = [].copyWithin || function copyWithin(target/*= 0*/, start/*= 0, end = @length*/){
	  var O     = toObject(this)
	    , len   = toLength(O.length)
	    , to    = toIndex(target, len)
	    , from  = toIndex(start, len)
	    , end   = arguments.length > 2 ? arguments[2] : undefined
	    , count = Math.min((end === undefined ? len : toIndex(end, len)) - from, len - to)
	    , inc   = 1;
	  if(from < to && to < from + count){
	    inc  = -1;
	    from += count - 1;
	    to   += count - 1;
	  }
	  while(count-- > 0){
	    if(from in O)O[to] = O[from];
	    else delete O[to];
	    to   += inc;
	    from += inc;
	  } return O;
	};

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(178);
	
	module.exports = function(iter, ITERATOR){
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(67)
	  , toObject  = __webpack_require__(51)
	  , IObject   = __webpack_require__(211)
	  , toLength  = __webpack_require__(44);
	
	module.exports = function(that, callbackfn, aLen, memo, isRight){
	  aFunction(callbackfn);
	  var O      = toObject(that)
	    , self   = IObject(O)
	    , length = toLength(O.length)
	    , index  = isRight ? length - 1 : 0
	    , i      = isRight ? -1 : 1;
	  if(aLen < 2)for(;;){
	    if(index in self){
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if(isRight ? index < 0 : length <= index){
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for(;isRight ? index >= 0 : length > index; index += i)if(index in self){
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction  = __webpack_require__(67)
	  , isObject   = __webpack_require__(25)
	  , invoke     = __webpack_require__(252)
	  , arraySlice = [].slice
	  , factories  = {};
	
	var construct = function(F, len, args){
	  if(!(len in factories)){
	    for(var n = [], i = 0; i < len; i++)n[i] = 'a[' + i + ']';
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /*, args... */){
	  var fn       = aFunction(this)
	    , partArgs = arraySlice.call(arguments, 1);
	  var bound = function(/* args... */){
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if(isObject(fn.prototype))bound.prototype = fn.prototype;
	  return bound;
	};

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var dP          = __webpack_require__(38).f
	  , create      = __webpack_require__(151)
	  , redefineAll = __webpack_require__(154)
	  , ctx         = __webpack_require__(113)
	  , anInstance  = __webpack_require__(149)
	  , defined     = __webpack_require__(92)
	  , forOf       = __webpack_require__(178)
	  , $iterDefine = __webpack_require__(338)
	  , step        = __webpack_require__(510)
	  , setSpecies  = __webpack_require__(155)
	  , DESCRIPTORS = __webpack_require__(37)
	  , fastKey     = __webpack_require__(130).fastKey
	  , SIZE        = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function(that, key){
	  // fast case
	  var index = fastKey(key), entry;
	  if(index !== 'F')return that._i[index];
	  // frozen object case
	  for(entry = that._f; entry; entry = entry.n){
	    if(entry.k == key)return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      anInstance(that, C, NAME, '_i');
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear(){
	        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
	          entry.r = true;
	          if(entry.p)entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function(key){
	        var that  = this
	          , entry = getEntry(that, key);
	        if(entry){
	          var next = entry.n
	            , prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if(prev)prev.n = next;
	          if(next)next.p = prev;
	          if(that._f == entry)that._f = next;
	          if(that._l == entry)that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /*, that = undefined */){
	        anInstance(this, C, 'forEach');
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
	          , entry;
	        while(entry = entry ? entry.n : this._f){
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while(entry && entry.r)entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key){
	        return !!getEntry(this, key);
	      }
	    });
	    if(DESCRIPTORS)dP(C.prototype, 'size', {
	      get: function(){
	        return defined(this[SIZE]);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var entry = getEntry(that, key)
	      , prev, index;
	    // change existing entry
	    if(entry){
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if(!that._f)that._f = entry;
	      if(prev)prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if(index !== 'F')that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function(C, NAME, IS_MAP){
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function(iterated, kind){
	      this._t = iterated;  // target
	      this._k = kind;      // kind
	      this._l = undefined; // previous
	    }, function(){
	      var that  = this
	        , kind  = that._k
	        , entry = that._l;
	      // revert to the last existing entry
	      while(entry && entry.r)entry = entry.p;
	      // get next entry
	      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if(kind == 'keys'  )return step(0, entry.k);
	      if(kind == 'values')return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(210)
	  , from    = __webpack_require__(501);
	module.exports = function(NAME){
	  return function toJSON(){
	    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll       = __webpack_require__(154)
	  , getWeak           = __webpack_require__(130).getWeak
	  , anObject          = __webpack_require__(14)
	  , isObject          = __webpack_require__(25)
	  , anInstance        = __webpack_require__(149)
	  , forOf             = __webpack_require__(178)
	  , createArrayMethod = __webpack_require__(97)
	  , $has              = __webpack_require__(62)
	  , arrayFind         = createArrayMethod(5)
	  , arrayFindIndex    = createArrayMethod(6)
	  , id                = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function(that){
	  return that._l || (that._l = new UncaughtFrozenStore);
	};
	var UncaughtFrozenStore = function(){
	  this.a = [];
	};
	var findUncaughtFrozen = function(store, key){
	  return arrayFind(store.a, function(it){
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function(key){
	    var entry = findUncaughtFrozen(this, key);
	    if(entry)return entry[1];
	  },
	  has: function(key){
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function(key, value){
	    var entry = findUncaughtFrozen(this, key);
	    if(entry)entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function(key){
	    var index = arrayFindIndex(this.a, function(it){
	      return it[0] === key;
	    });
	    if(~index)this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      anInstance(that, C, NAME, '_i');
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function(key){
	        if(!isObject(key))return false;
	        var data = getWeak(key);
	        if(data === true)return uncaughtFrozenStore(this)['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key){
	        if(!isObject(key))return false;
	        var data = getWeak(key);
	        if(data === true)return uncaughtFrozenStore(this).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var data = getWeak(anObject(key), true);
	    if(data === true)uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(37) && !__webpack_require__(19)(function(){
	  return Object.defineProperty(__webpack_require__(330)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(25)
	  , floor    = Math.floor;
	module.exports = function isInteger(it){
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(14);
	module.exports = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch(e){
	    var ret = iterator['return'];
	    if(ret !== undefined)anObject(ret.call(iterator));
	    throw e;
	  }
	};

/***/ }),
/* 510 */
/***/ (function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ }),
/* 511 */
/***/ (function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x){
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys  = __webpack_require__(153)
	  , gOPS     = __webpack_require__(256)
	  , pIE      = __webpack_require__(212)
	  , toObject = __webpack_require__(51)
	  , IObject  = __webpack_require__(211)
	  , $assign  = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(19)(function(){
	  var A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , aLen  = arguments.length
	    , index = 1
	    , getSymbols = gOPS.f
	    , isEnum     = pIE.f;
	  while(aLen > index){
	    var S      = IObject(arguments[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  } return T;
	} : $assign;

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	var dP       = __webpack_require__(38)
	  , anObject = __webpack_require__(14)
	  , getKeys  = __webpack_require__(153);
	
	module.exports = __webpack_require__(37) ? Object.defineProperties : function defineProperties(O, Properties){
	  anObject(O);
	  var keys   = getKeys(Properties)
	    , length = keys.length
	    , i = 0
	    , P;
	  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(71)
	  , gOPN      = __webpack_require__(152).f
	  , toString  = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function(it){
	  try {
	    return gOPN(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it){
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	var has          = __webpack_require__(62)
	  , toIObject    = __webpack_require__(71)
	  , arrayIndexOf = __webpack_require__(248)(false)
	  , IE_PROTO     = __webpack_require__(343)('IE_PROTO');
	
	module.exports = function(object, names){
	  var O      = toIObject(object)
	    , i      = 0
	    , result = []
	    , key;
	  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while(names.length > i)if(has(O, key = names[i++])){
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(153)
	  , toIObject = __webpack_require__(71)
	  , isEnum    = __webpack_require__(212).f;
	module.exports = function(isEntries){
	  return function(it){
	    var O      = toIObject(it)
	      , keys   = getKeys(O)
	      , length = keys.length
	      , i      = 0
	      , result = []
	      , key;
	    while(length > i)if(isEnum.call(O, key = keys[i++])){
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN     = __webpack_require__(152)
	  , gOPS     = __webpack_require__(256)
	  , anObject = __webpack_require__(14)
	  , Reflect  = __webpack_require__(15).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it){
	  var keys       = gOPN.f(anObject(it))
	    , getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(15).parseFloat
	  , $trim       = __webpack_require__(181).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(348) + '-0') !== -Infinity ? function parseFloat(str){
	  var string = $trim(String(str), 3)
	    , result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(15).parseInt
	  , $trim     = __webpack_require__(181).trim
	  , ws        = __webpack_require__(348)
	  , hex       = /^[\-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix){
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;

/***/ }),
/* 520 */
/***/ (function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y){
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(44)
	  , repeat   = __webpack_require__(347)
	  , defined  = __webpack_require__(92);
	
	module.exports = function(that, maxLength, fillString, left){
	  var S            = String(defined(that))
	    , stringLength = S.length
	    , fillStr      = fillString === undefined ? ' ' : String(fillString)
	    , intMaxLength = toLength(maxLength);
	  if(intMaxLength <= stringLength || fillStr == '')return S;
	  var fillLen = intMaxLength - stringLength
	    , stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if(stringFiller.length > fillLen)stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(29);

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(504);
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(249)('Map', function(get){
	  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key){
	    var entry = strong.getEntry(this, key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value){
	    return strong.def(this, key === 0 ? 0 : key, value);
	  }
	}, strong, true);

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if(__webpack_require__(37) && /./g.flags != 'g')__webpack_require__(38).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(251)
	});

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(504);
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(249)('Set', function(get){
	  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value){
	    return strong.def(this, value = value === 0 ? 0 : value, value);
	  }
	}, strong);

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var each         = __webpack_require__(97)(0)
	  , redefine     = __webpack_require__(69)
	  , meta         = __webpack_require__(130)
	  , assign       = __webpack_require__(512)
	  , weak         = __webpack_require__(506)
	  , isObject     = __webpack_require__(25)
	  , getWeak      = meta.getWeak
	  , isExtensible = Object.isExtensible
	  , uncaughtFrozenStore = weak.ufstore
	  , tmp          = {}
	  , InternalMap;
	
	var wrapper = function(get){
	  return function WeakMap(){
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key){
	    if(isObject(key)){
	      var data = getWeak(key);
	      if(data === true)return uncaughtFrozenStore(this).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value){
	    return weak.def(this, key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(249)('WeakMap', wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if(new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7){
	  InternalMap = weak.getConstructor(wrapper);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function(key){
	    var proto  = $WeakMap.prototype
	      , method = proto[key];
	    redefine(proto, key, function(a, b){
	      // store frozen objects on internal weakmap shim
	      if(isObject(a) && !isExtensible(a)){
	        if(!this._f)this._f = new InternalMap;
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDisplayName = function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	};
	
	/* eslint-disable space-before-keywords */
	
	exports.default = function (EmbeddedComponent, props) {
	  var _class, _temp;
	
	  return _temp = _class = function (_Component) {
	    _inherits(_class, _Component);
	
	    function _class() {
	      _classCallCheck(this, _class);
	
	      return _possibleConstructorReturn(this, Object.getPrototypeOf(_class).apply(this, arguments));
	    }
	
	    _createClass(_class, [{
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(EmbeddedComponent, _extends({}, this.props, props));
	      }
	    }]);
	
	    return _class;
	  }(_react.Component), _class.displayName = 'Decorated(' + getDisplayName(EmbeddedComponent) + ')', _temp;
	};

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = dirtyHandlerIds;
	exports.areDirty = areDirty;
	
	var _xor = __webpack_require__(1443);
	
	var _xor2 = _interopRequireDefault(_xor);
	
	var _intersection = __webpack_require__(1435);
	
	var _intersection2 = _interopRequireDefault(_intersection);
	
	var _dragDrop = __webpack_require__(259);
	
	var _registry = __webpack_require__(260);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NONE = [];
	var ALL = [];
	
	function dirtyHandlerIds() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NONE;
	  var action = arguments[1];
	  var dragOperation = arguments[2];
	
	  switch (action.type) {
	    case _dragDrop.HOVER:
	      break;
	    case _registry.ADD_SOURCE:
	    case _registry.ADD_TARGET:
	    case _registry.REMOVE_TARGET:
	    case _registry.REMOVE_SOURCE:
	      return NONE;
	    case _dragDrop.BEGIN_DRAG:
	    case _dragDrop.PUBLISH_DRAG_SOURCE:
	    case _dragDrop.END_DRAG:
	    case _dragDrop.DROP:
	    default:
	      return ALL;
	  }
	
	  var targetIds = action.targetIds;
	  var prevTargetIds = dragOperation.targetIds;
	
	  var result = (0, _xor2.default)(targetIds, prevTargetIds);
	
	  var didChange = false;
	  if (result.length === 0) {
	    for (var i = 0; i < targetIds.length; i++) {
	      if (targetIds[i] !== prevTargetIds[i]) {
	        didChange = true;
	        break;
	      }
	    }
	  } else {
	    didChange = true;
	  }
	
	  if (!didChange) {
	    return NONE;
	  }
	
	  var prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
	  var innermostTargetId = targetIds[targetIds.length - 1];
	
	  if (prevInnermostTargetId !== innermostTargetId) {
	    if (prevInnermostTargetId) {
	      result.push(prevInnermostTargetId);
	    }
	    if (innermostTargetId) {
	      result.push(innermostTargetId);
	    }
	  }
	
	  return result;
	}
	
	function areDirty(state, handlerIds) {
	  if (state === NONE) {
	    return false;
	  }
	
	  if (state === ALL || typeof handlerIds === 'undefined') {
	    return true;
	  }
	
	  return (0, _intersection2.default)(handlerIds, state).length > 0;
	}

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = dragOffset;
	exports.getSourceClientOffset = getSourceClientOffset;
	exports.getDifferenceFromInitialOffset = getDifferenceFromInitialOffset;
	
	var _dragDrop = __webpack_require__(259);
	
	var initialState = {
	  initialSourceClientOffset: null,
	  initialClientOffset: null,
	  clientOffset: null
	};
	
	function areOffsetsEqual(offsetA, offsetB) {
	  if (offsetA === offsetB) {
	    return true;
	  }
	  return offsetA && offsetB && offsetA.x === offsetB.x && offsetA.y === offsetB.y;
	}
	
	function dragOffset() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _dragDrop.BEGIN_DRAG:
	      return {
	        initialSourceClientOffset: action.sourceClientOffset,
	        initialClientOffset: action.clientOffset,
	        clientOffset: action.clientOffset
	      };
	    case _dragDrop.HOVER:
	      if (areOffsetsEqual(state.clientOffset, action.clientOffset)) {
	        return state;
	      }
	      return _extends({}, state, {
	        clientOffset: action.clientOffset
	      });
	    case _dragDrop.END_DRAG:
	    case _dragDrop.DROP:
	      return initialState;
	    default:
	      return state;
	  }
	}
	
	function getSourceClientOffset(state) {
	  var clientOffset = state.clientOffset,
	      initialClientOffset = state.initialClientOffset,
	      initialSourceClientOffset = state.initialSourceClientOffset;
	
	  if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) {
	    return null;
	  }
	  return {
	    x: clientOffset.x + initialSourceClientOffset.x - initialClientOffset.x,
	    y: clientOffset.y + initialSourceClientOffset.y - initialClientOffset.y
	  };
	}
	
	function getDifferenceFromInitialOffset(state) {
	  var clientOffset = state.clientOffset,
	      initialClientOffset = state.initialClientOffset;
	
	  if (!clientOffset || !initialClientOffset) {
	    return null;
	  }
	  return {
	    x: clientOffset.x - initialClientOffset.x,
	    y: clientOffset.y - initialClientOffset.y
	  };
	}

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = matchesType;
	
	var _isArray = __webpack_require__(162);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function matchesType(targetType, draggedItemType) {
	  if ((0, _isArray2.default)(targetType)) {
	    return targetType.some(function (t) {
	      return t === draggedItemType;
	    });
	  } else {
	    return targetType === draggedItemType;
	  }
	}

/***/ }),
/* 531 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	module.exports = exports['default'];

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BlockTree
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(28);
	
	var emptyFunction = __webpack_require__(59);
	var findRangesImmutable = __webpack_require__(262);
	
	var List = Immutable.List;
	var Repeat = Immutable.Repeat;
	var Record = Immutable.Record;
	
	
	var returnTrue = emptyFunction.thatReturnsTrue;
	
	var FINGERPRINT_DELIMITER = '-';
	
	var defaultLeafRange = {
	  start: null,
	  end: null
	};
	
	var LeafRange = Record(defaultLeafRange);
	
	var defaultDecoratorRange = {
	  start: null,
	  end: null,
	  decoratorKey: null,
	  leaves: null
	};
	
	var DecoratorRange = Record(defaultDecoratorRange);
	
	var BlockTree = {
	  /**
	   * Generate a block tree for a given ContentBlock/decorator pair.
	   */
	  generate: function generate(block, decorator) {
	    var textLength = block.getLength();
	    if (!textLength) {
	      return List.of(new DecoratorRange({
	        start: 0,
	        end: 0,
	        decoratorKey: null,
	        leaves: List.of(new LeafRange({ start: 0, end: 0 }))
	      }));
	    }
	
	    var leafSets = [];
	    var decorations = decorator ? decorator.getDecorations(block) : List(Repeat(null, textLength));
	
	    var chars = block.getCharacterList();
	
	    findRangesImmutable(decorations, areEqual, returnTrue, function (start, end) {
	      leafSets.push(new DecoratorRange({
	        start: start,
	        end: end,
	        decoratorKey: decorations.get(start),
	        leaves: generateLeaves(chars.slice(start, end).toList(), start)
	      }));
	    });
	
	    return List(leafSets);
	  },
	
	  /**
	   * Create a string representation of the given tree map. This allows us
	   * to rapidly determine whether a tree has undergone a significant
	   * structural change.
	   */
	  getFingerprint: function getFingerprint(tree) {
	    return tree.map(function (leafSet) {
	      var decoratorKey = leafSet.get('decoratorKey');
	      var fingerprintString = decoratorKey !== null ? decoratorKey + '.' + (leafSet.get('end') - leafSet.get('start')) : '';
	      return '' + fingerprintString + '.' + leafSet.get('leaves').size;
	    }).join(FINGERPRINT_DELIMITER);
	  }
	};
	
	/**
	 * Generate LeafRange records for a given character list.
	 */
	function generateLeaves(characters, offset) {
	  var leaves = [];
	  var inlineStyles = characters.map(function (c) {
	    return c.getStyle();
	  }).toList();
	  findRangesImmutable(inlineStyles, areEqual, returnTrue, function (start, end) {
	    leaves.push(new LeafRange({
	      start: start + offset,
	      end: end + offset
	    }));
	  });
	  return List(leaves);
	}
	
	function areEqual(a, b) {
	  return a === b;
	}
	
	module.exports = BlockTree;

/***/ }),
/* 533 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultDraftInlineStyle
	 * 
	 */
	
	'use strict';
	
	module.exports = {
	  BOLD: {
	    fontWeight: 'bold'
	  },
	
	  CODE: {
	    fontFamily: 'monospace',
	    wordWrap: 'break-word'
	  },
	
	  ITALIC: {
	    fontStyle: 'italic'
	  },
	
	  STRIKETHROUGH: {
	    textDecoration: 'line-through'
	  },
	
	  UNDERLINE: {
	    textDecoration: 'underline'
	  }
	};

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorBlock.react
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(20);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContentBlock = __webpack_require__(158);
	var DraftEditorLeaf = __webpack_require__(1059);
	var DraftOffsetKey = __webpack_require__(261);
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(22);
	var Scroll = __webpack_require__(560);
	var SelectionState = __webpack_require__(182);
	var Style = __webpack_require__(366);
	var UnicodeBidi = __webpack_require__(561);
	var UnicodeBidiDirection = __webpack_require__(367);
	
	var cx = __webpack_require__(215);
	var getElementPosition = __webpack_require__(1343);
	var getScrollPosition = __webpack_require__(369);
	var getViewportDimensions = __webpack_require__(1347);
	var nullthrows = __webpack_require__(81);
	
	var SCROLL_BUFFER = 10;
	
	/**
	 * The default block renderer for a `DraftEditor` component.
	 *
	 * A `DraftEditorBlock` is able to render a given `ContentBlock` to its
	 * appropriate decorator and inline style components.
	 */
	var DraftEditorBlock = function (_React$Component) {
	  _inherits(DraftEditorBlock, _React$Component);
	
	  function DraftEditorBlock() {
	    _classCallCheck(this, DraftEditorBlock);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  DraftEditorBlock.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    return this.props.block !== nextProps.block || this.props.tree !== nextProps.tree || this.props.direction !== nextProps.direction || isBlockOnSelectionEdge(nextProps.selection, nextProps.block.getKey()) && nextProps.forceSelection;
	  };
	
	  /**
	   * When a block is mounted and overlaps the selection state, we need to make
	   * sure that the cursor is visible to match native behavior. This may not
	   * be the case if the user has pressed `RETURN` or pasted some content, since
	   * programatically creating these new blocks and setting the DOM selection
	   * will miss out on the browser natively scrolling to that position.
	   *
	   * To replicate native behavior, if the block overlaps the selection state
	   * on mount, force the scroll position. Check the scroll state of the scroll
	   * parent, and adjust it to align the entire block to the bottom of the
	   * scroll parent.
	   */
	
	
	  DraftEditorBlock.prototype.componentDidMount = function componentDidMount() {
	    var selection = this.props.selection;
	    var endKey = selection.getEndKey();
	    if (!selection.getHasFocus() || endKey !== this.props.block.getKey()) {
	      return;
	    }
	
	    var blockNode = ReactDOM.findDOMNode(this);
	    var scrollParent = Style.getScrollParent(blockNode);
	    var scrollPosition = getScrollPosition(scrollParent);
	    var scrollDelta;
	
	    if (scrollParent === window) {
	      var nodePosition = getElementPosition(blockNode);
	      var nodeBottom = nodePosition.y + nodePosition.height;
	      var viewportHeight = getViewportDimensions().height;
	      scrollDelta = nodeBottom - viewportHeight;
	      if (scrollDelta > 0) {
	        window.scrollTo(scrollPosition.x, scrollPosition.y + scrollDelta + SCROLL_BUFFER);
	      }
	    } else {
	      var blockBottom = blockNode.offsetHeight + blockNode.offsetTop;
	      var scrollBottom = scrollParent.offsetHeight + scrollPosition.y;
	      scrollDelta = blockBottom - scrollBottom;
	      if (scrollDelta > 0) {
	        Scroll.setTop(scrollParent, Scroll.getTop(scrollParent) + scrollDelta + SCROLL_BUFFER);
	      }
	    }
	  };
	
	  DraftEditorBlock.prototype._renderChildren = function _renderChildren() {
	    var _this2 = this;
	
	    var block = this.props.block;
	    var blockKey = block.getKey();
	    var text = block.getText();
	    var lastLeafSet = this.props.tree.size - 1;
	    var hasSelection = isBlockOnSelectionEdge(this.props.selection, blockKey);
	
	    return this.props.tree.map(function (leafSet, ii) {
	      var leavesForLeafSet = leafSet.get('leaves');
	      var lastLeaf = leavesForLeafSet.size - 1;
	      var leaves = leavesForLeafSet.map(function (leaf, jj) {
	        var offsetKey = DraftOffsetKey.encode(blockKey, ii, jj);
	        var start = leaf.get('start');
	        var end = leaf.get('end');
	        return React.createElement(DraftEditorLeaf, {
	          key: offsetKey,
	          offsetKey: offsetKey,
	          blockKey: blockKey,
	          start: start,
	          selection: hasSelection ? _this2.props.selection : undefined,
	          forceSelection: _this2.props.forceSelection,
	          text: text.slice(start, end),
	          styleSet: block.getInlineStyleAt(start),
	          customStyleMap: _this2.props.customStyleMap,
	          customStyleFn: _this2.props.customStyleFn,
	          isLast: ii === lastLeafSet && jj === lastLeaf
	        });
	      }).toArray();
	
	      var decoratorKey = leafSet.get('decoratorKey');
	      if (decoratorKey == null) {
	        return leaves;
	      }
	
	      if (!_this2.props.decorator) {
	        return leaves;
	      }
	
	      var decorator = nullthrows(_this2.props.decorator);
	
	      var DecoratorComponent = decorator.getComponentForKey(decoratorKey);
	      if (!DecoratorComponent) {
	        return leaves;
	      }
	
	      var decoratorProps = decorator.getPropsForKey(decoratorKey);
	      var decoratorOffsetKey = DraftOffsetKey.encode(blockKey, ii, 0);
	      var decoratedText = text.slice(leavesForLeafSet.first().get('start'), leavesForLeafSet.last().get('end'));
	
	      // Resetting dir to the same value on a child node makes Chrome/Firefox
	      // confused on cursor movement. See http://jsfiddle.net/d157kLck/3/
	      var dir = UnicodeBidiDirection.getHTMLDirIfDifferent(UnicodeBidi.getDirection(decoratedText), _this2.props.direction);
	
	      return React.createElement(
	        DecoratorComponent,
	        _extends({}, decoratorProps, {
	          decoratedText: decoratedText,
	          dir: dir,
	          key: decoratorOffsetKey,
	          entityKey: block.getEntityAt(leafSet.get('start')),
	          offsetKey: decoratorOffsetKey }),
	        leaves
	      );
	    }).toArray();
	  };
	
	  DraftEditorBlock.prototype.render = function render() {
	    var _props = this.props;
	    var direction = _props.direction;
	    var offsetKey = _props.offsetKey;
	
	    var className = cx({
	      'public/DraftStyleDefault/block': true,
	      'public/DraftStyleDefault/ltr': direction === 'LTR',
	      'public/DraftStyleDefault/rtl': direction === 'RTL'
	    });
	
	    return React.createElement(
	      'div',
	      { 'data-offset-key': offsetKey, className: className },
	      this._renderChildren()
	    );
	  };
	
	  return DraftEditorBlock;
	}(React.Component);
	
	/**
	 * Return whether a block overlaps with either edge of the `SelectionState`.
	 */
	
	
	function isBlockOnSelectionEdge(selection, key) {
	  return selection.getAnchorKey() === key || selection.getFocusKey() === key;
	}
	
	module.exports = DraftEditorBlock;

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEntityInstance
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Immutable = __webpack_require__(28);
	
	var Record = Immutable.Record;
	
	
	var DraftEntityInstanceRecord = Record({
	  type: 'TOKEN',
	  mutability: 'IMMUTABLE',
	  data: Object
	});
	
	/**
	 * An instance of a document entity, consisting of a `type` and relevant
	 * `data`, metadata about the entity.
	 *
	 * For instance, a "link" entity might provide a URI, and a "mention"
	 * entity might provide the mentioned user's ID. These pieces of data
	 * may be used when rendering the entity as part of a ContentBlock DOM
	 * representation. For a link, the data would be used as an href for
	 * the rendered anchor. For a mention, the ID could be used to retrieve
	 * a hovercard.
	 */
	
	var DraftEntityInstance = function (_DraftEntityInstanceR) {
	  _inherits(DraftEntityInstance, _DraftEntityInstanceR);
	
	  function DraftEntityInstance() {
	    _classCallCheck(this, DraftEntityInstance);
	
	    return _possibleConstructorReturn(this, _DraftEntityInstanceR.apply(this, arguments));
	  }
	
	  DraftEntityInstance.prototype.getType = function getType() {
	    return this.get('type');
	  };
	
	  DraftEntityInstance.prototype.getMutability = function getMutability() {
	    return this.get('mutability');
	  };
	
	  DraftEntityInstance.prototype.getData = function getData() {
	    return this.get('data');
	  };
	
	  return DraftEntityInstance;
	}(DraftEntityInstanceRecord);
	
	module.exports = DraftEntityInstance;

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftRemovableWord
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var TokenizeUtil = __webpack_require__(1335);
	
	var punctuation = TokenizeUtil.getPunctuation();
	
	// The apostrophe and curly single quotes behave in a curious way: when
	// surrounded on both sides by word characters, they behave as word chars; when
	// either neighbor is punctuation or an end of the string, they behave as
	// punctuation.
	var CHAMELEON_CHARS = '[\'‘’]';
	
	// Remove the underscore, which should count as part of the removable word. The
	// "chameleon chars" also count as punctuation in this regex.
	var WHITESPACE_AND_PUNCTUATION = '\\s|(?![_])' + punctuation;
	
	var DELETE_STRING = '^' + '(?:' + WHITESPACE_AND_PUNCTUATION + ')*' + '(?:' + CHAMELEON_CHARS + '|(?!' + WHITESPACE_AND_PUNCTUATION + ').)*' + '(?:(?!' + WHITESPACE_AND_PUNCTUATION + ').)';
	var DELETE_REGEX = new RegExp(DELETE_STRING);
	
	var BACKSPACE_STRING = '(?:(?!' + WHITESPACE_AND_PUNCTUATION + ').)' + '(?:' + CHAMELEON_CHARS + '|(?!' + WHITESPACE_AND_PUNCTUATION + ').)*' + '(?:' + WHITESPACE_AND_PUNCTUATION + ')*' + '$';
	var BACKSPACE_REGEX = new RegExp(BACKSPACE_STRING);
	
	function getRemovableWord(text, isBackward) {
	  var matches = isBackward ? BACKSPACE_REGEX.exec(text) : DELETE_REGEX.exec(text);
	  return matches ? matches[0] : text;
	}
	
	var DraftRemovableWord = {
	  getBackward: function getBackward(text) {
	    return getRemovableWord(text, true);
	  },
	
	  getForward: function getForward(text) {
	    return getRemovableWord(text, false);
	  }
	};
	
	module.exports = DraftRemovableWord;

/***/ }),
/* 537 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftStringKey
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var DraftStringKey = {
	  stringify: function stringify(key) {
	    return '_' + String(key);
	  },
	
	  unstringify: function unstringify(key) {
	    return key.slice(1);
	  }
	};
	
	module.exports = DraftStringKey;

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule convertFromHTMLToContentBlocks
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var CharacterMetadata = __webpack_require__(94);
	var ContentBlock = __webpack_require__(158);
	var DefaultDraftBlockRenderMap = __webpack_require__(357);
	var DraftEntity = __webpack_require__(117);
	var Immutable = __webpack_require__(28);
	var URI = __webpack_require__(1336);
	
	var generateRandomKey = __webpack_require__(100);
	var getSafeBodyFromHTML = __webpack_require__(543);
	var invariant = __webpack_require__(10);
	var nullthrows = __webpack_require__(81);
	var sanitizeDraftText = __webpack_require__(362);
	
	var List = Immutable.List;
	var OrderedSet = Immutable.OrderedSet;
	
	
	var NBSP = '&nbsp;';
	var SPACE = ' ';
	
	// Arbitrary max indent
	var MAX_DEPTH = 4;
	
	// used for replacing characters in HTML
	var REGEX_CR = new RegExp('\r', 'g');
	var REGEX_LF = new RegExp('\n', 'g');
	var REGEX_NBSP = new RegExp(NBSP, 'g');
	var REGEX_CARRIAGE = new RegExp('&#13;?', 'g');
	var REGEX_ZWS = new RegExp('&#8203;?', 'g');
	
	// https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight
	var boldValues = ['bold', 'bolder', '500', '600', '700', '800', '900'];
	var notBoldValues = ['light', 'lighter', '100', '200', '300', '400'];
	
	// Block tag flow is different because LIs do not have
	// a deterministic style ;_;
	var inlineTags = {
	  b: 'BOLD',
	  code: 'CODE',
	  del: 'STRIKETHROUGH',
	  em: 'ITALIC',
	  i: 'ITALIC',
	  s: 'STRIKETHROUGH',
	  strike: 'STRIKETHROUGH',
	  strong: 'BOLD',
	  u: 'UNDERLINE'
	};
	
	var anchorAttr = ['className', 'href', 'rel', 'target', 'title'];
	
	var lastBlock;
	
	function getEmptyChunk() {
	  return {
	    text: '',
	    inlines: [],
	    entities: [],
	    blocks: []
	  };
	}
	
	function getWhitespaceChunk(inEntity) {
	  var entities = new Array(1);
	  if (inEntity) {
	    entities[0] = inEntity;
	  }
	  return {
	    text: SPACE,
	    inlines: [OrderedSet()],
	    entities: entities,
	    blocks: []
	  };
	}
	
	function getSoftNewlineChunk() {
	  return {
	    text: '\n',
	    inlines: [OrderedSet()],
	    entities: new Array(1),
	    blocks: []
	  };
	}
	
	function getBlockDividerChunk(block, depth) {
	  return {
	    text: '\r',
	    inlines: [OrderedSet()],
	    entities: new Array(1),
	    blocks: [{
	      type: block,
	      depth: Math.max(0, Math.min(MAX_DEPTH, depth))
	    }]
	  };
	}
	
	function getListBlockType(tag, lastList) {
	  if (tag === 'li') {
	    return lastList === 'ol' ? 'ordered-list-item' : 'unordered-list-item';
	  }
	  return null;
	}
	
	function getBlockMapSupportedTags(blockRenderMap) {
	  var unstyledElement = blockRenderMap.get('unstyled').element;
	  return blockRenderMap.map(function (config) {
	    return config.element;
	  }).valueSeq().toSet().filter(function (tag) {
	    return tag && tag !== unstyledElement;
	  }).toArray().sort();
	}
	
	// custom element conversions
	function getMultiMatchedType(tag, lastList, multiMatchExtractor) {
	  for (var ii = 0; ii < multiMatchExtractor.length; ii++) {
	    var matchType = multiMatchExtractor[ii](tag, lastList);
	    if (matchType) {
	      return matchType;
	    }
	  }
	  return null;
	}
	
	function getBlockTypeForTag(tag, lastList, blockRenderMap) {
	  var matchedTypes = blockRenderMap.filter(function (config) {
	    return config.element === tag || config.wrapper === tag;
	  }).keySeq().toSet().toArray().sort();
	
	  // if we dont have any matched type, return unstyled
	  // if we have one matched type return it
	  // if we have multi matched types use the multi-match function to gather type
	  switch (matchedTypes.length) {
	    case 0:
	      return 'unstyled';
	    case 1:
	      return matchedTypes[0];
	    default:
	      return getMultiMatchedType(tag, lastList, [getListBlockType]) || 'unstyled';
	  }
	}
	
	function processInlineTag(tag, node, currentStyle) {
	  var styleToCheck = inlineTags[tag];
	  if (styleToCheck) {
	    currentStyle = currentStyle.add(styleToCheck).toOrderedSet();
	  } else if (node instanceof HTMLElement) {
	    (function () {
	      var htmlElement = node;
	      currentStyle = currentStyle.withMutations(function (style) {
	        var fontWeight = htmlElement.style.fontWeight;
	        var fontStyle = htmlElement.style.fontStyle;
	        var textDecoration = htmlElement.style.textDecoration;
	
	        if (boldValues.indexOf(fontWeight) >= 0) {
	          style.add('BOLD');
	        } else if (notBoldValues.indexOf(fontWeight) >= 0) {
	          style.remove('BOLD');
	        }
	
	        if (fontStyle === 'italic') {
	          style.add('ITALIC');
	        } else if (fontStyle === 'normal') {
	          style.remove('ITALIC');
	        }
	
	        if (textDecoration === 'underline') {
	          style.add('UNDERLINE');
	        }
	        if (textDecoration === 'line-through') {
	          style.add('STRIKETHROUGH');
	        }
	        if (textDecoration === 'none') {
	          style.remove('UNDERLINE');
	          style.remove('STRIKETHROUGH');
	        }
	      }).toOrderedSet();
	    })();
	  }
	  return currentStyle;
	}
	
	function joinChunks(A, B) {
	  // Sometimes two blocks will touch in the DOM and we need to strip the
	  // extra delimiter to preserve niceness.
	  var lastInA = A.text.slice(-1);
	  var firstInB = B.text.slice(0, 1);
	
	  if (lastInA === '\r' && firstInB === '\r') {
	    A.text = A.text.slice(0, -1);
	    A.inlines.pop();
	    A.entities.pop();
	    A.blocks.pop();
	  }
	
	  // Kill whitespace after blocks
	  if (lastInA === '\r') {
	    if (B.text === SPACE || B.text === '\n') {
	      return A;
	    } else if (firstInB === SPACE || firstInB === '\n') {
	      B.text = B.text.slice(1);
	      B.inlines.shift();
	      B.entities.shift();
	    }
	  }
	
	  return {
	    text: A.text + B.text,
	    inlines: A.inlines.concat(B.inlines),
	    entities: A.entities.concat(B.entities),
	    blocks: A.blocks.concat(B.blocks)
	  };
	}
	
	/**
	 * Check to see if we have anything like <p> <blockquote> <h1>... to create
	 * block tags from. If we do, we can use those and ignore <div> tags. If we
	 * don't, we can treat <div> tags as meaningful (unstyled) blocks.
	 */
	function containsSemanticBlockMarkup(html, blockTags) {
	  return blockTags.some(function (tag) {
	    return html.indexOf('<' + tag) !== -1;
	  });
	}
	
	function hasValidLinkText(link) {
	  !(link instanceof HTMLAnchorElement) ?  false ? invariant(false, 'Link must be an HTMLAnchorElement.') : invariant(false) : void 0;
	  var protocol = link.protocol;
	  return protocol === 'http:' || protocol === 'https:' || protocol === 'mailto:';
	}
	
	function genFragment(node, inlineStyle, lastList, inBlock, blockTags, depth, blockRenderMap, inEntity) {
	  var nodeName = node.nodeName.toLowerCase();
	  var newBlock = false;
	  var nextBlockType = 'unstyled';
	  var lastLastBlock = lastBlock;
	
	  // Base Case
	  if (nodeName === '#text') {
	    var text = node.textContent;
	    if (text.trim() === '' && inBlock !== 'pre') {
	      return getWhitespaceChunk(inEntity);
	    }
	    if (inBlock !== 'pre') {
	      // Can't use empty string because MSWord
	      text = text.replace(REGEX_LF, SPACE);
	    }
	
	    // save the last block so we can use it later
	    lastBlock = nodeName;
	
	    return {
	      text: text,
	      inlines: Array(text.length).fill(inlineStyle),
	      entities: Array(text.length).fill(inEntity),
	      blocks: []
	    };
	  }
	
	  // save the last block so we can use it later
	  lastBlock = nodeName;
	
	  // BR tags
	  if (nodeName === 'br') {
	    if (lastLastBlock === 'br' && (!inBlock || getBlockTypeForTag(inBlock, lastList, blockRenderMap) === 'unstyled')) {
	      return getBlockDividerChunk('unstyled', depth);
	    }
	    return getSoftNewlineChunk();
	  }
	
	  var chunk = getEmptyChunk();
	  var newChunk = null;
	
	  // Inline tags
	  inlineStyle = processInlineTag(nodeName, node, inlineStyle);
	
	  // Handle lists
	  if (nodeName === 'ul' || nodeName === 'ol') {
	    if (lastList) {
	      depth += 1;
	    }
	    lastList = nodeName;
	  }
	
	  // Block Tags
	  if (!inBlock && blockTags.indexOf(nodeName) !== -1) {
	    chunk = getBlockDividerChunk(getBlockTypeForTag(nodeName, lastList, blockRenderMap), depth);
	    inBlock = nodeName;
	    newBlock = true;
	  } else if (lastList && inBlock === 'li' && nodeName === 'li') {
	    chunk = getBlockDividerChunk(getBlockTypeForTag(nodeName, lastList, blockRenderMap), depth);
	    inBlock = nodeName;
	    newBlock = true;
	    nextBlockType = lastList === 'ul' ? 'unordered-list-item' : 'ordered-list-item';
	  }
	
	  // Recurse through children
	  var child = node.firstChild;
	  if (child != null) {
	    nodeName = child.nodeName.toLowerCase();
	  }
	
	  var entityId = null;
	
	  while (child) {
	    if (child instanceof HTMLAnchorElement && child.href && hasValidLinkText(child)) {
	      (function () {
	        var anchor = child;
	        var entityConfig = {};
	
	        anchorAttr.forEach(function (attr) {
	          var anchorAttribute = anchor.getAttribute(attr);
	          if (anchorAttribute) {
	            entityConfig[attr] = anchorAttribute;
	          }
	        });
	
	        entityConfig.url = new URI(anchor.href).toString();
	
	        entityId = DraftEntity.create('LINK', 'MUTABLE', entityConfig);
	      })();
	    } else {
	      entityId = undefined;
	    }
	
	    newChunk = genFragment(child, inlineStyle, lastList, inBlock, blockTags, depth, blockRenderMap, entityId || inEntity);
	
	    chunk = joinChunks(chunk, newChunk);
	    var sibling = child.nextSibling;
	
	    // Put in a newline to break up blocks inside blocks
	    if (sibling && blockTags.indexOf(nodeName) >= 0 && inBlock) {
	      chunk = joinChunks(chunk, getSoftNewlineChunk());
	    }
	    if (sibling) {
	      nodeName = sibling.nodeName.toLowerCase();
	    }
	    child = sibling;
	  }
	
	  if (newBlock) {
	    chunk = joinChunks(chunk, getBlockDividerChunk(nextBlockType, depth));
	  }
	
	  return chunk;
	}
	
	function getChunkForHTML(html, DOMBuilder, blockRenderMap) {
	  html = html.trim().replace(REGEX_CR, '').replace(REGEX_NBSP, SPACE).replace(REGEX_CARRIAGE, '').replace(REGEX_ZWS, '');
	
	  var supportedBlockTags = getBlockMapSupportedTags(blockRenderMap);
	
	  var safeBody = DOMBuilder(html);
	  if (!safeBody) {
	    return null;
	  }
	  lastBlock = null;
	
	  // Sometimes we aren't dealing with content that contains nice semantic
	  // tags. In this case, use divs to separate everything out into paragraphs
	  // and hope for the best.
	  var workingBlocks = containsSemanticBlockMarkup(html, supportedBlockTags) ? supportedBlockTags : ['div'];
	
	  // Start with -1 block depth to offset the fact that we are passing in a fake
	  // UL block to start with.
	  var chunk = genFragment(safeBody, OrderedSet(), 'ul', null, workingBlocks, -1, blockRenderMap);
	
	  // join with previous block to prevent weirdness on paste
	  if (chunk.text.indexOf('\r') === 0) {
	    chunk = {
	      text: chunk.text.slice(1),
	      inlines: chunk.inlines.slice(1),
	      entities: chunk.entities.slice(1),
	      blocks: chunk.blocks
	    };
	  }
	
	  // Kill block delimiter at the end
	  if (chunk.text.slice(-1) === '\r') {
	    chunk.text = chunk.text.slice(0, -1);
	    chunk.inlines = chunk.inlines.slice(0, -1);
	    chunk.entities = chunk.entities.slice(0, -1);
	    chunk.blocks.pop();
	  }
	
	  // If we saw no block tags, put an unstyled one in
	  if (chunk.blocks.length === 0) {
	    chunk.blocks.push({ type: 'unstyled', depth: 0 });
	  }
	
	  // Sometimes we start with text that isn't in a block, which is then
	  // followed by blocks. Need to fix up the blocks to add in
	  // an unstyled block for this content
	  if (chunk.text.split('\r').length === chunk.blocks.length + 1) {
	    chunk.blocks.unshift({ type: 'unstyled', depth: 0 });
	  }
	
	  return chunk;
	}
	
	function convertFromHTMLtoContentBlocks(html) {
	  var DOMBuilder = arguments.length <= 1 || arguments[1] === undefined ? getSafeBodyFromHTML : arguments[1];
	  var blockRenderMap = arguments.length <= 2 || arguments[2] === undefined ? DefaultDraftBlockRenderMap : arguments[2];
	
	  // Be ABSOLUTELY SURE that the dom builder you pass here won't execute
	  // arbitrary code in whatever environment you're running this in. For an
	  // example of how we try to do this in-browser, see getSafeBodyFromHTML.
	
	  var chunk = getChunkForHTML(html, DOMBuilder, blockRenderMap);
	
	  if (chunk == null) {
	    return null;
	  }
	  var start = 0;
	  return chunk.text.split('\r').map(function (textBlock, ii) {
	    // Make absolutely certain that our text is acceptable.
	    textBlock = sanitizeDraftText(textBlock);
	    var end = start + textBlock.length;
	    var inlines = nullthrows(chunk).inlines.slice(start, end);
	    var entities = nullthrows(chunk).entities.slice(start, end);
	    var characterList = List(inlines.map(function (style, ii) {
	      var data = { style: style, entity: null };
	      if (entities[ii]) {
	        data.entity = entities[ii];
	      }
	      return CharacterMetadata.create(data);
	    }));
	    start = end + 1;
	
	    return new ContentBlock({
	      key: generateRandomKey(),
	      type: nullthrows(chunk).blocks[ii].type,
	      depth: nullthrows(chunk).blocks[ii].depth,
	      text: textBlock,
	      characterList: characterList
	    });
	  });
	}
	
	module.exports = convertFromHTMLtoContentBlocks;

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getDefaultKeyBinding
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var KeyBindingUtil = __webpack_require__(358);
	var Keys = __webpack_require__(365);
	var UserAgent = __webpack_require__(101);
	
	var isOSX = UserAgent.isPlatform('Mac OS X');
	var isWindows = UserAgent.isPlatform('Windows');
	
	// Firefox on OSX had a bug resulting in navigation instead of cursor movement.
	// This bug was fixed in Firefox 29. Feature detection is virtually impossible
	// so we just check the version number. See #342765.
	var shouldFixFirefoxMovement = isOSX && UserAgent.isBrowser('Firefox < 29');
	
	var hasCommandModifier = KeyBindingUtil.hasCommandModifier;
	var isCtrlKeyCommand = KeyBindingUtil.isCtrlKeyCommand;
	
	
	function shouldRemoveWord(e) {
	  return isOSX && e.altKey || isCtrlKeyCommand(e);
	}
	
	/**
	 * Get the appropriate undo/redo command for a Z key command.
	 */
	function getZCommand(e) {
	  if (!hasCommandModifier(e)) {
	    return null;
	  }
	  return e.shiftKey ? 'redo' : 'undo';
	}
	
	function getDeleteCommand(e) {
	  // Allow default "cut" behavior for Windows on Shift + Delete.
	  if (isWindows && e.shiftKey) {
	    return null;
	  }
	  return shouldRemoveWord(e) ? 'delete-word' : 'delete';
	}
	
	function getBackspaceCommand(e) {
	  if (hasCommandModifier(e) && isOSX) {
	    return 'backspace-to-start-of-line';
	  }
	  return shouldRemoveWord(e) ? 'backspace-word' : 'backspace';
	}
	
	/**
	 * Retrieve a bound key command for the given event.
	 */
	function getDefaultKeyBinding(e) {
	  switch (e.keyCode) {
	    case 66:
	      // B
	      return hasCommandModifier(e) ? 'bold' : null;
	    case 68:
	      // D
	      return isCtrlKeyCommand(e) ? 'delete' : null;
	    case 72:
	      // H
	      return isCtrlKeyCommand(e) ? 'backspace' : null;
	    case 73:
	      // I
	      return hasCommandModifier(e) ? 'italic' : null;
	    case 74:
	      // J
	      return hasCommandModifier(e) ? 'code' : null;
	    case 75:
	      // K
	      return !isWindows && isCtrlKeyCommand(e) ? 'secondary-cut' : null;
	    case 77:
	      // M
	      return isCtrlKeyCommand(e) ? 'split-block' : null;
	    case 79:
	      // O
	      return isCtrlKeyCommand(e) ? 'split-block' : null;
	    case 84:
	      // T
	      return isOSX && isCtrlKeyCommand(e) ? 'transpose-characters' : null;
	    case 85:
	      // U
	      return hasCommandModifier(e) ? 'underline' : null;
	    case 87:
	      // W
	      return isOSX && isCtrlKeyCommand(e) ? 'backspace-word' : null;
	    case 89:
	      // Y
	      if (isCtrlKeyCommand(e)) {
	        return isWindows ? 'redo' : 'secondary-paste';
	      }
	      return null;
	    case 90:
	      // Z
	      return getZCommand(e) || null;
	    case Keys.RETURN:
	      return 'split-block';
	    case Keys.DELETE:
	      return getDeleteCommand(e);
	    case Keys.BACKSPACE:
	      return getBackspaceCommand(e);
	    // LEFT/RIGHT handlers serve as a workaround for a Firefox bug.
	    case Keys.LEFT:
	      return shouldFixFirefoxMovement && hasCommandModifier(e) ? 'move-selection-to-start-of-block' : null;
	    case Keys.RIGHT:
	      return shouldFixFirefoxMovement && hasCommandModifier(e) ? 'move-selection-to-end-of-block' : null;
	    default:
	      return null;
	  }
	}
	
	module.exports = getDefaultKeyBinding;

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getDraftEditorSelectionWithNodes
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var findAncestorOffsetKey = __webpack_require__(359);
	var getSelectionOffsetKeyForNode = __webpack_require__(544);
	var getUpdatedSelectionState = __webpack_require__(546);
	var invariant = __webpack_require__(10);
	var nullthrows = __webpack_require__(81);
	
	/**
	 * Convert the current selection range to an anchor/focus pair of offset keys
	 * and values that can be interpreted by components.
	 */
	function getDraftEditorSelectionWithNodes(editorState, root, anchorNode, anchorOffset, focusNode, focusOffset) {
	  var anchorIsTextNode = anchorNode.nodeType === Node.TEXT_NODE;
	  var focusIsTextNode = focusNode.nodeType === Node.TEXT_NODE;
	
	  // If the selection range lies only on text nodes, the task is simple.
	  // Find the nearest offset-aware elements and use the
	  // offset values supplied by the selection range.
	  if (anchorIsTextNode && focusIsTextNode) {
	    return {
	      selectionState: getUpdatedSelectionState(editorState, nullthrows(findAncestorOffsetKey(anchorNode)), anchorOffset, nullthrows(findAncestorOffsetKey(focusNode)), focusOffset),
	      needsRecovery: false
	    };
	  }
	
	  var anchorPoint = null;
	  var focusPoint = null;
	  var needsRecovery = true;
	
	  // An element is selected. Convert this selection range into leaf offset
	  // keys and offset values for consumption at the component level. This
	  // is common in Firefox, where select-all and triple click behavior leads
	  // to entire elements being selected.
	  //
	  // Note that we use the `needsRecovery` parameter in the callback here. This
	  // is because when certain elements are selected, the behavior for subsequent
	  // cursor movement (e.g. via arrow keys) is uncertain and may not match
	  // expectations at the component level. For example, if an entire <div> is
	  // selected and the user presses the right arrow, Firefox keeps the selection
	  // on the <div>. If we allow subsequent keypresses to insert characters
	  // natively, they will be inserted into a browser-created text node to the
	  // right of that <div>. This is obviously undesirable.
	  //
	  // With the `needsRecovery` flag, we inform the caller that it is responsible
	  // for manually setting the selection state on the rendered document to
	  // ensure proper selection state maintenance.
	
	  if (anchorIsTextNode) {
	    anchorPoint = {
	      key: nullthrows(findAncestorOffsetKey(anchorNode)),
	      offset: anchorOffset
	    };
	    focusPoint = getPointForNonTextNode(root, focusNode, focusOffset);
	  } else if (focusIsTextNode) {
	    focusPoint = {
	      key: nullthrows(findAncestorOffsetKey(focusNode)),
	      offset: focusOffset
	    };
	    anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset);
	  } else {
	    anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset);
	    focusPoint = getPointForNonTextNode(root, focusNode, focusOffset);
	
	    // If the selection is collapsed on an empty block, don't force recovery.
	    // This way, on arrow key selection changes, the browser can move the
	    // cursor from a non-zero offset on one block, through empty blocks,
	    // to a matching non-zero offset on other text blocks.
	    if (anchorNode === focusNode && anchorOffset === focusOffset) {
	      needsRecovery = !!anchorNode.firstChild && anchorNode.firstChild.nodeName !== 'BR';
	    }
	  }
	
	  return {
	    selectionState: getUpdatedSelectionState(editorState, anchorPoint.key, anchorPoint.offset, focusPoint.key, focusPoint.offset),
	    needsRecovery: needsRecovery
	  };
	}
	
	/**
	 * Identify the first leaf descendant for the given node.
	 */
	function getFirstLeaf(node) {
	  while (node.firstChild && getSelectionOffsetKeyForNode(node.firstChild)) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Identify the last leaf descendant for the given node.
	 */
	function getLastLeaf(node) {
	  while (node.lastChild && getSelectionOffsetKeyForNode(node.lastChild)) {
	    node = node.lastChild;
	  }
	  return node;
	}
	
	function getPointForNonTextNode(editorRoot, startNode, childOffset) {
	  var node = startNode;
	  var offsetKey = findAncestorOffsetKey(node);
	
	  !(offsetKey != null || editorRoot && (editorRoot === node || editorRoot.firstChild === node)) ?  false ? invariant(false, 'Unknown node in selection range.') : invariant(false) : void 0;
	
	  // If the editorRoot is the selection, step downward into the content
	  // wrapper.
	  if (editorRoot === node) {
	    node = node.firstChild;
	    !(node instanceof Element && node.getAttribute('data-contents') === 'true') ?  false ? invariant(false, 'Invalid DraftEditorContents structure.') : invariant(false) : void 0;
	    if (childOffset > 0) {
	      childOffset = node.childNodes.length;
	    }
	  }
	
	  // If the child offset is zero and we have an offset key, we're done.
	  // If there's no offset key because the entire editor is selected,
	  // find the leftmost ("first") leaf in the tree and use that as the offset
	  // key.
	  if (childOffset === 0) {
	    var key = null;
	    if (offsetKey != null) {
	      key = offsetKey;
	    } else {
	      var firstLeaf = getFirstLeaf(node);
	      key = nullthrows(getSelectionOffsetKeyForNode(firstLeaf));
	    }
	    return { key: key, offset: 0 };
	  }
	
	  var nodeBeforeCursor = node.childNodes[childOffset - 1];
	  var leafKey = null;
	  var textLength = null;
	
	  if (!getSelectionOffsetKeyForNode(nodeBeforeCursor)) {
	    // Our target node may be a leaf or a text node, in which case we're
	    // already where we want to be and can just use the child's length as
	    // our offset.
	    leafKey = nullthrows(offsetKey);
	    textLength = getTextContentLength(nodeBeforeCursor);
	  } else {
	    // Otherwise, we'll look at the child to the left of the cursor and find
	    // the last leaf node in its subtree.
	    var lastLeaf = getLastLeaf(nodeBeforeCursor);
	    leafKey = nullthrows(getSelectionOffsetKeyForNode(lastLeaf));
	    textLength = getTextContentLength(lastLeaf);
	  }
	
	  return {
	    key: leafKey,
	    offset: textLength
	  };
	}
	
	/**
	 * Return the length of a node's textContent, regarding single newline
	 * characters as zero-length. This allows us to avoid problems with identifying
	 * the correct selection offset for empty blocks in IE, in which we
	 * render newlines instead of break tags.
	 */
	function getTextContentLength(node) {
	  var textContent = node.textContent;
	  return textContent === '\n' ? 0 : textContent.length;
	}
	
	module.exports = getDraftEditorSelectionWithNodes;

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getFragmentFromSelection
	 * 
	 */
	
	'use strict';
	
	var getContentStateFragment = __webpack_require__(263);
	
	function getFragmentFromSelection(editorState) {
	  var selectionState = editorState.getSelection();
	
	  if (selectionState.isCollapsed()) {
	    return null;
	  }
	
	  return getContentStateFragment(editorState.getCurrentContent(), selectionState);
	}
	
	module.exports = getFragmentFromSelection;

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getRangeClientRects
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var UserAgent = __webpack_require__(101);
	
	var invariant = __webpack_require__(10);
	
	var isChrome = UserAgent.isBrowser('Chrome');
	
	// In Chrome, the client rects will include the entire bounds of all nodes that
	// begin (have a start tag) within the selection, even if the selection does
	// not overlap the entire node. To resolve this, we split the range at each
	// start tag and join the client rects together.
	// https://code.google.com/p/chromium/issues/detail?id=324437
	/* eslint-disable consistent-return */
	function getRangeClientRectsChrome(range) {
	  var tempRange = range.cloneRange();
	  var clientRects = [];
	
	  for (var ancestor = range.endContainer; ancestor != null; ancestor = ancestor.parentNode) {
	    // If we've climbed up to the common ancestor, we can now use the
	    // original start point and stop climbing the tree.
	    var atCommonAncestor = ancestor === range.commonAncestorContainer;
	    if (atCommonAncestor) {
	      tempRange.setStart(range.startContainer, range.startOffset);
	    } else {
	      tempRange.setStart(tempRange.endContainer, 0);
	    }
	    var rects = Array.from(tempRange.getClientRects());
	    clientRects.push(rects);
	    if (atCommonAncestor) {
	      var _ref;
	
	      clientRects.reverse();
	      return (_ref = []).concat.apply(_ref, clientRects);
	    }
	    tempRange.setEndBefore(ancestor);
	  }
	
	   true ?  false ? invariant(false, 'Found an unexpected detached subtree when getting range client rects.') : invariant(false) : void 0;
	}
	/* eslint-enable consistent-return */
	
	/**
	 * Like range.getClientRects() but normalizes for browser bugs.
	 */
	var getRangeClientRects = isChrome ? getRangeClientRectsChrome : function (range) {
	  return Array.from(range.getClientRects());
	};
	
	module.exports = getRangeClientRects;

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getSafeBodyFromHTML
	 * 
	 */
	
	'use strict';
	
	var UserAgent = __webpack_require__(101);
	
	var isOldIE = UserAgent.isBrowser('IE <= 9');
	
	// Provides a dom node that will not execute scripts
	// https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation.createHTMLDocument
	// https://developer.mozilla.org/en-US/Add-ons/Code_snippets/HTML_to_DOM
	
	function getSafeBodyFromHTML(html) {
	  var doc;
	  var root = null;
	  // Provides a safe context
	  if (!isOldIE && document.implementation && document.implementation.createHTMLDocument) {
	    doc = document.implementation.createHTMLDocument('foo');
	    doc.documentElement.innerHTML = html;
	    root = doc.getElementsByTagName('body')[0];
	  }
	  return root;
	}
	
	module.exports = getSafeBodyFromHTML;

/***/ }),
/* 544 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getSelectionOffsetKeyForNode
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	/**
	 * Get offset key from a node or it's child nodes. Return the first offset key
	 * found on the DOM tree of given node.
	 */
	
	function getSelectionOffsetKeyForNode(node) {
	  if (node instanceof Element) {
	    var offsetKey = node.getAttribute('data-offset-key');
	    if (offsetKey) {
	      return offsetKey;
	    }
	    for (var ii = 0; ii < node.childNodes.length; ii++) {
	      var childOffsetKey = getSelectionOffsetKeyForNode(node.childNodes[ii]);
	      if (childOffsetKey) {
	        return childOffsetKey;
	      }
	    }
	  }
	  return null;
	}
	
	module.exports = getSelectionOffsetKeyForNode;

/***/ }),
/* 545 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getTextContentFromFiles
	 * 
	 */
	
	'use strict';
	
	var TEXT_CLIPPING_REGEX = /\.textClipping$/;
	
	var TEXT_TYPES = {
	  'text/plain': true,
	  'text/html': true,
	  'text/rtf': true
	};
	
	// Somewhat arbitrary upper bound on text size. Let's not lock up the browser.
	var TEXT_SIZE_UPPER_BOUND = 5000;
	
	/**
	 * Extract the text content from a file list.
	 */
	function getTextContentFromFiles(files, callback) {
	  var readCount = 0;
	  var results = [];
	  files.forEach(function ( /*blob*/file) {
	    readFile(file, function ( /*string*/text) {
	      readCount++;
	      text && results.push(text.slice(0, TEXT_SIZE_UPPER_BOUND));
	      if (readCount == files.length) {
	        callback(results.join('\r'));
	      }
	    });
	  });
	}
	
	/**
	 * todo isaac: Do work to turn html/rtf into a content fragment.
	 */
	function readFile(file, callback) {
	  if (!global.FileReader || file.type && !(file.type in TEXT_TYPES)) {
	    callback('');
	    return;
	  }
	
	  if (file.type === '') {
	    var contents = '';
	    // Special-case text clippings, which have an empty type but include
	    // `.textClipping` in the file name. `readAsText` results in an empty
	    // string for text clippings, so we force the file name to serve
	    // as the text value for the file.
	    if (TEXT_CLIPPING_REGEX.test(file.name)) {
	      contents = file.name.replace(TEXT_CLIPPING_REGEX, '');
	    }
	    callback(contents);
	    return;
	  }
	
	  var reader = new FileReader();
	  reader.onload = function () {
	    callback(reader.result);
	  };
	  reader.onerror = function () {
	    callback('');
	  };
	  reader.readAsText(file);
	}
	
	module.exports = getTextContentFromFiles;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getUpdatedSelectionState
	 * 
	 */
	
	'use strict';
	
	var DraftOffsetKey = __webpack_require__(261);
	
	var nullthrows = __webpack_require__(81);
	
	function getUpdatedSelectionState(editorState, anchorKey, anchorOffset, focusKey, focusOffset) {
	  var selection = nullthrows(editorState.getSelection());
	  if (false) {
	    if (!anchorKey || !focusKey) {
	      /*eslint-disable no-console */
	      console.warn('Invalid selection state.', arguments, editorState.toJS());
	      /*eslint-enable no-console */
	      return selection;
	    }
	  }
	
	  var anchorPath = DraftOffsetKey.decode(anchorKey);
	  var anchorBlockKey = anchorPath.blockKey;
	  var anchorLeaf = editorState.getBlockTree(anchorBlockKey).getIn([anchorPath.decoratorKey, 'leaves', anchorPath.leafKey]);
	
	  var focusPath = DraftOffsetKey.decode(focusKey);
	  var focusBlockKey = focusPath.blockKey;
	  var focusLeaf = editorState.getBlockTree(focusBlockKey).getIn([focusPath.decoratorKey, 'leaves', focusPath.leafKey]);
	
	  var anchorLeafStart = anchorLeaf.get('start');
	  var focusLeafStart = focusLeaf.get('start');
	
	  var anchorBlockOffset = anchorLeaf ? anchorLeafStart + anchorOffset : null;
	  var focusBlockOffset = focusLeaf ? focusLeafStart + focusOffset : null;
	
	  var areEqual = selection.getAnchorKey() === anchorBlockKey && selection.getAnchorOffset() === anchorBlockOffset && selection.getFocusKey() === focusBlockKey && selection.getFocusOffset() === focusBlockOffset;
	
	  if (areEqual) {
	    return selection;
	  }
	
	  var isBackward = false;
	  if (anchorBlockKey === focusBlockKey) {
	    var anchorLeafEnd = anchorLeaf.get('end');
	    var focusLeafEnd = focusLeaf.get('end');
	    if (focusLeafStart === anchorLeafStart && focusLeafEnd === anchorLeafEnd) {
	      isBackward = focusOffset < anchorOffset;
	    } else {
	      isBackward = focusLeafStart < anchorLeafStart;
	    }
	  } else {
	    var startKey = editorState.getCurrentContent().getBlockMap().keySeq().skipUntil(function (v) {
	      return v === anchorBlockKey || v === focusBlockKey;
	    }).first();
	    isBackward = startKey === focusBlockKey;
	  }
	
	  return selection.merge({
	    anchorKey: anchorBlockKey,
	    anchorOffset: anchorBlockOffset,
	    focusKey: focusBlockKey,
	    focusOffset: focusBlockOffset,
	    isBackward: isBackward
	  });
	}
	
	module.exports = getUpdatedSelectionState;

/***/ }),
/* 547 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule insertIntoList
	 * 
	 */
	
	'use strict';
	
	/**
	 * Maintain persistence for target list when appending and prepending.
	 */
	function insertIntoList(targetList, toInsert, offset) {
	  if (offset === targetList.count()) {
	    toInsert.forEach(function (c) {
	      targetList = targetList.push(c);
	    });
	  } else if (offset === 0) {
	    toInsert.reverse().forEach(function (c) {
	      targetList = targetList.unshift(c);
	    });
	  } else {
	    var head = targetList.slice(0, offset);
	    var tail = targetList.slice(offset);
	    targetList = head.concat(toInsert, tail).toList();
	  }
	  return targetList;
	}
	
	module.exports = insertIntoList;

/***/ }),
/* 548 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isSelectionAtLeafStart
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	function isSelectionAtLeafStart(editorState) {
	  var selection = editorState.getSelection();
	  var anchorKey = selection.getAnchorKey();
	  var blockTree = editorState.getBlockTree(anchorKey);
	  var offset = selection.getStartOffset();
	
	  var isAtStart = false;
	
	  blockTree.some(function (leafSet) {
	    if (offset === leafSet.get('start')) {
	      isAtStart = true;
	      return true;
	    }
	
	    if (offset < leafSet.get('end')) {
	      return leafSet.get('leaves').some(function (leaf) {
	        var leafStart = leaf.get('start');
	        if (offset === leafStart) {
	          isAtStart = true;
	          return true;
	        }
	
	        return false;
	      });
	    }
	
	    return false;
	  });
	
	  return isAtStart;
	}
	
	module.exports = isSelectionAtLeafStart;

/***/ }),
/* 549 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule moveSelectionForward
	 * 
	 */
	
	'use strict';
	
	/**
	 * Given a collapsed selection, move the focus `maxDistance` forward within
	 * the selected block. If the selection will go beyond the end of the block,
	 * move focus to the start of the next block, but no further.
	 *
	 * This function is not Unicode-aware, so surrogate pairs will be treated
	 * as having length 2.
	 */
	function moveSelectionForward(editorState, maxDistance) {
	  var selection = editorState.getSelection();
	  var key = selection.getStartKey();
	  var offset = selection.getStartOffset();
	  var content = editorState.getCurrentContent();
	
	  var focusKey = key;
	  var focusOffset;
	
	  var block = content.getBlockForKey(key);
	
	  if (maxDistance > block.getText().length - offset) {
	    focusKey = content.getKeyAfter(key);
	    focusOffset = 0;
	  } else {
	    focusOffset = offset + maxDistance;
	  }
	
	  return selection.merge({ focusKey: focusKey, focusOffset: focusOffset });
	}
	
	module.exports = moveSelectionForward;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule removeEntitiesAtEdges
	 * 
	 */
	
	'use strict';
	
	var CharacterMetadata = __webpack_require__(94);
	var DraftEntity = __webpack_require__(117);
	
	var findRangesImmutable = __webpack_require__(262);
	var invariant = __webpack_require__(10);
	
	function removeEntitiesAtEdges(contentState, selectionState) {
	  var blockMap = contentState.getBlockMap();
	
	  var updatedBlocks = {};
	
	  var startKey = selectionState.getStartKey();
	  var startOffset = selectionState.getStartOffset();
	  var startBlock = blockMap.get(startKey);
	  var updatedStart = removeForBlock(startBlock, startOffset);
	
	  if (updatedStart !== startBlock) {
	    updatedBlocks[startKey] = updatedStart;
	  }
	
	  var endKey = selectionState.getEndKey();
	  var endOffset = selectionState.getEndOffset();
	  var endBlock = blockMap.get(endKey);
	  if (startKey === endKey) {
	    endBlock = updatedStart;
	  }
	
	  var updatedEnd = removeForBlock(endBlock, endOffset);
	
	  if (updatedEnd !== endBlock) {
	    updatedBlocks[endKey] = updatedEnd;
	  }
	
	  if (!Object.keys(updatedBlocks).length) {
	    return contentState.set('selectionAfter', selectionState);
	  }
	
	  return contentState.merge({
	    blockMap: blockMap.merge(updatedBlocks),
	    selectionAfter: selectionState
	  });
	}
	
	function getRemovalRange(characters, key, offset) {
	  var removalRange;
	  findRangesImmutable(characters, function (a, b) {
	    return a.getEntity() === b.getEntity();
	  }, function (element) {
	    return element.getEntity() === key;
	  }, function (start, end) {
	    if (start <= offset && end >= offset) {
	      removalRange = { start: start, end: end };
	    }
	  });
	  !(typeof removalRange === 'object') ?  false ? invariant(false, 'Removal range must exist within character list.') : invariant(false) : void 0;
	  return removalRange;
	}
	
	function removeForBlock(block, offset) {
	  var chars = block.getCharacterList();
	  var charBefore = offset > 0 ? chars.get(offset - 1) : undefined;
	  var charAfter = offset < chars.count() ? chars.get(offset) : undefined;
	  var entityBeforeCursor = charBefore ? charBefore.getEntity() : undefined;
	  var entityAfterCursor = charAfter ? charAfter.getEntity() : undefined;
	
	  if (entityAfterCursor && entityAfterCursor === entityBeforeCursor) {
	    var entity = DraftEntity.get(entityAfterCursor);
	    if (entity.getMutability() !== 'MUTABLE') {
	      var _getRemovalRange = getRemovalRange(chars, entityAfterCursor, offset);
	
	      var start = _getRemovalRange.start;
	      var end = _getRemovalRange.end;
	
	      var current;
	      while (start < end) {
	        current = chars.get(start);
	        chars = chars.set(start, CharacterMetadata.applyEntity(current, null));
	        start++;
	      }
	      return block.set('characterList', chars);
	    }
	  }
	
	  return block;
	}
	
	module.exports = removeEntitiesAtEdges;

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies
	 */
	
	var XMLHttpRequest = __webpack_require__(364);
	var XHR = __webpack_require__(1116);
	var JSONP = __webpack_require__(1115);
	var websocket = __webpack_require__(1117);
	
	/**
	 * Export transports.
	 */
	
	exports.polling = polling;
	exports.websocket = websocket;
	
	/**
	 * Polling transport polymorphic constructor.
	 * Decides on xhr vs jsonp based on feature detection.
	 *
	 * @api private
	 */
	
	function polling (opts) {
	  var xhr;
	  var xd = false;
	  var xs = false;
	  var jsonp = false !== opts.jsonp;
	
	  if (global.location) {
	    var isSSL = 'https:' === location.protocol;
	    var port = location.port;
	
	    // some user agents have empty `location.port`
	    if (!port) {
	      port = isSSL ? 443 : 80;
	    }
	
	    xd = opts.hostname !== location.hostname || port !== opts.port;
	    xs = opts.secure !== isSSL;
	  }
	
	  opts.xdomain = xd;
	  opts.xscheme = xs;
	  xhr = new XMLHttpRequest(opts);
	
	  if ('open' in xhr && !opts.forceJSONP) {
	    return new XHR(opts);
	  } else {
	    if (!jsonp) throw new Error('JSONP disabled');
	    return new JSONP(opts);
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var Transport = __webpack_require__(363);
	var parseqs = __webpack_require__(382);
	var parser = __webpack_require__(183);
	var inherit = __webpack_require__(247);
	var yeast = __webpack_require__(803);
	var debug = __webpack_require__(116)('engine.io-client:polling');
	
	/**
	 * Module exports.
	 */
	
	module.exports = Polling;
	
	/**
	 * Is XHR2 supported?
	 */
	
	var hasXHR2 = (function () {
	  var XMLHttpRequest = __webpack_require__(364);
	  var xhr = new XMLHttpRequest({ xdomain: false });
	  return null != xhr.responseType;
	})();
	
	/**
	 * Polling interface.
	 *
	 * @param {Object} opts
	 * @api private
	 */
	
	function Polling (opts) {
	  var forceBase64 = (opts && opts.forceBase64);
	  if (!hasXHR2 || forceBase64) {
	    this.supportsBinary = false;
	  }
	  Transport.call(this, opts);
	}
	
	/**
	 * Inherits from Transport.
	 */
	
	inherit(Polling, Transport);
	
	/**
	 * Transport name.
	 */
	
	Polling.prototype.name = 'polling';
	
	/**
	 * Opens the socket (triggers polling). We write a PING message to determine
	 * when the transport is open.
	 *
	 * @api private
	 */
	
	Polling.prototype.doOpen = function () {
	  this.poll();
	};
	
	/**
	 * Pauses polling.
	 *
	 * @param {Function} callback upon buffers are flushed and transport is paused
	 * @api private
	 */
	
	Polling.prototype.pause = function (onPause) {
	  var self = this;
	
	  this.readyState = 'pausing';
	
	  function pause () {
	    debug('paused');
	    self.readyState = 'paused';
	    onPause();
	  }
	
	  if (this.polling || !this.writable) {
	    var total = 0;
	
	    if (this.polling) {
	      debug('we are currently polling - waiting to pause');
	      total++;
	      this.once('pollComplete', function () {
	        debug('pre-pause polling complete');
	        --total || pause();
	      });
	    }
	
	    if (!this.writable) {
	      debug('we are currently writing - waiting to pause');
	      total++;
	      this.once('drain', function () {
	        debug('pre-pause writing complete');
	        --total || pause();
	      });
	    }
	  } else {
	    pause();
	  }
	};
	
	/**
	 * Starts polling cycle.
	 *
	 * @api public
	 */
	
	Polling.prototype.poll = function () {
	  debug('polling');
	  this.polling = true;
	  this.doPoll();
	  this.emit('poll');
	};
	
	/**
	 * Overloads onData to detect payloads.
	 *
	 * @api private
	 */
	
	Polling.prototype.onData = function (data) {
	  var self = this;
	  debug('polling got data %s', data);
	  var callback = function (packet, index, total) {
	    // if its the first message we consider the transport open
	    if ('opening' === self.readyState) {
	      self.onOpen();
	    }
	
	    // if its a close packet, we close the ongoing requests
	    if ('close' === packet.type) {
	      self.onClose();
	      return false;
	    }
	
	    // otherwise bypass onData and handle the message
	    self.onPacket(packet);
	  };
	
	  // decode payload
	  parser.decodePayload(data, this.socket.binaryType, callback);
	
	  // if an event did not trigger closing
	  if ('closed' !== this.readyState) {
	    // if we got data we're not polling
	    this.polling = false;
	    this.emit('pollComplete');
	
	    if ('open' === this.readyState) {
	      this.poll();
	    } else {
	      debug('ignoring poll - transport state "%s"', this.readyState);
	    }
	  }
	};
	
	/**
	 * For polling, send a close packet.
	 *
	 * @api private
	 */
	
	Polling.prototype.doClose = function () {
	  var self = this;
	
	  function close () {
	    debug('writing close packet');
	    self.write([{ type: 'close' }]);
	  }
	
	  if ('open' === this.readyState) {
	    debug('transport open - closing');
	    close();
	  } else {
	    // in case we're trying to close while
	    // handshaking is in progress (GH-164)
	    debug('transport not open - deferring close');
	    this.once('open', close);
	  }
	};
	
	/**
	 * Writes a packets payload.
	 *
	 * @param {Array} data packets
	 * @param {Function} drain callback
	 * @api private
	 */
	
	Polling.prototype.write = function (packets) {
	  var self = this;
	  this.writable = false;
	  var callbackfn = function () {
	    self.writable = true;
	    self.emit('drain');
	  };
	
	  parser.encodePayload(packets, this.supportsBinary, function (data) {
	    self.doWrite(data, callbackfn);
	  });
	};
	
	/**
	 * Generates uri for connection.
	 *
	 * @api private
	 */
	
	Polling.prototype.uri = function () {
	  var query = this.query || {};
	  var schema = this.secure ? 'https' : 'http';
	  var port = '';
	
	  // cache busting is forced
	  if (false !== this.timestampRequests) {
	    query[this.timestampParam] = yeast();
	  }
	
	  if (!this.supportsBinary && !query.sid) {
	    query.b64 = 1;
	  }
	
	  query = parseqs.encode(query);
	
	  // avoid port if default for schema
	  if (this.port && (('https' === schema && Number(this.port) !== 443) ||
	     ('http' === schema && Number(this.port) !== 80))) {
	    port = ':' + this.port;
	  }
	
	  // prepend ? to query
	  if (query.length) {
	    query = '?' + query;
	  }
	
	  var ipv6 = this.hostname.indexOf(':') !== -1;
	  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
	};


/***/ }),
/* 553 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 554 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 555 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 556 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 557 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var PhotosMimeType = __webpack_require__(1334);
	
	var createArrayFromMixed = __webpack_require__(563);
	var emptyFunction = __webpack_require__(59);
	
	var CR_LF_REGEX = new RegExp('\r\n', 'g');
	var LF_ONLY = '\n';
	
	var RICH_TEXT_TYPES = {
	  'text/rtf': 1,
	  'text/html': 1
	};
	
	/**
	 * If DataTransferItem is a file then return the Blob of data.
	 *
	 * @param {object} item
	 * @return {?blob}
	 */
	function getFileFromDataTransfer(item) {
	  if (item.kind == 'file') {
	    return item.getAsFile();
	  }
	}
	
	var DataTransfer = function () {
	  /**
	   * @param {object} data
	   */
	  function DataTransfer(data) {
	    _classCallCheck(this, DataTransfer);
	
	    this.data = data;
	
	    // Types could be DOMStringList or array
	    this.types = data.types ? createArrayFromMixed(data.types) : [];
	  }
	
	  /**
	   * Is this likely to be a rich text data transfer?
	   *
	   * @return {boolean}
	   */
	
	
	  DataTransfer.prototype.isRichText = function isRichText() {
	    // If HTML is available, treat this data as rich text. This way, we avoid
	    // using a pasted image if it is packaged with HTML -- this may occur with
	    // pastes from MS Word, for example.  However this is only rich text if
	    // there's accompanying text.
	    if (this.getHTML() && this.getText()) {
	      return true;
	    }
	
	    // When an image is copied from a preview window, you end up with two
	    // DataTransferItems one of which is a file's metadata as text.  Skip those.
	    if (this.isImage()) {
	      return false;
	    }
	
	    return this.types.some(function (type) {
	      return RICH_TEXT_TYPES[type];
	    });
	  };
	
	  /**
	   * Get raw text.
	   *
	   * @return {?string}
	   */
	
	
	  DataTransfer.prototype.getText = function getText() {
	    var text;
	    if (this.data.getData) {
	      if (!this.types.length) {
	        text = this.data.getData('Text');
	      } else if (this.types.indexOf('text/plain') != -1) {
	        text = this.data.getData('text/plain');
	      }
	    }
	    return text ? text.replace(CR_LF_REGEX, LF_ONLY) : null;
	  };
	
	  /**
	   * Get HTML paste data
	   *
	   * @return {?string}
	   */
	
	
	  DataTransfer.prototype.getHTML = function getHTML() {
	    if (this.data.getData) {
	      if (!this.types.length) {
	        return this.data.getData('Text');
	      } else if (this.types.indexOf('text/html') != -1) {
	        return this.data.getData('text/html');
	      }
	    }
	  };
	
	  /**
	   * Is this a link data transfer?
	   *
	   * @return {boolean}
	   */
	
	
	  DataTransfer.prototype.isLink = function isLink() {
	    return this.types.some(function (type) {
	      return type.indexOf('Url') != -1 || type.indexOf('text/uri-list') != -1 || type.indexOf('text/x-moz-url');
	    });
	  };
	
	  /**
	   * Get a link url.
	   *
	   * @return {?string}
	   */
	
	
	  DataTransfer.prototype.getLink = function getLink() {
	    if (this.data.getData) {
	      if (this.types.indexOf('text/x-moz-url') != -1) {
	        var url = this.data.getData('text/x-moz-url').split('\n');
	        return url[0];
	      }
	      return this.types.indexOf('text/uri-list') != -1 ? this.data.getData('text/uri-list') : this.data.getData('url');
	    }
	
	    return null;
	  };
	
	  /**
	   * Is this an image data transfer?
	   *
	   * @return {boolean}
	   */
	
	
	  DataTransfer.prototype.isImage = function isImage() {
	    var isImage = this.types.some(function (type) {
	      // Firefox will have a type of application/x-moz-file for images during
	      // dragging
	      return type.indexOf('application/x-moz-file') != -1;
	    });
	
	    if (isImage) {
	      return true;
	    }
	
	    var items = this.getFiles();
	    for (var i = 0; i < items.length; i++) {
	      var type = items[i].type;
	      if (!PhotosMimeType.isImage(type)) {
	        return false;
	      }
	    }
	
	    return true;
	  };
	
	  DataTransfer.prototype.getCount = function getCount() {
	    if (this.data.hasOwnProperty('items')) {
	      return this.data.items.length;
	    } else if (this.data.hasOwnProperty('mozItemCount')) {
	      return this.data.mozItemCount;
	    } else if (this.data.files) {
	      return this.data.files.length;
	    }
	    return null;
	  };
	
	  /**
	   * Get files.
	   *
	   * @return {array}
	   */
	
	
	  DataTransfer.prototype.getFiles = function getFiles() {
	    if (this.data.items) {
	      // createArrayFromMixed doesn't properly handle DataTransferItemLists.
	      return Array.prototype.slice.call(this.data.items).map(getFileFromDataTransfer).filter(emptyFunction.thatReturnsArgument);
	    } else if (this.data.files) {
	      return Array.prototype.slice.call(this.data.files);
	    } else {
	      return [];
	    }
	  };
	
	  /**
	   * Are there any files to fetch?
	   *
	   * @return {boolean}
	   */
	
	
	  DataTransfer.prototype.hasFiles = function hasFiles() {
	    return this.getFiles().length > 0;
	  };
	
	  return DataTransfer;
	}();
	
	module.exports = DataTransfer;

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(59);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ }),
/* 560 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/**
	 * @param {DOMElement} element
	 * @param {DOMDocument} doc
	 * @return {boolean}
	 */
	function _isViewportScrollElement(element, doc) {
	  return !!doc && (element === doc.documentElement || element === doc.body);
	}
	
	/**
	 * Scroll Module. This class contains 4 simple static functions
	 * to be used to access Element.scrollTop/scrollLeft properties.
	 * To solve the inconsistencies between browsers when either
	 * document.body or document.documentElement is supplied,
	 * below logic will be used to alleviate the issue:
	 *
	 * 1. If 'element' is either 'document.body' or 'document.documentElement,
	 *    get whichever element's 'scroll{Top,Left}' is larger.
	 * 2. If 'element' is either 'document.body' or 'document.documentElement',
	 *    set the 'scroll{Top,Left}' on both elements.
	 */
	
	var Scroll = {
	  /**
	   * @param {DOMElement} element
	   * @return {number}
	   */
	  getTop: function getTop(element) {
	    var doc = element.ownerDocument;
	    return _isViewportScrollElement(element, doc) ?
	    // In practice, they will either both have the same value,
	    // or one will be zero and the other will be the scroll position
	    // of the viewport. So we can use `X || Y` instead of `Math.max(X, Y)`
	    doc.body.scrollTop || doc.documentElement.scrollTop : element.scrollTop;
	  },
	
	  /**
	   * @param {DOMElement} element
	   * @param {number} newTop
	   */
	  setTop: function setTop(element, newTop) {
	    var doc = element.ownerDocument;
	    if (_isViewportScrollElement(element, doc)) {
	      doc.body.scrollTop = doc.documentElement.scrollTop = newTop;
	    } else {
	      element.scrollTop = newTop;
	    }
	  },
	
	  /**
	   * @param {DOMElement} element
	   * @return {number}
	   */
	  getLeft: function getLeft(element) {
	    var doc = element.ownerDocument;
	    return _isViewportScrollElement(element, doc) ? doc.body.scrollLeft || doc.documentElement.scrollLeft : element.scrollLeft;
	  },
	
	  /**
	   * @param {DOMElement} element
	   * @param {number} newLeft
	   */
	  setLeft: function setLeft(element, newLeft) {
	    var doc = element.ownerDocument;
	    if (_isViewportScrollElement(element, doc)) {
	      doc.body.scrollLeft = doc.documentElement.scrollLeft = newLeft;
	    } else {
	      element.scrollLeft = newLeft;
	    }
	  }
	};
	
	module.exports = Scroll;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/**
	 * Basic (stateless) API for text direction detection
	 *
	 * Part of our implementation of Unicode Bidirectional Algorithm (UBA)
	 * Unicode Standard Annex #9 (UAX9)
	 * http://www.unicode.org/reports/tr9/
	 */
	
	'use strict';
	
	var UnicodeBidiDirection = __webpack_require__(367);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * RegExp ranges of characters with a *Strong* Bidi_Class value.
	 *
	 * Data is based on DerivedBidiClass.txt in UCD version 7.0.0.
	 *
	 * NOTE: For performance reasons, we only support Unicode's
	 *       Basic Multilingual Plane (BMP) for now.
	 */
	var RANGE_BY_BIDI_TYPE = {
	
	  L: 'A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u01BA\u01BB' + '\u01BC-\u01BF\u01C0-\u01C3\u01C4-\u0293\u0294\u0295-\u02AF\u02B0-\u02B8' + '\u02BB-\u02C1\u02D0-\u02D1\u02E0-\u02E4\u02EE\u0370-\u0373\u0376-\u0377' + '\u037A\u037B-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1' + '\u03A3-\u03F5\u03F7-\u0481\u0482\u048A-\u052F\u0531-\u0556\u0559' + '\u055A-\u055F\u0561-\u0587\u0589\u0903\u0904-\u0939\u093B\u093D' + '\u093E-\u0940\u0949-\u094C\u094E-\u094F\u0950\u0958-\u0961\u0964-\u0965' + '\u0966-\u096F\u0970\u0971\u0972-\u0980\u0982-\u0983\u0985-\u098C' + '\u098F-\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD' + '\u09BE-\u09C0\u09C7-\u09C8\u09CB-\u09CC\u09CE\u09D7\u09DC-\u09DD' + '\u09DF-\u09E1\u09E6-\u09EF\u09F0-\u09F1\u09F4-\u09F9\u09FA\u0A03' + '\u0A05-\u0A0A\u0A0F-\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32-\u0A33' + '\u0A35-\u0A36\u0A38-\u0A39\u0A3E-\u0A40\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F' + '\u0A72-\u0A74\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0' + '\u0AB2-\u0AB3\u0AB5-\u0AB9\u0ABD\u0ABE-\u0AC0\u0AC9\u0ACB-\u0ACC\u0AD0' + '\u0AE0-\u0AE1\u0AE6-\u0AEF\u0AF0\u0B02-\u0B03\u0B05-\u0B0C\u0B0F-\u0B10' + '\u0B13-\u0B28\u0B2A-\u0B30\u0B32-\u0B33\u0B35-\u0B39\u0B3D\u0B3E\u0B40' + '\u0B47-\u0B48\u0B4B-\u0B4C\u0B57\u0B5C-\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F' + '\u0B70\u0B71\u0B72-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95' + '\u0B99-\u0B9A\u0B9C\u0B9E-\u0B9F\u0BA3-\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9' + '\u0BBE-\u0BBF\u0BC1-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0BD0\u0BD7' + '\u0BE6-\u0BEF\u0BF0-\u0BF2\u0C01-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10' + '\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C41-\u0C44\u0C58-\u0C59\u0C60-\u0C61' + '\u0C66-\u0C6F\u0C7F\u0C82-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8' + '\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CBE\u0CBF\u0CC0-\u0CC4\u0CC6' + '\u0CC7-\u0CC8\u0CCA-\u0CCB\u0CD5-\u0CD6\u0CDE\u0CE0-\u0CE1\u0CE6-\u0CEF' + '\u0CF1-\u0CF2\u0D02-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D' + '\u0D3E-\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D4E\u0D57\u0D60-\u0D61' + '\u0D66-\u0D6F\u0D70-\u0D75\u0D79\u0D7A-\u0D7F\u0D82-\u0D83\u0D85-\u0D96' + '\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCF-\u0DD1\u0DD8-\u0DDF' + '\u0DE6-\u0DEF\u0DF2-\u0DF3\u0DF4\u0E01-\u0E30\u0E32-\u0E33\u0E40-\u0E45' + '\u0E46\u0E4F\u0E50-\u0E59\u0E5A-\u0E5B\u0E81-\u0E82\u0E84\u0E87-\u0E88' + '\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7' + '\u0EAA-\u0EAB\u0EAD-\u0EB0\u0EB2-\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6' + '\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F01-\u0F03\u0F04-\u0F12\u0F13\u0F14' + '\u0F15-\u0F17\u0F1A-\u0F1F\u0F20-\u0F29\u0F2A-\u0F33\u0F34\u0F36\u0F38' + '\u0F3E-\u0F3F\u0F40-\u0F47\u0F49-\u0F6C\u0F7F\u0F85\u0F88-\u0F8C' + '\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE-\u0FCF\u0FD0-\u0FD4\u0FD5-\u0FD8' + '\u0FD9-\u0FDA\u1000-\u102A\u102B-\u102C\u1031\u1038\u103B-\u103C\u103F' + '\u1040-\u1049\u104A-\u104F\u1050-\u1055\u1056-\u1057\u105A-\u105D\u1061' + '\u1062-\u1064\u1065-\u1066\u1067-\u106D\u106E-\u1070\u1075-\u1081' + '\u1083-\u1084\u1087-\u108C\u108E\u108F\u1090-\u1099\u109A-\u109C' + '\u109E-\u109F\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FB\u10FC' + '\u10FD-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288' + '\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5' + '\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1360-\u1368' + '\u1369-\u137C\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166D-\u166E' + '\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EB-\u16ED\u16EE-\u16F0' + '\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1735-\u1736' + '\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17B6\u17BE-\u17C5' + '\u17C7-\u17C8\u17D4-\u17D6\u17D7\u17D8-\u17DA\u17DC\u17E0-\u17E9' + '\u1810-\u1819\u1820-\u1842\u1843\u1844-\u1877\u1880-\u18A8\u18AA' + '\u18B0-\u18F5\u1900-\u191E\u1923-\u1926\u1929-\u192B\u1930-\u1931' + '\u1933-\u1938\u1946-\u194F\u1950-\u196D\u1970-\u1974\u1980-\u19AB' + '\u19B0-\u19C0\u19C1-\u19C7\u19C8-\u19C9\u19D0-\u19D9\u19DA\u1A00-\u1A16' + '\u1A19-\u1A1A\u1A1E-\u1A1F\u1A20-\u1A54\u1A55\u1A57\u1A61\u1A63-\u1A64' + '\u1A6D-\u1A72\u1A80-\u1A89\u1A90-\u1A99\u1AA0-\u1AA6\u1AA7\u1AA8-\u1AAD' + '\u1B04\u1B05-\u1B33\u1B35\u1B3B\u1B3D-\u1B41\u1B43-\u1B44\u1B45-\u1B4B' + '\u1B50-\u1B59\u1B5A-\u1B60\u1B61-\u1B6A\u1B74-\u1B7C\u1B82\u1B83-\u1BA0' + '\u1BA1\u1BA6-\u1BA7\u1BAA\u1BAE-\u1BAF\u1BB0-\u1BB9\u1BBA-\u1BE5\u1BE7' + '\u1BEA-\u1BEC\u1BEE\u1BF2-\u1BF3\u1BFC-\u1BFF\u1C00-\u1C23\u1C24-\u1C2B' + '\u1C34-\u1C35\u1C3B-\u1C3F\u1C40-\u1C49\u1C4D-\u1C4F\u1C50-\u1C59' + '\u1C5A-\u1C77\u1C78-\u1C7D\u1C7E-\u1C7F\u1CC0-\u1CC7\u1CD3\u1CE1' + '\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF2-\u1CF3\u1CF5-\u1CF6\u1D00-\u1D2B' + '\u1D2C-\u1D6A\u1D6B-\u1D77\u1D78\u1D79-\u1D9A\u1D9B-\u1DBF\u1E00-\u1F15' + '\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D' + '\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC' + '\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200E' + '\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D' + '\u2124\u2126\u2128\u212A-\u212D\u212F-\u2134\u2135-\u2138\u2139' + '\u213C-\u213F\u2145-\u2149\u214E\u214F\u2160-\u2182\u2183-\u2184' + '\u2185-\u2188\u2336-\u237A\u2395\u249C-\u24E9\u26AC\u2800-\u28FF' + '\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2C7B\u2C7C-\u2C7D\u2C7E-\u2CE4' + '\u2CEB-\u2CEE\u2CF2-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F' + '\u2D70\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE' + '\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005\u3006\u3007' + '\u3021-\u3029\u302E-\u302F\u3031-\u3035\u3038-\u303A\u303B\u303C' + '\u3041-\u3096\u309D-\u309E\u309F\u30A1-\u30FA\u30FC-\u30FE\u30FF' + '\u3105-\u312D\u3131-\u318E\u3190-\u3191\u3192-\u3195\u3196-\u319F' + '\u31A0-\u31BA\u31F0-\u31FF\u3200-\u321C\u3220-\u3229\u322A-\u3247' + '\u3248-\u324F\u3260-\u327B\u327F\u3280-\u3289\u328A-\u32B0\u32C0-\u32CB' + '\u32D0-\u32FE\u3300-\u3376\u337B-\u33DD\u33E0-\u33FE\u3400-\u4DB5' + '\u4E00-\u9FCC\uA000-\uA014\uA015\uA016-\uA48C\uA4D0-\uA4F7\uA4F8-\uA4FD' + '\uA4FE-\uA4FF\uA500-\uA60B\uA60C\uA610-\uA61F\uA620-\uA629\uA62A-\uA62B' + '\uA640-\uA66D\uA66E\uA680-\uA69B\uA69C-\uA69D\uA6A0-\uA6E5\uA6E6-\uA6EF' + '\uA6F2-\uA6F7\uA722-\uA76F\uA770\uA771-\uA787\uA789-\uA78A\uA78B-\uA78E' + '\uA790-\uA7AD\uA7B0-\uA7B1\uA7F7\uA7F8-\uA7F9\uA7FA\uA7FB-\uA801' + '\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA823-\uA824\uA827\uA830-\uA835' + '\uA836-\uA837\uA840-\uA873\uA880-\uA881\uA882-\uA8B3\uA8B4-\uA8C3' + '\uA8CE-\uA8CF\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8F8-\uA8FA\uA8FB\uA900-\uA909' + '\uA90A-\uA925\uA92E-\uA92F\uA930-\uA946\uA952-\uA953\uA95F\uA960-\uA97C' + '\uA983\uA984-\uA9B2\uA9B4-\uA9B5\uA9BA-\uA9BB\uA9BD-\uA9C0\uA9C1-\uA9CD' + '\uA9CF\uA9D0-\uA9D9\uA9DE-\uA9DF\uA9E0-\uA9E4\uA9E6\uA9E7-\uA9EF' + '\uA9F0-\uA9F9\uA9FA-\uA9FE\uAA00-\uAA28\uAA2F-\uAA30\uAA33-\uAA34' + '\uAA40-\uAA42\uAA44-\uAA4B\uAA4D\uAA50-\uAA59\uAA5C-\uAA5F\uAA60-\uAA6F' + '\uAA70\uAA71-\uAA76\uAA77-\uAA79\uAA7A\uAA7B\uAA7D\uAA7E-\uAAAF\uAAB1' + '\uAAB5-\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADC\uAADD\uAADE-\uAADF' + '\uAAE0-\uAAEA\uAAEB\uAAEE-\uAAEF\uAAF0-\uAAF1\uAAF2\uAAF3-\uAAF4\uAAF5' + '\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E' + '\uAB30-\uAB5A\uAB5B\uAB5C-\uAB5F\uAB64-\uAB65\uABC0-\uABE2\uABE3-\uABE4' + '\uABE6-\uABE7\uABE9-\uABEA\uABEB\uABEC\uABF0-\uABF9\uAC00-\uD7A3' + '\uD7B0-\uD7C6\uD7CB-\uD7FB\uE000-\uF8FF\uF900-\uFA6D\uFA70-\uFAD9' + '\uFB00-\uFB06\uFB13-\uFB17\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFF6F\uFF70' + '\uFF71-\uFF9D\uFF9E-\uFF9F\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF' + '\uFFD2-\uFFD7\uFFDA-\uFFDC',
	
	  R: '\u0590\u05BE\u05C0\u05C3\u05C6\u05C8-\u05CF\u05D0-\u05EA\u05EB-\u05EF' + '\u05F0-\u05F2\u05F3-\u05F4\u05F5-\u05FF\u07C0-\u07C9\u07CA-\u07EA' + '\u07F4-\u07F5\u07FA\u07FB-\u07FF\u0800-\u0815\u081A\u0824\u0828' + '\u082E-\u082F\u0830-\u083E\u083F\u0840-\u0858\u085C-\u085D\u085E' + '\u085F-\u089F\u200F\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB37\uFB38-\uFB3C' + '\uFB3D\uFB3E\uFB3F\uFB40-\uFB41\uFB42\uFB43-\uFB44\uFB45\uFB46-\uFB4F',
	
	  AL: '\u0608\u060B\u060D\u061B\u061C\u061D\u061E-\u061F\u0620-\u063F\u0640' + '\u0641-\u064A\u066D\u066E-\u066F\u0671-\u06D3\u06D4\u06D5\u06E5-\u06E6' + '\u06EE-\u06EF\u06FA-\u06FC\u06FD-\u06FE\u06FF\u0700-\u070D\u070E\u070F' + '\u0710\u0712-\u072F\u074B-\u074C\u074D-\u07A5\u07B1\u07B2-\u07BF' + '\u08A0-\u08B2\u08B3-\u08E3\uFB50-\uFBB1\uFBB2-\uFBC1\uFBC2-\uFBD2' + '\uFBD3-\uFD3D\uFD40-\uFD4F\uFD50-\uFD8F\uFD90-\uFD91\uFD92-\uFDC7' + '\uFDC8-\uFDCF\uFDF0-\uFDFB\uFDFC\uFDFE-\uFDFF\uFE70-\uFE74\uFE75' + '\uFE76-\uFEFC\uFEFD-\uFEFE'
	
	};
	
	var REGEX_STRONG = new RegExp('[' + RANGE_BY_BIDI_TYPE.L + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + ']');
	
	var REGEX_RTL = new RegExp('[' + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + ']');
	
	/**
	 * Returns the first strong character (has Bidi_Class value of L, R, or AL).
	 *
	 * @param str  A text block; e.g. paragraph, table cell, tag
	 * @return     A character with strong bidi direction, or null if not found
	 */
	function firstStrongChar(str) {
	  var match = REGEX_STRONG.exec(str);
	  return match == null ? null : match[0];
	}
	
	/**
	 * Returns the direction of a block of text, based on the direction of its
	 * first strong character (has Bidi_Class value of L, R, or AL).
	 *
	 * @param str  A text block; e.g. paragraph, table cell, tag
	 * @return     The resolved direction
	 */
	function firstStrongCharDir(str) {
	  var strongChar = firstStrongChar(str);
	  if (strongChar == null) {
	    return UnicodeBidiDirection.NEUTRAL;
	  }
	  return REGEX_RTL.exec(strongChar) ? UnicodeBidiDirection.RTL : UnicodeBidiDirection.LTR;
	}
	
	/**
	 * Returns the direction of a block of text, based on the direction of its
	 * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
	 * direction, if no strong character is found.
	 *
	 * This function is supposed to be used in respect to Higher-Level Protocol
	 * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
	 *
	 * @param str       A text block; e.g. paragraph, table cell, tag
	 * @param fallback  Fallback direction, used if no strong direction detected
	 *                  for the block (default = NEUTRAL)
	 * @return          The resolved direction
	 */
	function resolveBlockDir(str, fallback) {
	  fallback = fallback || UnicodeBidiDirection.NEUTRAL;
	  if (!str.length) {
	    return fallback;
	  }
	  var blockDir = firstStrongCharDir(str);
	  return blockDir === UnicodeBidiDirection.NEUTRAL ? fallback : blockDir;
	}
	
	/**
	 * Returns the direction of a block of text, based on the direction of its
	 * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
	 * direction, if no strong character is found.
	 *
	 * NOTE: This function is similar to resolveBlockDir(), but uses the global
	 * direction as the fallback, so it *always* returns a Strong direction,
	 * making it useful for integration in places that you need to make the final
	 * decision, like setting some CSS class.
	 *
	 * This function is supposed to be used in respect to Higher-Level Protocol
	 * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
	 *
	 * @param str             A text block; e.g. paragraph, table cell
	 * @param strongFallback  Fallback direction, used if no strong direction
	 *                        detected for the block (default = global direction)
	 * @return                The resolved Strong direction
	 */
	function getDirection(str, strongFallback) {
	  if (!strongFallback) {
	    strongFallback = UnicodeBidiDirection.getGlobalDir();
	  }
	  !UnicodeBidiDirection.isStrong(strongFallback) ?  false ? invariant(false, 'Fallback direction must be a strong direction') : invariant(false) : void 0;
	  return resolveBlockDir(str, strongFallback);
	}
	
	/**
	 * Returns true if getDirection(arguments...) returns LTR.
	 *
	 * @param str             A text block; e.g. paragraph, table cell
	 * @param strongFallback  Fallback direction, used if no strong direction
	 *                        detected for the block (default = global direction)
	 * @return                True if the resolved direction is LTR
	 */
	function isDirectionLTR(str, strongFallback) {
	  return getDirection(str, strongFallback) === UnicodeBidiDirection.LTR;
	}
	
	/**
	 * Returns true if getDirection(arguments...) returns RTL.
	 *
	 * @param str             A text block; e.g. paragraph, table cell
	 * @param strongFallback  Fallback direction, used if no strong direction
	 *                        detected for the block (default = global direction)
	 * @return                True if the resolved direction is RTL
	 */
	function isDirectionRTL(str, strongFallback) {
	  return getDirection(str, strongFallback) === UnicodeBidiDirection.RTL;
	}
	
	var UnicodeBidi = {
	  firstStrongChar: firstStrongChar,
	  firstStrongCharDir: firstStrongCharDir,
	  resolveBlockDir: resolveBlockDir,
	  getDirection: getDirection,
	  isDirectionLTR: isDirectionLTR,
	  isDirectionRTL: isDirectionRTL
	};
	
	module.exports = UnicodeBidi;

/***/ }),
/* 562 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ }),
/* 564 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ }),
/* 565 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ }),
/* 566 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ }),
/* 567 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ }),
/* 568 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getMargin;
	var toNumber = function toNumber(n) {
	  return parseInt(n) || 0;
	};
	
	function getMargin(style) {
	  return {
	    top: toNumber(style.marginTop),
	    right: toNumber(style.marginRight),
	    bottom: toNumber(style.marginBottom),
	    left: toNumber(style.marginLeft)
	  };
	}
	
	module.exports = exports["default"];

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* global Blob File */
	
	/*
	 * Module requirements.
	 */
	
	var isArray = __webpack_require__(1357);
	
	var toString = Object.prototype.toString;
	var withNativeBlob = typeof global.Blob === 'function' || toString.call(global.Blob) === '[object BlobConstructor]';
	var withNativeFile = typeof global.File === 'function' || toString.call(global.File) === '[object FileConstructor]';
	
	/**
	 * Module exports.
	 */
	
	module.exports = hasBinary;
	
	/**
	 * Checks for binary data.
	 *
	 * Supports Buffer, ArrayBuffer, Blob and File.
	 *
	 * @param {Object} anything
	 * @api public
	 */
	
	function hasBinary (obj) {
	  if (!obj || typeof obj !== 'object') {
	    return false;
	  }
	
	  if (isArray(obj)) {
	    for (var i = 0, l = obj.length; i < l; i++) {
	      if (hasBinary(obj[i])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  if ((typeof global.Buffer === 'function' && global.Buffer.isBuffer && global.Buffer.isBuffer(obj)) ||
	     (typeof global.ArrayBuffer === 'function' && obj instanceof ArrayBuffer) ||
	     (withNativeBlob && obj instanceof Blob) ||
	     (withNativeFile && obj instanceof File)
	    ) {
	    return true;
	  }
	
	  // see: https://github.com/Automattic/has-binary/pull/4
	  if (obj.toJSON && typeof obj.toJSON === 'function' && arguments.length === 1) {
	    return hasBinary(obj.toJSON(), true);
	  }
	
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key) && hasBinary(obj[key])) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	/*eslint-disable no-empty */
	'use strict';
	
	exports.__esModule = true;
	exports.saveState = saveState;
	exports.readState = readState;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(102);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var KeyPrefix = '@@History/';
	var QuotaExceededErrors = ['QuotaExceededError', 'QUOTA_EXCEEDED_ERR'];
	
	var SecurityError = 'SecurityError';
	
	function createKey(key) {
	  return KeyPrefix + key;
	}
	
	function saveState(key, state) {
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available due to security settings') : undefined;
	
	      return;
	    }
	
	    if (QuotaExceededErrors.indexOf(error.name) >= 0 && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : undefined;
	
	      return;
	    }
	
	    throw error;
	  }
	}
	
	function readState(key) {
	  var json = undefined;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to read state; sessionStorage is not available due to security settings') : undefined;
	
	      return null;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return null;
	}

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(267);
	
	var _DOMUtils = __webpack_require__(370);
	
	var _createHistory = __webpack_require__(573);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createDOMHistory(options) {
	  var history = _createHistory2['default'](_extends({
	    getUserConfirmation: _DOMUtils.getUserConfirmation
	  }, options, {
	    go: _DOMUtils.go
	  }));
	
	  function listen(listener) {
	    !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'DOM history needs a DOM') : _invariant2['default'](false) : undefined;
	
	    return history.listen(listener);
	  }
	
	  return _extends({}, history, {
	    listen: listen
	  });
	}
	
	exports['default'] = createDOMHistory;
	module.exports = exports['default'];

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(102);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(184);
	
	var _PathUtils = __webpack_require__(160);
	
	var _ExecutionEnvironment = __webpack_require__(267);
	
	var _DOMUtils = __webpack_require__(370);
	
	var _DOMStateStorage = __webpack_require__(570);
	
	var _createDOMHistory = __webpack_require__(571);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	function isAbsolutePath(path) {
	  return typeof path === 'string' && path.charAt(0) === '/';
	}
	
	function ensureSlash() {
	  var path = _DOMUtils.getHashPath();
	
	  if (isAbsolutePath(path)) return true;
	
	  _DOMUtils.replaceHashPath('/' + path);
	
	  return false;
	}
	
	function addQueryStringValueToPath(path, key, value) {
	  return path + (path.indexOf('?') === -1 ? '?' : '&') + (key + '=' + value);
	}
	
	function stripQueryStringValueFromPath(path, key) {
	  return path.replace(new RegExp('[?&]?' + key + '=[a-zA-Z0-9]+'), '');
	}
	
	function getQueryStringValueFromPath(path, key) {
	  var match = path.match(new RegExp('\\?.*?\\b' + key + '=(.+?)\\b'));
	  return match && match[1];
	}
	
	var DefaultQueryKey = '_k';
	
	function createHashHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Hash history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var queryKey = options.queryKey;
	
	  if (queryKey === undefined || !!queryKey) queryKey = typeof queryKey === 'string' ? queryKey : DefaultQueryKey;
	
	  function getCurrentLocation() {
	    var path = _DOMUtils.getHashPath();
	
	    var key = undefined,
	        state = undefined;
	    if (queryKey) {
	      key = getQueryStringValueFromPath(path, queryKey);
	      path = stripQueryStringValueFromPath(path, queryKey);
	
	      if (key) {
	        state = _DOMStateStorage.readState(key);
	      } else {
	        state = null;
	        key = history.createKey();
	        _DOMUtils.replaceHashPath(addQueryStringValueToPath(path, queryKey, key));
	      }
	    } else {
	      key = state = null;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startHashChangeListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function hashChangeListener() {
	      if (!ensureSlash()) return; // Always make sure hashes are preceeded with a /.
	
	      transitionTo(getCurrentLocation());
	    }
	
	    ensureSlash();
	    _DOMUtils.addEventListener(window, 'hashchange', hashChangeListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'hashchange', hashChangeListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    var path = (basename || '') + pathname + search;
	
	    if (queryKey) {
	      path = addQueryStringValueToPath(path, queryKey, key);
	      _DOMStateStorage.saveState(key, state);
	    } else {
	      // Drop key and state.
	      location.key = location.state = null;
	    }
	
	    var currentHash = _DOMUtils.getHashPath();
	
	    if (action === _Actions.PUSH) {
	      if (currentHash !== path) {
	        window.location.hash = path;
	      } else {
	         false ? _warning2['default'](false, 'You cannot PUSH the same path using hash history') : undefined;
	      }
	    } else if (currentHash !== path) {
	      // REPLACE
	      _DOMUtils.replaceHashPath(path);
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopHashChangeListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function push(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.push(location);
	  }
	
	  function replace(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replace(location);
	  }
	
	  var goIsSupportedWithoutReload = _DOMUtils.supportsGoWithoutReloadUsingHash();
	
	  function go(n) {
	     false ? _warning2['default'](goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : undefined;
	
	    history.go(n);
	  }
	
	  function createHref(path) {
	    return '#' + history.createHref(path);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopHashChangeListener();
	  }
	
	  // deprecated
	  function pushState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.pushState(state, path);
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replaceState(state, path);
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    push: push,
	    replace: replace,
	    go: go,
	    createHref: createHref,
	
	    registerTransitionHook: registerTransitionHook, // deprecated - warning is in createHistory
	    unregisterTransitionHook: unregisterTransitionHook, // deprecated - warning is in createHistory
	    pushState: pushState, // deprecated - warning is in createHistory
	    replaceState: replaceState // deprecated - warning is in createHistory
	  });
	}
	
	exports['default'] = createHashHistory;
	module.exports = exports['default'];

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(102);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _deepEqual = __webpack_require__(354);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _PathUtils = __webpack_require__(160);
	
	var _AsyncUtils = __webpack_require__(1359);
	
	var _Actions = __webpack_require__(184);
	
	var _createLocation2 = __webpack_require__(1361);
	
	var _createLocation3 = _interopRequireDefault(_createLocation2);
	
	var _runTransitionHook = __webpack_require__(372);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(371);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function createRandomKey(length) {
	  return Math.random().toString(36).substr(2, length);
	}
	
	function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search &&
	  //a.action === b.action && // Different action !== location change.
	  a.key === b.key && _deepEqual2['default'](a.state, b.state);
	}
	
	var DefaultKeyLength = 6;
	
	function createHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var getCurrentLocation = options.getCurrentLocation;
	  var finishTransition = options.finishTransition;
	  var saveState = options.saveState;
	  var go = options.go;
	  var getUserConfirmation = options.getUserConfirmation;
	  var keyLength = options.keyLength;
	
	  if (typeof keyLength !== 'number') keyLength = DefaultKeyLength;
	
	  var transitionHooks = [];
	
	  function listenBefore(hook) {
	    transitionHooks.push(hook);
	
	    return function () {
	      transitionHooks = transitionHooks.filter(function (item) {
	        return item !== hook;
	      });
	    };
	  }
	
	  var allKeys = [];
	  var changeListeners = [];
	  var location = undefined;
	
	  function getCurrent() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) {
	      return allKeys.indexOf(pendingLocation.key);
	    } else if (location) {
	      return allKeys.indexOf(location.key);
	    } else {
	      return -1;
	    }
	  }
	
	  function updateLocation(newLocation) {
	    var current = getCurrent();
	
	    location = newLocation;
	
	    if (location.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, current + 1), [location.key]);
	    } else if (location.action === _Actions.REPLACE) {
	      allKeys[current] = location.key;
	    }
	
	    changeListeners.forEach(function (listener) {
	      listener(location);
	    });
	  }
	
	  function listen(listener) {
	    changeListeners.push(listener);
	
	    if (location) {
	      listener(location);
	    } else {
	      var _location = getCurrentLocation();
	      allKeys = [_location.key];
	      updateLocation(_location);
	    }
	
	    return function () {
	      changeListeners = changeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }
	
	  function confirmTransitionTo(location, callback) {
	    _AsyncUtils.loopAsync(transitionHooks.length, function (index, next, done) {
	      _runTransitionHook2['default'](transitionHooks[index], location, function (result) {
	        if (result != null) {
	          done(result);
	        } else {
	          next();
	        }
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  }
	
	  var pendingLocation = undefined;
	
	  function transitionTo(nextLocation) {
	    if (location && locationsAreEqual(location, nextLocation)) return; // Nothing to do.
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted.
	
	      if (ok) {
	        // treat PUSH to current path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = createPath(location);
	          var nextPath = createPath(nextLocation);
	
	          if (nextPath === prevPath && _deepEqual2['default'](location.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (finishTransition(nextLocation) !== false) updateLocation(nextLocation);
	      } else if (location && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(location.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL.
	      }
	    });
	  }
	
	  function push(location) {
	    transitionTo(createLocation(location, _Actions.PUSH, createKey()));
	  }
	
	  function replace(location) {
	    transitionTo(createLocation(location, _Actions.REPLACE, createKey()));
	  }
	
	  function goBack() {
	    go(-1);
	  }
	
	  function goForward() {
	    go(1);
	  }
	
	  function createKey() {
	    return createRandomKey(keyLength);
	  }
	
	  function createPath(location) {
	    if (location == null || typeof location === 'string') return location;
	
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	
	    var result = pathname;
	
	    if (search) result += search;
	
	    if (hash) result += hash;
	
	    return result;
	  }
	
	  function createHref(location) {
	    return createPath(location);
	  }
	
	  function createLocation(location, action) {
	    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];
	
	    if (typeof action === 'object') {
	       false ? _warning2['default'](false, 'The state (2nd) argument to history.createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      location = _extends({}, location, { state: action });
	
	      action = key;
	      key = arguments[3] || createKey();
	    }
	
	    return _createLocation3['default'](location, action, key);
	  }
	
	  // deprecated
	  function setState(state) {
	    if (location) {
	      updateLocationState(location, state);
	      updateLocation(location);
	    } else {
	      updateLocationState(getCurrentLocation(), state);
	    }
	  }
	
	  function updateLocationState(location, state) {
	    location.state = _extends({}, location.state, state);
	    saveState(location.key, location.state);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (transitionHooks.indexOf(hook) === -1) transitionHooks.push(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    transitionHooks = transitionHooks.filter(function (item) {
	      return item !== hook;
	    });
	  }
	
	  // deprecated
	  function pushState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    push(_extends({ state: state }, path));
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    replace(_extends({ state: state }, path));
	  }
	
	  return {
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: createPath,
	    createHref: createHref,
	    createLocation: createLocation,
	
	    setState: _deprecate2['default'](setState, 'setState is deprecated; use location.key to save state instead'),
	    registerTransitionHook: _deprecate2['default'](registerTransitionHook, 'registerTransitionHook is deprecated; use listenBefore instead'),
	    unregisterTransitionHook: _deprecate2['default'](unregisterTransitionHook, 'unregisterTransitionHook is deprecated; use the callback returned from listenBefore instead'),
	    pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	    replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	  };
	}
	
	exports['default'] = createHistory;
	module.exports = exports['default'];

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(102);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ExecutionEnvironment = __webpack_require__(267);
	
	var _PathUtils = __webpack_require__(160);
	
	var _runTransitionHook = __webpack_require__(372);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(371);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var basename = options.basename;
	
	    var checkedBaseHref = false;
	
	    function checkBaseHref() {
	      if (checkedBaseHref) {
	        return;
	      }
	
	      // Automatically use the value of <base href> in HTML
	      // documents as basename if it's not explicitly given.
	      if (basename == null && _ExecutionEnvironment.canUseDOM) {
	        var base = document.getElementsByTagName('base')[0];
	        var baseHref = base && base.getAttribute('href');
	
	        if (baseHref != null) {
	          basename = baseHref;
	
	           false ? _warning2['default'](false, 'Automatically setting basename using <base href> is deprecated and will ' + 'be removed in the next major release. The semantics of <base href> are ' + 'subtly different from basename. Please pass the basename explicitly in ' + 'the options to createHistory') : undefined;
	        }
	      }
	
	      checkedBaseHref = true;
	    }
	
	    function addBasename(location) {
	      checkBaseHref();
	
	      if (basename && location.basename == null) {
	        if (location.pathname.indexOf(basename) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    }
	
	    function prependBasename(location) {
	      checkBaseHref();
	
	      if (!basename) return location;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var pname = location.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, location, {
	        pathname: pathname
	      });
	    }
	
	    // Override all read methods with basename-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addBasename(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addBasename(location));
	      });
	    }
	
	    // Override all write methods with basename-aware versions.
	    function push(location) {
	      history.push(prependBasename(location));
	    }
	
	    function replace(location) {
	      history.replace(prependBasename(location));
	    }
	
	    function createPath(location) {
	      return history.createPath(prependBasename(location));
	    }
	
	    function createHref(location) {
	      return history.createHref(prependBasename(location));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    }
	
	    // deprecated
	    function pushState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path));
	    }
	
	    // deprecated
	    function replaceState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useBasename;
	module.exports = exports['default'];

/***/ }),
/* 575 */
/***/ (function(module, exports) {

	/**
	 * Constants enumerating the HTTP status codes.
	 *
	 * All status codes defined in RFC1945 (HTTP/1.0, RFC2616 (HTTP/1.1),
	 * RFC2518 (WebDAV), RFC6585 (Additional HTTP Status Codes), and
	 * RFC7538 (Permanent Redirect) are supported.
	 *
	 * Based on the org.apache.commons.httpclient.HttpStatus Java API.
	 *
	 * Ported by Bryce Neal.
	 */
	
	var statusCodes = {};
	
	statusCodes[exports.ACCEPTED = 202] = "Accepted";
	statusCodes[exports.BAD_GATEWAY = 502] = "Bad Gateway";
	statusCodes[exports.BAD_REQUEST = 400] = "Bad Request";
	statusCodes[exports.CONFLICT = 409] = "Conflict";
	statusCodes[exports.CONTINUE = 100] = "Continue";
	statusCodes[exports.CREATED = 201] = "Created";
	statusCodes[exports.EXPECTATION_FAILED = 417] = "Expectation Failed";
	statusCodes[exports.FAILED_DEPENDENCY  = 424] = "Failed Dependency";
	statusCodes[exports.FORBIDDEN = 403] = "Forbidden";
	statusCodes[exports.GATEWAY_TIMEOUT = 504] = "Gateway Timeout";
	statusCodes[exports.GONE = 410] = "Gone";
	statusCodes[exports.HTTP_VERSION_NOT_SUPPORTED = 505] = "HTTP Version Not Supported";
	statusCodes[exports.INSUFFICIENT_SPACE_ON_RESOURCE = 419] = "Insufficient Space on Resource";
	statusCodes[exports.INSUFFICIENT_STORAGE = 507] = "Insufficient Storage";
	statusCodes[exports.INTERNAL_SERVER_ERROR = 500] = "Server Error";
	statusCodes[exports.LENGTH_REQUIRED = 411] = "Length Required";
	statusCodes[exports.LOCKED = 423] = "Locked";
	statusCodes[exports.METHOD_FAILURE = 420] = "Method Failure";
	statusCodes[exports.METHOD_NOT_ALLOWED = 405] = "Method Not Allowed";
	statusCodes[exports.MOVED_PERMANENTLY = 301] = "Moved Permanently";
	statusCodes[exports.MOVED_TEMPORARILY = 302] = "Moved Temporarily";
	statusCodes[exports.MULTI_STATUS = 207] = "Multi-Status";
	statusCodes[exports.MULTIPLE_CHOICES = 300] = "Multiple Choices";
	statusCodes[exports.NETWORK_AUTHENTICATION_REQUIRED = 511] = "Network Authentication Required";
	statusCodes[exports.NO_CONTENT = 204] = "No Content";
	statusCodes[exports.NON_AUTHORITATIVE_INFORMATION = 203] = "Non Authoritative Information";
	statusCodes[exports.NOT_ACCEPTABLE = 406] = "Not Acceptable";
	statusCodes[exports.NOT_FOUND = 404] = "Not Found";
	statusCodes[exports.NOT_IMPLEMENTED = 501] = "Not Implemented";
	statusCodes[exports.NOT_MODIFIED = 304] = "Not Modified";
	statusCodes[exports.OK = 200] = "OK";
	statusCodes[exports.PARTIAL_CONTENT = 206] = "Partial Content";
	statusCodes[exports.PAYMENT_REQUIRED = 402] = "Payment Required";
	statusCodes[exports.PERMANENT_REDIRECT = 308] = "Permanent Redirect";
	statusCodes[exports.PRECONDITION_FAILED = 412] = "Precondition Failed";
	statusCodes[exports.PRECONDITION_REQUIRED = 428] = "Precondition Required";
	statusCodes[exports.PROCESSING = 102] = "Processing";
	statusCodes[exports.PROXY_AUTHENTICATION_REQUIRED = 407] = "Proxy Authentication Required";
	statusCodes[exports.REQUEST_HEADER_FIELDS_TOO_LARGE = 431] = "Request Header Fields Too Large";
	statusCodes[exports.REQUEST_TIMEOUT = 408] = "Request Timeout";
	statusCodes[exports.REQUEST_TOO_LONG = 413] = "Request Entity Too Large";
	statusCodes[exports.REQUEST_URI_TOO_LONG = 414] = "Request-URI Too Long";
	statusCodes[exports.REQUESTED_RANGE_NOT_SATISFIABLE = 416] = "Requested Range Not Satisfiable";
	statusCodes[exports.RESET_CONTENT = 205] = "Reset Content";
	statusCodes[exports.SEE_OTHER = 303] = "See Other";
	statusCodes[exports.SERVICE_UNAVAILABLE = 503] = "Service Unavailable";
	statusCodes[exports.SWITCHING_PROTOCOLS = 101] = "Switching Protocols";
	statusCodes[exports.TEMPORARY_REDIRECT = 307] = "Temporary Redirect";
	statusCodes[exports.TOO_MANY_REQUESTS = 429] = "Too Many Requests";
	statusCodes[exports.UNAUTHORIZED = 401] = "Unauthorized";
	statusCodes[exports.UNPROCESSABLE_ENTITY = 422] = "Unprocessable Entity";
	statusCodes[exports.UNSUPPORTED_MEDIA_TYPE = 415] = "Unsupported Media Type";
	statusCodes[exports.USE_PROXY = 305] = "Use Proxy";
	
	exports.getStatusText = function(statusCode) {
	  if (statusCodes.hasOwnProperty(statusCode)) {
	    return statusCodes[statusCode];
	  } else {
	    throw new Error("Status code does not exist: " + statusCode);
	  }
	};


/***/ }),
/* 576 */
/***/ (function(module, exports) {

	
	var indexOf = [].indexOf;
	
	module.exports = function(arr, obj){
	  if (indexOf) return arr.indexOf(obj);
	  for (var i = 0; i < arr.length; ++i) {
	    if (arr[i] === obj) return i;
	  }
	  return -1;
	};

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	
	////////////////////////////////////////////////////////////////////////////////
	// Helpers
	
	// Merge objects
	//
	function assign(obj /*from1, from2, from3, ...*/) {
	  var sources = Array.prototype.slice.call(arguments, 1);
	
	  sources.forEach(function (source) {
	    if (!source) { return; }
	
	    Object.keys(source).forEach(function (key) {
	      obj[key] = source[key];
	    });
	  });
	
	  return obj;
	}
	
	function _class(obj) { return Object.prototype.toString.call(obj); }
	function isString(obj) { return _class(obj) === '[object String]'; }
	function isObject(obj) { return _class(obj) === '[object Object]'; }
	function isRegExp(obj) { return _class(obj) === '[object RegExp]'; }
	function isFunction(obj) { return _class(obj) === '[object Function]'; }
	
	
	function escapeRE(str) { return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&'); }
	
	////////////////////////////////////////////////////////////////////////////////
	
	
	var defaultOptions = {
	  fuzzyLink: true,
	  fuzzyEmail: true,
	  fuzzyIP: false
	};
	
	
	function isOptionsObj(obj) {
	  return Object.keys(obj || {}).reduce(function (acc, k) {
	    return acc || defaultOptions.hasOwnProperty(k);
	  }, false);
	}
	
	
	var defaultSchemas = {
	  'http:': {
	    validate: function (text, pos, self) {
	      var tail = text.slice(pos);
	
	      if (!self.re.http) {
	        // compile lazily, because "host"-containing variables can change on tlds update.
	        self.re.http =  new RegExp(
	          '^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i'
	        );
	      }
	      if (self.re.http.test(tail)) {
	        return tail.match(self.re.http)[0].length;
	      }
	      return 0;
	    }
	  },
	  'https:':  'http:',
	  'ftp:':    'http:',
	  '//':      {
	    validate: function (text, pos, self) {
	      var tail = text.slice(pos);
	
	      if (!self.re.no_http) {
	      // compile lazily, because "host"-containing variables can change on tlds update.
	        self.re.no_http =  new RegExp(
	          '^' +
	          self.re.src_auth +
	          // Don't allow single-level domains, because of false positives like '//test'
	          // with code comments
	          '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' +
	          self.re.src_port +
	          self.re.src_host_terminator +
	          self.re.src_path,
	
	          'i'
	        );
	      }
	
	      if (self.re.no_http.test(tail)) {
	        // should not be `://` & `///`, that protects from errors in protocol name
	        if (pos >= 3 && text[pos - 3] === ':') { return 0; }
	        if (pos >= 3 && text[pos - 3] === '/') { return 0; }
	        return tail.match(self.re.no_http)[0].length;
	      }
	      return 0;
	    }
	  },
	  'mailto:': {
	    validate: function (text, pos, self) {
	      var tail = text.slice(pos);
	
	      if (!self.re.mailto) {
	        self.re.mailto =  new RegExp(
	          '^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i'
	        );
	      }
	      if (self.re.mailto.test(tail)) {
	        return tail.match(self.re.mailto)[0].length;
	      }
	      return 0;
	    }
	  }
	};
	
	/*eslint-disable max-len*/
	
	// RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
	var tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
	
	// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
	var tlds_default = 'biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф'.split('|');
	
	/*eslint-enable max-len*/
	
	////////////////////////////////////////////////////////////////////////////////
	
	function resetScanCache(self) {
	  self.__index__ = -1;
	  self.__text_cache__   = '';
	}
	
	function createValidator(re) {
	  return function (text, pos) {
	    var tail = text.slice(pos);
	
	    if (re.test(tail)) {
	      return tail.match(re)[0].length;
	    }
	    return 0;
	  };
	}
	
	function createNormalizer() {
	  return function (match, self) {
	    self.normalize(match);
	  };
	}
	
	// Schemas compiler. Build regexps.
	//
	function compile(self) {
	
	  // Load & clone RE patterns.
	  var re = self.re = __webpack_require__(1365)(self.__opts__);
	
	  // Define dynamic patterns
	  var tlds = self.__tlds__.slice();
	
	  self.onCompile();
	
	  if (!self.__tlds_replaced__) {
	    tlds.push(tlds_2ch_src_re);
	  }
	  tlds.push(re.src_xn);
	
	  re.src_tlds = tlds.join('|');
	
	  function untpl(tpl) { return tpl.replace('%TLDS%', re.src_tlds); }
	
	  re.email_fuzzy      = RegExp(untpl(re.tpl_email_fuzzy), 'i');
	  re.link_fuzzy       = RegExp(untpl(re.tpl_link_fuzzy), 'i');
	  re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
	  re.host_fuzzy_test  = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
	
	  //
	  // Compile each schema
	  //
	
	  var aliases = [];
	
	  self.__compiled__ = {}; // Reset compiled data
	
	  function schemaError(name, val) {
	    throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
	  }
	
	  Object.keys(self.__schemas__).forEach(function (name) {
	    var val = self.__schemas__[name];
	
	    // skip disabled methods
	    if (val === null) { return; }
	
	    var compiled = { validate: null, link: null };
	
	    self.__compiled__[name] = compiled;
	
	    if (isObject(val)) {
	      if (isRegExp(val.validate)) {
	        compiled.validate = createValidator(val.validate);
	      } else if (isFunction(val.validate)) {
	        compiled.validate = val.validate;
	      } else {
	        schemaError(name, val);
	      }
	
	      if (isFunction(val.normalize)) {
	        compiled.normalize = val.normalize;
	      } else if (!val.normalize) {
	        compiled.normalize = createNormalizer();
	      } else {
	        schemaError(name, val);
	      }
	
	      return;
	    }
	
	    if (isString(val)) {
	      aliases.push(name);
	      return;
	    }
	
	    schemaError(name, val);
	  });
	
	  //
	  // Compile postponed aliases
	  //
	
	  aliases.forEach(function (alias) {
	    if (!self.__compiled__[self.__schemas__[alias]]) {
	      // Silently fail on missed schemas to avoid errons on disable.
	      // schemaError(alias, self.__schemas__[alias]);
	      return;
	    }
	
	    self.__compiled__[alias].validate =
	      self.__compiled__[self.__schemas__[alias]].validate;
	    self.__compiled__[alias].normalize =
	      self.__compiled__[self.__schemas__[alias]].normalize;
	  });
	
	  //
	  // Fake record for guessed links
	  //
	  self.__compiled__[''] = { validate: null, normalize: createNormalizer() };
	
	  //
	  // Build schema condition
	  //
	  var slist = Object.keys(self.__compiled__)
	                      .filter(function (name) {
	                        // Filter disabled & fake schemas
	                        return name.length > 0 && self.__compiled__[name];
	                      })
	                      .map(escapeRE)
	                      .join('|');
	  // (?!_) cause 1.5x slowdown
	  self.re.schema_test   = RegExp('(^|(?!_)(?:[><]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
	  self.re.schema_search = RegExp('(^|(?!_)(?:[><]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
	
	  self.re.pretest       = RegExp(
	                            '(' + self.re.schema_test.source + ')|' +
	                            '(' + self.re.host_fuzzy_test.source + ')|' +
	                            '@',
	                            'i');
	
	  //
	  // Cleanup
	  //
	
	  resetScanCache(self);
	}
	
	/**
	 * class Match
	 *
	 * Match result. Single element of array, returned by [[LinkifyIt#match]]
	 **/
	function Match(self, shift) {
	  var start = self.__index__,
	      end   = self.__last_index__,
	      text  = self.__text_cache__.slice(start, end);
	
	  /**
	   * Match#schema -> String
	   *
	   * Prefix (protocol) for matched string.
	   **/
	  this.schema    = self.__schema__.toLowerCase();
	  /**
	   * Match#index -> Number
	   *
	   * First position of matched string.
	   **/
	  this.index     = start + shift;
	  /**
	   * Match#lastIndex -> Number
	   *
	   * Next position after matched string.
	   **/
	  this.lastIndex = end + shift;
	  /**
	   * Match#raw -> String
	   *
	   * Matched string.
	   **/
	  this.raw       = text;
	  /**
	   * Match#text -> String
	   *
	   * Notmalized text of matched string.
	   **/
	  this.text      = text;
	  /**
	   * Match#url -> String
	   *
	   * Normalized url of matched string.
	   **/
	  this.url       = text;
	}
	
	function createMatch(self, shift) {
	  var match = new Match(self, shift);
	
	  self.__compiled__[match.schema].normalize(match, self);
	
	  return match;
	}
	
	
	/**
	 * class LinkifyIt
	 **/
	
	/**
	 * new LinkifyIt(schemas, options)
	 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
	 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
	 *
	 * Creates new linkifier instance with optional additional schemas.
	 * Can be called without `new` keyword for convenience.
	 *
	 * By default understands:
	 *
	 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
	 * - "fuzzy" links and emails (example.com, foo@bar.com).
	 *
	 * `schemas` is an object, where each key/value describes protocol/rule:
	 *
	 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
	 *   for example). `linkify-it` makes shure that prefix is not preceeded with
	 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
	 * - __value__ - rule to check tail after link prefix
	 *   - _String_ - just alias to existing rule
	 *   - _Object_
	 *     - _validate_ - validator function (should return matched length on success),
	 *       or `RegExp`.
	 *     - _normalize_ - optional function to normalize text & url of matched result
	 *       (for example, for @twitter mentions).
	 *
	 * `options`:
	 *
	 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
	 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
	 *   like version numbers. Default `false`.
	 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
	 *
	 **/
	function LinkifyIt(schemas, options) {
	  if (!(this instanceof LinkifyIt)) {
	    return new LinkifyIt(schemas, options);
	  }
	
	  if (!options) {
	    if (isOptionsObj(schemas)) {
	      options = schemas;
	      schemas = {};
	    }
	  }
	
	  this.__opts__           = assign({}, defaultOptions, options);
	
	  // Cache last tested result. Used to skip repeating steps on next `match` call.
	  this.__index__          = -1;
	  this.__last_index__     = -1; // Next scan position
	  this.__schema__         = '';
	  this.__text_cache__     = '';
	
	  this.__schemas__        = assign({}, defaultSchemas, schemas);
	  this.__compiled__       = {};
	
	  this.__tlds__           = tlds_default;
	  this.__tlds_replaced__  = false;
	
	  this.re = {};
	
	  compile(this);
	}
	
	
	/** chainable
	 * LinkifyIt#add(schema, definition)
	 * - schema (String): rule name (fixed pattern prefix)
	 * - definition (String|RegExp|Object): schema definition
	 *
	 * Add new rule definition. See constructor description for details.
	 **/
	LinkifyIt.prototype.add = function add(schema, definition) {
	  this.__schemas__[schema] = definition;
	  compile(this);
	  return this;
	};
	
	
	/** chainable
	 * LinkifyIt#set(options)
	 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
	 *
	 * Set recognition options for links without schema.
	 **/
	LinkifyIt.prototype.set = function set(options) {
	  this.__opts__ = assign(this.__opts__, options);
	  return this;
	};
	
	
	/**
	 * LinkifyIt#test(text) -> Boolean
	 *
	 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
	 **/
	LinkifyIt.prototype.test = function test(text) {
	  // Reset scan cache
	  this.__text_cache__ = text;
	  this.__index__      = -1;
	
	  if (!text.length) { return false; }
	
	  var m, ml, me, len, shift, next, re, tld_pos, at_pos;
	
	  // try to scan for link with schema - that's the most simple rule
	  if (this.re.schema_test.test(text)) {
	    re = this.re.schema_search;
	    re.lastIndex = 0;
	    while ((m = re.exec(text)) !== null) {
	      len = this.testSchemaAt(text, m[2], re.lastIndex);
	      if (len) {
	        this.__schema__     = m[2];
	        this.__index__      = m.index + m[1].length;
	        this.__last_index__ = m.index + m[0].length + len;
	        break;
	      }
	    }
	  }
	
	  if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
	    // guess schemaless links
	    tld_pos = text.search(this.re.host_fuzzy_test);
	    if (tld_pos >= 0) {
	      // if tld is located after found link - no need to check fuzzy pattern
	      if (this.__index__ < 0 || tld_pos < this.__index__) {
	        if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
	
	          shift = ml.index + ml[1].length;
	
	          if (this.__index__ < 0 || shift < this.__index__) {
	            this.__schema__     = '';
	            this.__index__      = shift;
	            this.__last_index__ = ml.index + ml[0].length;
	          }
	        }
	      }
	    }
	  }
	
	  if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
	    // guess schemaless emails
	    at_pos = text.indexOf('@');
	    if (at_pos >= 0) {
	      // We can't skip this check, because this cases are possible:
	      // 192.168.1.1@gmail.com, my.in@example.com
	      if ((me = text.match(this.re.email_fuzzy)) !== null) {
	
	        shift = me.index + me[1].length;
	        next  = me.index + me[0].length;
	
	        if (this.__index__ < 0 || shift < this.__index__ ||
	            (shift === this.__index__ && next > this.__last_index__)) {
	          this.__schema__     = 'mailto:';
	          this.__index__      = shift;
	          this.__last_index__ = next;
	        }
	      }
	    }
	  }
	
	  return this.__index__ >= 0;
	};
	
	
	/**
	 * LinkifyIt#pretest(text) -> Boolean
	 *
	 * Very quick check, that can give false positives. Returns true if link MAY BE
	 * can exists. Can be used for speed optimization, when you need to check that
	 * link NOT exists.
	 **/
	LinkifyIt.prototype.pretest = function pretest(text) {
	  return this.re.pretest.test(text);
	};
	
	
	/**
	 * LinkifyIt#testSchemaAt(text, name, position) -> Number
	 * - text (String): text to scan
	 * - name (String): rule (schema) name
	 * - position (Number): text offset to check from
	 *
	 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
	 * at given position. Returns length of found pattern (0 on fail).
	 **/
	LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
	  // If not supported schema check requested - terminate
	  if (!this.__compiled__[schema.toLowerCase()]) {
	    return 0;
	  }
	  return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
	};
	
	
	/**
	 * LinkifyIt#match(text) -> Array|null
	 *
	 * Returns array of found link descriptions or `null` on fail. We strongly
	 * recommend to use [[LinkifyIt#test]] first, for best speed.
	 *
	 * ##### Result match description
	 *
	 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
	 *   protocol-neutral  links.
	 * - __index__ - offset of matched text
	 * - __lastIndex__ - index of next char after mathch end
	 * - __raw__ - matched text
	 * - __text__ - normalized text
	 * - __url__ - link, generated from matched text
	 **/
	LinkifyIt.prototype.match = function match(text) {
	  var shift = 0, result = [];
	
	  // Try to take previous element from cache, if .test() called before
	  if (this.__index__ >= 0 && this.__text_cache__ === text) {
	    result.push(createMatch(this, shift));
	    shift = this.__last_index__;
	  }
	
	  // Cut head if cache was used
	  var tail = shift ? text.slice(shift) : text;
	
	  // Scan string until end reached
	  while (this.test(tail)) {
	    result.push(createMatch(this, shift));
	
	    tail = tail.slice(this.__last_index__);
	    shift += this.__last_index__;
	  }
	
	  if (result.length) {
	    return result;
	  }
	
	  return null;
	};
	
	
	/** chainable
	 * LinkifyIt#tlds(list [, keepOld]) -> this
	 * - list (Array): list of tlds
	 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
	 *
	 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
	 * to avoid false positives. By default this algorythm used:
	 *
	 * - hostname with any 2-letter root zones are ok.
	 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
	 *   are ok.
	 * - encoded (`xn--...`) root zones are ok.
	 *
	 * If list is replaced, then exact match for 2-chars root zones will be checked.
	 **/
	LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
	  list = Array.isArray(list) ? list : [ list ];
	
	  if (!keepOld) {
	    this.__tlds__ = list.slice();
	    this.__tlds_replaced__ = true;
	    compile(this);
	    return this;
	  }
	
	  this.__tlds__ = this.__tlds__.concat(list)
	                                  .sort()
	                                  .filter(function (el, idx, arr) {
	                                    return el !== arr[idx - 1];
	                                  })
	                                  .reverse();
	
	  compile(this);
	  return this;
	};
	
	/**
	 * LinkifyIt#normalize(match)
	 *
	 * Default normalizer (if schema does not define it's own).
	 **/
	LinkifyIt.prototype.normalize = function normalize(match) {
	
	  // Do minimal possible changes by default. Need to collect feedback prior
	  // to move forward https://github.com/markdown-it/linkify-it/issues/1
	
	  if (!match.schema) { match.url = 'http://' + match.url; }
	
	  if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) {
	    match.url = 'mailto:' + match.url;
	  }
	};
	
	
	/**
	 * LinkifyIt#onCompile()
	 *
	 * Override to modify basic RegExp-s.
	 **/
	LinkifyIt.prototype.onCompile = function onCompile() {
	};
	
	
	module.exports = LinkifyIt;


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(1413),
	    mapCacheDelete = __webpack_require__(1414),
	    mapCacheGet = __webpack_require__(1415),
	    mapCacheHas = __webpack_require__(1416),
	    mapCacheSet = __webpack_require__(1417);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 579 */
/***/ (function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(584);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(374),
	    arrayIncludes = __webpack_require__(376),
	    arrayIncludesWith = __webpack_require__(377),
	    arrayMap = __webpack_require__(378),
	    baseUnary = __webpack_require__(379),
	    cacheHas = __webpack_require__(380);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of methods like `_.difference` without support
	 * for excluding multiple arrays or iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      isCommon = true,
	      length = array.length,
	      result = [],
	      valuesLength = values.length;
	
	  if (!length) {
	    return result;
	  }
	  if (iteratee) {
	    values = arrayMap(values, baseUnary(iteratee));
	  }
	  if (comparator) {
	    includes = arrayIncludesWith;
	    isCommon = false;
	  }
	  else if (values.length >= LARGE_ARRAY_SIZE) {
	    includes = cacheHas;
	    isCommon = false;
	    values = new SetCache(values);
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee == null ? value : iteratee(value);
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === computed) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (!includes(values, computed, comparator)) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(1376),
	    isFlattenable = __webpack_require__(1403);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(374),
	    arrayIncludes = __webpack_require__(376),
	    arrayIncludesWith = __webpack_require__(377),
	    cacheHas = __webpack_require__(380),
	    createSet = __webpack_require__(1393),
	    setToArray = __webpack_require__(587);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      length = array.length,
	      isCommon = true,
	      result = [],
	      seen = result;
	
	  if (comparator) {
	    isCommon = false;
	    includes = arrayIncludesWith;
	  }
	  else if (length >= LARGE_ARRAY_SIZE) {
	    var set = iteratee ? null : createSet(array);
	    if (set) {
	      return setToArray(set);
	    }
	    isCommon = false;
	    includes = cacheHas;
	    seen = new SetCache;
	  }
	  else {
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (!includes(seen, computed, comparator)) {
	      if (seen !== result) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseUniq;


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(272);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),
/* 585 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 586 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 587 */
/***/ (function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ }),
/* 588 */
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(1381),
	    isObjectLike = __webpack_require__(219);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(270),
	    isObject = __webpack_require__(218);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 591 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 592 */
/***/ (function(module, exports) {

	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(581),
	    baseRest = __webpack_require__(185),
	    isArrayLikeObject = __webpack_require__(275);
	
	/**
	 * Creates an array excluding all given values using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * **Note:** Unlike `_.pull`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...*} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @see _.difference, _.xor
	 * @example
	 *
	 * _.without([2, 1, 2, 3], 1, 2);
	 * // => [3]
	 */
	var without = baseRest(function(array, values) {
	  return isArrayLikeObject(array)
	    ? baseDifference(array, values)
	    : [];
	});
	
	module.exports = without;


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*global define:false */
	/**
	 * Copyright 2012-2017 Craig Campbell
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * Mousetrap is a simple keyboard shortcut library for Javascript with
	 * no external dependencies
	 *
	 * @version 1.6.1
	 * @url craig.is/killing/mice
	 */
	(function(window, document, undefined) {
	
	    // Check if mousetrap is used inside browser, if not, return
	    if (!window) {
	        return;
	    }
	
	    /**
	     * mapping of special keycodes to their corresponding keys
	     *
	     * everything in this dictionary cannot use keypress events
	     * so it has to be here to map to the correct keycodes for
	     * keyup/keydown events
	     *
	     * @type {Object}
	     */
	    var _MAP = {
	        8: 'backspace',
	        9: 'tab',
	        13: 'enter',
	        16: 'shift',
	        17: 'ctrl',
	        18: 'alt',
	        20: 'capslock',
	        27: 'esc',
	        32: 'space',
	        33: 'pageup',
	        34: 'pagedown',
	        35: 'end',
	        36: 'home',
	        37: 'left',
	        38: 'up',
	        39: 'right',
	        40: 'down',
	        45: 'ins',
	        46: 'del',
	        91: 'meta',
	        93: 'meta',
	        224: 'meta'
	    };
	
	    /**
	     * mapping for special characters so they can support
	     *
	     * this dictionary is only used incase you want to bind a
	     * keyup or keydown event to one of these keys
	     *
	     * @type {Object}
	     */
	    var _KEYCODE_MAP = {
	        106: '*',
	        107: '+',
	        109: '-',
	        110: '.',
	        111 : '/',
	        186: ';',
	        187: '=',
	        188: ',',
	        189: '-',
	        190: '.',
	        191: '/',
	        192: '`',
	        219: '[',
	        220: '\\',
	        221: ']',
	        222: '\''
	    };
	
	    /**
	     * this is a mapping of keys that require shift on a US keypad
	     * back to the non shift equivelents
	     *
	     * this is so you can use keyup events with these keys
	     *
	     * note that this will only work reliably on US keyboards
	     *
	     * @type {Object}
	     */
	    var _SHIFT_MAP = {
	        '~': '`',
	        '!': '1',
	        '@': '2',
	        '#': '3',
	        '$': '4',
	        '%': '5',
	        '^': '6',
	        '&': '7',
	        '*': '8',
	        '(': '9',
	        ')': '0',
	        '_': '-',
	        '+': '=',
	        ':': ';',
	        '\"': '\'',
	        '<': ',',
	        '>': '.',
	        '?': '/',
	        '|': '\\'
	    };
	
	    /**
	     * this is a list of special strings you can use to map
	     * to modifier keys when you specify your keyboard shortcuts
	     *
	     * @type {Object}
	     */
	    var _SPECIAL_ALIASES = {
	        'option': 'alt',
	        'command': 'meta',
	        'return': 'enter',
	        'escape': 'esc',
	        'plus': '+',
	        'mod': /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? 'meta' : 'ctrl'
	    };
	
	    /**
	     * variable to store the flipped version of _MAP from above
	     * needed to check if we should use keypress or not when no action
	     * is specified
	     *
	     * @type {Object|undefined}
	     */
	    var _REVERSE_MAP;
	
	    /**
	     * loop through the f keys, f1 to f19 and add them to the map
	     * programatically
	     */
	    for (var i = 1; i < 20; ++i) {
	        _MAP[111 + i] = 'f' + i;
	    }
	
	    /**
	     * loop through to map numbers on the numeric keypad
	     */
	    for (i = 0; i <= 9; ++i) {
	
	        // This needs to use a string cause otherwise since 0 is falsey
	        // mousetrap will never fire for numpad 0 pressed as part of a keydown
	        // event.
	        //
	        // @see https://github.com/ccampbell/mousetrap/pull/258
	        _MAP[i + 96] = i.toString();
	    }
	
	    /**
	     * cross browser add event method
	     *
	     * @param {Element|HTMLDocument} object
	     * @param {string} type
	     * @param {Function} callback
	     * @returns void
	     */
	    function _addEvent(object, type, callback) {
	        if (object.addEventListener) {
	            object.addEventListener(type, callback, false);
	            return;
	        }
	
	        object.attachEvent('on' + type, callback);
	    }
	
	    /**
	     * takes the event and returns the key character
	     *
	     * @param {Event} e
	     * @return {string}
	     */
	    function _characterFromEvent(e) {
	
	        // for keypress events we should return the character as is
	        if (e.type == 'keypress') {
	            var character = String.fromCharCode(e.which);
	
	            // if the shift key is not pressed then it is safe to assume
	            // that we want the character to be lowercase.  this means if
	            // you accidentally have caps lock on then your key bindings
	            // will continue to work
	            //
	            // the only side effect that might not be desired is if you
	            // bind something like 'A' cause you want to trigger an
	            // event when capital A is pressed caps lock will no longer
	            // trigger the event.  shift+a will though.
	            if (!e.shiftKey) {
	                character = character.toLowerCase();
	            }
	
	            return character;
	        }
	
	        // for non keypress events the special maps are needed
	        if (_MAP[e.which]) {
	            return _MAP[e.which];
	        }
	
	        if (_KEYCODE_MAP[e.which]) {
	            return _KEYCODE_MAP[e.which];
	        }
	
	        // if it is not in the special map
	
	        // with keydown and keyup events the character seems to always
	        // come in as an uppercase character whether you are pressing shift
	        // or not.  we should make sure it is always lowercase for comparisons
	        return String.fromCharCode(e.which).toLowerCase();
	    }
	
	    /**
	     * checks if two arrays are equal
	     *
	     * @param {Array} modifiers1
	     * @param {Array} modifiers2
	     * @returns {boolean}
	     */
	    function _modifiersMatch(modifiers1, modifiers2) {
	        return modifiers1.sort().join(',') === modifiers2.sort().join(',');
	    }
	
	    /**
	     * takes a key event and figures out what the modifiers are
	     *
	     * @param {Event} e
	     * @returns {Array}
	     */
	    function _eventModifiers(e) {
	        var modifiers = [];
	
	        if (e.shiftKey) {
	            modifiers.push('shift');
	        }
	
	        if (e.altKey) {
	            modifiers.push('alt');
	        }
	
	        if (e.ctrlKey) {
	            modifiers.push('ctrl');
	        }
	
	        if (e.metaKey) {
	            modifiers.push('meta');
	        }
	
	        return modifiers;
	    }
	
	    /**
	     * prevents default for this event
	     *
	     * @param {Event} e
	     * @returns void
	     */
	    function _preventDefault(e) {
	        if (e.preventDefault) {
	            e.preventDefault();
	            return;
	        }
	
	        e.returnValue = false;
	    }
	
	    /**
	     * stops propogation for this event
	     *
	     * @param {Event} e
	     * @returns void
	     */
	    function _stopPropagation(e) {
	        if (e.stopPropagation) {
	            e.stopPropagation();
	            return;
	        }
	
	        e.cancelBubble = true;
	    }
	
	    /**
	     * determines if the keycode specified is a modifier key or not
	     *
	     * @param {string} key
	     * @returns {boolean}
	     */
	    function _isModifier(key) {
	        return key == 'shift' || key == 'ctrl' || key == 'alt' || key == 'meta';
	    }
	
	    /**
	     * reverses the map lookup so that we can look for specific keys
	     * to see what can and can't use keypress
	     *
	     * @return {Object}
	     */
	    function _getReverseMap() {
	        if (!_REVERSE_MAP) {
	            _REVERSE_MAP = {};
	            for (var key in _MAP) {
	
	                // pull out the numeric keypad from here cause keypress should
	                // be able to detect the keys from the character
	                if (key > 95 && key < 112) {
	                    continue;
	                }
	
	                if (_MAP.hasOwnProperty(key)) {
	                    _REVERSE_MAP[_MAP[key]] = key;
	                }
	            }
	        }
	        return _REVERSE_MAP;
	    }
	
	    /**
	     * picks the best action based on the key combination
	     *
	     * @param {string} key - character for key
	     * @param {Array} modifiers
	     * @param {string=} action passed in
	     */
	    function _pickBestAction(key, modifiers, action) {
	
	        // if no action was picked in we should try to pick the one
	        // that we think would work best for this key
	        if (!action) {
	            action = _getReverseMap()[key] ? 'keydown' : 'keypress';
	        }
	
	        // modifier keys don't work as expected with keypress,
	        // switch to keydown
	        if (action == 'keypress' && modifiers.length) {
	            action = 'keydown';
	        }
	
	        return action;
	    }
	
	    /**
	     * Converts from a string key combination to an array
	     *
	     * @param  {string} combination like "command+shift+l"
	     * @return {Array}
	     */
	    function _keysFromString(combination) {
	        if (combination === '+') {
	            return ['+'];
	        }
	
	        combination = combination.replace(/\+{2}/g, '+plus');
	        return combination.split('+');
	    }
	
	    /**
	     * Gets info for a specific key combination
	     *
	     * @param  {string} combination key combination ("command+s" or "a" or "*")
	     * @param  {string=} action
	     * @returns {Object}
	     */
	    function _getKeyInfo(combination, action) {
	        var keys;
	        var key;
	        var i;
	        var modifiers = [];
	
	        // take the keys from this pattern and figure out what the actual
	        // pattern is all about
	        keys = _keysFromString(combination);
	
	        for (i = 0; i < keys.length; ++i) {
	            key = keys[i];
	
	            // normalize key names
	            if (_SPECIAL_ALIASES[key]) {
	                key = _SPECIAL_ALIASES[key];
	            }
	
	            // if this is not a keypress event then we should
	            // be smart about using shift keys
	            // this will only work for US keyboards however
	            if (action && action != 'keypress' && _SHIFT_MAP[key]) {
	                key = _SHIFT_MAP[key];
	                modifiers.push('shift');
	            }
	
	            // if this key is a modifier then add it to the list of modifiers
	            if (_isModifier(key)) {
	                modifiers.push(key);
	            }
	        }
	
	        // depending on what the key combination is
	        // we will try to pick the best event for it
	        action = _pickBestAction(key, modifiers, action);
	
	        return {
	            key: key,
	            modifiers: modifiers,
	            action: action
	        };
	    }
	
	    function _belongsTo(element, ancestor) {
	        if (element === null || element === document) {
	            return false;
	        }
	
	        if (element === ancestor) {
	            return true;
	        }
	
	        return _belongsTo(element.parentNode, ancestor);
	    }
	
	    function Mousetrap(targetElement) {
	        var self = this;
	
	        targetElement = targetElement || document;
	
	        if (!(self instanceof Mousetrap)) {
	            return new Mousetrap(targetElement);
	        }
	
	        /**
	         * element to attach key events to
	         *
	         * @type {Element}
	         */
	        self.target = targetElement;
	
	        /**
	         * a list of all the callbacks setup via Mousetrap.bind()
	         *
	         * @type {Object}
	         */
	        self._callbacks = {};
	
	        /**
	         * direct map of string combinations to callbacks used for trigger()
	         *
	         * @type {Object}
	         */
	        self._directMap = {};
	
	        /**
	         * keeps track of what level each sequence is at since multiple
	         * sequences can start out with the same sequence
	         *
	         * @type {Object}
	         */
	        var _sequenceLevels = {};
	
	        /**
	         * variable to store the setTimeout call
	         *
	         * @type {null|number}
	         */
	        var _resetTimer;
	
	        /**
	         * temporary state where we will ignore the next keyup
	         *
	         * @type {boolean|string}
	         */
	        var _ignoreNextKeyup = false;
	
	        /**
	         * temporary state where we will ignore the next keypress
	         *
	         * @type {boolean}
	         */
	        var _ignoreNextKeypress = false;
	
	        /**
	         * are we currently inside of a sequence?
	         * type of action ("keyup" or "keydown" or "keypress") or false
	         *
	         * @type {boolean|string}
	         */
	        var _nextExpectedAction = false;
	
	        /**
	         * resets all sequence counters except for the ones passed in
	         *
	         * @param {Object} doNotReset
	         * @returns void
	         */
	        function _resetSequences(doNotReset) {
	            doNotReset = doNotReset || {};
	
	            var activeSequences = false,
	                key;
	
	            for (key in _sequenceLevels) {
	                if (doNotReset[key]) {
	                    activeSequences = true;
	                    continue;
	                }
	                _sequenceLevels[key] = 0;
	            }
	
	            if (!activeSequences) {
	                _nextExpectedAction = false;
	            }
	        }
	
	        /**
	         * finds all callbacks that match based on the keycode, modifiers,
	         * and action
	         *
	         * @param {string} character
	         * @param {Array} modifiers
	         * @param {Event|Object} e
	         * @param {string=} sequenceName - name of the sequence we are looking for
	         * @param {string=} combination
	         * @param {number=} level
	         * @returns {Array}
	         */
	        function _getMatches(character, modifiers, e, sequenceName, combination, level) {
	            var i;
	            var callback;
	            var matches = [];
	            var action = e.type;
	
	            // if there are no events related to this keycode
	            if (!self._callbacks[character]) {
	                return [];
	            }
	
	            // if a modifier key is coming up on its own we should allow it
	            if (action == 'keyup' && _isModifier(character)) {
	                modifiers = [character];
	            }
	
	            // loop through all callbacks for the key that was pressed
	            // and see if any of them match
	            for (i = 0; i < self._callbacks[character].length; ++i) {
	                callback = self._callbacks[character][i];
	
	                // if a sequence name is not specified, but this is a sequence at
	                // the wrong level then move onto the next match
	                if (!sequenceName && callback.seq && _sequenceLevels[callback.seq] != callback.level) {
	                    continue;
	                }
	
	                // if the action we are looking for doesn't match the action we got
	                // then we should keep going
	                if (action != callback.action) {
	                    continue;
	                }
	
	                // if this is a keypress event and the meta key and control key
	                // are not pressed that means that we need to only look at the
	                // character, otherwise check the modifiers as well
	                //
	                // chrome will not fire a keypress if meta or control is down
	                // safari will fire a keypress if meta or meta+shift is down
	                // firefox will fire a keypress if meta or control is down
	                if ((action == 'keypress' && !e.metaKey && !e.ctrlKey) || _modifiersMatch(modifiers, callback.modifiers)) {
	
	                    // when you bind a combination or sequence a second time it
	                    // should overwrite the first one.  if a sequenceName or
	                    // combination is specified in this call it does just that
	                    //
	                    // @todo make deleting its own method?
	                    var deleteCombo = !sequenceName && callback.combo == combination;
	                    var deleteSequence = sequenceName && callback.seq == sequenceName && callback.level == level;
	                    if (deleteCombo || deleteSequence) {
	                        self._callbacks[character].splice(i, 1);
	                    }
	
	                    matches.push(callback);
	                }
	            }
	
	            return matches;
	        }
	
	        /**
	         * actually calls the callback function
	         *
	         * if your callback function returns false this will use the jquery
	         * convention - prevent default and stop propogation on the event
	         *
	         * @param {Function} callback
	         * @param {Event} e
	         * @returns void
	         */
	        function _fireCallback(callback, e, combo, sequence) {
	
	            // if this event should not happen stop here
	            if (self.stopCallback(e, e.target || e.srcElement, combo, sequence)) {
	                return;
	            }
	
	            if (callback(e, combo) === false) {
	                _preventDefault(e);
	                _stopPropagation(e);
	            }
	        }
	
	        /**
	         * handles a character key event
	         *
	         * @param {string} character
	         * @param {Array} modifiers
	         * @param {Event} e
	         * @returns void
	         */
	        self._handleKey = function(character, modifiers, e) {
	            var callbacks = _getMatches(character, modifiers, e);
	            var i;
	            var doNotReset = {};
	            var maxLevel = 0;
	            var processedSequenceCallback = false;
	
	            // Calculate the maxLevel for sequences so we can only execute the longest callback sequence
	            for (i = 0; i < callbacks.length; ++i) {
	                if (callbacks[i].seq) {
	                    maxLevel = Math.max(maxLevel, callbacks[i].level);
	                }
	            }
	
	            // loop through matching callbacks for this key event
	            for (i = 0; i < callbacks.length; ++i) {
	
	                // fire for all sequence callbacks
	                // this is because if for example you have multiple sequences
	                // bound such as "g i" and "g t" they both need to fire the
	                // callback for matching g cause otherwise you can only ever
	                // match the first one
	                if (callbacks[i].seq) {
	
	                    // only fire callbacks for the maxLevel to prevent
	                    // subsequences from also firing
	                    //
	                    // for example 'a option b' should not cause 'option b' to fire
	                    // even though 'option b' is part of the other sequence
	                    //
	                    // any sequences that do not match here will be discarded
	                    // below by the _resetSequences call
	                    if (callbacks[i].level != maxLevel) {
	                        continue;
	                    }
	
	                    processedSequenceCallback = true;
	
	                    // keep a list of which sequences were matches for later
	                    doNotReset[callbacks[i].seq] = 1;
	                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo, callbacks[i].seq);
	                    continue;
	                }
	
	                // if there were no sequence matches but we are still here
	                // that means this is a regular match so we should fire that
	                if (!processedSequenceCallback) {
	                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo);
	                }
	            }
	
	            // if the key you pressed matches the type of sequence without
	            // being a modifier (ie "keyup" or "keypress") then we should
	            // reset all sequences that were not matched by this event
	            //
	            // this is so, for example, if you have the sequence "h a t" and you
	            // type "h e a r t" it does not match.  in this case the "e" will
	            // cause the sequence to reset
	            //
	            // modifier keys are ignored because you can have a sequence
	            // that contains modifiers such as "enter ctrl+space" and in most
	            // cases the modifier key will be pressed before the next key
	            //
	            // also if you have a sequence such as "ctrl+b a" then pressing the
	            // "b" key will trigger a "keypress" and a "keydown"
	            //
	            // the "keydown" is expected when there is a modifier, but the
	            // "keypress" ends up matching the _nextExpectedAction since it occurs
	            // after and that causes the sequence to reset
	            //
	            // we ignore keypresses in a sequence that directly follow a keydown
	            // for the same character
	            var ignoreThisKeypress = e.type == 'keypress' && _ignoreNextKeypress;
	            if (e.type == _nextExpectedAction && !_isModifier(character) && !ignoreThisKeypress) {
	                _resetSequences(doNotReset);
	            }
	
	            _ignoreNextKeypress = processedSequenceCallback && e.type == 'keydown';
	        };
	
	        /**
	         * handles a keydown event
	         *
	         * @param {Event} e
	         * @returns void
	         */
	        function _handleKeyEvent(e) {
	
	            // normalize e.which for key events
	            // @see http://stackoverflow.com/questions/4285627/javascript-keycode-vs-charcode-utter-confusion
	            if (typeof e.which !== 'number') {
	                e.which = e.keyCode;
	            }
	
	            var character = _characterFromEvent(e);
	
	            // no character found then stop
	            if (!character) {
	                return;
	            }
	
	            // need to use === for the character check because the character can be 0
	            if (e.type == 'keyup' && _ignoreNextKeyup === character) {
	                _ignoreNextKeyup = false;
	                return;
	            }
	
	            self.handleKey(character, _eventModifiers(e), e);
	        }
	
	        /**
	         * called to set a 1 second timeout on the specified sequence
	         *
	         * this is so after each key press in the sequence you have 1 second
	         * to press the next key before you have to start over
	         *
	         * @returns void
	         */
	        function _resetSequenceTimer() {
	            clearTimeout(_resetTimer);
	            _resetTimer = setTimeout(_resetSequences, 1000);
	        }
	
	        /**
	         * binds a key sequence to an event
	         *
	         * @param {string} combo - combo specified in bind call
	         * @param {Array} keys
	         * @param {Function} callback
	         * @param {string=} action
	         * @returns void
	         */
	        function _bindSequence(combo, keys, callback, action) {
	
	            // start off by adding a sequence level record for this combination
	            // and setting the level to 0
	            _sequenceLevels[combo] = 0;
	
	            /**
	             * callback to increase the sequence level for this sequence and reset
	             * all other sequences that were active
	             *
	             * @param {string} nextAction
	             * @returns {Function}
	             */
	            function _increaseSequence(nextAction) {
	                return function() {
	                    _nextExpectedAction = nextAction;
	                    ++_sequenceLevels[combo];
	                    _resetSequenceTimer();
	                };
	            }
	
	            /**
	             * wraps the specified callback inside of another function in order
	             * to reset all sequence counters as soon as this sequence is done
	             *
	             * @param {Event} e
	             * @returns void
	             */
	            function _callbackAndReset(e) {
	                _fireCallback(callback, e, combo);
	
	                // we should ignore the next key up if the action is key down
	                // or keypress.  this is so if you finish a sequence and
	                // release the key the final key will not trigger a keyup
	                if (action !== 'keyup') {
	                    _ignoreNextKeyup = _characterFromEvent(e);
	                }
	
	                // weird race condition if a sequence ends with the key
	                // another sequence begins with
	                setTimeout(_resetSequences, 10);
	            }
	
	            // loop through keys one at a time and bind the appropriate callback
	            // function.  for any key leading up to the final one it should
	            // increase the sequence. after the final, it should reset all sequences
	            //
	            // if an action is specified in the original bind call then that will
	            // be used throughout.  otherwise we will pass the action that the
	            // next key in the sequence should match.  this allows a sequence
	            // to mix and match keypress and keydown events depending on which
	            // ones are better suited to the key provided
	            for (var i = 0; i < keys.length; ++i) {
	                var isFinal = i + 1 === keys.length;
	                var wrappedCallback = isFinal ? _callbackAndReset : _increaseSequence(action || _getKeyInfo(keys[i + 1]).action);
	                _bindSingle(keys[i], wrappedCallback, action, combo, i);
	            }
	        }
	
	        /**
	         * binds a single keyboard combination
	         *
	         * @param {string} combination
	         * @param {Function} callback
	         * @param {string=} action
	         * @param {string=} sequenceName - name of sequence if part of sequence
	         * @param {number=} level - what part of the sequence the command is
	         * @returns void
	         */
	        function _bindSingle(combination, callback, action, sequenceName, level) {
	
	            // store a direct mapped reference for use with Mousetrap.trigger
	            self._directMap[combination + ':' + action] = callback;
	
	            // make sure multiple spaces in a row become a single space
	            combination = combination.replace(/\s+/g, ' ');
	
	            var sequence = combination.split(' ');
	            var info;
	
	            // if this pattern is a sequence of keys then run through this method
	            // to reprocess each pattern one key at a time
	            if (sequence.length > 1) {
	                _bindSequence(combination, sequence, callback, action);
	                return;
	            }
	
	            info = _getKeyInfo(combination, action);
	
	            // make sure to initialize array if this is the first time
	            // a callback is added for this key
	            self._callbacks[info.key] = self._callbacks[info.key] || [];
	
	            // remove an existing match if there is one
	            _getMatches(info.key, info.modifiers, {type: info.action}, sequenceName, combination, level);
	
	            // add this call back to the array
	            // if it is a sequence put it at the beginning
	            // if not put it at the end
	            //
	            // this is important because the way these are processed expects
	            // the sequence ones to come first
	            self._callbacks[info.key][sequenceName ? 'unshift' : 'push']({
	                callback: callback,
	                modifiers: info.modifiers,
	                action: info.action,
	                seq: sequenceName,
	                level: level,
	                combo: combination
	            });
	        }
	
	        /**
	         * binds multiple combinations to the same callback
	         *
	         * @param {Array} combinations
	         * @param {Function} callback
	         * @param {string|undefined} action
	         * @returns void
	         */
	        self._bindMultiple = function(combinations, callback, action) {
	            for (var i = 0; i < combinations.length; ++i) {
	                _bindSingle(combinations[i], callback, action);
	            }
	        };
	
	        // start!
	        _addEvent(targetElement, 'keypress', _handleKeyEvent);
	        _addEvent(targetElement, 'keydown', _handleKeyEvent);
	        _addEvent(targetElement, 'keyup', _handleKeyEvent);
	    }
	
	    /**
	     * binds an event to mousetrap
	     *
	     * can be a single key, a combination of keys separated with +,
	     * an array of keys, or a sequence of keys separated by spaces
	     *
	     * be sure to list the modifier keys first to make sure that the
	     * correct key ends up getting bound (the last key in the pattern)
	     *
	     * @param {string|Array} keys
	     * @param {Function} callback
	     * @param {string=} action - 'keypress', 'keydown', or 'keyup'
	     * @returns void
	     */
	    Mousetrap.prototype.bind = function(keys, callback, action) {
	        var self = this;
	        keys = keys instanceof Array ? keys : [keys];
	        self._bindMultiple.call(self, keys, callback, action);
	        return self;
	    };
	
	    /**
	     * unbinds an event to mousetrap
	     *
	     * the unbinding sets the callback function of the specified key combo
	     * to an empty function and deletes the corresponding key in the
	     * _directMap dict.
	     *
	     * TODO: actually remove this from the _callbacks dictionary instead
	     * of binding an empty function
	     *
	     * the keycombo+action has to be exactly the same as
	     * it was defined in the bind method
	     *
	     * @param {string|Array} keys
	     * @param {string} action
	     * @returns void
	     */
	    Mousetrap.prototype.unbind = function(keys, action) {
	        var self = this;
	        return self.bind.call(self, keys, function() {}, action);
	    };
	
	    /**
	     * triggers an event that has already been bound
	     *
	     * @param {string} keys
	     * @param {string=} action
	     * @returns void
	     */
	    Mousetrap.prototype.trigger = function(keys, action) {
	        var self = this;
	        if (self._directMap[keys + ':' + action]) {
	            self._directMap[keys + ':' + action]({}, keys);
	        }
	        return self;
	    };
	
	    /**
	     * resets the library back to its initial state.  this is useful
	     * if you want to clear out the current keyboard shortcuts and bind
	     * new ones - for example if you switch to another page
	     *
	     * @returns void
	     */
	    Mousetrap.prototype.reset = function() {
	        var self = this;
	        self._callbacks = {};
	        self._directMap = {};
	        return self;
	    };
	
	    /**
	     * should we stop this event before firing off callbacks
	     *
	     * @param {Event} e
	     * @param {Element} element
	     * @return {boolean}
	     */
	    Mousetrap.prototype.stopCallback = function(e, element) {
	        var self = this;
	
	        // if the element has the class "mousetrap" then no need to stop
	        if ((' ' + element.className + ' ').indexOf(' mousetrap ') > -1) {
	            return false;
	        }
	
	        if (_belongsTo(element, self.target)) {
	            return false;
	        }
	
	        // stop for input, select, and textarea
	        return element.tagName == 'INPUT' || element.tagName == 'SELECT' || element.tagName == 'TEXTAREA' || element.isContentEditable;
	    };
	
	    /**
	     * exposes _handleKey publicly so it can be overwritten by extensions
	     */
	    Mousetrap.prototype.handleKey = function() {
	        var self = this;
	        return self._handleKey.apply(self, arguments);
	    };
	
	    /**
	     * allow custom key mappings
	     */
	    Mousetrap.addKeycodes = function(object) {
	        for (var key in object) {
	            if (object.hasOwnProperty(key)) {
	                _MAP[key] = object[key];
	            }
	        }
	        _REVERSE_MAP = null;
	    };
	
	    /**
	     * Init the global mousetrap functions
	     *
	     * This method is needed to allow the global mousetrap functions to work
	     * now that mousetrap is a constructor function.
	     */
	    Mousetrap.init = function() {
	        var documentMousetrap = Mousetrap(document);
	        for (var method in documentMousetrap) {
	            if (method.charAt(0) !== '_') {
	                Mousetrap[method] = (function(method) {
	                    return function() {
	                        return documentMousetrap[method].apply(documentMousetrap, arguments);
	                    };
	                } (method));
	            }
	        }
	    };
	
	    Mousetrap.init();
	
	    // expose mousetrap to the global object
	    window.Mousetrap = Mousetrap;
	
	    // expose as a common js module
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = Mousetrap;
	    }
	
	    // expose mousetrap as an AMD module
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	            return Mousetrap;
	        }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	}) (typeof window !== 'undefined' ? window : null, typeof  window !== 'undefined' ? document : null);


/***/ }),
/* 595 */
/***/ (function(module, exports) {

	/**
	 * Parses an URI
	 *
	 * @author Steven Levithan <stevenlevithan.com> (MIT license)
	 * @api private
	 */
	
	var re = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
	
	var parts = [
	    'source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'
	];
	
	module.exports = function parseuri(str) {
	    var src = str,
	        b = str.indexOf('['),
	        e = str.indexOf(']');
	
	    if (b != -1 && e != -1) {
	        str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
	    }
	
	    var m = re.exec(str || ''),
	        uri = {},
	        i = 14;
	
	    while (i--) {
	        uri[parts[i]] = m[i] || '';
	    }
	
	    if (b != -1 && e != -1) {
	        uri.source = src;
	        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
	        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
	        uri.ipv6uri = true;
	    }
	
	    return uri;
	};


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(1450);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isSafari = exports.isFirefox = undefined;
	
	var _memoize = __webpack_require__(1440);
	
	var _memoize2 = _interopRequireDefault(_memoize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isFirefox = exports.isFirefox = (0, _memoize2.default)(function () {
	  return (/firefox/i.test(navigator.userAgent)
	  );
	});
	var isSafari = exports.isSafari = (0, _memoize2.default)(function () {
	  return Boolean(window.safari);
	});

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unpackBackendForEs5Users = exports.createChildContext = exports.CHILD_CONTEXT_TYPES = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = DragDropContext;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dndCore = __webpack_require__(1027);
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _hoistNonReactStatics = __webpack_require__(161);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _checkDecoratorArguments = __webpack_require__(276);
	
	var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CHILD_CONTEXT_TYPES = exports.CHILD_CONTEXT_TYPES = {
	  dragDropManager: _react.PropTypes.object.isRequired
	};
	
	var createChildContext = exports.createChildContext = function createChildContext(backend, context) {
	  return {
	    dragDropManager: new _dndCore.DragDropManager(backend, context)
	  };
	};
	
	var unpackBackendForEs5Users = exports.unpackBackendForEs5Users = function unpackBackendForEs5Users(backendOrModule) {
	  // Auto-detect ES6 default export for people still using ES5
	  var backend = backendOrModule;
	  if ((typeof backend === 'undefined' ? 'undefined' : _typeof(backend)) === 'object' && typeof backend.default === 'function') {
	    backend = backend.default;
	  }
	  (0, _invariant2.default)(typeof backend === 'function', 'Expected the backend to be a function or an ES6 module exporting a default function. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-drop-context.html');
	  return backend;
	};
	
	function DragDropContext(backendOrModule) {
	  _checkDecoratorArguments2.default.apply(undefined, ['DragDropContext', 'backend'].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line prefer-rest-params
	
	  var backend = unpackBackendForEs5Users(backendOrModule);
	  var childContext = createChildContext(backend);
	
	  return function decorateContext(DecoratedComponent) {
	    var _class, _temp;
	
	    var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
	
	    var DragDropContextContainer = (_temp = _class = function (_Component) {
	      _inherits(DragDropContextContainer, _Component);
	
	      function DragDropContextContainer() {
	        _classCallCheck(this, DragDropContextContainer);
	
	        return _possibleConstructorReturn(this, (DragDropContextContainer.__proto__ || Object.getPrototypeOf(DragDropContextContainer)).apply(this, arguments));
	      }
	
	      _createClass(DragDropContextContainer, [{
	        key: 'getDecoratedComponentInstance',
	        value: function getDecoratedComponentInstance() {
	          (0, _invariant2.default)(this.child, 'In order to access an instance of the decorated component it can ' + 'not be a stateless component.');
	          return this.child;
	        }
	      }, {
	        key: 'getManager',
	        value: function getManager() {
	          return childContext.dragDropManager;
	        }
	      }, {
	        key: 'getChildContext',
	        value: function getChildContext() {
	          return childContext;
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var _this2 = this;
	
	          return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, {
	            ref: function ref(child) {
	              return _this2.child = child;
	            }
	          }));
	        }
	      }]);
	
	      return DragDropContextContainer;
	    }(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = 'DragDropContext(' + displayName + ')', _class.childContextTypes = CHILD_CONTEXT_TYPES, _temp);
	
	
	    return (0, _hoistNonReactStatics2.default)(DragDropContextContainer, DecoratedComponent);
	  };
	}

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = areOptionsEqual;
	
	var _shallowEqual = __webpack_require__(384);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function areOptionsEqual(nextOptions, currentOptions) {
	  if (currentOptions === nextOptions) {
	    return true;
	  }
	
	  return currentOptions !== null && nextOptions !== null && (0, _shallowEqual2.default)(currentOptions, nextOptions);
	}

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = decorateHandler;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _disposables = __webpack_require__(1020);
	
	var _isPlainObject = __webpack_require__(118);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _hoistNonReactStatics = __webpack_require__(161);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _shallowEqual = __webpack_require__(384);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _shallowEqualScalar = __webpack_require__(602);
	
	var _shallowEqualScalar2 = _interopRequireDefault(_shallowEqualScalar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function decorateHandler(_ref) {
	  var _class, _temp;
	
	  var DecoratedComponent = _ref.DecoratedComponent,
	      createHandler = _ref.createHandler,
	      createMonitor = _ref.createMonitor,
	      createConnector = _ref.createConnector,
	      registerHandler = _ref.registerHandler,
	      containerDisplayName = _ref.containerDisplayName,
	      getType = _ref.getType,
	      collect = _ref.collect,
	      options = _ref.options;
	  var _options$arePropsEqua = options.arePropsEqual,
	      arePropsEqual = _options$arePropsEqua === undefined ? _shallowEqualScalar2.default : _options$arePropsEqua;
	
	  var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
	
	  var DragDropContainer = (_temp = _class = function (_Component) {
	    _inherits(DragDropContainer, _Component);
	
	    _createClass(DragDropContainer, [{
	      key: 'getHandlerId',
	      value: function getHandlerId() {
	        return this.handlerId;
	      }
	    }, {
	      key: 'getDecoratedComponentInstance',
	      value: function getDecoratedComponentInstance() {
	        return this.decoratedComponentInstance;
	      }
	    }, {
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps, nextState) {
	        return !arePropsEqual(nextProps, this.props) || !(0, _shallowEqual2.default)(nextState, this.state);
	      }
	    }]);
	
	    function DragDropContainer(props, context) {
	      _classCallCheck(this, DragDropContainer);
	
	      var _this = _possibleConstructorReturn(this, (DragDropContainer.__proto__ || Object.getPrototypeOf(DragDropContainer)).call(this, props, context));
	
	      _this.handleChange = _this.handleChange.bind(_this);
	      _this.handleChildRef = _this.handleChildRef.bind(_this);
	
	      (0, _invariant2.default)(_typeof(_this.context.dragDropManager) === 'object', 'Could not find the drag and drop manager in the context of %s. ' + 'Make sure to wrap the top-level component of your app with DragDropContext. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);
	
	      _this.manager = _this.context.dragDropManager;
	      _this.handlerMonitor = createMonitor(_this.manager);
	      _this.handlerConnector = createConnector(_this.manager.getBackend());
	      _this.handler = createHandler(_this.handlerMonitor);
	
	      _this.disposable = new _disposables.SerialDisposable();
	      _this.receiveProps(props);
	      _this.state = _this.getCurrentState();
	      _this.dispose();
	      return _this;
	    }
	
	    _createClass(DragDropContainer, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        this.isCurrentlyMounted = true;
	        this.disposable = new _disposables.SerialDisposable();
	        this.currentType = null;
	        this.receiveProps(this.props);
	        this.handleChange();
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (!arePropsEqual(nextProps, this.props)) {
	          this.receiveProps(nextProps);
	          this.handleChange();
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        this.dispose();
	        this.isCurrentlyMounted = false;
	      }
	    }, {
	      key: 'receiveProps',
	      value: function receiveProps(props) {
	        this.handler.receiveProps(props);
	        this.receiveType(getType(props));
	      }
	    }, {
	      key: 'receiveType',
	      value: function receiveType(type) {
	        if (type === this.currentType) {
	          return;
	        }
	
	        this.currentType = type;
	
	        var _registerHandler = registerHandler(type, this.handler, this.manager),
	            handlerId = _registerHandler.handlerId,
	            unregister = _registerHandler.unregister;
	
	        this.handlerId = handlerId;
	        this.handlerMonitor.receiveHandlerId(handlerId);
	        this.handlerConnector.receiveHandlerId(handlerId);
	
	        var globalMonitor = this.manager.getMonitor();
	        var unsubscribe = globalMonitor.subscribeToStateChange(this.handleChange, { handlerIds: [handlerId] });
	
	        this.disposable.setDisposable(new _disposables.CompositeDisposable(new _disposables.Disposable(unsubscribe), new _disposables.Disposable(unregister)));
	      }
	    }, {
	      key: 'handleChange',
	      value: function handleChange() {
	        if (!this.isCurrentlyMounted) {
	          return;
	        }
	
	        var nextState = this.getCurrentState();
	        if (!(0, _shallowEqual2.default)(nextState, this.state)) {
	          this.setState(nextState);
	        }
	      }
	    }, {
	      key: 'dispose',
	      value: function dispose() {
	        this.disposable.dispose();
	        this.handlerConnector.receiveHandlerId(null);
	      }
	    }, {
	      key: 'handleChildRef',
	      value: function handleChildRef(component) {
	        this.decoratedComponentInstance = component;
	        this.handler.receiveComponent(component);
	      }
	    }, {
	      key: 'getCurrentState',
	      value: function getCurrentState() {
	        var nextState = collect(this.handlerConnector.hooks, this.handlerMonitor);
	
	        if (false) {
	          (0, _invariant2.default)((0, _isPlainObject2.default)(nextState), 'Expected `collect` specified as the second argument to ' + '%s for %s to return a plain object of props to inject. ' + 'Instead, received %s.', containerDisplayName, displayName, nextState);
	        }
	
	        return nextState;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, this.state, {
	          ref: this.handleChildRef
	        }));
	      }
	    }]);
	
	    return DragDropContainer;
	  }(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = containerDisplayName + '(' + displayName + ')', _class.contextTypes = {
	    dragDropManager: _react.PropTypes.object.isRequired
	  }, _temp);
	
	
	  return (0, _hoistNonReactStatics2.default)(DragDropContainer, DecoratedComponent);
	}

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	       value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isValidType;
	
	var _isArray = __webpack_require__(162);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidType(type, allowArray) {
	       return typeof type === 'string' || (typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'symbol' || allowArray && (0, _isArray2.default)(type) && type.every(function (t) {
	              return isValidType(t, false);
	       });
	}

/***/ }),
/* 602 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = shallowEqualScalar;
	function shallowEqualScalar(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i += 1) {
	    if (!hasOwn.call(objB, keysA[i])) {
	      return false;
	    }
	
	    var valA = objA[keysA[i]];
	    var valB = objB[keysA[i]];
	
	    if (valA !== valB || (typeof valA === 'undefined' ? 'undefined' : _typeof(valA)) === 'object' || (typeof valB === 'undefined' ? 'undefined' : _typeof(valB)) === 'object') {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = wrapConnectorHooks;
	
	var _react = __webpack_require__(1);
	
	var _cloneWithRef = __webpack_require__(1473);
	
	var _cloneWithRef2 = _interopRequireDefault(_cloneWithRef);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function throwIfCompositeComponentElement(element) {
	  // Custom components can no longer be wrapped directly in React DnD 2.0
	  // so that we don't need to depend on findDOMNode() from react-dom.
	  if (typeof element.type === 'string') {
	    return;
	  }
	
	  var displayName = element.type.displayName || element.type.name || 'the component';
	
	  throw new Error('Only native element nodes can now be passed to React DnD connectors.' + ('You can either wrap ' + displayName + ' into a <div>, or turn it into a ') + 'drag source or a drop target itself.');
	}
	
	function wrapHookToRecognizeElement(hook) {
	  return function () {
	    var elementOrNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	    // When passed a node, call the hook straight away.
	    if (!(0, _react.isValidElement)(elementOrNode)) {
	      var node = elementOrNode;
	      hook(node, options);
	      return undefined;
	    }
	
	    // If passed a ReactElement, clone it and attach this function as a ref.
	    // This helps us achieve a neat API where user doesn't even know that refs
	    // are being used under the hood.
	    var element = elementOrNode;
	    throwIfCompositeComponentElement(element);
	
	    // When no options are passed, use the hook directly
	    var ref = options ? function (node) {
	      return hook(node, options);
	    } : hook;
	
	    return (0, _cloneWithRef2.default)(element, ref);
	  };
	}
	
	function wrapConnectorHooks(hooks) {
	  var wrappedHooks = {};
	
	  Object.keys(hooks).forEach(function (key) {
	    var hook = hooks[key];
	    var wrappedHook = wrapHookToRecognizeElement(hook);
	    wrappedHooks[key] = function () {
	      return wrappedHook;
	    };
	  });
	
	  return wrappedHooks;
	}

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
	    PropTypes = __webpack_require__(2),
	    withSideEffect = __webpack_require__(1573);
	
	function reducePropsToState(propsList) {
	  var innermostProps = propsList[propsList.length - 1];
	  if (innermostProps) {
	    return innermostProps.title;
	  }
	}
	
	function handleStateChangeOnClient(title) {
	  var nextTitle = title || '';
	  if (nextTitle !== document.title) {
	    document.title = nextTitle;
	  }
	}
	
	function DocumentTitle() {}
	DocumentTitle.prototype = Object.create(React.Component.prototype);
	
	DocumentTitle.displayName = 'DocumentTitle';
	DocumentTitle.propTypes = {
	  title: PropTypes.string.isRequired
	};
	
	DocumentTitle.prototype.render = function() {
	  if (this.props.children) {
	    return React.Children.only(this.props.children);
	  } else {
	    return null;
	  }
	};
	
	module.exports = withSideEffect(
	  reducePropsToState,
	  handleStateChangeOnClient
	)(DocumentTitle);


/***/ }),
/* 605 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(163);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(188);
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactInstrumentation = __webpack_require__(95);
	
	var quoteAttributeValueForBrowser = __webpack_require__(1535);
	var warning = __webpack_require__(16);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	
	};
	
	module.exports = DOMPropertyOperations;

/***/ }),
/* 608 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(20);
	
	var LinkedValueUtils = __webpack_require__(390);
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactUpdates = __webpack_require__(103);
	
	var warning = __webpack_require__(16);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ }),
/* 610 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ }),
/* 611 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var invariant = __webpack_require__(10);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(1495);
	
	var containsNode = __webpack_require__(368);
	var focusNode = __webpack_require__(564);
	var getActiveElement = __webpack_require__(265);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var DOMLazyTree = __webpack_require__(187);
	var DOMProperty = __webpack_require__(188);
	var React = __webpack_require__(191);
	var ReactBrowserEventEmitter = __webpack_require__(277);
	var ReactCurrentOwner = __webpack_require__(120);
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactDOMContainerInfo = __webpack_require__(1489);
	var ReactDOMFeatureFlags = __webpack_require__(1491);
	var ReactFeatureFlags = __webpack_require__(611);
	var ReactInstanceMap = __webpack_require__(223);
	var ReactInstrumentation = __webpack_require__(95);
	var ReactMarkupChecksum = __webpack_require__(1505);
	var ReactReconciler = __webpack_require__(189);
	var ReactUpdateQueue = __webpack_require__(393);
	var ReactUpdates = __webpack_require__(103);
	
	var emptyObject = __webpack_require__(216);
	var instantiateReactComponent = __webpack_require__(621);
	var invariant = __webpack_require__(10);
	var setInnerHTML = __webpack_require__(281);
	var shouldUpdateReactComponent = __webpack_require__(399);
	var warning = __webpack_require__(16);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, { child: nextElement });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var React = __webpack_require__(191);
	
	var invariant = __webpack_require__(10);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ }),
/* 616 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ }),
/* 618 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(615);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(64);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21),
	    _assign = __webpack_require__(20);
	
	var ReactCompositeComponent = __webpack_require__(1486);
	var ReactEmptyComponent = __webpack_require__(610);
	var ReactHostComponent = __webpack_require__(612);
	
	var getNextDebugID = __webpack_require__(1587);
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(16);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + 'it\'s defined in.';
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ }),
/* 622 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(64);
	var escapeTextContentForBrowser = __webpack_require__(280);
	var setInnerHTML = __webpack_require__(281);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var ReactCurrentOwner = __webpack_require__(120);
	var REACT_ELEMENT_TYPE = __webpack_require__(1501);
	
	var getIteratorFn = __webpack_require__(1532);
	var invariant = __webpack_require__(10);
	var KeyEscapeUtils = __webpack_require__(389);
	var warning = __webpack_require__(16);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = connectAdvanced;
	
	var _hoistNonReactStatics = __webpack_require__(161);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _Subscription = __webpack_require__(1548);
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	var _PropTypes = __webpack_require__(401);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var hotReloadingVersion = 0;
	var dummyState = {};
	function noop() {}
	function makeSelectorStateful(sourceSelector, store) {
	  // wrap the selector in an object that tracks its results between runs.
	  var selector = {
	    run: function runComponentSelector(props) {
	      try {
	        var nextProps = sourceSelector(store.getState(), props);
	        if (nextProps !== selector.props || selector.error) {
	          selector.shouldComponentUpdate = true;
	          selector.props = nextProps;
	          selector.error = null;
	        }
	      } catch (error) {
	        selector.shouldComponentUpdate = true;
	        selector.error = error;
	      }
	    }
	  };
	
	  return selector;
	}
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory) {
	  var _contextTypes, _childContextTypes;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$getDisplayName = _ref.getDisplayName,
	      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
	    return 'ConnectAdvanced(' + name + ')';
	  } : _ref$getDisplayName,
	      _ref$methodName = _ref.methodName,
	      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
	      _ref$renderCountProp = _ref.renderCountProp,
	      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
	      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
	      _ref$storeKey = _ref.storeKey,
	      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
	      _ref$withRef = _ref.withRef,
	      withRef = _ref$withRef === undefined ? false : _ref$withRef,
	      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);
	
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _PropTypes.storeShape, _contextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _childContextTypes);
	
	  return function wrapWithConnect(WrappedComponent) {
	    (0, _invariant2.default)(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	
	    var displayName = getDisplayName(wrappedComponentName);
	
	    var selectorFactoryOptions = _extends({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = props[storeKey] || context[storeKey];
	        _this.propsMode = Boolean(props[storeKey]);
	        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
	
	        (0, _invariant2.default)(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));
	
	        _this.initSelector();
	        _this.initSubscription();
	        return _this;
	      }
	
	      Connect.prototype.getChildContext = function getChildContext() {
	        var _ref2;
	
	        // If this component received store from props, its subscription should be transparent
	        // to any descendants receiving store+subscription from context; it passes along
	        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
	        // Connect to control ordering of notifications to flow top-down.
	        var subscription = this.propsMode ? null : this.subscription;
	        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return;
	
	        // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        this.subscription = null;
	        this.notifyNestedSubs = noop;
	        this.store = null;
	        this.selector.run = noop;
	        this.selector.shouldComponentUpdate = false;
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2.default)(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
	        return this.wrappedInstance;
	      };
	
	      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      Connect.prototype.initSelector = function initSelector() {
	        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
	        this.selector = makeSelectorStateful(sourceSelector, this.store);
	        this.selector.run(this.props);
	      };
	
	      Connect.prototype.initSubscription = function initSubscription() {
	        if (!shouldHandleStateChanges) return;
	
	        // parentSub's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
	        this.subscription = new _Subscription2.default(this.store, parentSub, this.onStateChange.bind(this));
	
	        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
	        // the middle of the notification loop, where `this.subscription` will then be null. An
	        // extra null check every change can be avoided by copying the method onto `this` and then
	        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
	        // listeners logic is changed to not call listeners that have been unsubscribed in the
	        // middle of the notification loop.
	        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
	      };
	
	      Connect.prototype.onStateChange = function onStateChange() {
	        this.selector.run(this.props);
	
	        if (!this.selector.shouldComponentUpdate) {
	          this.notifyNestedSubs();
	        } else {
	          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
	          this.setState(dummyState);
	        }
	      };
	
	      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
	        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
	        // needs to notify nested subs. Once called, it unimplements itself until further state
	        // changes occur. Doing it this way vs having a permanent `componentDidMount` that does
	        // a boolean check every time avoids an extra method call most of the time, resulting
	        // in some perf boost.
	        this.componentDidUpdate = undefined;
	        this.notifyNestedSubs();
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      Connect.prototype.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
	        // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	        var withExtras = _extends({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
	        return withExtras;
	      };
	
	      Connect.prototype.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	    Connect.propTypes = contextTypes;
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector();
	
	          if (this.subscription) this.subscription.tryUnsubscribe();
	          this.initSubscription();
	          if (shouldHandleStateChanges) this.subscription.trySubscribe();
	        }
	      };
	    }
	
	    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
	  };
	}

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = __webpack_require__(627);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	}
	
	// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	}
	
	// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    };
	
	    // allow detectFactoryAndVerify to get ownProps
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject2.default)(props, displayName, methodName);
	
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifyPlainObject;
	
	var _isPlainObject = __webpack_require__(118);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(282);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject2.default)(value)) {
	    (0, _warning2.default)(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
	  }
	}

/***/ }),
/* 628 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * This action type will be dispatched by the history actions below.
	 * If you're writing a middleware to watch for navigation events, be sure to
	 * look for actions of this type.
	 */
	var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';
	
	function updateLocation(method) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return {
	      type: CALL_HISTORY_METHOD,
	      payload: { method: method, args: args }
	    };
	  };
	}
	
	/**
	 * These actions correspond to the history API.
	 * The associated routerMiddleware will capture these events before they get to
	 * your reducer and reissue them as the matching function on your history.
	 */
	var push = exports.push = updateLocation('push');
	var replace = exports.replace = updateLocation('replace');
	var go = exports.go = updateLocation('go');
	var goBack = exports.goBack = updateLocation('goBack');
	var goForward = exports.goForward = updateLocation('goForward');
	
	var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 629 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.routerReducer = routerReducer;
	/**
	 * This action type will be dispatched when your history
	 * receives a location change.
	 */
	var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
	
	var initialState = {
	  locationBeforeTransitions: null
	};
	
	/**
	 * This reducer will update the state with the most recent location history
	 * has transitioned to. This may not be in sync with the router, particularly
	 * if you have asynchronously-loaded routes, so reading from and relying on
	 * this state is discouraged.
	 */
	function routerReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      type = _ref.type,
	      payload = _ref.payload;
	
	  if (type === LOCATION_CHANGE) {
	    return _extends({}, state, { locationBeforeTransitions: payload });
	  }
	
	  return state;
	}

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(46);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(403);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var bool = _React$PropTypes.bool;
	var object = _React$PropTypes.object;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	var oneOfType = _React$PropTypes.oneOfType;
	
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function createLocationDescriptor(to, _ref) {
	  var query = _ref.query;
	  var hash = _ref.hash;
	  var state = _ref.state;
	
	  if (query || hash || state) {
	    return { pathname: to, query: query, hash: hash, state: state };
	  }
	
	  return to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 *
	 * Links may pass along location state and/or query string parameters
	 * in the state/query props, respectively.
	 *
	 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
	 */
	var Link = _react2.default.createClass({
	  displayName: 'Link',
	
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: oneOfType([string, object]),
	    query: object,
	    hash: string,
	    state: object,
	    activeStyle: object,
	    activeClassName: string,
	    onlyActiveOnIndex: bool.isRequired,
	    onClick: func,
	    target: string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    !this.context.router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    var _props = this.props;
	    var to = _props.to;
	    var query = _props.query;
	    var hash = _props.hash;
	    var state = _props.state;
	
	    var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	
	    this.context.router.push(location);
	  },
	  render: function render() {
	    var _props2 = this.props;
	    var to = _props2.to;
	    var query = _props2.query;
	    var hash = _props2.hash;
	    var state = _props2.state;
	    var activeClassName = _props2.activeClassName;
	    var activeStyle = _props2.activeStyle;
	    var onlyActiveOnIndex = _props2.onlyActiveOnIndex;
	
	    var props = _objectWithoutProperties(_props2, ['to', 'query', 'hash', 'state', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	     false ? (0, _routerWarning2.default)(!(query || hash || state), 'the `query`, `hash`, and `state` props on `<Link>` are deprecated, use `<Link to={{ pathname, query, hash, state }}/>. http://tiny.cc/router-isActivedeprecated') : void 0;
	
	    // Ignore if rendered outside the context of router, simplifies unit testing.
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (to == null) {
	        return _react2.default.createElement('a', props);
	      }
	
	      var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	      props.href = router.createHref(location);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(location, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(133);
	
	var _PatternUtils = __webpack_require__(190);
	
	var _InternalPropTypes = __webpack_require__(164);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	
	var Redirect = _react2.default.createClass({
	  displayName: 'Redirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location;
	        var params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: string,
	    from: string, // Alias for path
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.createRoutingHistory = createRoutingHistory;
	
	var _deprecateObjectProperties = __webpack_require__(284);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createRouterObject(history, transitionManager) {
	  return _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	}
	
	// deprecated
	function createRoutingHistory(history, transitionManager) {
	  history = _extends({}, history, transitionManager);
	
	  if (false) {
	    history = (0, _deprecateObjectProperties2.default)(history, '`props.history` and `context.history` are deprecated. Please use `context.router`. http://tiny.cc/router-contextchanges');
	  }
	
	  return history;
	}

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(268);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(574);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(1362);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useRoutes` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  history.__v2_compatible__ = true;
	  return history;
	}
	module.exports = exports['default'];

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	};
	
	var _useRouterHistory = __webpack_require__(636);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	module.exports = exports['default'];

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = makeStateWithLocation;
	
	var _deprecateObjectProperties = __webpack_require__(284);
	
	var _routerWarning = __webpack_require__(46);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeStateWithLocation(state, location) {
	  if (false) {
	    var stateWithLocation = _extends({}, state);
	
	    // I don't use deprecateObjectProperties here because I want to keep the
	    // same code path between development and production, in that we just
	    // assign extra properties to the copy of the state object in both cases.
	
	    var _loop = function _loop(prop) {
	      if (!Object.prototype.hasOwnProperty.call(location, prop)) {
	        return 'continue';
	      }
	
	      Object.defineProperty(stateWithLocation, prop, {
	        get: function get() {
	          process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, 'Accessing location properties directly from the first argument to `getComponent`, `getComponents`, `getChildRoutes`, and `getIndexRoute` is deprecated. That argument is now the router state (`nextState` or `partialNextState`) rather than the location. To access the location, use `nextState.location` or `partialNextState.location`.') : void 0;
	          return location[prop];
	        }
	      });
	    };
	
	    for (var prop in location) {
	      var _ret = _loop(prop);
	
	      if (_ret === 'continue') continue;
	    }
	
	    return stateWithLocation;
	  }
	
	  return _extends({}, state, location);
	}
	module.exports = exports['default'];

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(268);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(574);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    history.__v2_compatible__ = true;
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.nameShape = undefined;
	exports.transitionTimeout = transitionTimeout;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  active: _propTypes2.default.string
	}), _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  enterActive: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  leaveActive: _propTypes2.default.string,
	  appear: _propTypes2.default.string,
	  appearActive: _propTypes2.default.string
	})]);

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(193);
	
	var ReactCurrentOwner = __webpack_require__(120);
	
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(16);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty)
	  // Strip regex characters so we can use it for regex
	  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  // Remove hasOwnProperty from the template to make it generic
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs
	};
	
	module.exports = ReactComponentTreeHook;

/***/ }),
/* 639 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.componentFromStreamWithConfig = undefined;
	
	var _react = __webpack_require__(1);
	
	var _changeEmitter = __webpack_require__(497);
	
	var _symbolObservable = __webpack_require__(409);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	var _setObservableConfig = __webpack_require__(286);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var componentFromStreamWithConfig = exports.componentFromStreamWithConfig = function componentFromStreamWithConfig(config) {
	  return function (propsToVdom) {
	    return function (_Component) {
	      _inherits(ComponentFromStream, _Component);
	
	      function ComponentFromStream() {
	        var _config$fromESObserva;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ComponentFromStream);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { vdom: null }, _this.propsEmitter = (0, _changeEmitter.createChangeEmitter)(), _this.props$ = config.fromESObservable((_config$fromESObserva = {
	          subscribe: function subscribe(observer) {
	            var unsubscribe = _this.propsEmitter.listen(function (props) {
	              return observer.next(props);
	            });
	            return { unsubscribe: unsubscribe };
	          }
	        }, _config$fromESObserva[_symbolObservable2.default] = function () {
	          return this;
	        }, _config$fromESObserva)), _this.vdom$ = config.toESObservable(propsToVdom(_this.props$)), _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      // Stream of props
	
	
	      // Stream of vdom
	
	
	      ComponentFromStream.prototype.componentWillMount = function componentWillMount() {
	        var _this2 = this;
	
	        // Subscribe to child prop changes so we know when to re-render
	        this.subscription = this.vdom$.subscribe({
	          next: function next(vdom) {
	            _this2.setState({ vdom: vdom });
	          }
	        });
	        this.propsEmitter.emit(this.props);
	      };
	
	      ComponentFromStream.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        // Receive new props from the owner
	        this.propsEmitter.emit(nextProps);
	      };
	
	      ComponentFromStream.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	        return nextState.vdom !== this.state.vdom;
	      };
	
	      ComponentFromStream.prototype.componentWillUnmount = function componentWillUnmount() {
	        // Clean-up subscription before un-mounting
	        this.subscription.unsubscribe();
	      };
	
	      ComponentFromStream.prototype.render = function render() {
	        return this.state.vdom;
	      };
	
	      return ComponentFromStream;
	    }(_react.Component);
	  };
	};
	
	var componentFromStream = componentFromStreamWithConfig(_setObservableConfig.config);
	
	exports.default = componentFromStream;

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createEagerElementUtil = __webpack_require__(645);
	
	var _createEagerElementUtil2 = _interopRequireDefault(_createEagerElementUtil);
	
	var _isReferentiallyTransparentFunctionComponent = __webpack_require__(643);
	
	var _isReferentiallyTransparentFunctionComponent2 = _interopRequireDefault(_isReferentiallyTransparentFunctionComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createEagerElement = function createEagerElement(type, props, children) {
	  var isReferentiallyTransparent = (0, _isReferentiallyTransparentFunctionComponent2.default)(type);
	  /* eslint-disable */
	  var hasKey = props && props.hasOwnProperty('key');
	  /* eslint-enable */
	  return (0, _createEagerElementUtil2.default)(hasKey, isReferentiallyTransparent, type, props, children);
	};
	
	exports.default = createEagerElement;

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isClassComponent = __webpack_require__(408);
	
	var _isClassComponent2 = _interopRequireDefault(_isClassComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isReferentiallyTransparentFunctionComponent = function isReferentiallyTransparentFunctionComponent(Component) {
	  return Boolean(typeof Component === 'function' && !(0, _isClassComponent2.default)(Component) && !Component.defaultProps && !Component.contextTypes && !Component.propTypes);
	};
	
	exports.default = isReferentiallyTransparentFunctionComponent;

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shouldUpdate = __webpack_require__(411);
	
	var _shouldUpdate2 = _interopRequireDefault(_shouldUpdate);
	
	var _shallowEqual = __webpack_require__(287);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _createHelper = __webpack_require__(30);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _pick = __webpack_require__(413);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onlyUpdateForKeys = function onlyUpdateForKeys(propKeys) {
	  return (0, _shouldUpdate2.default)(function (props, nextProps) {
	    return !(0, _shallowEqual2.default)((0, _pick2.default)(nextProps, propKeys), (0, _pick2.default)(props, propKeys));
	  });
	};
	
	exports.default = (0, _createHelper2.default)(onlyUpdateForKeys, 'onlyUpdateForKeys');

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createEagerElementUtil = function createEagerElementUtil(hasKey, isReferentiallyTransparent, type, props, children) {
	  if (!hasKey && isReferentiallyTransparent) {
	    if (children) {
	      return type(_extends({}, props, { children: children }));
	    }
	    return type(props);
	  }
	
	  var Component = type;
	
	  if (children) {
	    return _react2.default.createElement(
	      Component,
	      props,
	      children
	    );
	  }
	
	  return _react2.default.createElement(Component, props);
	};
	
	exports.default = createEagerElementUtil;

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.untouch = exports.touch = exports.swapArrayValues = exports.submitFailed = exports.stopSubmit = exports.stopAsyncValidation = exports.startSubmit = exports.startAsyncValidation = exports.reset = exports.removeArrayValue = exports.initialize = exports.focus = exports.destroy = exports.change = exports.blur = exports.autofill = exports.addArrayValue = undefined;
	
	var _actionTypes = __webpack_require__(414);
	
	var addArrayValue = exports.addArrayValue = function addArrayValue(path, value, index, fields) {
	  return { type: _actionTypes.ADD_ARRAY_VALUE, path: path, value: value, index: index, fields: fields };
	};
	
	var autofill = exports.autofill = function autofill(field, value) {
	  return { type: _actionTypes.AUTOFILL, field: field, value: value };
	};
	
	var blur = exports.blur = function blur(field, value) {
	  return { type: _actionTypes.BLUR, field: field, value: value };
	};
	
	var change = exports.change = function change(field, value) {
	  return { type: _actionTypes.CHANGE, field: field, value: value };
	};
	
	var destroy = exports.destroy = function destroy() {
	  return { type: _actionTypes.DESTROY };
	};
	
	var focus = exports.focus = function focus(field) {
	  return { type: _actionTypes.FOCUS, field: field };
	};
	
	var initialize = exports.initialize = function initialize(data, fields) {
	  var overwriteValues = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (!Array.isArray(fields)) {
	    throw new Error('must provide fields array to initialize() action creator');
	  }
	  return { type: _actionTypes.INITIALIZE, data: data, fields: fields, overwriteValues: overwriteValues };
	};
	
	var removeArrayValue = exports.removeArrayValue = function removeArrayValue(path, index) {
	  return { type: _actionTypes.REMOVE_ARRAY_VALUE, path: path, index: index };
	};
	
	var reset = exports.reset = function reset() {
	  return { type: _actionTypes.RESET };
	};
	
	var startAsyncValidation = exports.startAsyncValidation = function startAsyncValidation(field) {
	  return { type: _actionTypes.START_ASYNC_VALIDATION, field: field };
	};
	
	var startSubmit = exports.startSubmit = function startSubmit() {
	  return { type: _actionTypes.START_SUBMIT };
	};
	
	var stopAsyncValidation = exports.stopAsyncValidation = function stopAsyncValidation(errors) {
	  return { type: _actionTypes.STOP_ASYNC_VALIDATION, errors: errors };
	};
	
	var stopSubmit = exports.stopSubmit = function stopSubmit(errors) {
	  return { type: _actionTypes.STOP_SUBMIT, errors: errors };
	};
	
	var submitFailed = exports.submitFailed = function submitFailed() {
	  return { type: _actionTypes.SUBMIT_FAILED };
	};
	
	var swapArrayValues = exports.swapArrayValues = function swapArrayValues(path, indexA, indexB) {
	  return { type: _actionTypes.SWAP_ARRAY_VALUES, path: path, indexA: indexA, indexB: indexB };
	};
	
	var touch = exports.touch = function touch() {
	  for (var _len = arguments.length, fields = Array(_len), _key = 0; _key < _len; _key++) {
	    fields[_key] = arguments[_key];
	  }
	
	  return { type: _actionTypes.TOUCH, fields: fields };
	};
	
	var untouch = exports.untouch = function untouch() {
	  for (var _len2 = arguments.length, fields = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    fields[_key2] = arguments[_key2];
	  }
	
	  return { type: _actionTypes.UNTOUCH, fields: fields };
	};

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = bindActionData;
	
	var _mapValues = __webpack_require__(416);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Adds additional properties to the results of the function or map of functions passed
	 */
	function bindActionData(action, data) {
	  if (typeof action === 'function') {
	    return function () {
	      return _extends({}, action.apply(undefined, arguments), data);
	    };
	  }
	  if (typeof action === 'object') {
	    return (0, _mapValues2.default)(action, function (value) {
	      return bindActionData(value, data);
	    });
	  }
	  return action;
	}

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reducer = __webpack_require__(417);
	
	var _initializeState = __webpack_require__(656);
	
	var _initializeState2 = _interopRequireDefault(_initializeState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createInitialState = function createInitialState(data, fields, state) {
	  var _extends2;
	
	  var overwriteValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	  var markInitialized = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
	
	  return _extends({}, (0, _initializeState2.default)(data, fields, state, overwriteValues), (_extends2 = {
	    _asyncValidating: false,
	    _active: undefined
	  }, _extends2[_reducer.globalErrorKey] = undefined, _extends2._initialized = markInitialized, _extends2._submitting = false, _extends2._submitFailed = false, _extends2));
	};
	
	exports.default = createInitialState;

/***/ }),
/* 649 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var dataKey = exports.dataKey = 'value';
	var createOnDragStart = function createOnDragStart(name, getValue) {
	  return function (event) {
	    event.dataTransfer.setData(dataKey, getValue());
	  };
	};
	
	exports.default = createOnDragStart;

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isEvent = __webpack_require__(651);
	
	var _isEvent2 = _interopRequireDefault(_isEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getSelectedValues = function getSelectedValues(options) {
	  var result = [];
	  if (options) {
	    for (var index = 0; index < options.length; index++) {
	      var option = options[index];
	      if (option.selected) {
	        result.push(option.value);
	      }
	    }
	  }
	  return result;
	};
	
	var getValue = function getValue(event, isReactNative) {
	  if ((0, _isEvent2.default)(event)) {
	    if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) {
	      return event.nativeEvent.text;
	    }
	    if (isReactNative && event.nativeEvent !== undefined) {
	      return event.nativeEvent.text;
	    }
	    var _event$target = event.target,
	        type = _event$target.type,
	        value = _event$target.value,
	        checked = _event$target.checked,
	        files = _event$target.files,
	        dataTransfer = event.dataTransfer;
	
	    if (type === 'checkbox') {
	      return checked;
	    }
	    if (type === 'radio') {
	      return checked ? value : '';
	    }
	    if (type === 'file') {
	      return files || dataTransfer && dataTransfer.files;
	    }
	    if (type === 'select-multiple') {
	      return getSelectedValues(event.target.options);
	    }
	    if (value !== '' && (type === 'number' || type === 'range')) {
	      return parseFloat(value);
	    }
	    return value;
	  }
	  // not an event, so must be either our value or an object containing our value in the 'value' key
	  return event && typeof event === 'object' && event.value !== undefined ? event.value : // extract value from { value: value } structure. https://github.com/nikgraf/belle/issues/58
	  event;
	};
	
	exports.default = getValue;

/***/ }),
/* 651 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var isEvent = function isEvent(candidate) {
	  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
	};
	
	exports.default = isEvent;

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isEvent = __webpack_require__(651);
	
	var _isEvent2 = _interopRequireDefault(_isEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var silenceEvent = function silenceEvent(event) {
	  var is = (0, _isEvent2.default)(event);
	  if (is) {
	    event.preventDefault();
	  }
	  return is;
	};
	
	exports.default = silenceEvent;

/***/ }),
/* 653 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getDisplayName;
	function getDisplayName(Comp) {
	  return Comp.displayName || Comp.name || 'Component';
	}

/***/ }),
/* 654 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Given a state[field], get the value.
	 *  Fallback to .initialValue when .value is undefined to prevent double render/initialize cycle.
	 *  See {@link https://github.com/erikras/redux-form/issues/621}.
	 */
	var itemToValue = function itemToValue(_ref) {
	  var value = _ref.value,
	      initialValue = _ref.initialValue;
	  return typeof value !== 'undefined' ? value : initialValue;
	};
	
	var getValue = function getValue(field, state, dest) {
	  var dotIndex = field.indexOf('.');
	  var openIndex = field.indexOf('[');
	  var closeIndex = field.indexOf(']');
	  if (openIndex > 0 && closeIndex !== openIndex + 1) {
	    throw new Error('found [ not followed by ]');
	  }
	  if (openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    // array field
	    var key = field.substring(0, openIndex);
	    var rest = field.substring(closeIndex + 1);
	    if (rest[0] === '.') {
	      rest = rest.substring(1);
	    }
	    var array = state && state[key] || [];
	    if (rest) {
	      if (!dest[key]) {
	        dest[key] = [];
	      }
	      array.forEach(function (item, index) {
	        if (!dest[key][index]) {
	          dest[key][index] = {};
	        }
	        getValue(rest, item, dest[key][index]);
	      });
	    } else {
	      dest[key] = array.map(itemToValue);
	    }
	  } else if (dotIndex > 0) {
	    // subobject field
	    var _key = field.substring(0, dotIndex);
	    var _rest = field.substring(dotIndex + 1);
	    if (!dest[_key]) {
	      dest[_key] = {};
	    }
	    getValue(_rest, state && state[_key] || {}, dest[_key]);
	  } else {
	    dest[field] = state[field] && itemToValue(state[field]);
	  }
	};
	
	var getValues = function getValues(fields, state) {
	  return fields.reduce(function (accumulator, field) {
	    getValue(field, state, accumulator);
	    return accumulator;
	  }, {});
	};
	
	exports.default = getValues;

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _fieldValue = __webpack_require__(194);
	
	/**
	 * A different version of getValues() that does not need the fields array
	 */
	var getValuesFromState = function getValuesFromState(state) {
	  if (!state) {
	    return state;
	  }
	  var keys = Object.keys(state);
	  if (!keys.length) {
	    return undefined;
	  }
	  return keys.reduce(function (accumulator, key) {
	    var field = state[key];
	    if (field) {
	      if ((0, _fieldValue.isFieldValue)(field)) {
	        if (field.value !== undefined) {
	          accumulator[key] = field.value;
	        }
	      } else if (Array.isArray(field)) {
	        accumulator[key] = field.map(function (arrayField) {
	          return (0, _fieldValue.isFieldValue)(arrayField) ? arrayField.value : getValuesFromState(arrayField);
	        });
	      } else if (typeof field === 'object') {
	        var result = getValuesFromState(field);
	
	        if (result && Object.keys(result).length > 0) {
	          accumulator[key] = result;
	        }
	      }
	    }
	    return accumulator;
	  }, {});
	};
	
	exports.default = getValuesFromState;

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _fieldValue = __webpack_require__(194);
	
	var makeEntry = function makeEntry(value, previousValue, overwriteValues) {
	  if (value === undefined && previousValue === undefined) return (0, _fieldValue.makeFieldValue)({});
	  return (0, _fieldValue.makeFieldValue)({
	    initial: value,
	    value: overwriteValues ? value : previousValue
	  });
	};
	
	/**
	 * Sets the initial values into the state and returns a new copy of the state
	 */
	var initializeState = function initializeState(values, fields) {
	  var state = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var overwriteValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	  if (!fields) {
	    throw new Error('fields must be passed when initializing state');
	  }
	  if (!values || !fields.length) {
	    return state;
	  }
	  var initializeField = function initializeField(path, src, dest) {
	    var dotIndex = path.indexOf('.');
	    if (dotIndex === 0) {
	      return initializeField(path.substring(1), src, dest);
	    }
	    var openIndex = path.indexOf('[');
	    var closeIndex = path.indexOf(']');
	    var result = _extends({}, dest) || {};
	    if (dotIndex >= 0 && (openIndex < 0 || dotIndex < openIndex)) {
	      // is dot notation
	      var key = path.substring(0, dotIndex);
	      result[key] = src[key] && initializeField(path.substring(dotIndex + 1), src[key], result[key] || {});
	    } else if (openIndex >= 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	      // is array notation
	      if (closeIndex < 0) {
	        throw new Error('found \'[\' but no \']\': \'' + path + '\'');
	      }
	      var _key = path.substring(0, openIndex);
	      var srcArray = src[_key];
	      var destArray = result[_key];
	      var rest = path.substring(closeIndex + 1);
	      if (Array.isArray(srcArray)) {
	        if (rest.length) {
	          // need to keep recursing
	          result[_key] = srcArray.map(function (srcValue, srcIndex) {
	            return initializeField(rest, srcValue, destArray && destArray[srcIndex]);
	          });
	        } else {
	          result[_key] = srcArray.map(function (srcValue, srcIndex) {
	            return makeEntry(srcValue, destArray && destArray[srcIndex] && destArray[srcIndex].value, overwriteValues);
	          });
	        }
	      } else {
	        result[_key] = [];
	      }
	    } else {
	      result[path] = makeEntry(src && src[path], dest && dest[path] && dest[path].value, overwriteValues);
	    }
	    return result;
	  };
	  return fields.reduce(function (accumulator, field) {
	    return initializeField(field, values, accumulator);
	  }, _extends({}, state));
	};
	
	exports.default = initializeState;

/***/ }),
/* 657 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var isChecked = function isChecked(value) {
	  if (typeof value === 'boolean') {
	    return value;
	  }
	  if (typeof value === 'string') {
	    var lower = value.toLowerCase();
	    if (lower === 'true') {
	      return true;
	    }
	    if (lower === 'false') {
	      return false;
	    }
	  }
	  return undefined;
	};
	
	exports.default = isChecked;

/***/ }),
/* 658 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Reads any potentially deep value from an object using dot and array syntax
	 */
	var read = function read(path, object) {
	  if (!path || !object) {
	    return object;
	  }
	  var dotIndex = path.indexOf('.');
	  if (dotIndex === 0) {
	    return read(path.substring(1), object);
	  }
	  var openIndex = path.indexOf('[');
	  var closeIndex = path.indexOf(']');
	  if (dotIndex >= 0 && (openIndex < 0 || dotIndex < openIndex)) {
	    // iterate down object tree
	    return read(path.substring(dotIndex + 1), object[path.substring(0, dotIndex)]);
	  }
	  if (openIndex >= 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    if (closeIndex < 0) {
	      throw new Error('found [ but no ]');
	    }
	    var key = path.substring(0, openIndex);
	    var index = path.substring(openIndex + 1, closeIndex);
	    if (!index.length) {
	      return object[key];
	    }
	    if (openIndex === 0) {
	      return read(path.substring(closeIndex + 1), object[index]);
	    }
	    if (!object[key]) {
	      return undefined;
	    }
	    return read(path.substring(closeIndex + 1), object[key][index]);
	  }
	  return object[path];
	};
	
	exports.default = read;

/***/ }),
/* 659 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/**
	 * Writes any potentially deep value from an object using dot and array syntax,
	 * and returns a new copy of the object.
	 */
	var write = function write(path, value, object) {
	  var _extends7;
	
	  var dotIndex = path.indexOf('.');
	  if (dotIndex === 0) {
	    return write(path.substring(1), value, object);
	  }
	  var openIndex = path.indexOf('[');
	  var closeIndex = path.indexOf(']');
	  if (dotIndex >= 0 && (openIndex < 0 || dotIndex < openIndex)) {
	    var _extends2;
	
	    // is dot notation
	    var key = path.substring(0, dotIndex);
	    return _extends({}, object, (_extends2 = {}, _extends2[key] = write(path.substring(dotIndex + 1), value, object[key] || {}), _extends2));
	  }
	  if (openIndex >= 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    var _extends6;
	
	    // is array notation
	    if (closeIndex < 0) {
	      throw new Error('found [ but no ]');
	    }
	    var _key = path.substring(0, openIndex);
	    var index = path.substring(openIndex + 1, closeIndex);
	    var array = object[_key] || [];
	    var rest = path.substring(closeIndex + 1);
	    if (index) {
	      var _extends4;
	
	      // indexed array
	      if (rest.length) {
	        var _extends3;
	
	        // need to keep recursing
	        var dest = array[index] || {};
	        var arrayCopy = [].concat(array);
	        arrayCopy[index] = write(rest, value, dest);
	        return _extends({}, object || {}, (_extends3 = {}, _extends3[_key] = arrayCopy, _extends3));
	      }
	      var copy = [].concat(array);
	      copy[index] = typeof value === 'function' ? value(copy[index]) : value;
	      return _extends({}, object || {}, (_extends4 = {}, _extends4[_key] = copy, _extends4));
	    }
	    // indexless array
	    if (rest.length) {
	      var _extends5;
	
	      // need to keep recursing
	      if ((!array || !array.length) && typeof value === 'function') {
	        return object; // don't even set a value under [key]
	      }
	      var _arrayCopy = array.map(function (dest) {
	        return write(rest, value, dest);
	      });
	      return _extends({}, object || {}, (_extends5 = {}, _extends5[_key] = _arrayCopy, _extends5));
	    }
	    var result = void 0;
	    if (Array.isArray(value)) {
	      result = value;
	    } else if (object[_key]) {
	      result = array.map(function (dest) {
	        return typeof value === 'function' ? value(dest) : value;
	      });
	    } else if (typeof value === 'function') {
	      return object; // don't even set a value under [key]
	    } else {
	      result = value;
	    }
	    return _extends({}, object || {}, (_extends6 = {}, _extends6[_key] = result, _extends6));
	  }
	  return _extends({}, object, (_extends7 = {}, _extends7[path] = typeof value === 'function' ? value(object[path]) : value, _extends7));
	};
	
	exports.default = write;

/***/ }),
/* 660 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (action) {
	  return action && action.type === '@@redux/INIT' ? 'initialState argument passed to createStore' : 'previous state received by the reducer';
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=getStateName.js.map

/***/ }),
/* 661 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var repeat = exports.repeat = function repeat(str, times) {
	  return new Array(times + 1).join(str);
	};
	
	var pad = exports.pad = function pad(num, maxLength) {
	  return repeat("0", maxLength - num.toString().length) + num;
	};
	
	var formatTime = exports.formatTime = function formatTime(time) {
	  return pad(time.getHours(), 2) + ":" + pad(time.getMinutes(), 2) + ":" + pad(time.getSeconds(), 2) + "." + pad(time.getMilliseconds(), 3);
	};
	
	// Use performance API if it's available in order to get better precision
	var timer = exports.timer = typeof performance !== "undefined" && performance !== null && typeof performance.now === "function" ? performance : Date;

/***/ }),
/* 662 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ }),
/* 663 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  var last = funcs[funcs.length - 1];
	  var rest = funcs.slice(0, -1);
	  return function () {
	    return rest.reduceRight(function (composed, f) {
	      return f(composed);
	    }, last.apply(undefined, arguments));
	  };
	}

/***/ }),
/* 664 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var eio = __webpack_require__(1112);
	var Socket = __webpack_require__(667);
	var Emitter = __webpack_require__(176);
	var parser = __webpack_require__(419);
	var on = __webpack_require__(666);
	var bind = __webpack_require__(498);
	var debug = __webpack_require__(116)('socket.io-client:manager');
	var indexOf = __webpack_require__(576);
	var Backoff = __webpack_require__(826);
	
	/**
	 * IE6+ hasOwnProperty
	 */
	
	var has = Object.prototype.hasOwnProperty;
	
	/**
	 * Module exports
	 */
	
	module.exports = Manager;
	
	/**
	 * `Manager` constructor.
	 *
	 * @param {String} engine instance or engine uri/opts
	 * @param {Object} options
	 * @api public
	 */
	
	function Manager (uri, opts) {
	  if (!(this instanceof Manager)) return new Manager(uri, opts);
	  if (uri && ('object' === typeof uri)) {
	    opts = uri;
	    uri = undefined;
	  }
	  opts = opts || {};
	
	  opts.path = opts.path || '/socket.io';
	  this.nsps = {};
	  this.subs = [];
	  this.opts = opts;
	  this.reconnection(opts.reconnection !== false);
	  this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
	  this.reconnectionDelay(opts.reconnectionDelay || 1000);
	  this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
	  this.randomizationFactor(opts.randomizationFactor || 0.5);
	  this.backoff = new Backoff({
	    min: this.reconnectionDelay(),
	    max: this.reconnectionDelayMax(),
	    jitter: this.randomizationFactor()
	  });
	  this.timeout(null == opts.timeout ? 20000 : opts.timeout);
	  this.readyState = 'closed';
	  this.uri = uri;
	  this.connecting = [];
	  this.lastPing = null;
	  this.encoding = false;
	  this.packetBuffer = [];
	  var _parser = opts.parser || parser;
	  this.encoder = new _parser.Encoder();
	  this.decoder = new _parser.Decoder();
	  this.autoConnect = opts.autoConnect !== false;
	  if (this.autoConnect) this.open();
	}
	
	/**
	 * Propagate given event to sockets and emit on `this`
	 *
	 * @api private
	 */
	
	Manager.prototype.emitAll = function () {
	  this.emit.apply(this, arguments);
	  for (var nsp in this.nsps) {
	    if (has.call(this.nsps, nsp)) {
	      this.nsps[nsp].emit.apply(this.nsps[nsp], arguments);
	    }
	  }
	};
	
	/**
	 * Update `socket.id` of all sockets
	 *
	 * @api private
	 */
	
	Manager.prototype.updateSocketIds = function () {
	  for (var nsp in this.nsps) {
	    if (has.call(this.nsps, nsp)) {
	      this.nsps[nsp].id = this.generateId(nsp);
	    }
	  }
	};
	
	/**
	 * generate `socket.id` for the given `nsp`
	 *
	 * @param {String} nsp
	 * @return {String}
	 * @api private
	 */
	
	Manager.prototype.generateId = function (nsp) {
	  return (nsp === '/' ? '' : (nsp + '#')) + this.engine.id;
	};
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Manager.prototype);
	
	/**
	 * Sets the `reconnection` config.
	 *
	 * @param {Boolean} true/false if it should automatically reconnect
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnection = function (v) {
	  if (!arguments.length) return this._reconnection;
	  this._reconnection = !!v;
	  return this;
	};
	
	/**
	 * Sets the reconnection attempts config.
	 *
	 * @param {Number} max reconnection attempts before giving up
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionAttempts = function (v) {
	  if (!arguments.length) return this._reconnectionAttempts;
	  this._reconnectionAttempts = v;
	  return this;
	};
	
	/**
	 * Sets the delay between reconnections.
	 *
	 * @param {Number} delay
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionDelay = function (v) {
	  if (!arguments.length) return this._reconnectionDelay;
	  this._reconnectionDelay = v;
	  this.backoff && this.backoff.setMin(v);
	  return this;
	};
	
	Manager.prototype.randomizationFactor = function (v) {
	  if (!arguments.length) return this._randomizationFactor;
	  this._randomizationFactor = v;
	  this.backoff && this.backoff.setJitter(v);
	  return this;
	};
	
	/**
	 * Sets the maximum delay between reconnections.
	 *
	 * @param {Number} delay
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionDelayMax = function (v) {
	  if (!arguments.length) return this._reconnectionDelayMax;
	  this._reconnectionDelayMax = v;
	  this.backoff && this.backoff.setMax(v);
	  return this;
	};
	
	/**
	 * Sets the connection timeout. `false` to disable
	 *
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.timeout = function (v) {
	  if (!arguments.length) return this._timeout;
	  this._timeout = v;
	  return this;
	};
	
	/**
	 * Starts trying to reconnect if reconnection is enabled and we have not
	 * started reconnecting yet
	 *
	 * @api private
	 */
	
	Manager.prototype.maybeReconnectOnOpen = function () {
	  // Only try to reconnect if it's the first time we're connecting
	  if (!this.reconnecting && this._reconnection && this.backoff.attempts === 0) {
	    // keeps reconnection from firing twice for the same reconnection loop
	    this.reconnect();
	  }
	};
	
	/**
	 * Sets the current transport `socket`.
	 *
	 * @param {Function} optional, callback
	 * @return {Manager} self
	 * @api public
	 */
	
	Manager.prototype.open =
	Manager.prototype.connect = function (fn, opts) {
	  debug('readyState %s', this.readyState);
	  if (~this.readyState.indexOf('open')) return this;
	
	  debug('opening %s', this.uri);
	  this.engine = eio(this.uri, this.opts);
	  var socket = this.engine;
	  var self = this;
	  this.readyState = 'opening';
	  this.skipReconnect = false;
	
	  // emit `open`
	  var openSub = on(socket, 'open', function () {
	    self.onopen();
	    fn && fn();
	  });
	
	  // emit `connect_error`
	  var errorSub = on(socket, 'error', function (data) {
	    debug('connect_error');
	    self.cleanup();
	    self.readyState = 'closed';
	    self.emitAll('connect_error', data);
	    if (fn) {
	      var err = new Error('Connection error');
	      err.data = data;
	      fn(err);
	    } else {
	      // Only do this if there is no fn to handle the error
	      self.maybeReconnectOnOpen();
	    }
	  });
	
	  // emit `connect_timeout`
	  if (false !== this._timeout) {
	    var timeout = this._timeout;
	    debug('connect attempt will timeout after %d', timeout);
	
	    // set timer
	    var timer = setTimeout(function () {
	      debug('connect attempt timed out after %d', timeout);
	      openSub.destroy();
	      socket.close();
	      socket.emit('error', 'timeout');
	      self.emitAll('connect_timeout', timeout);
	    }, timeout);
	
	    this.subs.push({
	      destroy: function () {
	        clearTimeout(timer);
	      }
	    });
	  }
	
	  this.subs.push(openSub);
	  this.subs.push(errorSub);
	
	  return this;
	};
	
	/**
	 * Called upon transport open.
	 *
	 * @api private
	 */
	
	Manager.prototype.onopen = function () {
	  debug('open');
	
	  // clear old subs
	  this.cleanup();
	
	  // mark as open
	  this.readyState = 'open';
	  this.emit('open');
	
	  // add new subs
	  var socket = this.engine;
	  this.subs.push(on(socket, 'data', bind(this, 'ondata')));
	  this.subs.push(on(socket, 'ping', bind(this, 'onping')));
	  this.subs.push(on(socket, 'pong', bind(this, 'onpong')));
	  this.subs.push(on(socket, 'error', bind(this, 'onerror')));
	  this.subs.push(on(socket, 'close', bind(this, 'onclose')));
	  this.subs.push(on(this.decoder, 'decoded', bind(this, 'ondecoded')));
	};
	
	/**
	 * Called upon a ping.
	 *
	 * @api private
	 */
	
	Manager.prototype.onping = function () {
	  this.lastPing = new Date();
	  this.emitAll('ping');
	};
	
	/**
	 * Called upon a packet.
	 *
	 * @api private
	 */
	
	Manager.prototype.onpong = function () {
	  this.emitAll('pong', new Date() - this.lastPing);
	};
	
	/**
	 * Called with data.
	 *
	 * @api private
	 */
	
	Manager.prototype.ondata = function (data) {
	  this.decoder.add(data);
	};
	
	/**
	 * Called when parser fully decodes a packet.
	 *
	 * @api private
	 */
	
	Manager.prototype.ondecoded = function (packet) {
	  this.emit('packet', packet);
	};
	
	/**
	 * Called upon socket error.
	 *
	 * @api private
	 */
	
	Manager.prototype.onerror = function (err) {
	  debug('error', err);
	  this.emitAll('error', err);
	};
	
	/**
	 * Creates a new socket for the given `nsp`.
	 *
	 * @return {Socket}
	 * @api public
	 */
	
	Manager.prototype.socket = function (nsp, opts) {
	  var socket = this.nsps[nsp];
	  if (!socket) {
	    socket = new Socket(this, nsp, opts);
	    this.nsps[nsp] = socket;
	    var self = this;
	    socket.on('connecting', onConnecting);
	    socket.on('connect', function () {
	      socket.id = self.generateId(nsp);
	    });
	
	    if (this.autoConnect) {
	      // manually call here since connecting event is fired before listening
	      onConnecting();
	    }
	  }
	
	  function onConnecting () {
	    if (!~indexOf(self.connecting, socket)) {
	      self.connecting.push(socket);
	    }
	  }
	
	  return socket;
	};
	
	/**
	 * Called upon a socket close.
	 *
	 * @param {Socket} socket
	 */
	
	Manager.prototype.destroy = function (socket) {
	  var index = indexOf(this.connecting, socket);
	  if (~index) this.connecting.splice(index, 1);
	  if (this.connecting.length) return;
	
	  this.close();
	};
	
	/**
	 * Writes a packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Manager.prototype.packet = function (packet) {
	  debug('writing packet %j', packet);
	  var self = this;
	  if (packet.query && packet.type === 0) packet.nsp += '?' + packet.query;
	
	  if (!self.encoding) {
	    // encode, then write to engine with result
	    self.encoding = true;
	    this.encoder.encode(packet, function (encodedPackets) {
	      for (var i = 0; i < encodedPackets.length; i++) {
	        self.engine.write(encodedPackets[i], packet.options);
	      }
	      self.encoding = false;
	      self.processPacketQueue();
	    });
	  } else { // add packet to the queue
	    self.packetBuffer.push(packet);
	  }
	};
	
	/**
	 * If packet buffer is non-empty, begins encoding the
	 * next packet in line.
	 *
	 * @api private
	 */
	
	Manager.prototype.processPacketQueue = function () {
	  if (this.packetBuffer.length > 0 && !this.encoding) {
	    var pack = this.packetBuffer.shift();
	    this.packet(pack);
	  }
	};
	
	/**
	 * Clean up transport subscriptions and packet buffer.
	 *
	 * @api private
	 */
	
	Manager.prototype.cleanup = function () {
	  debug('cleanup');
	
	  var subsLength = this.subs.length;
	  for (var i = 0; i < subsLength; i++) {
	    var sub = this.subs.shift();
	    sub.destroy();
	  }
	
	  this.packetBuffer = [];
	  this.encoding = false;
	  this.lastPing = null;
	
	  this.decoder.destroy();
	};
	
	/**
	 * Close the current socket.
	 *
	 * @api private
	 */
	
	Manager.prototype.close =
	Manager.prototype.disconnect = function () {
	  debug('disconnect');
	  this.skipReconnect = true;
	  this.reconnecting = false;
	  if ('opening' === this.readyState) {
	    // `onclose` will not fire because
	    // an open event never happened
	    this.cleanup();
	  }
	  this.backoff.reset();
	  this.readyState = 'closed';
	  if (this.engine) this.engine.close();
	};
	
	/**
	 * Called upon engine close.
	 *
	 * @api private
	 */
	
	Manager.prototype.onclose = function (reason) {
	  debug('onclose');
	
	  this.cleanup();
	  this.backoff.reset();
	  this.readyState = 'closed';
	  this.emit('close', reason);
	
	  if (this._reconnection && !this.skipReconnect) {
	    this.reconnect();
	  }
	};
	
	/**
	 * Attempt a reconnection.
	 *
	 * @api private
	 */
	
	Manager.prototype.reconnect = function () {
	  if (this.reconnecting || this.skipReconnect) return this;
	
	  var self = this;
	
	  if (this.backoff.attempts >= this._reconnectionAttempts) {
	    debug('reconnect failed');
	    this.backoff.reset();
	    this.emitAll('reconnect_failed');
	    this.reconnecting = false;
	  } else {
	    var delay = this.backoff.duration();
	    debug('will wait %dms before reconnect attempt', delay);
	
	    this.reconnecting = true;
	    var timer = setTimeout(function () {
	      if (self.skipReconnect) return;
	
	      debug('attempting reconnect');
	      self.emitAll('reconnect_attempt', self.backoff.attempts);
	      self.emitAll('reconnecting', self.backoff.attempts);
	
	      // check again for the case socket closed in above events
	      if (self.skipReconnect) return;
	
	      self.open(function (err) {
	        if (err) {
	          debug('reconnect attempt error');
	          self.reconnecting = false;
	          self.reconnect();
	          self.emitAll('reconnect_error', err.data);
	        } else {
	          debug('reconnect success');
	          self.onreconnect();
	        }
	      });
	    }, delay);
	
	    this.subs.push({
	      destroy: function () {
	        clearTimeout(timer);
	      }
	    });
	  }
	};
	
	/**
	 * Called upon successful reconnect.
	 *
	 * @api private
	 */
	
	Manager.prototype.onreconnect = function () {
	  var attempt = this.backoff.attempts;
	  this.reconnecting = false;
	  this.backoff.reset();
	  this.updateSocketIds();
	  this.emitAll('reconnect', attempt);
	};


/***/ }),
/* 666 */
/***/ (function(module, exports) {

	
	/**
	 * Module exports.
	 */
	
	module.exports = on;
	
	/**
	 * Helper for subscriptions.
	 *
	 * @param {Object|EventEmitter} obj with `Emitter` mixin or `EventEmitter`
	 * @param {String} event name
	 * @param {Function} callback
	 * @api public
	 */
	
	function on (obj, ev, fn) {
	  obj.on(ev, fn);
	  return {
	    destroy: function () {
	      obj.removeListener(ev, fn);
	    }
	  };
	}


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var parser = __webpack_require__(419);
	var Emitter = __webpack_require__(176);
	var toArray = __webpack_require__(2315);
	var on = __webpack_require__(666);
	var bind = __webpack_require__(498);
	var debug = __webpack_require__(116)('socket.io-client:socket');
	
	/**
	 * Module exports.
	 */
	
	module.exports = exports = Socket;
	
	/**
	 * Internal events (blacklisted).
	 * These events can't be emitted by the user.
	 *
	 * @api private
	 */
	
	var events = {
	  connect: 1,
	  connect_error: 1,
	  connect_timeout: 1,
	  connecting: 1,
	  disconnect: 1,
	  error: 1,
	  reconnect: 1,
	  reconnect_attempt: 1,
	  reconnect_failed: 1,
	  reconnect_error: 1,
	  reconnecting: 1,
	  ping: 1,
	  pong: 1
	};
	
	/**
	 * Shortcut to `Emitter#emit`.
	 */
	
	var emit = Emitter.prototype.emit;
	
	/**
	 * `Socket` constructor.
	 *
	 * @api public
	 */
	
	function Socket (io, nsp, opts) {
	  this.io = io;
	  this.nsp = nsp;
	  this.json = this; // compat
	  this.ids = 0;
	  this.acks = {};
	  this.receiveBuffer = [];
	  this.sendBuffer = [];
	  this.connected = false;
	  this.disconnected = true;
	  if (opts && opts.query) {
	    this.query = opts.query;
	  }
	  if (this.io.autoConnect) this.open();
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Socket.prototype);
	
	/**
	 * Subscribe to open, close and packet events
	 *
	 * @api private
	 */
	
	Socket.prototype.subEvents = function () {
	  if (this.subs) return;
	
	  var io = this.io;
	  this.subs = [
	    on(io, 'open', bind(this, 'onopen')),
	    on(io, 'packet', bind(this, 'onpacket')),
	    on(io, 'close', bind(this, 'onclose'))
	  ];
	};
	
	/**
	 * "Opens" the socket.
	 *
	 * @api public
	 */
	
	Socket.prototype.open =
	Socket.prototype.connect = function () {
	  if (this.connected) return this;
	
	  this.subEvents();
	  this.io.open(); // ensure open
	  if ('open' === this.io.readyState) this.onopen();
	  this.emit('connecting');
	  return this;
	};
	
	/**
	 * Sends a `message` event.
	 *
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.send = function () {
	  var args = toArray(arguments);
	  args.unshift('message');
	  this.emit.apply(this, args);
	  return this;
	};
	
	/**
	 * Override `emit`.
	 * If the event is in `events`, it's emitted normally.
	 *
	 * @param {String} event name
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.emit = function (ev) {
	  if (events.hasOwnProperty(ev)) {
	    emit.apply(this, arguments);
	    return this;
	  }
	
	  var args = toArray(arguments);
	  var packet = { type: parser.EVENT, data: args };
	
	  packet.options = {};
	  packet.options.compress = !this.flags || false !== this.flags.compress;
	
	  // event ack callback
	  if ('function' === typeof args[args.length - 1]) {
	    debug('emitting packet with ack id %d', this.ids);
	    this.acks[this.ids] = args.pop();
	    packet.id = this.ids++;
	  }
	
	  if (this.connected) {
	    this.packet(packet);
	  } else {
	    this.sendBuffer.push(packet);
	  }
	
	  delete this.flags;
	
	  return this;
	};
	
	/**
	 * Sends a packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.packet = function (packet) {
	  packet.nsp = this.nsp;
	  this.io.packet(packet);
	};
	
	/**
	 * Called upon engine `open`.
	 *
	 * @api private
	 */
	
	Socket.prototype.onopen = function () {
	  debug('transport is open - connecting');
	
	  // write connect packet if necessary
	  if ('/' !== this.nsp) {
	    if (this.query) {
	      this.packet({type: parser.CONNECT, query: this.query});
	    } else {
	      this.packet({type: parser.CONNECT});
	    }
	  }
	};
	
	/**
	 * Called upon engine `close`.
	 *
	 * @param {String} reason
	 * @api private
	 */
	
	Socket.prototype.onclose = function (reason) {
	  debug('close (%s)', reason);
	  this.connected = false;
	  this.disconnected = true;
	  delete this.id;
	  this.emit('disconnect', reason);
	};
	
	/**
	 * Called with socket packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onpacket = function (packet) {
	  if (packet.nsp !== this.nsp) return;
	
	  switch (packet.type) {
	    case parser.CONNECT:
	      this.onconnect();
	      break;
	
	    case parser.EVENT:
	      this.onevent(packet);
	      break;
	
	    case parser.BINARY_EVENT:
	      this.onevent(packet);
	      break;
	
	    case parser.ACK:
	      this.onack(packet);
	      break;
	
	    case parser.BINARY_ACK:
	      this.onack(packet);
	      break;
	
	    case parser.DISCONNECT:
	      this.ondisconnect();
	      break;
	
	    case parser.ERROR:
	      this.emit('error', packet.data);
	      break;
	  }
	};
	
	/**
	 * Called upon a server event.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onevent = function (packet) {
	  var args = packet.data || [];
	  debug('emitting event %j', args);
	
	  if (null != packet.id) {
	    debug('attaching ack callback to event');
	    args.push(this.ack(packet.id));
	  }
	
	  if (this.connected) {
	    emit.apply(this, args);
	  } else {
	    this.receiveBuffer.push(args);
	  }
	};
	
	/**
	 * Produces an ack callback to emit with an event.
	 *
	 * @api private
	 */
	
	Socket.prototype.ack = function (id) {
	  var self = this;
	  var sent = false;
	  return function () {
	    // prevent double callbacks
	    if (sent) return;
	    sent = true;
	    var args = toArray(arguments);
	    debug('sending ack %j', args);
	
	    self.packet({
	      type: parser.ACK,
	      id: id,
	      data: args
	    });
	  };
	};
	
	/**
	 * Called upon a server acknowlegement.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onack = function (packet) {
	  var ack = this.acks[packet.id];
	  if ('function' === typeof ack) {
	    debug('calling ack %s with %j', packet.id, packet.data);
	    ack.apply(this, packet.data);
	    delete this.acks[packet.id];
	  } else {
	    debug('bad ack %s', packet.id);
	  }
	};
	
	/**
	 * Called upon server connect.
	 *
	 * @api private
	 */
	
	Socket.prototype.onconnect = function () {
	  this.connected = true;
	  this.disconnected = false;
	  this.emit('connect');
	  this.emitBuffered();
	};
	
	/**
	 * Emit buffered events (received and emitted).
	 *
	 * @api private
	 */
	
	Socket.prototype.emitBuffered = function () {
	  var i;
	  for (i = 0; i < this.receiveBuffer.length; i++) {
	    emit.apply(this, this.receiveBuffer[i]);
	  }
	  this.receiveBuffer = [];
	
	  for (i = 0; i < this.sendBuffer.length; i++) {
	    this.packet(this.sendBuffer[i]);
	  }
	  this.sendBuffer = [];
	};
	
	/**
	 * Called upon server disconnect.
	 *
	 * @api private
	 */
	
	Socket.prototype.ondisconnect = function () {
	  debug('server disconnect (%s)', this.nsp);
	  this.destroy();
	  this.onclose('io server disconnect');
	};
	
	/**
	 * Called upon forced client/server side disconnections,
	 * this method ensures the manager stops tracking us and
	 * that reconnections don't get triggered for this.
	 *
	 * @api private.
	 */
	
	Socket.prototype.destroy = function () {
	  if (this.subs) {
	    // clean subscriptions to avoid reconnections
	    for (var i = 0; i < this.subs.length; i++) {
	      this.subs[i].destroy();
	    }
	    this.subs = null;
	  }
	
	  this.io.destroy(this);
	};
	
	/**
	 * Disconnects the socket manually.
	 *
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.close =
	Socket.prototype.disconnect = function () {
	  if (this.connected) {
	    debug('performing disconnect (%s)', this.nsp);
	    this.packet({ type: parser.DISCONNECT });
	  }
	
	  // remove socket from pool
	  this.destroy();
	
	  if (this.connected) {
	    // fire events
	    this.onclose('io client disconnect');
	  }
	  return this;
	};
	
	/**
	 * Sets the compress flag.
	 *
	 * @param {Boolean} if `true`, compresses the sending data
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.compress = function (compress) {
	  this.flags = this.flags || {};
	  this.flags.compress = compress;
	  return this;
	};


/***/ }),
/* 668 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	module.exports = isBuf;
	
	/**
	 * Returns true if obj is a buffer or an arraybuffer.
	 *
	 * @api private
	 */
	
	function isBuf(obj) {
	  return (global.Buffer && global.Buffer.isBuffer(obj)) ||
	         (global.ArrayBuffer && obj instanceof ArrayBuffer);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.intercomSetUnreadMessages = exports.intercomShowMessages = undefined;
	
	var _analyticsConstants = __webpack_require__(165);
	
	var intercomShowMessages = exports.intercomShowMessages = function intercomShowMessages() {
	    return { type: _analyticsConstants.INTERCOM_SHOW_MESSAGES };
	};
	
	var intercomSetUnreadMessages = exports.intercomSetUnreadMessages = function intercomSetUnreadMessages(count) {
	    return { type: _analyticsConstants.INTERCOM_SET_UNREAD_MESSAGES, count: count };
	};

/***/ }),
/* 670 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PASSWORD_CHANGE_INITIALISED = exports.PASSWORD_CHANGE_INITIALISED = 'PASSWORD_CHANGE_INITIALISED';
	var PASSWORD_CHANGE_CODE_EXPIRED = exports.PASSWORD_CHANGE_CODE_EXPIRED = 'PASSWORD_CHANGE_CODE_EXPIRED';
	var PASSWORD_CHANGED = exports.PASSWORD_CHANGED = 'PASSWORD_CHANGED';
	var PASSWORD_CHANGE_FAILED = exports.PASSWORD_CHANGE_FAILED = 'PASSWORD_CHANGE_FAILED';

/***/ }),
/* 671 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PASSWORD_RESET_REQUESTED = exports.PASSWORD_RESET_REQUESTED = 'PASSWORD_RESET_REQUESTED';
	var PASSWORD_RESET_REQUEST_FAILED = exports.PASSWORD_RESET_REQUEST_FAILED = 'PASSWORD_RESET_REQUEST_FAILED';

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.changePassword = exports.getResetEmail = exports.reset = undefined;
	
	var _http = __webpack_require__(76);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _httpConstants = __webpack_require__(90);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reset = exports.reset = function reset(email) {
	    var resetConfig = {
	        method: _httpConstants.METHODS.POST,
	        url: 'auth/password/reset',
	        data: {
	            email: email.toLowerCase()
	        }
	    };
	
	    return (0, _http2.default)(resetConfig);
	};
	
	var getResetEmail = exports.getResetEmail = function getResetEmail(code) {
	    var getResetConfig = {
	        method: _httpConstants.METHODS.GET,
	        url: 'auth/password/code/' + code
	    };
	
	    return (0, _http2.default)(getResetConfig).then(function (response) {
	        return response.data.email;
	    });
	};
	
	var changePassword = exports.changePassword = function changePassword(_ref) {
	    var email = _ref.email,
	        code = _ref.code,
	        password = _ref.password;
	
	    var changePasswordConfig = {
	        method: _httpConstants.METHODS.PUT,
	        url: 'auth/password/change',
	        data: {
	            email: email,
	            code: code,
	            password: password
	        }
	    };
	
	    return (0, _http2.default)(changePasswordConfig);
	};

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = exports.CANVAS_ELEMENT_ID = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class; // React
	
	
	// Utils
	
	
	// Selectors
	
	
	// Actions
	
	
	// Components
	
	
	// Constants
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reselect = __webpack_require__(7);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _gridUtils = __webpack_require__(42);
	
	var _dontUpdateForKeys = __webpack_require__(206);
	
	var _dontUpdateForKeys2 = _interopRequireDefault(_dontUpdateForKeys);
	
	var _gridSizeSelector = __webpack_require__(66);
	
	var _boardSelector = __webpack_require__(83);
	
	var _elementAttachmentActions = __webpack_require__(142);
	
	var _grabScrollDecorator = __webpack_require__(1693);
	
	var _grabScrollDecorator2 = _interopRequireDefault(_grabScrollDecorator);
	
	var _CanvasElement = __webpack_require__(1687);
	
	var _CanvasElement2 = _interopRequireDefault(_CanvasElement);
	
	var _DocumentModeCanvasDebugger = __webpack_require__(1942);
	
	var _DocumentModeCanvasDebugger2 = _interopRequireDefault(_DocumentModeCanvasDebugger);
	
	var _canvasLineEdgeDropTarget = __webpack_require__(1993);
	
	var _canvasLineEdgeDropTarget2 = _interopRequireDefault(_canvasLineEdgeDropTarget);
	
	var _CanvasDragLayer = __webpack_require__(1690);
	
	var _CanvasDragLayer2 = _interopRequireDefault(_CanvasDragLayer);
	
	var _canvasDropTargetDecorator = __webpack_require__(1692);
	
	var _canvasDropTargetDecorator2 = _interopRequireDefault(_canvasDropTargetDecorator);
	
	var _canvasShortcutElementDecorator = __webpack_require__(1688);
	
	var _canvasShortcutElementDecorator2 = _interopRequireDefault(_canvasShortcutElementDecorator);
	
	var _canvasSizeDecorator = __webpack_require__(1689);
	
	var _canvasSizeDecorator2 = _interopRequireDefault(_canvasSizeDecorator);
	
	var _measureCanvasDecorator = __webpack_require__(1911);
	
	var _measureCanvasDecorator2 = _interopRequireDefault(_measureCanvasDecorator);
	
	var _SelectionMarquee = __webpack_require__(1694);
	
	var _SelectionMarquee2 = _interopRequireDefault(_SelectionMarquee);
	
	var _selectionMarqueeCanvasStateDecorator = __webpack_require__(1695);
	
	var _selectionMarqueeCanvasStateDecorator2 = _interopRequireDefault(_selectionMarqueeCanvasStateDecorator);
	
	var _inboxConstants = __webpack_require__(234);
	
	var _exportConstants = __webpack_require__(317);
	
	__webpack_require__(1126);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Canvas ID
	var CANVAS_ELEMENT_ID = exports.CANVAS_ELEMENT_ID = 'canvas';
	
	/* Redux property connectors. */
	var mapStateToProps = (0, _reselect.createSelector)(_gridSizeSelector.getGridSize, _boardSelector.getIsCurrentBoardFetched, _boardSelector.getCurrentBoardInboxState, function (gridSize, isCurrentBoardFetched, currentBoardInboxState) {
	    return {
	        gridSize: gridSize,
	        inboxState: isCurrentBoardFetched && currentBoardInboxState || _inboxConstants.INBOX_STATE.CLOSED
	    };
	});
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        dispatchErrorUploadingElementAttachment: function dispatchErrorUploadingElementAttachment(_ref) {
	            var id = _ref.id,
	                error = _ref.error;
	            return dispatch((0, _elementAttachmentActions.errorUploadingElementAttachment)({ id: id, error: error }));
	        }
	    };
	};
	
	var getCanvasStyle = function getCanvasStyle(inboxState, gridSize) {
	    return {
	        right: inboxState === _inboxConstants.INBOX_STATE.OPEN ? (0, _gridUtils.gridPointsToPixels)(_inboxConstants.INBOX_WIDTH, gridSize) : 0
	    };
	};
	
	var Canvas = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec2 = (0, _dontUpdateForKeys2.default)(['canDrop', 'isHovered', 'isDragging', 'onCanvasResize', 'createShortcutElement']), (0, _grabScrollDecorator2.default)(_class = _dec(_class = (0, _canvasShortcutElementDecorator2.default)(_class = (0, _canvasDropTargetDecorator2.default)(_class = (0, _canvasLineEdgeDropTarget2.default)(_class = (0, _canvasSizeDecorator2.default)(_class = (0, _measureCanvasDecorator2.default)(_class = (0, _selectionMarqueeCanvasStateDecorator2.default)(_class = _dec2(_class = function (_React$Component) {
	    _inherits(Canvas, _React$Component);
	
	    function Canvas() {
	        _classCallCheck(this, Canvas);
	
	        return _possibleConstructorReturn(this, (Canvas.__proto__ || Object.getPrototypeOf(Canvas)).apply(this, arguments));
	    }
	
	    _createClass(Canvas, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.setShortcutHandlerCanvasNode(this.canvas);
	        }
	        // if current board changes, reset the canvas's scroll position
	
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.props.currentBoardId !== nextProps.currentBoardId) {
	                this.canvas.scrollLeft = 0;
	                this.canvas.scrollTop = 0;
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                canvasElementIds = _props.canvasElementIds,
	                sortedCanvasElementIds = _props.sortedCanvasElementIds,
	                connectDropTarget = _props.connectDropTarget,
	                connectLineEdgeDropTarget = _props.connectLineEdgeDropTarget,
	                gridSize = _props.gridSize,
	                inboxState = _props.inboxState,
	                currentBoardId = _props.currentBoardId,
	                isEditable = _props.isEditable,
	                elementFilter = _props.elementFilter,
	                handleDoubleClick = _props.handleDoubleClick,
	                grabEnabled = _props.grabEnabled,
	                grabbing = _props.grabbing,
	                deselectAll = _props.deselectAll,
	                createShortcutElement = _props.createShortcutElement,
	                createShortcutCard = _props.createShortcutCard,
	                createShortcutImage = _props.createShortcutImage,
	                createShortcutLink = _props.createShortcutLink,
	                readyToMeasure = _props.readyToMeasure,
	                selectionMarqueeActive = _props.selectionMarqueeActive,
	                setSelectionMarqueeActive = _props.setSelectionMarqueeActive;
	
	
	            var canvasClassNames = (0, _classnames2.default)('Canvas', {
	                grab: grabEnabled,
	                grabbing: grabbing,
	                'selection-marquee-active': selectionMarqueeActive
	            });
	
	            return connectDropTarget(connectLineEdgeDropTarget(_react2.default.createElement(
	                'div',
	                { id: CANVAS_ELEMENT_ID, className: canvasClassNames,
	                    style: getCanvasStyle(inboxState, gridSize),
	                    onDoubleClick: handleDoubleClick,
	                    ref: function ref(c) {
	                        _this2.canvas = c;
	                    } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'scrollable-container',
	                        id: _exportConstants.EXPORT_ROOT_ELEMENT_ID,
	                        ref: function ref(c) {
	                            _this2.scrollableContainer = c;
	                        },
	                        style: this.props.canvasSize },
	                    canvasElementIds.map(function (elementId) {
	                        return _react2.default.createElement(_CanvasElement2.default, {
	                            sortIndex: sortedCanvasElementIds.indexOf(elementId),
	                            readyToMeasure: readyToMeasure,
	                            elementId: elementId,
	                            key: elementId,
	                            gridSize: gridSize,
	                            currentBoardId: currentBoardId,
	                            isEditable: isEditable,
	                            deselectAll: deselectAll,
	                            createShortcutElement: createShortcutElement,
	                            createShortcutCard: createShortcutCard,
	                            createShortcutImage: createShortcutImage,
	                            createShortcutLink: createShortcutLink,
	                            elementFilter: elementFilter });
	                    }),
	                    _react2.default.createElement(_CanvasDragLayer2.default, { currentBoardId: currentBoardId }),
	                    _react2.default.createElement(_DocumentModeCanvasDebugger2.default, { gridSize: gridSize }),
	                    _react2.default.createElement(_SelectionMarquee2.default, { canvasElementIds: canvasElementIds,
	                        setSelectionMarqueeActive: setSelectionMarqueeActive,
	                        eventListenerNode: this.scrollableContainer }),
	                    _react2.default.createElement('div', { className: 'element-grab-blocker' })
	                )
	            )));
	        }
	    }]);
	
	    return Canvas;
	}(_react2.default.Component)) || _class) || _class) || _class) || _class) || _class) || _class) || _class) || _class) || _class);
	exports.default = Canvas;
	
	
	Canvas.propTypes = {
	    currentBoardId: _propTypes2.default.string,
	    canvasElementIds: _propTypes2.default.array,
	    sortedCanvasElementIds: _propTypes2.default.array,
	    inboxState: _propTypes2.default.string,
	    connectDropTarget: _propTypes2.default.func,
	    gridSize: _propTypes2.default.number,
	    isOver: _propTypes2.default.bool,
	    isEditable: _propTypes2.default.bool,
	    onCanvasClick: _propTypes2.default.func,
	    onCanvasResize: _propTypes2.default.func,
	    handleDoubleClick: _propTypes2.default.func,
	    deselectAll: _propTypes2.default.func,
	    elementFilter: _propTypes2.default.object,
	    connectLineEdgeDropTarget: _propTypes2.default.func,
	    dispatchErrorUploadingElementAttachment: _propTypes2.default.func,
	    grabEnabled: _propTypes2.default.bool,
	    grabbing: _propTypes2.default.bool,
	    createShortcutElement: _propTypes2.default.func,
	    createShortcutCard: _propTypes2.default.func,
	    createShortcutImage: _propTypes2.default.func,
	    createShortcutLink: _propTypes2.default.func,
	    canvasSize: _propTypes2.default.object,
	    setShortcutHandlerCanvasNode: _propTypes2.default.func,
	    setSizeHandlerCanvasNode: _propTypes2.default.func,
	    readyToMeasure: _propTypes2.default.bool,
	    selectionMarqueeActive: _propTypes2.default.bool,
	    setSelectionMarqueeActive: _propTypes2.default.func
	};

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.isLineAffectedByDrag = exports.hasConnectingElementIds = exports.isDraggingLineControlPoint = exports.isDraggingLineEdge = undefined;
	
	var _lineConstants = __webpack_require__(57);
	
	var isDraggingLineEdge = exports.isDraggingLineEdge = function isDraggingLineEdge(itemType) {
	    return itemType === _lineConstants.LINE_EDGE_DND_TYPE;
	}; // Constants
	var isDraggingLineControlPoint = exports.isDraggingLineControlPoint = function isDraggingLineControlPoint(itemType) {
	    return itemType === _lineConstants.LINE_CONTROL_POINT_DND_TYPE;
	};
	var hasConnectingElementIds = exports.hasConnectingElementIds = function hasConnectingElementIds(item) {
	    return item && item.connectingElementIds && item.connectingElementIds.length;
	};
	
	var isLineAffectedByDrag = exports.isLineAffectedByDrag = function isLineAffectedByDrag(item, itemType) {
	    return isDraggingLineEdge(itemType) || hasConnectingElementIds(item) || isDraggingLineControlPoint(itemType);
	};

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CSSTransitionGroup = __webpack_require__(134);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var DEFAULTS = {
	    transitionName: 'fade',
	    duration: 300,
	    appear: false
	};
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULTS,
	        transitionName = _ref.transitionName,
	        duration = _ref.duration,
	        appear = _ref.appear;
	
	    return function (DecoratedComponent) {
	        var AnimateFadeDecorator = function AnimateFadeDecorator(_ref2) {
	            var _ref2$fadeIn = _ref2.fadeIn,
	                fadeIn = _ref2$fadeIn === undefined ? false : _ref2$fadeIn,
	                _ref2$show = _ref2.show,
	                show = _ref2$show === undefined ? true : _ref2$show,
	                props = _objectWithoutProperties(_ref2, ['fadeIn', 'show']);
	
	            if (fadeIn) {
	                return _react2.default.createElement(
	                    _CSSTransitionGroup2.default,
	                    {
	                        transitionName: transitionName,
	                        transitionAppear: appear,
	                        transitionAppearTimeout: duration,
	                        transitionEnterTimeout: duration,
	                        transitionLeaveTimeout: duration },
	                    show ? _react2.default.createElement(DecoratedComponent, props) : null
	                );
	            }
	
	            return show ? _react2.default.createElement(DecoratedComponent, props) : null;
	        };
	
	        AnimateFadeDecorator.propTypes = {
	            fadeIn: _propTypes2.default.bool,
	            show: _propTypes2.default.bool
	        };
	
	        return AnimateFadeDecorator;
	    };
	};

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(34);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	__webpack_require__(1134);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	var ToolButton = function ToolButton(_ref) {
	    var icon = _ref.icon,
	        text = _ref.text,
	        onClickFn = _ref.onClickFn,
	        className = _ref.className;
	
	    var textElement = text ? _react2.default.createElement(
	        'span',
	        { className: 'tool-text' },
	        text
	    ) : null;
	    return _react2.default.createElement(
	        _Button2.default,
	        { className: (0, _classnames2.default)('ToolButton highlight', className), onClickFn: onClickFn },
	        _react2.default.createElement(
	            'div',
	            { className: 'button-content' },
	            icon,
	            textElement
	        )
	    );
	};
	
	// Styles
	// Lib
	
	
	ToolButton.propTypes = {
	    icon: _propTypes2.default.object,
	    text: _propTypes2.default.string,
	    onClickFn: _propTypes2.default.func,
	    className: _propTypes2.default.string
	};
	
	exports.default = ToolButton;

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.toggleCaption = exports.setHideCaption = exports.setShowCaption = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _selectionActions = __webpack_require__(55);
	
	var _elementActions = __webpack_require__(26);
	
	var _elementSelector = __webpack_require__(41);
	
	var _elementCaptionUtil = __webpack_require__(137);
	
	var _analytics = __webpack_require__(47);
	
	var _captionConstants = __webpack_require__(293);
	
	// Utils
	var changeCaption = function changeCaption(desiredShowCaptionState) {
	    return function (_ref) {
	        var elementId = _ref.elementId;
	        return function (dispatch, getState) {
	            var state = getState();
	            var element = (0, _elementSelector.getElement)(state, { elementId: elementId });
	
	            // If already hiding the caption then no need to fire event
	            if ((0, _elementCaptionUtil.getShowCaption)(element) === desiredShowCaptionState) return;
	
	            dispatch((0, _elementActions.updateElement)({
	                id: elementId,
	                changes: { showCaption: desiredShowCaptionState }
	            }));
	        };
	    };
	};
	
	// Constants
	// Actions
	var setShowCaption = exports.setShowCaption = changeCaption(true);
	var setHideCaption = exports.setHideCaption = changeCaption(false);
	
	var toggleCaption = exports.toggleCaption = function toggleCaption() {
	    return function (dispatch, getState) {
	        var state = getState();
	        var elementId = state.getIn(['app', 'selection', 'ids']).first();
	        var element = state.get('elements').get(elementId);
	
	        var showingCaption = (0, _elementCaptionUtil.getShowCaption)(element);
	
	        var addedRemoved = showingCaption ? 'removed' : 'added';
	        (0, _analytics.analyticsEvent)(addedRemoved + '-' + element.get('elementType') + '-caption');
	
	        dispatch((0, _elementActions.updateElement)({
	            id: elementId,
	            changes: { showCaption: !showingCaption }
	        }));
	
	        // Need to use a timeout so that the hiding & showing of the caption occurs AFTER the simpleTextEditor
	        // performs its content updates.  Otherwise undo / redo would not be seen by the user.
	        (0, _lodash.defer)(function () {
	            if (!showingCaption) {
	                dispatch((0, _selectionActions.startEditingElement)({ id: elementId, editorKey: _captionConstants.CAPTION_EDITOR_KEY }));
	            } else {
	                dispatch((0, _selectionActions.finishEditingElement)());
	            }
	        });
	    };
	};

/***/ }),
/* 678 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getConnections = exports.getConnections = function getConnections(state) {
	  return state.get('connections');
	};

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _draftJs = __webpack_require__(39);
	
	var _draftjsConstants = __webpack_require__(121);
	
	// From https://github.com/ngs/draft-js-markdown-shortcuts-plugin
	// Lib
	exports.default = function (editorState, type, text) {
	    var blockMetadata = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	    if (!type) return editorState;
	    var currentContent = editorState.getCurrentContent();
	    var selection = editorState.getSelection();
	    var key = selection.getStartKey();
	    var blockMap = currentContent.getBlockMap();
	    var block = blockMap.get(key);
	    var data = block.getData().merge(blockMetadata);
	    var newBlock = block.merge({ type: type, data: data, text: text || '' });
	    var newSelection = selection.merge({ anchorOffset: 0, focusOffset: 0 });
	    var newContentState = currentContent.merge({
	        blockMap: blockMap.set(key, newBlock),
	        selectionAfter: newSelection
	    });
	    return _draftJs.EditorState.push(editorState, newContentState, _draftjsConstants.EditorChangeType.CHANGE_BLOCK_TYPE);
	};
	
	// Constants

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _draftJs = __webpack_require__(39);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Updates the metadata for a given key.
	 * If the metadata is null the key will be deleted from the metadata map.
	 *
	 * @param block {Object} The block to update metadata for.
	 * @param metadata {Object} The data to store against the block key in the metadata map.  If null the key will be
	 *          removed from the map.
	 * @param editorState {Function} The function to retrieve the editor state.
	 */
	exports.default = function (editorState, block, metadata) {
	    var blockKey = block.getKey();
	    var contentState = editorState.getCurrentContent();
	    var updatedBlock = contentState.getBlockForKey(blockKey).mergeIn(['data'], metadata);
	
	    var blockMap = contentState.getBlockMap();
	    blockMap = blockMap.merge(_defineProperty({}, blockKey, updatedBlock));
	    contentState = contentState.merge({ blockMap: blockMap });
	
	    // TODO use a constant for the change description
	    return _draftJs.EditorState.push(editorState, contentState, 'change-block-metadata');
	};

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RichTextEditor = exports.SimpleTextEditor = undefined;
	
	var _SimpleTextEditor2 = __webpack_require__(1746);
	
	var _SimpleTextEditor3 = _interopRequireDefault(_SimpleTextEditor2);
	
	var _RichTextEditor2 = __webpack_require__(1745);
	
	var _RichTextEditor3 = _interopRequireDefault(_RichTextEditor2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.SimpleTextEditor = _SimpleTextEditor3.default;
	exports.RichTextEditor = _RichTextEditor3.default;

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _draftJs = __webpack_require__(39);
	
	var _draftJsPluginsEditor = __webpack_require__(1048);
	
	var _draftJsPluginsEditor2 = _interopRequireDefault(_draftJsPluginsEditor);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _recompose = __webpack_require__(9);
	
	var _lodash = __webpack_require__(4);
	
	var _textEditorStoreConnector = __webpack_require__(1748);
	
	var _textEditorStoreConnector2 = _interopRequireDefault(_textEditorStoreConnector);
	
	var _rICThrottle = __webpack_require__(2296);
	
	var _rICThrottle2 = _interopRequireDefault(_rICThrottle);
	
	var _forceBlur = __webpack_require__(1714);
	
	var _forceBlur2 = _interopRequireDefault(_forceBlur);
	
	var _editorPropComparisons = __webpack_require__(1717);
	
	var _selectionUtils = __webpack_require__(458);
	
	var _createCompositeDecorator = __webpack_require__(1727);
	
	var _createCompositeDecorator2 = _interopRequireDefault(_createCompositeDecorator);
	
	var _textConstants = __webpack_require__(1754);
	
	__webpack_require__(1121);
	
	__webpack_require__(1138);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	// Editor store
	
	
	// Utils
	
	
	// Plugins
	
	
	// Constants
	
	
	// Styles
	
	
	exports.default = function (plugins, config) {
	    var _class;
	
	    // Used when the redux state updates outside of the user's edits
	    var decorator = (0, _createCompositeDecorator2.default)(plugins);
	
	    var MilanoteEditor = (0, _recompose.pure)(_class = (0, _textEditorStoreConnector2.default)(_class = function (_React$Component) {
	        _inherits(MilanoteEditor, _React$Component);
	
	        _createClass(MilanoteEditor, null, [{
	            key: 'buildFromTextContent',
	            value: function buildFromTextContent(textContent) {
	                var contentState = (0, _lodash.isString)(textContent) ? _draftJs.ContentState.createFromText(textContent) : (0, _draftJs.convertFromRaw)(_extends({ entityMap: {}, blocks: [] }, textContent.toJS()));
	
	                return _draftJs.EditorState.createWithContent(contentState, decorator);
	            }
	        }, {
	            key: 'buildEditorState',
	            value: function buildEditorState(textContent) {
	                return textContent ? MilanoteEditor.buildFromTextContent(textContent) : _draftJs.EditorState.createEmpty(decorator);
	            }
	        }]);
	
	        function MilanoteEditor(props) {
	            _classCallCheck(this, MilanoteEditor);
	
	            var _this = _possibleConstructorReturn(this, (MilanoteEditor.__proto__ || Object.getPrototypeOf(MilanoteEditor)).call(this, props));
	
	            _initialiseProps.call(_this);
	
	            var textContent = _this.props.textContent;
	
	            var editorState = MilanoteEditor.buildEditorState(textContent);
	
	            // These counts are used to determine whether enough changes have been made to force an update to the server.
	            _this.lastSavedContent = editorState.getCurrentContent();
	
	            _this.state = { editorState: editorState };
	            return _this;
	        }
	
	        _createClass(MilanoteEditor, [{
	            key: 'componentDidMount',
	            value: function componentDidMount() {
	                if (this.props.isEditing && this.editor) {
	                    this.editor.focus();
	                    this.onChange(_draftJs.EditorState.moveFocusToEnd(this.state.editorState));
	                }
	            }
	
	            /**
	             * Checks the next props to see if the component has changed from editing to not-editing, or vice versa.
	             * If changing to editing the component will gain focus.
	             * If changing to not-editing the component will fire the update action to save any changes.
	             *
	             * If there are changes to the components text content this will also update the editorState with those changes.
	             */
	
	        }, {
	            key: 'componentWillReceiveProps',
	            value: function componentWillReceiveProps(nextProps) {
	                if ((0, _editorPropComparisons.stayedEditingElement)(this.props, nextProps) && (0, _editorPropComparisons.editorStateHasChanged)(this.props, nextProps)) {
	                    this.setEditorState(nextProps.editorState);
	                }
	
	                if ((0, _editorPropComparisons.noLongerEditingThisEditor)(this.props, nextProps)) {
	                    this.saveCurrentContent();
	                }
	
	                if ((0, _editorPropComparisons.stayedEditingElement)(this.props, nextProps)) {
	                    return;
	                }
	
	                if ((0, _editorPropComparisons.noLongerEditingElement)(this.props, nextProps)) {
	                    this.forceEditorBlur();
	                    return;
	                }
	
	                if ((0, _editorPropComparisons.textContentHasChanged)(this.props, nextProps)) {
	                    var editorState = MilanoteEditor.buildEditorState(nextProps.textContent);
	                    this.lastSavedContent = editorState.getCurrentContent();
	                    this.setEditorState(editorState);
	                }
	            }
	        }, {
	            key: 'componentDidUpdate',
	            value: function componentDidUpdate(oldProps) {
	                if ((0, _editorPropComparisons.startedEditingThisElement)(oldProps, this.props)) {
	                    // The focus() is required by Firefox because it will not focus the editor DOM element if it's read
	                    // only.  Thus we need to wait for the editor to become editable, then force focus to the editor and
	                    // finally move the cursor to the end of the text area.
	                    this.editor.focus();
	                    this.onChange(_draftJs.EditorState.moveFocusToEnd(this.state.editorState));
	                }
	            }
	
	            /**
	             * Ensure all timers and updates are complete or flushed when unmounting component.
	             */
	
	        }, {
	            key: 'componentWillUnmount',
	            value: function componentWillUnmount() {
	                // Force save (and clear of timers) on unmount
	                this.saveCurrentContent();
	            }
	
	            /**
	             * Saves the new editor state to the internal state of this component, and also fires a Redux action to update
	             * the current editors editorState.
	             *
	             * This is used so that updates made by the user while typing will be reflected in the view.
	             */
	
	
	            /**
	             * Prevent the mouse down event from bubbling to the canvas so that the 'edit complete' action doesn't fire.
	             */
	
	
	            /**
	             * Fires a redux action when this editor becomes focused so that the application can keep track of the editor that's
	             * currently active.
	             */
	
	
	            // This is needed because draft is not blurring automatically when focus is moved to another editor
	
	        }, {
	            key: 'render',
	            value: function render() {
	                var _this2 = this;
	
	                var _props = this.props,
	                    isEditing = _props.isEditing,
	                    isEditable = _props.isEditable,
	                    className = _props.className;
	                var editorState = this.state.editorState;
	
	
	                var classes = {
	                    editing: (0, _editorPropComparisons.currentlyEditingThisEditor)(this.props)
	                };
	
	                return _react2.default.createElement(
	                    'div',
	                    { className: (0, _classnames2.default)('Editor', config.className, className, classes),
	                        tabIndex: '-1',
	                        onMouseDown: this.onMouseDown,
	                        onClick: this.focusOnEditor },
	                    _react2.default.createElement(_draftJsPluginsEditor2.default, _extends({ ref: function ref(c) {
	                            _this2.editor = c;
	                        }
	                    }, this.props, {
	                        saveCurrentContent: this.saveCurrentContent,
	                        defaultBlockRenderMap: true,
	                        editorState: editorState,
	                        onChange: this.onChange,
	                        onFocus: this.focusOnEditor,
	                        readOnly: !(isEditable && isEditing),
	                        plugins: plugins,
	                        spellCheck: true }))
	                );
	            }
	        }]);
	
	        return MilanoteEditor;
	    }(_react2.default.Component)) || _class) || _class;
	
	    var _initialiseProps = function _initialiseProps() {
	        var _this3 = this;
	
	        this.onChange = function (editorState) {
	            if (!_this3.props.isEditable) return;
	
	            // The content has changed restart the debounce
	            _this3.clearDebounceTimer();
	
	            var currentContent = _this3.state.editorState.getCurrentContent();
	            var newContent = editorState.getCurrentContent();
	
	            var lastSavedBlockCount = _this3.lastSavedContent.getBlockMap().size;
	            var newBlockCount = newContent.getBlockMap().size;
	
	            // If the content has not changed a focus change has occurred
	            // and if the content is not the same as the last saved content then it should be saved.
	            // Or if a new line has been created or deleted then it should be saved.
	            var contentHasChanged = currentContent !== newContent;
	            var shouldSave = lastSavedBlockCount !== newBlockCount || !_this3.props.isEditing;
	            if (shouldSave) {
	                _this3.saveData(editorState);
	            } else if (contentHasChanged) {
	                _this3.changeDebounceTimer = setTimeout(function () {
	                    return _this3.saveData(editorState);
	                }, _textConstants.DEFAULT_SAVE_TIMEOUT);
	            }
	
	            _this3.props.editorStateChanged({ editorId: _this3.props.editorId, editorState: editorState });
	        };
	
	        this.onMouseDown = function (event) {
	            if (_this3.props.isEditing) event.stopPropagation();
	        };
	
	        this.setEditorState = function (editorState) {
	            _this3.setState({ editorState: editorState });
	        };
	
	        this.clearDebounceTimer = function () {
	            if (_this3.changeDebounceTimer) clearTimeout(_this3.changeDebounceTimer);
	            _this3.saveDataOnIdle.cancel();
	        };
	
	        this.saveData = function (editorState) {
	            // If a timer is still running clear it
	            _this3.clearDebounceTimer();
	
	            var currentContent = editorState.getCurrentContent();
	            // Don't save if the last saved content is the same as the currently saved content
	            if (_this3.lastSavedContent === currentContent) return;
	            _this3.lastSavedContent = currentContent;
	
	            var saveContent = _this3.props.saveContent;
	
	
	            var textContent = (0, _draftJs.convertToRaw)(currentContent);
	
	            // Defer the saving of content until CPU time is available
	            saveContent && saveContent(textContent);
	        };
	
	        this.saveDataOnIdle = (0, _rICThrottle2.default)(this.saveData);
	
	        this.focusOnEditor = function (event) {
	            var editorKey = _this3.props.editorKey;
	
	            if ((0, _selectionUtils.isAttemptingMultiSelect)(event) || (0, _editorPropComparisons.currentlyEditingThisEditor)(_this3.props)) return;
	
	            _this3.props.startEditing(editorKey);
	        };
	
	        this.forceEditorBlur = function () {
	            // This doesn't seem to do anything as far as setting the editor state, it just feels correct
	            _this3.editor.blur();
	            var updatedEditorState = (0, _forceBlur2.default)(_this3.state.editorState);
	            // Don't need all the onChange checks for this state
	            _this3.setEditorState(updatedEditorState);
	        };
	
	        this.saveCurrentContent = function () {
	            _this3.saveData(_this3.state.editorState);
	        };
	    };
	
	    MilanoteEditor.propTypes = {
	        editorState: _propTypes2.default.object,
	        editorId: _propTypes2.default.string.isRequired,
	        editorKey: _propTypes2.default.string.isRequired,
	        textContent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	        className: _propTypes2.default.string,
	        isEditing: _propTypes2.default.bool,
	        isEditable: _propTypes2.default.bool,
	        editorStateChanged: _propTypes2.default.func,
	        saveContent: _propTypes2.default.func,
	        startEditing: _propTypes2.default.func,
	        stopEditing: _propTypes2.default.func
	    };
	
	    return MilanoteEditor;
	};

/***/ }),
/* 683 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var EMPTY_DELETE = exports.EMPTY_DELETE = 'empty-delete';

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keyBindingFn = __webpack_require__(1729);
	
	var _keyBindingFn2 = _interopRequireDefault(_keyBindingFn);
	
	var _handleKeyCommand = __webpack_require__(1728);
	
	var _handleKeyCommand2 = _interopRequireDefault(_handleKeyCommand);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Requires the props:
	 *  - saveCurrentContent, and
	 *  - emptyDelete
	 */
	exports.default = function () {
	  return {
	    keyBindingFn: _keyBindingFn2.default,
	    handleKeyCommand: _handleKeyCommand2.default
	  };
	};

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _handleKeyCommand = __webpack_require__(1730);
	
	var _handleKeyCommand2 = _interopRequireDefault(_handleKeyCommand);
	
	var _handleReturn = __webpack_require__(1731);
	
	var _handleReturn2 = _interopRequireDefault(_handleReturn);
	
	var _onTab = __webpack_require__(1732);
	
	var _onTab2 = _interopRequireDefault(_onTab);
	
	__webpack_require__(1141);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * TODO Should this instead be called styledText or something similar maybe?
	 */
	// Handlers
	exports.default = function () {
	    return {
	        // Allows cmd+b etc to be used to style text
	        handleKeyCommand: _handleKeyCommand2.default,
	        // Provides editing help such as removing certain block styles on enter, or adding soft new lines.
	        handleReturn: _handleReturn2.default,
	        // Allows deep lists
	        onTab: _onTab2.default
	    };
	};
	
	// Styles

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _draftJsLinkifyPlugin = __webpack_require__(1040);
	
	var _draftJsLinkifyPlugin2 = _interopRequireDefault(_draftJsLinkifyPlugin);
	
	var _DraftLinkAnchor = __webpack_require__(1733);
	
	var _DraftLinkAnchor2 = _interopRequireDefault(_DraftLinkAnchor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Lib
	exports.default = function () {
	    return (0, _draftJsLinkifyPlugin2.default)({
	        target: '_blank',
	        component: _DraftLinkAnchor2.default
	    });
	};
	
	// Components

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _handleReturn = __webpack_require__(1740);
	
	var _handleReturn2 = _interopRequireDefault(_handleReturn);
	
	var _onEscape = __webpack_require__(1741);
	
	var _onEscape2 = _interopRequireDefault(_onEscape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Requires the following props:
	 *  - stopEditing
	 */
	// Handlers
	exports.default = function () {
	  return {
	    handleReturn: _handleReturn2.default,
	    // Stop editing on escape
	    onEscape: _onEscape2.default
	  };
	};

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _onBlur = __webpack_require__(1744);
	
	var _onBlur2 = _interopRequireDefault(_onBlur);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Requires the following props:
	 *  - stopEditing
	 */
	exports.default = function () {
	  return {
	    // Stop editing on escape
	    onBlur: _onBlur2.default
	  };
	}; // Handlers

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Constants
	
	
	var _reactRedux = __webpack_require__(3);
	
	var _editorConstants = __webpack_require__(197);
	
	exports.default = function () {
	    var opts = _extends({}, arguments.length <= 3 ? undefined : arguments[3], {
	        storeKey: _editorConstants.EDITOR_STORE_NAME,
	        getDisplayName: function getDisplayName(component) {
	            return 'EditorStoreConnect(' + component + ')';
	        }
	    });
	    return (0, _reactRedux.connect)(arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 1 ? undefined : arguments[1], arguments.length <= 2 ? undefined : arguments[2], opts);
	};

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.editorStyleChange = exports.editorStateChanged = undefined;
	
	var _editorConstants = __webpack_require__(197);
	
	var editorStateChanged = exports.editorStateChanged = function editorStateChanged(_ref) {
	    var editorId = _ref.editorId,
	        editorState = _ref.editorState;
	    return {
	        type: _editorConstants.EDITOR_STATE_CHANGED,
	        editorId: editorId,
	        editorState: editorState
	    };
	}; // Constants
	var editorStyleChange = exports.editorStyleChange = function editorStyleChange(_ref2) {
	    var styleCommand = _ref2.styleCommand,
	        selection = _ref2.selection;
	    return {
	        type: _editorConstants.EDITOR_STYLE_COMMAND,
	        styleCommand: styleCommand,
	        selection: selection
	    };
	};

/***/ }),
/* 691 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getEditorState = exports.getEditorState = function getEditorState(state) {
	  return state.get('editorState');
	};
	var getEditorId = exports.getEditorId = function getEditorId(state) {
	  return state.get('editorId');
	};

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reselect = __webpack_require__(7);
	
	var getIsElectron = function getIsElectron() {
	    return ("production") === 'electron';
	};
	
	exports.default = (0, _reselect.createStructuredSelector)({
	    isElectron: getIsElectron
	});

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.searchForIcon = undefined;
	
	var _http = __webpack_require__(76);
	
	var _http2 = _interopRequireDefault(_http);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var searchForIcon = exports.searchForIcon = function searchForIcon(query, count) {
	    var requestConfig = {
	        url: 'icons',
	        params: {
	            search: query.toLowerCase(),
	            count: count
	        },
	        timeout: 10000
	    };
	
	    return (0, _http2.default)(requestConfig);
	};

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LinkButton = __webpack_require__(74);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	__webpack_require__(1145);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	// Lib
	var RetryErrorComponent = function RetryErrorComponent(_ref) {
	    var message = _ref.message,
	        retryFn = _ref.retryFn;
	    return _react2.default.createElement(
	        'div',
	        { className: 'RetryErrorComponent' },
	        _react2.default.createElement(
	            'span',
	            { className: 'message' },
	            message
	        ),
	        _react2.default.createElement(
	            _LinkButton2.default,
	            { className: 'error', onClickFn: retryFn },
	            'Try again'
	        )
	    );
	};
	
	// Styles
	
	
	RetryErrorComponent.propTypes = {
	    message: _propTypes2.default.string.isRequired,
	    retryFn: _propTypes2.default.func.isRequired
	};
	
	exports.default = RetryErrorComponent;

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setBrowserUnsupportedAcknowledgement = exports.getBrowserUnsupportedAcknowledgement = exports.isSupportedBrowser = exports.validateRequiredFeatures = exports.LOCAL_STORAGE_FEATURE_NAME = undefined;
	
	var _REQUIRED_FEATURES;
	
	var _lodash = __webpack_require__(4);
	
	var _localStorage = __webpack_require__(314);
	
	var _localStorage2 = _interopRequireDefault(_localStorage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // Lib
	
	
	// Services
	
	
	/**
	 * Feature detection extracted from Modernizr's source:
	 * https://github.com/Modernizr/Modernizr/tree/master/feature-detects
	 */
	function createElement() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	    }
	
	    if (typeof document.createElement !== 'function') {
	        // This is the case in IE7, where the type of createElement is "object".
	        // For this reason, we cannot call apply() as Object is not a Function.
	        return document.createElement(args[0]);
	    }
	    return document.createElement.apply(document, args);
	}
	
	// Content editable
	var contentEditableTest = function contentEditableTest() {
	    // early bail out
	    if (!('contentEditable' in document.documentElement)) {
	        return;
	    }
	
	    // some mobile browsers (android < 3.0, iOS < 5) claim to support
	    // contentEditable, but but don't really. This test checks to see
	    // confirms whether or not it actually supports it.
	
	    var div = createElement('div');
	    div.contentEditable = true;
	    return div.contentEditable === 'true';
	};
	
	// SVGs
	var svgTest = function svgTest() {
	    return !!document.createElementNS && !!document.createElementNS('http://www.w3.org/2000/svg', 'svg').createSVGRect;
	};
	
	// Web sockets
	var webSocketsTest = function webSocketsTest() {
	    var protocol = 'https:' == location.protocol ? 'wss' : 'ws'; // eslint-disable-line
	
	    if ('WebSocket' in window) {
	        var protoBin = 'binaryType' in WebSocket.prototype;
	        if (protoBin) {
	            return protoBin;
	        }
	        try {
	            return !!new WebSocket(protocol + '://.').binaryType;
	        } catch (e) {
	            // Do nothing
	        }
	    }
	    return false;
	};
	
	// End Modernizr feature detection
	var LOCAL_STORAGE_FEATURE_NAME = exports.LOCAL_STORAGE_FEATURE_NAME = 'localStorage';
	var REQUIRED_FEATURES = (_REQUIRED_FEATURES = {}, _defineProperty(_REQUIRED_FEATURES, LOCAL_STORAGE_FEATURE_NAME, {
	    test: _localStorage.localStorageFeatureTest
	}), _defineProperty(_REQUIRED_FEATURES, 'contentEditable', {
	    test: contentEditableTest
	}), _defineProperty(_REQUIRED_FEATURES, 'svg', {
	    test: svgTest
	}), _defineProperty(_REQUIRED_FEATURES, 'webSockets', {
	    test: webSocketsTest
	}), _REQUIRED_FEATURES);
	
	/**
	 * Check if the required features work on this browser.
	 */
	var validateRequiredFeatures = exports.validateRequiredFeatures = function validateRequiredFeatures() {
	    var isSupported = true;
	    var errors = [];
	
	    (0, _lodash.forOwn)(REQUIRED_FEATURES, function (featureData, featureName) {
	        var featureTestResult = featureData.test();
	        if (!featureTestResult) {
	            console.warn('FEATURE WARNING: Required feature ' + featureName + ' is not supported by this browser');
	            errors.push(featureName);
	        }
	        isSupported = isSupported && featureTestResult;
	    });
	
	    return {
	        isSupported: isSupported,
	        errors: errors
	    };
	};
	
	var isSupportedBrowser = exports.isSupportedBrowser = function isSupportedBrowser() {
	    var supportedBrowserRegex = /Safari|Chrome|Firefox|iPhone|iPad/;
	    var unsupportedBrowserRegex = /Edge|MSIE|rv:11/;
	
	    var userAgent = window.navigator.userAgent || '';
	    return supportedBrowserRegex.test(userAgent) && !unsupportedBrowserRegex.test(userAgent);
	};
	
	var BROWSER_UNSUPPORTED_ACKNOWLEDGEMENT_KEY = 'unsupportedAcknowledgement';
	
	var getBrowserUnsupportedAcknowledgement = exports.getBrowserUnsupportedAcknowledgement = function getBrowserUnsupportedAcknowledgement() {
	    return _localStorage2.default.getItem(BROWSER_UNSUPPORTED_ACKNOWLEDGEMENT_KEY) === 'true';
	};
	
	var setBrowserUnsupportedAcknowledgement = exports.setBrowserUnsupportedAcknowledgement = function setBrowserUnsupportedAcknowledgement() {
	    return _localStorage2.default.setItem(BROWSER_UNSUPPORTED_ACKNOWLEDGEMENT_KEY, true);
	};

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _recompose = __webpack_require__(9);
	
	var _immutableHelper = __webpack_require__(23);
	
	var _navigationActions = __webpack_require__(27);
	
	var _FullScreenErrorModal = __webpack_require__(139);
	
	var _FullScreenErrorModal2 = _interopRequireDefault(_FullScreenErrorModal);
	
	var _ModalActionsList = __webpack_require__(126);
	
	var _ModalActionsList2 = _interopRequireDefault(_ModalActionsList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	
	
	// Util
	// Lib
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        isGuest: state.getIn(['app', 'currentUser', 'isGuest'])
	    };
	};
	
	// Actions
	
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        backToRoot: function backToRoot(event) {
	            event.preventDefault();
	            dispatch((0, _navigationActions.navigateToRootWorkspace)());
	        },
	        backToLogin: function backToLogin(event) {
	            event.preventDefault();
	            dispatch((0, _navigationActions.navigateToLogin)());
	        }
	    };
	};
	
	var GenericErrorModal = function GenericErrorModal(_ref) {
	    var error = _ref.error,
	        showActions = _ref.showActions,
	        isGuest = _ref.isGuest,
	        backToRoot = _ref.backToRoot,
	        backToLogin = _ref.backToLogin,
	        close = _ref.close;
	
	    var titleMessage = (0, _immutableHelper.prop)('message', error) || 'Something went wrong';
	    var description = (0, _immutableHelper.prop)('description', error) || "We apologise for the inconvenience and we're working hard to fix it.  Please try again later.";
	    var code = (0, _immutableHelper.prop)('code', error) || 'UNKNOWN_ERROR';
	
	    var descriptionElement = _react2.default.createElement(
	        'p',
	        null,
	        description
	    );
	    var detailsElement = _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        descriptionElement
	    );
	
	    if (showActions) {
	        var guestActions = [{ text: 'Log in', func: backToLogin }];
	        var loggedInActions = [{ text: 'Return to your workspace', func: backToRoot }];
	        var actions = isGuest ? guestActions : loggedInActions;
	
	        detailsElement = _react2.default.createElement(
	            'div',
	            null,
	            descriptionElement,
	            _react2.default.createElement(_ModalActionsList2.default, { actions: actions })
	        );
	    }
	
	    return _react2.default.createElement(
	        _FullScreenErrorModal2.default,
	        { close: close },
	        _react2.default.createElement(
	            'h2',
	            null,
	            titleMessage
	        ),
	        detailsElement,
	        _react2.default.createElement(
	            'div',
	            { className: 'section' },
	            _react2.default.createElement(
	                'p',
	                null,
	                'Contact ',
	                _react2.default.createElement(
	                    'a',
	                    { href: 'mailto:support@milanote.com' },
	                    'support@milanote.com'
	                ),
	                ' for more help.'
	            ),
	            _react2.default.createElement(
	                'p',
	                { className: 'info' },
	                'Error code: ',
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    code
	                )
	            )
	        )
	    );
	};
	
	GenericErrorModal.propTypes = {
	    error: _propTypes2.default.object,
	    showActions: _propTypes2.default.bool,
	    isGuest: _propTypes2.default.bool,
	    backToRoot: _propTypes2.default.func,
	    backToLogin: _propTypes2.default.func,
	    close: _propTypes2.default.func
	};
	
	var enhance = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps));
	
	exports.default = enhance(GenericErrorModal);

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _immutableHelper = __webpack_require__(23);
	
	var _notificationConstants = __webpack_require__(88);
	
	// Utils
	exports.default = function (_ref) {
	    var subject = _ref.subject,
	        introduction = _ref.introduction,
	        error = _ref.error,
	        boardId = _ref.boardId,
	        currentUser = _ref.currentUser;
	    return 'mailto:' + _notificationConstants.MILANOTE_EMAILS.SUPPORT + '?subject=' + subject + ('&body=Hi Milanote team,\n' + _notificationConstants.URL_ENCODINGS.NEW_LINE + _notificationConstants.URL_ENCODINGS.NEW_LINE + '\n' + introduction + _notificationConstants.URL_ENCODINGS.NEW_LINE + '\nPlease contact ' + currentUser.getIn(['name', 'displayName']) + ' at ' + currentUser.get('email') + '.\n' + _notificationConstants.URL_ENCODINGS.NEW_LINE + _notificationConstants.URL_ENCODINGS.NEW_LINE + '\nThanks\n' + _notificationConstants.URL_ENCODINGS.NEW_LINE + _notificationConstants.URL_ENCODINGS.NEW_LINE + '\nDetails:' + _notificationConstants.URL_ENCODINGS.NEW_LINE + '\n' + _notificationConstants.URL_ENCODINGS.TAB + 'Time: ' + new Date() + _notificationConstants.URL_ENCODINGS.NEW_LINE + '\n' + _notificationConstants.URL_ENCODINGS.TAB + 'Board: ' + boardId + _notificationConstants.URL_ENCODINGS.NEW_LINE + '\n' + _notificationConstants.URL_ENCODINGS.TAB + 'User: ' + currentUser.get('_id') + _notificationConstants.URL_ENCODINGS.NEW_LINE + '\n' + _notificationConstants.URL_ENCODINGS.TAB + 'Error code: ' + (0, _immutableHelper.prop)('code', error) + _notificationConstants.URL_ENCODINGS.NEW_LINE + '\n' + _notificationConstants.URL_ENCODINGS.TAB + 'Error message: ' + (0, _immutableHelper.prop)('message', error) + _notificationConstants.URL_ENCODINGS.NEW_LINE + '\n' + _notificationConstants.URL_ENCODINGS.TAB + 'Error ID: ' + (0, _immutableHelper.prop)('id', error) + _notificationConstants.URL_ENCODINGS.NEW_LINE + '\n');
	};
	
	// Constants

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(1147);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Fieldset = function Fieldset(props) {
	    var disabled = props.disabled,
	        form = props.form,
	        name = props.name,
	        legend = props.legend;
	
	    return _react2.default.createElement(
	        'fieldset',
	        { className: 'Fieldset ' + name, disabled: disabled, form: form, name: name },
	        legend ? _react2.default.createElement(
	            'legend',
	            null,
	            legend
	        ) : null,
	        _react2.default.createElement(
	            'div',
	            { className: 'fieldset-contents' },
	            props.children
	        )
	    );
	};
	
	// Styles
	// Lib
	
	
	Fieldset.propTypes = {
	    disabled: _propTypes2.default.bool,
	    form: _propTypes2.default.string,
	    name: _propTypes2.default.string,
	    legend: _propTypes2.default.string,
	    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
	};
	
	exports.default = Fieldset;

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CreditCard = __webpack_require__(1772);
	
	var _CreditCard2 = _interopRequireDefault(_CreditCard);
	
	var _stripeService = __webpack_require__(432);
	
	__webpack_require__(1150);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreditCardForm = function (_React$Component) {
	    _inherits(CreditCardForm, _React$Component);
	
	    function CreditCardForm() {
	        _classCallCheck(this, CreditCardForm);
	
	        return _possibleConstructorReturn(this, (CreditCardForm.__proto__ || Object.getPrototypeOf(CreditCardForm)).apply(this, arguments));
	    }
	
	    _createClass(CreditCardForm, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            (0, _stripeService.bootStripe)();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'CreditCardForm' },
	                _react2.default.createElement(_CreditCard2.default, this.props)
	            );
	        }
	    }]);
	
	    return CreditCardForm;
	}(_react2.default.Component);
	
	exports.default = CreditCardForm;

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _domUtil = __webpack_require__(107);
	
	__webpack_require__(1152);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StaticURLField = function StaticURLField(_ref) {
	    var url = _ref.url,
	        className = _ref.className;
	    return _react2.default.createElement('input', { className: (0, _classnames2.default)('StaticURLField', className), value: url, onFocus: _domUtil.selectAndCopyInput, readOnly: true });
	};
	
	StaticURLField.propTypes = {
	    url: _propTypes2.default.string,
	    className: _propTypes2.default.string
	};
	
	exports.default = StaticURLField;

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	__webpack_require__(1157);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	var FormPrimaryMessage = function FormPrimaryMessage(_ref) {
	    var icon = _ref.icon,
	        message = _ref.message,
	        children = _ref.children,
	        show = _ref.show,
	        className = _ref.className;
	
	    if (!show) return null;
	
	    return _react2.default.createElement(
	        'p',
	        { className: (0, _classnames2.default)('FormPrimaryMessage', className) },
	        icon ? _react2.default.createElement(_Icon2.default, { name: icon }) : null,
	        message,
	        children
	    );
	};
	
	// Styles
	// Lib
	
	
	FormPrimaryMessage.propTypes = {
	    message: _propTypes2.default.string,
	    icon: _propTypes2.default.string,
	    show: _propTypes2.default.bool,
	    className: _propTypes2.default.string,
	    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
	};
	
	exports.default = FormPrimaryMessage;

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	/**
	 * Provides state management for components that can be in either an editable or read only state.
	 */
	exports.default = function (DecoratedComponent) {
	    var ReadOnlyOrEditableDecorator = function (_React$Component) {
	        _inherits(ReadOnlyOrEditableDecorator, _React$Component);
	
	        function ReadOnlyOrEditableDecorator(props) {
	            _classCallCheck(this, ReadOnlyOrEditableDecorator);
	
	            var _this = _possibleConstructorReturn(this, (ReadOnlyOrEditableDecorator.__proto__ || Object.getPrototypeOf(ReadOnlyOrEditableDecorator)).call(this, props));
	
	            _this.toggleEditing = function () {
	                _this.setState({ isEditing: !_this.state.isEditing });
	            };
	
	            _this.startEditing = function () {
	                _this.setState({ isEditing: true });
	            };
	
	            _this.stopEditing = function () {
	                _this.setState({ isEditing: false });
	            };
	
	            _this.state = { isEditing: false };
	            return _this;
	        }
	
	        _createClass(ReadOnlyOrEditableDecorator, [{
	            key: 'render',
	            value: function render() {
	                var isEditing = this.state.isEditing;
	
	                return _react2.default.createElement(DecoratedComponent, _extends({
	                    isEditing: isEditing,
	                    toggleEditing: this.toggleEditing,
	                    startEditing: this.startEditing,
	                    stopEditing: this.stopEditing
	                }, this.props));
	            }
	        }]);
	
	        return ReadOnlyOrEditableDecorator;
	    }(_react2.default.Component);
	
	    ReadOnlyOrEditableDecorator.propTypes = {};
	
	    return ReadOnlyOrEditableDecorator;
	};

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(1159);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MilanoteLogotype = function MilanoteLogotype(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'MilanoteLogotype ' + props.className },
	        _react2.default.createElement('img', { src: __webpack_require__(2322) }),
	        _react2.default.createElement(
	            'span',
	            null,
	            'Milanote'
	        )
	    );
	};
	
	MilanoteLogotype.propTypes = {
	    className: _propTypes2.default.string,
	    white: _propTypes2.default.bool
	};
	
	exports.default = MilanoteLogotype;

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _imageHelper = __webpack_require__(1984);
	
	var _logger = __webpack_require__(128);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _mediaConstants = __webpack_require__(148);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This component renders the appropriately sized image based on the size of the image and the image sizes available
	 * to select from.
	 */
	// Lib
	var ResponsiveImageFACC = function ResponsiveImageFACC(_ref) {
	    var imageType = _ref.imageType,
	        imageDetails = _ref.imageDetails,
	        size = _ref.size,
	        children = _ref.children;
	
	    if (!imageDetails) return null;
	
	    var imageName = (0, _imageHelper.getResponsiveImageName)(size, _mediaConstants.IMAGE_TYPE_CONFIGS[imageType].sizes);
	    var imageSource = imageDetails.get(imageName);
	
	    if (!imageSource) {
	        _logger2.default.warn('Expected a source \'' + imageSource + '\' but unable to find it', imageSource);
	        return null;
	    }
	
	    return children(imageSource);
	};
	
	// Constants
	
	
	// Util
	
	
	ResponsiveImageFACC.propTypes = {
	    imageType: _propTypes2.default.string.isRequired,
	    imageDetails: _propTypes2.default.object.isRequired,
	    children: _propTypes2.default.func.isRequired,
	    size: _propTypes2.default.number.isRequired
	};
	
	exports.default = ResponsiveImageFACC;

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class; // Lib
	
	
	// Actions
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(4);
	
	var _progressiveImageActions = __webpack_require__(1904);
	
	__webpack_require__(555);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IMAGE_FADE_TIMEOUT = 300;
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        hasLoaded: state.getIn(['app', 'progressiveImages', ownProps.source])
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        onImageLoad: function onImageLoad() {
	            dispatch((0, _progressiveImageActions.markImageAsLoaded)({ source: ownProps.source }));
	            // If an onload callback is provided invoke it now
	            ownProps.onImageLoadCb && ownProps.onImageLoadCb();
	        }
	    };
	};
	
	/**
	 * Shows an image which progressively becomes better quality by first showing a thumbnail of the image,
	 * and then, once the larger version has loaded, replaces the thumbnail with the full size image.
	 *
	 * NOTE: The component initially shows the source file because it would otherwise cause a flash of content when dragging
	 * an element that has already loaded.
	 * Now there will be a slight flash when the image has not yet loaded, but that's an acceptable trade off.
	 */
	var ProgressiveImageFACC = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_React$Component) {
	    _inherits(ProgressiveImageFACC, _React$Component);
	
	    function ProgressiveImageFACC(props) {
	        _classCallCheck(this, ProgressiveImageFACC);
	
	        var _this = _possibleConstructorReturn(this, (ProgressiveImageFACC.__proto__ || Object.getPrototypeOf(ProgressiveImageFACC)).call(this, props));
	
	        _this.fetchThenShowImage = function (source, onImageLoadFn) {
	            _this.img = new Image();
	            _this.img.src = source;
	            _this.img.onload = function () {
	                _this.setState({
	                    initialLoad: false,
	                    visibleSource: source
	                });
	
	                // Make sure the transparent fade has finished before switching the image
	                (0, _lodash.delay)(function () {
	                    return onImageLoadFn(source);
	                }, IMAGE_FADE_TIMEOUT);
	            };
	        };
	
	        _this.state = {
	            initialLoad: true,
	            visibleSource: props.source
	        };
	        return _this;
	    }
	
	    /**
	     * When the component is added to the DOM, set the source to the thumbnail and then start fetching the full sized
	     * image.
	     */
	
	
	    _createClass(ProgressiveImageFACC, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                source = _props.source,
	                onImageLoad = _props.onImageLoad,
	                hasLoaded = _props.hasLoaded;
	
	            // Fetch the real source, and once it's loaded set its state
	
	            !hasLoaded && this.fetchThenShowImage(source, onImageLoad);
	        }
	
	        /**
	         * If the nextProps change the source, then fetch the new source and then replace it with the current source.
	         */
	
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.source !== this.props.source) {
	                this.fetchThenShowImage(nextProps.source, nextProps.onImageLoad);
	            }
	        }
	
	        /**
	         * Remove callbacks when unmounted.
	         */
	
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this.img) {
	                this.img.onload = function () {
	                    return null;
	                };
	            }
	        }
	
	        /**
	         * Fetches the source and then replaces the state with that source.
	         *
	         * @param source {String} The URL of the source to retrieve.
	         * @param onImageLoadFn {Function} The function to call when an image is loaded.
	         */
	
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                hasLoaded = _props2.hasLoaded,
	                children = _props2.children;
	            var _state = this.state,
	                initialLoad = _state.initialLoad,
	                visibleSource = _state.visibleSource;
	
	            return children({ hideImage: initialLoad && !hasLoaded, visibleSource: visibleSource });
	        }
	    }]);
	
	    return ProgressiveImageFACC;
	}(_react2.default.Component)) || _class);
	
	
	ProgressiveImageFACC.propTypes = {
	    source: _propTypes2.default.string.isRequired,
	    onImageLoad: _propTypes2.default.func,
	    hasLoaded: _propTypes2.default.bool,
	    children: _propTypes2.default.func
	};
	
	exports.default = ProgressiveImageFACC;

/***/ }),
/* 706 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var IMAGE_LOADED = exports.IMAGE_LOADED = 'IMAGE_LOADED';

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _animateFadeDecorator = __webpack_require__(675);
	
	var _animateFadeDecorator2 = _interopRequireDefault(_animateFadeDecorator);
	
	var _MilanoteLogo = __webpack_require__(1783);
	
	var _MilanoteLogo2 = _interopRequireDefault(_MilanoteLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LogoSpinner = function LogoSpinner(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'LogoSpinner' },
	        _react2.default.createElement(_MilanoteLogo2.default, props)
	    );
	};
	
	exports.default = (0, _animateFadeDecorator2.default)()(LogoSpinner);

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PageLoaderMain = __webpack_require__(439);
	
	var _PageLoaderMain2 = _interopRequireDefault(_PageLoaderMain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageLoader = function PageLoader(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'PageLoader Workspace' },
	        _react2.default.createElement(
	            'header',
	            { className: 'AppHeader' },
	            _react2.default.createElement('div', { className: 'header-section header-tools' }),
	            _react2.default.createElement('div', { className: 'header-section CurrentBoardHeader' })
	        ),
	        _react2.default.createElement(_PageLoaderMain2.default, props)
	    );
	};
	
	PageLoader.propTypes = {
	    showQuote: _propTypes2.default.bool
	};
	
	exports.default = PageLoader;

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _recompose = __webpack_require__(9);
	
	var LOADING_STATES = {
	    INITIAL: 'INITIAL',
	    LOADING: 'LOADING',
	    SUCCESS: 'SUCCESS'
	};
	
	var enhance = (0, _recompose.compose)((0, _recompose.withState)('loadingState', 'updateLoadingState', ''), (0, _recompose.withState)('loadingTransitionError', 'updateTransitionError', ''), (0, _recompose.withHandlers)({
	    setLoading: function setLoading(props) {
	        return function (event) {
	            return props.updateLoadingState(LOADING_STATES.LOADING);
	        };
	    },
	    setSuccess: function setSuccess(props) {
	        return function (event) {
	            return props.updateLoadingState(LOADING_STATES.SUCCESS);
	        };
	    },
	    setInitial: function setInitial(props) {
	        return function (event) {
	            return props.updateLoadingState(LOADING_STATES.INITIAL);
	        };
	    },
	    setLoadingError: function setLoadingError(props) {
	        return function (event) {
	            return props.updateTransitionError(event);
	        };
	    },
	    clearLoadingError: function clearLoadingError(props) {
	        return function (event) {
	            return props.updateTransitionError(null);
	        };
	    }
	}), (0, _recompose.withProps)(function (props) {
	    return {
	        isLoading: props.loadingState === LOADING_STATES.LOADING,
	        isSuccessful: props.loadingState === LOADING_STATES.SUCCESS
	    };
	}));
	
	exports.default = enhance;

/***/ }),
/* 710 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MeasurementsRegistry = function MeasurementsRegistry() {
	    var _this = this;
	
	    _classCallCheck(this, MeasurementsRegistry);
	
	    this.registerElement = function (id) {
	        _this.elementReferenceCount[id] = _this.elementReferenceCount[id] || 0;
	        _this.elementReferenceCount[id]++;
	    };
	
	    this.removeElement = function (id) {
	        _this.elementReferenceCount[id]--;
	    };
	
	    this.getElementReferenceCount = function (id) {
	        return _this.elementReferenceCount[id] || 0;
	    };
	
	    this.registerCanvas = function (canvas) {
	        _this.canvas = canvas;
	    };
	
	    this.removeCanvas = function () {
	        _this.canvas = null;
	    };
	
	    this.getCanvasScroll = function () {
	        var canvasRect = _this.canvas && _this.canvas.getBoundingClientRect();
	        return {
	            top: _this.canvas && _this.canvas.scrollTop - canvasRect.top || 0,
	            left: _this.canvas && _this.canvas.scrollLeft - canvasRect.left || 0
	        };
	    };
	
	    this.elementReferenceCount = {};
	}
	
	// This is required to ensure that measurement removal events are not fired prematurely
	;
	
	/**
	 * Initialises an instance, for simplicity, because it's being used on the client side.
	 */
	
	
	var measurementsRegistry = new MeasurementsRegistry();
	exports.default = measurementsRegistry;

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(1166);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Overlay = function Overlay(_ref) {
	    var children = _ref.children;
	    return _react2.default.createElement(
	        'div',
	        { className: 'Overlay' },
	        children
	    );
	};
	
	// Styles
	// Lib
	
	
	Overlay.propTypes = {
	    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
	};
	
	exports.default = Overlay;

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PageContent = __webpack_require__(1917);
	
	var _PageContent2 = _interopRequireDefault(_PageContent);
	
	var _ModalCloseButton = __webpack_require__(1915);
	
	var _ModalCloseButton2 = _interopRequireDefault(_ModalCloseButton);
	
	var _ModalBackButton = __webpack_require__(1914);
	
	var _ModalBackButton2 = _interopRequireDefault(_ModalBackButton);
	
	__webpack_require__(1169);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	// Components
	
	
	// Styles
	
	
	var Modal = function (_React$Component) {
	    _inherits(Modal, _React$Component);
	
	    function Modal() {
	        _classCallCheck(this, Modal);
	
	        return _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).apply(this, arguments));
	    }
	
	    _createClass(Modal, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            document.body.classList.add('modal');
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            document.body.classList.remove('modal');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                children = _props.children,
	                className = _props.className,
	                onClick = _props.onClick;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'modal-container', onClick: onClick },
	                _react2.default.createElement(
	                    'div',
	                    { className: (0, _classnames2.default)('Modal', className) },
	                    _react2.default.createElement(_ModalBackButton2.default, this.props),
	                    _react2.default.createElement(_ModalCloseButton2.default, this.props),
	                    _react2.default.createElement(
	                        _PageContent2.default,
	                        { className: 'modal-content' },
	                        children
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Modal;
	}(_react2.default.Component);
	
	Modal.propTypes = {
	    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array]).isRequired,
	    className: _propTypes2.default.string,
	    onClick: _propTypes2.default.func,
	    close: _propTypes2.default.func
	};
	
	exports.default = Modal;

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class; // Lib
	
	
	// Actions
	
	
	// Selectors
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _navigationActions = __webpack_require__(27);
	
	var _currentBoardIdSelector = __webpack_require__(306);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        currentBoardId: (0, _currentBoardIdSelector.getCurrentBoardId)(state)
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        dispatchNavigateToBoard: function dispatchNavigateToBoard(_ref) {
	            var boardId = _ref.boardId;
	            return dispatch((0, _navigationActions.navigateToBoard)({ boardId: boardId }));
	        }
	    };
	};
	
	var ModalManager = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_React$Component) {
	    _inherits(ModalManager, _React$Component);
	
	    function ModalManager() {
	        var _ref2;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ModalManager);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = ModalManager.__proto__ || Object.getPrototypeOf(ModalManager)).call.apply(_ref2, [this].concat(args))), _this), _this.closeModalAndNavigate = function () {
	            var _this$props = _this.props,
	                currentBoardId = _this$props.currentBoardId,
	                dispatchModalClose = _this$props.dispatchModalClose,
	                dispatchNavigateToBoard = _this$props.dispatchNavigateToBoard;
	
	            dispatchModalClose && dispatchModalClose();
	            dispatchNavigateToBoard({ boardId: currentBoardId });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ModalManager, [{
	        key: 'render',
	        value: function render() {
	            return this.props.children ? _react2.default.cloneElement(this.props.children, {
	                close: this.closeModalAndNavigate
	            }) : null;
	        }
	    }]);
	
	    return ModalManager;
	}(_react2.default.Component)) || _class);
	
	
	ModalManager.propTypes = {
	    dispatchModalClose: _propTypes2.default.func,
	    dispatchNavigateToBoard: _propTypes2.default.func,
	    currentBoardId: _propTypes2.default.string,
	    children: _propTypes2.default.node
	};
	
	exports.default = ModalManager;

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(4);
	
	__webpack_require__(1181);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Lib
	var PopupList = function PopupList(_ref) {
	    var title = _ref.title,
	        actions = _ref.actions,
	        children = _ref.children,
	        list = _ref.list;
	
	    var mappableList = (0, _lodash.isArray)(list) ? list : list.valueSeq();
	    return _react2.default.createElement(
	        'div',
	        { className: 'PopupList' },
	        _react2.default.createElement(
	            'div',
	            { className: 'list-header' },
	            _react2.default.createElement(
	                'span',
	                { className: 'list-title' },
	                title
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'actions' },
	                actions
	            )
	        ),
	        _react2.default.createElement(
	            'ul',
	            { className: 'popup-list' },
	            mappableList.map(function (listItem, index) {
	                return _react2.default.createElement(
	                    'li',
	                    { key: index },
	                    children(listItem, index)
	                );
	            })
	        )
	    );
	};
	
	// Styles
	
	
	PopupList.propTypes = {
	    title: _propTypes2.default.string,
	    actions: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	    children: _propTypes2.default.func.isRequired,
	    list: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object])
	};
	
	exports.default = PopupList;

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _BoardIcon = __webpack_require__(451);
	
	var _BoardIcon2 = _interopRequireDefault(_BoardIcon);
	
	__webpack_require__(1182);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	var BoardPopupListItemLoading = function BoardPopupListItemLoading(props) {
	    return _react2.default.createElement('div', { className: 'BoardPopupListItemLoading' });
	};
	
	// Styles
	// Lib
	
	
	var BoardPopupListItem = function BoardPopupListItem(props) {
	    var linkURL = props.linkURL,
	        board = props.board,
	        users = props.users,
	        navigateToLinkedBoard = props.navigateToLinkedBoard,
	        active = props.active,
	        TimestampComponent = props.TimestampComponent,
	        ActivityComponent = props.ActivityComponent,
	        className = props.className,
	        isNew = props.isNew;
	
	
	    if (!board || !users.length && !users.size) return _react2.default.createElement(BoardPopupListItemLoading, null);
	
	    var _linkURL = linkURL || '/' + board.get('id');
	
	    return _react2.default.createElement(
	        'a',
	        { className: (0, _classnames2.default)('BoardPopupListItem', className, { active: active }),
	            href: _linkURL,
	            onClick: navigateToLinkedBoard },
	        _react2.default.createElement(
	            'div',
	            { className: 'icon' },
	            _react2.default.createElement(_BoardIcon2.default, {
	                icon: board.getIn(['content', 'icon']),
	                element: board,
	                color: board.getIn(['content', 'color']),
	                size: 5 })
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'message' },
	            _react2.default.createElement(
	                'div',
	                { className: 'title' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 'board-name' },
	                    board.getIn(['content', 'title'])
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'timestamp' },
	                _react2.default.createElement(TimestampComponent, props)
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'activity' },
	                _react2.default.createElement(ActivityComponent, props)
	            )
	        ),
	        isNew ? _react2.default.createElement('div', { className: 'new-marker' }) : null
	    );
	};
	
	BoardPopupListItem.propTypes = {
	    linkURL: _propTypes2.default.string,
	    board: _propTypes2.default.object.isRequired,
	    users: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]).isRequired,
	    navigateToLinkedBoard: _propTypes2.default.func,
	    active: _propTypes2.default.bool,
	    isNew: _propTypes2.default.bool,
	    TimestampComponent: _propTypes2.default.func,
	    ActivityComponent: _propTypes2.default.func,
	    className: _propTypes2.default.string
	};
	
	exports.default = BoardPopupListItem;

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	// Actions
	
	
	// Utils
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _navigationActions = __webpack_require__(27);
	
	var _staticResourceUtil = __webpack_require__(443);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Redux connect methods
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        dispatchNavigateToStaticPage: function dispatchNavigateToStaticPage(event) {
	            event.preventDefault();
	            dispatch((0, _navigationActions.navigateToStaticPage)(ownProps.config.resourceName));
	        }
	    };
	};
	
	var StaticPageLink = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec(_class = function (_React$Component) {
	    _inherits(StaticPageLink, _React$Component);
	
	    function StaticPageLink() {
	        _classCallCheck(this, StaticPageLink);
	
	        return _possibleConstructorReturn(this, (StaticPageLink.__proto__ || Object.getPrototypeOf(StaticPageLink)).apply(this, arguments));
	    }
	
	    _createClass(StaticPageLink, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                config = _props.config,
	                dispatchNavigateToStaticPage = _props.dispatchNavigateToStaticPage;
	
	            var href = (0, _staticResourceUtil.getStaticPageUrl)(config.resourceName);
	
	            return _react2.default.createElement(
	                'a',
	                { href: href, onClick: dispatchNavigateToStaticPage },
	                config.displayName
	            );
	        }
	    }]);
	
	    return StaticPageLink;
	}(_react2.default.Component)) || _class);
	
	
	StaticPageLink.propTypes = {
	    config: _propTypes2.default.object.isRequired,
	    dispatchNavigateToStaticPage: _propTypes2.default.func
	};
	
	exports.default = StaticPageLink;

/***/ }),
/* 717 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var RESOURCE_ACTION_TYPES = exports.RESOURCE_ACTION_TYPES = {
	    RESOURCE_FETCH: 'RESOURCE_FETCH',
	    RESOURCE_FETCH_ERROR: 'RESOURCE_FETCH_ERROR',
	    RESOURCE_FETCH_SUCCESS: 'RESOURCE_FETCH_SUCCESS'
	};

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	var _reactDnd = __webpack_require__(72);
	
	var _reactDndHtml5Backend = __webpack_require__(220);
	
	var handleFileDrop = function handleFileDrop(props, monitor, component) {
	    var file = monitor.getItem().files && monitor.getItem().files[0];
	    if (file && props.uploadImage) {
	        props.uploadImage(file);
	    }
	};
	
	var defaultDropSpec = {
	    drop: handleFileDrop
	};
	
	var defaultDropCollect = function defaultDropCollect(connector, monitor) {
	    return {
	        imageConnectDropTarget: connector.dropTarget(),
	        imageIsHovered: monitor.canDrop() && monitor.isOver(),
	        imageCanDrop: monitor.canDrop()
	    };
	};
	
	exports.default = function (customSpec, customCollect) {
	    var collect = customCollect || defaultDropCollect;
	    var spec = _extends({}, defaultDropSpec, customSpec);
	
	    return (0, _reactDnd.DropTarget)(_reactDndHtml5Backend.NativeTypes.FILE, spec, collect);
	};

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.toggleDebugTool = exports.enableDebugTools = undefined;
	
	var _debugConstants = __webpack_require__(298);
	
	var _debugUtil = __webpack_require__(299);
	
	// Constants
	var enableDebugTools = exports.enableDebugTools = function enableDebugTools() {
	    (0, _debugUtil.enableDebug)();
	    return {
	        type: _debugConstants.ENABLE_DEBUG_TOOLS
	    };
	};
	
	// Utils
	var toggleDebugTool = exports.toggleDebugTool = function toggleDebugTool(_ref) {
	    var enabled = _ref.enabled,
	        toolName = _ref.toolName;
	    return {
	        type: _debugConstants.DEBUG_TOOL_TOGGLE,
	        enabled: enabled,
	        toolName: toolName
	    };
	};

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _dec3, _class; // Lib
	
	
	// Components
	
	
	// Styles
	
	
	// Util
	
	
	// Drop Utils
	
	
	// Constants
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reselect = __webpack_require__(7);
	
	var _shallowequal = __webpack_require__(225);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	var _lodash = __webpack_require__(4);
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _recompose = __webpack_require__(9);
	
	var _ElementDropTarget = __webpack_require__(168);
	
	var _ElementDropTarget2 = _interopRequireDefault(_ElementDropTarget);
	
	var _elementLineEdgeDropTarget = __webpack_require__(200);
	
	var _elementLineEdgeDropTarget2 = _interopRequireDefault(_elementLineEdgeDropTarget);
	
	var _navigateOnHoverDecorator = __webpack_require__(727);
	
	var _navigateOnHoverDecorator2 = _interopRequireDefault(_navigateOnHoverDecorator);
	
	var _Board = __webpack_require__(450);
	
	var _Board2 = _interopRequireDefault(_Board);
	
	var _permissionsService = __webpack_require__(75);
	
	var _navigationActions = __webpack_require__(27);
	
	var _elementIconActions = __webpack_require__(1756);
	
	var _inboxDropLocationFn = __webpack_require__(459);
	
	var _inboxDropLocationFn2 = _interopRequireDefault(_inboxDropLocationFn);
	
	var _permissionUtil = __webpack_require__(89);
	
	var _makeCanDropFn = __webpack_require__(300);
	
	var _makeCanDropFn2 = _interopRequireDefault(_makeCanDropFn);
	
	var _preventDropOnSelfPredicate = __webpack_require__(454);
	
	var _preventDropOnSelfPredicate2 = _interopRequireDefault(_preventDropOnSelfPredicate);
	
	var _preventLinePredicate = __webpack_require__(301);
	
	var _preventLinePredicate2 = _interopRequireDefault(_preventLinePredicate);
	
	var _elementConstants = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var dropPermittedSelector = function dropPermittedSelector() {
	    return (0, _reselect.createSelector)(_permissionsService.currentBoardUserPermissionsSelector, (0, _permissionsService.createElementUserPermissionsSelector)(), function (currentBoardPermissions, boardPermissions) {
	        var dropPermitted = (0, _permissionUtil.canWrite)(boardPermissions) && (0, _permissionUtil.canWrite)(currentBoardPermissions) && (0, _permissionUtil.canSave)(boardPermissions) === (0, _permissionUtil.canSave)(currentBoardPermissions);
	        return dropPermitted;
	    });
	};
	
	var makeBoardSelector = function makeBoardSelector() {
	    return (0, _reselect.createSelector)(dropPermittedSelector(), function (dropPermitted) {
	        return { dropPermitted: dropPermitted };
	    });
	};
	
	var mapDispatchToProps = function mapDispatchToProps() {
	    return function (dispatch) {
	        return {
	            dispatchNavigateToBoard: function dispatchNavigateToBoard(boardId, keepSelection) {
	                return dispatch((0, _navigationActions.navigateToBoard)({ boardId: boardId, keepSelection: keepSelection }));
	            },
	            dispatchFindDefaultIcon: function dispatchFindDefaultIcon(id, title, transactionId) {
	                return dispatch((0, _elementIconActions.findDefaultIcon)({ id: id, query: title, transactionId: transactionId }));
	            }
	        };
	    };
	};
	
	var dropTargetConfig = {
	    drop: _inboxDropLocationFn2.default,
	    canDrop: (0, _makeCanDropFn2.default)([_preventDropOnSelfPredicate2.default, _preventLinePredicate2.default])
	};
	
	var BoardContainer = (_dec = (0, _reactRedux.connect)(makeBoardSelector, mapDispatchToProps), _dec2 = (0, _recompose.branch)(function (props) {
	    return props.isAlias;
	}, _lodash.identity, _elementLineEdgeDropTarget2.default), _dec3 = (0, _ElementDropTarget2.default)(dropTargetConfig, _elementConstants.DROP_TARGET_TYPES.BOARD), _dec(_class = _dec2(_class = _dec3(_class = (0, _navigateOnHoverDecorator2.default)(_class = function (_React$Component) {
	    _inherits(BoardContainer, _React$Component);
	
	    function BoardContainer() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, BoardContainer);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BoardContainer.__proto__ || Object.getPrototypeOf(BoardContainer)).call.apply(_ref, [this].concat(args))), _this), _this.onHeadingClick = function (event) {
	            var _this$props = _this.props,
	                isEditing = _this$props.isEditing,
	                element = _this$props.element,
	                startEditing = _this$props.startEditing;
	
	            event.stopPropagation();
	            if (isEditing) return;
	
	            startEditing(element.get('id'));
	        }, _this.onTitleEditDone = function (_ref2) {
	            var title = _ref2.title,
	                transactionId = _ref2.transactionId;
	            var _this$props2 = _this.props,
	                element = _this$props2.element,
	                dispatchFindDefaultIcon = _this$props2.dispatchFindDefaultIcon;
	
	            if (element.getIn(['content', 'icon', 'id'])) return;
	
	            dispatchFindDefaultIcon(element.get('id'), title, transactionId);
	        }, _this.onDoubleClick = function (event) {
	            var elementEvents = _this.props.elementEvents;
	
	            _this.navigateToBoard(event);
	            elementEvents.onDoubleClick(event);
	        }, _this.onClick = function (event) {
	            var _this$props3 = _this.props,
	                documentMode = _this$props3.documentMode,
	                element = _this$props3.element,
	                dispatchNavigateToBoard = _this$props3.dispatchNavigateToBoard,
	                elementEvents = _this$props3.elementEvents;
	
	            if (documentMode) return dispatchNavigateToBoard(element.get('id'));
	            return elementEvents.onClick(event);
	        }, _this.navigateToBoard = function (event) {
	            var _this$props4 = _this.props,
	                element = _this$props4.element,
	                dispatchNavigateToBoard = _this$props4.dispatchNavigateToBoard;
	
	            dispatchNavigateToBoard(element.get('id'));
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(BoardContainer, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var currentlyShowingHoverStyle = this.props.isHovered && this.props.canDrop;
	            var nextShowingHoverStyle = nextProps.isHovered && nextProps.canDrop;
	
	            if (currentlyShowingHoverStyle !== nextShowingHoverStyle) {
	                var domNode = _reactDom2.default.findDOMNode(this);
	                nextShowingHoverStyle ? domNode.classList.add('can-drop') : domNode.classList.remove('can-drop');
	            }
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            // Check for shallow equality on everything.
	            return !(0, _shallowequal2.default)(this.props, nextProps, function (thisValue, nextValue, key) {
	                // Don't update on is hovered or canDrop to prevent re-rendering many times while dragging
	                // Rely on the componentWillReceiveProps to do some class updates imperatively
	                if (key === 'isHovered' || key === 'canDrop') return true;
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(_Board2.default, _extends({}, this.props, {
	                navigateToBoard: this.navigateToBoard,
	                onHeadingClick: this.onHeadingClick,
	                onClick: this.onClick,
	                onDoubleClick: this.onDoubleClick,
	                onTitleEditDone: this.onTitleEditDone }));
	        }
	    }]);
	
	    return BoardContainer;
	}(_react2.default.Component)) || _class) || _class) || _class) || _class);
	exports.default = BoardContainer;
	
	
	BoardContainer.propTypes = {
	    element: _propTypes2.default.object.isRequired,
	    isEditing: _propTypes2.default.bool,
	    documentMode: _propTypes2.default.bool,
	    dispatchFindDefaultIcon: _propTypes2.default.func,
	    dispatchNavigateToBoard: _propTypes2.default.func,
	    startEditing: _propTypes2.default.func,
	    isHovered: _propTypes2.default.bool,
	    canDrop: _propTypes2.default.bool,
	    elementEvents: _propTypes2.default.object,
	    isAlias: _propTypes2.default.bool
	};

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _mediaConstants = __webpack_require__(148);
	
	var _ElementImage = __webpack_require__(437);
	
	var _ElementImage2 = _interopRequireDefault(_ElementImage);
	
	__webpack_require__(1200);
	
	var _gridUtils = __webpack_require__(42);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Styles
	
	
	// Components
	// Lib
	var getStyle = function getStyle(size) {
	    return {
	        width: size,
	        height: size
	    };
	};
	
	var BoardImage = function BoardImage(_ref) {
	    var element = _ref.element,
	        size = _ref.size,
	        gridSize = _ref.gridSize;
	
	    if (!element) return null;
	
	    var actualSize = (0, _gridUtils.gridPointsToPixels)(size, gridSize);
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'BoardImage', style: getStyle(actualSize) },
	        _react2.default.createElement(_ElementImage2.default, {
	            imageType: _mediaConstants.IMAGE_TYPES.BOARD,
	            element: element,
	            size: actualSize,
	            forcedHeight: actualSize,
	            forcedWidth: actualSize })
	    );
	};
	
	BoardImage.propTypes = {
	    element: _propTypes2.default.object,
	    imageData: _propTypes2.default.object,
	    attachmentData: _propTypes2.default.object,
	    size: _propTypes2.default.number,
	    gridSize: _propTypes2.default.number
	};
	
	exports.default = BoardImage;

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	// Components
	
	
	// Helpers
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _editor = __webpack_require__(681);
	
	var _elementUtil = __webpack_require__(105);
	
	var _ColorBar = __webpack_require__(294);
	
	var _ColorBar2 = _interopRequireDefault(_ColorBar);
	
	var _Caption = __webpack_require__(424);
	
	var _Caption2 = _interopRequireDefault(_Caption);
	
	var _ElementUserTag = __webpack_require__(203);
	
	var _ElementUserTag2 = _interopRequireDefault(_ElementUserTag);
	
	var _gridUtils = __webpack_require__(42);
	
	var _elementCaptionUtil = __webpack_require__(137);
	
	var _cardConstants = __webpack_require__(111);
	
	__webpack_require__(1203);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Card = function Card(props) {
	    var element = props.element,
	        gridSize = props.gridSize,
	        inList = props.inList,
	        isEditing = props.isEditing,
	        startEditing = props.startEditing,
	        saveContent = props.saveContent,
	        stopEditing = props.stopEditing,
	        isEditable = props.isEditable,
	        moveElementToTrash = props.moveElementToTrash,
	        currentEditorKey = props.currentEditorKey,
	        createNewCard = props.createNewCard,
	        elementEvents = props.elementEvents;
	
	
	    var classes = (0, _elementUtil.elementClassNames)('Card drag-handle', props);
	
	    var colorName = element.getIn(['content', 'color']);
	    var captionContent = (0, _elementCaptionUtil.getCaption)(element);
	    var captionVisible = (0, _elementCaptionUtil.getShowCaption)(element);
	
	    return _react2.default.createElement(
	        'div',
	        _extends({ id: (0, _elementUtil.getDomElementId)(element.get('id')), className: classes }, elementEvents, {
	            style: (0, _gridUtils.getElementStyle)(34, gridSize, inList) }),
	        _react2.default.createElement(_ColorBar2.default, { colorName: colorName }),
	        _react2.default.createElement(_ElementUserTag2.default, props),
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_editor.RichTextEditor, {
	                className: 'cardContent',
	                textContent: element.getIn(['content', 'textContent']),
	                isEditing: isEditing,
	                saveContent: saveContent,
	                startEditing: startEditing,
	                stopEditing: stopEditing,
	                isEditable: isEditable,
	                onEmptyBackspace: moveElementToTrash,
	                editorId: element.get('id') + '-' + _cardConstants.CARD_TYPE,
	                editorKey: _cardConstants.CARD_TYPE,
	                currentEditorKey: currentEditorKey,
	                createNewCard: createNewCard })
	        ),
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_Caption2.default, _extends({}, props, {
	                showDivider: true,
	                textContent: captionContent,
	                captionVisible: captionVisible }))
	        )
	    );
	};
	
	Card.propTypes = {
	    element: _propTypes2.default.object.isRequired,
	    gridSize: _propTypes2.default.number,
	    inList: _propTypes2.default.string,
	    isSelected: _propTypes2.default.bool,
	    isEditing: _propTypes2.default.bool,
	    isEditable: _propTypes2.default.bool,
	    isHovered: _propTypes2.default.bool,
	    startEditing: _propTypes2.default.func,
	    stopEditing: _propTypes2.default.func,
	    saveContent: _propTypes2.default.func,
	    moveElementToTrash: _propTypes2.default.func,
	    documentMode: _propTypes2.default.bool,
	    currentEditorKey: _propTypes2.default.string,
	    createNewCard: _propTypes2.default.func,
	    onEmptyBackspace: _propTypes2.default.func,
	    saveCaptionContent: _propTypes2.default.func,
	    elementEvents: _propTypes2.default.object
	};
	
	exports.default = Card;

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class; // Lib
	
	
	// Components
	
	
	// Selectors
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _shallowequal = __webpack_require__(225);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	var _lodash = __webpack_require__(4);
	
	var _reselect = __webpack_require__(7);
	
	var _Column = __webpack_require__(1962);
	
	var _Column2 = _interopRequireDefault(_Column);
	
	var _elementSelector = __webpack_require__(2269);
	
	var _containerElementSelector = __webpack_require__(725);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var makeColumnSelector = function makeColumnSelector() {
	    return (0, _reselect.createSelector)((0, _elementSelector.getElementChildrenSorted)(), (0, _containerElementSelector.makeContainerElementChildrenTypesSelector)(), function (children, childrenTypes) {
	        return {
	            children: children,
	            childrenTypes: childrenTypes
	        };
	    });
	};
	
	var ColumnContainer = (_dec = (0, _reactRedux.connect)(makeColumnSelector), _dec(_class = function (_React$Component) {
	    _inherits(ColumnContainer, _React$Component);
	
	    function ColumnContainer() {
	        _classCallCheck(this, ColumnContainer);
	
	        return _possibleConstructorReturn(this, (ColumnContainer.__proto__ || Object.getPrototypeOf(ColumnContainer)).apply(this, arguments));
	    }
	
	    _createClass(ColumnContainer, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            // Check for shallow equality on everything except for ancestorIds.
	            return !(0, _shallowequal2.default)(this.props, nextProps, function (thisValue, nextValue, key) {
	                if (key !== 'children') return;
	                return thisValue === nextValue || (0, _lodash.isEqual)(thisValue, nextValue);
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(_Column2.default, this.props);
	        }
	    }]);
	
	    return ColumnContainer;
	}(_react2.default.Component)) || _class);
	exports.default = ColumnContainer;
	
	
	ColumnContainer.propTypes = {
	    element: _propTypes2.default.object.isRequired,
	    children: _propTypes2.default.array,
	    currentBoardId: _propTypes2.default.string,
	    connectDropTarget: _propTypes2.default.func,
	    isHovered: _propTypes2.default.bool,
	    isPresentational: _propTypes2.default.bool
	};

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _stringUtil = __webpack_require__(58);
	
	var _recompose = __webpack_require__(9);
	
	__webpack_require__(1205);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Lib
	var getChildTypeCount = function getChildTypeCount(childrenTypes, type) {
	    return childrenTypes[type] || 0;
	};
	
	// Styles
	
	
	var showBoardCount = function showBoardCount(childrenTypes) {
	    return !!childrenTypes.board;
	};
	var showCardCount = function showCardCount(childrenTypes) {
	    return !!childrenTypes.card || !showBoardCount(childrenTypes);
	};
	
	var showTypeCount = function showTypeCount(childrenTypes, type) {
	    return type === 'board' ? showBoardCount(childrenTypes) : showCardCount(childrenTypes);
	};
	
	var getChildTypeCountDescription = function getChildTypeCountDescription(childrenTypes, type) {
	    var count = getChildTypeCount(childrenTypes, type);
	    return showTypeCount(childrenTypes, type) ? count + ' ' + (0, _stringUtil.pluralise)(type, count) : '';
	};
	
	var getSeparator = function getSeparator(childrenTypes) {
	    return showCardCount(childrenTypes) && showBoardCount(childrenTypes) ? ', ' : '';
	};
	
	var ContainerElementChildCount = function ContainerElementChildCount(_ref) {
	    var childrenTypes = _ref.childrenTypes,
	        show = _ref.show;
	
	    var boardText = getChildTypeCountDescription(childrenTypes, 'board');
	    var cardText = getChildTypeCountDescription(childrenTypes, 'card');
	    var separator = getSeparator(childrenTypes);
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'ContainerElementChildCount' },
	        _react2.default.createElement(
	            'span',
	            { className: (0, _classnames2.default)('text', { show: show }) },
	            boardText + separator + cardText
	        )
	    );
	};
	
	ContainerElementChildCount.propTypes = {
	    childrenTypes: _propTypes2.default.object,
	    show: _propTypes2.default.bool
	};
	
	exports.default = (0, _recompose.onlyUpdateForPropTypes)(ContainerElementChildCount);

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.makeContainerElementChildrenTypesSelector = undefined;
	
	var _milanoteReselect = __webpack_require__(49);
	
	var _elementHelper = __webpack_require__(13);
	
	var _elementSelector = __webpack_require__(41);
	
	// Utils
	var getElementChildrenSelectionStateSlice = function getElementChildrenSelectionStateSlice(state, ownProps) {
	    var elementId = ownProps.linkedElementId || ownProps.element.get('id');
	    return {
	        elements: (0, _elementSelector.getElements)(state),
	        elementId: elementId,
	        deepChildrenModificationTime: state.getIn(['cache', 'deepChildrenMod', elementId])
	    };
	};
	var elementChildrenSelectorEqualityChecker = function elementChildrenSelectorEqualityChecker(nextStateSlice, prevStateSlice) {
	    return prevStateSlice.deepChildrenModificationTime === nextStateSlice.deepChildrenModificationTime;
	};
	var createCustomElementChildrenSelector = (0, _milanoteReselect.createCustomEqualSelector)(elementChildrenSelectorEqualityChecker);
	var makeElementChildrenSelector = function makeElementChildrenSelector() {
	    return createCustomElementChildrenSelector(getElementChildrenSelectionStateSlice, function (_ref) {
	        var elements = _ref.elements,
	            elementId = _ref.elementId;
	        return (0, _elementHelper.getChildrenDeep)(elements, elementId);
	    });
	};
	
	var makeContainerElementChildrenTypesSelector = exports.makeContainerElementChildrenTypesSelector = function makeContainerElementChildrenTypesSelector() {
	    return (0, _milanoteReselect.createShallowSelector)(makeElementChildrenSelector(), function (children) {
	        return children.filter(function (child) {
	            return (0, _elementHelper.isContent)(child) || (0, _elementHelper.isBoardLike)(child);
	        }).reduce(function (acc, child) {
	            var type = (0, _elementHelper.isBoardLike)(child) ? 'board' : 'card';
	            var typeVal = acc[type];
	            acc[type] = typeVal ? typeVal + 1 : 1;
	            return acc;
	        }, {});
	    });
	};

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _dragAndDropUtils = __webpack_require__(145);
	
	var _boardConstants = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* Drop Target functionality. */
	/*
	 NOTES ON DROP LOCATION:
	 Unfortunately due to some discrepancies between the HTML5DragAndDropBackend and the TouchBackend the TouchBackend
	 does not guarantee the ordering of drop targets at this point in time.
	 This means that the dropping of an element onto another element which is within another element doesn't guarantee
	 that the top element will be the first to execute a drop handler function.
	 For example, if a board is on top of a canvas and a card is dropped onto a board, there's no guarantee that the
	 board's drop handler will fire before the canvas's drop handler.
	 As such we need to make sure that all drop targets that can potentially have other drop targets on top of them
	 check to see if a child has handled the drop before handling it itself.
	 */
	
	
	// Utils
	exports.default = function (props, monitor, component) {
	    // Don't handle the drop if it's already been handled by a child.
	    if ((0, _dragAndDropUtils.dropTargetAlreadyHandled)(monitor, component)) return;
	
	    var domNode = _reactDom2.default.findDOMNode(component);
	    var position = { index: 0 };
	    var dropPermitted = props.dropPermitted;
	
	
	    if (dropPermitted === false) {
	        console.warn("You don't have the permission to modify that board.");
	        return;
	    }
	
	    return {
	        location: {
	            parentId: props.element.get('id'),
	            section: _boardConstants.BOARD_SECTIONS.INBOX,
	            position: position
	        },
	        handledBy: domNode
	    };
	};
	
	// Constants
	// Lib

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _undoRedoActions = __webpack_require__(316);
	
	var _undoRedoSelector = __webpack_require__(474);
	
	var _propsComparisons = __webpack_require__(147);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	// Actions
	
	
	// Selectors
	
	
	// Prop comparisons
	
	
	var isNowHovered = (0, _propsComparisons.now)('isHovered');
	var isNoLongerHovered = (0, _propsComparisons.noLonger)('isHovered');
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        isCurrentlyMoving: (0, _undoRedoSelector.getCurrentOperation)(state) === 'move'
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        dispatchStartMoveOperation: function dispatchStartMoveOperation() {
	            return dispatch((0, _undoRedoActions.startOperation)('move'));
	        }
	    };
	};
	
	exports.default = function (DecoratedComponent) {
	    var _dec, _class;
	
	    var NavigateOnHover = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_React$Component) {
	        _inherits(NavigateOnHover, _React$Component);
	
	        function NavigateOnHover(props) {
	            _classCallCheck(this, NavigateOnHover);
	
	            var _this = _possibleConstructorReturn(this, (NavigateOnHover.__proto__ || Object.getPrototypeOf(NavigateOnHover)).call(this, props));
	
	            _this.prepareToNavigate = function () {
	                _this.setState({ showNavigationFeedback: true });
	                _this.hoveredTimerId = setTimeout(_this.hoveredNavigate, 300);
	            };
	
	            _this.hoveredNavigate = function () {
	                var _this$props = _this.props,
	                    element = _this$props.element,
	                    dispatchNavigateToBoard = _this$props.dispatchNavigateToBoard,
	                    dispatchStartMoveOperation = _this$props.dispatchStartMoveOperation;
	
	                _this.setState({ showNavigationFeedback: false });
	                dispatchStartMoveOperation();
	                dispatchNavigateToBoard(element.get('id'), true);
	            };
	
	            _this.hoveredTimerId = null;
	
	            _this.state = { showNavigationFeedback: false };
	            return _this;
	        }
	
	        _createClass(NavigateOnHover, [{
	            key: 'componentWillReceiveProps',
	            value: function componentWillReceiveProps(nextProps) {
	                if (isNowHovered(this.props, nextProps) && nextProps.canDrop && nextProps.dropPermitted) {
	                    // Delay for longer on the first hover
	                    var timeout = this.props.isCurrentlyMoving ? 400 : 700;
	                    this.hoveredTimerId = setTimeout(this.prepareToNavigate, timeout);
	                }
	
	                if (this.hoveredTimerId && isNoLongerHovered(this.props, nextProps)) {
	                    clearTimeout(this.hoveredTimerId);
	                    this.setState({ showNavigationFeedback: false });
	                }
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                var showNavigationFeedback = this.state.showNavigationFeedback;
	
	
	                return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, { showNavigationFeedback: showNavigationFeedback }));
	            }
	        }]);
	
	        return NavigateOnHover;
	    }(_react2.default.Component)) || _class);
	
	
	    NavigateOnHover.propTypes = {
	        dispatchNavigateToBoard: _propTypes2.default.func,
	        dispatchStartMoveOperation: _propTypes2.default.func,
	        element: _propTypes2.default.object,
	        isCurrentlyMoving: _propTypes2.default.bool
	    };
	
	    return NavigateOnHover;
	};

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.filterElement = undefined;
	
	var _elementHelper = __webpack_require__(13);
	
	var filterElement = exports.filterElement = function filterElement(element, elementFilter) {
	    var modified = element.getIn(['meta', 'significantModified']);
	    var modifiedBy = element.getIn(['meta', 'modifiedBy']);
	    var elementId = (0, _elementHelper.getPhysicalId)(element);
	
	    if (elementFilter.modifiedAfter && (!modified || modified < elementFilter.modifiedAfter)) return false;
	    if (elementFilter.modifiedBefore && (!modified || modified > elementFilter.modifiedBefore)) return false;
	    if (elementFilter.modifiedBy && elementFilter.modifiedBy.indexOf(modifiedBy) === -1) return false;
	    if (elementFilter.ids && elementFilter.ids.indexOf(elementId) === -1) return false;
	
	    return true;
	};

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isMoveToOrFromTrash = exports.isMoveFromTrash = exports.isMoveToTrash = undefined;
	
	var _boardConstants = __webpack_require__(17);
	
	var isTrashMove = function isTrashMove(location) {
	  return location.section === _boardConstants.BOARD_SECTIONS.TRASH;
	}; // Constants
	var isMoveToTrash = exports.isMoveToTrash = function isMoveToTrash(_ref) {
	  var location = _ref.location;
	  return isTrashMove(location);
	};
	var isMoveFromTrash = exports.isMoveFromTrash = function isMoveFromTrash(_ref2) {
	  var from = _ref2.from;
	  return isTrashMove(from);
	};
	var isMoveToOrFromTrash = exports.isMoveToOrFromTrash = function isMoveToOrFromTrash(_ref3) {
	  var location = _ref3.location,
	      from = _ref3.from;
	  return isMoveToTrash({ location: location }) || isMoveFromTrash({ from: from });
	};

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.makeGetElementPixelPosition = exports.getElementGridPosition = undefined;
	
	var _reselect = __webpack_require__(7);
	
	var _fp = __webpack_require__(52);
	
	var _gridSizeSelector = __webpack_require__(66);
	
	var _elementSelector = __webpack_require__(41);
	
	// Selectors
	// Lib
	var getElementGridPosition = exports.getElementGridPosition = function getElementGridPosition(state, ownProps) {
	    return (0, _elementSelector.getElement)(state, ownProps).getIn(['location', 'position']);
	};
	
	var makeGetElementPixelPosition = exports.makeGetElementPixelPosition = function makeGetElementPixelPosition() {
	    return (0, _reselect.createSelector)(getElementGridPosition, _gridSizeSelector.getGridSize, function (elementGridPosition, gridSize) {
	        return elementGridPosition.map((0, _fp.multiply)(gridSize));
	    });
	};

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchElements = exports.fetchElement = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _resources = __webpack_require__(469);
	
	var _resources2 = _interopRequireDefault(_resources);
	
	var _resourceUtil = __webpack_require__(108);
	
	var _elementActions = __webpack_require__(26);
	
	var _elementSelector = __webpack_require__(41);
	
	var _resourceConstants = __webpack_require__(85);
	
	var _immutableHelper = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // Lib
	
	
	// Util
	
	
	// Actions
	
	
	// State selectors
	
	
	// Constants
	
	
	var elementsResource = (0, _resources2.default)(_resourceConstants.RESOURCE_TYPES.elements);
	
	/**
	 * Fetches element from the server
	 *
	 * @param boardId {String} The boardId of the board to fetch from the server.
	 * @param force {Boolean} (Optional) If true this will
	 *
	 * @return {Promise} A promise resolved when the data has been retrieved.
	 */
	var fetchElement = exports.fetchElement = function fetchElement(elementId, force) {
	    return function (dispatch, getState) {
	        var state = getState();
	        var elementResourcesState = (0, _elementSelector.elementsResourcesSelector)(state);
	        var resourceState = elementResourcesState.get(elementId);
	
	        // If we shouldn't fetch the element then resolve immediately
	        if (!(0, _resourceUtil.shouldFetchResource)(force, resourceState)) return Promise.resolve();
	
	        return elementsResource({ dispatch: dispatch, id: elementId }).then(function (response) {
	            if (response.data.error) return response;
	
	            var remoteElement = response.data;
	
	            var elements = _defineProperty({}, remoteElement.id, remoteElement);
	
	            dispatch((0, _elementActions.loadElements)(elements));
	            return response;
	        });
	    };
	};
	
	var fetchElements = exports.fetchElements = function fetchElements(args) {
	    return function (dispatch, getState) {
	        var elementIds = args.elementIds,
	            force = args.force,
	            loadAncestors = args.loadAncestors;
	
	
	        var state = getState();
	        var elementResourcesState = (0, _elementSelector.elementsResourcesSelector)(state);
	
	        var getElementResource = (0, _immutableHelper.propFrom)(elementResourcesState);
	
	        // If we are not forcing the fetch, and we have the element, and it has been fetched or it is fetching
	        // then we don't need to fetch it again
	        var elementIdsToFetch = force ? elementIds : elementIds.filter(function (id) {
	            return (0, _resourceUtil.shouldFetchResource)(force, getElementResource(id));
	        });
	
	        if (!elementIdsToFetch.length) {
	            return Promise.resolve();
	        }
	
	        var httpConf = {
	            timeout: 10000,
	            params: {
	                loadAncestors: loadAncestors
	            }
	        };
	
	        return elementsResource({ dispatch: dispatch, config: httpConf, ids: elementIdsToFetch }).then(function (response) {
	            if (!(0, _lodash.size)(response.data.elements)) return response;
	
	            dispatch((0, _elementActions.loadElements)(response.data.elements));
	            return response;
	        });
	    };
	};

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	// Components
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementUtil = __webpack_require__(105);
	
	var _lodash = __webpack_require__(4);
	
	var _ImageUploader = __webpack_require__(1982);
	
	var _ImageUploader2 = _interopRequireDefault(_ImageUploader);
	
	var _ImageRenderer = __webpack_require__(1981);
	
	var _ImageRenderer2 = _interopRequireDefault(_ImageRenderer);
	
	var _ColorBar = __webpack_require__(294);
	
	var _ColorBar2 = _interopRequireDefault(_ColorBar);
	
	var _Caption = __webpack_require__(424);
	
	var _Caption2 = _interopRequireDefault(_Caption);
	
	var _ElementUserTag = __webpack_require__(203);
	
	var _ElementUserTag2 = _interopRequireDefault(_ElementUserTag);
	
	var _ElementResizeHandle = __webpack_require__(741);
	
	var _ElementResizeHandle2 = _interopRequireDefault(_ElementResizeHandle);
	
	var _elementCaptionUtil = __webpack_require__(137);
	
	var _gridUtils = __webpack_require__(42);
	
	var _elementConstants = __webpack_require__(12);
	
	var _imageConstants = __webpack_require__(87);
	
	__webpack_require__(1209);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Image = function Image(props) {
	    var element = props.element,
	        gridSize = props.gridSize,
	        inList = props.inList,
	        tempSize = props.tempSize,
	        elementEvents = props.elementEvents,
	        isEditable = props.isEditable,
	        isLocked = props.isLocked;
	
	
	    var imageData = element.getIn(['content', 'image']);
	    var hasImage = imageData || element.getIn(['attachment', 'data']);
	
	    var displayElement = hasImage ? _react2.default.createElement(_ImageRenderer2.default, props) : _react2.default.createElement(_ImageUploader2.default, props);
	
	    var colorName = element.getIn(['content', 'color']);
	    var captionContent = (0, _elementCaptionUtil.getCaption)(element);
	    var captionVisible = (0, _elementCaptionUtil.getShowCaption)(element);
	    var imageElementSize = element.getIn(['content', 'width']);
	    var imageWidth = tempSize || imageElementSize || _elementConstants.ELEMENT_DEFAULT_WIDTH;
	
	    var defaultMaxWidth = (0, _lodash.min)([element.getIn(['content', 'image', 'width']), _imageConstants.IMAGE_WIDTH_MAX]);
	
	    var transparent = !captionVisible && !colorName && !element.getIn(['content', 'showBackground']) && imageData && imageData.get('transparent');
	
	    var classes = (0, _elementUtil.elementClassNames)('Image drag-handle', _extends({}, props, { transparent: transparent }));
	    var showSpinner = element.getIn(['attachment', 'fetching']);
	
	    return _react2.default.createElement(
	        'div',
	        _extends({ id: (0, _elementUtil.getDomElementId)(element.get('id')), className: classes,
	            style: (0, _gridUtils.getElementStyle)(imageWidth, gridSize, inList) }, elementEvents),
	        _react2.default.createElement(_ColorBar2.default, { colorName: colorName }),
	        _react2.default.createElement(_ElementUserTag2.default, props),
	        displayElement,
	        _react2.default.createElement(_Caption2.default, _extends({}, props, {
	            showDivider: !hasImage,
	            textContent: captionContent,
	            captionVisible: captionVisible })),
	        _react2.default.createElement(_ElementResizeHandle2.default, _extends({}, props, { minWidth: _imageConstants.IMAGE_MIN_WIDTH_GRID,
	            defaultMaxWidth: defaultMaxWidth,
	            showHandle: !isLocked && isEditable && !showSpinner }))
	    );
	};
	
	Image.propTypes = {
	    element: _propTypes2.default.object.isRequired,
	    gridSize: _propTypes2.default.number,
	    isSelected: _propTypes2.default.bool,
	    isEditing: _propTypes2.default.bool,
	    inList: _propTypes2.default.string,
	    uploadImage: _propTypes2.default.func,
	    isHovered: _propTypes2.default.bool,
	    canDrop: _propTypes2.default.bool,
	    tempSize: _propTypes2.default.number,
	    className: _propTypes2.default.string,
	    documentMode: _propTypes2.default.bool,
	    elementEvents: _propTypes2.default.object,
	    isEditable: _propTypes2.default.bool,
	    isLocked: _propTypes2.default.bool
	};
	
	exports.default = Image;

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Components
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DragHandle = __webpack_require__(734);
	
	var _DragHandle2 = _interopRequireDefault(_DragHandle);
	
	__webpack_require__(1212);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ControlPointDragHandle = function ControlPointDragHandle(props) {
	    return _react2.default.createElement(_DragHandle2.default, _extends({ className: 'ControlPointDragHandle', style: { background: props.color } }, props));
	};
	
	ControlPointDragHandle.propTypes = {
	    pos: _propTypes2.default.object,
	    color: _propTypes2.default.string,
	    show: _propTypes2.default.bool
	};
	
	exports.default = ControlPointDragHandle;

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getHandleStyle = function getHandleStyle(_ref) {
	    var _ref$pos = _ref.pos,
	        x = _ref$pos.x,
	        y = _ref$pos.y;
	    return {
	        left: x,
	        top: y
	    };
	};
	
	var DragHandle = function DragHandle(props) {
	    var show = props.show,
	        className = props.className,
	        style = props.style,
	        connectDragSource = props.connectDragSource,
	        isHitArea = props.isHitArea,
	        snapped = props.snapped,
	        onMouseDown = props.onMouseDown,
	        onDoubleClick = props.onDoubleClick;
	
	    if (!show) return null;
	
	    var handleStyles = _extends({}, getHandleStyle(props), style);
	
	    var wrapperFn = connectDragSource || _lodash.identity;
	    return wrapperFn(_react2.default.createElement('div', { className: (0, _classnames2.default)('DragHandle', className, { 'hit-area': isHitArea, snapped: snapped }),
	        onMouseDown: onMouseDown, onDoubleClick: onDoubleClick,
	        style: handleStyles }));
	};
	
	DragHandle.propTypes = {
	    show: _propTypes2.default.bool,
	    pos: _propTypes2.default.object,
	    className: _propTypes2.default.string,
	    style: _propTypes2.default.object,
	    isHitArea: _propTypes2.default.bool,
	    onMouseDown: _propTypes2.default.func,
	    snapped: _propTypes2.default.bool
	};
	
	exports.default = DragHandle;

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Components
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DragHandle = __webpack_require__(734);
	
	var _DragHandle2 = _interopRequireDefault(_DragHandle);
	
	__webpack_require__(1213);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EdgeDragHandle = function EdgeDragHandle(props) {
	    return _react2.default.createElement(_DragHandle2.default, _extends({ className: 'EdgeDragHandle' }, props));
	};
	
	EdgeDragHandle.propTypes = {
	    show: _propTypes2.default.bool,
	    pos: _propTypes2.default.object
	};
	
	exports.default = EdgeDragHandle;

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _dec3, _class; // Lib
	
	
	// Selectors
	
	
	// Components
	
	
	// Measurements
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reselect = __webpack_require__(7);
	
	var _recompose = __webpack_require__(9);
	
	var _elementSelector = __webpack_require__(41);
	
	var _lineSelector = __webpack_require__(232);
	
	var _Line = __webpack_require__(303);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	var _measurementsConnect = __webpack_require__(123);
	
	var _measurementsConnect2 = _interopRequireDefault(_measurementsConnect);
	
	var _measurementsSelector = __webpack_require__(124);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// TODO Return only the required measurements (the ones that the line edges require)
	var mapMeasurementsStateToProps = function mapMeasurementsStateToProps(connectionsState) {
	    return {
	        measurements: (0, _measurementsSelector.getMeasurementsMap)(connectionsState)
	    };
	};
	
	var makeMapStateToProps = function makeMapStateToProps() {
	    return (0, _reselect.createSelector)(_elementSelector.getElementId, (0, _lineSelector.makeGetEdgesPx)(), _elementSelector.getColourHex, _lineSelector.getLineStartStyle, _lineSelector.getLineEndStyle, _lineSelector.getIsLineStartSnapped, _lineSelector.getIsLineEndSnapped, function (state, ownProps) {
	        return ownProps.isPresentational;
	    }, function (elementId, _ref, colorHex, startStyle, endStyle, startSnapped, endSnapped, isPresentational) {
	        var start = _ref.start,
	            end = _ref.end,
	            startEdgeOrigin = _ref.startEdgeOrigin,
	            endEdgeOrigin = _ref.endEdgeOrigin,
	            controlPoint = _ref.controlPoint,
	            startConnectionRect = _ref.startConnectionRect,
	            endConnectionRect = _ref.endConnectionRect;
	        return {
	            elementId: elementId,
	            start: start,
	            end: end,
	            startConnectionRect: startConnectionRect,
	            endConnectionRect: endConnectionRect,
	            startEdgeOrigin: startEdgeOrigin,
	            endEdgeOrigin: endEdgeOrigin,
	            controlPoint: controlPoint,
	            colorHex: colorHex,
	            startStyle: startStyle,
	            endStyle: endStyle,
	            startSnapped: startSnapped && !isPresentational,
	            endSnapped: endSnapped && !isPresentational
	        };
	    });
	};
	
	var LinePresentationalWrapper = (_dec = (0, _measurementsConnect2.default)(mapMeasurementsStateToProps), _dec2 = (0, _recompose.shouldUpdate)(function (props, nextProps) {
	    return !nextProps.isPresentational;
	}), _dec3 = (0, _reactRedux.connect)(makeMapStateToProps), _dec(_class = _dec2(_class = _dec3(_class = function (_React$Component) {
	    _inherits(LinePresentationalWrapper, _React$Component);
	
	    function LinePresentationalWrapper() {
	        _classCallCheck(this, LinePresentationalWrapper);
	
	        return _possibleConstructorReturn(this, (LinePresentationalWrapper.__proto__ || Object.getPrototypeOf(LinePresentationalWrapper)).apply(this, arguments));
	    }
	
	    _createClass(LinePresentationalWrapper, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                cacheEdges = _props.cacheEdges,
	                start = _props.start,
	                end = _props.end;
	
	            if (cacheEdges) {
	                cacheEdges({ start: start, end: end });
	            }
	
	            return _react2.default.createElement(_Line2.default, this.props);
	        }
	    }]);
	
	    return LinePresentationalWrapper;
	}(_react2.default.Component)) || _class) || _class) || _class);
	
	
	LinePresentationalWrapper.propTypes = {
	    cacheEdges: _propTypes2.default.func,
	    start: _propTypes2.default.object,
	    end: _propTypes2.default.object,
	    isPresentational: _propTypes2.default.bool
	};
	
	exports.default = LinePresentationalWrapper;

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getEndpointSnappedToAngle = undefined;
	
	var _Vector = __webpack_require__(323);
	
	var _Vector2 = _interopRequireDefault(_Vector);
	
	var _point = __webpack_require__(50);
	
	var pointLib = _interopRequireWildcard(_point);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Utils
	var SNAP_ANGLE = 45;
	var DIAGONALLY_DOWN_RIGHT_ANGLE = -45;
	var DIAGONALLY_UP_LEFT_ANGLE = 135;
	var HORIZONTAL_ANGLE = 180;
	var VERTICAL_ANGLE = 90;
	
	var matchDiagonal = function matchDiagonal(inverse) {
	    return function (vector) {
	        var factor = inverse ? -1 : 1;
	        if (Math.abs(vector.x) > Math.abs(vector.y)) return new _Vector2.default(vector.x, factor * vector.x);
	        return new _Vector2.default(factor * vector.y, vector.y);
	    };
	};
	var matchHorizontal = function matchHorizontal(vector) {
	    return new _Vector2.default(vector.x, 0);
	};
	var matchVertical = function matchVertical(vector) {
	    return new _Vector2.default(0, vector.y);
	};
	
	var getSnapAngleRule = function getSnapAngleRule(snappedAngle) {
	    if (snappedAngle % HORIZONTAL_ANGLE === 0) return matchHorizontal;
	    if (snappedAngle % VERTICAL_ANGLE === 0) return matchVertical;
	    var inverseDiagonal = snappedAngle === DIAGONALLY_DOWN_RIGHT_ANGLE || snappedAngle === DIAGONALLY_UP_LEFT_ANGLE;
	    return matchDiagonal(inverseDiagonal);
	};
	
	var getClosestSnappedAngle = function getClosestSnappedAngle(vector) {
	    return Math.round(vector.angleDeg() / SNAP_ANGLE) * SNAP_ANGLE;
	};
	
	var getEndpointSnappedToAngle = exports.getEndpointSnappedToAngle = function getEndpointSnappedToAngle(_ref) {
	    var fixedPoint = _ref.fixedPoint,
	        flexiblePoint = _ref.flexiblePoint;
	
	    // Get the vector between the start and end points
	    var lineVector = _Vector2.default.fromObject(pointLib.difference(fixedPoint, flexiblePoint));
	    // Figure out the closest angle that it should snap to
	    var snappedAngle = getClosestSnappedAngle(lineVector);
	    // Get the appropriate rule for updating the vector
	    var snappedAngleRule = getSnapAngleRule(snappedAngle);
	    // Update the vector according to the snapped angle's rule
	    var updatedVector = snappedAngleRule(lineVector);
	    // Translate the vector back into its original coordinates
	    return pointLib.translate(fixedPoint, updatedVector);
	};

/***/ }),
/* 738 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Arrow constants
	var FULL_RES_ARROW_WIDTH = exports.FULL_RES_ARROW_WIDTH = 14;
	var FULL_RES_ARROW_HEIGHT = exports.FULL_RES_ARROW_HEIGHT = 12;
	var FULL_RES_STROKE_WIDTH = exports.FULL_RES_STROKE_WIDTH = 2;
	
	// The arrow is scaled based on the stroke width (because the markerUnits are strokeWidth)
	// so divide by the stroke width to get the actual units.
	var ARROW_WIDTH_UNITS = exports.ARROW_WIDTH_UNITS = FULL_RES_ARROW_WIDTH / FULL_RES_STROKE_WIDTH;
	var ARROW_HEIGHT_UNITS = exports.ARROW_HEIGHT_UNITS = FULL_RES_ARROW_HEIGHT / FULL_RES_STROKE_WIDTH;
	
	// Line constants
	var LINE_HIT_AREA = exports.LINE_HIT_AREA = 20;
	var INSET = exports.INSET = LINE_HIT_AREA / 2;

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	// Components
	
	
	// Helpers
	
	
	// Constants
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementUtil = __webpack_require__(105);
	
	var _ColorBar = __webpack_require__(294);
	
	var _ColorBar2 = _interopRequireDefault(_ColorBar);
	
	var _LinkHeader = __webpack_require__(1999);
	
	var _LinkHeader2 = _interopRequireDefault(_LinkHeader);
	
	var _LinkMetadata = __webpack_require__(2001);
	
	var _LinkMetadata2 = _interopRequireDefault(_LinkMetadata);
	
	var _Caption = __webpack_require__(424);
	
	var _Caption2 = _interopRequireDefault(_Caption);
	
	var _ElementUserTag = __webpack_require__(203);
	
	var _ElementUserTag2 = _interopRequireDefault(_ElementUserTag);
	
	var _LinkMedia = __webpack_require__(2005);
	
	var _LinkMedia2 = _interopRequireDefault(_LinkMedia);
	
	var _ElementResizeHandle = __webpack_require__(741);
	
	var _ElementResizeHandle2 = _interopRequireDefault(_ElementResizeHandle);
	
	var _gridUtils = __webpack_require__(42);
	
	var _elementCaptionUtil = __webpack_require__(137);
	
	var _elementConstants = __webpack_require__(12);
	
	var _richMediaConstants = __webpack_require__(483);
	
	__webpack_require__(1215);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Link = function Link(props) {
	    var element = props.element,
	        inList = props.inList,
	        gridSize = props.gridSize,
	        elementEvents = props.elementEvents,
	        tempSize = props.tempSize,
	        isLocked = props.isLocked,
	        isEditable = props.isEditable;
	
	
	    var classes = (0, _elementUtil.elementClassNames)('Link drag-handle', props);
	
	    var colorName = element.get('content').get('color');
	    var captionContent = (0, _elementCaptionUtil.getCaption)(element);
	    var captionVisible = (0, _elementCaptionUtil.getShowCaption)(element);
	
	    var mediaType = element.getIn(['content', 'mediaType']);
	    var canResize = _richMediaConstants.RESIZEABLE_MEDIA.indexOf(mediaType) !== -1 && !isLocked && isEditable;
	    var savedElementSize = element.getIn(['content', 'width']);
	    var elementWidth = tempSize || savedElementSize || _elementConstants.ELEMENT_DEFAULT_WIDTH;
	
	    var defaultMaxWidth = element.getIn(['content', 'media', 'width']);
	
	    return _react2.default.createElement(
	        'div',
	        _extends({ id: (0, _elementUtil.getDomElementId)(element.get('id')),
	            className: classes,
	            style: (0, _gridUtils.getElementStyle)(elementWidth, gridSize, inList)
	        }, elementEvents),
	        _react2.default.createElement(_LinkMedia2.default, _extends({}, props, { width: elementWidth })),
	        _react2.default.createElement(_ColorBar2.default, { colorName: colorName }),
	        _react2.default.createElement(_ElementUserTag2.default, props),
	        _react2.default.createElement(_LinkHeader2.default, props),
	        _react2.default.createElement(_LinkMetadata2.default, props),
	        _react2.default.createElement(_Caption2.default, _extends({}, props, {
	            showDivider: true,
	            textContent: captionContent,
	            captionVisible: captionVisible })),
	        _react2.default.createElement(_ElementResizeHandle2.default, _extends({}, props, { minWidth: _elementConstants.ELEMENT_DEFAULT_WIDTH, defaultMaxWidth: defaultMaxWidth,
	            showHandle: canResize }))
	    );
	};
	
	Link.propTypes = {
	    element: _propTypes2.default.object.isRequired,
	    gridSize: _propTypes2.default.number,
	    inList: _propTypes2.default.string,
	    isSelected: _propTypes2.default.bool,
	    isEditing: _propTypes2.default.bool,
	    isHovered: _propTypes2.default.bool,
	    startEditing: _propTypes2.default.func,
	    setEditHandler: _propTypes2.default.func,
	    stopEditing: _propTypes2.default.func,
	    saveContent: _propTypes2.default.func,
	    handleKey: _propTypes2.default.func,
	    className: _propTypes2.default.string,
	    documentMode: _propTypes2.default.bool,
	    elementEvents: _propTypes2.default.object,
	    tempSize: _propTypes2.default.number,
	    isLocked: _propTypes2.default.bool,
	    isEditable: _propTypes2.default.bool
	};
	
	exports.default = Link;

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setLinkElementUrl = exports.toggleLinkAttachment = exports.fetchLinkAttachment = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Services
	
	
	// Actions
	
	
	// Constants
	
	
	var _lodash = __webpack_require__(4);
	
	var _mediaService = __webpack_require__(315);
	
	var _mediaService2 = _interopRequireDefault(_mediaService);
	
	var _boardService = __webpack_require__(167);
	
	var _elementActions = __webpack_require__(26);
	
	var _selectionActions = __webpack_require__(55);
	
	var _elementAttachmentActions = __webpack_require__(142);
	
	var _imageConstants = __webpack_require__(87);
	
	var _aliasConstants = __webpack_require__(241);
	
	var _richMediaConstants = __webpack_require__(483);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fetchLinkAttachment = exports.fetchLinkAttachment = function fetchLinkAttachment(_ref) {
	    var id = _ref.id,
	        url = _ref.url;
	    return function (dispatch, getState) {
	        dispatch((0, _elementAttachmentActions.uploadingElementAttachment)({ id: id }));
	
	        return _mediaService2.default.link.fetchLinkAttachment({ id: id, url: url }).then(function (_ref2) {
	            var data = _ref2.data;
	
	            dispatch((0, _elementAttachmentActions.completedUploadingElementAttachment)({ id: id }));
	
	            if (!data.image) return;
	
	            var changes = _extends({}, data, {
	                showAttachment: true
	            });
	
	            dispatch((0, _elementActions.updateElement)({
	                id: id,
	                changes: changes
	            }));
	        });
	    };
	};
	
	var toggleLinkAttachment = exports.toggleLinkAttachment = function toggleLinkAttachment() {
	    return function (dispatch, getState) {
	        var state = getState();
	
	        var elementId = state.getIn(['app', 'selection', 'ids']).first();
	        var element = state.get('elements').get(elementId);
	
	        var fetching = element.getIn(['attachment', 'fetching']);
	        if (fetching) return;
	
	        dispatch((0, _elementActions.updateElement)({
	            id: elementId,
	            changes: {
	                showAttachment: !element.getIn(['content', 'showAttachment'])
	            }
	        }));
	    };
	};
	
	var getChangesCaption = function getChangesCaption(data) {
	    if (!data.description) return {};
	
	    var showCaption = data.mediaType !== _richMediaConstants.MEDIA_TYPES.VIDEO && data.mediaType !== _richMediaConstants.MEDIA_TYPES.RICH;
	    return {
	        caption: data.description,
	        showCaption: showCaption
	    };
	};
	
	var prepareChanges = function prepareChanges(data) {
	    return _extends({}, (0, _lodash.omit)(data, ['description', 'elementType']), getChangesCaption(data));
	};
	
	var linkHasAttachment = function linkHasAttachment(changes) {
	    return (0, _lodash.get)(changes, ['link', 'hasAttachment']);
	};
	
	var handleLinkTypeResponse = function handleLinkTypeResponse(id, data) {
	    return function (dispatch, getState) {
	        var changes = prepareChanges(data);
	
	        dispatch((0, _elementActions.updateElement)({
	            id: id,
	            changes: changes
	        }));
	
	        // TODO This seems very round-about, is the experience really worth the extra code?
	        if (linkHasAttachment(changes)) {
	            dispatch(fetchLinkAttachment({ id: id, url: (0, _lodash.get)(changes, ['link', 'url']) }));
	        }
	    };
	};
	
	var handleImageTypeResponse = function handleImageTypeResponse(id, data) {
	    return function (dispatch, getState) {
	        var changes = prepareChanges(data);
	
	        dispatch((0, _elementActions.setElementType)({
	            id: id,
	            elementType: _imageConstants.IMAGE_TYPE
	        }));
	
	        dispatch((0, _elementActions.updateElement)({
	            id: id,
	            changes: changes
	        }));
	    };
	};
	
	var handleAliasTypeResponse = function handleAliasTypeResponse(id, data) {
	    return function (dispatch, getState) {
	        var changes = prepareChanges(data);
	
	        dispatch((0, _elementActions.setElementType)({
	            id: id,
	            elementType: _aliasConstants.ALIAS_TYPE
	        }));
	
	        dispatch((0, _elementActions.updateElement)({
	            id: id,
	            changes: changes
	        }));
	
	        dispatch((0, _boardService.fetchBoard)({ boardId: data.linkTo }));
	    };
	};
	
	var setLinkElementUrl = exports.setLinkElementUrl = function setLinkElementUrl(_ref3) {
	    var id = _ref3.id,
	        url = _ref3.url;
	    return function (dispatch, getState) {
	        var fetching = getState().getIn(['elements', id, 'attachment', 'fetching']);
	        if (fetching) return;
	
	        dispatch((0, _elementAttachmentActions.uploadingElementAttachment)({ id: id }));
	        dispatch((0, _selectionActions.finishEditingElement)());
	
	        return _mediaService2.default.link.fetchLink({ id: id, url: url }).then(function (_ref4) {
	            var data = _ref4.data;
	
	            if (!data || data.error) throw new Error('no data');
	            dispatch((0, _elementAttachmentActions.completedUploadingElementAttachment)({ id: id }));
	
	            switch (data.elementType) {
	                case _imageConstants.IMAGE_TYPE:
	                    return dispatch(handleImageTypeResponse(id, data));
	                case _aliasConstants.ALIAS_TYPE:
	                    return dispatch(handleAliasTypeResponse(id, data));
	                default:
	                    return dispatch(handleLinkTypeResponse(id, data));
	            }
	        }).catch(function (err) {
	            var error = (0, _lodash.get)(err, ['response', 'data', 'error'], err);
	            console.error(error);
	
	            dispatch((0, _elementAttachmentActions.completedUploadingElementAttachment)({ id: id }));
	            dispatch((0, _elementActions.updateElement)({
	                id: id,
	                sync: false,
	                changes: {
	                    temp: { error: error, url: url }
	                }
	            }));
	        });
	    };
	};

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(9);
	
	var _browser = __webpack_require__(61);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _elementResizeHandleMouseDecorator = __webpack_require__(2007);
	
	var _elementResizeHandleMouseDecorator2 = _interopRequireDefault(_elementResizeHandleMouseDecorator);
	
	var _elementResizeHandleTouchDecorator = __webpack_require__(2008);
	
	var _elementResizeHandleTouchDecorator2 = _interopRequireDefault(_elementResizeHandleTouchDecorator);
	
	__webpack_require__(1221);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	var ElementResizeHandle = function ElementResizeHandle(props) {
	    var onMouseDown = props.onMouseDown,
	        onTouchStart = props.onTouchStart,
	        onDoubleClick = props.onDoubleClick,
	        inList = props.inList,
	        showHandle = props.showHandle;
	
	
	    if (inList || !showHandle) {
	        return null;
	    }
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'ElementResizeHandle',
	            onMouseDown: onMouseDown,
	            onTouchStart: onTouchStart,
	            onDoubleClick: onDoubleClick },
	        _react2.default.createElement(_Icon2.default, { name: 'element-resize-handle' })
	    );
	};
	
	// Styles
	
	
	ElementResizeHandle.propTypes = {
	    element: _propTypes2.default.object,
	    gridSize: _propTypes2.default.number,
	    inList: _propTypes2.default.string,
	    showHandle: _propTypes2.default.bool,
	    onMouseDown: _propTypes2.default.func,
	    onTouchStart: _propTypes2.default.func,
	    onDoubleClick: _propTypes2.default.func
	};
	
	exports.default = (0, _recompose.branch)(_browser.isMobile, _elementResizeHandleTouchDecorator2.default, _elementResizeHandleMouseDecorator2.default)(ElementResizeHandle);

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _elementConstants = __webpack_require__(12);
	
	exports.default = function (currentSize, sizeChange, minWidth) {
	    return Math.max((currentSize || _elementConstants.ELEMENT_DEFAULT_WIDTH) + sizeChange, minWidth);
	};

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(34);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	__webpack_require__(1232);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InboxHeader = function InboxHeader(props) {
	    var closeInboxHandler = props.closeInboxHandler;
	
	
	    var CloseButton = _react2.default.createElement(
	        'div',
	        { className: 'close-inbox' },
	        _react2.default.createElement(
	            _Button2.default,
	            { onClickFn: closeInboxHandler },
	            _react2.default.createElement(
	                'span',
	                null,
	                'Close'
	            )
	        )
	    );
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'InboxHeader' },
	        _react2.default.createElement(
	            'h2',
	            { className: 'inbox-title' },
	            'Unsorted notes'
	        ),
	        closeInboxHandler ? CloseButton : null
	    );
	};
	
	InboxHeader.propTypes = {
	    gridSize: _propTypes2.default.number,
	    closeInboxHandler: _propTypes2.default.func,
	    className: _propTypes2.default.string
	};
	
	exports.default = InboxHeader;

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ListPresentational = __webpack_require__(747);
	
	var _ListPresentational2 = _interopRequireDefault(_ListPresentational);
	
	var _ListContainer = __webpack_require__(2032);
	
	var _ListContainer2 = _interopRequireDefault(_ListContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var List = function List(props) {
	    var isPresentational = props.isPresentational;
	
	    var DisplayList = isPresentational ? _ListPresentational2.default : _ListContainer2.default;
	
	    return _react2.default.createElement(DisplayList, props);
	};
	
	List.propTypes = {
	    isPresentational: _propTypes2.default.bool
	};
	
	exports.default = List;

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(9);
	
	var _ListElementPresentational = __webpack_require__(746);
	
	var _ListElementPresentational2 = _interopRequireDefault(_ListElementPresentational);
	
	var _ListElementContainer = __webpack_require__(2034);
	
	var _ListElementContainer2 = _interopRequireDefault(_ListElementContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	var ListElement = function ListElement(props) {
	    var isPresentational = props.isPresentational;
	
	    var DisplayElement = isPresentational ? _ListElementPresentational2.default : _ListElementContainer2.default;
	    return _react2.default.createElement(DisplayElement, props);
	}; // Lib
	
	
	ListElement.propTypes = {
	    currentBoardId: _propTypes2.default.string.isRequired,
	    isPresentational: _propTypes2.default.bool,
	    inList: _propTypes2.default.string
	};
	
	exports.default = (0, _recompose.pure)(ListElement);

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Element = __webpack_require__(449);
	
	var _Element2 = _interopRequireDefault(_Element);
	
	__webpack_require__(1237);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListElementPresentational = function ListElementPresentational(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'ListElement' },
	        _react2.default.createElement(_Element2.default, props)
	    );
	};
	
	ListElementPresentational.propTypes = {
	    currentBoardId: _propTypes2.default.string.isRequired
	};
	
	exports.default = ListElementPresentational;

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _ListElement = __webpack_require__(745);
	
	var _ListElement2 = _interopRequireDefault(_ListElement);
	
	var _ListDropPreview = __webpack_require__(2033);
	
	var _ListDropPreview2 = _interopRequireDefault(_ListDropPreview);
	
	var _EmptyListPlaceholder = __webpack_require__(2031);
	
	var _EmptyListPlaceholder2 = _interopRequireDefault(_EmptyListPlaceholder);
	
	__webpack_require__(1234);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } // Lib
	
	
	// Components
	
	
	var ListPresentational = function ListPresentational(props) {
	    var children = props.children,
	        isHovered = props.isHovered,
	        isPresentational = props.isPresentational,
	        registerListElement = props.registerListElement,
	        deregisterListElement = props.deregisterListElement,
	        hoveredIndex = props.hoveredIndex,
	        gridSize = props.gridSize,
	        inListClass = props.inListClass,
	        currentBoardId = props.currentBoardId,
	        isEditable = props.isEditable,
	        documentMode = props.documentMode,
	        elementFilter = props.elementFilter,
	        deselectAll = props.deselectAll,
	        createShortcutElement = props.createShortcutElement,
	        createShortcutCard = props.createShortcutCard,
	        createShortcutImage = props.createShortcutImage,
	        createShortcutLink = props.createShortcutLink,
	        readyToMeasure = props.readyToMeasure;
	
	
	    var listIndex = 0;
	    var showDropPreview = isHovered && hoveredIndex !== null && children.size > 0;
	    var displayElements = showDropPreview ? Immutable.List([].concat(_toConsumableArray(children.slice(0, hoveredIndex)), [{ preview: true }], _toConsumableArray(children.slice(hoveredIndex)))) : children;
	
	    var renderElements = displayElements.map(function (element) {
	        if (element.preview) return _react2.default.createElement(_ListDropPreview2.default, { key: 'dropPreview' });
	
	        var i = listIndex;
	        listIndex++;
	
	        return _react2.default.createElement(_ListElement2.default, {
	            element: element,
	            gridSize: gridSize,
	            inList: inListClass || 'in-list',
	            key: element.get('id'),
	            currentBoardId: currentBoardId,
	            isPresentational: isPresentational,
	            registerListElement: registerListElement,
	            deregisterListElement: deregisterListElement,
	            deselectAll: deselectAll,
	            createShortcutElement: createShortcutElement,
	            createShortcutCard: createShortcutCard,
	            createShortcutImage: createShortcutImage,
	            createShortcutLink: createShortcutLink,
	            listIndex: i,
	            documentMode: documentMode,
	            isEditable: isEditable,
	            elementFilter: elementFilter,
	            readyToMeasure: readyToMeasure });
	    });
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'List' },
	        children.size === 0 ? _react2.default.createElement(_EmptyListPlaceholder2.default, props) : renderElements
	    );
	};
	
	ListPresentational.propTypes = {
	    listId: _propTypes2.default.string.isRequired,
	    currentBoardId: _propTypes2.default.string.isRequired,
	    children: _propTypes2.default.object.isRequired,
	    connectDropTarget: _propTypes2.default.func,
	    isHovered: _propTypes2.default.bool,
	    hoveredIndex: _propTypes2.default.number,
	    isPresentational: _propTypes2.default.bool,
	    isEditable: _propTypes2.default.bool,
	    registerListElement: _propTypes2.default.func,
	    deregisterListElement: _propTypes2.default.func,
	    gridSize: _propTypes2.default.number,
	    inListClass: _propTypes2.default.string,
	    documentMode: _propTypes2.default.bool,
	    elementFilter: _propTypes2.default.object,
	    deselectAll: _propTypes2.default.func,
	    createShortcutElement: _propTypes2.default.func,
	    createShortcutCard: _propTypes2.default.func,
	    createShortcutImage: _propTypes2.default.func,
	    createShortcutLink: _propTypes2.default.func,
	    readyToMeasure: _propTypes2.default.bool
	};
	
	exports.default = ListPresentational;

/***/ }),
/* 748 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var MODIFIED_ELEMENTS_SET = exports.MODIFIED_ELEMENTS_SET = 'MODIFIED_ELEMENTS_SET';
	var MODIFIED_ELEMENTS_ADD = exports.MODIFIED_ELEMENTS_ADD = 'MODIFIED_ELEMENTS_ADD';
	var MODIFIED_ELEMENTS_ERROR = exports.MODIFIED_ELEMENTS_ERROR = 'MODIFIED_ELEMENTS_ERROR';

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.notificationsReadySelector = exports.errorNotificationUserIds = exports.getNotificationUserResources = exports.notificationUsersSelector = exports.notificationUserIdsSelector = exports.activeNotificationsIdsSelector = exports.notificationsCountSelector = exports.activeNotificationsSelector = exports.modifiedElementsSelector = exports.getForcedPoll = exports.getFetchedTime = undefined;
	
	var _reselect = __webpack_require__(7);
	
	var _milanoteReselect = __webpack_require__(49);
	
	var _resourceUtil = __webpack_require__(108);
	
	var _usersSelector = __webpack_require__(204);
	
	var _immutableHelper = __webpack_require__(23);
	
	// Utils
	var getFetchedTime = exports.getFetchedTime = function getFetchedTime(state) {
	    return state.getIn(['notifications', 'fetchedTime']);
	}; // Lib
	var getForcedPoll = exports.getForcedPoll = function getForcedPoll(state) {
	    return state.getIn(['notifications', 'forcedPoll']);
	};
	
	var modifiedElementsSelector = exports.modifiedElementsSelector = (0, _reselect.createSelector)(function (state) {
	    return state.getIn(['notifications', 'modifiedElements']);
	}, function (modifiedElements) {
	    return modifiedElements.sort(function (messageA, messageB) {
	        return messageB.get('modifiedTime') - messageA.get('modifiedTime');
	    });
	});
	
	var activeNotificationsSelector = exports.activeNotificationsSelector = (0, _reselect.createSelector)(modifiedElementsSelector, function (state) {
	    return state.getIn(['app', 'currentUser', 'viewedBoards']);
	}, function (state) {
	    return state.getIn(['app', 'currentUser', 'lastCheckedNotifications']);
	}, function (modifiedElements, viewedBoards, lastCheckedNotifications) {
	    return modifiedElements.filter(function (notification) {
	        return notification.get('active');
	    }).filter(function (notification) {
	        return !viewedBoards.get(notification.get('id')) || viewedBoards.get(notification.get('id')) < notification.get('modifiedTime');
	    });
	});
	
	var notificationsCountSelector = exports.notificationsCountSelector = (0, _reselect.createSelector)(activeNotificationsSelector, function (state) {
	    return state.getIn(['app', 'currentUser', 'lastCheckedNotifications']);
	}, function (activeNotifications, lastCheckedNotifications) {
	    return activeNotifications.filter(function (notification) {
	        return notification.get('modifiedTime') > lastCheckedNotifications;
	    }).size;
	});
	
	var activeNotificationsIdsSelector = exports.activeNotificationsIdsSelector = (0, _reselect.createSelector)(activeNotificationsSelector, function (activeNotifications) {
	    return activeNotifications.map(function (notification) {
	        return notification.get('id');
	    });
	});
	
	var notificationUserIdsSelector = exports.notificationUserIdsSelector = (0, _reselect.createSelector)(modifiedElementsSelector, function (modifiedElements, users) {
	    return modifiedElements.reduce(function (acc, message) {
	        message.get('children').forEach(function (child) {
	            var userId = child.get('modifiedBy');
	            if (acc.indexOf(userId) === -1) acc.push(userId);
	        });
	
	        return acc;
	    }, []);
	});
	
	var notificationUsersSelector = exports.notificationUsersSelector = (0, _milanoteReselect.createShallowSelector)(notificationUserIdsSelector, function (state) {
	    return state.get('users');
	}, _immutableHelper.getMany);
	
	var getNotificationUserResources = exports.getNotificationUserResources = (0, _usersSelector.makeFilteredUsersResourcesSelector)(notificationUserIdsSelector);
	
	var errorNotificationUserIds = exports.errorNotificationUserIds = (0, _milanoteReselect.createShallowSelector)(getNotificationUserResources, function (notificationUsers) {
	    return notificationUsers.filter(_resourceUtil.isError).keySeq().toArray();
	});
	
	var notificationsReadySelector = exports.notificationsReadySelector = (0, _reselect.createSelector)(function (state) {
	    return state.getIn(['notifications', 'fetched']);
	}, notificationUserIdsSelector, notificationUsersSelector, getNotificationUserResources, function (notificationsFetched, notificationUserIds, notificationUsers, notificationUserResources) {
	    return notificationsFetched && notificationUserIds.length === notificationUsers.size && !notificationUserResources.some(_resourceUtil.isFetching) && !notificationUserResources.some(_resourceUtil.isError);
	});

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.currentBoardIdSet = undefined;
	
	var _currentBoardIdConstants = __webpack_require__(461);
	
	var currentBoardIdSet = exports.currentBoardIdSet = function currentBoardIdSet(_ref) {
	    var boardId = _ref.boardId;
	    return {
	        type: _currentBoardIdConstants.CURRENT_BOARD_ID_SET,
	        boardId: boardId
	    };
	}; // Constants

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.EMAIL_PREFERENCE_CHECKLIST = undefined;
	
	var _userConstants = __webpack_require__(32);
	
	var EMAIL_PREFERENCE_CHECKLIST = exports.EMAIL_PREFERENCE_CHECKLIST = [{
	    value: _userConstants.EMAIL_PREFERENCE_BITS.ACTIVITY_DIGEST,
	    label: 'A daily summary of changes to boards you share'
	}, { value: _userConstants.EMAIL_PREFERENCE_BITS.SHARED_BOARDS, label: 'An alert when someone shares a board with you' }, { value: _userConstants.EMAIL_PREFERENCE_BITS.PRODUCT_UPDATES, label: 'New feature announcements' }]; // Constants

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.resetPayment = exports.submitCreditCardUpdateForm = exports.submitPaymentForm = exports.cancelSubscription = exports.fetchUpcomingInvoice = exports.clearCoupon = exports.fetchCoupon = exports.loadPlans = exports.setProrateDate = exports.clearPrefilledCard = exports.setViewState = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _lodash = __webpack_require__(4);
	
	var _creditCardActions = __webpack_require__(1773);
	
	var _formSubmissionExceptionHandler = __webpack_require__(296);
	
	var _formSubmissionExceptionHandler2 = _interopRequireDefault(_formSubmissionExceptionHandler);
	
	var _navigationActions = __webpack_require__(27);
	
	var _currentUserActions = __webpack_require__(84);
	
	var _teamManagementSelectors = __webpack_require__(463);
	
	var _paymentSelector = __webpack_require__(308);
	
	var _paymentService = __webpack_require__(753);
	
	var _paymentConstants = __webpack_require__(202);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var setViewState = exports.setViewState = function setViewState(viewState) {
	    return {
	        type: _paymentConstants.PAYMENT_SET_VIEW_STATE,
	        viewState: viewState
	    };
	};
	
	var clearPrefilledCard = exports.clearPrefilledCard = function clearPrefilledCard() {
	    return {
	        type: _paymentConstants.PAYMENT_CARD_CLEAR
	    };
	};
	
	var setProrateDate = exports.setProrateDate = function setProrateDate(date) {
	    return {
	        type: _paymentConstants.PAYMENT_SET_PRORATE_DATE,
	        date: date
	    };
	};
	
	var loadPlans = exports.loadPlans = function loadPlans(_ref) {
	    var volume = _ref.volume;
	    return function (dispatch) {
	        dispatch({ type: _paymentConstants.PAYMENT_PLANS_FETCHING });
	
	        (0, _paymentService.getPlans)({ volume: volume }).then(function (response) {
	            var plans = response.data.plans;
	            dispatch({ type: _paymentConstants.PAYMENT_PLANS_FETCHED, plans: plans });
	        });
	    };
	};
	
	var couponError = function couponError(couponCode) {
	    return {
	        type: _paymentConstants.PAYMENT_COUPON_FAILED,
	        coupon: {
	            error: true,
	            id: couponCode
	        }
	    };
	};
	
	var fetchCoupon = exports.fetchCoupon = function fetchCoupon(couponCode) {
	    return function (dispatch) {
	        dispatch({ type: _paymentConstants.PAYMENT_COUPON_FETCHING });
	
	        return (0, _paymentService.getCoupon)({ couponCode: couponCode }).then(function (response) {
	            var coupon = response.data.coupon;
	
	            // return an error if the coupon code exists but is invalid
	            if (!coupon || !coupon.valid) {
	                return dispatch(couponError(couponCode));
	            }
	
	            return dispatch({ type: _paymentConstants.PAYMENT_COUPON_FETCHED, coupon: coupon });
	        }).catch(function (error) {
	            return dispatch(couponError(couponCode));
	        });
	    };
	};
	
	var clearCoupon = exports.clearCoupon = function clearCoupon() {
	    return { type: _paymentConstants.PAYMENT_COUPON_CLEAR };
	};
	
	var fetchUpcomingInvoice = exports.fetchUpcomingInvoice = function fetchUpcomingInvoice(_ref2) {
	    var subscriptionId = _ref2.subscriptionId,
	        customerId = _ref2.customerId,
	        planInterval = _ref2.planInterval,
	        coupon = _ref2.coupon,
	        prorateDate = _ref2.prorateDate;
	    return function (dispatch, getState) {
	        dispatch({ type: _paymentConstants.PAYMENT_UPCOMING_FETCHING });
	
	        var memberIds = (0, _teamManagementSelectors.selectedTeamMemberIdsSelector)(getState()).keySeq().toArray().join(',');
	
	        (0, _paymentService.previewUpcomingInvoice)({ subscriptionId: subscriptionId, customerId: customerId, planInterval: planInterval, coupon: coupon, prorateDate: prorateDate, memberIds: memberIds }).then(function (response) {
	            var invoice = response.data;
	            dispatch({ type: _paymentConstants.PAYMENT_UPCOMING_FETCHED, invoice: invoice });
	        }).catch(function (error) {
	            dispatch({
	                type: _paymentConstants.PAYMENT_UPCOMING_FAILED,
	                invoice: {
	                    error: true
	                }
	            });
	        });
	    };
	};
	
	var cancelSubscription = exports.cancelSubscription = function cancelSubscription(subscriptionId) {
	    return function (dispatch, getState) {
	        (0, _paymentService.deleteSubscription)({ subscriptionId: subscriptionId }).then(function (result) {
	            return dispatch((0, _currentUserActions.refreshCurrentUser)());
	        });
	    };
	};
	
	var submitPaymentForm = exports.submitPaymentForm = function submitPaymentForm(params) {
	    return function (dispatch, getState) {
	        var plan = params.plan,
	            cardPrefilled = params.cardPrefilled,
	            prorateDate = params.prorateDate;
	
	        var state = getState();
	
	        var planInterval = plan;
	
	        var currentUser = state.getIn(['app', 'currentUser']);
	        var customerId = currentUser.get('customerId');
	        var subscriptionId = currentUser.get('subscriptionId');
	
	        var couponOb = (0, _paymentSelector.couponSelector)(state);
	        var coupon = couponOb && couponOb.get('valid') && couponOb.get('id');
	
	        var memberIds = (0, _teamManagementSelectors.selectedTeamMemberIdsSelector)(state).valueSeq().toArray().join(',');
	
	        var tokenPromise = cardPrefilled ? Promise.resolve({}) : (0, _creditCardActions.requestStripeToken)(_extends({}, params, { form: _paymentConstants.PAYMENT_FORM_NAME }), dispatch);
	
	        return tokenPromise.then(function (_ref3) {
	            var token = _ref3.token;
	
	            var tokenId = token && token.id;
	
	            var customerPromise = customerId && tokenId ? (0, _paymentService.updateCustomer)({ token: tokenId, customerId: customerId }) : Promise.resolve({});
	
	            var subscriptionPromise = subscriptionId ? (0, _paymentService.updateSubscription)({ subscriptionId: subscriptionId, planInterval: planInterval, coupon: coupon, prorateDate: prorateDate, memberIds: memberIds }) : (0, _paymentService.createSubscription)({ token: tokenId, planInterval: planInterval, coupon: coupon, prorateDate: prorateDate, memberIds: memberIds });
	
	            dispatch(setViewState(_paymentConstants.PAYMENT_VIEW_STATES.PROCESSING));
	
	            return customerPromise.then(function (customer) {
	                return subscriptionPromise.then(function (subscription) {
	                    dispatch(setProrateDate(null));
	                    dispatch(setViewState(_paymentConstants.PAYMENT_VIEW_STATES.SUCCESS));
	                    dispatch((0, _currentUserActions.refreshCurrentUser)());
	                });
	            }).catch(function (error) {
	                dispatch(setViewState(_paymentConstants.PAYMENT_VIEW_STATES.CARD_FORM));
	
	                var errorMessage = (0, _lodash.get)(error, 'response.data.error.detail');
	                var errorOb = (0, _lodash.get)(error, 'response.data.error');
	                if (errorOb && errorMessage) errorOb.message = errorMessage;
	
	                return (0, _formSubmissionExceptionHandler2.default)({
	                    dispatch: dispatch,
	                    getState: getState,
	                    form: _paymentConstants.PAYMENT_FORM_NAME,
	                    sensitive: true
	                })(error);
	            });
	        });
	    };
	};
	
	var submitCreditCardUpdateForm = exports.submitCreditCardUpdateForm = function submitCreditCardUpdateForm(params) {
	    return function (dispatch, getState) {
	        var cardPrefilled = params.cardPrefilled,
	            setLoading = params.setLoading,
	            setSuccess = params.setSuccess,
	            setInitial = params.setInitial;
	
	        var customerId = getState().getIn(['app', 'currentUser', 'customerId']);
	        if (!customerId || cardPrefilled) return;
	
	        return (0, _creditCardActions.requestStripeToken)(_extends({}, params, { form: _paymentConstants.PAYMENT_FORM_NAME }), dispatch).then(function (_ref4) {
	            var token = _ref4.token;
	
	            var tokenId = token && token.id;
	
	            setLoading();
	
	            return (0, _paymentService.updateCustomer)({ token: tokenId, customerId: customerId }).then(function (customer) {
	                setSuccess();
	            }).catch(function (error) {
	                setInitial();
	
	                var errorMessage = (0, _lodash.get)(error, 'response.data.error.detail');
	                var errorOb = (0, _lodash.get)(error, 'response.data.error');
	                if (errorOb && errorMessage) errorOb.message = errorMessage;
	
	                return (0, _formSubmissionExceptionHandler2.default)({
	                    dispatch: dispatch,
	                    getState: getState,
	                    form: _paymentConstants.PAYMENT_FORM_NAME,
	                    sensitive: true
	                })(error);
	            });
	        });
	    };
	};
	
	var resetPayment = exports.resetPayment = _navigationActions.navigateToRootWorkspace;

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.sendTeamEnquiry = exports.previewUpcomingInvoice = exports.updateSubscription = exports.createSubscription = exports.deleteSubscription = exports.updateCustomer = exports.getCustomer = exports.getPlans = exports.getCoupon = undefined;
	
	var _http = __webpack_require__(76);
	
	var _httpConstants = __webpack_require__(90);
	
	var getCoupon = exports.getCoupon = function getCoupon(_ref) {
	    var couponCode = _ref.couponCode;
	    return (0, _http.http)({
	        url: 'payments/coupons/' + couponCode
	    });
	};
	
	var getPlans = exports.getPlans = function getPlans(_ref2) {
	    var volume = _ref2.volume;
	    return (0, _http.http)({
	        url: 'payments/plans',
	        params: {
	            volume: volume
	        }
	    });
	};
	
	var getCustomer = exports.getCustomer = function getCustomer(_ref3) {
	    var customerId = _ref3.customerId;
	    return (0, _http.http)({ url: 'payments/customers/' + customerId });
	};
	
	var updateCustomer = exports.updateCustomer = function updateCustomer(_ref4) {
	    var customerId = _ref4.customerId,
	        token = _ref4.token;
	    return (0, _http.http)({
	        url: 'payments/customers/' + customerId,
	        method: _httpConstants.METHODS.PUT,
	        timeout: 10000,
	        data: {
	            token: token
	        }
	    });
	};
	
	var deleteSubscription = exports.deleteSubscription = function deleteSubscription(_ref5) {
	    var subscriptionId = _ref5.subscriptionId;
	    return (0, _http.http)({
	        url: 'payments/subscriptions/' + subscriptionId,
	        method: _httpConstants.METHODS.DELETE,
	        timeout: 30000
	    });
	};
	
	var createSubscription = exports.createSubscription = function createSubscription(_ref6) {
	    var token = _ref6.token,
	        planInterval = _ref6.planInterval,
	        coupon = _ref6.coupon,
	        prorateDate = _ref6.prorateDate,
	        memberIds = _ref6.memberIds;
	    return (0, _http.http)({
	        url: 'payments/subscriptions',
	        method: _httpConstants.METHODS.POST,
	        data: {
	            token: token,
	            planInterval: planInterval,
	            coupon: coupon,
	            prorateDate: prorateDate,
	            memberIds: memberIds
	        },
	        timeout: 30000
	    });
	};
	
	var updateSubscription = exports.updateSubscription = function updateSubscription(_ref7) {
	    var subscriptionId = _ref7.subscriptionId,
	        planInterval = _ref7.planInterval,
	        coupon = _ref7.coupon,
	        prorateDate = _ref7.prorateDate,
	        memberIds = _ref7.memberIds;
	    return (0, _http.http)({
	        url: 'payments/subscriptions/' + subscriptionId,
	        method: _httpConstants.METHODS.PUT,
	        data: {
	            planInterval: planInterval,
	            coupon: coupon,
	            prorateDate: prorateDate,
	            memberIds: memberIds
	        },
	        timeout: 30000
	    });
	};
	
	var previewUpcomingInvoice = exports.previewUpcomingInvoice = function previewUpcomingInvoice(_ref8) {
	    var subscriptionId = _ref8.subscriptionId,
	        customerId = _ref8.customerId,
	        planInterval = _ref8.planInterval,
	        coupon = _ref8.coupon,
	        prorateDate = _ref8.prorateDate,
	        memberIds = _ref8.memberIds;
	    return (0, _http.http)({
	        url: 'payments/subscriptions/' + subscriptionId + '/preview',
	        method: _httpConstants.METHODS.GET,
	        params: {
	            customerId: customerId,
	            memberIds: memberIds,
	            planInterval: planInterval,
	            coupon: coupon,
	            prorateDate: prorateDate
	        },
	        timeout: 5000
	    });
	};
	
	var sendTeamEnquiry = exports.sendTeamEnquiry = function sendTeamEnquiry(_ref9) {
	    var email = _ref9.email;
	    return (0, _http.http)({
	        url: 'payments/subscriptions/teams/enquire',
	        method: _httpConstants.METHODS.POST,
	        data: {
	            email: email
	        }
	    });
	};

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _userUtil = __webpack_require__(31);
	
	var _elementCountConstants = __webpack_require__(169);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlanStatusTitle = function PlanStatusTitle(_ref) {
	    var currentUser = _ref.currentUser,
	        contentTotalCount = _ref.contentTotalCount,
	        contentTotalLimit = _ref.contentTotalLimit;
	
	    if ((0, _userUtil.isSubscribed)(currentUser)) {
	        return _react2.default.createElement(
	            'div',
	            { className: 'plan-status' },
	            'You\'re on the ',
	            _react2.default.createElement(
	                'span',
	                { className: 'plan-name' },
	                'Professional'
	            ),
	            ' plan'
	        );
	    }
	
	    if (contentTotalCount >= contentTotalLimit) {
	        return _react2.default.createElement(
	            'div',
	            { className: 'plan-status' },
	            _react2.default.createElement(
	                'span',
	                { className: 'plan-name' },
	                'Your workspace is full'
	            )
	        );
	    }
	
	    if (contentTotalCount >= contentTotalLimit - _elementCountConstants.ELEMENT_COUNT_WARNING_START) {
	        return _react2.default.createElement(
	            'div',
	            { className: 'plan-status' },
	            _react2.default.createElement(
	                'span',
	                { className: 'plan-name' },
	                'Your workspace is almost full'
	            )
	        );
	    }
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'plan-status' },
	        'You\'re on the ',
	        _react2.default.createElement(
	            'span',
	            { className: 'plan-name' },
	            'Free'
	        ),
	        ' plan'
	    );
	};
	
	PlanStatusTitle.propTypes = {
	    currentUser: _propTypes2.default.object,
	    contentTotalCount: _propTypes2.default.number,
	    contentTotalLimit: _propTypes2.default.number
	};
	
	exports.default = PlanStatusTitle;

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getReferrer = exports.setReferrer = undefined;
	
	var _localStorage = __webpack_require__(314);
	
	var _localStorage2 = _interopRequireDefault(_localStorage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var setReferrer = exports.setReferrer = function setReferrer(referrer) {
	  return _localStorage2.default.setItem('milanote.referrer', referrer);
	};
	
	var getReferrer = exports.getReferrer = function getReferrer() {
	  return _localStorage2.default.getItem('milanote.referrer');
	};

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(9);
	
	var _userHelper = __webpack_require__(175);
	
	var _LinkButton = __webpack_require__(74);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userButtonHandler = {
	    handleClick: function handleClick(_ref) {
	        var user = _ref.user,
	            addUser = _ref.addUser;
	        return function (event) {
	            return addUser({ userEmail: (0, _userHelper.getEmail)(user) });
	        };
	    }
	};
	
	var TeamSuggestionButton = function TeamSuggestionButton(_ref2) {
	    var user = _ref2.user,
	        handleClick = _ref2.handleClick;
	    return _react2.default.createElement(
	        _LinkButton2.default,
	        { onClickFn: handleClick },
	        (0, _userHelper.getName)(user)
	    );
	};
	
	TeamSuggestionButton.propTypes = {
	    user: _propTypes2.default.object,
	    handleClick: _propTypes2.default.func
	};
	
	exports.default = (0, _recompose.withHandlers)(userButtonHandler)(TeamSuggestionButton);

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reselect = __webpack_require__(7);
	
	var _fp = __webpack_require__(52);
	
	var _userHelper = __webpack_require__(175);
	
	var _TeamSuggestionButton = __webpack_require__(756);
	
	var _TeamSuggestionButton2 = _interopRequireDefault(_TeamSuggestionButton);
	
	var _AdditionalTeamSuggestionsUtil = __webpack_require__(2111);
	
	var _AdditionalTeamSuggestionsUtil2 = _interopRequireDefault(_AdditionalTeamSuggestionsUtil);
	
	__webpack_require__(1261);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SUGGESTIONS_LIMIT = 2;
	
	var passFilter = function passFilter() {
	    return true;
	};
	
	var getUsers = function getUsers(state) {
	    return state.get('users');
	};
	var getSelectedUserIds = function getSelectedUserIds(state, props) {
	    return props.selectedUserIds || [];
	};
	var getFilterString = function getFilterString(state, props) {
	    return props.filterString;
	};
	var getCustomFilter = function getCustomFilter(state, props) {
	    return props.customFilter || passFilter;
	};
	
	var getShareCount = function getShareCount(user) {
	    return user && user.get('shareCount') || 0;
	};
	
	var sortByShareCount = function sortByShareCount(userA, userB) {
	    return getShareCount(userB) - getShareCount(userA);
	};
	var sortAlphabetically = function sortAlphabetically(userA, userB) {
	    var nameA = (0, _userHelper.getName)(userA);
	    var nameB = (0, _userHelper.getName)(userB);
	    if (nameA < nameB) return -1;
	    if (nameA > nameB) return 1;
	    return 0;
	};
	
	var filterUser = function filterUser(filterString) {
	    return function (user) {
	        if (!filterString || !filterString.length) return true;
	
	        var filterOn = (0, _fp.lowerCase)(filterString);
	        var doesStartWith = (0, _fp.startsWith)(filterOn);
	        var doesInclude = (0, _fp.includes)(filterOn);
	
	        return doesInclude((0, _fp.lowerCase)((0, _userHelper.getEmail)(user))) || doesStartWith((0, _fp.lowerCase)((0, _userHelper.getGivenName)(user))) || doesStartWith((0, _fp.lowerCase)((0, _userHelper.getFamilyName)(user)));
	    };
	};
	
	var unselectedUsersSelector = (0, _reselect.createSelector)(getUsers, getSelectedUserIds, function (users, selectedUserIds) {
	    return users.toList().filter(function (user) {
	        return !selectedUserIds.includes((0, _userHelper.getId)(user));
	    });
	});
	
	var suggestedUsersSelector = (0, _reselect.createSelector)(unselectedUsersSelector, getFilterString, getCustomFilter, function (unselectedUsers, filterString, customFilter) {
	    return unselectedUsers.filter(filterUser(filterString)).filter(customFilter).sort(sortByShareCount);
	});
	
	var limitedSuggestionsSelector = (0, _reselect.createSelector)(suggestedUsersSelector, function (users) {
	    return users.slice(0, SUGGESTIONS_LIMIT);
	});
	
	var additionalSuggestionsSelector = (0, _reselect.createSelector)(suggestedUsersSelector, function (users) {
	    return users.slice(SUGGESTIONS_LIMIT).sort(sortAlphabetically);
	});
	
	var shouldShowSuggestionsSelector = (0, _reselect.createSelector)(unselectedUsersSelector, getFilterString, function (unselectedUsers, filterString) {
	    return !!(unselectedUsers.size && filterString);
	});
	
	var userListSelector = (0, _reselect.createStructuredSelector)({
	    suggestedUsers: limitedSuggestionsSelector,
	    additionalSuggestedUsers: additionalSuggestionsSelector,
	    shouldShowSuggestions: shouldShowSuggestionsSelector
	});
	
	var SuggestedUsersList = function SuggestedUsersList(_ref) {
	    var suggestedUsers = _ref.suggestedUsers,
	        additionalSuggestedUsers = _ref.additionalSuggestedUsers,
	        addUser = _ref.addUser;
	    return _react2.default.createElement(
	        'ul',
	        null,
	        suggestedUsers.map(function (user) {
	            return _react2.default.createElement(
	                'li',
	                { key: (0, _userHelper.getId)(user) },
	                _react2.default.createElement(_TeamSuggestionButton2.default, { user: user, addUser: addUser })
	            );
	        }),
	        _react2.default.createElement(_AdditionalTeamSuggestionsUtil2.default, { users: additionalSuggestedUsers, addUser: addUser })
	    );
	};
	
	var TeamSuggestions = function TeamSuggestions(props) {
	    var filterString = props.filterString,
	        suggestedUsers = props.suggestedUsers,
	        shouldShowSuggestions = props.shouldShowSuggestions,
	        _props$defaultTitle = props.defaultTitle,
	        defaultTitle = _props$defaultTitle === undefined ? 'Recent' : _props$defaultTitle;
	
	
	    if (!shouldShowSuggestions && !suggestedUsers.size) return null;
	
	    var title = filterString ? 'Suggested: ' : defaultTitle + ': ';
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'TeamSuggestions' },
	        _react2.default.createElement(
	            'span',
	            { className: 'suggestion-title' },
	            title
	        ),
	        suggestedUsers.size ? _react2.default.createElement(SuggestedUsersList, props) : _react2.default.createElement(
	            'span',
	            { className: 'suggestion-title' },
	            'No-one found'
	        )
	    );
	};
	
	SuggestedUsersList.propTypes = TeamSuggestions.propTypes = {
	    addUser: _propTypes2.default.func.isRequired,
	    suggestedUsers: _propTypes2.default.object,
	    additionalSuggestedUsers: _propTypes2.default.object,
	    filterString: _propTypes2.default.string,
	    defaultTitle: _propTypes2.default.string,
	    shouldShowSuggestions: _propTypes2.default.bool
	};
	
	exports.default = (0, _reactRedux.connect)(userListSelector)(TeamSuggestions);

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.userActivityError = exports.userActivityLoad = exports.loadUser = exports.loadUsers = exports.trackUsers = undefined;
	
	var _errorUtil = __webpack_require__(466);
	
	var _userConstants = __webpack_require__(311);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // Utils
	
	
	// Constants
	
	
	var trackUsers = exports.trackUsers = function trackUsers(userIds) {
	    return { type: _userConstants.TRACK_USERS, userIds: userIds };
	};
	var loadUsers = exports.loadUsers = function loadUsers(users) {
	    return { type: _userConstants.USERS_LOAD, users: users };
	};
	var loadUser = exports.loadUser = function loadUser(user) {
	    return {
	        type: _userConstants.USERS_LOAD,
	        users: _defineProperty({}, user._id, user)
	    };
	};
	
	var userActivityLoad = exports.userActivityLoad = function userActivityLoad(_ref) {
	    var users = _ref.users,
	        disconnectedUserIds = _ref.disconnectedUserIds;
	    return {
	        type: _userConstants.USER_ACTIVITY_LOAD,
	        users: users,
	        disconnectedUserIds: disconnectedUserIds
	    };
	};
	var userActivityError = exports.userActivityError = function userActivityError(userIds, error) {
	    return {
	        type: _userConstants.USER_ACTIVITY_ERROR,
	        userIds: userIds,
	        error: (0, _errorUtil.extractErrorDetailsForAction)(error)
	    };
	};

/***/ }),
/* 759 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getDragModifierKeys = exports.getDragModifierKeys = function getDragModifierKeys(state) {
	  return state.getIn(['app', 'dragModifierKeys']);
	};

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(4);
	
	var _getClientConfig = __webpack_require__(48);
	
	var _getClientConfig2 = _interopRequireDefault(_getClientConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _lodash.memoize)(function () {
	  return (0, _getClientConfig2.default)().apiRoot || location.protocol + '//' + window.location.host;
	});

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(4);
	
	var _keysToObject = __webpack_require__(762);
	
	var _keysToObject2 = _interopRequireDefault(_keysToObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates an empty object with the same keys as the passed in object.
	 * <pre>
	 *     emptyObject({ a: '1', b: '2', c: '3' });
	 *     // => { a: null, b: null, c: null }
	 */
	// Lib
	exports.default = function (object) {
	  return (0, _keysToObject2.default)(null, (0, _lodash.keys)(object));
	};
	
	// Util

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(4);
	
	/**
	 * Creates a new object with default values based on the keys passed in.
	 * The default values can be set by a function that takes a key and returns a value, or can be constant.
	 *
	 * <pre>
	 *     keysToObject(null, ['a', 'b', 'c']);
	 *     // => { a: null, b: null, c: null }
	 * </pre>
	 */
	exports.default = (0, _lodash.curry)(function (defaultValue, keys) {
	    var defaultValueFunction = (0, _lodash.isFunction)(defaultValue) ? defaultValue : function (key) {
	        return defaultValue;
	    };
	
	    return (0, _lodash.zipObject)(keys, (0, _lodash.map)(keys, defaultValueFunction));
	}); // Lib

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rafThrottle = __webpack_require__(245);
	
	var _rafThrottle2 = _interopRequireDefault(_rafThrottle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	// Utils
	
	
	exports.default = function (DecoratedComponent) {
	    var renderThrottleDecorator = function (_React$Component) {
	        _inherits(renderThrottleDecorator, _React$Component);
	
	        function renderThrottleDecorator(props) {
	            _classCallCheck(this, renderThrottleDecorator);
	
	            var _this = _possibleConstructorReturn(this, (renderThrottleDecorator.__proto__ || Object.getPrototypeOf(renderThrottleDecorator)).call(this, props));
	
	            _this.throttledSetState = (0, _rafThrottle2.default)(_this.setState.bind(_this));
	
	            _this.state = {};
	            return _this;
	        }
	
	        _createClass(renderThrottleDecorator, [{
	            key: 'componentWillMount',
	            value: function componentWillMount() {
	                this.setState({ props: this.props });
	            }
	        }, {
	            key: 'componentWillReceiveProps',
	            value: function componentWillReceiveProps(nextProps) {
	                this.throttledSetState({ props: nextProps });
	            }
	        }, {
	            key: 'shouldComponentUpdate',
	            value: function shouldComponentUpdate(nextProps, nextState) {
	                return this.state !== nextState;
	            }
	        }, {
	            key: 'componentWillUnmount',
	            value: function componentWillUnmount() {
	                this.throttledSetState.cancel();
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                return _react2.default.createElement(DecoratedComponent, this.state.props);
	            }
	        }]);
	
	        return renderThrottleDecorator;
	    }(_react2.default.Component);
	
	    renderThrottleDecorator.propTypes = {};
	
	    return renderThrottleDecorator;
	};

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PropTypes = __webpack_require__(401);
	
	var _warning = __webpack_require__(282);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This is a copy paste of the react-redux Provider, with changes made to allow the store name to be specified.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Usage: first you must create a provider, then wrap it around your app. e.g. in Root.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <pre>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     import makeCustomProvider from './makeCustomProvider';
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     const MeasurementsProvider = makeCustomProvider('measurementsStore');
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     ...
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     <MeasurementsProvider store={measurementsStore}>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *         ....
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     </MeasurementsProvider>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * </pre>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	    if (didWarnAboutReceivingStore) {
	        return;
	    }
	    didWarnAboutReceivingStore = true;
	
	    (0, _warning2.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	exports.default = function (storeName) {
	    var CustomProvider = function (_Component) {
	        _inherits(CustomProvider, _Component);
	
	        function CustomProvider(props, context) {
	            _classCallCheck(this, CustomProvider);
	
	            var _this = _possibleConstructorReturn(this, (CustomProvider.__proto__ || Object.getPrototypeOf(CustomProvider)).call(this, props, context));
	
	            _this.store = props.store;
	            return _this;
	        }
	
	        _createClass(CustomProvider, [{
	            key: 'getChildContext',
	            value: function getChildContext() {
	                return _defineProperty({}, storeName, this.store);
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                return _react.Children.only(this.props.children);
	            }
	        }]);
	
	        return CustomProvider;
	    }(_react.Component);
	
	    if (false) {
	        CustomProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	            var store = this.store;
	            var nextStore = nextProps.store;
	
	
	            if (store !== nextStore) {
	                warnAboutReceivingStore();
	            }
	        };
	    }
	
	    CustomProvider.propTypes = {
	        store: _PropTypes.storeShape.isRequired,
	        children: _propTypes2.default.element.isRequired
	    };
	    CustomProvider.childContextTypes = _defineProperty({}, storeName, _PropTypes.storeShape.isRequired);
	    CustomProvider.displayName = 'CustomProvider';
	
	    return CustomProvider;
	};

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.makeResourceInvalidatedActionCreator = exports.makeResourceStaleActionCreator = exports.makeResourceErrorActionCreator = exports.makeResourceActionCreator = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _resourceConstants = __webpack_require__(85);
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var makeResourceActionCreator = function makeResourceActionCreator(resourceType, actionType) {
	    return function (_ref) {
	        var id = _ref.id,
	            ids = _ref.ids,
	            rest = _objectWithoutProperties(_ref, ['id', 'ids']);
	
	        return _extends({
	            type: actionType,
	            resource: resourceType,
	            ids: id ? [id] : ids
	        }, rest);
	    };
	};
	
	exports.makeResourceActionCreator = makeResourceActionCreator;
	var makeResourceErrorActionCreator = exports.makeResourceErrorActionCreator = function makeResourceErrorActionCreator(resourceType) {
	    return makeResourceActionCreator(resourceType, _resourceConstants.RESOURCES_FETCH_ERROR);
	};
	
	var makeResourceStaleActionCreator = exports.makeResourceStaleActionCreator = function makeResourceStaleActionCreator(resourceType) {
	    return makeResourceActionCreator(resourceType, _resourceConstants.RESOURCES_MARKED_AS_STALE);
	};
	
	var makeResourceInvalidatedActionCreator = exports.makeResourceInvalidatedActionCreator = function makeResourceInvalidatedActionCreator(resourceType) {
	    return function () {
	        return {
	            type: _resourceConstants.RESOURCES_INVALIDATED,
	            resource: resourceType
	        };
	    };
	};

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _promisedFileReader = __webpack_require__(468);
	
	var _getExifOrientationData = __webpack_require__(2137);
	
	var _getExifOrientationData2 = _interopRequireDefault(_getExifOrientationData);
	
	var _mimeConstants = __webpack_require__(798);
	
	var _jpegExifOrientationTransformer = __webpack_require__(2138);
	
	var _jpegExifOrientationTransformer2 = _interopRequireDefault(_jpegExifOrientationTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Constants
	// Utils
	var ORIENTATIONS_REQUIRING_TRANSFORMATIONS = [2, 3, 4, 5, 6, 7, 8];
	
	// JPEG EXIF Orientation
	
	
	var orientationRequiresTransformation = function orientationRequiresTransformation(orientation) {
	    return ORIENTATIONS_REQUIRING_TRANSFORMATIONS.indexOf(orientation) !== -1;
	};
	
	exports.default = function (inputFile) {
	    // If not a JPEG file then we don't need to worry about
	    if (inputFile.type !== _mimeConstants.MIME_TYPES.JPEG) {
	        return (0, _promisedFileReader.readAsDataURL)(inputFile).then(function (imageDataUri) {
	            return { file: inputFile, imageDataUri: imageDataUri };
	        });
	    }
	
	    return (0, _getExifOrientationData2.default)(inputFile).then(function (srcOrientation) {
	        return (0, _promisedFileReader.readAsDataURL)(inputFile).then(function (imageDataUri) {
	            return { file: inputFile, imageDataUri: imageDataUri, srcOrientation: srcOrientation };
	        });
	    }).then(function (_ref) {
	        var file = _ref.file,
	            imageDataUri = _ref.imageDataUri,
	            srcOrientation = _ref.srcOrientation;
	        return orientationRequiresTransformation(srcOrientation) ? (0, _jpegExifOrientationTransformer2.default)({ srcOrientation: srcOrientation, imageDataUri: imageDataUri }) : { file: file, imageDataUri: imageDataUri };
	    });
	};

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.channelsUpdated = exports.socketDisconnect = exports.socketConnect = undefined;
	
	var _socketConstants = __webpack_require__(109);
	
	var socketConnect = exports.socketConnect = function socketConnect() {
	    return { type: _socketConstants.SOCKET_CONNECT };
	};
	var socketDisconnect = exports.socketDisconnect = function socketDisconnect() {
	    return { type: _socketConstants.SOCKET_DISCONNECT };
	};
	
	var channelsUpdated = exports.channelsUpdated = function channelsUpdated(_ref) {
	    var joined = _ref.joined,
	        left = _ref.left,
	        boardChannels = _ref.boardChannels;
	    return {
	        type: _socketConstants.CHANNELS_UPDATED,
	        joined: joined,
	        left: left,
	        boardChannels: boardChannels
	    };
	};

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.socketConnectedSelector = exports.getSocketConnectionStatus = exports.getSocketConnection = undefined;
	
	var _reselect = __webpack_require__(7);
	
	var _socketConstants = __webpack_require__(109);
	
	// Lib
	var getSocketConnection = exports.getSocketConnection = function getSocketConnection(state) {
	    return state.getIn(['app', 'socketConnection']);
	};
	
	// Constants
	var getSocketConnectionStatus = exports.getSocketConnectionStatus = function getSocketConnectionStatus(state) {
	    return state.getIn(['app', 'socketConnection', 'status']);
	};
	
	var socketConnectedSelector = exports.socketConnectedSelector = (0, _reselect.createSelector)(getSocketConnectionStatus, function (socketStatus) {
	    return socketStatus === _socketConstants.SOCKET_CONNECTION_STATUS.CONNECTED;
	});

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reselect = __webpack_require__(7);
	
	var _reactRedux = __webpack_require__(3);
	
	var _BreadcrumbList = __webpack_require__(2164);
	
	var _BreadcrumbList2 = _interopRequireDefault(_BreadcrumbList);
	
	var _AccountUtil = __webpack_require__(2169);
	
	var _AccountUtil2 = _interopRequireDefault(_AccountUtil);
	
	var _NotificationUtil = __webpack_require__(2186);
	
	var _NotificationUtil2 = _interopRequireDefault(_NotificationUtil);
	
	var _CurrentBoardHeader = __webpack_require__(2161);
	
	var _CurrentBoardHeader2 = _interopRequireDefault(_CurrentBoardHeader);
	
	var _LiveEditingUtil = __webpack_require__(2185);
	
	var _LiveEditingUtil2 = _interopRequireDefault(_LiveEditingUtil);
	
	var _ReferUtil = __webpack_require__(2165);
	
	var _ReferUtil2 = _interopRequireDefault(_ReferUtil);
	
	var _HelpUtil = __webpack_require__(2182);
	
	var _HelpUtil2 = _interopRequireDefault(_HelpUtil);
	
	var _mainSelector = __webpack_require__(239);
	
	__webpack_require__(1265);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Util
	var boardAncestorsSelector = (0, _reselect.createSelector)(_mainSelector.getBreadcrumb, function (state, props) {
	    return state.getIn(['app', 'currentUser', 'rootBoardId']);
	}, function (breadcrumbObj, rootBoardId) {
	    return {
	        rootBoardId: rootBoardId,
	        breadcrumbObj: breadcrumbObj
	    };
	});
	
	// Styles
	
	
	// Components
	// Lib
	
	
	var AppHeaderMobile = function AppHeaderMobile(props) {
	    return _react2.default.createElement(
	        'header',
	        { className: 'AppHeader' },
	        _react2.default.createElement(
	            'div',
	            { className: 'header-section header-tools' },
	            _react2.default.createElement(
	                'div',
	                { className: 'header-left' },
	                _react2.default.createElement(_BreadcrumbList2.default, props)
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'header-right' },
	                _react2.default.createElement(_NotificationUtil2.default, { currentUser: props.currentUser }),
	                _react2.default.createElement(_AccountUtil2.default, { currentUser: props.currentUser })
	            )
	        )
	    );
	};
	
	var AppHeaderDesktop = function AppHeaderDesktop(props) {
	    return _react2.default.createElement(
	        'header',
	        { className: 'AppHeader' },
	        _react2.default.createElement(
	            'div',
	            { className: 'header-section header-tools' },
	            _react2.default.createElement(
	                'div',
	                { className: 'header-left' },
	                _react2.default.createElement(_BreadcrumbList2.default, props)
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'header-right' },
	                _react2.default.createElement(_ReferUtil2.default, { currentUser: props.currentUser }),
	                _react2.default.createElement(_HelpUtil2.default, null),
	                _react2.default.createElement(_LiveEditingUtil2.default, { currentUser: props.currentUser }),
	                _react2.default.createElement(_NotificationUtil2.default, { currentUser: props.currentUser }),
	                _react2.default.createElement(_AccountUtil2.default, { currentUser: props.currentUser })
	            )
	        ),
	        _react2.default.createElement(_CurrentBoardHeader2.default, props)
	    );
	};
	
	var AppHeader = function AppHeader(props) {
	    return props.isMobileView ? _react2.default.createElement(AppHeaderMobile, props) : _react2.default.createElement(AppHeaderDesktop, props);
	};
	
	AppHeader.propTypes = AppHeaderMobile.propTypes = AppHeaderDesktop.propTypes = {
	    currentUser: _propTypes2.default.object,
	    currentBoardId: _propTypes2.default.string.isRequired,
	    documentMode: _propTypes2.default.bool,
	    isEditable: _propTypes2.default.bool,
	    isMobileView: _propTypes2.default.bool,
	    getDocumentElementSizes: _propTypes2.default.func,
	    elementFilter: _propTypes2.default.object,
	    breadcrumbObj: _propTypes2.default.object
	};
	
	exports.default = (0, _reactRedux.connect)(boardAncestorsSelector)(AppHeader);

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(9);
	
	var _EditableTitle = __webpack_require__(228);
	
	var _EditableTitle2 = _interopRequireDefault(_EditableTitle);
	
	__webpack_require__(1266);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	var BoardTitle = function BoardTitle(_ref) {
	    var currentBoardId = _ref.currentBoardId,
	        isEditable = _ref.isEditable,
	        currentBoard = _ref.currentBoard;
	    return _react2.default.createElement(
	        'div',
	        { className: 'BoardTitle' },
	        _react2.default.createElement(_EditableTitle2.default, {
	            element: currentBoard,
	            elementId: currentBoardId,
	            isEditable: isEditable,
	            editorKey: 'CURRENT_BOARD_TITLE' })
	    );
	};
	
	// Styles
	// Lib
	
	
	BoardTitle.propTypes = {
	    currentBoardId: _propTypes2.default.string.isRequired,
	    isEditable: _propTypes2.default.bool,
	    currentBoard: _propTypes2.default.object
	};
	
	exports.default = (0, _recompose.pure)(BoardTitle);

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _AccountGuestPopup = __webpack_require__(2167);
	
	var _AccountGuestPopup2 = _interopRequireDefault(_AccountGuestPopup);
	
	var _AccountUserPopup = __webpack_require__(2168);
	
	var _AccountUserPopup2 = _interopRequireDefault(_AccountUserPopup);
	
	var _navigationActions = __webpack_require__(27);
	
	__webpack_require__(1273);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        currentUser: state.getIn(['app', 'currentUser'])
	    };
	};
	
	// Styles
	
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        login: function login() {
	            return dispatch((0, _navigationActions.navigateToLogin)());
	        }
	    };
	};
	
	var AccountPopup = function AccountPopup(props) {
	    return props.currentUser.get('isGuest') ? _react2.default.createElement(_AccountGuestPopup2.default, props) : _react2.default.createElement(_AccountUserPopup2.default, props);
	};
	
	AccountPopup.propTypes = {
	    currentUser: _propTypes2.default.object
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AccountPopup);

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class; // Lib
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reselect = __webpack_require__(7);
	
	var _PopupPanel = __webpack_require__(54);
	
	var _PopupPanel2 = _interopRequireDefault(_PopupPanel);
	
	var _BillingTierFree = __webpack_require__(773);
	
	var _BillingTierFree2 = _interopRequireDefault(_BillingTierFree);
	
	var _Button = __webpack_require__(34);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _popupActions = __webpack_require__(35);
	
	var _popupOpenSelector = __webpack_require__(141);
	
	var _popupOpenSelector2 = _interopRequireDefault(_popupOpenSelector);
	
	var _elementCountSelector = __webpack_require__(170);
	
	var _currentUserSelector = __webpack_require__(33);
	
	var _userUtil = __webpack_require__(31);
	
	var _elementCountConstants = __webpack_require__(169);
	
	__webpack_require__(1274);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Only show the close button if not in the mobile view.
	 */
	var BillingAlertCloseButton = function BillingAlertCloseButton(_ref) {
	    var isMobileView = _ref.isMobileView,
	        closeAlertPopup = _ref.closeAlertPopup;
	
	    if (isMobileView) return null;
	    return _react2.default.createElement(
	        'div',
	        { className: 'header' },
	        _react2.default.createElement(
	            _Button2.default,
	            { onClickFn: closeAlertPopup, className: 'close-button' },
	            _react2.default.createElement(_Icon2.default, { name: 'close-x' })
	        )
	    );
	};
	
	BillingAlertCloseButton.propTypes = {
	    closeAlertPopup: _propTypes2.default.func,
	    isMobileView: _propTypes2.default.bool
	};
	
	var countSelector = (0, _reselect.createSelector)(_elementCountSelector.contentTotalCountSelector, _elementCountSelector.contentTotalLimitSelector, (0, _popupOpenSelector2.default)(_elementCountConstants.ELEMENT_COUNT_LIMIT_POPUP), _currentUserSelector.getCurrentUser, function (contentTotalCount, contentTotalLimit, popupOpen, currentUser) {
	    return {
	        contentTotalCount: contentTotalCount,
	        contentTotalLimit: contentTotalLimit,
	        popupOpen: popupOpen,
	        currentUser: currentUser
	    };
	});
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        openAlertPopup: function openAlertPopup() {
	            return dispatch((0, _popupActions.openPopup)(_elementCountConstants.ELEMENT_COUNT_LIMIT_POPUP));
	        },
	        closeAlertPopup: function closeAlertPopup() {
	            return dispatch((0, _popupActions.closePopup)(_elementCountConstants.ELEMENT_COUNT_LIMIT_POPUP));
	        }
	    };
	};
	
	var BillingAlertPopup = (_dec = (0, _reactRedux.connect)(countSelector, mapDispatchToProps), _dec(_class = function (_React$Component) {
	    _inherits(BillingAlertPopup, _React$Component);
	
	    function BillingAlertPopup() {
	        _classCallCheck(this, BillingAlertPopup);
	
	        return _possibleConstructorReturn(this, (BillingAlertPopup.__proto__ || Object.getPrototypeOf(BillingAlertPopup)).apply(this, arguments));
	    }
	
	    _createClass(BillingAlertPopup, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var oldCount = this.props.contentTotalCount;
	            var contentTotalCount = nextProps.contentTotalCount,
	                contentTotalLimit = nextProps.contentTotalLimit,
	                openAlertPopup = nextProps.openAlertPopup,
	                popupOpen = nextProps.popupOpen,
	                currentUser = nextProps.currentUser;
	
	            // don't open popup if currentUser is subscribed
	
	            if ((0, _userUtil.isSubscribed)(currentUser)) return;
	
	            // don't open popup if it's already open, or count went down
	            if (popupOpen || contentTotalCount <= oldCount) return;
	
	            // if you have too much content, open popup
	            if (contentTotalCount >= contentTotalLimit - _elementCountConstants.ELEMENT_COUNT_WARNING_START && contentTotalCount % _elementCountConstants.ELEMENT_COUNT_WARNING_INTERVAL === 0) return openAlertPopup();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _PopupPanel2.default,
	                _extends({}, this.props, {
	                    popupId: _elementCountConstants.ELEMENT_COUNT_LIMIT_POPUP,
	                    className: 'BillingAlertPopup',
	                    stayOpen: true }),
	                _react2.default.createElement(BillingAlertCloseButton, this.props),
	                _react2.default.createElement(_BillingTierFree2.default, { buttonClass: 'FormButton primary' })
	            );
	        }
	    }]);
	
	    return BillingAlertPopup;
	}(_react2.default.Component)) || _class);
	
	
	BillingAlertPopup.propTypes = {
	    contentTotalCount: _propTypes2.default.number,
	    contentTotalLimit: _propTypes2.default.number,
	    openAlertPopup: _propTypes2.default.func,
	    closeAlertPopup: _propTypes2.default.func,
	    currentUser: _propTypes2.default.object
	};
	
	exports.default = BillingAlertPopup;

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reselect = __webpack_require__(7);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ElementCount = __webpack_require__(774);
	
	var _ElementCount2 = _interopRequireDefault(_ElementCount);
	
	var _PlanStatusTitle = __webpack_require__(754);
	
	var _PlanStatusTitle2 = _interopRequireDefault(_PlanStatusTitle);
	
	var _ElectronLink = __webpack_require__(427);
	
	var _ElectronLink2 = _interopRequireDefault(_ElectronLink);
	
	var _elementCountSelector = __webpack_require__(170);
	
	var _userConstants = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var countSelector = (0, _reselect.createSelector)(_elementCountSelector.contentElementCountSelector, _elementCountSelector.contentTotalCountSelector, _elementCountSelector.contentTotalLimitSelector, function (elementCount, contentTotalCount, contentTotalLimit) {
	    return {
	        elementCount: elementCount,
	        contentTotalCount: contentTotalCount,
	        contentTotalLimit: contentTotalLimit
	    };
	});
	
	var BillingTierFree = function BillingTierFree(props) {
	    var contentTotalCount = props.contentTotalCount,
	        contentTotalLimit = props.contentTotalLimit,
	        buttonClass = props.buttonClass;
	
	
	    var earnedContent = contentTotalLimit - _userConstants.CONTENT_LIMIT_FREE_BASE;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'BillingStatusDisplay BillingTierFree' },
	        _react2.default.createElement(
	            'div',
	            { className: 'plan-status' },
	            _react2.default.createElement(_PlanStatusTitle2.default, { contentTotalCount: contentTotalCount, contentTotalLimit: contentTotalLimit })
	        ),
	        _react2.default.createElement(_ElementCount2.default, _extends({}, props, { contentTotalLimit: contentTotalLimit, showCountDetail: true })),
	        _react2.default.createElement(
	            'div',
	            { className: 'plan-actions' },
	            earnedContent > 0 ? _react2.default.createElement(
	                'span',
	                { className: 'earned' },
	                'You\'ve earned ',
	                earnedContent,
	                ' extra cards'
	            ) : null,
	            _react2.default.createElement(
	                _ElectronLink2.default,
	                { to: '/account/plan', className: (0, _classnames2.default)(buttonClass || 'action', 'primary') },
	                'Get more space'
	            )
	        )
	    );
	};
	
	BillingTierFree.propTypes = {
	    currentUser: _propTypes2.default.object,
	    elementCount: _propTypes2.default.object,
	    contentTotalCount: _propTypes2.default.number,
	    contentTotalLimit: _propTypes2.default.number,
	    buttonClass: _propTypes2.default.string
	};
	
	exports.default = (0, _reactRedux.connect)(countSelector)(BillingTierFree);

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _notificationUtils = __webpack_require__(324);
	
	__webpack_require__(1277);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ElementCount = function ElementCount(props) {
	    var contentTotalCount = props.contentTotalCount,
	        elementCount = props.elementCount,
	        contentTotalLimit = props.contentTotalLimit,
	        showCountDetail = props.showCountDetail,
	        children = props.children;
	
	    var isFull = contentTotalCount >= contentTotalLimit;
	    var countDetail = showCountDetail ? (0, _notificationUtils.describeElementTypes)(elementCount.toJS()) : '';
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'ElementCount' },
	        _react2.default.createElement(
	            'div',
	            { className: 'content-explain' },
	            children,
	            contentTotalCount,
	            ' / ',
	            contentTotalLimit,
	            ' used',
	            countDetail.length ? ' (' + countDetail + ')' : null
	        ),
	        _react2.default.createElement('progress', { value: contentTotalCount, max: contentTotalLimit, className: (0, _classnames2.default)({ full: isFull }) })
	    );
	};
	
	ElementCount.propTypes = {
	    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array, _propTypes2.default.string]),
	    elementCount: _propTypes2.default.object,
	    contentTotalCount: _propTypes2.default.number,
	    contentTotalLimit: _propTypes2.default.number,
	    showCountDetail: _propTypes2.default.bool
	};
	
	exports.default = ElementCount;

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reselect = __webpack_require__(7);
	
	var _electronConstants = __webpack_require__(321);
	
	var electronUpdateSelector = (0, _reselect.createSelector)(function (state) {
	    return state.getIn(['app', 'electron', 'autoUpdate']);
	}, function (state) {
	    return state.getIn(['app', 'electron', 'appVersion']);
	}, function (autoUpdate, version) {
	    return {
	        autoUpdate: autoUpdate,
	        version: version,
	        updateReady: autoUpdate === _electronConstants.AUTOUPDATE_STATE.READY
	    };
	});
	
	exports.default = electronUpdateSelector;

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ToggleInput = __webpack_require__(1778);
	
	var _ToggleInput2 = _interopRequireDefault(_ToggleInput);
	
	__webpack_require__(557);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	// Lib
	var EmailPreferenceToggle = function EmailPreferenceToggle(_ref) {
	    var value = _ref.value,
	        active = _ref.active,
	        label = _ref.label,
	        updatePreference = _ref.updatePreference;
	    return _react2.default.createElement(
	        'li',
	        { className: 'EmailPreferenceToggle' },
	        _react2.default.createElement(_ToggleInput2.default, { label: label, value: value, active: active, onChange: updatePreference })
	    );
	};
	
	// Styles
	
	
	EmailPreferenceToggle.propTypes = {
	    updatePreference: _propTypes2.default.func.isRequired,
	    active: _propTypes2.default.bool,
	    value: _propTypes2.default.number.isRequired,
	    label: _propTypes2.default.string.isRequired
	};
	
	exports.default = EmailPreferenceToggle;

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class; // Lib
	
	
	// Services
	
	
	// Components
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _userService = __webpack_require__(106);
	
	var _PopupEmptyContent = __webpack_require__(441);
	
	var _PopupEmptyContent2 = _interopRequireDefault(_PopupEmptyContent);
	
	var _RetryErrorComponent = __webpack_require__(694);
	
	var _RetryErrorComponent2 = _interopRequireDefault(_RetryErrorComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        dispatchFetchUsers: function dispatchFetchUsers(userIds) {
	            return dispatch((0, _userService.fetchUsers)(userIds, true));
	        }
	    };
	};
	
	var PopupUserErrorEmptyContent = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec(_class = function (_React$Component) {
	    _inherits(PopupUserErrorEmptyContent, _React$Component);
	
	    function PopupUserErrorEmptyContent() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, PopupUserErrorEmptyContent);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PopupUserErrorEmptyContent.__proto__ || Object.getPrototypeOf(PopupUserErrorEmptyContent)).call.apply(_ref, [this].concat(args))), _this), _this.retry = function () {
	            var _this$props = _this.props,
	                userIds = _this$props.userIds,
	                dispatchFetchUsers = _this$props.dispatchFetchUsers;
	
	            dispatchFetchUsers(userIds);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(PopupUserErrorEmptyContent, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _PopupEmptyContent2.default,
	                null,
	                _react2.default.createElement(_RetryErrorComponent2.default, { message: 'There was a problem loading users', retryFn: this.retry })
	            );
	        }
	    }]);
	
	    return PopupUserErrorEmptyContent;
	}(_react2.default.Component)) || _class);
	
	
	PopupUserErrorEmptyContent.propTypes = {
	    userIds: _propTypes2.default.array,
	    dispatchFetchUsers: _propTypes2.default.func
	};
	
	exports.default = PopupUserErrorEmptyContent;

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reselect = __webpack_require__(7);
	
	var _recompose = __webpack_require__(9);
	
	var _elementHelper = __webpack_require__(13);
	
	var _elementFilterUtil = __webpack_require__(728);
	
	var _stringUtil = __webpack_require__(58);
	
	var _notificationUtils = __webpack_require__(324);
	
	var _boardSelector = __webpack_require__(83);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _PillButton = __webpack_require__(1701);
	
	var _PillButton2 = _interopRequireDefault(_PillButton);
	
	var _navigationActions = __webpack_require__(27);
	
	__webpack_require__(1280);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Actions
	
	
	// Components
	// Lib
	var FILTER_TYPES = {
	    ELEMENT: 'ELEMENT',
	    DATE: 'DATE'
	};
	
	// Styles
	
	
	// Selectors
	
	
	// Utils
	
	
	var activeElementSelector = (0, _reselect.createSelector)(function (state, ownProps) {
	    return ownProps.elementFilter;
	}, function (state) {
	    return state.get('elements');
	}, function (state, ownProps) {
	    return ownProps.currentBoardId;
	}, function (elementFilter, elements, currentBoardId) {
	    if (!elementFilter) return null;
	
	    var children = (0, _elementHelper.getChildrenDeep)(elements, currentBoardId);
	
	    return children.filter(function (element) {
	        return (0, _elementFilterUtil.filterElement)(element, elementFilter);
	    });
	});
	
	var elementFilterTypeSelector = (0, _reselect.createSelector)(function (state, ownProps) {
	    return ownProps.elementFilter;
	}, function (elementFilter) {
	    return elementFilter && elementFilter.ids ? FILTER_TYPES.ELEMENT : FILTER_TYPES.DATE;
	});
	
	var elementFilterUtilSelector = (0, _reselect.createSelector)(function (state, ownProps) {
	    return ownProps.elementFilter;
	}, activeElementSelector, _boardSelector.getIsCurrentBoardFetched, elementFilterTypeSelector, function (elementFilter, activeElements, currentBoardFetched, filterType) {
	    return {
	        active: currentBoardFetched && elementFilter !== null,
	        activeElements: activeElements,
	        filterCount: activeElements && activeElements.size,
	        filterType: filterType
	    };
	});
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        dispatchClearFilter: function dispatchClearFilter() {
	            return dispatch((0, _navigationActions.clearFilter)());
	        }
	    };
	};
	
	var lifecyleEvents = {
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        var active = nextProps.active,
	            filterCount = nextProps.filterCount,
	            dispatchClearFilter = nextProps.dispatchClearFilter;
	
	        if (active && filterCount === 0) dispatchClearFilter();
	    }
	};
	
	var ElementFilterRecent = function ElementFilterRecent(_ref) {
	    var filterCount = _ref.filterCount;
	    return _react2.default.createElement(
	        'span',
	        { className: 'changes' },
	        _react2.default.createElement(
	            'span',
	            { className: 'verb' },
	            'Showing'
	        ),
	        _react2.default.createElement(
	            'span',
	            { className: 'query' },
	            ' ',
	            filterCount,
	            ' recent ',
	            (0, _stringUtil.pluralise)('change', filterCount)
	        )
	    );
	};
	
	ElementFilterRecent.propTypes = {
	    filterCount: _propTypes2.default.number
	};
	
	var ElementFilterDescribe = function ElementFilterDescribe(_ref2) {
	    var activeElements = _ref2.activeElements;
	
	    var elementsJs = activeElements.toJS();
	    var elements = Object.keys(elementsJs).map(function (key) {
	        return elementsJs[key];
	    }).reduce(_notificationUtils.reduceTypeCounts, {});
	
	    return _react2.default.createElement(
	        'span',
	        { className: 'changes' },
	        _react2.default.createElement(
	            'span',
	            { className: 'verb' },
	            'Showing'
	        ),
	        _react2.default.createElement(
	            'span',
	            { className: 'query' },
	            ' ',
	            (0, _notificationUtils.describeElementTypes)(elements)
	        )
	    );
	};
	
	ElementFilterDescribe.propTypes = {
	    activeElements: _propTypes2.default.object
	};
	
	var ElementFilterUtil = function ElementFilterUtil(props) {
	    var active = props.active,
	        filterType = props.filterType,
	        dispatchClearFilter = props.dispatchClearFilter;
	
	
	    if (!active) return null;
	
	    return _react2.default.createElement(
	        _PillButton2.default,
	        { className: 'ElementFilterUtil', onClickFn: dispatchClearFilter },
	        filterType === FILTER_TYPES.DATE ? _react2.default.createElement(ElementFilterRecent, props) : _react2.default.createElement(ElementFilterDescribe, props),
	        _react2.default.createElement(
	            'span',
	            { className: 'close' },
	            _react2.default.createElement(_Icon2.default, { name: 'close-x-small' })
	        )
	    );
	};
	
	ElementFilterUtil.propTypes = {
	    active: _propTypes2.default.bool,
	    dispatchClearFilter: _propTypes2.default.func,
	    activeElements: _propTypes2.default.object,
	    filterCount: _propTypes2.default.number,
	    filterType: _propTypes2.default.string
	};
	
	var enhance = (0, _recompose.compose)((0, _reactRedux.connect)(elementFilterUtilSelector, mapDispatchToProps), (0, _recompose.lifecycle)(lifecyleEvents), _recompose.pure);
	
	exports.default = enhance(ElementFilterUtil);

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reselect = __webpack_require__(7);
	
	var _popupOpenSelector = __webpack_require__(141);
	
	var _popupOpenSelector2 = _interopRequireDefault(_popupOpenSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getUnreadMessageCount = function getUnreadMessageCount(state) {
	    return state.getIn(['app', 'analytics', 'unreadMessageCount']);
	};
	
	exports.default = (0, _reselect.createStructuredSelector)({
	    popupOpen: (0, _popupOpenSelector2.default)('help'),
	    unreadMessageCount: getUnreadMessageCount
	});

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getActiveUsersByBoards = undefined;
	
	var _reselect = __webpack_require__(7);
	
	var _lodash = __webpack_require__(4);
	
	var _popupOpenSelector = __webpack_require__(141);
	
	var _popupOpenSelector2 = _interopRequireDefault(_popupOpenSelector);
	
	var _usersSelector = __webpack_require__(204);
	
	var _milanoteReselect = __webpack_require__(49);
	
	var _userUtil = __webpack_require__(31);
	
	var _resourceUtil = __webpack_require__(108);
	
	var _permissionsService = __webpack_require__(75);
	
	var _liveEditingUtilConstants = __webpack_require__(475);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getActiveUsersByBoards = exports.getActiveUsersByBoards = (0, _reselect.createSelector)(function (state) {
	    return state.get('users');
	}, function (state) {
	    return state.get('elements');
	}, function (state) {
	    return state.getIn(['app', 'currentUser', '_id']);
	}, function (users, elements, currentUserId) {
	    return (0, _lodash.values)(users.reduce(function (boardIdMap, user) {
	        if (user.get('_id') === currentUserId || !(0, _userUtil.isOnline)(user)) return boardIdMap;
	        var remoteUserId = user.get('_id');
	        var usersCurrentBoardId = user.get('currentBoardId');
	
	        if ((0, _permissionsService.canSaveBoard)(elements, usersCurrentBoardId, currentUserId) && (0, _permissionsService.canSaveBoard)(elements, usersCurrentBoardId, remoteUserId)) {
	            boardIdMap[usersCurrentBoardId] = boardIdMap[usersCurrentBoardId] || { boardId: usersCurrentBoardId, users: [] };
	            boardIdMap[usersCurrentBoardId].users.push(remoteUserId);
	        }
	
	        return boardIdMap;
	    }, {}));
	});
	
	// Constants
	
	
	// Utils
	
	
	// Selectors
	// Lib
	
	
	var getActiveUsers = (0, _reselect.createSelector)(function (state) {
	    return state.get('users');
	}, function (state) {
	    return state.get('elements');
	}, function (state) {
	    return state.getIn(['app', 'currentUser', '_id']);
	}, function (users, elements, currentUserId) {
	    return users.filter(function (user) {
	        var remoteUserId = user.get('_id');
	        var userCurrentBoardId = user.get('currentBoardId');
	        return user.get('_id') !== currentUserId && (0, _userUtil.isOnline)(user) && (0, _permissionsService.canSaveBoard)(elements, userCurrentBoardId, currentUserId) && (0, _permissionsService.canSaveBoard)(elements, userCurrentBoardId, remoteUserId);
	    });
	});
	
	var getActiveUserIds = (0, _milanoteReselect.createShallowSelector)(getActiveUsers, function (activeUsers) {
	    return activeUsers.keySeq().toArray();
	});
	
	var getActiveUserResources = (0, _usersSelector.makeFilteredUsersResourcesSelector)(getActiveUserIds);
	
	var getErrorActiveUserIds = (0, _milanoteReselect.createShallowSelector)(getActiveUserResources, function (activeUserResourcesState) {
	    return activeUserResourcesState.filter(_resourceUtil.isError).keySeq().toArray();
	});
	
	var getFetchingActiveUserIds = (0, _milanoteReselect.createShallowSelector)(getActiveUserResources, function (activeUserResourcesState) {
	    return activeUserResourcesState.filter(_resourceUtil.isFetching).keySeq().toArray();
	});
	
	var getActiveUserCount = (0, _reselect.createSelector)(getActiveUsers, function (activeUsers) {
	    return activeUsers.size;
	});
	
	exports.default = (0, _reselect.createSelector)((0, _popupOpenSelector2.default)(_liveEditingUtilConstants.LIVE_EDITING_POPUP_ID), getActiveUserCount, getActiveUsersByBoards, getErrorActiveUserIds, getFetchingActiveUserIds, function (popupOpen, activeUserCount, activeUsersByBoards, errorActiveUserIds, fetchingActiveUserIds) {
	    return {
	        popupOpen: popupOpen,
	        activeUserCount: activeUserCount,
	        activeUsersByBoards: activeUsersByBoards,
	        errorActiveUserIds: errorActiveUserIds,
	        fetchingActiveUserIds: fetchingActiveUserIds
	    };
	});

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Utils
	
	
	// Actions
	
	
	// Components
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__(3);
	
	var _recompose = __webpack_require__(9);
	
	var _stringUtil = __webpack_require__(58);
	
	var _timeUtil = __webpack_require__(43);
	
	var _notificationActions = __webpack_require__(460);
	
	var _currentUserActions = __webpack_require__(84);
	
	var _Button = __webpack_require__(34);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _PopupPanel = __webpack_require__(54);
	
	var _PopupPanel2 = _interopRequireDefault(_PopupPanel);
	
	var _ModifiedBoardMessage = __webpack_require__(2188);
	
	var _ModifiedBoardMessage2 = _interopRequireDefault(_ModifiedBoardMessage);
	
	var _PopupList = __webpack_require__(714);
	
	var _PopupList2 = _interopRequireDefault(_PopupList);
	
	var _PopupEmptyContent = __webpack_require__(441);
	
	var _PopupEmptyContent2 = _interopRequireDefault(_PopupEmptyContent);
	
	var _PopupUserErrorEmptyContent = __webpack_require__(777);
	
	var _PopupUserErrorEmptyContent2 = _interopRequireDefault(_PopupUserErrorEmptyContent);
	
	var _notificationUtilSelector = __webpack_require__(782);
	
	var _notificationUtilSelector2 = _interopRequireDefault(_notificationUtilSelector);
	
	__webpack_require__(1289);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        dispatchMarkBoardsAsSeen: function dispatchMarkBoardsAsSeen(boardIds, userId) {
	            return dispatch((0, _notificationActions.markBoardsAsSeen)({ ids: boardIds, userId: userId }));
	        },
	        updateLastCheckedTime: function updateLastCheckedTime(currentUserId) {
	            return function () {
	                dispatch((0, _currentUserActions.updateCurrentUser)({
	                    userId: currentUserId,
	                    changes: {
	                        lastCheckedNotifications: (0, _timeUtil.getTimestamp)()
	                    }
	                }));
	            };
	        }
	    };
	};
	
	var notificationPopupHandlers = {
	    clearNotifications: function clearNotifications(_ref) {
	        var dispatchMarkBoardsAsSeen = _ref.dispatchMarkBoardsAsSeen,
	            currentUser = _ref.currentUser,
	            notifications = _ref.notifications;
	        return function (event) {
	            var boardIds = notifications.map(function (notification) {
	                return notification.get('id');
	            }).toArray();
	            dispatchMarkBoardsAsSeen(boardIds, currentUser.get('_id'));
	        };
	    }
	};
	
	var NotificationPopupEmptyContent = function NotificationPopupEmptyContent(props) {
	    return _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	            'li',
	            { key: 'empty' },
	            _react2.default.createElement(_PopupEmptyContent2.default, { message: 'You\'re all up to date.' })
	        )
	    );
	};
	
	var NotificationList = function NotificationList(_ref2) {
	    var notifications = _ref2.notifications,
	        activeNotifications = _ref2.activeNotifications,
	        clearNotifications = _ref2.clearNotifications;
	
	    var title = activeNotifications.size ? activeNotifications.size + ' unseen ' + (0, _stringUtil.pluralise)('update', activeNotifications.size) : 'No changes since your last visit';
	
	    var actions = _react2.default.createElement(
	        _Button2.default,
	        { className: 'clear-button', onClickFn: clearNotifications },
	        'Mark all as seen'
	    );
	
	    return _react2.default.createElement(
	        _PopupList2.default,
	        { title: title, actions: actions, list: notifications },
	        function (notification, index) {
	            return _react2.default.createElement(_ModifiedBoardMessage2.default, {
	                notification: notification,
	                active: activeNotifications.contains(notification.get('id')) });
	        }
	    );
	};
	
	var NotificationPopup = function NotificationPopup(props) {
	    var notifications = props.notifications,
	        updateLastCheckedTime = props.updateLastCheckedTime,
	        currentUser = props.currentUser,
	        errorUserIds = props.errorUserIds,
	        notificationsReady = props.notificationsReady;
	
	
	    var content = null;
	    if (errorUserIds.length) {
	        content = _react2.default.createElement(_PopupUserErrorEmptyContent2.default, _extends({ userIds: errorUserIds }, props));
	    } else if (notificationsReady) {
	        content = notifications.size ? _react2.default.createElement(NotificationList, props) : _react2.default.createElement(NotificationPopupEmptyContent, props);
	    } else {
	        content = _react2.default.createElement(_PopupEmptyContent2.default, { showSpinner: true });
	    }
	
	    return _react2.default.createElement(
	        _PopupPanel2.default,
	        _extends({}, props, {
	            popupId: 'notification',
	            className: (0, _classnames2.default)('NotificationPopup', { new: notifications.size }),
	            onClose: updateLastCheckedTime(currentUser.get('_id')) }),
	        content
	    );
	};
	
	NotificationList.propTypes = NotificationPopup.propTypes = {
	    notifications: _propTypes2.default.object,
	    activeNotifications: _propTypes2.default.object,
	    currentUser: _propTypes2.default.object,
	    updateLastCheckedTime: _propTypes2.default.func,
	    errorUserIds: _propTypes2.default.array,
	    notificationsReady: _propTypes2.default.bool
	};
	
	var enhance = (0, _recompose.compose)((0, _reactRedux.connect)(_notificationUtilSelector2.default, mapDispatchToProps), (0, _recompose.withHandlers)(notificationPopupHandlers));
	
	exports.default = enhance(NotificationPopup);

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reselect = __webpack_require__(7);
	
	var _notificationSelector = __webpack_require__(749);
	
	var _currentUserSelector = __webpack_require__(33);
	
	var _popupOpenSelector = __webpack_require__(141);
	
	var _popupOpenSelector2 = _interopRequireDefault(_popupOpenSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Lib
	exports.default = (0, _reselect.createStructuredSelector)({
	    popupOpen: (0, _popupOpenSelector2.default)('notification'),
	
	    fetchedTime: _notificationSelector.getFetchedTime,
	    forcedPoll: _notificationSelector.getForcedPoll,
	
	    isGuest: _currentUserSelector.isGuestSelector,
	    currentUser: _currentUserSelector.getCurrentUser,
	
	    notifications: _notificationSelector.modifiedElementsSelector,
	    activeNotifications: _notificationSelector.activeNotificationsIdsSelector,
	    notificationsCount: _notificationSelector.notificationsCountSelector,
	    notificationUserIds: _notificationSelector.notificationUserIdsSelector,
	    notificationsReady: _notificationSelector.notificationsReadySelector,
	    errorUserIds: _notificationSelector.errorNotificationUserIds
	});

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class; // Lib
	
	
	// Actions
	
	
	// Components
	
	
	// Utils
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(3);
	
	var _sharingPopupActions = __webpack_require__(478);
	
	var sharingPopupActions = _interopRequireWildcard(_sharingPopupActions);
	
	var _PopupPanel = __webpack_require__(54);
	
	var _PopupPanel2 = _interopRequireDefault(_PopupPanel);
	
	var _PopupArrow = __webpack_require__(1924);
	
	var _PopupArrow2 = _interopRequireDefault(_PopupArrow);
	
	var _UserAccessList = __webpack_require__(2198);
	
	var _UserAccessList2 = _interopRequireDefault(_UserAccessList);
	
	var _BoardSharingInputForm = __webpack_require__(2192);
	
	var _BoardSharingInputForm2 = _interopRequireDefault(_BoardSharingInputForm);
	
	var _BoardSharingPublic = __webpack_require__(2194);
	
	var _BoardSharingPublic2 = _interopRequireDefault(_BoardSharingPublic);
	
	var _userService = __webpack_require__(106);
	
	var userService = _interopRequireWildcard(_userService);
	
	var _boardSharingHelpers = __webpack_require__(476);
	
	var _sharingUtilSelector = __webpack_require__(318);
	
	__webpack_require__(1292);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        fetchUsers: function fetchUsers(userIds) {
	            return dispatch(userService.fetchUsers(userIds));
	        },
	        toggleShareForm: function toggleShareForm() {
	            return dispatch(sharingPopupActions.toggleShareForm());
	        },
	        publiclyShareBoard: function publiclyShareBoard() {
	            return dispatch(sharingPopupActions.publiclyShareBoard({ elementId: ownProps.currentBoardId }));
	        },
	        unsharePublicBoard: function unsharePublicBoard() {
	            return dispatch(sharingPopupActions.unsharePublicBoard({ elementId: ownProps.currentBoardId }));
	        }
	    };
	};
	
	var BoardSharingPopup = (_dec = (0, _reactRedux.connect)(_sharingUtilSelector.boardSharingPopupSelector, mapDispatchToProps), _dec(_class = function (_React$Component) {
	    _inherits(BoardSharingPopup, _React$Component);
	
	    function BoardSharingPopup() {
	        _classCallCheck(this, BoardSharingPopup);
	
	        var _this = _possibleConstructorReturn(this, (BoardSharingPopup.__proto__ || Object.getPrototypeOf(BoardSharingPopup)).call(this));
	
	        _this.state = {
	            upArrowPosition: {
	                left: 0
	            }
	        };
	        return _this;
	    }
	
	    /**
	     * Need to wait until after the component has updated so we can get the new position of the popup.
	     */
	    /* eslint-disable react/no-did-update-set-state */
	
	
	    _createClass(BoardSharingPopup, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (prevProps.isMobileView) return;
	
	            if (!prevProps.popupOpen && this.props.popupOpen || this.props.popupOpen && this.props.downArrowPosition !== prevProps.downArrowPosition) {
	                var popupElement = _reactDom2.default.findDOMNode(this.refs.popup);
	                if (!popupElement) return;
	
	                var popupPosition = popupElement.getBoundingClientRect();
	
	                var downArrowPosition = this.props.downArrowPosition;
	
	                var leftPosition = Math.floor(downArrowPosition.left + downArrowPosition.width / 2 - popupPosition.left - _PopupArrow.POPUP_ARROW_WIDTH / 2);
	                var upArrowPosition = {
	                    left: leftPosition + 'px'
	                };
	
	                this.setState({ upArrowPosition: upArrowPosition });
	            }
	        }
	        /* eslint-enable react/no-did-update-set-state */
	
	    }, {
	        key: 'render',
	        value: function render() {
	            var boardPermissions = this.props.boardPermissions;
	            var upArrowPosition = this.state.upArrowPosition;
	
	
	            return _react2.default.createElement(
	                _PopupPanel2.default,
	                _extends({}, this.props, { ref: 'popup', className: 'BoardSharingPopup', popupId: 'sharing' }),
	                _react2.default.createElement(_PopupArrow2.default, { style: upArrowPosition }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'share-content' },
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'title' },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            'This board is'
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'status' },
	                            ' ',
	                            (0, _boardSharingHelpers.sharedTitle)(boardPermissions).toLowerCase()
	                        )
	                    ),
	                    _react2.default.createElement(_BoardSharingInputForm2.default, this.props),
	                    _react2.default.createElement(_UserAccessList2.default, this.props),
	                    _react2.default.createElement(_BoardSharingPublic2.default, this.props)
	                )
	            );
	        }
	    }]);
	
	    return BoardSharingPopup;
	}(_react2.default.Component)) || _class);
	
	
	BoardSharingPopup.propTypes = {
	    fetchUsers: _propTypes2.default.func,
	    toggleShareForm: _propTypes2.default.func,
	    sharingPopupState: _propTypes2.default.object,
	    boardPermissions: _propTypes2.default.object,
	    isShared: _propTypes2.default.bool,
	    currentBoard: _propTypes2.default.object,
	    currentBoardId: _propTypes2.default.string,
	    popupOpen: _propTypes2.default.bool,
	    downArrowPosition: _propTypes2.default.object,
	    isMobileView: _propTypes2.default.bool
	};
	
	exports.default = BoardSharingPopup;

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class; // Lib
	
	
	// Components
	
	
	// Actions
	
	
	// Utils
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _Button = __webpack_require__(34);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _BoardSharingPopup = __webpack_require__(783);
	
	var _BoardSharingPopup2 = _interopRequireDefault(_BoardSharingPopup);
	
	var _RootBoardSharingPopup = __webpack_require__(2191);
	
	var _RootBoardSharingPopup2 = _interopRequireDefault(_RootBoardSharingPopup);
	
	var _BoardWriteStatus = __webpack_require__(2190);
	
	var _BoardWriteStatus2 = _interopRequireDefault(_BoardWriteStatus);
	
	var _popupActions = __webpack_require__(35);
	
	var _permissionUtil = __webpack_require__(89);
	
	var _boardSharingHelpers = __webpack_require__(476);
	
	var _sharingUtilSelector = __webpack_require__(318);
	
	__webpack_require__(1293);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        openPopupPanel: function openPopupPanel() {
	            return dispatch((0, _popupActions.togglePopup)('sharing'));
	        },
	        openRootBoardTooltip: function openRootBoardTooltip() {
	            return dispatch((0, _popupActions.togglePopup)('sharing-tooltip'));
	        }
	    };
	};
	
	var BoardSharingUtil = (_dec = (0, _reactRedux.connect)(_sharingUtilSelector.boardSharingUtilSelector, mapDispatchToProps), _dec(_class = function (_React$Component) {
	    _inherits(BoardSharingUtil, _React$Component);
	
	    function BoardSharingUtil() {
	        _classCallCheck(this, BoardSharingUtil);
	
	        var _this = _possibleConstructorReturn(this, (BoardSharingUtil.__proto__ || Object.getPrototypeOf(BoardSharingUtil)).call(this));
	
	        _this.state = {
	            downArrowPosition: {
	                left: 0,
	                width: 0
	            }
	        };
	
	        _this.updateArrowState = _this.updateArrowState.bind(_this);
	        return _this;
	    }
	
	    _createClass(BoardSharingUtil, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (!this.props.popupOpen && nextProps.popupOpen) {
	                this.updateArrowState();
	            }
	        }
	
	        /**
	         * Need to wait until after the component has updated so we can get the new position of the arrow.
	         */
	        /* eslint-disable react/no-did-update-set-state */
	
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.popupOpen && this.props.sharedUserCount !== prevProps.sharedUserCount) {
	                this.updateArrowState();
	            }
	        }
	        /* eslint-enable react/no-did-update-set-state */
	
	    }, {
	        key: 'updateArrowState',
	        value: function updateArrowState() {
	            var arrowBoundingRect = this.refs.arrow.getBoundingClientRect();
	            this.setState({
	                downArrowPosition: {
	                    left: arrowBoundingRect.left,
	                    width: arrowBoundingRect.width
	                }
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                isRootBoard = _props.isRootBoard,
	                userPermissions = _props.userPermissions,
	                boardPermissions = _props.boardPermissions,
	                openPopupPanel = _props.openPopupPanel,
	                isMobileView = _props.isMobileView,
	                openRootBoardTooltip = _props.openRootBoardTooltip;
	            var downArrowPosition = this.state.downArrowPosition;
	
	
	            if (!(0, _permissionUtil.canEditPermissions)(userPermissions)) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'BoardSharingUtil' },
	                    _react2.default.createElement(_BoardWriteStatus2.default, this.props)
	                );
	            }
	
	            var handleButtonClick = isRootBoard ? openRootBoardTooltip : openPopupPanel;
	
	            var buttonTitle = isRootBoard ? 'Private' : (0, _boardSharingHelpers.utilSharedTitle)(boardPermissions, isMobileView);
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'BoardSharingUtil' },
	                _react2.default.createElement(
	                    _Button2.default,
	                    { popupId: 'sharing', onClickFn: handleButtonClick },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'button-content' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'header-util-text' },
	                            buttonTitle
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { ref: 'arrow', className: 'arrow' },
	                            _react2.default.createElement(_Icon2.default, { name: 'menu-down-arrow' })
	                        )
	                    )
	                ),
	                isRootBoard ? _react2.default.createElement(_RootBoardSharingPopup2.default, this.props) : _react2.default.createElement(_BoardSharingPopup2.default, _extends({}, this.props, { downArrowPosition: downArrowPosition }))
	            );
	        }
	    }]);
	
	    return BoardSharingUtil;
	}(_react2.default.Component)) || _class);
	
	
	BoardSharingUtil.propTypes = {
	    popupOpen: _propTypes2.default.bool,
	    openPopupPanel: _propTypes2.default.func,
	    openRootBoardTooltip: _propTypes2.default.func,
	    children: _propTypes2.default.element,
	    currentBoardId: _propTypes2.default.string,
	    sharingContext: _propTypes2.default.object,
	    isShared: _propTypes2.default.bool,
	    isMobileView: _propTypes2.default.bool,
	    isRootBoard: _propTypes2.default.bool,
	    sharedUserCount: _propTypes2.default.number,
	    boardPermissions: _propTypes2.default.object,
	    userPermissions: _propTypes2.default.number,
	    usersCurrentlyViewing: _propTypes2.default.object
	};
	
	exports.default = BoardSharingUtil;

/***/ }),
/* 785 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SHARE_POPUP_TOGGLE_SHARE_FORM = exports.SHARE_POPUP_TOGGLE_SHARE_FORM = 'SHARE_POPUP_TOGGLE_SHARE_FORM';

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.documentSelector = exports.inboxChildrenSelector = undefined;
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _reselect = __webpack_require__(7);
	
	var _milanoteReselect = __webpack_require__(49);
	
	var _mainSelector = __webpack_require__(239);
	
	var _gridSizeSelector = __webpack_require__(66);
	
	var _gridSizeSelector2 = _interopRequireDefault(_gridSizeSelector);
	
	var _elementHelper = __webpack_require__(13);
	
	var _documentModeUtil = __webpack_require__(2206);
	
	var _boardConstants = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Lib
	var cleanElementMeta = function cleanElementMeta(element) {
	    return element.delete('meta').delete('attachment');
	};
	
	// Constants
	
	
	// Selectors
	
	
	var canvasChildrenSelector = (0, _milanoteReselect.createImmutableShallowSelector)(_mainSelector.getCurrentChildren, function (children) {
	    return children.filter(function (child) {
	        return child.getIn(['location', 'section']) === _boardConstants.BOARD_SECTIONS.CANVAS;
	    });
	});
	
	var inboxChildrenSelector = exports.inboxChildrenSelector = (0, _milanoteReselect.createImmutableShallowSelector)(_mainSelector.getCurrentChildren, function (children) {
	    return children.filter(function (child) {
	        return child.getIn(['location', 'section']) === _boardConstants.BOARD_SECTIONS.INBOX;
	    }).sort(_elementHelper.sortByScore).toList();
	});
	
	var cleanCanvasChildrenSelector = (0, _milanoteReselect.createImmutableShallowSelector)(canvasChildrenSelector, function (children) {
	    return children.filterNot(_elementHelper.isLine).map(cleanElementMeta);
	});
	
	var documentOrderSelector = (0, _milanoteReselect.createImmutableShallowSelector)(cleanCanvasChildrenSelector, function (canvasChildren) {
	    var sizes = canvasChildren.map(function (child) {
	        return {
	            id: child.get('id'),
	            width: 0,
	            height: 0
	        };
	    }).toArray();
	
	    var processedElements = (0, _documentModeUtil.calculateDocumentModeOrder)({ elements: canvasChildren, elementSizes: sizes });
	
	    return Immutable.List(processedElements.order);
	});
	
	var documentOrderedChildrenSelector = (0, _milanoteReselect.createImmutableShallowSelector)(documentOrderSelector, canvasChildrenSelector, function (order, children) {
	    return order.map(function (elementId) {
	        return children.get(elementId);
	    });
	});
	
	// TODO - Not sure if the grid size should really be passed through here, but just doing it as a POC
	var documentSelector = exports.documentSelector = (0, _reselect.createSelector)(function (state, props) {
	    return props.currentBoardId;
	}, _gridSizeSelector2.default, documentOrderedChildrenSelector, inboxChildrenSelector, _mainSelector.getBreadcrumb, function (currentBoardId, gridSize, documentChildren, inboxChildren, breadcrumb) {
	    return {
	        orderedElements: documentChildren,
	        inboxElements: inboxChildren,
	        gridSize: gridSize,
	        breadcrumb: breadcrumb
	    };
	});

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1312);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Lib
	var ToolSeparator = function ToolSeparator() {
	    return _react2.default.createElement('div', { className: 'ToolSeparator' });
	};
	
	// Styles
	
	
	ToolSeparator.propTypes = {};
	
	exports.default = ToolSeparator;

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _elementActions = __webpack_require__(26);
	
	var _Tool = __webpack_require__(110);
	
	var _Tool2 = _interopRequireDefault(_Tool);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _lineConstants = __webpack_require__(57);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	
	
	// Constants
	
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        isActive: ownProps.selectedElements.first().getIn(['content', ownProps.styleProp]) === _lineConstants.LINE_MARKER_STYLE.ARROW
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        dispatchUpdateSelectedElements: function dispatchUpdateSelectedElements(_ref) {
	            var changes = _ref.changes;
	            return dispatch((0, _elementActions.updateSelectedElements)({ changes: changes }));
	        }
	    };
	};
	
	var ArrowTool = function (_React$Component) {
	    _inherits(ArrowTool, _React$Component);
	
	    function ArrowTool() {
	        var _ref2;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ArrowTool);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = ArrowTool.__proto__ || Object.getPrototypeOf(ArrowTool)).call.apply(_ref2, [this].concat(args))), _this), _this.toggleArrow = function () {
	            var _this$props = _this.props,
	                isActive = _this$props.isActive,
	                styleProp = _this$props.styleProp,
	                dispatchUpdateSelectedElements = _this$props.dispatchUpdateSelectedElements;
	
	            var changes = _defineProperty({}, styleProp, isActive ? _lineConstants.LINE_MARKER_STYLE.NONE : _lineConstants.LINE_MARKER_STYLE.ARROW);
	            dispatchUpdateSelectedElements({ changes: changes });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ArrowTool, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                iconDirection = _props.iconDirection,
	                isActive = _props.isActive;
	
	
	            var iconName = isActive ? 'toolbar-arrow-' + iconDirection + '-on' : 'toolbar-arrow-' + iconDirection;
	            return _react2.default.createElement(
	                _Tool2.default,
	                _extends({}, this.props, { handleMouseDown: this.toggleArrow, isActive: true }),
	                _react2.default.createElement(_Icon2.default, { name: iconName })
	            );
	        }
	    }]);
	
	    return ArrowTool;
	}(_react2.default.Component);
	
	ArrowTool.propTypes = {
	    name: _propTypes2.default.string,
	    isActive: _propTypes2.default.bool,
	    styleProp: _propTypes2.default.string.isRequired,
	    selectedElements: _propTypes2.default.object.isRequired,
	    dispatchUpdateSelectedElements: _propTypes2.default.func,
	    iconDirection: _propTypes2.default.string.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ArrowTool);

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.popupModeSelector = exports.selectedImageSelector = exports.selectedIconSelector = exports.firstElementIdSelector = undefined;
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _reselect = __webpack_require__(7);
	
	var _lodash = __webpack_require__(4);
	
	var _iconsPopupConstants = __webpack_require__(240);
	
	var _elementIconConstants = __webpack_require__(429);
	
	var _stringUtil = __webpack_require__(58);
	
	var _makeStringIconDef = __webpack_require__(430);
	
	var _makeStringIconDef2 = _interopRequireDefault(_makeStringIconDef);
	
	var _popupOpenSelector = __webpack_require__(141);
	
	var _popupOpenSelector2 = _interopRequireDefault(_popupOpenSelector);
	
	var _selectedElementsSelector = __webpack_require__(127);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Helper functions
	var filterWords = function filterWords(wordList) {
	    var filterNumbers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	    var filterPunctuation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	    return wordList.filter(function (word) {
	        return (!filterNumbers || isNaN(word)) && _iconsPopupConstants.ICON_POPUP_WORD_FILTERS.indexOf(word.toLowerCase()) === -1;
	    });
	};
	
	var getFirstSelected = function getFirstSelected(propertyPath) {
	    return function (selectedElements) {
	        return selectedElements.first() ? selectedElements.first().getIn(propertyPath) : null;
	    };
	};
	var getFirstAttachmentData = getFirstSelected(['attachment', 'data']);
	var getSelectedImage = function getSelectedImage(selection, elements) {
	    return getFirstAttachmentData(selection, elements) || getFirstSelected(['content', 'image', 'regular'])(selection, elements);
	};
	var getSelectedIcon = getFirstSelected(['content', 'icon']);
	
	var getFirstElementId = getFirstSelected(['id']);
	
	// Selected property selectors
	var firstElementIdSelector = exports.firstElementIdSelector = (0, _reselect.createSelector)(_selectedElementsSelector.getSelectedElements, getFirstElementId);
	
	// Selected property selectors
	var selectedIconSelector = exports.selectedIconSelector = (0, _reselect.createSelector)(_selectedElementsSelector.getSelectedElements, getSelectedIcon);
	
	var selectedImageSelector = exports.selectedImageSelector = (0, _reselect.createSelector)(_selectedElementsSelector.getSelectedElements, getSelectedImage);
	
	// Popup state selectors
	var popupModeSelector = exports.popupModeSelector = (0, _reselect.createSelector)(function (state, ownProps) {
	    return state.getIn(['app', 'popup', 'icons', 'mode']);
	}, selectedImageSelector, function (popupMode, selectedImage) {
	    var actualPopupMode = popupMode;
	    if (!actualPopupMode) {
	        actualPopupMode = selectedImage ? _iconsPopupConstants.ICON_POPUP_MODE_IMAGES : _iconsPopupConstants.ICON_POPUP_MODE_DEFAULT;
	    }
	    return actualPopupMode;
	});
	
	var selectedElementTitleSelector = (0, _reselect.createSelector)(function (state, ownProps) {
	    return ownProps.selectedElements;
	}, function (selectedElements) {
	    return selectedElements && selectedElements.first().getIn(['content', 'title']);
	});
	
	var popupQuerySelector = (0, _reselect.createSelector)(popupModeSelector, selectedElementTitleSelector, function (popupMode, selectedTitle) {
	    if (popupMode === _iconsPopupConstants.ICON_POPUP_MODE_DEFAULT) {
	        return selectedTitle;
	    } else if (popupMode === _iconsPopupConstants.ICON_POPUP_MODE_LETTERS) {
	        return _iconsPopupConstants.ICON_POPUP_MODE_LETTERS;
	    }
	    return popupMode;
	});
	
	var lettersSelector = (0, _reselect.createSelector)(selectedElementTitleSelector, function (selectedTitle) {
	    var titleWords = (0, _stringUtil.slugify)(selectedTitle, '-').split('-');
	
	    if (titleWords.length > 2) {
	        titleWords = filterWords(titleWords, false, false);
	    }
	
	    var titleLetters = titleWords.map(function (word) {
	        return isNaN(word) || word.length > _elementIconConstants.STRING_ICON_MAX_LENGTH ? word[0].toLowerCase() : word;
	    });
	
	    var iconStringList = [];
	
	    if (titleLetters.length >= 2) {
	        var combined = titleLetters.reduce(function (acc, letter) {
	            return acc.length < _elementIconConstants.STRING_ICON_MAX_LENGTH ? acc + letter : acc;
	        }, '');
	        if (combined.length <= _elementIconConstants.STRING_ICON_MAX_LENGTH) iconStringList.push(combined);
	    }
	
	    if (titleLetters.length >= 3) {
	        var combinedStartEnd = titleLetters[0] + titleLetters[titleLetters.length - 1];
	        if (combinedStartEnd.length <= _elementIconConstants.STRING_ICON_MAX_LENGTH) iconStringList.push(combinedStartEnd);
	    }
	
	    titleLetters.forEach(function (letter) {
	        iconStringList.push(letter);
	    });
	
	    _iconsPopupConstants.ICON_POPUP_NUMBERS_LIST.forEach(function (letter) {
	        if (titleLetters.indexOf(letter) !== -1) return;
	        iconStringList.push(letter);
	    });
	
	    var stringIcons = (0, _lodash.uniq)(iconStringList).map(function (letter) {
	        return (0, _makeStringIconDef2.default)(letter);
	    });
	    return Immutable.List(stringIcons);
	});
	
	var iconListSelector = (0, _reselect.createSelector)(popupModeSelector, popupQuerySelector, selectedElementTitleSelector, lettersSelector, function (state, ownProps) {
	    return state.getIn(['app', 'popup', 'icons', 'searchResults']);
	}, function (popupMode, popupQuery, selectedTitle, lettersList, searchResults) {
	    switch (popupMode) {
	        case _iconsPopupConstants.ICON_POPUP_MODE_DEFAULT:
	            return searchResults.get(popupQuery) && searchResults.get(popupQuery).slice(0, 8).concat(lettersList);
	        case _iconsPopupConstants.ICON_POPUP_MODE_LETTERS:
	            return lettersList.concat(_iconsPopupConstants.STRING_ICONS);
	        default:
	            return searchResults.get(popupQuery);
	    }
	});
	
	var iconPopupModeListSelector = (0, _reselect.createSelector)(function (state, ownProps) {
	    return ownProps.selectedElements;
	}, selectedElementTitleSelector, function (state, ownProps) {
	    return state.getIn(['app', 'popup', 'icons', 'elementSearches']);
	}, selectedImageSelector, function (selectedElements, selectedTitle, elementSearches, selectedImage) {
	    if (!selectedTitle) return;
	
	    var popupModeList = [{ slug: _iconsPopupConstants.ICON_POPUP_MODE_DEFAULT, title: 'Recommended' }];
	    var customList = [];
	
	    var splitTitle = filterWords(selectedTitle.split(' ')).map(function (word) {
	        return word.replace(/[.,\/"'\^&\*;:{}=\-_`~()]/g, '');
	    }).filter(function (word) {
	        return word.length > 0;
	    });
	
	    if (splitTitle.length > 1) {
	        splitTitle.forEach(function (part) {
	            customList.push({
	                slug: part,
	                title: part
	            });
	        });
	    }
	
	    var firstEl = selectedElements.first().get('id');
	    var savedSearches = elementSearches.get(firstEl) && elementSearches.get(firstEl).valueSeq().toArray();
	
	    if (savedSearches) {
	        savedSearches.forEach(function (q) {
	            customList.push({
	                title: q,
	                slug: q
	            });
	        });
	    }
	
	    customList = customList.slice(-(_iconsPopupConstants.ICON_POPUP_MODE_LIST_MAX - 3));
	    popupModeList = popupModeList.concat(customList);
	
	    popupModeList.push({ slug: _iconsPopupConstants.ICON_POPUP_MODE_LETTERS, title: 'Letters & numbers' });
	
	    var imageModeTitle = selectedImage ? 'Custom image' : 'Upload an image';
	    popupModeList.push({ slug: _iconsPopupConstants.ICON_POPUP_MODE_IMAGES, title: imageModeTitle });
	    return popupModeList;
	});
	
	var iconPopupSelector = (0, _reselect.createSelector)((0, _popupOpenSelector2.default)('icon'), popupQuerySelector, iconPopupModeListSelector, iconListSelector, function (isActive, popupQuery, modeList, iconList) {
	    if (!isActive) return { isActive: isActive };
	
	    return {
	        isActive: isActive,
	        popupQuery: popupQuery,
	        modeList: modeList,
	        iconList: iconList
	    };
	});
	
	exports.default = iconPopupSelector;

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.findIcons = exports.setIconPopupMode = undefined;
	
	var _elementIconService = __webpack_require__(693);
	
	var _iconsPopupConstants = __webpack_require__(240);
	
	var setIconPopupMode = exports.setIconPopupMode = function setIconPopupMode(_ref) {
	    var mode = _ref.mode,
	        id = _ref.id;
	    return {
	        type: _iconsPopupConstants.ICON_POPUP_MODE_SET,
	        mode: mode,
	        id: id
	    };
	};
	
	var findIcons = exports.findIcons = function findIcons(_ref2) {
	    var query = _ref2.query,
	        id = _ref2.id;
	    return function (dispatch, getState) {
	        dispatch({ type: _iconsPopupConstants.ICON_POPUP_SEARCH_SUBMIT, query: query, id: id });
	
	        (0, _elementIconService.searchForIcon)(query, 16).then(function (response) {
	            var icons = response.data.icons;
	
	            dispatch({ type: _iconsPopupConstants.ICON_POPUP_SEARCH_SUCCESS, query: query, icons: icons });
	        }).catch(function (err) {
	            console.error('ERROR: Retrieving icons.', err, err.response);
	            dispatch({ type: _iconsPopupConstants.ICON_POPUP_SEARCH_FAILURE, query: query });
	        });
	    };
	};

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getLeafClusters = exports.getClustersBelow = exports.createDendrogram = exports.createClusterDictionary = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _distanceMatrix = __webpack_require__(2262);
	
	var distanceMatrixLib = _interopRequireWildcard(_distanceMatrix);
	
	var _cluster = __webpack_require__(482);
	
	var clusterLib = _interopRequireWildcard(_cluster);
	
	var _screePlot = __webpack_require__(792);
	
	var screePlotLib = _interopRequireWildcard(_screePlot);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// √
	// Lib
	var createClusterDictionary = exports.createClusterDictionary = function createClusterDictionary(clusters) {
	    return clusters.reduce(function (dictionary, cluster) {
	        dictionary[cluster.id] = cluster;
	        return dictionary;
	    }, {});
	};
	
	/**
	 * Lance William algorithm uses previously computed values of the minimum distances of the existing clusters to
	 * determine the new minimum distance of the new cluster.
	 */
	
	
	// Distance Matrix
	var lanceWilliamDistanceFn = function lanceWilliamDistanceFn(distanceMatrix) {
	    return function (newCluster, existingCluster) {
	        return Math.min(distanceMatrixLib.getDistance(distanceMatrix, newCluster.children[0].id, existingCluster.id), distanceMatrixLib.getDistance(distanceMatrix, newCluster.children[1].id, existingCluster.id));
	    };
	};
	
	/**
	 * This function creates a binary tree (dendrogram) of clusters using "hierarchical agglomerative clustering".
	 * It uses the "single linkage" method to determine which clusters to merge.
	 */
	// √
	var createDendrogram = exports.createDendrogram = function createDendrogram(initialClusters, distanceFn, autoClusterDistance) {
	    var rootCluster = void 0;
	
	    var autoClusterDistSquared = autoClusterDistance * Math.abs(autoClusterDistance);
	    var screePlot = screePlotLib.createEmptyScreePlot(autoClusterDistSquared);
	
	    var clusterDictionary = createClusterDictionary(initialClusters);
	    var distanceMatrix = distanceMatrixLib.createDistanceMatrix(initialClusters, distanceFn);
	
	    // An array of the distances which have been used to create the dendrogram
	    var usedDistances = [];
	    var minDistance = distanceMatrixLib.getMinDistance(distanceMatrix);
	    while (minDistance) {
	        usedDistances.push(minDistance);
	
	        var cluster1 = clusterDictionary[minDistance.clusters[0]];
	        var cluster2 = clusterDictionary[minDistance.clusters[1]];
	
	        // Add to scree plot - The minimum distance is used as the variance of the plot
	        screePlot = screePlotLib.addPoint(screePlot, Math.pow(minDistance.dist / 2, 2));
	
	        // Merge clusters
	        var mergedCluster = clusterLib.mergeClusters(cluster1, cluster2, screePlot.currMaxHeight);
	
	        // Remove the merged clusters from the dictionary
	        delete clusterDictionary[cluster1.id];
	        delete clusterDictionary[cluster2.id];
	
	        // Get the current list of clusters
	        var clusters = (0, _lodash.values)(clusterDictionary);
	        // Use lance williams to calculate the distance between other clusters and add them to the distance matrix
	        distanceMatrix = distanceMatrixLib.addCluster(distanceMatrix, clusters, mergedCluster, lanceWilliamDistanceFn(distanceMatrix));
	
	        // Remove old clusters from the distances array
	        distanceMatrix = distanceMatrixLib.removeClusters(distanceMatrix, cluster1.id, cluster2.id);
	
	        // Add the new cluster to the dictionary
	        clusterDictionary[mergedCluster.id] = mergedCluster;
	
	        minDistance = distanceMatrixLib.getMinDistance(distanceMatrix);
	        rootCluster = mergedCluster;
	    }
	
	    return {
	        rootCluster: rootCluster,
	        screePlot: screePlot,
	        distanceMatrix: distanceMatrix,
	        usedDistances: usedDistances
	    };
	};
	
	var sliceCluster = function sliceCluster(cluster, sliceHeight, matchingClusters) {
	    if (!cluster) return matchingClusters;
	
	    // If this cluster is above the slice height we need to recursively checking the children
	    if (cluster.height > sliceHeight) {
	        sliceCluster(cluster.children[0], sliceHeight, matchingClusters);
	        sliceCluster(cluster.children[1], sliceHeight, matchingClusters);
	    } else {
	        // Otherwise this cluster should be added to the matching clusters
	        matchingClusters.push(cluster);
	    }
	    return matchingClusters;
	};
	
	// √
	var getClustersBelow = exports.getClustersBelow = function getClustersBelow(dendrogram, sliceHeight) {
	    return sliceCluster(dendrogram, sliceHeight, []);
	};
	
	var getLeafClusters = exports.getLeafClusters = function getLeafClusters(cluster) {
	    var matchingClusters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	    if (!cluster) return matchingClusters;
	
	    if (!cluster.children.length) {
	        matchingClusters.push(cluster);
	    } else {
	        getLeafClusters(cluster.children[0], matchingClusters);
	        getLeafClusters(cluster.children[1], matchingClusters);
	    }
	
	    return matchingClusters;
	};

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.findElbowPoint = exports.getErrorMargins = exports.getLinearIncrement = exports.getSlope = exports.addPoint = exports.createEmptyScreePlot = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _documentOrderAlgorithmConstants = __webpack_require__(320);
	
	// Lib
	var createEmptyScreePlot = exports.createEmptyScreePlot = function createEmptyScreePlot(autoClusterDistance) {
	    return {
	        points: [],
	        currMaxHeight: 0,
	        autoClusterDistance: autoClusterDistance
	    };
	};
	
	// Constants
	
	
	var createScreePlotPoint = function createScreePlotPoint(_ref) {
	    var x = _ref.x,
	        height = _ref.height,
	        variance = _ref.variance;
	    return { x: x, height: height, variance: variance };
	};
	
	// √
	var addPoint = exports.addPoint = function addPoint(screePlot, variance) {
	    // "height" is the cumulative distance between clusters which have been merged.
	    // It's used as the measure of the variance between clusters in the dendrogram.
	    // This is because a more traditional measurement of variance is impossible since
	    // the distance function is non-euclidean which makes finding a centroid for each cluster impossible
	    var height = screePlot.currMaxHeight + variance;
	
	    var point = createScreePlotPoint({ height: height, x: screePlot.points.length, variance: variance });
	    screePlot.points.push(point);
	    screePlot.currMaxHeight = height;
	
	    return screePlot;
	};
	
	var getSlope = exports.getSlope = function getSlope(dx, dy) {
	    return Math.atan(dy / dx);
	};
	
	/**
	 * Finds the change in height and divides it by the number of points to ensure that the width of the graph
	 * is the same as the height.
	 * This is important for the elbow point calculations to be accurate.
	 */
	var getLinearIncrement = exports.getLinearIncrement = function getLinearIncrement(points) {
	    if (points.length === 1) return points[0].variance;
	    return (points[points.length - 1].height - points[0].height) / points.length;
	};
	
	var getErrorMargins = exports.getErrorMargins = function getErrorMargins(points) {
	    // Finds all the error margins when creating a linear line from the origin to the point and then the point
	    // to the curve end
	    var maxHeight = points[points.length - 1].height;
	    var maxX = points.length - 1;
	    var dx = getLinearIncrement(points);
	    return points.slice(1, -1).map(function (point, index) {
	        // Calculate the gradients to find the error between the points, then choose the point with the min error
	        // Lines will be of the form:
	        //  y = m1 * x    and
	        //  y = m2 * x + c2  (c is a negative number)
	
	        // Therefore:
	        // m1 = height / (index * dx)
	        // and
	        // m2 = (max height - height) / (max index * dx - index * dx)
	        // c = max height - (max index * dx) * ((max height - height) / ((max index * dx) - (index * dx)))
	
	        // The first line will intersect the origin so no need to worry about a c
	        var height = point.height;
	        var currX = index + 1;
	        var m1 = height / currX;
	        var line1Fn = function line1Fn(x) {
	            return m1 * x;
	        };
	
	        var m2 = (maxHeight - height) / (maxX - currX);
	        var c2 = maxHeight - maxX * (maxHeight - height) / (maxX - currX);
	        var line2Fn = function line2Fn(x) {
	            return m2 * x + c2;
	        };
	
	        // The total error difference between points using the functions
	        var cumulativeError = 0;
	        for (var i = 0; i < currX; i++) {
	            var actualHeight = points[0].height;
	            cumulativeError += Math.abs(actualHeight - line1Fn(i));
	        }
	
	        for (var _i = currX; _i < maxX; _i++) {
	            var _actualHeight = points[0].height;
	            cumulativeError += Math.abs(_actualHeight - line2Fn(_i));
	        }
	
	        // Used to determine if the line is too linear
	        var theta1 = getSlope(currX * dx, height);
	        var theta2 = getSlope((maxX - currX) * dx, maxHeight - height);
	
	        return {
	            cumulativeError: cumulativeError,
	            index: currX,
	            dTheta: theta2 - theta1
	        };
	    });
	};
	
	// √
	var findElbowPoint = exports.findElbowPoint = function findElbowPoint(screePlot) {
	    var errorMargins = getErrorMargins(screePlot.points);
	    var minErrorMargin = (0, _lodash.minBy)(errorMargins, function (errorMargin) {
	        return errorMargin.cumulativeError;
	    });
	
	    var elbowPoint = screePlot.points[screePlot.points.length - 1];
	    var dTheta = 0;
	    if (minErrorMargin) {
	        // If we don't have an elbow point just use the last value
	        elbowPoint = screePlot.points[minErrorMargin.index];
	        dTheta = minErrorMargin.dTheta;
	    }
	
	    // If graph is too linear, change it to the last point so everything is split
	    var tooLinear = dTheta < _documentOrderAlgorithmConstants.MIN_CHANGE_IN_SCREE_PLOT_SLOPE;
	    if (tooLinear) {
	        elbowPoint = screePlot.points[screePlot.points.length - 1];
	    }
	
	    return {
	        elbowPoint: elbowPoint,
	        errorMargins: errorMargins,
	        tooLinear: tooLinear,
	        points: screePlot.points
	    };
	};

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.deleteElement = exports.setElementType = exports.updateElement = exports.updateMultipleElements = exports.createElementWithId = undefined;
	
	var _timeUtil = __webpack_require__(43);
	
	var _elementConstants = __webpack_require__(12);
	
	var TYPES = _interopRequireWildcard(_elementConstants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Utils
	var createElementWithId = exports.createElementWithId = function createElementWithId(_ref) {
	    var id = _ref.id,
	        elementType = _ref.elementType,
	        location = _ref.location,
	        _ref$content = _ref.content,
	        content = _ref$content === undefined ? {} : _ref$content,
	        acl = _ref.acl,
	        _ref$sync = _ref.sync,
	        sync = _ref$sync === undefined ? true : _ref$sync,
	        modified = _ref.modified,
	        _ref$meta = _ref.meta,
	        meta = _ref$meta === undefined ? {} : _ref$meta,
	        transactionId = _ref.transactionId,
	        duplicate = _ref.duplicate;
	    return {
	        type: TYPES.ELEMENT_CREATE,
	        id: id,
	        elementType: elementType,
	        location: location,
	        content: content,
	        meta: meta,
	        modified: modified || (0, _timeUtil.getTimestamp)(),
	        acl: acl,
	        sync: sync,
	        transactionId: transactionId,
	        duplicate: duplicate
	    };
	};
	
	// Constants
	var updateMultipleElements = exports.updateMultipleElements = function updateMultipleElements(_ref2) {
	    var updates = _ref2.updates,
	        _ref2$sync = _ref2.sync,
	        sync = _ref2$sync === undefined ? true : _ref2$sync,
	        transactionId = _ref2.transactionId;
	    return {
	        type: TYPES.ELEMENT_UPDATE,
	        updates: updates,
	        sync: sync,
	        modified: (0, _timeUtil.getTimestamp)(),
	        transactionId: transactionId
	    };
	};
	
	var updateElement = exports.updateElement = function updateElement(_ref3) {
	    var id = _ref3.id,
	        changes = _ref3.changes,
	        _ref3$sync = _ref3.sync,
	        sync = _ref3$sync === undefined ? true : _ref3$sync,
	        transactionId = _ref3.transactionId;
	    return updateMultipleElements({
	        updates: [{ id: id, changes: changes }],
	        sync: sync,
	        transactionId: transactionId
	    });
	};
	
	var setElementType = exports.setElementType = function setElementType(_ref4) {
	    var id = _ref4.id,
	        elementType = _ref4.elementType,
	        _ref4$sync = _ref4.sync,
	        sync = _ref4$sync === undefined ? true : _ref4$sync,
	        transactionId = _ref4.transactionId;
	    return {
	        type: TYPES.ELEMENT_SET_TYPE,
	        id: id,
	        elementType: elementType,
	        sync: sync,
	        transactionId: transactionId
	    };
	};
	
	var deleteElement = exports.deleteElement = function deleteElement(_ref5) {
	    var id = _ref5.id,
	        location = _ref5.location,
	        _ref5$sync = _ref5.sync,
	        sync = _ref5$sync === undefined ? true : _ref5$sync,
	        transactionId = _ref5.transactionId;
	    return {
	        type: TYPES.ELEMENT_DELETE,
	        id: id,
	        location: location,
	        sync: sync,
	        transactionId: transactionId
	    };
	};

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getNewScores = exports.calculateResetScores = exports.DEFAULT_INCREMENT = undefined;
	
	var _lodash = __webpack_require__(4);
	
	// 2^16 (Trello seem to do this...)
	var DEFAULT_INCREMENT = exports.DEFAULT_INCREMENT = 65536; // Lib
	var calculateResetScores = exports.calculateResetScores = function calculateResetScores(size) {
	    var scoresArray = [];
	    for (var i = 0; i < size; i++) {
	        scoresArray[i] = i * DEFAULT_INCREMENT;
	    }
	    return scoresArray;
	};
	
	/* eslint-disable eqeqeq */
	var calculateIncrement = function calculateIncrement(prevScore, nextScore, insertCount) {
	    // == checks for undefined & null
	    if (nextScore == null) return DEFAULT_INCREMENT;
	    if (prevScore == null) return -DEFAULT_INCREMENT;
	    return (nextScore - prevScore) / (insertCount + 1);
	};
	
	/* eslint-disable eqeqeq */
	var calculateStartingScore = function calculateStartingScore(prevScore, nextScore, increment) {
	    // == checks for undefined & null
	    // If there's nothing in the list we start at 0
	    if (prevScore == null && nextScore == null) return 0;
	    // If there's nothing before this insert, then start at the nextScore plus the increment (which will be negative)
	    if (prevScore == null) return nextScore + increment;
	    // Otherwise just add the increment to the previous score
	    return prevScore + increment;
	};
	/* eslint-enable eqeqeq */
	
	/**
	 * Returns an array of scores for each inserted element, or null if a score collision occurs.
	 *
	 * @param scores {[Number]} The array of existing scores to insert new scores into.
	 * @param index {Number} The index to insert new scores at.
	 * @param insertCount {Number} The number of scores to insert.
	 */
	var getNewScores = exports.getNewScores = function getNewScores(scores, index, insertCount) {
	    var prevScore = scores[index - 1];
	    // The old score at this index will become the next score after the insert
	    var nextScore = scores[index];
	
	    var increment = calculateIncrement(prevScore, nextScore, insertCount);
	    var startScore = calculateStartingScore(prevScore, nextScore, increment);
	
	    // Score collision - the scores must be recalculated as we have hit the limit
	    if (startScore === prevScore || startScore === nextScore) return null;
	
	    var endScore = startScore + insertCount * increment;
	
	    return (0, _lodash.range)(startScore, endScore, increment);
	};

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.calculateQuadraticControlPoint = exports.rectBezierIntersection = exports.rectControlPointWithinRectIntersection = exports.findControlPointWithinRectSideIntersection = exports.rectCurvedBezierIntersection = exports.findCurveSideIntersection = undefined;
	
	var _bezierJs = __webpack_require__(828);
	
	var _bezierJs2 = _interopRequireDefault(_bezierJs);
	
	var _lodash = __webpack_require__(4);
	
	var _intersection = __webpack_require__(2277);
	
	var _rect = __webpack_require__(208);
	
	var rectLib = _interopRequireWildcard(_rect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Make the bezier 't' value (ratio at which it sits along the line) halfway along the line
	
	
	// Geometry
	// Lib
	var DEFAULT_BEZIER_T = 0.5;
	var MAX_INTERSECTION_ATTEMPTS = 5;
	
	var findCurveSideIntersection = exports.findCurveSideIntersection = function findCurveSideIntersection(_ref) {
	    var side = _ref.side,
	        bezier = _ref.bezier;
	
	    var intersections = bezier.intersects({ p1: side.start, p2: side.end });
	    if (!intersections.length) return;
	
	    // Sort and then pick the first intersection because it will be closer to the origin of the line
	    intersections.sort();
	    return intersections[0];
	};
	
	var rectCurvedBezierIntersection = exports.rectCurvedBezierIntersection = function rectCurvedBezierIntersection(_ref2) {
	    var sides = _ref2.sides,
	        bezier = _ref2.bezier;
	
	    var intersection = (0, _lodash.reduce)(sides, function (accIntersection, side) {
	        var newIntersection = findCurveSideIntersection({ side: side, bezier: bezier });
	        return !accIntersection || newIntersection < accIntersection ? newIntersection : accIntersection;
	    }, null);
	    return intersection ? bezier.get(intersection) : undefined;
	};
	
	var findLinearSideIntersection = function findLinearSideIntersection(_ref3) {
	    var side = _ref3.side,
	        bezier = _ref3.bezier;
	    return (0, _intersection.lineIntersectionPoints)(side.start, side.end, bezier.points[0], bezier.points[2]);
	};
	
	var rectLinearBezierIntersection = function rectLinearBezierIntersection(_ref4) {
	    var sides = _ref4.sides,
	        bezier = _ref4.bezier;
	    return (0, _lodash.reduce)(sides, function (intersection, side) {
	        return intersection || findLinearSideIntersection({ side: side, bezier: bezier });
	    }, null);
	};
	
	var findControlPointWithinRectSideIntersection = exports.findControlPointWithinRectSideIntersection = function findControlPointWithinRectSideIntersection(_ref5) {
	    var side = _ref5.side,
	        controlPoint = _ref5.controlPoint,
	        targetPoint = _ref5.targetPoint;
	    return (0, _intersection.lineIntersectionPoints)(side.start, side.end, controlPoint, targetPoint);
	};
	
	var rectControlPointWithinRectIntersection = exports.rectControlPointWithinRectIntersection = function rectControlPointWithinRectIntersection(_ref6) {
	    var sides = _ref6.sides,
	        controlPoint = _ref6.controlPoint,
	        targetPoint = _ref6.targetPoint;
	    return (0, _lodash.reduce)(sides, function (intersection, side) {
	        return intersection || findControlPointWithinRectSideIntersection({ side: side, controlPoint: controlPoint, targetPoint: targetPoint });
	    }, null);
	};
	
	/**
	 * Finds the point at which the bezier curve (made from the bezier points provided) intersects the rectangle.
	 * If it intersects at many points
	 */
	var rectBezierIntersection = exports.rectBezierIntersection = function rectBezierIntersection(rect, _ref7) {
	    var sourcePoint = _ref7.sourcePoint,
	        controlPoint = _ref7.controlPoint,
	        targetPoint = _ref7.targetPoint;
	    var attempt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	    var sides = rectLib.getSides(rect);
	    if (rectLib.containsPoint(rect, controlPoint)) {
	        return rectControlPointWithinRectIntersection({ sides: sides, controlPoint: controlPoint, targetPoint: targetPoint });
	    }
	
	    var bezier = _bezierJs2.default.quadraticFromPoints(sourcePoint, controlPoint, targetPoint, DEFAULT_BEZIER_T);
	
	    if (bezier._linear) return rectLinearBezierIntersection({ sides: sides, bezier: bezier });
	
	    // Try to find the intersection using the Bezier library
	    var intersection = rectCurvedBezierIntersection({ sides: sides, bezier: bezier });
	
	    // Unfortunately the Bezier library suffers some Math rounding errors, as such if an intersection can't be
	    // found we retry with a slightly different target point in the hope that the rounding error doesn't occur.
	    // If we retry 5 times and we still don't have an intersection then we just finish (I think that would be
	    // pretty unlikely).
	    if (intersection || attempt >= MAX_INTERSECTION_ATTEMPTS) return intersection;
	
	    return rectBezierIntersection(rect, {
	        sourcePoint: sourcePoint,
	        controlPoint: controlPoint,
	        targetPoint: {
	            x: attempt % 2 ? targetPoint.x + 1 : targetPoint.x,
	            y: attempt % 2 ? targetPoint.y : targetPoint.y + 1
	        }
	    }, attempt + 1);
	};
	
	/**
	 * http://stackoverflow.com/questions/9710616/explain-formula-to-curve-through-a-control-point
	 */
	var quadraticControlPointFormula = function quadraticControlPointFormula(dimension) {
	    return function (start, end, lineControlPoint, ratio) {
	        return (lineControlPoint[dimension] - Math.pow(1 - ratio, 2) * start[dimension] - Math.pow(ratio, 2) * end[dimension]) / (2 * ratio * (1 - ratio));
	    };
	};
	var quadraticControlPointFormulaX = quadraticControlPointFormula('x');
	var quadraticControlPointFormulaY = quadraticControlPointFormula('y');
	
	var calculateQuadraticControlPoint = exports.calculateQuadraticControlPoint = function calculateQuadraticControlPoint(start, end, lineControlPoint) {
	    var ratio = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.5;
	    return {
	        x: quadraticControlPointFormulaX(start, end, lineControlPoint, ratio),
	        y: quadraticControlPointFormulaY(start, end, lineControlPoint, ratio)
	    };
	};

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.roundUpVals = exports.roundVals = exports.scale = exports.difference = exports.translate = undefined;
	
	var _fp = __webpack_require__(52);
	
	var _combine = __webpack_require__(2292);
	
	var _combine2 = _interopRequireDefault(_combine);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Lib
	var translate = exports.translate = (0, _combine2.default)(_fp.add);
	
	// Utils
	var difference = exports.difference = (0, _combine2.default)(_fp.subtract);
	var scale = exports.scale = (0, _fp.curry)(function (multiplier, multiplicandObj) {
	    return (0, _fp.mapValues)((0, _fp.multiply)(multiplier), multiplicandObj);
	});
	var roundVals = exports.roundVals = (0, _fp.mapValues)(_fp.round);
	var roundUpVals = exports.roundUpVals = (0, _fp.mapValues)(_fp.ceil);

/***/ }),
/* 797 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/*! Copyright (c) 2013 client IO */
	/* eslint-disable */
	//      Geometry library.
	
	var g = function () {
	
	    var g = {};
	
	    // Declare shorthands to the most used math functions.
	    var math = Math;
	    var abs = math.abs;
	    var cos = math.cos;
	    var sin = math.sin;
	    var sqrt = math.sqrt;
	    var mmin = math.min;
	    var mmax = math.max;
	    var atan2 = math.atan2;
	    var _round = math.round;
	    var floor = math.floor;
	    var PI = math.PI;
	    var random = math.random;
	
	    g.bezier = {
	
	        // Cubic Bezier curve path through points.
	        // Ported from C# implementation by Oleg V. Polikarpotchkin and Peter Lee (http://www.codeproject.com/KB/graphics/BezierSpline.aspx).
	        // @param {array} points Array of points through which the smooth line will go.
	        // @return {array} SVG Path commands as an array
	        curveThroughPoints: function curveThroughPoints(points) {
	
	            var controlPoints = this.getCurveControlPoints(points);
	            var path = ['M', points[0].x, points[0].y];
	
	            for (var i = 0; i < controlPoints[0].length; i++) {
	                path.push('C', controlPoints[0][i].x, controlPoints[0][i].y, controlPoints[1][i].x, controlPoints[1][i].y, points[i + 1].x, points[i + 1].y);
	            }
	
	            return path;
	        },
	
	        // Get open-ended Bezier Spline Control Points.
	        // @param knots Input Knot Bezier spline points (At least two points!).
	        // @param firstControlPoints Output First Control points. Array of knots.length - 1 length.
	        // @param secondControlPoints Output Second Control points. Array of knots.length - 1 length.
	        getCurveControlPoints: function getCurveControlPoints(knots) {
	
	            var firstControlPoints = [];
	            var secondControlPoints = [];
	            var n = knots.length - 1;
	            var i;
	
	            // Special case: Bezier curve should be a straight line.
	            if (n == 1) {
	                // 3P1 = 2P0 + P3
	                firstControlPoints[0] = Point((2 * knots[0].x + knots[1].x) / 3, (2 * knots[0].y + knots[1].y) / 3);
	                // P2 = 2P1 – P0
	                secondControlPoints[0] = Point(2 * firstControlPoints[0].x - knots[0].x, 2 * firstControlPoints[0].y - knots[0].y);
	                return [firstControlPoints, secondControlPoints];
	            }
	
	            // Calculate first Bezier control points.
	            // Right hand side vector.
	            var rhs = [];
	
	            // Set right hand side X values.
	            for (i = 1; i < n - 1; i++) {
	                rhs[i] = 4 * knots[i].x + 2 * knots[i + 1].x;
	            }
	            rhs[0] = knots[0].x + 2 * knots[1].x;
	            rhs[n - 1] = (8 * knots[n - 1].x + knots[n].x) / 2.0;
	            // Get first control points X-values.
	            var x = this.getFirstControlPoints(rhs);
	
	            // Set right hand side Y values.
	            for (i = 1; i < n - 1; ++i) {
	                rhs[i] = 4 * knots[i].y + 2 * knots[i + 1].y;
	            }
	            rhs[0] = knots[0].y + 2 * knots[1].y;
	            rhs[n - 1] = (8 * knots[n - 1].y + knots[n].y) / 2.0;
	            // Get first control points Y-values.
	            var y = this.getFirstControlPoints(rhs);
	
	            // Fill output arrays.
	            for (i = 0; i < n; i++) {
	                // First control point.
	                firstControlPoints.push(Point(x[i], y[i]));
	                // Second control point.
	                if (i < n - 1) {
	                    secondControlPoints.push(Point(2 * knots[i + 1].x - x[i + 1], 2 * knots[i + 1].y - y[i + 1]));
	                } else {
	                    secondControlPoints.push(Point((knots[n].x + x[n - 1]) / 2, (knots[n].y + y[n - 1]) / 2));
	                }
	            }
	            return [firstControlPoints, secondControlPoints];
	        },
	
	        // Divide a Bezier curve into two at point defined by value 't' <0,1>.
	        // Using deCasteljau algorithm. http://math.stackexchange.com/a/317867
	        // @param control points (start, control start, control end, end)
	        // @return a function accepts t and returns 2 curves each defined by 4 control points.
	        getCurveDivider: function getCurveDivider(p0, p1, p2, p3) {
	
	            return function divideCurve(t) {
	
	                var l = Line(p0, p1).pointAt(t);
	                var m = Line(p1, p2).pointAt(t);
	                var n = Line(p2, p3).pointAt(t);
	                var p = Line(l, m).pointAt(t);
	                var q = Line(m, n).pointAt(t);
	                var r = Line(p, q).pointAt(t);
	                return [{ p0: p0, p1: l, p2: p, p3: r }, { p0: r, p1: q, p2: n, p3: p3 }];
	            };
	        },
	
	        // Solves a tridiagonal system for one of coordinates (x or y) of first Bezier control points.
	        // @param rhs Right hand side vector.
	        // @return Solution vector.
	        getFirstControlPoints: function getFirstControlPoints(rhs) {
	
	            var n = rhs.length;
	            // `x` is a solution vector.
	            var x = [];
	            var tmp = [];
	            var b = 2.0;
	
	            x[0] = rhs[0] / b;
	            // Decomposition and forward substitution.
	            for (var i = 1; i < n; i++) {
	                tmp[i] = 1 / b;
	                b = (i < n - 1 ? 4.0 : 3.5) - tmp[i];
	                x[i] = (rhs[i] - x[i - 1]) / b;
	            }
	            for (i = 1; i < n; i++) {
	                // Backsubstitution.
	                x[n - i - 1] -= tmp[n - i] * x[n - i];
	            }
	            return x;
	        },
	
	        // Solves an inversion problem -- Given the (x, y) coordinates of a point which lies on
	        // a parametric curve x = x(t)/w(t), y = y(t)/w(t), ﬁnd the parameter value t
	        // which corresponds to that point.
	        // @param control points (start, control start, control end, end)
	        // @return a function accepts a point and returns t.
	        getInversionSolver: function getInversionSolver(p0, p1, p2, p3) {
	
	            var pts = arguments;
	            function l(i, j) {
	                // calculates a determinant 3x3
	                // [p.x  p.y  1]
	                // [pi.x pi.y 1]
	                // [pj.x pj.y 1]
	                var pi = pts[i];
	                var pj = pts[j];
	                return function (p) {
	                    var w = (i % 3 ? 3 : 1) * (j % 3 ? 3 : 1);
	                    var lij = p.x * (pi.y - pj.y) + p.y * (pj.x - pi.x) + pi.x * pj.y - pi.y * pj.x;
	                    return w * lij;
	                };
	            }
	            return function solveInversion(p) {
	                var ct = 3 * l(2, 3)(p1);
	                var c1 = l(1, 3)(p0) / ct;
	                var c2 = -l(2, 3)(p0) / ct;
	                var la = c1 * l(3, 1)(p) + c2 * (l(3, 0)(p) + l(2, 1)(p)) + l(2, 0)(p);
	                var lb = c1 * l(3, 0)(p) + c2 * l(2, 0)(p) + l(1, 0)(p);
	                return lb / (lb - la);
	            };
	        }
	    };
	
	    var Ellipse = g.Ellipse = function (c, a, b) {
	
	        if (!(this instanceof Ellipse)) {
	            return new Ellipse(c, a, b);
	        }
	
	        if (c instanceof Ellipse) {
	            return new Ellipse(Point(c), c.a, c.b);
	        }
	
	        c = Point(c);
	        this.x = c.x;
	        this.y = c.y;
	        this.a = a;
	        this.b = b;
	    };
	
	    g.Ellipse.fromRect = function (rect) {
	
	        rect = Rect(rect);
	        return Ellipse(rect.center(), rect.width / 2, rect.height / 2);
	    };
	
	    g.Ellipse.prototype = {
	
	        bbox: function bbox() {
	
	            return Rect(this.x - this.a, this.y - this.b, 2 * this.a, 2 * this.b);
	        },
	
	        clone: function clone() {
	
	            return Ellipse(this);
	        },
	
	        /**
	         * @param {g.Point} point
	         * @returns {number} result < 1 - inside ellipse, result == 1 - on ellipse boundary, result > 1 - outside
	         */
	        normalizedDistance: function normalizedDistance(point) {
	
	            var x0 = point.x;
	            var y0 = point.y;
	            var a = this.a;
	            var b = this.b;
	            var x = this.x;
	            var y = this.y;
	
	            return (x0 - x) * (x0 - x) / (a * a) + (y0 - y) * (y0 - y) / (b * b);
	        },
	
	        /**
	         * @param {g.Point} p
	         * @returns {boolean}
	         */
	        containsPoint: function containsPoint(p) {
	
	            return this.normalizedDistance(p) <= 1;
	        },
	
	        /**
	         * @returns {g.Point}
	         */
	        center: function center() {
	
	            return Point(this.x, this.y);
	        },
	
	        /** Compute angle between tangent and x axis
	         * @param {g.Point} p Point of tangency, it has to be on ellipse boundaries.
	         * @returns {number} angle between tangent and x axis
	         */
	        tangentTheta: function tangentTheta(p) {
	
	            var refPointDelta = 30;
	            var x0 = p.x;
	            var y0 = p.y;
	            var a = this.a;
	            var b = this.b;
	            var center = this.bbox().center();
	            var m = center.x;
	            var n = center.y;
	
	            var q1 = x0 > center.x + a / 2;
	            var q3 = x0 < center.x - a / 2;
	
	            var y, x;
	            if (q1 || q3) {
	                y = x0 > center.x ? y0 - refPointDelta : y0 + refPointDelta;
	                x = a * a / (x0 - m) - a * a * (y0 - n) * (y - n) / (b * b * (x0 - m)) + m;
	            } else {
	                x = y0 > center.y ? x0 + refPointDelta : x0 - refPointDelta;
	                y = b * b / (y0 - n) - b * b * (x0 - m) * (x - m) / (a * a * (y0 - n)) + n;
	            }
	
	            return g.point(x, y).theta(p);
	        },
	
	        equals: function equals(ellipse) {
	
	            ellipse = Ellipse(ellipse);
	            return ellipse.x === this.x && ellipse.y === this.y && ellipse.a === this.a && ellipse.b === this.b;
	        },
	
	        // Find point on me where line from my center to
	        // point p intersects my boundary.
	        // @param {number} angle If angle is specified, intersection with rotated ellipse is computed.
	        intersectionWithLineFromCenterToPoint: function intersectionWithLineFromCenterToPoint(p, angle) {
	
	            p = Point(p);
	            if (angle) p.rotate(Point(this.x, this.y), angle);
	            var dx = p.x - this.x;
	            var dy = p.y - this.y;
	            var result;
	            if (dx === 0) {
	                result = this.bbox().pointNearestToPoint(p);
	                if (angle) return result.rotate(Point(this.x, this.y), -angle);
	                return result;
	            }
	            var m = dy / dx;
	            var mSquared = m * m;
	            var aSquared = this.a * this.a;
	            var bSquared = this.b * this.b;
	            var x = sqrt(1 / (1 / aSquared + mSquared / bSquared));
	
	            x = dx < 0 ? -x : x;
	            var y = m * x;
	            result = Point(this.x + x, this.y + y);
	            if (angle) return result.rotate(Point(this.x, this.y), -angle);
	            return result;
	        },
	
	        toString: function toString() {
	
	            return Point(this.x, this.y).toString() + ' ' + this.a + ' ' + this.b;
	        }
	    };
	
	    var Line = g.Line = function (p1, p2) {
	
	        if (!(this instanceof Line)) {
	            return new Line(p1, p2);
	        }
	
	        this.start = Point(p1);
	        this.end = Point(p2);
	    };
	
	    g.Line.prototype = {
	
	        // @return the bearing (cardinal direction) of the line. For example N, W, or SE.
	        // @returns {String} One of the following bearings : NE, E, SE, S, SW, W, NW, N.
	        bearing: function bearing() {
	
	            var lat1 = toRad(this.start.y);
	            var lat2 = toRad(this.end.y);
	            var lon1 = this.start.x;
	            var lon2 = this.end.x;
	            var dLon = toRad(lon2 - lon1);
	            var y = sin(dLon) * cos(lat2);
	            var x = cos(lat1) * sin(lat2) - sin(lat1) * cos(lat2) * cos(dLon);
	            var brng = toDeg(atan2(y, x));
	
	            var bearings = ['NE', 'E', 'SE', 'S', 'SW', 'W', 'NW', 'N'];
	
	            var index = brng - 22.5;
	            if (index < 0) index += 360;
	            index = parseInt(index / 45);
	
	            return bearings[index];
	        },
	
	        clone: function clone() {
	
	            return Line(this);
	        },
	
	        // @return {point} Point where I'm intersecting l.
	        // @see Squeak Smalltalk, LineSegment>>intersectionWith:
	        intersection: function intersection(l) {
	            var pt1Dir = Point(this.end.x - this.start.x, this.end.y - this.start.y);
	            var pt2Dir = Point(l.end.x - l.start.x, l.end.y - l.start.y);
	            var det = pt1Dir.x * pt2Dir.y - pt1Dir.y * pt2Dir.x;
	            var deltaPt = Point(l.start.x - this.start.x, l.start.y - this.start.y);
	            var alpha = deltaPt.x * pt2Dir.y - deltaPt.y * pt2Dir.x;
	            var beta = deltaPt.x * pt1Dir.y - deltaPt.y * pt1Dir.x;
	
	            if (det === 0 || alpha * det < 0 || beta * det < 0) {
	                // No intersection found.
	                return null;
	            }
	            if (det > 0) {
	                if (alpha > det || beta > det) {
	                    return null;
	                }
	            } else {
	                if (alpha < det || beta < det) {
	                    return null;
	                }
	            }
	            return Point(this.start.x + alpha * pt1Dir.x / det, this.start.y + alpha * pt1Dir.y / det);
	        },
	
	        // @return {double} length of the line
	        length: function length() {
	            return sqrt(this.squaredLength());
	        },
	
	        // @return {point} my midpoint
	        midpoint: function midpoint() {
	            return Point((this.start.x + this.end.x) / 2, (this.start.y + this.end.y) / 2);
	        },
	
	        // @return {point} my point at 't' <0,1>
	        pointAt: function pointAt(t) {
	
	            var x = (1 - t) * this.start.x + t * this.end.x;
	            var y = (1 - t) * this.start.y + t * this.end.y;
	            return Point(x, y);
	        },
	
	        // @return {number} the offset of the point `p` from the line. + if the point `p` is on the right side of the line, - if on the left and 0 if on the line.
	        pointOffset: function pointOffset(p) {
	
	            // Find the sign of the determinant of vectors (start,end), where p is the query point.
	            return ((this.end.x - this.start.x) * (p.y - this.start.y) - (this.end.y - this.start.y) * (p.x - this.start.x)) / 2;
	        },
	
	        // @return {integer} length without sqrt
	        // @note for applications where the exact length is not necessary (e.g. compare only)
	        squaredLength: function squaredLength() {
	            var x0 = this.start.x;
	            var y0 = this.start.y;
	            var x1 = this.end.x;
	            var y1 = this.end.y;
	            return (x0 -= x1) * x0 + (y0 -= y1) * y0;
	        },
	
	        toString: function toString() {
	            return this.start.toString() + ' ' + this.end.toString();
	        }
	    };
	
	    /*
	        Point is the most basic object consisting of x/y coordinate.
	         Possible instantiations are:
	        * `Point(10, 20)`
	        * `new Point(10, 20)`
	        * `Point('10 20')`
	        * `Point(Point(10, 20))`
	    */
	    var Point = g.Point = function (x, y) {
	
	        if (!(this instanceof Point)) {
	            return new Point(x, y);
	        }
	
	        if (typeof x === 'string') {
	            var xy = x.split(x.indexOf('@') === -1 ? ' ' : '@');
	            x = parseInt(xy[0], 10);
	            y = parseInt(xy[1], 10);
	        } else if (Object(x) === x) {
	            y = x.y;
	            x = x.x;
	        }
	
	        this.x = x === undefined ? 0 : x;
	        this.y = y === undefined ? 0 : y;
	    };
	
	    // Alternative constructor, from polar coordinates.
	    // @param {number} Distance.
	    // @param {number} Angle in radians.
	    // @param {point} [optional] Origin.
	    g.Point.fromPolar = function (distance, angle, origin) {
	
	        origin = origin && Point(origin) || Point(0, 0);
	        var x = abs(distance * cos(angle));
	        var y = abs(distance * sin(angle));
	        var deg = normalizeAngle(toDeg(angle));
	
	        if (deg < 90) {
	            y = -y;
	        } else if (deg < 180) {
	            x = -x;
	            y = -y;
	        } else if (deg < 270) {
	            x = -x;
	        }
	
	        return Point(origin.x + x, origin.y + y);
	    };
	
	    // Create a point with random coordinates that fall into the range `[x1, x2]` and `[y1, y2]`.
	    g.Point.random = function (x1, x2, y1, y2) {
	
	        return Point(floor(random() * (x2 - x1 + 1) + x1), floor(random() * (y2 - y1 + 1) + y1));
	    };
	
	    g.Point.prototype = {
	
	        // If point lies outside rectangle `r`, return the nearest point on the boundary of rect `r`,
	        // otherwise return point itself.
	        // (see Squeak Smalltalk, Point>>adhereTo:)
	        adhereToRect: function adhereToRect(r) {
	
	            if (r.containsPoint(this)) {
	                return this;
	            }
	
	            this.x = mmin(mmax(this.x, r.x), r.x + r.width);
	            this.y = mmin(mmax(this.y, r.y), r.y + r.height);
	            return this;
	        },
	
	        // Return the bearing between me and the given point.
	        bearing: function bearing(point) {
	
	            return Line(this, point).bearing();
	        },
	
	        // Returns change in angle from my previous position (-dx, -dy) to my new position
	        // relative to ref point.
	        changeInAngle: function changeInAngle(dx, dy, ref) {
	
	            // Revert the translation and measure the change in angle around x-axis.
	            return Point(this).offset(-dx, -dy).theta(ref) - this.theta(ref);
	        },
	
	        clone: function clone() {
	
	            return Point(this);
	        },
	
	        difference: function difference(p) {
	
	            return Point(this.x - p.x, this.y - p.y);
	        },
	
	        // Returns distance between me and point `p`.
	        distance: function distance(p) {
	
	            return Line(this, p).length();
	        },
	
	        equals: function equals(p) {
	
	            return this.x === p.x && this.y === p.y;
	        },
	
	        magnitude: function magnitude() {
	
	            return sqrt(this.x * this.x + this.y * this.y) || 0.01;
	        },
	
	        // Returns a manhattan (taxi-cab) distance between me and point `p`.
	        manhattanDistance: function manhattanDistance(p) {
	
	            return abs(p.x - this.x) + abs(p.y - this.y);
	        },
	
	        // Move point on line starting from ref ending at me by
	        // distance distance.
	        move: function move(ref, distance) {
	
	            var theta = toRad(Point(ref).theta(this));
	            return this.offset(cos(theta) * distance, -sin(theta) * distance);
	        },
	
	        // Scales x and y such that the distance between the point and the origin (0,0) is equal to the given length.
	        normalize: function normalize(length) {
	
	            var scale = (length || 1) / this.magnitude();
	            return this.scale(scale, scale);
	        },
	
	        // Offset me by the specified amount.
	        offset: function offset(dx, dy) {
	
	            this.x += dx || 0;
	            this.y += dy || 0;
	            return this;
	        },
	
	        // Returns a point that is the reflection of me with
	        // the center of inversion in ref point.
	        reflection: function reflection(ref) {
	
	            return Point(ref).move(this, this.distance(ref));
	        },
	
	        // Rotate point by angle around origin.
	        rotate: function rotate(origin, angle) {
	
	            angle = (angle + 360) % 360;
	            this.toPolar(origin);
	            this.y += toRad(angle);
	            var point = Point.fromPolar(this.x, this.y, origin);
	            this.x = point.x;
	            this.y = point.y;
	            return this;
	        },
	
	        round: function round(precision) {
	
	            this.x = precision ? this.x.toFixed(precision) : _round(this.x);
	            this.y = precision ? this.y.toFixed(precision) : _round(this.y);
	            return this;
	        },
	
	        // Scale point with origin.
	        scale: function scale(sx, sy, origin) {
	
	            origin = origin && Point(origin) || Point(0, 0);
	            this.x = origin.x + sx * (this.x - origin.x);
	            this.y = origin.y + sy * (this.y - origin.y);
	            return this;
	        },
	
	        snapToGrid: function snapToGrid(gx, gy) {
	
	            this.x = _snapToGrid(this.x, gx);
	            this.y = _snapToGrid(this.y, gy || gx);
	            return this;
	        },
	
	        // Compute the angle between me and `p` and the x axis.
	        // (cartesian-to-polar coordinates conversion)
	        // Return theta angle in degrees.
	        theta: function theta(p) {
	
	            p = Point(p);
	            // Invert the y-axis.
	            var y = -(p.y - this.y);
	            var x = p.x - this.x;
	            // Makes sure that the comparison with zero takes rounding errors into account.
	            var PRECISION = 10;
	            // Note that `atan2` is not defined for `x`, `y` both equal zero.
	            var rad = y.toFixed(PRECISION) == 0 && x.toFixed(PRECISION) == 0 ? 0 : atan2(y, x);
	
	            // Correction for III. and IV. quadrant.
	            if (rad < 0) {
	                rad = 2 * PI + rad;
	            }
	            return 180 * rad / PI;
	        },
	
	        toJSON: function toJSON() {
	
	            return { x: this.x, y: this.y };
	        },
	
	        // Converts rectangular to polar coordinates.
	        // An origin can be specified, otherwise it's 0@0.
	        toPolar: function toPolar(o) {
	
	            o = o && Point(o) || Point(0, 0);
	            var x = this.x;
	            var y = this.y;
	            this.x = sqrt((x - o.x) * (x - o.x) + (y - o.y) * (y - o.y)); // r
	            this.y = toRad(o.theta(Point(x, y)));
	            return this;
	        },
	
	        toString: function toString() {
	
	            return this.x + '@' + this.y;
	        },
	
	        update: function update(x, y) {
	
	            this.x = x || 0;
	            this.y = y || 0;
	            return this;
	        }
	    };
	
	    var Rect = g.Rect = function (x, y, w, h) {
	
	        if (!(this instanceof Rect)) {
	            return new Rect(x, y, w, h);
	        }
	
	        if (Object(x) === x) {
	            y = x.y;
	            w = x.width;
	            h = x.height;
	            x = x.x;
	        }
	
	        this.x = x === undefined ? 0 : x;
	        this.y = y === undefined ? 0 : y;
	        this.width = w === undefined ? 0 : w;
	        this.height = h === undefined ? 0 : h;
	    };
	
	    g.Rect.fromEllipse = function (e) {
	
	        e = Ellipse(e);
	        return Rect(e.x - e.a, e.y - e.b, 2 * e.a, 2 * e.b);
	    };
	
	    g.Rect.prototype = {
	
	        // Find my bounding box when I'm rotated with the center of rotation in the center of me.
	        // @return r {rectangle} representing a bounding box
	        bbox: function bbox(angle) {
	
	            var theta = toRad(angle || 0);
	            var st = abs(sin(theta));
	            var ct = abs(cos(theta));
	            var w = this.width * ct + this.height * st;
	            var h = this.width * st + this.height * ct;
	            return Rect(this.x + (this.width - w) / 2, this.y + (this.height - h) / 2, w, h);
	        },
	
	        bottomLeft: function bottomLeft() {
	
	            return Point(this.x, this.y + this.height);
	        },
	
	        bottomMiddle: function bottomMiddle() {
	
	            return Point(this.x + this.width / 2, this.y + this.height);
	        },
	
	        center: function center() {
	
	            return Point(this.x + this.width / 2, this.y + this.height / 2);
	        },
	
	        clone: function clone() {
	
	            return Rect(this);
	        },
	
	        // @return {bool} true if point p is insight me
	        containsPoint: function containsPoint(p) {
	
	            p = Point(p);
	            return p.x >= this.x && p.x <= this.x + this.width && p.y >= this.y && p.y <= this.y + this.height;
	        },
	
	        // @return {bool} true if rectangle `r` is inside me.
	        containsRect: function containsRect(r) {
	
	            var r0 = Rect(this).normalize();
	            var r1 = Rect(r).normalize();
	            var w0 = r0.width;
	            var h0 = r0.height;
	            var w1 = r1.width;
	            var h1 = r1.height;
	
	            if (!w0 || !h0 || !w1 || !h1) {
	                // At least one of the dimensions is 0
	                return false;
	            }
	
	            var x0 = r0.x;
	            var y0 = r0.y;
	            var x1 = r1.x;
	            var y1 = r1.y;
	
	            w1 += x1;
	            w0 += x0;
	            h1 += y1;
	            h0 += y0;
	
	            return x0 <= x1 && w1 <= w0 && y0 <= y1 && h1 <= h0;
	        },
	
	        corner: function corner() {
	
	            return Point(this.x + this.width, this.y + this.height);
	        },
	
	        // @return {boolean} true if rectangles are equal.
	        equals: function equals(r) {
	
	            var mr = Rect(this).normalize();
	            var nr = Rect(r).normalize();
	            return mr.x === nr.x && mr.y === nr.y && mr.width === nr.width && mr.height === nr.height;
	        },
	
	        // @return {rect} if rectangles intersect, {null} if not.
	        intersect: function intersect(r) {
	
	            var myOrigin = this.origin();
	            var myCorner = this.corner();
	            var rOrigin = r.origin();
	            var rCorner = r.corner();
	
	            // No intersection found
	            if (rCorner.x <= myOrigin.x || rCorner.y <= myOrigin.y || rOrigin.x >= myCorner.x || rOrigin.y >= myCorner.y) return null;
	
	            var x = Math.max(myOrigin.x, rOrigin.x);
	            var y = Math.max(myOrigin.y, rOrigin.y);
	
	            return Rect(x, y, Math.min(myCorner.x, rCorner.x) - x, Math.min(myCorner.y, rCorner.y) - y);
	        },
	
	        /**
	         * MILANOTE MODIFICATION
	         */
	        // Find point on my boundary where line starting
	        // from an origin ending in point p intersects me.
	        // @param {number} angle If angle is specified, intersection with rotated rectangle is computed.
	        intersectionWithLineFromOriginToPoint: function intersectionWithLineFromOriginToPoint(o, p, angle) {
	            o = Point(o);
	            p = Point(p);
	
	            var result;
	            if (angle) p.rotate(o, angle);
	
	            // (clockwise, starting from the top side)
	            var sides = [Line(this.origin(), this.topRight()), Line(this.topRight(), this.corner()), Line(this.corner(), this.bottomLeft()), Line(this.bottomLeft(), this.origin())];
	            var connector = Line(o, p);
	
	            for (var i = sides.length - 1; i >= 0; --i) {
	                var intersection = sides[i].intersection(connector);
	                if (intersection !== null) {
	                    result = intersection;
	                    break;
	                }
	            }
	            if (result && angle) result.rotate(o, -angle);
	            return result;
	        },
	
	        /**
	         * MILANOTE MODIFICATION.
	         * The original 'intersectionWithLineFromCenterToPoint' was too specific for our needs, instead
	         * of a centre point, we needed a potentially different origin.
	         */
	        // Find point on my boundary where line starting
	        // from my center ending in point p intersects me.
	        // @param {number} angle If angle is specified, intersection with rotated rectangle is computed.
	        intersectionWithLineFromCenterToPoint: function intersectionWithLineFromCenterToPoint(p, angle) {
	            var center = Point(this.x + this.width / 2, this.y + this.height / 2);
	            return this.intersectionWithLineFromOriginToPoint(center, p, angle);
	        },
	
	        leftMiddle: function leftMiddle() {
	
	            return Point(this.x, this.y + this.height / 2);
	        },
	
	        // Move and expand me.
	        // @param r {rectangle} representing deltas
	        moveAndExpand: function moveAndExpand(r) {
	
	            this.x += r.x || 0;
	            this.y += r.y || 0;
	            this.width += r.width || 0;
	            this.height += r.height || 0;
	            return this;
	        },
	
	        // Normalize the rectangle; i.e., make it so that it has a non-negative width and height.
	        // If width < 0 the function swaps the left and right corners,
	        // and it swaps the top and bottom corners if height < 0
	        // like in http://qt-project.org/doc/qt-4.8/qrectf.html#normalized
	        normalize: function normalize() {
	
	            var newx = this.x;
	            var newy = this.y;
	            var newwidth = this.width;
	            var newheight = this.height;
	            if (this.width < 0) {
	                newx = this.x + this.width;
	                newwidth = -this.width;
	            }
	            if (this.height < 0) {
	                newy = this.y + this.height;
	                newheight = -this.height;
	            }
	            this.x = newx;
	            this.y = newy;
	            this.width = newwidth;
	            this.height = newheight;
	            return this;
	        },
	
	        origin: function origin() {
	
	            return Point(this.x, this.y);
	        },
	
	        // @return {point} a point on my boundary nearest to the given point.
	        // @see Squeak Smalltalk, Rectangle>>pointNearestTo:
	        pointNearestToPoint: function pointNearestToPoint(point) {
	
	            point = Point(point);
	            if (this.containsPoint(point)) {
	                var side = this.sideNearestToPoint(point);
	                switch (side) {
	                    case 'right':
	                        return Point(this.x + this.width, point.y);
	                    case 'left':
	                        return Point(this.x, point.y);
	                    case 'bottom':
	                        return Point(point.x, this.y + this.height);
	                    case 'top':
	                        return Point(point.x, this.y);
	                }
	            }
	            return point.adhereToRect(this);
	        },
	
	        rightMiddle: function rightMiddle() {
	
	            return Point(this.x + this.width, this.y + this.height / 2);
	        },
	
	        round: function round(precision) {
	
	            this.x = precision ? this.x.toFixed(precision) : _round(this.x);
	            this.y = precision ? this.y.toFixed(precision) : _round(this.y);
	            this.width = precision ? this.width.toFixed(precision) : _round(this.width);
	            this.height = precision ? this.height.toFixed(precision) : _round(this.height);
	            return this;
	        },
	
	        // Scale rectangle with origin.
	        scale: function scale(sx, sy, origin) {
	
	            origin = this.origin().scale(sx, sy, origin);
	            this.x = origin.x;
	            this.y = origin.y;
	            this.width *= sx;
	            this.height *= sy;
	            return this;
	        },
	
	        // @return {string} (left|right|top|bottom) side which is nearest to point
	        // @see Squeak Smalltalk, Rectangle>>sideNearestTo:
	        sideNearestToPoint: function sideNearestToPoint(point) {
	
	            point = Point(point);
	            var distToLeft = point.x - this.x;
	            var distToRight = this.x + this.width - point.x;
	            var distToTop = point.y - this.y;
	            var distToBottom = this.y + this.height - point.y;
	            var closest = distToLeft;
	            var side = 'left';
	
	            if (distToRight < closest) {
	                closest = distToRight;
	                side = 'right';
	            }
	            if (distToTop < closest) {
	                closest = distToTop;
	                side = 'top';
	            }
	            if (distToBottom < closest) {
	                closest = distToBottom;
	                side = 'bottom';
	            }
	            return side;
	        },
	
	        snapToGrid: function snapToGrid(gx, gy) {
	
	            var origin = this.origin().snapToGrid(gx, gy);
	            var corner = this.corner().snapToGrid(gx, gy);
	            this.x = origin.x;
	            this.y = origin.y;
	            this.width = corner.x - origin.x;
	            this.height = corner.y - origin.y;
	            return this;
	        },
	
	        topMiddle: function topMiddle() {
	
	            return Point(this.x + this.width / 2, this.y);
	        },
	
	        topRight: function topRight() {
	
	            return Point(this.x + this.width, this.y);
	        },
	
	        toJSON: function toJSON() {
	
	            return { x: this.x, y: this.y, width: this.width, height: this.height };
	        },
	
	        toString: function toString() {
	
	            return this.origin().toString() + ' ' + this.corner().toString();
	        },
	
	        // @return {rect} representing the union of both rectangles.
	        union: function union(rect) {
	
	            var myOrigin = this.origin();
	            var myCorner = this.corner();
	            var rOrigin = rect.origin();
	            var rCorner = rect.corner();
	
	            var originX = Math.min(myOrigin.x, rOrigin.x);
	            var originY = Math.min(myOrigin.y, rOrigin.y);
	            var cornerX = Math.max(myCorner.x, rCorner.x);
	            var cornerY = Math.max(myCorner.y, rCorner.y);
	
	            return Rect(originX, originY, cornerX - originX, cornerY - originY);
	        }
	    };
	
	    var normalizeAngle = g.normalizeAngle = function (angle) {
	
	        return angle % 360 + (angle < 0 ? 360 : 0);
	    };
	
	    g.scale = {
	
	        // Return the `value` from the `domain` interval scaled to the `range` interval.
	        linear: function linear(domain, range, value) {
	
	            var domainSpan = domain[1] - domain[0];
	            var rangeSpan = range[1] - range[0];
	            return (value - domain[0]) / domainSpan * rangeSpan + range[0] || 0;
	        }
	    };
	
	    var _snapToGrid = g.snapToGrid = function (value, gridSize) {
	
	        return gridSize * Math.round(value / gridSize);
	    };
	
	    var toDeg = g.toDeg = function (rad) {
	
	        return 180 * rad / PI % 360;
	    };
	
	    var toRad = g.toRad = function (deg, over360) {
	
	        over360 = over360 || false;
	        deg = over360 ? deg : deg % 360;
	        return deg * PI / 180;
	    };
	
	    // For backwards compatibility:
	    g.ellipse = g.Ellipse;
	    g.line = g.Line;
	    g.point = g.Point;
	    g.rect = g.Rect;
	
	    return g;
	}();
	
	exports.default = g;

/***/ }),
/* 798 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var MIME_TYPES = exports.MIME_TYPES = {
	    PDF: 'application/pdf',
	    HTML: 'text/html',
	    DOCX: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
	    MARKDOWN: 'text/markdown; charset=UTF-8',
	    PLAIN_TEXT: 'text/plain; charset=UTF-8',
	    // Images
	    GIF: 'image/gif',
	    JPEG: 'image/jpeg',
	    PNG: 'image/png'
	};

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.isElementId = exports.checkIdValid = exports.getClientTick = exports.getClientId = exports.getTimestamp = undefined;
	
	var _base = __webpack_require__(246);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _uidConstants = __webpack_require__(487);
	
	var _timestamp = __webpack_require__(486);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getTimestamp = exports.getTimestamp = function getTimestamp(id) {
	    return (0, _timestamp.parseTimestamp)(id.slice(0, _uidConstants.TIMESTAMP_LENGTH));
	};
	var getClientId = exports.getClientId = function getClientId(id) {
	    return id.slice(_uidConstants.TIMESTAMP_LENGTH, _uidConstants.TIMESTAMP_LENGTH + _uidConstants.CLIENT_ID_LENGTH);
	};
	var getClientTick = exports.getClientTick = function getClientTick(id) {
	    return _base2.default.decode(id.slice(_uidConstants.TIMESTAMP_LENGTH + _uidConstants.CLIENT_ID_LENGTH));
	};
	
	var checkIdValid = exports.checkIdValid = function checkIdValid(id, clientId, lastTick) {
	    if (id.length !== _uidConstants.ELEMENT_ID_LENGTH) return false;
	    if (getClientId(id) !== clientId) return false;
	    if (getClientTick(id) <= lastTick) return false;
	    return true;
	};
	
	var isElementId = exports.isElementId = function isElementId(id) {
	    if (id.length !== _uidConstants.ELEMENT_ID_LENGTH) return false;
	    return true;
	};

/***/ }),
/* 800 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (value, pad) {
	  return ("" + pad + value).slice(-pad.length);
	};

/***/ }),
/* 801 */
/***/ (function(module, exports) {

	module.exports = [
	  "aaa",
	  "aarp",
	  "abarth",
	  "abb",
	  "abbott",
	  "abbvie",
	  "abc",
	  "able",
	  "abogado",
	  "abudhabi",
	  "ac",
	  "academy",
	  "accenture",
	  "accountant",
	  "accountants",
	  "aco",
	  "active",
	  "actor",
	  "ad",
	  "adac",
	  "ads",
	  "adult",
	  "ae",
	  "aeg",
	  "aero",
	  "aetna",
	  "af",
	  "afamilycompany",
	  "afl",
	  "ag",
	  "agakhan",
	  "agency",
	  "ai",
	  "aig",
	  "aigo",
	  "airbus",
	  "airforce",
	  "airtel",
	  "akdn",
	  "al",
	  "alfaromeo",
	  "alibaba",
	  "alipay",
	  "allfinanz",
	  "allstate",
	  "ally",
	  "alsace",
	  "alstom",
	  "am",
	  "americanexpress",
	  "americanfamily",
	  "amex",
	  "amfam",
	  "amica",
	  "amsterdam",
	  "analytics",
	  "android",
	  "anquan",
	  "anz",
	  "ao",
	  "apartments",
	  "app",
	  "apple",
	  "aq",
	  "aquarelle",
	  "ar",
	  "aramco",
	  "archi",
	  "army",
	  "arpa",
	  "art",
	  "arte",
	  "as",
	  "asda",
	  "asia",
	  "associates",
	  "at",
	  "athleta",
	  "attorney",
	  "au",
	  "auction",
	  "audi",
	  "audible",
	  "audio",
	  "auspost",
	  "author",
	  "auto",
	  "autos",
	  "avianca",
	  "aw",
	  "aws",
	  "ax",
	  "axa",
	  "az",
	  "azure",
	  "ba",
	  "baby",
	  "baidu",
	  "banamex",
	  "bananarepublic",
	  "band",
	  "bank",
	  "bar",
	  "barcelona",
	  "barclaycard",
	  "barclays",
	  "barefoot",
	  "bargains",
	  "bauhaus",
	  "bayern",
	  "bb",
	  "bbc",
	  "bbt",
	  "bbva",
	  "bcg",
	  "bcn",
	  "bd",
	  "be",
	  "beats",
	  "beauty",
	  "beer",
	  "bentley",
	  "berlin",
	  "best",
	  "bestbuy",
	  "bet",
	  "bf",
	  "bg",
	  "bh",
	  "bharti",
	  "bi",
	  "bible",
	  "bid",
	  "bike",
	  "bing",
	  "bingo",
	  "bio",
	  "biz",
	  "bj",
	  "black",
	  "blackfriday",
	  "blanco",
	  "blockbuster",
	  "blog",
	  "bloomberg",
	  "blue",
	  "bm",
	  "bms",
	  "bmw",
	  "bn",
	  "bnl",
	  "bnpparibas",
	  "bo",
	  "boats",
	  "boehringer",
	  "bofa",
	  "bom",
	  "bond",
	  "boo",
	  "book",
	  "booking",
	  "boots",
	  "bosch",
	  "bostik",
	  "bot",
	  "boutique",
	  "br",
	  "bradesco",
	  "bridgestone",
	  "broadway",
	  "broker",
	  "brother",
	  "brussels",
	  "bs",
	  "bt",
	  "budapest",
	  "bugatti",
	  "build",
	  "builders",
	  "business",
	  "buy",
	  "buzz",
	  "bv",
	  "bw",
	  "by",
	  "bz",
	  "bzh",
	  "ca",
	  "cab",
	  "cafe",
	  "cal",
	  "call",
	  "calvinklein",
	  "cam",
	  "camera",
	  "camp",
	  "cancerresearch",
	  "canon",
	  "capetown",
	  "capital",
	  "capitalone",
	  "car",
	  "caravan",
	  "cards",
	  "care",
	  "career",
	  "careers",
	  "cars",
	  "cartier",
	  "casa",
	  "cash",
	  "casino",
	  "cat",
	  "catering",
	  "cba",
	  "cbn",
	  "cbre",
	  "cbs",
	  "cc",
	  "cd",
	  "ceb",
	  "center",
	  "ceo",
	  "cern",
	  "cf",
	  "cfa",
	  "cfd",
	  "cg",
	  "ch",
	  "chanel",
	  "channel",
	  "chase",
	  "chat",
	  "cheap",
	  "chintai",
	  "chloe",
	  "christmas",
	  "chrome",
	  "chrysler",
	  "church",
	  "ci",
	  "cipriani",
	  "circle",
	  "cisco",
	  "citadel",
	  "citi",
	  "citic",
	  "city",
	  "cityeats",
	  "ck",
	  "cl",
	  "claims",
	  "cleaning",
	  "click",
	  "clinic",
	  "clinique",
	  "clothing",
	  "cloud",
	  "club",
	  "clubmed",
	  "cm",
	  "cn",
	  "co",
	  "coach",
	  "codes",
	  "coffee",
	  "college",
	  "cologne",
	  "com",
	  "comcast",
	  "commbank",
	  "community",
	  "company",
	  "compare",
	  "computer",
	  "comsec",
	  "condos",
	  "construction",
	  "consulting",
	  "contact",
	  "contractors",
	  "cooking",
	  "cookingchannel",
	  "cool",
	  "coop",
	  "corsica",
	  "country",
	  "coupon",
	  "coupons",
	  "courses",
	  "cr",
	  "credit",
	  "creditcard",
	  "creditunion",
	  "cricket",
	  "crown",
	  "crs",
	  "cruises",
	  "csc",
	  "cu",
	  "cuisinella",
	  "cv",
	  "cw",
	  "cx",
	  "cy",
	  "cymru",
	  "cyou",
	  "cz",
	  "dabur",
	  "dad",
	  "dance",
	  "date",
	  "dating",
	  "datsun",
	  "day",
	  "dclk",
	  "dds",
	  "de",
	  "deal",
	  "dealer",
	  "deals",
	  "degree",
	  "delivery",
	  "dell",
	  "deloitte",
	  "delta",
	  "democrat",
	  "dental",
	  "dentist",
	  "desi",
	  "design",
	  "dev",
	  "dhl",
	  "diamonds",
	  "diet",
	  "digital",
	  "direct",
	  "directory",
	  "discount",
	  "discover",
	  "dish",
	  "diy",
	  "dj",
	  "dk",
	  "dm",
	  "dnp",
	  "do",
	  "docs",
	  "doctor",
	  "dodge",
	  "dog",
	  "doha",
	  "domains",
	  "dot",
	  "download",
	  "drive",
	  "dtv",
	  "dubai",
	  "duck",
	  "dunlop",
	  "duns",
	  "dupont",
	  "durban",
	  "dvag",
	  "dz",
	  "earth",
	  "eat",
	  "ec",
	  "eco",
	  "edeka",
	  "edu",
	  "education",
	  "ee",
	  "eg",
	  "email",
	  "emerck",
	  "energy",
	  "engineer",
	  "engineering",
	  "enterprises",
	  "epost",
	  "epson",
	  "equipment",
	  "er",
	  "ericsson",
	  "erni",
	  "es",
	  "esq",
	  "estate",
	  "esurance",
	  "et",
	  "eu",
	  "eurovision",
	  "eus",
	  "events",
	  "everbank",
	  "exchange",
	  "expert",
	  "exposed",
	  "express",
	  "extraspace",
	  "fage",
	  "fail",
	  "fairwinds",
	  "faith",
	  "family",
	  "fan",
	  "fans",
	  "farm",
	  "farmers",
	  "fashion",
	  "fast",
	  "fedex",
	  "feedback",
	  "ferrari",
	  "ferrero",
	  "fi",
	  "fiat",
	  "fidelity",
	  "film",
	  "final",
	  "finance",
	  "financial",
	  "fire",
	  "firestone",
	  "firmdale",
	  "fish",
	  "fishing",
	  "fit",
	  "fitness",
	  "fj",
	  "fk",
	  "flickr",
	  "flights",
	  "flir",
	  "florist",
	  "flowers",
	  "fly",
	  "fm",
	  "fo",
	  "foo",
	  "foodnetwork",
	  "football",
	  "ford",
	  "forex",
	  "forsale",
	  "forum",
	  "foundation",
	  "fox",
	  "fr",
	  "fresenius",
	  "frl",
	  "frogans",
	  "frontdoor",
	  "frontier",
	  "ftr",
	  "fujitsu",
	  "fujixerox",
	  "fund",
	  "furniture",
	  "futbol",
	  "fyi",
	  "ga",
	  "gal",
	  "gallery",
	  "gallo",
	  "gallup",
	  "game",
	  "games",
	  "gap",
	  "garden",
	  "gb",
	  "gbiz",
	  "gd",
	  "gdn",
	  "ge",
	  "gea",
	  "gent",
	  "genting",
	  "george",
	  "gf",
	  "gg",
	  "ggee",
	  "gh",
	  "gi",
	  "gift",
	  "gifts",
	  "gives",
	  "giving",
	  "gl",
	  "glade",
	  "glass",
	  "gle",
	  "global",
	  "globo",
	  "gm",
	  "gmail",
	  "gmbh",
	  "gmo",
	  "gmx",
	  "gn",
	  "godaddy",
	  "gold",
	  "goldpoint",
	  "golf",
	  "goo",
	  "goodhands",
	  "goodyear",
	  "goog",
	  "google",
	  "gop",
	  "got",
	  "gov",
	  "gp",
	  "gq",
	  "gr",
	  "grainger",
	  "graphics",
	  "gratis",
	  "green",
	  "gripe",
	  "group",
	  "gs",
	  "gt",
	  "gu",
	  "guardian",
	  "gucci",
	  "guge",
	  "guide",
	  "guitars",
	  "guru",
	  "gw",
	  "gy",
	  "hamburg",
	  "hangout",
	  "haus",
	  "hbo",
	  "hdfc",
	  "hdfcbank",
	  "health",
	  "healthcare",
	  "help",
	  "helsinki",
	  "here",
	  "hermes",
	  "hgtv",
	  "hiphop",
	  "hisamitsu",
	  "hitachi",
	  "hiv",
	  "hk",
	  "hkt",
	  "hm",
	  "hn",
	  "hockey",
	  "holdings",
	  "holiday",
	  "homedepot",
	  "homegoods",
	  "homes",
	  "homesense",
	  "honda",
	  "honeywell",
	  "horse",
	  "host",
	  "hosting",
	  "hot",
	  "hoteles",
	  "hotmail",
	  "house",
	  "how",
	  "hr",
	  "hsbc",
	  "ht",
	  "htc",
	  "hu",
	  "hughes",
	  "hyatt",
	  "hyundai",
	  "ibm",
	  "icbc",
	  "ice",
	  "icu",
	  "id",
	  "ie",
	  "ieee",
	  "ifm",
	  "iinet",
	  "ikano",
	  "il",
	  "im",
	  "imamat",
	  "imdb",
	  "immo",
	  "immobilien",
	  "in",
	  "industries",
	  "infiniti",
	  "info",
	  "ing",
	  "ink",
	  "institute",
	  "insurance",
	  "insure",
	  "int",
	  "intel",
	  "international",
	  "intuit",
	  "investments",
	  "io",
	  "ipiranga",
	  "iq",
	  "ir",
	  "irish",
	  "is",
	  "iselect",
	  "ismaili",
	  "ist",
	  "istanbul",
	  "it",
	  "itau",
	  "itv",
	  "iwc",
	  "jaguar",
	  "java",
	  "jcb",
	  "jcp",
	  "je",
	  "jeep",
	  "jetzt",
	  "jewelry",
	  "jlc",
	  "jll",
	  "jm",
	  "jmp",
	  "jnj",
	  "jo",
	  "jobs",
	  "joburg",
	  "jot",
	  "joy",
	  "jp",
	  "jpmorgan",
	  "jprs",
	  "juegos",
	  "juniper",
	  "kaufen",
	  "kddi",
	  "ke",
	  "kerryhotels",
	  "kerrylogistics",
	  "kerryproperties",
	  "kfh",
	  "kg",
	  "kh",
	  "ki",
	  "kia",
	  "kim",
	  "kinder",
	  "kindle",
	  "kitchen",
	  "kiwi",
	  "km",
	  "kn",
	  "koeln",
	  "komatsu",
	  "kosher",
	  "kp",
	  "kpmg",
	  "kpn",
	  "kr",
	  "krd",
	  "kred",
	  "kuokgroup",
	  "kw",
	  "ky",
	  "kyoto",
	  "kz",
	  "la",
	  "lacaixa",
	  "ladbrokes",
	  "lamborghini",
	  "lamer",
	  "lancaster",
	  "lancia",
	  "lancome",
	  "land",
	  "landrover",
	  "lanxess",
	  "lasalle",
	  "lat",
	  "latino",
	  "latrobe",
	  "law",
	  "lawyer",
	  "lb",
	  "lc",
	  "lds",
	  "lease",
	  "leclerc",
	  "lefrak",
	  "legal",
	  "lego",
	  "lexus",
	  "lgbt",
	  "li",
	  "liaison",
	  "lidl",
	  "life",
	  "lifeinsurance",
	  "lifestyle",
	  "lighting",
	  "like",
	  "lilly",
	  "limited",
	  "limo",
	  "lincoln",
	  "linde",
	  "link",
	  "lipsy",
	  "live",
	  "living",
	  "lixil",
	  "lk",
	  "loan",
	  "loans",
	  "locker",
	  "locus",
	  "loft",
	  "lol",
	  "london",
	  "lotte",
	  "lotto",
	  "love",
	  "lpl",
	  "lplfinancial",
	  "lr",
	  "ls",
	  "lt",
	  "ltd",
	  "ltda",
	  "lu",
	  "lundbeck",
	  "lupin",
	  "luxe",
	  "luxury",
	  "lv",
	  "ly",
	  "ma",
	  "macys",
	  "madrid",
	  "maif",
	  "maison",
	  "makeup",
	  "man",
	  "management",
	  "mango",
	  "market",
	  "marketing",
	  "markets",
	  "marriott",
	  "marshalls",
	  "maserati",
	  "mattel",
	  "mba",
	  "mc",
	  "mcd",
	  "mcdonalds",
	  "mckinsey",
	  "md",
	  "me",
	  "med",
	  "media",
	  "meet",
	  "melbourne",
	  "meme",
	  "memorial",
	  "men",
	  "menu",
	  "meo",
	  "metlife",
	  "mg",
	  "mh",
	  "miami",
	  "microsoft",
	  "mil",
	  "mini",
	  "mint",
	  "mit",
	  "mitsubishi",
	  "mk",
	  "ml",
	  "mlb",
	  "mls",
	  "mm",
	  "mma",
	  "mn",
	  "mo",
	  "mobi",
	  "mobily",
	  "moda",
	  "moe",
	  "moi",
	  "mom",
	  "monash",
	  "money",
	  "montblanc",
	  "mopar",
	  "mormon",
	  "mortgage",
	  "moscow",
	  "motorcycles",
	  "mov",
	  "movie",
	  "movistar",
	  "mp",
	  "mq",
	  "mr",
	  "ms",
	  "msd",
	  "mt",
	  "mtn",
	  "mtpc",
	  "mtr",
	  "mu",
	  "museum",
	  "mutual",
	  "mutuelle",
	  "mv",
	  "mw",
	  "mx",
	  "my",
	  "mz",
	  "na",
	  "nab",
	  "nadex",
	  "nagoya",
	  "name",
	  "nationwide",
	  "natura",
	  "navy",
	  "nba",
	  "nc",
	  "ne",
	  "nec",
	  "net",
	  "netbank",
	  "netflix",
	  "network",
	  "neustar",
	  "new",
	  "news",
	  "next",
	  "nextdirect",
	  "nexus",
	  "nf",
	  "nfl",
	  "ng",
	  "ngo",
	  "nhk",
	  "ni",
	  "nico",
	  "nike",
	  "nikon",
	  "ninja",
	  "nissan",
	  "nissay",
	  "nl",
	  "no",
	  "nokia",
	  "northwesternmutual",
	  "norton",
	  "now",
	  "nowruz",
	  "nowtv",
	  "np",
	  "nr",
	  "nra",
	  "nrw",
	  "ntt",
	  "nu",
	  "nyc",
	  "nz",
	  "obi",
	  "off",
	  "office",
	  "okinawa",
	  "olayan",
	  "olayangroup",
	  "oldnavy",
	  "ollo",
	  "om",
	  "omega",
	  "one",
	  "ong",
	  "onl",
	  "online",
	  "onyourside",
	  "ooo",
	  "open",
	  "oracle",
	  "orange",
	  "org",
	  "organic",
	  "orientexpress",
	  "origins",
	  "osaka",
	  "otsuka",
	  "ott",
	  "ovh",
	  "pa",
	  "page",
	  "pamperedchef",
	  "panasonic",
	  "panerai",
	  "paris",
	  "pars",
	  "partners",
	  "parts",
	  "party",
	  "passagens",
	  "pay",
	  "pccw",
	  "pe",
	  "pet",
	  "pf",
	  "pfizer",
	  "pg",
	  "ph",
	  "pharmacy",
	  "philips",
	  "photo",
	  "photography",
	  "photos",
	  "physio",
	  "piaget",
	  "pics",
	  "pictet",
	  "pictures",
	  "pid",
	  "pin",
	  "ping",
	  "pink",
	  "pioneer",
	  "pizza",
	  "pk",
	  "pl",
	  "place",
	  "play",
	  "playstation",
	  "plumbing",
	  "plus",
	  "pm",
	  "pn",
	  "pnc",
	  "pohl",
	  "poker",
	  "politie",
	  "porn",
	  "post",
	  "pr",
	  "pramerica",
	  "praxi",
	  "press",
	  "prime",
	  "pro",
	  "prod",
	  "productions",
	  "prof",
	  "progressive",
	  "promo",
	  "properties",
	  "property",
	  "protection",
	  "pru",
	  "prudential",
	  "ps",
	  "pt",
	  "pub",
	  "pw",
	  "pwc",
	  "py",
	  "qa",
	  "qpon",
	  "quebec",
	  "quest",
	  "qvc",
	  "racing",
	  "raid",
	  "re",
	  "read",
	  "realestate",
	  "realtor",
	  "realty",
	  "recipes",
	  "red",
	  "redstone",
	  "redumbrella",
	  "rehab",
	  "reise",
	  "reisen",
	  "reit",
	  "ren",
	  "rent",
	  "rentals",
	  "repair",
	  "report",
	  "republican",
	  "rest",
	  "restaurant",
	  "review",
	  "reviews",
	  "rexroth",
	  "rich",
	  "richardli",
	  "ricoh",
	  "rightathome",
	  "rio",
	  "rip",
	  "ro",
	  "rocher",
	  "rocks",
	  "rodeo",
	  "room",
	  "rs",
	  "rsvp",
	  "ru",
	  "ruhr",
	  "run",
	  "rw",
	  "rwe",
	  "ryukyu",
	  "sa",
	  "saarland",
	  "safe",
	  "safety",
	  "sakura",
	  "sale",
	  "salon",
	  "samsclub",
	  "samsung",
	  "sandvik",
	  "sandvikcoromant",
	  "sanofi",
	  "sap",
	  "sapo",
	  "sarl",
	  "sas",
	  "save",
	  "saxo",
	  "sb",
	  "sbi",
	  "sbs",
	  "sc",
	  "sca",
	  "scb",
	  "schaeffler",
	  "schmidt",
	  "scholarships",
	  "school",
	  "schule",
	  "schwarz",
	  "science",
	  "scjohnson",
	  "scor",
	  "scot",
	  "sd",
	  "se",
	  "seat",
	  "secure",
	  "security",
	  "seek",
	  "select",
	  "sener",
	  "services",
	  "ses",
	  "seven",
	  "sew",
	  "sex",
	  "sexy",
	  "sfr",
	  "sg",
	  "sh",
	  "shangrila",
	  "sharp",
	  "shaw",
	  "shell",
	  "shia",
	  "shiksha",
	  "shoes",
	  "shop",
	  "shopping",
	  "shouji",
	  "show",
	  "showtime",
	  "shriram",
	  "si",
	  "silk",
	  "sina",
	  "singles",
	  "site",
	  "sj",
	  "sk",
	  "ski",
	  "skin",
	  "sky",
	  "skype",
	  "sl",
	  "sling",
	  "sm",
	  "smart",
	  "smile",
	  "sn",
	  "sncf",
	  "so",
	  "soccer",
	  "social",
	  "softbank",
	  "software",
	  "sohu",
	  "solar",
	  "solutions",
	  "song",
	  "sony",
	  "soy",
	  "space",
	  "spiegel",
	  "spot",
	  "spreadbetting",
	  "sr",
	  "srl",
	  "srt",
	  "st",
	  "stada",
	  "staples",
	  "star",
	  "starhub",
	  "statebank",
	  "statefarm",
	  "statoil",
	  "stc",
	  "stcgroup",
	  "stockholm",
	  "storage",
	  "store",
	  "stream",
	  "studio",
	  "study",
	  "style",
	  "su",
	  "sucks",
	  "supplies",
	  "supply",
	  "support",
	  "surf",
	  "surgery",
	  "suzuki",
	  "sv",
	  "swatch",
	  "swiftcover",
	  "swiss",
	  "sx",
	  "sy",
	  "sydney",
	  "symantec",
	  "systems",
	  "sz",
	  "tab",
	  "taipei",
	  "talk",
	  "taobao",
	  "target",
	  "tatamotors",
	  "tatar",
	  "tattoo",
	  "tax",
	  "taxi",
	  "tc",
	  "tci",
	  "td",
	  "tdk",
	  "team",
	  "tech",
	  "technology",
	  "tel",
	  "telecity",
	  "telefonica",
	  "temasek",
	  "tennis",
	  "teva",
	  "tf",
	  "tg",
	  "th",
	  "thd",
	  "theater",
	  "theatre",
	  "tiaa",
	  "tickets",
	  "tienda",
	  "tiffany",
	  "tips",
	  "tires",
	  "tirol",
	  "tj",
	  "tjmaxx",
	  "tjx",
	  "tk",
	  "tkmaxx",
	  "tl",
	  "tm",
	  "tmall",
	  "tn",
	  "to",
	  "today",
	  "tokyo",
	  "tools",
	  "top",
	  "toray",
	  "toshiba",
	  "total",
	  "tours",
	  "town",
	  "toyota",
	  "toys",
	  "tr",
	  "trade",
	  "trading",
	  "training",
	  "travel",
	  "travelchannel",
	  "travelers",
	  "travelersinsurance",
	  "trust",
	  "trv",
	  "tt",
	  "tube",
	  "tui",
	  "tunes",
	  "tushu",
	  "tv",
	  "tvs",
	  "tw",
	  "tz",
	  "ua",
	  "ubank",
	  "ubs",
	  "uconnect",
	  "ug",
	  "uk",
	  "unicom",
	  "university",
	  "uno",
	  "uol",
	  "ups",
	  "us",
	  "uy",
	  "uz",
	  "va",
	  "vacations",
	  "vana",
	  "vanguard",
	  "vc",
	  "ve",
	  "vegas",
	  "ventures",
	  "verisign",
	  "versicherung",
	  "vet",
	  "vg",
	  "vi",
	  "viajes",
	  "video",
	  "vig",
	  "viking",
	  "villas",
	  "vin",
	  "vip",
	  "virgin",
	  "visa",
	  "vision",
	  "vista",
	  "vistaprint",
	  "viva",
	  "vivo",
	  "vlaanderen",
	  "vn",
	  "vodka",
	  "volkswagen",
	  "vote",
	  "voting",
	  "voto",
	  "voyage",
	  "vu",
	  "vuelos",
	  "wales",
	  "walmart",
	  "walter",
	  "wang",
	  "wanggou",
	  "warman",
	  "watch",
	  "watches",
	  "weather",
	  "weatherchannel",
	  "webcam",
	  "weber",
	  "website",
	  "wed",
	  "wedding",
	  "weibo",
	  "weir",
	  "wf",
	  "whoswho",
	  "wien",
	  "wiki",
	  "williamhill",
	  "win",
	  "windows",
	  "wine",
	  "winners",
	  "wme",
	  "wolterskluwer",
	  "woodside",
	  "work",
	  "works",
	  "world",
	  "ws",
	  "wtc",
	  "wtf",
	  "xbox",
	  "xerox",
	  "xfinity",
	  "xihuan",
	  "xin",
	  "कॉम", // xn--11b4c3d
	  "セール", // xn--1ck2e1b
	  "佛山", // xn--1qqw23a
	  "慈善", // xn--30rr7y
	  "集团", // xn--3bst00m
	  "在线", // xn--3ds443g
	  "한국", // xn--3e0b707e
	  "大众汽车", // xn--3oq18vl8pn36a
	  "点看", // xn--3pxu8k
	  "คอม", // xn--42c2d9a
	  "ভারত", // xn--45brj9c
	  "八卦", // xn--45q11c
	  "موقع", // xn--4gbrim
	  "公益", // xn--55qw42g
	  "公司", // xn--55qx5d
	  "香格里拉", // xn--5su34j936bgsg
	  "网站", // xn--5tzm5g
	  "移动", // xn--6frz82g
	  "我爱你", // xn--6qq986b3xl
	  "москва", // xn--80adxhks
	  "қаз", // xn--80ao21a
	  "онлайн", // xn--80asehdb
	  "сайт", // xn--80aswg
	  "联通", // xn--8y0a063a
	  "срб", // xn--90a3ac
	  "бг", // xn--90ae
	  "бел", // xn--90ais
	  "קום", // xn--9dbq2a
	  "时尚", // xn--9et52u
	  "微博", // xn--9krt00a
	  "淡马锡", // xn--b4w605ferd
	  "ファッション", // xn--bck1b9a5dre4c
	  "орг", // xn--c1avg
	  "नेट", // xn--c2br7g
	  "ストア", // xn--cck2b3b
	  "삼성", // xn--cg4bki
	  "சிங்கப்பூர்", // xn--clchc0ea0b2g2a9gcd
	  "商标", // xn--czr694b
	  "商店", // xn--czrs0t
	  "商城", // xn--czru2d
	  "дети", // xn--d1acj3b
	  "мкд", // xn--d1alf
	  "ею", // xn--e1a4c
	  "ポイント", // xn--eckvdtc9d
	  "新闻", // xn--efvy88h
	  "工行", // xn--estv75g
	  "家電", // xn--fct429k
	  "كوم", // xn--fhbei
	  "中文网", // xn--fiq228c5hs
	  "中信", // xn--fiq64b
	  "中国", // xn--fiqs8s
	  "中國", // xn--fiqz9s
	  "娱乐", // xn--fjq720a
	  "谷歌", // xn--flw351e
	  "భారత్", // xn--fpcrj9c3d
	  "ලංකා", // xn--fzc2c9e2c
	  "電訊盈科", // xn--fzys8d69uvgm
	  "购物", // xn--g2xx48c
	  "クラウド", // xn--gckr3f0f
	  "ભારત", // xn--gecrj9c
	  "भारत", // xn--h2brj9c
	  "网店", // xn--hxt814e
	  "संगठन", // xn--i1b6b1a6a2e
	  "餐厅", // xn--imr513n
	  "网络", // xn--io0a7i
	  "ком", // xn--j1aef
	  "укр", // xn--j1amh
	  "香港", // xn--j6w193g
	  "诺基亚", // xn--jlq61u9w7b
	  "食品", // xn--jvr189m
	  "飞利浦", // xn--kcrx77d1x4a
	  "台湾", // xn--kprw13d
	  "台灣", // xn--kpry57d
	  "手表", // xn--kpu716f
	  "手机", // xn--kput3i
	  "мон", // xn--l1acc
	  "الجزائر", // xn--lgbbat1ad8j
	  "عمان", // xn--mgb9awbf
	  "ارامكو", // xn--mgba3a3ejt
	  "ایران", // xn--mgba3a4f16a
	  "العليان", // xn--mgba7c0bbn0a
	  "امارات", // xn--mgbaam7a8h
	  "بازار", // xn--mgbab2bd
	  "الاردن", // xn--mgbayh7gpa
	  "موبايلي", // xn--mgbb9fbpob
	  "بھارت", // xn--mgbbh1a71e
	  "المغرب", // xn--mgbc0a9azcg
	  "ابوظبي", // xn--mgbca7dzdo
	  "السعودية", // xn--mgberp4a5d4ar
	  "سودان", // xn--mgbpl2fh
	  "همراه", // xn--mgbt3dhd
	  "عراق", // xn--mgbtx2b
	  "مليسيا", // xn--mgbx4cd0ab
	  "澳門", // xn--mix891f
	  "닷컴", // xn--mk1bu44c
	  "政府", // xn--mxtq1m
	  "شبكة", // xn--ngbc5azd
	  "بيتك", // xn--ngbe9e0a
	  "გე", // xn--node
	  "机构", // xn--nqv7f
	  "组织机构", // xn--nqv7fs00ema
	  "健康", // xn--nyqy26a
	  "ไทย", // xn--o3cw4h
	  "سورية", // xn--ogbpf8fl
	  "рус", // xn--p1acf
	  "рф", // xn--p1ai
	  "珠宝", // xn--pbt977c
	  "تونس", // xn--pgbs0dh
	  "大拿", // xn--pssy2u
	  "みんな", // xn--q9jyb4c
	  "グーグル", // xn--qcka1pmc
	  "ελ", // xn--qxam
	  "世界", // xn--rhqv96g
	  "書籍", // xn--rovu88b
	  "ਭਾਰਤ", // xn--s9brj9c
	  "网址", // xn--ses554g
	  "닷넷", // xn--t60b56a
	  "コム", // xn--tckwe
	  "游戏", // xn--unup4y
	  "vermögensberater", // xn--vermgensberater-ctb
	  "vermögensberatung", // xn--vermgensberatung-pwb
	  "企业", // xn--vhquv
	  "信息", // xn--vuq861b
	  "嘉里大酒店", // xn--w4r85el8fhu5dnra
	  "嘉里", // xn--w4rs40l
	  "مصر", // xn--wgbh1c
	  "قطر", // xn--wgbl6a
	  "广东", // xn--xhq521b
	  "இலங்கை", // xn--xkc2al3hye2a
	  "இந்தியா", // xn--xkc2dl3a5ee0h
	  "հայ", // xn--y9a3aq
	  "新加坡", // xn--yfro4i67o
	  "فلسطين", // xn--ygbi2ammx
	  "政务", // xn--zfr164b
	  "xperia",
	  "xxx",
	  "xyz",
	  "yachts",
	  "yahoo",
	  "yamaxun",
	  "yandex",
	  "ye",
	  "yodobashi",
	  "yoga",
	  "yokohama",
	  "you",
	  "youtube",
	  "yt",
	  "yun",
	  "za",
	  "zappos",
	  "zara",
	  "zero",
	  "zip",
	  "zippo",
	  "zm",
	  "zone",
	  "zuerich",
	  "zw"
	];


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 803 */
/***/ (function(module, exports) {

	'use strict';
	
	var alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split('')
	  , length = 64
	  , map = {}
	  , seed = 0
	  , i = 0
	  , prev;
	
	/**
	 * Return a string representing the specified number.
	 *
	 * @param {Number} num The number to convert.
	 * @returns {String} The string representation of the number.
	 * @api public
	 */
	function encode(num) {
	  var encoded = '';
	
	  do {
	    encoded = alphabet[num % length] + encoded;
	    num = Math.floor(num / length);
	  } while (num > 0);
	
	  return encoded;
	}
	
	/**
	 * Return the integer value specified by the given string.
	 *
	 * @param {String} str The string to convert.
	 * @returns {Number} The integer value represented by the string.
	 * @api public
	 */
	function decode(str) {
	  var decoded = 0;
	
	  for (i = 0; i < str.length; i++) {
	    decoded = decoded * length + map[str.charAt(i)];
	  }
	
	  return decoded;
	}
	
	/**
	 * Yeast: A tiny growing id generator.
	 *
	 * @returns {String} A unique id.
	 * @api public
	 */
	function yeast() {
	  var now = encode(+new Date());
	
	  if (now !== prev) return seed = 0, prev = now;
	  return now +'.'+ encode(seed++);
	}
	
	//
	// Map each character to its index.
	//
	for (; i < length; i++) map[alphabet[i]] = i;
	
	//
	// Expose the `yeast`, `encode` and `decode` functions.
	//
	yeast.encode = encode;
	yeast.decode = decode;
	module.exports = yeast;


/***/ }),
/* 804 */
/***/ (function(module, exports) {

	module.exports = after
	
	function after(count, callback, err_cb) {
	    var bail = false
	    err_cb = err_cb || noop
	    proxy.count = count
	
	    return (count === 0) ? callback() : proxy
	
	    function proxy(err, result) {
	        if (proxy.count <= 0) {
	            throw new Error('after called too many times')
	        }
	        --proxy.count
	
	        // after first error, rest are passed to err_cb
	        if (err) {
	            bail = true
	            callback(err)
	            // future error callbacks will go to error handler
	            callback = err_cb
	        } else if (proxy.count === 0 && !bail) {
	            callback(null, result)
	        }
	    }
	}
	
	function noop() {}


/***/ }),
/* 805 */
/***/ (function(module, exports) {

	/**
	 * An abstraction for slicing an arraybuffer even when
	 * ArrayBuffer.prototype.slice is not supported
	 *
	 * @api public
	 */
	
	module.exports = function(arraybuffer, start, end) {
	  var bytes = arraybuffer.byteLength;
	  start = start || 0;
	  end = end || bytes;
	
	  if (arraybuffer.slice) { return arraybuffer.slice(start, end); }
	
	  if (start < 0) { start += bytes; }
	  if (end < 0) { end += bytes; }
	  if (end > bytes) { end = bytes; }
	
	  if (start >= bytes || start >= end || bytes === 0) {
	    return new ArrayBuffer(0);
	  }
	
	  var abv = new Uint8Array(arraybuffer);
	  var result = new Uint8Array(end - start);
	  for (var i = start, ii = 0; i < end; i++, ii++) {
	    result[ii] = abv[i];
	  }
	  return result.buffer;
	};


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	// rawAsap provides everything we need except exception management.
	var rawAsap = __webpack_require__(807);
	// RawTasks are recycled to reduce GC churn.
	var freeTasks = [];
	// We queue errors to ensure they are thrown in right order (FIFO).
	// Array-as-queue is good enough here, since we are just dealing with exceptions.
	var pendingErrors = [];
	var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);
	
	function throwFirstError() {
	    if (pendingErrors.length) {
	        throw pendingErrors.shift();
	    }
	}
	
	/**
	 * Calls a task as soon as possible after returning, in its own event, with priority
	 * over other events like animation, reflow, and repaint. An error thrown from an
	 * event will not interrupt, nor even substantially slow down the processing of
	 * other events, but will be rather postponed to a lower priority event.
	 * @param {{call}} task A callable object, typically a function that takes no
	 * arguments.
	 */
	module.exports = asap;
	function asap(task) {
	    var rawTask;
	    if (freeTasks.length) {
	        rawTask = freeTasks.pop();
	    } else {
	        rawTask = new RawTask();
	    }
	    rawTask.task = task;
	    rawAsap(rawTask);
	}
	
	// We wrap tasks with recyclable task objects.  A task object implements
	// `call`, just like a function.
	function RawTask() {
	    this.task = null;
	}
	
	// The sole purpose of wrapping the task is to catch the exception and recycle
	// the task object after its single use.
	RawTask.prototype.call = function () {
	    try {
	        this.task.call();
	    } catch (error) {
	        if (asap.onerror) {
	            // This hook exists purely for testing purposes.
	            // Its name will be periodically randomized to break any code that
	            // depends on its existence.
	            asap.onerror(error);
	        } else {
	            // In a web browser, exceptions are not fatal. However, to avoid
	            // slowing down the queue of pending tasks, we rethrow the error in a
	            // lower priority turn.
	            pendingErrors.push(error);
	            requestErrorThrow();
	        }
	    } finally {
	        this.task = null;
	        freeTasks[freeTasks.length] = this;
	    }
	};


/***/ }),
/* 807 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(78);
	var bind = __webpack_require__(494);
	var Axios = __webpack_require__(810);
	var defaults = __webpack_require__(327);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(491);
	axios.CancelToken = __webpack_require__(809);
	axios.isCancel = __webpack_require__(492);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(824);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(491);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(327);
	var utils = __webpack_require__(78);
	var InterceptorManager = __webpack_require__(811);
	var dispatchRequest = __webpack_require__(812);
	var isAbsoluteURL = __webpack_require__(820);
	var combineURLs = __webpack_require__(818);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(78);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(78);
	var transformData = __webpack_require__(815);
	var isCancel = __webpack_require__(492);
	var defaults = __webpack_require__(327);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ }),
/* 813 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 @ @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.response = response;
	  return error;
	};


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(493);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response
	    ));
	  }
	};


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(78);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ }),
/* 816 */
/***/ (function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(78);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      }
	
	      if (!utils.isArray(val)) {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ }),
/* 818 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '');
	};


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(78);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ }),
/* 820 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(78);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(78);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(78);
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  });
	
	  return parsed;
	};


/***/ }),
/* 824 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(1012);
	
	__webpack_require__(1653);
	
	__webpack_require__(832);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 826 */
/***/ (function(module, exports) {

	
	/**
	 * Expose `Backoff`.
	 */
	
	module.exports = Backoff;
	
	/**
	 * Initialize backoff timer with `opts`.
	 *
	 * - `min` initial timeout in milliseconds [100]
	 * - `max` max timeout [10000]
	 * - `jitter` [0]
	 * - `factor` [2]
	 *
	 * @param {Object} opts
	 * @api public
	 */
	
	function Backoff(opts) {
	  opts = opts || {};
	  this.ms = opts.min || 100;
	  this.max = opts.max || 10000;
	  this.factor = opts.factor || 2;
	  this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
	  this.attempts = 0;
	}
	
	/**
	 * Return the backoff duration.
	 *
	 * @return {Number}
	 * @api public
	 */
	
	Backoff.prototype.duration = function(){
	  var ms = this.ms * Math.pow(this.factor, this.attempts++);
	  if (this.jitter) {
	    var rand =  Math.random();
	    var deviation = Math.floor(rand * this.jitter * ms);
	    ms = (Math.floor(rand * 10) & 1) == 0  ? ms - deviation : ms + deviation;
	  }
	  return Math.min(ms, this.max) | 0;
	};
	
	/**
	 * Reset the number of attempts.
	 *
	 * @api public
	 */
	
	Backoff.prototype.reset = function(){
	  this.attempts = 0;
	};
	
	/**
	 * Set the minimum duration
	 *
	 * @api public
	 */
	
	Backoff.prototype.setMin = function(min){
	  this.ms = min;
	};
	
	/**
	 * Set the maximum duration
	 *
	 * @api public
	 */
	
	Backoff.prototype.setMax = function(max){
	  this.max = max;
	};
	
	/**
	 * Set the jitter
	 *
	 * @api public
	 */
	
	Backoff.prototype.setJitter = function(jitter){
	  this.jitter = jitter;
	};
	


/***/ }),
/* 827 */
/***/ (function(module, exports) {

	/*
	 * base64-arraybuffer
	 * https://github.com/niklasvh/base64-arraybuffer
	 *
	 * Copyright (c) 2012 Niklas von Hertzen
	 * Licensed under the MIT license.
	 */
	(function(){
	  "use strict";
	
	  var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
	
	  // Use a lookup table to find the index.
	  var lookup = new Uint8Array(256);
	  for (var i = 0; i < chars.length; i++) {
	    lookup[chars.charCodeAt(i)] = i;
	  }
	
	  exports.encode = function(arraybuffer) {
	    var bytes = new Uint8Array(arraybuffer),
	    i, len = bytes.length, base64 = "";
	
	    for (i = 0; i < len; i+=3) {
	      base64 += chars[bytes[i] >> 2];
	      base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
	      base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
	      base64 += chars[bytes[i + 2] & 63];
	    }
	
	    if ((len % 3) === 2) {
	      base64 = base64.substring(0, base64.length - 1) + "=";
	    } else if (len % 3 === 1) {
	      base64 = base64.substring(0, base64.length - 2) + "==";
	    }
	
	    return base64;
	  };
	
	  exports.decode =  function(base64) {
	    var bufferLength = base64.length * 0.75,
	    len = base64.length, i, p = 0,
	    encoded1, encoded2, encoded3, encoded4;
	
	    if (base64[base64.length - 1] === "=") {
	      bufferLength--;
	      if (base64[base64.length - 2] === "=") {
	        bufferLength--;
	      }
	    }
	
	    var arraybuffer = new ArrayBuffer(bufferLength),
	    bytes = new Uint8Array(arraybuffer);
	
	    for (i = 0; i < len; i+=4) {
	      encoded1 = lookup[base64.charCodeAt(i)];
	      encoded2 = lookup[base64.charCodeAt(i+1)];
	      encoded3 = lookup[base64.charCodeAt(i+2)];
	      encoded4 = lookup[base64.charCodeAt(i+3)];
	
	      bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
	      bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
	      bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
	    }
	
	    return arraybuffer;
	  };
	})();


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(495);


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	(function() {
	  "use strict";
	
	  var utils = __webpack_require__(496);
	
	  /**
	   * Poly Bezier
	   * @param {[type]} curves [description]
	   */
	  var PolyBezier = function(curves) {
	    this.curves = [];
	    this._3d = false;
	    if(!!curves) {
	      this.curves = curves;
	      this._3d = this.curves[0]._3d;
	    }
	  }
	
	  PolyBezier.prototype = {
	    valueOf: function() {
	      return this.toString();
	    },
	    toString: function() {
	      return "[" + this.curves.map(function(curve) {
	        return utils.pointsToString(curve.points);
	      }).join(", ") + "]";
	    },
	    addCurve: function(curve) {
	      this.curves.push(curve);
	      this._3d = this._3d || curve._3d;
	    },
	    length: function() {
	      return this.curves.map(function(v) { return v.length(); }).reduce(function(a,b) { return a+b; });
	    },
	    curve: function(idx) {
	      return this.curves[idx];
	    },
	    bbox: function() {
	      var c = this.curves;
	      var bbox = c[0].bbox();
	      for(var i=1; i<c.length; i++) {
	        utils.expandbox(bbox, c[i].bbox());
	      }
	      return bbox;
	    },
	    offset: function(d) {
	      var offset = [];
	      this.curves.forEach(function(v) {
	        offset = offset.concat(v.offset(d));
	      });
	      return new PolyBezier(offset);
	    }
	  };
	
	  module.exports = PolyBezier;
	}());


/***/ }),
/* 830 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Create a blob builder even when vendor prefixes exist
	 */
	
	var BlobBuilder = global.BlobBuilder
	  || global.WebKitBlobBuilder
	  || global.MSBlobBuilder
	  || global.MozBlobBuilder;
	
	/**
	 * Check if Blob constructor is supported
	 */
	
	var blobSupported = (function() {
	  try {
	    var a = new Blob(['hi']);
	    return a.size === 2;
	  } catch(e) {
	    return false;
	  }
	})();
	
	/**
	 * Check if Blob constructor supports ArrayBufferViews
	 * Fails in Safari 6, so we need to map to ArrayBuffers there.
	 */
	
	var blobSupportsArrayBufferView = blobSupported && (function() {
	  try {
	    var b = new Blob([new Uint8Array([1,2])]);
	    return b.size === 2;
	  } catch(e) {
	    return false;
	  }
	})();
	
	/**
	 * Check if BlobBuilder is supported
	 */
	
	var blobBuilderSupported = BlobBuilder
	  && BlobBuilder.prototype.append
	  && BlobBuilder.prototype.getBlob;
	
	/**
	 * Helper function that maps ArrayBufferViews to ArrayBuffers
	 * Used by BlobBuilder constructor and old browsers that didn't
	 * support it in the Blob constructor.
	 */
	
	function mapArrayBufferViews(ary) {
	  for (var i = 0; i < ary.length; i++) {
	    var chunk = ary[i];
	    if (chunk.buffer instanceof ArrayBuffer) {
	      var buf = chunk.buffer;
	
	      // if this is a subarray, make a copy so we only
	      // include the subarray region from the underlying buffer
	      if (chunk.byteLength !== buf.byteLength) {
	        var copy = new Uint8Array(chunk.byteLength);
	        copy.set(new Uint8Array(buf, chunk.byteOffset, chunk.byteLength));
	        buf = copy.buffer;
	      }
	
	      ary[i] = buf;
	    }
	  }
	}
	
	function BlobBuilderConstructor(ary, options) {
	  options = options || {};
	
	  var bb = new BlobBuilder();
	  mapArrayBufferViews(ary);
	
	  for (var i = 0; i < ary.length; i++) {
	    bb.append(ary[i]);
	  }
	
	  return (options.type) ? bb.getBlob(options.type) : bb.getBlob();
	};
	
	function BlobConstructor(ary, options) {
	  mapArrayBufferViews(ary);
	  return new Blob(ary, options || {});
	};
	
	module.exports = (function() {
	  if (blobSupported) {
	    return blobSupportsArrayBufferView ? global.Blob : BlobConstructor;
	  } else if (blobBuilderSupported) {
	    return BlobBuilderConstructor;
	  } else {
	    return undefined;
	  }
	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 831 */
/***/ (function(module, exports) {

	
	module.exports = function chain(){
	  var len = arguments.length
	  var args = [];
	
	  for (var i = 0; i < len; i++)
	    args[i] = arguments[i]
	
	  args = args.filter(function(fn){ return fn != null })
	
	  if (args.length === 0) return undefined
	  if (args.length === 1) return args[0]
	
	  return args.reduce(function(current, next){
	    return function chainedFunction() {
	      current.apply(this, arguments);
	      next.apply(this, arguments);
	    };
	  })
	}


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(841);
	module.exports = __webpack_require__(112).RegExp.escape;

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(25)
	  , isArray  = __webpack_require__(336)
	  , SPECIES  = __webpack_require__(29)('species');
	
	module.exports = function(original){
	  var C;
	  if(isArray(original)){
	    C = original.constructor;
	    // cross-realm fallback
	    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
	    if(isObject(C)){
	      C = C[SPECIES];
	      if(C === null)C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(833);
	
	module.exports = function(original, length){
	  return new (speciesConstructor(original))(length);
	};

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var anObject    = __webpack_require__(14)
	  , toPrimitive = __webpack_require__(99)
	  , NUMBER      = 'number';
	
	module.exports = function(hint){
	  if(hint !== 'string' && hint !== NUMBER && hint !== 'default')throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(153)
	  , gOPS    = __webpack_require__(256)
	  , pIE     = __webpack_require__(212);
	module.exports = function(it){
	  var result     = getKeys(it)
	    , getSymbols = gOPS.f;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = pIE.f
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
	  } return result;
	};

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(153)
	  , toIObject = __webpack_require__(71);
	module.exports = function(object, el){
	  var O      = toIObject(object)
	    , keys   = getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var path      = __webpack_require__(839)
	  , invoke    = __webpack_require__(252)
	  , aFunction = __webpack_require__(67);
	module.exports = function(/* ...pargs */){
	  var fn     = aFunction(this)
	    , length = arguments.length
	    , pargs  = Array(length)
	    , i      = 0
	    , _      = path._
	    , holder = false;
	  while(length > i)if((pargs[i] = arguments[i++]) === _)holder = true;
	  return function(/* ...args */){
	    var that = this
	      , aLen = arguments.length
	      , j = 0, k = 0, args;
	    if(!holder && !aLen)return invoke(fn, pargs, that);
	    args = pargs.slice();
	    if(holder)for(;length > j; j++)if(args[j] === _)args[j] = arguments[k++];
	    while(aLen > k)args.push(arguments[k++]);
	    return invoke(fn, args, that);
	  };
	};

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(15);

/***/ }),
/* 840 */
/***/ (function(module, exports) {

	module.exports = function(regExp, replace){
	  var replacer = replace === Object(replace) ? function(part){
	    return replace[part];
	  } : replace;
	  return function(it){
	    return String(it).replace(regExp, replacer);
	  };
	};

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(5)
	  , $re     = __webpack_require__(840)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', {escape: function escape(it){ return $re(it); }});


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(5);
	
	$export($export.P, 'Array', {copyWithin: __webpack_require__(500)});
	
	__webpack_require__(177)('copyWithin');

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5)
	  , $every  = __webpack_require__(97)(4);
	
	$export($export.P + $export.F * !__webpack_require__(93)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */){
	    return $every(this, callbackfn, arguments[1]);
	  }
	});

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(5);
	
	$export($export.P, 'Array', {fill: __webpack_require__(328)});
	
	__webpack_require__(177)('fill');

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5)
	  , $filter = __webpack_require__(97)(2);
	
	$export($export.P + $export.F * !__webpack_require__(93)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */){
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(5)
	  , $find   = __webpack_require__(97)(6)
	  , KEY     = 'findIndex'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(177)(KEY);

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(5)
	  , $find   = __webpack_require__(97)(5)
	  , KEY     = 'find'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(177)(KEY);

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export  = __webpack_require__(5)
	  , $forEach = __webpack_require__(97)(0)
	  , STRICT   = __webpack_require__(93)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */){
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx            = __webpack_require__(113)
	  , $export        = __webpack_require__(5)
	  , toObject       = __webpack_require__(51)
	  , call           = __webpack_require__(509)
	  , isArrayIter    = __webpack_require__(335)
	  , toLength       = __webpack_require__(44)
	  , createProperty = __webpack_require__(329)
	  , getIterFn      = __webpack_require__(352);
	
	$export($export.S + $export.F * !__webpack_require__(254)(function(iter){ Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
	    var O       = toObject(arrayLike)
	      , C       = typeof this == 'function' ? this : Array
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , index   = 0
	      , iterFn  = getIterFn(O)
	      , length, result, step, iterator;
	    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
	      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for(result = new C(length); length > index; index++){
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export       = __webpack_require__(5)
	  , $indexOf      = __webpack_require__(248)(false)
	  , $native       = [].indexOf
	  , NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(93)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /*, fromIndex = 0 */){
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Array', {isArray: __webpack_require__(336)});

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export   = __webpack_require__(5)
	  , toIObject = __webpack_require__(71)
	  , arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(211) != Object || !__webpack_require__(93)(arrayJoin)), 'Array', {
	  join: function join(separator){
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export       = __webpack_require__(5)
	  , toIObject     = __webpack_require__(71)
	  , toInteger     = __webpack_require__(132)
	  , toLength      = __webpack_require__(44)
	  , $native       = [].lastIndexOf
	  , NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(93)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /*, fromIndex = @[*-1] */){
	    // convert -0 to +0
	    if(NEGATIVE_ZERO)return $native.apply(this, arguments) || 0;
	    var O      = toIObject(this)
	      , length = toLength(O.length)
	      , index  = length - 1;
	    if(arguments.length > 1)index = Math.min(index, toInteger(arguments[1]));
	    if(index < 0)index = length + index;
	    for(;index >= 0; index--)if(index in O)if(O[index] === searchElement)return index || 0;
	    return -1;
	  }
	});

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5)
	  , $map    = __webpack_require__(97)(1);
	
	$export($export.P + $export.F * !__webpack_require__(93)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */){
	    return $map(this, callbackfn, arguments[1]);
	  }
	});

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export        = __webpack_require__(5)
	  , createProperty = __webpack_require__(329);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(19)(function(){
	  function F(){}
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */){
	    var index  = 0
	      , aLen   = arguments.length
	      , result = new (typeof this == 'function' ? this : Array)(aLen);
	    while(aLen > index)createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5)
	  , $reduce = __webpack_require__(502);
	
	$export($export.P + $export.F * !__webpack_require__(93)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */){
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5)
	  , $reduce = __webpack_require__(502);
	
	$export($export.P + $export.F * !__webpack_require__(93)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */){
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export    = __webpack_require__(5)
	  , html       = __webpack_require__(333)
	  , cof        = __webpack_require__(91)
	  , toIndex    = __webpack_require__(156)
	  , toLength   = __webpack_require__(44)
	  , arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(19)(function(){
	  if(html)arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end){
	    var len   = toLength(this.length)
	      , klass = cof(this);
	    end = end === undefined ? len : end;
	    if(klass == 'Array')return arraySlice.call(this, begin, end);
	    var start  = toIndex(begin, len)
	      , upTo   = toIndex(end, len)
	      , size   = toLength(upTo - start)
	      , cloned = Array(size)
	      , i      = 0;
	    for(; i < size; i++)cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5)
	  , $some   = __webpack_require__(97)(3);
	
	$export($export.P + $export.F * !__webpack_require__(93)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */){
	    return $some(this, callbackfn, arguments[1]);
	  }
	});

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export   = __webpack_require__(5)
	  , aFunction = __webpack_require__(67)
	  , toObject  = __webpack_require__(51)
	  , fails     = __webpack_require__(19)
	  , $sort     = [].sort
	  , test      = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function(){
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function(){
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(93)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn){
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(155)('Array');

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Date', {now: function(){ return new Date().getTime(); }});

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(5)
	  , fails   = __webpack_require__(19)
	  , getTime = Date.prototype.getTime;
	
	var lz = function(num){
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (fails(function(){
	  return new Date(-5e13 - 1).toISOString() != '0385-07-25T07:06:39.999Z';
	}) || !fails(function(){
	  new Date(NaN).toISOString();
	})), 'Date', {
	  toISOString: function toISOString(){
	    if(!isFinite(getTime.call(this)))throw RangeError('Invalid time value');
	    var d = this
	      , y = d.getUTCFullYear()
	      , m = d.getUTCMilliseconds()
	      , s = y < 0 ? '-' : y > 9999 ? '+' : '';
	    return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	      '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	      'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	      ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	  }
	});

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export     = __webpack_require__(5)
	  , toObject    = __webpack_require__(51)
	  , toPrimitive = __webpack_require__(99);
	
	$export($export.P + $export.F * __webpack_require__(19)(function(){
	  return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({toISOString: function(){ return 1; }}) !== 1;
	}), 'Date', {
	  toJSON: function toJSON(key){
	    var O  = toObject(this)
	      , pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(29)('toPrimitive')
	  , proto        = Date.prototype;
	
	if(!(TO_PRIMITIVE in proto))__webpack_require__(68)(proto, TO_PRIMITIVE, __webpack_require__(835));

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	var DateProto    = Date.prototype
	  , INVALID_DATE = 'Invalid Date'
	  , TO_STRING    = 'toString'
	  , $toString    = DateProto[TO_STRING]
	  , getTime      = DateProto.getTime;
	if(new Date(NaN) + '' != INVALID_DATE){
	  __webpack_require__(69)(DateProto, TO_STRING, function toString(){
	    var value = getTime.call(this);
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(5);
	
	$export($export.P, 'Function', {bind: __webpack_require__(503)});

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isObject       = __webpack_require__(25)
	  , getPrototypeOf = __webpack_require__(80)
	  , HAS_INSTANCE   = __webpack_require__(29)('hasInstance')
	  , FunctionProto  = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if(!(HAS_INSTANCE in FunctionProto))__webpack_require__(38).f(FunctionProto, HAS_INSTANCE, {value: function(O){
	  if(typeof this != 'function' || !isObject(O))return false;
	  if(!isObject(this.prototype))return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while(O = getPrototypeOf(O))if(this.prototype === O)return true;
	  return false;
	}});

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(38).f
	  , createDesc = __webpack_require__(131)
	  , has        = __webpack_require__(62)
	  , FProto     = Function.prototype
	  , nameRE     = /^\s*function ([^ (]*)/
	  , NAME       = 'name';
	
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(37) && dP(FProto, NAME, {
	  configurable: true,
	  get: function(){
	    try {
	      var that = this
	        , name = ('' + that).match(nameRE)[1];
	      has(that, NAME) || !isExtensible(that) || dP(that, NAME, createDesc(5, name));
	      return name;
	    } catch(e){
	      return '';
	    }
	  }
	});

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(5)
	  , log1p   = __webpack_require__(511)
	  , sqrt    = Math.sqrt
	  , $acosh  = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN 
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x){
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(5)
	  , $asinh  = Math.asinh;
	
	function asinh(x){
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0 
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', {asinh: asinh});

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(5)
	  , $atanh  = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0 
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x){
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(5)
	  , sign    = __webpack_require__(340);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x){
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x){
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(5)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x){
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(5)
	  , $expm1  = __webpack_require__(339);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', {expm1: $expm1});

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export   = __webpack_require__(5)
	  , sign      = __webpack_require__(340)
	  , pow       = Math.pow
	  , EPSILON   = pow(2, -52)
	  , EPSILON32 = pow(2, -23)
	  , MAX32     = pow(2, 127) * (2 - EPSILON32)
	  , MIN32     = pow(2, -126);
	
	var roundTiesToEven = function(n){
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	
	$export($export.S, 'Math', {
	  fround: function fround(x){
	    var $abs  = Math.abs(x)
	      , $sign = sign(x)
	      , a, result;
	    if($abs < MIN32)return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	    a = (1 + EPSILON32 / EPSILON) * $abs;
	    result = a - (a - $abs);
	    if(result > MAX32 || result != result)return $sign * Infinity;
	    return $sign * result;
	  }
	});

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(5)
	  , abs     = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2){ // eslint-disable-line no-unused-vars
	    var sum  = 0
	      , i    = 0
	      , aLen = arguments.length
	      , larg = 0
	      , arg, div;
	    while(i < aLen){
	      arg = abs(arguments[i++]);
	      if(larg < arg){
	        div  = larg / arg;
	        sum  = sum * div * div + 1;
	        larg = arg;
	      } else if(arg > 0){
	        div  = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(5)
	  , $imul   = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(19)(function(){
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y){
	    var UINT16 = 0xffff
	      , xn = +x
	      , yn = +y
	      , xl = UINT16 & xn
	      , yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', {
	  log10: function log10(x){
	    return Math.log(x) / Math.LN10;
	  }
	});

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', {log1p: __webpack_require__(511)});

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', {
	  log2: function log2(x){
	    return Math.log(x) / Math.LN2;
	  }
	});

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', {sign: __webpack_require__(340)});

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(5)
	  , expm1   = __webpack_require__(339)
	  , exp     = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(19)(function(){
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x){
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(5)
	  , expm1   = __webpack_require__(339)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x){
	    var a = expm1(x = +x)
	      , b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it){
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global            = __webpack_require__(15)
	  , has               = __webpack_require__(62)
	  , cof               = __webpack_require__(91)
	  , inheritIfRequired = __webpack_require__(334)
	  , toPrimitive       = __webpack_require__(99)
	  , fails             = __webpack_require__(19)
	  , gOPN              = __webpack_require__(152).f
	  , gOPD              = __webpack_require__(79).f
	  , dP                = __webpack_require__(38).f
	  , $trim             = __webpack_require__(181).trim
	  , NUMBER            = 'Number'
	  , $Number           = global[NUMBER]
	  , Base              = $Number
	  , proto             = $Number.prototype
	  // Opera ~12 has broken Object#toString
	  , BROKEN_COF        = cof(__webpack_require__(151)(proto)) == NUMBER
	  , TRIM              = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function(argument){
	  var it = toPrimitive(argument, false);
	  if(typeof it == 'string' && it.length > 2){
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0)
	      , third, radix, maxCode;
	    if(first === 43 || first === 45){
	      third = it.charCodeAt(2);
	      if(third === 88 || third === 120)return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if(first === 48){
	      switch(it.charCodeAt(1)){
	        case 66 : case 98  : radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79 : case 111 : radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default : return +it;
	      }
	      for(var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++){
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if(code < 48 || code > maxCode)return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if(!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')){
	  $Number = function Number(value){
	    var it = arguments.length < 1 ? 0 : value
	      , that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function(){ proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for(var keys = __webpack_require__(37) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++){
	    if(has(Base, key = keys[j]) && !has($Number, key)){
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(69)(global, NUMBER, $Number);
	}

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Number', {EPSILON: Math.pow(2, -52)});

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export   = __webpack_require__(5)
	  , _isFinite = __webpack_require__(15).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it){
	    return typeof it == 'number' && _isFinite(it);
	  }
	});

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Number', {isInteger: __webpack_require__(508)});

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number){
	    return number != number;
	  }
	});

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export   = __webpack_require__(5)
	  , isInteger = __webpack_require__(508)
	  , abs       = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number){
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Number', {MAX_SAFE_INTEGER: 0x1fffffffffffff});

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Number', {MIN_SAFE_INTEGER: -0x1fffffffffffff});

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	var $export     = __webpack_require__(5)
	  , $parseFloat = __webpack_require__(518);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', {parseFloat: $parseFloat});

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(5)
	  , $parseInt = __webpack_require__(519);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', {parseInt: $parseInt});

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(5)
	  , toInteger    = __webpack_require__(132)
	  , aNumberValue = __webpack_require__(499)
	  , repeat       = __webpack_require__(347)
	  , $toFixed     = 1..toFixed
	  , floor        = Math.floor
	  , data         = [0, 0, 0, 0, 0, 0]
	  , ERROR        = 'Number.toFixed: incorrect invocation!'
	  , ZERO         = '0';
	
	var multiply = function(n, c){
	  var i  = -1
	    , c2 = c;
	  while(++i < 6){
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function(n){
	  var i = 6
	    , c = 0;
	  while(--i >= 0){
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function(){
	  var i = 6
	    , s = '';
	  while(--i >= 0){
	    if(s !== '' || i === 0 || data[i] !== 0){
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function(x, n, acc){
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function(x){
	  var n  = 0
	    , x2 = x;
	  while(x2 >= 4096){
	    n += 12;
	    x2 /= 4096;
	  }
	  while(x2 >= 2){
	    n  += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128..toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(19)(function(){
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits){
	    var x = aNumberValue(this, ERROR)
	      , f = toInteger(fractionDigits)
	      , s = ''
	      , m = ZERO
	      , e, z, j, k;
	    if(f < 0 || f > 20)throw RangeError(ERROR);
	    if(x != x)return 'NaN';
	    if(x <= -1e21 || x >= 1e21)return String(x);
	    if(x < 0){
	      s = '-';
	      x = -x;
	    }
	    if(x > 1e-21){
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if(e > 0){
	        multiply(0, z);
	        j = f;
	        while(j >= 7){
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while(j >= 23){
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if(f > 0){
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(5)
	  , $fails       = __webpack_require__(19)
	  , aNumberValue = __webpack_require__(499)
	  , $toPrecision = 1..toPrecision;
	
	$export($export.P + $export.F * ($fails(function(){
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function(){
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision){
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision); 
	  }
	});

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(5);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(512)});

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(5)
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', {create: __webpack_require__(151)});

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(5);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(37), 'Object', {defineProperties: __webpack_require__(513)});

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(5);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(37), 'Object', {defineProperty: __webpack_require__(38).f});

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(25)
	  , meta     = __webpack_require__(130).onFreeze;
	
	__webpack_require__(98)('freeze', function($freeze){
	  return function freeze(it){
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject                 = __webpack_require__(71)
	  , $getOwnPropertyDescriptor = __webpack_require__(79).f;
	
	__webpack_require__(98)('getOwnPropertyDescriptor', function(){
	  return function getOwnPropertyDescriptor(it, key){
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(98)('getOwnPropertyNames', function(){
	  return __webpack_require__(514).f;
	});

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject        = __webpack_require__(51)
	  , $getPrototypeOf = __webpack_require__(80);
	
	__webpack_require__(98)('getPrototypeOf', function(){
	  return function getPrototypeOf(it){
	    return $getPrototypeOf(toObject(it));
	  };
	});

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(25);
	
	__webpack_require__(98)('isExtensible', function($isExtensible){
	  return function isExtensible(it){
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(25);
	
	__webpack_require__(98)('isFrozen', function($isFrozen){
	  return function isFrozen(it){
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(25);
	
	__webpack_require__(98)('isSealed', function($isSealed){
	  return function isSealed(it){
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(5);
	$export($export.S, 'Object', {is: __webpack_require__(520)});

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(51)
	  , $keys    = __webpack_require__(153);
	
	__webpack_require__(98)('keys', function(){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(25)
	  , meta     = __webpack_require__(130).onFreeze;
	
	__webpack_require__(98)('preventExtensions', function($preventExtensions){
	  return function preventExtensions(it){
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(25)
	  , meta     = __webpack_require__(130).onFreeze;
	
	__webpack_require__(98)('seal', function($seal){
	  return function seal(it){
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(5);
	$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(342).set});

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(210)
	  , test    = {};
	test[__webpack_require__(29)('toStringTag')] = 'z';
	if(test + '' != '[object z]'){
	  __webpack_require__(69)(Object.prototype, 'toString', function toString(){
	    return '[object ' + classof(this) + ']';
	  }, true);
	}

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

	var $export     = __webpack_require__(5)
	  , $parseFloat = __webpack_require__(518);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), {parseFloat: $parseFloat});

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(5)
	  , $parseInt = __webpack_require__(519);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), {parseInt: $parseInt});

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY            = __webpack_require__(150)
	  , global             = __webpack_require__(15)
	  , ctx                = __webpack_require__(113)
	  , classof            = __webpack_require__(210)
	  , $export            = __webpack_require__(5)
	  , isObject           = __webpack_require__(25)
	  , aFunction          = __webpack_require__(67)
	  , anInstance         = __webpack_require__(149)
	  , forOf              = __webpack_require__(178)
	  , speciesConstructor = __webpack_require__(344)
	  , task               = __webpack_require__(349).set
	  , microtask          = __webpack_require__(341)()
	  , PROMISE            = 'Promise'
	  , TypeError          = global.TypeError
	  , process            = global.process
	  , $Promise           = global[PROMISE]
	  , process            = global.process
	  , isNode             = classof(process) == 'process'
	  , empty              = function(){ /* empty */ }
	  , Internal, GenericPromiseCapability, Wrapper;
	
	var USE_NATIVE = !!function(){
	  try {
	    // correct subclassing with @@species support
	    var promise     = $Promise.resolve(1)
	      , FakePromise = (promise.constructor = {})[__webpack_require__(29)('species')] = function(exec){ exec(empty, empty); };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch(e){ /* empty */ }
	}();
	
	// helpers
	var sameConstructor = function(a, b){
	  // with library wrapper special case
	  return a === b || a === $Promise && b === Wrapper;
	};
	var isThenable = function(it){
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var newPromiseCapability = function(C){
	  return sameConstructor($Promise, C)
	    ? new PromiseCapability(C)
	    : new GenericPromiseCapability(C);
	};
	var PromiseCapability = GenericPromiseCapability = function(C){
	  var resolve, reject;
	  this.promise = new C(function($$resolve, $$reject){
	    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject  = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject  = aFunction(reject);
	};
	var perform = function(exec){
	  try {
	    exec();
	  } catch(e){
	    return {error: e};
	  }
	};
	var notify = function(promise, isReject){
	  if(promise._n)return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function(){
	    var value = promise._v
	      , ok    = promise._s == 1
	      , i     = 0;
	    var run = function(reaction){
	      var handler = ok ? reaction.ok : reaction.fail
	        , resolve = reaction.resolve
	        , reject  = reaction.reject
	        , domain  = reaction.domain
	        , result, then;
	      try {
	        if(handler){
	          if(!ok){
	            if(promise._h == 2)onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if(handler === true)result = value;
	          else {
	            if(domain)domain.enter();
	            result = handler(value);
	            if(domain)domain.exit();
	          }
	          if(result === reaction.promise){
	            reject(TypeError('Promise-chain cycle'));
	          } else if(then = isThenable(result)){
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch(e){
	        reject(e);
	      }
	    };
	    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if(isReject && !promise._h)onUnhandled(promise);
	  });
	};
	var onUnhandled = function(promise){
	  task.call(global, function(){
	    var value = promise._v
	      , abrupt, handler, console;
	    if(isUnhandled(promise)){
	      abrupt = perform(function(){
	        if(isNode){
	          process.emit('unhandledRejection', value, promise);
	        } else if(handler = global.onunhandledrejection){
	          handler({promise: promise, reason: value});
	        } else if((console = global.console) && console.error){
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if(abrupt)throw abrupt.error;
	  });
	};
	var isUnhandled = function(promise){
	  if(promise._h == 1)return false;
	  var chain = promise._a || promise._c
	    , i     = 0
	    , reaction;
	  while(chain.length > i){
	    reaction = chain[i++];
	    if(reaction.fail || !isUnhandled(reaction.promise))return false;
	  } return true;
	};
	var onHandleUnhandled = function(promise){
	  task.call(global, function(){
	    var handler;
	    if(isNode){
	      process.emit('rejectionHandled', promise);
	    } else if(handler = global.onrejectionhandled){
	      handler({promise: promise, reason: promise._v});
	    }
	  });
	};
	var $reject = function(value){
	  var promise = this;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if(!promise._a)promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function(value){
	  var promise = this
	    , then;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if(promise === value)throw TypeError("Promise can't be resolved itself");
	    if(then = isThenable(value)){
	      microtask(function(){
	        var wrapper = {_w: promise, _d: false}; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch(e){
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch(e){
	    $reject.call({_w: promise, _d: false}, e); // wrap
	  }
	};
	
	// constructor polyfill
	if(!USE_NATIVE){
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor){
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch(err){
	      $reject.call(this, err);
	    }
	  };
	  Internal = function Promise(executor){
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(154)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected){
	      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail   = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if(this._a)this._a.push(reaction);
	      if(this._s)notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function(onRejected){
	      return this.then(undefined, onRejected);
	    }
	  });
	  PromiseCapability = function(){
	    var promise  = new Internal;
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject  = ctx($reject, promise, 1);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
	__webpack_require__(180)($Promise, PROMISE);
	__webpack_require__(155)(PROMISE);
	Wrapper = __webpack_require__(112)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r){
	    var capability = newPromiseCapability(this)
	      , $$reject   = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x){
	    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
	    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
	    var capability = newPromiseCapability(this)
	      , $$resolve  = capability.resolve;
	    $$resolve(x);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(254)(function(iter){
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , resolve    = capability.resolve
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      var values    = []
	        , index     = 0
	        , remaining = 1;
	      forOf(iterable, false, function(promise){
	        var $index        = index++
	          , alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function(value){
	          if(alreadyCalled)return;
	          alreadyCalled  = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      forOf(iterable, false, function(promise){
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  }
	});

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export   = __webpack_require__(5)
	  , aFunction = __webpack_require__(67)
	  , anObject  = __webpack_require__(14)
	  , rApply    = (__webpack_require__(15).Reflect || {}).apply
	  , fApply    = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(19)(function(){
	  rApply(function(){});
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList){
	    var T = aFunction(target)
	      , L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export    = __webpack_require__(5)
	  , create     = __webpack_require__(151)
	  , aFunction  = __webpack_require__(67)
	  , anObject   = __webpack_require__(14)
	  , isObject   = __webpack_require__(25)
	  , fails      = __webpack_require__(19)
	  , bind       = __webpack_require__(503)
	  , rConstruct = (__webpack_require__(15).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function(){
	  function F(){}
	  return !(rConstruct(function(){}, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function(){
	  rConstruct(function(){});
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /*, newTarget*/){
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if(ARGS_BUG && !NEW_TARGET_BUG)return rConstruct(Target, args, newTarget);
	    if(Target == newTarget){
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch(args.length){
	        case 0: return new Target;
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args));
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto    = newTarget.prototype
	      , instance = create(isObject(proto) ? proto : Object.prototype)
	      , result   = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP          = __webpack_require__(38)
	  , $export     = __webpack_require__(5)
	  , anObject    = __webpack_require__(14)
	  , toPrimitive = __webpack_require__(99);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(19)(function(){
	  Reflect.defineProperty(dP.f({}, 1, {value: 1}), 1, {value: 2});
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes){
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export  = __webpack_require__(5)
	  , gOPD     = __webpack_require__(79).f
	  , anObject = __webpack_require__(14);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey){
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export  = __webpack_require__(5)
	  , anObject = __webpack_require__(14);
	var Enumerate = function(iterated){
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = []       // keys
	    , key;
	  for(key in iterated)keys.push(key);
	};
	__webpack_require__(337)(Enumerate, 'Object', function(){
	  var that = this
	    , keys = that._k
	    , key;
	  do {
	    if(that._i >= keys.length)return {value: undefined, done: true};
	  } while(!((key = keys[that._i++]) in that._t));
	  return {value: key, done: false};
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target){
	    return new Enumerate(target);
	  }
	});

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD     = __webpack_require__(79)
	  , $export  = __webpack_require__(5)
	  , anObject = __webpack_require__(14);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey){
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export  = __webpack_require__(5)
	  , getProto = __webpack_require__(80)
	  , anObject = __webpack_require__(14);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target){
	    return getProto(anObject(target));
	  }
	});

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD           = __webpack_require__(79)
	  , getPrototypeOf = __webpack_require__(80)
	  , has            = __webpack_require__(62)
	  , $export        = __webpack_require__(5)
	  , isObject       = __webpack_require__(25)
	  , anObject       = __webpack_require__(14);
	
	function get(target, propertyKey/*, receiver*/){
	  var receiver = arguments.length < 3 ? target : arguments[2]
	    , desc, proto;
	  if(anObject(target) === receiver)return target[propertyKey];
	  if(desc = gOPD.f(target, propertyKey))return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if(isObject(proto = getPrototypeOf(target)))return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', {get: get});

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey){
	    return propertyKey in target;
	  }
	});

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export       = __webpack_require__(5)
	  , anObject      = __webpack_require__(14)
	  , $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target){
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Reflect', {ownKeys: __webpack_require__(517)});

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export            = __webpack_require__(5)
	  , anObject           = __webpack_require__(14)
	  , $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target){
	    anObject(target);
	    try {
	      if($preventExtensions)$preventExtensions(target);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export  = __webpack_require__(5)
	  , setProto = __webpack_require__(342);
	
	if(setProto)$export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto){
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP             = __webpack_require__(38)
	  , gOPD           = __webpack_require__(79)
	  , getPrototypeOf = __webpack_require__(80)
	  , has            = __webpack_require__(62)
	  , $export        = __webpack_require__(5)
	  , createDesc     = __webpack_require__(131)
	  , anObject       = __webpack_require__(14)
	  , isObject       = __webpack_require__(25);
	
	function set(target, propertyKey, V/*, receiver*/){
	  var receiver = arguments.length < 4 ? target : arguments[3]
	    , ownDesc  = gOPD.f(anObject(target), propertyKey)
	    , existingDescriptor, proto;
	  if(!ownDesc){
	    if(isObject(proto = getPrototypeOf(target))){
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if(has(ownDesc, 'value')){
	    if(ownDesc.writable === false || !isObject(receiver))return false;
	    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
	    existingDescriptor.value = V;
	    dP.f(receiver, propertyKey, existingDescriptor);
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', {set: set});

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

	var global            = __webpack_require__(15)
	  , inheritIfRequired = __webpack_require__(334)
	  , dP                = __webpack_require__(38).f
	  , gOPN              = __webpack_require__(152).f
	  , isRegExp          = __webpack_require__(253)
	  , $flags            = __webpack_require__(251)
	  , $RegExp           = global.RegExp
	  , Base              = $RegExp
	  , proto             = $RegExp.prototype
	  , re1               = /a/g
	  , re2               = /a/g
	  // "new" creates a new object, old webkit buggy here
	  , CORRECT_NEW       = new $RegExp(re1) !== re1;
	
	if(__webpack_require__(37) && (!CORRECT_NEW || __webpack_require__(19)(function(){
	  re2[__webpack_require__(29)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))){
	  $RegExp = function RegExp(p, f){
	    var tiRE = this instanceof $RegExp
	      , piRE = isRegExp(p)
	      , fiU  = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function(key){
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function(){ return Base[key]; },
	      set: function(it){ Base[key] = it; }
	    });
	  };
	  for(var keys = gOPN(Base), i = 0; keys.length > i; )proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(69)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(155)('RegExp');

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	// @@match logic
	__webpack_require__(250)('match', 1, function(defined, MATCH, $match){
	  // 21.1.3.11 String.prototype.match(regexp)
	  return [function match(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  }, $match];
	});

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	// @@replace logic
	__webpack_require__(250)('replace', 2, function(defined, REPLACE, $replace){
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	  return [function replace(searchValue, replaceValue){
	    'use strict';
	    var O  = defined(this)
	      , fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined
	      ? fn.call(searchValue, O, replaceValue)
	      : $replace.call(String(O), searchValue, replaceValue);
	  }, $replace];
	});

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	// @@search logic
	__webpack_require__(250)('search', 1, function(defined, SEARCH, $search){
	  // 21.1.3.15 String.prototype.search(regexp)
	  return [function search(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  }, $search];
	});

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	// @@split logic
	__webpack_require__(250)('split', 2, function(defined, SPLIT, $split){
	  'use strict';
	  var isRegExp   = __webpack_require__(253)
	    , _split     = $split
	    , $push      = [].push
	    , $SPLIT     = 'split'
	    , LENGTH     = 'length'
	    , LAST_INDEX = 'lastIndex';
	  if(
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ){
	    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
	    // based on es5-shim implementation, need to rework it
	    $split = function(separator, limit){
	      var string = String(this);
	      if(separator === undefined && limit === 0)return [];
	      // If `separator` is not a regex, use native split
	      if(!isRegExp(separator))return _split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var separator2, match, lastIndex, lastLength, i;
	      // Doesn't need flags gy, but they don't hurt
	      if(!NPCG)separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
	      while(match = separatorCopy.exec(string)){
	        // `separatorCopy.lastIndex` is not reliable cross-browser
	        lastIndex = match.index + match[0][LENGTH];
	        if(lastIndex > lastLastIndex){
	          output.push(string.slice(lastLastIndex, match.index));
	          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
	          if(!NPCG && match[LENGTH] > 1)match[0].replace(separator2, function(){
	            for(i = 1; i < arguments[LENGTH] - 2; i++)if(arguments[i] === undefined)match[i] = undefined;
	          });
	          if(match[LENGTH] > 1 && match.index < string[LENGTH])$push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if(output[LENGTH] >= splitLimit)break;
	        }
	        if(separatorCopy[LAST_INDEX] === match.index)separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if(lastLastIndex === string[LENGTH]){
	        if(lastLength || !separatorCopy.test(''))output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if('0'[$SPLIT](undefined, 0)[LENGTH]){
	    $split = function(separator, limit){
	      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
	    };
	  }
	  // 21.1.3.17 String.prototype.split(separator, limit)
	  return [function split(separator, limit){
	    var O  = defined(this)
	      , fn = separator == undefined ? undefined : separator[SPLIT];
	    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
	  }, $split];
	});

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(524);
	var anObject    = __webpack_require__(14)
	  , $flags      = __webpack_require__(251)
	  , DESCRIPTORS = __webpack_require__(37)
	  , TO_STRING   = 'toString'
	  , $toString   = /./[TO_STRING];
	
	var define = function(fn){
	  __webpack_require__(69)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if(__webpack_require__(19)(function(){ return $toString.call({source: 'a', flags: 'b'}) != '/a/b'; })){
	  define(function toString(){
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if($toString.name != TO_STRING){
	  define(function toString(){
	    return $toString.call(this);
	  });
	}

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(70)('anchor', function(createHTML){
	  return function anchor(name){
	    return createHTML(this, 'a', 'name', name);
	  }
	});

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(70)('big', function(createHTML){
	  return function big(){
	    return createHTML(this, 'big', '', '');
	  }
	});

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(70)('blink', function(createHTML){
	  return function blink(){
	    return createHTML(this, 'blink', '', '');
	  }
	});

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(70)('bold', function(createHTML){
	  return function bold(){
	    return createHTML(this, 'b', '', '');
	  }
	});

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5)
	  , $at     = __webpack_require__(345)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos){
	    return $at(this, pos);
	  }
	});

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export   = __webpack_require__(5)
	  , toLength  = __webpack_require__(44)
	  , context   = __webpack_require__(346)
	  , ENDS_WITH = 'endsWith'
	  , $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(332)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /*, endPosition = @length */){
	    var that = context(this, searchString, ENDS_WITH)
	      , endPosition = arguments.length > 1 ? arguments[1] : undefined
	      , len    = toLength(that.length)
	      , end    = endPosition === undefined ? len : Math.min(toLength(endPosition), len)
	      , search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(70)('fixed', function(createHTML){
	  return function fixed(){
	    return createHTML(this, 'tt', '', '');
	  }
	});

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(70)('fontcolor', function(createHTML){
	  return function fontcolor(color){
	    return createHTML(this, 'font', 'color', color);
	  }
	});

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(70)('fontsize', function(createHTML){
	  return function fontsize(size){
	    return createHTML(this, 'font', 'size', size);
	  }
	});

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	var $export        = __webpack_require__(5)
	  , toIndex        = __webpack_require__(156)
	  , fromCharCode   = String.fromCharCode
	  , $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x){ // eslint-disable-line no-unused-vars
	    var res  = []
	      , aLen = arguments.length
	      , i    = 0
	      , code;
	    while(aLen > i){
	      code = +arguments[i++];
	      if(toIndex(code, 0x10ffff) !== code)throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export  = __webpack_require__(5)
	  , context  = __webpack_require__(346)
	  , INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(332)(INCLUDES), 'String', {
	  includes: function includes(searchString /*, position = 0 */){
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(70)('italics', function(createHTML){
	  return function italics(){
	    return createHTML(this, 'i', '', '');
	  }
	});

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(345)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(338)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(70)('link', function(createHTML){
	  return function link(url){
	    return createHTML(this, 'a', 'href', url);
	  }
	});

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(5)
	  , toIObject = __webpack_require__(71)
	  , toLength  = __webpack_require__(44);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite){
	    var tpl  = toIObject(callSite.raw)
	      , len  = toLength(tpl.length)
	      , aLen = arguments.length
	      , res  = []
	      , i    = 0;
	    while(len > i){
	      res.push(String(tpl[i++]));
	      if(i < aLen)res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(5);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(347)
	});

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(70)('small', function(createHTML){
	  return function small(){
	    return createHTML(this, 'small', '', '');
	  }
	});

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export     = __webpack_require__(5)
	  , toLength    = __webpack_require__(44)
	  , context     = __webpack_require__(346)
	  , STARTS_WITH = 'startsWith'
	  , $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(332)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /*, position = 0 */){
	    var that   = context(this, searchString, STARTS_WITH)
	      , index  = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length))
	      , search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(70)('strike', function(createHTML){
	  return function strike(){
	    return createHTML(this, 'strike', '', '');
	  }
	});

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(70)('sub', function(createHTML){
	  return function sub(){
	    return createHTML(this, 'sub', '', '');
	  }
	});

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(70)('sup', function(createHTML){
	  return function sup(){
	    return createHTML(this, 'sup', '', '');
	  }
	});

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(181)('trim', function($trim){
	  return function trim(){
	    return $trim(this, 3);
	  };
	});

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global         = __webpack_require__(15)
	  , has            = __webpack_require__(62)
	  , DESCRIPTORS    = __webpack_require__(37)
	  , $export        = __webpack_require__(5)
	  , redefine       = __webpack_require__(69)
	  , META           = __webpack_require__(130).KEY
	  , $fails         = __webpack_require__(19)
	  , shared         = __webpack_require__(257)
	  , setToStringTag = __webpack_require__(180)
	  , uid            = __webpack_require__(157)
	  , wks            = __webpack_require__(29)
	  , wksExt         = __webpack_require__(522)
	  , wksDefine      = __webpack_require__(351)
	  , keyOf          = __webpack_require__(837)
	  , enumKeys       = __webpack_require__(836)
	  , isArray        = __webpack_require__(336)
	  , anObject       = __webpack_require__(14)
	  , toIObject      = __webpack_require__(71)
	  , toPrimitive    = __webpack_require__(99)
	  , createDesc     = __webpack_require__(131)
	  , _create        = __webpack_require__(151)
	  , gOPNExt        = __webpack_require__(514)
	  , $GOPD          = __webpack_require__(79)
	  , $DP            = __webpack_require__(38)
	  , $keys          = __webpack_require__(153)
	  , gOPD           = $GOPD.f
	  , dP             = $DP.f
	  , gOPN           = gOPNExt.f
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , PROTOTYPE      = 'prototype'
	  , HIDDEN         = wks('_hidden')
	  , TO_PRIMITIVE   = wks('toPrimitive')
	  , isEnum         = {}.propertyIsEnumerable
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , OPSymbols      = shared('op-symbols')
	  , ObjectProto    = Object[PROTOTYPE]
	  , USE_NATIVE     = typeof $Symbol == 'function'
	  , QObject        = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(dP({}, 'a', {
	    get: function(){ return dP(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = gOPD(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  dP(it, key, D);
	  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
	  return typeof it == 'symbol';
	} : function(it){
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D){
	  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if(has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  it  = toIObject(it);
	  key = toPrimitive(key, true);
	  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
	  var D = gOPD(it, key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = gOPN(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var IS_OP  = it === ObjectProto
	    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if(!USE_NATIVE){
	  $Symbol = function Symbol(){
	    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function(value){
	      if(this === ObjectProto)$set.call(OPSymbols, value);
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f   = $defineProperty;
	  __webpack_require__(152).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(212).f  = $propertyIsEnumerable;
	  __webpack_require__(256).f = $getOwnPropertySymbols;
	
	  if(DESCRIPTORS && !__webpack_require__(150)){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function(name){
	    return wrap(wks(name));
	  }
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});
	
	for(var symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);
	
	for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    if(isSymbol(key))return keyOf(SymbolRegistry, key);
	    throw TypeError(key + ' is not a symbol!');
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it){
	    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	    var args = [it]
	      , i    = 1
	      , replacer, $replacer;
	    while(arguments.length > i)args.push(arguments[i++]);
	    replacer = args[1];
	    if(typeof replacer == 'function')$replacer = replacer;
	    if($replacer || !isArray(replacer))replacer = function(key, value){
	      if($replacer)value = $replacer.call(this, key, value);
	      if(!isSymbol(value))return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(68)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(5)
	  , $typed       = __webpack_require__(258)
	  , buffer       = __webpack_require__(350)
	  , anObject     = __webpack_require__(14)
	  , toIndex      = __webpack_require__(156)
	  , toLength     = __webpack_require__(44)
	  , isObject     = __webpack_require__(25)
	  , ArrayBuffer  = __webpack_require__(15).ArrayBuffer
	  , speciesConstructor = __webpack_require__(344)
	  , $ArrayBuffer = buffer.ArrayBuffer
	  , $DataView    = buffer.DataView
	  , $isView      = $typed.ABV && ArrayBuffer.isView
	  , $slice       = $ArrayBuffer.prototype.slice
	  , VIEW         = $typed.VIEW
	  , ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), {ArrayBuffer: $ArrayBuffer});
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it){
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(19)(function(){
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end){
	    if($slice !== undefined && end === undefined)return $slice.call(anObject(this), start); // FF fix
	    var len    = anObject(this).byteLength
	      , first  = toIndex(start, len)
	      , final  = toIndex(end === undefined ? len : end, len)
	      , result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first))
	      , viewS  = new $DataView(this)
	      , viewT  = new $DataView(result)
	      , index  = 0;
	    while(first < final){
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(155)(ARRAY_BUFFER);

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(5);
	$export($export.G + $export.W + $export.F * !__webpack_require__(258).ABV, {
	  DataView: __webpack_require__(350).DataView
	});

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(115)('Float32', 4, function(init){
	  return function Float32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(115)('Float64', 8, function(init){
	  return function Float64Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(115)('Int16', 2, function(init){
	  return function Int16Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(115)('Int32', 4, function(init){
	  return function Int32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(115)('Int8', 1, function(init){
	  return function Int8Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(115)('Uint16', 2, function(init){
	  return function Uint16Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(115)('Uint32', 4, function(init){
	  return function Uint32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(115)('Uint8', 1, function(init){
	  return function Uint8Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(115)('Uint8', 1, function(init){
	  return function Uint8ClampedArray(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	}, true);

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(506);
	
	// 23.4 WeakSet Objects
	__webpack_require__(249)('WeakSet', function(get){
	  return function WeakSet(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value){
	    return weak.def(this, value, true);
	  }
	}, weak, false, true);

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export   = __webpack_require__(5)
	  , $includes = __webpack_require__(248)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /*, fromIndex = 0 */){
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(177)('includes');

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export   = __webpack_require__(5)
	  , microtask = __webpack_require__(341)()
	  , process   = __webpack_require__(15).process
	  , isNode    = __webpack_require__(91)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn){
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(5)
	  , cof     = __webpack_require__(91);
	
	$export($export.S, 'Error', {
	  isError: function isError(it){
	    return cof(it) === 'Error';
	  }
	});

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(5);
	
	$export($export.P + $export.R, 'Map', {toJSON: __webpack_require__(505)('Map')});

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1){
	    var $x0 = x0 >>> 0
	      , $x1 = x1 >>> 0
	      , $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v){
	    var UINT16 = 0xffff
	      , $u = +u
	      , $v = +v
	      , u0 = $u & UINT16
	      , v0 = $v & UINT16
	      , u1 = $u >> 16
	      , v1 = $v >> 16
	      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1){
	    var $x0 = x0 >>> 0
	      , $x1 = x1 >>> 0
	      , $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v){
	    var UINT16 = 0xffff
	      , $u = +u
	      , $v = +v
	      , u0 = $u & UINT16
	      , v0 = $v & UINT16
	      , u1 = $u >>> 16
	      , v1 = $v >>> 16
	      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export         = __webpack_require__(5)
	  , toObject        = __webpack_require__(51)
	  , aFunction       = __webpack_require__(67)
	  , $defineProperty = __webpack_require__(38);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(37) && $export($export.P + __webpack_require__(255), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter){
	    $defineProperty.f(toObject(this), P, {get: aFunction(getter), enumerable: true, configurable: true});
	  }
	});

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export         = __webpack_require__(5)
	  , toObject        = __webpack_require__(51)
	  , aFunction       = __webpack_require__(67)
	  , $defineProperty = __webpack_require__(38);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(37) && $export($export.P + __webpack_require__(255), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter){
	    $defineProperty.f(toObject(this), P, {set: aFunction(setter), enumerable: true, configurable: true});
	  }
	});

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export  = __webpack_require__(5)
	  , $entries = __webpack_require__(516)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it){
	    return $entries(it);
	  }
	});

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export        = __webpack_require__(5)
	  , ownKeys        = __webpack_require__(517)
	  , toIObject      = __webpack_require__(71)
	  , gOPD           = __webpack_require__(79)
	  , createProperty = __webpack_require__(329);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object){
	    var O       = toIObject(object)
	      , getDesc = gOPD.f
	      , keys    = ownKeys(O)
	      , result  = {}
	      , i       = 0
	      , key;
	    while(keys.length > i)createProperty(result, key = keys[i++], getDesc(O, key));
	    return result;
	  }
	});

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export                  = __webpack_require__(5)
	  , toObject                 = __webpack_require__(51)
	  , toPrimitive              = __webpack_require__(99)
	  , getPrototypeOf           = __webpack_require__(80)
	  , getOwnPropertyDescriptor = __webpack_require__(79).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(37) && $export($export.P + __webpack_require__(255), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P){
	    var O = toObject(this)
	      , K = toPrimitive(P, true)
	      , D;
	    do {
	      if(D = getOwnPropertyDescriptor(O, K))return D.get;
	    } while(O = getPrototypeOf(O));
	  }
	});

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export                  = __webpack_require__(5)
	  , toObject                 = __webpack_require__(51)
	  , toPrimitive              = __webpack_require__(99)
	  , getPrototypeOf           = __webpack_require__(80)
	  , getOwnPropertyDescriptor = __webpack_require__(79).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(37) && $export($export.P + __webpack_require__(255), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P){
	    var O = toObject(this)
	      , K = toPrimitive(P, true)
	      , D;
	    do {
	      if(D = getOwnPropertyDescriptor(O, K))return D.set;
	    } while(O = getPrototypeOf(O));
	  }
	});

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(5)
	  , $values = __webpack_require__(516)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it){
	    return $values(it);
	  }
	});

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export     = __webpack_require__(5)
	  , global      = __webpack_require__(15)
	  , core        = __webpack_require__(112)
	  , microtask   = __webpack_require__(341)()
	  , OBSERVABLE  = __webpack_require__(29)('observable')
	  , aFunction   = __webpack_require__(67)
	  , anObject    = __webpack_require__(14)
	  , anInstance  = __webpack_require__(149)
	  , redefineAll = __webpack_require__(154)
	  , hide        = __webpack_require__(68)
	  , forOf       = __webpack_require__(178)
	  , RETURN      = forOf.RETURN;
	
	var getMethod = function(fn){
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function(subscription){
	  var cleanup = subscription._c;
	  if(cleanup){
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function(subscription){
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function(subscription){
	  if(!subscriptionClosed(subscription)){
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function(observer, subscriber){
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup      = subscriber(observer)
	      , subscription = cleanup;
	    if(cleanup != null){
	      if(typeof cleanup.unsubscribe === 'function')cleanup = function(){ subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch(e){
	    observer.error(e);
	    return;
	  } if(subscriptionClosed(this))cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe(){ closeSubscription(this); }
	});
	
	var SubscriptionObserver = function(subscription){
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value){
	    var subscription = this._s;
	    if(!subscriptionClosed(subscription)){
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if(m)return m.call(observer, value);
	      } catch(e){
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value){
	    var subscription = this._s;
	    if(subscriptionClosed(subscription))throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if(!m)throw value;
	      value = m.call(observer, value);
	    } catch(e){
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value){
	    var subscription = this._s;
	    if(!subscriptionClosed(subscription)){
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch(e){
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber){
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer){
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn){
	    var that = this;
	    return new (core.Promise || global.Promise)(function(resolve, reject){
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next : function(value){
	          try {
	            return fn(value);
	          } catch(e){
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x){
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if(method){
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function(observer){
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function(observer){
	      var done = false;
	      microtask(function(){
	        if(!done){
	          try {
	            if(forOf(x, false, function(it){
	              observer.next(it);
	              if(done)return RETURN;
	            }) === RETURN)return;
	          } catch(e){
	            if(done)throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function(){ done = true; };
	    });
	  },
	  of: function of(){
	    for(var i = 0, l = arguments.length, items = Array(l); i < l;)items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function(observer){
	      var done = false;
	      microtask(function(){
	        if(!done){
	          for(var i = 0; i < items.length; ++i){
	            observer.next(items[i]);
	            if(done)return;
	          } observer.complete();
	        }
	      });
	      return function(){ done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function(){ return this; });
	
	$export($export.G, {Observable: $Observable});
	
	__webpack_require__(155)('Observable');

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata                  = __webpack_require__(114)
	  , anObject                  = __webpack_require__(14)
	  , toMetaKey                 = metadata.key
	  , ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey){
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	}});

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(114)
	  , anObject               = __webpack_require__(14)
	  , toMetaKey              = metadata.key
	  , getOrCreateMetadataMap = metadata.map
	  , store                  = metadata.store;
	
	metadata.exp({deleteMetadata: function deleteMetadata(metadataKey, target /*, targetKey */){
	  var targetKey   = arguments.length < 3 ? undefined : toMetaKey(arguments[2])
	    , metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if(metadataMap === undefined || !metadataMap['delete'](metadataKey))return false;
	  if(metadataMap.size)return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	}});

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

	var Set                     = __webpack_require__(525)
	  , from                    = __webpack_require__(501)
	  , metadata                = __webpack_require__(114)
	  , anObject                = __webpack_require__(14)
	  , getPrototypeOf          = __webpack_require__(80)
	  , ordinaryOwnMetadataKeys = metadata.keys
	  , toMetaKey               = metadata.key;
	
	var ordinaryMetadataKeys = function(O, P){
	  var oKeys  = ordinaryOwnMetadataKeys(O, P)
	    , parent = getPrototypeOf(O);
	  if(parent === null)return oKeys;
	  var pKeys  = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({getMetadataKeys: function getMetadataKeys(target /*, targetKey */){
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	}});

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(114)
	  , anObject               = __webpack_require__(14)
	  , getPrototypeOf         = __webpack_require__(80)
	  , ordinaryHasOwnMetadata = metadata.has
	  , ordinaryGetOwnMetadata = metadata.get
	  , toMetaKey              = metadata.key;
	
	var ordinaryGetMetadata = function(MetadataKey, O, P){
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if(hasOwn)return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({getMetadata: function getMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata                = __webpack_require__(114)
	  , anObject                = __webpack_require__(14)
	  , ordinaryOwnMetadataKeys = metadata.keys
	  , toMetaKey               = metadata.key;
	
	metadata.exp({getOwnMetadataKeys: function getOwnMetadataKeys(target /*, targetKey */){
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	}});

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(114)
	  , anObject               = __webpack_require__(14)
	  , ordinaryGetOwnMetadata = metadata.get
	  , toMetaKey              = metadata.key;
	
	metadata.exp({getOwnMetadata: function getOwnMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(114)
	  , anObject               = __webpack_require__(14)
	  , getPrototypeOf         = __webpack_require__(80)
	  , ordinaryHasOwnMetadata = metadata.has
	  , toMetaKey              = metadata.key;
	
	var ordinaryHasMetadata = function(MetadataKey, O, P){
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if(hasOwn)return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({hasMetadata: function hasMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(114)
	  , anObject               = __webpack_require__(14)
	  , ordinaryHasOwnMetadata = metadata.has
	  , toMetaKey              = metadata.key;
	
	metadata.exp({hasOwnMetadata: function hasOwnMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata                  = __webpack_require__(114)
	  , anObject                  = __webpack_require__(14)
	  , aFunction                 = __webpack_require__(67)
	  , toMetaKey                 = metadata.key
	  , ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({metadata: function metadata(metadataKey, metadataValue){
	  return function decorator(target, targetKey){
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	}});

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(5);
	
	$export($export.P + $export.R, 'Set', {toJSON: __webpack_require__(505)('Set')});

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(5)
	  , $at     = __webpack_require__(345)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos){
	    return $at(this, pos);
	  }
	});

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export     = __webpack_require__(5)
	  , defined     = __webpack_require__(92)
	  , toLength    = __webpack_require__(44)
	  , isRegExp    = __webpack_require__(253)
	  , getFlags    = __webpack_require__(251)
	  , RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function(regexp, string){
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(337)($RegExpStringIterator, 'RegExp String', function next(){
	  var match = this._r.exec(this._s);
	  return {value: match, done: match === null};
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp){
	    defined(this);
	    if(!isRegExp(regexp))throw TypeError(regexp + ' is not a regexp!');
	    var S     = String(this)
	      , flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp)
	      , rx    = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(5)
	  , $pad    = __webpack_require__(521);
	
	$export($export.P, 'String', {
	  padEnd: function padEnd(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(5)
	  , $pad    = __webpack_require__(521);
	
	$export($export.P, 'String', {
	  padStart: function padStart(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(181)('trimLeft', function($trim){
	  return function trimLeft(){
	    return $trim(this, 1);
	  };
	}, 'trimStart');

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(181)('trimRight', function($trim){
	  return function trimRight(){
	    return $trim(this, 2);
	  };
	}, 'trimEnd');

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(351)('asyncIterator');

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(351)('observable');

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-global
	var $export = __webpack_require__(5);
	
	$export($export.S, 'System', {global: __webpack_require__(15)});

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators    = __webpack_require__(353)
	  , redefine      = __webpack_require__(69)
	  , global        = __webpack_require__(15)
	  , hide          = __webpack_require__(68)
	  , Iterators     = __webpack_require__(179)
	  , wks           = __webpack_require__(29)
	  , ITERATOR      = wks('iterator')
	  , TO_STRING_TAG = wks('toStringTag')
	  , ArrayValues   = Iterators.Array;
	
	for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
	  var NAME       = collections[i]
	    , Collection = global[NAME]
	    , proto      = Collection && Collection.prototype
	    , key;
	  if(proto){
	    if(!proto[ITERATOR])hide(proto, ITERATOR, ArrayValues);
	    if(!proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    for(key in $iterators)if(!proto[key])redefine(proto, key, $iterators[key], true);
	  }
	}

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(5)
	  , $task   = __webpack_require__(349);
	$export($export.G + $export.B, {
	  setImmediate:   $task.set,
	  clearImmediate: $task.clear
	});

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global     = __webpack_require__(15)
	  , $export    = __webpack_require__(5)
	  , invoke     = __webpack_require__(252)
	  , partial    = __webpack_require__(838)
	  , navigator  = global.navigator
	  , MSIE       = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
	var wrap = function(set){
	  return MSIE ? function(fn, time /*, ...args */){
	    return set(invoke(
	      partial,
	      [].slice.call(arguments, 2),
	      typeof fn == 'function' ? fn : Function(fn)
	    ), time);
	  } : set;
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout:  wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(961);
	__webpack_require__(900);
	__webpack_require__(902);
	__webpack_require__(901);
	__webpack_require__(904);
	__webpack_require__(906);
	__webpack_require__(911);
	__webpack_require__(905);
	__webpack_require__(903);
	__webpack_require__(913);
	__webpack_require__(912);
	__webpack_require__(908);
	__webpack_require__(909);
	__webpack_require__(907);
	__webpack_require__(899);
	__webpack_require__(910);
	__webpack_require__(914);
	__webpack_require__(915);
	__webpack_require__(867);
	__webpack_require__(869);
	__webpack_require__(868);
	__webpack_require__(917);
	__webpack_require__(916);
	__webpack_require__(887);
	__webpack_require__(897);
	__webpack_require__(898);
	__webpack_require__(888);
	__webpack_require__(889);
	__webpack_require__(890);
	__webpack_require__(891);
	__webpack_require__(892);
	__webpack_require__(893);
	__webpack_require__(894);
	__webpack_require__(895);
	__webpack_require__(896);
	__webpack_require__(870);
	__webpack_require__(871);
	__webpack_require__(872);
	__webpack_require__(873);
	__webpack_require__(874);
	__webpack_require__(875);
	__webpack_require__(876);
	__webpack_require__(877);
	__webpack_require__(878);
	__webpack_require__(879);
	__webpack_require__(880);
	__webpack_require__(881);
	__webpack_require__(882);
	__webpack_require__(883);
	__webpack_require__(884);
	__webpack_require__(885);
	__webpack_require__(886);
	__webpack_require__(948);
	__webpack_require__(953);
	__webpack_require__(960);
	__webpack_require__(951);
	__webpack_require__(943);
	__webpack_require__(944);
	__webpack_require__(949);
	__webpack_require__(954);
	__webpack_require__(956);
	__webpack_require__(939);
	__webpack_require__(940);
	__webpack_require__(941);
	__webpack_require__(942);
	__webpack_require__(945);
	__webpack_require__(946);
	__webpack_require__(947);
	__webpack_require__(950);
	__webpack_require__(952);
	__webpack_require__(955);
	__webpack_require__(957);
	__webpack_require__(958);
	__webpack_require__(959);
	__webpack_require__(862);
	__webpack_require__(864);
	__webpack_require__(863);
	__webpack_require__(866);
	__webpack_require__(865);
	__webpack_require__(851);
	__webpack_require__(849);
	__webpack_require__(855);
	__webpack_require__(852);
	__webpack_require__(858);
	__webpack_require__(860);
	__webpack_require__(848);
	__webpack_require__(854);
	__webpack_require__(845);
	__webpack_require__(859);
	__webpack_require__(843);
	__webpack_require__(857);
	__webpack_require__(856);
	__webpack_require__(850);
	__webpack_require__(853);
	__webpack_require__(842);
	__webpack_require__(844);
	__webpack_require__(847);
	__webpack_require__(846);
	__webpack_require__(861);
	__webpack_require__(353);
	__webpack_require__(933);
	__webpack_require__(938);
	__webpack_require__(524);
	__webpack_require__(934);
	__webpack_require__(935);
	__webpack_require__(936);
	__webpack_require__(937);
	__webpack_require__(918);
	__webpack_require__(523);
	__webpack_require__(525);
	__webpack_require__(526);
	__webpack_require__(973);
	__webpack_require__(962);
	__webpack_require__(963);
	__webpack_require__(968);
	__webpack_require__(971);
	__webpack_require__(972);
	__webpack_require__(966);
	__webpack_require__(969);
	__webpack_require__(967);
	__webpack_require__(970);
	__webpack_require__(964);
	__webpack_require__(965);
	__webpack_require__(919);
	__webpack_require__(920);
	__webpack_require__(921);
	__webpack_require__(922);
	__webpack_require__(923);
	__webpack_require__(926);
	__webpack_require__(924);
	__webpack_require__(925);
	__webpack_require__(927);
	__webpack_require__(928);
	__webpack_require__(929);
	__webpack_require__(930);
	__webpack_require__(932);
	__webpack_require__(931);
	__webpack_require__(974);
	__webpack_require__(1000);
	__webpack_require__(1003);
	__webpack_require__(1002);
	__webpack_require__(1004);
	__webpack_require__(1005);
	__webpack_require__(1001);
	__webpack_require__(1006);
	__webpack_require__(1007);
	__webpack_require__(985);
	__webpack_require__(988);
	__webpack_require__(984);
	__webpack_require__(982);
	__webpack_require__(983);
	__webpack_require__(986);
	__webpack_require__(987);
	__webpack_require__(977);
	__webpack_require__(999);
	__webpack_require__(1008);
	__webpack_require__(976);
	__webpack_require__(978);
	__webpack_require__(980);
	__webpack_require__(979);
	__webpack_require__(981);
	__webpack_require__(990);
	__webpack_require__(991);
	__webpack_require__(993);
	__webpack_require__(992);
	__webpack_require__(995);
	__webpack_require__(994);
	__webpack_require__(996);
	__webpack_require__(997);
	__webpack_require__(998);
	__webpack_require__(975);
	__webpack_require__(989);
	__webpack_require__(1011);
	__webpack_require__(1010);
	__webpack_require__(1009);
	module.exports = __webpack_require__(112);

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(1445);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 * @param {String} namespace
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor(namespace) {
	  var hash = 0, i;
	
	  for (i in namespace) {
	    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
	    hash |= 0; // Convert to 32bit integer
	  }
	
	  return exports.colors[Math.abs(hash) % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function createDebug(namespace) {
	
	  function debug() {
	    // disabled?
	    if (!debug.enabled) return;
	
	    var self = debug;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // turn the `arguments` into a proper Array
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %O
	      args.unshift('%O');
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting (colors, etc.)
	    exports.formatArgs.call(self, args);
	
	    var logFn = debug.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	
	  debug.namespace = namespace;
	  debug.enabled = exports.enabled(namespace);
	  debug.useColors = exports.useColors();
	  debug.color = selectColor(namespace);
	
	  // env-specific initialization logic for debug instances
	  if ('function' === typeof exports.init) {
	    exports.init(debug);
	  }
	
	  return debug;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  exports.names = [];
	  exports.skips = [];
	
	  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * deep-diff.
	 * Licensed under the MIT License.
	 */
	;(function(root, factory) {
	  'use strict';
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return factory();
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    // Browser globals (root is window)
	    root.DeepDiff = factory();
	  }
	}(this, function(undefined) {
	  'use strict';
	
	  var $scope, conflict, conflictResolution = [];
	  if (typeof global === 'object' && global) {
	    $scope = global;
	  } else if (typeof window !== 'undefined') {
	    $scope = window;
	  } else {
	    $scope = {};
	  }
	  conflict = $scope.DeepDiff;
	  if (conflict) {
	    conflictResolution.push(
	      function() {
	        if ('undefined' !== typeof conflict && $scope.DeepDiff === accumulateDiff) {
	          $scope.DeepDiff = conflict;
	          conflict = undefined;
	        }
	      });
	  }
	
	  // nodejs compatible on server side and in the browser.
	  function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor;
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  }
	
	  function Diff(kind, path) {
	    Object.defineProperty(this, 'kind', {
	      value: kind,
	      enumerable: true
	    });
	    if (path && path.length) {
	      Object.defineProperty(this, 'path', {
	        value: path,
	        enumerable: true
	      });
	    }
	  }
	
	  function DiffEdit(path, origin, value) {
	    DiffEdit.super_.call(this, 'E', path);
	    Object.defineProperty(this, 'lhs', {
	      value: origin,
	      enumerable: true
	    });
	    Object.defineProperty(this, 'rhs', {
	      value: value,
	      enumerable: true
	    });
	  }
	  inherits(DiffEdit, Diff);
	
	  function DiffNew(path, value) {
	    DiffNew.super_.call(this, 'N', path);
	    Object.defineProperty(this, 'rhs', {
	      value: value,
	      enumerable: true
	    });
	  }
	  inherits(DiffNew, Diff);
	
	  function DiffDeleted(path, value) {
	    DiffDeleted.super_.call(this, 'D', path);
	    Object.defineProperty(this, 'lhs', {
	      value: value,
	      enumerable: true
	    });
	  }
	  inherits(DiffDeleted, Diff);
	
	  function DiffArray(path, index, item) {
	    DiffArray.super_.call(this, 'A', path);
	    Object.defineProperty(this, 'index', {
	      value: index,
	      enumerable: true
	    });
	    Object.defineProperty(this, 'item', {
	      value: item,
	      enumerable: true
	    });
	  }
	  inherits(DiffArray, Diff);
	
	  function arrayRemove(arr, from, to) {
	    var rest = arr.slice((to || from) + 1 || arr.length);
	    arr.length = from < 0 ? arr.length + from : from;
	    arr.push.apply(arr, rest);
	    return arr;
	  }
	
	  function realTypeOf(subject) {
	    var type = typeof subject;
	    if (type !== 'object') {
	      return type;
	    }
	
	    if (subject === Math) {
	      return 'math';
	    } else if (subject === null) {
	      return 'null';
	    } else if (Array.isArray(subject)) {
	      return 'array';
	    } else if (Object.prototype.toString.call(subject) === '[object Date]') {
	      return 'date';
	    } else if (typeof subject.toString !== 'undefined' && /^\/.*\//.test(subject.toString())) {
	      return 'regexp';
	    }
	    return 'object';
	  }
	
	  function deepDiff(lhs, rhs, changes, prefilter, path, key, stack) {
	    path = path || [];
	    var currentPath = path.slice(0);
	    if (typeof key !== 'undefined') {
	      if (prefilter) {
	        if (typeof(prefilter) === 'function' && prefilter(currentPath, key)) { return; }
	        else if (typeof(prefilter) === 'object') {
	          if (prefilter.prefilter && prefilter.prefilter(currentPath, key)) { return; }
	          if (prefilter.normalize) {
	            var alt = prefilter.normalize(currentPath, key, lhs, rhs);
	            if (alt) {
	              lhs = alt[0];
	              rhs = alt[1];
	            }
	          }
	        }
	      }
	      currentPath.push(key);
	    }
	
	    // Use string comparison for regexes
	    if (realTypeOf(lhs) === 'regexp' && realTypeOf(rhs) === 'regexp') {
	      lhs = lhs.toString();
	      rhs = rhs.toString();
	    }
	
	    var ltype = typeof lhs;
	    var rtype = typeof rhs;
	    if (ltype === 'undefined') {
	      if (rtype !== 'undefined') {
	        changes(new DiffNew(currentPath, rhs));
	      }
	    } else if (rtype === 'undefined') {
	      changes(new DiffDeleted(currentPath, lhs));
	    } else if (realTypeOf(lhs) !== realTypeOf(rhs)) {
	      changes(new DiffEdit(currentPath, lhs, rhs));
	    } else if (Object.prototype.toString.call(lhs) === '[object Date]' && Object.prototype.toString.call(rhs) === '[object Date]' && ((lhs - rhs) !== 0)) {
	      changes(new DiffEdit(currentPath, lhs, rhs));
	    } else if (ltype === 'object' && lhs !== null && rhs !== null) {
	      stack = stack || [];
	      if (stack.indexOf(lhs) < 0) {
	        stack.push(lhs);
	        if (Array.isArray(lhs)) {
	          var i, len = lhs.length;
	          for (i = 0; i < lhs.length; i++) {
	            if (i >= rhs.length) {
	              changes(new DiffArray(currentPath, i, new DiffDeleted(undefined, lhs[i])));
	            } else {
	              deepDiff(lhs[i], rhs[i], changes, prefilter, currentPath, i, stack);
	            }
	          }
	          while (i < rhs.length) {
	            changes(new DiffArray(currentPath, i, new DiffNew(undefined, rhs[i++])));
	          }
	        } else {
	          var akeys = Object.keys(lhs);
	          var pkeys = Object.keys(rhs);
	          akeys.forEach(function(k, i) {
	            var other = pkeys.indexOf(k);
	            if (other >= 0) {
	              deepDiff(lhs[k], rhs[k], changes, prefilter, currentPath, k, stack);
	              pkeys = arrayRemove(pkeys, other);
	            } else {
	              deepDiff(lhs[k], undefined, changes, prefilter, currentPath, k, stack);
	            }
	          });
	          pkeys.forEach(function(k) {
	            deepDiff(undefined, rhs[k], changes, prefilter, currentPath, k, stack);
	          });
	        }
	        stack.length = stack.length - 1;
	      }
	    } else if (lhs !== rhs) {
	      if (!(ltype === 'number' && isNaN(lhs) && isNaN(rhs))) {
	        changes(new DiffEdit(currentPath, lhs, rhs));
	      }
	    }
	  }
	
	  function accumulateDiff(lhs, rhs, prefilter, accum) {
	    accum = accum || [];
	    deepDiff(lhs, rhs,
	      function(diff) {
	        if (diff) {
	          accum.push(diff);
	        }
	      },
	      prefilter);
	    return (accum.length) ? accum : undefined;
	  }
	
	  function applyArrayChange(arr, index, change) {
	    if (change.path && change.path.length) {
	      var it = arr[index],
	          i, u = change.path.length - 1;
	      for (i = 0; i < u; i++) {
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          applyArrayChange(it[change.path[i]], change.index, change.item);
	          break;
	        case 'D':
	          delete it[change.path[i]];
	          break;
	        case 'E':
	        case 'N':
	          it[change.path[i]] = change.rhs;
	          break;
	      }
	    } else {
	      switch (change.kind) {
	        case 'A':
	          applyArrayChange(arr[index], change.index, change.item);
	          break;
	        case 'D':
	          arr = arrayRemove(arr, index);
	          break;
	        case 'E':
	        case 'N':
	          arr[index] = change.rhs;
	          break;
	      }
	    }
	    return arr;
	  }
	
	  function applyChange(target, source, change) {
	    if (target && source && change && change.kind) {
	      var it = target,
	          i = -1,
	          last = change.path ? change.path.length - 1 : 0;
	      while (++i < last) {
	        if (typeof it[change.path[i]] === 'undefined') {
	          it[change.path[i]] = (typeof change.path[i] === 'number') ? [] : {};
	        }
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          applyArrayChange(change.path ? it[change.path[i]] : it, change.index, change.item);
	          break;
	        case 'D':
	          delete it[change.path[i]];
	          break;
	        case 'E':
	        case 'N':
	          it[change.path[i]] = change.rhs;
	          break;
	      }
	    }
	  }
	
	  function revertArrayChange(arr, index, change) {
	    if (change.path && change.path.length) {
	      // the structure of the object at the index has changed...
	      var it = arr[index],
	          i, u = change.path.length - 1;
	      for (i = 0; i < u; i++) {
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          revertArrayChange(it[change.path[i]], change.index, change.item);
	          break;
	        case 'D':
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'E':
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'N':
	          delete it[change.path[i]];
	          break;
	      }
	    } else {
	      // the array item is different...
	      switch (change.kind) {
	        case 'A':
	          revertArrayChange(arr[index], change.index, change.item);
	          break;
	        case 'D':
	          arr[index] = change.lhs;
	          break;
	        case 'E':
	          arr[index] = change.lhs;
	          break;
	        case 'N':
	          arr = arrayRemove(arr, index);
	          break;
	      }
	    }
	    return arr;
	  }
	
	  function revertChange(target, source, change) {
	    if (target && source && change && change.kind) {
	      var it = target,
	          i, u;
	      u = change.path.length - 1;
	      for (i = 0; i < u; i++) {
	        if (typeof it[change.path[i]] === 'undefined') {
	          it[change.path[i]] = {};
	        }
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          // Array was modified...
	          // it will be an array...
	          revertArrayChange(it[change.path[i]], change.index, change.item);
	          break;
	        case 'D':
	          // Item was deleted...
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'E':
	          // Item was edited...
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'N':
	          // Item is new...
	          delete it[change.path[i]];
	          break;
	      }
	    }
	  }
	
	  function applyDiff(target, source, filter) {
	    if (target && source) {
	      var onChange = function(change) {
	        if (!filter || filter(target, source, change)) {
	          applyChange(target, source, change);
	        }
	      };
	      deepDiff(target, source, onChange);
	    }
	  }
	
	  Object.defineProperties(accumulateDiff, {
	
	    diff: {
	      value: accumulateDiff,
	      enumerable: true
	    },
	    observableDiff: {
	      value: deepDiff,
	      enumerable: true
	    },
	    applyDiff: {
	      value: applyDiff,
	      enumerable: true
	    },
	    applyChange: {
	      value: applyChange,
	      enumerable: true
	    },
	    revertChange: {
	      value: revertChange,
	      enumerable: true
	    },
	    isConflict: {
	      value: function() {
	        return 'undefined' !== typeof conflict;
	      },
	      enumerable: true
	    },
	    noConflict: {
	      value: function() {
	        if (conflictResolution) {
	          conflictResolution.forEach(function(it) {
	            it();
	          });
	          conflictResolution = null;
	        }
	        return accumulateDiff;
	      },
	      enumerable: true
	    }
	  });
	
	  return accumulateDiff;
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),
/* 1016 */
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
	exports.__esModule = true;
	
	var _isDisposable = __webpack_require__(355);
	
	var _isDisposable2 = _interopRequireWildcard(_isDisposable);
	
	/**
	 * Represents a group of disposable resources that are disposed together.
	 */
	
	var CompositeDisposable = (function () {
	  function CompositeDisposable() {
	    for (var _len = arguments.length, disposables = Array(_len), _key = 0; _key < _len; _key++) {
	      disposables[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, CompositeDisposable);
	
	    if (Array.isArray(disposables[0]) && disposables.length === 1) {
	      disposables = disposables[0];
	    }
	
	    for (var i = 0; i < disposables.length; i++) {
	      if (!_isDisposable2['default'](disposables[i])) {
	        throw new Error('Expected a disposable');
	      }
	    }
	
	    this.disposables = disposables;
	    this.isDisposed = false;
	  }
	
	  /**
	   * Adds a disposable to the CompositeDisposable or disposes the disposable if the CompositeDisposable is disposed.
	   * @param {Disposable} item Disposable to add.
	   */
	
	  CompositeDisposable.prototype.add = function add(item) {
	    if (this.isDisposed) {
	      item.dispose();
	    } else {
	      this.disposables.push(item);
	    }
	  };
	
	  /**
	   * Removes and disposes the first occurrence of a disposable from the CompositeDisposable.
	   * @param {Disposable} item Disposable to remove.
	   * @returns {Boolean} true if found; false otherwise.
	   */
	
	  CompositeDisposable.prototype.remove = function remove(item) {
	    if (this.isDisposed) {
	      return false;
	    }
	
	    var index = this.disposables.indexOf(item);
	    if (index === -1) {
	      return false;
	    }
	
	    this.disposables.splice(index, 1);
	    item.dispose();
	    return true;
	  };
	
	  /**
	   * Disposes all disposables in the group and removes them from the group.
	   */
	
	  CompositeDisposable.prototype.dispose = function dispose() {
	    if (this.isDisposed) {
	      return;
	    }
	
	    var len = this.disposables.length;
	    var currentDisposables = new Array(len);
	    for (var i = 0; i < len; i++) {
	      currentDisposables[i] = this.disposables[i];
	    }
	
	    this.isDisposed = true;
	    this.disposables = [];
	    this.length = 0;
	
	    for (var i = 0; i < len; i++) {
	      currentDisposables[i].dispose();
	    }
	  };
	
	  return CompositeDisposable;
	})();
	
	exports['default'] = CompositeDisposable;
	module.exports = exports['default'];

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

	"use strict";
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	exports.__esModule = true;
	var noop = function noop() {};
	
	/**
	 * The basic disposable.
	 */
	
	var Disposable = (function () {
	  function Disposable(action) {
	    _classCallCheck(this, Disposable);
	
	    this.isDisposed = false;
	    this.action = action || noop;
	  }
	
	  Disposable.prototype.dispose = function dispose() {
	    if (!this.isDisposed) {
	      this.action.call(null);
	      this.isDisposed = true;
	    }
	  };
	
	  _createClass(Disposable, null, [{
	    key: "empty",
	    enumerable: true,
	    value: { dispose: noop }
	  }]);
	
	  return Disposable;
	})();
	
	exports["default"] = Disposable;
	module.exports = exports["default"];

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
	exports.__esModule = true;
	
	var _isDisposable = __webpack_require__(355);
	
	var _isDisposable2 = _interopRequireWildcard(_isDisposable);
	
	var SerialDisposable = (function () {
	  function SerialDisposable() {
	    _classCallCheck(this, SerialDisposable);
	
	    this.isDisposed = false;
	    this.current = null;
	  }
	
	  /**
	   * Gets the underlying disposable.
	   * @return The underlying disposable.
	   */
	
	  SerialDisposable.prototype.getDisposable = function getDisposable() {
	    return this.current;
	  };
	
	  /**
	   * Sets the underlying disposable.
	   * @param {Disposable} value The new underlying disposable.
	   */
	
	  SerialDisposable.prototype.setDisposable = function setDisposable() {
	    var value = arguments[0] === undefined ? null : arguments[0];
	
	    if (value != null && !_isDisposable2['default'](value)) {
	      throw new Error('Expected either an empty value or a valid disposable');
	    }
	
	    var isDisposed = this.isDisposed;
	    var previous = undefined;
	
	    if (!isDisposed) {
	      previous = this.current;
	      this.current = value;
	    }
	
	    if (previous) {
	      previous.dispose();
	    }
	
	    if (isDisposed && value) {
	      value.dispose();
	    }
	  };
	
	  /**
	   * Disposes the underlying disposable as well as all future replacements.
	   */
	
	  SerialDisposable.prototype.dispose = function dispose() {
	    if (this.isDisposed) {
	      return;
	    }
	
	    this.isDisposed = true;
	    var previous = this.current;
	    this.current = null;
	
	    if (previous) {
	      previous.dispose();
	    }
	  };
	
	  return SerialDisposable;
	})();
	
	exports['default'] = SerialDisposable;
	module.exports = exports['default'];

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };
	
	exports.__esModule = true;
	
	var _isDisposable2 = __webpack_require__(355);
	
	var _isDisposable3 = _interopRequireWildcard(_isDisposable2);
	
	exports.isDisposable = _isDisposable3['default'];
	
	var _Disposable2 = __webpack_require__(1018);
	
	var _Disposable3 = _interopRequireWildcard(_Disposable2);
	
	exports.Disposable = _Disposable3['default'];
	
	var _CompositeDisposable2 = __webpack_require__(1017);
	
	var _CompositeDisposable3 = _interopRequireWildcard(_CompositeDisposable2);
	
	exports.CompositeDisposable = _CompositeDisposable3['default'];
	
	var _SerialDisposable2 = __webpack_require__(1019);
	
	var _SerialDisposable3 = _interopRequireWildcard(_SerialDisposable2);
	
	exports.SerialDisposable = _SerialDisposable3['default'];

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _createStore = __webpack_require__(418);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _reducers = __webpack_require__(1029);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _dragDrop = __webpack_require__(259);
	
	var dragDropActions = _interopRequireWildcard(_dragDrop);
	
	var _DragDropMonitor = __webpack_require__(1022);
	
	var _DragDropMonitor2 = _interopRequireDefault(_DragDropMonitor);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DragDropManager = function () {
	  function DragDropManager(createBackend) {
	    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, DragDropManager);
	
	    var store = (0, _createStore2.default)(_reducers2.default);
	    this.context = context;
	    this.store = store;
	    this.monitor = new _DragDropMonitor2.default(store);
	    this.registry = this.monitor.registry;
	    this.backend = createBackend(this);
	
	    store.subscribe(this.handleRefCountChange.bind(this));
	  }
	
	  _createClass(DragDropManager, [{
	    key: 'handleRefCountChange',
	    value: function handleRefCountChange() {
	      var shouldSetUp = this.store.getState().refCount > 0;
	      if (shouldSetUp && !this.isSetUp) {
	        this.backend.setup();
	        this.isSetUp = true;
	      } else if (!shouldSetUp && this.isSetUp) {
	        this.backend.teardown();
	        this.isSetUp = false;
	      }
	    }
	  }, {
	    key: 'getContext',
	    value: function getContext() {
	      return this.context;
	    }
	  }, {
	    key: 'getMonitor',
	    value: function getMonitor() {
	      return this.monitor;
	    }
	  }, {
	    key: 'getBackend',
	    value: function getBackend() {
	      return this.backend;
	    }
	  }, {
	    key: 'getRegistry',
	    value: function getRegistry() {
	      return this.registry;
	    }
	  }, {
	    key: 'getActions',
	    value: function getActions() {
	      var manager = this;
	      var dispatch = this.store.dispatch;
	
	
	      function bindActionCreator(actionCreator) {
	        return function () {
	          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	          }
	
	          var action = actionCreator.apply(manager, args);
	          if (typeof action !== 'undefined') {
	            dispatch(action);
	          }
	        };
	      }
	
	      return Object.keys(dragDropActions).filter(function (key) {
	        return typeof dragDropActions[key] === 'function';
	      }).reduce(function (boundActions, key) {
	        var action = dragDropActions[key];
	        boundActions[key] = bindActionCreator(action); // eslint-disable-line no-param-reassign
	        return boundActions;
	      }, {});
	    }
	  }]);
	
	  return DragDropManager;
	}();
	
	exports.default = DragDropManager;

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isArray = __webpack_require__(162);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _matchesType = __webpack_require__(530);
	
	var _matchesType2 = _interopRequireDefault(_matchesType);
	
	var _HandlerRegistry = __webpack_require__(1025);
	
	var _HandlerRegistry2 = _interopRequireDefault(_HandlerRegistry);
	
	var _dragOffset = __webpack_require__(529);
	
	var _dirtyHandlerIds = __webpack_require__(528);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DragDropMonitor = function () {
	  function DragDropMonitor(store) {
	    _classCallCheck(this, DragDropMonitor);
	
	    this.store = store;
	    this.registry = new _HandlerRegistry2.default(store);
	  }
	
	  _createClass(DragDropMonitor, [{
	    key: 'subscribeToStateChange',
	    value: function subscribeToStateChange(listener) {
	      var _this = this;
	
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var handlerIds = options.handlerIds;
	
	      (0, _invariant2.default)(typeof listener === 'function', 'listener must be a function.');
	      (0, _invariant2.default)(typeof handlerIds === 'undefined' || (0, _isArray2.default)(handlerIds), 'handlerIds, when specified, must be an array of strings.');
	
	      var prevStateId = this.store.getState().stateId;
	      var handleChange = function handleChange() {
	        var state = _this.store.getState();
	        var currentStateId = state.stateId;
	        try {
	          var canSkipListener = currentStateId === prevStateId || currentStateId === prevStateId + 1 && !(0, _dirtyHandlerIds.areDirty)(state.dirtyHandlerIds, handlerIds);
	
	          if (!canSkipListener) {
	            listener();
	          }
	        } finally {
	          prevStateId = currentStateId;
	        }
	      };
	
	      return this.store.subscribe(handleChange);
	    }
	  }, {
	    key: 'subscribeToOffsetChange',
	    value: function subscribeToOffsetChange(listener) {
	      var _this2 = this;
	
	      (0, _invariant2.default)(typeof listener === 'function', 'listener must be a function.');
	
	      var previousState = this.store.getState().dragOffset;
	      var handleChange = function handleChange() {
	        var nextState = _this2.store.getState().dragOffset;
	        if (nextState === previousState) {
	          return;
	        }
	
	        previousState = nextState;
	        listener();
	      };
	
	      return this.store.subscribe(handleChange);
	    }
	  }, {
	    key: 'canDragSource',
	    value: function canDragSource(sourceId) {
	      var source = this.registry.getSource(sourceId);
	      (0, _invariant2.default)(source, 'Expected to find a valid source.');
	
	      if (this.isDragging()) {
	        return false;
	      }
	
	      return source.canDrag(this, sourceId);
	    }
	  }, {
	    key: 'canDropOnTarget',
	    value: function canDropOnTarget(targetId) {
	      var target = this.registry.getTarget(targetId);
	      (0, _invariant2.default)(target, 'Expected to find a valid target.');
	
	      if (!this.isDragging() || this.didDrop()) {
	        return false;
	      }
	
	      var targetType = this.registry.getTargetType(targetId);
	      var draggedItemType = this.getItemType();
	      return (0, _matchesType2.default)(targetType, draggedItemType) && target.canDrop(this, targetId);
	    }
	  }, {
	    key: 'isDragging',
	    value: function isDragging() {
	      return Boolean(this.getItemType());
	    }
	  }, {
	    key: 'isDraggingSource',
	    value: function isDraggingSource(sourceId) {
	      var source = this.registry.getSource(sourceId, true);
	      (0, _invariant2.default)(source, 'Expected to find a valid source.');
	
	      if (!this.isDragging() || !this.isSourcePublic()) {
	        return false;
	      }
	
	      var sourceType = this.registry.getSourceType(sourceId);
	      var draggedItemType = this.getItemType();
	      if (sourceType !== draggedItemType) {
	        return false;
	      }
	
	      return source.isDragging(this, sourceId);
	    }
	  }, {
	    key: 'isOverTarget',
	    value: function isOverTarget(targetId) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { shallow: false };
	      var shallow = options.shallow;
	
	      if (!this.isDragging()) {
	        return false;
	      }
	
	      var targetType = this.registry.getTargetType(targetId);
	      var draggedItemType = this.getItemType();
	      if (!(0, _matchesType2.default)(targetType, draggedItemType)) {
	        return false;
	      }
	
	      var targetIds = this.getTargetIds();
	      if (!targetIds.length) {
	        return false;
	      }
	
	      var index = targetIds.indexOf(targetId);
	      if (shallow) {
	        return index === targetIds.length - 1;
	      } else {
	        return index > -1;
	      }
	    }
	  }, {
	    key: 'getItemType',
	    value: function getItemType() {
	      return this.store.getState().dragOperation.itemType;
	    }
	  }, {
	    key: 'getItem',
	    value: function getItem() {
	      return this.store.getState().dragOperation.item;
	    }
	  }, {
	    key: 'getSourceId',
	    value: function getSourceId() {
	      return this.store.getState().dragOperation.sourceId;
	    }
	  }, {
	    key: 'getTargetIds',
	    value: function getTargetIds() {
	      return this.store.getState().dragOperation.targetIds;
	    }
	  }, {
	    key: 'getDropResult',
	    value: function getDropResult() {
	      return this.store.getState().dragOperation.dropResult;
	    }
	  }, {
	    key: 'didDrop',
	    value: function didDrop() {
	      return this.store.getState().dragOperation.didDrop;
	    }
	  }, {
	    key: 'isSourcePublic',
	    value: function isSourcePublic() {
	      return this.store.getState().dragOperation.isSourcePublic;
	    }
	  }, {
	    key: 'getInitialClientOffset',
	    value: function getInitialClientOffset() {
	      return this.store.getState().dragOffset.initialClientOffset;
	    }
	  }, {
	    key: 'getInitialSourceClientOffset',
	    value: function getInitialSourceClientOffset() {
	      return this.store.getState().dragOffset.initialSourceClientOffset;
	    }
	  }, {
	    key: 'getClientOffset',
	    value: function getClientOffset() {
	      return this.store.getState().dragOffset.clientOffset;
	    }
	  }, {
	    key: 'getSourceClientOffset',
	    value: function getSourceClientOffset() {
	      return (0, _dragOffset.getSourceClientOffset)(this.store.getState().dragOffset);
	    }
	  }, {
	    key: 'getDifferenceFromInitialOffset',
	    value: function getDifferenceFromInitialOffset() {
	      return (0, _dragOffset.getDifferenceFromInitialOffset)(this.store.getState().dragOffset);
	    }
	  }]);
	
	  return DragDropMonitor;
	}();
	
	exports.default = DragDropMonitor;

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DragSource = function () {
	  function DragSource() {
	    _classCallCheck(this, DragSource);
	  }
	
	  _createClass(DragSource, [{
	    key: "canDrag",
	    value: function canDrag() {
	      return true;
	    }
	  }, {
	    key: "isDragging",
	    value: function isDragging(monitor, handle) {
	      return handle === monitor.getSourceId();
	    }
	  }, {
	    key: "endDrag",
	    value: function endDrag() {}
	  }]);
	
	  return DragSource;
	}();
	
	exports.default = DragSource;

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DropTarget = function () {
	  function DropTarget() {
	    _classCallCheck(this, DropTarget);
	  }
	
	  _createClass(DropTarget, [{
	    key: "canDrop",
	    value: function canDrop() {
	      return true;
	    }
	  }, {
	    key: "hover",
	    value: function hover() {}
	  }, {
	    key: "drop",
	    value: function drop() {}
	  }]);
	
	  return DropTarget;
	}();
	
	exports.default = DropTarget;

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isArray = __webpack_require__(162);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _asap = __webpack_require__(806);
	
	var _asap2 = _interopRequireDefault(_asap);
	
	var _registry = __webpack_require__(260);
	
	var _getNextUniqueId = __webpack_require__(1032);
	
	var _getNextUniqueId2 = _interopRequireDefault(_getNextUniqueId);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HandlerRoles = {
	  SOURCE: 'SOURCE',
	  TARGET: 'TARGET'
	};
	
	function validateSourceContract(source) {
	  (0, _invariant2.default)(typeof source.canDrag === 'function', 'Expected canDrag to be a function.');
	  (0, _invariant2.default)(typeof source.beginDrag === 'function', 'Expected beginDrag to be a function.');
	  (0, _invariant2.default)(typeof source.endDrag === 'function', 'Expected endDrag to be a function.');
	}
	
	function validateTargetContract(target) {
	  (0, _invariant2.default)(typeof target.canDrop === 'function', 'Expected canDrop to be a function.');
	  (0, _invariant2.default)(typeof target.hover === 'function', 'Expected hover to be a function.');
	  (0, _invariant2.default)(typeof target.drop === 'function', 'Expected beginDrag to be a function.');
	}
	
	function validateType(type, allowArray) {
	  if (allowArray && (0, _isArray2.default)(type)) {
	    type.forEach(function (t) {
	      return validateType(t, false);
	    });
	    return;
	  }
	
	  (0, _invariant2.default)(typeof type === 'string' || (typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'symbol', allowArray ? 'Type can only be a string, a symbol, or an array of either.' : 'Type can only be a string or a symbol.');
	}
	
	function getNextHandlerId(role) {
	  var id = (0, _getNextUniqueId2.default)().toString();
	  switch (role) {
	    case HandlerRoles.SOURCE:
	      return 'S' + id;
	    case HandlerRoles.TARGET:
	      return 'T' + id;
	    default:
	      (0, _invariant2.default)(false, 'Unknown role: ' + role);
	  }
	}
	
	function parseRoleFromHandlerId(handlerId) {
	  switch (handlerId[0]) {
	    case 'S':
	      return HandlerRoles.SOURCE;
	    case 'T':
	      return HandlerRoles.TARGET;
	    default:
	      (0, _invariant2.default)(false, 'Cannot parse handler ID: ' + handlerId);
	  }
	}
	
	var HandlerRegistry = function () {
	  function HandlerRegistry(store) {
	    _classCallCheck(this, HandlerRegistry);
	
	    this.store = store;
	
	    this.types = {};
	    this.handlers = {};
	
	    this.pinnedSourceId = null;
	    this.pinnedSource = null;
	  }
	
	  _createClass(HandlerRegistry, [{
	    key: 'addSource',
	    value: function addSource(type, source) {
	      validateType(type);
	      validateSourceContract(source);
	
	      var sourceId = this.addHandler(HandlerRoles.SOURCE, type, source);
	      this.store.dispatch((0, _registry.addSource)(sourceId));
	      return sourceId;
	    }
	  }, {
	    key: 'addTarget',
	    value: function addTarget(type, target) {
	      validateType(type, true);
	      validateTargetContract(target);
	
	      var targetId = this.addHandler(HandlerRoles.TARGET, type, target);
	      this.store.dispatch((0, _registry.addTarget)(targetId));
	      return targetId;
	    }
	  }, {
	    key: 'addHandler',
	    value: function addHandler(role, type, handler) {
	      var id = getNextHandlerId(role);
	      this.types[id] = type;
	      this.handlers[id] = handler;
	
	      return id;
	    }
	  }, {
	    key: 'containsHandler',
	    value: function containsHandler(handler) {
	      var _this = this;
	
	      return Object.keys(this.handlers).some(function (key) {
	        return _this.handlers[key] === handler;
	      });
	    }
	  }, {
	    key: 'getSource',
	    value: function getSource(sourceId, includePinned) {
	      (0, _invariant2.default)(this.isSourceId(sourceId), 'Expected a valid source ID.');
	
	      var isPinned = includePinned && sourceId === this.pinnedSourceId;
	      var source = isPinned ? this.pinnedSource : this.handlers[sourceId];
	
	      return source;
	    }
	  }, {
	    key: 'getTarget',
	    value: function getTarget(targetId) {
	      (0, _invariant2.default)(this.isTargetId(targetId), 'Expected a valid target ID.');
	      return this.handlers[targetId];
	    }
	  }, {
	    key: 'getSourceType',
	    value: function getSourceType(sourceId) {
	      (0, _invariant2.default)(this.isSourceId(sourceId), 'Expected a valid source ID.');
	      return this.types[sourceId];
	    }
	  }, {
	    key: 'getTargetType',
	    value: function getTargetType(targetId) {
	      (0, _invariant2.default)(this.isTargetId(targetId), 'Expected a valid target ID.');
	      return this.types[targetId];
	    }
	  }, {
	    key: 'isSourceId',
	    value: function isSourceId(handlerId) {
	      var role = parseRoleFromHandlerId(handlerId);
	      return role === HandlerRoles.SOURCE;
	    }
	  }, {
	    key: 'isTargetId',
	    value: function isTargetId(handlerId) {
	      var role = parseRoleFromHandlerId(handlerId);
	      return role === HandlerRoles.TARGET;
	    }
	  }, {
	    key: 'removeSource',
	    value: function removeSource(sourceId) {
	      var _this2 = this;
	
	      (0, _invariant2.default)(this.getSource(sourceId), 'Expected an existing source.');
	      this.store.dispatch((0, _registry.removeSource)(sourceId));
	
	      (0, _asap2.default)(function () {
	        delete _this2.handlers[sourceId];
	        delete _this2.types[sourceId];
	      });
	    }
	  }, {
	    key: 'removeTarget',
	    value: function removeTarget(targetId) {
	      var _this3 = this;
	
	      (0, _invariant2.default)(this.getTarget(targetId), 'Expected an existing target.');
	      this.store.dispatch((0, _registry.removeTarget)(targetId));
	
	      (0, _asap2.default)(function () {
	        delete _this3.handlers[targetId];
	        delete _this3.types[targetId];
	      });
	    }
	  }, {
	    key: 'pinSource',
	    value: function pinSource(sourceId) {
	      var source = this.getSource(sourceId);
	      (0, _invariant2.default)(source, 'Expected an existing source.');
	
	      this.pinnedSourceId = sourceId;
	      this.pinnedSource = source;
	    }
	  }, {
	    key: 'unpinSource',
	    value: function unpinSource() {
	      (0, _invariant2.default)(this.pinnedSource, 'No source is pinned at the time.');
	
	      this.pinnedSourceId = null;
	      this.pinnedSource = null;
	    }
	  }]);
	
	  return HandlerRegistry;
	}();
	
	exports.default = HandlerRegistry;

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = createBackend;
	
	var _noop = __webpack_require__(592);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TestBackend = function () {
	  function TestBackend(manager) {
	    _classCallCheck(this, TestBackend);
	
	    this.actions = manager.getActions();
	  }
	
	  _createClass(TestBackend, [{
	    key: 'setup',
	    value: function setup() {
	      this.didCallSetup = true;
	    }
	  }, {
	    key: 'teardown',
	    value: function teardown() {
	      this.didCallTeardown = true;
	    }
	  }, {
	    key: 'connectDragSource',
	    value: function connectDragSource() {
	      return _noop2.default;
	    }
	  }, {
	    key: 'connectDragPreview',
	    value: function connectDragPreview() {
	      return _noop2.default;
	    }
	  }, {
	    key: 'connectDropTarget',
	    value: function connectDropTarget() {
	      return _noop2.default;
	    }
	  }, {
	    key: 'simulateBeginDrag',
	    value: function simulateBeginDrag(sourceIds, options) {
	      this.actions.beginDrag(sourceIds, options);
	    }
	  }, {
	    key: 'simulatePublishDragSource',
	    value: function simulatePublishDragSource() {
	      this.actions.publishDragSource();
	    }
	  }, {
	    key: 'simulateHover',
	    value: function simulateHover(targetIds, options) {
	      this.actions.hover(targetIds, options);
	    }
	  }, {
	    key: 'simulateDrop',
	    value: function simulateDrop() {
	      this.actions.drop();
	    }
	  }, {
	    key: 'simulateEndDrag',
	    value: function simulateEndDrag() {
	      this.actions.endDrag();
	    }
	  }]);
	
	  return TestBackend;
	}();
	
	function createBackend(manager) {
	  return new TestBackend(manager);
	}

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DragDropManager = __webpack_require__(1021);
	
	Object.defineProperty(exports, 'DragDropManager', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DragDropManager).default;
	  }
	});
	
	var _DragSource = __webpack_require__(1023);
	
	Object.defineProperty(exports, 'DragSource', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DragSource).default;
	  }
	});
	
	var _DropTarget = __webpack_require__(1024);
	
	Object.defineProperty(exports, 'DropTarget', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DropTarget).default;
	  }
	});
	
	var _createTestBackend = __webpack_require__(1026);
	
	Object.defineProperty(exports, 'createTestBackend', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_createTestBackend).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = dragOperation;
	
	var _without = __webpack_require__(593);
	
	var _without2 = _interopRequireDefault(_without);
	
	var _dragDrop = __webpack_require__(259);
	
	var _registry = __webpack_require__(260);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	  itemType: null,
	  item: null,
	  sourceId: null,
	  targetIds: [],
	  dropResult: null,
	  didDrop: false,
	  isSourcePublic: null
	};
	
	function dragOperation() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _dragDrop.BEGIN_DRAG:
	      return _extends({}, state, {
	        itemType: action.itemType,
	        item: action.item,
	        sourceId: action.sourceId,
	        isSourcePublic: action.isSourcePublic,
	        dropResult: null,
	        didDrop: false
	      });
	    case _dragDrop.PUBLISH_DRAG_SOURCE:
	      return _extends({}, state, {
	        isSourcePublic: true
	      });
	    case _dragDrop.HOVER:
	      return _extends({}, state, {
	        targetIds: action.targetIds
	      });
	    case _registry.REMOVE_TARGET:
	      if (state.targetIds.indexOf(action.targetId) === -1) {
	        return state;
	      }
	      return _extends({}, state, {
	        targetIds: (0, _without2.default)(state.targetIds, action.targetId)
	      });
	    case _dragDrop.DROP:
	      return _extends({}, state, {
	        dropResult: action.dropResult,
	        didDrop: true,
	        targetIds: []
	      });
	    case _dragDrop.END_DRAG:
	      return _extends({}, state, {
	        itemType: null,
	        item: null,
	        sourceId: null,
	        dropResult: null,
	        didDrop: false,
	        isSourcePublic: null,
	        targetIds: []
	      });
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = reduce;
	
	var _dragOffset = __webpack_require__(529);
	
	var _dragOffset2 = _interopRequireDefault(_dragOffset);
	
	var _dragOperation = __webpack_require__(1028);
	
	var _dragOperation2 = _interopRequireDefault(_dragOperation);
	
	var _refCount = __webpack_require__(1030);
	
	var _refCount2 = _interopRequireDefault(_refCount);
	
	var _dirtyHandlerIds = __webpack_require__(528);
	
	var _dirtyHandlerIds2 = _interopRequireDefault(_dirtyHandlerIds);
	
	var _stateId = __webpack_require__(1031);
	
	var _stateId2 = _interopRequireDefault(_stateId);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function reduce() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  return {
	    dirtyHandlerIds: (0, _dirtyHandlerIds2.default)(state.dirtyHandlerIds, action, state.dragOperation),
	    dragOffset: (0, _dragOffset2.default)(state.dragOffset, action),
	    refCount: (0, _refCount2.default)(state.refCount, action),
	    dragOperation: (0, _dragOperation2.default)(state.dragOperation, action),
	    stateId: (0, _stateId2.default)(state.stateId)
	  };
	}

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = refCount;
	
	var _registry = __webpack_require__(260);
	
	function refCount() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _registry.ADD_SOURCE:
	    case _registry.ADD_TARGET:
	      return state + 1;
	    case _registry.REMOVE_SOURCE:
	    case _registry.REMOVE_TARGET:
	      return state - 1;
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = stateId;
	function stateId() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	  return state + 1;
	}

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getNextUniqueId;
	var nextUniqueId = 0;
	
	function getNextUniqueId() {
	  return nextUniqueId++;
	}

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addClass;
	
	var _hasClass = __webpack_require__(1034);
	
	var _hasClass2 = _interopRequireDefault(_hasClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element)) element.className = element.className + ' ' + className;
	}
	module.exports = exports['default'];

/***/ }),
/* 1034 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hasClass;
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + element.className + " ").indexOf(" " + className + " ") !== -1;
	}
	module.exports = exports["default"];

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	};

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = undefined;
	
	var _inDOM = __webpack_require__(531);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var transform = 'transform';
	var prefix = void 0,
	    transitionEnd = void 0,
	    animationEnd = void 0;
	var transitionProperty = void 0,
	    transitionDuration = void 0,
	    transitionTiming = void 0,
	    transitionDelay = void 0;
	var animationName = void 0,
	    animationDuration = void 0,
	    animationTiming = void 0,
	    animationDelay = void 0;
	
	if (_inDOM2.default) {
	  var _getTransitionPropert = getTransitionProperties();
	
	  prefix = _getTransitionPropert.prefix;
	  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
	  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
	
	
	  exports.transform = transform = prefix + '-' + transform;
	  exports.transitionProperty = transitionProperty = prefix + '-transition-property';
	  exports.transitionDuration = transitionDuration = prefix + '-transition-duration';
	  exports.transitionDelay = transitionDelay = prefix + '-transition-delay';
	  exports.transitionTiming = transitionTiming = prefix + '-transition-timing-function';
	
	  exports.animationName = animationName = prefix + '-animation-name';
	  exports.animationDuration = animationDuration = prefix + '-animation-duration';
	  exports.animationTiming = animationTiming = prefix + '-animation-delay';
	  exports.animationDelay = animationDelay = prefix + '-animation-timing-function';
	}
	
	exports.transform = transform;
	exports.transitionProperty = transitionProperty;
	exports.transitionTiming = transitionTiming;
	exports.transitionDelay = transitionDelay;
	exports.transitionDuration = transitionDuration;
	exports.transitionEnd = transitionEnd;
	exports.animationName = animationName;
	exports.animationDuration = animationDuration;
	exports.animationTiming = animationTiming;
	exports.animationDelay = animationDelay;
	exports.animationEnd = animationEnd;
	exports.default = {
	  transform: transform,
	  end: transitionEnd,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	
	
	function getTransitionProperties() {
	  var style = document.createElement('div').style;
	
	  var vendorMap = {
	    O: function O(e) {
	      return 'o' + e.toLowerCase();
	    },
	    Moz: function Moz(e) {
	      return e.toLowerCase();
	    },
	    Webkit: function Webkit(e) {
	      return 'webkit' + e;
	    },
	    ms: function ms(e) {
	      return 'MS' + e;
	    }
	  };
	
	  var vendors = Object.keys(vendorMap);
	
	  var transitionEnd = void 0,
	      animationEnd = void 0;
	  var prefix = '';
	
	  for (var i = 0; i < vendors.length; i++) {
	    var vendor = vendors[i];
	
	    if (vendor + 'TransitionProperty' in style) {
	      prefix = '-' + vendor.toLowerCase();
	      transitionEnd = vendorMap[vendor]('TransitionEnd');
	      animationEnd = vendorMap[vendor]('AnimationEnd');
	      break;
	    }
	  }
	
	  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
	
	  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
	
	  style = null;
	
	  return { animationEnd: animationEnd, transitionEnd: transitionEnd, prefix: prefix };
	}

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inDOM = __webpack_require__(531);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
	var cancel = 'clearTimeout';
	var raf = fallback;
	var compatRaf = void 0;
	
	var getKey = function getKey(vendor, k) {
	  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
	};
	
	if (_inDOM2.default) {
	  vendors.some(function (vendor) {
	    var rafKey = getKey(vendor, 'request');
	
	    if (rafKey in window) {
	      cancel = getKey(vendor, 'cancel');
	      return raf = function raf(cb) {
	        return window[rafKey](cb);
	      };
	    }
	  });
	}
	
	/* https://github.com/component/raf */
	var prev = new Date().getTime();
	function fallback(fn) {
	  var curr = new Date().getTime(),
	      ms = Math.max(0, 16 - (curr - prev)),
	      req = setTimeout(fn, ms);
	
	  prev = curr;
	  return req;
	}
	
	compatRaf = function compatRaf(cb) {
	  return raf(cb);
	};
	compatRaf.cancel = function (id) {
	  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
	};
	exports.default = compatRaf;
	module.exports = exports['default'];

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;;(function(factory) {
	    'use strict';
	    /* global window: false, define: false, module: false */
	    var root = typeof window === 'undefined' ? null : window;
	
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function(){ return factory(root); }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module !== 'undefined') {
	        module.exports = factory(root);
	    } else {
	        root.DOMPurify = factory(root);
	    }
	}(function factory(window) {
	    'use strict';
	
	    var DOMPurify = function(window) {
	        return factory(window);
	    };
	
	    /**
	     * Version label, exposed for easier checks
	     * if DOMPurify is up to date or not
	     */
	    DOMPurify.version = '0.7.4';
	
	    if (!window || !window.document || window.document.nodeType !== 9) {
	        // not running in a browser, provide a factory function
	        // so that you can pass your own Window
	        DOMPurify.isSupported = false;
	        return DOMPurify;
	    }
	
	    var document = window.document;
	    var originalDocument = document;
	    var DocumentFragment = window.DocumentFragment;
	    var HTMLTemplateElement = window.HTMLTemplateElement;
	    var NodeFilter = window.NodeFilter;
	    var NamedNodeMap = window.NamedNodeMap || window.MozNamedAttrMap;
	    var Text = window.Text;
	    var Comment = window.Comment;
	    var DOMParser = window.DOMParser;
	
	    // As per issue #47, the web-components registry is inherited by a
	    // new document created via createHTMLDocument. As per the spec
	    // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
	    // a new empty registry is used when creating a template contents owner
	    // document, so we use that as our parent document to ensure nothing
	    // is inherited.
	    if (typeof HTMLTemplateElement === 'function') {
	        document = document.createElement('template').content.ownerDocument;
	    }
	    var implementation = document.implementation;
	    var createNodeIterator = document.createNodeIterator;
	    var getElementsByTagName = document.getElementsByTagName;
	    var createDocumentFragment = document.createDocumentFragment;
	    var importNode = originalDocument.importNode;
	
	    var hooks = {};
	
	    /**
	     * Expose whether this browser supports running the full DOMPurify.
	     */
	    DOMPurify.isSupported =
	        typeof implementation.createHTMLDocument !== 'undefined' &&
	        document.documentMode !== 9;
	
	    /* Add properties to a lookup table */
	    var _addToSet = function(set, array) {
	        var l = array.length;
	        while (l--) {
	            set[array[l]] = true;
	        }
	        return set;
	    };
	
	    /* Shallow clone an object */
	    var _cloneObj = function(object) {
	        var newObject = {};
	        var property;
	        for (property in object) {
	            if (object.hasOwnProperty(property)) {
	                newObject[property] = object[property];
	            }
	        }
	        return newObject;
	    };
	
	    /**
	     * We consider the elements and attributes below to be safe. Ideally
	     * don't add any new ones but feel free to remove unwanted ones.
	     */
	
	    /* allowed element names */
	    var ALLOWED_TAGS = null;
	    var DEFAULT_ALLOWED_TAGS = _addToSet({}, [
	
	        // HTML
	        'a','abbr','acronym','address','area','article','aside','audio','b',
	        'bdi','bdo','big','blink','blockquote','body','br','button','canvas',
	        'caption','center','cite','code','col','colgroup','content','data',
	        'datalist','dd','decorator','del','details','dfn','dir','div','dl','dt',
	        'element','em','fieldset','figcaption','figure','font','footer','form',
	        'h1','h2','h3','h4','h5','h6','head','header','hgroup','hr','html','i',
	        'img','input','ins','kbd','label','legend','li','main','map','mark',
	        'marquee','menu','menuitem','meter','nav','nobr','ol','optgroup',
	        'option','output','p','pre','progress','q','rp','rt','ruby','s','samp',
	        'section','select','shadow','small','source','spacer','span','strike',
	        'strong','style','sub','summary','sup','table','tbody','td','template',
	        'textarea','tfoot','th','thead','time','tr','track','tt','u','ul','var',
	        'video','wbr',
	
	        // SVG
	        'svg','altglyph','altglyphdef','altglyphitem','animatecolor',
	        'animatemotion','animatetransform','circle','clippath','defs','desc',
	        'ellipse','font','g','glyph','glyphref','hkern','image','line',
	        'lineargradient','marker','mask','metadata','mpath','path','pattern',
	        'polygon','polyline','radialgradient','rect','stop','switch','symbol',
	        'text','textpath','title','tref','tspan','view','vkern',
	
	        // SVG Filters
	        'feBlend','feColorMatrix','feComponentTransfer','feComposite',
	        'feConvolveMatrix','feDiffuseLighting','feDisplacementMap',
	        'feFlood','feFuncA','feFuncB','feFuncG','feFuncR','feGaussianBlur',
	        'feImage','feMerge','feMergeNode','feMorphology','feOffset',
	        'feSpecularLighting','feTile','feTurbulence',
	
	        //MathML
	        'math','menclose','merror','mfenced','mfrac','mglyph','mi','mlabeledtr',
	        'mmuliscripts','mn','mo','mover','mpadded','mphantom','mroot','mrow',
	        'ms','mpspace','msqrt','mystyle','msub','msup','msubsup','mtable','mtd',
	        'mtext','mtr','munder','munderover',
	
	        //Text
	        '#text'
	    ]);
	
	    /* Allowed attribute names */
	    var ALLOWED_ATTR = null;
	    var DEFAULT_ALLOWED_ATTR = _addToSet({}, [
	
	        // HTML
	        'accept','action','align','alt','autocomplete','background','bgcolor',
	        'border','cellpadding','cellspacing','checked','cite','class','clear','color',
	        'cols','colspan','coords','datetime','default','dir','disabled',
	        'download','enctype','face','for','headers','height','hidden','high','href',
	        'hreflang','id','ismap','label','lang','list','loop', 'low','max',
	        'maxlength','media','method','min','multiple','name','noshade','novalidate',
	        'nowrap','open','optimum','pattern','placeholder','poster','preload','pubdate',
	        'radiogroup','readonly','rel','required','rev','reversed','rows',
	        'rowspan','spellcheck','scope','selected','shape','size','span',
	        'srclang','start','src','step','style','summary','tabindex','title',
	        'type','usemap','valign','value','width','xmlns',
	
	        // SVG
	        'accent-height','accumulate','additivive','alignment-baseline',
	        'ascent','attributename','attributetype','azimuth','basefrequency',
	        'baseline-shift','begin','bias','by','clip','clip-path','clip-rule',
	        'color','color-interpolation','color-interpolation-filters','color-profile',
	        'color-rendering','cx','cy','d','dx','dy','diffuseconstant','direction',
	        'display','divisor','dur','edgemode','elevation','end','fill','fill-opacity',
	        'fill-rule','filter','flood-color','flood-opacity','font-family','font-size',
	        'font-size-adjust','font-stretch','font-style','font-variant','font-weight',
	        'fx', 'fy','g1','g2','glyph-name','glyphref','gradientunits','gradienttransform',
	        'image-rendering','in','in2','k','k1','k2','k3','k4','kerning','keypoints',
	        'keysplines','keytimes','lengthadjust','letter-spacing','kernelmatrix',
	        'kernelunitlength','lighting-color','local','marker-end','marker-mid',
	        'marker-start','markerheight','markerunits','markerwidth','maskcontentunits',
	        'maskunits','max','mask','mode','min','numoctaves','offset','operator',
	        'opacity','order','orient','orientation','origin','overflow','paint-order',
	        'path','pathlength','patterncontentunits','patterntransform','patternunits',
	        'points','preservealpha','r','rx','ry','radius','refx','refy','repeatcount',
	        'repeatdur','restart','rotate','scale','seed','shape-rendering','specularconstant',
	        'specularexponent','spreadmethod','stddeviation','stitchtiles','stop-color',
	        'stop-opacity','stroke-dasharray','stroke-dashoffset','stroke-linecap',
	        'stroke-linejoin','stroke-miterlimit','stroke-opacity','stroke','stroke-width',
	        'surfacescale','targetx','targety','transform','text-anchor','text-decoration',
	        'text-rendering','textlength','u1','u2','unicode','values','viewbox',
	        'visibility','vert-adv-y','vert-origin-x','vert-origin-y','word-spacing',
	        'wrap','writing-mode','xchannelselector','ychannelselector','x','x1','x2',
	        'y','y1','y2','z','zoomandpan',
	
	        // MathML
	        'accent','accentunder','bevelled','close','columnsalign','columnlines',
	        'columnspan','denomalign','depth','display','displaystyle','fence',
	        'frame','largeop','length','linethickness','lspace','lquote',
	        'mathbackground','mathcolor','mathsize','mathvariant','maxsize',
	        'minsize','movablelimits','notation','numalign','open','rowalign',
	        'rowlines','rowspacing','rowspan','rspace','rquote','scriptlevel',
	        'scriptminsize','scriptsizemultiplier','selection','separator',
	        'separators','stretchy','subscriptshift','supscriptshift','symmetric',
	        'voffset',
	
	        // XML
	        'xlink:href','xml:id','xlink:title','xml:space','xmlns:xlink'
	    ]);
	
	    /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */
	    var FORBID_TAGS = null;
	
	    /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */
	    var FORBID_ATTR = null;
	
	    /* Decide if custom data attributes are okay */
	    var ALLOW_DATA_ATTR = true;
	
	    /* Output should be safe for jQuery's $() factory? */
	    var SAFE_FOR_JQUERY = false;
	
	    /* Output should be safe for common template engines.
	     * This means, DOMPurify removes data attributes, mustaches and ERB
	     */
	    var SAFE_FOR_TEMPLATES = false;
	
	    /* Specify template detection regex for SAFE_FOR_TEMPLATES mode */
	    var MUSTACHE_EXPR = /\{\{[\s\S]*|[\s\S]*\}\}/gm;
	    var ERB_EXPR = /<%[\s\S]*|[\s\S]*%>/gm;
	
	    /* Decide if document with <html>... should be returned */
	    var WHOLE_DOCUMENT = false;
	
	    /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html string.
	     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
	     */
	    var RETURN_DOM = false;
	
	    /* Decide if a DOM `DocumentFragment` should be returned, instead of a html string */
	    var RETURN_DOM_FRAGMENT = false;
	
	    /* If `RETURN_DOM` or `RETURN_DOM_FRAGMENT` is enabled, decide if the returned DOM
	     * `Node` is imported into the current `Document`. If this flag is not enabled the
	     * `Node` will belong (its ownerDocument) to a fresh `HTMLDocument`, created by
	     * DOMPurify. */
	    var RETURN_DOM_IMPORT = false;
	
	    /* Output should be free from DOM clobbering attacks? */
	    var SANITIZE_DOM = true;
	
	    /* Keep element content when removing element? */
	    var KEEP_CONTENT = true;
	
	    /* Tags to ignore content of when KEEP_CONTENT is true */
	    var FORBID_CONTENTS = _addToSet({}, [
	        'audio', 'head', 'math', 'script', 'style', 'svg', 'video'
	    ]);
	
	    /* Tags that are safe for data: URIs */
	    var DATA_URI_TAGS = _addToSet({}, [
	        'audio', 'video', 'img', 'source'
	    ]);
	
	    /* Attributes safe for values like "javascript:" */
	    var URI_SAFE_ATTRIBUTES = _addToSet({}, [
	        'alt','class','for','id','label','name','pattern','placeholder',
	        'summary','title','value','style','xmlns'
	    ]);
	
	    /* Keep a reference to config to pass to hooks */
	    var CONFIG = null;
	
	    /* Ideally, do not touch anything below this line */
	    /* ______________________________________________ */
	
	    var formElement = document.createElement('form');
	
	    /**
	     * _parseConfig
	     *
	     * @param  optional config literal
	     */
	    var _parseConfig = function(cfg) {
	        /* Shield configuration object from tampering */
	        if (typeof cfg !== 'object') {
	            cfg = {};
	        }
	
	        /* Set configuration parameters */
	        ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ?
	            _addToSet({}, cfg.ALLOWED_TAGS) : DEFAULT_ALLOWED_TAGS;
	        ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ?
	            _addToSet({}, cfg.ALLOWED_ATTR) : DEFAULT_ALLOWED_ATTR;
	        FORBID_TAGS = 'FORBID_TAGS' in cfg ?
	            _addToSet({}, cfg.FORBID_TAGS) : {};
	        FORBID_ATTR = 'FORBID_ATTR' in cfg ?
	            _addToSet({}, cfg.FORBID_ATTR) : {};
	        ALLOW_DATA_ATTR     = cfg.ALLOW_DATA_ATTR     !== false; // Default true
	        SAFE_FOR_JQUERY     = cfg.SAFE_FOR_JQUERY     ||  false; // Default false
	        SAFE_FOR_TEMPLATES  = cfg.SAFE_FOR_TEMPLATES  ||  false; // Default false
	        WHOLE_DOCUMENT      = cfg.WHOLE_DOCUMENT      ||  false; // Default false
	        RETURN_DOM          = cfg.RETURN_DOM          ||  false; // Default false
	        RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT ||  false; // Default false
	        RETURN_DOM_IMPORT   = cfg.RETURN_DOM_IMPORT   ||  false; // Default false
	        SANITIZE_DOM        = cfg.SANITIZE_DOM        !== false; // Default true
	        KEEP_CONTENT        = cfg.KEEP_CONTENT        !== false; // Default true
	
	        if (SAFE_FOR_TEMPLATES) {
	            ALLOW_DATA_ATTR = false;
	        }
	
	        if (RETURN_DOM_FRAGMENT) {
	            RETURN_DOM = true;
	        }
	
	        /* Merge configuration parameters */
	        if (cfg.ADD_TAGS) {
	            if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
	                ALLOWED_TAGS = _cloneObj(ALLOWED_TAGS);
	            }
	            _addToSet(ALLOWED_TAGS, cfg.ADD_TAGS);
	        }
	        if (cfg.ADD_ATTR) {
	            if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
	                ALLOWED_ATTR = _cloneObj(ALLOWED_ATTR);
	            }
	            _addToSet(ALLOWED_ATTR, cfg.ADD_ATTR);
	        }
	
	        /* Add #text in case KEEP_CONTENT is set to true */
	        if (KEEP_CONTENT) { ALLOWED_TAGS['#text'] = true; }
	
	        // Prevent further manipulation of configuration.
	        // Not available in IE8, Safari 5, etc.
	        if (Object && 'freeze' in Object) { Object.freeze(cfg); }
	
	        CONFIG = cfg;
	    };
	
	   /**
	     * _forceRemove
	     *
	     * @param  a DOM node
	     */
	    var _forceRemove = function(node) {
	        try {
	            node.parentNode.removeChild(node);
	        } catch (e) {
	            node.outerHTML = '';
	        }
	    };
	
	   /**
	     * _initDocument
	     *
	     * @param  a string of dirty markup
	     * @return a DOM, filled with the dirty markup
	     */
	    var _initDocument = function(dirty) {
	        /* Create a HTML document using DOMParser */
	        var doc, body;
	        try {
	            doc = new DOMParser().parseFromString(dirty, 'text/html');
	        } catch (e) {}
	
	        /* Some browsers throw, some browsers return null for the code above
	           DOMParser with text/html support is only in very recent browsers. */
	        if (!doc) {
	            doc = implementation.createHTMLDocument('');
	            body = doc.body;
	            body.parentNode.removeChild(body.parentNode.firstElementChild);
	            body.outerHTML = dirty;
	        }
	
	        /* Work on whole document or just its body */
	        if (typeof doc.getElementsByTagName === 'function') {
	            return doc.getElementsByTagName(
	                WHOLE_DOCUMENT ? 'html' : 'body')[0];
	        }
	        return getElementsByTagName.call(doc,
	            WHOLE_DOCUMENT ? 'html' : 'body')[0];
	    };
	
	    /**
	     * _createIterator
	     *
	     * @param  document/fragment to create iterator for
	     * @return iterator instance
	     */
	    var _createIterator = function(root) {
	        return createNodeIterator.call(root.ownerDocument || root,
	            root,
	            NodeFilter.SHOW_ELEMENT
	            | NodeFilter.SHOW_COMMENT
	            | NodeFilter.SHOW_TEXT,
	            function() { return NodeFilter.FILTER_ACCEPT; },
	            false
	        );
	    };
	
	    /**
	     * _isClobbered
	     *
	     * @param  element to check for clobbering attacks
	     * @return true if clobbered, false if safe
	     */
	    var _isClobbered = function(elm) {
	        if (elm instanceof Text || elm instanceof Comment) {
	            return false;
	        }
	        if (  typeof elm.nodeName !== 'string'
	           || typeof elm.textContent !== 'string'
	           || typeof elm.removeChild !== 'function'
	           || !(elm.attributes instanceof NamedNodeMap)
	           || typeof elm.removeAttribute !== 'function'
	           || typeof elm.setAttribute !== 'function'
	        ) {
	            return true;
	        }
	        return false;
	    };
	
	    /**
	     * _sanitizeElements
	     *
	     * @protect nodeName
	     * @protect textContent
	     * @protect removeChild
	     *
	     * @param   node to check for permission to exist
	     * @return  true if node was killed, false if left alive
	     */
	    var _sanitizeElements = function(currentNode) {
	        var tagName, content;
	        /* Execute a hook if present */
	        _executeHook('beforeSanitizeElements', currentNode, null);
	
	        /* Check if element is clobbered or can clobber */
	        if (_isClobbered(currentNode)) {
	            _forceRemove(currentNode);
	            return true;
	        }
	
	        /* Now let's check the element's type and name */
	        tagName = currentNode.nodeName.toLowerCase();
	
	        /* Execute a hook if present */
	        _executeHook('uponSanitizeElement', currentNode, {
	            tagName: tagName
	        });
	
	        /* Remove element if anything forbids its presence */
	        if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
	            /* Keep content except for black-listed elements */
	            if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]
	                    && typeof currentNode.insertAdjacentHTML === 'function') {
	                try {
	                    currentNode.insertAdjacentHTML('AfterEnd', currentNode.innerHTML);
	                } catch (e) {}
	            }
	            _forceRemove(currentNode);
	            return true;
	        }
	
	        /* Convert markup to cover jQuery behavior */
	        if (SAFE_FOR_JQUERY && !currentNode.firstElementChild &&
	                (!currentNode.content || !currentNode.content.firstElementChild)) {
	            currentNode.innerHTML = currentNode.textContent.replace(/</g, '&lt;');
	        }
	
	        /* Sanitize element content to be template-safe */
	        if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
	            /* Get the element's text content */
	            content = currentNode.textContent;
	            content = content.replace(MUSTACHE_EXPR, ' ');
	            content = content.replace(ERB_EXPR, ' ');
	            currentNode.textContent = content;
	        }
	
	        /* Execute a hook if present */
	        _executeHook('afterSanitizeElements', currentNode, null);
	
	        return false;
	    };
	
	    var DATA_ATTR = /^data-[\w.\u00B7-\uFFFF-]/;
	    var IS_ALLOWED_URI = /^(?:(?:(?:f|ht)tps?|mailto|tel):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i;
	    /* This needs to be extensive thanks to Webkit/Blink's behavior */
	    var ATTR_WHITESPACE = /[\x00-\x20\xA0\u1680\u180E\u2000-\u2029\u205f\u3000]/g;
	
	    /**
	     * _sanitizeAttributes
	     *
	     * @protect attributes
	     * @protect nodeName
	     * @protect removeAttribute
	     * @protect setAttribute
	     *
	     * @param   node to sanitize
	     * @return  void
	     */
	    var _sanitizeAttributes = function(currentNode) {
	        var attr, name, value, lcName, idAttr, attributes, hookEvent, l;
	        /* Execute a hook if present */
	        _executeHook('beforeSanitizeAttributes', currentNode, null);
	
	        attributes = currentNode.attributes;
	
	        /* Check if we have attributes; if not we might have a text node */
	        if (!attributes) { return; }
	
	        hookEvent = {
	            attrName: '',
	            attrValue: '',
	            keepAttr: true
	        };
	        l = attributes.length;
	
	        /* Go backwards over all attributes; safely remove bad ones */
	        while (l--) {
	            attr = attributes[l];
	            name = attr.name;
	            value = attr.value;
	            lcName = name.toLowerCase();
	
	            /* Execute a hook if present */
	            hookEvent.attrName = lcName;
	            hookEvent.attrValue = value;
	            hookEvent.keepAttr = true;
	            _executeHook('uponSanitizeAttribute', currentNode, hookEvent );
	            value = hookEvent.attrValue;
	
	            /* Remove attribute */
	            // Safari (iOS + Mac), last tested v8.0.5, crashes if you try to
	            // remove a "name" attribute from an <img> tag that has an "id"
	            // attribute at the time.
	            if (lcName === 'name'  &&
	                    currentNode.nodeName === 'IMG' && attributes.id) {
	                idAttr = attributes.id;
	                attributes = Array.prototype.slice.apply(attributes);
	                currentNode.removeAttribute('id');
	                currentNode.removeAttribute(name);
	                if (attributes.indexOf(idAttr) > l) {
	                    currentNode.setAttribute('id', idAttr.value);
	                }
	            } else {
	                // This avoids a crash in Safari v9.0 with double-ids.
	                // The trick is to first set the id to be empty and then to
	                // remove the attriubute
	                if (name === 'id') {
	                    currentNode.setAttribute(name, '');
	                }
	                currentNode.removeAttribute(name);
	            }
	
	            /* Did the hooks approve of the attribute? */
	            if (!hookEvent.keepAttr) {
	                continue;
	            }
	
	            /* Make sure attribute cannot clobber */
	            if (SANITIZE_DOM &&
	                    (lcName === 'id' || lcName === 'name') &&
	                    (value in window || value in document || value in formElement)) {
	                continue;
	            }
	
	            /* Sanitize attribute content to be template-safe */
	            if (SAFE_FOR_TEMPLATES) {
	                value = value.replace(MUSTACHE_EXPR, ' ');
	                value = value.replace(ERB_EXPR, ' ');
	            }
	
	            if (
	                /* Check the name is permitted */
	                (ALLOWED_ATTR[lcName] && !FORBID_ATTR[lcName] && (
	                  /* Check no script, data or unknown possibly unsafe URI
	                     unless we know URI values are safe for that attribute */
	                  URI_SAFE_ATTRIBUTES[lcName] ||
	                  IS_ALLOWED_URI.test(value.replace(ATTR_WHITESPACE,'')) ||
	                  /* Keep image data URIs alive if src is allowed */
	                  (lcName === 'src' && value.indexOf('data:') === 0 &&
	                   DATA_URI_TAGS[currentNode.nodeName.toLowerCase()])
	                )) ||
	                /* Allow potentially valid data-* attributes:
	                 * At least one character after "-" (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
	                 * XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
	                 * We don't need to check the value; it's always URI safe.
	                 */
	                 (ALLOW_DATA_ATTR && DATA_ATTR.test(lcName))
	            ) {
	                /* Handle invalid data-* attribute set by try-catching it */
	                try {
	                    currentNode.setAttribute(name, value);
	                } catch (e) {}
	            }
	        }
	
	        /* Execute a hook if present */
	        _executeHook('afterSanitizeAttributes', currentNode, null);
	    };
	
	    /**
	     * _sanitizeShadowDOM
	     *
	     * @param  fragment to iterate over recursively
	     * @return void
	     */
	    var _sanitizeShadowDOM = function(fragment) {
	        var shadowNode;
	        var shadowIterator = _createIterator(fragment);
	
	        /* Execute a hook if present */
	        _executeHook('beforeSanitizeShadowDOM', fragment, null);
	
	        while ( (shadowNode = shadowIterator.nextNode()) ) {
	            /* Execute a hook if present */
	            _executeHook('uponSanitizeShadowNode', shadowNode, null);
	
	            /* Sanitize tags and elements */
	            if (_sanitizeElements(shadowNode)) {
	                continue;
	            }
	
	            /* Deep shadow DOM detected */
	            if (shadowNode.content instanceof DocumentFragment) {
	                _sanitizeShadowDOM(shadowNode.content);
	            }
	
	            /* Check attributes, sanitize if necessary */
	            _sanitizeAttributes(shadowNode);
	        }
	
	        /* Execute a hook if present */
	        _executeHook('afterSanitizeShadowDOM', fragment, null);
	    };
	
	    /**
	     * _executeHook
	     * Execute user configurable hooks
	     *
	     * @param  {String} entryPoint  Name of the hook's entry point
	     * @param  {Node} currentNode
	     */
	    var _executeHook = function(entryPoint, currentNode, data) {
	        if (!hooks[entryPoint]) { return; }
	
	        hooks[entryPoint].forEach(function(hook) {
	            hook.call(DOMPurify, currentNode, data, CONFIG);
	        });
	    };
	
	    /**
	     * sanitize
	     * Public method providing core sanitation functionality
	     *
	     * @param {String} dirty string
	     * @param {Object} configuration object
	     */
	    DOMPurify.sanitize = function(dirty, cfg) {
	        var body, currentNode, oldNode, nodeIterator, returnNode;
	        /* Make sure we have a string to sanitize.
	           DO NOT return early, as this will return the wrong type if
	           the user has requested a DOM object rather than a string */
	        if (!dirty) {
	            dirty = '';
	        }
	
	        /* Stringify, in case dirty is an object */
	        if (typeof dirty !== 'string') {
	            if (typeof dirty.toString !== 'function') {
	                throw new TypeError('toString is not a function');
	            } else {
	                dirty = dirty.toString();
	            }
	        }
	
	        /* Check we can run. Otherwise fall back or ignore */
	        if (!DOMPurify.isSupported) {
	            if (typeof window.toStaticHTML === 'object'
	                || typeof window.toStaticHTML === 'function') {
	                return window.toStaticHTML(dirty);
	            }
	            return dirty;
	        }
	
	        /* Assign config vars */
	        _parseConfig(cfg);
	
	        /* Exit directly if we have nothing to do */
	        if (!RETURN_DOM && !WHOLE_DOCUMENT && dirty.indexOf('<') === -1) {
	            return dirty;
	        }
	
	        /* Initialize the document to work on */
	        body = _initDocument(dirty);
	
	        /* Check we have a DOM node from the data */
	        if (!body) {
	            return RETURN_DOM ? null : '';
	        }
	
	        /* Get node iterator */
	        nodeIterator = _createIterator(body);
	
	        /* Now start iterating over the created document */
	        while ( (currentNode = nodeIterator.nextNode()) ) {
	
	            /* Fix IE's strange behavior with manipulated textNodes #89 */
	            if (currentNode.nodeType === 3 && currentNode === oldNode) {
	                continue;
	            }
	
	            /* Sanitize tags and elements */
	            if (_sanitizeElements(currentNode)) {
	                continue;
	            }
	
	            /* Shadow DOM detected, sanitize it */
	            if (currentNode.content instanceof DocumentFragment) {
	                _sanitizeShadowDOM(currentNode.content);
	            }
	
	            /* Check attributes, sanitize if necessary */
	            _sanitizeAttributes(currentNode);
	
	            oldNode = currentNode;
	        }
	
	        /* Return sanitized string or DOM */
	        if (RETURN_DOM) {
	
	            if (RETURN_DOM_FRAGMENT) {
	                returnNode = createDocumentFragment.call(body.ownerDocument);
	
	                while (body.firstChild) {
	                    returnNode.appendChild(body.firstChild);
	                }
	            } else {
	                returnNode = body;
	            }
	
	            if (RETURN_DOM_IMPORT) {
	                /* adoptNode() is not used because internal state is not reset
	                   (e.g. the past names map of a HTMLFormElement), this is safe
	                   in theory but we would rather not risk another attack vector.
	                   The state that is cloned by importNode() is explicitly defined
	                   by the specs. */
	                returnNode = importNode.call(originalDocument, returnNode, true);
	            }
	
	            return returnNode;
	        }
	
	        return WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
	    };
	
	    /**
	     * addHook
	     * Public method to add DOMPurify hooks
	     *
	     * @param {String} entryPoint
	     * @param {Function} hookFunction
	     */
	    DOMPurify.addHook = function(entryPoint, hookFunction) {
	        if (typeof hookFunction !== 'function') { return; }
	        hooks[entryPoint] = hooks[entryPoint] || [];
	        hooks[entryPoint].push(hookFunction);
	    };
	
	    /**
	     * removeHook
	     * Public method to remove a DOMPurify hook at a given entryPoint
	     * (pops it from the stack of hooks if more are present)
	     *
	     * @param {String} entryPoint
	     * @return void
	     */
	    DOMPurify.removeHook = function(entryPoint) {
	        if (hooks[entryPoint]) {
	            hooks[entryPoint].pop();
	        }
	    };
	
	    /**
	     * removeHooks
	     * Public method to remove all DOMPurify hooks at a given entryPoint
	     *
	     * @param  {String} entryPoint
	     * @return void
	     */
	    DOMPurify.removeHooks = function(entryPoint) {
	        if (hooks[entryPoint]) {
	            hooks[entryPoint] = [];
	        }
	    };
	
	    /**
	     * removeAllHooks
	     * Public method to remove all DOMPurify hooks
	     *
	     * @return void
	     */
	    DOMPurify.removeAllHooks = function() {
	        hooks = [];
	    };
	
	    return DOMPurify;
	}));


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _unionClassNames = __webpack_require__(2321);
	
	var _unionClassNames2 = _interopRequireDefault(_unionClassNames);
	
	var _linkifyIt = __webpack_require__(577);
	
	var _linkifyIt2 = _interopRequireDefault(_linkifyIt);
	
	var _tlds = __webpack_require__(801);
	
	var _tlds2 = _interopRequireDefault(_tlds);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var linkify = (0, _linkifyIt2.default)();
	linkify.tlds(_tlds2.default);
	
	// The component we render when we encounter a hyperlink in the text
	
	var Link = function (_Component) {
	  _inherits(Link, _Component);
	
	  function Link() {
	    _classCallCheck(this, Link);
	
	    return _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).apply(this, arguments));
	  }
	
	  _createClass(Link, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var _props$decoratedText = _props.decoratedText;
	      var decoratedText = _props$decoratedText === undefined ? '' : _props$decoratedText;
	      var _props$theme = _props.theme;
	      var theme = _props$theme === undefined ? {} : _props$theme;
	      var _props$target = _props.target;
	      var target = _props$target === undefined ? '_self' : _props$target;
	      var className = _props.className;
	      var component = _props.component;
	      var dir = _props.dir;
	      var entityKey = _props.entityKey;
	      var getEditorState = _props.getEditorState;
	      var offsetKey = _props.offsetKey;
	      var setEditorState = _props.setEditorState;
	
	      var otherProps = _objectWithoutProperties(_props, ['decoratedText', 'theme', 'target', 'className', 'component', 'dir', 'entityKey', 'getEditorState', 'offsetKey', 'setEditorState']);
	
	      var combinedClassName = (0, _unionClassNames2.default)(theme.link, className);
	      var links = linkify.match(decoratedText);
	      var href = links && links[0] ? links[0].url : '';
	
	      var props = _extends({}, otherProps, {
	        href: href,
	        target: target,
	        className: combinedClassName
	      });
	
	      return component ? _react2.default.createElement(component, props) : _react2.default.createElement('a', props); // eslint-disable-line jsx-a11y/anchor-has-content
	    }
	  }]);
	
	  return Link;
	}(_react.Component);
	
	exports.default = Link;

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _decorateComponentWithProps = __webpack_require__(527);
	
	var _decorateComponentWithProps2 = _interopRequireDefault(_decorateComponentWithProps);
	
	var _Link = __webpack_require__(1039);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _linkStrategy = __webpack_require__(1041);
	
	var _linkStrategy2 = _interopRequireDefault(_linkStrategy);
	
	var _styles = {
	  "link": "draftJsLinkifyPlugin__link__2ittM"
	};
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultTheme = {
	  link: _styles2.default.link
	};
	
	var linkPlugin = function linkPlugin() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  // Styles are overwritten instead of merged as merging causes a lot of confusion.
	
	  // Why? Because when merging a developer needs to know all of the underlying
	  // styles which needs a deep dive into the code. Merging also makes it prone to
	  // errors when upgrading as basically every styling change would become a major
	  // breaking change. 1px of an increased padding can break a whole layout.
	
	  var component = config.component;
	  var _config$theme = config.theme;
	  var theme = _config$theme === undefined ? defaultTheme : _config$theme;
	  var _config$target = config.target;
	  var target = _config$target === undefined ? '_self' : _config$target;
	
	
	  return {
	    decorators: [{
	      strategy: _linkStrategy2.default,
	      component: (0, _decorateComponentWithProps2.default)(_Link2.default, { theme: theme, target: target, component: component })
	    }]
	  };
	};
	
	exports.default = linkPlugin;

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _linkifyIt = __webpack_require__(577);
	
	var _linkifyIt2 = _interopRequireDefault(_linkifyIt);
	
	var _tlds = __webpack_require__(801);
	
	var _tlds2 = _interopRequireDefault(_tlds);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var linkify = (0, _linkifyIt2.default)();
	linkify.tlds(_tlds2.default);
	
	// Gets all the links in the text, and returns them via the callback
	var linkStrategy = function linkStrategy(contentBlock, callback) {
	  var links = linkify.match(contentBlock.get('text'));
	  if (typeof links !== 'undefined' && links !== null) {
	    for (var i = 0; i < links.length; i += 1) {
	      callback(links[i].index, links[i].lastIndex);
	    }
	  }
	};
	
	exports.default = linkStrategy;

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _immutable = __webpack_require__(8);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var KEY_SEPARATOR = '-';
	
	var MultiDecorator = function () {
	  function MultiDecorator(decorators) {
	    _classCallCheck(this, MultiDecorator);
	
	    this.decorators = _immutable2.default.List(decorators);
	  }
	
	  /**
	   * Return list of decoration IDs per character
	   *
	   * @param {ContentBlock} block
	   * @return {List<String>}
	   */
	
	
	  _createClass(MultiDecorator, [{
	    key: 'getDecorations',
	    value: function getDecorations(block) {
	      var decorations = new Array(block.getText().length).fill(null);
	
	      this.decorators.forEach(function (decorator, i) {
	        var subDecorations = decorator.getDecorations(block);
	
	        subDecorations.forEach(function (key, offset) {
	          if (!key) {
	            return;
	          }
	
	          decorations[offset] = i + KEY_SEPARATOR + key;
	        });
	      });
	
	      return _immutable2.default.List(decorations);
	    }
	
	    /**
	     * Return component to render a decoration
	     *
	     * @param {String} key
	     * @return {Function}
	     */
	
	  }, {
	    key: 'getComponentForKey',
	    value: function getComponentForKey(key) {
	      var decorator = this.getDecoratorForKey(key);
	      return decorator.getComponentForKey(MultiDecorator.getInnerKey(key));
	    }
	
	    /**
	     * Return props to render a decoration
	     *
	     * @param {String} key
	     * @return {Object}
	     */
	
	  }, {
	    key: 'getPropsForKey',
	    value: function getPropsForKey(key) {
	      var decorator = this.getDecoratorForKey(key);
	      return decorator.getPropsForKey(MultiDecorator.getInnerKey(key));
	    }
	
	    /**
	     * Return a decorator for a specific key
	     *
	     * @param {String} key
	     * @return {Decorator}
	     */
	
	  }, {
	    key: 'getDecoratorForKey',
	    value: function getDecoratorForKey(key) {
	      var parts = key.split(KEY_SEPARATOR);
	      var index = Number(parts[0]);
	
	      return this.decorators.get(index);
	    }
	
	    /**
	     * Return inner key for a decorator
	     *
	     * @param {String} key
	     * @return {String}
	     */
	
	  }], [{
	    key: 'getInnerKey',
	    value: function getInnerKey(key) {
	      var parts = key.split(KEY_SEPARATOR);
	      return parts.slice(1).join(KEY_SEPARATOR);
	    }
	  }]);
	
	  return MultiDecorator;
	}();
	
	module.exports = MultiDecorator;

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * Creates a composite decorator based on the provided plugins
	                                                                                                                                                                                                                                                                   */
	
	var _immutable = __webpack_require__(8);
	
	var _draftJs = __webpack_require__(39);
	
	var _decorateComponentWithProps = __webpack_require__(527);
	
	var _decorateComponentWithProps2 = _interopRequireDefault(_decorateComponentWithProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (decorators, getEditorState, setEditorState) {
	  var convertedDecorators = (0, _immutable.List)(decorators).map(function (decorator) {
	    return _extends({}, decorator, {
	      component: (0, _decorateComponentWithProps2.default)(decorator.component, { getEditorState: getEditorState, setEditorState: setEditorState })
	    });
	  }).toJS();
	
	  return new _draftJs.CompositeDecorator(convertedDecorators);
	};

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.keyBindingFn = keyBindingFn;
	
	var _draftJs = __webpack_require__(39);
	
	/**
	 * Handle default key bindings.
	 *
	 * @param {Event} event
	 * @return {String} defaultCommand
	 */
	function keyBindingFn(event) {
	  return (0, _draftJs.getDefaultKeyBinding)(event);
	}

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _draftJs = __webpack_require__(39);
	
	var _immutable = __webpack_require__(8);
	
	var _MultiDecorator = __webpack_require__(1042);
	
	var _MultiDecorator2 = _interopRequireDefault(_MultiDecorator);
	
	var _createCompositeDecorator = __webpack_require__(1043);
	
	var _createCompositeDecorator2 = _interopRequireDefault(_createCompositeDecorator);
	
	var _moveSelectionToEnd = __webpack_require__(1046);
	
	var _moveSelectionToEnd2 = _interopRequireDefault(_moveSelectionToEnd);
	
	var _proxies = __webpack_require__(1047);
	
	var _proxies2 = _interopRequireDefault(_proxies);
	
	var _defaultKeyBindingPlugin = __webpack_require__(1044);
	
	var defaultKeyBindingPlugin = _interopRequireWildcard(_defaultKeyBindingPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-continue */
	
	
	/**
	 * The main editor component
	 */
	var PluginEditor = function (_Component) {
	  _inherits(PluginEditor, _Component);
	
	  function PluginEditor(props) {
	    _classCallCheck(this, PluginEditor);
	
	    var _this = _possibleConstructorReturn(this, (PluginEditor.__proto__ || Object.getPrototypeOf(PluginEditor)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var plugins = [_this.props].concat(_toConsumableArray(_this.resolvePlugins()));
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = plugins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var plugin = _step.value;
	
	        if (typeof plugin.initialize !== 'function') continue;
	        plugin.initialize(_this.getPluginMethods());
	      }
	
	      // attach proxy methods like `focus` or `blur`
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	      var _loop = function _loop() {
	        var method = _step2.value;
	
	        _this[method] = function () {
	          var _this$editor;
	
	          return (_this$editor = _this.editor)[method].apply(_this$editor, arguments);
	        };
	      };
	
	      for (var _iterator2 = _proxies2.default[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	        _loop();
	      }
	    } catch (err) {
	      _didIteratorError2 = true;
	      _iteratorError2 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion2 && _iterator2.return) {
	          _iterator2.return();
	        }
	      } finally {
	        if (_didIteratorError2) {
	          throw _iteratorError2;
	        }
	      }
	    }
	
	    _this.state = {}; // TODO for Nik: ask ben why this is relevent
	    return _this;
	  }
	
	  _createClass(PluginEditor, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var decorators = this.resolveDecorators();
	      var compositeDecorator = (0, _createCompositeDecorator2.default)(decorators.filter(function (decorator) {
	        return !_this2.decoratorIsCustom(decorator);
	      }), this.getEditorState, this.onChange);
	
	      var customDecorators = decorators.filter(function (decorator) {
	        return _this2.decoratorIsCustom(decorator);
	      });
	
	      var multiDecorator = new _MultiDecorator2.default([].concat(_toConsumableArray(customDecorators), [compositeDecorator]));
	
	      var editorState = _draftJs.EditorState.set(this.props.editorState, { decorator: multiDecorator });
	      this.onChange((0, _moveSelectionToEnd2.default)(editorState));
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _this3 = this;
	
	      this.resolvePlugins().forEach(function (plugin) {
	        if (plugin.willUnmount) {
	          plugin.willUnmount({
	            getEditorState: _this3.getEditorState,
	            setEditorState: _this3.onChange
	          });
	        }
	      });
	    }
	
	    // Cycle through the plugins, changing the editor state with what the plugins
	    // changed (or didn't)
	
	
	    // TODO further down in render we use readOnly={this.props.readOnly || this.state.readOnly}. Ask Ben why readOnly is here just from the props? Why would plugins use this instead of just taking it from getProps?
	
	
	    // Return true if decorator implements the DraftDecoratorType interface
	    // @see https://github.com/facebook/draft-js/blob/master/src/model/decorators/DraftDecoratorType.js
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var pluginHooks = this.createPluginHooks();
	      var customStyleMap = this.resolveCustomStyleMap();
	      var accessibilityProps = this.resolveAccessibilityProps();
	      var blockRenderMap = this.resolveblockRenderMap();
	      return _react2.default.createElement(_draftJs.Editor, _extends({}, this.props, accessibilityProps, pluginHooks, {
	        readOnly: this.props.readOnly || this.state.readOnly,
	        customStyleMap: customStyleMap,
	        blockRenderMap: blockRenderMap,
	        onChange: this.onChange,
	        editorState: this.props.editorState,
	        ref: function ref(element) {
	          _this4.editor = element;
	        }
	      }));
	    }
	  }]);
	
	  return PluginEditor;
	}(_react.Component);
	
	PluginEditor.propTypes = {
	  editorState: _react2.default.PropTypes.object.isRequired,
	  onChange: _react2.default.PropTypes.func.isRequired,
	  plugins: _react2.default.PropTypes.array,
	  defaultKeyBindings: _react2.default.PropTypes.bool,
	  defaultBlockRenderMap: _react2.default.PropTypes.bool,
	  customStyleMap: _react2.default.PropTypes.object,
	  decorators: _react2.default.PropTypes.array
	};
	PluginEditor.defaultProps = {
	  defaultBlockRenderMap: true,
	  defaultKeyBindings: true,
	  customStyleMap: {},
	  plugins: [],
	  decorators: []
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this5 = this;
	
	  this.onChange = function (editorState) {
	    var newEditorState = editorState;
	    _this5.resolvePlugins().forEach(function (plugin) {
	      if (plugin.onChange) {
	        newEditorState = plugin.onChange(newEditorState, _this5.getPluginMethods());
	      }
	    });
	
	    if (_this5.props.onChange) {
	      _this5.props.onChange(newEditorState, _this5.getPluginMethods());
	    }
	  };
	
	  this.getPlugins = function () {
	    return _this5.props.plugins.slice(0);
	  };
	
	  this.getProps = function () {
	    return _extends({}, _this5.props);
	  };
	
	  this.getReadOnly = function () {
	    return _this5.props.readOnly;
	  };
	
	  this.setReadOnly = function (readOnly) {
	    if (readOnly !== _this5.state.readOnly) _this5.setState({ readOnly: readOnly });
	  };
	
	  this.getEditorRef = function () {
	    return _this5.editor;
	  };
	
	  this.getEditorState = function () {
	    return _this5.props.editorState;
	  };
	
	  this.getPluginMethods = function () {
	    return {
	      getPlugins: _this5.getPlugins,
	      getProps: _this5.getProps,
	      setEditorState: _this5.onChange,
	      getEditorState: _this5.getEditorState,
	      getReadOnly: _this5.getReadOnly,
	      setReadOnly: _this5.setReadOnly,
	      getEditorRef: _this5.getEditorRef
	    };
	  };
	
	  this.createEventHooks = function (methodName, plugins) {
	    return function () {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      var newArgs = [].slice.apply(args);
	      newArgs.push(_this5.getPluginMethods());
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = plugins[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var plugin = _step3.value;
	
	          if (typeof plugin[methodName] !== 'function') continue;
	          var result = plugin[methodName].apply(plugin, _toConsumableArray(newArgs));
	          if (result === true) return true;
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	
	      return false;
	    };
	  };
	
	  this.createHandleHooks = function (methodName, plugins) {
	    return function () {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      var newArgs = [].slice.apply(args);
	      newArgs.push(_this5.getPluginMethods());
	      var _iteratorNormalCompletion4 = true;
	      var _didIteratorError4 = false;
	      var _iteratorError4 = undefined;
	
	      try {
	        for (var _iterator4 = plugins[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	          var plugin = _step4.value;
	
	          if (typeof plugin[methodName] !== 'function') continue;
	          var result = plugin[methodName].apply(plugin, _toConsumableArray(newArgs));
	          if (result === 'handled') return 'handled';
	        }
	      } catch (err) {
	        _didIteratorError4 = true;
	        _iteratorError4 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion4 && _iterator4.return) {
	            _iterator4.return();
	          }
	        } finally {
	          if (_didIteratorError4) {
	            throw _iteratorError4;
	          }
	        }
	      }
	
	      return 'not-handled';
	    };
	  };
	
	  this.createFnHooks = function (methodName, plugins) {
	    return function () {
	      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	
	      var newArgs = [].slice.apply(args);
	
	      newArgs.push(_this5.getPluginMethods());
	
	      if (methodName === 'blockRendererFn') {
	        var block = { props: {} };
	        var _iteratorNormalCompletion5 = true;
	        var _didIteratorError5 = false;
	        var _iteratorError5 = undefined;
	
	        try {
	          for (var _iterator5 = plugins[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	            var plugin = _step5.value;
	
	            if (typeof plugin[methodName] !== 'function') continue;
	            var result = plugin[methodName].apply(plugin, _toConsumableArray(newArgs));
	            if (result !== undefined && result !== null) {
	              var pluginProps = result.props;
	
	              var pluginRest = _objectWithoutProperties(result, ['props']); // eslint-disable-line no-use-before-define
	
	
	              var _block = block;
	              var props = _block.props;
	
	              var rest = _objectWithoutProperties(_block, ['props']); // eslint-disable-line no-use-before-define
	
	
	              block = _extends({}, rest, pluginRest, { props: _extends({}, props, pluginProps) });
	            }
	          }
	        } catch (err) {
	          _didIteratorError5 = true;
	          _iteratorError5 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion5 && _iterator5.return) {
	              _iterator5.return();
	            }
	          } finally {
	            if (_didIteratorError5) {
	              throw _iteratorError5;
	            }
	          }
	        }
	
	        return block.component ? block : false;
	      } else if (methodName === 'blockStyleFn') {
	        var styles = void 0;
	        var _iteratorNormalCompletion6 = true;
	        var _didIteratorError6 = false;
	        var _iteratorError6 = undefined;
	
	        try {
	          for (var _iterator6 = plugins[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	            var _plugin = _step6.value;
	
	            if (typeof _plugin[methodName] !== 'function') continue;
	            var _result = _plugin[methodName].apply(_plugin, _toConsumableArray(newArgs));
	            if (_result !== undefined) {
	              styles = (styles ? styles + ' ' : '') + _result;
	            }
	          }
	        } catch (err) {
	          _didIteratorError6 = true;
	          _iteratorError6 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion6 && _iterator6.return) {
	              _iterator6.return();
	            }
	          } finally {
	            if (_didIteratorError6) {
	              throw _iteratorError6;
	            }
	          }
	        }
	
	        return styles || false;
	      }
	
	      var _iteratorNormalCompletion7 = true;
	      var _didIteratorError7 = false;
	      var _iteratorError7 = undefined;
	
	      try {
	        for (var _iterator7 = plugins[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
	          var _plugin2 = _step7.value;
	
	          if (typeof _plugin2[methodName] !== 'function') continue;
	          var _result2 = _plugin2[methodName].apply(_plugin2, _toConsumableArray(newArgs));
	          if (_result2 !== undefined) {
	            return _result2;
	          }
	        }
	      } catch (err) {
	        _didIteratorError7 = true;
	        _iteratorError7 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion7 && _iterator7.return) {
	            _iterator7.return();
	          }
	        } finally {
	          if (_didIteratorError7) {
	            throw _iteratorError7;
	          }
	        }
	      }
	
	      return false;
	    };
	  };
	
	  this.createPluginHooks = function () {
	    var pluginHooks = {};
	    var eventHookKeys = [];
	    var handleHookKeys = [];
	    var fnHookKeys = [];
	    var plugins = [_this5.props].concat(_toConsumableArray(_this5.resolvePlugins()));
	
	    plugins.forEach(function (plugin) {
	      Object.keys(plugin).forEach(function (attrName) {
	        if (attrName === 'onChange') return;
	
	        // if `attrName` has been added as a hook key already, ignore this one
	        if (eventHookKeys.indexOf(attrName) !== -1 || fnHookKeys.indexOf(attrName) !== -1) return;
	
	        var isEventHookKey = attrName.indexOf('on') === 0;
	        if (isEventHookKey) {
	          eventHookKeys.push(attrName);
	          return;
	        }
	
	        var isHandleHookKey = attrName.indexOf('handle') === 0;
	        if (isHandleHookKey) {
	          handleHookKeys.push(attrName);
	          return;
	        }
	
	        // checks if `attrName` ends with 'Fn'
	        var isFnHookKey = attrName.length - 2 === attrName.indexOf('Fn');
	        if (isFnHookKey) {
	          fnHookKeys.push(attrName);
	        }
	      });
	    });
	
	    eventHookKeys.forEach(function (attrName) {
	      pluginHooks[attrName] = _this5.createEventHooks(attrName, plugins);
	    });
	
	    handleHookKeys.forEach(function (attrName) {
	      pluginHooks[attrName] = _this5.createHandleHooks(attrName, plugins);
	    });
	
	    fnHookKeys.forEach(function (attrName) {
	      pluginHooks[attrName] = _this5.createFnHooks(attrName, plugins);
	    });
	
	    return pluginHooks;
	  };
	
	  this.resolvePlugins = function () {
	    var plugins = _this5.props.plugins.slice(0);
	    if (_this5.props.defaultKeyBindings) {
	      plugins.push(defaultKeyBindingPlugin);
	    }
	
	    return plugins;
	  };
	
	  this.resolveDecorators = function () {
	    var _props = _this5.props;
	    var decorators = _props.decorators;
	    var plugins = _props.plugins;
	
	    return (0, _immutable.List)([{ decorators: decorators }].concat(_toConsumableArray(plugins))).filter(function (plugin) {
	      return plugin.decorators !== undefined;
	    }).flatMap(function (plugin) {
	      return plugin.decorators;
	    });
	  };
	
	  this.decoratorIsCustom = function (decorator) {
	    return typeof decorator.getDecorations === 'function' && typeof decorator.getComponentForKey === 'function' && typeof decorator.getPropsForKey === 'function';
	  };
	
	  this.resolveCustomStyleMap = function () {
	    return _this5.props.plugins.filter(function (plug) {
	      return plug.customStyleMap !== undefined;
	    }).map(function (plug) {
	      return plug.customStyleMap;
	    }).concat([_this5.props.customStyleMap]).reduce(function (styles, style) {
	      return _extends({}, styles, style);
	    }, {});
	  };
	
	  this.resolveblockRenderMap = function () {
	    var blockRenderMap = _this5.props.plugins.filter(function (plug) {
	      return plug.blockRenderMap !== undefined;
	    }).reduce(function (maps, plug) {
	      return maps.merge(plug.blockRenderMap);
	    }, (0, _immutable.Map)({}));
	    if (_this5.props.defaultBlockRenderMap) {
	      blockRenderMap = _draftJs.DefaultDraftBlockRenderMap.merge(blockRenderMap);
	    }
	    if (_this5.props.blockRenderMap) {
	      blockRenderMap = blockRenderMap.merge(_this5.props.blockRenderMap);
	    }
	    return blockRenderMap;
	  };
	
	  this.resolveAccessibilityProps = function () {
	    var accessibilityProps = {};
	    var plugins = [_this5.props].concat(_toConsumableArray(_this5.resolvePlugins()));
	    var _iteratorNormalCompletion8 = true;
	    var _didIteratorError8 = false;
	    var _iteratorError8 = undefined;
	
	    try {
	      for (var _iterator8 = plugins[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
	        var plugin = _step8.value;
	
	        if (typeof plugin.getAccessibilityProps !== 'function') continue;
	        var props = plugin.getAccessibilityProps();
	        var popupProps = {};
	
	        if (accessibilityProps.ariaHasPopup === undefined) {
	          popupProps.ariaHasPopup = props.ariaHasPopup;
	        } else if (props.ariaHasPopup === 'true') {
	          popupProps.ariaHasPopup = 'true';
	        }
	
	        if (accessibilityProps.ariaExpanded === undefined) {
	          popupProps.ariaExpanded = props.ariaExpanded;
	        } else if (props.ariaExpanded === 'true') {
	          popupProps.ariaExpanded = 'true';
	        }
	
	        accessibilityProps = _extends({}, accessibilityProps, props, popupProps);
	      }
	    } catch (err) {
	      _didIteratorError8 = true;
	      _iteratorError8 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion8 && _iterator8.return) {
	          _iterator8.return();
	        }
	      } finally {
	        if (_didIteratorError8) {
	          throw _iteratorError8;
	        }
	      }
	    }
	
	    return accessibilityProps;
	  };
	};
	
	exports.default = PluginEditor;

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _draftJs = __webpack_require__(39);
	
	/**
	 * Returns a new EditorState where the Selection is at the end.
	 *
	 * This ensures to mimic the textarea behaviour where the Selection is placed at
	 * the end. This is needed when blocks (like stickers or other media) are added
	 * without the editor having had focus yet. It still works to place the
	 * Selection at a specific location by clicking on the text.
	 */
	var moveSelectionToEnd = function moveSelectionToEnd(editorState) {
	  var content = editorState.getCurrentContent();
	  var blockMap = content.getBlockMap();
	
	  var key = blockMap.last().getKey();
	  var length = blockMap.last().getLength();
	
	  var selection = new _draftJs.SelectionState({
	    anchorKey: key,
	    anchorOffset: length,
	    focusKey: key,
	    focusOffset: length
	  });
	
	  return _draftJs.EditorState.acceptSelection(editorState, selection);
	};
	
	exports.default = moveSelectionToEnd;

/***/ }),
/* 1047 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// the list of available proxies can be found here: https://github.com/facebook/draft-js/blob/master/src/component/base/DraftEditor.react.js#L120
	var proxies = ['focus', 'blur', 'setMode', 'exitCurrentMode', 'restoreEditorDOM', 'setRenderGuard', 'removeRenderGuard', 'setClipboard', 'getClipboard', 'getEditorKey', 'update', 'onDragEnter', 'onDragLeave'];
	
	exports.default = proxies;

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.composeDecorators = exports.createEditorStateWithText = exports.default = undefined;
	
	var _createEditorStateWithText = __webpack_require__(1050);
	
	var _createEditorStateWithText2 = _interopRequireDefault(_createEditorStateWithText);
	
	var _composeDecorators = __webpack_require__(1049);
	
	var _composeDecorators2 = _interopRequireDefault(_composeDecorators);
	
	var _Editor = __webpack_require__(1045);
	
	var _Editor2 = _interopRequireDefault(_Editor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Editor2.default;
	
	// eslint-disable-next-line import/no-named-as-default
	
	var createEditorStateWithText = exports.createEditorStateWithText = _createEditorStateWithText2.default;
	var composeDecorators = exports.composeDecorators = _composeDecorators2.default;

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	// This code originally has been copied from Recompose
	// https://github.com/acdlite/recompose/blob/master/src/packages/recompose/compose.js
	exports.default = function () {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  var last = funcs[funcs.length - 1];
	  return function () {
	    var result = last.apply(undefined, arguments);
	    for (var i = funcs.length - 2; i >= 0; i -= 1) {
	      var f = funcs[i];
	      result = f(result);
	    }
	    return result;
	  };
	};

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _draftJs = __webpack_require__(39);
	
	exports.default = function (text) {
	  return _draftJs.EditorState.createWithContent(_draftJs.ContentState.createFromText(text));
	}; /**
	    * Create an editor state with some text in it already
	    */

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule AtomicBlockUtils
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var BlockMapBuilder = __webpack_require__(213);
	var CharacterMetadata = __webpack_require__(94);
	var ContentBlock = __webpack_require__(158);
	var DraftModifier = __webpack_require__(63);
	var EditorState = __webpack_require__(24);
	var Immutable = __webpack_require__(28);
	
	var generateRandomKey = __webpack_require__(100);
	
	var List = Immutable.List;
	var Repeat = Immutable.Repeat;
	
	
	var AtomicBlockUtils = {
	  insertAtomicBlock: function insertAtomicBlock(editorState, entityKey, character) {
	    var contentState = editorState.getCurrentContent();
	    var selectionState = editorState.getSelection();
	
	    var afterRemoval = DraftModifier.removeRange(contentState, selectionState, 'backward');
	
	    var targetSelection = afterRemoval.getSelectionAfter();
	    var afterSplit = DraftModifier.splitBlock(afterRemoval, targetSelection);
	    var insertionTarget = afterSplit.getSelectionAfter();
	
	    var asAtomicBlock = DraftModifier.setBlockType(afterSplit, insertionTarget, 'atomic');
	
	    var charData = CharacterMetadata.create({ entity: entityKey });
	
	    var fragmentArray = [new ContentBlock({
	      key: generateRandomKey(),
	      type: 'atomic',
	      text: character,
	      characterList: List(Repeat(charData, character.length))
	    }), new ContentBlock({
	      key: generateRandomKey(),
	      type: 'unstyled',
	      text: '',
	      characterList: List()
	    })];
	
	    var fragment = BlockMapBuilder.createFromArray(fragmentArray);
	
	    var withAtomicBlock = DraftModifier.replaceWithFragment(asAtomicBlock, insertionTarget, fragment);
	
	    var newContent = withAtomicBlock.merge({
	      selectionBefore: selectionState,
	      selectionAfter: withAtomicBlock.getSelectionAfter().set('hasFocus', true)
	    });
	
	    return EditorState.push(editorState, newContent, 'insert-fragment');
	  }
	};
	
	module.exports = AtomicBlockUtils;

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CompositeDraftDecorator
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Immutable = __webpack_require__(28);
	
	var List = Immutable.List;
	
	
	var DELIMITER = '.';
	
	/**
	 * A CompositeDraftDecorator traverses through a list of DraftDecorator
	 * instances to identify sections of a ContentBlock that should be rendered
	 * in a "decorated" manner. For example, hashtags, mentions, and links may
	 * be intended to stand out visually, be rendered as anchors, etc.
	 *
	 * The list of decorators supplied to the constructor will be used in the
	 * order they are provided. This allows the caller to specify a priority for
	 * string matching, in case of match collisions among decorators.
	 *
	 * For instance, I may have a link with a `#` in its text. Though this section
	 * of text may match our hashtag decorator, it should not be treated as a
	 * hashtag. I should therefore list my link DraftDecorator
	 * before my hashtag DraftDecorator when constructing this composite
	 * decorator instance.
	 *
	 * Thus, when a collision like this is encountered, the earlier match is
	 * preserved and the new match is discarded.
	 */
	
	var CompositeDraftDecorator = function () {
	  function CompositeDraftDecorator(decorators) {
	    _classCallCheck(this, CompositeDraftDecorator);
	
	    // Copy the decorator array, since we use this array order to determine
	    // precedence of decoration matching. If the array is mutated externally,
	    // we don't want to be affected here.
	    this._decorators = decorators.slice();
	  }
	
	  CompositeDraftDecorator.prototype.getDecorations = function getDecorations(block) {
	    var decorations = Array(block.getText().length).fill(null);
	
	    this._decorators.forEach(function ( /*object*/decorator, /*number*/ii) {
	      var counter = 0;
	      var strategy = decorator.strategy;
	      strategy(block, function ( /*number*/start, /*number*/end) {
	        // Find out if any of our matching range is already occupied
	        // by another decorator. If so, discard the match. Otherwise, store
	        // the component key for rendering.
	        if (canOccupySlice(decorations, start, end)) {
	          occupySlice(decorations, start, end, ii + DELIMITER + counter);
	          counter++;
	        }
	      });
	    });
	
	    return List(decorations);
	  };
	
	  CompositeDraftDecorator.prototype.getComponentForKey = function getComponentForKey(key) {
	    var componentKey = parseInt(key.split(DELIMITER)[0], 10);
	    return this._decorators[componentKey].component;
	  };
	
	  CompositeDraftDecorator.prototype.getPropsForKey = function getPropsForKey(key) {
	    var componentKey = parseInt(key.split(DELIMITER)[0], 10);
	    return this._decorators[componentKey].props;
	  };
	
	  return CompositeDraftDecorator;
	}();
	
	/**
	 * Determine whether we can occupy the specified slice of the decorations
	 * array.
	 */
	
	
	function canOccupySlice(decorations, start, end) {
	  for (var ii = start; ii < end; ii++) {
	    if (decorations[ii] != null) {
	      return false;
	    }
	  }
	  return true;
	}
	
	/**
	 * Splice the specified component into our decoration array at the desired
	 * range.
	 */
	function occupySlice(targetArr, start, end, componentKey) {
	  for (var ii = start; ii < end; ii++) {
	    targetArr[ii] = componentKey;
	  }
	}
	
	module.exports = CompositeDraftDecorator;

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ContentStateInlineStyle
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var CharacterMetadata = __webpack_require__(94);
	
	var _require = __webpack_require__(28);
	
	var Map = _require.Map;
	
	
	var ContentStateInlineStyle = {
	  add: function add(contentState, selectionState, inlineStyle) {
	    return modifyInlineStyle(contentState, selectionState, inlineStyle, true);
	  },
	
	  remove: function remove(contentState, selectionState, inlineStyle) {
	    return modifyInlineStyle(contentState, selectionState, inlineStyle, false);
	  }
	};
	
	function modifyInlineStyle(contentState, selectionState, inlineStyle, addOrRemove) {
	  var blockMap = contentState.getBlockMap();
	  var startKey = selectionState.getStartKey();
	  var startOffset = selectionState.getStartOffset();
	  var endKey = selectionState.getEndKey();
	  var endOffset = selectionState.getEndOffset();
	
	  var newBlocks = blockMap.skipUntil(function (_, k) {
	    return k === startKey;
	  }).takeUntil(function (_, k) {
	    return k === endKey;
	  }).concat(Map([[endKey, blockMap.get(endKey)]])).map(function (block, blockKey) {
	    var sliceStart;
	    var sliceEnd;
	
	    if (startKey === endKey) {
	      sliceStart = startOffset;
	      sliceEnd = endOffset;
	    } else {
	      sliceStart = blockKey === startKey ? startOffset : 0;
	      sliceEnd = blockKey === endKey ? endOffset : block.getLength();
	    }
	
	    var chars = block.getCharacterList();
	    var current;
	    while (sliceStart < sliceEnd) {
	      current = chars.get(sliceStart);
	      chars = chars.set(sliceStart, addOrRemove ? CharacterMetadata.applyStyle(current, inlineStyle) : CharacterMetadata.removeStyle(current, inlineStyle));
	      sliceStart++;
	    }
	
	    return block.set('characterList', chars);
	  });
	
	  return contentState.merge({
	    blockMap: blockMap.merge(newBlocks),
	    selectionBefore: selectionState,
	    selectionAfter: selectionState
	  });
	}
	
	module.exports = ContentStateInlineStyle;

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditor.react
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(20);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DefaultDraftBlockRenderMap = __webpack_require__(357);
	var DefaultDraftInlineStyle = __webpack_require__(533);
	var DraftEditorCompositionHandler = __webpack_require__(1055);
	var DraftEditorContents = __webpack_require__(1056);
	var DraftEditorDragHandler = __webpack_require__(1057);
	var DraftEditorEditHandler = __webpack_require__(1058);
	var DraftEditorPlaceholder = __webpack_require__(1060);
	var EditorState = __webpack_require__(24);
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(22);
	var Scroll = __webpack_require__(560);
	var Style = __webpack_require__(366);
	var UserAgent = __webpack_require__(101);
	
	var cx = __webpack_require__(215);
	var emptyFunction = __webpack_require__(59);
	var generateRandomKey = __webpack_require__(100);
	var getDefaultKeyBinding = __webpack_require__(539);
	var nullthrows = __webpack_require__(81);
	var getScrollPosition = __webpack_require__(369);
	
	var isIE = UserAgent.isBrowser('IE');
	
	// IE does not support the `input` event on contentEditable, so we can't
	// observe spellcheck behavior.
	var allowSpellCheck = !isIE;
	
	// Define a set of handler objects to correspond to each possible `mode`
	// of editor behavior.
	var handlerMap = {
	  'edit': DraftEditorEditHandler,
	  'composite': DraftEditorCompositionHandler,
	  'drag': DraftEditorDragHandler,
	  'cut': null,
	  'render': null
	};
	
	/**
	 * `DraftEditor` is the root editor component. It composes a `contentEditable`
	 * div, and provides a wide variety of useful function props for managing the
	 * state of the editor. See `DraftEditorProps` for details.
	 */
	var DraftEditor = function (_React$Component) {
	  _inherits(DraftEditor, _React$Component);
	
	  function DraftEditor(props) {
	    _classCallCheck(this, DraftEditor);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this._blockSelectEvents = false;
	    _this._clipboard = null;
	    _this._guardAgainstRender = false;
	    _this._handler = null;
	    _this._dragCount = 0;
	    _this._editorKey = generateRandomKey();
	    _this._placeholderAccessibilityID = 'placeholder-' + _this._editorKey;
	
	    _this._onBeforeInput = _this._buildHandler('onBeforeInput');
	    _this._onBlur = _this._buildHandler('onBlur');
	    _this._onCharacterData = _this._buildHandler('onCharacterData');
	    _this._onCompositionEnd = _this._buildHandler('onCompositionEnd');
	    _this._onCompositionStart = _this._buildHandler('onCompositionStart');
	    _this._onCopy = _this._buildHandler('onCopy');
	    _this._onCut = _this._buildHandler('onCut');
	    _this._onDragEnd = _this._buildHandler('onDragEnd');
	    _this._onDragOver = _this._buildHandler('onDragOver');
	    _this._onDragStart = _this._buildHandler('onDragStart');
	    _this._onDrop = _this._buildHandler('onDrop');
	    _this._onInput = _this._buildHandler('onInput');
	    _this._onFocus = _this._buildHandler('onFocus');
	    _this._onKeyDown = _this._buildHandler('onKeyDown');
	    _this._onKeyPress = _this._buildHandler('onKeyPress');
	    _this._onKeyUp = _this._buildHandler('onKeyUp');
	    _this._onMouseDown = _this._buildHandler('onMouseDown');
	    _this._onMouseUp = _this._buildHandler('onMouseUp');
	    _this._onPaste = _this._buildHandler('onPaste');
	    _this._onSelect = _this._buildHandler('onSelect');
	
	    // Manual binding for public and internal methods.
	    _this.focus = _this._focus.bind(_this);
	    _this.blur = _this._blur.bind(_this);
	    _this.setMode = _this._setMode.bind(_this);
	    _this.exitCurrentMode = _this._exitCurrentMode.bind(_this);
	    _this.restoreEditorDOM = _this._restoreEditorDOM.bind(_this);
	    _this.setRenderGuard = _this._setRenderGuard.bind(_this);
	    _this.removeRenderGuard = _this._removeRenderGuard.bind(_this);
	    _this.setClipboard = _this._setClipboard.bind(_this);
	    _this.getClipboard = _this._getClipboard.bind(_this);
	    _this.getEditorKey = function () {
	      return _this._editorKey;
	    };
	    _this.update = _this._update.bind(_this);
	    _this.onDragEnter = _this._onDragEnter.bind(_this);
	    _this.onDragLeave = _this._onDragLeave.bind(_this);
	
	    // See `_restoreEditorDOM()`.
	    _this.state = { containerKey: 0 };
	    return _this;
	  }
	
	  /**
	   * Build a method that will pass the event to the specified handler method.
	   * This allows us to look up the correct handler function for the current
	   * editor mode, if any has been specified.
	   */
	
	
	  /**
	   * Define proxies that can route events to the current handler.
	   */
	
	
	  DraftEditor.prototype._buildHandler = function _buildHandler(eventName) {
	    var _this2 = this;
	
	    return function (e) {
	      if (!_this2.props.readOnly) {
	        var method = _this2._handler && _this2._handler[eventName];
	        method && method.call(_this2, e);
	      }
	    };
	  };
	
	  DraftEditor.prototype._showPlaceholder = function _showPlaceholder() {
	    return !!this.props.placeholder && !this.props.editorState.isInCompositionMode() && !this.props.editorState.getCurrentContent().hasText();
	  };
	
	  DraftEditor.prototype._renderPlaceholder = function _renderPlaceholder() {
	    if (this._showPlaceholder()) {
	      return React.createElement(DraftEditorPlaceholder, {
	        text: nullthrows(this.props.placeholder),
	        editorState: this.props.editorState,
	        textAlignment: this.props.textAlignment,
	        accessibilityID: this._placeholderAccessibilityID
	      });
	    }
	    return null;
	  };
	
	  DraftEditor.prototype.render = function render() {
	    var _props = this.props;
	    var readOnly = _props.readOnly;
	    var textAlignment = _props.textAlignment;
	
	    var rootClass = cx({
	      'DraftEditor/root': true,
	      'DraftEditor/alignLeft': textAlignment === 'left',
	      'DraftEditor/alignRight': textAlignment === 'right',
	      'DraftEditor/alignCenter': textAlignment === 'center'
	    });
	
	    var contentStyle = {
	      outline: 'none',
	      whiteSpace: 'pre-wrap',
	      wordWrap: 'break-word'
	    };
	
	    return React.createElement(
	      'div',
	      { className: rootClass },
	      this._renderPlaceholder(),
	      React.createElement(
	        'div',
	        {
	          className: cx('DraftEditor/editorContainer'),
	          key: 'editor' + this.state.containerKey,
	          ref: 'editorContainer' },
	        React.createElement(
	          'div',
	          {
	            'aria-activedescendant': readOnly ? null : this.props.ariaActiveDescendantID,
	            'aria-autocomplete': readOnly ? null : this.props.ariaAutoComplete,
	            'aria-describedby': this._showPlaceholder() ? this._placeholderAccessibilityID : null,
	            'aria-expanded': readOnly ? null : this.props.ariaExpanded,
	            'aria-haspopup': readOnly ? null : this.props.ariaHasPopup,
	            'aria-label': this.props.ariaLabel,
	            'aria-owns': readOnly ? null : this.props.ariaOwneeID,
	            className: cx('public/DraftEditor/content'),
	            contentEditable: !readOnly,
	            'data-testid': this.props.webDriverTestID,
	            onBeforeInput: this._onBeforeInput,
	            onBlur: this._onBlur,
	            onCompositionEnd: this._onCompositionEnd,
	            onCompositionStart: this._onCompositionStart,
	            onCopy: this._onCopy,
	            onCut: this._onCut,
	            onDragEnd: this._onDragEnd,
	            onDragEnter: this.onDragEnter,
	            onDragLeave: this.onDragLeave,
	            onDragOver: this._onDragOver,
	            onDragStart: this._onDragStart,
	            onDrop: this._onDrop,
	            onFocus: this._onFocus,
	            onInput: this._onInput,
	            onKeyDown: this._onKeyDown,
	            onKeyPress: this._onKeyPress,
	            onKeyUp: this._onKeyUp,
	            onMouseUp: this._onMouseUp,
	            onPaste: this._onPaste,
	            onSelect: this._onSelect,
	            ref: 'editor',
	            role: readOnly ? null : this.props.role || 'textbox',
	            spellCheck: allowSpellCheck && this.props.spellCheck,
	            style: contentStyle,
	            suppressContentEditableWarning: true,
	            tabIndex: this.props.tabIndex },
	          React.createElement(DraftEditorContents, {
	            blockRenderMap: this.props.blockRenderMap,
	            blockRendererFn: this.props.blockRendererFn,
	            blockStyleFn: this.props.blockStyleFn,
	            customStyleMap: _extends({}, DefaultDraftInlineStyle, this.props.customStyleMap),
	            customStyleFn: this.props.customStyleFn,
	            editorKey: this._editorKey,
	            editorState: this.props.editorState
	          })
	        )
	      )
	    );
	  };
	
	  DraftEditor.prototype.componentDidMount = function componentDidMount() {
	    this.setMode('edit');
	
	    /**
	     * IE has a hardcoded "feature" that attempts to convert link text into
	     * anchors in contentEditable DOM. This breaks the editor's expectations of
	     * the DOM, and control is lost. Disable it to make IE behave.
	     * See: http://blogs.msdn.com/b/ieinternals/archive/2010/09/15/
	     * ie9-beta-minor-change-list.aspx
	     */
	    if (isIE) {
	      document.execCommand('AutoUrlDetect', false, false);
	    }
	  };
	
	  /**
	   * Prevent selection events from affecting the current editor state. This
	   * is mostly intended to defend against IE, which fires off `selectionchange`
	   * events regardless of whether the selection is set via the browser or
	   * programmatically. We only care about selection events that occur because
	   * of browser interaction, not re-renders and forced selections.
	   */
	
	
	  DraftEditor.prototype.componentWillUpdate = function componentWillUpdate() {
	    this._blockSelectEvents = true;
	  };
	
	  DraftEditor.prototype.componentDidUpdate = function componentDidUpdate() {
	    this._blockSelectEvents = false;
	  };
	
	  /**
	   * Used via `this.focus()`.
	   *
	   * Force focus back onto the editor node.
	   *
	   * Forcing focus causes the browser to scroll to the top of the editor, which
	   * may be undesirable when the editor is taller than the viewport. To solve
	   * this, either use a specified scroll position (in cases like `cut` behavior
	   * where it should be restored to a known position) or store the current
	   * scroll state and put it back in place after focus has been forced.
	   */
	
	
	  DraftEditor.prototype._focus = function _focus(scrollPosition) {
	    var editorState = this.props.editorState;
	
	    var alreadyHasFocus = editorState.getSelection().getHasFocus();
	    var editorNode = ReactDOM.findDOMNode(this.refs.editor);
	
	    var scrollParent = Style.getScrollParent(editorNode);
	
	    var _ref = scrollPosition || getScrollPosition(scrollParent);
	
	    var x = _ref.x;
	    var y = _ref.y;
	
	
	    editorNode.focus();
	    if (scrollParent === window) {
	      window.scrollTo(x, y);
	    } else {
	      Scroll.setTop(scrollParent, y);
	    }
	
	    // On Chrome and Safari, calling focus on contenteditable focuses the
	    // cursor at the first character. This is something you don't expect when
	    // you're clicking on an input element but not directly on a character.
	    // Put the cursor back where it was before the blur.
	    if (!alreadyHasFocus) {
	      this.update(EditorState.forceSelection(editorState, editorState.getSelection()));
	    }
	  };
	
	  DraftEditor.prototype._blur = function _blur() {
	    ReactDOM.findDOMNode(this.refs.editor).blur();
	  };
	
	  /**
	   * Used via `this.setMode(...)`.
	   *
	   * Set the behavior mode for the editor component. This switches the current
	   * handler module to ensure that DOM events are managed appropriately for
	   * the active mode.
	   */
	
	
	  DraftEditor.prototype._setMode = function _setMode(mode) {
	    this._handler = handlerMap[mode];
	  };
	
	  DraftEditor.prototype._exitCurrentMode = function _exitCurrentMode() {
	    this.setMode('edit');
	  };
	
	  /**
	   * Used via `this.restoreEditorDOM()`.
	   *
	   * Force a complete re-render of the editor based on the current EditorState.
	   * This is useful when we know we are going to lose control of the DOM
	   * state (cut command, IME) and we want to make sure that reconciliation
	   * occurs on a version of the DOM that is synchronized with our EditorState.
	   */
	
	
	  DraftEditor.prototype._restoreEditorDOM = function _restoreEditorDOM(scrollPosition) {
	    var _this3 = this;
	
	    this.setState({ containerKey: this.state.containerKey + 1 }, function () {
	      _this3._focus(scrollPosition);
	    });
	  };
	
	  /**
	   * Guard against rendering. Intended for use when we need to manually
	   * reset editor contents, to ensure that no outside influences lead to
	   * React reconciliation when we are in an uncertain state.
	   */
	
	
	  DraftEditor.prototype._setRenderGuard = function _setRenderGuard() {
	    this._guardAgainstRender = true;
	  };
	
	  DraftEditor.prototype._removeRenderGuard = function _removeRenderGuard() {
	    this._guardAgainstRender = false;
	  };
	
	  /**
	   * Used via `this.setClipboard(...)`.
	   *
	   * Set the clipboard state for a cut/copy event.
	   */
	
	
	  DraftEditor.prototype._setClipboard = function _setClipboard(clipboard) {
	    this._clipboard = clipboard;
	  };
	
	  /**
	   * Used via `this.getClipboard()`.
	   *
	   * Retrieve the clipboard state for a cut/copy event.
	   */
	
	
	  DraftEditor.prototype._getClipboard = function _getClipboard() {
	    return this._clipboard;
	  };
	
	  /**
	   * Used via `this.update(...)`.
	   *
	   * Propagate a new `EditorState` object to higher-level components. This is
	   * the method by which event handlers inform the `DraftEditor` component of
	   * state changes. A component that composes a `DraftEditor` **must** provide
	   * an `onChange` prop to receive state updates passed along from this
	   * function.
	   */
	
	
	  DraftEditor.prototype._update = function _update(editorState) {
	    this.props.onChange(editorState);
	  };
	
	  /**
	   * Used in conjunction with `_onDragLeave()`, by counting the number of times
	   * a dragged element enters and leaves the editor (or any of its children),
	   * to determine when the dragged element absolutely leaves the editor.
	   */
	
	
	  DraftEditor.prototype._onDragEnter = function _onDragEnter() {
	    this._dragCount++;
	  };
	
	  /**
	   * See `_onDragEnter()`.
	   */
	
	
	  DraftEditor.prototype._onDragLeave = function _onDragLeave() {
	    this._dragCount--;
	    if (this._dragCount === 0) {
	      this.exitCurrentMode();
	    }
	  };
	
	  return DraftEditor;
	}(React.Component);
	
	DraftEditor.defaultProps = {
	  blockRenderMap: DefaultDraftBlockRenderMap,
	  blockRendererFn: emptyFunction.thatReturnsNull,
	  blockStyleFn: emptyFunction.thatReturns(''),
	  keyBindingFn: getDefaultKeyBinding,
	  readOnly: false,
	  spellCheck: false,
	  stripPastedStyles: false
	};
	
	
	module.exports = DraftEditor;

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorCompositionHandler
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(63);
	var EditorState = __webpack_require__(24);
	var Keys = __webpack_require__(365);
	
	var getEntityKeyForSelection = __webpack_require__(360);
	var isSelectionAtLeafStart = __webpack_require__(548);
	
	/**
	 * Millisecond delay to allow `compositionstart` to fire again upon
	 * `compositionend`.
	 *
	 * This is used for Korean input to ensure that typing can continue without
	 * the editor trying to render too quickly. More specifically, Safari 7.1+
	 * triggers `compositionstart` a little slower than Chrome/FF, which
	 * leads to composed characters being resolved and re-render occurring
	 * sooner than we want.
	 */
	var RESOLVE_DELAY = 20;
	
	/**
	 * A handful of variables used to track the current composition and its
	 * resolution status. These exist at the module level because it is not
	 * possible to have compositions occurring in multiple editors simultaneously,
	 * and it simplifies state management with respect to the DraftEditor component.
	 */
	var resolved = false;
	var stillComposing = false;
	var textInputData = '';
	
	var DraftEditorCompositionHandler = {
	  onBeforeInput: function onBeforeInput(e) {
	    textInputData = (textInputData || '') + e.data;
	  },
	
	  /**
	   * A `compositionstart` event has fired while we're still in composition
	   * mode. Continue the current composition session to prevent a re-render.
	   */
	  onCompositionStart: function onCompositionStart() {
	    stillComposing = true;
	  },
	
	  /**
	   * Attempt to end the current composition session.
	   *
	   * Defer handling because browser will still insert the chars into active
	   * element after `compositionend`. If a `compositionstart` event fires
	   * before `resolveComposition` executes, our composition session will
	   * continue.
	   *
	   * The `resolved` flag is useful because certain IME interfaces fire the
	   * `compositionend` event multiple times, thus queueing up multiple attempts
	   * at handling the composition. Since handling the same composition event
	   * twice could break the DOM, we only use the first event. Example: Arabic
	   * Google Input Tools on Windows 8.1 fires `compositionend` three times.
	   */
	  onCompositionEnd: function onCompositionEnd() {
	    var _this = this;
	
	    resolved = false;
	    stillComposing = false;
	    setTimeout(function () {
	      if (!resolved) {
	        DraftEditorCompositionHandler.resolveComposition.call(_this);
	      }
	    }, RESOLVE_DELAY);
	  },
	
	  /**
	   * In Safari, keydown events may fire when committing compositions. If
	   * the arrow keys are used to commit, prevent default so that the cursor
	   * doesn't move, otherwise it will jump back noticeably on re-render.
	   */
	  onKeyDown: function onKeyDown(e) {
	    if (e.which === Keys.RIGHT || e.which === Keys.LEFT) {
	      e.preventDefault();
	    }
	  },
	
	  /**
	   * Keypress events may fire when committing compositions. In Firefox,
	   * pressing RETURN commits the composition and inserts extra newline
	   * characters that we do not want. `preventDefault` allows the composition
	   * to be committed while preventing the extra characters.
	   */
	  onKeyPress: function onKeyPress(e) {
	    if (e.which === Keys.RETURN) {
	      e.preventDefault();
	    }
	  },
	
	  /**
	   * Attempt to insert composed characters into the document.
	   *
	   * If we are still in a composition session, do nothing. Otherwise, insert
	   * the characters into the document and terminate the composition session.
	   *
	   * If no characters were composed -- for instance, the user
	   * deleted all composed characters and committed nothing new --
	   * force a re-render. We also re-render when the composition occurs
	   * at the beginning of a leaf, to ensure that if the browser has
	   * created a new text node for the composition, we will discard it.
	   *
	   * Resetting innerHTML will move focus to the beginning of the editor,
	   * so we update to force it back to the correct place.
	   */
	  resolveComposition: function resolveComposition() {
	    if (stillComposing) {
	      return;
	    }
	
	    resolved = true;
	    var composedChars = textInputData;
	    textInputData = '';
	
	    var editorState = EditorState.set(this.props.editorState, {
	      inCompositionMode: false
	    });
	
	    var currentStyle = editorState.getCurrentInlineStyle();
	    var entityKey = getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection());
	
	    var mustReset = !composedChars || isSelectionAtLeafStart(editorState) || currentStyle.size > 0 || entityKey !== null;
	
	    if (mustReset) {
	      this.restoreEditorDOM();
	    }
	
	    this.exitCurrentMode();
	    this.removeRenderGuard();
	
	    if (composedChars) {
	      // If characters have been composed, re-rendering with the update
	      // is sufficient to reset the editor.
	      var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), composedChars, currentStyle, entityKey);
	      this.update(EditorState.push(editorState, contentState, 'insert-characters'));
	      return;
	    }
	
	    if (mustReset) {
	      this.update(EditorState.set(editorState, {
	        nativelyRenderedContent: null,
	        forceSelection: true
	      }));
	    }
	  }
	};
	
	module.exports = DraftEditorCompositionHandler;

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorContents.react
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(20);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DraftEditorBlock = __webpack_require__(534);
	var DraftOffsetKey = __webpack_require__(261);
	var EditorState = __webpack_require__(24);
	var React = __webpack_require__(1);
	
	var cx = __webpack_require__(215);
	var joinClasses = __webpack_require__(1351);
	var nullthrows = __webpack_require__(81);
	
	/**
	 * `DraftEditorContents` is the container component for all block components
	 * rendered for a `DraftEditor`. It is optimized to aggressively avoid
	 * re-rendering blocks whenever possible.
	 *
	 * This component is separate from `DraftEditor` because certain props
	 * (for instance, ARIA props) must be allowed to update without affecting
	 * the contents of the editor.
	 */
	var DraftEditorContents = function (_React$Component) {
	  _inherits(DraftEditorContents, _React$Component);
	
	  function DraftEditorContents() {
	    _classCallCheck(this, DraftEditorContents);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  DraftEditorContents.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    var prevEditorState = this.props.editorState;
	    var nextEditorState = nextProps.editorState;
	
	    var prevDirectionMap = prevEditorState.getDirectionMap();
	    var nextDirectionMap = nextEditorState.getDirectionMap();
	
	    // Text direction has changed for one or more blocks. We must re-render.
	    if (prevDirectionMap !== nextDirectionMap) {
	      return true;
	    }
	
	    var didHaveFocus = prevEditorState.getSelection().getHasFocus();
	    var nowHasFocus = nextEditorState.getSelection().getHasFocus();
	
	    if (didHaveFocus !== nowHasFocus) {
	      return true;
	    }
	
	    var nextNativeContent = nextEditorState.getNativelyRenderedContent();
	
	    var wasComposing = prevEditorState.isInCompositionMode();
	    var nowComposing = nextEditorState.isInCompositionMode();
	
	    // If the state is unchanged or we're currently rendering a natively
	    // rendered state, there's nothing new to be done.
	    if (prevEditorState === nextEditorState || nextNativeContent !== null && nextEditorState.getCurrentContent() === nextNativeContent || wasComposing && nowComposing) {
	      return false;
	    }
	
	    var prevContent = prevEditorState.getCurrentContent();
	    var nextContent = nextEditorState.getCurrentContent();
	    var prevDecorator = prevEditorState.getDecorator();
	    var nextDecorator = nextEditorState.getDecorator();
	    return wasComposing !== nowComposing || prevContent !== nextContent || prevDecorator !== nextDecorator || nextEditorState.mustForceSelection();
	  };
	
	  DraftEditorContents.prototype.render = function render() {
	    var _props = this.props;
	    var blockRenderMap = _props.blockRenderMap;
	    var blockRendererFn = _props.blockRendererFn;
	    var customStyleMap = _props.customStyleMap;
	    var customStyleFn = _props.customStyleFn;
	    var editorState = _props.editorState;
	
	
	    var content = editorState.getCurrentContent();
	    var selection = editorState.getSelection();
	    var forceSelection = editorState.mustForceSelection();
	    var decorator = editorState.getDecorator();
	    var directionMap = nullthrows(editorState.getDirectionMap());
	
	    var blocksAsArray = content.getBlocksAsArray();
	    var processedBlocks = [];
	    var currentDepth = null;
	    var lastWrapperTemplate = null;
	
	    for (var ii = 0; ii < blocksAsArray.length; ii++) {
	      var _block = blocksAsArray[ii];
	      var key = _block.getKey();
	      var blockType = _block.getType();
	
	      var customRenderer = blockRendererFn(_block);
	      var CustomComponent = void 0,
	          customProps = void 0,
	          customEditable = void 0;
	      if (customRenderer) {
	        CustomComponent = customRenderer.component;
	        customProps = customRenderer.props;
	        customEditable = customRenderer.editable;
	      }
	
	      var direction = directionMap.get(key);
	      var offsetKey = DraftOffsetKey.encode(key, 0, 0);
	      var componentProps = {
	        block: _block,
	        blockProps: customProps,
	        customStyleMap: customStyleMap,
	        customStyleFn: customStyleFn,
	        decorator: decorator,
	        direction: direction,
	        forceSelection: forceSelection,
	        key: key,
	        offsetKey: offsetKey,
	        selection: selection,
	        tree: editorState.getBlockTree(key)
	      };
	
	      var configForType = blockRenderMap.get(blockType);
	      var wrapperTemplate = configForType.wrapper;
	
	      var _Element = configForType.element || blockRenderMap.get('unstyled').element;
	
	      var depth = _block.getDepth();
	      var className = this.props.blockStyleFn(_block);
	
	      // List items are special snowflakes, since we handle nesting and
	      // counters manually.
	      if (_Element === 'li') {
	        var shouldResetCount = lastWrapperTemplate !== wrapperTemplate || currentDepth === null || depth > currentDepth;
	        className = joinClasses(className, getListItemClasses(blockType, depth, shouldResetCount, direction));
	      }
	
	      var Component = CustomComponent || DraftEditorBlock;
	      var childProps = {
	        className: className,
	        'data-block': true,
	        'data-editor': this.props.editorKey,
	        'data-offset-key': offsetKey,
	        key: key
	      };
	      if (customEditable !== undefined) {
	        childProps = _extends({}, childProps, {
	          contentEditable: customEditable,
	          suppressContentEditableWarning: true
	        });
	      }
	
	      var child = React.createElement(_Element, childProps, React.createElement(Component, componentProps));
	
	      processedBlocks.push({
	        block: child,
	        wrapperTemplate: wrapperTemplate,
	        key: key,
	        offsetKey: offsetKey
	      });
	
	      if (wrapperTemplate) {
	        currentDepth = _block.getDepth();
	      } else {
	        currentDepth = null;
	      }
	      lastWrapperTemplate = wrapperTemplate;
	    }
	
	    // Group contiguous runs of blocks that have the same wrapperTemplate
	    var outputBlocks = [];
	    for (var _ii = 0; _ii < processedBlocks.length;) {
	      var info = processedBlocks[_ii];
	      if (info.wrapperTemplate) {
	        var blocks = [];
	        do {
	          blocks.push(processedBlocks[_ii].block);
	          _ii++;
	        } while (_ii < processedBlocks.length && processedBlocks[_ii].wrapperTemplate === info.wrapperTemplate);
	        var wrapperElement = React.cloneElement(info.wrapperTemplate, {
	          key: info.key + '-wrap',
	          'data-offset-key': info.offsetKey
	        }, blocks);
	        outputBlocks.push(wrapperElement);
	      } else {
	        outputBlocks.push(info.block);
	        _ii++;
	      }
	    }
	
	    return React.createElement(
	      'div',
	      { 'data-contents': 'true' },
	      outputBlocks
	    );
	  };
	
	  return DraftEditorContents;
	}(React.Component);
	
	/**
	 * Provide default styling for list items. This way, lists will be styled with
	 * proper counters and indentation even if the caller does not specify
	 * their own styling at all. If more than five levels of nesting are needed,
	 * the necessary CSS classes can be provided via `blockStyleFn` configuration.
	 */
	
	
	function getListItemClasses(type, depth, shouldResetCount, direction) {
	  return cx({
	    'public/DraftStyleDefault/unorderedListItem': type === 'unordered-list-item',
	    'public/DraftStyleDefault/orderedListItem': type === 'ordered-list-item',
	    'public/DraftStyleDefault/reset': shouldResetCount,
	    'public/DraftStyleDefault/depth0': depth === 0,
	    'public/DraftStyleDefault/depth1': depth === 1,
	    'public/DraftStyleDefault/depth2': depth === 2,
	    'public/DraftStyleDefault/depth3': depth === 3,
	    'public/DraftStyleDefault/depth4': depth === 4,
	    'public/DraftStyleDefault/listLTR': direction === 'LTR',
	    'public/DraftStyleDefault/listRTL': direction === 'RTL'
	  });
	}
	
	module.exports = DraftEditorContents;

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorDragHandler
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var DataTransfer = __webpack_require__(558);
	var DraftModifier = __webpack_require__(63);
	var EditorState = __webpack_require__(24);
	
	var findAncestorOffsetKey = __webpack_require__(359);
	var getTextContentFromFiles = __webpack_require__(545);
	var getUpdatedSelectionState = __webpack_require__(546);
	var nullthrows = __webpack_require__(81);
	
	var isEventHandled = __webpack_require__(264);
	
	/**
	 * Get a SelectionState for the supplied mouse event.
	 */
	function getSelectionForEvent(event, editorState) {
	  var node = null;
	  var offset = null;
	
	  if (typeof document.caretRangeFromPoint === 'function') {
	    var dropRange = document.caretRangeFromPoint(event.x, event.y);
	    node = dropRange.startContainer;
	    offset = dropRange.startOffset;
	  } else if (event.rangeParent) {
	    node = event.rangeParent;
	    offset = event.rangeOffset;
	  } else {
	    return null;
	  }
	
	  node = nullthrows(node);
	  offset = nullthrows(offset);
	  var offsetKey = nullthrows(findAncestorOffsetKey(node));
	
	  return getUpdatedSelectionState(editorState, offsetKey, offset, offsetKey, offset);
	}
	
	var DraftEditorDragHandler = {
	  /**
	   * Drag originating from input terminated.
	   */
	  onDragEnd: function onDragEnd() {
	    this.exitCurrentMode();
	  },
	
	  /**
	   * Handle data being dropped.
	   */
	  onDrop: function onDrop(e) {
	    var _this = this;
	
	    var data = new DataTransfer(e.nativeEvent.dataTransfer);
	
	    var editorState = this.props.editorState;
	    var dropSelection = getSelectionForEvent(e.nativeEvent, editorState);
	
	    e.preventDefault();
	    this.exitCurrentMode();
	
	    if (dropSelection == null) {
	      return;
	    }
	
	    var files = data.getFiles();
	    if (files.length > 0) {
	      if (this.props.handleDroppedFiles && isEventHandled(this.props.handleDroppedFiles(dropSelection, files))) {
	        return;
	      }
	
	      getTextContentFromFiles(files, function (fileText) {
	        fileText && _this.update(insertTextAtSelection(editorState, nullthrows(dropSelection), // flow wtf
	        fileText));
	      });
	      return;
	    }
	
	    var dragType = this._internalDrag ? 'internal' : 'external';
	    if (this.props.handleDrop && isEventHandled(this.props.handleDrop(dropSelection, data, dragType))) {
	      return;
	    }
	
	    if (this._internalDrag) {
	      this.update(moveText(editorState, dropSelection));
	      return;
	    }
	
	    this.update(insertTextAtSelection(editorState, dropSelection, data.getText()));
	  }
	
	};
	
	function moveText(editorState, targetSelection) {
	  var newContentState = DraftModifier.moveText(editorState.getCurrentContent(), editorState.getSelection(), targetSelection);
	  return EditorState.push(editorState, newContentState, 'insert-fragment');
	}
	
	/**
	 * Insert text at a specified selection.
	 */
	function insertTextAtSelection(editorState, selection, text) {
	  var newContentState = DraftModifier.insertText(editorState.getCurrentContent(), selection, text, editorState.getCurrentInlineStyle());
	  return EditorState.push(editorState, newContentState, 'insert-fragment');
	}
	
	module.exports = DraftEditorDragHandler;

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorEditHandler
	 * 
	 */
	
	'use strict';
	
	var onBeforeInput = __webpack_require__(1075);
	var onBlur = __webpack_require__(1076);
	var onCompositionStart = __webpack_require__(1077);
	var onCopy = __webpack_require__(1078);
	var onCut = __webpack_require__(1079);
	var onDragOver = __webpack_require__(1080);
	var onDragStart = __webpack_require__(1081);
	var onFocus = __webpack_require__(1082);
	var onInput = __webpack_require__(1083);
	var onKeyDown = __webpack_require__(1084);
	var onPaste = __webpack_require__(1085);
	var onSelect = __webpack_require__(1086);
	
	var DraftEditorEditHandler = {
	  onBeforeInput: onBeforeInput,
	  onBlur: onBlur,
	  onCompositionStart: onCompositionStart,
	  onCopy: onCopy,
	  onCut: onCut,
	  onDragOver: onDragOver,
	  onDragStart: onDragStart,
	  onFocus: onFocus,
	  onInput: onInput,
	  onKeyDown: onKeyDown,
	  onPaste: onPaste,
	  onSelect: onSelect
	};
	
	module.exports = DraftEditorEditHandler;

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorLeaf.react
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(20);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DraftEditorTextNode = __webpack_require__(1061);
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(22);
	var SelectionState = __webpack_require__(182);
	
	var setDraftEditorSelection = __webpack_require__(1109);
	
	/**
	 * All leaf nodes in the editor are spans with single text nodes. Leaf
	 * elements are styled based on the merging of an optional custom style map
	 * and a default style map.
	 *
	 * `DraftEditorLeaf` also provides a wrapper for calling into the imperative
	 * DOM Selection API. In this way, top-level components can declaratively
	 * maintain the selection state.
	 */
	var DraftEditorLeaf = function (_React$Component) {
	  _inherits(DraftEditorLeaf, _React$Component);
	
	  function DraftEditorLeaf() {
	    _classCallCheck(this, DraftEditorLeaf);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  /**
	   * By making individual leaf instances aware of their context within
	   * the text of the editor, we can set our selection range more
	   * easily than we could in the non-React world.
	   *
	   * Note that this depends on our maintaining tight control over the
	   * DOM structure of the TextEditor component. If leaves had multiple
	   * text nodes, this would be harder.
	   */
	  DraftEditorLeaf.prototype._setSelection = function _setSelection() {
	    var selection = this.props.selection;
	
	    // If selection state is irrelevant to the parent block, no-op.
	
	    if (selection == null || !selection.getHasFocus()) {
	      return;
	    }
	
	    var _props = this.props;
	    var blockKey = _props.blockKey;
	    var start = _props.start;
	    var text = _props.text;
	
	    var end = start + text.length;
	    if (!selection.hasEdgeWithin(blockKey, start, end)) {
	      return;
	    }
	
	    // Determine the appropriate target node for selection. If the child
	    // is not a text node, it is a <br /> spacer. In this case, use the
	    // <span> itself as the selection target.
	    var node = ReactDOM.findDOMNode(this);
	    var child = node.firstChild;
	    var targetNode = void 0;
	
	    if (child.nodeType === Node.TEXT_NODE) {
	      targetNode = child;
	    } else if (child.tagName === 'BR') {
	      targetNode = node;
	    } else {
	      targetNode = child.firstChild;
	    }
	
	    setDraftEditorSelection(selection, targetNode, blockKey, start, end);
	  };
	
	  DraftEditorLeaf.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    return ReactDOM.findDOMNode(this.refs.leaf).textContent !== nextProps.text || nextProps.styleSet !== this.props.styleSet || nextProps.forceSelection;
	  };
	
	  DraftEditorLeaf.prototype.componentDidUpdate = function componentDidUpdate() {
	    this._setSelection();
	  };
	
	  DraftEditorLeaf.prototype.componentDidMount = function componentDidMount() {
	    this._setSelection();
	  };
	
	  DraftEditorLeaf.prototype.render = function render() {
	    var text = this.props.text;
	
	    // If the leaf is at the end of its block and ends in a soft newline, append
	    // an extra line feed character. Browsers collapse trailing newline
	    // characters, which leaves the cursor in the wrong place after a
	    // shift+enter. The extra character repairs this.
	
	    if (text.endsWith('\n') && this.props.isLast) {
	      text += '\n';
	    }
	
	    var _props2 = this.props;
	    var customStyleMap = _props2.customStyleMap;
	    var customStyleFn = _props2.customStyleFn;
	    var offsetKey = _props2.offsetKey;
	    var styleSet = _props2.styleSet;
	
	    var styleObj = styleSet.reduce(function (map, styleName) {
	      var mergedStyles = {};
	      var style = customStyleMap[styleName];
	
	      if (style !== undefined && map.textDecoration !== style.textDecoration) {
	        // .trim() is necessary for IE9/10/11 and Edge
	        mergedStyles.textDecoration = [map.textDecoration, style.textDecoration].join(' ').trim();
	      }
	
	      return _assign(map, style, mergedStyles);
	    }, {});
	
	    if (customStyleFn) {
	      var newStyles = customStyleFn(styleSet);
	      styleObj = _assign(styleObj, newStyles);
	    }
	
	    return React.createElement(
	      'span',
	      {
	        'data-offset-key': offsetKey,
	        ref: 'leaf',
	        style: styleObj },
	      React.createElement(
	        DraftEditorTextNode,
	        null,
	        text
	      )
	    );
	  };
	
	  return DraftEditorLeaf;
	}(React.Component);
	
	module.exports = DraftEditorLeaf;

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorPlaceholder.react
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	
	var cx = __webpack_require__(215);
	
	/**
	 * This component is responsible for rendering placeholder text for the
	 * `DraftEditor` component.
	 *
	 * Override placeholder style via CSS.
	 */
	var DraftEditorPlaceholder = function (_React$Component) {
	  _inherits(DraftEditorPlaceholder, _React$Component);
	
	  function DraftEditorPlaceholder() {
	    _classCallCheck(this, DraftEditorPlaceholder);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  DraftEditorPlaceholder.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    return this.props.text !== nextProps.text || this.props.editorState.getSelection().getHasFocus() !== nextProps.editorState.getSelection().getHasFocus();
	  };
	
	  DraftEditorPlaceholder.prototype.render = function render() {
	    var hasFocus = this.props.editorState.getSelection().getHasFocus();
	
	    var className = cx({
	      'public/DraftEditorPlaceholder/root': true,
	      'public/DraftEditorPlaceholder/hasFocus': hasFocus
	    });
	
	    return React.createElement(
	      'div',
	      { className: className },
	      React.createElement(
	        'div',
	        {
	          className: cx('public/DraftEditorPlaceholder/inner'),
	          id: this.props.accessibilityID },
	        this.props.text
	      )
	    );
	  };
	
	  return DraftEditorPlaceholder;
	}(React.Component);
	
	module.exports = DraftEditorPlaceholder;

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorTextNode.react
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(22);
	var UserAgent = __webpack_require__(101);
	
	// In IE, spans with <br> tags render as two newlines. By rendering a span
	// with only a newline character, we can be sure to render a single line.
	var useNewlineChar = UserAgent.isBrowser('IE <= 11');
	
	/**
	 * Check whether the node should be considered a newline.
	 */
	function isNewline(node) {
	  return useNewlineChar ? node.textContent === '\n' : node.tagName === 'BR';
	}
	
	/**
	 * Placeholder elements for empty text content.
	 *
	 * What is this `data-text` attribute, anyway? It turns out that we need to
	 * put an attribute on the lowest-level text node in order to preserve correct
	 * spellcheck handling. If the <span> is naked, Chrome and Safari may do
	 * bizarre things to do the DOM -- split text nodes, create extra spans, etc.
	 * If the <span> has an attribute, this appears not to happen.
	 * See http://jsfiddle.net/9khdavod/ for the failure case, and
	 * http://jsfiddle.net/7pg143f7/ for the fixed case.
	 */
	var NEWLINE_A = useNewlineChar ? React.createElement(
	  'span',
	  { key: 'A', 'data-text': 'true' },
	  '\n'
	) : React.createElement('br', { key: 'A', 'data-text': 'true' });
	
	var NEWLINE_B = useNewlineChar ? React.createElement(
	  'span',
	  { key: 'B', 'data-text': 'true' },
	  '\n'
	) : React.createElement('br', { key: 'B', 'data-text': 'true' });
	
	/**
	 * The lowest-level component in a `DraftEditor`, the text node component
	 * replaces the default React text node implementation. This allows us to
	 * perform custom handling of newline behavior and avoid re-rendering text
	 * nodes with DOM state that already matches the expectations of our immutable
	 * editor state.
	 */
	var DraftEditorTextNode = function (_React$Component) {
	  _inherits(DraftEditorTextNode, _React$Component);
	
	  function DraftEditorTextNode(props) {
	    _classCallCheck(this, DraftEditorTextNode);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this._forceFlag = false;
	    return _this;
	  }
	
	  DraftEditorTextNode.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    var node = ReactDOM.findDOMNode(this);
	    var shouldBeNewline = nextProps.children === '';
	    if (shouldBeNewline) {
	      return !isNewline(node);
	    }
	    return node.textContent !== nextProps.children;
	  };
	
	  DraftEditorTextNode.prototype.componentWillUpdate = function componentWillUpdate() {
	    // By flipping this flag, we also keep flipping keys which forces
	    // React to remount this node every time it rerenders.
	    this._forceFlag = !this._forceFlag;
	  };
	
	  DraftEditorTextNode.prototype.render = function render() {
	    if (this.props.children === '') {
	      return this._forceFlag ? NEWLINE_A : NEWLINE_B;
	    }
	    return React.createElement(
	      'span',
	      { key: this._forceFlag ? 'A' : 'B', 'data-text': 'true' },
	      this.props.children
	    );
	  };
	
	  return DraftEditorTextNode;
	}(React.Component);
	
	module.exports = DraftEditorTextNode;

/***/ }),
/* 1062 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEntitySegments
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	/**
	 * Identify the range to delete from a segmented entity.
	 *
	 * Rules:
	 *
	 *  Example: 'John F. Kennedy'
	 *
	 *   - Deletion from within any non-whitespace (i.e. ['John', 'F.', 'Kennedy'])
	 *     will return the range of that text.
	 *
	 *       'John F. Kennedy' -> 'John F.'
	 *                  ^
	 *
	 *   - Forward deletion of whitespace will remove the following section:
	 *
	 *       'John F. Kennedy' -> 'John Kennedy'
	 *            ^
	 *
	 *   - Backward deletion of whitespace will remove the previous section:
	 *
	 *       'John F. Kennedy' -> 'F. Kennedy'
	 *            ^
	 */
	var DraftEntitySegments = {
	  getRemovalRange: function getRemovalRange(selectionStart, selectionEnd, text, entityStart, direction) {
	    var segments = text.split(' ');
	    segments = segments.map(function ( /*string*/segment, /*number*/ii) {
	      if (direction === 'forward') {
	        if (ii > 0) {
	          return ' ' + segment;
	        }
	      } else if (ii < segments.length - 1) {
	        return segment + ' ';
	      }
	      return segment;
	    });
	
	    var segmentStart = entityStart;
	    var segmentEnd;
	    var segment;
	    var removalStart = null;
	    var removalEnd = null;
	
	    for (var jj = 0; jj < segments.length; jj++) {
	      segment = segments[jj];
	      segmentEnd = segmentStart + segment.length;
	
	      // Our selection overlaps this segment.
	      if (selectionStart < segmentEnd && segmentStart < selectionEnd) {
	        if (removalStart !== null) {
	          removalEnd = segmentEnd;
	        } else {
	          removalStart = segmentStart;
	          removalEnd = segmentEnd;
	        }
	      } else if (removalStart !== null) {
	        break;
	      }
	
	      segmentStart = segmentEnd;
	    }
	
	    var entityEnd = entityStart + text.length;
	    var atStart = removalStart === entityStart;
	    var atEnd = removalEnd === entityEnd;
	
	    if (!atStart && atEnd || atStart && !atEnd) {
	      if (direction === 'forward') {
	        if (removalEnd !== entityEnd) {
	          removalEnd++;
	        }
	      } else if (removalStart !== entityStart) {
	        removalStart--;
	      }
	    }
	
	    return {
	      start: removalStart,
	      end: removalEnd
	    };
	  }
	};
	
	module.exports = DraftEntitySegments;

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftPasteProcessor
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var CharacterMetadata = __webpack_require__(94);
	var ContentBlock = __webpack_require__(158);
	var Immutable = __webpack_require__(28);
	
	var convertFromHTMLtoContentBlocks = __webpack_require__(538);
	var generateRandomKey = __webpack_require__(100);
	var getSafeBodyFromHTML = __webpack_require__(543);
	var sanitizeDraftText = __webpack_require__(362);
	
	var List = Immutable.List;
	var Repeat = Immutable.Repeat;
	
	
	var DraftPasteProcessor = {
	  processHTML: function processHTML(html, blockRenderMap) {
	    return convertFromHTMLtoContentBlocks(html, getSafeBodyFromHTML, blockRenderMap);
	  },
	  processText: function processText(textBlocks, character) {
	    return textBlocks.map(function (textLine) {
	      textLine = sanitizeDraftText(textLine);
	      return new ContentBlock({
	        key: generateRandomKey(),
	        type: 'unstyled',
	        text: textLine,
	        characterList: List(Repeat(character, textLine.length))
	      });
	    });
	  }
	};
	
	module.exports = DraftPasteProcessor;

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EditorBidiService
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(28);
	var UnicodeBidiService = __webpack_require__(1337);
	
	var nullthrows = __webpack_require__(81);
	
	var OrderedMap = Immutable.OrderedMap;
	
	
	var bidiService;
	
	var EditorBidiService = {
	  getDirectionMap: function getDirectionMap(content, prevBidiMap) {
	    if (!bidiService) {
	      bidiService = new UnicodeBidiService();
	    } else {
	      bidiService.reset();
	    }
	
	    var blockMap = content.getBlockMap();
	    var nextBidi = blockMap.valueSeq().map(function (block) {
	      return nullthrows(bidiService).getDirection(block.getText());
	    });
	    var bidiMap = OrderedMap(blockMap.keySeq().zip(nextBidi));
	
	    if (prevBidiMap != null && Immutable.is(prevBidiMap, bidiMap)) {
	      return prevBidiMap;
	    }
	
	    return bidiMap;
	  }
	};
	
	module.exports = EditorBidiService;

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule RichTextEditorUtil
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var DraftEntity = __webpack_require__(117);
	var DraftModifier = __webpack_require__(63);
	var EditorState = __webpack_require__(24);
	var SelectionState = __webpack_require__(182);
	
	var adjustBlockDepthForContentState = __webpack_require__(1067);
	var nullthrows = __webpack_require__(81);
	
	var RichTextEditorUtil = {
	  currentBlockContainsLink: function currentBlockContainsLink(editorState) {
	    var selection = editorState.getSelection();
	    return editorState.getCurrentContent().getBlockForKey(selection.getAnchorKey()).getCharacterList().slice(selection.getStartOffset(), selection.getEndOffset()).some(function (v) {
	      var entity = v.getEntity();
	      return !!entity && DraftEntity.get(entity).getType() === 'LINK';
	    });
	  },
	
	  getCurrentBlockType: function getCurrentBlockType(editorState) {
	    var selection = editorState.getSelection();
	    return editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();
	  },
	
	  getDataObjectForLinkURL: function getDataObjectForLinkURL(uri) {
	    return { url: uri.toString() };
	  },
	
	  handleKeyCommand: function handleKeyCommand(editorState, command) {
	    switch (command) {
	      case 'bold':
	        return RichTextEditorUtil.toggleInlineStyle(editorState, 'BOLD');
	      case 'italic':
	        return RichTextEditorUtil.toggleInlineStyle(editorState, 'ITALIC');
	      case 'underline':
	        return RichTextEditorUtil.toggleInlineStyle(editorState, 'UNDERLINE');
	      case 'code':
	        return RichTextEditorUtil.toggleCode(editorState);
	      case 'backspace':
	      case 'backspace-word':
	      case 'backspace-to-start-of-line':
	        return RichTextEditorUtil.onBackspace(editorState);
	      case 'delete':
	      case 'delete-word':
	      case 'delete-to-end-of-block':
	        return RichTextEditorUtil.onDelete(editorState);
	      default:
	        return null;
	    }
	  },
	
	  insertSoftNewline: function insertSoftNewline(editorState) {
	    var contentState = DraftModifier.insertText(editorState.getCurrentContent(), editorState.getSelection(), '\n', editorState.getCurrentInlineStyle(), null);
	
	    var newEditorState = EditorState.push(editorState, contentState, 'insert-characters');
	
	    return EditorState.forceSelection(newEditorState, contentState.getSelectionAfter());
	  },
	
	  /**
	   * For collapsed selections at the start of styled blocks, backspace should
	   * just remove the existing style.
	   */
	  onBackspace: function onBackspace(editorState) {
	    var selection = editorState.getSelection();
	    if (!selection.isCollapsed() || selection.getAnchorOffset() || selection.getFocusOffset()) {
	      return null;
	    }
	
	    // First, try to remove a preceding atomic block.
	    var content = editorState.getCurrentContent();
	    var startKey = selection.getStartKey();
	    var blockBefore = content.getBlockBefore(startKey);
	
	    if (blockBefore && blockBefore.getType() === 'atomic') {
	      var atomicBlockTarget = selection.merge({
	        anchorKey: blockBefore.getKey(),
	        anchorOffset: 0
	      });
	      var asCurrentStyle = DraftModifier.setBlockType(content, atomicBlockTarget, content.getBlockForKey(startKey).getType());
	      var withoutAtomicBlock = DraftModifier.removeRange(asCurrentStyle, atomicBlockTarget, 'backward');
	      if (withoutAtomicBlock !== content) {
	        return EditorState.push(editorState, withoutAtomicBlock, 'remove-range');
	      }
	    }
	
	    // If that doesn't succeed, try to remove the current block style.
	    var withoutBlockStyle = RichTextEditorUtil.tryToRemoveBlockStyle(editorState);
	
	    if (withoutBlockStyle) {
	      return EditorState.push(editorState, withoutBlockStyle, 'change-block-type');
	    }
	
	    return null;
	  },
	
	  onDelete: function onDelete(editorState) {
	    var selection = editorState.getSelection();
	    if (!selection.isCollapsed()) {
	      return null;
	    }
	
	    var content = editorState.getCurrentContent();
	    var startKey = selection.getStartKey();
	    var block = content.getBlockForKey(startKey);
	    var length = block.getLength();
	
	    // The cursor is somewhere within the text. Behave normally.
	    if (selection.getStartOffset() < length) {
	      return null;
	    }
	
	    var blockAfter = content.getBlockAfter(startKey);
	
	    if (!blockAfter || blockAfter.getType() !== 'atomic') {
	      return null;
	    }
	
	    var atomicBlockTarget = selection.merge({
	      focusKey: blockAfter.getKey(),
	      focusOffset: blockAfter.getLength()
	    });
	
	    var withoutAtomicBlock = DraftModifier.removeRange(content, atomicBlockTarget, 'forward');
	
	    if (withoutAtomicBlock !== content) {
	      return EditorState.push(editorState, withoutAtomicBlock, 'remove-range');
	    }
	
	    return null;
	  },
	
	  onTab: function onTab(event, editorState, maxDepth) {
	    var selection = editorState.getSelection();
	    var key = selection.getAnchorKey();
	    if (key !== selection.getFocusKey()) {
	      return editorState;
	    }
	
	    var content = editorState.getCurrentContent();
	    var block = content.getBlockForKey(key);
	    var type = block.getType();
	    if (type !== 'unordered-list-item' && type !== 'ordered-list-item') {
	      return editorState;
	    }
	
	    event.preventDefault();
	
	    // Only allow indenting one level beyond the block above, and only if
	    // the block above is a list item as well.
	    var blockAbove = content.getBlockBefore(key);
	    if (!blockAbove) {
	      return editorState;
	    }
	
	    var typeAbove = blockAbove.getType();
	    if (typeAbove !== 'unordered-list-item' && typeAbove !== 'ordered-list-item') {
	      return editorState;
	    }
	
	    var depth = block.getDepth();
	    if (!event.shiftKey && depth === maxDepth) {
	      return editorState;
	    }
	
	    maxDepth = Math.min(blockAbove.getDepth() + 1, maxDepth);
	
	    var withAdjustment = adjustBlockDepthForContentState(content, selection, event.shiftKey ? -1 : 1, maxDepth);
	
	    return EditorState.push(editorState, withAdjustment, 'adjust-depth');
	  },
	
	  toggleBlockType: function toggleBlockType(editorState, blockType) {
	    var selection = editorState.getSelection();
	    var startKey = selection.getStartKey();
	    var endKey = selection.getEndKey();
	    var content = editorState.getCurrentContent();
	    var target = selection;
	
	    // Triple-click can lead to a selection that includes offset 0 of the
	    // following block. The `SelectionState` for this case is accurate, but
	    // we should avoid toggling block type for the trailing block because it
	    // is a confusing interaction.
	    if (startKey !== endKey && selection.getEndOffset() === 0) {
	      var blockBefore = nullthrows(content.getBlockBefore(endKey));
	      endKey = blockBefore.getKey();
	      target = target.merge({
	        anchorKey: startKey,
	        anchorOffset: selection.getStartOffset(),
	        focusKey: endKey,
	        focusOffset: blockBefore.getLength(),
	        isBackward: false
	      });
	    }
	
	    var hasAtomicBlock = content.getBlockMap().skipWhile(function (_, k) {
	      return k !== startKey;
	    }).reverse().skipWhile(function (_, k) {
	      return k !== endKey;
	    }).some(function (v) {
	      return v.getType() === 'atomic';
	    });
	
	    if (hasAtomicBlock) {
	      return editorState;
	    }
	
	    var typeToSet = content.getBlockForKey(startKey).getType() === blockType ? 'unstyled' : blockType;
	
	    return EditorState.push(editorState, DraftModifier.setBlockType(content, target, typeToSet), 'change-block-type');
	  },
	
	  toggleCode: function toggleCode(editorState) {
	    var selection = editorState.getSelection();
	    var anchorKey = selection.getAnchorKey();
	    var focusKey = selection.getFocusKey();
	
	    if (selection.isCollapsed() || anchorKey !== focusKey) {
	      return RichTextEditorUtil.toggleBlockType(editorState, 'code-block');
	    }
	
	    return RichTextEditorUtil.toggleInlineStyle(editorState, 'CODE');
	  },
	
	  /**
	   * Toggle the specified inline style for the selection. If the
	   * user's selection is collapsed, apply or remove the style for the
	   * internal state. If it is not collapsed, apply the change directly
	   * to the document state.
	   */
	  toggleInlineStyle: function toggleInlineStyle(editorState, inlineStyle) {
	    var selection = editorState.getSelection();
	    var currentStyle = editorState.getCurrentInlineStyle();
	
	    // If the selection is collapsed, toggle the specified style on or off and
	    // set the result as the new inline style override. This will then be
	    // used as the inline style for the next character to be inserted.
	    if (selection.isCollapsed()) {
	      return EditorState.setInlineStyleOverride(editorState, currentStyle.has(inlineStyle) ? currentStyle.remove(inlineStyle) : currentStyle.add(inlineStyle));
	    }
	
	    // If characters are selected, immediately apply or remove the
	    // inline style on the document state itself.
	    var content = editorState.getCurrentContent();
	    var newContent;
	
	    // If the style is already present for the selection range, remove it.
	    // Otherwise, apply it.
	    if (currentStyle.has(inlineStyle)) {
	      newContent = DraftModifier.removeInlineStyle(content, selection, inlineStyle);
	    } else {
	      newContent = DraftModifier.applyInlineStyle(content, selection, inlineStyle);
	    }
	
	    return EditorState.push(editorState, newContent, 'change-inline-style');
	  },
	
	  toggleLink: function toggleLink(editorState, targetSelection, entityKey) {
	    var withoutLink = DraftModifier.applyEntity(editorState.getCurrentContent(), targetSelection, entityKey);
	
	    return EditorState.push(editorState, withoutLink, 'apply-entity');
	  },
	
	  /**
	   * When a collapsed cursor is at the start of an empty styled block, allow
	   * certain key commands (newline, backspace) to simply change the
	   * style of the block instead of the default behavior.
	   */
	  tryToRemoveBlockStyle: function tryToRemoveBlockStyle(editorState) {
	    var selection = editorState.getSelection();
	    var offset = selection.getAnchorOffset();
	    if (selection.isCollapsed() && offset === 0) {
	      var key = selection.getAnchorKey();
	      var content = editorState.getCurrentContent();
	      var block = content.getBlockForKey(key);
	      if (block.getLength() > 0) {
	        return null;
	      }
	
	      var type = block.getType();
	      var blockBefore = content.getBlockBefore(key);
	      if (type === 'code-block' && blockBefore && blockBefore.getType() === 'code-block') {
	        return null;
	      }
	
	      if (type !== 'unstyled') {
	        return DraftModifier.setBlockType(content, selection, 'unstyled');
	      }
	    }
	    return null;
	  }
	};
	
	module.exports = RichTextEditorUtil;

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SecondaryClipboard
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(63);
	var EditorState = __webpack_require__(24);
	
	var getContentStateFragment = __webpack_require__(263);
	var nullthrows = __webpack_require__(81);
	
	var clipboard = null;
	
	/**
	 * Some systems offer a "secondary" clipboard to allow quick internal cut
	 * and paste behavior. For instance, Ctrl+K (cut) and Ctrl+Y (paste).
	 */
	var SecondaryClipboard = {
	  cut: function cut(editorState) {
	    var content = editorState.getCurrentContent();
	    var selection = editorState.getSelection();
	    var targetRange = null;
	
	    if (selection.isCollapsed()) {
	      var anchorKey = selection.getAnchorKey();
	      var blockEnd = content.getBlockForKey(anchorKey).getLength();
	
	      if (blockEnd === selection.getAnchorOffset()) {
	        return editorState;
	      }
	
	      targetRange = selection.set('focusOffset', blockEnd);
	    } else {
	      targetRange = selection;
	    }
	
	    targetRange = nullthrows(targetRange);
	    clipboard = getContentStateFragment(content, targetRange);
	
	    var afterRemoval = DraftModifier.removeRange(content, targetRange, 'forward');
	
	    if (afterRemoval === content) {
	      return editorState;
	    }
	
	    return EditorState.push(editorState, afterRemoval, 'remove-range');
	  },
	
	  paste: function paste(editorState) {
	    if (!clipboard) {
	      return editorState;
	    }
	
	    var newContent = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), clipboard);
	
	    return EditorState.push(editorState, newContent, 'insert-fragment');
	  }
	};
	
	module.exports = SecondaryClipboard;

/***/ }),
/* 1067 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule adjustBlockDepthForContentState
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	function adjustBlockDepthForContentState(contentState, selectionState, adjustment, maxDepth) {
	  var startKey = selectionState.getStartKey();
	  var endKey = selectionState.getEndKey();
	  var blockMap = contentState.getBlockMap();
	  var blocks = blockMap.toSeq().skipUntil(function (_, k) {
	    return k === startKey;
	  }).takeUntil(function (_, k) {
	    return k === endKey;
	  }).concat([[endKey, blockMap.get(endKey)]]).map(function (block) {
	    var depth = block.getDepth() + adjustment;
	    depth = Math.max(0, Math.min(depth, maxDepth));
	    return block.set('depth', depth);
	  });
	
	  blockMap = blockMap.merge(blocks);
	
	  return contentState.merge({
	    blockMap: blockMap,
	    selectionBefore: selectionState,
	    selectionAfter: selectionState
	  });
	}
	
	module.exports = adjustBlockDepthForContentState;

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule applyEntityToContentBlock
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var CharacterMetadata = __webpack_require__(94);
	
	function applyEntityToContentBlock(contentBlock, start, end, entityKey) {
	  var characterList = contentBlock.getCharacterList();
	  while (start < end) {
	    characterList = characterList.set(start, CharacterMetadata.applyEntity(characterList.get(start), entityKey));
	    start++;
	  }
	  return contentBlock.set('characterList', characterList);
	}
	
	module.exports = applyEntityToContentBlock;

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule applyEntityToContentState
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(28);
	
	var applyEntityToContentBlock = __webpack_require__(1068);
	
	function applyEntityToContentState(contentState, selectionState, entityKey) {
	  var blockMap = contentState.getBlockMap();
	  var startKey = selectionState.getStartKey();
	  var startOffset = selectionState.getStartOffset();
	  var endKey = selectionState.getEndKey();
	  var endOffset = selectionState.getEndOffset();
	
	  var newBlocks = blockMap.skipUntil(function (_, k) {
	    return k === startKey;
	  }).takeUntil(function (_, k) {
	    return k === endKey;
	  }).toOrderedMap().merge(Immutable.OrderedMap([[endKey, blockMap.get(endKey)]])).map(function (block, blockKey) {
	    var sliceStart = blockKey === startKey ? startOffset : 0;
	    var sliceEnd = blockKey === endKey ? endOffset : block.getLength();
	    return applyEntityToContentBlock(block, sliceStart, sliceEnd, entityKey);
	  });
	
	  return contentState.merge({
	    blockMap: blockMap.merge(newBlocks),
	    selectionBefore: selectionState,
	    selectionAfter: selectionState
	  });
	}
	
	module.exports = applyEntityToContentState;

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule convertFromDraftStateToRaw
	 * 
	 */
	
	'use strict';
	
	var DraftEntity = __webpack_require__(117);
	var DraftStringKey = __webpack_require__(537);
	
	var encodeEntityRanges = __webpack_require__(1087);
	var encodeInlineStyleRanges = __webpack_require__(1088);
	
	function convertFromDraftStateToRaw(contentState) {
	  var entityStorageKey = 0;
	  var entityStorageMap = {};
	  var rawBlocks = [];
	
	  contentState.getBlockMap().forEach(function (block, blockKey) {
	    block.findEntityRanges(function (character) {
	      return character.getEntity() !== null;
	    }, function (start) {
	      // Stringify to maintain order of otherwise numeric keys.
	      var stringifiedEntityKey = DraftStringKey.stringify(block.getEntityAt(start));
	      if (!entityStorageMap.hasOwnProperty(stringifiedEntityKey)) {
	        entityStorageMap[stringifiedEntityKey] = '' + entityStorageKey++;
	      }
	    });
	
	    rawBlocks.push({
	      key: blockKey,
	      text: block.getText(),
	      type: block.getType(),
	      depth: block.getDepth(),
	      inlineStyleRanges: encodeInlineStyleRanges(block),
	      entityRanges: encodeEntityRanges(block, entityStorageMap),
	      data: block.getData().toObject()
	    });
	  });
	
	  // Flip storage map so that our storage keys map to global
	  // DraftEntity keys.
	  var entityKeys = Object.keys(entityStorageMap);
	  var flippedStorageMap = {};
	  entityKeys.forEach(function (key, jj) {
	    var entity = DraftEntity.get(DraftStringKey.unstringify(key));
	    flippedStorageMap[jj] = {
	      type: entity.getType(),
	      mutability: entity.getMutability(),
	      data: entity.getData()
	    };
	  });
	
	  return {
	    entityMap: flippedStorageMap,
	    blocks: rawBlocks
	  };
	}
	
	module.exports = convertFromDraftStateToRaw;

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule convertFromRawToDraftState
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(20);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var ContentBlock = __webpack_require__(158);
	var ContentState = __webpack_require__(356);
	var DraftEntity = __webpack_require__(117);
	var Immutable = __webpack_require__(28);
	
	var createCharacterList = __webpack_require__(1072);
	var decodeEntityRanges = __webpack_require__(1073);
	var decodeInlineStyleRanges = __webpack_require__(1074);
	var generateRandomKey = __webpack_require__(100);
	
	var Map = Immutable.Map;
	
	
	function convertFromRawToDraftState(rawState) {
	  var blocks = rawState.blocks;
	  var entityMap = rawState.entityMap;
	
	
	  var fromStorageToLocal = {};
	  Object.keys(entityMap).forEach(function (storageKey) {
	    var encodedEntity = entityMap[storageKey];
	    var type = encodedEntity.type;
	    var mutability = encodedEntity.mutability;
	    var data = encodedEntity.data;
	
	    var newKey = DraftEntity.create(type, mutability, data || {});
	    fromStorageToLocal[storageKey] = newKey;
	  });
	
	  var contentBlocks = blocks.map(function (block) {
	    var key = block.key;
	    var type = block.type;
	    var text = block.text;
	    var depth = block.depth;
	    var inlineStyleRanges = block.inlineStyleRanges;
	    var entityRanges = block.entityRanges;
	    var data = block.data;
	
	    key = key || generateRandomKey();
	    depth = depth || 0;
	    inlineStyleRanges = inlineStyleRanges || [];
	    entityRanges = entityRanges || [];
	    data = Map(data);
	
	    var inlineStyles = decodeInlineStyleRanges(text, inlineStyleRanges);
	
	    // Translate entity range keys to the DraftEntity map.
	    var filteredEntityRanges = entityRanges.filter(function (range) {
	      return fromStorageToLocal.hasOwnProperty(range.key);
	    }).map(function (range) {
	      return _extends({}, range, { key: fromStorageToLocal[range.key] });
	    });
	
	    var entities = decodeEntityRanges(text, filteredEntityRanges);
	    var characterList = createCharacterList(inlineStyles, entities);
	
	    return new ContentBlock({ key: key, type: type, text: text, depth: depth, characterList: characterList, data: data });
	  });
	
	  return ContentState.createFromBlockArray(contentBlocks);
	}
	
	module.exports = convertFromRawToDraftState;

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createCharacterList
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var CharacterMetadata = __webpack_require__(94);
	var Immutable = __webpack_require__(28);
	
	var List = Immutable.List;
	
	
	function createCharacterList(inlineStyles, entities) {
	  var characterArray = inlineStyles.map(function (style, ii) {
	    var entity = entities[ii];
	    return CharacterMetadata.create({ style: style, entity: entity });
	  });
	  return List(characterArray);
	}
	
	module.exports = createCharacterList;

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule decodeEntityRanges
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var UnicodeUtils = __webpack_require__(159);
	
	var substr = UnicodeUtils.substr;
	
	/**
	 * Convert to native JavaScript string lengths to determine ranges.
	 */
	
	function decodeEntityRanges(text, ranges) {
	  var entities = Array(text.length).fill(null);
	  if (ranges) {
	    ranges.forEach(function (range) {
	      // Using Unicode-enabled substrings converted to JavaScript lengths,
	      // fill the output array with entity keys.
	      var start = substr(text, 0, range.offset).length;
	      var end = start + substr(text, range.offset, range.length).length;
	      for (var ii = start; ii < end; ii++) {
	        entities[ii] = range.key;
	      }
	    });
	  }
	  return entities;
	}
	
	module.exports = decodeEntityRanges;

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule decodeInlineStyleRanges
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var UnicodeUtils = __webpack_require__(159);
	
	var _require = __webpack_require__(28);
	
	var OrderedSet = _require.OrderedSet;
	var substr = UnicodeUtils.substr;
	
	
	var EMPTY_SET = OrderedSet();
	
	/**
	 * Convert to native JavaScript string lengths to determine ranges.
	 */
	function decodeInlineStyleRanges(text, ranges) {
	  var styles = Array(text.length).fill(EMPTY_SET);
	  if (ranges) {
	    ranges.forEach(function ( /*object*/range) {
	      var cursor = substr(text, 0, range.offset).length;
	      var end = cursor + substr(text, range.offset, range.length).length;
	      while (cursor < end) {
	        styles[cursor] = styles[cursor].add(range.style);
	        cursor++;
	      }
	    });
	  }
	  return styles;
	}
	
	module.exports = decodeInlineStyleRanges;

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnBeforeInput
	 * 
	 */
	
	'use strict';
	
	var BlockTree = __webpack_require__(532);
	var DraftModifier = __webpack_require__(63);
	var EditorState = __webpack_require__(24);
	var UserAgent = __webpack_require__(101);
	
	var getEntityKeyForSelection = __webpack_require__(360);
	var isSelectionAtLeafStart = __webpack_require__(548);
	var nullthrows = __webpack_require__(81);
	
	var isEventHandled = __webpack_require__(264);
	
	// When nothing is focused, Firefox regards two characters, `'` and `/`, as
	// commands that should open and focus the "quickfind" search bar. This should
	// *never* happen while a contenteditable is focused, but as of v28, it
	// sometimes does, even when the keypress event target is the contenteditable.
	// This breaks the input. Special case these characters to ensure that when
	// they are typed, we prevent default on the event to make sure not to
	// trigger quickfind.
	var FF_QUICKFIND_CHAR = '\'';
	var FF_QUICKFIND_LINK_CHAR = '\/';
	var isFirefox = UserAgent.isBrowser('Firefox');
	
	function mustPreventDefaultForCharacter(character) {
	  return isFirefox && (character == FF_QUICKFIND_CHAR || character == FF_QUICKFIND_LINK_CHAR);
	}
	
	/**
	 * Replace the current selection with the specified text string, with the
	 * inline style and entity key applied to the newly inserted text.
	 */
	function replaceText(editorState, text, inlineStyle, entityKey) {
	  var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), text, inlineStyle, entityKey);
	  return EditorState.push(editorState, contentState, 'insert-characters');
	}
	
	/**
	 * When `onBeforeInput` executes, the browser is attempting to insert a
	 * character into the editor. Apply this character data to the document,
	 * allowing native insertion if possible.
	 *
	 * Native insertion is encouraged in order to limit re-rendering and to
	 * preserve spellcheck highlighting, which disappears or flashes if re-render
	 * occurs on the relevant text nodes.
	 */
	function editOnBeforeInput(e) {
	  var chars = e.data;
	
	  // In some cases (ex: IE ideographic space insertion) no character data
	  // is provided. There's nothing to do when this happens.
	  if (!chars) {
	    return;
	  }
	
	  // Allow the top-level component to handle the insertion manually. This is
	  // useful when triggering interesting behaviors for a character insertion,
	  // Simple examples: replacing a raw text ':)' with a smile emoji or image
	  // decorator, or setting a block to be a list item after typing '- ' at the
	  // start of the block.
	  if (this.props.handleBeforeInput && isEventHandled(this.props.handleBeforeInput(chars))) {
	    e.preventDefault();
	    return;
	  }
	
	  // If selection is collapsed, conditionally allow native behavior. This
	  // reduces re-renders and preserves spellcheck highlighting. If the selection
	  // is not collapsed, we will re-render.
	  var editorState = this.props.editorState;
	  var selection = editorState.getSelection();
	
	  if (!selection.isCollapsed()) {
	    e.preventDefault();
	    this.update(replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())));
	    return;
	  }
	
	  var mayAllowNative = !isSelectionAtLeafStart(editorState);
	  var newEditorState = replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection()));
	
	  if (!mayAllowNative) {
	    e.preventDefault();
	    this.update(newEditorState);
	    return;
	  }
	
	  var anchorKey = selection.getAnchorKey();
	  var anchorTree = editorState.getBlockTree(anchorKey);
	
	  // Check the old and new "fingerprints" of the current block to determine
	  // whether this insertion requires any addition or removal of text nodes,
	  // in which case we would prevent the native character insertion.
	  var originalFingerprint = BlockTree.getFingerprint(anchorTree);
	  var newFingerprint = BlockTree.getFingerprint(newEditorState.getBlockTree(anchorKey));
	
	  if (mustPreventDefaultForCharacter(chars) || originalFingerprint !== newFingerprint || nullthrows(newEditorState.getDirectionMap()).get(anchorKey) !== nullthrows(editorState.getDirectionMap()).get(anchorKey)) {
	    e.preventDefault();
	  } else {
	    // The native event is allowed to occur.
	    newEditorState = EditorState.set(newEditorState, {
	      nativelyRenderedContent: newEditorState.getCurrentContent()
	    });
	  }
	
	  this.update(newEditorState);
	}
	
	module.exports = editOnBeforeInput;

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnBlur
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(24);
	var UserAgent = __webpack_require__(101);
	
	var getActiveElement = __webpack_require__(265);
	
	var isWebKit = UserAgent.isEngine('WebKit');
	
	function editOnBlur(e) {
	  // Webkit has a bug in which blurring a contenteditable by clicking on
	  // other active elements will trigger the `blur` event but will not remove
	  // the DOM selection from the contenteditable. We therefore force the
	  // issue to be certain, checking whether the active element is `body`
	  // to force it when blurring occurs within the window (as opposed to
	  // clicking to another tab or window).
	  if (isWebKit && getActiveElement() === document.body) {
	    global.getSelection().removeAllRanges();
	  }
	
	  var editorState = this.props.editorState;
	  var currentSelection = editorState.getSelection();
	  if (!currentSelection.getHasFocus()) {
	    return;
	  }
	
	  var selection = currentSelection.set('hasFocus', false);
	  this.props.onBlur && this.props.onBlur(e);
	  this.update(EditorState.acceptSelection(editorState, selection));
	}
	
	module.exports = editOnBlur;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnCompositionStart
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(24);
	
	/**
	 * The user has begun using an IME input system. Switching to `composite` mode
	 * allows handling composition input and disables other edit behavior.
	 */
	function editOnCompositionStart() {
	  this.setRenderGuard();
	  this.setMode('composite');
	  this.update(EditorState.set(this.props.editorState, { inCompositionMode: true }));
	}
	
	module.exports = editOnCompositionStart;

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnCopy
	 * 
	 */
	
	'use strict';
	
	var getFragmentFromSelection = __webpack_require__(541);
	
	/**
	 * If we have a selection, create a ContentState fragment and store
	 * it in our internal clipboard. Subsequent paste events will use this
	 * fragment if no external clipboard data is supplied.
	 */
	function editOnCopy(e) {
	  var editorState = this.props.editorState;
	  var selection = editorState.getSelection();
	
	  // No selection, so there's nothing to copy.
	  if (selection.isCollapsed()) {
	    e.preventDefault();
	    return;
	  }
	
	  this.setClipboard(getFragmentFromSelection(this.props.editorState));
	}
	
	module.exports = editOnCopy;

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnCut
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(63);
	var EditorState = __webpack_require__(24);
	var Style = __webpack_require__(366);
	
	var getFragmentFromSelection = __webpack_require__(541);
	var getScrollPosition = __webpack_require__(369);
	
	/**
	 * On `cut` events, native behavior is allowed to occur so that the system
	 * clipboard is set properly. This means that we need to take steps to recover
	 * the editor DOM state after the `cut` has occurred in order to maintain
	 * control of the component.
	 *
	 * In addition, we can keep a copy of the removed fragment, including all
	 * styles and entities, for use as an internal paste.
	 */
	function editOnCut(e) {
	  var _this = this;
	
	  var editorState = this.props.editorState;
	  var selection = editorState.getSelection();
	
	  // No selection, so there's nothing to cut.
	  if (selection.isCollapsed()) {
	    e.preventDefault();
	    return;
	  }
	
	  // Track the current scroll position so that it can be forced back in place
	  // after the editor regains control of the DOM.
	  var scrollParent = Style.getScrollParent(e.target);
	
	  var _getScrollPosition = getScrollPosition(scrollParent);
	
	  var x = _getScrollPosition.x;
	  var y = _getScrollPosition.y;
	
	
	  var fragment = getFragmentFromSelection(editorState);
	  this.setClipboard(fragment);
	
	  // Set `cut` mode to disable all event handling temporarily.
	  this.setRenderGuard();
	  this.setMode('cut');
	
	  // Let native `cut` behavior occur, then recover control.
	  setTimeout(function () {
	    _this.restoreEditorDOM({ x: x, y: y });
	    _this.removeRenderGuard();
	    _this.exitCurrentMode();
	    _this.update(removeFragment(editorState));
	  }, 0);
	}
	
	function removeFragment(editorState) {
	  var newContent = DraftModifier.removeRange(editorState.getCurrentContent(), editorState.getSelection(), 'forward');
	  return EditorState.push(editorState, newContent, 'remove-range');
	}
	
	module.exports = editOnCut;

/***/ }),
/* 1080 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnDragOver
	 * 
	 */
	
	'use strict';
	
	/**
	 * Drag behavior has begun from outside the editor element.
	 */
	
	function editOnDragOver(e) {
	  this._internalDrag = false;
	  this.setMode('drag');
	  e.preventDefault();
	}
	
	module.exports = editOnDragOver;

/***/ }),
/* 1081 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnDragStart
	 * 
	 */
	
	'use strict';
	
	/**
	 * A `dragstart` event has begun within the text editor component.
	 */
	
	function editOnDragStart() {
	  this._internalDrag = true;
	  this.setMode('drag');
	}
	
	module.exports = editOnDragStart;

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnFocus
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(24);
	
	function editOnFocus(e) {
	  var editorState = this.props.editorState;
	  var currentSelection = editorState.getSelection();
	  if (currentSelection.getHasFocus()) {
	    return;
	  }
	
	  var selection = currentSelection.set('hasFocus', true);
	  this.props.onFocus && this.props.onFocus(e);
	
	  // When the tab containing this text editor is hidden and the user does a
	  // find-in-page in a _different_ tab, Chrome on Mac likes to forget what the
	  // selection was right after sending this focus event and (if you let it)
	  // moves the cursor back to the beginning of the editor, so we force the
	  // selection here instead of simply accepting it in order to preserve the
	  // old cursor position. See https://crbug.com/540004.
	  this.update(EditorState.forceSelection(editorState, selection));
	}
	
	module.exports = editOnFocus;

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnInput
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(63);
	var DraftOffsetKey = __webpack_require__(261);
	var EditorState = __webpack_require__(24);
	var Entity = __webpack_require__(117);
	var UserAgent = __webpack_require__(101);
	
	var findAncestorOffsetKey = __webpack_require__(359);
	var nullthrows = __webpack_require__(81);
	
	var isGecko = UserAgent.isEngine('Gecko');
	
	var DOUBLE_NEWLINE = '\n\n';
	
	/**
	 * This function is intended to handle spellcheck and autocorrect changes,
	 * which occur in the DOM natively without any opportunity to observe or
	 * interpret the changes before they occur.
	 *
	 * The `input` event fires in contentEditable elements reliably for non-IE
	 * browsers, immediately after changes occur to the editor DOM. Since our other
	 * handlers override or otherwise handle cover other varieties of text input,
	 * the DOM state should match the model in all controlled input cases. Thus,
	 * when an `input` change leads to a DOM/model mismatch, the change should be
	 * due to a spellcheck change, and we can incorporate it into our model.
	 */
	function editOnInput() {
	  var domSelection = global.getSelection();
	
	  var anchorNode = domSelection.anchorNode;
	  var isCollapsed = domSelection.isCollapsed;
	
	  if (anchorNode.nodeType !== Node.TEXT_NODE) {
	    return;
	  }
	
	  var domText = anchorNode.textContent;
	  var editorState = this.props.editorState;
	
	  var offsetKey = nullthrows(findAncestorOffsetKey(anchorNode));
	
	  var _DraftOffsetKey$decod = DraftOffsetKey.decode(offsetKey);
	
	  var blockKey = _DraftOffsetKey$decod.blockKey;
	  var decoratorKey = _DraftOffsetKey$decod.decoratorKey;
	  var leafKey = _DraftOffsetKey$decod.leafKey;
	
	  var _editorState$getBlock = editorState.getBlockTree(blockKey).getIn([decoratorKey, 'leaves', leafKey]);
	
	  var start = _editorState$getBlock.start;
	  var end = _editorState$getBlock.end;
	
	
	  var content = editorState.getCurrentContent();
	  var block = content.getBlockForKey(blockKey);
	  var modelText = block.getText().slice(start, end);
	
	  // Special-case soft newlines here. If the DOM text ends in a soft newline,
	  // we will have manually inserted an extra soft newline in DraftEditorLeaf.
	  // We want to remove this extra newline for the purpose of our comparison
	  // of DOM and model text.
	  if (domText.endsWith(DOUBLE_NEWLINE)) {
	    domText = domText.slice(0, -1);
	  }
	
	  // No change -- the DOM is up to date. Nothing to do here.
	  if (domText === modelText) {
	    return;
	  }
	
	  var selection = editorState.getSelection();
	
	  // We'll replace the entire leaf with the text content of the target.
	  var targetRange = selection.merge({
	    anchorOffset: start,
	    focusOffset: end,
	    isBackward: false
	  });
	
	  var entityKey = block.getEntityAt(start);
	  var entity = entityKey && Entity.get(entityKey);
	  var entityType = entity && entity.getMutability();
	  var preserveEntity = entityType === 'MUTABLE';
	
	  // Immutable or segmented entities cannot properly be handled by the
	  // default browser undo, so we have to use a different change type to
	  // force using our internal undo method instead of falling through to the
	  // native browser undo.
	  var changeType = preserveEntity ? 'spellcheck-change' : 'apply-entity';
	
	  var newContent = DraftModifier.replaceText(content, targetRange, domText, block.getInlineStyleAt(start), preserveEntity ? block.getEntityAt(start) : null);
	
	  var anchorOffset, focusOffset, startOffset, endOffset;
	
	  if (isGecko) {
	    // Firefox selection does not change while the context menu is open, so
	    // we preserve the anchor and focus values of the DOM selection.
	    anchorOffset = domSelection.anchorOffset;
	    focusOffset = domSelection.focusOffset;
	    startOffset = start + Math.min(anchorOffset, focusOffset);
	    endOffset = startOffset + Math.abs(anchorOffset - focusOffset);
	    anchorOffset = startOffset;
	    focusOffset = endOffset;
	  } else {
	    // Browsers other than Firefox may adjust DOM selection while the context
	    // menu is open, and Safari autocorrect is prone to providing an inaccurate
	    // DOM selection. Don't trust it. Instead, use our existing SelectionState
	    // and adjust it based on the number of characters changed during the
	    // mutation.
	    var charDelta = domText.length - modelText.length;
	    startOffset = selection.getStartOffset();
	    endOffset = selection.getEndOffset();
	
	    anchorOffset = isCollapsed ? endOffset + charDelta : startOffset;
	    focusOffset = endOffset + charDelta;
	  }
	
	  // Segmented entities are completely or partially removed when their
	  // text content changes. For this case we do not want any text to be selected
	  // after the change, so we are not merging the selection.
	  var contentWithAdjustedDOMSelection = newContent.merge({
	    selectionBefore: content.getSelectionAfter(),
	    selectionAfter: selection.merge({ anchorOffset: anchorOffset, focusOffset: focusOffset })
	  });
	
	  this.update(EditorState.push(editorState, contentWithAdjustedDOMSelection, changeType));
	}
	
	module.exports = editOnInput;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnKeyDown
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(63);
	var EditorState = __webpack_require__(24);
	var KeyBindingUtil = __webpack_require__(358);
	var Keys = __webpack_require__(365);
	var SecondaryClipboard = __webpack_require__(1066);
	var UserAgent = __webpack_require__(101);
	
	var keyCommandBackspaceToStartOfLine = __webpack_require__(1097);
	var keyCommandBackspaceWord = __webpack_require__(1098);
	var keyCommandDeleteWord = __webpack_require__(1099);
	var keyCommandInsertNewline = __webpack_require__(1100);
	var keyCommandPlainBackspace = __webpack_require__(1103);
	var keyCommandPlainDelete = __webpack_require__(1104);
	var keyCommandMoveSelectionToEndOfBlock = __webpack_require__(1101);
	var keyCommandMoveSelectionToStartOfBlock = __webpack_require__(1102);
	var keyCommandTransposeCharacters = __webpack_require__(1105);
	var keyCommandUndo = __webpack_require__(1106);
	
	var isEventHandled = __webpack_require__(264);
	
	var isOptionKeyCommand = KeyBindingUtil.isOptionKeyCommand;
	
	var isChrome = UserAgent.isBrowser('Chrome');
	
	/**
	 * Map a `DraftEditorCommand` command value to a corresponding function.
	 */
	function onKeyCommand(command, editorState) {
	  switch (command) {
	    case 'redo':
	      return EditorState.redo(editorState);
	    case 'delete':
	      return keyCommandPlainDelete(editorState);
	    case 'delete-word':
	      return keyCommandDeleteWord(editorState);
	    case 'backspace':
	      return keyCommandPlainBackspace(editorState);
	    case 'backspace-word':
	      return keyCommandBackspaceWord(editorState);
	    case 'backspace-to-start-of-line':
	      return keyCommandBackspaceToStartOfLine(editorState);
	    case 'split-block':
	      return keyCommandInsertNewline(editorState);
	    case 'transpose-characters':
	      return keyCommandTransposeCharacters(editorState);
	    case 'move-selection-to-start-of-block':
	      return keyCommandMoveSelectionToStartOfBlock(editorState);
	    case 'move-selection-to-end-of-block':
	      return keyCommandMoveSelectionToEndOfBlock(editorState);
	    case 'secondary-cut':
	      return SecondaryClipboard.cut(editorState);
	    case 'secondary-paste':
	      return SecondaryClipboard.paste(editorState);
	    default:
	      return editorState;
	  }
	}
	
	/**
	 * Intercept keydown behavior to handle keys and commands manually, if desired.
	 *
	 * Keydown combinations may be mapped to `DraftCommand` values, which may
	 * correspond to command functions that modify the editor or its contents.
	 *
	 * See `getDefaultKeyBinding` for defaults. Alternatively, the top-level
	 * component may provide a custom mapping via the `keyBindingFn` prop.
	 */
	function editOnKeyDown(e) {
	  var keyCode = e.which;
	  var editorState = this.props.editorState;
	
	  switch (keyCode) {
	    case Keys.RETURN:
	      e.preventDefault();
	      // The top-level component may manually handle newline insertion. If
	      // no special handling is performed, fall through to command handling.
	      if (this.props.handleReturn && isEventHandled(this.props.handleReturn(e))) {
	        return;
	      }
	      break;
	    case Keys.ESC:
	      e.preventDefault();
	      this.props.onEscape && this.props.onEscape(e);
	      return;
	    case Keys.TAB:
	      this.props.onTab && this.props.onTab(e);
	      return;
	    case Keys.UP:
	      this.props.onUpArrow && this.props.onUpArrow(e);
	      return;
	    case Keys.DOWN:
	      this.props.onDownArrow && this.props.onDownArrow(e);
	      return;
	    case Keys.SPACE:
	      // Handling for OSX where option + space scrolls.
	      if (isChrome && isOptionKeyCommand(e)) {
	        e.preventDefault();
	        // Insert a nbsp into the editor.
	        var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), ' ');
	        this.update(EditorState.push(editorState, contentState, 'insert-characters'));
	        return;
	      }
	  }
	
	  var command = this.props.keyBindingFn(e);
	
	  // If no command is specified, allow keydown event to continue.
	  if (!command) {
	    return;
	  }
	
	  if (command === 'undo') {
	    // Since undo requires some special updating behavior to keep the editor
	    // in sync, handle it separately.
	    keyCommandUndo(e, editorState, this.update);
	    return;
	  }
	
	  // At this point, we know that we're handling a command of some kind, so
	  // we don't want to insert a character following the keydown.
	  e.preventDefault();
	
	  // Allow components higher up the tree to handle the command first.
	  if (this.props.handleKeyCommand && isEventHandled(this.props.handleKeyCommand(command))) {
	    return;
	  }
	
	  var newState = onKeyCommand(command, editorState);
	  if (newState !== editorState) {
	    this.update(newState);
	  }
	}
	
	module.exports = editOnKeyDown;

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnPaste
	 * 
	 */
	
	'use strict';
	
	var BlockMapBuilder = __webpack_require__(213);
	var CharacterMetadata = __webpack_require__(94);
	var DataTransfer = __webpack_require__(558);
	var DraftModifier = __webpack_require__(63);
	var DraftPasteProcessor = __webpack_require__(1063);
	var EditorState = __webpack_require__(24);
	
	var getEntityKeyForSelection = __webpack_require__(360);
	var getTextContentFromFiles = __webpack_require__(545);
	var splitTextIntoTextBlocks = __webpack_require__(1111);
	
	var isEventHandled = __webpack_require__(264);
	
	/**
	 * Paste content.
	 */
	function editOnPaste(e) {
	  var _this = this;
	
	  e.preventDefault();
	  var data = new DataTransfer(e.clipboardData);
	
	  // Get files, unless this is likely to be a string the user wants inline.
	  if (!data.isRichText()) {
	    var files = data.getFiles();
	    var defaultFileText = data.getText();
	    if (files.length > 0) {
	      // Allow customized paste handling for images, etc. Otherwise, fall
	      // through to insert text contents into the editor.
	      if (this.props.handlePastedFiles && isEventHandled(this.props.handlePastedFiles(files))) {
	        return;
	      }
	
	      getTextContentFromFiles(files, function ( /*string*/fileText) {
	        fileText = fileText || defaultFileText;
	        if (!fileText) {
	          return;
	        }
	
	        var editorState = _this.props.editorState;
	
	        var blocks = splitTextIntoTextBlocks(fileText);
	        var character = CharacterMetadata.create({
	          style: editorState.getCurrentInlineStyle(),
	          entity: getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())
	        });
	
	        var text = DraftPasteProcessor.processText(blocks, character);
	        var fragment = BlockMapBuilder.createFromArray(text);
	
	        var withInsertedText = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment);
	
	        _this.update(EditorState.push(editorState, withInsertedText, 'insert-fragment'));
	      });
	
	      return;
	    }
	  }
	
	  var textBlocks = [];
	  var text = data.getText();
	  var html = data.getHTML();
	
	  if (this.props.handlePastedText && isEventHandled(this.props.handlePastedText(text, html))) {
	    return;
	  }
	
	  if (text) {
	    textBlocks = splitTextIntoTextBlocks(text);
	  }
	
	  if (!this.props.stripPastedStyles) {
	    // If the text from the paste event is rich content that matches what we
	    // already have on the internal clipboard, assume that we should just use
	    // the clipboard fragment for the paste. This will allow us to preserve
	    // styling and entities, if any are present. Note that newlines are
	    // stripped during comparison -- this is because copy/paste within the
	    // editor in Firefox and IE will not include empty lines. The resulting
	    // paste will preserve the newlines correctly.
	    var internalClipboard = this.getClipboard();
	    if (data.isRichText() && internalClipboard) {
	      if (
	      // If the editorKey is present in the pasted HTML, it should be safe to
	      // assume this is an internal paste.
	      html.indexOf(this.getEditorKey()) !== -1 ||
	      // The copy may have been made within a single block, in which case the
	      // editor key won't be part of the paste. In this case, just check
	      // whether the pasted text matches the internal clipboard.
	      textBlocks.length === 1 && internalClipboard.size === 1 && internalClipboard.first().getText() === text) {
	        this.update(insertFragment(this.props.editorState, internalClipboard));
	        return;
	      }
	    } else if (internalClipboard && data.types.includes('com.apple.webarchive') && !data.types.includes('text/html') && areTextBlocksAndClipboardEqual(textBlocks, internalClipboard)) {
	      // Safari does not properly store text/html in some cases.
	      // Use the internalClipboard if present and equal to what is on
	      // the clipboard. See https://bugs.webkit.org/show_bug.cgi?id=19893.
	      this.update(insertFragment(this.props.editorState, internalClipboard));
	      return;
	    }
	
	    // If there is html paste data, try to parse that.
	    if (html) {
	      var htmlFragment = DraftPasteProcessor.processHTML(html, this.props.blockRenderMap);
	      if (htmlFragment) {
	        var htmlMap = BlockMapBuilder.createFromArray(htmlFragment);
	        this.update(insertFragment(this.props.editorState, htmlMap));
	        return;
	      }
	    }
	
	    // Otherwise, create a new fragment from our pasted text. Also
	    // empty the internal clipboard, since it's no longer valid.
	    this.setClipboard(null);
	  }
	
	  if (textBlocks) {
	    var editorState = this.props.editorState;
	
	    var character = CharacterMetadata.create({
	      style: editorState.getCurrentInlineStyle(),
	      entity: getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())
	    });
	
	    var textFragment = DraftPasteProcessor.processText(textBlocks, character);
	
	    var textMap = BlockMapBuilder.createFromArray(textFragment);
	    this.update(insertFragment(this.props.editorState, textMap));
	  }
	}
	
	function insertFragment(editorState, fragment) {
	  var newContent = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment);
	  return EditorState.push(editorState, newContent, 'insert-fragment');
	}
	
	function areTextBlocksAndClipboardEqual(textBlocks, blockMap) {
	  return textBlocks.length === blockMap.size && blockMap.valueSeq().every(function (block, ii) {
	    return block.getText() === textBlocks[ii];
	  });
	}
	
	module.exports = editOnPaste;

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnSelect
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(24);
	var ReactDOM = __webpack_require__(22);
	
	var getDraftEditorSelection = __webpack_require__(1091);
	
	function editOnSelect() {
	  if (this._blockSelectEvents) {
	    return;
	  }
	
	  var editorState = this.props.editorState;
	  var documentSelection = getDraftEditorSelection(editorState, ReactDOM.findDOMNode(this.refs.editorContainer).firstChild);
	  var updatedSelectionState = documentSelection.selectionState;
	
	  if (updatedSelectionState !== editorState.getSelection()) {
	    if (documentSelection.needsRecovery) {
	      editorState = EditorState.forceSelection(editorState, updatedSelectionState);
	    } else {
	      editorState = EditorState.acceptSelection(editorState, updatedSelectionState);
	    }
	    this.update(editorState);
	  }
	}
	
	module.exports = editOnSelect;

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule encodeEntityRanges
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var DraftStringKey = __webpack_require__(537);
	var UnicodeUtils = __webpack_require__(159);
	
	var strlen = UnicodeUtils.strlen;
	
	/**
	 * Convert to UTF-8 character counts for storage.
	 */
	
	function encodeEntityRanges(block, storageMap) {
	  var encoded = [];
	  block.findEntityRanges(function (character) {
	    return !!character.getEntity();
	  }, function ( /*number*/start, /*number*/end) {
	    var text = block.getText();
	    var key = block.getEntityAt(start);
	    encoded.push({
	      offset: strlen(text.slice(0, start)),
	      length: strlen(text.slice(start, end)),
	      // Encode the key as a number for range storage.
	      key: Number(storageMap[DraftStringKey.stringify(key)])
	    });
	  });
	  return encoded;
	}
	
	module.exports = encodeEntityRanges;

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule encodeInlineStyleRanges
	 * 
	 */
	
	'use strict';
	
	var UnicodeUtils = __webpack_require__(159);
	
	var findRangesImmutable = __webpack_require__(262);
	
	var areEqual = function areEqual(a, b) {
	  return a === b;
	};
	var isTruthy = function isTruthy(a) {
	  return !!a;
	};
	var EMPTY_ARRAY = [];
	
	/**
	 * Helper function for getting encoded styles for each inline style. Convert
	 * to UTF-8 character counts for storage.
	 */
	function getEncodedInlinesForType(block, styleList, styleToEncode) {
	  var ranges = [];
	
	  // Obtain an array with ranges for only the specified style.
	  var filteredInlines = styleList.map(function (style) {
	    return style.has(styleToEncode);
	  }).toList();
	
	  findRangesImmutable(filteredInlines, areEqual,
	  // We only want to keep ranges with nonzero style values.
	  isTruthy, function (start, end) {
	    var text = block.getText();
	    ranges.push({
	      offset: UnicodeUtils.strlen(text.slice(0, start)),
	      length: UnicodeUtils.strlen(text.slice(start, end)),
	      style: styleToEncode
	    });
	  });
	
	  return ranges;
	}
	
	/*
	 * Retrieve the encoded arrays of inline styles, with each individual style
	 * treated separately.
	 */
	function encodeInlineStyleRanges(block) {
	  var styleList = block.getCharacterList().map(function (c) {
	    return c.getStyle();
	  }).toList();
	  var ranges = styleList.flatten().toSet().map(function (style) {
	    return getEncodedInlinesForType(block, styleList, style);
	  });
	
	  return Array.prototype.concat.apply(EMPTY_ARRAY, ranges.toJS());
	}
	
	module.exports = encodeInlineStyleRanges;

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule expandRangeToStartOfLine
	 * @typechecks
	 * 
	 */
	
	var UnicodeUtils = __webpack_require__(159);
	
	var getRangeClientRects = __webpack_require__(542);
	var invariant = __webpack_require__(10);
	
	/**
	 * Return the computed line height, in pixels, for the provided element.
	 */
	function getLineHeightPx(element) {
	  var computed = getComputedStyle(element);
	  var div = document.createElement('div');
	  div.style.fontFamily = computed.fontFamily;
	  div.style.fontSize = computed.fontSize;
	  div.style.fontStyle = computed.fontStyle;
	  div.style.fontWeight = computed.fontWeight;
	  div.style.lineHeight = computed.lineHeight;
	  div.style.position = 'absolute';
	  div.textContent = 'M';
	
	  // forced layout here
	  document.body.appendChild(div);
	  var rect = div.getBoundingClientRect();
	  document.body.removeChild(div);
	
	  return rect.height;
	}
	
	/**
	 * Return whether every ClientRect in the provided list lies on the same line.
	 *
	 * We assume that the rects on the same line all contain the baseline, so the
	 * lowest top line needs to be above the highest bottom line (i.e., if you were
	 * to project the rects onto the y-axis, their intersection would be nonempty).
	 *
	 * In addition, we require that no two boxes are lineHeight (or more) apart at
	 * either top or bottom, which helps protect against false positives for fonts
	 * with extremely large glyph heights (e.g., with a font size of 17px, Zapfino
	 * produces rects of height 58px!).
	 */
	function areRectsOnOneLine(rects, lineHeight) {
	  var minTop = Infinity;
	  var minBottom = Infinity;
	  var maxTop = -Infinity;
	  var maxBottom = -Infinity;
	
	  for (var ii = 0; ii < rects.length; ii++) {
	    var rect = rects[ii];
	    if (rect.width === 0 || rect.width === 1) {
	      // When a range starts or ends a soft wrap, many browsers (Chrome, IE,
	      // Safari) include an empty rect on the previous or next line. When the
	      // text lies in a container whose position is not integral (e.g., from
	      // margin: auto), Safari makes these empty rects have width 1 (instead of
	      // 0). Having one-pixel-wide characters seems unlikely (and most browsers
	      // report widths in subpixel precision anyway) so it's relatively safe to
	      // skip over them.
	      continue;
	    }
	    minTop = Math.min(minTop, rect.top);
	    minBottom = Math.min(minBottom, rect.bottom);
	    maxTop = Math.max(maxTop, rect.top);
	    maxBottom = Math.max(maxBottom, rect.bottom);
	  }
	
	  return maxTop <= minBottom && maxTop - minTop < lineHeight && maxBottom - minBottom < lineHeight;
	}
	
	/**
	 * Return the length of a node, as used by Range offsets.
	 */
	function getNodeLength(node) {
	  // http://www.w3.org/TR/dom/#concept-node-length
	  switch (node.nodeType) {
	    case Node.DOCUMENT_TYPE_NODE:
	      return 0;
	    case Node.TEXT_NODE:
	    case Node.PROCESSING_INSTRUCTION_NODE:
	    case Node.COMMENT_NODE:
	      return node.length;
	    default:
	      return node.childNodes.length;
	  }
	}
	
	/**
	 * Given a collapsed range, move the start position backwards as far as
	 * possible while the range still spans only a single line.
	 */
	function expandRangeToStartOfLine(range) {
	  !range.collapsed ?  false ? invariant(false, 'expandRangeToStartOfLine: Provided range is not collapsed.') : invariant(false) : void 0;
	  range = range.cloneRange();
	
	  var containingElement = range.startContainer;
	  if (containingElement.nodeType !== 1) {
	    containingElement = containingElement.parentNode;
	  }
	  var lineHeight = getLineHeightPx(containingElement);
	
	  // Imagine our text looks like:
	  //   <div><span>once upon a time, there was a <em>boy
	  //   who lived</em> </span><q><strong>under^ the
	  //   stairs</strong> in a small closet.</q></div>
	  // where the caret represents the cursor. First, we crawl up the tree until
	  // the range spans multiple lines (setting the start point to before
	  // "<strong>", then before "<div>"), then at each level we do a search to
	  // find the latest point which is still on a previous line. We'll find that
	  // the break point is inside the span, then inside the <em>, then in its text
	  // node child, the actual break point before "who".
	
	  var bestContainer = range.endContainer;
	  var bestOffset = range.endOffset;
	  range.setStart(range.startContainer, 0);
	
	  while (areRectsOnOneLine(getRangeClientRects(range), lineHeight)) {
	    bestContainer = range.startContainer;
	    bestOffset = range.startOffset;
	    !bestContainer.parentNode ?  false ? invariant(false, 'Found unexpected detached subtree when traversing.') : invariant(false) : void 0;
	    range.setStartBefore(bestContainer);
	    if (bestContainer.nodeType === 1 && getComputedStyle(bestContainer).display !== 'inline') {
	      // The start of the line is never in a different block-level container.
	      break;
	    }
	  }
	
	  // In the above example, range now spans from "<div>" to "under",
	  // bestContainer is <div>, and bestOffset is 1 (index of <q> inside <div>)].
	  // Picking out which child to recurse into here is a special case since we
	  // don't want to check past <q> -- once we find that the final range starts
	  // in <span>, we can look at all of its children (and all of their children)
	  // to find the break point.
	
	  // At all times, (bestContainer, bestOffset) is the latest single-line start
	  // point that we know of.
	  var currentContainer = bestContainer;
	  var maxIndexToConsider = bestOffset - 1;
	
	  do {
	    var nodeValue = currentContainer.nodeValue;
	
	    for (var ii = maxIndexToConsider; ii >= 0; ii--) {
	      if (nodeValue != null && ii > 0 && UnicodeUtils.isSurrogatePair(nodeValue, ii - 1)) {
	        // We're in the middle of a surrogate pair -- skip over so we never
	        // return a range with an endpoint in the middle of a code point.
	        continue;
	      }
	
	      range.setStart(currentContainer, ii);
	      if (areRectsOnOneLine(getRangeClientRects(range), lineHeight)) {
	        bestContainer = currentContainer;
	        bestOffset = ii;
	      } else {
	        break;
	      }
	    }
	
	    if (ii === -1 || currentContainer.childNodes.length === 0) {
	      // If ii === -1, then (bestContainer, bestOffset), which is equal to
	      // (currentContainer, 0), was a single-line start point but a start
	      // point before currentContainer wasn't, so the line break seems to
	      // have occurred immediately after currentContainer's start tag
	      //
	      // If currentContainer.childNodes.length === 0, we're already at a
	      // terminal node (e.g., text node) and should return our current best.
	      break;
	    }
	
	    currentContainer = currentContainer.childNodes[ii];
	    maxIndexToConsider = getNodeLength(currentContainer);
	  } while (true);
	
	  range.setStart(bestContainer, bestOffset);
	  return range;
	}
	
	module.exports = expandRangeToStartOfLine;

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getCharacterRemovalRange
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var DraftEntity = __webpack_require__(117);
	var DraftEntitySegments = __webpack_require__(1062);
	
	var getRangesForDraftEntity = __webpack_require__(1093);
	var invariant = __webpack_require__(10);
	
	/**
	 * Given a SelectionState and a removal direction, determine the entire range
	 * that should be removed from a ContentState. This is based on any entities
	 * within the target, with their `mutability` values taken into account.
	 *
	 * For instance, if we are attempting to remove part of an "immutable" entity
	 * range, the entire entity must be removed. The returned `SelectionState`
	 * will be adjusted accordingly.
	 */
	function getCharacterRemovalRange(block, selectionState, direction) {
	  var start = selectionState.getStartOffset();
	  var end = selectionState.getEndOffset();
	  var entityKey = block.getEntityAt(start);
	  if (!entityKey) {
	    return selectionState;
	  }
	
	  var entity = DraftEntity.get(entityKey);
	  var mutability = entity.getMutability();
	
	  // `MUTABLE` entities can just have the specified range of text removed
	  // directly. No adjustments are needed.
	  if (mutability === 'MUTABLE') {
	    return selectionState;
	  }
	
	  // Find the entity range that overlaps with our removal range.
	  var entityRanges = getRangesForDraftEntity(block, entityKey).filter(function (range) {
	    return start < range.end && end > range.start;
	  });
	
	  !(entityRanges.length == 1) ?  false ? invariant(false, 'There should only be one entity range within this removal range.') : invariant(false) : void 0;
	
	  var entityRange = entityRanges[0];
	
	  // For `IMMUTABLE` entity types, we will remove the entire entity range.
	  if (mutability === 'IMMUTABLE') {
	    return selectionState.merge({
	      anchorOffset: entityRange.start,
	      focusOffset: entityRange.end,
	      isBackward: false
	    });
	  }
	
	  // For `SEGMENTED` entity types, determine the appropriate segment to
	  // remove.
	  var removalRange = DraftEntitySegments.getRemovalRange(start, end, block.getText().slice(entityRange.start, entityRange.end), entityRange.start, direction);
	
	  return selectionState.merge({
	    anchorOffset: removalRange.start,
	    focusOffset: removalRange.end,
	    isBackward: false
	  });
	}
	
	module.exports = getCharacterRemovalRange;

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getDraftEditorSelection
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var getDraftEditorSelectionWithNodes = __webpack_require__(540);
	
	/**
	 * Convert the current selection range to an anchor/focus pair of offset keys
	 * and values that can be interpreted by components.
	 */
	function getDraftEditorSelection(editorState, root) {
	  var selection = global.getSelection();
	
	  // No active selection.
	  if (selection.rangeCount === 0) {
	    return {
	      selectionState: editorState.getSelection().set('hasFocus', false),
	      needsRecovery: false
	    };
	  }
	
	  return getDraftEditorSelectionWithNodes(editorState, root, selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	}
	
	module.exports = getDraftEditorSelection;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getRangeBoundingClientRect
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var getRangeClientRects = __webpack_require__(542);
	
	/**
	 * Like range.getBoundingClientRect() but normalizes for browser bugs.
	 */
	function getRangeBoundingClientRect(range) {
	  // "Return a DOMRect object describing the smallest rectangle that includes
	  // the first rectangle in list and all of the remaining rectangles of which
	  // the height or width is not zero."
	  // http://www.w3.org/TR/cssom-view/#dom-range-getboundingclientrect
	  var rects = getRangeClientRects(range);
	  var top = 0;
	  var right = 0;
	  var bottom = 0;
	  var left = 0;
	
	  if (rects.length) {
	    var _rects$ = rects[0];
	    top = _rects$.top;
	    right = _rects$.right;
	    bottom = _rects$.bottom;
	    left = _rects$.left;
	
	    for (var ii = 1; ii < rects.length; ii++) {
	      var rect = rects[ii];
	      if (rect.height !== 0 || rect.width !== 0) {
	        top = Math.min(top, rect.top);
	        right = Math.max(right, rect.right);
	        bottom = Math.max(bottom, rect.bottom);
	        left = Math.min(left, rect.left);
	      }
	    }
	  }
	
	  return {
	    top: top,
	    right: right,
	    bottom: bottom,
	    left: left,
	    width: right - left,
	    height: bottom - top
	  };
	}
	
	module.exports = getRangeBoundingClientRect;

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getRangesForDraftEntity
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Obtain the start and end positions of the range that has the
	 * specified entity applied to it.
	 *
	 * Entity keys are applied only to contiguous stretches of text, so this
	 * method searches for the first instance of the entity key and returns
	 * the subsequent range.
	 */
	function getRangesForDraftEntity(block, key) {
	  var ranges = [];
	  block.findEntityRanges(function (c) {
	    return c.getEntity() === key;
	  }, function (start, end) {
	    ranges.push({ start: start, end: end });
	  });
	
	  !!!ranges.length ?  false ? invariant(false, 'Entity key not found in this range.') : invariant(false) : void 0;
	
	  return ranges;
	}
	
	module.exports = getRangesForDraftEntity;

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getVisibleSelectionRect
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var getRangeBoundingClientRect = __webpack_require__(1092);
	
	/**
	 * Return the bounding ClientRect for the visible DOM selection, if any.
	 * In cases where there are no selected ranges or the bounding rect is
	 * temporarily invalid, return null.
	 */
	function getVisibleSelectionRect(global) {
	  var selection = global.getSelection();
	  if (!selection.rangeCount) {
	    return null;
	  }
	
	  var range = selection.getRangeAt(0);
	  var boundingRect = getRangeBoundingClientRect(range);
	  var top = boundingRect.top;
	  var right = boundingRect.right;
	  var bottom = boundingRect.bottom;
	  var left = boundingRect.left;
	
	  // When a re-render leads to a node being removed, the DOM selection will
	  // temporarily be placed on an ancestor node, which leads to an invalid
	  // bounding rect. Discard this state.
	
	  if (top === 0 && right === 0 && bottom === 0 && left === 0) {
	    return null;
	  }
	
	  return boundingRect;
	}
	
	module.exports = getVisibleSelectionRect;

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule insertFragmentIntoContentState
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var BlockMapBuilder = __webpack_require__(213);
	
	var generateRandomKey = __webpack_require__(100);
	var insertIntoList = __webpack_require__(547);
	var invariant = __webpack_require__(10);
	
	function insertFragmentIntoContentState(contentState, selectionState, fragment) {
	  !selectionState.isCollapsed() ?  false ? invariant(false, '`insertFragment` should only be called with a collapsed selection state.') : invariant(false) : void 0;
	
	  var targetKey = selectionState.getStartKey();
	  var targetOffset = selectionState.getStartOffset();
	
	  var blockMap = contentState.getBlockMap();
	
	  var fragmentSize = fragment.size;
	  var finalKey;
	  var finalOffset;
	
	  if (fragmentSize === 1) {
	    var targetBlock = blockMap.get(targetKey);
	    var pastedBlock = fragment.first();
	    var text = targetBlock.getText();
	    var chars = targetBlock.getCharacterList();
	
	    var newBlock = targetBlock.merge({
	      text: text.slice(0, targetOffset) + pastedBlock.getText() + text.slice(targetOffset),
	      characterList: insertIntoList(chars, pastedBlock.getCharacterList(), targetOffset),
	      data: pastedBlock.getData()
	    });
	
	    blockMap = blockMap.set(targetKey, newBlock);
	
	    finalKey = targetKey;
	    finalOffset = targetOffset + pastedBlock.getText().length;
	
	    return contentState.merge({
	      blockMap: blockMap.set(targetKey, newBlock),
	      selectionBefore: selectionState,
	      selectionAfter: selectionState.merge({
	        anchorKey: finalKey,
	        anchorOffset: finalOffset,
	        focusKey: finalKey,
	        focusOffset: finalOffset,
	        isBackward: false
	      })
	    });
	  }
	
	  var newBlockArr = [];
	
	  contentState.getBlockMap().forEach(function (block, blockKey) {
	    if (blockKey !== targetKey) {
	      newBlockArr.push(block);
	      return;
	    }
	
	    var text = block.getText();
	    var chars = block.getCharacterList();
	
	    // Modify head portion of block.
	    var blockSize = text.length;
	    var headText = text.slice(0, targetOffset);
	    var headCharacters = chars.slice(0, targetOffset);
	    var appendToHead = fragment.first();
	
	    var modifiedHead = block.merge({
	      text: headText + appendToHead.getText(),
	      characterList: headCharacters.concat(appendToHead.getCharacterList()),
	      type: headText ? block.getType() : appendToHead.getType(),
	      data: appendToHead.getData()
	    });
	
	    newBlockArr.push(modifiedHead);
	
	    // Insert fragment blocks after the head and before the tail.
	    fragment.slice(1, fragmentSize - 1).forEach(function (fragmentBlock) {
	      newBlockArr.push(fragmentBlock.set('key', generateRandomKey()));
	    });
	
	    // Modify tail portion of block.
	    var tailText = text.slice(targetOffset, blockSize);
	    var tailCharacters = chars.slice(targetOffset, blockSize);
	    var prependToTail = fragment.last();
	    finalKey = generateRandomKey();
	
	    var modifiedTail = prependToTail.merge({
	      key: finalKey,
	      text: prependToTail.getText() + tailText,
	      characterList: prependToTail.getCharacterList().concat(tailCharacters),
	      data: prependToTail.getData()
	    });
	
	    newBlockArr.push(modifiedTail);
	  });
	
	  finalOffset = fragment.last().getLength();
	
	  return contentState.merge({
	    blockMap: BlockMapBuilder.createFromArray(newBlockArr),
	    selectionBefore: selectionState,
	    selectionAfter: selectionState.merge({
	      anchorKey: finalKey,
	      anchorOffset: finalOffset,
	      focusKey: finalKey,
	      focusOffset: finalOffset,
	      isBackward: false
	    })
	  });
	}
	
	module.exports = insertFragmentIntoContentState;

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule insertTextIntoContentState
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(28);
	
	var insertIntoList = __webpack_require__(547);
	var invariant = __webpack_require__(10);
	
	var Repeat = Immutable.Repeat;
	
	
	function insertTextIntoContentState(contentState, selectionState, text, characterMetadata) {
	  !selectionState.isCollapsed() ?  false ? invariant(false, '`insertText` should only be called with a collapsed range.') : invariant(false) : void 0;
	
	  var len = text.length;
	  if (!len) {
	    return contentState;
	  }
	
	  var blockMap = contentState.getBlockMap();
	  var key = selectionState.getStartKey();
	  var offset = selectionState.getStartOffset();
	  var block = blockMap.get(key);
	  var blockText = block.getText();
	
	  var newBlock = block.merge({
	    text: blockText.slice(0, offset) + text + blockText.slice(offset, block.getLength()),
	    characterList: insertIntoList(block.getCharacterList(), Repeat(characterMetadata, len).toList(), offset)
	  });
	
	  var newOffset = offset + len;
	
	  return contentState.merge({
	    blockMap: blockMap.set(key, newBlock),
	    selectionAfter: selectionState.merge({
	      anchorOffset: newOffset,
	      focusOffset: newOffset
	    })
	  });
	}
	
	module.exports = insertTextIntoContentState;

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandBackspaceToStartOfLine
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(24);
	
	var expandRangeToStartOfLine = __webpack_require__(1089);
	var getDraftEditorSelectionWithNodes = __webpack_require__(540);
	var moveSelectionBackward = __webpack_require__(361);
	var removeTextWithStrategy = __webpack_require__(214);
	
	function keyCommandBackspaceToStartOfLine(editorState) {
	  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
	    var selection = strategyState.getSelection();
	    if (selection.isCollapsed() && selection.getAnchorOffset() === 0) {
	      return moveSelectionBackward(strategyState, 1);
	    }
	
	    var domSelection = global.getSelection();
	    var range = domSelection.getRangeAt(0);
	    range = expandRangeToStartOfLine(range);
	
	    return getDraftEditorSelectionWithNodes(strategyState, null, range.endContainer, range.endOffset, range.startContainer, range.startOffset).selectionState;
	  }, 'backward');
	
	  if (afterRemoval === editorState.getCurrentContent()) {
	    return editorState;
	  }
	
	  return EditorState.push(editorState, afterRemoval, 'remove-range');
	}
	
	module.exports = keyCommandBackspaceToStartOfLine;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandBackspaceWord
	 * 
	 */
	
	'use strict';
	
	var DraftRemovableWord = __webpack_require__(536);
	var EditorState = __webpack_require__(24);
	
	var moveSelectionBackward = __webpack_require__(361);
	var removeTextWithStrategy = __webpack_require__(214);
	
	/**
	 * Delete the word that is left of the cursor, as well as any spaces or
	 * punctuation after the word.
	 */
	function keyCommandBackspaceWord(editorState) {
	  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
	    var selection = strategyState.getSelection();
	    var offset = selection.getStartOffset();
	    // If there are no words before the cursor, remove the preceding newline.
	    if (offset === 0) {
	      return moveSelectionBackward(strategyState, 1);
	    }
	    var key = selection.getStartKey();
	    var content = strategyState.getCurrentContent();
	    var text = content.getBlockForKey(key).getText().slice(0, offset);
	    var toRemove = DraftRemovableWord.getBackward(text);
	    return moveSelectionBackward(strategyState, toRemove.length || 1);
	  }, 'backward');
	
	  if (afterRemoval === editorState.getCurrentContent()) {
	    return editorState;
	  }
	
	  return EditorState.push(editorState, afterRemoval, 'remove-range');
	}
	
	module.exports = keyCommandBackspaceWord;

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandDeleteWord
	 * 
	 */
	
	'use strict';
	
	var DraftRemovableWord = __webpack_require__(536);
	var EditorState = __webpack_require__(24);
	
	var moveSelectionForward = __webpack_require__(549);
	var removeTextWithStrategy = __webpack_require__(214);
	
	/**
	 * Delete the word that is right of the cursor, as well as any spaces or
	 * punctuation before the word.
	 */
	function keyCommandDeleteWord(editorState) {
	  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
	    var selection = strategyState.getSelection();
	    var offset = selection.getStartOffset();
	    var key = selection.getStartKey();
	    var content = strategyState.getCurrentContent();
	    var text = content.getBlockForKey(key).getText().slice(offset);
	    var toRemove = DraftRemovableWord.getForward(text);
	
	    // If there are no words in front of the cursor, remove the newline.
	    return moveSelectionForward(strategyState, toRemove.length || 1);
	  }, 'forward');
	
	  if (afterRemoval === editorState.getCurrentContent()) {
	    return editorState;
	  }
	
	  return EditorState.push(editorState, afterRemoval, 'remove-range');
	}
	
	module.exports = keyCommandDeleteWord;

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandInsertNewline
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(63);
	var EditorState = __webpack_require__(24);
	
	function keyCommandInsertNewline(editorState) {
	  var contentState = DraftModifier.splitBlock(editorState.getCurrentContent(), editorState.getSelection());
	  return EditorState.push(editorState, contentState, 'split-block');
	}
	
	module.exports = keyCommandInsertNewline;

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandMoveSelectionToEndOfBlock
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(24);
	
	/**
	 * See comment for `moveSelectionToStartOfBlock`.
	 */
	function keyCommandMoveSelectionToEndOfBlock(editorState) {
	  var selection = editorState.getSelection();
	  var endKey = selection.getEndKey();
	  var content = editorState.getCurrentContent();
	  var textLength = content.getBlockForKey(endKey).getLength();
	  return EditorState.set(editorState, {
	    selection: selection.merge({
	      anchorKey: endKey,
	      anchorOffset: textLength,
	      focusKey: endKey,
	      focusOffset: textLength,
	      isBackward: false
	    }),
	    forceSelection: true
	  });
	}
	
	module.exports = keyCommandMoveSelectionToEndOfBlock;

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandMoveSelectionToStartOfBlock
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(24);
	
	/**
	 * Collapse selection at the start of the first selected block. This is used
	 * for Firefox versions that attempt to navigate forward/backward instead of
	 * moving the cursor. Other browsers are able to move the cursor natively.
	 */
	function keyCommandMoveSelectionToStartOfBlock(editorState) {
	  var selection = editorState.getSelection();
	  var startKey = selection.getStartKey();
	  return EditorState.set(editorState, {
	    selection: selection.merge({
	      anchorKey: startKey,
	      anchorOffset: 0,
	      focusKey: startKey,
	      focusOffset: 0,
	      isBackward: false
	    }),
	    forceSelection: true
	  });
	}
	
	module.exports = keyCommandMoveSelectionToStartOfBlock;

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandPlainBackspace
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(24);
	var UnicodeUtils = __webpack_require__(159);
	
	var moveSelectionBackward = __webpack_require__(361);
	var removeTextWithStrategy = __webpack_require__(214);
	
	/**
	 * Remove the selected range. If the cursor is collapsed, remove the preceding
	 * character. This operation is Unicode-aware, so removing a single character
	 * will remove a surrogate pair properly as well.
	 */
	function keyCommandPlainBackspace(editorState) {
	  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
	    var selection = strategyState.getSelection();
	    var content = strategyState.getCurrentContent();
	    var key = selection.getAnchorKey();
	    var offset = selection.getAnchorOffset();
	    var charBehind = content.getBlockForKey(key).getText()[offset - 1];
	    return moveSelectionBackward(strategyState, charBehind ? UnicodeUtils.getUTF16Length(charBehind, 0) : 1);
	  }, 'backward');
	
	  if (afterRemoval === editorState.getCurrentContent()) {
	    return editorState;
	  }
	
	  var selection = editorState.getSelection();
	  return EditorState.push(editorState, afterRemoval.set('selectionBefore', selection), selection.isCollapsed() ? 'backspace-character' : 'remove-range');
	}
	
	module.exports = keyCommandPlainBackspace;

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandPlainDelete
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(24);
	var UnicodeUtils = __webpack_require__(159);
	
	var moveSelectionForward = __webpack_require__(549);
	var removeTextWithStrategy = __webpack_require__(214);
	
	/**
	 * Remove the selected range. If the cursor is collapsed, remove the following
	 * character. This operation is Unicode-aware, so removing a single character
	 * will remove a surrogate pair properly as well.
	 */
	function keyCommandPlainDelete(editorState) {
	  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
	    var selection = strategyState.getSelection();
	    var content = strategyState.getCurrentContent();
	    var key = selection.getAnchorKey();
	    var offset = selection.getAnchorOffset();
	    var charAhead = content.getBlockForKey(key).getText()[offset];
	    return moveSelectionForward(strategyState, charAhead ? UnicodeUtils.getUTF16Length(charAhead, 0) : 1);
	  }, 'forward');
	
	  if (afterRemoval === editorState.getCurrentContent()) {
	    return editorState;
	  }
	
	  var selection = editorState.getSelection();
	
	  return EditorState.push(editorState, afterRemoval.set('selectionBefore', selection), selection.isCollapsed() ? 'delete-character' : 'remove-range');
	}
	
	module.exports = keyCommandPlainDelete;

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandTransposeCharacters
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(63);
	var EditorState = __webpack_require__(24);
	
	var getContentStateFragment = __webpack_require__(263);
	
	/**
	 * Transpose the characters on either side of a collapsed cursor, or
	 * if the cursor is at the end of the block, transpose the last two
	 * characters.
	 */
	function keyCommandTransposeCharacters(editorState) {
	  var selection = editorState.getSelection();
	  if (!selection.isCollapsed()) {
	    return editorState;
	  }
	
	  var offset = selection.getAnchorOffset();
	  if (offset === 0) {
	    return editorState;
	  }
	
	  var blockKey = selection.getAnchorKey();
	  var content = editorState.getCurrentContent();
	  var block = content.getBlockForKey(blockKey);
	  var length = block.getLength();
	
	  // Nothing to transpose if there aren't two characters.
	  if (length <= 1) {
	    return editorState;
	  }
	
	  var removalRange;
	  var finalSelection;
	
	  if (offset === length) {
	    // The cursor is at the end of the block. Swap the last two characters.
	    removalRange = selection.set('anchorOffset', offset - 1);
	    finalSelection = selection;
	  } else {
	    removalRange = selection.set('focusOffset', offset + 1);
	    finalSelection = removalRange.set('anchorOffset', offset + 1);
	  }
	
	  // Extract the character to move as a fragment. This preserves its
	  // styling and entity, if any.
	  var movedFragment = getContentStateFragment(content, removalRange);
	  var afterRemoval = DraftModifier.removeRange(content, removalRange, 'backward');
	
	  // After the removal, the insertion target is one character back.
	  var selectionAfter = afterRemoval.getSelectionAfter();
	  var targetOffset = selectionAfter.getAnchorOffset() - 1;
	  var targetRange = selectionAfter.merge({
	    anchorOffset: targetOffset,
	    focusOffset: targetOffset
	  });
	
	  var afterInsert = DraftModifier.replaceWithFragment(afterRemoval, targetRange, movedFragment);
	
	  var newEditorState = EditorState.push(editorState, afterInsert, 'insert-fragment');
	
	  return EditorState.acceptSelection(newEditorState, finalSelection);
	}
	
	module.exports = keyCommandTransposeCharacters;

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandUndo
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(24);
	
	function keyCommandUndo(e, editorState, updateFn) {
	  var undoneState = EditorState.undo(editorState);
	
	  // If the last change to occur was a spellcheck change, allow the undo
	  // event to fall through to the browser. This allows the browser to record
	  // the unwanted change, which should soon lead it to learn not to suggest
	  // the correction again.
	  if (editorState.getLastChangeType() === 'spellcheck-change') {
	    var nativelyRenderedContent = undoneState.getCurrentContent();
	    updateFn(EditorState.set(undoneState, { nativelyRenderedContent: nativelyRenderedContent }));
	    return;
	  }
	
	  // Otheriwse, manage the undo behavior manually.
	  e.preventDefault();
	  if (!editorState.getNativelyRenderedContent()) {
	    updateFn(undoneState);
	    return;
	  }
	
	  // Trigger a re-render with the current content state to ensure that the
	  // component tree has up-to-date props for comparison.
	  updateFn(EditorState.set(editorState, { nativelyRenderedContent: null }));
	
	  // Wait to ensure that the re-render has occurred before performing
	  // the undo action.
	  setTimeout(function () {
	    updateFn(undoneState);
	  }, 0);
	}
	
	module.exports = keyCommandUndo;

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule modifyBlockForContentState
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(28);
	
	var Map = Immutable.Map;
	
	
	function modifyBlockForContentState(contentState, selectionState, operation) {
	  var startKey = selectionState.getStartKey();
	  var endKey = selectionState.getEndKey();
	  var blockMap = contentState.getBlockMap();
	  var newBlocks = blockMap.toSeq().skipUntil(function (_, k) {
	    return k === startKey;
	  }).takeUntil(function (_, k) {
	    return k === endKey;
	  }).concat(Map([[endKey, blockMap.get(endKey)]])).map(operation);
	
	  return contentState.merge({
	    blockMap: blockMap.merge(newBlocks),
	    selectionBefore: selectionState,
	    selectionAfter: selectionState
	  });
	}
	
	module.exports = modifyBlockForContentState;

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule removeRangeFromContentState
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(28);
	
	function removeRangeFromContentState(contentState, selectionState) {
	  if (selectionState.isCollapsed()) {
	    return contentState;
	  }
	
	  var blockMap = contentState.getBlockMap();
	  var startKey = selectionState.getStartKey();
	  var startOffset = selectionState.getStartOffset();
	  var endKey = selectionState.getEndKey();
	  var endOffset = selectionState.getEndOffset();
	
	  var startBlock = blockMap.get(startKey);
	  var endBlock = blockMap.get(endKey);
	  var characterList;
	
	  if (startBlock === endBlock) {
	    characterList = removeFromList(startBlock.getCharacterList(), startOffset, endOffset);
	  } else {
	    characterList = startBlock.getCharacterList().slice(0, startOffset).concat(endBlock.getCharacterList().slice(endOffset));
	  }
	
	  var modifiedStart = startBlock.merge({
	    text: startBlock.getText().slice(0, startOffset) + endBlock.getText().slice(endOffset),
	    characterList: characterList
	  });
	
	  var newBlocks = blockMap.toSeq().skipUntil(function (_, k) {
	    return k === startKey;
	  }).takeUntil(function (_, k) {
	    return k === endKey;
	  }).concat(Immutable.Map([[endKey, null]])).map(function (_, k) {
	    return k === startKey ? modifiedStart : null;
	  });
	
	  blockMap = blockMap.merge(newBlocks).filter(function (block) {
	    return !!block;
	  });
	
	  return contentState.merge({
	    blockMap: blockMap,
	    selectionBefore: selectionState,
	    selectionAfter: selectionState.merge({
	      anchorKey: startKey,
	      anchorOffset: startOffset,
	      focusKey: startKey,
	      focusOffset: startOffset,
	      isBackward: false
	    })
	  });
	}
	
	/**
	 * Maintain persistence for target list when removing characters on the
	 * head and tail of the character list.
	 */
	function removeFromList(targetList, startOffset, endOffset) {
	  if (startOffset === 0) {
	    while (startOffset < endOffset) {
	      targetList = targetList.shift();
	      startOffset++;
	    }
	  } else if (endOffset === targetList.count()) {
	    while (endOffset > startOffset) {
	      targetList = targetList.pop();
	      endOffset--;
	    }
	  } else {
	    var head = targetList.slice(0, startOffset);
	    var tail = targetList.slice(endOffset);
	    targetList = head.concat(tail).toList();
	  }
	  return targetList;
	}
	
	module.exports = removeRangeFromContentState;

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setDraftEditorSelection
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var containsNode = __webpack_require__(368);
	var getActiveElement = __webpack_require__(265);
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 */
	function setDraftEditorSelection(selectionState, node, blockKey, nodeStart, nodeEnd) {
	  // It's possible that the editor has been removed from the DOM but
	  // our selection code doesn't know it yet. Forcing selection in
	  // this case may lead to errors, so just bail now.
	  if (!containsNode(document.documentElement, node)) {
	    return;
	  }
	
	  var selection = global.getSelection();
	  var anchorKey = selectionState.getAnchorKey();
	  var anchorOffset = selectionState.getAnchorOffset();
	  var focusKey = selectionState.getFocusKey();
	  var focusOffset = selectionState.getFocusOffset();
	  var isBackward = selectionState.getIsBackward();
	
	  // IE doesn't support backward selection. Swap key/offset pairs.
	  if (!selection.extend && isBackward) {
	    var tempKey = anchorKey;
	    var tempOffset = anchorOffset;
	    anchorKey = focusKey;
	    anchorOffset = focusOffset;
	    focusKey = tempKey;
	    focusOffset = tempOffset;
	    isBackward = false;
	  }
	
	  var hasAnchor = anchorKey === blockKey && nodeStart <= anchorOffset && nodeEnd >= anchorOffset;
	
	  var hasFocus = focusKey === blockKey && nodeStart <= focusOffset && nodeEnd >= focusOffset;
	
	  // If the selection is entirely bound within this node, set the selection
	  // and be done.
	  if (hasAnchor && hasFocus) {
	    selection.removeAllRanges();
	    addPointToSelection(selection, node, anchorOffset - nodeStart);
	    addFocusToSelection(selection, node, focusOffset - nodeStart);
	    return;
	  }
	
	  if (!isBackward) {
	    // If the anchor is within this node, set the range start.
	    if (hasAnchor) {
	      selection.removeAllRanges();
	      addPointToSelection(selection, node, anchorOffset - nodeStart);
	    }
	
	    // If the focus is within this node, we can assume that we have
	    // already set the appropriate start range on the selection, and
	    // can simply extend the selection.
	    if (hasFocus) {
	      addFocusToSelection(selection, node, focusOffset - nodeStart);
	    }
	  } else {
	    // If this node has the focus, set the selection range to be a
	    // collapsed range beginning here. Later, when we encounter the anchor,
	    // we'll use this information to extend the selection.
	    if (hasFocus) {
	      selection.removeAllRanges();
	      addPointToSelection(selection, node, focusOffset - nodeStart);
	    }
	
	    // If this node has the anchor, we may assume that the correct
	    // focus information is already stored on the selection object.
	    // We keep track of it, reset the selection range, and extend it
	    // back to the focus point.
	    if (hasAnchor) {
	      var storedFocusNode = selection.focusNode;
	      var storedFocusOffset = selection.focusOffset;
	
	      selection.removeAllRanges();
	      addPointToSelection(selection, node, anchorOffset - nodeStart);
	      addFocusToSelection(selection, storedFocusNode, storedFocusOffset);
	    }
	  }
	}
	
	/**
	 * Extend selection towards focus point.
	 */
	function addFocusToSelection(selection, node, offset) {
	  if (selection.extend && containsNode(getActiveElement(), node)) {
	    // If `extend` is called while another element has focus, an error is
	    // thrown. We therefore disable `extend` if the active element is somewhere
	    // other than the node we are selecting. This should only occur in Firefox,
	    // since it is the only browser to support multiple selections.
	    // See https://bugzilla.mozilla.org/show_bug.cgi?id=921444.
	    selection.extend(node, offset);
	  } else {
	    // IE doesn't support extend. This will mean no backward selection.
	    // Extract the existing selection range and add focus to it.
	    // Additionally, clone the selection range. IE11 throws an
	    // InvalidStateError when attempting to access selection properties
	    // after the range is detached.
	    var range = selection.getRangeAt(0);
	    range.setEnd(node, offset);
	    selection.addRange(range.cloneRange());
	  }
	}
	
	function addPointToSelection(selection, node, offset) {
	  var range = document.createRange();
	  range.setStart(node, offset);
	  selection.addRange(range);
	}
	
	module.exports = setDraftEditorSelection;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule splitBlockInContentState
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(28);
	
	var generateRandomKey = __webpack_require__(100);
	var invariant = __webpack_require__(10);
	
	var Map = Immutable.Map;
	
	
	function splitBlockInContentState(contentState, selectionState) {
	  !selectionState.isCollapsed() ?  false ? invariant(false, 'Selection range must be collapsed.') : invariant(false) : void 0;
	
	  var key = selectionState.getAnchorKey();
	  var offset = selectionState.getAnchorOffset();
	  var blockMap = contentState.getBlockMap();
	  var blockToSplit = blockMap.get(key);
	
	  var text = blockToSplit.getText();
	  var chars = blockToSplit.getCharacterList();
	
	  var blockAbove = blockToSplit.merge({
	    text: text.slice(0, offset),
	    characterList: chars.slice(0, offset)
	  });
	
	  var keyBelow = generateRandomKey();
	  var blockBelow = blockAbove.merge({
	    key: keyBelow,
	    text: text.slice(offset),
	    characterList: chars.slice(offset),
	    data: Map()
	  });
	
	  var blocksBefore = blockMap.toSeq().takeUntil(function (v) {
	    return v === blockToSplit;
	  });
	  var blocksAfter = blockMap.toSeq().skipUntil(function (v) {
	    return v === blockToSplit;
	  }).rest();
	  var newBlocks = blocksBefore.concat([[blockAbove.getKey(), blockAbove], [blockBelow.getKey(), blockBelow]], blocksAfter).toOrderedMap();
	
	  return contentState.merge({
	    blockMap: newBlocks,
	    selectionBefore: selectionState,
	    selectionAfter: selectionState.merge({
	      anchorKey: keyBelow,
	      anchorOffset: 0,
	      focusKey: keyBelow,
	      focusOffset: 0,
	      isBackward: false
	    })
	  });
	}
	
	module.exports = splitBlockInContentState;

/***/ }),
/* 1111 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule splitTextIntoTextBlocks
	 * 
	 */
	
	'use strict';
	
	var NEWLINE_REGEX = /\r\n?|\n/g;
	
	function splitTextIntoTextBlocks(text) {
	  return text.split(NEWLINE_REGEX);
	}
	
	module.exports = splitTextIntoTextBlocks;

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

	
	module.exports = __webpack_require__(1113);


/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

	
	module.exports = __webpack_require__(1114);
	
	/**
	 * Exports parser
	 *
	 * @api public
	 *
	 */
	module.exports.parser = __webpack_require__(183);


/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies.
	 */
	
	var transports = __webpack_require__(551);
	var Emitter = __webpack_require__(176);
	var debug = __webpack_require__(116)('engine.io-client:socket');
	var index = __webpack_require__(576);
	var parser = __webpack_require__(183);
	var parseuri = __webpack_require__(595);
	var parsejson = __webpack_require__(1446);
	var parseqs = __webpack_require__(382);
	
	/**
	 * Module exports.
	 */
	
	module.exports = Socket;
	
	/**
	 * Socket constructor.
	 *
	 * @param {String|Object} uri or options
	 * @param {Object} options
	 * @api public
	 */
	
	function Socket (uri, opts) {
	  if (!(this instanceof Socket)) return new Socket(uri, opts);
	
	  opts = opts || {};
	
	  if (uri && 'object' === typeof uri) {
	    opts = uri;
	    uri = null;
	  }
	
	  if (uri) {
	    uri = parseuri(uri);
	    opts.hostname = uri.host;
	    opts.secure = uri.protocol === 'https' || uri.protocol === 'wss';
	    opts.port = uri.port;
	    if (uri.query) opts.query = uri.query;
	  } else if (opts.host) {
	    opts.hostname = parseuri(opts.host).host;
	  }
	
	  this.secure = null != opts.secure ? opts.secure
	    : (global.location && 'https:' === location.protocol);
	
	  if (opts.hostname && !opts.port) {
	    // if no port is specified manually, use the protocol default
	    opts.port = this.secure ? '443' : '80';
	  }
	
	  this.agent = opts.agent || false;
	  this.hostname = opts.hostname ||
	    (global.location ? location.hostname : 'localhost');
	  this.port = opts.port || (global.location && location.port
	      ? location.port
	      : (this.secure ? 443 : 80));
	  this.query = opts.query || {};
	  if ('string' === typeof this.query) this.query = parseqs.decode(this.query);
	  this.upgrade = false !== opts.upgrade;
	  this.path = (opts.path || '/engine.io').replace(/\/$/, '') + '/';
	  this.forceJSONP = !!opts.forceJSONP;
	  this.jsonp = false !== opts.jsonp;
	  this.forceBase64 = !!opts.forceBase64;
	  this.enablesXDR = !!opts.enablesXDR;
	  this.timestampParam = opts.timestampParam || 't';
	  this.timestampRequests = opts.timestampRequests;
	  this.transports = opts.transports || ['polling', 'websocket'];
	  this.transportOptions = opts.transportOptions || {};
	  this.readyState = '';
	  this.writeBuffer = [];
	  this.prevBufferLen = 0;
	  this.policyPort = opts.policyPort || 843;
	  this.rememberUpgrade = opts.rememberUpgrade || false;
	  this.binaryType = null;
	  this.onlyBinaryUpgrades = opts.onlyBinaryUpgrades;
	  this.perMessageDeflate = false !== opts.perMessageDeflate ? (opts.perMessageDeflate || {}) : false;
	
	  if (true === this.perMessageDeflate) this.perMessageDeflate = {};
	  if (this.perMessageDeflate && null == this.perMessageDeflate.threshold) {
	    this.perMessageDeflate.threshold = 1024;
	  }
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx || null;
	  this.key = opts.key || null;
	  this.passphrase = opts.passphrase || null;
	  this.cert = opts.cert || null;
	  this.ca = opts.ca || null;
	  this.ciphers = opts.ciphers || null;
	  this.rejectUnauthorized = opts.rejectUnauthorized === undefined ? true : opts.rejectUnauthorized;
	  this.forceNode = !!opts.forceNode;
	
	  // other options for Node.js client
	  var freeGlobal = typeof global === 'object' && global;
	  if (freeGlobal.global === freeGlobal) {
	    if (opts.extraHeaders && Object.keys(opts.extraHeaders).length > 0) {
	      this.extraHeaders = opts.extraHeaders;
	    }
	
	    if (opts.localAddress) {
	      this.localAddress = opts.localAddress;
	    }
	  }
	
	  // set on handshake
	  this.id = null;
	  this.upgrades = null;
	  this.pingInterval = null;
	  this.pingTimeout = null;
	
	  // set on heartbeat
	  this.pingIntervalTimer = null;
	  this.pingTimeoutTimer = null;
	
	  this.open();
	}
	
	Socket.priorWebsocketSuccess = false;
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Socket.prototype);
	
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	Socket.protocol = parser.protocol; // this is an int
	
	/**
	 * Expose deps for legacy compatibility
	 * and standalone browser access.
	 */
	
	Socket.Socket = Socket;
	Socket.Transport = __webpack_require__(363);
	Socket.transports = __webpack_require__(551);
	Socket.parser = __webpack_require__(183);
	
	/**
	 * Creates transport of the given type.
	 *
	 * @param {String} transport name
	 * @return {Transport}
	 * @api private
	 */
	
	Socket.prototype.createTransport = function (name) {
	  debug('creating transport "%s"', name);
	  var query = clone(this.query);
	
	  // append engine.io protocol identifier
	  query.EIO = parser.protocol;
	
	  // transport name
	  query.transport = name;
	
	  // per-transport options
	  var options = this.transportOptions[name] || {};
	
	  // session id if we already have one
	  if (this.id) query.sid = this.id;
	
	  var transport = new transports[name]({
	    query: query,
	    socket: this,
	    agent: options.agent || this.agent,
	    hostname: options.hostname || this.hostname,
	    port: options.port || this.port,
	    secure: options.secure || this.secure,
	    path: options.path || this.path,
	    forceJSONP: options.forceJSONP || this.forceJSONP,
	    jsonp: options.jsonp || this.jsonp,
	    forceBase64: options.forceBase64 || this.forceBase64,
	    enablesXDR: options.enablesXDR || this.enablesXDR,
	    timestampRequests: options.timestampRequests || this.timestampRequests,
	    timestampParam: options.timestampParam || this.timestampParam,
	    policyPort: options.policyPort || this.policyPort,
	    pfx: options.pfx || this.pfx,
	    key: options.key || this.key,
	    passphrase: options.passphrase || this.passphrase,
	    cert: options.cert || this.cert,
	    ca: options.ca || this.ca,
	    ciphers: options.ciphers || this.ciphers,
	    rejectUnauthorized: options.rejectUnauthorized || this.rejectUnauthorized,
	    perMessageDeflate: options.perMessageDeflate || this.perMessageDeflate,
	    extraHeaders: options.extraHeaders || this.extraHeaders,
	    forceNode: options.forceNode || this.forceNode,
	    localAddress: options.localAddress || this.localAddress,
	    requestTimeout: options.requestTimeout || this.requestTimeout,
	    protocols: options.protocols || void (0)
	  });
	
	  return transport;
	};
	
	function clone (obj) {
	  var o = {};
	  for (var i in obj) {
	    if (obj.hasOwnProperty(i)) {
	      o[i] = obj[i];
	    }
	  }
	  return o;
	}
	
	/**
	 * Initializes transport to use and starts probe.
	 *
	 * @api private
	 */
	Socket.prototype.open = function () {
	  var transport;
	  if (this.rememberUpgrade && Socket.priorWebsocketSuccess && this.transports.indexOf('websocket') !== -1) {
	    transport = 'websocket';
	  } else if (0 === this.transports.length) {
	    // Emit error on next tick so it can be listened to
	    var self = this;
	    setTimeout(function () {
	      self.emit('error', 'No transports available');
	    }, 0);
	    return;
	  } else {
	    transport = this.transports[0];
	  }
	  this.readyState = 'opening';
	
	  // Retry with the next transport if the transport is disabled (jsonp: false)
	  try {
	    transport = this.createTransport(transport);
	  } catch (e) {
	    this.transports.shift();
	    this.open();
	    return;
	  }
	
	  transport.open();
	  this.setTransport(transport);
	};
	
	/**
	 * Sets the current transport. Disables the existing one (if any).
	 *
	 * @api private
	 */
	
	Socket.prototype.setTransport = function (transport) {
	  debug('setting transport %s', transport.name);
	  var self = this;
	
	  if (this.transport) {
	    debug('clearing existing transport %s', this.transport.name);
	    this.transport.removeAllListeners();
	  }
	
	  // set up transport
	  this.transport = transport;
	
	  // set up transport listeners
	  transport
	  .on('drain', function () {
	    self.onDrain();
	  })
	  .on('packet', function (packet) {
	    self.onPacket(packet);
	  })
	  .on('error', function (e) {
	    self.onError(e);
	  })
	  .on('close', function () {
	    self.onClose('transport close');
	  });
	};
	
	/**
	 * Probes a transport.
	 *
	 * @param {String} transport name
	 * @api private
	 */
	
	Socket.prototype.probe = function (name) {
	  debug('probing transport "%s"', name);
	  var transport = this.createTransport(name, { probe: 1 });
	  var failed = false;
	  var self = this;
	
	  Socket.priorWebsocketSuccess = false;
	
	  function onTransportOpen () {
	    if (self.onlyBinaryUpgrades) {
	      var upgradeLosesBinary = !this.supportsBinary && self.transport.supportsBinary;
	      failed = failed || upgradeLosesBinary;
	    }
	    if (failed) return;
	
	    debug('probe transport "%s" opened', name);
	    transport.send([{ type: 'ping', data: 'probe' }]);
	    transport.once('packet', function (msg) {
	      if (failed) return;
	      if ('pong' === msg.type && 'probe' === msg.data) {
	        debug('probe transport "%s" pong', name);
	        self.upgrading = true;
	        self.emit('upgrading', transport);
	        if (!transport) return;
	        Socket.priorWebsocketSuccess = 'websocket' === transport.name;
	
	        debug('pausing current transport "%s"', self.transport.name);
	        self.transport.pause(function () {
	          if (failed) return;
	          if ('closed' === self.readyState) return;
	          debug('changing transport and sending upgrade packet');
	
	          cleanup();
	
	          self.setTransport(transport);
	          transport.send([{ type: 'upgrade' }]);
	          self.emit('upgrade', transport);
	          transport = null;
	          self.upgrading = false;
	          self.flush();
	        });
	      } else {
	        debug('probe transport "%s" failed', name);
	        var err = new Error('probe error');
	        err.transport = transport.name;
	        self.emit('upgradeError', err);
	      }
	    });
	  }
	
	  function freezeTransport () {
	    if (failed) return;
	
	    // Any callback called by transport should be ignored since now
	    failed = true;
	
	    cleanup();
	
	    transport.close();
	    transport = null;
	  }
	
	  // Handle any error that happens while probing
	  function onerror (err) {
	    var error = new Error('probe error: ' + err);
	    error.transport = transport.name;
	
	    freezeTransport();
	
	    debug('probe transport "%s" failed because of error: %s', name, err);
	
	    self.emit('upgradeError', error);
	  }
	
	  function onTransportClose () {
	    onerror('transport closed');
	  }
	
	  // When the socket is closed while we're probing
	  function onclose () {
	    onerror('socket closed');
	  }
	
	  // When the socket is upgraded while we're probing
	  function onupgrade (to) {
	    if (transport && to.name !== transport.name) {
	      debug('"%s" works - aborting "%s"', to.name, transport.name);
	      freezeTransport();
	    }
	  }
	
	  // Remove all listeners on the transport and on self
	  function cleanup () {
	    transport.removeListener('open', onTransportOpen);
	    transport.removeListener('error', onerror);
	    transport.removeListener('close', onTransportClose);
	    self.removeListener('close', onclose);
	    self.removeListener('upgrading', onupgrade);
	  }
	
	  transport.once('open', onTransportOpen);
	  transport.once('error', onerror);
	  transport.once('close', onTransportClose);
	
	  this.once('close', onclose);
	  this.once('upgrading', onupgrade);
	
	  transport.open();
	};
	
	/**
	 * Called when connection is deemed open.
	 *
	 * @api public
	 */
	
	Socket.prototype.onOpen = function () {
	  debug('socket open');
	  this.readyState = 'open';
	  Socket.priorWebsocketSuccess = 'websocket' === this.transport.name;
	  this.emit('open');
	  this.flush();
	
	  // we check for `readyState` in case an `open`
	  // listener already closed the socket
	  if ('open' === this.readyState && this.upgrade && this.transport.pause) {
	    debug('starting upgrade probes');
	    for (var i = 0, l = this.upgrades.length; i < l; i++) {
	      this.probe(this.upgrades[i]);
	    }
	  }
	};
	
	/**
	 * Handles a packet.
	 *
	 * @api private
	 */
	
	Socket.prototype.onPacket = function (packet) {
	  if ('opening' === this.readyState || 'open' === this.readyState ||
	      'closing' === this.readyState) {
	    debug('socket receive: type "%s", data "%s"', packet.type, packet.data);
	
	    this.emit('packet', packet);
	
	    // Socket is live - any packet counts
	    this.emit('heartbeat');
	
	    switch (packet.type) {
	      case 'open':
	        this.onHandshake(parsejson(packet.data));
	        break;
	
	      case 'pong':
	        this.setPing();
	        this.emit('pong');
	        break;
	
	      case 'error':
	        var err = new Error('server error');
	        err.code = packet.data;
	        this.onError(err);
	        break;
	
	      case 'message':
	        this.emit('data', packet.data);
	        this.emit('message', packet.data);
	        break;
	    }
	  } else {
	    debug('packet received with socket readyState "%s"', this.readyState);
	  }
	};
	
	/**
	 * Called upon handshake completion.
	 *
	 * @param {Object} handshake obj
	 * @api private
	 */
	
	Socket.prototype.onHandshake = function (data) {
	  this.emit('handshake', data);
	  this.id = data.sid;
	  this.transport.query.sid = data.sid;
	  this.upgrades = this.filterUpgrades(data.upgrades);
	  this.pingInterval = data.pingInterval;
	  this.pingTimeout = data.pingTimeout;
	  this.onOpen();
	  // In case open handler closes socket
	  if ('closed' === this.readyState) return;
	  this.setPing();
	
	  // Prolong liveness of socket on heartbeat
	  this.removeListener('heartbeat', this.onHeartbeat);
	  this.on('heartbeat', this.onHeartbeat);
	};
	
	/**
	 * Resets ping timeout.
	 *
	 * @api private
	 */
	
	Socket.prototype.onHeartbeat = function (timeout) {
	  clearTimeout(this.pingTimeoutTimer);
	  var self = this;
	  self.pingTimeoutTimer = setTimeout(function () {
	    if ('closed' === self.readyState) return;
	    self.onClose('ping timeout');
	  }, timeout || (self.pingInterval + self.pingTimeout));
	};
	
	/**
	 * Pings server every `this.pingInterval` and expects response
	 * within `this.pingTimeout` or closes connection.
	 *
	 * @api private
	 */
	
	Socket.prototype.setPing = function () {
	  var self = this;
	  clearTimeout(self.pingIntervalTimer);
	  self.pingIntervalTimer = setTimeout(function () {
	    debug('writing ping packet - expecting pong within %sms', self.pingTimeout);
	    self.ping();
	    self.onHeartbeat(self.pingTimeout);
	  }, self.pingInterval);
	};
	
	/**
	* Sends a ping packet.
	*
	* @api private
	*/
	
	Socket.prototype.ping = function () {
	  var self = this;
	  this.sendPacket('ping', function () {
	    self.emit('ping');
	  });
	};
	
	/**
	 * Called on `drain` event
	 *
	 * @api private
	 */
	
	Socket.prototype.onDrain = function () {
	  this.writeBuffer.splice(0, this.prevBufferLen);
	
	  // setting prevBufferLen = 0 is very important
	  // for example, when upgrading, upgrade packet is sent over,
	  // and a nonzero prevBufferLen could cause problems on `drain`
	  this.prevBufferLen = 0;
	
	  if (0 === this.writeBuffer.length) {
	    this.emit('drain');
	  } else {
	    this.flush();
	  }
	};
	
	/**
	 * Flush write buffers.
	 *
	 * @api private
	 */
	
	Socket.prototype.flush = function () {
	  if ('closed' !== this.readyState && this.transport.writable &&
	    !this.upgrading && this.writeBuffer.length) {
	    debug('flushing %d packets in socket', this.writeBuffer.length);
	    this.transport.send(this.writeBuffer);
	    // keep track of current length of writeBuffer
	    // splice writeBuffer and callbackBuffer on `drain`
	    this.prevBufferLen = this.writeBuffer.length;
	    this.emit('flush');
	  }
	};
	
	/**
	 * Sends a message.
	 *
	 * @param {String} message.
	 * @param {Function} callback function.
	 * @param {Object} options.
	 * @return {Socket} for chaining.
	 * @api public
	 */
	
	Socket.prototype.write =
	Socket.prototype.send = function (msg, options, fn) {
	  this.sendPacket('message', msg, options, fn);
	  return this;
	};
	
	/**
	 * Sends a packet.
	 *
	 * @param {String} packet type.
	 * @param {String} data.
	 * @param {Object} options.
	 * @param {Function} callback function.
	 * @api private
	 */
	
	Socket.prototype.sendPacket = function (type, data, options, fn) {
	  if ('function' === typeof data) {
	    fn = data;
	    data = undefined;
	  }
	
	  if ('function' === typeof options) {
	    fn = options;
	    options = null;
	  }
	
	  if ('closing' === this.readyState || 'closed' === this.readyState) {
	    return;
	  }
	
	  options = options || {};
	  options.compress = false !== options.compress;
	
	  var packet = {
	    type: type,
	    data: data,
	    options: options
	  };
	  this.emit('packetCreate', packet);
	  this.writeBuffer.push(packet);
	  if (fn) this.once('flush', fn);
	  this.flush();
	};
	
	/**
	 * Closes the connection.
	 *
	 * @api private
	 */
	
	Socket.prototype.close = function () {
	  if ('opening' === this.readyState || 'open' === this.readyState) {
	    this.readyState = 'closing';
	
	    var self = this;
	
	    if (this.writeBuffer.length) {
	      this.once('drain', function () {
	        if (this.upgrading) {
	          waitForUpgrade();
	        } else {
	          close();
	        }
	      });
	    } else if (this.upgrading) {
	      waitForUpgrade();
	    } else {
	      close();
	    }
	  }
	
	  function close () {
	    self.onClose('forced close');
	    debug('socket closing - telling transport to close');
	    self.transport.close();
	  }
	
	  function cleanupAndClose () {
	    self.removeListener('upgrade', cleanupAndClose);
	    self.removeListener('upgradeError', cleanupAndClose);
	    close();
	  }
	
	  function waitForUpgrade () {
	    // wait for upgrade to finish since we can't send packets while pausing a transport
	    self.once('upgrade', cleanupAndClose);
	    self.once('upgradeError', cleanupAndClose);
	  }
	
	  return this;
	};
	
	/**
	 * Called upon transport error
	 *
	 * @api private
	 */
	
	Socket.prototype.onError = function (err) {
	  debug('socket error %j', err);
	  Socket.priorWebsocketSuccess = false;
	  this.emit('error', err);
	  this.onClose('transport error', err);
	};
	
	/**
	 * Called upon transport close.
	 *
	 * @api private
	 */
	
	Socket.prototype.onClose = function (reason, desc) {
	  if ('opening' === this.readyState || 'open' === this.readyState || 'closing' === this.readyState) {
	    debug('socket close with reason: "%s"', reason);
	    var self = this;
	
	    // clear timers
	    clearTimeout(this.pingIntervalTimer);
	    clearTimeout(this.pingTimeoutTimer);
	
	    // stop event from firing again for transport
	    this.transport.removeAllListeners('close');
	
	    // ensure transport won't stay open
	    this.transport.close();
	
	    // ignore further transport communication
	    this.transport.removeAllListeners();
	
	    // set ready state
	    this.readyState = 'closed';
	
	    // clear session id
	    this.id = null;
	
	    // emit close event
	    this.emit('close', reason, desc);
	
	    // clean buffers after, so users can still
	    // grab the buffers on `close` event
	    self.writeBuffer = [];
	    self.prevBufferLen = 0;
	  }
	};
	
	/**
	 * Filters upgrades, returning only those matching client transports.
	 *
	 * @param {Array} server upgrades
	 * @api private
	 *
	 */
	
	Socket.prototype.filterUpgrades = function (upgrades) {
	  var filteredUpgrades = [];
	  for (var i = 0, j = upgrades.length; i < j; i++) {
	    if (~index(this.transports, upgrades[i])) filteredUpgrades.push(upgrades[i]);
	  }
	  return filteredUpgrades;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module requirements.
	 */
	
	var Polling = __webpack_require__(552);
	var inherit = __webpack_require__(247);
	
	/**
	 * Module exports.
	 */
	
	module.exports = JSONPPolling;
	
	/**
	 * Cached regular expressions.
	 */
	
	var rNewline = /\n/g;
	var rEscapedNewline = /\\n/g;
	
	/**
	 * Global JSONP callbacks.
	 */
	
	var callbacks;
	
	/**
	 * Noop.
	 */
	
	function empty () { }
	
	/**
	 * JSONP Polling constructor.
	 *
	 * @param {Object} opts.
	 * @api public
	 */
	
	function JSONPPolling (opts) {
	  Polling.call(this, opts);
	
	  this.query = this.query || {};
	
	  // define global callbacks array if not present
	  // we do this here (lazily) to avoid unneeded global pollution
	  if (!callbacks) {
	    // we need to consider multiple engines in the same page
	    if (!global.___eio) global.___eio = [];
	    callbacks = global.___eio;
	  }
	
	  // callback identifier
	  this.index = callbacks.length;
	
	  // add callback to jsonp global
	  var self = this;
	  callbacks.push(function (msg) {
	    self.onData(msg);
	  });
	
	  // append to query string
	  this.query.j = this.index;
	
	  // prevent spurious errors from being emitted when the window is unloaded
	  if (global.document && global.addEventListener) {
	    global.addEventListener('beforeunload', function () {
	      if (self.script) self.script.onerror = empty;
	    }, false);
	  }
	}
	
	/**
	 * Inherits from Polling.
	 */
	
	inherit(JSONPPolling, Polling);
	
	/*
	 * JSONP only supports binary as base64 encoded strings
	 */
	
	JSONPPolling.prototype.supportsBinary = false;
	
	/**
	 * Closes the socket.
	 *
	 * @api private
	 */
	
	JSONPPolling.prototype.doClose = function () {
	  if (this.script) {
	    this.script.parentNode.removeChild(this.script);
	    this.script = null;
	  }
	
	  if (this.form) {
	    this.form.parentNode.removeChild(this.form);
	    this.form = null;
	    this.iframe = null;
	  }
	
	  Polling.prototype.doClose.call(this);
	};
	
	/**
	 * Starts a poll cycle.
	 *
	 * @api private
	 */
	
	JSONPPolling.prototype.doPoll = function () {
	  var self = this;
	  var script = document.createElement('script');
	
	  if (this.script) {
	    this.script.parentNode.removeChild(this.script);
	    this.script = null;
	  }
	
	  script.async = true;
	  script.src = this.uri();
	  script.onerror = function (e) {
	    self.onError('jsonp poll error', e);
	  };
	
	  var insertAt = document.getElementsByTagName('script')[0];
	  if (insertAt) {
	    insertAt.parentNode.insertBefore(script, insertAt);
	  } else {
	    (document.head || document.body).appendChild(script);
	  }
	  this.script = script;
	
	  var isUAgecko = 'undefined' !== typeof navigator && /gecko/i.test(navigator.userAgent);
	
	  if (isUAgecko) {
	    setTimeout(function () {
	      var iframe = document.createElement('iframe');
	      document.body.appendChild(iframe);
	      document.body.removeChild(iframe);
	    }, 100);
	  }
	};
	
	/**
	 * Writes with a hidden iframe.
	 *
	 * @param {String} data to send
	 * @param {Function} called upon flush.
	 * @api private
	 */
	
	JSONPPolling.prototype.doWrite = function (data, fn) {
	  var self = this;
	
	  if (!this.form) {
	    var form = document.createElement('form');
	    var area = document.createElement('textarea');
	    var id = this.iframeId = 'eio_iframe_' + this.index;
	    var iframe;
	
	    form.className = 'socketio';
	    form.style.position = 'absolute';
	    form.style.top = '-1000px';
	    form.style.left = '-1000px';
	    form.target = id;
	    form.method = 'POST';
	    form.setAttribute('accept-charset', 'utf-8');
	    area.name = 'd';
	    form.appendChild(area);
	    document.body.appendChild(form);
	
	    this.form = form;
	    this.area = area;
	  }
	
	  this.form.action = this.uri();
	
	  function complete () {
	    initIframe();
	    fn();
	  }
	
	  function initIframe () {
	    if (self.iframe) {
	      try {
	        self.form.removeChild(self.iframe);
	      } catch (e) {
	        self.onError('jsonp polling iframe removal error', e);
	      }
	    }
	
	    try {
	      // ie6 dynamic iframes with target="" support (thanks Chris Lambacher)
	      var html = '<iframe src="javascript:0" name="' + self.iframeId + '">';
	      iframe = document.createElement(html);
	    } catch (e) {
	      iframe = document.createElement('iframe');
	      iframe.name = self.iframeId;
	      iframe.src = 'javascript:0';
	    }
	
	    iframe.id = self.iframeId;
	
	    self.form.appendChild(iframe);
	    self.iframe = iframe;
	  }
	
	  initIframe();
	
	  // escape \n to prevent it from being converted into \r\n by some UAs
	  // double escaping is required for escaped new lines because unescaping of new lines can be done safely on server-side
	  data = data.replace(rEscapedNewline, '\\\n');
	  this.area.value = data.replace(rNewline, '\\n');
	
	  try {
	    this.form.submit();
	  } catch (e) {}
	
	  if (this.iframe.attachEvent) {
	    this.iframe.onreadystatechange = function () {
	      if (self.iframe.readyState === 'complete') {
	        complete();
	      }
	    };
	  } else {
	    this.iframe.onload = complete;
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module requirements.
	 */
	
	var XMLHttpRequest = __webpack_require__(364);
	var Polling = __webpack_require__(552);
	var Emitter = __webpack_require__(176);
	var inherit = __webpack_require__(247);
	var debug = __webpack_require__(116)('engine.io-client:polling-xhr');
	
	/**
	 * Module exports.
	 */
	
	module.exports = XHR;
	module.exports.Request = Request;
	
	/**
	 * Empty function
	 */
	
	function empty () {}
	
	/**
	 * XHR Polling constructor.
	 *
	 * @param {Object} opts
	 * @api public
	 */
	
	function XHR (opts) {
	  Polling.call(this, opts);
	  this.requestTimeout = opts.requestTimeout;
	  this.extraHeaders = opts.extraHeaders;
	
	  if (global.location) {
	    var isSSL = 'https:' === location.protocol;
	    var port = location.port;
	
	    // some user agents have empty `location.port`
	    if (!port) {
	      port = isSSL ? 443 : 80;
	    }
	
	    this.xd = opts.hostname !== global.location.hostname ||
	      port !== opts.port;
	    this.xs = opts.secure !== isSSL;
	  }
	}
	
	/**
	 * Inherits from Polling.
	 */
	
	inherit(XHR, Polling);
	
	/**
	 * XHR supports binary
	 */
	
	XHR.prototype.supportsBinary = true;
	
	/**
	 * Creates a request.
	 *
	 * @param {String} method
	 * @api private
	 */
	
	XHR.prototype.request = function (opts) {
	  opts = opts || {};
	  opts.uri = this.uri();
	  opts.xd = this.xd;
	  opts.xs = this.xs;
	  opts.agent = this.agent || false;
	  opts.supportsBinary = this.supportsBinary;
	  opts.enablesXDR = this.enablesXDR;
	
	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	  opts.requestTimeout = this.requestTimeout;
	
	  // other options for Node.js client
	  opts.extraHeaders = this.extraHeaders;
	
	  return new Request(opts);
	};
	
	/**
	 * Sends data.
	 *
	 * @param {String} data to send.
	 * @param {Function} called upon flush.
	 * @api private
	 */
	
	XHR.prototype.doWrite = function (data, fn) {
	  var isBinary = typeof data !== 'string' && data !== undefined;
	  var req = this.request({ method: 'POST', data: data, isBinary: isBinary });
	  var self = this;
	  req.on('success', fn);
	  req.on('error', function (err) {
	    self.onError('xhr post error', err);
	  });
	  this.sendXhr = req;
	};
	
	/**
	 * Starts a poll cycle.
	 *
	 * @api private
	 */
	
	XHR.prototype.doPoll = function () {
	  debug('xhr poll');
	  var req = this.request();
	  var self = this;
	  req.on('data', function (data) {
	    self.onData(data);
	  });
	  req.on('error', function (err) {
	    self.onError('xhr poll error', err);
	  });
	  this.pollXhr = req;
	};
	
	/**
	 * Request constructor
	 *
	 * @param {Object} options
	 * @api public
	 */
	
	function Request (opts) {
	  this.method = opts.method || 'GET';
	  this.uri = opts.uri;
	  this.xd = !!opts.xd;
	  this.xs = !!opts.xs;
	  this.async = false !== opts.async;
	  this.data = undefined !== opts.data ? opts.data : null;
	  this.agent = opts.agent;
	  this.isBinary = opts.isBinary;
	  this.supportsBinary = opts.supportsBinary;
	  this.enablesXDR = opts.enablesXDR;
	  this.requestTimeout = opts.requestTimeout;
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx;
	  this.key = opts.key;
	  this.passphrase = opts.passphrase;
	  this.cert = opts.cert;
	  this.ca = opts.ca;
	  this.ciphers = opts.ciphers;
	  this.rejectUnauthorized = opts.rejectUnauthorized;
	
	  // other options for Node.js client
	  this.extraHeaders = opts.extraHeaders;
	
	  this.create();
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Request.prototype);
	
	/**
	 * Creates the XHR object and sends the request.
	 *
	 * @api private
	 */
	
	Request.prototype.create = function () {
	  var opts = { agent: this.agent, xdomain: this.xd, xscheme: this.xs, enablesXDR: this.enablesXDR };
	
	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	
	  var xhr = this.xhr = new XMLHttpRequest(opts);
	  var self = this;
	
	  try {
	    debug('xhr open %s: %s', this.method, this.uri);
	    xhr.open(this.method, this.uri, this.async);
	    try {
	      if (this.extraHeaders) {
	        xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
	        for (var i in this.extraHeaders) {
	          if (this.extraHeaders.hasOwnProperty(i)) {
	            xhr.setRequestHeader(i, this.extraHeaders[i]);
	          }
	        }
	      }
	    } catch (e) {}
	
	    if ('POST' === this.method) {
	      try {
	        if (this.isBinary) {
	          xhr.setRequestHeader('Content-type', 'application/octet-stream');
	        } else {
	          xhr.setRequestHeader('Content-type', 'text/plain;charset=UTF-8');
	        }
	      } catch (e) {}
	    }
	
	    try {
	      xhr.setRequestHeader('Accept', '*/*');
	    } catch (e) {}
	
	    // ie6 check
	    if ('withCredentials' in xhr) {
	      xhr.withCredentials = true;
	    }
	
	    if (this.requestTimeout) {
	      xhr.timeout = this.requestTimeout;
	    }
	
	    if (this.hasXDR()) {
	      xhr.onload = function () {
	        self.onLoad();
	      };
	      xhr.onerror = function () {
	        self.onError(xhr.responseText);
	      };
	    } else {
	      xhr.onreadystatechange = function () {
	        if (xhr.readyState === 2) {
	          var contentType;
	          try {
	            contentType = xhr.getResponseHeader('Content-Type');
	          } catch (e) {}
	          if (contentType === 'application/octet-stream') {
	            xhr.responseType = 'arraybuffer';
	          }
	        }
	        if (4 !== xhr.readyState) return;
	        if (200 === xhr.status || 1223 === xhr.status) {
	          self.onLoad();
	        } else {
	          // make sure the `error` event handler that's user-set
	          // does not throw in the same tick and gets caught here
	          setTimeout(function () {
	            self.onError(xhr.status);
	          }, 0);
	        }
	      };
	    }
	
	    debug('xhr data %s', this.data);
	    xhr.send(this.data);
	  } catch (e) {
	    // Need to defer since .create() is called directly fhrom the constructor
	    // and thus the 'error' event can only be only bound *after* this exception
	    // occurs.  Therefore, also, we cannot throw here at all.
	    setTimeout(function () {
	      self.onError(e);
	    }, 0);
	    return;
	  }
	
	  if (global.document) {
	    this.index = Request.requestsCount++;
	    Request.requests[this.index] = this;
	  }
	};
	
	/**
	 * Called upon successful response.
	 *
	 * @api private
	 */
	
	Request.prototype.onSuccess = function () {
	  this.emit('success');
	  this.cleanup();
	};
	
	/**
	 * Called if we have data.
	 *
	 * @api private
	 */
	
	Request.prototype.onData = function (data) {
	  this.emit('data', data);
	  this.onSuccess();
	};
	
	/**
	 * Called upon error.
	 *
	 * @api private
	 */
	
	Request.prototype.onError = function (err) {
	  this.emit('error', err);
	  this.cleanup(true);
	};
	
	/**
	 * Cleans up house.
	 *
	 * @api private
	 */
	
	Request.prototype.cleanup = function (fromError) {
	  if ('undefined' === typeof this.xhr || null === this.xhr) {
	    return;
	  }
	  // xmlhttprequest
	  if (this.hasXDR()) {
	    this.xhr.onload = this.xhr.onerror = empty;
	  } else {
	    this.xhr.onreadystatechange = empty;
	  }
	
	  if (fromError) {
	    try {
	      this.xhr.abort();
	    } catch (e) {}
	  }
	
	  if (global.document) {
	    delete Request.requests[this.index];
	  }
	
	  this.xhr = null;
	};
	
	/**
	 * Called upon load.
	 *
	 * @api private
	 */
	
	Request.prototype.onLoad = function () {
	  var data;
	  try {
	    var contentType;
	    try {
	      contentType = this.xhr.getResponseHeader('Content-Type');
	    } catch (e) {}
	    if (contentType === 'application/octet-stream') {
	      data = this.xhr.response || this.xhr.responseText;
	    } else {
	      data = this.xhr.responseText;
	    }
	  } catch (e) {
	    this.onError(e);
	  }
	  if (null != data) {
	    this.onData(data);
	  }
	};
	
	/**
	 * Check if it has XDomainRequest.
	 *
	 * @api private
	 */
	
	Request.prototype.hasXDR = function () {
	  return 'undefined' !== typeof global.XDomainRequest && !this.xs && this.enablesXDR;
	};
	
	/**
	 * Aborts the request.
	 *
	 * @api public
	 */
	
	Request.prototype.abort = function () {
	  this.cleanup();
	};
	
	/**
	 * Aborts pending requests when unloading the window. This is needed to prevent
	 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
	 * emitted.
	 */
	
	Request.requestsCount = 0;
	Request.requests = {};
	
	if (global.document) {
	  if (global.attachEvent) {
	    global.attachEvent('onunload', unloadHandler);
	  } else if (global.addEventListener) {
	    global.addEventListener('beforeunload', unloadHandler, false);
	  }
	}
	
	function unloadHandler () {
	  for (var i in Request.requests) {
	    if (Request.requests.hasOwnProperty(i)) {
	      Request.requests[i].abort();
	    }
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies.
	 */
	
	var Transport = __webpack_require__(363);
	var parser = __webpack_require__(183);
	var parseqs = __webpack_require__(382);
	var inherit = __webpack_require__(247);
	var yeast = __webpack_require__(803);
	var debug = __webpack_require__(116)('engine.io-client:websocket');
	var BrowserWebSocket = global.WebSocket || global.MozWebSocket;
	var NodeWebSocket;
	if (typeof window === 'undefined') {
	  try {
	    NodeWebSocket = __webpack_require__(2329);
	  } catch (e) { }
	}
	
	/**
	 * Get either the `WebSocket` or `MozWebSocket` globals
	 * in the browser or try to resolve WebSocket-compatible
	 * interface exposed by `ws` for Node-like environment.
	 */
	
	var WebSocket = BrowserWebSocket;
	if (!WebSocket && typeof window === 'undefined') {
	  WebSocket = NodeWebSocket;
	}
	
	/**
	 * Module exports.
	 */
	
	module.exports = WS;
	
	/**
	 * WebSocket transport constructor.
	 *
	 * @api {Object} connection options
	 * @api public
	 */
	
	function WS (opts) {
	  var forceBase64 = (opts && opts.forceBase64);
	  if (forceBase64) {
	    this.supportsBinary = false;
	  }
	  this.perMessageDeflate = opts.perMessageDeflate;
	  this.usingBrowserWebSocket = BrowserWebSocket && !opts.forceNode;
	  this.protocols = opts.protocols;
	  if (!this.usingBrowserWebSocket) {
	    WebSocket = NodeWebSocket;
	  }
	  Transport.call(this, opts);
	}
	
	/**
	 * Inherits from Transport.
	 */
	
	inherit(WS, Transport);
	
	/**
	 * Transport name.
	 *
	 * @api public
	 */
	
	WS.prototype.name = 'websocket';
	
	/*
	 * WebSockets support binary
	 */
	
	WS.prototype.supportsBinary = true;
	
	/**
	 * Opens socket.
	 *
	 * @api private
	 */
	
	WS.prototype.doOpen = function () {
	  if (!this.check()) {
	    // let probe timeout
	    return;
	  }
	
	  var uri = this.uri();
	  var protocols = this.protocols;
	  var opts = {
	    agent: this.agent,
	    perMessageDeflate: this.perMessageDeflate
	  };
	
	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	  if (this.extraHeaders) {
	    opts.headers = this.extraHeaders;
	  }
	  if (this.localAddress) {
	    opts.localAddress = this.localAddress;
	  }
	
	  try {
	    this.ws = this.usingBrowserWebSocket ? (protocols ? new WebSocket(uri, protocols) : new WebSocket(uri)) : new WebSocket(uri, protocols, opts);
	  } catch (err) {
	    return this.emit('error', err);
	  }
	
	  if (this.ws.binaryType === undefined) {
	    this.supportsBinary = false;
	  }
	
	  if (this.ws.supports && this.ws.supports.binary) {
	    this.supportsBinary = true;
	    this.ws.binaryType = 'nodebuffer';
	  } else {
	    this.ws.binaryType = 'arraybuffer';
	  }
	
	  this.addEventListeners();
	};
	
	/**
	 * Adds event listeners to the socket
	 *
	 * @api private
	 */
	
	WS.prototype.addEventListeners = function () {
	  var self = this;
	
	  this.ws.onopen = function () {
	    self.onOpen();
	  };
	  this.ws.onclose = function () {
	    self.onClose();
	  };
	  this.ws.onmessage = function (ev) {
	    self.onData(ev.data);
	  };
	  this.ws.onerror = function (e) {
	    self.onError('websocket error', e);
	  };
	};
	
	/**
	 * Writes data to socket.
	 *
	 * @param {Array} array of packets.
	 * @api private
	 */
	
	WS.prototype.write = function (packets) {
	  var self = this;
	  this.writable = false;
	
	  // encodePacket efficient as it uses WS framing
	  // no need for encodePayload
	  var total = packets.length;
	  for (var i = 0, l = total; i < l; i++) {
	    (function (packet) {
	      parser.encodePacket(packet, self.supportsBinary, function (data) {
	        if (!self.usingBrowserWebSocket) {
	          // always create a new object (GH-437)
	          var opts = {};
	          if (packet.options) {
	            opts.compress = packet.options.compress;
	          }
	
	          if (self.perMessageDeflate) {
	            var len = 'string' === typeof data ? global.Buffer.byteLength(data) : data.length;
	            if (len < self.perMessageDeflate.threshold) {
	              opts.compress = false;
	            }
	          }
	        }
	
	        // Sometimes the websocket has already been closed but the browser didn't
	        // have a chance of informing us about it yet, in that case send will
	        // throw an error
	        try {
	          if (self.usingBrowserWebSocket) {
	            // TypeError is thrown when passing the second argument on Safari
	            self.ws.send(data);
	          } else {
	            self.ws.send(data, opts);
	          }
	        } catch (e) {
	          debug('websocket closed before onclose event');
	        }
	
	        --total || done();
	      });
	    })(packets[i]);
	  }
	
	  function done () {
	    self.emit('flush');
	
	    // fake drain
	    // defer to next tick to allow Socket to clear writeBuffer
	    setTimeout(function () {
	      self.writable = true;
	      self.emit('drain');
	    }, 0);
	  }
	};
	
	/**
	 * Called upon close
	 *
	 * @api private
	 */
	
	WS.prototype.onClose = function () {
	  Transport.prototype.onClose.call(this);
	};
	
	/**
	 * Closes socket.
	 *
	 * @api private
	 */
	
	WS.prototype.doClose = function () {
	  if (typeof this.ws !== 'undefined') {
	    this.ws.close();
	  }
	};
	
	/**
	 * Generates uri for connection.
	 *
	 * @api private
	 */
	
	WS.prototype.uri = function () {
	  var query = this.query || {};
	  var schema = this.secure ? 'wss' : 'ws';
	  var port = '';
	
	  // avoid port if default for schema
	  if (this.port && (('wss' === schema && Number(this.port) !== 443) ||
	    ('ws' === schema && Number(this.port) !== 80))) {
	    port = ':' + this.port;
	  }
	
	  // append timestamp to URI
	  if (this.timestampRequests) {
	    query[this.timestampParam] = yeast();
	  }
	
	  // communicate binary support capabilities
	  if (!this.supportsBinary) {
	    query.b64 = 1;
	  }
	
	  query = parseqs.encode(query);
	
	  // prepend ? to query
	  if (query.length) {
	    query = '?' + query;
	  }
	
	  var ipv6 = this.hostname.indexOf(':') !== -1;
	  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
	};
	
	/**
	 * Feature detection for WebSocket.
	 *
	 * @return {Boolean} whether this transport is available.
	 * @api public
	 */
	
	WS.prototype.check = function () {
	  return !!WebSocket && !('__initialize' in WebSocket && this.name === WS.prototype.name);
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1118 */
/***/ (function(module, exports) {

	
	/**
	 * Gets the keys for an object.
	 *
	 * @return {Array} keys
	 * @api private
	 */
	
	module.exports = Object.keys || function keys (obj){
	  var arr = [];
	  var has = Object.prototype.hasOwnProperty;
	
	  for (var i in obj) {
	    if (has.call(obj, i)) {
	      arr.push(i);
	    }
	  }
	  return arr;
	};


/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/utf8js v2.1.2 by @mathias */
	;(function(root) {
	
		// Detect free variables `exports`
		var freeExports = typeof exports == 'object' && exports;
	
		// Detect free variable `module`
		var freeModule = typeof module == 'object' && module &&
			module.exports == freeExports && module;
	
		// Detect free variable `global`, from Node.js or Browserified code,
		// and use it as `root`
		var freeGlobal = typeof global == 'object' && global;
		if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
			root = freeGlobal;
		}
	
		/*--------------------------------------------------------------------------*/
	
		var stringFromCharCode = String.fromCharCode;
	
		// Taken from https://mths.be/punycode
		function ucs2decode(string) {
			var output = [];
			var counter = 0;
			var length = string.length;
			var value;
			var extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		// Taken from https://mths.be/punycode
		function ucs2encode(array) {
			var length = array.length;
			var index = -1;
			var value;
			var output = '';
			while (++index < length) {
				value = array[index];
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
			}
			return output;
		}
	
		function checkScalarValue(codePoint, strict) {
			if (codePoint >= 0xD800 && codePoint <= 0xDFFF) {
				if (strict) {
					throw Error(
						'Lone surrogate U+' + codePoint.toString(16).toUpperCase() +
						' is not a scalar value'
					);
				}
				return false;
			}
			return true;
		}
		/*--------------------------------------------------------------------------*/
	
		function createByte(codePoint, shift) {
			return stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);
		}
	
		function encodeCodePoint(codePoint, strict) {
			if ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence
				return stringFromCharCode(codePoint);
			}
			var symbol = '';
			if ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence
				symbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);
			}
			else if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence
				if (!checkScalarValue(codePoint, strict)) {
					codePoint = 0xFFFD;
				}
				symbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);
				symbol += createByte(codePoint, 6);
			}
			else if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence
				symbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);
				symbol += createByte(codePoint, 12);
				symbol += createByte(codePoint, 6);
			}
			symbol += stringFromCharCode((codePoint & 0x3F) | 0x80);
			return symbol;
		}
	
		function utf8encode(string, opts) {
			opts = opts || {};
			var strict = false !== opts.strict;
	
			var codePoints = ucs2decode(string);
			var length = codePoints.length;
			var index = -1;
			var codePoint;
			var byteString = '';
			while (++index < length) {
				codePoint = codePoints[index];
				byteString += encodeCodePoint(codePoint, strict);
			}
			return byteString;
		}
	
		/*--------------------------------------------------------------------------*/
	
		function readContinuationByte() {
			if (byteIndex >= byteCount) {
				throw Error('Invalid byte index');
			}
	
			var continuationByte = byteArray[byteIndex] & 0xFF;
			byteIndex++;
	
			if ((continuationByte & 0xC0) == 0x80) {
				return continuationByte & 0x3F;
			}
	
			// If we end up here, it’s not a continuation byte
			throw Error('Invalid continuation byte');
		}
	
		function decodeSymbol(strict) {
			var byte1;
			var byte2;
			var byte3;
			var byte4;
			var codePoint;
	
			if (byteIndex > byteCount) {
				throw Error('Invalid byte index');
			}
	
			if (byteIndex == byteCount) {
				return false;
			}
	
			// Read first byte
			byte1 = byteArray[byteIndex] & 0xFF;
			byteIndex++;
	
			// 1-byte sequence (no continuation bytes)
			if ((byte1 & 0x80) == 0) {
				return byte1;
			}
	
			// 2-byte sequence
			if ((byte1 & 0xE0) == 0xC0) {
				byte2 = readContinuationByte();
				codePoint = ((byte1 & 0x1F) << 6) | byte2;
				if (codePoint >= 0x80) {
					return codePoint;
				} else {
					throw Error('Invalid continuation byte');
				}
			}
	
			// 3-byte sequence (may include unpaired surrogates)
			if ((byte1 & 0xF0) == 0xE0) {
				byte2 = readContinuationByte();
				byte3 = readContinuationByte();
				codePoint = ((byte1 & 0x0F) << 12) | (byte2 << 6) | byte3;
				if (codePoint >= 0x0800) {
					return checkScalarValue(codePoint, strict) ? codePoint : 0xFFFD;
				} else {
					throw Error('Invalid continuation byte');
				}
			}
	
			// 4-byte sequence
			if ((byte1 & 0xF8) == 0xF0) {
				byte2 = readContinuationByte();
				byte3 = readContinuationByte();
				byte4 = readContinuationByte();
				codePoint = ((byte1 & 0x07) << 0x12) | (byte2 << 0x0C) |
					(byte3 << 0x06) | byte4;
				if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {
					return codePoint;
				}
			}
	
			throw Error('Invalid UTF-8 detected');
		}
	
		var byteArray;
		var byteCount;
		var byteIndex;
		function utf8decode(byteString, opts) {
			opts = opts || {};
			var strict = false !== opts.strict;
	
			byteArray = ucs2decode(byteString);
			byteCount = byteArray.length;
			byteIndex = 0;
			var codePoints = [];
			var tmp;
			while ((tmp = decodeSymbol(strict)) !== false) {
				codePoints.push(tmp);
			}
			return ucs2encode(codePoints);
		}
	
		/*--------------------------------------------------------------------------*/
	
		var utf8 = {
			'version': '2.1.2',
			'encode': utf8encode,
			'decode': utf8decode
		};
	
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return utf8;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}	else if (freeExports && !freeExports.nodeType) {
			if (freeModule) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = utf8;
			} else { // in Narwhal or RingoJS v0.7.0-
				var object = {};
				var hasOwnProperty = object.hasOwnProperty;
				for (var key in utf8) {
					hasOwnProperty.call(utf8, key) && (freeExports[key] = utf8[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.utf8 = utf8;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(209)(module), (function() { return this; }())))

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),
/* 1121 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1122 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1123 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1124 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1125 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1126 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1127 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1128 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1129 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1130 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1131 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1132 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1133 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1134 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1135 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1136 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1137 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1138 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1139 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1140 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1141 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1142 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1143 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1144 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1145 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1146 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1147 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1148 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1149 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1150 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1151 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1152 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1153 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1154 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1155 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1156 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1157 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1158 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1159 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1160 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1161 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1162 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1163 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1164 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1165 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1166 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1167 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1168 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1169 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1170 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1171 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1172 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1173 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1174 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1175 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1176 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1177 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1178 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1179 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1180 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1181 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1182 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1183 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1184 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1185 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1186 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1187 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1188 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1189 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1190 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1191 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1192 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1193 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1194 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1195 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1196 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1197 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1198 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1199 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1200 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1201 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1202 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1203 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1204 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1205 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1206 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1207 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1208 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1209 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1210 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1211 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1212 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1213 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1214 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1215 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1216 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1217 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1218 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1219 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1220 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1221 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1222 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1223 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1224 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1225 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1226 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1227 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1228 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1229 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1230 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1231 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1232 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1233 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1234 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1235 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1236 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1237 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1238 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1239 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1240 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1241 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1242 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1243 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1244 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1245 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1246 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1247 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1248 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1249 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1250 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1251 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1252 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1253 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1254 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1255 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1256 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1257 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1258 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1259 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1260 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1261 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1262 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1263 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1264 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1265 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1266 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1267 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1268 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1269 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1270 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1271 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1272 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1273 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1274 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1275 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1276 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1277 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1278 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1279 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1280 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1281 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1282 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1283 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1284 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1285 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1286 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1287 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1288 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1289 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1290 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1291 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1292 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1293 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1294 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1295 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1296 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1297 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1298 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1299 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1300 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1301 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1302 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1303 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1304 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1305 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1306 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1307 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1308 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1309 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1310 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1311 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1312 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1313 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1314 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1315 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1316 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1317 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1318 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1319 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1320 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1321 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1322 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1323 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1324 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1325 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1326 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1327 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1328 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1329 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1330 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1331 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1332 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1333 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1334 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	var PhotosMimeType = {
	  isImage: function isImage(mimeString) {
	    return getParts(mimeString)[0] === 'image';
	  },
	  isJpeg: function isJpeg(mimeString) {
	    var parts = getParts(mimeString);
	    return PhotosMimeType.isImage(mimeString) && (
	    // see http://fburl.com/10972194
	    parts[1] === 'jpeg' || parts[1] === 'pjpeg');
	  }
	};
	
	function getParts(mimeString) {
	  return mimeString.split('/');
	}
	
	module.exports = PhotosMimeType;

/***/ }),
/* 1335 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * @stub
	 * 
	 */
	
	'use strict';
	
	// \u00a1-\u00b1\u00b4-\u00b8\u00ba\u00bb\u00bf
	//             is latin supplement punctuation except fractions and superscript
	//             numbers
	// \u2010-\u2027\u2030-\u205e
	//             is punctuation from the general punctuation block:
	//             weird quotes, commas, bullets, dashes, etc.
	// \u30fb\u3001\u3002\u3008-\u3011\u3014-\u301f
	//             is CJK punctuation
	// \uff1a-\uff1f\uff01-\uff0f\uff3b-\uff40\uff5b-\uff65
	//             is some full-width/half-width punctuation
	// \u2E2E\u061f\u066a-\u066c\u061b\u060c\u060d\uFD3e\uFD3F
	//             is some Arabic punctuation marks
	// \u1801\u0964\u104a\u104b
	//             is misc. other language punctuation marks
	
	var PUNCTUATION = '[.,+*?$|#{}()\'\\^\\-\\[\\]\\\\\\/!@%"~=<>_:;' + '\u30FB\u3001\u3002\u3008-\u3011\u3014-\u301F\uFF1A-\uFF1F\uFF01-\uFF0F' + '\uFF3B-\uFF40\uFF5B-\uFF65\u2E2E\u061F\u066A-\u066C\u061B\u060C\u060D' + '\uFD3E\uFD3F\u1801\u0964\u104A\u104B\u2010-\u2027\u2030-\u205E' + '\xA1-\xB1\xB4-\xB8\xBA\xBB\xBF]';
	
	module.exports = {
	  getPunctuation: function getPunctuation() {
	    return PUNCTUATION;
	  }
	};

/***/ }),
/* 1336 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var URI = function () {
	  function URI(uri) {
	    _classCallCheck(this, URI);
	
	    this._uri = uri;
	  }
	
	  URI.prototype.toString = function toString() {
	    return this._uri;
	  };
	
	  return URI;
	}();
	
	module.exports = URI;

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/**
	 * Stateful API for text direction detection
	 *
	 * This class can be used in applications where you need to detect the
	 * direction of a sequence of text blocks, where each direction shall be used
	 * as the fallback direction for the next one.
	 *
	 * NOTE: A default direction, if not provided, is set based on the global
	 *       direction, as defined by `UnicodeBidiDirection`.
	 *
	 * == Example ==
	 * ```
	 * var UnicodeBidiService = require('UnicodeBidiService');
	 *
	 * var bidiService = new UnicodeBidiService();
	 *
	 * ...
	 *
	 * bidiService.reset();
	 * for (var para in paragraphs) {
	 *   var dir = bidiService.getDirection(para);
	 *   ...
	 * }
	 * ```
	 *
	 * Part of our implementation of Unicode Bidirectional Algorithm (UBA)
	 * Unicode Standard Annex #9 (UAX9)
	 * http://www.unicode.org/reports/tr9/
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UnicodeBidi = __webpack_require__(561);
	var UnicodeBidiDirection = __webpack_require__(367);
	
	var invariant = __webpack_require__(10);
	
	var UnicodeBidiService = function () {
	
	  /**
	   * Stateful class for paragraph direction detection
	   *
	   * @param defaultDir  Default direction of the service
	   */
	  function UnicodeBidiService(defaultDir) {
	    _classCallCheck(this, UnicodeBidiService);
	
	    if (!defaultDir) {
	      defaultDir = UnicodeBidiDirection.getGlobalDir();
	    } else {
	      !UnicodeBidiDirection.isStrong(defaultDir) ?  false ? invariant(false, 'Default direction must be a strong direction (LTR or RTL)') : invariant(false) : void 0;
	    }
	    this._defaultDir = defaultDir;
	    this.reset();
	  }
	
	  /**
	   * Reset the internal state
	   *
	   * Instead of creating a new instance, you can just reset() your instance
	   * everytime you start a new loop.
	   */
	
	
	  UnicodeBidiService.prototype.reset = function reset() {
	    this._lastDir = this._defaultDir;
	  };
	
	  /**
	   * Returns the direction of a block of text, and remembers it as the
	   * fall-back direction for the next paragraph.
	   *
	   * @param str  A text block, e.g. paragraph, table cell, tag
	   * @return     The resolved direction
	   */
	
	
	  UnicodeBidiService.prototype.getDirection = function getDirection(str) {
	    this._lastDir = UnicodeBidi.getDirection(str, this._lastDir);
	    return this._lastDir;
	  };
	
	  return UnicodeBidiService;
	}();
	
	module.exports = UnicodeBidiService;

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/**
	 * Usage note:
	 * This module makes a best effort to export the same data we would internally.
	 * At Facebook we use a server-generated module that does the parsing and
	 * exports the data for the client to use. We can't rely on a server-side
	 * implementation in open source so instead we make use of an open source
	 * library to do the heavy lifting and then make some adjustments as necessary.
	 * It's likely there will be some differences. Some we can smooth over.
	 * Others are going to be harder.
	 */
	
	'use strict';
	
	var UAParser = __webpack_require__(2316);
	
	var UNKNOWN = 'Unknown';
	
	var PLATFORM_MAP = {
	  'Mac OS': 'Mac OS X'
	};
	
	/**
	 * Convert from UAParser platform name to what we expect.
	 */
	function convertPlatformName(name) {
	  return PLATFORM_MAP[name] || name;
	}
	
	/**
	 * Get the version number in parts. This is very naive. We actually get major
	 * version as a part of UAParser already, which is generally good enough, but
	 * let's get the minor just in case.
	 */
	function getBrowserVersion(version) {
	  if (!version) {
	    return {
	      major: '',
	      minor: ''
	    };
	  }
	  var parts = version.split('.');
	  return {
	    major: parts[0],
	    minor: parts[1]
	  };
	}
	
	/**
	 * Get the UA data fom UAParser and then convert it to the format we're
	 * expecting for our APIS.
	 */
	var parser = new UAParser();
	var results = parser.getResult();
	
	// Do some conversion first.
	var browserVersionData = getBrowserVersion(results.browser.version);
	var uaData = {
	  browserArchitecture: results.cpu.architecture || UNKNOWN,
	  browserFullVersion: results.browser.version || UNKNOWN,
	  browserMinorVersion: browserVersionData.minor || UNKNOWN,
	  browserName: results.browser.name || UNKNOWN,
	  browserVersion: results.browser.major || UNKNOWN,
	  deviceName: results.device.model || UNKNOWN,
	  engineName: results.engine.name || UNKNOWN,
	  engineVersion: results.engine.version || UNKNOWN,
	  platformArchitecture: results.cpu.architecture || UNKNOWN,
	  platformName: convertPlatformName(results.os.name) || UNKNOWN,
	  platformVersion: results.os.version || UNKNOWN,
	  platformFullVersion: results.os.version || UNKNOWN
	};
	
	module.exports = uaData;

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(10);
	
	var componentRegex = /\./;
	var orRegex = /\|\|/;
	var rangeRegex = /\s+\-\s+/;
	var modifierRegex = /^(<=|<|=|>=|~>|~|>|)?\s*(.+)/;
	var numericRegex = /^(\d*)(.*)/;
	
	/**
	 * Splits input `range` on "||" and returns true if any subrange matches
	 * `version`.
	 *
	 * @param {string} range
	 * @param {string} version
	 * @returns {boolean}
	 */
	function checkOrExpression(range, version) {
	  var expressions = range.split(orRegex);
	
	  if (expressions.length > 1) {
	    return expressions.some(function (range) {
	      return VersionRange.contains(range, version);
	    });
	  } else {
	    range = expressions[0].trim();
	    return checkRangeExpression(range, version);
	  }
	}
	
	/**
	 * Splits input `range` on " - " (the surrounding whitespace is required) and
	 * returns true if version falls between the two operands.
	 *
	 * @param {string} range
	 * @param {string} version
	 * @returns {boolean}
	 */
	function checkRangeExpression(range, version) {
	  var expressions = range.split(rangeRegex);
	
	  !(expressions.length > 0 && expressions.length <= 2) ?  false ? invariant(false, 'the "-" operator expects exactly 2 operands') : invariant(false) : void 0;
	
	  if (expressions.length === 1) {
	    return checkSimpleExpression(expressions[0], version);
	  } else {
	    var startVersion = expressions[0],
	        endVersion = expressions[1];
	
	    !(isSimpleVersion(startVersion) && isSimpleVersion(endVersion)) ?  false ? invariant(false, 'operands to the "-" operator must be simple (no modifiers)') : invariant(false) : void 0;
	
	    return checkSimpleExpression('>=' + startVersion, version) && checkSimpleExpression('<=' + endVersion, version);
	  }
	}
	
	/**
	 * Checks if `range` matches `version`. `range` should be a "simple" range (ie.
	 * not a compound range using the " - " or "||" operators).
	 *
	 * @param {string} range
	 * @param {string} version
	 * @returns {boolean}
	 */
	function checkSimpleExpression(range, version) {
	  range = range.trim();
	  if (range === '') {
	    return true;
	  }
	
	  var versionComponents = version.split(componentRegex);
	
	  var _getModifierAndCompon = getModifierAndComponents(range),
	      modifier = _getModifierAndCompon.modifier,
	      rangeComponents = _getModifierAndCompon.rangeComponents;
	
	  switch (modifier) {
	    case '<':
	      return checkLessThan(versionComponents, rangeComponents);
	    case '<=':
	      return checkLessThanOrEqual(versionComponents, rangeComponents);
	    case '>=':
	      return checkGreaterThanOrEqual(versionComponents, rangeComponents);
	    case '>':
	      return checkGreaterThan(versionComponents, rangeComponents);
	    case '~':
	    case '~>':
	      return checkApproximateVersion(versionComponents, rangeComponents);
	    default:
	      return checkEqual(versionComponents, rangeComponents);
	  }
	}
	
	/**
	 * Checks whether `a` is less than `b`.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkLessThan(a, b) {
	  return compareComponents(a, b) === -1;
	}
	
	/**
	 * Checks whether `a` is less than or equal to `b`.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkLessThanOrEqual(a, b) {
	  var result = compareComponents(a, b);
	  return result === -1 || result === 0;
	}
	
	/**
	 * Checks whether `a` is equal to `b`.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkEqual(a, b) {
	  return compareComponents(a, b) === 0;
	}
	
	/**
	 * Checks whether `a` is greater than or equal to `b`.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkGreaterThanOrEqual(a, b) {
	  var result = compareComponents(a, b);
	  return result === 1 || result === 0;
	}
	
	/**
	 * Checks whether `a` is greater than `b`.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkGreaterThan(a, b) {
	  return compareComponents(a, b) === 1;
	}
	
	/**
	 * Checks whether `a` is "reasonably close" to `b` (as described in
	 * https://www.npmjs.org/doc/misc/semver.html). For example, if `b` is "1.3.1"
	 * then "reasonably close" is defined as ">= 1.3.1 and < 1.4".
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkApproximateVersion(a, b) {
	  var lowerBound = b.slice();
	  var upperBound = b.slice();
	
	  if (upperBound.length > 1) {
	    upperBound.pop();
	  }
	  var lastIndex = upperBound.length - 1;
	  var numeric = parseInt(upperBound[lastIndex], 10);
	  if (isNumber(numeric)) {
	    upperBound[lastIndex] = numeric + 1 + '';
	  }
	
	  return checkGreaterThanOrEqual(a, lowerBound) && checkLessThan(a, upperBound);
	}
	
	/**
	 * Extracts the optional modifier (<, <=, =, >=, >, ~, ~>) and version
	 * components from `range`.
	 *
	 * For example, given `range` ">= 1.2.3" returns an object with a `modifier` of
	 * `">="` and `components` of `[1, 2, 3]`.
	 *
	 * @param {string} range
	 * @returns {object}
	 */
	function getModifierAndComponents(range) {
	  var rangeComponents = range.split(componentRegex);
	  var matches = rangeComponents[0].match(modifierRegex);
	  !matches ?  false ? invariant(false, 'expected regex to match but it did not') : invariant(false) : void 0;
	
	  return {
	    modifier: matches[1],
	    rangeComponents: [matches[2]].concat(rangeComponents.slice(1))
	  };
	}
	
	/**
	 * Determines if `number` is a number.
	 *
	 * @param {mixed} number
	 * @returns {boolean}
	 */
	function isNumber(number) {
	  return !isNaN(number) && isFinite(number);
	}
	
	/**
	 * Tests whether `range` is a "simple" version number without any modifiers
	 * (">", "~" etc).
	 *
	 * @param {string} range
	 * @returns {boolean}
	 */
	function isSimpleVersion(range) {
	  return !getModifierAndComponents(range).modifier;
	}
	
	/**
	 * Zero-pads array `array` until it is at least `length` long.
	 *
	 * @param {array} array
	 * @param {number} length
	 */
	function zeroPad(array, length) {
	  for (var i = array.length; i < length; i++) {
	    array[i] = '0';
	  }
	}
	
	/**
	 * Normalizes `a` and `b` in preparation for comparison by doing the following:
	 *
	 * - zero-pads `a` and `b`
	 * - marks any "x", "X" or "*" component in `b` as equivalent by zero-ing it out
	 *   in both `a` and `b`
	 * - marks any final "*" component in `b` as a greedy wildcard by zero-ing it
	 *   and all of its successors in `a`
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {array<array<string>>}
	 */
	function normalizeVersions(a, b) {
	  a = a.slice();
	  b = b.slice();
	
	  zeroPad(a, b.length);
	
	  // mark "x" and "*" components as equal
	  for (var i = 0; i < b.length; i++) {
	    var matches = b[i].match(/^[x*]$/i);
	    if (matches) {
	      b[i] = a[i] = '0';
	
	      // final "*" greedily zeros all remaining components
	      if (matches[0] === '*' && i === b.length - 1) {
	        for (var j = i; j < a.length; j++) {
	          a[j] = '0';
	        }
	      }
	    }
	  }
	
	  zeroPad(b, a.length);
	
	  return [a, b];
	}
	
	/**
	 * Returns the numerical -- not the lexicographical -- ordering of `a` and `b`.
	 *
	 * For example, `10-alpha` is greater than `2-beta`.
	 *
	 * @param {string} a
	 * @param {string} b
	 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
	 * or greater than `b`, respectively
	 */
	function compareNumeric(a, b) {
	  var aPrefix = a.match(numericRegex)[1];
	  var bPrefix = b.match(numericRegex)[1];
	  var aNumeric = parseInt(aPrefix, 10);
	  var bNumeric = parseInt(bPrefix, 10);
	
	  if (isNumber(aNumeric) && isNumber(bNumeric) && aNumeric !== bNumeric) {
	    return compare(aNumeric, bNumeric);
	  } else {
	    return compare(a, b);
	  }
	}
	
	/**
	 * Returns the ordering of `a` and `b`.
	 *
	 * @param {string|number} a
	 * @param {string|number} b
	 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
	 * or greater than `b`, respectively
	 */
	function compare(a, b) {
	  !(typeof a === typeof b) ?  false ? invariant(false, '"a" and "b" must be of the same type') : invariant(false) : void 0;
	
	  if (a > b) {
	    return 1;
	  } else if (a < b) {
	    return -1;
	  } else {
	    return 0;
	  }
	}
	
	/**
	 * Compares arrays of version components.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
	 * or greater than `b`, respectively
	 */
	function compareComponents(a, b) {
	  var _normalizeVersions = normalizeVersions(a, b),
	      aNormalized = _normalizeVersions[0],
	      bNormalized = _normalizeVersions[1];
	
	  for (var i = 0; i < bNormalized.length; i++) {
	    var result = compareNumeric(aNormalized[i], bNormalized[i]);
	    if (result) {
	      return result;
	    }
	  }
	
	  return 0;
	}
	
	var VersionRange = {
	  /**
	   * Checks whether `version` satisfies the `range` specification.
	   *
	   * We support a subset of the expressions defined in
	   * https://www.npmjs.org/doc/misc/semver.html:
	   *
	   *    version   Must match version exactly
	   *    =version  Same as just version
	   *    >version  Must be greater than version
	   *    >=version Must be greater than or equal to version
	   *    <version  Must be less than version
	   *    <=version Must be less than or equal to version
	   *    ~version  Must be at least version, but less than the next significant
	   *              revision above version:
	   *              "~1.2.3" is equivalent to ">= 1.2.3 and < 1.3"
	   *    ~>version Equivalent to ~version
	   *    1.2.x     Must match "1.2.x", where "x" is a wildcard that matches
	   *              anything
	   *    1.2.*     Similar to "1.2.x", but "*" in the trailing position is a
	   *              "greedy" wildcard, so will match any number of additional
	   *              components:
	   *              "1.2.*" will match "1.2.1", "1.2.1.1", "1.2.1.1.1" etc
	   *    *         Any version
	   *    ""        (Empty string) Same as *
	   *    v1 - v2   Equivalent to ">= v1 and <= v2"
	   *    r1 || r2  Passes if either r1 or r2 are satisfied
	   *
	   * @param {string} range
	   * @param {string} version
	   * @returns {boolean}
	   */
	  contains: function contains(range, version) {
	    return checkOrExpression(range.trim(), version.trim());
	  }
	};
	
	module.exports = VersionRange;

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(562);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(64);
	
	var createArrayFromMixed = __webpack_require__(563);
	var getMarkupWrap = __webpack_require__(1345);
	var invariant = __webpack_require__(10);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ }),
/* 1342 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var isWebkit = typeof navigator !== 'undefined' && navigator.userAgent.indexOf('AppleWebKit') > -1;
	
	/**
	 * Gets the element with the document scroll properties such as `scrollLeft` and
	 * `scrollHeight`. This may differ across different browsers.
	 *
	 * NOTE: The return value can be null if the DOM is not yet ready.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getDocumentScrollElement(doc) {
	  doc = doc || document;
	  return !isWebkit && doc.compatMode === 'CSS1Compat' ? doc.documentElement : doc.body;
	}
	
	module.exports = getDocumentScrollElement;

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var getElementRect = __webpack_require__(1344);
	
	/**
	 * Gets an element's position in pixels relative to the viewport. The returned
	 * object represents the position of the element's top left corner.
	 *
	 * @param {DOMElement} element
	 * @return {object}
	 */
	function getElementPosition(element) {
	  var rect = getElementRect(element);
	  return {
	    x: rect.left,
	    y: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	}
	
	module.exports = getElementPosition;

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var containsNode = __webpack_require__(368);
	
	/**
	 * Gets an element's bounding rect in pixels relative to the viewport.
	 *
	 * @param {DOMElement} elem
	 * @return {object}
	 */
	function getElementRect(elem) {
	  var docElem = elem.ownerDocument.documentElement;
	
	  // FF 2, Safari 3 and Opera 9.5- do not support getBoundingClientRect().
	  // IE9- will throw if the element is not in the document.
	  if (!('getBoundingClientRect' in elem) || !containsNode(docElem, elem)) {
	    return {
	      left: 0,
	      right: 0,
	      top: 0,
	      bottom: 0
	    };
	  }
	
	  // Subtracts clientTop/Left because IE8- added a 2px border to the
	  // <html> element (see http://fburl.com/1493213). IE 7 in
	  // Quicksmode does not report clientLeft/clientTop so there
	  // will be an unaccounted offset of 2px when in quirksmode
	  var rect = elem.getBoundingClientRect();
	
	  return {
	    left: Math.round(rect.left) - docElem.clientLeft,
	    right: Math.round(rect.right) - docElem.clientLeft,
	    top: Math.round(rect.top) - docElem.clientTop,
	    bottom: Math.round(rect.bottom) - docElem.clientTop
	  };
	}
	
	module.exports = getElementRect;

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(64);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var camelize = __webpack_require__(562);
	var hyphenate = __webpack_require__(566);
	
	function asString(value) /*?string*/{
	  return value == null ? value : String(value);
	}
	
	function getStyleProperty( /*DOMNode*/node, /*string*/name) /*?string*/{
	  var computedStyle = void 0;
	
	  // W3C Standard
	  if (window.getComputedStyle) {
	    // In certain cases such as within an iframe in FF3, this returns null.
	    computedStyle = window.getComputedStyle(node, null);
	    if (computedStyle) {
	      return asString(computedStyle.getPropertyValue(hyphenate(name)));
	    }
	  }
	  // Safari
	  if (document.defaultView && document.defaultView.getComputedStyle) {
	    computedStyle = document.defaultView.getComputedStyle(node, null);
	    // A Safari bug causes this to return null for `display: none` elements.
	    if (computedStyle) {
	      return asString(computedStyle.getPropertyValue(hyphenate(name)));
	    }
	    if (name === 'display') {
	      return 'none';
	    }
	  }
	  // Internet Explorer
	  if (node.currentStyle) {
	    if (name === 'float') {
	      return asString(node.currentStyle.cssFloat || node.currentStyle.styleFloat);
	    }
	    return asString(node.currentStyle[camelize(name)]);
	  }
	  return asString(node.style && node.style[camelize(name)]);
	}
	
	module.exports = getStyleProperty;

/***/ }),
/* 1347 */
/***/ (function(module, exports) {

	"use strict";
	
	function getViewportWidth() {
	  var width = void 0;
	  if (document.documentElement) {
	    width = document.documentElement.clientWidth;
	  }
	
	  if (!width && document.body) {
	    width = document.body.clientWidth;
	  }
	
	  return width || 0;
	} /**
	   * Copyright (c) 2013-present, Facebook, Inc.
	   * All rights reserved.
	   *
	   * This source code is licensed under the BSD-style license found in the
	   * LICENSE file in the root directory of this source tree. An additional grant
	   * of patent rights can be found in the PATENTS file in the same directory.
	   *
	   * 
	   * @typechecks
	   */
	
	function getViewportHeight() {
	  var height = void 0;
	  if (document.documentElement) {
	    height = document.documentElement.clientHeight;
	  }
	
	  if (!height && document.body) {
	    height = document.body.clientHeight;
	  }
	
	  return height || 0;
	}
	
	/**
	 * Gets the viewport dimensions including any scrollbars.
	 */
	function getViewportDimensions() {
	  return {
	    width: window.innerWidth || getViewportWidth(),
	    height: window.innerHeight || getViewportHeight()
	  };
	}
	
	/**
	 * Gets the viewport dimensions excluding any scrollbars.
	 */
	getViewportDimensions.withoutScrollbars = function () {
	  return {
	    width: getViewportWidth(),
	    height: getViewportHeight()
	  };
	};
	
	module.exports = getViewportDimensions;

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(566);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ }),
/* 1349 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(1349);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ }),
/* 1351 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Combines multiple className strings into one.
	 * http://jsperf.com/joinclasses-args-vs-array
	 *
	 * @param {...?string} className
	 * @return {string}
	 */
	
	function joinClasses(className /*, ... */) {
	  if (!className) {
	    className = '';
	  }
	  var nextClass = void 0;
	  var argLength = arguments.length;
	  if (argLength > 1) {
	    for (var ii = 1; ii < argLength; ii++) {
	      nextClass = arguments[ii];
	      if (nextClass) {
	        className = (className ? className + ' ' : '') + nextClass;
	      }
	    }
	  }
	  return className;
	}
	
	module.exports = joinClasses;

/***/ }),
/* 1352 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Executes the provided `callback` once for each enumerable own property in the
	 * object and constructs a new object from the results. The `callback` is
	 * invoked with three arguments:
	 *
	 *  - the property value
	 *  - the property name
	 *  - the object being traversed
	 *
	 * Properties that are added after the call to `mapObject` will not be visited
	 * by `callback`. If the values of existing properties are changed, the value
	 * passed to `callback` will be the value at the time `mapObject` visits them.
	 * Properties that are deleted before being visited are not visited.
	 *
	 * @grep function objectMap()
	 * @grep function objMap()
	 *
	 * @param {?object} object
	 * @param {function} callback
	 * @param {*} context
	 * @return {?object}
	 */
	function mapObject(object, callback, context) {
	  if (!object) {
	    return null;
	  }
	  var result = {};
	  for (var name in object) {
	    if (hasOwnProperty.call(object, name)) {
	      result[name] = callback.call(context, object[name], name, object);
	    }
	  }
	  return result;
	}
	
	module.exports = mapObject;

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img-3322d7.jpg";

/***/ }),
/* 1354 */
/***/ (function(module, exports) {

	/* eslint-env browser */
	module.exports = typeof self == 'object' ? self.FormData : window.FormData;


/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = getCloneDimensions;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _getMargin = __webpack_require__(568);
	
	var _getMargin2 = _interopRequireDefault(_getMargin);
	
	function getCloneDimensions(node, options) {
	  var parentNode = node.parentNode;
	
	  var context = document.createElement('div');
	  var clone = node.cloneNode(true);
	  var style = getComputedStyle(node);
	  var rect = undefined,
	      width = undefined,
	      height = undefined,
	      margin = undefined;
	
	  // give the node some context to measure off of
	  // no height and hidden overflow hide node copy
	  context.style.height = 0;
	  context.style.overflow = 'hidden';
	
	  // clean up any attributes that might cause a conflict with the original node
	  // i.e. inputs that should focus or submit data
	  clone.setAttribute('id', '');
	  clone.setAttribute('name', '');
	
	  // set props to get a true dimension calculation
	  if (options.display || style.getPropertyValue('display') === 'none') {
	    clone.style.display = options.display || 'block';
	  }
	  if (options.width || !parseInt(style.getPropertyValue('width'))) {
	    clone.style.width = options.width || 'auto';
	  }
	  if (options.height || !parseInt(style.getPropertyValue('height'))) {
	    clone.style.height = options.height || 'auto';
	  }
	
	  // append copy to context
	  context.appendChild(clone);
	
	  // append context to DOM so we can measure
	  parentNode.appendChild(context);
	
	  // get accurate dimensions
	  rect = clone.getBoundingClientRect();
	  width = clone.offsetWidth;
	  height = clone.offsetHeight;
	
	  // destroy clone
	  parentNode.removeChild(context);
	
	  return {
	    rect: {
	      width: width,
	      height: height,
	      top: rect.top,
	      right: rect.right,
	      bottom: rect.bottom,
	      left: rect.left
	    },
	    margin: (0, _getMargin2['default'])(style)
	  };
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = getNodeDimensions;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _getCloneDimensions = __webpack_require__(1355);
	
	var _getCloneDimensions2 = _interopRequireDefault(_getCloneDimensions);
	
	var _getMargin = __webpack_require__(568);
	
	var _getMargin2 = _interopRequireDefault(_getMargin);
	
	function getNodeDimensions(node) {
	  var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  var rect = node.getBoundingClientRect();
	  var width = undefined,
	      height = undefined,
	      margin = undefined;
	
	  // determine if we need to clone the element to get proper dimensions or not
	  if (!rect.width || !rect.height || options.clone) {
	    var cloneDimensions = (0, _getCloneDimensions2['default'])(node, options);
	    rect = cloneDimensions.rect;
	    margin = cloneDimensions.margin;
	  }
	  // if no cloning needed, we need to determine if margin should be accounted for
	  else if (options.margin) {
	      margin = (0, _getMargin2['default'])(getComputedStyle(node));
	    }
	
	  // include margin in width/height calculation if desired
	  if (options.margin) {
	    width = margin.left + rect.width + margin.right;
	    height = margin.top + rect.height + margin.bottom;
	  } else {
	    width = rect.width;
	    height = rect.height;
	  }
	
	  return {
	    width: width,
	    height: height,
	    top: rect.top,
	    right: rect.right,
	    bottom: rect.bottom,
	    left: rect.left
	  };
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1357 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 1358 */
/***/ (function(module, exports) {

	
	/**
	 * Module exports.
	 *
	 * Logic borrowed from Modernizr:
	 *
	 *   - https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cors.js
	 */
	
	try {
	  module.exports = typeof XMLHttpRequest !== 'undefined' &&
	    'withCredentials' in new XMLHttpRequest();
	} catch (err) {
	  // if XMLHttp support is disabled in IE then it will throw
	  // when trying to create
	  module.exports = false;
	}


/***/ }),
/* 1359 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var _slice = Array.prototype.slice;
	exports.loopAsync = loopAsync;
	
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = undefined;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(_slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}

/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(184);
	
	var _PathUtils = __webpack_require__(160);
	
	var _ExecutionEnvironment = __webpack_require__(267);
	
	var _DOMUtils = __webpack_require__(370);
	
	var _DOMStateStorage = __webpack_require__(570);
	
	var _createDOMHistory = __webpack_require__(571);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve URLs.
	 */
	function createBrowserHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Browser history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var forceRefresh = options.forceRefresh;
	
	  var isSupported = _DOMUtils.supportsHistory();
	  var useRefresh = !isSupported || forceRefresh;
	
	  function getCurrentLocation(historyState) {
	    try {
	      historyState = historyState || window.history.state || {};
	    } catch (e) {
	      historyState = {};
	    }
	
	    var path = _DOMUtils.getWindowPath();
	    var _historyState = historyState;
	    var key = _historyState.key;
	
	    var state = undefined;
	    if (key) {
	      state = _DOMStateStorage.readState(key);
	    } else {
	      state = null;
	      key = history.createKey();
	
	      if (isSupported) window.history.replaceState(_extends({}, historyState, { key: key }), null);
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startPopStateListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function popStateListener(event) {
	      if (event.state === undefined) return; // Ignore extraneous popstate events in WebKit.
	
	      transitionTo(getCurrentLocation(event.state));
	    }
	
	    _DOMUtils.addEventListener(window, 'popstate', popStateListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'popstate', popStateListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    _DOMStateStorage.saveState(key, state);
	
	    var path = (basename || '') + pathname + search + hash;
	    var historyState = {
	      key: key
	    };
	
	    if (action === _Actions.PUSH) {
	      if (useRefresh) {
	        window.location.href = path;
	        return false; // Prevent location update.
	      } else {
	          window.history.pushState(historyState, null, path);
	        }
	    } else {
	      // REPLACE
	      if (useRefresh) {
	        window.location.replace(path);
	        return false; // Prevent location update.
	      } else {
	          window.history.replaceState(historyState, null, path);
	        }
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopPopStateListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopPopStateListener();
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    registerTransitionHook: registerTransitionHook,
	    unregisterTransitionHook: unregisterTransitionHook
	  });
	}
	
	exports['default'] = createBrowserHistory;
	module.exports = exports['default'];

/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(102);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Actions = __webpack_require__(184);
	
	var _PathUtils = __webpack_require__(160);
	
	function createLocation() {
	  var location = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
	  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	  var _fourthArg = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
	
	  if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	  if (typeof action === 'object') {
	     false ? _warning2['default'](false, 'The state (2nd) argument to createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	    location = _extends({}, location, { state: action });
	
	    action = key || _Actions.POP;
	    key = _fourthArg;
	  }
	
	  var pathname = location.pathname || '/';
	  var search = location.search || '';
	  var hash = location.hash || '';
	  var state = location.state || null;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	}
	
	exports['default'] = createLocation;
	module.exports = exports['default'];

/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(102);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PathUtils = __webpack_require__(160);
	
	var _Actions = __webpack_require__(184);
	
	var _createHistory = __webpack_require__(573);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	}
	
	function createMemoryHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var history = _createHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: saveState,
	    go: go
	  }));
	
	  var _options = options;
	  var entries = _options.entries;
	  var current = _options.current;
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    var key = history.createKey();
	
	    if (typeof entry === 'string') return { pathname: entry, key: key };
	
	    if (typeof entry === 'object' && entry) return _extends({}, entry, { key: key });
	
	     true ?  false ? _invariant2['default'](false, 'Unable to create history entry from %s', entry) : _invariant2['default'](false) : undefined;
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? _invariant2['default'](false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : _invariant2['default'](false) : undefined;
	  }
	
	  var storage = createStateStorage(entries);
	
	  function saveState(key, state) {
	    storage[key] = state;
	  }
	
	  function readState(key) {
	    return storage[key];
	  }
	
	  function getCurrentLocation() {
	    var entry = entries[current];
	    var basename = entry.basename;
	    var pathname = entry.pathname;
	    var search = entry.search;
	
	    var path = (basename || '') + pathname + (search || '');
	
	    var key = undefined,
	        state = undefined;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    } else {
	      key = history.createKey();
	      state = null;
	      entry.key = key;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  }
	
	  function go(n) {
	    if (n) {
	      if (!canGo(n)) {
	         false ? _warning2['default'](false, 'Cannot go(%s) there is not enough history', n) : undefined;
	        return;
	      }
	
	      current += n;
	
	      var currentLocation = getCurrentLocation();
	
	      // change action to POP
	      history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	    }
	  }
	
	  function finishTransition(location) {
	    switch (location.action) {
	      case _Actions.PUSH:
	        current += 1;
	
	        // if we are not on the top of stack
	        // remove rest and push new
	        if (current < entries.length) entries.splice(current);
	
	        entries.push(location);
	        saveState(location.key, location.state);
	        break;
	      case _Actions.REPLACE:
	        entries[current] = location;
	        saveState(location.key, location.state);
	        break;
	    }
	  }
	
	  return history;
	}
	
	exports['default'] = createMemoryHistory;
	module.exports = exports['default'];

/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Print a human readable timestamp to the terminal
	 * given a number representing seconds
	 *
	 * Author: Dave Eddy <dave@daveeddy.com>
	 * Date: 8/18/2014
	 * License: MIT
	 */
	
	var util = __webpack_require__(2325);
	
	module.exports = human;
	
	function human(seconds) {
	  if (seconds instanceof Date)
	    seconds = Math.round((Date.now() - seconds) / 1000);
	  var suffix = seconds < 0 ? 'from now' : 'ago';
	  seconds = Math.abs(seconds);
	
	  var times = [
	    seconds / 60 / 60 / 24 / 365, // years
	    seconds / 60 / 60 / 24 / 30,  // months
	    seconds / 60 / 60 / 24 / 7,   // weeks
	    seconds / 60 / 60 / 24,       // days
	    seconds / 60 / 60,            // hours
	    seconds / 60,                 // minutes
	    seconds                       // seconds
	  ];
	  var names = ['year', 'month', 'week', 'day', 'hour', 'minute', 'second'];
	
	  for (var i = 0; i < names.length; i++) {
	    var time = Math.floor(times[i]);
	    if (time > 1)
	      return util.format('%d %ss %s', time, names[i], suffix);
	    else if (time === 1)
	      return util.format('%d %s %s', time, names[i], suffix);
	  }
	  return util.format('0 seconds %s', suffix);
	}


/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.immutableDevTools=t():e.immutableDevTools=t()}(this,function(){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={exports:{},id:n,loaded:!1};return e[n].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var r={};return t.m=e,t.c=r,t.p="",t(0)}([function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{"default":e}}function o(e){if("undefined"==typeof window)throw new Error("Can only install immutable-devtools in a browser environment.");if(i!==!0){window.devtoolsFormatters=window.devtoolsFormatters||[];var t=(0,u["default"])(e),r=t.RecordFormatter,n=t.OrderedMapFormatter,o=t.OrderedSetFormatter,a=t.ListFormatter,s=t.MapFormatter,l=t.SetFormatter,d=t.StackFormatter;window.devtoolsFormatters.push(r,n,o,a,s,l,d),i=!0}}Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=o;var a=r(1),u=n(a);"undefined"!=typeof Immutable&&(Immutable.installDevTools=o.bind(null,Immutable));var i=!1},function(e,t){"use strict";function r(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)}function n(e){var t=function(e,t){return"undefined"==typeof e?["span",d,"undefined"]:"null"===e?["span",d,"null"]:["object",{object:e,config:t}]},n=function(e){var t=arguments.length<=1||void 0===arguments[1]?"Iterable":arguments[1];return["span",["span",a,t],["span","["+e.size+"]"]]},c=function(e,t){return e.size>0&&!(t&&t.noPreview)},f=function(e,t){var n=e.map(t).toList().toJS();return["ol",o].concat(r(n))},p={header:function(n,o){if(!(n instanceof e.Record))return null;var i=n.clear(),s=!e.is(i,n);if(o&&o.noPreview)return["span",s?a:d,n._name||n.constructor.name||"Record"];var c=void 0;if(s){var f=n.keySeq().reduce(function(r,o){return e.is(i.get(o),n.get(o))?r:(r.length&&r.push(", "),r.push(["span",{},["span",u,o+": "],t(n.get(o),{noPreview:!0})]),r)},[]);c=["span",l,"{"].concat(r(f),["}"])}else c=["span",l,"{}"];return["span",{},["span",a,n._name||n.constructor.name||"Record"]," ",c]},hasBody:c,body:function(n){var a=n.clear(),u=n.keySeq().map(function(r){var o=e.is(a.get(r),n.get(r))?i:s;return["li",{},["span",o,r+": "],t(n.get(r))]}).toJS();return["ol",o].concat(r(u))}},m={header:function(t){return e.List.isList(t)?n(t,"List"):null},hasBody:c,body:function(e){return f(e,function(e,r){return["li",["span",u,r+": "],t(e)]})}},y={header:function(t){return e.Stack.isStack(t)?n(t,"Stack"):null},hasBody:c,body:function(e){return f(e,function(e,r){return["li",["span",u,r+": "],t(e)]})}},v={header:function(t){return e.Map.isMap(t)?n(t,"Map"):null},hasBody:c,body:function(e){return f(e,function(e,r){return["li",{},"{",t(r)," => ",t(e),"}"]})}},b={header:function(t){return e.OrderedMap.isOrderedMap(t)?n(t,"OrderedMap"):null},hasBody:c,body:function(e){return f(e,function(e,r){return["li",{},"{",t(r)," => ",t(e),"}"]})}},h={header:function(t){return e.Set.isSet(t)?n(t,"Set"):null},hasBody:c,body:function(e){return f(e,function(e){return["li",t(e)]})}},S={header:function(t){return e.OrderedSet.isOrderedSet(t)?n(t,"OrderedSet"):null},hasBody:c,body:function(e){return f(e,function(e){return["li",t(e)]})}};return{RecordFormatter:p,OrderedMapFormatter:b,OrderedSetFormatter:S,ListFormatter:m,MapFormatter:v,SetFormatter:h,StackFormatter:y}}Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=n;var o={style:"list-style-type: none; padding: 0; margin: 0 0 0 12px; font-style: normal"},a={style:"color: rgb(232,98,0)"},u={style:"color: #881391"},i={style:"color: #777"},s={style:"color: #881391; font-weight: bolder"},l={style:"color: #777; font-style: italic"},d={style:"color: #777"}}])});

/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	
	module.exports = function (opts) {
	  var re = {};
	
	  // Use direct extract instead of `regenerate` to reduse browserified size
	  re.src_Any = __webpack_require__(2320).source;
	  re.src_Cc  = __webpack_require__(2317).source;
	  re.src_Z   = __webpack_require__(2319).source;
	  re.src_P   = __webpack_require__(2318).source;
	
	  // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
	  re.src_ZPCc = [ re.src_Z, re.src_P, re.src_Cc ].join('|');
	
	  // \p{\Z\Cc} (white spaces + control)
	  re.src_ZCc = [ re.src_Z, re.src_Cc ].join('|');
	
	  // All possible word characters (everything without punctuation, spaces & controls)
	  // Defined via punctuation & spaces to save space
	  // Should be something like \p{\L\N\S\M} (\w but without `_`)
	  re.src_pseudo_letter       = '(?:(?!>|<|' + re.src_ZPCc + ')' + re.src_Any + ')';
	  // The same as abothe but without [0-9]
	  // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
	
	  ////////////////////////////////////////////////////////////////////////////////
	
	  re.src_ip4 =
	
	    '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
	
	  // Prohibit [@/] in user/pass to avoid wrong domain fetch.
	  re.src_auth    = '(?:(?:(?!' + re.src_ZCc + '|[@/]).)+@)?';
	
	  re.src_port =
	
	    '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
	
	  re.src_host_terminator =
	
	    '(?=$|>|<|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
	
	  re.src_path =
	
	    '(?:' +
	      '[/?#]' +
	        '(?:' +
	          '(?!' + re.src_ZCc + '|[()[\\]{}.,"\'?!\\-<>]).|' +
	          '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' +
	          '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' +
	          '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' +
	          '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' +
	          "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" +
	          "\\'(?=" + re.src_pseudo_letter + '|[-]).|' +  // allow `I'm_king` if no pair found
	          '\\.{2,3}[a-zA-Z0-9%/]|' + // github has ... in commit range links. Restrict to
	                                     // - english
	                                     // - percent-encoded
	                                     // - parts of file path
	                                     // until more examples found.
	          '\\.(?!' + re.src_ZCc + '|[.]).|' +
	          (opts && opts['---'] ?
	            '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
	          :
	            '\\-+|'
	          ) +
	          '\\,(?!' + re.src_ZCc + ').|' +      // allow `,,,` in paths
	          '\\!(?!' + re.src_ZCc + '|[!]).|' +
	          '\\?(?!' + re.src_ZCc + '|[?]).' +
	        ')+' +
	      '|\\/' +
	    ')?';
	
	  re.src_email_name =
	
	    '[\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]+';
	
	  re.src_xn =
	
	    'xn--[a-z0-9\\-]{1,59}';
	
	  // More to read about domain names
	  // http://serverfault.com/questions/638260/
	
	  re.src_domain_root =
	
	    // Allow letters & digits (http://test1)
	    '(?:' +
	      re.src_xn +
	      '|' +
	      re.src_pseudo_letter + '{1,63}' +
	    ')';
	
	  re.src_domain =
	
	    '(?:' +
	      re.src_xn +
	      '|' +
	      '(?:' + re.src_pseudo_letter + ')' +
	      '|' +
	      // don't allow `--` in domain names, because:
	      // - that can conflict with markdown &mdash; / &ndash;
	      // - nobody use those anyway
	      '(?:' + re.src_pseudo_letter + '(?:-(?!-)|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' +
	    ')';
	
	  re.src_host =
	
	    '(?:' +
	    // Don't need IP check, because digits are already allowed in normal domain names
	    //   src_ip4 +
	    // '|' +
	      '(?:(?:(?:' + re.src_domain + ')\\.)*' + re.src_domain_root + ')' +
	    ')';
	
	  re.tpl_host_fuzzy =
	
	    '(?:' +
	      re.src_ip4 +
	    '|' +
	      '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' +
	    ')';
	
	  re.tpl_host_no_ip_fuzzy =
	
	    '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
	
	  re.src_host_strict =
	
	    re.src_host + re.src_host_terminator;
	
	  re.tpl_host_fuzzy_strict =
	
	    re.tpl_host_fuzzy + re.src_host_terminator;
	
	  re.src_host_port_strict =
	
	    re.src_host + re.src_port + re.src_host_terminator;
	
	  re.tpl_host_port_fuzzy_strict =
	
	    re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
	
	  re.tpl_host_port_no_ip_fuzzy_strict =
	
	    re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
	
	
	  ////////////////////////////////////////////////////////////////////////////////
	  // Main rules
	
	  // Rude test fuzzy links by host, for quick deny
	  re.tpl_host_fuzzy_test =
	
	    'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
	
	  re.tpl_email_fuzzy =
	
	      '(^|<|>|\\(|' + re.src_ZCc + ')(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
	
	  re.tpl_link_fuzzy =
	      // Fuzzy link can't be prepended with .:/\- and non punctuation.
	      // but can start with > (markdown blockquote)
	      '(^|(?![.:/\\-_@])(?:[$+<=>^`|]|' + re.src_ZPCc + '))' +
	      '((?![$+<=>^`|])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
	
	  re.tpl_link_no_ip_fuzzy =
	      // Fuzzy link can't be prepended with .:/\- and non punctuation.
	      // but can start with > (markdown blockquote)
	      '(^|(?![.:/\\-_@])(?:[$+<=>^`|]|' + re.src_ZPCc + '))' +
	      '((?![$+<=>^`|])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
	
	  return re;
	};


/***/ }),
/* 1366 */
/***/ (function(module, exports) {

	/**
	 * lodash 3.9.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]';
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = getNative;


/***/ }),
/* 1367 */
/***/ (function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isArguments;


/***/ }),
/* 1368 */
/***/ (function(module, exports) {

	/**
	 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]',
	    funcTag = '[object Function]';
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = getNative(Array, 'isArray');
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	};
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = isArray;


/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.1.2 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var getNative = __webpack_require__(1366),
	    isArguments = __webpack_require__(1367),
	    isArray = __webpack_require__(1368);
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeKeys = getNative(Object, 'keys');
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * A fallback implementation of `Object.keys` which creates an array of the
	 * own enumerable property names of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function shimKeys(object) {
	  var props = keysIn(object),
	      propsLength = props.length,
	      length = propsLength && object.length;
	
	  var allowIndexes = !!length && isLength(length) &&
	    (isArray(object) || isArguments(object));
	
	  var index = -1,
	      result = [];
	
	  while (++index < propsLength) {
	    var key = props[index];
	    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	var keys = !nativeKeys ? shimKeys : function(object) {
	  var Ctor = object == null ? undefined : object.constructor;
	  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	      (typeof object != 'function' && isArrayLike(object))) {
	    return shimKeys(object);
	  }
	  return isObject(object) ? nativeKeys(object) : [];
	};
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keys;


/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(1398),
	    hashDelete = __webpack_require__(1399),
	    hashGet = __webpack_require__(1400),
	    hashHas = __webpack_require__(1401),
	    hashSet = __webpack_require__(1402);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(1408),
	    listCacheDelete = __webpack_require__(1409),
	    listCacheGet = __webpack_require__(1410),
	    listCacheHas = __webpack_require__(1411),
	    listCacheSet = __webpack_require__(1412);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(272),
	    root = __webpack_require__(217);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(272),
	    root = __webpack_require__(217);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 1374 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(1387),
	    isArguments = __webpack_require__(589),
	    isArray = __webpack_require__(162),
	    isBuffer = __webpack_require__(1436),
	    isIndex = __webpack_require__(586),
	    isTypedArray = __webpack_require__(1437);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 1376 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(580),
	    eq = __webpack_require__(274);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ }),
/* 1378 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(1378),
	    baseIsNaN = __webpack_require__(1382),
	    strictIndexOf = __webpack_require__(1427);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(374),
	    arrayIncludes = __webpack_require__(376),
	    arrayIncludesWith = __webpack_require__(377),
	    arrayMap = __webpack_require__(378),
	    baseUnary = __webpack_require__(379),
	    cacheHas = __webpack_require__(380);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * The base implementation of methods like `_.intersection`, without support
	 * for iteratee shorthands, that accepts an array of arrays to inspect.
	 *
	 * @private
	 * @param {Array} arrays The arrays to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of shared values.
	 */
	function baseIntersection(arrays, iteratee, comparator) {
	  var includes = comparator ? arrayIncludesWith : arrayIncludes,
	      length = arrays[0].length,
	      othLength = arrays.length,
	      othIndex = othLength,
	      caches = Array(othLength),
	      maxLength = Infinity,
	      result = [];
	
	  while (othIndex--) {
	    var array = arrays[othIndex];
	    if (othIndex && iteratee) {
	      array = arrayMap(array, baseUnary(iteratee));
	    }
	    maxLength = nativeMin(array.length, maxLength);
	    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	      ? new SetCache(othIndex && array)
	      : undefined;
	  }
	  array = arrays[0];
	
	  var index = -1,
	      seen = caches[0];
	
	  outer:
	  while (++index < length && result.length < maxLength) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (!(seen
	          ? cacheHas(seen, computed)
	          : includes(result, computed, comparator)
	        )) {
	      othIndex = othLength;
	      while (--othIndex) {
	        var cache = caches[othIndex];
	        if (!(cache
	              ? cacheHas(cache, computed)
	              : includes(arrays[othIndex], computed, comparator))
	            ) {
	          continue outer;
	        }
	      }
	      if (seen) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseIntersection;


/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(270),
	    isObjectLike = __webpack_require__(219);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),
/* 1382 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(590),
	    isMasked = __webpack_require__(1406),
	    isObject = __webpack_require__(218),
	    toSource = __webpack_require__(1428);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(270),
	    isLength = __webpack_require__(591),
	    isObjectLike = __webpack_require__(219);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(218),
	    isPrototype = __webpack_require__(1407),
	    nativeKeysIn = __webpack_require__(1418);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(1430),
	    defineProperty = __webpack_require__(584),
	    identity = __webpack_require__(588);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ }),
/* 1387 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(581),
	    baseFlatten = __webpack_require__(582),
	    baseUniq = __webpack_require__(583);
	
	/**
	 * The base implementation of methods like `_.xor`, without support for
	 * iteratee shorthands, that accepts an array of arrays to inspect.
	 *
	 * @private
	 * @param {Array} arrays The arrays to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of values.
	 */
	function baseXor(arrays, iteratee, comparator) {
	  var length = arrays.length;
	  if (length < 2) {
	    return length ? baseUniq(arrays[0]) : [];
	  }
	  var index = -1,
	      result = Array(length);
	
	  while (++index < length) {
	    var array = arrays[index],
	        othIndex = -1;
	
	    while (++othIndex < length) {
	      if (othIndex != index) {
	        result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	      }
	    }
	  }
	  return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	}
	
	module.exports = baseXor;


/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLikeObject = __webpack_require__(275);
	
	/**
	 * Casts `value` to an empty array if it's not an array like object.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array|Object} Returns the cast array-like object.
	 */
	function castArrayLikeObject(value) {
	  return isArrayLikeObject(value) ? value : [];
	}
	
	module.exports = castArrayLikeObject;


/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(1377),
	    baseAssignValue = __webpack_require__(580);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(217);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(185),
	    isIterateeCall = __webpack_require__(1404);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(1373),
	    noop = __webpack_require__(592),
	    setToArray = __webpack_require__(587);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Creates a set object of `values`.
	 *
	 * @private
	 * @param {Array} values The values to add to the set.
	 * @returns {Object} Returns the new set.
	 */
	var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	  return new Set(values);
	};
	
	module.exports = createSet;


/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(274);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	 * of source objects to the destination object for all destination properties
	 * that resolve to `undefined`.
	 *
	 * @private
	 * @param {*} objValue The destination value.
	 * @param {*} srcValue The source value.
	 * @param {string} key The key of the property to assign.
	 * @param {Object} object The parent object of `objValue`.
	 * @returns {*} Returns the value to assign.
	 */
	function customDefaultsAssignIn(objValue, srcValue, key, object) {
	  if (objValue === undefined ||
	      (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	    return srcValue;
	  }
	  return objValue;
	}
	
	module.exports = customDefaultsAssignIn;


/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(1421);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(375);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 1397 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(273);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),
/* 1399 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(273);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(273);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(273);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(375),
	    isArguments = __webpack_require__(589),
	    isArray = __webpack_require__(162);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(274),
	    isArrayLike = __webpack_require__(381),
	    isIndex = __webpack_require__(586),
	    isObject = __webpack_require__(218);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ }),
/* 1405 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(1391);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 1407 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 1408 */
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(269);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(269);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(269);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(269);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(1370),
	    ListCache = __webpack_require__(1371),
	    Map = __webpack_require__(1372);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(271);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(271);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(271);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(271);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 1418 */
/***/ (function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(585);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(209)(module)))

/***/ }),
/* 1420 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 1421 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(579);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ }),
/* 1423 */
/***/ (function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ }),
/* 1424 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(1386),
	    shortOut = __webpack_require__(1426);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ }),
/* 1426 */
/***/ (function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ }),
/* 1427 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ }),
/* 1428 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(1390),
	    createAssigner = __webpack_require__(1392),
	    keysIn = __webpack_require__(1438);
	
	/**
	 * This method is like `_.assignIn` except that it accepts `customizer`
	 * which is invoked to produce the assigned values. If `customizer` returns
	 * `undefined`, assignment is handled by the method instead. The `customizer`
	 * is invoked with five arguments: (objValue, srcValue, key, object, source).
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @alias extendWith
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} sources The source objects.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 * @see _.assignWith
	 * @example
	 *
	 * function customizer(objValue, srcValue) {
	 *   return _.isUndefined(objValue) ? srcValue : objValue;
	 * }
	 *
	 * var defaults = _.partialRight(_.assignInWith, customizer);
	 *
	 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	 * // => { 'a': 1, 'b': 2 }
	 */
	var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	  copyObject(source, keysIn(source), object, customizer);
	});
	
	module.exports = assignInWith;


/***/ }),
/* 1430 */
/***/ (function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(579),
	    assignInWith = __webpack_require__(1429),
	    baseRest = __webpack_require__(185),
	    customDefaultsAssignIn = __webpack_require__(1394);
	
	/**
	 * Assigns own and inherited enumerable string keyed properties of source
	 * objects to the destination object for all destination properties that
	 * resolve to `undefined`. Source objects are applied from left to right.
	 * Once a property is set, additional values of the same property are ignored.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.defaultsDeep
	 * @example
	 *
	 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	 * // => { 'a': 1, 'b': 2 }
	 */
	var defaults = baseRest(function(args) {
	  args.push(undefined, customDefaultsAssignIn);
	  return apply(assignInWith, undefined, args);
	});
	
	module.exports = defaults;


/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

	var mapping = __webpack_require__(1433),
	    fallbackHolder = __webpack_require__(1434);
	
	/** Built-in value reference. */
	var push = Array.prototype.push;
	
	/**
	 * Creates a function, with an arity of `n`, that invokes `func` with the
	 * arguments it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} n The arity of the new function.
	 * @returns {Function} Returns the new function.
	 */
	function baseArity(func, n) {
	  return n == 2
	    ? function(a, b) { return func.apply(undefined, arguments); }
	    : function(a) { return func.apply(undefined, arguments); };
	}
	
	/**
	 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
	 * any additional arguments.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @param {number} n The arity cap.
	 * @returns {Function} Returns the new function.
	 */
	function baseAry(func, n) {
	  return n == 2
	    ? function(a, b) { return func(a, b); }
	    : function(a) { return func(a); };
	}
	
	/**
	 * Creates a clone of `array`.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the cloned array.
	 */
	function cloneArray(array) {
	  var length = array ? array.length : 0,
	      result = Array(length);
	
	  while (length--) {
	    result[length] = array[length];
	  }
	  return result;
	}
	
	/**
	 * Creates a function that clones a given object using the assignment `func`.
	 *
	 * @private
	 * @param {Function} func The assignment function.
	 * @returns {Function} Returns the new cloner function.
	 */
	function createCloner(func) {
	  return function(object) {
	    return func({}, object);
	  };
	}
	
	/**
	 * A specialized version of `_.spread` which flattens the spread array into
	 * the arguments of the invoked `func`.
	 *
	 * @private
	 * @param {Function} func The function to spread arguments over.
	 * @param {number} start The start position of the spread.
	 * @returns {Function} Returns the new function.
	 */
	function flatSpread(func, start) {
	  return function() {
	    var length = arguments.length,
	        lastIndex = length - 1,
	        args = Array(length);
	
	    while (length--) {
	      args[length] = arguments[length];
	    }
	    var array = args[start],
	        otherArgs = args.slice(0, start);
	
	    if (array) {
	      push.apply(otherArgs, array);
	    }
	    if (start != lastIndex) {
	      push.apply(otherArgs, args.slice(start + 1));
	    }
	    return func.apply(this, otherArgs);
	  };
	}
	
	/**
	 * Creates a function that wraps `func` and uses `cloner` to clone the first
	 * argument it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} cloner The function to clone arguments.
	 * @returns {Function} Returns the new immutable function.
	 */
	function wrapImmutable(func, cloner) {
	  return function() {
	    var length = arguments.length;
	    if (!length) {
	      return;
	    }
	    var args = Array(length);
	    while (length--) {
	      args[length] = arguments[length];
	    }
	    var result = args[0] = cloner.apply(undefined, args);
	    func.apply(undefined, args);
	    return result;
	  };
	}
	
	/**
	 * The base implementation of `convert` which accepts a `util` object of methods
	 * required to perform conversions.
	 *
	 * @param {Object} util The util object.
	 * @param {string} name The name of the function to convert.
	 * @param {Function} func The function to convert.
	 * @param {Object} [options] The options object.
	 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
	 * @param {boolean} [options.curry=true] Specify currying.
	 * @param {boolean} [options.fixed=true] Specify fixed arity.
	 * @param {boolean} [options.immutable=true] Specify immutable operations.
	 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
	 * @returns {Function|Object} Returns the converted function or object.
	 */
	function baseConvert(util, name, func, options) {
	  var setPlaceholder,
	      isLib = typeof name == 'function',
	      isObj = name === Object(name);
	
	  if (isObj) {
	    options = func;
	    func = name;
	    name = undefined;
	  }
	  if (func == null) {
	    throw new TypeError;
	  }
	  options || (options = {});
	
	  var config = {
	    'cap': 'cap' in options ? options.cap : true,
	    'curry': 'curry' in options ? options.curry : true,
	    'fixed': 'fixed' in options ? options.fixed : true,
	    'immutable': 'immutable' in options ? options.immutable : true,
	    'rearg': 'rearg' in options ? options.rearg : true
	  };
	
	  var forceCurry = ('curry' in options) && options.curry,
	      forceFixed = ('fixed' in options) && options.fixed,
	      forceRearg = ('rearg' in options) && options.rearg,
	      placeholder = isLib ? func : fallbackHolder,
	      pristine = isLib ? func.runInContext() : undefined;
	
	  var helpers = isLib ? func : {
	    'ary': util.ary,
	    'assign': util.assign,
	    'clone': util.clone,
	    'curry': util.curry,
	    'forEach': util.forEach,
	    'isArray': util.isArray,
	    'isFunction': util.isFunction,
	    'iteratee': util.iteratee,
	    'keys': util.keys,
	    'rearg': util.rearg,
	    'toInteger': util.toInteger,
	    'toPath': util.toPath
	  };
	
	  var ary = helpers.ary,
	      assign = helpers.assign,
	      clone = helpers.clone,
	      curry = helpers.curry,
	      each = helpers.forEach,
	      isArray = helpers.isArray,
	      isFunction = helpers.isFunction,
	      keys = helpers.keys,
	      rearg = helpers.rearg,
	      toInteger = helpers.toInteger,
	      toPath = helpers.toPath;
	
	  var aryMethodKeys = keys(mapping.aryMethod);
	
	  var wrappers = {
	    'castArray': function(castArray) {
	      return function() {
	        var value = arguments[0];
	        return isArray(value)
	          ? castArray(cloneArray(value))
	          : castArray.apply(undefined, arguments);
	      };
	    },
	    'iteratee': function(iteratee) {
	      return function() {
	        var func = arguments[0],
	            arity = arguments[1],
	            result = iteratee(func, arity),
	            length = result.length;
	
	        if (config.cap && typeof arity == 'number') {
	          arity = arity > 2 ? (arity - 2) : 1;
	          return (length && length <= arity) ? result : baseAry(result, arity);
	        }
	        return result;
	      };
	    },
	    'mixin': function(mixin) {
	      return function(source) {
	        var func = this;
	        if (!isFunction(func)) {
	          return mixin(func, Object(source));
	        }
	        var pairs = [];
	        each(keys(source), function(key) {
	          if (isFunction(source[key])) {
	            pairs.push([key, func.prototype[key]]);
	          }
	        });
	
	        mixin(func, Object(source));
	
	        each(pairs, function(pair) {
	          var value = pair[1];
	          if (isFunction(value)) {
	            func.prototype[pair[0]] = value;
	          } else {
	            delete func.prototype[pair[0]];
	          }
	        });
	        return func;
	      };
	    },
	    'nthArg': function(nthArg) {
	      return function(n) {
	        var arity = n < 0 ? 1 : (toInteger(n) + 1);
	        return curry(nthArg(n), arity);
	      };
	    },
	    'rearg': function(rearg) {
	      return function(func, indexes) {
	        var arity = indexes ? indexes.length : 0;
	        return curry(rearg(func, indexes), arity);
	      };
	    },
	    'runInContext': function(runInContext) {
	      return function(context) {
	        return baseConvert(util, runInContext(context), options);
	      };
	    }
	  };
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Casts `func` to a function with an arity capped iteratee if needed.
	   *
	   * @private
	   * @param {string} name The name of the function to inspect.
	   * @param {Function} func The function to inspect.
	   * @returns {Function} Returns the cast function.
	   */
	  function castCap(name, func) {
	    if (config.cap) {
	      var indexes = mapping.iterateeRearg[name];
	      if (indexes) {
	        return iterateeRearg(func, indexes);
	      }
	      var n = !isLib && mapping.iterateeAry[name];
	      if (n) {
	        return iterateeAry(func, n);
	      }
	    }
	    return func;
	  }
	
	  /**
	   * Casts `func` to a curried function if needed.
	   *
	   * @private
	   * @param {string} name The name of the function to inspect.
	   * @param {Function} func The function to inspect.
	   * @param {number} n The arity of `func`.
	   * @returns {Function} Returns the cast function.
	   */
	  function castCurry(name, func, n) {
	    return (forceCurry || (config.curry && n > 1))
	      ? curry(func, n)
	      : func;
	  }
	
	  /**
	   * Casts `func` to a fixed arity function if needed.
	   *
	   * @private
	   * @param {string} name The name of the function to inspect.
	   * @param {Function} func The function to inspect.
	   * @param {number} n The arity cap.
	   * @returns {Function} Returns the cast function.
	   */
	  function castFixed(name, func, n) {
	    if (config.fixed && (forceFixed || !mapping.skipFixed[name])) {
	      var data = mapping.methodSpread[name],
	          start = data && data.start;
	
	      return start  === undefined ? ary(func, n) : flatSpread(func, start);
	    }
	    return func;
	  }
	
	  /**
	   * Casts `func` to an rearged function if needed.
	   *
	   * @private
	   * @param {string} name The name of the function to inspect.
	   * @param {Function} func The function to inspect.
	   * @param {number} n The arity of `func`.
	   * @returns {Function} Returns the cast function.
	   */
	  function castRearg(name, func, n) {
	    return (config.rearg && n > 1 && (forceRearg || !mapping.skipRearg[name]))
	      ? rearg(func, mapping.methodRearg[name] || mapping.aryRearg[n])
	      : func;
	  }
	
	  /**
	   * Creates a clone of `object` by `path`.
	   *
	   * @private
	   * @param {Object} object The object to clone.
	   * @param {Array|string} path The path to clone by.
	   * @returns {Object} Returns the cloned object.
	   */
	  function cloneByPath(object, path) {
	    path = toPath(path);
	
	    var index = -1,
	        length = path.length,
	        lastIndex = length - 1,
	        result = clone(Object(object)),
	        nested = result;
	
	    while (nested != null && ++index < length) {
	      var key = path[index],
	          value = nested[key];
	
	      if (value != null) {
	        nested[path[index]] = clone(index == lastIndex ? value : Object(value));
	      }
	      nested = nested[key];
	    }
	    return result;
	  }
	
	  /**
	   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
	   * version with conversion `options` applied.
	   *
	   * @param {Object} [options] The options object. See `baseConvert` for more details.
	   * @returns {Function} Returns the converted `lodash`.
	   */
	  function convertLib(options) {
	    return _.runInContext.convert(options)(undefined);
	  }
	
	  /**
	   * Create a converter function for `func` of `name`.
	   *
	   * @param {string} name The name of the function to convert.
	   * @param {Function} func The function to convert.
	   * @returns {Function} Returns the new converter function.
	   */
	  function createConverter(name, func) {
	    var realName = mapping.aliasToReal[name] || name,
	        methodName = mapping.remap[realName] || realName,
	        oldOptions = options;
	
	    return function(options) {
	      var newUtil = isLib ? pristine : helpers,
	          newFunc = isLib ? pristine[methodName] : func,
	          newOptions = assign(assign({}, oldOptions), options);
	
	      return baseConvert(newUtil, realName, newFunc, newOptions);
	    };
	  }
	
	  /**
	   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
	   * arguments, ignoring any additional arguments.
	   *
	   * @private
	   * @param {Function} func The function to cap iteratee arguments for.
	   * @param {number} n The arity cap.
	   * @returns {Function} Returns the new function.
	   */
	  function iterateeAry(func, n) {
	    return overArg(func, function(func) {
	      return typeof func == 'function' ? baseAry(func, n) : func;
	    });
	  }
	
	  /**
	   * Creates a function that wraps `func` to invoke its iteratee with arguments
	   * arranged according to the specified `indexes` where the argument value at
	   * the first index is provided as the first argument, the argument value at
	   * the second index is provided as the second argument, and so on.
	   *
	   * @private
	   * @param {Function} func The function to rearrange iteratee arguments for.
	   * @param {number[]} indexes The arranged argument indexes.
	   * @returns {Function} Returns the new function.
	   */
	  function iterateeRearg(func, indexes) {
	    return overArg(func, function(func) {
	      var n = indexes.length;
	      return baseArity(rearg(baseAry(func, n), indexes), n);
	    });
	  }
	
	  /**
	   * Creates a function that invokes `func` with its first argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function() {
	      var length = arguments.length;
	      if (!length) {
	        return func();
	      }
	      var args = Array(length);
	      while (length--) {
	        args[length] = arguments[length];
	      }
	      var index = config.rearg ? 0 : (length - 1);
	      args[index] = transform(args[index]);
	      return func.apply(undefined, args);
	    };
	  }
	
	  /**
	   * Creates a function that wraps `func` and applys the conversions
	   * rules by `name`.
	   *
	   * @private
	   * @param {string} name The name of the function to wrap.
	   * @param {Function} func The function to wrap.
	   * @returns {Function} Returns the converted function.
	   */
	  function wrap(name, func) {
	    var result,
	        realName = mapping.aliasToReal[name] || name,
	        wrapped = func,
	        wrapper = wrappers[realName];
	
	    if (wrapper) {
	      wrapped = wrapper(func);
	    }
	    else if (config.immutable) {
	      if (mapping.mutate.array[realName]) {
	        wrapped = wrapImmutable(func, cloneArray);
	      }
	      else if (mapping.mutate.object[realName]) {
	        wrapped = wrapImmutable(func, createCloner(func));
	      }
	      else if (mapping.mutate.set[realName]) {
	        wrapped = wrapImmutable(func, cloneByPath);
	      }
	    }
	    each(aryMethodKeys, function(aryKey) {
	      each(mapping.aryMethod[aryKey], function(otherName) {
	        if (realName == otherName) {
	          var data = mapping.methodSpread[realName],
	              afterRearg = data && data.afterRearg;
	
	          result = afterRearg
	            ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey)
	            : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);
	
	          result = castCap(realName, result);
	          result = castCurry(realName, result, aryKey);
	          return false;
	        }
	      });
	      return !result;
	    });
	
	    result || (result = wrapped);
	    if (result == func) {
	      result = forceCurry ? curry(result, 1) : function() {
	        return func.apply(this, arguments);
	      };
	    }
	    result.convert = createConverter(realName, func);
	    if (mapping.placeholder[realName]) {
	      setPlaceholder = true;
	      result.placeholder = func.placeholder = placeholder;
	    }
	    return result;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  if (!isObj) {
	    return wrap(name, func);
	  }
	  var _ = func;
	
	  // Convert methods by ary cap.
	  var pairs = [];
	  each(aryMethodKeys, function(aryKey) {
	    each(mapping.aryMethod[aryKey], function(key) {
	      var func = _[mapping.remap[key] || key];
	      if (func) {
	        pairs.push([key, wrap(key, func)]);
	      }
	    });
	  });
	
	  // Convert remaining methods.
	  each(keys(_), function(key) {
	    var func = _[key];
	    if (typeof func == 'function') {
	      var length = pairs.length;
	      while (length--) {
	        if (pairs[length][0] == key) {
	          return;
	        }
	      }
	      func.convert = createConverter(key, func);
	      pairs.push([key, func]);
	    }
	  });
	
	  // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
	  each(pairs, function(pair) {
	    _[pair[0]] = pair[1];
	  });
	
	  _.convert = convertLib;
	  if (setPlaceholder) {
	    _.placeholder = placeholder;
	  }
	  // Assign aliases.
	  each(keys(_), function(key) {
	    each(mapping.realToAlias[key] || [], function(alias) {
	      _[alias] = _[key];
	    });
	  });
	
	  return _;
	}
	
	module.exports = baseConvert;


/***/ }),
/* 1433 */
/***/ (function(module, exports) {

	/** Used to map aliases to their real names. */
	exports.aliasToReal = {
	
	  // Lodash aliases.
	  'each': 'forEach',
	  'eachRight': 'forEachRight',
	  'entries': 'toPairs',
	  'entriesIn': 'toPairsIn',
	  'extend': 'assignIn',
	  'extendAll': 'assignInAll',
	  'extendAllWith': 'assignInAllWith',
	  'extendWith': 'assignInWith',
	  'first': 'head',
	
	  // Methods that are curried variants of others.
	  'conforms': 'conformsTo',
	  'matches': 'isMatch',
	  'property': 'get',
	
	  // Ramda aliases.
	  '__': 'placeholder',
	  'F': 'stubFalse',
	  'T': 'stubTrue',
	  'all': 'every',
	  'allPass': 'overEvery',
	  'always': 'constant',
	  'any': 'some',
	  'anyPass': 'overSome',
	  'apply': 'spread',
	  'assoc': 'set',
	  'assocPath': 'set',
	  'complement': 'negate',
	  'compose': 'flowRight',
	  'contains': 'includes',
	  'dissoc': 'unset',
	  'dissocPath': 'unset',
	  'dropLast': 'dropRight',
	  'dropLastWhile': 'dropRightWhile',
	  'equals': 'isEqual',
	  'identical': 'eq',
	  'indexBy': 'keyBy',
	  'init': 'initial',
	  'invertObj': 'invert',
	  'juxt': 'over',
	  'omitAll': 'omit',
	  'nAry': 'ary',
	  'path': 'get',
	  'pathEq': 'matchesProperty',
	  'pathOr': 'getOr',
	  'paths': 'at',
	  'pickAll': 'pick',
	  'pipe': 'flow',
	  'pluck': 'map',
	  'prop': 'get',
	  'propEq': 'matchesProperty',
	  'propOr': 'getOr',
	  'props': 'at',
	  'symmetricDifference': 'xor',
	  'symmetricDifferenceBy': 'xorBy',
	  'symmetricDifferenceWith': 'xorWith',
	  'takeLast': 'takeRight',
	  'takeLastWhile': 'takeRightWhile',
	  'unapply': 'rest',
	  'unnest': 'flatten',
	  'useWith': 'overArgs',
	  'where': 'conformsTo',
	  'whereEq': 'isMatch',
	  'zipObj': 'zipObject'
	};
	
	/** Used to map ary to method names. */
	exports.aryMethod = {
	  '1': [
	    'assignAll', 'assignInAll', 'attempt', 'castArray', 'ceil', 'create',
	    'curry', 'curryRight', 'defaultsAll', 'defaultsDeepAll', 'floor', 'flow',
	    'flowRight', 'fromPairs', 'invert', 'iteratee', 'memoize', 'method', 'mergeAll',
	    'methodOf', 'mixin', 'nthArg', 'over', 'overEvery', 'overSome','rest', 'reverse',
	    'round', 'runInContext', 'spread', 'template', 'trim', 'trimEnd', 'trimStart',
	    'uniqueId', 'words', 'zipAll'
	  ],
	  '2': [
	    'add', 'after', 'ary', 'assign', 'assignAllWith', 'assignIn', 'assignInAllWith',
	    'at', 'before', 'bind', 'bindAll', 'bindKey', 'chunk', 'cloneDeepWith',
	    'cloneWith', 'concat', 'conformsTo', 'countBy', 'curryN', 'curryRightN',
	    'debounce', 'defaults', 'defaultsDeep', 'defaultTo', 'delay', 'difference',
	    'divide', 'drop', 'dropRight', 'dropRightWhile', 'dropWhile', 'endsWith', 'eq',
	    'every', 'filter', 'find', 'findIndex', 'findKey', 'findLast', 'findLastIndex',
	    'findLastKey', 'flatMap', 'flatMapDeep', 'flattenDepth', 'forEach',
	    'forEachRight', 'forIn', 'forInRight', 'forOwn', 'forOwnRight', 'get',
	    'groupBy', 'gt', 'gte', 'has', 'hasIn', 'includes', 'indexOf', 'intersection',
	    'invertBy', 'invoke', 'invokeMap', 'isEqual', 'isMatch', 'join', 'keyBy',
	    'lastIndexOf', 'lt', 'lte', 'map', 'mapKeys', 'mapValues', 'matchesProperty',
	    'maxBy', 'meanBy', 'merge', 'mergeAllWith', 'minBy', 'multiply', 'nth', 'omit',
	    'omitBy', 'overArgs', 'pad', 'padEnd', 'padStart', 'parseInt', 'partial',
	    'partialRight', 'partition', 'pick', 'pickBy', 'propertyOf', 'pull', 'pullAll',
	    'pullAt', 'random', 'range', 'rangeRight', 'rearg', 'reject', 'remove',
	    'repeat', 'restFrom', 'result', 'sampleSize', 'some', 'sortBy', 'sortedIndex',
	    'sortedIndexOf', 'sortedLastIndex', 'sortedLastIndexOf', 'sortedUniqBy',
	    'split', 'spreadFrom', 'startsWith', 'subtract', 'sumBy', 'take', 'takeRight',
	    'takeRightWhile', 'takeWhile', 'tap', 'throttle', 'thru', 'times', 'trimChars',
	    'trimCharsEnd', 'trimCharsStart', 'truncate', 'union', 'uniqBy', 'uniqWith',
	    'unset', 'unzipWith', 'without', 'wrap', 'xor', 'zip', 'zipObject',
	    'zipObjectDeep'
	  ],
	  '3': [
	    'assignInWith', 'assignWith', 'clamp', 'differenceBy', 'differenceWith',
	    'findFrom', 'findIndexFrom', 'findLastFrom', 'findLastIndexFrom', 'getOr',
	    'includesFrom', 'indexOfFrom', 'inRange', 'intersectionBy', 'intersectionWith',
	    'invokeArgs', 'invokeArgsMap', 'isEqualWith', 'isMatchWith', 'flatMapDepth',
	    'lastIndexOfFrom', 'mergeWith', 'orderBy', 'padChars', 'padCharsEnd',
	    'padCharsStart', 'pullAllBy', 'pullAllWith', 'rangeStep', 'rangeStepRight',
	    'reduce', 'reduceRight', 'replace', 'set', 'slice', 'sortedIndexBy',
	    'sortedLastIndexBy', 'transform', 'unionBy', 'unionWith', 'update', 'xorBy',
	    'xorWith', 'zipWith'
	  ],
	  '4': [
	    'fill', 'setWith', 'updateWith'
	  ]
	};
	
	/** Used to map ary to rearg configs. */
	exports.aryRearg = {
	  '2': [1, 0],
	  '3': [2, 0, 1],
	  '4': [3, 2, 0, 1]
	};
	
	/** Used to map method names to their iteratee ary. */
	exports.iterateeAry = {
	  'dropRightWhile': 1,
	  'dropWhile': 1,
	  'every': 1,
	  'filter': 1,
	  'find': 1,
	  'findFrom': 1,
	  'findIndex': 1,
	  'findIndexFrom': 1,
	  'findKey': 1,
	  'findLast': 1,
	  'findLastFrom': 1,
	  'findLastIndex': 1,
	  'findLastIndexFrom': 1,
	  'findLastKey': 1,
	  'flatMap': 1,
	  'flatMapDeep': 1,
	  'flatMapDepth': 1,
	  'forEach': 1,
	  'forEachRight': 1,
	  'forIn': 1,
	  'forInRight': 1,
	  'forOwn': 1,
	  'forOwnRight': 1,
	  'map': 1,
	  'mapKeys': 1,
	  'mapValues': 1,
	  'partition': 1,
	  'reduce': 2,
	  'reduceRight': 2,
	  'reject': 1,
	  'remove': 1,
	  'some': 1,
	  'takeRightWhile': 1,
	  'takeWhile': 1,
	  'times': 1,
	  'transform': 2
	};
	
	/** Used to map method names to iteratee rearg configs. */
	exports.iterateeRearg = {
	  'mapKeys': [1],
	  'reduceRight': [1, 0]
	};
	
	/** Used to map method names to rearg configs. */
	exports.methodRearg = {
	  'assignInAllWith': [1, 0],
	  'assignInWith': [1, 2, 0],
	  'assignAllWith': [1, 0],
	  'assignWith': [1, 2, 0],
	  'differenceBy': [1, 2, 0],
	  'differenceWith': [1, 2, 0],
	  'getOr': [2, 1, 0],
	  'intersectionBy': [1, 2, 0],
	  'intersectionWith': [1, 2, 0],
	  'isEqualWith': [1, 2, 0],
	  'isMatchWith': [2, 1, 0],
	  'mergeAllWith': [1, 0],
	  'mergeWith': [1, 2, 0],
	  'padChars': [2, 1, 0],
	  'padCharsEnd': [2, 1, 0],
	  'padCharsStart': [2, 1, 0],
	  'pullAllBy': [2, 1, 0],
	  'pullAllWith': [2, 1, 0],
	  'rangeStep': [1, 2, 0],
	  'rangeStepRight': [1, 2, 0],
	  'setWith': [3, 1, 2, 0],
	  'sortedIndexBy': [2, 1, 0],
	  'sortedLastIndexBy': [2, 1, 0],
	  'unionBy': [1, 2, 0],
	  'unionWith': [1, 2, 0],
	  'updateWith': [3, 1, 2, 0],
	  'xorBy': [1, 2, 0],
	  'xorWith': [1, 2, 0],
	  'zipWith': [1, 2, 0]
	};
	
	/** Used to map method names to spread configs. */
	exports.methodSpread = {
	  'assignAll': { 'start': 0 },
	  'assignAllWith': { 'start': 0 },
	  'assignInAll': { 'start': 0 },
	  'assignInAllWith': { 'start': 0 },
	  'defaultsAll': { 'start': 0 },
	  'defaultsDeepAll': { 'start': 0 },
	  'invokeArgs': { 'start': 2 },
	  'invokeArgsMap': { 'start': 2 },
	  'mergeAll': { 'start': 0 },
	  'mergeAllWith': { 'start': 0 },
	  'partial': { 'start': 1 },
	  'partialRight': { 'start': 1 },
	  'without': { 'start': 1 },
	  'zipAll': { 'start': 0 }
	};
	
	/** Used to identify methods which mutate arrays or objects. */
	exports.mutate = {
	  'array': {
	    'fill': true,
	    'pull': true,
	    'pullAll': true,
	    'pullAllBy': true,
	    'pullAllWith': true,
	    'pullAt': true,
	    'remove': true,
	    'reverse': true
	  },
	  'object': {
	    'assign': true,
	    'assignAll': true,
	    'assignAllWith': true,
	    'assignIn': true,
	    'assignInAll': true,
	    'assignInAllWith': true,
	    'assignInWith': true,
	    'assignWith': true,
	    'defaults': true,
	    'defaultsAll': true,
	    'defaultsDeep': true,
	    'defaultsDeepAll': true,
	    'merge': true,
	    'mergeAll': true,
	    'mergeAllWith': true,
	    'mergeWith': true,
	  },
	  'set': {
	    'set': true,
	    'setWith': true,
	    'unset': true,
	    'update': true,
	    'updateWith': true
	  }
	};
	
	/** Used to track methods with placeholder support */
	exports.placeholder = {
	  'bind': true,
	  'bindKey': true,
	  'curry': true,
	  'curryRight': true,
	  'partial': true,
	  'partialRight': true
	};
	
	/** Used to map real names to their aliases. */
	exports.realToAlias = (function() {
	  var hasOwnProperty = Object.prototype.hasOwnProperty,
	      object = exports.aliasToReal,
	      result = {};
	
	  for (var key in object) {
	    var value = object[key];
	    if (hasOwnProperty.call(result, value)) {
	      result[value].push(key);
	    } else {
	      result[value] = [key];
	    }
	  }
	  return result;
	}());
	
	/** Used to map method names to other names. */
	exports.remap = {
	  'assignAll': 'assign',
	  'assignAllWith': 'assignWith',
	  'assignInAll': 'assignIn',
	  'assignInAllWith': 'assignInWith',
	  'curryN': 'curry',
	  'curryRightN': 'curryRight',
	  'defaultsAll': 'defaults',
	  'defaultsDeepAll': 'defaultsDeep',
	  'findFrom': 'find',
	  'findIndexFrom': 'findIndex',
	  'findLastFrom': 'findLast',
	  'findLastIndexFrom': 'findLastIndex',
	  'getOr': 'get',
	  'includesFrom': 'includes',
	  'indexOfFrom': 'indexOf',
	  'invokeArgs': 'invoke',
	  'invokeArgsMap': 'invokeMap',
	  'lastIndexOfFrom': 'lastIndexOf',
	  'mergeAll': 'merge',
	  'mergeAllWith': 'mergeWith',
	  'padChars': 'pad',
	  'padCharsEnd': 'padEnd',
	  'padCharsStart': 'padStart',
	  'propertyOf': 'get',
	  'rangeStep': 'range',
	  'rangeStepRight': 'rangeRight',
	  'restFrom': 'rest',
	  'spreadFrom': 'spread',
	  'trimChars': 'trim',
	  'trimCharsEnd': 'trimEnd',
	  'trimCharsStart': 'trimStart',
	  'zipAll': 'zip'
	};
	
	/** Used to track methods that skip fixing their arity. */
	exports.skipFixed = {
	  'castArray': true,
	  'flow': true,
	  'flowRight': true,
	  'iteratee': true,
	  'mixin': true,
	  'rearg': true,
	  'runInContext': true
	};
	
	/** Used to track methods that skip rearranging arguments. */
	exports.skipRearg = {
	  'add': true,
	  'assign': true,
	  'assignIn': true,
	  'bind': true,
	  'bindKey': true,
	  'concat': true,
	  'difference': true,
	  'divide': true,
	  'eq': true,
	  'gt': true,
	  'gte': true,
	  'isEqual': true,
	  'lt': true,
	  'lte': true,
	  'matchesProperty': true,
	  'merge': true,
	  'multiply': true,
	  'overArgs': true,
	  'partial': true,
	  'partialRight': true,
	  'propertyOf': true,
	  'random': true,
	  'range': true,
	  'rangeRight': true,
	  'subtract': true,
	  'zip': true,
	  'zipObject': true,
	  'zipObjectDeep': true
	};


/***/ }),
/* 1434 */
/***/ (function(module, exports) {

	/**
	 * The default argument placeholder value for methods.
	 *
	 * @type {Object}
	 */
	module.exports = {};


/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(378),
	    baseIntersection = __webpack_require__(1380),
	    baseRest = __webpack_require__(185),
	    castArrayLikeObject = __webpack_require__(1389);
	
	/**
	 * Creates an array of unique values that are included in all given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. The order and references of result values are
	 * determined by the first array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of intersecting values.
	 * @example
	 *
	 * _.intersection([2, 1], [2, 3]);
	 * // => [2]
	 */
	var intersection = baseRest(function(arrays) {
	  var mapped = arrayMap(arrays, castArrayLikeObject);
	  return (mapped.length && mapped[0] === arrays[0])
	    ? baseIntersection(mapped)
	    : [];
	});
	
	module.exports = intersection;


/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(217),
	    stubFalse = __webpack_require__(1441);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(209)(module)))

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(1384),
	    baseUnary = __webpack_require__(379),
	    nodeUtil = __webpack_require__(1419);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(1375),
	    baseKeysIn = __webpack_require__(1385),
	    isArrayLike = __webpack_require__(381);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash lodash.com/license | Underscore.js 1.8.3 underscorejs.org/LICENSE
	 */
	;(function(){function n(n,t){return n.set(t[0],t[1]),n}function t(n,t){return n.add(t),n}function r(n,t,r){switch(r.length){case 0:return n.call(t);case 1:return n.call(t,r[0]);case 2:return n.call(t,r[0],r[1]);case 3:return n.call(t,r[0],r[1],r[2])}return n.apply(t,r)}function e(n,t,r,e){for(var u=-1,i=null==n?0:n.length;++u<i;){var o=n[u];t(e,o,r(o),n)}return e}function u(n,t){for(var r=-1,e=null==n?0:n.length;++r<e&&false!==t(n[r],r,n););return n}function i(n,t){for(var r=null==n?0:n.length;r--&&false!==t(n[r],r,n););
	return n}function o(n,t){for(var r=-1,e=null==n?0:n.length;++r<e;)if(!t(n[r],r,n))return false;return true}function f(n,t){for(var r=-1,e=null==n?0:n.length,u=0,i=[];++r<e;){var o=n[r];t(o,r,n)&&(i[u++]=o)}return i}function c(n,t){return!(null==n||!n.length)&&-1<d(n,t,0)}function a(n,t,r){for(var e=-1,u=null==n?0:n.length;++e<u;)if(r(t,n[e]))return true;return false}function l(n,t){for(var r=-1,e=null==n?0:n.length,u=Array(e);++r<e;)u[r]=t(n[r],r,n);return u}function s(n,t){for(var r=-1,e=t.length,u=n.length;++r<e;)n[u+r]=t[r];
	return n}function h(n,t,r,e){var u=-1,i=null==n?0:n.length;for(e&&i&&(r=n[++u]);++u<i;)r=t(r,n[u],u,n);return r}function p(n,t,r,e){var u=null==n?0:n.length;for(e&&u&&(r=n[--u]);u--;)r=t(r,n[u],u,n);return r}function _(n,t){for(var r=-1,e=null==n?0:n.length;++r<e;)if(t(n[r],r,n))return true;return false}function v(n,t,r){var e;return r(n,function(n,r,u){if(t(n,r,u))return e=r,false}),e}function g(n,t,r,e){var u=n.length;for(r+=e?1:-1;e?r--:++r<u;)if(t(n[r],r,n))return r;return-1}function d(n,t,r){if(t===t)n:{
	--r;for(var e=n.length;++r<e;)if(n[r]===t){n=r;break n}n=-1}else n=g(n,b,r);return n}function y(n,t,r,e){--r;for(var u=n.length;++r<u;)if(e(n[r],t))return r;return-1}function b(n){return n!==n}function x(n,t){var r=null==n?0:n.length;return r?k(n,t)/r:P}function j(n){return function(t){return null==t?F:t[n]}}function w(n){return function(t){return null==n?F:n[t]}}function m(n,t,r,e,u){return u(n,function(n,u,i){r=e?(e=false,n):t(r,n,u,i)}),r}function A(n,t){var r=n.length;for(n.sort(t);r--;)n[r]=n[r].c;
	return n}function k(n,t){for(var r,e=-1,u=n.length;++e<u;){var i=t(n[e]);i!==F&&(r=r===F?i:r+i)}return r}function E(n,t){for(var r=-1,e=Array(n);++r<n;)e[r]=t(r);return e}function O(n,t){return l(t,function(t){return[t,n[t]]})}function S(n){return function(t){return n(t)}}function I(n,t){return l(t,function(t){return n[t]})}function R(n,t){return n.has(t)}function z(n,t){for(var r=-1,e=n.length;++r<e&&-1<d(t,n[r],0););return r}function W(n,t){for(var r=n.length;r--&&-1<d(t,n[r],0););return r}function B(n){
	return"\\"+Tn[n]}function L(n){var t=-1,r=Array(n.size);return n.forEach(function(n,e){r[++t]=[e,n]}),r}function U(n,t){return function(r){return n(t(r))}}function C(n,t){for(var r=-1,e=n.length,u=0,i=[];++r<e;){var o=n[r];o!==t&&"__lodash_placeholder__"!==o||(n[r]="__lodash_placeholder__",i[u++]=r)}return i}function D(n){var t=-1,r=Array(n.size);return n.forEach(function(n){r[++t]=n}),r}function M(n){var t=-1,r=Array(n.size);return n.forEach(function(n){r[++t]=[n,n]}),r}function T(n){if(Bn.test(n)){
	for(var t=zn.lastIndex=0;zn.test(n);)++t;n=t}else n=tt(n);return n}function $(n){return Bn.test(n)?n.match(zn)||[]:n.split("")}var F,N=1/0,P=NaN,Z=[["ary",128],["bind",1],["bindKey",2],["curry",8],["curryRight",16],["flip",512],["partial",32],["partialRight",64],["rearg",256]],q=/\b__p\+='';/g,V=/\b(__p\+=)''\+/g,K=/(__e\(.*?\)|\b__t\))\+'';/g,G=/&(?:amp|lt|gt|quot|#39);/g,H=/[&<>"']/g,J=RegExp(G.source),Y=RegExp(H.source),Q=/<%-([\s\S]+?)%>/g,X=/<%([\s\S]+?)%>/g,nn=/<%=([\s\S]+?)%>/g,tn=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,rn=/^\w*$/,en=/^\./,un=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,on=/[\\^$.*+?()[\]{}|]/g,fn=RegExp(on.source),cn=/^\s+|\s+$/g,an=/^\s+/,ln=/\s+$/,sn=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,hn=/\{\n\/\* \[wrapped with (.+)\] \*/,pn=/,? & /,_n=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,vn=/\\(\\)?/g,gn=/\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,dn=/\w*$/,yn=/^[-+]0x[0-9a-f]+$/i,bn=/^0b[01]+$/i,xn=/^\[object .+?Constructor\]$/,jn=/^0o[0-7]+$/i,wn=/^(?:0|[1-9]\d*)$/,mn=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,An=/($^)/,kn=/['\n\r\u2028\u2029\\]/g,En="[\\ufe0e\\ufe0f]?(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?(?:\\u200d(?:[^\\ud800-\\udfff]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff])[\\ufe0e\\ufe0f]?(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?)*",On="(?:[\\u2700-\\u27bf]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff])"+En,Sn="(?:[^\\ud800-\\udfff][\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]?|[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff]|[\\ud800-\\udfff])",In=RegExp("['\u2019]","g"),Rn=RegExp("[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]","g"),zn=RegExp("\\ud83c[\\udffb-\\udfff](?=\\ud83c[\\udffb-\\udfff])|"+Sn+En,"g"),Wn=RegExp(["[A-Z\\xc0-\\xd6\\xd8-\\xde]?[a-z\\xdf-\\xf6\\xf8-\\xff]+(?:['\u2019](?:d|ll|m|re|s|t|ve))?(?=[\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000]|[A-Z\\xc0-\\xd6\\xd8-\\xde]|$)|(?:[A-Z\\xc0-\\xd6\\xd8-\\xde]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])+(?:['\u2019](?:D|LL|M|RE|S|T|VE))?(?=[\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000]|[A-Z\\xc0-\\xd6\\xd8-\\xde](?:[a-z\\xdf-\\xf6\\xf8-\\xff]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])|$)|[A-Z\\xc0-\\xd6\\xd8-\\xde]?(?:[a-z\\xdf-\\xf6\\xf8-\\xff]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])+(?:['\u2019](?:d|ll|m|re|s|t|ve))?|[A-Z\\xc0-\\xd6\\xd8-\\xde]+(?:['\u2019](?:D|LL|M|RE|S|T|VE))?|\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)|\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)|\\d+",On].join("|"),"g"),Bn=RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]"),Ln=/[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,Un="Array Buffer DataView Date Error Float32Array Float64Array Function Int8Array Int16Array Int32Array Map Math Object Promise RegExp Set String Symbol TypeError Uint8Array Uint8ClampedArray Uint16Array Uint32Array WeakMap _ clearTimeout isFinite parseInt setTimeout".split(" "),Cn={};
	Cn["[object Float32Array]"]=Cn["[object Float64Array]"]=Cn["[object Int8Array]"]=Cn["[object Int16Array]"]=Cn["[object Int32Array]"]=Cn["[object Uint8Array]"]=Cn["[object Uint8ClampedArray]"]=Cn["[object Uint16Array]"]=Cn["[object Uint32Array]"]=true,Cn["[object Arguments]"]=Cn["[object Array]"]=Cn["[object ArrayBuffer]"]=Cn["[object Boolean]"]=Cn["[object DataView]"]=Cn["[object Date]"]=Cn["[object Error]"]=Cn["[object Function]"]=Cn["[object Map]"]=Cn["[object Number]"]=Cn["[object Object]"]=Cn["[object RegExp]"]=Cn["[object Set]"]=Cn["[object String]"]=Cn["[object WeakMap]"]=false;
	var Dn={};Dn["[object Arguments]"]=Dn["[object Array]"]=Dn["[object ArrayBuffer]"]=Dn["[object DataView]"]=Dn["[object Boolean]"]=Dn["[object Date]"]=Dn["[object Float32Array]"]=Dn["[object Float64Array]"]=Dn["[object Int8Array]"]=Dn["[object Int16Array]"]=Dn["[object Int32Array]"]=Dn["[object Map]"]=Dn["[object Number]"]=Dn["[object Object]"]=Dn["[object RegExp]"]=Dn["[object Set]"]=Dn["[object String]"]=Dn["[object Symbol]"]=Dn["[object Uint8Array]"]=Dn["[object Uint8ClampedArray]"]=Dn["[object Uint16Array]"]=Dn["[object Uint32Array]"]=true,
	Dn["[object Error]"]=Dn["[object Function]"]=Dn["[object WeakMap]"]=false;var Mn,Tn={"\\":"\\","'":"'","\n":"n","\r":"r","\u2028":"u2028","\u2029":"u2029"},$n=parseFloat,Fn=parseInt,Nn=typeof global=="object"&&global&&global.Object===Object&&global,Pn=typeof self=="object"&&self&&self.Object===Object&&self,Zn=Nn||Pn||Function("return this")(),qn=typeof exports=="object"&&exports&&!exports.nodeType&&exports,Vn=qn&&typeof module=="object"&&module&&!module.nodeType&&module,Kn=Vn&&Vn.exports===qn,Gn=Kn&&Nn.process;
	n:{try{Mn=Gn&&Gn.binding&&Gn.binding("util");break n}catch(n){}Mn=void 0}var Hn=Mn&&Mn.isArrayBuffer,Jn=Mn&&Mn.isDate,Yn=Mn&&Mn.isMap,Qn=Mn&&Mn.isRegExp,Xn=Mn&&Mn.isSet,nt=Mn&&Mn.isTypedArray,tt=j("length"),rt=w({"\xc0":"A","\xc1":"A","\xc2":"A","\xc3":"A","\xc4":"A","\xc5":"A","\xe0":"a","\xe1":"a","\xe2":"a","\xe3":"a","\xe4":"a","\xe5":"a","\xc7":"C","\xe7":"c","\xd0":"D","\xf0":"d","\xc8":"E","\xc9":"E","\xca":"E","\xcb":"E","\xe8":"e","\xe9":"e","\xea":"e","\xeb":"e","\xcc":"I","\xcd":"I","\xce":"I",
	"\xcf":"I","\xec":"i","\xed":"i","\xee":"i","\xef":"i","\xd1":"N","\xf1":"n","\xd2":"O","\xd3":"O","\xd4":"O","\xd5":"O","\xd6":"O","\xd8":"O","\xf2":"o","\xf3":"o","\xf4":"o","\xf5":"o","\xf6":"o","\xf8":"o","\xd9":"U","\xda":"U","\xdb":"U","\xdc":"U","\xf9":"u","\xfa":"u","\xfb":"u","\xfc":"u","\xdd":"Y","\xfd":"y","\xff":"y","\xc6":"Ae","\xe6":"ae","\xde":"Th","\xfe":"th","\xdf":"ss","\u0100":"A","\u0102":"A","\u0104":"A","\u0101":"a","\u0103":"a","\u0105":"a","\u0106":"C","\u0108":"C","\u010a":"C",
	"\u010c":"C","\u0107":"c","\u0109":"c","\u010b":"c","\u010d":"c","\u010e":"D","\u0110":"D","\u010f":"d","\u0111":"d","\u0112":"E","\u0114":"E","\u0116":"E","\u0118":"E","\u011a":"E","\u0113":"e","\u0115":"e","\u0117":"e","\u0119":"e","\u011b":"e","\u011c":"G","\u011e":"G","\u0120":"G","\u0122":"G","\u011d":"g","\u011f":"g","\u0121":"g","\u0123":"g","\u0124":"H","\u0126":"H","\u0125":"h","\u0127":"h","\u0128":"I","\u012a":"I","\u012c":"I","\u012e":"I","\u0130":"I","\u0129":"i","\u012b":"i","\u012d":"i",
	"\u012f":"i","\u0131":"i","\u0134":"J","\u0135":"j","\u0136":"K","\u0137":"k","\u0138":"k","\u0139":"L","\u013b":"L","\u013d":"L","\u013f":"L","\u0141":"L","\u013a":"l","\u013c":"l","\u013e":"l","\u0140":"l","\u0142":"l","\u0143":"N","\u0145":"N","\u0147":"N","\u014a":"N","\u0144":"n","\u0146":"n","\u0148":"n","\u014b":"n","\u014c":"O","\u014e":"O","\u0150":"O","\u014d":"o","\u014f":"o","\u0151":"o","\u0154":"R","\u0156":"R","\u0158":"R","\u0155":"r","\u0157":"r","\u0159":"r","\u015a":"S","\u015c":"S",
	"\u015e":"S","\u0160":"S","\u015b":"s","\u015d":"s","\u015f":"s","\u0161":"s","\u0162":"T","\u0164":"T","\u0166":"T","\u0163":"t","\u0165":"t","\u0167":"t","\u0168":"U","\u016a":"U","\u016c":"U","\u016e":"U","\u0170":"U","\u0172":"U","\u0169":"u","\u016b":"u","\u016d":"u","\u016f":"u","\u0171":"u","\u0173":"u","\u0174":"W","\u0175":"w","\u0176":"Y","\u0177":"y","\u0178":"Y","\u0179":"Z","\u017b":"Z","\u017d":"Z","\u017a":"z","\u017c":"z","\u017e":"z","\u0132":"IJ","\u0133":"ij","\u0152":"Oe","\u0153":"oe",
	"\u0149":"'n","\u017f":"s"}),et=w({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}),ut=w({"&amp;":"&","&lt;":"<","&gt;":">","&quot;":'"',"&#39;":"'"}),it=function w(En){function On(n){if(xu(n)&&!af(n)&&!(n instanceof Mn)){if(n instanceof zn)return n;if(ci.call(n,"__wrapped__"))return Pe(n)}return new zn(n)}function Sn(){}function zn(n,t){this.__wrapped__=n,this.__actions__=[],this.__chain__=!!t,this.__index__=0,this.__values__=F}function Mn(n){this.__wrapped__=n,this.__actions__=[],this.__dir__=1,
	this.__filtered__=false,this.__iteratees__=[],this.__takeCount__=4294967295,this.__views__=[]}function Tn(n){var t=-1,r=null==n?0:n.length;for(this.clear();++t<r;){var e=n[t];this.set(e[0],e[1])}}function Nn(n){var t=-1,r=null==n?0:n.length;for(this.clear();++t<r;){var e=n[t];this.set(e[0],e[1])}}function Pn(n){var t=-1,r=null==n?0:n.length;for(this.clear();++t<r;){var e=n[t];this.set(e[0],e[1])}}function qn(n){var t=-1,r=null==n?0:n.length;for(this.__data__=new Pn;++t<r;)this.add(n[t])}function Vn(n){
	this.size=(this.__data__=new Nn(n)).size}function Gn(n,t){var r,e=af(n),u=!e&&cf(n),i=!e&&!u&&sf(n),o=!e&&!u&&!i&&gf(n),u=(e=e||u||i||o)?E(n.length,ri):[],f=u.length;for(r in n)!t&&!ci.call(n,r)||e&&("length"==r||i&&("offset"==r||"parent"==r)||o&&("buffer"==r||"byteLength"==r||"byteOffset"==r)||Re(r,f))||u.push(r);return u}function tt(n){var t=n.length;return t?n[cr(0,t-1)]:F}function ot(n,t){return Te(Mr(n),gt(t,0,n.length))}function ft(n){return Te(Mr(n))}function ct(n,t,r){(r===F||hu(n[t],r))&&(r!==F||t in n)||_t(n,t,r);
	}function at(n,t,r){var e=n[t];ci.call(n,t)&&hu(e,r)&&(r!==F||t in n)||_t(n,t,r)}function lt(n,t){for(var r=n.length;r--;)if(hu(n[r][0],t))return r;return-1}function st(n,t,r,e){return oo(n,function(n,u,i){t(e,n,r(n),i)}),e}function ht(n,t){return n&&Tr(t,Lu(t),n)}function pt(n,t){return n&&Tr(t,Uu(t),n)}function _t(n,t,r){"__proto__"==t&&Ei?Ei(n,t,{configurable:true,enumerable:true,value:r,writable:true}):n[t]=r}function vt(n,t){for(var r=-1,e=t.length,u=Hu(e),i=null==n;++r<e;)u[r]=i?F:Wu(n,t[r]);return u;
	}function gt(n,t,r){return n===n&&(r!==F&&(n=n<=r?n:r),t!==F&&(n=n>=t?n:t)),n}function dt(n,t,r,e,i,o){var f,c=1&t,a=2&t,l=4&t;if(r&&(f=i?r(n,e,i,o):r(n)),f!==F)return f;if(!bu(n))return n;if(e=af(n)){if(f=Ee(n),!c)return Mr(n,f)}else{var s=yo(n),h="[object Function]"==s||"[object GeneratorFunction]"==s;if(sf(n))return Wr(n,c);if("[object Object]"==s||"[object Arguments]"==s||h&&!i){if(f=a||h?{}:Oe(n),!c)return a?Fr(n,pt(f,n)):$r(n,ht(f,n))}else{if(!Dn[s])return i?n:{};f=Se(n,s,dt,c)}}if(o||(o=new Vn),
	i=o.get(n))return i;o.set(n,f);var a=l?a?ye:de:a?Uu:Lu,p=e?F:a(n);return u(p||n,function(e,u){p&&(u=e,e=n[u]),at(f,u,dt(e,t,r,u,n,o))}),f}function yt(n){var t=Lu(n);return function(r){return bt(r,n,t)}}function bt(n,t,r){var e=r.length;if(null==n)return!e;for(n=ni(n);e--;){var u=r[e],i=t[u],o=n[u];if(o===F&&!(u in n)||!i(o))return false}return true}function xt(n,t,r){if(typeof n!="function")throw new ei("Expected a function");return jo(function(){n.apply(F,r)},t)}function jt(n,t,r,e){var u=-1,i=c,o=true,f=n.length,s=[],h=t.length;
	if(!f)return s;r&&(t=l(t,S(r))),e?(i=a,o=false):200<=t.length&&(i=R,o=false,t=new qn(t));n:for(;++u<f;){var p=n[u],_=null==r?p:r(p),p=e||0!==p?p:0;if(o&&_===_){for(var v=h;v--;)if(t[v]===_)continue n;s.push(p)}else i(t,_,e)||s.push(p)}return s}function wt(n,t){var r=true;return oo(n,function(n,e,u){return r=!!t(n,e,u)}),r}function mt(n,t,r){for(var e=-1,u=n.length;++e<u;){var i=n[e],o=t(i);if(null!=o&&(f===F?o===o&&!Au(o):r(o,f)))var f=o,c=i}return c}function At(n,t){var r=[];return oo(n,function(n,e,u){
	t(n,e,u)&&r.push(n)}),r}function kt(n,t,r,e,u){var i=-1,o=n.length;for(r||(r=Ie),u||(u=[]);++i<o;){var f=n[i];0<t&&r(f)?1<t?kt(f,t-1,r,e,u):s(u,f):e||(u[u.length]=f)}return u}function Et(n,t){return n&&co(n,t,Lu)}function Ot(n,t){return n&&ao(n,t,Lu)}function St(n,t){return f(t,function(t){return gu(n[t])})}function It(n,t){t=Rr(t,n);for(var r=0,e=t.length;null!=n&&r<e;)n=n[$e(t[r++])];return r&&r==e?n:F}function Rt(n,t,r){return t=t(n),af(n)?t:s(t,r(n))}function zt(n){if(null==n)n=n===F?"[object Undefined]":"[object Null]";else if(ki&&ki in ni(n)){
	var t=ci.call(n,ki),r=n[ki];try{n[ki]=F;var e=true}catch(n){}var u=si.call(n);e&&(t?n[ki]=r:delete n[ki]),n=u}else n=si.call(n);return n}function Wt(n,t){return n>t}function Bt(n,t){return null!=n&&ci.call(n,t)}function Lt(n,t){return null!=n&&t in ni(n)}function Ut(n,t,r){for(var e=r?a:c,u=n[0].length,i=n.length,o=i,f=Hu(i),s=1/0,h=[];o--;){var p=n[o];o&&t&&(p=l(p,S(t))),s=Mi(p.length,s),f[o]=!r&&(t||120<=u&&120<=p.length)?new qn(o&&p):F}var p=n[0],_=-1,v=f[0];n:for(;++_<u&&h.length<s;){var g=p[_],d=t?t(g):g,g=r||0!==g?g:0;
	if(v?!R(v,d):!e(h,d,r)){for(o=i;--o;){var y=f[o];if(y?!R(y,d):!e(n[o],d,r))continue n}v&&v.push(d),h.push(g)}}return h}function Ct(n,t,r){var e={};return Et(n,function(n,u,i){t(e,r(n),u,i)}),e}function Dt(n,t,e){return t=Rr(t,n),n=2>t.length?n:It(n,vr(t,0,-1)),t=null==n?n:n[$e(Ge(t))],null==t?F:r(t,n,e)}function Mt(n){return xu(n)&&"[object Arguments]"==zt(n)}function Tt(n){return xu(n)&&"[object ArrayBuffer]"==zt(n)}function $t(n){return xu(n)&&"[object Date]"==zt(n)}function Ft(n,t,r,e,u){if(n===t)t=true;else if(null==n||null==t||!xu(n)&&!xu(t))t=n!==n&&t!==t;else n:{
	var i=af(n),o=af(t),f=i?"[object Array]":yo(n),c=o?"[object Array]":yo(t),f="[object Arguments]"==f?"[object Object]":f,c="[object Arguments]"==c?"[object Object]":c,a="[object Object]"==f,o="[object Object]"==c;if((c=f==c)&&sf(n)){if(!sf(t)){t=false;break n}i=true,a=false}if(c&&!a)u||(u=new Vn),t=i||gf(n)?_e(n,t,r,e,Ft,u):ve(n,t,f,r,e,Ft,u);else{if(!(1&r)&&(i=a&&ci.call(n,"__wrapped__"),f=o&&ci.call(t,"__wrapped__"),i||f)){n=i?n.value():n,t=f?t.value():t,u||(u=new Vn),t=Ft(n,t,r,e,u);break n}if(c)t:if(u||(u=new Vn),
	i=1&r,f=de(n),o=f.length,c=de(t).length,o==c||i){for(a=o;a--;){var l=f[a];if(!(i?l in t:ci.call(t,l))){t=false;break t}}if((c=u.get(n))&&u.get(t))t=c==t;else{c=true,u.set(n,t),u.set(t,n);for(var s=i;++a<o;){var l=f[a],h=n[l],p=t[l];if(e)var _=i?e(p,h,l,t,n,u):e(h,p,l,n,t,u);if(_===F?h!==p&&!Ft(h,p,r,e,u):!_){c=false;break}s||(s="constructor"==l)}c&&!s&&(r=n.constructor,e=t.constructor,r!=e&&"constructor"in n&&"constructor"in t&&!(typeof r=="function"&&r instanceof r&&typeof e=="function"&&e instanceof e)&&(c=false)),
	u.delete(n),u.delete(t),t=c}}else t=false;else t=false}}return t}function Nt(n){return xu(n)&&"[object Map]"==yo(n)}function Pt(n,t,r,e){var u=r.length,i=u,o=!e;if(null==n)return!i;for(n=ni(n);u--;){var f=r[u];if(o&&f[2]?f[1]!==n[f[0]]:!(f[0]in n))return false}for(;++u<i;){var f=r[u],c=f[0],a=n[c],l=f[1];if(o&&f[2]){if(a===F&&!(c in n))return false}else{if(f=new Vn,e)var s=e(a,l,c,n,t,f);if(s===F?!Ft(l,a,3,e,f):!s)return false}}return true}function Zt(n){return!(!bu(n)||li&&li in n)&&(gu(n)?_i:xn).test(Fe(n))}function qt(n){
	return xu(n)&&"[object RegExp]"==zt(n)}function Vt(n){return xu(n)&&"[object Set]"==yo(n)}function Kt(n){return xu(n)&&yu(n.length)&&!!Cn[zt(n)]}function Gt(n){return typeof n=="function"?n:null==n?Nu:typeof n=="object"?af(n)?Xt(n[0],n[1]):Qt(n):Vu(n)}function Ht(n){if(!Le(n))return Ci(n);var t,r=[];for(t in ni(n))ci.call(n,t)&&"constructor"!=t&&r.push(t);return r}function Jt(n,t){return n<t}function Yt(n,t){var r=-1,e=pu(n)?Hu(n.length):[];return oo(n,function(n,u,i){e[++r]=t(n,u,i)}),e}function Qt(n){
	var t=me(n);return 1==t.length&&t[0][2]?Ue(t[0][0],t[0][1]):function(r){return r===n||Pt(r,n,t)}}function Xt(n,t){return We(n)&&t===t&&!bu(t)?Ue($e(n),t):function(r){var e=Wu(r,n);return e===F&&e===t?Bu(r,n):Ft(t,e,3)}}function nr(n,t,r,e,u){n!==t&&co(t,function(i,o){if(bu(i)){u||(u=new Vn);var f=u,c=n[o],a=t[o],l=f.get(a);if(l)ct(n,o,l);else{var l=e?e(c,a,o+"",n,t,f):F,s=l===F;if(s){var h=af(a),p=!h&&sf(a),_=!h&&!p&&gf(a),l=a;h||p||_?af(c)?l=c:_u(c)?l=Mr(c):p?(s=false,l=Wr(a,true)):_?(s=false,l=Lr(a,true)):l=[]:wu(a)||cf(a)?(l=c,
	cf(c)?l=Ru(c):(!bu(c)||r&&gu(c))&&(l=Oe(a))):s=false}s&&(f.set(a,l),nr(l,a,r,e,f),f.delete(a)),ct(n,o,l)}}else f=e?e(n[o],i,o+"",n,t,u):F,f===F&&(f=i),ct(n,o,f)},Uu)}function tr(n,t){var r=n.length;if(r)return t+=0>t?r:0,Re(t,r)?n[t]:F}function rr(n,t,r){var e=-1;return t=l(t.length?t:[Nu],S(je())),n=Yt(n,function(n){return{a:l(t,function(t){return t(n)}),b:++e,c:n}}),A(n,function(n,t){var e;n:{e=-1;for(var u=n.a,i=t.a,o=u.length,f=r.length;++e<o;){var c=Ur(u[e],i[e]);if(c){e=e>=f?c:c*("desc"==r[e]?-1:1);
	break n}}e=n.b-t.b}return e})}function er(n,t){return ur(n,t,function(t,r){return Bu(n,r)})}function ur(n,t,r){for(var e=-1,u=t.length,i={};++e<u;){var o=t[e],f=It(n,o);r(f,o)&&pr(i,Rr(o,n),f)}return i}function ir(n){return function(t){return It(t,n)}}function or(n,t,r,e){var u=e?y:d,i=-1,o=t.length,f=n;for(n===t&&(t=Mr(t)),r&&(f=l(n,S(r)));++i<o;)for(var c=0,a=t[i],a=r?r(a):a;-1<(c=u(f,a,c,e));)f!==n&&wi.call(f,c,1),wi.call(n,c,1);return n}function fr(n,t){for(var r=n?t.length:0,e=r-1;r--;){var u=t[r];
	if(r==e||u!==i){var i=u;Re(u)?wi.call(n,u,1):mr(n,u)}}}function cr(n,t){return n+zi(Fi()*(t-n+1))}function ar(n,t){var r="";if(!n||1>t||9007199254740991<t)return r;do t%2&&(r+=n),(t=zi(t/2))&&(n+=n);while(t);return r}function lr(n,t){return wo(Ce(n,t,Nu),n+"")}function sr(n){return tt(Du(n))}function hr(n,t){var r=Du(n);return Te(r,gt(t,0,r.length))}function pr(n,t,r,e){if(!bu(n))return n;t=Rr(t,n);for(var u=-1,i=t.length,o=i-1,f=n;null!=f&&++u<i;){var c=$e(t[u]),a=r;if(u!=o){var l=f[c],a=e?e(l,c,f):F;
	a===F&&(a=bu(l)?l:Re(t[u+1])?[]:{})}at(f,c,a),f=f[c]}return n}function _r(n){return Te(Du(n))}function vr(n,t,r){var e=-1,u=n.length;for(0>t&&(t=-t>u?0:u+t),r=r>u?u:r,0>r&&(r+=u),u=t>r?0:r-t>>>0,t>>>=0,r=Hu(u);++e<u;)r[e]=n[e+t];return r}function gr(n,t){var r;return oo(n,function(n,e,u){return r=t(n,e,u),!r}),!!r}function dr(n,t,r){var e=0,u=null==n?e:n.length;if(typeof t=="number"&&t===t&&2147483647>=u){for(;e<u;){var i=e+u>>>1,o=n[i];null!==o&&!Au(o)&&(r?o<=t:o<t)?e=i+1:u=i}return u}return yr(n,t,Nu,r);
	}function yr(n,t,r,e){t=r(t);for(var u=0,i=null==n?0:n.length,o=t!==t,f=null===t,c=Au(t),a=t===F;u<i;){var l=zi((u+i)/2),s=r(n[l]),h=s!==F,p=null===s,_=s===s,v=Au(s);(o?e||_:a?_&&(e||h):f?_&&h&&(e||!p):c?_&&h&&!p&&(e||!v):p||v?0:e?s<=t:s<t)?u=l+1:i=l}return Mi(i,4294967294)}function br(n,t){for(var r=-1,e=n.length,u=0,i=[];++r<e;){var o=n[r],f=t?t(o):o;if(!r||!hu(f,c)){var c=f;i[u++]=0===o?0:o}}return i}function xr(n){return typeof n=="number"?n:Au(n)?P:+n}function jr(n){if(typeof n=="string")return n;
	if(af(n))return l(n,jr)+"";if(Au(n))return uo?uo.call(n):"";var t=n+"";return"0"==t&&1/n==-N?"-0":t}function wr(n,t,r){var e=-1,u=c,i=n.length,o=true,f=[],l=f;if(r)o=false,u=a;else if(200<=i){if(u=t?null:po(n))return D(u);o=false,u=R,l=new qn}else l=t?[]:f;n:for(;++e<i;){var s=n[e],h=t?t(s):s,s=r||0!==s?s:0;if(o&&h===h){for(var p=l.length;p--;)if(l[p]===h)continue n;t&&l.push(h),f.push(s)}else u(l,h,r)||(l!==f&&l.push(h),f.push(s))}return f}function mr(n,t){return t=Rr(t,n),n=2>t.length?n:It(n,vr(t,0,-1)),
	null==n||delete n[$e(Ge(t))]}function Ar(n,t,r,e){for(var u=n.length,i=e?u:-1;(e?i--:++i<u)&&t(n[i],i,n););return r?vr(n,e?0:i,e?i+1:u):vr(n,e?i+1:0,e?u:i)}function kr(n,t){var r=n;return r instanceof Mn&&(r=r.value()),h(t,function(n,t){return t.func.apply(t.thisArg,s([n],t.args))},r)}function Er(n,t,r){var e=n.length;if(2>e)return e?wr(n[0]):[];for(var u=-1,i=Hu(e);++u<e;)for(var o=n[u],f=-1;++f<e;)f!=u&&(i[u]=jt(i[u]||o,n[f],t,r));return wr(kt(i,1),t,r)}function Or(n,t,r){for(var e=-1,u=n.length,i=t.length,o={};++e<u;)r(o,n[e],e<i?t[e]:F);
	return o}function Sr(n){return _u(n)?n:[]}function Ir(n){return typeof n=="function"?n:Nu}function Rr(n,t){return af(n)?n:We(n,t)?[n]:mo(zu(n))}function zr(n,t,r){var e=n.length;return r=r===F?e:r,!t&&r>=e?n:vr(n,t,r)}function Wr(n,t){if(t)return n.slice();var r=n.length,r=yi?yi(r):new n.constructor(r);return n.copy(r),r}function Br(n){var t=new n.constructor(n.byteLength);return new di(t).set(new di(n)),t}function Lr(n,t){return new n.constructor(t?Br(n.buffer):n.buffer,n.byteOffset,n.length)}function Ur(n,t){
	if(n!==t){var r=n!==F,e=null===n,u=n===n,i=Au(n),o=t!==F,f=null===t,c=t===t,a=Au(t);if(!f&&!a&&!i&&n>t||i&&o&&c&&!f&&!a||e&&o&&c||!r&&c||!u)return 1;if(!e&&!i&&!a&&n<t||a&&r&&u&&!e&&!i||f&&r&&u||!o&&u||!c)return-1}return 0}function Cr(n,t,r,e){var u=-1,i=n.length,o=r.length,f=-1,c=t.length,a=Di(i-o,0),l=Hu(c+a);for(e=!e;++f<c;)l[f]=t[f];for(;++u<o;)(e||u<i)&&(l[r[u]]=n[u]);for(;a--;)l[f++]=n[u++];return l}function Dr(n,t,r,e){var u=-1,i=n.length,o=-1,f=r.length,c=-1,a=t.length,l=Di(i-f,0),s=Hu(l+a);
	for(e=!e;++u<l;)s[u]=n[u];for(l=u;++c<a;)s[l+c]=t[c];for(;++o<f;)(e||u<i)&&(s[l+r[o]]=n[u++]);return s}function Mr(n,t){var r=-1,e=n.length;for(t||(t=Hu(e));++r<e;)t[r]=n[r];return t}function Tr(n,t,r,e){var u=!r;r||(r={});for(var i=-1,o=t.length;++i<o;){var f=t[i],c=e?e(r[f],n[f],f,r,n):F;c===F&&(c=n[f]),u?_t(r,f,c):at(r,f,c)}return r}function $r(n,t){return Tr(n,vo(n),t)}function Fr(n,t){return Tr(n,go(n),t)}function Nr(n,t){return function(r,u){var i=af(r)?e:st,o=t?t():{};return i(r,n,je(u,2),o);
	}}function Pr(n){return lr(function(t,r){var e=-1,u=r.length,i=1<u?r[u-1]:F,o=2<u?r[2]:F,i=3<n.length&&typeof i=="function"?(u--,i):F;for(o&&ze(r[0],r[1],o)&&(i=3>u?F:i,u=1),t=ni(t);++e<u;)(o=r[e])&&n(t,o,e,i);return t})}function Zr(n,t){return function(r,e){if(null==r)return r;if(!pu(r))return n(r,e);for(var u=r.length,i=t?u:-1,o=ni(r);(t?i--:++i<u)&&false!==e(o[i],i,o););return r}}function qr(n){return function(t,r,e){var u=-1,i=ni(t);e=e(t);for(var o=e.length;o--;){var f=e[n?o:++u];if(false===r(i[f],f,i))break;
	}return t}}function Vr(n,t,r){function e(){return(this&&this!==Zn&&this instanceof e?i:n).apply(u?r:this,arguments)}var u=1&t,i=Hr(n);return e}function Kr(n){return function(t){t=zu(t);var r=Bn.test(t)?$(t):F,e=r?r[0]:t.charAt(0);return t=r?zr(r,1).join(""):t.slice(1),e[n]()+t}}function Gr(n){return function(t){return h($u(Tu(t).replace(In,"")),n,"")}}function Hr(n){return function(){var t=arguments;switch(t.length){case 0:return new n;case 1:return new n(t[0]);case 2:return new n(t[0],t[1]);case 3:
	return new n(t[0],t[1],t[2]);case 4:return new n(t[0],t[1],t[2],t[3]);case 5:return new n(t[0],t[1],t[2],t[3],t[4]);case 6:return new n(t[0],t[1],t[2],t[3],t[4],t[5]);case 7:return new n(t[0],t[1],t[2],t[3],t[4],t[5],t[6])}var r=io(n.prototype),t=n.apply(r,t);return bu(t)?t:r}}function Jr(n,t,e){function u(){for(var o=arguments.length,f=Hu(o),c=o,a=xe(u);c--;)f[c]=arguments[c];return c=3>o&&f[0]!==a&&f[o-1]!==a?[]:C(f,a),o-=c.length,o<e?fe(n,t,Xr,u.placeholder,F,f,c,F,F,e-o):r(this&&this!==Zn&&this instanceof u?i:n,this,f);
	}var i=Hr(n);return u}function Yr(n){return function(t,r,e){var u=ni(t);if(!pu(t)){var i=je(r,3);t=Lu(t),r=function(n){return i(u[n],n,u)}}return r=n(t,r,e),-1<r?u[i?t[r]:r]:F}}function Qr(n){return ge(function(t){var r=t.length,e=r,u=zn.prototype.thru;for(n&&t.reverse();e--;){var i=t[e];if(typeof i!="function")throw new ei("Expected a function");if(u&&!o&&"wrapper"==be(i))var o=new zn([],true)}for(e=o?e:r;++e<r;)var i=t[e],u=be(i),f="wrapper"==u?_o(i):F,o=f&&Be(f[0])&&424==f[1]&&!f[4].length&&1==f[9]?o[be(f[0])].apply(o,f[3]):1==i.length&&Be(i)?o[u]():o.thru(i);
	return function(){var n=arguments,e=n[0];if(o&&1==n.length&&af(e))return o.plant(e).value();for(var u=0,n=r?t[u].apply(this,n):e;++u<r;)n=t[u].call(this,n);return n}})}function Xr(n,t,r,e,u,i,o,f,c,a){function l(){for(var d=arguments.length,y=Hu(d),b=d;b--;)y[b]=arguments[b];if(_){var x,j=xe(l),b=y.length;for(x=0;b--;)y[b]===j&&++x}if(e&&(y=Cr(y,e,u,_)),i&&(y=Dr(y,i,o,_)),d-=x,_&&d<a)return j=C(y,j),fe(n,t,Xr,l.placeholder,r,y,j,f,c,a-d);if(j=h?r:this,b=p?j[n]:n,d=y.length,f){x=y.length;for(var w=Mi(f.length,x),m=Mr(y);w--;){
	var A=f[w];y[w]=Re(A,x)?m[A]:F}}else v&&1<d&&y.reverse();return s&&c<d&&(y.length=c),this&&this!==Zn&&this instanceof l&&(b=g||Hr(b)),b.apply(j,y)}var s=128&t,h=1&t,p=2&t,_=24&t,v=512&t,g=p?F:Hr(n);return l}function ne(n,t){return function(r,e){return Ct(r,n,t(e))}}function te(n,t){return function(r,e){var u;if(r===F&&e===F)return t;if(r!==F&&(u=r),e!==F){if(u===F)return e;typeof r=="string"||typeof e=="string"?(r=jr(r),e=jr(e)):(r=xr(r),e=xr(e)),u=n(r,e)}return u}}function re(n){return ge(function(t){
	return t=l(t,S(je())),lr(function(e){var u=this;return n(t,function(n){return r(n,u,e)})})})}function ee(n,t){t=t===F?" ":jr(t);var r=t.length;return 2>r?r?ar(t,n):t:(r=ar(t,Ri(n/T(t))),Bn.test(t)?zr($(r),0,n).join(""):r.slice(0,n))}function ue(n,t,e,u){function i(){for(var t=-1,c=arguments.length,a=-1,l=u.length,s=Hu(l+c),h=this&&this!==Zn&&this instanceof i?f:n;++a<l;)s[a]=u[a];for(;c--;)s[a++]=arguments[++t];return r(h,o?e:this,s)}var o=1&t,f=Hr(n);return i}function ie(n){return function(t,r,e){
	e&&typeof e!="number"&&ze(t,r,e)&&(r=e=F),t=Eu(t),r===F?(r=t,t=0):r=Eu(r),e=e===F?t<r?1:-1:Eu(e);var u=-1;r=Di(Ri((r-t)/(e||1)),0);for(var i=Hu(r);r--;)i[n?r:++u]=t,t+=e;return i}}function oe(n){return function(t,r){return typeof t=="string"&&typeof r=="string"||(t=Iu(t),r=Iu(r)),n(t,r)}}function fe(n,t,r,e,u,i,o,f,c,a){var l=8&t,s=l?o:F;o=l?F:o;var h=l?i:F;return i=l?F:i,t=(t|(l?32:64))&~(l?64:32),4&t||(t&=-4),u=[n,t,u,h,s,i,o,f,c,a],r=r.apply(F,u),Be(n)&&xo(r,u),r.placeholder=e,De(r,n,t)}function ce(n){
	var t=Xu[n];return function(n,r){if(n=Iu(n),r=null==r?0:Mi(Ou(r),292)){var e=(zu(n)+"e").split("e"),e=t(e[0]+"e"+(+e[1]+r)),e=(zu(e)+"e").split("e");return+(e[0]+"e"+(+e[1]-r))}return t(n)}}function ae(n){return function(t){var r=yo(t);return"[object Map]"==r?L(t):"[object Set]"==r?M(t):O(t,n(t))}}function le(n,t,r,e,u,i,o,f){var c=2&t;if(!c&&typeof n!="function")throw new ei("Expected a function");var a=e?e.length:0;if(a||(t&=-97,e=u=F),o=o===F?o:Di(Ou(o),0),f=f===F?f:Ou(f),a-=u?u.length:0,64&t){
	var l=e,s=u;e=u=F}var h=c?F:_o(n);return i=[n,t,r,e,u,l,s,i,o,f],h&&(r=i[1],n=h[1],t=r|n,e=128==n&&8==r||128==n&&256==r&&i[7].length<=h[8]||384==n&&h[7].length<=h[8]&&8==r,131>t||e)&&(1&n&&(i[2]=h[2],t|=1&r?0:4),(r=h[3])&&(e=i[3],i[3]=e?Cr(e,r,h[4]):r,i[4]=e?C(i[3],"__lodash_placeholder__"):h[4]),(r=h[5])&&(e=i[5],i[5]=e?Dr(e,r,h[6]):r,i[6]=e?C(i[5],"__lodash_placeholder__"):h[6]),(r=h[7])&&(i[7]=r),128&n&&(i[8]=null==i[8]?h[8]:Mi(i[8],h[8])),null==i[9]&&(i[9]=h[9]),i[0]=h[0],i[1]=t),n=i[0],t=i[1],
	r=i[2],e=i[3],u=i[4],f=i[9]=i[9]===F?c?0:n.length:Di(i[9]-a,0),!f&&24&t&&(t&=-25),De((h?lo:xo)(t&&1!=t?8==t||16==t?Jr(n,t,f):32!=t&&33!=t||u.length?Xr.apply(F,i):ue(n,t,r,e):Vr(n,t,r),i),n,t)}function se(n,t,r,e){return n===F||hu(n,ii[r])&&!ci.call(e,r)?t:n}function he(n,t,r,e,u,i){return bu(n)&&bu(t)&&(i.set(t,n),nr(n,t,F,he,i),i.delete(t)),n}function pe(n){return wu(n)?F:n}function _e(n,t,r,e,u,i){var o=1&r,f=n.length,c=t.length;if(f!=c&&!(o&&c>f))return false;if((c=i.get(n))&&i.get(t))return c==t;var c=-1,a=true,l=2&r?new qn:F;
	for(i.set(n,t),i.set(t,n);++c<f;){var s=n[c],h=t[c];if(e)var p=o?e(h,s,c,t,n,i):e(s,h,c,n,t,i);if(p!==F){if(p)continue;a=false;break}if(l){if(!_(t,function(n,t){if(!R(l,t)&&(s===n||u(s,n,r,e,i)))return l.push(t)})){a=false;break}}else if(s!==h&&!u(s,h,r,e,i)){a=false;break}}return i.delete(n),i.delete(t),a}function ve(n,t,r,e,u,i,o){switch(r){case"[object DataView]":if(n.byteLength!=t.byteLength||n.byteOffset!=t.byteOffset)break;n=n.buffer,t=t.buffer;case"[object ArrayBuffer]":if(n.byteLength!=t.byteLength||!i(new di(n),new di(t)))break;
	return true;case"[object Boolean]":case"[object Date]":case"[object Number]":return hu(+n,+t);case"[object Error]":return n.name==t.name&&n.message==t.message;case"[object RegExp]":case"[object String]":return n==t+"";case"[object Map]":var f=L;case"[object Set]":if(f||(f=D),n.size!=t.size&&!(1&e))break;return(r=o.get(n))?r==t:(e|=2,o.set(n,t),t=_e(f(n),f(t),e,u,i,o),o.delete(n),t);case"[object Symbol]":if(eo)return eo.call(n)==eo.call(t)}return false}function ge(n){return wo(Ce(n,F,Ve),n+"")}function de(n){
	return Rt(n,Lu,vo)}function ye(n){return Rt(n,Uu,go)}function be(n){for(var t=n.name+"",r=Ji[t],e=ci.call(Ji,t)?r.length:0;e--;){var u=r[e],i=u.func;if(null==i||i==n)return u.name}return t}function xe(n){return(ci.call(On,"placeholder")?On:n).placeholder}function je(){var n=On.iteratee||Pu,n=n===Pu?Gt:n;return arguments.length?n(arguments[0],arguments[1]):n}function we(n,t){var r=n.__data__,e=typeof t;return("string"==e||"number"==e||"symbol"==e||"boolean"==e?"__proto__"!==t:null===t)?r[typeof t=="string"?"string":"hash"]:r.map;
	}function me(n){for(var t=Lu(n),r=t.length;r--;){var e=t[r],u=n[e];t[r]=[e,u,u===u&&!bu(u)]}return t}function Ae(n,t){var r=null==n?F:n[t];return Zt(r)?r:F}function ke(n,t,r){t=Rr(t,n);for(var e=-1,u=t.length,i=false;++e<u;){var o=$e(t[e]);if(!(i=null!=n&&r(n,o)))break;n=n[o]}return i||++e!=u?i:(u=null==n?0:n.length,!!u&&yu(u)&&Re(o,u)&&(af(n)||cf(n)))}function Ee(n){var t=n.length,r=n.constructor(t);return t&&"string"==typeof n[0]&&ci.call(n,"index")&&(r.index=n.index,r.input=n.input),r}function Oe(n){
	return typeof n.constructor!="function"||Le(n)?{}:io(bi(n))}function Se(r,e,u,i){var o=r.constructor;switch(e){case"[object ArrayBuffer]":return Br(r);case"[object Boolean]":case"[object Date]":return new o(+r);case"[object DataView]":return e=i?Br(r.buffer):r.buffer,new r.constructor(e,r.byteOffset,r.byteLength);case"[object Float32Array]":case"[object Float64Array]":case"[object Int8Array]":case"[object Int16Array]":case"[object Int32Array]":case"[object Uint8Array]":case"[object Uint8ClampedArray]":
	case"[object Uint16Array]":case"[object Uint32Array]":return Lr(r,i);case"[object Map]":return e=i?u(L(r),1):L(r),h(e,n,new r.constructor);case"[object Number]":case"[object String]":return new o(r);case"[object RegExp]":return e=new r.constructor(r.source,dn.exec(r)),e.lastIndex=r.lastIndex,e;case"[object Set]":return e=i?u(D(r),1):D(r),h(e,t,new r.constructor);case"[object Symbol]":return eo?ni(eo.call(r)):{}}}function Ie(n){return af(n)||cf(n)||!!(mi&&n&&n[mi])}function Re(n,t){return t=null==t?9007199254740991:t,
	!!t&&(typeof n=="number"||wn.test(n))&&-1<n&&0==n%1&&n<t}function ze(n,t,r){if(!bu(r))return false;var e=typeof t;return!!("number"==e?pu(r)&&Re(t,r.length):"string"==e&&t in r)&&hu(r[t],n)}function We(n,t){if(af(n))return false;var r=typeof n;return!("number"!=r&&"symbol"!=r&&"boolean"!=r&&null!=n&&!Au(n))||(rn.test(n)||!tn.test(n)||null!=t&&n in ni(t))}function Be(n){var t=be(n),r=On[t];return typeof r=="function"&&t in Mn.prototype&&(n===r||(t=_o(r),!!t&&n===t[0]))}function Le(n){var t=n&&n.constructor;
	return n===(typeof t=="function"&&t.prototype||ii)}function Ue(n,t){return function(r){return null!=r&&(r[n]===t&&(t!==F||n in ni(r)))}}function Ce(n,t,e){return t=Di(t===F?n.length-1:t,0),function(){for(var u=arguments,i=-1,o=Di(u.length-t,0),f=Hu(o);++i<o;)f[i]=u[t+i];for(i=-1,o=Hu(t+1);++i<t;)o[i]=u[i];return o[t]=e(f),r(n,this,o)}}function De(n,t,r){var e=t+"";t=wo;var u,i=Ne;return u=(u=e.match(hn))?u[1].split(pn):[],r=i(u,r),(i=r.length)&&(u=i-1,r[u]=(1<i?"& ":"")+r[u],r=r.join(2<i?", ":" "),
	e=e.replace(sn,"{\n/* [wrapped with "+r+"] */\n")),t(n,e)}function Me(n){var t=0,r=0;return function(){var e=Ti(),u=16-(e-r);if(r=e,0<u){if(800<=++t)return arguments[0]}else t=0;return n.apply(F,arguments)}}function Te(n,t){var r=-1,e=n.length,u=e-1;for(t=t===F?e:t;++r<t;){var e=cr(r,u),i=n[e];n[e]=n[r],n[r]=i}return n.length=t,n}function $e(n){if(typeof n=="string"||Au(n))return n;var t=n+"";return"0"==t&&1/n==-N?"-0":t}function Fe(n){if(null!=n){try{return fi.call(n)}catch(n){}return n+""}return"";
	}function Ne(n,t){return u(Z,function(r){var e="_."+r[0];t&r[1]&&!c(n,e)&&n.push(e)}),n.sort()}function Pe(n){if(n instanceof Mn)return n.clone();var t=new zn(n.__wrapped__,n.__chain__);return t.__actions__=Mr(n.__actions__),t.__index__=n.__index__,t.__values__=n.__values__,t}function Ze(n,t,r){var e=null==n?0:n.length;return e?(r=null==r?0:Ou(r),0>r&&(r=Di(e+r,0)),g(n,je(t,3),r)):-1}function qe(n,t,r){var e=null==n?0:n.length;if(!e)return-1;var u=e-1;return r!==F&&(u=Ou(r),u=0>r?Di(e+u,0):Mi(u,e-1)),
	g(n,je(t,3),u,true)}function Ve(n){return(null==n?0:n.length)?kt(n,1):[]}function Ke(n){return n&&n.length?n[0]:F}function Ge(n){var t=null==n?0:n.length;return t?n[t-1]:F}function He(n,t){return n&&n.length&&t&&t.length?or(n,t):n}function Je(n){return null==n?n:Ni.call(n)}function Ye(n){if(!n||!n.length)return[];var t=0;return n=f(n,function(n){if(_u(n))return t=Di(n.length,t),true}),E(t,function(t){return l(n,j(t))})}function Qe(n,t){if(!n||!n.length)return[];var e=Ye(n);return null==t?e:l(e,function(n){
	return r(t,F,n)})}function Xe(n){return n=On(n),n.__chain__=true,n}function nu(n,t){return t(n)}function tu(){return this}function ru(n,t){return(af(n)?u:oo)(n,je(t,3))}function eu(n,t){return(af(n)?i:fo)(n,je(t,3))}function uu(n,t){return(af(n)?l:Yt)(n,je(t,3))}function iu(n,t,r){return t=r?F:t,t=n&&null==t?n.length:t,le(n,128,F,F,F,F,t)}function ou(n,t){var r;if(typeof t!="function")throw new ei("Expected a function");return n=Ou(n),function(){return 0<--n&&(r=t.apply(this,arguments)),1>=n&&(t=F),
	r}}function fu(n,t,r){return t=r?F:t,n=le(n,8,F,F,F,F,F,t),n.placeholder=fu.placeholder,n}function cu(n,t,r){return t=r?F:t,n=le(n,16,F,F,F,F,F,t),n.placeholder=cu.placeholder,n}function au(n,t,r){function e(t){var r=c,e=a;return c=a=F,_=t,s=n.apply(e,r)}function u(n){var r=n-p;return n-=_,p===F||r>=t||0>r||g&&n>=l}function i(){var n=Jo();if(u(n))return o(n);var r,e=jo;r=n-_,n=t-(n-p),r=g?Mi(n,l-r):n,h=e(i,r)}function o(n){return h=F,d&&c?e(n):(c=a=F,s)}function f(){var n=Jo(),r=u(n);if(c=arguments,
	a=this,p=n,r){if(h===F)return _=n=p,h=jo(i,t),v?e(n):s;if(g)return h=jo(i,t),e(p)}return h===F&&(h=jo(i,t)),s}var c,a,l,s,h,p,_=0,v=false,g=false,d=true;if(typeof n!="function")throw new ei("Expected a function");return t=Iu(t)||0,bu(r)&&(v=!!r.leading,l=(g="maxWait"in r)?Di(Iu(r.maxWait)||0,t):l,d="trailing"in r?!!r.trailing:d),f.cancel=function(){h!==F&&ho(h),_=0,c=p=a=h=F},f.flush=function(){return h===F?s:o(Jo())},f}function lu(n,t){function r(){var e=arguments,u=t?t.apply(this,e):e[0],i=r.cache;return i.has(u)?i.get(u):(e=n.apply(this,e),
	r.cache=i.set(u,e)||i,e)}if(typeof n!="function"||null!=t&&typeof t!="function")throw new ei("Expected a function");return r.cache=new(lu.Cache||Pn),r}function su(n){if(typeof n!="function")throw new ei("Expected a function");return function(){var t=arguments;switch(t.length){case 0:return!n.call(this);case 1:return!n.call(this,t[0]);case 2:return!n.call(this,t[0],t[1]);case 3:return!n.call(this,t[0],t[1],t[2])}return!n.apply(this,t)}}function hu(n,t){return n===t||n!==n&&t!==t}function pu(n){return null!=n&&yu(n.length)&&!gu(n);
	}function _u(n){return xu(n)&&pu(n)}function vu(n){if(!xu(n))return false;var t=zt(n);return"[object Error]"==t||"[object DOMException]"==t||typeof n.message=="string"&&typeof n.name=="string"&&!wu(n)}function gu(n){return!!bu(n)&&(n=zt(n),"[object Function]"==n||"[object GeneratorFunction]"==n||"[object AsyncFunction]"==n||"[object Proxy]"==n)}function du(n){return typeof n=="number"&&n==Ou(n)}function yu(n){return typeof n=="number"&&-1<n&&0==n%1&&9007199254740991>=n}function bu(n){var t=typeof n;return null!=n&&("object"==t||"function"==t);
	}function xu(n){return null!=n&&typeof n=="object"}function ju(n){return typeof n=="number"||xu(n)&&"[object Number]"==zt(n)}function wu(n){return!(!xu(n)||"[object Object]"!=zt(n))&&(n=bi(n),null===n||(n=ci.call(n,"constructor")&&n.constructor,typeof n=="function"&&n instanceof n&&fi.call(n)==hi))}function mu(n){return typeof n=="string"||!af(n)&&xu(n)&&"[object String]"==zt(n)}function Au(n){return typeof n=="symbol"||xu(n)&&"[object Symbol]"==zt(n)}function ku(n){if(!n)return[];if(pu(n))return mu(n)?$(n):Mr(n);
	if(Ai&&n[Ai]){n=n[Ai]();for(var t,r=[];!(t=n.next()).done;)r.push(t.value);return r}return t=yo(n),("[object Map]"==t?L:"[object Set]"==t?D:Du)(n)}function Eu(n){return n?(n=Iu(n),n===N||n===-N?1.7976931348623157e308*(0>n?-1:1):n===n?n:0):0===n?n:0}function Ou(n){n=Eu(n);var t=n%1;return n===n?t?n-t:n:0}function Su(n){return n?gt(Ou(n),0,4294967295):0}function Iu(n){if(typeof n=="number")return n;if(Au(n))return P;if(bu(n)&&(n=typeof n.valueOf=="function"?n.valueOf():n,n=bu(n)?n+"":n),typeof n!="string")return 0===n?n:+n;
	n=n.replace(cn,"");var t=bn.test(n);return t||jn.test(n)?Fn(n.slice(2),t?2:8):yn.test(n)?P:+n}function Ru(n){return Tr(n,Uu(n))}function zu(n){return null==n?"":jr(n)}function Wu(n,t,r){return n=null==n?F:It(n,t),n===F?r:n}function Bu(n,t){return null!=n&&ke(n,t,Lt)}function Lu(n){return pu(n)?Gn(n):Ht(n)}function Uu(n){if(pu(n))n=Gn(n,true);else if(bu(n)){var t,r=Le(n),e=[];for(t in n)("constructor"!=t||!r&&ci.call(n,t))&&e.push(t);n=e}else{if(t=[],null!=n)for(r in ni(n))t.push(r);n=t}return n}function Cu(n,t){
	if(null==n)return{};var r=l(ye(n),function(n){return[n]});return t=je(t),ur(n,r,function(n,r){return t(n,r[0])})}function Du(n){return null==n?[]:I(n,Lu(n))}function Mu(n){return Nf(zu(n).toLowerCase())}function Tu(n){return(n=zu(n))&&n.replace(mn,rt).replace(Rn,"")}function $u(n,t,r){return n=zu(n),t=r?F:t,t===F?Ln.test(n)?n.match(Wn)||[]:n.match(_n)||[]:n.match(t)||[]}function Fu(n){return function(){return n}}function Nu(n){return n}function Pu(n){return Gt(typeof n=="function"?n:dt(n,1))}function Zu(n,t,r){
	var e=Lu(t),i=St(t,e);null!=r||bu(t)&&(i.length||!e.length)||(r=t,t=n,n=this,i=St(t,Lu(t)));var o=!(bu(r)&&"chain"in r&&!r.chain),f=gu(n);return u(i,function(r){var e=t[r];n[r]=e,f&&(n.prototype[r]=function(){var t=this.__chain__;if(o||t){var r=n(this.__wrapped__);return(r.__actions__=Mr(this.__actions__)).push({func:e,args:arguments,thisArg:n}),r.__chain__=t,r}return e.apply(n,s([this.value()],arguments))})}),n}function qu(){}function Vu(n){return We(n)?j($e(n)):ir(n)}function Ku(){return[]}function Gu(){
	return false}En=null==En?Zn:it.defaults(Zn.Object(),En,it.pick(Zn,Un));var Hu=En.Array,Ju=En.Date,Yu=En.Error,Qu=En.Function,Xu=En.Math,ni=En.Object,ti=En.RegExp,ri=En.String,ei=En.TypeError,ui=Hu.prototype,ii=ni.prototype,oi=En["__core-js_shared__"],fi=Qu.prototype.toString,ci=ii.hasOwnProperty,ai=0,li=function(){var n=/[^.]+$/.exec(oi&&oi.keys&&oi.keys.IE_PROTO||"");return n?"Symbol(src)_1."+n:""}(),si=ii.toString,hi=fi.call(ni),pi=Zn._,_i=ti("^"+fi.call(ci).replace(on,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),vi=Kn?En.Buffer:F,gi=En.Symbol,di=En.Uint8Array,yi=vi?vi.f:F,bi=U(ni.getPrototypeOf,ni),xi=ni.create,ji=ii.propertyIsEnumerable,wi=ui.splice,mi=gi?gi.isConcatSpreadable:F,Ai=gi?gi.iterator:F,ki=gi?gi.toStringTag:F,Ei=function(){
	try{var n=Ae(ni,"defineProperty");return n({},"",{}),n}catch(n){}}(),Oi=En.clearTimeout!==Zn.clearTimeout&&En.clearTimeout,Si=Ju&&Ju.now!==Zn.Date.now&&Ju.now,Ii=En.setTimeout!==Zn.setTimeout&&En.setTimeout,Ri=Xu.ceil,zi=Xu.floor,Wi=ni.getOwnPropertySymbols,Bi=vi?vi.isBuffer:F,Li=En.isFinite,Ui=ui.join,Ci=U(ni.keys,ni),Di=Xu.max,Mi=Xu.min,Ti=Ju.now,$i=En.parseInt,Fi=Xu.random,Ni=ui.reverse,Pi=Ae(En,"DataView"),Zi=Ae(En,"Map"),qi=Ae(En,"Promise"),Vi=Ae(En,"Set"),Ki=Ae(En,"WeakMap"),Gi=Ae(ni,"create"),Hi=Ki&&new Ki,Ji={},Yi=Fe(Pi),Qi=Fe(Zi),Xi=Fe(qi),no=Fe(Vi),to=Fe(Ki),ro=gi?gi.prototype:F,eo=ro?ro.valueOf:F,uo=ro?ro.toString:F,io=function(){
	function n(){}return function(t){return bu(t)?xi?xi(t):(n.prototype=t,t=new n,n.prototype=F,t):{}}}();On.templateSettings={escape:Q,evaluate:X,interpolate:nn,variable:"",imports:{_:On}},On.prototype=Sn.prototype,On.prototype.constructor=On,zn.prototype=io(Sn.prototype),zn.prototype.constructor=zn,Mn.prototype=io(Sn.prototype),Mn.prototype.constructor=Mn,Tn.prototype.clear=function(){this.__data__=Gi?Gi(null):{},this.size=0},Tn.prototype.delete=function(n){return n=this.has(n)&&delete this.__data__[n],
	this.size-=n?1:0,n},Tn.prototype.get=function(n){var t=this.__data__;return Gi?(n=t[n],"__lodash_hash_undefined__"===n?F:n):ci.call(t,n)?t[n]:F},Tn.prototype.has=function(n){var t=this.__data__;return Gi?t[n]!==F:ci.call(t,n)},Tn.prototype.set=function(n,t){var r=this.__data__;return this.size+=this.has(n)?0:1,r[n]=Gi&&t===F?"__lodash_hash_undefined__":t,this},Nn.prototype.clear=function(){this.__data__=[],this.size=0},Nn.prototype.delete=function(n){var t=this.__data__;return n=lt(t,n),!(0>n)&&(n==t.length-1?t.pop():wi.call(t,n,1),
	--this.size,true)},Nn.prototype.get=function(n){var t=this.__data__;return n=lt(t,n),0>n?F:t[n][1]},Nn.prototype.has=function(n){return-1<lt(this.__data__,n)},Nn.prototype.set=function(n,t){var r=this.__data__,e=lt(r,n);return 0>e?(++this.size,r.push([n,t])):r[e][1]=t,this},Pn.prototype.clear=function(){this.size=0,this.__data__={hash:new Tn,map:new(Zi||Nn),string:new Tn}},Pn.prototype.delete=function(n){return n=we(this,n).delete(n),this.size-=n?1:0,n},Pn.prototype.get=function(n){return we(this,n).get(n);
	},Pn.prototype.has=function(n){return we(this,n).has(n)},Pn.prototype.set=function(n,t){var r=we(this,n),e=r.size;return r.set(n,t),this.size+=r.size==e?0:1,this},qn.prototype.add=qn.prototype.push=function(n){return this.__data__.set(n,"__lodash_hash_undefined__"),this},qn.prototype.has=function(n){return this.__data__.has(n)},Vn.prototype.clear=function(){this.__data__=new Nn,this.size=0},Vn.prototype.delete=function(n){var t=this.__data__;return n=t.delete(n),this.size=t.size,n},Vn.prototype.get=function(n){
	return this.__data__.get(n)},Vn.prototype.has=function(n){return this.__data__.has(n)},Vn.prototype.set=function(n,t){var r=this.__data__;if(r instanceof Nn){var e=r.__data__;if(!Zi||199>e.length)return e.push([n,t]),this.size=++r.size,this;r=this.__data__=new Pn(e)}return r.set(n,t),this.size=r.size,this};var oo=Zr(Et),fo=Zr(Ot,true),co=qr(),ao=qr(true),lo=Hi?function(n,t){return Hi.set(n,t),n}:Nu,so=Ei?function(n,t){return Ei(n,"toString",{configurable:true,enumerable:false,value:Fu(t),writable:true})}:Nu,ho=Oi||function(n){
	return Zn.clearTimeout(n)},po=Vi&&1/D(new Vi([,-0]))[1]==N?function(n){return new Vi(n)}:qu,_o=Hi?function(n){return Hi.get(n)}:qu,vo=Wi?function(n){return null==n?[]:(n=ni(n),f(Wi(n),function(t){return ji.call(n,t)}))}:Ku,go=Wi?function(n){for(var t=[];n;)s(t,vo(n)),n=bi(n);return t}:Ku,yo=zt;(Pi&&"[object DataView]"!=yo(new Pi(new ArrayBuffer(1)))||Zi&&"[object Map]"!=yo(new Zi)||qi&&"[object Promise]"!=yo(qi.resolve())||Vi&&"[object Set]"!=yo(new Vi)||Ki&&"[object WeakMap]"!=yo(new Ki))&&(yo=function(n){
	var t=zt(n);if(n=(n="[object Object]"==t?n.constructor:F)?Fe(n):"")switch(n){case Yi:return"[object DataView]";case Qi:return"[object Map]";case Xi:return"[object Promise]";case no:return"[object Set]";case to:return"[object WeakMap]"}return t});var bo=oi?gu:Gu,xo=Me(lo),jo=Ii||function(n,t){return Zn.setTimeout(n,t)},wo=Me(so),mo=function(n){n=lu(n,function(n){return 500===t.size&&t.clear(),n});var t=n.cache;return n}(function(n){var t=[];return en.test(n)&&t.push(""),n.replace(un,function(n,r,e,u){
	t.push(e?u.replace(vn,"$1"):r||n)}),t}),Ao=lr(function(n,t){return _u(n)?jt(n,kt(t,1,_u,true)):[]}),ko=lr(function(n,t){var r=Ge(t);return _u(r)&&(r=F),_u(n)?jt(n,kt(t,1,_u,true),je(r,2)):[]}),Eo=lr(function(n,t){var r=Ge(t);return _u(r)&&(r=F),_u(n)?jt(n,kt(t,1,_u,true),F,r):[]}),Oo=lr(function(n){var t=l(n,Sr);return t.length&&t[0]===n[0]?Ut(t):[]}),So=lr(function(n){var t=Ge(n),r=l(n,Sr);return t===Ge(r)?t=F:r.pop(),r.length&&r[0]===n[0]?Ut(r,je(t,2)):[]}),Io=lr(function(n){var t=Ge(n),r=l(n,Sr);return(t=typeof t=="function"?t:F)&&r.pop(),
	r.length&&r[0]===n[0]?Ut(r,F,t):[]}),Ro=lr(He),zo=ge(function(n,t){var r=null==n?0:n.length,e=vt(n,t);return fr(n,l(t,function(n){return Re(n,r)?+n:n}).sort(Ur)),e}),Wo=lr(function(n){return wr(kt(n,1,_u,true))}),Bo=lr(function(n){var t=Ge(n);return _u(t)&&(t=F),wr(kt(n,1,_u,true),je(t,2))}),Lo=lr(function(n){var t=Ge(n),t=typeof t=="function"?t:F;return wr(kt(n,1,_u,true),F,t)}),Uo=lr(function(n,t){return _u(n)?jt(n,t):[]}),Co=lr(function(n){return Er(f(n,_u))}),Do=lr(function(n){var t=Ge(n);return _u(t)&&(t=F),
	Er(f(n,_u),je(t,2))}),Mo=lr(function(n){var t=Ge(n),t=typeof t=="function"?t:F;return Er(f(n,_u),F,t)}),To=lr(Ye),$o=lr(function(n){var t=n.length,t=1<t?n[t-1]:F,t=typeof t=="function"?(n.pop(),t):F;return Qe(n,t)}),Fo=ge(function(n){function t(t){return vt(t,n)}var r=n.length,e=r?n[0]:0,u=this.__wrapped__;return!(1<r||this.__actions__.length)&&u instanceof Mn&&Re(e)?(u=u.slice(e,+e+(r?1:0)),u.__actions__.push({func:nu,args:[t],thisArg:F}),new zn(u,this.__chain__).thru(function(n){return r&&!n.length&&n.push(F),
	n})):this.thru(t)}),No=Nr(function(n,t,r){ci.call(n,r)?++n[r]:_t(n,r,1)}),Po=Yr(Ze),Zo=Yr(qe),qo=Nr(function(n,t,r){ci.call(n,r)?n[r].push(t):_t(n,r,[t])}),Vo=lr(function(n,t,e){var u=-1,i=typeof t=="function",o=pu(n)?Hu(n.length):[];return oo(n,function(n){o[++u]=i?r(t,n,e):Dt(n,t,e)}),o}),Ko=Nr(function(n,t,r){_t(n,r,t)}),Go=Nr(function(n,t,r){n[r?0:1].push(t)},function(){return[[],[]]}),Ho=lr(function(n,t){if(null==n)return[];var r=t.length;return 1<r&&ze(n,t[0],t[1])?t=[]:2<r&&ze(t[0],t[1],t[2])&&(t=[t[0]]),
	rr(n,kt(t,1),[])}),Jo=Si||function(){return Zn.Date.now()},Yo=lr(function(n,t,r){var e=1;if(r.length)var u=C(r,xe(Yo)),e=32|e;return le(n,e,t,r,u)}),Qo=lr(function(n,t,r){var e=3;if(r.length)var u=C(r,xe(Qo)),e=32|e;return le(t,e,n,r,u)}),Xo=lr(function(n,t){return xt(n,1,t)}),nf=lr(function(n,t,r){return xt(n,Iu(t)||0,r)});lu.Cache=Pn;var tf=lr(function(n,t){t=1==t.length&&af(t[0])?l(t[0],S(je())):l(kt(t,1),S(je()));var e=t.length;return lr(function(u){for(var i=-1,o=Mi(u.length,e);++i<o;)u[i]=t[i].call(this,u[i]);
	return r(n,this,u)})}),rf=lr(function(n,t){return le(n,32,F,t,C(t,xe(rf)))}),ef=lr(function(n,t){return le(n,64,F,t,C(t,xe(ef)))}),uf=ge(function(n,t){return le(n,256,F,F,F,t)}),of=oe(Wt),ff=oe(function(n,t){return n>=t}),cf=Mt(function(){return arguments}())?Mt:function(n){return xu(n)&&ci.call(n,"callee")&&!ji.call(n,"callee")},af=Hu.isArray,lf=Hn?S(Hn):Tt,sf=Bi||Gu,hf=Jn?S(Jn):$t,pf=Yn?S(Yn):Nt,_f=Qn?S(Qn):qt,vf=Xn?S(Xn):Vt,gf=nt?S(nt):Kt,df=oe(Jt),yf=oe(function(n,t){return n<=t}),bf=Pr(function(n,t){
	if(Le(t)||pu(t))Tr(t,Lu(t),n);else for(var r in t)ci.call(t,r)&&at(n,r,t[r])}),xf=Pr(function(n,t){Tr(t,Uu(t),n)}),jf=Pr(function(n,t,r,e){Tr(t,Uu(t),n,e)}),wf=Pr(function(n,t,r,e){Tr(t,Lu(t),n,e)}),mf=ge(vt),Af=lr(function(n){return n.push(F,se),r(jf,F,n)}),kf=lr(function(n){return n.push(F,he),r(Rf,F,n)}),Ef=ne(function(n,t,r){n[t]=r},Fu(Nu)),Of=ne(function(n,t,r){ci.call(n,t)?n[t].push(r):n[t]=[r]},je),Sf=lr(Dt),If=Pr(function(n,t,r){nr(n,t,r)}),Rf=Pr(function(n,t,r,e){nr(n,t,r,e)}),zf=ge(function(n,t){
	var r={};if(null==n)return r;var e=false;t=l(t,function(t){return t=Rr(t,n),e||(e=1<t.length),t}),Tr(n,ye(n),r),e&&(r=dt(r,7,pe));for(var u=t.length;u--;)mr(r,t[u]);return r}),Wf=ge(function(n,t){return null==n?{}:er(n,t)}),Bf=ae(Lu),Lf=ae(Uu),Uf=Gr(function(n,t,r){return t=t.toLowerCase(),n+(r?Mu(t):t)}),Cf=Gr(function(n,t,r){return n+(r?"-":"")+t.toLowerCase()}),Df=Gr(function(n,t,r){return n+(r?" ":"")+t.toLowerCase()}),Mf=Kr("toLowerCase"),Tf=Gr(function(n,t,r){return n+(r?"_":"")+t.toLowerCase();
	}),$f=Gr(function(n,t,r){return n+(r?" ":"")+Nf(t)}),Ff=Gr(function(n,t,r){return n+(r?" ":"")+t.toUpperCase()}),Nf=Kr("toUpperCase"),Pf=lr(function(n,t){try{return r(n,F,t)}catch(n){return vu(n)?n:new Yu(n)}}),Zf=ge(function(n,t){return u(t,function(t){t=$e(t),_t(n,t,Yo(n[t],n))}),n}),qf=Qr(),Vf=Qr(true),Kf=lr(function(n,t){return function(r){return Dt(r,n,t)}}),Gf=lr(function(n,t){return function(r){return Dt(n,r,t)}}),Hf=re(l),Jf=re(o),Yf=re(_),Qf=ie(),Xf=ie(true),nc=te(function(n,t){return n+t},0),tc=ce("ceil"),rc=te(function(n,t){
	return n/t},1),ec=ce("floor"),uc=te(function(n,t){return n*t},1),ic=ce("round"),oc=te(function(n,t){return n-t},0);return On.after=function(n,t){if(typeof t!="function")throw new ei("Expected a function");return n=Ou(n),function(){if(1>--n)return t.apply(this,arguments)}},On.ary=iu,On.assign=bf,On.assignIn=xf,On.assignInWith=jf,On.assignWith=wf,On.at=mf,On.before=ou,On.bind=Yo,On.bindAll=Zf,On.bindKey=Qo,On.castArray=function(){if(!arguments.length)return[];var n=arguments[0];return af(n)?n:[n]},
	On.chain=Xe,On.chunk=function(n,t,r){if(t=(r?ze(n,t,r):t===F)?1:Di(Ou(t),0),r=null==n?0:n.length,!r||1>t)return[];for(var e=0,u=0,i=Hu(Ri(r/t));e<r;)i[u++]=vr(n,e,e+=t);return i},On.compact=function(n){for(var t=-1,r=null==n?0:n.length,e=0,u=[];++t<r;){var i=n[t];i&&(u[e++]=i)}return u},On.concat=function(){var n=arguments.length;if(!n)return[];for(var t=Hu(n-1),r=arguments[0];n--;)t[n-1]=arguments[n];return s(af(r)?Mr(r):[r],kt(t,1))},On.cond=function(n){var t=null==n?0:n.length,e=je();return n=t?l(n,function(n){
	if("function"!=typeof n[1])throw new ei("Expected a function");return[e(n[0]),n[1]]}):[],lr(function(e){for(var u=-1;++u<t;){var i=n[u];if(r(i[0],this,e))return r(i[1],this,e)}})},On.conforms=function(n){return yt(dt(n,1))},On.constant=Fu,On.countBy=No,On.create=function(n,t){var r=io(n);return null==t?r:ht(r,t)},On.curry=fu,On.curryRight=cu,On.debounce=au,On.defaults=Af,On.defaultsDeep=kf,On.defer=Xo,On.delay=nf,On.difference=Ao,On.differenceBy=ko,On.differenceWith=Eo,On.drop=function(n,t,r){var e=null==n?0:n.length;
	return e?(t=r||t===F?1:Ou(t),vr(n,0>t?0:t,e)):[]},On.dropRight=function(n,t,r){var e=null==n?0:n.length;return e?(t=r||t===F?1:Ou(t),t=e-t,vr(n,0,0>t?0:t)):[]},On.dropRightWhile=function(n,t){return n&&n.length?Ar(n,je(t,3),true,true):[]},On.dropWhile=function(n,t){return n&&n.length?Ar(n,je(t,3),true):[]},On.fill=function(n,t,r,e){var u=null==n?0:n.length;if(!u)return[];for(r&&typeof r!="number"&&ze(n,t,r)&&(r=0,e=u),u=n.length,r=Ou(r),0>r&&(r=-r>u?0:u+r),e=e===F||e>u?u:Ou(e),0>e&&(e+=u),e=r>e?0:Su(e);r<e;)n[r++]=t;
	return n},On.filter=function(n,t){return(af(n)?f:At)(n,je(t,3))},On.flatMap=function(n,t){return kt(uu(n,t),1)},On.flatMapDeep=function(n,t){return kt(uu(n,t),N)},On.flatMapDepth=function(n,t,r){return r=r===F?1:Ou(r),kt(uu(n,t),r)},On.flatten=Ve,On.flattenDeep=function(n){return(null==n?0:n.length)?kt(n,N):[]},On.flattenDepth=function(n,t){return null!=n&&n.length?(t=t===F?1:Ou(t),kt(n,t)):[]},On.flip=function(n){return le(n,512)},On.flow=qf,On.flowRight=Vf,On.fromPairs=function(n){for(var t=-1,r=null==n?0:n.length,e={};++t<r;){
	var u=n[t];e[u[0]]=u[1]}return e},On.functions=function(n){return null==n?[]:St(n,Lu(n))},On.functionsIn=function(n){return null==n?[]:St(n,Uu(n))},On.groupBy=qo,On.initial=function(n){return(null==n?0:n.length)?vr(n,0,-1):[]},On.intersection=Oo,On.intersectionBy=So,On.intersectionWith=Io,On.invert=Ef,On.invertBy=Of,On.invokeMap=Vo,On.iteratee=Pu,On.keyBy=Ko,On.keys=Lu,On.keysIn=Uu,On.map=uu,On.mapKeys=function(n,t){var r={};return t=je(t,3),Et(n,function(n,e,u){_t(r,t(n,e,u),n)}),r},On.mapValues=function(n,t){
	var r={};return t=je(t,3),Et(n,function(n,e,u){_t(r,e,t(n,e,u))}),r},On.matches=function(n){return Qt(dt(n,1))},On.matchesProperty=function(n,t){return Xt(n,dt(t,1))},On.memoize=lu,On.merge=If,On.mergeWith=Rf,On.method=Kf,On.methodOf=Gf,On.mixin=Zu,On.negate=su,On.nthArg=function(n){return n=Ou(n),lr(function(t){return tr(t,n)})},On.omit=zf,On.omitBy=function(n,t){return Cu(n,su(je(t)))},On.once=function(n){return ou(2,n)},On.orderBy=function(n,t,r,e){return null==n?[]:(af(t)||(t=null==t?[]:[t]),
	r=e?F:r,af(r)||(r=null==r?[]:[r]),rr(n,t,r))},On.over=Hf,On.overArgs=tf,On.overEvery=Jf,On.overSome=Yf,On.partial=rf,On.partialRight=ef,On.partition=Go,On.pick=Wf,On.pickBy=Cu,On.property=Vu,On.propertyOf=function(n){return function(t){return null==n?F:It(n,t)}},On.pull=Ro,On.pullAll=He,On.pullAllBy=function(n,t,r){return n&&n.length&&t&&t.length?or(n,t,je(r,2)):n},On.pullAllWith=function(n,t,r){return n&&n.length&&t&&t.length?or(n,t,F,r):n},On.pullAt=zo,On.range=Qf,On.rangeRight=Xf,On.rearg=uf,On.reject=function(n,t){
	return(af(n)?f:At)(n,su(je(t,3)))},On.remove=function(n,t){var r=[];if(!n||!n.length)return r;var e=-1,u=[],i=n.length;for(t=je(t,3);++e<i;){var o=n[e];t(o,e,n)&&(r.push(o),u.push(e))}return fr(n,u),r},On.rest=function(n,t){if(typeof n!="function")throw new ei("Expected a function");return t=t===F?t:Ou(t),lr(n,t)},On.reverse=Je,On.sampleSize=function(n,t,r){return t=(r?ze(n,t,r):t===F)?1:Ou(t),(af(n)?ot:hr)(n,t)},On.set=function(n,t,r){return null==n?n:pr(n,t,r)},On.setWith=function(n,t,r,e){return e=typeof e=="function"?e:F,
	null==n?n:pr(n,t,r,e)},On.shuffle=function(n){return(af(n)?ft:_r)(n)},On.slice=function(n,t,r){var e=null==n?0:n.length;return e?(r&&typeof r!="number"&&ze(n,t,r)?(t=0,r=e):(t=null==t?0:Ou(t),r=r===F?e:Ou(r)),vr(n,t,r)):[]},On.sortBy=Ho,On.sortedUniq=function(n){return n&&n.length?br(n):[]},On.sortedUniqBy=function(n,t){return n&&n.length?br(n,je(t,2)):[]},On.split=function(n,t,r){return r&&typeof r!="number"&&ze(n,t,r)&&(t=r=F),r=r===F?4294967295:r>>>0,r?(n=zu(n))&&(typeof t=="string"||null!=t&&!_f(t))&&(t=jr(t),
	!t&&Bn.test(n))?zr($(n),0,r):n.split(t,r):[]},On.spread=function(n,t){if(typeof n!="function")throw new ei("Expected a function");return t=null==t?0:Di(Ou(t),0),lr(function(e){var u=e[t];return e=zr(e,0,t),u&&s(e,u),r(n,this,e)})},On.tail=function(n){var t=null==n?0:n.length;return t?vr(n,1,t):[]},On.take=function(n,t,r){return n&&n.length?(t=r||t===F?1:Ou(t),vr(n,0,0>t?0:t)):[]},On.takeRight=function(n,t,r){var e=null==n?0:n.length;return e?(t=r||t===F?1:Ou(t),t=e-t,vr(n,0>t?0:t,e)):[]},On.takeRightWhile=function(n,t){
	return n&&n.length?Ar(n,je(t,3),false,true):[]},On.takeWhile=function(n,t){return n&&n.length?Ar(n,je(t,3)):[]},On.tap=function(n,t){return t(n),n},On.throttle=function(n,t,r){var e=true,u=true;if(typeof n!="function")throw new ei("Expected a function");return bu(r)&&(e="leading"in r?!!r.leading:e,u="trailing"in r?!!r.trailing:u),au(n,t,{leading:e,maxWait:t,trailing:u})},On.thru=nu,On.toArray=ku,On.toPairs=Bf,On.toPairsIn=Lf,On.toPath=function(n){return af(n)?l(n,$e):Au(n)?[n]:Mr(mo(zu(n)))},On.toPlainObject=Ru,
	On.transform=function(n,t,r){var e=af(n),i=e||sf(n)||gf(n);if(t=je(t,4),null==r){var o=n&&n.constructor;r=i?e?new o:[]:bu(n)&&gu(o)?io(bi(n)):{}}return(i?u:Et)(n,function(n,e,u){return t(r,n,e,u)}),r},On.unary=function(n){return iu(n,1)},On.union=Wo,On.unionBy=Bo,On.unionWith=Lo,On.uniq=function(n){return n&&n.length?wr(n):[]},On.uniqBy=function(n,t){return n&&n.length?wr(n,je(t,2)):[]},On.uniqWith=function(n,t){return t=typeof t=="function"?t:F,n&&n.length?wr(n,F,t):[]},On.unset=function(n,t){return null==n||mr(n,t);
	},On.unzip=Ye,On.unzipWith=Qe,On.update=function(n,t,r){return null==n?n:pr(n,t,Ir(r)(It(n,t)),void 0)},On.updateWith=function(n,t,r,e){return e=typeof e=="function"?e:F,null!=n&&(n=pr(n,t,Ir(r)(It(n,t)),e)),n},On.values=Du,On.valuesIn=function(n){return null==n?[]:I(n,Uu(n))},On.without=Uo,On.words=$u,On.wrap=function(n,t){return rf(Ir(t),n)},On.xor=Co,On.xorBy=Do,On.xorWith=Mo,On.zip=To,On.zipObject=function(n,t){return Or(n||[],t||[],at)},On.zipObjectDeep=function(n,t){return Or(n||[],t||[],pr);
	},On.zipWith=$o,On.entries=Bf,On.entriesIn=Lf,On.extend=xf,On.extendWith=jf,Zu(On,On),On.add=nc,On.attempt=Pf,On.camelCase=Uf,On.capitalize=Mu,On.ceil=tc,On.clamp=function(n,t,r){return r===F&&(r=t,t=F),r!==F&&(r=Iu(r),r=r===r?r:0),t!==F&&(t=Iu(t),t=t===t?t:0),gt(Iu(n),t,r)},On.clone=function(n){return dt(n,4)},On.cloneDeep=function(n){return dt(n,5)},On.cloneDeepWith=function(n,t){return t=typeof t=="function"?t:F,dt(n,5,t)},On.cloneWith=function(n,t){return t=typeof t=="function"?t:F,dt(n,4,t)},
	On.conformsTo=function(n,t){return null==t||bt(n,t,Lu(t))},On.deburr=Tu,On.defaultTo=function(n,t){return null==n||n!==n?t:n},On.divide=rc,On.endsWith=function(n,t,r){n=zu(n),t=jr(t);var e=n.length,e=r=r===F?e:gt(Ou(r),0,e);return r-=t.length,0<=r&&n.slice(r,e)==t},On.eq=hu,On.escape=function(n){return(n=zu(n))&&Y.test(n)?n.replace(H,et):n},On.escapeRegExp=function(n){return(n=zu(n))&&fn.test(n)?n.replace(on,"\\$&"):n},On.every=function(n,t,r){var e=af(n)?o:wt;return r&&ze(n,t,r)&&(t=F),e(n,je(t,3));
	},On.find=Po,On.findIndex=Ze,On.findKey=function(n,t){return v(n,je(t,3),Et)},On.findLast=Zo,On.findLastIndex=qe,On.findLastKey=function(n,t){return v(n,je(t,3),Ot)},On.floor=ec,On.forEach=ru,On.forEachRight=eu,On.forIn=function(n,t){return null==n?n:co(n,je(t,3),Uu)},On.forInRight=function(n,t){return null==n?n:ao(n,je(t,3),Uu)},On.forOwn=function(n,t){return n&&Et(n,je(t,3))},On.forOwnRight=function(n,t){return n&&Ot(n,je(t,3))},On.get=Wu,On.gt=of,On.gte=ff,On.has=function(n,t){return null!=n&&ke(n,t,Bt);
	},On.hasIn=Bu,On.head=Ke,On.identity=Nu,On.includes=function(n,t,r,e){return n=pu(n)?n:Du(n),r=r&&!e?Ou(r):0,e=n.length,0>r&&(r=Di(e+r,0)),mu(n)?r<=e&&-1<n.indexOf(t,r):!!e&&-1<d(n,t,r)},On.indexOf=function(n,t,r){var e=null==n?0:n.length;return e?(r=null==r?0:Ou(r),0>r&&(r=Di(e+r,0)),d(n,t,r)):-1},On.inRange=function(n,t,r){return t=Eu(t),r===F?(r=t,t=0):r=Eu(r),n=Iu(n),n>=Mi(t,r)&&n<Di(t,r)},On.invoke=Sf,On.isArguments=cf,On.isArray=af,On.isArrayBuffer=lf,On.isArrayLike=pu,On.isArrayLikeObject=_u,
	On.isBoolean=function(n){return true===n||false===n||xu(n)&&"[object Boolean]"==zt(n)},On.isBuffer=sf,On.isDate=hf,On.isElement=function(n){return xu(n)&&1===n.nodeType&&!wu(n)},On.isEmpty=function(n){if(null==n)return true;if(pu(n)&&(af(n)||typeof n=="string"||typeof n.splice=="function"||sf(n)||gf(n)||cf(n)))return!n.length;var t=yo(n);if("[object Map]"==t||"[object Set]"==t)return!n.size;if(Le(n))return!Ht(n).length;for(var r in n)if(ci.call(n,r))return false;return true},On.isEqual=function(n,t){return Ft(n,t);
	},On.isEqualWith=function(n,t,r){var e=(r=typeof r=="function"?r:F)?r(n,t):F;return e===F?Ft(n,t,F,r):!!e},On.isError=vu,On.isFinite=function(n){return typeof n=="number"&&Li(n)},On.isFunction=gu,On.isInteger=du,On.isLength=yu,On.isMap=pf,On.isMatch=function(n,t){return n===t||Pt(n,t,me(t))},On.isMatchWith=function(n,t,r){return r=typeof r=="function"?r:F,Pt(n,t,me(t),r)},On.isNaN=function(n){return ju(n)&&n!=+n},On.isNative=function(n){if(bo(n))throw new Yu("Unsupported core-js use. Try https://npms.io/search?q=ponyfill.");
	return Zt(n)},On.isNil=function(n){return null==n},On.isNull=function(n){return null===n},On.isNumber=ju,On.isObject=bu,On.isObjectLike=xu,On.isPlainObject=wu,On.isRegExp=_f,On.isSafeInteger=function(n){return du(n)&&-9007199254740991<=n&&9007199254740991>=n},On.isSet=vf,On.isString=mu,On.isSymbol=Au,On.isTypedArray=gf,On.isUndefined=function(n){return n===F},On.isWeakMap=function(n){return xu(n)&&"[object WeakMap]"==yo(n)},On.isWeakSet=function(n){return xu(n)&&"[object WeakSet]"==zt(n)},On.join=function(n,t){
	return null==n?"":Ui.call(n,t)},On.kebabCase=Cf,On.last=Ge,On.lastIndexOf=function(n,t,r){var e=null==n?0:n.length;if(!e)return-1;var u=e;if(r!==F&&(u=Ou(r),u=0>u?Di(e+u,0):Mi(u,e-1)),t===t){for(r=u+1;r--&&n[r]!==t;);n=r}else n=g(n,b,u,true);return n},On.lowerCase=Df,On.lowerFirst=Mf,On.lt=df,On.lte=yf,On.max=function(n){return n&&n.length?mt(n,Nu,Wt):F},On.maxBy=function(n,t){return n&&n.length?mt(n,je(t,2),Wt):F},On.mean=function(n){return x(n,Nu)},On.meanBy=function(n,t){return x(n,je(t,2))},On.min=function(n){
	return n&&n.length?mt(n,Nu,Jt):F},On.minBy=function(n,t){return n&&n.length?mt(n,je(t,2),Jt):F},On.stubArray=Ku,On.stubFalse=Gu,On.stubObject=function(){return{}},On.stubString=function(){return""},On.stubTrue=function(){return true},On.multiply=uc,On.nth=function(n,t){return n&&n.length?tr(n,Ou(t)):F},On.noConflict=function(){return Zn._===this&&(Zn._=pi),this},On.noop=qu,On.now=Jo,On.pad=function(n,t,r){n=zu(n);var e=(t=Ou(t))?T(n):0;return!t||e>=t?n:(t=(t-e)/2,ee(zi(t),r)+n+ee(Ri(t),r))},On.padEnd=function(n,t,r){
	n=zu(n);var e=(t=Ou(t))?T(n):0;return t&&e<t?n+ee(t-e,r):n},On.padStart=function(n,t,r){n=zu(n);var e=(t=Ou(t))?T(n):0;return t&&e<t?ee(t-e,r)+n:n},On.parseInt=function(n,t,r){return r||null==t?t=0:t&&(t=+t),$i(zu(n).replace(an,""),t||0)},On.random=function(n,t,r){if(r&&typeof r!="boolean"&&ze(n,t,r)&&(t=r=F),r===F&&(typeof t=="boolean"?(r=t,t=F):typeof n=="boolean"&&(r=n,n=F)),n===F&&t===F?(n=0,t=1):(n=Eu(n),t===F?(t=n,n=0):t=Eu(t)),n>t){var e=n;n=t,t=e}return r||n%1||t%1?(r=Fi(),Mi(n+r*(t-n+$n("1e-"+((r+"").length-1))),t)):cr(n,t);
	},On.reduce=function(n,t,r){var e=af(n)?h:m,u=3>arguments.length;return e(n,je(t,4),r,u,oo)},On.reduceRight=function(n,t,r){var e=af(n)?p:m,u=3>arguments.length;return e(n,je(t,4),r,u,fo)},On.repeat=function(n,t,r){return t=(r?ze(n,t,r):t===F)?1:Ou(t),ar(zu(n),t)},On.replace=function(){var n=arguments,t=zu(n[0]);return 3>n.length?t:t.replace(n[1],n[2])},On.result=function(n,t,r){t=Rr(t,n);var e=-1,u=t.length;for(u||(u=1,n=F);++e<u;){var i=null==n?F:n[$e(t[e])];i===F&&(e=u,i=r),n=gu(i)?i.call(n):i;
	}return n},On.round=ic,On.runInContext=w,On.sample=function(n){return(af(n)?tt:sr)(n)},On.size=function(n){if(null==n)return 0;if(pu(n))return mu(n)?T(n):n.length;var t=yo(n);return"[object Map]"==t||"[object Set]"==t?n.size:Ht(n).length},On.snakeCase=Tf,On.some=function(n,t,r){var e=af(n)?_:gr;return r&&ze(n,t,r)&&(t=F),e(n,je(t,3))},On.sortedIndex=function(n,t){return dr(n,t)},On.sortedIndexBy=function(n,t,r){return yr(n,t,je(r,2))},On.sortedIndexOf=function(n,t){var r=null==n?0:n.length;if(r){
	var e=dr(n,t);if(e<r&&hu(n[e],t))return e}return-1},On.sortedLastIndex=function(n,t){return dr(n,t,true)},On.sortedLastIndexBy=function(n,t,r){return yr(n,t,je(r,2),true)},On.sortedLastIndexOf=function(n,t){if(null==n?0:n.length){var r=dr(n,t,true)-1;if(hu(n[r],t))return r}return-1},On.startCase=$f,On.startsWith=function(n,t,r){return n=zu(n),r=null==r?0:gt(Ou(r),0,n.length),t=jr(t),n.slice(r,r+t.length)==t},On.subtract=oc,On.sum=function(n){return n&&n.length?k(n,Nu):0},On.sumBy=function(n,t){return n&&n.length?k(n,je(t,2)):0;
	},On.template=function(n,t,r){var e=On.templateSettings;r&&ze(n,t,r)&&(t=F),n=zu(n),t=jf({},t,e,se),r=jf({},t.imports,e.imports,se);var u,i,o=Lu(r),f=I(r,o),c=0;r=t.interpolate||An;var a="__p+='";r=ti((t.escape||An).source+"|"+r.source+"|"+(r===nn?gn:An).source+"|"+(t.evaluate||An).source+"|$","g");var l="sourceURL"in t?"//# sourceURL="+t.sourceURL+"\n":"";if(n.replace(r,function(t,r,e,o,f,l){return e||(e=o),a+=n.slice(c,l).replace(kn,B),r&&(u=true,a+="'+__e("+r+")+'"),f&&(i=true,a+="';"+f+";\n__p+='"),
	e&&(a+="'+((__t=("+e+"))==null?'':__t)+'"),c=l+t.length,t}),a+="';",(t=t.variable)||(a="with(obj){"+a+"}"),a=(i?a.replace(q,""):a).replace(V,"$1").replace(K,"$1;"),a="function("+(t||"obj")+"){"+(t?"":"obj||(obj={});")+"var __t,__p=''"+(u?",__e=_.escape":"")+(i?",__j=Array.prototype.join;function print(){__p+=__j.call(arguments,'')}":";")+a+"return __p}",t=Pf(function(){return Qu(o,l+"return "+a).apply(F,f)}),t.source=a,vu(t))throw t;return t},On.times=function(n,t){if(n=Ou(n),1>n||9007199254740991<n)return[];
	var r=4294967295,e=Mi(n,4294967295);for(t=je(t),n-=4294967295,e=E(e,t);++r<n;)t(r);return e},On.toFinite=Eu,On.toInteger=Ou,On.toLength=Su,On.toLower=function(n){return zu(n).toLowerCase()},On.toNumber=Iu,On.toSafeInteger=function(n){return n?gt(Ou(n),-9007199254740991,9007199254740991):0===n?n:0},On.toString=zu,On.toUpper=function(n){return zu(n).toUpperCase()},On.trim=function(n,t,r){return(n=zu(n))&&(r||t===F)?n.replace(cn,""):n&&(t=jr(t))?(n=$(n),r=$(t),t=z(n,r),r=W(n,r)+1,zr(n,t,r).join("")):n;
	},On.trimEnd=function(n,t,r){return(n=zu(n))&&(r||t===F)?n.replace(ln,""):n&&(t=jr(t))?(n=$(n),t=W(n,$(t))+1,zr(n,0,t).join("")):n},On.trimStart=function(n,t,r){return(n=zu(n))&&(r||t===F)?n.replace(an,""):n&&(t=jr(t))?(n=$(n),t=z(n,$(t)),zr(n,t).join("")):n},On.truncate=function(n,t){var r=30,e="...";if(bu(t))var u="separator"in t?t.separator:u,r="length"in t?Ou(t.length):r,e="omission"in t?jr(t.omission):e;n=zu(n);var i=n.length;if(Bn.test(n))var o=$(n),i=o.length;if(r>=i)return n;if(i=r-T(e),1>i)return e;
	if(r=o?zr(o,0,i).join(""):n.slice(0,i),u===F)return r+e;if(o&&(i+=r.length-i),_f(u)){if(n.slice(i).search(u)){var f=r;for(u.global||(u=ti(u.source,zu(dn.exec(u))+"g")),u.lastIndex=0;o=u.exec(f);)var c=o.index;r=r.slice(0,c===F?i:c)}}else n.indexOf(jr(u),i)!=i&&(u=r.lastIndexOf(u),-1<u&&(r=r.slice(0,u)));return r+e},On.unescape=function(n){return(n=zu(n))&&J.test(n)?n.replace(G,ut):n},On.uniqueId=function(n){var t=++ai;return zu(n)+t},On.upperCase=Ff,On.upperFirst=Nf,On.each=ru,On.eachRight=eu,On.first=Ke,
	Zu(On,function(){var n={};return Et(On,function(t,r){ci.call(On.prototype,r)||(n[r]=t)}),n}(),{chain:false}),On.VERSION="4.17.4",u("bind bindKey curry curryRight partial partialRight".split(" "),function(n){On[n].placeholder=On}),u(["drop","take"],function(n,t){Mn.prototype[n]=function(r){r=r===F?1:Di(Ou(r),0);var e=this.__filtered__&&!t?new Mn(this):this.clone();return e.__filtered__?e.__takeCount__=Mi(r,e.__takeCount__):e.__views__.push({size:Mi(r,4294967295),type:n+(0>e.__dir__?"Right":"")}),e},Mn.prototype[n+"Right"]=function(t){
	return this.reverse()[n](t).reverse()}}),u(["filter","map","takeWhile"],function(n,t){var r=t+1,e=1==r||3==r;Mn.prototype[n]=function(n){var t=this.clone();return t.__iteratees__.push({iteratee:je(n,3),type:r}),t.__filtered__=t.__filtered__||e,t}}),u(["head","last"],function(n,t){var r="take"+(t?"Right":"");Mn.prototype[n]=function(){return this[r](1).value()[0]}}),u(["initial","tail"],function(n,t){var r="drop"+(t?"":"Right");Mn.prototype[n]=function(){return this.__filtered__?new Mn(this):this[r](1);
	}}),Mn.prototype.compact=function(){return this.filter(Nu)},Mn.prototype.find=function(n){return this.filter(n).head()},Mn.prototype.findLast=function(n){return this.reverse().find(n)},Mn.prototype.invokeMap=lr(function(n,t){return typeof n=="function"?new Mn(this):this.map(function(r){return Dt(r,n,t)})}),Mn.prototype.reject=function(n){return this.filter(su(je(n)))},Mn.prototype.slice=function(n,t){n=Ou(n);var r=this;return r.__filtered__&&(0<n||0>t)?new Mn(r):(0>n?r=r.takeRight(-n):n&&(r=r.drop(n)),
	t!==F&&(t=Ou(t),r=0>t?r.dropRight(-t):r.take(t-n)),r)},Mn.prototype.takeRightWhile=function(n){return this.reverse().takeWhile(n).reverse()},Mn.prototype.toArray=function(){return this.take(4294967295)},Et(Mn.prototype,function(n,t){var r=/^(?:filter|find|map|reject)|While$/.test(t),e=/^(?:head|last)$/.test(t),u=On[e?"take"+("last"==t?"Right":""):t],i=e||/^find/.test(t);u&&(On.prototype[t]=function(){function t(n){return n=u.apply(On,s([n],f)),e&&h?n[0]:n}var o=this.__wrapped__,f=e?[1]:arguments,c=o instanceof Mn,a=f[0],l=c||af(o);
	l&&r&&typeof a=="function"&&1!=a.length&&(c=l=false);var h=this.__chain__,p=!!this.__actions__.length,a=i&&!h,c=c&&!p;return!i&&l?(o=c?o:new Mn(this),o=n.apply(o,f),o.__actions__.push({func:nu,args:[t],thisArg:F}),new zn(o,h)):a&&c?n.apply(this,f):(o=this.thru(t),a?e?o.value()[0]:o.value():o)})}),u("pop push shift sort splice unshift".split(" "),function(n){var t=ui[n],r=/^(?:push|sort|unshift)$/.test(n)?"tap":"thru",e=/^(?:pop|shift)$/.test(n);On.prototype[n]=function(){var n=arguments;if(e&&!this.__chain__){
	var u=this.value();return t.apply(af(u)?u:[],n)}return this[r](function(r){return t.apply(af(r)?r:[],n)})}}),Et(Mn.prototype,function(n,t){var r=On[t];if(r){var e=r.name+"";(Ji[e]||(Ji[e]=[])).push({name:t,func:r})}}),Ji[Xr(F,2).name]=[{name:"wrapper",func:F}],Mn.prototype.clone=function(){var n=new Mn(this.__wrapped__);return n.__actions__=Mr(this.__actions__),n.__dir__=this.__dir__,n.__filtered__=this.__filtered__,n.__iteratees__=Mr(this.__iteratees__),n.__takeCount__=this.__takeCount__,n.__views__=Mr(this.__views__),
	n},Mn.prototype.reverse=function(){if(this.__filtered__){var n=new Mn(this);n.__dir__=-1,n.__filtered__=true}else n=this.clone(),n.__dir__*=-1;return n},Mn.prototype.value=function(){var n,t=this.__wrapped__.value(),r=this.__dir__,e=af(t),u=0>r,i=e?t.length:0;n=i;for(var o=this.__views__,f=0,c=-1,a=o.length;++c<a;){var l=o[c],s=l.size;switch(l.type){case"drop":f+=s;break;case"dropRight":n-=s;break;case"take":n=Mi(n,f+s);break;case"takeRight":f=Di(f,n-s)}}if(n={start:f,end:n},o=n.start,f=n.end,n=f-o,
	o=u?f:o-1,f=this.__iteratees__,c=f.length,a=0,l=Mi(n,this.__takeCount__),!e||!u&&i==n&&l==n)return kr(t,this.__actions__);e=[];n:for(;n--&&a<l;){for(o+=r,u=-1,i=t[o];++u<c;){var h=f[u],s=h.type,h=(0,h.iteratee)(i);if(2==s)i=h;else if(!h){if(1==s)continue n;break n}}e[a++]=i}return e},On.prototype.at=Fo,On.prototype.chain=function(){return Xe(this)},On.prototype.commit=function(){return new zn(this.value(),this.__chain__)},On.prototype.next=function(){this.__values__===F&&(this.__values__=ku(this.value()));
	var n=this.__index__>=this.__values__.length;return{done:n,value:n?F:this.__values__[this.__index__++]}},On.prototype.plant=function(n){for(var t,r=this;r instanceof Sn;){var e=Pe(r);e.__index__=0,e.__values__=F,t?u.__wrapped__=e:t=e;var u=e,r=r.__wrapped__}return u.__wrapped__=n,t},On.prototype.reverse=function(){var n=this.__wrapped__;return n instanceof Mn?(this.__actions__.length&&(n=new Mn(this)),n=n.reverse(),n.__actions__.push({func:nu,args:[Je],thisArg:F}),new zn(n,this.__chain__)):this.thru(Je);
	},On.prototype.toJSON=On.prototype.valueOf=On.prototype.value=function(){return kr(this.__wrapped__,this.__actions__)},On.prototype.first=On.prototype.head,Ai&&(On.prototype[Ai]=tu),On}(); true?(Zn._=it, !(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return it}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))):Vn?((Vn.exports=it)._=it,qn._=it):Zn._=it}).call(this);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(209)(module)))

/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(578);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ }),
/* 1441 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(582),
	    baseRest = __webpack_require__(185),
	    baseUniq = __webpack_require__(583),
	    isArrayLikeObject = __webpack_require__(275);
	
	/**
	 * Creates an array of unique values, in order, from all given arrays using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of combined values.
	 * @example
	 *
	 * _.union([2], [1, 2]);
	 * // => [2, 1]
	 */
	var union = baseRest(function(arrays) {
	  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	});
	
	module.exports = union;


/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(1374),
	    baseRest = __webpack_require__(185),
	    baseXor = __webpack_require__(1388),
	    isArrayLikeObject = __webpack_require__(275);
	
	/**
	 * Creates an array of unique values that is the
	 * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	 * of the given arrays. The order of result values is determined by the order
	 * they occur in the arrays.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of filtered values.
	 * @see _.difference, _.without
	 * @example
	 *
	 * _.xor([2, 1], [2, 3]);
	 * // => [1, 3]
	 */
	var xor = baseRest(function(arrays) {
	  return baseXor(arrayFilter(arrays, isArrayLikeObject));
	});
	
	module.exports = xor;


/***/ }),
/* 1444 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (resultFn) {
	    var isEqual = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : simpleIsEqual;
	
	    var lastThis = void 0;
	    var lastArgs = [];
	    var lastResult = void 0;
	    var calledOnce = false;
	
	    var isNewArgEqualToLast = function isNewArgEqualToLast(newArg, index) {
	        return isEqual(newArg, lastArgs[index]);
	    };
	
	    // breaking cache when context (this) or arguments change
	    return function () {
	        for (var _len = arguments.length, newArgs = Array(_len), _key = 0; _key < _len; _key++) {
	            newArgs[_key] = arguments[_key];
	        }
	
	        if (calledOnce && lastThis === this && newArgs.length === lastArgs.length && newArgs.every(isNewArgEqualToLast)) {
	            return lastResult;
	        }
	
	        calledOnce = true;
	        lastThis = this;
	        lastArgs = newArgs;
	        lastResult = resultFn.apply(this, newArgs);
	        return lastResult;
	    };
	};
	
	var simpleIsEqual = function simpleIsEqual(a, b) {
	    return a === b;
	};

/***/ }),
/* 1445 */
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000
	var m = s * 60
	var h = m * 60
	var d = h * 24
	var y = d * 365.25
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function (val, options) {
	  options = options || {}
	  var type = typeof val
	  if (type === 'string' && val.length > 0) {
	    return parse(val)
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ?
				fmtLong(val) :
				fmtShort(val)
	  }
	  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val))
	}
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str)
	  if (str.length > 10000) {
	    return
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str)
	  if (!match) {
	    return
	  }
	  var n = parseFloat(match[1])
	  var type = (match[2] || 'ms').toLowerCase()
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n
	    default:
	      return undefined
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd'
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h'
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm'
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's'
	  }
	  return ms + 'ms'
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms'
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's'
	}


/***/ }),
/* 1446 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * JSON parse.
	 *
	 * @see Based on jQuery#parseJSON (MIT) and JSON2
	 * @api private
	 */
	
	var rvalidchars = /^[\],:{}\s]*$/;
	var rvalidescape = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g;
	var rvalidtokens = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
	var rvalidbraces = /(?:^|:|,)(?:\s*\[)+/g;
	var rtrimLeft = /^\s+/;
	var rtrimRight = /\s+$/;
	
	module.exports = function parsejson(data) {
	  if ('string' != typeof data || !data) {
	    return null;
	  }
	
	  data = data.replace(rtrimLeft, '').replace(rtrimRight, '');
	
	  // Attempt to parse using the native JSON parser first
	  if (global.JSON && JSON.parse) {
	    return JSON.parse(data);
	  }
	
	  if (rvalidchars.test(data.replace(rvalidescape, '@')
	      .replace(rvalidtokens, ']')
	      .replace(rvalidbraces, ''))) {
	    return (new Function('return ' + data))();
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1447 */
/***/ (function(module, exports) {

	/*! Player.js - v0.0.11 - 2015-07-24
	* http://github.com/embedly/player.js
	* Copyright (c) 2015 Embedly; Licensed BSD */
	(function(window, document){
	var playerjs = {};
	
	playerjs.DEBUG = false;
	playerjs.VERSION = '0.0.11';
	playerjs.CONTEXT = 'player.js';
	playerjs.POST_MESSAGE = !!window.postMessage;
	
	/*
	* Utils.
	*/
	playerjs.origin = function(url){
	  // Grab the origin of a URL
	  if (url.substr(0, 2) === '//'){
	    url = window.location.protocol + url;
	  }
	
	  return url.split('/').slice(0,3).join('/');
	};
	
	playerjs.addEvent = function(elem, type, eventHandle) {
	  if (!elem) { return; }
	  if ( elem.addEventListener ) {
	    elem.addEventListener( type, eventHandle, false );
	  } else if ( elem.attachEvent ) {
	    elem.attachEvent( "on" + type, eventHandle );
	  } else {
	    elem["on"+type]=eventHandle;
	  }
	};
	
	// usage: log('inside coolFunc',this,arguments);
	// http://paulirish.com/2009/log-a-lightweight-wrapper-for-consolelog/
	playerjs.log = function(){
	  playerjs.log.history = playerjs.log.history || [];   // store logs to an array for reference
	  playerjs.log.history.push(arguments);
	  if(window.console && playerjs.DEBUG){
	    window.console.log( Array.prototype.slice.call(arguments) );
	  }
	};
	
	// isFunctions
	playerjs.isString = function (obj) {
	  return Object.prototype.toString.call(obj) === '[object String]';
	};
	
	playerjs.isObject = function(obj){
	  return Object.prototype.toString.call(obj) === "[object Object]";
	};
	
	playerjs.isArray = function(obj){
	  return Object.prototype.toString.call(obj) === "[object Array]";
	};
	
	playerjs.isNone = function(obj){
	  return (obj === null || obj === undefined);
	};
	
	playerjs.has = function(obj, key){
	  return Object.prototype.hasOwnProperty.call(obj, key);
	};
	
	// ie8 doesn't support indexOf in arrays, based on underscore.
	playerjs.indexOf = function(array, item) {
	  if (array == null){ return -1; }
	  var i = 0, length = array.length;
	  if (Array.prototype.IndexOf && array.indexOf === Array.prototype.IndexOf) {
	    return array.indexOf(item);
	  }
	  for (; i < length; i++) {
	    if (array[i] === item) { return i; }
	  }
	  return -1;
	};
	
	// Assert
	playerjs.assert = function(test, msg) {
	  if (!test) {
	    throw msg || "Player.js Assert Failed";
	  }
	};
	/*
	* Keeper is just a method for keeping track of all the callbacks.
	*/
	
	playerjs.Keeper = function(){
	  this.init();
	};
	
	playerjs.Keeper.prototype.init = function(){
	  this.data = {};
	};
	
	playerjs.Keeper.prototype.getUUID = function(){
	  // Create a random id. #http://stackoverflow.com/a/2117523/564191
	  return 'listener-xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
	      var r = Math.random()*16|0, v = c === 'x' ? r : (r&0x3|0x8);
	      return v.toString(16);
	  });
	};
	
	playerjs.Keeper.prototype.has = function(event, id){
	  if (!this.data.hasOwnProperty(event)){
	    return false;
	  }
	
	  if (playerjs.isNone(id)){
	    return true;
	  }
	
	  // Figure out if we have the event.
	  var events = this.data[event];
	
	  for (var i = 0; i < events.length; i++){
	    if (events[i].id === id){
	      return true;
	    }
	  }
	
	  return false;
	};
	
	playerjs.Keeper.prototype.add = function(id, event, cb, ctx, one){
	  var d = {
	    id: id,
	    event: event,
	    cb: cb,
	    ctx: ctx,
	    one: one
	  };
	
	  if (this.has(event)){
	    this.data[event].push(d);
	  } else {
	    this.data[event] = [d];
	  }
	};
	
	playerjs.Keeper.prototype.execute = function(event, id, data, ctx){
	  if (!this.has(event, id)){
	    return false;
	  }
	
	  var keep = [],
	    execute = [];
	
	  for (var i=0; i< this.data[event].length; i++){
	    var d = this.data[event][i];
	
	    // There are omni events, in that they do not have an id. i.e "ready".
	    // Or there is an ID and we only want to execute the right id'd method.
	    if (playerjs.isNone(id) || (!playerjs.isNone(id) && d.id === id )){
	
	      execute.push({
	        cb: d.cb,
	        ctx: d.ctx? d.ctx: ctx,
	        data: data
	      });
	
	      // If we only wanted to execute this once.
	      if (d.one === false){
	        keep.push(d);
	      }
	    } else {
	      keep.push(d);
	    }
	  }
	
	  if (keep.length === 0){
	    delete this.data[event];
	  } else {
	    this.data[event] = keep;
	  }
	
	  // We need to execute everything after we deal with the one stuff. otherwise
	  // we have issues to order of operations.
	  for (var n=0; n < execute.length; n++){
	    var e = execute[n];
	    e.cb.call(e.ctx, e.data);
	  }
	};
	
	playerjs.Keeper.prototype.on = function(id, event, cb, ctx){
	  this.add(id, event, cb, ctx, false);
	};
	
	playerjs.Keeper.prototype.one = function(id, event, cb, ctx){
	  this.add(id, event, cb, ctx, true);
	};
	
	playerjs.Keeper.prototype.off = function(event, cb){
	  // We should probably restructure so this is a bit less of a pain.
	  var listeners = [];
	
	  if (!this.data.hasOwnProperty(event)){
	    return listeners;
	  }
	
	  var keep = [];
	
	  // Loop through everything.
	  for (var i=0; i< this.data[event].length; i++){
	    var data = this.data[event][i];
	    // If we only keep if there was a CB and the CB is there.
	    if (!playerjs.isNone(cb) && data.cb !== cb) {
	      keep.push(data);
	    } else if (!playerjs.isNone(data.id)) {
	      listeners.push(data.id);
	    }
	  }
	
	  if (keep.length === 0){
	    delete this.data[event];
	  } else {
	    this.data[event] = keep;
	  }
	
	  return listeners;
	};
	
	/*
	* Player.js is a javascript library for interacting with iframes via
	* postMessage that use an Open Player Spec
	*
	*/
	
	playerjs.Player = function(elem, options){
	  if (!(this instanceof playerjs.Player)) {
	    return new playerjs.Player(elem, options);
	  }
	  this.init(elem, options);
	};
	
	playerjs.EVENTS = {
	  READY: 'ready',
	  PLAY: 'play',
	  PAUSE: 'pause',
	  ENDED: 'ended',
	  TIMEUPDATE: 'timeupdate',
	  PROGRESS: 'progress',
	  ERROR: 'error'
	};
	
	playerjs.EVENTS.all = function(){
	  var all = [];
	  for (var key in playerjs.EVENTS) {
	    if (playerjs.has(playerjs.EVENTS, key) && playerjs.isString(playerjs.EVENTS[key])) {
	      all.push(playerjs.EVENTS[key]);
	    }
	  }
	  return all;
	};
	
	playerjs.METHODS = {
	  PLAY: 'play',
	  PAUSE: 'pause',
	  GETPAUSED: 'getPaused',
	  MUTE: 'mute',
	  UNMUTE: 'unmute',
	  GETMUTED: 'getMuted',
	  SETVOLUME: 'setVolume',
	  GETVOLUME: 'getVolume',
	  GETDURATION: 'getDuration',
	  SETCURRENTTIME: 'setCurrentTime',
	  GETCURRENTTIME:'getCurrentTime',
	  SETLOOP: 'setLoop',
	  GETLOOP: 'getLoop',
	  REMOVEEVENTLISTENER: 'removeEventListener',
	  ADDEVENTLISTENER: 'addEventListener'
	};
	
	playerjs.METHODS.all = function(){
	  var all = [];
	  for (var key in playerjs.METHODS) {
	    if (playerjs.has(playerjs.METHODS, key) && playerjs.isString(playerjs.METHODS[key])) {
	      all.push(playerjs.METHODS[key]);
	    }
	  }
	  return all;
	};
	
	playerjs.READIED = [];
	
	playerjs.Player.prototype.init = function(elem, options){
	
	  var self = this;
	
	  if (playerjs.isString(elem)){
	    elem = document.getElementById(elem);
	  }
	
	  this.elem = elem;
	
	  // Figure out the origin of where we are sending messages.
	  this.origin = playerjs.origin(elem.src);
	
	  // Event handling.
	  this.keeper = new playerjs.Keeper();
	
	  // Queuing before ready.
	  this.isReady = false;
	  this.queue = [];
	
	  // Assume that everything is supported, unless we know otherwise.
	  this.events = playerjs.EVENTS.all();
	  this.methods = playerjs.METHODS.all();
	
	  if (playerjs.POST_MESSAGE){
	    // Set up the reciever.
	    playerjs.addEvent(window, 'message', function(e){
	      self.receive(e);
	    });
	  } else {
	    playerjs.log('Post Message is not Available.');
	  }
	
	  // See if we caught the src event first, otherwise assume we haven't loaded
	  if (playerjs.indexOf(playerjs.READIED, elem.src) > -1){
	    self.loaded = true;
	  } else {
	    // Try the onload event, just lets us give another test.
	    this.elem.onload = function(){
	      self.loaded = true;
	    };
	  }
	};
	
	playerjs.Player.prototype.send = function(data, callback, ctx){
	  // Add the context and version to the data.
	  data.context = playerjs.CONTEXT;
	  data.version = playerjs.VERSION;
	
	  // We are expecting a response.
	  if (callback) {
	    // Create a UUID
	    var id = this.keeper.getUUID();
	
	    // Set the listener.
	    data.listener = id;
	
	    // Only hang on to this listener once.
	    this.keeper.one(id, data.method, callback, ctx);
	  }
	
	  if (!this.isReady && data.value !== 'ready'){
	    playerjs.log('Player.queue', data);
	    this.queue.push(data);
	    return false;
	  }
	
	  playerjs.log('Player.send', data, this.origin);
	
	  if (this.loaded === true){
	    this.elem.contentWindow.postMessage(JSON.stringify(data), this.origin);
	  }
	
	  return true;
	};
	
	playerjs.Player.prototype.receive = function(e){
	  playerjs.log('Player.receive', e);
	
	  if (e.origin !== this.origin){
	    return false;
	  }
	
	  var data;
	  try {
	    data = JSON.parse(e.data);
	  } catch (err){
	    // Not a valid response.
	    return false;
	  }
	
	  // abort if this message wasn't a player.js message
	  if (data.context !== playerjs.CONTEXT) {
	    return false;
	  }
	
	  // We need to determine if we are ready.
	  if (data.event === 'ready' && data.value && data.value.src === this.elem.src){
	    this.ready(data);
	  }
	
	  if (this.keeper.has(data.event, data.listener)){
	    this.keeper.execute(data.event, data.listener, data.value, this);
	  }
	};
	
	
	playerjs.Player.prototype.ready = function(data){
	
	  if (this.isReady === true){
	    return false;
	  }
	
	  // If we got a list of supported methods, we should set them.
	  if (data.value.events){
	    this.events = data.value.events;
	  }
	  if (data.value.methods){
	    this.methods = data.value.methods;
	  }
	
	  // set ready.
	  this.isReady = true;
	  this.loaded = true;
	
	  // Clear the queue
	  for (var i=0; i<this.queue.length; i++){
	    var obj = this.queue[i];
	
	    playerjs.log('Player.dequeue', obj);
	
	    if (data.event === 'ready'){
	      this.keeper.execute(obj.event, obj.listener, true, this);
	    }
	    this.send(obj);
	  }
	  this.queue = [];
	};
	
	playerjs.Player.prototype.on = function(event, callback, ctx){
	  var id = this.keeper.getUUID();
	
	  if (event === 'ready'){
	    // We only want to call ready once.
	    this.keeper.one(id, event, callback, ctx);
	  } else {
	    this.keeper.on(id, event, callback, ctx);
	  }
	
	  this.send({
	    method: 'addEventListener',
	    value: event,
	    listener: id
	  });
	
	  return true;
	};
	
	playerjs.Player.prototype.off = function(event, callback){
	
	  var listeners = this.keeper.off(event, callback);
	  playerjs.log('Player.off', listeners);
	
	  if (listeners.length > 0) {
	    for (var i in listeners){
	      this.send({
	        method: 'removeEventListener',
	        value: event,
	        listener: listeners[i]
	      });
	      return true;
	    }
	  }
	
	  return false;
	};
	
	// Based on what ready passed back, we can determine if the events/method are
	// supported by the player.
	playerjs.Player.prototype.supports = function(evtOrMethod, names){
	
	  playerjs.assert(playerjs.indexOf(['method', 'event'], evtOrMethod) > -1,
	    'evtOrMethod needs to be either "event" or "method" got ' + evtOrMethod);
	
	  // Make everything an array.
	  names = playerjs.isArray(names) ? names : [names];
	
	  var all = evtOrMethod === 'event' ? this.events : this.methods;
	
	  for (var i=0; i < names.length; i++){
	    if (playerjs.indexOf(all, names[i]) === -1){
	      return false;
	    }
	  }
	
	  return true;
	};
	
	//create function to add to the Player prototype
	function createPrototypeFunction(name) {
	
	  return function() {
	
	    var data = {
	      method: name
	    };
	
	    var args = Array.prototype.slice.call(arguments);
	
	    //for getters add the passed parameters to the arguments for the send call
	    if (/^get/.test(name)) {
	      playerjs.assert(args.length > 0, 'Get methods require a callback.');
	      args.unshift(data);
	    } else {
	      //for setter add the first arg to the value field
	      if (/^set/.test(name)) {
	        playerjs.assert(args.length !== 0, 'Set methods require a value.');
	        data.value = args[0];
	      }
	      args = [data];
	    }
	
	    this.send.apply(this, args);
	  };
	}
	
	// Loop through the methods to add them to the prototype.
	for (var i = 0, l = playerjs.METHODS.all().length; i < l; i++) {
	  var methodName = playerjs.METHODS.all()[i];
	
	  // We don't want to overwrite existing methods.
	  if (!playerjs.Player.prototype.hasOwnProperty(methodName)){
	    playerjs.Player.prototype[methodName] = createPrototypeFunction(methodName);
	  }
	}
	
	window.playerjs = playerjs;
	
	// We need to catch all ready events in case the iframe is ready before the
	// player is invoked.
	playerjs.addEvent(window, 'message', function(e){
	  var data;
	  try {
	    data = JSON.parse(e.data);
	  } catch (err){
	    return false;
	  }
	
	  // abort if this message wasn't a player.js message
	  if (data.context !== playerjs.CONTEXT) {
	    return false;
	  }
	
	  // We need to determine if we are ready.
	  if (data.event === 'ready' && data.value && data.value.src){
	    playerjs.READIED.push(data.value.src);
	  }
	});
	
	/*
	* Does all the wiring up for the backend.
	*
	* var receiver = new playerjs.Receiver();
	* receiver.on('play', function(){ video.play() });
	* receiver.on('getDuration', function(callback){ callback(video.duration) });
	* receiver.emit('timeupdate', {});
	*/
	
	playerjs.Receiver = function(events, methods){
	  this.init(events, methods);
	};
	
	playerjs.Receiver.prototype.init = function(events, methods){
	  var self = this;
	
	  // Deal with the ready crap.
	  this.isReady = false;
	
	  // Bind the window message.
	  this.origin = playerjs.origin(document.referrer);
	
	  //Create a holder for all the methods.
	  this.methods = {};
	
	  // holds all the information about what's supported
	  this.supported = {
	    events: events ? events : playerjs.EVENTS.all(),
	    methods: methods ? methods : playerjs.METHODS.all()
	  };
	
	  // Deals with the adding and removing of event listeners.
	  this.eventListeners = {};
	
	  // We can't send any messages.
	  this.reject = !(window.self !== window.top && playerjs.POST_MESSAGE);
	
	  // We aren't in an iframe, don't listen.
	  if (!this.reject){
	    playerjs.addEvent(window, 'message', function(e){
	      self.receive(e);
	    });
	  }
	};
	
	playerjs.Receiver.prototype.receive = function(e){
	  // Only want to listen to events that came from our origin.
	  if (e.origin !== this.origin){
	    return false;
	  }
	
	  // Browsers that support postMessage also support JSON.
	  var data = {};
	  if (playerjs.isObject(e.data)){
	    data = e.data;
	  } else {
	    try {
	      data = window.JSON.parse(e.data);
	    } catch (err){
	      playerjs.log('JSON Parse Error', err);
	    }
	  }
	
	  playerjs.log('Receiver.receive', e, data);
	
	  // Nothing for us to do.
	  if (!data.method){
	    return false;
	  }
	
	  // make sure the context is correct.
	  if (data.context !== playerjs.CONTEXT){
	    return false;
	  }
	
	  // Make sure we have a valid method.
	  if (playerjs.indexOf(playerjs.METHODS.all(), data.method) === -1){
	    this.emit('error', {
	      code: 2,
	      msg: 'Invalid Method "'+data.method+'"'
	    });
	    return false;
	  }
	
	  // See if we added a listener
	  var listener = !playerjs.isNone(data.listener) ? data.listener : null;
	
	  // Add Event Listener.
	  if (data.method === 'addEventListener') {
	    if (this.eventListeners.hasOwnProperty(data.value)) {
	      //If the listener is the same, i.e. null only add it once.
	      if (playerjs.indexOf(this.eventListeners[data.value], listener) === -1){
	        this.eventListeners[data.value].push(listener);
	      }
	    } else {
	      this.eventListeners[data.value] = [listener];
	    }
	
	    if (data.value === 'ready' && this.isReady){
	      this.ready();
	    }
	  }
	  // Remove the event listener.
	  else if (data.method === 'removeEventListener') {
	    if (this.eventListeners.hasOwnProperty(data.value)) {
	      var index = playerjs.indexOf(this.eventListeners[data.value], listener);
	
	      // if we find the element, remove it.
	      if (index > -1){
	        this.eventListeners[data.value].splice(index, 1);
	      }
	
	      if (this.eventListeners[data.value].length === 0){
	        delete this.eventListeners[data.value];
	      }
	    }
	  }
	  // Go get it.
	  else {
	    this.get(data.method, data.value, listener);
	  }
	};
	
	playerjs.Receiver.prototype.get = function(method, value, listener){
	  var self = this;
	
	  // Now lets do it.
	  if (!this.methods.hasOwnProperty(method)){
	    this.emit('error', {
	      code: 3,
	      msg: 'Method Not Supported"'+method+'"'
	    });
	    return false;
	  }
	
	  var func = this.methods[method];
	
	  if (method.substr(0,3) === 'get') {
	    var callback = function(val){
	      self.send(method, val, listener);
	    };
	    func.call(this, callback);
	  } else {
	    func.call(this, value);
	  }
	};
	
	playerjs.Receiver.prototype.on = function(event, callback){
	  this.methods[event] = callback;
	};
	
	playerjs.Receiver.prototype.send = function(event, value, listener){
	
	  playerjs.log('Receiver.send', event, value, listener);
	
	  if (this.reject){
	    // We are not in a frame, or we don't support POST_MESSAGE
	    playerjs.log('Receiver.send.reject', event, value, listener);
	    return false;
	  }
	
	  var data = {
	    context: playerjs.CONTEXT,
	    version: playerjs.VERSION,
	    event: event
	  };
	
	  if (!playerjs.isNone(value)){
	    data.value = value;
	  }
	
	  if (!playerjs.isNone(listener)){
	    data.listener = listener;
	  }
	
	  var msg = JSON.stringify(data);
	  window.parent.postMessage(msg, this.origin === "" ? '*' : this.origin);
	};
	
	playerjs.Receiver.prototype.emit = function(event, value){
	
	  if (!this.eventListeners.hasOwnProperty(event)){
	    return false;
	  }
	
	  playerjs.log('Instance.emit', event, value, this.eventListeners[event]);
	
	  for (var i=0; i < this.eventListeners[event].length; i++){
	    var listener = this.eventListeners[event][i];
	    this.send(event, value, listener);
	  }
	
	  return true;
	};
	
	playerjs.Receiver.prototype.ready = function(){
	  playerjs.log('Receiver.ready');
	  this.isReady = true;
	
	  var data = {
	    src: window.location.toString(),
	    events: this.supported.events,
	    methods: this.supported.methods
	  };
	
	  if (!this.emit('ready', data)){
	    this.send('ready', data);
	  }
	
	};
	
	playerjs.HTML5Adapter = function(video){
	  if (!(this instanceof playerjs.HTML5Adapter)) {
	    return new playerjs.HTML5Adapter(video);
	  }
	  this.init(video);
	};
	
	playerjs.HTML5Adapter.prototype.init = function(video){
	
	  playerjs.assert(video, 'playerjs.VideoJSReceiver requires a video element');
	
	  // Set up the actual receiver
	  var receiver = this.receiver = new playerjs.Receiver();
	
	  /* EVENTS */
	  video.addEventListener('playing', function(){
	    receiver.emit('play');
	  });
	
	  video.addEventListener('pause', function(){
	    receiver.emit('pause');
	  });
	
	  video.addEventListener('ended', function(){
	    receiver.emit('ended');
	  });
	
	  video.addEventListener('timeupdate', function(){
	    receiver.emit('timeupdate', {
	      seconds: video.currentTime,
	      duration: video.duration
	    });
	  });
	
	  video.addEventListener('progress', function(){
	    receiver.emit('buffered', {
	      percent: video.buffered.length
	    });
	  });
	
	  /* Methods */
	  receiver.on('play', function(){
	    video.play();
	  });
	
	  receiver.on('pause', function(){
	    video.pause();
	  });
	
	  receiver.on('getPaused', function(callback){
	    callback(video.paused);
	  });
	
	  receiver.on('getCurrentTime', function(callback){
	    callback(video.currentTime);
	  });
	
	  receiver.on('setCurrentTime', function(value){
	    video.currentTime = value;
	  });
	
	  receiver.on('getDuration', function(callback){
	    callback(video.duration);
	  });
	
	  receiver.on('getVolume', function(callback){
	    callback(video.volume * 100);
	  });
	
	  receiver.on('setVolume', function(value){
	    video.volume = value/100;
	  });
	
	  receiver.on('mute', function(){
	    video.muted = true;
	  });
	
	  receiver.on('unmute', function(){
	    video.muted = false;
	  });
	
	  receiver.on('getMuted', function(callback){
	    callback(video.muted);
	  });
	
	  receiver.on('getLoop', function(callback){
	    callback(video.loop);
	  });
	
	  receiver.on('setLoop', function(value){
	    video.loop = value;
	  });
	};
	
	/* Call when the video has loaded */
	playerjs.HTML5Adapter.prototype.ready = function(){
	  this.receiver.ready();
	};
	//http://www.longtailvideo.com/support/jw-player/28851/javascript-api-reference
	playerjs.JWPlayerAdapter = function(player){
	  if (!(this instanceof playerjs.JWPlayerAdapter)) {
	    return new playerjs.JWPlayerAdapter(player);
	  }
	  this.init(player);
	};
	
	playerjs.JWPlayerAdapter.prototype.init = function(player){
	
	  playerjs.assert(player, 'playerjs.JWPlayerAdapter requires a player object');
	
	  // Set up the actual receiver
	  var receiver = this.receiver = new playerjs.Receiver();
	
	  // JWPlayer doesn't have a seLoop, so we can do it ourself.
	  this.looped = false;
	
	  /* EVENTS */
	  player.onPause(function(){
	    receiver.emit('pause');
	  });
	
	  player.onPlay(function(){
	    receiver.emit('play');
	  });
	
	  player.onTime(function(e){
	    var seconds = e.position,
	      duration = e.duration;
	
	    if (!seconds || !duration){
	      return false;
	    }
	
	    var value = {
	      seconds: seconds,
	      duration: duration
	    };
	    receiver.emit('timeupdate', value);
	  });
	
	  var self = this;
	  player.onComplete(function(){
	    // Fake the looping
	    if (self.looped === true){
	      // By default jwplayer seeks after play.
	      player.seek(0);
	    } else {
	      // Else throw the ended event.
	      receiver.emit('ended');
	    }
	  });
	
	  player.onError(function(){
	    receiver.emit('error');
	  });
	
	
	  /* METHODS */
	  receiver.on('play', function(){
	    player.play(true);
	  });
	
	  receiver.on('pause', function(){
	    player.pause(true);
	  });
	
	  receiver.on('getPaused', function(callback){
	    callback(player.getState() !== 'PLAYING');
	  });
	
	  receiver.on('getCurrentTime', function(callback){
	    callback(player.getPosition());
	  });
	
	  receiver.on('setCurrentTime', function(value){
	    player.seek(value);
	  });
	
	  receiver.on('getDuration', function(callback){
	    callback(player.getDuration());
	  });
	
	  receiver.on('getVolume', function(callback){
	    callback(player.getVolume());
	  });
	
	  receiver.on('setVolume', function(value){
	    player.setVolume(value);
	  });
	
	  receiver.on('mute', function(){
	    player.setMute(true);
	  });
	
	  receiver.on('unmute', function(){
	    player.setMute(false);
	  });
	
	  receiver.on('getMuted', function(callback){
	    callback(player.getMute() === true);
	  });
	
	  receiver.on('getLoop', function(callback){
	    callback(this.looped);
	  }, this);
	
	  receiver.on('setLoop', function(value){
	    this.looped = value;
	  }, this);
	};
	
	/* Call when the video.js is ready */
	playerjs.JWPlayerAdapter.prototype.ready = function(){
	  this.receiver.ready();
	};
	
	playerjs.MockAdapter = function(){
	  if (!(this instanceof playerjs.MockAdapter)) {
	    return new playerjs.MockAdapter();
	  }
	  this.init();
	};
	
	playerjs.MockAdapter.prototype.init = function(){
	
	  // Our mock video
	  var video = {
	    duration: 20,
	    currentTime: 0,
	    interval: null,
	    timeupdate: function(){},
	    volume: 100,
	    mute: false,
	    playing: false,
	    loop : false,
	    play: function(){
	      video.interval = setInterval(function(){
	        video.currentTime += 0.25;
	        video.timeupdate({
	          seconds: video.currentTime,
	          duration: video.duration
	        });
	      }, 250);
	      video.playing = true;
	    },
	    pause: function(){
	      clearInterval(video.interval);
	      video.playing = false;
	    }
	  };
	
	  // Set up the actual receiver
	  var receiver = this.receiver = new playerjs.Receiver();
	
	  receiver.on('play', function(){
	    var self = this;
	    video.play();
	    this.emit('play');
	    video.timeupdate = function(data){
	      self.emit('timeupdate', data);
	    };
	  });
	
	  receiver.on('pause', function(){
	    video.pause();
	    this.emit('pause');
	  });
	
	  receiver.on('getPaused', function(callback){
	    callback(!video.playing);
	  });
	
	  receiver.on('getCurrentTime', function(callback){
	    callback(video.currentTime);
	  });
	
	  receiver.on('setCurrentTime', function(value){
	    video.currentTime = value;
	  });
	
	  receiver.on('getDuration', function(callback){
	    callback(video.duration);
	  });
	
	  receiver.on('getVolume', function(callback){
	    callback(video.volume);
	  });
	
	  receiver.on('setVolume', function(value){
	    video.volume = value;
	  });
	
	  receiver.on('mute', function(){
	    video.mute = true;
	  });
	
	  receiver.on('unmute', function(){
	    video.mute = false;
	  });
	
	  receiver.on('getMuted', function(callback){
	    callback(video.mute);
	  });
	
	  receiver.on('getLoop', function(callback){
	    callback(video.loop);
	  });
	
	  receiver.on('setLoop', function(value){
	    video.loop = value;
	  });
	};
	
	/* Call when the video has loaded */
	playerjs.MockAdapter.prototype.ready = function(){
	  this.receiver.ready();
	};
	playerjs.SublimeAdapter = function(player){
	  if (!(this instanceof playerjs.SublimeAdapter)) {
	    return new playerjs.SublimeAdapter(player);
	  }
	  this.init(player);
	};
	
	// Subset of methods available.
	playerjs.SublimeAdapter.prototype.events = [
	  playerjs.EVENTS.READY,
	  playerjs.EVENTS.PLAY,
	  playerjs.EVENTS.PAUSE,
	  playerjs.EVENTS.ENDED,
	  playerjs.EVENTS.TIMEUPDATE,
	  playerjs.EVENTS.ERROR
	];
	
	playerjs.SublimeAdapter.prototype.methods = [
	  playerjs.METHODS.PLAY,
	  playerjs.METHODS.PAUSE,
	  playerjs.METHODS.GETDURATION,
	  playerjs.METHODS.SETCURRENTTIME,
	  playerjs.METHODS.GETCURRENTTIME,
	  playerjs.METHODS.REMOVEEVENTLISTENER,
	  playerjs.METHODS.ADDEVENTLISTENER
	];
	
	playerjs.SublimeAdapter.prototype.init = function(player){
	
	  playerjs.assert(player, 'playerjs.SublimeAdapter requires a player object');
	
	  // Set up the actual receiver
	  var receiver = this.receiver = new playerjs.Receiver(this.events, this.methods);
	
	  /* EVENTS */
	  player.on("pause", function(){
	    receiver.emit('pause');
	  });
	
	  player.on("play", function(){
	    receiver.emit('play');
	  });
	
	  player.on("timeUpdate", function(player, seconds){
	    var duration = player.duration();
	
	    if (!seconds || !duration){
	      return false;
	    }
	
	    var value = {
	      seconds: seconds,
	      duration: duration
	    };
	    receiver.emit('timeupdate', value);
	  });
	
	  player.on("end", function(){
	    receiver.emit('ended');
	  });
	
	  /* METHODS */
	  receiver.on('play', function(){
	    player.play();
	  });
	
	  receiver.on('pause', function(){
	    player.pause();
	  });
	
	  receiver.on('getCurrentTime', function(callback){
	    callback(player.playbackTime());
	  });
	
	  receiver.on('setCurrentTime', function(value){
	    player.seekTo(value);
	  });
	
	  receiver.on('getDuration', function(callback){
	    callback(player.duration());
	  });
	};
	
	/* Call when the video.js is ready */
	playerjs.SublimeAdapter.prototype.ready = function(){
	  this.receiver.ready();
	};
	
	playerjs.VideoJSAdapter = function(player){
	  if (!(this instanceof playerjs.VideoJSAdapter)) {
	    return new playerjs.VideoJSAdapter(player);
	  }
	  this.init(player);
	};
	
	playerjs.VideoJSAdapter.prototype.init = function(player){
	
	  playerjs.assert(player, 'playerjs.VideoJSReceiver requires a player object');
	
	  // Set up the actual receiver
	  var receiver = this.receiver = new playerjs.Receiver();
	
	  /* EVENTS */
	  player.on("pause", function(){
	    receiver.emit('pause');
	  });
	
	  player.on("play", function(){
	    receiver.emit('play');
	  });
	
	  player.on("timeupdate", function(e){
	    var seconds = player.currentTime(),
	      duration = player.duration();
	
	    if (!seconds || !duration){
	      return false;
	    }
	
	    var value = {
	      seconds: seconds,
	      duration: duration
	    };
	    receiver.emit('timeupdate', value);
	  });
	
	  player.on("ended", function(){
	    receiver.emit('ended');
	  });
	
	  player.on("error", function(){
	    receiver.emit('error');
	  });
	
	
	  /* METHODS */
	  receiver.on('play', function(){
	    player.play();
	  });
	
	  receiver.on('pause', function(){
	    player.pause();
	  });
	
	  receiver.on('getPaused', function(callback){
	    callback(player.paused());
	  });
	
	  receiver.on('getCurrentTime', function(callback){
	    callback(player.currentTime());
	  });
	
	  receiver.on('setCurrentTime', function(value){
	    player.currentTime(value);
	  });
	
	  receiver.on('getDuration', function(callback){
	    callback(player.duration());
	  });
	
	  receiver.on('getVolume', function(callback){
	    callback(player.volume() * 100);
	  });
	
	  receiver.on('setVolume', function(value){
	    player.volume(value/100);
	  });
	
	  receiver.on('mute', function(){
	    player.volume(0);
	  });
	
	  receiver.on('unmute', function(){
	    player.volume(1);
	  });
	
	  receiver.on('getMuted', function(callback){
	    callback(player.volume() === 0);
	  });
	
	  receiver.on('getLoop', function(callback){
	    callback(player.loop());
	  });
	
	  receiver.on('setLoop', function(value){
	    player.loop(value);
	  });
	};
	
	/* Call when the video.js is ready */
	playerjs.VideoJSAdapter.prototype.ready = function(){
	  this.receiver.ready();
	};
	
	})(window, document);

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	if (false) {
	  var invariant = require('fbjs/lib/invariant');
	  var warning = require('fbjs/lib/warning');
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(59);
	var invariant = __webpack_require__(10);
	
	module.exports = function() {
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  function shim() {
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(59);
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(16);
	
	var ReactPropTypesSecret = __webpack_require__(1451);
	var checkPropTypes = __webpack_require__(1448);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 1451 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(1659);
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str) {
		if (typeof str !== 'string') {
			return {};
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return {};
		}
	
		return str.split('&').reduce(function (ret, param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			key = decodeURIComponent(key);
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			if (!ret.hasOwnProperty(key)) {
				ret[key] = val;
			} else if (Array.isArray(ret[key])) {
				ret[key].push(val);
			} else {
				ret[key] = [ret[key], val];
			}
	
			return ret;
		}, {});
	};
	
	exports.stringify = function (obj) {
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return key;
			}
	
			if (Array.isArray(val)) {
				return val.slice().sort().map(function (val2) {
					return strictUriEncode(key) + '=' + strictUriEncode(val2);
				}).join('&');
			}
	
			return strictUriEncode(key) + '=' + strictUriEncode(val);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _union = __webpack_require__(1442);
	
	var _union2 = _interopRequireDefault(_union);
	
	var _without = __webpack_require__(593);
	
	var _without2 = _interopRequireDefault(_without);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EnterLeaveCounter = function () {
	  function EnterLeaveCounter() {
	    _classCallCheck(this, EnterLeaveCounter);
	
	    this.entered = [];
	  }
	
	  _createClass(EnterLeaveCounter, [{
	    key: 'enter',
	    value: function enter(enteringNode) {
	      var previousLength = this.entered.length;
	
	      var isNodeEntered = function isNodeEntered(node) {
	        return document.documentElement.contains(node) && (!node.contains || node.contains(enteringNode));
	      };
	
	      this.entered = (0, _union2.default)(this.entered.filter(isNodeEntered), [enteringNode]);
	
	      return previousLength === 0 && this.entered.length > 0;
	    }
	  }, {
	    key: 'leave',
	    value: function leave(leavingNode) {
	      var previousLength = this.entered.length;
	
	      this.entered = (0, _without2.default)(this.entered.filter(function (node) {
	        return document.documentElement.contains(node);
	      }), leavingNode);
	
	      return previousLength > 0 && this.entered.length === 0;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.entered = [];
	    }
	  }]);
	
	  return EnterLeaveCounter;
	}();
	
	exports.default = EnterLeaveCounter;

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _defaults = __webpack_require__(1431);
	
	var _defaults2 = _interopRequireDefault(_defaults);
	
	var _shallowEqual = __webpack_require__(1459);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _EnterLeaveCounter = __webpack_require__(1453);
	
	var _EnterLeaveCounter2 = _interopRequireDefault(_EnterLeaveCounter);
	
	var _BrowserDetector = __webpack_require__(597);
	
	var _OffsetUtils = __webpack_require__(1457);
	
	var _NativeDragSources = __webpack_require__(1456);
	
	var _NativeTypes = __webpack_require__(383);
	
	var NativeTypes = _interopRequireWildcard(_NativeTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HTML5Backend = function () {
	  function HTML5Backend(manager) {
	    _classCallCheck(this, HTML5Backend);
	
	    this.actions = manager.getActions();
	    this.monitor = manager.getMonitor();
	    this.registry = manager.getRegistry();
	    this.context = manager.getContext();
	
	    this.sourcePreviewNodes = {};
	    this.sourcePreviewNodeOptions = {};
	    this.sourceNodes = {};
	    this.sourceNodeOptions = {};
	    this.enterLeaveCounter = new _EnterLeaveCounter2.default();
	
	    this.dragStartSourceIds = [];
	    this.dropTargetIds = [];
	    this.dragEnterTargetIds = [];
	    this.currentNativeSource = null;
	    this.currentNativeHandle = null;
	    this.currentDragSourceNode = null;
	    this.currentDragSourceNodeOffset = null;
	    this.currentDragSourceNodeOffsetChanged = false;
	    this.altKeyPressed = false;
	
	    this.getSourceClientOffset = this.getSourceClientOffset.bind(this);
	    this.handleTopDragStart = this.handleTopDragStart.bind(this);
	    this.handleTopDragStartCapture = this.handleTopDragStartCapture.bind(this);
	    this.handleTopDragEndCapture = this.handleTopDragEndCapture.bind(this);
	    this.handleTopDragEnter = this.handleTopDragEnter.bind(this);
	    this.handleTopDragEnterCapture = this.handleTopDragEnterCapture.bind(this);
	    this.handleTopDragLeaveCapture = this.handleTopDragLeaveCapture.bind(this);
	    this.handleTopDragOver = this.handleTopDragOver.bind(this);
	    this.handleTopDragOverCapture = this.handleTopDragOverCapture.bind(this);
	    this.handleTopDrop = this.handleTopDrop.bind(this);
	    this.handleTopDropCapture = this.handleTopDropCapture.bind(this);
	    this.handleSelectStart = this.handleSelectStart.bind(this);
	    this.endDragIfSourceWasRemovedFromDOM = this.endDragIfSourceWasRemovedFromDOM.bind(this);
	    this.endDragNativeItem = this.endDragNativeItem.bind(this);
	  }
	
	  _createClass(HTML5Backend, [{
	    key: 'setup',
	    value: function setup() {
	      if (this.window === undefined) {
	        return;
	      }
	
	      if (this.window.__isReactDndBackendSetUp) {
	        // eslint-disable-line no-underscore-dangle
	        throw new Error('Cannot have two HTML5 backends at the same time.');
	      }
	      this.window.__isReactDndBackendSetUp = true; // eslint-disable-line no-underscore-dangle
	      this.addEventListeners(this.window);
	    }
	  }, {
	    key: 'teardown',
	    value: function teardown() {
	      if (this.window === undefined) {
	        return;
	      }
	
	      this.window.__isReactDndBackendSetUp = false; // eslint-disable-line no-underscore-dangle
	      this.removeEventListeners(this.window);
	      this.clearCurrentDragSourceNode();
	    }
	  }, {
	    key: 'addEventListeners',
	    value: function addEventListeners(target) {
	      target.addEventListener('dragstart', this.handleTopDragStart);
	      target.addEventListener('dragstart', this.handleTopDragStartCapture, true);
	      target.addEventListener('dragend', this.handleTopDragEndCapture, true);
	      target.addEventListener('dragenter', this.handleTopDragEnter);
	      target.addEventListener('dragenter', this.handleTopDragEnterCapture, true);
	      target.addEventListener('dragleave', this.handleTopDragLeaveCapture, true);
	      target.addEventListener('dragover', this.handleTopDragOver);
	      target.addEventListener('dragover', this.handleTopDragOverCapture, true);
	      target.addEventListener('drop', this.handleTopDrop);
	      target.addEventListener('drop', this.handleTopDropCapture, true);
	    }
	  }, {
	    key: 'removeEventListeners',
	    value: function removeEventListeners(target) {
	      target.removeEventListener('dragstart', this.handleTopDragStart);
	      target.removeEventListener('dragstart', this.handleTopDragStartCapture, true);
	      target.removeEventListener('dragend', this.handleTopDragEndCapture, true);
	      target.removeEventListener('dragenter', this.handleTopDragEnter);
	      target.removeEventListener('dragenter', this.handleTopDragEnterCapture, true);
	      target.removeEventListener('dragleave', this.handleTopDragLeaveCapture, true);
	      target.removeEventListener('dragover', this.handleTopDragOver);
	      target.removeEventListener('dragover', this.handleTopDragOverCapture, true);
	      target.removeEventListener('drop', this.handleTopDrop);
	      target.removeEventListener('drop', this.handleTopDropCapture, true);
	    }
	  }, {
	    key: 'connectDragPreview',
	    value: function connectDragPreview(sourceId, node, options) {
	      var _this = this;
	
	      this.sourcePreviewNodeOptions[sourceId] = options;
	      this.sourcePreviewNodes[sourceId] = node;
	
	      return function () {
	        delete _this.sourcePreviewNodes[sourceId];
	        delete _this.sourcePreviewNodeOptions[sourceId];
	      };
	    }
	  }, {
	    key: 'connectDragSource',
	    value: function connectDragSource(sourceId, node, options) {
	      var _this2 = this;
	
	      this.sourceNodes[sourceId] = node;
	      this.sourceNodeOptions[sourceId] = options;
	
	      var handleDragStart = function handleDragStart(e) {
	        return _this2.handleDragStart(e, sourceId);
	      };
	      var handleSelectStart = function handleSelectStart(e) {
	        return _this2.handleSelectStart(e, sourceId);
	      };
	
	      node.setAttribute('draggable', true);
	      node.addEventListener('dragstart', handleDragStart);
	      node.addEventListener('selectstart', handleSelectStart);
	
	      return function () {
	        delete _this2.sourceNodes[sourceId];
	        delete _this2.sourceNodeOptions[sourceId];
	
	        node.removeEventListener('dragstart', handleDragStart);
	        node.removeEventListener('selectstart', handleSelectStart);
	        node.setAttribute('draggable', false);
	      };
	    }
	  }, {
	    key: 'connectDropTarget',
	    value: function connectDropTarget(targetId, node) {
	      var _this3 = this;
	
	      var handleDragEnter = function handleDragEnter(e) {
	        return _this3.handleDragEnter(e, targetId);
	      };
	      var handleDragOver = function handleDragOver(e) {
	        return _this3.handleDragOver(e, targetId);
	      };
	      var handleDrop = function handleDrop(e) {
	        return _this3.handleDrop(e, targetId);
	      };
	
	      node.addEventListener('dragenter', handleDragEnter);
	      node.addEventListener('dragover', handleDragOver);
	      node.addEventListener('drop', handleDrop);
	
	      return function () {
	        node.removeEventListener('dragenter', handleDragEnter);
	        node.removeEventListener('dragover', handleDragOver);
	        node.removeEventListener('drop', handleDrop);
	      };
	    }
	  }, {
	    key: 'getCurrentSourceNodeOptions',
	    value: function getCurrentSourceNodeOptions() {
	      var sourceId = this.monitor.getSourceId();
	      var sourceNodeOptions = this.sourceNodeOptions[sourceId];
	
	      return (0, _defaults2.default)(sourceNodeOptions || {}, {
	        dropEffect: this.altKeyPressed ? 'copy' : 'move'
	      });
	    }
	  }, {
	    key: 'getCurrentDropEffect',
	    value: function getCurrentDropEffect() {
	      if (this.isDraggingNativeItem()) {
	        // It makes more sense to default to 'copy' for native resources
	        return 'copy';
	      }
	
	      return this.getCurrentSourceNodeOptions().dropEffect;
	    }
	  }, {
	    key: 'getCurrentSourcePreviewNodeOptions',
	    value: function getCurrentSourcePreviewNodeOptions() {
	      var sourceId = this.monitor.getSourceId();
	      var sourcePreviewNodeOptions = this.sourcePreviewNodeOptions[sourceId];
	
	      return (0, _defaults2.default)(sourcePreviewNodeOptions || {}, {
	        anchorX: 0.5,
	        anchorY: 0.5,
	        captureDraggingState: false
	      });
	    }
	  }, {
	    key: 'getSourceClientOffset',
	    value: function getSourceClientOffset(sourceId) {
	      return (0, _OffsetUtils.getNodeClientOffset)(this.sourceNodes[sourceId]);
	    }
	  }, {
	    key: 'isDraggingNativeItem',
	    value: function isDraggingNativeItem() {
	      var itemType = this.monitor.getItemType();
	      return Object.keys(NativeTypes).some(function (key) {
	        return NativeTypes[key] === itemType;
	      });
	    }
	  }, {
	    key: 'beginDragNativeItem',
	    value: function beginDragNativeItem(type) {
	      this.clearCurrentDragSourceNode();
	
	      var SourceType = (0, _NativeDragSources.createNativeDragSource)(type);
	      this.currentNativeSource = new SourceType();
	      this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
	      this.actions.beginDrag([this.currentNativeHandle]);
	
	      // On Firefox, if mousemove fires, the drag is over but browser failed to tell us.
	      // This is not true for other browsers.
	      if ((0, _BrowserDetector.isFirefox)()) {
	        this.window.addEventListener('mousemove', this.endDragNativeItem, true);
	      }
	    }
	  }, {
	    key: 'endDragNativeItem',
	    value: function endDragNativeItem() {
	      if (!this.isDraggingNativeItem()) {
	        return;
	      }
	
	      if ((0, _BrowserDetector.isFirefox)()) {
	        this.window.removeEventListener('mousemove', this.endDragNativeItem, true);
	      }
	
	      this.actions.endDrag();
	      this.registry.removeSource(this.currentNativeHandle);
	      this.currentNativeHandle = null;
	      this.currentNativeSource = null;
	    }
	  }, {
	    key: 'endDragIfSourceWasRemovedFromDOM',
	    value: function endDragIfSourceWasRemovedFromDOM() {
	      var node = this.currentDragSourceNode;
	      if (document.body.contains(node)) {
	        return;
	      }
	
	      if (this.clearCurrentDragSourceNode()) {
	        this.actions.endDrag();
	      }
	    }
	  }, {
	    key: 'setCurrentDragSourceNode',
	    value: function setCurrentDragSourceNode(node) {
	      this.clearCurrentDragSourceNode();
	      this.currentDragSourceNode = node;
	      this.currentDragSourceNodeOffset = (0, _OffsetUtils.getNodeClientOffset)(node);
	      this.currentDragSourceNodeOffsetChanged = false;
	
	      // Receiving a mouse event in the middle of a dragging operation
	      // means it has ended and the drag source node disappeared from DOM,
	      // so the browser didn't dispatch the dragend event.
	      this.window.addEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
	    }
	  }, {
	    key: 'clearCurrentDragSourceNode',
	    value: function clearCurrentDragSourceNode() {
	      if (this.currentDragSourceNode) {
	        this.currentDragSourceNode = null;
	        this.currentDragSourceNodeOffset = null;
	        this.currentDragSourceNodeOffsetChanged = false;
	        this.window.removeEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: 'checkIfCurrentDragSourceRectChanged',
	    value: function checkIfCurrentDragSourceRectChanged() {
	      var node = this.currentDragSourceNode;
	      if (!node) {
	        return false;
	      }
	
	      if (this.currentDragSourceNodeOffsetChanged) {
	        return true;
	      }
	
	      this.currentDragSourceNodeOffsetChanged = !(0, _shallowEqual2.default)((0, _OffsetUtils.getNodeClientOffset)(node), this.currentDragSourceNodeOffset);
	
	      return this.currentDragSourceNodeOffsetChanged;
	    }
	  }, {
	    key: 'handleTopDragStartCapture',
	    value: function handleTopDragStartCapture() {
	      this.clearCurrentDragSourceNode();
	      this.dragStartSourceIds = [];
	    }
	  }, {
	    key: 'handleDragStart',
	    value: function handleDragStart(e, sourceId) {
	      this.dragStartSourceIds.unshift(sourceId);
	    }
	  }, {
	    key: 'handleTopDragStart',
	    value: function handleTopDragStart(e) {
	      var _this4 = this;
	
	      var dragStartSourceIds = this.dragStartSourceIds;
	
	      this.dragStartSourceIds = null;
	
	      var clientOffset = (0, _OffsetUtils.getEventClientOffset)(e);
	
	      // Don't publish the source just yet (see why below)
	      this.actions.beginDrag(dragStartSourceIds, {
	        publishSource: false,
	        getSourceClientOffset: this.getSourceClientOffset,
	        clientOffset: clientOffset
	      });
	
	      var dataTransfer = e.dataTransfer;
	
	      var nativeType = (0, _NativeDragSources.matchNativeItemType)(dataTransfer);
	
	      if (this.monitor.isDragging()) {
	        if (typeof dataTransfer.setDragImage === 'function') {
	          // Use custom drag image if user specifies it.
	          // If child drag source refuses drag but parent agrees,
	          // use parent's node as drag image. Neither works in IE though.
	          var sourceId = this.monitor.getSourceId();
	          var sourceNode = this.sourceNodes[sourceId];
	          var dragPreview = this.sourcePreviewNodes[sourceId] || sourceNode;
	
	          var _getCurrentSourcePrev = this.getCurrentSourcePreviewNodeOptions(),
	              anchorX = _getCurrentSourcePrev.anchorX,
	              anchorY = _getCurrentSourcePrev.anchorY;
	
	          var anchorPoint = { anchorX: anchorX, anchorY: anchorY };
	          var dragPreviewOffset = (0, _OffsetUtils.getDragPreviewOffset)(sourceNode, dragPreview, clientOffset, anchorPoint);
	          dataTransfer.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
	        }
	
	        try {
	          // Firefox won't drag without setting data
	          dataTransfer.setData('application/json', {});
	        } catch (err) {}
	        // IE doesn't support MIME types in setData
	
	
	        // Store drag source node so we can check whether
	        // it is removed from DOM and trigger endDrag manually.
	        this.setCurrentDragSourceNode(e.target);
	
	        // Now we are ready to publish the drag source.. or are we not?
	
	        var _getCurrentSourcePrev2 = this.getCurrentSourcePreviewNodeOptions(),
	            captureDraggingState = _getCurrentSourcePrev2.captureDraggingState;
	
	        if (!captureDraggingState) {
	          // Usually we want to publish it in the next tick so that browser
	          // is able to screenshot the current (not yet dragging) state.
	          //
	          // It also neatly avoids a situation where render() returns null
	          // in the same tick for the source element, and browser freaks out.
	          setTimeout(function () {
	            return _this4.actions.publishDragSource();
	          });
	        } else {
	          // In some cases the user may want to override this behavior, e.g.
	          // to work around IE not supporting custom drag previews.
	          //
	          // When using a custom drag layer, the only way to prevent
	          // the default drag preview from drawing in IE is to screenshot
	          // the dragging state in which the node itself has zero opacity
	          // and height. In this case, though, returning null from render()
	          // will abruptly end the dragging, which is not obvious.
	          //
	          // This is the reason such behavior is strictly opt-in.
	          this.actions.publishDragSource();
	        }
	      } else if (nativeType) {
	        // A native item (such as URL) dragged from inside the document
	        this.beginDragNativeItem(nativeType);
	      } else if (!dataTransfer.types && (!e.target.hasAttribute || !e.target.hasAttribute('draggable'))) {
	        // Looks like a Safari bug: dataTransfer.types is null, but there was no draggable.
	        // Just let it drag. It's a native type (URL or text) and will be picked up in
	        // dragenter handler.
	        return; // eslint-disable-line no-useless-return
	      } else {
	        // If by this time no drag source reacted, tell browser not to drag.
	        e.preventDefault();
	      }
	    }
	  }, {
	    key: 'handleTopDragEndCapture',
	    value: function handleTopDragEndCapture() {
	      if (this.clearCurrentDragSourceNode()) {
	        // Firefox can dispatch this event in an infinite loop
	        // if dragend handler does something like showing an alert.
	        // Only proceed if we have not handled it already.
	        this.actions.endDrag();
	      }
	    }
	  }, {
	    key: 'handleTopDragEnterCapture',
	    value: function handleTopDragEnterCapture(e) {
	      this.dragEnterTargetIds = [];
	
	      var isFirstEnter = this.enterLeaveCounter.enter(e.target);
	      if (!isFirstEnter || this.monitor.isDragging()) {
	        return;
	      }
	
	      var dataTransfer = e.dataTransfer;
	
	      var nativeType = (0, _NativeDragSources.matchNativeItemType)(dataTransfer);
	
	      if (nativeType) {
	        // A native item (such as file or URL) dragged from outside the document
	        this.beginDragNativeItem(nativeType);
	      }
	    }
	  }, {
	    key: 'handleDragEnter',
	    value: function handleDragEnter(e, targetId) {
	      this.dragEnterTargetIds.unshift(targetId);
	    }
	  }, {
	    key: 'handleTopDragEnter',
	    value: function handleTopDragEnter(e) {
	      var _this5 = this;
	
	      var dragEnterTargetIds = this.dragEnterTargetIds;
	
	      this.dragEnterTargetIds = [];
	
	      if (!this.monitor.isDragging()) {
	        // This is probably a native item type we don't understand.
	        return;
	      }
	
	      this.altKeyPressed = e.altKey;
	
	      if (!(0, _BrowserDetector.isFirefox)()) {
	        // Don't emit hover in `dragenter` on Firefox due to an edge case.
	        // If the target changes position as the result of `dragenter`, Firefox
	        // will still happily dispatch `dragover` despite target being no longer
	        // there. The easy solution is to only fire `hover` in `dragover` on FF.
	        this.actions.hover(dragEnterTargetIds, {
	          clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
	        });
	      }
	
	      var canDrop = dragEnterTargetIds.some(function (targetId) {
	        return _this5.monitor.canDropOnTarget(targetId);
	      });
	
	      if (canDrop) {
	        // IE requires this to fire dragover events
	        e.preventDefault();
	        e.dataTransfer.dropEffect = this.getCurrentDropEffect();
	      }
	    }
	  }, {
	    key: 'handleTopDragOverCapture',
	    value: function handleTopDragOverCapture() {
	      this.dragOverTargetIds = [];
	    }
	  }, {
	    key: 'handleDragOver',
	    value: function handleDragOver(e, targetId) {
	      this.dragOverTargetIds.unshift(targetId);
	    }
	  }, {
	    key: 'handleTopDragOver',
	    value: function handleTopDragOver(e) {
	      var _this6 = this;
	
	      var dragOverTargetIds = this.dragOverTargetIds;
	
	      this.dragOverTargetIds = [];
	
	      if (!this.monitor.isDragging()) {
	        // This is probably a native item type we don't understand.
	        // Prevent default "drop and blow away the whole document" action.
	        e.preventDefault();
	        e.dataTransfer.dropEffect = 'none';
	        return;
	      }
	
	      this.altKeyPressed = e.altKey;
	
	      this.actions.hover(dragOverTargetIds, {
	        clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
	      });
	
	      var canDrop = dragOverTargetIds.some(function (targetId) {
	        return _this6.monitor.canDropOnTarget(targetId);
	      });
	
	      if (canDrop) {
	        // Show user-specified drop effect.
	        e.preventDefault();
	        e.dataTransfer.dropEffect = this.getCurrentDropEffect();
	      } else if (this.isDraggingNativeItem()) {
	        // Don't show a nice cursor but still prevent default
	        // "drop and blow away the whole document" action.
	        e.preventDefault();
	        e.dataTransfer.dropEffect = 'none';
	      } else if (this.checkIfCurrentDragSourceRectChanged()) {
	        // Prevent animating to incorrect position.
	        // Drop effect must be other than 'none' to prevent animation.
	        e.preventDefault();
	        e.dataTransfer.dropEffect = 'move';
	      }
	    }
	  }, {
	    key: 'handleTopDragLeaveCapture',
	    value: function handleTopDragLeaveCapture(e) {
	      if (this.isDraggingNativeItem()) {
	        e.preventDefault();
	      }
	
	      var isLastLeave = this.enterLeaveCounter.leave(e.target);
	      if (!isLastLeave) {
	        return;
	      }
	
	      if (this.isDraggingNativeItem()) {
	        this.endDragNativeItem();
	      }
	    }
	  }, {
	    key: 'handleTopDropCapture',
	    value: function handleTopDropCapture(e) {
	      this.dropTargetIds = [];
	      e.preventDefault();
	
	      if (this.isDraggingNativeItem()) {
	        this.currentNativeSource.mutateItemByReadingDataTransfer(e.dataTransfer);
	      }
	
	      this.enterLeaveCounter.reset();
	    }
	  }, {
	    key: 'handleDrop',
	    value: function handleDrop(e, targetId) {
	      this.dropTargetIds.unshift(targetId);
	    }
	  }, {
	    key: 'handleTopDrop',
	    value: function handleTopDrop(e) {
	      var dropTargetIds = this.dropTargetIds;
	
	      this.dropTargetIds = [];
	
	      this.actions.hover(dropTargetIds, {
	        clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
	      });
	      this.actions.drop({ dropEffect: this.getCurrentDropEffect() });
	
	      if (this.isDraggingNativeItem()) {
	        this.endDragNativeItem();
	      } else {
	        this.endDragIfSourceWasRemovedFromDOM();
	      }
	    }
	  }, {
	    key: 'handleSelectStart',
	    value: function handleSelectStart(e) {
	      var target = e.target;
	
	      // Only IE requires us to explicitly say
	      // we want drag drop operation to start
	
	      if (typeof target.dragDrop !== 'function') {
	        return;
	      }
	
	      // Inputs and textareas should be selectable
	      if (target.tagName === 'INPUT' || target.tagName === 'SELECT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
	        return;
	      }
	
	      // For other targets, ask IE
	      // to enable drag and drop
	      e.preventDefault();
	      target.dragDrop();
	    }
	  }, {
	    key: 'window',
	    get: function get() {
	      if (this.context && this.context.window) {
	        return this.context.window;
	      } else if (typeof window !== 'undefined') {
	        return window;
	      }
	      return undefined;
	    }
	  }]);
	
	  return HTML5Backend;
	}();
	
	exports.default = HTML5Backend;

/***/ }),
/* 1455 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/* eslint
	   no-plusplus: off,
	   no-mixed-operators: off
	*/
	var MonotonicInterpolant = function () {
	  function MonotonicInterpolant(xs, ys) {
	    _classCallCheck(this, MonotonicInterpolant);
	
	    var length = xs.length;
	
	    // Rearrange xs and ys so that xs is sorted
	    var indexes = [];
	    for (var i = 0; i < length; i++) {
	      indexes.push(i);
	    }
	    indexes.sort(function (a, b) {
	      return xs[a] < xs[b] ? -1 : 1;
	    });
	
	    // Get consecutive differences and slopes
	    var dys = [];
	    var dxs = [];
	    var ms = [];
	    var dx = void 0;
	    var dy = void 0;
	    for (var _i = 0; _i < length - 1; _i++) {
	      dx = xs[_i + 1] - xs[_i];
	      dy = ys[_i + 1] - ys[_i];
	      dxs.push(dx);
	      dys.push(dy);
	      ms.push(dy / dx);
	    }
	
	    // Get degree-1 coefficients
	    var c1s = [ms[0]];
	    for (var _i2 = 0; _i2 < dxs.length - 1; _i2++) {
	      var _m = ms[_i2];
	      var mNext = ms[_i2 + 1];
	      if (_m * mNext <= 0) {
	        c1s.push(0);
	      } else {
	        dx = dxs[_i2];
	        var dxNext = dxs[_i2 + 1];
	        var common = dx + dxNext;
	        c1s.push(3 * common / ((common + dxNext) / _m + (common + dx) / mNext));
	      }
	    }
	    c1s.push(ms[ms.length - 1]);
	
	    // Get degree-2 and degree-3 coefficients
	    var c2s = [];
	    var c3s = [];
	    var m = void 0;
	    for (var _i3 = 0; _i3 < c1s.length - 1; _i3++) {
	      m = ms[_i3];
	      var c1 = c1s[_i3];
	      var invDx = 1 / dxs[_i3];
	      var _common = c1 + c1s[_i3 + 1] - m - m;
	      c2s.push((m - c1 - _common) * invDx);
	      c3s.push(_common * invDx * invDx);
	    }
	
	    this.xs = xs;
	    this.ys = ys;
	    this.c1s = c1s;
	    this.c2s = c2s;
	    this.c3s = c3s;
	  }
	
	  _createClass(MonotonicInterpolant, [{
	    key: "interpolate",
	    value: function interpolate(x) {
	      var xs = this.xs,
	          ys = this.ys,
	          c1s = this.c1s,
	          c2s = this.c2s,
	          c3s = this.c3s;
	
	      // The rightmost point in the dataset should give an exact result
	
	      var i = xs.length - 1;
	      if (x === xs[i]) {
	        return ys[i];
	      }
	
	      // Search for the interval x is in, returning the corresponding y if x is one of the original xs
	      var low = 0;
	      var high = c3s.length - 1;
	      var mid = void 0;
	      while (low <= high) {
	        mid = Math.floor(0.5 * (low + high));
	        var xHere = xs[mid];
	        if (xHere < x) {
	          low = mid + 1;
	        } else if (xHere > x) {
	          high = mid - 1;
	        } else {
	          return ys[mid];
	        }
	      }
	      i = Math.max(0, high);
	
	      // Interpolate
	      var diff = x - xs[i];
	      var diffSq = diff * diff;
	      return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
	    }
	  }]);
	
	  return MonotonicInterpolant;
	}();
	
	exports.default = MonotonicInterpolant;

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _nativeTypesConfig;
	
	exports.createNativeDragSource = createNativeDragSource;
	exports.matchNativeItemType = matchNativeItemType;
	
	var _NativeTypes = __webpack_require__(383);
	
	var NativeTypes = _interopRequireWildcard(_NativeTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function getDataFromDataTransfer(dataTransfer, typesToTry, defaultValue) {
	  var result = typesToTry.reduce(function (resultSoFar, typeToTry) {
	    return resultSoFar || dataTransfer.getData(typeToTry);
	  }, null);
	
	  return result != null ? // eslint-disable-line eqeqeq
	  result : defaultValue;
	}
	
	var nativeTypesConfig = (_nativeTypesConfig = {}, _defineProperty(_nativeTypesConfig, NativeTypes.FILE, {
	  exposeProperty: 'files',
	  matchesTypes: ['Files'],
	  getData: function getData(dataTransfer) {
	    return Array.prototype.slice.call(dataTransfer.files);
	  }
	}), _defineProperty(_nativeTypesConfig, NativeTypes.URL, {
	  exposeProperty: 'urls',
	  matchesTypes: ['Url', 'text/uri-list'],
	  getData: function getData(dataTransfer, matchesTypes) {
	    return getDataFromDataTransfer(dataTransfer, matchesTypes, '').split('\n');
	  }
	}), _defineProperty(_nativeTypesConfig, NativeTypes.TEXT, {
	  exposeProperty: 'text',
	  matchesTypes: ['Text', 'text/plain'],
	  getData: function getData(dataTransfer, matchesTypes) {
	    return getDataFromDataTransfer(dataTransfer, matchesTypes, '');
	  }
	}), _nativeTypesConfig);
	
	function createNativeDragSource(type) {
	  var _nativeTypesConfig$ty = nativeTypesConfig[type],
	      exposeProperty = _nativeTypesConfig$ty.exposeProperty,
	      matchesTypes = _nativeTypesConfig$ty.matchesTypes,
	      getData = _nativeTypesConfig$ty.getData;
	
	
	  return function () {
	    function NativeDragSource() {
	      var _item, _mutatorMap;
	
	      _classCallCheck(this, NativeDragSource);
	
	      this.item = (_item = {}, _mutatorMap = {}, _mutatorMap[exposeProperty] = _mutatorMap[exposeProperty] || {}, _mutatorMap[exposeProperty].get = function () {
	        console.warn( // eslint-disable-line no-console
	        'Browser doesn\'t allow reading "' + exposeProperty + '" until the drop event.');
	        return null;
	      }, _defineEnumerableProperties(_item, _mutatorMap), _item);
	    }
	
	    _createClass(NativeDragSource, [{
	      key: 'mutateItemByReadingDataTransfer',
	      value: function mutateItemByReadingDataTransfer(dataTransfer) {
	        delete this.item[exposeProperty];
	        this.item[exposeProperty] = getData(dataTransfer, matchesTypes);
	      }
	    }, {
	      key: 'canDrag',
	      value: function canDrag() {
	        return true;
	      }
	    }, {
	      key: 'beginDrag',
	      value: function beginDrag() {
	        return this.item;
	      }
	    }, {
	      key: 'isDragging',
	      value: function isDragging(monitor, handle) {
	        return handle === monitor.getSourceId();
	      }
	    }, {
	      key: 'endDrag',
	      value: function endDrag() {}
	    }]);
	
	    return NativeDragSource;
	  }();
	}
	
	function matchNativeItemType(dataTransfer) {
	  var dataTransferTypes = Array.prototype.slice.call(dataTransfer.types || []);
	
	  return Object.keys(nativeTypesConfig).filter(function (nativeItemType) {
	    var matchesTypes = nativeTypesConfig[nativeItemType].matchesTypes;
	
	    return matchesTypes.some(function (t) {
	      return dataTransferTypes.indexOf(t) > -1;
	    });
	  })[0] || null;
	}

/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getNodeClientOffset = getNodeClientOffset;
	exports.getEventClientOffset = getEventClientOffset;
	exports.getDragPreviewOffset = getDragPreviewOffset;
	
	var _BrowserDetector = __webpack_require__(597);
	
	var _MonotonicInterpolant = __webpack_require__(1455);
	
	var _MonotonicInterpolant2 = _interopRequireDefault(_MonotonicInterpolant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint
	   no-mixed-operators: off
	*/
	var ELEMENT_NODE = 1;
	
	function getNodeClientOffset(node) {
	  var el = node.nodeType === ELEMENT_NODE ? node : node.parentElement;
	
	  if (!el) {
	    return null;
	  }
	
	  var _el$getBoundingClient = el.getBoundingClientRect(),
	      top = _el$getBoundingClient.top,
	      left = _el$getBoundingClient.left;
	
	  return { x: left, y: top };
	}
	
	function getEventClientOffset(e) {
	  return {
	    x: e.clientX,
	    y: e.clientY
	  };
	}
	
	function getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint) {
	  // The browsers will use the image intrinsic size under different conditions.
	  // Firefox only cares if it's an image, but WebKit also wants it to be detached.
	  var isImage = dragPreview.nodeName === 'IMG' && ((0, _BrowserDetector.isFirefox)() || !document.documentElement.contains(dragPreview));
	  var dragPreviewNode = isImage ? sourceNode : dragPreview;
	
	  var dragPreviewNodeOffsetFromClient = getNodeClientOffset(dragPreviewNode);
	  var offsetFromDragPreview = {
	    x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
	    y: clientOffset.y - dragPreviewNodeOffsetFromClient.y
	  };
	
	  var sourceWidth = sourceNode.offsetWidth,
	      sourceHeight = sourceNode.offsetHeight;
	  var anchorX = anchorPoint.anchorX,
	      anchorY = anchorPoint.anchorY;
	
	
	  var dragPreviewWidth = isImage ? dragPreview.width : sourceWidth;
	  var dragPreviewHeight = isImage ? dragPreview.height : sourceHeight;
	
	  // Work around @2x coordinate discrepancies in browsers
	  if ((0, _BrowserDetector.isSafari)() && isImage) {
	    dragPreviewHeight /= window.devicePixelRatio;
	    dragPreviewWidth /= window.devicePixelRatio;
	  } else if ((0, _BrowserDetector.isFirefox)() && !isImage) {
	    dragPreviewHeight *= window.devicePixelRatio;
	    dragPreviewWidth *= window.devicePixelRatio;
	  }
	
	  // Interpolate coordinates depending on anchor point
	  // If you know a simpler way to do this, let me know
	  var interpolantX = new _MonotonicInterpolant2.default([0, 0.5, 1], [
	  // Dock to the left
	  offsetFromDragPreview.x,
	  // Align at the center
	  offsetFromDragPreview.x / sourceWidth * dragPreviewWidth,
	  // Dock to the right
	  offsetFromDragPreview.x + dragPreviewWidth - sourceWidth]);
	  var interpolantY = new _MonotonicInterpolant2.default([0, 0.5, 1], [
	  // Dock to the top
	  offsetFromDragPreview.y,
	  // Align at the center
	  offsetFromDragPreview.y / sourceHeight * dragPreviewHeight,
	  // Dock to the bottom
	  offsetFromDragPreview.y + dragPreviewHeight - sourceHeight]);
	  var x = interpolantX.interpolate(anchorX);
	  var y = interpolantY.interpolate(anchorY);
	
	  // Work around Safari 8 positioning bug
	  if ((0, _BrowserDetector.isSafari)() && isImage) {
	    // We'll have to wait for @3x to see if this is entirely correct
	    y += (window.devicePixelRatio - 1) * dragPreviewHeight;
	  }
	
	  return { x: x, y: y };
	}

/***/ }),
/* 1458 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getEmptyImage;
	var emptyImage = void 0;
	function getEmptyImage() {
	  if (!emptyImage) {
	    emptyImage = new Image();
	    emptyImage.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
	  }
	
	  return emptyImage;
	}

/***/ }),
/* 1459 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i += 1) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	
	    var valA = objA[keysA[i]];
	    var valB = objB[keysA[i]];
	
	    if (valA !== valB) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the MIT License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TouchBackend = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = createTouchBackend;
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function getEventClientTouchOffset(e) {
	    if (e.targetTouches.length === 1) {
	        return getEventClientOffset(e.targetTouches[0]);
	    }
	}
	
	function getEventClientOffset(e) {
	    if (e.targetTouches) {
	        return getEventClientTouchOffset(e);
	    } else {
	        return {
	            x: e.clientX,
	            y: e.clientY
	        };
	    }
	}
	
	var ELEMENT_NODE = 1;
	function getNodeClientOffset(node) {
	    var el = node.nodeType === ELEMENT_NODE ? node : node.parentElement;
	
	    if (!el) {
	        return null;
	    }
	
	    var _el$getBoundingClient = el.getBoundingClientRect();
	
	    var top = _el$getBoundingClient.top;
	    var left = _el$getBoundingClient.left;
	
	    return { x: left, y: top };
	}
	
	var eventNames = {
	    mouse: {
	        start: 'mousedown',
	        move: 'mousemove',
	        end: 'mouseup'
	    },
	    touch: {
	        start: 'touchstart',
	        move: 'touchmove',
	        end: 'touchend'
	    }
	};
	
	var TouchBackend = exports.TouchBackend = function () {
	    function TouchBackend(manager) {
	        var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	        _classCallCheck(this, TouchBackend);
	
	        options.delayTouchStart = options.delayTouchStart || options.delay;
	
	        options = _extends({
	            enableTouchEvents: true,
	            enableMouseEvents: false,
	            delayTouchStart: 0,
	            delayMouseStart: 0
	        }, options);
	
	        this.actions = manager.getActions();
	        this.monitor = manager.getMonitor();
	        this.registry = manager.getRegistry();
	
	        this.delayTouchStart = options.delayTouchStart;
	        this.delayMouseStart = options.delayMouseStart;
	        this.sourceNodes = {};
	        this.sourceNodeOptions = {};
	        this.sourcePreviewNodes = {};
	        this.sourcePreviewNodeOptions = {};
	        this.targetNodes = {};
	        this.targetNodeOptions = {};
	        this.listenerTypes = [];
	        this._mouseClientOffset = {};
	
	        if (options.enableMouseEvents) {
	            this.listenerTypes.push('mouse');
	        }
	
	        if (options.enableTouchEvents) {
	            this.listenerTypes.push('touch');
	        }
	
	        this.getSourceClientOffset = this.getSourceClientOffset.bind(this);
	        this.handleTopMoveStart = this.handleTopMoveStart.bind(this);
	        this.handleTopMoveStartDelay = this.handleTopMoveStartDelay.bind(this);
	        this.handleTopMoveStartCapture = this.handleTopMoveStartCapture.bind(this);
	        this.handleTopMoveCapture = this.handleTopMoveCapture.bind(this);
	        this.handleTopMoveEndCapture = this.handleTopMoveEndCapture.bind(this);
	    }
	
	    _createClass(TouchBackend, [{
	        key: 'setup',
	        value: function setup() {
	            if (typeof window === 'undefined') {
	                return;
	            }
	
	            (0, _invariant2.default)(!this.constructor.isSetUp, 'Cannot have two Touch backends at the same time.');
	            this.constructor.isSetUp = true;
	
	            this.addEventListener(window, 'start', this.getTopMoveStartHandler());
	            this.addEventListener(window, 'start', this.handleTopMoveStartCapture, true);
	            this.addEventListener(window, 'move', this.handleTopMoveCapture, true);
	            this.addEventListener(window, 'end', this.handleTopMoveEndCapture, true);
	        }
	    }, {
	        key: 'teardown',
	        value: function teardown() {
	            if (typeof window === 'undefined') {
	                return;
	            }
	
	            this.constructor.isSetUp = false;
	            this._mouseClientOffset = {};
	
	            this.removeEventListener(window, 'start', this.handleTopMoveStartCapture, true);
	            this.removeEventListener(window, 'start', this.handleTopMoveStart);
	            this.removeEventListener(window, 'move', this.handleTopMoveCapture, true);
	            this.removeEventListener(window, 'end', this.handleTopMoveEndCapture, true);
	
	            this.uninstallSourceNodeRemovalObserver();
	        }
	    }, {
	        key: 'addEventListener',
	        value: function addEventListener(subject, event, handler, capture) {
	            this.listenerTypes.forEach(function (listenerType) {
	                subject.addEventListener(eventNames[listenerType][event], handler, capture);
	            });
	        }
	    }, {
	        key: 'removeEventListener',
	        value: function removeEventListener(subject, event, handler, capture) {
	            this.listenerTypes.forEach(function (listenerType) {
	                subject.removeEventListener(eventNames[listenerType][event], handler, capture);
	            });
	        }
	    }, {
	        key: 'connectDragSource',
	        value: function connectDragSource(sourceId, node, options) {
	            var _this = this;
	
	            var handleMoveStart = this.handleMoveStart.bind(this, sourceId);
	            this.sourceNodes[sourceId] = node;
	
	            this.addEventListener(node, 'start', handleMoveStart);
	
	            return function () {
	                delete _this.sourceNodes[sourceId];
	                _this.removeEventListener(node, 'start', handleMoveStart);
	            };
	        }
	    }, {
	        key: 'connectDragPreview',
	        value: function connectDragPreview(sourceId, node, options) {
	            var _this2 = this;
	
	            this.sourcePreviewNodeOptions[sourceId] = options;
	            this.sourcePreviewNodes[sourceId] = node;
	
	            return function () {
	                delete _this2.sourcePreviewNodes[sourceId];
	                delete _this2.sourcePreviewNodeOptions[sourceId];
	            };
	        }
	    }, {
	        key: 'connectDropTarget',
	        value: function connectDropTarget(targetId, node) {
	            var _this3 = this;
	
	            this.targetNodes[targetId] = node;
	
	            return function () {
	                delete _this3.targetNodes[targetId];
	            };
	        }
	    }, {
	        key: 'getSourceClientOffset',
	        value: function getSourceClientOffset(sourceId) {
	            return getNodeClientOffset(this.sourceNodes[sourceId]);
	        }
	    }, {
	        key: 'handleTopMoveStartCapture',
	        value: function handleTopMoveStartCapture(e) {
	            this.moveStartSourceIds = [];
	        }
	    }, {
	        key: 'handleMoveStart',
	        value: function handleMoveStart(sourceId) {
	            this.moveStartSourceIds.unshift(sourceId);
	        }
	    }, {
	        key: 'getTopMoveStartHandler',
	        value: function getTopMoveStartHandler() {
	            if (!this.delayTouchStart && !this.delayMouseStart) {
	                return this.handleTopMoveStart;
	            }
	
	            return this.handleTopMoveStartDelay;
	        }
	    }, {
	        key: 'handleTopMoveStart',
	        value: function handleTopMoveStart(e) {
	            // Don't prematurely preventDefault() here since it might:
	            // 1. Mess up scrolling
	            // 2. Mess up long tap (which brings up context menu)
	            // 3. If there's an anchor link as a child, tap won't be triggered on link
	
	            var clientOffset = getEventClientOffset(e);
	            if (clientOffset) {
	                this._mouseClientOffset = clientOffset;
	            }
	        }
	    }, {
	        key: 'handleTopMoveStartDelay',
	        value: function handleTopMoveStartDelay(e) {
	            var delay = e.type === eventNames.touch.start ? this.delayTouchStart : this.delayMouseStart;
	            this.timeout = setTimeout(this.handleTopMoveStart.bind(this, e), delay);
	        }
	    }, {
	        key: 'handleTopMoveCapture',
	        value: function handleTopMoveCapture(e) {
	            var _this4 = this;
	
	            clearTimeout(this.timeout);
	
	            var moveStartSourceIds = this.moveStartSourceIds;
	
	            var clientOffset = getEventClientOffset(e);
	
	            if (!clientOffset) {
	                return;
	            }
	
	            // If we're not dragging and we've moved a little, that counts as a drag start
	            if (!this.monitor.isDragging() && this._mouseClientOffset.hasOwnProperty('x') && moveStartSourceIds && (this._mouseClientOffset.x !== clientOffset.x || this._mouseClientOffset.y !== clientOffset.y)) {
	                this.moveStartSourceIds = null;
	                this.actions.beginDrag(moveStartSourceIds, {
	                    clientOffset: this._mouseClientOffset,
	                    getSourceClientOffset: this.getSourceClientOffset,
	                    publishSource: false
	                });
	            }
	
	            if (!this.monitor.isDragging()) {
	                return;
	            }
	
	            var sourceNode = this.sourceNodes[this.monitor.getSourceId()];
	            this.installSourceNodeRemovalObserver(sourceNode);
	            this.actions.publishDragSource();
	
	            e.preventDefault();
	
	            var matchingTargetIds = Object.keys(this.targetNodes).filter(function (targetId) {
	                var boundingRect = _this4.targetNodes[targetId].getBoundingClientRect();
	                return clientOffset.x >= boundingRect.left && clientOffset.x <= boundingRect.right && clientOffset.y >= boundingRect.top && clientOffset.y <= boundingRect.bottom;
	            });
	
	            this.actions.hover(matchingTargetIds, {
	                clientOffset: clientOffset
	            });
	        }
	    }, {
	        key: 'handleTopMoveEndCapture',
	        value: function handleTopMoveEndCapture(e) {
	            if (!this.monitor.isDragging() || this.monitor.didDrop()) {
	                this.moveStartSourceIds = null;
	                return;
	            }
	
	            e.preventDefault();
	
	            this._mouseClientOffset = {};
	
	            this.uninstallSourceNodeRemovalObserver();
	            this.actions.drop();
	            this.actions.endDrag();
	        }
	    }, {
	        key: 'installSourceNodeRemovalObserver',
	        value: function installSourceNodeRemovalObserver(node) {
	            var _this5 = this;
	
	            this.uninstallSourceNodeRemovalObserver();
	
	            this.draggedSourceNode = node;
	            this.draggedSourceNodeRemovalObserver = new window.MutationObserver(function () {
	                if (!node.parentElement) {
	                    _this5.resurrectSourceNode();
	                    _this5.uninstallSourceNodeRemovalObserver();
	                }
	            });
	
	            if (!node || !node.parentElement) {
	                return;
	            }
	
	            this.draggedSourceNodeRemovalObserver.observe(node.parentElement, { childList: true });
	        }
	    }, {
	        key: 'resurrectSourceNode',
	        value: function resurrectSourceNode() {
	            this.draggedSourceNode.style.display = 'none';
	            this.draggedSourceNode.removeAttribute('data-reactid');
	            document.body.appendChild(this.draggedSourceNode);
	        }
	    }, {
	        key: 'uninstallSourceNodeRemovalObserver',
	        value: function uninstallSourceNodeRemovalObserver() {
	            if (this.draggedSourceNodeRemovalObserver) {
	                this.draggedSourceNodeRemovalObserver.disconnect();
	            }
	
	            this.draggedSourceNodeRemovalObserver = null;
	            this.draggedSourceNode = null;
	        }
	    }]);
	
	    return TouchBackend;
	}();
	
	function createTouchBackend() {
	    var optionsOrManager = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var touchBackendFactory = function touchBackendFactory(manager) {
	        return new TouchBackend(manager, optionsOrManager);
	    };
	
	    if (optionsOrManager.getMonitor) {
	        return touchBackendFactory(optionsOrManager);
	    } else {
	        return touchBackendFactory;
	    }
	}

/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _DragDropContext = __webpack_require__(598);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This class is a React-Component based version of the DragDropContext.
	 * This is an alternative to decorating an application component with an ES7 decorator.
	 */
	var DragDropContextProvider = (_temp = _class = function (_Component) {
	  _inherits(DragDropContextProvider, _Component);
	
	  function DragDropContextProvider(props, context) {
	    _classCallCheck(this, DragDropContextProvider);
	
	    var _this = _possibleConstructorReturn(this, (DragDropContextProvider.__proto__ || Object.getPrototypeOf(DragDropContextProvider)).call(this, props, context));
	
	    _this.backend = (0, _DragDropContext.unpackBackendForEs5Users)(props.backend);
	    return _this;
	  }
	
	  _createClass(DragDropContextProvider, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var _this2 = this;
	
	      /**
	       * This property determines which window global to use for creating the DragDropManager.
	       * If a window has been injected explicitly via props, that is used first. If it is available
	       * as a context value, then use that, otherwise use the browser global.
	       */
	      var getWindow = function getWindow() {
	        if (_this2.props && _this2.props.window) {
	          return _this2.props.window;
	        } else if (_this2.context && _this2.context.window) {
	          return _this2.context.window;
	        } else if (typeof window !== 'undefined') {
	          return window;
	        }
	        return undefined;
	      };
	
	      return (0, _DragDropContext.createChildContext)(this.backend, { window: getWindow() });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react.Children.only(this.props.children);
	    }
	  }]);
	
	  return DragDropContextProvider;
	}(_react.Component), _class.propTypes = {
	  backend: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.object]).isRequired,
	  children: _react.PropTypes.element.isRequired,
	  window: _react.PropTypes.object }, _class.defaultProps = {
	  window: undefined
	}, _class.childContextTypes = _DragDropContext.CHILD_CONTEXT_TYPES, _class.displayName = 'DragDropContextProvider', _class.contextTypes = {
	  window: _react.PropTypes.object
	}, _temp);
	exports.default = DragDropContextProvider;

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = DragLayer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hoistNonReactStatics = __webpack_require__(161);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _isPlainObject = __webpack_require__(118);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _shallowEqual = __webpack_require__(384);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _shallowEqualScalar = __webpack_require__(602);
	
	var _shallowEqualScalar2 = _interopRequireDefault(_shallowEqualScalar);
	
	var _checkDecoratorArguments = __webpack_require__(276);
	
	var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function DragLayer(collect) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  _checkDecoratorArguments2.default.apply(undefined, ['DragLayer', 'collect[, options]'].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line prefer-rest-params
	  (0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the first argument to DragLayer ' + 'to be a function that collects props to inject into the component. ', 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-layer.html', collect);
	  (0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the second argument to DragLayer to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-layer.html', options);
	
	  return function decorateLayer(DecoratedComponent) {
	    var _class, _temp;
	
	    var _options$arePropsEqua = options.arePropsEqual,
	        arePropsEqual = _options$arePropsEqua === undefined ? _shallowEqualScalar2.default : _options$arePropsEqua;
	
	    var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
	
	    var DragLayerContainer = (_temp = _class = function (_Component) {
	      _inherits(DragLayerContainer, _Component);
	
	      _createClass(DragLayerContainer, [{
	        key: 'getDecoratedComponentInstance',
	        value: function getDecoratedComponentInstance() {
	          (0, _invariant2.default)(this.child, 'In order to access an instance of the decorated component it can ' + 'not be a stateless component.');
	          return this.child;
	        }
	      }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	          return !arePropsEqual(nextProps, this.props) || !(0, _shallowEqual2.default)(nextState, this.state);
	        }
	      }]);
	
	      function DragLayerContainer(props, context) {
	        _classCallCheck(this, DragLayerContainer);
	
	        var _this = _possibleConstructorReturn(this, (DragLayerContainer.__proto__ || Object.getPrototypeOf(DragLayerContainer)).call(this, props));
	
	        _this.handleChange = _this.handleChange.bind(_this);
	
	        _this.manager = context.dragDropManager;
	        (0, _invariant2.default)(_typeof(_this.manager) === 'object', 'Could not find the drag and drop manager in the context of %s. ' + 'Make sure to wrap the top-level component of your app with DragDropContext. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);
	
	        _this.state = _this.getCurrentState();
	        return _this;
	      }
	
	      _createClass(DragLayerContainer, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	          this.isCurrentlyMounted = true;
	
	          var monitor = this.manager.getMonitor();
	          this.unsubscribeFromOffsetChange = monitor.subscribeToOffsetChange(this.handleChange);
	          this.unsubscribeFromStateChange = monitor.subscribeToStateChange(this.handleChange);
	
	          this.handleChange();
	        }
	      }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          this.isCurrentlyMounted = false;
	
	          this.unsubscribeFromOffsetChange();
	          this.unsubscribeFromStateChange();
	        }
	      }, {
	        key: 'handleChange',
	        value: function handleChange() {
	          if (!this.isCurrentlyMounted) {
	            return;
	          }
	
	          var nextState = this.getCurrentState();
	          if (!(0, _shallowEqual2.default)(nextState, this.state)) {
	            this.setState(nextState);
	          }
	        }
	      }, {
	        key: 'getCurrentState',
	        value: function getCurrentState() {
	          var monitor = this.manager.getMonitor();
	          return collect(monitor);
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var _this2 = this;
	
	          return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, this.state, {
	            ref: function ref(child) {
	              return _this2.child = child;
	            }
	          }));
	        }
	      }]);
	
	      return DragLayerContainer;
	    }(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = 'DragLayer(' + displayName + ')', _class.contextTypes = {
	      dragDropManager: _react.PropTypes.object.isRequired
	    }, _temp);
	
	
	    return (0, _hoistNonReactStatics2.default)(DragLayerContainer, DecoratedComponent);
	  };
	}

/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = DragSource;
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isPlainObject = __webpack_require__(118);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _checkDecoratorArguments = __webpack_require__(276);
	
	var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);
	
	var _decorateHandler = __webpack_require__(600);
	
	var _decorateHandler2 = _interopRequireDefault(_decorateHandler);
	
	var _registerSource = __webpack_require__(1471);
	
	var _registerSource2 = _interopRequireDefault(_registerSource);
	
	var _createSourceFactory = __webpack_require__(1466);
	
	var _createSourceFactory2 = _interopRequireDefault(_createSourceFactory);
	
	var _createSourceMonitor = __webpack_require__(1467);
	
	var _createSourceMonitor2 = _interopRequireDefault(_createSourceMonitor);
	
	var _createSourceConnector = __webpack_require__(1465);
	
	var _createSourceConnector2 = _interopRequireDefault(_createSourceConnector);
	
	var _isValidType = __webpack_require__(601);
	
	var _isValidType2 = _interopRequireDefault(_isValidType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DragSource(type, spec, collect) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  _checkDecoratorArguments2.default.apply(undefined, ['DragSource', 'type, spec, collect[, options]'].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line prefer-rest-params
	  var getType = type;
	  if (typeof type !== 'function') {
	    (0, _invariant2.default)((0, _isValidType2.default)(type), 'Expected "type" provided as the first argument to DragSource to be ' + 'a string, or a function that returns a string given the current props. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', type);
	    getType = function getType() {
	      return type;
	    };
	  }
	  (0, _invariant2.default)((0, _isPlainObject2.default)(spec), 'Expected "spec" provided as the second argument to DragSource to be ' + 'a plain object. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', spec);
	  var createSource = (0, _createSourceFactory2.default)(spec);
	  (0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the third argument to DragSource to be ' + 'a function that returns a plain object of props to inject. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', collect);
	  (0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the fourth argument to DragSource to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', collect);
	
	  return function decorateSource(DecoratedComponent) {
	    return (0, _decorateHandler2.default)({
	      connectBackend: function connectBackend(backend, sourceId) {
	        return backend.connectDragSource(sourceId);
	      },
	      containerDisplayName: 'DragSource',
	      createHandler: createSource,
	      registerHandler: _registerSource2.default,
	      createMonitor: _createSourceMonitor2.default,
	      createConnector: _createSourceConnector2.default,
	      DecoratedComponent: DecoratedComponent,
	      getType: getType,
	      collect: collect,
	      options: options
	    });
	  };
	}

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = DropTarget;
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isPlainObject = __webpack_require__(118);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _checkDecoratorArguments = __webpack_require__(276);
	
	var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);
	
	var _decorateHandler = __webpack_require__(600);
	
	var _decorateHandler2 = _interopRequireDefault(_decorateHandler);
	
	var _registerTarget = __webpack_require__(1472);
	
	var _registerTarget2 = _interopRequireDefault(_registerTarget);
	
	var _createTargetFactory = __webpack_require__(1469);
	
	var _createTargetFactory2 = _interopRequireDefault(_createTargetFactory);
	
	var _createTargetMonitor = __webpack_require__(1470);
	
	var _createTargetMonitor2 = _interopRequireDefault(_createTargetMonitor);
	
	var _createTargetConnector = __webpack_require__(1468);
	
	var _createTargetConnector2 = _interopRequireDefault(_createTargetConnector);
	
	var _isValidType = __webpack_require__(601);
	
	var _isValidType2 = _interopRequireDefault(_isValidType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DropTarget(type, spec, collect) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  _checkDecoratorArguments2.default.apply(undefined, ['DropTarget', 'type, spec, collect[, options]'].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line prefer-rest-params
	  var getType = type;
	  if (typeof type !== 'function') {
	    (0, _invariant2.default)((0, _isValidType2.default)(type, true), 'Expected "type" provided as the first argument to DropTarget to be ' + 'a string, an array of strings, or a function that returns either given ' + 'the current props. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', type);
	    getType = function getType() {
	      return type;
	    };
	  }
	  (0, _invariant2.default)((0, _isPlainObject2.default)(spec), 'Expected "spec" provided as the second argument to DropTarget to be ' + 'a plain object. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', spec);
	  var createTarget = (0, _createTargetFactory2.default)(spec);
	  (0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the third argument to DropTarget to be ' + 'a function that returns a plain object of props to inject. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', collect);
	  (0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the fourth argument to DropTarget to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', collect);
	
	  return function decorateTarget(DecoratedComponent) {
	    return (0, _decorateHandler2.default)({
	      connectBackend: function connectBackend(backend, targetId) {
	        return backend.connectDropTarget(targetId);
	      },
	      containerDisplayName: 'DropTarget',
	      createHandler: createTarget,
	      registerHandler: _registerTarget2.default,
	      createMonitor: _createTargetMonitor2.default,
	      createConnector: _createTargetConnector2.default,
	      DecoratedComponent: DecoratedComponent,
	      getType: getType,
	      collect: collect,
	      options: options
	    });
	  };
	}

/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createSourceConnector;
	
	var _wrapConnectorHooks = __webpack_require__(603);
	
	var _wrapConnectorHooks2 = _interopRequireDefault(_wrapConnectorHooks);
	
	var _areOptionsEqual = __webpack_require__(599);
	
	var _areOptionsEqual2 = _interopRequireDefault(_areOptionsEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createSourceConnector(backend) {
	  var currentHandlerId = void 0;
	
	  var currentDragSourceNode = void 0;
	  var currentDragSourceOptions = void 0;
	  var disconnectCurrentDragSource = void 0;
	
	  var currentDragPreviewNode = void 0;
	  var currentDragPreviewOptions = void 0;
	  var disconnectCurrentDragPreview = void 0;
	
	  function reconnectDragSource() {
	    if (disconnectCurrentDragSource) {
	      disconnectCurrentDragSource();
	      disconnectCurrentDragSource = null;
	    }
	
	    if (currentHandlerId && currentDragSourceNode) {
	      disconnectCurrentDragSource = backend.connectDragSource(currentHandlerId, currentDragSourceNode, currentDragSourceOptions);
	    }
	  }
	
	  function reconnectDragPreview() {
	    if (disconnectCurrentDragPreview) {
	      disconnectCurrentDragPreview();
	      disconnectCurrentDragPreview = null;
	    }
	
	    if (currentHandlerId && currentDragPreviewNode) {
	      disconnectCurrentDragPreview = backend.connectDragPreview(currentHandlerId, currentDragPreviewNode, currentDragPreviewOptions);
	    }
	  }
	
	  function receiveHandlerId(handlerId) {
	    if (handlerId === currentHandlerId) {
	      return;
	    }
	
	    currentHandlerId = handlerId;
	    reconnectDragSource();
	    reconnectDragPreview();
	  }
	
	  var hooks = (0, _wrapConnectorHooks2.default)({
	    dragSource: function connectDragSource(node, options) {
	      if (node === currentDragSourceNode && (0, _areOptionsEqual2.default)(options, currentDragSourceOptions)) {
	        return;
	      }
	
	      currentDragSourceNode = node;
	      currentDragSourceOptions = options;
	
	      reconnectDragSource();
	    },
	
	    dragPreview: function connectDragPreview(node, options) {
	      if (node === currentDragPreviewNode && (0, _areOptionsEqual2.default)(options, currentDragPreviewOptions)) {
	        return;
	      }
	
	      currentDragPreviewNode = node;
	      currentDragPreviewOptions = options;
	
	      reconnectDragPreview();
	    }
	  });
	
	  return {
	    receiveHandlerId: receiveHandlerId,
	    hooks: hooks
	  };
	}

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = createSourceFactory;
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isPlainObject = __webpack_require__(118);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ALLOWED_SPEC_METHODS = ['canDrag', 'beginDrag', 'isDragging', 'endDrag'];
	var REQUIRED_SPEC_METHODS = ['beginDrag'];
	
	function createSourceFactory(spec) {
	  Object.keys(spec).forEach(function (key) {
	    (0, _invariant2.default)(ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drag source specification to only have ' + 'some of the following keys: %s. ' + 'Instead received a specification with an unexpected "%s" key. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', ALLOWED_SPEC_METHODS.join(', '), key);
	    (0, _invariant2.default)(typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', key, key, spec[key]);
	  });
	  REQUIRED_SPEC_METHODS.forEach(function (key) {
	    (0, _invariant2.default)(typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', key, key, spec[key]);
	  });
	
	  var Source = function () {
	    function Source(monitor) {
	      _classCallCheck(this, Source);
	
	      this.monitor = monitor;
	      this.props = null;
	      this.component = null;
	    }
	
	    _createClass(Source, [{
	      key: 'receiveProps',
	      value: function receiveProps(props) {
	        this.props = props;
	      }
	    }, {
	      key: 'receiveComponent',
	      value: function receiveComponent(component) {
	        this.component = component;
	      }
	    }, {
	      key: 'canDrag',
	      value: function canDrag() {
	        if (!spec.canDrag) {
	          return true;
	        }
	
	        return spec.canDrag(this.props, this.monitor);
	      }
	    }, {
	      key: 'isDragging',
	      value: function isDragging(globalMonitor, sourceId) {
	        if (!spec.isDragging) {
	          return sourceId === globalMonitor.getSourceId();
	        }
	
	        return spec.isDragging(this.props, this.monitor);
	      }
	    }, {
	      key: 'beginDrag',
	      value: function beginDrag() {
	        var item = spec.beginDrag(this.props, this.monitor, this.component);
	        if (false) {
	          (0, _invariant2.default)((0, _isPlainObject2.default)(item), 'beginDrag() must return a plain object that represents the dragged item. ' + 'Instead received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', item);
	        }
	        return item;
	      }
	    }, {
	      key: 'endDrag',
	      value: function endDrag() {
	        if (!spec.endDrag) {
	          return;
	        }
	
	        spec.endDrag(this.props, this.monitor, this.component);
	      }
	    }]);
	
	    return Source;
	  }();
	
	  return function createSource(monitor) {
	    return new Source(monitor);
	  };
	}

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = createSourceMonitor;
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var isCallingCanDrag = false;
	var isCallingIsDragging = false;
	
	var SourceMonitor = function () {
	  function SourceMonitor(manager) {
	    _classCallCheck(this, SourceMonitor);
	
	    this.internalMonitor = manager.getMonitor();
	  }
	
	  _createClass(SourceMonitor, [{
	    key: 'receiveHandlerId',
	    value: function receiveHandlerId(sourceId) {
	      this.sourceId = sourceId;
	    }
	  }, {
	    key: 'canDrag',
	    value: function canDrag() {
	      (0, _invariant2.default)(!isCallingCanDrag, 'You may not call monitor.canDrag() inside your canDrag() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source-monitor.html');
	
	      try {
	        isCallingCanDrag = true;
	        return this.internalMonitor.canDragSource(this.sourceId);
	      } finally {
	        isCallingCanDrag = false;
	      }
	    }
	  }, {
	    key: 'isDragging',
	    value: function isDragging() {
	      (0, _invariant2.default)(!isCallingIsDragging, 'You may not call monitor.isDragging() inside your isDragging() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source-monitor.html');
	
	      try {
	        isCallingIsDragging = true;
	        return this.internalMonitor.isDraggingSource(this.sourceId);
	      } finally {
	        isCallingIsDragging = false;
	      }
	    }
	  }, {
	    key: 'getItemType',
	    value: function getItemType() {
	      return this.internalMonitor.getItemType();
	    }
	  }, {
	    key: 'getItem',
	    value: function getItem() {
	      return this.internalMonitor.getItem();
	    }
	  }, {
	    key: 'getDropResult',
	    value: function getDropResult() {
	      return this.internalMonitor.getDropResult();
	    }
	  }, {
	    key: 'didDrop',
	    value: function didDrop() {
	      return this.internalMonitor.didDrop();
	    }
	  }, {
	    key: 'getInitialClientOffset',
	    value: function getInitialClientOffset() {
	      return this.internalMonitor.getInitialClientOffset();
	    }
	  }, {
	    key: 'getInitialSourceClientOffset',
	    value: function getInitialSourceClientOffset() {
	      return this.internalMonitor.getInitialSourceClientOffset();
	    }
	  }, {
	    key: 'getSourceClientOffset',
	    value: function getSourceClientOffset() {
	      return this.internalMonitor.getSourceClientOffset();
	    }
	  }, {
	    key: 'getClientOffset',
	    value: function getClientOffset() {
	      return this.internalMonitor.getClientOffset();
	    }
	  }, {
	    key: 'getDifferenceFromInitialOffset',
	    value: function getDifferenceFromInitialOffset() {
	      return this.internalMonitor.getDifferenceFromInitialOffset();
	    }
	  }]);
	
	  return SourceMonitor;
	}();
	
	function createSourceMonitor(manager) {
	  return new SourceMonitor(manager);
	}

/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createTargetConnector;
	
	var _wrapConnectorHooks = __webpack_require__(603);
	
	var _wrapConnectorHooks2 = _interopRequireDefault(_wrapConnectorHooks);
	
	var _areOptionsEqual = __webpack_require__(599);
	
	var _areOptionsEqual2 = _interopRequireDefault(_areOptionsEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createTargetConnector(backend) {
	  var currentHandlerId = void 0;
	
	  var currentDropTargetNode = void 0;
	  var currentDropTargetOptions = void 0;
	  var disconnectCurrentDropTarget = void 0;
	
	  function reconnectDropTarget() {
	    if (disconnectCurrentDropTarget) {
	      disconnectCurrentDropTarget();
	      disconnectCurrentDropTarget = null;
	    }
	
	    if (currentHandlerId && currentDropTargetNode) {
	      disconnectCurrentDropTarget = backend.connectDropTarget(currentHandlerId, currentDropTargetNode, currentDropTargetOptions);
	    }
	  }
	
	  function receiveHandlerId(handlerId) {
	    if (handlerId === currentHandlerId) {
	      return;
	    }
	
	    currentHandlerId = handlerId;
	    reconnectDropTarget();
	  }
	
	  var hooks = (0, _wrapConnectorHooks2.default)({
	    dropTarget: function connectDropTarget(node, options) {
	      if (node === currentDropTargetNode && (0, _areOptionsEqual2.default)(options, currentDropTargetOptions)) {
	        return;
	      }
	
	      currentDropTargetNode = node;
	      currentDropTargetOptions = options;
	
	      reconnectDropTarget();
	    }
	  });
	
	  return {
	    receiveHandlerId: receiveHandlerId,
	    hooks: hooks
	  };
	}

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = createTargetFactory;
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isPlainObject = __webpack_require__(118);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ALLOWED_SPEC_METHODS = ['canDrop', 'hover', 'drop'];
	
	function createTargetFactory(spec) {
	  Object.keys(spec).forEach(function (key) {
	    (0, _invariant2.default)(ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drop target specification to only have ' + 'some of the following keys: %s. ' + 'Instead received a specification with an unexpected "%s" key. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', ALLOWED_SPEC_METHODS.join(', '), key);
	    (0, _invariant2.default)(typeof spec[key] === 'function', 'Expected %s in the drop target specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', key, key, spec[key]);
	  });
	
	  var Target = function () {
	    function Target(monitor) {
	      _classCallCheck(this, Target);
	
	      this.monitor = monitor;
	      this.props = null;
	      this.component = null;
	    }
	
	    _createClass(Target, [{
	      key: 'receiveProps',
	      value: function receiveProps(props) {
	        this.props = props;
	      }
	    }, {
	      key: 'receiveMonitor',
	      value: function receiveMonitor(monitor) {
	        this.monitor = monitor;
	      }
	    }, {
	      key: 'receiveComponent',
	      value: function receiveComponent(component) {
	        this.component = component;
	      }
	    }, {
	      key: 'canDrop',
	      value: function canDrop() {
	        if (!spec.canDrop) {
	          return true;
	        }
	
	        return spec.canDrop(this.props, this.monitor);
	      }
	    }, {
	      key: 'hover',
	      value: function hover() {
	        if (!spec.hover) {
	          return;
	        }
	
	        spec.hover(this.props, this.monitor, this.component);
	      }
	    }, {
	      key: 'drop',
	      value: function drop() {
	        if (!spec.drop) {
	          return undefined;
	        }
	
	        var dropResult = spec.drop(this.props, this.monitor, this.component);
	        if (false) {
	          (0, _invariant2.default)(typeof dropResult === 'undefined' || (0, _isPlainObject2.default)(dropResult), 'drop() must either return undefined, or an object that represents the drop result. ' + 'Instead received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', dropResult);
	        }
	        return dropResult;
	      }
	    }]);
	
	    return Target;
	  }();
	
	  return function createTarget(monitor) {
	    return new Target(monitor);
	  };
	}

/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = createTargetMonitor;
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var isCallingCanDrop = false;
	
	var TargetMonitor = function () {
	  function TargetMonitor(manager) {
	    _classCallCheck(this, TargetMonitor);
	
	    this.internalMonitor = manager.getMonitor();
	  }
	
	  _createClass(TargetMonitor, [{
	    key: 'receiveHandlerId',
	    value: function receiveHandlerId(targetId) {
	      this.targetId = targetId;
	    }
	  }, {
	    key: 'canDrop',
	    value: function canDrop() {
	      (0, _invariant2.default)(!isCallingCanDrop, 'You may not call monitor.canDrop() inside your canDrop() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target-monitor.html');
	
	      try {
	        isCallingCanDrop = true;
	        return this.internalMonitor.canDropOnTarget(this.targetId);
	      } finally {
	        isCallingCanDrop = false;
	      }
	    }
	  }, {
	    key: 'isOver',
	    value: function isOver(options) {
	      return this.internalMonitor.isOverTarget(this.targetId, options);
	    }
	  }, {
	    key: 'getItemType',
	    value: function getItemType() {
	      return this.internalMonitor.getItemType();
	    }
	  }, {
	    key: 'getItem',
	    value: function getItem() {
	      return this.internalMonitor.getItem();
	    }
	  }, {
	    key: 'getDropResult',
	    value: function getDropResult() {
	      return this.internalMonitor.getDropResult();
	    }
	  }, {
	    key: 'didDrop',
	    value: function didDrop() {
	      return this.internalMonitor.didDrop();
	    }
	  }, {
	    key: 'getInitialClientOffset',
	    value: function getInitialClientOffset() {
	      return this.internalMonitor.getInitialClientOffset();
	    }
	  }, {
	    key: 'getInitialSourceClientOffset',
	    value: function getInitialSourceClientOffset() {
	      return this.internalMonitor.getInitialSourceClientOffset();
	    }
	  }, {
	    key: 'getSourceClientOffset',
	    value: function getSourceClientOffset() {
	      return this.internalMonitor.getSourceClientOffset();
	    }
	  }, {
	    key: 'getClientOffset',
	    value: function getClientOffset() {
	      return this.internalMonitor.getClientOffset();
	    }
	  }, {
	    key: 'getDifferenceFromInitialOffset',
	    value: function getDifferenceFromInitialOffset() {
	      return this.internalMonitor.getDifferenceFromInitialOffset();
	    }
	  }]);
	
	  return TargetMonitor;
	}();
	
	function createTargetMonitor(manager) {
	  return new TargetMonitor(manager);
	}

/***/ }),
/* 1471 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = registerSource;
	function registerSource(type, source, manager) {
	  var registry = manager.getRegistry();
	  var sourceId = registry.addSource(type, source);
	
	  function unregisterSource() {
	    registry.removeSource(sourceId);
	  }
	
	  return {
	    handlerId: sourceId,
	    unregister: unregisterSource
	  };
	}

/***/ }),
/* 1472 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = registerTarget;
	function registerTarget(type, target, manager) {
	  var registry = manager.getRegistry();
	  var targetId = registry.addTarget(type, target);
	
	  function unregisterTarget() {
	    registry.removeTarget(targetId);
	  }
	
	  return {
	    handlerId: targetId,
	    unregister: unregisterTarget
	  };
	}

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cloneWithRef;
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function cloneWithRef(element, newRef) {
	  var previousRef = element.ref;
	  (0, _invariant2.default)(typeof previousRef !== 'string', 'Cannot connect React DnD to an element with an existing string ref. ' + 'Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. ' + 'Read more: https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute');
	
	  if (!previousRef) {
	    // When there is no ref on the element, use the new ref directly
	    return (0, _react.cloneElement)(element, {
	      ref: newRef
	    });
	  }
	
	  return (0, _react.cloneElement)(element, {
	    ref: function ref(node) {
	      newRef(node);
	
	      if (previousRef) {
	        previousRef(node);
	      }
	    }
	  });
	}

/***/ }),
/* 1474 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(40);
	
	var focusNode = __webpack_require__(564);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(222);
	var ExecutionEnvironment = __webpack_require__(64);
	var FallbackCompositionState = __webpack_require__(1482);
	var SyntheticCompositionEvent = __webpack_require__(1519);
	var SyntheticInputEvent = __webpack_require__(1522);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(605);
	var ExecutionEnvironment = __webpack_require__(64);
	var ReactInstrumentation = __webpack_require__(95);
	
	var camelizeStyleName = __webpack_require__(1340);
	var dangerousStyleValue = __webpack_require__(1528);
	var hyphenateStyleName = __webpack_require__(1348);
	var memoizeStringOnly = __webpack_require__(567);
	var warning = __webpack_require__(16);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue, component);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName], component);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = CSSPropertyOperations;

/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(221);
	var EventPropagators = __webpack_require__(222);
	var ExecutionEnvironment = __webpack_require__(64);
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactUpdates = __webpack_require__(103);
	var SyntheticEvent = __webpack_require__(119);
	
	var getEventTarget = __webpack_require__(397);
	var isEventSupported = __webpack_require__(398);
	var isTextInputElement = __webpack_require__(622);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	  // IE10+ fire input events to often, such when a placeholder
	  // changes or when an input with a placeholder is focused.
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 11);
	}
	
	/**
	 * (For IE <=11) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For IE <=11) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  if (activeElement.attachEvent) {
	    activeElement.attachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.addEventListener('propertychange', handlePropertyChange, false);
	  }
	}
	
	/**
	 * (For IE <=11) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	
	  if (activeElement.detachEvent) {
	    activeElement.detachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
	  }
	
	  activeElement = null;
	  activeElementInst = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For IE <=11) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetInstForInputEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topInput') {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return targetInst;
	  }
	}
	
	function handleEventsForInputEventIE(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9-11, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventIE(topLevelType, targetInst) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementInst;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topClick') {
	    return targetInst;
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst);
	      if (inst) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var DOMLazyTree = __webpack_require__(187);
	var ExecutionEnvironment = __webpack_require__(64);
	
	var createNodesFromMarkup = __webpack_require__(1341);
	var emptyFunction = __webpack_require__(59);
	var invariant = __webpack_require__(10);
	
	var Danger = {
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	
	};
	
	module.exports = Danger;

/***/ }),
/* 1480 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(222);
	var ReactDOMComponentTree = __webpack_require__(40);
	var SyntheticMouseEvent = __webpack_require__(278);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(20);
	
	var PooledClass = __webpack_require__(163);
	
	var getTextContentAccessor = __webpack_require__(620);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(188);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(189);
	
	var instantiateReactComponent = __webpack_require__(621);
	var KeyEscapeUtils = __webpack_require__(389);
	var shouldUpdateReactComponent = __webpack_require__(399);
	var traverseAllChildren = __webpack_require__(624);
	var warning = __webpack_require__(16);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"BROWSER":true,"NODE_ENV":"production","APPLICATION_MODE":"production"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(638);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
	  ) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
	  ) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(186)))

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(385);
	var ReactDOMIDOperations = __webpack_require__(1492);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21),
	    _assign = __webpack_require__(20);
	
	var React = __webpack_require__(191);
	var ReactComponentEnvironment = __webpack_require__(391);
	var ReactCurrentOwner = __webpack_require__(120);
	var ReactErrorUtils = __webpack_require__(392);
	var ReactInstanceMap = __webpack_require__(223);
	var ReactInstrumentation = __webpack_require__(95);
	var ReactNodeTypes = __webpack_require__(615);
	var ReactReconciler = __webpack_require__(189);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(216);
	var invariant = __webpack_require__(10);
	var shallowEqual = __webpack_require__(266);
	var shouldUpdateReactComponent = __webpack_require__(399);
	var warning = __webpack_require__(16);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactDefaultInjection = __webpack_require__(1500);
	var ReactMount = __webpack_require__(614);
	var ReactReconciler = __webpack_require__(189);
	var ReactUpdates = __webpack_require__(103);
	var ReactVersion = __webpack_require__(1513);
	
	var findDOMNode = __webpack_require__(1529);
	var getHostComponentFromComposite = __webpack_require__(619);
	var renderSubtreeIntoContainer = __webpack_require__(1536);
	var warning = __webpack_require__(16);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21),
	    _assign = __webpack_require__(20);
	
	var AutoFocusUtils = __webpack_require__(1475);
	var CSSPropertyOperations = __webpack_require__(1477);
	var DOMLazyTree = __webpack_require__(187);
	var DOMNamespaces = __webpack_require__(386);
	var DOMProperty = __webpack_require__(188);
	var DOMPropertyOperations = __webpack_require__(607);
	var EventPluginHub = __webpack_require__(221);
	var EventPluginRegistry = __webpack_require__(387);
	var ReactBrowserEventEmitter = __webpack_require__(277);
	var ReactDOMComponentFlags = __webpack_require__(608);
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactDOMInput = __webpack_require__(1493);
	var ReactDOMOption = __webpack_require__(1494);
	var ReactDOMSelect = __webpack_require__(609);
	var ReactDOMTextarea = __webpack_require__(1497);
	var ReactInstrumentation = __webpack_require__(95);
	var ReactMultiChild = __webpack_require__(1506);
	var ReactServerRenderingTransaction = __webpack_require__(1511);
	
	var emptyFunction = __webpack_require__(59);
	var escapeTextContentForBrowser = __webpack_require__(280);
	var invariant = __webpack_require__(10);
	var isEventSupported = __webpack_require__(398);
	var shallowEqual = __webpack_require__(266);
	var validateDOMNesting = __webpack_require__(400);
	var warning = __webpack_require__(16);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(400);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(20);
	
	var DOMLazyTree = __webpack_require__(187);
	var ReactDOMComponentTree = __webpack_require__(40);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 1491 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(385);
	var ReactDOMComponentTree = __webpack_require__(40);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21),
	    _assign = __webpack_require__(20);
	
	var DOMPropertyOperations = __webpack_require__(607);
	var LinkedValueUtils = __webpack_require__(390);
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactUpdates = __webpack_require__(103);
	
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(16);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        // eslint-disable-next-line
	        if (value != valueAsNumber) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	        // eslint-disable-next-line
	      } else if (value != node.value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(20);
	
	var React = __webpack_require__(191);
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactDOMSelect = __webpack_require__(609);
	
	var warning = __webpack_require__(16);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(64);
	
	var getNodeForCharacterOffset = __webpack_require__(1533);
	var getTextContentAccessor = __webpack_require__(620);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21),
	    _assign = __webpack_require__(20);
	
	var DOMChildrenOperations = __webpack_require__(385);
	var DOMLazyTree = __webpack_require__(187);
	var ReactDOMComponentTree = __webpack_require__(40);
	
	var escapeTextContentForBrowser = __webpack_require__(280);
	var invariant = __webpack_require__(10);
	var validateDOMNesting = __webpack_require__(400);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21),
	    _assign = __webpack_require__(20);
	
	var LinkedValueUtils = __webpack_require__(390);
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactUpdates = __webpack_require__(103);
	
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(16);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(20);
	
	var ReactUpdates = __webpack_require__(103);
	var Transaction = __webpack_require__(279);
	
	var emptyFunction = __webpack_require__(59);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(1474);
	var BeforeInputEventPlugin = __webpack_require__(1476);
	var ChangeEventPlugin = __webpack_require__(1478);
	var DefaultEventPluginOrder = __webpack_require__(1480);
	var EnterLeaveEventPlugin = __webpack_require__(1481);
	var HTMLDOMPropertyConfig = __webpack_require__(1483);
	var ReactComponentBrowserEnvironment = __webpack_require__(1485);
	var ReactDOMComponent = __webpack_require__(1488);
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactDOMEmptyComponent = __webpack_require__(1490);
	var ReactDOMTreeTraversal = __webpack_require__(1498);
	var ReactDOMTextComponent = __webpack_require__(1496);
	var ReactDefaultBatchingStrategy = __webpack_require__(1499);
	var ReactEventListener = __webpack_require__(1503);
	var ReactInjection = __webpack_require__(1504);
	var ReactReconcileTransaction = __webpack_require__(1509);
	var SVGDOMPropertyConfig = __webpack_require__(1514);
	var SelectEventPlugin = __webpack_require__(1515);
	var SimpleEventPlugin = __webpack_require__(1516);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ }),
/* 1501 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(221);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(20);
	
	var EventListener = __webpack_require__(559);
	var ExecutionEnvironment = __webpack_require__(64);
	var PooledClass = __webpack_require__(163);
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactUpdates = __webpack_require__(103);
	
	var getEventTarget = __webpack_require__(397);
	var getUnboundedScrollPosition = __webpack_require__(565);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(188);
	var EventPluginHub = __webpack_require__(221);
	var EventPluginUtils = __webpack_require__(388);
	var ReactComponentEnvironment = __webpack_require__(391);
	var ReactEmptyComponent = __webpack_require__(610);
	var ReactBrowserEventEmitter = __webpack_require__(277);
	var ReactHostComponent = __webpack_require__(612);
	var ReactUpdates = __webpack_require__(103);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(1527);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var ReactComponentEnvironment = __webpack_require__(391);
	var ReactInstanceMap = __webpack_require__(223);
	var ReactInstrumentation = __webpack_require__(95);
	
	var ReactCurrentOwner = __webpack_require__(120);
	var ReactReconciler = __webpack_require__(189);
	var ReactChildReconciler = __webpack_require__(1484);
	
	var emptyFunction = __webpack_require__(59);
	var flattenChildren = __webpack_require__(1530);
	var invariant = __webpack_require__(10);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ }),
/* 1508 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(20);
	
	var CallbackQueue = __webpack_require__(606);
	var PooledClass = __webpack_require__(163);
	var ReactBrowserEventEmitter = __webpack_require__(277);
	var ReactInputSelection = __webpack_require__(613);
	var ReactInstrumentation = __webpack_require__(95);
	var Transaction = __webpack_require__(279);
	var ReactUpdateQueue = __webpack_require__(393);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(1507);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(20);
	
	var PooledClass = __webpack_require__(163);
	var Transaction = __webpack_require__(279);
	var ReactInstrumentation = __webpack_require__(95);
	var ReactServerUpdateQueue = __webpack_require__(1512);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(393);
	
	var warning = __webpack_require__(16);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ }),
/* 1513 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.5.4';

/***/ }),
/* 1514 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(222);
	var ExecutionEnvironment = __webpack_require__(64);
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactInputSelection = __webpack_require__(613);
	var SyntheticEvent = __webpack_require__(119);
	
	var getActiveElement = __webpack_require__(265);
	var isTextInputElement = __webpack_require__(622);
	var shallowEqual = __webpack_require__(266);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var EventListener = __webpack_require__(559);
	var EventPropagators = __webpack_require__(222);
	var ReactDOMComponentTree = __webpack_require__(40);
	var SyntheticAnimationEvent = __webpack_require__(1517);
	var SyntheticClipboardEvent = __webpack_require__(1518);
	var SyntheticEvent = __webpack_require__(119);
	var SyntheticFocusEvent = __webpack_require__(1521);
	var SyntheticKeyboardEvent = __webpack_require__(1523);
	var SyntheticMouseEvent = __webpack_require__(278);
	var SyntheticDragEvent = __webpack_require__(1520);
	var SyntheticTouchEvent = __webpack_require__(1524);
	var SyntheticTransitionEvent = __webpack_require__(1525);
	var SyntheticUIEvent = __webpack_require__(224);
	var SyntheticWheelEvent = __webpack_require__(1526);
	
	var emptyFunction = __webpack_require__(59);
	var getEventCharCode = __webpack_require__(395);
	var invariant = __webpack_require__(10);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(119);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(119);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(119);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(278);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(224);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(119);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(224);
	
	var getEventCharCode = __webpack_require__(395);
	var getEventKey = __webpack_require__(1531);
	var getEventModifierState = __webpack_require__(396);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(224);
	
	var getEventModifierState = __webpack_require__(396);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(119);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(278);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ }),
/* 1527 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(605);
	var warning = __webpack_require__(16);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var ReactCurrentOwner = __webpack_require__(120);
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactInstanceMap = __webpack_require__(223);
	
	var getHostComponentFromComposite = __webpack_require__(619);
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(16);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(389);
	var traverseAllChildren = __webpack_require__(624);
	var warning = __webpack_require__(16);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"BROWSER":true,"NODE_ENV":"production","APPLICATION_MODE":"production"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(638);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(186)))

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(395);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ }),
/* 1532 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 1533 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(64);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(280);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(614);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _deepEqual = __webpack_require__(354);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	function intersects(array1, array2) {
	  return !!(array1 && array2 && array1.some(function (item) {
	    return ~array2.indexOf(item);
	  }));
	}
	
	var LazyCache = (function () {
	  function LazyCache(component, calculators) {
	    var _this = this;
	
	    _classCallCheck(this, LazyCache);
	
	    this.component = component;
	    this.allProps = [];
	    this.cache = Object.keys(calculators).reduce(function (accumulator, key) {
	      var _extends2;
	
	      var calculator = calculators[key];
	      var fn = calculator.fn;
	      var paramNames = calculator.params;
	      paramNames.forEach(function (param) {
	        if (! ~_this.allProps.indexOf(param)) {
	          _this.allProps.push(param);
	        }
	      });
	      return _extends({}, accumulator, (_extends2 = {}, _extends2[key] = {
	        value: undefined,
	        props: paramNames,
	        fn: fn
	      }, _extends2));
	    }, {});
	  }
	
	  LazyCache.prototype.get = function get(key) {
	    var component = this.component;
	    var _cache$key = this.cache[key];
	    var value = _cache$key.value;
	    var fn = _cache$key.fn;
	    var props = _cache$key.props;
	
	    if (value !== undefined) {
	      return value;
	    }
	    var params = props.map(function (prop) {
	      return component.props[prop];
	    });
	    var result = fn.apply(undefined, params);
	    this.cache[key].value = result;
	    return result;
	  };
	
	  LazyCache.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    var component = this.component;
	
	    var diffProps = [];
	    this.allProps.forEach(function (prop) {
	      if (!_deepEqual2['default'](component.props[prop], nextProps[prop])) {
	        diffProps.push(prop);
	      }
	    });
	    if (diffProps.length) {
	      Object.keys(this.cache).forEach(function (key) {
	        if (intersects(diffProps, _this2.cache[key].props)) {
	          delete _this2.cache[key].value; // uncache value
	        }
	      });
	    }
	  };
	
	  return LazyCache;
	})();
	
	exports['default'] = LazyCache;
	module.exports = exports['default'];

/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1537);


/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _resizeObserverPolyfill = __webpack_require__(1654);
	
	var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);
	
	var _getNodeDimensions = __webpack_require__(1356);
	
	var _getNodeDimensions2 = _interopRequireDefault(_getNodeDimensions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Measure = function (_Component) {
	  _inherits(Measure, _Component);
	
	  function Measure(props) {
	    _classCallCheck(this, Measure);
	
	    var _this = _possibleConstructorReturn(this, (Measure.__proto__ || Object.getPrototypeOf(Measure)).call(this, props));
	
	    _this.measure = function () {
	      var includeMargin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.includeMargin;
	      var useClone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props.useClone;
	
	      // bail out if we shouldn't measure
	      if (!_this.props.shouldMeasure) return;
	
	      // if no parent available we need to requery the DOM node
	      if (!_this._node.parentNode) {
	        _this._setDOMNode();
	      }
	
	      var dimensions = _this.getDimensions(_this._node, includeMargin, useClone);
	      var isChildFunction = typeof _this.props.children === 'function';
	
	      // determine if we need to update our callback with new dimensions or not
	      _this._propsToMeasure.some(function (prop) {
	        if (dimensions[prop] !== _this._lastDimensions[prop]) {
	          // update our callback if we've found a dimension that has changed
	          _this.props.onMeasure(dimensions);
	
	          // update state to send dimensions to child function
	          if (isChildFunction && typeof _this !== 'undefined') {
	            _this.setState({ dimensions: dimensions });
	          }
	
	          // store last dimensions to compare changes
	          _this._lastDimensions = dimensions;
	
	          // we don't need to look any further, bail out
	          return true;
	        }
	      });
	    };
	
	    _this.state = {
	      dimensions: {
	        width: 0,
	        height: 0,
	        top: 0,
	        right: 0,
	        bottom: 0,
	        left: 0
	      }
	    };
	    _this._node = null;
	    _this._propsToMeasure = _this._getPropsToMeasure(props);
	    _this._lastDimensions = {};
	    return _this;
	  }
	
	  _createClass(Measure, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this._setDOMNode();
	
	      // measure on first render
	      this.measure();
	
	      // add component to resize observer to detect changes on resize
	      this.resizeObserver = new _resizeObserverPolyfill2.default(function () {
	        return _this2.measure();
	      });
	      this.resizeObserver.observe(this._node);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(_ref) {
	      var config = _ref.config,
	          whitelist = _ref.whitelist,
	          blacklist = _ref.blacklist;
	
	      // we store the properties ourselves so we need to update them if the
	      // whitelist or blacklist props have changed
	      if (this.props.whitelist !== whitelist || this.props.blacklist !== blacklist) {
	        this._propsToMeasure = this._getPropsToMeasure({ whitelist: whitelist, blacklist: blacklist });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.resizeObserver.disconnect(this._node);
	      this._node = null;
	    }
	  }, {
	    key: '_setDOMNode',
	    value: function _setDOMNode() {
	      this._node = _reactDom2.default.findDOMNode(this);
	    }
	  }, {
	    key: 'getDimensions',
	    value: function getDimensions() {
	      var node = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._node;
	      var includeMargin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props.includeMargin;
	      var useClone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props.useClone;
	      var cloneOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.props.cloneOptions;
	
	      return (0, _getNodeDimensions2.default)(node, _extends({
	        margin: includeMargin,
	        clone: useClone
	      }, cloneOptions));
	    }
	  }, {
	    key: '_getPropsToMeasure',
	    value: function _getPropsToMeasure(_ref2) {
	      var whitelist = _ref2.whitelist,
	          blacklist = _ref2.blacklist;
	
	      return whitelist.filter(function (prop) {
	        return blacklist.indexOf(prop) < 0;
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	
	      return _react.Children.only(typeof children === 'function' ? children(this.state.dimensions) : children);
	    }
	  }]);
	
	  return Measure;
	}(_react.Component);
	
	Measure.propTypes = {
	  whitelist: _propTypes2.default.array,
	  blacklist: _propTypes2.default.array,
	  includeMargin: _propTypes2.default.bool,
	  useClone: _propTypes2.default.bool,
	  cloneOptions: _propTypes2.default.object,
	  shouldMeasure: _propTypes2.default.bool,
	  onMeasure: _propTypes2.default.func
	};
	Measure.defaultProps = {
	  whitelist: ['width', 'height', 'top', 'right', 'bottom', 'left'],
	  blacklist: [],
	  includeMargin: true,
	  useClone: false,
	  cloneOptions: {},
	  shouldMeasure: true,
	  onMeasure: function onMeasure() {
	    return null;
	  }
	};
	exports.default = Measure;
	module.exports = exports['default'];

/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Measure = __webpack_require__(1539);
	
	var _Measure2 = _interopRequireDefault(_Measure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Measure2.default;
	module.exports = exports['default'];

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PropTypes = __webpack_require__(401);
	
	var _warning = __webpack_require__(282);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store, storeSubscription: null };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    return _react.Children.only(this.props.children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports.default = Provider;
	
	
	if (false) {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _PropTypes.storeShape.isRequired,
	  children: _propTypes2.default.element.isRequired
	};
	Provider.childContextTypes = {
	  store: _PropTypes.storeShape.isRequired,
	  storeSubscription: _PropTypes.subscriptionShape
	};
	Provider.displayName = 'Provider';

/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createConnect = createConnect;
	
	var _connectAdvanced = __webpack_require__(625);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _shallowEqual = __webpack_require__(1549);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _mapDispatchToProps = __webpack_require__(1543);
	
	var _mapDispatchToProps2 = _interopRequireDefault(_mapDispatchToProps);
	
	var _mapStateToProps = __webpack_require__(1544);
	
	var _mapStateToProps2 = _interopRequireDefault(_mapStateToProps);
	
	var _mergeProps = __webpack_require__(1545);
	
	var _mergeProps2 = _interopRequireDefault(_mergeProps);
	
	var _selectorFactory = __webpack_require__(1546);
	
	var _selectorFactory2 = _interopRequireDefault(_selectorFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	}
	
	// createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	function createConnect() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === undefined ? _connectAdvanced2.default : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? _mapStateToProps2.default : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? _mapDispatchToProps2.default : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === undefined ? _mergeProps2.default : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === undefined ? _selectorFactory2.default : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
	        _ref2$pure = _ref2.pure,
	        pure = _ref2$pure === undefined ? true : _ref2$pure,
	        _ref2$areStatesEqual = _ref2.areStatesEqual,
	        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
	        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
	        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? _shallowEqual2.default : _ref2$areOwnPropsEqua,
	        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
	        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? _shallowEqual2.default : _ref2$areStatePropsEq,
	        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
	        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? _shallowEqual2.default : _ref2$areMergedPropsE,
	        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);
	
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	
	    return connectHOC(selectorFactory, _extends({
	      // used in error messages
	      methodName: 'connect',
	
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return 'Connect(' + name + ')';
	      },
	
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	
	    }, extraOptions));
	  };
	}
	
	exports.default = createConnect();

/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	
	var _redux = __webpack_require__(195);
	
	var _wrapMapToProps = __webpack_require__(626);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return { dispatch: dispatch };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	exports.default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	
	var _wrapMapToProps = __webpack_require__(626);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	exports.default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	
	var _verifyPlainObject = __webpack_require__(627);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return _extends({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	
	    var hasRunOnce = false;
	    var mergedProps = void 0;
	
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	
	        if (false) (0, _verifyPlainObject2.default)(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	exports.default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports.default = finalPropsSelectorFactory;
	
	var _verifySubselectors = __webpack_require__(1547);
	
	var _verifySubselectors2 = _interopRequireDefault(_verifySubselectors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	
	  var hasRunAtLeastOnce = false;
	  var state = void 0;
	  var ownProps = void 0;
	  var stateProps = void 0;
	  var dispatchProps = void 0;
	  var mergedProps = void 0;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	}
	
	// TODO: Add more comments
	
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);
	
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors2.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifySubselectors;
	
	var _warning = __webpack_require__(282);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      (0, _warning2.default)('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ }),
/* 1548 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription = function () {
	  function Subscription(store, parentSub, onStateChange) {
	    _classCallCheck(this, Subscription);
	
	    this.store = store;
	    this.parentSub = parentSub;
	    this.onStateChange = onStateChange;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  Subscription.prototype.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  Subscription.prototype.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports.default = Subscription;

/***/ }),
/* 1549 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = routerMiddleware;
	
	var _actions = __webpack_require__(628);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
	 * provided history object. This will prevent these actions from reaching your
	 * reducer or any middleware that comes after this one.
	 */
	function routerMiddleware(history) {
	  return function () {
	    return function (next) {
	      return function (action) {
	        if (action.type !== _actions.CALL_HISTORY_METHOD) {
	          return next(action);
	        }
	
	        var _action$payload = action.payload,
	            method = _action$payload.method,
	            args = _action$payload.args;
	
	        history[method].apply(history, _toConsumableArray(args));
	      };
	    };
	  };
	}

/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = syncHistoryWithStore;
	
	var _reducer = __webpack_require__(629);
	
	var defaultSelectLocationState = function defaultSelectLocationState(state) {
	  return state.routing;
	};
	
	/**
	 * This function synchronizes your history state with the Redux store.
	 * Location changes flow from history to the store. An enhanced history is
	 * returned with a listen method that responds to store updates for location.
	 *
	 * When this history is provided to the router, this means the location data
	 * will flow like this:
	 * history.push -> store.dispatch -> enhancedHistory.listen -> router
	 * This ensures that when the store state changes due to a replay or other
	 * event, the router will be updated appropriately and can transition to the
	 * correct router state.
	 */
	function syncHistoryWithStore(history, store) {
	  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	      _ref$selectLocationSt = _ref.selectLocationState,
	      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
	      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
	      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;
	
	  // Ensure that the reducer is mounted on the store and functioning properly.
	  if (typeof selectLocationState(store.getState()) === 'undefined') {
	    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
	  }
	
	  var initialLocation = void 0;
	  var isTimeTraveling = void 0;
	  var unsubscribeFromStore = void 0;
	  var unsubscribeFromHistory = void 0;
	  var currentLocation = void 0;
	
	  // What does the store say about current location?
	  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
	    var locationState = selectLocationState(store.getState());
	    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
	  };
	
	  // Init initialLocation with potential location in store
	  initialLocation = getLocationInStore();
	
	  // If the store is replayed, update the URL in the browser to match.
	  if (adjustUrlOnReplay) {
	    var handleStoreChange = function handleStoreChange() {
	      var locationInStore = getLocationInStore(true);
	      if (currentLocation === locationInStore || initialLocation === locationInStore) {
	        return;
	      }
	
	      // Update address bar to reflect store state
	      isTimeTraveling = true;
	      currentLocation = locationInStore;
	      history.transitionTo(_extends({}, locationInStore, {
	        action: 'PUSH'
	      }));
	      isTimeTraveling = false;
	    };
	
	    unsubscribeFromStore = store.subscribe(handleStoreChange);
	    handleStoreChange();
	  }
	
	  // Whenever location changes, dispatch an action to get it in the store
	  var handleLocationChange = function handleLocationChange(location) {
	    // ... unless we just caused that location change
	    if (isTimeTraveling) {
	      return;
	    }
	
	    // Remember where we are
	    currentLocation = location;
	
	    // Are we being called for the first time?
	    if (!initialLocation) {
	      // Remember as a fallback in case state is reset
	      initialLocation = location;
	
	      // Respect persisted location, if any
	      if (getLocationInStore()) {
	        return;
	      }
	    }
	
	    // Tell the store to update by dispatching an action
	    store.dispatch({
	      type: _reducer.LOCATION_CHANGE,
	      payload: location
	    });
	  };
	  unsubscribeFromHistory = history.listen(handleLocationChange);
	
	  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
	  if (history.getCurrentLocation) {
	    handleLocationChange(history.getCurrentLocation());
	  }
	
	  // The enhanced history uses store as source of truth
	  return _extends({}, history, {
	    // The listeners are subscribed to the store instead of history
	    listen: function listen(listener) {
	      // Copy of last location.
	      var lastPublishedLocation = getLocationInStore(true);
	
	      // Keep track of whether we unsubscribed, as Redux store
	      // only applies changes in subscriptions on next dispatch
	      var unsubscribed = false;
	      var unsubscribeFromStore = store.subscribe(function () {
	        var currentLocation = getLocationInStore(true);
	        if (currentLocation === lastPublishedLocation) {
	          return;
	        }
	        lastPublishedLocation = currentLocation;
	        if (!unsubscribed) {
	          listener(lastPublishedLocation);
	        }
	      });
	
	      // History 2.x listeners expect a synchronous call. Make the first call to the
	      // listener after subscribing to the store, in case the listener causes a
	      // location change (e.g. when it redirects)
	      if (!history.getCurrentLocation) {
	        listener(lastPublishedLocation);
	      }
	
	      // Let user unsubscribe later
	      return function () {
	        unsubscribed = true;
	        unsubscribeFromStore();
	      };
	    },
	
	
	    // It also provides a way to destroy internal listeners
	    unsubscribe: function unsubscribe() {
	      if (adjustUrlOnReplay) {
	        unsubscribeFromStore();
	      }
	      unsubscribeFromHistory();
	    }
	  });
	}

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(46);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _InternalPropTypes = __webpack_require__(164);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A mixin that adds the "history" instance variable to components.
	 */
	var History = {
	
	  contextTypes: {
	    history: _InternalPropTypes.history
	  },
	
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `History` mixin is deprecated, please access `context.router` with your own `contextTypes`. http://tiny.cc/router-historymixin') : void 0;
	    this.history = this.context.history;
	  }
	};
	
	exports.default = History;
	module.exports = exports['default'];

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(630);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = _react2.default.createClass({
	  displayName: 'IndexLink',
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(46);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(631);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(164);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	
	var IndexRedirect = _react2.default.createClass({
	  displayName: 'IndexRedirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(46);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(133);
	
	var _InternalPropTypes = __webpack_require__(164);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react2.default.PropTypes.func;
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	
	var IndexRoute = _react2.default.createClass({
	  displayName: 'IndexRoute',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(46);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The Lifecycle mixin adds the routerWillLeave lifecycle method to a
	 * component that may be used to cancel a transition or prompt the user
	 * for confirmation.
	 *
	 * On standard transitions, routerWillLeave receives a single argument: the
	 * location we're transitioning to. To cancel the transition, return false.
	 * To prompt the user for confirmation, return a prompt message (string).
	 *
	 * During the beforeunload event (assuming you're using the useBeforeUnload
	 * history enhancer), routerWillLeave does not receive a location object
	 * because it isn't possible for us to know the location we're transitioning
	 * to. In this case routerWillLeave must return a prompt message to prevent
	 * the user from closing the window/tab.
	 */
	
	var Lifecycle = {
	
	  contextTypes: {
	    history: object.isRequired,
	    // Nested children receive the route as context, either
	    // set by the route component using the RouteContext mixin
	    // or by some other ancestor.
	    route: object
	  },
	
	  propTypes: {
	    // Route components receive the route object as a prop.
	    route: object
	  },
	
	  componentDidMount: function componentDidMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `Lifecycle` mixin is deprecated, please use `context.router.setRouteLeaveHook(route, hook)`. http://tiny.cc/router-lifecyclemixin') : void 0;
	    !this.routerWillLeave ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin requires you to define a routerWillLeave method') : (0, _invariant2.default)(false) : void 0;
	
	    var route = this.props.route || this.context.route;
	
	    !route ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin must be used on either a) a <Route component> or ' + 'b) a descendant of a <Route component> that uses the RouteContext mixin') : (0, _invariant2.default)(false) : void 0;
	
	    this._unlistenBeforeLeavingRoute = this.context.history.listenBeforeLeavingRoute(route, this.routerWillLeave);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlistenBeforeLeavingRoute) this._unlistenBeforeLeavingRoute();
	  }
	};
	
	exports.default = Lifecycle;
	module.exports = exports['default'];

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(133);
	
	var _InternalPropTypes = __webpack_require__(164);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	
	var Route = _react2.default.createClass({
	  displayName: 'Route',
	
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(46);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The RouteContext mixin provides a convenient way for route
	 * components to set the route in context. This is needed for
	 * routes that render elements that want to use the Lifecycle
	 * mixin to prevent transitions.
	 */
	
	var RouteContext = {
	
	  propTypes: {
	    route: object.isRequired
	  },
	
	  childContextTypes: {
	    route: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      route: this.props.route
	    };
	  },
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'The `RouteContext` mixin is deprecated. You can provide `this.props.route` on context with your own `contextTypes`. http://tiny.cc/router-routecontextmixin') : void 0;
	  }
	};
	
	exports.default = RouteContext;
	module.exports = exports['default'];

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createHashHistory = __webpack_require__(572);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _useQueries = __webpack_require__(268);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createTransitionManager = __webpack_require__(404);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _InternalPropTypes = __webpack_require__(164);
	
	var _RouterContext = __webpack_require__(283);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(133);
	
	var _RouterUtils = __webpack_require__(632);
	
	var _routerWarning = __webpack_require__(46);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isDeprecatedHistory(history) {
	  return !history || !history.__v2_compatible__;
	}
	
	/* istanbul ignore next: sanity check */
	function isUnsupportedHistory(history) {
	  // v3 histories expose getCurrentLocation, but aren't currently supported.
	  return history && history.getCurrentLocation;
	}
	
	var _React$PropTypes = _react2.default.PropTypes;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	
	var Router = _react2.default.createClass({
	  displayName: 'Router',
	
	
	  propTypes: {
	    history: object,
	    children: _InternalPropTypes.routes,
	    routes: _InternalPropTypes.routes, // alias for children
	    render: func,
	    createElement: func,
	    onError: func,
	    onUpdate: func,
	
	    // Deprecated:
	    parseQueryString: func,
	    stringifyQuery: func,
	
	    // PRIVATE: For client-side rehydration of server match.
	    matchContext: object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    var _props = this.props;
	    var parseQueryString = _props.parseQueryString;
	    var stringifyQuery = _props.stringifyQuery;
	
	     false ? (0, _routerWarning2.default)(!(parseQueryString || stringifyQuery), '`parseQueryString` and `stringifyQuery` are deprecated. Please create a custom history. http://tiny.cc/router-customquerystring') : void 0;
	
	    var _createRouterObjects = this.createRouterObjects();
	
	    var history = _createRouterObjects.history;
	    var transitionManager = _createRouterObjects.transitionManager;
	    var router = _createRouterObjects.router;
	
	
	    this._unlisten = transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	
	    this.history = history;
	    this.router = router;
	  },
	  createRouterObjects: function createRouterObjects() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext;
	    }
	
	    var history = this.props.history;
	    var _props2 = this.props;
	    var routes = _props2.routes;
	    var children = _props2.children;
	
	
	    !!isUnsupportedHistory(history) ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v3.x. ' + 'This version of React Router is not compatible with v3 history ' + 'objects. Please use history v2.x instead.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isDeprecatedHistory(history)) {
	      history = this.wrapDeprecatedHistory(history);
	    }
	
	    var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	    var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	    var routingHistory = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	    return { history: routingHistory, transitionManager: transitionManager, router: router };
	  },
	  wrapDeprecatedHistory: function wrapDeprecatedHistory(history) {
	    var _props3 = this.props;
	    var parseQueryString = _props3.parseQueryString;
	    var stringifyQuery = _props3.stringifyQuery;
	
	
	    var createHistory = void 0;
	    if (history) {
	       false ? (0, _routerWarning2.default)(false, 'It appears you have provided a deprecated history object to `<Router/>`, please use a history provided by ' + 'React Router with `import { browserHistory } from \'react-router\'` or `import { hashHistory } from \'react-router\'`. ' + 'If you are using a custom history please create it with `useRouterHistory`, see http://tiny.cc/router-usinghistory for details.') : void 0;
	      createHistory = function createHistory() {
	        return history;
	      };
	    } else {
	       false ? (0, _routerWarning2.default)(false, '`Router` no longer defaults the history prop to hash history. Please use the `hashHistory` singleton instead. http://tiny.cc/router-defaulthistory') : void 0;
	      createHistory = _createHashHistory2.default;
	    }
	
	    return (0, _useQueries2.default)(createHistory)({ parseQueryString: parseQueryString, stringifyQuery: stringifyQuery });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state;
	    var location = _state.location;
	    var routes = _state.routes;
	    var params = _state.params;
	    var components = _state.components;
	    var _props4 = this.props;
	    var createElement = _props4.createElement;
	    var render = _props4.render;
	
	    var props = _objectWithoutProperties(_props4, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(Router.propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      history: this.history,
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(283);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(46);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RoutingContext = _react2.default.createClass({
	  displayName: 'RoutingContext',
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, '`RoutingContext` has been renamed to `RouterContext`. Please use `import { RouterContext } from \'react-router\'`. http://tiny.cc/router-routercontext') : void 0;
	  },
	  render: function render() {
	    return _react2.default.createElement(_RouterContext2.default, this.props);
	  }
	});
	
	exports.default = RoutingContext;
	module.exports = exports['default'];

/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.runEnterHooks = runEnterHooks;
	exports.runChangeHooks = runChangeHooks;
	exports.runLeaveHooks = runLeaveHooks;
	
	var _AsyncUtils = __webpack_require__(402);
	
	var _routerWarning = __webpack_require__(46);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createTransitionHook(hook, route, asyncArity) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    hook.apply(route, args);
	
	    if (hook.length < asyncArity) {
	      var callback = args[args.length - 1];
	      // Assume hook executes synchronously and
	      // automatically call the callback.
	      callback();
	    }
	  };
	}
	
	function getEnterHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3));
	
	    return hooks;
	  }, []);
	}
	
	function getChangeHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4));
	    return hooks;
	  }, []);
	}
	
	function runTransitionHooks(length, iter, callback) {
	  if (!length) {
	    callback();
	    return;
	  }
	
	  var redirectInfo = void 0;
	  function replace(location, deprecatedPathname, deprecatedQuery) {
	    if (deprecatedPathname) {
	       false ? (0, _routerWarning2.default)(false, '`replaceState(state, pathname, query) is deprecated; use `replace(location)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      redirectInfo = {
	        pathname: deprecatedPathname,
	        query: deprecatedQuery,
	        state: location
	      };
	
	      return;
	    }
	
	    redirectInfo = location;
	  }
	
	  (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	    iter(index, replace, function (error) {
	      if (error || redirectInfo) {
	        done(error, redirectInfo); // No need to continue.
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	
	/**
	 * Runs all onEnter hooks in the given array of routes in order
	 * with onEnter(nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runEnterHooks(routes, nextState, callback) {
	  var hooks = getEnterHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onChange hooks in the given array of routes in order
	 * with onChange(prevState, nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runChangeHooks(routes, state, nextState, callback) {
	  var hooks = getChangeHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](state, nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onLeave hooks in the given array of routes in order.
	 */
	function runLeaveHooks(routes, prevState) {
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	  }
	}

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(283);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(46);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length <= 0 || arguments[0] === undefined ? _react.createElement : arguments[0];
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(1360);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(634);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(190);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    (function () {
	      var parentIsLeaving = false;
	      leaveRoutes = prevRoutes.filter(function (route) {
	        if (parentIsLeaving) {
	          return true;
	        } else {
	          var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	          if (isLeaving) parentIsLeaving = true;
	          return isLeaving;
	        }
	      });
	
	      // onLeave hooks start at the leaf route.
	      leaveRoutes.reverse();
	
	      enterRoutes = [];
	      changeRoutes = [];
	
	      nextRoutes.forEach(function (route) {
	        var isNew = prevRoutes.indexOf(route) === -1;
	        var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	        if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	      });
	    })();
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(402);
	
	var _makeStateWithLocation = __webpack_require__(635);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (!getComponent) {
	    callback();
	    return;
	  }
	
	  var location = nextState.location;
	
	  var nextStateWithLocation = (0, _makeStateWithLocation2.default)(nextState, location);
	
	  getComponent.call(route, nextStateWithLocation, callback);
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(190);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(572);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(634);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(190);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname;
	  var query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(184);
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(633);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(404);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(133);
	
	var _RouterUtils = __webpack_require__(632);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history;
	  var routes = _ref.routes;
	  var location = _ref.location;
	
	  var options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  var unlisten = void 0;
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    // Pick up the location from the history via synchronous history.listen
	    // call if needed.
	    unlisten = history.listen(function (historyLocation) {
	      location = historyLocation;
	    });
	  }
	
	  var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	  history = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    callback(error, redirectLocation && router.createLocation(redirectLocation, _Actions.REPLACE), nextState && _extends({}, nextState, {
	      history: history,
	      router: router,
	      matchContext: { history: history, transitionManager: transitionManager, router: router }
	    }));
	
	    // Defer removing the listener to here to prevent DOM histories from having
	    // to unwind DOM event listeners unnecessarily, in case callback renders a
	    // <Router> and attaches another history listener.
	    if (unlisten) {
	      unlisten();
	    }
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(402);
	
	var _makeStateWithLocation = __webpack_require__(635);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	var _PatternUtils = __webpack_require__(190);
	
	var _routerWarning = __webpack_require__(46);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(133);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	  route.getChildRoutes(partialNextStateWithLocation, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	    route.getIndexRoute(partialNextStateWithLocation, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	  } else if (route.childRoutes) {
	    (function () {
	      var pathless = route.childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    })();
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var _ret2 = function () {
	        var match = {
	          routes: [route],
	          params: createParams(paramNames, paramValues)
	        };
	
	        getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	          if (error) {
	            callback(error);
	          } else {
	            if (Array.isArray(indexRoute)) {
	              var _match$routes;
	
	               false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	                return !route.path;
	              }), 'Index routes should not have paths') : void 0;
	              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	            } else if (indexRoute) {
	               false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	              match.routes.push(indexRoute);
	            }
	
	            callback(null, match);
	          }
	        });
	
	        return {
	          v: void 0
	        };
	      }();
	
	      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length <= 4 || arguments[4] === undefined ? [] : arguments[4];
	  var paramValues = arguments.length <= 5 || arguments[5] === undefined ? [] : arguments[5];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _useQueries = __webpack_require__(268);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _createTransitionManager = __webpack_require__(404);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _routerWarning = __webpack_require__(46);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know about routing.
	 *
	 * Enhances history objects with the following methods:
	 *
	 * - listen((error, nextState) => {})
	 * - listenBeforeLeavingRoute(route, (nextLocation) => {})
	 * - match(location, (error, redirectLocation, nextState) => {})
	 * - isActive(pathname, query, indexOnly=false)
	 */
	function useRoutes(createHistory) {
	   false ? (0, _routerWarning2.default)(false, '`useRoutes` is deprecated. Please use `createTransitionManager` instead.') : void 0;
	
	  return function () {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var routes = _ref.routes;
	
	    var options = _objectWithoutProperties(_ref, ['routes']);
	
	    var history = (0, _useQueries2.default)(createHistory)(options);
	    var transitionManager = (0, _createTransitionManager2.default)(history, routes);
	    return _extends({}, history, transitionManager);
	  };
	}
	
	exports.default = useRoutes;
	module.exports = exports['default'];

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hoistNonReactStatics = __webpack_require__(161);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _PropTypes = __webpack_require__(403);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = _react2.default.createClass({
	    displayName: 'WithRouter',
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      var props = _extends({}, this.props, { router: router });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(1120);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__(225);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = undefined;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = (function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        _Component.apply(this, arguments);
	      }
	
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !_shallowequal2['default'](nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2['default'].createElement(WrappedComponent, this.props);
	      };
	
	      _createClass(SideEffect, null, [{
	        key: 'displayName',
	
	        // Try to use displayName of wrapped component
	        value: 'SideEffect(' + getDisplayName(WrappedComponent) + ')',
	
	        // Expose canUseDOM so tests can monkeypatch it
	        enumerable: true
	      }, {
	        key: 'canUseDOM',
	        value: _exenv2['default'].canUseDOM,
	        enumerable: true
	      }]);
	
	      return SideEffect;
	    })(_react.Component);
	
	    return SideEffect;
	  };
	};

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _addClass = __webpack_require__(1033);
	
	var _addClass2 = _interopRequireDefault(_addClass);
	
	var _removeClass = __webpack_require__(1035);
	
	var _removeClass2 = _interopRequireDefault(_removeClass);
	
	var _requestAnimationFrame = __webpack_require__(1037);
	
	var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);
	
	var _properties = __webpack_require__(1036);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(22);
	
	var _PropTypes = __webpack_require__(637);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var events = [];
	if (_properties.transitionEnd) events.push(_properties.transitionEnd);
	if (_properties.animationEnd) events.push(_properties.animationEnd);
	
	function addEndListener(node, listener) {
	  if (events.length) {
	    events.forEach(function (e) {
	      return node.addEventListener(e, listener, false);
	    });
	  } else {
	    setTimeout(listener, 0);
	  }
	
	  return function () {
	    if (!events.length) return;
	    events.forEach(function (e) {
	      return node.removeEventListener(e, listener, false);
	    });
	  };
	}
	
	var propTypes = {
	  children: _propTypes2.default.node,
	  name: _PropTypes.nameShape.isRequired,
	
	  // Once we require timeouts to be specified, we can remove the
	  // boolean flags (appear etc.) and just accept a number
	  // or a bool for the timeout flags (appearTimeout etc.)
	  appear: _propTypes2.default.bool,
	  enter: _propTypes2.default.bool,
	  leave: _propTypes2.default.bool,
	  appearTimeout: _propTypes2.default.number,
	  enterTimeout: _propTypes2.default.number,
	  leaveTimeout: _propTypes2.default.number
	};
	
	var CSSTransitionGroupChild = function (_React$Component) {
	  _inherits(CSSTransitionGroupChild, _React$Component);
	
	  function CSSTransitionGroupChild() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroupChild);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
	      if (_this.props.appear) {
	        _this.transition('appear', done, _this.props.appearTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillEnter = function (done) {
	      if (_this.props.enter) {
	        _this.transition('enter', done, _this.props.enterTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillLeave = function (done) {
	      if (_this.props.leave) {
	        _this.transition('leave', done, _this.props.leaveTimeout);
	      } else {
	        done();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
	    this.classNameAndNodeQueue = [];
	    this.transitionTimeouts = [];
	  };
	
	  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounted = true;
	
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	    this.transitionTimeouts.forEach(function (timeout) {
	      clearTimeout(timeout);
	    });
	
	    this.classNameAndNodeQueue.length = 0;
	  };
	
	  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
	    var node = (0, _reactDom.findDOMNode)(this);
	
	    if (!node) {
	      if (finishCallback) {
	        finishCallback();
	      }
	      return;
	    }
	
	    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
	    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
	    var timer = null;
	    var removeListeners = void 0;
	
	    (0, _addClass2.default)(node, className);
	
	    // Need to do this to actually trigger a transition.
	    this.queueClassAndNode(activeClassName, node);
	
	    // Clean-up the animation after the specified delay
	    var finish = function finish(e) {
	      if (e && e.target !== node) {
	        return;
	      }
	
	      clearTimeout(timer);
	      if (removeListeners) removeListeners();
	
	      (0, _removeClass2.default)(node, className);
	      (0, _removeClass2.default)(node, activeClassName);
	
	      if (removeListeners) removeListeners();
	
	      // Usually this optional callback is used for informing an owner of
	      // a leave animation and telling it to remove the child.
	      if (finishCallback) {
	        finishCallback();
	      }
	    };
	
	    if (timeout) {
	      timer = setTimeout(finish, timeout);
	      this.transitionTimeouts.push(timer);
	    } else if (_properties.transitionEnd) {
	      removeListeners = addEndListener(node, finish);
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
	    var _this2 = this;
	
	    this.classNameAndNodeQueue.push({
	      className: className,
	      node: node
	    });
	
	    if (!this.rafHandle) {
	      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
	        return _this2.flushClassNameAndNodeQueue();
	      });
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
	    if (!this.unmounted) {
	      this.classNameAndNodeQueue.forEach(function (obj) {
	        // This is for to force a repaint,
	        // which is necessary in order to transition styles when adding a class name.
	        /* eslint-disable no-unused-expressions */
	        obj.node.scrollTop;
	        /* eslint-enable no-unused-expressions */
	        (0, _addClass2.default)(obj.node, obj.className);
	      });
	    }
	    this.classNameAndNodeQueue.length = 0;
	    this.rafHandle = null;
	  };
	
	  CSSTransitionGroupChild.prototype.render = function render() {
	    var props = _extends({}, this.props);
	    delete props.name;
	    delete props.appear;
	    delete props.enter;
	    delete props.leave;
	    delete props.appearTimeout;
	    delete props.enterTimeout;
	    delete props.leaveTimeout;
	    delete props.children;
	    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
	  };
	
	  return CSSTransitionGroupChild;
	}(_react2.default.Component);
	
	CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';
	
	
	CSSTransitionGroupChild.propTypes = propTypes;
	
	exports.default = CSSTransitionGroupChild;
	module.exports = exports['default'];

/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _chainFunction = __webpack_require__(831);
	
	var _chainFunction2 = _interopRequireDefault(_chainFunction);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(802);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ChildMapping = __webpack_require__(1576);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  component: _propTypes2.default.any,
	  childFactory: _propTypes2.default.func,
	  children: _propTypes2.default.node
	};
	
	var defaultProps = {
	  component: 'span',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.performAppear = function (key) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      var component = _this.childRefs[key];
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key));
	      } else {
	        _this._handleDoneAppearing(key);
	      }
	    };
	
	    _this._handleDoneAppearing = function (key) {
	      var component = _this.childRefs[key];
	      if (component && component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key);
	      }
	    };
	
	    _this.performEnter = function (key) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      var component = _this.childRefs[key];
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key));
	      } else {
	        _this._handleDoneEntering(key);
	      }
	    };
	
	    _this._handleDoneEntering = function (key) {
	      var component = _this.childRefs[key];
	      if (component && component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key);
	      }
	    };
	
	    _this.performLeave = function (key) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      var component = _this.childRefs[key];
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key);
	      }
	    };
	
	    _this._handleDoneLeaving = function (key) {
	      var component = _this.childRefs[key];
	
	      if (component && component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.performEnter(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _extends({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    };
	
	    _this.childRefs = Object.create(null);
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children)
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key);
	      }
	    }
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
	    });
	
	    for (var key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (var _key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
	      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
	        this.keysToLeave.push(_key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(this.performEnter);
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(this.performLeave);
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _this2 = this;
	
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	
	    var _loop = function _loop(key) {
	      var child = _this2.state.children[key];
	      if (child) {
	        var isCallbackRef = typeof child.ref !== 'string';
	         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;
	
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(_react2.default.cloneElement(_this2.props.childFactory(child), {
	          key: key,
	          ref: (0, _chainFunction2.default)(isCallbackRef ? child.ref : null, function (r) {
	            _this2.childRefs[key] = r;
	          })
	        }));
	      }
	    };
	
	    for (var key in this.state.children) {
	      _loop(key);
	    }
	
	    // Do not forward TransitionGroup props to primitive DOM nodes
	    var props = _extends({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return _react2.default.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.displayName = 'TransitionGroup';
	
	
	TransitionGroup.propTypes = propTypes;
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children) {
	  if (!children) {
	    return children;
	  }
	  var result = {};
	  _react.Children.map(children, function (child) {
	    return child;
	  }).forEach(function (child) {
	    result[child.key] = child;
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    if (next.hasOwnProperty(key)) {
	      return next[key];
	    }
	
	    return prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = {};
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (next.hasOwnProperty(prevKey)) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending.hasOwnProperty(nextKey)) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ }),
/* 1577 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(193);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(1578);
	var ReactElement = __webpack_require__(192);
	
	var emptyFunction = __webpack_require__(59);
	var traverseAllChildren = __webpack_require__(1589);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(193),
	    _assign = __webpack_require__(20);
	
	var ReactComponent = __webpack_require__(405);
	var ReactElement = __webpack_require__(192);
	var ReactPropTypeLocationNames = __webpack_require__(1582);
	var ReactNoopUpdateQueue = __webpack_require__(406);
	
	var emptyObject = __webpack_require__(216);
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(16);
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or host components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: 'DEFINE_MANY',
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: 'DEFINE_MANY',
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: 'DEFINE_MANY',
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: 'DEFINE_MANY_MERGED',
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @required
	   */
	  render: 'DEFINE_ONCE',
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: 'DEFINE_MANY',
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: 'DEFINE_ONCE',
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: 'DEFINE_MANY',
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: 'OVERRIDE_BASE'
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, 'childContext');
	    }
	    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, 'context');
	    }
	    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, 'prop');
	    }
	    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but only in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	    }
	  }
	}
	
	function validateMethodOverride(isAlreadyDefined, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === 'OVERRIDE_BASE') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (isAlreadyDefined) {
	    !(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classes.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    if (false) {
	      var typeofSpec = typeof spec;
	      var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	    }
	
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;
	
	  var proto = Constructor.prototype;
	  var autoBindPairs = proto.__reactAutoBindPairs;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    var isAlreadyDefined = proto.hasOwnProperty(name);
	    validateMethodOverride(isAlreadyDefined, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        autoBindPairs.push(name, property);
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY')) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === 'DEFINE_MANY_MERGED') {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === 'DEFINE_MANY') {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;
	
	    var isInherited = name in Constructor;
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  var pairs = component.__reactAutoBindPairs;
	  for (var i = 0; i < pairs.length; i += 2) {
	    var autoBindKey = pairs[i];
	    var method = pairs[i + 1];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback, 'replaceState');
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  }
	};
	
	var ReactClassComponent = function () {};
	_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	var didWarnDeprecated = false;
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(didWarnDeprecated, '%s: React.createClass is deprecated and will be removed in version 16. ' + 'Use plain JavaScript classes instead. If you\'re not yet ready to ' + 'migrate, create-react-class is available on npm as a ' + 'drop-in replacement.', spec && spec.displayName || 'A Component') : void 0;
	      didWarnDeprecated = true;
	    }
	
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(192);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(192),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(596);
	
	module.exports = factory(isValidElement);

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(20);
	
	var ReactComponent = __webpack_require__(405);
	var ReactNoopUpdateQueue = __webpack_require__(406);
	
	var emptyObject = __webpack_require__(216);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = ReactPureComponent;

/***/ }),
/* 1585 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.5.4';

/***/ }),
/* 1586 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 1587 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(193);
	
	var ReactElement = __webpack_require__(192);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(193);
	
	var ReactCurrentOwner = __webpack_require__(120);
	var REACT_ELEMENT_TYPE = __webpack_require__(639);
	
	var getIteratorFn = __webpack_require__(1586);
	var invariant = __webpack_require__(10);
	var KeyEscapeUtils = __webpack_require__(1577);
	var warning = __webpack_require__(16);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createHelper = __webpack_require__(30);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _createEagerFactory = __webpack_require__(53);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var branch = function branch(test, left, right) {
	  return function (BaseComponent) {
	    return function (_React$Component) {
	      _inherits(_class2, _React$Component);
	
	      function _class2(props, context) {
	        _classCallCheck(this, _class2);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	        _this.LeftComponent = null;
	        _this.RightComponent = null;
	
	        _this.computeChildComponent(_this.props);
	        return _this;
	      }
	
	      _class2.prototype.computeChildComponent = function computeChildComponent(props) {
	        if (test(props)) {
	          this.leftFactory = this.leftFactory || (0, _createEagerFactory2.default)(left(BaseComponent));
	          this.factory = this.leftFactory;
	        } else {
	          this.rightFactory = this.rightFactory || (0, _createEagerFactory2.default)(right(BaseComponent));
	          this.factory = this.rightFactory;
	        }
	      };
	
	      _class2.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.computeChildComponent(nextProps);
	      };
	
	      _class2.prototype.render = function render() {
	        return this.factory(this.props);
	      };
	
	      return _class2;
	    }(_react2.default.Component);
	  };
	};
	
	exports.default = (0, _createHelper2.default)(branch, 'branch');

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _omit = __webpack_require__(412);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _createEagerElement = __webpack_require__(642);
	
	var _createEagerElement2 = _interopRequireDefault(_createEagerElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var componentFromProp = function componentFromProp(propName) {
	  var Component = function Component(props) {
	    return (0, _createEagerElement2.default)(props[propName], (0, _omit2.default)(props, [propName]));
	  };
	  Component.displayName = 'componentFromProp(' + propName + ')';
	  return Component;
	};
	
	exports.default = componentFromProp;

/***/ }),
/* 1592 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = compose;
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  var last = funcs[funcs.length - 1];
	  return function () {
	    var result = last.apply(undefined, arguments);
	    for (var i = funcs.length - 2; i >= 0; i--) {
	      var f = funcs[i];
	      result = f(result);
	    }
	    return result;
	  };
	}

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createEventHandlerWithConfig = undefined;
	
	var _symbolObservable = __webpack_require__(409);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	var _changeEmitter = __webpack_require__(497);
	
	var _setObservableConfig = __webpack_require__(286);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createEventHandlerWithConfig = exports.createEventHandlerWithConfig = function createEventHandlerWithConfig(config) {
	  return function () {
	    var _config$fromESObserva;
	
	    var emitter = (0, _changeEmitter.createChangeEmitter)();
	    var stream = config.fromESObservable((_config$fromESObserva = {
	      subscribe: function subscribe(observer) {
	        var unsubscribe = emitter.listen(function (value) {
	          return observer.next(value);
	        });
	        return { unsubscribe: unsubscribe };
	      }
	    }, _config$fromESObserva[_symbolObservable2.default] = function () {
	      return this;
	    }, _config$fromESObserva));
	    return {
	      handler: emitter.emit,
	      stream: stream
	    };
	  };
	};
	
	var createEventHandler = createEventHandlerWithConfig(_setObservableConfig.config);
	
	exports.default = createEventHandler;

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var createSink = function createSink(callback) {
	  return function (_Component) {
	    _inherits(Sink, _Component);
	
	    function Sink() {
	      _classCallCheck(this, Sink);
	
	      return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    Sink.prototype.componentWillMount = function componentWillMount() {
	      callback(this.props);
	    };
	
	    Sink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      callback(nextProps);
	    };
	
	    Sink.prototype.render = function render() {
	      return null;
	    };
	
	    return Sink;
	  }(_react.Component);
	};
	
	exports.default = createSink;

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHelper = __webpack_require__(30);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _createEagerFactory = __webpack_require__(53);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultProps = function defaultProps(props) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	    var DefaultProps = function DefaultProps(ownerProps) {
	      return factory(ownerProps);
	    };
	    DefaultProps.defaultProps = props;
	    return DefaultProps;
	  };
	};
	
	exports.default = (0, _createHelper2.default)(defaultProps, 'defaultProps');

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createHelper = __webpack_require__(30);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _createEagerFactory = __webpack_require__(53);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var flattenProp = function flattenProp(propName) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	    return function (props) {
	      return factory(_extends({}, props, props[propName]));
	    };
	  };
	};
	
	exports.default = (0, _createHelper2.default)(flattenProp, 'flattenProp');

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createHelper = __webpack_require__(30);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _createEagerFactory = __webpack_require__(53);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getContext = function getContext(contextTypes) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	    var GetContext = function GetContext(ownerProps, context) {
	      return factory(_extends({}, ownerProps, context));
	    };
	
	    GetContext.contextTypes = contextTypes;
	
	    return GetContext;
	  };
	};
	
	exports.default = (0, _createHelper2.default)(getContext, 'getContext');

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _hoistNonReactStatics = __webpack_require__(161);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hoistStatics = function hoistStatics(higherOrderComponent) {
	  return function (BaseComponent) {
	    var NewComponent = higherOrderComponent(BaseComponent);
	    (0, _hoistNonReactStatics2.default)(NewComponent, BaseComponent);
	    return NewComponent;
	  };
	};
	
	exports.default = hoistStatics;

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _createHelper = __webpack_require__(30);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _createEagerFactory = __webpack_require__(53);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var lifecycle = function lifecycle(spec) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	
	    if (false) {
	      console.error('lifecycle() does not support the render method; its behavior is to ' + 'pass all props and state to the base component.');
	    }
	
	    /* eslint-disable react/prefer-es6-class */
	    return (0, _react.createClass)(_extends({}, spec, {
	      render: function render() {
	        return factory(_extends({}, this.props, this.state));
	      }
	    }));
	    /* eslint-enable react/prefer-es6-class */
	  };
	};
	
	exports.default = (0, _createHelper2.default)(lifecycle, 'lifecycle');

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.mapPropsStreamWithConfig = undefined;
	
	var _symbolObservable = __webpack_require__(409);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	var _createEagerFactory = __webpack_require__(53);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	var _createHelper = __webpack_require__(30);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _componentFromStream = __webpack_require__(641);
	
	var _setObservableConfig = __webpack_require__(286);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var identity = function identity(t) {
	  return t;
	};
	var componentFromStream = (0, _componentFromStream.componentFromStreamWithConfig)({
	  fromESObservable: identity,
	  toESObservable: identity
	});
	
	var mapPropsStreamWithConfig = exports.mapPropsStreamWithConfig = function mapPropsStreamWithConfig(config) {
	  return function (transform) {
	    return function (BaseComponent) {
	      var factory = (0, _createEagerFactory2.default)(BaseComponent);
	      var fromESObservable = config.fromESObservable;
	      var toESObservable = config.toESObservable;
	
	      return componentFromStream(function (props$) {
	        var _ref;
	
	        return _ref = {
	          subscribe: function subscribe(observer) {
	            var subscription = toESObservable(transform(fromESObservable(props$))).subscribe({
	              next: function next(childProps) {
	                return observer.next(factory(childProps));
	              }
	            });
	            return {
	              unsubscribe: function unsubscribe() {
	                return subscription.unsubscribe();
	              }
	            };
	          }
	        }, _ref[_symbolObservable2.default] = function () {
	          return this;
	        }, _ref;
	      });
	    };
	  };
	};
	
	var mapPropsStream = mapPropsStreamWithConfig(_setObservableConfig.config);
	
	exports.default = (0, _createHelper2.default)(mapPropsStream, 'mapPropsStream');

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createEagerFactory = __webpack_require__(53);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var nest = function nest() {
	  for (var _len = arguments.length, Components = Array(_len), _key = 0; _key < _len; _key++) {
	    Components[_key] = arguments[_key];
	  }
	
	  var factories = Components.map(_createEagerFactory2.default);
	  var Nest = function Nest(_ref) {
	    var props = _objectWithoutProperties(_ref, []);
	
	    var children = _ref.children;
	    return factories.reduceRight(function (child, factory) {
	      return factory(props, child);
	    }, children);
	  };
	
	  if (false) {
	    /* eslint-disable global-require */
	    var getDisplayName = require('./getDisplayName').default;
	    /* eslint-enable global-require */
	    var displayNames = Components.map(getDisplayName);
	    Nest.displayName = 'nest(' + displayNames.join(', ') + ')';
	  }
	
	  return Nest;
	};
	
	exports.default = nest;

/***/ }),
/* 1602 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function symbolObservablePonyfill(root) {
		var result;
		var Symbol = root.Symbol;
	
		if (typeof Symbol === 'function') {
			if (Symbol.observable) {
				result = Symbol.observable;
			} else {
				result = Symbol('observable');
				Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};


/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _onlyUpdateForKeys = __webpack_require__(644);
	
	var _onlyUpdateForKeys2 = _interopRequireDefault(_onlyUpdateForKeys);
	
	var _createHelper = __webpack_require__(30);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onlyUpdateForPropTypes = function onlyUpdateForPropTypes(BaseComponent) {
	  var propTypes = BaseComponent.propTypes;
	
	  if (false) {
	    /* eslint-disable global-require */
	    var getDisplayName = require('./getDisplayName').default;
	    /* eslint-enable global-require */
	    if (!propTypes) {
	      /* eslint-disable */
	      console.error('A component without any `propTypes` was passed to ' + '`onlyUpdateForPropTypes()`. Check the implementation of the ' + ('component with display name "' + getDisplayName(BaseComponent) + '".'));
	      /* eslint-enable */
	    }
	  }
	
	  var propKeys = Object.keys(propTypes || {});
	  var OnlyUpdateForPropTypes = (0, _onlyUpdateForKeys2.default)(propKeys)(BaseComponent);
	
	  return OnlyUpdateForPropTypes;
	};
	
	exports.default = (0, _createHelper2.default)(onlyUpdateForPropTypes, 'onlyUpdateForPropTypes', true, true);

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shouldUpdate = __webpack_require__(411);
	
	var _shouldUpdate2 = _interopRequireDefault(_shouldUpdate);
	
	var _shallowEqual = __webpack_require__(287);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _createHelper = __webpack_require__(30);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pure = (0, _shouldUpdate2.default)(function (props, nextProps) {
	  return !(0, _shallowEqual2.default)(props, nextProps);
	});
	
	exports.default = (0, _createHelper2.default)(pure, 'pure', true, true);

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _omit = __webpack_require__(412);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _mapProps = __webpack_require__(285);
	
	var _mapProps2 = _interopRequireDefault(_mapProps);
	
	var _createHelper = __webpack_require__(30);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renameProp = function renameProp(oldName, newName) {
	  return (0, _mapProps2.default)(function (props) {
	    var _extends2;
	
	    return _extends({}, (0, _omit2.default)(props, [oldName]), (_extends2 = {}, _extends2[newName] = props[oldName], _extends2));
	  });
	};
	
	exports.default = (0, _createHelper2.default)(renameProp, 'renameProp');

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _omit = __webpack_require__(412);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _pick = __webpack_require__(413);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	var _mapProps = __webpack_require__(285);
	
	var _mapProps2 = _interopRequireDefault(_mapProps);
	
	var _createHelper = __webpack_require__(30);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var keys = Object.keys;
	
	
	var mapKeys = function mapKeys(obj, func) {
	  return keys(obj).reduce(function (result, key) {
	    var val = obj[key];
	    /* eslint-disable no-param-reassign */
	    result[func(val, key)] = val;
	    /* eslint-enable no-param-reassign */
	    return result;
	  }, {});
	};
	
	var renameProps = function renameProps(nameMap) {
	  return (0, _mapProps2.default)(function (props) {
	    return _extends({}, (0, _omit2.default)(props, keys(nameMap)), mapKeys((0, _pick2.default)(props, keys(nameMap)), function (_, oldName) {
	      return nameMap[oldName];
	    }));
	  });
	};
	
	exports.default = (0, _createHelper2.default)(renameProps, 'renameProps');

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHelper = __webpack_require__(30);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _createEagerFactory = __webpack_require__(53);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import React from 'react'
	
	
	var renderComponent = function renderComponent(Component) {
	  return function (_) {
	    var factory = (0, _createEagerFactory2.default)(Component);
	    var RenderComponent = function RenderComponent(props) {
	      return factory(props);
	    };
	    // const RenderComponent = props => <Component {...props} />
	    if (false) {
	      /* eslint-disable global-require */
	      var wrapDisplayName = require('./wrapDisplayName').default;
	      /* eslint-enable global-require */
	      RenderComponent.displayName = wrapDisplayName(Component, 'renderComponent');
	    }
	    return RenderComponent;
	  };
	};
	
	exports.default = (0, _createHelper2.default)(renderComponent, 'renderComponent', false);

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHelper = __webpack_require__(30);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderNothing = function renderNothing(_) {
	  var Nothing = function Nothing() {
	    return null;
	  };
	  Nothing.displayName = 'Nothing';
	  return Nothing;
	};
	
	exports.default = (0, _createHelper2.default)(renderNothing, 'renderNothing', false, true);

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _setStatic = __webpack_require__(410);
	
	var _setStatic2 = _interopRequireDefault(_setStatic);
	
	var _createHelper = __webpack_require__(30);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var setDisplayName = function setDisplayName(displayName) {
	  return (0, _setStatic2.default)('displayName', displayName);
	};
	
	exports.default = (0, _createHelper2.default)(setDisplayName, 'setDisplayName', false);

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _setStatic = __webpack_require__(410);
	
	var _setStatic2 = _interopRequireDefault(_setStatic);
	
	var _createHelper = __webpack_require__(30);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var setPropTypes = function setPropTypes(propTypes) {
	  return (0, _setStatic2.default)('propTypes', propTypes);
	};
	
	exports.default = (0, _createHelper2.default)(setPropTypes, 'setPropTypes', false);

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _getDisplayName = __webpack_require__(407);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	var _isClassComponent = __webpack_require__(408);
	
	var _isClassComponent2 = _interopRequireDefault(_isClassComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var toClass = function toClass(baseComponent) {
	  if ((0, _isClassComponent2.default)(baseComponent)) {
	    return baseComponent;
	  }
	
	  var ToClass = function (_Component) {
	    _inherits(ToClass, _Component);
	
	    function ToClass() {
	      _classCallCheck(this, ToClass);
	
	      return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    ToClass.prototype.render = function render() {
	      if (typeof baseComponent === 'string') {
	        return _react2.default.createElement('baseComponent', this.props);
	      }
	      return baseComponent(this.props, this.context);
	    };
	
	    return ToClass;
	  }(_react.Component);
	
	  ToClass.displayName = (0, _getDisplayName2.default)(baseComponent);
	  ToClass.propTypes = baseComponent.propTypes;
	  ToClass.contextTypes = baseComponent.contextTypes;
	  ToClass.defaultProps = baseComponent.defaultProps;
	
	  return ToClass;
	};
	
	exports.default = toClass;

/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _createHelper = __webpack_require__(30);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _createEagerFactory = __webpack_require__(53);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var withContext = function withContext(childContextTypes, getChildContext) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	
	    var WithContext = function (_Component) {
	      _inherits(WithContext, _Component);
	
	      function WithContext() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, WithContext);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getChildContext = function () {
	          return getChildContext(_this.props);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      WithContext.prototype.render = function render() {
	        return factory(this.props);
	      };
	
	      return WithContext;
	    }(_react.Component);
	
	    WithContext.childContextTypes = childContextTypes;
	
	    return WithContext;
	  };
	};
	
	exports.default = (0, _createHelper2.default)(withContext, 'withContext');

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _createEagerFactory = __webpack_require__(53);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	var _createHelper = __webpack_require__(30);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapValues = function mapValues(obj, func) {
	  var result = [];
	  var i = 0;
	  /* eslint-disable no-restricted-syntax */
	  for (var key in obj) {
	    if (obj.hasOwnProperty(key)) {
	      i += 1;
	      result[key] = func(obj[key], key, i);
	    }
	  }
	  /* eslint-enable no-restricted-syntax */
	  return result;
	};
	
	var withHandlers = function withHandlers(handlers) {
	  return function (BaseComponent) {
	    var _class, _temp2, _initialiseProps;
	
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	    return _temp2 = _class = function (_Component) {
	      _inherits(_class, _Component);
	
	      function _class() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, _class);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      _class.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
	        this.cachedHandlers = {};
	      };
	
	      _class.prototype.render = function render() {
	        return factory(_extends({}, this.props, this.handlers));
	      };
	
	      return _class;
	    }(_react.Component), _initialiseProps = function _initialiseProps() {
	      var _this2 = this;
	
	      this.cachedHandlers = {};
	      this.handlers = mapValues(handlers, function (createHandler, handlerName) {
	        return function () {
	          var cachedHandler = _this2.cachedHandlers[handlerName];
	          if (cachedHandler) {
	            return cachedHandler.apply(undefined, arguments);
	          }
	
	          var handler = createHandler(_this2.props);
	          _this2.cachedHandlers[handlerName] = handler;
	
	          if (false) {
	            console.error('withHandlers(): Expected a map of higher-order functions. ' + 'Refer to the docs for more info.');
	          }
	
	          return handler.apply(undefined, arguments);
	        };
	      });
	    }, _temp2;
	  };
	};
	
	exports.default = (0, _createHelper2.default)(withHandlers, 'withHandlers');

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createHelper = __webpack_require__(30);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _mapProps = __webpack_require__(285);
	
	var _mapProps2 = _interopRequireDefault(_mapProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var withProps = function withProps(input) {
	  return (0, _mapProps2.default)(function (props) {
	    return _extends({}, props, typeof input === 'function' ? input(props) : input);
	  });
	};
	
	exports.default = (0, _createHelper2.default)(withProps, 'withProps');

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _pick = __webpack_require__(413);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	var _shallowEqual = __webpack_require__(287);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _createHelper = __webpack_require__(30);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _createEagerFactory = __webpack_require__(53);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	    var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
	      return !(0, _shallowEqual2.default)((0, _pick2.default)(props, shouldMapOrKeys), (0, _pick2.default)(nextProps, shouldMapOrKeys));
	    };
	
	    return function (_Component) {
	      _inherits(_class2, _Component);
	
	      function _class2() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, _class2);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.computedProps = propsMapper(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      _class2.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (shouldMap(this.props, nextProps)) {
	          this.computedProps = propsMapper(nextProps);
	        }
	      };
	
	      _class2.prototype.render = function render() {
	        return factory(_extends({}, this.props, this.computedProps));
	      };
	
	      return _class2;
	    }(_react.Component);
	  };
	};
	
	exports.default = (0, _createHelper2.default)(withPropsOnChange, 'withPropsOnChange');

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _createHelper = __webpack_require__(30);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _createEagerFactory = __webpack_require__(53);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var withReducer = function withReducer(stateName, dispatchName, reducer, initialState) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	    return function (_Component) {
	      _inherits(_class2, _Component);
	
	      function _class2() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, _class2);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
	        }, _this.dispatch = function (action) {
	          return _this.setState(function (_ref) {
	            var stateValue = _ref.stateValue;
	            return {
	              stateValue: reducer(stateValue, action)
	            };
	          });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      _class2.prototype.render = function render() {
	        var _extends2;
	
	        return factory(_extends({}, this.props, (_extends2 = {}, _extends2[stateName] = this.state.stateValue, _extends2[dispatchName] = this.dispatch, _extends2)));
	      };
	
	      return _class2;
	    }(_react.Component);
	  };
	};
	
	exports.default = (0, _createHelper2.default)(withReducer, 'withReducer');

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _createHelper = __webpack_require__(30);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _createEagerFactory = __webpack_require__(53);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var withState = function withState(stateName, stateUpdaterName, initialState) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	    return function (_Component) {
	      _inherits(_class2, _Component);
	
	      function _class2() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, _class2);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
	        }, _this.updateStateValue = function (updateFn, callback) {
	          return _this.setState(function (_ref) {
	            var stateValue = _ref.stateValue;
	            return {
	              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
	            };
	          }, callback);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      _class2.prototype.render = function render() {
	        var _extends2;
	
	        return factory(_extends({}, this.props, (_extends2 = {}, _extends2[stateName] = this.state.stateValue, _extends2[stateUpdaterName] = this.updateStateValue, _extends2)));
	      };
	
	      return _class2;
	    }(_react.Component);
	  };
	};
	
	exports.default = (0, _createHelper2.default)(withState, 'withState');

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _getDisplayName = __webpack_require__(407);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
	  return hocName + '(' + (0, _getDisplayName2.default)(BaseComponent) + ')';
	};
	
	exports.default = wrapDisplayName;

/***/ }),
/* 1619 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var type = exports.type = '@@redux-batch-middleware/BATCH';
	
	var batch = exports.batch = function batch(_ref) {
	    var dispatch = _ref.dispatch;
	
	    return function (next) {
	        return function (action) {
	            Array.isArray(action) ? dispatch({ type: type, payload: action }) : next(action);
	        };
	    };
	};
	
	var batching = exports.batching = function batching(reducer) {
	    return function batcher(state, action) {
	        return action.type === type ? action.payload.reduce(batcher, state) : reducer(state, action);
	    };
	};

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isPromise = __webpack_require__(373);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	var _isValid = __webpack_require__(288);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var asyncValidation = function asyncValidation(fn, start, stop, field) {
	  start(field);
	  var promise = fn();
	  if (!(0, _isPromise2.default)(promise)) {
	    throw new Error('asyncValidate function passed to reduxForm must return a promise');
	  }
	  var handleErrors = function handleErrors(rejected) {
	    return function (errors) {
	      if (!(0, _isValid2.default)(errors)) {
	        stop(errors);
	        return Promise.reject();
	      } else if (rejected) {
	        stop();
	        throw new Error('Asynchronous validation promise was rejected without errors.');
	      }
	      stop();
	      return Promise.resolve();
	    };
	  };
	  return promise.then(handleErrors(false), handleErrors(true));
	};
	
	exports.default = asyncValidation;

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createAll;
	
	var _reducer = __webpack_require__(417);
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _createReduxForm = __webpack_require__(1624);
	
	var _createReduxForm2 = _interopRequireDefault(_createReduxForm);
	
	var _mapValues = __webpack_require__(416);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _bindActionData = __webpack_require__(647);
	
	var _bindActionData2 = _interopRequireDefault(_bindActionData);
	
	var _actions = __webpack_require__(646);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _actionTypes = __webpack_require__(414);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _createPropTypes = __webpack_require__(1623);
	
	var _createPropTypes2 = _interopRequireDefault(_createPropTypes);
	
	var _getValuesFromState = __webpack_require__(655);
	
	var _getValuesFromState2 = _interopRequireDefault(_getValuesFromState);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// bind form as first parameter of action creators
	var boundActions = _extends({}, (0, _mapValues2.default)(_extends({}, actions, {
	  autofillWithKey: function autofillWithKey(key) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return (0, _bindActionData2.default)(actions.autofill, { key: key }).apply(undefined, args);
	  },
	  changeWithKey: function changeWithKey(key) {
	    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	      args[_key2 - 1] = arguments[_key2];
	    }
	
	    return (0, _bindActionData2.default)(actions.change, { key: key }).apply(undefined, args);
	  },
	  initializeWithKey: function initializeWithKey(key) {
	    for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	      args[_key3 - 1] = arguments[_key3];
	    }
	
	    return (0, _bindActionData2.default)(actions.initialize, { key: key }).apply(undefined, args);
	  },
	  reset: function reset(key) {
	    return (0, _bindActionData2.default)(actions.reset, { key: key })();
	  },
	  touchWithKey: function touchWithKey(key) {
	    for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	      args[_key4 - 1] = arguments[_key4];
	    }
	
	    return (0, _bindActionData2.default)(actions.touch, { key: key }).apply(undefined, args);
	  },
	  untouchWithKey: function untouchWithKey(key) {
	    for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	      args[_key5 - 1] = arguments[_key5];
	    }
	
	    return (0, _bindActionData2.default)(actions.untouch, { key: key }).apply(undefined, args);
	  },
	  destroy: function destroy(key) {
	    return (0, _bindActionData2.default)(actions.destroy, { key: key })();
	  }
	}), function (action) {
	  return function (form) {
	    for (var _len6 = arguments.length, args = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
	      args[_key6 - 1] = arguments[_key6];
	    }
	
	    return (0, _bindActionData2.default)(action, { form: form }).apply(undefined, args);
	  };
	}));
	
	var addArrayValue = boundActions.addArrayValue;
	var autofill = boundActions.autofill;
	var autofillWithKey = boundActions.autofillWithKey;
	var blur = boundActions.blur;
	var change = boundActions.change;
	var changeWithKey = boundActions.changeWithKey;
	var destroy = boundActions.destroy;
	var focus = boundActions.focus;
	var initialize = boundActions.initialize;
	var initializeWithKey = boundActions.initializeWithKey;
	var removeArrayValue = boundActions.removeArrayValue;
	var reset = boundActions.reset;
	var startAsyncValidation = boundActions.startAsyncValidation;
	var startSubmit = boundActions.startSubmit;
	var stopAsyncValidation = boundActions.stopAsyncValidation;
	var stopSubmit = boundActions.stopSubmit;
	var submitFailed = boundActions.submitFailed;
	var swapArrayValues = boundActions.swapArrayValues;
	var touch = boundActions.touch;
	var touchWithKey = boundActions.touchWithKey;
	var untouch = boundActions.untouch;
	var untouchWithKey = boundActions.untouchWithKey;
	
	function createAll(isReactNative, React, connect) {
	  return {
	    actionTypes: actionTypes,
	    addArrayValue: addArrayValue,
	    autofill: autofill,
	    autofillWithKey: autofillWithKey,
	    blur: blur,
	    change: change,
	    changeWithKey: changeWithKey,
	    destroy: destroy,
	    focus: focus,
	    getValues: _getValuesFromState2.default,
	    initialize: initialize,
	    initializeWithKey: initializeWithKey,
	    propTypes: (0, _createPropTypes2.default)(),
	    reduxForm: (0, _createReduxForm2.default)(isReactNative, React, connect),
	    reducer: _reducer2.default,
	    removeArrayValue: removeArrayValue,
	    reset: reset,
	    startAsyncValidation: startAsyncValidation,
	    startSubmit: startSubmit,
	    stopAsyncValidation: stopAsyncValidation,
	    stopSubmit: stopSubmit,
	    submitFailed: submitFailed,
	    swapArrayValues: swapArrayValues,
	    touch: touch,
	    touchWithKey: touchWithKey,
	    untouch: untouch,
	    untouchWithKey: untouchWithKey
	  };
	}

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _actions = __webpack_require__(646);
	
	var importedActions = _interopRequireWildcard(_actions);
	
	var _getDisplayName = __webpack_require__(653);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	var _reducer = __webpack_require__(417);
	
	var _deepEqual = __webpack_require__(354);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _bindActionData = __webpack_require__(647);
	
	var _bindActionData2 = _interopRequireDefault(_bindActionData);
	
	var _getValues = __webpack_require__(654);
	
	var _getValues2 = _interopRequireDefault(_getValues);
	
	var _isValid = __webpack_require__(288);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	var _readFields = __webpack_require__(1635);
	
	var _readFields2 = _interopRequireDefault(_readFields);
	
	var _handleSubmit2 = __webpack_require__(1631);
	
	var _handleSubmit3 = _interopRequireDefault(_handleSubmit2);
	
	var _asyncValidation = __webpack_require__(1620);
	
	var _asyncValidation2 = _interopRequireDefault(_asyncValidation);
	
	var _silenceEvents = __webpack_require__(1630);
	
	var _silenceEvents2 = _interopRequireDefault(_silenceEvents);
	
	var _silenceEvent = __webpack_require__(652);
	
	var _silenceEvent2 = _interopRequireDefault(_silenceEvent);
	
	var _wrapMapDispatchToProps = __webpack_require__(1641);
	
	var _wrapMapDispatchToProps2 = _interopRequireDefault(_wrapMapDispatchToProps);
	
	var _wrapMapStateToProps = __webpack_require__(1642);
	
	var _wrapMapStateToProps2 = _interopRequireDefault(_wrapMapStateToProps);
	
	var _createInitialState = __webpack_require__(648);
	
	var _createInitialState2 = _interopRequireDefault(_createInitialState);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Creates a HOC that knows how to create redux-connected sub-components.
	 */
	var createHigherOrderComponent = function createHigherOrderComponent(config, isReactNative, React, connect, WrappedComponent, mapStateToProps, mapDispatchToProps, mergeProps, options) {
	  var Component = React.Component;
	
	  return function (reduxMountPoint, formName, formKey, getFormState) {
	    var _ref = options || {},
	        _ref$withRef = _ref.withRef,
	        withRef = _ref$withRef === undefined ? false : _ref$withRef;
	
	    var ReduxForm = function (_Component) {
	      _inherits(ReduxForm, _Component);
	
	      function ReduxForm(props) {
	        _classCallCheck(this, ReduxForm);
	
	        // bind functions
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.asyncValidate = _this.asyncValidate.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        var _this$props = _this.props,
	            initialValues = _this$props.initialValues,
	            submitPassback = _this$props.submitPassback;
	        // Check if form state was initialized, if not, initialize it.
	
	        var form = (0, _deepEqual2.default)(props.form, _reducer.initialState) ? (0, _createInitialState2.default)(initialValues, config.fields, {}, true, false) : props.form;
	        _this.fields = (0, _readFields2.default)(_extends({}, props, { form: form }), {}, {}, _this.asyncValidate, isReactNative);
	        submitPassback(function () {
	          return _this.handleSubmit();
	        }); // wrapped in function to disallow params
	        return _this;
	      }
	
	      ReduxForm.prototype.componentWillMount = function componentWillMount() {
	        var _props = this.props,
	            fields = _props.fields,
	            form = _props.form,
	            initialize = _props.initialize,
	            initialValues = _props.initialValues;
	
	        if (initialValues && !form._initialized) {
	          initialize(initialValues, fields);
	        }
	      };
	
	      ReduxForm.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!(0, _deepEqual2.default)(this.props.fields, nextProps.fields) || !(0, _deepEqual2.default)(this.props.form, nextProps.form, { strict: true })) {
	          this.fields = (0, _readFields2.default)(nextProps, this.props, this.fields, this.asyncValidate, isReactNative);
	        }
	        if (!(0, _deepEqual2.default)(this.props.initialValues, nextProps.initialValues)) {
	          this.props.initialize(nextProps.initialValues, nextProps.fields, this.props.overwriteOnInitialValuesChange || !this.props.form._initialized);
	        }
	      };
	
	      ReduxForm.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (config.destroyOnUnmount) {
	          this.props.destroy();
	        }
	      };
	
	      ReduxForm.prototype.asyncValidate = function asyncValidate(name, value) {
	        var _this2 = this;
	
	        var _props2 = this.props,
	            alwaysAsyncValidate = _props2.alwaysAsyncValidate,
	            asyncValidate = _props2.asyncValidate,
	            dispatch = _props2.dispatch,
	            fields = _props2.fields,
	            form = _props2.form,
	            startAsyncValidation = _props2.startAsyncValidation,
	            stopAsyncValidation = _props2.stopAsyncValidation,
	            validate = _props2.validate;
	
	        var isSubmitting = !name;
	        if (asyncValidate) {
	          var values = (0, _getValues2.default)(fields, form);
	          if (name) {
	            values[name] = value;
	          }
	          var syncErrors = validate(values, this.props);
	          var allPristine = this.fields._meta.allPristine;
	
	          var initialized = form._initialized;
	
	          // if blur validating, only run async validate if sync validation passes
	          // and submitting (not blur validation) or form is dirty or form was never initialized
	          // unless alwaysAsyncValidate is true
	          var syncValidationPasses = isSubmitting || (0, _isValid2.default)(syncErrors[name]);
	          if (alwaysAsyncValidate || syncValidationPasses && (isSubmitting || !allPristine || !initialized)) {
	            return (0, _asyncValidation2.default)(function () {
	              return asyncValidate(values, dispatch, _this2.props);
	            }, startAsyncValidation, stopAsyncValidation, name);
	          }
	        }
	      };
	
	      ReduxForm.prototype.handleSubmit = function handleSubmit(submitOrEvent) {
	        var _this3 = this;
	
	        var _props3 = this.props,
	            onSubmit = _props3.onSubmit,
	            fields = _props3.fields,
	            form = _props3.form;
	
	        var check = function check(submit) {
	          if (!submit || typeof submit !== 'function') {
	            throw new Error('You must either pass handleSubmit() an onSubmit function or pass onSubmit as a prop');
	          }
	          return submit;
	        };
	        return !submitOrEvent || (0, _silenceEvent2.default)(submitOrEvent) ?
	        // submitOrEvent is an event: fire submit
	        (0, _handleSubmit3.default)(check(onSubmit), (0, _getValues2.default)(fields, form), this.props, this.asyncValidate) :
	        // submitOrEvent is the submit function: return deferred submit thunk
	        (0, _silenceEvents2.default)(function () {
	          return (0, _handleSubmit3.default)(check(submitOrEvent), (0, _getValues2.default)(fields, form), _this3.props, _this3.asyncValidate);
	        });
	      };
	
	      ReduxForm.prototype.render = function render() {
	        var _this4 = this,
	            _ref2;
	
	        var allFields = this.fields;
	
	        var _props4 = this.props,
	            addArrayValue = _props4.addArrayValue,
	            asyncBlurFields = _props4.asyncBlurFields,
	            autofill = _props4.autofill,
	            blur = _props4.blur,
	            change = _props4.change,
	            destroy = _props4.destroy,
	            focus = _props4.focus,
	            fields = _props4.fields,
	            form = _props4.form,
	            initialValues = _props4.initialValues,
	            initialize = _props4.initialize,
	            onSubmit = _props4.onSubmit,
	            propNamespace = _props4.propNamespace,
	            reset = _props4.reset,
	            removeArrayValue = _props4.removeArrayValue,
	            returnRejectedSubmitPromise = _props4.returnRejectedSubmitPromise,
	            startAsyncValidation = _props4.startAsyncValidation,
	            startSubmit = _props4.startSubmit,
	            stopAsyncValidation = _props4.stopAsyncValidation,
	            stopSubmit = _props4.stopSubmit,
	            submitFailed = _props4.submitFailed,
	            swapArrayValues = _props4.swapArrayValues,
	            touch = _props4.touch,
	            untouch = _props4.untouch,
	            validate = _props4.validate,
	            passableProps = _objectWithoutProperties(_props4, ['addArrayValue', 'asyncBlurFields', 'autofill', 'blur', 'change', 'destroy', 'focus', 'fields', 'form', 'initialValues', 'initialize', 'onSubmit', 'propNamespace', 'reset', 'removeArrayValue', 'returnRejectedSubmitPromise', 'startAsyncValidation', 'startSubmit', 'stopAsyncValidation', 'stopSubmit', 'submitFailed', 'swapArrayValues', 'touch', 'untouch', 'validate']); // eslint-disable-line no-redeclare
	
	
	        var _allFields$_meta = allFields._meta,
	            allPristine = _allFields$_meta.allPristine,
	            allValid = _allFields$_meta.allValid,
	            errors = _allFields$_meta.errors,
	            formError = _allFields$_meta.formError,
	            values = _allFields$_meta.values;
	
	
	        var props = {
	          // State:
	          active: form._active,
	          asyncValidating: form._asyncValidating,
	          dirty: !allPristine,
	          error: formError,
	          errors: errors,
	          fields: allFields,
	          formKey: formKey,
	          invalid: !allValid,
	          pristine: allPristine,
	          submitting: form._submitting,
	          submitFailed: form._submitFailed,
	          valid: allValid,
	          values: values,
	
	          // Actions:
	          asyncValidate: (0, _silenceEvents2.default)(function () {
	            return _this4.asyncValidate();
	          }),
	          // ^ doesn't just pass this.asyncValidate to disallow values passing
	          destroyForm: (0, _silenceEvents2.default)(destroy),
	          handleSubmit: this.handleSubmit,
	          initializeForm: (0, _silenceEvents2.default)(function (initValues) {
	            return initialize(initValues, fields);
	          }),
	          resetForm: (0, _silenceEvents2.default)(reset),
	          touch: (0, _silenceEvents2.default)(function () {
	            return touch.apply(undefined, arguments);
	          }),
	          touchAll: (0, _silenceEvents2.default)(function () {
	            return touch.apply(undefined, fields);
	          }),
	          untouch: (0, _silenceEvents2.default)(function () {
	            return untouch.apply(undefined, arguments);
	          }),
	          untouchAll: (0, _silenceEvents2.default)(function () {
	            return untouch.apply(undefined, fields);
	          })
	        };
	        var passedProps = propNamespace ? (_ref2 = {}, _ref2[propNamespace] = props, _ref2) : props;
	        if (withRef) {
	          return React.createElement(WrappedComponent, _extends({}, _extends({}, passableProps, passedProps), { ref: 'wrappedInstance' }));
	        }
	        return React.createElement(WrappedComponent, _extends({}, passableProps, passedProps));
	      };
	
	      return ReduxForm;
	    }(Component);
	
	    ReduxForm.displayName = 'ReduxForm(' + (0, _getDisplayName2.default)(WrappedComponent) + ')';
	    ReduxForm.WrappedComponent = WrappedComponent;
	    ReduxForm.propTypes = {
	      // props:
	      alwaysAsyncValidate: _propTypes2.default.bool,
	      asyncBlurFields: _propTypes2.default.arrayOf(_propTypes2.default.string),
	      asyncValidate: _propTypes2.default.func,
	      dispatch: _propTypes2.default.func.isRequired,
	      fields: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
	      form: _propTypes2.default.object,
	      initialValues: _propTypes2.default.any,
	      onSubmit: _propTypes2.default.func,
	      onSubmitSuccess: _propTypes2.default.func,
	      onSubmitFail: _propTypes2.default.func,
	      overwriteOnInitialValuesChange: _propTypes2.default.bool.isRequired,
	      propNamespace: _propTypes2.default.string,
	      readonly: _propTypes2.default.bool,
	      returnRejectedSubmitPromise: _propTypes2.default.bool,
	      submitPassback: _propTypes2.default.func.isRequired,
	      validate: _propTypes2.default.func,
	
	      // actions:
	      addArrayValue: _propTypes2.default.func.isRequired,
	      autofill: _propTypes2.default.func.isRequired,
	      blur: _propTypes2.default.func.isRequired,
	      change: _propTypes2.default.func.isRequired,
	      destroy: _propTypes2.default.func.isRequired,
	      focus: _propTypes2.default.func.isRequired,
	      initialize: _propTypes2.default.func.isRequired,
	      removeArrayValue: _propTypes2.default.func.isRequired,
	      reset: _propTypes2.default.func.isRequired,
	      startAsyncValidation: _propTypes2.default.func.isRequired,
	      startSubmit: _propTypes2.default.func.isRequired,
	      stopAsyncValidation: _propTypes2.default.func.isRequired,
	      stopSubmit: _propTypes2.default.func.isRequired,
	      submitFailed: _propTypes2.default.func.isRequired,
	      swapArrayValues: _propTypes2.default.func.isRequired,
	      touch: _propTypes2.default.func.isRequired,
	      untouch: _propTypes2.default.func.isRequired
	    };
	    ReduxForm.defaultProps = {
	      asyncBlurFields: [],
	      form: _reducer.initialState,
	      readonly: false,
	      returnRejectedSubmitPromise: false,
	      validate: function validate() {
	        return {};
	      }
	    };
	
	    // bind touch flags to blur and change
	    var unboundActions = _extends({}, importedActions, {
	      blur: (0, _bindActionData2.default)(importedActions.blur, {
	        touch: !!config.touchOnBlur
	      }),
	      change: (0, _bindActionData2.default)(importedActions.change, {
	        touch: !!config.touchOnChange
	      })
	    });
	
	    // make redux connector with or without form key
	    var decorate = formKey !== undefined && formKey !== null ? connect((0, _wrapMapStateToProps2.default)(mapStateToProps, function (state) {
	      var formState = getFormState(state, reduxMountPoint);
	      if (!formState) {
	        throw new Error('You need to mount the redux-form reducer at "' + reduxMountPoint + '"');
	      }
	      return formState && formState[formName] && formState[formName][formKey];
	    }), (0, _wrapMapDispatchToProps2.default)(mapDispatchToProps, (0, _bindActionData2.default)(unboundActions, {
	      form: formName,
	      key: formKey
	    })), mergeProps, options) : connect((0, _wrapMapStateToProps2.default)(mapStateToProps, function (state) {
	      var formState = getFormState(state, reduxMountPoint);
	      if (!formState) {
	        throw new Error('You need to mount the redux-form reducer at "' + reduxMountPoint + '"');
	      }
	      return formState && formState[formName];
	    }), (0, _wrapMapDispatchToProps2.default)(mapDispatchToProps, (0, _bindActionData2.default)(unboundActions, { form: formName })), mergeProps, options);
	
	    return decorate(ReduxForm);
	  };
	};
	
	exports.default = createHigherOrderComponent;

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createPropTypes = function createPropTypes() {
	  return {
	    // State:
	    active: _propTypes2.default.string, // currently active field
	    asyncValidating: _propTypes2.default.bool.isRequired, // true if async validation is running
	    autofilled: _propTypes2.default.bool, // true if set programmatically by autofill
	    dirty: _propTypes2.default.bool.isRequired, // true if any values are different from initialValues
	    error: _propTypes2.default.any, // form-wide error from '_error' key in validation result
	    errors: _propTypes2.default.object, // a map of errors corresponding to structure of form data (result of validation)
	    fields: _propTypes2.default.object.isRequired, // the map of fields
	    formKey: _propTypes2.default.any, // the form key if one was provided (used when doing multirecord forms)
	    invalid: _propTypes2.default.bool.isRequired, // true if there are any validation errors
	    pristine: _propTypes2.default.bool.isRequired, // true if the values are the same as initialValues
	    submitting: _propTypes2.default.bool.isRequired, // true if the form is in the process of being submitted
	    submitFailed: _propTypes2.default.bool.isRequired, // true if the form was submitted and failed for any reason
	    valid: _propTypes2.default.bool.isRequired, // true if there are no validation errors
	    values: _propTypes2.default.object.isRequired, // the values of the form as they will be submitted
	
	    // Actions:
	    asyncValidate: _propTypes2.default.func.isRequired, // function to trigger async validation
	    destroyForm: _propTypes2.default.func.isRequired, // action to destroy the form's data in Redux
	    handleSubmit: _propTypes2.default.func.isRequired, // function to submit the form
	    initializeForm: _propTypes2.default.func.isRequired, // action to initialize form data
	    resetForm: _propTypes2.default.func.isRequired, // action to reset the form data to previously initialized values
	    touch: _propTypes2.default.func.isRequired, // action to mark fields as touched
	    touchAll: _propTypes2.default.func.isRequired, // action to mark ALL fields as touched
	    untouch: _propTypes2.default.func.isRequired, // action to mark fields as untouched
	    untouchAll: _propTypes2.default.func.isRequired // action to mark ALL fields as untouched
	  };
	};
	
	exports.default = createPropTypes;

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createReduxFormConnector = __webpack_require__(1625);
	
	var _createReduxFormConnector2 = _interopRequireDefault(_createReduxFormConnector);
	
	var _hoistNonReactStatics = __webpack_require__(161);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(18);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The decorator that is the main API to redux-form
	 */
	var createReduxForm = function createReduxForm(isReactNative, React, connect) {
	  var Component = React.Component;
	
	  var reduxFormConnector = (0, _createReduxFormConnector2.default)(isReactNative, React, connect);
	  return function (config, mapStateToProps, mapDispatchToProps, mergeProps, options) {
	    return function (WrappedComponent) {
	      var ReduxFormConnector = reduxFormConnector(WrappedComponent, mapStateToProps, mapDispatchToProps, mergeProps, options);
	
	      var _ref = options || {},
	          _ref$withRef = _ref.withRef,
	          withRef = _ref$withRef === undefined ? false : _ref$withRef;
	
	      var configWithDefaults = _extends({
	        overwriteOnInitialValuesChange: true,
	        touchOnBlur: true,
	        touchOnChange: false,
	        destroyOnUnmount: true
	      }, config);
	
	      var ConnectedForm = function (_Component) {
	        _inherits(ConnectedForm, _Component);
	
	        function ConnectedForm(props) {
	          _classCallCheck(this, ConnectedForm);
	
	          var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	          _this.handleSubmitPassback = _this.handleSubmitPassback.bind(_this);
	          return _this;
	        }
	
	        ConnectedForm.prototype.getWrappedInstance = function getWrappedInstance() {
	          (0, _invariant2.default)(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	          return this.refs.wrappedInstance.refs.wrappedInstance.getWrappedInstance().refs.wrappedInstance;
	        };
	
	        ConnectedForm.prototype.handleSubmitPassback = function handleSubmitPassback(submit) {
	          this.submit = submit;
	        };
	
	        ConnectedForm.prototype.render = function render() {
	          if (withRef) {
	            return React.createElement(ReduxFormConnector, _extends({}, configWithDefaults, this.props, {
	              ref: 'wrappedInstance',
	              submitPassback: this.handleSubmitPassback }));
	          }
	          return React.createElement(ReduxFormConnector, _extends({}, configWithDefaults, this.props, {
	            submitPassback: this.handleSubmitPassback }));
	        };
	
	        return ConnectedForm;
	      }(Component);
	
	      return (0, _hoistNonReactStatics2.default)(ConnectedForm, WrappedComponent);
	    };
	  };
	};
	
	exports.default = createReduxForm;

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _noGetters = __webpack_require__(1538);
	
	var _noGetters2 = _interopRequireDefault(_noGetters);
	
	var _getDisplayName = __webpack_require__(653);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	var _createHigherOrderComponent = __webpack_require__(1622);
	
	var _createHigherOrderComponent2 = _interopRequireDefault(_createHigherOrderComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This component tracks props that affect how the form is mounted to the store. Normally these should not change,
	 * but if they do, the connected components below it need to be redefined.
	 */
	var createReduxFormConnector = function createReduxFormConnector(isReactNative, React, connect) {
	  return function (WrappedComponent, mapStateToProps, mapDispatchToProps, mergeProps, options) {
	    var Component = React.Component;
	
	    var _ref = options || {},
	        _ref$withRef = _ref.withRef,
	        withRef = _ref$withRef === undefined ? false : _ref$withRef;
	
	    var ReduxFormConnector = function (_Component) {
	      _inherits(ReduxFormConnector, _Component);
	
	      function ReduxFormConnector(props) {
	        _classCallCheck(this, ReduxFormConnector);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.cache = new _noGetters2.default(_this, {
	          ReduxForm: {
	            params: [
	            // props that effect how redux-form connects to the redux store
	            'reduxMountPoint', 'form', 'formKey', 'getFormState'],
	            fn: (0, _createHigherOrderComponent2.default)(props, isReactNative, React, connect, WrappedComponent, mapStateToProps, mapDispatchToProps, mergeProps, options)
	          }
	        });
	        return _this;
	      }
	
	      ReduxFormConnector.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.cache.componentWillReceiveProps(nextProps);
	      };
	
	      ReduxFormConnector.prototype.render = function render() {
	        var ReduxForm = this.cache.get('ReduxForm');
	        // remove some redux-form config-only props
	
	        var _props = this.props,
	            reduxMountPoint = _props.reduxMountPoint,
	            destroyOnUnmount = _props.destroyOnUnmount,
	            form = _props.form,
	            getFormState = _props.getFormState,
	            touchOnBlur = _props.touchOnBlur,
	            touchOnChange = _props.touchOnChange,
	            passableProps = _objectWithoutProperties(_props, ['reduxMountPoint', 'destroyOnUnmount', 'form', 'getFormState', 'touchOnBlur', 'touchOnChange']); // eslint-disable-line no-redeclare
	
	
	        if (withRef) {
	          return React.createElement(ReduxForm, _extends({}, passableProps, { ref: 'wrappedInstance' }));
	        }
	        return React.createElement(ReduxForm, passableProps);
	      };
	
	      return ReduxFormConnector;
	    }(Component);
	
	    ReduxFormConnector.displayName = 'ReduxFormConnector(' + (0, _getDisplayName2.default)(WrappedComponent) + ')';
	    ReduxFormConnector.WrappedComponent = WrappedComponent;
	    ReduxFormConnector.propTypes = {
	      destroyOnUnmount: _propTypes2.default.bool,
	      reduxMountPoint: _propTypes2.default.string,
	      form: _propTypes2.default.string.isRequired,
	      formKey: _propTypes2.default.string,
	      getFormState: _propTypes2.default.func,
	      touchOnBlur: _propTypes2.default.bool,
	      touchOnChange: _propTypes2.default.bool
	    };
	    ReduxFormConnector.defaultProps = {
	      reduxMountPoint: 'form',
	      getFormState: function getFormState(state, reduxMountPoint) {
	        return state[reduxMountPoint];
	      }
	    };
	    return ReduxFormConnector;
	  };
	};
	
	exports.default = createReduxFormConnector;

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _getValue = __webpack_require__(650);
	
	var _getValue2 = _interopRequireDefault(_getValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createOnBlur = function createOnBlur(name, blur, isReactNative, afterBlur) {
	  return function (event) {
	    var value = (0, _getValue2.default)(event, isReactNative);
	    blur(name, value);
	    if (afterBlur) {
	      afterBlur(name, value);
	    }
	  };
	};
	exports.default = createOnBlur;

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _getValue = __webpack_require__(650);
	
	var _getValue2 = _interopRequireDefault(_getValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createOnChange = function createOnChange(name, change, isReactNative) {
	  return function (event) {
	    return change(name, (0, _getValue2.default)(event, isReactNative));
	  };
	};
	exports.default = createOnChange;

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createOnDragStart = __webpack_require__(649);
	
	var createOnDrop = function createOnDrop(name, change) {
	  return function (event) {
	    change(name, event.dataTransfer.getData(_createOnDragStart.dataKey));
	  };
	};
	exports.default = createOnDrop;

/***/ }),
/* 1629 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var createOnFocus = function createOnFocus(name, focus) {
	  return function () {
	    return focus(name);
	  };
	};
	exports.default = createOnFocus;

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _silenceEvent = __webpack_require__(652);
	
	var _silenceEvent2 = _interopRequireDefault(_silenceEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var silenceEvents = function silenceEvents(fn) {
	  return function (event) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return (0, _silenceEvent2.default)(event) ? fn.apply(undefined, args) : fn.apply(undefined, [event].concat(args));
	  };
	};
	
	exports.default = silenceEvents;

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isPromise = __webpack_require__(373);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	var _isValid = __webpack_require__(288);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var handleSubmit = function handleSubmit(submit, values, props, asyncValidate) {
	  var dispatch = props.dispatch,
	      fields = props.fields,
	      onSubmitSuccess = props.onSubmitSuccess,
	      onSubmitFail = props.onSubmitFail,
	      startSubmit = props.startSubmit,
	      stopSubmit = props.stopSubmit,
	      submitFailed = props.submitFailed,
	      returnRejectedSubmitPromise = props.returnRejectedSubmitPromise,
	      touch = props.touch,
	      validate = props.validate;
	
	  var syncErrors = validate(values, props);
	  touch.apply(undefined, fields); // touch all fields
	  if ((0, _isValid2.default)(syncErrors)) {
	    var doSubmit = function doSubmit() {
	      var result = submit(values, dispatch, props);
	      if ((0, _isPromise2.default)(result)) {
	        startSubmit();
	        return result.then(function (submitResult) {
	          stopSubmit();
	          if (onSubmitSuccess) {
	            onSubmitSuccess(submitResult);
	          }
	          return submitResult;
	        }, function (submitError) {
	          stopSubmit(submitError);
	          if (onSubmitFail) {
	            onSubmitFail(submitError);
	          }
	          if (returnRejectedSubmitPromise) {
	            return Promise.reject(submitError);
	          }
	        });
	      }
	      if (onSubmitSuccess) {
	        onSubmitSuccess(result);
	      }
	      return result;
	    };
	    var asyncValidateResult = asyncValidate();
	    return (0, _isPromise2.default)(asyncValidateResult) ?
	    // asyncValidateResult will be rejected if async validation failed
	    asyncValidateResult.then(doSubmit, function () {
	      submitFailed();
	      if (onSubmitFail) {
	        onSubmitFail();
	      }
	      return returnRejectedSubmitPromise ? Promise.reject() : Promise.resolve();
	    }) : doSubmit(); // no async validation, so submit
	  }
	  submitFailed();
	
	  if (onSubmitFail) {
	    onSubmitFail(syncErrors);
	  }
	
	  if (returnRejectedSubmitPromise) {
	    return Promise.reject(syncErrors);
	  }
	};
	
	exports.default = handleSubmit;

/***/ }),
/* 1632 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isPristine;
	function isPristine(initial, data) {
	  if (initial === data) {
	    return true;
	  }
	  if (typeof initial === 'boolean' || typeof data === 'boolean') {
	    return initial === data;
	  } else if (initial instanceof Date && data instanceof Date) {
	    return initial.getTime() === data.getTime();
	  } else if (initial && typeof initial === 'object') {
	    if (!data || typeof data !== 'object') {
	      return false;
	    }
	    var initialKeys = Object.keys(initial);
	    var dataKeys = Object.keys(data);
	    if (initialKeys.length !== dataKeys.length) {
	      return false;
	    }
	    for (var index = 0; index < dataKeys.length; index++) {
	      var key = dataKeys[index];
	      if (!isPristine(initial[key], data[key])) {
	        return false;
	      }
	    }
	  } else if (initial || data) {
	    // allow '' to equate to undefined or null
	    return initial === data;
	  } else if (initial === null && data === 0 || initial === 0 && data === null) {
	    return false;
	  }
	  return true;
	}

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = normalizeFields;
	
	var _fieldValue = __webpack_require__(194);
	
	function extractKey(field) {
	  var dotIndex = field.indexOf('.');
	  var openIndex = field.indexOf('[');
	  var closeIndex = field.indexOf(']');
	
	  if (openIndex > 0 && closeIndex !== openIndex + 1) {
	    throw new Error('found [ not followed by ]');
	  }
	
	  var isArray = openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex);
	  var key = void 0;
	  var nestedPath = void 0;
	
	  if (isArray) {
	    key = field.substring(0, openIndex);
	    nestedPath = field.substring(closeIndex + 1);
	
	    if (nestedPath[0] === '.') {
	      nestedPath = nestedPath.substring(1);
	    }
	  } else if (dotIndex > 0) {
	    key = field.substring(0, dotIndex);
	    nestedPath = field.substring(dotIndex + 1);
	  } else {
	    key = field;
	  }
	
	  return { isArray: isArray, key: key, nestedPath: nestedPath };
	}
	
	function normalizeField(field, fullFieldPath, state, previousState, values, previousValues, normalizers) {
	  if (field.isArray) {
	    if (field.nestedPath) {
	      var array = state && state[field.key] || [];
	      var previousArray = previousState && previousState[field.key] || [];
	      var nestedField = extractKey(field.nestedPath);
	
	      return array.map(function (nestedState, i) {
	        nestedState[nestedField.key] = normalizeField(nestedField, fullFieldPath, nestedState, previousArray[i], values, previousValues, normalizers);
	
	        return nestedState;
	      });
	    }
	
	    var _normalizer = normalizers[fullFieldPath];
	
	    var result = _normalizer(state && state[field.key], previousState && previousState[field.key], values, previousValues);
	    return field.isArray ? result && result.map(_fieldValue.makeFieldValue) : result;
	  } else if (field.nestedPath) {
	    var nestedState = state && state[field.key] || {};
	    var _nestedField = extractKey(field.nestedPath);
	
	    nestedState[_nestedField.key] = normalizeField(_nestedField, fullFieldPath, nestedState, previousState && previousState[field.key], values, previousValues, normalizers);
	
	    return nestedState;
	  }
	
	  var finalField = state && Object.assign({}, state[field.key] || {});
	  var normalizer = normalizers[fullFieldPath];
	
	  finalField.value = normalizer(finalField.value, previousState && previousState[field.key] && previousState[field.key].value, values, previousValues);
	
	  return (0, _fieldValue.makeFieldValue)(finalField);
	}
	
	function normalizeFields(normalizers, state, previousState, values, previousValues) {
	  var newState = Object.keys(normalizers).reduce(function (accumulator, field) {
	    var extracted = extractKey(field);
	
	    accumulator[extracted.key] = normalizeField(extracted, field, state, previousState, values, previousValues, normalizers);
	
	    return accumulator;
	  }, {});
	
	  return _extends({}, state, newState);
	}

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createOnBlur = __webpack_require__(1626);
	
	var _createOnBlur2 = _interopRequireDefault(_createOnBlur);
	
	var _createOnChange = __webpack_require__(1627);
	
	var _createOnChange2 = _interopRequireDefault(_createOnChange);
	
	var _createOnDragStart = __webpack_require__(649);
	
	var _createOnDragStart2 = _interopRequireDefault(_createOnDragStart);
	
	var _createOnDrop = __webpack_require__(1628);
	
	var _createOnDrop2 = _interopRequireDefault(_createOnDrop);
	
	var _createOnFocus = __webpack_require__(1629);
	
	var _createOnFocus2 = _interopRequireDefault(_createOnFocus);
	
	var _silencePromise = __webpack_require__(1639);
	
	var _silencePromise2 = _interopRequireDefault(_silencePromise);
	
	var _read = __webpack_require__(658);
	
	var _read2 = _interopRequireDefault(_read);
	
	var _updateField = __webpack_require__(1640);
	
	var _updateField2 = _interopRequireDefault(_updateField);
	
	var _isChecked = __webpack_require__(657);
	
	var _isChecked2 = _interopRequireDefault(_isChecked);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getSuffix(input, closeIndex) {
	  var suffix = input.substring(closeIndex + 1);
	  if (suffix[0] === '.') {
	    suffix = suffix.substring(1);
	  }
	  return suffix;
	}
	
	var getNextKey = function getNextKey(path) {
	  var dotIndex = path.indexOf('.');
	  var openIndex = path.indexOf('[');
	  if (openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    return path.substring(0, openIndex);
	  }
	  return dotIndex > 0 ? path.substring(0, dotIndex) : path;
	};
	
	var shouldAsyncValidate = function shouldAsyncValidate(name, asyncBlurFields) {
	  return (
	    // remove array indices
	    ~asyncBlurFields.indexOf(name.replace(/\[[0-9]+\]/g, '[]'))
	  );
	};
	
	var readField = function readField(state, fieldName) {
	  var pathToHere = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	  var fields = arguments[3];
	  var syncErrors = arguments[4];
	  var asyncValidate = arguments[5];
	  var isReactNative = arguments[6];
	  var props = arguments[7];
	  var callback = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : function () {
	    return null;
	  };
	  var prefix = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : '';
	  var asyncBlurFields = props.asyncBlurFields,
	      autofill = props.autofill,
	      blur = props.blur,
	      change = props.change,
	      focus = props.focus,
	      form = props.form,
	      initialValues = props.initialValues,
	      readonly = props.readonly,
	      addArrayValue = props.addArrayValue,
	      removeArrayValue = props.removeArrayValue,
	      swapArrayValues = props.swapArrayValues;
	
	  var dotIndex = fieldName.indexOf('.');
	  var openIndex = fieldName.indexOf('[');
	  var closeIndex = fieldName.indexOf(']');
	  if (openIndex > 0 && closeIndex !== openIndex + 1) {
	    throw new Error('found [ not followed by ]');
	  }
	
	  if (openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    // array field
	    var key = fieldName.substring(0, openIndex);
	    var rest = getSuffix(fieldName, closeIndex);
	    var stateArray = state && state[key] || [];
	    var fullPrefix = prefix + fieldName.substring(0, closeIndex + 1);
	    var subfields = props.fields.reduce(function (accumulator, field) {
	      if (field.indexOf(fullPrefix) === 0) {
	        accumulator.push(field);
	      }
	      return accumulator;
	    }, []).map(function (field) {
	      return getSuffix(field, prefix.length + closeIndex);
	    });
	    var addMethods = function addMethods(dest) {
	      Object.defineProperty(dest, 'addField', {
	        value: function value(_value, index) {
	          return addArrayValue(pathToHere + key, _value, index, subfields);
	        }
	      });
	      Object.defineProperty(dest, 'removeField', {
	        value: function value(index) {
	          return removeArrayValue(pathToHere + key, index);
	        }
	      });
	      Object.defineProperty(dest, 'swapFields', {
	        value: function value(indexA, indexB) {
	          return swapArrayValues(pathToHere + key, indexA, indexB);
	        }
	      });
	      return dest;
	    };
	    if (!fields[key] || fields[key].length !== stateArray.length) {
	      fields[key] = fields[key] ? [].concat(fields[key]) : [];
	      addMethods(fields[key]);
	    }
	    var fieldArray = fields[key];
	    var changed = false;
	    stateArray.forEach(function (fieldState, index) {
	      if (rest && !fieldArray[index]) {
	        fieldArray[index] = {};
	        changed = true;
	      }
	      var dest = rest ? fieldArray[index] : {};
	      var nextPath = '' + pathToHere + key + '[' + index + ']' + (rest ? '.' : '');
	      var nextPrefix = '' + prefix + key + '[]' + (rest ? '.' : '');
	
	      var result = readField(fieldState, rest, nextPath, dest, syncErrors, asyncValidate, isReactNative, props, callback, nextPrefix);
	      if (fieldArray[index] !== result) {
	        if (rest) {
	          // if something's after [] in field name, the array item is an object field
	          // we need it to compare !== to the original (so react re-renders appropriately)
	          result = _extends({}, dest);
	        }
	        fieldArray[index] = result;
	        changed = true;
	      }
	    });
	    if (fieldArray.length > stateArray.length) {
	      // remove extra items that aren't in state array
	      fieldArray.splice(stateArray.length, fieldArray.length - stateArray.length);
	    }
	    if (changed) {
	      fieldArray = addMethods([].concat(fieldArray));
	    }
	    fields[key] = fieldArray;
	    return fieldArray;
	  }
	  if (dotIndex > 0) {
	    // subobject field
	    var _key = fieldName.substring(0, dotIndex);
	    var _rest = fieldName.substring(dotIndex + 1);
	    var subobject = fields[_key] || {};
	    var nextPath = pathToHere + _key + '.';
	    var nextKey = getNextKey(_rest);
	    var nextPrefix = prefix + _key + '.';
	    var previous = subobject[nextKey];
	    var result = readField(state[_key] || {}, _rest, nextPath, subobject, syncErrors, asyncValidate, isReactNative, props, callback, nextPrefix);
	    if (result !== previous) {
	      var _extends2;
	
	      subobject = _extends({}, subobject, (_extends2 = {}, _extends2[nextKey] = result, _extends2));
	    }
	    fields[_key] = subobject;
	    return subobject;
	  }
	  var name = pathToHere + fieldName;
	  var field = fields[fieldName] || {};
	  if (field.name !== name) {
	    var onChange = (0, _createOnChange2.default)(name, change, isReactNative);
	    var initialFormValue = (0, _read2.default)(name + '.initial', form);
	    var initialValue = initialFormValue || (0, _read2.default)(name, initialValues);
	    initialValue = initialValue === undefined ? '' : initialValue;
	    field.name = name;
	    field.checked = (0, _isChecked2.default)(initialValue);
	    field.value = initialValue;
	    field.initialValue = initialValue;
	    if (!readonly) {
	      field.autofill = function (value) {
	        return autofill(name, value);
	      };
	      field.onBlur = (0, _createOnBlur2.default)(name, blur, isReactNative, shouldAsyncValidate(name, asyncBlurFields) && function (blurName, blurValue) {
	        return (0, _silencePromise2.default)(asyncValidate(blurName, blurValue));
	      });
	      field.onChange = onChange;
	      field.onDragStart = (0, _createOnDragStart2.default)(name, function () {
	        return field.value;
	      });
	      field.onDrop = (0, _createOnDrop2.default)(name, change);
	      field.onFocus = (0, _createOnFocus2.default)(name, focus);
	      field.onUpdate = onChange; // alias to support belle. https://github.com/nikgraf/belle/issues/58
	    }
	    field.valid = true;
	    field.invalid = false;
	    Object.defineProperty(field, '_isField', { value: true });
	  }
	
	  var fieldState = (fieldName ? state[fieldName] : state) || {};
	  var syncError = (0, _read2.default)(name, syncErrors);
	  var updated = (0, _updateField2.default)(field, fieldState, name === form._active, syncError);
	  if (fieldName || fields[fieldName] !== updated) {
	    fields[fieldName] = updated;
	  }
	  callback(updated);
	  return updated;
	};
	
	exports.default = readField;

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _readField = __webpack_require__(1634);
	
	var _readField2 = _interopRequireDefault(_readField);
	
	var _write = __webpack_require__(659);
	
	var _write2 = _interopRequireDefault(_write);
	
	var _getValues = __webpack_require__(654);
	
	var _getValues2 = _interopRequireDefault(_getValues);
	
	var _removeField = __webpack_require__(1636);
	
	var _removeField2 = _interopRequireDefault(_removeField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Reads props and generates (or updates) field structure
	 */
	var readFields = function readFields(props, previousProps, myFields, asyncValidate, isReactNative) {
	  var fields = props.fields,
	      form = props.form,
	      validate = props.validate;
	
	  var previousFields = previousProps.fields;
	  var values = (0, _getValues2.default)(fields, form);
	  var syncErrors = validate(values, props) || {};
	  var errors = {};
	  var formError = syncErrors._error || form._error;
	  var allValid = !formError;
	  var allPristine = true;
	  var tally = function tally(field) {
	    if (field.error) {
	      errors = (0, _write2.default)(field.name, field.error, errors);
	      allValid = false;
	    }
	    if (field.dirty) {
	      allPristine = false;
	    }
	  };
	  var fieldObjects = previousFields ? previousFields.reduce(function (accumulator, previousField) {
	    return ~fields.indexOf(previousField) ? accumulator : (0, _removeField2.default)(accumulator, previousField);
	  }, _extends({}, myFields)) : _extends({}, myFields);
	  fields.forEach(function (name) {
	    (0, _readField2.default)(form, name, undefined, fieldObjects, syncErrors, asyncValidate, isReactNative, props, tally);
	  });
	  Object.defineProperty(fieldObjects, '_meta', {
	    value: {
	      allPristine: allPristine,
	      allValid: allValid,
	      values: values,
	      errors: errors,
	      formError: formError
	    }
	  });
	  return fieldObjects;
	};
	exports.default = readFields;

/***/ }),
/* 1636 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var without = function without(object, key) {
	  var copy = _extends({}, object);
	  delete copy[key];
	  return copy;
	};
	
	var removeField = function removeField(fields, path) {
	  var dotIndex = path.indexOf('.');
	  var openIndex = path.indexOf('[');
	  var closeIndex = path.indexOf(']');
	  if (openIndex > 0 && closeIndex !== openIndex + 1) {
	    throw new Error('found [ not followed by ]');
	  }
	  if (openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    // array field
	    var key = path.substring(0, openIndex);
	    if (!Array.isArray(fields[key])) {
	      return without(fields, key);
	    }
	    var rest = path.substring(closeIndex + 1);
	    if (rest[0] === '.') {
	      rest = rest.substring(1);
	    }
	    if (rest) {
	      var _extends2;
	
	      var copy = [];
	      fields[key].forEach(function (item, index) {
	        var result = removeField(item, rest);
	        if (Object.keys(result).length) {
	          copy[index] = result;
	        }
	      });
	      return copy.length ? _extends({}, fields, (_extends2 = {}, _extends2[key] = copy, _extends2)) : without(fields, key);
	    }
	    return without(fields, key);
	  }
	  if (dotIndex > 0) {
	    var _extends3;
	
	    // subobject field
	    var _key = path.substring(0, dotIndex);
	    var _rest = path.substring(dotIndex + 1);
	    if (!fields[_key]) {
	      return fields;
	    }
	    var result = removeField(fields[_key], _rest);
	    return Object.keys(result).length ? _extends({}, fields, (_extends3 = {}, _extends3[_key] = removeField(fields[_key], _rest), _extends3)) : without(fields, _key);
	  }
	  return without(fields, path);
	};
	
	exports.default = removeField;

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _fieldValue = __webpack_require__(194);
	
	var reset = function reset(value) {
	  return (0, _fieldValue.makeFieldValue)(value === undefined || value && value.initial === undefined ? {} : { initial: value.initial, value: value.initial });
	};
	
	/**
	 * Sets the initial values into the state and returns a new copy of the state
	 */
	var resetState = function resetState(values) {
	  return values ? Object.keys(values).reduce(function (accumulator, key) {
	    var value = values[key];
	    if (Array.isArray(value)) {
	      accumulator[key] = value.map(function (item) {
	        return (0, _fieldValue.isFieldValue)(item) ? reset(item) : resetState(item);
	      });
	    } else if (value) {
	      if ((0, _fieldValue.isFieldValue)(value)) {
	        accumulator[key] = reset(value);
	      } else if (typeof value === 'object' && value !== null) {
	        accumulator[key] = resetState(value);
	      } else {
	        accumulator[key] = value;
	      }
	    }
	    return accumulator;
	  }, {}) : values;
	};
	
	exports.default = resetState;

/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _fieldValue = __webpack_require__(194);
	
	var isMetaKey = function isMetaKey(key) {
	  return key[0] === '_';
	};
	
	/**
	 * Sets an error on a field deep in the tree, returning a new copy of the state
	 */
	var setErrors = function setErrors(state, errors, destKey) {
	  var clear = function clear() {
	    if (Array.isArray(state)) {
	      return state.map(function (stateItem, index) {
	        return setErrors(stateItem, errors && errors[index], destKey);
	      });
	    }
	    if (state && typeof state === 'object') {
	      var result = Object.keys(state).reduce(function (accumulator, key) {
	        var _extends2;
	
	        return isMetaKey(key) ? accumulator : _extends({}, accumulator, (_extends2 = {}, _extends2[key] = setErrors(state[key], errors && errors[key], destKey), _extends2));
	      }, state);
	      if ((0, _fieldValue.isFieldValue)(state)) {
	        (0, _fieldValue.makeFieldValue)(result);
	      }
	      return result;
	    }
	    return (0, _fieldValue.makeFieldValue)(state);
	  };
	  if (typeof File !== 'undefined' && state instanceof File) {
	    return state;
	  }
	  if (!errors) {
	    if (!state) {
	      return state;
	    }
	    if (state[destKey]) {
	      var copy = _extends({}, state);
	      delete copy[destKey];
	      return (0, _fieldValue.makeFieldValue)(copy);
	    }
	    return clear();
	  }
	  if (typeof errors === 'string') {
	    var _extends3;
	
	    return (0, _fieldValue.makeFieldValue)(_extends({}, state, (_extends3 = {}, _extends3[destKey] = errors, _extends3)));
	  }
	  if (Array.isArray(errors)) {
	    if (!state || Array.isArray(state)) {
	      var _copy = (state || []).map(function (stateItem, index) {
	        return setErrors(stateItem, errors[index], destKey);
	      });
	      errors.forEach(function (errorItem, index) {
	        return _copy[index] = setErrors(_copy[index], errorItem, destKey);
	      });
	      return _copy;
	    }
	    return setErrors(state, errors[0], destKey); // use first error
	  }
	  if ((0, _fieldValue.isFieldValue)(state)) {
	    var _extends4;
	
	    return (0, _fieldValue.makeFieldValue)(_extends({}, state, (_extends4 = {}, _extends4[destKey] = errors, _extends4)));
	  }
	  var errorKeys = Object.keys(errors);
	  if (!errorKeys.length && !state) {
	    return state;
	  }
	  return errorKeys.reduce(function (accumulator, key) {
	    var _extends5;
	
	    return isMetaKey(key) ? accumulator : _extends({}, accumulator, (_extends5 = {}, _extends5[key] = setErrors(state && state[key], errors[key], destKey), _extends5));
	  }, clear() || {});
	};
	
	exports.default = setErrors;

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isPromise = __webpack_require__(373);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var noop = function noop() {
	  return undefined;
	};
	
	var silencePromise = function silencePromise(promise) {
	  return (0, _isPromise2.default)(promise) ? promise.then(noop, noop) : promise;
	};
	
	exports.default = silencePromise;

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _isPristine = __webpack_require__(1632);
	
	var _isPristine2 = _interopRequireDefault(_isPristine);
	
	var _isValid = __webpack_require__(288);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	var _isChecked = __webpack_require__(657);
	
	var _isChecked2 = _interopRequireDefault(_isChecked);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Updates a field object from the store values
	 */
	var updateField = function updateField(field, formField, active, syncError) {
	  var diff = {};
	  var formFieldValue = formField.value === undefined ? '' : formField.value;
	
	  // update field value
	  if (field.value !== formFieldValue) {
	    diff.value = formFieldValue;
	    diff.checked = (0, _isChecked2.default)(formFieldValue);
	  }
	
	  // update dirty/pristine
	  var pristine = (0, _isPristine2.default)(formFieldValue, formField.initial);
	  if (field.pristine !== pristine) {
	    diff.dirty = !pristine;
	    diff.pristine = pristine;
	  }
	
	  // update field error
	  var error = syncError || formField.submitError || formField.asyncError;
	  if (error !== field.error) {
	    diff.error = error;
	  }
	  var valid = (0, _isValid2.default)(error);
	  if (field.valid !== valid) {
	    diff.invalid = !valid;
	    diff.valid = valid;
	  }
	
	  if (active !== field.active) {
	    diff.active = active;
	  }
	  var touched = !!formField.touched;
	  if (touched !== field.touched) {
	    diff.touched = touched;
	  }
	  var visited = !!formField.visited;
	  if (visited !== field.visited) {
	    diff.visited = visited;
	  }
	  var autofilled = !!formField.autofilled;
	  if (autofilled !== field.autofilled) {
	    diff.autofilled = autofilled;
	  }
	
	  if ('initial' in formField && formField.initial !== field.initialValue) {
	    field.initialValue = formField.initial;
	  }
	
	  return Object.keys(diff).length ? _extends({}, field, diff) : field;
	};
	exports.default = updateField;

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _redux = __webpack_require__(195);
	
	var wrapMapDispatchToProps = function wrapMapDispatchToProps(mapDispatchToProps, actionCreators) {
	  if (mapDispatchToProps) {
	    if (typeof mapDispatchToProps === 'function') {
	      if (mapDispatchToProps.length > 1) {
	        return function (dispatch, ownProps) {
	          return _extends({
	            dispatch: dispatch
	          }, mapDispatchToProps(dispatch, ownProps), (0, _redux.bindActionCreators)(actionCreators, dispatch));
	        };
	      }
	      return function (dispatch) {
	        return _extends({
	          dispatch: dispatch
	        }, mapDispatchToProps(dispatch), (0, _redux.bindActionCreators)(actionCreators, dispatch));
	      };
	    }
	    return function (dispatch) {
	      return _extends({
	        dispatch: dispatch
	      }, (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch), (0, _redux.bindActionCreators)(actionCreators, dispatch));
	    };
	  }
	  return function (dispatch) {
	    return _extends({
	      dispatch: dispatch
	    }, (0, _redux.bindActionCreators)(actionCreators, dispatch));
	  };
	};
	
	exports.default = wrapMapDispatchToProps;

/***/ }),
/* 1642 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var wrapMapStateToProps = function wrapMapStateToProps(mapStateToProps, getForm) {
	  if (mapStateToProps) {
	    if (typeof mapStateToProps !== 'function') {
	      throw new Error('mapStateToProps must be a function');
	    }
	    if (mapStateToProps.length > 1) {
	      return function (state, ownProps) {
	        return _extends({}, mapStateToProps(state, ownProps), {
	          form: getForm(state)
	        });
	      };
	    }
	    return function (state) {
	      return _extends({}, mapStateToProps(state), {
	        form: getForm(state)
	      });
	    };
	  }
	  return function (state) {
	    return {
	      form: getForm(state)
	    };
	  };
	};
	
	exports.default = wrapMapStateToProps;

/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(8);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _utilities = __webpack_require__(1645);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (reducers) {
	  var getDefaultState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _immutable2.default.Map;
	
	  var reducerKeys = Object.keys(reducers);
	
	  // eslint-disable-next-line space-infix-ops
	  return function () {
	    var inputState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getDefaultState();
	    var action = arguments[1];
	
	    // eslint-disable-next-line no-process-env
	    if (false) {
	      var warningMessage = (0, _utilities.getUnexpectedInvocationParameterMessage)(inputState, reducers, action);
	
	      if (warningMessage) {
	        // eslint-disable-next-line no-console
	        console.error(warningMessage);
	      }
	    }
	
	    return inputState.withMutations(function (temporaryState) {
	      reducerKeys.forEach(function (reducerName) {
	        var reducer = reducers[reducerName];
	        var currentDomainState = temporaryState.get(reducerName);
	        var nextDomainState = reducer(currentDomainState, action);
	
	        (0, _utilities.validateNextState)(nextDomainState, reducerName, action);
	
	        temporaryState.set(reducerName, nextDomainState);
	      });
	    });
	  };
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=combineReducers.js.map

/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(8);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _getStateName = __webpack_require__(660);
	
	var _getStateName2 = _interopRequireDefault(_getStateName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (state, reducers, action) {
	  var reducerNames = Object.keys(reducers);
	
	  if (!reducerNames.length) {
	    return 'Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.';
	  }
	
	  var stateName = (0, _getStateName2.default)(action);
	
	  if (!_immutable2.default.Iterable.isIterable(state)) {
	    return 'The ' + stateName + ' is of unexpected type. Expected argument to be an instance of Immutable.Iterable with the following properties: "' + reducerNames.join('", "') + '".';
	  }
	
	  var unexpectedStatePropertyNames = state.keySeq().toArray().filter(function (name) {
	    return !reducers.hasOwnProperty(name);
	  });
	
	  if (unexpectedStatePropertyNames.length > 0) {
	    return 'Unexpected ' + (unexpectedStatePropertyNames.length === 1 ? 'property' : 'properties') + ' "' + unexpectedStatePropertyNames.join('", "') + '" found in ' + stateName + '. Expected to find one of the known reducer property names instead: "' + reducerNames.join('", "') + '". Unexpected properties will be ignored.';
	  }
	
	  return null;
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=getUnexpectedInvocationParameterMessage.js.map

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.validateNextState = exports.getUnexpectedInvocationParameterMessage = exports.getStateName = undefined;
	
	var _getStateName2 = __webpack_require__(660);
	
	var _getStateName3 = _interopRequireDefault(_getStateName2);
	
	var _getUnexpectedInvocationParameterMessage2 = __webpack_require__(1644);
	
	var _getUnexpectedInvocationParameterMessage3 = _interopRequireDefault(_getUnexpectedInvocationParameterMessage2);
	
	var _validateNextState2 = __webpack_require__(1646);
	
	var _validateNextState3 = _interopRequireDefault(_validateNextState2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.getStateName = _getStateName3.default;
	exports.getUnexpectedInvocationParameterMessage = _getUnexpectedInvocationParameterMessage3.default;
	exports.validateNextState = _validateNextState3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1646 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (nextState, reducerName, action) {
	  // eslint-disable-next-line no-undefined
	  if (nextState === undefined) {
	    throw new Error('Reducer "' + reducerName + '" returned undefined when handling "' + action.type + '" action. To ignore an action, you must explicitly return the previous state.');
	  }
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=validateNextState.js.map

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.printBuffer = printBuffer;
	
	var _helpers = __webpack_require__(661);
	
	var _diff = __webpack_require__(1649);
	
	var _diff2 = _interopRequireDefault(_diff);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * Get log level string based on supplied params
	 *
	 * @param {string | function | object} level - console[level]
	 * @param {object} action - selected action
	 * @param {array} payload - selected payload
	 * @param {string} type - log entry type
	 *
	 * @returns {string} level
	 */
	function getLogLevel(level, action, payload, type) {
	  switch (typeof level === 'undefined' ? 'undefined' : _typeof(level)) {
	    case 'object':
	      return typeof level[type] === 'function' ? level[type].apply(level, _toConsumableArray(payload)) : level[type];
	    case 'function':
	      return level(action);
	    default:
	      return level;
	  }
	}
	
	function defaultTitleFormatter(options) {
	  var timestamp = options.timestamp,
	      duration = options.duration;
	
	
	  return function (action, time, took) {
	    var parts = ['action'];
	
	    parts.push('%c' + String(action.type));
	    if (timestamp) parts.push('%c@ ' + time);
	    if (duration) parts.push('%c(in ' + took.toFixed(2) + ' ms)');
	
	    return parts.join(' ');
	  };
	}
	
	function printBuffer(buffer, options) {
	  var logger = options.logger,
	      actionTransformer = options.actionTransformer,
	      _options$titleFormatt = options.titleFormatter,
	      titleFormatter = _options$titleFormatt === undefined ? defaultTitleFormatter(options) : _options$titleFormatt,
	      collapsed = options.collapsed,
	      colors = options.colors,
	      level = options.level,
	      diff = options.diff;
	
	
	  var isUsingDefaultFormatter = typeof options.titleFormatter === 'undefined';
	
	  buffer.forEach(function (logEntry, key) {
	    var started = logEntry.started,
	        startedTime = logEntry.startedTime,
	        action = logEntry.action,
	        prevState = logEntry.prevState,
	        error = logEntry.error;
	    var took = logEntry.took,
	        nextState = logEntry.nextState;
	
	    var nextEntry = buffer[key + 1];
	
	    if (nextEntry) {
	      nextState = nextEntry.prevState;
	      took = nextEntry.started - started;
	    }
	
	    // Message
	    var formattedAction = actionTransformer(action);
	    var isCollapsed = typeof collapsed === 'function' ? collapsed(function () {
	      return nextState;
	    }, action, logEntry) : collapsed;
	
	    var formattedTime = (0, _helpers.formatTime)(startedTime);
	    var titleCSS = colors.title ? 'color: ' + colors.title(formattedAction) + ';' : '';
	    var headerCSS = ['color: gray; font-weight: lighter;'];
	    headerCSS.push(titleCSS);
	    if (options.timestamp) headerCSS.push('color: gray; font-weight: lighter;');
	    if (options.duration) headerCSS.push('color: gray; font-weight: lighter;');
	    var title = titleFormatter(formattedAction, formattedTime, took);
	
	    // Render
	    try {
	      if (isCollapsed) {
	        if (colors.title && isUsingDefaultFormatter) logger.groupCollapsed.apply(logger, ['%c ' + title].concat(headerCSS));else logger.groupCollapsed(title);
	      } else {
	        if (colors.title && isUsingDefaultFormatter) logger.group.apply(logger, ['%c ' + title].concat(headerCSS));else logger.group(title);
	      }
	    } catch (e) {
	      logger.log(title);
	    }
	
	    var prevStateLevel = getLogLevel(level, formattedAction, [prevState], 'prevState');
	    var actionLevel = getLogLevel(level, formattedAction, [formattedAction], 'action');
	    var errorLevel = getLogLevel(level, formattedAction, [error, prevState], 'error');
	    var nextStateLevel = getLogLevel(level, formattedAction, [nextState], 'nextState');
	
	    if (prevStateLevel) {
	      if (colors.prevState) logger[prevStateLevel]('%c prev state', 'color: ' + colors.prevState(prevState) + '; font-weight: bold', prevState);else logger[prevStateLevel]('prev state', prevState);
	    }
	
	    if (actionLevel) {
	      if (colors.action) logger[actionLevel]('%c action    ', 'color: ' + colors.action(formattedAction) + '; font-weight: bold', formattedAction);else logger[actionLevel]('action    ', formattedAction);
	    }
	
	    if (error && errorLevel) {
	      if (colors.error) logger[errorLevel]('%c error     ', 'color: ' + colors.error(error, prevState) + '; font-weight: bold;', error);else logger[errorLevel]('error     ', error);
	    }
	
	    if (nextStateLevel) {
	      if (colors.nextState) logger[nextStateLevel]('%c next state', 'color: ' + colors.nextState(nextState) + '; font-weight: bold', nextState);else logger[nextStateLevel]('next state', nextState);
	    }
	
	    if (diff) {
	      (0, _diff2.default)(prevState, nextState, logger, isCollapsed);
	    }
	
	    try {
	      logger.groupEnd();
	    } catch (e) {
	      logger.log('\u2014\u2014 log end \u2014\u2014');
	    }
	  });
	}

/***/ }),
/* 1648 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  level: "log",
	  logger: console,
	  logErrors: true,
	  collapsed: undefined,
	  predicate: undefined,
	  duration: false,
	  timestamp: true,
	  stateTransformer: function stateTransformer(state) {
	    return state;
	  },
	  actionTransformer: function actionTransformer(action) {
	    return action;
	  },
	  errorTransformer: function errorTransformer(error) {
	    return error;
	  },
	  colors: {
	    title: function title() {
	      return "inherit";
	    },
	    prevState: function prevState() {
	      return "#9E9E9E";
	    },
	    action: function action() {
	      return "#03A9F4";
	    },
	    nextState: function nextState() {
	      return "#4CAF50";
	    },
	    error: function error() {
	      return "#F20404";
	    }
	  },
	  diff: false,
	  diffPredicate: undefined,
	
	  // Deprecated options
	  transformer: undefined
	};
	module.exports = exports["default"];

/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = diffLogger;
	
	var _deepDiff = __webpack_require__(1014);
	
	var _deepDiff2 = _interopRequireDefault(_deepDiff);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// https://github.com/flitbit/diff#differences
	var dictionary = {
	  'E': {
	    color: '#2196F3',
	    text: 'CHANGED:'
	  },
	  'N': {
	    color: '#4CAF50',
	    text: 'ADDED:'
	  },
	  'D': {
	    color: '#F44336',
	    text: 'DELETED:'
	  },
	  'A': {
	    color: '#2196F3',
	    text: 'ARRAY:'
	  }
	};
	
	function style(kind) {
	  return 'color: ' + dictionary[kind].color + '; font-weight: bold';
	}
	
	function render(diff) {
	  var kind = diff.kind,
	      path = diff.path,
	      lhs = diff.lhs,
	      rhs = diff.rhs,
	      index = diff.index,
	      item = diff.item;
	
	
	  switch (kind) {
	    case 'E':
	      return [path.join('.'), lhs, '\u2192', rhs];
	    case 'N':
	      return [path.join('.'), rhs];
	    case 'D':
	      return [path.join('.')];
	    case 'A':
	      return [path.join('.') + '[' + index + ']', item];
	    default:
	      return [];
	  }
	}
	
	function diffLogger(prevState, newState, logger, isCollapsed) {
	  var diff = (0, _deepDiff2.default)(prevState, newState);
	
	  try {
	    if (isCollapsed) {
	      logger.groupCollapsed('diff');
	    } else {
	      logger.group('diff');
	    }
	  } catch (e) {
	    logger.log('diff');
	  }
	
	  if (diff) {
	    diff.forEach(function (elem) {
	      var kind = elem.kind;
	
	      var output = render(elem);
	
	      logger.log.apply(logger, ['%c ' + dictionary[kind].text, style(kind)].concat(_toConsumableArray(output)));
	    });
	  } else {
	    logger.log('\u2014\u2014 no diff \u2014\u2014');
	  }
	
	  try {
	    logger.groupEnd();
	  } catch (e) {
	    logger.log('\u2014\u2014 diff end \u2014\u2014 ');
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(663);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ }),
/* 1651 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(418);
	
	var _isPlainObject = __webpack_require__(118);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(664);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerSanity(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  if (false) {
	    var unexpectedKeyCache = {};
	  }
	
	  var sanityError;
	  try {
	    assertReducerSanity(finalReducers);
	  } catch (e) {
	    sanityError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	    var action = arguments[1];
	
	    if (sanityError) {
	      throw sanityError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var i = 0; i < finalReducerKeys.length; i++) {
	      var key = finalReducerKeys[i];
	      var reducer = finalReducers[key];
	      var previousStateForKey = state[key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof process === "object" && process.domain) {
	      invoke = process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(186)))

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.ResizeObserver = factory());
	}(this, (function () {
	'use strict';
	
	/**
	 * A collection of shims that provide minimal functionality of the ES6 collections.
	 *
	 * These implementations are not meant to be used outside of the ResizeObserver
	 * modules as they cover only a limited range of use cases.
	 */
	/* eslint-disable require-jsdoc, valid-jsdoc */
	var MapShim = (function () {
	    if (typeof Map != 'undefined') {
	        return Map;
	    }
	
	    /**
	     * Returns index in provided array that matches the specified key.
	     *
	     * @param {Array<Array>} arr
	     * @param {*} key
	     * @returns {number}
	     */
	    function getIndex(arr, key) {
	        var result = -1;
	
	        arr.some(function (entry, index) {
	            if (entry[0] === key) {
	                result = index;
	
	                return true;
	            }
	
	            return false;
	        });
	
	        return result;
	    }
	
	    return (function () {
	        function anonymous() {
	            this.__entries__ = [];
	        }
	
	        var prototypeAccessors = { size: {} };
	
	        /**
	         * @returns {boolean}
	         */
	        prototypeAccessors.size.get = function () {
	            return this.__entries__.length;
	        };
	
	        /**
	         * @param {*} key
	         * @returns {*}
	         */
	        anonymous.prototype.get = function (key) {
	            var index = getIndex(this.__entries__, key);
	            var entry = this.__entries__[index];
	
	            return entry && entry[1];
	        };
	
	        /**
	         * @param {*} key
	         * @param {*} value
	         * @returns {void}
	         */
	        anonymous.prototype.set = function (key, value) {
	            var index = getIndex(this.__entries__, key);
	
	            if (~index) {
	                this.__entries__[index][1] = value;
	            } else {
	                this.__entries__.push([key, value]);
	            }
	        };
	
	        /**
	         * @param {*} key
	         * @returns {void}
	         */
	        anonymous.prototype.delete = function (key) {
	            var entries = this.__entries__;
	            var index = getIndex(entries, key);
	
	            if (~index) {
	                entries.splice(index, 1);
	            }
	        };
	
	        /**
	         * @param {*} key
	         * @returns {void}
	         */
	        anonymous.prototype.has = function (key) {
	            return !!~getIndex(this.__entries__, key);
	        };
	
	        /**
	         * @returns {void}
	         */
	        anonymous.prototype.clear = function () {
	            this.__entries__.splice(0);
	        };
	
	        /**
	         * @param {Function} callback
	         * @param {*} [ctx=null]
	         * @returns {void}
	         */
	        anonymous.prototype.forEach = function (callback, ctx) {
	            if ( ctx === void 0 ) ctx = null;
	
	            for (var i = 0, list = this.__entries__; i < list.length; i += 1) {
	                var entry = list[i];
	
	                callback.call(ctx, entry[1], entry[0]);
	            }
	        };
	
	        Object.defineProperties( anonymous.prototype, prototypeAccessors );
	
	        return anonymous;
	    }());
	})();
	
	/**
	 * Detects whether window and document objects are available in current environment.
	 */
	var isBrowser = typeof window != 'undefined' && typeof document != 'undefined' && window.document === document;
	
	/**
	 * A shim for the requestAnimationFrame which falls back to the setTimeout if
	 * first one is not supported.
	 *
	 * @returns {number} Requests' identifier.
	 */
	var requestAnimationFrame$1 = (function () {
	    if (typeof requestAnimationFrame === 'function') {
	        return requestAnimationFrame;
	    }
	
	    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	})();
	
	// Defines minimum timeout before adding a trailing call.
	var trailingTimeout = 2;
	
	/**
	 * Creates a wrapper function which ensures that provided callback will be
	 * invoked only once during the specified delay period.
	 *
	 * @param {Function} callback - Function to be invoked after the delay period.
	 * @param {number} delay - Delay after which to invoke callback.
	 * @returns {Function}
	 */
	var throttle = function (callback, delay) {
	    var leadingCall = false,
	        trailingCall = false,
	        lastCallTime = 0;
	
	    /**
	     * Invokes the original callback function and schedules new invocation if
	     * the "proxy" was called during current request.
	     *
	     * @returns {void}
	     */
	    function resolvePending() {
	        if (leadingCall) {
	            leadingCall = false;
	
	            callback();
	        }
	
	        if (trailingCall) {
	            proxy();
	        }
	    }
	
	    /**
	     * Callback invoked after the specified delay. It will further postpone
	     * invocation of the original function delegating it to the
	     * requestAnimationFrame.
	     *
	     * @returns {void}
	     */
	    function timeoutCallback() {
	        requestAnimationFrame$1(resolvePending);
	    }
	
	    /**
	     * Schedules invocation of the original function.
	     *
	     * @returns {void}
	     */
	    function proxy() {
	        var timeStamp = Date.now();
	
	        if (leadingCall) {
	            // Reject immediately following calls.
	            if (timeStamp - lastCallTime < trailingTimeout) {
	                return;
	            }
	
	            // Schedule new call to be in invoked when the pending one is resolved.
	            // This is important for "transitions" which never actually start
	            // immediately so there is a chance that we might miss one if change
	            // happens amids the pending invocation.
	            trailingCall = true;
	        } else {
	            leadingCall = true;
	            trailingCall = false;
	
	            setTimeout(timeoutCallback, delay);
	        }
	
	        lastCallTime = timeStamp;
	    }
	
	    return proxy;
	};
	
	// Minimum delay before invoking the update of observers.
	var REFRESH_DELAY = 20;
	
	// A list of substrings of CSS properties used to find transition events that
	// might affect dimensions of observed elements.
	var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	
	// Detect whether running in IE 11 (facepalm).
	var isIE11 = typeof navigator != 'undefined' && /Trident\/.*rv:11/.test(navigator.userAgent);
	
	// MutationObserver should not be used if running in Internet Explorer 11 as it's
	// implementation is unreliable. Example: https://jsfiddle.net/x2r3jpuz/2/
	//
	// It's a real bummer that there is no other way to check for this issue but to
	// use the UA information.
	var mutationObserverSupported = typeof MutationObserver != 'undefined' && !isIE11;
	
	/**
	 * Singleton controller class which handles updates of ResizeObserver instances.
	 */
	var ResizeObserverController = function() {
	    /**
	     * Indicates whether DOM listeners have been added.
	     *
	     * @private {boolean}
	     */
	    this.connected_ = false;
	
	    /**
	     * Tells that controller has subscribed for Mutation Events.
	     *
	     * @private {boolean}
	     */
	    this.mutationEventsAdded_ = false;
	
	    /**
	     * Keeps reference to the instance of MutationObserver.
	     *
	     * @private {MutationObserver}
	     */
	    this.mutationsObserver_ = null;
	
	    /**
	     * A list of connected observers.
	     *
	     * @private {Array<ResizeObserverSPI>}
	     */
	    this.observers_ = [];
	
	    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	    this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	};
	
	/**
	 * Adds observer to observers list.
	 *
	 * @param {ResizeObserverSPI} observer - Observer to be added.
	 * @returns {void}
	 */
	ResizeObserverController.prototype.addObserver = function (observer) {
	    if (!~this.observers_.indexOf(observer)) {
	        this.observers_.push(observer);
	    }
	
	    // Add listeners if they haven't been added yet.
	    if (!this.connected_) {
	        this.connect_();
	    }
	};
	
	/**
	 * Removes observer from observers list.
	 *
	 * @param {ResizeObserverSPI} observer - Observer to be removed.
	 * @returns {void}
	 */
	ResizeObserverController.prototype.removeObserver = function (observer) {
	    var observers = this.observers_;
	    var index = observers.indexOf(observer);
	
	    // Remove observer if it's present in registry.
	    if (~index) {
	        observers.splice(index, 1);
	    }
	
	    // Remove listeners if controller has no connected observers.
	    if (!observers.length && this.connected_) {
	        this.disconnect_();
	    }
	};
	
	/**
	 * Invokes the update of observers. It will continue running updates insofar
	 * it detects changes.
	 *
	 * @returns {void}
	 */
	ResizeObserverController.prototype.refresh = function () {
	    var changesDetected = this.updateObservers_();
	
	    // Continue running updates if changes have been detected as there might
	    // be future ones caused by CSS transitions.
	    if (changesDetected) {
	        this.refresh();
	    }
	};
	
	/**
	 * Updates every observer from observers list and notifies them of queued
	 * entries.
	 *
	 * @private
	 * @returns {boolean} Returns "true" if any observer has detected changes in
	 *  dimensions of it's elements.
	 */
	ResizeObserverController.prototype.updateObservers_ = function () {
	    // Collect observers that have active observations.
	    var activeObservers = this.observers_.filter(function (observer) {
	        return observer.gatherActive(), observer.hasActive();
	    });
	
	    // Deliver notifications in a separate cycle in order to avoid any
	    // collisions between observers, e.g. when multiple instances of
	    // ResizeObserver are tracking the same element and the callback of one
	    // of them changes content dimensions of the observed target. Sometimes
	    // this may result in notifications being blocked for the rest of observers.
	    activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	
	    return activeObservers.length > 0;
	};
	
	/**
	 * Initializes DOM listeners.
	 *
	 * @private
	 * @returns {void}
	 */
	ResizeObserverController.prototype.connect_ = function () {
	    // Do nothing if running in a non-browser environment or if listeners
	    // have been already added.
	    if (!isBrowser || this.connected_) {
	        return;
	    }
	
	    // Subscription to the "Transitionend" event is used as a workaround for
	    // delayed transitions. This way it's possible to capture at least the
	    // final state of an element.
	    document.addEventListener('transitionend', this.onTransitionEnd_);
	
	    window.addEventListener('resize', this.refresh);
	
	    if (mutationObserverSupported) {
	        this.mutationsObserver_ = new MutationObserver(this.refresh);
	
	        this.mutationsObserver_.observe(document, {
	            attributes: true,
	            childList: true,
	            characterData: true,
	            subtree: true
	        });
	    } else {
	        document.addEventListener('DOMSubtreeModified', this.refresh);
	
	        this.mutationEventsAdded_ = true;
	    }
	
	    this.connected_ = true;
	};
	
	/**
	 * Removes DOM listeners.
	 *
	 * @private
	 * @returns {void}
	 */
	ResizeObserverController.prototype.disconnect_ = function () {
	    // Do nothing if running in a non-browser environment or if listeners
	    // have been already removed.
	    if (!isBrowser || !this.connected_) {
	        return;
	    }
	
	    document.removeEventListener('transitionend', this.onTransitionEnd_);
	    window.removeEventListener('resize', this.refresh);
	
	    if (this.mutationsObserver_) {
	        this.mutationsObserver_.disconnect();
	    }
	
	    if (this.mutationEventsAdded_) {
	        document.removeEventListener('DOMSubtreeModified', this.refresh);
	    }
	
	    this.mutationsObserver_ = null;
	    this.mutationEventsAdded_ = false;
	    this.connected_ = false;
	};
	
	/**
	 * "Transitionend" event handler.
	 *
	 * @private
	 * @param {TransitionEvent} event
	 * @returns {void}
	 */
	ResizeObserverController.prototype.onTransitionEnd_ = function (ref) {
	        var propertyName = ref.propertyName;
	
	    // Detect whether transition may affect dimensions of an element.
	    var isReflowProperty = transitionKeys.some(function (key) {
	        return !!~propertyName.indexOf(key);
	    });
	
	    if (isReflowProperty) {
	        this.refresh();
	    }
	};
	
	/**
	 * Returns instance of the ResizeObserverController.
	 *
	 * @returns {ResizeObserverController}
	 */
	ResizeObserverController.getInstance = function () {
	    if (!this.instance_) {
	        this.instance_ = new ResizeObserverController();
	    }
	
	    return this.instance_;
	};
	
	/**
	 * Holds reference to the controller's instance.
	 *
	 * @private {ResizeObserverController}
	 */
	ResizeObserverController.instance_ = null;
	
	/**
	 * Defines non-writable/enumerable properties of the provided target object.
	 *
	 * @param {Object} target - Object for which to define properties.
	 * @param {Object} props - Properties to be defined.
	 * @returns {Object} Target object.
	 */
	var defineConfigurable = (function (target, props) {
	    for (var i = 0, list = Object.keys(props); i < list.length; i += 1) {
	        var key = list[i];
	
	        Object.defineProperty(target, key, {
	            value: props[key],
	            enumerable: false,
	            writable: false,
	            configurable: true
	        });
	    }
	
	    return target;
	});
	
	// Placeholder of an empty content rectangle.
	var emptyRect = createRectInit(0, 0, 0, 0);
	
	/**
	 * Converts provided string to a number.
	 *
	 * @param {number|string} value
	 * @returns {number}
	 */
	function toFloat(value) {
	    return parseFloat(value) || 0;
	}
	
	/**
	 * Extracts borders size from provided styles.
	 *
	 * @param {CSSStyleDeclaration} styles
	 * @param {...string} positions - Borders positions (top, right, ...)
	 * @returns {number}
	 */
	function getBordersSize(styles) {
	    var positions = Array.prototype.slice.call(arguments, 1);
	
	    return positions.reduce(function (size, position) {
	        var value = styles['border-' + position + '-width'];
	
	        return size + toFloat(value);
	    }, 0);
	}
	
	/**
	 * Extracts paddings sizes from provided styles.
	 *
	 * @param {CSSStyleDeclaration} styles
	 * @returns {Object} Paddings box.
	 */
	function getPaddings(styles) {
	    var positions = ['top', 'right', 'bottom', 'left'];
	    var paddings = {};
	
	    for (var i = 0, list = positions; i < list.length; i += 1) {
	        var position = list[i];
	
	        var value = styles['padding-' + position];
	
	        paddings[position] = toFloat(value);
	    }
	
	    return paddings;
	}
	
	/**
	 * Calculates content rectangle of provided SVG element.
	 *
	 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	 *      to be calculated.
	 * @returns {DOMRectInit}
	 */
	function getSVGContentRect(target) {
	    var bbox = target.getBBox();
	
	    return createRectInit(0, 0, bbox.width, bbox.height);
	}
	
	/**
	 * Calculates content rectangle of provided HTMLElement.
	 *
	 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	 * @returns {DOMRectInit}
	 */
	function getHTMLElementContentRect(target) {
	    // Client width & height properties can't be
	    // used exclusively as they provide rounded values.
	    var clientWidth = target.clientWidth;
	    var clientHeight = target.clientHeight;
	
	    // By this condition we can catch all non-replaced inline, hidden and
	    // detached elements. Though elements with width & height properties less
	    // than 0.5 will be discarded as well.
	    //
	    // Without it we would need to implement separate methods for each of
	    // those cases and it's not possible to perform a precise and performance
	    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	    // gives wrong results for elements with width & height less than 0.5.
	    if (!clientWidth && !clientHeight) {
	        return emptyRect;
	    }
	
	    var styles = getComputedStyle(target);
	    var paddings = getPaddings(styles);
	    var horizPad = paddings.left + paddings.right;
	    var vertPad = paddings.top + paddings.bottom;
	
	    // Computed styles of width & height are being used because they are the
	    // only dimensions available to JS that contain non-rounded values. It could
	    // be possible to utilize the getBoundingClientRect if only it's data wasn't
	    // affected by CSS transformations let alone paddings, borders and scroll bars.
	    var width = toFloat(styles.width),
	        height = toFloat(styles.height);
	
	    // Width & height include paddings and borders when the 'border-box' box
	    // model is applied (except for IE).
	    if (styles.boxSizing === 'border-box') {
	        // Following conditions are required to handle Internet Explorer which
	        // doesn't include paddings and borders to computed CSS dimensions.
	        //
	        // We can say that if CSS dimensions + paddings are equal to the "client"
	        // properties then it's either IE, and thus we don't need to subtract
	        // anything, or an element merely doesn't have paddings/borders styles.
	        if (Math.round(width + horizPad) !== clientWidth) {
	            width -= getBordersSize(styles, 'left', 'right') + horizPad;
	        }
	
	        if (Math.round(height + vertPad) !== clientHeight) {
	            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	        }
	    }
	
	    // Following steps can't be applied to the document's root element as its
	    // client[Width/Height] properties represent viewport area of the window.
	    // Besides, it's as well not necessary as the <html> itself neither has
	    // rendered scroll bars nor it can be clipped.
	    if (!isDocumentElement(target)) {
	        // In some browsers (only in Firefox, actually) CSS width & height
	        // include scroll bars size which can be removed at this step as scroll
	        // bars are the only difference between rounded dimensions + paddings
	        // and "client" properties, though that is not always true in Chrome.
	        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	
	        // Chrome has a rather weird rounding of "client" properties.
	        // E.g. for an element with content width of 314.2px it sometimes gives
	        // the client width of 315px and for the width of 314.7px it may give
	        // 314px. And it doesn't happen all the time. So just ignore this delta
	        // as a non-relevant.
	        if (Math.abs(vertScrollbar) !== 1) {
	            width -= vertScrollbar;
	        }
	
	        if (Math.abs(horizScrollbar) !== 1) {
	            height -= horizScrollbar;
	        }
	    }
	
	    return createRectInit(paddings.left, paddings.top, width, height);
	}
	
	/**
	 * Checks whether provided element is an instance of the SVGGraphicsElement.
	 *
	 * @param {Element} target - Element to be checked.
	 * @returns {boolean}
	 */
	var isSVGGraphicsElement = (function () {
	    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	    // interface.
	    if (typeof SVGGraphicsElement != 'undefined') {
	        return function (target) { return target instanceof SVGGraphicsElement; };
	    }
	
	    // If it's so, then check that element is at least an instance of the
	    // SVGElement and that it has the "getBBox" method.
	    // eslint-disable-next-line no-extra-parens
	    return function (target) { return target instanceof SVGElement && typeof target.getBBox === 'function'; };
	})();
	
	/**
	 * Checks whether provided element is a document element (<html>).
	 *
	 * @param {Element} target - Element to be checked.
	 * @returns {boolean}
	 */
	function isDocumentElement(target) {
	    return target === document.documentElement;
	}
	
	/**
	 * Calculates an appropriate content rectangle for provided html or svg element.
	 *
	 * @param {Element} target - Element content rectangle of which needs to be calculated.
	 * @returns {DOMRectInit}
	 */
	function getContentRect(target) {
	    if (!isBrowser) {
	        return emptyRect;
	    }
	
	    if (isSVGGraphicsElement(target)) {
	        return getSVGContentRect(target);
	    }
	
	    return getHTMLElementContentRect(target);
	}
	
	/**
	 * Creates rectangle with an interface of the DOMRectReadOnly.
	 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	 *
	 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	 * @returns {DOMRectReadOnly}
	 */
	function createReadOnlyRect(ref) {
	    var x = ref.x;
	    var y = ref.y;
	    var width = ref.width;
	    var height = ref.height;
	
	    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	    var Constr = typeof DOMRectReadOnly != 'undefined' ? DOMRectReadOnly : Object;
	    var rect = Object.create(Constr.prototype);
	
	    // Rectangle's properties are not writable and non-enumerable.
	    defineConfigurable(rect, {
	        x: x, y: y, width: width, height: height,
	        top: y,
	        right: x + width,
	        bottom: height + y,
	        left: x
	    });
	
	    return rect;
	}
	
	/**
	 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	 *
	 * @param {number} x - X coordinate.
	 * @param {number} y - Y coordinate.
	 * @param {number} width - Rectangle's width.
	 * @param {number} height - Rectangle's height.
	 * @returns {DOMRectInit}
	 */
	function createRectInit(x, y, width, height) {
	    return { x: x, y: y, width: width, height: height };
	}
	
	/**
	 * Class that is responsible for computations of the content rectangle of
	 * provided DOM element and for keeping track of it's changes.
	 */
	var ResizeObservation = function(target) {
	    /**
	     * Broadcasted width of content rectangle.
	     *
	     * @type {number}
	     */
	    this.broadcastWidth = 0;
	
	    /**
	     * Broadcasted height of content rectangle.
	     *
	     * @type {number}
	     */
	    this.broadcastHeight = 0;
	
	    /**
	     * Reference to the last observed content rectangle.
	     *
	     * @private {DOMRectInit}
	     */
	    this.contentRect_ = createRectInit(0, 0, 0, 0);
	
	    /**
	     * Reference to the observed element.
	     *
	     * @type {Element}
	     */
	    this.target = target;
	};
	
	/**
	 * Updates content rectangle and tells whether it's width or height properties
	 * have changed since the last broadcast.
	 *
	 * @returns {boolean}
	 */
	ResizeObservation.prototype.isActive = function () {
	    var rect = getContentRect(this.target);
	
	    this.contentRect_ = rect;
	
	    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
	};
	
	/**
	 * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	 * from the corresponding properties of the last observed content rectangle.
	 *
	 * @returns {DOMRectInit} Last observed content rectangle.
	 */
	ResizeObservation.prototype.broadcastRect = function () {
	    var rect = this.contentRect_;
	
	    this.broadcastWidth = rect.width;
	    this.broadcastHeight = rect.height;
	
	    return rect;
	};
	
	var ResizeObserverEntry = function(target, rectInit) {
	    var contentRect = createReadOnlyRect(rectInit);
	
	    // According to the specification following properties are not writable
	    // and are also not enumerable in the native implementation.
	    //
	    // Property accessors are not being used as they'd require to define a
	    // private WeakMap storage which may cause memory leaks in browsers that
	    // don't support this type of collections.
	    defineConfigurable(this, { target: target, contentRect: contentRect });
	};
	
	var ResizeObserverSPI = function(callback, controller, callbackCtx) {
	    if (typeof callback !== 'function') {
	        throw new TypeError('The callback provided as parameter 1 is not a function.');
	    }
	
	    /**
	     * Collection of resize observations that have detected changes in dimensions
	     * of elements.
	     *
	     * @private {Array<ResizeObservation>}
	     */
	    this.activeObservations_ = [];
	
	    /**
	     * Registry of the ResizeObservation instances.
	     *
	     * @private {Map<Element, ResizeObservation>}
	     */
	    this.observations_ = new MapShim();
	
	    /**
	     * Reference to the callback function.
	     *
	     * @private {ResizeObserverCallback}
	     */
	    this.callback_ = callback;
	
	    /**
	     * Reference to the associated ResizeObserverController.
	     *
	     * @private {ResizeObserverController}
	     */
	    this.controller_ = controller;
	
	    /**
	     * Public ResizeObserver instance which will be passed to the callback
	     * function and used as a value of it's "this" binding.
	     *
	     * @private {ResizeObserver}
	     */
	    this.callbackCtx_ = callbackCtx;
	};
	
	/**
	 * Starts observing provided element.
	 *
	 * @param {Element} target - Element to be observed.
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.observe = function (target) {
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    // Do nothing if current environment doesn't have the Element interface.
	    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	        return;
	    }
	
	    if (!(target instanceof Element)) {
	        throw new TypeError('parameter 1 is not of type "Element".');
	    }
	
	    var observations = this.observations_;
	
	    // Do nothing if element is already being observed.
	    if (observations.has(target)) {
	        return;
	    }
	
	    observations.set(target, new ResizeObservation(target));
	
	    this.controller_.addObserver(this);
	
	    // Force the update of observations.
	    this.controller_.refresh();
	};
	
	/**
	 * Stops observing provided element.
	 *
	 * @param {Element} target - Element to stop observing.
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.unobserve = function (target) {
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    // Do nothing if current environment doesn't have the Element interface.
	    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	        return;
	    }
	
	    if (!(target instanceof Element)) {
	        throw new TypeError('parameter 1 is not of type "Element".');
	    }
	
	    var observations = this.observations_;
	
	    // Do nothing if element is not being observed.
	    if (!observations.has(target)) {
	        return;
	    }
	
	    observations.delete(target);
	
	    if (!observations.size) {
	        this.controller_.removeObserver(this);
	    }
	};
	
	/**
	 * Stops observing all elements.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.disconnect = function () {
	    this.clearActive();
	    this.observations_.clear();
	    this.controller_.removeObserver(this);
	};
	
	/**
	 * Collects observation instances the associated element of which has changed
	 * it's content rectangle.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.gatherActive = function () {
	        var this$1 = this;
	
	    this.clearActive();
	
	    this.observations_.forEach(function (observation) {
	        if (observation.isActive()) {
	            this$1.activeObservations_.push(observation);
	        }
	    });
	};
	
	/**
	 * Invokes initial callback function with a list of ResizeObserverEntry
	 * instances collected from active resize observations.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.broadcastActive = function () {
	    // Do nothing if observer doesn't have active observations.
	    if (!this.hasActive()) {
	        return;
	    }
	
	    var ctx = this.callbackCtx_;
	
	    // Create ResizeObserverEntry instance for every active observation.
	    var entries = this.activeObservations_.map(function (observation) {
	        return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	    });
	
	    this.callback_.call(ctx, entries, ctx);
	    this.clearActive();
	};
	
	/**
	 * Clears the collection of active observations.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.clearActive = function () {
	    this.activeObservations_.splice(0);
	};
	
	/**
	 * Tells whether observer has active observations.
	 *
	 * @returns {boolean}
	 */
	ResizeObserverSPI.prototype.hasActive = function () {
	    return this.activeObservations_.length > 0;
	};
	
	// Registry of internal observers. If WeakMap is not available use current shim
	// for the Map collection as it has all required methods and because WeakMap
	// can't be fully polyfilled anyway.
	var observers = typeof WeakMap != 'undefined' ? new WeakMap() : new MapShim();
	
	/**
	 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	 * exposing only those methods and properties that are defined in the spec.
	 */
	var ResizeObserver$1 = function(callback) {
	    if (!(this instanceof ResizeObserver$1)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    var controller = ResizeObserverController.getInstance();
	    var observer = new ResizeObserverSPI(callback, controller, this);
	
	    observers.set(this, observer);
	};
	
	// Expose public methods of ResizeObserver.
	['observe', 'unobserve', 'disconnect'].forEach(function (method) {
	    ResizeObserver$1.prototype[method] = function () {
	        return (ref = observers.get(this))[method].apply(ref, arguments);
	        var ref;
	    };
	});
	
	var index = (function () {
	    // Export existing implementation if available.
	    if (typeof ResizeObserver != 'undefined') {
	        // eslint-disable-next-line no-undef
	        return ResizeObserver;
	    }
	
	    return ResizeObserver$1;
	})();
	
	return index;
	})));


/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var url = __webpack_require__(1656);
	var parser = __webpack_require__(419);
	var Manager = __webpack_require__(665);
	var debug = __webpack_require__(116)('socket.io-client');
	
	/**
	 * Module exports.
	 */
	
	module.exports = exports = lookup;
	
	/**
	 * Managers cache.
	 */
	
	var cache = exports.managers = {};
	
	/**
	 * Looks up an existing `Manager` for multiplexing.
	 * If the user summons:
	 *
	 *   `io('http://localhost/a');`
	 *   `io('http://localhost/b');`
	 *
	 * We reuse the existing instance based on same scheme/port/host,
	 * and we initialize sockets for each namespace.
	 *
	 * @api public
	 */
	
	function lookup (uri, opts) {
	  if (typeof uri === 'object') {
	    opts = uri;
	    uri = undefined;
	  }
	
	  opts = opts || {};
	
	  var parsed = url(uri);
	  var source = parsed.source;
	  var id = parsed.id;
	  var path = parsed.path;
	  var sameNamespace = cache[id] && path in cache[id].nsps;
	  var newConnection = opts.forceNew || opts['force new connection'] ||
	                      false === opts.multiplex || sameNamespace;
	
	  var io;
	
	  if (newConnection) {
	    debug('ignoring socket cache for %s', source);
	    io = Manager(source, opts);
	  } else {
	    if (!cache[id]) {
	      debug('new io instance for %s', source);
	      cache[id] = Manager(source, opts);
	    }
	    io = cache[id];
	  }
	  if (parsed.query && !opts.query) {
	    opts.query = parsed.query;
	  } else if (opts && 'object' === typeof opts.query) {
	    opts.query = encodeQueryString(opts.query);
	  }
	  return io.socket(parsed.path, opts);
	}
	/**
	 *  Helper method to parse query objects to string.
	 * @param {object} query
	 * @returns {string}
	 */
	function encodeQueryString (obj) {
	  var str = [];
	  for (var p in obj) {
	    if (obj.hasOwnProperty(p)) {
	      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
	    }
	  }
	  return str.join('&');
	}
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	exports.protocol = parser.protocol;
	
	/**
	 * `connect`.
	 *
	 * @param {String} uri
	 * @api public
	 */
	
	exports.connect = lookup;
	
	/**
	 * Expose constructors for standalone build.
	 *
	 * @api public
	 */
	
	exports.Manager = __webpack_require__(665);
	exports.Socket = __webpack_require__(667);


/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module dependencies.
	 */
	
	var parseuri = __webpack_require__(595);
	var debug = __webpack_require__(116)('socket.io-client:url');
	
	/**
	 * Module exports.
	 */
	
	module.exports = url;
	
	/**
	 * URL parser.
	 *
	 * @param {String} url
	 * @param {Object} An object meant to mimic window.location.
	 *                 Defaults to window.location.
	 * @api public
	 */
	
	function url (uri, loc) {
	  var obj = uri;
	
	  // default to window.location
	  loc = loc || global.location;
	  if (null == uri) uri = loc.protocol + '//' + loc.host;
	
	  // relative path support
	  if ('string' === typeof uri) {
	    if ('/' === uri.charAt(0)) {
	      if ('/' === uri.charAt(1)) {
	        uri = loc.protocol + uri;
	      } else {
	        uri = loc.host + uri;
	      }
	    }
	
	    if (!/^(https?|wss?):\/\//.test(uri)) {
	      debug('protocol-less url %s', uri);
	      if ('undefined' !== typeof loc) {
	        uri = loc.protocol + '//' + uri;
	      } else {
	        uri = 'https://' + uri;
	      }
	    }
	
	    // parse
	    debug('parse %s', uri);
	    obj = parseuri(uri);
	  }
	
	  // make sure we treat `localhost:80` and `localhost` equally
	  if (!obj.port) {
	    if (/^(http|ws)$/.test(obj.protocol)) {
	      obj.port = '80';
	    } else if (/^(http|ws)s$/.test(obj.protocol)) {
	      obj.port = '443';
	    }
	  }
	
	  obj.path = obj.path || '/';
	
	  var ipv6 = obj.host.indexOf(':') !== -1;
	  var host = ipv6 ? '[' + obj.host + ']' : obj.host;
	
	  // define unique id
	  obj.id = obj.protocol + '://' + host + ':' + obj.port;
	  // define href
	  obj.href = obj.protocol + '://' + host + (loc && loc.port === obj.port ? '' : (':' + obj.port));
	
	  return obj;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*global Blob,File*/
	
	/**
	 * Module requirements
	 */
	
	var isArray = __webpack_require__(1658);
	var isBuf = __webpack_require__(668);
	var toString = Object.prototype.toString;
	var withNativeBlob = typeof global.Blob === 'function' || toString.call(global.Blob) === '[object BlobConstructor]';
	var withNativeFile = typeof global.File === 'function' || toString.call(global.File) === '[object FileConstructor]';
	
	/**
	 * Replaces every Buffer | ArrayBuffer in packet with a numbered placeholder.
	 * Anything with blobs or files should be fed through removeBlobs before coming
	 * here.
	 *
	 * @param {Object} packet - socket.io event packet
	 * @return {Object} with deconstructed packet and list of buffers
	 * @api public
	 */
	
	exports.deconstructPacket = function(packet) {
	  var buffers = [];
	  var packetData = packet.data;
	  var pack = packet;
	  pack.data = _deconstructPacket(packetData, buffers);
	  pack.attachments = buffers.length; // number of binary 'attachments'
	  return {packet: pack, buffers: buffers};
	};
	
	function _deconstructPacket(data, buffers) {
	  if (!data) return data;
	
	  if (isBuf(data)) {
	    var placeholder = { _placeholder: true, num: buffers.length };
	    buffers.push(data);
	    return placeholder;
	  } else if (isArray(data)) {
	    var newData = new Array(data.length);
	    for (var i = 0; i < data.length; i++) {
	      newData[i] = _deconstructPacket(data[i], buffers);
	    }
	    return newData;
	  } else if (typeof data === 'object' && !(data instanceof Date)) {
	    var newData = {};
	    for (var key in data) {
	      newData[key] = _deconstructPacket(data[key], buffers);
	    }
	    return newData;
	  }
	  return data;
	}
	
	/**
	 * Reconstructs a binary packet from its placeholder packet and buffers
	 *
	 * @param {Object} packet - event packet with placeholders
	 * @param {Array} buffers - binary buffers to put in placeholder positions
	 * @return {Object} reconstructed packet
	 * @api public
	 */
	
	exports.reconstructPacket = function(packet, buffers) {
	  packet.data = _reconstructPacket(packet.data, buffers);
	  packet.attachments = undefined; // no longer useful
	  return packet;
	};
	
	function _reconstructPacket(data, buffers) {
	  if (!data) return data;
	
	  if (data && data._placeholder) {
	    return buffers[data.num]; // appropriate buffer (should be natural order anyway)
	  } else if (isArray(data)) {
	    for (var i = 0; i < data.length; i++) {
	      data[i] = _reconstructPacket(data[i], buffers);
	    }
	  } else if (typeof data === 'object') {
	    for (var key in data) {
	      data[key] = _reconstructPacket(data[key], buffers);
	    }
	  }
	
	  return data;
	}
	
	/**
	 * Asynchronously removes Blobs or Files from data via
	 * FileReader's readAsArrayBuffer method. Used before encoding
	 * data as msgpack. Calls callback with the blobless data.
	 *
	 * @param {Object} data
	 * @param {Function} callback
	 * @api private
	 */
	
	exports.removeBlobs = function(data, callback) {
	  function _removeBlobs(obj, curKey, containingObject) {
	    if (!obj) return obj;
	
	    // convert any blob
	    if ((withNativeBlob && obj instanceof Blob) ||
	        (withNativeFile && obj instanceof File)) {
	      pendingBlobs++;
	
	      // async filereader
	      var fileReader = new FileReader();
	      fileReader.onload = function() { // this.result == arraybuffer
	        if (containingObject) {
	          containingObject[curKey] = this.result;
	        }
	        else {
	          bloblessData = this.result;
	        }
	
	        // if nothing pending its callback time
	        if(! --pendingBlobs) {
	          callback(bloblessData);
	        }
	      };
	
	      fileReader.readAsArrayBuffer(obj); // blob -> arraybuffer
	    } else if (isArray(obj)) { // handle array
	      for (var i = 0; i < obj.length; i++) {
	        _removeBlobs(obj[i], i, obj);
	      }
	    } else if (typeof obj === 'object' && !isBuf(obj)) { // and object
	      for (var key in obj) {
	        _removeBlobs(obj[key], key, obj);
	      }
	    }
	  }
	
	  var pendingBlobs = 0;
	  var bloblessData = data;
	  _removeBlobs(bloblessData);
	  if (!pendingBlobs) {
	    callback(bloblessData);
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1658 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 1659 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ }),
/* 1660 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (error, getState) {
	    if (!(error.user_id || error.user) && getState) {
	        var currentUserId = getState().getIn(['app', 'currentUser', '_id']);
	        if (currentUserId) {
	            error.user_id = currentUserId;
	        }
	    }
	    return error;
	};

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _actionTypeMap;
	
	var _reactRouterRedux = __webpack_require__(82);
	
	var _intercomService = __webpack_require__(290);
	
	var _elementCountSelector = __webpack_require__(170);
	
	var _elementMoveActionUtil = __webpack_require__(729);
	
	var _elementConstants = __webpack_require__(12);
	
	var _userConstants = __webpack_require__(32);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // Lib
	
	
	// Analytics
	
	
	// Constants
	
	
	var trackNavigate = function trackNavigate(state, action) {
	    var currentUserId = state.getIn(['app', 'currentUser', '_id']);
	    var currentBoardId = state.getIn(['users', currentUserId, 'currentBoardId']);
	
	    var sharedBoardUsers = state.get('users').filter(function (user) {
	        return user.get('currentBoardId') === currentBoardId || user.get('_id') === currentUserId;
	    });
	
	    if (sharedBoardUsers.size >= 2) {
	        (0, _intercomService.intercomTrackEvent)('live-shared-board', { users_count: sharedBoardUsers.size });
	    }
	};
	
	var updateIntercom = function updateIntercom(state, action) {
	    var billableContent = (0, _elementCountSelector.contentTotalCountSelector)(state);
	    if (!billableContent) return (0, _intercomService.intercomUpdate)({});
	
	    var contentLimit = (0, _elementCountSelector.contentTotalLimitSelector)(state);
	    var contentRemaining = contentLimit - billableContent;
	
	    (0, _intercomService.intercomUpdate)({ billable_content: billableContent, billable_content_remaining: contentRemaining });
	};
	
	var trackElementCreate = function trackElementCreate(state, action) {
	    if (action.remote) return;
	    (0, _intercomService.intercomTrackEvent)('created-' + action.elementType.toLowerCase());
	
	    // request updated auto messages from intercom
	    updateIntercom(state, action);
	};
	
	var trackMultiMoveToTrash = function trackMultiMoveToTrash(state, action) {
	    if (action.moves.some(_elementMoveActionUtil.isMoveToOrFromTrash)) updateIntercom(state, action);
	};
	
	var actionTypeMap = (_actionTypeMap = {}, _defineProperty(_actionTypeMap, _userConstants.USER_NAVIGATE, trackNavigate), _defineProperty(_actionTypeMap, _reactRouterRedux.LOCATION_CHANGE, updateIntercom), _defineProperty(_actionTypeMap, _elementConstants.ELEMENT_CREATE, trackElementCreate), _defineProperty(_actionTypeMap, _elementConstants.ELEMENT_MOVE_MULTI, trackMultiMoveToTrash), _actionTypeMap);
	
	exports.default = function (store) {
	    return function (next) {
	        return function (action) {
	            var trackActionType = actionTypeMap[action.type];
	            if (trackActionType) {
	                trackActionType(store.getState(), action);
	            }
	        };
	    };
	};

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	// Constants
	
	
	var _intercomService = __webpack_require__(290);
	
	var _getClientConfig = __webpack_require__(48);
	
	var _getClientConfig2 = _interopRequireDefault(_getClientConfig);
	
	var _rollbarService = __webpack_require__(226);
	
	var _analyticsEventMiddleware = __webpack_require__(1661);
	
	var _analyticsEventMiddleware2 = _interopRequireDefault(_analyticsEventMiddleware);
	
	var _analyticsActions = __webpack_require__(669);
	
	var _analyticsConstants = __webpack_require__(165);
	
	var _currentUserConstants = __webpack_require__(144);
	
	var _authConstants = __webpack_require__(136);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    var config = (0, _getClientConfig2.default)();
	
	    // if no analytics enabled, return empty middleware
	    if (!config.analytics || !config.analytics.enabled) {
	        return function (store) {
	            return function (next) {
	                return function (action) {
	                    return next(action);
	                };
	            };
	        };
	    }
	
	    // send user data to intercom
	    var sendUserData = function sendUserData(user) {
	        var createdDate = parseInt(user._id.slice(0, 8), 16);
	
	        var intercomUser = {
	            user_id: user._id,
	            created_at: createdDate,
	            email: user.email,
	            name: user.name && user.name.displayName,
	            res_width: screen.availWidth,
	            res_height: screen.availHeight,
	            hide_default_launcher: true
	        };
	
	        (0, _intercomService.intercomBoot)(_extends({
	            app_id: config.analytics.appId
	        }, intercomUser));
	    };
	
	    var shutdownIntercom = function shutdownIntercom() {
	        (0, _intercomService.intercomShutdown)();
	    };
	
	    // return analytics middleware
	    return function (store) {
	        // on unread count change, dispatch an event to the store with the new count
	        (0, _intercomService.intercomOnMessage)(function (unreadCount) {
	            return store.dispatch((0, _analyticsActions.intercomSetUnreadMessages)(unreadCount));
	        });
	
	        return function (next) {
	            return function (action) {
	                var updated = next(action);
	
	                (0, _analyticsEventMiddleware2.default)(store)(next)(action);
	
	                if (action.remote) return updated;
	
	                switch (action.type) {
	                    case _currentUserConstants.CURRENT_USER_SET:
	                        // when we set user data, send it to intercom
	                        sendUserData(action.user);
	                        (0, _rollbarService.setRollbarUser)(action.user);
	                        break;
	                    case _currentUserConstants.CURRENT_USER_SET_GUEST:
	                        // if we only have a guest user, boot interom without user
	                        (0, _intercomService.intercomBoot)({
	                            app_id: config.analytics.appId
	                        });
	                        break;
	                    case _authConstants.LOGOUT:
	                        // shut down intercom when user logs out
	                        shutdownIntercom();
	                        break;
	                    case _analyticsConstants.INTERCOM_SHOW_MESSAGES:
	                        (0, _intercomService.intercomShowMessenger)();
	                        break;
	                    default:
	                        break;
	                }
	
	                return updated;
	            };
	        };
	    };
	};

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _analyticsConstants = __webpack_require__(165);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialState = Immutable.Map({
	    unreadMessageCount: 0
	});
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _analyticsConstants.INTERCOM_SET_UNREAD_MESSAGES:
	            return state.set('unreadMessageCount', action.count);
	        default:
	            return state;
	    }
	};

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.googleAnalyticsSend = exports.googleAnalyticsApi = exports.googleAnalyticsAvaliable = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _getClientConfig = __webpack_require__(48);
	
	var _getClientConfig2 = _interopRequireDefault(_getClientConfig);
	
	var _logger = __webpack_require__(128);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _analyticsConstants = __webpack_require__(165);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useGoogleAnalytics = (0, _lodash.memoize)(function () {
	    return (0, _getClientConfig2.default)().analytics.enabled && (0, _getClientConfig2.default)().analytics.googleTrackingId;
	});
	var googleAnalyticsAvaliable = exports.googleAnalyticsAvaliable = function googleAnalyticsAvaliable() {
	    return !!window.ga;
	};
	
	var googleAnalyticsApi = exports.googleAnalyticsApi = function googleAnalyticsApi(action) {
	    return function (data) {
	        _logger2.default.info('Google Analytics:', action, data);
	
	        if (!useGoogleAnalytics()) return;
	        if (!googleAnalyticsAvaliable()) return _logger2.default.warn('Google Analytics not initialized yet');
	
	        window.ga(action, data);
	    };
	};
	
	var googleAnalyticsSend = exports.googleAnalyticsSend = googleAnalyticsApi(_analyticsConstants.GOOGLE_ANALYTICS_OPERATIONS.send);

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	var _lodash = __webpack_require__(4);
	
	var removeSensitiveInformation = function removeSensitiveInformation(normalisedError) {
	    return _extends({}, normalisedError, {
	        data: undefined,
	        errorDetails: undefined
	    });
	};
	
	var getResponseErrorData = function getResponseErrorData(data) {
	    if (!data || !data.error) return undefined;
	    var error = data.error;
	
	    return {
	        errorName: error.name,
	        errorCode: error.code,
	        errorMessage: error.message,
	        errorDetails: error.details || error.detail
	    };
	};
	
	var getResponseRequestData = function getResponseRequestData(request) {
	    if (!request) return undefined;
	
	    return {
	        // Overwrite the other apiUrl as this is more detailed
	        apiUrl: request.responseURL
	    };
	};
	
	var getResponseData = function getResponseData(response) {
	    if (!response) return undefined;
	
	    return _extends({
	        status: response.status,
	        statusText: response.statusText
	    }, getResponseRequestData(response.request), getResponseErrorData(response.data));
	};
	
	var getConfigData = function getConfigData(config) {
	    if (!config) return undefined;
	
	    return {
	        apiUrl: config.url,
	        method: config.method,
	        data: config.data
	    };
	};
	
	var normaliseError = function normaliseError(error) {
	    return _extends({
	        id: error.id,
	        code: error.code
	    }, getConfigData(error.config), getResponseData(error.response));
	};
	
	exports.default = function (_ref) {
	    var error = _ref.error,
	        sensitive = _ref.sensitive;
	
	    var transformations = [normaliseError];
	    if (sensitive) transformations.push(removeSensitiveInformation);
	    return (0, _lodash.flow)(transformations)(error);
	};

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class; // Lib
	
	
	// Decorators
	
	
	// Components
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _debugManagerDecorator = __webpack_require__(1938);
	
	var _debugManagerDecorator2 = _interopRequireDefault(_debugManagerDecorator);
	
	var _BrowserDetection = __webpack_require__(1760);
	
	var _BrowserDetection2 = _interopRequireDefault(_BrowserDetection);
	
	var _DebugToolbarContainer = __webpack_require__(1937);
	
	var _DebugToolbarContainer2 = _interopRequireDefault(_DebugToolbarContainer);
	
	__webpack_require__(1122);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AppInitContainer = (0, _debugManagerDecorator2.default)(_class = function (_React$Component) {
	    _inherits(AppInitContainer, _React$Component);
	
	    function AppInitContainer() {
	        _classCallCheck(this, AppInitContainer);
	
	        return _possibleConstructorReturn(this, (AppInitContainer.__proto__ || Object.getPrototypeOf(AppInitContainer)).apply(this, arguments));
	    }
	
	    _createClass(AppInitContainer, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'App' },
	                this.props.children,
	                _react2.default.createElement(_BrowserDetection2.default, this.props),
	                _react2.default.createElement(_DebugToolbarContainer2.default, this.props)
	            );
	        }
	    }]);
	
	    return AppInitContainer;
	}(_react2.default.Component)) || _class;
	
	AppInitContainer.propTypes = {
	    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
	};
	
	exports.default = AppInitContainer;

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class; // Lib
	
	
	// Actions
	
	
	// Selectors
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _currentBoardIdActions = __webpack_require__(750);
	
	var _navigationActions = __webpack_require__(27);
	
	var _currentBoardIdSelector = __webpack_require__(306);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        stateCurrentBoardId: (0, _currentBoardIdSelector.getCurrentBoardId)(state)
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        dispatchCurrentBoardIdSet: function dispatchCurrentBoardIdSet(_ref) {
	            var boardId = _ref.boardId;
	            return dispatch((0, _currentBoardIdActions.currentBoardIdSet)({ boardId: boardId }));
	        },
	        dispatchUpdateUrl: function dispatchUpdateUrl(argObj) {
	            return dispatch((0, _navigationActions.updateBoardSlug)(argObj));
	        }
	    };
	};
	
	var CurrentBoardIdSynchroniser = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_React$Component) {
	    _inherits(CurrentBoardIdSynchroniser, _React$Component);
	
	    function CurrentBoardIdSynchroniser() {
	        var _ref2;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, CurrentBoardIdSynchroniser);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = CurrentBoardIdSynchroniser.__proto__ || Object.getPrototypeOf(CurrentBoardIdSynchroniser)).call.apply(_ref2, [this].concat(args))), _this), _this.updateCurrentBoardId = function (boardId) {
	            var dispatchCurrentBoardIdSet = _this.props.dispatchCurrentBoardIdSet;
	
	            dispatchCurrentBoardIdSet({ boardId: boardId });
	        }, _this.updateUrl = function (_ref3) {
	            var currentBoardId = _ref3.params.currentBoardId,
	                routeParams = _ref3.routeParams,
	                dispatchUpdateUrl = _ref3.dispatchUpdateUrl;
	
	            if (!routeParams.slug) {
	                dispatchUpdateUrl({ boardId: currentBoardId, routeParams: routeParams });
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(CurrentBoardIdSynchroniser, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                currentBoardId = _props.params.currentBoardId,
	                stateCurrentBoardId = _props.stateCurrentBoardId;
	
	
	            if (currentBoardId) this.updateUrl(this.props);
	
	            if (currentBoardId !== stateCurrentBoardId) {
	                this.updateCurrentBoardId(currentBoardId);
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var currentBoardId = nextProps.params.currentBoardId,
	                stateCurrentBoardId = nextProps.stateCurrentBoardId;
	
	
	            if (currentBoardId) this.updateUrl(nextProps);
	
	            if (currentBoardId !== this.props.params.currentBoardId && currentBoardId !== stateCurrentBoardId) {
	                this.updateCurrentBoardId(currentBoardId);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return null;
	        }
	    }]);
	
	    return CurrentBoardIdSynchroniser;
	}(_react2.default.Component)) || _class);
	
	
	CurrentBoardIdSynchroniser.propTypes = {
	    stateCurrentBoardId: _propTypes2.default.string,
	    dispatchCurrentBoardIdSet: _propTypes2.default.func,
	    dispatchUpdateUrl: _propTypes2.default.func,
	    params: _propTypes2.default.object.isRequired,
	    routeParams: _propTypes2.default.object.isRequired
	};
	
	exports.default = CurrentBoardIdSynchroniser;

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _routes = __webpack_require__(1669);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _reactRouter = __webpack_require__(45);
	
	var _reactDocumentTitle = __webpack_require__(604);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _ElementConnectionsContextProvider = __webpack_require__(1705);
	
	var _ElementConnectionsContextProvider2 = _interopRequireDefault(_ElementConnectionsContextProvider);
	
	var _MeasurementsProvider = __webpack_require__(1907);
	
	var _MeasurementsProvider2 = _interopRequireDefault(_MeasurementsProvider);
	
	var _EditorStoreProvider = __webpack_require__(1747);
	
	var _EditorStoreProvider2 = _interopRequireDefault(_EditorStoreProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Element connections
	
	
	/**
	 * The root component of the application.
	 *  - Sets up the Redux Provider (which allows container components to access the store).
	 *  - Configures the Router (from React Router).
	 *
	 * This component requires:
	 *  - store (redux store)
	 *  - history (the react-router-redux wrapped browserHistory instance)
	 */
	var Root = function (_React$Component) {
	    _inherits(Root, _React$Component);
	
	    function Root() {
	        _classCallCheck(this, Root);
	
	        return _possibleConstructorReturn(this, (Root.__proto__ || Object.getPrototypeOf(Root)).apply(this, arguments));
	    }
	
	    _createClass(Root, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                store = _props.store,
	                history = _props.history,
	                measurementsStore = _props.measurementsStore,
	                elementConnectionsManager = _props.elementConnectionsManager,
	                editorStore = _props.editorStore;
	
	
	            return _react2.default.createElement(
	                _ElementConnectionsContextProvider2.default,
	                { manager: elementConnectionsManager },
	                _react2.default.createElement(
	                    _EditorStoreProvider2.default,
	                    { store: editorStore },
	                    _react2.default.createElement(
	                        _MeasurementsProvider2.default,
	                        { store: measurementsStore },
	                        _react2.default.createElement(
	                            _reactRedux.Provider,
	                            { store: store },
	                            _react2.default.createElement(
	                                _reactDocumentTitle2.default,
	                                { title: 'Milanote' },
	                                _react2.default.createElement(_reactRouter.Router, { history: history, routes: _routes2.default, store: store })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Root;
	}(_react2.default.Component);
	
	exports.default = Root;
	
	
	Root.propTypes = {
	    elementConnectionsManager: _propTypes2.default.object.isRequired,
	    editorStore: _propTypes2.default.object.isRequired,
	    measurementsStore: _propTypes2.default.object.isRequired,
	    store: _propTypes2.default.object.isRequired,
	    history: _propTypes2.default.object.isRequired
	};

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(45);
	
	var _AppInitContainer = __webpack_require__(1666);
	
	var _AppInitContainer2 = _interopRequireDefault(_AppInitContainer);
	
	var _WorkspaceInitContainer = __webpack_require__(2152);
	
	var _WorkspaceInitContainer2 = _interopRequireDefault(_WorkspaceInitContainer);
	
	var _Login = __webpack_require__(1682);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _Register = __webpack_require__(1684);
	
	var _Register2 = _interopRequireDefault(_Register);
	
	var _ForgottenPasswordModal = __webpack_require__(1678);
	
	var _ForgottenPasswordModal2 = _interopRequireDefault(_ForgottenPasswordModal);
	
	var _ChangePasswordModal = __webpack_require__(1673);
	
	var _ChangePasswordModal2 = _interopRequireDefault(_ChangePasswordModal);
	
	var _StaticPage = __webpack_require__(1932);
	
	var _StaticPage2 = _interopRequireDefault(_StaticPage);
	
	var _CurrentBoardIdSynchroniser = __webpack_require__(1667);
	
	var _CurrentBoardIdSynchroniser2 = _interopRequireDefault(_CurrentBoardIdSynchroniser);
	
	var _EmailUnsubscribeFullscreenModal = __webpack_require__(2083);
	
	var _EmailUnsubscribeFullscreenModal2 = _interopRequireDefault(_EmailUnsubscribeFullscreenModal);
	
	var _Payment = __webpack_require__(2057);
	
	var _Payment2 = _interopRequireDefault(_Payment);
	
	var _CurrentPlan = __webpack_require__(2067);
	
	var _CurrentPlan2 = _interopRequireDefault(_CurrentPlan);
	
	var _AccountSettingsModal = __webpack_require__(2081);
	
	var _AccountSettingsModal2 = _interopRequireDefault(_AccountSettingsModal);
	
	var _UpdateCardModal = __webpack_require__(2105);
	
	var _UpdateCardModal2 = _interopRequireDefault(_UpdateCardModal);
	
	var _TeamManagement = __webpack_require__(2093);
	
	var _TeamManagement2 = _interopRequireDefault(_TeamManagement);
	
	var _ReferModal = __webpack_require__(2077);
	
	var _ReferModal2 = _interopRequireDefault(_ReferModal);
	
	var _ReferralRedirect = __webpack_require__(2080);
	
	var _ReferralRedirect2 = _interopRequireDefault(_ReferralRedirect);
	
	var _AccountModalRoot = __webpack_require__(2056);
	
	var _AccountModalRoot2 = _interopRequireDefault(_AccountModalRoot);
	
	var _UnsubscribeModal = __webpack_require__(2101);
	
	var _UnsubscribeModal2 = _interopRequireDefault(_UnsubscribeModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * route.js
	 *  - Builds the routes for the application.
	 */
	
	
	// Components
	// Lib
	exports.default = _react2.default.createElement(
	    _reactRouter.Route,
	    { component: _AppInitContainer2.default },
	    _react2.default.createElement(_reactRouter.Route, { path: '/login', component: _Login2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/register', component: _Register2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/forgotten-password', component: _ForgottenPasswordModal2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/change-password', component: _ChangePasswordModal2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/unsubscribe', component: _EmailUnsubscribeFullscreenModal2.default }),
	    _react2.default.createElement(_reactRouter.Redirect, { from: '/account/unsubscribe', to: '/unsubscribe' }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/static/(:page)', component: _StaticPage2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/refer/(:referrer)', component: _ReferralRedirect2.default }),
	    _react2.default.createElement(_reactRouter.Redirect, { from: '/account', to: '/account/plan' }),
	    _react2.default.createElement(
	        _reactRouter.Route,
	        { path: '/', component: _WorkspaceInitContainer2.default },
	        _react2.default.createElement(
	            _reactRouter.Route,
	            { path: '/account', component: _AccountModalRoot2.default },
	            _react2.default.createElement(_reactRouter.Route, { path: 'plan', component: _CurrentPlan2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'card', component: _UpdateCardModal2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'refer', component: _ReferModal2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'cancel', component: _UnsubscribeModal2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'payment', component: _Payment2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'team', component: _TeamManagement2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'settings', component: _AccountSettingsModal2.default })
	        ),
	        _react2.default.createElement(_reactRouter.Route, { path: '/:currentBoardId(/:slug)', component: _CurrentBoardIdSynchroniser2.default })
	    )
	);
	// import AuthenticatedContainer from '../auth/AuthenticatedContainer';

/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	// Utils
	
	
	// Selectors
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reselect = __webpack_require__(7);
	
	var _lodash = __webpack_require__(4);
	
	var _authService = __webpack_require__(227);
	
	var _navigationActions = __webpack_require__(27);
	
	var _currentUserSelector = __webpack_require__(33);
	
	var _PageLoader = __webpack_require__(708);
	
	var _PageLoader2 = _interopRequireDefault(_PageLoader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var currentUserAvailableSelector = (0, _reselect.createSelector)(_currentUserSelector.getCurrentUser, function (currentUser) {
	    return currentUser.get('authenticated') && currentUser.get('fetched');
	});
	
	var getLocation = function getLocation(state) {
	    return state.get('routing') && state.get('routing').locationBeforeTransitions;
	};
	
	/**
	 * Selector used to build up the user data for Intercom
	 */
	
	var authenticatedRouteSelector = (0, _reselect.createStructuredSelector)({
	    isUserAvailable: currentUserAvailableSelector,
	    location: getLocation
	});
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        navigateToLogin: function navigateToLogin(_ref) {
	            var from = _ref.from;
	            return dispatch((0, _navigationActions.navigateToLogin)({ from: from }));
	        }
	    };
	};
	
	var AuthenticatedRoute = (_dec = (0, _reactRedux.connect)(authenticatedRouteSelector, mapDispatchToProps), _dec(_class = function (_React$Component) {
	    _inherits(AuthenticatedRoute, _React$Component);
	
	    function AuthenticatedRoute() {
	        _classCallCheck(this, AuthenticatedRoute);
	
	        return _possibleConstructorReturn(this, (AuthenticatedRoute.__proto__ || Object.getPrototypeOf(AuthenticatedRoute)).apply(this, arguments));
	    }
	
	    _createClass(AuthenticatedRoute, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                navigateToLogin = _props.navigateToLogin,
	                location = _props.location;
	
	            var pathname = (0, _lodash.get)(location, 'pathname');
	
	            var authToken = (0, _authService.getCurrentUserToken)();
	            if (!authToken) {
	                console.warn('AuthenticatedContainer:' + ' Attempted to access an authenticated page without an authentication token');
	                return navigateToLogin({ from: pathname });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var isUserAvailable = this.props.isUserAvailable;
	
	
	            if (!isUserAvailable) return _react2.default.createElement(_PageLoader2.default, null);
	
	            return this.props.children;
	        }
	    }]);
	
	    return AuthenticatedRoute;
	}(_react2.default.Component)) || _class);
	exports.default = AuthenticatedRoute;
	
	
	AuthenticatedRoute.propTypes = {
	    isUserAvailable: _propTypes2.default.bool,
	    intercomUser: _propTypes2.default.object,
	    analytics: _propTypes2.default.object,
	    children: _propTypes2.default.object,
	    location: _propTypes2.default.object,
	    initialiseCurrentUser: _propTypes2.default.func,
	    navigateToLogin: _propTypes2.default.func
	};

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FullScreenErrorModal = __webpack_require__(139);
	
	var _FullScreenErrorModal2 = _interopRequireDefault(_FullScreenErrorModal);
	
	var _ModalActionsList = __webpack_require__(126);
	
	var _ModalActionsList2 = _interopRequireDefault(_ModalActionsList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	// Lib
	var ChangePasswordExpiredModal = function ChangePasswordExpiredModal(_ref) {
	    var navigateToLogin = _ref.navigateToLogin,
	        navigateToForgotPassword = _ref.navigateToForgotPassword;
	
	    var actions = [{ text: 'Reset your password again', func: navigateToForgotPassword }];
	
	    return _react2.default.createElement(
	        _FullScreenErrorModal2.default,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'heading' },
	            _react2.default.createElement(
	                'h2',
	                null,
	                'This code has expired.'
	            )
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            'You only have one hour to reset your password after you receive the reset password email.'
	        ),
	        _react2.default.createElement(_ModalActionsList2.default, { actions: actions }),
	        _react2.default.createElement(
	            'div',
	            { className: 'section secondary' },
	            _react2.default.createElement(
	                'div',
	                { className: 'return-to-login' },
	                'Go back to the \xA0',
	                _react2.default.createElement(
	                    'a',
	                    { href: '/login', onClick: navigateToLogin },
	                    'Log in screen'
	                )
	            )
	        )
	    );
	};
	
	ChangePasswordExpiredModal.propTypes = {
	    navigateToLogin: _propTypes2.default.func.isRequired,
	    navigateToForgotPassword: _propTypes2.default.func.isRequired
	};
	
	exports.default = ChangePasswordExpiredModal;

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class; // Lib
	
	
	// Custom Decorators
	
	
	// Components
	
	
	// Constants
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _milanoteForm = __webpack_require__(104);
	
	var _milanoteForm2 = _interopRequireDefault(_milanoteForm);
	
	var _FullScreenModal = __webpack_require__(125);
	
	var _FullScreenModal2 = _interopRequireDefault(_FullScreenModal);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Form = __webpack_require__(138);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormButton = __webpack_require__(60);
	
	var _FormButton2 = _interopRequireDefault(_FormButton);
	
	var _PasswordInput = __webpack_require__(433);
	
	var _PasswordInput2 = _interopRequireDefault(_PasswordInput);
	
	var _FieldValidationMessages = __webpack_require__(122);
	
	var _FieldValidationMessages2 = _interopRequireDefault(_FieldValidationMessages);
	
	var _validationConstants = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChangePasswordInputModal = (_dec = (0, _milanoteForm2.default)({ form: 'changePassword', fieldsConfig: _validationConstants.CHANGE_PASSWORD_FIELDS }), _dec(_class = function (_React$Component) {
	    _inherits(ChangePasswordInputModal, _React$Component);
	
	    function ChangePasswordInputModal() {
	        _classCallCheck(this, ChangePasswordInputModal);
	
	        return _possibleConstructorReturn(this, (ChangePasswordInputModal.__proto__ || Object.getPrototypeOf(ChangePasswordInputModal)).apply(this, arguments));
	    }
	
	    _createClass(ChangePasswordInputModal, [{
	        key: 'componentDidMount',
	
	        /**
	         * Focuses the email input field when the page loads.
	         */
	        value: function componentDidMount() {
	            // this.refs.password.focus();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                submitInterceptor = _props.submitInterceptor,
	                sanitisedErrors = _props.sanitisedErrors,
	                submitting = _props.submitting,
	                showingErrors = _props.showingErrors,
	                navigateToLogin = _props.navigateToLogin;
	
	
	            return _react2.default.createElement(
	                _FullScreenModal2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'logo' },
	                    _react2.default.createElement(_Icon2.default, { name: 'milanote-logo-large' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'heading' },
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        'Please enter a new password'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'section' },
	                    _react2.default.createElement(
	                        _Form2.default,
	                        { className: (0, _classnames2.default)('auth-form form', { submitting: submitting }), onSubmit: submitInterceptor,
	                            noValidate: true },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'form-row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'field-info' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'field-label', htmlFor: 'password' },
	                                    'Password'
	                                ),
	                                _react2.default.createElement(_FieldValidationMessages2.default, { sanitisedError: sanitisedErrors.password })
	                            ),
	                            _react2.default.createElement(_PasswordInput2.default, _extends({}, this.props, { ref: 'password',
	                                name: _validationConstants.CHANGE_PASSWORD_FIELDS.password.name, canShowPassword: true }))
	                        ),
	                        _react2.default.createElement(
	                            _FormButton2.default,
	                            { type: 'submit', className: 'row primary', disabled: submitting || showingErrors },
	                            'Set new password'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'section secondary' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'return-to-login' },
	                        'Go back to the \xA0',
	                        _react2.default.createElement(
	                            'a',
	                            { href: '/login', onClick: navigateToLogin },
	                            'Log in screen'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ChangePasswordInputModal;
	}(_react2.default.Component)) || _class);
	
	
	ChangePasswordInputModal.propTypes = {
	    submitInterceptor: _propTypes2.default.func,
	    navigateToLogin: _propTypes2.default.func,
	    sanitisedErrors: _propTypes2.default.object,
	    submitting: _propTypes2.default.bool,
	    showingErrors: _propTypes2.default.bool
	};
	
	exports.default = ChangePasswordInputModal;

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class; // Lib
	
	
	// Actions
	
	
	// Components
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reselect = __webpack_require__(7);
	
	var _navigationActions = __webpack_require__(27);
	
	var _changePasswordActions = __webpack_require__(1675);
	
	var _ChangePasswordSuccessModal = __webpack_require__(1674);
	
	var _ChangePasswordSuccessModal2 = _interopRequireDefault(_ChangePasswordSuccessModal);
	
	var _ChangePasswordInputModal = __webpack_require__(1672);
	
	var _ChangePasswordInputModal2 = _interopRequireDefault(_ChangePasswordInputModal);
	
	var _ChangePasswordExpiredModal = __webpack_require__(1671);
	
	var _ChangePasswordExpiredModal2 = _interopRequireDefault(_ChangePasswordExpiredModal);
	
	var _GenericErrorModal = __webpack_require__(696);
	
	var _GenericErrorModal2 = _interopRequireDefault(_GenericErrorModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Redux connect methods
	var mapStateToProps = (0, _reselect.createSelector)(function (state) {
	    return state.getIn(['app', 'modal', 'changePassword']);
	}, function (changePasswordModalState) {
	    return changePasswordModalState.toJS();
	});
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        onSubmit: function onSubmit(_ref) {
	            var password = _ref.password;
	            return dispatch((0, _changePasswordActions.passwordChangeSubmitted)({ password: password }));
	        },
	        dispatchPasswordChangeCodeNotFound: function dispatchPasswordChangeCodeNotFound() {
	            return dispatch((0, _changePasswordActions.passwordChangeCodeNotFound)());
	        },
	        dispatchFetchPasswordResetCodeDetails: function dispatchFetchPasswordResetCodeDetails(code) {
	            return dispatch((0, _changePasswordActions.fetchPasswordResetCodeDetails)(code));
	        },
	        dispatchNavigateToLogin: function dispatchNavigateToLogin(event) {
	            event.preventDefault();
	            dispatch((0, _navigationActions.navigateToLogin)());
	        },
	        dispatchNavigateToForgotPassword: function dispatchNavigateToForgotPassword(event) {
	            event.preventDefault();
	            dispatch((0, _navigationActions.navigateToForgotPassword)());
	        }
	    };
	};
	
	var ChangePasswordModal = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_React$Component) {
	    _inherits(ChangePasswordModal, _React$Component);
	
	    function ChangePasswordModal() {
	        _classCallCheck(this, ChangePasswordModal);
	
	        return _possibleConstructorReturn(this, (ChangePasswordModal.__proto__ || Object.getPrototypeOf(ChangePasswordModal)).apply(this, arguments));
	    }
	
	    _createClass(ChangePasswordModal, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                location = _props.location,
	                dispatchFetchPasswordResetCodeDetails = _props.dispatchFetchPasswordResetCodeDetails,
	                dispatchPasswordChangeCodeNotFound = _props.dispatchPasswordChangeCodeNotFound;
	
	
	            if (!location.query || !location.query.code) return dispatchPasswordChangeCodeNotFound();
	
	            var code = location.query.code;
	
	            dispatchFetchPasswordResetCodeDetails(code);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                dispatchNavigateToLogin = _props2.dispatchNavigateToLogin,
	                dispatchNavigateToForgotPassword = _props2.dispatchNavigateToForgotPassword,
	                passwordUpdated = _props2.passwordUpdated,
	                isExpired = _props2.isExpired,
	                isError = _props2.isError,
	                isLoading = _props2.isLoading,
	                error = _props2.error;
	
	
	            if (isLoading) return null;
	
	            if (isError) return _react2.default.createElement(_GenericErrorModal2.default, { error: error, showActions: true });
	
	            if (isExpired) {
	                return _react2.default.createElement(_ChangePasswordExpiredModal2.default, { navigateToLogin: dispatchNavigateToLogin,
	                    navigateToForgotPassword: dispatchNavigateToForgotPassword });
	            }
	
	            return passwordUpdated ? _react2.default.createElement(_ChangePasswordSuccessModal2.default, { navigateToLogin: dispatchNavigateToLogin }) : _react2.default.createElement(_ChangePasswordInputModal2.default, this.props);
	        }
	    }]);
	
	    return ChangePasswordModal;
	}(_react2.default.Component)) || _class);
	exports.default = ChangePasswordModal;
	
	
	ChangePasswordModal.propTypes = {
	    loginSubmit: _propTypes2.default.func,
	    dispatchNavigateToLogin: _propTypes2.default.func,
	    dispatchNavigateToForgotPassword: _propTypes2.default.func,
	    dispatchFetchPasswordResetCodeDetails: _propTypes2.default.func,
	    dispatchPasswordChangeCodeNotFound: _propTypes2.default.func,
	    onSubmit: _propTypes2.default.func,
	    location: _propTypes2.default.object.isRequired,
	    passwordUpdated: _propTypes2.default.bool,
	    isExpired: _propTypes2.default.bool,
	    isError: _propTypes2.default.bool,
	    isLoading: _propTypes2.default.bool,
	    error: _propTypes2.default.object
	};

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FullScreenModal = __webpack_require__(125);
	
	var _FullScreenModal2 = _interopRequireDefault(_FullScreenModal);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	// Lib
	var ChangePasswordSuccessModal = function ChangePasswordSuccessModal(_ref) {
	    var navigateToLogin = _ref.navigateToLogin;
	    return _react2.default.createElement(
	        _FullScreenModal2.default,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'logo' },
	            _react2.default.createElement(_Icon2.default, { name: 'milanote-logo-large' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'heading' },
	            _react2.default.createElement(
	                'h2',
	                { className: 'with-icon' },
	                _react2.default.createElement(_Icon2.default, { name: 'green-tick' }),
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    'Password changed'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'section' },
	            _react2.default.createElement(
	                'p',
	                null,
	                'Your password has been changed.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'You can log in with the new password by following the link below.'
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'section secondary' },
	            _react2.default.createElement(
	                'div',
	                { className: 'return-to-login' },
	                'Go back to the \xA0',
	                _react2.default.createElement(
	                    'a',
	                    { href: '/login', onClick: navigateToLogin },
	                    'Log in screen'
	                )
	            )
	        )
	    );
	};
	
	ChangePasswordSuccessModal.propTypes = {
	    navigateToLogin: _propTypes2.default.func.isRequired
	};
	
	exports.default = ChangePasswordSuccessModal;

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchPasswordResetCodeDetails = exports.passwordChangeSubmitted = exports.passwordChangeCodeNotFound = undefined;
	
	var _httpStatusCodes = __webpack_require__(575);
	
	var _httpStatusCodes2 = _interopRequireDefault(_httpStatusCodes);
	
	var _passwordService = __webpack_require__(672);
	
	var _changePasswordConstants = __webpack_require__(670);
	
	var CHANGE_PASSWORD_ACTION_TYPES = _interopRequireWildcard(_changePasswordConstants);
	
	var _errorConstants = __webpack_require__(243);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Constants
	// Lib
	var passwordChangeFailed = function passwordChangeFailed(error) {
	    return {
	        type: CHANGE_PASSWORD_ACTION_TYPES.PASSWORD_CHANGE_FAILED,
	        error: error
	    };
	};
	
	// Services
	
	
	var passwordChangeCodeExpired = function passwordChangeCodeExpired() {
	    return {
	        type: CHANGE_PASSWORD_ACTION_TYPES.PASSWORD_CHANGE_CODE_EXPIRED
	    };
	};
	
	var passwordChangeCodeNotFound = exports.passwordChangeCodeNotFound = function passwordChangeCodeNotFound() {
	    return passwordChangeFailed({
	        message: 'A code must be provided',
	        description: 'In order to reset a password a code must be provided with the reset link.',
	        code: 'NO_RESET_CODE'
	    });
	};
	
	var passwordChangeCodeInvalid = function passwordChangeCodeInvalid() {
	    return passwordChangeFailed({
	        message: 'The code provided is invalid',
	        description: "There's something wrong with your reset code, please try following " + 'the link within your reset password email again.',
	        code: 'INVALID_RESET_CODE'
	    });
	};
	
	var passwordChangeInitialised = function passwordChangeInitialised(_ref) {
	    var email = _ref.email,
	        code = _ref.code;
	    return {
	        type: CHANGE_PASSWORD_ACTION_TYPES.PASSWORD_CHANGE_INITIALISED,
	        email: email,
	        code: code
	    };
	};
	
	var passwordChanged = function passwordChanged() {
	    return {
	        type: CHANGE_PASSWORD_ACTION_TYPES.PASSWORD_CHANGED
	    };
	};
	
	var passwordChangeSubmitted = exports.passwordChangeSubmitted = function passwordChangeSubmitted(_ref2) {
	    var password = _ref2.password;
	    return function (dispatch, getState) {
	        var state = getState();
	        var email = state.getIn(['app', 'modal', 'changePassword', 'email']);
	        var code = state.getIn(['app', 'modal', 'changePassword', 'code']);
	
	        return (0, _passwordService.changePassword)({ email: email, code: code, password: password }).then(function (res) {
	            return dispatch(passwordChanged());
	        }).catch(function (err) {
	            var status = err.response && err.response.status;
	
	            switch (status) {
	                case _httpStatusCodes2.default.NOT_FOUND:
	                    return dispatch(passwordChangeCodeExpired());
	                case _httpStatusCodes2.default.BAD_REQUEST:
	                    // Allow the password error to display on screen
	                    // On validation errors respond with a structure that the form can react to
	                    if (err.response.data.error && err.response.data.error.code === _errorConstants.RESPONSE_ERROR.VALIDATION_FAILURE && !!err.response.data.error.details.password) {
	                        return Promise.reject(err.response.data.error.details);
	                    }
	
	                    // Otherwise treat it as a generic error
	                    dispatch(passwordChangeFailed({
	                        code: err.response.code || err.response.status
	                    }));
	                    break;
	                default:
	                    dispatch(passwordChangeFailed({
	                        code: err.response ? err.code || err.status : undefined
	                    }));
	            }
	        });
	    };
	};
	
	var fetchPasswordResetCodeDetails = exports.fetchPasswordResetCodeDetails = function fetchPasswordResetCodeDetails(code) {
	    return function (dispatch) {
	        (0, _passwordService.getResetEmail)(code).then(function (email) {
	            return dispatch(passwordChangeInitialised({ email: email, code: code }));
	        }).catch(function (err) {
	            var status = err.response && err.response.status;
	
	            switch (status) {
	                case _httpStatusCodes2.default.NOT_FOUND:
	                    return dispatch(passwordChangeCodeExpired());
	                case _httpStatusCodes2.default.BAD_REQUEST:
	                    return dispatch(passwordChangeCodeInvalid());
	                default:
	                    return dispatch(passwordChangeFailed({
	                        code: err.response ? err.code || err.status : undefined
	                    }));
	            }
	        });
	    };
	};

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _changePasswordConstants = __webpack_require__(670);
	
	var CHANGE_PASSWORD_ACTION_TYPES = _interopRequireWildcard(_changePasswordConstants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Initial state
	// Lib
	var initialState = Immutable.Map({
	    isLoading: true,
	    isError: false,
	    isExpired: false,
	    passwordUpdated: false,
	    email: '',
	    error: null,
	    code: null
	});
	
	// Constants
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case CHANGE_PASSWORD_ACTION_TYPES.PASSWORD_CHANGE_FAILED:
	            return state.set('isLoading', false).set('isError', true).set('error', action.error);
	        case CHANGE_PASSWORD_ACTION_TYPES.PASSWORD_CHANGE_CODE_EXPIRED:
	            return state.set('isLoading', false).set('isExpired', true);
	        case CHANGE_PASSWORD_ACTION_TYPES.PASSWORD_CHANGE_INITIALISED:
	            return state.set('isLoading', false).set('email', action.email).set('code', action.code);
	        case CHANGE_PASSWORD_ACTION_TYPES.PASSWORD_CHANGED:
	            return state.set('passwordUpdated', true);
	        default:
	            return state;
	    }
	};

/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class; // Lib
	
	
	// Custom Decorators
	
	
	// Components
	
	
	// Constants
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _milanoteForm = __webpack_require__(104);
	
	var _milanoteForm2 = _interopRequireDefault(_milanoteForm);
	
	var _FullScreenModal = __webpack_require__(125);
	
	var _FullScreenModal2 = _interopRequireDefault(_FullScreenModal);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Form = __webpack_require__(138);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormButton = __webpack_require__(60);
	
	var _FormButton2 = _interopRequireDefault(_FormButton);
	
	var _FormInput = __webpack_require__(96);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _FieldValidationMessages = __webpack_require__(122);
	
	var _FieldValidationMessages2 = _interopRequireDefault(_FieldValidationMessages);
	
	var _validationConstants = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ForgottenPasswordInputModal = (_dec = (0, _milanoteForm2.default)({ form: 'forgotPassword', fieldsConfig: _validationConstants.REQUEST_PASSWORD_RESET_FIELDS }), _dec(_class = function (_React$Component) {
	    _inherits(ForgottenPasswordInputModal, _React$Component);
	
	    function ForgottenPasswordInputModal() {
	        _classCallCheck(this, ForgottenPasswordInputModal);
	
	        return _possibleConstructorReturn(this, (ForgottenPasswordInputModal.__proto__ || Object.getPrototypeOf(ForgottenPasswordInputModal)).apply(this, arguments));
	    }
	
	    _createClass(ForgottenPasswordInputModal, [{
	        key: 'componentDidMount',
	
	        /**
	         * Focuses the email input field when the page loads.
	         */
	        value: function componentDidMount() {
	            this.refs.email.focus();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                submitInterceptor = _props.submitInterceptor,
	                sanitisedErrors = _props.sanitisedErrors,
	                submitting = _props.submitting,
	                showingErrors = _props.showingErrors;
	
	
	            return _react2.default.createElement(
	                _FullScreenModal2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'logo' },
	                    _react2.default.createElement(_Icon2.default, { name: 'milanote-logo-large' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'heading' },
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        'Reset your password'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'section' },
	                    _react2.default.createElement(
	                        _Form2.default,
	                        { className: (0, _classnames2.default)('auth-form form', { submitting: submitting }), onSubmit: submitInterceptor,
	                            noValidate: true },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'form-row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'field-info' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'field-label', htmlFor: 'email' },
	                                    'Your email'
	                                ),
	                                _react2.default.createElement(_FieldValidationMessages2.default, { sanitisedError: sanitisedErrors.email })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'field-row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'field' },
	                                    _react2.default.createElement(_FormInput2.default, _extends({}, this.props, { ref: 'email',
	                                        name: _validationConstants.REQUEST_PASSWORD_RESET_FIELDS.email.name,
	                                        type: _validationConstants.REQUEST_PASSWORD_RESET_FIELDS.email.type,
	                                        placeholder: 'you@domain.com' }))
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _FormButton2.default,
	                            { type: 'submit', className: 'row primary', disabled: submitting || showingErrors },
	                            'Request reset link'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'section secondary' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'return-to-login' },
	                        'Go back to the \xA0',
	                        _react2.default.createElement(
	                            'a',
	                            { href: '/login', onClick: this.props.navigateToLogin },
	                            'Log in screen'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ForgottenPasswordInputModal;
	}(_react2.default.Component)) || _class);
	
	
	ForgottenPasswordInputModal.propTypes = {
	    submitInterceptor: _propTypes2.default.func,
	    submitFailed: _propTypes2.default.bool,
	    showingErrors: _propTypes2.default.bool,
	    submitting: _propTypes2.default.bool,
	    navigateToLogin: _propTypes2.default.func,
	    onChange: _propTypes2.default.func,
	    sanitisedErrors: _propTypes2.default.object
	};
	
	exports.default = ForgottenPasswordInputModal;

/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reselect = __webpack_require__(7);
	
	var _navigationActions = __webpack_require__(27);
	
	var _forgottenPasswordActions = __webpack_require__(1680);
	
	var _ForgottenPasswordSuccessModal = __webpack_require__(1679);
	
	var _ForgottenPasswordSuccessModal2 = _interopRequireDefault(_ForgottenPasswordSuccessModal);
	
	var _ForgottenPasswordInputModal = __webpack_require__(1677);
	
	var _ForgottenPasswordInputModal2 = _interopRequireDefault(_ForgottenPasswordInputModal);
	
	var _GenericErrorModal = __webpack_require__(696);
	
	var _GenericErrorModal2 = _interopRequireDefault(_GenericErrorModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Redux connect methods
	var mapStateToProps = (0, _reselect.createSelector)(function (state) {
	    return state.getIn(['app', 'modal', 'forgottenPassword']);
	}, function (forgottenPasswordModalState) {
	    return forgottenPasswordModalState.toJS();
	});
	
	// Components
	
	
	// Actions
	// Lib
	
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        onSubmit: function onSubmit(_ref) {
	            var email = _ref.email;
	            return dispatch((0, _forgottenPasswordActions.passwordResetRequestSubmitted)({ email: email }));
	        },
	        dispatchNavigateToLogin: function dispatchNavigateToLogin(event) {
	            event.preventDefault();
	            dispatch((0, _navigationActions.navigateToLogin)());
	        }
	    };
	};
	
	var ForgottenPasswordModal = function ForgottenPasswordModal(props) {
	    var dispatchNavigateToLogin = props.dispatchNavigateToLogin,
	        resetSent = props.resetSent,
	        resetEmail = props.resetEmail,
	        isError = props.isError,
	        error = props.error;
	
	
	    if (isError) return _react2.default.createElement(_GenericErrorModal2.default, { error: error, showActions: true });
	
	    return resetSent ? _react2.default.createElement(_ForgottenPasswordSuccessModal2.default, { email: resetEmail, navigateToLogin: dispatchNavigateToLogin }) : _react2.default.createElement(_ForgottenPasswordInputModal2.default, props);
	};
	
	ForgottenPasswordModal.propTypes = {
	    loginSubmit: _propTypes2.default.func,
	    fields: _propTypes2.default.object,
	    submitInterceptor: _propTypes2.default.func,
	    submitFailed: _propTypes2.default.bool,
	    showingErrors: _propTypes2.default.bool,
	    submitting: _propTypes2.default.bool,
	    dispatchNavigateToLogin: _propTypes2.default.func,
	    onChange: _propTypes2.default.func,
	    sanitisedErrors: _propTypes2.default.object,
	    resetSent: _propTypes2.default.bool,
	    isError: _propTypes2.default.bool,
	    resetEmail: _propTypes2.default.string,
	    error: _propTypes2.default.object
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ForgottenPasswordModal);

/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FullScreenModal = __webpack_require__(125);
	
	var _FullScreenModal2 = _interopRequireDefault(_FullScreenModal);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _stringUtil = __webpack_require__(58);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ForgottenPasswordSuccessModal = function ForgottenPasswordSuccessModal(_ref) {
	    var email = _ref.email,
	        navigateToLogin = _ref.navigateToLogin;
	    return _react2.default.createElement(
	        _FullScreenModal2.default,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'logo' },
	            _react2.default.createElement(_Icon2.default, { name: 'milanote-logo-large' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'heading' },
	            _react2.default.createElement(
	                'h2',
	                { className: 'with-icon' },
	                _react2.default.createElement(_Icon2.default, { name: 'green-tick' }),
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    'Reset link has been sent'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'section' },
	            _react2.default.createElement(
	                'p',
	                null,
	                'An email with your reset password link has been sent to',
	                _stringUtil.SPACE,
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    email
	                ),
	                '.  The link will expire in one hour.'
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'section secondary' },
	            _react2.default.createElement(
	                'div',
	                { className: 'return-to-login' },
	                'Go back to the \xA0',
	                _react2.default.createElement(
	                    'a',
	                    { href: '/login', onClick: navigateToLogin },
	                    'Log in screen'
	                )
	            )
	        )
	    );
	};
	
	// Constants
	
	
	// Components
	// Lib
	
	
	ForgottenPasswordSuccessModal.propTypes = {
	    email: _propTypes2.default.string.isRequired,
	    navigateToLogin: _propTypes2.default.func.isRequired
	};
	
	exports.default = ForgottenPasswordSuccessModal;

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.passwordResetRequestSubmitted = exports.passwordResetRequestFailed = exports.passwordResetRequested = undefined;
	
	var _passwordService = __webpack_require__(672);
	
	var _forgottenPasswordConstants = __webpack_require__(671);
	
	var _errorConstants = __webpack_require__(243);
	
	// Constants
	var passwordResetRequested = exports.passwordResetRequested = function passwordResetRequested(email) {
	    return {
	        type: _forgottenPasswordConstants.PASSWORD_RESET_REQUESTED,
	        email: email
	    };
	}; // Services
	var passwordResetRequestFailed = exports.passwordResetRequestFailed = function passwordResetRequestFailed() {
	    var errorData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return {
	        type: _forgottenPasswordConstants.PASSWORD_RESET_REQUEST_FAILED,
	        error: {
	            code: errorData.code || errorData.status
	        }
	    };
	};
	
	var passwordResetRequestSubmitted = exports.passwordResetRequestSubmitted = function passwordResetRequestSubmitted(_ref) {
	    var email = _ref.email;
	    return function (dispatch) {
	        return (0, _passwordService.reset)(email).then(function (res) {
	            return dispatch(passwordResetRequested(email));
	        }).catch(function (err) {
	            var error = err.response && err.response.data && err.response.data.error;
	
	            // On validation errors respond with a structure that the form can react to
	            if (error && error.code === _errorConstants.RESPONSE_ERROR.VALIDATION_FAILURE) {
	                return Promise.reject(error.details);
	            }
	
	            dispatch(passwordResetRequestFailed(err.response));
	        });
	    };
	};

/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _forgottenPasswordConstants = __webpack_require__(671);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Initial state
	// Lib
	var initialState = Immutable.Map({
	    resetSent: false,
	    resetEmail: '',
	    isError: false,
	    error: null
	});
	
	// Constants
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _forgottenPasswordConstants.PASSWORD_RESET_REQUESTED:
	            return state.set('resetSent', true).set('resetEmail', action.email);
	        case _forgottenPasswordConstants.PASSWORD_RESET_REQUEST_FAILED:
	            return state.set('isError', true).set('error', action.error);
	        default:
	            return state;
	    }
	};

/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class; // Lib
	
	
	// Custom Decorators
	
	
	// Actions
	
	
	// Components
	
	
	// Constants
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouter = __webpack_require__(45);
	
	var _milanoteForm = __webpack_require__(104);
	
	var _milanoteForm2 = _interopRequireDefault(_milanoteForm);
	
	var _authActions = __webpack_require__(421);
	
	var _navigationActions = __webpack_require__(27);
	
	var _FullScreenModal = __webpack_require__(125);
	
	var _FullScreenModal2 = _interopRequireDefault(_FullScreenModal);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _PasswordInput = __webpack_require__(433);
	
	var _PasswordInput2 = _interopRequireDefault(_PasswordInput);
	
	var _Form = __webpack_require__(138);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormButton = __webpack_require__(60);
	
	var _FormButton2 = _interopRequireDefault(_FormButton);
	
	var _FormInput = __webpack_require__(96);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _FieldValidationMessages = __webpack_require__(122);
	
	var _FieldValidationMessages2 = _interopRequireDefault(_FieldValidationMessages);
	
	var _StaticPageLink = __webpack_require__(716);
	
	var _StaticPageLink2 = _interopRequireDefault(_StaticPageLink);
	
	var _PrimaryErrorMessage = __webpack_require__(230);
	
	var _PrimaryErrorMessage2 = _interopRequireDefault(_PrimaryErrorMessage);
	
	var _staticPageConstants = __webpack_require__(442);
	
	var _loginFormConstants = __webpack_require__(291);
	
	__webpack_require__(1123);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        isGuest: state.getIn(['app', 'currentUser', 'isGuest'])
	    };
	};
	
	// Redux connect methods
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        onSubmit: function onSubmit(_ref) {
	            var email = _ref.email,
	                password = _ref.password;
	            return dispatch((0, _authActions.login)(email, password));
	        },
	        navigateToWorkspace: function navigateToWorkspace() {
	            return dispatch((0, _navigationActions.redirectLoggedInUserToWorkspace)());
	        }
	    };
	};
	
	var Login = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec2 = (0, _milanoteForm2.default)({ form: _loginFormConstants.LOGIN_FORM_NAME, fieldsConfig: _loginFormConstants.LOGIN_FORM_FIELDS }), _dec(_class = _dec2(_class = function (_React$Component) {
	    _inherits(Login, _React$Component);
	
	    function Login() {
	        _classCallCheck(this, Login);
	
	        return _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).apply(this, arguments));
	    }
	
	    _createClass(Login, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                isGuest = _props.isGuest,
	                navigateToWorkspace = _props.navigateToWorkspace;
	
	            if (!isGuest) return navigateToWorkspace();
	        }
	
	        /**
	         * Focuses the email input field when the page loads.
	         */
	
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.refs.email.focus();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                submitInterceptor = _props2.submitInterceptor,
	                sanitisedErrors = _props2.sanitisedErrors,
	                submitting = _props2.submitting,
	                showingErrors = _props2.showingErrors,
	                primaryError = _props2.primaryError,
	                dirtySinceSubmission = _props2.dirtySinceSubmission;
	
	
	            return _react2.default.createElement(
	                _FullScreenModal2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'logo' },
	                    _react2.default.createElement(_Icon2.default, { name: 'milanote-logo-large' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'heading' },
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        'Log in to Milanote'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'section' },
	                    _react2.default.createElement(
	                        _Form2.default,
	                        { className: (0, _classnames2.default)('auth-form form', { submitting: submitting }), onSubmit: submitInterceptor,
	                            noValidate: true },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'form-row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'field-info' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'field-label', htmlFor: 'email' },
	                                    'Your email'
	                                ),
	                                _react2.default.createElement(_FieldValidationMessages2.default, { sanitisedError: sanitisedErrors.email })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'field-row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'field' },
	                                    _react2.default.createElement(_FormInput2.default, _extends({}, this.props, { ref: 'email',
	                                        name: _loginFormConstants.LOGIN_FORM_FIELDS.email.name,
	                                        type: _loginFormConstants.LOGIN_FORM_FIELDS.email.type,
	                                        placeholder: 'you@domain.com' }))
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'form-row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'field-info' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'field-label', htmlFor: 'password' },
	                                    'Your password'
	                                ),
	                                _react2.default.createElement(_FieldValidationMessages2.default, { sanitisedError: sanitisedErrors.password })
	                            ),
	                            _react2.default.createElement(_PasswordInput2.default, _extends({}, this.props, {
	                                name: _loginFormConstants.LOGIN_FORM_FIELDS.password.name,
	                                canShowPassword: false }))
	                        ),
	                        _react2.default.createElement(
	                            _FormButton2.default,
	                            { type: 'submit', className: 'row primary', disabled: submitting || showingErrors },
	                            'Log in'
	                        ),
	                        _react2.default.createElement(_PrimaryErrorMessage2.default, { message: primaryError && primaryError.message,
	                            show: !!primaryError && !dirtySinceSubmission && !submitting }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'disclaimer' },
	                            'By using Milanote you are agreeing to our\xA0',
	                            _react2.default.createElement(_StaticPageLink2.default, { config: _staticPageConstants.STATIC_PAGE.termsOfService }),
	                            '\xA0and our\xA0',
	                            _react2.default.createElement(_StaticPageLink2.default, { config: _staticPageConstants.STATIC_PAGE.privacyPolicy })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'section' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'forgotten-password' },
	                        'Forgotten your password?',
	                        ' ',
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/forgotten-password' },
	                            'Reset it'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'section' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'register-instead' },
	                            'Don\'t have an account?',
	                            ' ',
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: '/register' },
	                                'Sign up now'
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Login;
	}(_react2.default.Component)) || _class) || _class);
	exports.default = Login;
	
	
	Login.propTypes = {
	    loginSubmit: _propTypes2.default.func,
	    fields: _propTypes2.default.object,
	    submitInterceptor: _propTypes2.default.func,
	    submitFailed: _propTypes2.default.bool,
	    showingErrors: _propTypes2.default.bool,
	    submitting: _propTypes2.default.bool,
	    navigateToWorkspace: _propTypes2.default.func,
	    onChange: _propTypes2.default.func,
	    sanitisedErrors: _propTypes2.default.object,
	    primaryError: _propTypes2.default.object,
	    dirtySinceSubmission: _propTypes2.default.bool,
	    isGuest: _propTypes2.default.bool
	};

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _formSubReducerWrapper = __webpack_require__(229);
	
	var _formSubReducerWrapper2 = _interopRequireDefault(_formSubReducerWrapper);
	
	var _loginFormConstants = __webpack_require__(291);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Utils
	var loginSubFormReducer = function loginSubFormReducer(state, action) {
	    switch (action.type) {
	        default:
	            return state;
	    }
	};
	
	// Constants
	exports.default = (0, _formSubReducerWrapper2.default)(loginSubFormReducer, _loginFormConstants.LOGIN_FORM_NAME);

/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class; // Lib
	
	
	// Custom Decorators
	
	
	// Actions
	
	
	// Util
	
	
	// Components
	
	
	// Constants
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _milanoteForm = __webpack_require__(104);
	
	var _milanoteForm2 = _interopRequireDefault(_milanoteForm);
	
	var _authActions = __webpack_require__(421);
	
	var _referrerService = __webpack_require__(755);
	
	var _FullScreenMarketingModal = __webpack_require__(1921);
	
	var _FullScreenMarketingModal2 = _interopRequireDefault(_FullScreenMarketingModal);
	
	var _PasswordInput = __webpack_require__(433);
	
	var _PasswordInput2 = _interopRequireDefault(_PasswordInput);
	
	var _Form = __webpack_require__(138);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormButton = __webpack_require__(60);
	
	var _FormButton2 = _interopRequireDefault(_FormButton);
	
	var _FormInput = __webpack_require__(96);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _FieldValidationMessages = __webpack_require__(122);
	
	var _FieldValidationMessages2 = _interopRequireDefault(_FieldValidationMessages);
	
	var _StaticPageLink = __webpack_require__(716);
	
	var _StaticPageLink2 = _interopRequireDefault(_StaticPageLink);
	
	var _PrimaryErrorMessage = __webpack_require__(230);
	
	var _PrimaryErrorMessage2 = _interopRequireDefault(_PrimaryErrorMessage);
	
	var _RegisterHeader = __webpack_require__(1685);
	
	var _RegisterHeader2 = _interopRequireDefault(_RegisterHeader);
	
	__webpack_require__(1124);
	
	var _staticPageConstants = __webpack_require__(442);
	
	var _registerFormConstants = __webpack_require__(292);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getMarketingReferralCode = function getMarketingReferralCode(state) {
	    var query = state.get('routing').locationBeforeTransitions.query;
	
	    return query.r || query.ref;
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        inviteCode: state.get('routing').locationBeforeTransitions.query.invite,
	        marketingReferralCode: getMarketingReferralCode(state)
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        onSubmit: function onSubmit(values) {
	            return dispatch((0, _authActions.register)(values));
	        },
	        fetchInviteInformation: function fetchInviteInformation() {
	            return dispatch((0, _authActions.fetchInvite)());
	        }
	    };
	};
	
	var mapStateToForm = function mapStateToForm(state) {
	    return {
	        initialValues: {
	            inviteCode: state.get('routing').locationBeforeTransitions.query.invite,
	            referrerCode: (0, _referrerService.getReferrer)(),
	            marketingReferralCode: getMarketingReferralCode(state)
	        }
	    };
	};
	
	var Register = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec2 = (0, _milanoteForm2.default)({ form: _registerFormConstants.REGISTER_FORM_NAME, fieldsConfig: _registerFormConstants.REGISTER_FORM_FIELDS }, mapStateToForm), _dec(_class = _dec2(_class = function (_React$Component) {
	    _inherits(Register, _React$Component);
	
	    function Register() {
	        _classCallCheck(this, Register);
	
	        return _possibleConstructorReturn(this, (Register.__proto__ || Object.getPrototypeOf(Register)).apply(this, arguments));
	    }
	
	    _createClass(Register, [{
	        key: 'componentDidMount',
	
	        /**
	         * Focuses the email input field when the page loads.
	         */
	        value: function componentDidMount() {
	            this.refs.givenName.focus();
	
	            if (this.props.inviteCode) this.props.fetchInviteInformation();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                submitInterceptor = _props.submitInterceptor,
	                sanitisedErrors = _props.sanitisedErrors,
	                submitting = _props.submitting,
	                showingErrors = _props.showingErrors,
	                primaryError = _props.primaryError,
	                dirtySinceSubmission = _props.dirtySinceSubmission;
	
	
	            return _react2.default.createElement(
	                _FullScreenMarketingModal2.default,
	                {
	                    className: 'Register',
	                    header: _react2.default.createElement(_RegisterHeader2.default, this.props),
	                    background: __webpack_require__(1353) },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'heading' },
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        'Create your account'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'section' },
	                    _react2.default.createElement(
	                        _Form2.default,
	                        { className: (0, _classnames2.default)('auth-form form', { submitting: submitting }),
	                            onSubmit: submitInterceptor,
	                            noValidate: true },
	                        _react2.default.createElement('input', { id: 'pwd', className: 'fake-password', tabIndex: '-1', 'aria-hidden': 'true', type: 'password',
	                            name: 'fakepasswordremembered' }),
	                        _react2.default.createElement(_FormInput2.default, _extends({}, this.props, { name: _registerFormConstants.REGISTER_FORM_FIELDS.inviteCode.name, type: 'hidden' })),
	                        _react2.default.createElement(_FormInput2.default, _extends({}, this.props, {
	                            name: _registerFormConstants.REGISTER_FORM_FIELDS.marketingReferralCode.name, type: 'hidden' })),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'form-row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'field-info' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'field-label', htmlFor: 'givenName' },
	                                    'Your name'
	                                ),
	                                _react2.default.createElement(_FieldValidationMessages2.default, { sanitisedError: sanitisedErrors.givenName }),
	                                _react2.default.createElement(_FieldValidationMessages2.default, { sanitisedError: sanitisedErrors.familyName })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'field-row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'field' },
	                                    _react2.default.createElement(_FormInput2.default, _extends({}, this.props, { ref: 'givenName',
	                                        name: _registerFormConstants.REGISTER_FORM_FIELDS.givenName.name,
	                                        type: _registerFormConstants.REGISTER_FORM_FIELDS.givenName.type,
	                                        placeholder: 'First name',
	                                        maxLength: _registerFormConstants.REGISTER_FORM_FIELDS.givenName.maxLength }))
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'field' },
	                                    _react2.default.createElement(_FormInput2.default, _extends({}, this.props, { ref: 'familyName',
	                                        name: _registerFormConstants.REGISTER_FORM_FIELDS.familyName.name,
	                                        type: _registerFormConstants.REGISTER_FORM_FIELDS.familyName.type,
	                                        placeholder: 'Last name',
	                                        maxLength: _registerFormConstants.REGISTER_FORM_FIELDS.familyName.maxLength }))
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'form-row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'field-info' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'field-label', htmlFor: 'email' },
	                                    'Your email'
	                                ),
	                                _react2.default.createElement(_FieldValidationMessages2.default, { sanitisedError: sanitisedErrors.email })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'field-row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'field' },
	                                    _react2.default.createElement(_FormInput2.default, _extends({}, this.props, {
	                                        name: _registerFormConstants.REGISTER_FORM_FIELDS.email.name,
	                                        type: _registerFormConstants.REGISTER_FORM_FIELDS.email.type }))
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'form-row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'field-info' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'field-label', htmlFor: 'password' },
	                                    'Choose a password'
	                                ),
	                                _react2.default.createElement(_FieldValidationMessages2.default, { sanitisedError: sanitisedErrors.password })
	                            ),
	                            _react2.default.createElement(_PasswordInput2.default, _extends({}, this.props, {
	                                name: _registerFormConstants.REGISTER_FORM_FIELDS.password.name,
	                                canShowPassword: true }))
	                        ),
	                        _react2.default.createElement(_FieldValidationMessages2.default, { sanitisedError: sanitisedErrors.inviteCode }),
	                        _react2.default.createElement(
	                            _FormButton2.default,
	                            { type: 'submit', className: 'row primary', disabled: submitting || showingErrors },
	                            'Register'
	                        ),
	                        _react2.default.createElement(_PrimaryErrorMessage2.default, { message: primaryError && primaryError.message,
	                            show: !!primaryError && !dirtySinceSubmission && !submitting }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'disclaimer' },
	                            'By proceeding to create your account and use Milanote, you are agreeing to our\xA0',
	                            _react2.default.createElement(_StaticPageLink2.default, { config: _staticPageConstants.STATIC_PAGE.termsOfService }),
	                            '\xA0and our\xA0',
	                            _react2.default.createElement(_StaticPageLink2.default, { config: _staticPageConstants.STATIC_PAGE.privacyPolicy })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Register;
	}(_react2.default.Component)) || _class) || _class);
	exports.default = Register;
	
	
	Register.propTypes = {
	    navigateToStaticPage: _propTypes2.default.func,
	    submitInterceptor: _propTypes2.default.func,
	    submitFailed: _propTypes2.default.bool,
	    submitting: _propTypes2.default.bool,
	    showingErrors: _propTypes2.default.bool,
	    onChange: _propTypes2.default.func,
	    sanitisedErrors: _propTypes2.default.object,
	    inviteCode: _propTypes2.default.string,
	    marketingReferralCode: _propTypes2.default.string,
	    fetchInviteInformation: _propTypes2.default.func,
	    primaryError: _propTypes2.default.object,
	    dirtySinceSubmission: _propTypes2.default.bool
	};

/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(45);
	
	var _AnchorButton = __webpack_require__(423);
	
	var _AnchorButton2 = _interopRequireDefault(_AnchorButton);
	
	var _MilanoteLogotype = __webpack_require__(703);
	
	var _MilanoteLogotype2 = _interopRequireDefault(_MilanoteLogotype);
	
	var _urlConstants = __webpack_require__(326);
	
	__webpack_require__(1125);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RegisterHeader = function RegisterHeader(props) {
	    return _react2.default.createElement(
	        'header',
	        { className: 'RegisterHeader' },
	        _react2.default.createElement(
	            'nav',
	            null,
	            _react2.default.createElement(
	                _AnchorButton2.default,
	                { href: _urlConstants.MARKETING_URL },
	                _react2.default.createElement(_MilanoteLogotype2.default, null)
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'nav-right' },
	                _react2.default.createElement(
	                    _AnchorButton2.default,
	                    { href: _urlConstants.MARKETING_PLANS_URL, className: 'plans-button' },
	                    'View plans'
	                ),
	                _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: '/login', className: 'login-button' },
	                    'Log in'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'title-section' },
	            _react2.default.createElement(
	                'h1',
	                null,
	                'The notes app for creative work'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'For the research, thinking and planning behind your next great piece of work.'
	            )
	        )
	    );
	};
	
	exports.default = RegisterHeader;

/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Utils
	
	
	// Constants
	
	
	var _formSubReducerWrapper = __webpack_require__(229);
	
	var _formSubReducerWrapper2 = _interopRequireDefault(_formSubReducerWrapper);
	
	var _registerFormConstants = __webpack_require__(292);
	
	var _authConstants = __webpack_require__(136);
	
	var AUTH_ACTION_TYPES = _interopRequireWildcard(_authConstants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var registerSubFormReducer = function registerSubFormReducer(state, action) {
	    switch (action.type) {
	        case AUTH_ACTION_TYPES.REGISTER_INVITE_FETCHED:
	            return _extends({}, state, { email: { value: action.email } });
	        default:
	            return state;
	    }
	};
	
	exports.default = (0, _formSubReducerWrapper2.default)(registerSubFormReducer, _registerFormConstants.REGISTER_FORM_NAME);

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class; // Lib
	
	
	// Components
	
	
	// Utils
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(9);
	
	var _Element = __webpack_require__(449);
	
	var _Element2 = _interopRequireDefault(_Element);
	
	var _gridUtils = __webpack_require__(42);
	
	var _elementSelector = __webpack_require__(41);
	
	__webpack_require__(1127);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DISABLE_DRAG_CLASS_NAME = 'disable-drag';
	
	var makeMapStateToProps = function makeMapStateToProps() {
	    return function (state, ownProps) {
	        return {
	            element: (0, _elementSelector.getElement)(state, ownProps)
	        };
	    };
	};
	
	var CanvasElement = (_dec = (0, _reactRedux.connect)(makeMapStateToProps), _dec(_class = function (_React$Component) {
	    _inherits(CanvasElement, _React$Component);
	
	    function CanvasElement() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, CanvasElement);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CanvasElement.__proto__ || Object.getPrototypeOf(CanvasElement)).call.apply(_ref, [this].concat(args))), _this), _this.disableDrag = function () {
	            if (!_this.canvasElementDiv) return;
	            _this.canvasElementDiv.classList.add(DISABLE_DRAG_CLASS_NAME);
	        }, _this.enableDrag = function () {
	            if (!_this.canvasElementDiv) return;
	            _this.canvasElementDiv.classList.remove(DISABLE_DRAG_CLASS_NAME);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(CanvasElement, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                element = _props.element,
	                gridSize = _props.gridSize,
	                sortIndex = _props.sortIndex;
	
	
	            var canvasSize = {
	                x: (0, _gridUtils.gridPointsToPixels)(element.getIn(['location', 'position', 'x']), gridSize),
	                y: (0, _gridUtils.gridPointsToPixels)(element.getIn(['location', 'position', 'y']), gridSize)
	            };
	
	            var style = {
	                top: canvasSize.y + 'px',
	                left: canvasSize.x + 'px',
	                zIndex: sortIndex
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { 'data-element-id': element.get('id'), className: 'CanvasElement', style: style,
	                    ref: function ref(c) {
	                        _this2.canvasElementDiv = c;
	                    } },
	                _react2.default.createElement(_Element2.default, _extends({}, this.props, { disableDrag: this.disableDrag, enableDrag: this.enableDrag }))
	            );
	        }
	    }]);
	
	    return CanvasElement;
	}(_react2.default.Component)) || _class);
	
	
	CanvasElement.propTypes = {
	    elementId: _propTypes2.default.string.isRequired,
	    element: _propTypes2.default.object,
	    gridSize: _propTypes2.default.number.isRequired,
	    connectDragSource: _propTypes2.default.func,
	    onDrop: _propTypes2.default.func,
	    isDragging: _propTypes2.default.bool,
	    sortIndex: _propTypes2.default.number
	};
	
	// Wrap the canvas element so it can be used in the document mode calculations
	exports.default = (0, _recompose.pure)(CanvasElement);

/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _fp = __webpack_require__(52);
	
	var _recompose = __webpack_require__(9);
	
	var _canvasUtil = __webpack_require__(422);
	
	var _analytics = __webpack_require__(47);
	
	var omitProps = (0, _recompose.compose)(_recompose.mapProps, _fp.omit);
	
	var shortcutElementHandlers = {
	    handleDoubleClick: function handleDoubleClick(_ref) {
	        var canvasNode = _ref.canvasNode,
	            createShortcutCard = _ref.createShortcutCard,
	            gridSize = _ref.gridSize,
	            currentBoardId = _ref.currentBoardId,
	            isEditable = _ref.isEditable;
	        return function (event) {
	            if (!canvasNode || !isEditable) return;
	
	            var canvasPositionPx = {
	                x: event.clientX,
	                y: event.clientY - 1
	            };
	
	            var _getCanvasLocation = (0, _canvasUtil.getCanvasLocation)(canvasNode, canvasPositionPx, gridSize, currentBoardId),
	                location = _getCanvasLocation.location;
	
	            createShortcutCard({ location: location });
	
	            (0, _analytics.analyticsEvent)('created-card-doubleclick');
	        };
	    }
	};
	
	var shortcutElementDecorator = (0, _recompose.compose)((0, _recompose.withState)('canvasNode', 'setShortcutHandlerCanvasNode', null), (0, _recompose.withHandlers)(shortcutElementHandlers), omitProps(['canvasNode']));
	
	exports.default = shortcutElementDecorator;

/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _measurementsConnect = __webpack_require__(123);
	
	var _measurementsConnect2 = _interopRequireDefault(_measurementsConnect);
	
	var _measurementsSelector = __webpack_require__(124);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	// Utils
	
	
	var SIZE_PADDING = 250;
	var EMPTY_SIZE = { width: 0, height: 0 };
	
	var mapMeasurementsStateToProps = function mapMeasurementsStateToProps(state) {
	    return {
	        measurements: (0, _measurementsSelector.getMeasurementsMap)(state)
	    };
	};
	
	exports.default = function (DecoratedComponent) {
	    var _dec, _class;
	
	    var canvasSizeDecorator = (_dec = (0, _measurementsConnect2.default)(mapMeasurementsStateToProps), _dec(_class = function (_React$Component) {
	        _inherits(canvasSizeDecorator, _React$Component);
	
	        function canvasSizeDecorator(props) {
	            _classCallCheck(this, canvasSizeDecorator);
	
	            var _this = _possibleConstructorReturn(this, (canvasSizeDecorator.__proto__ || Object.getPrototypeOf(canvasSizeDecorator)).call(this, props));
	
	            _this.resetCanvasSize = function () {
	                _this.canvasSize = EMPTY_SIZE;
	            };
	
	            _this.calculateCanvasSize = function (nextProps) {
	                var canvasElementIds = nextProps.canvasElementIds,
	                    measurements = nextProps.measurements;
	
	
	                var newCanvasSize = measurements.reduce(function (size, measurement, id) {
	                    if (!(0, _lodash.includes)(canvasElementIds, id)) return size;
	
	                    size.width = Math.max(size.width, measurement.get('right'));
	                    size.height = Math.max(size.height, measurement.get('bottom'));
	                    return size;
	                }, { width: 0, height: 0 });
	
	                var sizePixels = {
	                    width: Math.max(_this.canvasSize.width, newCanvasSize.width + SIZE_PADDING),
	                    height: Math.max(_this.canvasSize.height, newCanvasSize.height + SIZE_PADDING)
	                };
	
	                _this.canvasSize = sizePixels;
	                _this.setState({ canvasSize: sizePixels });
	            };
	
	            _this.debouncedCalculateCanvasSize = (0, _lodash.debounce)(_this.calculateCanvasSize, 64);
	
	
	            _this.canvasSize = EMPTY_SIZE;
	            _this.state = {
	                canvasSize: EMPTY_SIZE
	            };
	            return _this;
	        }
	
	        _createClass(canvasSizeDecorator, [{
	            key: 'componentWillReceiveProps',
	            value: function componentWillReceiveProps(nextProps) {
	                var measurements = nextProps.measurements,
	                    currentBoardId = nextProps.currentBoardId;
	
	
	                if (currentBoardId !== this.props.currentBoardId) this.resetCanvasSize();
	
	                if (measurements === this.props.measurements) return;
	
	                this.debouncedCalculateCanvasSize(nextProps);
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                var canvasSize = this.state.canvasSize;
	
	                var _props = this.props,
	                    measurements = _props.measurements,
	                    rest = _objectWithoutProperties(_props, ['measurements']); // eslint-disable-line no-unused-vars
	
	                return _react2.default.createElement(DecoratedComponent, _extends({ canvasSize: canvasSize }, rest));
	            }
	        }]);
	
	        return canvasSizeDecorator;
	    }(_react2.default.Component)) || _class);
	
	
	    canvasSizeDecorator.propTypes = {
	        canvasElementIds: _propTypes2.default.array,
	        measurements: _propTypes2.default.object,
	        currentBoardId: _propTypes2.default.string
	    };
	
	    return canvasSizeDecorator;
	};

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class; // Lib
	
	
	// Utils
	
	
	// Components
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDnd = __webpack_require__(72);
	
	var _dragLayerUtil = __webpack_require__(674);
	
	var _LineDragLayer = __webpack_require__(1691);
	
	var _LineDragLayer2 = _interopRequireDefault(_LineDragLayer);
	
	__webpack_require__(1128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var workspaceDragLayerConnect = function workspaceDragLayerConnect(monitor) {
	    return {
	        isDragging: monitor.isDragging(),
	        itemType: monitor.getItemType(),
	        item: monitor.getItem()
	    };
	};
	
	var CanvasDragLayer = (_dec = (0, _reactDnd.DragLayer)(workspaceDragLayerConnect), _dec(_class = function (_React$Component) {
	    _inherits(CanvasDragLayer, _React$Component);
	
	    function CanvasDragLayer() {
	        _classCallCheck(this, CanvasDragLayer);
	
	        return _possibleConstructorReturn(this, (CanvasDragLayer.__proto__ || Object.getPrototypeOf(CanvasDragLayer)).apply(this, arguments));
	    }
	
	    _createClass(CanvasDragLayer, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                isDragging = _props.isDragging,
	                itemType = _props.itemType,
	                item = _props.item;
	
	
	            if (!(isDragging && (0, _dragLayerUtil.isLineAffectedByDrag)(item, itemType))) return null;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'CanvasDragLayer' },
	                _react2.default.createElement(_LineDragLayer2.default, null)
	            );
	        }
	    }]);
	
	    return CanvasDragLayer;
	}(_react2.default.Component)) || _class);
	
	
	CanvasDragLayer.propTypes = {
	    currentBoardId: _propTypes2.default.string.isRequired,
	    isDragging: _propTypes2.default.bool,
	    itemType: _propTypes2.default.string,
	    item: _propTypes2.default.object
	};
	
	exports.default = CanvasDragLayer;

/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class; // Lib
	
	
	// Utils
	
	
	// Components
	
	
	// Selector
	
	
	// Constants
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDnd = __webpack_require__(72);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(4);
	
	var _memoizeOne = __webpack_require__(1444);
	
	var _memoizeOne2 = _interopRequireDefault(_memoizeOne);
	
	var _dragLayerUtil = __webpack_require__(674);
	
	var _renderThrottleDecorator = __webpack_require__(763);
	
	var _renderThrottleDecorator2 = _interopRequireDefault(_renderThrottleDecorator);
	
	var _LineDragPreview = __webpack_require__(1992);
	
	var _LineDragPreview2 = _interopRequireDefault(_LineDragPreview);
	
	var _LineControlPointDragPreview = __webpack_require__(1991);
	
	var _LineControlPointDragPreview2 = _interopRequireDefault(_LineControlPointDragPreview);
	
	var _ConnectedLineDragPreview = __webpack_require__(1989);
	
	var _ConnectedLineDragPreview2 = _interopRequireDefault(_ConnectedLineDragPreview);
	
	var _ElementPositioner = __webpack_require__(1947);
	
	var _ElementPositioner2 = _interopRequireDefault(_ElementPositioner);
	
	var _gridSizeSelector = __webpack_require__(66);
	
	var _dragModifierKeysSelector = __webpack_require__(759);
	
	var _dragModifierKeysConstants = __webpack_require__(172);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ORIGIN = { x: 0, y: 0 };
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        gridSize: (0, _gridSizeSelector.getGridSize)(state)
	    };
	};
	
	var lineDragLayerCollect = function lineDragLayerCollect(monitor) {
	    return {
	        itemType: monitor.getItemType(),
	        item: monitor.getItem(),
	        offsetDiff: monitor.getDifferenceFromInitialOffset()
	    };
	};
	
	var DraggedLineControlPointPreview = function DraggedLineControlPointPreview(_ref) {
	    var item = _ref.item,
	        offsetDiff = _ref.offsetDiff,
	        gridSize = _ref.gridSize;
	    return _react2.default.createElement(
	        _ElementPositioner2.default,
	        { elementId: item.id },
	        _react2.default.createElement(_LineControlPointDragPreview2.default, { elementId: item.id, offsetDiff: offsetDiff, pos: item.pos, gridSize: gridSize })
	    );
	};
	
	var mapStateToDraggedLineEdgePreviewProps = function mapStateToDraggedLineEdgePreviewProps(state) {
	    return {
	        shouldSnapToAngle: (0, _dragModifierKeysSelector.getDragModifierKeys)(state).get(_dragModifierKeysConstants.MODIFIER_KEYS.shiftKey)
	    };
	};
	var DraggedLineEdgePreview = function DraggedLineEdgePreview(_ref2) {
	    var item = _ref2.item,
	        offsetDiff = _ref2.offsetDiff,
	        gridSize = _ref2.gridSize,
	        shouldSnapToAngle = _ref2.shouldSnapToAngle;
	    return _react2.default.createElement(
	        _ElementPositioner2.default,
	        { elementId: item.id },
	        _react2.default.createElement(_LineDragPreview2.default, { elementId: item.id, draggedEdge: item.edge, offsetDiff: offsetDiff, pos: item.pos,
	            shouldSnapToAngle: shouldSnapToAngle, gridSize: gridSize })
	    );
	};
	DraggedLineEdgePreview = (0, _reactRedux.connect)(mapStateToDraggedLineEdgePreviewProps)(DraggedLineEdgePreview);
	
	/**
	 * memoizeOne memoizes only the last invocation of the method, thus ensuring the memoize cache doesn't grow out of
	 * control.
	 */
	var getNotDraggedConnectedElementIds = (0, _memoizeOne2.default)(function (connectingElementIds, draggedElementIds) {
	    return (0, _lodash.difference)(connectingElementIds, draggedElementIds);
	});
	
	var mapStateToDraggedConnectedElementProps = function mapStateToDraggedConnectedElementProps(state) {
	    return {
	        copyDrag: (0, _dragModifierKeysSelector.getDragModifierKeys)(state).get(_dragModifierKeysConstants.MODIFIER_KEYS.altKey)
	    };
	};
	var DraggedConnectedElement = function DraggedConnectedElement(_ref3) {
	    var item = _ref3.item,
	        offsetDiff = _ref3.offsetDiff,
	        gridSize = _ref3.gridSize,
	        copyDrag = _ref3.copyDrag;
	
	    // FIXME Hack to keep lines in place when the altKey is pressed (as the element is being copied, not moved)
	    // This should probably be moved into the dnd library somehow
	    var offset = copyDrag ? ORIGIN : offsetDiff;
	
	    // If a connected element is also selected then it will also be dragged so shouldn't be included in the connected
	    // element drag preview (but instead in the selected element drag preview).
	    var notDraggedConnectedElementIds = getNotDraggedConnectedElementIds(item.connectingElementIds, item.draggedElementIds);
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        notDraggedConnectedElementIds.map(function (connectingElementId) {
	            return _react2.default.createElement(
	                _ElementPositioner2.default,
	                { key: connectingElementId, elementId: connectingElementId },
	                _react2.default.createElement(_ConnectedLineDragPreview2.default, { elementId: connectingElementId, draggedElementIds: item.draggedElementIds,
	                    offsetDiff: offset, gridSize: gridSize })
	            );
	        })
	    );
	};
	DraggedConnectedElement = (0, _reactRedux.connect)(mapStateToDraggedConnectedElementProps)(DraggedConnectedElement);
	
	var LineDragLayer = (_dec = (0, _reactDnd.DragLayer)(lineDragLayerCollect), _dec2 = (0, _reactRedux.connect)(mapStateToProps), _dec(_class = (0, _renderThrottleDecorator2.default)(_class = _dec2(_class = function (_React$Component) {
	    _inherits(LineDragLayer, _React$Component);
	
	    function LineDragLayer() {
	        _classCallCheck(this, LineDragLayer);
	
	        return _possibleConstructorReturn(this, (LineDragLayer.__proto__ || Object.getPrototypeOf(LineDragLayer)).apply(this, arguments));
	    }
	
	    _createClass(LineDragLayer, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            return (0, _dragLayerUtil.isLineAffectedByDrag)(nextProps.item, nextProps.itemType) || (0, _dragLayerUtil.isLineAffectedByDrag)(this.props.item, this.props.itemType);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                item = _props.item,
	                itemType = _props.itemType,
	                offsetDiff = _props.offsetDiff;
	
	            if (!(offsetDiff && (0, _dragLayerUtil.isLineAffectedByDrag)(item, itemType))) return null;
	
	            var content = null;
	            if ((0, _dragLayerUtil.isDraggingLineEdge)(itemType)) {
	                content = _react2.default.createElement(DraggedLineEdgePreview, this.props);
	            } else if ((0, _dragLayerUtil.isDraggingLineControlPoint)(itemType)) {
	                content = _react2.default.createElement(DraggedLineControlPointPreview, this.props);
	            } else {
	                content = _react2.default.createElement(DraggedConnectedElement, this.props);
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'LineDragLayer' },
	                content
	            );
	        }
	    }]);
	
	    return LineDragLayer;
	}(_react2.default.Component)) || _class) || _class) || _class);
	
	
	DraggedLineControlPointPreview.propTypes = DraggedLineEdgePreview.propTypes = DraggedConnectedElement.propTypes = LineDragLayer.propTypes = {
	    item: _propTypes2.default.object,
	    itemType: _propTypes2.default.string,
	    gridSize: _propTypes2.default.number,
	    offsetDiff: _propTypes2.default.object
	};
	
	exports.default = LineDragLayer;

/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	// Utils
	
	
	var _reactDndHtml5Backend = __webpack_require__(220);
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ElementDropTarget = __webpack_require__(168);
	
	var _ElementDropTarget2 = _interopRequireDefault(_ElementDropTarget);
	
	var _fileValidator = __webpack_require__(238);
	
	var _dragAndDropUtils = __webpack_require__(145);
	
	var _canvasUtil = __webpack_require__(422);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// When dropping file onto the canvas, offset the drop position by 60 pixels, just to make it feel a little nicer
	var FILE_DROP_OFFSET = -60;
	var FILE_DROP_EACH_OFFSET = 30;
	
	var NATIVE_TYPES = [_reactDndHtml5Backend.NativeTypes.FILE, _reactDndHtml5Backend.NativeTypes.URL, _reactDndHtml5Backend.NativeTypes.TEXT];
	
	var getNativeDropLocation = function getNativeDropLocation(props, monitor, component) {
	    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	    var gridSize = props.gridSize,
	        currentBoardId = props.currentBoardId;
	
	
	    var domComponent = _reactDom2.default.findDOMNode(component);
	    var dropPosition = {
	        x: monitor.getClientOffset().x + FILE_DROP_OFFSET + FILE_DROP_EACH_OFFSET * i,
	        y: monitor.getClientOffset().y + FILE_DROP_OFFSET + FILE_DROP_EACH_OFFSET * i
	    };
	
	    return (0, _canvasUtil.getCanvasLocation)(domComponent, dropPosition, gridSize, currentBoardId);
	};
	
	// text dropping functionality
	var handleTextDrop = function handleTextDrop(props, monitor, component) {
	    var createShortcutCard = props.createShortcutCard,
	        isEditable = props.isEditable,
	        currentBoardId = props.currentBoardId;
	
	    var _monitor$getItem = monitor.getItem(),
	        text = _monitor$getItem.text;
	
	    if (!isEditable) return;
	
	    var _getNativeDropLocatio = getNativeDropLocation(props, monitor, component),
	        location = _getNativeDropLocatio.location;
	
	    createShortcutCard({ location: location, text: text, currentBoardId: currentBoardId });
	};
	
	// file dropping functionality
	var handleFileDrop = function handleFileDrop(props, monitor, component) {
	    var createShortcutImage = props.createShortcutImage,
	        isEditable = props.isEditable,
	        currentBoardId = props.currentBoardId,
	        dispatchErrorUploadingElementAttachment = props.dispatchErrorUploadingElementAttachment;
	
	    var _monitor$getItem2 = monitor.getItem(),
	        files = _monitor$getItem2.files;
	
	    if (!isEditable) return;
	
	    files.forEach(function (file, i) {
	        // TODO Should do some type detection here
	        var validationErrors = (0, _fileValidator.validateImageFile)(file);
	
	        var _getNativeDropLocatio2 = getNativeDropLocation(props, monitor, component, i),
	            location = _getNativeDropLocatio2.location;
	
	        // TODO This is very similar to the ImageContainer. Possibly share the code?
	
	
	        if (validationErrors) {
	            // Create the empty element to show the error in
	            var elementId = createShortcutImage({
	                location: location,
	                currentBoardId: currentBoardId
	            });
	
	            dispatchErrorUploadingElementAttachment({
	                id: elementId,
	                error: validationErrors
	            });
	            return;
	        }
	
	        createShortcutImage({ location: location, file: file, currentBoardId: currentBoardId });
	    });
	};
	
	// url dropping functionality
	var handleUrlDrop = function handleUrlDrop(props, monitor, component) {
	    var createShortcutLink = props.createShortcutLink,
	        isEditable = props.isEditable,
	        currentBoardId = props.currentBoardId,
	        deselectAll = props.deselectAll;
	
	    var _monitor$getItem3 = monitor.getItem(),
	        urls = _monitor$getItem3.urls;
	
	    if (!isEditable) return;
	
	    urls.forEach(function (url, i) {
	        var _getNativeDropLocatio3 = getNativeDropLocation(props, monitor, component, i),
	            location = _getNativeDropLocatio3.location;
	
	        createShortcutLink({ location: location, url: url, currentBoardId: currentBoardId });
	        deselectAll();
	    });
	};
	
	// Drop Target functionality.
	var dropLocationFn = function dropLocationFn(props, monitor, component) {
	    if ((0, _dragAndDropUtils.dropTargetAlreadyHandled)(monitor, component)) return;
	
	    // Don't handle the drop if it's already been handled by something else on the canvas.
	    if (monitor.didDrop()) return;
	
	    if (monitor.getItemType() === _reactDndHtml5Backend.NativeTypes.TEXT) return handleTextDrop(props, monitor, component);
	    if (monitor.getItemType() === _reactDndHtml5Backend.NativeTypes.FILE) return handleFileDrop(props, monitor, component);
	    if (monitor.getItemType() === _reactDndHtml5Backend.NativeTypes.URL) return handleUrlDrop(props, monitor, component);
	
	    var gridSize = props.gridSize,
	        currentBoardId = props.currentBoardId;
	
	    var domComponent = _reactDom2.default.findDOMNode(component);
	
	    var item = monitor.getItem();
	    var dropPosition = (0, _dragAndDropUtils.getElementDropPosition)({
	        item: item,
	        sourceClientOffset: monitor.getSourceClientOffset(),
	        clientOffset: monitor.getClientOffset(),
	        gridSize: gridSize
	    });
	
	    var canvasLocation = (0, _canvasUtil.getCanvasLocation)(domComponent, dropPosition, gridSize, currentBoardId);
	    return _extends({}, canvasLocation, {
	        // The canvas accepts all elements
	        acceptedElementIds: item.draggedElementIds
	    });
	};
	
	var canvasDropCollect = function canvasDropCollect(connector) {
	    return {
	        connectDropTarget: connector.dropTarget()
	    };
	};
	
	exports.default = (0, _ElementDropTarget2.default)({ drop: dropLocationFn, acceptDropTypes: NATIVE_TYPES }, null, canvasDropCollect);

/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _keyConstants = __webpack_require__(146);
	
	var _rafThrottle = __webpack_require__(245);
	
	var _rafThrottle2 = _interopRequireDefault(_rafThrottle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	// Constants
	
	
	exports.default = function (DecoratedComponent) {
	    var grabScrollDecorator = function (_React$Component) {
	        _inherits(grabScrollDecorator, _React$Component);
	
	        function grabScrollDecorator(props) {
	            _classCallCheck(this, grabScrollDecorator);
	
	            var _this = _possibleConstructorReturn(this, (grabScrollDecorator.__proto__ || Object.getPrototypeOf(grabScrollDecorator)).call(this, props));
	
	            _this.onKeyDown = function (event) {
	                var grabEnabled = _this.state.grabEnabled;
	
	                // If the event
	
	                if (event.keyCode === _keyConstants.KEY_CODES.SPACEBAR && event.target === window.document.body) {
	                    // TODO Try to prevent the cursor from hiding when the space bar is pressed
	                    event.preventDefault();
	                    event.stopPropagation();
	
	                    if (!grabEnabled) {
	                        _this.setState({ grabEnabled: true });
	                        document.addEventListener('mousedown', _this.bodyMousedown);
	                    }
	                }
	            };
	
	            _this.onKeyUp = function (event) {
	                var grabEnabled = _this.state.grabEnabled;
	
	
	                if (event.keyCode === _keyConstants.KEY_CODES.SPACEBAR && grabEnabled) {
	                    _this.setState({ grabEnabled: false, grabbing: false });
	                    _this.rafBodyMousemove.cancel();
	                    document.removeEventListener('mousedown', _this.bodyMousedown);
	                    document.removeEventListener('mousemove', _this.rafBodyMousemove);
	                    document.removeEventListener('mouseup', _this.bodyMouseup);
	                }
	            };
	
	            _this.bodyMousedown = function (event) {
	                _this.canvas = _reactDom2.default.findDOMNode(_this);
	                _this.mouseX = event.pageX;
	                _this.mouseY = event.pageY;
	                _this.setState({ grabbing: true });
	
	                document.addEventListener('mouseup', _this.bodyMouseup);
	                document.addEventListener('mousemove', _this.rafBodyMousemove);
	                event.preventDefault();
	                event.stopPropagation();
	            };
	
	            _this.bodyMousemove = function (event) {
	                _this.canvas.scrollLeft = Math.max((_this.canvas.scrollLeft || 0) + (_this.mouseX - event.pageX), 0);
	                _this.canvas.scrollTop = Math.max((_this.canvas.scrollTop || 0) + (_this.mouseY - event.pageY), 0);
	
	                _this.mouseX = event.pageX;
	                _this.mouseY = event.pageY;
	                event.preventDefault();
	                event.stopPropagation();
	            };
	
	            _this.rafBodyMousemove = (0, _rafThrottle2.default)(_this.bodyMousemove);
	
	            _this.bodyMouseup = function () {
	                _this.setState({ grabbing: false });
	                _this.rafBodyMousemove.cancel();
	                document.removeEventListener('mousemove', _this.rafBodyMousemove);
	                document.removeEventListener('mouseup', _this.bodyMouseup);
	                event.preventDefault();
	                event.stopPropagation();
	            };
	
	            _this.state = {
	                grabEnabled: false,
	                grabbing: false
	            };
	
	            _this.mouseX = 0;
	            _this.mouseY = 0;
	            return _this;
	        }
	
	        _createClass(grabScrollDecorator, [{
	            key: 'componentDidMount',
	            value: function componentDidMount() {
	                document.addEventListener('keydown', this.onKeyDown);
	                document.addEventListener('keyup', this.onKeyUp);
	            }
	        }, {
	            key: 'componentWillUnmount',
	            value: function componentWillUnmount() {
	                document.removeEventListener('keydown', this.onKeyDown);
	                document.removeEventListener('keyup', this.onKeyUp);
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                var _state = this.state,
	                    grabEnabled = _state.grabEnabled,
	                    grabbing = _state.grabbing;
	
	
	                return _react2.default.createElement(DecoratedComponent, _extends({ grabEnabled: grabEnabled, grabbing: grabbing }, this.props));
	            }
	        }]);
	
	        return grabScrollDecorator;
	    }(_react2.default.Component);
	
	    grabScrollDecorator.propTypes = {};
	
	    return grabScrollDecorator;
	};

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class; // Lib
	
	
	// Components
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _selectionMarqueeStateDecorator = __webpack_require__(1698);
	
	var _selectionMarqueeStateDecorator2 = _interopRequireDefault(_selectionMarqueeStateDecorator);
	
	var _selectionMarqueeMouseEventHandlerDecorator = __webpack_require__(1696);
	
	var _selectionMarqueeMouseEventHandlerDecorator2 = _interopRequireDefault(_selectionMarqueeMouseEventHandlerDecorator);
	
	var _selectionMarqueeSelectedElementFinderDecorator = __webpack_require__(1697);
	
	var _selectionMarqueeSelectedElementFinderDecorator2 = _interopRequireDefault(_selectionMarqueeSelectedElementFinderDecorator);
	
	__webpack_require__(1129);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SelectionMarquee = (0, _selectionMarqueeStateDecorator2.default)(_class = (0, _selectionMarqueeSelectedElementFinderDecorator2.default)(_class = (0, _selectionMarqueeMouseEventHandlerDecorator2.default)(_class = function (_React$Component) {
	    _inherits(SelectionMarquee, _React$Component);
	
	    function SelectionMarquee() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, SelectionMarquee);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SelectionMarquee.__proto__ || Object.getPrototypeOf(SelectionMarquee)).call.apply(_ref, [this].concat(args))), _this), _this.getMarqueePositionStyle = function () {
	            var _this$props = _this.props,
	                top = _this$props.top,
	                left = _this$props.left,
	                width = _this$props.width,
	                height = _this$props.height;
	
	            return { top: top, left: left, width: width, height: height };
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(SelectionMarquee, [{
	        key: 'render',
	        value: function render() {
	            if (!this.props.active) return null;
	            return _react2.default.createElement('div', { className: 'SelectionMarquee', style: this.getMarqueePositionStyle() });
	        }
	    }]);
	
	    return SelectionMarquee;
	}(_react2.default.Component)) || _class) || _class) || _class;
	
	SelectionMarquee.propTypes = {
	    active: _propTypes2.default.bool,
	    top: _propTypes2.default.number,
	    left: _propTypes2.default.number,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number
	};
	
	exports.default = SelectionMarquee;

/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _recompose = __webpack_require__(9);
	
	exports.default = (0, _recompose.withState)('selectionMarqueeActive', 'setSelectionMarqueeActive', false); // Lib

/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _rafThrottle = __webpack_require__(245);
	
	var _rafThrottle2 = _interopRequireDefault(_rafThrottle);
	
	var _selectionUtils = __webpack_require__(458);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/sort-comp */
	// Lib
	
	
	// Utils
	
	
	/**
	 * Attaches the DOM event listeners and invokes the state update methods as appropriate based on mouse moves.
	 */
	exports.default = function (DecoratedComponent) {
	    var SelectionMarqueeEventHandler = function (_React$Component) {
	        _inherits(SelectionMarqueeEventHandler, _React$Component);
	
	        function SelectionMarqueeEventHandler(props) {
	            _classCallCheck(this, SelectionMarqueeEventHandler);
	
	            var _this = _possibleConstructorReturn(this, (SelectionMarqueeEventHandler.__proto__ || Object.getPrototypeOf(SelectionMarqueeEventHandler)).call(this, props));
	
	            _initialiseProps.call(_this);
	
	            _this.eventsAttached = false;
	            return _this;
	        }
	
	        _createClass(SelectionMarqueeEventHandler, [{
	            key: 'componentWillMount',
	            value: function componentWillMount() {
	                this.attachMarqueeSelectionStartListener(this.props);
	            }
	        }, {
	            key: 'componentDidMount',
	            value: function componentDidMount() {
	                this.attachMarqueeSelectionStartListener(this.props);
	            }
	        }, {
	            key: 'componentWillReceiveProps',
	            value: function componentWillReceiveProps(nextProps) {
	                this.attachMarqueeSelectionStartListener(nextProps);
	            }
	        }, {
	            key: 'componentWillUnmount',
	            value: function componentWillUnmount() {
	                this.removeEventListeners();
	            } // eslint-disable-line react/sort-comp
	
	        }, {
	            key: 'render',
	            value: function render() {
	                return _react2.default.createElement(DecoratedComponent, this.props);
	            }
	        }]);
	
	        return SelectionMarqueeEventHandler;
	    }(_react2.default.Component);
	
	    var _initialiseProps = function _initialiseProps() {
	        var _this2 = this;
	
	        this.attachMarqueeSelectionStartListener = function (props) {
	            if (!props.eventListenerNode || _this2.eventsAttached) return;
	
	            _this2.eventsAttached = true;
	
	            props.eventListenerNode.addEventListener('mousedown', _this2.onMouseDown);
	        };
	
	        this.removeMarqueeSelectionStartListener = function () {
	            _this2.props.eventListenerNode.removeEventListener('mousedown', _this2.onMouseDown);
	        };
	
	        this.attachMarqueeSelectionMoveListeners = function () {
	            document.addEventListener('mousemove', _this2.throttledMouseMove);
	            document.addEventListener('mouseup', _this2.onMouseUp);
	        };
	
	        this.removeMarqueeSelectionMoveListeners = function () {
	            document.removeEventListener('mousemove', _this2.throttledMouseMove);
	            document.removeEventListener('mouseup', _this2.onMouseUp);
	        };
	
	        this.removeEventListeners = function () {
	            if (!_this2.props.eventListenerNode) return;
	            _this2.eventsAttached = false;
	
	            _this2.removeMarqueeSelectionStartListener();
	            _this2.removeMarqueeSelectionMoveListeners();
	        };
	
	        this.onMouseDown = function (event) {
	            var _props = _this2.props,
	                startMarqueeSelect = _props.startMarqueeSelect,
	                eventListenerNode = _props.eventListenerNode;
	
	
	            if (event.target !== eventListenerNode || event.button !== 0) return;
	
	            // Set focus to the document body so that keyboard shortcuts can be used again after interacting
	            // with an iFrame
	            window.focus();
	            if (document.activeElement) document.activeElement.blur();
	
	            event.preventDefault();
	            _this2.attachMarqueeSelectionMoveListeners();
	
	            var appendMode = (0, _selectionUtils.isAttemptingMultiSelect)(event);
	            startMarqueeSelect(_extends({}, _this2.getPositionFromMouseEvent(event), { appendMode: appendMode }));
	        };
	
	        this.onMouseMove = function (event) {
	            _this2.props.dragMarqueeSelectionTo(_this2.getPositionFromMouseEvent(event));
	        };
	
	        this.throttledMouseMove = (0, _rafThrottle2.default)(this.onMouseMove);
	
	        this.onMouseUp = function (event) {
	            _this2.throttledMouseMove.cancel();
	            _this2.props.finishMarqueeSelect();
	            _this2.removeMarqueeSelectionMoveListeners();
	        };
	
	        this.getPositionFromMouseEvent = function (event) {
	            // We need to use the pageX/Y because the offsetX/Y changes based on the hovered element.  Because of this
	            // we need to subtract the canvas's translation from the pageX/Y
	            var eventListenerBoundingRect = _this2.props.eventListenerNode.getBoundingClientRect();
	
	            return {
	                x: event.pageX - eventListenerBoundingRect.left,
	                y: event.pageY - eventListenerBoundingRect.top
	            };
	        };
	    };
	
	    SelectionMarqueeEventHandler.propTypes = {
	        eventListenerNode: _propTypes2.default.object,
	        startMarqueeSelect: _propTypes2.default.func,
	        dragMarqueeSelectionTo: _propTypes2.default.func,
	        finishMarqueeSelect: _propTypes2.default.func,
	        deselectAll: _propTypes2.default.func
	    };
	
	    return SelectionMarqueeEventHandler;
	};

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _reactRedux = __webpack_require__(3);
	
	var _rect = __webpack_require__(208);
	
	var rectLib = _interopRequireWildcard(_rect);
	
	var _immutableHelper = __webpack_require__(23);
	
	var _rafThrottle = __webpack_require__(245);
	
	var _rafThrottle2 = _interopRequireDefault(_rafThrottle);
	
	var _elementUtil = __webpack_require__(105);
	
	var _selectionActions = __webpack_require__(55);
	
	var _measurementsConnect = __webpack_require__(123);
	
	var _measurementsConnect2 = _interopRequireDefault(_measurementsConnect);
	
	var _measurementsSelector = __webpack_require__(124);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	// Utils
	
	
	// Actions
	
	
	// Components
	
	
	// Selectors
	
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        dispatchSetSelectedElements: function dispatchSetSelectedElements(ids) {
	            return dispatch((0, _selectionActions.setSelectedElements)({ ids: ids }));
	        },
	        dispatchAddSelectedElements: function dispatchAddSelectedElements(ids) {
	            return dispatch((0, _selectionActions.addSelectedElements)({ ids: ids }));
	        },
	        dispatchRemoveSelectedElements: function dispatchRemoveSelectedElements(ids) {
	            return dispatch((0, _selectionActions.removeSelectedElements)({ ids: ids }));
	        },
	        dispatchDeselectAllElements: function dispatchDeselectAllElements(ids) {
	            return dispatch((0, _selectionActions.deselectAllElements)({ ids: ids }));
	        }
	    };
	};
	
	var MARQUEE_SELECTION_CLASS = 'marquee-selected';
	/**
	 * PERFORMANCE:
	 * The following functions use vanilla JS to add classes to hovered elements for performance reasons.
	 * 1. This prevents dispatching store state changes every time an element is hovered (thus preventing many re-renders
	 *      or prop recalculations).
	 * 2. Actually selecting elements causes their order in the DOM to change (due to the sorting of elements on the
	 *      canvas), thus selecting and deselecting elements causes reasonably significant DOM changes in a small amount
	 *      of time.  By using classes instead minimal DOM changes are required and instead of relying on React to
	 *      perform reconciliation the browser only has to perform style & paint recalculations.
	 */
	var modifySelectionMarqueeClass = function modifySelectionMarqueeClass(modificationType) {
	    return function (elementIds) {
	        elementIds.forEach(function (id) {
	            var canvasElement = document.getElementById((0, _elementUtil.getDomElementId)(id));
	            if (!canvasElement) return;
	
	            canvasElement.classList[modificationType](MARQUEE_SELECTION_CLASS);
	        });
	    };
	};
	
	var addSelectionMarqueeHoveredClass = modifySelectionMarqueeClass('add');
	var removeSelectionMarqueeHoveredClass = modifySelectionMarqueeClass('remove');
	
	var mapMeasurementsStateToProps = function mapMeasurementsStateToProps(state) {
	    return {
	        measurements: (0, _measurementsSelector.getMeasurementsMap)(state)
	    };
	};
	
	exports.default = function (DecoratedComponent) {
	    var _dec, _dec2, _class;
	
	    var SelectionMarqueeSelectedElementFinderDecorator = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec2 = (0, _measurementsConnect2.default)(mapMeasurementsStateToProps), _dec(_class = _dec2(_class = function (_React$Component) {
	        _inherits(SelectionMarqueeSelectedElementFinderDecorator, _React$Component);
	
	        function SelectionMarqueeSelectedElementFinderDecorator(props) {
	            _classCallCheck(this, SelectionMarqueeSelectedElementFinderDecorator);
	
	            var _this = _possibleConstructorReturn(this, (SelectionMarqueeSelectedElementFinderDecorator.__proto__ || Object.getPrototypeOf(SelectionMarqueeSelectedElementFinderDecorator)).call(this, props));
	
	            _this.findHoveredElements = function (_ref) {
	                var top = _ref.top,
	                    left = _ref.left,
	                    width = _ref.width,
	                    height = _ref.height,
	                    measurements = _ref.measurements;
	                var _this$props = _this.props,
	                    canvasElementIds = _this$props.canvasElementIds,
	                    active = _this$props.active;
	
	                if (!active || !width || !height) return;
	
	                var marqueeRect = rectLib.getRect({ x: left, y: top, width: width, height: height });
	
	                var currentHoveredElements = measurements.filter(function (elementMeasurement, elementId) {
	                    if (!canvasElementIds.some(function (elId) {
	                        return elId === elementId;
	                    })) return false;
	
	                    var elementRect = rectLib.getRect({
	                        x: elementMeasurement.get('left'),
	                        y: elementMeasurement.get('top'),
	                        width: elementMeasurement.get('width'),
	                        height: elementMeasurement.get('height')
	                    });
	                    return rectLib.isOverlapping(elementRect, marqueeRect);
	                });
	
	                var currentHoveredElementIds = (0, _immutableHelper.toIdArray)(currentHoveredElements);
	
	                var noLongerHovered = (0, _lodash.difference)(_this.hoveredElementIds, currentHoveredElementIds);
	                var newHovered = (0, _lodash.difference)(currentHoveredElementIds, _this.hoveredElementIds);
	
	                if (newHovered.length || noLongerHovered.length) {
	                    _this.hoveredElementIds = currentHoveredElementIds;
	                    addSelectionMarqueeHoveredClass(newHovered);
	                    removeSelectionMarqueeHoveredClass(noLongerHovered);
	                }
	            };
	
	            _this.throttledFindHoveredElements = (0, _rafThrottle2.default)(_this.findHoveredElements);
	
	            _this.startMarqueeSelect = function (args) {
	                var appendMode = args.appendMode;
	                var _this$props2 = _this.props,
	                    dispatchDeselectAllElements = _this$props2.dispatchDeselectAllElements,
	                    startMarqueeSelect = _this$props2.startMarqueeSelect;
	
	
	                if (!appendMode) {
	                    dispatchDeselectAllElements();
	                }
	
	                return startMarqueeSelect(args);
	            };
	
	            _this.finishMarqueeSelect = function () {
	                var _this$props3 = _this.props,
	                    finishMarqueeSelect = _this$props3.finishMarqueeSelect,
	                    dispatchSetSelectedElements = _this$props3.dispatchSetSelectedElements,
	                    dispatchAddSelectedElements = _this$props3.dispatchAddSelectedElements,
	                    appendMode = _this$props3.appendMode;
	
	
	                _this.throttledFindHoveredElements.cancel();
	
	                removeSelectionMarqueeHoveredClass(_this.hoveredElementIds);
	
	                appendMode ? dispatchAddSelectedElements(_this.hoveredElementIds) : dispatchSetSelectedElements(_this.hoveredElementIds);
	
	                _this.hoveredElementIds = [];
	                return finishMarqueeSelect.apply(undefined, arguments);
	            };
	
	            _this.hoveredElementIds = [];
	            return _this;
	        }
	
	        _createClass(SelectionMarqueeSelectedElementFinderDecorator, [{
	            key: 'componentWillReceiveProps',
	            value: function componentWillReceiveProps(nextProps) {
	                if (nextProps.active) {
	                    this.throttledFindHoveredElements(nextProps);
	                }
	            }
	        }, {
	            key: 'componentWillUnmount',
	            value: function componentWillUnmount() {
	                this.throttledFindHoveredElements.cancel();
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                var _props = this.props,
	                    measurements = _props.measurements,
	                    rest = _objectWithoutProperties(_props, ['measurements']); // eslint-disable-line no-unused-vars
	
	
	                return _react2.default.createElement(DecoratedComponent, _extends({}, rest, {
	                    finishMarqueeSelect: this.finishMarqueeSelect,
	                    startMarqueeSelect: this.startMarqueeSelect }));
	            }
	        }]);
	
	        return SelectionMarqueeSelectedElementFinderDecorator;
	    }(_react2.default.Component)) || _class) || _class);
	
	
	    SelectionMarqueeSelectedElementFinderDecorator.propTypes = {
	        canvasElementIds: _propTypes2.default.array.isRequired,
	        dispatchSetSelectedElements: _propTypes2.default.func,
	        dispatchAddSelectedElements: _propTypes2.default.func,
	        dispatchRemoveSelectedElements: _propTypes2.default.func,
	        dispatchDeselectAllElements: _propTypes2.default.func,
	        startMarqueeSelect: _propTypes2.default.func,
	        finishMarqueeSelect: _propTypes2.default.func,
	        measurements: _propTypes2.default.object,
	        active: _propTypes2.default.bool,
	        appendMode: _propTypes2.default.bool,
	        top: _propTypes2.default.number,
	        left: _propTypes2.default.number,
	        width: _propTypes2.default.number,
	        height: _propTypes2.default.number
	    };
	
	    return SelectionMarqueeSelectedElementFinderDecorator;
	};

/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	var initialState = {
	    active: false,
	    appendMode: false,
	    top: null,
	    left: null,
	    width: null,
	    height: null
	};
	
	exports.default = function (DecoratedComponent) {
	    var SelectionMarqueeStateManager = function (_React$Component) {
	        _inherits(SelectionMarqueeStateManager, _React$Component);
	
	        function SelectionMarqueeStateManager(props) {
	            _classCallCheck(this, SelectionMarqueeStateManager);
	
	            var _this = _possibleConstructorReturn(this, (SelectionMarqueeStateManager.__proto__ || Object.getPrototypeOf(SelectionMarqueeStateManager)).call(this, props));
	
	            _this.startMarqueeSelect = function (_ref) {
	                var x = _ref.x,
	                    y = _ref.y,
	                    _ref$appendMode = _ref.appendMode,
	                    appendMode = _ref$appendMode === undefined ? false : _ref$appendMode;
	
	                _this.startPosition = { x: x, y: y };
	                _this.setState({ active: true, left: x, top: y, appendMode: appendMode });
	                _this.props.setSelectionMarqueeActive(true);
	            };
	
	            _this.dragMarqueeSelectionTo = function (_ref2) {
	                var x = _ref2.x,
	                    y = _ref2.y;
	
	                var dx = x - _this.startPosition.x;
	                var dy = y - _this.startPosition.y;
	
	                var width = Math.abs(dx);
	                var height = Math.abs(dy);
	                var left = dx < 0 ? x : _this.startPosition.x;
	                var top = dy < 0 ? y : _this.startPosition.y;
	
	                _this.setState({ left: left, top: top, width: width, height: height });
	            };
	
	            _this.finishMarqueeSelect = function () {
	                _this.setState(initialState);
	                _this.props.setSelectionMarqueeActive(false);
	            };
	
	            _this.state = initialState;
	
	            _this.startPosition = {
	                x: null,
	                y: null
	            };
	            return _this;
	        }
	
	        // Methods to update the state
	
	
	        _createClass(SelectionMarqueeStateManager, [{
	            key: 'render',
	            value: function render() {
	                return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, this.state, {
	                    startMarqueeSelect: this.startMarqueeSelect,
	                    dragMarqueeSelectionTo: this.dragMarqueeSelectionTo,
	                    finishMarqueeSelect: this.finishMarqueeSelect }));
	            }
	        }]);
	
	        return SelectionMarqueeStateManager;
	    }(_react2.default.Component);
	
	    SelectionMarqueeStateManager.propTypes = {
	        setSelectionMarqueeActive: _propTypes2.default.func
	    };
	
	    return SelectionMarqueeStateManager;
	};

/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouter = __webpack_require__(45);
	
	__webpack_require__(1130);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tab = function Tab(_ref) {
	    var route = _ref.route,
	        title = _ref.title,
	        active = _ref.active;
	    return _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	            _reactRouter.Link,
	            { to: route, className: (0, _classnames2.default)('Tab', { active: active }) },
	            title
	        )
	    );
	};
	
	Tab.propTypes = {
	    route: _propTypes2.default.string,
	    title: _propTypes2.default.string,
	    active: _propTypes2.default.bool
	};
	
	var TabbedNavigation = function TabbedNavigation(_ref2) {
	    var tabs = _ref2.tabs,
	        children = _ref2.children,
	        className = _ref2.className,
	        location = _ref2.location;
	    return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('TabbedNavigation', className) },
	        _react2.default.createElement(
	            'nav',
	            { className: 'tabs' },
	            _react2.default.createElement(
	                'ul',
	                null,
	                tabs.map(function (tab) {
	                    return _react2.default.createElement(Tab, _extends({}, tab, { key: tab.route, active: location.pathname === tab.route }));
	                })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'tab-content-scroll' },
	            _react2.default.createElement(
	                'div',
	                { className: 'tab-content' },
	                children
	            )
	        )
	    );
	};
	
	TabbedNavigation.propTypes = {
	    tabs: _propTypes2.default.array.isRequired,
	    location: _propTypes2.default.object.isRequired,
	    children: _propTypes2.default.element,
	    className: _propTypes2.default.string
	};
	
	exports.default = TabbedNavigation;

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EMITTER_STYLE = {
	    position: 'absolute'
	};
	
	var easeInOutCubic = function easeInOutCubic(t) {
	    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
	};
	
	var randRange = function randRange(min, max) {
	    return Math.random() * (max - min) + min;
	};
	
	var getStyle = function getStyle(particle) {
	    var age = particle.age / particle.maxAge;
	    var rotate = particle.rotate;
	    var scale = Math.sin(age) * 2;
	    var opacity = easeInOutCubic(1 - age);
	
	    var transform = 'translate3d(' + particle.x + 'px, ' + particle.y + 'px, 0) rotate(' + rotate + 'deg) scale(' + scale + ')';
	
	    return {
	        transform: transform,
	        WebkitTransform: transform,
	        opacity: opacity,
	        position: 'absolute',
	        left: 0,
	        top: 0
	    };
	};
	
	var Particle = function Particle(_ref) {
	    var particle = _ref.particle,
	        iconName = _ref.iconName,
	        children = _ref.children;
	    return _react2.default.createElement(
	        'div',
	        { className: 'Particle', style: getStyle(particle) },
	        children
	    );
	};
	
	Particle.propTypes = {
	    particle: _propTypes2.default.object,
	    iconName: _propTypes2.default.string,
	    children: _propTypes2.default.element
	};
	
	var updateParticle = function updateParticle(particle) {
	    return {
	        x: particle.x + particle.vx,
	        y: particle.y + particle.vy,
	        vx: particle.vx + particle.gravity.x,
	        vy: particle.vy + particle.gravity.y,
	        rotate: particle.rotate + particle.vr,
	        vr: particle.vr * 0.99,
	        age: particle.age + 1,
	        maxAge: particle.maxAge,
	        gravity: particle.gravity
	    };
	};
	
	var ParticleEmitter = function (_React$Component) {
	    _inherits(ParticleEmitter, _React$Component);
	
	    function ParticleEmitter(props) {
	        _classCallCheck(this, ParticleEmitter);
	
	        var _this = _possibleConstructorReturn(this, (ParticleEmitter.__proto__ || Object.getPrototypeOf(ParticleEmitter)).call(this, props));
	
	        _this.animateParticles = function () {
	            var _this$props = _this.props,
	                stopAfter = _this$props.stopAfter,
	                _this$props$particleF = _this$props.particleFrequency,
	                particleFrequency = _this$props$particleF === undefined ? 20 : _this$props$particleF;
	
	
	            if (!_this.animate) return;
	
	            var particles = _this.state.particles;
	
	            var updated = particles.map(updateParticle).filter(function (particle) {
	                return particle.age < particle.maxAge;
	            });
	
	            _this.setState({
	                particles: updated
	            });
	
	            _this.addTick++;
	            if (_this.addTick % particleFrequency === 0) _this.addParticle();
	
	            if (stopAfter && _this.totalCount > stopAfter && !updated.length) {
	                _this.animate = false;
	            }
	
	            requestAnimationFrame(_this.animateParticles);
	        };
	
	        _this.addParticle = function () {
	            var _this$props2 = _this.props,
	                _this$props2$maxAge = _this$props2.maxAge,
	                maxAge = _this$props2$maxAge === undefined ? 150 : _this$props2$maxAge,
	                stopAfter = _this$props2.stopAfter,
	                _this$props2$initalVe = _this$props2.initalVelocityX,
	                initalVelocityX = _this$props2$initalVe === undefined ? {
	                max: 2,
	                min: -2
	            } : _this$props2$initalVe,
	                _this$props2$initalVe2 = _this$props2.initalVelocityY,
	                initalVelocityY = _this$props2$initalVe2 === undefined ? {
	                max: -4,
	                min: -8
	            } : _this$props2$initalVe2,
	                _this$props2$rotation = _this$props2.rotationVelocity,
	                rotationVelocity = _this$props2$rotation === undefined ? {
	                max: 10,
	                min: -10
	            } : _this$props2$rotation,
	                _this$props2$initalPo = _this$props2.initalPositionRect,
	                initalPositionRect = _this$props2$initalPo === undefined ? {
	                x: 0,
	                y: 0,
	                width: 0,
	                height: 0
	            } : _this$props2$initalPo,
	                _this$props2$gravity = _this$props2.gravity,
	                gravity = _this$props2$gravity === undefined ? {
	                x: 0,
	                y: 0.1
	            } : _this$props2$gravity;
	
	
	            if (stopAfter && _this.totalCount > stopAfter) return;
	
	            var particles = _this.state.particles;
	
	
	            var newParticle = {
	                x: randRange(initalPositionRect.x, initalPositionRect.width),
	                y: randRange(initalPositionRect.y, initalPositionRect.height),
	                vx: randRange(initalVelocityX.min, initalVelocityX.max),
	                vy: randRange(initalVelocityY.min, initalVelocityY.max),
	                vr: randRange(rotationVelocity.min, rotationVelocity.max),
	                rotate: 0,
	                age: 0,
	                maxAge: maxAge,
	                gravity: gravity
	            };
	
	            _this.totalCount++;
	
	            _this.setState({
	                particles: [].concat(_toConsumableArray(particles), [newParticle])
	            });
	        };
	
	        _this.state = {
	            particles: []
	        };
	        return _this;
	    }
	
	    _createClass(ParticleEmitter, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.animate = true;
	            this.addTick = 0;
	            this.totalCount = 0;
	            this.animateParticles();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.animate = false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                children = _props.children,
	                className = _props.className;
	            var particles = this.state.particles;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'ParticleEmitter ' + className, style: EMITTER_STYLE },
	                particles.map(function (particle, i) {
	                    return _react2.default.createElement(Particle, { particle: particle, key: i, children: children });
	                })
	            );
	        }
	    }]);
	
	    return ParticleEmitter;
	}(_react2.default.Component);
	
	ParticleEmitter.propTypes = {
	    maxAge: _propTypes2.default.number,
	    stopAfter: _propTypes2.default.number,
	    particleFrequency: _propTypes2.default.number,
	    className: _propTypes2.default.string,
	
	    gravity: _propTypes2.default.shape({
	        x: _propTypes2.default.number,
	        y: _propTypes2.default.number
	    }),
	
	    initalVelocityX: _propTypes2.default.shape({
	        min: _propTypes2.default.number,
	        max: _propTypes2.default.number
	    }),
	
	    initalVelocityY: _propTypes2.default.shape({
	        min: _propTypes2.default.number,
	        max: _propTypes2.default.number
	    }),
	
	    rotationVelocity: _propTypes2.default.shape({
	        min: _propTypes2.default.number,
	        max: _propTypes2.default.number
	    }),
	
	    initalPositionRect: _propTypes2.default.shape({
	        x: _propTypes2.default.number,
	        y: _propTypes2.default.number,
	        width: _propTypes2.default.number,
	        height: _propTypes2.default.number
	    }),
	
	    children: _propTypes2.default.element
	};
	
	exports.default = ParticleEmitter;

/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(34);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	__webpack_require__(1132);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	var PillButton = function PillButton(_ref) {
	    var children = _ref.children,
	        onClickFn = _ref.onClickFn,
	        className = _ref.className;
	    return _react2.default.createElement(
	        _Button2.default,
	        { className: (0, _classnames2.default)('PillButton', className), onClickFn: onClickFn },
	        children
	    );
	};
	
	// Styles
	// Lib
	
	
	PillButton.propTypes = {
	    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	    onClickFn: _propTypes2.default.func,
	    className: _propTypes2.default.string
	};
	
	exports.default = PillButton;

/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SHARE_SERVICES = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _planEnquiryAnalyticsService = __webpack_require__(235);
	
	__webpack_require__(1133);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Analytics
	var SHARE_SERVICES = exports.SHARE_SERVICES = {
	    FACEBOOK: 'FACEBOOK',
	    TWITTER: 'TWITTER',
	    EMAIL: 'EMAIL'
	};
	
	var MESSAGE = {
	    FACEBOOK: 'Share',
	    TWITTER: 'Tweet',
	    EMAIL: 'Email'
	};
	
	var getLink = function getLink(_ref) {
	    var service = _ref.service,
	        defaultContent = _ref.defaultContent,
	        bodyContent = _ref.bodyContent,
	        url = _ref.url;
	
	    switch (service) {
	        case SHARE_SERVICES.FACEBOOK:
	            return 'https://www.facebook.com/sharer/sharer.php?u=' + url + '&description=' + defaultContent;
	        case SHARE_SERVICES.TWITTER:
	            return 'https://twitter.com/intent/tweet?text=' + defaultContent + '&url=' + url;
	        case SHARE_SERVICES.EMAIL:
	        default:
	            return 'mailto:?subject=' + defaultContent + '&body=' + bodyContent;
	    }
	};
	
	var getLinkTarget = function getLinkTarget(service) {
	    switch (service) {
	        case SHARE_SERVICES.FACEBOOK:
	        case SHARE_SERVICES.TWITTER:
	            return '_blank';
	        case SHARE_SERVICES.EMAIL:
	        default:
	            return '_self';
	    }
	};
	
	var getLinkAnalyticsEvent = function getLinkAnalyticsEvent(service) {
	    switch (service) {
	        case SHARE_SERVICES.FACEBOOK:
	            return _planEnquiryAnalyticsService.googleAnalyticsFacebookReferralEvent;
	        case SHARE_SERVICES.TWITTER:
	            return _planEnquiryAnalyticsService.googleAnalyticsTwitterReferralEvent;
	        case SHARE_SERVICES.EMAIL:
	        default:
	            return _planEnquiryAnalyticsService.googleAnalyticsEmailReferralEvent;
	    }
	};
	
	var ShareButton = function ShareButton(_ref2) {
	    var service = _ref2.service,
	        defaultContent = _ref2.defaultContent,
	        bodyContent = _ref2.bodyContent,
	        url = _ref2.url,
	        children = _ref2.children;
	    return _react2.default.createElement(
	        'a',
	        { className: (0, _classnames2.default)('ShareButton', service.toLowerCase()),
	            onClick: getLinkAnalyticsEvent(service),
	            href: getLink({ service: service, defaultContent: defaultContent, bodyContent: bodyContent, url: url }),
	            target: getLinkTarget(service) },
	        children || MESSAGE[service]
	    );
	};
	
	ShareButton.propTypes = {
	    service: _propTypes2.default.string.isRequired,
	    url: _propTypes2.default.string,
	    defaultContent: _propTypes2.default.string.isRequired,
	    bodyContent: _propTypes2.default.string,
	    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node, _propTypes2.default.string])
	};
	
	exports.default = ShareButton;

/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _ElementConnectionsRegistry = __webpack_require__(1704);
	
	var _ElementConnectionsRegistry2 = _interopRequireDefault(_ElementConnectionsRegistry);
	
	var _configureElementConnectionsStore = __webpack_require__(1708);
	
	var _configureElementConnectionsStore2 = _interopRequireDefault(_configureElementConnectionsStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } // Registry
	
	
	// Store configuration
	
	
	/**
	 * Holds a reference to the store and the registry.
	 * Also provides a method to subscribe to the store.
	 */
	var ElementConnectionsManager = function ElementConnectionsManager() {
	    var _this = this;
	
	    _classCallCheck(this, ElementConnectionsManager);
	
	    this.subscribeToStateChange = function (listener) {
	        return (
	            // TODO probably a lot of performance improvements to be done here
	            _this.store.subscribe(listener)
	        );
	    };
	
	    this.registry = new _ElementConnectionsRegistry2.default();
	    this.store = (0, _configureElementConnectionsStore2.default)();
	}
	
	/**
	 * Subscribes the listener function to any elementConnections state changes.
	 * Returns a method to unsubscribe.
	 */
	;
	
	exports.default = ElementConnectionsManager;

/***/ }),
/* 1704 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Keeps a reference to the source specs and a count of the targets.
	 * This allows the source specs to be retrieved and invoke functions on them at a later time.
	 */
	var ElementConnectionsRegistry = function ElementConnectionsRegistry() {
	    var _this = this;
	
	    _classCallCheck(this, ElementConnectionsRegistry);
	
	    this.addSource = function (id, sourceSpec) {
	        _this.sources[id] = sourceSpec;
	    };
	
	    this.removeSource = function (id) {
	        _this.sources[id] = null;
	    };
	
	    this.getSource = function (id) {
	        return _this.sources[id];
	    };
	
	    this.sources = {};
	};
	
	exports.default = ElementConnectionsRegistry;

/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	/**
	 * Provides the ElementConnectionsManager to other components via the React context.
	 */
	var ElementConnectionsContextProvider = function (_React$Component) {
	    _inherits(ElementConnectionsContextProvider, _React$Component);
	
	    function ElementConnectionsContextProvider(props, context) {
	        _classCallCheck(this, ElementConnectionsContextProvider);
	
	        var _this = _possibleConstructorReturn(this, (ElementConnectionsContextProvider.__proto__ || Object.getPrototypeOf(ElementConnectionsContextProvider)).call(this, props, context));
	
	        _this.manager = props.manager;
	        return _this;
	    }
	
	    _createClass(ElementConnectionsContextProvider, [{
	        key: 'getChildContext',
	        value: function getChildContext() {
	            return { elementConnectionsManager: this.manager };
	        }
	    }, {
	        key: 'getManager',
	        value: function getManager() {
	            return this.elementConnectionsManager;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.Children.only(this.props.children);
	        }
	    }]);
	
	    return ElementConnectionsContextProvider;
	}(_react2.default.Component);
	
	ElementConnectionsContextProvider.propTypes = {
	    children: _propTypes2.default.element.isRequired,
	    manager: _propTypes2.default.object.isRequired
	};
	
	ElementConnectionsContextProvider.childContextTypes = {
	    elementConnectionsManager: _propTypes2.default.object.isRequired
	};
	
	exports.default = ElementConnectionsContextProvider;

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	/**
	 * This allows components to connect to the "elementConnections store" so they can query the store and
	 * place data onto the component's props.
	 *
	 * It's a decorator that accepts mapConnectionStateToProps (an object that defines the data to retrieve from the state
	 * and the props to assign it to).
	 */
	exports.default = function (mapConnectionStateToProps) {
	    return function (DecoratedComponent) {
	        var ElementConnectionObserver = function (_React$Component) {
	            _inherits(ElementConnectionObserver, _React$Component);
	
	            function ElementConnectionObserver(props, context) {
	                _classCallCheck(this, ElementConnectionObserver);
	
	                var _this = _possibleConstructorReturn(this, (ElementConnectionObserver.__proto__ || Object.getPrototypeOf(ElementConnectionObserver)).call(this, props, context));
	
	                _this.getCurrentState = function () {
	                    return mapConnectionStateToProps(_this.manager.store.getState(), _this.props);
	                };
	
	                _this.handleChange = function () {
	                    var currentState = _this.getCurrentState();
	
	                    if ((0, _recompose.shallowEqual)(currentState, _this.state)) return;
	
	                    _this.setState(currentState);
	                };
	
	                _this.manager = context.elementConnectionsManager;
	
	                _this.unsubscribe = _this.manager.subscribeToStateChange(_this.handleChange);
	
	                _this.state = _this.getCurrentState();
	                return _this;
	            }
	
	            _createClass(ElementConnectionObserver, [{
	                key: 'componentWillUnmount',
	                value: function componentWillUnmount() {
	                    // Stop listening to state changes
	                    this.unsubscribe();
	                }
	
	                // TODO Need to check # of arguments like React-redux to determine whether to invoke or not
	
	
	                // TODO Will likely need some significant performance improvements here
	
	            }, {
	                key: 'render',
	                value: function render() {
	                    return _react2.default.createElement(DecoratedComponent, _extends({}, this.state, this.props));
	                }
	            }]);
	
	            return ElementConnectionObserver;
	        }(_react2.default.Component);
	
	        ElementConnectionObserver.contextTypes = {
	            elementConnectionsManager: _propTypes2.default.object.isRequired
	        };
	
	        return ElementConnectionObserver;
	    };
	};

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Utils
	
	
	// Actions
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(9);
	
	var _lodash = __webpack_require__(4);
	
	var _createElementConnectionsSourceSpec = __webpack_require__(1711);
	
	var _createElementConnectionsSourceSpec2 = _interopRequireDefault(_createElementConnectionsSourceSpec);
	
	var _connectionsActions = __webpack_require__(1709);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultCollect = {
	    getConnectionSourceId: function getConnectionSourceId(props) {
	        return props.elementId || props.element.get('id');
	    },
	    getConnectionTargetIds: function getConnectionTargetIds(props) {
	        return null;
	    }
	};
	
	/**
	 * Identifies a possible connection source.
	 * It takes a "spec" (specification) that can implement some hooks into actions (such as move events) and allow
	 * the sources to perform some of their own logic and perhaps dispatch some events.
	 *
	 * It also takes a "collecting" function which allows the connection source ID and the target IDs to be defined
	 * by the source.
	 * By default the source ID will be either the 'elementId' or the 'element.get('id')' from the props, but this
	 * can be overridden by implementing the 'getConnectionSourceId(props)' method.
	 *
	 * The 'getConnectionTargetIds(props)' is required and defines the connection target IDs that this source is
	 * connecting to.
	 */
	
	exports.default = function (customSpec, customCollect) {
	    return function (DecoratedComponent) {
	        var collect = _extends({}, defaultCollect, customCollect);
	
	        var ElementConnectionSource = function (_React$Component) {
	            _inherits(ElementConnectionSource, _React$Component);
	
	            function ElementConnectionSource(props, context) {
	                _classCallCheck(this, ElementConnectionSource);
	
	                var _this = _possibleConstructorReturn(this, (ElementConnectionSource.__proto__ || Object.getPrototypeOf(ElementConnectionSource)).call(this, props, context));
	
	                _initialiseProps.call(_this);
	
	                _this.manager = context.elementConnectionsManager;
	                _this.connections = null;
	
	                var id = collect.getConnectionSourceId(_this.props);
	
	                _this.sourceSpec = (0, _createElementConnectionsSourceSpec2.default)(customSpec, props);
	                _this.manager.registry.addSource(id, _this.sourceSpec);
	                return _this;
	            }
	
	            _createClass(ElementConnectionSource, [{
	                key: 'componentWillMount',
	                value: function componentWillMount() {
	                    this.propsChange(this.props);
	                }
	            }, {
	                key: 'componentWillReceiveProps',
	                value: function componentWillReceiveProps(nextProps) {
	                    this.propsChange(nextProps);
	                }
	            }, {
	                key: 'componentWillUnmount',
	                value: function componentWillUnmount() {
	                    var id = collect.getConnectionSourceId(this.props);
	                    this.manager.store.dispatch((0, _connectionsActions.connectionsRemove)({ id: id }));
	                    this.manager.registry.removeSource(id);
	                }
	            }, {
	                key: 'render',
	                value: function render() {
	                    return _react2.default.createElement(DecoratedComponent, this.props);
	                }
	            }]);
	
	            return ElementConnectionSource;
	        }(_react2.default.Component);
	
	        var _initialiseProps = function _initialiseProps() {
	            var _this2 = this;
	
	            this.propsChange = function (props) {
	                var id = collect.getConnectionSourceId(props);
	                var connections = collect.getConnectionTargetIds(props);
	
	                if (connections === _this2.connections || (0, _lodash.isEmpty)(connections) && (0, _lodash.isEmpty)(_this2.connections) || (0, _recompose.shallowEqual)(connections, _this2.connections)) return;
	
	                _this2.sourceSpec.receiveProps(props);
	                _this2.connections = connections;
	                _this2.manager.store.dispatch((0, _connectionsActions.connectionsSet)({ id: id, connections: _this2.connections }));
	            };
	        };
	
	        ElementConnectionSource.propTypes = {};
	
	        ElementConnectionSource.contextTypes = {
	            elementConnectionsManager: _propTypes2.default.object.isRequired
	        };
	
	        return ElementConnectionSource;
	    };
	};

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = configureElementConnectionsStore;
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _redux = __webpack_require__(195);
	
	var _reduxLogger = __webpack_require__(289);
	
	var _getClientConfig = __webpack_require__(48);
	
	var _getClientConfig2 = _interopRequireDefault(_getClientConfig);
	
	var _reduxBulkingMiddleware = __webpack_require__(307);
	
	var _rootElementConnectionsReducer = __webpack_require__(1713);
	
	var _rootElementConnectionsReducer2 = _interopRequireDefault(_rootElementConnectionsReducer);
	
	var _configConstants = __webpack_require__(135);
	
	var _connectionsConstants = __webpack_require__(426);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Constants
	
	
	// Middleware
	// Lib
	function configureElementConnectionsStore() {
	    var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Immutable.Map();
	
	    var middlewareList = [];
	    var config = (0, _getClientConfig2.default)();
	
	    middlewareList.push((0, _reduxBulkingMiddleware.bulkingMiddleware)({ bulkActionTypes: _connectionsConstants.BULK_CONNECTIONS_ACTIONS }));
	
	    if (config.debugLevel > _configConstants.DEBUG_LEVEL.OFF) {
	        middlewareList.push((0, _reduxLogger.createLogger)({
	            collapsed: true,
	            duration: true,
	            colors: {
	                title: function title(action) {
	                    return 'teal';
	                }
	            }
	        }));
	    }
	
	    var middleware = _redux.applyMiddleware.apply(null, middlewareList);
	
	    return (0, _redux.createStore)((0, _reduxBulkingMiddleware.enableReducerBatching)(_rootElementConnectionsReducer2.default), initialState, middleware);
	}
	
	// Reducer
	
	
	// Utils

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.connectionsRemove = exports.connectionsSet = exports.measurementsRemove = exports.measurementsSet = undefined;
	
	var _connectionsConstants = __webpack_require__(426);
	
	var measurementsSet = exports.measurementsSet = function measurementsSet(_ref) {
	  var id = _ref.id,
	      measurements = _ref.measurements;
	  return { type: _connectionsConstants.MEASUREMENT_SET, id: id, measurements: measurements };
	}; // Constants
	var measurementsRemove = exports.measurementsRemove = function measurementsRemove(_ref2) {
	  var id = _ref2.id,
	      measurements = _ref2.measurements;
	  return { type: _connectionsConstants.MEASUREMENT_REMOVE, id: id, measurements: measurements };
	};
	
	var connectionsSet = exports.connectionsSet = function connectionsSet(_ref3) {
	  var id = _ref3.id,
	      connections = _ref3.connections;
	  return { type: _connectionsConstants.CONNECTIONS_SET, id: id, connections: connections };
	};
	var connectionsRemove = exports.connectionsRemove = function connectionsRemove(_ref4) {
	  var id = _ref4.id,
	      connections = _ref4.connections;
	  return { type: _connectionsConstants.CONNECTIONS_REMOVE, id: id, connections: connections };
	};

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _immutableHelper = __webpack_require__(23);
	
	var _connectionsSelector = __webpack_require__(678);
	
	var _elementConstants = __webpack_require__(12);
	
	// Selector
	
	
	// Selectors
	var getConnectingElements = function getConnectingElements(connectionsState, _ref) {
	    var id = _ref.id;
	    return (0, _immutableHelper.toIdArray)((0, _connectionsSelector.getConnections)(connectionsState).filter(function (connectedElements) {
	        return connectedElements.includes(id);
	    }));
	};
	
	// Selector
	
	
	// Constants
	// Utils
	var getIsConnected = function getIsConnected(connectionsState, _ref2) {
	    var id = _ref2.id;
	
	    var connectionData = (0, _connectionsSelector.getConnections)(connectionsState).get(id);
	    return connectionData && connectionData.size;
	};
	
	var handleSingleElementMove = function handleSingleElementMove(elementConnectionsManager, store, action, move) {
	    // Find the ID of the thing being moved
	    var id = move.id;
	
	    // Determine if the moved element is a 'connecting' element and allow it to perform
	    // some updates to its state
	
	    var isConnected = getIsConnected(elementConnectionsManager.store.getState(), { id: id });
	    if (isConnected) {
	        var sourceSpec = elementConnectionsManager.registry.getSource(id);
	        sourceSpec.handleConnectionSourceMove(action, move);
	    }
	
	    // Figure out if it has any connected elements
	    var connectedElementIdArray = getConnectingElements(elementConnectionsManager.store.getState(), { id: id });
	
	    // For each connected element, invoke the appropriate method
	    connectedElementIdArray.forEach(function (connectedElementId) {
	        // Get the connected element from the registry
	        var sourceSpec = elementConnectionsManager.registry.getSource(connectedElementId);
	
	        // Invoke the appropriate spec method
	        sourceSpec.handleConnectedElementMove(action, move);
	    });
	
	    return null;
	};
	
	var handleElementMultiMoveAction = function handleElementMultiMoveAction(elementConnectionsManager, store, action) {
	    return action.moves.map(function (move) {
	        return handleSingleElementMove(elementConnectionsManager, store, action, move);
	    });
	};
	
	/**
	 * Allows standard Milanote store actions to be intercepted by the elementConnections Manager.
	 */
	
	exports.default = function (elementConnectionsManager) {
	    return function (store) {
	        return function (next) {
	            return function (action) {
	                // Prevent handling the undo & redo actions
	                if (action.isUndo || action.isRedo) return next(action);
	
	                switch (action.type) {
	                    case _elementConstants.ELEMENT_MOVE_MULTI:
	                        handleElementMultiMoveAction(elementConnectionsManager, store, action);
	                        break;
	                    default:
	                        break;
	                }
	
	                return next(action);
	            };
	        };
	    };
	};

/***/ }),
/* 1711 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * The spec defines the operations that will be invoked at various times and gives sources the ability to implement
	 * their own handlers in for those moments.
	 *
	 * Currently the only events handled are ELEMENT_MOVE_MULTI events of connected targets (handleConnectedElementMove)
	 * and connecting sources (handleConnectionSourceMove).
	 * These are invoked via the elementConnectionsMiddleware.
	 */
	exports.default = function (customSpec, initialProps) {
	    var ElementConnectionSourceSpec = function ElementConnectionSourceSpec(props) {
	        _classCallCheck(this, ElementConnectionSourceSpec);
	
	        _initialiseProps.call(this);
	
	        this.props = props;
	    }
	
	    /**
	     * Private method that can receive the source's props when they change.
	     */
	
	
	    /**
	     * Invoked when an element that a source is connected to is moved.
	     * This gives sources the ability to perform some checks and updates when an element they're connected to
	     * is moved.
	     *
	     * @param action {Object} The action object that is being dispatched.
	     * @param move {Object} An object describing the move event { id, from, location }.
	     */
	
	
	    /**
	     * Invoked when a source is moved.
	     * This gives sources the ability to perform some checks and updates when it's being moved (e.g. so it can
	     * disconnect if required).
	     *
	     * @param action {Object} The action object that is being dispatched.
	     * @param move {Object} An object describing the move event { id, from, location }.
	     */
	    ;
	
	    var _initialiseProps = function _initialiseProps() {
	        var _this = this;
	
	        this.receiveProps = function (props) {
	            _this.props = props;
	        };
	
	        this.handleConnectedElementMove = function (action, move) {
	            return customSpec.handleConnectedElementMove && customSpec.handleConnectedElementMove(_this.props, action, move);
	        };
	
	        this.handleConnectionSourceMove = function (action, move) {
	            return customSpec.handleConnectionSourceMove && customSpec.handleConnectionSourceMove(_this.props, action, move);
	        };
	    };
	
	    return new ElementConnectionSourceSpec(initialProps);
	};

/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _connectionsConstants = __webpack_require__(426);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Lib
	var initialState = Immutable.Map();
	
	/**
	 * Stores a map of connection sources and the target IDs of the things they're connected to.
	 */
	
	
	// Constants
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _connectionsConstants.CONNECTIONS_SET:
	            return state.set(action.id, Immutable.fromJS(action.connections));
	        case _connectionsConstants.CONNECTIONS_REMOVE:
	            return state.delete(action.id);
	        default:
	            return state;
	    }
	};

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxImmutable = __webpack_require__(73);
	
	var _connectionsReducer = __webpack_require__(1712);
	
	var _connectionsReducer2 = _interopRequireDefault(_connectionsReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Lib
	exports.default = (0, _reduxImmutable.combineReducers)({
	    connections: _connectionsReducer2.default
	});
	
	// Reducers

/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _draftJs = __webpack_require__(39);
	
	exports.default = function (editorState) {
	    var currentSelection = editorState.getSelection();
	    var selection = currentSelection.set('hasFocus', false);
	    return _draftJs.EditorState.acceptSelection(editorState, selection);
	};

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _draftJs = __webpack_require__(39);
	
	var _draftjsConstants = __webpack_require__(121);
	
	// Lib
	exports.default = function (editorState, style) {
	    var selection = editorState.getSelection();
	    var contentState = editorState.getCurrentContent();
	
	    contentState = _draftJs.Modifier.splitBlock(contentState, selection);
	    if (style) {
	        contentState = _draftJs.Modifier.setBlockType(contentState, contentState.getSelectionAfter(), style);
	    }
	    return _draftJs.EditorState.push(editorState, contentState, _draftjsConstants.EditorChangeType.SPLIT_BLOCK);
	};
	
	// Constants

/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _insertNewline = __webpack_require__(1715);
	
	var _insertNewline2 = _interopRequireDefault(_insertNewline);
	
	var _richTextConstants = __webpack_require__(166);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Utils
	exports.default = function (editorState) {
	  return (0, _insertNewline2.default)(editorState, _richTextConstants.STYLE_COMMANDS.UNSTYLED);
	};
	
	// Constants

/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.currentlyEditingThisEditor = exports.startedEditingThisElement = exports.noLongerEditingThisEditor = exports.editingKeyNowEqualsThisKey = exports.editingKeyNoLongerEqualsThisKey = exports.editingKeyDoesNotEqualThisKey = exports.editingKeyEqualsThisKey = exports.editorStateHasChanged = exports.textContentHasChanged = exports.stayedEditingElement = exports.nowEditingElement = exports.noLongerEditingElement = undefined;
	
	var _propsComparisons = __webpack_require__(147);
	
	// Property comparison functions
	var noLongerEditingElement = exports.noLongerEditingElement = (0, _propsComparisons.noLonger)('isEditing'); // Utils
	var nowEditingElement = exports.nowEditingElement = (0, _propsComparisons.now)('isEditing');
	var stayedEditingElement = exports.stayedEditingElement = (0, _propsComparisons.stayedTrue)('isEditing');
	var textContentHasChanged = exports.textContentHasChanged = (0, _propsComparisons.hasChanged)('textContent');
	var editorStateHasChanged = exports.editorStateHasChanged = (0, _propsComparisons.hasChanged)('editorState');
	
	var editingKeyEqualsThisKey = exports.editingKeyEqualsThisKey = function editingKeyEqualsThisKey(props) {
	    return props.currentEditorKey === props.editorKey;
	};
	var editingKeyDoesNotEqualThisKey = exports.editingKeyDoesNotEqualThisKey = function editingKeyDoesNotEqualThisKey(props) {
	    return props.currentEditorKey !== props.editorKey;
	};
	var editingKeyNoLongerEqualsThisKey = exports.editingKeyNoLongerEqualsThisKey = function editingKeyNoLongerEqualsThisKey(oldProps, newProps) {
	    return editingKeyEqualsThisKey(oldProps) && editingKeyDoesNotEqualThisKey(newProps);
	};
	var editingKeyNowEqualsThisKey = exports.editingKeyNowEqualsThisKey = function editingKeyNowEqualsThisKey(oldProps, newProps) {
	    return editingKeyDoesNotEqualThisKey(oldProps) && editingKeyEqualsThisKey(newProps);
	};
	
	var noLongerEditingThisEditor = exports.noLongerEditingThisEditor = function noLongerEditingThisEditor(oldProps, newProps) {
	    return noLongerEditingElement(oldProps, newProps) && editingKeyEqualsThisKey(oldProps) || oldProps.isEditing && editingKeyNoLongerEqualsThisKey(oldProps, newProps);
	};
	
	var startedEditingThisElement = exports.startedEditingThisElement = function startedEditingThisElement(oldProps, newProps) {
	    return nowEditingElement(oldProps, newProps) && editingKeyEqualsThisKey(newProps);
	};
	
	var currentlyEditingThisEditor = exports.currentlyEditingThisEditor = function currentlyEditingThisEditor(currentProps) {
	    return currentProps.isEditing && editingKeyEqualsThisKey(currentProps);
	};

/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _checklistConstants = __webpack_require__(196);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // Lib
	
	
	// Constants
	
	
	/**
	 * Render the following structure:
	 * <ul className="checklist-ul">
	 *     <li>...</li>
	 *     ...
	 * </ul>
	 */
	exports.default = Immutable.Map(_defineProperty({}, _checklistConstants.CHECKLIST_BLOCK_TYPE, {
	    element: 'li',
	    wrapper: _react2.default.createElement('ul', { className: 'checklist-ul' })
	}));

/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _wrappedUpdateBlockMetadata = __webpack_require__(1743);
	
	var _wrappedUpdateBlockMetadata2 = _interopRequireDefault(_wrappedUpdateBlockMetadata);
	
	var _returnFocusToEditor = __webpack_require__(1742);
	
	var _returnFocusToEditor2 = _interopRequireDefault(_returnFocusToEditor);
	
	var _ChecklistEditorBlock = __webpack_require__(1721);
	
	var _ChecklistEditorBlock2 = _interopRequireDefault(_ChecklistEditorBlock);
	
	var _checklistConstants = __webpack_require__(196);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Provides the component to be rendered by the block type as well as any props that go with it.
	 */
	
	
	// Components
	// Utils
	exports.default = function (block, _ref) {
	    var getEditorState = _ref.getEditorState,
	        setEditorState = _ref.setEditorState,
	        getProps = _ref.getProps;
	
	    if (block.getType() !== _checklistConstants.CHECKLIST_BLOCK_TYPE) return null;
	
	    var props = getProps();
	
	    return {
	        component: _ChecklistEditorBlock2.default,
	        props: {
	            isEditable: props.isEditable,
	            updateMetadataFn: (0, _wrappedUpdateBlockMetadata2.default)(getEditorState, setEditorState),
	            returnFocusToEditor: (0, _returnFocusToEditor2.default)(props, { getEditorState: getEditorState, setEditorState: setEditorState }),
	            checked: !!block.getData().get('checked')
	        }
	    };
	};
	
	// Constants

/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Components
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _dependencies = __webpack_require__(295);
	
	__webpack_require__(1139);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Checkbox = function Checkbox(props) {
	    return _react2.default.createElement(
	        'div',
	        _extends({ contentEditable: false, className: (0, _classnames2.default)('Checkbox', { checked: props.checked }) }, props),
	        _react2.default.createElement(_dependencies.Icon, { name: 'tick' })
	    );
	};
	
	Checkbox.propTypes = {
	    checked: _propTypes2.default.bool
	};
	
	exports.default = Checkbox;

/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _draftJs = __webpack_require__(39);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Checkbox = __webpack_require__(1720);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _dependencies = __webpack_require__(295);
	
	__webpack_require__(1140);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	// Components
	
	
	// Utils
	
	
	// Styles
	
	
	/**
	 * Renders a checklist block level item to the list.
	 *  _
	 * | | Some text goes here.
	 *  —
	 */
	var ChecklistEditorBlock = function (_React$Component) {
	    _inherits(ChecklistEditorBlock, _React$Component);
	
	    function ChecklistEditorBlock() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ChecklistEditorBlock);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChecklistEditorBlock.__proto__ || Object.getPrototypeOf(ChecklistEditorBlock)).call.apply(_ref, [this].concat(args))), _this), _this.toggleChecked = function (event) {
	            var _this$props = _this.props,
	                blockProps = _this$props.blockProps,
	                block = _this$props.block;
	            var updateMetadataFn = blockProps.updateMetadataFn,
	                returnFocusToEditor = blockProps.returnFocusToEditor,
	                checked = blockProps.checked;
	
	
	            if (!blockProps.isEditable) return;
	
	            event.stopPropagation();
	
	            var newChecked = !checked;
	            updateMetadataFn(block, { checked: newChecked });
	
	            returnFocusToEditor();
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	    /**
	     * Toggles the internal state of 'checked' as well as updating the editor's metadata for this block.
	     * If the block becomes unchecked we delete the entry from the metadata map to prevent it from growing too large.
	     */
	
	
	    _createClass(ChecklistEditorBlock, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                offsetKey = _props.offsetKey,
	                blockProps = _props.blockProps;
	            var checked = blockProps.checked;
	
	
	            var blockClassNames = (0, _classnames2.default)('ChecklistEditorBlock', { checked: checked });
	
	            return _react2.default.createElement(
	                'div',
	                { className: blockClassNames, 'data-offset-key': offsetKey },
	                _react2.default.createElement(_Checkbox2.default, { checked: checked, onMouseDown: this.toggleChecked, onClick: _dependencies.stopPropagationOnly }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'text' },
	                    _react2.default.createElement(_draftJs.EditorBlock, this.props)
	                )
	            );
	        }
	    }]);
	
	    return ChecklistEditorBlock;
	}(_react2.default.Component);
	
	exports.default = ChecklistEditorBlock;
	
	
	ChecklistEditorBlock.propTypes = {
	    block: _propTypes2.default.object.isRequired,
	    blockProps: _propTypes2.default.object.isRequired,
	    offsetKey: _propTypes2.default.string.isRequired
	};

/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _changeCurrentBlockType = __webpack_require__(679);
	
	var _changeCurrentBlockType2 = _interopRequireDefault(_changeCurrentBlockType);
	
	var _updateBlockMetadata = __webpack_require__(680);
	
	var _updateBlockMetadata2 = _interopRequireDefault(_updateBlockMetadata);
	
	var _draftjsConstants = __webpack_require__(121);
	
	var _checklistConstants = __webpack_require__(196);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Match the start of the string followed by [ ] or [] or [x]
	
	
	// Constants
	// Utils
	var CHECKLIST_MARKDOWN_PATTERN = /^(\[ \]|\[\]|\[x\])$/i;
	
	// TODO Maybe move this into the markdown plugin
	
	exports.default = function (char, _ref) {
	    var getEditorState = _ref.getEditorState,
	        setEditorState = _ref.setEditorState;
	
	    if (char !== ' ') return _draftjsConstants.HANDLER_RETURN_VALUES.notHandled;
	
	    var editorState = getEditorState();
	
	    // TODO Use the code from markdown
	    var currentSelection = editorState.getSelection();
	    var key = currentSelection.getStartKey();
	    var block = editorState.getCurrentContent().getBlockForKey(key);
	    var text = block.getText();
	    var position = currentSelection.getAnchorOffset();
	    var lineBeforeCharacter = text.slice(0, position);
	    var lineAfterCharacter = text.slice(position);
	
	    if (lineBeforeCharacter.match(CHECKLIST_MARKDOWN_PATTERN)) {
	        var updatedEditorState = (0, _changeCurrentBlockType2.default)(editorState, _checklistConstants.CHECKLIST_BLOCK_TYPE, lineAfterCharacter);
	
	        if (lineBeforeCharacter === '[x]' || lineBeforeCharacter === '[X]') {
	            // TODO Figure out if this should be immutable
	            updatedEditorState = (0, _updateBlockMetadata2.default)(updatedEditorState, block, { checked: true });
	        }
	
	        setEditorState(updatedEditorState);
	        return _draftjsConstants.HANDLER_RETURN_VALUES.handled;
	    }
	
	    return _draftjsConstants.HANDLER_RETURN_VALUES.notHandled;
	};

/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _moveSelectionToEndOfPreviousBlock = __webpack_require__(1726);
	
	var _moveSelectionToEndOfPreviousBlock2 = _interopRequireDefault(_moveSelectionToEndOfPreviousBlock);
	
	var _checklistConstants = __webpack_require__(196);
	
	var _draftjsConstants = __webpack_require__(121);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Constants
	exports.default = function (command, _ref) {
	    var getEditorState = _ref.getEditorState,
	        setEditorState = _ref.setEditorState;
	
	    switch (command) {
	        case _checklistConstants.COMMANDS.MOVE_SELECTION_TO_END_OF_PREVIOUS_BLOCK:
	            setEditorState((0, _moveSelectionToEndOfPreviousBlock2.default)(getEditorState()));
	            return _draftjsConstants.HANDLER_RETURN_VALUES.handled;
	        default:
	            return _draftjsConstants.HANDLER_RETURN_VALUES.notHandled;
	    }
	}; // Utils

/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _blockRendererFn = __webpack_require__(1719);
	
	var _blockRendererFn2 = _interopRequireDefault(_blockRendererFn);
	
	var _blockRenderMap = __webpack_require__(1718);
	
	var _blockRenderMap2 = _interopRequireDefault(_blockRenderMap);
	
	var _keyBindingFn = __webpack_require__(1725);
	
	var _keyBindingFn2 = _interopRequireDefault(_keyBindingFn);
	
	var _handleKeyCommand = __webpack_require__(1723);
	
	var _handleKeyCommand2 = _interopRequireDefault(_handleKeyCommand);
	
	var _handleBeforeInput = __webpack_require__(1722);
	
	var _handleBeforeInput2 = _interopRequireDefault(_handleBeforeInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return {
	        blockRendererFn: _blockRendererFn2.default,
	        blockRenderMap: _blockRenderMap2.default,
	        keyBindingFn: _keyBindingFn2.default,
	        handleKeyCommand: _handleKeyCommand2.default,
	        // TODO Maybe move this into the markdown plugin
	        handleBeforeInput: _handleBeforeInput2.default
	    };
	}; // Helpers

/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _dependencies = __webpack_require__(295);
	
	var _checklistConstants = __webpack_require__(196);
	
	/**
	 * This is apparently required to help editor navigation around the checkbox.
	 * I haven't noticed issues without it at this stage, but it was recommended by
	 * the author of Draft JS in the following thread:
	 * https://github.com/facebook/draft-js/issues/132
	 */
	exports.default = function (event, _ref) {
	    var getEditorState = _ref.getEditorState;
	
	    if (event.keyCode === _dependencies.KEY_CODES.LEFT_ARROW) {
	        var editorState = getEditorState();
	        var selection = editorState.getSelection();
	        var startKey = selection.getStartKey();
	        var blockType = editorState.getCurrentContent().getBlockForKey(startKey).getType();
	        if (blockType === _checklistConstants.CHECKLIST_BLOCK_TYPE && selection.getStartOffset() === 0 && (selection.isCollapsed() || selection.getIsBackward())) {
	            return _checklistConstants.COMMANDS.MOVE_SELECTION_TO_END_OF_PREVIOUS_BLOCK;
	        }
	    }
	}; // Constants

/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	var _draftJs = __webpack_require__(39);
	
	var _checklistConstants = __webpack_require__(196);
	
	/**
	 * Handles the command for moving a selection to the end of the previous block.
	 * This is used in scenarios where a custom block needs to prevent the content editable from treating certain elements
	 * as navigateable via the cursor.
	 * For example, the checklist component does not require the check box to be able to have the cursor before it, only
	 * within the text.
	 *
	 * @param editorState {EditorState} The current editor state to modify.
	 * @returns {EditorState} An updated editor state, or null if no updates are required.
	 */
	exports.default = function (editorState) {
	    var selection = editorState.getSelection();
	    var startKey = selection.getStartKey();
	    var contentState = editorState.getCurrentContent();
	    var prevBlock = contentState.getBlockBefore(startKey);
	
	    // If there's no previous block, then do nothing
	    if (!prevBlock) return null;
	
	    var prevKey = prevBlock.getKey();
	    var prevLength = prevBlock.getLength();
	
	    // Move the focus offset to the end of the previous line
	    var selectionChanges = {
	        focusKey: prevKey,
	        focusOffset: prevLength
	    };
	    // If the selection is collapsed, keep it collapsed by also moving the anchor
	    if (selection.isCollapsed()) {
	        selectionChanges = _extends({}, selectionChanges, {
	            anchorKey: prevKey,
	            anchorOffset: prevLength
	        });
	    }
	
	    var nextSelection = selection.merge(selectionChanges);
	
	    // Update the selection state.
	    var updatedEditorState = _draftJs.EditorState.forceSelection(editorState, nextSelection);
	    return _draftJs.EditorState.push(updatedEditorState, contentState, _checklistConstants.COMMANDS.MOVE_SELECTION_TO_END_OF_PREVIOUS_BLOCK);
	};

/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _draftJs = __webpack_require__(39);
	
	var _lodash = __webpack_require__(4);
	
	exports.default = function (plugins) {
	    return new _draftJs.CompositeDecorator((0, _lodash.flatMap)(plugins, function (plugin) {
	        return plugin.decorators || [];
	    }));
	};

/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _commandConstants = __webpack_require__(683);
	
	var _draftjsConstants = __webpack_require__(121);
	
	// Constants
	exports.default = function (command, _ref) {
	    var getProps = _ref.getProps;
	
	    if (command !== _commandConstants.EMPTY_DELETE) return _draftjsConstants.HANDLER_RETURN_VALUES.notHandled;
	
	    var _getProps = getProps(),
	        saveCurrentContent = _getProps.saveCurrentContent,
	        onEmptyBackspace = _getProps.onEmptyBackspace;
	
	    saveCurrentContent && saveCurrentContent();
	    onEmptyBackspace && onEmptyBackspace();
	    return _draftjsConstants.HANDLER_RETURN_VALUES.handled;
	};

/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _commandConstants = __webpack_require__(683);
	
	var _dependencies = __webpack_require__(295);
	
	/**
	 * If the editor is empty then fire the empty delete command.
	 */
	// Constants
	var getDeleteCommand = function getDeleteCommand(editorState) {
	    return editorState.getCurrentContent().hasText() ? undefined : _commandConstants.EMPTY_DELETE;
	};
	
	exports.default = function (event, _ref) {
	    var getEditorState = _ref.getEditorState;
	
	    switch (event.keyCode) {
	        case _dependencies.KEY_CODES.BACKSPACE:
	        case _dependencies.KEY_CODES.DELETE:
	            return getDeleteCommand(getEditorState());
	        default:
	            return;
	    }
	};

/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _draftJs = __webpack_require__(39);
	
	var _draftjsConstants = __webpack_require__(121);
	
	/**
	 * Handles a key command such as 'bold', 'italic' etc.
	 */
	// Lib
	exports.default = function (command, _ref) {
	    var getEditorState = _ref.getEditorState,
	        setEditorState = _ref.setEditorState;
	
	    var editorState = getEditorState();
	
	    var newEditorState = _draftJs.RichUtils.handleKeyCommand(editorState, command);
	
	    if (newEditorState) {
	        setEditorState(newEditorState);
	        return _draftjsConstants.HANDLER_RETURN_VALUES.handled;
	    }
	    return _draftjsConstants.HANDLER_RETURN_VALUES.notHandled;
	};
	
	// Constants

/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _draftJs = __webpack_require__(39);
	
	var _insertUnstyledNewline = __webpack_require__(1716);
	
	var _insertUnstyledNewline2 = _interopRequireDefault(_insertUnstyledNewline);
	
	var _keyboardUtility = __webpack_require__(313);
	
	var _richTextConstants = __webpack_require__(166);
	
	var _draftjsConstants = __webpack_require__(121);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Constants
	
	
	// Utils
	var getNewStateOnReturn = function getNewStateOnReturn(event, editorState) {
	    if ((0, _keyboardUtility.hasCommandModifier)(event)) return editorState;
	
	    if ((0, _keyboardUtility.hasShiftKey)(event)) return _draftJs.RichUtils.insertSoftNewline(editorState);
	
	    var newContentState = _draftJs.RichUtils.tryToRemoveBlockStyle(editorState);
	    if (newContentState) return _draftJs.EditorState.push(editorState, newContentState, 'change-block-type');
	
	    var currentBlockType = _draftJs.RichUtils.getCurrentBlockType(editorState);
	
	    if (currentBlockType.indexOf(_richTextConstants.STYLE_COMMANDS.HEADING_PREFIX) !== -1 || currentBlockType === _richTextConstants.STYLE_COMMANDS.BLOCKQUOTE) {
	        return (0, _insertUnstyledNewline2.default)(editorState);
	    }
	
	    return editorState;
	}; // Lib
	
	exports.default = function (event, _ref) {
	    var getEditorState = _ref.getEditorState,
	        setEditorState = _ref.setEditorState;
	
	    var editorState = getEditorState();
	    var newEditorState = getNewStateOnReturn(event, editorState);
	
	    if (newEditorState !== editorState) {
	        setEditorState(newEditorState);
	        return _draftjsConstants.HANDLER_RETURN_VALUES.handled;
	    }
	    return _draftjsConstants.HANDLER_RETURN_VALUES.notHandled;
	};

/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _draftJs = __webpack_require__(39);
	
	var MAX_DEPTH = 2; // Lib
	
	exports.default = function (event, _ref) {
	    var getEditorState = _ref.getEditorState,
	        setEditorState = _ref.setEditorState;
	
	    var editorState = getEditorState();
	    var updatedState = _draftJs.RichUtils.onTab(event, editorState, MAX_DEPTH);
	
	    if (updatedState !== editorState) {
	        setEditorState(updatedState);
	    }
	};

/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _domUtil = __webpack_require__(107);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DraftLinkAnchor = function DraftLinkAnchor(_ref) {
	    var target = _ref.target,
	        href = _ref.href,
	        className = _ref.className,
	        children = _ref.children;
	    return _react2.default.createElement(
	        'a',
	        { className: 'DraftLinkAnchor ' + className, href: href, target: target, onClick: _domUtil.stopPropagationOnly },
	        children
	    );
	};
	
	// Utils
	// Lib
	
	
	DraftLinkAnchor.propTypes = {
	    target: _propTypes2.default.string,
	    href: _propTypes2.default.string,
	    className: _propTypes2.default.string,
	    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
	};
	
	exports.default = DraftLinkAnchor;

/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _handleBlockType = __webpack_require__(1735);
	
	var _handleBlockType2 = _interopRequireDefault(_handleBlockType);
	
	var _draftjsConstants = __webpack_require__(121);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Utils
	exports.default = function (char, _ref) {
	    var getEditorState = _ref.getEditorState,
	        setEditorState = _ref.setEditorState;
	
	    var editorState = getEditorState();
	    if (char !== ' ') return editorState;
	
	    var newEditorState = (0, _handleBlockType2.default)(editorState, char);
	
	    // TODO Inline markdown was erroneous.  Return to later
	    // if (editorState === newEditorState) {
	    //     newEditorState = handleInlineStyle(editorState, char);
	    // }
	
	    if (editorState !== newEditorState) {
	        setEditorState(newEditorState);
	        return _draftjsConstants.HANDLER_RETURN_VALUES.handled;
	    }
	
	    return _draftjsConstants.HANDLER_RETURN_VALUES.notHandled;
	};
	// import handleInlineStyle from './handleInlineStyle';
	
	// Constants

/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _changeCurrentBlockType = __webpack_require__(679);
	
	var _changeCurrentBlockType2 = _interopRequireDefault(_changeCurrentBlockType);
	
	var _matchBlockTypeMarkdown = __webpack_require__(1739);
	
	var _matchBlockTypeMarkdown2 = _interopRequireDefault(_matchBlockTypeMarkdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Utils
	exports.default = function (editorState, character) {
	    var currentSelection = editorState.getSelection();
	    var key = currentSelection.getStartKey();
	    var text = editorState.getCurrentContent().getBlockForKey(key).getText();
	    var position = currentSelection.getAnchorOffset();
	    var lineAfterCharacter = text.slice(position);
	    var line = [text.slice(0, position), character, lineAfterCharacter].join('');
	
	    var newBlockType = (0, _matchBlockTypeMarkdown2.default)(line);
	
	    return (0, _changeCurrentBlockType2.default)(editorState, newBlockType, lineAfterCharacter);
	};

/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _handleBeforeInput = __webpack_require__(1734);
	
	var _handleBeforeInput2 = _interopRequireDefault(_handleBeforeInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return {
	        handleBeforeInput: _handleBeforeInput2.default
	    };
	}; // Utils

/***/ }),
/* 1737 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var ORDERED_LIST = exports.ORDERED_LIST = /^\s*1\.\s+/;
	var LIST = exports.LIST = /^\s*[\*,\-]\s+/;
	var HEADING = exports.HEADING = /^\s*#+\s+/;
	var BLOCKQUOTE = exports.BLOCKQUOTE = /^\s*>\s+/;
	
	var BOLD = exports.BOLD = [/\*\*([^(?:**)]+)\*\*/g, /__([^(?:__)]+)__/g];
	var ITALIC = exports.ITALIC = [/\*([^*]+)\*/g, /_([^_]+)_/g];

/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.matchItalic = exports.matchBold = exports.matchBlockquote = exports.matchList = exports.matchOrderedList = exports.matchHeading = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _markDownPatterns = __webpack_require__(1737);
	
	var markDownPatterns = _interopRequireWildcard(_markDownPatterns);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var matchPattern = function matchPattern(pattern) {
	    return function (text) {
	        return text.match(pattern);
	    };
	};
	
	// Block styles
	var matchHeading = exports.matchHeading = matchPattern(markDownPatterns.HEADING);
	var matchOrderedList = exports.matchOrderedList = matchPattern(markDownPatterns.ORDERED_LIST);
	var matchList = exports.matchList = matchPattern(markDownPatterns.LIST);
	var matchBlockquote = exports.matchBlockquote = matchPattern(markDownPatterns.BLOCKQUOTE);
	
	var matchPatterns = function matchPatterns(patterns) {
	    return function (text) {
	        return patterns.reduce(function (currMatches, pattern) {
	            var newMatch = null;
	            var matches = [];
	            do {
	                newMatch = pattern.exec(text);
	                if (newMatch) matches.push(newMatch);
	            } while (newMatch);
	
	            if ((0, _lodash.isEmpty)(matches)) return currMatches;
	
	            return currMatches ? currMatches.concat(matches) : matches;
	        }, null);
	    };
	};
	
	// Inline styles
	var matchBold = exports.matchBold = matchPatterns(markDownPatterns.BOLD);
	var matchItalic = exports.matchItalic = matchPatterns(markDownPatterns.ITALIC);

/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _BLOCK_TYPE_MATCH_FUN;
	
	var _lodash = __webpack_require__(4);
	
	var _markdownPatternMatcher = __webpack_require__(1738);
	
	var _richTextConstants = __webpack_require__(166);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // Lib
	
	
	// Utils
	
	
	// Constants
	
	
	var BLOCK_TYPE_MATCH_FUNCTIONS_MAP = (_BLOCK_TYPE_MATCH_FUN = {}, _defineProperty(_BLOCK_TYPE_MATCH_FUN, _richTextConstants.STYLE_COMMANDS.HEADING, _markdownPatternMatcher.matchHeading), _defineProperty(_BLOCK_TYPE_MATCH_FUN, _richTextConstants.STYLE_COMMANDS.ORDERED_LIST, _markdownPatternMatcher.matchOrderedList), _defineProperty(_BLOCK_TYPE_MATCH_FUN, _richTextConstants.STYLE_COMMANDS.LIST, _markdownPatternMatcher.matchList), _defineProperty(_BLOCK_TYPE_MATCH_FUN, _richTextConstants.STYLE_COMMANDS.BLOCKQUOTE, _markdownPatternMatcher.matchBlockquote), _BLOCK_TYPE_MATCH_FUN);
	
	exports.default = function (line) {
	    return (0, _lodash.reduce)(BLOCK_TYPE_MATCH_FUNCTIONS_MAP, function (acc, fn, blockType) {
	        if (acc) return acc;
	        return fn(line) ? blockType : null;
	    }, null);
	};

/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(4);
	
	var _draftJs = __webpack_require__(39);
	
	var _draftjsConstants = __webpack_require__(121);
	
	exports.default = function (event, _ref) {
	    var getProps = _ref.getProps;
	
	    var _getProps = getProps(),
	        createNewCard = _getProps.createNewCard,
	        saveCurrentContent = _getProps.saveCurrentContent;
	
	    if (createNewCard && (_draftJs.KeyBindingUtil.hasCommandModifier(event) || _draftJs.KeyBindingUtil.isCtrlKeyCommand(event))) {
	        saveCurrentContent();
	        (0, _lodash.defer)(function () {
	            return createNewCard();
	        });
	        return _draftjsConstants.HANDLER_RETURN_VALUES.handled;
	    }
	    return _draftjsConstants.HANDLER_RETURN_VALUES.notHandled;
	};
	
	// Constants
	// Lib

/***/ }),
/* 1741 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	/**
	 * Stop editing on escape.
	 */
	exports.default = function (event, _ref) {
	    var getProps = _ref.getProps;
	
	    var _getProps = getProps(),
	        stopEditing = _getProps.stopEditing;
	
	    if (!stopEditing) return;
	
	    event.preventDefault();
	    // TODO Check all devices to see if this was really necessary
	    // this.editor.blur();
	    stopEditing();
	};

/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _draftJs = __webpack_require__(39);
	
	var _lodash = __webpack_require__(4);
	
	exports.default = function (_ref, _ref2) {
	    var isEditing = _ref.isEditing;
	    var getEditorState = _ref2.getEditorState,
	        setEditorState = _ref2.setEditorState;
	    return function () {
	        if (!isEditing) return;
	
	        // Get the selection state before a delay
	        var selection = getEditorState().getSelection();
	
	        // For some reason Draft has started changing focus back to the start of the editor when the checkboxes are
	        // clicked, so this will wait until after the focus has been changed and then force it back to position it
	        // was before the focus was changed.
	        (0, _lodash.defer)(function () {
	            var editorState = getEditorState();
	            var newEditorState = _draftJs.EditorState.forceSelection(editorState, selection);
	            setEditorState(newEditorState);
	        });
	    };
	};

/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _updateBlockMetadata = __webpack_require__(680);
	
	var _updateBlockMetadata2 = _interopRequireDefault(_updateBlockMetadata);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (getEditorState, setEditorState) {
	    return function (block, metadata) {
	        var editorState = getEditorState();
	        var newEditorState = (0, _updateBlockMetadata2.default)(editorState, block, metadata);
	        setEditorState(newEditorState);
	    };
	};

/***/ }),
/* 1744 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	/**
	 * Stop editing on blur.
	 */
	exports.default = function (event, _ref) {
	    var getProps = _ref.getProps;
	
	    var _getProps = getProps(),
	        stopEditing = _getProps.stopEditing;
	
	    if (!stopEditing) return;
	
	    stopEditing();
	};

/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _browser = __webpack_require__(61);
	
	var _createMilanoteEditor = __webpack_require__(682);
	
	var _createMilanoteEditor2 = _interopRequireDefault(_createMilanoteEditor);
	
	var _linkify = __webpack_require__(686);
	
	var _linkify2 = _interopRequireDefault(_linkify);
	
	var _checklist = __webpack_require__(1724);
	
	var _checklist2 = _interopRequireDefault(_checklist);
	
	var _deleteOnEmpty = __webpack_require__(684);
	
	var _deleteOnEmpty2 = _interopRequireDefault(_deleteOnEmpty);
	
	var _markdownSupport = __webpack_require__(1736);
	
	var _markdownSupport2 = _interopRequireDefault(_markdownSupport);
	
	var _editingHelper = __webpack_require__(685);
	
	var _editingHelper2 = _interopRequireDefault(_editingHelper);
	
	var _milanoteShortcuts = __webpack_require__(687);
	
	var _milanoteShortcuts2 = _interopRequireDefault(_milanoteShortcuts);
	
	var _stopEditingOnBlur = __webpack_require__(688);
	
	var _stopEditingOnBlur2 = _interopRequireDefault(_stopEditingOnBlur);
	
	__webpack_require__(1142);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Plugins
	// Utils
	var checklistPlugin = (0, _checklist2.default)();
	
	// Styles
	
	
	// Editor
	
	var deleteOnEmptyPlugin = (0, _deleteOnEmpty2.default)();
	var markdownPlugin = (0, _markdownSupport2.default)();
	var editingHelperPlugin = (0, _editingHelper2.default)();
	var milanoteShortcutsPlugin = (0, _milanoteShortcuts2.default)();
	var linkifyPlugin = (0, _linkify2.default)();
	var stopEditingOnBlurPlugin = (0, _stopEditingOnBlur2.default)();
	
	var plugins = [linkifyPlugin, deleteOnEmptyPlugin, checklistPlugin, markdownPlugin, editingHelperPlugin, milanoteShortcutsPlugin];
	
	// Only stop editing for iPhones
	if ((0, _browser.isMobile)() && _browser.isApple) {
	    plugins.push(stopEditingOnBlurPlugin);
	}
	
	exports.default = (0, _createMilanoteEditor2.default)(plugins, { className: 'RichTextEditor' });

/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _browser = __webpack_require__(61);
	
	var _createMilanoteEditor = __webpack_require__(682);
	
	var _createMilanoteEditor2 = _interopRequireDefault(_createMilanoteEditor);
	
	var _linkify = __webpack_require__(686);
	
	var _linkify2 = _interopRequireDefault(_linkify);
	
	var _milanoteShortcuts = __webpack_require__(687);
	
	var _milanoteShortcuts2 = _interopRequireDefault(_milanoteShortcuts);
	
	var _deleteOnEmpty = __webpack_require__(684);
	
	var _deleteOnEmpty2 = _interopRequireDefault(_deleteOnEmpty);
	
	var _editingHelper = __webpack_require__(685);
	
	var _editingHelper2 = _interopRequireDefault(_editingHelper);
	
	var _stopEditingOnBlur = __webpack_require__(688);
	
	var _stopEditingOnBlur2 = _interopRequireDefault(_stopEditingOnBlur);
	
	__webpack_require__(1143);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Plugins
	// Utils
	var linkifyPlugin = (0, _linkify2.default)();
	
	// Styles
	
	
	// Components
	
	var deleteOnEmptyPlugin = (0, _deleteOnEmpty2.default)();
	var milanoteShortcutsPlugin = (0, _milanoteShortcuts2.default)();
	var editingHelperPlugin = (0, _editingHelper2.default)();
	var stopEditingOnBlurPlugin = (0, _stopEditingOnBlur2.default)();
	
	var plugins = [linkifyPlugin, milanoteShortcutsPlugin, deleteOnEmptyPlugin, editingHelperPlugin];
	
	// Only stop editing for iPhones
	if ((0, _browser.isMobile)() && _browser.isApple) {
	    plugins.push(stopEditingOnBlurPlugin);
	}
	
	exports.default = (0, _createMilanoteEditor2.default)(plugins, { className: 'SimpleTextEditor' });

/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _makeCustomProvider = __webpack_require__(764);
	
	var _makeCustomProvider2 = _interopRequireDefault(_makeCustomProvider);
	
	var _editorConstants = __webpack_require__(197);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Utils
	exports.default = (0, _makeCustomProvider2.default)(_editorConstants.EDITOR_STORE_NAME);
	
	// Constants

/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _editorStoreConnect = __webpack_require__(689);
	
	var _editorStoreConnect2 = _interopRequireDefault(_editorStoreConnect);
	
	var _editorActions = __webpack_require__(690);
	
	var _editorStoreSelector = __webpack_require__(691);
	
	var _milanoteReselect = __webpack_require__(49);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Simply separates the store connection logic out of the TextEditor components as they are already very large.
	 */
	
	// Utils
	var mapEditorDispatchToProps = function mapEditorDispatchToProps(dispatch) {
	    return {
	        editorStateChanged: function editorStateChanged(_ref) {
	            var editorId = _ref.editorId,
	                editorState = _ref.editorState;
	            return dispatch((0, _editorActions.editorStateChanged)({ editorId: editorId, editorState: editorState }));
	        }
	    };
	};
	
	var getEditorStateSlice = function getEditorStateSlice() {
	    return function (state, ownProps) {
	        return {
	            editorState: (0, _editorStoreSelector.getEditorState)(state),
	            isEditing: ownProps.isEditing && (0, _editorStoreSelector.getEditorId)(state) === ownProps.editorId
	        };
	    };
	};
	
	var editorStateSelectorEqualityChecker = function editorStateSelectorEqualityChecker(nextStateSlice, prevStateSlice) {
	    if (nextStateSlice.isEditing) {
	        return prevStateSlice.isEditing && prevStateSlice.editorState === nextStateSlice.editorState;
	    }
	
	    return true;
	};
	
	var createCustomEditorStateSelector = (0, _milanoteReselect.createCustomEqualShallowSelector)(editorStateSelectorEqualityChecker);
	
	var makeMapEditorStateToProps = function makeMapEditorStateToProps() {
	    return createCustomEditorStateSelector(getEditorStateSlice(), function (_ref2) {
	        var editorState = _ref2.editorState,
	            isEditing = _ref2.isEditing;
	        return {
	            editorState: isEditing ? editorState : null
	        };
	    });
	};
	
	exports.default = (0, _editorStoreConnect2.default)(makeMapEditorStateToProps, mapEditorDispatchToProps);

/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.LOG_FILTER_ACTIONS = undefined;
	exports.default = configureEditorStore;
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _redux = __webpack_require__(195);
	
	var _reduxLogger = __webpack_require__(289);
	
	var _getClientConfig = __webpack_require__(48);
	
	var _getClientConfig2 = _interopRequireDefault(_getClientConfig);
	
	var _index = __webpack_require__(1753);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _configConstants = __webpack_require__(135);
	
	var _editorConstants = __webpack_require__(197);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // Lib
	
	
	// Utils
	
	
	// Reducer
	
	
	// Constants
	
	
	// Actions to filter from the logger
	var LOG_FILTER_ACTIONS = exports.LOG_FILTER_ACTIONS = Immutable.Map(_defineProperty({}, _editorConstants.EDITOR_STATE_CHANGED, _configConstants.DEBUG_LEVEL.FINE));
	
	function configureEditorStore() {
	    var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Immutable.Map();
	
	    var middlewareList = [];
	    var config = (0, _getClientConfig2.default)();
	
	    if (config.debugLevel > _configConstants.DEBUG_LEVEL.OFF) {
	        var filteredActions = LOG_FILTER_ACTIONS.filter(function (logLevel) {
	            return logLevel >= config.debugLevel;
	        }).keySeq().toArray();
	
	        middlewareList.push((0, _reduxLogger.createLogger)({
	            predicate: function predicate(getState, action) {
	                return filteredActions.indexOf(action.type) === -1;
	            },
	            collapsed: true,
	            duration: true,
	            colors: {
	                title: function title(action) {
	                    return 'goldenrod';
	                }
	            }
	        }));
	    }
	
	    var middleware = _redux.applyMiddleware.apply(null, middlewareList);
	
	    return (0, _redux.createStore)(_index2.default, initialState, middleware);
	}

/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = editorIdReducer;
	
	var _editorConstants = __webpack_require__(197);
	
	var initialState = null;
	
	/**
	 * Stores a map of measurements of target IDs.
	 */
	// Constants
	function editorIdReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _editorConstants.EDITOR_STATE_CHANGED:
	            return action.editorId;
	        default:
	            return state;
	    }
	}

/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = editorStateReducer;
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _handleStyleCommand = __webpack_require__(1752);
	
	var _editorConstants = __webpack_require__(197);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Handlers
	var initialState = Immutable.Map();
	
	/**
	 * Stores a map of measurements of target IDs.
	 */
	
	
	// Constants
	// Lib
	function editorStateReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _editorConstants.EDITOR_STATE_CHANGED:
	            return action.editorState;
	        case _editorConstants.EDITOR_STYLE_COMMAND:
	            return (0, _handleStyleCommand.handleStyleCommand)(state, action);
	        default:
	            return state;
	    }
	}

/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.handleStyleCommand = undefined;
	
	var _draftJs = __webpack_require__(39);
	
	var _richTextConstants = __webpack_require__(166);
	
	// Lib
	var handleStyleCommand = exports.handleStyleCommand = function handleStyleCommand(state, action) {
	    var editorState = state;
	
	    var selection = action.selection,
	        styleCommand = action.styleCommand;
	
	
	    var styleType = _richTextConstants.STYLE_COMMAND_TYPES[styleCommand];
	
	    var toggleFn = styleType === _richTextConstants.STYLE_TYPES.INLINE ? _draftJs.RichUtils.toggleInlineStyle : _draftJs.RichUtils.toggleBlockType;
	
	    if (selection) {
	        editorState = _draftJs.EditorState.forceSelection(editorState, selection);
	    }
	
	    return toggleFn(editorState, styleCommand);
	};
	
	// Constants

/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxImmutable = __webpack_require__(73);
	
	var _editorStateReducer = __webpack_require__(1751);
	
	var _editorStateReducer2 = _interopRequireDefault(_editorStateReducer);
	
	var _editorIdReducer = __webpack_require__(1750);
	
	var _editorIdReducer2 = _interopRequireDefault(_editorIdReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Reducers
	exports.default = (0, _reduxImmutable.combineReducers)({
	    editorState: _editorStateReducer2.default,
	    editorId: _editorIdReducer2.default
	}); // Lib

/***/ }),
/* 1754 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var DEFAULT_SAVE_TIMEOUT = exports.DEFAULT_SAVE_TIMEOUT = 5000;
	
	var COMMANDS = exports.COMMANDS = {
	    clear: 'clear',
	    finishEditing: 'finishEditing',
	    onEmptyBackspace: 'onEmptyBackspace'
	};

/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _electronSelector = __webpack_require__(692);
	
	var _electronSelector2 = _interopRequireDefault(_electronSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ElectronVisible = function ElectronVisible(_ref) {
	    var children = _ref.children,
	        isElectron = _ref.isElectron;
	    return isElectron ? children : null;
	};
	
	ElectronVisible.propTypes = {
	    isElectron: _react2.default.PropTypes.bool,
	    children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node])
	};
	
	exports.default = (0, _reactRedux.connect)(_electronSelector2.default)(ElectronVisible);

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.findDefaultIcon = undefined;
	
	var _elementActions = __webpack_require__(26);
	
	var _elementIconService = __webpack_require__(693);
	
	var _elementHelper = __webpack_require__(13);
	
	var _makeStringIconDef = __webpack_require__(430);
	
	var _makeStringIconDef2 = _interopRequireDefault(_makeStringIconDef);
	
	var _stringUtil = __webpack_require__(58);
	
	var _elementConstants = __webpack_require__(12);
	
	var TYPES = _interopRequireWildcard(_elementConstants);
	
	var _boardConstants = __webpack_require__(17);
	
	var _elementIconConstants = __webpack_require__(429);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var makeFallbackBoardIcon = function makeFallbackBoardIcon(_ref) {
	    var id = _ref.id,
	        transactionId = _ref.transactionId;
	    return function (dispatch, getState) {
	        var state = getState();
	        var element = state.get('elements').get(id);
	        var title = element && element.getIn(['content', 'title']) || _boardConstants.BOARD_DEFAULT_TITLE;
	        var stringIcon = void 0;
	
	        if (title === _boardConstants.BOARD_DEFAULT_TITLE) {
	            var elementParentId = element.getIn(['location', 'parentId']);
	            var peerBoards = (0, _elementHelper.getChildren)(state.get('elements'), elementParentId).filter(function (el) {
	                return el.get('elementType') === _boardConstants.BOARD_TYPE && el.getIn(['content', 'title']) === _boardConstants.BOARD_DEFAULT_TITLE;
	            });
	
	            var boardsCount = peerBoards.size % 10;
	            stringIcon = (0, _makeStringIconDef2.default)(boardsCount.toString(10));
	        } else {
	            var titleLetters = (0, _stringUtil.slugify)(title, '-').split('-').map(function (word) {
	                return word[0];
	            });
	            if (titleLetters <= _elementIconConstants.STRING_ICON_MAX_LENGTH) {
	                stringIcon = (0, _makeStringIconDef2.default)(titleLetters.join(''));
	            } else {
	                stringIcon = (0, _makeStringIconDef2.default)(titleLetters[0]);
	            }
	        }
	
	        dispatch((0, _elementActions.updateElement)({
	            type: TYPES.ELEMENT_UPDATE,
	            id: id,
	            changes: {
	                icon: stringIcon
	            },
	            transactionId: transactionId
	        }));
	    };
	};
	
	var findDefaultIcon = exports.findDefaultIcon = function findDefaultIcon(_ref2) {
	    var id = _ref2.id,
	        query = _ref2.query,
	        transactionId = _ref2.transactionId;
	    return function (dispatch, getState) {
	        var element = getState().get('elements').get(id);
	        var title = element && element.get('content').get('title') || _boardConstants.BOARD_DEFAULT_TITLE;
	
	        if (title === _boardConstants.BOARD_DEFAULT_TITLE) {
	            return dispatch(makeFallbackBoardIcon({ id: id, transactionId: transactionId }));
	        }
	
	        dispatch({
	            type: TYPES.ELEMENT_ICON_FIND,
	            id: id,
	            query: query
	        });
	
	        (0, _elementIconService.searchForIcon)(query, 1).then(function (response) {
	            var icons = response.data.icons;
	
	            if (!icons.length) throw new Error('No icons found');
	
	            dispatch({ type: TYPES.ELEMENT_ICON_FIND_SUCCESS, id: id });
	
	            var icon = icons[0];
	
	            dispatch((0, _elementActions.updateElement)({
	                type: TYPES.ELEMENT_UPDATE,
	                id: id,
	                changes: {
	                    icon: icon
	                },
	                transactionId: transactionId
	            }));
	        }).catch(function () {
	            dispatch(makeFallbackBoardIcon({ id: id, transactionId: transactionId }));
	        });
	    };
	};

/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(9);
	
	var _LogoSpinner = __webpack_require__(707);
	
	var _LogoSpinner2 = _interopRequireDefault(_LogoSpinner);
	
	var _socketConstants = __webpack_require__(109);
	
	__webpack_require__(1146);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Constants
	var SocketConnectionStatusError = function SocketConnectionStatusError(props) {
	    var socketConnection = props.socketConnection;
	
	
	    if (socketConnection.get('status') !== _socketConstants.SOCKET_CONNECTION_STATUS.DISCONNECTED) return null;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'SocketConnectionStatusError' },
	        _react2.default.createElement(_LogoSpinner2.default, null),
	        _react2.default.createElement(
	            'p',
	            null,
	            'Reconnecting'
	        )
	    );
	};
	
	// Styles
	
	
	// Components
	
	
	SocketConnectionStatusError.propTypes = {
	    socketConnection: _propTypes2.default.object
	};
	
	exports.default = (0, _recompose.pure)(SocketConnectionStatusError);

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ERROR_MODALS_MAP, _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reselect = __webpack_require__(7);
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _boardSelector = __webpack_require__(83);
	
	var _errorModalSelector = __webpack_require__(1771);
	
	var _permissionsService = __webpack_require__(75);
	
	var _permissionUtil = __webpack_require__(89);
	
	var _rollbarService = __webpack_require__(226);
	
	var _navigationActions = __webpack_require__(27);
	
	var _errorModalActions = __webpack_require__(1768);
	
	var _currentBoardIdActions = __webpack_require__(750);
	
	var _ModalManager = __webpack_require__(713);
	
	var _ModalManager2 = _interopRequireDefault(_ModalManager);
	
	var _UnknownErrorModal = __webpack_require__(1767);
	
	var _UnknownErrorModal2 = _interopRequireDefault(_UnknownErrorModal);
	
	var _BoardSimpleErrorModal = __webpack_require__(1765);
	
	var _BoardSimpleErrorModal2 = _interopRequireDefault(_BoardSimpleErrorModal);
	
	var _BoardAccessDeniedModal = __webpack_require__(1764);
	
	var _BoardAccessDeniedModal2 = _interopRequireDefault(_BoardAccessDeniedModal);
	
	var _TimeoutErrorModal = __webpack_require__(1766);
	
	var _TimeoutErrorModal2 = _interopRequireDefault(_TimeoutErrorModal);
	
	var _errorConstants = __webpack_require__(243);
	
	var _rollbarConstants = __webpack_require__(420);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // Lib
	
	
	// Selectors
	
	
	// Utils
	
	
	// Actions
	
	
	// Components
	
	
	// Constants
	
	
	var READ_PERMISSIONS = (0, _permissionUtil.calculatePermissionValue)({
	    read: true,
	    write: false,
	    owner: false,
	    permissions: false,
	    save: false
	});
	
	var ERROR_MODALS_MAP = (_ERROR_MODALS_MAP = {
	    // Unknown error
	    default: _UnknownErrorModal2.default
	}, _defineProperty(_ERROR_MODALS_MAP, _errorConstants.BOARD_ERROR.GENERIC_ERROR, _UnknownErrorModal2.default), _defineProperty(_ERROR_MODALS_MAP, _errorConstants.BOARD_ERROR.DELETED, _BoardSimpleErrorModal2.default), _defineProperty(_ERROR_MODALS_MAP, _errorConstants.BOARD_ERROR.NOT_FOUND, _BoardSimpleErrorModal2.default), _defineProperty(_ERROR_MODALS_MAP, 'credentials_required', _BoardAccessDeniedModal2.default), _defineProperty(_ERROR_MODALS_MAP, _errorConstants.BOARD_ERROR.ACCESS_DENIED, _BoardAccessDeniedModal2.default), _defineProperty(_ERROR_MODALS_MAP, _errorConstants.BOARD_ERROR.TIMEOUT, _TimeoutErrorModal2.default), _defineProperty(_ERROR_MODALS_MAP, _errorConstants.BOARD_ERROR.CONNECTION_LOST, _TimeoutErrorModal2.default), _ERROR_MODALS_MAP);
	
	var isNetworkError = function isNetworkError(errorDetails) {
	    return errorDetails && (errorDetails.code === _errorConstants.BOARD_ERROR.TIMEOUT || errorDetails.code === _errorConstants.BOARD_ERROR.CONNECTION_LOST);
	};
	
	var getBoardPermissionsError = function getBoardPermissionsError(elements, currentBoardId, currentUserId) {
	    var accessDenied = (0, _permissionsService.confirmedInvalidPermissions)(elements, currentBoardId, currentUserId, READ_PERMISSIONS);
	    if (!accessDenied) return null;
	
	    return Immutable.fromJS({
	        code: _errorConstants.BOARD_ERROR.ACCESS_DENIED,
	        message: "You don't have access to this board"
	    });
	};
	
	var workspaceErrorSelector = (0, _reselect.createSelector)(function (state) {
	    return state.get('elements');
	}, function (state, ownProps) {
	    return ownProps.currentBoardId;
	}, function (state) {
	    return state.getIn(['app', 'currentUser', '_id']);
	}, function (state, ownProps) {
	    return state.getIn(['app', 'currentUser']);
	}, _boardSelector.getCurrentBoardError, _boardSelector.getIsCurrentBoardFetched, _errorModalSelector.getActiveErrorModalId, _errorModalSelector.getErrorModalData, function (elements, currentBoardId, currentUserId, currentUser, currentBoardError, isCurrentBoardFetched, activeErrorModalId, errorModalData) {
	    return {
	        permissionsError: getBoardPermissionsError(elements, currentBoardId, currentUserId),
	        currentUser: currentUser,
	        currentBoardError: currentBoardError,
	        isCurrentBoardFetched: isCurrentBoardFetched,
	        activeErrorModalId: activeErrorModalId,
	        errorModalData: errorModalData
	    };
	});
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        navigateToLogin: function navigateToLogin() {
	            return dispatch((0, _navigationActions.navigateToLogin)());
	        },
	        dispatchModalOpen: function dispatchModalOpen(_ref) {
	            var modalId = _ref.modalId,
	                data = _ref.data;
	            return dispatch((0, _errorModalActions.errorModalOpen)({ modalId: modalId, data: data }));
	        },
	        dispatchModalClose: function dispatchModalClose() {
	            return dispatch((0, _errorModalActions.errorModalClose)());
	        },
	        dispatchCurrentBoardIdSet: function dispatchCurrentBoardIdSet(_ref2) {
	            var boardId = _ref2.boardId;
	            return dispatch((0, _currentBoardIdActions.currentBoardIdSet)({ boardId: boardId }));
	        }
	    };
	};
	
	var WorkspaceErrorModalManager = (_dec = (0, _reactRedux.connect)(workspaceErrorSelector, mapDispatchToProps), _dec(_class = function (_React$Component) {
	    _inherits(WorkspaceErrorModalManager, _React$Component);
	
	    function WorkspaceErrorModalManager() {
	        var _ref3;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, WorkspaceErrorModalManager);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = WorkspaceErrorModalManager.__proto__ || Object.getPrototypeOf(WorkspaceErrorModalManager)).call.apply(_ref3, [this].concat(args))), _this), _this.getErrorFromProps = function (props) {
	            return props.currentBoardError || props.permissionsError;
	        }, _this.getWorkspaceError = function (props) {
	            var isCurrentBoardFetched = props.isCurrentBoardFetched,
	                dispatchModalOpen = props.dispatchModalOpen,
	                currentBoardId = props.currentBoardId;
	            // If we don't have the board then we need to wait for it before displaying an error
	
	            if (!isCurrentBoardFetched) return null;
	            var error = _this.getErrorFromProps(props);
	            if (!error) return null;
	            var modalId = error.get('code') || _errorConstants.BOARD_ERROR.GENERIC_ERROR;
	            dispatchModalOpen({ modalId: modalId, data: { error: error.toJS(), boardId: currentBoardId } });
	            _this.viewPreviousOrRootBoard(props, error);
	            return error;
	        }, _this.viewPreviousOrRootBoard = function (_ref4, errorDetails) {
	            var currentBoardId = _ref4.currentBoardId,
	                currentUser = _ref4.currentUser,
	                dispatchCurrentBoardIdSet = _ref4.dispatchCurrentBoardIdSet;
	
	            var rootBoardId = currentUser.get('rootBoardId');
	            var isGuest = currentUser.get('isGuest');
	
	            // TODO Change this logic if we instead navigate to the previous board
	            if (isGuest) return;
	
	            var details = errorDetails.toJS();
	            if (currentBoardId !== rootBoardId) {
	                return dispatchCurrentBoardIdSet({ boardId: rootBoardId });
	            }
	
	            // Is root board and is not network error
	            if (!isNetworkError(details)) {
	                var errorMessage = 'The root board has an error, this cannot be recovered from.';
	                var error = { id: details.id, rootBoardId: rootBoardId, errorMessage: errorMessage, details: details };
	                (0, _rollbarService.manuallyReportError)({ errorMessage: errorMessage, error: error, sensitive: false, level: _rollbarConstants.ROLLBAR_LEVELS.CRITICAL });
	                console.error(errorMessage, rootBoardId, errorDetails);
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(WorkspaceErrorModalManager, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            if (this.getErrorFromProps(this.props)) this.getWorkspaceError(this.props);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var location = nextProps.location,
	                permissionsError = nextProps.permissionsError,
	                currentUser = nextProps.currentUser,
	                dispatchModalClose = nextProps.dispatchModalClose,
	                activeErrorModalId = nextProps.activeErrorModalId;
	
	            // A guest user has a permissions error, so just redirect them to login instead of
	
	            if (permissionsError && currentUser && currentUser.get('isGuest')) {
	                nextProps.navigateToLogin();
	            }
	
	            // If there's an error modal active, close it on route change
	            if (activeErrorModalId && location.pathname !== this.props.location.pathname) {
	                dispatchModalClose();
	            }
	
	            // Only attempt to open the modal if there is a new error, this should prevent infinite recursions
	            if (this.getErrorFromProps(this.props) !== this.getErrorFromProps(nextProps)) {
	                this.getWorkspaceError(nextProps);
	            }
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            if (this.props.permissionsError !== nextProps.permissionsError) return true;
	
	            return nextProps.activeErrorModalId !== this.props.activeErrorModalId;
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            var _props = this.props,
	                activeErrorModalId = _props.activeErrorModalId,
	                dispatchModalClose = _props.dispatchModalClose;
	
	            if (activeErrorModalId) dispatchModalClose();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                activeErrorModalId = _props2.activeErrorModalId,
	                errorModalData = _props2.errorModalData,
	                dispatchModalClose = _props2.dispatchModalClose;
	
	
	            var modalComponent = null;
	
	            if (activeErrorModalId) {
	                var ActiveModal = ERROR_MODALS_MAP[activeErrorModalId] || ERROR_MODALS_MAP.default;
	                modalComponent = _react2.default.createElement(ActiveModal, _extends({}, errorModalData.toJS(), this.props));
	            }
	
	            return _react2.default.createElement(
	                _ModalManager2.default,
	                { dispatchModalClose: dispatchModalClose },
	                modalComponent
	            );
	        }
	    }]);
	
	    return WorkspaceErrorModalManager;
	}(_react2.default.Component)) || _class);
	
	
	WorkspaceErrorModalManager.propTypes = {
	    permissionsError: _propTypes2.default.object,
	    currentBoardId: _propTypes2.default.string,
	    navigateToLogin: _propTypes2.default.func,
	    currentBoardError: _propTypes2.default.func,
	    isCurrentBoardFetched: _propTypes2.default.bool,
	    activeErrorModalId: _propTypes2.default.string,
	    dispatchModalOpen: _propTypes2.default.func,
	    dispatchModalClose: _propTypes2.default.func,
	    dispatchCurrentBoardIdSet: _propTypes2.default.func,
	    location: _propTypes2.default.object.isRequired,
	    errorModalData: _propTypes2.default.object
	};
	
	exports.default = WorkspaceErrorModalManager;

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FullScreenErrorModal = __webpack_require__(139);
	
	var _FullScreenErrorModal2 = _interopRequireDefault(_FullScreenErrorModal);
	
	var _ModalActionsList = __webpack_require__(126);
	
	var _ModalActionsList2 = _interopRequireDefault(_ModalActionsList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	var BrowserCookieFullScreenWarning = function BrowserCookieFullScreenWarning(props) {
	    return _react2.default.createElement(
	        _FullScreenErrorModal2.default,
	        null,
	        _react2.default.createElement(
	            'h2',
	            null,
	            'Sorry, you need to enable storage to use Milanote'
	        ),
	        _react2.default.createElement(
	            'p',
	            { className: 'explanation' },
	            'Milanote uses your browser\'s storage to save data while you\'re working, please enable it and try again.'
	        ),
	        _react2.default.createElement(_ModalActionsList2.default, { actions: [{ text: 'Find out more', href: 'http://www.whatarecookies.com/' }] })
	    );
	}; // Lib
	
	
	BrowserCookieFullScreenWarning.propTypes = {};
	
	exports.default = BrowserCookieFullScreenWarning;

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _browserDetectionService = __webpack_require__(695);
	
	var _browser = __webpack_require__(61);
	
	var _BrowserWarning = __webpack_require__(1762);
	
	var _BrowserWarning2 = _interopRequireDefault(_BrowserWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	// Utils
	
	
	// Components
	
	
	var BrowserDetection = function (_React$Component) {
	    _inherits(BrowserDetection, _React$Component);
	
	    function BrowserDetection() {
	        _classCallCheck(this, BrowserDetection);
	
	        var _this = _possibleConstructorReturn(this, (BrowserDetection.__proto__ || Object.getPrototypeOf(BrowserDetection)).call(this));
	
	        _this.state = {
	            supportedBrowser: false,
	            acknowledgement: false,
	            features: {
	                isValid: true,
	                errors: []
	            }
	        };
	
	        _this.acknowledgeUnsupportedBrowser = _this.acknowledgeUnsupportedBrowser.bind(_this);
	        return _this;
	    }
	
	    _createClass(BrowserDetection, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var supportedBrowser = (0, _browserDetectionService.isSupportedBrowser)();
	            var requiredFeatureValidationResult = (0, _browserDetectionService.validateRequiredFeatures)();
	
	            var acknowledgement = false;
	            if (!supportedBrowser || !requiredFeatureValidationResult.isSupported) {
	                acknowledgement = (0, _browserDetectionService.getBrowserUnsupportedAcknowledgement)();
	            }
	
	            this.setState({
	                supportedBrowser: supportedBrowser,
	                acknowledgement: acknowledgement,
	                features: requiredFeatureValidationResult
	            });
	
	            if ((0, _browser.isSafari)()) this.setBodyClass('safari');
	            if ((0, _browser.isMobile)()) this.setBodyClass('touch-device');
	        }
	    }, {
	        key: 'setBodyClass',
	        value: function setBodyClass(className) {
	            document.body.classList.add(className);
	        }
	    }, {
	        key: 'acknowledgeUnsupportedBrowser',
	        value: function acknowledgeUnsupportedBrowser() {
	            // Save the decision to local storage so they don't keep on getting asked on page refresh
	            (0, _browserDetectionService.setBrowserUnsupportedAcknowledgement)();
	            // Save the decision to state so they are presented with the workspace / login page
	            this.setState({ acknowledgement: true });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _state = this.state,
	                supportedBrowser = _state.supportedBrowser,
	                features = _state.features,
	                acknowledgement = _state.acknowledgement;
	
	
	            return _react2.default.createElement(_BrowserWarning2.default, {
	                acknowledgeUnsupportedBrowser: this.acknowledgeUnsupportedBrowser,
	                supportedBrowser: supportedBrowser,
	                features: features,
	                acknowledgement: acknowledgement });
	        }
	    }]);
	
	    return BrowserDetection;
	}(_react2.default.Component);
	
	BrowserDetection.propTypes = {
	    children: _propTypes2.default.element
	};
	
	exports.default = BrowserDetection;

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FullScreenErrorModal = __webpack_require__(139);
	
	var _FullScreenErrorModal2 = _interopRequireDefault(_FullScreenErrorModal);
	
	var _ModalActionsList = __webpack_require__(126);
	
	var _ModalActionsList2 = _interopRequireDefault(_ModalActionsList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	// Lib
	var BrowserUnsupportedFullScreenWarning = function BrowserUnsupportedFullScreenWarning(props) {
	    var actions = [{ text: 'Install Google Chrome instead...', href: 'https://www.google.com.au/chrome/' }, { text: 'Continue anyway', func: props.acknowledgeUnsupportedBrowser }];
	
	    return _react2.default.createElement(
	        _FullScreenErrorModal2.default,
	        null,
	        _react2.default.createElement(
	            'h2',
	            null,
	            'Sorry, your browser isn\'t supported yet'
	        ),
	        _react2.default.createElement(
	            'p',
	            { className: 'explanation' },
	            'We\'re working hard to make Milanote work in Microsoft Edge, but we\'re not there yet.'
	        ),
	        _react2.default.createElement(_ModalActionsList2.default, { actions: actions })
	    );
	};
	
	BrowserUnsupportedFullScreenWarning.propTypes = {
	    permissionsError: _propTypes2.default.object,
	    currentBoard: _propTypes2.default.object,
	    acknowledgeUnsupportedBrowser: _propTypes2.default.func.isRequired
	};
	
	exports.default = BrowserUnsupportedFullScreenWarning;

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _BrowserUnsupportedFullScreenWarning = __webpack_require__(1761);
	
	var _BrowserUnsupportedFullScreenWarning2 = _interopRequireDefault(_BrowserUnsupportedFullScreenWarning);
	
	var _BrowserCookieFullScreenWarning = __webpack_require__(1759);
	
	var _BrowserCookieFullScreenWarning2 = _interopRequireDefault(_BrowserCookieFullScreenWarning);
	
	var _browserDetectionService = __webpack_require__(695);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BrowserWarning = function BrowserWarning(props) {
	    var supportedBrowser = props.supportedBrowser,
	        features = props.features,
	        acknowledgement = props.acknowledgement;
	
	
	    var showBrowserWarning = (!supportedBrowser || !features.isSupported) && !acknowledgement;
	
	    if (!showBrowserWarning) return null;
	
	    if (!features.isSupported && features.errors.indexOf(_browserDetectionService.LOCAL_STORAGE_FEATURE_NAME) !== -1) {
	        return _react2.default.createElement(_BrowserCookieFullScreenWarning2.default, props);
	    }
	
	    return _react2.default.createElement(_BrowserUnsupportedFullScreenWarning2.default, props);
	};
	
	// Constants
	
	
	// Components
	// Lib
	
	
	BrowserWarning.propTypes = {
	    supportedBrowser: _propTypes2.default.bool,
	    features: _propTypes2.default.object,
	    acknowledgement: _propTypes2.default.bool,
	    acknowledgeUnsupportedBrowser: _propTypes2.default.func.isRequired
	};
	
	exports.default = BrowserWarning;

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _errorModalConstants = __webpack_require__(431);
	
	var initialState = null;
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _errorModalConstants.ERROR_MODAL_OPEN:
	            return action.modalId;
	        case _errorModalConstants.ERROR_MODAL_CLOSE:
	            return initialState;
	        default:
	            return state;
	    }
	};

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _recompose = __webpack_require__(9);
	
	var _navigationActions = __webpack_require__(27);
	
	var _FullScreenErrorModal = __webpack_require__(139);
	
	var _FullScreenErrorModal2 = _interopRequireDefault(_FullScreenErrorModal);
	
	var _ModalActionsList = __webpack_require__(126);
	
	var _ModalActionsList2 = _interopRequireDefault(_ModalActionsList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        currentUser: state.getIn(['app', 'currentUser'])
	    };
	};
	
	// Actions
	// Lib
	
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        navigateToLogin: function navigateToLogin(event) {
	            event.preventDefault();
	            dispatch((0, _navigationActions.navigateToLogin)());
	        }
	    };
	};
	
	var BoardAccessDeniedModal = function BoardAccessDeniedModal(props) {
	    var currentUser = props.currentUser,
	        close = props.close;
	
	
	    var isGuest = currentUser.get('isGuest');
	
	    var guestActions = [{ text: 'Log in', func: props.navigateToLogin }];
	    var loggedInActions = [{ text: 'Log in as someone else', func: props.navigateToLogin }];
	    var actions = isGuest ? guestActions : loggedInActions;
	
	    var loggedInMessage = isGuest ? null : _react2.default.createElement(
	        'p',
	        { className: 'details secondary' },
	        'You\'re currently logged in as:',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	            'strong',
	            null,
	            currentUser.get('email')
	        )
	    );
	
	    return _react2.default.createElement(
	        _FullScreenErrorModal2.default,
	        { overlay: true, close: close },
	        _react2.default.createElement(
	            'h2',
	            null,
	            'You don\'t have permission to view this board'
	        ),
	        _react2.default.createElement(_ModalActionsList2.default, { actions: actions }),
	        loggedInMessage
	    );
	};
	
	BoardAccessDeniedModal.propTypes = {
	    requestAccess: _propTypes2.default.func,
	    navigateToLogin: _propTypes2.default.func,
	    currentUser: _propTypes2.default.object,
	    close: _propTypes2.default.func
	};
	
	var enhance = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps));
	
	exports.default = enhance(BoardAccessDeniedModal);

/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _recompose = __webpack_require__(9);
	
	var _immutableHelper = __webpack_require__(23);
	
	var _navigationActions = __webpack_require__(27);
	
	var _FullScreenErrorModal = __webpack_require__(139);
	
	var _FullScreenErrorModal2 = _interopRequireDefault(_FullScreenErrorModal);
	
	var _ModalActionsList = __webpack_require__(126);
	
	var _ModalActionsList2 = _interopRequireDefault(_ModalActionsList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	
	
	// Utils
	// Lib
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        currentUser: state.getIn(['app', 'currentUser'])
	    };
	};
	
	// Actions
	
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        navigateToLogin: function navigateToLogin(event) {
	            event.preventDefault();
	            dispatch((0, _navigationActions.navigateToLogin)());
	        }
	    };
	};
	
	var BoardSimpleErrorModal = function BoardSimpleErrorModal(props) {
	    var error = props.error,
	        currentUser = props.currentUser,
	        close = props.close;
	
	
	    var isGuest = currentUser.get('isGuest');
	
	    var guestActions = [{ text: 'Log in', func: props.navigateToLogin }];
	    var loggedInActions = [];
	    var actions = isGuest ? guestActions : loggedInActions;
	
	    return _react2.default.createElement(
	        _FullScreenErrorModal2.default,
	        { overlay: true, close: close },
	        _react2.default.createElement(
	            'h2',
	            null,
	            (0, _immutableHelper.prop)('message', error)
	        ),
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'p',
	                null,
	                'Sorry, the board you\'re trying to access no longer exists.'
	            ),
	            _react2.default.createElement(_ModalActionsList2.default, { actions: actions })
	        )
	    );
	};
	
	BoardSimpleErrorModal.propTypes = {
	    navigateToLogin: _propTypes2.default.func,
	    error: _propTypes2.default.object,
	    currentUser: _propTypes2.default.object,
	    close: _propTypes2.default.func
	};
	
	var enhance = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps));
	
	exports.default = enhance(BoardSimpleErrorModal);

/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _recompose = __webpack_require__(9);
	
	var _getErrorEmailHref = __webpack_require__(697);
	
	var _getErrorEmailHref2 = _interopRequireDefault(_getErrorEmailHref);
	
	var _navigationActions = __webpack_require__(27);
	
	var _FullScreenErrorModal = __webpack_require__(139);
	
	var _FullScreenErrorModal2 = _interopRequireDefault(_FullScreenErrorModal);
	
	var _ModalActionsList = __webpack_require__(126);
	
	var _ModalActionsList2 = _interopRequireDefault(_ModalActionsList);
	
	var _notificationConstants = __webpack_require__(88);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Actions
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        currentUser: state.getIn(['app', 'currentUser'])
	    };
	};
	
	// Constants
	
	
	// Components
	
	
	// Utils
	// Lib
	
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        dispatchRefreshPage: function dispatchRefreshPage(event) {
	            event.preventDefault();
	            dispatch((0, _navigationActions.refreshPage)());
	        }
	    };
	};
	
	var TimeoutErrorModal = function TimeoutErrorModal(_ref) {
	    var error = _ref.error,
	        boardId = _ref.boardId,
	        currentUser = _ref.currentUser,
	        dispatchRefreshPage = _ref.dispatchRefreshPage,
	        close = _ref.close;
	
	    var actions = [{ text: 'Refresh page', func: dispatchRefreshPage }];
	
	    var emailConfig = {
	        error: error,
	        boardId: boardId,
	        currentUser: currentUser,
	        subject: 'Milanote page load issue',
	        introduction: 'I encountered an issue while loading a Milanote page.'
	    };
	
	    return _react2.default.createElement(
	        _FullScreenErrorModal2.default,
	        { close: close },
	        _react2.default.createElement(
	            'h2',
	            null,
	            'Something went wrong'
	        ),
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'p',
	                null,
	                'For some reason it\'s taking an unusually long time to load your content. This often resolves itself after a few minutes \u2014 please try again soon.'
	            ),
	            _react2.default.createElement(_ModalActionsList2.default, { actions: actions })
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'section' },
	            _react2.default.createElement(
	                'p',
	                null,
	                'Contact',
	                ' ',
	                _react2.default.createElement(
	                    'a',
	                    { href: (0, _getErrorEmailHref2.default)(emailConfig) },
	                    _notificationConstants.MILANOTE_EMAILS.SUPPORT
	                ),
	                ' ',
	                'for more help.'
	            )
	        )
	    );
	};
	
	TimeoutErrorModal.propTypes = {
	    error: _propTypes2.default.object,
	    boardId: _propTypes2.default.string,
	    currentUser: _propTypes2.default.object,
	    dispatchRefreshPage: _propTypes2.default.func,
	    close: _propTypes2.default.func
	};
	
	var enhance = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps));
	
	exports.default = enhance(TimeoutErrorModal);

/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _recompose = __webpack_require__(9);
	
	var _immutableHelper = __webpack_require__(23);
	
	var _getErrorEmailHref = __webpack_require__(697);
	
	var _getErrorEmailHref2 = _interopRequireDefault(_getErrorEmailHref);
	
	var _rollbarService = __webpack_require__(226);
	
	var _navigationActions = __webpack_require__(27);
	
	var _FullScreenErrorModal = __webpack_require__(139);
	
	var _FullScreenErrorModal2 = _interopRequireDefault(_FullScreenErrorModal);
	
	var _ModalActionsList = __webpack_require__(126);
	
	var _ModalActionsList2 = _interopRequireDefault(_ModalActionsList);
	
	var _notificationConstants = __webpack_require__(88);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	// Util
	
	
	// Actions
	
	
	// Components
	
	
	// Constants
	
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        currentUser: state.getIn(['app', 'currentUser']),
	        isGuest: state.getIn(['app', 'currentUser', 'isGuest'])
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        backToLogin: function backToLogin(event) {
	            event.preventDefault();
	            dispatch((0, _navigationActions.navigateToLogin)());
	        }
	    };
	};
	
	/**
	 * This component is intended to be used when an unknown / unhandled error occurs.
	 * For example we already handle the board timeout issue, but if we didn't then this modal would be defaulted to.
	 */
	
	var UnknownErrorModal = function (_React$Component) {
	    _inherits(UnknownErrorModal, _React$Component);
	
	    function UnknownErrorModal() {
	        _classCallCheck(this, UnknownErrorModal);
	
	        return _possibleConstructorReturn(this, (UnknownErrorModal.__proto__ || Object.getPrototypeOf(UnknownErrorModal)).apply(this, arguments));
	    }
	
	    _createClass(UnknownErrorModal, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            (0, _rollbarService.manuallyReportError)({
	                error: this.props.error,
	                sensitive: false
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                error = _props.error,
	                isGuest = _props.isGuest,
	                boardId = _props.boardId,
	                backToLogin = _props.backToLogin,
	                currentUser = _props.currentUser,
	                close = _props.close;
	
	            var code = (0, _immutableHelper.prop)('code', error) || 'UNKNOWN_ERROR';
	            var id = (0, _immutableHelper.prop)('id', error);
	
	            var idComponent = id ? _react2.default.createElement(
	                'p',
	                { className: 'info' },
	                'Error ID: ',
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    id
	                )
	            ) : null;
	
	            var guestActions = [{ text: 'Log in', func: backToLogin }];
	            var loggedInActions = [];
	            var actions = isGuest ? guestActions : loggedInActions;
	
	            var emailConfig = {
	                error: error,
	                boardId: boardId,
	                currentUser: currentUser,
	                subject: 'Milanote issue',
	                introduction: 'I encountered an issue while using Milanote.'
	            };
	
	            return _react2.default.createElement(
	                _FullScreenErrorModal2.default,
	                { close: close },
	                _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Something went wrong'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'We apologise for the inconvenience, the error has been logged and we\'ll try to resolve it soon.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Please try again later.'
	                    ),
	                    _react2.default.createElement(_ModalActionsList2.default, { actions: actions })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'section' },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Contact',
	                        ' ',
	                        _react2.default.createElement(
	                            'a',
	                            { href: (0, _getErrorEmailHref2.default)(emailConfig) },
	                            _notificationConstants.MILANOTE_EMAILS.SUPPORT
	                        ),
	                        ' ',
	                        'for more help.'
	                    ),
	                    idComponent,
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'info' },
	                        'Error code: ',
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            code
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return UnknownErrorModal;
	}(_react2.default.Component);
	
	UnknownErrorModal.propTypes = {
	    error: _propTypes2.default.object,
	    currentUser: _propTypes2.default.object,
	    isGuest: _propTypes2.default.bool,
	    backToLogin: _propTypes2.default.func,
	    close: _propTypes2.default.func,
	    boardId: _propTypes2.default.string
	};
	
	var enhance = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps));
	
	exports.default = enhance(UnknownErrorModal);

/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.errorModalClose = exports.errorModalOpen = undefined;
	
	var _errorModalConstants = __webpack_require__(431);
	
	var errorModalOpen = exports.errorModalOpen = function errorModalOpen(_ref) {
	  var modalId = _ref.modalId,
	      data = _ref.data;
	  return { type: _errorModalConstants.ERROR_MODAL_OPEN, modalId: modalId, data: data };
	}; // Constants
	var errorModalClose = exports.errorModalClose = function errorModalClose() {
	  return { type: _errorModalConstants.ERROR_MODAL_CLOSE };
	};

/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _errorModalConstants = __webpack_require__(431);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Lib
	var initialState = Immutable.Map();
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _errorModalConstants.ERROR_MODAL_OPEN:
	            return action.data ? Immutable.fromJS(action.data) : initialState;
	        default:
	            return state;
	    }
	};

/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxImmutable = __webpack_require__(73);
	
	var _activeErrorModalIdReducer = __webpack_require__(1763);
	
	var _activeErrorModalIdReducer2 = _interopRequireDefault(_activeErrorModalIdReducer);
	
	var _errorModalDataReducer = __webpack_require__(1769);
	
	var _errorModalDataReducer2 = _interopRequireDefault(_errorModalDataReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _reduxImmutable.combineReducers)({
	    activeModalId: _activeErrorModalIdReducer2.default,
	    data: _errorModalDataReducer2.default
	}); // Lib

/***/ }),
/* 1771 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getActiveErrorModalId = exports.getActiveErrorModalId = function getActiveErrorModalId(state) {
	  return state.getIn(['app', 'modal', 'errorModal', 'activeModalId']);
	};
	var getErrorModalData = exports.getErrorModalData = function getErrorModalData(state) {
	  return state.getIn(['app', 'modal', 'errorModal', 'data']);
	};

/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _FormInput = __webpack_require__(96);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _FieldValidationMessages = __webpack_require__(122);
	
	var _FieldValidationMessages2 = _interopRequireDefault(_FieldValidationMessages);
	
	var _Fieldset = __webpack_require__(698);
	
	var _Fieldset2 = _interopRequireDefault(_Fieldset);
	
	var _LinkButton = __webpack_require__(74);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	var _FieldRow = __webpack_require__(1781);
	
	var _FieldRow2 = _interopRequireDefault(_FieldRow);
	
	var _Field = __webpack_require__(1780);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _creditCardFormatters = __webpack_require__(1775);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CreditCard = function CreditCard(props) {
	    var sanitisedErrors = props.sanitisedErrors,
	        fields = props.fields,
	        dispatchClearCard = props.dispatchClearCard;
	
	
	    var disabled = !!fields.cardPrefilled.value;
	
	    return _react2.default.createElement(
	        _Fieldset2.default,
	        _extends({}, props, { name: 'CreditCard' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'form-header' },
	            _react2.default.createElement(
	                'legend',
	                null,
	                'Credit card details'
	            ),
	            fields.cardPrefilled.value ? _react2.default.createElement(
	                _LinkButton2.default,
	                { onClickFn: dispatchClearCard },
	                'Edit'
	            ) : null,
	            _react2.default.createElement(_FieldValidationMessages2.default, { sanitisedError: sanitisedErrors.number }),
	            _react2.default.createElement(_FieldValidationMessages2.default, { sanitisedError: sanitisedErrors.expiry }),
	            _react2.default.createElement(_FieldValidationMessages2.default, { sanitisedError: sanitisedErrors.cvc })
	        ),
	        _react2.default.createElement(
	            _FieldRow2.default,
	            null,
	            _react2.default.createElement(
	                _Field2.default,
	                { className: 'name' },
	                _react2.default.createElement(_FormInput2.default, _extends({}, props, {
	                    name: fields.cardName.name,
	                    type: 'text',
	                    className: 'cc-name',
	                    id: 'cardHolder',
	                    autoComplete: 'cc-name',
	                    placeholder: 'Name on card',
	                    noName: true,
	                    noValidate: true,
	                    disabled: disabled }))
	            )
	        ),
	        _react2.default.createElement(
	            _FieldRow2.default,
	            null,
	            _react2.default.createElement(
	                _Field2.default,
	                { className: (0, _classnames2.default)('card-number', (0, _creditCardFormatters.getCardType)(fields.number.value), fields.cardBrand.value) },
	                _react2.default.createElement(_FormInput2.default, _extends({}, props, {
	                    name: fields.number.name,
	                    type: 'text',
	                    className: 'cc-number',
	                    id: 'cardNumber',
	                    autoComplete: 'cc-number',
	                    placeholder: 'Card number',
	                    pattern: '\\d*',
	                    noName: true,
	                    noValidate: true,
	                    valueFormatter: _creditCardFormatters.numberFormatter,
	                    disabled: disabled }))
	            )
	        ),
	        _react2.default.createElement(
	            _FieldRow2.default,
	            null,
	            _react2.default.createElement(
	                _Field2.default,
	                { className: 'expiry' },
	                _react2.default.createElement(_FormInput2.default, _extends({}, props, {
	                    name: fields.expiry.name,
	                    type: 'text',
	                    id: 'cardExpiration',
	                    className: 'cc-exp',
	                    autoComplete: 'cc-exp',
	                    placeholder: 'MM / YY',
	                    pattern: '\\d*',
	                    noName: true,
	                    noValidate: true,
	                    valueFormatter: _creditCardFormatters.expiryFormatter,
	                    disabled: disabled }))
	            ),
	            _react2.default.createElement(
	                _Field2.default,
	                { className: 'cvc' },
	                _react2.default.createElement(_FormInput2.default, _extends({}, props, {
	                    name: fields.cvc.name,
	                    type: 'text',
	                    id: 'cardCsc',
	                    className: 'cc-cvc',
	                    autoComplete: 'off',
	                    placeholder: 'CVC',
	                    pattern: '\\d*',
	                    noName: true,
	                    noValidate: true,
	                    valueFormatter: _creditCardFormatters.cvcFormatter,
	                    disabled: disabled }))
	            )
	        ),
	        !disabled ? _react2.default.createElement(
	            _FieldRow2.default,
	            null,
	            _react2.default.createElement(
	                _Field2.default,
	                null,
	                _react2.default.createElement(_FormInput2.default, _extends({}, props, {
	                    name: fields.postcode.name,
	                    type: 'text',
	                    id: 'frmZipS',
	                    placeholder: 'ZIP / Postcode',
	                    disabled: disabled,
	                    maxLength: 16,
	                    autocomplete: 'shipping postal-code' }))
	            )
	        ) : null
	    );
	};
	
	CreditCard.propTypes = {
	    fields: _propTypes2.default.object,
	    submitInterceptor: _propTypes2.default.func,
	    submitFailed: _propTypes2.default.bool,
	    showingErrors: _propTypes2.default.bool,
	    submitting: _propTypes2.default.bool,
	    onChange: _propTypes2.default.func,
	    sanitisedErrors: _propTypes2.default.object,
	    primaryError: _propTypes2.default.object,
	    dirtySinceSubmission: _propTypes2.default.bool,
	    customer: _propTypes2.default.object,
	    dispatchClearCard: _propTypes2.default.func
	};
	
	exports.default = CreditCard;

/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.requestStripeToken = undefined;
	
	var _stripeService = __webpack_require__(432);
	
	var _formActions = __webpack_require__(434);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var requestStripeToken = exports.requestStripeToken = function requestStripeToken(formFields, dispatch) {
	    return new Promise(function (resolve, reject) {
	        var _formFields$form = formFields.form,
	            form = _formFields$form === undefined ? 'payment' : _formFields$form,
	            number = formFields.number,
	            expiry = formFields.expiry,
	            cvc = formFields.cvc,
	            cardName = formFields.cardName,
	            postcode = formFields.postcode;
	
	
	        var handleError = function handleError(_ref) {
	            var error = _ref.error;
	
	            if (error.type !== 'card_error') {
	                return reject(dispatch((0, _formActions.formSubmissionFailed)({
	                    form: form,
	                    primaryError: {
	                        message: error.message
	                    }
	                })));
	            }
	
	            var fieldName = error.param;
	
	            if (fieldName === 'exp_year' || fieldName === 'exp_month') fieldName = 'expiry';
	
	            var errorOb = _defineProperty({}, fieldName, {
	                message: error.message,
	                type: 'ERROR'
	            });
	
	            return reject(errorOb);
	        };
	
	        var onTokenResponse = function onTokenResponse(status, response) {
	            if (response.error) return handleError(response);
	            resolve({ token: response });
	        };
	
	        (0, _stripeService.getStripe)().card.createToken({
	            name: cardName,
	            number: number,
	            exp: expiry,
	            cvc: cvc,
	            address_zip: postcode
	        }, onTokenResponse);
	    });
	};

/***/ }),
/* 1774 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var CREDIT_CARD_FORM_FIELDS = exports.CREDIT_CARD_FORM_FIELDS = {
	    // credit card valuues
	    cardName: {
	        name: 'cardName',
	        type: 'text',
	        required: true
	    },
	    number: {
	        name: 'number',
	        type: 'text',
	        required: true
	    },
	    expiry: {
	        name: 'expiry',
	        type: 'text',
	        required: true
	    },
	    cvc: {
	        name: 'cvc',
	        type: 'text',
	        required: true
	    },
	    postcode: {
	        name: 'postcode',
	        type: 'text',
	        required: true
	    },
	
	    // prefilled values
	    cardBrand: {
	        name: 'cardBrand',
	        type: 'text'
	    },
	    cardPrefilled: {
	        name: 'cardPrefilled',
	        type: 'text'
	    }
	};

/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.cvcFormatter = exports.expiryFormatter = exports.numberFormatter = exports.getCardType = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _stringUtil = __webpack_require__(58);
	
	var _stripeService = __webpack_require__(432);
	
	var DATE_SEPARATOR = ' / ';
	
	var getCardType = exports.getCardType = (0, _lodash.throttle)(function (number) {
	    if ((0, _stripeService.getStripe)()) return (0, _stripeService.getStripe)().card.cardType(number).toLowerCase();
	}, 200);
	
	var filterRegex = /[^0-9\•]/g;
	
	var numberFormatter = exports.numberFormatter = function numberFormatter(number) {
	    return (0, _stringUtil.chunkString)(number.replace(filterRegex, '').substr(0, 16), 4).join(' ');
	};
	
	var endsInSeparator = function endsInSeparator(expiry, dateParts) {
	    return (expiry.indexOf('/') === 2 || expiry.indexOf(DATE_SEPARATOR) === 2) && dateParts.length === 1;
	};
	
	var expiryFormatter = exports.expiryFormatter = function expiryFormatter(expiry) {
	    var dateParts = (0, _stringUtil.chunkString)(expiry.replace(filterRegex, '').substr(0, 4), 2);
	    return endsInSeparator(expiry, dateParts) ? dateParts[0] + DATE_SEPARATOR : dateParts.join(DATE_SEPARATOR);
	};
	
	var cvcFormatter = exports.cvcFormatter = function cvcFormatter(cvc) {
	    return cvc.replace(filterRegex, '').substr(0, 4);
	};

/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(4);
	
	__webpack_require__(554);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var INPUT_PROPS = [
	// HTML attributes
	'placeholder', 'type', 'value', 'defaultValue', 'selected', 'checked',
	// Event listeners
	'onBlur', 'onChange', 'onFocus'];
	
	var RadioInput = function RadioInput(props) {
	    var name = props.name,
	        value = props.value,
	        fields = props.fields,
	        className = props.className,
	        sanitisedErrors = props.sanitisedErrors,
	        onChange = props.onChange;
	
	    var field = fields[name];
	
	    var isError = sanitisedErrors[name] && sanitisedErrors[name].showError;
	
	    return _react2.default.createElement('input', _extends({ id: name
	    }, (0, _lodash.pick)(props, INPUT_PROPS), (0, _lodash.pick)(field, INPUT_PROPS), {
	        value: value,
	        checked: field.value === value,
	        name: name,
	        type: 'radio',
	        onChange: onChange(name),
	        className: (0, _classnames2.default)('RadioInput', className, { error: isError }) }));
	};
	
	RadioInput.propTypes = {
	    name: _propTypes2.default.string.isRequired,
	    value: _propTypes2.default.string.isRequired,
	    fields: _propTypes2.default.object.isRequired,
	    onChange: _propTypes2.default.func.isRequired,
	    sanitisedErrors: _propTypes2.default.object,
	    className: _propTypes2.default.string,
	    noName: _propTypes2.default.bool,
	    valueFormatter: _propTypes2.default.func,
	    checked: _propTypes2.default.bool
	};
	
	exports.default = RadioInput;

/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1153);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Lib
	var ToggleButton = function ToggleButton(_ref) {
	    var active = _ref.active;
	    return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('ToggleButton', { active: active }) },
	        _react2.default.createElement('div', { className: 'toggle-thumb' })
	    );
	};
	
	// Styles
	
	
	ToggleButton.propTypes = {
	    active: _propTypes2.default.bool
	};
	
	exports.default = ToggleButton;

/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ToggleButton = __webpack_require__(1777);
	
	var _ToggleButton2 = _interopRequireDefault(_ToggleButton);
	
	__webpack_require__(1154);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	// Lib
	var ToggleInput = function ToggleInput(_ref) {
	    var value = _ref.value,
	        label = _ref.label,
	        active = _ref.active,
	        onChange = _ref.onChange;
	    return _react2.default.createElement(
	        'label',
	        { className: 'ToggleInput' },
	        _react2.default.createElement('input', { type: 'checkbox', className: 'checkbox', value: value, checked: active, onChange: onChange }),
	        _react2.default.createElement(_ToggleButton2.default, { active: active }),
	        _react2.default.createElement(
	            'span',
	            { className: 'text' },
	            label
	        )
	    );
	};
	
	// Styles
	
	
	ToggleInput.propTypes = {
	    onChange: _propTypes2.default.func,
	    active: _propTypes2.default.bool,
	    value: _propTypes2.default.number.isRequired,
	    label: _propTypes2.default.string.isRequired
	};
	
	exports.default = ToggleInput;

/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _formReducer$plugin;
	
	var _reduxForm = __webpack_require__(415);
	
	var _registerFormReducer = __webpack_require__(1686);
	
	var _registerFormReducer2 = _interopRequireDefault(_registerFormReducer);
	
	var _loginFormReducer = __webpack_require__(1683);
	
	var _loginFormReducer2 = _interopRequireDefault(_loginFormReducer);
	
	var _boardSharingFormReducer = __webpack_require__(2193);
	
	var _boardSharingFormReducer2 = _interopRequireDefault(_boardSharingFormReducer);
	
	var _paymentFormReducer = __webpack_require__(2062);
	
	var _paymentFormReducer2 = _interopRequireDefault(_paymentFormReducer);
	
	var _teamInputFormReducer = __webpack_require__(2095);
	
	var _teamInputFormReducer2 = _interopRequireDefault(_teamInputFormReducer);
	
	var _registerFormConstants = __webpack_require__(292);
	
	var _loginFormConstants = __webpack_require__(291);
	
	var _boardSharingFormConstants = __webpack_require__(477);
	
	var _paymentConstants = __webpack_require__(202);
	
	var _teamFormConstants = __webpack_require__(309);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // Lib
	
	
	// Reducers
	
	
	// Constants
	
	
	exports.default = _reduxForm.reducer.plugin((_formReducer$plugin = {}, _defineProperty(_formReducer$plugin, _registerFormConstants.REGISTER_FORM_NAME, _registerFormReducer2.default), _defineProperty(_formReducer$plugin, _loginFormConstants.LOGIN_FORM_NAME, _loginFormReducer2.default), _defineProperty(_formReducer$plugin, _paymentConstants.PAYMENT_FORM_NAME, _paymentFormReducer2.default), _defineProperty(_formReducer$plugin, _boardSharingFormConstants.ADD_SHARED_USER_FORM_NAME, _boardSharingFormReducer2.default), _defineProperty(_formReducer$plugin, _teamFormConstants.ADD_TEAM_MEMBER_FORM_NAME, _teamInputFormReducer2.default), _formReducer$plugin));

/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1155);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Field = function Field(_ref) {
	    var children = _ref.children,
	        className = _ref.className;
	    return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('Field', className) },
	        children
	    );
	};
	
	Field.propTypes = {
	    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array, _propTypes2.default.string]),
	    className: _propTypes2.default.string
	};
	
	exports.default = Field;

/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1156);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FieldRow = function FieldRow(_ref) {
	    var children = _ref.children,
	        className = _ref.className;
	    return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('FieldRow', className) },
	        children
	    );
	};
	
	FieldRow.propTypes = {
	    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array, _propTypes2.default.string]),
	    className: _propTypes2.default.string
	};
	
	exports.default = FieldRow;

/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FormPrimaryMessage = __webpack_require__(701);
	
	var _FormPrimaryMessage2 = _interopRequireDefault(_FormPrimaryMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PrimarySuccessMessage = function PrimarySuccessMessage(_ref) {
	    var message = _ref.message,
	        show = _ref.show,
	        children = _ref.children;
	    return _react2.default.createElement(
	        _FormPrimaryMessage2.default,
	        { className: 'PrimarySuccessMessage', message: message, show: show, icon: 'green-tick' },
	        children
	    );
	};
	
	// Components
	// Lib
	
	
	PrimarySuccessMessage.propTypes = {
	    message: _propTypes2.default.string.isRequired,
	    show: _propTypes2.default.bool,
	    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
	};
	
	exports.default = PrimarySuccessMessage;

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _recompose = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LOGO_RATIO = 370 / 920;
	var LINE_THICKNESS_RATIO = 30 / 920;
	var DEFAULT_SIZE = 60;
	
	var enhance = (0, _recompose.defaultProps)({
	    size: DEFAULT_SIZE,
	    strokeWidth: DEFAULT_SIZE * LINE_THICKNESS_RATIO,
	    color: '#f4511c',
	    animate: true
	});
	
	var getLogoPath = function getLogoPath(size) {
	    var logoSize = size * LOGO_RATIO;
	    var offset = size / 2 - logoSize / 2;
	
	    var x1 = 0 + offset;
	    var y1 = 0 + offset;
	
	    var x2 = 0 + offset;
	    var y2 = logoSize + offset;
	
	    var x3 = logoSize + offset;
	    var y3 = logoSize + offset;
	
	    var x4 = logoSize + offset;
	    var y4 = 0 + offset;
	
	    return 'M ' + x1 + ' ' + y1 + ' L ' + x2 + ' ' + y2 + ' L ' + x3 + ' ' + y3 + ' L ' + x4 + ' ' + y4 + ' L ' + x2 + ' ' + y2 + ' M ' + x1 + ' ' + y1 + ' L ' + x3 + ' ' + y3;
	};
	
	var getViewBox = function getViewBox(size) {
	    return '0 0 ' + size + ' ' + size;
	};
	
	var MilanoteLogo = function MilanoteLogo(_ref) {
	    var size = _ref.size,
	        strokeWidth = _ref.strokeWidth,
	        animate = _ref.animate,
	        color = _ref.color;
	    return _react2.default.createElement(
	        'div',
	        { className: 'MilanoteLogo', style: { position: 'relative', width: size, height: size } },
	        _react2.default.createElement(
	            'svg',
	            { viewBox: getViewBox(size),
	                width: size,
	                height: size,
	                style: { position: 'absolute' },
	                className: 'path logo-spinner-circle' },
	            _react2.default.createElement('circle', { cx: size / 2,
	                cy: size / 2,
	                r: size / 2 - strokeWidth,
	                fill: 'none',
	                strokeWidth: strokeWidth,
	                strokeMiterlimit: '10',
	                stroke: color })
	        ),
	        _react2.default.createElement(
	            'svg',
	            { viewBox: getViewBox(size),
	                width: size,
	                height: size, style: { position: 'absolute' },
	                className: (0, _classnames2.default)('logo-spinner-icon', { animate: animate }) },
	            _react2.default.createElement('path', { d: getLogoPath(size),
	                strokeWidth: strokeWidth,
	                stroke: color,
	                fill: 'none',
	                strokeLinecap: 'round',
	                strokeLinejoin: 'round' })
	        )
	    );
	};
	
	MilanoteLogo.propTypes = {
	    size: _propTypes2.default.number,
	    strokeWidth: _propTypes2.default.number,
	    color: _propTypes2.default.string,
	    animate: _propTypes2.default.bool
	};
	
	exports.default = enhance(MilanoteLogo);

/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _boardLink = __webpack_require__(1785);
	
	var _boardLink2 = _interopRequireDefault(_boardLink);
	
	var _boardLocked = __webpack_require__(1786);
	
	var _boardLocked2 = _interopRequireDefault(_boardLocked);
	
	var _boardSharedUsers = __webpack_require__(1787);
	
	var _boardSharedUsers2 = _interopRequireDefault(_boardSharedUsers);
	
	var _chevronLeft = __webpack_require__(1788);
	
	var _chevronLeft2 = _interopRequireDefault(_chevronLeft);
	
	var _closeXSmall = __webpack_require__(1789);
	
	var _closeXSmall2 = _interopRequireDefault(_closeXSmall);
	
	var _closeX = __webpack_require__(1790);
	
	var _closeX2 = _interopRequireDefault(_closeX);
	
	var _crossLarge = __webpack_require__(1791);
	
	var _crossLarge2 = _interopRequireDefault(_crossLarge);
	
	var _crossSmall = __webpack_require__(1792);
	
	var _crossSmall2 = _interopRequireDefault(_crossSmall);
	
	var _elementBoard = __webpack_require__(1793);
	
	var _elementBoard2 = _interopRequireDefault(_elementBoard);
	
	var _elementCard = __webpack_require__(1794);
	
	var _elementCard2 = _interopRequireDefault(_elementCard);
	
	var _elementColumn = __webpack_require__(1795);
	
	var _elementColumn2 = _interopRequireDefault(_elementColumn);
	
	var _elementImage = __webpack_require__(1796);
	
	var _elementImage2 = _interopRequireDefault(_elementImage);
	
	var _elementLine = __webpack_require__(1797);
	
	var _elementLine2 = _interopRequireDefault(_elementLine);
	
	var _elementLink = __webpack_require__(1798);
	
	var _elementLink2 = _interopRequireDefault(_elementLink);
	
	var _elementResizeHandle = __webpack_require__(1799);
	
	var _elementResizeHandle2 = _interopRequireDefault(_elementResizeHandle);
	
	var _errorAlert = __webpack_require__(1800);
	
	var _errorAlert2 = _interopRequireDefault(_errorAlert);
	
	var _exportMarkdown = __webpack_require__(1801);
	
	var _exportMarkdown2 = _interopRequireDefault(_exportMarkdown);
	
	var _exportPdf = __webpack_require__(1802);
	
	var _exportPdf2 = _interopRequireDefault(_exportPdf);
	
	var _exportText = __webpack_require__(1803);
	
	var _exportText2 = _interopRequireDefault(_exportText);
	
	var _exportWord = __webpack_require__(1804);
	
	var _exportWord2 = _interopRequireDefault(_exportWord);
	
	var _greenTick = __webpack_require__(1805);
	
	var _greenTick2 = _interopRequireDefault(_greenTick);
	
	var _helpCenter = __webpack_require__(1806);
	
	var _helpCenter2 = _interopRequireDefault(_helpCenter);
	
	var _imageFormUpload = __webpack_require__(1807);
	
	var _imageFormUpload2 = _interopRequireDefault(_imageFormUpload);
	
	var _imagePopupUpload = __webpack_require__(1808);
	
	var _imagePopupUpload2 = _interopRequireDefault(_imagePopupUpload);
	
	var _inboxEmpty = __webpack_require__(1809);
	
	var _inboxEmpty2 = _interopRequireDefault(_inboxEmpty);
	
	var _linkFail = __webpack_require__(1810);
	
	var _linkFail2 = _interopRequireDefault(_linkFail);
	
	var _linkIcon = __webpack_require__(1811);
	
	var _linkIcon2 = _interopRequireDefault(_linkIcon);
	
	var _menuDownArrow = __webpack_require__(1812);
	
	var _menuDownArrow2 = _interopRequireDefault(_menuDownArrow);
	
	var _milanoteLogoLarge = __webpack_require__(1813);
	
	var _milanoteLogoLarge2 = _interopRequireDefault(_milanoteLogoLarge);
	
	var _milanoteLogoSmall = __webpack_require__(1814);
	
	var _milanoteLogoSmall2 = _interopRequireDefault(_milanoteLogoSmall);
	
	var _navAntenna = __webpack_require__(1815);
	
	var _navAntenna2 = _interopRequireDefault(_navAntenna);
	
	var _navCreate = __webpack_require__(1816);
	
	var _navCreate2 = _interopRequireDefault(_navCreate);
	
	var _navExport = __webpack_require__(1817);
	
	var _navExport2 = _interopRequireDefault(_navExport);
	
	var _navHelp = __webpack_require__(1818);
	
	var _navHelp2 = _interopRequireDefault(_navHelp);
	
	var _navNotifications = __webpack_require__(1819);
	
	var _navNotifications2 = _interopRequireDefault(_navNotifications);
	
	var _navSearch = __webpack_require__(1820);
	
	var _navSearch2 = _interopRequireDefault(_navSearch);
	
	var _paymentFree = __webpack_require__(1821);
	
	var _paymentFree2 = _interopRequireDefault(_paymentFree);
	
	var _paymentIndividual = __webpack_require__(1822);
	
	var _paymentIndividual2 = _interopRequireDefault(_paymentIndividual);
	
	var _paymentStar = __webpack_require__(1823);
	
	var _paymentStar2 = _interopRequireDefault(_paymentStar);
	
	var _paymentTeam = __webpack_require__(1824);
	
	var _paymentTeam2 = _interopRequireDefault(_paymentTeam);
	
	var _paymentTrophy = __webpack_require__(1825);
	
	var _paymentTrophy2 = _interopRequireDefault(_paymentTrophy);
	
	var _playArrow = __webpack_require__(1826);
	
	var _playArrow2 = _interopRequireDefault(_playArrow);
	
	var _tick = __webpack_require__(1827);
	
	var _tick2 = _interopRequireDefault(_tick);
	
	var _toolbarArrowLeftOn = __webpack_require__(1828);
	
	var _toolbarArrowLeftOn2 = _interopRequireDefault(_toolbarArrowLeftOn);
	
	var _toolbarArrowLeft = __webpack_require__(1829);
	
	var _toolbarArrowLeft2 = _interopRequireDefault(_toolbarArrowLeft);
	
	var _toolbarArrowRightOn = __webpack_require__(1830);
	
	var _toolbarArrowRightOn2 = _interopRequireDefault(_toolbarArrowRightOn);
	
	var _toolbarArrowRight = __webpack_require__(1831);
	
	var _toolbarArrowRight2 = _interopRequireDefault(_toolbarArrowRight);
	
	var _toolbarBoldOn = __webpack_require__(1832);
	
	var _toolbarBoldOn2 = _interopRequireDefault(_toolbarBoldOn);
	
	var _toolbarBold = __webpack_require__(1833);
	
	var _toolbarBold2 = _interopRequireDefault(_toolbarBold);
	
	var _toolbarCaptionOn = __webpack_require__(1834);
	
	var _toolbarCaptionOn2 = _interopRequireDefault(_toolbarCaptionOn);
	
	var _toolbarCaption = __webpack_require__(1835);
	
	var _toolbarCaption2 = _interopRequireDefault(_toolbarCaption);
	
	var _toolbarChecklistOn = __webpack_require__(1836);
	
	var _toolbarChecklistOn2 = _interopRequireDefault(_toolbarChecklistOn);
	
	var _toolbarChecklist = __webpack_require__(1837);
	
	var _toolbarChecklist2 = _interopRequireDefault(_toolbarChecklist);
	
	var _toolbarH1On = __webpack_require__(1838);
	
	var _toolbarH1On2 = _interopRequireDefault(_toolbarH1On);
	
	var _toolbarH = __webpack_require__(1839);
	
	var _toolbarH2 = _interopRequireDefault(_toolbarH);
	
	var _toolbarImagePreviewOn = __webpack_require__(1840);
	
	var _toolbarImagePreviewOn2 = _interopRequireDefault(_toolbarImagePreviewOn);
	
	var _toolbarImagePreview = __webpack_require__(1841);
	
	var _toolbarImagePreview2 = _interopRequireDefault(_toolbarImagePreview);
	
	var _toolbarItalicOn = __webpack_require__(1842);
	
	var _toolbarItalicOn2 = _interopRequireDefault(_toolbarItalicOn);
	
	var _toolbarItalic = __webpack_require__(1843);
	
	var _toolbarItalic2 = _interopRequireDefault(_toolbarItalic);
	
	var _toolbarListOn = __webpack_require__(1844);
	
	var _toolbarListOn2 = _interopRequireDefault(_toolbarListOn);
	
	var _toolbarList = __webpack_require__(1845);
	
	var _toolbarList2 = _interopRequireDefault(_toolbarList);
	
	var _toolbarLockOn = __webpack_require__(1846);
	
	var _toolbarLockOn2 = _interopRequireDefault(_toolbarLockOn);
	
	var _toolbarLock = __webpack_require__(1847);
	
	var _toolbarLock2 = _interopRequireDefault(_toolbarLock);
	
	var _toolbarNumlistOn = __webpack_require__(1848);
	
	var _toolbarNumlistOn2 = _interopRequireDefault(_toolbarNumlistOn);
	
	var _toolbarNumlist = __webpack_require__(1849);
	
	var _toolbarNumlist2 = _interopRequireDefault(_toolbarNumlist);
	
	var _toolbarQuoteOn = __webpack_require__(1850);
	
	var _toolbarQuoteOn2 = _interopRequireDefault(_toolbarQuoteOn);
	
	var _toolbarQuote = __webpack_require__(1851);
	
	var _toolbarQuote2 = _interopRequireDefault(_toolbarQuote);
	
	var _toolbarTransparentOn = __webpack_require__(1852);
	
	var _toolbarTransparentOn2 = _interopRequireDefault(_toolbarTransparentOn);
	
	var _toolbarTransparent = __webpack_require__(1853);
	
	var _toolbarTransparent2 = _interopRequireDefault(_toolbarTransparent);
	
	var _toolbarTrash = __webpack_require__(1854);
	
	var _toolbarTrash2 = _interopRequireDefault(_toolbarTrash);
	
	var _userGuest = __webpack_require__(1855);
	
	var _userGuest2 = _interopRequireDefault(_userGuest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    'board-link': _boardLink2.default,
	    'board-locked': _boardLocked2.default,
	    'board-shared-users': _boardSharedUsers2.default,
	    'chevron-left': _chevronLeft2.default,
	    'close-x-small': _closeXSmall2.default,
	    'close-x': _closeX2.default,
	    'cross-large': _crossLarge2.default,
	    'cross-small': _crossSmall2.default,
	    'element-board': _elementBoard2.default,
	    'element-card': _elementCard2.default,
	    'element-column': _elementColumn2.default,
	    'element-image': _elementImage2.default,
	    'element-line': _elementLine2.default,
	    'element-link': _elementLink2.default,
	    'element-resize-handle': _elementResizeHandle2.default,
	    'error-alert': _errorAlert2.default,
	    'export-markdown': _exportMarkdown2.default,
	    'export-pdf': _exportPdf2.default,
	    'export-text': _exportText2.default,
	    'export-word': _exportWord2.default,
	    'green-tick': _greenTick2.default,
	    'help-center': _helpCenter2.default,
	    'image-form-upload': _imageFormUpload2.default,
	    'image-popup-upload': _imagePopupUpload2.default,
	    'inbox-empty': _inboxEmpty2.default,
	    'link-fail': _linkFail2.default,
	    'link-icon': _linkIcon2.default,
	    'menu-down-arrow': _menuDownArrow2.default,
	    'milanote-logo-large': _milanoteLogoLarge2.default,
	    'milanote-logo-small': _milanoteLogoSmall2.default,
	    'nav-antenna': _navAntenna2.default,
	    'nav-create': _navCreate2.default,
	    'nav-export': _navExport2.default,
	    'nav-help': _navHelp2.default,
	    'nav-notifications': _navNotifications2.default,
	    'nav-search': _navSearch2.default,
	    'payment-free': _paymentFree2.default,
	    'payment-individual': _paymentIndividual2.default,
	    'payment-star': _paymentStar2.default,
	    'payment-team': _paymentTeam2.default,
	    'payment-trophy': _paymentTrophy2.default,
	    'play-arrow': _playArrow2.default,
	    'tick': _tick2.default,
	    'toolbar-arrow-left-on': _toolbarArrowLeftOn2.default,
	    'toolbar-arrow-left': _toolbarArrowLeft2.default,
	    'toolbar-arrow-right-on': _toolbarArrowRightOn2.default,
	    'toolbar-arrow-right': _toolbarArrowRight2.default,
	    'toolbar-bold-on': _toolbarBoldOn2.default,
	    'toolbar-bold': _toolbarBold2.default,
	    'toolbar-caption-on': _toolbarCaptionOn2.default,
	    'toolbar-caption': _toolbarCaption2.default,
	    'toolbar-checklist-on': _toolbarChecklistOn2.default,
	    'toolbar-checklist': _toolbarChecklist2.default,
	    'toolbar-h1-on': _toolbarH1On2.default,
	    'toolbar-h1': _toolbarH2.default,
	    'toolbar-image-preview-on': _toolbarImagePreviewOn2.default,
	    'toolbar-image-preview': _toolbarImagePreview2.default,
	    'toolbar-italic-on': _toolbarItalicOn2.default,
	    'toolbar-italic': _toolbarItalic2.default,
	    'toolbar-list-on': _toolbarListOn2.default,
	    'toolbar-list': _toolbarList2.default,
	    'toolbar-lock-on': _toolbarLockOn2.default,
	    'toolbar-lock': _toolbarLock2.default,
	    'toolbar-numlist-on': _toolbarNumlistOn2.default,
	    'toolbar-numlist': _toolbarNumlist2.default,
	    'toolbar-quote-on': _toolbarQuoteOn2.default,
	    'toolbar-quote': _toolbarQuote2.default,
	    'toolbar-transparent-on': _toolbarTransparentOn2.default,
	    'toolbar-transparent': _toolbarTransparent2.default,
	    'toolbar-trash': _toolbarTrash2.default,
	    'user-guest': _userGuest2.default
	}; /*eslint-disable */

/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "13", height: "10", viewBox: "0 0 13 10", className: "Icon board-link", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement("path", { d: "M8.125 3.283c-3.819 0-7.15 2.626-8.076 6.369L0 9.848a11.051 11.051 0 0 1 7.849-3.282h.276v3.282L13 4.924 8.125 0v3.283z", fill: "#FFF", fillRule: "nonzero" })
	    );
	}; /*eslint-disable */

/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "8", height: "10", viewBox: "0 0 8 10", className: "Icon board-locked", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement(
	                "g",
	                { fill: "#31303A" },
	                _react2.default.createElement("path", { d: "M6.5 5H6V2.893C6 1.853 5.114 1 4 1c-1.11 0-2 .857-2 1.893V5H1V2.893C1 1.295 2.347 0 4 0c1.657 0 3 1.29 3 2.893V5h-.5z" }),
	                _react2.default.createElement("path", { d: "M0 4h8v6H0z" })
	            )
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "13", height: "9", viewBox: "0 0 13 9", className: "Icon board-shared-users", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "#FFF", fillRule: "evenodd" },
	            _react2.default.createElement("path", { d: "M4 4c1.103 0 2-.897 2-2 0-1.125-.943-2-2-2S2 .875 2 2c0 1.103.897 2 2 2M7.73 5.128c.466-.147 1.047-.239 1.772-.24 1.793.001 2.712.568 3.148 1.13.262.337.35.672.35.882v.64a.392.392 0 0 1-.031.149c-.073.18-.272.311-.508.311H9v-.414c0-.533-.199-1.154-.577-1.702a3.751 3.751 0 0 0-.692-.756zM9.5 4c.827 0 1.5-.673 1.5-1.5 0-.844-.707-1.5-1.5-1.5S8 1.656 8 2.5C8 3.327 8.673 4 9.5 4M4.002 5C1.948 5 .899 5.73.4 6.452c-.299.434-.4.864-.4 1.134v.824A.613.613 0 0 0 .616 9h6.768A.613.613 0 0 0 8 8.41v-.824c0-.27-.1-.7-.4-1.134C7.102 5.73 6.052 5 4.002 5z" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "6", height: "10", viewBox: "0 0 6 10", className: "Icon chevron-left", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement("path", { d: "M5.067 8.183a.625.625 0 1 1-.884.884l-4-4a.625.625 0 0 1 0-.884l4-4a.625.625 0 0 1 .884.884L1.509 4.625l3.558 3.558z", fill: "#777", fillRule: "nonzero" })
	    );
	}; /*eslint-disable */

/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "9", height: "9", viewBox: "0 0 9 9", className: "Icon close-x-small", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "#FFF", fillRule: "evenodd" },
	            _react2.default.createElement("path", { d: "M7.496.592a.854.854 0 0 1 1.21.002c.335.335.332.88.002 1.21l-6.49 6.49a.854.854 0 0 1-1.21-.002.859.859 0 0 1-.002-1.21l6.49-6.49z" }),
	            _react2.default.createElement("path", { d: "M1.006 1.804a.854.854 0 0 1 .002-1.21.859.859 0 0 1 1.21-.002l6.49 6.49a.854.854 0 0 1-.002 1.21.859.859 0 0 1-1.21.002l-6.49-6.49z" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "11", height: "11", viewBox: "0 0 11 11", className: "Icon close-x", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement("path", { d: "M6.63 5.857l3.89-3.89a.674.674 0 1 0-.954-.955l-3.891 3.89-3.89-3.89a.674.674 0 1 0-.955.955l3.89 3.89-3.89 3.89a.674.674 0 1 0 .954.955l3.891-3.89 3.89 3.89a.674.674 0 1 0 .955-.954l-3.89-3.89z", fill: "#777", fillRule: "evenodd" })
	    );
	}; /*eslint-disable */

/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "40", height: "40", viewBox: "0 0 40 40", className: "Icon cross-large", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("circle", { fill: "#E60B0B", cx: "20", cy: "20", r: "20" }),
	            _react2.default.createElement(
	                "g",
	                { fill: "#FFF" },
	                _react2.default.createElement("path", { d: "M26.586 10.586l-16 16 2.828 2.828 16-16z" }),
	                _react2.default.createElement("path", { d: "M26.586 29.414l2.828-2.828-16-16-2.828 2.828z" })
	            )
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "20", height: "20", viewBox: "0 0 20 20", className: "Icon cross-small", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("circle", { fill: "#E60B0B", cx: "10", cy: "10", r: "10" }),
	            _react2.default.createElement(
	                "g",
	                { fill: "#FFF" },
	                _react2.default.createElement("path", { d: "M13.293 5.293l-8 8 1.414 1.414 8-8z" }),
	                _react2.default.createElement("path", { d: "M13.293 14.707l1.414-1.414-8-8-1.414 1.414z" })
	            )
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "38", height: "38", viewBox: "0 0 38 38", className: "Icon element-board", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("rect", { fill: "#C7C7C7", width: "38", height: "38", rx: "4" }),
	            _react2.default.createElement("path", { d: "M1 3.995v30.01A2.99 2.99 0 0 0 3.995 37h30.01A2.99 2.99 0 0 0 37 34.005V3.995A2.99 2.99 0 0 0 34.005 1H3.995A2.99 2.99 0 0 0 1 3.995zm-1 0A3.99 3.99 0 0 1 3.995 0h30.01A3.99 3.99 0 0 1 38 3.995v30.01A3.99 3.99 0 0 1 34.005 38H3.995A3.99 3.99 0 0 1 0 34.005V3.995z", fill: "#A5A5A5" }),
	            _react2.default.createElement("path", { fill: "#FFF", d: "M9 9h9v12H9zM9 23h9v6H9zM20 9h9v20h-9z" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "38", height: "28", viewBox: "0 0 38 28", className: "Icon element-card", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("path", { fill: "#888", d: "M0 0h38v28H0z" }),
	            _react2.default.createElement("path", { fill: "#FFF", d: "M1 1h36v26H1z" }),
	            _react2.default.createElement("path", { d: "M38 0v28H0V0h38zM1 1v26h36V1H1z", fill: "#A5A5A5" }),
	            _react2.default.createElement("path", { fill: "#929292", d: "M6 7h26v1H6zM6 10h24v1H6zM6 13h26v1H6zM6 16h22v1H6z" }),
	            _react2.default.createElement("path", { fill: "#929292", d: "M6 7h26v1H6zM6 10h24v1H6zM6 13h26v1H6zM6 16h22v1H6z" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "36", height: "39", viewBox: "0 0 36 39", className: "Icon element-column", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "defs",
	            null,
	            _react2.default.createElement("path", { id: "b-element-column", d: "M1 1h34v36H1z" }),
	            _react2.default.createElement(
	                "filter",
	                { x: "-50%", y: "-50%", width: "200%", height: "200%", filterUnits: "objectBoundingBox", id: "a-element-column" },
	                _react2.default.createElement("feOffset", { dy: "1", "in": "SourceAlpha", result: "shadowOffsetOuter1" }),
	                _react2.default.createElement("feGaussianBlur", { stdDeviation: ".5", "in": "shadowOffsetOuter1", result: "shadowBlurOuter1" }),
	                _react2.default.createElement("feColorMatrix", { values: "0 0 0 0 0.431372549 0 0 0 0 0.431372549 0 0 0 0 0.443137255 0 0 0 0.329313859 0", "in": "shadowBlurOuter1" })
	            )
	        ),
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement(
	                "g",
	                null,
	                _react2.default.createElement("use", { fill: "#000", filter: "url(#a-element-column)", xlinkHref: "#b-element-column" }),
	                _react2.default.createElement("use", { fill: "#FFF", xlinkHref: "#b-element-column" })
	            ),
	            _react2.default.createElement("path", { d: "M36 0v38H0V0h36zM1 1v36h34V1H1z", fill: "#A5A5A5" }),
	            _react2.default.createElement("path", { d: "M32 11v10H4V11h28zM5 12v8h26v-8H5z", fill: "#C6C6C6" }),
	            _react2.default.createElement("path", { fill: "#333", d: "M10 5h16v2H10z" }),
	            _react2.default.createElement("path", { d: "M32 23v10H4V23h28zM5 24v8h26v-8H5z", fill: "#C6C6C6" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "38", height: "40", viewBox: "0 0 38 40", className: "Icon element-image", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "defs",
	            null,
	            _react2.default.createElement("path", { id: "b-element-image", d: "M1 1h36v37H1z" }),
	            _react2.default.createElement(
	                "filter",
	                { x: "-50%", y: "-50%", width: "200%", height: "200%", filterUnits: "objectBoundingBox", id: "a-element-image" },
	                _react2.default.createElement("feOffset", { dy: "1", "in": "SourceAlpha", result: "shadowOffsetOuter1" }),
	                _react2.default.createElement("feGaussianBlur", { stdDeviation: ".5", "in": "shadowOffsetOuter1", result: "shadowBlurOuter1" }),
	                _react2.default.createElement("feColorMatrix", { values: "0 0 0 0 0.431372549 0 0 0 0 0.431372549 0 0 0 0 0.443137255 0 0 0 0.329313859 0", "in": "shadowBlurOuter1" })
	            ),
	            _react2.default.createElement(
	                "linearGradient",
	                { x1: "0%", y1: "100%", x2: "0%", y2: "0%", id: "c-element-image" },
	                _react2.default.createElement("stop", { offset: "0%", stopColor: "#B5DFF5" }),
	                _react2.default.createElement("stop", { offset: "100%", stopColor: "#A6D7F4" })
	            ),
	            _react2.default.createElement(
	                "linearGradient",
	                { x1: "50%", y1: "100%", x2: "50%", y2: "0%", id: "d-element-image" },
	                _react2.default.createElement("stop", { offset: "0%", stopColor: "#96BA68" }),
	                _react2.default.createElement("stop", { offset: "100%", stopColor: "#7AA947" })
	            ),
	            _react2.default.createElement("path", { d: "M26 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z", id: "f-element-image" }),
	            _react2.default.createElement(
	                "filter",
	                { x: "-50%", y: "-50%", width: "200%", height: "200%", filterUnits: "objectBoundingBox", id: "e-element-image" },
	                _react2.default.createElement("feOffset", { "in": "SourceAlpha", result: "shadowOffsetOuter1" }),
	                _react2.default.createElement("feGaussianBlur", { stdDeviation: "2.5", "in": "shadowOffsetOuter1", result: "shadowBlurOuter1" }),
	                _react2.default.createElement("feColorMatrix", { values: "0 0 0 0 1 0 0 0 0 0.992156863 0 0 0 0 0.866666667 0 0 0 0.5 0", "in": "shadowBlurOuter1" })
	            )
	        ),
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement(
	                "g",
	                null,
	                _react2.default.createElement("use", { fill: "#000", filter: "url(#a-element-image)", xlinkHref: "#b-element-image" }),
	                _react2.default.createElement("use", { fill: "#FFF", xlinkHref: "#b-element-image" })
	            ),
	            _react2.default.createElement("path", { d: "M38 0v39H0V0h38zM1 1v37h36V1H1z", fill: "#A5A5A5" }),
	            _react2.default.createElement("path", { fill: "url(#c-element-image)", d: "M4 4h30v24H4z" }),
	            _react2.default.createElement("path", { fill: "url(#d-element-image)", d: "M14 15l10 13H4z" }),
	            _react2.default.createElement("path", { fill: "url(#d-element-image)", d: "M27.5 20l6.5 8H21z" }),
	            _react2.default.createElement("path", { d: "M34 4v24H4V4h30zM5 5v22h28V5H5z", fill: "#000", fillOpacity: ".1" }),
	            _react2.default.createElement(
	                "g",
	                null,
	                _react2.default.createElement("use", { fill: "#000", filter: "url(#e-element-image)", xlinkHref: "#f-element-image" }),
	                _react2.default.createElement("use", { fill: "#FFFDDE", xlinkHref: "#f-element-image" })
	            )
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "33", height: "33", viewBox: "0 0 33 33", className: "Icon element-line", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement("path", { d: "M27.462 6.953L1.707 32.707.293 31.293 26.046 5.54 24 3.5 33 0l-3.343 9.142-2.195-2.19z", fill: "#777", fillRule: "evenodd" })
	    );
	}; /*eslint-disable */

/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "36", height: "37", viewBox: "0 0 36 37", className: "Icon element-link", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "defs",
	            null,
	            _react2.default.createElement("path", { id: "b-element-link", d: "M1 1h34v34H1z" }),
	            _react2.default.createElement(
	                "filter",
	                { x: "-50%", y: "-50%", width: "200%", height: "200%", filterUnits: "objectBoundingBox", id: "a-element-link" },
	                _react2.default.createElement("feOffset", { dy: "1", "in": "SourceAlpha", result: "shadowOffsetOuter1" }),
	                _react2.default.createElement("feGaussianBlur", { stdDeviation: ".5", "in": "shadowOffsetOuter1", result: "shadowBlurOuter1" }),
	                _react2.default.createElement("feColorMatrix", { values: "0 0 0 0 0.431372549 0 0 0 0 0.431372549 0 0 0 0 0.443137255 0 0 0 0.329313859 0", "in": "shadowBlurOuter1" })
	            )
	        ),
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement(
	                "g",
	                null,
	                _react2.default.createElement("use", { fill: "#000", filter: "url(#a-element-link)", xlinkHref: "#b-element-link" }),
	                _react2.default.createElement("use", { fill: "#FFF", xlinkHref: "#b-element-link" })
	            ),
	            _react2.default.createElement("path", { d: "M36 0v36H0V0h36zM1 1v34h34V1H1z", fill: "#A5A5A5" }),
	            _react2.default.createElement("path", { d: "M17.156 18.833c-1.146-1.05-1.13-2.599 0-3.637l3.565-3.601c1.241-1.428 3.17-1.744 4.339-.56 1.135 1.15.748 2.962-.688 4.208l-2.211 2.136a.65.65 0 1 0 .903.934l2.186-2.112c1.916-1.662 2.482-4.31.735-6.08-1.764-1.785-4.551-1.328-6.217.59l-3.513 3.55c-1.664 1.527-1.69 3.96.023 5.53a.65.65 0 1 0 .878-.958z", fill: "#333" }),
	            _react2.default.createElement("path", { d: "M18.855 17.13c1.147 1.05 1.13 2.599 0 3.638l-3.544 3.61c-1.24 1.425-3.168 1.741-4.337.557-1.135-1.15-.749-2.96.688-4.207l2.21-2.136a.65.65 0 1 0-.903-.934l-2.185 2.112c-1.917 1.662-2.482 4.31-.735 6.078 1.763 1.786 4.55 1.329 6.216-.59l3.493-3.556c1.663-1.527 1.69-3.96-.025-5.531a.65.65 0 0 0-.878.958z", fill: "#333" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "13", height: "13", viewBox: "0 0 13 13", className: "Icon element-resize-handle", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement("path", { d: "M1.707 13L13 1.707V.293L.293 13h1.414zm4 0L13 5.707V4.293L4.293 13h1.414zm4 0L13 9.707V8.293L8.293 13h1.414z", fill: "#777", fillRule: "evenodd" })
	    );
	}; /*eslint-disable */

/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "58", height: "53", viewBox: "0 0 58 53", className: "Icon error-alert", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "#F4511C", fillRule: "evenodd" },
	            _react2.default.createElement("path", { d: "M51.666 51a4.317 4.317 0 0 0 3.753-2.216 4.517 4.517 0 0 0 0-4.433L32.753 4.216A4.314 4.314 0 0 0 29 2c-1.55 0-2.98.844-3.755 2.216L2.579 44.351a4.53 4.53 0 0 0 0 4.433A4.318 4.318 0 0 0 6.335 51h45.33zM6.335 52.964a6.282 6.282 0 0 1-5.467-3.217 6.494 6.494 0 0 1 .001-6.361L23.535 3.25A6.281 6.281 0 0 1 29 .036a6.277 6.277 0 0 1 5.463 3.215L57.13 43.386a6.48 6.48 0 0 1 0 6.363 6.28 6.28 0 0 1-5.463 3.215H6.335z" }),
	            _react2.default.createElement("path", { d: "M27.135 27.636L27 20h4l-.135 7.636L30.298 36h-2.596zM29 43a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "20", height: "26", viewBox: "0 0 20 26", className: "Icon export-markdown", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("path", { fill: "#CACACA", d: "M0 0v26h20V6.999L13 0z" }),
	            _react2.default.createElement("path", { fill: "#FFF", d: "M1 1h11v7h7v17H1z" }),
	            _react2.default.createElement("path", { fill: "#FFF", d: "M13 1.417l5.581 5.582H13z" }),
	            _react2.default.createElement("path", { d: "M3.996 12.152h1.536l1.416 3.864.516 1.488h.048l.504-1.488 1.392-3.864h1.536V20H9.636v-3.588c0-.184.006-.384.018-.6.012-.216.026-.434.042-.654.016-.22.036-.436.06-.648.024-.212.044-.41.06-.594h-.048l-.636 1.788-1.356 3.564h-.648l-1.356-3.564-.624-1.788H5.1l.054.594.06.648c.02.22.036.438.048.654.012.216.018.416.018.6V20H3.996v-7.848zM14.5 20l2.5-3h-5l2.5 3zm-.5-8h1v5h-1v-5z", fill: "#4C4C4C" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "23", height: "26", viewBox: "0 0 23 26", className: "Icon export-pdf", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "defs",
	            null,
	            _react2.default.createElement("path", { id: "a-export-pdf", d: "M0 4h12v7H0z" }),
	            _react2.default.createElement(
	                "filter",
	                { x: "-50%", y: "-50%", width: "200%", height: "200%", filterUnits: "objectBoundingBox", id: "b-export-pdf" },
	                _react2.default.createElement("feOffset", { dy: "-1", "in": "SourceAlpha", result: "shadowOffsetInner1" }),
	                _react2.default.createElement("feComposite", { "in": "shadowOffsetInner1", in2: "SourceAlpha", operator: "arithmetic", k2: "-1", k3: "1", result: "shadowInnerInner1" }),
	                _react2.default.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0", "in": "shadowInnerInner1", result: "shadowMatrixInner1" }),
	                _react2.default.createElement("feOffset", { dx: "1", "in": "SourceAlpha", result: "shadowOffsetInner2" }),
	                _react2.default.createElement("feComposite", { "in": "shadowOffsetInner2", in2: "SourceAlpha", operator: "arithmetic", k2: "-1", k3: "1", result: "shadowInnerInner2" }),
	                _react2.default.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0", "in": "shadowInnerInner2", result: "shadowMatrixInner2" }),
	                _react2.default.createElement(
	                    "feMerge",
	                    null,
	                    _react2.default.createElement("feMergeNode", { "in": "shadowMatrixInner1" }),
	                    _react2.default.createElement("feMergeNode", { "in": "shadowMatrixInner2" })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("path", { fill: "#CACACA", d: "M3 0v26h20V6.999L16 0z" }),
	            _react2.default.createElement("path", { fill: "#FFF", d: "M4 1h11v7h7v17H4z" }),
	            _react2.default.createElement("path", { fill: "#FFF", d: "M16 1.417l5.581 5.582H16z" }),
	            _react2.default.createElement(
	                "g",
	                null,
	                _react2.default.createElement("use", { fill: "#E60B0B", xlinkHref: "#a-export-pdf" }),
	                _react2.default.createElement("use", { fill: "#000", filter: "url(#b-export-pdf)", xlinkHref: "#a-export-pdf" })
	            )
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "20", height: "26", viewBox: "0 0 20 26", className: "Icon export-text", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("path", { fill: "#CACACA", d: "M0 0v26h20V6.999L13 0z" }),
	            _react2.default.createElement("path", { fill: "#FFF", d: "M1 1h11v7h7v17H1z" }),
	            _react2.default.createElement("path", { fill: "#FFF", d: "M13 1.417l5.581 5.582H13z" }),
	            _react2.default.createElement(
	                "g",
	                { fill: "#929292" },
	                _react2.default.createElement("path", { d: "M4 12h12v1H4zM4 14h12v1H4zM4 16h12v1H4zM4 18h12v1H4z" })
	            )
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "20", height: "26", viewBox: "0 0 20 26", className: "Icon export-word", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("path", { fill: "#CACACA", d: "M0 0v26h20V6.999L13 0z" }),
	            _react2.default.createElement("path", { fill: "#FFF", d: "M1 1h11v7h7v17H1z" }),
	            _react2.default.createElement("path", { fill: "#FFF", d: "M13 1.417l5.581 5.582H13z" }),
	            _react2.default.createElement("path", { d: "M5 12h1.963l.585 3.965c.052.442.108.886.169 1.332.06.447.117.895.169 1.346h.052c.087-.45.171-.9.253-1.346.083-.446.167-.89.254-1.332L9.355 12h1.625l.91 3.965c.087.433.171.873.253 1.32.083.446.167.899.254 1.358h.052c.06-.46.12-.91.175-1.352.057-.442.115-.884.176-1.326L13.385 12h1.833l-1.508 8.476h-2.405l-.832-3.848c-.07-.33-.132-.66-.189-.995a33.537 33.537 0 0 1-.149-.968h-.052l-.162.969c-.057.333-.12.665-.189.994l-.793 3.848H6.573L5 12z", fill: "#2A579A" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "30", height: "30", viewBox: "0 0 30 30", className: "Icon green-tick", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("circle", { fill: "#379802", cx: "15", cy: "15", r: "15" }),
	            _react2.default.createElement("path", { d: "M13.06 21.182l10.061-10.06L21 9l-7.94 7.924L9.622 13.5 7.5 15.621z", fill: "#FFF" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "59", height: "53", viewBox: "0 0 59 53", className: "Icon help-center", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "defs",
	            null,
	            _react2.default.createElement("path", { id: "a-help-center", d: "M41 14.5V0H5v48h36V36.75z" })
	        ),
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("path", { stroke: "#979797", d: "M30.442 6L35 13.287V52H1V6h29.442z", strokeWidth: "2" }),
	            _react2.default.createElement("use", { fill: "#FFF", xlinkHref: "#a-help-center" }),
	            _react2.default.createElement("path", { stroke: "#979797", d: "M40 47H6V1h34v46z", strokeWidth: "2" }),
	            _react2.default.createElement(
	                "g",
	                { stroke: "#979797", transform: "translate(29 13)", strokeWidth: "2" },
	                _react2.default.createElement("circle", { cx: "11", cy: "11", r: "11" }),
	                _react2.default.createElement("path", { d: "M21.232 16.49l6.486 6.485a3 3 0 1 1-4.243 4.243l-6.486-6.486 4.243-4.243z" })
	            )
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "54", height: "44", viewBox: "0 0 54 44", className: "Icon image-form-upload", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement("path", { d: "M36 40.966h7.326C49.22 40.966 54 35.936 54 29.733c0-5.776-4.142-10.533-9.471-11.162.035-.46.052-.923.052-1.392C44.581 7.691 37.272 0 28.256 0 20.09 0 13.326 6.307 12.12 14.544 5.388 14.786 0 20.606 0 27.751c0 7.298 5.622 13.215 12.558 13.215h7.692v-1h-7.692C6.186 39.966 1 34.508 1 27.75c0-6.599 4.956-11.984 11.157-12.208l.833-.03.12-.824C14.259 6.848 20.68 1 28.257 1 36.708 1 43.58 8.233 43.58 17.18c0 .44-.016.88-.05 1.315l-.072.957.952.112C49.27 20.138 53 24.5 53 29.733c0 5.662-4.343 10.233-9.674 10.233H36v1zm-7-18.027V43.25h-1V22.939l-5.941 5.874-.356.351-.703-.71.356-.352 7.144-7.1 7.155 7.1.345.351-.682.711-.346-.351L29 22.939z", fill: "#D7D7D7", fillRule: "evenodd" })
	    );
	}; /*eslint-disable */

/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "24", height: "21", viewBox: "0 0 24 21", className: "Icon image-popup-upload", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("path", { d: "M16 18h3.256C21.876 18 24 15.79 24 13.065c0-2.538-1.841-4.629-4.21-4.905.016-.202.024-.406.024-.612C19.814 3.38 16.565 0 12.558 0 8.93 0 5.923 2.771 5.388 6.39 2.394 6.498 0 9.055 0 12.195 0 15.4 2.499 18 5.581 18H9v-.9H5.581C3.004 17.1.9 14.911.9 12.194.9 9.54 2.91 7.379 5.42 7.29l.748-.027.11-.74C6.753 3.298 9.42.9 12.557.9c3.502 0 6.356 2.969 6.356 6.648 0 .182-.007.363-.02.543l-.067.863.86.1c1.927.225 3.413 1.943 3.413 4.01 0 2.237-1.73 4.036-3.844 4.036H16v.9z", fill: "#929292" }),
	            _react2.default.createElement("path", { d: "M13 11.207V20.5h-1v-9.293l-2.146 2.147-.354.353L8.793 13l.353-.354 3-3 .354-.353.177.177.177.176 3 3 .353.354-.707.707-.354-.353L13 11.207z", fill: "#979797" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { viewBox: "0 0 123 23", className: "Icon inbox-empty", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "#d7d7d7" },
	            _react2.default.createElement("path", { d: "M77 12.4l-2.4-2V.9c0-.5-.4-.9-.9-.9H49.3c-.5 0-.9.4-.9.9V10.3l-2.4 2c-.2.2-.3.4-.3.7v9.1c0 .5.4.9.9.9h29.8c.5 0 .9-.4.9-.9V13c0-.2-.2-.5-.3-.6zm-1.1.2h-1.3v-1.1l1.3 1.1zM49.3.9h24.4v11.6h-9v.4c0 .1-.4 2.8-3.2 2.8-2.7 0-3.2-2.7-3.2-2.8v-.4h-9V.9zm-.9 10.6v1.1h-1.3l1.3-1.1zm-1.8 10.6v-8.6h10.9c.3 1.3 1.4 3.2 4 3.2s3.7-1.9 4-3.2h10.9v8.6H46.6z" }),
	            _react2.default.createElement("path", { d: "M52.9 4.5H70v.9H52.9zM52.9 9H70v.9H52.9zM52.9 6.8h16.2v.9H52.9z" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "16", height: "15", viewBox: "0 0 16 15", className: "Icon link-fail", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "defs",
	            null,
	            _react2.default.createElement("path", { d: "M1.284 15c-.459 0-.883-.258-1.112-.678a1.427 1.427 0 0 1 0-1.357L6.887.678C7.117.258 7.541 0 8 0c.46 0 .883.258 1.112.678l6.716 12.287c.23.42.23.936 0 1.357-.23.42-.654.678-1.112.678H1.284z", id: "a-link-fail" })
	        ),
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("path", { stroke: "#F6A623", d: "M1.284 15c-.459 0-.883-.258-1.112-.678a1.427 1.427 0 0 1 0-1.357L6.887.678C7.117.258 7.541 0 8 0c.46 0 .883.258 1.112.678l6.716 12.287c.23.42.23.936 0 1.357-.23.42-.654.678-1.112.678H1.284z" }),
	            _react2.default.createElement(
	                "g",
	                { fill: "#F6A623" },
	                _react2.default.createElement("path", { d: "M7.068 6.712L7 5.5h2l-.068 1.212L8.65 9.5H7.35zM8 12.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" })
	            )
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "16", height: "16", viewBox: "0 0 16 16", className: "Icon link-icon", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement("path", { d: "M7.405 8.57c-1.047-.961-1.032-2.384.001-3.333l3.03-3.069c1.122-1.29 2.878-1.579 3.947-.495 1.04 1.054.688 2.707-.613 3.835l-2.203 2.13a.5.5 0 0 0 .695.72l2.183-2.113c1.67-1.447 2.16-3.745.65-5.275-1.527-1.546-3.944-1.15-5.392.519l-2.99 3.028c-1.444 1.326-1.466 3.43.017 4.79a.5.5 0 1 0 .675-.738zm1.19-1.139c1.047.961 1.032 2.383-.001 3.333l-3.03 3.069c-1.122 1.29-2.878 1.578-3.947.495-1.04-1.054-.688-2.707.613-3.835l2.203-2.13a.5.5 0 0 0-.695-.72L1.555 9.756c-1.67 1.448-2.16 3.745-.65 5.276 1.527 1.546 3.944 1.149 5.392-.52l2.99-3.028c1.444-1.326 1.466-3.429-.017-4.789a.5.5 0 1 0-.675.737z", fill: "#6E6E71", fillRule: "evenodd" })
	    );
	}; /*eslint-disable */

/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "8", height: "5", viewBox: "0 0 8 5", className: "Icon menu-down-arrow", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement("path", { d: "M0 0h8L4 5z", fill: "#929292", fillRule: "evenodd" })
	    );
	}; /*eslint-disable */

/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "102", height: "102", viewBox: "0 0 102 102", className: "Icon milanote-logo-large", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { stroke: "#F4511C", fill: "none", strokeLinejoin: "round", strokeLinecap: "round", fillRule: "evenodd", strokeWidth: "2.5" },
	            _react2.default.createElement("path", { d: "M51 100C23.938 100 2 78.062 2 51S23.938 2 51 2s49 21.938 49 49-21.938 49-49 49z" }),
	            _react2.default.createElement("path", { d: "M72.359 72.359L29.641 29.641v42.718h42.718V29.641L29.641 72.359" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "18", height: "18", viewBox: "0 0 18 18", className: "Icon milanote-logo-small", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "#F4511C" },
	            _react2.default.createElement("path", { d: "M9 17A8 8 0 1 0 9 1a8 8 0 0 0 0 16zm0 1A9 9 0 1 1 9 0a9 9 0 0 1 0 18z" }),
	            _react2.default.createElement("path", { d: "M12.854 12.146l-7-7A.5.5 0 0 0 5 5.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.854-.354l-7 7a.5.5 0 0 0 .708.708l7-7L12 5.5v7l.5-.5h-7l.5.5v-7l-.854.354 7 7a.5.5 0 0 0 .708-.708z" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "23", height: "21", viewBox: "0 0 23 21", className: "Icon nav-antenna", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "#777", fillRule: "evenodd" },
	            _react2.default.createElement("path", { d: "M6.781 2.451a.677.677 0 0 0-.955 0c-2.92 2.922-2.92 7.676 0 10.597a.673.673 0 0 0 .955.001.675.675 0 0 0 0-.955 6.149 6.149 0 0 1 0-8.688.675.675 0 0 0 0-.955m-2.838-.973a.675.675 0 1 0-.955-.955c-3.984 3.985-3.984 10.469 0 14.454a.676.676 0 0 0 .955-.955c-3.459-3.459-3.459-9.086 0-12.544M19.262.523a.675.675 0 1 0-.955.955c3.459 3.459 3.459 9.086 0 12.544a.675.675 0 1 0 .955.955c3.984-3.985 3.984-10.47 0-14.454m-3.793 1.929a.674.674 0 0 0 0 .954 6.152 6.152 0 0 1 0 8.689.674.674 0 0 0 .477 1.15.673.673 0 0 0 .478-.196c2.92-2.922 2.92-7.676 0-10.597a.676.676 0 0 0-.955 0z" }),
	            _react2.default.createElement("path", { d: "M11.125 10.49a2.743 2.743 0 0 1-2.741-2.74 2.743 2.743 0 0 1 2.741-2.74 2.743 2.743 0 0 1 2.741 2.74 2.743 2.743 0 0 1-2.741 2.74zm.923 8.647a.452.452 0 0 1-.446.445h-.954a.452.452 0 0 1-.446-.445v-7.41c.298.069.605.114.923.114.318 0 .625-.045.923-.114v7.41zm-.923-15.478a4.09 4.09 0 0 0-2.272 7.49v7.988a1.8 1.8 0 0 0 1.795 1.795h.954a1.8 1.8 0 0 0 1.795-1.795V11.15a4.09 4.09 0 0 0-2.272-7.491z" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "22", height: "21", viewBox: "0 0 22 21", className: "Icon nav-create", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement("path", { d: "M3.493 7.5a2.998 2.998 0 0 0-2.993 3c0 1.663 1.336 3 2.993 3H8.5L8 13v5.007A2.998 2.998 0 0 0 11 21c1.663 0 3-1.336 3-2.993V13l-.5.5h5.007a2.998 2.998 0 0 0 2.993-3c0-1.663-1.336-3-2.993-3H13.5l.5.5V2.993A2.998 2.998 0 0 0 11 0a2.99 2.99 0 0 0-3 2.993V8l.5-.5H3.493zM9 8.5V2.993A1.99 1.99 0 0 1 11 1c1.104 0 2 .894 2 1.993V8.5h5.507a1.99 1.99 0 0 1 1.993 2c0 1.104-.894 2-1.993 2H13v5.507A1.99 1.99 0 0 1 11 20c-1.104 0-2-.894-2-1.993V12.5H3.493a1.99 1.99 0 0 1-1.993-2c0-1.104.894-2 1.993-2H9z", fill: "#979797", fillRule: "evenodd" })
	    );
	}; /*eslint-disable */

/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "23", height: "21", viewBox: "0 0 23 21", className: "Icon nav-export", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "#777", fillRule: "nonzero" },
	            _react2.default.createElement("path", { d: "M14.325 1.675H1.675v17.65h12.65V1.675zm.675 19H1A.675.675 0 0 1 .325 20V1C.325.627.627.325 1 .325h14c.373 0 .675.302.675.675v19a.675.675 0 0 1-.675.675z" }),
	            _react2.default.createElement("path", { d: "M20.864 11.12l-1.675 1.629a.625.625 0 0 0 .872.896L22.779 11a.625.625 0 0 0 .007-.89l-2.718-2.727a.625.625 0 0 0-.886.882l1.599 1.604H9.005a.625.625 0 0 0 0 1.25h11.859z" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "21", height: "21", viewBox: "0 0 21 21", className: "Icon nav-help", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "#777", fillRule: "evenodd" },
	            _react2.default.createElement("path", { d: "M10.5 19.711a9.211 9.211 0 1 0 0-18.422 9.211 9.211 0 0 0 0 18.422zm0 1.289C4.701 21 0 16.299 0 10.5S4.701 0 10.5 0 21 4.701 21 10.5 16.299 21 10.5 21z", fillRule: "nonzero" }),
	            _react2.default.createElement("path", { d: "M9.65 12.802c.005-.707.066-1.197.183-1.47.117-.273.424-.633.921-1.082.483-.57.827-1.009 1.031-1.316.205-.307.308-.678.308-1.112 0-.516-.138-.914-.414-1.191-.275-.278-.669-.417-1.18-.417-.444 0-.822.12-1.134.362-.312.241-.468.596-.468 1.064 0 0-.025.839-.71.839-.686 0-.686-.883-.686-.883-.015-.785.262-1.414.83-1.887C8.897 5.236 9.62 5 10.498 5c.96 0 1.706.245 2.237.735.531.49.797 1.173.797 2.05 0 .63-.172 1.205-.515 1.727-.344.521-.799 1.055-1.364 1.6-.263.264-.423.5-.48.71-.055.21-.083.536-.083.98H9.65zm1.492 2.998H9.636v-1.52h1.506v1.52z" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "26", height: "20", viewBox: "0 0 26 20", className: "Icon nav-notifications", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "#777", fillRule: "nonzero" },
	            _react2.default.createElement("path", { d: "M8.5 7.75a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5zM8.5 9a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9zM11.696 12.374c-.667-.076-1.709-.124-3.196-.124s-2.53.048-3.196.124a4.608 4.608 0 0 0-.406.061l-.092.044-.199.026c-1.818.235-3.357 2.02-3.357 3.895v1.802c0 .301.247.548.553.548h13.394a.544.544 0 0 0 .553-.548V16.4c0-1.858-1.537-3.635-3.374-3.897l-.19-.028-.084-.04a4.608 4.608 0 0 0-.406-.06zM0 16.4c0-2.485 1.987-4.817 4.447-5.135 0 0 .553-.265 4.053-.265s4.053.265 4.053.265C15.009 11.615 17 13.923 17 16.4v1.802c0 .993-.797 1.798-1.803 1.798H1.803A1.801 1.801 0 0 1 0 18.202V16.4zM19.5 9.75a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5zm0 1.25a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7z" }),
	            _react2.default.createElement("path", { d: "M14.25 17.367v1.197a.19.19 0 0 0 .19.186h10.12c.106 0 .19-.084.19-.186v-1.197c0-1.317-1.1-2.61-2.485-2.839a9.917 9.917 0 0 0-.775-.135c-.63-.09-1.304-.143-1.99-.143a14.262 14.262 0 0 0-2.856.296c-1.29.201-2.394 1.502-2.394 2.82zm-1.25 0c0-1.929 1.547-3.76 3.452-4.056 0 0 1.336-.311 3.048-.311s3.048.311 3.048.311c1.906.311 3.452 2.125 3.452 4.056v1.197c0 .793-.645 1.436-1.44 1.436H14.44A1.44 1.44 0 0 1 13 18.564v-1.197z" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "21", height: "21", viewBox: "0 0 21 21", className: "Icon nav-search", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement("path", { d: "M19.243 19.242a1.005 1.005 0 0 1-1.419-.004l-4.067-4.067a8.565 8.565 0 0 0 1.414-1.415l4.067 4.068a.992.992 0 0 1 .005 1.418M1 8.499c0-4.135 3.364-7.5 7.5-7.5s7.5 3.365 7.5 7.5c0 4.136-3.364 7.5-7.5 7.5S1 12.635 1 8.499m14.749 4.422A8.451 8.451 0 0 0 17 8.5 8.5 8.5 0 0 0 8.5 0 8.5 8.5 0 0 0 0 8.5 8.5 8.5 0 0 0 8.5 17a8.446 8.446 0 0 0 4.421-1.251l4.196 4.196a2.003 2.003 0 0 0 2.833.004 1.997 1.997 0 0 0-.005-2.832l-4.196-4.196z", fill: "#929292", fillRule: "evenodd" })
	    );
	}; /*eslint-disable */

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "56", height: "56", viewBox: "0 0 56 56", className: "Icon payment-free", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { transform: "translate(1 1)", fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("path", { d: "M11.004 30.794c0 .429.34.769.782.769.428 0 .768-.34.768-.769V27.91h3.805a.704.704 0 1 0 0-1.411h-3.805V24.09h4.372a.704.704 0 1 0 0-1.411h-5.14a.77.77 0 0 0-.782.781v7.333zm8.266 0c0 .429.34.769.781.769.429 0 .769-.34.769-.769v-2.368h1.953l2.142 2.734c.176.24.403.403.756.403.378 0 .743-.29.743-.718 0-.24-.1-.403-.252-.592l-1.688-2.13c1.184-.365 2.003-1.222 2.003-2.633v-.025c0-.769-.265-1.424-.73-1.903-.568-.554-1.437-.882-2.546-.882h-3.15a.77.77 0 0 0-.781.781v7.333zm1.55-3.742v-2.96h2.255c1.147 0 1.827.516 1.827 1.46v.026c0 .895-.706 1.474-1.814 1.474H20.82zm8.34 4.448h5.192a.691.691 0 0 0 .693-.693.7.7 0 0 0-.693-.693H29.93v-2.369h3.792a.688.688 0 0 0 .693-.68.702.702 0 0 0-.693-.706H29.93v-2.293h4.36a.691.691 0 0 0 .693-.693.7.7 0 0 0-.693-.693h-5.128a.77.77 0 0 0-.781.781v7.258c0 .44.34.781.78.781zm8.443 0h5.191a.691.691 0 0 0 .693-.693.7.7 0 0 0-.693-.693h-4.422v-2.369h3.792a.688.688 0 0 0 .693-.68.702.702 0 0 0-.693-.706h-3.793v-2.293h4.36a.691.691 0 0 0 .693-.693.7.7 0 0 0-.693-.693h-5.128a.77.77 0 0 0-.781.781v7.258c0 .44.34.781.78.781z", fill: "#F4511C" }),
	            _react2.default.createElement("circle", { stroke: "#F4511C", cx: "27", cy: "27", r: "27", strokeWidth: "1.5" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "52", height: "56", viewBox: "0 0 52 56", className: "Icon payment-individual", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "#F4511C", fillRule: "evenodd" },
	            _react2.default.createElement("path", { d: "M2.331 46.321v6.238A1.44 1.44 0 0 0 3.771 54H49.01a1.44 1.44 0 0 0 1.44-1.441V46.32c0-5.279-5.052-16.545-24.059-16.545-19.006 0-24.059 11.266-24.059 16.545zm-1.5 0c0-3.644 1.862-7.99 5.366-11.337 4.472-4.271 11.205-6.708 20.193-6.708 8.989 0 15.722 2.437 20.193 6.708 3.504 3.348 5.366 7.693 5.366 11.337v6.238a2.94 2.94 0 0 1-2.94 2.941H3.772a2.94 2.94 0 0 1-2.94-2.941V46.32zM26.39 23.532c5.906 0 10.693-4.82 10.693-10.766S32.296 2 26.39 2c-5.905 0-10.692 4.82-10.692 10.766s4.787 10.766 10.692 10.766zm0 1.5c-6.736 0-12.192-5.494-12.192-12.266S19.654.5 26.39.5c6.737 0 12.193 5.494 12.193 12.266S33.127 25.032 26.39 25.032z" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "40", height: "38", viewBox: "0 0 40 38", className: "Icon payment-star", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement("path", { d: "M20 30.5L8.832 36.371l2.133-12.435-9.035-8.807 12.486-1.815L20 2l5.584 11.314L38.07 15.13l-9.035 8.807 2.133 12.435z", stroke: "#F4511C", fill: "none", strokeLinejoin: "round", strokeLinecap: "round", fillRule: "evenodd", strokeWidth: "3" })
	    );
	}; /*eslint-disable */

/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "79", height: "56", viewBox: "0 0 79 56", className: "Icon payment-team", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "#F4511C", fillRule: "evenodd" },
	            _react2.default.createElement("path", { d: "M15.875 46.321v6.238c0 .797.644 1.441 1.438 1.441h45.155c.795 0 1.438-.645 1.438-1.441V46.32c0-5.279-5.043-16.545-24.015-16.545S15.875 41.042 15.875 46.321zm-1.5 0c0-3.643 1.859-7.988 5.356-11.336 4.464-4.272 11.186-6.709 20.16-6.709 8.973 0 15.695 2.437 20.159 6.71 3.497 3.347 5.356 7.692 5.356 11.335v6.238a2.939 2.939 0 0 1-2.938 2.941H17.313a2.939 2.939 0 0 1-2.938-2.941V46.32zM39.89 23.532c5.895 0 10.674-4.82 10.674-10.766S45.785 2 39.891 2c-5.895 0-10.674 4.82-10.674 10.766s4.779 10.766 10.674 10.766zm0 1.5c-6.726 0-12.173-5.494-12.173-12.266C27.717 5.995 33.164.5 39.891.5c6.726 0 12.173 5.495 12.173 12.266 0 6.772-5.447 12.266-12.173 12.266z" }),
	            _react2.default.createElement("path", { d: "M52.699 37.156v3.188c0 .407.329.737.734.737h23.08c.406 0 .735-.33.735-.737v-3.188c0-2.698-2.578-8.456-12.275-8.456-9.697 0-12.274 5.758-12.274 8.456zm-1.5 0c0-5.187 4.983-9.956 13.774-9.956 8.792 0 13.775 4.769 13.775 9.956v3.188c0 1.234-1 2.237-2.235 2.237h-23.08a2.235 2.235 0 0 1-2.234-2.237v-3.188zM64.973 23.855c2.947 0 5.337-2.41 5.337-5.383s-2.39-5.383-5.337-5.383c-2.947 0-5.337 2.41-5.337 5.383s2.39 5.383 5.337 5.383zm0 1.5c-3.779 0-6.837-3.084-6.837-6.883 0-3.798 3.058-6.883 6.837-6.883s6.837 3.085 6.837 6.883c0 3.799-3.058 6.883-6.837 6.883z" }),
	            _react2.default.createElement(
	                "g",
	                null,
	                _react2.default.createElement("path", { d: "M2 37.156v3.188c0 .407.329.737.735.737h23.08c.405 0 .734-.33.734-.737v-3.188c0-2.698-2.578-8.456-12.275-8.456C4.578 28.7 2 34.458 2 37.156zm-1.5 0c0-5.187 4.983-9.956 13.774-9.956 8.792 0 13.775 4.769 13.775 9.956v3.188c0 1.234-1 2.237-2.235 2.237H2.734A2.235 2.235 0 0 1 .5 40.344v-3.188zM14.274 23.855c2.948 0 5.337-2.41 5.337-5.383s-2.39-5.383-5.337-5.383c-2.947 0-5.336 2.41-5.336 5.383s2.389 5.383 5.336 5.383zm0 1.5c-3.778 0-6.836-3.084-6.836-6.883 0-3.798 3.058-6.883 6.836-6.883 3.78 0 6.837 3.085 6.837 6.883 0 3.799-3.058 6.883-6.837 6.883z" })
	            )
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "119", height: "139", viewBox: "0 0 119 139", className: "Icon payment-trophy", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "defs",
	            null,
	            _react2.default.createElement("path", { d: "M80.353 68.533c14.672-7.343 34.443-23.509 38.003-45.25 1.475-9.007-2.885-15.727-11.709-17.697-.84-.188-5.685-1.18-10.511.873", id: "a-payment-trophy" }),
	            _react2.default.createElement(
	                "mask",
	                { id: "b-payment-trophy", x: "0", y: "0", width: "38.286", height: "63.351", fill: "#fff" },
	                _react2.default.createElement("use", { xlinkHref: "#a-payment-trophy" })
	            )
	        ),
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("path", { d: "M3.89 22.798c-1.227-7.492 2.183-12.673 9.402-14.284.29-.065.63-.128 1.066-.186.645-.087 1.338-.14 2.065-.146 1.936-.015 3.826.303 5.553 1.038l1.174-2.76c-4.826-2.054-9.67-1.062-10.511-.874C3.815 7.556-.545 14.276.929 23.282 4.49 45.024 24.262 61.19 38.934 68.533l-.991-3.898C20.777 55.337 6.663 39.732 3.89 22.798z", fill: "#F4511C" }),
	            _react2.default.createElement("path", { d: "M47.39 75.066c.15.16.15.16.303.32 4.533 4.787 6.182 7.38 6.182 11.878 0 4.176-2.98 7.633-7.759 10.75a42.624 42.624 0 0 1-4.733 2.652c-.89.43-1.606.744-2.075.935-.739.392-1.475 1.55-1.475 2.313v.32h45.334v-.32c0-.777-.738-1.942-1.452-2.304a37.436 37.436 0 0 1-2.098-.944 42.624 42.624 0 0 1-4.733-2.651c-4.78-3.118-7.759-6.575-7.759-10.751 0-4.72 2.237-8.21 6.61-12.323 12.863-12.096 21.713-39.967 22.24-71.707H25.026c.544 30.839 9.432 58.147 22.365 71.832zm35.53 23.796c1.793.822 3.247 3.085 3.247 5.052v3.32H34.833v-3.32c0-1.968 1.466-4.207 3.247-5.052 0 0 12.795-5.093 12.795-11.598 0-4.314-2.888-7.198-5.665-10.137C32.064 63.216 22 34.673 22 .234h77c0 34.44-9.545 64.042-23.21 76.893-2.778 2.611-5.665 5.823-5.665 10.137 0 6.505 12.795 11.598 12.795 11.598z", fill: "#F4511C" }),
	            _react2.default.createElement("path", { d: "M31 114.997c0 .003 57.999.003 57.999.003.003 0 .001-7.997.001-7.997C89 107 31.001 107 31.001 107c-.003 0-.001 7.997-.001 7.997zm-3-7.994A2.998 2.998 0 0 1 31.001 104h57.998A3 3 0 0 1 92 107.003v7.994A2.998 2.998 0 0 1 88.999 118H31.001A3 3 0 0 1 28 114.997v-7.994z", fill: "#F4511C" }),
	            _react2.default.createElement("path", { d: "M21 136.004C21 136 98.998 136 98.998 136L99 117.996c0 .004-77.998.004-77.998.004L21 136.004zm-3-18.013A2.992 2.992 0 0 1 21.002 115h77.996a2.998 2.998 0 0 1 3.002 2.991v18.018A2.992 2.992 0 0 1 98.998 139H21.002A2.998 2.998 0 0 1 18 136.009V117.99z", fill: "#F4511C" }),
	            _react2.default.createElement("use", { stroke: "#F4511C", mask: "url(#b-payment-trophy)", xlinkHref: "#a-payment-trophy", strokeWidth: "6" }),
	            _react2.default.createElement("path", { d: "M45.232 22.264h4.284c.636 0 1.233.063 1.791.189a4.015 4.015 0 0 1 1.458.63c.414.294.741.684.981 1.17.24.486.36 1.083.36 1.791 0 .684-.123 1.278-.369 1.782a3.455 3.455 0 0 1-.999 1.242c-.42.324-.906.564-1.458.72a6.46 6.46 0 0 1-1.764.234h-1.638V34h-2.646V22.264zm4.122 5.652c1.44 0 2.16-.624 2.16-1.872 0-.612-.183-1.044-.549-1.296-.366-.252-.903-.378-1.611-.378h-1.476v3.546h1.476zm9.432-.252h1.368c.696 0 1.227-.147 1.593-.441.366-.294.549-.729.549-1.305s-.183-.978-.549-1.206c-.366-.228-.897-.342-1.593-.342h-1.368v3.294zM62.494 34l-2.25-4.23h-1.458V34H56.14V22.264h4.23c.624 0 1.209.06 1.755.18.546.12 1.023.321 1.431.603.408.282.732.657.972 1.125.24.468.36 1.05.36 1.746 0 .864-.189 1.575-.567 2.133a3.458 3.458 0 0 1-1.521 1.251L65.464 34h-2.97zm9.504.216c-.792 0-1.515-.141-2.169-.423a4.716 4.716 0 0 1-1.683-1.215c-.468-.528-.831-1.17-1.089-1.926s-.387-1.614-.387-2.574c0-.96.129-1.815.387-2.565s.621-1.38 1.089-1.89c.468-.51 1.029-.9 1.683-1.17.654-.27 1.377-.405 2.169-.405s1.515.135 2.169.405c.654.27 1.215.663 1.683 1.179.468.516.831 1.149 1.089 1.899s.387 1.599.387 2.547c0 .96-.129 1.818-.387 2.574-.258.756-.621 1.398-1.089 1.926a4.716 4.716 0 0 1-1.683 1.215c-.654.282-1.377.423-2.169.423zm0-2.286c.804 0 1.44-.345 1.908-1.035.468-.69.702-1.629.702-2.817 0-1.176-.234-2.094-.702-2.754-.468-.66-1.104-.99-1.908-.99-.804 0-1.44.33-1.908.99-.468.66-.702 1.578-.702 2.754 0 1.188.234 2.127.702 2.817.468.69 1.104 1.035 1.908 1.035z", fill: "#F4511C" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "24", height: "24", viewBox: "0 0 24 24", className: "Icon play-arrow", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement("path", { d: "M24 12L0 24V0z", fill: "#FFF", fillRule: "evenodd" })
	    );
	}; /*eslint-disable */

/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "22", height: "19", viewBox: "0 0 22 19", className: "Icon tick", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("path", { fill: "#FFF", d: "M9.414 16.828L8 18.243l-1.414-1.415-4.707-4.707-1.415-1.414L1.88 9.293l1.414-1.414 1.412-1.412 1.414 1.41 3.293 3.282-2.825.001 9.292-9.282L17.294.465l1.413 1.414 1.414 1.414 1.415 1.414-1.415 1.414z" }),
	            _react2.default.createElement("path", { fill: "#B5B5B5", d: "M8 15.414L18.707 4.707l-1.414-1.414L8 12.575 4.707 9.293l-1.414 1.414z", className: "tick-line" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "38", height: "38", viewBox: "0 0 38 38", className: "Icon toolbar-arrow-left-on", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("path", { d: "M26 21v5l-16-7.5L26 12v5h11.375v4H26z", fill: "#4C4C4C" }),
	            _react2.default.createElement("path", { d: "M19 37C9.059 37 1 28.941 1 19S9.059 1 19 1s18 8.059 18 18-8.059 18-18 18z", stroke: "#000", strokeWidth: "2" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "38", height: "38", viewBox: "0 0 38 38", className: "Icon toolbar-arrow-left", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("path", { d: "M26 21v5l-16-7.5L26 12v5h11.375v4H26z", fill: "#4C4C4C" }),
	            _react2.default.createElement("path", { d: "M19 37.5C8.783 37.5.5 29.217.5 19S8.783.5 19 .5 37.5 8.783 37.5 19 29.217 37.5 19 37.5z", stroke: "#BBB" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "38", height: "38", viewBox: "0 0 38 38", className: "Icon toolbar-arrow-right-on", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("path", { d: "M12 21v5l16-7.5L12 12v5H.625v4H12z", fill: "#4C4C4C" }),
	            _react2.default.createElement("path", { d: "M19 37c9.941 0 18-8.059 18-18S28.941 1 19 1 1 9.059 1 19s8.059 18 18 18z", stroke: "#000", strokeWidth: "2" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "38", height: "38", viewBox: "0 0 38 38", className: "Icon toolbar-arrow-right", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("path", { d: "M12 21v5l16-7.5L12 12v5H.625v4H12z", fill: "#4C4C4C" }),
	            _react2.default.createElement("path", { d: "M19 37.5c10.217 0 18.5-8.283 18.5-18.5S29.217.5 19 .5.5 8.783.5 19 8.783 37.5 19 37.5z", stroke: "#BBB" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "38", height: "38", viewBox: "0 0 38 38", className: "Icon toolbar-bold-on", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { transform: "translate(1 1)", fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("rect", { stroke: "#000", width: "36", height: "36", rx: "3", strokeWidth: "2" }),
	            _react2.default.createElement("path", { d: "M14 11h4.46c.68 0 1.31.05 1.89.15.58.1 1.087.277 1.52.53.433.253.773.587 1.02 1 .247.413.37.933.37 1.56 0 .293-.043.587-.13.88a2.744 2.744 0 0 1-1.07 1.5c-.28.2-.607.347-.98.44v.08c.933.173 1.637.507 2.11 1 .473.493.71 1.18.71 2.06 0 .667-.13 1.24-.39 1.72s-.62.877-1.08 1.19c-.46.313-.997.547-1.61.7a8.146 8.146 0 0 1-1.98.23H14V11zm4.32 5.26c.72 0 1.243-.143 1.57-.43.327-.287.49-.677.49-1.17 0-.493-.167-.847-.5-1.06-.333-.213-.847-.32-1.54-.32h-1.4v2.98h1.38zm.28 5.5c1.613 0 2.42-.593 2.42-1.78 0-.573-.2-.99-.6-1.25-.4-.26-1.007-.39-1.82-.39h-1.66v3.42h1.66z", fill: "#4C4C4C" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "36", height: "36", viewBox: "0 0 36 36", className: "Icon toolbar-bold", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("rect", { stroke: "#BBB", x: ".5", y: ".5", width: "35", height: "35", rx: "3" }),
	            _react2.default.createElement("path", { d: "M14 11h4.46c.68 0 1.31.05 1.89.15.58.1 1.087.277 1.52.53.433.253.773.587 1.02 1 .247.413.37.933.37 1.56 0 .293-.043.587-.13.88a2.744 2.744 0 0 1-1.07 1.5c-.28.2-.607.347-.98.44v.08c.933.173 1.637.507 2.11 1 .473.493.71 1.18.71 2.06 0 .667-.13 1.24-.39 1.72s-.62.877-1.08 1.19c-.46.313-.997.547-1.61.7a8.146 8.146 0 0 1-1.98.23H14V11zm4.32 5.26c.72 0 1.243-.143 1.57-.43.327-.287.49-.677.49-1.17 0-.493-.167-.847-.5-1.06-.333-.213-.847-.32-1.54-.32h-1.4v2.98h1.38zm.28 5.5c1.613 0 2.42-.593 2.42-1.78 0-.573-.2-.99-.6-1.25-.4-.26-1.007-.39-1.82-.39h-1.66v3.42h1.66z", fill: "#4C4C4C" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "38", height: "38", viewBox: "0 0 38 38", className: "Icon toolbar-caption-on", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { transform: "translate(1 1)", fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("rect", { stroke: "#000", width: "36", height: "36", rx: "3", strokeWidth: "2" }),
	            _react2.default.createElement("path", { fill: "#4C4C4C", d: "M5 24h26v2H5zM5 28h23v2H5z" }),
	            _react2.default.createElement("path", { fill: "#BBB", d: "M1 19h34v1H1z" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "36", height: "36", viewBox: "0 0 36 36", className: "Icon toolbar-caption", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("rect", { stroke: "#BBB", x: ".5", y: ".5", width: "35", height: "35", rx: "3" }),
	            _react2.default.createElement("path", { fill: "#4C4C4C", d: "M5 24h26v2H5zM5 28h23v2H5z" }),
	            _react2.default.createElement("path", { fill: "#BBB", d: "M1 19h34v1H1z" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "38", height: "38", viewBox: "0 0 38 38", className: "Icon toolbar-checklist-on", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { transform: "translate(1 1)", fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("rect", { stroke: "#000", width: "36", height: "36", rx: "3", strokeWidth: "2" }),
	            _react2.default.createElement("path", { fill: "#4C4C4C", d: "M17.707 22.121l10.707-10.707L27 10l-9.293 9.282L14.414 16 13 17.414z", fillRule: "nonzero" }),
	            _react2.default.createElement("path", { d: "M27 17v7.007A3.001 3.001 0 0 1 24.007 27H11.993A3.001 3.001 0 0 1 9 24.007V11.993A3.001 3.001 0 0 1 11.993 9H24v1H11.993A2.001 2.001 0 0 0 10 11.993v12.014C10 25.1 10.897 26 11.993 26h12.014A2.001 2.001 0 0 0 26 24.007V17h1z", fill: "#4C4C4C", fillRule: "nonzero" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "36", height: "36", viewBox: "0 0 36 36", className: "Icon toolbar-checklist", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("rect", { stroke: "#BBB", x: ".5", y: ".5", width: "35", height: "35", rx: "3" }),
	            _react2.default.createElement("path", { fill: "#4C4C4C", d: "M17.707 22.121l10.707-10.707L27 10l-9.293 9.282L14.414 16 13 17.414z", fillRule: "nonzero" }),
	            _react2.default.createElement("path", { d: "M27 17v7.007A3.001 3.001 0 0 1 24.007 27H11.993A3.001 3.001 0 0 1 9 24.007V11.993A3.001 3.001 0 0 1 11.993 9H24v1H11.993A2.001 2.001 0 0 0 10 11.993v12.014C10 25.1 10.897 26 11.993 26h12.014A2.001 2.001 0 0 0 26 24.007V17h1z", fill: "#4C4C4C", fillRule: "nonzero" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "38", height: "38", viewBox: "0 0 38 38", className: "Icon toolbar-h1-on", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { transform: "translate(1 1)", fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("rect", { stroke: "#000", width: "36", height: "36", rx: "3", strokeWidth: "2" }),
	            _react2.default.createElement("path", { d: "M16.896 21.456c0 .944-.48 1.12-1.52 1.152v.768h5.072v-.768c-1.072-.032-1.52-.208-1.52-1.152v-7.408c0-.928.448-1.104 1.52-1.136v-.768h-5.072v.768c1.04.032 1.52.208 1.52 1.136v3.136h-5.344v-3.136c0-.928.48-1.104 1.52-1.136v-.768H8v.768c1.072.032 1.52.208 1.52 1.136v7.408c0 .944-.448 1.12-1.52 1.152v.768h5.072v-.768c-1.04-.032-1.52-.208-1.52-1.152v-3.408h5.344v3.408zM25.2 12c-.832 1.104-1.52 1.52-3.072 1.744l-.512.08v.656h2.112v6.96c0 .976-.384 1.04-2.112 1.152v.784h6.112v-.784c-1.664-.096-2.016-.176-2.016-1.152V12H25.2z", fill: "#4C4C4C" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "36", height: "36", viewBox: "0 0 36 36", className: "Icon toolbar-h1", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("rect", { stroke: "#BBB", x: ".5", y: ".5", width: "35", height: "35", rx: "3" }),
	            _react2.default.createElement("path", { d: "M16.896 21.456c0 .944-.48 1.12-1.52 1.152v.768h5.072v-.768c-1.072-.032-1.52-.208-1.52-1.152v-7.408c0-.928.448-1.104 1.52-1.136v-.768h-5.072v.768c1.04.032 1.52.208 1.52 1.136v3.136h-5.344v-3.136c0-.928.48-1.104 1.52-1.136v-.768H8v.768c1.072.032 1.52.208 1.52 1.136v7.408c0 .944-.448 1.12-1.52 1.152v.768h5.072v-.768c-1.04-.032-1.52-.208-1.52-1.152v-3.408h5.344v3.408zM25.2 12c-.832 1.104-1.52 1.52-3.072 1.744l-.512.08v.656h2.112v6.96c0 .976-.384 1.04-2.112 1.152v.784h6.112v-.784c-1.664-.096-2.016-.176-2.016-1.152V12H25.2z", fill: "#4C4C4C" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "38", height: "30", viewBox: "0 0 38 30", className: "Icon toolbar-image-preview-on", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("path", { fill: "#D9D9D9", d: "M1 1h36v28H1z" }),
	            _react2.default.createElement("path", { fill: "#D9D9D9", d: "M1 1h36v28H1z" }),
	            _react2.default.createElement("path", { fill: "#4C4C4C", d: "M13 13l12 16H1z" }),
	            _react2.default.createElement("path", { fill: "#4C4C4C", d: "M29.5 20l7.5 9H22z" }),
	            _react2.default.createElement("path", { d: "M28 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6z", fill: "#FFF" }),
	            _react2.default.createElement("path", { stroke: "#000", d: "M1 1h36v28H1z", strokeWidth: "2" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "36", height: "28", viewBox: "0 0 36 28", className: "Icon toolbar-image-preview", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("path", { d: "M0 0h36v28H0z" }),
	            _react2.default.createElement("path", { fill: "#E3E3E3", d: "M0 0h36v28H0z" }),
	            _react2.default.createElement("path", { fill: "#4C4C4C", d: "M12 12l12 16H0z" }),
	            _react2.default.createElement("path", { fill: "#4C4C4C", d: "M28.5 19l7.5 9H21z" }),
	            _react2.default.createElement("path", { d: "M27 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6z", fill: "#FFF" }),
	            _react2.default.createElement("path", { stroke: "#BBB", d: "M.5.5h35v27H.5z" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "38", height: "38", viewBox: "0 0 38 38", className: "Icon toolbar-italic-on", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { transform: "translate(1 1)", fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("rect", { stroke: "#000", width: "36", height: "36", rx: "3", strokeWidth: "2" }),
	            _react2.default.createElement("path", { d: "M17.94 14.08h1.54l-1.96 9.72H16l1.94-9.72zm1.3-2.02c-.267 0-.497-.077-.69-.23-.193-.153-.29-.377-.29-.67 0-.333.117-.61.35-.83.233-.22.503-.33.81-.33.267 0 .497.08.69.24.193.16.29.387.29.68 0 .333-.117.607-.35.82-.233.213-.503.32-.81.32z", fill: "#4C4C4C" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "36", height: "36", viewBox: "0 0 36 36", className: "Icon toolbar-italic", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("rect", { stroke: "#BBB", x: ".5", y: ".5", width: "35", height: "35", rx: "3" }),
	            _react2.default.createElement("path", { d: "M17.94 14.08h1.54l-1.96 9.72H16l1.94-9.72zm1.3-2.02c-.267 0-.497-.077-.69-.23-.193-.153-.29-.377-.29-.67 0-.333.117-.61.35-.83.233-.22.503-.33.81-.33.267 0 .497.08.69.24.193.16.29.387.29.68 0 .333-.117.607-.35.82-.233.213-.503.32-.81.32z", fill: "#4C4C4C" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "38", height: "38", viewBox: "0 0 38 38", className: "Icon toolbar-list-on", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { transform: "translate(1 1)", fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("rect", { stroke: "#000", width: "36", height: "36", rx: "3", strokeWidth: "2" }),
	            _react2.default.createElement("path", { d: "M10 13a2 2 0 1 0 0-4 2 2 0 0 0 0 4z", fill: "#4C4C4C" }),
	            _react2.default.createElement("circle", { fill: "#4C4C4C", cx: "10", cy: "18", r: "2" }),
	            _react2.default.createElement("circle", { fill: "#4C4C4C", cx: "10", cy: "25", r: "2" }),
	            _react2.default.createElement("path", { fill: "#4C4C4C", d: "M16 10h12v2H16zM16 17h12v2H16zM16 24h12v2H16z" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "36", height: "36", viewBox: "0 0 36 36", className: "Icon toolbar-list", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("rect", { stroke: "#BBB", x: ".5", y: ".5", width: "35", height: "35", rx: "3" }),
	            _react2.default.createElement("path", { d: "M10 13a2 2 0 1 0 0-4 2 2 0 0 0 0 4z", fill: "#4C4C4C" }),
	            _react2.default.createElement("circle", { fill: "#4C4C4C", cx: "10", cy: "18", r: "2" }),
	            _react2.default.createElement("circle", { fill: "#4C4C4C", cx: "10", cy: "25", r: "2" }),
	            _react2.default.createElement("path", { fill: "#4C4C4C", d: "M16 10h12v2H16zM16 17h12v2H16zM16 24h12v2H16z" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "38", height: "38", viewBox: "0 0 38 38", className: "Icon toolbar-lock-on", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { transform: "translate(1 1)", fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("rect", { stroke: "#000", width: "36", height: "36", rx: "3", strokeWidth: "2" }),
	            _react2.default.createElement("rect", { fill: "#4C4C4C", x: "11", y: "16", width: "14", height: "10", rx: ".889" }),
	            _react2.default.createElement("path", { d: "M15 19.003a3 3 0 0 0 6 0v-6.006a3 3 0 0 0-6 0v6.006zm-2-6.006a5 5 0 0 1 10 0v6.006a5 5 0 0 1-10 0v-6.006z", fill: "#424242", fillRule: "nonzero" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "36", height: "36", viewBox: "0 0 36 36", className: "Icon toolbar-lock", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("rect", { stroke: "#BBB", x: ".5", y: ".5", width: "35", height: "35", rx: "3" }),
	            _react2.default.createElement("rect", { fill: "#4C4C4C", x: "11", y: "16", width: "14", height: "10", rx: ".889" }),
	            _react2.default.createElement("path", { d: "M15 19.003a3 3 0 0 0 6 0v-6.006a3 3 0 0 0-6 0v6.006zm-2-6.006a5 5 0 0 1 10 0v6.006a5 5 0 0 1-10 0v-6.006z", fill: "#4C4C4C", fillRule: "nonzero" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "38", height: "38", viewBox: "0 0 38 38", className: "Icon toolbar-numlist-on", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { transform: "translate(1 1)", fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("path", { d: "M8.045 18.65c.264-.246.505-.476.723-.69.219-.214.407-.415.565-.603.157-.188.28-.363.37-.525a.969.969 0 0 0 .132-.464c0-.203-.052-.357-.155-.463a.572.572 0 0 0-.428-.16.669.669 0 0 0-.403.127 2.217 2.217 0 0 0-.33.295L8 15.655c.203-.216.41-.38.623-.49.211-.11.464-.165.758-.165.203 0 .388.031.555.094.166.063.31.151.43.266.122.114.215.252.28.412a1.421 1.421 0 0 1-.013 1.066c-.074.18-.172.36-.295.539-.124.179-.264.358-.422.538-.158.18-.32.355-.49.528.104-.013.22-.025.348-.035a4.08 4.08 0 0 1 .34-.017h.83v.805H8.045v-.545zm.401 6.475c.127.122.266.223.417.302.151.078.316.118.496.118.206 0 .37-.043.492-.128a.418.418 0 0 0 .184-.364.612.612 0 0 0-.05-.25.418.418 0 0 0-.173-.187 1.064 1.064 0 0 0-.342-.118 2.98 2.98 0 0 0-.558-.043v-.683c.189 0 .345-.013.47-.039a.88.88 0 0 0 .302-.115.45.45 0 0 0 .213-.404.438.438 0 0 0-.131-.338c-.088-.08-.215-.121-.38-.121a.83.83 0 0 0-.405.098 2.18 2.18 0 0 0-.377.27l-.486-.591c.193-.167.395-.297.607-.39.213-.095.448-.142.706-.142.215 0 .41.025.588.075.177.05.328.125.453.224.124.098.222.217.292.357.07.14.105.302.105.486 0 .22-.06.404-.18.555-.121.15-.293.275-.516.37v.027c.24.07.439.19.594.358.155.168.233.388.233.66 0 .192-.042.364-.125.515a1.164 1.164 0 0 1-.335.38c-.14.104-.304.182-.492.237a2.13 2.13 0 0 1-.597.082c-.342 0-.63-.054-.867-.16a1.652 1.652 0 0 1-.584-.43l.446-.611z", fill: "#4C4C4C" }),
	            _react2.default.createElement("rect", { stroke: "#000", width: "36", height: "36", rx: "3", strokeWidth: "2" }),
	            _react2.default.createElement("path", { fill: "#4C4C4C", d: "M16 10h12v2H16zM16 17h12v2H16zM16 24h12v2H16zM8 11.25h.87V8.94h-.75v-.574c.218-.042.403-.092.554-.15.151-.06.298-.131.441-.215h.68v3.25h.75V12H8v-.75zM12.215 11.215A.726.726 0 0 1 12.75 11a.731.731 0 0 1 .75.754c0 .21-.072.388-.215.531a.726.726 0 0 1-.535.215.726.726 0 0 1-.535-.215.721.721 0 0 1-.215-.53c0-.217.072-.397.215-.54zM12.215 18.215A.726.726 0 0 1 12.75 18a.731.731 0 0 1 .75.754c0 .21-.072.388-.215.531a.726.726 0 0 1-.535.215.726.726 0 0 1-.535-.215.721.721 0 0 1-.215-.53c0-.217.072-.397.215-.54zM12.215 25.215A.726.726 0 0 1 12.75 25a.731.731 0 0 1 .75.754c0 .21-.072.388-.215.531a.726.726 0 0 1-.535.215.726.726 0 0 1-.535-.215.721.721 0 0 1-.215-.53c0-.217.072-.397.215-.54z" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "36", height: "36", viewBox: "0 0 36 36", className: "Icon toolbar-numlist", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("path", { d: "M8.045 18.65c.264-.246.505-.476.723-.69.219-.214.407-.415.565-.603.157-.188.28-.363.37-.525a.969.969 0 0 0 .132-.464c0-.203-.052-.357-.155-.463a.572.572 0 0 0-.428-.16.669.669 0 0 0-.403.127 2.217 2.217 0 0 0-.33.295L8 15.655c.203-.216.41-.38.623-.49.211-.11.464-.165.758-.165.203 0 .388.031.555.094.166.063.31.151.43.266.122.114.215.252.28.412a1.421 1.421 0 0 1-.013 1.066c-.074.18-.172.36-.295.539-.124.179-.264.358-.422.538-.158.18-.32.355-.49.528.104-.013.22-.025.348-.035a4.08 4.08 0 0 1 .34-.017h.83v.805H8.045v-.545zm.401 6.475c.127.122.266.223.417.302.151.078.316.118.496.118.206 0 .37-.043.492-.128a.418.418 0 0 0 .184-.364.612.612 0 0 0-.05-.25.418.418 0 0 0-.173-.187 1.064 1.064 0 0 0-.342-.118 2.98 2.98 0 0 0-.558-.043v-.683c.189 0 .345-.013.47-.039a.88.88 0 0 0 .302-.115.45.45 0 0 0 .213-.404.438.438 0 0 0-.131-.338c-.088-.08-.215-.121-.38-.121a.83.83 0 0 0-.405.098 2.18 2.18 0 0 0-.377.27l-.486-.591c.193-.167.395-.297.607-.39.213-.095.448-.142.706-.142.215 0 .41.025.588.075.177.05.328.125.453.224.124.098.222.217.292.357.07.14.105.302.105.486 0 .22-.06.404-.18.555-.121.15-.293.275-.516.37v.027c.24.07.439.19.594.358.155.168.233.388.233.66 0 .192-.042.364-.125.515a1.164 1.164 0 0 1-.335.38c-.14.104-.304.182-.492.237a2.13 2.13 0 0 1-.597.082c-.342 0-.63-.054-.867-.16a1.652 1.652 0 0 1-.584-.43l.446-.611z", fill: "#4C4C4C" }),
	            _react2.default.createElement("rect", { stroke: "#BBB", x: ".5", y: ".5", width: "35", height: "35", rx: "3" }),
	            _react2.default.createElement("path", { fill: "#4C4C4C", d: "M16 10h12v2H16zM16 17h12v2H16zM16 24h12v2H16zM8 11.25h.87V8.94h-.75v-.574c.218-.042.403-.092.554-.15.151-.06.298-.131.441-.215h.68v3.25h.75V12H8v-.75zM12.215 11.215A.726.726 0 0 1 12.75 11a.731.731 0 0 1 .75.754c0 .21-.072.388-.215.531a.726.726 0 0 1-.535.215.726.726 0 0 1-.535-.215.721.721 0 0 1-.215-.53c0-.217.072-.397.215-.54zM12.215 18.215A.726.726 0 0 1 12.75 18a.731.731 0 0 1 .75.754c0 .21-.072.388-.215.531a.726.726 0 0 1-.535.215.726.726 0 0 1-.535-.215.721.721 0 0 1-.215-.53c0-.217.072-.397.215-.54zM12.215 25.215A.726.726 0 0 1 12.75 25a.731.731 0 0 1 .75.754c0 .21-.072.388-.215.531a.726.726 0 0 1-.535.215.726.726 0 0 1-.535-.215.721.721 0 0 1-.215-.53c0-.217.072-.397.215-.54z" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "38", height: "38", viewBox: "0 0 38 38", className: "Icon toolbar-quote-on", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { transform: "translate(1 1)", fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("rect", { stroke: "#000", width: "36", height: "36", rx: "3", strokeWidth: "2" }),
	            _react2.default.createElement("path", { d: "M13.484 17.68c.108-1.764 1.26-2.7 3.852-3.024V13C12.872 13.252 11 15.7 11 18.976c0 2.232 1.08 3.708 3.06 3.708 1.62 0 2.7-1.08 2.7-2.592 0-1.368-.684-2.196-1.872-2.412h-1.404zM21.484 17.68c.108-1.764 1.26-2.7 3.852-3.024V13C20.872 13.252 19 15.7 19 18.976c0 2.232 1.08 3.708 3.06 3.708 1.62 0 2.7-1.08 2.7-2.592 0-1.368-.684-2.196-1.872-2.412h-1.404z", fill: "#4C4C4C" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "36", height: "36", viewBox: "0 0 36 36", className: "Icon toolbar-quote", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("rect", { stroke: "#BBB", x: ".5", y: ".5", width: "35", height: "35", rx: "3" }),
	            _react2.default.createElement("path", { d: "M13.484 17.68c.108-1.764 1.26-2.7 3.852-3.024V13C12.872 13.252 11 15.7 11 18.976c0 2.232 1.08 3.708 3.06 3.708 1.62 0 2.7-1.08 2.7-2.592 0-1.368-.684-2.196-1.872-2.412h-1.404zM21.484 17.68c.108-1.764 1.26-2.7 3.852-3.024V13C20.872 13.252 19 15.7 19 18.976c0 2.232 1.08 3.708 3.06 3.708 1.62 0 2.7-1.08 2.7-2.592 0-1.368-.684-2.196-1.872-2.412h-1.404z", fill: "#4C4C4C" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "38", height: "38", viewBox: "0 0 38 38", className: "Icon toolbar-transparent-on", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { transform: "translate(1 1)", fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("path", { d: "M.875 1.25L4 0v4H0l.875-2.75zM8 0h4v4H8V0zm8 0h4v4h-4V0zm8 0h4v4h-4V0zm8 0l2.75 1L36 4h-4V0zM4 4h4v4H4V4zm8 0h4v4h-4V4zm8 0h4v4h-4V4zm8 0h4v4h-4V4zM0 8h4v4H0V8zm8 0h4v4H8V8zm8 0h4v4h-4V8zm8 0h4v4h-4V8zm8 0h4v4h-4V8zM4 12h4v4H4v-4zm8 0h4v4h-4v-4zm8 0h4v4h-4v-4zm8 0h4v4h-4v-4zM0 16h4v4H0v-4zm8 0h4v4H8v-4zm8 0h4v4h-4v-4zm8 0h4v4h-4v-4zm8 0h4v4h-4v-4zM4 20h4v4H4v-4zm8 0h4v4h-4v-4zm8 0h4v4h-4v-4zm8 0h4v4h-4v-4zM0 24h4v4H0v-4zm8 0h4v4H8v-4zm8 0h4v4h-4v-4zm8 0h4v4h-4v-4zm8 0h4v4h-4v-4zM4 28h4v4H4v-4zm8 0h4v4h-4v-4zm8 0h4v4h-4v-4zm8 0h4v4h-4v-4zM0 32h4v4l-2.875-.875L0 32zm8 0h4v4H8v-4zm8 0h4v4h-4v-4zm8 0h4v4h-4v-4zm8 0h4l-.875 2.875L32 36v-4z", fill: "#D9D9D9" }),
	            _react2.default.createElement("rect", { stroke: "#000", width: "36", height: "36", rx: "3", strokeWidth: "2" }),
	            _react2.default.createElement("path", { d: "M17.702 8c2.156 0 3.913 1.745 3.913 3.886 0 .296-.064.603-.163.918.272-.191.544-.34.83-.432a3.948 3.948 0 0 1 1.548-.175 3.91 3.91 0 0 1 3.383 2.672c.667 2.036-.463 4.223-2.513 4.885-.287.092-.601.13-.938.134.268.198.503.407.68.648a3.87 3.87 0 0 1-.856 5.425c-1.745 1.259-4.209.882-5.476-.85a3.036 3.036 0 0 1-.408-.837 3.036 3.036 0 0 1-.407.837c-1.267 1.732-3.732 2.109-5.476.85a3.87 3.87 0 0 1-.856-5.425c.176-.24.412-.45.68-.648a3.194 3.194 0 0 1-.938-.134c-2.05-.662-3.18-2.849-2.513-4.885a3.91 3.91 0 0 1 3.383-2.672 3.948 3.948 0 0 1 1.549.175c.285.092.557.24.828.432a3.105 3.105 0 0 1-.163-.918C13.79 9.746 15.547 8 17.702 8zm0 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4z", fill: "#424242", fillRule: "nonzero" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "36", height: "36", viewBox: "0 0 36 36", className: "Icon toolbar-transparent", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("path", { d: "M.875 1.25L4 0v4H0l.875-2.75zM8 0h4v4H8V0zm8 0h4v4h-4V0zm8 0h4v4h-4V0zm8 0l2.75 1L36 4h-4V0zM4 4h4v4H4V4zm8 0h4v4h-4V4zm8 0h4v4h-4V4zm8 0h4v4h-4V4zM0 8h4v4H0V8zm8 0h4v4H8V8zm8 0h4v4h-4V8zm8 0h4v4h-4V8zm8 0h4v4h-4V8zM4 12h4v4H4v-4zm8 0h4v4h-4v-4zm8 0h4v4h-4v-4zm8 0h4v4h-4v-4zM0 16h4v4H0v-4zm8 0h4v4H8v-4zm8 0h4v4h-4v-4zm8 0h4v4h-4v-4zm8 0h4v4h-4v-4zM4 20h4v4H4v-4zm8 0h4v4h-4v-4zm8 0h4v4h-4v-4zm8 0h4v4h-4v-4zM0 24h4v4H0v-4zm8 0h4v4H8v-4zm8 0h4v4h-4v-4zm8 0h4v4h-4v-4zm8 0h4v4h-4v-4zM4 28h4v4H4v-4zm8 0h4v4h-4v-4zm8 0h4v4h-4v-4zm8 0h4v4h-4v-4zM0 32h4v4l-2.875-.875L0 32zm8 0h4v4H8v-4zm8 0h4v4h-4v-4zm8 0h4v4h-4v-4zm8 0h4l-.875 2.875L32 36v-4z", fill: "#D9D9D9" }),
	            _react2.default.createElement("rect", { stroke: "#BBB", x: ".5", y: ".5", width: "35", height: "35", rx: "3" }),
	            _react2.default.createElement("path", { d: "M17.702 8c2.156 0 3.913 1.745 3.913 3.886 0 .296-.064.603-.163.918.272-.191.544-.34.83-.432a3.948 3.948 0 0 1 1.548-.175 3.91 3.91 0 0 1 3.383 2.672c.667 2.036-.463 4.223-2.513 4.885-.287.092-.601.13-.938.134.268.198.503.407.68.648a3.87 3.87 0 0 1-.856 5.425c-1.745 1.259-4.209.882-5.476-.85a3.036 3.036 0 0 1-.408-.837 3.036 3.036 0 0 1-.407.837c-1.267 1.732-3.732 2.109-5.476.85a3.87 3.87 0 0 1-.856-5.425c.176-.24.412-.45.68-.648a3.194 3.194 0 0 1-.938-.134c-2.05-.662-3.18-2.849-2.513-4.885a3.91 3.91 0 0 1 3.383-2.672 3.948 3.948 0 0 1 1.549.175c.285.092.557.24.828.432a3.105 3.105 0 0 1-.163-.918C13.79 9.746 15.547 8 17.702 8zm0 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4z", fill: "#4C4C4C", fillRule: "nonzero" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "34", height: "40", viewBox: "0 0 34 40", className: "Icon toolbar-trash", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "defs",
	            null,
	            _react2.default.createElement(
	                "filter",
	                { x: "-50%", y: "-50%", width: "200%", height: "200%", filterUnits: "objectBoundingBox", id: "a-toolbar-trash" },
	                _react2.default.createElement("feGaussianBlur", { stdDeviation: "1.729", "in": "SourceGraphic" })
	            ),
	            _react2.default.createElement(
	                "linearGradient",
	                { x1: "98.055%", y1: "50%", x2: "0%", y2: "50%", id: "b-toolbar-trash" },
	                _react2.default.createElement("stop", { offset: "0%", stopColor: "#BEBEBE" }),
	                _react2.default.createElement("stop", { offset: "27.774%", stopColor: "#CDCDCD" }),
	                _react2.default.createElement("stop", { offset: "72.692%", stopColor: "#DDD" }),
	                _react2.default.createElement("stop", { offset: "100%", stopColor: "#C3C3C3" })
	            ),
	            _react2.default.createElement("path", { d: "M17 10c8.284 0 15-1.79 15-4s-6.716-4-15-4C8.716 2 2 3.79 2 6s6.716 4 15 4z", id: "c-toolbar-trash" }),
	            _react2.default.createElement(
	                "filter",
	                { x: "-50%", y: "-50%", width: "200%", height: "200%", filterUnits: "objectBoundingBox", id: "d-toolbar-trash" },
	                _react2.default.createElement("feGaussianBlur", { stdDeviation: "1.5", "in": "SourceAlpha", result: "shadowBlurInner1" }),
	                _react2.default.createElement("feOffset", { dy: "-2", "in": "shadowBlurInner1", result: "shadowOffsetInner1" }),
	                _react2.default.createElement("feComposite", { "in": "shadowOffsetInner1", in2: "SourceAlpha", operator: "arithmetic", k2: "-1", k3: "1", result: "shadowInnerInner1" }),
	                _react2.default.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0", "in": "shadowInnerInner1" })
	            )
	        ),
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("path", { d: "M1 6c0-2.761 7.163-5 16-5s16 2.239 16 5c0 .11-3 29-3 29 0 2.21-5.82 4-13 4S4 37.21 4 35C4 35 1 6.11 1 6z", fill: "#F9F9F9" }),
	            _react2.default.createElement("path", { d: "M1.024 6c0 .11 3 29 3 29 0 2.21 5.82 4 13 4s13-1.79 13-4c0 0 3-28.89 3-29 0-2.761-7.164-5-16-5-8.837 0-16 2.239-16 5zm16-6c10 0 17.5 2.5 17 6-.016.107-.334 3.336-1.501 14.603l-1.036 9.984-.34 3.275-.129 1.241C31.024 38.08 24.778 40 17.024 40c-7.756 0-14-1.921-14-5-.018-.122-.018-.122-.124-1.138l-.34-3.275-1.031-9.943C.357 9.336.024 6.108.024 6c-.5-3.5 7-6 17-6z", fill: "#A5A5A5" }),
	            _react2.default.createElement("path", { fill: "#FFF", filter: "url(#a-toolbar-trash)", d: "M23.5 37L27 9h-7z", fillOpacity: ".9" }),
	            _react2.default.createElement(
	                "g",
	                null,
	                _react2.default.createElement("use", { fill: "url(#b-toolbar-trash)", xlinkHref: "#c-toolbar-trash" }),
	                _react2.default.createElement("use", { fill: "#000", filter: "url(#d-toolbar-trash)", xlinkHref: "#c-toolbar-trash" })
	            ),
	            _react2.default.createElement("path", { d: "M17 10c8.284 0 15-1.79 15-4s-6.716-4-15-4C8.716 2 2 3.79 2 6s6.716 4 15 4zm0 1C8.083 11 1 9.111 1 6c0-3.111 7.083-5 16-5s16 1.889 16 5c0 3.111-7.083 5-16 5z", fill: "#FFF" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "16", height: "19", viewBox: "0 0 16 19", className: "Icon user-guest", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement("path", { d: "M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0zm12 12.248V15.17c0-.539-.202-1.4-.8-2.267-.997-1.445-3.096-2.903-7.196-2.904C3.896 10 1.798 11.46.8 12.905c-.598.866-.8 1.727-.8 2.266v1.077A12.944 12.944 0 0 0 8 19c3.017 0 5.794-1.028 8-2.752z", fill: "#929292", fillRule: "evenodd" })
	    );
	}; /*eslint-disable */

/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _closeX = __webpack_require__(1857);
	
	var _closeX2 = _interopRequireDefault(_closeX);
	
	var _elementBoard = __webpack_require__(1858);
	
	var _elementBoard2 = _interopRequireDefault(_elementBoard);
	
	var _elementCard = __webpack_require__(1859);
	
	var _elementCard2 = _interopRequireDefault(_elementCard);
	
	var _elementColumn = __webpack_require__(1860);
	
	var _elementColumn2 = _interopRequireDefault(_elementColumn);
	
	var _elementImage = __webpack_require__(1861);
	
	var _elementImage2 = _interopRequireDefault(_elementImage);
	
	var _elementLine = __webpack_require__(1862);
	
	var _elementLine2 = _interopRequireDefault(_elementLine);
	
	var _elementLink = __webpack_require__(1863);
	
	var _elementLink2 = _interopRequireDefault(_elementLink);
	
	var _linkIcon = __webpack_require__(1864);
	
	var _linkIcon2 = _interopRequireDefault(_linkIcon);
	
	var _navAntenna = __webpack_require__(1865);
	
	var _navAntenna2 = _interopRequireDefault(_navAntenna);
	
	var _navExport = __webpack_require__(1866);
	
	var _navExport2 = _interopRequireDefault(_navExport);
	
	var _navHelp = __webpack_require__(1867);
	
	var _navHelp2 = _interopRequireDefault(_navHelp);
	
	var _navNotifications = __webpack_require__(1868);
	
	var _navNotifications2 = _interopRequireDefault(_navNotifications);
	
	var _toolbarArrowLeftOff = __webpack_require__(1869);
	
	var _toolbarArrowLeftOff2 = _interopRequireDefault(_toolbarArrowLeftOff);
	
	var _toolbarArrowLeftOn = __webpack_require__(1870);
	
	var _toolbarArrowLeftOn2 = _interopRequireDefault(_toolbarArrowLeftOn);
	
	var _toolbarArrowLeft = __webpack_require__(1871);
	
	var _toolbarArrowLeft2 = _interopRequireDefault(_toolbarArrowLeft);
	
	var _toolbarArrowRightOff = __webpack_require__(1872);
	
	var _toolbarArrowRightOff2 = _interopRequireDefault(_toolbarArrowRightOff);
	
	var _toolbarArrowRightOn = __webpack_require__(1873);
	
	var _toolbarArrowRightOn2 = _interopRequireDefault(_toolbarArrowRightOn);
	
	var _toolbarArrowRight = __webpack_require__(1874);
	
	var _toolbarArrowRight2 = _interopRequireDefault(_toolbarArrowRight);
	
	var _toolbarBoldOn = __webpack_require__(1875);
	
	var _toolbarBoldOn2 = _interopRequireDefault(_toolbarBoldOn);
	
	var _toolbarBold = __webpack_require__(1876);
	
	var _toolbarBold2 = _interopRequireDefault(_toolbarBold);
	
	var _toolbarCaptionOn = __webpack_require__(1877);
	
	var _toolbarCaptionOn2 = _interopRequireDefault(_toolbarCaptionOn);
	
	var _toolbarCaption = __webpack_require__(1878);
	
	var _toolbarCaption2 = _interopRequireDefault(_toolbarCaption);
	
	var _toolbarChecklistOn = __webpack_require__(1879);
	
	var _toolbarChecklistOn2 = _interopRequireDefault(_toolbarChecklistOn);
	
	var _toolbarChecklist = __webpack_require__(1880);
	
	var _toolbarChecklist2 = _interopRequireDefault(_toolbarChecklist);
	
	var _toolbarH1On = __webpack_require__(1881);
	
	var _toolbarH1On2 = _interopRequireDefault(_toolbarH1On);
	
	var _toolbarH = __webpack_require__(1882);
	
	var _toolbarH2 = _interopRequireDefault(_toolbarH);
	
	var _toolbarImagePreviewOn = __webpack_require__(1883);
	
	var _toolbarImagePreviewOn2 = _interopRequireDefault(_toolbarImagePreviewOn);
	
	var _toolbarImagePreview = __webpack_require__(1884);
	
	var _toolbarImagePreview2 = _interopRequireDefault(_toolbarImagePreview);
	
	var _toolbarItalicOn = __webpack_require__(1885);
	
	var _toolbarItalicOn2 = _interopRequireDefault(_toolbarItalicOn);
	
	var _toolbarItalic = __webpack_require__(1886);
	
	var _toolbarItalic2 = _interopRequireDefault(_toolbarItalic);
	
	var _toolbarListOn = __webpack_require__(1887);
	
	var _toolbarListOn2 = _interopRequireDefault(_toolbarListOn);
	
	var _toolbarList = __webpack_require__(1888);
	
	var _toolbarList2 = _interopRequireDefault(_toolbarList);
	
	var _toolbarLockOn = __webpack_require__(1889);
	
	var _toolbarLockOn2 = _interopRequireDefault(_toolbarLockOn);
	
	var _toolbarLock = __webpack_require__(1890);
	
	var _toolbarLock2 = _interopRequireDefault(_toolbarLock);
	
	var _toolbarNumlistOn = __webpack_require__(1891);
	
	var _toolbarNumlistOn2 = _interopRequireDefault(_toolbarNumlistOn);
	
	var _toolbarNumlist = __webpack_require__(1892);
	
	var _toolbarNumlist2 = _interopRequireDefault(_toolbarNumlist);
	
	var _toolbarQuoteOn = __webpack_require__(1893);
	
	var _toolbarQuoteOn2 = _interopRequireDefault(_toolbarQuoteOn);
	
	var _toolbarQuote = __webpack_require__(1894);
	
	var _toolbarQuote2 = _interopRequireDefault(_toolbarQuote);
	
	var _toolbarTransparentOn = __webpack_require__(1895);
	
	var _toolbarTransparentOn2 = _interopRequireDefault(_toolbarTransparentOn);
	
	var _toolbarTransparent = __webpack_require__(1896);
	
	var _toolbarTransparent2 = _interopRequireDefault(_toolbarTransparent);
	
	var _toolbarTrash = __webpack_require__(1897);
	
	var _toolbarTrash2 = _interopRequireDefault(_toolbarTrash);
	
	var _userGuest = __webpack_require__(1898);
	
	var _userGuest2 = _interopRequireDefault(_userGuest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*eslint-disable */
	
	exports.default = {
	    'close-x': _closeX2.default,
	    'element-board': _elementBoard2.default,
	    'element-card': _elementCard2.default,
	    'element-column': _elementColumn2.default,
	    'element-image': _elementImage2.default,
	    'element-line': _elementLine2.default,
	    'element-link': _elementLink2.default,
	    'link-icon': _linkIcon2.default,
	    'nav-antenna': _navAntenna2.default,
	    'nav-export': _navExport2.default,
	    'nav-help': _navHelp2.default,
	    'nav-notifications': _navNotifications2.default,
	    'toolbar-arrow-left-off': _toolbarArrowLeftOff2.default,
	    'toolbar-arrow-left-on': _toolbarArrowLeftOn2.default,
	    'toolbar-arrow-left': _toolbarArrowLeft2.default,
	    'toolbar-arrow-right-off': _toolbarArrowRightOff2.default,
	    'toolbar-arrow-right-on': _toolbarArrowRightOn2.default,
	    'toolbar-arrow-right': _toolbarArrowRight2.default,
	    'toolbar-bold-on': _toolbarBoldOn2.default,
	    'toolbar-bold': _toolbarBold2.default,
	    'toolbar-caption-on': _toolbarCaptionOn2.default,
	    'toolbar-caption': _toolbarCaption2.default,
	    'toolbar-checklist-on': _toolbarChecklistOn2.default,
	    'toolbar-checklist': _toolbarChecklist2.default,
	    'toolbar-h1-on': _toolbarH1On2.default,
	    'toolbar-h1': _toolbarH2.default,
	    'toolbar-image-preview-on': _toolbarImagePreviewOn2.default,
	    'toolbar-image-preview': _toolbarImagePreview2.default,
	    'toolbar-italic-on': _toolbarItalicOn2.default,
	    'toolbar-italic': _toolbarItalic2.default,
	    'toolbar-list-on': _toolbarListOn2.default,
	    'toolbar-list': _toolbarList2.default,
	    'toolbar-lock-on': _toolbarLockOn2.default,
	    'toolbar-lock': _toolbarLock2.default,
	    'toolbar-numlist-on': _toolbarNumlistOn2.default,
	    'toolbar-numlist': _toolbarNumlist2.default,
	    'toolbar-quote-on': _toolbarQuoteOn2.default,
	    'toolbar-quote': _toolbarQuote2.default,
	    'toolbar-transparent-on': _toolbarTransparentOn2.default,
	    'toolbar-transparent': _toolbarTransparent2.default,
	    'toolbar-trash': _toolbarTrash2.default,
	    'user-guest': _userGuest2.default
	};

/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "8", height: "8", viewBox: "0 0 8 8", className: "Icon close-x", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { stroke: "#929292", fill: "none", strokeWidth: "1.2" },
	            _react2.default.createElement("path", { d: "M0 0l8 8M8 0L0 8" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "30", height: "30", viewBox: "0 0 30 30", className: "Icon element-board", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("rect", { fill: "#C7C7C7", width: "30", height: "30", rx: "3.5" }),
	            _react2.default.createElement("path", { d: "M1 3.196v23.608C1 28.019 1.982 29 3.196 29h23.608A2.194 2.194 0 0 0 29 26.804V3.196A2.194 2.194 0 0 0 26.804 1H3.196A2.194 2.194 0 0 0 1 3.196zm-1 0A3.194 3.194 0 0 1 3.196 0h23.608A3.194 3.194 0 0 1 30 3.196v23.608A3.194 3.194 0 0 1 26.804 30H3.196A3.194 3.194 0 0 1 0 26.804V3.196z", fill: "#A5A5A5" }),
	            _react2.default.createElement("path", { fill: "#FFF", d: "M7 7h7v9.474H7zM7 18h7v5H7zM16 7h7v16h-7z" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "30", height: "22", viewBox: "0 0 30 22", className: "Icon element-card", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("path", { fill: "#FFF", d: "M1 1h28v20H1z" }),
	            _react2.default.createElement("path", { d: "M1 21h28V1H1v20zM0 0h30v22H0V0z", fill: "#A5A5A5" }),
	            _react2.default.createElement("path", { fill: "#929292", d: "M5 5h20v1H5zM5 8h18v1H5zM5 11h20v1H5zM5 14h17v1H5z" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "28", height: "30", viewBox: "0 0 28 30", className: "Icon element-column", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("path", { fill: "#FFF", d: "M1 1h26v28H1z" }),
	            _react2.default.createElement("path", { d: "M28 29l-1 1v-1h1zM1 29h26V1H1v28zM0 0h28v30H0V0z", fill: "#A5A5A5" }),
	            _react2.default.createElement("path", { d: "M24 25h1l-1 1v-1zM4 25h20v-6H4v6zm-1-7h22v8H3v-8zM24 16h1l-1 1v-1zM4 16h20v-6H4v6zM3 9h22v8H3V9z", fill: "#C6C6C6" }),
	            _react2.default.createElement("path", { fill: "#333", d: "M8 4h12v2H8z" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "30", height: "29", viewBox: "0 0 30 29", className: "Icon element-image", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "defs",
	            null,
	            _react2.default.createElement(
	                "linearGradient",
	                { x1: "0%", y1: "100%", x2: "0%", y2: "0%", id: "a-element-image" },
	                _react2.default.createElement("stop", { offset: "0%", stopColor: "#B5DFF5" }),
	                _react2.default.createElement("stop", { offset: "100%", stopColor: "#A6D7F4" })
	            ),
	            _react2.default.createElement(
	                "linearGradient",
	                { x1: "50%", y1: "100%", x2: "50%", y2: "0%", id: "b-element-image" },
	                _react2.default.createElement("stop", { offset: "0%", stopColor: "#96BA68" }),
	                _react2.default.createElement("stop", { offset: "100%", stopColor: "#7AA947" })
	            ),
	            _react2.default.createElement("path", { d: "M22 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4z", id: "d-element-image" }),
	            _react2.default.createElement(
	                "filter",
	                { x: "-50%", y: "-50%", width: "200%", height: "200%", filterUnits: "objectBoundingBox", id: "c-element-image" },
	                _react2.default.createElement("feOffset", { "in": "SourceAlpha", result: "shadowOffsetOuter1" }),
	                _react2.default.createElement("feGaussianBlur", { stdDeviation: "1.5", "in": "shadowOffsetOuter1", result: "shadowBlurOuter1" }),
	                _react2.default.createElement("feColorMatrix", { values: "0 0 0 0 1 0 0 0 0 0.992156863 0 0 0 0 0.866666667 0 0 0 0.5 0", "in": "shadowBlurOuter1" })
	            )
	        ),
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("path", { d: "M1 28h28V1H1v27zM0 0h30v29H0V0z", fill: "#A5A5A5" }),
	            _react2.default.createElement("path", { fill: "#FFF", d: "M1 1h28v27H1z" }),
	            _react2.default.createElement("path", { fill: "url(#a-element-image)", d: "M3 3h24v19H3z" }),
	            _react2.default.createElement("path", { fill: "url(#b-element-image)", d: "M11 12l8 10H3z" }),
	            _react2.default.createElement("path", { fill: "url(#b-element-image)", d: "M22 16l5 6H17z" }),
	            _react2.default.createElement(
	                "g",
	                null,
	                _react2.default.createElement("use", { fill: "#000", filter: "url(#c-element-image)", xlinkHref: "#d-element-image" }),
	                _react2.default.createElement("use", { fill: "#FFFDDE", xlinkHref: "#d-element-image" })
	            ),
	            _react2.default.createElement("path", { d: "M26 21h1l-1 1v-1zM4 21h22V4H4v17zM3 3h24v19H3V3z", fill: "#000", fillOpacity: ".1" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "27", height: "27", viewBox: "0 0 27 27", className: "Icon element-line", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement("path", { d: "M22.491 5.64L1.566 26.566.434 25.434 21.358 4.51l-1.67-1.666L27 0l-2.716 7.428L22.49 5.64z", fill: "#777", fillRule: "evenodd" })
	    );
	}; /*eslint-disable */

/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "28", height: "28", viewBox: "0 0 28 28", className: "Icon element-link", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("path", { fill: "#FFF", d: "M1 1h26v26H1z" }),
	            _react2.default.createElement("path", { d: "M28 27l-1 1v-1h1zM1 27h26V1H1v26zM0 0h28v28H0V0z", fill: "#A5A5A5" }),
	            _react2.default.createElement(
	                "g",
	                { fill: "#333" },
	                _react2.default.createElement("path", { d: "M13.617 14.764c-.894-.82-.88-2.028 0-2.838l2.773-2.8c.967-1.113 2.47-1.36 3.382-.436.886.897.584 2.31-.535 3.281l-1.72 1.661a.5.5 0 1 0 .695.72l1.7-1.644c1.488-1.29 1.928-3.347.572-4.72-1.37-1.387-3.534-1.032-4.827.458l-2.733 2.76c-1.292 1.187-1.313 3.076.018 4.295a.5.5 0 0 0 .675-.737z" }),
	                _react2.default.createElement("path", { d: "M14.777 13.642c.895.82.882 2.028 0 2.838l-2.756 2.807c-.966 1.111-2.47 1.358-3.381.434-.886-.896-.584-2.309.535-3.28l1.72-1.66a.5.5 0 0 0-.696-.72l-1.7 1.643c-1.488 1.29-1.927 3.347-.57 4.72 1.368 1.386 3.533 1.031 4.826-.459l2.717-2.766c1.291-1.186 1.311-3.075-.02-4.294a.5.5 0 1 0-.675.737z" })
	            )
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "16", height: "16", viewBox: "0 0 16 16", className: "Icon link-icon", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement("path", { d: "M7.405 8.57c-1.047-.961-1.032-2.384.001-3.333l3.03-3.069c1.122-1.29 2.878-1.579 3.947-.495 1.04 1.054.688 2.707-.613 3.835l-2.203 2.13a.5.5 0 0 0 .695.72l2.183-2.113c1.67-1.447 2.16-3.745.65-5.275-1.527-1.546-3.944-1.15-5.392.519l-2.99 3.028c-1.444 1.326-1.466 3.43.017 4.79a.5.5 0 1 0 .675-.738zm1.19-1.139c1.047.961 1.032 2.383-.001 3.333l-3.03 3.069c-1.122 1.29-2.878 1.578-3.947.495-1.04-1.054-.688-2.707.613-3.835l2.203-2.13a.5.5 0 0 0-.695-.72L1.555 9.756c-1.67 1.448-2.16 3.745-.65 5.276 1.527 1.546 3.944 1.149 5.392-.52l2.99-3.028c1.444-1.326 1.466-3.429-.017-4.789a.5.5 0 1 0-.675.737z", fill: "#6E6E71", fillRule: "evenodd" })
	    );
	}; /*eslint-disable */

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "20", height: "18", viewBox: "0 0 20 18", className: "Icon nav-antenna", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "#777", fillRule: "evenodd" },
	            _react2.default.createElement("path", { d: "M2.147 6.688c0-1.99.772-3.857 2.176-5.26A.674.674 0 1 0 3.37.474c-3.426 3.427-3.426 9.002 0 12.428a.672.672 0 0 0 .953 0 .674.674 0 0 0 0-.954 7.389 7.389 0 0 1-2.176-5.26" }),
	            _react2.default.createElement("path", { d: "M5.237 6.688c0-1.37.532-2.656 1.498-3.622a.674.674 0 0 0-.953-.953 6.477 6.477 0 0 0 0 9.149.67.67 0 0 0 .476.197.672.672 0 0 0 .477-1.149 5.087 5.087 0 0 1-1.498-3.622M17.343.474a.676.676 0 0 0-.953 0 .677.677 0 0 0 0 .954 7.383 7.383 0 0 1 2.176 5.26c0 1.99-.772 3.858-2.176 5.26a.673.673 0 0 0 0 .954.671.671 0 0 0 .953 0c3.426-3.427 3.426-9.002 0-12.428" }),
	            _react2.default.createElement("path", { d: "M14.93 2.113a.673.673 0 1 0-.952.953 5.13 5.13 0 0 1 0 7.244.669.669 0 0 0-.001.951.665.665 0 0 0 .477.198.67.67 0 0 0 .477-.197 6.477 6.477 0 0 0 0-9.149" }),
	            _react2.default.createElement("path", { d: "M9.672 10.192c.483.098.886.098 1.369 0v6.174c0 .149-.13.279-.28.279h-.81a.286.286 0 0 1-.28-.28v-6.173zm.685-5.733c1.229 0 2.229 1 2.229 2.229s-1 2.229-2.23 2.229-2.23-1-2.23-2.23c0-1.228 1-2.228 2.23-2.228zm0-1.35a3.582 3.582 0 0 0-3.578 3.579c0 1.176.577 2.273 1.546 2.942v6.736c0 .897.73 1.626 1.626 1.626h.81c.897 0 1.627-.73 1.627-1.626V9.63a3.573 3.573 0 0 0 1.547-2.942 3.583 3.583 0 0 0-3.578-3.578z" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "21", height: "18", viewBox: "0 0 21 18", className: "Icon nav-export", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement("path", { d: "M12.626 8.29H8.204a.632.632 0 0 0 0 1.263h4.422v6.773H2.074V1.524h10.552V8.29zm7.363.235l-2.31-2.318a.63.63 0 0 0-.446-.187h-.002a.626.626 0 0 0-.445.185.626.626 0 0 0-.185.445.627.627 0 0 0 .183.448l1.19 1.192h-4V.85A.674.674 0 0 0 13.3.178H1.4A.673.673 0 0 0 .727.85V17c0 .372.301.674.673.674h11.9a.674.674 0 0 0 .674-.674V9.553h4.064l-1.247 1.213a.632.632 0 0 0 .432 1.084h.008a.628.628 0 0 0 .44-.18l2.311-2.246a.624.624 0 0 0 .191-.448.623.623 0 0 0-.184-.451z", fill: "#777", fillRule: "evenodd" })
	    );
	}; /*eslint-disable */

/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "19", height: "19", viewBox: "0 0 19 19", className: "Icon nav-help", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "#777", fillRule: "evenodd" },
	            _react2.default.createElement("path", { d: "M8.19 13.63h1.48v-1.492H8.19zM9.024 4.25c-.767 0-1.408.211-1.907.626-.505.42-.754.986-.741 1.681 0 .294.143.85.683.85.538 0 .695-.53.704-.813 0-.368.117-.638.359-.825.246-.191.549-.287.902-.287.405 0 .719.109.933.325.213.215.322.532.322.942 0 .348-.082.647-.245.89-.172.258-.464.631-.86 1.099-.438.396-.702.708-.807.955-.106.247-.16.668-.164 1.288l-.001.101h1.426v-.1c0-.366.022-.638.067-.807.043-.16.172-.348.38-.557.484-.467.879-.93 1.174-1.378.3-.458.454-.97.454-1.522 0-.771-.24-1.383-.71-1.817-.468-.432-1.131-.651-1.97-.651" }),
	            _react2.default.createElement("path", { d: "M16.755 9.025c0 4.262-3.467 7.73-7.73 7.73-4.262 0-7.73-3.468-7.73-7.73 0-4.262 3.468-7.73 7.73-7.73 4.263 0 7.73 3.468 7.73 7.73M9.025 0C4.05 0 0 4.049 0 9.025c0 4.977 4.049 9.025 9.026 9.025 4.976 0 9.024-4.048 9.024-9.025C18.05 4.049 14.002 0 9.026 0" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "23", height: "19", viewBox: "0 0 23 19", className: "Icon nav-notifications", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "#777", fillRule: "evenodd" },
	            _react2.default.createElement("path", { d: "M4.862 4.775a2.666 2.666 0 0 1 2.663-2.662 2.665 2.665 0 0 1 2.662 2.662 2.666 2.666 0 0 1-2.662 2.663 2.667 2.667 0 0 1-2.663-2.663M7.525 8.7a3.93 3.93 0 0 0 3.925-3.925A3.93 3.93 0 0 0 7.525.85 3.93 3.93 0 0 0 3.6 4.775 3.928 3.928 0 0 0 7.525 8.7M15.063 7.325a1.813 1.813 0 0 1 3.624 0 1.813 1.813 0 0 1-3.624 0m1.812 3.075a3.078 3.078 0 0 0 3.076-3.075 3.078 3.078 0 0 0-3.076-3.075A3.079 3.079 0 0 0 13.8 7.325a3.079 3.079 0 0 0 3.075 3.075M14.565 13.393c.201-.042.4-.077.632-.11a12.04 12.04 0 0 1 1.678-.12c.547 0 1.112.04 1.677.12.384.054.595.101.657.115 1.118.185 2.028 1.223 2.028 2.314v1.017c0 .033-.027.059-.063.059h-6.369c.027-.118.045-.24.045-.366V14.89c0-.516-.104-1.02-.285-1.497zm-2.053 3.336v-1.017c0-.672.365-1.346.896-1.794.11.314.178.641.178.972v1.532a.364.364 0 0 1-.369.366h-.642c-.034 0-.063-.027-.063-.059zm-8.114-5.072l.085-.039a3.86 3.86 0 0 1 .336-.051c.607-.069 1.517-.104 2.705-.104 1.19 0 2.1.035 2.705.104.156.018.267.036.315.043l.07.034.191.032c.764.109 1.465.542 1.974 1.139-.909.672-1.529 1.755-1.529 2.897v1.017c0 .021.01.038.011.059H1.833a.369.369 0 0 1-.37-.366V14.89c0-1.547 1.266-3.018 2.766-3.212l.17-.021zm15.09.51a12.873 12.873 0 0 0-2.613-.267c-1.45 0-2.603.264-2.607.266-.116.018-.226.057-.34.088-.707-.951-1.752-1.653-2.933-1.826-.109-.04-.766-.228-3.47-.228-2.7 0-3.358.187-3.47.228C1.928 10.709.2 12.708.2 14.89v1.532c0 .898.732 1.628 1.633 1.628h19.341c.731 0 1.327-.593 1.327-1.321v-1.017c0-1.684-1.355-3.274-3.013-3.545z" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "30", height: "30", viewBox: "0 0 30 30", className: "Icon toolbar-arrow-left-off", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("path", { d: "M20.582 16.726v3.933L7.84 14.738l12.743-5.132v3.934h8.924v3.186h-8.924z", fill: "#777" }),
	            _react2.default.createElement("path", { d: "M15 29c7.732 0 14-6.268 14-14S22.732 1 15 1 1 7.268 1 15s6.268 14 14 14zm0 1C6.716 30 0 23.284 0 15 0 6.716 6.716 0 15 0c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15z", fill: "#BBB", fillRule: "nonzero" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "32", height: "32", viewBox: "0 0 32 32", className: "Icon toolbar-arrow-left-on", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("path", { d: "M21.582 17.726v3.933L8.84 15.738l12.743-5.132v3.934h8.924v3.186h-8.924z", fill: "#4C4C4C" }),
	            _react2.default.createElement("path", { d: "M16 31C7.716 31 1 24.284 1 16 1 7.716 7.716 1 16 1c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15z", stroke: "#000", strokeWidth: "2" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "30", height: "30", viewBox: "0 0 30 30", className: "Icon toolbar-arrow-left", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("path", { d: "M20.582 16.726v3.933L7.84 14.738l12.743-5.132v3.934h8.924v3.186h-8.924z", fill: "#4C4C4C" }),
	            _react2.default.createElement("path", { d: "M15 29c7.732 0 14-6.268 14-14S22.732 1 15 1 1 7.268 1 15s6.268 14 14 14zm0 1C6.716 30 0 23.284 0 15 0 6.716 6.716 0 15 0c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15z", fill: "#BBB", fillRule: "nonzero" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "30", height: "30", viewBox: "-46 -4 30 30", className: "Icon toolbar-arrow-right-off", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement("path", { d: "M-45.5 12.7V9.5h8.9V5.6l12.7 5.1-12.7 5.9v-3.9h-8.9z", fill: "#777" }),
	        _react2.default.createElement("path", { d: "M-17 11c0-7.7-6.3-14-14-14s-14 6.3-14 14 6.3 14 14 14 14-6.3 14-14zm-29 0c0-8.3 6.7-15 15-15s15 6.7 15 15-6.7 15-15 15-15-6.7-15-15z", fill: "#bbb" })
	    );
	}; /*eslint-disable */

/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "32", height: "32", viewBox: "0 0 32 32", className: "Icon toolbar-arrow-right-on", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("path", { d: "M10.418 17.726v3.933l12.743-5.921-12.743-5.132v3.934H1.494v3.186h8.924z", fill: "#4C4C4C" }),
	            _react2.default.createElement("path", { d: "M16 31c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C7.716 1 1 7.716 1 16c0 8.284 6.716 15 15 15z", stroke: "#000", strokeWidth: "2" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "30", height: "30", viewBox: "0 0 30 30", className: "Icon toolbar-arrow-right", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("path", { d: "M9.418 16.726v3.933l12.743-5.921L9.418 9.606v3.934H.494v3.186h8.924z", fill: "#4C4C4C" }),
	            _react2.default.createElement("path", { d: "M15 29C7.268 29 1 22.732 1 15S7.268 1 15 1s14 6.268 14 14-6.268 14-14 14zm0 1c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15z", fill: "#BBB", fillRule: "nonzero" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "30", height: "30", viewBox: "0 0 30 30", className: "Icon toolbar-bold-on", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { transform: "translate(1 1)", fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("rect", { stroke: "#000", width: "28", height: "28", rx: "2.4", strokeWidth: "2" }),
	            _react2.default.createElement("path", { d: "M10 9h3.568c.544 0 1.048.04 1.512.12a3.6 3.6 0 0 1 1.216.424c.347.203.619.47.816.8.197.332.296.748.296 1.25 0 .235-.035.47-.104.704a2.196 2.196 0 0 1-.856 1.2c-.224.161-.485.278-.784.353v.064c.747.139 1.31.406 1.688.8.379.396.568.945.568 1.65 0 .533-.104.992-.312 1.377a2.688 2.688 0 0 1-.864.952 3.98 3.98 0 0 1-1.288.56 6.512 6.512 0 0 1-1.584.185H10V9zm3.456 4.21c.576 0 .995-.114 1.256-.343.261-.23.392-.542.392-.937s-.133-.678-.4-.849c-.267-.17-.677-.256-1.232-.256h-1.12v2.386h1.104zm.224 4.404c1.29 0 1.936-.475 1.936-1.425 0-.46-.16-.793-.48-1.001-.32-.208-.805-.312-1.456-.312h-1.328v2.738h1.328z", fill: "#4C4C4C" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "28", height: "28", viewBox: "0 0 28 28", className: "Icon toolbar-bold", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("rect", { stroke: "#BBB", x: ".5", y: ".5", width: "27", height: "27", rx: "2.4" }),
	            _react2.default.createElement("path", { d: "M10 9h3.568c.544 0 1.048.04 1.512.12a3.6 3.6 0 0 1 1.216.424c.347.203.619.47.816.8.197.332.296.748.296 1.25 0 .235-.035.47-.104.704a2.196 2.196 0 0 1-.856 1.2c-.224.161-.485.278-.784.353v.064c.747.139 1.31.406 1.688.8.379.396.568.945.568 1.65 0 .533-.104.992-.312 1.377a2.688 2.688 0 0 1-.864.952 3.98 3.98 0 0 1-1.288.56 6.512 6.512 0 0 1-1.584.185H10V9zm3.456 4.21c.576 0 .995-.114 1.256-.343.261-.23.392-.542.392-.937s-.133-.678-.4-.849c-.267-.17-.677-.256-1.232-.256h-1.12v2.386h1.104zm.224 4.404c1.29 0 1.936-.475 1.936-1.425 0-.46-.16-.793-.48-1.001-.32-.208-.805-.312-1.456-.312h-1.328v2.738h1.328z", fill: "#4C4C4C" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "30", height: "30", viewBox: "0 0 30 30", className: "Icon toolbar-caption-on", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { transform: "translate(1 1)", fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("path", { fill: "#4C4C4C", d: "M4 18h20v2H4zM4 22h16v2H4z" }),
	            _react2.default.createElement("path", { fill: "#BBB", d: "M0 14h28v1H0z" }),
	            _react2.default.createElement("rect", { stroke: "#000", width: "28", height: "28", rx: "2.4", strokeWidth: "2" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "28", height: "28", viewBox: "0 0 28 28", className: "Icon toolbar-caption", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("path", { fill: "#4C4C4C", d: "M4 18h20v2H4zM4 22h16v2H4z" }),
	            _react2.default.createElement("path", { fill: "#BBB", d: "M0 14h28v1H0z" }),
	            _react2.default.createElement("rect", { stroke: "#BBB", x: ".5", y: ".5", width: "27", height: "27", rx: "2.4" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "30", height: "30", viewBox: "0 0 30 30", className: "Icon toolbar-checklist-on", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { transform: "translate(1 1)", fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("rect", { stroke: "#000", width: "28", height: "28", rx: "2.4", strokeWidth: "2" }),
	            _react2.default.createElement("path", { fill: "#4C4C4C", d: "M14.04 17L22 9.144 20.84 8l-6.8 6.703-1.88-1.847L11 14z", fillRule: "nonzero" }),
	            _react2.default.createElement("path", { d: "M21 14v4.007A3.001 3.001 0 0 1 18.007 21H9.993A3.001 3.001 0 0 1 7 18.007V9.993A3.001 3.001 0 0 1 9.993 7H18v1H9.993A2.001 2.001 0 0 0 8 9.993v8.014C8 19.1 8.897 20 9.993 20h8.014A2.001 2.001 0 0 0 20 18.007V14h1z", fill: "#4C4C4C", fillRule: "nonzero" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "28", height: "28", viewBox: "0 0 28 28", className: "Icon toolbar-checklist", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("rect", { stroke: "#BBB", x: ".5", y: ".5", width: "27", height: "27", rx: "2.4" }),
	            _react2.default.createElement("path", { fill: "#4C4C4C", d: "M14.04 17L22 9.144 20.84 8l-6.8 6.703-1.88-1.847L11 14z", fillRule: "nonzero" }),
	            _react2.default.createElement("path", { d: "M21 14v4.007A3.001 3.001 0 0 1 18.007 21H9.993A3.001 3.001 0 0 1 7 18.007V9.993A3.001 3.001 0 0 1 9.993 7H18v1H9.993A2.001 2.001 0 0 0 8 9.993v8.014C8 19.1 8.897 20 9.993 20h8.014A2.001 2.001 0 0 0 20 18.007V14h1z", fill: "#4C4C4C", fillRule: "nonzero" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "30", height: "30", viewBox: "0 0 30 30", className: "Icon toolbar-h1-on", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("path", { d: "M1 3.4C1 2.073 2.08 1 3.4 1h23.2C27.927 1 29 2.08 29 3.4v23.2c0 1.326-1.08 2.4-2.4 2.4H3.4C2.073 29 1 27.92 1 26.6V3.4z", stroke: "#000", strokeWidth: "2" }),
	            _react2.default.createElement("path", { d: "M14.117 17.57c0 .755-.384.896-1.216.922v.615h4.057v-.615c-.857-.026-1.216-.167-1.216-.922v-5.93c0-.743.359-.884 1.216-.91v-.615h-4.057v.615c.832.026 1.216.167 1.216.91v2.51H9.842v-2.51c0-.743.384-.884 1.216-.91v-.615H7v.615c.858.026 1.216.167 1.216.91v5.93c0 .755-.358.896-1.216.922v.615h4.058v-.615c-.832-.026-1.216-.167-1.216-.922v-2.728h4.275v2.728zM20.76 10c-.666.884-1.216 1.217-2.458 1.396l-.41.064v.525h1.69v5.572c0 .781-.307.832-1.69.922v.628h4.89v-.628c-1.33-.077-1.612-.14-1.612-.922V10h-.41z", fill: "#4C4C4C" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "28", height: "28", viewBox: "0 0 28 28", className: "Icon toolbar-h1", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("path", { d: "M.5 2.4C.5 1.352 1.354.5 2.4.5h23.2c1.047 0 1.9.854 1.9 1.9v23.2c0 1.047-.854 1.9-1.9 1.9H2.4c-1.047 0-1.9-.854-1.9-1.9V2.4z", stroke: "#BBB" }),
	            _react2.default.createElement("path", { d: "M13.117 16.57c0 .755-.384.896-1.216.922v.615h4.057v-.615c-.857-.026-1.216-.167-1.216-.922v-5.93c0-.743.359-.884 1.216-.91v-.615h-4.057v.615c.832.026 1.216.167 1.216.91v2.51H8.842v-2.51c0-.743.384-.884 1.216-.91v-.615H6v.615c.858.026 1.216.167 1.216.91v5.93c0 .755-.358.896-1.216.922v.615h4.058v-.615c-.832-.026-1.216-.167-1.216-.922v-2.728h4.275v2.728zM19.76 9c-.666.884-1.216 1.217-2.458 1.396l-.41.064v.525h1.69v5.572c0 .781-.307.832-1.69.922v.628h4.89v-.628c-1.33-.077-1.612-.14-1.612-.922V9h-.41z", fill: "#4C4C4C" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "30", height: "24", viewBox: "0 0 30 24", className: "Icon toolbar-image-preview-on", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("path", { fill: "#D9D9D9", d: "M1 1h28v22H1z" }),
	            _react2.default.createElement("path", { fill: "#4C4C4C", d: "M10.5 10L20 23H1z" }),
	            _react2.default.createElement("path", { fill: "#4C4C4C", d: "M23 16l6 7H17z" }),
	            _react2.default.createElement("path", { d: "M22.5 10a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z", fill: "#FFF" }),
	            _react2.default.createElement("path", { stroke: "#000", d: "M1 1h28v22H1z", strokeWidth: "2" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "28", height: "22", viewBox: "0 0 28 22", className: "Icon toolbar-image-preview", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("path", { fill: "#E3E3E3", d: "M0 0h28v22H0z" }),
	            _react2.default.createElement("path", { d: "M0 0h28v22H0z" }),
	            _react2.default.createElement("path", { d: "M0 0h28v22H0z" }),
	            _react2.default.createElement("path", { fill: "#4C4C4C", d: "M9.5 9L19 22H0z" }),
	            _react2.default.createElement("path", { fill: "#4C4C4C", d: "M22 15l6 7H16z" }),
	            _react2.default.createElement("path", { d: "M21.5 9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z", fill: "#FFF" }),
	            _react2.default.createElement("path", { stroke: "#BBB", d: "M.5.5h27v21H.5z" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "30", height: "30", viewBox: "0 0 30 30", className: "Icon toolbar-italic-on", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { transform: "translate(1 1)", fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("rect", { stroke: "#000", width: "28", height: "28", rx: "2.4", strokeWidth: "2" }),
	            _react2.default.createElement("path", { d: "M13.552 11.266h1.232l-1.568 7.781H12l1.552-7.78zm1.04-1.617a.861.861 0 0 1-.552-.184c-.155-.123-.232-.302-.232-.536 0-.267.093-.489.28-.665A.916.916 0 0 1 14.736 8c.213 0 .397.064.552.192.155.128.232.31.232.544a.85.85 0 0 1-.28.657.93.93 0 0 1-.648.256z", fill: "#4C4C4C" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "28", height: "28", viewBox: "0 0 28 28", className: "Icon toolbar-italic", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("rect", { stroke: "#BBB", x: ".5", y: ".5", width: "27", height: "27", rx: "2.4" }),
	            _react2.default.createElement("path", { d: "M13.552 11.266h1.232l-1.568 7.781H12l1.552-7.78zm1.04-1.617a.861.861 0 0 1-.552-.184c-.155-.123-.232-.302-.232-.536 0-.267.093-.489.28-.665A.916.916 0 0 1 14.736 8c.213 0 .397.064.552.192.155.128.232.31.232.544a.85.85 0 0 1-.28.657.93.93 0 0 1-.648.256z", fill: "#4C4C4C" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "30", height: "30", viewBox: "0 0 30 30", className: "Icon toolbar-list-on", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { transform: "translate(1 1)", fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("path", { d: "M7.499 10.5a1.5 1.5 0 1 0-.001-2.999 1.5 1.5 0 0 0 .001 2.999zM7.499 15.5a1.5 1.5 0 1 0-.001-2.999 1.5 1.5 0 0 0 .001 2.999zM7.499 20.5a1.5 1.5 0 1 0-.001-2.999 1.5 1.5 0 0 0 .001 2.999zM12 8h10v2H12zM12 13h10v2H12zM12 18h10v2H12z", fill: "#4C4C4C" }),
	            _react2.default.createElement("rect", { stroke: "#000", width: "28", height: "28", rx: "2.4", strokeWidth: "2" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "28", height: "28", viewBox: "0 0 28 28", className: "Icon toolbar-list", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("path", { d: "M1 2.4v23.2c0 .77.63 1.4 1.4 1.4h23.2c.77 0 1.4-.63 1.4-1.4V2.4c0-.77-.63-1.4-1.4-1.4H2.4C1.63 1 1 1.63 1 2.4zm-1 0C0 1.073 1.08 0 2.4 0h23.2C26.927 0 28 1.08 28 2.4v23.2c0 1.326-1.08 2.4-2.4 2.4H2.4C1.073 28 0 26.92 0 25.6V2.4z", fill: "#BBB", fillRule: "nonzero" }),
	            _react2.default.createElement("path", { d: "M7.499 10.5a1.5 1.5 0 1 0-.001-2.999 1.5 1.5 0 0 0 .001 2.999zM7.499 15.5a1.5 1.5 0 1 0-.001-2.999 1.5 1.5 0 0 0 .001 2.999zM7.499 20.5a1.5 1.5 0 1 0-.001-2.999 1.5 1.5 0 0 0 .001 2.999zM12 8h10v2H12zM12 13h10v2H12zM12 18h10v2H12z", fill: "#4C4C4C" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "30", height: "30", viewBox: "0 0 30 30", className: "Icon toolbar-lock-on", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { transform: "translate(1 1)", fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("rect", { stroke: "#000", width: "28", height: "28", rx: "2.4", strokeWidth: "2" }),
	            _react2.default.createElement("rect", { fill: "#4C4C4C", x: "8", y: "13", width: "12", height: "8", rx: ".711" }),
	            _react2.default.createElement("path", { d: "M12 15.752c0 1.242.895 2.248 2 2.248 1.102 0 2-1.006 2-2.248v-4.504C16 10.006 15.105 9 14 9c-1.102 0-2 1.006-2 2.248v4.504zM10 11a4 4 0 0 1 8 0v4.808a4 4 0 0 1-8 0V11z", fill: "#4C4C4C", fillRule: "nonzero" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "28", height: "28", viewBox: "0 0 28 28", className: "Icon toolbar-lock", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("rect", { stroke: "#BBB", x: ".5", y: ".5", width: "27", height: "27", rx: "2.4" }),
	            _react2.default.createElement("rect", { fill: "#4C4C4C", x: "8", y: "13", width: "12", height: "8", rx: ".711" }),
	            _react2.default.createElement("path", { d: "M12 15.752c0 1.242.895 2.248 2 2.248 1.102 0 2-1.006 2-2.248v-4.504C16 10.006 15.105 9 14 9c-1.102 0-2 1.006-2 2.248v4.504zM10 11a4 4 0 0 1 8 0v4.808a4 4 0 0 1-8 0V11z", fill: "#4C4C4C", fillRule: "nonzero" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "30", height: "30", viewBox: "0 0 30 30", className: "Icon toolbar-numlist-on", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { transform: "translate(1 1)", fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("rect", { stroke: "#000", width: "28", height: "28", rx: "2.4", strokeWidth: "2" }),
	            _react2.default.createElement("path", { d: "M6.32 19.24c.09.087.19.16.298.216a.755.755 0 0 0 .355.084c.147 0 .265-.03.353-.092a.3.3 0 0 0 .131-.26.438.438 0 0 0-.035-.18.3.3 0 0 0-.125-.133.762.762 0 0 0-.244-.085 2.132 2.132 0 0 0-.4-.03v-.49c.135 0 .247-.01.337-.028a.63.63 0 0 0 .216-.082.322.322 0 0 0 .153-.29.314.314 0 0 0-.094-.242c-.063-.058-.154-.087-.273-.087a.593.593 0 0 0-.29.07 1.56 1.56 0 0 0-.27.193l-.347-.423c.138-.12.282-.212.434-.28.152-.067.32-.101.506-.101.153 0 .294.018.42.054.127.036.236.09.325.16.09.07.159.156.21.256.05.1.074.217.074.349 0 .156-.043.289-.129.397a.932.932 0 0 1-.369.266v.019a.91.91 0 0 1 .425.256.67.67 0 0 1 .167.473c0 .138-.03.26-.089.369-.06.108-.14.2-.24.273-.1.074-.218.13-.352.17-.135.038-.278.058-.428.058-.245 0-.451-.038-.62-.115A1.183 1.183 0 0 1 6 19.677l.32-.438zM6 9.438h.652V7.704H6.09v-.43c.163-.031.302-.07.415-.113.113-.044.224-.098.33-.161h.51v2.438h.562V10H6v-.562zM9.143 9.143A.484.484 0 0 1 9.5 9a.487.487 0 0 1 .5.503.48.48 0 0 1-.143.354A.484.484 0 0 1 9.5 10a.484.484 0 0 1-.357-.143A.48.48 0 0 1 9 9.503c0-.144.048-.264.143-.36zM9.143 14.143A.484.484 0 0 1 9.5 14a.487.487 0 0 1 .5.503.48.48 0 0 1-.143.354A.484.484 0 0 1 9.5 15a.484.484 0 0 1-.357-.143.48.48 0 0 1-.143-.354c0-.144.048-.264.143-.36zM9.143 19.143A.484.484 0 0 1 9.5 19a.487.487 0 0 1 .5.503.48.48 0 0 1-.143.354A.484.484 0 0 1 9.5 20a.484.484 0 0 1-.357-.143.48.48 0 0 1-.143-.354c0-.144.048-.264.143-.36zM12 8h10v2H12zM12 13h10v2H12zM12 18h10v2H12zM6.032 14.61c.189-.176.361-.34.517-.493.156-.153.29-.297.403-.432.113-.134.201-.26.264-.375a.693.693 0 0 0 .095-.332c0-.145-.037-.255-.11-.331a.408.408 0 0 0-.307-.114.478.478 0 0 0-.287.09c-.083.06-.162.131-.236.212L6 12.468c.145-.154.293-.27.445-.35A1.16 1.16 0 0 1 6.987 12c.145 0 .277.022.396.067a.908.908 0 0 1 .308.19c.087.082.153.18.2.295a1.017 1.017 0 0 1-.01.763 2.064 2.064 0 0 1-.21.384 4.092 4.092 0 0 1-.302.385c-.112.129-.23.254-.35.378.075-.01.157-.018.248-.025.091-.008.173-.012.244-.012h.593V15H6.032v-.39z", fill: "#4C4C4C" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "28", height: "28", viewBox: "0 0 28 28", className: "Icon toolbar-numlist", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("rect", { stroke: "#BBB", x: ".5", y: ".5", width: "27", height: "27", rx: "2.4" }),
	            _react2.default.createElement("path", { d: "M6.32 19.24c.09.087.19.16.298.216a.755.755 0 0 0 .355.084c.147 0 .265-.03.353-.092a.3.3 0 0 0 .131-.26.438.438 0 0 0-.035-.18.3.3 0 0 0-.125-.133.762.762 0 0 0-.244-.085 2.132 2.132 0 0 0-.4-.03v-.49c.135 0 .247-.01.337-.028a.63.63 0 0 0 .216-.082.322.322 0 0 0 .153-.29.314.314 0 0 0-.094-.242c-.063-.058-.154-.087-.273-.087a.593.593 0 0 0-.29.07 1.56 1.56 0 0 0-.27.193l-.347-.423c.138-.12.282-.212.434-.28.152-.067.32-.101.506-.101.153 0 .294.018.42.054.127.036.236.09.325.16.09.07.159.156.21.256.05.1.074.217.074.349 0 .156-.043.289-.129.397a.932.932 0 0 1-.369.266v.019a.91.91 0 0 1 .425.256.67.67 0 0 1 .167.473c0 .138-.03.26-.089.369-.06.108-.14.2-.24.273-.1.074-.218.13-.352.17-.135.038-.278.058-.428.058-.245 0-.451-.038-.62-.115A1.183 1.183 0 0 1 6 19.677l.32-.438zM6 9.438h.652V7.704H6.09v-.43c.163-.031.302-.07.415-.113.113-.044.224-.098.33-.161h.51v2.438h.562V10H6v-.562zM9.143 9.143A.484.484 0 0 1 9.5 9a.487.487 0 0 1 .5.503.48.48 0 0 1-.143.354A.484.484 0 0 1 9.5 10a.484.484 0 0 1-.357-.143A.48.48 0 0 1 9 9.503c0-.144.048-.264.143-.36zM9.143 14.143A.484.484 0 0 1 9.5 14a.487.487 0 0 1 .5.503.48.48 0 0 1-.143.354A.484.484 0 0 1 9.5 15a.484.484 0 0 1-.357-.143.48.48 0 0 1-.143-.354c0-.144.048-.264.143-.36zM9.143 19.143A.484.484 0 0 1 9.5 19a.487.487 0 0 1 .5.503.48.48 0 0 1-.143.354A.484.484 0 0 1 9.5 20a.484.484 0 0 1-.357-.143.48.48 0 0 1-.143-.354c0-.144.048-.264.143-.36zM12 8h10v2H12zM12 13h10v2H12zM12 18h10v2H12zM6.032 14.61c.189-.176.361-.34.517-.493.156-.153.29-.297.403-.432.113-.134.201-.26.264-.375a.693.693 0 0 0 .095-.332c0-.145-.037-.255-.11-.331a.408.408 0 0 0-.307-.114.478.478 0 0 0-.287.09c-.083.06-.162.131-.236.212L6 12.468c.145-.154.293-.27.445-.35A1.16 1.16 0 0 1 6.987 12c.145 0 .277.022.396.067a.908.908 0 0 1 .308.19c.087.082.153.18.2.295a1.017 1.017 0 0 1-.01.763 2.064 2.064 0 0 1-.21.384 4.092 4.092 0 0 1-.302.385c-.112.129-.23.254-.35.378.075-.01.157-.018.248-.025.091-.008.173-.012.244-.012h.593V15H6.032v-.39z", fill: "#4C4C4C" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "30", height: "30", viewBox: "0 0 30 30", className: "Icon toolbar-quote-on", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { transform: "translate(1 1)", fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("rect", { stroke: "#000", width: "28", height: "28", rx: "2.4", strokeWidth: "2" }),
	            _react2.default.createElement("path", { d: "M9.987 13.746c.087-1.412 1.008-2.161 3.082-2.42V10C9.498 10.202 8 12.161 8 14.784c0 1.787.864 2.968 2.448 2.968 1.296 0 2.16-.864 2.16-2.075 0-1.095-.547-1.758-1.498-1.93H9.987zM16.987 13.746c.087-1.412 1.008-2.161 3.082-2.42V10C16.498 10.202 15 12.161 15 14.784c0 1.787.864 2.968 2.448 2.968 1.296 0 2.16-.864 2.16-2.075 0-1.095-.547-1.758-1.498-1.93h-1.123z", fill: "#4C4C4C" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "28", height: "28", viewBox: "0 0 28 28", className: "Icon toolbar-quote", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("rect", { stroke: "#BBB", x: ".5", y: ".5", width: "27", height: "27", rx: "2.4" }),
	            _react2.default.createElement("path", { d: "M9.987 13.746c.087-1.412 1.008-2.161 3.082-2.42V10C9.498 10.202 8 12.161 8 14.784c0 1.787.864 2.968 2.448 2.968 1.296 0 2.16-.864 2.16-2.075 0-1.095-.547-1.758-1.498-1.93H9.987zM16.987 13.746c.087-1.412 1.008-2.161 3.082-2.42V10C16.498 10.202 15 12.161 15 14.784c0 1.787.864 2.968 2.448 2.968 1.296 0 2.16-.864 2.16-2.075 0-1.095-.547-1.758-1.498-1.93h-1.123z", fill: "#4C4C4C" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "30", height: "30", viewBox: "0 0 30 30", className: "Icon toolbar-transparent-on", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { transform: "translate(1 1)", fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement(
	                "g",
	                { fill: "#D9D9D9" },
	                _react2.default.createElement("path", { d: "M.875 1L4 0v4H0zM8 0h4v4H8zM16 0h4v4h-4zM24 0l2.875.937L28 4h-4zM4 4h4v4H4zM12 4h4v4h-4zM20 4h4v4h-4zM0 24h4v4L.875 26.812zM8 24h4v4H8zM16 24h4v4h-4zM24 24h4l-1.063 3.125L24 28zM0 8h4v4H0zM8 8h4v4H8zM16 8h4v4h-4zM24 8h4v4h-4zM4 12h4v4H4zM12 12h4v4h-4zM20 12h4v4h-4zM0 16h4v4H0zM8 16h4v4H8zM16 16h4v4h-4zM24 16h4v4h-4zM4 20h4v4H4zM12 20h4v4h-4zM20 20h4v4h-4z" })
	            ),
	            _react2.default.createElement("rect", { stroke: "#000", width: "28", height: "28", rx: "2.4", strokeWidth: "2" }),
	            _react2.default.createElement("path", { d: "M14 6a3.136 3.136 0 0 1 3.13 3.13c0 .239-.051.486-.13.74.217-.154.435-.274.663-.348a3.133 3.133 0 0 1 3.946 2.011 3.126 3.126 0 0 1-2.011 3.935c-.23.075-.481.105-.75.109.214.16.402.328.543.522a3.131 3.131 0 0 1-.684 4.37c-1.396 1.013-3.367.71-4.38-.685A2.452 2.452 0 0 1 14 19.11a2.452 2.452 0 0 1-.326.674c-1.014 1.395-2.985 1.698-4.38.685a3.131 3.131 0 0 1-.685-4.37c.14-.194.33-.363.543-.522a2.539 2.539 0 0 1-.75-.109 3.126 3.126 0 1 1 1.935-5.946c.228.074.446.194.663.348a2.517 2.517 0 0 1-.13-.74A3.136 3.136 0 0 1 14 6zm0 9.667c.884 0 1.6-.722 1.6-1.611 0-.89-.716-1.612-1.6-1.612-.884 0-1.6.722-1.6 1.612 0 .89.716 1.61 1.6 1.61z", fill: "#4C4C4C", fillRule: "nonzero" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "28", height: "28", viewBox: "0 0 28 28", className: "Icon toolbar-transparent", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement(
	                "g",
	                { fill: "#D9D9D9" },
	                _react2.default.createElement("path", { d: "M.875 1L4 0v4H0zM8 0h4v4H8zM16 0h4v4h-4zM24 0l2.875.937L28 4h-4zM4 4h4v4H4zM12 4h4v4h-4zM20 4h4v4h-4zM0 24h4v4L.875 26.812zM8 24h4v4H8zM16 24h4v4h-4zM24 24h4l-1.063 3.125L24 28zM0 8h4v4H0zM8 8h4v4H8zM16 8h4v4h-4zM24 8h4v4h-4zM4 12h4v4H4zM12 12h4v4h-4zM20 12h4v4h-4zM0 16h4v4H0zM8 16h4v4H8zM16 16h4v4h-4zM24 16h4v4h-4zM4 20h4v4H4zM12 20h4v4h-4zM20 20h4v4h-4z" })
	            ),
	            _react2.default.createElement("rect", { stroke: "#BBB", x: ".5", y: ".5", width: "27", height: "27", rx: "2.4" }),
	            _react2.default.createElement("path", { d: "M14 6a3.136 3.136 0 0 1 3.13 3.13c0 .239-.051.486-.13.74.217-.154.435-.274.663-.348a3.133 3.133 0 0 1 3.946 2.011 3.126 3.126 0 0 1-2.011 3.935c-.23.075-.481.105-.75.109.214.16.402.328.543.522a3.131 3.131 0 0 1-.684 4.37c-1.396 1.013-3.367.71-4.38-.685A2.452 2.452 0 0 1 14 19.11a2.452 2.452 0 0 1-.326.674c-1.014 1.395-2.985 1.698-4.38.685a3.131 3.131 0 0 1-.685-4.37c.14-.194.33-.363.543-.522a2.539 2.539 0 0 1-.75-.109 3.126 3.126 0 1 1 1.935-5.946c.228.074.446.194.663.348a2.517 2.517 0 0 1-.13-.74A3.136 3.136 0 0 1 14 6zm0 9.667c.884 0 1.6-.722 1.6-1.611 0-.89-.716-1.612-1.6-1.612-.884 0-1.6.722-1.6 1.612 0 .89.716 1.61 1.6 1.61z", fill: "#4C4C4C", fillRule: "nonzero" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "28", height: "33", viewBox: "0 0 28 33", className: "Icon toolbar-trash", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "defs",
	            null,
	            _react2.default.createElement(
	                "filter",
	                { x: "-50%", y: "-50%", width: "200%", height: "200%", filterUnits: "objectBoundingBox", id: "a-toolbar-trash" },
	                _react2.default.createElement("feGaussianBlur", { stdDeviation: "1.383", "in": "SourceGraphic" })
	            ),
	            _react2.default.createElement(
	                "linearGradient",
	                { x1: "98.055%", y1: "50%", x2: "0%", y2: "50%", id: "b-toolbar-trash" },
	                _react2.default.createElement("stop", { offset: "0%", stopColor: "#BEBEBE" }),
	                _react2.default.createElement("stop", { offset: "27.774%", stopColor: "#DADADA" }),
	                _react2.default.createElement("stop", { offset: "72.692%", stopColor: "#E2E2E2" }),
	                _react2.default.createElement("stop", { offset: "100%", stopColor: "#D7D7D7" })
	            ),
	            _react2.default.createElement("path", { d: "M14.5 9c6.579 0 11.912-1.433 11.912-3.2 0-1.767-5.333-3.2-11.912-3.2-6.579 0-11.912 1.433-11.912 3.2C2.588 7.567 7.921 9 14.5 9z", id: "c-toolbar-trash" }),
	            _react2.default.createElement(
	                "filter",
	                { x: "-50%", y: "-50%", width: "200%", height: "200%", filterUnits: "objectBoundingBox", id: "d-toolbar-trash" },
	                _react2.default.createElement("feGaussianBlur", { stdDeviation: "1", "in": "SourceAlpha", result: "shadowBlurInner1" }),
	                _react2.default.createElement("feOffset", { dy: "-2", "in": "shadowBlurInner1", result: "shadowOffsetInner1" }),
	                _react2.default.createElement("feComposite", { "in": "shadowOffsetInner1", in2: "SourceAlpha", operator: "arithmetic", k2: "-1", k3: "1", result: "shadowInnerInner1" }),
	                _react2.default.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.179093071 0", "in": "shadowInnerInner1" })
	            ),
	            _react2.default.createElement(
	                "linearGradient",
	                { x1: "98.055%", y1: "50%", x2: "0%", y2: "50%", id: "e-toolbar-trash" },
	                _react2.default.createElement("stop", { offset: "0%", stopColor: "#BEBEBE" }),
	                _react2.default.createElement("stop", { offset: "27.774%", stopColor: "#CDCDCD" }),
	                _react2.default.createElement("stop", { offset: "72.692%", stopColor: "#DDD" }),
	                _react2.default.createElement("stop", { offset: "100%", stopColor: "#C3C3C3" })
	            ),
	            _react2.default.createElement("path", { d: "M14 9c6.627 0 12-1.567 12-3.5S20.627 2 14 2 2 3.567 2 5.5 7.373 9 14 9z", id: "f-toolbar-trash" }),
	            _react2.default.createElement(
	                "filter",
	                { x: "-50%", y: "-50%", width: "200%", height: "200%", filterUnits: "objectBoundingBox", id: "g-toolbar-trash" },
	                _react2.default.createElement("feGaussianBlur", { stdDeviation: "1.5", "in": "SourceAlpha", result: "shadowBlurInner1" }),
	                _react2.default.createElement("feOffset", { dy: "-2", "in": "shadowBlurInner1", result: "shadowOffsetInner1" }),
	                _react2.default.createElement("feComposite", { "in": "shadowOffsetInner1", in2: "SourceAlpha", operator: "arithmetic", k2: "-1", k3: "1", result: "shadowInnerInner1" }),
	                _react2.default.createElement("feColorMatrix", { values: "0 0 0 0 0.568627451 0 0 0 0 0.568627451 0 0 0 0 0.568627451 0 0 0 1 0", "in": "shadowInnerInner1" })
	            )
	        ),
	        _react2.default.createElement(
	            "g",
	            { fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement("path", { d: "M1.021 5.372C.628 3.385 5.741 1 14 1c8.26 0 13.372 2.385 12.979 4.372-.017.085-2.36 23.051-2.36 23.051C24.619 30.41 19.648 32 14 32S3.381 30.41 3.381 28.423c0 0-2.343-22.966-2.36-23.051z", fill: "#F8F8F8" }),
	            _react2.default.createElement("path", { d: "M14 1.5c7.318 0 12.828 2.058 12.488 3.775-.012.064-.35 3.364-1.186 11.541l-.813 7.955-.266 2.61-.101.991C24.119 29.956 19.459 31.5 14 31.5S3.881 29.956 3.881 28.423c-.021-.23-.021-.23-.104-1.041l-.266-2.611-.81-7.925C1.864 8.64 1.525 5.34 1.512 5.275 1.172 3.558 6.683 1.5 14 1.5zM1.704 16.918l.812 7.954.266 2.611.102.99C2.88 30.808 7.99 32.5 14 32.5s11.119-1.693 11.119-4.077c.016-.13.016-.13.099-.94l.266-2.61a68575.266 68575.266 0 0 1 1.985-19.404C28.004 2.769 21.93.5 14 .5 6.072.5-.004 2.769.53 5.469c.003.01.547 5.319 1.174 11.449z", fill: "#A5A5A5", fillRule: "nonzero" }),
	            _react2.default.createElement("path", { fill: "#FFF", filter: "url(#a-toolbar-trash)", d: "M20 31l3-23h-6z", fillOpacity: ".9" }),
	            _react2.default.createElement(
	                "g",
	                null,
	                _react2.default.createElement("use", { fill: "url(#b-toolbar-trash)", xlinkHref: "#c-toolbar-trash" }),
	                _react2.default.createElement("use", { fill: "#000", filter: "url(#d-toolbar-trash)", xlinkHref: "#c-toolbar-trash" })
	            ),
	            _react2.default.createElement(
	                "g",
	                null,
	                _react2.default.createElement("use", { fill: "url(#e-toolbar-trash)", xlinkHref: "#f-toolbar-trash" }),
	                _react2.default.createElement("use", { fill: "#000", filter: "url(#g-toolbar-trash)", xlinkHref: "#f-toolbar-trash" })
	            ),
	            _react2.default.createElement("path", { d: "M14 9.5c6.925 0 12.5-1.626 12.5-4s-5.575-4-12.5-4-12.5 1.626-12.5 4 5.575 4 12.5 4zm0-1c-6.33 0-11.5-1.508-11.5-3s5.17-3 11.5-3 11.5 1.508 11.5 3-5.17 3-11.5 3z", fill: "#FFF", fillRule: "nonzero" })
	        )
	    );
	}; /*eslint-disable */

/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        "svg",
	        { width: "16", height: "18", viewBox: "0 0 16 18", className: "Icon user-guest", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement("path", { d: "M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0zm12 11.248V14.17c0-.539-.202-1.4-.8-2.267-.997-1.445-3.096-2.903-7.196-2.904C3.896 9 1.798 10.46.8 11.905c-.598.866-.8 1.727-.8 2.266v1.077A12.944 12.944 0 0 0 8 18c3.017 0 5.794-1.028 8-2.752z", fill: "#6F6F72", fillRule: "evenodd" })
	    );
	}; /*eslint-disable */

/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ResponsiveProgressiveImage = __webpack_require__(1901);
	
	var _ResponsiveProgressiveImage2 = _interopRequireDefault(_ResponsiveProgressiveImage);
	
	var _Spinner = __webpack_require__(65);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	__webpack_require__(1161);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OptimisticImage = function OptimisticImage(_ref) {
	    var imageType = _ref.imageType,
	        imageDetails = _ref.imageDetails,
	        attachmentDetails = _ref.attachmentDetails,
	        alt = _ref.alt,
	        size = _ref.size,
	        onImageLoadCb = _ref.onImageLoadCb,
	        children = _ref.children,
	        forcedHeight = _ref.forcedHeight,
	        forcedWidth = _ref.forcedWidth;
	
	    if (!imageDetails && !(attachmentDetails && attachmentDetails.get('data'))) return null;
	
	    var attachmentError = attachmentDetails && attachmentDetails.get('error');
	    var uploadedFileData = attachmentDetails && attachmentDetails.get('data');
	    var showSpinner = !!uploadedFileData && !attachmentError;
	
	    // If we don't have the uploaded file data, then we should not show the progressive image as it might
	    // not be completely downloaded.  But we do want to add it to the page so that it can be retrieved in the
	    // background
	    var showProgressiveImage = !uploadedFileData;
	
	    var progressiveImage = null;
	    // If we have image details render the progressive image to ensure its lifecycle hooks fire, even if display
	    // is 'none'
	    if (imageDetails) {
	        var style = {
	            display: showProgressiveImage ? 'block' : 'none'
	        };
	
	        progressiveImage = _react2.default.createElement(_ResponsiveProgressiveImage2.default, {
	            imageType: imageType,
	            imageDetails: imageDetails,
	            style: style,
	            alt: alt,
	            size: size,
	            onImageLoadCb: onImageLoadCb,
	            forcedHeight: forcedHeight,
	            forcedWidth: forcedWidth });
	    }
	
	    // If we have file data in the attachment then display the attachment image
	    var attachmentDataImage = uploadedFileData ? _react2.default.createElement('img', { className: 'attachment-image', src: uploadedFileData, width: forcedWidth || size, height: forcedHeight }) : null;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'OptimisticImage' },
	        _react2.default.createElement(_Spinner2.default, { show: showSpinner }),
	        attachmentDataImage,
	        progressiveImage,
	        children
	    );
	};
	
	// Styles
	
	
	// Components
	// Lib
	
	
	OptimisticImage.propTypes = {
	    imageType: _propTypes2.default.string.isRequired,
	    imageDetails: _propTypes2.default.object,
	    attachmentDetails: _propTypes2.default.object,
	    onImageLoadCb: _propTypes2.default.func,
	    alt: _propTypes2.default.string,
	    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	    size: _propTypes2.default.number.isRequired,
	    forcedWidth: _propTypes2.default.number,
	    forcedHeight: _propTypes2.default.number
	};
	
	exports.default = OptimisticImage;

/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ResponsiveImageFACC = __webpack_require__(704);
	
	var _ResponsiveImageFACC2 = _interopRequireDefault(_ResponsiveImageFACC);
	
	var _ProgressiveBackgroundImage = __webpack_require__(1902);
	
	var _ProgressiveBackgroundImage2 = _interopRequireDefault(_ProgressiveBackgroundImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	// Lib
	var ResponsiveProgressiveBackgroundImage = function ResponsiveProgressiveBackgroundImage(_ref) {
	    var imageType = _ref.imageType,
	        imageDetails = _ref.imageDetails,
	        size = _ref.size;
	
	    var aspectRatio = imageDetails.get('height') / imageDetails.get('width');
	    var thumbnail = imageDetails.get('thumb');
	
	    return _react2.default.createElement(
	        _ResponsiveImageFACC2.default,
	        { imageType: imageType, imageDetails: imageDetails, size: size },
	        function (imageSource) {
	            return _react2.default.createElement(_ProgressiveBackgroundImage2.default, { source: imageSource, aspectRatio: aspectRatio, thumbnail: thumbnail });
	        }
	    );
	};
	
	ResponsiveProgressiveBackgroundImage.propTypes = {
	    imageType: _propTypes2.default.string.isRequired,
	    imageDetails: _propTypes2.default.object.isRequired,
	    size: _propTypes2.default.number.isRequired
	};
	
	exports.default = ResponsiveProgressiveBackgroundImage;

/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ResponsiveImageFACC = __webpack_require__(704);
	
	var _ResponsiveImageFACC2 = _interopRequireDefault(_ResponsiveImageFACC);
	
	var _ProgressiveImage = __webpack_require__(1903);
	
	var _ProgressiveImage2 = _interopRequireDefault(_ProgressiveImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	// Lib
	var ResponsiveProgressiveImage = function ResponsiveProgressiveImage(_ref) {
	    var imageType = _ref.imageType,
	        imageDetails = _ref.imageDetails,
	        alt = _ref.alt,
	        size = _ref.size,
	        onImageLoadCb = _ref.onImageLoadCb,
	        style = _ref.style,
	        forcedWidth = _ref.forcedWidth,
	        forcedHeight = _ref.forcedHeight;
	
	    var aspectRatio = imageDetails.get('height') / imageDetails.get('width');
	    var thumb = imageDetails.get('thumb');
	    var transparent = imageDetails.get('transparent');
	
	    return _react2.default.createElement(
	        _ResponsiveImageFACC2.default,
	        { imageType: imageType, imageDetails: imageDetails, size: size },
	        function (imageSource) {
	            return _react2.default.createElement(_ProgressiveImage2.default, {
	                thumbnail: thumb,
	                source: imageSource,
	                style: style,
	                aspectRatio: aspectRatio,
	                onImageLoadCb: onImageLoadCb,
	                alt: alt,
	                size: size,
	                transparent: transparent,
	                forcedWidth: forcedWidth,
	                forcedHeight: forcedHeight });
	        }
	    );
	};
	
	ResponsiveProgressiveImage.propTypes = {
	    imageType: _propTypes2.default.string.isRequired,
	    imageDetails: _propTypes2.default.object.isRequired,
	    size: _propTypes2.default.number.isRequired,
	    onImageLoadCb: _propTypes2.default.func,
	    style: _propTypes2.default.object,
	    alt: _propTypes2.default.string,
	    forcedWidth: _propTypes2.default.number,
	    forcedHeight: _propTypes2.default.number
	};
	
	exports.default = ResponsiveProgressiveImage;

/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ProgressiveImageFACC = __webpack_require__(705);
	
	var _ProgressiveImageFACC2 = _interopRequireDefault(_ProgressiveImageFACC);
	
	var _BackgroundImage = __webpack_require__(436);
	
	var _BackgroundImage2 = _interopRequireDefault(_BackgroundImage);
	
	__webpack_require__(1162);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Shows an image which progressively becomes better quality by first showing a thumbnail of the image,
	 * and then, once the larger version has loaded, replaces the thumbnail with the full size image.
	 *
	 * NOTE: The component initially shows the source file because it would otherwise cause a flash of content when dragging
	 * an element that has already loaded.
	 * Now there will be a slight flash when the image has not yet loaded, but that's an acceptable trade off.
	 */
	// Lib
	var ProgressiveBackgroundImage = function ProgressiveBackgroundImage(props) {
	    var thumbnail = props.thumbnail;
	
	
	    return _react2.default.createElement(
	        _ProgressiveImageFACC2.default,
	        props,
	        function (_ref) {
	            var hideImage = _ref.hideImage,
	                visibleSource = _ref.visibleSource;
	            return _react2.default.createElement(
	                _BackgroundImage2.default,
	                { className: 'ProgressiveBackgroundImage', source: thumbnail },
	                _react2.default.createElement(_BackgroundImage2.default, { className: (0, _classnames2.default)('image', { transparent: hideImage }),
	                    source: visibleSource })
	            );
	        }
	    );
	};
	
	// Styles
	
	
	// Components
	
	
	ProgressiveBackgroundImage.propTypes = {
	    thumbnail: _propTypes2.default.string,
	    hideImage: _propTypes2.default.bool,
	    visibleSource: _propTypes2.default.string
	};
	
	exports.default = ProgressiveBackgroundImage;

/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Components
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ProgressiveImageFACC = __webpack_require__(705);
	
	var _ProgressiveImageFACC2 = _interopRequireDefault(_ProgressiveImageFACC);
	
	var _BackgroundImage = __webpack_require__(436);
	
	var _BackgroundImage2 = _interopRequireDefault(_BackgroundImage);
	
	__webpack_require__(555);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Shows an image which progressively becomes better quality by first showing a thumbnail of the image,
	 * and then, once the larger version has loaded, replaces the thumbnail with the full size image.
	 *
	 * NOTE: The component initially shows the source file because it would otherwise cause a flash of content when dragging
	 * an element that has already loaded.
	 * Now there will be a slight flash when the image has not yet loaded, but that's an acceptable trade off.
	 */
	var ProgressiveImage = function ProgressiveImage(props) {
	    var source = props.source,
	        thumbnail = props.thumbnail,
	        aspectRatio = props.aspectRatio,
	        style = props.style,
	        alt = props.alt,
	        forcedWidth = props.forcedWidth,
	        forcedHeight = props.forcedHeight,
	        transparent = props.transparent;
	
	
	    var styles = _extends({}, style, {
	        paddingBottom: Math.floor(aspectRatio * 100) + '%'
	    });
	
	    return _react2.default.createElement(
	        _ProgressiveImageFACC2.default,
	        props,
	        function (_ref) {
	            var hideImage = _ref.hideImage;
	            return _react2.default.createElement(
	                _BackgroundImage2.default,
	                { className: 'ProgressiveImage', style: styles, source: !transparent ? thumbnail : null },
	                _react2.default.createElement('img', { className: (0, _classnames2.default)('image', { transparent: hideImage }),
	                    src: source, alt: alt, width: forcedWidth, height: forcedHeight })
	            );
	        }
	    );
	};
	
	ProgressiveImage.propTypes = {
	    thumbnail: _propTypes2.default.string,
	    source: _propTypes2.default.string.isRequired,
	    aspectRatio: _propTypes2.default.number.isRequired,
	    onImageLoad: _propTypes2.default.func,
	    hasLoaded: _propTypes2.default.bool,
	    style: _propTypes2.default.object,
	    alt: _propTypes2.default.string,
	    forcedWidth: _propTypes2.default.number,
	    forcedHeight: _propTypes2.default.number,
	    transparent: _propTypes2.default.bool,
	    hideImage: _propTypes2.default.bool
	};
	
	exports.default = ProgressiveImage;

/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.markImageAsLoaded = undefined;
	
	var _progressiveImageConstants = __webpack_require__(706);
	
	/**
	 * Marks an image as loaded so that the Progressive image will not attempt to show the thumbnail.
	 *
	 * @param source {String} The source URL of the image that has been loaded.
	 */
	var markImageAsLoaded = exports.markImageAsLoaded = function markImageAsLoaded(_ref) {
	  var source = _ref.source;
	  return {
	    type: _progressiveImageConstants.IMAGE_LOADED,
	    source: source
	  };
	}; // Constants

/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _progressiveImageConstants = __webpack_require__(706);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Lib
	var initialState = Immutable.Map();
	
	// Constants
	
	
	var imageLoaded = function imageLoaded(state, action) {
	    if (!action.source) {
	        console.warn('An image without a source is being marked as loaded.');
	        return state;
	    }
	    return state.set(action.source, true);
	};
	
	/**
	 * Simple tracks a map of image sources that have been loaded.
	 * Used by the ProgressiveImages when displaying a drag preview to ensure that a flash of loading content
	 * isn't shown.
	 */
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _progressiveImageConstants.IMAGE_LOADED:
	            return imageLoaded(state, action);
	        default:
	            return state;
	    }
	};

/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(4);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reselect = __webpack_require__(7);
	
	var _getClientConfig = __webpack_require__(48);
	
	var _getClientConfig2 = _interopRequireDefault(_getClientConfig);
	
	var _PageLoader = __webpack_require__(708);
	
	var _PageLoader2 = _interopRequireDefault(_PageLoader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pageLoaderSelector = (0, _reselect.createSelector)(function () {
	    return {
	        quoteText: (0, _lodash.get)((0, _getClientConfig2.default)(), ['quote', 'text']),
	        quoteAttribution: (0, _lodash.get)((0, _getClientConfig2.default)(), ['quote', 'attribution'])
	    };
	});
	
	exports.default = (0, _reactRedux.connect)(pageLoaderSelector)(_PageLoader2.default);

/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _makeCustomProvider = __webpack_require__(764);
	
	var _makeCustomProvider2 = _interopRequireDefault(_makeCustomProvider);
	
	var _measurementsConstants = __webpack_require__(231);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Utils
	exports.default = (0, _makeCustomProvider2.default)(_measurementsConstants.MEASUREMENTS_STORE_NAME);
	
	// Constants

/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactMeasure = __webpack_require__(1540);
	
	var _reactMeasure2 = _interopRequireDefault(_reactMeasure);
	
	var _measurementsConnect = __webpack_require__(123);
	
	var _measurementsConnect2 = _interopRequireDefault(_measurementsConnect);
	
	var _measurementsRegistry = __webpack_require__(710);
	
	var _measurementsRegistry2 = _interopRequireDefault(_measurementsRegistry);
	
	var _measurementsActions = __webpack_require__(1909);
	
	var _measurements = __webpack_require__(2279);
	
	var _point = __webpack_require__(50);
	
	var _propsComparisons = __webpack_require__(147);
	
	var _elementHelper = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	// Measurements
	
	
	// Utils
	
	
	// Prop comparisons
	var hasListIndexChanged = (0, _propsComparisons.hasChanged)('listIndex');
	var hasParentLocationChanged = (0, _propsComparisons.hasChanged)('parentLocation');
	
	// Always take the centre
	var getOriginFromMeasurements = _measurements.getCentrePoint;
	
	var getOriginFromNode = function getOriginFromNode(node) {
	    return getOriginFromMeasurements(node.getBoundingClientRect());
	};
	
	/**
	 * Gets the origin in terms of an offset in px from the top left point of the connection target's measurements.
	 * This allows a different origin to be used for irregular shaped elements, while still keeping the connection boundary
	 * around the perimeter of the element.  For example, we want to connect to the centre of board icons, but want the
	 * connection boundary to include the text.
	 *
	 * @param measurements {Object} An object with top, left, width and height properties.
	 * @param node {HTMLNode} If the node exists it will be used to determine the origin, otherwise the boundary
	 *      measurements will be used.
	 */
	var getOriginOffset = function getOriginOffset(measurements, node) {
	    var originPx = node ? getOriginFromNode(node) : getOriginFromMeasurements(measurements);
	    var boundaryTopLeftPoint = (0, _measurements.getTopLeftPoint)(measurements);
	    return (0, _point.reverseTranslate)(boundaryTopLeftPoint, originPx);
	};
	
	var mapStateToProps = function mapStateToProps(state, _ref) {
	    var element = _ref.element;
	
	    var parentLocation = null;
	
	    if ((0, _elementHelper.isInList)(element)) {
	        var parent = (0, _elementHelper.getParent)(state.get('elements'), element);
	        parentLocation = parent && parent.get('location') || null;
	    }
	
	    return {
	        parentLocation: parentLocation
	    };
	};
	
	var mapMeasurementsDispatchToProps = function mapMeasurementsDispatchToProps(dispatch) {
	    return {
	        dispatchMeasurementsSet: function dispatchMeasurementsSet(_ref2) {
	            var id = _ref2.id,
	                measurements = _ref2.measurements;
	            return dispatch((0, _measurementsActions.measurementsSet)({ id: id, measurements: measurements }));
	        },
	        dispatchMeasurementsRemove: function dispatchMeasurementsRemove(_ref3) {
	            var id = _ref3.id;
	            return dispatch((0, _measurementsActions.measurementsRemove)({ id: id }));
	        }
	    };
	};
	
	exports.default = function (DecoratedComponent) {
	    var _dec, _dec2, _class;
	
	    var MeasureElementDecorator = (_dec = (0, _reactRedux.connect)(mapStateToProps), _dec2 = (0, _measurementsConnect2.default)(undefined, mapMeasurementsDispatchToProps), _dec(_class = _dec2(_class = function (_React$Component) {
	        _inherits(MeasureElementDecorator, _React$Component);
	
	        function MeasureElementDecorator(props, context) {
	            _classCallCheck(this, MeasureElementDecorator);
	
	            var _this = _possibleConstructorReturn(this, (MeasureElementDecorator.__proto__ || Object.getPrototypeOf(MeasureElementDecorator)).call(this, props, context));
	
	            _this.measureElement = function (measurements) {
	                // This is a hack to prevent full-screens from causing the canvas to keep growing.
	                // Potentially be more strict here (i.e. only for link element types with a video media type) but
	                // for now, keeping it general
	                if (measurements.width === screen.width) return;
	
	                var _this$props = _this.props,
	                    element = _this$props.element,
	                    dispatchMeasurementsSet = _this$props.dispatchMeasurementsSet;
	
	                var id = element.get('id');
	                var originOffset = getOriginOffset(measurements, _this.connectionOrigin);
	
	                // Translate measurements based on the canvas scroll
	                var canvasScroll = _measurementsRegistry2.default.getCanvasScroll();
	                measurements.top += canvasScroll.top;
	                measurements.bottom += canvasScroll.top;
	                measurements.left += canvasScroll.left;
	                measurements.right += canvasScroll.left;
	
	                _this.hasBeenMeasured = true;
	                dispatchMeasurementsSet({
	                    id: id,
	                    measurements: _extends({}, measurements, {
	                        originOffset: originOffset
	                    })
	                });
	            };
	
	            _this.connectionOriginRef = function (node) {
	                _this.connectionOrigin = node;
	            };
	
	            _this.registerConnectionOrigin = function (node) {
	                return (
	                    // Clones the element so that the consumer doesn't need to be aware that refs are being used
	                    _react2.default.cloneElement(node, {
	                        ref: _this.connectionOriginRef
	                    })
	                );
	            };
	
	            _this.hasBeenMeasured = false;
	            return _this;
	        }
	
	        _createClass(MeasureElementDecorator, [{
	            key: 'componentWillMount',
	            value: function componentWillMount() {
	                var element = this.props.element;
	
	                var id = element.get('id');
	                _measurementsRegistry2.default.registerElement(id);
	            }
	
	            /**
	             * Strangely this is needed because the 'top' / 'left' properties aren't causing the ResizeObserver to
	             * fire on these elements.  Not really sure if this is expected behaviour or not, but considering the
	             * properties can be blacklisted / whitelisted it doesn't seem like it.
	             */
	
	        }, {
	            key: 'componentDidUpdate',
	            value: function componentDidUpdate(prevProps) {
	                var element = this.props.element;
	
	                if (element.get('location') !== prevProps.element.get('location') || hasParentLocationChanged(prevProps, this.props) || hasListIndexChanged(prevProps, this.props)) {
	                    this.measureComponent.measure();
	                }
	            }
	        }, {
	            key: 'componentWillUnmount',
	            value: function componentWillUnmount() {
	                var _props = this.props,
	                    element = _props.element,
	                    dispatchMeasurementsRemove = _props.dispatchMeasurementsRemove;
	
	                var id = element.get('id');
	                _measurementsRegistry2.default.removeElement(id);
	
	                // Needed to do this because on 'undo' of a target move the element gets mounted again before dismount
	                // Thus the dismount was causing the mounted
	                if (_measurementsRegistry2.default.getElementReferenceCount(id) < 1 && this.hasBeenMeasured) {
	                    dispatchMeasurementsRemove({ id: id });
	                }
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                var _this2 = this;
	
	                var _props2 = this.props,
	                    parentLocation = _props2.parentLocation,
	                    rest = _objectWithoutProperties(_props2, ['parentLocation']); // eslint-disable-line no-unused-vars
	
	
	                var _props3 = this.props,
	                    documentMode = _props3.documentMode,
	                    readyToMeasure = _props3.readyToMeasure;
	
	
	                if (documentMode) return _react2.default.createElement(DecoratedComponent, rest);
	
	                return _react2.default.createElement(
	                    _reactMeasure2.default,
	                    { ref: function ref(c) {
	                            _this2.measureComponent = c;
	                        },
	                        whitelist: ['width', 'height', 'top', 'left'],
	                        shouldMeasure: !!readyToMeasure,
	                        onMeasure: this.measureElement },
	                    _react2.default.createElement(DecoratedComponent, _extends({}, rest, { registerConnectionOrigin: this.registerConnectionOrigin }))
	                );
	            }
	        }]);
	
	        return MeasureElementDecorator;
	    }(_react2.default.Component)) || _class) || _class);
	
	
	    MeasureElementDecorator.propTypes = {
	        element: _propTypes2.default.object.isRequired,
	        isDragging: _propTypes2.default.bool,
	        dispatchMeasurementsSet: _propTypes2.default.func,
	        dispatchMeasurementsRemove: _propTypes2.default.func,
	        documentMode: _propTypes2.default.bool,
	        parentLocation: _propTypes2.default.object,
	        readyToMeasure: _propTypes2.default.bool
	    };
	
	    return MeasureElementDecorator;
	};

/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.measurementsRemove = exports.measurementsSet = undefined;
	
	var _measurementsConstants = __webpack_require__(231);
	
	var measurementsSet = exports.measurementsSet = function measurementsSet(_ref) {
	  var id = _ref.id,
	      measurements = _ref.measurements;
	  return { type: _measurementsConstants.MEASUREMENT_SET, id: id, measurements: measurements };
	}; // Constants
	var measurementsRemove = exports.measurementsRemove = function measurementsRemove(_ref2) {
	  var id = _ref2.id;
	  return { type: _measurementsConstants.MEASUREMENT_REMOVE, id: id };
	};

/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = configureMeasurementsStore;
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _reduxThunk = __webpack_require__(662);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _redux = __webpack_require__(195);
	
	var _reduxLogger = __webpack_require__(289);
	
	var _getClientConfig = __webpack_require__(48);
	
	var _getClientConfig2 = _interopRequireDefault(_getClientConfig);
	
	var _reduxBulkingMiddleware = __webpack_require__(307);
	
	var _index = __webpack_require__(1912);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _configConstants = __webpack_require__(135);
	
	var _measurementsConstants = __webpack_require__(231);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Constants
	
	
	// Custom Middleware
	function configureMeasurementsStore() {
	    var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Immutable.Map();
	
	    var middlewareList = [];
	    var config = (0, _getClientConfig2.default)();
	
	    middlewareList.push(_reduxThunk2.default);
	    middlewareList.push((0, _reduxBulkingMiddleware.bulkingMiddleware)({ bulkActionTypes: _measurementsConstants.BULK_MEASUREMENT_ACTIONS }));
	
	    if (config.debugLevel > _configConstants.DEBUG_LEVEL.OFF) {
	        middlewareList.push((0, _reduxLogger.createLogger)({
	            collapsed: true,
	            duration: true,
	            colors: {
	                title: function title(action) {
	                    return 'palevioletred';
	                }
	            }
	        }));
	    }
	
	    var middleware = _redux.applyMiddleware.apply(null, middlewareList);
	
	    return (0, _redux.createStore)((0, _reduxBulkingMiddleware.enableReducerBatching)(_index2.default), initialState, middleware);
	}
	
	// Reducer
	
	
	// Utils
	// Lib

/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _measurementsConnect = __webpack_require__(123);
	
	var _measurementsConnect2 = _interopRequireDefault(_measurementsConnect);
	
	var _propsComparisons = __webpack_require__(147);
	
	var _measurementsRegistry = __webpack_require__(710);
	
	var _measurementsRegistry2 = _interopRequireDefault(_measurementsRegistry);
	
	var _measurementsSelector = __webpack_require__(124);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	// Utils
	
	
	// Measurements
	
	
	// Prop comparisons
	var nowHasAllMeasurements = (0, _propsComparisons.now)('hasAllMeasurements');
	
	var mapMeasurementsStateToProps = function mapMeasurementsStateToProps(state, ownProps) {
	    var canvasElementIds = ownProps.canvasElementIds;
	
	    var measurementsMap = (0, _measurementsSelector.getMeasurementsMap)(state);
	    var hasAllMeasurements = canvasElementIds.every(function (elId) {
	        return !!measurementsMap.get(elId);
	    });
	    return { hasAllMeasurements: hasAllMeasurements };
	};
	
	var CANVAS_LOADING_CLASS = 'canvas-loading';
	
	exports.default = function (DecoratedComponent) {
	    var _dec, _class;
	
	    var MeasureCanvasDecorator = (_dec = (0, _measurementsConnect2.default)(mapMeasurementsStateToProps), _dec(_class = function (_React$Component) {
	        _inherits(MeasureCanvasDecorator, _React$Component);
	
	        function MeasureCanvasDecorator(props) {
	            _classCallCheck(this, MeasureCanvasDecorator);
	
	            var _this = _possibleConstructorReturn(this, (MeasureCanvasDecorator.__proto__ || Object.getPrototypeOf(MeasureCanvasDecorator)).call(this, props));
	
	            _this.state = { readyToMeasure: false };
	            return _this;
	        }
	
	        _createClass(MeasureCanvasDecorator, [{
	            key: 'componentDidMount',
	            value: function componentDidMount() {
	                var canvasNode = _reactDom2.default.findDOMNode(this);
	                _measurementsRegistry2.default.registerCanvas(canvasNode);
	                canvasNode.classList.add(CANVAS_LOADING_CLASS);
	                this.setState({ readyToMeasure: true }); // eslint-disable-line react/no-did-mount-set-state
	            }
	        }, {
	            key: 'componentWillUpdate',
	            value: function componentWillUpdate(nextProps, nextState) {
	                if (!nextState.readyToMeasure) return;
	
	                if (nextProps.currentBoardId !== this.props.currentBoardId) {
	                    var canvasNode = _reactDom2.default.findDOMNode(this);
	                    canvasNode.classList.add(CANVAS_LOADING_CLASS);
	                }
	
	                if (nowHasAllMeasurements(this.props, nextProps)) {
	                    var _canvasNode = _reactDom2.default.findDOMNode(this);
	                    _canvasNode.classList.remove(CANVAS_LOADING_CLASS);
	                }
	            }
	        }, {
	            key: 'componentWillUnmount',
	            value: function componentWillUnmount() {
	                _measurementsRegistry2.default.removeCanvas();
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                var readyToMeasure = this.state.readyToMeasure;
	
	                var _props = this.props,
	                    hasAllMeasurements = _props.hasAllMeasurements,
	                    rest = _objectWithoutProperties(_props, ['hasAllMeasurements']); // eslint-disable-line no-unused-vars
	
	                return _react2.default.createElement(DecoratedComponent, _extends({ readyToMeasure: readyToMeasure }, rest));
	            }
	        }]);
	
	        return MeasureCanvasDecorator;
	    }(_react2.default.Component)) || _class);
	
	
	    MeasureCanvasDecorator.propTypes = {
	        hasAllMeasurements: _propTypes2.default.bool,
	        currentBoardId: _propTypes2.default.string
	    };
	
	    return MeasureCanvasDecorator;
	};

/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxImmutable = __webpack_require__(73);
	
	var _measurementsMapReducer = __webpack_require__(1913);
	
	var _measurementsMapReducer2 = _interopRequireDefault(_measurementsMapReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Lib
	exports.default = (0, _reduxImmutable.combineReducers)({
	    measurements: _measurementsMapReducer2.default
	});
	
	// Reducers

/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = measurementsMapReducer;
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _measurementsConstants = __webpack_require__(231);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Lib
	var initialState = Immutable.Map();
	
	/**
	 * Stores a map of measurements of target IDs.
	 */
	
	
	// Constants
	function measurementsMapReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _measurementsConstants.MEASUREMENT_SET:
	            return state.set(action.id, Immutable.fromJS(action.measurements));
	        case _measurementsConstants.MEASUREMENT_REMOVE:
	            return state.delete(action.id);
	        default:
	            return state;
	    }
	}

/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _recompose = __webpack_require__(9);
	
	var _reactRouterRedux = __webpack_require__(82);
	
	var _reactRedux = __webpack_require__(3);
	
	var _Button = __webpack_require__(34);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	__webpack_require__(1171);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, _ref) {
	    var backButtonRoutes = _ref.backButtonRoutes;
	    return {
	        showBackButton: backButtonRoutes && backButtonRoutes.indexOf(state.get('routing').locationBeforeTransitions.pathname) !== -1
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        goBackHistory: function goBackHistory() {
	            return dispatch((0, _reactRouterRedux.goBack)());
	        }
	    };
	};
	
	var ModalBackButton = function ModalBackButton(_ref2) {
	    var showBackButton = _ref2.showBackButton,
	        handleBackClick = _ref2.handleBackClick,
	        className = _ref2.className,
	        _ref2$title = _ref2.title,
	        title = _ref2$title === undefined ? 'Back' : _ref2$title;
	
	    if (!showBackButton) return null;
	
	    return _react2.default.createElement(
	        _Button2.default,
	        {
	            onClickFn: handleBackClick,
	            className: (0, _classnames2.default)('ModalBackButton', className) },
	        _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(_Icon2.default, { name: 'chevron-left' })
	        ),
	        ' ',
	        title
	    );
	};
	
	ModalBackButton.propTypes = {
	    showBackButton: _propTypes2.default.bool,
	    handleBackClick: _propTypes2.default.func,
	    className: _propTypes2.default.string,
	    title: _propTypes2.default.string
	};
	
	var enhance = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withHandlers)({
	    handleBackClick: function handleBackClick(_ref3) {
	        var goBackHistory = _ref3.goBackHistory;
	        return function (event) {
	            goBackHistory();
	        };
	    }
	}));
	
	exports.default = enhance(ModalBackButton);

/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(34);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	__webpack_require__(1172);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalCloseButton = function ModalCloseButton(_ref) {
	    var close = _ref.close;
	
	    if (!close) return null;
	
	    return _react2.default.createElement(
	        _Button2.default,
	        { onClickFn: close, className: 'ModalCloseButton' },
	        _react2.default.createElement(_Icon2.default, { name: 'close-x' })
	    );
	};
	
	ModalCloseButton.propTypes = {
	    close: _propTypes2.default.func
	};
	
	exports.default = ModalCloseButton;

/***/ }),
/* 1916 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _mousetrap = __webpack_require__(594);
	
	var _mousetrap2 = _interopRequireDefault(_mousetrap);
	
	var _keyConstants = __webpack_require__(146);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalKeyboardManager = function (_React$Component) {
	    _inherits(ModalKeyboardManager, _React$Component);
	
	    function ModalKeyboardManager() {
	        _classCallCheck(this, ModalKeyboardManager);
	
	        return _possibleConstructorReturn(this, (ModalKeyboardManager.__proto__ || Object.getPrototypeOf(ModalKeyboardManager)).apply(this, arguments));
	    }
	
	    _createClass(ModalKeyboardManager, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var close = this.props.close;
	
	
	            if (close) (0, _mousetrap2.default)(document.body).bind(_keyConstants.SHORTCUT_KEYS.ESCAPE, function (event) {
	                return close();
	            });
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            var close = this.props.close;
	
	
	            if (close) _mousetrap2.default.unbind(_keyConstants.SHORTCUT_KEYS.ESCAPE);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return this.props.children;
	        }
	    }]);
	
	    return ModalKeyboardManager;
	}(_react2.default.Component);
	
	ModalKeyboardManager.propTypes = {
	    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array]).isRequired,
	    close: _propTypes2.default.func
	};
	
	exports.default = ModalKeyboardManager;

/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1173);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Lib
	var PageContent = function PageContent(_ref) {
	    var children = _ref.children,
	        className = _ref.className;
	    return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('PageContent', className) },
	        children
	    );
	};
	
	// Styles
	
	
	PageContent.propTypes = {
	    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]).isRequired,
	    className: _propTypes2.default.string
	};
	
	exports.default = PageContent;

/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CSSTransitionGroup = __webpack_require__(134);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _ModalManager = __webpack_require__(713);
	
	var _ModalManager2 = _interopRequireDefault(_ModalManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RouteModalManager = function RouteModalManager(_ref) {
	    var children = _ref.children;
	    return _react2.default.createElement(
	        _CSSTransitionGroup2.default,
	        {
	            transitionName: 'fade-grow',
	            transitionAppear: true,
	            transitionEnterTimeout: 600,
	            transitionLeaveTimeout: 600,
	            transitionAppearTimeout: 600 },
	        _react2.default.createElement(
	            _ModalManager2.default,
	            { key: (0, _lodash.get)(children, ['props', 'route', 'path']) },
	            children
	        )
	    );
	};
	
	// Components
	// Lib
	
	
	RouteModalManager.propTypes = {
	    children: _propTypes2.default.node
	};
	
	exports.default = RouteModalManager;

/***/ }),
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Components
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FullScreenModal = __webpack_require__(125);
	
	var _FullScreenModal2 = _interopRequireDefault(_FullScreenModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RouteModalRoot = function RouteModalRoot(props) {
	    return _react2.default.createElement(
	        _FullScreenModal2.default,
	        _extends({ overlay: true }, props),
	        props.children
	    );
	};
	
	RouteModalRoot.propTypes = {
	    children: _propTypes2.default.node
	};
	
	exports.default = RouteModalRoot;

/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RouteModalRoot = __webpack_require__(1919);
	
	var _RouteModalRoot2 = _interopRequireDefault(_RouteModalRoot);
	
	var _AuthenticatedContainer = __webpack_require__(1670);
	
	var _AuthenticatedContainer2 = _interopRequireDefault(_AuthenticatedContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	// Lib
	var RouteModalRootAuthenticated = function RouteModalRootAuthenticated(props) {
	    return _react2.default.createElement(
	        _AuthenticatedContainer2.default,
	        null,
	        _react2.default.createElement(
	            _RouteModalRoot2.default,
	            props,
	            props.children
	        )
	    );
	};
	
	RouteModalRootAuthenticated.propTypes = {
	    children: _propTypes2.default.node
	};
	
	exports.default = RouteModalRootAuthenticated;

/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Modal = __webpack_require__(712);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _MarketingModalFooter = __webpack_require__(1922);
	
	var _MarketingModalFooter2 = _interopRequireDefault(_MarketingModalFooter);
	
	__webpack_require__(1174);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Lib
	var FullScreenModal = function FullScreenModal(props) {
	    var children = props.children,
	        className = props.className,
	        header = props.header,
	        background = props.background;
	
	
	    return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('FullScreenMarketingModal', className) },
	        _react2.default.createElement(
	            'div',
	            { className: 'modal-positioner',
	                style: { backgroundImage: 'url(' + background + ')' } },
	            header,
	            _react2.default.createElement(
	                _Modal2.default,
	                props,
	                children
	            )
	        ),
	        _react2.default.createElement(_MarketingModalFooter2.default, null)
	    );
	};
	
	// Styles
	
	
	// Components
	
	
	FullScreenModal.propTypes = {
	    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array]).isRequired,
	    header: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array]),
	    className: _propTypes2.default.string,
	    overlay: _propTypes2.default.bool,
	    close: _propTypes2.default.func,
	    backButtonRoutes: _propTypes2.default.array,
	    background: _propTypes2.default.string
	};
	
	exports.default = FullScreenModal;

/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MilanoteLogotype = __webpack_require__(703);
	
	var _MilanoteLogotype2 = _interopRequireDefault(_MilanoteLogotype);
	
	var _AnchorButton = __webpack_require__(423);
	
	var _AnchorButton2 = _interopRequireDefault(_AnchorButton);
	
	var _urlConstants = __webpack_require__(326);
	
	var _notificationConstants = __webpack_require__(88);
	
	__webpack_require__(1175);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MarketingModalFooter = function MarketingModalFooter(props) {
	    return _react2.default.createElement(
	        'footer',
	        { className: 'MarketingModalFooter' },
	        _react2.default.createElement(
	            'div',
	            { className: 'content' },
	            _react2.default.createElement(
	                'ul',
	                { className: 'links' },
	                _react2.default.createElement(
	                    'li',
	                    { className: 'group' },
	                    _react2.default.createElement(
	                        'ul',
	                        null,
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'group-header' },
	                            'Want to know more?'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { href: _urlConstants.BLOG_URL },
	                                'Milanote blog'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { href: _urlConstants.MARKETING_PLANS_URL },
	                                'Plans & pricing'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { href: _urlConstants.HELP_URL },
	                                'Help centre'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { href: _urlConstants.MARKETING_POLL_URL },
	                                'Upcoming features'
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    { className: 'group' },
	                    _react2.default.createElement(
	                        'ul',
	                        null,
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'group-header' },
	                            'Follow @milanoteapp'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'https://twitter.com/milanoteapp' },
	                                'Twitter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'https://www.facebook.com/milanoteapp' },
	                                'Facebook'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'https://www.instagram.com/milanoteapp' },
	                                'Instagram'
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    { className: 'group' },
	                    _react2.default.createElement(
	                        'a',
	                        { href: _urlConstants.MARKETING_URL + '/milanote-press-kit.zip' },
	                        'Download press kit'
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    { className: 'group' },
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'mailto:' + _notificationConstants.MILANOTE_EMAILS.INFO },
	                        _notificationConstants.MILANOTE_EMAILS.INFO
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'logo' },
	                _react2.default.createElement(
	                    _AnchorButton2.default,
	                    { className: 'home-link', href: _urlConstants.MARKETING_URL },
	                    _react2.default.createElement(_MilanoteLogotype2.default, { className: 'center' })
	                )
	            )
	        )
	    );
	};
	
	exports.default = MarketingModalFooter;

/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxImmutable = __webpack_require__(73);
	
	var _forgottenPasswordModalReducer = __webpack_require__(1681);
	
	var _forgottenPasswordModalReducer2 = _interopRequireDefault(_forgottenPasswordModalReducer);
	
	var _changePasswordModalReducer = __webpack_require__(1676);
	
	var _changePasswordModalReducer2 = _interopRequireDefault(_changePasswordModalReducer);
	
	var _paymentModalReducer = __webpack_require__(2063);
	
	var _paymentModalReducer2 = _interopRequireDefault(_paymentModalReducer);
	
	var _teamManagementModalReducer = __webpack_require__(2098);
	
	var _teamManagementModalReducer2 = _interopRequireDefault(_teamManagementModalReducer);
	
	var _errorModalReducer = __webpack_require__(1770);
	
	var _errorModalReducer2 = _interopRequireDefault(_errorModalReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Lib
	exports.default = (0, _reduxImmutable.combineReducers)({
	    errorModal: _errorModalReducer2.default,
	    forgottenPassword: _forgottenPasswordModalReducer2.default,
	    changePassword: _changePasswordModalReducer2.default,
	    payment: _paymentModalReducer2.default,
	    team: _teamManagementModalReducer2.default
	});
	
	// Reducers

/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.POPUP_ARROW_WIDTH = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(1176);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var POPUP_ARROW_WIDTH = exports.POPUP_ARROW_WIDTH = 14;
	
	var PopupArrow = function PopupArrow(_ref) {
	    var style = _ref.style;
	    return _react2.default.createElement(
	        'div',
	        { className: 'PopupArrow', style: style },
	        _react2.default.createElement('span', { className: 'arrow-outer' }),
	        _react2.default.createElement('span', { className: 'arrow-inner' })
	    );
	};
	
	PopupArrow.propTypes = {
	    style: _propTypes2.default.object
	};
	
	exports.default = PopupArrow;

/***/ }),
/* 1925 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Components
	
	
	// Actions
	
	
	// Selectors
	
	
	// Style
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reselect = __webpack_require__(7);
	
	var _AccountPopup = __webpack_require__(771);
	
	var _AccountPopup2 = _interopRequireDefault(_AccountPopup);
	
	var _NotificationPopup = __webpack_require__(781);
	
	var _NotificationPopup2 = _interopRequireDefault(_NotificationPopup);
	
	var _BoardSharingPopup = __webpack_require__(783);
	
	var _BoardSharingPopup2 = _interopRequireDefault(_BoardSharingPopup);
	
	var _BillingAlertPopup = __webpack_require__(772);
	
	var _BillingAlertPopup2 = _interopRequireDefault(_BillingAlertPopup);
	
	var _Button = __webpack_require__(34);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _popupActions = __webpack_require__(35);
	
	var _gridSizeSelector = __webpack_require__(66);
	
	__webpack_require__(1180);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SUPPORTED_POPUPS = {
	    user: _AccountPopup2.default,
	    notification: _NotificationPopup2.default,
	    sharing: _BoardSharingPopup2.default,
	    'billing-alert': _BillingAlertPopup2.default
	};
	
	var activePopupNameSelector = (0, _reselect.createSelector)(function (state) {
	    return state.getIn(['app', 'popup', 'active']);
	}, function (popupsMap) {
	    if (!popupsMap.size) return;
	    return popupsMap.keySeq().get(0);
	});
	
	var mapStateToProps = (0, _reselect.createSelector)(_gridSizeSelector.isMobileSize, activePopupNameSelector, function (isMobile, popupActive) {
	    return {
	        isMobile: isMobile,
	        popupActive: popupActive
	    };
	});
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        dispatchClosePopup: function dispatchClosePopup() {
	            return dispatch((0, _popupActions.closePopup)());
	        }
	    };
	};
	
	var PopupPanelMobileContainer = function PopupPanelMobileContainer(props) {
	    if (!props.isMobile || !props.popupActive) return null;
	
	    var PopupElement = SUPPORTED_POPUPS[props.popupActive];
	    if (!PopupElement) return null;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'PopupPanelMobileContainer' },
	        _react2.default.createElement(
	            'div',
	            { className: 'mobile-header' },
	            _react2.default.createElement(
	                _Button2.default,
	                { onClickFn: props.dispatchClosePopup },
	                _react2.default.createElement(_Icon2.default, { name: 'close-x' })
	            )
	        ),
	        _react2.default.createElement(PopupElement, _extends({}, props, { isMobileView: true }))
	    );
	};
	
	PopupPanelMobileContainer.propTypes = {
	    isMobile: _propTypes2.default.bool,
	    popupActive: _propTypes2.default.string,
	    dispatchClosePopup: _propTypes2.default.func
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PopupPanelMobileContainer);

/***/ }),
/* 1926 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(22);
	
	var _lodash = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LISTENER_CAPTURE_TRUE = {
	    capture: true
	};
	
	var LISTENER_CAPTURE_FALSE = {
	    capture: true
	};
	
	var PopupPanelMouseManager = function (_React$Component) {
	    _inherits(PopupPanelMouseManager, _React$Component);
	
	    function PopupPanelMouseManager() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, PopupPanelMouseManager);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PopupPanelMouseManager.__proto__ || Object.getPrototypeOf(PopupPanelMouseManager)).call.apply(_ref, [this].concat(args))), _this), _this.attachListener = function () {
	            var _this$props = _this.props,
	                duration = _this$props.duration,
	                stayOpen = _this$props.stayOpen;
	
	
	            if (stayOpen) return;
	
	            (0, _lodash.defer)(function () {
	                document.addEventListener('click', _this.checkTargetContained, LISTENER_CAPTURE_TRUE);
	                document.addEventListener('click', _this.closePopup, LISTENER_CAPTURE_FALSE);
	            });
	
	            if (duration) {
	                _this.delayedHide = (0, _lodash.delay)(_this.closePopup, duration);
	            }
	        }, _this.removeListener = function () {
	            var stayOpen = _this.props.stayOpen;
	
	            if (stayOpen) return;
	
	            document.removeEventListener('click', _this.checkTargetContained, LISTENER_CAPTURE_TRUE);
	            document.removeEventListener('click', _this.closePopup, LISTENER_CAPTURE_FALSE);
	
	            if (_this.delayedHide) {
	                clearTimeout(_this.delayedHide);
	                _this.delayedHide = null;
	            }
	        }, _this.checkTargetContained = function (event) {
	            var popup = (0, _reactDom.findDOMNode)(_this);
	            _this.targetContained = popup.contains(event.target);
	        }, _this.closePopup = function (event) {
	            // check if the target _was_ a child of the popup
	            if (_this.targetContained) return;
	
	            // if not, close the popup.
	            // deferred to not interfer with popup button toggle events
	            var closePopup = _this.props.closePopup;
	
	            (0, _lodash.defer)(closePopup);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(PopupPanelMouseManager, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var visible = this.props.visible;
	
	
	            if (visible) {
	                this.attachListener();
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _props = this.props,
	                visible = _props.visible,
	                onClose = _props.onClose;
	
	
	            if (!visible && nextProps.visible) {
	                this.attachListener();
	            }
	
	            if (visible && !nextProps.visible) {
	                this.removeListener();
	                onClose && onClose();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            var onClose = this.props.onClose;
	
	            this.removeListener();
	            onClose && onClose();
	        }
	
	        // check if the click target is outside the popup _before_ making any state updates,
	        // this is because there are a number of instances where the button will disapper after updating the state
	
	
	        // after updating the state,
	
	    }, {
	        key: 'render',
	        value: function render() {
	            return this.props.children;
	        }
	    }]);
	
	    return PopupPanelMouseManager;
	}(_react2.default.Component);
	
	PopupPanelMouseManager.propTypes = {
	    closePopup: _propTypes2.default.func.isRequired,
	    visible: _propTypes2.default.bool,
	    stayOpen: _propTypes2.default.bool,
	    duration: _propTypes2.default.number,
	    onClose: _propTypes2.default.func,
	    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]).isRequired
	};
	
	exports.default = PopupPanelMouseManager;

/***/ }),
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _popupConstants = __webpack_require__(140);
	
	var _draggingConstants = __webpack_require__(143);
	
	var _selectionConstants = __webpack_require__(77);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialState = Immutable.Map();
	
	var addPopup = function addPopup(state, _ref) {
	    var popupId = _ref.popupId;
	    return state.set(popupId, true);
	};
	var removePopup = function removePopup(state, _ref2) {
	    var popupId = _ref2.popupId;
	    return state.delete(popupId);
	};
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        // popup actions
	        case _popupConstants.POPUP_OPEN:
	            return addPopup(state, action);
	        case _popupConstants.POPUP_TOGGLE:
	            if (state.get(action.popupId)) return removePopup(state, action);
	            return addPopup(state, action);
	        case _popupConstants.POPUP_CLOSE:
	            if (action.closeAll) return initialState;
	            return removePopup(state, action);
	        // close popups on these Actions
	        case _selectionConstants.ELEMENTS_DESELECT_ALL:
	        case _draggingConstants.DRAG_START:
	        case '@@router/LOCATION_CHANGE':
	            return initialState;
	        default:
	            return state;
	    }
	};

/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxImmutable = __webpack_require__(73);
	
	var _popupActiveReducer = __webpack_require__(1927);
	
	var _popupActiveReducer2 = _interopRequireDefault(_popupActiveReducer);
	
	var _iconsPopupReducer = __webpack_require__(2236);
	
	var _iconsPopupReducer2 = _interopRequireDefault(_iconsPopupReducer);
	
	var _sharingPopupReducer = __webpack_require__(2196);
	
	var _sharingPopupReducer2 = _interopRequireDefault(_sharingPopupReducer);
	
	var _exportPopupReducer = __webpack_require__(2180);
	
	var _exportPopupReducer2 = _interopRequireDefault(_exportPopupReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _reduxImmutable.combineReducers)({
	    active: _popupActiveReducer2.default,
	    icons: _iconsPopupReducer2.default,
	    sharing: _sharingPopupReducer2.default,
	    exporting: _exportPopupReducer2.default
	});

/***/ }),
/* 1929 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var TOOLTIP_CODES = exports.TOOLTIP_CODES = {
	    BREADCRUMB: 1
	};

/***/ }),
/* 1930 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var markAsSeen = exports.markAsSeen = function markAsSeen(education, tooltipValue) {
	  return education | tooltipValue;
	};
	var markAsUnseen = exports.markAsUnseen = function markAsUnseen(education, tooltipValue) {
	  return ~tooltipValue & education;
	};
	var hasSeen = exports.hasSeen = function hasSeen(education, tooltipValue) {
	  return tooltipValue === (education & tooltipValue);
	};

/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	// Utils
	
	
	// Actions
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _staticResourceUtil = __webpack_require__(443);
	
	var _createMarkup = __webpack_require__(467);
	
	var _createMarkup2 = _interopRequireDefault(_createMarkup);
	
	var _staticResourceActions = __webpack_require__(1933);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    var resourceName = (0, _staticResourceUtil.getStaticHtmlResourceName)(ownProps.htmlName);
	
	    return {
	        resource: state.get('app').get('staticResources').get(resourceName)
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        fetchResource: function fetchResource(resourceName) {
	            return dispatch((0, _staticResourceActions.fetchStaticHtml)(resourceName));
	        }
	    };
	};
	
	var StaticHtml = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_React$Component) {
	    _inherits(StaticHtml, _React$Component);
	
	    function StaticHtml() {
	        _classCallCheck(this, StaticHtml);
	
	        return _possibleConstructorReturn(this, (StaticHtml.__proto__ || Object.getPrototypeOf(StaticHtml)).apply(this, arguments));
	    }
	
	    _createClass(StaticHtml, [{
	        key: 'componentWillMount',
	
	
	        /**
	         * When mounting, make sure the resource has been or will be fetched.
	         */
	        value: function componentWillMount() {
	            var _props = this.props,
	                fetchResource = _props.fetchResource,
	                htmlName = _props.htmlName;
	
	            fetchResource(htmlName);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var resource = this.props.resource;
	
	
	            var displayElement = _react2.default.createElement(
	                'div',
	                null,
	                'Loading...'
	            );
	            if (resource && resource.get('fetched')) {
	                var innerHtml = (0, _createMarkup2.default)(resource.get('data'));
	                displayElement = _react2.default.createElement('div', { dangerouslySetInnerHTML: innerHtml });
	            }
	
	            return displayElement;
	        }
	    }]);
	
	    return StaticHtml;
	}(_react2.default.Component)) || _class);
	
	
	StaticHtml.propTypes = {
	    htmlName: _propTypes2.default.string.isRequired,
	    fetchResource: _propTypes2.default.func,
	    resource: _propTypes2.default.object
	};
	
	exports.default = StaticHtml;

/***/ }),
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FullScreenModal = __webpack_require__(125);
	
	var _FullScreenModal2 = _interopRequireDefault(_FullScreenModal);
	
	var _StaticHtml = __webpack_require__(1931);
	
	var _StaticHtml2 = _interopRequireDefault(_StaticHtml);
	
	__webpack_require__(1184);
	
	__webpack_require__(1183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Styles
	
	
	// Components
	// Lib
	var StaticPage = function StaticPage(_ref) {
	    var page = _ref.routeParams.page;
	    return _react2.default.createElement(
	        _FullScreenModal2.default,
	        { className: 'StaticPage' },
	        _react2.default.createElement(_StaticHtml2.default, { htmlName: page })
	    );
	};
	
	StaticPage.propTypes = {
	    routeParams: _propTypes2.default.object.isRequired
	};
	
	exports.default = StaticPage;

/***/ }),
/* 1933 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchStaticHtml = exports.fetchResourceError = exports.fetchedResource = exports.fetchingResource = undefined;
	
	var _http = __webpack_require__(76);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _staticResourceUtil = __webpack_require__(443);
	
	var _staticResourceConstants = __webpack_require__(717);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fetchingResource = exports.fetchingResource = function fetchingResource(_ref) {
	    var resourceName = _ref.resourceName;
	    return {
	        type: _staticResourceConstants.RESOURCE_ACTION_TYPES.RESOURCE_FETCH,
	        resourceName: resourceName
	    };
	};
	
	// Constants
	// Utils
	var fetchedResource = exports.fetchedResource = function fetchedResource(_ref2) {
	    var resourceName = _ref2.resourceName,
	        data = _ref2.data;
	    return {
	        type: _staticResourceConstants.RESOURCE_ACTION_TYPES.RESOURCE_FETCH_SUCCESS,
	        resourceName: resourceName,
	        data: data
	    };
	};
	
	var fetchResourceError = exports.fetchResourceError = function fetchResourceError(_ref3) {
	    var resourceName = _ref3.resourceName,
	        error = _ref3.error;
	    return {
	        type: _staticResourceConstants.RESOURCE_ACTION_TYPES.RESOURCE_FETCH_ERROR,
	        resourceName: resourceName,
	        error: error
	    };
	};
	
	// TODO Migrate to the new resource fetching implementation
	var fetchStaticHtml = exports.fetchStaticHtml = function fetchStaticHtml(htmlDocName) {
	    return function (dispatch, getState) {
	        var resourceName = (0, _staticResourceUtil.getStaticHtmlResourceName)(htmlDocName);
	
	        var state = getState();
	        var resource = state.get('app').get('staticResources').get(resourceName);
	
	        if (resource && (resource.get('fetched') || resource.get('fetching'))) {
	            return Promise.resolve();
	        }
	
	        dispatch(fetchingResource({ resourceName: resourceName }));
	
	        return (0, _http2.default)({ prefix: 'html', url: htmlDocName + '.html', responseType: 'text', timeout: 10000 }).then(function (response) {
	            dispatch(fetchedResource({ resourceName: resourceName, data: response.data }));
	            return response;
	        }).catch(function (err) {
	            console.error('There was an error fetching the resource \'' + resourceName + '\'', err, err.response);
	            dispatch(fetchResourceError({ resourceName: resourceName, error: err.response }));
	            return Promise.reject(err.response);
	        });
	    };
	};

/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _staticResourceConstants = __webpack_require__(717);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Lib
	var initialState = Immutable.Map();
	
	// Constants
	
	
	var fetchResource = function fetchResource(state, action) {
	    var resourceState = Immutable.fromJS({
	        fetching: true,
	        fetched: false,
	        data: null
	    });
	    return state.set(action.resourceName, resourceState);
	};
	
	var resourceFetchError = function resourceFetchError(state, action) {
	    var resourceState = Immutable.fromJS({
	        fetching: false,
	        fetched: false,
	        error: action.error
	    });
	    return state.set(action.resourceName, resourceState);
	};
	
	var resourceFetchSuccess = function resourceFetchSuccess(state, action) {
	    var resourceState = Immutable.fromJS({
	        fetching: false,
	        fetched: true,
	        data: action.data,
	        error: null
	    });
	    return state.set(action.resourceName, resourceState);
	};
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _staticResourceConstants.RESOURCE_ACTION_TYPES.RESOURCE_FETCH:
	            return fetchResource(state, action);
	        case _staticResourceConstants.RESOURCE_ACTION_TYPES.RESOURCE_FETCH_ERROR:
	            return resourceFetchError(state, action);
	        case _staticResourceConstants.RESOURCE_ACTION_TYPES.RESOURCE_FETCH_SUCCESS:
	            return resourceFetchSuccess(state, action);
	        default:
	            return state;
	    }
	};

/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _debugActions = __webpack_require__(719);
	
	__webpack_require__(1189);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Actions
	// Lib
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        toggleDebugTool: function toggleDebugTool(enabled) {
	            return function () {
	                dispatch((0, _debugActions.toggleDebugTool)({ enabled: enabled, toolName: ownProps.toolName }));
	
	                ownProps.onClickFn && ownProps.onClickFn(enabled);
	            };
	        }
	    };
	};
	
	// Styles
	
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        toolEnabled: state.getIn(['debug', ownProps.toolName, 'enabled'])
	    };
	};
	
	var DebugTool = function DebugTool(props) {
	    var toolEnabled = props.toolEnabled;
	
	
	    var classes = (0, _classnames2.default)('DebugTool', {
	        active: toolEnabled
	    });
	
	    return _react2.default.createElement(
	        'div',
	        { className: classes, onClick: props.toggleDebugTool(!toolEnabled) },
	        props.children
	    );
	};
	
	DebugTool.propTypes = {
	    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	    toggleDebugTool: _propTypes2.default.func,
	    onClickFn: _propTypes2.default.func,
	    toolEnabled: _propTypes2.default.bool
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DebugTool);

/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _DocumentModeDebugTool = __webpack_require__(1944);
	
	var _DocumentModeDebugTool2 = _interopRequireDefault(_DocumentModeDebugTool);
	
	__webpack_require__(1190);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Lib
	exports.default = function (props) {
	    var perfTool = null;
	    // FIXME Required to write the function like this instead of using constants otherwise dead code removal does
	    // FIXME not work.  It might be possible to 'teach' webpack the constant though.
	    if (false) {
	        var PerformanceDebugTool = require('./performance/PerformanceDebugTool').default;
	        perfTool = _react2.default.createElement(PerformanceDebugTool, props);
	    }
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'DebugToolbar' },
	        _react2.default.createElement(
	            'div',
	            { className: 'debug-toolbar-wrapper' },
	            _react2.default.createElement(
	                'div',
	                { className: 'logo-wrapper' },
	                _react2.default.createElement(_Icon2.default, { name: 'milanote-logo-small' }),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'debug-heading' },
	                    'Milanote Debug Tools'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'tool-wrapper' },
	                _react2.default.createElement(_DocumentModeDebugTool2.default, props),
	                perfTool
	            )
	        )
	    );
	};
	
	// Styles
	
	
	// Components

/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _DebugToolbar = __webpack_require__(1936);
	
	var _DebugToolbar2 = _interopRequireDefault(_DebugToolbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Lib
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        debugEnabled: state.getIn(['debug', 'enabled'])
	    };
	};
	
	// Components
	
	
	var DebugToolbarContainer = function DebugToolbarContainer(props) {
	    var debugEnabled = props.debugEnabled;
	
	
	    if (!debugEnabled) return null;
	
	    return _react2.default.createElement(_DebugToolbar2.default, props);
	};
	
	DebugToolbarContainer.propTypes = {
	    debugEnabled: _propTypes2.default.bool
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(DebugToolbarContainer);

/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _debugActions = __webpack_require__(719);
	
	var _debugUtil = __webpack_require__(299);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	// Actions
	
	
	// Utils
	
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        enableDebugFeatures: function enableDebugFeatures() {
	            return dispatch((0, _debugActions.enableDebugTools)());
	        }
	    };
	};
	
	exports.default = function (DecoratedComponent) {
	    var _dec, _class;
	
	    var DebugManagerDecorator = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec(_class = function (_React$Component) {
	        _inherits(DebugManagerDecorator, _React$Component);
	
	        function DebugManagerDecorator() {
	            _classCallCheck(this, DebugManagerDecorator);
	
	            var _this = _possibleConstructorReturn(this, (DebugManagerDecorator.__proto__ || Object.getPrototypeOf(DebugManagerDecorator)).call(this));
	
	            window.enableDebug = _this.enableDebugFeatures.bind(_this);
	            return _this;
	        }
	
	        _createClass(DebugManagerDecorator, [{
	            key: 'componentWillMount',
	            value: function componentWillMount() {
	                if ((0, _debugUtil.shouldEnableDebugFeatures)()) {
	                    console.info('Milanote debug tools enabled');
	                    this.enableDebugFeatures();
	                }
	            }
	        }, {
	            key: 'enableDebugFeatures',
	            value: function enableDebugFeatures() {
	                this.props.enableDebugFeatures();
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                return _react2.default.createElement(DecoratedComponent, this.props);
	            }
	        }]);
	
	        return DebugManagerDecorator;
	    }(_react2.default.Component)) || _class);
	
	
	    DebugManagerDecorator.propTypes = {
	        enableDebugFeatures: _propTypes2.default.func
	    };
	
	    return DebugManagerDecorator;
	};

/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxImmutable = __webpack_require__(73);
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _debugDocumentModeReducer = __webpack_require__(1945);
	
	var _debugDocumentModeReducer2 = _interopRequireDefault(_debugDocumentModeReducer);
	
	var _debugConstants = __webpack_require__(298);
	
	var _debugDocumentModeConstants = __webpack_require__(448);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // Lib
	
	
	// Reducers
	
	
	// Constants
	
	
	var enabledReducer = function enabledReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    var action = arguments[1];
	    return action.type === _debugConstants.ENABLE_DEBUG_TOOLS ? true : state;
	};
	
	var debugReducer = (0, _reduxImmutable.combineReducers)(_defineProperty({
	    enabled: enabledReducer
	}, _debugDocumentModeConstants.DOC_MODE_DEBUG_TOOL_NAME, _debugDocumentModeReducer2.default));
	
	var initialState = Immutable.Map();
	var wrappedDebugReducer = function wrappedDebugReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    if (!state.get('enabled') && action.type !== _debugConstants.ENABLE_DEBUG_TOOLS) return state;
	    return debugReducer(state, action);
	};
	
	exports.default = wrappedDebugReducer;

/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Components
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DocumentModeCanvasColumnDebugger = __webpack_require__(1941);
	
	var _DocumentModeCanvasColumnDebugger2 = _interopRequireDefault(_DocumentModeCanvasColumnDebugger);
	
	var _DocumentModeCanvasReadingLineDebugger = __webpack_require__(447);
	
	var _DocumentModeCanvasReadingLineDebugger2 = _interopRequireDefault(_DocumentModeCanvasReadingLineDebugger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DocumentModeCanvasClusterDebugger = function DocumentModeCanvasClusterDebugger(_ref) {
	    var gridSize = _ref.gridSize,
	        clusterIndex = _ref.clusterIndex,
	        clusterData = _ref.clusterData,
	        elementOrder = _ref.elementOrder;
	
	    var columnReadingLines = clusterData.get('readingData');
	    var columnsData = clusterData.get('children');
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'DocumentModeCanvasClusterDebugger' },
	        columnsData.map(function (columnClusterData, index) {
	            return _react2.default.createElement(_DocumentModeCanvasColumnDebugger2.default, {
	                key: index,
	                gridSize: gridSize,
	                clusterIndex: clusterIndex,
	                columnIndex: index + 1,
	                columnData: columnClusterData,
	                elementOrder: elementOrder });
	        }),
	        columnReadingLines.map(function (readingLine, index) {
	            return _react2.default.createElement(_DocumentModeCanvasReadingLineDebugger2.default, _extends({
	                className: 'column',
	                key: index,
	                gridSize: gridSize,
	                order: index + 1
	            }, readingLine.toJS()));
	        })
	    );
	};
	
	DocumentModeCanvasClusterDebugger.propTypes = {
	    gridSize: _propTypes2.default.number.isRequired,
	    clusterIndex: _propTypes2.default.number.isRequired,
	    clusterData: _propTypes2.default.object.isRequired,
	    elementOrder: _propTypes2.default.object.isRequired
	};
	
	exports.default = DocumentModeCanvasClusterDebugger;

/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Components
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DocumentModeCanvasElementDebugger = __webpack_require__(1943);
	
	var _DocumentModeCanvasElementDebugger2 = _interopRequireDefault(_DocumentModeCanvasElementDebugger);
	
	var _DocumentModeCanvasReadingLineDebugger = __webpack_require__(447);
	
	var _DocumentModeCanvasReadingLineDebugger2 = _interopRequireDefault(_DocumentModeCanvasReadingLineDebugger);
	
	__webpack_require__(1191);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getColumnBorderStyle = function getColumnBorderStyle(gridSize, columnData) {
	    var bounds = columnData.getIn(['cluster', 'bounds']).toJS();
	
	    return {
	        top: bounds.top * gridSize,
	        left: bounds.left * gridSize,
	        width: (bounds.right - bounds.left) * gridSize,
	        height: (bounds.bottom - bounds.top) * gridSize
	    };
	};
	
	var DocumentModeCanvasColumnDebugger = function DocumentModeCanvasColumnDebugger(_ref) {
	    var gridSize = _ref.gridSize,
	        clusterIndex = _ref.clusterIndex,
	        columnIndex = _ref.columnIndex,
	        columnData = _ref.columnData,
	        elementOrder = _ref.elementOrder;
	
	    var columnReadingLines = columnData.get('readingData');
	    var elementsData = columnData.get('children');
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'DocumentModeCanvasColumnDebugger' },
	        _react2.default.createElement('div', { className: 'column-border', style: getColumnBorderStyle(gridSize, columnData) }),
	        elementsData.map(function (clusterData, index) {
	            return _react2.default.createElement(_DocumentModeCanvasElementDebugger2.default, {
	                key: index,
	                gridSize: gridSize,
	                clusterIndex: clusterIndex,
	                columnIndex: index + 1,
	                elementClusterData: clusterData,
	                elementOrder: elementOrder });
	        }),
	        columnReadingLines.map(function (readingLine, index) {
	            return _react2.default.createElement(_DocumentModeCanvasReadingLineDebugger2.default, _extends({
	                className: 'element',
	                key: index,
	                gridSize: gridSize,
	                order: index + 1
	            }, readingLine.toJS()));
	        })
	    );
	};
	
	DocumentModeCanvasColumnDebugger.propTypes = {
	    gridSize: _propTypes2.default.number.isRequired,
	    clusterIndex: _propTypes2.default.number.isRequired,
	    columnIndex: _propTypes2.default.number.isRequired,
	    columnData: _propTypes2.default.object.isRequired,
	    elementOrder: _propTypes2.default.object.isRequired
	};
	
	exports.default = DocumentModeCanvasColumnDebugger;

/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Components
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _DocumentModeCanvasClusterDebugger = __webpack_require__(1940);
	
	var _DocumentModeCanvasClusterDebugger2 = _interopRequireDefault(_DocumentModeCanvasClusterDebugger);
	
	var _DocumentModeCanvasReadingLineDebugger = __webpack_require__(447);
	
	var _DocumentModeCanvasReadingLineDebugger2 = _interopRequireDefault(_DocumentModeCanvasReadingLineDebugger);
	
	__webpack_require__(1192);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        documentModeDebugEnabled: state.getIn(['debug', 'enabled']) && state.getIn(['debug', 'documentMode', 'enabled']),
	        documentModeData: state.getIn(['debug', 'documentMode', 'data'])
	    };
	};
	
	var DocumentModeCanvasDebugger = function DocumentModeCanvasDebugger(props) {
	    var documentModeDebugEnabled = props.documentModeDebugEnabled,
	        documentModeData = props.documentModeData,
	        gridSize = props.gridSize;
	
	    if (!documentModeDebugEnabled) return null;
	
	    var clusterReadingLines = documentModeData.getIn(['details', 'readingData']);
	    var clustersData = documentModeData.getIn(['details', 'children']);
	    var elementOrder = documentModeData.get('order');
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'DocumentModeCanvasDebugger' },
	        clustersData.map(function (clusterData, index) {
	            return _react2.default.createElement(_DocumentModeCanvasClusterDebugger2.default, {
	                key: index, gridSize: gridSize, clusterIndex: index + 1,
	                clusterData: clusterData, elementOrder: elementOrder });
	        }),
	        clusterReadingLines.map(function (readingLine, index) {
	            return _react2.default.createElement(_DocumentModeCanvasReadingLineDebugger2.default, _extends({
	                className: 'cluster',
	                key: index,
	                gridSize: gridSize,
	                order: index + 1
	            }, readingLine.toJS()));
	        })
	    );
	};
	
	DocumentModeCanvasDebugger.propTypes = {
	    documentModeDebugEnabled: _propTypes2.default.bool,
	    documentModeData: _propTypes2.default.object,
	    gridSize: _propTypes2.default.number.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(DocumentModeCanvasDebugger);

/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(1193);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// The overlay colour will be picked depending on the index of the cluster it's within
	var CLUSTER_COLORS = ['rgba(255, 255, 0, 0.5)', // yellow
	'rgba(127, 219, 255, 0.5)', // blue
	'rgba(46, 204, 64, 0.5)', // green
	'rgba(240, 18, 190, 0.5)', // maroon
	'rgba(57, 204, 204, 0.5)', // teal
	'rgba(255, 133, 27, 0.5)', // orange
	'rgba(255, 65, 54, 0.5)', // red
	'rgba(1, 255, 112, 0.5)'];
	
	// Styles
	// Lib
	
	
	var getElementBorderStyle = function getElementBorderStyle(gridSize, elementClusterData, clusterIndex) {
	    var bounds = elementClusterData.getIn(['cluster', 'bounds']).toJS();
	    var colourIndex = (clusterIndex - 1) % CLUSTER_COLORS.length;
	
	    return {
	        top: bounds.top * gridSize,
	        left: bounds.left * gridSize,
	        width: (bounds.right - bounds.left) * gridSize,
	        height: (bounds.bottom - bounds.top) * gridSize,
	        background: CLUSTER_COLORS[colourIndex]
	    };
	};
	
	var DocumentModeCanvasElementDebugger = function DocumentModeCanvasElementDebugger(_ref) {
	    var gridSize = _ref.gridSize,
	        elementClusterData = _ref.elementClusterData,
	        clusterIndex = _ref.clusterIndex,
	        elementOrder = _ref.elementOrder;
	
	    var elementId = elementClusterData.getIn(['cluster', 'id']);
	    var order = elementOrder.indexOf(elementId) + 1;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'DocumentModeCanvasElementDebugger',
	            style: getElementBorderStyle(gridSize, elementClusterData, clusterIndex) },
	        _react2.default.createElement(
	            'span',
	            { className: 'order' },
	            order
	        ),
	        _react2.default.createElement(
	            'span',
	            { className: 'element-id' },
	            elementId.substr(-4)
	        )
	    );
	};
	
	DocumentModeCanvasElementDebugger.propTypes = {
	    gridSize: _propTypes2.default.number.isRequired,
	    clusterIndex: _propTypes2.default.number.isRequired,
	    columnIndex: _propTypes2.default.number.isRequired,
	    elementClusterData: _propTypes2.default.object.isRequired,
	    elementOrder: _propTypes2.default.object.isRequired
	};
	
	exports.default = DocumentModeCanvasElementDebugger;

/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _DebugTool = __webpack_require__(1935);
	
	var _DebugTool2 = _interopRequireDefault(_DebugTool);
	
	var _debugDocumentModeConstants = __webpack_require__(448);
	
	__webpack_require__(1195);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Constants
	// Lib
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        debugDocumentMode: function debugDocumentMode(enabled) {
	            if (!enabled) return;
	
	            // FIXME should instead use measurements (elementSizeManagerDecorator has been deleted)
	            // dispatch(calculateDocumentMode({
	            //     elementSizes: ownProps.getElementSizes(),
	            // }));
	        }
	    };
	};
	
	// Styles
	
	
	// Components
	
	
	var DocumentModeDebugTool = function DocumentModeDebugTool(_ref) {
	    var debugDocumentMode = _ref.debugDocumentMode;
	    return _react2.default.createElement(
	        'div',
	        { className: 'DocumentModeDebugTool' },
	        _react2.default.createElement(
	            _DebugTool2.default,
	            { toolName: _debugDocumentModeConstants.DOC_MODE_DEBUG_TOOL_NAME, onClickFn: debugDocumentMode },
	            'DM'
	        )
	    );
	};
	
	DocumentModeDebugTool.propTypes = {
	    docModeDebugEnabled: _propTypes2.default.bool,
	    toggleDocumentModeDebug: _propTypes2.default.func,
	    debugDocumentMode: _propTypes2.default.func
	};
	
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(DocumentModeDebugTool);

/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _debugDocumentModeConstants = __webpack_require__(448);
	
	var _debugConstants = __webpack_require__(298);
	
	var _documentModeConstants = __webpack_require__(2211);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Lib
	var initialState = Immutable.fromJS({
	    enabled: false,
	    data: {}
	});
	
	// Constants
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _debugConstants.DEBUG_TOOL_TOGGLE:
	            if (action.toolName !== _debugDocumentModeConstants.DOC_MODE_DEBUG_TOOL_NAME) return state;
	            return state.set('enabled', action.enabled);
	        case _documentModeConstants.DOCUMENT_MODE_CALCULATION:
	            return state.set('data', Immutable.fromJS(action.result));
	        default:
	            return state;
	    }
	};

/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class; // Lib
	
	
	// Util
	
	
	// Custom Decorators
	
	
	// Actions
	
	
	// Constants
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactDndHtml5Backend = __webpack_require__(220);
	
	var _lodash = __webpack_require__(4);
	
	var _recompose = __webpack_require__(9);
	
	var _elementRegistry = __webpack_require__(56);
	
	var elementRegistry = _interopRequireWildcard(_elementRegistry);
	
	var _domUtil = __webpack_require__(107);
	
	var _gridUtils = __webpack_require__(42);
	
	var _selectionUtils = __webpack_require__(458);
	
	var _elementHelper = __webpack_require__(13);
	
	var _elementSelector = __webpack_require__(41);
	
	var _elementSelector2 = _interopRequireDefault(_elementSelector);
	
	var _propsComparisons = __webpack_require__(147);
	
	var _elementResizeDecorator = __webpack_require__(2006);
	
	var _elementResizeDecorator2 = _interopRequireDefault(_elementResizeDecorator);
	
	var _measureElementDecorator = __webpack_require__(1908);
	
	var _measureElementDecorator2 = _interopRequireDefault(_measureElementDecorator);
	
	var _DraggableElement = __webpack_require__(1966);
	
	var _DraggableElement2 = _interopRequireDefault(_DraggableElement);
	
	var _selectionActions = __webpack_require__(55);
	
	var _elementActions = __webpack_require__(26);
	
	var _dragModifierKeysConstants = __webpack_require__(172);
	
	__webpack_require__(556);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isNoLongerResizing = (0, _propsComparisons.noLonger)('isResizing');
	
	var shouldAttachDragSource = function shouldAttachDragSource(_ref) {
	    var isEditable = _ref.isEditable,
	        isEditing = _ref.isEditing,
	        isEditingChild = _ref.isEditingChild,
	        documentMode = _ref.documentMode;
	    return isEditable && !isEditing && !isEditingChild && !documentMode;
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        dispatchUpdateElement: function dispatchUpdateElement(_ref2) {
	            var id = _ref2.id,
	                changes = _ref2.changes,
	                sync = _ref2.sync,
	                analyticsEvent = _ref2.analyticsEvent,
	                transactionId = _ref2.transactionId;
	            return dispatch((0, _elementActions.updateElement)({ id: id, changes: changes, sync: sync, analyticsEvent: analyticsEvent, transactionId: transactionId }));
	        },
	        dispatchSetSelectedElements: function dispatchSetSelectedElements(ids) {
	            return dispatch((0, _selectionActions.setSelectedElements)({ ids: ids }));
	        },
	        dispatchToggleSelectedElements: function dispatchToggleSelectedElements(ids) {
	            return dispatch((0, _selectionActions.toggleSelectedElements)({ ids: ids }));
	        },
	        dispatchStartEditingElement: function dispatchStartEditingElement(id, editorKey) {
	            return dispatch((0, _selectionActions.startEditingElement)({ id: id, editorKey: editorKey }));
	        },
	        stopEditing: function stopEditing() {
	            return dispatch((0, _selectionActions.finishEditingElement)());
	        }
	    };
	};
	
	var ElementContainer = (_dec = (0, _reactRedux.connect)(_elementSelector2.default, mapDispatchToProps), _dec(_class = (0, _DraggableElement2.default)(_class = (0, _measureElementDecorator2.default)(_class = (0, _elementResizeDecorator2.default)(_class = (0, _recompose.pure)(_class = function (_React$Component) {
	    _inherits(ElementContainer, _React$Component);
	
	    function ElementContainer(props) {
	        _classCallCheck(this, ElementContainer);
	
	        var _this = _possibleConstructorReturn(this, (ElementContainer.__proto__ || Object.getPrototypeOf(ElementContainer)).call(this, props));
	
	        _this.onMouseDown = function (event) {
	            var _this$props = _this.props,
	                isRemotelySelected = _this$props.isRemotelySelected,
	                isLocked = _this$props.isLocked,
	                stopEditing = _this$props.stopEditing,
	                documentMode = _this$props.documentMode,
	                isEditing = _this$props.isEditing;
	
	            if (documentMode) return;
	
	            event.stopPropagation();
	            if (isLocked) _this.selectThisElement(event);
	
	            if (!isRemotelySelected && isEditing) stopEditing();
	        };
	
	        _this.onClick = function (event) {
	            var isLocked = _this.props.isLocked;
	
	            // The locked selection is already handled by the onMouseDown
	
	            if (isLocked) return;
	
	            // Clicks will be prevented during a resize as we don't want to select the element after resizing
	            if (_this.preventClick) return;
	
	            _this.selectThisElement(event);
	        };
	
	        _this.startEditing = function (editorKey) {
	            var _this$props2 = _this.props,
	                element = _this$props2.element,
	                isEditable = _this$props2.isEditable,
	                isRemotelyActive = _this$props2.isRemotelyActive,
	                dispatchStartEditingElement = _this$props2.dispatchStartEditingElement;
	
	
	            if (!isEditable || isRemotelyActive) return;
	
	            dispatchStartEditingElement(element.get('id'), editorKey);
	        };
	
	        _this.selectThisElement = function (event) {
	            var _this$props3 = _this.props,
	                isEditable = _this$props3.isEditable,
	                isRemotelyActive = _this$props3.isRemotelyActive,
	                element = _this$props3.element,
	                dispatchSetSelectedElements = _this$props3.dispatchSetSelectedElements,
	                dispatchToggleSelectedElements = _this$props3.dispatchToggleSelectedElements;
	
	
	            if (!isEditable && !(0, _elementHelper.isBoard)(element)) {
	                return;
	            }
	            event && event.stopPropagation();
	
	            if (isRemotelyActive) return;
	
	            var selectIds = [element.get('id')];
	            if ((0, _elementHelper.isAlias)(element)) selectIds.push(element.getIn(['content', 'linkTo']));
	
	            return (0, _selectionUtils.isAttemptingMultiSelect)(event) ? dispatchToggleSelectedElements(selectIds) : dispatchSetSelectedElements(selectIds);
	        };
	
	        _this.elementEvents = {
	            onMouseDown: _this.onMouseDown,
	            onClick: _this.onClick,
	            onDoubleClick: _domUtil.stopPropagationOnly
	        };
	
	
	        _this.preventClick = false;
	        return _this;
	    }
	
	    _createClass(ElementContainer, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var connectDragPreview = this.props.connectDragPreview;
	
	            if (connectDragPreview) {
	                connectDragPreview((0, _reactDndHtml5Backend.getEmptyImage)());
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.props.isSelected) {
	                var domNode = _reactDom2.default.findDOMNode(this);
	                if (!(0, _domUtil.isDOMNodeInView)(domNode)) domNode.scrollIntoView();
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _this2 = this;
	
	            // If the element is selected and the modified time is within 300ms then scroll it into view.
	            if (!this.props.isSelected && nextProps.isSelected && this.props.element.getIn(['meta', 'modifiedTime']) > new Date().getTime() - 300) {
	                var domNode = _reactDom2.default.findDOMNode(this);
	                if (!(0, _domUtil.isDOMNodeInView)(domNode)) domNode.scrollIntoView();
	            }
	
	            // Prevent a click which occurs immediately after a resize from selecting the element
	            if (isNoLongerResizing(this.props, nextProps)) {
	                this.preventClick = true;
	                (0, _lodash.defer)(function () {
	                    _this2.preventClick = false;
	                });
	            }
	        }
	
	        /**
	         * If the element receives the mouse down event (because an input hasn't stopped propagation of the mouse down
	         * event).
	         */
	
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                element = _props.element,
	                isDragging = _props.isDragging,
	                connectDragSource = _props.connectDragSource,
	                dragModifierKeys = _props.dragModifierKeys,
	                isResizing = _props.isResizing;
	
	
	            var DisplayElement = elementRegistry.getElementContainerComponent(element.get('elementType'));
	            if (!DisplayElement) return null;
	
	            var normalisedFontStyle = (0, _gridUtils.getNormalisedFontStyle)(this.props);
	
	            var copyDrag = dragModifierKeys.get(_dragModifierKeysConstants.MODIFIER_KEYS.altKey);
	            var dropEffect = copyDrag ? 'copy' : 'move';
	
	            var elementClasses = (0, _classnames2.default)('Element', {
	                dragging: isDragging && !copyDrag,
	                copy: isDragging && copyDrag,
	                resizing: isResizing
	            });
	
	            var elementRender = _react2.default.createElement(
	                'div',
	                { className: elementClasses,
	                    'data-element-id': element.get('id'),
	                    style: normalisedFontStyle },
	                _react2.default.createElement(DisplayElement, _extends({
	                    startEditing: this.startEditing,
	                    elementEvents: this.elementEvents
	                }, this.props))
	            );
	
	            var wrappingFn = shouldAttachDragSource(this.props) ? connectDragSource : _lodash.identity;
	            return wrappingFn(elementRender, { dropEffect: dropEffect });
	        }
	    }]);
	
	    return ElementContainer;
	}(_react2.default.Component)) || _class) || _class) || _class) || _class) || _class);
	exports.default = ElementContainer;
	
	
	ElementContainer.propTypes = {
	    element: _propTypes2.default.object.isRequired,
	    currentBoardId: _propTypes2.default.string.isRequired,
	    isRemotelyActive: _propTypes2.default.bool,
	    isEditing: _propTypes2.default.bool,
	    isEditingChild: _propTypes2.default.bool,
	    isEditable: _propTypes2.default.bool,
	    isDraggable: _propTypes2.default.bool,
	    isSelected: _propTypes2.default.bool,
	    isLocked: _propTypes2.default.bool,
	    isOver: _propTypes2.default.bool,
	    inList: _propTypes2.default.string,
	    isDragging: _propTypes2.default.bool,
	    isResizing: _propTypes2.default.bool,
	    isHovered: _propTypes2.default.bool,
	    canDrop: _propTypes2.default.bool,
	    isRemotelySelected: _propTypes2.default.bool,
	    remoteSelectionData: _propTypes2.default.object,
	    connectDropTarget: _propTypes2.default.func,
	    connectDragSource: _propTypes2.default.func,
	    connectDragPreview: _propTypes2.default.func,
	    dispatchSetSelectedElements: _propTypes2.default.func,
	    dispatchToggleSelectedElements: _propTypes2.default.func,
	    dispatchStartEditingElement: _propTypes2.default.func,
	    dispatchUpdateElement: _propTypes2.default.func,
	    stopEditing: _propTypes2.default.func,
	    documentMode: _propTypes2.default.bool,
	    dragModifierKeys: _propTypes2.default.object,
	    dispatchGetSelectedElementIds: _propTypes2.default.func
	};

/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reselect = __webpack_require__(7);
	
	var _elementPositionSelector = __webpack_require__(730);
	
	var _cssUtil = __webpack_require__(312);
	
	__webpack_require__(1196);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps() {
	    return (0, _reselect.createSelector)((0, _elementPositionSelector.makeGetElementPixelPosition)(), function (elementPosition) {
	        return { elementPosition: elementPosition };
	    });
	};
	
	// Styles
	
	
	// Selectors
	// Lib
	
	
	var ElementPositioner = function ElementPositioner(_ref) {
	    var children = _ref.children,
	        elementPosition = _ref.elementPosition;
	    return _react2.default.createElement(
	        'div',
	        { className: 'ElementPositioner', style: (0, _cssUtil.getTranslationStyles)(elementPosition) },
	        children
	    );
	};
	
	ElementPositioner.propTypes = {
	    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	    elementId: _propTypes2.default.string.isRequired,
	    elementPosition: _propTypes2.default.object
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ElementPositioner);

/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Utils
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _elementRegistry = __webpack_require__(56);
	
	var elementRegistry = _interopRequireWildcard(_elementRegistry);
	
	var _gridUtils = __webpack_require__(42);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ElementPresentational = function ElementPresentational(props) {
	    var element = props.element,
	        isDragging = props.isDragging,
	        dragOrigin = props.dragOrigin;
	
	    var DisplayElement = elementRegistry.getElementPresentationalComponent(element.get('elementType'));
	
	    if (!DisplayElement) return null;
	
	    var styles = _extends({}, (0, _gridUtils.getNormalisedFontStyle)(props));
	
	    if (dragOrigin) {
	        styles.transformOrigin = dragOrigin.x + 'px ' + dragOrigin.y + 'px';
	    }
	
	    return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('Element', { isDragging: isDragging }), style: styles },
	        _react2.default.createElement(DisplayElement, props)
	    );
	};
	
	ElementPresentational.propTypes = {
	    element: _propTypes2.default.object.isRequired,
	    isDragging: _propTypes2.default.bool,
	    gridSize: _propTypes2.default.number.isRequired,
	    documentMode: _propTypes2.default.bool,
	    dragOrigin: _propTypes2.default.object
	};
	
	exports.default = ElementPresentational;

/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	// Selectors
	
	
	// Utils
	
	
	// Components
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reselect = __webpack_require__(7);
	
	var _recompose = __webpack_require__(9);
	
	var _lodash = __webpack_require__(4);
	
	var _permissionsService = __webpack_require__(75);
	
	var _boardSelector = __webpack_require__(83);
	
	var _permissionUtil = __webpack_require__(89);
	
	var _resourceUtil = __webpack_require__(108);
	
	var _Board = __webpack_require__(450);
	
	var _Board2 = _interopRequireDefault(_Board);
	
	var _BoardContainer = __webpack_require__(720);
	
	var _BoardContainer2 = _interopRequireDefault(_BoardContainer);
	
	var _AliasLoading = __webpack_require__(1950);
	
	var _AliasLoading2 = _interopRequireDefault(_AliasLoading);
	
	var _elementLineEdgeDropTarget = __webpack_require__(200);
	
	var _elementLineEdgeDropTarget2 = _interopRequireDefault(_elementLineEdgeDropTarget);
	
	__webpack_require__(1197);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var aliasSelector = (0, _reselect.createSelector)(function (state, ownProps) {
	    return state.get('elements');
	}, function (state, props) {
	    return props.element.getIn(['content', 'linkTo']);
	}, _permissionsService.aliasUserPermissionsSelector, _boardSelector.boardResourcesSelector, function (elements, linkedElementId, boardPermissions, boardResourcesState) {
	    var linkedBoard = elements.get(linkedElementId);
	    var linkedBoardResourceState = boardResourcesState.get(linkedElementId);
	
	    var isLocked = linkedBoard && (0, _resourceUtil.isFetched)(linkedBoardResourceState) && !(0, _permissionUtil.canRead)(boardPermissions);
	
	    return { isLocked: isLocked, linkedElementId: linkedElementId, linkedBoard: linkedBoard };
	});
	
	var Alias = function Alias(props) {
	    var linkedBoard = props.linkedBoard,
	        isPresentational = props.isPresentational,
	        element = props.element;
	
	
	    if (!linkedBoard || !linkedBoard.get('content') || linkedBoard.get('error')) {
	        return _react2.default.createElement(_AliasLoading2.default, props);
	    }
	
	    var isLinkAlias = element.getIn(['content', 'linkAlias']);
	
	    return isPresentational ? _react2.default.createElement(_Board2.default, _extends({}, props, { aliasId: element.get('id'), isAlias: true, isLinkAlias: isLinkAlias, element: linkedBoard })) : _react2.default.createElement(_BoardContainer2.default, _extends({}, props, { aliasId: element.get('id'), isAlias: true, isLinkAlias: isLinkAlias,
	        element: linkedBoard }));
	};
	
	Alias.propTypes = {
	    linkedElementId: _propTypes2.default.string,
	    isPresentational: _propTypes2.default.bool,
	    linkedBoard: _propTypes2.default.object,
	    element: _propTypes2.default.object
	};
	
	var enhance = (0, _recompose.compose)((0, _reactRedux.connect)(aliasSelector), (0, _recompose.branch)(function (props) {
	    return props.isPresentational;
	}, _lodash.identity, _elementLineEdgeDropTarget2.default));
	
	exports.default = enhance(Alias);

/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementUtil = __webpack_require__(105);
	
	var _BoardIcon = __webpack_require__(451);
	
	var _BoardIcon2 = _interopRequireDefault(_BoardIcon);
	
	var _EditableTitle = __webpack_require__(228);
	
	var _EditableTitle2 = _interopRequireDefault(_EditableTitle);
	
	var _gridUtils = __webpack_require__(42);
	
	var _boardConstants = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Utils
	
	
	// Components
	// Lib
	var iconData = Immutable.Map({ fetching: true });
	
	var AliasLoading = function AliasLoading(props) {
	    return _react2.default.createElement(
	        'div',
	        { id: (0, _elementUtil.getDomElementId)(props.element.get('id')), className: (0, _elementUtil.elementClassNames)('Board', props),
	            style: (0, _gridUtils.getElementStyle)(_boardConstants.DEFAULT_BOARD_WIDTH, props.gridSize, props.inList) },
	        _react2.default.createElement(
	            'div',
	            { className: 'board-content' },
	            _react2.default.createElement(_BoardIcon2.default, { size: 8, icon: iconData }),
	            _react2.default.createElement(_EditableTitle2.default, null)
	        )
	    );
	};
	
	AliasLoading.propTypes = {
	    element: _propTypes2.default.object.isRequired,
	    gridSize: _propTypes2.default.number.isRequired,
	    inList: _propTypes2.default.string,
	    isSelected: _propTypes2.default.bool,
	    isEditing: _propTypes2.default.bool,
	    isHovered: _propTypes2.default.bool,
	    isDragging: _propTypes2.default.bool,
	    className: _propTypes2.default.string
	};
	
	exports.default = AliasLoading;

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _index = __webpack_require__(2252);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _Alias = __webpack_require__(1949);
	
	var _Alias2 = _interopRequireDefault(_Alias);
	
	var _toolbarConstants = __webpack_require__(129);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return (0, _index2.default)({
	        containerComponent: _Alias2.default,
	        presentationalComponent: _Alias2.default,
	        tools: [_toolbarConstants.TOOLS.COLOR, _toolbarConstants.TOOLS.ICON],
	        showTool: false
	    });
	};

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.markBoardResourcesAsStale = undefined;
	
	var _resourceActions = __webpack_require__(765);
	
	var _resourceConstants = __webpack_require__(85);
	
	// Action Creators
	var markBoardResourcesAsStale = exports.markBoardResourcesAsStale = (0, _resourceActions.makeResourceStaleActionCreator)(_resourceConstants.RESOURCE_TYPES.boards);
	
	// Constants

/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(9);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	__webpack_require__(1201);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BoardLock = function BoardLock(_ref) {
	    var isLocked = _ref.isLocked;
	
	    if (!isLocked) return null;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'BoardLock' },
	        _react2.default.createElement(_Icon2.default, { name: 'board-lock' })
	    );
	};
	
	BoardLock.propTypes = {
	    isLocked: _propTypes2.default.bool
	};
	
	exports.default = (0, _recompose.pure)(BoardLock);

/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(9);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	__webpack_require__(1202);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStatusIcon = function getStatusIcon(_ref) {
	    var isShared = _ref.isShared,
	        isLinkAlias = _ref.isLinkAlias;
	    // eslint-disable-line react/prop-types
	    if (isLinkAlias) {
	        return _react2.default.createElement(_Icon2.default, { name: 'board-link' });
	    } else if (isShared) {
	        return _react2.default.createElement(_Icon2.default, { name: 'board-shared-users' });
	    }
	}; // Lib
	
	
	var BoardStatus = function BoardStatus(props) {
	    var statusIcon = getStatusIcon(props);
	    if (!statusIcon) return null;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'BoardStatus' },
	        _react2.default.createElement('div', { className: 'board-status-bg' }),
	        statusIcon
	    );
	};
	
	BoardStatus.propTypes = {
	    isShared: _propTypes2.default.bool,
	    isLinkAlias: _propTypes2.default.bool
	};
	
	exports.default = (0, _recompose.pure)(BoardStatus);

/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defaultResourceReducer = __webpack_require__(470);
	
	var _defaultResourceReducer2 = _interopRequireDefault(_defaultResourceReducer);
	
	var _elementHelper = __webpack_require__(13);
	
	var _elementConstants = __webpack_require__(12);
	
	var _socketConstants = __webpack_require__(109);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Constants
	// Reducers
	var elementCreateUpdate = function elementCreateUpdate(state, action) {
	    return state.set('fetched', true).set('fetching', false);
	};
	
	// Utils
	
	exports.default = function (state, action) {
	    var updatedState = (0, _defaultResourceReducer2.default)(state, action);
	
	    switch (action.type) {
	        case _elementConstants.ELEMENT_CREATE:
	            return (0, _elementHelper.isBoard)(action.elementType) ? elementCreateUpdate(updatedState, action) : updatedState;
	        case _socketConstants.SOCKET_DISCONNECT:
	            return updatedState.set('fetched', false);
	        default:
	            return updatedState;
	    }
	};

/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _makeResourceTypeReducer = __webpack_require__(471);
	
	var _makeResourceTypeReducer2 = _interopRequireDefault(_makeResourceTypeReducer);
	
	var _elementHelper = __webpack_require__(13);
	
	var _resourceConstants = __webpack_require__(85);
	
	var _elementConstants = __webpack_require__(12);
	
	var _socketConstants = __webpack_require__(109);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Utils
	var boardsPredicateFn = function boardsPredicateFn(action) {
	    return action.resource === _resourceConstants.RESOURCE_TYPES.boards || action.type === _elementConstants.ELEMENT_CREATE && (0, _elementHelper.isBoard)(action.elementType) || action.type === _socketConstants.SOCKET_DISCONNECT;
	};
	
	// Constants
	// Reducers
	exports.default = (0, _makeResourceTypeReducer2.default)(_resourceConstants.RESOURCE_TYPES.boards, boardsPredicateFn);

/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _index = __webpack_require__(2253);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _Board = __webpack_require__(450);
	
	var _Board2 = _interopRequireDefault(_Board);
	
	var _BoardContainer = __webpack_require__(720);
	
	var _BoardContainer2 = _interopRequireDefault(_BoardContainer);
	
	var _browser = __webpack_require__(61);
	
	var _toolbarConstants = __webpack_require__(129);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return (0, _index2.default)({
	        containerComponent: _BoardContainer2.default,
	        presentationalComponent: _Board2.default,
	        tools: [_toolbarConstants.TOOLS.COLOR, _toolbarConstants.TOOLS.ICON],
	        tooltip: _browser.isApple ? '⌃⌘B' : 'Ctrl+Alt+B'
	    });
	};

/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _lodash = __webpack_require__(4);
	
	var _timeUtil = __webpack_require__(43);
	
	var _elementConstants = __webpack_require__(12);
	
	var TYPES = _interopRequireWildcard(_elementConstants);
	
	var _elementsConstants = __webpack_require__(322);
	
	var ELEMENTS_ACTION_TYPES = _interopRequireWildcard(_elementsConstants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Constants
	var updateDeepChildrenMod = function updateDeepChildrenMod(state, ids) {
	    var timestamp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, _timeUtil.getTimestamp)();
	    return state.withMutations(function (mutableState) {
	        ids.forEach(function (id) {
	            return mutableState.set(id, timestamp);
	        });
	    });
	};
	
	// Utils
	/**
	 * deepChildrenModCache
	 * ====================
	 * This is intended to be used for performance gains to prevent unnecessary recalculations of the 'deep' children
	 * for an element.
	 * The getChildrenDeep operation is relatively expensive and would usually be executed on any element change (even
	 * if the element was entirely unrelated).
	 *
	 * This cache stores a timestamp of the last time that the children of a board were changed (this is performed in
	 * the elements reducer).
	 * The getChildrenDeepSelector will then use this cache to determine whether its state needs to be updated, or whether
	 * the previous result can be used instead.
	 */
	
	// Lib
	
	
	var handleElementLoad = function handleElementLoad(state, action) {
	    var ids = (0, _lodash.reduce)(action.elements, function (idArray, el) {
	        var parentId = el.location.parentId;
	        parentId && idArray.push(parentId);
	        return idArray;
	    }, []);
	    return updateDeepChildrenMod(state, ids);
	};
	
	var handleElementCreateOrDelete = function handleElementCreateOrDelete(state, action) {
	    var ids = [action.location.parentId];
	    return updateDeepChildrenMod(state, ids);
	};
	
	var isMoveRelevant = function isMoveRelevant(_ref) {
	    var from = _ref.from,
	        location = _ref.location;
	    return from.parentId !== location.parentId;
	};
	var getMoveIds = function getMoveIds(_ref2) {
	    var from = _ref2.from,
	        location = _ref2.location;
	    return [location.parentId, from.parentId];
	};
	
	var handleElementMoveMulti = function handleElementMoveMulti(state, action) {
	    var ids = (0, _lodash.uniq)((0, _lodash.flatMap)(action.moves.filter(isMoveRelevant).map(getMoveIds)));
	    if (ids.length === 0) return state;
	
	    return updateDeepChildrenMod(state, ids);
	};
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Immutable.Map();
	    var action = arguments[1];
	
	    switch (action.type) {
	        case ELEMENTS_ACTION_TYPES.ELEMENTS_LOAD:
	            return handleElementLoad(state, action);
	        case TYPES.ELEMENT_CREATE:
	        case TYPES.ELEMENT_DELETE:
	            return handleElementCreateOrDelete(state, action);
	        case TYPES.ELEMENT_MOVE_MULTI:
	            return handleElementMoveMulti(state, action);
	        default:
	            return state;
	    }
	};

/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxImmutable = __webpack_require__(73);
	
	var _deepChildrenModCacheReducer = __webpack_require__(1958);
	
	var _deepChildrenModCacheReducer2 = _interopRequireDefault(_deepChildrenModCacheReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Lib
	exports.default = (0, _reduxImmutable.combineReducers)({
	    deepChildrenMod: _deepChildrenModCacheReducer2.default
	});

/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class; // Lib
	
	
	// Utils
	
	
	// Actions
	
	
	// Constants
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(4);
	
	var _dontUpdateForKeys = __webpack_require__(206);
	
	var _dontUpdateForKeys2 = _interopRequireDefault(_dontUpdateForKeys);
	
	var _gridSizeSelector = __webpack_require__(66);
	
	var _elementCaptionUtil = __webpack_require__(137);
	
	var _ColumnOnDropDropTarget = __webpack_require__(452);
	
	var _ColumnOnDropDropTarget2 = _interopRequireDefault(_ColumnOnDropDropTarget);
	
	var _columnOnDropConnectDropTarget = __webpack_require__(453);
	
	var _columnOnDropConnectDropTarget2 = _interopRequireDefault(_columnOnDropConnectDropTarget);
	
	var _elementLineEdgeDropTarget = __webpack_require__(200);
	
	var _elementLineEdgeDropTarget2 = _interopRequireDefault(_elementLineEdgeDropTarget);
	
	var _captionContainerDecorator = __webpack_require__(425);
	
	var _captionContainerDecorator2 = _interopRequireDefault(_captionContainerDecorator);
	
	var _elementActions = __webpack_require__(26);
	
	var _elementShortcutActions = __webpack_require__(455);
	
	var _analytics = __webpack_require__(47);
	
	var _cardConstants = __webpack_require__(111);
	
	var _boardConstants = __webpack_require__(17);
	
	var _Card = __webpack_require__(722);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        dispatchSaveTextContent: function dispatchSaveTextContent(id, textContent) {
	            return dispatch((0, _elementActions.updateElement)({ id: id, changes: { textContent: textContent } }));
	        },
	        createCard: function createCard(_ref) {
	            var location = _ref.location,
	                currentBoardId = _ref.currentBoardId,
	                element = _ref.element;
	
	            (0, _analytics.analyticsEvent)('created-card-cmd-return');
	
	            return dispatch((0, _elementActions.createAndSelectElement)({
	                elementType: _cardConstants.CARD_TYPE,
	                location: location,
	                currentBoardId: currentBoardId,
	                content: {
	                    caption: (0, _elementCaptionUtil.getCaption)(element),
	                    showCaption: (0, _elementCaptionUtil.getShowCaption)(element)
	                }
	            }));
	        },
	        dispatchMoveElementToTrash: function dispatchMoveElementToTrash(_ref2) {
	            var isEditable = _ref2.isEditable,
	                currentBoardId = _ref2.currentBoardId;
	            return dispatch((0, _elementShortcutActions.moveElementToTrash)({ isEditable: isEditable, currentBoardId: currentBoardId }));
	        }
	    };
	};
	
	var CardContainer = (_dec = (0, _reactRedux.connect)(_gridSizeSelector.gridSizeSelector, mapDispatchToProps), _dec2 = (0, _dontUpdateForKeys2.default)(['dragModifierKeys', 'canDrop', 'readyToMeasure']), _dec(_class = (0, _ColumnOnDropDropTarget2.default)(_class = (0, _elementLineEdgeDropTarget2.default)(_class = _dec2(_class = (0, _captionContainerDecorator2.default)(_class = function (_React$Component) {
	    _inherits(CardContainer, _React$Component);
	
	    function CardContainer(props) {
	        _classCallCheck(this, CardContainer);
	
	        var _this = _possibleConstructorReturn(this, (CardContainer.__proto__ || Object.getPrototypeOf(CardContainer)).call(this, props));
	
	        _this.createNewCard = _this.createNewCard.bind(_this);
	        _this.createNewCardInList = _this.createNewCardInList.bind(_this);
	        _this.saveContent = _this.saveContent.bind(_this);
	        _this.moveElementToTrash = _this.moveElementToTrash.bind(_this);
	        return _this;
	    }
	
	    _createClass(CardContainer, [{
	        key: 'createNewCardInList',
	        value: function createNewCardInList() {
	            var _props = this.props,
	                createCard = _props.createCard,
	                element = _props.element,
	                listIndex = _props.listIndex,
	                currentBoardId = _props.currentBoardId;
	
	
	            var location = {
	                parentId: element.getIn(['location', 'parentId']),
	                section: _boardConstants.BOARD_SECTIONS.INBOX,
	                position: {
	                    index: listIndex + 1
	                }
	            };
	
	            createCard({ location: location, currentBoardId: currentBoardId, element: element });
	        }
	    }, {
	        key: 'createNewCardOnCanvas',
	        value: function createNewCardOnCanvas() {
	            var _props2 = this.props,
	                createCard = _props2.createCard,
	                element = _props2.element,
	                gridSize = _props2.gridSize,
	                currentBoardId = _props2.currentBoardId;
	
	
	            var thisNode = _reactDom2.default.findDOMNode(this);
	            var thisHeight = Math.round(thisNode.offsetHeight / gridSize);
	
	            var location = {
	                parentId: element.getIn(['location', 'parentId']),
	                section: _boardConstants.BOARD_SECTIONS.CANVAS,
	                position: {
	                    x: element.getIn(['location', 'position', 'x']),
	                    y: element.getIn(['location', 'position', 'y']) + thisHeight + 1
	                }
	            };
	
	            createCard({ location: location, currentBoardId: currentBoardId, element: element });
	        }
	    }, {
	        key: 'createNewCard',
	        value: function createNewCard() {
	            var inList = this.props.inList;
	
	
	            if (inList) {
	                this.createNewCardInList();
	            } else {
	                this.createNewCardOnCanvas();
	            }
	        }
	    }, {
	        key: 'saveContent',
	        value: function saveContent(textContent) {
	            var _props3 = this.props,
	                isEditable = _props3.isEditable,
	                element = _props3.element,
	                dispatchSaveTextContent = _props3.dispatchSaveTextContent;
	
	            if (!isEditable) return;
	
	            dispatchSaveTextContent(element.get('id'), textContent);
	        }
	    }, {
	        key: 'moveElementToTrash',
	        value: function moveElementToTrash() {
	            this.props.dispatchMoveElementToTrash(this.props);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props4 = this.props,
	                connectLineEdgeDropTarget = _props4.connectLineEdgeDropTarget,
	                inList = _props4.inList;
	
	
	            var lineEdgeConnector = connectLineEdgeDropTarget && !inList ? connectLineEdgeDropTarget : _lodash.identity;
	
	            return (0, _columnOnDropConnectDropTarget2.default)(this.props, lineEdgeConnector(_react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_Card2.default, _extends({}, this.props, {
	                    saveContent: this.saveContent,
	                    createNewCard: this.createNewCard,
	                    moveElementToTrash: this.moveElementToTrash }))
	            )));
	        }
	    }]);
	
	    return CardContainer;
	}(_react2.default.Component)) || _class) || _class) || _class) || _class) || _class);
	exports.default = CardContainer;
	
	
	CardContainer.propTypes = {
	    element: _propTypes2.default.object.isRequired,
	    currentBoardId: _propTypes2.default.string.isRequired,
	    createCard: _propTypes2.default.func,
	    inList: _propTypes2.default.string,
	    listIndex: _propTypes2.default.number,
	    gridSize: _propTypes2.default.number,
	    connectDropTarget: _propTypes2.default.func,
	    dispatchSaveTextContent: _propTypes2.default.func,
	    dispatchMoveElementToTrash: _propTypes2.default.func,
	    isEditable: _propTypes2.default.bool,
	    connectLineEdgeDropTarget: _propTypes2.default.func
	};

/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _index = __webpack_require__(2254);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _Card = __webpack_require__(722);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _CardContainer = __webpack_require__(1960);
	
	var _CardContainer2 = _interopRequireDefault(_CardContainer);
	
	var _browser = __webpack_require__(61);
	
	var _toolbarConstants = __webpack_require__(129);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return (0, _index2.default)({
	        containerComponent: _CardContainer2.default,
	        presentationalComponent: _Card2.default,
	        tools: [_toolbarConstants.TOOLS.RICH_TEXT, _toolbarConstants.TOOLS.COLOR, _extends({}, _toolbarConstants.TOOLS.CAPTION, { name: 'Description' })],
	        tooltip: _browser.isApple ? '⌃⌘N' : 'Ctrl+Alt+N'
	    });
	};

/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	// Components
	
	
	// Style
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementUtil = __webpack_require__(105);
	
	var _List = __webpack_require__(744);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _EditableTitle = __webpack_require__(228);
	
	var _EditableTitle2 = _interopRequireDefault(_EditableTitle);
	
	var _ColorBar = __webpack_require__(294);
	
	var _ColorBar2 = _interopRequireDefault(_ColorBar);
	
	var _ElementUserTag = __webpack_require__(203);
	
	var _ElementUserTag2 = _interopRequireDefault(_ElementUserTag);
	
	var _ContainerElementChildCount = __webpack_require__(724);
	
	var _ContainerElementChildCount2 = _interopRequireDefault(_ContainerElementChildCount);
	
	var _gridUtils = __webpack_require__(42);
	
	var _columnConstants = __webpack_require__(207);
	
	__webpack_require__(1204);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Column = function Column(props) {
	    var element = props.element,
	        gridSize = props.gridSize,
	        isSelected = props.isSelected,
	        inList = props.inList,
	        elementEvents = props.elementEvents;
	
	    var colorName = element.get('content').get('color');
	
	    var classes = (0, _elementUtil.elementClassNames)('Column drag-handle', props);
	
	    return _react2.default.createElement(
	        'div',
	        _extends({ id: (0, _elementUtil.getDomElementId)(element.get('id')), className: classes,
	            style: (0, _gridUtils.getElementStyle)(34, gridSize, inList) }, elementEvents),
	        _react2.default.createElement(_ColorBar2.default, { colorName: colorName }),
	        _react2.default.createElement(_ElementUserTag2.default, props),
	        _react2.default.createElement(_EditableTitle2.default, _extends({}, props, {
	            elementId: element.get('id'),
	            initialValue: 'New Column',
	            selectFirst: true,
	            selectAllOnEdit: true,
	            isSelected: isSelected,
	            editorKey: _columnConstants.COLUMN_TYPE })),
	        _react2.default.createElement(_ContainerElementChildCount2.default, _extends({}, props, { show: true })),
	        _react2.default.createElement(_List2.default, _extends({}, props, { listId: element.get('id') }))
	    );
	};
	
	Column.propTypes = {
	    element: _propTypes2.default.object.isRequired,
	    gridSize: _propTypes2.default.number,
	    isSelected: _propTypes2.default.bool,
	    inList: _propTypes2.default.string,
	    className: _propTypes2.default.string,
	    documentMode: _propTypes2.default.bool,
	    elementEvents: _propTypes2.default.object
	};
	
	exports.default = Column;

/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class; // Lib
	
	
	// Components
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _ColumnPresentationalWrapper = __webpack_require__(723);
	
	var _ColumnPresentationalWrapper2 = _interopRequireDefault(_ColumnPresentationalWrapper);
	
	var _elementLineEdgeDropTarget = __webpack_require__(200);
	
	var _elementLineEdgeDropTarget2 = _interopRequireDefault(_elementLineEdgeDropTarget);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ColumnContainer = (0, _elementLineEdgeDropTarget2.default)(_class = function (_React$Component) {
	    _inherits(ColumnContainer, _React$Component);
	
	    function ColumnContainer() {
	        _classCallCheck(this, ColumnContainer);
	
	        return _possibleConstructorReturn(this, (ColumnContainer.__proto__ || Object.getPrototypeOf(ColumnContainer)).apply(this, arguments));
	    }
	
	    _createClass(ColumnContainer, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                connectLineEdgeDropTarget = _props.connectLineEdgeDropTarget,
	                inList = _props.inList;
	
	
	            var lineEdgeConnector = connectLineEdgeDropTarget && !inList ? connectLineEdgeDropTarget : _lodash.identity;
	
	            return lineEdgeConnector(_react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_ColumnPresentationalWrapper2.default, this.props)
	            ));
	        }
	    }]);
	
	    return ColumnContainer;
	}(_react2.default.Component)) || _class;
	
	exports.default = ColumnContainer;
	
	
	ColumnContainer.propTypes = {
	    element: _propTypes2.default.object.isRequired,
	    children: _propTypes2.default.array,
	    currentBoardId: _propTypes2.default.string,
	    connectDropTarget: _propTypes2.default.func,
	    connectLineEdgeDropTarget: _propTypes2.default.func,
	    isHovered: _propTypes2.default.bool,
	    isPresentational: _propTypes2.default.bool,
	    inList: _propTypes2.default.string
	};

/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.createColumnWithChildren = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _undoRedoTransactionManager = __webpack_require__(86);
	
	var _elementActions = __webpack_require__(26);
	
	var _elementMoveActions = __webpack_require__(302);
	
	var _selectionActions = __webpack_require__(55);
	
	var _analytics = __webpack_require__(47);
	
	var _columnConstants = __webpack_require__(207);
	
	var _boardConstants = __webpack_require__(17);
	
	// Constants
	
	
	// Actions
	// Lib
	var createColumnWithChildren = exports.createColumnWithChildren = function createColumnWithChildren(_ref) {
	    var location = _ref.location,
	        content = _ref.content,
	        childIdArray = _ref.childIdArray,
	        _ref$sync = _ref.sync,
	        sync = _ref$sync === undefined ? true : _ref$sync,
	        _ref$transactionId = _ref.transactionId,
	        transactionId = _ref$transactionId === undefined ? (0, _undoRedoTransactionManager.getNewTransactionId)() : _ref$transactionId;
	    return function (dispatch, getState) {
	        (0, _analytics.analyticsEvent)('created-column-cmd-drop');
	
	        // Create the new column
	        var columnElementId = dispatch((0, _elementActions.createElement)({
	            elementType: _columnConstants.COLUMN_TYPE,
	            location: location,
	            content: content,
	            sync: sync,
	            transactionId: transactionId
	        }));
	
	        var moves = childIdArray.map(function (id) {
	            return {
	                id: id,
	                location: {
	                    parentId: columnElementId,
	                    section: _boardConstants.BOARD_SECTIONS.INBOX,
	                    position: { index: 0 }
	                }
	            };
	        });
	
	        dispatch((0, _elementMoveActions.moveMultipleElements)({ moves: moves, transactionId: transactionId }));
	
	        (0, _lodash.defer)(function () {
	            return dispatch((0, _selectionActions.startEditingElement)({ id: columnElementId }));
	        });
	
	        return { columnElementId: columnElementId, transactionId: transactionId };
	    };
	};
	
	// Utils

/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _index = __webpack_require__(2255);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _ColumnPresentationalWrapper = __webpack_require__(723);
	
	var _ColumnPresentationalWrapper2 = _interopRequireDefault(_ColumnPresentationalWrapper);
	
	var _ColumnContainer = __webpack_require__(1963);
	
	var _ColumnContainer2 = _interopRequireDefault(_ColumnContainer);
	
	var _browser = __webpack_require__(61);
	
	var _toolbarConstants = __webpack_require__(129);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return (0, _index2.default)({
	        presentationalComponent: _ColumnPresentationalWrapper2.default,
	        containerComponent: _ColumnContainer2.default,
	        tools: [_toolbarConstants.TOOLS.COLOR, _toolbarConstants.TOOLS.LOCK],
	        tooltip: _browser.isApple ? '⌃⌘G' : 'Ctrl+Alt+G'
	    });
	};

/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Measurements
	
	
	// Actions
	
	
	// Decorators
	
	
	// Utils
	
	
	// Constants
	
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactDnd = __webpack_require__(72);
	
	var _recompose = __webpack_require__(9);
	
	var _lodash = __webpack_require__(4);
	
	var _elementConstants = __webpack_require__(12);
	
	var _measurementsConnect = __webpack_require__(123);
	
	var _measurementsConnect2 = _interopRequireDefault(_measurementsConnect);
	
	var _measurementsSelector = __webpack_require__(124);
	
	var _elementDuplicateActions = __webpack_require__(1976);
	
	var _elementMoveActions = __webpack_require__(302);
	
	var _selectionActions = __webpack_require__(55);
	
	var _draggingActions = __webpack_require__(462);
	
	var _undoRedoActions = __webpack_require__(316);
	
	var _selectedElementsSelector = __webpack_require__(127);
	
	var _elementConnectionsObserverDecorator = __webpack_require__(1706);
	
	var _elementConnectionsObserverDecorator2 = _interopRequireDefault(_elementConnectionsObserverDecorator);
	
	var _elementHelper = __webpack_require__(13);
	
	var _analytics = __webpack_require__(47);
	
	var _immutableHelper = __webpack_require__(23);
	
	var _connectionsSelector = __webpack_require__(678);
	
	var _buildElementOffsetsMap = __webpack_require__(1972);
	
	var _buildElementOffsetsMap2 = _interopRequireDefault(_buildElementOffsetsMap);
	
	var _buildElementMovesArray = __webpack_require__(1971);
	
	var _buildElementMovesArray2 = _interopRequireDefault(_buildElementMovesArray);
	
	var _boardConstants = __webpack_require__(17);
	
	var _dragModifierKeysConstants = __webpack_require__(172);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Container Component Methods
	 */
	var mapConnectionStateToProps = function mapConnectionStateToProps(state) {
	    return {
	        // FIXME This actually provides no performance benefit because the function is being created every time the
	        // state changes.  Need to determine a better way of doing this.
	        getConnectingElements: function getConnectingElements(elementId) {
	            return (0, _immutableHelper.toIdArray)((0, _connectionsSelector.getConnections)(state).filter(function (connectedElements) {
	                return connectedElements.includes(elementId);
	            }));
	        }
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        startDragging: function startDragging(isSelected, ids) {
	            if (!isSelected) {
	                dispatch((0, _selectionActions.deselectAllElements)());
	            }
	            dispatch((0, _draggingActions.dragStart)(ids));
	        },
	        endDragging: function endDragging() {
	            return dispatch((0, _draggingActions.dragEnd)());
	        },
	        dispatchEndMoveOperation: function dispatchEndMoveOperation() {
	            return dispatch((0, _undoRedoActions.endOperation)('move'));
	        },
	        onDropMove: function onDropMove(_ref) {
	            var moves = _ref.moves,
	                transactionId = _ref.transactionId;
	            return dispatch((0, _elementMoveActions.moveMultipleElements)({ moves: moves, transactionId: transactionId }));
	        },
	        onDropCopy: function onDropCopy(_ref2) {
	            var duplications = _ref2.duplications,
	                transactionId = _ref2.transactionId;
	            return dispatch((0, _elementDuplicateActions.duplicateMultipleElements)({ duplications: duplications, transactionId: transactionId }));
	        },
	        dispatchGetSelectedElements: function dispatchGetSelectedElements() {
	            return dispatch(function (_, getState) {
	                return (0, _selectedElementsSelector.getSelectedElements)(getState());
	            });
	        },
	        dispatchGetSelectedElementIds: function dispatchGetSelectedElementIds() {
	            return dispatch(function (_, getState) {
	                return (0, _selectedElementsSelector.getSelectedElementIds)(getState());
	            });
	        }
	    };
	};
	
	var mapMeasurementsDispatchToProps = function mapMeasurementsDispatchToProps(dispatch) {
	    return {
	        dispatchGetMeasurementsMap: function dispatchGetMeasurementsMap() {
	            return dispatch(function (_, getState) {
	                return (0, _measurementsSelector.getMeasurementsMap)(getState());
	            });
	        }
	    };
	};
	
	var trackDraggingAnalyticsEvent = function trackDraggingAnalyticsEvent(copyDrag, dropResult, _ref3) {
	    var element = _ref3.element,
	        inList = _ref3.inList;
	
	    if (copyDrag) return (0, _analytics.analyticsEvent)('duplicated-element-opt-drag');
	    if (dropResult.location.section === _boardConstants.BOARD_SECTIONS.TRASH) return (0, _analytics.analyticsEvent)('moved-element-to-trash-drag');
	    if (dropResult.location.section === _boardConstants.BOARD_SECTIONS.INBOX && dropResult.location.parentId === element.getIn(['location', 'parentId']) && inList !== 'in-list') {
	        return (0, _analytics.analyticsEvent)('moved-element-to-unsorted-notes');
	    }
	};
	
	var getDraggedElements = function getDraggedElements(element, selectedElementIds, selectedElements) {
	    // ID of the element that's actually being dragged (from react-dnd perspective)
	    var grabbedElementId = element.get('id');
	    var draggedElements = null;
	
	    if (selectedElementIds.size && selectedElementIds.includes(grabbedElementId)) {
	        draggedElements = selectedElements.filter((0, _lodash.negate)(_elementHelper.isElementLocked)).toArray();
	    } else {
	        draggedElements = [element];
	    }
	
	    return (0, _elementHelper.filterOutLinkedBoards)(draggedElements);
	};
	
	/**
	 * Drag source contract.
	 */
	var draggableElementSource = {
	    canDrag: function canDrag(_ref4) {
	        var isEditing = _ref4.isEditing,
	            isEditingChild = _ref4.isEditingChild,
	            isEditable = _ref4.isEditable,
	            isLocked = _ref4.isLocked;
	
	        return !isLocked && isEditable && !(isEditing || isEditingChild);
	    },
	
	
	    // Returns the data describing the dragged tool
	    beginDrag: function beginDrag(props, monitor, component) {
	        var element = props.element,
	            startDragging = props.startDragging,
	            isSelected = props.isSelected,
	            getConnectingElements = props.getConnectingElements,
	            dispatchGetSelectedElementIds = props.dispatchGetSelectedElementIds,
	            dispatchGetSelectedElements = props.dispatchGetSelectedElements,
	            dispatchGetMeasurementsMap = props.dispatchGetMeasurementsMap,
	            gridSize = props.gridSize;
	
	        // Find out the offsets (from the top left of the grabbed element) for all dragged elements
	
	        var selectedElementIds = dispatchGetSelectedElementIds();
	        var selectedElements = dispatchGetSelectedElements();
	        var draggedElements = getDraggedElements(element, selectedElementIds, selectedElements);
	        var draggedElementIds = draggedElements.map(function (el) {
	            return el.get('id');
	        });
	        var connectingElementIds = (0, _lodash.uniq)((0, _lodash.flatMap)(draggedElementIds, getConnectingElements));
	        var location = element.get('location').toJS();
	
	        startDragging(isSelected, draggedElementIds);
	
	        var measurementsMap = dispatchGetMeasurementsMap();
	        var offsetsMap = (0, _buildElementOffsetsMap2.default)({
	            grabbedElement: element,
	            draggedElements: draggedElements,
	            measurementsMap: measurementsMap,
	            gridSize: gridSize
	        });
	
	        return {
	            element: element,
	            connectingElementIds: connectingElementIds,
	            draggedElementIds: draggedElementIds,
	            draggedElements: draggedElements,
	            offsetsMap: offsetsMap,
	            originalLocation: location,
	            fromList: !!props.inList,
	            hoveredItems: {},
	            hoveredTypes: {}
	        };
	    },
	    isDragging: function isDragging(props, monitor) {
	        var element = props.element;
	
	        var thisElementId = element.get('id');
	        var item = monitor.getItem();
	        var draggedElementIds = item.draggedElementIds,
	            connectingElementIds = item.connectingElementIds;
	
	        return draggedElementIds.includes(thisElementId) || (0, _lodash.includes)(connectingElementIds, thisElementId);
	    },
	
	
	    // Handles when the tool is dropped
	    endDrag: function endDrag(props, monitor, component) {
	        var element = props.element,
	            endDragging = props.endDragging,
	            onDropMove = props.onDropMove,
	            onDropCopy = props.onDropCopy,
	            dragModifierKeys = props.dragModifierKeys,
	            gridSize = props.gridSize,
	            dispatchGetSelectedElementIds = props.dispatchGetSelectedElementIds,
	            dispatchEndMoveOperation = props.dispatchEndMoveOperation,
	            dispatchGetMeasurementsMap = props.dispatchGetMeasurementsMap,
	            dispatchGetSelectedElements = props.dispatchGetSelectedElements;
	
	
	        endDragging();
	        var operationTransactionId = dispatchEndMoveOperation();
	
	        // Doing nothing if it was not dropped onto a compatible target
	        if (!monitor.didDrop()) return;
	
	        var item = monitor.getItem();
	        var dropResult = monitor.getDropResult();
	        var copyDrag = dragModifierKeys.get(_dragModifierKeysConstants.MODIFIER_KEYS.altKey);
	
	        // Only drop if a location is returned by the drop target
	        if (!dropResult.location) return;
	
	        trackDraggingAnalyticsEvent(copyDrag, dropResult, props);
	
	        // Use the drop transaction ID if one exists, otherwise use the move transaction ID
	        var transactionId = dropResult.transactionId || operationTransactionId;
	
	        var measurementsMap = dispatchGetMeasurementsMap();
	        var moves = (0, _buildElementMovesArray2.default)({ element: element, dropResult: dropResult, item: item, gridSize: gridSize, measurementsMap: measurementsMap });
	
	        if (copyDrag) {
	            // Update the IDs of aliases that we're duplicating to their physical board
	            var selectedElements = dispatchGetSelectedElements();
	            var selectedElementIds = dispatchGetSelectedElementIds();
	            var draggedAliases = getDraggedElements(element, selectedElementIds, selectedElements).filter(_elementHelper.isAlias);
	
	            var duplications = moves.map(function (move) {
	                var alias = (0, _lodash.find)(draggedAliases, function (aliasEl) {
	                    return aliasEl.get('id') === move.id;
	                });
	                if (!alias) return move;
	
	                return _extends({}, move, {
	                    id: (0, _elementHelper.getPhysicalId)(alias)
	                });
	            });
	
	            return onDropCopy({
	                duplications: duplications,
	                transactionId: transactionId
	            });
	        }
	
	        onDropMove({ moves: moves, transactionId: transactionId });
	    }
	};
	
	var dragCollect = function dragCollect(connector, monitor) {
	    return {
	        // Call inside render() to let React handle the drag event
	        connectDragSource: connector.dragSource(),
	        connectDragPreview: connector.dragPreview(),
	        // Get current drag state from the monitor
	        isDragging: monitor.isDragging()
	    };
	};
	
	exports.default = function (Element) {
	    return (0, _recompose.compose)((0, _elementConnectionsObserverDecorator2.default)(mapConnectionStateToProps), (0, _reactRedux.connect)(null, mapDispatchToProps), (0, _measurementsConnect2.default)(null, mapMeasurementsDispatchToProps), (0, _reactDnd.DragSource)(_elementConstants.ELEMENT_DND_TYPE, draggableElementSource, dragCollect))(Element);
	};

/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dragAndDropUtils = __webpack_require__(145);
	
	var _cssUtil = __webpack_require__(312);
	
	__webpack_require__(1206);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	// Utils
	
	
	// Styles
	
	
	var getTranslation = function getTranslation(props) {
	    // The distance between the top of the browser and the dragged element (not the mouse pointer)
	    var sourceClientOffset = props.sourceClientOffset,
	        clientOffset = props.clientOffset,
	        item = props.item;
	
	
	    if (!sourceClientOffset) return { display: 'none' };
	    var offset = (0, _dragAndDropUtils.isNewElement)({ item: item }) ? clientOffset : sourceClientOffset;
	
	    return (0, _cssUtil.getTranslationStyles)(offset);
	};
	
	var ElementDragGroupPositioner = function (_React$Component) {
	    _inherits(ElementDragGroupPositioner, _React$Component);
	
	    function ElementDragGroupPositioner() {
	        _classCallCheck(this, ElementDragGroupPositioner);
	
	        return _possibleConstructorReturn(this, (ElementDragGroupPositioner.__proto__ || Object.getPrototypeOf(ElementDragGroupPositioner)).apply(this, arguments));
	    }
	
	    _createClass(ElementDragGroupPositioner, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            return nextProps.clientOffset !== this.props.clientOffset;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'ElementDragGroupPositioner ' + this.props.hoveredTypes, style: getTranslation(this.props) },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'hover-transform-target' },
	                    this.props.children
	                )
	            );
	        }
	    }]);
	
	    return ElementDragGroupPositioner;
	}(_react2.default.Component);
	
	ElementDragGroupPositioner.propTypes = {
	    sourceClientOffset: _propTypes2.default.object,
	    clientOffset: _propTypes2.default.object,
	    hoveredTypes: _propTypes2.default.array,
	    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
	};
	
	exports.default = ElementDragGroupPositioner;

/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _elementSelector = __webpack_require__(41);
	
	var _elementSelector2 = _interopRequireDefault(_elementSelector);
	
	var _Element = __webpack_require__(449);
	
	var _Element2 = _interopRequireDefault(_Element);
	
	__webpack_require__(1207);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Returns the display element that matches the type of the element specified.
	 * This allows the React component appropriate to the element type to be used, instead of a generic element
	 * that needs to know every different type of element and how to render it.
	 *
	 * @param element The element object that will be rendered by this component.
	 * @constructor Element
	 */
	
	var ElementDragPreview = (_dec = (0, _reactRedux.connect)(_elementSelector2.default), _dec(_class = function (_React$Component) {
	    _inherits(ElementDragPreview, _React$Component);
	
	    function ElementDragPreview() {
	        _classCallCheck(this, ElementDragPreview);
	
	        return _possibleConstructorReturn(this, (ElementDragPreview.__proto__ || Object.getPrototypeOf(ElementDragPreview)).apply(this, arguments));
	    }
	
	    _createClass(ElementDragPreview, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            return false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'ElementDragPreview' },
	                _react2.default.createElement(_Element2.default, _extends({}, this.props, { isDragging: false }))
	            );
	        }
	    }]);
	
	    return ElementDragPreview;
	}(_react2.default.Component)) || _class);
	
	
	ElementDragPreview.propTypes = {
	    currentBoardId: _propTypes2.default.string.isRequired,
	    element: _propTypes2.default.object,
	    className: _propTypes2.default.string,
	    dragOrigin: _propTypes2.default.object
	};
	
	exports.default = ElementDragPreview;

/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ElementDragPreview = __webpack_require__(1968);
	
	var _ElementDragPreview2 = _interopRequireDefault(_ElementDragPreview);
	
	var _dragAndDropUtils = __webpack_require__(145);
	
	var _cssUtil = __webpack_require__(312);
	
	__webpack_require__(1208);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	// Components
	
	
	// Utils
	
	
	// Styles
	
	
	var getTranslation = function getTranslation(props) {
	    var offset = (0, _dragAndDropUtils.getElementOffset)(props);
	    return (0, _cssUtil.getTranslationStyles)(offset);
	};
	
	var ElementDragPreviewPositioner = function (_React$Component) {
	    _inherits(ElementDragPreviewPositioner, _React$Component);
	
	    function ElementDragPreviewPositioner() {
	        _classCallCheck(this, ElementDragPreviewPositioner);
	
	        return _possibleConstructorReturn(this, (ElementDragPreviewPositioner.__proto__ || Object.getPrototypeOf(ElementDragPreviewPositioner)).apply(this, arguments));
	    }
	
	    _createClass(ElementDragPreviewPositioner, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            return false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                element = _props.element,
	                gridSize = _props.gridSize,
	                currentBoardId = _props.currentBoardId;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'ElementDragPreviewPositioner', style: getTranslation(this.props) },
	                _react2.default.createElement(_ElementDragPreview2.default, { ref: 'elementDragPreview',
	                    currentBoardId: currentBoardId,
	                    element: element,
	                    isPresentational: true,
	                    gridSize: gridSize })
	            );
	        }
	    }]);
	
	    return ElementDragPreviewPositioner;
	}(_react2.default.Component);
	
	ElementDragPreviewPositioner.propTypes = {
	    element: _propTypes2.default.object.isRequired,
	    gridSize: _propTypes2.default.number.isRequired,
	    currentBoardId: _propTypes2.default.string.isRequired
	};
	
	exports.default = ElementDragPreviewPositioner;

/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ElementDragPreviewPositioner = __webpack_require__(1969);
	
	var _ElementDragPreviewPositioner2 = _interopRequireDefault(_ElementDragPreviewPositioner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	// Components
	
	
	var SelectedElementsDragPreviews = function (_React$Component) {
	    _inherits(SelectedElementsDragPreviews, _React$Component);
	
	    function SelectedElementsDragPreviews() {
	        _classCallCheck(this, SelectedElementsDragPreviews);
	
	        return _possibleConstructorReturn(this, (SelectedElementsDragPreviews.__proto__ || Object.getPrototypeOf(SelectedElementsDragPreviews)).apply(this, arguments));
	    }
	
	    _createClass(SelectedElementsDragPreviews, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            return false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var item = this.props.item;
	            var draggedElements = item.draggedElements;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'SelectedElementsDragPreviews' },
	                draggedElements.map(function (element, index) {
	                    return _react2.default.createElement(_ElementDragPreviewPositioner2.default, _extends({ key: element.get('id'), element: element, index: index
	                    }, _this2.props));
	                })
	            );
	        }
	    }]);
	
	    return SelectedElementsDragPreviews;
	}(_react2.default.Component);
	
	SelectedElementsDragPreviews.propTypes = {
	    item: _propTypes2.default.object.isRequired
	};
	
	exports.default = SelectedElementsDragPreviews;

/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Utils
	
	
	// Constants
	
	
	var _lodash = __webpack_require__(4);
	
	var _immutableHelper = __webpack_require__(23);
	
	var _point = __webpack_require__(50);
	
	var pointsLib = _interopRequireWildcard(_point);
	
	var _gridUtils = __webpack_require__(42);
	
	var _boardConstants = __webpack_require__(17);
	
	var _clamp = __webpack_require__(2276);
	
	var _clamp2 = _interopRequireDefault(_clamp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var getUpdatedLocation = function getUpdatedLocation(_ref) {
	    var dropResult = _ref.dropResult,
	        offsetsMap = _ref.offsetsMap,
	        elementId = _ref.elementId,
	        gridSize = _ref.gridSize;
	
	    // If the element is dropped onto the TRASH or INBOX then we don't need to make any updates to their position here
	    if (dropResult.location.section === _boardConstants.BOARD_SECTIONS.INBOX || dropResult.location.section === _boardConstants.BOARD_SECTIONS.TRASH) {
	        return (0, _lodash.cloneDeep)(dropResult.location);
	    }
	
	    var elementOffset = (0, _gridUtils.positionPixelsToGridPoints)(offsetsMap[elementId], gridSize);
	    var position = pointsLib.translate(dropResult.location.position, elementOffset);
	    // Prevent the element from disappearing off the canvas
	    position = (0, _lodash.mapValues)(position, (0, _clamp2.default)(0, Infinity));
	
	    return _extends({}, dropResult.location, {
	        position: position
	    });
	};
	
	var makeAddToMovesArrayReducer = function makeAddToMovesArrayReducer(_ref2) {
	    var dropResult = _ref2.dropResult,
	        offsetsMap = _ref2.offsetsMap,
	        gridSize = _ref2.gridSize,
	        measurementsMap = _ref2.measurementsMap;
	    return function (movesArray, elementId) {
	        var location = getUpdatedLocation({ dropResult: dropResult, offsetsMap: offsetsMap, elementId: elementId, gridSize: gridSize });
	        movesArray.push({ id: elementId, location: location });
	        return movesArray;
	    };
	};
	
	exports.default = function (_ref3) {
	    var dropResult = _ref3.dropResult,
	        item = _ref3.item,
	        gridSize = _ref3.gridSize,
	        measurementsMap = _ref3.measurementsMap;
	    var offsetsMap = item.offsetsMap;
	
	
	    var addToMovesArrayReducer = makeAddToMovesArrayReducer({ dropResult: dropResult, offsetsMap: offsetsMap, gridSize: gridSize });
	
	    return dropResult.acceptedElementIds.sort(function (idA, idB) {
	        return (0, _immutableHelper.propIn)([idA, 'top'], measurementsMap) - (0, _immutableHelper.propIn)([idB, 'top'], measurementsMap);
	    }).reduce(addToMovesArrayReducer, []);
	};

/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _elementHelper = __webpack_require__(13);
	
	var _point = __webpack_require__(50);
	
	var pointLib = _interopRequireWildcard(_point);
	
	var _dndConstants = __webpack_require__(171);
	
	var _dragAndDropUtils = __webpack_require__(145);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Constants
	// Utils
	var isGrabbedElement = function isGrabbedElement(_ref) {
	    var grabbedElement = _ref.grabbedElement,
	        element = _ref.element;
	    return grabbedElement.get('id') === element.get('id');
	};
	
	// Drag offsets
	var getBoardInListOriginOffset = function getBoardInListOriginOffset(_ref2) {
	    var element = _ref2.element,
	        gridSize = _ref2.gridSize,
	        measurementsMap = _ref2.measurementsMap;
	
	    var selectedElementMeasurements = measurementsMap.get(element.get('id'));
	    var originOffset = selectedElementMeasurements.get('originOffset').toJS();
	    return pointLib.difference((0, _dragAndDropUtils.getBoardIconCentreOffset)({ gridSize: gridSize }), originOffset);
	};
	
	/**
	 * This handles situations where the element needs to be repositioned because the dragged preview is not visually
	 * the same as the element that was grabbed (for example, boards in a list are a different shape).
	 */
	var getElementOriginOffset = function getElementOriginOffset(_ref3) {
	    var grabbedElement = _ref3.grabbedElement,
	        element = _ref3.element,
	        gridSize = _ref3.gridSize,
	        measurementsMap = _ref3.measurementsMap;
	
	    // A grabbed element has to be handled in the drag layer and the drop handler because the mouse offset information
	    // is not available at this time (beginDrag)
	    if (isGrabbedElement({ grabbedElement: grabbedElement, element: element })) return _dndConstants.NO_DRAG_OFFSET;
	
	    if ((0, _elementHelper.isBoardLike)(element) && (0, _elementHelper.isInList)(element)) {
	        return getBoardInListOriginOffset({ element: element, gridSize: gridSize, measurementsMap: measurementsMap });
	    }
	
	    return _dndConstants.NO_DRAG_OFFSET;
	};
	
	var getSelectedElementTranslation = function getSelectedElementTranslation(_ref4) {
	    var grabbedElement = _ref4.grabbedElement,
	        element = _ref4.element,
	        measurementsMap = _ref4.measurementsMap;
	
	    var selectedElementPosition = measurementsMap.get(element.get('id'));
	
	    // If this element is the grabbed element, no translation is necessary
	    if (isGrabbedElement({ grabbedElement: grabbedElement, element: element })) {
	        return _dndConstants.NO_DRAG_OFFSET;
	    }
	
	    var grabbedElementPosition = measurementsMap.get(grabbedElement.get('id'));
	
	    return {
	        x: selectedElementPosition.get('left') - grabbedElementPosition.get('left'),
	        y: selectedElementPosition.get('top') - grabbedElementPosition.get('top')
	    };
	};
	
	var getElementOffset = function getElementOffset(_ref5) {
	    var grabbedElement = _ref5.grabbedElement,
	        element = _ref5.element,
	        measurementsMap = _ref5.measurementsMap,
	        gridSize = _ref5.gridSize;
	    return pointLib.translate(getElementOriginOffset({ grabbedElement: grabbedElement, element: element, gridSize: gridSize, measurementsMap: measurementsMap }), getSelectedElementTranslation({ grabbedElement: grabbedElement, element: element, measurementsMap: measurementsMap }));
	};
	
	var addOffsetToMapReducer = function addOffsetToMapReducer(_ref6) {
	    var grabbedElement = _ref6.grabbedElement,
	        measurementsMap = _ref6.measurementsMap,
	        gridSize = _ref6.gridSize;
	    return function (offsetMap, element) {
	        offsetMap[element.get('id')] = getElementOffset({ grabbedElement: grabbedElement, element: element, measurementsMap: measurementsMap, gridSize: gridSize });
	        return offsetMap;
	    };
	};
	
	exports.default = function (_ref7) {
	    var grabbedElement = _ref7.grabbedElement,
	        draggedElements = _ref7.draggedElements,
	        measurementsMap = _ref7.measurementsMap,
	        gridSize = _ref7.gridSize;
	    return draggedElements.reduce(addOffsetToMapReducer({ grabbedElement: grabbedElement, measurementsMap: measurementsMap, gridSize: gridSize }), {});
	};

/***/ }),
/* 1973 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (_ref) {
	  var props = _ref.props,
	      monitor = _ref.monitor;
	  return props.canDrop;
	};

/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _elementHelper = __webpack_require__(13);
	
	exports.default = function (_ref) {
	    var props = _ref.props,
	        monitor = _ref.monitor;
	
	    var item = monitor.getItem();
	    var element = props.element;
	
	    // Don't allow columns to be dropped on columns
	
	    return !element || !item.element || !((0, _elementHelper.isColumn)(element) && item.draggedElements.every(function (el) {
	        return (0, _elementHelper.isColumn)(el) || (0, _elementHelper.isLine)(el);
	    }));
	}; // Utils

/***/ }),
/* 1975 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (_ref) {
	  var props = _ref.props,
	      monitor = _ref.monitor;
	  return props.currentBoardId !== props.elementId;
	};

/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.duplicateMultipleElements = exports.duplicateElement = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Actions
	
	
	// Util
	
	
	// Constants
	
	
	var _elementActions = __webpack_require__(793);
	
	var _elementActions2 = __webpack_require__(26);
	
	var _elementCountActions = __webpack_require__(464);
	
	var _http = __webpack_require__(76);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _elementHelper = __webpack_require__(13);
	
	var _undoRedoTransactionManager = __webpack_require__(86);
	
	var _boardConstants = __webpack_require__(17);
	
	var _httpConstants = __webpack_require__(90);
	
	var _elementConstants = __webpack_require__(12);
	
	var TYPES = _interopRequireWildcard(_elementConstants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prepareDuplicateContent = function prepareDuplicateContent(content) {
	    return _extends({}, content, {
	        title: content.title,
	        documentMode: undefined
	    });
	};
	
	var duplicateElement = exports.duplicateElement = function duplicateElement(_ref) {
	    var duplicateId = _ref.duplicateId,
	        location = _ref.location,
	        _ref$sync = _ref.sync,
	        sync = _ref$sync === undefined ? true : _ref$sync,
	        _ref$transactionId = _ref.transactionId,
	        transactionId = _ref$transactionId === undefined ? (0, _undoRedoTransactionManager.getNewTransactionId)() : _ref$transactionId;
	    return function (dispatch, getState) {
	        var state = getState();
	        var copyElement = state.getIn(['elements', duplicateId]);
	
	        if (!copyElement) return;
	
	        var elementType = (0, _elementHelper.isAlias)(copyElement) ? _boardConstants.BOARD_TYPE : copyElement.get('elementType');
	
	        var newElementDef = {
	            elementType: elementType,
	            location: location,
	            content: prepareDuplicateContent(copyElement.get('content').toJS()),
	            meta: copyElement.get('meta'),
	            duplicate: true,
	            transactionId: transactionId
	        };
	
	        var elementId = dispatch((0, _elementActions2.createElement)(newElementDef));
	
	        // don't continue if element creation wasn't successful
	        var createdElement = getState().getIn(['elements', elementId]);
	        if (!createdElement) return;
	
	        if (!(0, _elementHelper.isContainer)(copyElement)) return;
	
	        var postData = {
	            element: JSON.stringify({
	                id: elementId,
	                location: location
	            })
	        };
	
	        (0, _http2.default)({ url: 'elements/' + copyElement.get('id'), method: _httpConstants.METHODS.COPY, data: postData }).then(function (res) {
	            dispatch({
	                type: TYPES.ELEMENT_FORCE_LOAD,
	                id: elementId,
	                sync: true
	            });
	
	            dispatch((0, _elementCountActions.increaseElementCount)(res.data.elementCount, transactionId));
	        }).catch(function (err) {
	            if (!err.response) return console.error(err);
	
	            var data = err.response.data;
	
	            dispatch((0, _elementActions.deleteElement)({ id: elementId, location: location, transactionId: transactionId }));
	            // TODO: show an error modal here
	            alert(data.error && data.error.message); // eslint-disable-line no-alert
	        });
	    };
	};
	
	var duplicateMultipleElements = exports.duplicateMultipleElements = function duplicateMultipleElements(_ref2) {
	    var duplications = _ref2.duplications,
	        _ref2$transactionId = _ref2.transactionId,
	        transactionId = _ref2$transactionId === undefined ? (0, _undoRedoTransactionManager.getNewTransactionId)() : _ref2$transactionId;
	    return function (dispatch, getState) {
	        duplications.forEach(function (duplication) {
	            return dispatch(duplicateElement({
	                duplicateId: duplication.id,
	                location: duplication.location,
	                transactionId: transactionId
	            }));
	        });
	    };
	};

/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defaultResourceReducer = __webpack_require__(470);
	
	var _defaultResourceReducer2 = _interopRequireDefault(_defaultResourceReducer);
	
	var _elementConstants = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Reducers
	exports.default = function (state, action) {
	    var updatedState = (0, _defaultResourceReducer2.default)(state, action);
	
	    if (action.type === _elementConstants.ELEMENT_CREATE) {
	        return updatedState.set('fetched', true).set('fetching', false);
	    }
	
	    return updatedState;
	};
	
	// Constants

/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _makeResourceTypeReducer = __webpack_require__(471);
	
	var _makeResourceTypeReducer2 = _interopRequireDefault(_makeResourceTypeReducer);
	
	var _resourceConstants = __webpack_require__(85);
	
	var _elementConstants = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Constants
	var elementsPredicateFn = function elementsPredicateFn(action) {
	    return action.resource === _resourceConstants.RESOURCE_TYPES.elements || action.resource === _resourceConstants.RESOURCE_TYPES.boards && action.type !== _resourceConstants.RESOURCES_MARKED_AS_STALE || action.type === _elementConstants.ELEMENT_CREATE;
	}; // Reducers
	exports.default = (0, _makeResourceTypeReducer2.default)(_resourceConstants.RESOURCE_TYPES.elements, elementsPredicateFn);

/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	// Utils
	
	
	// Actions
	
	
	// Components
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(4);
	
	var _fileValidator = __webpack_require__(238);
	
	var _dontUpdateForKeys = __webpack_require__(206);
	
	var _dontUpdateForKeys2 = _interopRequireDefault(_dontUpdateForKeys);
	
	var _gridSizeSelector = __webpack_require__(66);
	
	var _analytics = __webpack_require__(47);
	
	var _elementAttachmentActions = __webpack_require__(142);
	
	var _elementAttachmentActions2 = __webpack_require__(142);
	
	var _Image = __webpack_require__(732);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _ColumnOnDropDropTarget = __webpack_require__(452);
	
	var _ColumnOnDropDropTarget2 = _interopRequireDefault(_ColumnOnDropDropTarget);
	
	var _columnOnDropConnectDropTarget = __webpack_require__(453);
	
	var _columnOnDropConnectDropTarget2 = _interopRequireDefault(_columnOnDropConnectDropTarget);
	
	var _captionContainerDecorator = __webpack_require__(425);
	
	var _captionContainerDecorator2 = _interopRequireDefault(_captionContainerDecorator);
	
	var _imageFileDropTargetDecorator = __webpack_require__(718);
	
	var _imageFileDropTargetDecorator2 = _interopRequireDefault(_imageFileDropTargetDecorator);
	
	var _elementLineEdgeDropTarget = __webpack_require__(200);
	
	var _elementLineEdgeDropTarget2 = _interopRequireDefault(_elementLineEdgeDropTarget);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// File drop functionality
	var handleCanDrop = function handleCanDrop(props, monitor, component) {
	    return !props.hasImage;
	};
	var ImageWithFileDrop = function ImageWithFileDrop(props) {
	    return _react2.default.createElement(_Image2.default, props);
	};
	ImageWithFileDrop = (0, _imageFileDropTargetDecorator2.default)({ canDrop: handleCanDrop })(ImageWithFileDrop);
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        dispatchUploadImage: function dispatchUploadImage(elementID, file) {
	            var validationError = (0, _fileValidator.validateImageFile)(file);
	            if (validationError) {
	                dispatch((0, _elementAttachmentActions2.errorUploadingElementAttachment)({
	                    id: elementID,
	                    error: validationError
	                }));
	                return;
	            }
	            return dispatch((0, _elementAttachmentActions.uploadAttachment)({ id: elementID, file: file }));
	        }
	    };
	};
	
	var ImageContainer = (_dec = (0, _reactRedux.connect)(_gridSizeSelector.gridSizeSelector, mapDispatchToProps), _dec2 = (0, _dontUpdateForKeys2.default)(['dragModifierKeys', 'canDrop']), _dec(_class = (0, _elementLineEdgeDropTarget2.default)(_class = (0, _ColumnOnDropDropTarget2.default)(_class = _dec2(_class = (0, _captionContainerDecorator2.default)(_class = function (_React$Component) {
	    _inherits(ImageContainer, _React$Component);
	
	    function ImageContainer() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ImageContainer);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ImageContainer.__proto__ || Object.getPrototypeOf(ImageContainer)).call.apply(_ref, [this].concat(args))), _this), _this.setElementSize = function (size) {
	            var setElementSize = _this.props.setElementSize;
	
	            (0, _analytics.analyticsEvent)('resized-image');
	            return setElementSize(size);
	        }, _this.handleKey = function (event) {
	            if (!_this.props.isSelected) return;
	            _this.props.captionKeyHandler(event, _this.props);
	        }, _this.uploadImage = function (file) {
	            var _this$props = _this.props,
	                dispatchUploadImage = _this$props.dispatchUploadImage,
	                element = _this$props.element;
	
	            dispatchUploadImage(element.get('id'), file);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ImageContainer, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                connectLineEdgeDropTarget = _props.connectLineEdgeDropTarget,
	                inList = _props.inList;
	
	
	            var lineEdgeConnector = connectLineEdgeDropTarget && !inList ? connectLineEdgeDropTarget : _lodash.identity;
	
	            return (0, _columnOnDropConnectDropTarget2.default)(this.props, lineEdgeConnector(_react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(ImageWithFileDrop, _extends({}, this.props, {
	                    uploadImage: this.uploadImage,
	                    handleKey: this.handleKey,
	                    setElementSize: this.setElementSize }))
	            )));
	        }
	    }]);
	
	    return ImageContainer;
	}(_react2.default.Component)) || _class) || _class) || _class) || _class) || _class);
	
	
	ImageContainer.propTypes = {
	    element: _propTypes2.default.object.isRequired,
	    connectDropTarget: _propTypes2.default.func,
	    connectLineEdgeDropTarget: _propTypes2.default.func,
	    isSelected: _propTypes2.default.bool,
	    captionKeyHandler: _propTypes2.default.func,
	    dispatchCleanElementAttachment: _propTypes2.default.func,
	    dispatchUpdateElement: _propTypes2.default.func.isRequired,
	    dispatchUploadImage: _propTypes2.default.func,
	    inList: _propTypes2.default.string,
	    setElementSize: _propTypes2.default.func
	};
	
	exports.default = ImageContainer;

/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _immutableHelper = __webpack_require__(23);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _LinkButton = __webpack_require__(74);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	var _elementAttachmentActions = __webpack_require__(142);
	
	__webpack_require__(1210);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	// Utils
	
	
	// Components
	
	
	// Actions
	
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        dispatchClearError: function dispatchClearError(id) {
	            return dispatch((0, _elementAttachmentActions.clearElementAttachmentError)({ id: id }));
	        }
	    };
	};
	
	var ImageErrorContent = function (_React$Component) {
	    _inherits(ImageErrorContent, _React$Component);
	
	    function ImageErrorContent() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ImageErrorContent);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ImageErrorContent.__proto__ || Object.getPrototypeOf(ImageErrorContent)).call.apply(_ref, [this].concat(args))), _this), _this.clearError = function () {
	            var _this$props = _this.props,
	                elementId = _this$props.elementId,
	                dispatchClearError = _this$props.dispatchClearError;
	
	            dispatchClearError(elementId);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ImageErrorContent, [{
	        key: 'render',
	        value: function render() {
	            var error = this.props.error;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'ImageErrorContent' },
	                _react2.default.createElement(_Icon2.default, { name: 'error-alert' }),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'details' },
	                    (0, _immutableHelper.prop)('message', error) || 'Unable to upload image',
	                    _react2.default.createElement('br', null),
	                    (0, _immutableHelper.prop)('explanation', error) || 'Sorry, something went wrong'
	                ),
	                _react2.default.createElement(
	                    _LinkButton2.default,
	                    { className: 'cta', onClickFn: this.clearError },
	                    'Try another image'
	                )
	            );
	        }
	    }]);
	
	    return ImageErrorContent;
	}(_react2.default.Component);
	
	ImageErrorContent.propTypes = {
	    error: _propTypes2.default.object,
	    dispatchClearError: _propTypes2.default.func,
	    elementId: _propTypes2.default.string,
	    imageConnectDropTarget: _propTypes2.default.func,
	    imageIsHovered: _propTypes2.default.bool,
	    imageCanDrop: _propTypes2.default.bool
	};
	
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(ImageErrorContent);

/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _gridUtils = __webpack_require__(42);
	
	var _propsComparisons = __webpack_require__(147);
	
	var _ElementImage = __webpack_require__(437);
	
	var _ElementImage2 = _interopRequireDefault(_ElementImage);
	
	var _imageConstants = __webpack_require__(87);
	
	var _elementConstants = __webpack_require__(12);
	
	var _mediaConstants = __webpack_require__(148);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Utils
	
	
	// Components
	
	
	// Constants
	
	
	var getFullSizeImageUrl = function getFullSizeImageUrl(element) {
	    return element.getIn(['content', 'image', _imageConstants.IMAGE_SIZES.ORIGINAL.name]) || element.getIn(['content', 'image', _imageConstants.IMAGE_SIZES.HUGE.name]);
	};
	
	// Prop comparisons
	var isNoLongerEditing = (0, _propsComparisons.noLonger)('isEditing');
	
	/**
	 * Renders a 'ProgressiveImage' for an element.
	 * If the element has image data the progressive image will use the thumbnail from the image data, otherwise it will
	 * use the data from the element's attachment as it must have just been uploaded.
	 *
	 * NOTE: This component should ONLY be used when there is actually image data (either in the element's content or
	 * attachment).  If it doesn't have data this component will not display correctly.
	 *
	 * @param element {Object} The element object from the redux store.
	 * @param showProgressive {Boolean} Whether to show a progressive image or standard image.
	 */
	
	var ImageRenderer = function (_React$Component) {
	    _inherits(ImageRenderer, _React$Component);
	
	    function ImageRenderer(props) {
	        _classCallCheck(this, ImageRenderer);
	
	        var _this = _possibleConstructorReturn(this, (ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call(this, props));
	
	        _this.openFullSizeImage = _this.openFullSizeImage.bind(_this);
	        return _this;
	    }
	
	    _createClass(ImageRenderer, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(oldProps) {
	            if (isNoLongerEditing(oldProps, this.props) && this.props.isSelected) {
	                this.refs.imageRenderer.focus();
	            }
	        }
	    }, {
	        key: 'openFullSizeImage',
	        value: function openFullSizeImage(event) {
	            event.preventDefault();
	
	            var element = this.props.element;
	
	            var imageURL = getFullSizeImageUrl(element);
	            if (!imageURL) return;
	
	            window.open(imageURL, '_blank');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                element = _props.element,
	                isHovered = _props.isHovered,
	                canDrop = _props.canDrop,
	                handleKey = _props.handleKey,
	                gridSize = _props.gridSize,
	                documentMode = _props.documentMode;
	
	
	            var size = element.getIn(['content', 'width']) || _elementConstants.ELEMENT_DEFAULT_WIDTH;
	            var width = documentMode ? _imageConstants.DOC_MODE_IMAGE_WIDTH : (0, _gridUtils.gridPointsToPixels)(size, gridSize);
	
	            return _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('focusable', { canDrop: isHovered && canDrop }),
	                    ref: 'imageRenderer',
	                    tabIndex: '-1',
	                    onKeyDown: handleKey,
	                    onDoubleClick: this.openFullSizeImage },
	                _react2.default.createElement(_ElementImage2.default, { element: element, imageType: _mediaConstants.IMAGE_TYPES.ELEMENT, size: width })
	            );
	        }
	    }]);
	
	    return ImageRenderer;
	}(_react2.default.Component);
	
	ImageRenderer.propTypes = {
	    gridSize: _propTypes2.default.number,
	    element: _propTypes2.default.object.isRequired,
	    isHovered: _propTypes2.default.bool,
	    canDrop: _propTypes2.default.bool,
	
	    size: _propTypes2.default.number,
	
	    isSelected: _propTypes2.default.bool,
	    isEditing: _propTypes2.default.bool,
	
	    handleKey: _propTypes2.default.func,
	    startEditing: _propTypes2.default.func,
	    stopEditing: _propTypes2.default.func,
	    saveContent: _propTypes2.default.func,
	    textContent: _propTypes2.default.string,
	    showCaption: _propTypes2.default.func,
	    onEmptyBackspace: _propTypes2.default.func,
	    documentMode: _propTypes2.default.bool
	};
	
	exports.default = ImageRenderer;

/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _recompose = __webpack_require__(9);
	
	var _ImageErrorContent = __webpack_require__(1980);
	
	var _ImageErrorContent2 = _interopRequireDefault(_ImageErrorContent);
	
	var _ImageUploaderContent = __webpack_require__(1983);
	
	var _ImageUploaderContent2 = _interopRequireDefault(_ImageUploaderContent);
	
	__webpack_require__(1211);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	// Components
	
	
	// Styles
	
	
	/**
	 * Creates a component which enables the user to upload an image to the server.
	 * This component will delegate the handling of uploading the file to the function passed in on the 'uploadImage'
	 * property.
	 */
	var ImageUploader = function (_React$Component) {
	    _inherits(ImageUploader, _React$Component);
	
	    function ImageUploader() {
	        _classCallCheck(this, ImageUploader);
	
	        return _possibleConstructorReturn(this, (ImageUploader.__proto__ || Object.getPrototypeOf(ImageUploader)).apply(this, arguments));
	    }
	
	    _createClass(ImageUploader, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                element = _props.element,
	                imageIsHovered = _props.imageIsHovered,
	                imageCanDrop = _props.imageCanDrop,
	                imageConnectDropTarget = _props.imageConnectDropTarget;
	
	            var error = element.getIn(['attachment', 'error']);
	
	            var displayElement = error ? _react2.default.createElement(_ImageErrorContent2.default, _extends({ elementId: element.get('id'), error: error }, this.props)) : _react2.default.createElement(_ImageUploaderContent2.default, _extends({ elementId: element.get('id') }, this.props));
	
	            var classes = (0, _classnames2.default)('ImageUploader drag-handle', {
	                hovered: imageIsHovered && imageCanDrop
	            });
	
	            var renderUploader = _react2.default.createElement(
	                'div',
	                { className: classes },
	                displayElement
	            );
	
	            return imageConnectDropTarget ? imageConnectDropTarget(renderUploader) : renderUploader;
	        }
	    }]);
	
	    return ImageUploader;
	}(_react2.default.Component);
	
	ImageUploader.propTypes = {
	    element: _propTypes2.default.object.isRequired,
	    uploadImage: _propTypes2.default.func,
	    imageIsHovered: _propTypes2.default.bool,
	    imageCanDrop: _propTypes2.default.bool,
	    imageConnectDropTarget: _propTypes2.default.func
	};
	
	exports.default = (0, _recompose.onlyUpdateForPropTypes)(ImageUploader);

/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ImageFileInput = __webpack_require__(444);
	
	var _ImageFileInput2 = _interopRequireDefault(_ImageFileInput);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	// Components
	
	
	var ImageUploaderContent = function (_React$Component) {
	    _inherits(ImageUploaderContent, _React$Component);
	
	    function ImageUploaderContent() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ImageUploaderContent);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ImageUploaderContent.__proto__ || Object.getPrototypeOf(ImageUploaderContent)).call.apply(_ref, [this].concat(args))), _this), _this.openFileSelect = function (event) {
	            var fileInput = _this.refs.fileInput;
	
	            var fileInputDomNode = _reactDom2.default.findDOMNode(fileInput);
	            fileInputDomNode.click();
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	    /**
	     * Delegates the click event on the fake file upload input to the real, hidden one.
	     */
	
	
	    _createClass(ImageUploaderContent, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                uploadImage = _props.uploadImage,
	                elementId = _props.elementId;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'uploader-content' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'click-area', onClick: this.openFileSelect },
	                    _react2.default.createElement(_ImageFileInput2.default, { ref: 'fileInput', id: elementId, uploadImage: uploadImage }),
	                    _react2.default.createElement(_Icon2.default, { name: 'image-form-upload' }),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'cta' },
	                        'Upload an image'
	                    )
	                ),
	                _react2.default.createElement(
	                    'p',
	                    { className: 'hint' },
	                    'Tip: You can drag and drop images straight from your desktop.'
	                )
	            );
	        }
	    }]);
	
	    return ImageUploaderContent;
	}(_react2.default.Component);
	
	ImageUploaderContent.propTypes = {
	    elementId: _propTypes2.default.string,
	    uploadImage: _propTypes2.default.func
	};
	
	exports.default = ImageUploaderContent;

/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getResponsiveImageName = undefined;
	
	var _browser = __webpack_require__(61);
	
	var getResponsiveImageName = exports.getResponsiveImageName = function getResponsiveImageName(containerWidth, sizes) {
	    var comparisonWidth = _browser.isRetina ? containerWidth * 2 : containerWidth;
	
	    // Start with the largest
	    return sizes.reduceRight(function (imageName, size) {
	        if (size.width >= comparisonWidth) return size.name;
	        return imageName;
	    }, sizes[sizes.length - 1].name);
	};

/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _index = __webpack_require__(2272);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _Image = __webpack_require__(732);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _ImageContainer = __webpack_require__(1979);
	
	var _ImageContainer2 = _interopRequireDefault(_ImageContainer);
	
	var _browser = __webpack_require__(61);
	
	var _toolbarConstants = __webpack_require__(129);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return (0, _index2.default)({
	        presentationalComponent: _Image2.default,
	        containerComponent: _ImageContainer2.default,
	        tools: [_toolbarConstants.TOOLS.RICH_TEXT, _toolbarConstants.TOOLS.COLOR, _toolbarConstants.TOOLS.CAPTION, _toolbarConstants.TOOLS.LOCK, _toolbarConstants.TOOLS.SHOW_BACKGROUND],
	        tooltip: _browser.isApple ? '⌃⌘I' : 'Ctrl+Alt+I'
	    });
	};

/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _card = __webpack_require__(1961);
	
	var _card2 = _interopRequireDefault(_card);
	
	var _board = __webpack_require__(1957);
	
	var _board2 = _interopRequireDefault(_board);
	
	var _image = __webpack_require__(1985);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _column = __webpack_require__(1965);
	
	var _column2 = _interopRequireDefault(_column);
	
	var _link = __webpack_require__(2003);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _alias = __webpack_require__(1951);
	
	var _alias2 = _interopRequireDefault(_alias);
	
	var _line = __webpack_require__(1994);
	
	var _line2 = _interopRequireDefault(_line);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    (0, _card2.default)();
	    (0, _image2.default)();
	    (0, _link2.default)();
	    (0, _column2.default)();
	    (0, _board2.default)();
	    (0, _alias2.default)();
	    (0, _line2.default)();
	};

/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class; // Lib
	
	
	// Geometry utils
	
	
	// Components
	
	
	// Constants
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDnd = __webpack_require__(72);
	
	var _lodash = __webpack_require__(4);
	
	var _Vector = __webpack_require__(323);
	
	var _Vector2 = _interopRequireDefault(_Vector);
	
	var _lineControlPointUtil = __webpack_require__(456);
	
	var _rect = __webpack_require__(208);
	
	var rectLib = _interopRequireWildcard(_rect);
	
	var _ControlPointDragHandle = __webpack_require__(733);
	
	var _ControlPointDragHandle2 = _interopRequireDefault(_ControlPointDragHandle);
	
	var _lineConstants = __webpack_require__(57);
	
	var _domUtil = __webpack_require__(107);
	
	var _dndConstants = __webpack_require__(171);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var edgeDragSource = {
	    beginDrag: function beginDrag(_ref, monitor, component) {
	        var elementId = _ref.elementId,
	            toggleLineVisibility = _ref.toggleLineVisibility,
	            pos = _ref.pos,
	            element = _ref.element;
	
	        (0, _lodash.defer)(toggleLineVisibility);
	        return { id: elementId, element: element, pos: pos };
	    },
	    endDrag: function endDrag(props, monitor) {
	        var updateLineControlPoint = props.updateLineControlPoint,
	            toggleLineVisibility = props.toggleLineVisibility,
	            controlPoint = props.controlPoint,
	            startEdgeOrigin = props.startEdgeOrigin,
	            endEdgeOrigin = props.endEdgeOrigin,
	            startConnectionRect = props.startConnectionRect,
	            endConnectionRect = props.endConnectionRect;
	
	        // Doing nothing if it was not dropped onto a compatible target
	
	        var dropResult = monitor.getDropResult();
	        if (!monitor.didDrop() || (0, _lodash.isEmpty)(dropResult)) {
	            toggleLineVisibility();
	            return;
	        }
	
	        var _dropResult$offsetDif = dropResult.offsetDiff,
	            offsetDiff = _dropResult$offsetDif === undefined ? _dndConstants.NO_DRAG_OFFSET : _dropResult$offsetDif;
	
	
	        var updatedControlPoint = _Vector2.default.fromObject(controlPoint)
	        // Add the offset moved by the mouse
	        .add(offsetDiff);
	
	        // Snapping
	        var controlPointPerpendicularMagnitude = (0, _lineControlPointUtil.calculateControlPointPerpendicularMagnitude)({
	            controlPoint: updatedControlPoint,
	            startEdgeOrigin: startEdgeOrigin,
	            endEdgeOrigin: endEdgeOrigin
	        });
	
	        var controlPointParallelRatio = (0, _lineControlPointUtil.calculateControlPointParallelRatio)({
	            controlPoint: updatedControlPoint,
	            startEdgeOrigin: startEdgeOrigin,
	            endEdgeOrigin: endEdgeOrigin
	        });
	
	        var control = void 0;
	        var isControlPointWithinAnElement = rectLib.containsPoint(startConnectionRect, updatedControlPoint) || rectLib.containsPoint(endConnectionRect, updatedControlPoint);
	
	        if ((0, _lineControlPointUtil.shouldSnapToStraight)({ controlPointPerpendicularMagnitude: controlPointPerpendicularMagnitude, controlPointParallelRatio: controlPointParallelRatio }) || isControlPointWithinAnElement) {
	            control = null;
	        } else {
	            control = {
	                perpMag: controlPointPerpendicularMagnitude,
	                parallelRatio: controlPointParallelRatio
	            };
	        }
	
	        updateLineControlPoint({ control: control });
	        toggleLineVisibility();
	    }
	};
	
	var dragCollect = function dragCollect(connector, monitor) {
	    return {
	        // Call inside render() to let React handle the drag event
	        connectDragSource: connector.dragSource(),
	        connectDragPreview: connector.dragPreview(),
	        // Get current drag state from the monitor
	        isDragging: monitor.isDragging()
	    };
	};
	
	var ControlPointDragHandleDragSource = (_dec = (0, _reactDnd.DragSource)(_lineConstants.LINE_CONTROL_POINT_DND_TYPE, edgeDragSource, dragCollect), _dec(_class = function (_React$Component) {
	    _inherits(ControlPointDragHandleDragSource, _React$Component);
	
	    function ControlPointDragHandleDragSource() {
	        _classCallCheck(this, ControlPointDragHandleDragSource);
	
	        return _possibleConstructorReturn(this, (ControlPointDragHandleDragSource.__proto__ || Object.getPrototypeOf(ControlPointDragHandleDragSource)).apply(this, arguments));
	    }
	
	    _createClass(ControlPointDragHandleDragSource, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(_ControlPointDragHandle2.default, this.props);
	        }
	    }]);
	
	    return ControlPointDragHandleDragSource;
	}(_react2.default.Component)) || _class);
	
	/**
	 * Needs to be a React component so that the parent's (Line) ref connects correctly.
	 */
	/* eslint-disable react/no-multi-comp */
	
	var ConnectedControlPointDragHandle = function (_React$Component2) {
	    _inherits(ConnectedControlPointDragHandle, _React$Component2);
	
	    function ConnectedControlPointDragHandle() {
	        var _ref2;
	
	        var _temp, _this2, _ret;
	
	        _classCallCheck(this, ConnectedControlPointDragHandle);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref2 = ConnectedControlPointDragHandle.__proto__ || Object.getPrototypeOf(ConnectedControlPointDragHandle)).call.apply(_ref2, [this].concat(args))), _this2), _this2.onDoubleClick = function (event) {
	            _this2.props.updateLineControlPoint({ control: null });
	
	            event.stopPropagation();
	            event.preventDefault();
	        }, _temp), _possibleConstructorReturn(_this2, _ret);
	    }
	
	    _createClass(ConnectedControlPointDragHandle, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                controlPoint = _props.controlPoint,
	                show = _props.show;
	
	            if (!show) return null;
	
	            return _react2.default.createElement(ControlPointDragHandleDragSource, _extends({ className: 'ControlPointDragHandle', isHitArea: true,
	                onMouseDown: _domUtil.stopPropagationOnly, onDoubleClick: this.onDoubleClick,
	                pos: controlPoint }, this.props));
	        }
	    }]);
	
	    return ConnectedControlPointDragHandle;
	}(_react2.default.Component);
	
	ConnectedControlPointDragHandle.propTypes = {
	    show: _propTypes2.default.bool,
	    startEdgeOrigin: _propTypes2.default.object,
	    endEdgeOrigin: _propTypes2.default.object,
	    color: _propTypes2.default.string,
	    controlPoint: _propTypes2.default.object,
	    updateLineControlPoint: _propTypes2.default.func,
	    startConnectionRect: _propTypes2.default.object,
	    endConnectionRect: _propTypes2.default.object
	};
	
	exports.default = ConnectedControlPointDragHandle;

/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class; // Lib
	
	
	// Utils
	
	
	// Components
	
	
	// Constants
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDnd = __webpack_require__(72);
	
	var _lodash = __webpack_require__(4);
	
	var _domUtil = __webpack_require__(107);
	
	var _lineSnapAngleUtil = __webpack_require__(737);
	
	var _point = __webpack_require__(50);
	
	var pointLib = _interopRequireWildcard(_point);
	
	var _EdgeDragHandle = __webpack_require__(735);
	
	var _EdgeDragHandle2 = _interopRequireDefault(_EdgeDragHandle);
	
	var _lineConstants = __webpack_require__(57);
	
	var _dndConstants = __webpack_require__(171);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var edgeDragSource = {
	    beginDrag: function beginDrag(_ref) {
	        var edge = _ref.edge,
	            elementId = _ref.elementId,
	            toggleLineVisibility = _ref.toggleLineVisibility,
	            pos = _ref.pos,
	            element = _ref.element;
	
	        (0, _lodash.defer)(toggleLineVisibility);
	        return { id: elementId, element: element, edge: edge, pos: pos };
	    },
	    endDrag: function endDrag(props, monitor) {
	        var updateLineEdge = props.updateLineEdge,
	            edge = props.edge,
	            pos = props.pos,
	            gridSize = props.gridSize,
	            toggleLineVisibility = props.toggleLineVisibility,
	            origin = props.origin,
	            dragModifierKeys = props.dragModifierKeys;
	
	        // Doing nothing if it was not dropped onto a compatible target
	
	        var dropResult = monitor.getDropResult();
	        if (!monitor.didDrop() || (0, _lodash.isEmpty)(dropResult)) {
	            toggleLineVisibility();
	            return;
	        }
	
	        var _dropResult$offsetDif = dropResult.offsetDiff,
	            offsetDiff = _dropResult$offsetDif === undefined ? _dndConstants.NO_DRAG_OFFSET : _dropResult$offsetDif,
	            snapped = dropResult.snapped,
	            elementId = dropResult.elementId;
	
	
	        var newPositionPx = pointLib.translate(offsetDiff, pos);
	        var shouldSnapToAngle = dragModifierKeys.get('shiftKey');
	
	        if (shouldSnapToAngle) {
	            newPositionPx = (0, _lineSnapAngleUtil.getEndpointSnappedToAngle)({
	                fixedPoint: origin,
	                flexiblePoint: newPositionPx
	            });
	        }
	
	        var newPosition = {
	            x: Math.round(newPositionPx.x / gridSize),
	            y: Math.round(newPositionPx.y / gridSize),
	            snapped: !!snapped
	        };
	
	        if (snapped) {
	            newPosition.elementId = elementId;
	        }
	
	        updateLineEdge({ edge: edge, newPosition: newPosition });
	        toggleLineVisibility();
	    }
	};
	
	var dragCollect = function dragCollect(connector, monitor) {
	    return {
	        // Call inside render() to let React handle the drag event
	        connectDragSource: connector.dragSource(),
	        connectDragPreview: connector.dragPreview(),
	        // Get current drag state from the monitor
	        isDragging: monitor.isDragging()
	    };
	};
	
	var EdgeDragHandleDragSource = (_dec = (0, _reactDnd.DragSource)(_lineConstants.LINE_EDGE_DND_TYPE, edgeDragSource, dragCollect), _dec(_class = function (_React$Component) {
	    _inherits(EdgeDragHandleDragSource, _React$Component);
	
	    function EdgeDragHandleDragSource() {
	        _classCallCheck(this, EdgeDragHandleDragSource);
	
	        return _possibleConstructorReturn(this, (EdgeDragHandleDragSource.__proto__ || Object.getPrototypeOf(EdgeDragHandleDragSource)).apply(this, arguments));
	    }
	
	    _createClass(EdgeDragHandleDragSource, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(_EdgeDragHandle2.default, this.props);
	        }
	    }]);
	
	    return EdgeDragHandleDragSource;
	}(_react2.default.Component)) || _class);
	
	/**
	 * Needs to be a React component so that the parent's (Line) ref connects correctly.
	 */
	/* eslint-disable react/no-multi-comp */
	
	var ConnectedEdgeDragHandle = function (_React$Component2) {
	    _inherits(ConnectedEdgeDragHandle, _React$Component2);
	
	    function ConnectedEdgeDragHandle() {
	        _classCallCheck(this, ConnectedEdgeDragHandle);
	
	        return _possibleConstructorReturn(this, (ConnectedEdgeDragHandle.__proto__ || Object.getPrototypeOf(ConnectedEdgeDragHandle)).apply(this, arguments));
	    }
	
	    _createClass(ConnectedEdgeDragHandle, [{
	        key: 'render',
	        value: function render() {
	            var show = this.props.show;
	
	            if (!show) return null;
	
	            return _react2.default.createElement(EdgeDragHandleDragSource, _extends({ onMouseDown: _domUtil.stopPropagationOnly, isHitArea: true }, this.props));
	        }
	    }]);
	
	    return ConnectedEdgeDragHandle;
	}(_react2.default.Component);
	
	ConnectedEdgeDragHandle.propTypes = {
	    show: _propTypes2.default.bool,
	    pos: _propTypes2.default.object,
	    edge: _propTypes2.default.string.isRequired,
	    elementId: _propTypes2.default.string.isRequired,
	    updateLineEdge: _propTypes2.default.func,
	    toggleLineVisibility: _propTypes2.default.func,
	    gridSize: _propTypes2.default.number,
	    origin: _propTypes2.default.object
	};
	
	exports.default = ConnectedEdgeDragHandle;

/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class; // Lib
	
	
	// Utils
	
	
	// Selectors
	
	
	// Components
	
	
	// Measurements Store
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reselect = __webpack_require__(7);
	
	var _lodash = __webpack_require__(4);
	
	var _point = __webpack_require__(50);
	
	var pointLib = _interopRequireWildcard(_point);
	
	var _rect = __webpack_require__(208);
	
	var rectLib = _interopRequireWildcard(_rect);
	
	var _lineUtil = __webpack_require__(201);
	
	var _elementSelector = __webpack_require__(41);
	
	var _lineSelector = __webpack_require__(232);
	
	var _lineConstants = __webpack_require__(57);
	
	var _Line = __webpack_require__(303);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	var _measurementsSelector = __webpack_require__(124);
	
	var _measurementsConnect = __webpack_require__(123);
	
	var _measurementsConnect2 = _interopRequireDefault(_measurementsConnect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// TODO Return only the required measurements (the ones that the line edges require)
	var mapMeasurementsStateToProps = function mapMeasurementsStateToProps(connectionsState) {
	    return {
	        measurements: (0, _measurementsSelector.getMeasurementsMap)(connectionsState)
	    };
	};
	
	var getUpdatedEdges = function getUpdatedEdges() {
	    return (0, _reselect.createSelector)((0, _lineSelector.makeGetLineEdgeDetails)(), _lineSelector.getLineControl, _elementSelector.getElement, function (state, ownProps) {
	        return ownProps.offsetDiff;
	    }, function (state, ownProps) {
	        return ownProps.draggedElementIds;
	    }, function (_ref, control, element, offsetDiff, draggedElementIds) {
	        var startEdgeOrigin = _ref.startEdgeOrigin,
	            startConnectionRect = _ref.startConnectionRect,
	            endEdgeOrigin = _ref.endEdgeOrigin,
	            endConnectionRect = _ref.endConnectionRect;
	
	        var draggingStart = (0, _lodash.includes)(draggedElementIds, element.getIn(['content', _lineConstants.LINE_EDGE.start, 'elementId']));
	        var draggingEnd = (0, _lodash.includes)(draggedElementIds, element.getIn(['content', _lineConstants.LINE_EDGE.end, 'elementId']));
	
	        var translatedStartConnectionRect = draggingStart ? rectLib.translate(offsetDiff, startConnectionRect) : startConnectionRect;
	        var translatedEndConnectionRect = draggingEnd ? rectLib.translate(offsetDiff, endConnectionRect) : endConnectionRect;
	
	        var translatedStartEdgeOrigin = draggingStart ? pointLib.translate(offsetDiff, startEdgeOrigin) : startEdgeOrigin;
	        var translatedEndEdgeOrigin = draggingEnd ? pointLib.translate(offsetDiff, endEdgeOrigin) : endEdgeOrigin;
	
	        // Find the control point
	        var controlPoint = (0, _lineSelector.getControlPosition)({
	            start: translatedStartEdgeOrigin,
	            end: translatedEndEdgeOrigin,
	            control: control
	        });
	
	        return (0, _lineUtil.getLinePointsOfInterest)({
	            startEdgeOrigin: translatedStartEdgeOrigin,
	            startConnectionRect: translatedStartConnectionRect,
	            endEdgeOrigin: translatedEndEdgeOrigin,
	            endConnectionRect: translatedEndConnectionRect,
	            controlPoint: controlPoint
	        });
	    });
	};
	
	var makeMapStateToProps = function makeMapStateToProps() {
	    return (0, _reselect.createSelector)(_elementSelector.getElementId, getUpdatedEdges(), _elementSelector.getColourHex, _lineSelector.getLineStartStyle, _lineSelector.getLineEndStyle, function (elementId, _ref2, colorHex, startStyle, endStyle) {
	        var start = _ref2.start,
	            end = _ref2.end,
	            controlPoint = _ref2.controlPoint;
	        return {
	            elementId: elementId,
	            start: start,
	            end: end,
	            controlPoint: controlPoint,
	            colorHex: colorHex,
	            startStyle: startStyle,
	            endStyle: endStyle
	        };
	    });
	};
	
	var ConnectedLineDragPreview = (_dec = (0, _measurementsConnect2.default)(mapMeasurementsStateToProps), _dec2 = (0, _reactRedux.connect)(makeMapStateToProps), _dec(_class = _dec2(_class = function (_React$Component) {
	    _inherits(ConnectedLineDragPreview, _React$Component);
	
	    function ConnectedLineDragPreview() {
	        _classCallCheck(this, ConnectedLineDragPreview);
	
	        return _possibleConstructorReturn(this, (ConnectedLineDragPreview.__proto__ || Object.getPrototypeOf(ConnectedLineDragPreview)).apply(this, arguments));
	    }
	
	    _createClass(ConnectedLineDragPreview, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(_Line2.default, _extends({}, this.props, { isPresentational: true }));
	        }
	    }]);
	
	    return ConnectedLineDragPreview;
	}(_react2.default.Component)) || _class) || _class);
	
	
	ConnectedLineDragPreview.propTypes = {
	    elementId: _propTypes2.default.string.isRequired,
	    draggedElementIds: _propTypes2.default.array.isRequired,
	    offsetDiff: _propTypes2.default.object
	};
	
	exports.default = ConnectedLineDragPreview;

/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Utils
	
	
	// Actions
	
	
	// Components
	
	
	// Constants
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _fp = __webpack_require__(52);
	
	var _reactRedux = __webpack_require__(3);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _point = __webpack_require__(242);
	
	var _lineUtil = __webpack_require__(201);
	
	var _point2 = __webpack_require__(50);
	
	var pointsLib = _interopRequireWildcard(_point2);
	
	var _lineSelector = __webpack_require__(232);
	
	var _elementActions = __webpack_require__(26);
	
	var _LinePresentationalWrapper = __webpack_require__(736);
	
	var _LinePresentationalWrapper2 = _interopRequireDefault(_LinePresentationalWrapper);
	
	var _elementConnectionsSourceDecorator = __webpack_require__(1707);
	
	var _elementConnectionsSourceDecorator2 = _interopRequireDefault(_elementConnectionsSourceDecorator);
	
	var _lineConstants = __webpack_require__(57);
	
	var _boardConstants = __webpack_require__(17);
	
	var _elementConstants = __webpack_require__(12);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        dispatchMoveAndUpdateElement: function dispatchMoveAndUpdateElement(_ref) {
	            var id = _ref.id,
	                changes = _ref.changes,
	                location = _ref.location,
	                transactionId = _ref.transactionId;
	            return dispatch((0, _elementActions.atomicMoveAndUpdate)({ id: id, changes: changes, location: location, transactionId: transactionId }));
	        }
	    };
	};
	
	var connectionSourceCollect = {
	    getConnectionTargetIds: function getConnectionTargetIds(_ref2) {
	        var element = _ref2.element;
	        return (0, _fp.compact)([element.getIn(['content', 'start', 'elementId']), element.getIn(['content', 'end', 'elementId'])]);
	    }
	};
	
	var connectionSourceSpec = {
	    handleConnectedElementMove: function handleConnectedElementMove(props, action, move) {
	        var element = props.element,
	            updateLineEdge = props.updateLineEdge,
	            gridSize = props.gridSize;
	
	
	        var elementParentId = element.getIn(['location', 'parentId']);
	        var droppedParentId = move.location.parentId;
	        var droppedSection = move.location.section;
	        if (elementParentId === droppedParentId && droppedSection === _boardConstants.BOARD_SECTIONS.CANVAS) return;
	
	        var movedElementId = move.id;
	
	        // Find the edge that was connected and remove its connection
	        var modifiedEdgeName = element.getIn(['content', 'start', 'elementId']) === movedElementId ? _lineConstants.LINE_EDGE.start : _lineConstants.LINE_EDGE.end;
	
	        var scaleToGridUnits = pointsLib.scale(1 / gridSize);
	        var edgesBeforeMove = props.getCachedEdges();
	
	        var previousEdgePosition = edgesBeforeMove[modifiedEdgeName];
	        var previousEdgeGridPosition = scaleToGridUnits(previousEdgePosition);
	
	        var modifiedEdge = element.getIn(['content', modifiedEdgeName]);
	        var newPosition = modifiedEdge.set('x', previousEdgeGridPosition.x).set('y', previousEdgeGridPosition.y).set('snapped', false).remove('elementId').toJS();
	
	        updateLineEdge({ edge: modifiedEdgeName, newPosition: newPosition, transactionId: action.transactionId });
	    },
	    handleConnectionSourceMove: function handleConnectionSourceMove(props, action, move) {
	        var dispatchUpdateElement = props.dispatchUpdateElement,
	            gridSize = props.gridSize;
	
	        // TODO This feels a bit hacky, would want to find a cleaner way of handling this
	
	        var disconnectStart = true;
	        var disconnectEnd = true;
	        if (action.type === _elementConstants.ELEMENT_MOVE_MULTI) {
	            var movedElementIds = action.moves.map(function (elementMove) {
	                return elementMove.id;
	            });
	
	            var startConnectedElementId = (0, _lineSelector.getStartConnectedElementId)(null, props);
	            var endConnectedElementId = (0, _lineSelector.getEndConnectedElementId)(null, props);
	
	            disconnectStart = !(0, _fp.includes)(startConnectedElementId, movedElementIds);
	            disconnectEnd = !(0, _fp.includes)(endConnectedElementId, movedElementIds);
	        }
	
	        var scaleToGridUnits = pointsLib.scale(1 / gridSize);
	        var edgesBeforeMove = props.getCachedEdges();
	        var changes = {};
	        var shouldDispatchUpdate = false;
	
	        if (disconnectStart) {
	            shouldDispatchUpdate = true;
	            changes.start = _extends({}, scaleToGridUnits(edgesBeforeMove.start), {
	                snapped: false
	            });
	        }
	
	        if (disconnectEnd) {
	            shouldDispatchUpdate = true;
	            changes.end = _extends({}, scaleToGridUnits(edgesBeforeMove.end), {
	                snapped: false
	            });
	        }
	
	        shouldDispatchUpdate && dispatchUpdateElement({ id: move.id, changes: changes, transactionId: action.transactionId });
	    }
	};
	
	var LineConnectionSource = function LineConnectionSource(props) {
	    return _react2.default.createElement(_LinePresentationalWrapper2.default, props);
	};
	
	LineConnectionSource = (0, _elementConnectionsSourceDecorator2.default)(connectionSourceSpec, connectionSourceCollect)(LineConnectionSource);
	
	var LineContainer = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec(_class = function (_React$Component) {
	    _inherits(LineContainer, _React$Component);
	
	    function LineContainer(props) {
	        _classCallCheck(this, LineContainer);
	
	        var _this = _possibleConstructorReturn(this, (LineContainer.__proto__ || Object.getPrototypeOf(LineContainer)).call(this, props));
	
	        _this.getCachedEdges = function () {
	            return {
	                start: _this.start,
	                end: _this.end
	            };
	        };
	
	        _this.cacheEdges = function (_ref3) {
	            var start = _ref3.start,
	                end = _ref3.end;
	
	            _this.start = start;
	            _this.end = end;
	        };
	
	        _this.updateLineControlPoint = function (_ref4) {
	            var control = _ref4.control;
	            var _this$props = _this.props,
	                dispatchUpdateElement = _this$props.dispatchUpdateElement,
	                element = _this$props.element;
	
	
	            dispatchUpdateElement({
	                id: element.get('id'),
	                changes: { control: control }
	            });
	        };
	
	        _this.updateLineEdge = function (_ref5) {
	            var edge = _ref5.edge,
	                newPosition = _ref5.newPosition,
	                transactionId = _ref5.transactionId;
	            var _this$props2 = _this.props,
	                element = _this$props2.element,
	                dispatchMoveAndUpdateElement = _this$props2.dispatchMoveAndUpdateElement;
	
	            var id = element.get('id');
	
	            var changes = _defineProperty({
	                start: element.getIn(['content', 'start']).toJS(),
	                end: element.getIn(['content', 'end']).toJS()
	            }, edge, newPosition);
	
	            // Ensure the line is at least a size of MIN_LINE_LENGTH
	            var newLineDist = (0, _lineUtil.getLineDistance)(changes);
	            if (newLineDist < _lineConstants.MIN_LINE_LENGTH) {
	                var distanceToIncreaseBy = _lineConstants.MIN_LINE_LENGTH - newLineDist;
	
	                // Need to extend the line
	                var mobileEdge = edge === _lineConstants.LINE_EDGE.start ? changes.start : changes.end;
	                var staticEdge = edge === _lineConstants.LINE_EDGE.start ? changes.end : changes.start;
	
	                var movedEdge = (0, _lineUtil.enlargeLine)(mobileEdge, staticEdge, distanceToIncreaseBy);
	                changes[edge] = _extends({}, changes[edge], movedEdge);
	            }
	
	            var endpoints = (0, _fp.values)(changes);
	            var translation = (0, _point.getTopLeftBoundaryPoint)(endpoints);
	
	            var initialLocation = element.get('location').toJS();
	
	            // Translate the actual element position down
	            var updatedLocation = _extends({}, initialLocation, {
	                position: (0, _point2.translate)(translation, initialLocation.position)
	            });
	
	            // Reverse the translation on the endpoints
	            changes.start = (0, _point2.reverseTranslate)(translation, changes.start);
	            changes.end = (0, _point2.reverseTranslate)(translation, changes.end);
	
	            dispatchMoveAndUpdateElement({ id: id, changes: changes, location: updatedLocation, transactionId: transactionId });
	        };
	
	        _this.toggleLineVisibility = function () {
	            _this.setState({
	                invisible: !_this.state.invisible
	            });
	        };
	
	        _this.state = { invisible: false };
	        return _this;
	    }
	
	    _createClass(LineContainer, [{
	        key: 'render',
	        value: function render() {
	            var invisible = this.state.invisible;
	
	            return _react2.default.createElement(LineConnectionSource, _extends({ className: (0, _classnames2.default)({ invisible: invisible }), updateLineEdge: this.updateLineEdge,
	                updateLineControlPoint: this.updateLineControlPoint,
	                toggleLineVisibility: this.toggleLineVisibility }, this.props, {
	                cacheEdges: this.cacheEdges, getCachedEdges: this.getCachedEdges }));
	        }
	    }]);
	
	    return LineContainer;
	}(_react2.default.Component)) || _class);
	
	
	LineContainer.propTypes = {
	    element: _propTypes2.default.object.isRequired,
	    dispatchMoveAndUpdateElement: _propTypes2.default.func,
	    dispatchUpdateElement: _propTypes2.default.func
	};
	
	exports.default = LineContainer;

/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class; // Lib
	
	
	// Utils
	
	
	// Selectors
	
	
	// Components
	
	
	// Measurements
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reselect = __webpack_require__(7);
	
	var _point = __webpack_require__(50);
	
	var pointLib = _interopRequireWildcard(_point);
	
	var _lineUtil = __webpack_require__(201);
	
	var _lineControlPointUtil = __webpack_require__(456);
	
	var _rect = __webpack_require__(208);
	
	var rectLib = _interopRequireWildcard(_rect);
	
	var _elementSelector = __webpack_require__(41);
	
	var _lineSelector = __webpack_require__(232);
	
	var _Line = __webpack_require__(303);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	var _measurementsConnect = __webpack_require__(123);
	
	var _measurementsConnect2 = _interopRequireDefault(_measurementsConnect);
	
	var _measurementsSelector = __webpack_require__(124);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// TODO Return only the required measurements (the ones that the line edges require)
	var mapMeasurementsStateToProps = function mapMeasurementsStateToProps(connectionsState) {
	    return {
	        measurements: (0, _measurementsSelector.getMeasurementsMap)(connectionsState)
	    };
	};
	
	var makeGetUpdatedLinePointsOfInterest = function makeGetUpdatedLinePointsOfInterest() {
	    return (0, _reselect.createSelector)((0, _lineSelector.makeGetLineEdgeDetails)(), _lineSelector.getLineControl, function (state, ownProps) {
	        return ownProps.offsetDiff;
	    }, function (_ref, control, offsetDiff) {
	        var startEdgeOrigin = _ref.startEdgeOrigin,
	            startConnectionRect = _ref.startConnectionRect,
	            endEdgeOrigin = _ref.endEdgeOrigin,
	            endConnectionRect = _ref.endConnectionRect;
	
	        // Find the control point
	        var controlPoint = (0, _lineSelector.getControlPosition)({ start: startEdgeOrigin, end: endEdgeOrigin, control: control });
	
	        // If connected and the control point is halfway between the start and end origins, then we need to get
	        // the updated control point
	        var originLineMidpoint = (0, _lineControlPointUtil.getHalfwayPoint)(startEdgeOrigin, endEdgeOrigin);
	        if ((startConnectionRect || endConnectionRect) && (pointLib.equals(originLineMidpoint, controlPoint) || rectLib.containsPoint(startConnectionRect, controlPoint) || rectLib.containsPoint(endConnectionRect, controlPoint))) {
	            var originalPointsOfInterest = (0, _lineUtil.getLinePointsOfInterest)({
	                startEdgeOrigin: startEdgeOrigin,
	                startConnectionRect: startConnectionRect,
	                endEdgeOrigin: endEdgeOrigin,
	                endConnectionRect: endConnectionRect,
	                controlPoint: controlPoint
	            });
	            controlPoint = originalPointsOfInterest.controlPoint;
	        }
	
	        controlPoint = pointLib.translate(controlPoint, offsetDiff);
	
	        var isControlPointInStartElement = rectLib.containsPoint(startConnectionRect, controlPoint);
	        var isControlPointInEndElement = rectLib.containsPoint(endConnectionRect, controlPoint);
	
	        if (!isControlPointInStartElement && !isControlPointInEndElement) {
	            controlPoint = (0, _lineControlPointUtil.snapControlPointIfClose)({ controlPoint: controlPoint, startEdgeOrigin: startEdgeOrigin, endEdgeOrigin: endEdgeOrigin });
	        }
	
	        // Use the line connecting from the end to the centre point of the start rect.
	        var startVisibleConnectionPoint = (0, _lineUtil.getVisibleConnectionPoint)({
	            sourcePoint: startEdgeOrigin,
	            controlPoint: controlPoint,
	            targetPoint: endEdgeOrigin,
	            sourcePerimeter: startConnectionRect
	        });
	        var endVisibleConnectionPoint = (0, _lineUtil.getVisibleConnectionPoint)({
	            sourcePoint: endEdgeOrigin,
	            controlPoint: controlPoint,
	            targetPoint: startEdgeOrigin,
	            sourcePerimeter: endConnectionRect
	        });
	
	        if (pointLib.equals(originLineMidpoint, controlPoint)) {
	            controlPoint = (0, _lineControlPointUtil.getHalfwayPoint)(startVisibleConnectionPoint, endVisibleConnectionPoint);
	        } else if (isControlPointInStartElement) {
	            controlPoint = startVisibleConnectionPoint;
	        } else if (isControlPointInEndElement) {
	            controlPoint = endVisibleConnectionPoint;
	        }
	
	        return {
	            start: startVisibleConnectionPoint,
	            end: endVisibleConnectionPoint,
	            startEdgeOrigin: startEdgeOrigin,
	            endEdgeOrigin: endEdgeOrigin,
	            controlPoint: controlPoint
	        };
	    });
	};
	
	var makeMapStateToProps = function makeMapStateToProps() {
	    return (0, _reselect.createSelector)(_elementSelector.getElementId, makeGetUpdatedLinePointsOfInterest(), _elementSelector.getColourHex, _lineSelector.getLineStartStyle, _lineSelector.getLineEndStyle, _lineSelector.getIsLineStartSnapped, _lineSelector.getIsLineEndSnapped, function (elementId, _ref2, colorHex, startStyle, endStyle, startSnapped, endSnapped) {
	        var start = _ref2.start,
	            end = _ref2.end,
	            controlPoint = _ref2.controlPoint;
	        return {
	            elementId: elementId,
	            start: start,
	            end: end,
	            colorHex: colorHex,
	            startStyle: startStyle,
	            endStyle: endStyle,
	            startSnapped: startSnapped,
	            endSnapped: endSnapped,
	            controlPoint: controlPoint
	        };
	    });
	};
	
	var LineControlPointDragPreview = (_dec = (0, _measurementsConnect2.default)(mapMeasurementsStateToProps), _dec2 = (0, _reactRedux.connect)(makeMapStateToProps), _dec(_class = _dec2(_class = function (_React$Component) {
	    _inherits(LineControlPointDragPreview, _React$Component);
	
	    function LineControlPointDragPreview() {
	        _classCallCheck(this, LineControlPointDragPreview);
	
	        return _possibleConstructorReturn(this, (LineControlPointDragPreview.__proto__ || Object.getPrototypeOf(LineControlPointDragPreview)).apply(this, arguments));
	    }
	
	    _createClass(LineControlPointDragPreview, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(_Line2.default, _extends({}, this.props, { isPresentational: true, isSelected: true }));
	        }
	    }]);
	
	    return LineControlPointDragPreview;
	}(_react2.default.Component)) || _class) || _class);
	
	
	LineControlPointDragPreview.propTypes = {
	    elementId: _propTypes2.default.string.isRequired,
	    offsetDiff: _propTypes2.default.object
	};
	
	exports.default = LineControlPointDragPreview;

/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class; // Lib
	
	
	// Utils
	
	
	// Selectors
	
	
	// Components
	
	
	// Measurements
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reselect = __webpack_require__(7);
	
	var _point = __webpack_require__(50);
	
	var pointLib = _interopRequireWildcard(_point);
	
	var _lineUtil = __webpack_require__(201);
	
	var _lineSnapAngleUtil = __webpack_require__(737);
	
	var _elementSelector = __webpack_require__(41);
	
	var _lineSelector = __webpack_require__(232);
	
	var _Line = __webpack_require__(303);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	var _measurementsSelector = __webpack_require__(124);
	
	var _measurementsConnect = __webpack_require__(123);
	
	var _measurementsConnect2 = _interopRequireDefault(_measurementsConnect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// TODO Return only the required measurements (the ones that the line edges require)
	var mapMeasurementsStateToProps = function mapMeasurementsStateToProps(connectionsState) {
	    return {
	        measurements: (0, _measurementsSelector.getMeasurementsMap)(connectionsState)
	    };
	};
	
	var updateFlexiblePoint = function updateFlexiblePoint(_ref) {
	    var offsetDiff = _ref.offsetDiff,
	        pos = _ref.pos,
	        shouldSnapToAngle = _ref.shouldSnapToAngle,
	        fixedPointOrigin = _ref.fixedPointOrigin;
	
	    var flexiblePoint = pointLib.translate(offsetDiff, pos);
	
	    if (shouldSnapToAngle) {
	        flexiblePoint = (0, _lineSnapAngleUtil.getEndpointSnappedToAngle)({ fixedPoint: fixedPointOrigin, flexiblePoint: flexiblePoint });
	    }
	
	    return flexiblePoint;
	};
	
	/**
	 * Updates the start, end and control point positions based on which end of the line is being dragged.
	 */
	var getUpdatedEdges = (0, _reselect.createSelector)((0, _lineSelector.makeGetLineEdgeDetails)(), _lineSelector.getLineControl, function (state, ownProps) {
	    return ownProps.draggedEdge;
	}, function (state, ownProps) {
	    return ownProps.offsetDiff;
	}, function (state, ownProps) {
	    return ownProps.pos;
	}, function (state, ownProps) {
	    return ownProps.shouldSnapToAngle;
	}, function (_ref2, control, draggedEdge, offsetDiff, pos, shouldSnapToAngle) {
	    var startEdgeOrigin = _ref2.startEdgeOrigin,
	        startConnectionRect = _ref2.startConnectionRect,
	        endEdgeOrigin = _ref2.endEdgeOrigin,
	        endConnectionRect = _ref2.endConnectionRect;
	
	    var fixedPointOrigin = (0, _lineUtil.isEndEdge)(draggedEdge) ? startEdgeOrigin : endEdgeOrigin;
	    var flexiblePoint = updateFlexiblePoint({ offsetDiff: offsetDiff, pos: pos, shouldSnapToAngle: shouldSnapToAngle, fixedPointOrigin: fixedPointOrigin });
	
	    var start = (0, _lineUtil.isEndEdge)(draggedEdge) ? fixedPointOrigin : flexiblePoint;
	    var end = (0, _lineUtil.isEndEdge)(draggedEdge) ? flexiblePoint : fixedPointOrigin;
	
	    var _startConnectionRect = (0, _lineUtil.isEndEdge)(draggedEdge) ? startConnectionRect : undefined;
	    var _endConnectionRect = (0, _lineUtil.isEndEdge)(draggedEdge) ? undefined : endConnectionRect;
	
	    var controlPoint = (0, _lineSelector.getControlPosition)({ start: start, end: end, control: control });
	
	    return (0, _lineUtil.getLinePointsOfInterest)({
	        startEdgeOrigin: start,
	        startConnectionRect: _startConnectionRect,
	        endEdgeOrigin: end,
	        endConnectionRect: _endConnectionRect,
	        controlPoint: controlPoint
	    });
	});
	
	var makeMapStateToProps = function makeMapStateToProps() {
	    return (0, _reselect.createSelector)(_elementSelector.getElementId, getUpdatedEdges, _elementSelector.getColourHex, _lineSelector.getLineStartStyle, _lineSelector.getLineEndStyle, _lineSelector.getIsLineStartSnapped, _lineSelector.getIsLineEndSnapped, function (state, ownProps) {
	        return ownProps.draggedEdge;
	    }, function (elementId, _ref3, colorHex, startStyle, endStyle, startSnapped, endSnapped, draggedEdge) {
	        var start = _ref3.start,
	            end = _ref3.end,
	            controlPoint = _ref3.controlPoint;
	        return {
	            elementId: elementId,
	            start: start,
	            end: end,
	            controlPoint: controlPoint,
	            colorHex: colorHex,
	            startStyle: startStyle,
	            endStyle: endStyle,
	            startSnapped: startSnapped && !(0, _lineUtil.isStartEdge)(draggedEdge),
	            endSnapped: endSnapped && !(0, _lineUtil.isEndEdge)(draggedEdge)
	        };
	    });
	};
	
	var LineDragPreview = (_dec = (0, _measurementsConnect2.default)(mapMeasurementsStateToProps), _dec2 = (0, _reactRedux.connect)(makeMapStateToProps), _dec(_class = _dec2(_class = function (_React$Component) {
	    _inherits(LineDragPreview, _React$Component);
	
	    function LineDragPreview() {
	        _classCallCheck(this, LineDragPreview);
	
	        return _possibleConstructorReturn(this, (LineDragPreview.__proto__ || Object.getPrototypeOf(LineDragPreview)).apply(this, arguments));
	    }
	
	    _createClass(LineDragPreview, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(_Line2.default, _extends({}, this.props, { isPresentational: true, isSelected: true }));
	        }
	    }]);
	
	    return LineDragPreview;
	}(_react2.default.Component)) || _class) || _class);
	
	
	LineDragPreview.propTypes = {
	    elementId: _propTypes2.default.string.isRequired,
	    draggedEdge: _propTypes2.default.string.isRequired,
	    offsetDiff: _propTypes2.default.object
	};
	
	exports.default = LineDragPreview;

/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactDnd = __webpack_require__(72);
	
	var _lineConstants = __webpack_require__(57);
	
	var _dndConstants = __webpack_require__(171);
	
	// Constants
	var canvasLineEdgeDropTargetSpec = {
	    drop: function drop(props, monitor) {
	        if (monitor.didDrop()) return;
	        var offsetDiff = monitor.getDifferenceFromInitialOffset() || _dndConstants.NO_DRAG_OFFSET;
	        return { offsetDiff: offsetDiff };
	    }
	}; // Lib
	
	
	var canvasLineEdgeDropCollect = function canvasLineEdgeDropCollect(connector, monitor) {
	    return {
	        connectLineEdgeDropTarget: connector.dropTarget()
	    };
	};
	
	var DROP_TYPES = [_lineConstants.LINE_CONTROL_POINT_DND_TYPE, _lineConstants.LINE_EDGE_DND_TYPE];
	
	exports.default = (0, _reactDnd.DropTarget)(DROP_TYPES, canvasLineEdgeDropTargetSpec, canvasLineEdgeDropCollect);

/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _index = __webpack_require__(2273);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _LinePresentationalWrapper = __webpack_require__(736);
	
	var _LinePresentationalWrapper2 = _interopRequireDefault(_LinePresentationalWrapper);
	
	var _LineContainer = __webpack_require__(1990);
	
	var _LineContainer2 = _interopRequireDefault(_LineContainer);
	
	var _toolbarConstants = __webpack_require__(129);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Utils
	exports.default = function () {
	    return (0, _index2.default)({
	        containerComponent: _LineContainer2.default,
	        presentationalComponent: _LinePresentationalWrapper2.default,
	        tools: [_toolbarConstants.TOOLS.COLOR, _toolbarConstants.TOOLS.START_ARROW, _toolbarConstants.TOOLS.END_ARROW]
	    });
	};
	
	// Constants
	
	
	// Components

/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getArrowMarkerId = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lineUtil = __webpack_require__(201);
	
	var _lineUiConstants = __webpack_require__(738);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Utils
	var START_ARROW_MARKER_PATH = 'M' + _lineUiConstants.ARROW_WIDTH_UNITS + ',0 L0,' + _lineUiConstants.ARROW_HEIGHT_UNITS / 2 + ' L' + _lineUiConstants.ARROW_WIDTH_UNITS + ',' + _lineUiConstants.ARROW_HEIGHT_UNITS + ' z';
	
	// Constants
	// Lib
	
	var END_ARROW_MARKER_PATH = 'M0,0 L' + _lineUiConstants.ARROW_WIDTH_UNITS + ',' + _lineUiConstants.ARROW_HEIGHT_UNITS / 2 + ' L0,' + _lineUiConstants.ARROW_HEIGHT_UNITS + ' z';
	
	var getArrowMarkerId = exports.getArrowMarkerId = function getArrowMarkerId(_ref) {
	    var edge = _ref.edge,
	        elementId = _ref.elementId,
	        idSuffix = _ref.idSuffix;
	    return (0, _lodash.compact)(['arrow', edge, elementId, idSuffix]).join('-');
	};
	
	var ArrowMarker = function ArrowMarker(_ref2) {
	    var edge = _ref2.edge,
	        elementId = _ref2.elementId,
	        idSuffix = _ref2.idSuffix,
	        colorHex = _ref2.colorHex;
	
	    var path = (0, _lineUtil.isStartEdge)(edge) ? START_ARROW_MARKER_PATH : END_ARROW_MARKER_PATH;
	    var refX = (0, _lineUtil.isStartEdge)(edge) ? 1 : _lineUiConstants.ARROW_WIDTH_UNITS - 1;
	
	    return _react2.default.createElement(
	        'marker',
	        { id: getArrowMarkerId({ edge: edge, elementId: elementId, idSuffix: idSuffix }), className: 'arrow',
	            viewBox: '0 0 ' + _lineUiConstants.ARROW_WIDTH_UNITS + ' ' + _lineUiConstants.ARROW_HEIGHT_UNITS,
	            refX: refX, refY: _lineUiConstants.ARROW_HEIGHT_UNITS / 2,
	            markerWidth: _lineUiConstants.ARROW_WIDTH_UNITS, markerHeight: _lineUiConstants.ARROW_HEIGHT_UNITS,
	            orient: 'auto', markerUnits: 'strokeWidth', fill: colorHex },
	        _react2.default.createElement('path', { d: path })
	    );
	};
	
	ArrowMarker.propTypes = {
	    edge: _propTypes2.default.string.isRequired,
	    elementId: _propTypes2.default.string.isRequired,
	    idSuffix: _propTypes2.default.string,
	    colorHex: _propTypes2.default.string
	};
	
	exports.default = ArrowMarker;

/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bezierUtil = __webpack_require__(795);
	
	var _point = __webpack_require__(50);
	
	var pointsLib = _interopRequireWildcard(_point);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	// Utils
	
	
	var getLinePath = function getLinePath(_ref) {
	    var start = _ref.start,
	        end = _ref.end,
	        controlPoint = _ref.controlPoint;
	
	    if (!controlPoint || pointsLib.equals(start, controlPoint) || pointsLib.equals(end, controlPoint)) {
	        return 'M' + start.x + ' ' + start.y + ' ' + end.x + ' ' + end.y;
	    }
	
	    var quadraticControlPoint = (0, _bezierUtil.calculateQuadraticControlPoint)(start, end, controlPoint);
	    return 'M' + start.x + ' ' + start.y + ' Q ' + quadraticControlPoint.x + ' ' + quadraticControlPoint.y + ' ' + end.x + ' ' + end.y;
	};
	
	var LinePath = function (_React$Component) {
	    _inherits(LinePath, _React$Component);
	
	    function LinePath() {
	        _classCallCheck(this, LinePath);
	
	        return _possibleConstructorReturn(this, (LinePath.__proto__ || Object.getPrototypeOf(LinePath)).apply(this, arguments));
	    }
	
	    _createClass(LinePath, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                start = _props.start,
	                end = _props.end,
	                controlPoint = _props.controlPoint,
	                rest = _objectWithoutProperties(_props, ['start', 'end', 'controlPoint']);
	
	            return _react2.default.createElement('path', _extends({ d: getLinePath({ start: start, end: end, controlPoint: controlPoint }) }, rest));
	        }
	    }]);
	
	    return LinePath;
	}(_react2.default.Component);
	
	LinePath.propTypes = {
	    start: _propTypes2.default.object,
	    end: _propTypes2.default.object,
	    controlPoint: _propTypes2.default.object
	};
	
	exports.default = LinePath;

/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ArrowMarker = __webpack_require__(1995);
	
	var _ArrowMarker2 = _interopRequireDefault(_ArrowMarker);
	
	var _LinePath = __webpack_require__(1996);
	
	var _LinePath2 = _interopRequireDefault(_LinePath);
	
	var _propsComparisons = __webpack_require__(147);
	
	var _rafThrottle = __webpack_require__(245);
	
	var _rafThrottle2 = _interopRequireDefault(_rafThrottle);
	
	var _browser = __webpack_require__(61);
	
	var _lineConstants = __webpack_require__(57);
	
	var _lineUiConstants = __webpack_require__(738);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	// Components
	
	
	// Utils
	
	
	// Constants
	
	
	var NO_MARKER_ID = '';
	
	var startHasChanged = (0, _propsComparisons.hasChanged)('start');
	var endHasChanged = (0, _propsComparisons.hasChanged)('end');
	var controlPointHasChanged = (0, _propsComparisons.hasChanged)('controlPoint');
	
	var getSvgStyle = function getSvgStyle(bbox) {
	    return {
	        top: bbox.y - _lineUiConstants.INSET,
	        left: bbox.x - _lineUiConstants.INSET,
	        width: bbox.width + _lineUiConstants.LINE_HIT_AREA,
	        height: bbox.height + _lineUiConstants.LINE_HIT_AREA
	    };
	};
	
	/**
	 * Get the URL for given marker style.
	 */
	var getMarker = function getMarker(_ref) {
	    var edge = _ref.edge,
	        edgeStyle = _ref.edgeStyle,
	        elementId = _ref.elementId,
	        idSuffix = _ref.idSuffix;
	
	    switch (edgeStyle) {
	        case _lineConstants.LINE_MARKER_STYLE.ARROW:
	            return 'url(#' + (0, _ArrowMarker.getArrowMarkerId)({ edge: edge, elementId: elementId, idSuffix: idSuffix }) + ')';
	        default:
	            return NO_MARKER_ID;
	    }
	};
	
	var LineSvg = function (_React$Component) {
	    _inherits(LineSvg, _React$Component);
	
	    function LineSvg(props) {
	        _classCallCheck(this, LineSvg);
	
	        var _this = _possibleConstructorReturn(this, (LineSvg.__proto__ || Object.getPrototypeOf(LineSvg)).call(this, props));
	
	        _this.getLineBoundingBox = function () {
	            if (_this.props.isPresentational && !(0, _browser.isSafari)() || !_this.lineHitArea) return;
	
	            var linePath = _reactDom2.default.findDOMNode(_this.lineHitArea);
	
	            if (!linePath || !linePath.getBBox) return;
	
	            var bbox = linePath.getBBox();
	            _this.setState({ bbox: bbox });
	        };
	
	        _this.throttledGetLineBoundingBox = (0, _rafThrottle2.default)(_this.getLineBoundingBox);
	
	
	        _this.state = {
	            bbox: null
	        };
	        return _this;
	    }
	
	    _createClass(LineSvg, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.throttledGetLineBoundingBox();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(oldProps) {
	            if (startHasChanged(oldProps, this.props) || endHasChanged(oldProps, this.props) || controlPointHasChanged(oldProps, this.props)) {
	                this.throttledGetLineBoundingBox();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                elementEvents = _props.elementEvents,
	                start = _props.start,
	                controlPoint = _props.controlPoint,
	                end = _props.end,
	                colorHex = _props.colorHex,
	                elementId = _props.elementId,
	                idSuffix = _props.idSuffix,
	                startStyle = _props.startStyle,
	                endStyle = _props.endStyle,
	                isPresentational = _props.isPresentational,
	                enableDrag = _props.enableDrag,
	                disableDrag = _props.disableDrag;
	            var bbox = this.state.bbox;
	
	
	            var startMarker = getMarker({ edge: _lineConstants.LINE_EDGE.start, edgeStyle: startStyle, elementId: elementId, idSuffix: idSuffix });
	            var endMarker = getMarker({ edge: _lineConstants.LINE_EDGE.end, edgeStyle: endStyle, elementId: elementId, idSuffix: idSuffix });
	
	            // Transformations
	            var svgTranslation = null;
	            var groupTranslation = null;
	            if ((!isPresentational || (0, _browser.isSafari)()) && bbox) {
	                svgTranslation = getSvgStyle(bbox);
	                groupTranslation = 'translate(' + (-bbox.x + _lineUiConstants.INSET) + ',' + (-bbox.y + _lineUiConstants.INSET) + ')';
	            }
	
	            return _react2.default.createElement(
	                'svg',
	                { className: 'svg-line', version: '1.1',
	                    style: svgTranslation },
	                _react2.default.createElement(
	                    'defs',
	                    null,
	                    _react2.default.createElement(_ArrowMarker2.default, { edge: _lineConstants.LINE_EDGE.start, elementId: elementId, idSuffix: idSuffix, colorHex: colorHex }),
	                    _react2.default.createElement(_ArrowMarker2.default, { edge: _lineConstants.LINE_EDGE.end, elementId: elementId, idSuffix: idSuffix, colorHex: colorHex })
	                ),
	                _react2.default.createElement(
	                    'g',
	                    { transform: groupTranslation, stroke: colorHex },
	                    _react2.default.createElement(_LinePath2.default, { className: 'line-path',
	                        start: start, end: end,
	                        controlPoint: controlPoint,
	                        stroke: colorHex,
	                        markerStart: startMarker,
	                        markerEnd: endMarker }),
	                    _react2.default.createElement(_LinePath2.default, _extends({ className: 'line-hit-area',
	                        start: start, end: end, controlPoint: controlPoint,
	                        stroke: 'transparent',
	                        ref: function ref(c) {
	                            _this2.lineHitArea = c;
	                        },
	                        onMouseOver: enableDrag, onMouseOut: disableDrag
	                    }, elementEvents))
	                )
	            );
	        }
	    }]);
	
	    return LineSvg;
	}(_react2.default.Component);
	
	LineSvg.propTypes = {
	    elementId: _propTypes2.default.string.isRequired,
	    start: _propTypes2.default.object.isRequired,
	    end: _propTypes2.default.object.isRequired,
	    colorHex: _propTypes2.default.string,
	    elementEvents: _propTypes2.default.object,
	    idSuffix: _propTypes2.default.string,
	    startStyle: _propTypes2.default.string,
	    endStyle: _propTypes2.default.string,
	    gridSize: _propTypes2.default.number.isRequired,
	    controlPoint: _propTypes2.default.object,
	    isPresentational: _propTypes2.default.bool,
	    enableDrag: _propTypes2.default.func,
	    disableDrag: _propTypes2.default.func
	};
	
	exports.default = LineSvg;

/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class; // Lib
	
	
	// Utils
	
	
	// Drop target
	
	
	// Decorators
	
	
	// Actions
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(4);
	
	var _dontUpdateForKeys = __webpack_require__(206);
	
	var _dontUpdateForKeys2 = _interopRequireDefault(_dontUpdateForKeys);
	
	var _gridSizeSelector = __webpack_require__(66);
	
	var _elementCaptionUtil = __webpack_require__(137);
	
	var _fieldValidationService = __webpack_require__(488);
	
	var _fieldValidationService2 = _interopRequireDefault(_fieldValidationService);
	
	var _ColumnOnDropDropTarget = __webpack_require__(452);
	
	var _ColumnOnDropDropTarget2 = _interopRequireDefault(_ColumnOnDropDropTarget);
	
	var _columnOnDropConnectDropTarget = __webpack_require__(453);
	
	var _columnOnDropConnectDropTarget2 = _interopRequireDefault(_columnOnDropConnectDropTarget);
	
	var _elementLineEdgeDropTarget = __webpack_require__(200);
	
	var _elementLineEdgeDropTarget2 = _interopRequireDefault(_elementLineEdgeDropTarget);
	
	var _captionContainerDecorator = __webpack_require__(425);
	
	var _captionContainerDecorator2 = _interopRequireDefault(_captionContainerDecorator);
	
	var _linkActions = __webpack_require__(740);
	
	var _elementShortcutActions = __webpack_require__(455);
	
	var _Link = __webpack_require__(739);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        dispatchSetLinkElementUrl: function dispatchSetLinkElementUrl(id, url) {
	            return dispatch((0, _linkActions.setLinkElementUrl)({ id: id, url: url }));
	        },
	        dispatchMoveElementToTrash: function dispatchMoveElementToTrash(_ref) {
	            var isEditable = _ref.isEditable,
	                currentBoardId = _ref.currentBoardId;
	            return dispatch((0, _elementShortcutActions.moveElementToTrash)({ isEditable: isEditable, currentBoardId: currentBoardId }));
	        }
	    };
	};
	
	var LinkContainer = (_dec = (0, _reactRedux.connect)(_gridSizeSelector.gridSizeSelector, mapDispatchToProps), _dec2 = (0, _dontUpdateForKeys2.default)(['dragModifierKeys', 'canDrop']), _dec(_class = (0, _elementLineEdgeDropTarget2.default)(_class = (0, _ColumnOnDropDropTarget2.default)(_class = _dec2(_class = (0, _captionContainerDecorator2.default)(_class = function (_React$Component) {
	    _inherits(LinkContainer, _React$Component);
	
	    function LinkContainer(props) {
	        _classCallCheck(this, LinkContainer);
	
	        var _this = _possibleConstructorReturn(this, (LinkContainer.__proto__ || Object.getPrototypeOf(LinkContainer)).call(this, props));
	
	        _this.handleKey = function (event) {
	            if (!_this.props.isSelected) return;
	            if (event.target !== _this.container) return;
	            if (!_this.props.element.getIn(['content', 'link', 'url'])) return;
	            _this.props.captionKeyHandler(event, _this.props);
	        };
	
	        _this.setTempContent = _this.setTempContent.bind(_this);
	        _this.setLinkUrl = _this.setLinkUrl.bind(_this);
	        _this.moveElementToTrash = _this.moveElementToTrash.bind(_this);
	        return _this;
	    }
	
	    _createClass(LinkContainer, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(oldProps) {
	            // focus on mount
	            var url = this.props.element.getIn(['content', 'link', 'url']);
	            var oldUrl = oldProps.element.getIn(['content', 'link', 'url']);
	
	            var showCaption = (0, _elementCaptionUtil.getShowCaption)(this.props.element);
	            var oldShowCaption = (0, _elementCaptionUtil.getShowCaption)(oldProps.element);
	
	            if (url && !oldUrl) {
	                this.container.focus();
	            }
	
	            if (!showCaption && oldShowCaption) {
	                this.container.focus();
	            }
	        }
	    }, {
	        key: 'setTempContent',
	        value: function setTempContent(tempContent) {
	            var _props = this.props,
	                dispatchUpdateElement = _props.dispatchUpdateElement,
	                element = _props.element;
	
	
	            dispatchUpdateElement({
	                id: element.get('id'),
	                changes: { temp: tempContent },
	                sync: false,
	                transactionId: null
	            });
	        }
	    }, {
	        key: 'setLinkUrl',
	        value: function setLinkUrl(url) {
	            var _props2 = this.props,
	                dispatchSetLinkElementUrl = _props2.dispatchSetLinkElementUrl,
	                element = _props2.element;
	
	
	            var validationError = (0, _fieldValidationService2.default)(url, { type: 'url', allowIPAddress: true, required: true });
	
	            if (validationError) return validationError;
	            dispatchSetLinkElementUrl(element.get('id'), url);
	        }
	    }, {
	        key: 'moveElementToTrash',
	        value: function moveElementToTrash() {
	            this.props.dispatchMoveElementToTrash(this.props);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                connectLineEdgeDropTarget = _props3.connectLineEdgeDropTarget,
	                inList = _props3.inList;
	
	
	            var lineEdgeConnector = connectLineEdgeDropTarget && !inList ? connectLineEdgeDropTarget : _lodash.identity;
	
	            return (0, _columnOnDropConnectDropTarget2.default)(this.props, lineEdgeConnector(_react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'LinkContainer',
	                        ref: function ref(c) {
	                            _this2.container = c;
	                        },
	                        onKeyDown: this.handleKey,
	                        tabIndex: '-1' },
	                    _react2.default.createElement(_Link2.default, _extends({}, this.props, { setLinkUrl: this.setLinkUrl, setTempContent: this.setTempContent,
	                        moveElementToTrash: this.moveElementToTrash }))
	                )
	            )));
	        }
	    }]);
	
	    return LinkContainer;
	}(_react2.default.Component)) || _class) || _class) || _class) || _class) || _class);
	exports.default = LinkContainer;
	
	
	LinkContainer.propTypes = {
	    element: _propTypes2.default.object.isRequired,
	    isEditing: _propTypes2.default.bool,
	    isSelected: _propTypes2.default.bool,
	    startEditing: _propTypes2.default.func,
	    stopEditing: _propTypes2.default.func,
	    dispatchShowCaption: _propTypes2.default.func,
	    dispatchSetLinkElementUrl: _propTypes2.default.func,
	    dispatchUpdateElement: _propTypes2.default.func,
	    dispatchMoveElementToTrash: _propTypes2.default.func,
	    connectDropTarget: _propTypes2.default.func,
	    connectLineEdgeDropTarget: _propTypes2.default.func,
	    inList: _propTypes2.default.string,
	    captionKeyHandler: _propTypes2.default.func
	};

/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _LinkInput = __webpack_require__(2000);
	
	var _LinkInput2 = _interopRequireDefault(_LinkInput);
	
	var _LinkStateDisplay = __webpack_require__(2002);
	
	var _LinkStateDisplay2 = _interopRequireDefault(_LinkStateDisplay);
	
	__webpack_require__(1216);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LinkURL = function LinkURL(_ref) {
	    var element = _ref.element;
	
	    var url = element.getIn(['content', 'link', 'url']);
	    return _react2.default.createElement(
	        'div',
	        { className: 'link-url' },
	        _react2.default.createElement(
	            'div',
	            null,
	            url
	        )
	    );
	};
	
	// Styles
	
	
	LinkURL.propTypes = {
	    element: _propTypes2.default.object
	};
	
	var LinkHeader = function LinkHeader(props) {
	    var isLoaded = props.element.getIn(['content', 'link', 'url']);
	
	    return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('LinkHeader', { loaded: isLoaded }) },
	        _react2.default.createElement(_LinkStateDisplay2.default, props),
	        !isLoaded ? _react2.default.createElement(_LinkInput2.default, props) : _react2.default.createElement(LinkURL, props)
	    );
	};
	
	LinkHeader.propTypes = {
	    element: _propTypes2.default.object
	};
	
	exports.default = LinkHeader;

/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lodash = __webpack_require__(4);
	
	var _domUtil = __webpack_require__(107);
	
	var _keyConstants = __webpack_require__(146);
	
	__webpack_require__(1217);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	// Utils
	
	
	// Constants
	
	
	// Styles
	
	
	var LinkInput = function (_React$Component) {
	    _inherits(LinkInput, _React$Component);
	
	    function LinkInput(props) {
	        _classCallCheck(this, LinkInput);
	
	        var _this = _possibleConstructorReturn(this, (LinkInput.__proto__ || Object.getPrototypeOf(LinkInput)).call(this, props));
	
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        _this.handleChange = _this.handleChange.bind(_this);
	        _this.handleKey = _this.handleKey.bind(_this);
	        _this.onClick = _this.onClick.bind(_this);
	        return _this;
	    }
	
	    _createClass(LinkInput, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _this2 = this;
	
	            var setTempContent = this.props.setTempContent;
	
	            // handle error
	
	            var url = this.props.element.getIn(['content', 'temp', 'url']);
	            var error = this.props.element.getIn(['content', 'temp', 'error']);
	
	            var nextError = nextProps.element.getIn(['content', 'temp', 'error']);
	
	            if (!error && nextError) {
	                _reactDom2.default.findDOMNode(this.refs.linkContainer).focus();
	
	                this.errorTime = setTimeout(function () {
	                    setTempContent({ error: null, url: url });
	                    _this2.errorTime = null;
	                }, 2000);
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(oldProps) {
	            var _this3 = this;
	
	            // focus on mount
	            var error = this.props.element.getIn(['content', 'temp', 'error']);
	            var oldError = oldProps.element.getIn(['content', 'temp', 'error']);
	
	            if (this.props.isEditing && !oldProps.isEditing || this.props.isSelected && !oldProps.isSelected) {
	                (0, _lodash.delay)(function () {
	                    return _this3.refs.linkInput.focus();
	                }, 10);
	            }
	
	            if (!this.props.isEditing && oldProps.isEditing || !this.props.isSelected && oldProps.isSelected) {
	                this.refs.linkInput && this.refs.linkInput.blur();
	
	                var url = this.props.element.getIn(['content', 'temp', 'url']);
	                if (url) this.handleSubmit();
	            }
	
	            if (!error && oldError && this.props.isSelected) {
	                this.refs.linkInput.focus();
	            }
	        }
	    }, {
	        key: 'onClick',
	        value: function onClick() {
	            this.props.startEditing();
	        }
	    }, {
	        key: 'handleSubmit',
	        value: function handleSubmit(event) {
	            event && event.preventDefault();
	            var url = this.props.element.getIn(['content', 'temp', 'url']);
	
	            var _props = this.props,
	                setLinkUrl = _props.setLinkUrl,
	                setTempContent = _props.setTempContent;
	
	            var validationResponse = setLinkUrl(url);
	
	            if (validationResponse) {
	                setTempContent({ error: validationResponse, url: url });
	            }
	
	            this.props.deselectAll();
	        }
	    }, {
	        key: 'handleChange',
	        value: function handleChange(event) {
	            var setTempContent = this.props.setTempContent;
	
	            setTempContent({ url: event.target.value });
	        }
	    }, {
	        key: 'handleKey',
	        value: function handleKey(event) {
	            event.stopPropagation();
	            var _props2 = this.props,
	                element = _props2.element,
	                setTempContent = _props2.setTempContent,
	                stopEditing = _props2.stopEditing,
	                moveElementToTrash = _props2.moveElementToTrash;
	
	
	            if (event.which === _keyConstants.KEY_CODES.ESC) {
	                return stopEditing();
	            }
	
	            var url = element.getIn(['content', 'temp', 'url']);
	            var error = element.getIn(['content', 'temp', 'error']);
	
	            if (!url && (event.which === _keyConstants.KEY_CODES.BACKSPACE || event.which === _keyConstants.KEY_CODES.DELETE)) {
	                event.preventDefault();
	                moveElementToTrash();
	            }
	
	            if (error) {
	                if (this.errorTime) {
	                    clearTimeout(this.errorTime);
	                    this.errorTime = null;
	                }
	
	                return setTempContent({ error: null, url: url });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props3 = this.props,
	                isSelected = _props3.isSelected,
	                element = _props3.element;
	
	            var url = element.getIn(['content', 'temp', 'url']);
	            var error = element.getIn(['content', 'temp', 'error']);
	            var fetching = element.getIn(['attachment', 'fetching']);
	
	            var inputError = _react2.default.createElement(
	                'div',
	                { className: 'error-message' },
	                error && error.get('message') || 'URL not found'
	            );
	
	            var input = _react2.default.createElement(
	                'div',
	                { className: 'input-wrapper', onMouseDown: _domUtil.stopPropagationOnly, onClick: this.onClick },
	                _react2.default.createElement('input', { onChange: this.handleChange,
	                    onKeyDown: this.handleKey,
	                    value: url || '',
	                    ref: 'linkInput',
	                    placeholder: 'Enter a URL...',
	                    autoComplete: 'off',
	                    autoCorrect: 'off',
	                    autoCapitalize: 'off',
	                    spellCheck: 'false',
	                    disabled: !isSelected || fetching })
	            );
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'LinkInput', onKeyDown: this.handleKey, ref: 'linkContainer', tabIndex: '-1' },
	                _react2.default.createElement(
	                    'form',
	                    { className: 'link-form', onSubmit: this.handleSubmit },
	                    error ? inputError : input
	                )
	            );
	        }
	    }]);
	
	    return LinkInput;
	}(_react2.default.Component);
	
	LinkInput.propTypes = {
	    element: _propTypes2.default.object,
	    isSelected: _propTypes2.default.bool,
	    isEditing: _propTypes2.default.bool,
	    setLinkUrl: _propTypes2.default.func,
	    setTempContent: _propTypes2.default.func,
	    startEditing: _propTypes2.default.func,
	    stopEditing: _propTypes2.default.func,
	    moveElementToTrash: _propTypes2.default.func,
	    deselectAll: _propTypes2.default.func
	};
	
	exports.default = LinkInput;

/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _domUtil = __webpack_require__(107);
	
	var _EditableTitle = __webpack_require__(228);
	
	var _EditableTitle2 = _interopRequireDefault(_EditableTitle);
	
	__webpack_require__(1218);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LinkMetadata = function LinkMetadata(props) {
	    var element = props.element,
	        isEditable = props.isEditable,
	        isSingleSelected = props.isSingleSelected,
	        isSelected = props.isSelected;
	
	    var linkData = element.getIn(['content', 'link']);
	
	    if (!linkData) return null;
	
	    var linkWrapper = _react2.default.createElement('a', { href: linkData.get('url'), target: '_blank', onClick: _domUtil.stopPropagationOnly });
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'LinkMetadata' },
	        _react2.default.createElement(_EditableTitle2.default, {
	            element: element,
	            elementId: element.get('id'),
	            isEditable: isEditable,
	            initialValue: linkData.get('title'),
	            maxLength: 500,
	            isSelected: isSelected,
	            wrapTitleElement: !isSingleSelected ? linkWrapper : null,
	            editorKey: 'LINK_TITLE' })
	    );
	};
	
	LinkMetadata.propTypes = {
	    element: _propTypes2.default.object.isRequired,
	    isEditable: _propTypes2.default.bool,
	    isSelected: _propTypes2.default.bool,
	    isSingleSelected: _propTypes2.default.bool
	};
	
	exports.default = LinkMetadata;

/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Spinner = __webpack_require__(65);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	__webpack_require__(1219);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LinkStateDisplay = function LinkStateDisplay(_ref) {
	    var element = _ref.element;
	
	    var fetching = !element.getIn(['content', 'link', 'url']) && element.getIn(['attachment', 'fetching']);
	    var error = element.getIn(['content', 'temp', 'error']);
	    var favicon = element.getIn(['content', 'link', 'favicon']);
	
	    var displayElement = _react2.default.createElement(_Icon2.default, { name: 'link-icon' });
	
	    if (error) {
	        displayElement = _react2.default.createElement(_Icon2.default, { name: 'link-fail' });
	    }
	
	    if (fetching) {
	        displayElement = _react2.default.createElement(_Spinner2.default, { show: true });
	    }
	
	    if (favicon) {
	        displayElement = _react2.default.createElement('img', { src: favicon, width: '16', height: '16' });
	    }
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'LinkStateDisplay' },
	        displayElement
	    );
	};
	
	LinkStateDisplay.propTypes = {
	    element: _propTypes2.default.object
	};
	
	exports.default = LinkStateDisplay;

/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _index = __webpack_require__(2274);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _Link = __webpack_require__(739);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _LinkContainer = __webpack_require__(1998);
	
	var _LinkContainer2 = _interopRequireDefault(_LinkContainer);
	
	var _toolbarConstants = __webpack_require__(129);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return (0, _index2.default)({
	        containerComponent: _LinkContainer2.default,
	        presentationalComponent: _Link2.default,
	        tools: [_toolbarConstants.TOOLS.RICH_TEXT, _toolbarConstants.TOOLS.COLOR, _toolbarConstants.TOOLS.ATTACHMENT, _extends({}, _toolbarConstants.TOOLS.CAPTION, { name: 'Description' })]
	    });
	};

/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gridUtils = __webpack_require__(42);
	
	var _ElementImage = __webpack_require__(437);
	
	var _ElementImage2 = _interopRequireDefault(_ElementImage);
	
	var _Spinner = __webpack_require__(65);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _mediaConstants = __webpack_require__(148);
	
	__webpack_require__(1220);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LinkImage = function LinkImage(_ref) {
	    var element = _ref.element,
	        gridSize = _ref.gridSize;
	
	    var linkData = element.getIn(['content', 'link']);
	    if (!linkData) return null;
	
	    var fetching = element.getIn(['attachment', 'fetching']);
	    var fetchingAttchment = linkData.get('hasAttachment') && fetching;
	    var showAttachment = element.getIn(['content', 'showAttachment']);
	
	    if (fetchingAttchment) {
	        return _react2.default.createElement(
	            'div',
	            { className: 'LinkImage loading' },
	            _react2.default.createElement(
	                'div',
	                { className: 'spinner-container' },
	                _react2.default.createElement(_Spinner2.default, { show: true })
	            )
	        );
	    }
	
	    if (!showAttachment) return null;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'LinkImage' },
	        _react2.default.createElement(_ElementImage2.default, {
	            element: element,
	            imageType: _mediaConstants.IMAGE_TYPES.ELEMENT,
	            size: (0, _gridUtils.gridPointsToPixels)(34, gridSize) })
	    );
	};
	
	LinkImage.propTypes = {
	    element: _react2.default.PropTypes.object,
	    gridSize: _react2.default.PropTypes.number
	};
	
	exports.default = LinkImage;

/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LinkImage = __webpack_require__(2004);
	
	var _LinkImage2 = _interopRequireDefault(_LinkImage);
	
	var _VideoMedia = __webpack_require__(2017);
	
	var _VideoMedia2 = _interopRequireDefault(_VideoMedia);
	
	var _RichMedia = __webpack_require__(457);
	
	var _RichMedia2 = _interopRequireDefault(_RichMedia);
	
	var _MapMedia = __webpack_require__(2014);
	
	var _MapMedia2 = _interopRequireDefault(_MapMedia);
	
	var _richMediaConstants = __webpack_require__(483);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LinkMedia = function LinkMedia(props) {
	    var element = props.element;
	
	
	    var mediaType = element.getIn(['content', 'mediaType']);
	
	    switch (mediaType) {
	        case _richMediaConstants.MEDIA_TYPES.VIDEO:
	            return _react2.default.createElement(_VideoMedia2.default, props);
	        case _richMediaConstants.MEDIA_TYPES.MAP:
	            return _react2.default.createElement(_MapMedia2.default, props);
	        case _richMediaConstants.MEDIA_TYPES.RICH:
	            return _react2.default.createElement(_RichMedia2.default, props);
	        default:
	            return _react2.default.createElement(_LinkImage2.default, props);
	    }
	};
	
	// Constants
	
	
	// Components
	// Lib
	
	
	LinkMedia.propTypes = {
	    element: _propTypes2.default.object.isRequired
	};
	
	exports.default = LinkMedia;

/***/ }),
/* 2006 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _index = __webpack_require__(47);
	
	var _Canvas = __webpack_require__(673);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	// Utils
	
	
	// Constants
	
	
	exports.default = function (DecoratedComponent) {
	    var ElementResizeDecorator = function (_React$Component) {
	        _inherits(ElementResizeDecorator, _React$Component);
	
	        function ElementResizeDecorator(props) {
	            _classCallCheck(this, ElementResizeDecorator);
	
	            var _this = _possibleConstructorReturn(this, (ElementResizeDecorator.__proto__ || Object.getPrototypeOf(ElementResizeDecorator)).call(this, props));
	
	            _this.setTempElementSize = function (size) {
	                _this.setState({ size: size });
	                _this.setIsResizing(true);
	            };
	
	            _this.setElementSize = function (size) {
	                var _this$props = _this.props,
	                    element = _this$props.element,
	                    dispatchUpdateElement = _this$props.dispatchUpdateElement;
	
	
	                _this.setState({ size: null });
	                dispatchUpdateElement({ id: element.get('id'), changes: { width: Math.round(size) } });
	                (0, _index.analyticsEvent)('resized-element');
	                _this.setIsResizing(false);
	            };
	
	            _this.setIsResizing = function (isResizing) {
	                if (_this.state.isResizing === isResizing) return;
	
	                _this.setState({ isResizing: isResizing });
	                var canvasElement = document.getElementById(_Canvas.CANVAS_ELEMENT_ID);
	                _this.state.isResizing ? canvasElement.classList.add('resizing-element') : canvasElement.classList.remove('resizing-element');
	            };
	
	            _this.state = { size: null, isResizing: false };
	            return _this;
	        }
	
	        /**
	         * A bit hacky, but prevents the need to pass a reference to the canvas down to every component.
	         */
	
	
	        _createClass(ElementResizeDecorator, [{
	            key: 'render',
	            value: function render() {
	                var _state = this.state,
	                    size = _state.size,
	                    isResizing = _state.isResizing;
	
	
	                return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, {
	                    tempSize: size,
	                    isResizing: isResizing,
	                    setElementSize: this.setElementSize,
	                    setTempElementSize: this.setTempElementSize }));
	            }
	        }]);
	
	        return ElementResizeDecorator;
	    }(_react2.default.Component);
	
	    ElementResizeDecorator.propTypes = {
	        element: _propTypes2.default.object,
	        dispatchUpdateElement: _propTypes2.default.func
	    };
	
	    return ElementResizeDecorator;
	};

/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _calculateElementSize = __webpack_require__(742);
	
	var _calculateElementSize2 = _interopRequireDefault(_calculateElementSize);
	
	var _elementConstants = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	exports.default = function (Component) {
	    var ElementResizeHandleMouse = function (_React$Component) {
	        _inherits(ElementResizeHandleMouse, _React$Component);
	
	        function ElementResizeHandleMouse() {
	            var _ref;
	
	            var _temp, _this, _ret;
	
	            _classCallCheck(this, ElementResizeHandleMouse);
	
	            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                args[_key] = arguments[_key];
	            }
	
	            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ElementResizeHandleMouse.__proto__ || Object.getPrototypeOf(ElementResizeHandleMouse)).call.apply(_ref, [this].concat(args))), _this), _this.onMouseMove = function (event) {
	                var _this$props = _this.props,
	                    setTempElementSize = _this$props.setTempElementSize,
	                    gridSize = _this$props.gridSize,
	                    element = _this$props.element,
	                    minWidth = _this$props.minWidth;
	
	                var elementSize = element.getIn(['content', 'width']);
	
	                event.preventDefault();
	                event.stopPropagation();
	
	                setTempElementSize(_this.getElementSize(_this.startX, event.clientX, elementSize, gridSize, minWidth));
	            }, _this.onMouseUp = function (event) {
	                var _this$props2 = _this.props,
	                    setElementSize = _this$props2.setElementSize,
	                    gridSize = _this$props2.gridSize,
	                    element = _this$props2.element,
	                    minWidth = _this$props2.minWidth;
	
	                var elementSize = element.getIn(['content', 'width']);
	
	                event.preventDefault();
	                event.stopPropagation();
	
	                document.removeEventListener('mousemove', _this.onMouseMove);
	                document.removeEventListener('mouseup', _this.onMouseUp);
	
	                setElementSize(_this.getElementSize(_this.startX, event.clientX, elementSize, gridSize, minWidth));
	            }, _this.onMouseDown = function (event) {
	                var setTempElementSize = _this.props.setTempElementSize;
	
	                if (!setTempElementSize) return;
	
	                event.preventDefault();
	                event.stopPropagation();
	
	                _this.startX = event.clientX;
	
	                document.addEventListener('mousemove', _this.startDragging);
	                document.addEventListener('mouseup', _this.cancelDragging);
	            }, _this.onDoubleClick = function (event) {
	                var _this$props3 = _this.props,
	                    setElementSize = _this$props3.setElementSize,
	                    gridSize = _this$props3.gridSize,
	                    element = _this$props3.element,
	                    defaultMaxWidth = _this$props3.defaultMaxWidth;
	
	
	                if (!setElementSize) return;
	
	                event.preventDefault();
	                event.stopPropagation();
	
	                var currentWidth = element.getIn(['content', 'width']);
	
	                if (currentWidth > _elementConstants.ELEMENT_DEFAULT_WIDTH) return setElementSize(_elementConstants.ELEMENT_DEFAULT_WIDTH);
	
	                return setElementSize((0, _lodash.max)([defaultMaxWidth / gridSize, _elementConstants.ELEMENT_DEFAULT_WIDTH]));
	            }, _this.getElementSize = function (startX, currentX, elementSize, gridSize, minWidth) {
	                var sizeChange = (currentX - startX) / gridSize;
	                return (0, _calculateElementSize2.default)(elementSize, sizeChange, minWidth);
	            }, _this.startDragging = function (event) {
	                document.removeEventListener('mousemove', _this.startDragging);
	                document.removeEventListener('mouseup', _this.cancelDragging);
	
	                document.addEventListener('mousemove', _this.onMouseMove);
	                document.addEventListener('mouseup', _this.onMouseUp);
	            }, _this.cancelDragging = function (event) {
	                document.removeEventListener('mousemove', _this.startDragging);
	                document.removeEventListener('mouseup', _this.cancelDragging);
	            }, _temp), _possibleConstructorReturn(_this, _ret);
	        }
	
	        _createClass(ElementResizeHandleMouse, [{
	            key: 'render',
	            value: function render() {
	                return _react2.default.createElement(Component, _extends({}, this.props, { onMouseDown: this.onMouseDown, onDoubleClick: this.onDoubleClick }));
	            }
	        }]);
	
	        return ElementResizeHandleMouse;
	    }(_react2.default.Component);
	
	    ElementResizeHandleMouse.propTypes = {
	        children: _propTypes2.default.node,
	        element: _propTypes2.default.object,
	        gridSize: _propTypes2.default.number,
	        inList: _propTypes2.default.string,
	        showHandle: _propTypes2.default.bool,
	        setElementSize: _propTypes2.default.func,
	        setTempElementSize: _propTypes2.default.func,
	        minWidth: _propTypes2.default.number,
	        defaultMaxWidth: _propTypes2.default.number
	    };
	
	    return ElementResizeHandleMouse;
	};

/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _calculateElementSize = __webpack_require__(742);
	
	var _calculateElementSize2 = _interopRequireDefault(_calculateElementSize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	exports.default = function (Component) {
	    var ElementResizeHandleTouch = function (_React$Component) {
	        _inherits(ElementResizeHandleTouch, _React$Component);
	
	        function ElementResizeHandleTouch() {
	            var _ref;
	
	            var _temp, _this, _ret;
	
	            _classCallCheck(this, ElementResizeHandleTouch);
	
	            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                args[_key] = arguments[_key];
	            }
	
	            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ElementResizeHandleTouch.__proto__ || Object.getPrototypeOf(ElementResizeHandleTouch)).call.apply(_ref, [this].concat(args))), _this), _this.onTouchMove = function (event) {
	                var _this$props = _this.props,
	                    setTempElementSize = _this$props.setTempElementSize,
	                    element = _this$props.element,
	                    minWidth = _this$props.minWidth;
	
	                var elementSize = element.getIn(['content', 'width']);
	
	                event.preventDefault();
	                event.stopPropagation();
	
	                if (event.touches.length < 2) return;
	
	                var gestureSize = _this.getGestureSize(event);
	                var sizeChange = gestureSize - _this.gestureSizeStart;
	
	                _this.elementSize = (0, _calculateElementSize2.default)(elementSize, sizeChange, minWidth);
	
	                setTempElementSize(_this.elementSize);
	            }, _this.onTouchEnd = function (event) {
	                var setElementSize = _this.props.setElementSize;
	
	
	                event.preventDefault();
	                event.stopPropagation();
	
	                document.removeEventListener('touchmove', _this.onTouchMove);
	                document.removeEventListener('touchend', _this.onTouchEnd);
	
	                setElementSize(_this.elementSize);
	            }, _this.onTouchStart = function (event) {
	                var setTempElementSize = _this.props.setTempElementSize;
	
	                if (!setTempElementSize) return;
	
	                event.preventDefault();
	
	                document.addEventListener('touchmove', _this.startTouchDragging);
	                document.addEventListener('touchend', _this.cancelTouchDragging);
	            }, _this.getGestureSize = function (event) {
	                var gridSize = _this.props.gridSize;
	
	
	                var touchA = event.touches.item(0);
	                var touchB = event.touches.item(1);
	
	                var dx = touchB.clientX - touchA.clientX;
	                var dy = touchB.clientY - touchA.clientY;
	
	                return Math.sqrt(dx * dx + dy * dy) / gridSize;
	            }, _this.startTouchDragging = function (event) {
	                if (event.touches.length < 2) return _this.cancelTouchDragging();
	
	                document.removeEventListener('touchmove', _this.startTouchDragging);
	                document.removeEventListener('touchend', _this.cancelTouchDragging);
	
	                _this.gestureSizeStart = _this.getGestureSize(event);
	
	                document.addEventListener('touchmove', _this.onTouchMove);
	                document.addEventListener('touchend', _this.onTouchEnd);
	            }, _this.cancelTouchDragging = function (event) {
	                document.removeEventListener('touchmove', _this.startTouchDragging);
	                document.removeEventListener('touchend', _this.cancelTouchDragging);
	            }, _temp), _possibleConstructorReturn(_this, _ret);
	        }
	
	        _createClass(ElementResizeHandleTouch, [{
	            key: 'render',
	            value: function render() {
	                return _react2.default.createElement(Component, _extends({}, this.props, { onTouchStart: this.onTouchStart }));
	            }
	        }]);
	
	        return ElementResizeHandleTouch;
	    }(_react2.default.Component);
	
	    ElementResizeHandleTouch.propTypes = {
	        children: _propTypes2.default.node,
	        element: _propTypes2.default.object,
	        gridSize: _propTypes2.default.number,
	        inList: _propTypes2.default.string,
	        showHandle: _propTypes2.default.bool,
	        setElementSize: _propTypes2.default.func,
	        setTempElementSize: _propTypes2.default.func,
	        minWidth: _propTypes2.default.number
	    };
	
	    return ElementResizeHandleTouch;
	};

/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RichMediaIFrameContent = __webpack_require__(2011);
	
	var _RichMediaIFrameContent2 = _interopRequireDefault(_RichMediaIFrameContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RichMediaContent = function RichMediaContent(props) {
	    var show = props.show;
	
	    if (!show) return null;
	
	    return _react2.default.createElement(_RichMediaIFrameContent2.default, props);
	};
	
	// Components
	// Lib
	
	
	RichMediaContent.propTypes = {
	    show: _propTypes2.default.bool
	};
	
	exports.default = RichMediaContent;

/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	__webpack_require__(1222);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	// Lib
	var RichMediaErrorOverlay = function RichMediaErrorOverlay(_ref) {
	    var show = _ref.show;
	
	    if (!show) return null;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'RichMediaErrorOverlay' },
	        _react2.default.createElement(_Icon2.default, { name: 'error-alert' }),
	        'Sorry, this media cannot be played'
	    );
	};
	
	// Styles
	
	
	RichMediaErrorOverlay.propTypes = {
	    show: _propTypes2.default.bool
	};
	
	exports.default = RichMediaErrorOverlay;

/***/ }),
/* 2011 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _createMarkup = __webpack_require__(467);
	
	var _createMarkup2 = _interopRequireDefault(_createMarkup);
	
	__webpack_require__(1223);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	// Utils
	
	
	// Styles
	
	
	var getIFramePlayerPadding = function getIFramePlayerPadding(mediaData) {
	    var ratio = mediaData.get('height') / mediaData.get('width');
	    return {
	        paddingBottom: Math.floor(ratio * 100) + '%'
	    };
	};
	
	var RichMediaIFrameContent = function (_React$Component) {
	    _inherits(RichMediaIFrameContent, _React$Component);
	
	    function RichMediaIFrameContent(props) {
	        _classCallCheck(this, RichMediaIFrameContent);
	
	        var _this = _possibleConstructorReturn(this, (RichMediaIFrameContent.__proto__ || Object.getPrototypeOf(RichMediaIFrameContent)).call(this, props));
	
	        _this.dispatchReady = function () {
	            if (_this.isReady) return;
	
	            _this.isReady = true;
	            _this.props.dispatchRichMediaReady();
	        };
	
	        _this.isReady = false;
	        return _this;
	    }
	
	    _createClass(RichMediaIFrameContent, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            // Wait two seconds before transitioning to the player in case the load event doesn't fire
	            this.mountTimer = (0, _lodash.delay)(this.dispatchReady, 2000);
	
	            if (!this.container) return;
	
	            var iFrame = this.container.querySelector('iframe.embedly-embed');
	            if (!iFrame) return;
	
	            iFrame.addEventListener('load', this.dispatchReady);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var mediaData = this.props.mediaData;
	
	
	            if (!mediaData) return null;
	
	            var iFrameContent = mediaData.get('html');
	
	            return _react2.default.createElement('div', { className: 'RichMediaIFrameContent', ref: function ref(c) {
	                    _this2.container = c;
	                },
	                style: getIFramePlayerPadding(mediaData),
	                dangerouslySetInnerHTML: (0, _createMarkup2.default)(iFrameContent) });
	        }
	    }]);
	
	    return RichMediaIFrameContent;
	}(_react2.default.Component);
	
	RichMediaIFrameContent.propTypes = {
	    mediaData: _propTypes2.default.object,
	    dispatchRichMediaReady: _propTypes2.default.func
	};
	
	exports.default = RichMediaIFrameContent;

/***/ }),
/* 2012 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _gridUtils = __webpack_require__(42);
	
	var _RichMediaPreviewOverlay = __webpack_require__(2013);
	
	var _RichMediaPreviewOverlay2 = _interopRequireDefault(_RichMediaPreviewOverlay);
	
	var _RichMediaErrorOverlay = __webpack_require__(2010);
	
	var _RichMediaErrorOverlay2 = _interopRequireDefault(_RichMediaErrorOverlay);
	
	var _Spinner = __webpack_require__(65);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _ResponsiveProgressiveBackgroundImage = __webpack_require__(1900);
	
	var _ResponsiveProgressiveBackgroundImage2 = _interopRequireDefault(_ResponsiveProgressiveBackgroundImage);
	
	var _mediaConstants = __webpack_require__(148);
	
	__webpack_require__(1224);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Constants
	
	
	// Components
	// Lib
	var getHeight = function getHeight(_ref) {
	    var mediaData = _ref.mediaData;
	
	    if (!mediaData) return;
	
	    var ratio = mediaData.get('height') / mediaData.get('width');
	
	    return {
	        paddingBottom: Math.floor(ratio * 100) + '%'
	    };
	};
	
	// Styles
	
	
	// Utils
	
	
	var RichMediaPreviewImage = function RichMediaPreviewImage(props) {
	    var imageData = props.imageData,
	        mediaData = props.mediaData,
	        width = props.width,
	        gridSize = props.gridSize,
	        onClick = props.onClick,
	        show = props.show,
	        showLoader = props.showLoader,
	        showError = props.showError,
	        previewIconName = props.previewIconName,
	        _props$OverlayCompone = props.OverlayComponent,
	        OverlayComponent = _props$OverlayCompone === undefined ? _RichMediaPreviewOverlay2.default : _props$OverlayCompone;
	
	
	    var widthPx = (0, _gridUtils.gridPointsToPixels)(width, gridSize);
	
	    if (!show) return null;
	
	    var imageElement = imageData ? _react2.default.createElement(_ResponsiveProgressiveBackgroundImage2.default, { imageType: _mediaConstants.IMAGE_TYPES.ELEMENT,
	        imageDetails: imageData, size: widthPx }) : null;
	
	    var previewImageClassNames = (0, _classnames2.default)('RichMediaPreviewImage', { loading: showLoader });
	
	    return _react2.default.createElement(
	        'div',
	        { className: previewImageClassNames, style: getHeight({ mediaData: mediaData, widthPx: widthPx }) },
	        imageElement,
	        _react2.default.createElement(OverlayComponent, { show: !showLoader && !showError, onClick: onClick, iconName: previewIconName }),
	        _react2.default.createElement(_Spinner2.default, { show: showLoader }),
	        _react2.default.createElement(_RichMediaErrorOverlay2.default, { show: showError })
	    );
	};
	
	RichMediaPreviewImage.propTypes = {
	    element: _propTypes2.default.object.isRequired,
	    imageData: _propTypes2.default.object,
	    mediaData: _propTypes2.default.object,
	    width: _propTypes2.default.number,
	    gridSize: _propTypes2.default.number,
	    enablePlayer: _propTypes2.default.func,
	    onClick: _propTypes2.default.func,
	    show: _propTypes2.default.bool,
	    showLoader: _propTypes2.default.bool,
	    showError: _propTypes2.default.bool,
	    previewIconName: _propTypes2.default.string,
	    OverlayComponent: _propTypes2.default.func
	};
	
	exports.default = RichMediaPreviewImage;

/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	__webpack_require__(1225);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	// Lib
	var RichMediaPreviewOverlay = function RichMediaPreviewOverlay(_ref) {
	    var onClick = _ref.onClick,
	        show = _ref.show,
	        _ref$iconName = _ref.iconName,
	        iconName = _ref$iconName === undefined ? 'play-arrow' : _ref$iconName;
	
	    if (!show) return null;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'RichMediaPreviewOverlay' },
	        _react2.default.createElement(
	            'div',
	            { className: 'circle-hit-area', onClick: onClick },
	            _react2.default.createElement(
	                'div',
	                { className: 'circle' },
	                _react2.default.createElement(_Icon2.default, { name: iconName })
	            )
	        )
	    );
	};
	
	// Styles
	
	
	RichMediaPreviewOverlay.propTypes = {
	    onClick: _propTypes2.default.func,
	    show: _propTypes2.default.bool,
	    iconName: _propTypes2.default.string
	};
	
	exports.default = RichMediaPreviewOverlay;

/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RichMedia = __webpack_require__(457);
	
	var _RichMedia2 = _interopRequireDefault(_RichMedia);
	
	var _MapPreviewOverlay = __webpack_require__(2015);
	
	var _MapPreviewOverlay2 = _interopRequireDefault(_MapPreviewOverlay);
	
	__webpack_require__(1226);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapMedia = function MapMedia(_ref) {
	    var element = _ref.element,
	        width = _ref.width,
	        gridSize = _ref.gridSize;
	    return _react2.default.createElement(_RichMedia2.default, { className: 'MapMedia', element: element, width: width, gridSize: gridSize,
	        OverlayComponent: _MapPreviewOverlay2.default });
	};
	
	// Styles
	
	
	// Components
	// Lib
	
	
	MapMedia.propTypes = {
	    element: _propTypes2.default.object.isRequired,
	    width: _propTypes2.default.number,
	    gridSize: _propTypes2.default.number
	};
	
	exports.default = MapMedia;

/***/ }),
/* 2015 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(1227);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapPreviewOverlay = function MapPreviewOverlay(_ref) {
	    var onClick = _ref.onClick,
	        show = _ref.show;
	
	    if (!show) return null;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'MapPreviewOverlay' },
	        _react2.default.createElement(
	            'div',
	            { className: 'launch-button-hit-area', onClick: onClick },
	            _react2.default.createElement(
	                'div',
	                { className: 'launch-button' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 'launch-text' },
	                    'Enable map'
	                )
	            )
	        )
	    );
	};
	
	// Styles
	// Lib
	
	
	MapPreviewOverlay.propTypes = {
	    onClick: _propTypes2.default.func,
	    show: _propTypes2.default.bool
	};
	
	exports.default = MapPreviewOverlay;

/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _player = __webpack_require__(1447);
	
	var PlayerJS = _interopRequireWildcard(_player);
	
	var _createMarkup = __webpack_require__(467);
	
	var _createMarkup2 = _interopRequireDefault(_createMarkup);
	
	__webpack_require__(1228);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	// eslint-disable-line no-unused-vars
	
	// Utils
	
	
	// Styles
	
	
	var getIFramePlayerPadding = function getIFramePlayerPadding(videoData) {
	    var ratio = videoData.get('height') / videoData.get('width');
	    return {
	        paddingBottom: Math.floor(ratio * 100) + '%'
	    };
	};
	
	var IFrameVideoPlayer = function (_React$Component) {
	    _inherits(IFrameVideoPlayer, _React$Component);
	
	    function IFrameVideoPlayer(props) {
	        _classCallCheck(this, IFrameVideoPlayer);
	
	        var _this = _possibleConstructorReturn(this, (IFrameVideoPlayer.__proto__ || Object.getPrototypeOf(IFrameVideoPlayer)).call(this, props));
	
	        _this.cancelTimers = function () {
	            _this.mountTimer && clearTimeout(_this.mountTimer);
	            _this.readyTimer && clearTimeout(_this.readyTimer);
	        };
	
	        _this.dispatchPlayerReady = function () {
	            if (_this.isReady) return;
	
	            _this.isReady = true;
	            _this.props.dispatchRichMediaReady();
	        };
	
	        _this.isReady = false;
	        return _this;
	    }
	
	    _createClass(IFrameVideoPlayer, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatchRichMediaError = _props.dispatchRichMediaError,
	                videoData = _props.videoData;
	
	
	            if (!videoData) {
	                dispatchRichMediaError();
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            if (!this.container) return;
	
	            var iFrame = this.container.querySelector('iframe.embedly-embed');
	            var player = new playerjs.Player(iFrame); // eslint-disable-line no-undef
	
	            // Wait a second before transitioning to the player in case the player does not
	            // support the 'ready' event
	            this.mountTimer = (0, _lodash.delay)(this.dispatchPlayerReady, 2000);
	
	            player.on('ready', function () {
	                _this2.cancelTimers();
	
	                // Wait at most 1.5 seconds before transitioning to the player in case the player does not
	                // support the 'play' event
	                _this2.readyTimer = (0, _lodash.delay)(_this2.dispatchPlayerReady, 2000);
	
	                player.on('play', _this2.dispatchPlayerReady);
	                player.on('ended', _this2.props.dispatchRichMediaReturnToPreview);
	                player.on('error', _this2.props.dispatchRichMediaError);
	            });
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            return false;
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.cancelTimers();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var videoData = this.props.videoData;
	
	
	            if (!videoData) return null;
	
	            return _react2.default.createElement('div', { ref: function ref(c) {
	                    _this3.container = c;
	                },
	                className: 'IFrameVideoPlayer',
	                style: getIFramePlayerPadding(videoData),
	                dangerouslySetInnerHTML: (0, _createMarkup2.default)(videoData.get('html')) });
	        }
	    }]);
	
	    return IFrameVideoPlayer;
	}(_react2.default.Component);
	
	IFrameVideoPlayer.propTypes = {
	    videoData: _propTypes2.default.object.isRequired,
	    dispatchRichMediaReady: _propTypes2.default.func,
	    dispatchRichMediaReturnToPreview: _propTypes2.default.func,
	    dispatchRichMediaError: _propTypes2.default.func
	};
	
	exports.default = IFrameVideoPlayer;

/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RichMedia = __webpack_require__(457);
	
	var _RichMedia2 = _interopRequireDefault(_RichMedia);
	
	var _VideoPlayer = __webpack_require__(2018);
	
	var _VideoPlayer2 = _interopRequireDefault(_VideoPlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	// Lib
	var VideoMedia = function VideoMedia(_ref) {
	    var element = _ref.element,
	        width = _ref.width,
	        gridSize = _ref.gridSize;
	    return _react2.default.createElement(_RichMedia2.default, { element: element, width: width, gridSize: gridSize, ContentComponent: _VideoPlayer2.default });
	};
	
	VideoMedia.propTypes = {
	    element: _propTypes2.default.object.isRequired,
	    width: _propTypes2.default.number,
	    gridSize: _propTypes2.default.number
	};
	
	exports.default = VideoMedia;

/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _IFrameVideoPlayer = __webpack_require__(2016);
	
	var _IFrameVideoPlayer2 = _interopRequireDefault(_IFrameVideoPlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VideoPlayer = function VideoPlayer(props) {
	    var element = props.element,
	        dispatchRichMediaReady = props.dispatchRichMediaReady,
	        dispatchRichMediaReturnToPreview = props.dispatchRichMediaReturnToPreview,
	        dispatchRichMediaError = props.dispatchRichMediaError,
	        _props$show = props.show,
	        show = _props$show === undefined ? false : _props$show;
	
	
	    if (!show) return null;
	
	    var videoData = element.getIn(['content', 'media']);
	
	    // At this stage we're only supporting Embedly videos
	    return _react2.default.createElement(
	        'div',
	        { className: 'VideoPlayer' },
	        _react2.default.createElement(_IFrameVideoPlayer2.default, { videoData: videoData,
	            dispatchRichMediaError: dispatchRichMediaError,
	            dispatchRichMediaReturnToPreview: dispatchRichMediaReturnToPreview,
	            dispatchRichMediaReady: dispatchRichMediaReady })
	    );
	};
	
	// Components
	// Lib
	
	
	VideoPlayer.propTypes = {
	    element: _propTypes2.default.object.isRequired,
	    show: _propTypes2.default.bool,
	    render: _propTypes2.default.bool,
	    dispatchRichMediaReady: _propTypes2.default.func,
	    dispatchRichMediaReturnToPreview: _propTypes2.default.func,
	    dispatchRichMediaError: _propTypes2.default.func
	};
	
	exports.default = VideoPlayer;

/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.richMediaError = exports.richMediaReady = exports.richMediaEmbedding = exports.richMediaReturnToPreview = undefined;
	
	var _richMediaConstants = __webpack_require__(304);
	
	var richMediaReturnToPreview = exports.richMediaReturnToPreview = function richMediaReturnToPreview(id) {
	    return {
	        id: id,
	        type: _richMediaConstants.RICH_MEDIA_RETURN_TO_PREVIEW
	    };
	};
	
	var richMediaEmbedding = exports.richMediaEmbedding = function richMediaEmbedding(id) {
	    return {
	        id: id,
	        type: _richMediaConstants.RICH_MEDIA_EMBEDDING
	    };
	};
	
	var richMediaReady = exports.richMediaReady = function richMediaReady(id) {
	    return {
	        id: id,
	        type: _richMediaConstants.RICH_MEDIA_READY
	    };
	};
	
	var richMediaError = exports.richMediaError = function richMediaError(id) {
	    return {
	        id: id,
	        type: _richMediaConstants.RICH_MEDIA_ERROR
	    };
	};

/***/ }),
/* 2020 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reselect = __webpack_require__(7);
	
	var _richMediaSelector = __webpack_require__(2023);
	
	var _richMediaActions = __webpack_require__(2019);
	
	var _richMediaConstants = __webpack_require__(304);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	// Selectors
	
	
	// Actions
	
	
	// Constants
	
	
	var mapStateToProps = (0, _reselect.createSelector)(function (state, ownProps) {
	    return ownProps.element.get('id');
	}, _richMediaSelector.getRichMediaState, function (id, richMediaState) {
	    var contentState = (0, _richMediaSelector.getRichMediaContentState)(id, richMediaState);
	    var embeddingRichMedia = contentState === _richMediaConstants.RICH_MEDIA_STATE.EMBEDDING;
	    var showRichMedia = embeddingRichMedia || contentState === _richMediaConstants.RICH_MEDIA_STATE.READY;
	    var showError = contentState === _richMediaConstants.RICH_MEDIA_STATE.ERROR;
	    var showPreview = !contentState || contentState === _richMediaConstants.RICH_MEDIA_STATE.PREVIEW || embeddingRichMedia || showError;
	
	    return {
	        contentState: contentState,
	        showPreview: showPreview,
	        embeddingRichMedia: embeddingRichMedia,
	        showRichMedia: showRichMedia,
	        showError: showError
	    };
	});
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        dispatchRichMediaEmbedding: function dispatchRichMediaEmbedding(id) {
	            return dispatch((0, _richMediaActions.richMediaEmbedding)(id));
	        },
	        dispatchRichMediaReady: function dispatchRichMediaReady(id) {
	            return dispatch((0, _richMediaActions.richMediaReady)(id));
	        },
	        dispatchRichMediaError: function dispatchRichMediaError(id) {
	            return dispatch((0, _richMediaActions.richMediaError)(id));
	        },
	        dispatchRichMediaReturnToPreview: function dispatchRichMediaReturnToPreview(id) {
	            return dispatch((0, _richMediaActions.richMediaReturnToPreview)(id));
	        }
	    };
	};
	
	exports.default = function (DecoratedComponent) {
	    var _dec, _class;
	
	    var richMediaConnectDecorator = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_React$Component) {
	        _inherits(richMediaConnectDecorator, _React$Component);
	
	        function richMediaConnectDecorator() {
	            var _ref;
	
	            var _temp, _this, _ret;
	
	            _classCallCheck(this, richMediaConnectDecorator);
	
	            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                args[_key] = arguments[_key];
	            }
	
	            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = richMediaConnectDecorator.__proto__ || Object.getPrototypeOf(richMediaConnectDecorator)).call.apply(_ref, [this].concat(args))), _this), _this.dispatchRichMediaEmbedding = function () {
	                return _this.dispatchMediaUpdateFn(_this.props.dispatchRichMediaEmbedding);
	            }, _this.dispatchRichMediaReady = function () {
	                return _this.dispatchMediaUpdateFn(_this.props.dispatchRichMediaReady);
	            }, _this.dispatchRichMediaError = function () {
	                return _this.dispatchMediaUpdateFn(_this.props.dispatchRichMediaError);
	            }, _this.dispatchRichMediaReturnToPreview = function () {
	                return _this.dispatchMediaUpdateFn(_this.props.dispatchRichMediaReturnToPreview);
	            }, _this.dispatchMediaUpdateFn = function (fn) {
	                var element = _this.props.element;
	
	                var id = element.get('id');
	                return fn(id);
	            }, _temp), _possibleConstructorReturn(_this, _ret);
	        }
	
	        _createClass(richMediaConnectDecorator, [{
	            key: 'render',
	            value: function render() {
	                return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, {
	                    dispatchRichMediaEmbedding: this.dispatchRichMediaEmbedding,
	                    dispatchRichMediaReady: this.dispatchRichMediaReady,
	                    dispatchRichMediaError: this.dispatchRichMediaError,
	                    dispatchRichMediaReturnToPreview: this.dispatchRichMediaReturnToPreview }));
	            }
	        }]);
	
	        return richMediaConnectDecorator;
	    }(_react2.default.Component)) || _class);
	
	
	    richMediaConnectDecorator.propTypes = {
	        element: _propTypes2.default.object.isRequired,
	        showPreview: _propTypes2.default.bool,
	        dispatchRichMediaEmbedding: _propTypes2.default.func,
	        dispatchRichMediaReady: _propTypes2.default.func,
	        dispatchRichMediaError: _propTypes2.default.func,
	        dispatchRichMediaReturnToPreview: _propTypes2.default.func
	    };
	
	    return richMediaConnectDecorator;
	};

/***/ }),
/* 2021 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRouterRedux = __webpack_require__(82);
	
	var _richMediaConstants = __webpack_require__(304);
	
	var _draggingConstants = __webpack_require__(143);
	
	// Constants
	var initialState = _richMediaConstants.RICH_MEDIA_STATE.PREVIEW; // Lib
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _richMediaConstants.RICH_MEDIA_EMBEDDING:
	            return _richMediaConstants.RICH_MEDIA_STATE.EMBEDDING;
	        case _richMediaConstants.RICH_MEDIA_READY:
	            return _richMediaConstants.RICH_MEDIA_STATE.READY;
	        case _richMediaConstants.RICH_MEDIA_ERROR:
	            return _richMediaConstants.RICH_MEDIA_STATE.ERROR;
	        case _richMediaConstants.RICH_MEDIA_RETURN_TO_PREVIEW:
	        case _draggingConstants.DRAG_START:
	        case _reactRouterRedux.LOCATION_CHANGE:
	            return initialState;
	        default:
	            return state;
	    }
	};

/***/ }),
/* 2022 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxImmutable = __webpack_require__(73);
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _reactRouterRedux = __webpack_require__(82);
	
	var _richMediaContentStateReducer = __webpack_require__(2021);
	
	var _richMediaContentStateReducer2 = _interopRequireDefault(_richMediaContentStateReducer);
	
	var _richMediaConstants = __webpack_require__(304);
	
	var _draggingConstants = __webpack_require__(143);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Constants
	// Lib
	var individualRichMediaReducer = (0, _reduxImmutable.combineReducers)({
	    contentState: _richMediaContentStateReducer2.default
	});
	
	// Reducers
	
	
	var updateId = function updateId(state, action, id) {
	    return state.update(id, function (currIdState) {
	        return individualRichMediaReducer(currIdState, action);
	    });
	};
	var delegateToId = function delegateToId(state, action) {
	    return updateId(state, action, action.id);
	};
	
	var delegateToAllIds = function delegateToAllIds(state, action) {
	    return state.withMutations(function (mutableState) {
	        return action.ids && action.ids.forEach(function (id) {
	            return updateId(mutableState, action, id);
	        });
	    });
	};
	
	var delegateToAllEntries = function delegateToAllEntries(state, action) {
	    return state.withMutations(function (mutableState) {
	        return mutableState.forEach(function (val, id) {
	            return updateId(mutableState, action, id);
	        });
	    });
	};
	
	// The rich media state is a map of ID to { contentState }
	var initialState = Immutable.Map();
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _richMediaConstants.RICH_MEDIA_EMBEDDING:
	        case _richMediaConstants.RICH_MEDIA_ERROR:
	        case _richMediaConstants.RICH_MEDIA_READY:
	        case _richMediaConstants.RICH_MEDIA_RETURN_TO_PREVIEW:
	            return delegateToId(state, action);
	        case _draggingConstants.DRAG_START:
	            return delegateToAllIds(state, action);
	        case _reactRouterRedux.LOCATION_CHANGE:
	            return delegateToAllEntries(state, action);
	        default:
	            return state;
	    }
	};

/***/ }),
/* 2023 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getRichMediaState = exports.getRichMediaState = function getRichMediaState(state, ownProps) {
	  return state.getIn(['app', 'richMedia']);
	};
	var getRichMediaContentState = exports.getRichMediaContentState = function getRichMediaContentState(id, richMediaState) {
	  return richMediaState.getIn([id, 'contentState']);
	};

/***/ }),
/* 2024 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = currentlyEditing;
	
	var _selectionConstants = __webpack_require__(77);
	
	var SELECTION_ACTION_TYPES = _interopRequireWildcard(_selectionConstants);
	
	var _draggingConstants = __webpack_require__(143);
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialState = Immutable.fromJS({
	    id: null
	});
	
	/**
	 * When an element is selected, check if it's the same element that's being edited, otherwise stop editing.
	 */
	var handleElementSelect = function handleElementSelect(state, action) {
	    var currentlyEditingId = state.get('id');
	    return currentlyEditingId && action.ids.length === 1 && action.ids.indexOf(currentlyEditingId) !== -1 ? state : initialState;
	};
	
	function currentlyEditing() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case SELECTION_ACTION_TYPES.ELEMENT_EDIT_START:
	            return state.merge({
	                id: action.id,
	                editorKey: action.editorKey
	            });
	        case SELECTION_ACTION_TYPES.ELEMENT_SET_EDIT_HANDLER:
	            return state.merge({
	                id: action.id,
	                editorKey: action.editorKey
	            });
	        case SELECTION_ACTION_TYPES.ELEMENT_EDIT_COMPLETE:
	            return initialState;
	        case SELECTION_ACTION_TYPES.ELEMENTS_SELECTED:
	            return handleElementSelect(state, action);
	        case _draggingConstants.DRAG_START:
	            return initialState;
	        default:
	            return state;
	    }
	}

/***/ }),
/* 2025 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = selection;
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _lodash = __webpack_require__(4);
	
	var _selectionConstants = __webpack_require__(77);
	
	var SELECTION_ACTION_TYPES = _interopRequireWildcard(_selectionConstants);
	
	var _undoRedoConstants = __webpack_require__(473);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Constants
	// Lib
	var initialState = Immutable.fromJS({
	    ids: [],
	    keepSelection: false
	});
	
	function selection() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case SELECTION_ACTION_TYPES.ELEMENTS_SELECTED:
	            return state.update('ids', function (ids) {
	                return ids.concat(action.ids);
	            });
	        case SELECTION_ACTION_TYPES.ELEMENTS_DESELECTED:
	            return state.update('ids', function (ids) {
	                return ids.filterNot(function (id) {
	                    return (0, _lodash.includes)(action.ids, id);
	                });
	            });
	        case SELECTION_ACTION_TYPES.ELEMENTS_DESELECT_ALL:
	        case '@@router/LOCATION_CHANGE':
	            return state.get('keepSelection') ? state : initialState;
	        case _undoRedoConstants.START_OPERATION:
	            return state.set('keepSelection', true);
	        case _undoRedoConstants.END_OPERATION:
	            return state.set('keepSelection', false);
	        default:
	            return state;
	    }
	}

/***/ }),
/* 2026 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	__webpack_require__(1229);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmptyInboxPlaceholder = function EmptyInboxPlaceholder(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'EmptyInboxPlaceholder' },
	        _react2.default.createElement(
	            'div',
	            { className: 'inbox-placeholder-content' },
	            _react2.default.createElement(
	                'div',
	                { className: 'inbox-icon' },
	                _react2.default.createElement(_Icon2.default, { name: 'inbox-empty' })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'inbox-description' },
	                'A place to put things while you decide where they should go'
	            )
	        )
	    );
	};
	
	EmptyInboxPlaceholder.propTypes = {
	    isHovered: _propTypes2.default.bool
	};
	
	exports.default = EmptyInboxPlaceholder;

/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _reselect = __webpack_require__(7);
	
	var _milanoteReselect = __webpack_require__(49);
	
	var _elementSelector = __webpack_require__(41);
	
	var _List = __webpack_require__(744);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _InboxHeader = __webpack_require__(743);
	
	var _InboxHeader2 = _interopRequireDefault(_InboxHeader);
	
	var _EmptyInboxPlaceholder = __webpack_require__(2026);
	
	var _EmptyInboxPlaceholder2 = _interopRequireDefault(_EmptyInboxPlaceholder);
	
	var _gridUtils = __webpack_require__(42);
	
	var _inboxConstants = __webpack_require__(234);
	
	__webpack_require__(1230);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var inboxElementsSelector = (0, _milanoteReselect.createShallowSelector)(function (state, ownProps) {
	    return ownProps.inboxElementIds;
	}, _elementSelector.getElements, function (inboxElementIds, elements) {
	    return inboxElementIds.map(function (elId) {
	        return elements.get(elId);
	    });
	});
	
	var mapStateToProps = (0, _reselect.createSelector)(inboxElementsSelector, function (inboxElements, elements) {
	    return { inboxElements: Immutable.List(inboxElements) };
	});
	
	var Inbox = function Inbox(props) {
	    var inboxElements = props.inboxElements,
	        currentBoardId = props.currentBoardId,
	        deselectAll = props.deselectAll,
	        gridSize = props.gridSize;
	
	    var emptyInboxPlaceholder = _react2.default.createElement(_EmptyInboxPlaceholder2.default, props);
	
	    return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('Inbox', { empty: inboxElements.size === 0 }),
	            onClick: deselectAll,
	            style: (0, _gridUtils.getElementStyle)(_inboxConstants.INBOX_WIDTH, gridSize) },
	        _react2.default.createElement(
	            'div',
	            { className: 'inbox-header' },
	            _react2.default.createElement(_InboxHeader2.default, props)
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'list-scrollable' },
	            _react2.default.createElement(_List2.default, _extends({}, props, {
	                readyToMeasure: true,
	                listId: currentBoardId,
	                children: inboxElements,
	                placeholderComponent: emptyInboxPlaceholder,
	                inListClass: 'in-list-inbox' }))
	        )
	    );
	};
	
	Inbox.propTypes = {
	    currentBoardId: _propTypes2.default.string,
	    onDrop: _propTypes2.default.func,
	    inboxElementIds: _propTypes2.default.array,
	    inboxElements: _propTypes2.default.object,
	    deselectAll: _propTypes2.default.func,
	    gridSize: _propTypes2.default.number
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Inbox);

/***/ }),
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class; // Lib
	
	
	// Component
	
	
	// Drop Utils
	
	
	// Constants
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(34);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ElementDropTarget = __webpack_require__(168);
	
	var _ElementDropTarget2 = _interopRequireDefault(_ElementDropTarget);
	
	var _makeCanDropFn = __webpack_require__(300);
	
	var _makeCanDropFn2 = _interopRequireDefault(_makeCanDropFn);
	
	var _preventDropOnSelfPredicate = __webpack_require__(454);
	
	var _preventDropOnSelfPredicate2 = _interopRequireDefault(_preventDropOnSelfPredicate);
	
	var _preventLinePredicate = __webpack_require__(301);
	
	var _preventLinePredicate2 = _interopRequireDefault(_preventLinePredicate);
	
	var _elementConstants = __webpack_require__(12);
	
	__webpack_require__(1231);
	
	var _inboxDropLocationFn = __webpack_require__(459);
	
	var _inboxDropLocationFn2 = _interopRequireDefault(_inboxDropLocationFn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var dropTargetConfig = {
	    drop: _inboxDropLocationFn2.default,
	    canDrop: (0, _makeCanDropFn2.default)([_preventDropOnSelfPredicate2.default, _preventLinePredicate2.default])
	};
	
	var InboxClosed = (_dec = (0, _ElementDropTarget2.default)(dropTargetConfig, _elementConstants.DROP_TARGET_TYPES.INBOX_CLOSED), _dec(_class = function (_React$Component) {
	    _inherits(InboxClosed, _React$Component);
	
	    function InboxClosed() {
	        _classCallCheck(this, InboxClosed);
	
	        return _possibleConstructorReturn(this, (InboxClosed.__proto__ || Object.getPrototypeOf(InboxClosed)).apply(this, arguments));
	    }
	
	    _createClass(InboxClosed, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                openInboxHandler = _props.openInboxHandler,
	                inboxElementIds = _props.inboxElementIds,
	                connectDropTarget = _props.connectDropTarget,
	                isHovered = _props.isHovered;
	
	            return connectDropTarget(_react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('InboxClosed', { hovered: isHovered, empty: inboxElementIds.length === 0 }) },
	                _react2.default.createElement(
	                    _Button2.default,
	                    { onClickFn: openInboxHandler },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            'Unsorted '
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'count' },
	                            inboxElementIds.length
	                        )
	                    )
	                )
	            ));
	        }
	    }]);
	
	    return InboxClosed;
	}(_react2.default.Component)) || _class);
	exports.default = InboxClosed;
	
	
	InboxClosed.propTypes = {
	    currentBoardId: _propTypes2.default.string,
	    openInboxHandler: _propTypes2.default.func,
	    connectDropTarget: _propTypes2.default.func,
	    inboxElementIds: _propTypes2.default.array,
	    isHovered: _propTypes2.default.bool
	};

/***/ }),
/* 2029 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class; // Lib
	
	
	// Selectors
	
	
	// Components
	
	
	// Actions
	
	
	// Constants
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _recompose = __webpack_require__(9);
	
	var _reselect = __webpack_require__(7);
	
	var _boardSelector = __webpack_require__(83);
	
	var _Inbox = __webpack_require__(2027);
	
	var _Inbox2 = _interopRequireDefault(_Inbox);
	
	var _InboxClosed = __webpack_require__(2028);
	
	var _InboxClosed2 = _interopRequireDefault(_InboxClosed);
	
	var _inboxActions = __webpack_require__(305);
	
	var _selectionActions = __webpack_require__(55);
	
	var _inboxConstants = __webpack_require__(234);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* Redux property connectors. */
	var mapStateToProps = (0, _reselect.createSelector)(_boardSelector.getIsCurrentBoardFetched, _boardSelector.getCurrentBoardInboxState, function (isCurrentBoardFetched, currentBoardInboxState) {
	    return {
	        inboxState: isCurrentBoardFetched && currentBoardInboxState || _inboxConstants.INBOX_STATE.CLOSED
	    };
	});
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        dispatchCloseInbox: function dispatchCloseInbox(id) {
	            return dispatch((0, _inboxActions.closeInbox)({ id: id }));
	        },
	        dispatchOpenInbox: function dispatchOpenInbox(id) {
	            return dispatch((0, _inboxActions.openInbox)({ id: id }));
	        },
	        deselectAll: function deselectAll(event) {
	            return dispatch((0, _selectionActions.deselectAllElements)());
	        }
	    };
	};
	
	var InboxContainer = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_React$Component) {
	    _inherits(InboxContainer, _React$Component);
	
	    function InboxContainer(props) {
	        _classCallCheck(this, InboxContainer);
	
	        var _this = _possibleConstructorReturn(this, (InboxContainer.__proto__ || Object.getPrototypeOf(InboxContainer)).call(this, props));
	
	        _this.openInbox = _this.openInbox.bind(_this);
	        _this.closeInbox = _this.closeInbox.bind(_this);
	        return _this;
	    }
	
	    _createClass(InboxContainer, [{
	        key: 'openInbox',
	        value: function openInbox() {
	            this.props.dispatchOpenInbox(this.props.currentBoardId);
	        }
	    }, {
	        key: 'closeInbox',
	        value: function closeInbox() {
	            this.props.dispatchCloseInbox(this.props.currentBoardId);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                inboxState = _props.inboxState,
	                inboxElementIds = _props.inboxElementIds,
	                gridSize = _props.gridSize,
	                currentBoardId = _props.currentBoardId,
	                deselectAll = _props.deselectAll,
	                currentBoard = _props.currentBoard;
	
	
	            return inboxState === _inboxConstants.INBOX_STATE.OPEN ? _react2.default.createElement(_Inbox2.default, _extends({ closeInboxHandler: this.closeInbox, gridSize: gridSize }, this.props, {
	                inboxElementIds: inboxElementIds, currentBoardId: currentBoardId, deselectAll: deselectAll })) : _react2.default.createElement(_InboxClosed2.default, { openInboxHandler: this.openInbox, inboxElementIds: inboxElementIds, element: currentBoard });
	        }
	    }]);
	
	    return InboxContainer;
	}(_react2.default.Component)) || _class);
	
	
	InboxContainer.propTypes = {
	    currentBoard: _propTypes2.default.object.isRequired,
	    inboxElementIds: _propTypes2.default.array.isRequired,
	    currentBoardId: _propTypes2.default.string.isRequired,
	    inboxState: _propTypes2.default.string,
	    dispatchCloseInbox: _propTypes2.default.func,
	    dispatchOpenInbox: _propTypes2.default.func,
	    deselectAll: _propTypes2.default.func,
	    gridSize: _propTypes2.default.number
	};
	
	exports.default = (0, _recompose.onlyUpdateForPropTypes)(InboxContainer);

/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouter = __webpack_require__(45);
	
	var _reactRouterRedux = __webpack_require__(82);
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _webfontloader = __webpack_require__(2327);
	
	var _webfontloader2 = _interopRequireDefault(_webfontloader);
	
	var _getClientConfig = __webpack_require__(48);
	
	var _getClientConfig2 = _interopRequireDefault(_getClientConfig);
	
	var _configConstants = __webpack_require__(135);
	
	var _configureStore = __webpack_require__(2048);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	var _configureEditorStore = __webpack_require__(1749);
	
	var _configureEditorStore2 = _interopRequireDefault(_configureEditorStore);
	
	var _initialiseElementTypes = __webpack_require__(1986);
	
	var _initialiseElementTypes2 = _interopRequireDefault(_initialiseElementTypes);
	
	var _configureMeasurementsStore = __webpack_require__(1910);
	
	var _configureMeasurementsStore2 = _interopRequireDefault(_configureMeasurementsStore);
	
	var _ElementConnectionsManager = __webpack_require__(1703);
	
	var _ElementConnectionsManager2 = _interopRequireDefault(_ElementConnectionsManager);
	
	var _Root = __webpack_require__(1668);
	
	var _Root2 = _interopRequireDefault(_Root);
	
	__webpack_require__(1238);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	if (false) require('./scss/electron-inject.scss');
	
	// in development, load the fonts required. In prod, these are built to a seperate file.
	
	
	// Styles
	
	
	// Utilities
	
	
	// Constants
	// Libraries
	if (false) require('./scss/font-face.scss');
	
	_webfontloader2.default.load({
	    custom: {
	        families: ['Source Sans:n4,i4,n7,i7', 'Tiempos:n7,i4', 'Source Code Pro:n4', 'Gotham:n4,n7']
	    }
	});
	
	/**
	 * Index.js
	 *  -   Defines the root of the application and creates the store instance as well as
	 *      its initial state.
	 *  -   Also ensures that the Redux state is synchronised with the URL and vice versa.
	 *  -   Installs Immutable.js development tools if we're in the development environment.
	 */
	
	/* eslint-disable no-console */
	console.log('%cWelcome to %cMilanote', 'font-size: 18px; font-family: Tiempos', 'color: #f4511c; font-size: 18px; font-family: "Tiempos", Times, serif; font-weight: 600;');
	/* eslint-enable no-console */
	
	var config = (0, _getClientConfig2.default)();
	// Allow immutable JS objects to be printed nicely in the console
	if (config.debugLevel >= _configConstants.DEBUG_LEVEL.INFO) {
	    var installDevTools = __webpack_require__(1364);
	    installDevTools.default(Immutable);
	}
	
	(0, _initialiseElementTypes2.default)();
	
	var historyManager =  false ? _reactRouter.hashHistory : _reactRouter.browserHistory;
	
	// Stores
	var elementConnectionsManager = new _ElementConnectionsManager2.default();
	var editorStore = (0, _configureEditorStore2.default)();
	var measurementsStore = (0, _configureMeasurementsStore2.default)();
	var initialState = Immutable.Map();
	var store = (0, _configureStore2.default)(initialState, historyManager, elementConnectionsManager);
	
	// Configure the browser history to instead be wrapped by the react-router-redux history
	var historyOptions = {
	    selectLocationState: function selectLocationState(state) {
	        return state.get('routing');
	    }
	};
	var history = (0, _reactRouterRedux.syncHistoryWithStore)(historyManager, store, historyOptions);
	
	var mountNode = document.getElementById('app');
	_reactDom2.default.render(_react2.default.createElement(_Root2.default, { store: store, history: history,
	    measurementsStore: measurementsStore,
	    editorStore: editorStore,
	    elementConnectionsManager: elementConnectionsManager }), mountNode);

/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1233);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var placeholderDefault = _react2.default.createElement('div', { className: 'default-placeholder' });
	
	var EmptyListPlaceholder = function EmptyListPlaceholder(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('EmptyListPlaceholder', { hovered: props.isHovered }) },
	        props.placeholderComponent ? props.placeholderComponent : placeholderDefault
	    );
	};
	
	EmptyListPlaceholder.propTypes = {
	    isHovered: _propTypes2.default.bool,
	    placeholderComponent: _propTypes2.default.element
	};
	
	exports.default = EmptyListPlaceholder;

/***/ }),
/* 2032 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class; // Lib
	
	
	// Decorators
	
	
	// Utils
	
	// Drop Utils
	
	
	// Components
	
	
	// Constants
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowequal = __webpack_require__(225);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	var _lodash = __webpack_require__(4);
	
	var _ElementDropTarget = __webpack_require__(168);
	
	var _ElementDropTarget2 = _interopRequireDefault(_ElementDropTarget);
	
	var _dragAndDropUtils = __webpack_require__(145);
	
	var _analytics = __webpack_require__(47);
	
	var _makeCanDropFn = __webpack_require__(300);
	
	var _makeCanDropFn2 = _interopRequireDefault(_makeCanDropFn);
	
	var _preventDropOnSelfPredicate = __webpack_require__(454);
	
	var _preventDropOnSelfPredicate2 = _interopRequireDefault(_preventDropOnSelfPredicate);
	
	var _preventLinePredicate = __webpack_require__(301);
	
	var _preventLinePredicate2 = _interopRequireDefault(_preventLinePredicate);
	
	var _preventColumnsOrLinesOnColumnsPredicate = __webpack_require__(1974);
	
	var _preventColumnsOrLinesOnColumnsPredicate2 = _interopRequireDefault(_preventColumnsOrLinesOnColumnsPredicate);
	
	var _ListPresentational = __webpack_require__(747);
	
	var _ListPresentational2 = _interopRequireDefault(_ListPresentational);
	
	var _boardConstants = __webpack_require__(17);
	
	var _elementConstants = __webpack_require__(12);
	
	__webpack_require__(1235);
	
	var _elementHelper = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Handles the drop of an element onto the column.
	 */
	var onDrop = function onDrop(index, domNode, props, item) {
	    var listId = props.listId,
	        element = props.element;
	
	    var position = { index: index };
	    var draggedElements = item.draggedElements;
	
	
	    var acceptedElementIds = draggedElements.filter(function (el) {
	        return !(0, _elementHelper.isLine)(el) && !((0, _elementHelper.isColumn)(element) && (0, _elementHelper.isColumn)(el));
	    }).map(function (el) {
	        return el.get('id');
	    });
	
	    return {
	        acceptedElementIds: acceptedElementIds,
	        location: {
	            parentId: listId,
	            section: _boardConstants.BOARD_SECTIONS.INBOX,
	            position: position
	        },
	        handledBy: domNode
	    };
	};
	
	var getRangeIndex = function getRangeIndex(posY, ranges, invalidIds) {
	    var currentIndex = 0;
	    var currentValidIndex = 0;
	    var currentRange = ranges[currentIndex];
	    while (currentRange && posY > currentRange.range) {
	        currentIndex++;
	
	        if (!(0, _lodash.includes)(invalidIds, currentRange.id)) {
	            currentValidIndex = currentIndex;
	        }
	
	        currentRange = ranges[currentIndex];
	    }
	    return currentValidIndex;
	};
	
	/* Drop Target functionality. */
	var dropLocationFn = function dropLocationFn(props, monitor, component) {
	    // Don't handle the drop if it's already been handled by a child.
	    if ((0, _dragAndDropUtils.dropTargetAlreadyHandled)(monitor, component)) return;
	
	    var children = props.children;
	
	    var domNode = _reactDom2.default.findDOMNode(component);
	
	    var item = monitor.getItem();
	
	    // Use the item's index, or add it to the end of the list
	    var dropIndex = item.index || item.index === 0 ? item.index : children.length;
	
	    return onDrop(dropIndex, domNode, props, item);
	};
	
	var hoverFn = function hoverFn(props, monitor, component) {
	    // Determine rectangle on screen
	
	    var hoverBoundingRect = _reactDom2.default.findDOMNode(component).getBoundingClientRect();
	
	    // Determine mouse position
	    var clientOffset = monitor.getClientOffset();
	    // Get pixels to the top
	    var hoverClientY = clientOffset.y - hoverBoundingRect.top - component.offsetTop;
	
	    var _monitor$getItem = monitor.getItem(),
	        element = _monitor$getItem.element,
	        draggedElementIds = _monitor$getItem.draggedElementIds;
	    // Find the index that the hovered item is currently hovering over
	
	
	    var hoveredIndex = getRangeIndex(hoverClientY, component.rangeArray, draggedElementIds);
	
	    var showPlaceholder = true;
	
	    if (draggedElementIds.length === 1) {
	        var hoveringItemId = element.get('id');
	        var hoveringItemParentId = element.getIn(['location', 'parentId']);
	        var hoveringItemSection = element.get('location').get('section');
	
	        var listId = props.listId,
	            children = props.children;
	
	        // If dragging an item from the current list, then check the index because
	        // the placeholder should only be shown if its index will change.
	
	        if (listId === hoveringItemParentId && hoveringItemSection === _boardConstants.BOARD_SECTIONS.INBOX) {
	            var currentIndex = children.reduce(function (acc, child, index) {
	                return hoveringItemId === child.get('id') ? index : acc;
	            }, null);
	
	            // If the index is the current position, or the next position (which would result in the same position anyway)
	            // then don't show the placeholder, and just set the index to the current position so that the move event
	            // won't fire.  (There's no point firing a move event when nothing changes).
	            if (currentIndex === hoveredIndex || currentIndex + 1 === hoveredIndex) {
	                hoveredIndex = currentIndex;
	                showPlaceholder = false;
	            }
	        }
	    }
	
	    // Set on the item so that it can drop it at the correct index in the drop handler
	    monitor.getItem().index = hoveredIndex;
	
	    if (hoveredIndex === component.state.hoveredIndex) return;
	
	    // If the placeholder should be shown, set the hovered index, otherwise set it to null
	    component.setState({
	        hoveredIndex: showPlaceholder ? hoveredIndex : null
	    });
	};
	
	var dropTargetConfig = {
	    drop: dropLocationFn,
	    canDrop: (0, _makeCanDropFn2.default)([_preventDropOnSelfPredicate2.default, _preventLinePredicate2.default, _preventColumnsOrLinesOnColumnsPredicate2.default]),
	    hover: hoverFn
	};
	
	var ListContainer = (_dec = (0, _ElementDropTarget2.default)(dropTargetConfig, _elementConstants.DROP_TARGET_TYPES.LIST), _dec(_class = function (_React$Component) {
	    _inherits(ListContainer, _React$Component);
	
	    function ListContainer(props) {
	        _classCallCheck(this, ListContainer);
	
	        var _this = _possibleConstructorReturn(this, (ListContainer.__proto__ || Object.getPrototypeOf(ListContainer)).call(this, props));
	
	        _this.registerListElement = _this.registerListElement.bind(_this);
	        _this.deregisterListElement = _this.deregisterListElement.bind(_this);
	        _this.handleDoubleClick = _this.handleDoubleClick.bind(_this);
	        _this.calculateListRanges = _this.calculateListRanges.bind(_this);
	
	        _this.listElements = [];
	        _this.rangeArray = [];
	
	        _this.state = { hoveredIndex: null };
	        return _this;
	    }
	
	    _createClass(ListContainer, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            // TODO This could be enhanced and made to occur when the page is idle..  I don't think there's any reason
	            // why this would need to occur on component mount.  It should only be used while dragging
	            // FIXME Try to use the measurements array for this instead
	
	            // sometimes we need to add padding to the list component to make it
	            // receive hover events in the correct way. (see Column.scss)
	            // This messes up the offset values working out the hovered index.
	            // Here, we work out how much padding is applied to the list,
	            // so we can remove it from the calulated hoverY when dragging over the list
	            var domNode = _reactDom2.default.findDOMNode(this);
	
	            var paddingTop = window.getComputedStyle(domNode) && window.getComputedStyle(domNode).paddingTop;
	
	            this.offsetTop = paddingTop ? parseInt(paddingTop, 10) : 0;
	
	            this.calculateListRanges();
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            // Don't update when the 'canDrop' property changes because this is not used by lists
	            // NOTE: Need to use should component update instead of dontUpdateForProps because this component
	            //    relies on its component hierarchy for list management unfortunately.  A decorator will change this.
	            return !(0, _shallowequal2.default)(this.state, nextState) || !(0, _shallowequal2.default)(this.props, nextProps, function (thisValue, nextValue, key) {
	                return key === 'canDrop' ? true : undefined;
	            });
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            // If children change, calculate the space that each list element is taking up
	            if (!this.props.children.equals(prevProps.children)) {
	                this.calculateListRanges();
	            }
	        }
	
	        /**
	         * Keeps track of the list elements for this list, so their vertical ranges can be extracted on hover.
	         *
	         * @param listElement {ReactComponent} The ListElementContainer component for the list element.
	         */
	
	    }, {
	        key: 'registerListElement',
	        value: function registerListElement(listElement) {
	            this.listElements.push(listElement);
	        }
	
	        /**
	         * Removes an element from the array of list elements (because, for example it's been removed from the list.
	         *
	         * @param listElement {ReactComponent} The ListElementContainer component for the list element.
	         */
	
	    }, {
	        key: 'deregisterListElement',
	        value: function deregisterListElement(listElement) {
	            var listElementIndex = this.listElements.indexOf(listElement);
	            if (listElementIndex !== -1) {
	                this.listElements.splice(listElementIndex, 1);
	            }
	        }
	    }, {
	        key: 'calculateListRanges',
	        value: function calculateListRanges() {
	            this.rangeArray = this.listElements.map(function (listElement) {
	                return {
	                    id: listElement.props.element.get('id'),
	                    range: listElement.getRange()
	                };
	            }).sort(function (listElementA, listElementB) {
	                return listElementA.range - listElementB.range;
	            });
	        }
	
	        // create a new element when you double click
	
	    }, {
	        key: 'handleDoubleClick',
	        value: function handleDoubleClick(event) {
	            var _props = this.props,
	                createShortcutCard = _props.createShortcutCard,
	                listId = _props.listId,
	                currentBoardId = _props.currentBoardId,
	                isEditable = _props.isEditable;
	
	
	            if (!isEditable || !createShortcutCard) return;
	
	            event.preventDefault();
	            event.stopPropagation();
	
	            var clickPosY = event.clientY - _reactDom2.default.findDOMNode(this).getBoundingClientRect().top - 20;
	            var index = getRangeIndex(clickPosY, this.rangeArray);
	
	            var location = {
	                parentId: listId,
	                section: 'INBOX',
	                position: { index: index || 0 }
	            };
	
	            createShortcutCard({ location: location, currentBoardId: listId });
	
	            if (listId === currentBoardId) (0, _analytics.analyticsEvent)('moved-element-to-unsorted-note');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                connectDropTarget = _props2.connectDropTarget,
	                inListClass = _props2.inListClass;
	            var hoveredIndex = this.state.hoveredIndex;
	
	
	            return connectDropTarget(_react2.default.createElement(
	                'div',
	                { className: 'ListContainer',
	                    onDoubleClick: this.handleDoubleClick },
	                _react2.default.createElement(_ListPresentational2.default, _extends({}, this.props, {
	                    inListClass: inListClass,
	                    hoveredIndex: hoveredIndex,
	                    registerListElement: this.registerListElement,
	                    deregisterListElement: this.deregisterListElement }))
	            ));
	        }
	    }]);
	
	    return ListContainer;
	}(_react2.default.Component)) || _class);
	exports.default = ListContainer;
	
	
	ListContainer.propTypes = {
	    listId: _propTypes2.default.string,
	    currentBoardId: _propTypes2.default.string,
	    connectDropTarget: _propTypes2.default.func,
	    children: _propTypes2.default.object.isRequired,
	    isHovered: _propTypes2.default.bool,
	    createShortcutCard: _propTypes2.default.func,
	    inListClass: _propTypes2.default.string,
	    isEditable: _propTypes2.default.bool
	};

/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1236);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListDropPreview = function ListDropPreview(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'ListDropPreview' },
	    _react2.default.createElement('div', { className: 'preview-line' })
	  );
	};
	
	exports.default = ListDropPreview;

/***/ }),
/* 2034 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(22);
	
	var _ListElementPresentational = __webpack_require__(746);
	
	var _ListElementPresentational2 = _interopRequireDefault(_ListElementPresentational);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	// Components
	
	
	var ListElementContainer = function (_React$Component) {
	    _inherits(ListElementContainer, _React$Component);
	
	    function ListElementContainer(props) {
	        _classCallCheck(this, ListElementContainer);
	
	        var _this = _possibleConstructorReturn(this, (ListElementContainer.__proto__ || Object.getPrototypeOf(ListElementContainer)).call(this, props));
	
	        _this.getRange = _this.getRange.bind(_this);
	        return _this;
	    }
	
	    /**
	     * Register the list element with the parent on mount.
	     */
	
	
	    _createClass(ListElementContainer, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var registerListElement = this.props.registerListElement;
	
	            registerListElement && registerListElement(this);
	        }
	
	        /**
	         * Remove the list element from the parent when un-mounting.
	         */
	
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            var deregisterListElement = this.props.deregisterListElement;
	
	            deregisterListElement && deregisterListElement(this);
	        }
	
	        /**
	         * Retrieves the vertical point within the list that this index covers.
	         *
	         * @returns {Number} The vertical point within the list that determines whether the index should
	         *              be more than the current index.
	         */
	
	    }, {
	        key: 'getRange',
	        value: function getRange() {
	            var domNode = (0, _reactDom.findDOMNode)(this);
	            // Get vertical middle
	            return domNode.offsetTop + domNode.offsetHeight / 2;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(_ListElementPresentational2.default, this.props);
	        }
	    }]);
	
	    return ListElementContainer;
	}(_react2.default.Component);
	
	ListElementContainer.propTypes = {
	    element: _propTypes2.default.object,
	    currentBoardId: _propTypes2.default.string.isRequired,
	    connectDropTarget: _propTypes2.default.func,
	    registerListElement: _propTypes2.default.func,
	    deregisterListElement: _propTypes2.default.func
	};
	
	exports.default = ListElementContainer;

/***/ }),
/* 2035 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class; // Lib
	
	
	// Actions
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _userService = __webpack_require__(106);
	
	var _notificationActions = __webpack_require__(460);
	
	var _boardService = __webpack_require__(167);
	
	var _notificationPollManagerSelector = __webpack_require__(2036);
	
	var _notificationPollManagerSelector2 = _interopRequireDefault(_notificationPollManagerSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// poll for new notifications every five minutes
	var POLL_MODIFICATIONS_DELAY = 1000 * 60 * 5;
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        fetchModified: function fetchModified() {
	            return dispatch((0, _notificationActions.fetchModifiedBoards)());
	        },
	        fetchNotificationUsers: function fetchNotificationUsers(users) {
	            return dispatch((0, _userService.fetchUsers)(users));
	        },
	        fetchNotificationBoards: function fetchNotificationBoards(boardIds) {
	            return dispatch((0, _boardService.fetchBoards)({ boardIds: boardIds, loadAncestors: false }));
	        }
	    };
	};
	
	var NotificationPollWindow = (_dec = (0, _reactRedux.connect)(_notificationPollManagerSelector2.default, mapDispatchToProps), _dec(_class = function (_React$Component) {
	    _inherits(NotificationPollWindow, _React$Component);
	
	    function NotificationPollWindow() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, NotificationPollWindow);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NotificationPollWindow.__proto__ || Object.getPrototypeOf(NotificationPollWindow)).call.apply(_ref, [this].concat(args))), _this), _this.startPollNotificationsInterval = function () {
	            _this.pollTimer = setInterval(function () {
	                return _this.props.fetchModified();
	            }, POLL_MODIFICATIONS_DELAY);
	        }, _this.stopPollNotificationsInterval = function () {
	            if (_this.pollTimer) {
	                clearInterval(_this.pollTimer);
	                _this.pollTimer = null;
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(NotificationPollWindow, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                fetchModified = _props.fetchModified,
	                isGuest = _props.isGuest;
	
	            if (isGuest) return;
	
	            fetchModified();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _props2 = this.props,
	                notifications = _props2.notifications,
	                fetchNotificationUsers = _props2.fetchNotificationUsers,
	                fetchedTime = _props2.fetchedTime,
	                forcedPoll = _props2.forcedPoll,
	                fetchModified = _props2.fetchModified,
	                notificationUserIds = _props2.notificationUserIds;
	
	
	            if (fetchedTime !== nextProps.fetchedTime) {
	                this.stopPollNotificationsInterval();
	                this.startPollNotificationsInterval();
	            }
	
	            if (forcedPoll !== nextProps.forcedPoll) {
	                this.stopPollNotificationsInterval();
	                fetchModified();
	            }
	
	            if (notifications !== nextProps.notifications) {
	                if (!notificationUserIds.length) return;
	                fetchNotificationUsers(notificationUserIds);
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.stopPollNotificationsInterval();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return null;
	        }
	    }]);
	
	    return NotificationPollWindow;
	}(_react2.default.Component)) || _class);
	
	
	NotificationPollWindow.propTypes = {
	    isGuest: _react2.default.PropTypes.bool,
	    fetchedTime: _react2.default.PropTypes.number,
	    forcedPoll: _react2.default.PropTypes.number,
	
	    notifications: _react2.default.PropTypes.object,
	    notificationUserIds: _react2.default.PropTypes.array,
	
	    fetchNotificationUsers: _react2.default.PropTypes.func,
	    fetchNotificationBoards: _react2.default.PropTypes.func,
	    fetchModified: _react2.default.PropTypes.func
	};
	
	exports.default = NotificationPollWindow;

/***/ }),
/* 2036 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reselect = __webpack_require__(7);
	
	var _notificationSelector = __webpack_require__(749);
	
	var _currentUserSelector = __webpack_require__(33);
	
	exports.default = (0, _reselect.createStructuredSelector)({
	    fetchedTime: _notificationSelector.getFetchedTime,
	    forcedPoll: _notificationSelector.getForcedPoll,
	    isGuest: _currentUserSelector.isGuestSelector,
	
	    notifications: _notificationSelector.modifiedElementsSelector,
	    notificationUserIds: _notificationSelector.notificationUserIdsSelector
	}); // Lib

/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _timeUtil = __webpack_require__(43);
	
	var _notificationConstants = __webpack_require__(748);
	
	var _userConstants = __webpack_require__(32);
	
	var _notificationConstants2 = __webpack_require__(88);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialState = Immutable.fromJS({
	    fetched: false,
	    fetchedTime: null,
	    forcedPoll: null,
	    modifiedElements: {}
	});
	
	var updateNotificationSeen = function updateNotificationSeen(state, action) {
	    if (!state.getIn(['modifiedElements', action.previousBoardId])) return state;
	
	    return state.setIn(['modifiedElements', action.previousBoardId, 'viewedBoard'], action.timestamp);
	};
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _notificationConstants.MODIFIED_ELEMENTS_SET:
	            return state.set('modifiedElements', Immutable.fromJS(action.modifiedElements)).set('fetchedTime', (0, _timeUtil.getTimestamp)()).set('fetched', true);
	        case _notificationConstants.MODIFIED_ELEMENTS_ADD:
	            return state.mergeDeepIn(['modifiedElements'], action.modifiedElements).set('fetchedTime', (0, _timeUtil.getTimestamp)()).set('fetched', true);
	        case _userConstants.USER_NAVIGATE:
	            return updateNotificationSeen(state, action);
	        case _notificationConstants2.MODIFIED_ELEMENTS_FORCE_POLL:
	            return state.set('forcedPoll', action.timestamp);
	        case _notificationConstants.MODIFIED_ELEMENTS_ERROR:
	            return state.set('fetched', true);
	        default:
	            return state;
	    }
	};

/***/ }),
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxImmutable = __webpack_require__(73);
	
	var _currentlyEditingReducer = __webpack_require__(2024);
	
	var _currentlyEditingReducer2 = _interopRequireDefault(_currentlyEditingReducer);
	
	var _selectionReducer = __webpack_require__(2025);
	
	var _selectionReducer2 = _interopRequireDefault(_selectionReducer);
	
	var _gridReducer = __webpack_require__(2125);
	
	var _gridReducer2 = _interopRequireDefault(_gridReducer);
	
	var _currentUserReducer = __webpack_require__(2108);
	
	var _currentUserReducer2 = _interopRequireDefault(_currentUserReducer);
	
	var _draggingReducer = __webpack_require__(2040);
	
	var _draggingReducer2 = _interopRequireDefault(_draggingReducer);
	
	var _progressiveImageReducer = __webpack_require__(1905);
	
	var _progressiveImageReducer2 = _interopRequireDefault(_progressiveImageReducer);
	
	var _popupReducer = __webpack_require__(1928);
	
	var _popupReducer2 = _interopRequireDefault(_popupReducer);
	
	var _modalReducer = __webpack_require__(1923);
	
	var _modalReducer2 = _interopRequireDefault(_modalReducer);
	
	var _socketReducer = __webpack_require__(2143);
	
	var _socketReducer2 = _interopRequireDefault(_socketReducer);
	
	var _staticResourcesReducer = __webpack_require__(1934);
	
	var _staticResourcesReducer2 = _interopRequireDefault(_staticResourcesReducer);
	
	var _currentBoardIdReducer = __webpack_require__(2039);
	
	var _currentBoardIdReducer2 = _interopRequireDefault(_currentBoardIdReducer);
	
	var _dragModifierKeysReducer = __webpack_require__(2122);
	
	var _dragModifierKeysReducer2 = _interopRequireDefault(_dragModifierKeysReducer);
	
	var _analyticsReducer = __webpack_require__(1663);
	
	var _analyticsReducer2 = _interopRequireDefault(_analyticsReducer);
	
	var _richMediaReducer = __webpack_require__(2022);
	
	var _richMediaReducer2 = _interopRequireDefault(_richMediaReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Client only state
	var reducersMap = {
	    currentBoardId: _currentBoardIdReducer2.default,
	    currentlyEditing: _currentlyEditingReducer2.default,
	    dragModifierKeys: _dragModifierKeysReducer2.default,
	    selection: _selectionReducer2.default,
	    gridSize: _gridReducer2.default,
	    currentUser: _currentUserReducer2.default,
	    dragging: _draggingReducer2.default,
	    progressiveImages: _progressiveImageReducer2.default,
	    socketConnection: _socketReducer2.default,
	    popup: _popupReducer2.default,
	    modal: _modalReducer2.default,
	    staticResources: _staticResourcesReducer2.default,
	    analytics: _analyticsReducer2.default,
	    richMedia: _richMediaReducer2.default
	};
	
	// only include the electron-specific reducer when running in electron context
	if (false) {
	    reducersMap.electron = require('./electronReducer').default;
	}
	
	var appReducer = (0, _reduxImmutable.combineReducers)(reducersMap);
	
	var clientAppReducer = function clientAppReducer(state, action) {
	    if (action.remote) {
	        return state;
	    }
	    return appReducer(state, action);
	};
	
	exports.default = clientAppReducer;

/***/ }),
/* 2039 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _currentBoardIdConstants = __webpack_require__(461);
	
	var _currentUserConstants = __webpack_require__(144);
	
	// Constants
	var initialState = _currentBoardIdConstants.UNINITIALISED;
	
	var handleCurrentUserSet = function handleCurrentUserSet(state, action) {
	    return (
	        // Only update the current board ID if it hasn't already been set
	        state === _currentBoardIdConstants.UNINITIALISED ? action.user.lastViewedBoard || action.user.rootBoardId : state
	    );
	};
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _currentBoardIdConstants.CURRENT_BOARD_ID_SET:
	            return action.boardId;
	        case _currentUserConstants.CURRENT_USER_SET:
	            return handleCurrentUserSet(state, action);
	        default:
	            return state;
	    }
	};

/***/ }),
/* 2040 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _draggingConstants = __webpack_require__(143);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialState = Immutable.fromJS({
	    isDragging: false,
	    hoveredItems: {},
	    hoveredTypes: {}
	});
	
	var updateHoveredItems = function updateHoveredItems(state, action) {
	    var targetId = action.targetId,
	        targetType = action.targetType;
	
	    var updated = state.setIn(['hoveredItems', targetId], true);
	    var typeList = state.get('hoveredTypes').get(targetType) || Immutable.List();
	    return updated.setIn(['hoveredTypes', targetType], typeList.push(targetId));
	};
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _draggingConstants.DRAG_START:
	            return state.set('isDragging', true);
	        case _draggingConstants.DRAG_END:
	            return initialState;
	        case _draggingConstants.DRAG_OVER:
	            if (state.get('hoveredItems').get(action.targetId)) return state;
	            return updateHoveredItems(state, action);
	        default:
	            return state;
	    }
	};

/***/ }),
/* 2041 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxImmutable = __webpack_require__(73);
	
	var _routingImmutableReducer = __webpack_require__(2043);
	
	var _routingImmutableReducer2 = _interopRequireDefault(_routingImmutableReducer);
	
	var _elementsReducer = __webpack_require__(2270);
	
	var _elementsReducer2 = _interopRequireDefault(_elementsReducer);
	
	var _usersReducer = __webpack_require__(2113);
	
	var _usersReducer2 = _interopRequireDefault(_usersReducer);
	
	var _appReducer = __webpack_require__(2038);
	
	var _appReducer2 = _interopRequireDefault(_appReducer);
	
	var _undoRedoReducer = __webpack_require__(2148);
	
	var _undoRedoReducer2 = _interopRequireDefault(_undoRedoReducer);
	
	var _formReducer = __webpack_require__(1779);
	
	var _formReducer2 = _interopRequireDefault(_formReducer);
	
	var _notificationsReducer = __webpack_require__(2037);
	
	var _notificationsReducer2 = _interopRequireDefault(_notificationsReducer);
	
	var _lastSavedReducer = __webpack_require__(2042);
	
	var _lastSavedReducer2 = _interopRequireDefault(_lastSavedReducer);
	
	var _remoteActivityReducer = __webpack_require__(2044);
	
	var _remoteActivityReducer2 = _interopRequireDefault(_remoteActivityReducer);
	
	var _debugReducer = __webpack_require__(1939);
	
	var _debugReducer2 = _interopRequireDefault(_debugReducer);
	
	var _reducers = __webpack_require__(2136);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _elementCountReducer = __webpack_require__(2110);
	
	var _elementCountReducer2 = _interopRequireDefault(_elementCountReducer);
	
	var _cache = __webpack_require__(1959);
	
	var _cache2 = _interopRequireDefault(_cache);
	
	var _authConstants = __webpack_require__(136);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * reducers/index.js
	 *  - Returns the root reducer for the client.
	 */
	var rootReducer = (0, _reduxImmutable.combineReducers)({
	    debug: _debugReducer2.default,
	    routing: _routingImmutableReducer2.default,
	    elements: _elementsReducer2.default,
	    users: _usersReducer2.default,
	    notifications: _notificationsReducer2.default,
	    remoteActivity: _remoteActivityReducer2.default,
	    app: _appReducer2.default,
	    undoRedo: _undoRedoReducer2.default,
	    form: _formReducer2.default,
	    lastSaved: _lastSavedReducer2.default,
	    resources: _reducers2.default,
	    elementCount: _elementCountReducer2.default,
	    cache: _cache2.default
	});
	
	/**
	 * Reset the entire application state when the current user logs out.
	 */
	
	
	// Logout action type
	// Lib
	var wrappedRootReducer = function wrappedRootReducer(state, action) {
	    if (!action.remote && action.type === _authConstants.LOGOUT && action.userId === state.getIn(['app', 'currentUser', '_id'])) {
	        return rootReducer(undefined, action);
	    }
	    return rootReducer(state, action);
	};
	
	exports.default = wrappedRootReducer;

/***/ }),
/* 2042 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var initialState = null;
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    if (action.sync && action.modified) {
	        return action.modified;
	    }
	    return state;
	};

/***/ }),
/* 2043 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	exports.default = routerReducer;
	
	var _reactRouterRedux = __webpack_require__(82);
	
	var initialState = {
	    locationBeforeTransitions: null
	};
	
	/**
	 * From react-router-redux source:
	 *
	 * This reducer will update the state with the most recent location history
	 * has transitioned to. This may not be in sync with the router, particularly
	 * if you have asynchronously-loaded routes, so reading from and relying on
	 * this state it is discouraged.
	 */
	function routerReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    if (action.type === _reactRouterRedux.LOCATION_CHANGE) {
	        return _extends({}, state, {
	            locationBeforeTransitions: action.payload
	        });
	    }
	    return state;
	}

/***/ }),
/* 2044 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxImmutable = __webpack_require__(73);
	
	var _selectedElementsReducer = __webpack_require__(2046);
	
	var _selectedElementsReducer2 = _interopRequireDefault(_selectedElementsReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Lib
	exports.default = (0, _reduxImmutable.combineReducers)({
	    selectedElements: _selectedElementsReducer2.default
	});
	
	// Reducers

/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _selectionConstants = __webpack_require__(77);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Initial state
	// Lib
	var initialState = Immutable.Map({
	    userId: null
	});
	
	// Constants
	
	
	var updateSelectedElement = function updateSelectedElement(state, action) {
	    return state.set('userId', action.user._id);
	};
	var removeSelectedElement = function removeSelectedElement(state, action) {
	    return state.set('userId', null);
	};
	
	// Reducer
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _selectionConstants.ELEMENTS_SELECTED:
	            return updateSelectedElement(state, action);
	        case _selectionConstants.ELEMENTS_DESELECTED:
	            return removeSelectedElement(state, action);
	        case _selectionConstants.ELEMENTS_DESELECT_ALL:
	            return initialState;
	        default:
	            return state;
	    }
	};

/***/ }),
/* 2046 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _lodash = __webpack_require__(4);
	
	var _selectedElementReducer = __webpack_require__(2045);
	
	var _selectedElementReducer2 = _interopRequireDefault(_selectedElementReducer);
	
	var _selectionConstants = __webpack_require__(77);
	
	var _userConstants = __webpack_require__(311);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } // Lib
	
	
	// Reducers
	
	
	// Constants
	
	
	var initialState = Immutable.Map();
	
	var delegateToSelectedElement = function delegateToSelectedElement(state, action, elementId) {
	    return state.set(elementId, (0, _selectedElementReducer2.default)(undefined, action));
	};
	
	var delegateToEachSelectedElement = function delegateToEachSelectedElement(state, action) {
	    return action.ids.reduce(function (newState, elementId) {
	        return delegateToSelectedElement(newState, action, elementId);
	    }, state);
	};
	
	/**
	 * When a user disconnects, remove all of their selected element entries.
	 */
	var clearSelectedElementsForUser = function clearSelectedElementsForUser(state, action) {
	    var userId = action.userId || action.user._id;
	    return state.filter(function (selectedElementEntry) {
	        return selectedElementEntry.get('userId') !== userId;
	    });
	};
	
	var loadUserSelectedElements = function loadUserSelectedElements(state, action) {
	    var selectedElementIdsMap = (0, _lodash.reduce)(action.users, function (elementIdsMap, activeUserData) {
	        var selectedElementIds = activeUserData.selectedElementIds ? activeUserData.selectedElementIds.split(',') : [];
	        selectedElementIds.forEach(function (elementId) {
	            return elementIdsMap[elementId] = { userId: activeUserData._id };
	        });
	        return elementIdsMap;
	    }, {});
	
	    var userIdsToClear = [].concat(_toConsumableArray((0, _lodash.keys)(action.users)), _toConsumableArray(action.disconnectedUserIds));
	    return userIdsToClear.reduce(function (updatedState, userId) {
	        return clearSelectedElementsForUser(updatedState, { userId: userId });
	    }, state).merge(Immutable.fromJS(selectedElementIdsMap));
	};
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    if (action.type === _userConstants.USER_NAVIGATE) return clearSelectedElementsForUser(state, action);
	
	    if (action.remote !== true && action.type !== _userConstants.USER_ACTIVITY_LOAD) return state;
	
	    switch (action.type) {
	        case _userConstants.USER_ACTIVITY_LOAD:
	            return loadUserSelectedElements(state, action);
	        case _selectionConstants.ELEMENTS_SELECTED:
	        case _selectionConstants.ELEMENTS_DESELECTED:
	            return delegateToEachSelectedElement(state, action);
	        case _selectionConstants.ELEMENTS_DESELECT_ALL:
	            return clearSelectedElementsForUser(state, action);
	        case _userConstants.USER_DISCONNECT:
	            return clearSelectedElementsForUser(state, action);
	        default:
	            return state;
	    }
	};

/***/ }),
/* 2047 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (_ref) {
	    var getState = _ref.getState;
	    return function (next) {
	        return function (action) {
	            var nextAction = next(action);
	            if (window) {
	                window._state = getState();
	            }
	            return nextAction;
	        };
	    };
	};

/***/ }),
/* 2048 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var configureStore = void 0;
	
	if (false) {
	    configureStore = require('./configureStoreElectronClient').default;
	} else {
	    configureStore = __webpack_require__(2049).default;
	}
	
	exports.default = configureStore;

/***/ }),
/* 2049 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = configureStore;
	
	var _redux = __webpack_require__(195);
	
	var _socketClient = __webpack_require__(2142);
	
	var _getMiddleware = __webpack_require__(2052);
	
	var _getMiddleware2 = _interopRequireDefault(_getMiddleware);
	
	var _reducers = __webpack_require__(2041);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _reduxBulkingMiddleware = __webpack_require__(307);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function configureStore(initialState, browserHistory, elementConnectionsManager) {
	    var socketManager = (0, _socketClient.getSocketManager)();
	
	    var middlewareList = (0, _getMiddleware2.default)({
	        browserHistory: browserHistory,
	        socketManager: socketManager,
	        elementConnectionsManager: elementConnectionsManager
	    });
	
	    var middleware = _redux.applyMiddleware.apply(null, middlewareList);
	
	    var store = (0, _redux.createStore)((0, _reduxBulkingMiddleware.enableReducerBatching)(_reducers2.default), initialState, middleware);
	    socketManager.subscribeToStore(store);
	
	    if (false) {
	        // Enable Webpack hot module replacement for reducers
	        module.hot.accept('../reducers', function () {
	            var nextReducer = require('../reducers');
	            store.replaceReducer(nextReducer);
	        });
	    }
	
	    return store;
	}

/***/ }),
/* 2050 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _selectionConstants = __webpack_require__(77);
	
	var _draggingConstants = __webpack_require__(143);
	
	var _navigationActions = __webpack_require__(27);
	
	var _lodash = __webpack_require__(4);
	
	exports.default = function (store) {
	    return function (next) {
	        return function (action) {
	            if (action.remote) return next(action);
	
	            var filterState = (0, _lodash.get)(store.getState().get('routing'), ['locationBeforeTransitions', 'search']);
	            if (!filterState) return next(action);
	
	            switch (action.type) {
	                case _selectionConstants.ELEMENTS_SELECTED:
	                case _selectionConstants.ELEMENT_EDIT_START:
	                case _draggingConstants.DRAG_START:
	                    store.dispatch((0, _navigationActions.clearFilter)());
	                    break;
	                default:
	                    break;
	            }
	
	            return next(action);
	        };
	    };
	};

/***/ }),
/* 2051 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _boardService = __webpack_require__(167);
	
	var _elementConstants = __webpack_require__(12);
	
	exports.default = function (store) {
	    return function (next) {
	        return function (action) {
	            if (action.type !== _elementConstants.ELEMENT_FORCE_LOAD) return next(action);
	
	            store.dispatch((0, _boardService.fetchBoard)({
	                boardId: action.id,
	                force: true,
	                excludeSelf: true,
	                loadNextBoards: true,
	                loadAncestors: false
	            }));
	
	            return next(action);
	        };
	    };
	};

/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxThunk = __webpack_require__(662);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reduxLogger = __webpack_require__(289);
	
	var _reactRouterRedux = __webpack_require__(82);
	
	var _createSocketMiddleware = __webpack_require__(2141);
	
	var _undoRedoMiddleware = __webpack_require__(2147);
	
	var _undoRedoMiddleware2 = _interopRequireDefault(_undoRedoMiddleware);
	
	var _analyticsMiddleware = __webpack_require__(1662);
	
	var _analyticsMiddleware2 = _interopRequireDefault(_analyticsMiddleware);
	
	var _filterStateRoutingMiddleware = __webpack_require__(2050);
	
	var _filterStateRoutingMiddleware2 = _interopRequireDefault(_filterStateRoutingMiddleware);
	
	var _createElementConnectionsMiddleware = __webpack_require__(1710);
	
	var _createElementConnectionsMiddleware2 = _interopRequireDefault(_createElementConnectionsMiddleware);
	
	var _elementCountMiddleware = __webpack_require__(2109);
	
	var _elementCountMiddleware2 = _interopRequireDefault(_elementCountMiddleware);
	
	var _addStateToWindowMiddleware = __webpack_require__(2047);
	
	var _addStateToWindowMiddleware2 = _interopRequireDefault(_addStateToWindowMiddleware);
	
	var _forceElementLoadMiddleware = __webpack_require__(2051);
	
	var _forceElementLoadMiddleware2 = _interopRequireDefault(_forceElementLoadMiddleware);
	
	var _reduxBulkingMiddleware = __webpack_require__(307);
	
	var _getClientConfig = __webpack_require__(48);
	
	var _getClientConfig2 = _interopRequireDefault(_getClientConfig);
	
	var _debugUtil = __webpack_require__(299);
	
	var _configConstants = __webpack_require__(135);
	
	var _loggingConfig = __webpack_require__(2053);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var browserHistory = _ref.browserHistory,
	        elementConnectionsManager = _ref.elementConnectionsManager,
	        socketManager = _ref.socketManager;
	
	    var middlewareList = [];
	    var config = (0, _getClientConfig2.default)();
	
	    middlewareList.push(_reduxThunk2.default);
	    middlewareList.push(_undoRedoMiddleware2.default);
	
	    if (browserHistory) middlewareList.push((0, _reactRouterRedux.routerMiddleware)(browserHistory));
	    if (elementConnectionsManager) middlewareList.push((0, _createElementConnectionsMiddleware2.default)(elementConnectionsManager));
	
	    middlewareList.push(_elementCountMiddleware2.default);
	    middlewareList.push(_filterStateRoutingMiddleware2.default);
	
	    middlewareList.push((0, _analyticsMiddleware2.default)());
	
	    if (socketManager) middlewareList.push((0, _createSocketMiddleware.createSocketMiddleware)(socketManager));
	
	    middlewareList.push((0, _reduxBulkingMiddleware.bulkingMiddleware)());
	    middlewareList.push(_forceElementLoadMiddleware2.default);
	
	    if (config.debugLevel > _configConstants.DEBUG_LEVEL.OFF) {
	        var filteredActions = _loggingConfig.LOG_FILTER_ACTIONS.filter(function (logLevel) {
	            return logLevel >= config.debugLevel;
	        }).keySeq().toArray();
	
	        middlewareList.push((0, _reduxLogger.createLogger)({
	            predicate: function predicate(getState, action) {
	                return filteredActions.indexOf(action.type) === -1;
	            },
	            collapsed: true,
	            duration: true,
	            titleFormatter: function titleFormatter(action, time, took) {
	                if (action.type === _reduxBulkingMiddleware.BATCH_ACTION_TYPE) {
	                    var actions = action.payload.map(function (a) {
	                        return a.type;
	                    }).join(', ');
	                    return 'batch action: ' + actions + ' (in ' + took.toFixed(2) + ' ms)';
	                }
	
	                return 'action ' + action.type + ' (in ' + took.toFixed(2) + ' ms)';
	            }
	        }));
	
	        if (_debugUtil.isDebugEnabled) {
	            middlewareList.push(_addStateToWindowMiddleware2.default);
	        }
	    }
	
	    if (_debugUtil.isDebugEnabled) {
	        middlewareList.push(_addStateToWindowMiddleware2.default);
	    }
	
	    return middlewareList;
	};

/***/ }),
/* 2053 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.LOG_FILTER_ACTIONS = undefined;
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _configConstants = __webpack_require__(135);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var LOG_FILTER_ACTIONS = exports.LOG_FILTER_ACTIONS = Immutable.Map({
	    'redux-form/CHANGE': _configConstants.DEBUG_LEVEL.FINE
	});
	
	// Logging constants

/***/ }),
/* 2054 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Components
	
	
	// Util
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TabbedNavigation = __webpack_require__(1699);
	
	var _TabbedNavigation2 = _interopRequireDefault(_TabbedNavigation);
	
	var _PlanStatusTitle = __webpack_require__(754);
	
	var _PlanStatusTitle2 = _interopRequireDefault(_PlanStatusTitle);
	
	var _userUtil = __webpack_require__(31);
	
	__webpack_require__(1239);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TAB_UPGRADE = {
	    title: 'Upgrade your plan',
	    route: '/account/plan'
	};
	
	var TAB_REFER = {
	    title: 'Refer a friend',
	    route: '/account/refer'
	};
	
	var TABS = [TAB_UPGRADE, TAB_REFER];
	
	var getLastPath = function getLastPath(routes) {
	    return routes[routes.length - 1].path;
	};
	
	// this is a bit gross:
	// only plan and refer modals should be shown within tab view,
	// and only when the user isn't subscribed
	var shouldUseTabs = function shouldUseTabs(_ref) {
	    var routes = _ref.routes,
	        currentUser = _ref.currentUser;
	
	    if ((0, _userUtil.isSubscribed)(currentUser)) return false;
	
	    var path = getLastPath(routes);
	    if (path === 'plan' || path === 'refer') return true;
	
	    return false;
	};
	
	var AccountModalTabbed = function AccountModalTabbed(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'AccountModal tabbed' },
	        _react2.default.createElement(
	            'div',
	            { className: 'account-header' },
	            _react2.default.createElement(
	                'h1',
	                null,
	                _react2.default.createElement(_PlanStatusTitle2.default, props)
	            )
	        ),
	        _react2.default.createElement(
	            _TabbedNavigation2.default,
	            _extends({}, props, { tabs: TABS }),
	            props.children
	        )
	    );
	};
	
	var AccountModalBox = function AccountModalBox(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'AccountModal' },
	        props.children
	    );
	};
	
	AccountModalTabbed.propTypes = AccountModalBox.propTypes = {
	    children: _propTypes2.default.element
	};
	
	var AccountModal = function AccountModal(props) {
	    if (shouldUseTabs(props)) return _react2.default.createElement(AccountModalTabbed, props);
	    return _react2.default.createElement(AccountModalBox, props);
	};
	
	AccountModal.propTypes = {
	    children: _propTypes2.default.element,
	    currentUser: _propTypes2.default.object
	};
	
	exports.default = AccountModal;

/***/ }),
/* 2055 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reselect = __webpack_require__(7);
	
	var _reactRedux = __webpack_require__(3);
	
	var _AccountModal = __webpack_require__(2054);
	
	var _AccountModal2 = _interopRequireDefault(_AccountModal);
	
	var _currentUserSelector = __webpack_require__(33);
	
	var _elementCountSelector = __webpack_require__(170);
	
	var _userUtil = __webpack_require__(31);
	
	var _currentUserActions = __webpack_require__(84);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var accountSelector = (0, _reselect.createSelector)(_currentUserSelector.getCurrentUser, _elementCountSelector.contentElementCountSelector, _elementCountSelector.contentTotalCountSelector, _elementCountSelector.contentTotalLimitSelector, function (currentUser, elementCount, contentTotalCount, contentTotalLimit) {
	    return {
	        currentUser: currentUser,
	        elementCount: elementCount,
	        contentTotalCount: contentTotalCount,
	        contentTotalLimit: contentTotalLimit,
	        subscription: currentUser.get('subscription')
	    };
	});
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        dispatchFetchReferrals: function dispatchFetchReferrals() {
	            return dispatch((0, _currentUserActions.fetchCurrentUserReferrals)());
	        },
	        dispatchFetchSubscription: function dispatchFetchSubscription() {
	            return dispatch((0, _currentUserActions.fetchCurrentUserSubscription)());
	        }
	    };
	};
	
	var AccountModalContainer = (_dec = (0, _reactRedux.connect)(accountSelector, mapDispatchToProps), _dec(_class = function (_React$Component) {
	    _inherits(AccountModalContainer, _React$Component);
	
	    function AccountModalContainer() {
	        _classCallCheck(this, AccountModalContainer);
	
	        return _possibleConstructorReturn(this, (AccountModalContainer.__proto__ || Object.getPrototypeOf(AccountModalContainer)).apply(this, arguments));
	    }
	
	    _createClass(AccountModalContainer, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatchFetchReferrals = _props.dispatchFetchReferrals,
	                dispatchFetchSubscription = _props.dispatchFetchSubscription,
	                currentUser = _props.currentUser;
	
	
	            if (!currentUser.get('referrals')) dispatchFetchReferrals();
	
	            if ((0, _userUtil.isSubscribed)(currentUser) && !currentUser.getIn(['subscription', 'detail']) || currentUser.get('customerId') && !currentUser.getIn(['customer', 'id'])) {
	                dispatchFetchSubscription();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(_AccountModal2.default, this.props);
	        }
	    }]);
	
	    return AccountModalContainer;
	}(_react2.default.Component)) || _class);
	
	
	AccountModalContainer.propTypes = {
	    currentUser: _propTypes2.default.object,
	    dispatchFetchReferrals: _propTypes2.default.func,
	    dispatchFetchSubscription: _propTypes2.default.func
	};
	
	exports.default = AccountModalContainer;

/***/ }),
/* 2056 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RouteModalRootAuthenticated = __webpack_require__(1920);
	
	var _RouteModalRootAuthenticated2 = _interopRequireDefault(_RouteModalRootAuthenticated);
	
	var _AccountModalContainer = __webpack_require__(2055);
	
	var _AccountModalContainer2 = _interopRequireDefault(_AccountModalContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BACK_BUTTON_ROUTES = ['/account/payment', '/account/team', '/account/card', '/account/cancel'];
	
	var AccountModalRoot = function AccountModalRoot(props) {
	    return _react2.default.createElement(
	        _RouteModalRootAuthenticated2.default,
	        _extends({}, props, {
	            className: 'auto-width',
	            backButtonRoutes: BACK_BUTTON_ROUTES }),
	        _react2.default.createElement(
	            _AccountModalContainer2.default,
	            props,
	            props.children
	        )
	    );
	};
	
	AccountModalRoot.propTypes = {
	    children: _propTypes2.default.node
	};
	
	exports.default = AccountModalRoot;

/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _dec3, _dec4, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(4);
	
	var _recompose = __webpack_require__(9);
	
	var _milanoteForm = __webpack_require__(104);
	
	var _milanoteForm2 = _interopRequireDefault(_milanoteForm);
	
	var _LoadingTransitionDisplay = __webpack_require__(438);
	
	var _LoadingTransitionDisplay2 = _interopRequireDefault(_LoadingTransitionDisplay);
	
	var _PaymentForm = __webpack_require__(2059);
	
	var _PaymentForm2 = _interopRequireDefault(_PaymentForm);
	
	var _PaymentProcessing = __webpack_require__(2064);
	
	var _PaymentProcessing2 = _interopRequireDefault(_PaymentProcessing);
	
	var _PaymentSuccess = __webpack_require__(2065);
	
	var _PaymentSuccess2 = _interopRequireDefault(_PaymentSuccess);
	
	var _planEnquiryAnalyticsService = __webpack_require__(235);
	
	var _userUtil = __webpack_require__(31);
	
	var _timeUtil = __webpack_require__(43);
	
	var _paymentActions = __webpack_require__(752);
	
	var _paymentSelector = __webpack_require__(308);
	
	var _paymentConstants = __webpack_require__(202);
	
	__webpack_require__(1240);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        dispatchLoadPlans: function dispatchLoadPlans(volume) {
	            return dispatch((0, _paymentActions.loadPlans)({ volume: volume }));
	        },
	        dispatchClearCard: function dispatchClearCard() {
	            return dispatch((0, _paymentActions.clearPrefilledCard)());
	        },
	        dispatchFetchCoupon: function dispatchFetchCoupon(couponCode) {
	            return dispatch((0, _paymentActions.fetchCoupon)(couponCode));
	        },
	        dispatchClearCoupon: function dispatchClearCoupon() {
	            return dispatch((0, _paymentActions.clearCoupon)());
	        },
	        dispatchResetPayment: function dispatchResetPayment() {
	            return dispatch((0, _paymentActions.resetPayment)());
	        },
	        dispatchFetchUpcomingInvoice: function dispatchFetchUpcomingInvoice(params) {
	            return dispatch((0, _paymentActions.fetchUpcomingInvoice)(params));
	        },
	        dispatchSetProrateDate: function dispatchSetProrateDate(date) {
	            return dispatch((0, _paymentActions.setProrateDate)(date));
	        }
	    };
	};
	
	var connectSubmitToProps = function connectSubmitToProps(dispatch, ownProps) {
	    return {
	        onSubmit: function onSubmit(values) {
	            var ownCoupon = ownProps.coupon && ownProps.coupon.get('id');
	
	            // if we have an unsubmitted coupon field, fetch the coupn
	            if (values.coupon && (!ownCoupon || values.coupon !== ownCoupon)) {
	                return ownProps.dispatchFetchCoupon(values.coupon).then(function (result) {
	                    // if the fetched coupon is valid, proceed to submitting the form
	                    if ((0, _lodash.get)(result, ['coupon', 'valid'])) return dispatch((0, _paymentActions.submitPaymentForm)(values));
	                });
	            }
	
	            // if no coupon value, just submit the form
	            return dispatch((0, _paymentActions.submitPaymentForm)(values));
	        }
	    };
	};
	
	var Payment = (_dec = (0, _reactRedux.connect)(_paymentSelector.paymentSelector, mapDispatchToProps), _dec2 = (0, _reactRedux.connect)(null, connectSubmitToProps), _dec3 = (0, _milanoteForm2.default)({ form: _paymentConstants.PAYMENT_FORM_NAME, fieldsConfig: _paymentConstants.PAYMENT_FORM_FIELDS }, _paymentSelector.paymentFormValuesSelector), _dec4 = (0, _recompose.withHandlers)({
	    handleCouponButtonClick: function handleCouponButtonClick(_ref) {
	        var values = _ref.values,
	            dispatchFetchCoupon = _ref.dispatchFetchCoupon;
	        return function (event) {
	            return dispatchFetchCoupon(values.coupon);
	        };
	    }
	}), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = function (_React$Component) {
	    _inherits(Payment, _React$Component);
	
	    function Payment() {
	        var _ref2;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Payment);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Payment.__proto__ || Object.getPrototypeOf(Payment)).call.apply(_ref2, [this].concat(args))), _this), _this.checkUpcomingCost = function (nextProps) {
	            var currentUser = nextProps.currentUser,
	                dispatchFetchUpcomingInvoice = nextProps.dispatchFetchUpcomingInvoice,
	                submitting = nextProps.submitting;
	
	            if (submitting) return;
	            if (!(0, _userUtil.isSubscribed)(currentUser)) return;
	
	            var prorateDate = (0, _lodash.get)(_this.props, ['values', 'prorateDate']);
	            var nextProrateDate = (0, _lodash.get)(nextProps, ['values', 'prorateDate']);
	            if (!nextProrateDate) return;
	
	            var interval = (0, _lodash.get)(_this.props, ['values', 'plan']);
	            var nextInterval = (0, _lodash.get)(nextProps, ['values', 'plan']);
	
	            var coupon = (0, _lodash.get)(_this.props, 'coupon');
	            var nextCoupon = (0, _lodash.get)(nextProps, 'coupon');
	
	            var couponId = coupon && coupon.get('valid') ? coupon.get('id') : undefined;
	
	            var nextCouponId = nextCoupon && nextCoupon.get('valid') ? nextCoupon.get('id') : undefined;
	
	            if (interval === nextInterval && couponId === nextCouponId && prorateDate === nextProrateDate) return;
	
	            dispatchFetchUpcomingInvoice({
	                subscriptionId: currentUser.get('subscriptionId'),
	                customerId: currentUser.get('customerId'),
	                planInterval: nextInterval,
	                planVolume: 1,
	                coupon: nextCouponId,
	                prorateDate: nextProrateDate
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Payment, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatchLoadPlans = _props.dispatchLoadPlans,
	                planVolume = _props.planVolume,
	                plans = _props.plans,
	                dispatchSetProrateDate = _props.dispatchSetProrateDate;
	
	
	            (0, _planEnquiryAnalyticsService.individualPlanEnquiryAnalytics)();
	            dispatchSetProrateDate((0, _timeUtil.getTimestampSeconds)());
	
	            if (!plans) dispatchLoadPlans(planVolume);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.checkUpcomingCost(nextProps);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'Payment' },
	                _react2.default.createElement(_LoadingTransitionDisplay2.default, _extends({}, this.props, {
	                    isLoading: this.props.viewState === _paymentConstants.PAYMENT_VIEW_STATES.PROCESSING,
	                    isSuccessful: this.props.viewState === _paymentConstants.PAYMENT_VIEW_STATES.SUCCESS,
	                    InitialComponent: _PaymentForm2.default,
	                    LoadingComponent: _PaymentProcessing2.default,
	                    SuccessComponent: _PaymentSuccess2.default }))
	            );
	        }
	    }]);
	
	    return Payment;
	}(_react2.default.Component)) || _class) || _class) || _class) || _class);
	exports.default = Payment;
	
	
	Payment.propTypes = {
	    planVolume: _propTypes2.default.number,
	    viewState: _propTypes2.default.string,
	    currentUser: _propTypes2.default.object,
	    customer: _propTypes2.default.object,
	    coupon: _propTypes2.default.object,
	    plans: _propTypes2.default.object,
	    subscription: _propTypes2.default.object,
	    submitting: _propTypes2.default.bool,
	    values: _propTypes2.default.object,
	
	    dispatchLoadPlans: _propTypes2.default.func,
	    dispatchFetchCoupon: _propTypes2.default.func,
	    dispatchFetchUpcomingInvoice: _propTypes2.default.func,
	    dispatchSetProrateDate: _propTypes2.default.func
	};

/***/ }),
/* 2058 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Fieldset = __webpack_require__(698);
	
	var _Fieldset2 = _interopRequireDefault(_Fieldset);
	
	var _LinkButton = __webpack_require__(74);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	var _FormButton = __webpack_require__(60);
	
	var _FormButton2 = _interopRequireDefault(_FormButton);
	
	var _FormInput = __webpack_require__(96);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _Spinner = __webpack_require__(65);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _paymentUtil = __webpack_require__(244);
	
	__webpack_require__(1241);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Coupon = function Coupon(_ref) {
	    var coupon = _ref.coupon,
	        values = _ref.values,
	        dispatchClearCoupon = _ref.dispatchClearCoupon;
	
	    if (!coupon) return null;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'Coupon' },
	        'Coupon:',
	        ' ',
	        _react2.default.createElement(
	            'span',
	            { className: 'code' },
	            _react2.default.createElement(
	                'strong',
	                null,
	                coupon.get('id')
	            ),
	            ' (',
	            (0, _paymentUtil.describeCoupon)(coupon.toJS()),
	            ')'
	        ),
	        ' ',
	        _react2.default.createElement(
	            _LinkButton2.default,
	            { onClickFn: dispatchClearCoupon, className: 'show-field-button' },
	            'Change'
	        )
	    );
	};
	
	Coupon.propTypes = {
	    coupon: _propTypes2.default.object,
	    values: _propTypes2.default.object,
	    dispatchClearCoupon: _propTypes2.default.func
	};
	
	var CouponSubmitButton = function CouponSubmitButton(_ref2) {
	    var fetching = _ref2.fetching,
	        onClickFn = _ref2.onClickFn;
	    return fetching ? _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Spinner2.default, { show: true })
	    ) : _react2.default.createElement(
	        _FormButton2.default,
	        {
	            className: 'secondary',
	            type: 'button',
	            onClickFn: onClickFn },
	        'Add coupon'
	    );
	};
	
	CouponSubmitButton.propTypes = {
	    fetching: _propTypes2.default.bool,
	    onClickFn: _propTypes2.default.func
	};
	
	var CouponCode = function CouponCode(props) {
	    var coupon = props.coupon,
	        dispatchClearCoupon = props.dispatchClearCoupon,
	        handleCouponButtonClick = props.handleCouponButtonClick;
	
	
	    if (coupon && coupon.get('id') && !coupon.get('error')) {
	        return _react2.default.createElement(Coupon, props);
	    }
	
	    var showField = coupon && (coupon.get('visible') || coupon.get('fetching') || coupon.get('error'));
	
	    if (!showField) {
	        return _react2.default.createElement(
	            _Fieldset2.default,
	            { name: 'CouponCode' },
	            _react2.default.createElement(
	                _LinkButton2.default,
	                { onClickFn: dispatchClearCoupon, className: 'show-field-button' },
	                'Have a coupon code?'
	            )
	        );
	    }
	
	    return _react2.default.createElement(
	        _Fieldset2.default,
	        { name: 'CouponCode' },
	        _react2.default.createElement(
	            'div',
	            { className: 'form-row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'field-info' },
	                _react2.default.createElement(
	                    'label',
	                    { className: 'field-label', htmlFor: 'coupon' },
	                    'Coupon code'
	                ),
	                coupon && coupon.get('error') ? _react2.default.createElement(
	                    'div',
	                    { className: 'field-message error' },
	                    'Sorry, coupon not valid'
	                ) : null
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'field-row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'field' },
	                    _react2.default.createElement(_FormInput2.default, _extends({}, props, {
	                        type: 'text',
	                        name: 'coupon' }))
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'field-button' },
	                    _react2.default.createElement(CouponSubmitButton, {
	                        fetching: coupon && coupon.get('fetching'),
	                        onClickFn: handleCouponButtonClick })
	                )
	            )
	        )
	    );
	};
	
	CouponCode.propTypes = {
	    coupon: _propTypes2.default.object,
	    dispatchClearCoupon: _propTypes2.default.func,
	    handleCouponButtonClick: _propTypes2.default.func
	};
	
	exports.default = CouponCode;

/***/ }),
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	// Analytics
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _planEnquiryAnalyticsService = __webpack_require__(235);
	
	var _FormButton = __webpack_require__(60);
	
	var _FormButton2 = _interopRequireDefault(_FormButton);
	
	var _Form = __webpack_require__(138);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormInput = __webpack_require__(96);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _PrimaryErrorMessage = __webpack_require__(230);
	
	var _PrimaryErrorMessage2 = _interopRequireDefault(_PrimaryErrorMessage);
	
	var _CreditCardContainer = __webpack_require__(699);
	
	var _CreditCardContainer2 = _interopRequireDefault(_CreditCardContainer);
	
	var _PaymentPlanList = __webpack_require__(2060);
	
	var _PaymentPlanList2 = _interopRequireDefault(_PaymentPlanList);
	
	var _PaymentSummary = __webpack_require__(2061);
	
	var _PaymentSummary2 = _interopRequireDefault(_PaymentSummary);
	
	var _CouponCode = __webpack_require__(2058);
	
	var _CouponCode2 = _interopRequireDefault(_CouponCode);
	
	var _userUtil = __webpack_require__(31);
	
	var _stringUtil = __webpack_require__(58);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaymentFormTitle = function PaymentFormTitle(_ref) {
	    var currentUser = _ref.currentUser,
	        planVolume = _ref.planVolume;
	
	    if ((0, _userUtil.isSubscribed)(currentUser)) {
	        return (0, _stringUtil.chooseSingular)(planVolume, _react2.default.createElement(
	            'h1',
	            null,
	            'Update your billing details'
	        ), _react2.default.createElement(
	            'h1',
	            null,
	            'Update billing details (',
	            planVolume,
	            '\xA0people)'
	        ));
	    }
	
	    return (0, _stringUtil.chooseSingular)(planVolume, _react2.default.createElement(
	        'h1',
	        null,
	        'Professional plan upgrade'
	    ), _react2.default.createElement(
	        'h1',
	        null,
	        'Professional upgrade (',
	        planVolume,
	        '\xA0people)'
	    ));
	};
	
	PaymentFormTitle.propTypes = {
	    currentUser: _propTypes2.default.object,
	    planVolume: _propTypes2.default.number
	};
	
	var PaymentForm = function PaymentForm(props) {
	    var submitInterceptor = props.submitInterceptor,
	        currentUser = props.currentUser,
	        submitting = props.submitting,
	        primaryError = props.primaryError,
	        dirtySinceSubmission = props.dirtySinceSubmission;
	
	
	    var onClick = (0, _userUtil.isSubscribed)(currentUser) ? _lodash.identity : _planEnquiryAnalyticsService.googleAnalyticsIndividualPayment;
	
	    return _react2.default.createElement(
	        _Form2.default,
	        { onSubmit: submitInterceptor, className: 'PaymentForm' },
	        _react2.default.createElement(PaymentFormTitle, props),
	        _react2.default.createElement(_FormInput2.default, _extends({}, props, { name: 'prorateDate', type: 'hidden' })),
	        _react2.default.createElement(_PaymentPlanList2.default, props),
	        _react2.default.createElement(_CreditCardContainer2.default, props),
	        _react2.default.createElement(_CouponCode2.default, props),
	        _react2.default.createElement(_PaymentSummary2.default, props),
	        _react2.default.createElement(_PrimaryErrorMessage2.default, { message: primaryError && primaryError.message,
	            show: !!primaryError && !dirtySinceSubmission && !submitting }),
	        _react2.default.createElement(
	            _FormButton2.default,
	            { onClickFn: onClick, type: 'submit', className: 'row payment', disabled: submitting },
	            (0, _userUtil.isSubscribed)(currentUser) ? 'Save changes' : 'Buy now'
	        )
	    );
	};
	
	PaymentForm.propTypes = {
	    currentUser: _propTypes2.default.object,
	    submitting: _propTypes2.default.bool,
	    pristine: _propTypes2.default.bool,
	    submitInterceptor: _propTypes2.default.func,
	    primaryError: _propTypes2.default.object,
	    dirtySinceSubmission: _propTypes2.default.bool
	};
	
	exports.default = PaymentForm;

/***/ }),
/* 2060 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RadioInput = __webpack_require__(1776);
	
	var _RadioInput2 = _interopRequireDefault(_RadioInput);
	
	var _Spinner = __webpack_require__(65);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _paymentConstants = __webpack_require__(484);
	
	var _paymentUtil = __webpack_require__(244);
	
	var _currencyUtil = __webpack_require__(325);
	
	__webpack_require__(1242);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var PaymentPlan = function PaymentPlan(_ref) {
	    var plan = _ref.plan,
	        planVolume = _ref.planVolume,
	        props = _objectWithoutProperties(_ref, ['plan', 'planVolume']);
	
	    var period = plan.get('interval');
	    var price = (0, _paymentUtil.centsToDollars)(plan.get('amount') * planVolume);
	    var priceMonthly = (0, _paymentUtil.convertPriceUnits)(price, period, _paymentConstants.PRICE_BILLING_UNITS.month);
	    var currency = (0, _currencyUtil.getCurrencySymbol)(plan.get('currency'));
	    var savePercent = plan.getIn(['metadata', 'save_percent']);
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'field-row' },
	        _react2.default.createElement(
	            'div',
	            { className: 'field' },
	            _react2.default.createElement(
	                'label',
	                { className: 'plan' },
	                _react2.default.createElement(_RadioInput2.default, _extends({}, props, {
	                    name: 'plan',
	                    value: period,
	                    type: 'radio',
	                    className: 'radio' })),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'describe' },
	                    'Billed ',
	                    period + 'ly',
	                    savePercent ? _react2.default.createElement(
	                        'span',
	                        { className: 'save' },
	                        ' (save ',
	                        savePercent,
	                        '%)'
	                    ) : null
	                ),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'price' },
	                    currency,
	                    priceMonthly,
	                    ' / month'
	                )
	            )
	        )
	    );
	};
	
	PaymentPlan.propTypes = {
	    plan: _propTypes2.default.object,
	    planVolume: _propTypes2.default.number
	};
	
	var PaymentPlanList = function PaymentPlanList(props) {
	    var plans = props.plans;
	
	
	    if (!plans) {
	        return _react2.default.createElement(
	            'div',
	            { className: 'PaymentPlanList' },
	            _react2.default.createElement(_Spinner2.default, { show: true })
	        );
	    }
	
	    var plansOrdered = plans.sort(function (a, b) {
	        return (0, _paymentUtil.convertPriceUnits)(a.get('amount'), a.get('interval'), _paymentConstants.PRICE_BILLING_UNITS.month) - (0, _paymentUtil.convertPriceUnits)(b.get('amount'), b.get('interval'), _paymentConstants.PRICE_BILLING_UNITS.month);
	    });
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'PaymentPlanList' },
	        plansOrdered.map(function (plan) {
	            return _react2.default.createElement(PaymentPlan, _extends({}, props, { plan: plan, key: plan.get('id') }));
	        })
	    );
	};
	
	PaymentPlanList.propTypes = {
	    plans: _propTypes2.default.object
	};
	
	exports.default = PaymentPlanList;

/***/ }),
/* 2061 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _paymentUtil = __webpack_require__(244);
	
	var _currencyUtil = __webpack_require__(325);
	
	var _Spinner = __webpack_require__(65);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	__webpack_require__(1243);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaymentAmount = function PaymentAmount(_ref) {
	    var coupon = _ref.coupon,
	        plan = _ref.plan,
	        planVolume = _ref.planVolume,
	        upcomingInvoice = _ref.upcomingInvoice;
	
	    if (upcomingInvoice && upcomingInvoice.get('fetching')) return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(_Spinner2.default, { show: true })
	    );
	
	    var planAmount = (0, _paymentUtil.calculateCouponDiscount)(coupon, plan.get('amount') * planVolume);
	
	    var invoiceAmount = void 0;
	    if (upcomingInvoice) {
	        invoiceAmount = upcomingInvoice.get('amountDue');
	    } else {
	        invoiceAmount = planAmount;
	    }
	
	    var currency = (0, _currencyUtil.getCurrencySymbol)(plan.get('currency'));
	
	    return _react2.default.createElement(
	        'span',
	        null,
	        currency,
	        (0, _paymentUtil.centsToDollars)(invoiceAmount)
	    );
	};
	
	PaymentAmount.propTypes = {
	    coupon: _propTypes2.default.object,
	    plan: _propTypes2.default.object,
	    planVolume: _propTypes2.default.number,
	    upcomingInvoice: _propTypes2.default.object
	};
	
	var PaymentSummary = function PaymentSummary(_ref2) {
	    var fields = _ref2.fields,
	        plans = _ref2.plans,
	        planVolume = _ref2.planVolume,
	        coupon = _ref2.coupon,
	        upcomingInvoice = _ref2.upcomingInvoice;
	
	    if (!plans) return _react2.default.createElement('div', { className: 'PaymentSummary' });
	
	    var selectedPlanValue = (0, _lodash.get)(fields, ['plan', 'value']);
	    var plan = plans.filter(function (filterPlan) {
	        return filterPlan.get('interval') === selectedPlanValue;
	    }).first();
	
	    var couponJs = coupon && coupon.toJS();
	    var planAmount = (0, _paymentUtil.calculateCouponDiscount)(couponJs, plan.get('amount') * planVolume);
	
	    var period = plan.get('interval');
	    var currency = (0, _currencyUtil.getCurrencySymbol)(plan.get('currency'));
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'PaymentSummary' },
	        _react2.default.createElement(
	            'div',
	            { className: 'summary' },
	            _react2.default.createElement(
	                'span',
	                null,
	                'Billed now'
	            ),
	            _react2.default.createElement(PaymentAmount, {
	                coupon: couponJs,
	                plan: plan,
	                planVolume: planVolume,
	                upcomingInvoice: upcomingInvoice })
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'disclaimer' },
	            'You\'ll be charged ',
	            currency,
	            (0, _paymentUtil.centsToDollars)(planAmount),
	            ' ',
	            period,
	            'ly (including applicable taxes) until you cancel your subscription. Previous charges won\u2019t be refunded when you cancel unless it\u2019s legally required.'
	        )
	    );
	};
	
	PaymentSummary.propTypes = {
	    fields: _propTypes2.default.object,
	    plans: _propTypes2.default.object,
	    coupon: _propTypes2.default.object,
	    upcomingInvoice: _propTypes2.default.object,
	    planVolume: _propTypes2.default.number
	};
	
	exports.default = PaymentSummary;

/***/ }),
/* 2062 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Utils
	
	
	// Constants
	
	
	var _formSubReducerWrapper = __webpack_require__(229);
	
	var _formSubReducerWrapper2 = _interopRequireDefault(_formSubReducerWrapper);
	
	var _paymentConstants = __webpack_require__(202);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var paymentFormReducer = function paymentFormReducer(state, action) {
	    switch (action.type) {
	        case _paymentConstants.PAYMENT_CARD_CLEAR:
	            return _extends({}, state, {
	                number: { value: undefined },
	                expiry: { value: undefined },
	                cvc: { value: undefined },
	                cardBrand: { value: undefined },
	                postcode: { value: undefined },
	                cardName: { value: undefined },
	                cardPrefilled: { value: false }
	            });
	        default:
	            return state;
	    }
	};
	
	exports.default = (0, _formSubReducerWrapper2.default)(paymentFormReducer, _paymentConstants.PAYMENT_FORM_NAME);

/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _paymentConstants = __webpack_require__(202);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Initial state
	var initialState = Immutable.fromJS({
	    viewState: _paymentConstants.PAYMENT_VIEW_STATES.CARD_FORM,
	    plans: undefined,
	    coupon: undefined,
	    upcomingInvoice: undefined,
	    prorateDate: undefined
	});
	
	var fetching = Immutable.Map({ fetching: true });
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _paymentConstants.PAYMENT_SET_VIEW_STATE:
	            return state.set('viewState', action.viewState);
	        case _paymentConstants.PAYMENT_PLANS_FETCHING:
	            return state.set('plans', undefined);
	        case _paymentConstants.PAYMENT_PLANS_FETCHED:
	            return state.set('plans', Immutable.fromJS(action.plans));
	        case _paymentConstants.PAYMENT_PLANS_FAILED:
	            return state.set('plans', undefined);
	        case _paymentConstants.PAYMENT_COUPON_FETCHING:
	            return state.set('coupon', fetching);
	        case _paymentConstants.PAYMENT_COUPON_FETCHED:
	            return state.set('coupon', Immutable.fromJS(action.coupon));
	        case _paymentConstants.PAYMENT_COUPON_FAILED:
	            return state.set('coupon', Immutable.fromJS(action.coupon));
	        case _paymentConstants.PAYMENT_COUPON_CLEAR:
	            return state.set('coupon', Immutable.fromJS({ visible: true }));
	        case _paymentConstants.PAYMENT_UPCOMING_FETCHING:
	            return state.set('upcomingInvoice', fetching);
	        case _paymentConstants.PAYMENT_UPCOMING_FETCHED:
	            return state.set('upcomingInvoice', Immutable.fromJS(action.invoice));
	        case _paymentConstants.PAYMENT_UPCOMING_FAILED:
	            return state.set('upcomingInvoice', undefined);
	        case _paymentConstants.PAYMENT_SET_PRORATE_DATE:
	            return state.set('prorateDate', action.date);
	        case 'redux-form/DESTROY':
	            if (action.form === _paymentConstants.PAYMENT_FORM_NAME) return initialState;
	            return state;
	        default:
	            return state;
	    }
	};

/***/ }),
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ProcessingPage = __webpack_require__(297);
	
	var _ProcessingPage2 = _interopRequireDefault(_ProcessingPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaymentProcessing = function PaymentProcessing(props) {
	    return _react2.default.createElement(
	        _ProcessingPage2.default,
	        null,
	        _react2.default.createElement(
	            'h1',
	            null,
	            'Processing your payment'
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            'This should only take a few seconds\u2026'
	        ),
	        _react2.default.createElement(
	            'p',
	            { className: 'disclaimer' },
	            _react2.default.createElement(
	                'a',
	                { href: 'mailto:support@milanote.com' },
	                'Report a problem'
	            )
	        )
	    );
	};
	
	exports.default = PaymentProcessing;

/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Trophy = __webpack_require__(2066);
	
	var _Trophy2 = _interopRequireDefault(_Trophy);
	
	var _FormButton = __webpack_require__(60);
	
	var _FormButton2 = _interopRequireDefault(_FormButton);
	
	var _FlexCenter = __webpack_require__(198);
	
	var _FlexCenter2 = _interopRequireDefault(_FlexCenter);
	
	__webpack_require__(1244);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaymentSuccess = function PaymentSuccess(_ref) {
	    var dispatchResetPayment = _ref.dispatchResetPayment;
	    return _react2.default.createElement(
	        _FlexCenter2.default,
	        { className: 'PaymentSuccess' },
	        _react2.default.createElement(_Trophy2.default, null),
	        _react2.default.createElement(
	            'h1',
	            null,
	            'Congratulations'
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            'You\u2019ve upgraded to professional plan'
	        ),
	        _react2.default.createElement(
	            _FormButton2.default,
	            { className: 'primary', onClickFn: dispatchResetPayment },
	            'OK'
	        )
	    );
	};
	
	PaymentSuccess.propTypes = {
	    dispatchResetPayment: _propTypes2.default.func
	};
	
	exports.default = PaymentSuccess;

/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ParticleEmitter = __webpack_require__(1700);
	
	var _ParticleEmitter2 = _interopRequireDefault(_ParticleEmitter);
	
	__webpack_require__(1245);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Trophy = function Trophy(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'Trophy' },
	        _react2.default.createElement(_Icon2.default, { name: 'payment-trophy' }),
	        _react2.default.createElement(
	            _ParticleEmitter2.default,
	            {
	                stopAfter: 35,
	                particleFrequency: 7,
	                initalVelocityX: { min: -1.5, max: 1.5 },
	                initalVelocityY: { min: -6, max: -4 } },
	            _react2.default.createElement(_Icon2.default, { name: 'payment-star' })
	        )
	    );
	};
	
	exports.default = Trophy;

/***/ }),
/* 2067 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reselect = __webpack_require__(7);
	
	var _userUtil = __webpack_require__(31);
	
	var _currentUserSelector = __webpack_require__(33);
	
	var _teamManagementActions = __webpack_require__(310);
	
	var _UpgradePlan = __webpack_require__(2076);
	
	var _UpgradePlan2 = _interopRequireDefault(_UpgradePlan);
	
	var _PlanPro = __webpack_require__(2068);
	
	var _PlanPro2 = _interopRequireDefault(_PlanPro);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var planSelector = (0, _reselect.createStructuredSelector)({
	    currentUser: _currentUserSelector.getCurrentUser,
	    isSubscriptionAdmin: _currentUserSelector.currentUserIsSubscriptionAdminSelector,
	    subscription: _currentUserSelector.getCurrentUserSubscription,
	    subscriptionDetail: _currentUserSelector.getCurrentUserSubscriptionDetail,
	    subscriptionTeam: _currentUserSelector.subscriptionTeamSelector,
	    customer: _currentUserSelector.getCurrentUserCustomer,
	    subscriptionAdminUser: _currentUserSelector.subscriptionAdminUserSelector
	});
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        revertTeamList: function revertTeamList(userIds) {
	            return dispatch((0, _teamManagementActions.setTeamMembers)({ userIds: userIds }));
	        }
	    };
	};
	
	var CurrentPlan = function (_React$Component) {
	    _inherits(CurrentPlan, _React$Component);
	
	    function CurrentPlan() {
	        _classCallCheck(this, CurrentPlan);
	
	        return _possibleConstructorReturn(this, (CurrentPlan.__proto__ || Object.getPrototypeOf(CurrentPlan)).apply(this, arguments));
	    }
	
	    _createClass(CurrentPlan, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                currentUser = _props.currentUser,
	                subscription = _props.subscription,
	                revertTeamList = _props.revertTeamList;
	
	
	            var userIds = subscription && subscription.get('teamMemberIds') ? subscription.get('teamMemberIds').toArray() : [currentUser.get('_id')];
	
	            revertTeamList(userIds);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if ((0, _userUtil.isSubscribed)(this.props.currentUser)) return _react2.default.createElement(_PlanPro2.default, this.props);
	            return _react2.default.createElement(_UpgradePlan2.default, this.props);
	        }
	    }]);
	
	    return CurrentPlan;
	}(_react2.default.Component);
	
	CurrentPlan.propTypes = {
	    currentUser: _propTypes2.default.object,
	    subscription: _propTypes2.default.object,
	    revertTeamList: _propTypes2.default.func
	};
	
	exports.default = (0, _reactRedux.connect)(planSelector, mapDispatchToProps)(CurrentPlan);

/***/ }),
/* 2068 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reselect = __webpack_require__(7);
	
	var _reactRedux = __webpack_require__(3);
	
	var _ProcessingPage = __webpack_require__(297);
	
	var _ProcessingPage2 = _interopRequireDefault(_ProcessingPage);
	
	var _FlexCenter = __webpack_require__(198);
	
	var _FlexCenter2 = _interopRequireDefault(_FlexCenter);
	
	var _PlanTypeDetailSection = __webpack_require__(2074);
	
	var _PlanTypeDetailSection2 = _interopRequireDefault(_PlanTypeDetailSection);
	
	var _PlanCardDetailSection = __webpack_require__(2071);
	
	var _PlanCardDetailSection2 = _interopRequireDefault(_PlanCardDetailSection);
	
	var _PlanStorageDetailSection = __webpack_require__(2072);
	
	var _PlanStorageDetailSection2 = _interopRequireDefault(_PlanStorageDetailSection);
	
	var _PlanBillingDetailSection = __webpack_require__(2069);
	
	var _PlanBillingDetailSection2 = _interopRequireDefault(_PlanBillingDetailSection);
	
	var _PlanTeamDetailSection = __webpack_require__(2073);
	
	var _PlanTeamDetailSection2 = _interopRequireDefault(_PlanTeamDetailSection);
	
	var _PlanCancelSection = __webpack_require__(2070);
	
	var _PlanCancelSection2 = _interopRequireDefault(_PlanCancelSection);
	
	var _elementCountSelector = __webpack_require__(170);
	
	__webpack_require__(1246);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var countSelector = (0, _reselect.createStructuredSelector)({
	    elementCount: _elementCountSelector.contentElementCountSelector
	});
	
	var UpgradePlan = function UpgradePlan(props) {
	    var subscriptionDetail = props.subscriptionDetail;
	
	
	    if (!subscriptionDetail) return _react2.default.createElement(_ProcessingPage2.default, null);
	
	    return _react2.default.createElement(
	        _FlexCenter2.default,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'PlanPro' },
	            _react2.default.createElement(_PlanTypeDetailSection2.default, props),
	            _react2.default.createElement(_PlanStorageDetailSection2.default, props),
	            _react2.default.createElement(_PlanCardDetailSection2.default, props),
	            _react2.default.createElement(_PlanBillingDetailSection2.default, props),
	            _react2.default.createElement(_PlanTeamDetailSection2.default, props),
	            _react2.default.createElement(_PlanCancelSection2.default, props)
	        )
	    );
	};
	
	UpgradePlan.propTypes = {
	    subscriptionDetail: _propTypes2.default.object,
	    elementCount: _propTypes2.default.object
	};
	
	exports.default = (0, _reactRedux.connect)(countSelector)(UpgradePlan);

/***/ }),
/* 2069 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(45);
	
	var _paymentUtil = __webpack_require__(244);
	
	var _currencyUtil = __webpack_require__(325);
	
	var _paymentConstants = __webpack_require__(484);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlanBillingDetailSection = function PlanBillingDetailSection(_ref) {
	    var subscriptionDetail = _ref.subscriptionDetail,
	        isSubscriptionAdmin = _ref.isSubscriptionAdmin;
	
	    if (!subscriptionDetail) return null;
	    if (!isSubscriptionAdmin) return null;
	
	    var coupon = subscriptionDetail.getIn(['discount', 'coupon']);
	    var couponOb = coupon ? coupon.toJS() : {};
	
	    var plan = subscriptionDetail.get('plan');
	    var planCost = plan.get('amount');
	    var interval = plan.get('interval');
	    var volume = subscriptionDetail.get('quantity');
	
	    var currency = (0, _currencyUtil.getCurrencySymbol)(plan.get('currency'));
	    var price = (0, _paymentUtil.centsToDollars)((0, _paymentUtil.calculateCouponDiscount)(couponOb, (0, _paymentUtil.convertPriceUnits)(planCost, interval, _paymentConstants.PRICE_BILLING_UNITS.month) * volume));
	
	    var billingFrequency = (0, _paymentUtil.describeFrequency)(interval);
	
	    return _react2.default.createElement(
	        'section',
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'detail' },
	            _react2.default.createElement(
	                'p',
	                { className: 'section-title' },
	                'You\'re paying ',
	                currency,
	                price,
	                ' / month'
	            ),
	            _react2.default.createElement(
	                'p',
	                { className: 'paren' },
	                'Billed ',
	                billingFrequency,
	                ' ',
	                _react2.default.createElement('br', null)
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'action' },
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: '/account/payment' },
	                    'Change billing frequency'
	                )
	            )
	        )
	    );
	};
	
	PlanBillingDetailSection.propTypes = {
	    subscriptionDetail: _propTypes2.default.object,
	    isSubscriptionAdmin: _propTypes2.default.bool
	};
	
	exports.default = PlanBillingDetailSection;

/***/ }),
/* 2070 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(45);
	
	var _userUtil = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var NonAdminPlanCancelSection = function NonAdminPlanCancelSection(_ref) {
	    var subscriptionAdminUser = _ref.subscriptionAdminUser;
	
	    if (!subscriptionAdminUser) return null;
	
	    var adminName = (0, _userUtil.getDisplayName)(subscriptionAdminUser);
	    var adminEmail = subscriptionAdminUser.get('email');
	    var adminMailTo = 'mailto:' + adminEmail;
	
	    return _react2.default.createElement(
	        'section',
	        { className: 'downgrade' },
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'p',
	                null,
	                'Your subscription admin is',
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    ' ',
	                    adminName,
	                    ' '
	                ),
	                '(',
	                _react2.default.createElement(
	                    'a',
	                    { href: adminMailTo },
	                    adminEmail
	                ),
	                '). Please contact them to modifiy your plan.'
	            )
	        )
	    );
	};
	
	NonAdminPlanCancelSection.propTypes = {
	    subscriptionAdminUser: _propTypes2.default.object
	};
	
	var AdminPlanCancelSection = function AdminPlanCancelSection(props) {
	    return _react2.default.createElement(
	        'section',
	        { className: 'downgrade' },
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: '/account/cancel' },
	                    'Downgrade to the free plan'
	                )
	            )
	        )
	    );
	};
	
	var PlanCancelSection = function PlanCancelSection(_ref2) {
	    var isSubscriptionAdmin = _ref2.isSubscriptionAdmin,
	        props = _objectWithoutProperties(_ref2, ['isSubscriptionAdmin']);
	
	    return isSubscriptionAdmin ? _react2.default.createElement(AdminPlanCancelSection, props) : _react2.default.createElement(NonAdminPlanCancelSection, props);
	};
	
	PlanCancelSection.propTypes = {
	    isSubscriptionAdmin: _propTypes2.default.bool
	};
	
	exports.default = PlanCancelSection;

/***/ }),
/* 2071 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlanCardDetailSection = function PlanCardDetailSection(_ref) {
	    var customer = _ref.customer,
	        isSubscriptionAdmin = _ref.isSubscriptionAdmin;
	
	    if (!customer || !isSubscriptionAdmin) return null;
	
	    var sources = customer.getIn(['sources', 'data']);
	    var card = sources && sources.first();
	
	    var cardBrand = card && card.get('brand') || 'Unknown type';
	    var last4 = card && card.get('last4') || '••••';
	    var cardNumber = '\u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022 ' + last4;
	
	    return _react2.default.createElement(
	        'section',
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'detail' },
	            _react2.default.createElement(
	                'p',
	                { className: 'section-title' },
	                'You\'re paying via credit card'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'span',
	                    { className: 'paren' },
	                    cardBrand,
	                    ' (',
	                    cardNumber,
	                    ')'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'action' },
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: '/account/card' },
	                    'Update card details'
	                )
	            )
	        )
	    );
	};
	
	PlanCardDetailSection.propTypes = {
	    customer: _propTypes2.default.object,
	    isSubscriptionAdmin: _propTypes2.default.bool
	};
	
	exports.default = PlanCardDetailSection;

/***/ }),
/* 2072 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _notificationUtils = __webpack_require__(324);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlanStorageDetailSection = function PlanStorageDetailSection(_ref) {
	    var elementCount = _ref.elementCount;
	
	    if (!elementCount) return null;
	
	    var countDetail = (0, _notificationUtils.describeElementTypes)(elementCount.toJS());
	
	    return _react2.default.createElement(
	        'section',
	        null,
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'p',
	                { className: 'section-title' },
	                'Unlimited storage'
	            ),
	            _react2.default.createElement(
	                'p',
	                { className: 'usage' },
	                'You\'ve added ',
	                countDetail
	            )
	        )
	    );
	};
	
	PlanStorageDetailSection.propTypes = {
	    elementCount: _propTypes2.default.object
	};
	
	exports.default = PlanStorageDetailSection;

/***/ }),
/* 2073 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(45);
	
	var _userUtil = __webpack_require__(31);
	
	var _stringUtil = __webpack_require__(58);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LIST_LIMIT = 3;
	
	var PlanIndividualDetail = function PlanIndividualDetail(_ref) {
	    var isSubscriptionAdmin = _ref.isSubscriptionAdmin;
	    return _react2.default.createElement(
	        'section',
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'detail' },
	            _react2.default.createElement(
	                'p',
	                { className: 'section-title' },
	                'You are on an individual plan'
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'action' },
	            isSubscriptionAdmin ? _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: '/account/team' },
	                    'Add team members'
	                )
	            ) : null
	        )
	    );
	};
	
	var TeamMemberUser = function TeamMemberUser(_ref2) {
	    var user = _ref2.user,
	        subscription = _ref2.subscription;
	
	    if (!user) return null;
	
	    return _react2.default.createElement(
	        'span',
	        null,
	        (0, _userUtil.getDisplayName)(user),
	        (0, _userUtil.isUserSubscriptionAdmin)(user, subscription) ? _react2.default.createElement(
	            'strong',
	            null,
	            ' (admin)'
	        ) : null
	    );
	};
	
	TeamMemberUser.propTypes = {
	    user: _propTypes2.default.object,
	    subscription: _propTypes2.default.object
	};
	
	var PlanTeamDetail = function PlanTeamDetail(_ref3) {
	    var subscriptionTeam = _ref3.subscriptionTeam,
	        subscription = _ref3.subscription,
	        isSubscriptionAdmin = _ref3.isSubscriptionAdmin;
	
	    var teamSize = subscriptionTeam.size;
	
	    var teamList = subscriptionTeam.sort(function (a, b) {
	        if ((0, _userUtil.isUserSubscriptionAdmin)(a, subscription)) return -1;
	        if ((0, _userUtil.isUserSubscriptionAdmin)(b, subscription)) return 1;
	
	        var nameA = (0, _userUtil.getDisplayName)(a);
	        var nameB = (0, _userUtil.getDisplayName)(b);
	        if (nameA < nameB) return -1;
	        if (nameA > nameB) return 1;
	
	        return 0;
	    }).slice(0, LIST_LIMIT);
	
	    var remainderSize = subscriptionTeam.size - LIST_LIMIT;
	
	    return _react2.default.createElement(
	        'section',
	        { className: 'wide' },
	        _react2.default.createElement(
	            'div',
	            { className: 'detail' },
	            _react2.default.createElement(
	                'p',
	                { className: 'section-title' },
	                'Your team has ',
	                teamSize,
	                ' ',
	                (0, _stringUtil.pluralise)('member', teamSize)
	            ),
	            _react2.default.createElement(
	                'p',
	                { className: 'usage' },
	                teamList.map(function (user, i, list) {
	                    return _react2.default.createElement(
	                        'span',
	                        { key: i },
	                        _react2.default.createElement(TeamMemberUser, { user: user, subscription: subscription }),
	                        (0, _stringUtil.listSeparator)(i, list.size)
	                    );
	                }),
	                remainderSize > 0 ? _react2.default.createElement(
	                    'span',
	                    null,
	                    ' ',
	                    '+ ',
	                    remainderSize,
	                    ' more...'
	                ) : null
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'action' },
	            isSubscriptionAdmin ? _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: '/account/team' },
	                    'Manage team'
	                )
	            ) : null
	        )
	    );
	};
	
	var PlanTeamDetailSection = function PlanTeamDetailSection(props) {
	    var subscriptionTeam = props.subscriptionTeam;
	
	
	    if (!subscriptionTeam) return null;
	    var teamSize = subscriptionTeam.size;
	
	    return teamSize > 1 ? _react2.default.createElement(PlanTeamDetail, props) : _react2.default.createElement(PlanIndividualDetail, props);
	};
	
	PlanIndividualDetail.propTypes = PlanTeamDetail.propTypes = PlanTeamDetailSection.propTypes = {
	    subscription: _propTypes2.default.object,
	    subscriptionTeam: _propTypes2.default.object,
	    isSubscriptionAdmin: _propTypes2.default.bool
	};
	
	exports.default = PlanTeamDetailSection;

/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _UserPlanBadge = __webpack_require__(446);
	
	var _UserPlanBadge2 = _interopRequireDefault(_UserPlanBadge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlanTypeDetailSection = function PlanTypeDetailSection(_ref) {
	    var subscriptionDetail = _ref.subscriptionDetail,
	        currentUser = _ref.currentUser;
	
	    if (!subscriptionDetail) return null;
	
	    return _react2.default.createElement(
	        'section',
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'plan' },
	            _react2.default.createElement(
	                'div',
	                { className: 'status' },
	                _react2.default.createElement(
	                    'h1',
	                    null,
	                    'You\u2019re on the Professional plan'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_UserPlanBadge2.default, { user: currentUser })
	            )
	        )
	    );
	};
	
	PlanTypeDetailSection.propTypes = {
	    currentUser: _propTypes2.default.object,
	    subscriptionDetail: _propTypes2.default.object
	};
	
	exports.default = PlanTypeDetailSection;

/***/ }),
/* 2075 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1247);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlanOption = function PlanOption(_ref) {
	    var className = _ref.className,
	        children = _ref.children;
	    return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('PlanOption', className) },
	        children
	    );
	};
	
	PlanOption.propTypes = {
	    className: _propTypes2.default.string,
	    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array])
	};
	
	exports.default = PlanOption;

/***/ }),
/* 2076 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(45);
	
	var _recompose = __webpack_require__(9);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reselect = __webpack_require__(7);
	
	var _planEnquiryAnalyticsService = __webpack_require__(235);
	
	var _PlanOption = __webpack_require__(2075);
	
	var _PlanOption2 = _interopRequireDefault(_PlanOption);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ElementCount = __webpack_require__(774);
	
	var _ElementCount2 = _interopRequireDefault(_ElementCount);
	
	var _elementCountSelector = __webpack_require__(170);
	
	var _notificationConstants = __webpack_require__(88);
	
	__webpack_require__(1248);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	var elementCountSelector = (0, _reselect.createStructuredSelector)({
	    elementCount: _elementCountSelector.contentElementCountSelector,
	    contentTotalCount: _elementCountSelector.contentTotalCountSelector,
	    contentTotalLimit: _elementCountSelector.contentTotalLimitSelector
	});
	
	// Constants
	
	
	// selector
	
	
	// Analytics
	
	
	// Styles
	
	
	var getEmailHref = function getEmailHref(_ref) {
	    var currentUser = _ref.currentUser;
	    return 'mailto:' + _notificationConstants.MILANOTE_EMAILS.SUPPORT + '?subject=Enterprise enquiry: ' + currentUser.get('email') + ('&body=Hi Milanote team,\n' + _notificationConstants.URL_ENCODINGS.NEW_LINE + _notificationConstants.URL_ENCODINGS.NEW_LINE + '\nI\'m interested in your enterprise plans.' + _notificationConstants.URL_ENCODINGS.NEW_LINE + '\nPlease contact ' + currentUser.getIn(['name', 'displayName']) + ' at ' + currentUser.get('email') + '.\n' + _notificationConstants.URL_ENCODINGS.NEW_LINE + _notificationConstants.URL_ENCODINGS.NEW_LINE + '\nThanks');
	};
	
	var UpgradePlan = function UpgradePlan(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'UpgradePlan' },
	        _react2.default.createElement(
	            'div',
	            { className: 'plan-options' },
	            _react2.default.createElement(
	                _PlanOption2.default,
	                null,
	                _react2.default.createElement(_Icon2.default, { name: 'payment-free' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'details' },
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        'Free'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'description' },
	                        'Free with no time limit'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'cta free' },
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'storage' },
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            props.contentTotalLimit,
	                            ' notes, images or links'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'price' },
	                        'FREE'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'count' },
	                        _react2.default.createElement(
	                            _ElementCount2.default,
	                            props,
	                            'Your current plan \u2013',
	                            ' '
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _PlanOption2.default,
	                null,
	                _react2.default.createElement(_Icon2.default, { name: 'payment-individual' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'details' },
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        'Professional'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'description' },
	                        'For solo professionals'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'cta' },
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'storage' },
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Unlimited storage'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'price' },
	                        '$12 / month'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'disclaimer' },
	                        'per person billed annually ',
	                        _react2.default.createElement('br', null),
	                        '$15 when billed monthly'
	                    ),
	                    _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: '/account/payment', className: 'FormButton primary' },
	                        'Upgrade now'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _PlanOption2.default,
	                null,
	                _react2.default.createElement(_Icon2.default, { name: 'payment-team' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'details' },
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        'Professional team'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'description' },
	                        'Sign up 2+ people and save.'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'cta' },
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'storage' },
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Unlimited storage'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'price' },
	                        '$10 / month'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'disclaimer' },
	                        'per person billed annually ',
	                        _react2.default.createElement('br', null),
	                        '$12.50 when billed monthly'
	                    ),
	                    _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: '/account/team', className: 'FormButton primary' },
	                        'Upgrade your team'
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'enterprise-option' },
	            'Part of a larger team?',
	            ' ',
	            _react2.default.createElement(
	                'a',
	                { href: getEmailHref(props), onClick: _planEnquiryAnalyticsService.enterprisePlanEnquiryAnalytics },
	                'Contact us about our enterprise plan'
	            )
	        )
	    );
	};
	
	UpgradePlan.propTypes = {
	    currentUser: _propTypes2.default.object.isRequired,
	    contentTotalLimit: _propTypes2.default.number
	};
	
	var enhance = (0, _recompose.compose)((0, _reactRedux.connect)(elementCountSelector), (0, _recompose.lifecycle)({
	    componentWillMount: _planEnquiryAnalyticsService.googleAnalyticsPlanViewEvent
	}));
	
	exports.default = enhance(UpgradePlan);

/***/ }),
/* 2077 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(9);
	
	var _planEnquiryAnalyticsService = __webpack_require__(235);
	
	var _ReferSheet = __webpack_require__(2078);
	
	var _ReferSheet2 = _interopRequireDefault(_ReferSheet);
	
	__webpack_require__(1249);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	var ReferModal = function ReferModal(props) {
	    return _react2.default.createElement(_ReferSheet2.default, props);
	};
	
	// Analytics
	// Lib
	
	
	var googleAnalyticsReferralViewOnMount = (0, _recompose.lifecycle)({
	    componentWillMount: _planEnquiryAnalyticsService.googleAnalyticsReferralViewEvent
	});
	
	exports.default = googleAnalyticsReferralViewOnMount(ReferModal);

/***/ }),
/* 2078 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reselect = __webpack_require__(7);
	
	var _currentUserSelector = __webpack_require__(33);
	
	var _getAppUrl = __webpack_require__(760);
	
	var _getAppUrl2 = _interopRequireDefault(_getAppUrl);
	
	var _ShareButton = __webpack_require__(1702);
	
	var _ShareButton2 = _interopRequireDefault(_ShareButton);
	
	var _StaticURLField = __webpack_require__(700);
	
	var _StaticURLField2 = _interopRequireDefault(_StaticURLField);
	
	var _ReferralList = __webpack_require__(2079);
	
	var _ReferralList2 = _interopRequireDefault(_ReferralList);
	
	var _userConstants = __webpack_require__(32);
	
	__webpack_require__(1250);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LB = '%0D%0A';
	
	var TWEET_BUTTON_CONTENT = "I've started using @milanoteapp, the notes app for creative work. " + 'You should too! Sign up for free:';
	
	var getReferralURL = function getReferralURL(referrerCode) {
	    return (0, _getAppUrl2.default)() + '/refer/' + referrerCode;
	};
	
	var getEmailBodyContent = function getEmailBodyContent(referralUrl, currentUser) {
	    return 'Hi,' + LB + LB + '\nI\'ve been using a new app which I think you\'d like.' + LB + LB + '\nIt\'s called Milanote. It\'s a visual workspace designed to match the way creative people think.' + LB + LB + '\nSign up for free here:' + LB + '\n' + referralUrl + LB + LB + '\n' + currentUser.getIn(['name', 'givenName']);
	};
	
	var referSheetSelector = (0, _reselect.createSelector)(_currentUserSelector.getCurrentUser, function (state) {
	    return state.get('users');
	}, function (currentUser, users) {
	    return {
	        currentUser: currentUser,
	        users: users,
	        referrerCode: currentUser.get('referrerCode'),
	        referrals: currentUser.get('referrals')
	    };
	});
	
	var ReferSheet = function ReferSheet(props) {
	    var referrerCode = props.referrerCode,
	        users = props.users,
	        currentUser = props.currentUser,
	        referrals = props.referrals;
	
	    var referralUrl = getReferralURL(referrerCode);
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'ReferSheet' },
	        _react2.default.createElement(
	            'div',
	            { className: 'refer-explain' },
	            _react2.default.createElement(
	                'p',
	                null,
	                'Increase your storage by ',
	                _userConstants.CONTENT_LIMIT_REFERRAL_MULTIPLIER,
	                ' cards every time someone signs up using this link (up to a maximum of ',
	                _userConstants.CONTENT_LIMIT_FREE_MAX,
	                ')'
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'refer-link' },
	            _react2.default.createElement(
	                'h3',
	                null,
	                'Your personal referral link:'
	            ),
	            _react2.default.createElement(_StaticURLField2.default, { url: referralUrl })
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'refer-share' },
	            _react2.default.createElement(
	                'h3',
	                null,
	                'Share your link:'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'share-buttons' },
	                _react2.default.createElement(_ShareButton2.default, { service: _ShareButton.SHARE_SERVICES.TWITTER,
	                    url: referralUrl,
	                    defaultContent: TWEET_BUTTON_CONTENT }),
	                _react2.default.createElement(_ShareButton2.default, { service: _ShareButton.SHARE_SERVICES.FACEBOOK,
	                    url: referralUrl,
	                    defaultContent: 'Unlock your creativity Milanote. Sign up for free!' }),
	                _react2.default.createElement(_ShareButton2.default, { service: _ShareButton.SHARE_SERVICES.EMAIL,
	                    defaultContent: 'Milanote',
	                    bodyContent: getEmailBodyContent(referralUrl, currentUser) })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'disclaimer' },
	                'You\'ll get a chance to write a custom message before it\'s posted'
	            )
	        ),
	        _react2.default.createElement(_ReferralList2.default, { referrals: referrals, users: users })
	    );
	};
	
	ReferSheet.propTypes = {
	    currentUser: _propTypes2.default.object,
	    users: _propTypes2.default.object,
	    referrals: _propTypes2.default.object,
	    referrerCode: _propTypes2.default.string
	};
	
	exports.default = (0, _reactRedux.connect)(referSheetSelector)(ReferSheet);

/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _UserAvatar = __webpack_require__(199);
	
	var _UserAvatar2 = _interopRequireDefault(_UserAvatar);
	
	var _UserName = __webpack_require__(445);
	
	var _UserName2 = _interopRequireDefault(_UserName);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _referralUtil = __webpack_require__(2286);
	
	__webpack_require__(1251);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReferralUser = function ReferralUser(_ref) {
	    var user = _ref.user;
	    return _react2.default.createElement(
	        'span',
	        { className: 'ReferralDescription' },
	        _react2.default.createElement(_UserAvatar2.default, { user: user }),
	        _react2.default.createElement(_UserName2.default, { user: user })
	    );
	};
	
	var ReferralDescription = function ReferralDescription(_ref2) {
	    var referral = _ref2.referral;
	    return _react2.default.createElement(
	        'span',
	        { className: 'ReferralDescription' },
	        _react2.default.createElement(
	            'span',
	            { className: 'name' },
	            referral.get('description') || 'Bonus cards'
	        )
	    );
	};
	
	var Referral = function Referral(_ref3) {
	    var referral = _ref3.referral,
	        user = _ref3.user;
	    return _react2.default.createElement(
	        'li',
	        null,
	        user ? _react2.default.createElement(ReferralUser, { user: user }) : _react2.default.createElement(ReferralDescription, { referral: referral }),
	        _react2.default.createElement(
	            'span',
	            { className: 'status' },
	            _react2.default.createElement(_Icon2.default, { name: 'tick' }),
	            (0, _referralUtil.getReferralBonus)(referral),
	            ' extra cards'
	        )
	    );
	};
	
	ReferralUser.propTypes = ReferralDescription.propTypes = Referral.propTypes = {
	    referral: _propTypes2.default.object,
	    user: _propTypes2.default.object
	};
	
	var ReferralList = function ReferralList(_ref4) {
	    var referrals = _ref4.referrals,
	        users = _ref4.users;
	
	    if (!referrals || !referrals.size) return null;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'ReferralList' },
	        _react2.default.createElement(
	            'h3',
	            null,
	            'Your referrals:'
	        ),
	        _react2.default.createElement(
	            'ul',
	            null,
	            referrals.filter(function (referral) {
	                return referral.get('status') === 'ACTIVE';
	            }).map(function (referral) {
	                var userId = referral.get('userId');
	                var user = users.get(userId);
	
	                return _react2.default.createElement(Referral, { referral: referral, user: user, key: referral.get('_id') });
	            })
	        )
	    );
	};
	
	ReferralList.propTypes = {
	    referrals: _propTypes2.default.object,
	    users: _propTypes2.default.object
	};
	
	exports.default = ReferralList;

/***/ }),
/* 2080 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _recompose = __webpack_require__(9);
	
	var _referrerService = __webpack_require__(755);
	
	var _urlConstants = __webpack_require__(326);
	
	var ReferralRedirect = (0, _recompose.createSink)(function (_ref) {
	    var routeParams = _ref.routeParams;
	    var referrer = routeParams.referrer;
	
	    if (referrer) (0, _referrerService.setReferrer)(referrer);
	
	    window.location = _urlConstants.REFERRAL_REDIRECT_URL + '?r=' + referrer;
	});
	
	exports.default = ReferralRedirect;

/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _EmailPreferenceToggleContainer = __webpack_require__(2175);
	
	var _EmailPreferenceToggleContainer2 = _interopRequireDefault(_EmailPreferenceToggleContainer);
	
	var _EditableUserName = __webpack_require__(2089);
	
	var _EditableUserName2 = _interopRequireDefault(_EditableUserName);
	
	var _EditableUserEmail = __webpack_require__(2086);
	
	var _EditableUserEmail2 = _interopRequireDefault(_EditableUserEmail);
	
	var _accountConstants = __webpack_require__(751);
	
	__webpack_require__(1252);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	
	
	// Constants
	
	
	// Styles
	
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        currentUser: state.getIn(['app', 'currentUser'])
	    };
	};
	
	var AccountSettingsModal = function (_React$Component) {
	    _inherits(AccountSettingsModal, _React$Component);
	
	    function AccountSettingsModal() {
	        _classCallCheck(this, AccountSettingsModal);
	
	        return _possibleConstructorReturn(this, (AccountSettingsModal.__proto__ || Object.getPrototypeOf(AccountSettingsModal)).apply(this, arguments));
	    }
	
	    _createClass(AccountSettingsModal, [{
	        key: 'render',
	        value: function render() {
	            var currentUser = this.props.currentUser;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'AccountSettingsModal' },
	                _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Settings'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'user-details section' },
	                    _react2.default.createElement(_EditableUserName2.default, null),
	                    _react2.default.createElement(_EditableUserEmail2.default, null)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'section' },
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        'Email preferences'
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        null,
	                        _accountConstants.EMAIL_PREFERENCE_CHECKLIST.map(function (emailPreferenceEntry) {
	                            return _react2.default.createElement(_EmailPreferenceToggleContainer2.default, {
	                                key: emailPreferenceEntry.value,
	                                currentUser: currentUser,
	                                emailPreferenceEntry: emailPreferenceEntry });
	                        })
	                    )
	                ),
	                _react2.default.createElement('div', { className: 'section' })
	            );
	        }
	    }]);
	
	    return AccountSettingsModal;
	}(_react2.default.Component);
	
	AccountSettingsModal.propTypes = {
	    displayName: _propTypes2.default.string,
	    email: _propTypes2.default.string,
	    currentUser: _propTypes2.default.object
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(AccountSettingsModal);

/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SubscriptionErrorView = __webpack_require__(2084);
	
	var _SubscriptionErrorView2 = _interopRequireDefault(_SubscriptionErrorView);
	
	var _UpdateSubscriptionsView = __webpack_require__(2085);
	
	var _UpdateSubscriptionsView2 = _interopRequireDefault(_UpdateSubscriptionsView);
	
	var _emailPreferenceService = __webpack_require__(2092);
	
	var _userConstants = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	// Components
	
	
	// Actions
	
	
	// Constants
	
	
	var EmailUnsubscribe = function (_React$Component) {
	    _inherits(EmailUnsubscribe, _React$Component);
	
	    function EmailUnsubscribe(props) {
	        _classCallCheck(this, EmailUnsubscribe);
	
	        var _this = _possibleConstructorReturn(this, (EmailUnsubscribe.__proto__ || Object.getPrototypeOf(EmailUnsubscribe)).call(this, props));
	
	        _this.loadPreferences = function () {
	            _this.setState({
	                loading: true
	            });
	
	            (0, _emailPreferenceService.getEmailPreferences)({ email: _this.props.email }).then(function (response) {
	                _this.setState({
	                    loading: false,
	                    emailPreference: response.data.user.emailPreference
	                });
	            }).catch(function (err) {
	                _this.setState({
	                    error: err.data.error,
	                    loading: false
	                });
	            });
	        };
	
	        _this.savePreferences = function (event) {
	            event && event.preventDefault();
	
	            var emailPreference = _this.state.emailPreference;
	
	
	            var updatedEmailPreference = emailPreference ? _userConstants.EMAIL_PREFERENCE_BUFFER_BITS | emailPreference :
	            // Hard set to zero if the user specifies they don't want any email notifications
	            0;
	
	            _this.setState({
	                loading: true
	            });
	
	            (0, _emailPreferenceService.updateEmailPreferences)({ email: _this.props.email, emailPreference: updatedEmailPreference }).then(function (response) {
	                _this.setState({
	                    loading: false,
	                    savedEmailPreference: emailPreference,
	                    submitted: true,
	                    dirty: false
	                });
	            }).catch(function (err) {
	                _this.setState({
	                    error: err.data.error,
	                    loading: false
	                });
	            });
	        };
	
	        _this.updatePreference = function (event) {
	            var emailPreference = _this.state.emailPreference;
	
	            var updateBit = event.target.value;
	
	            _this.setState({
	                emailPreference: emailPreference ^ updateBit,
	                dirty: true
	            });
	        };
	
	        _this.clearError = function () {
	            _this.setState({
	                error: null
	            });
	        };
	
	        _this.state = {
	            error: null,
	            loading: false,
	            dirty: false,
	            submitted: false,
	            emailPreference: 0,
	            // Initially start 'dirty' so the user can select to save their preferences
	            savedEmailPreference: _userConstants.EMAIL_PREFERENCE_ALL
	        };
	        return _this;
	    }
	
	    _createClass(EmailUnsubscribe, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.loadPreferences();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var error = this.state.error;
	
	
	            var RenderComponent = error ? _SubscriptionErrorView2.default : _UpdateSubscriptionsView2.default;
	
	            return _react2.default.createElement(RenderComponent, _extends({}, this.state, this.props, {
	                updatePreference: this.updatePreference,
	                savePreferences: this.savePreferences,
	                error: error,
	                clearError: this.clearError }));
	        }
	    }]);
	
	    return EmailUnsubscribe;
	}(_react2.default.Component);
	
	exports.default = EmailUnsubscribe;
	
	
	EmailUnsubscribe.propTypes = {
	    email: _propTypes2.default.string,
	    isGuest: _propTypes2.default.bool,
	    dispatchNavigateToLogin: _propTypes2.default.func,
	    dispatchNavigateToRootWorkspace: _propTypes2.default.func
	};

/***/ }),
/* 2083 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _FullScreenModal = __webpack_require__(125);
	
	var _FullScreenModal2 = _interopRequireDefault(_FullScreenModal);
	
	var _EmailUnsubscribe = __webpack_require__(2082);
	
	var _EmailUnsubscribe2 = _interopRequireDefault(_EmailUnsubscribe);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _navigationActions = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        email: state.get('routing').locationBeforeTransitions.query.email,
	        isGuest: state.getIn(['app', 'currentUser', 'isGuest'])
	    };
	};
	
	// Actions
	// Lib
	
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        dispatchNavigateToLogin: function dispatchNavigateToLogin() {
	            return dispatch((0, _navigationActions.navigateToLogin)());
	        },
	        dispatchNavigateToRootWorkspace: function dispatchNavigateToRootWorkspace() {
	            return dispatch((0, _navigationActions.navigateToRootWorkspace)());
	        }
	    };
	};
	
	var EmailUnsubscribeFullscreenModal = function EmailUnsubscribeFullscreenModal(props) {
	    var isGuest = props.isGuest,
	        dispatchNavigateToRootWorkspace = props.dispatchNavigateToRootWorkspace,
	        dispatchNavigateToLogin = props.dispatchNavigateToLogin;
	
	    var logoAction = isGuest ? dispatchNavigateToLogin : dispatchNavigateToRootWorkspace;
	
	    return _react2.default.createElement(
	        _FullScreenModal2.default,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'logo' },
	            _react2.default.createElement(
	                'span',
	                { className: 'actionable', onClick: logoAction },
	                _react2.default.createElement(_Icon2.default, { name: 'milanote-logo-large' })
	            )
	        ),
	        _react2.default.createElement(_EmailUnsubscribe2.default, props)
	    );
	};
	
	EmailUnsubscribeFullscreenModal.propTypes = {
	    dispatchNavigateToLogin: _propTypes2.default.func,
	    dispatchNavigateToRootWorkspace: _propTypes2.default.func,
	    isGuest: _propTypes2.default.bool
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(EmailUnsubscribeFullscreenModal);

/***/ }),
/* 2084 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ModalActionsList = __webpack_require__(126);
	
	var _ModalActionsList2 = _interopRequireDefault(_ModalActionsList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SubscriptionErrorView = function SubscriptionErrorView(props) {
	    var error = props.error,
	        isGuest = props.isGuest,
	        dispatchNavigateToRootWorkspace = props.dispatchNavigateToRootWorkspace,
	        dispatchNavigateToLogin = props.dispatchNavigateToLogin,
	        clearError = props.clearError;
	
	
	    var guestActions = [{ text: 'Log in', func: dispatchNavigateToLogin }];
	    var loggedInActions = [{ text: 'Return to your workspace', func: dispatchNavigateToRootWorkspace }];
	    var actions = isGuest ? guestActions : loggedInActions;
	
	    actions.unshift({ text: 'Try again', func: clearError });
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'Subscriptions SubscriptionErrorView' },
	        _react2.default.createElement(
	            'h2',
	            null,
	            'Sorry, there was an error'
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            error.message || 'Please try again'
	        ),
	        _react2.default.createElement(_ModalActionsList2.default, { actions: actions })
	    );
	};
	
	SubscriptionErrorView.propTypes = {
	    error: _propTypes2.default.object.isRequired,
	    isGuest: _propTypes2.default.bool,
	    dispatchNavigateToRootWorkspace: _propTypes2.default.func.isRequired,
	    dispatchNavigateToLogin: _propTypes2.default.func.isRequired,
	    clearError: _propTypes2.default.func.isRequired
	};
	
	exports.default = SubscriptionErrorView;

/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _EmailPreferenceToggle = __webpack_require__(776);
	
	var _EmailPreferenceToggle2 = _interopRequireDefault(_EmailPreferenceToggle);
	
	var _FormButton = __webpack_require__(60);
	
	var _FormButton2 = _interopRequireDefault(_FormButton);
	
	var _PrimarySuccessMessage = __webpack_require__(1782);
	
	var _PrimarySuccessMessage2 = _interopRequireDefault(_PrimarySuccessMessage);
	
	var _accountConstants = __webpack_require__(751);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UpdateSubscriptionsView = function UpdateSubscriptionsView(props) {
	    var updatePreference = props.updatePreference,
	        emailPreference = props.emailPreference,
	        savedEmailPreference = props.savedEmailPreference,
	        loading = props.loading,
	        savePreferences = props.savePreferences,
	        submitted = props.submitted,
	        dirty = props.dirty;
	
	
	    var changesMade = emailPreference !== savedEmailPreference;
	    var changesSaved = submitted && !dirty && !changesMade;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'Subscriptions UpdateSubscriptionsView' },
	        _react2.default.createElement(
	            'h2',
	            null,
	            'Update subscriptions'
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'section' },
	            _react2.default.createElement(
	                'p',
	                null,
	                'Choose what you\'d like to be notified about then click "Save preferences":'
	            ),
	            _react2.default.createElement(
	                'ul',
	                { className: 'option-list' },
	                _accountConstants.EMAIL_PREFERENCE_CHECKLIST.map(function (emailPreferenceEntry) {
	                    return _react2.default.createElement(_EmailPreferenceToggle2.default, {
	                        key: emailPreferenceEntry.value,
	                        updatePreference: updatePreference,
	                        active: !!(emailPreference & emailPreferenceEntry.value),
	                        value: emailPreferenceEntry.value,
	                        label: emailPreferenceEntry.label });
	                })
	            ),
	            _react2.default.createElement(
	                _FormButton2.default,
	                { className: 'primary', onClickFn: savePreferences, disabled: loading || submitted && !dirty },
	                'Save preferences'
	            ),
	            _react2.default.createElement(_PrimarySuccessMessage2.default, { message: 'Your subscription preferences have been saved', show: changesSaved })
	        )
	    );
	};
	
	UpdateSubscriptionsView.propTypes = {
	    updatePreference: _propTypes2.default.func.isRequired,
	    emailPreference: _propTypes2.default.number.isRequired,
	    savedEmailPreference: _propTypes2.default.number.isRequired,
	    loading: _propTypes2.default.bool,
	    savePreferences: _propTypes2.default.func.isRequired,
	    isGuest: _propTypes2.default.bool,
	    dispatchNavigateToRootWorkspace: _propTypes2.default.func.isRequired,
	    dispatchNavigateToLogin: _propTypes2.default.func.isRequired,
	    submitted: _propTypes2.default.bool,
	    dirty: _propTypes2.default.bool
	};
	
	exports.default = UpdateSubscriptionsView;

/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _readOnlyOrEditableDecorator = __webpack_require__(702);
	
	var _readOnlyOrEditableDecorator2 = _interopRequireDefault(_readOnlyOrEditableDecorator);
	
	var _UserEmailForm = __webpack_require__(2087);
	
	var _UserEmailForm2 = _interopRequireDefault(_UserEmailForm);
	
	var _UserEmailReadOnly = __webpack_require__(2088);
	
	var _UserEmailReadOnly2 = _interopRequireDefault(_UserEmailReadOnly);
	
	__webpack_require__(1253);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	// Lib
	var EditableUserEmail = function EditableUserEmail(_ref) {
	    var isEditing = _ref.isEditing,
	        toggleEditing = _ref.toggleEditing;
	    return _react2.default.createElement(
	        'div',
	        { className: 'EditableUserEmail' },
	        isEditing ? _react2.default.createElement(_UserEmailForm2.default, { onSubmit: toggleEditing }) : _react2.default.createElement(_UserEmailReadOnly2.default, { toggleEditable: toggleEditing })
	    );
	};
	
	// Styles
	
	
	EditableUserEmail.propTypes = {
	    isEditing: _propTypes2.default.bool,
	    toggleEditing: _propTypes2.default.func
	};
	
	exports.default = (0, _readOnlyOrEditableDecorator2.default)(EditableUserEmail);

/***/ }),
/* 2087 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _dec3, _class; // Lib
	
	
	// Utils
	
	
	// Actions
	
	
	// Components
	
	
	// Selector
	
	
	// Constants
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _milanoteForm = __webpack_require__(104);
	
	var _milanoteForm2 = _interopRequireDefault(_milanoteForm);
	
	var _formSubmissionExceptionHandler = __webpack_require__(296);
	
	var _formSubmissionExceptionHandler2 = _interopRequireDefault(_formSubmissionExceptionHandler);
	
	var _currentUserActions = __webpack_require__(84);
	
	var _FormInput = __webpack_require__(96);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _FieldValidationMessages = __webpack_require__(122);
	
	var _FieldValidationMessages2 = _interopRequireDefault(_FieldValidationMessages);
	
	var _LinkButton = __webpack_require__(74);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	var _currentUserSelector = __webpack_require__(33);
	
	var _validationConstants = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FORM_NAME = 'userEmail';
	
	var USER_EMAIL_FIELDS = {
	    email: _validationConstants.FIELDS.email
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        initialEmail: (0, _currentUserSelector.getCurrentUser)(state).getIn(['email'])
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        onSubmit: function onSubmit(_ref) {
	            var email = _ref.email;
	            var onSubmit = ownProps.onSubmit,
	                initialEmail = ownProps.initialEmail;
	
	
	            var userChanges = { email: email };
	
	            if (initialEmail === email) {
	                onSubmit();
	                return;
	            }
	
	            return dispatch((0, _currentUserActions.updateCurrentUserHtpp)(userChanges)).then(onSubmit).catch((0, _formSubmissionExceptionHandler2.default)({ dispatch: dispatch, form: FORM_NAME }));
	        }
	    };
	};
	
	var mapStateToForm = function mapStateToForm(state) {
	    var currentUser = (0, _currentUserSelector.getCurrentUser)(state);
	    return {
	        initialValues: {
	            email: currentUser.getIn(['email'])
	        }
	    };
	};
	
	var UserEmailForm = (_dec = (0, _reactRedux.connect)(mapStateToProps), _dec2 = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec3 = (0, _milanoteForm2.default)({ form: FORM_NAME, fieldsConfig: USER_EMAIL_FIELDS }, mapStateToForm), _dec(_class = _dec2(_class = _dec3(_class = function (_React$Component) {
	    _inherits(UserEmailForm, _React$Component);
	
	    function UserEmailForm() {
	        _classCallCheck(this, UserEmailForm);
	
	        return _possibleConstructorReturn(this, (UserEmailForm.__proto__ || Object.getPrototypeOf(UserEmailForm)).apply(this, arguments));
	    }
	
	    _createClass(UserEmailForm, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.email.focus();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                submitInterceptor = _props.submitInterceptor,
	                sanitisedErrors = _props.sanitisedErrors;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'UserEmailForm' },
	                _react2.default.createElement(
	                    'form',
	                    { onSubmit: submitInterceptor },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'input-fields' },
	                        _react2.default.createElement(_FormInput2.default, _extends({}, this.props, { ref: function ref(c) {
	                                _this2.email = c;
	                            },
	                            name: USER_EMAIL_FIELDS.email.name,
	                            type: USER_EMAIL_FIELDS.email.type,
	                            placeholder: 'email',
	                            maxLength: USER_EMAIL_FIELDS.email.maxLength }))
	                    ),
	                    _react2.default.createElement(
	                        _LinkButton2.default,
	                        { type: 'submit' },
	                        'Done'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'errors' },
	                    _react2.default.createElement(_FieldValidationMessages2.default, { sanitisedError: sanitisedErrors.email })
	                )
	            );
	        }
	    }]);
	
	    return UserEmailForm;
	}(_react2.default.Component)) || _class) || _class) || _class);
	
	
	UserEmailForm.propTypes = {
	    onSubmit: _propTypes2.default.func,
	    submitInterceptor: _propTypes2.default.func,
	    sanitisedErrors: _propTypes2.default.object
	};
	
	exports.default = UserEmailForm;

/***/ }),
/* 2088 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _LinkButton = __webpack_require__(74);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Lib
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        email: state.getIn(['app', 'currentUser', 'email'])
	    };
	};
	
	// Components
	
	
	var UserEmailReadOnly = function UserEmailReadOnly(_ref) {
	    var email = _ref.email,
	        toggleEditable = _ref.toggleEditable;
	    return _react2.default.createElement(
	        'div',
	        { className: 'UserNameReadOnly' },
	        _react2.default.createElement(
	            'span',
	            null,
	            email
	        ),
	        _react2.default.createElement(
	            _LinkButton2.default,
	            { onClickFn: toggleEditable },
	            'Change'
	        )
	    );
	};
	
	UserEmailReadOnly.propTypes = {
	    email: _propTypes2.default.string,
	    toggleEditable: _propTypes2.default.func
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(UserEmailReadOnly);

/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _readOnlyOrEditableDecorator = __webpack_require__(702);
	
	var _readOnlyOrEditableDecorator2 = _interopRequireDefault(_readOnlyOrEditableDecorator);
	
	var _UserNameForm = __webpack_require__(2090);
	
	var _UserNameForm2 = _interopRequireDefault(_UserNameForm);
	
	var _UserNameReadOnly = __webpack_require__(2091);
	
	var _UserNameReadOnly2 = _interopRequireDefault(_UserNameReadOnly);
	
	__webpack_require__(1254);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	// Lib
	var EditableUserName = function EditableUserName(_ref) {
	    var isEditing = _ref.isEditing,
	        toggleEditing = _ref.toggleEditing;
	    return _react2.default.createElement(
	        'div',
	        { className: 'EditableUserName' },
	        isEditing ? _react2.default.createElement(_UserNameForm2.default, { onSubmit: toggleEditing }) : _react2.default.createElement(_UserNameReadOnly2.default, { toggleEditable: toggleEditing })
	    );
	};
	
	// Styles
	
	
	EditableUserName.propTypes = {
	    isEditing: _propTypes2.default.bool,
	    toggleEditing: _propTypes2.default.func
	};
	
	exports.default = (0, _readOnlyOrEditableDecorator2.default)(EditableUserName);

/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _dec3, _class; // Lib
	
	
	// Utils
	
	
	// Actions
	
	
	// Components
	
	
	// Selector
	
	
	// Constants
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _milanoteForm = __webpack_require__(104);
	
	var _milanoteForm2 = _interopRequireDefault(_milanoteForm);
	
	var _formSubmissionExceptionHandler = __webpack_require__(296);
	
	var _formSubmissionExceptionHandler2 = _interopRequireDefault(_formSubmissionExceptionHandler);
	
	var _currentUserActions = __webpack_require__(84);
	
	var _FormInput = __webpack_require__(96);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _FieldValidationMessages = __webpack_require__(122);
	
	var _FieldValidationMessages2 = _interopRequireDefault(_FieldValidationMessages);
	
	var _LinkButton = __webpack_require__(74);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	var _currentUserSelector = __webpack_require__(33);
	
	var _validationConstants = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FORM_NAME = 'userName';
	
	var USERNAME_FIELDS = {
	    givenName: _validationConstants.FIELDS.givenName,
	    familyName: _validationConstants.FIELDS.familyName
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	    var currentUser = (0, _currentUserSelector.getCurrentUser)(state);
	    return {
	        initialGivenName: currentUser.getIn(['name', 'givenName']),
	        initialFamilyName: currentUser.getIn(['name', 'familyName'])
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        onSubmit: function onSubmit(_ref) {
	            var givenName = _ref.givenName,
	                familyName = _ref.familyName;
	            var onSubmit = ownProps.onSubmit,
	                initialGivenName = ownProps.initialGivenName,
	                initialFamilyName = ownProps.initialFamilyName;
	
	
	            if (initialGivenName === givenName && initialFamilyName === familyName) {
	                onSubmit();
	                return;
	            }
	
	            var userChanges = {
	                name: {
	                    givenName: givenName,
	                    familyName: familyName,
	                    displayName: givenName + ' ' + familyName
	                }
	            };
	
	            return dispatch((0, _currentUserActions.updateCurrentUserHtpp)(userChanges)).then(onSubmit).catch((0, _formSubmissionExceptionHandler2.default)({ dispatch: dispatch, form: FORM_NAME }));
	        }
	    };
	};
	
	var mapStateToForm = function mapStateToForm(state) {
	    var currentUser = (0, _currentUserSelector.getCurrentUser)(state);
	    return {
	        initialValues: {
	            givenName: currentUser.getIn(['name', 'givenName']),
	            familyName: currentUser.getIn(['name', 'familyName'])
	        }
	    };
	};
	
	var UserNameForm = (_dec = (0, _reactRedux.connect)(mapStateToProps), _dec2 = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec3 = (0, _milanoteForm2.default)({ form: FORM_NAME, fieldsConfig: USERNAME_FIELDS }, mapStateToForm), _dec(_class = _dec2(_class = _dec3(_class = function (_React$Component) {
	    _inherits(UserNameForm, _React$Component);
	
	    function UserNameForm() {
	        _classCallCheck(this, UserNameForm);
	
	        return _possibleConstructorReturn(this, (UserNameForm.__proto__ || Object.getPrototypeOf(UserNameForm)).apply(this, arguments));
	    }
	
	    _createClass(UserNameForm, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.givenName.focus();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                submitInterceptor = _props.submitInterceptor,
	                sanitisedErrors = _props.sanitisedErrors;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'UserNameForm' },
	                _react2.default.createElement(
	                    'form',
	                    { onSubmit: submitInterceptor },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'input-fields' },
	                        _react2.default.createElement(_FormInput2.default, _extends({}, this.props, { ref: function ref(c) {
	                                _this2.givenName = c;
	                            },
	                            name: USERNAME_FIELDS.givenName.name,
	                            type: USERNAME_FIELDS.givenName.type,
	                            placeholder: 'First name',
	                            maxLength: USERNAME_FIELDS.givenName.maxLength })),
	                        _react2.default.createElement(_FormInput2.default, _extends({}, this.props, { ref: 'familyName',
	                            name: USERNAME_FIELDS.familyName.name,
	                            type: USERNAME_FIELDS.familyName.type,
	                            placeholder: 'Last name',
	                            maxLength: USERNAME_FIELDS.familyName.maxLength }))
	                    ),
	                    _react2.default.createElement(
	                        _LinkButton2.default,
	                        { type: 'submit' },
	                        'Done'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'errors' },
	                    _react2.default.createElement(_FieldValidationMessages2.default, { sanitisedError: sanitisedErrors.givenName }),
	                    _react2.default.createElement(_FieldValidationMessages2.default, { sanitisedError: sanitisedErrors.familyName })
	                )
	            );
	        }
	    }]);
	
	    return UserNameForm;
	}(_react2.default.Component)) || _class) || _class) || _class);
	
	
	UserNameForm.propTypes = {
	    onSubmit: _propTypes2.default.func,
	    submitInterceptor: _propTypes2.default.func,
	    sanitisedErrors: _propTypes2.default.object
	};
	
	exports.default = UserNameForm;

/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _LinkButton = __webpack_require__(74);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Lib
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        displayName: state.getIn(['app', 'currentUser', 'name', 'displayName'])
	    };
	};
	
	// Components
	
	
	var UserNameReadOnly = function UserNameReadOnly(_ref) {
	    var displayName = _ref.displayName,
	        toggleEditable = _ref.toggleEditable;
	    return _react2.default.createElement(
	        'div',
	        { className: 'UserNameReadOnly' },
	        _react2.default.createElement(
	            'span',
	            null,
	            displayName
	        ),
	        _react2.default.createElement(
	            _LinkButton2.default,
	            { onClickFn: toggleEditable },
	            'Change'
	        )
	    );
	};
	
	UserNameReadOnly.propTypes = {
	    displayName: _propTypes2.default.string,
	    toggleEditable: _propTypes2.default.func
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(UserNameReadOnly);

/***/ }),
/* 2092 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.updateEmailPreferences = exports.getEmailPreferences = undefined;
	
	var _http = __webpack_require__(76);
	
	var _http2 = _interopRequireDefault(_http);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getEmailPreferences = exports.getEmailPreferences = function getEmailPreferences(_ref) {
	    var email = _ref.email;
	
	    var httpConfig = {
	        url: 'users/email/preferences',
	        method: 'get',
	        params: {
	            email: email
	        }
	    };
	
	    return (0, _http2.default)(httpConfig);
	};
	
	var updateEmailPreferences = exports.updateEmailPreferences = function updateEmailPreferences(_ref2) {
	    var email = _ref2.email,
	        emailPreference = _ref2.emailPreference;
	
	    var httpConfig = {
	        url: 'users/email/preferences',
	        method: 'put',
	        data: {
	            email: email,
	            emailPreference: emailPreference
	        }
	    };
	
	    return (0, _http2.default)(httpConfig);
	};

/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouterRedux = __webpack_require__(82);
	
	var _teamManagementSelectors = __webpack_require__(463);
	
	var _userUtil = __webpack_require__(31);
	
	var _TeamInputForm = __webpack_require__(2094);
	
	var _TeamInputForm2 = _interopRequireDefault(_TeamInputForm);
	
	var _TeamMembersList = __webpack_require__(2097);
	
	var _TeamMembersList2 = _interopRequireDefault(_TeamMembersList);
	
	var _FormButton = __webpack_require__(60);
	
	var _FormButton2 = _interopRequireDefault(_FormButton);
	
	__webpack_require__(1255);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        navigateToPayment: function navigateToPayment() {
	            return dispatch((0, _reactRouterRedux.push)('/account/payment'));
	        }
	    };
	};
	
	var TeamManagementTitle = function TeamManagementTitle(_ref) {
	    var currentUser = _ref.currentUser;
	    return (0, _userUtil.isSubscribed)(currentUser) ? _react2.default.createElement(
	        'h2',
	        null,
	        'Professional team plan'
	    ) : _react2.default.createElement(
	        'h2',
	        null,
	        'Who do you want to upgrade?'
	    );
	};
	
	TeamManagementTitle.propTypes = {
	    currentUser: _propTypes2.default.object
	};
	
	var TeamManagement = function TeamManagement(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'TeamManagement' },
	        _react2.default.createElement(
	            'div',
	            { className: 'form-members' },
	            _react2.default.createElement(TeamManagementTitle, props),
	            _react2.default.createElement(
	                'h3',
	                null,
	                'Team members ',
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    '(minimum 2)'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'team-list-scrollable' },
	                _react2.default.createElement(_TeamMembersList2.default, props)
	            ),
	            _react2.default.createElement(_TeamInputForm2.default, props)
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'form-footer' },
	            _react2.default.createElement(
	                _FormButton2.default,
	                { className: 'primary',
	                    disabled: !props.hasChanges || props.teamMembers.size <= 1,
	                    onClickFn: props.navigateToPayment },
	                (0, _userUtil.isSubscribed)(props.currentUser) ? 'Save changes & review payment' : 'Continue to payment'
	            )
	        )
	    );
	};
	
	TeamManagement.propTypes = {
	    teamMembers: _propTypes2.default.object,
	    navigateToPayment: _propTypes2.default.func,
	    currentUser: _propTypes2.default.object,
	    hasChanges: _propTypes2.default.bool
	};
	
	exports.default = (0, _reactRedux.connect)(_teamManagementSelectors.teamManagementModalSelctor, mapDispatchToProps)(TeamManagement);

/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class; // Lib
	
	
	// Utils
	
	
	// Actions
	
	
	// Components
	
	
	// Constants
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _userHelper = __webpack_require__(175);
	
	var _userUtil = __webpack_require__(31);
	
	var _teamManagementActions = __webpack_require__(310);
	
	var _Form = __webpack_require__(138);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormButton = __webpack_require__(60);
	
	var _FormButton2 = _interopRequireDefault(_FormButton);
	
	var _FormInput = __webpack_require__(96);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _FieldValidationMessages = __webpack_require__(122);
	
	var _FieldValidationMessages2 = _interopRequireDefault(_FieldValidationMessages);
	
	var _milanoteForm = __webpack_require__(104);
	
	var _milanoteForm2 = _interopRequireDefault(_milanoteForm);
	
	var _PrimaryErrorMessage = __webpack_require__(230);
	
	var _PrimaryErrorMessage2 = _interopRequireDefault(_PrimaryErrorMessage);
	
	var _TeamSuggestions = __webpack_require__(757);
	
	var _TeamSuggestions2 = _interopRequireDefault(_TeamSuggestions);
	
	var _teamFormConstants = __webpack_require__(309);
	
	__webpack_require__(1256);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var customMemberSuggestionFilter = function customMemberSuggestionFilter(user) {
	    return !(0, _userUtil.isSubscribed)(user);
	};
	
	// Redux connect methods
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        onSubmit: function onSubmit(_ref) {
	            var userEmail = _ref.userEmail;
	            return dispatch((0, _teamManagementActions.fetchAndAddTeamMember)({ userEmail: userEmail }));
	        },
	        addUserHandler: function addUserHandler(_ref2) {
	            var userEmail = _ref2.userEmail;
	            return dispatch((0, _teamManagementActions.fetchAndAddTeamMember)({ userEmail: userEmail }));
	        }
	    };
	};
	
	var TeamInputForm = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec2 = (0, _milanoteForm2.default)({ form: _teamFormConstants.ADD_TEAM_MEMBER_FORM_NAME, fieldsConfig: _teamFormConstants.ADD_TEAM_MEMBER_FORM_FIELDS }), _dec(_class = _dec2(_class = function (_React$Component) {
	    _inherits(TeamInputForm, _React$Component);
	
	    function TeamInputForm() {
	        _classCallCheck(this, TeamInputForm);
	
	        return _possibleConstructorReturn(this, (TeamInputForm.__proto__ || Object.getPrototypeOf(TeamInputForm)).apply(this, arguments));
	    }
	
	    _createClass(TeamInputForm, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.refs.userEmail.focus();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                submitInterceptor = _props.submitInterceptor,
	                sanitisedErrors = _props.sanitisedErrors,
	                submitting = _props.submitting,
	                showingErrors = _props.showingErrors,
	                primaryError = _props.primaryError,
	                dirtySinceSubmission = _props.dirtySinceSubmission,
	                addUserHandler = _props.addUserHandler,
	                values = _props.values,
	                teamMembers = _props.teamMembers;
	
	
	            var selectedUserIds = teamMembers.map(_userHelper.getId);
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'TeamInputForm' },
	                _react2.default.createElement(
	                    _Form2.default,
	                    { className: (0, _classnames2.default)('form', { submitting: submitting }),
	                        onSubmit: submitInterceptor,
	                        noValidate: true },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'form-row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'field-info' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'field-label', htmlFor: 'userEmail' },
	                                'Add a team member'
	                            )
	                        ),
	                        _react2.default.createElement(_FieldValidationMessages2.default, { sanitisedError: sanitisedErrors.userEmail }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'field-row' },
	                            _react2.default.createElement(_FormInput2.default, _extends({}, this.props, { ref: 'userEmail',
	                                name: _teamFormConstants.ADD_TEAM_MEMBER_FORM_FIELDS.userEmail.name,
	                                type: _teamFormConstants.ADD_TEAM_MEMBER_FORM_FIELDS.userEmail.type,
	                                placeholder: 'e.g. alex.lee@milanote.com',
	                                maxLength: _teamFormConstants.ADD_TEAM_MEMBER_FORM_FIELDS.userEmail.maxLength,
	                                autoComplete: 'off' })),
	                            _react2.default.createElement(
	                                _FormButton2.default,
	                                { className: 'secondary inline',
	                                    type: 'submit',
	                                    disabled: submitting || showingErrors },
	                                'Add'
	                            )
	                        ),
	                        _react2.default.createElement(_TeamSuggestions2.default, {
	                            defaultTitle: 'Suggested',
	                            addUser: addUserHandler,
	                            selectedUserIds: selectedUserIds,
	                            customFilter: customMemberSuggestionFilter,
	                            filterString: values.userEmail })
	                    ),
	                    _react2.default.createElement(_PrimaryErrorMessage2.default, {
	                        icon: null,
	                        message: primaryError && primaryError.message,
	                        show: !!primaryError && !dirtySinceSubmission && !submitting })
	                )
	            );
	        }
	    }]);
	
	    return TeamInputForm;
	}(_react2.default.Component)) || _class) || _class);
	
	
	TeamInputForm.propTypes = {
	    fields: _propTypes2.default.object,
	    submitInterceptor: _propTypes2.default.func,
	    submitFailed: _propTypes2.default.bool,
	    showingErrors: _propTypes2.default.bool,
	    submitting: _propTypes2.default.bool,
	    dirtySinceSubmission: _propTypes2.default.bool,
	    onChange: _propTypes2.default.func,
	    addUserHandler: _propTypes2.default.func,
	    sanitisedErrors: _propTypes2.default.object,
	    primaryError: _propTypes2.default.object,
	    values: _propTypes2.default.object,
	    teamMembers: _propTypes2.default.object
	};
	
	exports.default = TeamInputForm;

/***/ }),
/* 2095 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Utils
	
	
	// Constants
	
	
	var _formSubReducerWrapper = __webpack_require__(229);
	
	var _formSubReducerWrapper2 = _interopRequireDefault(_formSubReducerWrapper);
	
	var _teamFormConstants = __webpack_require__(309);
	
	var _teamManagementConstants = __webpack_require__(236);
	
	var _formConstants = __webpack_require__(435);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addTeamMemberSubFormReducer = function addTeamMemberSubFormReducer(state, action) {
	    switch (action.type) {
	        case _teamManagementConstants.TEAM_MEMBER_ADD_NEW:
	        case _formConstants.FORM_SUBMISSION_FAILED:
	            return _extends({}, state, { userEmail: { value: '' } });
	        default:
	            return state;
	    }
	};
	
	exports.default = (0, _formSubReducerWrapper2.default)(addTeamMemberSubFormReducer, _teamFormConstants.ADD_TEAM_MEMBER_FORM_NAME);

/***/ }),
/* 2096 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__(3);
	
	var _recompose = __webpack_require__(9);
	
	var _LinkButton = __webpack_require__(74);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	var _UserAvatar = __webpack_require__(199);
	
	var _UserAvatar2 = _interopRequireDefault(_UserAvatar);
	
	var _UserName = __webpack_require__(445);
	
	var _UserName2 = _interopRequireDefault(_UserName);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _teamManagementActions = __webpack_require__(310);
	
	var _teamManagementConstants = __webpack_require__(236);
	
	__webpack_require__(1257);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        dispatchRemoveMember: function dispatchRemoveMember(userId) {
	            return dispatch((0, _teamManagementActions.removeTeamMember)({ userId: userId }));
	        },
	        dispatchAddMember: function dispatchAddMember(userId) {
	            return dispatch((0, _teamManagementActions.addTeamMember)({ userId: userId }));
	        }
	    };
	};
	
	var UserStatusDescription = function UserStatusDescription(_ref) {
	    var user = _ref.user,
	        currentUser = _ref.currentUser;
	
	    if (user.get('_id') === currentUser.get('_id')) return _react2.default.createElement(
	        'span',
	        null,
	        'Admin'
	    );
	
	    return null;
	};
	
	var UserStatusAction = function UserStatusAction(_ref2) {
	    var user = _ref2.user,
	        currentUser = _ref2.currentUser,
	        removeMember = _ref2.removeMember,
	        undoRemoveMember = _ref2.undoRemoveMember;
	
	    if (user.get('_id') === currentUser.get('_id')) return null;
	
	    switch (user.get('memberState')) {
	        case _teamManagementConstants.TEAM_MEMBER_STATES.NEW:
	            return _react2.default.createElement(
	                _LinkButton2.default,
	                { className: 'secondary', onClickFn: removeMember },
	                _react2.default.createElement(_Icon2.default, { name: 'close-x' })
	            );
	        case _teamManagementConstants.TEAM_MEMBER_STATES.ADDED:
	            return _react2.default.createElement(
	                _LinkButton2.default,
	                { onClickFn: removeMember },
	                'Remove from team'
	            );
	        case _teamManagementConstants.TEAM_MEMBER_STATES.REMOVED:
	            return _react2.default.createElement(
	                _LinkButton2.default,
	                { onClickFn: undoRemoveMember },
	                'Undo'
	            );
	        default:
	            return null;
	    }
	};
	
	var UserStatus = function UserStatus(props) {
	    return _react2.default.createElement(
	        'span',
	        { className: 'status' },
	        _react2.default.createElement(UserStatusDescription, props),
	        ' ',
	        _react2.default.createElement(UserStatusAction, props)
	    );
	};
	
	UserStatusAction.propTypes = UserStatusDescription.propTypes = {
	    user: _propTypes2.default.object,
	    currentUser: _propTypes2.default.object,
	    removeMember: _propTypes2.default.func,
	    undoRemoveMember: _propTypes2.default.func
	};
	
	var TeamMembersEntry = function (_React$Component) {
	    _inherits(TeamMembersEntry, _React$Component);
	
	    function TeamMembersEntry() {
	        _classCallCheck(this, TeamMembersEntry);
	
	        return _possibleConstructorReturn(this, (TeamMembersEntry.__proto__ || Object.getPrototypeOf(TeamMembersEntry)).apply(this, arguments));
	    }
	
	    _createClass(TeamMembersEntry, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.memberEntry.scrollIntoView();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var index = this.props.index;
	
	
	            var classes = (0, _classnames2.default)('TeamMemberEntry', {
	                removed: this.props.user.get('memberState') === _teamManagementConstants.TEAM_MEMBER_STATES.REMOVED
	            });
	
	            return _react2.default.createElement(
	                'div',
	                { className: classes, ref: function ref(c) {
	                        _this2.memberEntry = c;
	                    } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'details' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'index' },
	                        index + 1,
	                        '.'
	                    ),
	                    _react2.default.createElement(_UserAvatar2.default, this.props),
	                    _react2.default.createElement(_UserName2.default, this.props),
	                    _react2.default.createElement(UserStatus, this.props)
	                )
	            );
	        }
	    }]);
	
	    return TeamMembersEntry;
	}(_react2.default.Component);
	
	TeamMembersEntry.propTypes = {
	    user: _propTypes2.default.object,
	    index: _propTypes2.default.number
	};
	
	var enhance = (0, _recompose.compose)((0, _reactRedux.connect)(null, mapDispatchToProps), (0, _recompose.withHandlers)({
	    removeMember: function removeMember(_ref3) {
	        var dispatchRemoveMember = _ref3.dispatchRemoveMember,
	            user = _ref3.user;
	        return function (event) {
	            return dispatchRemoveMember(user.get('_id'));
	        };
	    },
	    undoRemoveMember: function undoRemoveMember(_ref4) {
	        var dispatchAddMember = _ref4.dispatchAddMember,
	            user = _ref4.user;
	        return function (event) {
	            return dispatchAddMember(user.get('_id'));
	        };
	    }
	}));
	
	exports.default = enhance(TeamMembersEntry);

/***/ }),
/* 2097 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CSSTransitionGroup = __webpack_require__(134);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _TeamMemberEntry = __webpack_require__(2096);
	
	var _TeamMemberEntry2 = _interopRequireDefault(_TeamMemberEntry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var sortList = function sortList(currentUser) {
	    return function (a, b) {
	        if (a.get('_id') === currentUser.get('_id')) return -1;
	        if (b.get('_id') === currentUser.get('_id')) return 1;
	
	        return 0;
	    };
	};
	
	var TeamMembersList = function TeamMembersList(_ref) {
	    var teamMembers = _ref.teamMembers,
	        props = _objectWithoutProperties(_ref, ['teamMembers']);
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'TeamMembersList' },
	        _react2.default.createElement(
	            _CSSTransitionGroup2.default,
	            {
	                transitionName: 'glow',
	                transitionEnterTimeout: 1000,
	                transitionLeaveTimeout: 1 },
	            teamMembers.valueSeq().sort(sortList(props.currentUser)).map(function (user, i) {
	                return _react2.default.createElement(_TeamMemberEntry2.default, _extends({}, props, { user: user, key: user.get('_id'), index: i }));
	            })
	        )
	    );
	};
	
	TeamMembersList.propTypes = {
	    teamMembers: _propTypes2.default.object,
	    currentUser: _propTypes2.default.object
	};
	
	exports.default = TeamMembersList;

/***/ }),
/* 2098 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _teamManagementConstants = __webpack_require__(236);
	
	var _currentUserConstants = __webpack_require__(144);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Initial state
	var initialState = Immutable.Map({
	    teamMembers: Immutable.OrderedMap(),
	    initialIds: Immutable.List()
	});
	
	var addTeamMember = function addTeamMember(state, userId) {
	    return state.setIn(['teamMembers', userId], Immutable.Map({ userId: userId, state: _teamManagementConstants.TEAM_MEMBER_STATES.ADDED }));
	};
	
	var addNewTeamMember = function addNewTeamMember(state, _ref) {
	    var userId = _ref.userId,
	        valid = _ref.valid;
	    return state.setIn(['teamMembers', userId], Immutable.Map({ userId: userId, state: _teamManagementConstants.TEAM_MEMBER_STATES.NEW }));
	};
	
	var removeTeamMember = function removeTeamMember(state, userId) {
	    var existingMemberState = state.getIn(['teamMembers', userId, 'state']);
	
	    if (existingMemberState === _teamManagementConstants.TEAM_MEMBER_STATES.ADDED) {
	        return state.setIn(['teamMembers', userId, 'state'], _teamManagementConstants.TEAM_MEMBER_STATES.REMOVED);
	    }
	
	    return state.deleteIn(['teamMembers', userId]);
	};
	
	var setTeamMembers = function setTeamMembers(state, userIds) {
	    return userIds.reduce(function (acc, userId) {
	        return addTeamMember(acc, userId);
	    }, initialState).set('initialIds', Immutable.List(userIds));
	};
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _currentUserConstants.CURRENT_USER_SET:
	            return addTeamMember(state, action.user._id);
	        case _teamManagementConstants.TEAM_MEMBER_ADD_NEW:
	            return addNewTeamMember(state, action);
	        case _teamManagementConstants.TEAM_MEMBER_ADD:
	            return addTeamMember(state, action.userId);
	        case _teamManagementConstants.TEAM_MEMBER_REMOVE:
	            return removeTeamMember(state, action.userId);
	        case _teamManagementConstants.TEAM_MEMBERS_SET:
	            return setTeamMembers(state, action.userIds);
	        default:
	            return state;
	    }
	};

/***/ }),
/* 2099 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(45);
	
	var _FormButton = __webpack_require__(60);
	
	var _FormButton2 = _interopRequireDefault(_FormButton);
	
	var _FlexCenter = __webpack_require__(198);
	
	var _FlexCenter2 = _interopRequireDefault(_FlexCenter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UnsubscribeConfirm = function UnsubscribeConfirm(_ref) {
	    var onUnsubscribeButtonClick = _ref.onUnsubscribeButtonClick;
	    return _react2.default.createElement(
	        _FlexCenter2.default,
	        null,
	        _react2.default.createElement(
	            'h1',
	            null,
	            'Are you sure you want to downgrade your plan?'
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            'You\'ll still have access to all of your content, but you won\'t be able to add any more.'
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'actions' },
	            _react2.default.createElement(
	                _FormButton2.default,
	                { className: 'primary', onClickFn: onUnsubscribeButtonClick },
	                'Yes, downgrade my plan'
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/account/plan' },
	                'No, I\'ve changed my mind'
	            )
	        )
	    );
	};
	
	UnsubscribeConfirm.propTypes = {
	    onUnsubscribeButtonClick: _propTypes2.default.func
	};
	
	exports.default = UnsubscribeConfirm;

/***/ }),
/* 2100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _FormButton = __webpack_require__(60);
	
	var _FormButton2 = _interopRequireDefault(_FormButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UnsubscribeProcessing = function UnsubscribeProcessing(_ref) {
	    var onErrorButtonClick = _ref.onErrorButtonClick;
	    return _react2.default.createElement(
	        'div',
	        { className: 'Form UnsubscribeProcessing modal-flex' },
	        _react2.default.createElement(
	            'div',
	            { className: 'content' },
	            _react2.default.createElement(_Icon2.default, { name: 'error-alert' }),
	            _react2.default.createElement(
	                'h1',
	                null,
	                'Sorry, something went wrong!'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Please ',
	                _react2.default.createElement(
	                    'a',
	                    { href: 'mailto:support@milanote.com' },
	                    'contact us'
	                ),
	                ' or try again'
	            ),
	            _react2.default.createElement(
	                _FormButton2.default,
	                { className: 'primary', onClickFn: onErrorButtonClick },
	                'Back'
	            )
	        )
	    );
	};
	
	UnsubscribeProcessing.propTypes = {
	    onErrorButtonClick: _propTypes2.default.func
	};
	
	exports.default = UnsubscribeProcessing;

/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(9);
	
	var _reactRedux = __webpack_require__(3);
	
	var _paymentService = __webpack_require__(753);
	
	var _currentUserActions = __webpack_require__(84);
	
	var _paymentSelector = __webpack_require__(308);
	
	var _LoadingTransitionDisplay = __webpack_require__(438);
	
	var _LoadingTransitionDisplay2 = _interopRequireDefault(_LoadingTransitionDisplay);
	
	var _loadingTransitionDecorator = __webpack_require__(709);
	
	var _loadingTransitionDecorator2 = _interopRequireDefault(_loadingTransitionDecorator);
	
	var _UnsubscribeConfirm = __webpack_require__(2099);
	
	var _UnsubscribeConfirm2 = _interopRequireDefault(_UnsubscribeConfirm);
	
	var _UnsubscribeProcessing = __webpack_require__(2102);
	
	var _UnsubscribeProcessing2 = _interopRequireDefault(_UnsubscribeProcessing);
	
	var _UnsubscribeSuccess = __webpack_require__(2103);
	
	var _UnsubscribeSuccess2 = _interopRequireDefault(_UnsubscribeSuccess);
	
	var _UnsubscribeError = __webpack_require__(2100);
	
	var _UnsubscribeError2 = _interopRequireDefault(_UnsubscribeError);
	
	__webpack_require__(1258);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        dispatchRefreshCurrentUser: function dispatchRefreshCurrentUser() {
	            return dispatch((0, _currentUserActions.refreshCurrentUser)());
	        }
	    };
	};
	
	var unsubscribeHandlers = {
	    onUnsubscribeButtonClick: function onUnsubscribeButtonClick(props) {
	        return function (event) {
	            var subscription = props.subscription,
	                dispatchRefreshCurrentUser = props.dispatchRefreshCurrentUser,
	                setLoading = props.setLoading,
	                setSuccess = props.setSuccess,
	                setLoadingError = props.setLoadingError;
	
	
	            setLoading();
	
	            (0, _paymentService.deleteSubscription)({ subscriptionId: subscription.get('id') }).then(function (response) {
	                setSuccess();
	                dispatchRefreshCurrentUser();
	            }).catch(function (error) {
	                console.error(error);
	                setLoadingError(error);
	            });
	        };
	    },
	    onErrorButtonClick: function onErrorButtonClick(props) {
	        return function (event) {
	            props.setInitial();
	            props.clearLoadingError();
	        };
	    }
	};
	
	var UnsubscribeModal = function UnsubscribeModal(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'UnsubscribeModal' },
	        _react2.default.createElement(_LoadingTransitionDisplay2.default, _extends({}, props, {
	            InitialComponent: _UnsubscribeConfirm2.default,
	            LoadingComponent: _UnsubscribeProcessing2.default,
	            SuccessComponent: _UnsubscribeSuccess2.default,
	            ErrorComponent: _UnsubscribeError2.default }))
	    );
	};
	
	var enhance = (0, _recompose.compose)(_loadingTransitionDecorator2.default, (0, _reactRedux.connect)(_paymentSelector.unsubscribeSelector, mapDispatchToProps), (0, _recompose.withHandlers)(unsubscribeHandlers));
	
	exports.default = enhance(UnsubscribeModal);

/***/ }),
/* 2102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ProcessingPage = __webpack_require__(297);
	
	var _ProcessingPage2 = _interopRequireDefault(_ProcessingPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UnsubscribeProcessing = function UnsubscribeProcessing(props) {
	    return _react2.default.createElement(
	        _ProcessingPage2.default,
	        null,
	        _react2.default.createElement(
	            'h1',
	            null,
	            'Processing'
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            'This should only take a few seconds\u2026'
	        ),
	        _react2.default.createElement(
	            'p',
	            { className: 'disclaimer' },
	            _react2.default.createElement(
	                'a',
	                { href: 'mailto:support@milanote.com' },
	                'Report a problem'
	            )
	        )
	    );
	};
	
	exports.default = UnsubscribeProcessing;

/***/ }),
/* 2103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(45);
	
	var _FlexCenter = __webpack_require__(198);
	
	var _FlexCenter2 = _interopRequireDefault(_FlexCenter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UnsubscribeSuccess = function UnsubscribeSuccess(props) {
	    return _react2.default.createElement(
	        _FlexCenter2.default,
	        { className: 'UnsubscribeSuccess' },
	        _react2.default.createElement(
	            'p',
	            null,
	            'You\'ve downgraded to the free plan.'
	        ),
	        _react2.default.createElement(
	            _reactRouter.Link,
	            { className: 'Button FormButton primary', to: '/' },
	            'OK'
	        )
	    );
	};
	
	exports.default = UnsubscribeSuccess;

/***/ }),
/* 2104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FormButton = __webpack_require__(60);
	
	var _FormButton2 = _interopRequireDefault(_FormButton);
	
	var _Form = __webpack_require__(138);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _PrimaryErrorMessage = __webpack_require__(230);
	
	var _PrimaryErrorMessage2 = _interopRequireDefault(_PrimaryErrorMessage);
	
	var _CreditCardContainer = __webpack_require__(699);
	
	var _CreditCardContainer2 = _interopRequireDefault(_CreditCardContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaymentForm = function PaymentForm(props) {
	    var submitInterceptor = props.submitInterceptor,
	        submitting = props.submitting,
	        primaryError = props.primaryError,
	        dirtySinceSubmission = props.dirtySinceSubmission,
	        pristine = props.pristine;
	
	
	    return _react2.default.createElement(
	        _Form2.default,
	        { onSubmit: submitInterceptor, className: 'PaymentForm' },
	        _react2.default.createElement(
	            'h1',
	            null,
	            'Update your credit card details'
	        ),
	        _react2.default.createElement(_CreditCardContainer2.default, props),
	        _react2.default.createElement(_PrimaryErrorMessage2.default, { message: primaryError && primaryError.message,
	            show: !!primaryError && !dirtySinceSubmission && !submitting }),
	        _react2.default.createElement(
	            _FormButton2.default,
	            { type: 'submit', className: 'row payment', disabled: submitting || pristine },
	            'Save changes'
	        )
	    );
	};
	
	PaymentForm.propTypes = {
	    currentUser: _propTypes2.default.object,
	    submitting: _propTypes2.default.bool,
	    pristine: _propTypes2.default.bool,
	    submitInterceptor: _propTypes2.default.func,
	    primaryError: _propTypes2.default.object,
	    dirtySinceSubmission: _propTypes2.default.bool
	};
	
	exports.default = PaymentForm;

/***/ }),
/* 2105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(9);
	
	var _reactRedux = __webpack_require__(3);
	
	var _milanoteForm = __webpack_require__(104);
	
	var _milanoteForm2 = _interopRequireDefault(_milanoteForm);
	
	var _loadingTransitionDecorator = __webpack_require__(709);
	
	var _loadingTransitionDecorator2 = _interopRequireDefault(_loadingTransitionDecorator);
	
	var _LoadingTransitionDisplay = __webpack_require__(438);
	
	var _LoadingTransitionDisplay2 = _interopRequireDefault(_LoadingTransitionDisplay);
	
	var _UpdateCardForm = __webpack_require__(2104);
	
	var _UpdateCardForm2 = _interopRequireDefault(_UpdateCardForm);
	
	var _UpdateCardProcessing = __webpack_require__(2106);
	
	var _UpdateCardProcessing2 = _interopRequireDefault(_UpdateCardProcessing);
	
	var _UpdateCardSuccess = __webpack_require__(2107);
	
	var _UpdateCardSuccess2 = _interopRequireDefault(_UpdateCardSuccess);
	
	var _paymentActions = __webpack_require__(752);
	
	var _paymentSelector = __webpack_require__(308);
	
	var _paymentConstants = __webpack_require__(202);
	
	__webpack_require__(1259);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref) {
	    var setInitial = _ref.setInitial,
	        setSuccess = _ref.setSuccess,
	        setLoading = _ref.setLoading;
	    return {
	        onSubmit: function onSubmit(values) {
	            return dispatch((0, _paymentActions.submitCreditCardUpdateForm)(_extends({}, values, { setInitial: setInitial, setSuccess: setSuccess, setLoading: setLoading })));
	        },
	        dispatchClearCard: function dispatchClearCard() {
	            return dispatch((0, _paymentActions.clearPrefilledCard)());
	        }
	    };
	};
	
	var UpdateCardModal = function UpdateCardModal(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'UpdateCardModal' },
	        _react2.default.createElement(_LoadingTransitionDisplay2.default, _extends({}, props, {
	            InitialComponent: _UpdateCardForm2.default,
	            LoadingComponent: _UpdateCardProcessing2.default,
	            SuccessComponent: _UpdateCardSuccess2.default }))
	    );
	};
	
	var enhance = (0, _recompose.compose)(_loadingTransitionDecorator2.default, (0, _reactRedux.connect)(null, mapDispatchToProps), (0, _milanoteForm2.default)({ form: _paymentConstants.PAYMENT_FORM_NAME, fieldsConfig: _paymentConstants.CARD_UPDATE_FORM_FIELDS }, _paymentSelector.paymentFormValuesSelector));
	
	exports.default = enhance(UpdateCardModal);

/***/ }),
/* 2106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ProcessingPage = __webpack_require__(297);
	
	var _ProcessingPage2 = _interopRequireDefault(_ProcessingPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UpdateCardProcessing = function UpdateCardProcessing(props) {
	    return _react2.default.createElement(
	        _ProcessingPage2.default,
	        null,
	        _react2.default.createElement(
	            'h1',
	            null,
	            'Processing'
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            'This should only take a few seconds\u2026'
	        ),
	        _react2.default.createElement(
	            'p',
	            { className: 'disclaimer' },
	            _react2.default.createElement(
	                'a',
	                { href: 'mailto:support@milanote.com' },
	                'Report a problem'
	            )
	        )
	    );
	};
	
	exports.default = UpdateCardProcessing;

/***/ }),
/* 2107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(45);
	
	var _FlexCenter = __webpack_require__(198);
	
	var _FlexCenter2 = _interopRequireDefault(_FlexCenter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UpdateCardSuccess = function UpdateCardSuccess(props) {
	    return _react2.default.createElement(
	        _FlexCenter2.default,
	        { className: 'UpdateCardSuccess' },
	        _react2.default.createElement(
	            'h1',
	            null,
	            'Success'
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            'Your credit card details have been updated.'
	        ),
	        _react2.default.createElement(
	            _reactRouter.Link,
	            { className: 'Button FormButton primary', to: '/' },
	            'OK'
	        )
	    );
	};
	
	exports.default = UpdateCardSuccess;

/***/ }),
/* 2108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	// Utils
	
	
	// Constants
	
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _authService = __webpack_require__(227);
	
	var _userConstants = __webpack_require__(32);
	
	var _currentUserConstants = __webpack_require__(144);
	
	var _elementConstants = __webpack_require__(12);
	
	var _authConstants = __webpack_require__(136);
	
	var _notificationConstants = __webpack_require__(88);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialState = Immutable.Map({
	    _id: 'guest',
	    // TODO This might be erroneous, maybe it needs to be set during bootstrap
	    // It causes the initial state object to forever be what it was when the app loaded
	    isGuest: !(0, _authService.getCurrentUserToken)(),
	    authenticated: false,
	    fetched: false,
	    clientId: 'NULLID',
	    clientTick: 0,
	    viewedBoards: Immutable.Map()
	});
	
	var updateCurrentUserDetails = function updateCurrentUserDetails(state, action) {
	    if (action.userId !== state.get('_id')) return state;
	
	    var userChanges = Immutable.fromJS(action.changes);
	    return state.mergeDeep(userChanges);
	};
	
	var updateViewedBoards = function updateViewedBoards(state, viewedBoardIds, timestamp) {
	    return state.update('viewedBoards', function (viewedBoards) {
	        var updatedBoards = viewedBoards;
	        viewedBoardIds.forEach(function (id) {
	            updatedBoards = updatedBoards.set(id, timestamp);
	        });
	        return updatedBoards;
	    });
	};
	
	var setUserImageData = function setUserImageData(state, action) {
	    return state.setIn(['image', 'data'], action.imageData).setIn(['image', 'uploading'], true);
	};
	
	var setUserImageUploadComplete = function setUserImageUploadComplete(state, action) {
	    return state.setIn(['image', 'uploading'], false);
	};
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _userConstants.USER_UPDATE:
	            return updateCurrentUserDetails(state, action);
	        case _authConstants.LOGOUT:
	            return initialState.set('isGuest', true);
	        case _authConstants.REGISTER_SUCCESS:
	        case _authConstants.LOGIN_SUCCESS:
	            return state.set('isGuest', false);
	        case _userConstants.USER_REFRESH:
	        case _currentUserConstants.CURRENT_USER_SET:
	            return Immutable.fromJS(_extends({}, action.user, {
	                isGuest: false,
	                authenticated: true,
	                fetched: true,
	                viewedBoards: {}
	            }));
	        case _elementConstants.ELEMENT_CREATE:
	            return state.update('clientTick', function (tick) {
	                return tick + 1;
	            });
	        case _userConstants.USER_NAVIGATE:
	            return updateViewedBoards(state, [action.newBoardId, action.previousBoardId], action.timestamp);
	        case _notificationConstants.MODIFIED_ELEMENTS_MARK_SEEN:
	            return updateViewedBoards(state, action.ids, action.timestamp);
	        case _currentUserConstants.CURRENT_USER_IMAGE_SET:
	            return setUserImageData(state, action);
	        // TODO Image error handling
	        case _currentUserConstants.CURRENT_USER_IMAGE_UPLOAD_ERROR:
	        case _currentUserConstants.CURRENT_USER_IMAGE_UPLOAD_COMPLETE:
	            return setUserImageUploadComplete(state, action);
	        default:
	            return state;
	    }
	};

/***/ }),
/* 2109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(4);
	
	var _elementCountActions = __webpack_require__(464);
	
	var _popupActions = __webpack_require__(35);
	
	var _elementCountSelector = __webpack_require__(170);
	
	var _currentUserSelector = __webpack_require__(33);
	
	var _elementHelper = __webpack_require__(13);
	
	var _elementMoveActionUtil = __webpack_require__(729);
	
	var _immutableHelper = __webpack_require__(23);
	
	var _notificationUtils = __webpack_require__(324);
	
	var _elementConstants = __webpack_require__(12);
	
	var _elementCountConstants = __webpack_require__(169);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // Lib
	
	
	// Actions
	
	
	// Selectors
	
	
	// Utils
	
	
	// Constants
	
	
	/**
	 * Creations or deletions (of new elements) don't need to perform any requests to the server to find child elements
	 * (as there won't be any).
	 */
	var createNewElementModifyCountMiddlewareFn = function createNewElementModifyCountMiddlewareFn(transformCountElementFn) {
	    return function (store, action) {
	        var elementType = action.elementType;
	        // dispatch an action to reduce the element count based on the type of the element
	        store.dispatch(transformCountElementFn(_defineProperty({}, elementType, 1), action.transactionId));
	    };
	};
	
	var increaseCountNewElement = createNewElementModifyCountMiddlewareFn(_elementCountActions.increaseElementCount);
	var reduceCountNewElement = createNewElementModifyCountMiddlewareFn(_elementCountActions.increaseElementCount);
	
	var createModifyCountMiddlewareFn = function createModifyCountMiddlewareFn(transformCountElementFn, transformCountContainerFn) {
	    return function (store, action) {
	        var state = store.getState();
	        var currentUserId = (0, _currentUserSelector.getCurrentUserId)(state);
	
	        // If the action is a create or delete the || case will be used
	        var moves = action.moves || [(0, _lodash.pick)(action, ['id', 'location', 'from'])];
	        var movedElementsOfInterest = moves.filter(_elementMoveActionUtil.isMoveToOrFromTrash).map(function (_ref) {
	            var id = _ref.id;
	            return state.getIn(['elements', id]);
	        }).filter((0, _elementHelper.isElementCreatedByUser)(currentUserId));
	
	        // NOTE: This assumes that multi-moves will only ever all be to trash or from trash.
	        var countsMap = movedElementsOfInterest.reduce(_notificationUtils.reduceTypeCounts, {});
	
	        // If there's no changes in the element count then no need to continue
	        if ((0, _lodash.reduce)(countsMap, _lodash.add, 0) <= 0) return;
	
	        // dispatch an action to reduce the element count based on the type of the element
	        store.dispatch(transformCountElementFn(countsMap, action.transactionId));
	
	        movedElementsOfInterest.filter(_elementHelper.isContainer).forEach(function (element) {
	            // if the element is a container, also fetch it's children count and remove those as well
	            var elementId = (0, _elementHelper.getPhysicalId)(element);
	            store.dispatch(transformCountContainerFn(elementId, action.transactionId));
	        });
	    };
	};
	
	var increaseCount = createModifyCountMiddlewareFn(_elementCountActions.increaseElementCount, _elementCountActions.fetchBoardDescendantCountAndIncrease);
	
	var reduceCount = createModifyCountMiddlewareFn(_elementCountActions.decreaseElementCount, _elementCountActions.fetchBoardDescendantCountAndDecrease);
	
	// only these actions will change the count
	// otherwise, ignore the action
	var actionTypePredicate = function actionTypePredicate(action) {
	    switch (action.type) {
	        case _elementConstants.ELEMENT_DELETE:
	        case _elementConstants.ELEMENT_CREATE:
	        case _elementCountConstants.ELEMENT_COUNT_INCREAESE:
	        case _elementCountConstants.ELEMENT_COUNT_DECREASE:
	            return true;
	        case _elementConstants.ELEMENT_MOVE_MULTI:
	            return action.moves.some(_elementMoveActionUtil.isMoveToOrFromTrash);
	        default:
	            return false;
	    }
	};
	
	var remoteActionPredicate = function remoteActionPredicate(action, state) {
	    // if action is local, we care about it
	    if (!action.remote) return true;
	
	    var element = state.getIn(['elements', action.id]) || action;
	    if (!element) return false;
	
	    // if element is a container, we care about it even if it's isn't created by
	    // the current user because it could contain elements we care about
	    var elementType = (0, _immutableHelper.prop)('elementType', element);
	    if ((0, _elementHelper.isContainer)(elementType)) return true;
	
	    // if element isn't a container, check the creator - we only care about
	    // elements created by the current user
	    var currentUserId = state.getIn(['app', 'currentUser', '_id']);
	    var elementCreator = (0, _immutableHelper.propIn)(['meta', 'creator'], element);
	
	    return elementCreator && elementCreator === currentUserId;
	};
	
	var actionPredicate = function actionPredicate(action, state) {
	    return actionTypePredicate(action) && remoteActionPredicate(action, state);
	};
	
	var elementCountTrackingMiddleware = function elementCountTrackingMiddleware(store) {
	    return function (next) {
	        return function (action) {
	            if (action.isUndo || action.isRedo) return next(action);
	
	            // NOTE: Here we're assuming that the move is either a deletion or addition, but it can't be both
	            //  Need to change this in the future if this proves to be incorrect
	            if (action.type === _elementConstants.ELEMENT_MOVE_MULTI && action.moves.some(_elementMoveActionUtil.isMoveToTrash)) {
	                reduceCount(store, action);
	            }
	            if (action.type === _elementConstants.ELEMENT_MOVE_MULTI && action.moves.some(_elementMoveActionUtil.isMoveFromTrash)) {
	                increaseCount(store, action);
	            }
	
	            if (action.type === _elementConstants.ELEMENT_DELETE) {
	                reduceCountNewElement(store, action);
	            }
	
	            if (action.type === _elementConstants.ELEMENT_CREATE) {
	                increaseCountNewElement(store, action);
	            }
	
	            return next(action);
	        };
	    };
	};
	
	// this will intercept element create actions and stop them from occurring
	// when the user's element count has been exceeded
	var elementCreationInterceptMiddleware = function elementCreationInterceptMiddleware(store) {
	    return function (next) {
	        return function (action) {
	            if (action.remote || action.type !== _elementConstants.ELEMENT_CREATE) return next(action);
	
	            var elementType = action.elementType,
	                duplicate = action.duplicate;
	
	
	            var state = store.getState();
	
	            if (!(0, _elementHelper.isContainer)(elementType) || duplicate) {
	                var totalContent = (0, _elementCountSelector.contentTotalCountSelector)(state);
	                var totalContentLimit = (0, _elementCountSelector.contentTotalLimitSelector)(state);
	
	                if (totalContent >= totalContentLimit) return store.dispatch((0, _popupActions.openPopup)(_elementCountConstants.ELEMENT_COUNT_LIMIT_POPUP));
	            }
	
	            return next(action);
	        };
	    };
	};
	
	exports.default = function (store) {
	    return function (next) {
	        return function (action) {
	            var state = store.getState();
	
	            // only count if the action is of interest
	            if (!actionPredicate(action, state)) return next(action);
	
	            return elementCreationInterceptMiddleware(store)(elementCountTrackingMiddleware(store)(next))(action);
	        };
	    };
	};

/***/ }),
/* 2110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(4);
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _elementCountConstants = __webpack_require__(169);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initalState = Immutable.Map();
	
	var updateCount = function updateCount() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var modifiy = arguments[1];
	    return Math.max(state + modifiy, 0);
	};
	
	/**
	 * Abstract state transformer for element counts
	 * @param {method} valueTransformer - method used to transform each key in the state
	 * @param {string} state - current state of the reducer
	 * @param {object} action - deconstruected for just { counts }; a map of elementCounts used to modifiy the existing state
	 * @return {object} transformed state
	 *
	 * @example
	 * // results in { CARD: 3, BOARD: 4 }
	 * const stateTransform = (state = 0, modifiy) => state + modifiy;
	 * transformCount(stateTransform)({ CARD: 2, BOARD: 1 }, { CARD: 1, BOARD: 3 })
	 * @example
	 */
	var transformCount = function transformCount(valueTransformer) {
	    return function (state, _ref) {
	        var counts = _ref.counts;
	        return state.withMutations(function (mutateState) {
	            var elementTypes = (0, _lodash.keys)(counts);
	            elementTypes.forEach(function (type) {
	                mutateState.set(type, valueTransformer(mutateState.get(type, 0), counts[type]));
	            });
	        });
	    };
	};
	
	var increaseElementCount = transformCount(updateCount);
	var decreaseElementCount = transformCount(function (a, b) {
	    return updateCount(a, b * -1);
	});
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initalState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _elementCountConstants.ELEMENT_COUNT_INCREAESE:
	            return increaseElementCount(state, action);
	        case _elementCountConstants.ELEMENT_COUNT_DECREASE:
	            return decreaseElementCount(state, action);
	        default:
	            return state;
	    }
	};

/***/ }),
/* 2111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _LinkButton = __webpack_require__(74);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	var _TeamSuggestionButton = __webpack_require__(756);
	
	var _TeamSuggestionButton2 = _interopRequireDefault(_TeamSuggestionButton);
	
	var _PopupPanel = __webpack_require__(54);
	
	var _PopupPanel2 = _interopRequireDefault(_PopupPanel);
	
	var _popupActions = __webpack_require__(35);
	
	var _userHelper = __webpack_require__(175);
	
	__webpack_require__(1260);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var POPUP_NAME = 'add-users-additional';
	
	var AddUserPopup = function AddUserPopup(_ref) {
	    var users = _ref.users,
	        addUser = _ref.addUser;
	    return _react2.default.createElement(
	        _PopupPanel2.default,
	        { popupId: POPUP_NAME, className: 'AddUserPopup', arrowDir: 'null', isSubPopup: true },
	        _react2.default.createElement(
	            'ul',
	            null,
	            users.map(function (user) {
	                return _react2.default.createElement(
	                    'li',
	                    { key: (0, _userHelper.getId)(user) },
	                    _react2.default.createElement(_TeamSuggestionButton2.default, { user: user, addUser: addUser })
	                );
	            })
	        )
	    );
	};
	
	AddUserPopup.propTypes = {
	    users: _propTypes2.default.object,
	    popupOpen: _propTypes2.default.bool,
	    addUser: _propTypes2.default.func,
	    togglePopup: _propTypes2.default.func
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        handlePopupButtonClick: function handlePopupButtonClick() {
	            return dispatch((0, _popupActions.togglePopup)(POPUP_NAME));
	        }
	    };
	};
	
	var AdditionalTeamSuggestionsUtil = function AdditionalTeamSuggestionsUtil(_ref2) {
	    var users = _ref2.users,
	        handlePopupButtonClick = _ref2.handlePopupButtonClick,
	        addUser = _ref2.addUser;
	
	    if (!users.size) return null;
	
	    return _react2.default.createElement(
	        'li',
	        { className: 'AdditionalTeamSuggestionsUtil' },
	        _react2.default.createElement(
	            _LinkButton2.default,
	            { onClickFn: handlePopupButtonClick },
	            users.size,
	            ' more...'
	        ),
	        _react2.default.createElement(AddUserPopup, {
	            users: users,
	            addUser: addUser })
	    );
	};
	
	AdditionalTeamSuggestionsUtil.propTypes = {
	    users: _propTypes2.default.object,
	    popupOpen: _propTypes2.default.bool,
	    handlePopupButtonClick: _propTypes2.default.func,
	    addUser: _propTypes2.default.func
	};
	
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(AdditionalTeamSuggestionsUtil);

/***/ }),
/* 2112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Constants
	
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _userConstants = __webpack_require__(311);
	
	var _currentUserConstants = __webpack_require__(144);
	
	var _selectionConstants = __webpack_require__(77);
	
	var _elementConstants = __webpack_require__(12);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialState = Immutable.Map({
	    currentBoardId: null,
	    timestamp: null,
	    selectedElementIds: null
	});
	
	var updateUser = function updateUser(state, action) {
	    var userChanges = Immutable.fromJS(action.changes);
	    return state.mergeDeep(userChanges);
	};
	
	var setUser = function setUser(state, action) {
	    return state.mergeDeep(Immutable.fromJS(action.user));
	};
	
	var updateActiveUserBoard = function updateActiveUserBoard(state, action) {
	    var timestamp = action.modified || action.timestamp;
	    return state.set('onlineStatus', _userConstants.USER_ONLINE_STATUS.CONNECTED).set('currentBoardId', action.newBoardId).set('timestamp', timestamp);
	};
	
	var updateActiveUserTimestamp = function updateActiveUserTimestamp(state, action) {
	    var timestamp = action.modified || action.timestamp;
	    return state.set('onlineStatus', _userConstants.USER_ONLINE_STATUS.CONNECTED).set('timestamp', timestamp);
	};
	
	var connectUser = function connectUser(state, action) {
	    return state.set('onlineStatus', _userConstants.USER_ONLINE_STATUS.CONNECTED).set('timestamp', action.timestamp);
	};
	
	var disconnectUser = function disconnectUser(state, action) {
	    return state.set('onlineStatus', _userConstants.USER_ONLINE_STATUS.DISCONNECTED).set('selectedElementIds', null);
	};
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _userConstants.USER_UPDATE:
	            return updateUser(state, action);
	        case _userConstants.USER_REFRESH:
	        case _currentUserConstants.CURRENT_USER_SET:
	            return setUser(state, {
	                user: _extends({}, action.user, {
	                    onlineStatus: _userConstants.USER_ONLINE_STATUS.CONNECTED,
	                    authenticated: true,
	                    fetched: true
	                })
	            });
	        case _userConstants.USER_NAVIGATE:
	            return updateActiveUserBoard(state, action);
	        case _elementConstants.ELEMENT_MOVE_MULTI:
	        case _elementConstants.ELEMENT_UPDATE:
	        case _selectionConstants.ELEMENTS_SELECTED:
	        case _selectionConstants.ELEMENTS_DESELECTED:
	            return updateActiveUserTimestamp(state, action);
	        case _userConstants.USER_CONNECT:
	            return connectUser(state, action);
	        case _userConstants.USER_ACTIVITY_LOAD:
	        case _userConstants.USER_DISCONNECT:
	            return disconnectUser(state, action);
	        default:
	            return state;
	    }
	};

/***/ }),
/* 2113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _logger = __webpack_require__(128);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _userReducer = __webpack_require__(2112);
	
	var _userReducer2 = _interopRequireDefault(_userReducer);
	
	var _userConstants = __webpack_require__(311);
	
	var _currentUserConstants = __webpack_require__(144);
	
	var _selectionConstants = __webpack_require__(77);
	
	var _elementConstants = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Constants
	
	
	// Utils
	var initialState = Immutable.Map();
	
	// Reducers
	// Lib
	
	
	var addTrackedUsers = function addTrackedUsers(state, action) {
	    return state.withMutations(function (mutableState) {
	        return action.userIds.forEach(function (userId) {
	            return mutableState.setIn([userId, '_id'], userId);
	        });
	    });
	};
	
	var loadUsers = function loadUsers(state, action) {
	    return state.mergeDeep(action.users);
	};
	
	var loadActiveUsers = function loadActiveUsers(state, action) {
	    return state.mergeDeep(action.users);
	};
	
	/**
	 * Delegates the handling of the action to the user.
	 * If the user does not exist then add its entry to the state.
	 */
	var delegateToUser = function delegateToUser(state, action) {
	    if (!(action.user && action.user._id) && !action.userId) {
	        _logger2.default.warn('User action does not contain a user ID', action);
	        return state;
	    }
	
	    var userId = action.userId || action.user._id;
	
	    // If we don't have the user then we cannot update it, we must set it
	    return state.get(userId) ? state.update(userId, function (userEntry) {
	        return (0, _userReducer2.default)(userEntry, action);
	    }) : state.set(userId, (0, _userReducer2.default)(undefined, action));
	};
	
	var userActivityLoad = function userActivityLoad(state, action) {
	    return state.withMutations(function (mutableState) {
	        loadActiveUsers(mutableState, action);
	        action.disconnectedUserIds.forEach(function (disconnectedUserId) {
	            return mutableState.update(disconnectedUserId, function (userState) {
	                return (0, _userReducer2.default)(userState, action);
	            });
	        });
	    });
	};
	
	var delegateRemoteActionToUser = function delegateRemoteActionToUser(state, action) {
	    return action.remote ? delegateToUser(state, action) : state;
	};
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _userConstants.USER_ACTIVITY_LOAD:
	            return userActivityLoad(state, action);
	        case _userConstants.USERS_LOAD:
	            return loadUsers(state, action);
	        case _userConstants.USER_REFRESH:
	        case _userConstants.USER_UPDATE:
	        case _currentUserConstants.CURRENT_USER_SET:
	        case _userConstants.USER_NAVIGATE:
	            return delegateToUser(state, action);
	        case _elementConstants.ELEMENT_MOVE_MULTI:
	        case _elementConstants.ELEMENT_UPDATE:
	        case _selectionConstants.ELEMENTS_SELECTED:
	        case _selectionConstants.ELEMENTS_DESELECTED:
	        case _userConstants.USER_CONNECT:
	        case _userConstants.USER_DISCONNECT:
	            return delegateRemoteActionToUser(state, action);
	        case _userConstants.TRACK_USERS:
	            return addTrackedUsers(state, action);
	        case _elementConstants.ELEMENT_SHARE:
	            return addTrackedUsers(state, { userIds: [action.userId] });
	        default:
	            return state;
	    }
	};

/***/ }),
/* 2114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RemoteUserManager = __webpack_require__(2116);
	
	var _RemoteUserManager2 = _interopRequireDefault(_RemoteUserManager);
	
	var _SocketChannelManager = __webpack_require__(2117);
	
	var _SocketChannelManager2 = _interopRequireDefault(_SocketChannelManager);
	
	var _StaleBoardManager = __webpack_require__(2118);
	
	var _StaleBoardManager2 = _interopRequireDefault(_StaleBoardManager);
	
	var _UserActivityManager = __webpack_require__(2119);
	
	var _UserActivityManager2 = _interopRequireDefault(_UserActivityManager);
	
	var _RefreshStaleBoardManager = __webpack_require__(2115);
	
	var _RefreshStaleBoardManager2 = _interopRequireDefault(_RefreshStaleBoardManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	// Components
	
	
	var CollaborationManager = function (_React$Component) {
	    _inherits(CollaborationManager, _React$Component);
	
	    function CollaborationManager() {
	        _classCallCheck(this, CollaborationManager);
	
	        return _possibleConstructorReturn(this, (CollaborationManager.__proto__ || Object.getPrototypeOf(CollaborationManager)).apply(this, arguments));
	    }
	
	    _createClass(CollaborationManager, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                children = _props.children,
	                currentBoardId = _props.currentBoardId;
	
	            return _react2.default.createElement(
	                _RefreshStaleBoardManager2.default,
	                { currentBoardId: currentBoardId },
	                _react2.default.createElement(
	                    _StaleBoardManager2.default,
	                    { currentBoardId: currentBoardId },
	                    _react2.default.createElement(
	                        _SocketChannelManager2.default,
	                        { currentBoardId: currentBoardId },
	                        _react2.default.createElement(
	                            _UserActivityManager2.default,
	                            { currentBoardId: currentBoardId },
	                            _react2.default.createElement(
	                                _RemoteUserManager2.default,
	                                { currentBoardId: currentBoardId },
	                                children
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CollaborationManager;
	}(_react2.default.Component);
	
	CollaborationManager.propTypes = {
	    children: _propTypes2.default.element.isRequired,
	    currentBoardId: _propTypes2.default.string
	};
	
	exports.default = CollaborationManager;

/***/ }),
/* 2115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class; // Lib
	
	
	// Util
	
	
	// Services
	
	
	// Selectors
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(4);
	
	var _milanoteReselect = __webpack_require__(49);
	
	var _boardService = __webpack_require__(167);
	
	var _socketChannelSelector = __webpack_require__(465);
	
	var _socketChannelSelector2 = _interopRequireDefault(_socketChannelSelector);
	
	var _boardSelector = __webpack_require__(83);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = (0, _milanoteReselect.createShallowSelector)(_socketChannelSelector2.default, _boardSelector.getFetchedBoardIds, function (_ref, fetchedBoardIds) {
	    var boardChannels = _ref.boardChannels;
	    return {
	        boardChannels: boardChannels,
	        fetchedBoardIds: fetchedBoardIds
	    };
	});
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        dispatchRefreshIfModified: function dispatchRefreshIfModified(boardId) {
	            return dispatch((0, _boardService.refreshIfModified)({ boardId: boardId }));
	        }
	    };
	};
	
	var RefreshStaleBoardManager = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_React$Component) {
	    _inherits(RefreshStaleBoardManager, _React$Component);
	
	    function RefreshStaleBoardManager() {
	        _classCallCheck(this, RefreshStaleBoardManager);
	
	        return _possibleConstructorReturn(this, (RefreshStaleBoardManager.__proto__ || Object.getPrototypeOf(RefreshStaleBoardManager)).apply(this, arguments));
	    }
	
	    _createClass(RefreshStaleBoardManager, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var dispatchRefreshIfModified = nextProps.dispatchRefreshIfModified,
	                boardChannels = nextProps.boardChannels,
	                fetchedBoardIds = nextProps.fetchedBoardIds;
	
	
	            if (boardChannels !== this.props.boardChannels) {
	                var newBoardChannels = (0, _lodash.difference)(boardChannels, this.props.boardChannels);
	                newBoardChannels.forEach(function (boardId) {
	                    // Haven't retrieved the board yet so no need checking if it's been modified
	                    if (!(0, _lodash.includes)(fetchedBoardIds, boardId)) return;
	
	                    dispatchRefreshIfModified(boardId);
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.Children.only(this.props.children);
	        }
	    }]);
	
	    return RefreshStaleBoardManager;
	}(_react2.default.Component)) || _class);
	
	
	RefreshStaleBoardManager.propTypes = {
	    children: _propTypes2.default.element.isRequired,
	    boardChannels: _propTypes2.default.array,
	    fetchedBoardIds: _propTypes2.default.array,
	    dispatchRefreshIfModified: _propTypes2.default.func
	};
	
	exports.default = RefreshStaleBoardManager;

/***/ }),
/* 2116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reselect = __webpack_require__(7);
	
	var _lodash = __webpack_require__(4);
	
	var _milanoteReselect = __webpack_require__(49);
	
	var _userService = __webpack_require__(106);
	
	var userService = _interopRequireWildcard(_userService);
	
	var _elementService = __webpack_require__(731);
	
	var elementService = _interopRequireWildcard(_elementService);
	
	var _remoteUsersSelector = __webpack_require__(237);
	
	var _currentUserSelector = __webpack_require__(33);
	
	var _permissionsService = __webpack_require__(75);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } // Lib
	
	
	// Utils
	
	
	// Selectors
	
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        fetchUsers: function fetchUsers(userIds) {
	            return dispatch(userService.fetchUsers(userIds));
	        },
	        fetchElements: function fetchElements(elementIds) {
	            return dispatch(elementService.fetchElements({ elementIds: elementIds, loadAncestors: true }));
	        }
	    };
	};
	
	/**
	 * Fetch any user that is in the user store, or has permissions to the current board (but isn't in the user store).
	 *
	 * The latter situation could happen if a board with an ACL that contains new users is moved inside another shared
	 * board, and the current user then navigates to that board.
	 */
	var remoteUserSelector = (0, _milanoteReselect.createShallowSelector)(_remoteUsersSelector.getTrackedUserIds, _permissionsService.currentBoardSharedUsersSelector, function (remoteUserIds, currentBoardSharedUsers) {
	    return (0, _lodash.uniq)([].concat(_toConsumableArray(remoteUserIds), _toConsumableArray(currentBoardSharedUsers)));
	});
	
	var sharedUserManagerSelector = (0, _reselect.createSelector)(remoteUserSelector, _remoteUsersSelector.getRemoteCurrentlyViewedBoardIds, _currentUserSelector.isGuestSelector, function (remoteUserIds, currentlyViewedBoardIds, isGuest) {
	    return {
	        remoteUserIds: remoteUserIds,
	        currentlyViewedBoardIds: currentlyViewedBoardIds,
	        isGuest: isGuest
	    };
	});
	
	/**
	 * Ensures that the shared users are being fetched whenever the component is mounted or the board is changed.
	 */
	var RemoteUserManager = (_dec = (0, _reactRedux.connect)(sharedUserManagerSelector, mapDispatchToProps), _dec(_class = function (_React$Component) {
	    _inherits(RemoteUserManager, _React$Component);
	
	    function RemoteUserManager() {
	        _classCallCheck(this, RemoteUserManager);
	
	        return _possibleConstructorReturn(this, (RemoteUserManager.__proto__ || Object.getPrototypeOf(RemoteUserManager)).apply(this, arguments));
	    }
	
	    _createClass(RemoteUserManager, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                remoteUserIds = _props.remoteUserIds,
	                fetchUsers = _props.fetchUsers,
	                isGuest = _props.isGuest;
	
	
	            if (isGuest) return;
	
	            fetchUsers(remoteUserIds);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var isGuest = nextProps.isGuest;
	
	            if (isGuest) return;
	
	            // Load remote users
	            if (this.props.remoteUserIds !== nextProps.remoteUserIds) {
	                var remoteUserIds = nextProps.remoteUserIds,
	                    fetchUsers = nextProps.fetchUsers;
	
	                fetchUsers(remoteUserIds);
	            }
	
	            if (this.props.currentlyViewedBoardIds !== nextProps.currentlyViewedBoardIds) {
	                var currentlyViewedBoardIds = nextProps.currentlyViewedBoardIds,
	                    fetchElements = nextProps.fetchElements;
	
	                fetchElements(currentlyViewedBoardIds);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.Children.only(this.props.children);
	        }
	    }]);
	
	    return RemoteUserManager;
	}(_react2.default.Component)) || _class);
	
	
	RemoteUserManager.propTypes = {
	    children: _propTypes2.default.element.isRequired,
	    fetchUsers: _propTypes2.default.func,
	    fetchElements: _propTypes2.default.func,
	    remoteUserIds: _propTypes2.default.array,
	    currentlyViewedBoardIds: _propTypes2.default.array,
	    isGuest: _propTypes2.default.bool
	};
	
	exports.default = RemoteUserManager;

/***/ }),
/* 2117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class; // Lib
	
	
	// Actions
	
	
	// Selectors
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(4);
	
	var _socketActions = __webpack_require__(767);
	
	var _socketChannelSelector = __webpack_require__(465);
	
	var _socketChannelSelector2 = _interopRequireDefault(_socketChannelSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        dispatchChannelsUpdated: function dispatchChannelsUpdated(channelUpdate) {
	            return dispatch((0, _socketActions.channelsUpdated)(channelUpdate));
	        }
	    };
	};
	
	var SocketChannelManager = (_dec = (0, _reactRedux.connect)(_socketChannelSelector2.default, mapDispatchToProps), _dec(_class = function (_React$Component) {
	    _inherits(SocketChannelManager, _React$Component);
	
	    function SocketChannelManager() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, SocketChannelManager);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SocketChannelManager.__proto__ || Object.getPrototypeOf(SocketChannelManager)).call.apply(_ref, [this].concat(args))), _this), _this.updateChannels = function (_ref2) {
	            var nextChannels = _ref2.nextChannels,
	                _ref2$prevChannels = _ref2.prevChannels,
	                prevChannels = _ref2$prevChannels === undefined ? [] : _ref2$prevChannels,
	                boardChannels = _ref2.boardChannels;
	            var dispatchChannelsUpdated = _this.props.dispatchChannelsUpdated;
	
	
	            var joined = (0, _lodash.difference)(nextChannels, prevChannels);
	            var left = (0, _lodash.difference)(prevChannels, nextChannels);
	
	            // Don't update if we haven't joined or left anything
	            if (!joined.length && !left.length) return;
	
	            dispatchChannelsUpdated({
	                joined: joined,
	                left: left,
	                boardChannels: boardChannels
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(SocketChannelManager, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                channels = _props.channels,
	                boardChannels = _props.boardChannels;
	
	            this.updateChannels({ nextChannels: channels, boardChannels: boardChannels });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var channels = nextProps.channels,
	                boardChannels = nextProps.boardChannels;
	
	
	            if (channels !== this.props.channels) {
	                this.updateChannels({ nextChannels: channels, prevChannels: this.props.channels, boardChannels: boardChannels });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.Children.only(this.props.children);
	        }
	    }]);
	
	    return SocketChannelManager;
	}(_react2.default.Component)) || _class);
	
	
	SocketChannelManager.propTypes = {
	    children: _propTypes2.default.element.isRequired,
	    channels: _propTypes2.default.array,
	    boardChannels: _propTypes2.default.array,
	    dispatchChannelsUpdated: _propTypes2.default.func
	};
	
	exports.default = SocketChannelManager;

/***/ }),
/* 2118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class; // Lib
	
	
	// Util
	
	
	// Actions
	
	
	// Selectors
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reselect = __webpack_require__(7);
	
	var _lodash = __webpack_require__(4);
	
	var _milanoteReselect = __webpack_require__(49);
	
	var _boardActions = __webpack_require__(1952);
	
	var _socketChannelSelector = __webpack_require__(465);
	
	var _socketChannelSelector2 = _interopRequireDefault(_socketChannelSelector);
	
	var _remoteUsersSelector = __webpack_require__(237);
	
	var _currentUserSelector = __webpack_require__(33);
	
	var _boardSelector = __webpack_require__(83);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EMPTY_ARRAY = [];
	
	var shallowPotentiallyStaleElementsSelector = (0, _milanoteReselect.createShallowSelector)(_socketChannelSelector2.default, _remoteUsersSelector.getRemoteActiveCurrentlyViewedBoardIds, _currentUserSelector.isGuestSelector, function (_ref, viewedBoardIds, isGuest) {
	    var channels = _ref.channels;
	    return isGuest ? EMPTY_ARRAY :
	    // Any board that is currently being viewed and we are not connected to the channel of could be stale
	    (0, _lodash.difference)(viewedBoardIds, channels);
	});
	
	var retrievedStaleElementsSelector = (0, _milanoteReselect.createShallowSelector)(shallowPotentiallyStaleElementsSelector, _boardSelector.getFetchedBoardIds, _currentUserSelector.isGuestSelector, function (potentiallyStaleElements, retrievedBoardIds, isGuest) {
	    return isGuest ? EMPTY_ARRAY :
	    // The stale elements are any elements that have been retrieved and are being edited by remote users in
	    // channels that the current user is not connected to.
	    (0, _lodash.intersection)(potentiallyStaleElements, retrievedBoardIds);
	});
	
	var mapStateToProps = (0, _reselect.createSelector)(retrievedStaleElementsSelector, _currentUserSelector.isGuestSelector, function (staleBoards, isGuest) {
	    return { staleBoards: staleBoards, isGuest: isGuest };
	});
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        dispatchMarkElementsAsStale: function dispatchMarkElementsAsStale(ids) {
	            return dispatch((0, _boardActions.markBoardResourcesAsStale)({ ids: ids }));
	        }
	    };
	};
	
	/**
	 * Figures out which elements are currently being viewed by remote users and not the current user and marks those
	 * elements as stale by firing a ELEMENTS_STALE action.
	 */
	var StaleBoardManager = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_React$Component) {
	    _inherits(StaleBoardManager, _React$Component);
	
	    function StaleBoardManager() {
	        _classCallCheck(this, StaleBoardManager);
	
	        return _possibleConstructorReturn(this, (StaleBoardManager.__proto__ || Object.getPrototypeOf(StaleBoardManager)).apply(this, arguments));
	    }
	
	    _createClass(StaleBoardManager, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                staleBoards = _props.staleBoards,
	                dispatchMarkElementsAsStale = _props.dispatchMarkElementsAsStale,
	                isGuest = _props.isGuest;
	
	            if (isGuest) return;
	
	            staleBoards.length && dispatchMarkElementsAsStale(staleBoards);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var staleBoards = nextProps.staleBoards,
	                dispatchMarkElementsAsStale = nextProps.dispatchMarkElementsAsStale,
	                isGuest = nextProps.isGuest;
	
	            if (isGuest) return;
	
	            if (this.props.staleBoards !== staleBoards && staleBoards.length) {
	                dispatchMarkElementsAsStale(staleBoards);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.Children.only(this.props.children);
	        }
	    }]);
	
	    return StaleBoardManager;
	}(_react2.default.Component)) || _class);
	
	
	StaleBoardManager.propTypes = {
	    children: _propTypes2.default.element.isRequired,
	    staleBoards: _propTypes2.default.array,
	    dispatchMarkElementsAsStale: _propTypes2.default.func,
	    isGuest: _propTypes2.default.bool
	};
	
	exports.default = StaleBoardManager;

/***/ }),
/* 2119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class; // Lib
	
	
	// Utils
	
	
	// Selectors
	
	
	// Constants
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _milanoteReselect = __webpack_require__(49);
	
	var _userService = __webpack_require__(106);
	
	var _sharingUtilSelector = __webpack_require__(318);
	
	var _remoteUsersSelector = __webpack_require__(237);
	
	var _socketConnectionSelector = __webpack_require__(768);
	
	var _currentUserSelector = __webpack_require__(33);
	
	var _userConstants = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = (0, _milanoteReselect.createShallowSelector)(_sharingUtilSelector.remoteUserIdsCurrentlyViewingSelector, _remoteUsersSelector.getTrackedUserIds, _socketConnectionSelector.socketConnectedSelector, _currentUserSelector.isGuestSelector, function (remoteUserIdsCurrentlyViewing, remoteUserIds, socketConnected, isGuest) {
	    return {
	        remoteUserIdsCurrentlyViewing: remoteUserIdsCurrentlyViewing,
	        remoteUserIds: remoteUserIds,
	        socketConnected: socketConnected,
	        isGuest: isGuest
	    };
	});
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        dispatchFetchUserActivity: function dispatchFetchUserActivity(userIds) {
	            return dispatch((0, _userService.fetchUserActivity)(userIds));
	        },
	        dispatchCheckIdleUsers: function dispatchCheckIdleUsers() {
	            return dispatch((0, _userService.checkIdleUsers)());
	        }
	    };
	};
	
	var UserActivityManager = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_React$Component) {
	    _inherits(UserActivityManager, _React$Component);
	
	    function UserActivityManager() {
	        _classCallCheck(this, UserActivityManager);
	
	        return _possibleConstructorReturn(this, (UserActivityManager.__proto__ || Object.getPrototypeOf(UserActivityManager)).apply(this, arguments));
	    }
	
	    _createClass(UserActivityManager, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            // Check for idle users twice for every timeout interval.  That way the client can only be at most
	            // 1/2 a timeout out of sync.  For example if the timeout is 10 minutes the client will be updated
	            // of another user's disconnection within at least 5 minutes.
	            this.idleUserCheckIntervalId = setInterval(this.props.dispatchCheckIdleUsers, _userConstants.USER_IDLE_TIMEOUT_MILLISECONDS / 2);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var currentBoardId = nextProps.currentBoardId,
	                remoteUserIdsCurrentlyViewing = nextProps.remoteUserIdsCurrentlyViewing,
	                dispatchFetchUserActivity = nextProps.dispatchFetchUserActivity,
	                socketConnected = nextProps.socketConnected,
	                remoteUserIds = nextProps.remoteUserIds,
	                isGuest = nextProps.isGuest;
	
	            // Don't load any user activity for guest users
	
	            if (isGuest) return;
	
	            // When we navigate to a new board that has remote users on it, get updates for their user activity
	            if (currentBoardId !== this.props.currentBoardId && remoteUserIdsCurrentlyViewing.length) {
	                dispatchFetchUserActivity(remoteUserIdsCurrentlyViewing);
	            }
	
	            // If we become connected again, re-fetch every user's activity
	            if (socketConnected && !this.props.socketConnected && remoteUserIds.length) {
	                dispatchFetchUserActivity(remoteUserIds);
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this.idleUserCheckIntervalId) clearInterval(this.idleUserCheckIntervalId);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.Children.only(this.props.children);
	        }
	    }]);
	
	    return UserActivityManager;
	}(_react2.default.Component)) || _class);
	
	
	UserActivityManager.propTypes = {
	    children: _propTypes2.default.element.isRequired,
	    remoteUserIdsCurrentlyViewing: _propTypes2.default.array,
	    remoteUserIds: _propTypes2.default.array,
	    currentBoardId: _propTypes2.default.string,
	    dispatchFetchUserActivity: _propTypes2.default.func,
	    dispatchCheckIdleUsers: _propTypes2.default.func,
	    isGuest: _propTypes2.default.bool,
	    socketConnected: _propTypes2.default.bool
	};
	
	exports.default = UserActivityManager;

/***/ }),
/* 2120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class; // Lib
	
	
	/**
	 * TAKEN FROM: https://gist.github.com/andersfly/25ab13dbd1acc5eb915f
	 * Detects drag modifier keys on drag events that originated
	 * from the wrapped component
	 *
	 * @param {boolean} options.listenForAllDragEvents
	 *   if true it will detect modifier keys for all drag events, and not
	 *   just the ones originating from the wrapped component
	 */
	
	
	// Actions
	
	
	// Constants
	
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dragModifierKeysActions = __webpack_require__(2121);
	
	var _dragModifierKeysConstants = __webpack_require__(172);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// All false
	var initialDragModifierKeys = _dragModifierKeysConstants.MODIFIER_KEYS_NAMES.reduce(function (mem, key) {
	    mem[key] = false;
	    return mem;
	}, {});
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        dispatchSetModifierKeys: function dispatchSetModifierKeys(modifierKeys) {
	            return dispatch((0, _dragModifierKeysActions.setDragModifierKeys)(modifierKeys));
	        }
	    };
	};
	
	var DragModifierKeysListener = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec(_class = function (_React$Component) {
	    _inherits(DragModifierKeysListener, _React$Component);
	
	    function DragModifierKeysListener(props) {
	        _classCallCheck(this, DragModifierKeysListener);
	
	        var _this = _possibleConstructorReturn(this, (DragModifierKeysListener.__proto__ || Object.getPrototypeOf(DragModifierKeysListener)).call(this, props));
	
	        _this.checkEventModifierKeys = function (event) {
	            var hasChanged = Object.keys(_this.dragModifierKeys).some(function (key) {
	                return _this.dragModifierKeys[key] !== event[key];
	            });
	
	            if (hasChanged) {
	                _this.dragModifierKeys = (0, _lodash.pick)(event, _dragModifierKeysConstants.MODIFIER_KEYS_NAMES);
	                _this.props.dispatchSetModifierKeys(_this.dragModifierKeys);
	            }
	        };
	
	        _this.onDragStart = _this.checkEventModifierKeys;
	        _this.onDrag = _this.checkEventModifierKeys;
	
	        _this.onDragEnd = function () {
	            _this.dragModifierKeys = initialDragModifierKeys;
	        };
	
	        _this.dragModifierKeys = initialDragModifierKeys;
	        return _this;
	    }
	
	    _createClass(DragModifierKeysListener, [{
	        key: 'componentDidMount',
	        value: function componentDidMount(event) {
	            window.addEventListener('dragstart', this.onDragStart);
	            // The 'drag' event doesn't detect modifier keys in FF for some reason.
	            // Therefore we listen for dragover on the window instead, which roughly
	            // gives the same result
	            window.addEventListener('dragover', this.onDrag);
	            window.addEventListener('dragend', this.onDragEnd);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount(event) {
	            window.removeEventListener('dragstart', this.onDragStart);
	            window.removeEventListener('dragover', this.onDrag);
	            window.removeEventListener('dragend', this.onDragEnd);
	        }
	
	        /* eslint-disable react/sort-comp */
	
	        /* eslint-enable react/sort-comp */
	
	    }, {
	        key: 'render',
	        value: function render() {
	            return null;
	        }
	    }]);
	
	    return DragModifierKeysListener;
	}(_react2.default.Component)) || _class);
	
	
	DragModifierKeysListener.propTypes = {
	    dispatchSetModifierKeys: _propTypes2.default.func
	};
	
	exports.default = DragModifierKeysListener;

/***/ }),
/* 2121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setDragModifierKeys = undefined;
	
	var _dragModifierKeysConstants = __webpack_require__(172);
	
	var setDragModifierKeys = exports.setDragModifierKeys = function setDragModifierKeys(modifierKeys) {
	    return {
	        type: _dragModifierKeysConstants.DRAG_MODIFIER_KEYS_SET,
	        modifierKeys: modifierKeys
	    };
	}; // Constants

/***/ }),
/* 2122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = modifierKeyReducer;
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _dragModifierKeysConstants = __webpack_require__(172);
	
	var _draggingConstants = __webpack_require__(143);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Constants
	var initialState = Immutable.fromJS({
	    ctrlKey: false,
	    shiftKey: false,
	    altKey: false,
	    metaKey: false
	}); // Lib
	function modifierKeyReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _dragModifierKeysConstants.DRAG_MODIFIER_KEYS_SET:
	            return Immutable.fromJS(action.modifierKeys);
	        case _draggingConstants.DRAG_END:
	            return initialState;
	        default:
	            return state;
	    }
	}

/***/ }),
/* 2123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _lodash = __webpack_require__(4);
	
	var _gridActions = __webpack_require__(2124);
	
	var _gridUtils = __webpack_require__(42);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RESIZE_UPDATE_RATE = 300;
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        gridSize: state.getIn(['app', 'gridSize'])
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        updateGridSize: function updateGridSize(size, name) {
	            return dispatch((0, _gridActions.setGridSize)(size, name));
	        }
	    };
	};
	
	var GridSizeManager = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_React$Component) {
	    _inherits(GridSizeManager, _React$Component);
	
	    function GridSizeManager() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, GridSizeManager);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GridSizeManager.__proto__ || Object.getPrototypeOf(GridSizeManager)).call.apply(_ref, [this].concat(args))), _this), _this.setBodyClass = function (bodyClass) {
	            _this.removeBodyClass();
	            document.body.classList.add(bodyClass);
	            _this.currentBodyClass = bodyClass;
	        }, _this.removeBodyClass = function () {
	            if (_this.currentBodyClass) document.body.classList.remove(_this.currentBodyClass);
	        }, _this.updateSize = function (windowWidth) {
	            var _this$props = _this.props,
	                gridSize = _this$props.gridSize,
	                updateGridSize = _this$props.updateGridSize;
	
	            var newGridSize = (0, _gridUtils.calculateGridSize)(windowWidth);
	
	            if (newGridSize.name === gridSize.get('name')) return;
	
	            updateGridSize(newGridSize.size, newGridSize.name);
	        }, _this.handleResize = (0, _lodash.throttle)(function () {
	            return _this.updateSize(window.innerWidth);
	        }, RESIZE_UPDATE_RATE), _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(GridSizeManager, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.updateSize(window.innerWidth);
	            window.addEventListener('resize', this.handleResize);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.gridSize === this.props.gridSize) return;
	
	            var className = (0, _gridUtils.getGridSizeName)(nextProps.gridSize.get('name'));
	            this.setBodyClass(className);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.removeBodyClass();
	            window.removeEventListener('resize', this.handleResize);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.Children.only(this.props.children);
	        }
	    }]);
	
	    return GridSizeManager;
	}(_react2.default.Component)) || _class);
	
	
	GridSizeManager.propTypes = {
	    gridSize: _propTypes2.default.number,
	    updateGridSize: _propTypes2.default.func,
	    children: _propTypes2.default.element.isRequired
	};
	
	exports.default = GridSizeManager;

/***/ }),
/* 2124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setGridSize = undefined;
	
	var _gridConstants = __webpack_require__(205);
	
	var setGridSize = exports.setGridSize = function setGridSize(gridSize, sizeName) {
	  return { type: _gridConstants.GRID_RESIZE, gridSize: gridSize, sizeName: sizeName };
	};

/***/ }),
/* 2125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = gridReducer;
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _gridConstants = __webpack_require__(205);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialState = Immutable.Map({
	    size: _gridConstants.GRID.MEDIUM.size,
	    name: _gridConstants.GRID.MEDIUM.name
	});
	
	function gridReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _gridConstants.GRID_RESIZE:
	            return Immutable.Map({
	                size: action.gridSize,
	                name: action.sizeName
	            });
	        default:
	            return state;
	    }
	}

/***/ }),
/* 2126 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var placeCaretAtEnd = exports.placeCaretAtEnd = function placeCaretAtEnd(el) {
	    if (!el) return;
	    el.focus();
	    if (typeof window.getSelection !== 'undefined' && typeof document.createRange !== 'undefined') {
	        var range = document.createRange();
	        range.selectNodeContents(el);
	        range.collapse(false);
	        var sel = window.getSelection();
	        sel.removeAllRanges();
	        sel.addRange(range);
	    } else if (typeof document.body.createTextRange !== 'undefined') {
	        var textRange = document.body.createTextRange();
	        textRange.moveToElementText(el);
	        textRange.collapse(false);
	        textRange.select();
	    }
	};
	
	var selectAll = exports.selectAll = function selectAll(el) {
	    if (!el) return;
	    el.focus();
	
	    if (typeof window.getSelection !== 'undefined' && typeof document.createRange !== 'undefined') {
	        var range = document.createRange();
	        range.selectNodeContents(el);
	        var sel = window.getSelection();
	        sel.removeAllRanges();
	        sel.addRange(range);
	    } else if (typeof document.body.createTextRange !== 'undefined') {
	        var textRange = document.body.createTextRange();
	        textRange.moveToElementText(el);
	        textRange.select();
	    }
	};

/***/ }),
/* 2127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.bindShortcuts = undefined;
	
	var _mousetrap = __webpack_require__(594);
	
	var _mousetrap2 = _interopRequireDefault(_mousetrap);
	
	var _undoRedoActions = __webpack_require__(316);
	
	var _elementShortcutActions = __webpack_require__(455);
	
	var _timeUtil = __webpack_require__(43);
	
	var _selectionActions = __webpack_require__(55);
	
	var _inboxActions = __webpack_require__(305);
	
	var _keyConstants = __webpack_require__(146);
	
	var _cardConstants = __webpack_require__(111);
	
	var _boardConstants = __webpack_require__(17);
	
	var _columnConstants = __webpack_require__(207);
	
	var _imageConstants = __webpack_require__(87);
	
	var _linkConstants = __webpack_require__(174);
	
	var _inboxConstants = __webpack_require__(234);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var undo = function undo(dispatch, props) {
	    return dispatch((0, _undoRedoActions.undoAction)());
	};
	var redo = function redo(dispatch, props) {
	    return dispatch((0, _undoRedoActions.redoAction)());
	};
	var deselect = function deselect(dispatch, props) {
	    return dispatch((0, _selectionActions.deselectAllElements)());
	};
	var fakeSave = function fakeSave(dispatch, props) {
	    return dispatch({ type: 'FAKE_SAVE', sync: true, modified: (0, _timeUtil.getTimestamp)() });
	};
	
	var newCard = function newCard(dispatch, props) {
	    return dispatch((0, _elementShortcutActions.createNewElement)(_cardConstants.CARD_TYPE, props));
	};
	var newBoard = function newBoard(dispatch, props) {
	    return dispatch((0, _elementShortcutActions.createNewElement)(_boardConstants.BOARD_TYPE, props));
	};
	var newColumn = function newColumn(dispatch, props) {
	    return dispatch((0, _elementShortcutActions.createNewElement)(_columnConstants.COLUMN_TYPE, props));
	};
	var newImage = function newImage(dispatch, props) {
	    return dispatch((0, _elementShortcutActions.createNewElement)(_imageConstants.IMAGE_TYPE, props));
	};
	var newLink = function newLink(dispatch, props) {
	    return dispatch((0, _elementShortcutActions.createNewElement)(_linkConstants.LINK_TYPE, props));
	};
	
	var moveToTrash = function moveToTrash(dispatch, props) {
	    return dispatch((0, _elementShortcutActions.moveElementToTrash)(props));
	};
	var toggleUnsorted = function toggleUnsorted(dispatch, props) {
	    if (!props.currentBoard) return;
	    if (props.currentBoard.getIn(['content', 'inbox']) === _inboxConstants.INBOX_STATE.OPEN) {
	        return dispatch((0, _inboxActions.closeInbox)({ id: props.currentBoardId }));
	    }
	    dispatch((0, _inboxActions.openInbox)({ id: props.currentBoardId }));
	};
	
	var bindShortcuts = exports.bindShortcuts = function bindShortcuts(dispatch) {
	    var boundkeys = [];
	    var props = {};
	
	    var bind = function bind(keycode, dispatchAction) {
	        boundkeys.push(keycode);
	        _mousetrap2.default.bind(keycode, function (event) {
	            event.preventDefault();
	            dispatchAction(dispatch, props);
	        });
	    };
	
	    var bindGlobal = function bindGlobal(keycode, dispatchAction) {
	        boundkeys.push(keycode);
	        (0, _mousetrap2.default)(document.body).bind(keycode, function (event) {
	            event.preventDefault();
	            dispatchAction(dispatch, props);
	        });
	    };
	
	    var unbind = function unbind() {
	        boundkeys.forEach(function (keycode) {
	            _mousetrap2.default.unbind(keycode);
	        });
	    };
	
	    var setProps = function setProps(p) {
	        Object.assign(props, p);
	    };
	
	    // bind actions
	    bind(_keyConstants.SHORTCUT_KEYS.UNDO, undo);
	    bind(_keyConstants.SHORTCUT_KEYS.REDO, redo);
	
	    bindGlobal(_keyConstants.SHORTCUT_KEYS.NEW_CARD, newCard);
	    bindGlobal(_keyConstants.SHORTCUT_KEYS.NEW_BOARD, newBoard);
	    bindGlobal(_keyConstants.SHORTCUT_KEYS.NEW_COLUMN, newColumn);
	    bindGlobal(_keyConstants.SHORTCUT_KEYS.NEW_IMAGE, newImage);
	    bindGlobal(_keyConstants.SHORTCUT_KEYS.NEW_LINK, newLink);
	
	    bindGlobal(_keyConstants.SHORTCUT_KEYS.ESCAPE, deselect);
	    bind(_keyConstants.SHORTCUT_KEYS.DELETE, moveToTrash);
	    bind(_keyConstants.SHORTCUT_KEYS.TOGGLE_UNSORTED_NOTES, toggleUnsorted);
	
	    bindGlobal(_keyConstants.SHORTCUT_KEYS.SAVE, fakeSave);
	
	    return { unbind: unbind, setProps: setProps };
	};

/***/ }),
/* 2128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.objectIntersection = exports.emptyObject = exports.keysToObject = undefined;
	
	var _keysToObject2 = __webpack_require__(762);
	
	var _keysToObject3 = _interopRequireDefault(_keysToObject2);
	
	var _emptyObject2 = __webpack_require__(761);
	
	var _emptyObject3 = _interopRequireDefault(_emptyObject2);
	
	var _objectIntersection2 = __webpack_require__(2130);
	
	var _objectIntersection3 = _interopRequireDefault(_objectIntersection2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.keysToObject = _keysToObject3.default; // API
	
	exports.emptyObject = _emptyObject3.default;
	exports.objectIntersection = _objectIntersection3.default;

/***/ }),
/* 2129 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (val) {
	  return !val;
	};

/***/ }),
/* 2130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _fp = __webpack_require__(52);
	
	var _lodash = __webpack_require__(4);
	
	var _emptyObject = __webpack_require__(761);
	
	var _emptyObject2 = _interopRequireDefault(_emptyObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates a new object that is the intersection of the keys object and source object.
	 * The keys object is the object used for the keys, the source object is the object to use for the values.
	 * Any key that exists on the keys object but not the source object will be defaulted to null.
	 *
	 * <pre>
	 *     pickWithDefault({ a: '1', b: '2', c: '3' }, { a: '4', d: '5', e: '6' });
	 *     // => { a: '4', b: null, c: null }
	 * </pre>
	 *
	 * @param keysObject {Object} The object to use for keys.
	 * @param source {Object} The object to use for values.
	 */
	exports.default = function (keysObject, source) {
	  var pickKeys = (0, _lodash.keys)(keysObject);
	  var pickedValues = (0, _fp.pick)(pickKeys, source);
	  var defaultValues = (0, _emptyObject2.default)(keysObject);
	  return (0, _lodash.defaults)(pickedValues, defaultValues);
	};
	
	// Util
	// Lib

/***/ }),
/* 2131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	// NOTE: Reimplementation of recompose's createHelper as it wasn't exposed :(
	var createHelper = function createHelper(func, helperName) {
	    var setDisplayName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	    var noArgs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	    if (false) {
	        var wrapDisplayName = require('recompose').wrapDisplayName;
	
	        if (noArgs) {
	            return function (BaseComponent) {
	                var Component = func(BaseComponent);
	                Component.displayName = wrapDisplayName(BaseComponent, helperName);
	                return Component;
	            };
	        }
	
	        return function () {
	            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                args[_key] = arguments[_key];
	            }
	
	            if (args.length > func.length) {
	                console.error('Too many arguments passed to ' + helperName + '(). It should called ' + ('like so: ' + helperName + '(...args)(BaseComponent).'));
	            }
	
	            return function (BaseComponent) {
	                var Component = func.apply(undefined, args)(BaseComponent);
	                Component.displayName = wrapDisplayName(BaseComponent, helperName);
	                return Component;
	            };
	        };
	    }
	
	    return func;
	};
	
	exports.default = createHelper;

/***/ }),
/* 2132 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	// From: http://stackoverflow.com/questions/4998908/convert-data-uri-to-file-then-append-to-formdata
	var getByteString = function getByteString(dataURI) {
	    return dataURI.split(',')[0].indexOf('base64') >= 0 ? atob(dataURI.split(',')[1]) : decodeURI(dataURI.split(',')[1]);
	};
	
	var getMimeString = function getMimeString(dataURI) {
	    return dataURI.split(',')[0].split(':')[1].split(';')[0];
	};
	
	var convertToTypedArray = function convertToTypedArray(dataURI) {
	    var byteString = getByteString(dataURI);
	    var ia = new Uint8Array(byteString.length);
	    for (var i = 0; i < byteString.length; i++) {
	        ia[i] = byteString.charCodeAt(i);
	    }
	    return ia;
	};
	
	exports.default = function (dataURI) {
	    var mimeString = getMimeString(dataURI);
	    var intArray = convertToTypedArray(dataURI);
	    return new Blob([intArray], { type: mimeString });
	};

/***/ }),
/* 2133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.http = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Utils
	
	
	// Interceptors
	
	
	var _axios = __webpack_require__(489);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _logger = __webpack_require__(128);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _getClientConfig = __webpack_require__(48);
	
	var _getClientConfig2 = _interopRequireDefault(_getClientConfig);
	
	var _requestAuthorisationInterceptor = __webpack_require__(2134);
	
	var _requestAuthorisationInterceptor2 = _interopRequireDefault(_requestAuthorisationInterceptor);
	
	var _responseRetryInterceptor = __webpack_require__(2291);
	
	var _responseRetryInterceptor2 = _interopRequireDefault(_responseRetryInterceptor);
	
	var _httpConstants = __webpack_require__(90);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clientConfig = (0, _getClientConfig2.default)();
	var apiRootUrl = clientConfig.apiRoot || '';
	
	// Constants
	
	
	var DEFAULT_CONFIG = {
	    method: _httpConstants.METHODS.GET,
	    timeout: 2000,
	    responseType: 'json',
	    prefix: apiRootUrl + '/api'
	};
	
	// Request interceptors
	_axios2.default.interceptors.request.use(_requestAuthorisationInterceptor2.default);
	
	// Response interceptors
	var retryErrorCb = function retryErrorCb(err) {
	    return _logger2.default.warn('RETRYING: A http error occurred (' + (err.config.retry - err.config._retryCount) + ' ' + 'attempts remaining)', err, err.response, JSON.stringify(err));
	};
	_axios2.default.interceptors.response.use(undefined, (0, _responseRetryInterceptor2.default)(_axios2.default, retryErrorCb));
	
	var http = exports.http = function http(config) {
	    var axiosConfig = _extends({}, DEFAULT_CONFIG, config);
	    axiosConfig.url = axiosConfig.prefix + '/' + config.url;
	
	    return (0, _axios2.default)(axiosConfig);
	};

/***/ }),
/* 2134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _authService = __webpack_require__(227);
	
	exports.default = function (config) {
	    var token = (0, _authService.getCurrentUserToken)();
	    if (token) {
	        config.headers.Authorization = 'Bearer ' + token;
	    }
	    return config;
	}; // Services

/***/ }),
/* 2135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defaultResourceReducer = __webpack_require__(470);
	
	var _defaultResourceReducer2 = _interopRequireDefault(_defaultResourceReducer);
	
	var _elementsResourceReducer = __webpack_require__(1977);
	
	var _elementsResourceReducer2 = _interopRequireDefault(_elementsResourceReducer);
	
	var _boardsResourceReducer = __webpack_require__(1955);
	
	var _boardsResourceReducer2 = _interopRequireDefault(_boardsResourceReducer);
	
	var _resourceConstants = __webpack_require__(85);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Reducers
	exports.default = function (resourceType) {
	    switch (resourceType) {
	        case _resourceConstants.RESOURCE_TYPES.elements:
	            return _elementsResourceReducer2.default;
	        case _resourceConstants.RESOURCE_TYPES.boards:
	            return _boardsResourceReducer2.default;
	        default:
	            return _defaultResourceReducer2.default;
	    }
	};
	
	// Constants

/***/ }),
/* 2136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxImmutable = __webpack_require__(73);
	
	var _makeResourceTypeReducer = __webpack_require__(471);
	
	var _makeResourceTypeReducer2 = _interopRequireDefault(_makeResourceTypeReducer);
	
	var _elementsResourceTypeReducer = __webpack_require__(1978);
	
	var _elementsResourceTypeReducer2 = _interopRequireDefault(_elementsResourceTypeReducer);
	
	var _boardsResourceTypeReducer = __webpack_require__(1956);
	
	var _boardsResourceTypeReducer2 = _interopRequireDefault(_boardsResourceTypeReducer);
	
	var _resourceConstants = __webpack_require__(85);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Reducers
	exports.default = (0, _reduxImmutable.combineReducers)({
	    elements: _elementsResourceTypeReducer2.default,
	    boards: _boardsResourceTypeReducer2.default,
	    users: (0, _makeResourceTypeReducer2.default)(_resourceConstants.RESOURCE_TYPES.users)
	});
	
	// Constants
	// Lib

/***/ }),
/* 2137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _promisedFileReader = __webpack_require__(468);
	
	// For some details behind this implementation see:
	//      http://code.flickr.net/2012/06/01/parsing-exif-client-side-using-javascript-2/
	//      http://stackoverflow.com/questions/20600800/js-client-side-exif-orientation-rotate-and-mirror-jpeg-images
	//      http://stackoverflow.com/questions/7584794/
	//          accessing-jpeg-exif-rotation-data-in-javascript-on-the-client-side/32490603#32490603
	//      https://jsfiddle.net/wunderbart/dtwkfjpg/
	
	// EXIF Format Description:
	//      https://www.media.mit.edu/pia/Research/deepview/exif.html
	
	// The EXIF data is stored in the first 128 bytes of the image (supposed to be 64 but some formats spill over)
	var EXIF_DATA_BYTES = 128 * 1024;
	
	//
	/**
	 * -2 = Not a JPEG file
	 * -1 = Orientation is not defined
	 *  1 = Normal
	 *  2 = Horizontally mirrored
	 *  3 = Rotated 180 deg
	 *  4 = Rotated 180 deg and horizontally mirrored
	 *  5 = Rotated 270 deg and horizontally mirrored
	 *  6 = Rotated 270 deg
	 *  7 = Rotated 90 deg and horizontally mirrored
	 *  8 = Rotated 90 deg
	 */
	/* eslint-disable eqeqeq */
	// Util
	
	exports.default = function (file) {
	    return (0, _promisedFileReader.readAsArrayBuffer)(file, EXIF_DATA_BYTES).then(function (exifArrayBufferData) {
	        // In order to read the array buffer data we should use a data view because this supports endianness
	        var exifDataView = new DataView(exifArrayBufferData);
	
	        // EXIF defines different value types that can be encountered:
	        /*
	         1 = BYTE An 8-bit unsigned integer
	         DataView.getUint8
	         2 = ASCII An 8-bit byte containing one 7-bit ASCII code. The final byte is terminated with NULL.
	         3 = SHORT A 16-bit (2-byte) unsigned integer
	         DataView.getUint16
	         4 = LONG A 32-bit (4-byte) unsigned integer
	         DataView.getUint32
	         5 = RATIONAL Two LONGs. The first LONG is the numerator and the second LONG expresses the denominator.
	         7 = UNDEFINED An 8-bit byte that can take any value depending on the field definition
	         9 = SLONG A 32-bit (4-byte) signed integer (2’s complement notation)
	         10 = SRATIONAL Two SLONGs. The first SLONG is the numerator and the second SLONG is the denominator
	         */
	
	        // We're reading in the file as an array buffer so ASCII is done for us.
	
	        // TODO Do I need figure to figure out endianness?
	        // Start of image (SOI) bytes = 0xFFD8
	        if (exifDataView.getUint16(0, false) != 0xFFD8) {
	            // Not a JPEG image
	            return -2;
	        }
	
	        var length = exifDataView.byteLength;
	        // Skip the first two bytes as we've already verified they're SOI
	        var offset = 2;
	
	        while (offset < length) {
	            var marker = exifDataView.getUint16(offset, false);
	            offset += 2;
	
	            // APP1 = 2 bytes: 0xFFE1
	            // TODO Should I use the below comment somehow?
	            // We usually check the last byte of this for the value 0xE1, or 225 in decimal
	            // to prevent any endianness problems
	            if (marker == 0xFFE1) {
	                // TODO Where is this?? Is that maybe what the last else is doing?
	                // The next thing we want to know is the size of the APP1 data, we can use this to optimize and
	                // know when to stop reading, which is also 2 bytes
	
	                // Next up is the Exif header, which is always the 4 bytes 0x45, 0x78, 0x69, 0x66, or “Exif” in
	                // ASCII.
	                if (exifDataView.getUint32(offset += 2, false) != 0x45786966) {
	                    // eslint-disable-line no-cond-assign
	                    // If it does not equal it then there's something wrong with the data
	                    return -1;
	                }
	
	                // This is always followed up 2 null bytes 0x0000
	                // Then begins the TIFF header and then the 0th IFD, where our Exif is stored, followed by the 1st
	                // IFD, which usually contains a thumbnail of the image.
	
	                // We are concerned with application segment 1 (APP1).
	                // APP2 and others can contain other metadata about this compressed image
	
	                // Once we know we are at APP1 we can move on to the TIFF header which starts with the byte alignment,
	                // 0x4949 (II, Intel) or 0x4D4D (MM, Motorola), Intel being little endian and Motorola being big endian
	                var little = exifDataView.getUint16(offset += 6, false) == 0x4949;
	
	                // Then we have the tag marker, which is always 0x2A00 (or 0x002A for big endian):
	                // “an arbitrary but carefully chosen number (42) that further identifies the file as a TIFF file”
	
	                // Next we have the offset to the first IFD, which is usually 0x08000000, or 8 bytes from the beginning of
	                // the TIFF header (The 8 bytes: 0x49 0x49 0x2A 0x00 0x08 0x00 0x00 0x00).
	                offset += exifDataView.getUint32(offset + 4, little);
	
	                // Now we can begin parsing the 0th IFD.  - I think that's where we're up to
	                var tags = exifDataView.getUint16(offset, little);
	                offset += 2;
	
	                for (var i = 0; i < tags; i++) {
	                    // Orientation tag = 0x0112
	                    if (exifDataView.getUint16(offset + i * 12, little) == 0x0112) {
	                        return exifDataView.getUint16(offset + i * 12 + 8, little);
	                    }
	                }
	            } else if ((marker & 0xFF00) != 0xFF00) {
	                // Not sure about what this is
	                break;
	            } else {
	                // Not sure about this either, must be jumping to a location
	                offset += exifDataView.getUint16(offset, false);
	            }
	        }
	
	        // Undefined orientation
	        return -1;
	    });
	};
	
	// Other resources:
	//      https://gist.github.com/runeb/c11f864cd7ead969a5f0
	//      https://jsfiddle.net/orotemo/obvna6qn/1/
	//      http://www.daveperrett.com/articles/2012/07/28/exif-orientation-handling-is-a-ghetto/

/***/ }),
/* 2138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _loadImage = __webpack_require__(2139);
	
	var _dataURIToBlob = __webpack_require__(2132);
	
	var _dataURIToBlob2 = _interopRequireDefault(_dataURIToBlob);
	
	var _mimeConstants = __webpack_require__(798);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PORTRAIT_ORIENTATIONS = [5, 6, 7, 8];
	
	// Constants
	// Utils
	
	
	var isPortraitOrientation = function isPortraitOrientation(orientation) {
	    return PORTRAIT_ORIENTATIONS.indexOf(orientation) !== -1;
	};
	
	var buildTransformationArray = function buildTransformationArray(width, height) {
	    return [function (ctx) {
	        return ctx;
	    }, function (ctx) {
	        return ctx;
	    }, function (ctx) {
	        return ctx.transform(-1, 0, 0, 1, width, 0);
	    }, function (ctx) {
	        return ctx.transform(-1, 0, 0, -1, width, height);
	    }, function (ctx) {
	        return ctx.transform(1, 0, 0, -1, 0, height);
	    }, function (ctx) {
	        return ctx.transform(0, 1, 1, 0, 0, 0);
	    }, function (ctx) {
	        return ctx.transform(0, 1, -1, 0, height, 0);
	    }, function (ctx) {
	        return ctx.transform(0, -1, -1, 0, height, width);
	    }, function (ctx) {
	        return ctx.transform(0, -1, 1, 0, 0, width);
	    }];
	};
	
	exports.default = function (_ref) {
	    var srcOrientation = _ref.srcOrientation,
	        imageDataUri = _ref.imageDataUri;
	    return (0, _loadImage.loadImageFromDataUrl)(imageDataUri).then(function (imageLoadEvent) {
	        var img = imageLoadEvent.target;
	        var width = img.width;
	        var height = img.height;
	
	        var canvas = document.createElement('canvas');
	        var ctx = canvas.getContext('2d');
	
	        var isPortrait = isPortraitOrientation(srcOrientation);
	        canvas.width = isPortrait ? height : width;
	        canvas.height = isPortrait ? width : height;
	
	        // transform context before drawing image
	        var transformationArray = buildTransformationArray(width, height);
	        var transformationFn = transformationArray[srcOrientation] || transformationArray[0];
	        transformationFn(ctx);
	
	        // draw image
	        ctx.drawImage(img, 0, 0);
	
	        var rotatedImageBase64 = canvas.toDataURL(_mimeConstants.MIME_TYPES.JPEG);
	        var rotatedImageFile = (0, _dataURIToBlob2.default)(rotatedImageBase64);
	
	        return { file: rotatedImageFile, imageDataUri: rotatedImageBase64 };
	    });
	};

/***/ }),
/* 2139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.loadImageFromFile = exports.loadImageFromDataUrl = undefined;
	
	var _promisedFileReader = __webpack_require__(468);
	
	var loadImageFromDataUrl = exports.loadImageFromDataUrl = function loadImageFromDataUrl(srcBase64) {
	    return new Promise(function (resolve, reject) {
	        var img = new Image();
	        img.onload = resolve;
	        img.src = srcBase64;
	    });
	}; // Utils
	var loadImageFromFile = exports.loadImageFromFile = function loadImageFromFile(file) {
	    return (0, _promisedFileReader.readAsDataURL)(file).then(loadImageFromDataUrl);
	};

/***/ }),
/* 2140 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var createPrepareActionForServerFn = exports.createPrepareActionForServerFn = function createPrepareActionForServerFn(store) {
	    return function (action) {
	        var user = store.getState().getIn(['app', 'currentUser']);
	
	        return _extends({}, action, {
	            user: {
	                _id: user.get('_id'),
	                clientId: user.get('clientId'),
	                clientTick: user.get('clientTick')
	            },
	            undoRedoAction: undefined,
	            transactionId: undefined,
	            isUndo: undefined,
	            isRedo: undefined
	        });
	    };
	};

/***/ }),
/* 2141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.createSocketMiddleware = undefined;
	
	var _createPrepareActionForServerFn = __webpack_require__(2140);
	
	var _currentUserSelector = __webpack_require__(33);
	
	var _currentUserConstants = __webpack_require__(144);
	
	var _authConstants = __webpack_require__(136);
	
	var _socketConstants = __webpack_require__(109);
	
	var _electronConstants = __webpack_require__(321);
	
	// Constants
	// Util
	var createSocketMiddleware = exports.createSocketMiddleware = function createSocketMiddleware(socketManager) {
	    return function (store) {
	        var prepareActionForServer = (0, _createPrepareActionForServerFn.createPrepareActionForServerFn)(store);
	
	        return function (next) {
	            return function (action) {
	                var newState = next(action);
	
	                var isGuest = (0, _currentUserSelector.isGuestSelector)(store.getState());
	                if (isGuest && action.type !== _authConstants.LOGOUT) return newState;
	
	                if (action.sync) {
	                    var syncAction = prepareActionForServer(action);
	                    socketManager.emitAction(syncAction);
	                }
	
	                switch (action.type) {
	                    case _currentUserConstants.CURRENT_USER_SET:
	                        socketManager.connectSocket(action.user._id);
	                        break;
	                    case _socketConstants.CHANNELS_UPDATED:
	                        socketManager.updateChannels(action);
	                        break;
	                    case _authConstants.LOGOUT:
	                        socketManager.disconnectSocket();
	                        break;
	                    case _electronConstants.ELECTRON_APP_SLEEP:
	                        socketManager.disconnectSocket();
	                        break;
	                    case _electronConstants.ELECTRON_APP_WAKE:
	                        socketManager.connectSocket();
	                        break;
	                    default:
	                        break;
	                }
	
	                return newState;
	            };
	        };
	    };
	};
	
	// Data selectors

/***/ }),
/* 2142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getSocketManager = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	// Util
	
	
	// Selectors
	
	
	// Constants
	
	
	var _socket = __webpack_require__(1655);
	
	var _socket2 = _interopRequireDefault(_socket);
	
	var _socketActions = __webpack_require__(767);
	
	var _lodash = __webpack_require__(4);
	
	var _fp = __webpack_require__(52);
	
	var _elementService = __webpack_require__(731);
	
	var _elementHelper = __webpack_require__(13);
	
	var _permissionsService = __webpack_require__(75);
	
	var _getClientConfig = __webpack_require__(48);
	
	var _getClientConfig2 = _interopRequireDefault(_getClientConfig);
	
	var _currentUserSelector = __webpack_require__(33);
	
	var _elementConstants = __webpack_require__(12);
	
	var ELEMENT_ACTION_TYPE = _interopRequireWildcard(_elementConstants);
	
	var _selectionConstants = __webpack_require__(77);
	
	var ELEMENT_SELECTION_ACTION_TYPES = _interopRequireWildcard(_selectionConstants);
	
	var _socketConstants = __webpack_require__(109);
	
	var _permissionConstants = __webpack_require__(485);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var clientConfig = (0, _getClientConfig2.default)();
	var apiRoot = clientConfig.apiRoot || '/';
	
	var createSocketClient = function createSocketClient(userId) {
	    if (false) {
	        return (0, _socket2.default)(apiRoot.replace('https', 'wss').replace('http', 'ws'), {
	            query: 'userId=' + userId,
	            transports: ['websocket', 'polling']
	        });
	    }
	
	    return (0, _socket2.default)({ query: 'userId=' + userId });
	};
	
	var SocketManager = function () {
	    function SocketManager() {
	        var _this = this;
	
	        _classCallCheck(this, SocketManager);
	
	        this.getClosestBoardChannel = function (elementId) {
	            return _this.useBoardChannelIfValid((0, _elementHelper.getClosestUpBoardId)(_this.getElements(), elementId));
	        };
	
	        this.getElementIdsOfInterestFromMoveDetails = function (move) {
	            return [move.location.parentId, move.from.parentId];
	        };
	
	        this.getChannelsFromMoveElementIdsOfInterest = function (elementIds) {
	            return (0, _lodash.compact)((0, _lodash.uniq)(elementIds).map(_this.getClosestBoardChannel));
	        };
	
	        this.getChannelsFromMultiMoveAction = (0, _lodash.flow)((0, _fp.get)('moves'), (0, _fp.flatMap)(this.getElementIdsOfInterestFromMoveDetails), this.getChannelsFromMoveElementIdsOfInterest);
	
	        this.socketClient = null;
	        this.store = null;
	        this.dispatch = null;
	        this.queuedActions = [];
	        this.userId = null;
	    }
	
	    _createClass(SocketManager, [{
	        key: 'connectSocket',
	        value: function connectSocket(userId) {
	            var _this2 = this;
	
	            this.userId = userId || this.userId;
	
	            this.socketClient = createSocketClient(this.userId);
	
	            this.socketClient.on('action', function (action) {
	                // if it's an action that requires loaded element actions
	                if (action.type === ELEMENT_ACTION_TYPE.ELEMENT_MOVE_MULTI) {
	                    _this2.fetchUnknownElements(action.moves.map(function (move) {
	                        return move.id;
	                    }));
	                }
	
	                if (action.type === ELEMENT_ACTION_TYPE.ELEMENT_UPDATE) {
	                    _this2.fetchUnknownElements(action.updates.map(function (update) {
	                        return update.id;
	                    }));
	                }
	
	                _this2.dispatch(action);
	            });
	
	            this.socketClient.on('connect', function () {
	                var state = _this2.store.getState();
	                _this2.updateChannels({
	                    joined: state.getIn(['app', 'socketConnection', 'channels']).toJS(),
	                    left: []
	                });
	
	                _this2.dispatch((0, _socketActions.socketConnect)());
	
	                _this2.queuedActions.forEach(function (queued) {
	                    return _this2.socketEmit(queued.eventName, queued.action);
	                });
	                _this2.queuedActions = [];
	            });
	
	            this.socketClient.on('disconnect', function () {
	                _this2.dispatch((0, _socketActions.socketDisconnect)());
	            });
	        }
	    }, {
	        key: 'fetchUnknownElements',
	        value: function fetchUnknownElements(ids) {
	            var _this3 = this;
	
	            var elementIdsToFetch = ids.filter(function (id) {
	                var el = _this3.store.getState().getIn(['elements', id]);
	                return !el || !el.get('id') || (0, _elementHelper.isSkeleton)(el);
	            });
	
	            if (elementIdsToFetch.length) {
	                this.dispatch((0, _elementService.fetchElements)({ elementIds: elementIdsToFetch, force: true }));
	            }
	        }
	    }, {
	        key: 'getElements',
	        value: function getElements() {
	            return this.store.getState().get('elements');
	        }
	    }, {
	        key: 'validateSavePermissions',
	        value: function validateSavePermissions(elementId) {
	            var userId = (0, _currentUserSelector.getCurrentUserId)(this.store.getState());
	            return (0, _permissionsService.confirmedValidPermissions)(this.getElements(), elementId, userId, _permissionConstants.ACCESS_BITS.SAVE);
	        }
	
	        /**
	         * Will only return the element ID as a channel if the user has save permissions.
	         */
	
	    }, {
	        key: 'useBoardChannelIfValid',
	        value: function useBoardChannelIfValid(elementId) {
	            return this.validateSavePermissions(elementId) ? elementId : undefined;
	        }
	    }, {
	        key: 'getAncestorBoardChannel',
	        value: function getAncestorBoardChannel(elementId) {
	            return this.useBoardChannelIfValid((0, _elementHelper.getClosestAncestorBoardId)(this.getElements(), elementId));
	        }
	    }, {
	        key: 'getChannelsFromActionParentId',
	        value: function getChannelsFromActionParentId(syncAction) {
	            return [this.useBoardChannelIfValid(syncAction.location.parentId)];
	        }
	    }, {
	        key: 'getChannelsFromActionsAncestorBoard',
	        value: function getChannelsFromActionsAncestorBoard(elementId) {
	            return [this.getAncestorBoardChannel(elementId)];
	        }
	    }, {
	        key: 'getChannelsFromSingleElementUpdate',
	        value: function getChannelsFromSingleElementUpdate(elementId) {
	            // TODO Don't always need to send updates to the parent channel (e.g. if board inbox state changes)
	            // Always send the update to the element's board ancestor channel
	            var channels = this.getChannelsFromActionsAncestorBoard(elementId);
	
	            var state = this.store.getState();
	            var element = state.getIn(['elements', elementId]);
	
	            // If the element is a board then also send it to that board's channel too
	            if ((0, _elementHelper.isBoard)(element)) {
	                var boardChannel = this.useBoardChannelIfValid(elementId);
	                boardChannel && channels.push(boardChannel);
	            }
	
	            return channels;
	        }
	    }, {
	        key: 'getChannelsFromMultipleElementUpdateAction',
	        value: function getChannelsFromMultipleElementUpdateAction(syncAction) {
	            var _this4 = this;
	
	            return (0, _lodash.uniq)((0, _fp.flatMap)(function (update) {
	                return _this4.getChannelsFromSingleElementUpdate(update.id);
	            }, syncAction.updates));
	        }
	    }, {
	        key: 'getChannelsFromShareAction',
	        value: function getChannelsFromShareAction(action) {
	            return [action.userId, action.user._id];
	        }
	    }, {
	        key: 'getChannelsFromSelectionAction',
	        value: function getChannelsFromSelectionAction(syncAction) {
	            var firstSelectedId = (0, _lodash.head)(syncAction.ids);
	            var selectionChannel = this.getAncestorBoardChannel(firstSelectedId);
	            return selectionChannel ? ['' + selectionChannel + _socketConstants.LIVE_ACTIVITY_SUFFIX] : [];
	        }
	    }, {
	        key: 'getChannelsFromUserAction',
	        value: function getChannelsFromUserAction(action) {
	            return [action.userId || action.user && action.user._id];
	        }
	
	        /**
	         * Gets the socket channels relevant for the given action.
	         */
	
	    }, {
	        key: 'getActionChannels',
	        value: function getActionChannels(syncAction) {
	            switch (syncAction.type) {
	                case ELEMENT_ACTION_TYPE.ELEMENT_CREATE:
	                case ELEMENT_ACTION_TYPE.ELEMENT_DELETE:
	                    return this.getChannelsFromActionParentId(syncAction);
	                case ELEMENT_ACTION_TYPE.ELEMENT_UPDATE:
	                    return this.getChannelsFromMultipleElementUpdateAction(syncAction);
	                case ELEMENT_ACTION_TYPE.ELEMENT_SET_TYPE:
	                    return this.getChannelsFromActionsAncestorBoard(syncAction.id);
	                case ELEMENT_ACTION_TYPE.ELEMENT_MOVE_MULTI:
	                    return this.getChannelsFromMultiMoveAction(syncAction);
	                case ELEMENT_SELECTION_ACTION_TYPES.ELEMENTS_SELECTED:
	                case ELEMENT_SELECTION_ACTION_TYPES.ELEMENTS_DESELECTED:
	                case ELEMENT_SELECTION_ACTION_TYPES.ELEMENTS_DESELECT_ALL:
	                    return this.getChannelsFromSelectionAction(syncAction);
	                case ELEMENT_ACTION_TYPE.ELEMENT_SHARE:
	                case ELEMENT_ACTION_TYPE.ELEMENT_UNSHARE:
	                    return this.getChannelsFromShareAction(syncAction);
	                default:
	                    return this.getChannelsFromUserAction(syncAction);
	            }
	        }
	
	        /**
	         * Connect to all channels passed in here to ensure we can receive messages.
	         * Only validate whether we should send messages when sending.
	         */
	
	    }, {
	        key: 'updateChannels',
	        value: function updateChannels(_ref) {
	            var joined = _ref.joined,
	                left = _ref.left;
	
	            this.socketEmit('update-channels', {
	                joined: joined,
	                left: left
	            });
	        }
	    }, {
	        key: 'disconnectSocket',
	        value: function disconnectSocket() {
	            this.socketClient.io.disconnect();
	        }
	    }, {
	        key: 'emitAction',
	        value: function emitAction(syncAction) {
	            this.socketEmit('action', _extends({}, syncAction, {
	                channels: (0, _lodash.compact)(this.getActionChannels(syncAction))
	            }));
	        }
	    }, {
	        key: 'socketEmit',
	        value: function socketEmit(eventName, action) {
	            if (!this.socketClient) return this.queuedActions.push({ eventName: eventName, action: action });
	
	            this.socketClient.emit(eventName, action);
	        }
	    }, {
	        key: 'subscribeToStore',
	        value: function subscribeToStore(store) {
	            this.store = store;
	            this.dispatch = this.store.dispatch.bind(this.store);
	        }
	    }]);
	
	    return SocketManager;
	}();
	
	var getSocketManager = exports.getSocketManager = function getSocketManager() {
	    return new SocketManager();
	};

/***/ }),
/* 2143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _timeUtil = __webpack_require__(43);
	
	var _socketConstants = __webpack_require__(109);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialState = Immutable.Map({
	    status: _socketConstants.SOCKET_CONNECTION_STATUS.CONNECTED,
	    channels: Immutable.List(),
	    boardChannels: Immutable.List()
	});
	
	var updateChannels = function updateChannels(state, action) {
	    return state.withMutations(function (mutableState) {
	        return mutableState.update('channels', function (channels) {
	            return channels.filter(function (channelId) {
	                return action.left.indexOf(channelId) === -1;
	            }).concat(Immutable.List(action.joined));
	        }).set('boardChannels', Immutable.List(action.boardChannels));
	    });
	};
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _socketConstants.SOCKET_CONNECT:
	            return state.set('status', _socketConstants.SOCKET_CONNECTION_STATUS.CONNECTED).set('disconnectedTime', null);
	        case _socketConstants.SOCKET_DISCONNECT:
	            return state.set('status', _socketConstants.SOCKET_CONNECTION_STATUS.DISCONNECTED).set('disconnectTime', (0, _timeUtil.getTimestamp)());
	        case _socketConstants.CHANNELS_UPDATED:
	            return updateChannels(state, action);
	        default:
	            return state;
	    }
	};

/***/ }),
/* 2144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Constants
	
	
	var _selectionConstants = __webpack_require__(77);
	
	var SELECTION_ACTION_TYPES = _interopRequireWildcard(_selectionConstants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = function (state, action) {
	    // Don't redo element selections. This feels better because otherwise the user's cursor will get 'stuck' in editors
	    // and the user will have to deselect the element in order to continue undoing
	    if (action.type === SELECTION_ACTION_TYPES.ELEMENTS_SELECTED) {
	        return null;
	    }
	
	    return _extends({}, action, {
	        isRedo: true,
	        transactionId: action.transactionId
	    });
	};

/***/ }),
/* 2145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.createUndoDecreaseElementCount = exports.createUndoIncreaseElementCount = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Utils
	
	
	// Constants
	
	
	var _milanoteLodash = __webpack_require__(2128);
	
	var _elementConstants = __webpack_require__(12);
	
	var ELEMENT_ACTION_TYPES = _interopRequireWildcard(_elementConstants);
	
	var _reactRouterRedux = __webpack_require__(82);
	
	var _selectionConstants = __webpack_require__(77);
	
	var SELECTION_ACTION_TYPES = _interopRequireWildcard(_selectionConstants);
	
	var _elementCountConstants = __webpack_require__(169);
	
	var ELEMENT_COUNT_ACTION_TYPES = _interopRequireWildcard(_elementCountConstants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Reverse location & from
	var getSingleMoveUndoDetails = function getSingleMoveUndoDetails(state, _ref) {
	    var id = _ref.id,
	        location = _ref.location,
	        from = _ref.from;
	    return {
	        id: id,
	        location: _extends({}, from),
	        from: _extends({}, location)
	    };
	};
	
	var createUndoMoveAction = function createUndoMoveAction(state, action) {
	    return _extends({
	        type: action.type
	    }, getSingleMoveUndoDetails(state, action), {
	        sync: action.sync
	    });
	};
	
	var createUndoMultiMoveAction = function createUndoMultiMoveAction(state, action) {
	    return {
	        type: action.type,
	        moves: action.moves.map(function (move) {
	            return getSingleMoveUndoDetails(state, move);
	        }),
	        sync: action.sync
	    };
	};
	
	var getSingleUpdateUndoDetails = function getSingleUpdateUndoDetails(state, _ref2) {
	    var changes = _ref2.changes,
	        id = _ref2.id;
	    return {
	        id: id,
	        changes: (0, _milanoteLodash.objectIntersection)(changes, state.getIn(['elements', id, 'content']).toJS())
	    };
	};
	
	var createUndoUpdateAction = function createUndoUpdateAction(state, action) {
	    return {
	        type: action.type,
	        updates: action.updates.map(function (update) {
	            return getSingleUpdateUndoDetails(state, update);
	        }),
	        sync: action.sync
	    };
	};
	
	var createUndoMoveAndUpdateAction = function createUndoMoveAndUpdateAction(state, action) {
	    return _extends({}, createUndoMoveAction(state, action), getSingleUpdateUndoDetails(state, action));
	};
	
	var createUndoCreateAction = function createUndoCreateAction(state, action) {
	    return {
	        type: ELEMENT_ACTION_TYPES.ELEMENT_DELETE,
	        id: action.id,
	        elementType: action.elementType,
	        // Need to add this to ensure the action is synced with the server
	        location: {
	            parentId: action.location.parentId
	        },
	        sync: action.sync
	    };
	};
	
	var createUndoRouteChange = function createUndoRouteChange(state, action) {
	    return {
	        type: _reactRouterRedux.LOCATION_CHANGE,
	        payload: _extends({}, state.get('routing').locationBeforeTransitions, {
	            action: 'POP'
	        })
	    };
	};
	
	var createUndoSelectAction = function createUndoSelectAction(state, action) {
	    return {
	        type: SELECTION_ACTION_TYPES.ELEMENTS_DESELECTED,
	        ids: action.ids,
	        sync: action.sync
	    };
	};
	
	var createUndoIncreaseElementCount = exports.createUndoIncreaseElementCount = function createUndoIncreaseElementCount(state, action) {
	    return {
	        type: ELEMENT_COUNT_ACTION_TYPES.ELEMENT_COUNT_DECREASE,
	        counts: action.counts
	    };
	};
	
	var createUndoDecreaseElementCount = exports.createUndoDecreaseElementCount = function createUndoDecreaseElementCount(state, action) {
	    return {
	        type: ELEMENT_COUNT_ACTION_TYPES.ELEMENT_COUNT_INCREAESE,
	        counts: action.counts
	    };
	};
	
	var buildReverseAction = function buildReverseAction(state, action) {
	    switch (action.type) {
	        case ELEMENT_ACTION_TYPES.ELEMENT_MOVE_AND_UPDATE:
	            return createUndoMoveAndUpdateAction(state, action);
	        case ELEMENT_ACTION_TYPES.ELEMENT_MOVE_MULTI:
	            return createUndoMultiMoveAction(state, action);
	        case ELEMENT_ACTION_TYPES.ELEMENT_UPDATE:
	            return createUndoUpdateAction(state, action);
	        case ELEMENT_ACTION_TYPES.ELEMENT_CREATE:
	            return createUndoCreateAction(state, action);
	        case _reactRouterRedux.LOCATION_CHANGE:
	            return createUndoRouteChange(state, action);
	        case SELECTION_ACTION_TYPES.ELEMENTS_SELECTED:
	            return createUndoSelectAction(state, action);
	        case ELEMENT_COUNT_ACTION_TYPES.ELEMENT_COUNT_INCREAESE:
	            return createUndoIncreaseElementCount(state, action);
	        case ELEMENT_COUNT_ACTION_TYPES.ELEMENT_COUNT_DECREASE:
	            return createUndoDecreaseElementCount(state, action);
	        default:
	            throw Error('UNDO: Unknown action type, ' + action.type);
	    }
	};
	
	exports.default = function (state, action) {
	    return _extends({}, buildReverseAction(state, action), {
	        isUndo: true,
	        transactionId: action.transactionId
	    });
	};

/***/ }),
/* 2146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _elementConstants = __webpack_require__(12);
	
	var ELEMENT_ACTION_TYPES = _interopRequireWildcard(_elementConstants);
	
	var _reactRouterRedux = __webpack_require__(82);
	
	var _selectionConstants = __webpack_require__(77);
	
	var SELECTION_ACTION_TYPES = _interopRequireWildcard(_selectionConstants);
	
	var _elementCountConstants = __webpack_require__(169);
	
	var ELEMENT_COUNT_ACTION_TYPES = _interopRequireWildcard(_elementCountConstants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Constants
	var actionHasUndoProperties = function actionHasUndoProperties(action) {
	    // don't add other people's actions
	    if (action.remote) return false;
	
	    // don't add existing undo actions to the stack
	    if (action.isUndo) return false;
	    if (action.isRedo) return false;
	
	    // add regular location change actions to the stack
	    if (action.type === _reactRouterRedux.LOCATION_CHANGE) return true;
	    // add things with a transaction id will be added to the stack
	    if (action.transactionId) return true;
	
	    // default to not adding actions to stack
	    return false;
	};
	
	var stateHasElement = function stateHasElement(state, elementId) {
	    return state.hasIn(['elements', elementId]);
	};
	var stateHasSomeElements = function stateHasSomeElements(state, elementIds) {
	    return elementIds.some(function (elementId) {
	        return state.hasIn(['elements', elementId]);
	    });
	};
	var canUndoMultiMoveAction = function canUndoMultiMoveAction(state, action) {
	    return stateHasSomeElements(state, action.moves.map(function (move) {
	        return move.id;
	    }));
	};
	var canUndoMoveAction = function canUndoMoveAction(state, action) {
	    return stateHasElement(state, action.id);
	};
	var canUndoUpdateAction = function canUndoUpdateAction(state, action) {
	    return stateHasSomeElements(state, action.updates.map(function (update) {
	        return update.id;
	    }));
	};
	var canUndoRouteChange = function canUndoRouteChange(state, action) {
	    return !!state.get('routing').locationBeforeTransitions && action.payload && action.payload.action !== 'REPLACE';
	};
	
	var actionCanUndo = function actionCanUndo(state, action) {
	    switch (action.type) {
	        case ELEMENT_ACTION_TYPES.ELEMENT_MOVE_AND_UPDATE:
	            return canUndoMoveAction(state, action);
	        case ELEMENT_ACTION_TYPES.ELEMENT_MOVE_MULTI:
	            return canUndoMultiMoveAction(state, action);
	        case ELEMENT_ACTION_TYPES.ELEMENT_UPDATE:
	            return canUndoUpdateAction(state, action);
	        case _reactRouterRedux.LOCATION_CHANGE:
	            return canUndoRouteChange(state, action);
	        case SELECTION_ACTION_TYPES.ELEMENTS_SELECTED:
	        case ELEMENT_ACTION_TYPES.ELEMENT_CREATE:
	        case ELEMENT_COUNT_ACTION_TYPES.ELEMENT_COUNT_INCREAESE:
	        case ELEMENT_COUNT_ACTION_TYPES.ELEMENT_COUNT_DECREASE:
	            return true;
	        default:
	            return false;
	    }
	};
	
	exports.default = function (store, action) {
	    return actionHasUndoProperties(action) && actionCanUndo(store.getState(), action);
	};

/***/ }),
/* 2147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(4);
	
	var _undoRedoSelector = __webpack_require__(474);
	
	var _undoRedoTransactionManager = __webpack_require__(86);
	
	var _shouldAddUndo = __webpack_require__(2146);
	
	var _shouldAddUndo2 = _interopRequireDefault(_shouldAddUndo);
	
	var _createUndoAction = __webpack_require__(2145);
	
	var _createUndoAction2 = _interopRequireDefault(_createUndoAction);
	
	var _createRedoAction = __webpack_require__(2144);
	
	var _createRedoAction2 = _interopRequireDefault(_createRedoAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Lib
	var addTransactionIdIfNeeded = function addTransactionIdIfNeeded(store) {
	    return function (action) {
	        if (!action.transactionId) {
	            var currentState = store.getState();
	            var operation = (0, _undoRedoSelector.getCurrentOperation)(currentState);
	
	            // NOTE: This could potentially use a white-list of action types for each operation
	            //      which would then attach the same transaction ID to those actions.
	            //      For now, it's left as a 'boolean style string' that catches all actions without
	            //      a transaction ID.
	            // If we're within a current operation, use its transaction ID
	            action.transactionId = operation ? (0, _undoRedoSelector.getMostRecentTransactionId)(currentState) : (0, _undoRedoTransactionManager.getNewTransactionId)();
	        }
	        return action;
	    };
	};
	
	// Util
	
	
	var addUndoRedoAction = function addUndoRedoAction(store) {
	    return function (action) {
	        var currentState = store.getState();
	        action.undoRedoAction = {
	            undo: (0, _createUndoAction2.default)(currentState, action),
	            redo: (0, _createRedoAction2.default)(currentState, action)
	        };
	        return action;
	    };
	};
	
	var enrichAction = function enrichAction(store, action) {
	    return (0, _lodash.flow)(addTransactionIdIfNeeded(store), addUndoRedoAction(store))(action);
	};
	
	exports.default = function (store) {
	    return function (next) {
	        return function (action) {
	            // check if the action should be added to the stack
	            if (!(0, _shouldAddUndo2.default)(store, action)) return next(action);
	
	            var enrichedAction = enrichAction(store, action);
	            return next(enrichedAction);
	        };
	    };
	};

/***/ }),
/* 2148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _undoRedoTransactionManager = __webpack_require__(86);
	
	var _undoRedoTransactionsReducer = __webpack_require__(2149);
	
	var _undoRedoTransactionsReducer2 = _interopRequireDefault(_undoRedoTransactionsReducer);
	
	var _undoRedoConstants = __webpack_require__(473);
	
	var _authConstants = __webpack_require__(136);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Utils
	var initialState = Immutable.Map({
	    operation: null,
	    mostRecentTransactionId: (0, _undoRedoTransactionManager.getCurrentTransactionId)(),
	    transactions: Immutable.Map(),
	    undoStack: Immutable.Stack(),
	    redoStack: Immutable.Stack()
	});
	
	// General Stack
	
	
	// Reducers
	// Lib
	var getNextFromStack = function getNextFromStack(stackName) {
	    return function (state) {
	        return state.get(stackName).peek();
	    };
	};
	var removeNextFromStack = function removeNextFromStack(stackName) {
	    return function (state) {
	        return state.update(stackName, function (stack) {
	            return stack.shift();
	        });
	    };
	};
	
	// UNDO STACK
	var addToStackWithLimit = function addToStackWithLimit(value) {
	    return function (stack) {
	        return stack.size < _undoRedoConstants.UNDO_STACK_LIMIT ? stack.unshift(value) : stack.slice(0, _undoRedoConstants.UNDO_STACK_SLICE_SIZE).unshift(value);
	    };
	};
	
	var addToUndoStack = function addToUndoStack(state, undoActionId) {
	    return state.update('undoStack', addToStackWithLimit(undoActionId));
	};
	var getNextUndo = getNextFromStack('undoStack');
	var removeNextUndo = removeNextFromStack('undoStack');
	
	// REDO STACK
	// No limit on the redo stack
	var addToRedoStack = function addToRedoStack(state, redoActionId) {
	    return state.update('redoStack', function (redoStack) {
	        return redoStack.unshift(redoActionId);
	    });
	};
	
	var clearRedoStack = function clearRedoStack(state, action) {
	    return state.update('redoStack', function (redoStack) {
	        return redoStack.clear();
	    });
	};
	var getNextRedo = getNextFromStack('redoStack');
	var removeNextRedo = removeNextFromStack('redoStack');
	
	// STATE REDUCER
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    if (action.type === _authConstants.LOGOUT) {
	        return initialState;
	    }
	
	    var updatedState = state;
	    if (action.type === _undoRedoConstants.START_OPERATION) {
	        updatedState = updatedState.set('operation', action.name);
	    }
	    if (action.type === _undoRedoConstants.END_OPERATION) {
	        updatedState = updatedState.set('operation', null);
	    }
	
	    if (action.remote || !action.transactionId) return updatedState;
	
	    var mostRecentTransactionId = updatedState.get('mostRecentTransactionId');
	    var isNewTransaction = action.transactionId > mostRecentTransactionId;
	
	    // Add the action to the transactions map if required
	    updatedState = updatedState.update('transactions', function (transactionsState) {
	        return (0, _undoRedoTransactionsReducer2.default)(transactionsState, action);
	    });
	
	    if (isNewTransaction) {
	        updatedState = updatedState.set('mostRecentTransactionId', action.transactionId);
	
	        // Remove the transactions in the redo stack from the transactions map (as they can never be undone or redone
	        // from this point onwards).
	        var transactionIds = updatedState.get('redoStack');
	        updatedState = updatedState.update('transactions', function (transactionsState) {
	            return (0, _undoRedoTransactionsReducer.clearTransactions)(transactionsState, transactionIds);
	        });
	
	        // Add to undo stack
	        updatedState = addToUndoStack(updatedState, action.transactionId);
	
	        // clear redo stack
	        updatedState = clearRedoStack(updatedState);
	    }
	
	    if (action.isUndo) {
	        // The action to add to the redo stack now that it has been 'undone'
	        var redoTransactionId = getNextUndo(updatedState);
	
	        // Only change the stack if the action being undone is the first of the undo stack (subsequent actions will not
	        // modify the stacks).
	        if (action.transactionId === redoTransactionId) {
	            updatedState = removeNextUndo(updatedState);
	            updatedState = addToRedoStack(updatedState, redoTransactionId);
	        }
	    }
	
	    if (action.isRedo) {
	        // The action to add to the undo stack now that it has been 'redone'
	        var undoTransactionId = getNextRedo(updatedState);
	
	        // Only change the stack if the action being redone is the first of the redo stack (subsequent actions will not
	        // modify the stacks).
	        if (action.transactionId === undoTransactionId) {
	            updatedState = removeNextRedo(updatedState);
	            updatedState = addToUndoStack(updatedState, undoTransactionId);
	        }
	    }
	
	    return updatedState;
	};

/***/ }),
/* 2149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.clearTransactions = undefined;
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _reactRouterRedux = __webpack_require__(82);
	
	var _fp = __webpack_require__(52);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialState = Immutable.Map(); // Lib
	
	
	var getLastAction = function getLastAction(actionList) {
	    return actionList.get(actionList.size - 1);
	};
	
	var lastActionIsLocationChange = function lastActionIsLocationChange(actionList) {
	    if (!actionList) return false;
	    var lastActionType = (0, _fp.get)(['undo', 'type'], getLastAction(actionList));
	    return lastActionType === _reactRouterRedux.LOCATION_CHANGE;
	};
	
	var clearTransactions = exports.clearTransactions = function clearTransactions() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var transactionIds = arguments[1];
	    return state.filter(function (actions, transactionId) {
	        return transactionIds.indexOf(transactionId) === -1;
	    });
	};
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    if (!action.transactionId || !action.undoRedoAction) return state;
	
	    if (state.has(action.transactionId)) {
	        return state.update(action.transactionId, function (actionList) {
	            var undoRedoAction = action.undoRedoAction;
	            var updatedActionList = actionList;
	
	            // Collapse location change actions to prevent unnecessary multiple location changes on undo
	            if (action.type === _reactRouterRedux.LOCATION_CHANGE && lastActionIsLocationChange(actionList)) {
	                var lastAction = getLastAction(actionList);
	                undoRedoAction.undo = lastAction.undo;
	                updatedActionList = updatedActionList.pop();
	            }
	
	            return updatedActionList.push(undoRedoAction);
	        });
	    }
	
	    return state.set(action.transactionId, Immutable.List([action.undoRedoAction]));
	};

/***/ }),
/* 2150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _AppHeader = __webpack_require__(769);
	
	var _AppHeader2 = _interopRequireDefault(_AppHeader);
	
	var _Toolbar = __webpack_require__(2218);
	
	var _Toolbar2 = _interopRequireDefault(_Toolbar);
	
	var _Main = __webpack_require__(2199);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _WorkspaceClipboardHandler = __webpack_require__(2215);
	
	var _WorkspaceClipboardHandler2 = _interopRequireDefault(_WorkspaceClipboardHandler);
	
	var _PageLoaderMain = __webpack_require__(439);
	
	var _PageLoaderMain2 = _interopRequireDefault(_PageLoaderMain);
	
	var _elementShortcutsDecorator = __webpack_require__(2216);
	
	var _elementShortcutsDecorator2 = _interopRequireDefault(_elementShortcutsDecorator);
	
	var _socketConstants = __webpack_require__(109);
	
	__webpack_require__(1263);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	var WorkspacePositioner = function WorkspacePositioner(props) {
	    var isCurrentBoardFetching = props.isCurrentBoardFetching,
	        isCurrentBoardFetched = props.isCurrentBoardFetched;
	
	
	    if (isCurrentBoardFetching && !isCurrentBoardFetched) return _react2.default.createElement(_PageLoaderMain2.default, { color: '#cacaca' });
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'workspace-positioner' },
	        _react2.default.createElement(_Toolbar2.default, props),
	        _react2.default.createElement(_Main2.default, props),
	        _react2.default.createElement(_WorkspaceClipboardHandler2.default, props)
	    );
	};
	
	// Styles
	// Lib
	
	
	WorkspacePositioner.propTypes = {
	    isCurrentBoardFetching: _propTypes2.default.bool,
	    isCurrentBoardFetched: _propTypes2.default.bool
	};
	
	var Workspace = function Workspace(props) {
	    var socketConnection = props.socketConnection;
	
	
	    var classes = {
	        disconnected: socketConnection && socketConnection.get('status') === _socketConstants.SOCKET_CONNECTION_STATUS.DISCONNECTED
	    };
	
	    return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('Workspace', classes) },
	        _react2.default.createElement(_AppHeader2.default, props),
	        _react2.default.createElement(WorkspacePositioner, props)
	    );
	};
	
	Workspace.propTypes = {
	    currentBoardId: _propTypes2.default.string.isRequired,
	    className: _propTypes2.default.string,
	    socketConnection: _propTypes2.default.object
	};
	
	exports.default = (0, _elementShortcutsDecorator2.default)(Workspace);

/***/ }),
/* 2151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDndHtml5Backend = __webpack_require__(220);
	
	var _reactDndHtml5Backend2 = _interopRequireDefault(_reactDndHtml5Backend);
	
	var _reactDndTouchBackend = __webpack_require__(1460);
	
	var _reactDndTouchBackend2 = _interopRequireDefault(_reactDndTouchBackend);
	
	var _reactDnd = __webpack_require__(72);
	
	var _reactDocumentTitle = __webpack_require__(604);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _browser = __webpack_require__(61);
	
	var browserService = _interopRequireWildcard(_browser);
	
	var _CollaborationManager = __webpack_require__(2114);
	
	var _CollaborationManager2 = _interopRequireDefault(_CollaborationManager);
	
	var _WorkspaceDragLayer = __webpack_require__(2160);
	
	var _WorkspaceDragLayer2 = _interopRequireDefault(_WorkspaceDragLayer);
	
	var _SocketConnectionStatusError = __webpack_require__(1757);
	
	var _SocketConnectionStatusError2 = _interopRequireDefault(_SocketConnectionStatusError);
	
	var _PopupPanelMobileContainer = __webpack_require__(1925);
	
	var _PopupPanelMobileContainer2 = _interopRequireDefault(_PopupPanelMobileContainer);
	
	var _WorkspaceErrorModalManager = __webpack_require__(1758);
	
	var _WorkspaceErrorModalManager2 = _interopRequireDefault(_WorkspaceErrorModalManager);
	
	var _PageLoaderContainer = __webpack_require__(1906);
	
	var _PageLoaderContainer2 = _interopRequireDefault(_PageLoaderContainer);
	
	var _NotificationPollManager = __webpack_require__(2035);
	
	var _NotificationPollManager2 = _interopRequireDefault(_NotificationPollManager);
	
	var _Workspace = __webpack_require__(2150);
	
	var _Workspace2 = _interopRequireDefault(_Workspace);
	
	var _MobileWorkspace = __webpack_require__(2204);
	
	var _MobileWorkspace2 = _interopRequireDefault(_MobileWorkspace);
	
	var _WorkspaceKeyboardShortcutHandler = __webpack_require__(2153);
	
	var _WorkspaceKeyboardShortcutHandler2 = _interopRequireDefault(_WorkspaceKeyboardShortcutHandler);
	
	var _DragModifierKeysListener = __webpack_require__(2120);
	
	var _DragModifierKeysListener2 = _interopRequireDefault(_DragModifierKeysListener);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Utils
	// Lib
	var getDragDropBackend = function getDragDropBackend() {
	    return browserService.isMobile() ? _reactDndTouchBackend2.default : _reactDndHtml5Backend2.default;
	};
	
	/* ----
	 * WorkspaceContainer
	 * This component the middle level of the workspace stack
	 * it's responsible for interaction:
	 *    - drag & drop
	 *    - keyboard shortcuts
	 */
	
	// Components
	var WorkspaceContainer = function WorkspaceContainer(props) {
	    var currentBoardId = props.currentBoardId,
	        pageTitle = props.pageTitle,
	        socketConnection = props.socketConnection,
	        location = props.location,
	        showLoader = props.showLoader,
	        showLoaderQuote = props.showLoaderQuote,
	        isMobileView = props.isMobileView;
	
	
	    if (showLoader) {
	        return _react2.default.createElement(_PageLoaderContainer2.default, {
	            quoteFade: true,
	            quoteShow: showLoaderQuote,
	            logoFade: true,
	            logoShow: showLoaderQuote });
	    }
	
	    return _react2.default.createElement(
	        _CollaborationManager2.default,
	        { currentBoardId: currentBoardId },
	        _react2.default.createElement(
	            _reactDocumentTitle2.default,
	            { title: pageTitle },
	            _react2.default.createElement(
	                'div',
	                { className: 'WorkspaceWrapper' },
	                isMobileView ? _react2.default.createElement(_MobileWorkspace2.default, props) : _react2.default.createElement(_Workspace2.default, props),
	                _react2.default.createElement(_SocketConnectionStatusError2.default, { socketConnection: socketConnection }),
	                _react2.default.createElement(_WorkspaceErrorModalManager2.default, { currentBoardId: currentBoardId, location: location }),
	                _react2.default.createElement(_WorkspaceDragLayer2.default, { currentBoardId: currentBoardId }),
	                _react2.default.createElement(_PopupPanelMobileContainer2.default, props),
	                _react2.default.createElement(_NotificationPollManager2.default, null),
	                _react2.default.createElement(_DragModifierKeysListener2.default, null),
	                _react2.default.createElement(_WorkspaceKeyboardShortcutHandler2.default, props)
	            )
	        )
	    );
	};
	
	WorkspaceContainer.propTypes = {
	    currentBoardId: _propTypes2.default.string,
	    currentBoard: _propTypes2.default.object,
	    showLoader: _propTypes2.default.bool,
	    showLoaderQuote: _propTypes2.default.bool,
	    isMobileView: _propTypes2.default.bool,
	    pageTitle: _propTypes2.default.string,
	    socketConnection: _propTypes2.default.object,
	    location: _propTypes2.default.object
	};
	
	exports.default = (0, _reactDnd.DragDropContext)(getDragDropBackend())(WorkspaceContainer);

/***/ }),
/* 2152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _recompose = __webpack_require__(9);
	
	var _lodash = __webpack_require__(4);
	
	var _workspaceSelector = __webpack_require__(2251);
	
	var _workspaceSelector2 = _interopRequireDefault(_workspaceSelector);
	
	var _WorkspaceContainer = __webpack_require__(2151);
	
	var _WorkspaceContainer2 = _interopRequireDefault(_WorkspaceContainer);
	
	var _RouteModalManager = __webpack_require__(1918);
	
	var _RouteModalManager2 = _interopRequireDefault(_RouteModalManager);
	
	var _GridSizeManager = __webpack_require__(2123);
	
	var _GridSizeManager2 = _interopRequireDefault(_GridSizeManager);
	
	var _workspaceUserFetchDecorator = __webpack_require__(2158);
	
	var _workspaceUserFetchDecorator2 = _interopRequireDefault(_workspaceUserFetchDecorator);
	
	var _workspaceRootRedirectionDecorator = __webpack_require__(2157);
	
	var _workspaceRootRedirectionDecorator2 = _interopRequireDefault(_workspaceRootRedirectionDecorator);
	
	var _workspaceArtificialLoadingDelayDecorator = __webpack_require__(2154);
	
	var _workspaceArtificialLoadingDelayDecorator2 = _interopRequireDefault(_workspaceArtificialLoadingDelayDecorator);
	
	var _workspaceBoardFetchDecorator = __webpack_require__(2155);
	
	var _workspaceBoardFetchDecorator2 = _interopRequireDefault(_workspaceBoardFetchDecorator);
	
	var _workspaceNavigationDecorator = __webpack_require__(2156);
	
	var _workspaceNavigationDecorator2 = _interopRequireDefault(_workspaceNavigationDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* ----
	 * WorkspaceInitContainer
	 * This component is the top level of the workspace stack,
	 * it's responsible for fetching data and displaying and route-based modals
	 */
	
	// the decorators responsible for board data should only
	// be used after the user is ititialised
	
	
	// Components
	var boardLoadManagerEnhance = (0, _recompose.branch)(function (_ref) {
	    var isUserAvailable = _ref.isUserAvailable;
	    return !!isUserAvailable;
	}, (0, _recompose.compose)(_workspaceBoardFetchDecorator2.default, _workspaceNavigationDecorator2.default), _lodash.identity);
	
	// this handles loading of board and user navigation
	// using conditional decorators that only attach once
	
	
	// Selectors
	var BoardLoadManager = boardLoadManagerEnhance(function () {
	    return null;
	});
	
	var workspaceInitEnhance = (0, _recompose.compose)(
	// select all data needed by the workspace
	(0, _reactRedux.connect)(_workspaceSelector2.default),
	// keep the loader around until everything is ready to show
	_workspaceArtificialLoadingDelayDecorator2.default,
	// redirect '/' route to '/ROOT_BOARD_ID' route
	_workspaceRootRedirectionDecorator2.default,
	// fetch user data
	_workspaceUserFetchDecorator2.default);
	
	var WorkspaceInitContainer = function WorkspaceInitContainer(props) {
	    var children = props.children;
	
	
	    return _react2.default.createElement(
	        _GridSizeManager2.default,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'WorkspaceInitContainer' },
	            _react2.default.createElement(BoardLoadManager, props),
	            _react2.default.createElement(_WorkspaceContainer2.default, props),
	            _react2.default.createElement(
	                _RouteModalManager2.default,
	                null,
	                children
	            )
	        )
	    );
	};
	
	WorkspaceInitContainer.propTypes = {
	    currentBoardId: _propTypes2.default.string,
	    isGuest: _propTypes2.default.bool,
	    isUserAvailable: _propTypes2.default.bool,
	    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	    location: _propTypes2.default.object
	};
	
	exports.default = workspaceInitEnhance(WorkspaceInitContainer);

/***/ }),
/* 2153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class; // Lib
	
	
	// keyboard actions
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _keyboardShortcuts = __webpack_require__(2127);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WorkspaceKeyboardShortcutHandler = (_dec = (0, _reactRedux.connect)(), _dec(_class = function (_React$Component) {
	    _inherits(WorkspaceKeyboardShortcutHandler, _React$Component);
	
	    function WorkspaceKeyboardShortcutHandler() {
	        _classCallCheck(this, WorkspaceKeyboardShortcutHandler);
	
	        return _possibleConstructorReturn(this, (WorkspaceKeyboardShortcutHandler.__proto__ || Object.getPrototypeOf(WorkspaceKeyboardShortcutHandler)).apply(this, arguments));
	    }
	
	    _createClass(WorkspaceKeyboardShortcutHandler, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                currentBoardId = _props.currentBoardId,
	                currentBoard = _props.currentBoard,
	                isEditable = _props.isEditable,
	                dispatch = _props.dispatch;
	
	            this.keyboardManager = (0, _keyboardShortcuts.bindShortcuts)(dispatch);
	            this.keyboardManager.setProps({ currentBoardId: currentBoardId, currentBoard: currentBoard, isEditable: isEditable });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var currentBoardId = nextProps.currentBoardId,
	                currentBoard = nextProps.currentBoard,
	                isEditable = nextProps.isEditable;
	
	            if (this.keyboardManager) this.keyboardManager.setProps({ currentBoardId: currentBoardId, currentBoard: currentBoard, isEditable: isEditable });
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this.keyboardManager) this.keyboardManager.unbind();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return null;
	        }
	    }]);
	
	    return WorkspaceKeyboardShortcutHandler;
	}(_react2.default.Component)) || _class);
	
	
	WorkspaceKeyboardShortcutHandler.propTypes = {
	    currentBoardId: _propTypes2.default.string,
	    currentBoard: _propTypes2.default.object,
	    isEditable: _propTypes2.default.bool,
	    dispatch: _propTypes2.default.func
	};
	
	exports.default = WorkspaceKeyboardShortcutHandler;

/***/ }),
/* 2154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _timeUtil = __webpack_require__(43);
	
	var _getClientConfig = __webpack_require__(48);
	
	var _getClientConfig2 = _interopRequireDefault(_getClientConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	var LOADING_TIME_MIN = (0, _getClientConfig2.default)().initialLoadDelay || 3000;
	var QUOTE_FADE_DURATION = 300;
	
	exports.default = function (DecoratedComponent) {
	    var WorkspaceArtificialLoadingDelayDecorator = function (_React$Component) {
	        _inherits(WorkspaceArtificialLoadingDelayDecorator, _React$Component);
	
	        function WorkspaceArtificialLoadingDelayDecorator(props) {
	            _classCallCheck(this, WorkspaceArtificialLoadingDelayDecorator);
	
	            var _this = _possibleConstructorReturn(this, (WorkspaceArtificialLoadingDelayDecorator.__proto__ || Object.getPrototypeOf(WorkspaceArtificialLoadingDelayDecorator)).call(this, props));
	
	            _this.finishLoading = function () {
	                // don't set multiple delays if this method is called more than once
	                if (!_this.state.loading) return;
	                _this.setState({ loading: false });
	
	                var timeNow = (0, _timeUtil.getTimestamp)();
	                var loadingDifference = _this.startedLoading - timeNow;
	
	                var delayQuote = Math.max(0, loadingDifference + LOADING_TIME_MIN);
	                var delayLoader = delayQuote + QUOTE_FADE_DURATION;
	
	                (0, _lodash.delay)(function () {
	                    return _this.setState({ showLoaderQuote: false });
	                }, delayQuote);
	                (0, _lodash.delay)(function () {
	                    return _this.setState({ showLoader: false });
	                }, delayLoader);
	            };
	
	            _this.loadWithoutDelay = function () {
	                _this.setState({
	                    showLoaderQuote: false,
	                    showLoader: false
	                });
	            };
	
	            _this.state = {
	                showLoader: true,
	                showLoaderQuote: true,
	                loading: true
	            };
	            return _this;
	        }
	
	        _createClass(WorkspaceArtificialLoadingDelayDecorator, [{
	            key: 'componentWillMount',
	            value: function componentWillMount() {
	                this.startedLoading = window.__startedload || (0, _timeUtil.getTimestamp)();
	
	                // for hot reloading
	                if (this.props.isUserAvailable && !this.props.isGuest) this.loadWithoutDelay();
	            }
	        }, {
	            key: 'componentWillReceiveProps',
	            value: function componentWillReceiveProps(nextProps) {
	                if (nextProps.isUserAvailable && nextProps.currentBoard && nextProps.isCurrentBoardFetched || nextProps.isUserAvailable && nextProps.isCurrentBoardError) {
	                    this.finishLoading();
	                }
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                var _state = this.state,
	                    showLoader = _state.showLoader,
	                    showLoaderQuote = _state.showLoaderQuote;
	
	
	                return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, {
	                    showLoader: showLoader,
	                    showLoaderQuote: showLoaderQuote }));
	            }
	        }]);
	
	        return WorkspaceArtificialLoadingDelayDecorator;
	    }(_react2.default.Component);
	
	    WorkspaceArtificialLoadingDelayDecorator.propTypes = {
	        isUserAvailable: _propTypes2.default.bool,
	        isGuest: _propTypes2.default.bool
	    };
	
	    return WorkspaceArtificialLoadingDelayDecorator;
	};

/***/ }),
/* 2155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _boardService = __webpack_require__(167);
	
	var boardService = _interopRequireWildcard(_boardService);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        fetchBoard: function fetchBoard(args) {
	            return dispatch(boardService.fetchBoard(args));
	        }
	    };
	};
	
	/**
	 * This component is being used to separate the redirection logic out of the WorkspaceInitContainer to account
	 * for the scenario that the root URL is loaded (e.g. www.milanote.com) because sub routes are not invoked in
	 * this version of React Router when the current route matches exactly ('/').
	 */
	
	exports.default = function (DecoratedComponent) {
	    var _dec, _class;
	
	    var WorkspacBoardFetchDecorator = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec(_class = function (_React$Component) {
	        _inherits(WorkspacBoardFetchDecorator, _React$Component);
	
	        function WorkspacBoardFetchDecorator() {
	            _classCallCheck(this, WorkspacBoardFetchDecorator);
	
	            return _possibleConstructorReturn(this, (WorkspacBoardFetchDecorator.__proto__ || Object.getPrototypeOf(WorkspacBoardFetchDecorator)).apply(this, arguments));
	        }
	
	        _createClass(WorkspacBoardFetchDecorator, [{
	            key: 'componentWillMount',
	            value: function componentWillMount() {
	                var _props = this.props,
	                    currentBoardId = _props.currentBoardId,
	                    fetchBoard = _props.fetchBoard;
	
	
	                if (!currentBoardId) return;
	
	                fetchBoard({ boardId: currentBoardId, loadNextBoards: true, loadAncestors: true });
	            }
	        }, {
	            key: 'componentWillReceiveProps',
	            value: function componentWillReceiveProps(nextProps) {
	                var fetchBoard = nextProps.fetchBoard,
	                    currentBoardId = nextProps.currentBoardId,
	                    socketConnected = nextProps.socketConnected,
	                    isCurrentBoardFetched = nextProps.isCurrentBoardFetched,
	                    isCurrentBoardFetching = nextProps.isCurrentBoardFetching;
	
	
	                if (!currentBoardId || !socketConnected) return;
	
	                // Only fetch the board on property change if the board ID has changed
	                if (currentBoardId !== this.props.currentBoardId) {
	                    return fetchBoard({ boardId: currentBoardId, loadNextBoards: true });
	                }
	
	                // Handles the case that the current board is being fetched, but then errors during the fetch, but has not
	                // been marked as being fetched due to the helper service
	                if (!isCurrentBoardFetched && !isCurrentBoardFetching) {
	                    return fetchBoard({ boardId: currentBoardId, loadNextBoards: true });
	                }
	
	                // Fetch the board if the socket changes from disconnected to connected
	                if (socketConnected && !this.props.socketConnected) {
	                    fetchBoard({ boardId: currentBoardId, loadNextBoards: true });
	                }
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                return _react2.default.createElement(DecoratedComponent, this.props);
	            }
	        }]);
	
	        return WorkspacBoardFetchDecorator;
	    }(_react2.default.Component)) || _class);
	
	
	    WorkspacBoardFetchDecorator.propTypes = {
	        currentBoardId: _propTypes2.default.string,
	        isCurrentBoardFetched: _propTypes2.default.bool,
	        isCurrentBoardFetching: _propTypes2.default.bool,
	        socketConnected: _propTypes2.default.bool,
	        fetchBoard: _propTypes2.default.func
	    };
	
	    return WorkspacBoardFetchDecorator;
	};

/***/ }),
/* 2156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _currentUserActions = __webpack_require__(84);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	// Actions
	
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        sendUserNavigate: function sendUserNavigate(_ref) {
	            var currentUser = _ref.currentUser,
	                newBoardId = _ref.newBoardId,
	                previousBoardId = _ref.previousBoardId;
	
	            if (currentUser.get('isGuest')) return;
	
	            return dispatch((0, _currentUserActions.userNavigate)({ userId: currentUser.get('_id'), newBoardId: newBoardId, previousBoardId: previousBoardId }));
	        }
	    };
	};
	
	/**
	 * This component is being used to separate the redirection logic out of the WorkspaceInitContainer to account
	 * for the scenario that the root URL is loaded (e.g. www.milanote.com) because sub routes are not invoked in
	 * this version of React Router when the current route matches exactly ('/').
	 */
	
	exports.default = function (DecoratedComponent) {
	    var _dec, _class;
	
	    var WorkspaceNavigationDecorator = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec(_class = function (_React$Component) {
	        _inherits(WorkspaceNavigationDecorator, _React$Component);
	
	        function WorkspaceNavigationDecorator() {
	            _classCallCheck(this, WorkspaceNavigationDecorator);
	
	            return _possibleConstructorReturn(this, (WorkspaceNavigationDecorator.__proto__ || Object.getPrototypeOf(WorkspaceNavigationDecorator)).apply(this, arguments));
	        }
	
	        _createClass(WorkspaceNavigationDecorator, [{
	            key: 'componentWillMount',
	            value: function componentWillMount() {
	                var _props = this.props,
	                    currentUser = _props.currentUser,
	                    currentBoardId = _props.currentBoardId,
	                    sendUserNavigate = _props.sendUserNavigate,
	                    socketConnected = _props.socketConnected;
	
	
	                if (!currentBoardId || !socketConnected) return;
	                sendUserNavigate({ currentUser: currentUser, newBoardId: currentBoardId });
	            }
	        }, {
	            key: 'componentWillReceiveProps',
	            value: function componentWillReceiveProps(nextProps) {
	                var currentUser = nextProps.currentUser,
	                    currentBoardId = nextProps.currentBoardId,
	                    sendUserNavigate = nextProps.sendUserNavigate,
	                    socketConnected = nextProps.socketConnected;
	
	
	                if (!currentBoardId || !socketConnected) return;
	
	                if (this.props.currentBoardId !== currentBoardId) {
	                    sendUserNavigate({
	                        currentUser: currentUser,
	                        newBoardId: currentBoardId,
	                        previousBoardId: this.props.currentBoardId
	                    });
	                }
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                return _react2.default.createElement(DecoratedComponent, this.props);
	            }
	        }]);
	
	        return WorkspaceNavigationDecorator;
	    }(_react2.default.Component)) || _class);
	
	
	    WorkspaceNavigationDecorator.propTypes = {
	        currentBoardId: _propTypes2.default.string,
	        currentUser: _propTypes2.default.object,
	        socketConnected: _propTypes2.default.bool,
	        sendUserNavigate: _propTypes2.default.func
	    };
	
	    return WorkspaceNavigationDecorator;
	};

/***/ }),
/* 2157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _navigationActions = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	// Actions
	
	
	var ROOT_PATHNAME = '/';
	var isRoot = function isRoot(pathname) {
	    return pathname === ROOT_PATHNAME;
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        redirectToLogin: function redirectToLogin(_ref) {
	            var from = _ref.from;
	            return dispatch((0, _navigationActions.navigateToLogin)({ from: from }));
	        },
	        redirectToBoard: function redirectToBoard(_ref2) {
	            var boardId = _ref2.boardId;
	            return dispatch((0, _navigationActions.navigateToBoard)({ boardId: boardId }));
	        }
	    };
	};
	
	/**
	 * This component is being used to separate the redirection logic out of the WorkspaceInitContainer to account
	 * for the scenario that the root URL is loaded (e.g. www.milanote.com) because sub routes are not invoked in
	 * this version of React Router when the current route matches exactly ('/').
	 */
	
	exports.default = function (DecoratedComponent) {
	    var _dec, _class;
	
	    var WorkspaceRootRedirection = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec(_class = function (_React$Component) {
	        _inherits(WorkspaceRootRedirection, _React$Component);
	
	        function WorkspaceRootRedirection() {
	            var _ref3;
	
	            var _temp, _this, _ret;
	
	            _classCallCheck(this, WorkspaceRootRedirection);
	
	            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                args[_key] = arguments[_key];
	            }
	
	            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = WorkspaceRootRedirection.__proto__ || Object.getPrototypeOf(WorkspaceRootRedirection)).call.apply(_ref3, [this].concat(args))), _this), _this.redirectIfRoot = function (props) {
	                var isGuest = props.isGuest,
	                    isUserAvailable = props.isUserAvailable,
	                    pathname = props.location.pathname,
	                    redirectToLogin = props.redirectToLogin,
	                    redirectToBoard = props.redirectToBoard,
	                    currentBoardId = props.currentBoardId;
	
	
	                if (!isRoot(pathname)) return;
	
	                if (isGuest) return redirectToLogin({ redirect: pathname });
	                if (isUserAvailable) return redirectToBoard({ boardId: currentBoardId });
	            }, _temp), _possibleConstructorReturn(_this, _ret);
	        }
	
	        _createClass(WorkspaceRootRedirection, [{
	            key: 'componentWillMount',
	            value: function componentWillMount() {
	                this.redirectIfRoot(this.props);
	            }
	        }, {
	            key: 'componentWillReceiveProps',
	            value: function componentWillReceiveProps(nextProps) {
	                var pathname = nextProps.location.pathname,
	                    isUserAvailable = nextProps.isUserAvailable;
	
	
	                if (this.props.location.pathname === pathname && this.props.isUserAvailable === isUserAvailable) return;
	
	                this.redirectIfRoot(nextProps);
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                return _react2.default.createElement(DecoratedComponent, this.props);
	            }
	        }]);
	
	        return WorkspaceRootRedirection;
	    }(_react2.default.Component)) || _class);
	
	
	    WorkspaceRootRedirection.propTypes = {
	        isGuest: _propTypes2.default.bool,
	        isUserAvailable: _propTypes2.default.bool,
	        redirectToLogin: _propTypes2.default.func,
	        redirectToBoard: _propTypes2.default.func,
	        currentBoardId: _propTypes2.default.string,
	        location: _propTypes2.default.object.isRequired
	    };
	
	    return WorkspaceRootRedirection;
	};

/***/ }),
/* 2158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _currentUserActions = __webpack_require__(84);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	// Actions
	
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        initialiseCurrentUser: function initialiseCurrentUser() {
	            return dispatch((0, _currentUserActions.fetchCurrentUser)());
	        },
	        setGuestUser: function setGuestUser(user) {
	            return dispatch((0, _currentUserActions.setCurrentUserGuest)());
	        }
	    };
	};
	
	/**
	 * This component is being used to separate the redirection logic out of the WorkspaceInitContainer to account
	 * for the scenario that the root URL is loaded (e.g. www.milanote.com) because sub routes are not invoked in
	 * this version of React Router when the current route matches exactly ('/').
	 */
	
	exports.default = function (DecoratedComponent) {
	    var _dec, _class;
	
	    var WorkspaceUserFetchDecorator = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec(_class = function (_React$Component) {
	        _inherits(WorkspaceUserFetchDecorator, _React$Component);
	
	        function WorkspaceUserFetchDecorator() {
	            _classCallCheck(this, WorkspaceUserFetchDecorator);
	
	            return _possibleConstructorReturn(this, (WorkspaceUserFetchDecorator.__proto__ || Object.getPrototypeOf(WorkspaceUserFetchDecorator)).apply(this, arguments));
	        }
	
	        _createClass(WorkspaceUserFetchDecorator, [{
	            key: 'componentWillMount',
	            value: function componentWillMount() {
	                var _props = this.props,
	                    initialiseCurrentUser = _props.initialiseCurrentUser,
	                    isUserAvailable = _props.isUserAvailable,
	                    isGuest = _props.isGuest,
	                    setGuestUser = _props.setGuestUser;
	
	
	                if (!isUserAvailable) initialiseCurrentUser();
	                if (isGuest) setGuestUser();
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                return _react2.default.createElement(DecoratedComponent, this.props);
	            }
	        }]);
	
	        return WorkspaceUserFetchDecorator;
	    }(_react2.default.Component)) || _class);
	
	
	    WorkspaceUserFetchDecorator.propTypes = {
	        isGuest: _propTypes2.default.bool,
	        isUserAvailable: _propTypes2.default.bool,
	        initialiseCurrentUser: _propTypes2.default.func,
	        setGuestUser: _propTypes2.default.func
	    };
	
	    return WorkspaceUserFetchDecorator;
	};

/***/ }),
/* 2159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class; // Lib
	
	
	// Components
	
	
	// Util
	
	
	// Constants
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactDnd = __webpack_require__(72);
	
	var _shallowequal = __webpack_require__(225);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	var _reselect = __webpack_require__(7);
	
	var _renderThrottleDecorator = __webpack_require__(763);
	
	var _renderThrottleDecorator2 = _interopRequireDefault(_renderThrottleDecorator);
	
	var _SelectedElementsDragPreviews = __webpack_require__(1970);
	
	var _SelectedElementsDragPreviews2 = _interopRequireDefault(_SelectedElementsDragPreviews);
	
	var _ElementDragGroupPositioner = __webpack_require__(1967);
	
	var _ElementDragGroupPositioner2 = _interopRequireDefault(_ElementDragGroupPositioner);
	
	var _dragAndDropUtils = __webpack_require__(145);
	
	var _gridSizeSelector = __webpack_require__(66);
	
	var _elementConstants = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = (0, _reselect.createSelector)(_gridSizeSelector.getGridSize, function (state) {
	    return state.getIn(['app', 'dragging', 'hoveredTypes']);
	}, function (gridSize, hoveredTypes, selectedIds) {
	    return {
	        gridSize: gridSize,
	        hoveredTypes: hoveredTypes
	    };
	});
	
	/**
	 * Produces a map of CSS class names depending on the type of element that's hovered.
	 *
	 * @param monitor {DragLayerMonitor} The React DnD drag layer monitor.
	 * @param hoveredTypes {Immutable.Map} An immutable map of hovered types.
	 * @returns {Array} A an array of CSS class names that should be applied to the element
	 */
	var getHoveredTypes = function getHoveredTypes(monitor) {
	    var targetIds = monitor.isDragging() ? monitor.getTargetIds() : [];
	
	    var overClasses = targetIds.filter(function (id) {
	        return monitor.isOverTarget(id) && monitor.canDropOnTarget(id);
	    }).map(function (id) {
	        return monitor.registry.handlers[id] && monitor.registry.handlers[id].props;
	    }).filter(function (props) {
	        return props.targetType;
	    }).map(function (props) {
	        return props.targetType;
	    });
	
	    return overClasses;
	};
	
	var createMemoisedGetHoveredTypes = function createMemoisedGetHoveredTypes() {
	    var lastHoveredTypes = [];
	
	    return function (monitor) {
	        var hoveredTypes = getHoveredTypes(monitor);
	        if (!(0, _shallowequal2.default)(lastHoveredTypes, hoveredTypes)) {
	            lastHoveredTypes = hoveredTypes;
	        }
	        return lastHoveredTypes;
	    };
	};
	
	/**
	 * Along with the usual hovered item information & position, this also determines what target types, if any, the item
	 * is hovering over and determines the appropriate classes to add.
	 */
	var createCollect = function createCollect() {
	    var memoisedGetHoveredTypes = createMemoisedGetHoveredTypes();
	    var prevCollectProps = {};
	
	    return function (monitor) {
	        if (monitor.getItemType() === _elementConstants.ELEMENT_DND_TYPE) {
	            prevCollectProps = {
	                item: monitor.getItem(),
	                itemType: monitor.getItemType(),
	                hoveredTypes: memoisedGetHoveredTypes(monitor),
	                clientOffset: monitor.getClientOffset(),
	                sourceClientOffset: monitor.getSourceClientOffset(),
	                initialSourceClientOffset: monitor.getInitialSourceClientOffset(),
	                initialClientOffset: monitor.getInitialClientOffset()
	            };
	        }
	
	        return prevCollectProps;
	    };
	};
	
	var ElementDragLayer = (_dec = (0, _reactRedux.connect)(mapStateToProps), _dec2 = (0, _reactDnd.DragLayer)(createCollect()), _dec(_class = _dec2(_class = (0, _renderThrottleDecorator2.default)(_class = function (_React$Component) {
	    _inherits(ElementDragLayer, _React$Component);
	
	    function ElementDragLayer(props) {
	        _classCallCheck(this, ElementDragLayer);
	
	        var _this = _possibleConstructorReturn(this, (ElementDragLayer.__proto__ || Object.getPrototypeOf(ElementDragLayer)).call(this, props));
	
	        _this.state = { dragOrigin: null };
	        return _this;
	    }
	
	    _createClass(ElementDragLayer, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var itemType = nextProps.itemType;
	
	            if (itemType !== _elementConstants.ELEMENT_DND_TYPE) return;
	
	            if (nextProps.initialClientOffset === this.props.initialClientOffset && this.state.dragOrigin) return;
	
	            if (nextProps.initialClientOffset) {
	                this.setState({
	                    dragOrigin: (0, _dragAndDropUtils.getElementDragOrigin)(nextProps)
	                });
	
	                return;
	            }
	
	            this.setState({ dragOrigin: null });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                item = _props.item,
	                itemType = _props.itemType;
	            var dragOrigin = this.state.dragOrigin;
	
	            var _props2 = this.props,
	                hoveredTypes = _props2.hoveredTypes,
	                rest = _objectWithoutProperties(_props2, ['hoveredTypes']); // eslint-disable-line no-unused-vars
	
	            if (itemType !== _elementConstants.ELEMENT_DND_TYPE || !item || !item.element) return null;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'ElementDragLayer' },
	                _react2.default.createElement(
	                    _ElementDragGroupPositioner2.default,
	                    this.props,
	                    _react2.default.createElement(_SelectedElementsDragPreviews2.default, _extends({}, rest, { dragOrigin: dragOrigin }))
	                )
	            );
	        }
	    }]);
	
	    return ElementDragLayer;
	}(_react2.default.Component)) || _class) || _class) || _class);
	
	
	ElementDragLayer.propTypes = {
	    currentBoardId: _propTypes2.default.string.isRequired,
	    hoveredTypes: _propTypes2.default.object,
	    monitor: _propTypes2.default.object,
	    item: _propTypes2.default.object,
	    itemType: _propTypes2.default.string,
	    gridSize: _propTypes2.default.number,
	    clientOffset: _propTypes2.default.number,
	    initialClientOffset: _propTypes2.default.number,
	    initialSourceClientOffset: _propTypes2.default.number
	};
	
	exports.default = ElementDragLayer;

/***/ }),
/* 2160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class; // Lib
	
	
	// Components
	
	
	// Constants
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDnd = __webpack_require__(72);
	
	var _ElementDragLayer = __webpack_require__(2159);
	
	var _ElementDragLayer2 = _interopRequireDefault(_ElementDragLayer);
	
	var _elementConstants = __webpack_require__(12);
	
	__webpack_require__(1264);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var workspaceDragLayerConnect = function workspaceDragLayerConnect(monitor) {
	    return {
	        isDragging: monitor.isDragging(),
	        itemType: monitor.getItemType()
	    };
	};
	
	var WorkspaceDragLayer = (_dec = (0, _reactDnd.DragLayer)(workspaceDragLayerConnect), _dec(_class = function (_React$Component) {
	    _inherits(WorkspaceDragLayer, _React$Component);
	
	    function WorkspaceDragLayer() {
	        _classCallCheck(this, WorkspaceDragLayer);
	
	        return _possibleConstructorReturn(this, (WorkspaceDragLayer.__proto__ || Object.getPrototypeOf(WorkspaceDragLayer)).apply(this, arguments));
	    }
	
	    _createClass(WorkspaceDragLayer, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                isDragging = _props.isDragging,
	                currentBoardId = _props.currentBoardId,
	                itemType = _props.itemType;
	
	            if (!isDragging && itemType !== _elementConstants.ELEMENT_DND_TYPE) return null;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'WorkspaceDragLayer' },
	                _react2.default.createElement(_ElementDragLayer2.default, { currentBoardId: currentBoardId })
	            );
	        }
	    }]);
	
	    return WorkspaceDragLayer;
	}(_react2.default.Component)) || _class);
	
	
	WorkspaceDragLayer.propTypes = {
	    currentBoardId: _propTypes2.default.string,
	    isDragging: _propTypes2.default.bool,
	    itemType: _propTypes2.default.string
	};
	
	exports.default = WorkspaceDragLayer;

/***/ }),
/* 2161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(9);
	
	var _BoardSharingUtil = __webpack_require__(784);
	
	var _BoardSharingUtil2 = _interopRequireDefault(_BoardSharingUtil);
	
	var _SavingFeedbackUtil = __webpack_require__(2166);
	
	var _SavingFeedbackUtil2 = _interopRequireDefault(_SavingFeedbackUtil);
	
	var _ExportUtil = __webpack_require__(2178);
	
	var _ExportUtil2 = _interopRequireDefault(_ExportUtil);
	
	var _BoardTitle = __webpack_require__(770);
	
	var _BoardTitle2 = _interopRequireDefault(_BoardTitle);
	
	var _ElementFilterUtil = __webpack_require__(778);
	
	var _ElementFilterUtil2 = _interopRequireDefault(_ElementFilterUtil);
	
	__webpack_require__(1267);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	var CurrentBoardHeader = function CurrentBoardHeader(_ref) {
	    var currentBoardId = _ref.currentBoardId,
	        isEditable = _ref.isEditable,
	        elementFilter = _ref.elementFilter,
	        currentBoard = _ref.currentBoard;
	    return _react2.default.createElement(
	        'div',
	        { className: 'CurrentBoardHeader' },
	        _react2.default.createElement(
	            'div',
	            { className: 'header-left' },
	            _react2.default.createElement(_SavingFeedbackUtil2.default, null)
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'header-center' },
	            _react2.default.createElement('div', { className: 'spacer' }),
	            _react2.default.createElement(_BoardTitle2.default, { currentBoardId: currentBoardId, isEditable: isEditable, currentBoard: currentBoard }),
	            _react2.default.createElement(
	                'div',
	                { className: 'title-right' },
	                _react2.default.createElement(_BoardSharingUtil2.default, { currentBoardId: currentBoardId, elementFilter: elementFilter }),
	                elementFilter ? _react2.default.createElement(_ElementFilterUtil2.default, { currentBoardId: currentBoardId, elementFilter: elementFilter }) : null
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'header-right' },
	            _react2.default.createElement(_ExportUtil2.default, { currentBoardId: currentBoardId, isEditable: isEditable })
	        )
	    );
	};
	
	// Styles
	// Lib
	
	
	CurrentBoardHeader.propTypes = {
	    currentBoardId: _propTypes2.default.string.isRequired,
	    isEditable: _propTypes2.default.bool,
	    getDocumentElementSizes: _propTypes2.default.func,
	    elementFilter: _propTypes2.default.object,
	    currentBoard: _propTypes2.default.object
	};
	
	exports.default = (0, _recompose.onlyUpdateForPropTypes)(CurrentBoardHeader);

/***/ }),
/* 2162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = exports.createBreadcrumbSelector = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class; // Lib
	
	
	// Constants
	
	
	// Actions
	
	
	// Utils
	
	// Drop Utils
	
	
	// Components
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reselect = __webpack_require__(7);
	
	var _reactRedux = __webpack_require__(3);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _elementConstants = __webpack_require__(12);
	
	var _navigationActions = __webpack_require__(27);
	
	var _popupActions = __webpack_require__(35);
	
	var _currentUserActions = __webpack_require__(84);
	
	var _permissionsService = __webpack_require__(75);
	
	var _permissionUtil = __webpack_require__(89);
	
	var _tooltipUtil = __webpack_require__(1930);
	
	var tooltipUtil = _interopRequireWildcard(_tooltipUtil);
	
	var _tooltipConstants = __webpack_require__(1929);
	
	var _makeCanDropFn = __webpack_require__(300);
	
	var _makeCanDropFn2 = _interopRequireDefault(_makeCanDropFn);
	
	var _preventLinePredicate = __webpack_require__(301);
	
	var _preventLinePredicate2 = _interopRequireDefault(_preventLinePredicate);
	
	var _preventDropOnCurrentBoardPredicate = __webpack_require__(1975);
	
	var _preventDropOnCurrentBoardPredicate2 = _interopRequireDefault(_preventDropOnCurrentBoardPredicate);
	
	var _hasCanDropPredicate = __webpack_require__(1973);
	
	var _hasCanDropPredicate2 = _interopRequireDefault(_hasCanDropPredicate);
	
	var _inboxDropLocationFn = __webpack_require__(459);
	
	var _inboxDropLocationFn2 = _interopRequireDefault(_inboxDropLocationFn);
	
	var _navigateOnHoverDecorator = __webpack_require__(727);
	
	var _navigateOnHoverDecorator2 = _interopRequireDefault(_navigateOnHoverDecorator);
	
	var _ElementDropTarget = __webpack_require__(168);
	
	var _ElementDropTarget2 = _interopRequireDefault(_ElementDropTarget);
	
	var _BreadcrumbIcon = __webpack_require__(2163);
	
	var _BreadcrumbIcon2 = _interopRequireDefault(_BreadcrumbIcon);
	
	var _PopupPanel = __webpack_require__(54);
	
	var _PopupPanel2 = _interopRequireDefault(_PopupPanel);
	
	__webpack_require__(1268);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BreadcrumbTitle = function BreadcrumbTitle(_ref) {
	    var element = _ref.element;
	    return _react2.default.createElement(
	        'div',
	        { className: 'breadcrumb-title' },
	        element && element.getIn(['content', 'title'])
	    );
	};
	
	BreadcrumbTitle.propTypes = {
	    element: _propTypes2.default.object
	};
	
	var createBreadcrumbSelector = exports.createBreadcrumbSelector = function createBreadcrumbSelector() {
	    return (0, _reselect.createSelector)(function (state) {
	        return state.get('elements');
	    }, function (state, props) {
	        return props.elementId;
	    }, function (state, props) {
	        return state.getIn(['app', 'currentUser', 'rootBoardId']);
	    }, function (state, props) {
	        return state.getIn(['app', 'currentUser']);
	    }, function (state, props) {
	        return props.currentBoardId;
	    }, (0, _permissionsService.createElementUserPermissionsSelector)(), _permissionsService.currentBoardUserPermissionsSelector, function (elements, elementId, rootBoardId, currentUser, currentBoardId, breadcrumbPermissions, currentBoardPermissions) {
	        var canDrop = (0, _permissionUtil.canWrite)(breadcrumbPermissions) && (0, _permissionUtil.canWrite)(currentBoardPermissions) && (0, _permissionUtil.canSave)(breadcrumbPermissions) === (0, _permissionUtil.canSave)(currentBoardPermissions);
	
	        return {
	            element: elements.get(elementId),
	            isRoot: elementId === rootBoardId,
	            canDrop: canDrop,
	            isCurrentBoard: elementId === currentBoardId,
	            currentUser: currentUser,
	            // This supports the hover navigate functionality
	            dropPermitted: canDrop
	        };
	    });
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        dispatchNavigateToBoard: function dispatchNavigateToBoard(boardId, keepSelection) {
	            return dispatch((0, _navigationActions.navigateToBoard)({ boardId: boardId, keepSelection: keepSelection }));
	        },
	        showTooltip: function showTooltip() {
	            return dispatch((0, _popupActions.openPopup)('tooltip-breadcrumb'));
	        },
	        updateUser: function updateUser(action) {
	            return dispatch((0, _currentUserActions.updateCurrentUser)(action));
	        }
	    };
	};
	
	var dropTargetConfig = {
	    drop: _inboxDropLocationFn2.default,
	    canDrop: (0, _makeCanDropFn2.default)([_hasCanDropPredicate2.default, _preventDropOnCurrentBoardPredicate2.default, _preventLinePredicate2.default])
	};
	
	var Breadcrumb = (_dec = (0, _reactRedux.connect)(createBreadcrumbSelector, mapDispatchToProps), _dec2 = (0, _ElementDropTarget2.default)(dropTargetConfig, _elementConstants.DROP_TARGET_TYPES.BREADCRUMB), _dec(_class = _dec2(_class = (0, _navigateOnHoverDecorator2.default)(_class = function (_React$Component) {
	    _inherits(Breadcrumb, _React$Component);
	
	    function Breadcrumb() {
	        var _ref2;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Breadcrumb);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Breadcrumb.__proto__ || Object.getPrototypeOf(Breadcrumb)).call.apply(_ref2, [this].concat(args))), _this), _this.navigateToBoard = function (event) {
	            var _this$props = _this.props,
	                currentBoardId = _this$props.currentBoardId,
	                elementId = _this$props.elementId,
	                dispatchNavigateToBoard = _this$props.dispatchNavigateToBoard;
	
	
	            event.preventDefault();
	
	            if (currentBoardId === elementId) return;
	
	            dispatchNavigateToBoard(elementId);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Breadcrumb, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _props = this.props,
	                index = _props.index,
	                showTooltip = _props.showTooltip,
	                isCurrentBoard = _props.isCurrentBoard,
	                currentUser = _props.currentUser,
	                updateUser = _props.updateUser;
	
	
	            if (index === 0 && isCurrentBoard && !nextProps.isCurrentBoard && !tooltipUtil.hasSeen(currentUser.get('education'), _tooltipConstants.TOOLTIP_CODES.BREADCRUMB)) {
	                showTooltip();
	
	                updateUser({
	                    userId: currentUser.get('_id'),
	                    changes: {
	                        education: tooltipUtil.markAsSeen(currentUser.get('education'), _tooltipConstants.TOOLTIP_CODES.BREADCRUMB)
	                    }
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                elementId = _props2.elementId,
	                connectDropTarget = _props2.connectDropTarget,
	                canDrop = _props2.canDrop,
	                isHovered = _props2.isHovered,
	                isCurrentBoard = _props2.isCurrentBoard,
	                index = _props2.index,
	                showNavigationFeedback = _props2.showNavigationFeedback;
	
	
	            var linkURL = '/' + elementId;
	
	            var classes = (0, _classnames2.default)('Breadcrumb', {
	                'can-drop': canDrop,
	                hovered: isHovered,
	                current: isCurrentBoard,
	                'pre-nav': showNavigationFeedback
	            });
	
	            if (isCurrentBoard) {
	                return _react2.default.createElement(
	                    'li',
	                    { className: classes },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'BreadcrumbContents' },
	                        _react2.default.createElement(_BreadcrumbIcon2.default, this.props),
	                        _react2.default.createElement(BreadcrumbTitle, this.props)
	                    )
	                );
	            }
	
	            var popup = void 0;
	            if (index === 0) {
	                popup = _react2.default.createElement(
	                    _PopupPanel2.default,
	                    { className: 'tooltip',
	                        popupId: 'tooltip-breadcrumb',
	                        arrowDir: 'top',
	                        fadeIn: true },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        'Click to go back'
	                    )
	                );
	            }
	
	            return connectDropTarget(_react2.default.createElement(
	                'li',
	                { className: classes },
	                _react2.default.createElement(
	                    'a',
	                    { className: 'BreadcrumbContents', href: linkURL, onClick: this.navigateToBoard },
	                    _react2.default.createElement(_BreadcrumbIcon2.default, this.props),
	                    _react2.default.createElement(BreadcrumbTitle, this.props),
	                    popup
	                )
	            ));
	        }
	    }]);
	
	    return Breadcrumb;
	}(_react2.default.Component)) || _class) || _class) || _class);
	exports.default = Breadcrumb;
	
	
	Breadcrumb.propTypes = {
	    elementId: _propTypes2.default.string.isRequired,
	    currentBoardId: _propTypes2.default.string.isRequired,
	    element: _propTypes2.default.object,
	    dispatchNavigateToBoard: _propTypes2.default.func,
	    connectDropTarget: _propTypes2.default.func,
	    canDrop: _propTypes2.default.bool,
	    isCurrentBoard: _propTypes2.default.bool,
	    isHovered: _propTypes2.default.bool,
	    isRoot: _propTypes2.default.bool,
	    showTooltip: _propTypes2.default.func,
	    index: _propTypes2.default.number,
	    currentUser: _propTypes2.default.object,
	    updateUser: _propTypes2.default.func,
	    showNavigationFeedback: _propTypes2.default.bool
	};

/***/ }),
/* 2163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _colorHelper = __webpack_require__(319);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BreadcrumbIcon = function BreadcrumbIcon(_ref) {
	    var element = _ref.element,
	        isRoot = _ref.isRoot;
	
	    if (!element) return null;
	
	    var iconStyle = {};
	
	    var colorName = element.getIn(['content', 'color']);
	    var hexValue = (0, _colorHelper.getColorHexValue)(colorName);
	
	    if (hexValue) {
	        iconStyle.backgroundColor = (0, _colorHelper.getColorHexValue)(colorName);
	    }
	
	    if (isRoot) {
	        iconStyle.backgroundColor = 'transparent';
	    }
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'breadcrumb-icon', style: iconStyle },
	        isRoot ? _react2.default.createElement(_Icon2.default, { name: 'milanote-logo-small' }) : null
	    );
	};
	
	// Utils
	
	
	BreadcrumbIcon.propTypes = {
	    element: _propTypes2.default.object,
	    isRoot: _propTypes2.default.bool
	};
	
	exports.default = BreadcrumbIcon;

/***/ }),
/* 2164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class; // Lib
	
	
	// Components
	
	
	// Actions
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _Breadcrumb = __webpack_require__(2162);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _boardService = __webpack_require__(167);
	
	var boardService = _interopRequireWildcard(_boardService);
	
	__webpack_require__(1269);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        fetchBoard: function fetchBoard(argObj) {
	            return dispatch(boardService.fetchBoard(argObj));
	        }
	    };
	};
	
	var CompleteBreadcrumbList = function CompleteBreadcrumbList(_ref) {
	    var currentBoardId = _ref.currentBoardId,
	        breadcrumbObj = _ref.breadcrumbObj,
	        isMobileView = _ref.isMobileView;
	
	    var breadcrumbs = isMobileView ? breadcrumbObj.path.slice(-2, -1) : breadcrumbObj.path;
	
	    return _react2.default.createElement(
	        'ul',
	        null,
	        breadcrumbs.map(function (breadcrumb, index) {
	            return _react2.default.createElement(_Breadcrumb2.default, {
	                key: breadcrumb,
	                elementId: breadcrumb,
	                currentBoardId: currentBoardId,
	                index: index });
	        })
	    );
	};
	
	CompleteBreadcrumbList.propTypes = {
	    currentBoardId: _propTypes2.default.string.isRequired,
	    breadcrumbObj: _propTypes2.default.object,
	    isMobileView: _propTypes2.default.bool
	
	};
	
	var IncompleteList = function IncompleteList(_ref2) {
	    var rootBoardId = _ref2.rootBoardId,
	        currentBoardId = _ref2.currentBoardId;
	    return _react2.default.createElement(
	        'ul',
	        null,
	        rootBoardId ? _react2.default.createElement(_Breadcrumb2.default, { key: rootBoardId, elementId: rootBoardId, currentBoardId: currentBoardId, index: 0 }) : null,
	        _react2.default.createElement(_Breadcrumb2.default, { key: currentBoardId, elementId: currentBoardId, currentBoardId: currentBoardId, index: 1 })
	    );
	};
	
	IncompleteList.propTypes = {
	    currentBoardId: _propTypes2.default.string.isRequired,
	    rootBoardId: _propTypes2.default.string
	};
	
	var BreadcrumbList = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec(_class = function (_React$Component) {
	    _inherits(BreadcrumbList, _React$Component);
	
	    function BreadcrumbList() {
	        _classCallCheck(this, BreadcrumbList);
	
	        return _possibleConstructorReturn(this, (BreadcrumbList.__proto__ || Object.getPrototypeOf(BreadcrumbList)).apply(this, arguments));
	    }
	
	    _createClass(BreadcrumbList, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var fetchBoard = nextProps.fetchBoard,
	                breadcrumbObj = nextProps.breadcrumbObj;
	
	
	            if (breadcrumbObj.complete) return;
	
	            breadcrumbObj.missingElementIds.map(function (missingElementId) {
	                return fetchBoard({ boardId: missingElementId, loadNextBoards: false, loadAncestors: true });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var complete = this.props.breadcrumbObj.complete;
	
	
	            return _react2.default.createElement(
	                'nav',
	                { className: 'BreadcrumbList' },
	                complete ? _react2.default.createElement(CompleteBreadcrumbList, this.props) : _react2.default.createElement(IncompleteList, this.props)
	            );
	        }
	    }]);
	
	    return BreadcrumbList;
	}(_react2.default.Component)) || _class);
	exports.default = BreadcrumbList;
	
	
	BreadcrumbList.propTypes = {
	    fetchBoard: _propTypes2.default.func,
	    breadcrumbObj: _propTypes2.default.object,
	    currentBoardId: _propTypes2.default.string.isRequired,
	    rootBoardId: _propTypes2.default.string
	};

/***/ }),
/* 2165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _userUtil = __webpack_require__(31);
	
	var _ElectronLink = __webpack_require__(427);
	
	var _ElectronLink2 = _interopRequireDefault(_ElectronLink);
	
	__webpack_require__(1271);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReferUtil = function ReferUtil(_ref) {
	    var navigateToRefer = _ref.navigateToRefer,
	        currentUser = _ref.currentUser;
	
	    if ((0, _userUtil.isGuest)(currentUser) || (0, _userUtil.isSubscribed)(currentUser)) return null;
	
	    return _react2.default.createElement(
	        _ElectronLink2.default,
	        { to: '/account/refer', className: 'PillButton ReferUtil' },
	        'Refer a friend, get more space'
	    );
	};
	
	ReferUtil.propTypes = {
	    currentUser: _propTypes2.default.object,
	    navigateToRefer: _propTypes2.default.func
	};
	
	exports.default = ReferUtil;

/***/ }),
/* 2166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(4);
	
	var _reactRedux = __webpack_require__(3);
	
	__webpack_require__(1272);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        lastAction: state.get('lastSaved')
	    };
	};
	
	var SavingFeedbackUtil = (_dec = (0, _reactRedux.connect)(mapStateToProps), _dec(_class = function (_React$Component) {
	    _inherits(SavingFeedbackUtil, _React$Component);
	
	    function SavingFeedbackUtil(props) {
	        _classCallCheck(this, SavingFeedbackUtil);
	
	        var _this = _possibleConstructorReturn(this, (SavingFeedbackUtil.__proto__ || Object.getPrototypeOf(SavingFeedbackUtil)).call(this, props));
	
	        _this.state = {
	            showLoading: false,
	            hidden: true
	        };
	
	        _this.stopSaving = (0, _lodash.debounce)(function () {
	            _this.setState({ showLoading: false });
	            _this.hide();
	        }, 2000);
	
	        _this.hide = (0, _lodash.debounce)(function () {
	            _this.setState({ hidden: true });
	        }, 4000);
	        return _this;
	    }
	
	    _createClass(SavingFeedbackUtil, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.lastAction !== this.props.lastAction) {
	                this.setState({ showLoading: true, hidden: false });
	                this.stopSaving();
	                this.hide.cancel();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.stopSaving.cancel();
	            this.hide.cancel();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _state = this.state,
	                showLoading = _state.showLoading,
	                hidden = _state.hidden;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('SavingFeedbackUtil', { hidden: hidden }) },
	                showLoading ? _react2.default.createElement(
	                    'span',
	                    { className: 'saving' },
	                    'Saving...'
	                ) : _react2.default.createElement(
	                    'span',
	                    { className: 'save' },
	                    'Saved'
	                )
	            );
	        }
	    }]);
	
	    return SavingFeedbackUtil;
	}(_react2.default.Component)) || _class);
	exports.default = SavingFeedbackUtil;
	
	
	SavingFeedbackUtil.propTypes = {
	    lastAction: _propTypes2.default.bool
	};

/***/ }),
/* 2167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PopupPanel = __webpack_require__(54);
	
	var _PopupPanel2 = _interopRequireDefault(_PopupPanel);
	
	var _FormButton = __webpack_require__(60);
	
	var _FormButton2 = _interopRequireDefault(_FormButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GuestPopup = function GuestPopup(props) {
	    return _react2.default.createElement(
	        _PopupPanel2.default,
	        _extends({ popupId: 'user' }, props),
	        _react2.default.createElement(
	            'p',
	            { className: 'user-name' },
	            'Guest user'
	        ),
	        _react2.default.createElement(
	            _FormButton2.default,
	            { className: 'primary', onClickFn: props.login },
	            'Sign in'
	        )
	    );
	};
	
	GuestPopup.propTypes = {
	    login: _propTypes2.default.func
	};
	
	exports.default = GuestPopup;

/***/ }),
/* 2168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Components
	
	
	// Actions
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(45);
	
	var _LinkButton = __webpack_require__(74);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	var _PopupPanel = __webpack_require__(54);
	
	var _PopupPanel2 = _interopRequireDefault(_PopupPanel);
	
	var _AvatarPicker = __webpack_require__(2170);
	
	var _AvatarPicker2 = _interopRequireDefault(_AvatarPicker);
	
	var _BillingStatusDisplay = __webpack_require__(2171);
	
	var _BillingStatusDisplay2 = _interopRequireDefault(_BillingStatusDisplay);
	
	var _UserPlanBadge = __webpack_require__(446);
	
	var _UserPlanBadge2 = _interopRequireDefault(_UserPlanBadge);
	
	var _ElectronVisible = __webpack_require__(1755);
	
	var _ElectronVisible2 = _interopRequireDefault(_ElectronVisible);
	
	var _ElectronAppStatus = __webpack_require__(2173);
	
	var _ElectronAppStatus2 = _interopRequireDefault(_ElectronAppStatus);
	
	var _authActions = __webpack_require__(421);
	
	var authActions = _interopRequireWildcard(_authActions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        logout: function logout() {
	            return dispatch(authActions.logout());
	        }
	    };
	};
	
	var AccountUserPopup = function AccountUserPopup(props) {
	    var currentUser = props.currentUser,
	        logout = props.logout;
	
	
	    return _react2.default.createElement(
	        _PopupPanel2.default,
	        _extends({}, props, { className: 'AccountPopup', popupId: 'user' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'header' },
	            _react2.default.createElement(
	                'div',
	                { className: 'user-details' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'user-name' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'name' },
	                        currentUser.getIn(['name', 'displayName'])
	                    ),
	                    _react2.default.createElement(_UserPlanBadge2.default, { user: currentUser })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'email' },
	                    currentUser.get('email')
	                )
	            ),
	            _react2.default.createElement(_AvatarPicker2.default, { user: currentUser })
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'setting-links' },
	            _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/account/settings' },
	                'Account settings'
	            ),
	            _react2.default.createElement(
	                _LinkButton2.default,
	                { onClickFn: logout },
	                'Log out'
	            )
	        ),
	        _react2.default.createElement(_BillingStatusDisplay2.default, props),
	        _react2.default.createElement(
	            _ElectronVisible2.default,
	            null,
	            _react2.default.createElement(_ElectronAppStatus2.default, null)
	        )
	    );
	};
	
	AccountUserPopup.propTypes = {
	    currentUser: _propTypes2.default.object.isRequired,
	    logout: _propTypes2.default.func
	};
	
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(AccountUserPopup);

/***/ }),
/* 2169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	// Components
	
	
	// Actions
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _recompose = __webpack_require__(9);
	
	var _Button = __webpack_require__(34);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _UserAvatar = __webpack_require__(199);
	
	var _UserAvatar2 = _interopRequireDefault(_UserAvatar);
	
	var _AccountPopup = __webpack_require__(771);
	
	var _AccountPopup2 = _interopRequireDefault(_AccountPopup);
	
	var _BillingAlertPopup = __webpack_require__(772);
	
	var _BillingAlertPopup2 = _interopRequireDefault(_BillingAlertPopup);
	
	var _ElectronAppUpdateNotify = __webpack_require__(2174);
	
	var _ElectronAppUpdateNotify2 = _interopRequireDefault(_ElectronAppUpdateNotify);
	
	var _popupActions = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        currentUser: state.getIn(['app', 'currentUser'])
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        openPopupPanel: function openPopupPanel() {
	            return dispatch((0, _popupActions.togglePopup)('user'));
	        }
	    };
	};
	
	var AccountUtil = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec2 = (0, _recompose.onlyUpdateForKeys)(['currentUser']), _dec(_class = _dec2(_class = function (_React$Component) {
	    _inherits(AccountUtil, _React$Component);
	
	    function AccountUtil() {
	        _classCallCheck(this, AccountUtil);
	
	        return _possibleConstructorReturn(this, (AccountUtil.__proto__ || Object.getPrototypeOf(AccountUtil)).apply(this, arguments));
	    }
	
	    _createClass(AccountUtil, [{
	        key: 'render',
	        value: function render() {
	            var currentUser = this.props.currentUser;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'HeaderUtil' },
	                _react2.default.createElement(
	                    _Button2.default,
	                    { className: 'highlight', onClickFn: this.props.openPopupPanel },
	                    _react2.default.createElement(_UserAvatar2.default, { user: currentUser }),
	                    _react2.default.createElement(_ElectronAppUpdateNotify2.default, null)
	                ),
	                _react2.default.createElement(_AccountPopup2.default, null),
	                _react2.default.createElement(_BillingAlertPopup2.default, null)
	            );
	        }
	    }]);
	
	    return AccountUtil;
	}(_react2.default.Component)) || _class) || _class);
	
	
	AccountUtil.propTypes = {
	    currentUser: _propTypes2.default.object,
	    openPopupPanel: _propTypes2.default.func
	};
	
	exports.default = AccountUtil;

/***/ }),
/* 2170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class; // Lib
	
	// TODO 944 - Remove when user image design is completed
	// import ReactDOM from 'react-dom';
	
	
	// Components
	
	
	// Components
	
	
	// Actions
	
	
	// Utils
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _UserAvatar = __webpack_require__(199);
	
	var _UserAvatar2 = _interopRequireDefault(_UserAvatar);
	
	var _ImageFileInput = __webpack_require__(444);
	
	var _ImageFileInput2 = _interopRequireDefault(_ImageFileInput);
	
	var _Overlay = __webpack_require__(711);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _currentUserActions = __webpack_require__(84);
	
	var _fileValidator = __webpack_require__(238);
	
	__webpack_require__(1275);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        dispatchUploadCurrentUserAvatar: function dispatchUploadCurrentUserAvatar(userId, imageFile) {
	            return dispatch((0, _currentUserActions.uploadCurrentUserAvatar)(userId, imageFile));
	        }
	    };
	};
	
	var AvatarPicker = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec(_class = function (_React$Component) {
	    _inherits(AvatarPicker, _React$Component);
	
	    function AvatarPicker(props) {
	        _classCallCheck(this, AvatarPicker);
	
	        var _this = _possibleConstructorReturn(this, (AvatarPicker.__proto__ || Object.getPrototypeOf(AvatarPicker)).call(this, props));
	
	        _this.openFileSelect = _this.openFileSelect.bind(_this);
	        _this.uploadImage = _this.uploadImage.bind(_this);
	        return _this;
	    }
	
	    /**
	     * Delegates the click event on the fake file upload input to the real, hidden one.
	     */
	
	
	    _createClass(AvatarPicker, [{
	        key: 'openFileSelect',
	        value: function openFileSelect(event) {
	            // TODO 944 - Remove when user image design is completed
	            // const { imageFileInput } = this.refs;
	            // const fileInputDomNode = ReactDOM.findDOMNode(imageFileInput);
	            // fileInputDomNode.click();
	        }
	    }, {
	        key: 'uploadImage',
	        value: function uploadImage(imageFile) {
	            var _props = this.props,
	                user = _props.user,
	                dispatchUploadCurrentUserAvatar = _props.dispatchUploadCurrentUserAvatar;
	
	
	            var validationErrors = (0, _fileValidator.validateImageFile)(imageFile);
	            if (validationErrors) {
	                // TODO if validation errors, show them to the user
	                return;
	            }
	
	            dispatchUploadCurrentUserAvatar(user.get('_id'), imageFile);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var user = this.props.user;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'AvatarPicker', onClick: this.openFileSelect },
	                _react2.default.createElement(_ImageFileInput2.default, { ref: 'imageFileInput', id: 'avatar', uploadImage: this.uploadImage }),
	                _react2.default.createElement(_UserAvatar2.default, { user: user, size: 'large' }),
	                _react2.default.createElement(
	                    _Overlay2.default,
	                    null,
	                    'Change'
	                )
	            );
	        }
	    }]);
	
	    return AvatarPicker;
	}(_react2.default.Component)) || _class);
	
	
	AvatarPicker.propTypes = {
	    user: _propTypes2.default.object.isRequired,
	    uploadUserAvatar: _propTypes2.default.func,
	    dispatchUploadCurrentUserAvatar: _propTypes2.default.func
	};
	
	exports.default = AvatarPicker;

/***/ }),
/* 2171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _BillingTierFree = __webpack_require__(773);
	
	var _BillingTierFree2 = _interopRequireDefault(_BillingTierFree);
	
	var _BillingTierPro = __webpack_require__(2172);
	
	var _BillingTierPro2 = _interopRequireDefault(_BillingTierPro);
	
	var _userUtil = __webpack_require__(31);
	
	__webpack_require__(1276);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BillingStatusDisplay = function BillingStatusDisplay(props) {
	    return (0, _userUtil.isSubscribed)(props.currentUser) ? _react2.default.createElement(_BillingTierPro2.default, props) : _react2.default.createElement(_BillingTierFree2.default, props);
	};
	
	BillingStatusDisplay.propTypes = {
	    currentUser: _propTypes2.default.object
	};
	
	exports.default = BillingStatusDisplay;

/***/ }),
/* 2172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ElectronLink = __webpack_require__(427);
	
	var _ElectronLink2 = _interopRequireDefault(_ElectronLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BillingTierPro = function BillingTierPro(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'BillingStatusDisplay BillingTierPro' },
	        _react2.default.createElement(
	            'div',
	            { className: 'plan-status' },
	            'You\'re on the\xA0',
	            _react2.default.createElement(
	                'span',
	                { className: 'plan-name' },
	                props.currentUser.getIn(['subscription', 'planName']),
	                ' Plan'
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'plan-storage' },
	            'Unlimited storage'
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'plan-actions' },
	            _react2.default.createElement(
	                _ElectronLink2.default,
	                { to: '/account/plan', className: 'action' },
	                'View billing details'
	            )
	        )
	    );
	};
	
	BillingTierPro.propTypes = {
	    currentUser: _propTypes2.default.object.isRequired
	};
	
	exports.default = BillingTierPro;

/***/ }),
/* 2173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _electronActions = __webpack_require__(2263);
	
	var _Spinner = __webpack_require__(65);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _LinkButton = __webpack_require__(74);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	var _electronUpdateSelector = __webpack_require__(775);
	
	var _electronUpdateSelector2 = _interopRequireDefault(_electronUpdateSelector);
	
	var _electronConstants = __webpack_require__(321);
	
	__webpack_require__(1278);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        dispatchInstallUpdate: function dispatchInstallUpdate() {
	            return dispatch((0, _electronActions.autoUpdateInstallUpdate)());
	        },
	        dispatchForcePoll: function dispatchForcePoll() {
	            return dispatch((0, _electronActions.autoUpdateForcePoll)());
	        }
	    };
	};
	
	var UpdateStatus = function UpdateStatus(_ref) {
	    var autoUpdate = _ref.autoUpdate,
	        dispatchInstallUpdate = _ref.dispatchInstallUpdate,
	        dispatchForcePoll = _ref.dispatchForcePoll;
	
	    switch (autoUpdate) {
	        case _electronConstants.AUTOUPDATE_STATE.DOWNLOADING:
	            return _react2.default.createElement(
	                'div',
	                { className: 'downloading' },
	                _react2.default.createElement(_Spinner2.default, { show: true }),
	                ' ',
	                'Downloading update...'
	            );
	        case _electronConstants.AUTOUPDATE_STATE.CHECKING:
	            return _react2.default.createElement(
	                'div',
	                { className: 'downloading' },
	                _react2.default.createElement(_Spinner2.default, { show: true }),
	                ' ',
	                'Checking for update...'
	            );
	        case _electronConstants.AUTOUPDATE_STATE.READY:
	            return _react2.default.createElement(
	                'div',
	                { className: 'ready' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 'bullet' },
	                    '\u25CF'
	                ),
	                ' ',
	                _react2.default.createElement(
	                    _LinkButton2.default,
	                    { onClickFn: dispatchInstallUpdate },
	                    'Install update'
	                ),
	                ' ',
	                '(this will restart the app)'
	            );
	        case _electronConstants.AUTOUPDATE_STATE.ERROR:
	            return _react2.default.createElement(
	                'div',
	                { className: 'error' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 'bullet' },
	                    '\u25B2'
	                ),
	                ' Error downloading update',
	                ' ',
	                _react2.default.createElement(
	                    _LinkButton2.default,
	                    { onClickFn: dispatchForcePoll },
	                    'Retry'
	                )
	            );
	        default:
	            return _react2.default.createElement(
	                'div',
	                { className: 'up-to-date' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 'bullet' },
	                    '\u2714\uFE0E'
	                ),
	                ' Up to date'
	            );
	    }
	};
	
	var ElectronAppStatus = function ElectronAppStatus(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'ElectronAppStatus' },
	        _react2.default.createElement(
	            'div',
	            null,
	            'Milanote version ',
	            _react2.default.createElement(
	                'strong',
	                null,
	                props.version
	            )
	        ),
	        _react2.default.createElement(UpdateStatus, props)
	    );
	};
	
	ElectronAppStatus.propTypes = UpdateStatus.propTypes = {
	    autoUpdate: _react2.default.PropTypes.string,
	    version: _react2.default.PropTypes.string,
	    dispatchInstallUpdate: _react2.default.PropTypes.func,
	    dispatchForcePoll: _react2.default.PropTypes.func
	};
	
	exports.default = (0, _reactRedux.connect)(_electronUpdateSelector2.default, mapDispatchToProps)(ElectronAppStatus);

/***/ }),
/* 2174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _electronUpdateSelector = __webpack_require__(775);
	
	var _electronUpdateSelector2 = _interopRequireDefault(_electronUpdateSelector);
	
	__webpack_require__(1279);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ElectronAppUpdateNotify = function ElectronAppUpdateNotify(_ref) {
	    var updateReady = _ref.updateReady;
	
	    if (!updateReady) return null;
	
	    return _react2.default.createElement('div', { className: 'ElectronAppUpdateNotify' });
	};
	
	ElectronAppUpdateNotify.propTypes = {
	    updateReady: _react2.default.PropTypes.bool
	};
	
	exports.default = (0, _reactRedux.connect)(_electronUpdateSelector2.default)(ElectronAppUpdateNotify);

/***/ }),
/* 2175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class; // Lib
	
	
	// Actions
	
	
	// Components
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _currentUserActions = __webpack_require__(84);
	
	var _EmailPreferenceToggle = __webpack_require__(776);
	
	var _EmailPreferenceToggle2 = _interopRequireDefault(_EmailPreferenceToggle);
	
	__webpack_require__(557);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        toggleEmailPreference: function toggleEmailPreference(userId, emailPreference) {
	            return dispatch((0, _currentUserActions.updateCurrentUser)({
	                userId: userId,
	                changes: {
	                    settings: {
	                        email: emailPreference
	                    }
	                }
	            }));
	        }
	    };
	};
	
	var EmailPreferenceToggleContainer = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec(_class = function (_React$Component) {
	    _inherits(EmailPreferenceToggleContainer, _React$Component);
	
	    function EmailPreferenceToggleContainer(props) {
	        _classCallCheck(this, EmailPreferenceToggleContainer);
	
	        var _this = _possibleConstructorReturn(this, (EmailPreferenceToggleContainer.__proto__ || Object.getPrototypeOf(EmailPreferenceToggleContainer)).call(this, props));
	
	        _this.updatePreference = _this.updatePreference.bind(_this);
	        return _this;
	    }
	
	    _createClass(EmailPreferenceToggleContainer, [{
	        key: 'updatePreference',
	        value: function updatePreference() {
	            var _props = this.props,
	                emailPreferenceEntry = _props.emailPreferenceEntry,
	                currentUser = _props.currentUser,
	                toggleEmailPreference = _props.toggleEmailPreference;
	
	            var currentEmailPreference = currentUser.getIn(['settings', 'email']);
	            var newEmailPreference = currentEmailPreference ^ emailPreferenceEntry.value;
	
	            toggleEmailPreference(currentUser.get('_id'), newEmailPreference);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                currentUser = _props2.currentUser,
	                emailPreferenceEntry = _props2.emailPreferenceEntry;
	
	            var usersEmailPreferences = currentUser.getIn(['settings', 'email']);
	
	            return _react2.default.createElement(_EmailPreferenceToggle2.default, {
	                updatePreference: this.updatePreference,
	                active: !!(usersEmailPreferences & emailPreferenceEntry.value),
	                value: emailPreferenceEntry.value,
	                label: emailPreferenceEntry.label });
	        }
	    }]);
	
	    return EmailPreferenceToggleContainer;
	}(_react2.default.Component)) || _class);
	
	
	EmailPreferenceToggleContainer.propTypes = {
	    toggleEmailPreference: _propTypes2.default.func,
	    currentUser: _propTypes2.default.object.isRequired,
	    emailPreferenceEntry: _propTypes2.default.object.isRequired
	};
	
	exports.default = EmailPreferenceToggleContainer;

/***/ }),
/* 2176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Components
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PopupPanel = __webpack_require__(54);
	
	var _PopupPanel2 = _interopRequireDefault(_PopupPanel);
	
	var _ExportPopupButton = __webpack_require__(2177);
	
	var _ExportPopupButton2 = _interopRequireDefault(_ExportPopupButton);
	
	__webpack_require__(1281);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExportPopup = function ExportPopup(props) {
	    return _react2.default.createElement(
	        _PopupPanel2.default,
	        _extends({}, props, {
	            popupId: 'export',
	            className: 'ExportPopup' }),
	        _react2.default.createElement(_ExportPopupButton2.default, _extends({}, props, {
	            className: 'pdf',
	            iconName: 'export-pdf',
	            format: 'pdf-html',
	            title: 'Canvas (PDF)' })),
	        _react2.default.createElement(
	            'div',
	            { className: 'document-title' },
	            'Save as document'
	        ),
	        _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(_ExportPopupButton2.default, _extends({}, props, {
	                    className: 'pdf',
	                    iconName: 'export-pdf',
	                    format: 'pdf',
	                    title: 'PDF' }))
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(_ExportPopupButton2.default, _extends({}, props, {
	                    iconName: 'export-word',
	                    format: 'docx',
	                    title: 'Word' }))
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(_ExportPopupButton2.default, _extends({}, props, {
	                    iconName: 'export-markdown',
	                    format: 'md',
	                    title: 'Markdown' }))
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(_ExportPopupButton2.default, _extends({}, props, {
	                    iconName: 'export-text',
	                    format: 'txt',
	                    title: 'Plain text' }))
	            )
	        )
	    );
	};
	
	ExportPopup.propTypes = {
	    handlePDFExport: _propTypes2.default.func,
	    handleMarkdownExport: _propTypes2.default.func,
	    handleDocxExport: _propTypes2.default.func
	};
	
	exports.default = ExportPopup;

/***/ }),
/* 2177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reselect = __webpack_require__(7);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _recompose = __webpack_require__(9);
	
	var _Button = __webpack_require__(34);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Spinner = __webpack_require__(65);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _exportPopupActions = __webpack_require__(2179);
	
	var _analytics = __webpack_require__(47);
	
	var _exportConstants = __webpack_require__(317);
	
	__webpack_require__(1282);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var exportButtonSelector = (0, _reselect.createSelector)(function (state, ownProps) {
	    return state.getIn(['app', 'popup', 'exporting', ownProps.format]);
	}, function (buttonState) {
	    return {
	        fetching: buttonState === _exportConstants.EXPORT_BOARD_STATES.FETCHING,
	        fetched: buttonState && buttonState !== _exportConstants.EXPORT_BOARD_STATES.FETCHING && buttonState !== _exportConstants.EXPORT_BOARD_STATES.FAILED,
	        url: buttonState
	    };
	});
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        dispatchExportBoard: function dispatchExportBoard(_ref) {
	            var boardId = _ref.boardId,
	                format = _ref.format;
	            return dispatch((0, _exportPopupActions.exportBoard)({ boardId: boardId, format: format }));
	        }
	    };
	};
	
	var exportButtonHandlers = {
	    handleButtonClick: function handleButtonClick(props) {
	        return function () {
	            var dispatchExportBoard = props.dispatchExportBoard,
	                fetching = props.fetching,
	                fetched = props.fetched,
	                url = props.url,
	                currentBoardId = props.currentBoardId,
	                format = props.format;
	
	
	            if (fetched && url) return (0, _exportPopupActions.triggerDownload)(url);
	
	            (0, _analytics.analyticsEvent)('exported-board-' + format);
	
	            if (!fetching) return dispatchExportBoard({ boardId: currentBoardId, format: format });
	        };
	    }
	};
	
	var ExportPopupButton = function ExportPopupButton(props) {
	    var iconName = props.iconName,
	        title = props.title,
	        handleButtonClick = props.handleButtonClick,
	        className = props.className,
	        fetching = props.fetching,
	        fetched = props.fetched;
	
	
	    return _react2.default.createElement(
	        _Button2.default,
	        { onClickFn: handleButtonClick, className: (0, _classnames2.default)('ExportPopupButton', className) },
	        _react2.default.createElement(
	            'div',
	            { className: 'export-button-content' },
	            _react2.default.createElement(
	                'div',
	                { className: 'left' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'icon' },
	                    _react2.default.createElement(_Icon2.default, { name: iconName })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'title' },
	                    title
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'right' },
	                fetching ? _react2.default.createElement(
	                    'div',
	                    { className: 'fetching' },
	                    _react2.default.createElement(_Spinner2.default, { show: true }),
	                    ' ',
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        'Generating'
	                    )
	                ) : null,
	                fetched ? _react2.default.createElement(
	                    'div',
	                    { className: 'download' },
	                    'Download'
	                ) : null
	            )
	        )
	    );
	};
	
	ExportPopupButton.propTypes = {
	    iconName: _propTypes2.default.string.isRequired,
	    title: _propTypes2.default.string.isRequired,
	    format: _propTypes2.default.string.isRequired,
	    currentBoardId: _propTypes2.default.string.isRequired,
	    className: _propTypes2.default.string,
	    fetching: _propTypes2.default.bool,
	    fetched: _propTypes2.default.bool,
	    url: _propTypes2.default.string,
	    dispatchExportBoard: _propTypes2.default.func,
	    handleButtonClick: _propTypes2.default.func
	};
	
	var enhance = (0, _recompose.compose)((0, _reactRedux.connect)(exportButtonSelector, mapDispatchToProps), (0, _recompose.withHandlers)(exportButtonHandlers));
	
	exports.default = enhance(ExportPopupButton);

/***/ }),
/* 2178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _recompose = __webpack_require__(9);
	
	var _ToolButton = __webpack_require__(676);
	
	var _ToolButton2 = _interopRequireDefault(_ToolButton);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ExportPopup = __webpack_require__(2176);
	
	var _ExportPopup2 = _interopRequireDefault(_ExportPopup);
	
	var _popupActions = __webpack_require__(35);
	
	__webpack_require__(1283);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Actions
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        openPopupPanel: function openPopupPanel() {
	            return dispatch((0, _popupActions.togglePopup)('export'));
	        }
	    };
	};
	
	// Components
	// Lib
	
	
	var ExportUtil = function ExportUtil(props) {
	    var openPopupPanel = props.openPopupPanel;
	
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'ExportUtil' },
	        _react2.default.createElement(_ToolButton2.default, { onClickFn: openPopupPanel, icon: _react2.default.createElement(_Icon2.default, { name: 'nav-export' }), text: 'Export' }),
	        _react2.default.createElement(_ExportPopup2.default, props)
	    );
	};
	
	ExportUtil.propTypes = {
	    openPopupPanel: _propTypes2.default.func,
	    activeUserCount: _propTypes2.default.number
	};
	
	var enhance = (0, _recompose.compose)((0, _reactRedux.connect)(null, mapDispatchToProps), _recompose.pure);
	
	exports.default = enhance(ExportUtil);

/***/ }),
/* 2179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.exportBoard = exports.triggerDownload = undefined;
	
	var _exportConstants = __webpack_require__(317);
	
	var _browser = __webpack_require__(61);
	
	var _mediaService = __webpack_require__(315);
	
	var _mediaService2 = _interopRequireDefault(_mediaService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getCanvasDomHTML = function getCanvasDomHTML() {
	    var rootElement = document.getElementById(_exportConstants.EXPORT_ROOT_ELEMENT_ID);
	    var body = document.body;
	
	    if (!rootElement) return;
	
	    var rootHTML = rootElement.outerHTML;
	    var html = '<div class="CanvasExport ' + body.classList.value + '">' + rootHTML + '</div>';
	
	    return JSON.stringify({
	        html: html,
	        height: rootElement.clientHeight,
	        width: rootElement.clientWidth
	    });
	};
	
	var createLink = function createLink(url) {
	    // attempt to dowload the file by creating a fake link and clicking on it
	    var urlParts = url.split('/');
	    var filename = urlParts[urlParts.length - 1];
	
	    var link = document.createElement('a');
	    link.href = url;
	    link.target = '_self';
	    link.download = filename;
	
	    return link;
	};
	
	var triggerLink = function triggerLink(link) {
	    link.click();
	};
	
	var triggerLinkFirefox = function triggerLinkFirefox(link) {
	    document.body.appendChild(link);
	    link.click();
	    document.body.removeChild(link);
	};
	
	var triggerDownload = exports.triggerDownload = function triggerDownload(url) {
	    var link = createLink(url);
	    (0, _browser.isFirefox)() ? triggerLinkFirefox(link) : triggerLink(link);
	};
	
	var exportBoard = exports.exportBoard = function exportBoard(_ref) {
	    var boardId = _ref.boardId,
	        format = _ref.format;
	    return function (dispatch, getState) {
	        dispatch({ type: _exportConstants.EXPORT_BOARD_FETCH, format: format });
	
	        var htmlDOM = format === 'pdf-html' ? getCanvasDomHTML() : undefined;
	
	        return _mediaService2.default.export.exportBoard({ boardId: boardId, format: format, htmlDOM: htmlDOM }).then(function (_ref2) {
	            var data = _ref2.data;
	
	            var url = data.fileURL;
	            if (!url) return dispatch({ type: _exportConstants.EXPORT_BOARD_FAIL, format: format });
	
	            dispatch({ type: _exportConstants.EXPORT_BOARD_SUCCESS, format: format, url: url });
	
	            triggerDownload(url);
	        }).catch(function (error) {
	            dispatch({ type: _exportConstants.EXPORT_BOARD_FAIL, format: format });
	            Promise.reject(error);
	        });
	    };
	};

/***/ }),
/* 2180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _exportConstants = __webpack_require__(317);
	
	var _popupConstants = __webpack_require__(140);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Constants
	var initialState = Immutable.Map(); // Lib
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _exportConstants.EXPORT_BOARD_FETCH:
	            return state.set(action.format, _exportConstants.EXPORT_BOARD_STATES.FETCHING);
	        case _exportConstants.EXPORT_BOARD_FAIL:
	            return state.set(action.format, _exportConstants.EXPORT_BOARD_STATES.FAILED);
	        case _exportConstants.EXPORT_BOARD_SUCCESS:
	            return state.set(action.format, action.url);
	        case _popupConstants.POPUP_OPEN:
	        case _popupConstants.POPUP_CLOSE:
	        case _popupConstants.POPUP_TOGGLE:
	            return initialState;
	        default:
	            return state;
	    }
	};

/***/ }),
/* 2181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _PopupPanel = __webpack_require__(54);
	
	var _PopupPanel2 = _interopRequireDefault(_PopupPanel);
	
	var _AnchorButton = __webpack_require__(423);
	
	var _AnchorButton2 = _interopRequireDefault(_AnchorButton);
	
	var _CountIndicator = __webpack_require__(440);
	
	var _CountIndicator2 = _interopRequireDefault(_CountIndicator);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _helpUtilSelector = __webpack_require__(779);
	
	var _helpUtilSelector2 = _interopRequireDefault(_helpUtilSelector);
	
	var _analyticsActions = __webpack_require__(669);
	
	var _popupActions = __webpack_require__(35);
	
	var _urlConstants = __webpack_require__(326);
	
	__webpack_require__(1284);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Lib
	
	
	// Components
	
	
	// Selector
	
	
	// Actions
	
	
	// Constants
	
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        handleFeedbackButtonClick: function handleFeedbackButtonClick() {
	            dispatch((0, _popupActions.togglePopup)('help'));
	            dispatch((0, _analyticsActions.intercomShowMessages)());
	        }
	    };
	};
	
	var HelpPopup = function HelpPopup(_ref) {
	    var handleFeedbackButtonClick = _ref.handleFeedbackButtonClick,
	        unreadMessageCount = _ref.unreadMessageCount,
	        props = _objectWithoutProperties(_ref, ['handleFeedbackButtonClick', 'unreadMessageCount']);
	
	    return _react2.default.createElement(
	        _PopupPanel2.default,
	        _extends({}, props, {
	            popupId: 'help',
	            className: 'HelpPopup' }),
	        _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                    _AnchorButton2.default,
	                    { href: _urlConstants.HELP_URL, target: '_blank' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'icon icon-help-center' },
	                        _react2.default.createElement(_Icon2.default, { name: 'help-center' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'description' },
	                        _react2.default.createElement(
	                            'h3',
	                            null,
	                            'Search our help centre'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Read guides, articles & documents'
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                    _AnchorButton2.default,
	                    { onClickFn: handleFeedbackButtonClick },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'icon' },
	                        _react2.default.createElement('div', { className: 'chat-head' }),
	                        _react2.default.createElement(_CountIndicator2.default, { count: unreadMessageCount, badge: true })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'description' },
	                        _react2.default.createElement(
	                            'h3',
	                            null,
	                            'Chat to a real person'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'We\u2019ll respond in a few hours'
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	HelpPopup.propTypes = {
	    unreadMessageCount: _propTypes2.default.number,
	    handleFeedbackButtonClick: _propTypes2.default.func
	};
	
	exports.default = (0, _reactRedux.connect)(_helpUtilSelector2.default, mapDispatchToProps)(HelpPopup);

/***/ }),
/* 2182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Button = __webpack_require__(34);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _HelpPopup = __webpack_require__(2181);
	
	var _HelpPopup2 = _interopRequireDefault(_HelpPopup);
	
	var _CountIndicator = __webpack_require__(440);
	
	var _CountIndicator2 = _interopRequireDefault(_CountIndicator);
	
	var _helpUtilSelector = __webpack_require__(779);
	
	var _helpUtilSelector2 = _interopRequireDefault(_helpUtilSelector);
	
	var _popupActions = __webpack_require__(35);
	
	__webpack_require__(1285);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Actions
	// Lib
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        openPopupPanel: function openPopupPanel() {
	            return dispatch((0, _popupActions.togglePopup)('help'));
	        }
	    };
	};
	
	// Styles
	
	
	// Selector
	
	
	// Components
	
	
	var HelpUtil = function HelpUtil(_ref) {
	    var popupOpen = _ref.popupOpen,
	        unreadMessageCount = _ref.unreadMessageCount,
	        openPopupPanel = _ref.openPopupPanel;
	    return _react2.default.createElement(
	        'div',
	        { className: 'HeaderUtil HelpUtil' },
	        _react2.default.createElement(
	            _Button2.default,
	            { className: 'highlight', onClickFn: openPopupPanel },
	            _react2.default.createElement(
	                'div',
	                { className: 'util-icon' },
	                _react2.default.createElement(_Icon2.default, { name: 'nav-help' }),
	                _react2.default.createElement(_CountIndicator2.default, { count: unreadMessageCount, hide: popupOpen, badge: true })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'button-text' },
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    'Help'
	                )
	            )
	        ),
	        _react2.default.createElement(_HelpPopup2.default, null)
	    );
	};
	
	HelpUtil.propTypes = {
	    popupOpen: _react2.default.PropTypes.bool,
	    unreadMessageCount: _react2.default.PropTypes.number,
	    openPopupPanel: _propTypes2.default.func
	};
	
	exports.default = (0, _reactRedux.connect)(_helpUtilSelector2.default, mapDispatchToProps)(HelpUtil);

/***/ }),
/* 2183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class; // Lib
	
	
	// Util
	
	
	// Components
	
	
	// Action Creators
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reselect = __webpack_require__(7);
	
	var _stringUtil = __webpack_require__(58);
	
	var _BoardPopupListItem = __webpack_require__(715);
	
	var _BoardPopupListItem2 = _interopRequireDefault(_BoardPopupListItem);
	
	var _navigationActions = __webpack_require__(27);
	
	__webpack_require__(1286);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        dispatchNavigateToLinkedBoard: function dispatchNavigateToLinkedBoard(boardId) {
	            return dispatch((0, _navigationActions.navigateToBoard)({ boardId: boardId }));
	        }
	    };
	};
	
	var liveEditingEntrySelectorCreator = function liveEditingEntrySelectorCreator() {
	    return (0, _reselect.createSelector)(function (state, ownProps) {
	        return state.getIn(['elements', ownProps.boardId]);
	    }, function (state, ownProps) {
	        return state.get('users').filter(function (user) {
	            return ownProps.users.indexOf(user.get('_id')) !== -1;
	        });
	    }, function (activeBoard, activeUsers) {
	        return {
	            activeBoard: activeBoard,
	            activeUsers: activeUsers
	        };
	    });
	};
	
	var TimestampComponent = function TimestampComponent() {
	    return null;
	};
	
	var describeUsers = function describeUsers(users) {
	    return users.valueSeq().reduce(function (sentence, user, index, self) {
	        var separator = (0, _stringUtil.listSeparator)(index, self.size);
	        return '' + sentence + user.getIn(['name', 'displayName']) + separator;
	    }, '');
	};
	
	var ActivityComponent = function ActivityComponent(_ref) {
	    var users = _ref.users;
	    return _react2.default.createElement(
	        'span',
	        null,
	        describeUsers(users),
	        ' ',
	        (0, _stringUtil.chooseSingular)(users.size, 'is', 'are'),
	        ' viewing'
	    );
	};
	
	ActivityComponent.propTypes = {
	    users: _propTypes2.default.object.isRequired
	};
	
	var LiveEditingEntry = (_dec = (0, _reactRedux.connect)(liveEditingEntrySelectorCreator, mapDispatchToProps), _dec(_class = function (_React$Component) {
	    _inherits(LiveEditingEntry, _React$Component);
	
	    function LiveEditingEntry(props) {
	        _classCallCheck(this, LiveEditingEntry);
	
	        var _this = _possibleConstructorReturn(this, (LiveEditingEntry.__proto__ || Object.getPrototypeOf(LiveEditingEntry)).call(this, props));
	
	        _this.navigateToLinkedBoard = _this.navigateToLinkedBoard.bind(_this);
	        return _this;
	    }
	
	    _createClass(LiveEditingEntry, [{
	        key: 'navigateToLinkedBoard',
	        value: function navigateToLinkedBoard(event) {
	            event.preventDefault();
	            var _props = this.props,
	                dispatchNavigateToLinkedBoard = _props.dispatchNavigateToLinkedBoard,
	                boardId = _props.boardId;
	
	
	            dispatchNavigateToLinkedBoard(boardId);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                activeBoard = _props2.activeBoard,
	                activeUsers = _props2.activeUsers;
	
	
	            return _react2.default.createElement(_BoardPopupListItem2.default, {
	                className: 'LiveEditingEntry',
	                board: activeBoard,
	                users: activeUsers,
	                active: true,
	                navigateToLinkedBoard: this.navigateToLinkedBoard,
	                TimestampComponent: TimestampComponent,
	                ActivityComponent: ActivityComponent });
	        }
	    }]);
	
	    return LiveEditingEntry;
	}(_react2.default.Component)) || _class);
	
	
	LiveEditingEntry.propTypes = {
	    boardId: _propTypes2.default.string.isRequired,
	    activeBoard: _propTypes2.default.object,
	    activeUsers: _propTypes2.default.object,
	    dispatchNavigateToLinkedBoard: _propTypes2.default.func
	};
	
	exports.default = LiveEditingEntry;

/***/ }),
/* 2184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Utils
	
	
	// Selectors
	
	
	// Components
	
	
	// Constants
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__(3);
	
	var _stringUtil = __webpack_require__(58);
	
	var _liveEditingUtilSelector = __webpack_require__(780);
	
	var _liveEditingUtilSelector2 = _interopRequireDefault(_liveEditingUtilSelector);
	
	var _PopupPanel = __webpack_require__(54);
	
	var _PopupPanel2 = _interopRequireDefault(_PopupPanel);
	
	var _PopupList = __webpack_require__(714);
	
	var _PopupList2 = _interopRequireDefault(_PopupList);
	
	var _LiveEditingEntry = __webpack_require__(2183);
	
	var _LiveEditingEntry2 = _interopRequireDefault(_LiveEditingEntry);
	
	var _PopupUserErrorEmptyContent = __webpack_require__(777);
	
	var _PopupUserErrorEmptyContent2 = _interopRequireDefault(_PopupUserErrorEmptyContent);
	
	var _PopupEmptyContent = __webpack_require__(441);
	
	var _PopupEmptyContent2 = _interopRequireDefault(_PopupEmptyContent);
	
	var _liveEditingUtilConstants = __webpack_require__(475);
	
	__webpack_require__(1287);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LiveEditingPopupActiveContent = function LiveEditingPopupActiveContent(_ref) {
	    var activeUserCount = _ref.activeUserCount,
	        activeUsersByBoards = _ref.activeUsersByBoards;
	
	    var title = activeUserCount + ' active ' + (0, _stringUtil.pluralise)('user', activeUserCount);
	    return _react2.default.createElement(
	        _PopupList2.default,
	        { title: title, list: activeUsersByBoards },
	        function (activeUsersByBoard, index) {
	            return _react2.default.createElement(_LiveEditingEntry2.default, activeUsersByBoard);
	        }
	    );
	};
	
	LiveEditingPopupActiveContent.propTypes = {
	    activeUserCount: _propTypes2.default.number.isRequired,
	    activeUsersByBoards: _propTypes2.default.array.isRequired
	};
	
	var LiveEditingPopup = function LiveEditingPopup(props) {
	    var active = props.active,
	        errorActiveUserIds = props.errorActiveUserIds;
	
	
	    var content = null;
	    if (errorActiveUserIds.length) {
	        content = _react2.default.createElement(_PopupUserErrorEmptyContent2.default, _extends({ userIds: errorActiveUserIds }, props));
	    } else if (active) {
	        content = _react2.default.createElement(LiveEditingPopupActiveContent, props);
	    } else {
	        content = _react2.default.createElement(_PopupEmptyContent2.default, { message: 'No one is currently active in boards you share' });
	    }
	
	    return _react2.default.createElement(
	        _PopupPanel2.default,
	        _extends({ className: (0, _classnames2.default)('LiveEditingPopup', { active: active }) }, props, {
	            popupId: _liveEditingUtilConstants.LIVE_EDITING_POPUP_ID }),
	        content
	    );
	};
	
	LiveEditingPopup.propTypes = {
	    activeUserCount: _propTypes2.default.number.isRequired,
	    activeUsersByBoards: _propTypes2.default.array.isRequired,
	    errorActiveUserIds: _propTypes2.default.array,
	    active: _propTypes2.default.bool
	};
	
	exports.default = (0, _reactRedux.connect)(_liveEditingUtilSelector2.default)(LiveEditingPopup);

/***/ }),
/* 2185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Selectors
	
	
	// Components
	
	
	// Actions
	
	
	// Utils
	
	
	// Constants
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _recompose = __webpack_require__(9);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _liveEditingUtilSelector = __webpack_require__(780);
	
	var _liveEditingUtilSelector2 = _interopRequireDefault(_liveEditingUtilSelector);
	
	var _ToolButton = __webpack_require__(676);
	
	var _ToolButton2 = _interopRequireDefault(_ToolButton);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _LiveEditingPopup = __webpack_require__(2184);
	
	var _LiveEditingPopup2 = _interopRequireDefault(_LiveEditingPopup);
	
	var _popupActions = __webpack_require__(35);
	
	var _userUtil = __webpack_require__(31);
	
	var _liveEditingUtilConstants = __webpack_require__(475);
	
	__webpack_require__(1288);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        openPopupPanel: function openPopupPanel() {
	            return dispatch((0, _popupActions.togglePopup)(_liveEditingUtilConstants.LIVE_EDITING_POPUP_ID));
	        }
	    };
	};
	
	var LiveEditingUtil = function LiveEditingUtil(props) {
	    var currentUser = props.currentUser,
	        openPopupPanel = props.openPopupPanel,
	        activeUserCount = props.activeUserCount,
	        errorActiveUserIds = props.errorActiveUserIds,
	        fetchingActiveUserIds = props.fetchingActiveUserIds;
	
	
	    if ((0, _userUtil.isGuest)(currentUser)) return null;
	
	    var active = !errorActiveUserIds.length && !fetchingActiveUserIds.length && activeUserCount > 0;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'HeaderUtil' },
	        _react2.default.createElement(_ToolButton2.default, {
	            icon: _react2.default.createElement(_Icon2.default, { name: 'nav-antenna' }),
	            className: (0, _classnames2.default)('LiveEditingUtil', { active: active }),
	            onClickFn: openPopupPanel }),
	        _react2.default.createElement(_LiveEditingPopup2.default, _extends({}, props, { active: active }))
	    );
	};
	
	LiveEditingUtil.propTypes = {
	    currentUser: _propTypes2.default.object,
	    openPopupPanel: _propTypes2.default.func,
	    activeUserCount: _propTypes2.default.number,
	    errorActiveUserIds: _propTypes2.default.array,
	    fetchingActiveUserIds: _propTypes2.default.array
	};
	
	exports.default = (0, _reactRedux.connect)(_liveEditingUtilSelector2.default, mapDispatchToProps)((0, _recompose.pure)(LiveEditingUtil));

/***/ }),
/* 2186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _Button = __webpack_require__(34);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _NotificationPopup = __webpack_require__(781);
	
	var _NotificationPopup2 = _interopRequireDefault(_NotificationPopup);
	
	var _CountIndicator = __webpack_require__(440);
	
	var _CountIndicator2 = _interopRequireDefault(_CountIndicator);
	
	var _popupActions = __webpack_require__(35);
	
	var _userService = __webpack_require__(106);
	
	var _notificationActions = __webpack_require__(460);
	
	var _boardService = __webpack_require__(167);
	
	var _notificationUtilSelector = __webpack_require__(782);
	
	var _notificationUtilSelector2 = _interopRequireDefault(_notificationUtilSelector);
	
	var _analytics = __webpack_require__(47);
	
	__webpack_require__(1270);
	
	__webpack_require__(1290);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Styles
	
	
	// Actions
	
	
	// Components
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        openPopupPanel: function openPopupPanel() {
	            dispatch((0, _popupActions.togglePopup)('notification'));
	            (0, _analytics.analyticsEvent)('viewed-notifications');
	        },
	        fetchModified: function fetchModified() {
	            return dispatch((0, _notificationActions.fetchModifiedBoards)());
	        },
	        fetchNotificationUsers: function fetchNotificationUsers(users) {
	            return dispatch((0, _userService.fetchUsers)(users));
	        },
	        fetchNotificationBoards: function fetchNotificationBoards(boardIds) {
	            return dispatch((0, _boardService.fetchBoards)({ boardIds: boardIds, loadAncestors: false }));
	        }
	    };
	}; // Lib
	
	
	var NotificationUtil = function NotificationUtil(props) {
	    var isGuest = props.isGuest,
	        openPopupPanel = props.openPopupPanel,
	        notificationsCount = props.notificationsCount,
	        popupOpen = props.popupOpen,
	        notificationsReady = props.notificationsReady;
	
	    // don't show notifications for guest user
	
	    if (isGuest) return null;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'HeaderUtil' },
	        _react2.default.createElement(
	            _Button2.default,
	            { className: 'NotificationUtil highlight', onClickFn: openPopupPanel },
	            _react2.default.createElement(_Icon2.default, { name: 'nav-notifications' }),
	            _react2.default.createElement(_CountIndicator2.default, { count: notificationsCount, hide: popupOpen || !notificationsReady, badge: true })
	        ),
	        _react2.default.createElement(_NotificationPopup2.default, null)
	    );
	};
	
	NotificationUtil.propTypes = {
	    popupOpen: _propTypes2.default.bool,
	    isGuest: _propTypes2.default.bool,
	    openPopupPanel: _propTypes2.default.func,
	    children: _propTypes2.default.element,
	    notifications: _propTypes2.default.object,
	    activeNotifications: _propTypes2.default.object,
	    notificationsCount: _propTypes2.default.number,
	    currentUser: _propTypes2.default.object,
	    fetchedTime: _propTypes2.default.number,
	    forcedPoll: _propTypes2.default.number,
	    fetchNotificationUsers: _propTypes2.default.func,
	    fetchNotificationBoards: _propTypes2.default.func,
	    fetchModified: _propTypes2.default.func,
	    markBoardsAsSeen: _propTypes2.default.func,
	    notificationUserIds: _propTypes2.default.array,
	    notificationsReady: _propTypes2.default.bool
	};
	
	exports.default = (0, _reactRedux.connect)(_notificationUtilSelector2.default, mapDispatchToProps)(NotificationUtil);

/***/ }),
/* 2187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _stringUtil = __webpack_require__(58);
	
	var _elementRegistry = __webpack_require__(56);
	
	var _notificationConstants = __webpack_require__(88);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Element Types
	var THIS_BOARD_TYPE = 'this board';
	
	var AcivityItemMessage = function AcivityItemMessage(_ref) {
	    var type = _ref.type,
	        count = _ref.count,
	        index = _ref.index,
	        listSize = _ref.listSize;
	
	    if (type === THIS_BOARD_TYPE) {
	        return _react2.default.createElement(
	            'span',
	            null,
	            type,
	            (0, _stringUtil.listSeparator)(index, listSize)
	        );
	    }
	
	    return _react2.default.createElement(
	        'span',
	        null,
	        count,
	        '\xA0',
	        (0, _stringUtil.pluralise)(type.toLowerCase(), count),
	        (0, _stringUtil.listSeparator)(index, listSize)
	    );
	};
	
	AcivityItemMessage.propTypes = {
	    type: _propTypes2.default.string,
	    count: _propTypes2.default.number,
	    index: _propTypes2.default.number,
	    listSize: _propTypes2.default.number
	};
	
	var ModifiedBoardActivity = function ModifiedBoardActivity(_ref2) {
	    var notification = _ref2.notification,
	        board = _ref2.board,
	        users = _ref2.users;
	
	    if (notification.get('message') === _notificationConstants.MODIFIED_ELEMENTS_BOARD_MESSAGES.INVITED) {
	        return _react2.default.createElement(
	            'div',
	            { className: 'activity' },
	            users.map(function (user, i) {
	                return _react2.default.createElement(
	                    'span',
	                    { key: user.get('_id') },
	                    user.getIn(['name', 'displayName']),
	                    (0, _stringUtil.listSeparator)(i, users.length)
	                );
	            }),
	            _react2.default.createElement(
	                'span',
	                null,
	                ' shared this board with you'
	            )
	        );
	    }
	
	    var changes = notification.get('children');
	    var reduceTypeCounts = function reduceTypeCounts(acc, change) {
	        if (change.get('id') === notification.get('id')) return acc.set(THIS_BOARD_TYPE, 1);
	
	        var type = change.get('elementType');
	        var typeName = (0, _elementRegistry.getElementDisplayName)(type);
	
	        var count = acc.get(typeName) || 0;
	        return acc.set(typeName, count + 1);
	    };
	
	    var sortFn = function sortFn(a, b) {
	        if (a === THIS_BOARD_TYPE) return -1;
	        if (b === THIS_BOARD_TYPE) return 1;
	        return a > b;
	    };
	
	    var newElements = changes.filter(function (change) {
	        return change.get('message') === _notificationConstants.MODIFIED_ELEMENTS_MESSAGES.CREATED;
	    }).reduce(reduceTypeCounts, Immutable.Map());
	    var newElementTypes = newElements.keySeq().sort(sortFn);
	
	    var updatedElements = changes.filter(function (change) {
	        return change.get('message') === _notificationConstants.MODIFIED_ELEMENTS_MESSAGES.UPDATED;
	    }).reduce(reduceTypeCounts, Immutable.Map());
	    var updatedElementTypes = updatedElements.keySeq().sort(sortFn);
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'activity' },
	        users.map(function (user, i) {
	            return _react2.default.createElement(
	                'span',
	                { key: user.get('_id') },
	                user.getIn(['name', 'displayName']),
	                (0, _stringUtil.listSeparator)(i, users.length)
	            );
	        }),
	        newElementTypes.size ? _react2.default.createElement(
	            'span',
	            null,
	            ' added '
	        ) : null,
	        newElementTypes.map(function (type, i) {
	            return _react2.default.createElement(AcivityItemMessage, { key: i,
	                type: type.toLowerCase(),
	                count: newElements.get(type),
	                index: i,
	                listSize: newElementTypes.size });
	        }),
	        newElementTypes.size && updatedElementTypes.size ? _react2.default.createElement(
	            'span',
	            null,
	            ' and '
	        ) : null,
	        updatedElementTypes.size ? _react2.default.createElement(
	            'span',
	            null,
	            ' updated '
	        ) : null,
	        updatedElementTypes.map(function (type, i) {
	            return _react2.default.createElement(AcivityItemMessage, { key: i,
	                type: type.toLowerCase(),
	                count: updatedElements.get(type),
	                index: i,
	                listSize: updatedElementTypes.size });
	        })
	    );
	};
	
	ModifiedBoardActivity.propTypes = {
	    notification: _propTypes2.default.object,
	    board: _propTypes2.default.object,
	    users: _propTypes2.default.array,
	    navigateToLinkedBoard: _propTypes2.default.func,
	    lastSeenDate: _propTypes2.default.number,
	    active: _propTypes2.default.bool
	};
	
	exports.default = ModifiedBoardActivity;

/***/ }),
/* 2188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reselect = __webpack_require__(7);
	
	var _humanTime = __webpack_require__(1363);
	
	var _humanTime2 = _interopRequireDefault(_humanTime);
	
	var _recompose = __webpack_require__(9);
	
	var _navigationActions = __webpack_require__(27);
	
	var _modifiedBoardUtil = __webpack_require__(2189);
	
	var _ModifiedBoardActivity = __webpack_require__(2187);
	
	var _ModifiedBoardActivity2 = _interopRequireDefault(_ModifiedBoardActivity);
	
	var _BoardPopupListItem = __webpack_require__(715);
	
	var _BoardPopupListItem2 = _interopRequireDefault(_BoardPopupListItem);
	
	var _notificationConstants = __webpack_require__(88);
	
	__webpack_require__(1291);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Constants
	
	
	// Components
	
	
	// Actions
	// Lib
	var modifiedBoardSelector = (0, _reselect.createSelector)(function (state, ownProps) {
	    return ownProps.notification;
	}, function (state, ownProps) {
	    return state.getIn(['elements', ownProps.notification.get('id')]);
	}, function (state, ownProps) {
	    return state.get('users');
	}, function (state, ownProps) {
	    return state.getIn(['app', 'currentUser']);
	}, function (state, ownProps) {
	    return ownProps.active;
	}, function (notification, board, users, currentUser, active, boardLinkId) {
	    var notificationUsers = notification.get('children').map(function (child) {
	        return child.get('modifiedBy');
	    }).filter(function (child, index, self) {
	        return self.indexOf(child) === index;
	    }).filter(function (userId) {
	        return userId !== currentUser.get('_id');
	    }).reduce(function (acc, userId) {
	        var user = users.get(userId);
	        if (user) acc.push(user);
	
	        return acc;
	    }, []);
	
	    return {
	        board: board,
	        users: notificationUsers,
	        isNew: active && currentUser.get('lastCheckedNotifications') < notification.get('modifiedTime')
	    };
	});
	
	// Styles
	
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        dispatchNavigate: function dispatchNavigate(_ref) {
	            var boardId = _ref.boardId,
	                filter = _ref.filter;
	            return dispatch((0, _navigationActions.navigateToBoard)({ boardId: boardId, filter: filter }));
	        }
	    };
	};
	
	var navigationHandlers = {
	    navigateToLinkedBoard: function navigateToLinkedBoard(props) {
	        return function (event) {
	            event.preventDefault();
	            var notification = props.notification,
	                dispatchNavigate = props.dispatchNavigate;
	
	
	            dispatchNavigate({
	                boardId: notification.get('id'),
	                filter: (0, _modifiedBoardUtil.getMessageFilter)(notification)
	            });
	        };
	    }
	};
	
	var ModifiedBoardTimestampComponent = function ModifiedBoardTimestampComponent(_ref2) {
	    var modifiedTime = _ref2.modifiedTime,
	        notification = _ref2.notification;
	    return _react2.default.createElement(
	        'span',
	        null,
	        notification.get('message') === _notificationConstants.MODIFIED_ELEMENTS_BOARD_MESSAGES.INVITED ? _react2.default.createElement(
	            'span',
	            null,
	            'Invited '
	        ) : _react2.default.createElement(
	            'span',
	            null,
	            'Updated '
	        ),
	        _react2.default.createElement(
	            'span',
	            { title: modifiedTime },
	            (0, _humanTime2.default)(modifiedTime)
	        )
	    );
	};
	
	ModifiedBoardTimestampComponent.propTypes = {
	    modifiedTime: _propTypes2.default.object.isRequired,
	    notification: _propTypes2.default.object.isRequired
	};
	
	var ModifiedBoardMessage = function ModifiedBoardMessage(props) {
	    var notification = props.notification,
	        board = props.board,
	        users = props.users,
	        navigateToLinkedBoard = props.navigateToLinkedBoard,
	        active = props.active,
	        isNew = props.isNew;
	
	
	    var modifiedTime = new Date(notification.get('modifiedTime'));
	
	    var linkURL = null;
	    if (board && users.length) {
	        linkURL = (0, _modifiedBoardUtil.getMessageURL)(notification);
	    }
	
	    return _react2.default.createElement(_BoardPopupListItem2.default, {
	        className: 'ModifiedBoardMessage',
	        board: board,
	        users: users,
	        active: active,
	        isNew: isNew,
	        navigateToLinkedBoard: navigateToLinkedBoard,
	        linkURL: linkURL,
	        modifiedTime: modifiedTime,
	        notification: notification,
	        TimestampComponent: ModifiedBoardTimestampComponent,
	        ActivityComponent: _ModifiedBoardActivity2.default });
	};
	
	ModifiedBoardMessage.propTypes = {
	    notification: _propTypes2.default.object,
	    board: _propTypes2.default.object,
	    users: _propTypes2.default.array,
	    navigateToLinkedBoard: _propTypes2.default.func,
	    lastSeenDate: _propTypes2.default.number,
	    active: _propTypes2.default.bool,
	    isNew: _propTypes2.default.bool
	};
	
	var enhance = (0, _recompose.compose)((0, _reactRedux.connect)(modifiedBoardSelector, mapDispatchToProps), (0, _recompose.withHandlers)(navigationHandlers));
	
	exports.default = enhance(ModifiedBoardMessage);

/***/ }),
/* 2189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getMessageURL = exports.getMessageFilter = undefined;
	
	var _stringUtil = __webpack_require__(58);
	
	var _notificationConstants = __webpack_require__(88);
	
	var getModifiedFilters = function getModifiedFilters(modifiedChildren) {
	    var modifiedAfter = modifiedChildren.map(function (child) {
	        return child.get('modifiedTime');
	    }).reduce(function (modifiedTime, childModified) {
	        return Math.min(modifiedTime, childModified);
	    }, Infinity);
	
	    var modifiedBy = modifiedChildren.map(function (child) {
	        return child.get('modifiedBy');
	    }).filter(function (modifiedUser, i, list) {
	        return list.indexOf(modifiedUser) === i;
	    }).toArray();
	
	    return {
	        filter_after: modifiedAfter,
	        filter_user: modifiedBy
	    };
	};
	
	var getMessageFilter = exports.getMessageFilter = function getMessageFilter(message) {
	    if (message.get('message') === _notificationConstants.MODIFIED_ELEMENTS_BOARD_MESSAGES.INVITED) {
	        return null;
	    }
	
	    return getModifiedFilters(message.get('children'));
	};
	
	var getMessageURL = exports.getMessageURL = function getMessageURL(message) {
	    return '/' + message.get('id') + '?' + (0, _stringUtil.createQueryString)(getMessageFilter(message));
	};

/***/ }),
/* 2190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _permissionUtil = __webpack_require__(89);
	
	__webpack_require__(1294);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BoardWriteStatus = function BoardWriteStatus(_ref) {
	    var userPermissions = _ref.userPermissions;
	
	    if (!(0, _permissionUtil.canWrite)(userPermissions)) {
	        return _react2.default.createElement(
	            'div',
	            { className: 'BoardWriteStatus' },
	            _react2.default.createElement(
	                'span',
	                { className: 'status-type' },
	                _react2.default.createElement(_Icon2.default, { name: 'board-locked' }),
	                ' Read only'
	            )
	        );
	    }
	
	    if (!(0, _permissionUtil.canSave)(userPermissions)) {
	        return _react2.default.createElement(
	            'div',
	            { className: 'BoardWriteStatus' },
	            _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                    'span',
	                    { className: 'status-type' },
	                    _react2.default.createElement(_Icon2.default, { name: 'board-shared-users' }),
	                    ' Demo board'
	                ),
	                ' your changes won\'t be saved'
	            )
	        );
	    }
	
	    return null;
	};
	
	BoardWriteStatus.propTypes = {
	    userPermissions: _propTypes2.default.number
	};
	
	exports.default = BoardWriteStatus;

/***/ }),
/* 2191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PopupPanel = __webpack_require__(54);
	
	var _PopupPanel2 = _interopRequireDefault(_PopupPanel);
	
	__webpack_require__(1295);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RootBoardSharingPopup = function RootBoardSharingPopup(props) {
	    return _react2.default.createElement(
	        _PopupPanel2.default,
	        { className: 'RootBoardSharingPopup tooltip',
	            popupId: 'sharing-tooltip',
	            arrowDir: 'top',
	            duration: 6000,
	            fadeIn: true },
	        _react2.default.createElement(
	            'span',
	            null,
	            'Your main board is always private, ',
	            _react2.default.createElement('br', null),
	            'but any other board you create can be shared'
	        )
	    );
	};
	
	exports.default = RootBoardSharingPopup;

/***/ }),
/* 2192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class; // Lib
	
	
	// Utils
	
	
	// Actions
	
	
	// Components
	
	
	// Constants
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__(3);
	
	var _userHelper = __webpack_require__(175);
	
	var _sharingPopupActions = __webpack_require__(478);
	
	var _Form = __webpack_require__(138);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormButton = __webpack_require__(60);
	
	var _FormButton2 = _interopRequireDefault(_FormButton);
	
	var _FormInput = __webpack_require__(96);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _FieldValidationMessages = __webpack_require__(122);
	
	var _FieldValidationMessages2 = _interopRequireDefault(_FieldValidationMessages);
	
	var _milanoteForm = __webpack_require__(104);
	
	var _milanoteForm2 = _interopRequireDefault(_milanoteForm);
	
	var _TeamSuggestions = __webpack_require__(757);
	
	var _TeamSuggestions2 = _interopRequireDefault(_TeamSuggestions);
	
	var _boardSharingFormConstants = __webpack_require__(477);
	
	__webpack_require__(1296);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Redux connect methods
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        onSubmit: function onSubmit(_ref) {
	            var userEmail = _ref.userEmail;
	            return dispatch((0, _sharingPopupActions.addSharedUser)({ userEmail: userEmail, elementId: ownProps.currentBoardId }));
	        },
	        addUserHandler: function addUserHandler(_ref2) {
	            var userEmail = _ref2.userEmail;
	            return dispatch((0, _sharingPopupActions.addSharedUser)({ userEmail: userEmail, elementId: ownProps.currentBoardId }));
	        }
	    };
	};
	
	var BoardSharingInputForm = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec2 = (0, _milanoteForm2.default)({
	    form: _boardSharingFormConstants.ADD_SHARED_USER_FORM_NAME,
	    fieldsConfig: _boardSharingFormConstants.ADD_SHARED_USER_FORM_FIELDS,
	    initialValues: { userEmail: '' }
	}), _dec(_class = _dec2(_class = function (_React$Component) {
	    _inherits(BoardSharingInputForm, _React$Component);
	
	    function BoardSharingInputForm() {
	        _classCallCheck(this, BoardSharingInputForm);
	
	        return _possibleConstructorReturn(this, (BoardSharingInputForm.__proto__ || Object.getPrototypeOf(BoardSharingInputForm)).apply(this, arguments));
	    }
	
	    _createClass(BoardSharingInputForm, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.refs.userEmail.focus();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                submitInterceptor = _props.submitInterceptor,
	                sanitisedErrors = _props.sanitisedErrors,
	                submitting = _props.submitting,
	                showingErrors = _props.showingErrors,
	                addUserHandler = _props.addUserHandler,
	                sharedUsers = _props.sharedUsers,
	                values = _props.values;
	
	
	            var selectedUserIds = sharedUsers.map(_userHelper.getId);
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'BoardSharingInputForm' },
	                _react2.default.createElement(
	                    _Form2.default,
	                    { className: (0, _classnames2.default)('form', { submitting: submitting }),
	                        onSubmit: submitInterceptor,
	                        noValidate: true },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'form-row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'field-info' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'field-label', htmlFor: 'userEmail' },
	                                'Invite someone to edit this board'
	                            )
	                        ),
	                        _react2.default.createElement(_FieldValidationMessages2.default, { sanitisedError: sanitisedErrors.userEmail }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'field-row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'field' },
	                                _react2.default.createElement(_FormInput2.default, _extends({}, this.props, { ref: 'userEmail',
	                                    name: _boardSharingFormConstants.ADD_SHARED_USER_FORM_FIELDS.userEmail.name,
	                                    type: _boardSharingFormConstants.ADD_SHARED_USER_FORM_FIELDS.userEmail.type,
	                                    placeholder: 'e.g. alex.lee@milanote.com',
	                                    maxLength: _boardSharingFormConstants.ADD_SHARED_USER_FORM_FIELDS.userEmail.maxLength,
	                                    autoComplete: 'off' }))
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    _FormButton2.default,
	                                    { className: 'primary', type: 'submit',
	                                        disabled: submitting || showingErrors },
	                                    'Share'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(_TeamSuggestions2.default, {
	                            addUser: addUserHandler,
	                            selectedUserIds: selectedUserIds,
	                            filterString: values.userEmail })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return BoardSharingInputForm;
	}(_react2.default.Component)) || _class) || _class);
	
	
	BoardSharingInputForm.propTypes = {
	    fields: _propTypes2.default.object,
	    submitInterceptor: _propTypes2.default.func,
	    submitFailed: _propTypes2.default.bool,
	    showingErrors: _propTypes2.default.bool,
	    submitting: _propTypes2.default.bool,
	    onChange: _propTypes2.default.func,
	    addUserHandler: _propTypes2.default.func,
	    sanitisedErrors: _propTypes2.default.object,
	    currentBoardId: _propTypes2.default.string.isRequired,
	    sharedUsers: _propTypes2.default.object,
	    values: _propTypes2.default.object
	};
	
	exports.default = BoardSharingInputForm;

/***/ }),
/* 2193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Utils
	
	
	// Constants
	
	
	var _formSubReducerWrapper = __webpack_require__(229);
	
	var _formSubReducerWrapper2 = _interopRequireDefault(_formSubReducerWrapper);
	
	var _elementConstants = __webpack_require__(12);
	
	var ELEMENT_ACTION_TYPES = _interopRequireWildcard(_elementConstants);
	
	var _boardSharingFormConstants = __webpack_require__(477);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addSharedUserSubFormReducer = function addSharedUserSubFormReducer(state, action) {
	    switch (action.type) {
	        case ELEMENT_ACTION_TYPES.ELEMENT_SHARE:
	            return _extends({}, state, { userEmail: { value: '' } });
	        default:
	            return state;
	    }
	};
	
	exports.default = (0, _formSubReducerWrapper2.default)(addSharedUserSubFormReducer, _boardSharingFormConstants.ADD_SHARED_USER_FORM_NAME);

/***/ }),
/* 2194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PublicSharingLink = __webpack_require__(2195);
	
	var _PublicSharingLink2 = _interopRequireDefault(_PublicSharingLink);
	
	var _Button = __webpack_require__(34);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _boardSharingHelpers = __webpack_require__(476);
	
	__webpack_require__(1297);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BoardSharingPublic = function BoardSharingPublic(props) {
	    var boardPermissions = props.boardPermissions,
	        publiclyShareBoard = props.publiclyShareBoard;
	
	
	    var linkElement = _react2.default.createElement(
	        _Button2.default,
	        { className: 'link-button', onClickFn: publiclyShareBoard },
	        'Create a secret link to view this board'
	    );
	
	    if ((0, _boardSharingHelpers.isPublic)(boardPermissions)) {
	        linkElement = _react2.default.createElement(_PublicSharingLink2.default, props);
	    }
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'BoardSharingPublic' },
	        linkElement,
	        _react2.default.createElement(
	            'p',
	            { className: 'link-explain' },
	            _react2.default.createElement(
	                'strong',
	                null,
	                'Anyone'
	            ),
	            ' with this link will be able to view (but not edit) this board'
	        )
	    );
	};
	
	BoardSharingPublic.propTypes = {
	    boardPermissions: _propTypes2.default.object,
	    currentBoardId: _propTypes2.default.string,
	    publiclyShareBoard: _propTypes2.default.func
	};
	
	exports.default = BoardSharingPublic;

/***/ }),
/* 2195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(34);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _StaticURLField = __webpack_require__(700);
	
	var _StaticURLField2 = _interopRequireDefault(_StaticURLField);
	
	var _getAppUrl = __webpack_require__(760);
	
	var _getAppUrl2 = _interopRequireDefault(_getAppUrl);
	
	var _userConstants = __webpack_require__(32);
	
	__webpack_require__(1298);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getPublicLink = function getPublicLink(currentBoardId) {
	    return (0, _getAppUrl2.default)() + '/' + currentBoardId;
	};
	
	var PublicSharingLink = function PublicSharingLink(_ref) {
	    var currentBoardId = _ref.currentBoardId,
	        unsharePublicBoard = _ref.unsharePublicBoard,
	        boardPermissions = _ref.boardPermissions;
	
	    var sharedContext = boardPermissions[_userConstants.PUBLIC_USER_ID].elementId;
	    var url = getPublicLink(currentBoardId);
	    var showButton = sharedContext === currentBoardId;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'PublicSharingLink' },
	        _react2.default.createElement(
	            'div',
	            { className: 'public-link-title' },
	            _react2.default.createElement(
	                'span',
	                null,
	                'Link to this board'
	            ),
	            showButton ? _react2.default.createElement(
	                _Button2.default,
	                { className: 'link-button', onClickFn: unsharePublicBoard },
	                'Turn off'
	            ) : null
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'public-link' },
	            _react2.default.createElement(_StaticURLField2.default, { url: url })
	        )
	    );
	};
	
	PublicSharingLink.propTypes = {
	    currentBoardId: _propTypes2.default.string,
	    unsharePublicBoard: _propTypes2.default.func,
	    boardPermissions: _propTypes2.default.object
	};
	
	exports.default = PublicSharingLink;

/***/ }),
/* 2196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _sharingPopupConstants = __webpack_require__(785);
	
	var _popupConstants = __webpack_require__(140);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Constants
	var initialState = Immutable.Map({
	    showShareForm: false
	}); // Lib
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _sharingPopupConstants.SHARE_POPUP_TOGGLE_SHARE_FORM:
	            return state.set('showShareForm', !state.get('showShareForm'));
	        case _popupConstants.POPUP_OPEN:
	        case _popupConstants.POPUP_CLOSE:
	        case _popupConstants.POPUP_TOGGLE:
	            if (action.popupId !== 'sharing') return state;
	            return initialState;
	        default:
	            return state;
	    }
	};

/***/ }),
/* 2197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Actions
	
	
	// Components
	
	
	// Constants
	
	
	// Util
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(45);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _sharingPopupActions = __webpack_require__(478);
	
	var _navigationActions = __webpack_require__(27);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _UserAvatar = __webpack_require__(199);
	
	var _UserAvatar2 = _interopRequireDefault(_UserAvatar);
	
	var _UserName = __webpack_require__(445);
	
	var _UserName2 = _interopRequireDefault(_UserName);
	
	var _userConstants = __webpack_require__(32);
	
	var _permissionUtil = __webpack_require__(89);
	
	__webpack_require__(1299);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RemoveIcon = function RemoveIcon(_ref) {
	    var dispatchRemoveSharedUser = _ref.dispatchRemoveSharedUser;
	    return _react2.default.createElement(
	        'div',
	        { className: 'remove-icon', onClick: dispatchRemoveSharedUser },
	        _react2.default.createElement(_Icon2.default, { name: 'close-x' })
	    );
	};
	
	RemoveIcon.propTypes = {
	    dispatchRemoveSharedUser: _propTypes2.default.func
	};
	
	var UserStatus = function UserStatus(props) {
	    var permission = props.permission,
	        user = props.user,
	        isCurrentUser = props.isCurrentUser,
	        editable = props.editable,
	        sharedBoard = props.sharedBoard;
	
	
	    if ((0, _permissionUtil.isOwner)(permission)) return _react2.default.createElement(
	        'span',
	        { className: 'status' },
	        'Owner'
	    );
	    if (isCurrentUser) return _react2.default.createElement('span', { className: 'status' });
	
	    if (!editable) {
	        if (sharedBoard && sharedBoard.get('elementType') === 'BOARD') {
	            return _react2.default.createElement(
	                'span',
	                { className: 'status shared-board' },
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    'Sharing\xA0'
	                ),
	                _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: '/' + sharedBoard.get('id') },
	                    sharedBoard.getIn(['content', 'title'])
	                )
	            );
	        }
	
	        return _react2.default.createElement('span', { className: 'status' });
	    }
	
	    if (user && user.get('status') !== _userConstants.USER_STATUSES.ACTIVE) {
	        return _react2.default.createElement(
	            'span',
	            { className: 'status invited' },
	            _react2.default.createElement(
	                'span',
	                { className: 'status-text' },
	                'Invite sent'
	            ),
	            _react2.default.createElement(RemoveIcon, props)
	        );
	    }
	
	    return _react2.default.createElement(RemoveIcon, props);
	};
	
	UserStatus.propTypes = {
	    user: _propTypes2.default.object,
	    permission: _propTypes2.default.number,
	    isCurrentUser: _propTypes2.default.bool,
	    editable: _propTypes2.default.bool,
	    currentlyViewing: _propTypes2.default.bool,
	    sharedBoard: _propTypes2.default.object,
	    navigateToSharedBoard: _propTypes2.default.func
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        dispatchRemoveSharedUser: function dispatchRemoveSharedUser() {
	            return dispatch((0, _sharingPopupActions.removeSharedUser)({ elementId: ownProps.currentBoardId, userId: ownProps.userId }));
	        },
	        navigateToSharedBoard: function navigateToSharedBoard() {
	            return dispatch((0, _navigationActions.navigateToBoard)({ boardId: ownProps.sharedBoard.get('id') }));
	        }
	    };
	};
	
	var UserAccessEntry = function UserAccessEntry(props) {
	    var currentlyViewing = props.currentlyViewing;
	
	
	    var classes = (0, _classnames2.default)('UserAccessEntry', {
	        'currently-viewing': currentlyViewing
	    });
	
	    return _react2.default.createElement(
	        'div',
	        { className: classes },
	        _react2.default.createElement(
	            'div',
	            { className: 'details' },
	            _react2.default.createElement(_UserAvatar2.default, _extends({}, props, { active: currentlyViewing })),
	            _react2.default.createElement(_UserName2.default, props),
	            _react2.default.createElement(UserStatus, props)
	        )
	    );
	};
	
	UserAccessEntry.propTypes = {
	    user: _propTypes2.default.object.isRequired,
	    name: _propTypes2.default.string,
	    isCurrentUser: _propTypes2.default.bool,
	    permission: _propTypes2.default.number.isRequired,
	    editable: _propTypes2.default.bool,
	    currentBoardId: _propTypes2.default.string,
	    dispatchRemoveSharedUser: _propTypes2.default.func,
	    currentlyViewing: _propTypes2.default.bool,
	    online: _propTypes2.default.bool,
	    sharedBoard: _propTypes2.default.object
	};
	
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(UserAccessEntry);

/***/ }),
/* 2198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Components
	
	
	// Utils
	
	
	// Constants
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _CSSTransitionGroup = __webpack_require__(134);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _UserAccessEntry = __webpack_require__(2197);
	
	var _UserAccessEntry2 = _interopRequireDefault(_UserAccessEntry);
	
	var _Spinner = __webpack_require__(65);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _RetryErrorComponent = __webpack_require__(694);
	
	var _RetryErrorComponent2 = _interopRequireDefault(_RetryErrorComponent);
	
	var _userUtil = __webpack_require__(31);
	
	var _userConstants = __webpack_require__(32);
	
	__webpack_require__(1300);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        elements: state.get('elements'),
	        currentUserId: state.getIn(['app', 'currentUser', '_id'])
	    };
	};
	
	var userAccessSortingFn = function userAccessSortingFn(userAccessA, userAccessB) {
	    // Current user on top
	    if (userAccessA.isCurrentUser) return -1;
	    if (userAccessB.isCurrentUser) return 1;
	
	    // Remotely active users higher than non-active
	    if (userAccessA.currentlyViewing && !userAccessB.currentlyViewing) return -1;
	    if (userAccessB.currentlyViewing && !userAccessA.currentlyViewing) return 1;
	
	    // Editable users higher than non-editable
	    if (userAccessA.editable && !userAccessB.editable) return -1;
	    if (userAccessB.editable && !userAccessA.editable) return 1;
	
	    // Active users higher than invited
	    if (userAccessA.user.get('status') === _userConstants.USER_STATUSES.ACTIVE && !userAccessB.user.get('status') === _userConstants.USER_STATUSES.ACTIVE) return -1;
	    if (userAccessB.user.get('status') === _userConstants.USER_STATUSES.ACTIVE && !userAccessA.user.get('status') === _userConstants.USER_STATUSES.ACTIVE) return 1;
	
	    // Online users higher than offline
	    if (userAccessA.online && !userAccessB.online) return -1;
	    if (userAccessB.online && !userAccessA.online) return 1;
	
	    // Sorted finally by name
	    return userAccessA.name.localeCompare(userAccessB.name);
	};
	
	var UserAccessList = function UserAccessList(props) {
	    var boardPermissions = props.boardPermissions,
	        currentBoardId = props.currentBoardId,
	        sharedUsers = props.sharedUsers,
	        currentUserId = props.currentUserId,
	        usersCurrentlyViewing = props.usersCurrentlyViewing,
	        elements = props.elements,
	        sharedUserIds = props.sharedUserIds,
	        isLoading = props.isLoading,
	        isUserError = props.isUserError;
	
	
	    if (isUserError) {
	        var retryFn = function retryFn() {
	            return props.fetchUsers(sharedUserIds);
	        };
	        return _react2.default.createElement(
	            'div',
	            { className: 'UserAccessList error' },
	            _react2.default.createElement(_RetryErrorComponent2.default, { message: 'There was a problem loading users', retryFn: retryFn })
	        );
	    }
	
	    if (isLoading) {
	        return _react2.default.createElement(
	            'div',
	            { className: 'UserAccessList loading' },
	            _react2.default.createElement(_Spinner2.default, { show: true })
	        );
	    }
	
	    var userAccessArray = sharedUsers.reduce(function (userArrayAcc, user) {
	        var userId = user.get('_id');
	        var isCurrentUser = userId === currentUserId;
	        var permission = boardPermissions[userId].permission;
	        var boardId = boardPermissions[userId].elementId;
	        var name = (0, _userUtil.getDisplayName)(user);
	        var currentlyViewing = usersCurrentlyViewing.has(userId);
	        var online = (0, _userUtil.isOnline)(user);
	
	        var accessDetails = {
	            userId: userId,
	            isCurrentUser: isCurrentUser,
	            user: user,
	            name: name,
	            permission: permission,
	            currentlyViewing: currentlyViewing,
	            online: online,
	            editable: boardId === currentBoardId,
	            sharedBoard: elements.get(boardId)
	        };
	
	        userArrayAcc.push(accessDetails);
	        return userArrayAcc;
	    }, []).sort(userAccessSortingFn);
	
	    return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('UserAccessList users', { empty: sharedUsers.size <= 1 }) },
	        _react2.default.createElement(
	            _CSSTransitionGroup2.default,
	            {
	                transitionName: 'glow',
	                transitionEnterTimeout: 1000,
	                transitionLeaveTimeout: 1 },
	            userAccessArray.map(function (userAccess) {
	                return _react2.default.createElement(_UserAccessEntry2.default, _extends({ key: userAccess.userId }, userAccess, { currentBoardId: currentBoardId }));
	            })
	        )
	    );
	};
	
	UserAccessList.propTypes = {
	    sharedUsers: _propTypes2.default.object,
	    boardPermissions: _propTypes2.default.object,
	    currentBoardId: _propTypes2.default.string,
	    currentUserId: _propTypes2.default.string,
	    usersCurrentlyViewing: _propTypes2.default.object,
	    activeUsers: _propTypes2.default.object,
	    elements: _propTypes2.default.object,
	    fetchUsers: _propTypes2.default.func,
	    isUserError: _propTypes2.default.bool,
	    isLoading: _propTypes2.default.bool,
	    sharedUserIds: _propTypes2.default.array
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(UserAccessList);

/***/ }),
/* 2199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _mainSelector = __webpack_require__(239);
	
	var _mainSelector2 = _interopRequireDefault(_mainSelector);
	
	var _InboxContainer = __webpack_require__(2029);
	
	var _InboxContainer2 = _interopRequireDefault(_InboxContainer);
	
	var _Canvas = __webpack_require__(673);
	
	var _Canvas2 = _interopRequireDefault(_Canvas);
	
	__webpack_require__(1301);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Selectors
	// Lib
	var Main = function Main(props) {
	    var classes = {
	        'is-dragging': props.isDragging,
	        'no-toolbar': !props.isEditable,
	        editable: props.isEditable
	    };
	
	    if (!props.currentBoardId || !props.currentBoard) return null;
	
	    return _react2.default.createElement(
	        'main',
	        { className: (0, _classnames2.default)('Main', classes) },
	        _react2.default.createElement(_Canvas2.default, props),
	        _react2.default.createElement(_InboxContainer2.default, props)
	    );
	};
	
	// Styles
	
	
	// Components
	
	
	Main.propTypes = {
	    isDragging: _propTypes2.default.bool,
	    isEditable: _propTypes2.default.bool,
	    currentBoardId: _propTypes2.default.string,
	    currentBoard: _propTypes2.default.object
	};
	
	exports.default = (0, _reactRedux.connect)(_mainSelector2.default)(Main);

/***/ }),
/* 2200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(9);
	
	var _ListElement = __webpack_require__(745);
	
	var _ListElement2 = _interopRequireDefault(_ListElement);
	
	var _InboxHeader = __webpack_require__(743);
	
	var _InboxHeader2 = _interopRequireDefault(_InboxHeader);
	
	var _PageLoaderMain = __webpack_require__(439);
	
	var _PageLoaderMain2 = _interopRequireDefault(_PageLoaderMain);
	
	__webpack_require__(1302);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	var Document = function Document(props) {
	    var orderedElements = props.orderedElements,
	        inboxElements = props.inboxElements,
	        currentBoardId = props.currentBoardId,
	        gridSize = props.gridSize,
	        elementFilter = props.elementFilter,
	        isEditable = props.isEditable,
	        isCurrentBoardFetching = props.isCurrentBoardFetching,
	        isCurrentBoardFetched = props.isCurrentBoardFetched;
	
	
	    if (isCurrentBoardFetching && !isCurrentBoardFetched) return _react2.default.createElement(_PageLoaderMain2.default, null);
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'Document' },
	        orderedElements.map(function (element) {
	            return _react2.default.createElement(_ListElement2.default, {
	                element: element,
	                key: element.get('id'),
	                currentBoardId: currentBoardId,
	                inList: 'in-list-document-mode',
	                inListClass: 'in-list-document-mode',
	                gridSize: gridSize,
	                elementFilter: elementFilter,
	                isEditable: isEditable,
	                documentMode: true });
	        }),
	        inboxElements.size ? _react2.default.createElement(_InboxHeader2.default, null) : null,
	        inboxElements.map(function (element) {
	            return _react2.default.createElement(_ListElement2.default, {
	                element: element,
	                key: element.get('id'),
	                currentBoardId: currentBoardId,
	                inList: 'in-list-document-mode',
	                gridSize: gridSize,
	                elementFilter: elementFilter,
	                isEditable: isEditable,
	                documentMode: true });
	        })
	    );
	};
	
	// Styles
	// Lib
	
	
	Document.propTypes = {
	    orderedElements: _propTypes2.default.object,
	    inboxElements: _propTypes2.default.object,
	    currentBoardId: _propTypes2.default.string.isRequired,
	    gridSize: _propTypes2.default.number,
	    elementFilter: _propTypes2.default.object,
	    isEditable: _propTypes2.default.bool,
	    isCurrentBoardFetching: _propTypes2.default.bool,
	    isCurrentBoardFetched: _propTypes2.default.bool
	};
	
	exports.default = (0, _recompose.pure)(Document);

/***/ }),
/* 2201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(9);
	
	var _BoardTitle = __webpack_require__(770);
	
	var _BoardTitle2 = _interopRequireDefault(_BoardTitle);
	
	var _MobilePageStats = __webpack_require__(2203);
	
	var _MobilePageStats2 = _interopRequireDefault(_MobilePageStats);
	
	__webpack_require__(1303);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Lib
	var MobileBoardHeader = function MobileBoardHeader(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'MobileBoardHeader' },
	        _react2.default.createElement('div', { className: 'header-left' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'header-center' },
	            _react2.default.createElement(_BoardTitle2.default, props)
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'header-right' },
	            _react2.default.createElement(_MobilePageStats2.default, props)
	        )
	    );
	};
	
	// Styles
	
	
	// Components
	
	
	MobileBoardHeader.propTypes = {
	    currentBoardId: _propTypes2.default.string.isRequired,
	    isEditable: _propTypes2.default.bool,
	    getDocumentElementSizes: _propTypes2.default.func,
	    elementFilter: _propTypes2.default.object
	};
	
	exports.default = (0, _recompose.onlyUpdateForPropTypes)(MobileBoardHeader);

/***/ }),
/* 2202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reselect = __webpack_require__(7);
	
	var _permissionUtil = __webpack_require__(89);
	
	var _documentModeSelector = __webpack_require__(786);
	
	var _permissionsService = __webpack_require__(75);
	
	var _currentlyEditingSelector = __webpack_require__(233);
	
	var _ElementCreateUtil = __webpack_require__(2214);
	
	var _ElementCreateUtil2 = _interopRequireDefault(_ElementCreateUtil);
	
	__webpack_require__(1304);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	
	
	// Utils
	// Lib
	var floatingToolSelector = (0, _reselect.createSelector)(_documentModeSelector.inboxChildrenSelector, _permissionsService.currentBoardUserPermissionsSelector, _currentlyEditingSelector.isCurrentlyEditing, function (inboxChildren, currentBoardPermissions, isEditing) {
	    return {
	        inboxCount: inboxChildren.size,
	        showCreateButton: (0, _permissionUtil.canWrite)(currentBoardPermissions) && !isEditing
	    };
	});
	
	// Styles
	
	
	// Selectors
	
	
	var MobileFloatingTool = function MobileFloatingTool(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'MobileFloatingTool' },
	        _react2.default.createElement(_ElementCreateUtil2.default, props)
	    );
	};
	
	MobileFloatingTool.propTypes = {
	    currentBoardId: _propTypes2.default.string.isRequired,
	    isEditable: _propTypes2.default.bool
	};
	
	exports.default = (0, _reactRedux.connect)(floatingToolSelector)(MobileFloatingTool);

/***/ }),
/* 2203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _recompose = __webpack_require__(9);
	
	var _reselect = __webpack_require__(7);
	
	var _BoardSharingUtil = __webpack_require__(784);
	
	var _BoardSharingUtil2 = _interopRequireDefault(_BoardSharingUtil);
	
	var _ElementFilterUtil = __webpack_require__(778);
	
	var _ElementFilterUtil2 = _interopRequireDefault(_ElementFilterUtil);
	
	var _sharingUtilSelector = __webpack_require__(318);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Lib
	var statsSelector = (0, _reselect.createSelector)(_sharingUtilSelector.usersCurrentlyViewingSelector, function (usersCurrentlyViewing) {
	    return {
	        activeUsers: usersCurrentlyViewing ? usersCurrentlyViewing.size : 0
	    };
	});
	
	// Components
	
	
	var StatsComponent = function StatsComponent(_ref) {
	    var currentBoardId = _ref.currentBoardId,
	        elementFilter = _ref.elementFilter,
	        activeUsers = _ref.activeUsers;
	
	    if (elementFilter) return _react2.default.createElement(_ElementFilterUtil2.default, { currentBoardId: currentBoardId, elementFilter: elementFilter });
	    return _react2.default.createElement(_BoardSharingUtil2.default, { currentBoardId: currentBoardId, isMobileView: true });
	};
	
	var MobilePageStats = function MobilePageStats(props) {
	    return _react2.default.createElement(StatsComponent, props);
	};
	
	MobilePageStats.propTypes = StatsComponent.propTypes = {
	    currentBoardId: _propTypes2.default.string.isRequired,
	    elementFilter: _propTypes2.default.object,
	    activeUsers: _propTypes2.default.number
	};
	
	var enhance = (0, _recompose.compose)((0, _reactRedux.connect)(statsSelector), _recompose.pure);
	
	exports.default = enhance(MobilePageStats);

/***/ }),
/* 2204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class; // Lib
	
	
	// Selectors
	
	
	// Actions
	
	
	// Components
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _CSSTransitionGroup = __webpack_require__(134);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _lodash = __webpack_require__(4);
	
	var _documentModeSelector = __webpack_require__(786);
	
	var _selectionActions = __webpack_require__(55);
	
	var _Document = __webpack_require__(2200);
	
	var _Document2 = _interopRequireDefault(_Document);
	
	var _MobileBoardHeader = __webpack_require__(2201);
	
	var _MobileBoardHeader2 = _interopRequireDefault(_MobileBoardHeader);
	
	var _MobileFloatingTool = __webpack_require__(2202);
	
	var _MobileFloatingTool2 = _interopRequireDefault(_MobileFloatingTool);
	
	var _AppHeader = __webpack_require__(769);
	
	var _AppHeader2 = _interopRequireDefault(_AppHeader);
	
	var _AndroidStopEditingHelper = __webpack_require__(2208);
	
	var _AndroidStopEditingHelper2 = _interopRequireDefault(_AndroidStopEditingHelper);
	
	__webpack_require__(1305);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        deselectAll: function deselectAll(event) {
	            return dispatch((0, _selectionActions.deselectAllElements)());
	        }
	    };
	};
	
	// Styles
	
	
	var PAGE_TRANSITION_DUR = 300;
	var CURRENT_BOARD_HEADER_HEIGHT = 64;
	
	var MobileWorkspace = (_dec = (0, _reactRedux.connect)(_documentModeSelector.documentSelector, mapDispatchToProps), _dec(_class = function (_React$Component) {
	    _inherits(MobileWorkspace, _React$Component);
	
	    function MobileWorkspace(props) {
	        _classCallCheck(this, MobileWorkspace);
	
	        var _this = _possibleConstructorReturn(this, (MobileWorkspace.__proto__ || Object.getPrototypeOf(MobileWorkspace)).call(this, props));
	
	        _this.onScroll = (0, _lodash.throttle)(function (event) {
	            _this.setScrollBodyClass(window.scrollY > CURRENT_BOARD_HEADER_HEIGHT);
	        }, 100);
	
	        _this.setScrollBodyClass = function (enable) {
	            if (enable === _this.hasBodyClass) return;
	
	            _this.hasBodyClass = enable;
	
	            enable ? document.body.classList.add('mobile-scrolled') : document.body.classList.remove('mobile-scrolled');
	        };
	
	        _this.attachScrollListener = function (enable) {
	            return window.addEventListener('scroll', _this.onScroll);
	        };
	
	        _this.removeScrollListener = function (enable) {
	            return window.removeEventListener('scroll', _this.onScroll);
	        };
	
	        _this.hasBodyClass = false;
	
	        _this.state = {
	            pageTransition: 'slide-left'
	        };
	        return _this;
	    }
	
	    _createClass(MobileWorkspace, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.attachScrollListener();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (!nextProps.documentMode) return;
	            if (nextProps.currentBoardId === this.props.currentBoardId) return;
	            if (nextProps.breadcrumb.path === this.props.breadcrumb.path) return;
	
	            var pageTransition = nextProps.breadcrumb.path.length >= this.props.breadcrumb.path.length ? 'slide-left' : 'slide-right';
	
	            this.setState({ pageTransition: pageTransition });
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (prevProps.currentBoardId === this.props.currentBoardId) return;
	
	            // following is for elegent handling of animated iOS listview style navigation
	
	            // if we have changed page, manually add padding top of next board
	            // equal to the current scroll position
	            var styleStr = 'top: ' + window.scrollY + 'px;';
	            if (this.nextBoard) {
	                var nextBoardNode = _reactDom2.default.findDOMNode(this.nextBoard);
	                nextBoardNode && nextBoardNode.setAttribute('style', styleStr);
	            }
	
	            // then after the transition has completed, scroll to top of page
	            (0, _lodash.delay)(function () {
	                return window.scrollTo(0, 0);
	            }, PAGE_TRANSITION_DUR);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.removeScrollListener();
	            this.setScrollBodyClass(false);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                currentBoardId = _props.currentBoardId,
	                gridSize = _props.gridSize,
	                deselectAll = _props.deselectAll;
	            var pageTransition = this.state.pageTransition;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'DocumentMode' },
	                _react2.default.createElement(_AndroidStopEditingHelper2.default, null),
	                _react2.default.createElement(_AppHeader2.default, this.props),
	                _react2.default.createElement(_MobileFloatingTool2.default, this.props),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'content-wrapper' },
	                    _react2.default.createElement(
	                        _CSSTransitionGroup2.default,
	                        {
	                            transitionName: pageTransition,
	                            transitionEnterTimeout: PAGE_TRANSITION_DUR,
	                            transitionLeaveTimeout: PAGE_TRANSITION_DUR },
	                        _react2.default.createElement(
	                            'div',
	                            {
	                                className: 'content',
	                                key: currentBoardId, ref: function ref(c) {
	                                    _this2.nextBoard = c;
	                                },
	                                onClick: deselectAll },
	                            _react2.default.createElement('div', { className: 'header-spacer' }),
	                            _react2.default.createElement(_MobileBoardHeader2.default, this.props),
	                            _react2.default.createElement(_Document2.default, _extends({}, this.props, { currentBoardId: currentBoardId, gridSize: gridSize }))
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return MobileWorkspace;
	}(_react2.default.Component)) || _class);
	
	
	MobileWorkspace.propTypes = {
	    currentBoardId: _propTypes2.default.string.isRequired,
	    gridSize: _propTypes2.default.number,
	    documentMode: _propTypes2.default.bool,
	    isEditable: _propTypes2.default.bool,
	    elementFilter: _propTypes2.default.object,
	    breadcrumb: _propTypes2.default.object,
	    deselectAll: _propTypes2.default.func
	};
	
	exports.default = MobileWorkspace;

/***/ }),
/* 2205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.debugDocumentModeWrapper = undefined;
	
	var _getClientConfig = __webpack_require__(48);
	
	var _getClientConfig2 = _interopRequireDefault(_getClientConfig);
	
	var _debugUtil = __webpack_require__(299);
	
	var _configConstants = __webpack_require__(135);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Util
	var CONSOLE_DOC_MODE_TIME_NAME = 'DOC_MODE';
	
	/**
	 * Wraps the document mode function with debugging logs if debugging is supported.
	 */
	
	
	// Constants
	/* eslint-disable no-console */
	// Config
	var debugDocumentModeWrapper = exports.debugDocumentModeWrapper = function debugDocumentModeWrapper(documentModeFn) {
	    var config = (0, _getClientConfig2.default)();
	
	    // Don't debug if the console isn't good enough to, or the debug level is too low
	    if (config.debugLevel < _configConstants.DEBUG_LEVEL.FINE && !(0, _debugUtil.isDebugEnabled)() || !console.group) return documentModeFn;
	
	    console.groupCollapsed('%cDocument mode calculations', 'color: #f4511c');
	    console.time(CONSOLE_DOC_MODE_TIME_NAME);
	    console.info('%cCreating main clusters...', 'color: green');
	    console.info('%c-----------------------------', 'color: green');
	
	    return function (inputData) {
	        var documentModeData = documentModeFn(inputData);
	
	        if (documentModeData.earlyExit) {
	            console.debug("Document mode exited early as there's so few data points, calculations are unnecessary");
	            console.timeEnd(CONSOLE_DOC_MODE_TIME_NAME);
	            console.groupEnd();
	            return documentModeData;
	        }
	
	        console.debug('Distance Matrix:');
	        console.table(documentModeData.dendrogramData.distanceMatrix.matrix);
	
	        console.debug('Merges:');
	        console.table(documentModeData.dendrogramData.usedDistances.map(function (distObj) {
	            return {
	                cluster1: distObj.clusters[0],
	                cluster2: distObj.clusters[1],
	                distance: distObj.dist
	            };
	        }));
	
	        console.debug('Scree Plot:');
	        var screePlotTableData = documentModeData.elbowPointData.points.map(function (pointData, index) {
	            var tableData = {
	                height: pointData.height,
	                variance: pointData.variance
	            };
	
	            var errorData = documentModeData.elbowPointData.errorMargins[index - 1];
	            if (errorData) {
	                tableData.cumulativeError = errorData.cumulativeError;
	                tableData.dTheta = errorData.dTheta;
	            }
	
	            return tableData;
	        });
	        console.table(screePlotTableData);
	        console.debug('Variances:', documentModeData.elbowPointData.points.map(function (point) {
	            return point.variance;
	        }).join(', '));
	
	        // Finding the elbow point
	        console.debug('Elbow point:', documentModeData.elbowPointData.elbowPoint.x, ', Too linear:', documentModeData.elbowPointData.tooLinear);
	
	        console.timeEnd(CONSOLE_DOC_MODE_TIME_NAME);
	        console.groupEnd();
	
	        return documentModeData;
	    };
	};

/***/ }),
/* 2206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.calculateDocumentModeOrder = undefined;
	
	var _elementDataPreprocessor = __webpack_require__(2207);
	
	var _documentOrderDataBuilder = __webpack_require__(2260);
	
	var _documentModeDebugger = __webpack_require__(2205);
	
	var processDocumentElements = function processDocumentElements(_ref) {
	    var documentElements = _ref.documentElements;
	
	    var documentModeData = (0, _documentModeDebugger.debugDocumentModeWrapper)(_documentOrderDataBuilder.buildDocumentModeData)(documentElements);
	
	    return {
	        order: (0, _documentOrderDataBuilder.collapseDocumentElementOrder)(documentModeData),
	        details: documentModeData
	    };
	}; // Utils
	var calculateDocumentModeOrder = exports.calculateDocumentModeOrder = function calculateDocumentModeOrder(_ref2) {
	    var elements = _ref2.elements,
	        elementSizes = _ref2.elementSizes;
	
	    var documentElements = (0, _elementDataPreprocessor.preprocessElementData)(elements, elementSizes);
	    return processDocumentElements({ documentElements: documentElements });
	};

/***/ }),
/* 2207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.preprocessElementData = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Utils
	
	
	var _elementHelper = __webpack_require__(13);
	
	var _adjustElementType = __webpack_require__(2256);
	
	var _adjustElementType2 = _interopRequireDefault(_adjustElementType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var adjustBoardPosition = function adjustBoardPosition(documentModeDetails) {
	    return _extends({}, documentModeDetails, {
	        x: documentModeDetails.x - 2,
	        y: documentModeDetails.y - 1,
	        width: documentModeDetails.width + 4,
	        height: documentModeDetails.height + 1
	    });
	};
	
	var preprocessElementData = exports.preprocessElementData = function preprocessElementData(elements, elementSizes) {
	    return elementSizes.map(function (elementSizeDetails) {
	        var element = elements.get(elementSizeDetails.id);
	        var position = element.getIn(['location', 'position']).toJS();
	
	        var documentModeDetails = _extends({
	            x: position.x,
	            y: position.y
	        }, elementSizeDetails, {
	            elementType: (0, _adjustElementType2.default)(element.get('elementType')),
	            color: element.getIn(['content', 'color'])
	        });
	
	        if ((0, _elementHelper.isBoardLike)(documentModeDetails.elementType)) {
	            documentModeDetails = adjustBoardPosition(documentModeDetails);
	        }
	
	        return documentModeDetails;
	    });
	};

/***/ }),
/* 2208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class; // Lib
	
	
	// Decorators
	
	
	// Utils
	
	
	// Actions
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _androidOnly = __webpack_require__(2210);
	
	var _androidOnly2 = _interopRequireDefault(_androidOnly);
	
	var _androidKeyboardStateDecorator = __webpack_require__(2209);
	
	var _androidKeyboardStateDecorator2 = _interopRequireDefault(_androidKeyboardStateDecorator);
	
	var _propsComparisons = __webpack_require__(147);
	
	var _selectionActions = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var keyboardNoLongerVisible = (0, _propsComparisons.noLonger)('keyboardVisible');
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        dispatchStopEditing: function dispatchStopEditing() {
	            return dispatch((0, _selectionActions.finishEditingElement)());
	        }
	    };
	};
	
	var AndroidStopEditingHelper = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), (0, _androidOnly2.default)(_class = _dec(_class = (0, _androidKeyboardStateDecorator2.default)(_class = function (_React$Component) {
	    _inherits(AndroidStopEditingHelper, _React$Component);
	
	    function AndroidStopEditingHelper() {
	        _classCallCheck(this, AndroidStopEditingHelper);
	
	        return _possibleConstructorReturn(this, (AndroidStopEditingHelper.__proto__ || Object.getPrototypeOf(AndroidStopEditingHelper)).apply(this, arguments));
	    }
	
	    _createClass(AndroidStopEditingHelper, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var dispatchStopEditing = this.props.dispatchStopEditing;
	
	
	            if (keyboardNoLongerVisible(this.props, nextProps)) dispatchStopEditing();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return null;
	        }
	    }]);
	
	    return AndroidStopEditingHelper;
	}(_react2.default.Component)) || _class) || _class) || _class);
	
	
	AndroidStopEditingHelper.propTypes = {
	    dispatchStopEditing: _propTypes2.default.func,
	    keyboardVisible: _propTypes2.default.bool
	};
	
	exports.default = AndroidStopEditingHelper;

/***/ }),
/* 2209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	exports.default = function (DecoratedComponent) {
	    var androidKeyboardStateDecorator = function (_React$Component) {
	        _inherits(androidKeyboardStateDecorator, _React$Component);
	
	        function androidKeyboardStateDecorator(props) {
	            _classCallCheck(this, androidKeyboardStateDecorator);
	
	            var _this = _possibleConstructorReturn(this, (androidKeyboardStateDecorator.__proto__ || Object.getPrototypeOf(androidKeyboardStateDecorator)).call(this, props));
	
	            _this.onResize = function (event) {
	                _this.setState({ keyboardVisible: window.innerHeight < _this.initialWindowHeight });
	            };
	
	            _this.debouncedOnResize = (0, _lodash.debounce)(_this.onResize, 10);
	
	            _this.state = { keyboardVisible: false };
	            return _this;
	        }
	
	        _createClass(androidKeyboardStateDecorator, [{
	            key: 'componentWillMount',
	            value: function componentWillMount() {
	                window.addEventListener('resize', this.debouncedOnResize);
	                this.initialWindowHeight = window.innerHeight;
	            }
	        }, {
	            key: 'componentWillUnmount',
	            value: function componentWillUnmount() {
	                window.removeEventListener('resize', this.debouncedOnResize);
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                var keyboardVisible = this.state.keyboardVisible;
	
	                return _react2.default.createElement(DecoratedComponent, _extends({ keyboardVisible: keyboardVisible }, this.props));
	            }
	        }]);
	
	        return androidKeyboardStateDecorator;
	    }(_react2.default.Component);
	
	    androidKeyboardStateDecorator.propTypes = {};
	
	    return androidKeyboardStateDecorator;
	};

/***/ }),
/* 2210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _browser = __webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Lib
	exports.default = function (DecoratedComponent) {
	    return function (props) {
	        return (0, _browser.isAndroid)() ? _react2.default.createElement(DecoratedComponent, props) : null;
	    };
	};
	
	// Utils

/***/ }),
/* 2211 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Action Types
	var DOCUMENT_MODE_CALCULATION = exports.DOCUMENT_MODE_CALCULATION = 'DOCUMENT_MODE_CALCULATION';

/***/ }),
/* 2212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(9);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Button = __webpack_require__(34);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _boardConstants = __webpack_require__(17);
	
	__webpack_require__(1306);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var elementCreateHandlers = {
	    createElement: function createElement(props) {
	        return function (event) {
	            var dispatchCreateElement = props.dispatchCreateElement,
	                dispatchClosePopup = props.dispatchClosePopup,
	                elementType = props.elementType,
	                currentBoardId = props.currentBoardId,
	                inboxCount = props.inboxCount;
	
	
	            var location = {
	                parentId: currentBoardId,
	                section: _boardConstants.BOARD_SECTIONS.INBOX,
	                position: { index: inboxCount }
	            };
	
	            dispatchClosePopup();
	
	            dispatchCreateElement({
	                elementType: elementType,
	                location: location
	            });
	        };
	    }
	};
	
	var ElementCreateButton = function ElementCreateButton(_ref) {
	    var elementType = _ref.elementType,
	        name = _ref.name,
	        createElement = _ref.createElement;
	    return _react2.default.createElement(
	        'li',
	        { className: 'ElementCreateButton' },
	        _react2.default.createElement(
	            _Button2.default,
	            { className: 'feedback', onClickFn: createElement },
	            _react2.default.createElement(
	                'div',
	                { className: 'button-content' },
	                _react2.default.createElement(_Icon2.default, { name: 'element-' + elementType.toLowerCase(), size: _Icon.ICON_SIZES.SMALL }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'title' },
	                    name
	                )
	            )
	        )
	    );
	};
	
	ElementCreateButton.propTypes = {
	    elementType: _propTypes2.default.string,
	    name: _propTypes2.default.string,
	    createElement: _propTypes2.default.func,
	    currentBoardId: _propTypes2.default.string,
	    inboxCount: _propTypes2.default.number
	};
	
	exports.default = (0, _recompose.withHandlers)(elementCreateHandlers)(ElementCreateButton);

/***/ }),
/* 2213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _ElementCreateButton = __webpack_require__(2212);
	
	var _ElementCreateButton2 = _interopRequireDefault(_ElementCreateButton);
	
	var _PopupPanel = __webpack_require__(54);
	
	var _PopupPanel2 = _interopRequireDefault(_PopupPanel);
	
	var _elementActions = __webpack_require__(26);
	
	var _popupActions = __webpack_require__(35);
	
	var _elementRegistry = __webpack_require__(56);
	
	var _cardConstants = __webpack_require__(111);
	
	var _linkConstants = __webpack_require__(174);
	
	var _imageConstants = __webpack_require__(87);
	
	__webpack_require__(1307);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        dispatchCreateElement: function dispatchCreateElement(_ref) {
	            var elementType = _ref.elementType,
	                location = _ref.location;
	            return dispatch((0, _elementActions.createAndSelectElement)({ elementType: elementType, location: location }));
	        },
	        dispatchClosePopup: function dispatchClosePopup() {
	            return dispatch((0, _popupActions.closePopup)());
	        }
	    };
	};
	
	var ElementCreatePopup = function ElementCreatePopup(props) {
	    return _react2.default.createElement(
	        _PopupPanel2.default,
	        _extends({ popupId: 'element-create' }, props, { className: 'ElementCreatePopup', arrowDir: 'bottom' }),
	        _react2.default.createElement(
	            'ul',
	            { className: 'button-list' },
	            _react2.default.createElement(_ElementCreateButton2.default, _extends({}, props, {
	                elementType: _cardConstants.CARD_TYPE,
	                name: (0, _elementRegistry.getElementDisplayName)(_cardConstants.CARD_TYPE) })),
	            _react2.default.createElement(_ElementCreateButton2.default, _extends({}, props, {
	                elementType: _linkConstants.LINK_TYPE,
	                name: (0, _elementRegistry.getElementDisplayName)(_linkConstants.LINK_TYPE) })),
	            _react2.default.createElement(_ElementCreateButton2.default, _extends({}, props, {
	                elementType: _imageConstants.IMAGE_TYPE,
	                name: (0, _elementRegistry.getElementDisplayName)(_imageConstants.IMAGE_TYPE) }))
	        )
	    );
	};
	
	ElementCreatePopup.propTypes = {
	    dispatchCreateElement: _propTypes2.default.func,
	    dispatchClosePopup: _propTypes2.default.func,
	    currentBoardId: _propTypes2.default.string
	};
	
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(ElementCreatePopup);

/***/ }),
/* 2214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Components
	
	
	// Actions
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(34);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ElementCreatePopup = __webpack_require__(2213);
	
	var _ElementCreatePopup2 = _interopRequireDefault(_ElementCreatePopup);
	
	var _popupActions = __webpack_require__(35);
	
	__webpack_require__(1308);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        openPopupPanel: function openPopupPanel() {
	            dispatch((0, _popupActions.togglePopup)('element-create'));
	        }
	    };
	};
	
	var ElementCreateUtil = function ElementCreateUtil(props) {
	    var openPopupPanel = props.openPopupPanel,
	        showCreateButton = props.showCreateButton;
	
	
	    return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('ElementCreateUtil', { leave: !showCreateButton }) },
	        _react2.default.createElement(
	            _Button2.default,
	            { className: 'highlight', onClickFn: openPopupPanel },
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_Icon2.default, { name: 'nav-create' })
	            )
	        ),
	        _react2.default.createElement(_ElementCreatePopup2.default, _extends({}, props, { isMobileView: true }))
	    );
	};
	
	ElementCreateUtil.propTypes = {
	    openPopupPanel: _propTypes2.default.func,
	    showCreateButton: _propTypes2.default.bool
	};
	
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(ElementCreateUtil);

/***/ }),
/* 2215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _canvasUtil = __webpack_require__(422);
	
	var _fileValidator = __webpack_require__(238);
	
	var _keyboardUtility = __webpack_require__(313);
	
	var _linkUtils = __webpack_require__(2275);
	
	var _keyConstants = __webpack_require__(146);
	
	__webpack_require__(1309);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
	
	
	// Utils
	
	
	// Constants
	
	
	// Styles
	
	
	var DATA_TRANSFER_ITEM_KINDS = {
	    FILE: 'file'
	};
	
	var DATA_TRANSFER_TYPES = {
	    PLAIN_TEXT: 'text/plain',
	    HTML: 'text/html',
	    FILES: 'Files'
	};
	
	var WorkspaceClipboardHandler = function (_React$Component) {
	    _inherits(WorkspaceClipboardHandler, _React$Component);
	
	    function WorkspaceClipboardHandler() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, WorkspaceClipboardHandler);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WorkspaceClipboardHandler.__proto__ || Object.getPrototypeOf(WorkspaceClipboardHandler)).call.apply(_ref, [this].concat(args))), _this), _this.onKeyDown = function (event) {
	            if ((0, _keyboardUtility.hasCommandModifier)(event) && event.target === window.document.body && (event.keyCode === _keyConstants.KEY_CODES.CMD_LEFT || event.keyCode === _keyConstants.KEY_CODES.CMD_RIGHT || event.keyCode === _keyConstants.KEY_CODES.CTRL)) {
	                _this.clipboardDiv.focus();
	            }
	        }, _this.onPaste = function (event) {
	            if (document.activeElement !== window.document.body) return;
	            var clipboardData = event.clipboardData;
	            var _this$props = _this.props,
	                currentBoardId = _this$props.currentBoardId,
	                isEditable = _this$props.isEditable;
	
	
	            if (!isEditable) return;
	
	            var _getInboxLocation = (0, _canvasUtil.getInboxLocation)(currentBoardId),
	                location = _getInboxLocation.location;
	
	            var handlerData = { clipboardData: clipboardData, location: location };
	            return _this.handleFile(handlerData) || _this.handleLink(handlerData) || _this.handleHtml({ clipboardData: clipboardData, location: location }) || _this.handlePlainText({ clipboardData: clipboardData, location: location });
	        }, _this.handleFile = function (_ref2) {
	            var clipboardData = _ref2.clipboardData,
	                location = _ref2.location;
	
	            // If there's no file data transfer type then can't get a file from the pasted data
	            if (!(0, _lodash.includes)(clipboardData.types, DATA_TRANSFER_TYPES.FILES)) return;
	
	            var _this$props2 = _this.props,
	                createShortcutImage = _this$props2.createShortcutImage,
	                dispatchErrorUploadingElementAttachment = _this$props2.dispatchErrorUploadingElementAttachment;
	
	
	            var text = clipboardData.getData(DATA_TRANSFER_TYPES.PLAIN_TEXT);
	            var caption = (0, _linkUtils.isTextLink)(text) ? text : undefined;
	
	            var result = void 0;
	            var items = [].concat(_toConsumableArray(clipboardData.items));
	            items.filter(function (item) {
	                return item.kind === DATA_TRANSFER_ITEM_KINDS.FILE;
	            }).forEach(function (item) {
	                var file = item.getAsFile();
	
	                if (!file) {
	                    console.warn('Unable to read file');
	                    return;
	                }
	
	                var validationError = (0, _fileValidator.validateImageFile)(file);
	
	                if (validationError) {
	                    var elementId = createShortcutImage({ location: location });
	                    dispatchErrorUploadingElementAttachment({
	                        id: elementId,
	                        error: validationError
	                    });
	                    result = elementId;
	                    return result;
	                }
	
	                result = createShortcutImage({ location: location, file: file, caption: caption, showCaption: false });
	            });
	
	            return result;
	        }, _this.handleLink = function (_ref3) {
	            var clipboardData = _ref3.clipboardData,
	                location = _ref3.location;
	
	            // If there's no text data transfer type then can't get a link from the pasted data
	            if (!(0, _lodash.includes)(clipboardData.types, DATA_TRANSFER_TYPES.PLAIN_TEXT)) return;
	
	            var text = clipboardData.getData(DATA_TRANSFER_TYPES.PLAIN_TEXT);
	            if (!(0, _linkUtils.isTextLink)(text)) return;
	
	            var _this$props3 = _this.props,
	                createShortcutLink = _this$props3.createShortcutLink,
	                deselectAll = _this$props3.deselectAll;
	
	            var linkElementId = createShortcutLink({ location: location, url: text });
	            deselectAll();
	            return linkElementId;
	        }, _this.handleHtml = function (_ref4) {
	            var clipboardData = _ref4.clipboardData,
	                location = _ref4.location;
	
	            // If there's no html data transfer type then can't get HTML from the pasted data
	            if (!(0, _lodash.includes)(clipboardData.types, DATA_TRANSFER_TYPES.HTML)) return;
	
	            var createShortcutCard = _this.props.createShortcutCard;
	
	            var html = clipboardData.getData(DATA_TRANSFER_TYPES.HTML);
	
	            if (!html) return;
	
	            return createShortcutCard({ location: location, html: html });
	        }, _this.handlePlainText = function (_ref5) {
	            var clipboardData = _ref5.clipboardData,
	                location = _ref5.location;
	
	            // If there's no text data transfer type then can't get text from the pasted data
	            if (!(0, _lodash.includes)(clipboardData.types, DATA_TRANSFER_TYPES.PLAIN_TEXT)) return;
	
	            var createShortcutCard = _this.props.createShortcutCard;
	
	            var text = clipboardData.getData(DATA_TRANSFER_TYPES.PLAIN_TEXT);
	            return createShortcutCard({ location: location, text: text });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(WorkspaceClipboardHandler, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            document.addEventListener('paste', this.onPaste);
	            document.addEventListener('keydown', this.onKeyDown);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            document.removeEventListener('paste', this.onPaste);
	            document.removeEventListener('keydown', this.onKeyDown);
	        }
	
	        /**
	         * Focus the content editable so that Firefox (and I think Safari) can accept the paste events.
	         */
	
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement('div', { ref: function ref(c) {
	                    _this2.clipboardDiv = c;
	                }, className: 'WorkspaceClipboardHandler',
	                contentEditable: true, value: ' ' });
	        }
	    }]);
	
	    return WorkspaceClipboardHandler;
	}(_react2.default.Component);
	
	WorkspaceClipboardHandler.propTypes = {
	    isEditable: _propTypes2.default.bool,
	    deselectAll: _propTypes2.default.func,
	    createShortcutCard: _propTypes2.default.func,
	    createShortcutLink: _propTypes2.default.func,
	    createShortcutImage: _propTypes2.default.func,
	    dispatchErrorUploadingElementAttachment: _propTypes2.default.func,
	    currentBoardId: _propTypes2.default.string
	};
	
	exports.default = WorkspaceClipboardHandler;

/***/ }),
/* 2216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(3);
	
	var _elementActions = __webpack_require__(26);
	
	var _selectionActions = __webpack_require__(55);
	
	var _draftJs = __webpack_require__(39);
	
	var _cardConstants = __webpack_require__(111);
	
	var _linkConstants = __webpack_require__(174);
	
	var _imageConstants = __webpack_require__(87);
	
	// TODO Expose this in an "editor" function
	
	
	// Action creators
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    var deselectAll = function deselectAll() {
	        return dispatch((0, _selectionActions.deselectAllElements)());
	    };
	
	    var createShortcutElement = function createShortcutElement(_ref) {
	        var elementType = _ref.elementType,
	            location = _ref.location,
	            content = _ref.content,
	            attachment = _ref.attachment,
	            currentBoardId = _ref.currentBoardId;
	
	        // Default the current board ID to the drop location if not provided, to simplify the API
	        var _currentBoardId = currentBoardId || location.parentId;
	
	        return dispatch((0, _elementActions.createAndSelectElement)({
	            elementType: elementType,
	            location: location,
	            attachment: attachment,
	            content: content,
	            currentBoardId: _currentBoardId
	        }));
	    };
	
	    var createShortcutCard = function createShortcutCard(_ref2) {
	        var location = _ref2.location,
	            currentBoardId = _ref2.currentBoardId,
	            textContent = _ref2.textContent,
	            text = _ref2.text,
	            html = _ref2.html;
	
	        var elementConfig = {
	            elementType: _cardConstants.CARD_TYPE,
	            location: location,
	            currentBoardId: currentBoardId
	        };
	
	        var _textContent = void 0;
	        if (textContent) {
	            _textContent = textContent;
	        } else if (html) {
	            var blocksFromHtml = (0, _draftJs.convertFromHTML)(html);
	            var contentState = _draftJs.ContentState.createFromBlockArray(blocksFromHtml);
	            _textContent = (0, _draftJs.convertToRaw)(contentState);
	        } else if (text) {
	            // TODO Figure out how to keep styles with the editor
	            // TODO Expose this in an "editor" function
	            var _contentState = _draftJs.ContentState.createFromText(text);
	            _textContent = (0, _draftJs.convertToRaw)(_contentState);
	        }
	
	        if (_textContent) {
	            elementConfig.content = { textContent: _textContent };
	        }
	
	        return createShortcutElement(elementConfig);
	    };
	
	    var createShortcutImage = function createShortcutImage(_ref3) {
	        var location = _ref3.location,
	            currentBoardId = _ref3.currentBoardId,
	            file = _ref3.file,
	            caption = _ref3.caption,
	            _ref3$showCaption = _ref3.showCaption,
	            showCaption = _ref3$showCaption === undefined ? true : _ref3$showCaption;
	
	        var elementConfig = {
	            elementType: _imageConstants.IMAGE_TYPE,
	            location: location,
	            attachment: file,
	            currentBoardId: currentBoardId
	        };
	
	        if (caption) {
	            elementConfig.content = {
	                showCaption: showCaption,
	                caption: caption
	            };
	        }
	
	        return createShortcutElement(elementConfig);
	    };
	
	    var createShortcutLink = function createShortcutLink(_ref4) {
	        var location = _ref4.location,
	            currentBoardId = _ref4.currentBoardId,
	            url = _ref4.url;
	        return createShortcutElement({
	            elementType: _linkConstants.LINK_TYPE,
	            location: location,
	            content: { temp: { url: url, error: null } },
	            currentBoardId: currentBoardId
	        });
	    };
	
	    return {
	        deselectAll: deselectAll,
	        createShortcutElement: createShortcutElement,
	        createShortcutCard: createShortcutCard,
	        createShortcutImage: createShortcutImage,
	        createShortcutLink: createShortcutLink
	    };
	};
	
	// Constants
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps);

/***/ }),
/* 2217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _toolbarListModes, _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _ElementToolList = __webpack_require__(2220);
	
	var _ElementToolList2 = _interopRequireDefault(_ElementToolList);
	
	var _SelectionToolList = __webpack_require__(2224);
	
	var _SelectionToolList2 = _interopRequireDefault(_SelectionToolList);
	
	var _toolbarConstants = __webpack_require__(129);
	
	__webpack_require__(1311);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        selection: state.getIn(['app', 'selection'])
	    };
	};
	
	var toolbarListModes = (_toolbarListModes = {}, _defineProperty(_toolbarListModes, _toolbarConstants.TOOLBAR_MODES.ELEMENTS, _ElementToolList2.default), _defineProperty(_toolbarListModes, _toolbarConstants.TOOLBAR_MODES.SELECT, _SelectionToolList2.default), _toolbarListModes);
	
	var ToolList = (_dec = (0, _reactRedux.connect)(mapStateToProps), _dec(_class = function (_React$Component) {
	    _inherits(ToolList, _React$Component);
	
	    function ToolList() {
	        _classCallCheck(this, ToolList);
	
	        return _possibleConstructorReturn(this, (ToolList.__proto__ || Object.getPrototypeOf(ToolList)).apply(this, arguments));
	    }
	
	    _createClass(ToolList, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                selection = _props.selection,
	                currentBoardId = _props.currentBoardId,
	                gridSize = _props.gridSize;
	
	
	            var toolbarMode = _toolbarConstants.TOOLBAR_MODES.ELEMENTS;
	            // If there is a selection then start in the selected mode
	            var selectedIds = selection.get('ids');
	            var isSelection = selectedIds.size;
	            if (isSelection) {
	                toolbarMode = _toolbarConstants.TOOLBAR_MODES.SELECT;
	            }
	
	            var ToolListComponent = toolbarListModes[toolbarMode] || _ElementToolList2.default;
	            return _react2.default.createElement(ToolListComponent, { currentBoardId: currentBoardId, gridSize: gridSize });
	        }
	    }]);
	
	    return ToolList;
	}(_react2.default.Component)) || _class);
	exports.default = ToolList;
	
	
	ToolList.propTypes = {
	    selection: _propTypes2.default.object,
	    currentBoardId: _propTypes2.default.string.isRequired,
	    gridSize: _propTypes2.default.number
	};

/***/ }),
/* 2218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(9);
	
	var _ToolList = __webpack_require__(2217);
	
	var _ToolList2 = _interopRequireDefault(_ToolList);
	
	var _Trash = __webpack_require__(2221);
	
	var _Trash2 = _interopRequireDefault(_Trash);
	
	__webpack_require__(1313);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Toolbar = function Toolbar(_ref) {
	    var currentBoardId = _ref.currentBoardId,
	        isEditable = _ref.isEditable,
	        gridSize = _ref.gridSize;
	
	    if (!isEditable) return null;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'Toolbar' },
	        _react2.default.createElement(_ToolList2.default, { currentBoardId: currentBoardId, gridSize: gridSize }),
	        _react2.default.createElement(_Trash2.default, { currentBoardId: currentBoardId })
	    );
	};
	
	// Styles
	
	
	// Components
	
	
	Toolbar.propTypes = {
	    isEditable: _propTypes2.default.bool,
	    currentBoardId: _propTypes2.default.string.isRequired,
	    gridSize: _propTypes2.default.number
	};
	
	exports.default = (0, _recompose.onlyUpdateForPropTypes)(Toolbar);

/***/ }),
/* 2219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactDnd = __webpack_require__(72);
	
	var _reactDndHtml5Backend = __webpack_require__(220);
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _elementRegistry = __webpack_require__(56);
	
	var elementFactory = _interopRequireWildcard(_elementRegistry);
	
	var _elementActions = __webpack_require__(26);
	
	var _undoRedoActions = __webpack_require__(316);
	
	var _elementConstants = __webpack_require__(12);
	
	var _draggingActions = __webpack_require__(462);
	
	var _popupActions = __webpack_require__(35);
	
	var _analytics = __webpack_require__(47);
	
	var _Tool = __webpack_require__(110);
	
	var _Tool2 = _interopRequireDefault(_Tool);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _PopupPanel = __webpack_require__(54);
	
	var _PopupPanel2 = _interopRequireDefault(_PopupPanel);
	
	var _buildNewElementDragOffsetsMap = __webpack_require__(2222);
	
	var _buildNewElementDragOffsetsMap2 = _interopRequireDefault(_buildNewElementDragOffsetsMap);
	
	__webpack_require__(1314);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        startDragging: function startDragging() {
	            return dispatch((0, _draggingActions.dragStart)());
	        },
	        endDragging: function endDragging() {
	            return dispatch((0, _draggingActions.dragEnd)());
	        },
	        dispatchEndMoveOperation: function dispatchEndMoveOperation() {
	            return dispatch((0, _undoRedoActions.endOperation)('move'));
	        },
	        onDrop: function onDrop(location, transactionId) {
	            return dispatch((0, _elementActions.createAndSelectElement)({
	                elementType: ownProps.elementType,
	                location: location,
	                currentBoardId: ownProps.currentBoardId,
	                transactionId: transactionId
	            }));
	        },
	        showTooltip: function showTooltip() {
	            (0, _analytics.analyticsEvent)('clicked-toolbar-tool');
	            dispatch((0, _popupActions.openPopup)('tooltip-' + ownProps.elementType));
	        }
	    };
	};
	
	var toolSource = {
	    // Returns the data describing the dragged tool
	    beginDrag: function beginDrag(_ref) {
	        var elementType = _ref.elementType,
	            startDragging = _ref.startDragging,
	            gridSize = _ref.gridSize;
	
	        startDragging();
	        var element = elementFactory.createElementObject({ id: 'previewElement', elementType: elementType, location: {} });
	        var elementId = element.id;
	        element = Immutable.fromJS(element);
	        var offsetsMap = (0, _buildNewElementDragOffsetsMap2.default)({ element: element, gridSize: gridSize });
	        return {
	            element: element,
	            draggedElementIds: [elementId],
	            draggedElements: [element],
	            offsetsMap: offsetsMap,
	            hoveredItems: {},
	            hoveredTypes: {},
	            isCreate: true
	        };
	    },
	
	
	    // Handles when the tool is dropped
	    endDrag: function endDrag(props, monitor, component) {
	        props.endDragging();
	        var operationTransactionId = props.dispatchEndMoveOperation();
	
	        // Doing nothing if it was not dropped onto a compatible target
	        if (!monitor.didDrop()) return;
	
	        var dropResult = monitor.getDropResult();
	        // Only drop if a location is returned by the drop target
	        if (dropResult.location) {
	            /* WORKAROUND:
	             * This is a synthetic event that we're creating to ensure that the React "SelectEventPlugin" works with
	             * the drag and drop (react-dnd) and text editing (draft-js) libraries.
	             *
	             * React adds an "onSelect" event to content editable elements.  This is not standard in HTML, but the
	             * Draft JS text editor relies on this event to track the position of the cursor or the selection state.
	             *
	             * The SelectEventPlugin prevents the onSelect event whenever a drag occurs (in case the user is selecting,
	             * so it has a flag variable "mouseDown" that gets set to true on the mouseDown event and false on the
	             * mouseUp event.
	             * We're using the HTML5 backend of the React DnD library, so it uses the standard HTML5 drag and drop
	             * events.  With HTML5 drag and drop the mouseMove and mouseUp events are not fired once a drag starts.
	             * Thus the React "SelectEventPlugin" receives a "mouseDown" event, but never receives a mouse up event
	             * when the drop finishes.
	             * As such the SelectEventPlugin doesn't set mouseDown flag to false, and the onSelect event will not fire
	             * until a future mouse click forces the mouseDown flag back to false.
	             *
	             * Because we immediately set the element into its editing state when an element tool drop occurs, the
	             * onSelect event is not being fired.
	             *
	             * By firing this synthetic event we force the SelectEventPlugin to set its mouseDown flag to false, and as
	             * such the onSelect events will now fire when entering the editing mode after being dropped onto the
	             * canvas.
	             */
	            var event = new MouseEvent('mouseup', { bubbles: true });
	            document.body.dispatchEvent(event);
	
	            var transactionId = dropResult.transactionId || operationTransactionId;
	            props.onDrop(dropResult.location, transactionId);
	        }
	    }
	};
	
	var dragCollect = function dragCollect(connector, monitor) {
	    return {
	        // Call inside render() to let React handle the drag event
	        connectDragSource: connector.dragSource(),
	        connectDragPreview: connector.dragPreview(),
	        // Get current drag state from the monitor
	        isDragging: monitor.isDragging()
	    };
	};
	
	// connectDragSource and isDragging are added by the collect function
	/* eslint-disable react/prefer-stateless-function */
	var ElementTool = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec2 = (0, _reactDnd.DragSource)(_elementConstants.ELEMENT_DND_TYPE, toolSource, dragCollect), _dec(_class = _dec2(_class = function (_React$Component) {
	    _inherits(ElementTool, _React$Component);
	
	    function ElementTool() {
	        _classCallCheck(this, ElementTool);
	
	        return _possibleConstructorReturn(this, (ElementTool.__proto__ || Object.getPrototypeOf(ElementTool)).apply(this, arguments));
	    }
	
	    _createClass(ElementTool, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var connectDragPreview = this.props.connectDragPreview;
	
	            if (connectDragPreview) {
	                connectDragPreview((0, _reactDndHtml5Backend.getEmptyImage)());
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                connectDragSource = _props.connectDragSource,
	                elementType = _props.elementType,
	                showTooltip = _props.showTooltip;
	
	
	            return connectDragSource(_react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _Tool2.default,
	                    _extends({}, this.props, {
	                        className: 'ElementTool',
	                        isDraggable: true,
	                        handleClick: showTooltip,
	                        tooltip: elementFactory.getElementTooltip(elementType) }),
	                    _react2.default.createElement(_Icon2.default, { name: 'element-' + elementType.toLowerCase() }),
	                    _react2.default.createElement(
	                        _PopupPanel2.default,
	                        { className: 'tooltip',
	                            popupId: 'tooltip-' + elementType,
	                            arrowDir: 'left',
	                            duration: 4000,
	                            fadeIn: true },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            'Drag me'
	                        )
	                    )
	                )
	            ));
	        }
	    }]);
	
	    return ElementTool;
	}(_react2.default.Component)) || _class) || _class);
	exports.default = ElementTool;
	
	
	ElementTool.propTypes = {
	    name: _propTypes2.default.string.isRequired,
	    elementType: _propTypes2.default.string.isRequired,
	    currentBoardId: _propTypes2.default.string.isRequired,
	    connectDragSource: _propTypes2.default.func,
	    connectDragPreview: _propTypes2.default.func,
	    isDragging: _propTypes2.default.bool,
	    showTooltip: _propTypes2.default.func
	};

/***/ }),
/* 2220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	        value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ElementTool = __webpack_require__(2219);
	
	var _ElementTool2 = _interopRequireDefault(_ElementTool);
	
	var _ToolSeparator = __webpack_require__(787);
	
	var _ToolSeparator2 = _interopRequireDefault(_ToolSeparator);
	
	var _elementRegistry = __webpack_require__(56);
	
	var elementRegistry = _interopRequireWildcard(_elementRegistry);
	
	var _cardConstants = __webpack_require__(111);
	
	var _imageConstants = __webpack_require__(87);
	
	var _linkConstants = __webpack_require__(174);
	
	var _columnConstants = __webpack_require__(207);
	
	var _boardConstants = __webpack_require__(17);
	
	var _lineConstants = __webpack_require__(57);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Constants
	var ElementToolRenderer = function ElementToolRenderer(_ref) {
	        var elementTypeObject = _ref.elementTypeObject,
	            currentBoardId = _ref.currentBoardId,
	            gridSize = _ref.gridSize;
	        return _react2.default.createElement(_ElementTool2.default, {
	                key: elementTypeObject.elementType,
	                name: elementTypeObject.displayName,
	                elementType: elementTypeObject.elementType,
	                currentBoardId: currentBoardId,
	                gridSize: gridSize });
	};
	
	// Element Types
	
	
	// Components
	// Lib
	
	
	ElementToolRenderer.propTypes = {
	        currentBoardId: _propTypes2.default.string.isRequired,
	        elementTypeObject: _propTypes2.default.object.isRequired,
	        gridSize: _propTypes2.default.number.isRequired
	};
	
	var ElementToolList = function ElementToolList(props) {
	        var currentBoardId = props.currentBoardId,
	            gridSize = props.gridSize;
	
	        var elementTypes = elementRegistry.getElementTypeObjects();
	
	        return _react2.default.createElement(
	                'div',
	                { className: 'ToolList ElementToolList' },
	                _react2.default.createElement(ElementToolRenderer, { elementTypeObject: elementTypes[_cardConstants.CARD_TYPE], currentBoardId: currentBoardId,
	                        gridSize: gridSize }),
	                _react2.default.createElement(ElementToolRenderer, { elementTypeObject: elementTypes[_imageConstants.IMAGE_TYPE], currentBoardId: currentBoardId,
	                        gridSize: gridSize }),
	                _react2.default.createElement(ElementToolRenderer, { elementTypeObject: elementTypes[_linkConstants.LINK_TYPE], currentBoardId: currentBoardId,
	                        gridSize: gridSize }),
	                _react2.default.createElement(_ToolSeparator2.default, null),
	                _react2.default.createElement(ElementToolRenderer, { elementTypeObject: elementTypes[_columnConstants.COLUMN_TYPE], currentBoardId: currentBoardId,
	                        gridSize: gridSize }),
	                _react2.default.createElement(ElementToolRenderer, { elementTypeObject: elementTypes[_boardConstants.BOARD_TYPE], currentBoardId: currentBoardId,
	                        gridSize: gridSize }),
	                _react2.default.createElement(_ToolSeparator2.default, null),
	                _react2.default.createElement(ElementToolRenderer, { elementTypeObject: elementTypes[_lineConstants.LINE_TYPE], currentBoardId: currentBoardId,
	                        gridSize: gridSize })
	        );
	};
	
	ElementToolList.propTypes = {
	        currentBoardId: _propTypes2.default.string.isRequired,
	        gridSize: _propTypes2.default.number.isRequired
	};
	
	exports.default = ElementToolList;

/***/ }),
/* 2221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	// Decorators
	
	
	// Components
	
	
	// Actions
	
	
	// Constants
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__(3);
	
	var _ElementDropTarget = __webpack_require__(168);
	
	var _ElementDropTarget2 = _interopRequireDefault(_ElementDropTarget);
	
	var _Tool = __webpack_require__(110);
	
	var _Tool2 = _interopRequireDefault(_Tool);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _PopupPanel = __webpack_require__(54);
	
	var _PopupPanel2 = _interopRequireDefault(_PopupPanel);
	
	var _selectionActions = __webpack_require__(55);
	
	var _popupActions = __webpack_require__(35);
	
	var _boardConstants = __webpack_require__(17);
	
	var _elementConstants = __webpack_require__(12);
	
	__webpack_require__(1315);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        deselectAllElements: function deselectAllElements() {
	            return dispatch((0, _selectionActions.deselectAllElements)());
	        },
	        showTooltip: function showTooltip() {
	            return dispatch((0, _popupActions.openPopup)('tooltip-trash'));
	        }
	    };
	};
	
	var trashDropTargetHandler = function trashDropTargetHandler(props, monitor, component) {
	    props.deselectAllElements();
	
	    var _monitor$getItem = monitor.getItem(),
	        draggedElementIds = _monitor$getItem.draggedElementIds;
	
	    return {
	        acceptedElementIds: draggedElementIds,
	        location: {
	            parentId: '' + props.currentBoardId + _boardConstants.BOARD_ID_TRASH_APPEND,
	            section: _boardConstants.BOARD_SECTIONS.TRASH,
	            position: {
	                addedDate: new Date().getTime()
	            }
	        },
	        handledBy: _reactDom2.default.findDOMNode(component)
	    };
	};
	
	var Trash = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec2 = (0, _ElementDropTarget2.default)({ drop: trashDropTargetHandler }, _elementConstants.DROP_TARGET_TYPES.TRASH), _dec(_class = _dec2(_class = function (_React$Component) {
	    _inherits(Trash, _React$Component);
	
	    function Trash() {
	        _classCallCheck(this, Trash);
	
	        return _possibleConstructorReturn(this, (Trash.__proto__ || Object.getPrototypeOf(Trash)).apply(this, arguments));
	    }
	
	    _createClass(Trash, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                isHovered = _props.isHovered,
	                connectDropTarget = _props.connectDropTarget,
	                showTooltip = _props.showTooltip;
	
	            return connectDropTarget(_react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('Trash', { hover: isHovered }) },
	                _react2.default.createElement(
	                    _Tool2.default,
	                    _extends({}, this.props, { name: 'Trash', isDragging: false, handleClick: showTooltip }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'icon' },
	                        _react2.default.createElement(_Icon2.default, { name: 'toolbar-trash' })
	                    ),
	                    _react2.default.createElement(
	                        _PopupPanel2.default,
	                        { className: 'tooltip',
	                            popupId: 'tooltip-trash',
	                            arrowDir: 'left',
	                            duration: 4000,
	                            fadeIn: true },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            'Drag something here to delete it'
	                        )
	                    )
	                )
	            ));
	        }
	    }]);
	
	    return Trash;
	}(_react2.default.Component)) || _class) || _class);
	
	
	Trash.propTypes = {
	    connectDropTarget: _propTypes2.default.func,
	    deselectAllElements: _propTypes2.default.func,
	    isHovered: _propTypes2.default.bool,
	    currentBoardId: _propTypes2.default.string,
	    showTooltip: _propTypes2.default.func
	};
	
	exports.default = Trash;

/***/ }),
/* 2222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getNewElementOffset = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _dragAndDropUtils = __webpack_require__(145);
	
	var _point = __webpack_require__(50);
	
	var pointLib = _interopRequireWildcard(_point);
	
	var _elementHelper = __webpack_require__(13);
	
	var _dndConstants = __webpack_require__(171);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // Lib
	
	
	// Utils
	
	
	// Helpers
	
	
	// Constants
	
	
	/**
	 * Need to reposition lines so that the arrow is being held right in the middle.
	 */
	var getNewLineDragOffset = function getNewLineDragOffset(_ref) {
	    var gridSize = _ref.gridSize;
	    return pointLib.scale(-1, (0, _dragAndDropUtils.getNewLineDragOrigin)({ gridSize: gridSize }));
	};
	
	var getDefaultDragDropPosition = function getDefaultDragDropPosition(_ref2) {
	    var gridSize = _ref2.gridSize;
	    return pointLib.scale(-gridSize, _dndConstants.DEFAULT_NEW_ELEMENT_DRAG_OFFSET_GRID_UNITS);
	};
	
	var isNewLine = function isNewLine(_ref3) {
	    var element = _ref3.element;
	    return (0, _elementHelper.isLine)(element);
	};
	
	/**
	 * Retrieves the drag or drop position for an element.
	 * Usually this is simply the "source client offset" (the top left point of the element being dragged), however if a
	 * board is dragged out of a list it changes shape, so it needs to track the position of the mouse instead (the client
	 * offset).
	 */
	var getNewElementOffset = exports.getNewElementOffset = (0, _lodash.cond)([[isNewLine, getNewLineDragOffset], [_lodash.stubTrue, getDefaultDragDropPosition]]);
	
	exports.default = function (_ref4) {
	    var element = _ref4.element,
	        gridSize = _ref4.gridSize;
	    return _defineProperty({}, element.get('id'), getNewElementOffset({ element: element, gridSize: gridSize }));
	};

/***/ }),
/* 2223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ColorTool = __webpack_require__(2231);
	
	var _ColorTool2 = _interopRequireDefault(_ColorTool);
	
	var _IconTool = __webpack_require__(2233);
	
	var _IconTool2 = _interopRequireDefault(_IconTool);
	
	var _CaptionTool = __webpack_require__(2228);
	
	var _CaptionTool2 = _interopRequireDefault(_CaptionTool);
	
	var _AttachmentTool = __webpack_require__(2227);
	
	var _AttachmentTool2 = _interopRequireDefault(_AttachmentTool);
	
	var _RichTextToolList = __webpack_require__(2249);
	
	var _RichTextToolList2 = _interopRequireDefault(_RichTextToolList);
	
	var _LockTool = __webpack_require__(2247);
	
	var _LockTool2 = _interopRequireDefault(_LockTool);
	
	var _ShowBackgroundTool = __webpack_require__(2250);
	
	var _ShowBackgroundTool2 = _interopRequireDefault(_ShowBackgroundTool);
	
	var _StartArrowTool = __webpack_require__(2226);
	
	var _StartArrowTool2 = _interopRequireDefault(_StartArrowTool);
	
	var _EndArrowTool = __webpack_require__(2225);
	
	var _EndArrowTool2 = _interopRequireDefault(_EndArrowTool);
	
	var _toolbarConstants = __webpack_require__(129);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	var SelectionTool = function SelectionTool(_ref) {
	    var toolMode = _ref.toolMode,
	        selectedElements = _ref.selectedElements,
	        editorKey = _ref.editorKey,
	        gridSize = _ref.gridSize;
	
	    switch (toolMode.id) {
	        case _toolbarConstants.TOOLS.RICH_TEXT.id:
	            return _react2.default.createElement(_RichTextToolList2.default, { selectedElements: selectedElements, editorKey: editorKey });
	        case _toolbarConstants.TOOLS.COLOR.id:
	            return _react2.default.createElement(_ColorTool2.default, { selectedElements: selectedElements, name: toolMode.name });
	        case _toolbarConstants.TOOLS.ICON.id:
	            return _react2.default.createElement(_IconTool2.default, { selectedElements: selectedElements, name: toolMode.name, gridSize: gridSize });
	        case _toolbarConstants.TOOLS.CAPTION.id:
	            return _react2.default.createElement(_CaptionTool2.default, { selectedElements: selectedElements, name: toolMode.name });
	        case _toolbarConstants.TOOLS.ATTACHMENT.id:
	            return _react2.default.createElement(_AttachmentTool2.default, { selectedElements: selectedElements, name: toolMode.name });
	        case _toolbarConstants.TOOLS.LOCK.id:
	            return _react2.default.createElement(_LockTool2.default, { selectedElements: selectedElements, name: toolMode.name });
	        case _toolbarConstants.TOOLS.SHOW_BACKGROUND.id:
	            return _react2.default.createElement(_ShowBackgroundTool2.default, { selectedElements: selectedElements, name: toolMode.name });
	        case _toolbarConstants.TOOLS.START_ARROW.id:
	            return _react2.default.createElement(_StartArrowTool2.default, { selectedElements: selectedElements, name: toolMode.name });
	        case _toolbarConstants.TOOLS.END_ARROW.id:
	            return _react2.default.createElement(_EndArrowTool2.default, { selectedElements: selectedElements, name: toolMode.name });
	        default:
	            return null;
	    }
	};
	
	SelectionTool.propTypes = {
	    gridSize: _propTypes2.default.number.isRequired,
	    toolMode: _propTypes2.default.object,
	    selectedElements: _propTypes2.default.object,
	    editorKey: _propTypes2.default.string
	};
	
	exports.default = SelectionTool;

/***/ }),
/* 2224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reselect = __webpack_require__(7);
	
	var _reactRedux = __webpack_require__(3);
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _lodash = __webpack_require__(4);
	
	var _elementRegistry = __webpack_require__(56);
	
	var elementRegistry = _interopRequireWildcard(_elementRegistry);
	
	var _selectedElementsSelector = __webpack_require__(127);
	
	var _currentlyEditingSelector = __webpack_require__(233);
	
	var _elementHelper = __webpack_require__(13);
	
	var _SelectionTool = __webpack_require__(2223);
	
	var _SelectionTool2 = _interopRequireDefault(_SelectionTool);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } // Lib
	
	
	// Registry
	
	
	// Selectors
	
	
	// Utils
	
	
	// Components
	
	
	var getToolModes = function getToolModes(selectedElements) {
	    var toolTypes = Immutable.OrderedMap();
	
	    var isMultiSelect = selectedElements.size > 1;
	    var toolArrays = selectedElements.map(function (el) {
	        return (
	            // Don't load any tools for skeleton elements
	            (0, _elementHelper.isSkeleton)(el) ? [] : elementRegistry.getElementTools(el.get('elementType'))
	        );
	    }).toJS();
	
	    var commonTools = _lodash.intersection.apply(undefined, _toConsumableArray(toolArrays));
	    commonTools.forEach(function (tool) {
	        if (isMultiSelect && !tool.multiSelect) return;
	        toolTypes = toolTypes.set(tool.id, tool);
	    });
	
	    return toolTypes.toArray();
	};
	
	var toolModeSelector = (0, _reselect.createSelector)(_selectedElementsSelector.getSelectedElements, _currentlyEditingSelector.getCurrentlyEditingEditorKey, function (selectedElements, editorKey) {
	    return {
	        selectedElements: selectedElements,
	        editorKey: editorKey,
	        toolModes: getToolModes(selectedElements)
	    };
	});
	
	var SelectionToolList = function SelectionToolList(_ref) {
	    var toolModes = _ref.toolModes,
	        selectedElements = _ref.selectedElements,
	        editorKey = _ref.editorKey,
	        gridSize = _ref.gridSize;
	    return _react2.default.createElement(
	        'div',
	        { className: 'ToolList SelectionToolList' },
	        toolModes.map(function (tool, i) {
	            return _react2.default.createElement(_SelectionTool2.default, { key: i,
	                toolMode: tool,
	                selectedElements: selectedElements,
	                editorKey: editorKey,
	                gridSize: gridSize });
	        })
	    );
	};
	
	SelectionToolList.propTypes = {
	    toolModes: _propTypes2.default.array,
	    selectedElements: _propTypes2.default.object,
	    editorKey: _propTypes2.default.string,
	    gridSize: _propTypes2.default.number.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(toolModeSelector, null)(SelectionToolList);

/***/ }),
/* 2225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Components
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ArrowTool = __webpack_require__(788);
	
	var _ArrowTool2 = _interopRequireDefault(_ArrowTool);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EndArrowTool = function EndArrowTool(props) {
	    return _react2.default.createElement(_ArrowTool2.default, _extends({}, props, { styleProp: 'endStyle', iconDirection: 'right' }));
	};
	
	exports.default = EndArrowTool;

/***/ }),
/* 2226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Components
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ArrowTool = __webpack_require__(788);
	
	var _ArrowTool2 = _interopRequireDefault(_ArrowTool);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StartArrowTool = function StartArrowTool(props) {
	    return _react2.default.createElement(_ArrowTool2.default, _extends({}, props, { styleProp: 'startStyle', iconDirection: 'left' }));
	};
	
	exports.default = StartArrowTool;

/***/ }),
/* 2227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	// Components
	
	
	// Actions
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _Tool = __webpack_require__(110);
	
	var _Tool2 = _interopRequireDefault(_Tool);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _linkActions = __webpack_require__(740);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Toggles the caption on and off whenever the caption tool is clicked by either changing the image element to be
	 * currently editing (which by default will put the cursor into the field and show the caption), or deleting the
	 * caption text and changing the image to not be editing so that the caption will no longer have focus.
	 */
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        handleMouseDown: function handleMouseDown(event) {
	            event.preventDefault();
	            dispatch((0, _linkActions.toggleLinkAttachment)());
	        }
	    };
	};
	
	var AttachmentTool = function AttachmentTool(props) {
	    var name = props.name,
	        selectedElements = props.selectedElements;
	
	    var hasAttachment = selectedElements.first().getIn(['content', 'link', 'hasAttachment']);
	    if (!hasAttachment) return null;
	
	    var showingAttachment = selectedElements.first().getIn(['content', 'showAttachment']);
	    var iconName = showingAttachment ? 'toolbar-image-preview-on' : 'toolbar-image-preview';
	
	    return _react2.default.createElement(
	        _Tool2.default,
	        _extends({}, props, { name: name || 'Caption', isActive: showingAttachment }),
	        _react2.default.createElement(_Icon2.default, { name: iconName })
	    );
	};
	
	AttachmentTool.propTypes = {
	    name: _react2.default.PropTypes.string,
	    iconName: _react2.default.PropTypes.string,
	    styleCommand: _react2.default.PropTypes.string,
	    styleType: _react2.default.PropTypes.string,
	    showingCaption: _react2.default.PropTypes.bool,
	    selectedElements: _react2.default.PropTypes.object
	};
	
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(AttachmentTool);

/***/ }),
/* 2228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	// Selectors
	
	
	// Components
	
	
	// Actions
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reselect = __webpack_require__(7);
	
	var _elementSelector = __webpack_require__(41);
	
	var _selectedElementsSelector = __webpack_require__(127);
	
	var _elementCaptionUtil = __webpack_require__(137);
	
	var _Tool = __webpack_require__(110);
	
	var _Tool2 = _interopRequireDefault(_Tool);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _captionActions = __webpack_require__(677);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Gets the selected IDs and the currently editing ID.
	 * The first selected ID is the element we're interested in because we only apply the caption to one image element.
	 * If the same image element is being edited then the caption will be visible.
	 */
	var getCaptionState = (0, _reselect.createSelector)(_elementSelector.getElements, _selectedElementsSelector.getSelectedElementIds, function (elements, selection) {
	    var firstElementId = selection.first();
	    var firstElement = elements.get(firstElementId);
	    var showingCaption = firstElement ? (0, _elementCaptionUtil.getShowCaption)(firstElement) : false;
	
	    return {
	        selection: selection,
	        showingCaption: showingCaption
	    };
	});
	
	/**
	 * Toggles the caption on and off whenever the caption tool is clicked by either changing the image element to be
	 * currently editing (which by default will put the cursor into the field and show the caption), or deleting the
	 * caption text and changing the image to not be editing so that the caption will no longer have focus.
	 */
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        handleMouseDown: function handleMouseDown(event) {
	            event.preventDefault();
	            dispatch((0, _captionActions.toggleCaption)());
	        }
	    };
	};
	
	var CaptionTool = function CaptionTool(props) {
	    var showingCaption = props.showingCaption,
	        name = props.name;
	
	
	    var iconName = showingCaption ? 'toolbar-caption-on' : 'toolbar-caption';
	
	    return _react2.default.createElement(
	        _Tool2.default,
	        _extends({}, props, { name: name || 'Caption', isActive: showingCaption }),
	        _react2.default.createElement(_Icon2.default, { name: iconName })
	    );
	};
	
	CaptionTool.propTypes = {
	    name: _propTypes2.default.string,
	    iconName: _propTypes2.default.string,
	    styleCommand: _propTypes2.default.string,
	    styleType: _propTypes2.default.string,
	    showingCaption: _propTypes2.default.bool
	};
	
	exports.default = (0, _reactRedux.connect)(getCaptionState, mapDispatchToProps)(CaptionTool);

/***/ }),
/* 2229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(34);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	__webpack_require__(1316);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	var ColorButton = function ColorButton(props) {
	    var color = props.color,
	        isActive = props.isActive,
	        setColor = props.setColor,
	        selectedType = props.selectedType;
	
	
	    var onColorClick = function onColorClick(event) {
	        setColor(color);
	    };
	
	    var iconStyle = color ? { background: color.hex } : {};
	    var classes = {
	        active: isActive,
	        'no-color': !color || !color.hex
	    };
	
	    return _react2.default.createElement(
	        _Button2.default,
	        { className: (0, _classnames2.default)('ColorButton', selectedType, classes), onClickFn: onColorClick },
	        _react2.default.createElement('div', { className: 'color-icon', style: iconStyle })
	    );
	};
	
	// Styles
	// Lib
	
	
	ColorButton.propTypes = {
	    selectedType: _propTypes2.default.string,
	    color: _propTypes2.default.object,
	    isActive: _propTypes2.default.bool,
	    setColor: _propTypes2.default.func
	};
	
	exports.default = ColorButton;

/***/ }),
/* 2230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class; // Lib
	
	
	// Actions
	
	
	// Components
	
	
	// Constants
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _elementActions = __webpack_require__(26);
	
	var _popupActions = __webpack_require__(35);
	
	var _ColorButton = __webpack_require__(2229);
	
	var _ColorButton2 = _interopRequireDefault(_ColorButton);
	
	var _PopupPanel = __webpack_require__(54);
	
	var _PopupPanel2 = _interopRequireDefault(_PopupPanel);
	
	var _colorConstants = __webpack_require__(479);
	
	var _popupConstants = __webpack_require__(140);
	
	__webpack_require__(1317);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getIsActive = function getIsActive(selectedIds, elements, color) {
	    var isActive = true;
	    selectedIds.forEach(function (elementId) {
	        var element = elements.get(elementId);
	        var elementColor = element.getIn(['content', 'color']);
	        isActive = isActive && (!elementColor && !color || color && elementColor === color.name);
	    });
	    return isActive;
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        setColor: function setColor(color) {
	            var colorName = color ? color.name : null;
	            dispatch((0, _elementActions.updateSelectedElements)({ changes: { color: colorName } }));
	            dispatch((0, _popupActions.closePopup)());
	        }
	    };
	};
	
	var ColorPopup = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec(_class = function (_React$Component) {
	    _inherits(ColorPopup, _React$Component);
	
	    function ColorPopup() {
	        _classCallCheck(this, ColorPopup);
	
	        return _possibleConstructorReturn(this, (ColorPopup.__proto__ || Object.getPrototypeOf(ColorPopup)).apply(this, arguments));
	    }
	
	    _createClass(ColorPopup, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                setColor = _props.setColor,
	                elements = _props.elements,
	                selection = _props.selection,
	                selectedType = _props.selectedType;
	
	
	            return _react2.default.createElement(
	                _PopupPanel2.default,
	                { popupId: 'color', arrowDir: _popupConstants.ARROW_DIR.left, className: 'colorPopup' },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'ul',
	                        { className: 'colors' },
	                        Object.keys(_colorConstants.COLORS).map(function (color) {
	                            return _react2.default.createElement(
	                                'li',
	                                { key: color },
	                                _react2.default.createElement(_ColorButton2.default, {
	                                    selectedType: selectedType,
	                                    setColor: setColor,
	                                    color: _colorConstants.COLORS[color],
	                                    isActive: getIsActive(selection, elements, _colorConstants.COLORS[color]) })
	                            );
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ColorPopup;
	}(_react2.default.Component)) || _class);
	exports.default = ColorPopup;
	
	
	ColorPopup.propTypes = {
	    selectedType: _propTypes2.default.string,
	    selection: _propTypes2.default.object,
	    elements: _propTypes2.default.object,
	    setColor: _propTypes2.default.func
	};

/***/ }),
/* 2231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reselect = __webpack_require__(7);
	
	var _popupOpenSelector = __webpack_require__(141);
	
	var _popupOpenSelector2 = _interopRequireDefault(_popupOpenSelector);
	
	var _selectedElementsSelector = __webpack_require__(127);
	
	var _elementSelector = __webpack_require__(41);
	
	var _ColorToolIcon = __webpack_require__(2232);
	
	var _ColorToolIcon2 = _interopRequireDefault(_ColorToolIcon);
	
	var _ColorPopup = __webpack_require__(2230);
	
	var _ColorPopup2 = _interopRequireDefault(_ColorPopup);
	
	var _Tool = __webpack_require__(110);
	
	var _Tool2 = _interopRequireDefault(_Tool);
	
	var _popupActions = __webpack_require__(35);
	
	var _colorConstants = __webpack_require__(479);
	
	__webpack_require__(1318);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Constants
	
	
	// Components
	var getSelectedColor = function getSelectedColor(selection, elements) {
	    if (elements.get(selection.first())) {
	        return elements.get(selection.first()).getIn(['content', 'color']);
	    }
	
	    return null;
	};
	
	// Actions
	
	
	// Selectors
	// Lib
	
	
	var getSelectedElementType = function getSelectedElementType(selection, elements) {
	    if (elements.get(selection.first())) {
	        return elements.get(selection.first()).get('elementType');
	    }
	
	    return null;
	};
	
	var colorToolSelector = (0, _reselect.createSelector)(_elementSelector.getElements, _selectedElementsSelector.getSelectedElementIds, (0, _popupOpenSelector2.default)('color'), function (elements, selection, popupIsOpen) {
	    return {
	        elements: elements,
	        selection: selection,
	        popupIsOpen: popupIsOpen,
	        selectedColor: getSelectedColor(selection, elements),
	        selectedType: getSelectedElementType(selection, elements)
	    };
	});
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        openColorPopup: function openColorPopup() {
	            return dispatch((0, _popupActions.togglePopup)('color'));
	        }
	    };
	};
	
	var ColorTool = function ColorTool(props) {
	    var openColorPopup = props.openColorPopup,
	        selectedColor = props.selectedColor,
	        selectedType = props.selectedType,
	        popupIsOpen = props.popupIsOpen;
	
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'ColorTool' },
	        _react2.default.createElement(
	            _Tool2.default,
	            { handleClick: openColorPopup, name: 'Color' },
	            _react2.default.createElement(_ColorToolIcon2.default, { selectedType: selectedType, color: _colorConstants.COLORS[selectedColor], isActive: popupIsOpen })
	        ),
	        _react2.default.createElement(_ColorPopup2.default, props)
	    );
	};
	
	ColorTool.propTypes = {
	    openColorPopup: _propTypes2.default.func,
	    selectedColor: _propTypes2.default.string,
	    selectedType: _propTypes2.default.string,
	    popupIsOpen: _propTypes2.default.bool
	};
	
	exports.default = (0, _reactRedux.connect)(colorToolSelector, mapDispatchToProps)(ColorTool);

/***/ }),
/* 2232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1319);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Lib
	var ColorToolIcon = function ColorToolIcon(props) {
	    var color = props.color,
	        isActive = props.isActive,
	        selectedType = props.selectedType;
	
	
	    var classes = {
	        active: isActive,
	        'no-color': !color || !color.hex
	    };
	
	    var iconStyle = color ? { background: color.hex } : {};
	
	    return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('ColorToolIcon', selectedType, classes) },
	        _react2.default.createElement('div', { className: 'color-icon', style: iconStyle })
	    );
	};
	
	// Styles
	
	
	ColorToolIcon.propTypes = {
	    color: _propTypes2.default.object,
	    isActive: _propTypes2.default.bool,
	    selectedType: _propTypes2.default.string
	};
	
	exports.default = ColorToolIcon;

/***/ }),
/* 2233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reselect = __webpack_require__(7);
	
	var _popupOpenSelector = __webpack_require__(141);
	
	var _popupOpenSelector2 = _interopRequireDefault(_popupOpenSelector);
	
	var _iconPopupSelector = __webpack_require__(789);
	
	var _Tool = __webpack_require__(110);
	
	var _Tool2 = _interopRequireDefault(_Tool);
	
	var _ElementIcon = __webpack_require__(428);
	
	var _ElementIcon2 = _interopRequireDefault(_ElementIcon);
	
	var _IconPopup = __webpack_require__(2234);
	
	var _IconPopup2 = _interopRequireDefault(_IconPopup);
	
	var _IconToolImage = __webpack_require__(2235);
	
	var _IconToolImage2 = _interopRequireDefault(_IconToolImage);
	
	var _popupActions = __webpack_require__(35);
	
	__webpack_require__(1320);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Actions
	
	
	// Components
	
	
	// Selectors
	var iconToolSelector = (0, _reselect.createSelector)((0, _popupOpenSelector2.default)('icon'), _iconPopupSelector.popupModeSelector, _iconPopupSelector.selectedIconSelector, _iconPopupSelector.selectedImageSelector, _iconPopupSelector.firstElementIdSelector, function (popupIsOpen, popupMode, selectedIcon, selectedImage, firstElementId) {
	    return {
	        popupIsOpen: popupIsOpen,
	        selectedIcon: selectedIcon,
	        selectedImage: selectedImage,
	        popupMode: popupMode,
	        firstElementId: firstElementId
	    };
	});
	
	// Styles
	
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        openIconPopup: function openIconPopup() {
	            return dispatch((0, _popupActions.togglePopup)('icon'));
	        }
	    };
	};
	
	var IconTool = function IconTool(props) {
	    var openIconPopup = props.openIconPopup,
	        selectedIcon = props.selectedIcon,
	        selectedImage = props.selectedImage,
	        popupIsOpen = props.popupIsOpen;
	
	
	    var iconElement = selectedImage ? _react2.default.createElement(_IconToolImage2.default, { imageSource: selectedImage }) : _react2.default.createElement(_ElementIcon2.default, { icon: selectedIcon });
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'icon-tool-container' },
	        _react2.default.createElement(
	            _Tool2.default,
	            { className: 'IconTool',
	                name: 'Icon',
	                handleClick: openIconPopup,
	                isActive: popupIsOpen },
	            iconElement
	        ),
	        _react2.default.createElement(_IconPopup2.default, props)
	    );
	};
	
	IconTool.propTypes = {
	    gridSize: _propTypes2.default.number.isRequired,
	    openIconPopup: _propTypes2.default.func,
	    selectedIcon: _propTypes2.default.object,
	    popupIsOpen: _propTypes2.default.bool,
	    selectedElements: _propTypes2.default.object,
	    selectedImage: _propTypes2.default.string,
	    firstElementId: _propTypes2.default.string
	};
	
	exports.default = (0, _reactRedux.connect)(iconToolSelector, mapDispatchToProps)(IconTool);

/***/ }),
/* 2234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class; // Lib
	
	
	// Actions
	
	
	// Components
	
	
	// Constants
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _iconsPopupActions = __webpack_require__(790);
	
	var _PopupPanel = __webpack_require__(54);
	
	var _PopupPanel2 = _interopRequireDefault(_PopupPanel);
	
	var _IconTabContent = __webpack_require__(2240);
	
	var _IconTabContent2 = _interopRequireDefault(_IconTabContent);
	
	var _IconPopupModeList = __webpack_require__(2238);
	
	var _IconPopupModeList2 = _interopRequireDefault(_IconPopupModeList);
	
	var _IconPopupSearch = __webpack_require__(2239);
	
	var _IconPopupSearch2 = _interopRequireDefault(_IconPopupSearch);
	
	var _popupConstants = __webpack_require__(140);
	
	var _iconsPopupConstants = __webpack_require__(240);
	
	var _iconPopupSelector = __webpack_require__(789);
	
	var _iconPopupSelector2 = _interopRequireDefault(_iconPopupSelector);
	
	__webpack_require__(1321);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        searchForIcons: function searchForIcons(_ref) {
	            var query = _ref.query,
	                id = _ref.id;
	            return dispatch((0, _iconsPopupActions.findIcons)({ query: query, id: id }));
	        },
	        setModeDefault: function setModeDefault(event) {
	            event.preventDefault();
	            dispatch((0, _iconsPopupActions.setIconPopupMode)({ mode: _iconsPopupConstants.ICON_POPUP_MODE_DEFAULT }));
	        },
	        setMode: function setMode(_ref2) {
	            var mode = _ref2.mode,
	                id = _ref2.id;
	
	            if (!mode) return;
	            dispatch((0, _iconsPopupActions.setIconPopupMode)({ mode: mode, id: id }));
	        }
	    };
	};
	
	var popupModeHasChanged = function popupModeHasChanged(props, nextProps) {
	    return nextProps.popupMode !== props.popupMode;
	};
	var popupModeIsImages = function popupModeIsImages(props) {
	    return props.popupMode === _iconsPopupConstants.ICON_POPUP_MODE_IMAGES;
	};
	var popupBecameActive = function popupBecameActive(props, nextProps) {
	    return nextProps.isActive && !props.isActive;
	};
	
	var shouldSearchForIcons = function shouldSearchForIcons(props, nextProps) {
	    return (popupModeHasChanged(props, nextProps) || popupBecameActive(props, nextProps)) && !popupModeIsImages(nextProps) && !nextProps.iconList;
	};
	
	var IconPopup = (_dec = (0, _reactRedux.connect)(_iconPopupSelector2.default, mapDispatchToProps), _dec(_class = function (_React$Component) {
	    _inherits(IconPopup, _React$Component);
	
	    function IconPopup() {
	        _classCallCheck(this, IconPopup);
	
	        return _possibleConstructorReturn(this, (IconPopup.__proto__ || Object.getPrototypeOf(IconPopup)).apply(this, arguments));
	    }
	
	    _createClass(IconPopup, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var searchForIcons = this.props.searchForIcons;
	
	
	            if (!nextProps.isActive) return;
	
	            // Don't search for icons if the popup mode is images
	            if (shouldSearchForIcons(this.props, nextProps)) {
	                searchForIcons({
	                    query: nextProps.popupQuery,
	                    id: nextProps.selectedElements.first().get('id')
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _PopupPanel2.default,
	                { popupId: 'icon', arrowDir: _popupConstants.ARROW_DIR.left, className: 'iconPopup' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'icon-popup-content' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'mode-menu' },
	                        _react2.default.createElement(_IconPopupModeList2.default, this.props),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'tools' },
	                            _react2.default.createElement(_IconPopupSearch2.default, this.props)
	                        )
	                    ),
	                    _react2.default.createElement(_IconTabContent2.default, this.props)
	                )
	            );
	        }
	    }]);
	
	    return IconPopup;
	}(_react2.default.Component)) || _class);
	exports.default = IconPopup;
	
	
	IconPopup.propTypes = {
	    gridSize: _propTypes2.default.number.isRequired,
	    isActive: _propTypes2.default.bool,
	    selectedElements: _propTypes2.default.object,
	    iconList: _propTypes2.default.object,
	    popupMode: _propTypes2.default.string,
	    modeList: _propTypes2.default.array,
	    popupQuery: _propTypes2.default.string,
	    searchForIcons: _propTypes2.default.func,
	    setModeDefault: _propTypes2.default.func
	};

/***/ }),
/* 2235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _BackgroundImage = __webpack_require__(436);
	
	var _BackgroundImage2 = _interopRequireDefault(_BackgroundImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconToolImage = function IconToolImage(_ref) {
	    var imageSource = _ref.imageSource;
	    return _react2.default.createElement(_BackgroundImage2.default, { className: 'IconToolImage', source: imageSource });
	};
	
	// Components
	// Lib
	
	
	IconToolImage.propTypes = {
	    imageSource: _propTypes2.default.string.isRequired
	};
	
	exports.default = IconToolImage;

/***/ }),
/* 2236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _popupConstants = __webpack_require__(140);
	
	var _iconsPopupConstants = __webpack_require__(240);
	
	var POPUP = _interopRequireWildcard(_iconsPopupConstants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialState = Immutable.Map({
	    mode: POPUP.ICON_POPUP_MODE_DEFAULT,
	    modesMenu: Immutable.Map(),
	    searchResults: Immutable.Map(),
	    elementSearches: Immutable.Map()
	});
	
	var setPopupMode = function setPopupMode(state, action) {
	    var updateState = state;
	    if (action.id) {
	        updateState = state.setIn(['elementSearches', action.id, action.mode], action.mode);
	    }
	    return updateState.set('mode', action.mode);
	};
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _popupConstants.POPUP_OPEN:
	        case _popupConstants.POPUP_TOGGLE:
	            if (action.popupId !== 'icon') return state;
	            return state.set('mode', null);
	        case POPUP.ICON_POPUP_MODE_SET:
	            return setPopupMode(state, action);
	        case POPUP.ICON_POPUP_SEARCH_SUBMIT:
	            return state.setIn(['searchResults', action.query], null);
	        case POPUP.ICON_POPUP_SEARCH_SUCCESS:
	            return state.setIn(['searchResults', action.query], Immutable.fromJS(action.icons));
	        case POPUP.ICON_POPUP_SEARCH_FAILURE:
	            return state.setIn(['searchResults', action.query], Immutable.List());
	        default:
	            return state;
	    }
	};

/***/ }),
/* 2237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _iconsPopupActions = __webpack_require__(790);
	
	__webpack_require__(1322);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Actions
	// Lib
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        changePopupMode: function changePopupMode(event) {
	            event.preventDefault();
	            dispatch((0, _iconsPopupActions.setIconPopupMode)({ mode: ownProps.mode.slug }));
	        }
	    };
	};
	
	// Styles
	
	
	var IconPopupModeButton = function IconPopupModeButton(_ref) {
	    var mode = _ref.mode,
	        popupMode = _ref.popupMode,
	        changePopupMode = _ref.changePopupMode;
	    return _react2.default.createElement(
	        'a',
	        { href: '#',
	            onClick: changePopupMode,
	            className: (0, _classnames2.default)('IconPopupModeButton', { active: mode.slug === popupMode }) },
	        _react2.default.createElement(
	            'span',
	            { className: 'title' },
	            mode.title
	        )
	    );
	};
	
	IconPopupModeButton.propTypes = {
	    mode: _propTypes2.default.object,
	    popupMode: _propTypes2.default.string,
	    changePopupMode: _propTypes2.default.func
	};
	
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(IconPopupModeButton);

/***/ }),
/* 2238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Components
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _IconPopupModeButton = __webpack_require__(2237);
	
	var _IconPopupModeButton2 = _interopRequireDefault(_IconPopupModeButton);
	
	__webpack_require__(1323);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconPopupModeList = function IconPopupModeList(props) {
	    return _react2.default.createElement(
	        'ul',
	        { className: 'IconPopupModeList' },
	        props.modeList.map(function (mode, i) {
	            return _react2.default.createElement(
	                'li',
	                { key: i },
	                _react2.default.createElement(_IconPopupModeButton2.default, _extends({}, props, { mode: mode }))
	            );
	        })
	    );
	};
	
	IconPopupModeList.propTypes = {
	    modeList: _propTypes2.default.array
	};
	
	exports.default = IconPopupModeList;

/***/ }),
/* 2239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(1324);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IconPopupSearch = function (_React$Component) {
	    _inherits(IconPopupSearch, _React$Component);
	
	    function IconPopupSearch(props) {
	        _classCallCheck(this, IconPopupSearch);
	
	        var _this = _possibleConstructorReturn(this, (IconPopupSearch.__proto__ || Object.getPrototypeOf(IconPopupSearch)).call(this, props));
	
	        _this.state = {
	            search: ''
	        };
	
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        _this.handleChange = _this.handleChange.bind(_this);
	        return _this;
	    }
	
	    _createClass(IconPopupSearch, [{
	        key: 'handleSubmit',
	        value: function handleSubmit(event) {
	            event.preventDefault();
	            this.setState({ search: '' });
	            this.props.setMode({
	                mode: this.state.search,
	                id: this.props.selectedElements.first().get('id')
	            });
	        }
	    }, {
	        key: 'handleChange',
	        value: function handleChange(event) {
	            this.setState({ search: event.target.value });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'IconPopupSearch' },
	                _react2.default.createElement(
	                    'form',
	                    { onSubmit: this.handleSubmit },
	                    _react2.default.createElement('input', { placeholder: 'Search icons...',
	                        value: this.state.search,
	                        onChange: this.handleChange })
	                )
	            );
	        }
	    }]);
	
	    return IconPopupSearch;
	}(_react2.default.Component);
	
	exports.default = IconPopupSearch;
	
	
	IconPopupSearch.propTypes = {
	    setMode: _propTypes2.default.func,
	    selectedElements: _propTypes2.default.object
	};

/***/ }),
/* 2240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _IconList = __webpack_require__(2242);
	
	var _IconList2 = _interopRequireDefault(_IconList);
	
	var _IconTabContentImagePicker = __webpack_require__(2246);
	
	var _IconTabContentImagePicker2 = _interopRequireDefault(_IconTabContentImagePicker);
	
	var _iconsPopupConstants = __webpack_require__(240);
	
	__webpack_require__(1325);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Constants
	
	
	// Components
	var IconTabContent = function IconTabContent(props) {
	    var popupMode = props.popupMode;
	
	
	    var contentElement = popupMode === _iconsPopupConstants.ICON_POPUP_MODE_IMAGES ? _react2.default.createElement(_IconTabContentImagePicker2.default, props) : _react2.default.createElement(_IconList2.default, props);
	
	    var scrollable = popupMode !== _iconsPopupConstants.ICON_POPUP_MODE_IMAGES;
	
	    return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('IconTabContent', { scrollable: scrollable }) },
	        _react2.default.createElement(
	            'div',
	            null,
	            contentElement
	        )
	    );
	};
	
	// Styles
	// Lib
	
	
	IconTabContent.propTypes = {
	    popupMode: _propTypes2.default.string
	};
	
	exports.default = IconTabContent;

/***/ }),
/* 2241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(34);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ElementIcon = __webpack_require__(428);
	
	var _ElementIcon2 = _interopRequireDefault(_ElementIcon);
	
	var _elementActions = __webpack_require__(26);
	
	var _popupActions = __webpack_require__(35);
	
	__webpack_require__(1326);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var updateElementsIcon = function updateElementsIcon(icon, selectedElements) {
	    return function (dispatch, getState) {
	        dispatch((0, _elementActions.updateSelectedElements)({ changes: { icon: icon, image: null, attachment: null } }));
	    };
	};
	
	// Styles
	
	
	// Actions
	
	
	// Components
	// Lib
	
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        selectIcon: function selectIcon(event) {
	            dispatch(updateElementsIcon(ownProps.icon.toJS(), ownProps.selectedElements));
	            dispatch((0, _popupActions.closePopup)());
	        }
	    };
	};
	
	var IconButton = function IconButton(props) {
	    return _react2.default.createElement(
	        _Button2.default,
	        { className: (0, _classnames2.default)('IconButton', { active: props.isActive }), onClickFn: props.selectIcon },
	        _react2.default.createElement(_ElementIcon2.default, { icon: props.icon })
	    );
	};
	
	IconButton.propTypes = {
	    icon: _propTypes2.default.object,
	    selectedElements: _propTypes2.default.object,
	    selectIcon: _propTypes2.default.func,
	    isActive: _propTypes2.default.bool
	};
	
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(IconButton);

/***/ }),
/* 2242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _IconButton = __webpack_require__(2241);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _Spinner = __webpack_require__(65);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	__webpack_require__(1327);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getIsActive = function getIsActive(selectedElements, icon) {
	    var isActive = true;
	    selectedElements.forEach(function (element) {
	        var elementIconId = element.getIn(['content', 'icon', 'id']);
	        var iconId = icon && icon.get('id');
	        isActive = isActive && !elementIconId && !iconId || iconId && elementIconId === iconId;
	    });
	    return isActive;
	};
	
	var IconListLoading = function IconListLoading(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'IconList' },
	        _react2.default.createElement(
	            'div',
	            { className: 'iconlist-loading' },
	            _react2.default.createElement(_Spinner2.default, { show: true })
	        )
	    );
	};
	
	var IconListEmpty = function IconListEmpty(_ref) {
	    var popupQuery = _ref.popupQuery,
	        setModeDefault = _ref.setModeDefault;
	    return _react2.default.createElement(
	        'div',
	        { className: 'IconList' },
	        _react2.default.createElement(
	            'div',
	            { className: 'iconlist-loading' },
	            _react2.default.createElement(
	                'div',
	                { className: 'no-results' },
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'No icons found for "',
	                    popupQuery,
	                    '".'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: '#', onClick: setModeDefault },
	                        'See recommended icons'
	                    )
	                )
	            )
	        )
	    );
	};
	
	IconListEmpty.propTypes = {
	    popupQuery: _propTypes2.default.string,
	    setModeDefault: _propTypes2.default.func
	};
	
	var IconListResults = function IconListResults(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'IconList' },
	        _react2.default.createElement(
	            'ul',
	            null,
	            props.iconList.map(function (icon, i) {
	                return _react2.default.createElement(
	                    'li',
	                    { key: i },
	                    _react2.default.createElement(_IconButton2.default, _extends({}, props, { icon: icon, isActive: getIsActive(props.selectedElements, icon) }))
	                );
	            })
	        )
	    );
	};
	
	IconListResults.propTypes = {
	    iconList: _propTypes2.default.object,
	    selectedElements: _propTypes2.default.object
	};
	
	var IconList = function IconList(props) {
	    var iconList = props.iconList;
	
	
	    if (!iconList) return _react2.default.createElement(IconListLoading, props);
	    if (!iconList.size) return _react2.default.createElement(IconListEmpty, props);
	    return _react2.default.createElement(IconListResults, props);
	};
	
	IconList.propTypes = {
	    iconList: _propTypes2.default.object
	};
	
	exports.default = IconList;

/***/ }),
/* 2243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class; // Lib
	
	
	// Decorator
	
	
	// Components
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _imageFileDropTargetDecorator = __webpack_require__(718);
	
	var _imageFileDropTargetDecorator2 = _interopRequireDefault(_imageFileDropTargetDecorator);
	
	var _ImageFileInput = __webpack_require__(444);
	
	var _ImageFileInput2 = _interopRequireDefault(_ImageFileInput);
	
	var _BoardImageUploadIcon = __webpack_require__(2245);
	
	var _BoardImageUploadIcon2 = _interopRequireDefault(_BoardImageUploadIcon);
	
	var _Overlay = __webpack_require__(711);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _BoardImage = __webpack_require__(721);
	
	var _BoardImage2 = _interopRequireDefault(_BoardImage);
	
	__webpack_require__(1328);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BoardImagePicker = (_dec = (0, _imageFileDropTargetDecorator2.default)(), _dec(_class = function (_React$Component) {
	    _inherits(BoardImagePicker, _React$Component);
	
	    function BoardImagePicker() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, BoardImagePicker);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BoardImagePicker.__proto__ || Object.getPrototypeOf(BoardImagePicker)).call.apply(_ref, [this].concat(args))), _this), _this.openFileSelect = function (event) {
	            var imageFileInput = _this.refs.imageFileInput;
	
	            var fileInputDomNode = _reactDom2.default.findDOMNode(imageFileInput);
	            fileInputDomNode.click();
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	    /**
	     * Delegates the click event on the fake file upload input to the real, hidden one.
	     */
	
	
	    _createClass(BoardImagePicker, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                selectedImage = _props.selectedImage,
	                selectedElements = _props.selectedElements,
	                gridSize = _props.gridSize,
	                uploadImage = _props.uploadImage,
	                imageIsHovered = _props.imageIsHovered,
	                imageConnectDropTarget = _props.imageConnectDropTarget;
	
	
	            var firstSelectedElement = selectedElements.first();
	            var overlayText = selectedImage ? 'Change' : 'Upload';
	            var titleText = selectedImage ? 'Change image' : 'Choose an image';
	            var icon = selectedImage ? _react2.default.createElement(
	                'div',
	                { className: 'board-image-wrapper' },
	                _react2.default.createElement(_BoardImage2.default, { element: firstSelectedElement, size: 8, gridSize: gridSize })
	            ) : _react2.default.createElement(_BoardImageUploadIcon2.default, null);
	
	            return imageConnectDropTarget(_react2.default.createElement(
	                'div',
	                { className: 'BoardImagePicker', onClick: this.openFileSelect },
	                _react2.default.createElement(
	                    'div',
	                    { className: (0, _classnames2.default)('overlay-parent', { hovered: imageIsHovered }) },
	                    _react2.default.createElement(_ImageFileInput2.default, { ref: 'imageFileInput', id: 'board', uploadImage: uploadImage }),
	                    icon,
	                    _react2.default.createElement(
	                        _Overlay2.default,
	                        null,
	                        overlayText
	                    )
	                ),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'upload-title' },
	                    titleText
	                )
	            ));
	        }
	    }]);
	
	    return BoardImagePicker;
	}(_react2.default.Component)) || _class);
	
	
	BoardImagePicker.propTypes = {
	    gridSize: _propTypes2.default.number.isRequired,
	    selectedElements: _propTypes2.default.object.isRequired,
	    selectedImage: _propTypes2.default.string,
	    dispatchBoardImage: _propTypes2.default.func,
	    uploadImage: _propTypes2.default.func.isRequired,
	    imageIsHovered: _propTypes2.default.bool,
	    imageConnectDropTarget: _propTypes2.default.func
	};
	
	exports.default = BoardImagePicker;

/***/ }),
/* 2244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class; // Lib
	
	
	// Actions
	
	
	// Utils
	
	
	// Components
	
	
	// Constants
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _elementAttachmentActions = __webpack_require__(142);
	
	var _elementActions = __webpack_require__(26);
	
	var _popupActions = __webpack_require__(35);
	
	var _fileValidator = __webpack_require__(238);
	
	var _undoRedoTransactionManager = __webpack_require__(86);
	
	var _BoardImagePicker = __webpack_require__(2243);
	
	var _BoardImagePicker2 = _interopRequireDefault(_BoardImagePicker);
	
	var _mediaConstants = __webpack_require__(148);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        dispatchBoardImage: function dispatchBoardImage(id, file) {
	            var transactionId = (0, _undoRedoTransactionManager.getNewTransactionId)();
	            dispatch((0, _elementActions.updateElement)({ id: id, changes: { icon: null }, transactionId: transactionId }));
	            dispatch((0, _elementAttachmentActions.uploadAttachment)({ id: id, file: file, imageType: _mediaConstants.IMAGE_TYPES.BOARD, transactionId: transactionId }));
	        },
	        dispatchClosePopup: function dispatchClosePopup() {
	            return dispatch((0, _popupActions.closePopup)());
	        }
	    };
	};
	
	var BoardImagePickerContainer = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec(_class = function (_React$Component) {
	    _inherits(BoardImagePickerContainer, _React$Component);
	
	    function BoardImagePickerContainer() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, BoardImagePickerContainer);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BoardImagePickerContainer.__proto__ || Object.getPrototypeOf(BoardImagePickerContainer)).call.apply(_ref, [this].concat(args))), _this), _this.uploadImage = function (imageFile) {
	            var _this$props = _this.props,
	                dispatchBoardImage = _this$props.dispatchBoardImage,
	                dispatchClosePopup = _this$props.dispatchClosePopup,
	                selectedElements = _this$props.selectedElements;
	
	
	            var validationErrors = (0, _fileValidator.validateImageFile)(imageFile);
	            if (validationErrors) {
	                // TODO if validation errors, show them to the user
	                return;
	            }
	
	            selectedElements.forEach(function (element) {
	                return dispatchBoardImage(element.get('id'), imageFile);
	            });
	            dispatchClosePopup();
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(BoardImagePickerContainer, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(_BoardImagePicker2.default, _extends({}, this.props, { openFileSelect: this.openFileSelect,
	                uploadImage: this.uploadImage }));
	        }
	    }]);
	
	    return BoardImagePickerContainer;
	}(_react2.default.Component)) || _class);
	
	
	BoardImagePickerContainer.propTypes = {
	    gridSize: _propTypes2.default.number.isRequired,
	    selectedElements: _propTypes2.default.object.isRequired,
	    selectedImage: _propTypes2.default.string,
	    dispatchBoardImage: _propTypes2.default.func,
	    dispatchClosePopup: _propTypes2.default.func
	};
	
	exports.default = BoardImagePickerContainer;

/***/ }),
/* 2245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	__webpack_require__(1329);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	var BoardImageUploadIcon = function BoardImageUploadIcon() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'BoardImageUploadIcon' },
	        _react2.default.createElement(_Icon2.default, { name: 'image-form-upload' })
	    );
	};
	
	// Styles
	// Lib
	
	
	BoardImageUploadIcon.propTypes = {};
	
	exports.default = BoardImageUploadIcon;

/***/ }),
/* 2246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _BoardImagePickerContainer = __webpack_require__(2244);
	
	var _BoardImagePickerContainer2 = _interopRequireDefault(_BoardImagePickerContainer);
	
	__webpack_require__(1330);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	// Lib
	var IconTabContentImagePicker = function IconTabContentImagePicker(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'IconTabContentImagePicker' },
	        _react2.default.createElement(_BoardImagePickerContainer2.default, props),
	        _react2.default.createElement(
	            'div',
	            { className: 'instructions' },
	            'Tip: 160 x 160px works best.'
	        )
	    );
	};
	
	// Styles
	
	
	IconTabContentImagePicker.propTypes = {
	    gridSize: _propTypes2.default.number.isRequired,
	    selectedElements: _propTypes2.default.object.isRequired,
	    dispatchBoardImage: _propTypes2.default.func
	};
	
	exports.default = IconTabContentImagePicker;

/***/ }),
/* 2247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	// Components
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _elementActions = __webpack_require__(26);
	
	var _analytics = __webpack_require__(47);
	
	var _elementHelper = __webpack_require__(13);
	
	var _Tool = __webpack_require__(110);
	
	var _Tool2 = _interopRequireDefault(_Tool);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        isActive: (0, _elementHelper.isElementLocked)(ownProps.selectedElements.first())
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        handleMouseDown: function handleMouseDown(event) {
	            var lockValue = (0, _elementHelper.isElementLocked)(ownProps.selectedElements.first());
	            var changes = { locked: !lockValue };
	            dispatch((0, _elementActions.updateSelectedElements)({ changes: changes }));
	
	            var firstElementType = ownProps.selectedElements.first().get('elementType');
	            var lockedUnlocked = !lockValue ? 'locked' : 'unlocked';
	            (0, _analytics.analyticsEvent)(lockedUnlocked + '-' + firstElementType.toLowerCase());
	        }
	    };
	};
	
	var LockTool = function LockTool(props) {
	    return _react2.default.createElement(
	        _Tool2.default,
	        _extends({}, props, { name: props.name, isActive: props.isActive }),
	        _react2.default.createElement(_Icon2.default, { name: props.isActive ? 'toolbar-lock-on' : 'toolbar-lock' })
	    );
	};
	
	LockTool.propTypes = {
	    name: _propTypes2.default.string,
	    isActive: _propTypes2.default.bool
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LockTool);

/***/ }),
/* 2248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Utils
	
	
	// Actions
	
	
	// Components
	
	
	// Constants
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _editorStoreConnect = __webpack_require__(689);
	
	var _editorStoreConnect2 = _interopRequireDefault(_editorStoreConnect);
	
	var _editorStoreSelector = __webpack_require__(691);
	
	var _editorActions = __webpack_require__(690);
	
	var _Tool = __webpack_require__(110);
	
	var _Tool2 = _interopRequireDefault(_Tool);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _richTextConstants = __webpack_require__(166);
	
	__webpack_require__(1331);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapEditorStateToProps = function mapEditorStateToProps(state, ownProps) {
	    var styleCommand = ownProps.styleCommand;
	
	    var editorState = (0, _editorStoreSelector.getEditorState)(state);
	    if (!editorState) return { isActive: false };
	
	    var styleType = _richTextConstants.STYLE_COMMAND_TYPES[styleCommand];
	    if (styleType === _richTextConstants.STYLE_TYPES.BLOCK) {
	        var selection = editorState.getSelection();
	        var blockType = editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();
	        return { isActive: blockType === styleCommand };
	    }
	
	    var inlineStyle = editorState.getCurrentInlineStyle();
	    return { isActive: inlineStyle.has(styleCommand) };
	};
	
	var mapEditorDispatchToProps = function mapEditorDispatchToProps(dispatch, ownProps) {
	    return {
	        handleMouseDown: function handleMouseDown(event) {
	            event.preventDefault();
	            var styleCommand = ownProps.styleCommand;
	
	            dispatch((0, _editorActions.editorStyleChange)({ styleCommand: styleCommand }));
	        }
	    };
	};
	
	var RichTextTool = function RichTextTool(props) {
	    var iconName = props.iconName,
	        isActive = props.isActive;
	
	
	    var iconNameOnOff = isActive ? iconName + '-on' : iconName;
	
	    return _react2.default.createElement(
	        _Tool2.default,
	        _extends({}, props, { isActive: isActive }),
	        _react2.default.createElement(_Icon2.default, { name: iconNameOnOff })
	    );
	};
	
	RichTextTool.propTypes = {
	    name: _propTypes2.default.string,
	    iconName: _propTypes2.default.string.isRequired,
	    styleCommand: _propTypes2.default.string,
	    isActive: _propTypes2.default.bool
	};
	
	exports.default = (0, _editorStoreConnect2.default)(mapEditorStateToProps, mapEditorDispatchToProps)(RichTextTool);

/***/ }),
/* 2249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RichTextTool = __webpack_require__(2248);
	
	var _RichTextTool2 = _interopRequireDefault(_RichTextTool);
	
	var _ToolSeparator = __webpack_require__(787);
	
	var _ToolSeparator2 = _interopRequireDefault(_ToolSeparator);
	
	var _richTextConstants = __webpack_require__(166);
	
	var _captionConstants = __webpack_require__(293);
	
	var _cardConstants = __webpack_require__(111);
	
	__webpack_require__(1332);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Constants
	
	
	// Components
	// Lib
	var RichTextToolList = function RichTextToolList(_ref) {
	    var editorKey = _ref.editorKey;
	
	    var visibleTools = null;
	    if (editorKey === _captionConstants.CAPTION_EDITOR_KEY) {
	        visibleTools = _richTextConstants.INLINE_STYLE_TOOLS;
	    } else if (editorKey === _cardConstants.CARD_TYPE) {
	        visibleTools = _richTextConstants.RICH_STYLE_TOOLS;
	    }
	
	    if (!visibleTools) return null;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'RichTextToolList' },
	        visibleTools.map(function (tool) {
	            return _react2.default.createElement(_RichTextTool2.default, {
	                styleCommand: tool.textCommand,
	                key: tool.textCommand,
	                iconName: tool.iconName });
	        }),
	        _react2.default.createElement(_ToolSeparator2.default, null)
	    );
	};
	
	// Styles
	
	
	RichTextToolList.propTypes = {
	    editorKey: _propTypes2.default.string
	};
	
	exports.default = RichTextToolList;

/***/ }),
/* 2250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	// Components
	
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reselect = __webpack_require__(7);
	
	var _elementActions = __webpack_require__(26);
	
	var _Tool = __webpack_require__(110);
	
	var _Tool2 = _interopRequireDefault(_Tool);
	
	var _Icon = __webpack_require__(11);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	__webpack_require__(1333);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getToolActive = function getToolActive(props) {
	    return props.selectedElements.first().getIn(['content', 'showBackground']);
	};
	
	var shouldShowTool = function shouldShowTool(props) {
	    return props.selectedElements.reduce(function (acc, element) {
	        return acc || element.getIn(['content', 'image', 'transparent']) && !element.getIn(['content', 'color']) && !element.getIn(['content', 'showCaption']);
	    }, false);
	};
	
	var toolSelector = (0, _reselect.createSelector)(function (state, props) {
	    return getToolActive(props);
	}, function (state, props) {
	    return shouldShowTool(props);
	}, function (isActive, showTool) {
	    return {
	        isActive: isActive,
	        showTool: showTool
	    };
	});
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        handleMouseDown: function handleMouseDown(event) {
	            var showBackgroundValue = getToolActive(ownProps);
	            var changes = { showBackground: !showBackgroundValue };
	            dispatch((0, _elementActions.updateSelectedElements)({ changes: changes }));
	        }
	    };
	};
	
	var ShowBackgroundTool = function ShowBackgroundTool(props) {
	    if (!props.showTool) return null;
	
	    return _react2.default.createElement(
	        _Tool2.default,
	        _extends({}, props, { name: props.name, isActive: !props.isActive, className: 'ShowBackgroundTool' }),
	        _react2.default.createElement(_Icon2.default, { name: props.isActive ? 'toolbar-transparent' : 'toolbar-transparent-on' })
	    );
	};
	
	ShowBackgroundTool.propTypes = {
	    name: _propTypes2.default.string,
	    isActive: _propTypes2.default.bool,
	    showTool: _propTypes2.default.bool
	};
	
	exports.default = (0, _reactRedux.connect)(toolSelector, mapDispatchToProps)(ShowBackgroundTool);

/***/ }),
/* 2251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reselect = __webpack_require__(7);
	
	var _currentUserSelector = __webpack_require__(33);
	
	var _boardSelector = __webpack_require__(83);
	
	var _currentBoardIdSelector = __webpack_require__(306);
	
	var _gridSizeSelector = __webpack_require__(66);
	
	var _socketConnectionSelector = __webpack_require__(768);
	
	var _elementSelector = __webpack_require__(41);
	
	var _permissionsService = __webpack_require__(75);
	
	var _permissionUtil = __webpack_require__(89);
	
	var _gridConstants = __webpack_require__(205);
	
	// Selectors
	var elementFilterSelector = (0, _reselect.createSelector)(function (state, ownProps) {
	    return ownProps.location;
	}, function (location) {
	    var query = location.query;
	    if (!Object.keys(query).length) return null;
	
	    var elementFilter = {};
	
	    if (query.filter_after) elementFilter.modifiedAfter = query.filter_after;
	    if (query.filter_before) elementFilter.modifiedBefore = query.filter_before;
	    if (query.filter_user) elementFilter.modifiedBy = query.filter_user.split(',');
	    if (query.filter_ids) elementFilter.ids = query.filter_ids.split(',');
	
	    return elementFilter;
	});
	
	// Utils
	
	
	var getIsDragging = function getIsDragging(state) {
	    return state.getIn(['app', 'dragging', 'isDragging']);
	};
	
	var isMobileViewSelector = (0, _reselect.createSelector)(_gridSizeSelector.getGridSizeName, function (sizeName) {
	    return sizeName === _gridConstants.GRID.MOBILE.name;
	});
	
	var getCurrentBoard = (0, _reselect.createSelector)(_elementSelector.getElements, _currentBoardIdSelector.getCurrentBoardId, function (elements, currentBoardId) {
	    return elements.get(currentBoardId);
	});
	
	var isEditableSelector = (0, _reselect.createSelector)(_elementSelector.getElements, _currentBoardIdSelector.getCurrentBoardId, _currentUserSelector.getCurrentUserId, function (elements, currentBoardId, currentUserId) {
	    return (0, _permissionUtil.canWrite)((0, _permissionsService.getUserPermissions)(elements, currentBoardId, currentUserId));
	});
	
	var pageTitleSelector = (0, _reselect.createSelector)(getCurrentBoard, function (currentBoard) {
	    return currentBoard ? currentBoard.getIn(['content', 'title']) + ' - Milanote' : 'Milanote';
	});
	
	var workspaceSelector = (0, _reselect.createStructuredSelector)({
	    currentBoard: getCurrentBoard,
	    currentBoardId: _currentBoardIdSelector.getCurrentBoardId,
	    isCurrentBoardFetched: _boardSelector.getIsCurrentBoardFetched,
	    isCurrentBoardFetching: _boardSelector.getIsCurrentBoardFetching,
	    isCurrentBoardError: _boardSelector.getIsCurrentBoardError,
	    isEditable: isEditableSelector,
	    pageTitle: pageTitleSelector,
	
	    documentMode: isMobileViewSelector,
	    isMobileView: isMobileViewSelector,
	    gridSize: _gridSizeSelector.getGridSize,
	    isDragging: getIsDragging,
	    elementFilter: elementFilterSelector,
	
	    socketConnected: _socketConnectionSelector.socketConnectedSelector,
	    socketConnection: _socketConnectionSelector.getSocketConnection,
	
	    isGuest: _currentUserSelector.isGuestSelector,
	    currentUser: _currentUserSelector.getCurrentUser,
	    isUserAvailable: _currentUserSelector.isUserAvailableSelector
	});
	
	exports.default = workspaceSelector;

/***/ }),
/* 2252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _aliasConstants = __webpack_require__(241);
	
	var _elementRegistry = __webpack_require__(56);
	
	var _elementConstructor = __webpack_require__(173);
	
	var _elementConstructor2 = _interopRequireDefault(_elementConstructor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var objectConstructorFn = function objectConstructorFn(params) {
	    return _extends({}, (0, _elementConstructor2.default)(params), {
	        elementType: _aliasConstants.ALIAS_TYPE
	    });
	};
	
	exports.default = function () {
	    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return (0, _elementRegistry.registerElementType)(_extends({
	        elementType: _aliasConstants.ALIAS_TYPE,
	        objectConstructorFn: objectConstructorFn,
	        displayName: _aliasConstants.ALIAS_DISPLAY_NAME
	    }, params));
	};

/***/ }),
/* 2253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _boardConstants = __webpack_require__(17);
	
	var _elementRegistry = __webpack_require__(56);
	
	var _elementConstructor = __webpack_require__(173);
	
	var _elementConstructor2 = _interopRequireDefault(_elementConstructor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var objectConstructorFn = function objectConstructorFn(params) {
	    var content = params.content,
	        acl = params.acl;
	
	    return _extends({}, (0, _elementConstructor2.default)(params), {
	        elementType: _boardConstants.BOARD_TYPE,
	        content: _extends({
	            title: _boardConstants.BOARD_DEFAULT_TITLE,
	            icon: null,
	            color: null
	        }, content),
	        acl: acl
	    });
	};
	
	exports.default = function () {
	    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return (0, _elementRegistry.registerElementType)(_extends({
	        elementType: _boardConstants.BOARD_TYPE,
	        objectConstructorFn: objectConstructorFn,
	        displayName: _boardConstants.BOARD_DISPLAY_NAME
	    }, params));
	};

/***/ }),
/* 2254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _cardConstants = __webpack_require__(111);
	
	var _elementRegistry = __webpack_require__(56);
	
	var _elementConstructor = __webpack_require__(173);
	
	var _elementConstructor2 = _interopRequireDefault(_elementConstructor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var objectConstructorFn = function objectConstructorFn(params) {
	    var content = params.content;
	
	    return _extends({}, (0, _elementConstructor2.default)(params), {
	        elementType: _cardConstants.CARD_TYPE,
	        content: _extends({
	            textContent: null
	        }, content)
	    });
	};
	
	exports.default = function () {
	    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return (0, _elementRegistry.registerElementType)(_extends({
	        elementType: _cardConstants.CARD_TYPE,
	        objectConstructorFn: objectConstructorFn,
	        displayName: _cardConstants.CARD_DISPLAY_NAME
	    }, params));
	};

/***/ }),
/* 2255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _columnConstants = __webpack_require__(207);
	
	var _elementRegistry = __webpack_require__(56);
	
	var _elementConstructor = __webpack_require__(173);
	
	var _elementConstructor2 = _interopRequireDefault(_elementConstructor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var objectConstructorFn = function objectConstructorFn(params) {
	    var content = params.content;
	
	    return _extends({}, (0, _elementConstructor2.default)(params), {
	        elementType: _columnConstants.COLUMN_TYPE,
	        content: _extends({
	            title: _columnConstants.COLUMN_DEFAULT_TITLE
	        }, content)
	    });
	};
	
	exports.default = function () {
	    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return (0, _elementRegistry.registerElementType)(_extends({
	        elementType: _columnConstants.COLUMN_TYPE,
	        objectConstructorFn: objectConstructorFn,
	        displayName: _columnConstants.COLUMN_DISPLAY_NAME
	    }, params));
	};

/***/ }),
/* 2256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _elementHelper = __webpack_require__(13);
	
	var _boardConstants = __webpack_require__(17);
	
	var _cardConstants = __webpack_require__(111);
	
	exports.default = function (elementType) {
	    if ((0, _elementHelper.isBoardLike)(elementType)) return _boardConstants.BOARD_TYPE;
	
	    if ((0, _elementHelper.isCard)(elementType) || (0, _elementHelper.isLink)(elementType) || (0, _elementHelper.isColumn)(elementType)) return _cardConstants.CARD_TYPE;
	
	    return elementType;
	};

/***/ }),
/* 2257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.findColumnClusters = exports.findTopLevelClusters = exports.findClusters = undefined;
	
	var _dendrogram = __webpack_require__(791);
	
	var dendrogramLib = _interopRequireWildcard(_dendrogram);
	
	var _screePlot = __webpack_require__(792);
	
	var screePlotLib = _interopRequireWildcard(_screePlot);
	
	var _cluster = __webpack_require__(482);
	
	var clusterLib = _interopRequireWildcard(_cluster);
	
	var _clusterDistance = __webpack_require__(2258);
	
	var distanceLib = _interopRequireWildcard(_clusterDistance);
	
	var _documentOrderAlgorithmConstants = __webpack_require__(320);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var findClusters = exports.findClusters = function findClusters(initialClusters, distanceFn, autoClusterDistance) {
	    if (initialClusters.length <= 1) {
	        return {
	            clusters: initialClusters,
	            dendrogramData: {},
	            elbowPointData: {},
	            earlyExit: true
	        };
	    }
	
	    // Create a Dendrogram & Scree plot
	    var dendrogramData = dendrogramLib.createDendrogram(initialClusters, distanceFn, autoClusterDistance);
	
	    // Split the dendrogram into its clusters
	    var elbowPointData = screePlotLib.findElbowPoint(dendrogramData.screePlot);
	
	    return {
	        clusters: dendrogramLib.getClustersBelow(dendrogramData.rootCluster, elbowPointData.elbowPoint.height),
	        dendrogramData: dendrogramData,
	        elbowPointData: elbowPointData,
	        earlyExit: false
	    };
	};
	
	// Constants
	/**
	 * Functions to build an array of clusters.
	 */
	
	// Utils
	var findTopLevelClusters = exports.findTopLevelClusters = function findTopLevelClusters(documentElements) {
	    // First initial singleton clusters
	    var initialClusters = documentElements.map(clusterLib.createLeafCluster);
	    return findClusters(initialClusters, distanceLib.anyClusterSide, _documentOrderAlgorithmConstants.AUTO_CLUSTER_DISTANCE);
	};
	
	var findColumnClusters = exports.findColumnClusters = function findColumnClusters(cluster) {
	    // First get the leaf clusters (singleton clustors) of this cluster
	    var initialClusters = dendrogramLib.getLeafClusters(cluster);
	    return findClusters(initialClusters, distanceLib.clusterTopAndBottom, _documentOrderAlgorithmConstants.AUTO_COLUMN_DISTANCE);
	};

/***/ }),
/* 2258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.anyClusterSide = exports.clusterTopAndBottom = exports.topAndBottom = undefined;
	
	var _rect = __webpack_require__(481);
	
	var rectLib = _interopRequireWildcard(_rect);
	
	var _documentOrderAlgorithmConstants = __webpack_require__(320);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Lib
	var topAndBottom = exports.topAndBottom = function topAndBottom(rect1, rect2) {
	    return rectLib.isVerticallyInline(rect1, rect2, _documentOrderAlgorithmConstants.COLUMN_OVERLAP_THRESHOLD) ? _documentOrderAlgorithmConstants.AUTO_COLUMN_DISTANCE : _documentOrderAlgorithmConstants.MAX_DIST_BETWEEN_BOTTOM_AND_TOP;
	};
	
	// Constants
	var clusterTopAndBottom = exports.clusterTopAndBottom = function clusterTopAndBottom(cluster1, cluster2) {
	    return topAndBottom(cluster1.bounds, cluster2.bounds);
	};
	
	// √
	var adjustForCategory = function adjustForCategory(cat1, cat2, dist, adjustment) {
	    return cat1 === cat2 ? adjustment(cat1) * dist : dist;
	};
	var adjustForColor = function adjustForColor(cluster1, cluster2, dist) {
	    return adjustForCategory(cluster1.color, cluster2.color, dist, function () {
	        return _documentOrderAlgorithmConstants.SAME_COLOR_ADJUSTMENT;
	    });
	};
	var adjustForType = function adjustForType(cluster1, cluster2, dist) {
	    return adjustForCategory(cluster1.type, cluster2.type, dist, function (type) {
	        return _documentOrderAlgorithmConstants.SAME_TYPE_ADJUSTMENTS[type] || 1;
	    });
	};
	
	var clusterAdjustmentsPipeline = [adjustForColor, adjustForType];
	var anyClusterSide = exports.anyClusterSide = function anyClusterSide(cluster1, cluster2) {
	    var dist = rectLib.distanceFromAnySide(cluster1.bounds, cluster2.bounds);
	    return clusterAdjustmentsPipeline.reduce(function (adjustedDist, adjustmentFn) {
	        return adjustmentFn(cluster1, cluster2, adjustedDist);
	    }, dist);
	};

/***/ }),
/* 2259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.columnSort = exports.columnSortFn = exports.columnElementsSort = exports.naturalReadingSort = exports.getIndexOfClosestCluster = undefined;
	
	var _point = __webpack_require__(242);
	
	var pointLib = _interopRequireWildcard(_point);
	
	var _line = __webpack_require__(480);
	
	var lineLib = _interopRequireWildcard(_line);
	
	var _cluster = __webpack_require__(482);
	
	var clustersLib = _interopRequireWildcard(_cluster);
	
	var _dendrogram = __webpack_require__(791);
	
	var dendrogramLib = _interopRequireWildcard(_dendrogram);
	
	var _documentOrderAlgorithmConstants = __webpack_require__(320);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /**
	                                                                                                                                                                                                     * Functions responsible for sorting clusters.
	                                                                                                                                                                                                     */
	
	// Utils
	
	
	// Constants
	
	
	/**
	 * Finds the closest cluster to a set of points.
	 */
	var getIndexOfClosestCluster = exports.getIndexOfClosestCluster = function getIndexOfClosestCluster(clusters, fromPoints, pointSelectionFn) {
	    return clusters.reduce(function (acc, cluster, index) {
	        var toPoint = pointSelectionFn(cluster);
	
	        fromPoints.forEach(function (fromPoint) {
	            var distanceModifier = fromPoint.distanceModifier || 1;
	            var dist = pointLib.getDistance(fromPoint, toPoint) * distanceModifier;
	            if (dist < acc.minDist) {
	                acc.minDist = dist;
	                acc.clusterIndex = index;
	                acc.closestLine = lineLib.getLine(fromPoint, toPoint);
	            }
	        });
	
	        return acc;
	    }, { minDist: Infinity, clusterIndex: null, closestLine: null });
	};
	
	var sortClusters = function sortClusters(clusters, startingPoint) {
	    var pointsToReadFrom = [startingPoint];
	    var clustersToBeRead = [].concat(_toConsumableArray(clusters));
	
	    var sortedClusters = [];
	    // For debugging purposes
	    var readingLines = [];
	
	    var closestClusterDetails = getIndexOfClosestCluster(clustersToBeRead, pointsToReadFrom, clustersLib.getAverageTopLeft);
	
	    while (closestClusterDetails.clusterIndex !== null) {
	        // Remove the cluster we just read
	        var clusterToReadNext = clustersToBeRead.splice(closestClusterDetails.clusterIndex, 1)[0];
	        sortedClusters.push(clusterToReadNext);
	
	        readingLines.push(closestClusterDetails.closestLine);
	
	        // Make the next points to read the top right and bottom left points of the added cluster
	        var clusterBottomLeftPoint = clustersLib.getAverageBottomLeft(clusterToReadNext);
	        var clusterTopRightPoint = clustersLib.getAverageTopRight(clusterToReadNext);
	        clusterTopRightPoint.distanceModifier = _documentOrderAlgorithmConstants.ELEMENT_TOP_RIGHT_READING_MODIFIER;
	
	        pointsToReadFrom = [clusterBottomLeftPoint, clusterTopRightPoint];
	        closestClusterDetails = getIndexOfClosestCluster(clustersToBeRead, pointsToReadFrom, clustersLib.getAverageTopLeft);
	    }
	
	    return {
	        sortedClusters: sortedClusters,
	        readingLines: readingLines
	    };
	};
	
	/**
	 * Sorts clusters based on a natural reading order.
	 */
	var naturalReadingSort = exports.naturalReadingSort = function naturalReadingSort(clusters) {
	    // Start reading from the top of the canvas
	    var canvasTopLeft = pointLib.getPoint(0, 0);
	    return sortClusters(clusters, canvasTopLeft);
	};
	
	var columnElementsSort = exports.columnElementsSort = function columnElementsSort(columnCluster) {
	    var clustersToBeRead = dendrogramLib.getLeafClusters(columnCluster);
	    // Start reading from the column top left
	    var columnTopLeft = clustersLib.getAbsoluteTopLeft(columnCluster);
	    return sortClusters(clustersToBeRead, columnTopLeft);
	};
	
	var columnSortFn = exports.columnSortFn = function columnSortFn(columnA, columnB) {
	    return clustersLib.getAbsoluteCenterLeft(columnA).x - clustersLib.getAbsoluteCenterLeft(columnB).x;
	};
	
	var columnSort = exports.columnSort = function columnSort(columnClusters) {
	    var sortedClusters = columnClusters.sort(columnSortFn);
	    var readingData = sortedClusters.reduce(function (lineData, cluster) {
	        var toPoint = clustersLib.getAbsoluteTopLeft(cluster);
	        if (lineData.fromPoint) {
	            var line = lineLib.getLine(lineData.fromPoint, toPoint);
	            lineData.lines.push(line);
	        }
	        lineData.fromPoint = toPoint;
	        return lineData;
	    }, { fromPoint: null, lines: [] });
	
	    return {
	        sortedClusters: sortedClusters,
	        readingLines: readingData.lines
	    };
	};

/***/ }),
/* 2260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.collapseDocumentElementOrder = exports.buildDocumentModeData = exports.buildTopLevelClusterData = exports.buildColumnClusterData = exports.buildElementClusterData = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _clusterBuilder = __webpack_require__(2257);
	
	var clusterBuilder = _interopRequireWildcard(_clusterBuilder);
	
	var _clusterSorter = __webpack_require__(2259);
	
	var clusterSorter = _interopRequireWildcard(_clusterSorter);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } // Lib
	
	
	// Utils
	
	
	/**
	 * Builds the element level (leaf) cluster data.
	 */
	var buildElementClusterData = exports.buildElementClusterData = function buildElementClusterData(elementCluster) {
	    return {
	        cluster: elementCluster
	    };
	};
	
	/**
	 * Builds the column level cluster data which includes sorted element children and data relating to how the children
	 * were sorted.
	 */
	var buildColumnClusterData = exports.buildColumnClusterData = function buildColumnClusterData(columnCluster) {
	    var orderedElementsData = clusterSorter.columnElementsSort(columnCluster);
	    var children = orderedElementsData.sortedClusters.map(buildElementClusterData);
	
	    return {
	        cluster: columnCluster,
	        readingData: orderedElementsData.readingLines,
	        children: children
	    };
	};
	
	/**
	 * Builds the top level cluster which includes column clusters as children and the data relating to how those columns
	 * were found and sorted.
	 */
	var buildTopLevelClusterData = exports.buildTopLevelClusterData = function buildTopLevelClusterData(topLevelCluster) {
	    var columnClusterSearchData = clusterBuilder.findColumnClusters(topLevelCluster);
	    var sortedColumnClustersData = clusterSorter.columnSort(columnClusterSearchData.clusters);
	    var children = sortedColumnClustersData.sortedClusters.map(buildColumnClusterData);
	
	    return {
	        cluster: topLevelCluster,
	        dendrogramData: columnClusterSearchData.dendrogramData,
	        elbowPointData: columnClusterSearchData.elbowPointData,
	        readingData: sortedColumnClustersData.readingLines,
	        children: children
	    };
	};
	
	/**
	 * Builds the document mode data which includes the top level clusters as children (which in turn have column children
	 * which have element children) as well as the data relating to how the top level clusters were found and sorted.
	 */
	var buildDocumentModeData = exports.buildDocumentModeData = function buildDocumentModeData(documentElements) {
	    // First level clusters
	    var topLevelClusterSearchData = clusterBuilder.findTopLevelClusters(documentElements);
	    var sortedClusterData = clusterSorter.naturalReadingSort(topLevelClusterSearchData.clusters);
	    var children = sortedClusterData.sortedClusters.map(buildTopLevelClusterData);
	
	    return {
	        dendrogramData: topLevelClusterSearchData.dendrogramData,
	        elbowPointData: topLevelClusterSearchData.elbowPointData,
	        earlyExit: topLevelClusterSearchData.earlyExit,
	        readingData: sortedClusterData.readingLines,
	        children: children
	    };
	};
	
	var collapseDocumentElementOrder = exports.collapseDocumentElementOrder = function collapseDocumentElementOrder(documentModeData) {
	    return _lodash.concat.apply(undefined, [[]].concat(_toConsumableArray(documentModeData.children.map(function (topLevelClusterData) {
	        return _lodash.concat.apply(undefined, [[]].concat(_toConsumableArray(topLevelClusterData.children.map(function (columnClusterData) {
	            return columnClusterData.children.map(function (elementCluster) {
	                return elementCluster.cluster.id;
	            });
	        }))));
	    }))));
	};

/***/ }),
/* 2261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.mergeEdges = exports.getEdges = undefined;
	
	var _rect = __webpack_require__(481);
	
	var rectLib = _interopRequireWildcard(_rect);
	
	var _line = __webpack_require__(480);
	
	var lineLib = _interopRequireWildcard(_line);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// √
	var getEdges = exports.getEdges = function getEdges(rect1) {
	    return ['left', 'right', 'top', 'bottom'].reduce(function (obj, prop) {
	        obj[prop] = rectLib.getLineFromRect(rect1, prop);
	        return obj;
	    }, {});
	};
	
	// √
	var mergeEdges = exports.mergeEdges = function mergeEdges(edges1, edges2) {
	    return {
	        left: lineLib.getNewLine(edges1.left, edges2.left, lineLib.lineComparison.leftmost),
	        right: lineLib.getNewLine(edges1.right, edges2.right, lineLib.lineComparison.rightmost),
	        top: lineLib.getNewLine(edges1.top, edges2.top, lineLib.lineComparison.upper),
	        bottom: lineLib.getNewLine(edges1.bottom, edges2.bottom, lineLib.lineComparison.lower)
	    };
	};

/***/ }),
/* 2262 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// TODO Might want to perf test this - This is using immutable data
	var addCluster = exports.addCluster = function addCluster(distanceMatrix, clusters, newCluster, distanceFn) {
	    return clusters.reduce(function (updatedDistanceMatrix, existingCluster) {
	        // if this is this cluster don't create an entry for it
	        if (existingCluster.id === newCluster.id) {
	            return updatedDistanceMatrix;
	        }
	
	        // TODO PERF Potentially only add once per cluster
	        var distance = distanceFn(newCluster, existingCluster);
	        updatedDistanceMatrix.matrix[newCluster.id] = updatedDistanceMatrix.matrix[newCluster.id] || {};
	        updatedDistanceMatrix.matrix[newCluster.id][existingCluster.id] = distance;
	
	        updatedDistanceMatrix.distances = [].concat(_toConsumableArray(updatedDistanceMatrix.distances), [{ dist: distance, clusters: [newCluster.id, existingCluster.id] }]);
	
	        updatedDistanceMatrix.sorted = false;
	
	        return updatedDistanceMatrix;
	    }, _extends({}, distanceMatrix)) // Map of ID : ID : dist
	    ;
	};
	
	var getDistance = exports.getDistance = function getDistance(distanceMatrix, cluster1Id, cluster2Id) {
	    if (!isNaN(distanceMatrix.matrix[cluster1Id][cluster2Id])) {
	        return distanceMatrix.matrix[cluster1Id][cluster2Id];
	    } else if (!isNaN(distanceMatrix.matrix[cluster2Id][cluster1Id])) {
	        return distanceMatrix.matrix[cluster2Id][cluster1Id];
	    }
	    return Infinity;
	};
	
	var createDistanceMatrix = exports.createDistanceMatrix = function createDistanceMatrix(clusters, distanceFn) {
	    return (
	        // Create a map to every distance from every cluster
	        clusters.reduce(function (allDistanceMap, cluster) {
	            return addCluster(allDistanceMap, clusters, cluster, distanceFn);
	        }, { distances: [], matrix: {}, sorted: false })
	    );
	};
	
	var removeClusters = exports.removeClusters = function removeClusters(distanceMatrix, cluster1Id, cluster2Id) {
	    // Remove any distances which match the cluster IDs
	    var distances = distanceMatrix.distances.filter(function (distEntry) {
	        return distEntry.clusters.indexOf(cluster1Id) === -1 && distEntry.clusters.indexOf(cluster2Id) === -1;
	    });
	
	    // Remove the entries in the matrix for both clusters
	    // const matrix = omit(distanceMatrix.matrix, [cluster1Id, cluster2Id]);
	
	    return _extends({}, distanceMatrix, {
	        distances: distances
	    });
	};
	
	var sortByMinDist = exports.sortByMinDist = function sortByMinDist(distEntryA, distEntryB) {
	    return distEntryA.dist - distEntryB.dist;
	};
	
	var getMinDistance = exports.getMinDistance = function getMinDistance(distanceMatrix) {
	    var distances = distanceMatrix.distances;
	    if (!distanceMatrix.sorted) {
	        distances = distances.sort(sortByMinDist);
	    }
	    return distances[0];
	};

/***/ }),
/* 2263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.electronAppWake = exports.electronAppSleep = exports.autoUpdateError = exports.autoUpdateForcePoll = exports.autoUpdateCheckComplete = exports.autoUpdateCheckForUpdates = exports.autoUpdateInstallUpdate = exports.autoUpdateComplete = exports.autoUpdateAvailable = undefined;
	
	var _electronConstants = __webpack_require__(321);
	
	var autoUpdateAvailable = exports.autoUpdateAvailable = function autoUpdateAvailable() {
	    return {
	        type: _electronConstants.AUTOUPDATE_DOWNLOAD_START
	    };
	};
	
	var autoUpdateComplete = exports.autoUpdateComplete = function autoUpdateComplete(_ref) {
	    var name = _ref.name,
	        date = _ref.date,
	        notes = _ref.notes,
	        url = _ref.url;
	    return {
	        name: name,
	        date: date,
	        notes: notes,
	        url: url,
	        type: _electronConstants.AUTOUPDATE_DOWNLOAD_COMPLETE
	    };
	};
	
	var autoUpdateInstallUpdate = exports.autoUpdateInstallUpdate = function autoUpdateInstallUpdate() {
	    return {
	        type: _electronConstants.AUTOUPDATE_UPDATE_INSTALL
	    };
	};
	
	var autoUpdateCheckForUpdates = exports.autoUpdateCheckForUpdates = function autoUpdateCheckForUpdates() {
	    return {
	        type: _electronConstants.AUTOUPDATE_CHECK_START
	    };
	};
	
	var autoUpdateCheckComplete = exports.autoUpdateCheckComplete = function autoUpdateCheckComplete() {
	    return {
	        type: _electronConstants.AUTOUPDATE_CHECK_COMPLETE
	    };
	};
	
	var autoUpdateForcePoll = exports.autoUpdateForcePoll = function autoUpdateForcePoll() {
	    return {
	        type: _electronConstants.AUTOUPDATE_FORCE_POLL
	    };
	};
	
	var autoUpdateError = exports.autoUpdateError = function autoUpdateError(_ref2) {
	    var error = _ref2.error;
	    return {
	        type: _electronConstants.AUTOUPDATE_ERROR,
	        error: error
	    };
	};
	
	var electronAppSleep = exports.electronAppSleep = function electronAppSleep() {
	    return {
	        type: _electronConstants.ELECTRON_APP_SLEEP
	    };
	};
	
	var electronAppWake = exports.electronAppWake = function electronAppWake() {
	    return {
	        type: _electronConstants.ELECTRON_APP_WAKE
	    };
	};

/***/ }),
/* 2264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FallbackExportComponent = function FallbackExportComponent(_ref) {
	    var element = _ref.element;
	    return _react2.default.createElement(
	        'p',
	        null,
	        'Export not supported for element type: ',
	        element.elementType
	    );
	};
	
	FallbackExportComponent.propTypes = {
	    element: _propTypes2.default.object
	};
	
	exports.default = FallbackExportComponent;

/***/ }),
/* 2265 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (_ref) {
	  var element = _ref.element;
	  return "Could not export element (element type: " + element.elementType + ", id: " + element.id + ")";
	};

/***/ }),
/* 2266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.element = undefined;
	
	var _elementConstants = __webpack_require__(12);
	
	var TYPES = _interopRequireWildcard(_elementConstants);
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _elementRegistry = __webpack_require__(56);
	
	var elementFactory = _interopRequireWildcard(_elementRegistry);
	
	var _elementReducerAttachments = __webpack_require__(2267);
	
	var _elementReducerAttachments2 = _interopRequireDefault(_elementReducerAttachments);
	
	var _elementReducerIcons = __webpack_require__(2268);
	
	var _elementReducerIcons2 = _interopRequireDefault(_elementReducerIcons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialState = Immutable.Map();
	
	var createElement = function createElement(state, action) {
	    return Immutable.fromJS(elementFactory.createElementObject(action));
	};
	
	var shareElement = function shareElement(state, action) {
	    var acl = state.get('acl') || Immutable.Map();
	    acl = acl.set(action.userId, action.permissions);
	    return state.set('acl', acl);
	};
	
	var unshareElement = function unshareElement(state, action) {
	    var acl = state.get('acl') || Immutable.Map();
	    acl = acl.delete(action.userId);
	    return state.set('acl', acl);
	};
	
	var applyChangesToElement = function applyChangesToElement(state, _ref, changes) {
	    var modified = _ref.modified;
	    return state.update('content', function (content) {
	        return content.merge(Immutable.fromJS(changes));
	    }).setIn(['meta', 'modifiedTime'], modified);
	};
	
	var updateElement = function updateElement(state, action) {
	    var id = state.get('id');
	    var update = action.updates.filter(function (updateEntry) {
	        return updateEntry.id === id;
	    })[0];
	    return applyChangesToElement(state, action, update.changes);
	};
	
	var applyMoveToElement = function applyMoveToElement(state, _ref2, location) {
	    var modified = _ref2.modified;
	
	    if (!location.parentId || !location.section || !location.position) return state;
	    if (location.parentId === state.get('id')) return state;
	
	    return state.set('location', Immutable.fromJS(location)).setIn(['meta', 'modifiedTime'], modified);
	};
	
	var multiMoveElement = function multiMoveElement(state, action) {
	    var id = state.get('id');
	    var move = action.moves.filter(function (moveEntry) {
	        return moveEntry.id === id;
	    })[0];
	    return applyMoveToElement(state, action, move.location);
	};
	
	var moveAndUpdateElement = function moveAndUpdateElement(state, action) {
	    return state.withMutations(function (mutableState) {
	        applyMoveToElement(mutableState, action, action.location);
	        applyChangesToElement(mutableState, action, action.changes);
	    });
	};
	
	var setElementType = function setElementType(state, action) {
	    return state.set('elementType', action.elementType);
	};
	
	/**
	 * Element Reducer.
	 * Handles actions for individual elements.
	 * This is always delegated to by the elementsReducer (it is not part of the reducer hierarchy created using
	 * 'combineReducers').
	 *
	 * @param state {Element Object} The element that needs to respond to the action.
	 * @param action {Object} The redux action to respond to.
	 *
	 * @returns {Object} The new state of the element.
	 */
	var element = exports.element = function element() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case TYPES.ELEMENT_SHARE:
	            return shareElement(state, action);
	        case TYPES.ELEMENT_UNSHARE:
	            return unshareElement(state, action);
	        case TYPES.ELEMENT_CREATE:
	            return createElement(state, action);
	        case TYPES.ELEMENT_MOVE_MULTI:
	            return multiMoveElement(state, action);
	        case TYPES.ELEMENT_UPDATE:
	            return updateElement(state, action);
	        case TYPES.ELEMENT_SET_TYPE:
	            return setElementType(state, action);
	        case TYPES.ELEMENT_MOVE_AND_UPDATE:
	            return moveAndUpdateElement(state, action);
	        // Attachment uploads
	        case TYPES.ELEMENT_ATTACHMENT_UPLOADING:
	        case TYPES.ELEMENT_ATTACHMENT_UPLOAD_COMPLETED:
	        case TYPES.ELEMENT_ATTACHMENT_CLEAN:
	        case TYPES.ELEMENT_ATTACHMENT_DATA_READY:
	        case TYPES.ELEMENT_ATTACHMENT_UPLOAD_PROGRESSED:
	        case TYPES.ELEMENT_ATTACHMENT_UPLOAD_ERROR:
	        case TYPES.ELEMENT_ATTACHMENT_CLEAR_ERROR:
	            return (0, _elementReducerAttachments2.default)(state, action);
	        case TYPES.ELEMENT_ICON_FIND:
	        case TYPES.ELEMENT_ICON_FIND_SUCCESS:
	        case TYPES.ELEMENT_ICON_FIND_FAILURE:
	        case TYPES.ELEMENT_ICON_SEARCH:
	            return (0, _elementReducerIcons2.default)(state, action);
	        // On socket disconnection mark every element as stale so it will be re-fetched
	        default:
	            return state;
	    }
	};

/***/ }),
/* 2267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _elementConstants = __webpack_require__(12);
	
	var TYPES = _interopRequireWildcard(_elementConstants);
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Attachment Uploads
	var uploadingAttachment = function uploadingAttachment(state, action) {
	    var stateUpdate = {
	        attachment: {
	            fetching: true,
	            fetched: false
	        }
	    };
	    return state.mergeDeep(stateUpdate);
	};
	var attachmentDataReady = function attachmentDataReady(state, action) {
	    var stateUpdate = {
	        attachment: {
	            data: action.attachmentData
	        }
	    };
	    return state.mergeDeep(stateUpdate);
	};
	var updateAttachmentProgress = function updateAttachmentProgress(state, action) {
	    return state.setIn(['attachment', 'percentageComplete'], action.percentageComplete);
	};
	
	var completeAttachmentUpload = function completeAttachmentUpload(state, action) {
	    var stateUpdate = {
	        attachment: {
	            fetching: false,
	            fetched: true
	        }
	    };
	    return state.mergeDeep(stateUpdate);
	};
	
	var attachmentError = function attachmentError(state, action) {
	    var stateUpdate = {
	        attachment: {
	            data: null,
	            error: action.error,
	            fetching: false
	        }
	    };
	    return state.mergeDeep(stateUpdate);
	};
	
	var cleanAttachment = function cleanAttachment(state, action) {
	    return state.set('attachment', Immutable.Map());
	};
	
	exports.default = function (state, action) {
	    switch (action.type) {
	        case TYPES.ELEMENT_ATTACHMENT_UPLOADING:
	            return uploadingAttachment(state, action);
	        case TYPES.ELEMENT_ATTACHMENT_UPLOAD_COMPLETED:
	            return completeAttachmentUpload(state, action);
	        case TYPES.ELEMENT_ATTACHMENT_CLEAN:
	            return cleanAttachment(state, action);
	        case TYPES.ELEMENT_ATTACHMENT_DATA_READY:
	            return attachmentDataReady(state, action);
	        case TYPES.ELEMENT_ATTACHMENT_UPLOAD_PROGRESSED:
	            return updateAttachmentProgress(state, action);
	        case TYPES.ELEMENT_ATTACHMENT_UPLOAD_ERROR:
	            return attachmentError(state, action);
	        case TYPES.ELEMENT_ATTACHMENT_CLEAR_ERROR:
	            return cleanAttachment(state, action);
	        default:
	            return state;
	    }
	};

/***/ }),
/* 2268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _elementConstants = __webpack_require__(12);
	
	var TYPES = _interopRequireWildcard(_elementConstants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Attachment Uploads
	var findingIcon = function findingIcon(state, action) {
	    return state.update('content', function (content) {
	        return content.merge({ icon: { fetching: true } });
	    });
	};
	
	var findingIconComplete = function findingIconComplete(state, action) {
	    return state.update('content', function (content) {
	        return content.merge({ icon: { fetching: false } });
	    });
	};
	
	exports.default = function (state, action) {
	    switch (action.type) {
	        case TYPES.ELEMENT_ICON_FIND:
	            return findingIcon(state, action);
	        case TYPES.ELEMENT_ICON_FIND_SUCCESS:
	        case TYPES.ELEMENT_ICON_FIND_FAILURE:
	            return findingIconComplete(state, action);
	        default:
	            return state;
	    }
	};

/***/ }),
/* 2269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getElementChildrenSorted = exports.getElementChildren = exports.getElement = undefined;
	
	var _reselect = __webpack_require__(7);
	
	var _boardConstants = __webpack_require__(17);
	
	var _elementHelper = __webpack_require__(13);
	
	var getElement = exports.getElement = (0, _reselect.createSelector)(function (state) {
	    return state.get('elements');
	}, function (state, props) {
	    return props.elementId;
	}, function (elements, elementId) {
	    return { element: elements.get(elementId) };
	});
	
	var getElementChildren = exports.getElementChildren = function getElementChildren() {
	    return (0, _reselect.createSelector)(function (state) {
	        return state.get('elements');
	    }, function (state, props) {
	        return props.element.get('id');
	    }, function (elements, elementId) {
	        return (0, _elementHelper.getChildren)(elements, elementId);
	    });
	};
	
	var getElementChildrenSorted = exports.getElementChildrenSorted = function getElementChildrenSorted() {
	    return (0, _reselect.createSelector)(getElementChildren(), function (children) {
	        return (0, _elementHelper.getSortedChildrenInSection)(children, _boardConstants.BOARD_SECTIONS.INBOX);
	    });
	};

/***/ }),
/* 2270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = elements;
	
	var _immutable = __webpack_require__(8);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	var _fp = __webpack_require__(52);
	
	var _elementHelper = __webpack_require__(13);
	
	var _scoreCalculator = __webpack_require__(794);
	
	var _elementReducer = __webpack_require__(2266);
	
	var _elementConstants = __webpack_require__(12);
	
	var TYPES = _interopRequireWildcard(_elementConstants);
	
	var _elementsConstants = __webpack_require__(322);
	
	var ELEMENTS_ACTION_TYPES = _interopRequireWildcard(_elementsConstants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Constants
	var initialState = Immutable.Map();
	
	// Reducers
	
	
	// Utils
	// Lib
	
	
	var loadElements = function loadElements(state, action) {
	    var updatedState = state;
	    if (action.deletedElementIds && action.deletedElementIds.length) {
	        updatedState = updatedState.filter(function (el) {
	            return !(0, _fp.includes)(el.get('id'), action.deletedElementIds);
	        });
	    }
	
	    return updatedState.mergeDeep(action.elements);
	};
	
	var createElement = function createElement(state, action) {
	    // step 1: create the element
	    var newElement = (0, _elementReducer.element)(null, action);
	    if (!newElement) return state;
	
	    // step 2: insert element into the master element Map
	    return state.set(newElement.get('id'), newElement);
	};
	
	var deleteElement = function deleteElement(state, action) {
	    return state.delete(action.id);
	};
	
	/**
	 * Delegates the handling of the action to each element in the action's ids list.
	 * If an element does not exist, does nothing.
	 */
	var delegateToEachElementIfExists = function delegateToEachElementIfExists(iterablePropName) {
	    return function (state, action) {
	        return state.withMutations(function (mutableState) {
	            action[iterablePropName].forEach(function (prop) {
	                // If we don't have the element then we cannot update it
	                if (!mutableState.get(prop.id)) return;
	                mutableState.update(prop.id, function (el) {
	                    return (0, _elementReducer.element)(el, action);
	                });
	            });
	        });
	    };
	};
	
	var delegateUpdateToEachElementIfExists = delegateToEachElementIfExists('updates');
	var delegateMoveToEachElementIfExists = delegateToEachElementIfExists('moves');
	
	/**
	 * Delegates the handling of the action to the element which has been specified in the action.id.
	 * If the element does not exist, does nothing.
	 */
	var delegateToElementIfExists = function delegateToElementIfExists(state, action) {
	    // If we don't have the element then we cannot update it
	    if (!state.get(action.id)) return state;
	    return state.update(action.id, function (el) {
	        return (0, _elementReducer.element)(el, action);
	    });
	};
	
	var resetScores = function resetScores(state, action) {
	    // Gets the inbox children in sorted order based on their current scores
	    var inboxChildren = (0, _elementHelper.getSortedChildrenInSection)(state, action.section, action.parentId);
	    // Calculates the new 'reset' scores to use for each child
	    var resetScoresArray = (0, _scoreCalculator.calculateResetScores)(inboxChildren.length);
	
	    // Loop over each child (in order) and replace their current score with the new, reset score.
	    var updatedInboxElementMap = inboxChildren.reduce(function (elementMap, inboxElement, index) {
	        elementMap[inboxElement.get('id')] = inboxElement.setIn(['location', 'position', 'score'], resetScoresArray[index]);
	        return elementMap;
	    }, {});
	
	    return state.merge(updatedInboxElementMap);
	};
	
	/**
	 *
	 * @param state
	 * @param action
	 * @returns {*}
	 */
	function elements() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case ELEMENTS_ACTION_TYPES.ELEMENTS_LOAD:
	            return loadElements(state, action);
	        case TYPES.ELEMENT_CREATE:
	            return createElement(state, action);
	        case TYPES.ELEMENT_DELETE:
	            return deleteElement(state, action);
	        case TYPES.ELEMENT_UPDATE:
	            return delegateUpdateToEachElementIfExists(state, action);
	        case TYPES.ELEMENT_MOVE_MULTI:
	            return delegateMoveToEachElementIfExists(state, action);
	        case TYPES.ELEMENT_SET_TYPE:
	        case TYPES.ELEMENT_UNSHARE:
	        case TYPES.ELEMENT_SHARE:
	        case TYPES.ELEMENT_MOVE_AND_UPDATE:
	            return delegateToElementIfExists(state, action);
	        // Attachment uploads
	        case TYPES.ELEMENT_ATTACHMENT_UPLOADING:
	        case TYPES.ELEMENT_ATTACHMENT_DATA_READY:
	        case TYPES.ELEMENT_ATTACHMENT_UPLOAD_PROGRESSED:
	        case TYPES.ELEMENT_ATTACHMENT_UPLOAD_COMPLETED:
	        case TYPES.ELEMENT_ATTACHMENT_CLEAN:
	        case TYPES.ELEMENT_ATTACHMENT_UPLOAD_ERROR:
	        case TYPES.ELEMENT_ATTACHMENT_CLEAR_ERROR:
	        case TYPES.ELEMENT_ICON_FIND:
	        case TYPES.ELEMENT_ICON_FIND_SUCCESS:
	        case TYPES.ELEMENT_ICON_FIND_FAILURE:
	        case TYPES.ELEMENT_ICON_SEARCH:
	            return delegateToElementIfExists(state, action);
	        case ELEMENTS_ACTION_TYPES.ELEMENTS_RESET_SCORES:
	            return resetScores(state, action);
	        // TODO Restructure so that the elements reducer is no longer in 'common'
	        case 'LOGIN_SUBMIT':
	            return initialState;
	        default:
	            return state;
	    }
	}

/***/ }),
/* 2271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.generateUniqueErrorId = undefined;
	
	var _timestamp = __webpack_require__(486);
	
	var _randomString = __webpack_require__(2288);
	
	var _randomString2 = _interopRequireDefault(_randomString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var generateUniqueErrorId = exports.generateUniqueErrorId = function generateUniqueErrorId() {
	  return (0, _timestamp.createTimestamp)(new Date()) + (0, _randomString2.default)(3);
	};

/***/ }),
/* 2272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _imageConstants = __webpack_require__(87);
	
	var _elementRegistry = __webpack_require__(56);
	
	var _elementConstructor = __webpack_require__(173);
	
	var _elementConstructor2 = _interopRequireDefault(_elementConstructor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var objectConstructorFn = function objectConstructorFn(params) {
	    var content = params.content;
	
	    return _extends({}, (0, _elementConstructor2.default)(params), {
	        elementType: _imageConstants.IMAGE_TYPE,
	        content: _extends({
	            image: null
	        }, content)
	    });
	};
	
	exports.default = function () {
	    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return (0, _elementRegistry.registerElementType)(_extends({
	        elementType: _imageConstants.IMAGE_TYPE,
	        objectConstructorFn: objectConstructorFn,
	        displayName: _imageConstants.IMAGE_DISPLAY_NAME
	    }, params));
	};

/***/ }),
/* 2273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _lineConstants = __webpack_require__(57);
	
	var _elementRegistry = __webpack_require__(56);
	
	var _elementConstructor = __webpack_require__(173);
	
	var _elementConstructor2 = _interopRequireDefault(_elementConstructor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var objectConstructorFn = function objectConstructorFn(params) {
	    var _extends2;
	
	    var content = params.content;
	
	    return _extends({}, (0, _elementConstructor2.default)(params), {
	        elementType: _lineConstants.LINE_TYPE,
	        content: _extends((_extends2 = {}, _defineProperty(_extends2, _lineConstants.LINE_EDGE.start, {
	            x: 0,
	            y: _lineConstants.DEFAULT_LINE_HEIGHT
	        }), _defineProperty(_extends2, _lineConstants.LINE_EDGE.end, {
	            x: _lineConstants.DEFAULT_LINE_WIDTH,
	            y: 0
	        }), _defineProperty(_extends2, 'startStyle', _lineConstants.LINE_MARKER_STYLE.NONE), _defineProperty(_extends2, 'endStyle', _lineConstants.LINE_MARKER_STYLE.ARROW), _defineProperty(_extends2, 'lineStyle', _lineConstants.LINE_STYLE.SOLID), _defineProperty(_extends2, 'textContent', null), _extends2), content)
	    });
	};
	
	exports.default = function () {
	    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return (0, _elementRegistry.registerElementType)(_extends({
	        elementType: _lineConstants.LINE_TYPE,
	        objectConstructorFn: objectConstructorFn,
	        displayName: _lineConstants.LINE_DISPLAY_NAME
	    }, params));
	};

/***/ }),
/* 2274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _linkConstants = __webpack_require__(174);
	
	var _elementRegistry = __webpack_require__(56);
	
	var _elementConstructor = __webpack_require__(173);
	
	var _elementConstructor2 = _interopRequireDefault(_elementConstructor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var objectConstructorFn = function objectConstructorFn(params) {
	    var content = params.content;
	
	    return _extends({}, (0, _elementConstructor2.default)(params), {
	        elementType: _linkConstants.LINK_TYPE,
	        content: _extends({
	            url: null
	        }, content)
	    });
	};
	
	exports.default = function () {
	    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return (0, _elementRegistry.registerElementType)(_extends({
	        elementType: _linkConstants.LINK_TYPE,
	        objectConstructorFn: objectConstructorFn,
	        displayName: _linkConstants.LINK_DISPLAY_NAME
	    }, params));
	};

/***/ }),
/* 2275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isTextLink = undefined;
	
	var _validationConstants = __webpack_require__(36);
	
	var isTextLink = exports.isTextLink = function isTextLink(text) {
	  return text && text.split('\n').length === 1 && text.match(_validationConstants.URL_REGEX);
	};

/***/ }),
/* 2276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _fp = __webpack_require__(52);
	
	/**
	 * Ensures a value lies within a range.
	 */
	exports.default = (0, _fp.curry)(function (rangeStart, rangeMax, value) {
	  return Math.max(Math.min(value, rangeMax), rangeStart);
	}); // Lib

/***/ }),
/* 2277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.lineIntersection = exports.lineIntersectionPoints = undefined;
	
	var _point = __webpack_require__(50);
	
	// Required to avoid javascript rounding errors
	var ERROR_MARGIN = 0.1; // Geometry Utils
	
	
	var pointIsOnLine = function pointIsOnLine(x, y, x1, y1, x2, y2) {
	    var minX = Math.min(x1, x2);
	    var maxX = Math.max(x1, x2);
	    var minY = Math.min(y1, y2);
	    var maxY = Math.max(y1, y2);
	
	    return x >= minX - ERROR_MARGIN && x <= maxX + ERROR_MARGIN && y >= minY - ERROR_MARGIN && y <= maxY + ERROR_MARGIN;
	};
	
	// From http://pomax.github.io/bezierinfo/#intersections
	var lineIntersectionAlgebra = function lineIntersectionAlgebra(x1, y1, x2, y2, x3, y3, x4, y4) {
	    var nx = (x1 * y2 - y1 * x2) * (x3 - x4) - (x1 - x2) * (x3 * y4 - y3 * x4);
	    var ny = (x1 * y2 - y1 * x2) * (y3 - y4) - (y1 - y2) * (x3 * y4 - y3 * x4);
	    var d = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
	
	    if (d === 0) return null;
	
	    var x = nx / d;
	    var y = ny / d;
	
	    return pointIsOnLine(x, y, x1, y1, x2, y2) && pointIsOnLine(x, y, x3, y3, x4, y4) ? (0, _point.getPoint)(x, y) : null;
	};
	
	var lineIntersectionPoints = exports.lineIntersectionPoints = function lineIntersectionPoints(l1Start, l1End, l2Start, l2End) {
	    return lineIntersectionAlgebra(l1Start.x, l1Start.y, l1End.x, l1End.y, l2Start.x, l2Start.y, l2End.x, l2End.y);
	};
	
	var lineIntersection = exports.lineIntersection = function lineIntersection(line1, line2) {
	    return lineIntersectionPoints(line1.start, line1.end, line2.start, line2.end);
	};

/***/ }),
/* 2278 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var getLine = exports.getLine = function getLine(point1, point2) {
	    return {
	        start: point1,
	        end: point2
	    };
	};

/***/ }),
/* 2279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getCentrePoint = exports.getTopLeftPoint = undefined;
	
	var _point = __webpack_require__(50);
	
	var getTopLeftPoint = exports.getTopLeftPoint = function getTopLeftPoint(measurements) {
	    return (0, _point.getPoint)(measurements.left, measurements.top);
	};
	
	var getCentrePoint = exports.getCentrePoint = function getCentrePoint(measurements) {
	    return (0, _point.getPoint)(measurements.left + measurements.width / 2, measurements.top + measurements.height / 2);
	};

/***/ }),
/* 2280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _httpConstants = __webpack_require__(90);
	
	var _timeUtil = __webpack_require__(43);
	
	// Constants
	exports.default = function (mediaHttp) {
	    return {
	        exportBoard: function exportBoard(_ref) {
	            var boardId = _ref.boardId,
	                format = _ref.format,
	                htmlDOM = _ref.htmlDOM;
	
	            var requestConfig = {
	                url: 'export/' + boardId,
	                method: _httpConstants.METHODS.POST,
	                timeout: _timeUtil.TIMES.MINUTE,
	                data: {
	                    format: format,
	                    htmlDOM: htmlDOM
	                }
	            };
	
	            return mediaHttp(requestConfig);
	        }
	    };
	};

/***/ }),
/* 2281 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _httpConstants = __webpack_require__(90);
	
	var _timeUtil = __webpack_require__(43);
	
	var FormData = global.FormData || __webpack_require__(1354);
	
	// Constants
	
	// TODO Currently only supports images
	//
	exports.default = function (mediaHttp) {
	    return {
	        uploadMediaFile: function uploadMediaFile(file, options) {
	            var data = new FormData();
	            data.append('file', file);
	            data.append('options', JSON.stringify(options));
	
	            var requestConfig = {
	                url: 'image',
	                method: _httpConstants.METHODS.POST,
	                timeout: 5 * _timeUtil.TIMES.MINUTE,
	                data: data
	            };
	
	            if (data.getHeaders) {
	                requestConfig.headers = data.getHeaders();
	            }
	
	            return mediaHttp(requestConfig);
	        }
	    };
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 2282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _httpConstants = __webpack_require__(90);
	
	var _timeUtil = __webpack_require__(43);
	
	// Constants
	exports.default = function (mediaHttp) {
	    return {
	        fetchLink: function fetchLink(_ref) {
	            var id = _ref.id,
	                url = _ref.url;
	
	            var requestConfig = {
	                url: 'link',
	                method: _httpConstants.METHODS.POST,
	                timeout: _timeUtil.TIMES.MINUTE,
	                data: {
	                    url: url,
	                    elementId: id
	                }
	            };
	
	            return mediaHttp(requestConfig);
	        },
	        fetchLinkAttachment: function fetchLinkAttachment(_ref2) {
	            var id = _ref2.id,
	                url = _ref2.url;
	
	            var requestConfig = {
	                url: 'link/attachments',
	                method: _httpConstants.METHODS.POST,
	                timeout: _timeUtil.TIMES.MINUTE,
	                data: {
	                    url: url,
	                    elementId: id
	                }
	            };
	
	            return mediaHttp(requestConfig);
	        }
	    };
	};

/***/ }),
/* 2283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib
	
	
	// Constants
	
	
	var _axios = __webpack_require__(489);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _timeUtil = __webpack_require__(43);
	
	var _httpConstants = __webpack_require__(90);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_MEDIA_SERVER_HTTP_CONFIG = {
	    method: _httpConstants.METHODS.GET,
	    timeout: 2 * _timeUtil.TIMES.SECOND,
	    responseType: 'json'
	};
	
	exports.default = function (apiUrl, jwtToken) {
	    return function (httpConfig) {
	        var axiosConfig = _extends({}, DEFAULT_MEDIA_SERVER_HTTP_CONFIG, httpConfig);
	
	        if (jwtToken) {
	            axiosConfig.headers = _extends({}, axiosConfig.headers, {
	                Authorization: 'Bearer ' + jwtToken
	            });
	        }
	
	        axiosConfig.url = apiUrl + '/' + httpConfig.url;
	
	        return (0, _axios2.default)(axiosConfig);
	    };
	};

/***/ }),
/* 2284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createMediaHttpService = __webpack_require__(2283);
	
	var _createMediaHttpService2 = _interopRequireDefault(_createMediaHttpService);
	
	var _createExportApi = __webpack_require__(2280);
	
	var _createExportApi2 = _interopRequireDefault(_createExportApi);
	
	var _createImageApi = __webpack_require__(2281);
	
	var _createImageApi2 = _interopRequireDefault(_createImageApi);
	
	var _createLinkApi = __webpack_require__(2282);
	
	var _createLinkApi2 = _interopRequireDefault(_createLinkApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (apiUrl, jwtToken) {
	    var mediaHttp = (0, _createMediaHttpService2.default)(apiUrl, jwtToken);
	
	    return {
	        export: (0, _createExportApi2.default)(mediaHttp),
	        image: (0, _createImageApi2.default)(mediaHttp),
	        link: (0, _createLinkApi2.default)(mediaHttp)
	    };
	};

/***/ }),
/* 2285 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _CURRENCY;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var CURRENCY_TYPES = exports.CURRENCY_TYPES = {
	    EUR: 'EUR',
	    JPY: 'JPY',
	    GBP: 'GBP',
	    AUD: 'AUD',
	    USD: 'USD'
	};
	
	var CURRENCY = exports.CURRENCY = (_CURRENCY = {
	    default: {
	        symbol: '$'
	    }
	}, _defineProperty(_CURRENCY, CURRENCY_TYPES.EUR, {
	    code: CURRENCY_TYPES.EUR,
	    symbol: '€'
	}), _defineProperty(_CURRENCY, CURRENCY_TYPES.JPY, {
	    code: CURRENCY_TYPES.JPY,
	    symbol: '¥'
	}), _defineProperty(_CURRENCY, CURRENCY_TYPES.GBP, {
	    code: CURRENCY_TYPES.GBP,
	    symbol: '£'
	}), _CURRENCY);

/***/ }),
/* 2286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getReferralDescription = exports.getReferralBonus = undefined;
	
	var _immutableHelper = __webpack_require__(23);
	
	var _userConstants = __webpack_require__(32);
	
	var getReferralBonus = exports.getReferralBonus = function getReferralBonus(referral) {
	    return (0, _immutableHelper.prop)('cards', referral) || _userConstants.CONTENT_LIMIT_REFERRAL_MULTIPLIER;
	};
	
	var getReferralDescription = exports.getReferralDescription = function getReferralDescription(referral) {
	    return (0, _immutableHelper.prop)('description', referral);
	};

/***/ }),
/* 2287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _base = __webpack_require__(246);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _padLeft = __webpack_require__(800);
	
	var _padLeft2 = _interopRequireDefault(_padLeft);
	
	var _uidConstants = __webpack_require__(487);
	
	var _timestamp = __webpack_require__(486);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (clientId, clientIdTick) {
	    var timestamp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Date().getTime();
	
	    var time = (0, _timestamp.createTimestamp)(timestamp);
	    var tick = _base2.default.encode(clientIdTick % _uidConstants.TICK_MAX);
	    return time + clientId + (0, _padLeft2.default)(tick, '00');
	};

/***/ }),
/* 2288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _base = __webpack_require__(246);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _padLeft = __webpack_require__(800);
	
	var _padLeft2 = _interopRequireDefault(_padLeft);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createPad = function createPad(length) {
	    return new Array(length).join('0');
	};
	
	exports.default = function (length) {
	    var randomVal = Math.floor(Math.random() * Math.pow(62, length));
	    return (0, _padLeft2.default)(_base2.default.encode(randomVal), createPad(length));
	};

/***/ }),
/* 2289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.refreshUser = exports.updateUser = exports.userMarkAsDisconnected = exports.userDisconnect = exports.userConnect = undefined;
	
	var _timeUtil = __webpack_require__(43);
	
	var _userConstants = __webpack_require__(32);
	
	// Utils
	var userConnect = exports.userConnect = function userConnect(userId) {
	    return {
	        type: _userConstants.USER_CONNECT,
	        userId: userId,
	        timestamp: (0, _timeUtil.getTimestamp)()
	    };
	};
	
	// Constants
	var userDisconnect = exports.userDisconnect = function userDisconnect(userId) {
	    return {
	        type: _userConstants.USER_DISCONNECT,
	        userId: userId,
	        timestamp: (0, _timeUtil.getTimestamp)()
	    };
	};
	
	var userMarkAsDisconnected = exports.userMarkAsDisconnected = function userMarkAsDisconnected(userId) {
	    return {
	        type: _userConstants.USER_MARK_AS_DISCONNECTED,
	        userId: userId,
	        timestamp: (0, _timeUtil.getTimestamp)()
	    };
	};
	
	var updateUser = exports.updateUser = function updateUser(_ref) {
	    var userId = _ref.userId,
	        changes = _ref.changes,
	        _ref$sync = _ref.sync,
	        sync = _ref$sync === undefined ? true : _ref$sync;
	    return {
	        type: _userConstants.USER_UPDATE,
	        userId: userId,
	        changes: changes,
	        sync: sync
	    };
	};
	
	/**
	 * Update user merges changes onto the user, refresh user overwrites that user.
	 */
	var refreshUser = exports.refreshUser = function refreshUser(_ref2) {
	    var userId = _ref2.userId,
	        user = _ref2.user;
	    return {
	        type: _userConstants.USER_REFRESH,
	        userId: userId,
	        user: user
	    };
	};

/***/ }),
/* 2290 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	// This could potentially instead be associated with element types
	var MEDIA_STORAGE_URL = exports.MEDIA_STORAGE_URL = 'https://media.milanote.com/';
	var MEDIA_STORAGE_BUCKET = exports.MEDIA_STORAGE_BUCKET = 'milanote';
	
	var FILE_TYPES = exports.FILE_TYPES = {
	    IMAGE: {
	        name: 'image',
	        mimePattern: /^image\/(png|gif|jpe?g)/g,
	        maxSize: 10 * 1024 * 1024
	    }
	};

/***/ }),
/* 2291 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _httpStatusCodes = __webpack_require__(575);
	
	var _httpStatusCodes2 = _interopRequireDefault(_httpStatusCodes);
	
	var _delay = __webpack_require__(2293);
	
	var _delay2 = _interopRequireDefault(_delay);
	
	var _httpConstants = __webpack_require__(90);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Utils
	var isServerError = function isServerError(err) {
	    return err.response && err.response.status >= _httpStatusCodes2.default.INTERNAL_SERVER_ERROR;
	};
	
	// Constants
	// Lib
	
	var isTimeoutError = function isTimeoutError(err) {
	    return err.code === _httpConstants.ERROR_CODES.CONNECTION_ABORTED || err.code === _httpConstants.ERROR_CODES.CONNECTION_RESET;
	};
	var isRetriableError = function isRetriableError(err) {
	    return isServerError(err) || isTimeoutError(err);
	};
	var hasRetryConfig = function hasRetryConfig(err) {
	    return err.config && err.config.retry && err.config._retryCount !== err.config.retry;
	};
	
	var POWER = 3;
	// milliseconds
	var INITIAL_DELAY = 100;
	
	// Server error delay will have an exponential back off
	// 100ms, 800ms, 2.7s, 6.4s...
	var getServerErrorDelay = function getServerErrorDelay(err) {
	    return INITIAL_DELAY * Math.pow(err.config._retryCount, POWER);
	};
	// Timeout error delay will multiply the timeout by the number of retries in case the server is overloaded
	var getTimeoutErrorDelay = function getTimeoutErrorDelay(err) {
	    return err.config.timeout * err.config._retryCount;
	};
	var getDelay = function getDelay(err) {
	    return isTimeoutError(err) ? getTimeoutErrorDelay(err) : getServerErrorDelay(err);
	};
	
	exports.default = function (axiosInstance, errorCb) {
	    return function (err) {
	        // Don't retry if not configured to or it's not a retriable error
	        if (!hasRetryConfig(err) || !isRetriableError(err)) throw err;
	
	        err.config._retryCount = err.config._retryCount || 0;
	        errorCb && errorCb(err);
	
	        err.config._retryCount = err.config._retryCount + 1;
	        var delayTime = getDelay(err);
	
	        return (0, _delay2.default)(delayTime).then(function () {
	            return axiosInstance(err.config);
	        });
	    };
	};

/***/ }),
/* 2292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(4);
	
	exports.default = (0, _lodash.curry)(function (combiningFn, obj1, obj2) {
	    return (0, _lodash.mapValues)(obj2, function (val1, property) {
	        return combiningFn(val1, obj1[property]);
	    });
	}); // Lib

/***/ }),
/* 2293 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	/**
	 * Promisified timeout.
	 */
	exports.default = function (time) {
	  return new Promise(function (resolve) {
	    return setTimeout(function () {
	      return resolve();
	    }, time);
	  });
	};

/***/ }),
/* 2294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _fp = __webpack_require__(52);
	
	exports.default = (0, _fp.curryN)(2, function () {
	    var predicateArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var args = arguments[1];
	    return predicateArray.reduce(function (passing, predicateFn) {
	        return passing && predicateFn(args);
	    }, true);
	}); // Lib

/***/ }),
/* 2295 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var rIC = window.requestIdleCallback || window.setTimeout;
	exports.default = rIC;

/***/ }),
/* 2296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _rIC = __webpack_require__(2295);
	
	var _rIC2 = _interopRequireDefault(_rIC);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var usePolyfill = !window.requestIdleCallback;
	
	/**
	 * requestIdleCallback polyfill.
	 */
	
	exports.default = function (fn) {
	    var callbackId = void 0;
	
	    var throttled = function throttled() {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        var latestArgs = args;
	        // If we have already requested an animation frame, return
	        if (callbackId) return;
	
	        // Wait an animation frame
	        callbackId = (0, _rIC2.default)(function () {
	            callbackId = null;
	            fn.apply(undefined, latestArgs);
	        });
	    };
	
	    throttled.cancel = function () {
	        if (!callbackId) return;
	        usePolyfill ? clearTimeout(callbackId) : window.cancelIdleCallback(callbackId);
	        callbackId = null;
	    };
	
	    return throttled;
	};

/***/ }),
/* 2297 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var numbersAscending = exports.numbersAscending = function numbersAscending(n1, n2) {
	  return n1 - n2;
	};
	var numbersDescending = exports.numbersDescending = function numbersDescending(n1, n2) {
	  return n2 - n1;
	};

/***/ }),
/* 2298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _fieldValidationService = __webpack_require__(488);
	
	var _fieldValidationService2 = _interopRequireDefault(_fieldValidationService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Uses the registered validators to determine whether the specified field value is valid given its field config.
	 *
	 * @param fieldValues {Object} An object with properties of field names and values of field values.
	 * @param fieldValidationConfigs {Object} An object that specifies the validation config for each of the fields to
	 *          validate.
	 * @returns {Object} An object with properties for each of the fields, the value of each property is an error object
	 *          for that field, or null if the field is valid.
	 */
	exports.default = function (fieldValues, fieldValidationConfigs) {
	    var errors = {};
	    var isValid = true;
	
	    // Loop over each field config and validate based on it
	    for (var fieldConfigPropName in fieldValidationConfigs) {
	        if (!fieldValidationConfigs.hasOwnProperty(fieldConfigPropName)) continue;
	
	        var fieldConfig = fieldValidationConfigs[fieldConfigPropName];
	        var fieldName = fieldConfig.name;
	        var fieldValue = fieldValues[fieldName];
	
	        // Perform the validation using the 'validator service'
	        errors[fieldName] = (0, _fieldValidationService2.default)(fieldValue, fieldConfig);
	        isValid = isValid && !errors[fieldName];
	    }
	
	    return {
	        isValid: isValid,
	        errors: errors
	    };
	};

/***/ }),
/* 2299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.maxLengthValidator = exports.typeValidator = exports.requiredValidator = undefined;
	
	var _requiredValidator2 = __webpack_require__(2301);
	
	var _requiredValidator3 = _interopRequireDefault(_requiredValidator2);
	
	var _typeValidator2 = __webpack_require__(2311);
	
	var _typeValidator3 = _interopRequireDefault(_typeValidator2);
	
	var _maxLengthValidator2 = __webpack_require__(2300);
	
	var _maxLengthValidator3 = _interopRequireDefault(_maxLengthValidator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.requiredValidator = _requiredValidator3.default;
	exports.typeValidator = _typeValidator3.default;
	exports.maxLengthValidator = _maxLengthValidator3.default;

/***/ }),
/* 2300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _validationConstants = __webpack_require__(36);
	
	/**
	 * Returns an error object if the field config has a max length and the field's value is longer than the max length.
	 * Otherwise returns null.
	 */
	exports.default = function (fieldValue, validationConfig) {
	    // If there's no maxlength validation, or the field's length is less than the max length, don't return an error
	    if (!validationConfig.maxLength || validationConfig.maxLength >= fieldValue.length) return null;
	
	    return {
	        name: _validationConstants.FAILURE_NAMES.maxlength,
	        type: _validationConstants.FAILURE_TYPES.ERROR,
	        debounced: true,
	        message: 'Must be less than ' + validationConfig.maxLength + ' characters'
	    };
	};

/***/ }),
/* 2301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _validationConstants = __webpack_require__(36);
	
	var ERROR_OBJECT = {
	    name: _validationConstants.FAILURE_NAMES.required,
	    type: _validationConstants.FAILURE_TYPES.ERROR,
	    hideBeforeSubmit: true,
	    hideIfTouched: true
	};
	
	/**
	 * Returns an error object if a field's config states that the field is required, but the field does not have a value.
	 * Otherwise, returns null.
	 */
	
	exports.default = function (fieldValue, validationConfig) {
	    return validationConfig.required && !fieldValue ? _extends({}, ERROR_OBJECT, { fieldName: validationConfig.name }) : null;
	};

/***/ }),
/* 2302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _validationConstants = __webpack_require__(36);
	
	var DATE_ERROR_OBJECT = {
	    name: _validationConstants.FAILURE_NAMES.date,
	    type: _validationConstants.FAILURE_TYPES.ERROR,
	    debounced: true,
	    message: 'Not a valid date'
	};
	
	exports.default = function (fieldValue, validationConfig) {
	    if (!fieldValue) return;
	
	    var numericValue = parseInt(fieldValue, 10);
	    if (isNaN(numericValue)) return DATE_ERROR_OBJECT;
	
	    var date = new Date(numericValue);
	    if (isNaN(date.getTime())) return DATE_ERROR_OBJECT;
	
	    return null;
	};

/***/ }),
/* 2303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _validationConstants = __webpack_require__(36);
	
	var _idValidator = __webpack_require__(799);
	
	var ELEMENT_ID_ERROR_OBJECT = {
	    name: _validationConstants.FAILURE_NAMES.elementId,
	    type: _validationConstants.FAILURE_TYPES.ERROR,
	    message: 'Not a valid elementId'
	};
	
	exports.default = function (fieldValue, validationConfig) {
	    if (!fieldValue) return;
	
	    if (!(0, _idValidator.isElementId)(fieldValue)) return ELEMENT_ID_ERROR_OBJECT;
	
	    return null;
	};

/***/ }),
/* 2304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _validationConstants = __webpack_require__(36);
	
	var EMAIL_ERROR_OBJECT = {
	    name: _validationConstants.FAILURE_NAMES.email,
	    type: _validationConstants.FAILURE_TYPES.ERROR,
	    debounced: true,
	    message: 'Not a valid email'
	};
	
	var getErrorObject = function getErrorObject(fieldValue, validationConfig) {
	    return _extends({}, EMAIL_ERROR_OBJECT, {
	        value: fieldValue,
	        hideBeforeSubmit: !!validationConfig.hideBeforeSubmit
	    });
	};
	
	exports.default = function (fieldValue, validationConfig) {
	    if (!fieldValue) return null;
	    if (!fieldValue.match(_validationConstants.EMAIL_REGEX)) return getErrorObject(fieldValue, validationConfig);
	    return null;
	};

/***/ }),
/* 2305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(4);
	
	var _validationConstants = __webpack_require__(36);
	
	var OBJECT_ERROR_OBJECT = {
	    name: _validationConstants.FAILURE_NAMES.object,
	    type: _validationConstants.FAILURE_TYPES.ERROR,
	    message: 'Must be a string'
	};
	
	exports.default = function (fieldValue, validationConfig) {
	    if (!fieldValue) return;
	
	    if (!(0, _lodash.isString)(fieldValue)) return OBJECT_ERROR_OBJECT;
	
	    return null;
	};

/***/ }),
/* 2306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Const
	
	
	var _validationConstants = __webpack_require__(36);
	
	// Writing our own isValid function based on the MongoDB driver version to reduce file size as this will also
	// be included on the client
	var checkForHexRegExp = new RegExp('^[0-9a-fA-F]{24}$');
	var isObjectIdValid = function isObjectIdValid(id) {
	    if (id === null) return false;
	
	    if (typeof id === 'number') {
	        return true;
	    }
	
	    if (typeof id === 'string') {
	        return id.length === 12 || id.length === 24 && checkForHexRegExp.test(id);
	    }
	
	    return false;
	};
	
	var EMAIL_ERROR_OBJECT = {
	    name: _validationConstants.FAILURE_NAMES.objectId,
	    type: _validationConstants.FAILURE_TYPES.ERROR,
	    message: 'Not a valid objectId'
	};
	
	var getErrorObject = function getErrorObject(fieldValue) {
	    return _extends({}, EMAIL_ERROR_OBJECT, {
	        value: fieldValue
	    });
	};
	
	exports.default = function (fieldValue) {
	    if (!fieldValue) return null;
	    if (!isObjectIdValid(fieldValue)) return getErrorObject(fieldValue);
	    return null;
	};

/***/ }),
/* 2307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _lodash = __webpack_require__(4);
	
	var _validationConstants = __webpack_require__(36);
	
	var _fieldValidationService = __webpack_require__(488);
	
	var _fieldValidationService2 = _interopRequireDefault(_fieldValidationService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OBJECT_ERROR_OBJECT = {
	    name: _validationConstants.FAILURE_NAMES.object,
	    type: _validationConstants.FAILURE_TYPES.ERROR,
	    message: 'Must be a plain object'
	};
	
	exports.default = function (fieldValue, validationConfig) {
	    if (!fieldValue) return;
	
	    if (!(0, _lodash.isPlainObject)(fieldValue)) {
	        return _extends({}, OBJECT_ERROR_OBJECT, {
	            details: fieldValue
	        });
	    }
	
	    if (validationConfig.keys) {
	        var fieldErrors = validationConfig.keys.map(function (keyType) {
	            return (0, _fieldValidationService2.default)(fieldValue[keyType.name], keyType);
	        }).filter(function (err) {
	            return !!err;
	        });
	
	        if (fieldErrors.length) {
	            return _extends({}, OBJECT_ERROR_OBJECT, {
	                message: 'Object key validation failed',
	                details: fieldErrors
	            });
	        }
	    }
	
	    return null;
	};

/***/ }),
/* 2308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _validationConstants = __webpack_require__(36);
	
	var PASSWORD_ERROR_OBJECT = {
	    name: _validationConstants.FAILURE_NAMES.password,
	    type: _validationConstants.FAILURE_TYPES.ERROR,
	    debounced: true,
	    message: 'Must be at least 6 characters'
	};
	
	// This should be more complex in the future, however the only validation we're currently doing is on field length
	
	exports.default = function (fieldValue, validationConfig) {
	    return fieldValue.length < 6 ? PASSWORD_ERROR_OBJECT : null;
	};

/***/ }),
/* 2309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _validationConstants = __webpack_require__(36);
	
	exports.default = function (fieldValue, validationConfig) {
	    if (!fieldValue || !validationConfig.validValues) return;
	
	    if (validationConfig.validValues.indexOf(fieldValue) !== -1) return;
	
	    var errorObject = {
	        name: _validationConstants.FAILURE_NAMES.select,
	        type: _validationConstants.FAILURE_TYPES.ERROR,
	        debounced: true,
	        message: 'Not a valid select value',
	        validValues: validationConfig.validValues.join(',')
	    };
	
	    return errorObject;
	};

/***/ }),
/* 2310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _validationConstants = __webpack_require__(36);
	
	var URL_ERROR_OBJECT = {
	    name: _validationConstants.FAILURE_NAMES.url,
	    type: _validationConstants.FAILURE_TYPES.ERROR,
	    debounced: true,
	    message: 'Not a valid url'
	};
	
	exports.default = function (fieldValue, validationConfig) {
	    if (!fieldValue) return null;
	
	    if (fieldValue.match(_validationConstants.URL_REGEX)) return null;
	    if (validationConfig.allowIPAddress && fieldValue.match(_validationConstants.IP_ADDRESS_REGEX)) return null;
	    if (false) return null;
	
	    return URL_ERROR_OBJECT;
	};

/***/ }),
/* 2311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _TYPE_VALIDATORS;
	
	var _validationConstants = __webpack_require__(36);
	
	var _emailValidator = __webpack_require__(2304);
	
	var _emailValidator2 = _interopRequireDefault(_emailValidator);
	
	var _passwordValidator = __webpack_require__(2308);
	
	var _passwordValidator2 = _interopRequireDefault(_passwordValidator);
	
	var _dateValidator = __webpack_require__(2302);
	
	var _dateValidator2 = _interopRequireDefault(_dateValidator);
	
	var _selectValidator = __webpack_require__(2309);
	
	var _selectValidator2 = _interopRequireDefault(_selectValidator);
	
	var _urlValidator = __webpack_require__(2310);
	
	var _urlValidator2 = _interopRequireDefault(_urlValidator);
	
	var _elementIdValidator = __webpack_require__(2303);
	
	var _elementIdValidator2 = _interopRequireDefault(_elementIdValidator);
	
	var _htmlValidator = __webpack_require__(2305);
	
	var _htmlValidator2 = _interopRequireDefault(_htmlValidator);
	
	var _objectValidator = __webpack_require__(2307);
	
	var _objectValidator2 = _interopRequireDefault(_objectValidator);
	
	var _objectIdValidator = __webpack_require__(2306);
	
	var _objectIdValidator2 = _interopRequireDefault(_objectIdValidator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var TYPE_VALIDATORS = (_TYPE_VALIDATORS = {}, _defineProperty(_TYPE_VALIDATORS, _validationConstants.FIELD_TYPES.email, _emailValidator2.default), _defineProperty(_TYPE_VALIDATORS, _validationConstants.FIELD_TYPES.password, _passwordValidator2.default), _defineProperty(_TYPE_VALIDATORS, _validationConstants.FIELD_TYPES.date, _dateValidator2.default), _defineProperty(_TYPE_VALIDATORS, _validationConstants.FIELD_TYPES.select, _selectValidator2.default), _defineProperty(_TYPE_VALIDATORS, _validationConstants.FIELD_TYPES.url, _urlValidator2.default), _defineProperty(_TYPE_VALIDATORS, _validationConstants.FIELD_TYPES.elementId, _elementIdValidator2.default), _defineProperty(_TYPE_VALIDATORS, _validationConstants.FIELD_TYPES.html, _htmlValidator2.default), _defineProperty(_TYPE_VALIDATORS, _validationConstants.FIELD_TYPES.object, _objectValidator2.default), _defineProperty(_TYPE_VALIDATORS, _validationConstants.FIELD_TYPES.objectId, _objectIdValidator2.default), _TYPE_VALIDATORS);
	
	/**
	 */
	
	exports.default = function (fieldValue, validationConfig) {
	    // If we specifically don't want to do type validation, then immediately return null
	    if (validationConfig.disableTypeValidation) return null;
	
	    var typeValidator = TYPE_VALIDATORS[validationConfig.type];
	
	    return typeValidator ? typeValidator(fieldValue, validationConfig) : null;
	};

/***/ }),
/* 2312 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(2313);


/***/ }),
/* 2313 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(2314);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(209)(module)))

/***/ }),
/* 2314 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ }),
/* 2315 */
/***/ (function(module, exports) {

	module.exports = toArray
	
	function toArray(list, index) {
	    var array = []
	
	    index = index || 0
	
	    for (var i = index || 0; i < list.length; i++) {
	        array[i - index] = list[i]
	    }
	
	    return array
	}


/***/ }),
/* 2316 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * UAParser.js v0.7.12
	 * Lightweight JavaScript-based User-Agent string parser
	 * https://github.com/faisalman/ua-parser-js
	 *
	 * Copyright © 2012-2016 Faisal Salman <fyzlman@gmail.com>
	 * Dual licensed under GPLv2 & MIT
	 */
	
	(function (window, undefined) {
	
	    'use strict';
	
	    //////////////
	    // Constants
	    /////////////
	
	
	    var LIBVERSION  = '0.7.12',
	        EMPTY       = '',
	        UNKNOWN     = '?',
	        FUNC_TYPE   = 'function',
	        UNDEF_TYPE  = 'undefined',
	        OBJ_TYPE    = 'object',
	        STR_TYPE    = 'string',
	        MAJOR       = 'major', // deprecated
	        MODEL       = 'model',
	        NAME        = 'name',
	        TYPE        = 'type',
	        VENDOR      = 'vendor',
	        VERSION     = 'version',
	        ARCHITECTURE= 'architecture',
	        CONSOLE     = 'console',
	        MOBILE      = 'mobile',
	        TABLET      = 'tablet',
	        SMARTTV     = 'smarttv',
	        WEARABLE    = 'wearable',
	        EMBEDDED    = 'embedded';
	
	
	    ///////////
	    // Helper
	    //////////
	
	
	    var util = {
	        extend : function (regexes, extensions) {
	            var margedRegexes = {};
	            for (var i in regexes) {
	                if (extensions[i] && extensions[i].length % 2 === 0) {
	                    margedRegexes[i] = extensions[i].concat(regexes[i]);
	                } else {
	                    margedRegexes[i] = regexes[i];
	                }
	            }
	            return margedRegexes;
	        },
	        has : function (str1, str2) {
	          if (typeof str1 === "string") {
	            return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1;
	          } else {
	            return false;
	          }
	        },
	        lowerize : function (str) {
	            return str.toLowerCase();
	        },
	        major : function (version) {
	            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g,'').split(".")[0] : undefined;
	        },
	        trim : function (str) {
	          return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
	        }
	    };
	
	
	    ///////////////
	    // Map helper
	    //////////////
	
	
	    var mapper = {
	
	        rgx : function () {
	
	            var result, i = 0, j, k, p, q, matches, match, args = arguments;
	
	            // loop through all regexes maps
	            while (i < args.length && !matches) {
	
	                var regex = args[i],       // even sequence (0,2,4,..)
	                    props = args[i + 1];   // odd sequence (1,3,5,..)
	
	                // construct object barebones
	                if (typeof result === UNDEF_TYPE) {
	                    result = {};
	                    for (p in props) {
	                        if (props.hasOwnProperty(p)){
	                            q = props[p];
	                            if (typeof q === OBJ_TYPE) {
	                                result[q[0]] = undefined;
	                            } else {
	                                result[q] = undefined;
	                            }
	                        }
	                    }
	                }
	
	                // try matching uastring with regexes
	                j = k = 0;
	                while (j < regex.length && !matches) {
	                    matches = regex[j++].exec(this.getUA());
	                    if (!!matches) {
	                        for (p = 0; p < props.length; p++) {
	                            match = matches[++k];
	                            q = props[p];
	                            // check if given property is actually array
	                            if (typeof q === OBJ_TYPE && q.length > 0) {
	                                if (q.length == 2) {
	                                    if (typeof q[1] == FUNC_TYPE) {
	                                        // assign modified match
	                                        result[q[0]] = q[1].call(this, match);
	                                    } else {
	                                        // assign given value, ignore regex match
	                                        result[q[0]] = q[1];
	                                    }
	                                } else if (q.length == 3) {
	                                    // check whether function or regex
	                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
	                                        // call function (usually string mapper)
	                                        result[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
	                                    } else {
	                                        // sanitize match using given regex
	                                        result[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
	                                    }
	                                } else if (q.length == 4) {
	                                        result[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
	                                }
	                            } else {
	                                result[q] = match ? match : undefined;
	                            }
	                        }
	                    }
	                }
	                i += 2;
	            }
	            return result;
	        },
	
	        str : function (str, map) {
	
	            for (var i in map) {
	                // check if array
	                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
	                    for (var j = 0; j < map[i].length; j++) {
	                        if (util.has(map[i][j], str)) {
	                            return (i === UNKNOWN) ? undefined : i;
	                        }
	                    }
	                } else if (util.has(map[i], str)) {
	                    return (i === UNKNOWN) ? undefined : i;
	                }
	            }
	            return str;
	        }
	    };
	
	
	    ///////////////
	    // String map
	    //////////////
	
	
	    var maps = {
	
	        browser : {
	            oldsafari : {
	                version : {
	                    '1.0'   : '/8',
	                    '1.2'   : '/1',
	                    '1.3'   : '/3',
	                    '2.0'   : '/412',
	                    '2.0.2' : '/416',
	                    '2.0.3' : '/417',
	                    '2.0.4' : '/419',
	                    '?'     : '/'
	                }
	            }
	        },
	
	        device : {
	            amazon : {
	                model : {
	                    'Fire Phone' : ['SD', 'KF']
	                }
	            },
	            sprint : {
	                model : {
	                    'Evo Shift 4G' : '7373KT'
	                },
	                vendor : {
	                    'HTC'       : 'APA',
	                    'Sprint'    : 'Sprint'
	                }
	            }
	        },
	
	        os : {
	            windows : {
	                version : {
	                    'ME'        : '4.90',
	                    'NT 3.11'   : 'NT3.51',
	                    'NT 4.0'    : 'NT4.0',
	                    '2000'      : 'NT 5.0',
	                    'XP'        : ['NT 5.1', 'NT 5.2'],
	                    'Vista'     : 'NT 6.0',
	                    '7'         : 'NT 6.1',
	                    '8'         : 'NT 6.2',
	                    '8.1'       : 'NT 6.3',
	                    '10'        : ['NT 6.4', 'NT 10.0'],
	                    'RT'        : 'ARM'
	                }
	            }
	        }
	    };
	
	
	    //////////////
	    // Regex map
	    /////////////
	
	
	    var regexes = {
	
	        browser : [[
	
	            // Presto based
	            /(opera\smini)\/([\w\.-]+)/i,                                       // Opera Mini
	            /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,                      // Opera Mobi/Tablet
	            /(opera).+version\/([\w\.]+)/i,                                     // Opera > 9.80
	            /(opera)[\/\s]+([\w\.]+)/i                                          // Opera < 9.80
	            ], [NAME, VERSION], [
	
	            /(opios)[\/\s]+([\w\.]+)/i                                          // Opera mini on iphone >= 8.0
	            ], [[NAME, 'Opera Mini'], VERSION], [
	
	            /\s(opr)\/([\w\.]+)/i                                               // Opera Webkit
	            ], [[NAME, 'Opera'], VERSION], [
	
	            // Mixed
	            /(kindle)\/([\w\.]+)/i,                                             // Kindle
	            /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]+)*/i,
	                                                                                // Lunascape/Maxthon/Netfront/Jasmine/Blazer
	
	            // Trident based
	            /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,
	                                                                                // Avant/IEMobile/SlimBrowser/Baidu
	            /(?:ms|\()(ie)\s([\w\.]+)/i,                                        // Internet Explorer
	
	            // Webkit/KHTML based
	            /(rekonq)\/([\w\.]+)*/i,                                            // Rekonq
	            /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs)\/([\w\.-]+)/i
	                                                                                // Chromium/Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS
	            ], [NAME, VERSION], [
	
	            /(trident).+rv[:\s]([\w\.]+).+like\sgecko/i                         // IE11
	            ], [[NAME, 'IE'], VERSION], [
	
	            /(edge)\/((\d+)?[\w\.]+)/i                                          // Microsoft Edge
	            ], [NAME, VERSION], [
	
	            /(yabrowser)\/([\w\.]+)/i                                           // Yandex
	            ], [[NAME, 'Yandex'], VERSION], [
	
	            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
	            ], [[NAME, /_/g, ' '], VERSION], [
	
	            /(micromessenger)\/([\w\.]+)/i                                      // WeChat
	            ], [[NAME, 'WeChat'], VERSION], [
	
	            /xiaomi\/miuibrowser\/([\w\.]+)/i                                   // MIUI Browser
	            ], [VERSION, [NAME, 'MIUI Browser']], [
	
	            /\swv\).+(chrome)\/([\w\.]+)/i                                      // Chrome WebView
	            ], [[NAME, /(.+)/, '$1 WebView'], VERSION], [
	
	            /android.+samsungbrowser\/([\w\.]+)/i,
	            /android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i        // Android Browser
	            ], [VERSION, [NAME, 'Android Browser']], [
	
	            /(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i,
	                                                                                // Chrome/OmniWeb/Arora/Tizen/Nokia
	            /(qqbrowser)[\/\s]?([\w\.]+)/i
	                                                                                // QQBrowser
	            ], [NAME, VERSION], [
	
	            /(uc\s?browser)[\/\s]?([\w\.]+)/i,
	            /ucweb.+(ucbrowser)[\/\s]?([\w\.]+)/i,
	            /juc.+(ucweb)[\/\s]?([\w\.]+)/i
	                                                                                // UCBrowser
	            ], [[NAME, 'UCBrowser'], VERSION], [
	
	            /(dolfin)\/([\w\.]+)/i                                              // Dolphin
	            ], [[NAME, 'Dolphin'], VERSION], [
	
	            /((?:android.+)crmo|crios)\/([\w\.]+)/i                             // Chrome for Android/iOS
	            ], [[NAME, 'Chrome'], VERSION], [
	
	            /;fbav\/([\w\.]+);/i                                                // Facebook App for iOS
	            ], [VERSION, [NAME, 'Facebook']], [
	
	            /fxios\/([\w\.-]+)/i                                                // Firefox for iOS
	            ], [VERSION, [NAME, 'Firefox']], [
	
	            /version\/([\w\.]+).+?mobile\/\w+\s(safari)/i                       // Mobile Safari
	            ], [VERSION, [NAME, 'Mobile Safari']], [
	
	            /version\/([\w\.]+).+?(mobile\s?safari|safari)/i                    // Safari & Safari Mobile
	            ], [VERSION, NAME], [
	
	            /webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i                     // Safari < 3.0
	            ], [NAME, [VERSION, mapper.str, maps.browser.oldsafari.version]], [
	
	            /(konqueror)\/([\w\.]+)/i,                                          // Konqueror
	            /(webkit|khtml)\/([\w\.]+)/i
	            ], [NAME, VERSION], [
	
	            // Gecko based
	            /(navigator|netscape)\/([\w\.-]+)/i                                 // Netscape
	            ], [[NAME, 'Netscape'], VERSION], [
	            /(swiftfox)/i,                                                      // Swiftfox
	            /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,
	                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
	            /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix)\/([\w\.-]+)/i,
	                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
	            /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,                          // Mozilla
	
	            // Other
	            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,
	                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
	            /(links)\s\(([\w\.]+)/i,                                            // Links
	            /(gobrowser)\/?([\w\.]+)*/i,                                        // GoBrowser
	            /(ice\s?browser)\/v?([\w\._]+)/i,                                   // ICE Browser
	            /(mosaic)[\/\s]([\w\.]+)/i                                          // Mosaic
	            ], [NAME, VERSION]
	
	            /* /////////////////////
	            // Media players BEGIN
	            ////////////////////////
	
	            , [
	
	            /(apple(?:coremedia|))\/((\d+)[\w\._]+)/i,                          // Generic Apple CoreMedia
	            /(coremedia) v((\d+)[\w\._]+)/i
	            ], [NAME, VERSION], [
	
	            /(aqualung|lyssna|bsplayer)\/((\d+)?[\w\.-]+)/i                     // Aqualung/Lyssna/BSPlayer
	            ], [NAME, VERSION], [
	
	            /(ares|ossproxy)\s((\d+)[\w\.-]+)/i                                 // Ares/OSSProxy
	            ], [NAME, VERSION], [
	
	            /(audacious|audimusicstream|amarok|bass|core|dalvik|gnomemplayer|music on console|nsplayer|psp-internetradioplayer|videos)\/((\d+)[\w\.-]+)/i,
	                                                                                // Audacious/AudiMusicStream/Amarok/BASS/OpenCORE/Dalvik/GnomeMplayer/MoC
	                                                                                // NSPlayer/PSP-InternetRadioPlayer/Videos
	            /(clementine|music player daemon)\s((\d+)[\w\.-]+)/i,               // Clementine/MPD
	            /(lg player|nexplayer)\s((\d+)[\d\.]+)/i,
	            /player\/(nexplayer|lg player)\s((\d+)[\w\.-]+)/i                   // NexPlayer/LG Player
	            ], [NAME, VERSION], [
	            /(nexplayer)\s((\d+)[\w\.-]+)/i                                     // Nexplayer
	            ], [NAME, VERSION], [
	
	            /(flrp)\/((\d+)[\w\.-]+)/i                                          // Flip Player
	            ], [[NAME, 'Flip Player'], VERSION], [
	
	            /(fstream|nativehost|queryseekspider|ia-archiver|facebookexternalhit)/i
	                                                                                // FStream/NativeHost/QuerySeekSpider/IA Archiver/facebookexternalhit
	            ], [NAME], [
	
	            /(gstreamer) souphttpsrc (?:\([^\)]+\)){0,1} libsoup\/((\d+)[\w\.-]+)/i
	                                                                                // Gstreamer
	            ], [NAME, VERSION], [
	
	            /(htc streaming player)\s[\w_]+\s\/\s((\d+)[\d\.]+)/i,              // HTC Streaming Player
	            /(java|python-urllib|python-requests|wget|libcurl)\/((\d+)[\w\.-_]+)/i,
	                                                                                // Java/urllib/requests/wget/cURL
	            /(lavf)((\d+)[\d\.]+)/i                                             // Lavf (FFMPEG)
	            ], [NAME, VERSION], [
	
	            /(htc_one_s)\/((\d+)[\d\.]+)/i                                      // HTC One S
	            ], [[NAME, /_/g, ' '], VERSION], [
	
	            /(mplayer)(?:\s|\/)(?:(?:sherpya-){0,1}svn)(?:-|\s)(r\d+(?:-\d+[\w\.-]+){0,1})/i
	                                                                                // MPlayer SVN
	            ], [NAME, VERSION], [
	
	            /(mplayer)(?:\s|\/|[unkow-]+)((\d+)[\w\.-]+)/i                      // MPlayer
	            ], [NAME, VERSION], [
	
	            /(mplayer)/i,                                                       // MPlayer (no other info)
	            /(yourmuze)/i,                                                      // YourMuze
	            /(media player classic|nero showtime)/i                             // Media Player Classic/Nero ShowTime
	            ], [NAME], [
	
	            /(nero (?:home|scout))\/((\d+)[\w\.-]+)/i                           // Nero Home/Nero Scout
	            ], [NAME, VERSION], [
	
	            /(nokia\d+)\/((\d+)[\w\.-]+)/i                                      // Nokia
	            ], [NAME, VERSION], [
	
	            /\s(songbird)\/((\d+)[\w\.-]+)/i                                    // Songbird/Philips-Songbird
	            ], [NAME, VERSION], [
	
	            /(winamp)3 version ((\d+)[\w\.-]+)/i,                               // Winamp
	            /(winamp)\s((\d+)[\w\.-]+)/i,
	            /(winamp)mpeg\/((\d+)[\w\.-]+)/i
	            ], [NAME, VERSION], [
	
	            /(ocms-bot|tapinradio|tunein radio|unknown|winamp|inlight radio)/i  // OCMS-bot/tap in radio/tunein/unknown/winamp (no other info)
	                                                                                // inlight radio
	            ], [NAME], [
	
	            /(quicktime|rma|radioapp|radioclientapplication|soundtap|totem|stagefright|streamium)\/((\d+)[\w\.-]+)/i
	                                                                                // QuickTime/RealMedia/RadioApp/RadioClientApplication/
	                                                                                // SoundTap/Totem/Stagefright/Streamium
	            ], [NAME, VERSION], [
	
	            /(smp)((\d+)[\d\.]+)/i                                              // SMP
	            ], [NAME, VERSION], [
	
	            /(vlc) media player - version ((\d+)[\w\.]+)/i,                     // VLC Videolan
	            /(vlc)\/((\d+)[\w\.-]+)/i,
	            /(xbmc|gvfs|xine|xmms|irapp)\/((\d+)[\w\.-]+)/i,                    // XBMC/gvfs/Xine/XMMS/irapp
	            /(foobar2000)\/((\d+)[\d\.]+)/i,                                    // Foobar2000
	            /(itunes)\/((\d+)[\d\.]+)/i                                         // iTunes
	            ], [NAME, VERSION], [
	
	            /(wmplayer)\/((\d+)[\w\.-]+)/i,                                     // Windows Media Player
	            /(windows-media-player)\/((\d+)[\w\.-]+)/i
	            ], [[NAME, /-/g, ' '], VERSION], [
	
	            /windows\/((\d+)[\w\.-]+) upnp\/[\d\.]+ dlnadoc\/[\d\.]+ (home media server)/i
	                                                                                // Windows Media Server
	            ], [VERSION, [NAME, 'Windows']], [
	
	            /(com\.riseupradioalarm)\/((\d+)[\d\.]*)/i                          // RiseUP Radio Alarm
	            ], [NAME, VERSION], [
	
	            /(rad.io)\s((\d+)[\d\.]+)/i,                                        // Rad.io
	            /(radio.(?:de|at|fr))\s((\d+)[\d\.]+)/i
	            ], [[NAME, 'rad.io'], VERSION]
	
	            //////////////////////
	            // Media players END
	            ////////////////////*/
	
	        ],
	
	        cpu : [[
	
	            /(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i                     // AMD64
	            ], [[ARCHITECTURE, 'amd64']], [
	
	            /(ia32(?=;))/i                                                      // IA32 (quicktime)
	            ], [[ARCHITECTURE, util.lowerize]], [
	
	            /((?:i[346]|x)86)[;\)]/i                                            // IA32
	            ], [[ARCHITECTURE, 'ia32']], [
	
	            // PocketPC mistakenly identified as PowerPC
	            /windows\s(ce|mobile);\sppc;/i
	            ], [[ARCHITECTURE, 'arm']], [
	
	            /((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i                           // PowerPC
	            ], [[ARCHITECTURE, /ower/, '', util.lowerize]], [
	
	            /(sun4\w)[;\)]/i                                                    // SPARC
	            ], [[ARCHITECTURE, 'sparc']], [
	
	            /((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+;))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i
	                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
	            ], [[ARCHITECTURE, util.lowerize]]
	        ],
	
	        device : [[
	
	            /\((ipad|playbook);[\w\s\);-]+(rim|apple)/i                         // iPad/PlayBook
	            ], [MODEL, VENDOR, [TYPE, TABLET]], [
	
	            /applecoremedia\/[\w\.]+ \((ipad)/                                  // iPad
	            ], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]], [
	
	            /(apple\s{0,1}tv)/i                                                 // Apple TV
	            ], [[MODEL, 'Apple TV'], [VENDOR, 'Apple']], [
	
	            /(archos)\s(gamepad2?)/i,                                           // Archos
	            /(hp).+(touchpad)/i,                                                // HP TouchPad
	            /(hp).+(tablet)/i,                                                  // HP Tablet
	            /(kindle)\/([\w\.]+)/i,                                             // Kindle
	            /\s(nook)[\w\s]+build\/(\w+)/i,                                     // Nook
	            /(dell)\s(strea[kpr\s\d]*[\dko])/i                                  // Dell Streak
	            ], [VENDOR, MODEL, [TYPE, TABLET]], [
	
	            /(kf[A-z]+)\sbuild\/[\w\.]+.*silk\//i                               // Kindle Fire HD
	            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [
	            /(sd|kf)[0349hijorstuw]+\sbuild\/[\w\.]+.*silk\//i                  // Fire Phone
	            ], [[MODEL, mapper.str, maps.device.amazon.model], [VENDOR, 'Amazon'], [TYPE, MOBILE]], [
	
	            /\((ip[honed|\s\w*]+);.+(apple)/i                                   // iPod/iPhone
	            ], [MODEL, VENDOR, [TYPE, MOBILE]], [
	            /\((ip[honed|\s\w*]+);/i                                            // iPod/iPhone
	            ], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [
	
	            /(blackberry)[\s-]?(\w+)/i,                                         // BlackBerry
	            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|huawei|meizu|motorola|polytron)[\s_-]?([\w-]+)*/i,
	                                                                                // BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Huawei/Meizu/Motorola/Polytron
	            /(hp)\s([\w\s]+\w)/i,                                               // HP iPAQ
	            /(asus)-?(\w+)/i                                                    // Asus
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	            /\(bb10;\s(\w+)/i                                                   // BlackBerry 10
	            ], [MODEL, [VENDOR, 'BlackBerry'], [TYPE, MOBILE]], [
	                                                                                // Asus Tablets
	            /android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone)/i
	            ], [MODEL, [VENDOR, 'Asus'], [TYPE, TABLET]], [
	
	            /(sony)\s(tablet\s[ps])\sbuild\//i,                                  // Sony
	            /(sony)?(?:sgp.+)\sbuild\//i
	            ], [[VENDOR, 'Sony'], [MODEL, 'Xperia Tablet'], [TYPE, TABLET]], [
	            /(?:sony)?(?:(?:(?:c|d)\d{4})|(?:so[-l].+))\sbuild\//i
	            ], [[VENDOR, 'Sony'], [MODEL, 'Xperia Phone'], [TYPE, MOBILE]], [
	
	            /\s(ouya)\s/i,                                                      // Ouya
	            /(nintendo)\s([wids3u]+)/i                                          // Nintendo
	            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [
	
	            /android.+;\s(shield)\sbuild/i                                      // Nvidia
	            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [
	
	            /(playstation\s[34portablevi]+)/i                                   // Playstation
	            ], [MODEL, [VENDOR, 'Sony'], [TYPE, CONSOLE]], [
	
	            /(sprint\s(\w+))/i                                                  // Sprint Phones
	            ], [[VENDOR, mapper.str, maps.device.sprint.vendor], [MODEL, mapper.str, maps.device.sprint.model], [TYPE, MOBILE]], [
	
	            /(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i                         // Lenovo tablets
	            ], [VENDOR, MODEL, [TYPE, TABLET]], [
	
	            /(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i,                               // HTC
	            /(zte)-(\w+)*/i,                                                    // ZTE
	            /(alcatel|geeksphone|huawei|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]+)*/i
	                                                                                // Alcatel/GeeksPhone/Huawei/Lenovo/Nexian/Panasonic/Sony
	            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [
	
	            /(nexus\s9)/i                                                       // HTC Nexus 9
	            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [
	
	            /(nexus\s6p)/i                                                      // Huawei Nexus 6P
	            ], [MODEL, [VENDOR, 'Huawei'], [TYPE, MOBILE]], [
	
	            /(microsoft);\s(lumia[\s\w]+)/i                                     // Microsoft Lumia
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	
	            /[\s\(;](xbox(?:\sone)?)[\s\);]/i                                   // Microsoft Xbox
	            ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, CONSOLE]], [
	            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
	            ], [[MODEL, /\./g, ' '], [VENDOR, 'Microsoft'], [TYPE, MOBILE]], [
	
	                                                                                // Motorola
	            /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?(:?\s4g)?)[\w\s]+build\//i,
	            /mot[\s-]?(\w+)*/i,
	            /(XT\d{3,4}) build\//i,
	            /(nexus\s6)/i
	            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, MOBILE]], [
	            /android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i
	            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, TABLET]], [
	
	            /hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i            // HbbTV devices
	            ], [[VENDOR, util.trim], [MODEL, util.trim], [TYPE, SMARTTV]], [
	
	            /hbbtv.+maple;(\d+)/i
	            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, 'Samsung'], [TYPE, SMARTTV]], [
	
	            /\(dtv[\);].+(aquos)/i                                              // Sharp
	            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [
	
	            /android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,
	            /((SM-T\w+))/i
	            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, TABLET]], [                  // Samsung
	            /smart-tv.+(samsung)/i
	            ], [VENDOR, [TYPE, SMARTTV], MODEL], [
	            /((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,
	            /(sam[sung]*)[\s-]*(\w+-?[\w-]*)*/i,
	            /sec-((sgh\w+))/i
	            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, MOBILE]], [
	
	            /sie-(\w+)*/i                                                       // Siemens
	            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [
	
	            /(maemo|nokia).*(n900|lumia\s\d+)/i,                                // Nokia
	            /(nokia)[\s_-]?([\w-]+)*/i
	            ], [[VENDOR, 'Nokia'], MODEL, [TYPE, MOBILE]], [
	
	            /android\s3\.[\s\w;-]{10}(a\d{3})/i                                 // Acer
	            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [
	
	            /android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i                     // LG Tablet
	            ], [[VENDOR, 'LG'], MODEL, [TYPE, TABLET]], [
	            /(lg) netcast\.tv/i                                                 // LG SmartTV
	            ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
	            /(nexus\s[45])/i,                                                   // LG
	            /lg[e;\s\/-]+(\w+)*/i
	            ], [MODEL, [VENDOR, 'LG'], [TYPE, MOBILE]], [
	
	            /android.+(ideatab[a-z0-9\-\s]+)/i                                  // Lenovo
	            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [
	
	            /linux;.+((jolla));/i                                               // Jolla
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	
	            /((pebble))app\/[\d\.]+\s/i                                         // Pebble
	            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [
	
	            /android.+;\s(glass)\s\d/i                                          // Google Glass
	            ], [MODEL, [VENDOR, 'Google'], [TYPE, WEARABLE]], [
	
	            /android.+(\w+)\s+build\/hm\1/i,                                    // Xiaomi Hongmi 'numeric' models
	            /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,               // Xiaomi Hongmi
	            /android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d\w)?)\s+build/i    // Xiaomi Mi
	            ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, MOBILE]], [
	
	            /android.+a000(1)\s+build/i                                         // OnePlus
	            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [
	
	            /\s(tablet)[;\/]/i,                                                 // Unidentifiable Tablet
	            /\s(mobile)(?:[;\/]|\ssafari)/i                                     // Unidentifiable Mobile
	            ], [[TYPE, util.lowerize], VENDOR, MODEL]
	
	            /*//////////////////////////
	            // TODO: move to string map
	            ////////////////////////////
	
	            /(C6603)/i                                                          // Sony Xperia Z C6603
	            ], [[MODEL, 'Xperia Z C6603'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [
	            /(C6903)/i                                                          // Sony Xperia Z 1
	            ], [[MODEL, 'Xperia Z 1'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [
	
	            /(SM-G900[F|H])/i                                                   // Samsung Galaxy S5
	            ], [[MODEL, 'Galaxy S5'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-G7102)/i                                                       // Samsung Galaxy Grand 2
	            ], [[MODEL, 'Galaxy Grand 2'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-G530H)/i                                                       // Samsung Galaxy Grand Prime
	            ], [[MODEL, 'Galaxy Grand Prime'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-G313HZ)/i                                                      // Samsung Galaxy V
	            ], [[MODEL, 'Galaxy V'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-T805)/i                                                        // Samsung Galaxy Tab S 10.5
	            ], [[MODEL, 'Galaxy Tab S 10.5'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [
	            /(SM-G800F)/i                                                       // Samsung Galaxy S5 Mini
	            ], [[MODEL, 'Galaxy S5 Mini'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-T311)/i                                                        // Samsung Galaxy Tab 3 8.0
	            ], [[MODEL, 'Galaxy Tab 3 8.0'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [
	
	            /(R1001)/i                                                          // Oppo R1001
	            ], [MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]], [
	            /(X9006)/i                                                          // Oppo Find 7a
	            ], [[MODEL, 'Find 7a'], [VENDOR, 'Oppo'], [TYPE, MOBILE]], [
	            /(R2001)/i                                                          // Oppo YOYO R2001
	            ], [[MODEL, 'Yoyo R2001'], [VENDOR, 'Oppo'], [TYPE, MOBILE]], [
	            /(R815)/i                                                           // Oppo Clover R815
	            ], [[MODEL, 'Clover R815'], [VENDOR, 'Oppo'], [TYPE, MOBILE]], [
	             /(U707)/i                                                          // Oppo Find Way S
	            ], [[MODEL, 'Find Way S'], [VENDOR, 'Oppo'], [TYPE, MOBILE]], [
	
	            /(T3C)/i                                                            // Advan Vandroid T3C
	            ], [MODEL, [VENDOR, 'Advan'], [TYPE, TABLET]], [
	            /(ADVAN T1J\+)/i                                                    // Advan Vandroid T1J+
	            ], [[MODEL, 'Vandroid T1J+'], [VENDOR, 'Advan'], [TYPE, TABLET]], [
	            /(ADVAN S4A)/i                                                      // Advan Vandroid S4A
	            ], [[MODEL, 'Vandroid S4A'], [VENDOR, 'Advan'], [TYPE, MOBILE]], [
	
	            /(V972M)/i                                                          // ZTE V972M
	            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [
	
	            /(i-mobile)\s(IQ\s[\d\.]+)/i                                        // i-mobile IQ
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	            /(IQ6.3)/i                                                          // i-mobile IQ IQ 6.3
	            ], [[MODEL, 'IQ 6.3'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [
	            /(i-mobile)\s(i-style\s[\d\.]+)/i                                   // i-mobile i-STYLE
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	            /(i-STYLE2.1)/i                                                     // i-mobile i-STYLE 2.1
	            ], [[MODEL, 'i-STYLE 2.1'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [
	
	            /(mobiistar touch LAI 512)/i                                        // mobiistar touch LAI 512
	            ], [[MODEL, 'Touch LAI 512'], [VENDOR, 'mobiistar'], [TYPE, MOBILE]], [
	
	            /////////////
	            // END TODO
	            ///////////*/
	
	        ],
	
	        engine : [[
	
	            /windows.+\sedge\/([\w\.]+)/i                                       // EdgeHTML
	            ], [VERSION, [NAME, 'EdgeHTML']], [
	
	            /(presto)\/([\w\.]+)/i,                                             // Presto
	            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i,     // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m
	            /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,                          // KHTML/Tasman/Links
	            /(icab)[\/\s]([23]\.[\d\.]+)/i                                      // iCab
	            ], [NAME, VERSION], [
	
	            /rv\:([\w\.]+).*(gecko)/i                                           // Gecko
	            ], [VERSION, NAME]
	        ],
	
	        os : [[
	
	            // Windows based
	            /microsoft\s(windows)\s(vista|xp)/i                                 // Windows (iTunes)
	            ], [NAME, VERSION], [
	            /(windows)\snt\s6\.2;\s(arm)/i,                                     // Windows RT
	            /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s]+\w)*/i,                  // Windows Phone
	            /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i
	            ], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [
	            /(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i
	            ], [[NAME, 'Windows'], [VERSION, mapper.str, maps.os.windows.version]], [
	
	            // Mobile/Embedded OS
	            /\((bb)(10);/i                                                      // BlackBerry 10
	            ], [[NAME, 'BlackBerry'], VERSION], [
	            /(blackberry)\w*\/?([\w\.]+)*/i,                                    // Blackberry
	            /(tizen)[\/\s]([\w\.]+)/i,                                          // Tizen
	            /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]+)*/i,
	                                                                                // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki
	            /linux;.+(sailfish);/i                                              // Sailfish OS
	            ], [NAME, VERSION], [
	            /(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]+)*/i                 // Symbian
	            ], [[NAME, 'Symbian'], VERSION], [
	            /\((series40);/i                                                    // Series 40
	            ], [NAME], [
	            /mozilla.+\(mobile;.+gecko.+firefox/i                               // Firefox OS
	            ], [[NAME, 'Firefox OS'], VERSION], [
	
	            // Console
	            /(nintendo|playstation)\s([wids34portablevu]+)/i,                   // Nintendo/Playstation
	
	            // GNU/Linux based
	            /(mint)[\/\s\(]?(\w+)*/i,                                           // Mint
	            /(mageia|vectorlinux)[;\s]/i,                                       // Mageia/VectorLinux
	            /(joli|[kxln]?ubuntu|debian|[open]*suse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]+)*/i,
	                                                                                // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
	                                                                                // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
	            /(hurd|linux)\s?([\w\.]+)*/i,                                       // Hurd/Linux
	            /(gnu)\s?([\w\.]+)*/i                                               // GNU
	            ], [NAME, VERSION], [
	
	            /(cros)\s[\w]+\s([\w\.]+\w)/i                                       // Chromium OS
	            ], [[NAME, 'Chromium OS'], VERSION],[
	
	            // Solaris
	            /(sunos)\s?([\w\.]+\d)*/i                                           // Solaris
	            ], [[NAME, 'Solaris'], VERSION], [
	
	            // BSD based
	            /\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]+)*/i                   // FreeBSD/NetBSD/OpenBSD/PC-BSD/DragonFly
	            ], [NAME, VERSION],[
	
	            /(haiku)\s(\w+)/i                                                  // Haiku
	            ], [NAME, VERSION],[
	
	            /(ip[honead]+)(?:.*os\s([\w]+)*\slike\smac|;\sopera)/i              // iOS
	            ], [[NAME, 'iOS'], [VERSION, /_/g, '.']], [
	
	            /(mac\sos\sx)\s?([\w\s\.]+\w)*/i,
	            /(macintosh|mac(?=_powerpc)\s)/i                                    // Mac OS
	            ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [
	
	            // Other
	            /((?:open)?solaris)[\/\s-]?([\w\.]+)*/i,                            // Solaris
	            /(aix)\s((\d)(?=\.|\)|\s)[\w\.]*)*/i,                               // AIX
	            /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms)/i,
	                                                                                // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS
	            /(unix)\s?([\w\.]+)*/i                                              // UNIX
	            ], [NAME, VERSION]
	        ]
	    };
	
	
	    /////////////////
	    // Constructor
	    ////////////////
	
	
	    var UAParser = function (uastring, extensions) {
	
	        if (!(this instanceof UAParser)) {
	            return new UAParser(uastring, extensions).getResult();
	        }
	
	        var ua = uastring || ((window && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : EMPTY);
	        var rgxmap = extensions ? util.extend(regexes, extensions) : regexes;
	
	        this.getBrowser = function () {
	            var browser = mapper.rgx.apply(this, rgxmap.browser);
	            browser.major = util.major(browser.version);
	            return browser;
	        };
	        this.getCPU = function () {
	            return mapper.rgx.apply(this, rgxmap.cpu);
	        };
	        this.getDevice = function () {
	            return mapper.rgx.apply(this, rgxmap.device);
	        };
	        this.getEngine = function () {
	            return mapper.rgx.apply(this, rgxmap.engine);
	        };
	        this.getOS = function () {
	            return mapper.rgx.apply(this, rgxmap.os);
	        };
	        this.getResult = function() {
	            return {
	                ua      : this.getUA(),
	                browser : this.getBrowser(),
	                engine  : this.getEngine(),
	                os      : this.getOS(),
	                device  : this.getDevice(),
	                cpu     : this.getCPU()
	            };
	        };
	        this.getUA = function () {
	            return ua;
	        };
	        this.setUA = function (uastring) {
	            ua = uastring;
	            return this;
	        };
	        return this;
	    };
	
	    UAParser.VERSION = LIBVERSION;
	    UAParser.BROWSER = {
	        NAME    : NAME,
	        MAJOR   : MAJOR, // deprecated
	        VERSION : VERSION
	    };
	    UAParser.CPU = {
	        ARCHITECTURE : ARCHITECTURE
	    };
	    UAParser.DEVICE = {
	        MODEL   : MODEL,
	        VENDOR  : VENDOR,
	        TYPE    : TYPE,
	        CONSOLE : CONSOLE,
	        MOBILE  : MOBILE,
	        SMARTTV : SMARTTV,
	        TABLET  : TABLET,
	        WEARABLE: WEARABLE,
	        EMBEDDED: EMBEDDED
	    };
	    UAParser.ENGINE = {
	        NAME    : NAME,
	        VERSION : VERSION
	    };
	    UAParser.OS = {
	        NAME    : NAME,
	        VERSION : VERSION
	    };
	
	
	    ///////////
	    // Export
	    //////////
	
	
	    // check js environment
	    if (typeof(exports) !== UNDEF_TYPE) {
	        // nodejs env
	        if (typeof module !== UNDEF_TYPE && module.exports) {
	            exports = module.exports = UAParser;
	        }
	        exports.UAParser = UAParser;
	    } else {
	        // requirejs env (optional)
	        if ("function" === FUNC_TYPE && __webpack_require__(2328)) {
	            !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	                return UAParser;
	            }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	        } else {
	            // browser env
	            window.UAParser = UAParser;
	        }
	    }
	
	    // jQuery/Zepto specific (optional)
	    // Note:
	    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
	    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
	    //   and we should catch that.
	    var $ = window.jQuery || window.Zepto;
	    if (typeof $ !== UNDEF_TYPE) {
	        var parser = new UAParser();
	        $.ua = parser.getResult();
	        $.ua.get = function() {
	            return parser.getUA();
	        };
	        $.ua.set = function (uastring) {
	            parser.setUA(uastring);
	            var result = parser.getResult();
	            for (var prop in result) {
	                $.ua[prop] = result[prop];
	            }
	        };
	    }
	
	})(typeof window === 'object' ? window : this);


/***/ }),
/* 2317 */
/***/ (function(module, exports) {

	module.exports=/[\0-\x1F\x7F-\x9F]/

/***/ }),
/* 2318 */
/***/ (function(module, exports) {

	module.exports=/[!-#%-\*,-/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E44\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD807[\uDC41-\uDC45\uDC70\uDC71]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/

/***/ }),
/* 2319 */
/***/ (function(module, exports) {

	module.exports=/[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/

/***/ }),
/* 2320 */
/***/ (function(module, exports) {

	module.exports=/[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/

/***/ }),
/* 2321 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = unionClassNames;
	/**
	 * Returns the union of the passed-in arrays: the list of unique items, in order,
	 * that are present in one or more of the arrays.
	 *
	 * @param {...array} arrs - at least two iterable objects must be provide
	 */
	var union = function union() {
	  for (var _len = arguments.length, arrs = Array(_len), _key = 0; _key < _len; _key++) {
	    arrs[_key] = arguments[_key];
	  }
	
	  if (arrs) {
	    var _ret = function () {
	      var result = [];
	      arrs.forEach(function (arr) {
	        if (arr) {
	          arr.forEach(function (obj) {
	            if (result.indexOf(obj) < 0) {
	              result.push(obj);
	            }
	          });
	        }
	      });
	      return {
	        v: result
	      };
	    }();
	
	    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	  }
	
	  return undefined;
	};
	
	/**
	 * Returns a string containing all classes without duplicates.
	 *
	 * @param existingClassNames {String} - one or multiple classes
	 * @param additionalClassNames {String} - one or multiple classes
	 *
	 * @example
	 * // returns 'style-id-23 button buy-button'
	 * unionClassNames('style-id-23 button', 'button buy-button')
	 *
	 * Originally inspired by https://github.com/rackt/react-autocomplete/blob/master/lib/union-class-names.js
	 */
	function unionClassNames(existingClassNames, additionalClassNames) {
	  if (!existingClassNames && !additionalClassNames) return '';
	  if (!existingClassNames) return additionalClassNames;
	  if (!additionalClassNames) return existingClassNames;
	  return union(existingClassNames.split(' '), additionalClassNames.split(' ')).join(' ');
	}

/***/ }),
/* 2322 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PHRpdGxlPjAzQkNCQzFDLTM4Q0EtNDExQy1CMjgwLUEwMTMzOEU1RTY2MDwvdGl0bGU+PGRlZnM+PHBhdGggZD0iTTIwIDQwQzguOTU0IDQwIDAgMzEuMDQ2IDAgMjBTOC45NTQgMCAyMCAwczIwIDguOTU0IDIwIDIwLTguOTU0IDIwLTIwIDIweiIgaWQ9ImEiLz48bWFzayBpZD0iYiIgeD0iMCIgeT0iMCIgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiBmaWxsPSIjZmZmIj48dXNlIHhsaW5rOmhyZWY9IiNhIi8+PC9tYXNrPjwvZGVmcz48ZyBzdHJva2U9IiNGNDUxMUMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48dXNlIG1hc2s9InVybCgjYikiIHN0cm9rZS13aWR0aD0iMiIgeGxpbms6aHJlZj0iI2EiLz48cGF0aCBkPSJNMjguNSAyOC41bC0xNy0xN3YxN2gxN3YtMTdsLTE3IDE3Ii8+PC9nPjwvc3ZnPgo="

/***/ }),
/* 2323 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),
/* 2324 */
/***/ (function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ }),
/* 2325 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = ({"BROWSER":true,"NODE_ENV":"production","APPLICATION_MODE":"production"}).NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(2324);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(2323);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(186)))

/***/ }),
/* 2326 */
/***/ (function(module, exports) {

	exports = module.exports = Victor;
	
	/**
	 * # Victor - A JavaScript 2D vector class with methods for common vector operations
	 */
	
	/**
	 * Constructor. Will also work without the `new` keyword
	 *
	 * ### Examples:
	 *     var vec1 = new Victor(100, 50);
	 *     var vec2 = Victor(42, 1337);
	 *
	 * @param {Number} x Value of the x axis
	 * @param {Number} y Value of the y axis
	 * @return {Victor}
	 * @api public
	 */
	function Victor (x, y) {
		if (!(this instanceof Victor)) {
			return new Victor(x, y);
		}
	
		/**
		 * The X axis
		 *
		 * ### Examples:
		 *     var vec = new Victor.fromArray(42, 21);
		 *
		 *     vec.x;
		 *     // => 42
		 *
		 * @api public
		 */
		this.x = x || 0;
	
		/**
		 * The Y axis
		 *
		 * ### Examples:
		 *     var vec = new Victor.fromArray(42, 21);
		 *
		 *     vec.y;
		 *     // => 21
		 *
		 * @api public
		 */
		this.y = y || 0;
	};
	
	/**
	 * # Static
	 */
	
	/**
	 * Creates a new instance from an array
	 *
	 * ### Examples:
	 *     var vec = Victor.fromArray([42, 21]);
	 *
	 *     vec.toString();
	 *     // => x:42, y:21
	 *
	 * @name Victor.fromArray
	 * @param {Array} array Array with the x and y values at index 0 and 1 respectively
	 * @return {Victor} The new instance
	 * @api public
	 */
	Victor.fromArray = function (arr) {
		return new Victor(arr[0] || 0, arr[1] || 0);
	};
	
	/**
	 * Creates a new instance from an object
	 *
	 * ### Examples:
	 *     var vec = Victor.fromObject({ x: 42, y: 21 });
	 *
	 *     vec.toString();
	 *     // => x:42, y:21
	 *
	 * @name Victor.fromObject
	 * @param {Object} obj Object with the values for x and y
	 * @return {Victor} The new instance
	 * @api public
	 */
	Victor.fromObject = function (obj) {
		return new Victor(obj.x || 0, obj.y || 0);
	};
	
	/**
	 * # Manipulation
	 *
	 * These functions are chainable.
	 */
	
	/**
	 * Adds another vector's X axis to this one
	 *
	 * ### Examples:
	 *     var vec1 = new Victor(10, 10);
	 *     var vec2 = new Victor(20, 30);
	 *
	 *     vec1.addX(vec2);
	 *     vec1.toString();
	 *     // => x:30, y:10
	 *
	 * @param {Victor} vector The other vector you want to add to this one
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.addX = function (vec) {
		this.x += vec.x;
		return this;
	};
	
	/**
	 * Adds another vector's Y axis to this one
	 *
	 * ### Examples:
	 *     var vec1 = new Victor(10, 10);
	 *     var vec2 = new Victor(20, 30);
	 *
	 *     vec1.addY(vec2);
	 *     vec1.toString();
	 *     // => x:10, y:40
	 *
	 * @param {Victor} vector The other vector you want to add to this one
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.addY = function (vec) {
		this.y += vec.y;
		return this;
	};
	
	/**
	 * Adds another vector to this one
	 *
	 * ### Examples:
	 *     var vec1 = new Victor(10, 10);
	 *     var vec2 = new Victor(20, 30);
	 *
	 *     vec1.add(vec2);
	 *     vec1.toString();
	 *     // => x:30, y:40
	 *
	 * @param {Victor} vector The other vector you want to add to this one
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.add = function (vec) {
		this.x += vec.x;
		this.y += vec.y;
		return this;
	};
	
	/**
	 * Adds the given scalar to both vector axis
	 *
	 * ### Examples:
	 *     var vec = new Victor(1, 2);
	 *
	 *     vec.addScalar(2);
	 *     vec.toString();
	 *     // => x: 3, y: 4
	 *
	 * @param {Number} scalar The scalar to add
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.addScalar = function (scalar) {
		this.x += scalar;
		this.y += scalar;
		return this;
	};
	
	/**
	 * Adds the given scalar to the X axis
	 *
	 * ### Examples:
	 *     var vec = new Victor(1, 2);
	 *
	 *     vec.addScalarX(2);
	 *     vec.toString();
	 *     // => x: 3, y: 2
	 *
	 * @param {Number} scalar The scalar to add
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.addScalarX = function (scalar) {
		this.x += scalar;
		return this;
	};
	
	/**
	 * Adds the given scalar to the Y axis
	 *
	 * ### Examples:
	 *     var vec = new Victor(1, 2);
	 *
	 *     vec.addScalarY(2);
	 *     vec.toString();
	 *     // => x: 1, y: 4
	 *
	 * @param {Number} scalar The scalar to add
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.addScalarY = function (scalar) {
		this.y += scalar;
		return this;
	};
	
	/**
	 * Subtracts the X axis of another vector from this one
	 *
	 * ### Examples:
	 *     var vec1 = new Victor(100, 50);
	 *     var vec2 = new Victor(20, 30);
	 *
	 *     vec1.subtractX(vec2);
	 *     vec1.toString();
	 *     // => x:80, y:50
	 *
	 * @param {Victor} vector The other vector you want subtract from this one
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.subtractX = function (vec) {
		this.x -= vec.x;
		return this;
	};
	
	/**
	 * Subtracts the Y axis of another vector from this one
	 *
	 * ### Examples:
	 *     var vec1 = new Victor(100, 50);
	 *     var vec2 = new Victor(20, 30);
	 *
	 *     vec1.subtractY(vec2);
	 *     vec1.toString();
	 *     // => x:100, y:20
	 *
	 * @param {Victor} vector The other vector you want subtract from this one
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.subtractY = function (vec) {
		this.y -= vec.y;
		return this;
	};
	
	/**
	 * Subtracts another vector from this one
	 *
	 * ### Examples:
	 *     var vec1 = new Victor(100, 50);
	 *     var vec2 = new Victor(20, 30);
	 *
	 *     vec1.subtract(vec2);
	 *     vec1.toString();
	 *     // => x:80, y:20
	 *
	 * @param {Victor} vector The other vector you want subtract from this one
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.subtract = function (vec) {
		this.x -= vec.x;
		this.y -= vec.y;
		return this;
	};
	
	/**
	 * Subtracts the given scalar from both axis
	 *
	 * ### Examples:
	 *     var vec = new Victor(100, 200);
	 *
	 *     vec.subtractScalar(20);
	 *     vec.toString();
	 *     // => x: 80, y: 180
	 *
	 * @param {Number} scalar The scalar to subtract
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.subtractScalar = function (scalar) {
		this.x -= scalar;
		this.y -= scalar;
		return this;
	};
	
	/**
	 * Subtracts the given scalar from the X axis
	 *
	 * ### Examples:
	 *     var vec = new Victor(100, 200);
	 *
	 *     vec.subtractScalarX(20);
	 *     vec.toString();
	 *     // => x: 80, y: 200
	 *
	 * @param {Number} scalar The scalar to subtract
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.subtractScalarX = function (scalar) {
		this.x -= scalar;
		return this;
	};
	
	/**
	 * Subtracts the given scalar from the Y axis
	 *
	 * ### Examples:
	 *     var vec = new Victor(100, 200);
	 *
	 *     vec.subtractScalarY(20);
	 *     vec.toString();
	 *     // => x: 100, y: 180
	 *
	 * @param {Number} scalar The scalar to subtract
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.subtractScalarY = function (scalar) {
		this.y -= scalar;
		return this;
	};
	
	/**
	 * Divides the X axis by the x component of given vector
	 *
	 * ### Examples:
	 *     var vec = new Victor(100, 50);
	 *     var vec2 = new Victor(2, 0);
	 *
	 *     vec.divideX(vec2);
	 *     vec.toString();
	 *     // => x:50, y:50
	 *
	 * @param {Victor} vector The other vector you want divide by
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.divideX = function (vector) {
		this.x /= vector.x;
		return this;
	};
	
	/**
	 * Divides the Y axis by the y component of given vector
	 *
	 * ### Examples:
	 *     var vec = new Victor(100, 50);
	 *     var vec2 = new Victor(0, 2);
	 *
	 *     vec.divideY(vec2);
	 *     vec.toString();
	 *     // => x:100, y:25
	 *
	 * @param {Victor} vector The other vector you want divide by
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.divideY = function (vector) {
		this.y /= vector.y;
		return this;
	};
	
	/**
	 * Divides both vector axis by a axis values of given vector
	 *
	 * ### Examples:
	 *     var vec = new Victor(100, 50);
	 *     var vec2 = new Victor(2, 2);
	 *
	 *     vec.divide(vec2);
	 *     vec.toString();
	 *     // => x:50, y:25
	 *
	 * @param {Victor} vector The vector to divide by
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.divide = function (vector) {
		this.x /= vector.x;
		this.y /= vector.y;
		return this;
	};
	
	/**
	 * Divides both vector axis by the given scalar value
	 *
	 * ### Examples:
	 *     var vec = new Victor(100, 50);
	 *
	 *     vec.divideScalar(2);
	 *     vec.toString();
	 *     // => x:50, y:25
	 *
	 * @param {Number} The scalar to divide by
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.divideScalar = function (scalar) {
		if (scalar !== 0) {
			this.x /= scalar;
			this.y /= scalar;
		} else {
			this.x = 0;
			this.y = 0;
		}
	
		return this;
	};
	
	/**
	 * Divides the X axis by the given scalar value
	 *
	 * ### Examples:
	 *     var vec = new Victor(100, 50);
	 *
	 *     vec.divideScalarX(2);
	 *     vec.toString();
	 *     // => x:50, y:50
	 *
	 * @param {Number} The scalar to divide by
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.divideScalarX = function (scalar) {
		if (scalar !== 0) {
			this.x /= scalar;
		} else {
			this.x = 0;
		}
		return this;
	};
	
	/**
	 * Divides the Y axis by the given scalar value
	 *
	 * ### Examples:
	 *     var vec = new Victor(100, 50);
	 *
	 *     vec.divideScalarY(2);
	 *     vec.toString();
	 *     // => x:100, y:25
	 *
	 * @param {Number} The scalar to divide by
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.divideScalarY = function (scalar) {
		if (scalar !== 0) {
			this.y /= scalar;
		} else {
			this.y = 0;
		}
		return this;
	};
	
	/**
	 * Inverts the X axis
	 *
	 * ### Examples:
	 *     var vec = new Victor(100, 50);
	 *
	 *     vec.invertX();
	 *     vec.toString();
	 *     // => x:-100, y:50
	 *
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.invertX = function () {
		this.x *= -1;
		return this;
	};
	
	/**
	 * Inverts the Y axis
	 *
	 * ### Examples:
	 *     var vec = new Victor(100, 50);
	 *
	 *     vec.invertY();
	 *     vec.toString();
	 *     // => x:100, y:-50
	 *
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.invertY = function () {
		this.y *= -1;
		return this;
	};
	
	/**
	 * Inverts both axis
	 *
	 * ### Examples:
	 *     var vec = new Victor(100, 50);
	 *
	 *     vec.invert();
	 *     vec.toString();
	 *     // => x:-100, y:-50
	 *
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.invert = function () {
		this.invertX();
		this.invertY();
		return this;
	};
	
	/**
	 * Multiplies the X axis by X component of given vector
	 *
	 * ### Examples:
	 *     var vec = new Victor(100, 50);
	 *     var vec2 = new Victor(2, 0);
	 *
	 *     vec.multiplyX(vec2);
	 *     vec.toString();
	 *     // => x:200, y:50
	 *
	 * @param {Victor} vector The vector to multiply the axis with
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.multiplyX = function (vector) {
		this.x *= vector.x;
		return this;
	};
	
	/**
	 * Multiplies the Y axis by Y component of given vector
	 *
	 * ### Examples:
	 *     var vec = new Victor(100, 50);
	 *     var vec2 = new Victor(0, 2);
	 *
	 *     vec.multiplyX(vec2);
	 *     vec.toString();
	 *     // => x:100, y:100
	 *
	 * @param {Victor} vector The vector to multiply the axis with
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.multiplyY = function (vector) {
		this.y *= vector.y;
		return this;
	};
	
	/**
	 * Multiplies both vector axis by values from a given vector
	 *
	 * ### Examples:
	 *     var vec = new Victor(100, 50);
	 *     var vec2 = new Victor(2, 2);
	 *
	 *     vec.multiply(vec2);
	 *     vec.toString();
	 *     // => x:200, y:100
	 *
	 * @param {Victor} vector The vector to multiply by
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.multiply = function (vector) {
		this.x *= vector.x;
		this.y *= vector.y;
		return this;
	};
	
	/**
	 * Multiplies both vector axis by the given scalar value
	 *
	 * ### Examples:
	 *     var vec = new Victor(100, 50);
	 *
	 *     vec.multiplyScalar(2);
	 *     vec.toString();
	 *     // => x:200, y:100
	 *
	 * @param {Number} The scalar to multiply by
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.multiplyScalar = function (scalar) {
		this.x *= scalar;
		this.y *= scalar;
		return this;
	};
	
	/**
	 * Multiplies the X axis by the given scalar
	 *
	 * ### Examples:
	 *     var vec = new Victor(100, 50);
	 *
	 *     vec.multiplyScalarX(2);
	 *     vec.toString();
	 *     // => x:200, y:50
	 *
	 * @param {Number} The scalar to multiply the axis with
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.multiplyScalarX = function (scalar) {
		this.x *= scalar;
		return this;
	};
	
	/**
	 * Multiplies the Y axis by the given scalar
	 *
	 * ### Examples:
	 *     var vec = new Victor(100, 50);
	 *
	 *     vec.multiplyScalarY(2);
	 *     vec.toString();
	 *     // => x:100, y:100
	 *
	 * @param {Number} The scalar to multiply the axis with
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.multiplyScalarY = function (scalar) {
		this.y *= scalar;
		return this;
	};
	
	/**
	 * Normalize
	 *
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.normalize = function () {
		var length = this.length();
	
		if (length === 0) {
			this.x = 1;
			this.y = 0;
		} else {
			this.divide(Victor(length, length));
		}
		return this;
	};
	
	Victor.prototype.norm = Victor.prototype.normalize;
	
	/**
	 * If the absolute vector axis is greater than `max`, multiplies the axis by `factor`
	 *
	 * ### Examples:
	 *     var vec = new Victor(100, 50);
	 *
	 *     vec.limit(80, 0.9);
	 *     vec.toString();
	 *     // => x:90, y:50
	 *
	 * @param {Number} max The maximum value for both x and y axis
	 * @param {Number} factor Factor by which the axis are to be multiplied with
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.limit = function (max, factor) {
		if (Math.abs(this.x) > max){ this.x *= factor; }
		if (Math.abs(this.y) > max){ this.y *= factor; }
		return this;
	};
	
	/**
	 * Randomizes both vector axis with a value between 2 vectors
	 *
	 * ### Examples:
	 *     var vec = new Victor(100, 50);
	 *
	 *     vec.randomize(new Victor(50, 60), new Victor(70, 80`));
	 *     vec.toString();
	 *     // => x:67, y:73
	 *
	 * @param {Victor} topLeft first vector
	 * @param {Victor} bottomRight second vector
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.randomize = function (topLeft, bottomRight) {
		this.randomizeX(topLeft, bottomRight);
		this.randomizeY(topLeft, bottomRight);
	
		return this;
	};
	
	/**
	 * Randomizes the y axis with a value between 2 vectors
	 *
	 * ### Examples:
	 *     var vec = new Victor(100, 50);
	 *
	 *     vec.randomizeX(new Victor(50, 60), new Victor(70, 80`));
	 *     vec.toString();
	 *     // => x:55, y:50
	 *
	 * @param {Victor} topLeft first vector
	 * @param {Victor} bottomRight second vector
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.randomizeX = function (topLeft, bottomRight) {
		var min = Math.min(topLeft.x, bottomRight.x);
		var max = Math.max(topLeft.x, bottomRight.x);
		this.x = random(min, max);
		return this;
	};
	
	/**
	 * Randomizes the y axis with a value between 2 vectors
	 *
	 * ### Examples:
	 *     var vec = new Victor(100, 50);
	 *
	 *     vec.randomizeY(new Victor(50, 60), new Victor(70, 80`));
	 *     vec.toString();
	 *     // => x:100, y:66
	 *
	 * @param {Victor} topLeft first vector
	 * @param {Victor} bottomRight second vector
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.randomizeY = function (topLeft, bottomRight) {
		var min = Math.min(topLeft.y, bottomRight.y);
		var max = Math.max(topLeft.y, bottomRight.y);
		this.y = random(min, max);
		return this;
	};
	
	/**
	 * Randomly randomizes either axis between 2 vectors
	 *
	 * ### Examples:
	 *     var vec = new Victor(100, 50);
	 *
	 *     vec.randomizeAny(new Victor(50, 60), new Victor(70, 80));
	 *     vec.toString();
	 *     // => x:100, y:77
	 *
	 * @param {Victor} topLeft first vector
	 * @param {Victor} bottomRight second vector
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.randomizeAny = function (topLeft, bottomRight) {
		if (!! Math.round(Math.random())) {
			this.randomizeX(topLeft, bottomRight);
		} else {
			this.randomizeY(topLeft, bottomRight);
		}
		return this;
	};
	
	/**
	 * Rounds both axis to an integer value
	 *
	 * ### Examples:
	 *     var vec = new Victor(100.2, 50.9);
	 *
	 *     vec.unfloat();
	 *     vec.toString();
	 *     // => x:100, y:51
	 *
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.unfloat = function () {
		this.x = Math.round(this.x);
		this.y = Math.round(this.y);
		return this;
	};
	
	/**
	 * Rounds both axis to a certain precision
	 *
	 * ### Examples:
	 *     var vec = new Victor(100.2, 50.9);
	 *
	 *     vec.unfloat();
	 *     vec.toString();
	 *     // => x:100, y:51
	 *
	 * @param {Number} Precision (default: 8)
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.toFixed = function (precision) {
		if (typeof precision === 'undefined') { precision = 8; }
		this.x = this.x.toFixed(precision);
		this.y = this.y.toFixed(precision);
		return this;
	};
	
	/**
	 * Performs a linear blend / interpolation of the X axis towards another vector
	 *
	 * ### Examples:
	 *     var vec1 = new Victor(100, 100);
	 *     var vec2 = new Victor(200, 200);
	 *
	 *     vec1.mixX(vec2, 0.5);
	 *     vec.toString();
	 *     // => x:150, y:100
	 *
	 * @param {Victor} vector The other vector
	 * @param {Number} amount The blend amount (optional, default: 0.5)
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.mixX = function (vec, amount) {
		if (typeof amount === 'undefined') {
			amount = 0.5;
		}
	
		this.x = (1 - amount) * this.x + amount * vec.x;
		return this;
	};
	
	/**
	 * Performs a linear blend / interpolation of the Y axis towards another vector
	 *
	 * ### Examples:
	 *     var vec1 = new Victor(100, 100);
	 *     var vec2 = new Victor(200, 200);
	 *
	 *     vec1.mixY(vec2, 0.5);
	 *     vec.toString();
	 *     // => x:100, y:150
	 *
	 * @param {Victor} vector The other vector
	 * @param {Number} amount The blend amount (optional, default: 0.5)
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.mixY = function (vec, amount) {
		if (typeof amount === 'undefined') {
			amount = 0.5;
		}
	
		this.y = (1 - amount) * this.y + amount * vec.y;
		return this;
	};
	
	/**
	 * Performs a linear blend / interpolation towards another vector
	 *
	 * ### Examples:
	 *     var vec1 = new Victor(100, 100);
	 *     var vec2 = new Victor(200, 200);
	 *
	 *     vec1.mix(vec2, 0.5);
	 *     vec.toString();
	 *     // => x:150, y:150
	 *
	 * @param {Victor} vector The other vector
	 * @param {Number} amount The blend amount (optional, default: 0.5)
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.mix = function (vec, amount) {
		this.mixX(vec, amount);
		this.mixY(vec, amount);
		return this;
	};
	
	/**
	 * # Products
	 */
	
	/**
	 * Creates a clone of this vector
	 *
	 * ### Examples:
	 *     var vec1 = new Victor(10, 10);
	 *     var vec2 = vec1.clone();
	 *
	 *     vec2.toString();
	 *     // => x:10, y:10
	 *
	 * @return {Victor} A clone of the vector
	 * @api public
	 */
	Victor.prototype.clone = function () {
		return new Victor(this.x, this.y);
	};
	
	/**
	 * Copies another vector's X component in to its own
	 *
	 * ### Examples:
	 *     var vec1 = new Victor(10, 10);
	 *     var vec2 = new Victor(20, 20);
	 *     var vec2 = vec1.copyX(vec1);
	 *
	 *     vec2.toString();
	 *     // => x:20, y:10
	 *
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.copyX = function (vec) {
		this.x = vec.x;
		return this;
	};
	
	/**
	 * Copies another vector's Y component in to its own
	 *
	 * ### Examples:
	 *     var vec1 = new Victor(10, 10);
	 *     var vec2 = new Victor(20, 20);
	 *     var vec2 = vec1.copyY(vec1);
	 *
	 *     vec2.toString();
	 *     // => x:10, y:20
	 *
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.copyY = function (vec) {
		this.y = vec.y;
		return this;
	};
	
	/**
	 * Copies another vector's X and Y components in to its own
	 *
	 * ### Examples:
	 *     var vec1 = new Victor(10, 10);
	 *     var vec2 = new Victor(20, 20);
	 *     var vec2 = vec1.copy(vec1);
	 *
	 *     vec2.toString();
	 *     // => x:20, y:20
	 *
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.copy = function (vec) {
		this.copyX(vec);
		this.copyY(vec);
		return this;
	};
	
	/**
	 * Sets the vector to zero (0,0)
	 *
	 * ### Examples:
	 *     var vec1 = new Victor(10, 10);
	 *		 var1.zero();
	 *     vec1.toString();
	 *     // => x:0, y:0
	 *
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.zero = function () {
		this.x = this.y = 0;
		return this;
	};
	
	/**
	 * Calculates the dot product of this vector and another
	 *
	 * ### Examples:
	 *     var vec1 = new Victor(100, 50);
	 *     var vec2 = new Victor(200, 60);
	 *
	 *     vec1.dot(vec2);
	 *     // => 23000
	 *
	 * @param {Victor} vector The second vector
	 * @return {Number} Dot product
	 * @api public
	 */
	Victor.prototype.dot = function (vec2) {
		return this.x * vec2.x + this.y * vec2.y;
	};
	
	Victor.prototype.cross = function (vec2) {
		return (this.x * vec2.y ) - (this.y * vec2.x );
	};
	
	/**
	 * Projects a vector onto another vector, setting itself to the result.
	 *
	 * ### Examples:
	 *     var vec = new Victor(100, 0);
	 *     var vec2 = new Victor(100, 100);
	 *
	 *     vec.projectOnto(vec2);
	 *     vec.toString();
	 *     // => x:50, y:50
	 *
	 * @param {Victor} vector The other vector you want to project this vector onto
	 * @return {Victor} `this` for chaining capabilities
	 * @api public
	 */
	Victor.prototype.projectOnto = function (vec2) {
	    var coeff = ( (this.x * vec2.x)+(this.y * vec2.y) ) / ((vec2.x*vec2.x)+(vec2.y*vec2.y));
	    this.x = coeff * vec2.x;
	    this.y = coeff * vec2.y;
	    return this;
	};
	
	
	Victor.prototype.horizontalAngle = function () {
		return Math.atan2(this.y, this.x);
	};
	
	Victor.prototype.horizontalAngleDeg = function () {
		return radian2degrees(this.horizontalAngle());
	};
	
	Victor.prototype.verticalAngle = function () {
		return Math.atan2(this.x, this.y);
	};
	
	Victor.prototype.verticalAngleDeg = function () {
		return radian2degrees(this.verticalAngle());
	};
	
	Victor.prototype.angle = Victor.prototype.horizontalAngle;
	Victor.prototype.angleDeg = Victor.prototype.horizontalAngleDeg;
	Victor.prototype.direction = Victor.prototype.horizontalAngle;
	
	Victor.prototype.rotate = function (angle) {
		var nx = (this.x * Math.cos(angle)) - (this.y * Math.sin(angle));
		var ny = (this.x * Math.sin(angle)) + (this.y * Math.cos(angle));
	
		this.x = nx;
		this.y = ny;
	
		return this;
	};
	
	Victor.prototype.rotateDeg = function (angle) {
		angle = degrees2radian(angle);
		return this.rotate(angle);
	};
	
	Victor.prototype.rotateTo = function(rotation) {
		return this.rotate(rotation-this.angle());
	};
	
	Victor.prototype.rotateToDeg = function(rotation) {
		rotation = degrees2radian(rotation);
		return this.rotateTo(rotation);
	};
	
	Victor.prototype.rotateBy = function (rotation) {
		var angle = this.angle() + rotation;
	
		return this.rotate(angle);
	};
	
	Victor.prototype.rotateByDeg = function (rotation) {
		rotation = degrees2radian(rotation);
		return this.rotateBy(rotation);
	};
	
	/**
	 * Calculates the distance of the X axis between this vector and another
	 *
	 * ### Examples:
	 *     var vec1 = new Victor(100, 50);
	 *     var vec2 = new Victor(200, 60);
	 *
	 *     vec1.distanceX(vec2);
	 *     // => -100
	 *
	 * @param {Victor} vector The second vector
	 * @return {Number} Distance
	 * @api public
	 */
	Victor.prototype.distanceX = function (vec) {
		return this.x - vec.x;
	};
	
	/**
	 * Same as `distanceX()` but always returns an absolute number
	 *
	 * ### Examples:
	 *     var vec1 = new Victor(100, 50);
	 *     var vec2 = new Victor(200, 60);
	 *
	 *     vec1.absDistanceX(vec2);
	 *     // => 100
	 *
	 * @param {Victor} vector The second vector
	 * @return {Number} Absolute distance
	 * @api public
	 */
	Victor.prototype.absDistanceX = function (vec) {
		return Math.abs(this.distanceX(vec));
	};
	
	/**
	 * Calculates the distance of the Y axis between this vector and another
	 *
	 * ### Examples:
	 *     var vec1 = new Victor(100, 50);
	 *     var vec2 = new Victor(200, 60);
	 *
	 *     vec1.distanceY(vec2);
	 *     // => -10
	 *
	 * @param {Victor} vector The second vector
	 * @return {Number} Distance
	 * @api public
	 */
	Victor.prototype.distanceY = function (vec) {
		return this.y - vec.y;
	};
	
	/**
	 * Same as `distanceY()` but always returns an absolute number
	 *
	 * ### Examples:
	 *     var vec1 = new Victor(100, 50);
	 *     var vec2 = new Victor(200, 60);
	 *
	 *     vec1.distanceY(vec2);
	 *     // => 10
	 *
	 * @param {Victor} vector The second vector
	 * @return {Number} Absolute distance
	 * @api public
	 */
	Victor.prototype.absDistanceY = function (vec) {
		return Math.abs(this.distanceY(vec));
	};
	
	/**
	 * Calculates the euclidean distance between this vector and another
	 *
	 * ### Examples:
	 *     var vec1 = new Victor(100, 50);
	 *     var vec2 = new Victor(200, 60);
	 *
	 *     vec1.distance(vec2);
	 *     // => 100.4987562112089
	 *
	 * @param {Victor} vector The second vector
	 * @return {Number} Distance
	 * @api public
	 */
	Victor.prototype.distance = function (vec) {
		return Math.sqrt(this.distanceSq(vec));
	};
	
	/**
	 * Calculates the squared euclidean distance between this vector and another
	 *
	 * ### Examples:
	 *     var vec1 = new Victor(100, 50);
	 *     var vec2 = new Victor(200, 60);
	 *
	 *     vec1.distanceSq(vec2);
	 *     // => 10100
	 *
	 * @param {Victor} vector The second vector
	 * @return {Number} Distance
	 * @api public
	 */
	Victor.prototype.distanceSq = function (vec) {
		var dx = this.distanceX(vec),
			dy = this.distanceY(vec);
	
		return dx * dx + dy * dy;
	};
	
	/**
	 * Calculates the length or magnitude of the vector
	 *
	 * ### Examples:
	 *     var vec = new Victor(100, 50);
	 *
	 *     vec.length();
	 *     // => 111.80339887498948
	 *
	 * @return {Number} Length / Magnitude
	 * @api public
	 */
	Victor.prototype.length = function () {
		return Math.sqrt(this.lengthSq());
	};
	
	/**
	 * Squared length / magnitude
	 *
	 * ### Examples:
	 *     var vec = new Victor(100, 50);
	 *
	 *     vec.lengthSq();
	 *     // => 12500
	 *
	 * @return {Number} Length / Magnitude
	 * @api public
	 */
	Victor.prototype.lengthSq = function () {
		return this.x * this.x + this.y * this.y;
	};
	
	Victor.prototype.magnitude = Victor.prototype.length;
	
	/**
	 * Returns a true if vector is (0, 0)
	 *
	 * ### Examples:
	 *     var vec = new Victor(100, 50);
	 *     vec.zero();
	 *
	 *     // => true
	 *
	 * @return {Boolean}
	 * @api public
	 */
	Victor.prototype.isZero = function() {
		return this.x === 0 && this.y === 0;
	};
	
	/**
	 * Returns a true if this vector is the same as another
	 *
	 * ### Examples:
	 *     var vec1 = new Victor(100, 50);
	 *     var vec2 = new Victor(100, 50);
	 *     vec1.isEqualTo(vec2);
	 *
	 *     // => true
	 *
	 * @return {Boolean}
	 * @api public
	 */
	Victor.prototype.isEqualTo = function(vec2) {
		return this.x === vec2.x && this.y === vec2.y;
	};
	
	/**
	 * # Utility Methods
	 */
	
	/**
	 * Returns an string representation of the vector
	 *
	 * ### Examples:
	 *     var vec = new Victor(10, 20);
	 *
	 *     vec.toString();
	 *     // => x:10, y:20
	 *
	 * @return {String}
	 * @api public
	 */
	Victor.prototype.toString = function () {
		return 'x:' + this.x + ', y:' + this.y;
	};
	
	/**
	 * Returns an array representation of the vector
	 *
	 * ### Examples:
	 *     var vec = new Victor(10, 20);
	 *
	 *     vec.toArray();
	 *     // => [10, 20]
	 *
	 * @return {Array}
	 * @api public
	 */
	Victor.prototype.toArray = function () {
		return [ this.x, this.y ];
	};
	
	/**
	 * Returns an object representation of the vector
	 *
	 * ### Examples:
	 *     var vec = new Victor(10, 20);
	 *
	 *     vec.toObject();
	 *     // => { x: 10, y: 20 }
	 *
	 * @return {Object}
	 * @api public
	 */
	Victor.prototype.toObject = function () {
		return { x: this.x, y: this.y };
	};
	
	
	var degrees = 180 / Math.PI;
	
	function random (min, max) {
	    return Math.floor(Math.random() * (max - min + 1) + min);
	}
	
	function radian2degrees (rad) {
		return rad * degrees;
	}
	
	function degrees2radian (deg) {
		return deg / degrees;
	}


/***/ }),
/* 2327 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* Web Font Loader v1.6.27 - (c) Adobe Systems, Google. License: Apache 2.0 */(function(){function aa(a,b,c){return a.call.apply(a.bind,arguments)}function ba(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}}function p(a,b,c){p=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?aa:ba;return p.apply(null,arguments)}var q=Date.now||function(){return+new Date};function ca(a,b){this.a=a;this.m=b||a;this.c=this.m.document}var da=!!window.FontFace;function t(a,b,c,d){b=a.c.createElement(b);if(c)for(var e in c)c.hasOwnProperty(e)&&("style"==e?b.style.cssText=c[e]:b.setAttribute(e,c[e]));d&&b.appendChild(a.c.createTextNode(d));return b}function u(a,b,c){a=a.c.getElementsByTagName(b)[0];a||(a=document.documentElement);a.insertBefore(c,a.lastChild)}function v(a){a.parentNode&&a.parentNode.removeChild(a)}
	function w(a,b,c){b=b||[];c=c||[];for(var d=a.className.split(/\s+/),e=0;e<b.length;e+=1){for(var f=!1,g=0;g<d.length;g+=1)if(b[e]===d[g]){f=!0;break}f||d.push(b[e])}b=[];for(e=0;e<d.length;e+=1){f=!1;for(g=0;g<c.length;g+=1)if(d[e]===c[g]){f=!0;break}f||b.push(d[e])}a.className=b.join(" ").replace(/\s+/g," ").replace(/^\s+|\s+$/,"")}function y(a,b){for(var c=a.className.split(/\s+/),d=0,e=c.length;d<e;d++)if(c[d]==b)return!0;return!1}
	function z(a){if("string"===typeof a.f)return a.f;var b=a.m.location.protocol;"about:"==b&&(b=a.a.location.protocol);return"https:"==b?"https:":"http:"}function ea(a){return a.m.location.hostname||a.a.location.hostname}
	function A(a,b,c){function d(){k&&e&&f&&(k(g),k=null)}b=t(a,"link",{rel:"stylesheet",href:b,media:"all"});var e=!1,f=!0,g=null,k=c||null;da?(b.onload=function(){e=!0;d()},b.onerror=function(){e=!0;g=Error("Stylesheet failed to load");d()}):setTimeout(function(){e=!0;d()},0);u(a,"head",b)}
	function B(a,b,c,d){var e=a.c.getElementsByTagName("head")[0];if(e){var f=t(a,"script",{src:b}),g=!1;f.onload=f.onreadystatechange=function(){g||this.readyState&&"loaded"!=this.readyState&&"complete"!=this.readyState||(g=!0,c&&c(null),f.onload=f.onreadystatechange=null,"HEAD"==f.parentNode.tagName&&e.removeChild(f))};e.appendChild(f);setTimeout(function(){g||(g=!0,c&&c(Error("Script load timeout")))},d||5E3);return f}return null};function C(){this.a=0;this.c=null}function D(a){a.a++;return function(){a.a--;E(a)}}function F(a,b){a.c=b;E(a)}function E(a){0==a.a&&a.c&&(a.c(),a.c=null)};function G(a){this.a=a||"-"}G.prototype.c=function(a){for(var b=[],c=0;c<arguments.length;c++)b.push(arguments[c].replace(/[\W_]+/g,"").toLowerCase());return b.join(this.a)};function H(a,b){this.c=a;this.f=4;this.a="n";var c=(b||"n4").match(/^([nio])([1-9])$/i);c&&(this.a=c[1],this.f=parseInt(c[2],10))}function fa(a){return I(a)+" "+(a.f+"00")+" 300px "+J(a.c)}function J(a){var b=[];a=a.split(/,\s*/);for(var c=0;c<a.length;c++){var d=a[c].replace(/['"]/g,"");-1!=d.indexOf(" ")||/^\d/.test(d)?b.push("'"+d+"'"):b.push(d)}return b.join(",")}function K(a){return a.a+a.f}function I(a){var b="normal";"o"===a.a?b="oblique":"i"===a.a&&(b="italic");return b}
	function ga(a){var b=4,c="n",d=null;a&&((d=a.match(/(normal|oblique|italic)/i))&&d[1]&&(c=d[1].substr(0,1).toLowerCase()),(d=a.match(/([1-9]00|normal|bold)/i))&&d[1]&&(/bold/i.test(d[1])?b=7:/[1-9]00/.test(d[1])&&(b=parseInt(d[1].substr(0,1),10))));return c+b};function ha(a,b){this.c=a;this.f=a.m.document.documentElement;this.h=b;this.a=new G("-");this.j=!1!==b.events;this.g=!1!==b.classes}function ia(a){a.g&&w(a.f,[a.a.c("wf","loading")]);L(a,"loading")}function M(a){if(a.g){var b=y(a.f,a.a.c("wf","active")),c=[],d=[a.a.c("wf","loading")];b||c.push(a.a.c("wf","inactive"));w(a.f,c,d)}L(a,"inactive")}function L(a,b,c){if(a.j&&a.h[b])if(c)a.h[b](c.c,K(c));else a.h[b]()};function ja(){this.c={}}function ka(a,b,c){var d=[],e;for(e in b)if(b.hasOwnProperty(e)){var f=a.c[e];f&&d.push(f(b[e],c))}return d};function N(a,b){this.c=a;this.f=b;this.a=t(this.c,"span",{"aria-hidden":"true"},this.f)}function O(a){u(a.c,"body",a.a)}function P(a){return"display:block;position:absolute;top:-9999px;left:-9999px;font-size:300px;width:auto;height:auto;line-height:normal;margin:0;padding:0;font-variant:normal;white-space:nowrap;font-family:"+J(a.c)+";"+("font-style:"+I(a)+";font-weight:"+(a.f+"00")+";")};function Q(a,b,c,d,e,f){this.g=a;this.j=b;this.a=d;this.c=c;this.f=e||3E3;this.h=f||void 0}Q.prototype.start=function(){var a=this.c.m.document,b=this,c=q(),d=new Promise(function(d,e){function k(){q()-c>=b.f?e():a.fonts.load(fa(b.a),b.h).then(function(a){1<=a.length?d():setTimeout(k,25)},function(){e()})}k()}),e=new Promise(function(a,d){setTimeout(d,b.f)});Promise.race([e,d]).then(function(){b.g(b.a)},function(){b.j(b.a)})};function R(a,b,c,d,e,f,g){this.v=a;this.B=b;this.c=c;this.a=d;this.s=g||"BESbswy";this.f={};this.w=e||3E3;this.u=f||null;this.o=this.j=this.h=this.g=null;this.g=new N(this.c,this.s);this.h=new N(this.c,this.s);this.j=new N(this.c,this.s);this.o=new N(this.c,this.s);a=new H(this.a.c+",serif",K(this.a));a=P(a);this.g.a.style.cssText=a;a=new H(this.a.c+",sans-serif",K(this.a));a=P(a);this.h.a.style.cssText=a;a=new H("serif",K(this.a));a=P(a);this.j.a.style.cssText=a;a=new H("sans-serif",K(this.a));a=
	P(a);this.o.a.style.cssText=a;O(this.g);O(this.h);O(this.j);O(this.o)}var S={D:"serif",C:"sans-serif"},T=null;function U(){if(null===T){var a=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent);T=!!a&&(536>parseInt(a[1],10)||536===parseInt(a[1],10)&&11>=parseInt(a[2],10))}return T}R.prototype.start=function(){this.f.serif=this.j.a.offsetWidth;this.f["sans-serif"]=this.o.a.offsetWidth;this.A=q();la(this)};
	function ma(a,b,c){for(var d in S)if(S.hasOwnProperty(d)&&b===a.f[S[d]]&&c===a.f[S[d]])return!0;return!1}function la(a){var b=a.g.a.offsetWidth,c=a.h.a.offsetWidth,d;(d=b===a.f.serif&&c===a.f["sans-serif"])||(d=U()&&ma(a,b,c));d?q()-a.A>=a.w?U()&&ma(a,b,c)&&(null===a.u||a.u.hasOwnProperty(a.a.c))?V(a,a.v):V(a,a.B):na(a):V(a,a.v)}function na(a){setTimeout(p(function(){la(this)},a),50)}function V(a,b){setTimeout(p(function(){v(this.g.a);v(this.h.a);v(this.j.a);v(this.o.a);b(this.a)},a),0)};function W(a,b,c){this.c=a;this.a=b;this.f=0;this.o=this.j=!1;this.s=c}var X=null;W.prototype.g=function(a){var b=this.a;b.g&&w(b.f,[b.a.c("wf",a.c,K(a).toString(),"active")],[b.a.c("wf",a.c,K(a).toString(),"loading"),b.a.c("wf",a.c,K(a).toString(),"inactive")]);L(b,"fontactive",a);this.o=!0;oa(this)};
	W.prototype.h=function(a){var b=this.a;if(b.g){var c=y(b.f,b.a.c("wf",a.c,K(a).toString(),"active")),d=[],e=[b.a.c("wf",a.c,K(a).toString(),"loading")];c||d.push(b.a.c("wf",a.c,K(a).toString(),"inactive"));w(b.f,d,e)}L(b,"fontinactive",a);oa(this)};function oa(a){0==--a.f&&a.j&&(a.o?(a=a.a,a.g&&w(a.f,[a.a.c("wf","active")],[a.a.c("wf","loading"),a.a.c("wf","inactive")]),L(a,"active")):M(a.a))};function pa(a){this.j=a;this.a=new ja;this.h=0;this.f=this.g=!0}pa.prototype.load=function(a){this.c=new ca(this.j,a.context||this.j);this.g=!1!==a.events;this.f=!1!==a.classes;qa(this,new ha(this.c,a),a)};
	function ra(a,b,c,d,e){var f=0==--a.h;(a.f||a.g)&&setTimeout(function(){var a=e||null,k=d||null||{};if(0===c.length&&f)M(b.a);else{b.f+=c.length;f&&(b.j=f);var h,m=[];for(h=0;h<c.length;h++){var l=c[h],n=k[l.c],r=b.a,x=l;r.g&&w(r.f,[r.a.c("wf",x.c,K(x).toString(),"loading")]);L(r,"fontloading",x);r=null;if(null===X)if(window.FontFace){var x=/Gecko.*Firefox\/(\d+)/.exec(window.navigator.userAgent),ya=/OS X.*Version\/10\..*Safari/.exec(window.navigator.userAgent)&&/Apple/.exec(window.navigator.vendor);
	X=x?42<parseInt(x[1],10):ya?!1:!0}else X=!1;X?r=new Q(p(b.g,b),p(b.h,b),b.c,l,b.s,n):r=new R(p(b.g,b),p(b.h,b),b.c,l,b.s,a,n);m.push(r)}for(h=0;h<m.length;h++)m[h].start()}},0)}function qa(a,b,c){var d=[],e=c.timeout;ia(b);var d=ka(a.a,c,a.c),f=new W(a.c,b,e);a.h=d.length;b=0;for(c=d.length;b<c;b++)d[b].load(function(b,d,c){ra(a,f,b,d,c)})};function sa(a,b){this.c=a;this.a=b}function ta(a,b,c){var d=z(a.c);a=(a.a.api||"fast.fonts.net/jsapi").replace(/^.*http(s?):(\/\/)?/,"");return d+"//"+a+"/"+b+".js"+(c?"?v="+c:"")}
	sa.prototype.load=function(a){function b(){if(f["__mti_fntLst"+d]){var c=f["__mti_fntLst"+d](),e=[],h;if(c)for(var m=0;m<c.length;m++){var l=c[m].fontfamily;void 0!=c[m].fontStyle&&void 0!=c[m].fontWeight?(h=c[m].fontStyle+c[m].fontWeight,e.push(new H(l,h))):e.push(new H(l))}a(e)}else setTimeout(function(){b()},50)}var c=this,d=c.a.projectId,e=c.a.version;if(d){var f=c.c.m;B(this.c,ta(c,d,e),function(e){e?a([]):(f["__MonotypeConfiguration__"+d]=function(){return c.a},b())}).id="__MonotypeAPIScript__"+
	d}else a([])};function ua(a,b){this.c=a;this.a=b}ua.prototype.load=function(a){var b,c,d=this.a.urls||[],e=this.a.families||[],f=this.a.testStrings||{},g=new C;b=0;for(c=d.length;b<c;b++)A(this.c,d[b],D(g));var k=[];b=0;for(c=e.length;b<c;b++)if(d=e[b].split(":"),d[1])for(var h=d[1].split(","),m=0;m<h.length;m+=1)k.push(new H(d[0],h[m]));else k.push(new H(d[0]));F(g,function(){a(k,f)})};function va(a,b,c){a?this.c=a:this.c=b+wa;this.a=[];this.f=[];this.g=c||""}var wa="//fonts.googleapis.com/css";function xa(a,b){for(var c=b.length,d=0;d<c;d++){var e=b[d].split(":");3==e.length&&a.f.push(e.pop());var f="";2==e.length&&""!=e[1]&&(f=":");a.a.push(e.join(f))}}
	function za(a){if(0==a.a.length)throw Error("No fonts to load!");if(-1!=a.c.indexOf("kit="))return a.c;for(var b=a.a.length,c=[],d=0;d<b;d++)c.push(a.a[d].replace(/ /g,"+"));b=a.c+"?family="+c.join("%7C");0<a.f.length&&(b+="&subset="+a.f.join(","));0<a.g.length&&(b+="&text="+encodeURIComponent(a.g));return b};function Aa(a){this.f=a;this.a=[];this.c={}}
	var Ba={latin:"BESbswy","latin-ext":"\u00e7\u00f6\u00fc\u011f\u015f",cyrillic:"\u0439\u044f\u0416",greek:"\u03b1\u03b2\u03a3",khmer:"\u1780\u1781\u1782",Hanuman:"\u1780\u1781\u1782"},Ca={thin:"1",extralight:"2","extra-light":"2",ultralight:"2","ultra-light":"2",light:"3",regular:"4",book:"4",medium:"5","semi-bold":"6",semibold:"6","demi-bold":"6",demibold:"6",bold:"7","extra-bold":"8",extrabold:"8","ultra-bold":"8",ultrabold:"8",black:"9",heavy:"9",l:"3",r:"4",b:"7"},Da={i:"i",italic:"i",n:"n",normal:"n"},
	Ea=/^(thin|(?:(?:extra|ultra)-?)?light|regular|book|medium|(?:(?:semi|demi|extra|ultra)-?)?bold|black|heavy|l|r|b|[1-9]00)?(n|i|normal|italic)?$/;
	function Fa(a){for(var b=a.f.length,c=0;c<b;c++){var d=a.f[c].split(":"),e=d[0].replace(/\+/g," "),f=["n4"];if(2<=d.length){var g;var k=d[1];g=[];if(k)for(var k=k.split(","),h=k.length,m=0;m<h;m++){var l;l=k[m];if(l.match(/^[\w-]+$/)){var n=Ea.exec(l.toLowerCase());if(null==n)l="";else{l=n[2];l=null==l||""==l?"n":Da[l];n=n[1];if(null==n||""==n)n="4";else var r=Ca[n],n=r?r:isNaN(n)?"4":n.substr(0,1);l=[l,n].join("")}}else l="";l&&g.push(l)}0<g.length&&(f=g);3==d.length&&(d=d[2],g=[],d=d?d.split(","):
	g,0<d.length&&(d=Ba[d[0]])&&(a.c[e]=d))}a.c[e]||(d=Ba[e])&&(a.c[e]=d);for(d=0;d<f.length;d+=1)a.a.push(new H(e,f[d]))}};function Ga(a,b){this.c=a;this.a=b}var Ha={Arimo:!0,Cousine:!0,Tinos:!0};Ga.prototype.load=function(a){var b=new C,c=this.c,d=new va(this.a.api,z(c),this.a.text),e=this.a.families;xa(d,e);var f=new Aa(e);Fa(f);A(c,za(d),D(b));F(b,function(){a(f.a,f.c,Ha)})};function Ia(a,b){this.c=a;this.a=b}Ia.prototype.load=function(a){var b=this.a.id,c=this.c.m;b?B(this.c,(this.a.api||"https://use.typekit.net")+"/"+b+".js",function(b){if(b)a([]);else if(c.Typekit&&c.Typekit.config&&c.Typekit.config.fn){b=c.Typekit.config.fn;for(var e=[],f=0;f<b.length;f+=2)for(var g=b[f],k=b[f+1],h=0;h<k.length;h++)e.push(new H(g,k[h]));try{c.Typekit.load({events:!1,classes:!1,async:!0})}catch(m){}a(e)}},2E3):a([])};function Ja(a,b){this.c=a;this.f=b;this.a=[]}Ja.prototype.load=function(a){var b=this.f.id,c=this.c.m,d=this;b?(c.__webfontfontdeckmodule__||(c.__webfontfontdeckmodule__={}),c.__webfontfontdeckmodule__[b]=function(b,c){for(var g=0,k=c.fonts.length;g<k;++g){var h=c.fonts[g];d.a.push(new H(h.name,ga("font-weight:"+h.weight+";font-style:"+h.style)))}a(d.a)},B(this.c,z(this.c)+(this.f.api||"//f.fontdeck.com/s/css/js/")+ea(this.c)+"/"+b+".js",function(b){b&&a([])})):a([])};var Y=new pa(window);Y.a.c.custom=function(a,b){return new ua(b,a)};Y.a.c.fontdeck=function(a,b){return new Ja(b,a)};Y.a.c.monotype=function(a,b){return new sa(b,a)};Y.a.c.typekit=function(a,b){return new Ia(b,a)};Y.a.c.google=function(a,b){return new Ga(b,a)};var Z={load:p(Y.load,Y)}; true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return Z}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!==typeof module&&module.exports?module.exports=Z:(window.WebFont=Z,window.WebFontConfig&&Y.load(window.WebFontConfig));}());


/***/ }),
/* 2328 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 2329 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// main-b0195d9fcec16d78ca6e.js